webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(245);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(249);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(160);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.globalData = exports.appMethod = exports.appInstance = exports.setApp = undefined;

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _modal = __webpack_require__(76);

var _modal2 = _interopRequireDefault(_modal);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(78);

__webpack_require__(13);

var _lrz = __webpack_require__(123);

var _lrz2 = _interopRequireDefault(_lrz);

var _history = __webpack_require__(107);

var _http = __webpack_require__(36);

var _global = __webpack_require__(42);

var _tools = __webpack_require__(6);

var _page2 = __webpack_require__(43);

var _customEvent = __webpack_require__(18);

var _noDevPageList = __webpack_require__(125);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _officialPageList = __webpack_require__(175);

var _officialPageList2 = _interopRequireDefault(_officialPageList);

var _oldPageList = __webpack_require__(744);

var _oldPageList2 = _interopRequireDefault(_oldPageList);

var _PreviewImage = __webpack_require__(745);

var _ChooseLocation = __webpack_require__(747);

var _OpenLocation = __webpack_require__(749);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import has from '@atomicservice/asweb-sdk';
/**
 * 原app.js的其他模块引用（有替代方案时删除）
 */
// var qiniuUploader = require('./utils/qiniuUploader.js');

/**
 * APP 实例
 */
var appInstance = null;
/**
 *  APP 全局变量
 */
var globalData = {
  /**
   * 当前APPID
   */
  appId: (0, _global.getAppId)(),
  historyDataId: '',
  /**
   * 导航路由数组
   */
  tabBarPagePathArr: [],
  homepageRouter: '',
  formData: null,
  userInfo: {},
  systemInfo: null,
  sessionKey: '',
  notBindXcxAppId: false,
  waimaiTotalNum: 0,
  waimaiTotalPrice: 0,
  takeoutLocate: {},
  takeoutRefresh: false,
  communityGroupRefresh: false,
  isLogin: false,
  locationInfo: {
    latitude: '',
    longitude: '',
    address: '',
    info: {}
  },
  getDistributionInfo: '',
  getDistributorInfo: '',
  PromotionUserToken: '',
  communityUserToken: '', //社区团购团长分享token
  previewGoodsOrderGoodsInfo: [],
  goodsAdditionalInfo: {},
  urlLocationId: '',
  turnToPageFlag: false,
  wxParseOldPattern: '_listVesselRichText_',
  cdnUrl: 'http://cdn.jisuapp.cn',
  defaultPhoto: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/default_photo.png',
  siteBaseUrl: location.origin,
  userDomain: location.origin, // 用户子域名
  appTitle: '',
  appDescription: '',
  appLogo: '',
  /**
   * 扫描二维码进入小程序所带参数代理商的user-token
   */
  p_u: '',
  /**
   * 是否有多商家列表组件
   */
  hasFranchiseeList: false,
  /**
   * 是否有多商家连锁组件
   */
  hasFranchiseeChain: false,
  /**
   * 连锁店ID
   */
  chainAppId: '',
  hasTopicCom: false,
  pageScrollTop: 0,
  topicRefresh: false,
  kbHeight: '',
  goodsStoreConfig: '',
  goodsfranchiseeStoreConfig: {},
  /**
   * 有悬浮窗话题列表地图
   */
  susTopicsMap: {},
  /**
   * 需要刷新的页面
   */
  needRefreshPages: [],
  /**
   * 页面计数数据
   */
  newCountDataOnPage: {},
  /**
   * 子店底部导航信息
   */
  tabbarInfo: {},
  /**
   * 当前页面栈（暂时只有route信息）
   */
  currentPages: [],
  /**
   * webapp专有：app初始化时将页面参数全部保存起来
   */
  queryParams: {}
};
/**
 * 设置当前APP实例
 * @param {object} instance  传入this
 */
var setApp = function setApp(instance) {
  exports.appInstance = appInstance = instance;
};
/**
 * APP方法
 */
var appMethod = {
  /**
   * 全局数据
   */
  globalData: globalData,
  socket: null,
  onLaunch: function onLaunch() {
    var userInfo = void 0;
    if (userInfo = this.getStorageSync('userInfo')) {
      this.globalData.userInfo = userInfo;
    }
    this.appInitial();
    this.getShareAppSetting();
  },
  appInitial: function appInitial() {
    var that = this;
    this._getSystemInfo({
      success: function success(res) {
        that.setSystemInfoData(res);
      }
    });
    // TODO webpp应该不需要，暂时注释
    // this.sendRequest({
    //   url: '/index.php?r=AppUser/MarkWxXcxStatus',
    //   data: {
    //     his_id: this.globalData.historyDataId
    //   },
    //   method: 'GET',
    //   header: {
    //     'content-type': 'application/json'
    //   }
    // });
  },
  /**
   * 设置用户账号信息：微信号（登录后使用）
   */
  setQueryParams: function setQueryParams() {
    this.globalData.queryParams = (0, _tools.getCurrentPageQueryParams)();
  },
  /**
   * 绑定用户账号信息：微信号
   */
  bindUserAccount: function bindUserAccount() {
    var params = (0, _extends3.default)({}, this.globalData.queryParams, (0, _tools.getCurrentPageQueryParams)());
    if (!(params['account'] && params['from_account'])) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppUser/BindWeixinAccount',
      data: {
        account: params['account'],
        from_account: params['from_account']
      }
    });
    this.sendRequest({
      url: '/index.php?r=AppUser/UserCrmWxAccountBind',
      data: {
        account: params['from_account']
      }
    });
  },
  onShow: function onShow(options) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 页面找不到处理
   */
  onPageNotFound: function onPageNotFound() {
    this.turnToPage(this.getHomepageRouter());
  },
  onError: function onError(error) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  onHide: function onHide() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  bindUserTokenByPid: function bindUserTokenByPid(p_id) {
    var that = this;
    that.sendRequest({
      url: '/index.php?r=AppDistribution/GetUserTokenByPId',
      data: {
        p_id: p_id
      },
      success: function success(res) {
        if (res.data && res.data.user_token) {
          that.globalData.communityUserToken = res.data.user_token; //社区团购分享
          that._getPromotionUserToken({
            user_token: res.data.user_token
          });
        }
      }
    });
  },
  _getPromotionUserToken: function _getPromotionUserToken(param) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  returnSubPackageRouter: function returnSubPackageRouter(router) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _getSystemInfo: function _getSystemInfo(options) {
    this.getSystemInfo({
      success: function success(res) {
        typeof options.success === 'function' && options.success(res);
      },
      fail: function fail(res) {
        typeof options.fail === 'function' && options.fail(res);
      },
      complete: function complete(res) {
        typeof options.complete === 'function' && options.complete(res);
      }
    });
  },
  /**
   * 发请求 TODO 未完成
   * @param options 传入参数的对象
   */
  sendRequest: function sendRequest(options) {
    var that = this;
    // 请求参数
    var data = options.data || {};
    if (options.subshop) {
      data.app_id = options.subshop;
      options.chain = false;
    }
    if (options.chain && this.globalData.chainAppId) {
      data.app_id = this.getChainAppId();
    }
    if (!data.app_id) {
      data.app_id = this.getAppId();
    }
    // TODO: 暂时都不设loading
    var hideLoading = typeof options.hideLoading === 'boolean' ? options.hideLoading : true;
    (0, _http.ajax)({
      url: options.url,
      data: data,
      type: options.method || 'GET', // TOOD: 确定到底是method还是type
      headers: options.header,
      loading: !hideLoading,
      timeout: options.timeout,
      success: function success(data, res) {
        if (res.statusCode && res.statusCode != 200) {
          that.hideToast();
          that.showToast({
            title: '' + res.errMsg,
            icon: 'none'
          });
          typeof options.successStatusAbnormal == 'function' && options.successStatusAbnormal(res.data);
          return;
        }
        if (data.status && data.status != 0) {
          if (data.status == 2 || data.status == 401) {
            that.setIsLogin(false);
            that.goLogin();
            // TODO: 登录成功回调
            return;
          }
          if (data.status == 5) {
            typeof options.successStatus5 == 'function' && options.successStatus5(data);
            return;
          }
          if (data.status == 1) {
            options.success && options.success(data);
          }
          if (typeof options.successStatusAbnormal == 'function' && options.successStatusAbnormal(data) === false) {
            return;
          }
          that.hideToast();
          if (!options.hideModal) {
            that.showModal({
              content: '' + data.data,
              confirm: function confirm() {
                typeof options.successShowModalConfirm == 'function' && options.successShowModalConfirm(data);
              }
            });
          }
          if (options.hideTemplateLoading) {
            options.hideTemplateLoading();
          }
          return;
        }
        options.success && options.success(data);
      },
      error: function error(res) {
        options.fail && options.fail(res);
      },
      complete: function complete(res) {
        options.complete && options.complete(res);
      }
    });
  },
  /**
   * 跳转页面
   * @param url 要跳转页面的url
   * @param obj 要传入的参数对象
   */
  turnToPage: function turnToPage() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isRedirect = arguments[2];

    // console.log('测试', has)
    // has.asWeb.getEnv({
    //   callback: (err, res) => {
    //     // {"brand":"HUAWEI","deviceType":"phone","osFullName":"OpenHarmony-5.0.1.73(Beta2)","productModel":"ALN-AL00"}"  
    //     console.log(err,JSON.stringify(res))
    //   }
    // });
    var urlArr = url.split('?')[0].split('/');
    var router = urlArr[urlArr.length - 1];
    // 兼容处理，防止第二个参数不为对象
    if ((typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) !== 'object') {
      // 不为对象的第二个参数默认为布尔值，实际为isRedirect
      isRedirect = Boolean(obj) || false;
      obj = {}; // 处理为对象，防止后续报错
    }
    var state = Object.assign(obj, (0, _tools.getUrlQueryStringObj)(url));
    var search = (0, _tools.getUrlSearch)(state);

    // 已经在登录页的话，就不再跳转到登录页
    var pathnameArr = location.pathname.split('/');
    if (pathnameArr[pathnameArr.length - 1] === 'loginPage' && router === 'loginPage') {
      return;
    }
    // webapp暂不支持使用插件
    if (router.indexOf('plugin') === 0) {
      _toast2.default.info('插件不支持跳转');
      return;
    }
    // 开发完待测试的页面
    var testingPageList = {};
    if (testingPageList[router]) {
      _toast2.default.info(React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          null,
          '\u5F53\u524D\u529F\u80FD\u6D4B\u8BD5\u4E2D'
        ),
        React.createElement(
          'div',
          null,
          '\u5373\u5C06\u5F00\u653E\u4F7F\u7528'
        )
      ));
      return;
    }
    var currentPageData = appInstance.state.appData[router];
    if (_officialPageList2.default[router] || currentPageData) {
      // 当前官方页面已开发 或 当前为用户自定义页面 或 外链页面

      // 判断是否为外链页面
      if (currentPageData && currentPageData['customFeature']) {
        var pageUrl = currentPageData['customFeature']['pageUrl'];
        if (pageUrl) {
          window.open(pageUrl);
          return;
        }
        // 重定向
        if (isRedirect) {
          _history.history.replace('/' + router + search, state);
          return;
        }
      }
      _history.history.push('/' + router + search, state);
    } else if (_oldPageList2.default[router]) {
      // 有旧页面跳回旧页面
      var oldUrl = '/app?_app_id=' + (0, _global.getAppId)() + '&' + _oldPageList2.default[router](state);
      console.log('oldUrl', oldUrl);
      window.location.href = oldUrl;
    } else {
      // 当前不支持 或 未开发 功能
      if (_noDevPageList.noDevPageList.hasOwnProperty(router)) {
        (0, _noDevPageList.showNoDevToast)();
        return;
      }
      _toast2.default.info('跳转页面不存在');
    }
  },
  // socket估计还存在一些问题，之后修复
  connectSocket: function connectSocket(options) {
    var url = options.url,
        header = options.header,
        method = options.method;

    this.socket = new WebSocket(url);
  },
  onSocketOpen: function onSocketOpen(cb) {
    this.socket.onopen = function (res) {
      console.warn('socket连接成功');
      cb(res);
    };
  },
  sendSocketMessage: function sendSocketMessage(options) {
    if (this.socket.readyState == 1) {
      this.socket.send(options);
      console.warn('socket向服务器发送数据', options);
    }
  },
  onSocketMessage: function onSocketMessage(cb) {
    if (this.socket.readyState == 1) {
      this.socket.onmessage = function (res) {
        console.warn('socket服务器端返回数据', res);
        cb(res);
      };
    }
  },
  closeSocket: function closeSocket() {
    this.socket.close();
  },
  onSocketClose: function onSocketClose(cb) {
    var readyState = this.socket.readyState;
    if (readyState === 3) {
      cb();
    }
  },
  onSocketError: function onSocketError(cb) {
    this.socket.onerror = function () {
      cb();
    };
  },
  chainTurnToPage: function chainTurnToPage(url) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 小程序：跳转到某个页面，并关闭其余页面栈上的页面
   */
  reLaunch: function reLaunch(options) {
    this.setPageRouter(options.url);
    this.turnToPage(options.url);
    // wx.reLaunch({
    //   url: options.url,
    //   success: options.success,
    //   fail: options.fail,
    //   complete: options.complete
    // })
  },
  switchToTab: function switchToTab(url) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  turnBack: function turnBack() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var delta = Number(options.delta) || 1;
    _history.history.go(-delta);
  },
  /**
   * 跳转小程序
   * 这个视乎是可以从web跳转。因为公众号文章可以实现
   * TODO
   */
  navigateToXcx: function navigateToXcx() {
    _toast2.default.info('web端不支持跳转到微信小程序');
  },
  /**
   * 模拟微信顶部导航标题设置
   * @param {*} title 
   */
  setNavigationBarTitle: function setNavigationBarTitle(_ref) {
    var title = _ref.title,
        success = _ref.success,
        fail = _ref.fail,
        complete = _ref.complete;

    this.setPageTitle(title);
    complete && complete();
    success && success();
  },
  /**
   * 设置页面上面的标题
   */
  setPageTitle: function setPageTitle(title) {
    document.title = title;
    if (this.isWeixin()) {
      var body = document.getElementsByTagName('body')[0];
      var iframe = document.createElement("iframe");
      iframe.setAttribute("src", "/favicon.ico");
      iframe.setAttribute("style", "display:none");
      iframe.addEventListener('load', function () {
        setTimeout(function () {
          try {
            iframe.removeEventListener('load');
          } catch (err) {}
          document.body.removeChild(iframe);
        }, 0);
      });
      document.body.appendChild(iframe);
    }
  },
  /**
   * 展示轻提示
   * 注： duration = 0 时，onClose 无效，toast 不会消失；隐藏 toast 需要手动调用 hide
   */
  showToast: function showToast() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    param.duration = param.duration ? param.duration / 1000 : 1.5; //单位换算。从毫秒换成秒
    if (param.icon == 'success') {
      _toast2.default.success(param.title, param.duration, param.success || null, param.mask || false);
    } else if (param.icon == 'fail') {
      _toast2.default.fail(param.title, param.duration, param.success || null, param.mask || false);
    } else if (param.icon == 'offline') {
      _toast2.default.offline(param.title, param.duration, param.success || null, param.mask || false);
    } else {
      _toast2.default.info(param.title, param.duration, param.success || null, param.mask || false);
    }
  },
  /**
   * 隐藏轻提示
   */
  hideToast: function hideToast() {
    _toast2.default.hide();
  },
  /**
   * 暂时加载loading
   */
  showLoading: function showLoading() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    param.duration = param.duration ? param.duration / 1000 : 1.5; //单位换算。从毫秒换成秒
    _toast2.default.loading(param.title || '加载中...', param.duration1, param.success || null, param.mask || true);
  },
  /**
   * 隐藏loading
   */
  hideLoading: function hideLoading() {
    _toast2.default.hide();
  },
  /**
   * 展示模态框
   */
  showModal: function showModal() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var actions = [{
      text: param.confirmText || '确定',
      onPress: function onPress(res) {
        return typeof param.confirm == 'function' && param.confirm(res);
      },
      style: { color: param.confirmColor || '#3CC51F' }
    }];
    if (param.showCancel) {
      actions.unshift({
        text: param.cancelText || '取消',
        onPress: function onPress(res) {
          return typeof param.cancel == 'function' && param.cancel(res);
        },
        style: { color: param.cancelColor || '#000000' }
      });
    }
    _modal2.default.alert(param.title || '', param.content, actions);
  },
  chooseVideo: function chooseVideo(param, maxDuration, source) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取视频上传token
   * @param file
   * @param callback
   */
  getVideoUpToken: function getVideoUpToken(file, callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 视频上传成功后的回调
   * @param file
   * @param callback
   */
  uploadSuccessCallback: function uploadSuccessCallback(file, callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 根据视频id获取视频链接
   * @param video_id
   * @param callback
   */
  getVideoUrlById: function getVideoUrlById(video_id, callback) {
    if (!video_id) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoLibURL',
      data: {
        id: video_id
      },
      success: function success(res) {
        typeof callback === 'function' && callback(res.data);
      },
      error: function error(err) {
        console.log(err);
      }
    });
  },
  /**
   * 选择图片接口
   * @param {function} callback 上传成功回调
   */
  chooseImage: function chooseImage(callback) {
    // TODO 此方法有可能行不通。等找到办法在解决。可以先用img-upload组件
    var that = this;
    var ipt = document.createElement('input');
    ipt.type = "file";
    ipt.style = "width:0;height:0;opacity:0;padding:0;margin:0;border:none;";
    ipt.accept = "image/jpg, image/jpeg, image/gif, image/bmp, image/jp2, image/x-ms-bmp, image/x-png, image/png";
    document.body.appendChild(ipt);
    ipt.onchange = function (e) {
      that.showLoading({
        title: '上传中...',
        icon: 'loading',
        duration: 10000
      });
      var file = e.target.files[0];
      if (!file) {
        return;
      }
      var option = {
        width: 750,
        quality: 0.8
      };
      (0, _lrz2.default)(file, option).then(function (result) {
        (0, _http.ajax)({
          url: '/index.php?r=AppData/uploadImg',
          data: {
            img_data: result.base64,
            org: 1
          },
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info('图片上传失败，请重试');
              return;
            }
            callback && callback(res.data);
          },
          complete: function complete() {
            that.hideLoading();
            ipt.remove();
          }
        });
      });
    };
    // ipt.focus();
    ipt.click();
    setTimeout(function () {
      ipt.click();
    }, 100);
  },
  /**
   * 预览图片
   * @param options.current 初始预览的图片URL
   * @param options.urls 非必传 预览图片的URL数组
   */
  previewImage: function previewImage(options) {
    if (this.isWeixin()) {
      wx.previewImage({
        current: options.current || '',
        urls: options.urls || [options.current]
      });
    } else {
      ReactDOM.render(React.createElement(_PreviewImage.PreviewImage, { options: options }), document.getElementById('popup'));
    }
  },
  saveImageToPhotosAlbum: function saveImageToPhotosAlbum(url) {},
  playVoice: function playVoice(filePath) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  pauseVoice: function pauseVoice() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  countUserShareApp: function countUserShareApp(callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取分享的key ，对应路径上面psid参数
   */
  getShareKey: function getShareKey() {
    var that = this;
    that.sendRequest({
      url: "/index.php?r=AppShare/GetAppShareKey",
      success: function success(res) {
        if (res.status == 0) {
          that.globalData.pageShareKey = res.data;
        }
      }
    });
  },
  /**
   * 获取管理后台设置的分享图片和标题
   */
  getShareAppSetting: function getShareAppSetting() {
    var that = this;
    this.sendRequest({
      url: '/index.php?r=AppConfig/GetAppPageShareConfig',
      data: {},
      success: function success(res) {
        that.globalData.share_img = res.data.share_img;
        that.globalData.share_title = res.data.share_title;
        that.globalData.appDescription = res.data.description;
      }
    });
  },
  shareClickEvent: function shareClickEvent() {
    var _this2 = this;

    if (this.isWeixin()) {
      var div = document.createElement('div');
      div.style = 'position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.6);z-index:50';
      div.innerHTML = '\n      <div><img style="width: 1.2rem;position: absolute;top: .1rem;right: .5rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75fa1ace466.png" /></div>\n      <div style="color: #fff;font-size: 0.4rem;text-align: center;margin-top: 3rem;">\u5FEB\u901F\u5206\u4EAB\u7ED9\u597D\u53CB</div>\n      <div style="color: #fff;font-size: .3rem;text-align: center;margin-top: .1rem;line-height: 1rem;">\u70B9\u51FB\u5C4F\u5E55\u53F3\u4E0A\u89D2 <span style="display: inline-block;font-size: 0.6rem;vertical-align: top;">\xB7</span><span style="display: inline-block;font-size: 0.8rem;vertical-align: top;">\xB7</span><span style="display: inline-block;font-size: 0.6rem;vertical-align: top;">\xB7</span> \u6309\u94AE\uFF0C\u8FDB\u884C\u5206\u4EAB</div>\n      <div style="text-align: center;margin-top: 0.3rem;">\n        <div style="display:inline-block;margin: 0 0.5rem;"><img style="width: 2rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75f79c8d589.png" /><span style="display: block;width: .5rem;height: .5rem;margin: .1rem auto;text-align: center;line-height: .5rem;font-size: .28rem;border-radius:50%;background-color: #fff;">1</span></div>\n        <div style="display:inline-block;margin: 0 0.5rem;"><img style="width: 2rem;" src="https://img.zhichiwangluo.com/zcimgdir/album/file_5d75f79d4e270.png" /><span style="display: block;width: .5rem;height: .5rem;margin: .1rem auto;text-align: center;line-height: .5rem;font-size: .28rem;border-radius:50%;background-color: #fff;">2</span></div>\n      </div>';
      div.onclick = function () {
        div.remove();
      };
      document.body.appendChild(div);
    } else {
      var _pageInstance = this.getAppCurrentPage();
      this.setClipboardData({
        data: _pageInstance.shareData.path,
        success: function success() {
          _this2.showToast({ title: '网址已经复制，可以粘贴发给别人' });
        }
      });
    }
  },
  /**
   * 分享统一处理方法。
   */
  shareAppMessage: function shareAppMessage(options) {
    var that = this,
        image = '',
        title = '',
        pageInstance = this.getAppCurrentPage(),
        pageShareKey = that.globalData.pageShareKey,
        pageShareType = that.globalData.pageShareType,
        path = options.path,
        desc = '';

    if (pageShareKey) {
      if (path.indexOf('?') < 0) {
        path = path + '?psid=' + pageShareKey;
      } else {
        path = path + '&psid=' + pageShareKey;
      }
    } else {
      path = path;
    }

    if (pageShareType == 1) {
      // TODO
      // that.getRecvChance(1);
    }

    if (options.title) {
      title = options.title;
    } else if (pageInstance.data.page_config && pageInstance.data.page_config.share) {
      title = pageInstance.data.page_config.share_title;
    } else {
      title = this.globalData.share_title || this.getAppTitle() || '即速应用';
    }

    if (options.imageUrl) {
      image = options.imageUrl;
    } else if (pageInstance.data.page_config && pageInstance.data.page_config.share) {
      image = pageInstance.data.page_config.share_img || '';
    } else if (this.globalData.share_img) {
      image = this.globalData.share_img || '';
    } else {
      image = this.globalData.appLogo;
    }

    if (that.globalData.p_id !== undefined) {
      // 分销分享添加p_id
      path += ~path.indexOf('?') ? '&' : '?';
      path += 'p_id=' + that.globalData.p_id;
    }

    if (options.desc) {
      desc = options.desc;
    }

    return {
      title: title,
      path: path,
      imageUrl: image,
      desc: desc
    };
  },
  /**
   * 去支付，弹出选择支付方式
   * @param {string} param.orderId 订单ID，必传
   * @param {string} param.orderType 订单类型, 默认值1。说明： http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884350
   * @param {string} param.franchisee 子店ID
   * @param {function} param.cancel  支付取消之后触发（目前是点击关闭按钮触发）
   * @param {string} param.successUrl  支付成功之后的跳转的链接
   * @param {string} param.failUrl  支付失败之后的跳转的链接
   */
  goPay: function goPay(param) {
    appInstance.payRef.current.showPay({
      orderId: param.orderId,
      orderType: param.orderType || 1,
      franchisee: param.franchisee || '',
      successUrl: param.successUrl || '',
      failUrl: param.failUrl || '',
      cancel: param.cancel
    });
  },
  /**
   * 拨打电话
   */
  makePhoneCall: function makePhoneCall(number) {
    window.location.href = "tel:" + number;
  },
  /**
   * 获取定位
   */
  getLocation: function getLocation(options) {
    if (this.isWeixin()) {
      wx.getLocation({
        type: options.type || 'gcj02',
        success: function success(res) {
          typeof options.success === 'function' && options.success(res);
          typeof options.complete === 'function' && options.complete(res);
        },
        fail: function fail(res) {
          typeof options.fail === 'function' && options.fail(res);
          typeof options.complete === 'function' && options.complete(res);
        }
      });
    } else if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var res = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        typeof options.success === 'function' && options.success(res);
        typeof options.complete === 'function' && options.complete(res);
      }, function (res) {
        typeof options.fail === 'function' && options.fail(res);
        typeof options.complete === 'function' && options.complete(res);
      });
    } else {
      typeof options.fail === 'function' && options.fail(res);
      typeof options.complete === 'function' && options.complete(res);
    }
  },
  /**
   * 选择位置
   * @param {function} options.success 成功的回调
   * @param {function} options.fail 失败回调
   */
  chooseLocation: function chooseLocation(options) {
    ReactDOM.render(React.createElement(_ChooseLocation.ChooseLocation, { options: options }), document.getElementById('popup'));
  },
  /**
   * 查看地图
   * @param {Number} options.latitude 必填 纬度
   * @param {Number} options.longitude 必填 经度
   */
  openLocation: function openLocation(options) {
    if (this.isWeixin()) {
      wx.openLocation({
        latitude: options.latitude, // 纬度，浮点数，范围为90 ~ -90
        longitude: options.longitude, // 经度，浮点数，范围为180 ~ -180。
        scale: options.scale || 24, // 地图缩放级别,整形值,范围从1~28。默认为最大
        name: options.name || '', // 位置名
        address: options.address || '', // 地址详情说明
        infoUrl: options.infoUrl || '', // 在查看位置界面底部显示的超链接,可点击跳转
        success: function success(res) {
          typeof options.success === 'function' && options.success(res);
        },
        fail: function fail(res) {
          typeof options.fail === 'function' && options.fail(res);
        }
      });
    } else {
      ReactDOM.render(React.createElement(_OpenLocation.OpenLocation, { options: options }), document.getElementById('popup'));
    }
  },
  /**
   * 获取经纬度。全局变量有存的就取全局变量里的。否则就取定位获取
   */
  getLatLng: function getLatLng(options) {
    var that = this;
    var locationInfo = that.globalData.locationInfo;
    if (locationInfo.latitude) {
      var latlng = {
        latitude: locationInfo.latitude,
        longitude: locationInfo.longitude
      };
      typeof options.success === 'function' && options.success(latlng);
    } else {
      this.getLocation({
        type: 'gcj02',
        success: function success(res) {
          var latitude = res.latitude,
              longitude = res.longitude;
          if (latitude) {
            that.sendRequest({
              hideLoading: true,
              url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
              data: {
                latitude: latitude,
                longitude: longitude
              },
              success: function success(res) {
                that.setLocationInfo({
                  latitude: latitude,
                  longitude: longitude,
                  address: res.data.formatted_addresses.recommend,
                  info: res.data
                });
              }
            });
            var _latlng = {
              latitude: latitude,
              longitude: longitude
            };
            typeof options.success === 'function' && options.success(_latlng);
          } else {
            typeof options.fail === 'function' && options.fail();
          }
        },
        fail: function fail() {
          typeof options.fail === 'function' && options.fail();
        }
      });
    }
  },
  /**
   * 复制东西到剪贴板
   */
  setClipboardData: function setClipboardData(options) {
    var input = document.createElement('input');
    input.setAttribute('readonly', 'readonly');
    input.setAttribute('value', options.data || '');
    document.body.appendChild(input);
    input.setSelectionRange(0, 9999);
    if (document.execCommand('copy')) {
      input.select();
      document.execCommand('copy');
      typeof options.success === 'function' && options.success();
    }
    document.body.removeChild(input);
  },
  getClipboardData: function getClipboardData(options) {
    // TODO: 这个暂时没有想到解决办法。
  },
  showShareMenu: function showShareMenu(options) {
    // TODO: web应该没有这个方法
  },
  /**
   * 扫描二维码。
   * TODO
   */
  scanCode: function scanCode(options) {
    if (this.isWeixin()) {
      wx.scanQRCode({
        needResult: options.needResult || 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: options.success,
        fail: options.fail,
        complete: options.complete
      });
    } else {
      // 非微信部分的扫码需要调研一下
      _toast2.default.info('暂不支持扫码功能');
    }
  },
  /**
   * 将页面滚动到指定位置
   */
  pageScrollTo: function pageScrollTo(scrollTop) {
    document.body.scrollTop = document.documentElement.scrollTop = scrollTop || 0;
    var $customPage = document.getElementsByClassName('custom-page')[0];
    if ($customPage) {
      document.getElementsByClassName('custom-page')[0].scrollTop = scrollTop || 0;
    }
  },
  getAuthSetting: function getAuthSetting() {
    // TODO: 未处理当前函数，如确定不需要请删除。web应该模拟不了这个接口
  },
  /**
   * 获取本地存储
   * @param {*} options
   */
  getStorage: function getStorage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var key = this.getAppId() + '_webapp_' + options.key;
    var data = JSON.parse(localStorage.getItem(key));
    options.success && options.success({ data: data });
    options.complete && options.complete({ data: data });
  },
  /**
   * 获取本地存储(同步)
   * 模拟wx.getStorageSync
   * @param {*} options
   */
  getStorageSync: function getStorageSync(curkey) {
    var key = this.getAppId() + '_webapp_' + curkey;
    return JSON.parse(localStorage.getItem(key));
  },
  /**
   * 设置本地存储
   * @param {*} options
   */
  setStorage: function setStorage(options) {
    options = options || {};
    var key = this.getAppId() + '_webapp_' + options.key;
    localStorage.setItem(key, JSON.stringify(options.data));
  },
  /**
   * 移除本地存储
   * @param {*} options
   */
  removeStorage: function removeStorage(options) {
    options = options || {};
    var key = this.getAppId() + '_webapp_' + options.key;
    localStorage.removeItem(key);
    typeof options.success === 'function' && options.success();
  },
  createAnimation: function createAnimation(params) {
    // 小程序和web端的差异规则
    var REPLACE_RULE = {
      'timingFunction': 'easing'
    };

    // 基本属性 待补充
    var BASIC_ATTR = ['top', 'right', 'bottom', 'left', 'width', 'height', 'opacity'];

    // 构造函数
    function Amt() {};

    // 涉及到链式调用,因此需要单例,用来判断是否已经实例化
    var amtObj = null;

    // 关键帧: 一个对象，代表关键帧的一个集合
    Amt.prototype.keyframes = {};

    // 可选项: 代表动画持续时间的整形数字 (以毫秒为单位), 或者一个包含一个或多个时间属性的对象：
    Amt.prototype.options = {};

    // 创建动画实例时, 添加的可选项
    for (var key in params) {
      params[key] = params[key] === 'step-start' ? 'linear' : params[key];
      Amt.prototype.options[REPLACE_RULE[key] || key] = params[key];
    }

    // 设置一些基础的原型方法
    // 必须传入一个开始的状态和结束的状态 (比如 top: [0, 1rem])
    BASIC_ATTR.forEach(function (item) {
      Amt.prototype[item] = function (obj) {
        var start = obj.start,
            end = obj.end;

        Amt.prototype.keyframes[item] = [start, end];
        return amtObj;
      };
    });

    // 可选项方法设置
    Amt.prototype.step = function () {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      for (var _key in obj) {
        Amt.prototype.options[REPLACE_RULE[_key] || _key] = obj[_key];
      }
      return amtObj;
    };

    Amt.prototype.rotate = function (obj) {
      var start = obj.start,
          end = obj.end,
          dom = obj.dom;

      Amt.prototype.keyframes['transform'] = ['rotate(' + start + 'deg)', 'rotate(' + end + 'deg)'];
      // 旋转之后需要保留当前的旋转结束的位置
      if (dom) {
        setTimeout(function () {
          dom.style.transform = 'rotate(' + end + 'deg)';
        }, Amt.prototype.options.duration);
      }
      return amtObj;
    };

    // 如果实例化过就返回这个对象,否则进行实例化操作
    amtObj = amtObj || new Amt();

    return amtObj;
  },
  /**
   * 导入微信地址。只能在微信里面使用。其他地方无法导入
   */
  chooseAddress: function chooseAddress(options) {
    if (this.isWeixin()) {
      wx.openAddress({
        success: function success(res) {
          typeof options.success === 'function' && options.success(res);
        },
        fail: function fail(res) {
          typeof options.fail === 'function' && options.fail();
        }
      });
    } else {
      _toast2.default.info('除微信里面，其他地方暂时不支持导入');
    }
  },
  downloadFile: function downloadFile(url, successfn) {
    // TODO: 按理说不需要
  },
  connectWifi: function connectWifi(option) {
    // TODO: web实现不了
  },
  startWifi: function startWifi(option) {
    // TODO: web实现不了
  },
  wifiErrCode: function wifiErrCode(code) {
    // TODO: web实现不了
  },
  checkSession: function checkSession(callback) {
    // TODO: web不需要
  },
  /**
   * 公众号登录中
   */
  wechatGzhLogining: false,
  /**
   * 抖音登录中
   */
  douyinLogining: false,
  /**
   * 去登陆微信公众号授权完成
   * @param {*} options
   */
  goLogin: function goLogin() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 如果处于预览页内嵌中，默认已经游客登录（防止用户在当前页设置跳转去登录）
    if (localStorage.getItem('is_preview') == 1 || (0, _tools.getQueryString)('is_preview')) {
      // 游客登录 去登录（在预览页中嵌套中用此登录）
      return;
    }
    // 微信浏览器内部登录
    if (this.isWeixin()) {
      if (this.wechatGzhLogining) {
        return;
      }
      this.wechatGzhLogining = true;
      var url = encodeURIComponent(window.location.href);
      if (url.indexOf("jisugpt") != -1 || url.indexOf("gptIndex") != -1) {
        window.location.href = '/index.php?r=Weixin/GzhLogin&app_id=' + this.getAppId() + '&is_chat=1&redirect_url=' + url;
        return;
      }
      window.location.href = '/index.php?r=Weixin/GzhLogin&app_id=' + this.getAppId() + '&redirect_url=' + url;
      return;
    }
    // 抖音浏览器登录
    if (this.isDouyin()) {
      if (this.douyinLogining) {
        return;
      }
      this.douyinLogining = true;
      var _url = encodeURIComponent(window.location.href);
      window.location.href = '/index.php?r=ByteM/WebLogin&app_id=' + this.getAppId() + '&redirect_url=' + _url;
      return;
    }
    if (this.globalData.currentPages.length > 1) {
      // 当前需要登录页非导航页时，且不为第一层页面时，跳转去登录页面可回退到前一层
      this.turnToPage('loginPage', {}, 1);
    } else {
      // 当前需要登录页为导航页时，跳转去登录页面不可回退
      this.turnToPage('loginPage');
    }
    if (options.success) {
      this.getCurrentPage().callbackFun = options.success;
    }
  },
  /**
   * 是否登录
   */
  isLogin: function isLogin() {
    return this.getIsLogin();
  },
  /**
   * 请求用户信息
   */
  requestUserInfo: function requestUserInfo() {
    var _this3 = this;

    return new Promise(function (resolve) {
      _this3.sendRequest({
        url: '/index.php?r=AppData/getUserInfo',
        type: 'get',
        success: function success(res) {
          if (!res.data) {
            return;
          }
          _this3.setUserInfoStorage(res.data);
          setTimeout(function () {
            _this3.setPageUserInfo();
          }, 0);
          resolve();
          // TODO 补全代码
        }
      });
    });
  },
  /**
   * 页面初始化
   * @description 处理页面传入参数
   */
  onPageLoad: function onPageLoad() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var that = this;
    var pageInstance = this.getAppCurrentPage() || {};
    // 详情页参数
    var detail = options.detail || '';
    // 多商家参数
    var franchisee = options.franchisee;
    // 社区团购参数
    var promotionName = options.promotionName;

    // 分享参数保存在页面上
    pageInstance.sharePageParams = options;
    // 详情页参数处理
    if (detail) {
      pageInstance.dataId = detail;
    }
    // 多商家参数处理
    if (franchisee) {
      pageInstance.franchiseeId = franchisee;
      pageInstance.fmode = e.fmode;
      pageInstance.setData({
        franchiseeInfo: {
          id: e.franchisee,
          mode: e.fmode || ''
        }
      });
    }
    // 社区团购参数处理
    if (promotionName) {
      this.setPageTitle(promotionName);
    }
    // 页面数据设置 Page.data
    pageInstance.setData({
      dataId: detail,
      addShoppingCartShow: false,
      addTostoreShoppingCartShow: false,
      // 微信开放组件兼容性
      canIUseOfficialAccount: that.globalData.canIUseOfficialAccount,
      // 客服来源
      sessionFrom: this.getPageFranchiseeId() || this.globalData.appId
    });
    this.setPageUserInfo();
    // 全局数据设置
    this.globalData.takeoutRefresh = false; // 外卖组件刷新
    this.globalData.tostoreRefresh = false; // 到店组件刷新
    // 设置【技术支持】是否显示
    this.checkTechSupport();
    // 是否需要去绑定手机
    if (that.globalData.isGoBindPhone) {
      // 登录积分获取判断
      that.loginForRewardPoint(that.globalData.loginGetIntegralTime);
      that.globalData.loginGetIntegralTime = '';
      that.globalData.isGoBindPhone = false;
    }
    // 连锁店需要提前获取数据，否则不进行页面数据初始化
    if (this.globalData.chainNotLoading) {
      return;
    }

    // 进行页面数据初始化
    this.pageDataInitial();
    // 特殊页面数据初始化
    if (pageInstance.data.router === 'userCenterComponentPage') {
      this.getAppECStoreConfig(function (res) {
        pageInstance.setData({
          storeStyle: res.color_config
        });
      });
    }
  },
  /**
   * 比较用户是否有权限
   */
  toCompareRole: function toCompareRole(callback) {
    var pageInstance = this.getAppCurrentPage();
    var appRoleData = pageInstance.data.customFeature.appRoleData;
    var _userInfo = this.getUserInfo();

    if (!_userInfo.role_name) {
      typeof callback == 'function' && callback(true);
      return;
    }

    if (_userInfo.role_name.length > 0) {
      var hasRole = false;
      _userInfo.role_name.forEach(function (value) {
        appRoleData.forEach(function (item) {
          if (value == item.role_name) {
            hasRole = true;
            return;
          }
        });
        if (hasRole) return;
      });
      if (!hasRole) {
        typeof callback == 'function' && callback(true);
      } else {
        typeof callback == 'function' && callback(false);
      }
    } else if (_userInfo.role_name.length === 0) {
      typeof callback == 'function' && callback(true);
    }
  },
  // TODO: 未处理当前函数，如确定不需要请删除
  pullRefreshTime: '',
  onPagePullDownRefresh: function onPagePullDownRefresh() {
    // TODO: 未处理当前函数，如确定不需要请删除
    // 未在页面上实现当前触发
  },
  setPageScroll: function setPageScroll(pageInstance) {
    var _this4 = this;

    // 当前设置的【触发底部刷新】的组件 索引 (只有一个组件可设置)
    var reachBottomComponentIndex = -1;
    // 可设置【触发底部刷新】的组件
    // 组件类型 转换 组件滚动函数名
    var reachBottomMethodName = {
      'bbs': 'bbsScrollFuc',
      'list-vessel': 'pageScrollFunc',
      'goods-list': 'goodsScrollFunc',
      'seckill': 'seckillScrollFunc',
      'video-list': 'videoScrollFunc',
      'news': 'getNewsList',
      'topic': 'getTopListData',
      'franchisee-list': 'franchiseeScrollFunc',
      'exchange-coupon': 'exchangeCouponScrollFunc',
      'dynamic-classify': 'pageScrollFunc',
      'community-group': 'communityGroupScrollFunc',
      'group-buy-list': 'catchMoreGroupList',
      'presell': 'catchMorePresellList'
    };
    for (var i = 0; i < pageInstance.data.eles.length; i++) {
      var ele = pageInstance.data.eles[i];
      // 判断组件是否隐藏
      if (ele && ele.hidden) {
        continue;
      }
      var eleType = ele.type;
      var customFeature = ele.customFeature;
      // 符合条件
      if (reachBottomMethodName[eleType] && (eleType == 'news' && customFeature.vesselAutoheight === undefined || customFeature.vesselAutoheight == 1 && customFeature.loadingMethod == 0 || eleType == 'bbs')) {
        reachBottomComponentIndex = i;
      }
    }
    if (reachBottomComponentIndex === -1) {
      pageInstance.reachBottomFuc = [];
      return;
    }
    var componentData = pageInstance.data.eles[reachBottomComponentIndex];
    var componentType = componentData.type;
    var reachBottomObj = {
      param: {
        compIndex: reachBottomComponentIndex
      }
    };
    // 【动态列表】/【动态分类】 调取当前页面滚动函数
    if (componentType === 'list-vessel' || componentType === 'dynamic-classify') {
      reachBottomObj['triggerFuc'] = function (param) {
        _this4.pageScrollFunc(param.compIndex);
      };
    } else {
      reachBottomObj['triggerFuc'] = function (param) {
        pageInstance.callComponentMethod({
          componentIndex: reachBottomComponentIndex,
          methodName: reachBottomMethodName[componentType],
          argvs: [param.compIndex]
        });
      };
    }
    // 当前规则仅一个触底刷新组件
    pageInstance.reachBottomFuc = [reachBottomObj];
  },
  /**
   * 页面数据初始化
   * @param {*} isPullRefresh 
   * @param {*} pageIn 
   * @param {*} isAllowLoad 
   */
  pageDataInitial: function pageDataInitial(isPullRefresh, pageIn, isAllowLoad) {
    var _this = this;
    var pageInstance = pageIn || this.getAppCurrentPage();
    var pageRequestNum = pageInstance.requestNum;

    pageInstance.downcountObject = {};

    var appRole = Number(pageInstance.data.customFeature.AppRole);
    if (appRole && !isAllowLoad) {
      if (!pageInstance.isCompareRole) {
        pageInstance.isCompareRole = true;
        if (this.isLogin()) {
          _this.toCompareRole(function (value) {
            if (value) {
              _this.showModal({
                content: "您暂时没有浏览该页面的权限，请联系小程序管理员开通。",
                confirm: function confirm(res) {
                  pageInstance.isCompareRole = false;
                  _this.turnBack();
                }
              });
            } else {
              pageInstance.isCompareRole = false;
              _this.pageDataInitial(isPullRefresh, pageIn, true);
            }
          });
        } else {
          this.goLogin({
            success: function success() {
              _this.toCompareRole(function (value) {
                if (value) {
                  _this.showModal({
                    content: "您暂时没有浏览该页面的权限，请联系小程序管理员开通。",
                    confirm: function confirm(res) {
                      pageInstance.isCompareRole = false;
                      _this.turnBack();
                    }
                  });
                } else {
                  pageInstance.isCompareRole = false;
                  _this.pageDataInitial(isPullRefresh, pageIn, true);
                }
              });
            }
          });
        }
      }
      return;
    }

    if (!isPullRefresh) {
      _this.setPageScroll(pageInstance);
    }

    // 优先判断页面是否绑定了数据对象，没有绑定时直接展示页面，绑定时就等数据请求之后再展示
    if (!!pageInstance.dataId && !!pageInstance.data.customFeature.form) {
      var dataid = parseInt(pageInstance.dataId);
      var param = {};

      param.data_id = dataid;
      param.form = pageInstance.data.customFeature.form;

      pageInstance.requestNum = pageRequestNum + 1;
      _this.sendRequest({
        hideLoading: pageRequestNum++ == 1 ? false : true,
        url: '/index.php?r=AppData/getFormData',
        data: param,
        method: 'post',
        chain: true,
        success: function success(res) {
          var newdata = {};
          var formdata = res.data[0].form_data;

          for (var i in formdata) {
            if (i == 'category') {
              continue;
            }
            if (/region/.test(i)) {
              continue;
            }
            // TODO：小程序处理富文本字段 代码位置
          }
          newdata['detailData'] = formdata;
          pageInstance.setData(newdata);

          // 当有视频字段时，请求视频链接，并放到数据里 (数组)
          var field = _this.getFormPageField(pageInstance.data);

          var _loop = function _loop(_i) {
            if (field.indexOf(_i) > -1 && formdata[_i] instanceof Object && formdata[_i].type === 'video') {
              var video = formdata[_i];

              pageInstance.requestNum = pageRequestNum + 1;
              _this.sendRequest({
                hideLoading: pageRequestNum++ == 1 ? false : true, // 页面第一个请求才展示loading
                url: '/index.php?r=AppVideo/GetVideoLibUrl',
                data: {
                  id: video.id
                },
                chain: true,
                method: 'get',
                success: function success(res) {
                  var videoUrl = res.data,
                      newdata = {};

                  newdata['detailData.' + _i + '.videoUrl'] = videoUrl;
                  pageInstance.setData(newdata);
                }
              });
            }
          };

          for (var _i in formdata) {
            _loop(_i);
          }

          // TODO: 处理轮播组件(轮播组)旧数据处理方式 代码区域

          // 进行【动态容器】组件的数据初始化
          pageInstance.data.eles.forEach(function (ele, eleIndex) {
            if (ele.type === 'dynamic-vessel') {
              pageInstance.callComponentMethod({
                componentIndex: eleIndex,
                methodName: 'detailPageInit',
                argvs: [eleIndex, pageInstance, formdata]
              });
            }
          });
        },
        complete: function complete() {
          // TODO
          pageInstance.setData({
            page_hidden: false
          });
        }
      });
    } else if (!pageInstance.dataId && !!pageInstance.data.customFeature.form) {
      // WEBAPP
      // 绑定详情页，但没有具体id
      _this.showModal({
        content: "数据id为空，页面绑定详情页，需要从列表页跳转"
      });
    } else {
      // TODO
      pageInstance.setData({
        page_hidden: false
      });
    }
    // TODO: 当前位置为小程序组件初始化代码位置
    // 进行当前页组件及组件内部子组件的初始化(web端都是重新加载，组件自行初始化)
  },
  onPageScroll: function onPageScroll(e) {
    var pageInstance = this.getAppCurrentPage();
    var pageRouter = pageInstance.page_router;
    this.globalData.susTopicCompindexs = this.globalData.susTopicsMap[pageRouter];
    if (this.globalData.susTopicCompindexs && this.globalData.susTopicCompindexs.length) {
      // 有悬浮窗话题列表判断是否要显示向上按钮
      var topBtnShow = e.scrollTop > 0 && this.globalData.pageScrollTop - e.scrollTop > 0;
      for (var i in this.globalData.susTopicCompindexs) {
        var compindex = this.globalData.susTopicCompindexs[i];
        if ((pageInstance.data.eles[compindex].topicSuspension.topBtnShow || false) !== topBtnShow) {
          pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicSuspension.topBtnShow', topBtnShow));
        }
      }
    }
    this.globalData.pageScrollTop = e.scrollTop;
  },
  getIntegralLog: function getIntegralLog(addTime) {
    // TODO: 到时候看分享情况在决定要不要这个
  },
  /**
   * 文章计数
   */
  CountSpreadCount: function CountSpreadCount(articleId) {
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/CountSpreadCount',
      data: { article_id: articleId },
      success: function success(res) {}
    });
  },
  /**
   * 处理虚拟价格
   */
  formVirtualPrice: function formVirtualPrice(formdata) {
    var modelVP = [];
    var price = '';
    for (var l in formdata.goods_model) {
      modelVP.push(formdata.goods_model[l].virtual_price == '' ? 0 : Number(formdata.goods_model[l].virtual_price));
    }
    if (Math.min.apply(Math, modelVP) == Math.max.apply(Math, modelVP)) {
      if (formdata.virtual_price instanceof Object) {
        price = formdata.virtual_price;
        price = Math.min.apply(Math, modelVP).toFixed(2);
      } else {
        price = Math.min.apply(Math, modelVP).toFixed(2);
      }
    } else {
      if (formdata.virtual_price instanceof Object) {
        price = formdata.virtual_price;
        price = Math.min.apply(Math, modelVP).toFixed(2) + '~' + Math.max.apply(Math, modelVP).toFixed(2);
      } else {
        price = Math.min.apply(Math, modelVP).toFixed(2) + '~' + Math.max.apply(Math, modelVP).toFixed(2);
      }
    }
    return price;
  },
  /**
   * 获取动态列表绑定了什么字段
   */
  getListVessel: function getListVessel(comp) {
    var that = this;
    var field = [];

    if (Object.prototype.toString.call(comp.content) == "[object Array]") {
      for (var i = 0; i < comp.content.length; i++) {
        var cp = comp.content[i];
        if ((0, _typeof3.default)(cp.content) == 'object') {
          var f = that.getListVessel(cp);
          field = field.concat(f);
        } else if (cp.customFeature && cp.customFeature.segment) {
          field.push(cp.customFeature.segment);
          if (cp.customFeature.segment == 'default_map') {
            field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
          }
        }
      }
    } else {
      for (var _i2 in comp.content) {
        var _cp = comp.content[_i2];
        for (var j = 0; j < _cp.length; j++) {
          var cpj = _cp[j];
          if ((0, _typeof3.default)(cpj.content) == 'object') {
            var _f = that.getListVessel(cpj);
            field = field.concat(_f);
          } else if (cpj.customFeature && cpj.customFeature.segment) {
            field.push(cpj.customFeature.segment);
            if (cpj.customFeature.segment == 'default_map') {
              field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
            }
          }
        }
      }
    }
    return field;
  },
  /**
   * 获取表单绑定了什么字段
   */
  getFormPageField: function getFormPageField(data) {
    var that = this;
    var field = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = data.eles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var ele = _step.value;

        if ((0, _typeof3.default)(ele.content) == 'object') {
          var f = that.getListVessel(ele);
          field = field.concat(f);
        } else if (ele.customFeature && ele.customFeature.segment) {
          field.push(ele.customFeature.segment);
          if (ele.customFeature.segment == 'default_map') {
            field = field.concat(['region_lng', 'region_lat', 'region_string', 'region_detail']);
          }
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return field;
  },
  /**
   * 根据组件的ID，返回组件的索引值
   */
  getElementById: function getElementById(id, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    var pageData = pageInstance.data.eles;
    var compid = '';
    for (var i in pageData) {
      var ele = pageData[i];
      // if (Object.prototype.toString.call(ele) === "[object Object]"){ //web 这边不需要判断
      if (ele.type && ele.customFeature.id == id && !ele.hidden) {
        compid = {
          index: i,
          data: ele
        };
        break;
      }
      // }
    }
    return compid;
  },
  /**
   * 根据组件的ID，返回组件的索引值(替换getElementById)
   */
  findComponentIndexById: function findComponentIndexById(id, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    var pageData = pageInstance.data.eles || [];
    return pageData.findIndex(function (ele) {
      return ele.type && ele.customFeature.id == id && !ele.hidden;
    });
  },
  /**
   * 返回关联的组件的索引
   * @param {string} id 被关联的组件的ID，例如 商品列表的ID
   * @param {string} type 关联组件的type, 例如 分类组件的type
   * @param {string} field 关联组件的关联字段，不同的组件会不一样
   * @param {object} pageInstance 页面的实例，不传则获取当前页面
   */
  getInvolvedFromRefreshObject: function getInvolvedFromRefreshObject(id, type, field, pageInstance) {
    pageInstance = pageInstance || this.getAppCurrentPage();
    var pageData = pageInstance.data.eles;
    var compid = '';
    field = field || "refresh_object";
    for (var i in pageData) {
      var ele = pageData[i];
      // if (Object.prototype.toString.call(ele) === "[object Object]"){
      if (ele.type && type == ele.type && ele.customFeature[field] == id && !ele.hidden) {
        compid = {
          index: i,
          data: ele
        };
        break;
      }
      // }
    }
    return compid;
  },
  /**
   * 根据对象的路径去获取对应的值
   */
  getObjectByPath: function getObjectByPath(path, obj) {
    path = path.replace(/\[(\w+)\]/g, '.$1');
    var keyArr = path.split('.');
    for (var i = 0; i < keyArr.length; i++) {
      var key = keyArr[i];
      if (!obj.hasOwnProperty(key)) {
        break;
      }
      obj = obj[key];
    }
    return obj;
  },
  /**
   * 触发点击事件
   * @param {*} e
   */
  tapEventCommonHandler: function tapEventCommonHandler(e) {
    var customFeature = JSON.parse(e.currentTarget.dataset.eventParams);
    var compindex = e.currentTarget.dataset.compindex;
    if (!customFeature.compindex && compindex) {
      customFeature.compindex = compindex;
    }
    (0, _customEvent.customEvent)({
      customFeature: customFeature,
      event: event
    });
  },
  /**
   * 根据经纬度获取地址
   */
  getAddressByLatLng: function getAddressByLatLng(params, callback) {
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=Map/getAreaInfoByLatAndLng',
      data: {
        latitude: params.lat,
        longitude: params.lng
      },
      success: function success(res) {
        callback(res);
      }
    });
  },
  /**
   * 用户制作的页面的分享
   */
  onPageShareAppMessage: function onPageShareAppMessage(event) {
    var pageInstance = this.getAppCurrentPage();
    var pagePath = pageInstance.route;
    var image = event.target ? event.target.dataset.image : '';
    var title = event.target ? event.target.dataset.desc : '';
    var desc = this.globalData.appDescription;

    pagePath = window.location.origin + '/zc_webapp/' + pagePath;

    pageInstance.setData({
      pageQRCodeData: {
        shareDialogShow: "100%",
        shareMenuShow: false
      }
    });

    var pageParam = {
      "detail": pageInstance.dataId,
      "user_token": this.globalData.PromotionUserToken,
      "vcard_user_id": this.globalData.HasCardToShareUserId,
      "franchisee": pageInstance.franchiseeId
    };
    for (var i in pageParam) {
      if (pageParam[i]) {
        if (pagePath.indexOf('?') < 0) {
          pagePath += '?';
        } else {
          pagePath += '&';
        }
        pagePath += i + '=' + pageParam[i];
      }
    }

    return this.shareAppMessage({ path: pagePath, imageUrl: image, title: title, desc: desc });
  },
  onPageShow: function onPageShow() {
    // this.setPageUserInfo();
    // TODO: 未处理当前函数，如确定不需要请删除
    // let that = this;
    // let pageInstance = this.getAppCurrentPage();
    // let needRefreshPages = this.globalData.needRefreshPages;
    // let pageRouter = this.getPageRouter();
    // let pageIndex = needRefreshPages.indexOf(pageRouter);

    // if (this.globalData.takeoutRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.takeoutRefresh = false;
    // } else if (this.globalData.tostoreRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.tostoreRefresh = false;
    // } else if (this.globalData.topicRefresh && this.globalData.hasTopicCom) {
    //   this.pageDataInitial();
    //   this.globalData.topicRefresh = false;
    // } else if (this.globalData.listVesselRefresh && pageIndex > -1) {
    //   this.pageDataInitial();
    //   needRefreshPages.splice(pageIndex, 1);
    //   if (!needRefreshPages.length) {
    //     this.globalData.listVesselRefresh = false;
    //   }
    // } else if (this.globalData.communityGroupRefresh) {
    //   this.pageDataInitial();
    //   this.globalData.communityGroupRefresh = false;
    // } else {
    //   that.setPageUserInfo();
    // }
    // if (this.globalData.topicTurnToDetail) {
    //   this.globalData.topicTurnToDetail = false;
    // }
    // if (pageInstance.user_center_compids_params.length) {
    //   for (let i in pageInstance.user_center_compids_params) {
    //     let compid = pageInstance.user_center_compids_params[i].compid
    //     this._initUserCenterData(pageInstance, compid);
    //   }
    // }
    // if (!!pageInstance.exchangeCouponComps.length) {
    //   let _this = that
    //   for (let i in pageInstance.exchangeCouponComps) {
    //     let compid = pageInstance.exchangeCouponComps[i].compid;
    //     customComponent["exchange-coupon"].init(compid, pageInstance);
    //   }
    // }
    // 当前页面需要登录且没有绑定手机且未登录
    // if (pageInstance.need_login && !pageInstance.bind_phone && !this.isLogin()) {
    //   this.goLogin({});
    // } else if (pageInstance.need_login && pageInstance.bind_phone && !this.getUserInfo().phone && !that.globalData.isOpenSettingBack) {
    //   if (this.isLogin()) {
    //     setTimeout(function () {
    //       let url = 'pages/' + pageInstance.page_router + '/' + pageInstance.page_router + '?' + util.getCurrentPageArgs();
    //       that.turnToPage('/default/pages/bindCellphone/bindCellphone?p=' + encodeURIComponent(url), 1);
    //     }, 1000);
    //   } else {
    //     let addTime = Date.now();
    //     that.globalData.loginGetIntegralTime = addTime;
    //     that.globalData.isGoBindPhone = true;
    //     this.goLogin({
    //       success: function () {
    //         let userInfo = that.getUserInfo();
    //         if (!userInfo.phone) {
    //           let url = 'pages/' + pageInstance.page_router + '/' + pageInstance.page_router + '?' + util.getCurrentPageArgs();
    //           that.turnToPage('/default/pages/bindCellphone/bindCellphone?p=' + encodeURIComponent(url), 1);
    //         } else {
    //           that.loginForRewardPoint(addTime);
    //           that.globalData.isGoBindPhone = false;
    //         }
    //       }
    //     });
    //   }
    //   that.globalData.isOpenSettingBack = false;
    // }
    // 返回排号组件重新刷新
    // if (pageInstance.rowNumComps.length) {
    // }
    // 返回到店组件重新刷新
    // if (pageInstance.tostoreComps.length && pageInstance.returnToVersionFlag === 1) {

    // }
    // 多商家列表待审核状态进入预览修改了模板返回需要重新加载
    // if (this.globalData['franchiseeTplChange-' + pageInstance.page_router]) {

    // }
    // 签到刷新累积签到详情
    // if (pageInstance.signInComps.length) {
    // }
    // 多商家列表重新定位后刷新组件
    // if (this.globalData.franchiseeListCompsRefresh) {

    // }
    // 返回竖版列表重新刷新
    // if (pageInstance.verticalListComps && pageInstance.verticalListComps.length) {

    // }

    // let pageData = pageInstance.data;
    // for (let i in pageData) {
    //   let ele = pageData[i];
    //   if (Object.prototype.toString.call(ele) === "[object Object]"){
    //       let type = ele.type;
    //     if (type && !ele.hidden){
    //       let compid = ele.compId;
    //       customComponent[type] && customComponent[type].onPageShow && customComponent[type].onPageShow(compid, pageInstance);
    //     }
    //   }
    // }
  },
  onPageHide: function onPageHide() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  returnListHeight: function returnListHeight(isshow, takeout, mode) {
    return this.getSystemInfoSync().windowHeight;
  },
  onPageReachBottom: function onPageReachBottom() {
    var reachBottomFuc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    reachBottomFuc.forEach(function (e) {
      e.triggerFuc(e.param);
    });
  },
  onPageUnload: function onPageUnload(page) {
    var pageInstance = page || this.getAppCurrentPage();
    var pageRouter = page ? page.page_router : pageInstance.page_router;
    this._logining = false;
    var downcountArr = pageInstance.downcountArr;
    if (downcountArr && downcountArr.length) {
      for (var i = 0; i < downcountArr.length; i++) {
        downcountArr[i] && downcountArr[i].clear();
      }
    }

    if (this.globalData.newCountDataOnPage[pageRouter]) {
      // 清除绑定页面上的计数
      delete this.globalData.newCountDataOnPage[pageRouter];
    }
    //清除定时器
    var dco = pageInstance.downcountObject;
    for (var key in dco) {
      var dcok = dco[key];
      if (dcok && dcok.length) {
        for (var _i3 = 0; _i3 < dcok.length; _i3++) {
          dcok[_i3] && dcok[_i3].clear();
        }
      }
    }
    //清除多人点餐定时器
    pageInstance.data.eles.forEach(function (ele) {
      if (ele.type === 'vertical-list') {
        if (ele.timer) {
          clearInterval(ele.timer);
        }
      }
    });

    //清除动态分类借节点监控
    pageInstance.data.eles.forEach(function (ele, eleIndex) {
      if (ele.type === 'dynamic-classify') {
        if (ele.classify_observer) {
          clearInterval(ele.classify_observer);
        }
        if (ele.list_observer) {
          clearInterval(ele.list_observer);
        }
      }
    });
  },
  /**
   * 触发预览大图
   * @param {*} event
   */
  tapPrevewPictureHandler: function tapPrevewPictureHandler(event) {
    var img = event.currentTarget.dataset.img;
    var imgarr = event.currentTarget.dataset.imgarr.split(',');
    this.previewImage({
      current: event.currentTarget.dataset.img || imgarr[0],
      urls: imgarr instanceof Array ? imgarr : [imgarr]
    });
  },
  pageScrollFunc: function pageScrollFunc(event) {
    // TODO: 未完全实现
    var pageInstance = this.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];

    if (!compData) {
      console.log('pageScrollFunc is not find compData');
      return;
    }
    if (compData.is_search) {
      var searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    } else {
      this._pageScrollFunc(event);
    }
  },
  _pageScrollFunc: function _pageScrollFunc(event) {
    var pageInstance = this.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = (compData.curpage || 0) + 1;
    var newdata = {};
    var param = {};
    var _this = this;
    var customFeature = compData.customFeature;
    var url = '/index.php?r=AppData/getFormDataList';

    if (compData.type === 'news') {
      if (compData.pageObj.noMore && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
        _this.showModal({
          content: '已经加载到最后了'
        });
        return;
      }
      pageInstance.callComponentMethod({
        componentIndex: compindex,
        methodName: 'getNewsList',
        argvs: [{
          compindex: compindex,
          pageInstance: pageInstance
        }]
      });
      return;
    }

    if (!compData.is_more && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
      _this.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    // 动态列表处理
    if (compData.type === 'list-vessel') {
      param = pageInstance.data.eles[compindex].param;
    }
    param.form = customFeature.form;
    param.need_column_arr = compData.need_column_arr;

    // 动态分类组件处理
    if (compData.type === 'dynamic-classify') {
      var len = compData.currentCategory.length;
      var cate = compData.currentCategory[len - 1];
      if (len == 2) {
        var firstCate = compData.currentCategory[0];
        for (var j = 0; j < compData.classifyData.length; j++) {
          var classify = compData.classifyData[j];
          if (classify.category_id == firstCate && classify.subclass.length == 0) {
            cate = firstCate;
            break;
          }
        }
      }
      param = {
        form: compData.classifyGroupForm,
        page_size: compData.customFeature.loadingNum || 15,
        idx_arr: {
          idx: 'category',
          idx_value: cate
        },
        sort_key: compData.sort_key === undefined ? '' : compData.sort_key,
        sort_direction: compData.sort_direction === undefined ? '' : compData.sort_direction
      };
    }
    if (customFeature.form == 'group_buy') {
      url = "/index.php?r=AppGroupBuy/GetGroupBuyGoodsList";
      param.current_status = 0;
    }

    if (customFeature.source && customFeature.source !== 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }

    param.page_size = customFeature.loadingNum || 10;
    param.page = curpage;

    this.sendRequest({
      url: url,
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        newdata = {};
        var len = compData.list_data ? compData.list_data.length : 0;

        for (var _j in res.data) {
          if (customFeature.form == 'group_buy') {
            res.data[_j] = {
              form_data: Object.assign({}, res.data[_j])
            };
          }
          for (var k in res.data[_j].form_data) {
            if (k == 'category') {
              continue;
            }
            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[_j].form_data.virtual_price = _this.formVirtualPrice(res.data[_j].form_data);
            }
            if (k == 'distance') {
              res.data[_j].form_data[k] = _util2.default.formatDistance(res.data[_j].form_data[k]);
            }

            var description = res.data[_j].form_data[k];

            if (compData.listField && compData.listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
              //没有绑定的字段的富文本置为空
              res.data[_j].form_data[k] = '';
            }
          }

          newdata['eles[' + compindex + '].list_data[' + (+_j + len) + ']'] = res.data[_j];
        }

        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  },
  franchiseeScrollFunc: function franchiseeScrollFunc(event) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 点赞 取消点赞
   */
  changeCountRequert: {},
  changeCount: function changeCount(event) {
    var dataset = event.currentTarget.dataset;
    var that = this;
    var pageInstance = this.getAppCurrentPage();
    var newdata = {};
    var counted = dataset.counted;
    var compindex = dataset.compindex;
    var objrel = dataset.objrel;
    var form = dataset.form;
    var dataIndex = dataset.index;
    var parentcompindex = dataset.parentcompindex || -1;
    var parentcompData = parentcompindex > -1 ? pageInstance.data.eles[parentcompindex] : null;
    var parentType = dataset.parenttype;
    var url = void 0;
    var objIndex = compindex + '_' + objrel;

    if (counted == 1) {
      url = '/index.php?r=AppData/delCount';
    } else {
      url = '/index.php?r=AppData/addCount';
    }

    if (that.changeCountRequert[objIndex]) {
      return;
    }
    that.changeCountRequert[objIndex] = true;

    that.sendRequest({
      url: url,
      data: { obj_rel: objrel },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        newdata = {};

        if (parentcompindex > -1) {
          if (parentcompData.type === 'list-vessel') {
            newdata['eles[' + parentcompindex + '].list_data[' + dataIndex + '].count_num'] = counted == 1 ? parseInt(pageInstance.data.eles[parentcompindex].list_data[dataIndex].count_num) - 1 : parseInt(res.data.count_num);
            newdata['eles[' + parentcompindex + '].list_data[' + dataIndex + '].has_count'] = counted == 1 ? 0 : parseInt(res.data.has_count);
          } else if (parentcompData.type === 'bbs') {
            newdata['eles[' + parentcompindex + '].content.data[' + dataIndex + '].count_num'] = counted == 1 ? parseInt(pageInstance.data.eles[parentcompindex].content.data[dataIndex].count_num) - 1 : parseInt(res.data.count_num);
            newdata['eles[' + parentcompindex + '].content.data[' + dataIndex + '].has_count'] = counted == 1 ? 0 : parseInt(res.data.has_count);
          } else if (parentcompData.type === 'free-vessel' || parentcompData.type === 'popup-window' || parentcompData.type === 'dynamic-vessel') {
            // TODO 跟小程序稍有不同
            path = 'eles[' + parentcompindex + '].content[' + compindex + ']';
            newdata[path + '.count_data.count_num'] = parseInt(res.data.count_num);
            newdata[path + '.count_data.has_count'] = parseInt(res.data.has_count);
          } else if (parentType && parentType.indexOf('list_vessel') === 0) {
            newdata[parentType + '.list_data[' + dataIndex + '].count_num'] = parseInt(res.data.count_num);
            newdata[parentType + '.list_data[' + dataIndex + '].has_count'] = parseInt(res.data.has_count);
          }
        } else {
          newdata['eles[' + compindex + '.count_data.count_num'] = parseInt(res.data.count_num);
          newdata['eles[' + compindex + '.count_data.has_count'] = parseInt(res.data.has_count);
          pageInstance.setData(newdata);
        }

        pageInstance.setData(newdata);
        that.changeCountRequert[objIndex] = false;
      },
      complete: function complete() {
        that.changeCountRequert[objIndex] = false;
      }
    });
  },
  tapMapDetail: function tapMapDetail(event) {
    var dataset = event.currentTarget.dataset;
    var params = dataset.eventParams;
    if (!params) return;

    params = JSON.parse(params)[0];
    this.openLocation({
      latitude: +params.latitude,
      longitude: +params.longitude,
      name: params.desc || '',
      address: params.name || ''
    });
  },
  /**
   * 动态列表/动态分类 跳转页面函数
   * @param {*} event 
   */
  listVesselTurnToPage: function listVesselTurnToPage(event) {
    var that = this;
    var dataset = event.currentTarget.dataset;
    var pageInstance = this.getAppCurrentPage();
    var data_id = dataset.dataid;
    var router = dataset.router;
    var isseckill = dataset.isseckill; // 是否是商品秒杀
    var compindex = dataset.compindex;
    var index = dataset.index;
    var compData = pageInstance.data.eles[compindex];
    var list = compData.list_data[index];
    var form_data = list.form_data || list;

    if (this.isTurnToListVesselDetail) {
      // 防止重复点击
      this.showToast({
        title: '正在跳转，请勿重复点击',
        icon: 'none'
      });
      return;
    }
    this.isTurnToListVesselDetail = true;

    if (compData.haveViewCountEle) {
      // 动态列表有添加浏览计数
      var objId = compData.form;
      var contentPath = 'eles[' + compindex + '].list_data[' + index + '].count_info.view_info';
      var param = {
        count_type: 2,
        support_cancel: 0,
        effect: 2,
        total_times: 1,
        obj_id: objId,
        data_id: data_id
        // // 计数器组件索引（TODO: 还没找到，要写）
        // let countComponentIndex = -1;
        // // 调用计数器组件的方法
        // pageInstance.callComponentMethod({
        //   componentIndex: countComponentIndex,
        //   methodName: 'newCountAddCount',
        //   argvs: [param, function(res) {
        //     // 调用计数器组件的方法
        //     pageInstance.callComponentMethod({
        //       componentIndex: countComponentIndex,
        //       methodName: 'newCountSetNewData',
        //       argvs: [pageInstance, contentPath, res, function () {
        //         that.isTurnToListVesselDetail = false;
        //         that.globalData.listVesselHaveViewCountEle = true;
        //         that.listVesselTurnToPageAct(router, form_data, data_id, isseckill);
        //       }]
        //     });
        //   }]
        // });
      };return;
    }

    this.isTurnToListVesselDetail = false;
    this.listVesselTurnToPageAct(router, form_data, data_id, isseckill);
  },
  /**
   * 动态列表/动态分类 跳转页面后续处理
   * @param {*} router 
   * @param {*} form_data 
   * @param {*} data_id 
   * @param {*} isseckill 
   */
  listVesselTurnToPageAct: function listVesselTurnToPageAct(router, form_data, data_id, isseckill) {
    if (router == '' || router == -1 || router == '-1') {
      return;
    }
    var franchisee = this.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (router == 'tostoreDetail') {
      this.turnToPage('toStoreDetail?detail=' + data_id + chainParam);
    } else if (router == 'goodsDetail') {
      if (isseckill == 1) {
        var seckillType = form_data.is_seckill_activity ? form_data.is_seckill_activity : '';
        var seckill_activity_id = form_data.seckill_activity_id ? form_data.seckill_activity_id : '';
        var seckill_activity_time_id = form_data.seckill_activity_time_id ? form_data.seckill_activity_time_id : '';
        this.turnToPage('seckillDetail?id=' + data_id + '&sec_act_id=' + seckill_activity_id + '&sec_t_id=' + seckill_activity_time_id + '&secType=' + seckillType);
      } else if (form_data.is_group_buy && form_data.is_group_buy == 1) {
        data_id = form_data.goods_id; //模板上不存在goodsId，需要通过页面数据获取
        var group_activity_id = form_data.activity_id || '';
        this.turnToPage('gpgoodsDetail?goods_id=' + data_id + '&activity_id=' + group_activity_id + chainParam);
      } else {
        this.turnToPage('goodsDetail?detail=' + data_id + chainParam);
      }
    } else if (router == 'videoDetail') {
      this.turnToPage('videoDetail?detail=' + data_id + chainParam);
    } else if (router == 'groupGoodsDetail') {
      data_id = form_data.goods_id; //模板上不存在goodsId，需要通过页面数据获取
      var _group_activity_id = form_data.activity_id || '';
      this.turnToPage('gpgoodsDetail?goods_id=' + data_id + '&activity_id=' + _group_activity_id + chainParam);
    } else if (router == 'franchiseeDetail') {
      var mode = form_data.mode_id;
      this.goToFranchisee(mode, {
        detail: data_id
      });
    } else if (router == 'presellDetail') {
      this.turnToPage(router + '?detail=' + data_id);
    } else {
      this.turnToPage(router + '?detail=' + data_id);
    }
  },
  userCenterTurnToPage: function userCenterTurnToPage(event) {
    // 判断是否登录
    var that = this;
    if (this.isLogin()) {
      var _event$currentTarget$ = event.currentTarget.dataset,
          router = _event$currentTarget$.router,
          openVerifyPhone = _event$currentTarget$.openVerifyPhone,
          eventParams = _event$currentTarget$.eventParams,
          goodsType = _event$currentTarget$.goodsType,
          needCollectInfo = _event$currentTarget$.needCollectInfo,
          index = _event$currentTarget$.index;

      var param = JSON.parse(eventParams || '""');
      var currentIndex = index;
      if (router === 'myPresale') {
        this.turnToPage('presellOrderList');
        return;
      }
      if (router === 'newsPocketsBalance') {
        this.turnToPage(router);
        return;
      }
      // 开启手机验证
      if (openVerifyPhone && openVerifyPhone !== 'false' && !this.getUserInfo().phone) {
        // 验证用户信息是否有填写手机号
        this.turnToPage('bindCellphone');
        return;
      }
      if (router == 'myOrder' && goodsType) {
        this.turnToPage(router, {
          goodsType: goodsType,
          currentIndex: currentIndex
        });
        return;
      }
      if (router == 'vipCard' && globalData.hasFranchiseeList) {
        if (needCollectInfo == 1) {
          this.turnToPage(router, {
            is_member: 1,
            franchisee: globalData.chainAppId || ''
          });
          return;
        }
        this.turnToPage('vipCardList', {
          from: 'userCenterEle'
        });
        return;
      }
      this.turnToPage(router + ('?' + param), {
        from: 'userCenterEle'
      });
    } else {
      // 跳转登录
      this.goLogin({
        success: function success() {
          that._userCenterToPage(event);
        }
      });
      return;
    }
  },
  /**
   * 跳转商品详情
   */
  turnToGoodsDetail: function turnToGoodsDetail(event) {
    var dataset = event.currentTarget.dataset;
    var id = dataset.id;
    var contact = dataset.contact;
    var goodsType = dataset.goodsType;
    var group = dataset.group;
    var hidestock = dataset.hidestock;
    var isShowVirtualPrice = dataset.isshowvirtualprice;
    var unit = dataset.unit;

    var franchisee = this.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.appId && dataset.appId !== this.getAppId() && chainParam === '') {
      // 跳转子店商品
      chainParam += '&franchisee=' + dataset.appId;
    }
    if (group && group == 1) {
      this.turnToPage('gpgoodsDetail?goods_id=' + id + '&activity_id=' + dataset.groupid + '&contact=' + contact + chainParam);
      return;
    }
    switch (+goodsType) {
      case 0:
        this.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + '&isShowVirtualPrice=' + isShowVirtualPrice + chainParam);
        break;
      case 1:
        this.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        break;
      case 3:
        this.turnToPage('toStoreDetail?detail=' + id + chainParam);
        break;
      case 10:
        if (unit) {
          this.turnToPage('hotel?contact=' + contact + '&hidestock=' + hidestock + chainParam);
        } else {
          this.turnToPage('newAppointmentDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        }
        break;
    }
  },
  /*
  * 子店跳转到子店首页
  */
  goToFranchisee: function goToFranchisee(mode) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var is_redirect = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var router = '';
    if (mode == 1) {
      router = 'franchiseeWaimai';
    } else if (mode == 3) {
      router = 'franchiseeTostore';
    } else if (mode == 2) {
      router = 'franchiseeDetail4';
    } else {
      router = 'franchiseeDetail';
    }
    this.turnToPage(router, param, is_redirect);
  },
  /**
   * 分类组件：动态列表、动态分类刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortListVessel: function _sortListVessel(componentParams) {
    var that = this;
    var pageInstance = this.getAppCurrentPage();
    var compindex = componentParams['compindex'];
    var newdata = {};
    var needColumnArr = pageInstance.data.eles[compindex].need_column_arr || [];
    var listField = pageInstance.data.eles[compindex].listField;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].list_data'] = [];
    pageInstance.setData(newdata);

    if (needColumnArr.length) {
      componentParams.param.need_column_arr = needColumnArr;
    }
    if (componentParams.param.form == "app_shop" && (listField.indexOf('distance') > -1 || componentParams.param.sort_key == "distance")) {
      var locationInfo = that.globalData.locationInfo;
      if (locationInfo.latitude) {
        componentParams.param.extra_cond_arr = {};
        componentParams.param.extra_cond_arr.latitude = locationInfo.latitude;
        componentParams.param.extra_cond_arr.longitude = locationInfo.longitude;
      } else if (componentParams.param.sort_key == "distance") {
        that.getLatLng({
          success: function success(latlng) {
            componentParams.param.extra_cond_arr = {};
            componentParams.param.extra_cond_arr.latitude = latlng.latitude;
            componentParams.param.extra_cond_arr.longitude = latlng.longitude;
            that._sortListVessel(componentParams);
          },
          fail: function fail() {
            that.showToast({
              title: '定位失败，店铺距离将获取不到',
              icon: 'none'
            });
            componentParams.param.sort_key = "";
            that._sortListVessel(componentParams);
          }
        });
        return;
      }
    }

    this.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {};

        for (var j in res.data) {
          for (var k in res.data[j].form_data) {
            if (k == 'category') continue;

            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = that.formVirtualPrice(res.data[j].form_data);
            }
            if (k == 'distance') {
              res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
            }
            var description = res.data[j].form_data[k];
            if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
              //没有绑定的字段的富文本置为空
              res.data[j].form_data[k] = '';
            }
          }
        }

        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        if (pageInstance.data.eles[compindex].type === 'dynamic-classify') {
          newdata['eles[' + compindex + '].sort_key'] = componentParams.param.sort_key || '';
          newdata['eles[' + compindex + '].sort_direction'] = componentParams.param.sort_direction;
        }

        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 分类组件：商品列表刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortGoodsList: function _sortGoodsList(componentParams) {
    var that = this;
    var pageInstance = this.getAppCurrentPage();
    var compindex = componentParams['compindex'];
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];

    // 排序组件请求page_size
    componentParams.param.page_size = compData.customFeature.loadingNum || 10;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].param.sort_key'] = componentParams.param.sort_key; //临时处理，后续做了联动之后删除
    newdata['eles[' + compindex + '].param.sort_direction'] = componentParams.param.sort_direction; //临时处理，后续做了联动之后删除
    pageInstance.setData(newdata);

    if (compData.customFeature.form == 'new_appointment' && !compData.customFeature.tpl_id) {
      var noAppointTpl = {};
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      noAppointTpl['eles[' + compindex + '].loadingFail'] = false;
      noAppointTpl['eles[' + compindex + '].loading'] = false;
      pageInstance.setData(noAppointTpl);
      return;
    }

    this.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          var appId = that.getAppId();
          var goodslist = res.data;
          goodslist.map(function (item) {
            item.form_data.goods_model && delete item.form_data.goods_model;
            if (+componentParams.param.is_app_shop_cate_goods === 1 && item.form_data.app_id !== appId) {
              item.form_data.isSubShopGoods = true;
            } else {
              item.form_data.isSubShopGoods = false;
            }
            item.form_data.discount = (item.form_data.price * 10 / item.form_data.virtual_price).toFixed(2);
            var vip_discount = (item.form_data.vip_min_price * 10 / item.form_data.virtual_price).toFixed(2);
            item.form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
            delete item.form_data.description;
            if (item.form_data.app_shop_data && item.form_data.app_shop_data.distance != undefined) {
              var distance = item.form_data.app_shop_data.distance;
              item.form_data.app_shop_data.distance = _util2.default.formatDistance(distance);
            }
          });

          newdata['eles[' + compindex + '].goods_data'] = goodslist;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 分类组件：多商家刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortFranchiseeList: function _sortFranchiseeList(componentParams) {
    var that = this;
    var pageInstance = this.getAppCurrentPage();
    var compindex = componentParams['compindex'];
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];

    componentParams.param.latitude = compData.param.latitude;
    componentParams.param.longitude = compData.param.longitude;

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].franchisee_data'] = [];
    newdata['eles[' + compindex + '].param'] = componentParams.param;
    pageInstance.setData(newdata);
    if (componentParams.param.sort_key == 'distance' && !componentParams.param.latitude) {
      that.showModal({
        content: "未获取到定位！"
      });
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: componentParams.param,
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          var _newdata = {};

          for (var index in res.data) {
            var distance = res.data[index].distance;
            res.data[index].distance = _util2.default.formatDistance(distance);
          }
          that._getMyAppShopList(compindex, pageInstance);

          _newdata['eles[' + compindex + '].franchisee_data'] = res.data;
          _newdata['eles[' + compindex + '].is_more'] = res.is_more;
          _newdata['eles[' + compindex + '].curpage'] = 1;
          _newdata['eles[' + compindex + '].loading'] = false;
          _newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(_newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 获取商家列表（内部函数）
   * @param {*} compindex
   * @param {*} pageInstance
   */
  _getMyAppShopList: function _getMyAppShopList(compindex, pageInstance) {
    var that = this;
    that.sendRequest({
      url: '/index.php?r=AppShop/GetMyAppShopList',
      data: {
        parent_app_id: that.getAppId()
      },
      hideLoading: true,
      success: function success(res) {
        var newdata = {};
        var oldList = pageInstance.data.eles[compindex].franchisee_data || [];
        var list = res.data;
        var listId = [];
        if (reset) {
          var l = 0;
          for (var i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 2) {
              l++;
            } else {
              break;
            }
          }
          oldList.splice(0, l);
        }
        for (var _i4 = 0; _i4 < list.length; _i4++) {
          if (list[_i4].is_audit == 2) {
            oldList.unshift(list[_i4]);
            listId.push(list[_i4].id);
          }
        }
        if (reset) {
          for (var _i5 = 0; _i5 < oldList.length; _i5++) {
            if (oldList[_i5].is_audit == 1 && listId.indexOf(oldList[_i5].id) > -1) {
              oldList.splice(_i5, 1);
            }
          }
        }
        newdata['eles[' + compindex + '.franchisee_data'] = oldList;

        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 分类组件：视频列表刷新函数(TODO: 后续挪动到对应组件里面)
   * @param {*} componentParams
   */
  _sortVideoList: function _sortVideoList(componentParams) {
    var that = this;
    var pageInstance = this.getAppCurrentPage();
    var compindex = componentParams['compindex'];

    var newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].video_data'] = [];
    newdata['eles[' + compindex + '].param'] = componentParams.param;
    pageInstance.setData(newdata);

    this.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoList',
      data: componentParams.param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var rdata = res.data;
        var newdata = {};

        for (var i = 0; i < rdata.length; i++) {
          rdata[i].video_view = that.handlingNumber(rdata[i].video_view);
        }

        newdata['eles[' + compindex + '].video_data'] = rdata;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 点击事件拨打电话
   */
  callPhone: function callPhone(event) {
    var phone = event.currentTarget.dataset.phone;
    this.makePhoneCall(phone);
  },
  /**
   * 获取国家列表
   * @param compindex
   */
  getNationList: function getNationList(compindex) {
    var pageInstance = this.getAppCurrentPage();
    var newdata = {};
    this.sendRequest({
      url: '/index.php?r=Region/getNationList',
      data: {
        page: 1,
        page_size: 10
      },
      success: function success(res) {
        newdata['eles[' + compindex + '].nationList'] = res.data.reverse();
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 处理触发刷新列表事件
   * @param {*} event
   * @param {*} params
   */
  tapRefreshListHandler: function tapRefreshListHandler(event, params) {
    var pageInstance = this.getAppCurrentPage();
    var eventParams = params || JSON.parse(event.currentTarget.dataset.eventParams);
    var refreshObject = eventParams.refresh_object;

    var componentIndex = this.findComponentIndexById(refreshObject);
    if (componentIndex > -1) {
      var componentData = pageInstance.data.eles[componentIndex];
      // 组件类型
      var type = componentData.type;
      // 组件参数
      var param = componentData.param || {};
      // 封装传入
      var compids_params = {
        compindex: componentIndex,
        param: param
      };
      this._refreshPageList(type, eventParams, compids_params, pageInstance);
    }
  },
  _refreshPageList: function _refreshPageList(eleType, eventParams, compids_params, pageInstance) {
    var index_value = eventParams.index_value == -1 ? '' : eventParams.index_value;
    var requestData = {
      page: 1,
      form: compids_params.param.form,
      is_integral: compids_params.param.is_integral,
      is_count: compids_params.param.form && compids_params.param.is_count ? 1 : 0,
      idx_arr: {
        idx: eventParams.index_segment,
        idx_value: index_value
      }
    };
    var newdata = {};
    newdata['eles[' + compids_params['compindex'] + '].is_search'] = false;
    pageInstance.setData(newdata);

    compids_params.param.idx_arr = requestData.idx_arr;

    if (eleType === 'goods-list' || eleType === 'list-vessel' || eleType === 'topic-list' || eleType == 'group-buy-list') {
      var customFeature = pageInstance.data.eles[compids_params.compindex].customFeature;
      requestData.page_size = customFeature.loadingNum || 10;
      // 商品列表
      if (eleType === 'goods-list') {
        if (customFeature.isShowGroupBuyGoods) {
          requestData.is_group_buy = 1;
        }
        if (customFeature.controlCheck) {
          requestData.is_integral = 3;
        } else {
          if (customFeature.isIntegral) {
            requestData.is_integral = 1;
          } else {
            requestData.is_integral = 5;
          }
        }
      }

      //行业预约  模板为空兼容
      requestData.tpl_id = compids_params.param.tpl_id;
      if (requestData.form == 'new_appointment' && !requestData.tpl_id) {
        var noAppointTpl = {};
        noAppointTpl['eles[' + compids_params['compindex'] + '].goods_data'] = [];
        noAppointTpl['eles[' + compids_params['compindex'] + '].is_more'] = 0;
        pageInstance.setData(noAppointTpl);
        return;
      }
    }

    switch (eleType) {
      case 'goods-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshGoodsList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'list-vessel':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshListVessel',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'franchisee-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshFranchiseeList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'topic-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshTopicList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'news-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshNewsList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'video-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshVideoList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
      case 'group-buy-list':
        pageInstance.callComponentMethod({
          componentIndex: compids_params['compindex'],
          methodName: '_refreshGroupBuyList',
          argvs: [compids_params['compindex'], requestData, pageInstance]
        });
        break;
    }
  },
  //判断是否开启了社区团购
  _isOpenCommunityGroup: function _isOpenCommunityGroup(callback) {
    var that = this;
    this.sendRequest({
      url: '/index.php?r=AppDistribution/getDistributionInfo',
      success: function success(res) {
        if (res.data && res.data.app_id) {
          that.globalData.getDistributionInfo = res.data;
          if (typeof callback == "function") {
            callback(res.data);
            return;
          }
          that._isOpenCommunityGroupCenter(true);
        } else {
          that.showModal({
            content: '暂未开启推广'
          });
        }
      }
    });
  },
  //判断是否是团长
  _isOpenCommunityGroupCenter: function _isOpenCommunityGroupCenter(clickPage) {
    var that = this;
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistribution/getDistributorInfo',
      success: function success(res) {
        if (clickPage) {
          var threshold_type = +that.globalData.getDistributionInfo.threshold_type; //团长门槛
          var is_block_up = res.data ? res.data.dis_group_info ? +res.data.dis_group_info.is_block_up : '' : ''; //1停用团长
          var isAudit = res.data ? res.data.dis_group_info ? res.data.dis_group_info.is_audit : '' : ''; // 1：审核通过 2：待审核 3：审核拒绝
          that.globalData.getDistributorInfo = res.data;
          if (+isAudit === 1 || +is_block_up === 1) {
            //当是团长或者团长被停用
            that.turnToPage('/communityGroup/pages/communityGroupUserCenter/communityGroupUserCenter'); //团长个人中心
          } else {
            if (+isAudit === 2 || +isAudit === 3) {
              //当申请中或者申请被拒绝
              that.turnToPage('/communityGroup/pages/communityGroupApplyStatus/communityGroupApplyStatus'); //申请状态显示
            } else {
              //当没有申请即不是团长
              if (threshold_type != 1) {
                //有门槛
                that.turnToPage('/communityGroup/pages/communityGroupDoor/communityGroupDoor'); //团长门槛页
              } else {
                if (+that.globalData.getDistributionInfo['role_setting'][6]['pop_up_type'] === 0 && that.globalData.getDistributionInfo.role_setting[6].illustration) {
                  //页面招募
                  that.turnToPage('/communityGroup/pages/communityRecruit/communityRecruit'); //招募说明
                } else {
                  //弹窗式
                  that.turnToPage('/communityGroup/pages/communityGroupApply/communityGroupApply'); //申请团长页面
                }
              }
            }
          }
        } else {
          if (res.data) {
            that.globalData.p_id = res.data.id;
            that.globalData.PromotionUserToken = res.data.user_token;
          }
        }
      }
    });
  },
  _isOpenPromotion: function _isOpenPromotion(callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _isPromotionPerson: function _isPromotionPerson(clickPage) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  _hasSelfCard: function _hasSelfCard() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 展示电商商品列表的商品添加购物车弹窗
   */
  showGoodsShoppingcart: function showGoodsShoppingcart(event) {
    var pageInstance = this.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var goodsId = dataset.id;
    var buynow = dataset.buynow;
    var showVirtualPrice = dataset.isshowvirtualprice || '';
    var newData = {
      goodsId: goodsId,
      showBuynow: buynow,
      showVirtualPrice: showVirtualPrice,
      franchisee: pageInstance.franchiseeId || this.getChainId()
    };
    if (dataset.appId && dataset.appId !== this.getAppId()) {
      newData['franchisee'] = dataset.appId;
    }
    appInstance.goodsShoppingCartRef.current.showDialog(newData);
  },
  /**
   * 展示到店商品列表的商品添加购物车弹窗
   */
  showAddShoppingcart: function showAddShoppingcart(event) {
    var pageInstance = this.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var goodsId = dataset.id;
    var newData = {
      goodsId: goodsId,
      franchisee: pageInstance.franchiseeId || this.getChainId()
    };
    if (dataset.appId && dataset.appId !== this.getAppId()) {
      newData['franchisee'] = dataset.appId;
    }
    appInstance.tostoreShoppingCartRef.current.show(newData);
  },
  /**
   * 获取到店的购物车列表
   */
  getTostoreCartList: function getTostoreCartList() {
    var pageInstance = this.getAppCurrentPage();
    var franchiseeId = pageInstance.franchiseeId || this.getChainId();
    this.sendRequest({
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: 1,
        page_size: 100,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? this.getAppId() : ''
      },
      success: function success(res) {
        var price = 0,
            num = 0,
            addToShoppingCartCount = 0,
            tostoreTypeFlag = false;

        for (var i = res.data.length - 1; i >= 0; i--) {
          var data = res.data[i];
          if (data.goods_type == 3) {
            tostoreTypeFlag = true;
            price += +data.num * +data.price;
            num += +data.num;
          }
          if (pageInstance.goodsId == data.goods_id) {
            addToShoppingCartCount = data.num;
            pageInstance.cart_id = data.id;
          }
        }
        pageInstance.setData({
          tostoreTypeFlag: tostoreTypeFlag,
          cartGoodsNum: num,
          cartGoodsTotalPrice: price.toFixed(2),
          addToShoppingCartCount: addToShoppingCartCount

        });
      }
    });
  },
  /**
   * 跳转到搜索页面(TODO)
   */
  turnToSearchPage: function turnToSearchPage(event) {
    var pageInstance = this.getAppCurrentPage();
    var listid = event.target.dataset.listid;
    var param = '';
    if (listid) {
      var integral = '';
      var goodsListIndex = this.findComponentIndexById(listid, pageInstance);
      var customFeature = pageInstance.data.eles[goodsListIndex].customFeature;
      if (customFeature.controlCheck) {
        integral = 3;
      } else {
        if (customFeature.isIntegral) {
          integral = 1;
        } else {
          integral = 5;
        }
      }
      param = '&isHideStock=' + customFeature.isHideStock + '&isHideSales=' + customFeature.isHideSales + '&isShowVirtualPrice=' + customFeature.isShowVirtualPrice + '&isShoppingCart=' + customFeature.isShoppingCart + '&isBuyNow=' + customFeature.isBuyNow;
      if (customFeature.source && customFeature.source !== 'none') {
        param += '&category=' + customFeature.source;
      }
      if (integral) {
        param += '&integral=' + integral;
      }
      if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
        // 是否显示子店商品(排除子店功能页)
        param += '&isShowFG=' + 1;
      }
    }
    if (event.target.dataset.param) {
      this.turnToPage('advance-search?param=' + event.target.dataset.param + param);
    } else {
      this.turnToPage('advance-search?form=' + event.target.dataset.form + param);
    }
  },
  /**
   * 获取节点的信息
   * @param selector
   * @param callback
   */
  getBoundingClientRect: function getBoundingClientRect(selector, callback) {
    var dows = document.querySelectorAll(selector);
    var rects = [];
    dows.forEach(function (element) {
      rects.push({
        id: element.id,
        left: element.offsetLeft,
        right: element.offsetLeft + element.offsetWidth,
        top: element.offsetTop,
        bottom: element.offsetTop + element.offsetHeight,
        width: element.offsetWidth,
        height: element.offsetHeight
      });
    });
    typeof callback === 'function' && callback(rects);
  },
  /*
  * 秒杀开始之前
  */
  beforeSeckillDownCount: function beforeSeckillDownCount(formData, page, path) {
    var _this = this,
        downcount = void 0;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_start_time,
      showDays: true,
      callback: function callback() {
        var newData = {};
        newData[path + '.seckill_start_state'] = 1;
        newData[path + '.server_time'] = formData.seckill_start_time;
        page.setData(newData);
        formData.server_time = formData.seckill_start_time;
        _this.duringSeckillDownCount(formData, page, path);
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 秒杀正在进行
  */
  duringSeckillDownCount: function duringSeckillDownCount(formData, page, path) {
    var _this = this,
        downcount = void 0;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_end_time,
      showDays: true,
      callback: function callback() {
        var newData = {};
        newData[path + '.seckill_start_state'] = 2;
        page.setData(newData);
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 拼团开始之前
  */
  beforeGroupDownCount: function beforeGroupDownCount(formData, page, path) {
    var _this = this,
        downcount = void 0;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_start_time,
      showDays: true,
      callback: function callback() {
        var newData = {};
        newData[path + '.status'] = 3;
        newData[path + '.current_status'] = 3;
        newData[path + '.server_time'] = formData.seckill_start_time;
        page.setData(newData);
        formData.server_time = formData.seckill_start_time;
        _this.duringGroupDownCount(formData, page, path);
        var dc = '';
        var compid = path.split('.')[0];
      }
    }, page, path + '.downCount');

    return downcount;
  },
  /*
  * 拼团正在进行
  */
  duringGroupDownCount: function duringGroupDownCount(formData, page, path) {
    var _this = this,
        downcount = void 0;
    downcount = _this.seckillDownCount({
      startTime: formData.server_time,
      endTime: formData.seckill_end_time,
      showDays: true,
      callback: function callback() {
        var newData = {};
        newData[path + '.status'] = 4;
        newData[path + '.current_status'] = 4;
        page.setData(newData);
        if (path == "myTeams") {
          page.loadMyTeams();
        }
      }
    }, page, path + '.downCount');

    return downcount;
  },
  // 需要倒计时的对象
  seckillFunc: {},
  // 倒计时的定时器编号
  seckillInterval: '',
  /**
   * 倒计时
   */
  seckillDownCount: function seckillDownCount(opts, page, path) {
    var that = this;
    var opt = {
      startTime: opts.startTime || null,
      endTime: opts.endTime || null,
      callback: opts.callback,
      showDays: opts.showDays || false
    };
    var isiphone = this.isIos();

    if (isiphone && /\-/g.test(opt.endTime)) {
      opt.endTime = opt.endTime.replace(/\-/g, '/');
    }
    if (isiphone && /\-/g.test(opt.startTime)) {
      opt.startTime = opt.startTime.replace(/\-/g, '/');
    }
    if (/^\d+$/.test(opt.endTime)) {
      opt.endTime = opt.endTime * 1000;
    }
    if (/^\d+$/.test(opt.startTime)) {
      opt.startTime = opt.startTime * 1000;
    }

    var target_date = new Date(opt.endTime);
    var current_date = new Date(opt.startTime);
    var difference = target_date - current_date;
    var data = {};
    var len = 'sk' + parseInt(Math.random() * 100000000);
    data = {
      opts: opts,
      page: page,
      path: path,
      difference: difference,
      index: len
    };
    that.seckillFunc[len] = data;

    if (!that.seckillInterval) {
      that.seckillInterval = setInterval(function () {
        var newdata = {};
        var func = that.seckillFunc;
        for (var i in func) {
          var f = func[i];
          var _difference = f.difference;
          var _path = f.path;
          var _page = f.page;
          var router = _page.id; // TODO 每个页面的ID

          if (!newdata[router]) {
            newdata[router] = {
              page: _page,
              data: {}
            };
          }
          if (_difference < 0) {
            var callback = func[i].opts.callback;
            if (callback && typeof callback === 'function') {
              callback();
            };
            delete that.seckillFunc[i];
            continue;
          }
          var time = that.seckillCountTime(_difference, f.opts);
          newdata[router].data[_path + '.hours'] = time[0];
          newdata[router].data[_path + '.minutes'] = time[1];
          newdata[router].data[_path + '.seconds'] = time[2];
          if (f.opts.showDays) {
            newdata[router].data[_path + '.days'] = time[3];
          }

          that.seckillFunc[i].difference -= 1000;
        }
        for (var j in newdata) {

          newdata[j].page.setData(newdata[j].data);
        }
      }, 1000);
    }

    return {
      isClear: false,
      clear: function clear() {
        if (this.isClear) {
          return;
        }
        this.isClear = true;
        delete that.seckillFunc[len];
        if (_util2.default.isPlainObject(that.seckillFunc)) {
          clearInterval(that.seckillInterval);
          that.seckillInterval = '';
        }
      }
    };
  },
  /**
   * 计算倒计时
   */
  seckillCountTime: function seckillCountTime(difference, opts) {
    if (difference < 0) {
      return ['00', '00', '00'];
    }

    var _second = 1000,
        _minute = _second * 60,
        _hour = _minute * 60,
        _day = _hour * 24,
        time = [];

    var days = '';
    var hours = Math.floor(difference / _hour);
    var minutes = Math.floor(difference % _hour / _minute);
    var seconds = Math.floor(difference % _minute / _second);
    if (opts.showDays) {
      days = Math.floor(difference / _day);
      hours = Math.floor(difference % _day / _hour);
    }

    hours = String(hours).length >= 2 ? hours : '0' + hours;
    minutes = String(minutes).length >= 2 ? minutes : '0' + minutes;
    seconds = String(seconds).length >= 2 ? seconds : '0' + seconds;

    time[0] = hours;
    time[1] = minutes;
    time[2] = seconds;
    opts.showDays && (time[3] = days);

    return time;
  },
  getAssessList: function getAssessList(param) {
    param.url = '/index.php?r=AppShop/GetAssessList';
    this.sendRequest(param);
  },
  getOrderDetail: function getOrderDetail(param) {
    param.url = '/index.php?r=AppShop/getOrder';
    this.sendRequest(param);
  },
  showUpdateTip: function showUpdateTip() {
    // TODO: 可以删除
  },
  // 文字组件跳到地图(文本组件：详情页绑定地图字段对应点击事件)
  textToMap: function textToMap(event) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 跳转到视频详情
   * @param {*} event
   */
  turnToVideoDetail: function turnToVideoDetail(event) {
    var id = event.currentTarget.dataset.id;
    var franchisee = this.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    this.turnToPage('videoDetail?detail=' + id + chainParam);
  },
  /**
   * 处理数字
   */
  handlingNumber: function handlingNumber(num) {
    num = +num;
    if (num > 1000000) {
      //大于百万直接用万表示
      return Math.floor(num / 10000) + '万';
    } else if (num > 10000) {
      //大于一万小于百万的保留一位小数
      return (num / 10000).toString().replace(/([0-9]+.[0-9]{1})[0-9]*/, "$1") + '万';
    } else {
      return num;
    }
  },
  /**
   * 判断是否需要富文本解析 （TODO，没有真的用处）
   * @param {*} data 
   */
  needParseRichText: function needParseRichText(data) {
    return false;
  },
  /**
   * 根据经纬度算出距离
   */
  calculationDistanceByLatLng: function calculationDistanceByLatLng(lat1, lng1, lat2, lng2) {
    var EARTH_RADIUS = 6378137.0;
    var PI = Math.PI;
    var a = (lat1 - lat2) * PI / 180.0;
    var b = (lng1 - lng2) * PI / 180.0;
    var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) + Math.cos(lat1 * PI / 180.0) * Math.cos(lat2 * PI / 180.0) * Math.pow(Math.sin(b / 2), 2)));
    s = s * EARTH_RADIUS;
    s = Math.round(s * 10000) / 10000.0;
    return s;
  },
  /**
   * 判断是否需要登录
   */
  isNeedRewardModal: function isNeedRewardModal() {
    var that = this;
    that.sendRequest({
      hideLoading: true,
      url: '/index.php?r=appShop/isNeedLogin',
      data: {},
      success: function success(res) {
        if (res.status == 0 && res.data == 1 && !that.isLogin()) {
          that.goLogin({});
        }
      }
    });
  },
  loginForRewardPoint: function loginForRewardPoint(addTime) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getCollectActivity: function getCollectActivity() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  recvCollectRewards: function recvCollectRewards() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getEffectActivity: function getEffectActivity(psid) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  getRecvChance: function getRecvChance(type, s_token, isLogin) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  recvRewards: function recvRewards(immediately) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  // 积分弹窗回调
  rewardPointCB: function rewardPointCB(cbTy) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  animationEnd: function animationEnd(e) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取店铺设置
   */
  getAppECStoreConfig: function getAppECStoreConfig(callback, franchiseeId) {
    var _this = this;
    if (this.globalData.goodsStoreConfig && !franchiseeId) {
      callback(this.globalData.goodsStoreConfig);
      return;
    }

    if (franchiseeId && this.globalData.goodsfranchiseeStoreConfig[franchiseeId]) {
      callback(this.globalData.goodsfranchiseeStoreConfig[franchiseeId]);
      return;
    }
    franchiseeId = franchiseeId || this.getPageFranchiseeId();
    this.sendRequest({
      url: '/index.php?r=AppEcommerce/getAppBECStoreConfig',
      data: {
        sub_shop_app_id: franchiseeId || ''
      },
      success: function success(res) {
        if (franchiseeId) {
          _this.globalData.goodsfranchiseeStoreConfig[franchiseeId] = res.data;
        } else {
          _this.globalData.goodsStoreConfig = res.data;
        }
        callback && callback(res.data);
      }
    });
  },
  // 日志
  addLog: function addLog() {
    // TODO: web端后续需要日志在处理
  },
  addDebug: function addDebug() {
    // TODO: web端后续需要日志在处理
  },
  addInfo: function addInfo() {
    // TODO: web端后续需要日志在处理
  },
  addWarn: function addWarn() {
    // TODO: web端后续需要日志在处理
  },
  addError: function addError() {
    // TODO: web端后续需要日志在处理
  },
  saveLog: function saveLog(tp, argu) {
    // TODO: web端后续需要日志在处理
  },
  sendLog: function sendLog() {
    // TODO: web端后续需要日志在处理
  },
  getChainStoreInfo: function getChainStoreInfo() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 判断是否在营业时间内
   */
  businessTimeCompare: function businessTimeCompare(time) {
    var now = new Date();
    var min = now.getMinutes().toString();
    if (min.length <= 1) {
      min = '0' + min;
    }
    var current = +(now.getHours().toString() + min);
    var business = false;
    for (var i = 0; i < time.length; i++) {
      if (current > +time[i].start_time_str && current < +time[i].end_time_str) {
        business = true;
      }
    }
    return business;
  },
  /**
   * 清除连锁店信息
   */
  clearChainInfo: function clearChainInfo() {
    this.globalData.chainAppId = '';
    this.globalData.chainHistoryDataId = '';
    this.globalData.indexPageRefresh = true;
    this.globalData.p_u = '';
    // wx.removeStorageSync('chainStore'); // 这个句后续要改动一下
  },
  /**
   * 获取子店ID
   */
  getPageFranchiseeId: function getPageFranchiseeId() {
    var pageInstance = this.getAppCurrentPage() || {};
    return pageInstance.franchiseeId || this.getChainId() || '';
  },
  setCommunityGroupRefresh: function setCommunityGroupRefresh() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  setNowGommunityToken: function setNowGommunityToken(token) {
    this.setStorage({
      key: 'nowGommunityToken',
      data: token
    });
  },
  getNowGommunityToken: function getNowGommunityToken() {
    return this.getStorageSync('nowGommunityToken');
  },
  getCommunityActiveMessage: function getCommunityActiveMessage() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },

  pageRoot: {
    // TODO: 可以删除
  },
  /**
   * 记录子店访问量
   */
  addSubShopView: function addSubShopView(sub_app_id) {
    this.sendRequest({
      url: '/index.php?r=AppShopManage/AddSubShopView',
      data: {
        sub_app_id: sub_app_id
      },
      success: function success(res) {},
      fail: function fail() {}
    });
  },
  getPromotionPersonId: function getPromotionPersonId(callback) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 判断是否需要底部技术支持
   */
  checkTechSupport: function checkTechSupport(pageInstance) {
    var that = this;
    pageInstance = pageInstance || this.getAppCurrentPage();
    if (that.globalData.techSupport) {
      pageInstance.setData({
        techSupport: that.globalData.techSupport
      });
      return;
    }
    this.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/CheckTechSupport',
      success: function success(res) {
        that.globalData.techSupport = res.data;
        pageInstance.setData({
          techSupport: res.data
        });
      }
    });
  },
  /**
   * 检查小程序是单店、总店还是子店
   */
  checkIsSubOrParentShop: function checkIsSubOrParentShop() {
    var that = this;
    if (this.globalData.shopTypeData) {
      return;
    }
    this.sendRequest({
      url: '/index.php?r=AppShopManage/CheckIsAppSubOrParentShop',
      success: function success(res) {
        if (res.data) {
          // 保存在全局
          that.setShopTypeData(res.data);
        }
      }
    });
  },
  /**
   *  全局参数get、set部分 start
   *
   */
  /**
   * 获取首页router
   */
  getHomepageRouter: function getHomepageRouter() {
    return this.globalData.homepageRouter;
  },
  /**
   * 设置APPID
   */
  setAppId: function setAppId(value) {
    (0, _global.setAppId)(value); // 设置sessionStorage里的APPID
    this.globalData.appId = value;
  },
  /**
   * 获取APPID
   */
  getAppId: function getAppId() {
    return this.globalData.appId || (0, _global.getAppId)();
  },
  /**
   * 如果有连锁店ID，返回连锁店ID。否则返回总店APPID
   */
  getChainAppId: function getChainAppId() {
    return this.globalData.chainAppId || this.globalData.appId;
  },
  /**
   * 获取连锁店ID
   */
  getChainId: function getChainId() {
    return this.globalData.chainAppId || '';
  },
  /**
   * 获取当前页面的路由
   */
  getPageRouter: function getPageRouter() {
    var pageInstance = this.getAppCurrentPage();
    if (pageInstance) {
      return pageInstance.data.router;
    }
    return this.globalData.pageRouter;
  },
  /**
   * 设置页面pageRouter
   * @param url
   */
  setPageRouter: function setPageRouter(url) {
    var urlMatch = url.match(/.*\/(\w+)\??$/);
    if (urlMatch) {
      this.globalData.pageRouter = urlMatch[1];
    }
  },
  /**
   * 获取最后一个页面的路由
   */
  getLastPageRouter: function getLastPageRouter() {
    var lastPage = this.getAppCurrentPage();
    if (_page2.pageInstance) {
      return _page2.pageInstance.data.router;
    }
    return this.globalData.pageRouter;
  },
  /**
   * 获取默认的图片路径
   */
  getDefaultPhoto: function getDefaultPhoto() {
    return this.globalData.defaultPhoto;
  },
  getSessionKey: function getSessionKey() {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  setSessionKey: function setSessionKey(session_key) {
    // TODO: 未处理当前函数，如确定不需要请删除
  },
  /**
   * 获取用户信息
   */
  getUserInfo: function getUserInfo(key) {
    return key ? this.globalData.userInfo[key] : this.globalData.userInfo;
  },
  /**
   * 保存用户信息
   * @param {*} info
   */
  setUserInfoStorage: function setUserInfoStorage(info) {
    for (var key in info) {
      this.globalData.userInfo[key] = info[key];
    }
    this.setStorage({
      key: 'userInfo',
      data: this.globalData.userInfo
    });
  },
  /**
   * 设置页面的用户信息
   */
  setPageUserInfo: function setPageUserInfo(options) {
    var currentPage = this.getAppCurrentPage();
    // 若不为自定义页面
    if (!currentPage) {
      return;
    }
    var newdata = {};
    newdata['userInfo'] = this.getUserInfo();
    currentPage.setData(newdata);
  },
  /**
   * 获取当前页面实例
   */
  getAppCurrentPage: function getAppCurrentPage(options) {
    return _page2.pageInstance;
  },
  /**
   * 获取底部导航的路径
   */
  getTabPagePathArr: function getTabPagePathArr() {
    return this.globalData.tabBarPagePathArr;
  },
  /**
   * 获取APP的标题
   */
  getAppTitle: function getAppTitle() {
    return this.globalData.appTitle;
  },
  /**
   * 小程序使用（TODO，后续可以删掉，保留防止报错）
   */
  getWxParseResult: function getWxParseResult(data) {
    return data;
  },
  /**
   * 获取APP的描述
   */
  getAppDescription: function getAppDescription() {
    return this.globalData.appDescription;
  },
  /**
   * 把定位信息存下来
   */
  setLocationInfo: function setLocationInfo(info) {
    this.globalData.locationInfo = info;
  },
  /**
   * 获取定位信息
   */
  getLocationInfo: function getLocationInfo() {
    return this.globalData.locationInfo;
  },
  /**
   * 获取请求的域名
   */
  getSiteBaseUrl: function getSiteBaseUrl() {
    return this.globalData.siteBaseUrl;
  },
  /**
   * 获取cdn域名
   */
  getCdnUrl: function getCdnUrl() {
    return this.globalData.cdnUrl;
  },
  /**
   * TODO 暂时不清楚作用
   */
  getUrlLocationId: function getUrlLocationId() {
    return this.globalData.urlLocationId;
  },
  getPreviewGoodsInfo: function getPreviewGoodsInfo() {
    return this.globalData.previewGoodsOrderGoodsInfo;
  },
  setPreviewGoodsInfo: function setPreviewGoodsInfo(goodsInfoArr) {
    this.globalData.previewGoodsOrderGoodsInfo = goodsInfoArr;
  },
  getGoodsAdditionalInfo: function getGoodsAdditionalInfo() {
    return this.globalData.goodsAdditionalInfo;
  },
  setGoodsAdditionalInfo: function setGoodsAdditionalInfo(additionalInfo) {
    this.globalData.goodsAdditionalInfo = additionalInfo;
  },
  /**
   * 二维码标记
   * TODO(位置要移动)
   */
  showQRRemark: function showQRRemark(e) {
    var data = {};
    var compindex = e.currentTarget.dataset.compindex;
    var isShow = e.currentTarget.dataset.isshow;
    var pageInstance = this.getAppCurrentPage();
    if (isShow == 'true') {
      data['eles[' + compindex + '].userData.qrRemarkShow'] = true;
      pageInstance.setData(data);
      var url2 = '/index.php?r=appVipCard/getVipQRCode';
      var id = e.currentTarget.dataset.id;
      var is_paid_vip = e.currentTarget.dataset.type;
      this.sendRequest({
        url: url2,
        data: {
          id: id,
          is_paid_vip: is_paid_vip
        },
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function success(res) {
          var qrData = {};
          qrData['eles[' + compindex + '].qrData'] = res.data;
          pageInstance.setData(qrData);
        }
      });
    } else {
      data['eles[' + compindex + '].userData.qrRemarkShow'] = false;
      pageInstance.setData(data);
    }
  },
  /**
   * 获取是否登录
   */
  getIsLogin: function getIsLogin() {
    var appId = this.getAppId();
    return _tools.docCookies.getItem(appId + '_webappLogin') == 1;
  },
  /**
   * 设置是否登录
   * @param {boolean} isLogin
   */
  setIsLogin: function setIsLogin(isLogin) {
    var appId = this.getAppId();
    if (isLogin) {
      var exdate = new Date();
      exdate.setMinutes(exdate.getMinutes() + 120);
      _tools.docCookies.setItem('webappLogin', '1', exdate);
      _tools.docCookies.setItem(appId + '_webappLogin', '1', exdate);
      this.globalData.isLogin = true;
    } else {
      _tools.docCookies.setItem('webappLogin', '0');
      _tools.docCookies.setItem(appId + '_webappLogin', '0');
      this.globalData.isLogin = false;
    }
    this.removeStorage('nowSessionData'); // 重新登录或退出登录时清除本地对话缓存
  },
  getSystemInfoData: function getSystemInfoData() {
    var res = {};
    if (this.globalData.systemInfo) {
      return this.globalData.systemInfo;
    }
    try {
      if (this.isWeixin()) {
        res = this.getSystemInfoSync();
        res.rpxRatio = 750 / res.windowWidth;
      } else {
        res.rpxRatio = 750 / window.screen.width;
      }
      this.setSystemInfoData(res);
    } catch (e) {
      this.showModal({
        content: '获取系统信息失败'
      });
    }
    return res || {};
  },
  setSystemInfoData: function setSystemInfoData(res) {
    res.rpxRatio = 750 / res.windowWidth;
    this.globalData.systemInfo = res;
  },
  setShopTypeData: function setShopTypeData(shopData) {
    this.globalData.shopTypeData = shopData;
  },
  getShopTypeData: function getShopTypeData() {
    return this.globalData.shopTypeData;
  },
  /**
   * 判断当前页是否有设置底部导航
   */
  isTabBarPage: function isTabBarPage() {
    var pageInstance = this.getAppCurrentPage();
    var hasTabNav = false;
    if (pageInstance) {
      // 存在与底部导航路由数组中
      if (this.globalData.tabBarPagePathArr.indexOf(pageInstance.route) > -1) {
        hasTabNav = true;
      }
    }
    return hasTabNav;
  },
  /**
   * 获取当前页面栈
   */
  getCurrentPages: function getCurrentPages() {
    return this.globalData.currentPages;
  },
  /**
   * 获取当前页面在页面栈上的数据
   */
  getCurrentPage: function getCurrentPage() {
    var currentPages = this.getCurrentPages();
    return currentPages[currentPages.length - 1];
  },
  /**
   * 游客登录
   */
  autoTouristLogin: function autoTouristLogin() {
    var _this5 = this;

    return new Promise(function (resolve, reject) {
      _this5.sendRequest({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          phone: '16666666666',
          code: '123456'
        },
        success: function success() {
          // 设置登录成功
          _this5.setIsLogin(true);
          // 请求用户数据存到本地
          _this5.requestUserInfo();
        },
        complete: function complete() {
          resolve();
        }
      });
    });
  },
  /**
   * 微信原生方法获取视频组件实例
   */
  createVideoContext: function createVideoContext(id) {
    return document.getElementById(id);
  },
  /*
   * 获取系统信息
   * TODO
   */
  getSystemInfo: function getSystemInfo() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var systemInfo = {
      screenWidth: window.screen.width,
      screenHeight: window.screen.height,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    };
    if (options.success && typeof options.success === 'function') {
      options.success(systemInfo);
    }
    if (options.complete && typeof options.success === 'function') {
      options.complete(systemInfo);
    }
    return systemInfo;
  },
  /*
   * 同步获取系统信息(与小程序的方法名相同)
   */
  getSystemInfoSync: function getSystemInfoSync(options) {
    return this.getSystemInfo(options);
  },
  /**
   * 判断是否在微信里面
   */
  isWeixin: function () {
    var isWeixin = false;
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      isWeixin = true;
    }
    return function () {
      return isWeixin;
    };
  }(),
  /**
   * 判断是否在抖音里面
   */
  isDouyin: function () {
    var isDouyin = false;
    if (navigator.userAgent.toLowerCase().match(/aweme/i) == 'aweme') {
      isDouyin = true;
    }
    return function () {
      return isDouyin;
    };
  }(),
  /**
   * 判断是否为安卓
   */
  isAndroid: function isAndroid() {
    var ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('android') > -1 || ua.indexOf('linux') > -1;
  },
  /**
   * 判断是否为ios
   */
  isIos: function isIos() {
    var ua = navigator.userAgent.toLowerCase();
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  /**
   * 判断是否在pc端
   */
  isPC: function isPC() {
    var ua = navigator.userAgent;
    return !ua.match(/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i);
  }
};

exports.setApp = setApp;
exports.appInstance = appInstance;
exports.appMethod = appMethod;
exports.globalData = globalData;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQueryString = getQueryString;
exports.updateQueryStringParameter = updateQueryStringParameter;
exports.updateUrlParam = updateUrlParam;
exports.cssStyle2DomStyle = cssStyle2DomStyle;
exports.cssObj2DomObj = cssObj2DomObj;
exports.convertStyleData = convertStyleData;
exports.convertLineStyleData = convertLineStyleData;
exports.getOld2NewCssData = getOld2NewCssData;
exports.zoomUnit = zoomUnit;
exports.convertTagStyle = convertTagStyle;
exports.convertHtmlTag = convertHtmlTag;
exports.checkIfPhone = checkIfPhone;
exports.tranform2UrlEncode = tranform2UrlEncode;
exports.getCookiePara = getCookiePara;
exports.transformPx2Rem = transformPx2Rem;
exports.getGoodsTypeByForm = getGoodsTypeByForm;
exports.getFormByGoodsType = getFormByGoodsType;
exports.getUrlQueryStringObj = getUrlQueryStringObj;
exports.getUrlSearch = getUrlSearch;
exports.getCurrentPageQueryParams = getCurrentPageQueryParams;
exports.randomWord = randomWord;
/**
 * @file 工具方法
 * @description 提供公用的工具 tools
 */

/**
 * 获取URL指定key的参数值
 * @param {string} key
 * @returns {string}
 */
function getQueryString(key) {
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return '';
}

/**
 * 修改url地址参数
 * @param {*} str 
 */
function updateQueryStringParameter(uri, key, value) {
  if (!value) {
    return uri;
  }
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  } else {
    return uri + separator + key + "=" + value;
  }
}

/**
 * 修改当前地址参数
 * @param {string} key
 * @param {string} value
 */
function updateUrlParam(key, value) {
  window.history.replaceState(null, '', updateQueryStringParameter(window.location.href, '' + key, '' + value));
}

/**
 * '-'的css属性名转驼峰
 * @param {string} key
 * @returns {string}
 */
function cssStyle2DomStyle(str) {
  var re = /-(\w)/g;
  return str.replace(re, function ($0, $1) {
    return $1.toUpperCase();
  });
}

/**
 * css样式的对象转为驼峰对象
 * @param {string} key
 * @returns {string}
 */
function cssObj2DomObj(cssObj) {
  var domObj = {};
  for (var attr in cssObj) {
    domObj[cssStyle2DomStyle(attr)] = cssObj[attr];
  }
  return domObj;
}

/**
 * 转换成
 * @param {object} data 组件原有的基于320设计稿的style数据，含有px的数据需要转换成rem
 * @returns {object} 处理后的style数据
 */
function convertStyleData(data) {
  var obj = {};
  for (var attr in data) {
    var value = data[attr];
    if (value === value + '') {
      value = value.replace(/;/gi, ''); // 去掉可能会存在分号的数据
      if (value.indexOf('px') > -1) {
        if (!isNaN(Number(value.replace(/px/gi, '')))) {
          value = transformPx2Rem(value, 320);
        }
      }
    }
    obj[cssStyle2DomStyle(attr)] = value;
  }
  return obj;
}

/**
 * 将行内样式转换成obj格式,并且转换单位
 * @param {string} data - 比如 'font-size: 100rpx, margin: 100px;
 * @returns {object} 处理后的style数据 - {fontSzie: 1rem, margin: 2rem}
 */
function convertLineStyleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var obj = {};
  getOld2NewCssData(data).split(';').forEach(function (item) {
    if (item) {
      var splitStyle = item.split(/:/);
      if (splitStyle.length > 2) {
        splitStyle[1] = splitStyle.slice(1).join(':');
      }
      var key = cssStyle2DomStyle(splitStyle[0].trim());
      var value = splitStyle[1].trim();
      obj[key] = value;
    }
  });
  return obj;
}

// rpx -> rem, px -> rem
function getOld2NewCssData(data) {
  var rpx2remData = zoomUnit(data, 0.01, 'rpx', 'rem');
  return zoomUnit(rpx2remData, 0.02, 'px', 'rem');
}

/**
 * css单位倍数转换
 * @text：css字符串
 * @time:转后倍数（0.1 10）
 * @unit:单位
 * @toUnit:转为什么单位(非必传,不传为原单位)*/
function zoomUnit(text, times, unit, toUnit) {
  //匹配所有这个单位
  var unitRe = new RegExp('\\s*(\\d+)*(\\.)*(\\d+)*(-)*(\\d+)' + unit, 'img');
  //转化后单位
  var tranUnit = toUnit || unit;
  //匹配
  return text.replace(unitRe, function (x) {
    var result = x.trim().replace(unit, '');
    result = parseInt(+result * 10000, 10) * times / 10000;
    return ' ' + result + tranUnit;
  });
}

/**
 * 标签行内样式转换
 * @desc 将style={}和style=""转换成正确单位的行内样式
 * @returns {string}
 */
function convertTagStyle(data) {
  // 匹配带花括号
  var braceRe = /style={([\s\S]*?)}/gm;
  // 匹配带有字符串
  var strRe = /style="([\s\S]*?)"/gm;
  // 替换的后的值
  var braceRst = 'style={convertLineStyleData($1)}';
  var strRst = "style={convertLineStyleData('$1')}";
  return data.replace(braceRe, braceRst).replace(strRe, strRst);
}

/**
 * 标签替换
 * @desc 替换规则如下，如有补充再添加
 * 'Block' : 'React.Fragment',
 * 'View'  : 'div',
 * 'Text'  : 'text',
 * 'Form'  : 'form',
 * 'Video' : 'video',
 * 'Label' : 'label',
 * 'Button': 'button',
 * 'Input' : 'input',
 * 'Image' : 'img'
 */
function convertHtmlTag(data) {
  var TAG_NAME = {
    'Block': 'React.Fragment',
    'View': 'div',
    'Text': 'span',
    'Form': 'form',
    'Video': 'video',
    'Label': 'label',
    'Button': 'button',
    'Input': 'input',
    'Image': 'img'
  };
  var headReg = /(<Block)|(<View)|(<Text)|(<Form)|(<Video)|(<Label)|(<Button)|(<Input)|(<Image)/g;
  var tailReg = /(<\/Block>)|(<\/View>)|(<\/Text>)|(<\/Form>)|(<\/Video>)|(<\/Label>)|(<\/Button>)|(<\/Input>)|(<\/Image>)/g;
  // 替换首标签
  var head = data.replace(headReg, function (x) {
    return '<' + TAG_NAME[x.replace(/</, '')];
  });
  // 替换尾标签
  return head.replace(tailReg, function (x) {
    // 没有尾标签的可以直接删除
    if (x === '</Input>' || x === '</Image>') {
      return x.replace(x, '');
    } else {
      return '</' + TAG_NAME[x.replace(/<\/|>/g, '')] + '>';
    }
  });
}

/**
 * 检测是否符合手机规格
 * @param {string} key
 * @returns {string}
 */
function checkIfPhone(phone) {
  var regmTel = /^1\d{10}$/;
  if (regmTel.test(phone.trim())) {
    return true;
  } else {
    return false;
  }
}

/**
 * 转换对象为URL参数形式的方法
 * @param {obj} obj
 * @returns {string}
 */
function tranform2UrlEncode(obj) {
  var query = '',
      name,
      value,
      fullSubName,
      subName,
      subValue,
      innerObj,
      i;
  for (name in obj) {
    value = obj[name];
    if (value instanceof Array) {
      for (i = 0; i < value.length; ++i) {
        subValue = value[i];
        fullSubName = name + '[' + i + ']';
        innerObj = {};
        innerObj[fullSubName] = subValue;
        query += tranform2UrlEncode(innerObj) + '&';
      }
    } else if (value instanceof Object) {
      for (subName in value) {
        subValue = value[subName];
        fullSubName = name + '[' + subName + ']';
        innerObj = {};
        innerObj[fullSubName] = subValue;
        query += tranform2UrlEncode(innerObj) + '&';
      }
    } else if (value !== undefined && value !== null) query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
  }
  return query.length ? query.substr(0, query.length - 1) : query;
}

/**
 * 获取cookie参数
 * @param {string} name
 * @returns {string | null}
 */
function getCookiePara(name) {
  var name = name || 'PHPSESSID',
      reg = new RegExp("(^|\\D)" + name + "=([^&]*?)($|;)"),
      r = document.cookie.match(reg);

  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

/**
 * 转换成
 * @param {string | number} origin 750px | 750
 * @param {number} redix 基数，原始值是基于750px设计稿的，要填750，默认750
 * @returns {string} 换算后再加上rem单位
 */
/*
 * 换算规则整理：
 * 1rem(wx) = 16px = 32rpx = .32rem(webapp)
 * 100vw = 7.5rem      当前设备宽度
 * 1rem  = 100/7.5vw   当前视图宽度的1/7.5
 * 1rpx  = 0.01rem (微信小程序转换提醒)
 * 750px设计稿: 1px换算成1/100rem（0.01rem）
 * 320px设计稿: 1px换算成7.5/320rem (100vw/320 = 7.5rem/320)
 * (备注：html font-size: 1rem > 12px，浏览器默认最小为12px）
 * (原理：满足750px设计稿的100vw = 750 px，1rem = 100x vw / 750份 > 12px => x > 90 && x为10的倍数 => x 取 100)
 * (同比小程序中750rpx等于这边的7.5rem，相互换算只需要/100或*100）
 */
function transformPx2Rem(origin) {
  var redix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 750;

  // 当前origin为数字
  if (origin === +origin) {
    return origin * 7.5 / redix + 'rem';
  } else if (origin === origin + '') {
    // 当前origin为字符串
    if (origin.indexOf('rem') > -1) {
      return origin;
    }
    return Number(origin.replace(/px/gi, '')) * 7.5 / redix + 'rem';
  } else {
    return '0rem';
  }
}

// TODO 后续应该换地方
function getGoodsTypeByForm(form) {
  switch (form) {
    case 'goods':
      return 0;
    case 'appointment':
      return 1;
    case 'waimai':
      return 2;
    case 'tostore':
      return 3;
    case 'new_appointment':
      return 10;
    default:
      return 0;
  }
}

// TODO 后续应该换地方
function getFormByGoodsType(gt) {
  var type = +gt || 0;
  switch (type) {
    case 0:
      return 'goods';
    case 1:
      return 'appointment';
    case 2:
      return 'waimai';
    case 3:
      return 'tostore';
    case 10:
      return 'new_appointment';
    default:
      return 'goods';
  }
}

/**
 * 根据URL获取参数数据对象
 * @param {string} url
 * @returns {string}
 */
function getUrlQueryStringObj(url) {
  var qs = url.split('?')[1]; // 获取url中"?"符后的字串
  var args = {}; // 保存参数数据的对象
  var items = qs ? qs.split("&") : []; // 取得每一个参数项,
  var item = null;
  for (var i = 0; i < items.length; i++) {
    item = items[i].split("=");
    var name = decodeURIComponent(item[0]),
        value = decodeURIComponent(item[1]);
    if (name) {
      args[name] = value;
    }
  }
  return args;
}

/**
 * 根据state获取search 类似: ?param1=value1&param2=value2
 */
function getUrlSearch() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var search = '';
  for (var key in state) {
    if ('' + state[key] && state[key] != 'undefined' && state[key] !== undefined) {
      search += key + '=' + encodeURIComponent(state[key]) + '&';
    }
  }
  return search ? '?' + search : '';
}

/**
 * 获取当前页面路径中的参数
 */
function getCurrentPageQueryParams() {
  var params = {};
  var search = window.location.search;
  var queryIndex = search.indexOf('?');
  if (queryIndex !== -1) {
    var queryString = search.substring(1);
    queryString.split('&').forEach(function (pair) {
      var temp = pair.split('=');
      params[decodeURIComponent(temp[0])] = decodeURIComponent(temp[1]);
    });
  }
  return params;
}

/**
 * 产生随机字符串
 */
function randomWord() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

  var str = "";
  var arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  for (var i = 0; i < length; i++) {
    var pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
}

/**
 * cookie 读写处理
 */
var docCookies = exports.docCookies = {
  getItem: function getItem(sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function setItem(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!sKey || !this.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function hasItem(sKey) {
    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
  },
  keys: /* optional method: you can safely remove it! */function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(140);

var _page = __webpack_require__(43);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _weixinSdkConfig = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeSet = function safeSet(object, path, value) {
  return object == null ? object : (0, _common.baseSet)(object, path, value);
};

function defineGetter(component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: function get() {
      if (getter === 'props') {
        return component.props;
      }
      return (0, _extends3.default)({}, component.props, component.state);
    }
  });
}

var OfficialPage = function (_React$Component) {
  (0, _inherits3.default)(OfficialPage, _React$Component);

  function OfficialPage(props) {
    (0, _classCallCheck3.default)(this, OfficialPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OfficialPage.__proto__ || Object.getPrototypeOf(OfficialPage)).call(this, props));

    _this.id = (0, _tools.randomWord)(8);
    _this.route = _this.props.location.pathname.split('/')[1];
    _this.shareData = {};
    _this.officialPageRef = _react2.default.createRef();

    _this.setData = function (obj, callback) {
      var state = Object.assign({}, _this.state);
      Object.keys(obj).forEach(function (key) {
        safeSet(state, key, obj[key]);
      });
      Object.assign(_this.state, state);
      _this.setState(state);
      setTimeout(function () {
        typeof callback == 'function' && callback();
      }, 0);
    };

    _this.setShareData = function () {
      if (!_this.onShareAppMessage) {
        return;
      }
      _this.shareData = _this.onShareAppMessage();
      var url = _this.shareData.path;
      var urlArr = url.split('/');
      url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
      if (!/app_id/.test(url)) {
        if (url.indexOf('?') < 0) {
          url = url + '?app_id=' + _app.appMethod.getAppId();
        } else {
          url = url + '&app_id=' + _app.appMethod.getAppId();
        }
      }
      _this.shareData.path = url;
      if (_app.appMethod.isWeixin()) {
        (0, _weixinSdkConfig.configWxShare)({
          title: _this.shareData.title,
          link: _this.shareData.path,
          imgUrl: _this.shareData.imageUrl
        });
      }
    };

    _this.shareClickEvent = function () {
      _app.appMethod.shareClickEvent();
    };

    defineGetter(_this, 'data', 'state');
    // 设置当前页组件实例
    (0, _page.setPage)(_this);
    setTimeout(function () {
      _this.setShareData();
    }, 3000);
    return _this;
  }

  // 分享的点击事件（对小程序分享按钮的另种实现）


  return OfficialPage;
}(_react2.default.Component);

exports.default = OfficialPage;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopNav = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(382);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopNav = exports.TopNav = function (_CommonComponent) {
  (0, _inherits3.default)(TopNav, _CommonComponent);

  function TopNav(props) {
    (0, _classCallCheck3.default)(this, TopNav);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopNav.__proto__ || Object.getPrototypeOf(TopNav)).call(this, props));

    _this.stopPropagation = function (e) {
      e.stopPropagation();
    };

    _this.turnBack = function () {
      _app.appMethod.turnBack();
    };

    _this.turnHome = function () {
      _app.appMethod.turnToPage(_this.state.homePageRouter, {}, true);
    };

    _this.state = {
      title: props.title || '',
      isTabBarPage: _app.appMethod.isTabBarPage(),
      currentPageRouter: _app.appMethod.getPageRouter(),
      homePageRouter: _app.appMethod.getHomepageRouter()
    };
    console.log(_this.state);
    return _this;
  }

  (0, _createClass3.default)(TopNav, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          title = _state.title,
          isTabBarPage = _state.isTabBarPage;

      return _react2.default.createElement(
        'div',
        { className: 'common-component top-nav' },
        _react2.default.createElement(
          'div',
          { className: 'top-nav-content' },
          !isTabBarPage && _react2.default.createElement(
            'div',
            { className: 'top-nav-left' },
            _react2.default.createElement('label', { className: 'ico-moon icon-leftarrow', onClick: this.turnBack })
          ),
          _react2.default.createElement(
            'div',
            { className: 'top-nav-center' },
            _react2.default.createElement(
              'div',
              { className: 'top-nav-title' },
              title
            )
          )
        )
      );
    }
  }]);
  return TopNav;
}(_CommonComponent3.default);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(219);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(160);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollView = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* 此组件的参数全部参考微信小程序srcoll-view组件，enable-back-to-top, enable-flex属性不支持。这里enable-flex等于是true，都是启用flexbox布局。
*
* 另外组件会接收className 和 style 属性
*
*/

var ScrollView = exports.ScrollView = function (_React$Component) {
  (0, _inherits3.default)(ScrollView, _React$Component);

  function ScrollView(props) {
    (0, _classCallCheck3.default)(this, ScrollView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollView.__proto__ || Object.getPrototypeOf(ScrollView)).call(this, props));

    _this.topTimer = null;
    _this.leftTimer = null;
    _this.oldScrollTop = 0;
    _this.oldScrollLeft = 0;
    _this.scrollAllowBottom = true;
    _this.scrollAllowTop = true;
    _this.scrollAllowLeft = true;
    _this.scrollAllowRight = true;

    _this.scrollEvent = function (event) {
      var scrollDom = _this.scrollDiv.current;
      _this.props.bindscroll && _this.props.bindscroll((0, _extends3.default)({}, event, {
        detail: {
          scrollLeft: scrollDom.scrollLeft,
          scrollTop: scrollDom.scrollTop,
          scrollHeight: scrollDom.scrollHeight,
          scrollWidth: scrollDom.scrollWidth,
          deltaX: _this.oldScrollLeft - scrollDom.scrollLeft,
          deltaY: _this.oldScrollTop - scrollDom.scrollTop
        }
      }));

      var lowerThreshold = _this.props['lower-threshold'] || 0;
      var upperThreshold = _this.props['upper-threshold'] || 0;

      if (scrollDom.scrollTop + scrollDom.clientHeight >= scrollDom.scrollHeight - lowerThreshold && _this.oldScrollTop != scrollDom.scrollTop && _this.scrollAllowBottom && _this.scrollY) {
        _this.scrollAllowBottom = false;
        _this.props.bindscrolltolower && _this.props.bindscrolltolower((0, _extends3.default)({}, event, {
          detail: {
            direction: 'bottom'
          }
        }));
      } else if (scrollDom.scrollTop + scrollDom.clientHeight < scrollDom.scrollHeight - lowerThreshold) {
        _this.scrollAllowBottom = true;
      }
      if (scrollDom.scrollLeft + scrollDom.clientWidth >= scrollDom.scrollWidth - lowerThreshold && _this.oldScrollLeft != scrollDom.scrollLef && _this.scrollAllowRight && _this.scrollX) {
        _this.scrollAllowRight = false;
        _this.props.bindscrolltolower && _this.props.bindscrolltolower((0, _extends3.default)({}, event, {
          detail: {
            direction: 'right'
          }
        }));
      } else if (scrollDom.scrollLeft + scrollDom.clientWidth < scrollDom.scrollWidth - lowerThreshold) {
        _this.scrollAllowRight = true;
      }
      if (scrollDom.scrollTop <= 0 + upperThreshold && _this.oldScrollTop != scrollDom.scrollTop && _this.scrollAllowTop && _this.scrollY) {
        _this.scrollAllowTop = false;
        _this.props.bindscrolltoupper && _this.props.bindscrolltoupper((0, _extends3.default)({}, event, {
          detail: {
            direction: 'top'
          }
        }));
      } else if (scrollDom.scrollTop > 0 + upperThreshold) {
        _this.scrollAllowTop = true;
      }
      if (scrollDom.scrollLeft <= 0 + upperThreshold && _this.oldScrollLeft != scrollDom.scrollLeft && _this.scrollAllowLeft && _this.scrollX) {
        _this.scrollAllowLeft = false;
        _this.props.bindscrolltoupper && _this.props.bindscrolltoupper((0, _extends3.default)({}, event, {
          detail: {
            direction: 'left'
          }
        }));
      } else if (scrollDom.scrollLeft > 0 + upperThreshold) {
        _this.scrollAllowLeft = true;
      }

      _this.oldScrollTop = scrollDom.scrollTop; //一定要放在最后面。
      _this.oldScrollLeft = scrollDom.scrollLeft; //一定要放在最后面。
    };

    _this.scrollDiv = _react2.default.createRef();

    _this.scrollY = false;
    _this.scrollX = false;
    return _this;
  }

  (0, _createClass3.default)(ScrollView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var data = this.props;
      var scrollDom = this.scrollDiv.current;

      this.scrollY = data['scroll-y'] && data['scroll-y'] != 'false' ? true : false;
      this.scrollX = data['scroll-x'] && data['scroll-x'] != 'false' ? true : false;
      if (data['scroll-top']) {
        this.setScrollTop(data['scroll-top']);
      }
      if (data['scroll-left']) {
        this.setScrollLeft(data['scroll-left']);
      }
      if (data['scroll-into-view']) {
        var intoDom = document.getElementById(data['scroll-into-view']);
        if (this.scrollX) {
          this.setScrollLeft(intoDom.offsetLeft - scrollDom.offsetLeft);
        }
        if (this.scrollY) {
          this.setScrollTop(intoDom.offsetTop - scrollDom.offsetTop);
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var data = this.props;
      var scrollDom = this.scrollDiv.current;
      if (data['scroll-top'] != prevProps['scroll-top']) {
        this.setScrollTop(data['scroll-top']);
      }
      if (data['scroll-left'] != prevProps['scroll-left']) {
        this.setScrollLeft(data['scroll-left']);
      }
      if (data['scroll-into-view'] != prevProps['scroll-into-view']) {
        var intoDom = document.getElementById(data['scroll-into-view']);
        if (this.scrollX) {
          this.setScrollLeft(intoDom.offsetLeft - scrollDom.offsetLeft);
        }
        if (this.scrollY) {
          this.setScrollTop(intoDom.offsetTop - scrollDom.offsetTop);
        }
      }
    }

    // 设置滚动的高度

  }, {
    key: 'setScrollTop',
    value: function setScrollTop(top) {
      var _this2 = this;

      var scrollDom = this.scrollDiv.current;
      if (this.props['scroll-with-animation']) {
        var oldTop = scrollDom.scrollTop;
        cancelAnimationFrame(this.topTimer);
        var variation = Math.abs(top - oldTop);
        var step = Math.ceil(variation / 10);
        var time = 0;
        var animateFn = function animateFn() {
          var newTop = oldTop < top ? _this2.easeInOut(time, oldTop, variation, step) : oldTop - _this2.easeInOut(time, top, variation, step) + top;
          scrollDom.scrollTop = newTop;
          if (time < step) {
            time++;
            _this2.topTimer = requestAnimationFrame(animateFn);
          }
        };
        this.topTimer = requestAnimationFrame(animateFn);
      } else {
        scrollDom.scrollTop = top;
      }
    }

    // 设置滚动的左侧位置

  }, {
    key: 'setScrollLeft',
    value: function setScrollLeft(left) {
      var _this3 = this;

      var scrollDom = this.scrollDiv.current;
      if (this.props['scroll-with-animation']) {
        var oldLeft = scrollDom.scrollLeft;
        cancelAnimationFrame(this.leftTimer);
        var variation = Math.abs(left - oldLeft);
        var step = Math.ceil(variation / 10);
        var time = 0;
        var animateFn = function animateFn() {
          var newLeft = oldLeft < left ? _this3.easeInOut(time, oldLeft, variation, step) : oldLeft - _this3.easeInOut(time, left, variation, step) + left;
          scrollDom.scrollLeft = newLeft;
          if (time < step) {
            time++;
            _this3.leftTimer = requestAnimationFrame(animateFn);
          }
        };
        this.leftTimer = requestAnimationFrame(animateFn);
      } else {
        scrollDom.scrollLeft = left;
      }
    }
  }, {
    key: 'easeInOut',
    value: function easeInOut(t, b, c, d) {
      if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
      return c / 2 * ((t -= 2) * t * t + 2) + b;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          id = _props.id,
          className = _props.className,
          style = _props.style,
          hidden = _props.hidden,
          children = _props.children;
      // 传递参数中的data-参数

      var datasetObj = {};
      for (var key in this.props) {
        if (this.props.hasOwnProperty(key) && key.indexOf('data-') === 0) {
          datasetObj[key] = this.props[key];
        }
      }
      var styleObj = (0, _extends3.default)({}, style);
      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ ref: this.scrollDiv, id: id, className: 'jisu-component scroll-view scroll-view-wrapper ' + className, style: (0, _extends3.default)({}, style, { overflowX: this.props['scroll-x'] ? 'auto' : 'hidden', overflowY: this.props['scroll-y'] ? 'auto' : 'hidden' }) }, datasetObj, { hidden: hidden, onScroll: function onScroll(event) {
            _this4.scrollEvent(event);
          } }),
        children
      );
    }
  }]);
  return ScrollView;
}(_react2.default.Component);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcNotification = __webpack_require__(255);

var _rmcNotification2 = _interopRequireDefault(_rmcNotification);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var SHORT = 3;
var _config = {
    duration: SHORT,
    mask: true
};
var messageInstance = void 0;
var messageNeedHide = void 0;
var prefixCls = 'am-toast';
function getMessageInstance(mask, callback) {
    var _classnames;

    _rmcNotification2['default'].newInstance({
        prefixCls: prefixCls,
        style: {},
        transitionName: 'am-fade',
        className: (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-mask', mask), (0, _defineProperty3['default'])(_classnames, prefixCls + '-nomask', !mask), _classnames))
    }, function (notification) {
        return callback && callback(notification);
    });
}
function notice(content, type) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config.duration;
    var _onClose = arguments[3];
    var mask = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _config.mask;

    var iconTypes = {
        info: '',
        success: 'success',
        fail: 'fail',
        offline: 'dislike',
        loading: 'loading'
    };
    var iconType = iconTypes[type];
    messageNeedHide = false;
    getMessageInstance(mask, function (notification) {
        if (!notification) {
            return;
        }
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        }
        if (messageNeedHide) {
            notification.destroy();
            messageNeedHide = false;
            return;
        }
        messageInstance = notification;
        notification.notice({
            duration: duration,
            style: {},
            content: !!iconType ? React.createElement(
                'div',
                { className: prefixCls + '-text ' + prefixCls + '-text-icon', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(_icon2['default'], { type: iconType, size: 'lg' }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-text-info' },
                    content
                )
            ) : React.createElement(
                'div',
                { className: prefixCls + '-text', role: 'alert', 'aria-live': 'assertive' },
                React.createElement(
                    'div',
                    null,
                    content
                )
            ),
            closable: true,
            onClose: function onClose() {
                if (_onClose) {
                    _onClose();
                }
                notification.destroy();
                notification = null;
                messageInstance = null;
            }
        });
    });
}
exports['default'] = {
    SHORT: SHORT,
    LONG: 8,
    show: function show(content, duration, mask) {
        return notice(content, 'info', duration, function () {}, mask);
    },
    info: function info(content, duration, onClose, mask) {
        return notice(content, 'info', duration, onClose, mask);
    },
    success: function success(content, duration, onClose, mask) {
        return notice(content, 'success', duration, onClose, mask);
    },
    fail: function fail(content, duration, onClose, mask) {
        return notice(content, 'fail', duration, onClose, mask);
    },
    offline: function offline(content, duration, onClose, mask) {
        return notice(content, 'offline', duration, onClose, mask);
    },
    loading: function loading(content, duration, onClose, mask) {
        return notice(content, 'loading', duration, onClose, mask);
    },
    hide: function hide() {
        if (messageInstance) {
            messageInstance.destroy();
            messageInstance = null;
        } else {
            messageNeedHide = true;
        }
    },
    config: function config() {
        var conf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _conf$duration = conf.duration,
            duration = _conf$duration === undefined ? SHORT : _conf$duration,
            mask = conf.mask;

        _config.duration = duration;
        if (mask === false) {
            _config.mask = false;
        }
    }
};
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(27);

__webpack_require__(261);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(217)();
}


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function formatTime(date) {
  if (!date) {
    date = new Date();
  }

  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();

  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();

  return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
}

function formatNumber(n) {
  n = n.toString();
  return n[1] ? n : '0' + n;
}

// 格式化时间
// date 时间，可以不传，不传默认取当前时间。传值可以为：时间对象，时间戳，时间字符串（19-03-13 10:30:00、19/03/13 10:30:00、19-03-13）
// fmt 时间格式，默认："YYYY-MM-DD hh:mm:ss"；年月日大写， 时分秒小写
// 如果格式传 "YY-MM-DD", 则返回 "19-03-13"; 如果格式传 "YY/MM/DD", 则返回 "19/03/13"
function formatTimeYMD(date, fmt) {
  if (!date) {
    date = new Date();
  } else if (/^\d+$/.test(date)) {
    date = new Date(date * 1000);
  } else if (typeof date === 'string') {
    date = new Date(date.replace(/\-/g, '/'));
  } else {
    date = date;
  }
  fmt = fmt || 'YYYY-MM-DD hh:mm:ss';

  var time = {
    "M+": date.getMonth() + 1, //月份 
    "D+": date.getDate(), //日 
    "h+": date.getHours(), //小时 
    "m+": date.getMinutes(), //分 
    "s+": date.getSeconds() //秒
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in time) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? time[k] : ("00" + time[k]).substr(("" + time[k]).length));
    }
  }
  return fmt;
}

function formatDistance(distance) {
  if (!distance) {
    return 0;
  }
  distance = +distance;
  return distance < 1000 ? Math.round(distance) + 'm' : (distance / 1000).toFixed(1) + 'km';
}

function isPlainObject(obj) {
  for (var name in obj) {
    return false;
  }
  return true;
}

function isPhoneNumber(num) {
  return (/^1\d{10}$/.test(num)
  );
}

/*获取当前页url*/
function getCurrentPageUrl() {
  var pages = getCurrentPages();
  var currentPage = pages[pages.length - 1];
  var url = currentPage.route;
  return url;
}

/*获取当前页带参数的url*/
function getCurrentPageUrlWithArgs() {
  var pages = getCurrentPages();
  var currentPage = pages[pages.length - 1];
  var url = currentPage.route;
  var options = currentPage.options;
  var urlWithArgs = url + '?';
  for (var key in options) {
    var value = options[key];
    urlWithArgs += key + '=' + value + '&';
  }
  urlWithArgs = urlWithArgs.substring(0, urlWithArgs.length - 1);
  return urlWithArgs;
}

// 获取当前页面的参数
function getCurrentPageArgs() {
  var pages = getCurrentPages();
  var currentPage = pages[pages.length - 1];
  var options = currentPage.options;
  var args = '';
  for (var key in options) {
    var value = options[key];
    args += key + '=' + value + '&';
  }
  args = args.substring(0, args.length - 1);
  return args;
}

function getGoodsTypeByForm(form) {
  switch (form) {
    case 'goods':
      return 0;
    case 'appointment':
      return 1;
    case 'waimai':
      return 2;
    case 'tostore':
      return 3;
    case 'new_appointment':
      return 10;
    default:
      return 0;
  }
}

function getFormByGoodsType(gt) {
  var type = +gt || 0;
  switch (type) {
    case 0:
      return 'goods';
    case 1:
      return 'appointment';
    case 2:
      return 'waimai';
    case 3:
      return 'tostore';
    case 10:
      return 'new_appointment';
    default:
      return 'goods';
  }
}

function __each(arr, func) {
  var res = [];
  for (var k in arr) {
    res.push(func.call(this, arr[k], k));
  }
  return res;
}

function __filter(arr, func) {
  var res = [];
  __each(arr, function (v) {
    if (func(v)) {
      res.push(v);
    }
  });
  return res;
}

function __reduce(arr, func, init) {
  var res = init;
  var self = this;
  if (res === undefined) {
    res = arr[0];
    arr = arr.slice(1);
  }
  __each(arr, function (v, k) {
    res = func.call(self, res, v, k, arr);
  });
  return res;
}

function createAttrArr(attrStr) {
  var attrArr = attrStr.split(/[.\[\]]/) || [],
      func = function func(v) {
    return v;
  },
      func2 = function func2(v) {
    return (/^\d+$/.test(v) ? +v : v
    );
  };
  return __each(__filter(attrArr, func), func2);
}

function getValueByAttrStr(obj, attrStr) {
  var func = function func(o, k) {
    return o && o[k];
  };
  return __reduce(createAttrArr(attrStr), func, obj);
}

module.exports = {
  formatTime: formatTime,
  formatTimeYMD: formatTimeYMD,
  formatNumber: formatNumber,
  isPlainObject: isPlainObject,
  isPhoneNumber: isPhoneNumber,
  formatDistance: formatDistance,
  getCurrentPageUrl: getCurrentPageUrl,
  getCurrentPageUrlWithArgs: getCurrentPageUrlWithArgs,
  getCurrentPageArgs: getCurrentPageArgs,
  getGoodsTypeByForm: getGoodsTypeByForm,
  getFormByGoodsType: getFormByGoodsType,
  getValueByAttrStr: getValueByAttrStr
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickEventHandler = exports.customEvent = undefined;

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(13);

var _page = __webpack_require__(43);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 点击事件集合
 */
var handler = {
  /**
   * 详情：商品详情
   */
  'goods-trade': function goodsTrade(_ref) {
    var customFeature = _ref.customFeature,
        franchisee = _ref.franchisee;

    var type = customFeature['goods-type'] || customFeature['goods_type'];
    var id = customFeature['goods-id'] || customFeature['goods_id'];
    if (!id) {
      return;
    }
    var router = '';
    if (type == 3) {
      router = 'toStoreDetail';
    } else if (type == 10) {
      if (customFeature.unit == 3) {
        router = 'hotel';
      } else {
        router = 'newAppointmentDetail';
      }
    } else {
      router = 'goodsDetail';
    }
    _app.appMethod.turnToPage(router, {
      detail: id,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：秒杀
   */
  'to-seckill': function toSeckill(_ref2) {
    var customFeature = _ref2.customFeature,
        franchisee = _ref2.franchisee;

    var id = customFeature['seckill-id'] || customFeature['seckill_id'];
    if (!id) {
      return;
    }
    var activityId = customFeature['seckill-activity-id'] || 0;
    _app.appMethod.turnToPage('seckillDetail', {
      detail: id,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || '',
      sec_act_id: activityId || 0,
      sec_t_id: customFeature['seckill-activity-time-id'] || 0,
      secType: activityId != 0 ? 1 : 0
    });
  },
  /**
   * 页面
   */
  'inner-link': function innerLink(_ref3) {
    var customFeature = _ref3.customFeature,
        franchisee = _ref3.franchisee;

    var router = customFeature['inner-page-link'] || customFeature['page-link'] || customFeature['inner_page_link'];
    var pageInstance = _app.appMethod.getAppCurrentPage();
    if (router === 'prePage') {
      _app.appMethod.turnBack();
    } else {
      // 当前参数尚未有作用
      var isRedirect = customFeature.is_redirect == 1;
      var pageRouter = pageInstance.state.router;
      if (pageRouter == _app.appMethod.globalData.homepageRouter || _app.appMethod.getTabPagePathArr().indexOf(router) !== -1) {
        isRedirect = false;
      }
      _app.appMethod.turnToPage(router, {
        franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
      }, isRedirect);
    }
  },
  /**
   * 营销：拼团
   */
  'group-buy': function groupBuy(_ref4) {
    var customFeature = _ref4.customFeature,
        franchisee = _ref4.franchisee;

    var goodsId = customFeature['goods-id'] || customFeature['goods_id'];
    if (!goodsId) {
      return;
    }
    _app.appMethod.turnToPage('gpgoodsDetail', {
      goods_id: goodsId,
      activity_id: customFeature['active-id'] || customFeature['active_id'],
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：预售
   */
  'presell': function presell(_ref5) {
    var customFeature = _ref5.customFeature,
        franchisee = _ref5.franchisee;

    var goods_id = customFeature['goods-id'] || customFeature['goods_id'];
    franchisee = franchisee || _app.appMethod.getPageFranchiseeId() || '';
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (goods_id) {
      _app.appMethod.turnToPage('presellDetail?detail=' + goods_id + chainParam);
    }
  },
  /**
   * 功能：拨打电话
   */
  'call': function call(_ref6) {
    var customFeature = _ref6.customFeature,
        realValue = _ref6.realValue;

    if (customFeature && customFeature['phoneNumberSource'] === 'dynamic') {
      var _phoneNum = realValue ? realValue : '';
      if (!_phoneNum) {
        return;
      }
      _app.appMethod.makePhoneCall(_phoneNum);
      return;
    }
    var phoneNum = customFeature['phone-num'] || customFeature['phone_num'];
    _app.appMethod.makePhoneCall(phoneNum);
  },
  /**
   * 详情：优惠券详情
   */
  'get-coupon': function getCoupon(_ref7) {
    var customFeature = _ref7.customFeature,
        franchisee = _ref7.franchisee;

    var couponId = customFeature['coupon-id'] || customFeature['coupon_id'];
    if (!couponId) {
      return;
    }
    _app.appMethod.turnToPage('couponDetail', {
      detail: couponId,
      recv_type: customFeature['recv_type'],
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：社区详情
   */
  'community': function community(_ref8) {
    var customFeature = _ref8.customFeature,
        franchisee = _ref8.franchisee;

    _app.appMethod.turnToPage('communityPage', {
      detail: customFeature['community-id'] || customFeature['community_id'],
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：多商家入驻
   */
  'franchisee-enter': function franchiseeEnter() {
    _app.appMethod.turnToPage('franchiseeEnter');
  },
  /**
   * 多商家：合作联系
   */
  'franchisee-cooperation': function franchiseeCooperation() {
    _app.appMethod.turnToPage('franchiseeCooperation');
  },
  /**
   * 详情：商家详情
   */
  'to-franchisee': function toFranchisee(_ref9) {
    var customFeature = _ref9.customFeature;

    var franchisee_id = customFeature['franchisee-id'] || customFeature['franchisee_id'];
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        sub_shop_app_id: franchisee_id
      },
      success: function success(res) {
        if (res.status === 0 && Array.isArray(res.data) && res.data[0]) {
          var shopInfo = res.data[0];
          var subAppBar = shopInfo.sub_app_bar;
          var appid = franchisee_id;
          var audit = shopInfo.is_audit;
          var mode = shopInfo.mode_id;
          var id = shopInfo.id;
          var newmode = subAppBar.mode_id || '';
          var pageLink = subAppBar['homepage-router'] || '';
          var param = {};

          param.detail = appid;
          if (audit == 2) {
            param.shop_id = id;
          }
          if (pageLink) {
            mode = newmode;
            switch (pageLink.trim()) {
              case 'franchiseeWaimai':
                _app.appMethod.goToFranchisee(1, param);
                return;
              case 'franchiseeTostore':
                _app.appMethod.goToFranchisee(3, param);
                return;
              case 'franchiseeDetail4':
                _app.appMethod.goToFranchisee(2, param);
                return;
              case 'franchiseeDetail':
                _app.appMethod.goToFranchisee(0, param);
                return;
              default:
                break;
            }
            _app.appMethod.turnToPage(pageLink, {
              franchisee: franchisee_id,
              fmode: mode
            });
            return;
          }
          _app.appMethod.goToFranchisee(mode, param);
        } else {
          _app.appMethod.showModal({
            content: '获取子店信息失败'
          });
        }
      },
      error: function error() {
        _app.appMethod.showModal({
          content: '获取子店信息失败'
        });
      }
    });
  },
  /**
   * 开启推广
   */
  'to-promotion': function toPromotion() {
    _app.appMethod._isOpenPromotion();
  },
  /**
   * 营销：优惠券列表
   */
  'coupon-receive-list': function couponReceiveList() {
    _app.appMethod.turnToPage('couponReceiveListPage');
  },
  /**
   * 营销：储值
   */
  'recharge': function recharge() {
    _app.appMethod.turnToPage('recharge');
  },
  /**
   * 营销：大转盘
   */
  'lucky-wheel': function luckyWheel(_ref10) {
    var franchisee = _ref10.franchisee;

    _app.appMethod.turnToPage('luckyWheelDetail', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：砸金蛋
   */
  'golden-eggs': function goldenEggs(_ref11) {
    var franchisee = _ref11.franchisee;

    _app.appMethod.turnToPage('goldenEggs', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：刮刮乐
   */
  'scratch-card': function scratchCard(_ref12) {
    var franchisee = _ref12.franchisee;

    _app.appMethod.turnToPage('scratch', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 营销：集集乐
   */
  'collect-stars': function collectStars(_ref13) {
    var franchisee = _ref13.franchisee;

    _app.appMethod.turnToPage('collectStars', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频详情
   */
  'video': function video(_ref14) {
    var customFeature = _ref14.customFeature,
        franchisee = _ref14.franchisee;

    var video_id = customFeature['video-id'];
    _app.appMethod.turnToPage('videoDetail', {
      detail: video_id,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频详情
   */
  'video-detail': function videoDetail(_ref15) {
    var customFeature = _ref15.customFeature,
        franchisee = _ref15.franchisee;

    var video_id = customFeature['video_id'] || customFeature['video-id'];
    _app.appMethod.turnToPage('videoDetail', {
      detail: video_id,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：视频播放
   */
  'video-play': function videoPlay(_ref16) {
    var customFeature = _ref16.customFeature;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = customFeature.compindex;
    var video_id = customFeature['video-id'];
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoLibURL',
      method: 'get',
      data: { id: video_id },
      success: function success(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].videoUrl'] = res.data;
        // TOOO 未处理
        newdata['eles[' + compindex + '].carouselVideoTop'] = pageInstance.data.page_hasNavBar ? _app.appMethod.globalData.topNavBarHeight : 0;
        pageInstance.setData(newdata);
      }
    });
  },
  /**
   * 营销：当面付
   */
  'transfer': function transfer(_ref17) {
    var franchisee = _ref17.franchisee;

    _app.appMethod.turnToPage('transferPage', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：跳转小程序
   */
  'turn-to-xcx': function turnToXcx(_ref18) {
    var customFeature = _ref18.customFeature;

    _toast2.default.info(React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        null,
        '\u6682\u4E0D\u652F\u6301'
      ),
      React.createElement(
        'div',
        null,
        '\u3010\u8DF3\u8F6C\u5C0F\u7A0B\u5E8F\u3011\u529F\u80FD'
      )
    ));
    // app.navigateToXcx({
    //   appId: customFeature['xcx-appid'] || customFeature['xcx_appid'],
    //   path: customFeature['xcx-page-url'] || customFeature['xcx_page_url'] || ''
    // });
  },
  /**
   * 微信小程序: 联系客服
   */
  'contact': function contact() {
    _toast2.default.info(React.createElement(
      'div',
      null,
      React.createElement(
        'div',
        null,
        '\u6682\u4E0D\u652F\u6301'
      ),
      React.createElement(
        'div',
        null,
        '\u3010\u8054\u7CFB\u5BA2\u670D\u3011\u529F\u80FD'
      )
    ));
  },
  /**
   * 功能：Wifi
   * TODO 未确认实现方案
   */
  'wifi': function wifi(_ref19) {
    var customFeature = _ref19.customFeature,
        franchisee = _ref19.franchisee;

    _toast2.default.info('当前不支持wifi功能');
  },
  /**
   * 功能：跳转插件
   * TODO 未确认实现方案
   */
  'plugin-link': function pluginLink(_ref20) {
    var customFeature = _ref20.customFeature,
        franchisee = _ref20.franchisee;

    _toast2.default.info('当前不支持跳转插件');
  },
  /**
   * 详情：话题详情
   */
  'topic': function topic(_ref21) {
    var customFeature = _ref21.customFeature,
        franchisee = _ref21.franchisee;

    var topicId = customFeature['topic-id'] || customFeature['topic_id'];
    if (!topicId) {
      return;
    }
    _app.appMethod.turnToPage('communityDetail', {
      detail: topicId,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：资讯详情
   */
  'news': function news(_ref22) {
    var customFeature = _ref22.customFeature,
        franchisee = _ref22.franchisee;

    var newsId = customFeature['news-id'] || customFeature['news_id'];
    if (!newsId) {
      return;
    }
    console.log('newsId', newsId);
    _app.appMethod.turnToPage('newsDetail', {
      detail: newsId,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：分享朋友圈
   */
  'page-share': function pageShare(_ref23) {
    var customFeature = _ref23.customFeature,
        franchisee = _ref23.franchisee;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    var queryStr = '';
    for (var i in pageInstance.sharePageParams) {
      queryStr += '&' + i + '=' + pageInstance.sharePageParams[i];
    }
    var router = pageInstance.state.router;
    // TODO: options.detail 未处理
    var objId = router == 'newsDetail' ? pageInstance.options.detail : router;
    var shareType = router == 'newsDetail' ? 17 : 11;

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppDistribution/DistributionShareQRCode',
      data: {
        obj_id: objId,
        type: shareType,
        text: customFeature.pageShareCustomText,
        goods_img: customFeature.pageShareImgUrl,
        params: queryStr,
        p_id: _app.appMethod.globalData.p_id
      },
      success: function success(res) {
        _app.appInstance.pageQrcodeRef.current.show({
          pageQRCodeData: {
            'shareDialogShow': 0,
            'shareMenuShow': true,
            'goodsInfo': res.data
          }
        });
      }
    });
  },
  /**
   * 功能：分享朋友圈
   */
  'share': function share(_ref24) {
    var customFeature = _ref24.customFeature;

    _app.appMethod.shareClickEvent();
  },
  /**
   * 详情：微信优惠券详情
   */
  'wx-coupon': function wxCoupon(_ref25) {
    var customFeature = _ref25.customFeature;

    _toast2.default.info('当前不支持微信优惠券');
    return;
    var wxcouponId = customFeature['wxcoupon-id'] || customFeature['wxcoupon_id'];
    _app.appMethod.sendRequest({
      url: '/index.php?r=appWeChatCoupon/getSignature',
      data: {
        card_id: wxcouponId
      },
      success: function success(res) {
        // TODO: 微信优惠券
        // wx.addCard({
        //   cardList: [
        //     {
        //       cardId: wxcouponId,
        //       cardExt: '{"nonce_str":"' + res.data.timestamp + '","timestamp":"' + res.data.timestamp + '", "signature":"' + res.data.signature + '"}'
        //     }
        //   ],
        //   success: function (res) {
        //     app.sendRequest({
        //       url: '/index.php?r=appWeChatCoupon/recvCoupon',
        //       data: {
        //         code: res.cardList[0].code,
        //         card_id: res.cardList[0].cardId
        //       },
        //       success: function (res) {
        //         app.showModal({
        //           content: '领取卡券成功'
        //         })
        //       }
        //     });
        //   }
        // })
      }
    });
  },
  /**
   * 营销: 会员卡
   */
  'vip-card-list': function vipCardList(_ref26) {
    var franchisee = _ref26.franchisee;

    _app.appMethod.turnToPage('vipCard', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：足迹
   */
  'goods-foot-print': function goodsFootPrint() {
    _app.appMethod.turnToPage('goodsFootPrint');
  },
  /**
   * 功能：收藏
   */
  'goods-favorites': function goodsFavorites() {
    _app.appMethod.turnToPage('goodsFavorites');
  },
  /**
   * 营销：会员权益
   */
  'vip-interests': function vipInterests(_ref27) {
    var franchisee = _ref27.franchisee;

    franchisee = franchisee || _app.appMethod.getPageFranchiseeId() || '';
    var queryStr = franchisee ? '?franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('vipBenefits', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 功能：扫码购
   */
  'goods-scan-code': function goodsScanCode() {
    var path = 'shoppingCart?goodsScanCode=true';
    _app.appMethod.getAppECStoreConfig(function (res) {
      if (res.cart_config.shopping_by_scanning_code == 1) {
        _app.appMethod.turnToPage(path);
      } else {
        _app.appMethod.showModal({
          content: '暂未开通扫码购'
        });
      }
    });
  },
  /**
   * 功能：预览大图
   */
  'preview-picture': function previewPicture(_ref28) {
    var event = _ref28.event;

    var dataset = event.currentTarget.dataset;
    // TODO 待处理 dataset不能存非字符串类型
    var urls = dataset.imgarr instanceof Array ? dataset.imgarr : [dataset.imgarr];
    if (!dataset.imgarr && !dataset.img) {
      return;
    }
    _app.appMethod.previewImage({
      current: dataset.img || urls[0],
      urls: urls
    });
  },
  /**
   * 功能：弹窗控制
   */
  'popup-window-control': function popupWindowControl(_ref29) {
    var customFeature = _ref29.customFeature;

    var windowControl = customFeature.windowControl;
    var componentIndex = null;
    // 找出要控制的弹窗组件
    var component = _page.pageInstance.state.eles.find(function (ele, index) {
      // 受控弹窗组件id存在customFeature中
      if (ele.customFeature.id === windowControl.popupWindowId) {
        componentIndex = index;
        return true;
      }
    });
    if (!component) {
      return;
    }
    if (windowControl.action === 'show') {
      component['showPopupWindow'] = true;
    } else if (windowControl.action === 'hide') {
      component['showPopupWindow'] = false;
    }
    // 设置页面组件数据
    _page.pageMethod.setCustomComponentData(componentIndex, component);
    // 自动关闭
    if (component.customFeature.autoClose) {
      setTimeout(function () {
        component['showPopupWindow'] = false;
        _page.pageMethod.setCustomComponentData(componentIndex, component);
      }, +component.customFeature.closeDelay * 1000);
    }
  },
  /**
   * 功能：侧边栏控制
   */
  'sidebar-control': function sidebarControl(_ref30) {
    var customFeature = _ref30.customFeature;

    var sidebarControl = customFeature.sidebarControl;
    var componentIndex = null;
    // 找出要控制的侧边栏
    var component = _page.pageInstance.state.eles.find(function (ele, index) {
      // 受控侧边栏组件id存在customFeature中
      if (ele.customFeature.id === sidebarControl.sidebarId) {
        componentIndex = index;
        return true;
      }
    });
    if (!component) {
      return;
    }
    if (sidebarControl.action === 'show') {
      component['showSidebar'] = true;
    } else if (sidebarControl.action === 'hide') {
      component['hideSidebar'] = true;
    }
    // 设置页面组件数据
    _page.pageMethod.setCustomComponentData(componentIndex, component);
  },
  /**
   * 功能：刷新列表
   */
  'refresh-list': function refreshList(_ref31) {
    var customFeature = _ref31.customFeature;

    _app.appMethod.tapRefreshListHandler(null, {
      refresh_object: customFeature.refresh_object,
      index_segment: customFeature.index_segment,
      index_value: customFeature.index_value
    });
  },
  /**
   * 功能：搜索
   */
  'search': function search(_ref32) {
    var customFeature = _ref32.customFeature;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    var listId = customFeature.search.listId;
    var data = pageInstance.data.eles;
    var searchCompindex = -1;
    for (var i = 0; i < data.length; i++) {
      if (data[i].customFeature && listId == data[i].customFeature.id) {
        searchCompindex = i;
        break;
      }
    }
    if (searchCompindex > -1) {
      var searchCompData = pageInstance.data.eles[searchCompindex];
      if (searchCompData.type == 'goods-list') {
        _app.appMethod.turnToPage('classifyGoodsListPage', {
          form: searchCompData.customFeature.form
        });
      } else {
        _app.appMethod.showModal({
          content: '搜索的点击事件只能关联电商、到店、预约列表'
        });
        return;
      }
    } else {
      _app.appMethod.showModal({
        content: '找不到搜索关联的列表'
      });
    }
  },
  /**
   * 功能：回到顶部
   */
  'top': function top() {
    _app.appMethod.pageScrollTo(0);
  },
  /**
   * 通知推送：点击事件
   */
  'click-event': function clickEvent(_ref33) {
    var customFeature = _ref33.customFeature;

    var lookLink = customFeature['look-link'];
    _app.appMethod.turnToPage(lookLink, {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 详情：会员卡详情
   */
  'wx-vip-card': function wxVipCard(_ref34) {
    var customFeature = _ref34.customFeature;

    _toast2.default.info('暂不支持微信会员卡');
    return;
    // let cardId = customFeature['card-id'] ||  customFeature['card_id'];
    // let id = customFeature['wx-vip-card-id'] || customFeature['wx_vip_card_id'];
    // if (cardId){
    //   app.sendRequest({
    //     url: '/index.php?r=appWeChatCoupon/getSignature',
    //     data: {
    //       card_id: cardId
    //     },
    //     success: function (res) {
    //       wx.addCard({
    //         cardList: [
    //           {
    //             cardId: cardId,
    //             cardExt: '{"nonce_str":"' + res.data.timestamp + '","timestamp":"' + res.data.timestamp + '", "signature":"' + res.data.signature + '"}'
    //           }
    //         ],
    //         success: function (res) {
    //           console.log(res);
    //           app.showModal({
    //             content: '领取成功'
    //           });
    //         }
    //       })
    //     }
    //   });
    // } 
  },
  /**
   * 微分商城
   */
  'differential-mall': function differentialMall() {
    _app.appMethod.turnToPage('dMWebView', {
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  /**
   * 商品分类（仅多商家）(传值略有不同)
   */
  'goods-classify': function goodsClassify(_ref35) {
    var customFeature = _ref35.customFeature;

    var type = 'goods';
    if (form.goods_type == 0) {
      type = 'goods';
    } else if (form.goods_type == 3) {
      type = 'tostore';
    } else if (form.goods_type == 1) {
      type = 'appointment';
    }
    franchiseeId = franchiseeId || _app.appMethod.getPageFranchiseeId();
    _app.appMethod.turnToPage('goodsMore', {
      detail: type,
      categroy: customFeature.id,
      categroyName: customFeature.name,
      franchisee: franchisee || _app.appMethod.getPageFranchiseeId() || ''
    });
  },
  'turnToH5': function turnToH5(_ref36) {
    var customFeature = _ref36.customFeature;

    window.location.href = customFeature.turn_to_h5_url;
    return;
  }
};
/**
 * 点击事件触发函数
 * @param {object} options
 * @param {object} options.customFeature 必填 点击事件含有的参数
 * @param {object} [options.franchisee] 是否为多商家，是则为多商家appid
 * @param {object} [options.event] 事件
 */
function customEvent() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var customFeature = options.customFeature;

  if (!customFeature['action']) {
    return;
  }
  if (!handler[customFeature['action']]) {
    // Toast.info('当前点击事件尚未开发');
    return;
  }
  handler[customFeature['action']](options);
}

/**
 * 兼容旧点击事件调用
 * @param {*} action 
 */
/**
 * 兼容旧点击事件调用
 * @description 返回旧版对象（建议后续不要这样调用）
 * 改为customEvent()
 */
var clickEventHandler = function () {
  var obj = {};

  var _loop = function _loop(key) {
    obj[key] = function (param, franchisee, event) {
      handler[key]({
        customFeature: param,
        franchisee: franchisee,
        event: event
      });
    };
  };

  for (var key in handler) {
    _loop(key);
  }
  return obj;
}();

exports.customEvent = customEvent;
exports.clickEventHandler = clickEventHandler;

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(181);

__webpack_require__(302);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(228);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(236);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nonsense = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _AbstractPicker2 = __webpack_require__(283);

var _AbstractPicker3 = _interopRequireDefault(_AbstractPicker2);

var _propTypes = __webpack_require__(15);

var PropTypes = _interopRequireWildcard(_propTypes);

var _popupProps = __webpack_require__(289);

var _popupProps2 = _interopRequireDefault(_popupProps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// TODO:
// fix error TS4026:Public static property 'defaultProps' of exported class has or is using name 'React.ReactElement'
// fix error TS6133: 'React' is declared but its value is never read.
var nonsense = exports.nonsense = React.createElement('div', null);

var Picker = function (_AbstractPicker) {
    (0, _inherits3['default'])(Picker, _AbstractPicker);

    function Picker() {
        (0, _classCallCheck3['default'])(this, Picker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).apply(this, arguments));

        _this.popupProps = _popupProps2['default'];
        return _this;
    }

    return Picker;
}(_AbstractPicker3['default']);

exports['default'] = Picker;

Picker.defaultProps = (0, _AbstractPicker2.getDefaultProps)();
Picker.contextTypes = {
    antLocale: PropTypes.object
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RequestStatus = RequestStatus;

var _app = __webpack_require__(4);

__webpack_require__(759);

// 加载loading
var RequestLoading = function RequestLoading() {
  return React.createElement(
    'div',
    { className: 'loading-wrap' },
    React.createElement(
      'div',
      { className: 'loading-view' },
      React.createElement('div', { className: 'loading-dot1' }),
      React.createElement('div', { className: 'loading-dot2' })
    )
  );
};

// 加载没有数据
var RequestNone = function RequestNone(props) {
  var data = props.data.data;

  return React.createElement(
    'div',
    { className: 'request-none' },
    React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png' }),
    React.createElement(
      'div',
      null,
      data || '暂无数据'
    )
  );
};

// 加载失败
var RequestFail = function RequestFail(props) {
  var _props$data = props.data,
      compindex = _props$data.compindex,
      refreshEvent = _props$data.refreshEvent;

  return React.createElement(
    'div',
    { className: 'request-fail' },
    React.createElement(
      'div',
      null,
      '\u6570\u636E\u52A0\u8F7D\u5931\u8D25~ '
    ),
    React.createElement(
      'button',
      { className: 'request-refresh-btn', 'data-compindex': compindex, bindtap: _app.appMethod[refreshEvent] },
      '\u5237\u65B0\u91CD\u8BD5'
    )
  );
};

// 加载完所有数据
var RequestAll = function RequestAll() {
  return React.createElement(
    'div',
    { className: 'request-all' },
    '\u6CA1\u6709\u66F4\u591A\u4E86'
  );
};

function RequestStatus(props) {
  // 状态类型
  var is = props.is;
  // 是否为横版
  var hor = props.hor;
  var templates = {
    // 加载loading
    'requestLoading': function requestLoading(props) {
      return React.createElement(RequestLoading, props);
    },
    // 加载没有数据
    'requestNone': function requestNone(props) {
      return React.createElement(RequestNone, props);
    },
    // 加载失败
    'requestFail': function requestFail(props) {
      return React.createElement(RequestFail, props);
    },
    // 加载完所有数据
    'requestAll': function requestAll(props) {
      return React.createElement(RequestAll, props);
    }
  };
  if (!templates[is]) {
    return null;
  }
  return React.createElement(
    'div',
    { className: 'common request-status ' + (hor && 'hor-request-status') },
    templates[is](props)
  );
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _loadSprite = __webpack_require__(256);

var _loadSprite2 = _interopRequireDefault(_loadSprite);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Icon = function (_React$Component) {
    (0, _inherits3['default'])(Icon, _React$Component);

    function Icon() {
        (0, _classCallCheck3['default'])(this, Icon);
        return (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Icon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _loadSprite2['default'])();
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                type = _a.type,
                className = _a.className,
                size = _a.size,
                restProps = __rest(_a, ["type", "className", "size"]);
            var cls = (0, _classnames2['default'])(className, 'am-icon', 'am-icon-' + type, 'am-icon-' + size);
            return React.createElement(
                'svg',
                (0, _extends3['default'])({ className: cls }, restProps),
                React.createElement('use', { xlinkHref: '#' + type })
            );
        }
    }]);
    return Icon;
}(React.Component);

exports['default'] = Icon;

Icon.defaultProps = {
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(260);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(59));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(257);

__webpack_require__(258);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcNukaCarousel = __webpack_require__(406);

var _rmcNukaCarousel2 = _interopRequireDefault(_rmcNukaCarousel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Carousel = function (_React$Component) {
    (0, _inherits3['default'])(Carousel, _React$Component);

    function Carousel(props) {
        (0, _classCallCheck3['default'])(this, Carousel);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this.onChange = function (index) {
            _this.setState({
                selectedIndex: index
            }, function () {
                if (_this.props.afterChange) {
                    _this.props.afterChange(index);
                }
            });
        };
        _this.state = {
            selectedIndex: _this.props.selectedIndex
        };
        return _this;
    }

    (0, _createClass3['default'])(Carousel, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                infinite = _a.infinite,
                selectedIndex = _a.selectedIndex,
                beforeChange = _a.beforeChange,
                afterChange = _a.afterChange,
                dots = _a.dots,
                restProps = __rest(_a, ["infinite", "selectedIndex", "beforeChange", "afterChange", "dots"]);var prefixCls = restProps.prefixCls,
                dotActiveStyle = restProps.dotActiveStyle,
                dotStyle = restProps.dotStyle,
                className = restProps.className,
                vertical = restProps.vertical;

            var newProps = (0, _extends3['default'])({}, restProps, { wrapAround: infinite, slideIndex: selectedIndex, beforeSlide: beforeChange });
            var Decorators = [];
            if (dots) {
                Decorators = [{
                    component: function component(_ref) {
                        var slideCount = _ref.slideCount,
                            slidesToScroll = _ref.slidesToScroll,
                            currentSlide = _ref.currentSlide;

                        var arr = [];
                        for (var i = 0; i < slideCount; i += slidesToScroll) {
                            arr.push(i);
                        }
                        var dotDom = arr.map(function (index) {
                            var dotCls = (0, _classnames4['default'])(prefixCls + '-wrap-dot', (0, _defineProperty3['default'])({}, prefixCls + '-wrap-dot-active', index === currentSlide));
                            var currentDotStyle = index === currentSlide ? dotActiveStyle : dotStyle;
                            return React.createElement(
                                'div',
                                { className: dotCls, key: index },
                                React.createElement('span', { style: currentDotStyle })
                            );
                        });
                        return React.createElement(
                            'div',
                            { className: prefixCls + '-wrap' },
                            dotDom
                        );
                    },
                    position: 'BottomCenter'
                }];
            }
            var wrapCls = (0, _classnames4['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-vertical', vertical));
            return React.createElement(_rmcNukaCarousel2['default'], (0, _extends3['default'])({}, newProps, { className: wrapCls, decorators: Decorators, afterSlide: this.onChange }));
        }
    }]);
    return Carousel;
}(React.Component);

exports['default'] = Carousel;

Carousel.defaultProps = {
    prefixCls: 'am-carousel',
    dots: true,
    arrows: false,
    autoplay: false,
    infinite: false,
    cellAlign: 'center',
    selectedIndex: 0,
    dotStyle: {},
    dotActiveStyle: {}
};
module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(410);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Switch = function (_React$Component) {
    (0, _inherits3['default'])(Switch, _React$Component);

    function Switch() {
        (0, _classCallCheck3['default'])(this, Switch);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));

        _this.onChange = function (e) {
            var checked = e.target.checked;
            if (_this.props.onChange) {
                _this.props.onChange(checked);
            }
        };
        _this.onClick = function (e) {
            if (_this.props.onClick) {
                var val = void 0;
                // tslint:disable-next-line:prefer-conditional-expression
                if (e && e.target && e.target.checked !== undefined) {
                    val = e.target.checked;
                } else {
                    val = _this.props.checked;
                }
                _this.props.onClick(val);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Switch, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                name = _a.name,
                checked = _a.checked,
                disabled = _a.disabled,
                className = _a.className,
                platform = _a.platform,
                color = _a.color,
                restProps = __rest(_a, ["prefixCls", "name", "checked", "disabled", "className", "platform", "color"]);
            var wrapCls = (0, _classnames4['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-android', platform === 'android'));
            var fackInputCls = (0, _classnames4['default'])('checkbox', (0, _defineProperty3['default'])({}, 'checkbox-disabled', disabled));
            var globalProps = Object.keys(restProps).reduce(function (prev, key) {
                if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
                    prev[key] = restProps[key];
                }
                return prev;
            }, {});
            var style = this.props.style || {};
            if (color && checked) {
                style.backgroundColor = color;
            }
            return React.createElement(
                'label',
                { className: wrapCls },
                React.createElement('input', (0, _extends3['default'])({ type: 'checkbox', name: name, className: prefixCls + '-checkbox', disabled: disabled, checked: checked, onChange: this.onChange, value: checked ? 'on' : 'off' }, !disabled ? { onClick: this.onClick } : {}, globalProps)),
                React.createElement('div', (0, _extends3['default'])({ className: fackInputCls, style: style }, disabled ? { onClick: this.onClick } : {}))
            );
        }
    }]);
    return Switch;
}(React.Component);

exports['default'] = Switch;

Switch.defaultProps = {
    prefixCls: 'am-switch',
    name: '',
    checked: false,
    disabled: false,
    onChange: function onChange() {},

    platform: 'ios',
    onClick: function onClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(433);

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(114)('wks');
var uid = __webpack_require__(87);
var Symbol = __webpack_require__(34).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

exports.ajax = ajax;

__webpack_require__(13);

var _axios = __webpack_require__(262);

var _axios2 = _interopRequireDefault(_axios);

var _tools = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 按照jquery的api封装的方法
 * 默认配置
 * TODO 可选：是否登录的拦截，loading框
 */

/**
 * @file http库axios封装的方法
 * @description 提供公用的工具 functions
 */
function ajax() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!options.url) {
    console.log('请填写接口地址');
    return false;
  }
  if (options.loading) {
    _toast2.default.loading('加载中', 0);
  }
  var config = {
    method: options.type || 'post',
    url: options.url,
    headers: options.headers || {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    timeout: options.timeout || 30 * 1000,
    responsoType: options.dataType || 'json'
  };
  // success error data
  options.data = options.data || {};
  // 数据深拷贝，防止对原始数据的污染
  // webapp的所有接口均有_source_type = 'webapp'
  var isFileUpload = Object.values(options.data).some(function (value) {
    return value instanceof File;
  });
  if (!isFileUpload) {
    options.data = (0, _extends3.default)({}, JSON.parse(JSON.stringify(options.data)), { _source_type: 'webapp' });
  }
  if (config.method === 'get' || config.method === 'GET') {
    config.params = options.data;
  } else if (config.method === 'post' || config.method === 'POST') {
    // 检查是否有文件对象
    var _isFileUpload = Object.values(options.data).some(function (value) {
      return value instanceof File;
    });
    if (_isFileUpload) {
      // 使用 FormData 封装数据
      var formData = new FormData();
      for (var key in options.data) {
        if (options.data.hasOwnProperty(key)) {
          if (options.data[key] instanceof File) {
            formData.append(key, options.data[key]);
          } else {
            formData.append(key, JSON.stringify(options.data[key]));
          }
        }
      }
      config.data = formData;
    } else {
      config.data = options.data;
      config.transformRequest = [function (data, headers) {
        return (0, _tools.tranform2UrlEncode)(data);
      }];
    }
  }
  return (0, _axios2.default)(config).then(function (res) {
    if (options.loading) {
      _toast2.default.hide();
    }
    if (res.status == 200) {
      if (options.success) {
        options.success(res.data, res);
      }
    }
    if (options.complete) {
      options.complete(res.data, res);
    }
  }).catch(function (error) {
    if (options.loading) {
      _toast2.default.hide();
    }
    console.log('回调处理错误', error);
    if (options.error) {
      options.error(error);
    } else {
      console.log('网络故障');
    }
    if (options.complete) {
      options.complete();
    }
  });
}
/**
 * TODO
 * 要写一个拦截器，如果接口返回什么就要调到登录页面
 */

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(307);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(188);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(316);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(317);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(318);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(319);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(320);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _common = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeSet = function safeSet(object, path, value) {
  return object == null ? object : (0, _common.baseSet)(object, path, value);
};

function defineGetter(component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: function get() {
      if (getter === 'props') {
        return component.props;
      }
      return (0, _extends3.default)({}, component.props, component.state);
    }
  });
}

var CommonComponent = function (_React$Component) {
  (0, _inherits3.default)(CommonComponent, _React$Component);

  function CommonComponent(props) {
    (0, _classCallCheck3.default)(this, CommonComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommonComponent.__proto__ || Object.getPrototypeOf(CommonComponent)).call(this, props));

    _this.setData = function (obj, callback) {
      var state = Object.assign({}, _this.state);
      Object.keys(obj).forEach(function (key) {
        safeSet(state, key, obj[key]);
      });
      Object.assign(_this.state, state);
      _this.setState(state);
      setTimeout(function () {
        typeof callback == 'function' && callback();
      }, 0);
    };

    defineGetter(_this, 'data', 'state');
    return _this;
  }

  return CommonComponent;
}(_react2.default.Component);

exports.default = CommonComponent;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(169);
var isBuffer = __webpack_require__(264);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAppId = setAppId;
exports.getAppId = getAppId;
exports.checkIfLogin = checkIfLogin;

var _tools = __webpack_require__(6);

/**
 * 当前sessionStorage中即速应用appid的key
 */
var SPEED_APPID_KEY = 'jisuWebAppId';
/**
 * 获取当前sessionStorage中appid
 * @returns {string}
 */
/**
 * @file 全局方法
 * @description app全局方法
 */
function setAppId(value) {
  return sessionStorage.setItem(SPEED_APPID_KEY, value);
}
/**
 * 获取当前sessionStorage中appid
 * @returns {string}
 */
function getAppId() {
  return sessionStorage.getItem(SPEED_APPID_KEY);
}

/**
 * 获取当前appid
 * @returns {string}
 */
function checkIfLogin() {
  var appId = getAppId();
  return _tools.docCookies.getItem(appId + '_webappLogin') == 1;
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * 页面组件实例
 */
var pageInstance = null;
/**
 * 当前页面组件列表的ref
 */
var pageComponentRefs = [];
/**
 * 页面方法
 */
var pageMethod = {
  getCustomComponentData: function getCustomComponentData(index) {
    return pageInstance.state.eles[index];
  },
  setCustomComponentData: function setCustomComponentData(index, data) {
    var newData = {};
    newData['eles[' + index + ']'] = data;
    pageInstance.setData(newData);
  }
};
/**
 * 设置当前页面实例
 * @param {object} instance 
 */
var setPage = function setPage(instance) {
  exports.pageInstance = pageInstance = instance;
  exports.pageComponentRefs = pageComponentRefs = [];
};
exports.setPage = setPage;
exports.pageInstance = pageInstance;
exports.pageMethod = pageMethod;
exports.pageComponentRefs = pageComponentRefs;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(52);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _customComponentList = __webpack_require__(753);

var _customComponentList2 = _interopRequireDefault(_customComponentList);

__webpack_require__(934);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 提示当前组件正在开发中
 */
var DevelopCustomComponent = function DevelopCustomComponent() {
  return _react2.default.createElement(
    'div',
    { className: 'custom-component develop' },
    '\u8BE5\u7EC4\u4EF6\u4EC5\u652F\u6301\u5C0F\u7A0B\u5E8F\u7AEF\u67E5\u770B'
  );
};
/**
 * 不显示组件数据
 */
var hiddenCustomComponentList = {
  // 旧版个人中心组件
  'user-center': true,
  // 旧版底部导航组件
  'bottom-nav': true

  /**
   * @desc {showToast} 点击图片给的提示语 
   */
};var showToast = function showToast() {
  _toast2.default.info('仅为预览图效果，实际功能请在小程序端体验');
};
/**
 * 定义对应组件的 图片路径 替换 DevelopCustomComponent 组件
 */
var UnDoFuncComponent = function UnDoFuncComponent(props) {
  return _react2.default.createElement(
    'div',
    { className: 'custom-component', onClick: showToast },
    _react2.default.createElement('img', { className: 'unDoFuncImg', src: props.url, alt: '' })
  );
};
var showPicObj = {
  'live': function live(props) {
    // 直播
    var mode = props.data.customFeature.mode || 1;
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/live-mode' + mode + '.png';
  },
  'video-list-tiktok': function videoListTiktok(props) {
    // 抖音视频 
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/tiktok.png';
  },
  'times-card': function timesCard(props) {
    // 服务卡
    var _props$data$customFea = props.data.customFeature,
        card_type = _props$data$customFea.card_type,
        TCType = _props$data$customFea.TCType;

    var type = '1';
    if (card_type === 0 && TCType === 2) {
      // 次卡 样式1
      type = '1';
    } else if (card_type === 0 && TCType === 1) {
      // 次卡 样式2
      type = '2';
    } else if (card_type === 2 && TCType === 2) {
      // 充值卡 样式1
      type = '3';
    } else if (card_type === 2 && TCType === 1) {
      // 充值卡 样式2
      type = '4';
    }
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/time-card-mode' + type + '.png';
  },
  'shopping-card-list': function shoppingCardList(props) {
    // 购物卡
    var mode = props.data.customFeature.mode || 0;
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/shopping-card-mode' + mode + '.png';
  },
  'gift-card-list': function giftCardList(props) {
    // 礼品卡 同上
    var mode = props.data.customFeature.mode || 0;
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/shopping-card-mode' + mode + '.png';
  },
  'dynamic-navigation': function dynamicNavigation(props) {
    // 分类导航
    var mode = props.data.customFeature.mode || 0;
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/dynamic-navigation-mode' + mode + '.png';
  },
  'customer-service': function customerService(props) {
    // 智能回复
    return 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/customer-service.png';
  }
};

function CustomComponent(props) {
  if (props.data.hidden) {
    return null;
  }
  // 组件类型
  var type = props.data.type;
  // 当前组件不存在类型字段
  if (!type) {
    return null;
  }
  if (_customComponentList2.default[type]) {
    // 已开发组件
    var forwardedRef = props.forwardedRef,
        rest = (0, _objectWithoutProperties3.default)(props, ['forwardedRef']);

    return _customComponentList2.default[type](rest, forwardedRef);
  } else if (hiddenCustomComponentList[type]) {
    // 不显示组件
    return null;
  } else {
    // 用图片替换之前的文案 不需要处理的要过滤掉
    return _react2.default.createElement(UnDoFuncComponent, { url: showPicObj[type] && showPicObj[type](props) });
  }
}

exports.default = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(CustomComponent, (0, _extends3.default)({}, props, { forwardedRef: ref }));
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(52);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.LoadingBtn = LoadingBtn;

__webpack_require__(760);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LoadingBtn(props) {
  var customFeature = props.customFeature,
      rest = (0, _objectWithoutProperties3.default)(props, ['customFeature']);
  var loadingStyle = customFeature.loadingStyle,
      loadingImg = customFeature.loadingImg,
      loadingColor = customFeature.loadingColor,
      loadingText = customFeature.loadingText;

  return React.createElement(
    'div',
    (0, _extends3.default)({ className: 'common loading-btn' }, rest),
    loadingStyle == 'img' && React.createElement('img', { src: loadingImg }),
    loadingStyle == 'text' && React.createElement(
      'span',
      { style: {
          color: loadingColor
        } },
      loadingText
    )
  );
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var core = __webpack_require__(24);
var ctx = __webpack_require__(62);
var hide = __webpack_require__(56);
var has = __webpack_require__(57);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(304);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _ListItem = __webpack_require__(297);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var List = function (_React$Component) {
    (0, _inherits3['default'])(List, _React$Component);

    function List() {
        (0, _classCallCheck3['default'])(this, List);
        return (0, _possibleConstructorReturn3['default'])(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
    }

    (0, _createClass3['default'])(List, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                children = _a.children,
                className = _a.className,
                style = _a.style,
                renderHeader = _a.renderHeader,
                renderFooter = _a.renderFooter,
                restProps = __rest(_a, ["prefixCls", "children", "className", "style", "renderHeader", "renderFooter"]);
            var wrapCls = (0, _classnames2['default'])(prefixCls, className);
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls, style: style }, restProps),
                renderHeader ? React.createElement(
                    'div',
                    { className: prefixCls + '-header' },
                    typeof renderHeader === 'function' ? renderHeader() : renderHeader
                ) : null,
                children ? React.createElement(
                    'div',
                    { className: prefixCls + '-body' },
                    children
                ) : null,
                renderFooter ? React.createElement(
                    'div',
                    { className: prefixCls + '-footer' },
                    typeof renderFooter === 'function' ? renderFooter() : renderFooter
                ) : null
            );
        }
    }]);
    return List;
}(React.Component);

exports['default'] = List;

List.Item = _ListItem2['default'];
List.defaultProps = {
    prefixCls: 'am-list'
};
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(48);
var IE8_DOM_DEFINE = __webpack_require__(157);
var toPrimitive = __webpack_require__(109);
var dP = Object.defineProperty;

exports.f = __webpack_require__(51) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(63)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
// CONCATENATED MODULE: ./node_modules/resolve-pathname/esm/resolve-pathname.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ var resolve_pathname = (resolvePathname);

// CONCATENATED MODULE: ./node_modules/value-equal/esm/value-equal.js
function value_equal_valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = value_equal_valueOf(a);
    var bValue = value_equal_valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ var value_equal = (valueEqual);

// CONCATENATED MODULE: ./node_modules/tiny-warning/dist/tiny-warning.esm.js
var isProduction = "production" === 'production';
function tiny_warning_esm_warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ var tiny_warning_esm = (tiny_warning_esm_warning);

// CONCATENATED MODULE: ./node_modules/tiny-invariant/dist/tiny-invariant.esm.js
var tiny_invariant_esm_isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function tiny_invariant_esm_invariant(condition, message) {
    if (condition) {
        return;
    }
    if (tiny_invariant_esm_isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}



// CONCATENATED MODULE: ./node_modules/history/esm/history.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBrowserHistory", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHashHistory", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLocation", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "locationsAreEqual", function() { return locationsAreEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parsePath", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPath", function() { return createPath; });






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && value_equal(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : tiny_invariant_esm_invariant(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : tiny_invariant_esm_invariant(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(50);
var createDesc = __webpack_require__(72);
module.exports = __webpack_require__(51) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(159);
var defined = __webpack_require__(110);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(146), __webpack_require__(147));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var toSJISFunction
var CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  var digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var VersionCheck = __webpack_require__(209)
var Regex = __webpack_require__(210)

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(85);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(16);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rmc-feedback/es/TouchFeedback.js








var TouchFeedback_TouchFeedback = function (_React$Component) {
    inherits_default()(TouchFeedback, _React$Component);

    function TouchFeedback() {
        classCallCheck_default()(this, TouchFeedback);

        var _this = possibleConstructorReturn_default()(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));

        _this.state = {
            active: false
        };
        _this.onTouchStart = function (e) {
            _this.triggerEvent('TouchStart', true, e);
        };
        _this.onTouchMove = function (e) {
            _this.triggerEvent('TouchMove', false, e);
        };
        _this.onTouchEnd = function (e) {
            _this.triggerEvent('TouchEnd', false, e);
        };
        _this.onTouchCancel = function (e) {
            _this.triggerEvent('TouchCancel', false, e);
        };
        _this.onMouseDown = function (e) {
            // pc simulate mobile
            _this.triggerEvent('MouseDown', true, e);
        };
        _this.onMouseUp = function (e) {
            _this.triggerEvent('MouseUp', false, e);
        };
        _this.onMouseLeave = function (e) {
            _this.triggerEvent('MouseLeave', false, e);
        };
        return _this;
    }

    createClass_default()(TouchFeedback, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.disabled && this.state.active) {
                this.setState({
                    active: false
                });
            }
        }
    }, {
        key: 'triggerEvent',
        value: function triggerEvent(type, isActive, ev) {
            var eventType = 'on' + type;
            var children = this.props.children;

            if (children.props[eventType]) {
                children.props[eventType](ev);
            }
            if (isActive !== this.state.active) {
                this.setState({
                    active: isActive
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                disabled = _props.disabled,
                activeClassName = _props.activeClassName,
                activeStyle = _props.activeStyle;

            var events = disabled ? undefined : {
                onTouchStart: this.onTouchStart,
                onTouchMove: this.onTouchMove,
                onTouchEnd: this.onTouchEnd,
                onTouchCancel: this.onTouchCancel,
                onMouseDown: this.onMouseDown,
                onMouseUp: this.onMouseUp,
                onMouseLeave: this.onMouseLeave
            };
            var child = external__React__default.a.Children.only(children);
            if (!disabled && this.state.active) {
                var _child$props = child.props,
                    style = _child$props.style,
                    className = _child$props.className;

                if (activeStyle !== false) {
                    if (activeStyle) {
                        style = extends_default()({}, style, activeStyle);
                    }
                    className = classnames_default()(className, activeClassName);
                }
                return external__React__default.a.cloneElement(child, extends_default()({ className: className,
                    style: style }, events));
            }
            return external__React__default.a.cloneElement(child, events);
        }
    }]);

    return TouchFeedback;
}(external__React__default.a.Component);

/* harmony default export */ var es_TouchFeedback = (TouchFeedback_TouchFeedback);

TouchFeedback_TouchFeedback.defaultProps = {
    disabled: false
};
// CONCATENATED MODULE: ./node_modules/rmc-feedback/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return es_TouchFeedback; });


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemberDiscount = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _ScrollView = __webpack_require__(11);

__webpack_require__(434);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberDiscount = exports.MemberDiscount = function (_CommonComponent) {
  (0, _inherits3.default)(MemberDiscount, _CommonComponent);

  function MemberDiscount(props) {
    (0, _classCallCheck3.default)(this, MemberDiscount);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MemberDiscount.__proto__ || Object.getPrototypeOf(MemberDiscount)).call(this, props));

    _this2.show = function (options) {
      var discountType = options.discountType,
          franchisee = options.franchisee,
          afterSelectedDiscount = options.afterSelectedDiscount;


      _this2.setData({
        discountType: discountType,
        franchisee: franchisee
      });
      _this2.afterSelectedDiscount = afterSelectedDiscount;
    };

    _this2.showDialog = function (selectedDiscount) {
      var franchisee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      _this2.getAppECStoreConfig();
      var discountType = selectedDiscount.discount_type;
      var currentDiscount = _this2.data.currentDiscount;
      var currentTab = _this2.data.currentTab;
      var num = 0;

      if (!discountType) {
        var discount_type = '';
        _this2.data.discountType.map(function (val) {
          if (val.value.length > 0) {
            discount_type = val.label;
            num++;
          }
        });
        _this2.setData({
          isVisibled: true,
          selectedDiscount: {
            discount_type: discount_type,
            franchisee: franchisee
          },
          currentTab: discount_type,
          currentDiscount: {
            type: '',
            index: 0
          },
          isShowTarbar: num !== 1
        });
        return;
      }
      _this2.data.discountType.map(function (val) {
        if (val.label === discountType || val.label === 'vip' && discountType === 'paid_vip' || val.label === 'vip' && discountType === 'vip_benefit_day') {
          if (selectedDiscount.no_use_benefit === 1) {
            currentDiscount = {
              type: '',
              index: 0
            };
            currentTab = discountType;
            return;
          }
          if (discountType === 'coupon') {
            val.value.forEach(function (item, index) {
              if (item.coupon_id == selectedDiscount.coupon_id) {
                currentDiscount = {
                  type: 'coupon',
                  index: index
                };
              }
            });
            currentTab = 'coupon';
          } else if (discountType === 'vip' || discountType === 'paid_vip' || discountType === 'vip_benefit_day') {
            val.value.forEach(function (item, index) {
              if (item.vip_id == selectedDiscount.vip_id && item.discount_type == selectedDiscount.discount_type) {
                currentDiscount = {
                  type: 'vip',
                  index: index
                };
                currentTab = 'vip';
              }
            });
          } else if (discountType === 'integral') {
            currentDiscount = {
              type: 'integral',
              index: 0
            };
            currentTab = 'integral';
          }
        }
        if (val.value instanceof Array && val.value.length > 0) {
          num++;
        }
      });
      _this2.tipNameInit();
      _this2.setData({
        isVisibled: true,
        selectedDiscount: selectedDiscount,
        currentDiscount: currentDiscount,
        currentTab: currentTab,
        isShowTarbar: num !== 1
      });
    };

    _this2.tipNameInit = function () {
      var tipName = [];
      _this2.data.discountType.map(function (val) {
        if (val.label === 'coupon' && val.value.length) {
          tipName.push('优惠券');
        } else if (val.label === 'vip' && val.value.length) {
          tipName.push('会员卡');
        } else if (val.label === 'integral' && val.value.length) {
          tipName.push('积分');
        }
      });
      _this2.setData({
        tipName: tipName.length > 1 ? tipName.join('、') : ''
      });
    };

    _this2.selectedDiscount = function (e) {
      var type = e.currentTarget.dataset.type;
      var index = +e.currentTarget.dataset.index;
      var disabled = e.currentTarget.dataset.disabled || false;
      var selectedDiscount = _this2.data.selectedDiscount;
      var currentDiscount = _this2.data.currentDiscount;
      if (disabled) {
        return;
      }

      _this2.data.discountType.map(function (val) {
        if (val.label === type) {
          if (type === currentDiscount.type && index === currentDiscount.index) {
            // 反选不使用优惠
            if (selectedDiscount.type === 'combine') {
              selectedDiscount.no_use_benefit = 1;
            } else {
              selectedDiscount = {
                title: "不使用优惠",
                name: '无',
                no_use_benefit: 1
              };
            }
            currentDiscount = {
              type: '',
              index: 0
            };
          } else {
            if (selectedDiscount.type === 'combine') {
              selectedDiscount.no_use_benefit = 0;
              selectedDiscount.discount_type === 'coupon' ? selectedDiscount.coupon_id = val.value[index].coupon_id : '';
              if (selectedDiscount.discount_type === 'vip' || selectedDiscount.discount_type === 'paid_vip' || selectedDiscount.discount_type === 'vip_benefit_day') {
                selectedDiscount.discount_type = val.value[index].discount_type;
                selectedDiscount.vip_id = val.value[index].vip_id;
              }
            } else {
              selectedDiscount = val.value[index];
            }
            currentDiscount = {
              type: type,
              index: index
            };
          }

          _this2.setData({
            selectedDiscount: selectedDiscount,
            currentDiscount: currentDiscount
          });
        }
      });

      _this2.afterSelectedDiscount && _this2.afterSelectedDiscount({ selectedDiscount: selectedDiscount });

      _this2.setData({
        isVisibled: false
      });
    };

    _this2.hiddenDialog = function (e) {
      _this2.setData({
        isVisibled: false
      });
    };

    _this2.noUseDiscount = function () {
      var selectedDiscount = _this2.data.selectedDiscount;
      if (selectedDiscount.type === 'combine') {
        selectedDiscount.no_use_benefit = 1;
      } else {
        selectedDiscount = {
          title: "不使用优惠",
          name: '无',
          no_use_benefit: 1
        };
      }
      _this2.setData({
        selectedDiscount: selectedDiscount,
        currentDiscount: {
          type: '',
          index: 0
        },
        isVisibled: false
      });
      _this2.afterSelectedDiscount && _this2.afterSelectedDiscount({ selectedDiscount: selectedDiscount });
    };

    _this2.checkType = function (e) {
      e.stopPropagation();
      var label = e.currentTarget.dataset.label;

      _this2.setData({
        currentTab: label
      });
    };

    _this2.isShowTipChange = function () {
      _this2.setData({ isShowTip: false });
    };

    _this2.getVipCardInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPInfo',
        data: {
          sub_shop_app_id: _this.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var discountType = _this.data.discountType;
          discountType.map(function (val) {
            if (val.label === 'vip') {
              // val.value[0].logo = res.data.logo
            }
          });
          _this.setData({
            discountType: discountType
          });
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          themeColor: res.color_config.theme
        });
      }, _this2.data.franchiseeId);
    };

    _this2.options = _this2.props.options;

    _this2.state = {
      discountType: [{ // 优惠类型+优惠对应的数据 默认全部开启 value是优惠列表数据
        label: 'coupon',
        value: []
      }, {
        label: 'vip',
        value: []
      }, {
        label: 'integral',
        value: []
      }],
      isVisibled: false, // 弹窗开关
      isShowTip: true, // 是否显示提示语 默认开启
      tipName: '', // 提示语
      selectedDiscount: {}, // 选中的优惠
      currentDiscount: { // 当前选中优惠的类型和下标
        type: '',
        index: 0
      },
      themeColor: {
        type: '',
        value: ''
      },
      isShowTarbar: true,
      currentTab: '', // 当前选中的tab
      franchisee: '', //子店ID
      appLogo: _app.appMethod.globalData.appLogo
    };
    return _this2;
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一致


  // 选择优惠


  // 不使用优惠


  // 导航选择


  // 获取用户会员卡信息


  (0, _createClass3.default)(MemberDiscount, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          isVisibled = _state.isVisibled,
          selectedDiscount = _state.selectedDiscount,
          isShowTip = _state.isShowTip,
          tipName = _state.tipName,
          themeColor = _state.themeColor,
          isShowTarbar = _state.isShowTarbar,
          currentTab = _state.currentTab,
          discountType = _state.discountType,
          currentDiscount = _state.currentDiscount,
          appLogo = _state.appLogo;


      if (!isVisibled) {
        return null;
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'common-component member-discount' },
          isVisibled && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'discount-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                _react2.default.createElement(
                  'span',
                  { className: 'title-text' },
                  '\u8BF7\u9009\u62E9',
                  selectedDiscount.type !== 'combine' ? '会员优惠' : selectedDiscount.discount_type === 'vip' || selectedDiscount.discount_type === 'paid_vip' || selectedDiscount.discount_type === 'vip_benefit_day' ? '会员卡优惠' : selectedDiscount.discount_type === 'coupon' ? '优惠券优惠' : selectedDiscount.discount_type === 'integral' ? '积分优惠' : '会员优惠'
                ),
                _react2.default.createElement('div', { className: 'ico-moon icon-closes', onClick: this.hiddenDialog })
              ),
              isShowTip && tipName !== '' && _react2.default.createElement(
                'div',
                { className: 'tip-mess', style: { color: themeColor, backgroundColor: themeColor + '33' } },
                _react2.default.createElement('span', { className: 'ico-moon icon-remind' }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u53EA\u80FD\u9009\u7528\u4F1A\u5458\u5361\u6216\u4F18\u60E0\u5238\u5176\u4E2D\u4E00\u79CD\uFF0C\u4F5C\u4E3A\u4F1A\u5458\u4F18\u60E0\u4F7F\u7528\u3002'
                ),
                _react2.default.createElement('div', { className: 'ico-moon icon-closes', onClick: this.isShowTipChange })
              ),
              _react2.default.createElement(
                'div',
                { className: 'tab' },
                isShowTarbar && _react2.default.createElement(
                  'div',
                  { className: 'tab-bar' },
                  discountType.length > 0 && discountType.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'tab-item ' + (item.label === currentTab ? 'active' : ''), key: item.label, hidden: item.value.length < 1, 'data-label': item.label, onClick: _this3.checkType },
                      _react2.default.createElement(
                        'span',
                        { className: 'tab-item-text', style: item.label === currentTab ? { color: themeColor, borderColor: themeColor } : {} },
                        item.label === 'coupon' ? '优惠券' : item.label === 'vip' ? '会员卡' : item.label === 'integral' ? '积分' : ''
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  _ScrollView.ScrollView,
                  { 'scroll-y': 'true', className: 'my-coupon my-discount', hidden: currentTab !== 'coupon' },
                  discountType.map(function (type, typeIndex) {
                    return type.label === 'coupon' && _react2.default.createElement(
                      'div',
                      { key: typeIndex },
                      type.value.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'coupon-item', key: index, style: { borderTop: '.08rem solid ' + (currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#d9d9d9') }, 'data-type': 'coupon', 'data-index': index, 'data-disabled': item.disabled, onClick: _this3.selectedDiscount },
                          _react2.default.createElement(
                            'div',
                            { className: 'info', style: { color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#666' : '#ccc' } },
                            _react2.default.createElement(
                              'div',
                              { className: 'coupon-title text-overflow', style: { color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#333' : '#ccc' } },
                              item.title
                            ),
                            item.type == 0 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u4F7F\u7528\u6761\u4EF6\uFF1A\u6EE1',
                              item.condition,
                              '\u5143\uFF0C\u51CF',
                              item.value,
                              '\u5143'
                            ),
                            item.type == 1 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u4F7F\u7528\u6761\u4EF6: \u6253',
                              item.value,
                              '\u6298'
                            ),
                            item.type == 2 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u4F7F\u7528\u6761\u4EF6\uFF1A\u53EF\u62B5\u6263',
                              item.value,
                              '\u5143'
                            ),
                            item.type == 3 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              item.extra_condition == '' ? _react2.default.createElement(
                                'span',
                                null,
                                '\u4F7F\u7528\u6761\u4EF6: \u76F4\u63A5\u5151\u6362',
                                item.coupon_goods_info && item.coupon_goods_info.title,
                                ' '
                              ) : item.extra_condition.price ? _react2.default.createElement(
                                'span',
                                null,
                                '\u4F7F\u7528\u6761\u4EF6: \u6D88\u8D39\u6EE1',
                                item.extra_condition && item.extra_condition.price,
                                '\u5143\u53EF\u5151\u6362',
                                item.coupon_goods_info && item.coupon_goods_info.title
                              ) : item.extra_condition.goods_id ? _react2.default.createElement(
                                'span',
                                null,
                                '\u4F7F\u7528\u6761\u4EF6: \u8D2D\u4E70',
                                item.condition_goods_info && item.condition_goods_info.title,
                                '\u53EF\u5151\u6362',
                                item.coupon_goods_info && item.coupon_goods_info.title
                              ) : ''
                            ),
                            item.type == 4 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u4F7F\u7528\u6761\u4EF6: \u50A8\u503C\u91D1\u53EF\u5145\u503C',
                              item.value,
                              '\u5143'
                            ),
                            item.type == 5 && _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u4F7F\u7528\u6761\u4EF6: ',
                              item.extra_condition
                            ),
                            currentDiscount.type === 'coupon' && currentDiscount.index === index && _react2.default.createElement('div', { className: 'ico-moon icon-success-tip' }),
                            !(currentDiscount.type === 'coupon' && currentDiscount.index === index) && _react2.default.createElement('div', { className: 'icon-no-use' }),
                            _react2.default.createElement(
                              'div',
                              { className: 'background-word-area', style: { border: '2rpx solid ' + (currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc') } },
                              _react2.default.createElement('div', { className: 'background-circle', style: { background: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc' } }),
                              item.type == 0 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u51CF'
                              ),
                              item.type == 1 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u6298'
                              ),
                              item.type == 2 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u4EE3'
                              ),
                              item.type == 3 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u5151'
                              ),
                              item.type == 4 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u50A8'
                              ),
                              item.type == 5 && _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u901A'
                              )
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'time-block' },
                              _react2.default.createElement(
                                'div',
                                { className: 'effective-time', style: { color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#999' : '#ccc' } },
                                item.active_title
                              ),
                              !item.disabled && item.expire_day_count && _react2.default.createElement(
                                'div',
                                { className: 'maturity-time', style: { color: currentDiscount.type === 'coupon' && currentDiscount.index === index ? '#FF4D65' : '#ccc' } },
                                item.expire_day_count,
                                '\u5929\u540E\u5373\u5C06\u8FC7\u671F '
                              ),
                              item.disabled && _react2.default.createElement(
                                'div',
                                { className: 'disabled-text', style: { color: themeColor } },
                                item.cant_use_reason
                              )
                            )
                          )
                        );
                      }),
                      type.value.length === 0 && _react2.default.createElement(
                        'div',
                        { className: 'empty' },
                        _react2.default.createElement('img', { src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png' }),
                        '\u6682\u65E0\u4EFB\u4F55\u6570\u636E'
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  _ScrollView.ScrollView,
                  { 'scroll-y': 'true', className: 'my-card my-discount', hidden: currentTab !== 'vip' },
                  discountType.map(function (type, typeIndex) {
                    return type.label === 'vip' && _react2.default.createElement(
                      'div',
                      { key: typeIndex },
                      type.value.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'card-item', key: index, 'data-type': 'vip', 'data-index': index, onClick: _this3.selectedDiscount, style: { backgroundImage: "url('http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-default.png')" } },
                          _react2.default.createElement(
                            'div',
                            { className: 'card-img-block', style: { border: '6rpx solid ' + (item.logo ? '#ffc790' : '#fff') } },
                            item.logo ? _react2.default.createElement('img', { className: 'card-img', src: item.logo }) : _react2.default.createElement('img', { className: 'app-logo-img', src: appLogo })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'card-info' },
                            _react2.default.createElement(
                              'div',
                              { className: 'card-name text-overflow' },
                              item.app_name + ' ' + item.name,
                              ' '
                            ),
                            item.discount != 0 && _react2.default.createElement(
                              'div',
                              { className: 'card-mess text-overflow' },
                              '\u53EF\u4EAB ',
                              item.discount,
                              '\u6298'
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'card-btn' },
                            currentDiscount.type === 'vip' && currentDiscount.index === index ? '使用中' : '立即使用'
                          )
                        );
                      }),
                      type.value.length === 0 && _react2.default.createElement(
                        'div',
                        { className: 'empty' },
                        _react2.default.createElement('img', { src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png' }),
                        '\u6682\u65E0\u4EFB\u4F55\u6570\u636E'
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  _ScrollView.ScrollView,
                  { 'scroll-y': 'true', className: 'my-integral my-discount', hidden: currentTab !== 'integral' },
                  discountType.map(function (type, typeIndex) {
                    return type.label === 'integral' && _react2.default.createElement(
                      'div',
                      { key: typeIndex },
                      type.value.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'integral-item', key: index, style: { borderTop: '8rpx solid ' + (currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#d9d9d9') }, 'data-type': 'integral', 'data-index': index, onClick: _this3.selectedDiscount },
                          _react2.default.createElement(
                            'div',
                            { className: 'info', style: { color: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#333' : '#ccc' } },
                            _react2.default.createElement(
                              'div',
                              { className: 'integral-title' },
                              '\u79EF\u5206\u62B5\u6263 ',
                              _react2.default.createElement(
                                'span',
                                { className: 'red-text', style: { color: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc' } },
                                item.max_can_use_integral,
                                '\u79EF\u5206\u53EF\u7528'
                              )
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'use-condition' },
                              '\u79EF\u5206\u4F7F\u7528 : 100\u79EF\u5206 \u62B51\u5143'
                            ),
                            currentDiscount.type === 'integral' && currentDiscount.index === index && _react2.default.createElement('div', { className: 'ico-moon icon-success-tip' }),
                            !(currentDiscount.type === 'integral' && currentDiscount.index === index) && _react2.default.createElement('div', { className: 'icon-no-use' }),
                            _react2.default.createElement(
                              'div',
                              { className: 'background-word-area', style: { border: '2rpx solid ' + (currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc') } },
                              _react2.default.createElement('div', { className: 'background-circle', style: { background: currentDiscount.type === 'integral' && currentDiscount.index === index ? '#FF4D65' : '#ccc' } }),
                              _react2.default.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u79EF'
                              )
                            )
                          )
                        );
                      }),
                      type.value.length === 0 && _react2.default.createElement(
                        'div',
                        { className: 'empty' },
                        _react2.default.createElement('img', { src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/empty.png' }),
                        '\u6682\u65E0\u4EFB\u4F55\u6570\u636E'
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'no-use-btn', onClick: this.noUseDiscount },
                  '\u4E0D\u4F7F\u7528\u8BE5\u4F18\u60E0'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return MemberDiscount;
}(_CommonComponent3.default);

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class Scratch
 * @class
 * @classdesc 九宫格翻纸牌组件逻辑部分
 * @author pfan
 * @todo 1.drawImage 与 clearRect 清除展示移动端和模拟器不一致
 * @todo 2.小程序无globalCompositeOperation = 'destination-out'属性
 * @todo 3.小程序无getImageData获取像素点对比擦除范围
 * @todo 4.使用 downloadFile 这种方式来先加载图片再绘制
 * 
 * @example
 *  new Scratch(this,{
 *    canvasWidth: 197,   //画布宽带
 *    canvasHeight: 72,  //画布高度
 *    imageResource: './images/placeholder.png', //遮罩层图片
 *    r: 4, //笔触半径
 *    awardTxt: '中大奖', //底部抽奖文字奖项
 *    awardTxtColor: "#1AAD16", //底部抽奖文字颜色
 *    awardTxtFontSize: "24px", //底部抽奖文字大小
 *    maskColor: "red",  //没有图片遮罩层颜色
 *    callback: () => {
 *      //清除画布回调
 *    }
 *  })
 */
var Scratch = function () {

  /**
  * @constructs Scratch构造函数
  * @param  {Object} pageContext page路由指针
  * @param  {Object} opts      组件所需参数
  * @param  {Number} opts.canvasWidth  画布宽带
  * @param  {Number} opts.canvasHeight  画布高度
  * @param  {String} opts.imageResource  遮罩层图片
  * @param  {Number} opts.r    笔触半径
  * @param  {String} opts.awardTxt    底部抽奖文字奖项
  * @param  {String} opts.awardTxtColor    底部抽奖文字颜色
  * @param  {String} opts.awardTxtFontSize    底部抽奖文字大小
  * @param  {String} opts.maskColor     没有图片遮罩层颜色
  * @param  {Function} opts.callback    结束回调
  */
  function Scratch(pageContext, opts) {
    (0, _classCallCheck3.default)(this, Scratch);

    this.page = pageContext;
    this.canvasWidth = opts.canvasWidth;
    this.canvasHeight = opts.canvasHeight;
    this.imageResource = opts.imageResource;
    this.maskColor = opts.maskColor;
    // this.canvasId = opts.canvasId
    this.r = opts.r || 4;
    this.endCallBack = opts.callback;
    this.imgLoadCallback = opts.imgLoadCallback;
    this.lastX = 0;
    this.lastY = 0;
    this.minX = '';
    this.minY = '';
    this.maxX = '';
    this.maxY = '';
    this.isStart = false;
    this.init();

    this.page.touchStart = this.touchStart.bind(this);
    this.page.touchMove = this.touchMove.bind(this);
    this.page.touchEnd = this.touchEnd.bind(this);
    this.page.imgOnLoad = this.imgOnLoad.bind(this);

    this.page.setData({
      scratch: {
        "awardTxt": opts.awardTxt,
        "awardTxtColor": opts.awardTxtColor,
        "awardTxtFontSize": opts.awardTxtFontSize,
        "awardTxtLineHeight": opts.canvasHeight,
        "width": opts.canvasWidth,
        "height": opts.canvasHeight,
        "imageResource": opts.imageResource
      },
      "isScroll": true
    });
  }

  (0, _createClass3.default)(Scratch, [{
    key: 'init',
    value: function init() {
      var canvasWidth = this.canvasWidth,
          canvasHeight = this.canvasHeight,
          imageResource = this.imageResource,
          maskColor = this.maskColor;

      var self = this;
      var canvas = document.getElementById('scratch-canvas');
      if (!canvas) {
        return;
      }
      this.ctx = canvas.getContext('2d');
      this.ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      if (imageResource && imageResource != '') {
        var img = new Image();
        img.src = imageResource;
        img.onload = function () {
          self.ctx.drawImage(img, 0, 0, canvasWidth, canvasHeight);
          // self.ctx.draw();
          self.imgLoadCallback && self.imgLoadCallback();
        };
      } else {
        self.ctx.fillStyle = maskColor;
        self.ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        // self.ctx.draw()   
      }
    }
  }, {
    key: 'drawRect',
    value: function drawRect(x, y) {
      var r = this.r,
          canvasWidth = this.canvasWidth,
          canvasHeight = this.canvasHeight,
          lastX = this.lastX,
          lastY = this.lastY,
          minX = this.minX,
          minY = this.minY,
          maxX = this.maxX,
          maxY = this.maxY;

      var x1 = x - r > 0 ? x - r : 0;
      var y1 = y - r > 0 ? y - r : 0;
      if ('' !== minX) {
        this.minX = minX > x1 ? x1 : minX;
        this.minY = minY > y1 ? y1 : minY;
        this.maxX = maxX > x1 ? maxX : x1;
        this.maxY = maxY > y1 ? maxY : y1;
      } else {
        this.minX = x1;
        this.minY = y1;
        this.maxX = x1;
        this.maxY = y1;
      }
      this.lastX = x1;
      this.lastY = y1;

      return [x1, y1, 2 * r];
    }
  }, {
    key: 'start',
    value: function start() {
      this.isStart = true;
      this.page.setData({
        "isScroll": false
      });
    }
  }, {
    key: 'restart',
    value: function restart() {
      this.init();
      this.lastX = 0;
      this.lastY = 0;
      this.minX = '';
      this.minY = '';
      this.maxX = '';
      this.maxY = '';
      this.isStart = true;
      this.page.setData({
        "isScroll": false
      });
    }
  }, {
    key: 'touchStart',
    value: function touchStart(e) {
      if (!this.isStart) return;
      var canvas = document.getElementById('scratch-canvas');
      if (!canvas) {
        return;
      }
      var canvasX = this.canvasX || canvas.getBoundingClientRect().left;
      var canvasY = this.canvasY || canvas.getBoundingClientRect().top;
      var x = e.touches[0].clientX - canvasX;
      var y = e.touches[0].clientY - canvasY;
      var pos = this.drawRect(x, y);
      this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      // this.ctx.draw(true)
    }
  }, {
    key: 'touchMove',
    value: function touchMove(e) {
      if (!this.isStart) return;
      var canvas = document.getElementById('scratch-canvas');
      var canvasX = this.canvasX || canvas.getBoundingClientRect().left;
      var canvasY = this.canvasY || canvas.getBoundingClientRect().top;
      var x = e.touches[0].clientX - canvasX;
      var y = e.touches[0].clientY - canvasY;
      var pos = this.drawRect(x, y);
      this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      // this.ctx.draw(true)
    }
  }, {
    key: 'touchEnd',
    value: function touchEnd(e) {
      if (!this.isStart) return;
      //自动清楚采用点范围值方式判断
      var canvasWidth = this.canvasWidth,
          canvasHeight = this.canvasHeight,
          minX = this.minX,
          minY = this.minY,
          maxX = this.maxX,
          maxY = this.maxY;

      if (maxX - minX > .5 * canvasWidth && maxY - minY > .5 * canvasHeight) {
        // this.ctx.draw() 
        this.endCallBack && this.endCallBack();
        this.isStart = false;
        this.page.setData({
          "isScroll": true
        });
      }
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.init();
      this.lastX = 0;
      this.lastY = 0;
      this.minX = '';
      this.minY = '';
      this.maxX = '';
      this.maxY = '';
      this.isStart = false;
    }
  }, {
    key: 'imgOnLoad',
    value: function imgOnLoad() {}
  }]);
  return Scratch;
}();

exports.default = Scratch;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Implementation of a subset of node.js Buffer methods for the browser.
 * Based on https://github.com/feross/buffer
 */

/* eslint-disable no-proto */



var isArray = __webpack_require__(71)

function typedArraySupport () {
  // Can typed array instances be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

var K_MAX_LENGTH = Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff

function Buffer (arg, offset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, offset, length)
  }

  if (typeof arg === 'number') {
    return allocUnsafe(this, arg)
  }

  return from(this, arg, offset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array

  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    })
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

function createBuffer (that, length) {
  var buf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    buf = new Uint8Array(length)
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = that
    if (buf === null) {
      buf = new Buffer(length)
    }
    buf.length = length
  }

  return buf
}

function allocUnsafe (that, size) {
  var buf = createBuffer(that, size < 0 ? 0 : checked(size) | 0)

  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      buf[i] = 0
    }
  }

  return buf
}

function fromString (that, string) {
  var length = byteLength(string) | 0
  var buf = createBuffer(that, length)

  var actual = buf.write(string)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (that, array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    buf.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    buf = fromArrayLike(that, buf)
  }

  return buf
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(that, len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function byteLength (string) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  return utf8ToBytes(string).length
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function from (that, value, offset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, offset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, offset)
  }

  return fromObject(that, value)
}

Buffer.prototype.write = function write (string, offset, length) {
  // Buffer#write(string)
  if (offset === undefined) {
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
    } else {
      length = undefined
    }
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  return utf8Write(this, string, offset, length)
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

Buffer.prototype.fill = function fill (val, start, end) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : new Buffer(val)
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return createBuffer(null, 0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = allocUnsafe(null, length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

Buffer.byteLength = byteLength

Buffer.prototype._isBuffer = true
Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

module.exports.alloc = function (size) {
  var buffer = new Buffer(size)
  buffer.fill(0)
  return buffer
}

module.exports.from = function (data) {
  return new Buffer(data)
}


/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 73 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(110);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alert = __webpack_require__(227);

var _alert2 = _interopRequireDefault(_alert);

var _Modal = __webpack_require__(89);

var _Modal2 = _interopRequireDefault(_Modal);

var _operation = __webpack_require__(253);

var _operation2 = _interopRequireDefault(_operation);

var _prompt = __webpack_require__(254);

var _prompt2 = _interopRequireDefault(_prompt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Modal2['default'].alert = _alert2['default'];
_Modal2['default'].prompt = _prompt2['default'];
_Modal2['default'].operation = _operation2['default'];
exports['default'] = _Modal2['default'];
module.exports = exports['default'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(230)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(161)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(259);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Radio = __webpack_require__(194);

var _Radio2 = _interopRequireDefault(_Radio);

var _RadioItem = __webpack_require__(393);

var _RadioItem2 = _interopRequireDefault(_RadioItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Radio2['default'].RadioItem = _RadioItem2['default'];
exports['default'] = _Radio2['default'];
module.exports = exports['default'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(47);

__webpack_require__(394);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configWxSDK = configWxSDK;
exports.configWxShare = configWxShare;

var _http = __webpack_require__(36);

var _global = __webpack_require__(42);

var _tools = __webpack_require__(6);

// 配置页面微信接口
function configWxSDK() {
  (0, _http.ajax)({
    url: '/index.php?r=AppConfig/GetSmartyVar',
    type: 'get',
    data: {
      app_id: (0, _tools.getQueryString)('app_id') || (0, _global.getAppId)()
    },
    success: function success(res) {
      var is_custom_domain = res.data.is_custom_domain;
      var url = "//www.zhichiwangluo.com"; // 配置的全局常量 webpack.definePlugin webpack.cofig.js/webpack.prod.js中修改
      if (is_custom_domain == '1') {
        url = '//gzh.zhichiwangluo.com';
      }
      (0, _http.ajax)({
        url: url + '/index.php?r=Share/appJsConfig',
        type: 'get',
        data: {
          app_id: (0, _tools.getQueryString)('app_id') || (0, _global.getAppId)()
        },
        success: function success(data) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo', 'onMenuShareQZone', 'startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice', 'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'translateVoice', 'openLocation', 'getLocation', 'scanQRCode', 'chooseWXPay', 'addCard', 'chooseCard', 'openCard', 'openProductSpecificView', 'hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'closeWindow', 'openAddress', 'onMenuShareAppMessage', 'onMenuShareQQ'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            fail: function fail(msg) {
              console.log(msg);
            }
          });
        }
      });
    }
  });
};
//微信分享设置
function configWxShare(data) {
  console.log(JSON.stringify(data));
  wx.ready(function () {
    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容, 需在用户可能点击分享按钮前就先调用

    var shareOptions = {
      title: data.title, // 分享标题
      desc: data.desc || '', // 分享描述
      link: data.link, // 分享链接
      imgUrl: data.imgUrl || '', // 分享图标
      success: function success(msg) {
        // 设置成功
        // alert('11' + JSON.stringify(msg))
        console.log('设置分享朋友成功', JSON.stringify(msg));
        typeof data.success === 'function' && data.success(msg);
      },
      fail: function fail(msg) {
        // alert('12' + JSON.stringify(msg))
        console.log('设置分享朋友失败', JSON.stringify(msg));
        typeof data.fail === 'function' && data.fail(msg);
      },
      trigger: function trigger(msg) {
        // alert('13' + JSON.stringify(msg))
        console.log('点击分享朋友触发事件', JSON.stringify(msg));
      }
    };

    // wx.updateAppMessageShareData(shareOptions); 这个接口在某些机型上面有问题。先用下面两个接口替代，等后续再替换回来。
    wx.onMenuShareAppMessage(shareOptions);
    wx.onMenuShareQQ(shareOptions);

    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
    wx.updateTimelineShareData({
      title: data.title, // 分享标题
      link: data.link, // 分享链接
      imgUrl: data.imgUrl || '', // 分享图标
      success: function success(msg) {
        // 设置成功
        typeof data.success === 'function' && data.success(msg);
      },
      fail: function fail(msg) {
        typeof data.fail === 'function' && data.fail(msg);
      }
    });
  });
};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(629);


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(631);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(655);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIALOG_BGIMG = {
  'default': 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/diabg.png)',
  'delete': 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/diabg_del.png)'
};

var Dialog = function (_Component) {
  (0, _inherits3.default)(Dialog, _Component);

  function Dialog(props) {
    (0, _classCallCheck3.default)(this, Dialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).call(this, props));

    _this.close = function () {
      _this.setState({
        show: false
      });
    };

    _this.showModal = function (options) {
      options = options || {};
      _this.setState({
        show: true,
        title: typeof options.title == 'string' && options.title || "是否确定",
        content: typeof options.content == 'string' && options.content || "",
        status: typeof options.status == 'string' && (options.status == 'default' || options.status == 'delete') && options.status || 'default',
        cancelText: typeof options.cancelText == 'string' && options.cancelText || "取消",
        confirmText: typeof options.confirmText == 'string' && options.confirmText || "确认",
        cancel: typeof options.cancel == 'function' && options.cancel || function () {},
        confirm: typeof options.confirm == 'function' && options.confirm || function () {}
      });
    };

    _this.cancel = function () {
      _this.state.cancel();
      _this.close();
    };

    _this.confirm = function () {
      _this.state.confirm();
      _this.close();
    };

    _this.state = {
      show: false,
      title: "是否确定",
      content: "",
      status: 'default', // OR 'delete'
      cancelText: "取消",
      confirmText: "确定",
      cancel: function cancel() {},
      confirm: function confirm() {}
    };
    return _this;
  }

  (0, _createClass3.default)(Dialog, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState = function () {
        return;
      };
    }

    //取消

    //确认

  }, {
    key: "render",
    value: function render() {
      var _state = this.state,
          title = _state.title,
          content = _state.content,
          status = _state.status,
          cancelText = _state.cancelText,
          confirmText = _state.confirmText;

      return _react2.default.createElement(
        "div",
        null,
        this.state.show && _react2.default.createElement(
          "div",
          { className: "dialog" },
          _react2.default.createElement("div", { className: "mask", onClick: this.cancel }),
          _react2.default.createElement(
            "div",
            { className: "dia_box", style: { backgroundImage: DIALOG_BGIMG[status] } },
            _react2.default.createElement(
              "div",
              { className: "title" },
              title
            ),
            _react2.default.createElement(
              "div",
              { className: "content", title: content },
              content
            ),
            _react2.default.createElement(
              "div",
              { className: "controls" },
              _react2.default.createElement(
                "div",
                { className: "cancelbtn", onClick: this.cancel },
                cancelText
              ),
              _react2.default.createElement(
                "div",
                { className: "confirmbtn", onClick: this.confirm },
                confirmText
              )
            )
          )
        )
      );
    }
  }]);
  return Dialog;
}(_react.Component);

var div = document.createElement('div');
document.body.appendChild(div);
var DialogAlert = ReactDOM.render(_react2.default.createElement(Dialog, null), div);
exports.default = DialogAlert;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(158);
var enumBugKeys = __webpack_require__(115);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModalComponent = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcDialog = __webpack_require__(167);

var _rmcDialog2 = _interopRequireDefault(_rmcDialog);

var _rmcFeedback = __webpack_require__(65);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ModalComponent = exports.ModalComponent = function (_React$Component) {
    (0, _inherits3['default'])(ModalComponent, _React$Component);

    function ModalComponent() {
        (0, _classCallCheck3['default'])(this, ModalComponent);
        return (0, _possibleConstructorReturn3['default'])(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
    }

    return ModalComponent;
}(React.Component);

var Modal = function (_ModalComponent) {
    (0, _inherits3['default'])(Modal, _ModalComponent);

    function Modal() {
        (0, _classCallCheck3['default'])(this, Modal);
        return (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Modal, [{
        key: 'renderFooterButton',
        value: function renderFooterButton(button, prefixCls, i) {
            var buttonStyle = {};
            if (button.style) {
                buttonStyle = button.style;
                if (typeof buttonStyle === 'string') {
                    var styleMap = {
                        cancel: {},
                        'default': {},
                        destructive: { color: 'red' }
                    };
                    buttonStyle = styleMap[buttonStyle] || {};
                }
            }
            var onClickFn = function onClickFn(e) {
                e.preventDefault();
                if (button.onPress) {
                    button.onPress();
                }
            };
            return React.createElement(
                _rmcFeedback2['default'],
                { activeClassName: prefixCls + '-button-active', key: i },
                React.createElement(
                    'a',
                    { className: prefixCls + '-button', role: 'button', style: buttonStyle, onClick: onClickFn },
                    button.text || 'Button'
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classnames2;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                wrapClassName = _a.wrapClassName,
                transitionName = _a.transitionName,
                maskTransitionName = _a.maskTransitionName,
                style = _a.style,
                platform = _a.platform,
                _a$footer = _a.footer,
                footer = _a$footer === undefined ? [] : _a$footer,
                operation = _a.operation,
                animated = _a.animated,
                transparent = _a.transparent,
                popup = _a.popup,
                animationType = _a.animationType,
                restProps = __rest(_a, ["prefixCls", "className", "wrapClassName", "transitionName", "maskTransitionName", "style", "platform", "footer", "operation", "animated", "transparent", "popup", "animationType"]);
            var btnGroupClass = (0, _classnames4['default'])(prefixCls + '-button-group-' + (footer.length === 2 && !operation ? 'h' : 'v'), prefixCls + '-button-group-' + (operation ? 'operation' : 'normal'));
            var footerDom = footer.length ? React.createElement(
                'div',
                { className: btnGroupClass, role: 'group' },
                footer.map(function (button, i) {
                    return (
                        // tslint:disable-next-line:jsx-no-multiline-js
                        _this3.renderFooterButton(button, prefixCls, i)
                    );
                })
            ) : null;
            var transName = void 0;
            var maskTransName = void 0;
            if (animated) {
                // tslint:disable-next-line:prefer-conditional-expression
                if (transparent) {
                    transName = maskTransName = 'am-fade';
                } else {
                    transName = maskTransName = 'am-slide-up';
                }
                if (popup) {
                    transName = animationType === 'slide-up' ? 'am-slide-up' : 'am-slide-down';
                    maskTransName = 'am-fade';
                }
            }
            var wrapCls = (0, _classnames4['default'])(wrapClassName, (0, _defineProperty3['default'])({}, prefixCls + '-wrap-popup', popup));
            var cls = (0, _classnames4['default'])(className, (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-transparent', transparent), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup', popup), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-popup-' + animationType, popup && animationType), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-android', platform === 'android'), _classnames2));
            return React.createElement(_rmcDialog2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, className: cls, wrapClassName: wrapCls, transitionName: transitionName || transName, maskTransitionName: maskTransitionName || maskTransName, style: style, footer: footerDom }));
        }
    }]);
    return Modal;
}(ModalComponent);

exports['default'] = Modal;

Modal.defaultProps = {
    prefixCls: 'am-modal',
    transparent: false,
    popup: false,
    animationType: 'slide-down',
    animated: true,
    style: {},
    onShow: function onShow() {},

    footer: [],
    closable: false,
    operation: false,
    platform: 'ios'
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(50).f;
var has = __webpack_require__(57);
var TAG = __webpack_require__(35)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(233);
var global = __webpack_require__(34);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(64);
var TO_STRING_TAG = __webpack_require__(35)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

var _app = __webpack_require__(4);

__webpack_require__(280);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 定时器
var timer = null;
var AREA_CODE = {
  0: '',
  8: '60'
};

var LoginPage = function (_React$Component) {
  (0, _inherits3.default)(LoginPage, _React$Component);

  function LoginPage(props) {
    (0, _classCallCheck3.default)(this, LoginPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call(this, props));

    _this.state = {
      areaCode: 0,
      phoneNumber: '',
      picCode: '',
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
      identifyCode: '',
      verifying: false,
      time: 60,
      logining: false
    };

    _this.getPicCode = function () {
      _this.setState({
        picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.getIdentifyCode = function () {
      if (_this.state.verifying) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.picCode) {
        _toast2.default.info('请输入图形验证码');
        return;
      }
      _this.setState({
        verifying: true,
        time: 60
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      (0, _http.ajax)({
        url: '/index.php?r=AppUser/phoneCode',
        data: {
          app_id: (0, _global.getAppId)(),
          phone: phone,
          pic_code: _this.state.picCode
        },
        success: function success(res) {
          if (res.status !== 0) {
            _toast2.default.fail(res.data);
            _this.setState({
              verifying: false,
              time: 60
            });
            return;
          }
          timer = setInterval(function () {
            if (_this.state.time === 0) {
              clearInterval(timer);
              _this.setState({
                verifying: false,
                time: 60
              });
            }
            _this.setState({
              time: --_this.state.time
            });
          }, 1000);
        }
      });
    };

    _this.handleChange = function (name, event) {
      _this.setState((0, _defineProperty3.default)({}, name, event.target.value));
    };

    _this.handleLogin = function () {
      if (_this.state.logining) {
        return;
      }
      // if (!this.state.phoneNumber) {
      //   Toast.info('请输入手机号');
      //   return;
      // }
      // if (this.state.phoneNumber.includes(' ')) {
      //   Toast.info('手机号不能有空格');
      //   return;
      // }
      // if (!this.state.identifyCode) {
      //   Toast.info('请输入验证码');
      //   return;
      // }
      _this.setState({
        logining: true
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      (0, _http.ajax)({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          app_id: (0, _global.getAppId)(),
          phone: phone,
          code: _this.state.identifyCode
        },
        success: function success(res) {
          if (res.status !== 0) {
            _this.setState({
              logining: false
            });
            _toast2.default.fail(res.data);
            return;
          }
          _app.appMethod.setIsLogin(true);
          _app.appMethod.bindUserAccount();
          var nickname = res.nickname;
          var cover = res.cover_thumb;
          if (nickname && cover) {
            _toast2.default.info('登录成功', 1);
            // 请求用户数据存到本地
            _app.appMethod.requestUserInfo().then(function () {
              _app.appMethod.turnBack(); // 登录成功返回上一页
            });
            return;
          } else if (!nickname && !cover) {
            _toast2.default.info('登录成功 请补充个人信息');
          } else if (!nickname) {
            _toast2.default.info('登录成功 请补充个人昵称');
          } else if (!cover) {
            _toast2.default.info('登录成功 请补充个人头像');
          }
          _app.appMethod.turnToPage('userCenter'); // 信息不完整则跳到用户信息页面进行补全信息
        },
        error: function error() {
          _this.setState({
            logining: false
          });
          _toast2.default.fail(res.data);
        }
      });
    };

    _this.wxLogin = function () {
      var REDIRECT_URI = 'https://develop.zhichiwangluo.com/zc_webapp/' + _app.appMethod.getHomepageRouter() + '?app_id' + (0, _global.getAppId)();
      window.open('https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx66578094fccaae32&redirect_uri=' + REDIRECT_URI + '&response_type=code&scope=SCOPE&state=STATE#wechat_redirect');
    };

    document.title = '登录';
    if (_app.appMethod.isLogin()) {
      _app.appMethod.turnBack();
    }
    return _this;
  }
  /**
   * 更换图形验证码
   */

  /**
   * 获取验证码
   */

  /**
   * 处理input的值的更改
   */

  /**
   * 登录
   */


  /**
   * 微信公众号授权登录
   */


  (0, _createClass3.default)(LoginPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'loginPage', className: 'page' },
        _react2.default.createElement(
          'div',
          { className: 'center-wrap' },
          _react2.default.createElement(
            'header',
            null,
            '\u5373\u901F\u5E94\u7528'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { className: 'phone-wrap' },
              _react2.default.createElement(
                'select',
                { value: this.state.areaCode, onChange: this.handleChange.bind(this, 'areaCode') },
                _react2.default.createElement(
                  'option',
                  { value: '0' },
                  '\u4E2D\u56FD\u5927\u9646+86'
                ),
                _react2.default.createElement(
                  'option',
                  { value: '8' },
                  'Malaysia+60'
                )
              ),
              _react2.default.createElement('input', { id: 'login-phone', className: 'js-phone-input', type: 'number', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNumber, onChange: this.handleChange.bind(this, 'phoneNumber') })
            ),
            _react2.default.createElement(
              'p',
              { className: 'code-p' },
              _react2.default.createElement('input', { className: 'pic-code-input', type: 'text', placeholder: '\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
              _react2.default.createElement('img', { className: 'pic-code-url', src: this.state.picCodeUrl, onClick: this.getPicCode })
            ),
            _react2.default.createElement(
              'p',
              { className: 'code-p' },
              _react2.default.createElement('input', { id: 'login-code', className: 'code-input', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.c, onChange: this.handleChange.bind(this, 'identifyCode') }),
              _react2.default.createElement(
                'span',
                { className: 'get-code-btn', onClick: this.getIdentifyCode },
                this.state.verifying && this.state.time !== 60 ? this.state.time + 's' : '获取验证码'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'lrf-btn', onClick: this.handleLogin },
              '\u767B\u5F55'
            ),
            _react2.default.createElement(
              'div',
              { className: 'wx-login-btn', onClick: this.wxLogin },
              '\u5FAE\u4FE1\u6388\u6743\u767B\u5F55'
            )
          )
        )
      );
    }
  }]);
  return LoginPage;
}(_react2.default.Component);

exports.default = LoginPage;
;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _MultiPickerMixin = _interopRequireDefault(__webpack_require__(284));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MultiPicker = function MultiPicker(props) {
  var prefixCls = props.prefixCls,
      className = props.className,
      rootNativeProps = props.rootNativeProps,
      children = props.children,
      style = props.style;
  var selectedValue = props.getValue();
  var colElements = React.Children.map(children, function (col, i) {
    return React.cloneElement(col, {
      selectedValue: selectedValue[i],
      onValueChange: function onValueChange() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return props.onValueChange.apply(props, [i].concat(args));
      },
      onScrollChange: props.onScrollChange && function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return props.onScrollChange.apply(props, [i].concat(args));
      }
    });
  });
  return React.createElement("div", _extends({}, rootNativeProps, {
    style: style,
    className: (0, _classnames["default"])(className, prefixCls)
  }), colElements);
};

var _default = (0, _MultiPickerMixin["default"])(MultiPicker);

exports["default"] = _default;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(5));

var _classnames = _interopRequireDefault(__webpack_require__(16));

var _PickerMixin = _interopRequireDefault(__webpack_require__(285));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

;

var Picker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Picker, _React$Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _this.scrollHanders = function () {
      var scrollY = -1;
      var lastY = 0;
      var startY = 0;
      var scrollDisabled = false;
      var isMoving = false;

      var setTransform = function setTransform(nodeStyle, value) {
        nodeStyle.transform = value;
        nodeStyle.webkitTransform = value;
      };

      var setTransition = function setTransition(nodeStyle, value) {
        nodeStyle.transition = value;
        nodeStyle.webkitTransition = value;
      };

      var scrollTo = function scrollTo(_x, y) {
        var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : .3;

        if (scrollY !== y) {
          scrollY = y;

          if (time && !_this.props.noAnimate) {
            setTransition(_this.contentRef.style, "cubic-bezier(0,0,0.2,1.15) ".concat(time, "s"));
          }

          setTransform(_this.contentRef.style, "translate3d(0,".concat(-y, "px,0)"));
          setTimeout(function () {
            _this.scrollingComplete();

            if (_this.contentRef) {
              setTransition(_this.contentRef.style, '');
            }
          }, +time * 1000);
        }
      };

      var Velocity = function () {
        var minInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
        var maxInterval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        var _time = 0;
        var _y = 0;
        var _velocity = 0;
        var recorder = {
          record: function record(y) {
            var now = +new Date();
            _velocity = (y - _y) / (now - _time);

            if (now - _time >= minInterval) {
              _velocity = now - _time <= maxInterval ? _velocity : 0;
              _y = y;
              _time = now;
            }
          },
          getVelocity: function getVelocity(y) {
            if (y !== _y) {
              recorder.record(y);
            }

            return _velocity;
          }
        };
        return recorder;
      }();

      var onFinish = function onFinish() {
        isMoving = false;
        var targetY = scrollY;
        var height = (_this.props.children.length - 1) * _this.itemHeight;
        var time = .3;
        var velocity = Velocity.getVelocity(targetY) * 4;

        if (velocity) {
          targetY = velocity * 40 + targetY;
          time = Math.abs(velocity) * .1;
        }

        if (targetY % _this.itemHeight !== 0) {
          targetY = Math.round(targetY / _this.itemHeight) * _this.itemHeight;
        }

        if (targetY < 0) {
          targetY = 0;
        } else if (targetY > height) {
          targetY = height;
        }

        scrollTo(0, targetY, time < .3 ? .3 : time);

        _this.onScrollChange();
      };

      var onStart = function onStart(y) {
        if (scrollDisabled) {
          return;
        }

        isMoving = true;
        startY = y;
        lastY = scrollY;
      };

      var onMove = function onMove(y) {
        if (scrollDisabled || !isMoving) {
          return;
        }

        scrollY = lastY - y + startY;
        Velocity.record(scrollY);

        _this.onScrollChange();

        setTransform(_this.contentRef.style, "translate3d(0,".concat(-scrollY, "px,0)"));
      };

      return {
        touchstart: function touchstart(evt) {
          return onStart(evt.touches[0].pageY);
        },
        mousedown: function mousedown(evt) {
          return onStart(evt.pageY);
        },
        touchmove: function touchmove(evt) {
          evt.preventDefault();
          onMove(evt.touches[0].pageY);
        },
        mousemove: function mousemove(evt) {
          evt.preventDefault();
          onMove(evt.pageY);
        },
        touchend: function touchend() {
          return onFinish();
        },
        touchcancel: function touchcancel() {
          return onFinish();
        },
        mouseup: function mouseup() {
          return onFinish();
        },
        getValue: function getValue() {
          return scrollY;
        },
        scrollTo: scrollTo,
        setDisabled: function setDisabled() {
          var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
          scrollDisabled = disabled;
        }
      };
    }();

    _this.scrollTo = function (top) {
      _this.scrollHanders.scrollTo(0, top);
    };

    _this.scrollToWithoutAnimation = function (top) {
      _this.scrollHanders.scrollTo(0, top, 0);
    };

    _this.fireValueChange = function (selectedValue) {
      if (selectedValue !== _this.state.selectedValue) {
        if (!('selectedValue' in _this.props)) {
          _this.setState({
            selectedValue: selectedValue
          });
        }

        if (_this.props.onValueChange) {
          _this.props.onValueChange(selectedValue);
        }
      }
    };

    _this.onScrollChange = function () {
      var top = _this.scrollHanders.getValue();

      if (top >= 0) {
        var children = React.Children.toArray(_this.props.children);

        var index = _this.props.computeChildIndex(top, _this.itemHeight, children.length);

        if (_this.scrollValue !== index) {
          _this.scrollValue = index;
          var child = children[index];

          if (child && _this.props.onScrollChange) {
            _this.props.onScrollChange(child.props.value);
          } else if (!child && console.warn) {
            console.warn('child not found', children, index);
          }
        }
      }
    };

    _this.scrollingComplete = function () {
      var top = _this.scrollHanders.getValue();

      if (top >= 0) {
        _this.props.doScrollingComplete(top, _this.itemHeight, _this.fireValueChange);
      }
    };

    var selectedValueState;
    var _this$props = _this.props,
        selectedValue = _this$props.selectedValue,
        defaultSelectedValue = _this$props.defaultSelectedValue;

    if (selectedValue !== undefined) {
      selectedValueState = selectedValue;
    } else if (defaultSelectedValue !== undefined) {
      selectedValueState = defaultSelectedValue;
    } else {
      var children = React.Children.toArray(_this.props.children);
      selectedValueState = children && children[0] && children[0].props.value;
    }

    _this.state = {
      selectedValue: selectedValueState
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var contentRef = this.contentRef,
          indicatorRef = this.indicatorRef,
          maskRef = this.maskRef,
          rootRef = this.rootRef;
      var rootHeight = rootRef.getBoundingClientRect().height; // https://github.com/react-component/m-picker/issues/18

      var itemHeight = this.itemHeight = indicatorRef.getBoundingClientRect().height;
      var num = Math.floor(rootHeight / itemHeight);

      if (num % 2 === 0) {
        num--;
      }

      num--;
      num /= 2;
      contentRef.style.padding = "".concat(itemHeight * num, "px 0");
      indicatorRef.style.top = "".concat(itemHeight * num, "px");
      maskRef.style.backgroundSize = "100% ".concat(itemHeight * num, "px");
      this.scrollHanders.setDisabled(this.props.disabled);
      this.props.select(this.state.selectedValue, this.itemHeight, this.scrollTo);
      var passiveSupported = this.passiveSupported();
      var willPreventDefault = passiveSupported ? {
        passive: false
      } : false;
      var willNotPreventDefault = passiveSupported ? {
        passive: true
      } : false;
      Object.keys(this.scrollHanders).forEach(function (key) {
        if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
          var pd = key.indexOf('move') >= 0 ? willPreventDefault : willNotPreventDefault;
          rootRef.addEventListener(key, _this2.scrollHanders[key], pd);
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      Object.keys(this.scrollHanders).forEach(function (key) {
        if (key.indexOf('touch') === 0 || key.indexOf('mouse') === 0) {
          _this3.rootRef.removeEventListener(key, _this3.scrollHanders[key]);
        }
      });
    }
  }, {
    key: "passiveSupported",
    value: function passiveSupported() {
      var passiveSupported = false;

      try {
        var options = Object.defineProperty({}, 'passive', {
          get: function get() {
            passiveSupported = true;
          }
        });
        window.addEventListener('test', null, options);
      } catch (err) {}

      return passiveSupported;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      if ('selectedValue' in nextProps) {
        if (this.state.selectedValue !== nextProps.selectedValue) {
          this.setState({
            selectedValue: nextProps.selectedValue
          }, function () {
            _this4.props.select(nextProps.selectedValue, _this4.itemHeight, nextProps.noAnimate ? _this4.scrollToWithoutAnimation : _this4.scrollTo);
          });
        }
      }

      this.scrollHanders.setDisabled(nextProps.disabled);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.selectedValue !== nextState.selectedValue || this.props.children !== nextProps.children;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.select(this.state.selectedValue, this.itemHeight, this.scrollToWithoutAnimation);
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if ('selectedValue' in this.props) {
        return this.props.selectedValue;
      }

      var children = React.Children.toArray(this.props.children);
      return children && children[0] && children[0].props.value;
    }
  }, {
    key: "render",
    value: function render() {
      var _pickerCls,
          _this5 = this;

      var props = this.props;
      var prefixCls = props.prefixCls,
          itemStyle = props.itemStyle,
          indicatorStyle = props.indicatorStyle,
          _props$indicatorClass = props.indicatorClassName,
          indicatorClassName = _props$indicatorClass === void 0 ? '' : _props$indicatorClass,
          children = props.children;
      var selectedValue = this.state.selectedValue;
      var itemClassName = "".concat(prefixCls, "-item");
      var selectedItemClassName = "".concat(itemClassName, " ").concat(prefixCls, "-item-selected");

      var map = function map(item) {
        var _item$props = item.props,
            _item$props$className = _item$props.className,
            className = _item$props$className === void 0 ? '' : _item$props$className,
            style = _item$props.style,
            value = _item$props.value;
        return React.createElement("div", {
          style: _extends({}, itemStyle, style),
          className: "".concat(selectedValue === value ? selectedItemClassName : itemClassName, " ").concat(className),
          key: value
        }, item.children || item.props.children);
      }; // compatibility for preact


      var items = React.Children ? React.Children.map(children, map) : [].concat(children).map(map);
      var pickerCls = (_pickerCls = {}, _defineProperty(_pickerCls, props.className, !!props.className), _defineProperty(_pickerCls, prefixCls, true), _pickerCls);
      return React.createElement("div", {
        className: (0, _classnames["default"])(pickerCls),
        ref: function ref(el) {
          return _this5.rootRef = el;
        },
        style: this.props.style
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-mask"),
        ref: function ref(el) {
          return _this5.maskRef = el;
        }
      }), React.createElement("div", {
        className: "".concat(prefixCls, "-indicator ").concat(indicatorClassName),
        ref: function ref(el) {
          return _this5.indicatorRef = el;
        },
        style: indicatorStyle
      }), React.createElement("div", {
        className: "".concat(prefixCls, "-content"),
        ref: function ref(el) {
          return _this5.contentRef = el;
        }
      }, items));
    }
  }]);

  return Picker;
}(React.Component);

Picker.defaultProps = {
  prefixCls: 'rmc-picker'
};

var _default = (0, _PickerMixin["default"])(Picker);

exports["default"] = _default;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(137);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(190);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(365);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImgUpload = undefined;

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _lrz = __webpack_require__(123);

var _lrz2 = _interopRequireDefault(_lrz);

var _http = __webpack_require__(36);

__webpack_require__(381);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImgUpload = exports.ImgUpload = function (_React$Component) {
  (0, _inherits3.default)(ImgUpload, _React$Component);

  function ImgUpload(props) {
    (0, _classCallCheck3.default)(this, ImgUpload);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ImgUpload.__proto__ || Object.getPrototypeOf(ImgUpload)).call(this, props));

    _this.handleImgResize = function (e) {
      var file = e.target.files[0];
      if (!file) {
        return;
      }
      var option = {
        width: _this.options.width || 500,
        quality: _this.options.quality || 1
      };
      (0, _lrz2.default)(file, option).then(function (result) {
        (0, _http.ajax)({
          url: '/index.php?r=AppData/uploadImg',
          data: {
            img_data: result.base64,
            org: 1
          },
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info('图片上传失败，请重试');
              return;
            }
            _this.props.complete(res.data);
          }
        });
      });
    };

    _this.options = _this.props.options || {};
    return _this;
  }

  (0, _createClass3.default)(ImgUpload, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', { className: 'common img-upload', id: this.options.id, type: 'file', accept: 'image/jpg,image/jpeg, image/gif, image/bmp, image/jp2, image/x-ms-bmp, image/x-png', onChange: this.handleImgResize });
    }
  }]);
  return ImgUpload;
}(_react2.default.Component);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(15);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _DatePicker = __webpack_require__(385);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Popup = __webpack_require__(387);

var _Popup2 = _interopRequireDefault(_Popup);

var _getLocale = __webpack_require__(127);

var _utils = __webpack_require__(388);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var DatePicker = function (_React$Component) {
    (0, _inherits3['default'])(DatePicker, _React$Component);

    function DatePicker() {
        (0, _classCallCheck3['default'])(this, DatePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));

        _this.setScrollValue = function (v) {
            _this.scrollValue = v;
        };
        _this.onOk = function (v) {
            if (_this.scrollValue !== undefined) {
                v = _this.scrollValue;
            }
            if (_this.props.onChange) {
                _this.props.onChange(v);
            }
            if (_this.props.onOk) {
                _this.props.onOk(v);
            }
        };
        _this.onVisibleChange = function (visible) {
            _this.scrollValue = undefined;
            if (_this.props.onVisibleChange) {
                _this.props.onVisibleChange(visible);
            }
        };
        _this.fixOnOk = function (picker) {
            if (picker) {
                picker.onOk = _this.onOk;
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(DatePicker, [{
        key: 'render',
        value: function render() {
            // tslint:disable-next-line:no-this-assignment
            var props = this.props,
                context = this.context;
            var children = props.children,
                value = props.value,
                popupPrefixCls = props.popupPrefixCls;

            var locale = (0, _getLocale.getComponentLocale)(props, context, 'DatePicker', function () {
                return __webpack_require__(389);
            });
            var okText = locale.okText,
                dismissText = locale.dismissText,
                extra = locale.extra,
                DatePickerLocale = locale.DatePickerLocale;
            /**
             * 注意:
             * 受控 表示 通过设置 value 属性、组件的最终状态跟 value 设置值一致。
             * 默认不设置 value 或 只设置 defaultValue 表示非受控。
             *
             * DatePickerView 对外通过 value “只支持 受控” 模式（可以使用 defaultDate 支持 非受控 模式，但不对外）
             * PickerView 对外通过 value “只支持 受控” 模式
             *
             * DatePicker / Picker 对外只有 value 属性 (没有 defaultValue)，
             * 其中 List 展示部分 “只支持 受控” 模式，
             * 弹出的 选择器部分 会随外部 value 改变而变、同时能自由滚动
             * （即不会因为传入的 value 不变而不能滚动 (不像原生 input 的受控行为)）
             *
             */

            var datePicker = React.createElement(_DatePicker2['default'], { minuteStep: props.minuteStep, locale: DatePickerLocale, minDate: props.minDate, maxDate: props.maxDate, mode: props.mode, pickerPrefixCls: props.pickerPrefixCls, prefixCls: props.prefixCls, defaultDate: value || new Date(), use12Hours: props.use12Hours, onValueChange: props.onValueChange, onScrollChange: this.setScrollValue });
            return React.createElement(
                _Popup2['default'],
                (0, _extends3['default'])({ datePicker: datePicker, WrapComponent: 'div', transitionName: 'am-slide-up', maskTransitionName: 'am-fade' }, props, { prefixCls: popupPrefixCls, date: value || new Date(), dismissText: this.props.dismissText || dismissText, okText: this.props.okText || okText, ref: this.fixOnOk, onVisibleChange: this.onVisibleChange }),
                children && React.isValidElement(children) && React.cloneElement(children, {
                    extra: value ? (0, _utils.formatFn)(this, value) : this.props.extra || extra
                })
            );
        }
    }]);
    return DatePicker;
}(React.Component);

exports['default'] = DatePicker;

DatePicker.defaultProps = {
    mode: 'datetime',
    prefixCls: 'am-picker',
    pickerPrefixCls: 'am-picker-col',
    popupPrefixCls: 'am-picker-popup',
    minuteStep: 1,
    use12Hours: false
};
DatePicker.contextTypes = {
    antLocale: PropTypes.object
};
module.exports = exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GoodsShoppingCart = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

__webpack_require__(414);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsShoppingCart = exports.GoodsShoppingCart = function (_CommonComponent) {
  (0, _inherits3.default)(GoodsShoppingCart, _CommonComponent);

  function GoodsShoppingCart(props) {
    (0, _classCallCheck3.default)(this, GoodsShoppingCart);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsShoppingCart.__proto__ || Object.getPrototypeOf(GoodsShoppingCart)).call(this, props));

    _this2.goodsId = '';
    _this2.franchiseeId = '';

    _this2.show = function (options) {
      var afterSelectedGoods = options.afterSelectedGoods;


      _this2.afterSelectedGoods = afterSelectedGoods;
    };

    _this2.showDialog = function (data) {
      _this2.goodsId = data.goodsId;
      _this2.franchiseeId = data.franchisee || '';
      var pageInstance = _app.appMethod.getAppCurrentPage();
      _this2.setData({
        isShowBottom: pageInstance.data.isShowBottom || "",
        showBuyNow: data.showBuynow || '',
        showVirtualPrice: data.showVirtualPrice || ''
      });
      _this2.getGoodsDetail();
      _this2.getAppECStoreConfig();
    };

    _this2.getGoodsDetail = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: _this.goodsId,
          sub_shop_app_id: _this2.franchiseeId
        },
        method: 'post',
        success: function success(res) {
          var goods = res.data[0].form_data;
          var defaultSelect = goods.model_items[0];
          var goodsModel = [];
          var selectModels = [];
          var goodprice = 0;
          var goodstock = 0;
          var goodid = void 0;
          var selectText = '';
          var goodimgurl = '';
          var virtual_price = '';
          var is_vip_goods = goods.is_vip_goods;
          var vipprice = 0;
          if (goods.model_items.length) {
            goodprice = defaultSelect.price;
            goodstock = defaultSelect.stock;
            vipprice = defaultSelect.vip_price || defaultSelect.price;
            goodid = defaultSelect.id;
            goodimgurl = defaultSelect.img_url;
            virtual_price = defaultSelect.virtual_price;
          } else {
            goodprice = goods.price;
            vipprice = goods.vip_goods_price || goods.price;
            goodstock = goods.stock;
            goodimgurl = goods.cover;
            virtual_price = goods.virtual_price;
          }
          for (var key in goods.model) {
            if (key) {
              var model = goods.model[key];
              goodsModel.push(model);
              selectModels.push(model.subModelId[0]);
              selectText += '“' + model.subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel;

          _this.setData({
            isVisibled: true,
            goodsInfo: goods,
            'selectGoodsModelInfo.price': goodprice,
            'selectGoodsModelInfo.is_vip_goods': is_vip_goods,
            'selectGoodsModelInfo.vipprice': vipprice,
            'selectGoodsModelInfo.stock': goodstock,
            'selectGoodsModelInfo.buyCount': 1,
            'selectGoodsModelInfo.buyTostoreCount': 0,
            'selectGoodsModelInfo.cart_id': '',
            'selectGoodsModelInfo.models': selectModels,
            'selectGoodsModelInfo.modelId': goodid || '',
            'selectGoodsModelInfo.models_text': selectText,
            'selectGoodsModelInfo.imgurl': goodimgurl,
            'selectGoodsModelInfo.virtual_price': virtual_price,
            'selectGoodsModelInfo.max_can_use_integral': goods.max_can_use_integral
          });
        }
      });
    };

    _this2.selectGoodsSubModel = function (event) {
      var dataset = event.target.dataset;
      var modelIndex = dataset.modelIndex;
      var submodelIndex = dataset.submodelIndex;
      var data = {};
      var selectModels = _this2.data.selectGoodsModelInfo.models;
      var model = _this2.data.goodsInfo.model;
      var text = '';

      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];

      //拼已选规格文字
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['selectGoodsModelInfo.models'] = selectModels;
      data['selectGoodsModelInfo.models_text'] = text;

      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var selectModelIds = _this2.data.selectGoodsModelInfo.models.join(',');
      var modelItems = _this2.data.goodsInfo.model_items;
      var data = {};
      var cover = _this2.data.goodsInfo.cover;

      data['selectGoodsModelInfo.buyCount'] = 1;
      data['selectGoodsModelInfo.buyTostoreCount'] = 0;
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['selectGoodsModelInfo.stock'] = modelItems[i].stock;
          data['selectGoodsModelInfo.price'] = modelItems[i].price;
          data['selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
          data['selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || cover;
          data['selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price;
          data['selectGoodsModelInfo.vipprice'] = modelItems[i].vip_price;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.inputBuyCount = function (e) {
      _this2.setData({
        'selectGoodsModelInfo.buyCount': e.target.value
      });
    };

    _this2.clickGoodsMinusButton = function () {
      var count = _this2.data.selectGoodsModelInfo.buyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectGoodsModelInfo.buyCount': count - 1
      });
    };

    _this2.clickGoodsPlusButton = function () {
      var selectGoodsModelInfo = _this2.data.selectGoodsModelInfo;
      var count = selectGoodsModelInfo.buyCount;
      var stock = selectGoodsModelInfo.stock;

      if (count >= stock) {
        return;
      }
      _this2.setData({
        'selectGoodsModelInfo.buyCount': count + 1
      });
    };

    _this2.sureAddToShoppingCart = function () {
      var _this = _this2;
      var param = {
        goods_id: _this.data.goodsInfo.id,
        model_id: _this.data.selectGoodsModelInfo.modelId || '',
        num: _this.data.selectGoodsModelInfo.buyCount,
        sub_shop_app_id: _this2.franchiseeId,
        message_notice_type: 1
      };

      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          // 有的组件会有用到这个方法
          if (_this.afterSelectedGoods) {
            _this.afterSelectedGoods();
          }
          _this.hideDialog();
        }
      });
    };

    _this2.hideDialog = function () {
      _this2.setData({
        isVisibled: false
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.goPreviewGoodsOrder = function () {
      var _this = _this2;
      var param = {
        goods_id: _this.data.goodsInfo.id,
        model_id: _this.data.selectGoodsModelInfo.modelId || '',
        num: _this.data.selectGoodsModelInfo.buyCount,
        sub_shop_app_id: _this2.franchiseeId,
        message_notice_type: 1

      };

      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          var cart_arr = [res.data],
              pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cart_arr);
          _this.hideDialog();
          _app.appMethod.turnToPage(pagePath);
        }
      });
    };

    _this2.options = _this2.props.options;

    _this2.state = {
      isVisibled: false,
      showBuyNow: false,
      showVirtualPrice: false,
      goodsInfo: {},
      selectGoodsModelInfo: {
        buyCount: 0
      },
      isShowBottom: false,
      storeStyle: {}
    };
    return _this2;
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一致


  (0, _createClass3.default)(GoodsShoppingCart, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          isVisibled = _state.isVisibled,
          showBuyNow = _state.showBuyNow,
          showVirtualPrice = _state.showVirtualPrice,
          goodsInfo = _state.goodsInfo,
          selectGoodsModelInfo = _state.selectGoodsModelInfo,
          isShowBottom = _state.isShowBottom,
          storeStyle = _state.storeStyle;
      // 判断当前页是否有导航

      var hasTabNav = _app.appMethod.isTabBarPage();
      return _react2.default.createElement(
        'div',
        { className: 'common-component goods-shopping-cart goodsPayDialog', style: {
            bottom: hasTabNav ? '48px' : ''
          }, hidden: !isVisibled },
        _react2.default.createElement(
          'div',
          { className: 'goods-detail-contain', style: isShowBottom ? { bottom: '48px' } : {} },
          _react2.default.createElement('div', { className: 'ico-moon icon-closes', onClick: this.hideDialog.bind(this) }),
          _react2.default.createElement(
            'div',
            { className: 'goods-detail-header' },
            _react2.default.createElement('img', { className: 'goods-cover', src: selectGoodsModelInfo.imgurl || goodsInfo.cover }),
            _react2.default.createElement(
              'div',
              { className: 'select-goods-info' },
              _react2.default.createElement(
                'div',
                { className: 'goods-price' },
                selectGoodsModelInfo.is_vip_goods != 1 ? _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { color: storeStyle.theme } },
                    '\xA5',
                    selectGoodsModelInfo.price
                  ),
                  showVirtualPrice && selectGoodsModelInfo.virtual_price != 0 && _react2.default.createElement(
                    'span',
                    { className: 'virtualPrice' },
                    '\xA5',
                    selectGoodsModelInfo.virtual_price
                  )
                ) : _react2.default.createElement(
                  'div',
                  { className: 'pay-current-price member-status' },
                  _react2.default.createElement(
                    'div',
                    { className: 'member-price memeber-item', style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\xA5'
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      selectGoodsModelInfo.vipprice
                    )
                  ),
                  selectGoodsModelInfo.vipPrice != selectGoodsModelInfo.price && _react2.default.createElement(
                    'div',
                    { className: 'member-logo memeber-item' },
                    '\u4F1A\u5458\u4EF7'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'memebr-origin-price memeber-item', style: { color: '#999', display: 'inline-block' } },
                    showVirtualPrice && selectModelInfo.virtualPrice != 0 && _react2.default.createElement(
                      'span',
                      { className: 'virtualPrice', style: { marginLeft: 0 } },
                      '\uFFE5',
                      selectGoodsModelInfo.virtual_price
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-stock' },
                '\u5E93\u5B58',
                selectGoodsModelInfo.stock
              ),
              selectGoodsModelInfo.models_text && _react2.default.createElement(
                'div',
                { className: 'select-model' },
                '\u5DF2\u9009\uFF1A',
                selectGoodsModelInfo.models_text
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-detail-content' },
            _react2.default.createElement(
              'div',
              { className: 'goods-dialog-content', hidden: !(goodsInfo.model_items && goodsInfo.model_items.length) },
              goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                return _react2.default.createElement(
                  'div',
                  { className: 'goods-model', key: modelIndex },
                  _react2.default.createElement(
                    'div',
                    { className: 'model-title' },
                    model.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sub-model' },
                    model.subModelName.map(function (name, index) {
                      return _react2.default.createElement(
                        'span',
                        { className: 'subModel ' + (selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''), key: index, 'data-model-index': modelIndex, 'data-submodel-index': index, 'data-submodel-id': model.subModelId[index], onClick: _this3.selectGoodsSubModel.bind(_this3), style: selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? { background: storeStyle.theme + '33', color: storeStyle.theme, borderColor: storeStyle.theme } : {} },
                        name
                      );
                    })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-num-contain' },
            _react2.default.createElement(
              'span',
              { className: 'goods-num-title' },
              '\u8D2D\u4E70\u6570\u91CF\uFF1A'
            ),
            _react2.default.createElement(
              'div',
              { className: 'good-number-box pull-right' },
              _react2.default.createElement(
                'div',
                { className: 'goods-minus', onClick: this.clickGoodsMinusButton },
                '-'
              ),
              _react2.default.createElement('input', { className: 'goods-count', type: 'number', value: selectGoodsModelInfo.buyCount, onInput: this.inputBuyCount, onChange: this.inputBuyCount }),
              _react2.default.createElement(
                'div',
                { className: 'goods-plus', onClick: this.clickGoodsPlusButton },
                '+'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-shopping-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'add-shoppingcart', style: { background: storeStyle.secondary, color: storeStyle.secondary == '#ACD3FA' || storeStyle.secondary == '#FFCFDF' || storeStyle.secondary == '#ffffff' || storeStyle.secondary == '#DFF3ED' || storeStyle.secondary == '#FAF7ED' ? storeStyle.theme : '' }, onClick: this.sureAddToShoppingCart.bind(this) },
              '\u52A0\u5165\u8D2D\u7269\u8F66'
            ),
            showBuyNow && _react2.default.createElement(
              'div',
              { className: 'now-buy', style: { background: storeStyle.theme }, onClick: this.goPreviewGoodsOrder },
              '\u7ACB\u5373\u8D2D\u4E70'
            )
          )
        )
      );
    }
  }]);
  return GoodsShoppingCart;
}(_CommonComponent3.default);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Map = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(454);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
* @param { Number } latitude 中心经度。具体参考微信小程序map组件参数，下同。
* @param { Number } longitude 中心纬度。
* @param { Number } scale 缩放级别，取值范围为3-20。默认16
* @param { Array.<marker> } markers 标记点
* @param { Array.<circle> } circles 圆
* @param { Array.<control> } controls 控件
* @param { function } bindmarkertap 点击标记点时触发
* @param { function } bindcontroltap 点击控件时触发
* @param { function } bindregionchange 视野发生变化时触发的事件
*
* 另外组件会接收className 和 style 属性
*
* TODO： 注意很多参数并不完整。很多没有用到的就没有实现
*/

var Map = exports.Map = function (_React$Component) {
  (0, _inherits3.default)(Map, _React$Component);

  function Map(props) {
    (0, _classCallCheck3.default)(this, Map);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Map.__proto__ || Object.getPrototypeOf(Map)).call(this, props));

    _this.getCenterLocation = function (options) {
      var latlng = _this.mapInstance.getCenter();
      if (latlng) {
        typeof options.success === 'function' && options.success({
          longitude: latlng.lng,
          latitude: latlng.lat
        });
      } else {
        typeof options.fail === 'function' && options.fail();
      }
      typeof options.complete === 'function' && options.complete();
    };

    _this.mapInstance = null;
    _this.markersArr = [];
    _this.circleInstance = null;
    _this.controlsArr = [];

    _this.latitude = _this.props.latitude; //中心经度。
    _this.longitude = _this.props.longitude; //中心纬度。
    return _this;
  }

  (0, _createClass3.default)(Map, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.latitude || !this.longitude) {
        console.error('map组件，经纬度是必填参数');
        return;
      }

      this.mapInstance = new qq.maps.Map(document.getElementById("map-inner"), {
        zoom: +this.props.scale || 16,
        zoomControl: false,
        panControl: false,
        mapTypeControl: false
      });
      this.mapInstance.panTo(new qq.maps.LatLng(this.latitude, this.longitude));

      this.props.markers && this.setMarkers(this.props.markers);

      this.props.circles && this.setCircle(this.props.circles);

      this.props.controls && this.setcontrols(this.props.controls);

      qq.maps.event.addListener(this.mapInstance, 'dragend', function (e) {
        _this2.props.bindregionchange && _this2.props.bindregionchange({
          type: 'end',
          causedBy: 'drag'
        });
      });
      qq.maps.event.addListener(this.mapInstance, 'dragstart', function (e) {
        _this2.props.bindregionchange && _this2.props.bindregionchange({
          type: 'begin',
          causedBy: 'drag'
        });
      });
      qq.maps.event.addListener(this.mapInstance, 'zoom_changed', function (e) {
        _this2.props.bindregionchange && _this2.props.bindregionchange({
          type: 'end',
          causedBy: 'scale'
        });
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.props.markers && this.setMarkers(this.props.markers);

      this.props.circles && this.setCircle(this.props.circles);

      this.props.controls && this.setcontrols(this.props.controls);
    }

    // 多个设置标记

  }, {
    key: 'setMarkers',
    value: function setMarkers(ms) {
      var _this3 = this;

      this.markersArr.map(function (item, index) {
        item.setMap(null);
      });
      this.markersArr = [];
      ms.map(function (item, index) {
        _this3.setMarker(item);
      });
    }

    // 设置标记

  }, {
    key: 'setMarker',
    value: function setMarker(data) {
      var _this4 = this;

      if (!data.latitude || !data.longitude) {
        console.error('map组件markers属性如果有，markers属性里面的字段latitude，longitude是必填参数。可以参考微信小程序map组件');
        return;
      }
      var options = {
        map: this.mapInstance,
        position: new qq.maps.LatLng(data.latitude, data.longitude),
        title: data.title || ''
      };
      if (data.iconPath) {
        var size = '';
        var origin = new qq.maps.Point(0, 0);
        if (data.width || data.height) {
          size = new qq.maps.Size(data.width || 20, data.height || 30);
        }
        options.icon = new qq.maps.MarkerImage(data.iconPath, size, origin, null, size);
      }
      if (data.zIndex) {
        options.zIndex = data.zIndex;
      }

      var marker = new qq.maps.Marker(options);
      this.markersArr.push(marker);

      qq.maps.event.addListener(marker, 'click', function () {
        _this4.props.bindmarkertap && _this4.props.bindmarkertap({
          markerId: data.id || ''
        });
      });
    }

    // 设置圆

  }, {
    key: 'setCircle',
    value: function setCircle(data) {
      if (!data.latitude || !data.longitude || !data.radius) {
        console.error('map组件circle属性如果有，circle属性里面的字段latitude，longitude，radius是必填参数。可以参考微信小程序map组件');
        return;
      }
      this.circleInstance && this.circleInstance.setMap(null);
      this.circleInstance = new qq.maps.Circle({
        map: this.mapInstance,
        center: new qq.maps.LatLng(data.latitude, data.longitude),
        radius: data.radius,
        fillColor: data.fillColor || '',
        strokeWeight: data.strokeWidth || ''
      });
    }

    // 多个设置控件

  }, {
    key: 'setcontrols',
    value: function setcontrols(cs) {
      var _this5 = this;

      this.controlsArr.map(function (item, index) {
        item.remove();
      });
      this.controlsArr = [];
      cs.map(function (item, index) {
        _this5.setcontrol(item);
      });
    }

    // 设置控件

  }, {
    key: 'setcontrol',
    value: function setcontrol(data) {
      var _this6 = this;

      if (!data.iconPath) {
        console.error('map组件controls属性如果有，iconPath是必填参数。可以参考微信小程序map组件');
        return;
      }
      var control = document.createElement("div");
      control.style.cssText = (data.position && data.position.width ? 'width: ' + data.position.width + 'px;' : '') + (data.position && data.position.height ? 'height: ' + data.position.height + 'px;' : '') + 'margin-left: ' + (data.position && data.position.left ? data.position.left : 0) + 'px; margin-top:' + (data.position && data.position.top ? data.position.top : 0) + 'px;';
      control.innerHTML = '<img style="width: 100%; height: 100%;" src="' + data.iconPath + '" />';
      control.index = 3;

      this.mapInstance.controls[qq.maps.ControlPosition.LEFT_TOP].push(control);
      this.controlsArr.push(control);

      if (data.clickable) {
        qq.maps.event.addListener(control, "click", function () {
          _this6.props.bindcontroltap && _this6.props.bindcontroltap({
            controlId: data.id || ''
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'jisu-component map map-wrapper ' + this.props.className, style: this.props.style },
        _react2.default.createElement('div', { className: 'map-inner', id: 'map-inner', style: this.props.style })
      );
    }
  }]);
  return Map;
}(_react2.default.Component);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(559);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(562);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unlisten = exports.location = exports.history = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _history = __webpack_require__(54);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = (0, _history.createBrowserHistory)({
  basename: "/zc_webapp" || '/' // 配置的全局常量 webpack.definePlugin webpack.cofig.js/webpack.prod.js中修改
});

var location = history.location;

var unlisten = history.listen(function (location, action) {
  // 前一页面为自定义页面，执行前一页面组件销毁
  var pageInstance = _app.appMethod.getAppCurrentPage();
  if (pageInstance && pageInstance.customPageRef) {
    _app.appMethod.onPageUnload();
  }
  // WEBAPP:清除当前页面内弹窗内容（例如：预览大图等）
  ReactDOM.unmountComponentAtNode(document.getElementById('popup'));

  // The action is one of PUSH, REPLACE, or POP depending on how the user got to the current URL.
  console.log('路由处理中...', 'location:', location, 'action:', action);
  // 默认把app_id加到当前地址栏参数中（防止用户分享当前链接）
  (0, _tools.updateUrlParam)('app_id', _app.appMethod.getAppId());
  // 传递给父级窗口message
  if (window.top !== window) {
    var data = JSON.stringify({
      iframeId: window.frameElement ? window.frameElement.id : null,
      name: 'turnToPage',
      url: window.location.href,
      router: location.pathname.replace('/', '')
    });
    window.parent.postMessage(data, '*');
  }
  var route = location.pathname.split('/')[1];
  var page = {
    route: route,
    data: {},
    callbackData: null,
    setData: function setData(data) {
      if (this.callbackData) {
        this.callbackData = (0, _extends3.default)({}, this.callbackData, data);
      } else {
        this.callbackData = data;
      }
    },
    clearCallbackData: function clearCallbackData() {
      this.callbackData = null;
    }
  };
  if (action === 'PUSH' || action === 'REPLACE') {
    if (_app.appMethod.globalData.tabBarPagePathArr.indexOf(route) > -1) {
      // 跳转到有设置底部导航的页面，页面清空并设置为当前页
      _app.appMethod.globalData.currentPages = [page];
    } else {
      // 推入页面栈中
      if (action === 'REPLACE') {
        _app.appMethod.globalData.currentPages.pop();
      }
      if (action !== 'REPLACE' && _app.appMethod.getAppCurrentPage() && _app.appMethod.getAppCurrentPage().state) {
        _app.appMethod.getCurrentPage().data = JSON.parse(JSON.stringify(_app.appMethod.getAppCurrentPage().state));
      }
      _app.appMethod.globalData.currentPages.push(page);
    }
  } else if (action === 'POP') {
    if (_app.appMethod.globalData.currentPages.length > 1) {
      // 页面栈超过一个页面（不含一个）, 去掉最后一个
      _app.appMethod.globalData.currentPages.pop();
    } else {
      // 页面栈仅剩一个, 页面清空并设置为当前页
      _app.appMethod.globalData.currentPages = [page];
    }
  }
});

// To stop listening, call the function returned from listen().
// unlisten();

exports.history = history;
exports.location = location;
exports.unlisten = unlisten;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var document = __webpack_require__(34).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(53);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(112);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(114)('keys');
var uid = __webpack_require__(87);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var global = __webpack_require__(34);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(74) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 116 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = closest;
function closest(el, selector) {
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
    var p = el;
    while (p) {
        if (matchesSelector.call(p, selector)) {
            return p;
        }
        p = p.parentElement;
    }
    return null;
}
module.exports = exports["default"];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(48);
var dPs = __webpack_require__(232);
var enumBugKeys = __webpack_require__(115);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(108)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(163).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(35);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var core = __webpack_require__(24);
var LIBRARY = __webpack_require__(74);
var wksExt = __webpack_require__(119);
var defineProperty = __webpack_require__(50).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(88);
var createDesc = __webpack_require__(72);
var toIObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(109);
var has = __webpack_require__(57);
var IE8_DOM_DEFINE = __webpack_require__(157);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(51) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(10);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(15);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ./node_modules/rc-util/es/unsafeLifecyclesPolyfill.js


var unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!external__React__default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ var es_unsafeLifecyclesPolyfill = (unsafeLifecyclesPolyfill_unsafeLifecyclesPolyfill);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/ChildrenUtils.js


function toArrayChildren(children) {
  var ret = [];
  external__React__default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}
// EXTERNAL MODULE: external "ReactDOM"
var external__ReactDOM_ = __webpack_require__(19);
var external__ReactDOM__default = /*#__PURE__*/__webpack_require__.n(external__ReactDOM_);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__(21);
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/css-animation/es/Event.js
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ var Event = (TransitionEvents);
// EXTERNAL MODULE: ./node_modules/component-classes/index.js
var component_classes = __webpack_require__(252);
var component_classes_default = /*#__PURE__*/__webpack_require__.n(component_classes);

// CONCATENATED MODULE: ./node_modules/css-animation/es/index.js




var isCssAnimationSupported = Event.endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var es_cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : typeof_default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = component_classes_default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

es_cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    Event.removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  Event.addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

es_cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

es_cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ var es = (es_cssAnimation);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/util/animate.js
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ var animate = (util);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/AnimateChild.js










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild_AnimateChild = function (_React$Component) {
  inherits_default()(AnimateChild, _React$Component);

  function AnimateChild() {
    classCallCheck_default()(this, AnimateChild);

    return possibleConstructorReturn_default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  createClass_default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (animate.isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (animate.isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (animate.isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = external__ReactDOM__default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = es(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(external__React__default.a.Component);

AnimateChild_AnimateChild.propTypes = {
  children: prop_types_default.a.any,
  animation: prop_types_default.a.any,
  transitionName: prop_types_default.a.any
};
/* harmony default export */ var es_AnimateChild = (AnimateChild_AnimateChild);
// CONCATENATED MODULE: ./node_modules/rc-animate/es/Animate.js













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (external__React__default.a.isValidElement(children)) {
    if (!children.key) {
      return external__React__default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate_Animate = function (_React$Component) {
  inherits_default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    classCallCheck_default()(this, Animate);

    var _this = possibleConstructorReturn_default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    Animate__initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: toArrayChildren(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  createClass_default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = external__React__default.a.cloneElement(nextChild || currentChild, defineProperty_default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = mergeChildren(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && findChildInChildrenByKey(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && findChildInChildrenByKey(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return findShownChildInChildrenByKey(currentChildren, key, showProp);
      }
      return findChildInChildrenByKey(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return external__React__default.a.createElement(
            es_AnimateChild,
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = extends_default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return external__React__default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(external__React__default.a.Component);

Animate_Animate.isAnimate = true;
Animate_Animate.propTypes = {
  className: prop_types_default.a.string,
  style: prop_types_default.a.object,
  component: prop_types_default.a.any,
  componentProps: prop_types_default.a.object,
  animation: prop_types_default.a.object,
  transitionName: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  transitionEnter: prop_types_default.a.bool,
  transitionAppear: prop_types_default.a.bool,
  exclusive: prop_types_default.a.bool,
  transitionLeave: prop_types_default.a.bool,
  onEnd: prop_types_default.a.func,
  onEnter: prop_types_default.a.func,
  onLeave: prop_types_default.a.func,
  onAppear: prop_types_default.a.func,
  showProp: prop_types_default.a.string,
  children: prop_types_default.a.node
};
Animate_Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var Animate__initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (animate.allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (animate.allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = toArrayChildren(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (animate.allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!isSameChildren(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ var es_Animate = __webpack_exports__["a"] = (es_unsafeLifecyclesPolyfill(Animate_Animate));

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(7);
	__webpack_require__(8);

	module.exports = __webpack_require__(9);


	/**
	 *
	 * 　　　┏┓　　　┏┓
	 * 　　┏┛┻━━━┛┻┓
	 * 　　┃　　　　　　　┃
	 * 　　┃　　　━　　　┃
	 * 　　┃　┳┛　┗┳　┃
	 * 　　┃　　　　　　　┃
	 * 　　┃　　　┻　　　┃
	 * 　　┃　　　　　　　┃
	 * 　　┗━┓　　　┏━┛Code is far away from bug with the animal protecting
	 * 　　　　┃　　　┃    神兽保佑,代码无bug
	 * 　　　　┃　　　┃
	 * 　　　　┃　　　┗━━━┓
	 * 　　　　┃　　　　　 ┣┓
	 * 　　　　┃　　　　 ┏┛
	 * 　　　　┗┓┓┏━┳┓┏┛
	 * 　　　　　┃┫┫　┃┫┫
	 * 　　　　　┗┻┛　┗┻┛
	 *
	 */


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

	    // Use polyfill for setImmediate for performance gains
	    var asap = (typeof setImmediate === 'function' && setImmediate) ||
	        function (fn) {
	            setTimeout(fn, 1);
	        };

	    // Polyfill for Function.prototype.bind
	    function bind (fn, thisArg) {
	        return function () {
	            fn.apply(thisArg, arguments);
	        }
	    }

	    var isArray = Array.isArray || function (value) {
	            return Object.prototype.toString.call(value) === "[object Array]"
	        };

	    function Promise (fn) {
	        if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	        if (typeof fn !== 'function') throw new TypeError('not a function');
	        this._state     = null;
	        this._value     = null;
	        this._deferreds = []

	        doResolve(fn, bind(resolve, this), bind(reject, this))
	    }

	    function handle (deferred) {
	        var me = this;
	        if (this._state === null) {
	            this._deferreds.push(deferred);
	            return
	        }
	        asap(function () {
	            var cb = me._state ? deferred.onFulfilled : deferred.onRejected
	            if (cb === null) {
	                (me._state ? deferred.resolve : deferred.reject)(me._value);
	                return;
	            }
	            var ret;
	            try {
	                ret = cb(me._value);
	            }
	            catch (e) {
	                deferred.reject(e);
	                return;
	            }
	            deferred.resolve(ret);
	        })
	    }

	    function resolve (newValue) {
	        try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	            if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
	            if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                var then = newValue.then;
	                if (typeof then === 'function') {
	                    doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	                    return;
	                }
	            }
	            this._state = true;
	            this._value = newValue;
	            finale.call(this);
	        } catch (e) {
	            reject.call(this, e);
	        }
	    }

	    function reject (newValue) {
	        this._state = false;
	        this._value = newValue;
	        finale.call(this);
	    }

	    function finale () {
	        for (var i = 0, len = this._deferreds.length; i < len; i++) {
	            handle.call(this, this._deferreds[i]);
	        }
	        this._deferreds = null;
	    }

	    function Handler (onFulfilled, onRejected, resolve, reject) {
	        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	        this.onRejected  = typeof onRejected === 'function' ? onRejected : null;
	        this.resolve     = resolve;
	        this.reject      = reject;
	    }

	    /**
	     * Take a potentially misbehaving resolver function and make sure
	     * onFulfilled and onRejected are only called once.
	     *
	     * Makes no guarantees about asynchrony.
	     */
	    function doResolve (fn, onFulfilled, onRejected) {
	        var done = false;
	        try {
	            fn(function (value) {
	                if (done) return;
	                done = true;
	                onFulfilled(value);
	            }, function (reason) {
	                if (done) return;
	                done = true;
	                onRejected(reason);
	            })
	        } catch (ex) {
	            if (done) return;
	            done = true;
	            onRejected(ex);
	        }
	    }

	    Promise.prototype['catch'] = function (onRejected) {
	        return this.then(null, onRejected);
	    };

	    Promise.prototype.then = function (onFulfilled, onRejected) {
	        var me = this;
	        return new Promise(function (resolve, reject) {
	            handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	        })
	    };

	    Promise.all = function () {
	        var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);

	        return new Promise(function (resolve, reject) {
	            if (args.length === 0) return resolve([]);
	            var remaining = args.length;

	            function res (i, val) {
	                try {
	                    if (val && (typeof val === 'object' || typeof val === 'function')) {
	                        var then = val.then;
	                        if (typeof then === 'function') {
	                            then.call(val, function (val) {
	                                res(i, val)
	                            }, reject);
	                            return;
	                        }
	                    }
	                    args[i] = val;
	                    if (--remaining === 0) {
	                        resolve(args);
	                    }
	                } catch (ex) {
	                    reject(ex);
	                }
	            }

	            for (var i = 0; i < args.length; i++) {
	                res(i, args[i]);
	            }
	        });
	    };

	    Promise.resolve = function (value) {
	        if (value && typeof value === 'object' && value.constructor === Promise) {
	            return value;
	        }

	        return new Promise(function (resolve) {
	            resolve(value);
	        });
	    };

	    Promise.reject = function (value) {
	        return new Promise(function (resolve, reject) {
	            reject(value);
	        });
	    };

	    Promise.race = function (values) {
	        return new Promise(function (resolve, reject) {
	            for (var i = 0, len = values.length; i < len; i++) {
	                values[i].then(resolve, reject);
	            }
	        });
	    };

	    /**
	     * Set the immediate function to execute callbacks
	     * @param fn {function} Function to execute
	     * @private
	     */
	    Promise._setImmediateFn = function _setImmediateFn (fn) {
	        asap = fn;
	    };


	    Promise.prototype.always = function (callback) {
	        var constructor = this.constructor;

	        return this.then(function (value) {
	            return constructor.resolve(callback()).then(function () {
	                return value;
	            });
	        }, function (reason) {
	            return constructor.resolve(callback()).then(function () {
	                throw reason;
	            });
	        });
	    };

	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = Promise;
	    } else if (!root.Promise) {
	        root.Promise = Promise;
	    }

	})(this);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).setImmediate))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(3);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(4)))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	//@source https://xts.so/demo/compress/index.html

	// 早期版本的浏览器需要用BlobBuilder来构造Blob，创建一个通用构造器来兼容早期版本
	var BlobConstructor = ((function () {
	    try {
	        new Blob();
	        return true;
	    } catch (e) {
	        return false;
	    }
	})()) ? window.Blob : function (parts, opts) {
	    var bb = new (
	        window.BlobBuilder
	        || window.WebKitBlobBuilder
	        || window.MSBlobBuilder
	        || window.MozBlobBuilder
	    );
	    parts.forEach(function (p) {
	        bb.append(p);
	    });

	    return bb.getBlob(opts ? opts.type : undefined);
	};

	// Android上的AppleWebKit 534以前的内核存在一个Bug，
	// 导致FormData加入一个Blob对象后，上传的文件是0字节
	function hasFormDataBug () {
	    var bCheck = ~navigator.userAgent.indexOf('Android')
	        && ~navigator.vendor.indexOf('Google')
	        && !~navigator.userAgent.indexOf('Chrome');

	    // QQ X5浏览器也有这个BUG
	    return bCheck && navigator.userAgent.match(/AppleWebKit\/(\d+)/).pop() <= 534 || /MQQBrowser/g.test(navigator.userAgent);
	}
	var FormDataShim=(function(){
	    var formDataShimNums = 0;
	    function FormDataShim () {
	        var
	        // Store a reference to this
	        o        = this,
	    
	        // Data to be sent
	        parts = [],
	    
	        // Boundary parameter for separating the multipart values
	        boundary = Array(21).join('-') + (+new Date() * (1e16 * Math.random())).toString(36),
	    
	        // Store the current XHR send method so we can safely override it
	        oldSend  = XMLHttpRequest.prototype.send;
	        this.getParts = function () {
	            return parts.toString();
	        };
	        this.append   = function (name, value, filename) {
	            parts.push('--' + boundary + '\r\nContent-Disposition: form-data; name="' + name + '"');
	    
	            if (value instanceof Blob) {
	                parts.push('; filename="' + (filename || 'blob') + '"\r\nContent-Type: ' + value.type + '\r\n\r\n');
	                parts.push(value);
	            }
	            else {
	                parts.push('\r\n\r\n' + value);
	            }
	            parts.push('\r\n');
	        };
	    
	        formDataShimNums++;
	        XMLHttpRequest.prototype.send = function (val) {
	            var fr,
	                data,
	                oXHR = this;
	    
	            if (val === o) {
	                // Append the final boundary string
	                parts.push('--' + boundary + '--\r\n');
	                // Create the blob
	                data = new BlobConstructor(parts);
	    
	                // Set up and read the blob into an array to be sent
	                fr         = new FileReader();
	                fr.onload  = function () {
	                    oldSend.call(oXHR, fr.result);
	                };
	                fr.onerror = function (err) {
	                    throw err;
	                };
	                fr.readAsArrayBuffer(data);
	    
	                // Set the multipart content type and boudary
	                this.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + boundary);
	                formDataShimNums--;
	                if(formDataShimNums == 0){
	                    XMLHttpRequest.prototype.send = oldSend;
	                }
	            }
	            else {
	                oldSend.call(this, val);
	            }
	        };
	    };
	    FormDataShim.prototype = Object.create(FormData.prototype);
	    return FormDataShim;
	})();


	module.exports = {
	    Blob    : BlobConstructor,
	    FormData: hasFormDataBug() ? FormDataShim : FormData
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* exif */
	(function () {

	    var debug = false;

	    var root = this;

	    var EXIF = function (obj) {
	        if (obj instanceof EXIF) return obj;
	        if (!(this instanceof EXIF)) return new EXIF(obj);
	        this.EXIFwrapped = obj;
	    };

	    if (true) {
	        if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = EXIF;
	        }
	        exports.EXIF = EXIF;
	    } else {
	        root.EXIF = EXIF;
	    }

	    var ExifTags = EXIF.Tags = {

	        // version tags
	        0x9000: "ExifVersion",             // EXIF version
	        0xA000: "FlashpixVersion",         // Flashpix format version

	        // colorspace tags
	        0xA001: "ColorSpace",              // Color space information tag

	        // image configuration
	        0xA002: "PixelXDimension",         // Valid width of meaningful image
	        0xA003: "PixelYDimension",         // Valid height of meaningful image
	        0x9101: "ComponentsConfiguration", // Information about channels
	        0x9102: "CompressedBitsPerPixel",  // Compressed bits per pixel

	        // user information
	        0x927C: "MakerNote",               // Any desired information written by the manufacturer
	        0x9286: "UserComment",             // Comments by user

	        // related file
	        0xA004: "RelatedSoundFile",        // Name of related sound file

	        // date and time
	        0x9003: "DateTimeOriginal",        // Date and time when the original image was generated
	        0x9004: "DateTimeDigitized",       // Date and time when the image was stored digitally
	        0x9290: "SubsecTime",              // Fractions of seconds for DateTime
	        0x9291: "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
	        0x9292: "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

	        // picture-taking conditions
	        0x829A: "ExposureTime",            // Exposure time (in seconds)
	        0x829D: "FNumber",                 // F number
	        0x8822: "ExposureProgram",         // Exposure program
	        0x8824: "SpectralSensitivity",     // Spectral sensitivity
	        0x8827: "ISOSpeedRatings",         // ISO speed rating
	        0x8828: "OECF",                    // Optoelectric conversion factor
	        0x9201: "ShutterSpeedValue",       // Shutter speed
	        0x9202: "ApertureValue",           // Lens aperture
	        0x9203: "BrightnessValue",         // Value of brightness
	        0x9204: "ExposureBias",            // Exposure bias
	        0x9205: "MaxApertureValue",        // Smallest F number of lens
	        0x9206: "SubjectDistance",         // Distance to subject in meters
	        0x9207: "MeteringMode",            // Metering mode
	        0x9208: "LightSource",             // Kind of light source
	        0x9209: "Flash",                   // Flash status
	        0x9214: "SubjectArea",             // Location and area of main subject
	        0x920A: "FocalLength",             // Focal length of the lens in mm
	        0xA20B: "FlashEnergy",             // Strobe energy in BCPS
	        0xA20C: "SpatialFrequencyResponse",    //
	        0xA20E: "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
	        0xA20F: "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
	        0xA210: "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
	        0xA214: "SubjectLocation",         // Location of subject in image
	        0xA215: "ExposureIndex",           // Exposure index selected on camera
	        0xA217: "SensingMethod",           // Image sensor type
	        0xA300: "FileSource",              // Image source (3 == DSC)
	        0xA301: "SceneType",               // Scene type (1 == directly photographed)
	        0xA302: "CFAPattern",              // Color filter array geometric pattern
	        0xA401: "CustomRendered",          // Special processing
	        0xA402: "ExposureMode",            // Exposure mode
	        0xA403: "WhiteBalance",            // 1 = auto white balance, 2 = manual
	        0xA404: "DigitalZoomRation",       // Digital zoom ratio
	        0xA405: "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
	        0xA406: "SceneCaptureType",        // Type of scene
	        0xA407: "GainControl",             // Degree of overall image gain adjustment
	        0xA408: "Contrast",                // Direction of contrast processing applied by camera
	        0xA409: "Saturation",              // Direction of saturation processing applied by camera
	        0xA40A: "Sharpness",               // Direction of sharpness processing applied by camera
	        0xA40B: "DeviceSettingDescription",    //
	        0xA40C: "SubjectDistanceRange",    // Distance to subject

	        // other tags
	        0xA005: "InteroperabilityIFDPointer",
	        0xA420: "ImageUniqueID"            // Identifier assigned uniquely to each image
	    };

	    var TiffTags = EXIF.TiffTags = {
	        0x0100: "ImageWidth",
	        0x0101: "ImageHeight",
	        0x8769: "ExifIFDPointer",
	        0x8825: "GPSInfoIFDPointer",
	        0xA005: "InteroperabilityIFDPointer",
	        0x0102: "BitsPerSample",
	        0x0103: "Compression",
	        0x0106: "PhotometricInterpretation",
	        0x0112: "Orientation",
	        0x0115: "SamplesPerPixel",
	        0x011C: "PlanarConfiguration",
	        0x0212: "YCbCrSubSampling",
	        0x0213: "YCbCrPositioning",
	        0x011A: "XResolution",
	        0x011B: "YResolution",
	        0x0128: "ResolutionUnit",
	        0x0111: "StripOffsets",
	        0x0116: "RowsPerStrip",
	        0x0117: "StripByteCounts",
	        0x0201: "JPEGInterchangeFormat",
	        0x0202: "JPEGInterchangeFormatLength",
	        0x012D: "TransferFunction",
	        0x013E: "WhitePoint",
	        0x013F: "PrimaryChromaticities",
	        0x0211: "YCbCrCoefficients",
	        0x0214: "ReferenceBlackWhite",
	        0x0132: "DateTime",
	        0x010E: "ImageDescription",
	        0x010F: "Make",
	        0x0110: "Model",
	        0x0131: "Software",
	        0x013B: "Artist",
	        0x8298: "Copyright"
	    };

	    var GPSTags = EXIF.GPSTags = {
	        0x0000: "GPSVersionID",
	        0x0001: "GPSLatitudeRef",
	        0x0002: "GPSLatitude",
	        0x0003: "GPSLongitudeRef",
	        0x0004: "GPSLongitude",
	        0x0005: "GPSAltitudeRef",
	        0x0006: "GPSAltitude",
	        0x0007: "GPSTimeStamp",
	        0x0008: "GPSSatellites",
	        0x0009: "GPSStatus",
	        0x000A: "GPSMeasureMode",
	        0x000B: "GPSDOP",
	        0x000C: "GPSSpeedRef",
	        0x000D: "GPSSpeed",
	        0x000E: "GPSTrackRef",
	        0x000F: "GPSTrack",
	        0x0010: "GPSImgDirectionRef",
	        0x0011: "GPSImgDirection",
	        0x0012: "GPSMapDatum",
	        0x0013: "GPSDestLatitudeRef",
	        0x0014: "GPSDestLatitude",
	        0x0015: "GPSDestLongitudeRef",
	        0x0016: "GPSDestLongitude",
	        0x0017: "GPSDestBearingRef",
	        0x0018: "GPSDestBearing",
	        0x0019: "GPSDestDistanceRef",
	        0x001A: "GPSDestDistance",
	        0x001B: "GPSProcessingMethod",
	        0x001C: "GPSAreaInformation",
	        0x001D: "GPSDateStamp",
	        0x001E: "GPSDifferential"
	    };

	    var StringValues = EXIF.StringValues = {
	        ExposureProgram     : {
	            0: "Not defined",
	            1: "Manual",
	            2: "Normal program",
	            3: "Aperture priority",
	            4: "Shutter priority",
	            5: "Creative program",
	            6: "Action program",
	            7: "Portrait mode",
	            8: "Landscape mode"
	        },
	        MeteringMode        : {
	            0  : "Unknown",
	            1  : "Average",
	            2  : "CenterWeightedAverage",
	            3  : "Spot",
	            4  : "MultiSpot",
	            5  : "Pattern",
	            6  : "Partial",
	            255: "Other"
	        },
	        LightSource         : {
	            0  : "Unknown",
	            1  : "Daylight",
	            2  : "Fluorescent",
	            3  : "Tungsten (incandescent light)",
	            4  : "Flash",
	            9  : "Fine weather",
	            10 : "Cloudy weather",
	            11 : "Shade",
	            12 : "Daylight fluorescent (D 5700 - 7100K)",
	            13 : "Day white fluorescent (N 4600 - 5400K)",
	            14 : "Cool white fluorescent (W 3900 - 4500K)",
	            15 : "White fluorescent (WW 3200 - 3700K)",
	            17 : "Standard light A",
	            18 : "Standard light B",
	            19 : "Standard light C",
	            20 : "D55",
	            21 : "D65",
	            22 : "D75",
	            23 : "D50",
	            24 : "ISO studio tungsten",
	            255: "Other"
	        },
	        Flash               : {
	            0x0000: "Flash did not fire",
	            0x0001: "Flash fired",
	            0x0005: "Strobe return light not detected",
	            0x0007: "Strobe return light detected",
	            0x0009: "Flash fired, compulsory flash mode",
	            0x000D: "Flash fired, compulsory flash mode, return light not detected",
	            0x000F: "Flash fired, compulsory flash mode, return light detected",
	            0x0010: "Flash did not fire, compulsory flash mode",
	            0x0018: "Flash did not fire, auto mode",
	            0x0019: "Flash fired, auto mode",
	            0x001D: "Flash fired, auto mode, return light not detected",
	            0x001F: "Flash fired, auto mode, return light detected",
	            0x0020: "No flash function",
	            0x0041: "Flash fired, red-eye reduction mode",
	            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
	            0x0047: "Flash fired, red-eye reduction mode, return light detected",
	            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
	            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
	            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
	            0x0059: "Flash fired, auto mode, red-eye reduction mode",
	            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
	            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
	        },
	        SensingMethod       : {
	            1: "Not defined",
	            2: "One-chip color area sensor",
	            3: "Two-chip color area sensor",
	            4: "Three-chip color area sensor",
	            5: "Color sequential area sensor",
	            7: "Trilinear sensor",
	            8: "Color sequential linear sensor"
	        },
	        SceneCaptureType    : {
	            0: "Standard",
	            1: "Landscape",
	            2: "Portrait",
	            3: "Night scene"
	        },
	        SceneType           : {
	            1: "Directly photographed"
	        },
	        CustomRendered      : {
	            0: "Normal process",
	            1: "Custom process"
	        },
	        WhiteBalance        : {
	            0: "Auto white balance",
	            1: "Manual white balance"
	        },
	        GainControl         : {
	            0: "None",
	            1: "Low gain up",
	            2: "High gain up",
	            3: "Low gain down",
	            4: "High gain down"
	        },
	        Contrast            : {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        Saturation          : {
	            0: "Normal",
	            1: "Low saturation",
	            2: "High saturation"
	        },
	        Sharpness           : {
	            0: "Normal",
	            1: "Soft",
	            2: "Hard"
	        },
	        SubjectDistanceRange: {
	            0: "Unknown",
	            1: "Macro",
	            2: "Close view",
	            3: "Distant view"
	        },
	        FileSource          : {
	            3: "DSC"
	        },

	        Components: {
	            0: "",
	            1: "Y",
	            2: "Cb",
	            3: "Cr",
	            4: "R",
	            5: "G",
	            6: "B"
	        }
	    };

	    function addEvent (element, event, handler) {
	        if (element.addEventListener) {
	            element.addEventListener(event, handler, false);
	        } else if (element.attachEvent) {
	            element.attachEvent("on" + event, handler);
	        }
	    }

	    function imageHasData (img) {
	        return !!(img.exifdata);
	    }


	    function base64ToArrayBuffer (base64, contentType) {
	        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
	        base64     = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
	        var binary = atob(base64);
	        var len    = binary.length;
	        var buffer = new ArrayBuffer(len);
	        var view   = new Uint8Array(buffer);
	        for (var i = 0; i < len; i++) {
	            view[i] = binary.charCodeAt(i);
	        }
	        return buffer;
	    }

	    function objectURLToBlob (url, callback) {
	        var http          = new XMLHttpRequest();
	        http.open("GET", url, true);
	        http.responseType = "blob";
	        http.onload       = function (e) {
	            if (this.status == 200 || this.status === 0) {
	                callback(this.response);
	            }
	        };
	        http.send();
	    }

	    function getImageData (img, callback) {
	        function handleBinaryFile (binFile) {
	            var data     = findEXIFinJPEG(binFile);
	            var iptcdata = findIPTCinJPEG(binFile);
	            img.exifdata = data || {};
	            img.iptcdata = iptcdata || {};
	            if (callback) {
	                callback.call(img);
	            }
	        }

	        if (img.src) {
	            if (/^data\:/i.test(img.src)) { // Data URI
	                var arrayBuffer = base64ToArrayBuffer(img.src);
	                handleBinaryFile(arrayBuffer);

	            } else if (/^blob\:/i.test(img.src)) { // Object URL
	                var fileReader    = new FileReader();
	                fileReader.onload = function (e) {
	                    handleBinaryFile(e.target.result);
	                };
	                objectURLToBlob(img.src, function (blob) {
	                    fileReader.readAsArrayBuffer(blob);
	                });
	            } else {
	                var http          = new XMLHttpRequest();
	                http.onload       = function () {
	                    if (this.status == 200 || this.status === 0) {
	                        handleBinaryFile(http.response);
	                    } else {
	                        callback(new Error("Could not load image"));
	                    }
	                    http = null;
	                };
	                http.open("GET", img.src, true);
	                http.responseType = "arraybuffer";
	                http.send(null);
	            }
	        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
	            var fileReader    = new FileReader();
	            fileReader.onload = function (e) {
	                if (debug) console.log("Got file of length " + e.target.result.byteLength);
	                handleBinaryFile(e.target.result);
	            };

	            fileReader.readAsArrayBuffer(img);
	        }
	    }

	    function findEXIFinJPEG (file) {
	        var dataView = new DataView(file);

	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }

	        var offset = 2,
	            length = file.byteLength,
	            marker;

	        while (offset < length) {
	            if (dataView.getUint8(offset) != 0xFF) {
	                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
	                return false; // not a valid marker, something is wrong
	            }

	            marker = dataView.getUint8(offset + 1);
	            if (debug) console.log(marker);

	            // we could implement handling for other markers here,
	            // but we're only looking for 0xFFE1 for EXIF data

	            if (marker == 225) {
	                if (debug) console.log("Found 0xFFE1 marker");

	                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

	                // offset += 2 + file.getShortAt(offset+2, true);

	            } else {
	                offset += 2 + dataView.getUint16(offset + 2);
	            }

	        }

	    }

	    function findIPTCinJPEG (file) {
	        var dataView = new DataView(file);

	        if (debug) console.log("Got file of length " + file.byteLength);
	        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
	            if (debug) console.log("Not a valid JPEG");
	            return false; // not a valid jpeg
	        }

	        var offset = 2,
	            length = file.byteLength;


	        var isFieldSegmentStart = function (dataView, offset) {
	            return (
	                dataView.getUint8(offset) === 0x38 &&
	                dataView.getUint8(offset + 1) === 0x42 &&
	                dataView.getUint8(offset + 2) === 0x49 &&
	                dataView.getUint8(offset + 3) === 0x4D &&
	                dataView.getUint8(offset + 4) === 0x04 &&
	                dataView.getUint8(offset + 5) === 0x04
	            );
	        };

	        while (offset < length) {

	            if (isFieldSegmentStart(dataView, offset)) {

	                // Get the length of the name header (which is padded to an even number of bytes)
	                var nameHeaderLength = dataView.getUint8(offset + 7);
	                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
	                // Check for pre photoshop 6 format
	                if (nameHeaderLength === 0) {
	                    // Always 4
	                    nameHeaderLength = 4;
	                }

	                var startOffset   = offset + 8 + nameHeaderLength;
	                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

	                return readIPTCData(file, startOffset, sectionLength);

	                break;

	            }


	            // Not the marker, continue searching
	            offset++;

	        }

	    }

	    var IptcFieldMap = {
	        0x78: 'caption',
	        0x6E: 'credit',
	        0x19: 'keywords',
	        0x37: 'dateCreated',
	        0x50: 'byline',
	        0x55: 'bylineTitle',
	        0x7A: 'captionWriter',
	        0x69: 'headline',
	        0x74: 'copyright',
	        0x0F: 'category'
	    };

	    function readIPTCData (file, startOffset, sectionLength) {
	        var dataView        = new DataView(file);
	        var data            = {};
	        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
	        var segmentStartPos = startOffset;
	        while (segmentStartPos < startOffset + sectionLength) {
	            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
	                segmentType = dataView.getUint8(segmentStartPos + 2);
	                if (segmentType in IptcFieldMap) {
	                    dataSize    = dataView.getInt16(segmentStartPos + 3);
	                    segmentSize = dataSize + 5;
	                    fieldName   = IptcFieldMap[segmentType];
	                    fieldValue  = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
	                    // Check if we already stored a value with this name
	                    if (data.hasOwnProperty(fieldName)) {
	                        // Value already stored with this name, create multivalue field
	                        if (data[fieldName] instanceof Array) {
	                            data[fieldName].push(fieldValue);
	                        }
	                        else {
	                            data[fieldName] = [data[fieldName], fieldValue];
	                        }
	                    }
	                    else {
	                        data[fieldName] = fieldValue;
	                    }
	                }

	            }
	            segmentStartPos++;
	        }
	        return data;
	    }


	    function readTags (file, tiffStart, dirStart, strings, bigEnd) {
	        var entries = file.getUint16(dirStart, !bigEnd),
	            tags    = {},
	            entryOffset, tag,
	            i;

	        for (i = 0; i < entries; i++) {
	            entryOffset = dirStart + i * 12 + 2;
	            tag         = strings[file.getUint16(entryOffset, !bigEnd)];
	            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
	            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
	        }
	        return tags;
	    }


	    function readTagValue (file, entryOffset, tiffStart, dirStart, bigEnd) {
	        var type        = file.getUint16(entryOffset + 2, !bigEnd),
	            numValues   = file.getUint32(entryOffset + 4, !bigEnd),
	            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
	            offset,
	            vals, val, n,
	            numerator, denominator;

	        switch (type) {
	            case 1: // byte, 8-bit unsigned int
	            case 7: // undefined, 8-bit byte, value depending on field
	                if (numValues == 1) {
	                    return file.getUint8(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                    vals   = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint8(offset + n);
	                    }
	                    return vals;
	                }

	            case 2: // ascii, 8-bit byte
	                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
	                return getStringFromDB(file, offset, numValues - 1);

	            case 3: // short, 16 bit int
	                if (numValues == 1) {
	                    return file.getUint16(entryOffset + 8, !bigEnd);
	                } else {
	                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
	                    vals   = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
	                    }
	                    return vals;
	                }

	            case 4: // long, 32 bit int
	                if (numValues == 1) {
	                    return file.getUint32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }

	            case 5:    // rational = two long values, first is numerator, second is denominator
	                if (numValues == 1) {
	                    numerator       = file.getUint32(valueOffset, !bigEnd);
	                    denominator     = file.getUint32(valueOffset + 4, !bigEnd);
	                    val             = new Number(numerator / denominator);
	                    val.numerator   = numerator;
	                    val.denominator = denominator;
	                    return val;
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        numerator           = file.getUint32(valueOffset + 8 * n, !bigEnd);
	                        denominator         = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
	                        vals[n]             = new Number(numerator / denominator);
	                        vals[n].numerator   = numerator;
	                        vals[n].denominator = denominator;
	                    }
	                    return vals;
	                }

	            case 9: // slong, 32 bit signed int
	                if (numValues == 1) {
	                    return file.getInt32(entryOffset + 8, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
	                    }
	                    return vals;
	                }

	            case 10: // signed rational, two slongs, first is numerator, second is denominator
	                if (numValues == 1) {
	                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
	                } else {
	                    vals = [];
	                    for (n = 0; n < numValues; n++) {
	                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
	                    }
	                    return vals;
	                }
	        }
	    }

	    function getStringFromDB (buffer, start, length) {
	        var outstr = "", n;
	        for (n = start; n < start + length; n++) {
	            outstr += String.fromCharCode(buffer.getUint8(n));
	        }
	        return outstr;
	    }

	    function readEXIFData (file, start) {
	        if (getStringFromDB(file, start, 4) != "Exif") {
	            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
	            return false;
	        }

	        var bigEnd,
	            tags, tag,
	            exifData, gpsData,
	            tiffOffset = start + 6;

	        // test for TIFF validity and endianness
	        if (file.getUint16(tiffOffset) == 0x4949) {
	            bigEnd = false;
	        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
	            bigEnd = true;
	        } else {
	            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
	            return false;
	        }

	        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
	            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
	            return false;
	        }

	        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

	        if (firstIFDOffset < 0x00000008) {
	            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
	            return false;
	        }

	        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

	        if (tags.ExifIFDPointer) {
	            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
	            for (tag in exifData) {
	                switch (tag) {
	                    case "LightSource" :
	                    case "Flash" :
	                    case "MeteringMode" :
	                    case "ExposureProgram" :
	                    case "SensingMethod" :
	                    case "SceneCaptureType" :
	                    case "SceneType" :
	                    case "CustomRendered" :
	                    case "WhiteBalance" :
	                    case "GainControl" :
	                    case "Contrast" :
	                    case "Saturation" :
	                    case "Sharpness" :
	                    case "SubjectDistanceRange" :
	                    case "FileSource" :
	                        exifData[tag] = StringValues[tag][exifData[tag]];
	                        break;

	                    case "ExifVersion" :
	                    case "FlashpixVersion" :
	                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
	                        break;

	                    case "ComponentsConfiguration" :
	                        exifData[tag] =
	                            StringValues.Components[exifData[tag][0]] +
	                            StringValues.Components[exifData[tag][1]] +
	                            StringValues.Components[exifData[tag][2]] +
	                            StringValues.Components[exifData[tag][3]];
	                        break;
	                }
	                tags[tag] = exifData[tag];
	            }
	        }

	        if (tags.GPSInfoIFDPointer) {
	            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
	            for (tag in gpsData) {
	                switch (tag) {
	                    case "GPSVersionID" :
	                        gpsData[tag] = gpsData[tag][0] +
	                            "." + gpsData[tag][1] +
	                            "." + gpsData[tag][2] +
	                            "." + gpsData[tag][3];
	                        break;
	                }
	                tags[tag] = gpsData[tag];
	            }
	        }

	        return tags;
	    }

	    EXIF.getData = function (img, callback) {
	        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;

	        if (!imageHasData(img)) {
	            getImageData(img, callback);
	        } else {
	            if (callback) {
	                callback.call(img);
	            }
	        }
	        return true;
	    }

	    EXIF.getTag = function (img, tag) {
	        if (!imageHasData(img)) return;
	        return img.exifdata[tag];
	    }

	    EXIF.getAllTags = function (img) {
	        if (!imageHasData(img)) return {};
	        var a,
	            data = img.exifdata,
	            tags = {};
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                tags[a] = data[a];
	            }
	        }
	        return tags;
	    }

	    EXIF.pretty = function (img) {
	        if (!imageHasData(img)) return "";
	        var a,
	            data      = img.exifdata,
	            strPretty = "";
	        for (a in data) {
	            if (data.hasOwnProperty(a)) {
	                if (typeof data[a] == "object") {
	                    if (data[a] instanceof Number) {
	                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
	                    } else {
	                        strPretty += a + " : [" + data[a].length + " values]\r\n";
	                    }
	                } else {
	                    strPretty += a + " : " + data[a] + "\r\n";
	                }
	            }
	        }
	        return strPretty;
	    }

	    EXIF.readFromBinaryFile = function (file) {
	        return findEXIFinJPEG(file);
	    }

	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return EXIF;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	}.call(this));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Mega pixel image rendering library for iOS6 Safari
	 *
	 * Fixes iOS6 Safari's image file rendering issue for large size image (over mega-pixel),
	 * which causes unexpected subsampling when drawing it in canvas.
	 * By using this library, you can safely render the image with proper stretching.
	 *
	 * Copyright (c) 2012 Shinichi Tomita <shinichi.tomita@gmail.com>
	 * Released under the MIT license
	 */
	(function () {

	    /**
	     * Detect subsampling in loaded image.
	     * In iOS, larger images than 2M pixels may be subsampled in rendering.
	     */
	    function detectSubsampling (img) {
	        var iw = img.naturalWidth, ih = img.naturalHeight;
	        if (iw * ih > 1024 * 1024) { // subsampling may happen over megapixel image
	            var canvas   = document.createElement('canvas');
	            canvas.width = canvas.height = 1;
	            var ctx = canvas.getContext('2d');
	            ctx.drawImage(img, -iw + 1, 0);
	            // subsampled image becomes half smaller in rendering size.
	            // check alpha channel value to confirm image is covering edge pixel or not.
	            // if alpha value is 0 image is not covering, hence subsampled.
	            return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
	        } else {
	            return false;
	        }
	    }

	    /**
	     * Detecting vertical squash in loaded image.
	     * Fixes a bug which squash image vertically while drawing into canvas for some images.
	     */
	    function detectVerticalSquash (img, iw, ih) {
	        var canvas    = document.createElement('canvas');
	        canvas.width  = 1;
	        canvas.height = ih;
	        var ctx       = canvas.getContext('2d');
	        ctx.drawImage(img, 0, 0);
	        var data      = ctx.getImageData(0, 0, 1, ih).data;
	        // search image edge pixel position in case it is squashed vertically.
	        var sy = 0;
	        var ey = ih;
	        var py = ih;
	        while (py > sy) {
	            var alpha = data[(py - 1) * 4 + 3];
	            if (alpha === 0) {
	                ey = py;
	            } else {
	                sy = py;
	            }
	            py = (ey + sy) >> 1;
	        }
	        var ratio = (py / ih);
	        return (ratio === 0) ? 1 : ratio;
	    }

	    /**
	     * Rendering image element (with resizing) and get its data URL
	     */
	    function renderImageToDataURL (img, options, doSquash) {
	        var canvas = document.createElement('canvas');
	        renderImageToCanvas(img, canvas, options, doSquash);
	        return canvas.toDataURL("image/jpeg", options.quality || 0.8);
	    }

	    /**
	     * Rendering image element (with resizing) into the canvas element
	     */
	    function renderImageToCanvas (img, canvas, options, doSquash) {
	        var iw         = img.naturalWidth, ih = img.naturalHeight;
	        var width      = options.width, height = options.height;
	        var ctx        = canvas.getContext('2d');
	        ctx.save();
	        transformCoordinate(canvas, ctx, width, height, options.orientation);
	        var subsampled = detectSubsampling(img);
	        if (subsampled) {
	            iw /= 2;
	            ih /= 2;
	        }
	        var d = 1024; // size of tiling canvas
	        var tmpCanvas   = document.createElement('canvas');
	        tmpCanvas.width = tmpCanvas.height = d;
	        var tmpCtx          = tmpCanvas.getContext('2d');
	        var vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1;
	        var dw              = Math.ceil(d * width / iw);
	        var dh              = Math.ceil(d * height / ih / vertSquashRatio);
	        var sy              = 0;
	        var dy              = 0;
	        while (sy < ih) {
	            var sx = 0;
	            var dx = 0;
	            while (sx < iw) {
	                tmpCtx.clearRect(0, 0, d, d);
	                tmpCtx.drawImage(img, -sx, -sy);
	                ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
	                sx += d;
	                dx += dw;
	            }
	            sy += d;
	            dy += dh;
	        }
	        ctx.restore();
	        tmpCanvas           = tmpCtx = null;
	    }

	    /**
	     * Transform canvas coordination according to specified frame size and orientation
	     * Orientation value is from EXIF tag
	     */
	    function transformCoordinate (canvas, ctx, width, height, orientation) {
	        switch (orientation) {
	            case 5:
	            case 6:
	            case 7:
	            case 8:
	                canvas.width  = height;
	                canvas.height = width;
	                break;
	            default:
	                canvas.width  = width;
	                canvas.height = height;
	        }
	        switch (orientation) {
	            case 2:
	                // horizontal flip
	                ctx.translate(width, 0);
	                ctx.scale(-1, 1);
	                break;
	            case 3:
	                // 180 rotate left
	                ctx.translate(width, height);
	                ctx.rotate(Math.PI);
	                break;
	            case 4:
	                // vertical flip
	                ctx.translate(0, height);
	                ctx.scale(1, -1);
	                break;
	            case 5:
	                // vertical flip + 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.scale(1, -1);
	                break;
	            case 6:
	                // 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.translate(0, -height);
	                break;
	            case 7:
	                // horizontal flip + 90 rotate right
	                ctx.rotate(0.5 * Math.PI);
	                ctx.translate(width, -height);
	                ctx.scale(-1, 1);
	                break;
	            case 8:
	                // 90 rotate left
	                ctx.rotate(-0.5 * Math.PI);
	                ctx.translate(-width, 0);
	                break;
	            default:
	                break;
	        }
	    }


	    /**
	     * MegaPixImage class
	     */
	    function MegaPixImage (srcImage) {
	        if (window.Blob && srcImage instanceof Blob) {
	            var img = new Image();
	            var URL = window.URL && window.URL.createObjectURL ? window.URL :
	                window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL :
	                    null;
	            if (!URL) {
	                throw Error("No createObjectURL function found to create blob url");
	            }
	            img.src   = URL.createObjectURL(srcImage);
	            this.blob = srcImage;
	            srcImage  = img;
	        }
	        if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
	            var _this               = this;
	            srcImage.onload         = function () {
	                var listeners = _this.imageLoadListeners;
	                if (listeners) {
	                    _this.imageLoadListeners = null;
	                    for (var i = 0, len = listeners.length; i < len; i++) {
	                        listeners[i]();
	                    }
	                }
	            };
	            this.imageLoadListeners = [];
	        }
	        this.srcImage = srcImage;
	    }

	    /**
	     * Rendering megapix image into specified target element
	     */
	    MegaPixImage.prototype.render = function (target, options, callback) {
	        if (this.imageLoadListeners) {
	            var _this = this;
	            this.imageLoadListeners.push(function () {
	                _this.render(target, options, callback);
	            });
	            return;
	        }
	        options       = options || {};
	        var srcImage  = this.srcImage,
	            src       = srcImage.src,
	            srcLength = src.length,
	            imgWidth  = srcImage.naturalWidth, imgHeight = srcImage.naturalHeight,
	            width     = options.width, height = options.height,
	            maxWidth  = options.maxWidth, maxHeight = options.maxHeight,
	            doSquash  = this.blob && this.blob.type === 'image/jpeg' ||
	                src.indexOf('data:image/jpeg') === 0 ||
	                src.indexOf('.jpg') === srcLength - 4 ||
	                src.indexOf('.jpeg') === srcLength - 5;
	        if (width && !height) {
	            height = (imgHeight * width / imgWidth) << 0;
	        } else if (height && !width) {
	            width = (imgWidth * height / imgHeight) << 0;
	        } else {
	            width  = imgWidth;
	            height = imgHeight;
	        }
	        if (maxWidth && width > maxWidth) {
	            width  = maxWidth;
	            height = (imgHeight * width / imgWidth) << 0;
	        }
	        if (maxHeight && height > maxHeight) {
	            height = maxHeight;
	            width  = (imgWidth * height / imgHeight) << 0;
	        }
	        var opt = {width: width, height: height};
	        for (var k in options) opt[k] = options[k];

	        var tagName = target.tagName.toLowerCase();
	        if (tagName === 'img') {
	            target.src = renderImageToDataURL(this.srcImage, opt, doSquash);
	        } else if (tagName === 'canvas') {
	            renderImageToCanvas(this.srcImage, target, opt, doSquash);
	        }
	        if (typeof this.onrender === 'function') {
	            this.onrender(target);
	        }
	        if (callback) {
	            callback();
	        }
	    };

	    /**
	     * Export class to global
	     */
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	            return MegaPixImage;
	        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // for AMD loader
	    } else {
	        this.MegaPixImage = MegaPixImage;
	    }

	})();


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	function JPEGEncoder (l) {
	    var o = this;
	    var s = Math.round;
	    var k = Math.floor;
	    var O = new Array(64);
	    var K = new Array(64);
	    var d = new Array(64);
	    var Z = new Array(64);
	    var u;
	    var h;
	    var G;
	    var T;
	    var n = new Array(65535);
	    var m = new Array(65535);
	    var P = new Array(64);
	    var S = new Array(64);
	    var j = [];
	    var t = 0;
	    var a = 7;
	    var A = new Array(64);
	    var f = new Array(64);
	    var U = new Array(64);
	    var e = new Array(256);
	    var C = new Array(2048);
	    var x;
	    var i = [0, 1, 5, 6, 14, 15, 27, 28, 2, 4, 7, 13, 16, 26, 29, 42, 3, 8, 12, 17, 25, 30, 41, 43, 9, 11, 18, 24, 31, 40, 44, 53, 10, 19, 23, 32, 39, 45, 52, 54, 20, 22, 33, 38, 46, 51, 55, 60, 21, 34, 37, 47, 50, 56, 59, 61, 35, 36, 48, 49, 57, 58, 62, 63];
	    var g = [0, 0, 1, 5, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0];
	    var c = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	    var w = [0, 0, 2, 1, 3, 3, 2, 4, 3, 5, 5, 4, 4, 0, 0, 1, 125];
	    var E = [1, 2, 3, 0, 4, 17, 5, 18, 33, 49, 65, 6, 19, 81, 97, 7, 34, 113, 20, 50, 129, 145, 161, 8, 35, 66, 177, 193, 21, 82, 209, 240, 36, 51, 98, 114, 130, 9, 10, 22, 23, 24, 25, 26, 37, 38, 39, 40, 41, 42, 52, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250];
	    var v = [0, 0, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0];
	    var Y = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
	    var J = [0, 0, 2, 1, 2, 4, 4, 3, 4, 7, 5, 4, 4, 0, 1, 2, 119];
	    var B = [0, 1, 2, 3, 17, 4, 5, 33, 49, 6, 18, 65, 81, 7, 97, 113, 19, 34, 50, 129, 8, 20, 66, 145, 161, 177, 193, 9, 35, 51, 82, 240, 21, 98, 114, 209, 10, 22, 36, 52, 225, 37, 241, 23, 24, 25, 26, 38, 39, 40, 41, 42, 53, 54, 55, 56, 57, 58, 67, 68, 69, 70, 71, 72, 73, 74, 83, 84, 85, 86, 87, 88, 89, 90, 99, 100, 101, 102, 103, 104, 105, 106, 115, 116, 117, 118, 119, 120, 121, 122, 130, 131, 132, 133, 134, 135, 136, 137, 138, 146, 147, 148, 149, 150, 151, 152, 153, 154, 162, 163, 164, 165, 166, 167, 168, 169, 170, 178, 179, 180, 181, 182, 183, 184, 185, 186, 194, 195, 196, 197, 198, 199, 200, 201, 202, 210, 211, 212, 213, 214, 215, 216, 217, 218, 226, 227, 228, 229, 230, 231, 232, 233, 234, 242, 243, 244, 245, 246, 247, 248, 249, 250];

	    function M (ag) {
	        var af = [16, 11, 10, 16, 24, 40, 51, 61, 12, 12, 14, 19, 26, 58, 60, 55, 14, 13, 16, 24, 40, 57, 69, 56, 14, 17, 22, 29, 51, 87, 80, 62, 18, 22, 37, 56, 68, 109, 103, 77, 24, 35, 55, 64, 81, 104, 113, 92, 49, 64, 78, 87, 103, 121, 120, 101, 72, 92, 95, 98, 112, 100, 103, 99];
	        for (var ae = 0; ae < 64; ae++) {
	            var aj = k((af[ae] * ag + 50) / 100);
	            if (aj < 1) {
	                aj = 1
	            } else {
	                if (aj > 255) {
	                    aj = 255
	                }
	            }
	            O[i[ae]] = aj
	        }
	        var ah = [17, 18, 24, 47, 99, 99, 99, 99, 18, 21, 26, 66, 99, 99, 99, 99, 24, 26, 56, 99, 99, 99, 99, 99, 47, 66, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99, 99];
	        for (var ad = 0; ad < 64; ad++) {
	            var ai = k((ah[ad] * ag + 50) / 100);
	            if (ai < 1) {
	                ai = 1
	            } else {
	                if (ai > 255) {
	                    ai = 255
	                }
	            }
	            K[i[ad]] = ai
	        }
	        var ac = [1, 1.387039845, 1.306562965, 1.175875602, 1, 0.785694958, 0.5411961, 0.275899379];
	        var ab = 0;
	        for (var ak = 0; ak < 8; ak++) {
	            for (var aa = 0; aa < 8; aa++) {
	                d[ab] = (1 / (O[i[ab]] * ac[ak] * ac[aa] * 8));
	                Z[ab] = (1 / (K[i[ab]] * ac[ak] * ac[aa] * 8));
	                ab++
	            }
	        }
	    }

	    function q (ae, aa) {
	        var ad = 0;
	        var ag = 0;
	        var af = new Array();
	        for (var ab = 1; ab <= 16; ab++) {
	            for (var ac = 1; ac <= ae[ab]; ac++) {
	                af[aa[ag]]    = [];
	                af[aa[ag]][0] = ad;
	                af[aa[ag]][1] = ab;
	                ag++;
	                ad++
	            }
	            ad *= 2
	        }
	        return af
	    }

	    function W () {
	        u = q(g, c);
	        h = q(v, Y);
	        G = q(w, E);
	        T = q(J, B)
	    }

	    function z () {
	        var ac = 1;
	        var ab = 2;
	        for (var aa = 1; aa <= 15; aa++) {
	            for (var ad = ac; ad < ab; ad++) {
	                m[32767 + ad]    = aa;
	                n[32767 + ad]    = [];
	                n[32767 + ad][1] = aa;
	                n[32767 + ad][0] = ad
	            }
	            for (var ae = -(ab - 1); ae <= -ac; ae++) {
	                m[32767 + ae]    = aa;
	                n[32767 + ae]    = [];
	                n[32767 + ae][1] = aa;
	                n[32767 + ae][0] = ab - 1 + ae
	            }
	            ac <<= 1;
	            ab <<= 1
	        }
	    }

	    function V () {
	        for (var aa = 0; aa < 256; aa++) {
	            C[aa]               = 19595 * aa;
	            C[(aa + 256) >> 0]  = 38470 * aa;
	            C[(aa + 512) >> 0]  = 7471 * aa + 32768;
	            C[(aa + 768) >> 0]  = -11059 * aa;
	            C[(aa + 1024) >> 0] = -21709 * aa;
	            C[(aa + 1280) >> 0] = 32768 * aa + 8421375;
	            C[(aa + 1536) >> 0] = -27439 * aa;
	            C[(aa + 1792) >> 0] = -5329 * aa
	        }
	    }

	    function X (aa) {
	        var ac = aa[0];
	        var ab = aa[1] - 1;
	        while (ab >= 0) {
	            if (ac & (1 << ab)) {
	                t |= (1 << a)
	            }
	            ab--;
	            a--;
	            if (a < 0) {
	                if (t == 255) {
	                    F(255);
	                    F(0)
	                } else {
	                    F(t)
	                }
	                a = 7;
	                t = 0
	            }
	        }
	    }

	    function F (aa) {
	        j.push(e[aa])
	    }

	    function p (aa) {
	        F((aa >> 8) & 255);
	        F((aa) & 255)
	    }

	    function N (aZ, ap) {
	        var aL, aK, aJ, aI, aH, aD, aC, aB;
	        var aN   = 0;
	        var aR;
	        const aq = 8;
	        const ai = 64;
	        for (aR = 0; aR < aq; ++aR) {
	            aL         = aZ[aN];
	            aK         = aZ[aN + 1];
	            aJ         = aZ[aN + 2];
	            aI         = aZ[aN + 3];
	            aH         = aZ[aN + 4];
	            aD         = aZ[aN + 5];
	            aC         = aZ[aN + 6];
	            aB         = aZ[aN + 7];
	            var aY     = aL + aB;
	            var aO     = aL - aB;
	            var aX     = aK + aC;
	            var aP     = aK - aC;
	            var aU     = aJ + aD;
	            var aQ     = aJ - aD;
	            var aT     = aI + aH;
	            var aS     = aI - aH;
	            var an     = aY + aT;
	            var ak     = aY - aT;
	            var am     = aX + aU;
	            var al     = aX - aU;
	            aZ[aN]     = an + am;
	            aZ[aN + 4] = an - am;
	            var ax     = (al + ak) * 0.707106781;
	            aZ[aN + 2] = ak + ax;
	            aZ[aN + 6] = ak - ax;
	            an         = aS + aQ;
	            am         = aQ + aP;
	            al         = aP + aO;
	            var at     = (an - al) * 0.382683433;
	            var aw     = 0.5411961 * an + at;
	            var au     = 1.306562965 * al + at;
	            var av     = am * 0.707106781;
	            var ah     = aO + av;
	            var ag     = aO - av;
	            aZ[aN + 5] = ag + aw;
	            aZ[aN + 3] = ag - aw;
	            aZ[aN + 1] = ah + au;
	            aZ[aN + 7] = ah - au;
	            aN += 8
	        }
	        aN = 0;
	        for (aR = 0; aR < aq; ++aR) {
	            aL          = aZ[aN];
	            aK          = aZ[aN + 8];
	            aJ          = aZ[aN + 16];
	            aI          = aZ[aN + 24];
	            aH          = aZ[aN + 32];
	            aD          = aZ[aN + 40];
	            aC          = aZ[aN + 48];
	            aB          = aZ[aN + 56];
	            var ar      = aL + aB;
	            var aj      = aL - aB;
	            var az      = aK + aC;
	            var ae      = aK - aC;
	            var aG      = aJ + aD;
	            var ac      = aJ - aD;
	            var aW      = aI + aH;
	            var aa      = aI - aH;
	            var ao      = ar + aW;
	            var aV      = ar - aW;
	            var ay      = az + aG;
	            var aF      = az - aG;
	            aZ[aN]      = ao + ay;
	            aZ[aN + 32] = ao - ay;
	            var af      = (aF + aV) * 0.707106781;
	            aZ[aN + 16] = aV + af;
	            aZ[aN + 48] = aV - af;
	            ao          = aa + ac;
	            ay          = ac + ae;
	            aF          = ae + aj;
	            var aM      = (ao - aF) * 0.382683433;
	            var ad      = 0.5411961 * ao + aM;
	            var a1      = 1.306562965 * aF + aM;
	            var ab      = ay * 0.707106781;
	            var a0      = aj + ab;
	            var aA      = aj - ab;
	            aZ[aN + 40] = aA + ad;
	            aZ[aN + 24] = aA - ad;
	            aZ[aN + 8]  = a0 + a1;
	            aZ[aN + 56] = a0 - a1;
	            aN++
	        }
	        var aE;
	        for (aR = 0; aR < ai; ++aR) {
	            aE    = aZ[aR] * ap[aR];
	            P[aR] = (aE > 0) ? ((aE + 0.5) | 0) : ((aE - 0.5) | 0)
	        }
	        return P
	    }

	    function b () {
	        p(65504);
	        p(16);
	        F(74);
	        F(70);
	        F(73);
	        F(70);
	        F(0);
	        F(1);
	        F(1);
	        F(0);
	        p(1);
	        p(1);
	        F(0);
	        F(0)
	    }

	    function r (aa, ab) {
	        p(65472);
	        p(17);
	        F(8);
	        p(ab);
	        p(aa);
	        F(3);
	        F(1);
	        F(17);
	        F(0);
	        F(2);
	        F(17);
	        F(1);
	        F(3);
	        F(17);
	        F(1)
	    }

	    function D () {
	        p(65499);
	        p(132);
	        F(0);
	        for (var ab = 0; ab < 64; ab++) {
	            F(O[ab])
	        }
	        F(1);
	        for (var aa = 0; aa < 64; aa++) {
	            F(K[aa])
	        }
	    }

	    function H () {
	        p(65476);
	        p(418);
	        F(0);
	        for (var ae = 0; ae < 16; ae++) {
	            F(g[ae + 1])
	        }
	        for (var ad = 0; ad <= 11; ad++) {
	            F(c[ad])
	        }
	        F(16);
	        for (var ac = 0; ac < 16; ac++) {
	            F(w[ac + 1])
	        }
	        for (var ab = 0; ab <= 161; ab++) {
	            F(E[ab])
	        }
	        F(1);
	        for (var aa = 0; aa < 16; aa++) {
	            F(v[aa + 1])
	        }
	        for (var ah = 0; ah <= 11; ah++) {
	            F(Y[ah])
	        }
	        F(17);
	        for (var ag = 0; ag < 16; ag++) {
	            F(J[ag + 1])
	        }
	        for (var af = 0; af <= 161; af++) {
	            F(B[af])
	        }
	    }

	    function I () {
	        p(65498);
	        p(12);
	        F(3);
	        F(1);
	        F(0);
	        F(2);
	        F(17);
	        F(3);
	        F(17);
	        F(0);
	        F(63);
	        F(0)
	    }

	    function L (ad, aa, al, at, ap) {
	        var ag   = ap[0];
	        var ab   = ap[240];
	        var ac;
	        const ar = 16;
	        const ai = 63;
	        const ah = 64;
	        var aq   = N(ad, aa);
	        for (var am = 0; am < ah; ++am) {
	            S[i[am]] = aq[am]
	        }
	        var an = S[0] - al;
	        al     = S[0];
	        if (an == 0) {
	            X(at[0])
	        } else {
	            ac = 32767 + an;
	            X(at[m[ac]]);
	            X(n[ac])
	        }
	        var ae = 63;
	        for (; (ae > 0) && (S[ae] == 0); ae--) {
	        }
	        if (ae == 0) {
	            X(ag);
	            return al
	        }
	        var ao = 1;
	        var au;
	        while (ao <= ae) {
	            var ak = ao;
	            for (; (S[ao] == 0) && (ao <= ae); ++ao) {
	            }
	            var aj = ao - ak;
	            if (aj >= ar) {
	                au = aj >> 4;
	                for (var af = 1; af <= au; ++af) {
	                    X(ab)
	                }
	                aj = aj & 15
	            }
	            ac = 32767 + S[ao];
	            X(ap[(aj << 4) + m[ac]]);
	            X(n[ac]);
	            ao++
	        }
	        if (ae != ai) {
	            X(ag)
	        }
	        return al
	    }

	    function y () {
	        var ab = String.fromCharCode;
	        for (var aa = 0; aa < 256; aa++) {
	            e[aa] = ab(aa)
	        }
	    }

	    this.encode = function (an, aj, aB) {
	        var aa = new Date().getTime();
	        if (aj) {
	            R(aj)
	        }
	        j                       = new Array();
	        t                       = 0;
	        a                       = 7;
	        p(65496);
	        b();
	        D();
	        r(an.width, an.height);
	        H();
	        I();
	        var al                  = 0;
	        var aq                  = 0;
	        var ao                  = 0;
	        t                       = 0;
	        a                       = 7;
	        this.encode.displayName = "_encode_";
	        var at                  = an.data;
	        var ar                  = an.width;
	        var aA                  = an.height;
	        var ay                  = ar * 4;
	        var ai                  = ar * 3;
	        var ah, ag              = 0;
	        var am, ax, az;
	        var ab, ap, ac, af, ae;
	        while (ag < aA) {
	            ah = 0;
	            while (ah < ay) {
	                ab = ay * ag + ah;
	                ap = ab;
	                ac = -1;
	                af = 0;
	                for (ae = 0; ae < 64; ae++) {
	                    af = ae >> 3;
	                    ac = (ae & 7) * 4;
	                    ap = ab + (af * ay) + ac;
	                    if (ag + af >= aA) {
	                        ap -= (ay * (ag + 1 + af - aA))
	                    }
	                    if (ah + ac >= ay) {
	                        ap -= ((ah + ac) - ay + 4)
	                    }
	                    am    = at[ap++];
	                    ax    = at[ap++];
	                    az    = at[ap++];
	                    A[ae] = ((C[am] + C[(ax + 256) >> 0] + C[(az + 512) >> 0]) >> 16) - 128;
	                    f[ae] = ((C[(am + 768) >> 0] + C[(ax + 1024) >> 0] + C[(az + 1280) >> 0]) >> 16) - 128;
	                    U[ae] = ((C[(am + 1280) >> 0] + C[(ax + 1536) >> 0] + C[(az + 1792) >> 0]) >> 16) - 128
	                }
	                al = L(A, d, al, u, G);
	                aq = L(f, Z, aq, h, T);
	                ao = L(U, Z, ao, h, T);
	                ah += 32
	            }
	            ag += 8
	        }
	        if (a >= 0) {
	            var aw = [];
	            aw[1]  = a + 1;
	            aw[0]  = (1 << (a + 1)) - 1;
	            X(aw)
	        }
	        p(65497);
	        if (aB) {
	            var av = j.length;
	            var aC = new Uint8Array(av);
	            for (var au = 0; au < av; au++) {
	                aC[au] = j[au].charCodeAt()
	            }
	            j      = [];
	            var ak = new Date().getTime() - aa;
	            return aC
	        }
	        var ad = "data:image/jpeg;base64," + btoa(j.join(""));
	        j      = [];
	        var ak = new Date().getTime() - aa;
	        return ad
	    };
	    function R (ab) {
	        if (ab <= 0) {
	            ab = 1
	        }
	        if (ab > 100) {
	            ab = 100
	        }
	        if (x == ab) {
	            return
	        }
	        var aa = 0;
	        if (ab < 50) {
	            aa = Math.floor(5000 / ab)
	        } else {
	            aa = Math.floor(200 - ab * 2)
	        }
	        M(aa);
	        x      = ab;
	    }

	    function Q () {
	        var aa = new Date().getTime();
	        if (!l) {
	            l = 50
	        }
	        y();
	        W();
	        z();
	        V();
	        R(l);
	        var ab = new Date().getTime() - aa;
	    }

	    Q()
	}

	module.exports = JPEGEncoder;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	// 保证按需加载的文件路径正确
	__webpack_require__.p = getJsDir('lrz') + '/';
	window.URL              = window.URL || window.webkitURL;

	var Promise          = __webpack_require__(1),
	    BlobFormDataShim = __webpack_require__(5),
	    exif             = __webpack_require__(6);


	var UA = (function (userAgent) {
	    var ISOldIOS     = /OS (.*) like Mac OS X/g.exec(userAgent),
	        isOldAndroid = /Android (\d.*?);/g.exec(userAgent) || /Android\/(\d.*?) /g.exec(userAgent);

	    // 判断设备是否是IOS7以下
	    // 判断设备是否是android4.5以下
	    // 判断是否iOS
	    // 判断是否android
	    // 判断是否QQ浏览器
	    var IOS_VERSION = ISOldIOS ? +ISOldIOS.pop().replace(/-/g, '.') : 0
	    return {
	        oldIOS    : ISOldIOS ? IOS_VERSION < 8 : false,
	        newIOS    : ISOldIOS ? IOS_VERSION >= 13 : false,
	        oldAndroid: isOldAndroid ? +isOldAndroid.pop().substr(0, 3) < 4.5 : false,
	        iOS       : /\(i[^;]+;( U;)? CPU.+Mac OS X/.test(userAgent),
	        android   : /Android/g.test(userAgent),
	        mQQBrowser: /MQQBrowser/g.test(userAgent)
	    }
	})(navigator.userAgent);


	function Lrz (file, opts) {
	    var that = this;

	    if (!file) throw new Error('没有收到图片，可能的解决方案：https://github.com/think2011/localResizeIMG/issues/7');

	    opts = opts || {};

	    that.defaults = {
	        width    : null,
	        height   : null,
	        fieldName: 'file',
	        ingnoreOrientation: UA.iOS ? UA.newIOS : true,
	        quality  : 0.7
	    };

	    that.file = file;

	    for (var p in opts) {
	        if (!opts.hasOwnProperty(p)) continue;
	        that.defaults[p] = opts[p];
	    }

	    return this.init();
	}

	Lrz.prototype.init = function () {
	    var that         = this,
	        file         = that.file,
	        fileIsString = typeof file === 'string',
	        fileIsBase64 = /^data:/.test(file),
	        img          = new Image(),
	        canvas       = document.createElement('canvas'),
	        blob         = fileIsString ? file : URL.createObjectURL(file);

	    that.img    = img;
	    that.blob   = blob;
	    that.canvas = canvas;

	    if (fileIsString) {
	        that.fileName = fileIsBase64 ? 'base64.jpg' : (file.split('/').pop());
	    } else {
	        that.fileName = file.name;
	    }

	    if (!document.createElement('canvas').getContext) {
	        throw new Error('浏览器不支持canvas');
	    }

	    return new Promise(function (resolve, reject) {
	        img.onerror = function () {
	            var err = new Error('加载图片文件失败');
	            reject(err);
	            throw err;
	        };

	        img.onload = function () {
	            that._getBase64()
	                .then(function (base64) {
	                    if (base64.length < 10) {
	                        var err = new Error('生成base64失败');
	                        reject(err);
	                        throw err;
	                    }

	                    return base64;
	                })
	                .then(function (base64) {
	                    var formData = null;

	                    // 压缩文件太大就采用源文件,且使用原生的FormData() @source #55
	                    if (typeof that.file === 'object' && base64.length > that.file.size) {
	                        formData = new FormData();
	                        file     = that.file;
	                    } else {
	                        formData = new BlobFormDataShim.FormData();
	                        file     = dataURItoBlob(base64);
	                    }

	                    formData.append(that.defaults.fieldName, file, (that.fileName.replace(/\..+/g, '.jpg')));

	                    resolve({
	                        formData : formData,
	                        fileLen : +file.size,
	                        base64  : base64,
	                        base64Len: base64.length,
	                        origin   : that.file,
	                        file   : file
	                    });

	                    // 释放内存
	                    for (var p in that) {
	                        if (!that.hasOwnProperty(p)) continue;

	                        that[p] = null;
	                    }
	                    URL.revokeObjectURL(that.blob);
	                });
	        };

	        // 如果传入的是base64在移动端会报错
	        !fileIsBase64 && (img.crossOrigin = "*");

	        img.src = blob;
	    });
	};

	Lrz.prototype._getBase64 = function () {
	    var that   = this,
	        img    = that.img,
	        file   = that.file,
	        canvas = that.canvas;

	    return new Promise(function (resolve) {
	        try {
	            // 传入blob在android4.3以下有bug
	            exif.getData(typeof file === 'object' ? file : img, function () {
	                that.orientation = that.defaults.ingnoreOrientation ? 0 : exif.getTag(this, "Orientation");

	                that.resize = that._getResize();
	                that.ctx    = canvas.getContext('2d');

	                canvas.width  = that.resize.width;
	                canvas.height = that.resize.height;

	                // 设置为白色背景，jpg是不支持透明的，所以会被默认为canvas默认的黑色背景。
	                that.ctx.fillStyle = '#fff';
	                that.ctx.fillRect(0, 0, canvas.width, canvas.height);

	                // 根据设备对应处理方式
	                if (UA.oldIOS) {
	                    that._createBase64ForOldIOS().then(resolve);
	                }
	                else {
	                    that._createBase64().then(resolve);
	                }
	            });
	        } catch (err) {
	            // 这样能解决低内存设备闪退的问题吗？
	            throw new Error(err);
	        }
	    });
	};


	Lrz.prototype._createBase64ForOldIOS = function () {
	    var that        = this,
	        img         = that.img,
	        canvas      = that.canvas,
	        defaults    = that.defaults,
	        orientation = that.orientation;

	    return new Promise(function (resolve) {
	        !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(7)]; (function (MegaPixImage) {
	            var mpImg = new MegaPixImage(img);

	            if ("5678".indexOf(orientation) > -1) {
	                mpImg.render(canvas, {
	                    width      : canvas.height,
	                    height     : canvas.width,
	                    orientation: orientation
	                });
	            } else {
	                mpImg.render(canvas, {
	                    width      : canvas.width,
	                    height     : canvas.height,
	                    orientation: orientation
	                });
	            }

	            resolve(canvas.toDataURL('image/jpeg', defaults.quality));
	        }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}());
	    });
	};

	Lrz.prototype._createBase64 = function () {
	    var that        = this,
	        resize      = that.resize,
	        img         = that.img,
	        canvas      = that.canvas,
	        ctx         = that.ctx,
	        defaults    = that.defaults,
	        orientation = that.orientation;

	    // 调整为正确方向
	    switch (orientation) {
	        case 3:
	            ctx.rotate(180 * Math.PI / 180);
	            ctx.drawImage(img, -resize.width, -resize.height, resize.width, resize.height);
	            break;
	        case 6:
	            ctx.rotate(90 * Math.PI / 180);
	            ctx.drawImage(img, 0, -resize.width, resize.height, resize.width);
	            break;
	        case 8:
	            ctx.rotate(270 * Math.PI / 180);
	            ctx.drawImage(img, -resize.height, 0, resize.height, resize.width);
	            break;

	        case 2:
	            ctx.translate(resize.width, 0);
	            ctx.scale(-1, 1);
	            ctx.drawImage(img, 0, 0, resize.width, resize.height);
	            break;
	        case 4:
	            ctx.translate(resize.width, 0);
	            ctx.scale(-1, 1);
	            ctx.rotate(180 * Math.PI / 180);
	            ctx.drawImage(img, -resize.width, -resize.height, resize.width, resize.height);
	            break;
	        case 5:
	            ctx.translate(resize.width, 0);
	            ctx.scale(-1, 1);
	            ctx.rotate(90 * Math.PI / 180);
	            ctx.drawImage(img, 0, -resize.width, resize.height, resize.width);
	            break;
	        case 7:
	            ctx.translate(resize.width, 0);
	            ctx.scale(-1, 1);
	            ctx.rotate(270 * Math.PI / 180);
	            ctx.drawImage(img, -resize.height, 0, resize.height, resize.width);
	            break;

	        default:
	            ctx.drawImage(img, 0, 0, resize.width, resize.height);
	    }

	    return new Promise(function (resolve) {
	        if (UA.oldAndroid || UA.mQQBrowser || !navigator.userAgent) {
	            !/* require */(/* empty */function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(8)]; (function (JPEGEncoder) {
	                var encoder = new JPEGEncoder(),
	                    img     = ctx.getImageData(0, 0, canvas.width, canvas.height);

	                resolve(encoder.encode(img, defaults.quality * 100));
	            }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}())
	        }
	        else {
	            resolve(canvas.toDataURL('image/jpeg', defaults.quality));
	        }
	    });
	};

	Lrz.prototype._getResize = function () {
	    var that        = this,
	        img         = that.img,
	        defaults    = that.defaults,
	        width       = defaults.width,
	        height      = defaults.height,
	        orientation = that.orientation;

	    var ret = {
	        width : img.width,
	        height: img.height
	    };

	    if ("5678".indexOf(orientation) > -1) {
	        ret.width  = img.height;
	        ret.height = img.width;
	    }

	    // 如果原图小于设定，采用原图
	    if (ret.width < width || ret.height < height) {
	        return ret;
	    }

	    var scale = ret.width / ret.height;

	    if (width && height) {
	        if (scale >= width / height) {
	            if (ret.width > width) {
	                ret.width  = width;
	                ret.height = Math.ceil(width / scale);
	            }
	        } else {
	            if (ret.height > height) {
	                ret.height = height;
	                ret.width  = Math.ceil(height * scale);
	            }
	        }
	    }
	    else if (width) {
	        if (width < ret.width) {
	            ret.width  = width;
	            ret.height = Math.ceil(width / scale);
	        }
	    }
	    else if (height) {
	        if (height < ret.height) {
	            ret.width  = Math.ceil(height * scale);
	            ret.height = height;
	        }
	    }

	    // 超过这个值base64无法生成，在IOS上
	    while (ret.width >= 3264 || ret.height >= 2448) {
	        ret.width *= 0.8;
	        ret.height *= 0.8;
	    }

	    return ret;
	};

	/**
	 * 获取当前js文件所在路径，必须得在代码顶部执行此函数
	 * @returns {string}
	 */
	function getJsDir (src) {
	    var script = null;

	    if (src) {
	        script = [].filter.call(document.scripts, function (v) {
	            return v.src.indexOf(src) !== -1;
	        })[0];
	    } else {
	        script = document.scripts[document.scripts.length - 1];
	    }

	    if (!script) return null;

	    return script.src.substr(0, script.src.lastIndexOf('/'));
	}


	/**
	 * 转换成formdata
	 * @param dataURI
	 * @returns {*}
	 *
	 * @source http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
	 */
	function dataURItoBlob (dataURI) {
	    // convert base64/URLEncoded data component to raw binary data held in a string
	    var byteString;
	    if (dataURI.split(',')[0].indexOf('base64') >= 0)
	        byteString = atob(dataURI.split(',')[1]);
	    else
	        byteString = unescape(dataURI.split(',')[1]);

	    // separate out the mime component
	    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

	    // write the bytes of the string to a typed array
	    var ia = new Uint8Array(byteString.length);
	    for (var i = 0; i < byteString.length; i++) {
	        ia[i] = byteString.charCodeAt(i);
	    }

	    return new BlobFormDataShim.Blob([ia.buffer], {type: mimeString});
	}

	window.lrz = function (file, opts) {
	    return new Lrz(file, opts);
	};

	// 版本号来自package.json，构建时自动填充
	window.lrz.version = '__packageJSON.version__';

	module.exports = window.lrz;

	/**
	 *
	 * 　　　┏┓　　　┏┓
	 * 　　┏┛┻━━━┛┻┓
	 * 　　┃　　　　　　　┃
	 * 　　┃　　　━　　　┃
	 * 　　┃　┳┛　┗┳　┃
	 * 　　┃　　　　　　　┃
	 * 　　┃　　　┻　　　┃
	 * 　　┃　　　　　　　┃
	 * 　　┗━┓　　　┏━┛Code is far away from bug with the animal protecting
	 * 　　　　┃　　　┃    神兽保佑,代码无bug
	 * 　　　　┃　　　┃
	 * 　　　　┃　　　┗━━━┓
	 * 　　　　┃　　　　　 ┣┓
	 * 　　　　┃　　　　 ┏┛
	 * 　　　　┗┓┓┏━┳┓┏┛
	 * 　　　　　┃┫┫　┃┫┫
	 * 　　　　　┗┻┛　┗┻┛
	 *
	 */




/***/ })
/******/ ])
});
;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(41);
var normalizeHeaderName = __webpack_require__(266);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(171);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(171);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(170)))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showNoDevToast = exports.noDevPageList = undefined;

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _noDevPageList;

__webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 未开发页面列表 已开发后去掉
 */
var noDevPageList = (_noDevPageList = {
  classifyGoodsListPage: '搜索',
  collectStars: '集集乐',
  luckyWheelDetail: '大转盘',
  goldenEggs: '砸金蛋',
  scratch: '刮刮乐',
  numberOfStampsOrderDetail: '兑换优惠券',
  numberOfStampsUsed: '兑换优惠券',
  exchangeCouponDetail: '兑换优惠券',
  exchangeCouponDetailOrder: '兑换优惠券',
  previewSeckillOrder: '秒杀',
  seckillDetail: '秒杀',
  gpgoodsList: '拼团',
  gpgoodsDetail: '拼团',
  gpgroupDetail: '拼团',
  gpmyOrder: '拼团',
  gporderDetail: '拼团',
  gppaySuccess: '拼团',
  gpplaylaws: '拼团',
  previewGroupOrder: '预售',
  presellList: '预售',
  presellDetail: '预售',
  presellOrderDetail: '预售',
  presellOrderList: '预售',
  presellPaySuccess: '预售',
  previewPresellOrder: '预售',
  previewOrderDetail: '到店',
  paySuccess: '到店',
  tostoreOrderDetail: '到店',
  tostoreComment: '到店',
  makeTostoreComment: '到店',
  previewTakeoutOrder: '外卖',
  takeoutOrderDetail: '外卖',
  takeoutMakeComment: '外卖',
  orderTracking: '外卖',
  takeoutFeedback: '外卖',
  indemnityOrder: '外卖',
  cancelOrder: '外卖',
  checkRowNumberDetail: '排号组件',
  previewRowNumberOrder: '排号组件',
  rowNumberOrderDetail: '排号组件',
  promotionApply: '分销',
  promotionCommission: '分销',
  promotionGoods: '分销',
  promotionMyPromotion: '分销',
  promotionShopSetting: '分销',
  promotionTeam: '分销',
  promotionUserCenter: '分销',
  promotionWithdraw: '分销',
  promotionWithdrawRecord: '分销',
  promotionUserLevel: '分销',
  promotionLeaderPromotion: '分销',
  promotionMyIdentity: '分销',
  promotionWithdrawOffline: '分销',
  promotionWithdrawScreenshot: '分销',
  communityGroupAddGoods: '社区团购',
  communityGroupApply: '社区团购',
  communityGroupApplyStatus: '社区团购',
  communityGroupChildOrder: '社区团购',
  communityGroupGoodDetail: '社区团购',
  communityGroupOrder: '社区团购',
  communityGroupOrderDetail: '社区团购',
  communityGroupOrderSubmit: '社区团购',
  communityGroupPaySuccess: '社区团购',
  communityGroupSearchAddress: '社区团购',
  communityGroupSearchVillage: '社区团购',
  communityGroupWriteOff: '社区团购',
  communityGroupGoodsInfo: '社区团购',
  promotionSubShop: '分销',
  groupOrderDeta: '分销',
  dMCouponDetail: '微分商城',
  dMMerchantDetail: '微分商城',
  dMMerchantLocation: '微分商城',
  dMCouponsMall: '微分商城',
  dMUserCenter: '微分商城',
  dMUserInfoMod: '微分商城',
  dMCouponSuccess: '微分商城',
  dMCouponActive: '微分商城',
  dMWebView: '微分商城',
  dMMerchantAlbum: '微分商城',
  videoUsercenter: '视频',
  videoDetail: '视频',
  videoAssess: '视频',
  goodsMore: '',
  franchiseeDetail: '多商家',
  franchiseeTostore: '多商家',
  franchiseeEnter: '多商家',
  franchiseeEnterStatus: '多商家',
  franchiseeList: '多商家',
  franchiseePerfect: '多商家',
  franchiseeWaimai: '多商家',
  franchiseeCooperation: '多商家',
  franchiseeDetail4: '多商家',
  franchiseeFacility: '多商家',
  chainStoreList: '多商家',
  franchiseeSearch: '多商家',
  imgVideoView: '多商家'
}, (0, _defineProperty3.default)(_noDevPageList, 'chainStoreList', '多商家'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentDetail', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentStandard', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentImgShow', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentOrder', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentOrderDetail', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'newAppointmentQrcode', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'hotel', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'houseList', '行业预约'), (0, _defineProperty3.default)(_noDevPageList, 'calendar', '签到组件'), (0, _defineProperty3.default)(_noDevPageList, 'retroactive', '签到组件'), (0, _defineProperty3.default)(_noDevPageList, 'rule', '签到组件'), (0, _defineProperty3.default)(_noDevPageList, 'communityPage', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityDetail', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityUsercenter', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityNotify', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityFailpass', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityReport', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'communityComments', '社区'), (0, _defineProperty3.default)(_noDevPageList, 'newsDetail', '资讯'), (0, _defineProperty3.default)(_noDevPageList, 'newsPocketsDetail', '资讯'), (0, _defineProperty3.default)(_noDevPageList, 'newsCommentDetail', '资讯'), (0, _defineProperty3.default)(_noDevPageList, 'newsPocketsBalance', '资讯红包'), _noDevPageList);
var showNoDevToast = function showNoDevToast(router) {
  var noName = '暂不支持当前功能';
  var yesName = React.createElement(
    'div',
    null,
    React.createElement(
      'div',
      null,
      '\u6682\u4E0D\u652F\u6301'
    ),
    React.createElement(
      'div',
      null,
      '\u5F53\u524D\u529F\u80FD\u3010',
      noDevPageList[router],
      '\u3011'
    )
  );
  _toast2.default.info(noDevPageList[router] ? yesName : noName);
};
exports.noDevPageList = noDevPageList;
exports.showNoDevToast = showNoDevToast;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(65);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function isString(str) {
    return typeof str === 'string';
}
// Insert one space between two chinese characters automatically.
function insertSpace(child) {
    if (isString(child.type) && isTwoCNChar(child.props.children)) {
        return React.cloneElement(child, {}, child.props.children.split('').join(' '));
    }
    if (isString(child)) {
        if (isTwoCNChar(child)) {
            child = child.split('').join(' ');
        }
        return React.createElement(
            'span',
            null,
            child
        );
    }
    return child;
}

var Button = function (_React$Component) {
    (0, _inherits3['default'])(Button, _React$Component);

    function Button() {
        (0, _classCallCheck3['default'])(this, Button);
        return (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Button, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                type = _a.type,
                size = _a.size,
                inline = _a.inline,
                disabled = _a.disabled,
                icon = _a.icon,
                loading = _a.loading,
                activeStyle = _a.activeStyle,
                activeClassName = _a.activeClassName,
                onClick = _a.onClick,
                restProps = __rest(_a, ["children", "className", "prefixCls", "type", "size", "inline", "disabled", "icon", "loading", "activeStyle", "activeClassName", "onClick"]);
            var iconType = loading ? 'loading' : icon;
            var wrapCls = (0, _classnames3['default'])(prefixCls, className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-primary', type === 'primary'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-ghost', type === 'ghost'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-warning', type === 'warning'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-small', size === 'small'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-inline', inline), (0, _defineProperty3['default'])(_classnames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classnames, prefixCls + '-icon', !!iconType), _classnames));
            var kids = React.Children.map(children, insertSpace);
            var iconEl = void 0;
            if (typeof iconType === 'string') {
                iconEl = React.createElement(_icon2['default'], { 'aria-hidden': 'true', type: iconType, size: size === 'small' ? 'xxs' : 'md', className: prefixCls + '-icon' });
            } else if (iconType) {
                var rawCls = iconType.props && iconType.props.className;
                var cls = (0, _classnames3['default'])('am-icon', prefixCls + '-icon', size === 'small' ? 'am-icon-xxs' : 'am-icon-md');
                iconEl = React.cloneElement(iconType, {
                    className: rawCls ? rawCls + ' ' + cls : cls
                });
            }
            // use div, button native is buggy @yiminghe
            return React.createElement(
                _rmcFeedback2['default']
                // tslint:disable-next-line:jsx-no-multiline-js
                ,
                { activeClassName: activeClassName || (activeStyle ? prefixCls + '-active' : undefined), disabled: disabled, activeStyle: activeStyle },
                React.createElement(
                    'a',
                    (0, _extends3['default'])({ role: 'button', className: wrapCls }, restProps, { onClick: disabled ? undefined : onClick, 'aria-disabled': disabled }),
                    iconEl,
                    kids
                )
            );
        }
    }]);
    return Button;
}(React.Component);

Button.defaultProps = {
    prefixCls: 'am-button',
    size: 'large',
    inline: false,
    disabled: false,
    loading: false,
    activeStyle: {}
};
exports['default'] = Button;
module.exports = exports['default'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.getComponentLocale = getComponentLocale;
exports.getLocaleCode = getLocaleCode;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getComponentLocale(props, context, componentName, getDefaultLocale) {
    var locale = {};
    if (context && context.antLocale && context.antLocale[componentName]) {
        locale = context.antLocale[componentName];
    } else {
        var defaultLocale = getDefaultLocale();
        // TODO: make default lang of antd be English
        // https://github.com/ant-design/ant-design/issues/6334
        locale = defaultLocale['default'] || defaultLocale;
    }
    var result = (0, _extends3['default'])({}, locale);
    if (props.locale) {
        result = (0, _extends3['default'])({}, result, props.locale);
        if (props.locale.lang) {
            result.lang = (0, _extends3['default'])({}, locale.lang, props.locale.lang);
        }
    }
    return result;
}
function getLocaleCode(context) {
    var localeCode = context.antLocale && context.antLocale.locale;
    // Had use LocaleProvide but didn't set locale
    if (context.antLocale && context.antLocale.exist && !localeCode) {
        return 'zh-cn';
    }
    return localeCode;
}

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(27);

__webpack_require__(300);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(130);
var ITERATOR = __webpack_require__(35)('iterator');
var Iterators = __webpack_require__(64);
module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(73);
var TAG = __webpack_require__(35)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(95),
    isKey = __webpack_require__(336),
    stringToPath = __webpack_require__(340),
    toString = __webpack_require__(369);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(133),
    isObjectLike = __webpack_require__(136);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    getRawTag = __webpack_require__(338),
    objectToString = __webpack_require__(339);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(135);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(337);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(347),
    getValue = __webpack_require__(352);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 138 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(132);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.baseGet = baseGet;
exports.baseSet = baseSet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : (0, _typeof3.default)(global)) === 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : (0, _typeof3.default)(self)) === 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString !== 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/** Built-in value references. */
var _Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    hash: new Hash(),
    map: new (Map || ListCache)(),
    string: new Hash()
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value === 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key === 'string' ? 'string' : 'hash'] : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function (string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function (match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value === 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func !== 'function' || resolver && typeof resolver !== 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'symbol' || isObjectLike(value) && objectToString.call(value) == symbolTag;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__') {
    Object.defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used to check objects for own properties. */
var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

/**
 * The base implementation of `set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var length = path.length;
  var lastIndex = length - 1;

  var index = -1;
  var nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]);
    var newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Recommend = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

__webpack_require__(439);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventSource = [{ action: "get-coupon", name: "优惠券详情", local_icon: "icon-news-coupon" }, { action: "goods-trade", name: "商品详情", local_icon: "icon-news-goodsdetail" }, { action: "community", name: "社区详情", local_icon: "icon-news-community" }, { action: "to-franchisee", name: "商家详情", local_icon: "icon-news-business" }, { action: "coupon-receive-list", name: "优惠券列表", local_icon: "icon-news-coupon" }, { action: "recharge", name: "储值", local_icon: "icon-news-storage" }, { action: "transfer", name: "付款", local_icon: "icon-news-payment" }, { action: "to-promotion", name: "代言人中心", local_icon: "icon-news-extension" }, { action: "scratch-card", name: "刮刮乐", local_icon: "icon-news-scratch" }, { action: "lucky-wheel", name: "大转盘", local_icon: "icon-news-turntable" }, { action: "golden-eggs", name: "砸金蛋", local_icon: "icon-news-goldegg" }, { action: "call", name: "拨打电话", local_icon: "icon-news-callphone" }, { action: "turn-to-xcx", name: "跳转action小程序", local_icon: "icon-news-jump" }, { action: "share", name: "分享好友", local_icon: "icon-news-sharefriends" }, { action: "page-share", name: "分享朋友圈", local_icon: "icon-news-sharecircle" }, { action: "refresh-list", name: "刷新列表", local_icon: "icon-news-refreshlist" }, { action: "refresh-page", name: "刷新页面", local_icon: "icon-news-refreshpage" }, { action: "contact", name: "联系客服", local_icon: "icon-news-custom" }, { action: "preview-picture", name: "预览大图", local_icon: "icon-news-coupon" }, { action: "to-seckill", name: "秒杀", local_icon: "icon-news-kill" }, { action: "video-detail", name: "视频详情", local_icon: "icon-news-videodetail" }, { action: "topic", name: "话题详情", local_icon: "icon-news-topic" }, { action: "news", name: "资讯详情", local_icon: "icon-news-news" }, { action: "goods-scan-code", name: "扫码购", local_icon: "icon-shopping-scan" }, { action: "vcard", name: "名片详情", local_icon: "icon-vcard" }, { action: "vcard-msg-list", name: "名片消息列表", local_icon: "icon-vcard-msg-list" }];

function ArticleRecommendItem(props) {
  var item = props.item;
  return _react2.default.createElement(
    'div',
    { className: 'recommend-item' },
    _react2.default.createElement(
      'div',
      { className: 'recommend-article', style: { width: item.style != 1 || item.form_data.url.video ? '70%' : '100%' } },
      _react2.default.createElement(
        'div',
        { className: 'recommend-content' },
        item.title
      ),
      item.article_type == 3 ? _react2.default.createElement(
        'div',
        { className: 'recommend-adver-footer' },
        _react2.default.createElement(
          'span',
          { className: 'recommend-adver-tag' },
          '\u63A8\u8350'
        ),
        _react2.default.createElement(
          'span',
          { className: 'recommend-publish-time' },
          item.publish_time
        )
      ) : _react2.default.createElement(
        'div',
        { className: 'recommend-key-words' },
        _react2.default.createElement(
          'span',
          { className: 'recommend-comment-text' },
          item.comment_count,
          '\u8BC4\u8BBA'
        ),
        _react2.default.createElement(
          'span',
          { className: 'recommend-comment-text' },
          item.publish_time
        )
      )
    ),
    (item.style != 1 || item.form_data.url.video || item.form_data.video[0]) && _react2.default.createElement(
      'div',
      { className: 'img-wrap' },
      _react2.default.createElement('img', { src: item.imgs || item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'] || item['form_data'] && item['form_data']['video'] && item['form_data']['url']['video']['cover'] }),
      (item['form_data'] && item['form_data']['url'] && item['form_data']['url']['video'] && item['form_data']['url']['video']['cover'] || item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) && _react2.default.createElement(
        'div',
        { className: 'icon-wrap' },
        _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
      )
    )
  );
}

var Recommend = exports.Recommend = function (_CommonComponent) {
  (0, _inherits3.default)(Recommend, _CommonComponent);

  function Recommend(props) {
    (0, _classCallCheck3.default)(this, Recommend);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Recommend.__proto__ || Object.getPrototypeOf(Recommend)).call(this, props));

    _this.show = function (options) {
      if (options.franchiseeId) {
        _this.setState({
          franchiseeId: options.franchiseeId
        });
      }
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        res.recommend_config && res.recommend_config.map(function (item) {
          item.recommend_info = item.recommend_info.map(function (rg) {
            if (item.recommend_type == 3) {
              if (!rg.name) {
                rg.name = rg.pageRouterName ? rg.pageRouterName.split('/').pop() : '';
              }
              rg.iconImg = rg.iconImg ? rg.iconImg : rg.icon;
              if (!rg.name || !rg.iconImg || /click_event.*svg$/.test(rg.iconImg)) {
                var eventObj = eventSource.find(function (eb) {
                  return eb.action == rg.action;
                });
                if (eventObj) {
                  rg.name || (rg.name = eventObj.name);
                  if (!rg.iconImg || /click_event.*svg$/.test(rg.iconImg)) {
                    rg.local_icon = eventObj.local_icon;
                  }
                }
              }
              return rg;
            } else if (item.recommend_type == 0) {
              if (rg.article_type == 3 && rg.form_data.event.action) {
                var oldEventParams = rg.form_data.event,
                    newEventParams = {};
                Object.keys(oldEventParams).forEach(function (k) {
                  if (/\-/.test(k)) {
                    newEventParams[k.replace(/\-/g, '_')] = oldEventParams[k];
                  } else {
                    newEventParams[k] = oldEventParams[k];
                  }
                });
                rg.event_params = newEventParams;
              } else {
                rg.event_params = '';
              }
              if (rg.form_data && rg.form_data.recommend) {
                delete rg.form_data.recommend;
              }
              return rg;
            }
            return rg;
          });
        });
        _this.setData({
          storeStyle: res.color_config,
          recommendInfo: res.recommend_config || []
        });
      }, _this.data.franchiseeId);
    };

    _this.gotoCouponDetail = function (event) {
      var id = event.currentTarget.dataset.couponId;
      var franchiseeParam = _this.data.franchiseeId ? '&franchisee=' + _this.data.franchiseeId : '';
      _app.appMethod.turnToPage('/pages/couponDetail/couponDetail?couponStatus=recieve&detail=' + id + franchiseeParam);
    };

    _this.turnToArticle = function (event) {
      if (event.currentTarget.dataset.articleType == 3) {
        _this.bindEventTapHandler(event);
        return;
      }
      var id = event.currentTarget.dataset.id;
      var franchiseeParam = _this.data.franchiseeId ? '&franchisee=' + _this.data.franchiseeId : '';
      _app.appMethod.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + franchiseeParam);
    };

    _this.turnToGoodsDetail = function (event) {
      var id = event.currentTarget.dataset.id,
          style = event.currentTarget.dataset.style;
      var franchiseeParam = _this.data.franchiseeId ? '&franchisee=' + _this.data.franchiseeId : '';
      if (style == 3) {
        _app.appMethod.turnToPage('/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam);
      } else {
        _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + id + franchiseeParam);
      }
    };

    _this.bindEventTapHandler = function (e) {
      var form = JSON.parse(e.currentTarget.dataset.eventParams);;
      (0, _customEvent.customEvent)({
        customFeature: form,
        franchisee: _this.data.franchiseeId,
        event: e
      });
    };

    _this.state = {
      recommendInfo: [],
      storeStyle: {},
      appLogo: _app.appMethod.globalData.appLogo,
      franchiseeId: ""
    };
    return _this;
  }

  (0, _createClass3.default)(Recommend, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          recommendInfo = _state.recommendInfo,
          appLogo = _state.appLogo,
          storeStyle = _state.storeStyle;


      return _react2.default.createElement(
        'div',
        { className: 'common-component recommend-wrap' },
        recommendInfo && recommendInfo.map(function (recommendItem, index) {
          return _react2.default.createElement(
            'div',
            { className: 'recommend-box', key: index },
            recommendItem.recommend_type == 3 && recommendItem.recommend_info.length != 0 && _react2.default.createElement(
              'div',
              { className: 'more-operations' },
              _react2.default.createElement(
                'div',
                { className: 'recommend-title' },
                '\u66F4\u591A\u64CD\u4F5C'
              ),
              _react2.default.createElement(
                'div',
                { className: 'operations-wrap operations' + (recommendItem.recommend_info.length < 3 ? recommendItem.recommend_info.length : '3') },
                recommendItem.recommend_info.map(function (recList, recIndex) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'operations-inner', key: recIndex },
                    _react2.default.createElement(
                      'div',
                      { onClick: _this2.bindEventTapHandler, 'data-event-params': JSON.stringify(recList) },
                      _react2.default.createElement(
                        'div',
                        { className: 'icon-wrap' },
                        recList.local_icon ? _react2.default.createElement('label', { className: 'ico-moon ' + recList.local_icon }) : _react2.default.createElement('img', { className: 'recommend-image-icon', src: recList.iconImg })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'name' },
                        recList.name
                      )
                    )
                  );
                })
              )
            ),
            recommendItem.recommend_type == 0 && recommendItem.recommend_info.length > 0 && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'recommend-title' },
                '\u63A8\u8350\u6587\u7AE0'
              ),
              recommendItem.recommend_info.map(function (item) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: item.id },
                  item.is_publish == 1 && _react2.default.createElement(
                    'div',
                    { className: 'recommmend-list' },
                    _react2.default.createElement(
                      'div',
                      { 'data-id': item.id, onClick: _this2.turnToArticle, 'data-article-type': item.article_type, 'data-event-params': JSON.stringify(item.event_params) },
                      _react2.default.createElement(ArticleRecommendItem, { item: item })
                    )
                  )
                );
              })
            ),
            recommendItem.recommend_type == 1 && recommendItem.recommend_info.length > 0 && _react2.default.createElement(
              'div',
              { className: 'goods-list' },
              _react2.default.createElement(
                'div',
                { className: 'recommend-title' },
                '\u63A8\u8350\u5546\u54C1'
              ),
              recommendItem.recommend_info.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'recommmend-list recommend-item', 'data-id': item.id, onClick: _this2.turnToGoodsDetail, 'data-style': item.goods_type, key: index },
                  _react2.default.createElement(
                    'div',
                    { className: 'recommend-item-inner' },
                    _react2.default.createElement(
                      'div',
                      { className: 'img-wrap' },
                      _react2.default.createElement('img', { src: item.cover })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'recommend-article' },
                      _react2.default.createElement(
                        'div',
                        { className: 'recommend-goods-title' },
                        item.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'recommend-goods-price', style: { color: storeStyle.theme } },
                        '\xA5',
                        item.price
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'recommend-goods-sales' },
                        '\u6708\u9500',
                        item.sales,
                        '\u4EF6'
                      )
                    )
                  )
                );
              })
            ),
            recommendItem.recommend_type == 2 && recommendItem.recommend_info.length > 0 && _react2.default.createElement(
              'div',
              { className: 'ticket' },
              _react2.default.createElement(
                'div',
                { className: 'recommend-title' },
                '\u798F\u5229\u9886\u53D6'
              ),
              recommendItem.recommend_info.map(function (coupon, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'recommmend-list', key: index, onClick: _this2.gotoCouponDetail, 'data-coupon-id': coupon.id },
                  _react2.default.createElement(
                    'div',
                    { className: 'top-section' },
                    _react2.default.createElement('img', { className: 'ticket-image', src: appLogo }),
                    _react2.default.createElement(
                      'div',
                      { className: 'detail-info' },
                      _react2.default.createElement(
                        'div',
                        { className: 'name' },
                        coupon.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'use-condition' },
                        '\u4F7F\u7528\u6761\u4EF6\uFF1A',
                        coupon.discount
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'receive-btn', onClick: _this2.gotoCouponDetail, 'data-coupon-id': coupon.id },
                      '\u9886\u53D6'
                    )
                  )
                );
              })
            )
          );
        })
      );
    }
  }]);
  return Recommend;
}(_CommonComponent3.default);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(85);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _regenerator = __webpack_require__(82);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(83);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(644);

var _tabBar = __webpack_require__(645);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAnimation = function (_Component) {
  (0, _inherits3.default)(TextAnimation, _Component);

  function TextAnimation(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, TextAnimation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TextAnimation.__proto__ || Object.getPrototypeOf(TextAnimation)).call(this, props));

    _this.state = {
      displayText: "",
      userInfo: _app.appMethod.getUserInfo(),
      propsData: null,
      isPlayingAudio: false,
      generateing: false,
      timer: null
    };

    _this.stopGenerate = function () {
      clearInterval(_this.state.timer);
    };

    _this.setClipboardData = function (e) {
      var content = e.currentTarget.dataset.content;
      _app.appMethod.setClipboardData({
        data: content
      });
      _toast2.default.info('复制完成', 1);
    };

    _this.toPage = function () {
      _app.appMethod.turnToPage('userCenterComponentPage');
    };

    _this.againSend = function (e) {
      var content = e.currentTarget.dataset.content;
      _this.props.againSend(content);
    };

    _this.toBoxBottom = function () {
      _this.props.toBoxBottom();
    };

    _this.startShare = function () {
      _this.props.startShare();
    };

    _this.playAudio = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var utterance;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(window.speechSynthesis, '11111111111111');

              if (!_this.state.isPlayingAudio) {
                _context.next = 7;
                break;
              }

              console.log('停止播放');
              // window.speechSynthesis.cancel()
              window.speechSynthesis.pause();
              console.log(window.speechSynthesis, '333333333');
              // this.setState((prevState) => ({
              //   isPlayingAudio: false,
              // }));
              _context.next = 19;
              break;

            case 7:
              _this.setState(function () {
                return {
                  isPlayingAudio: true
                };
              });

              if (!('speechSynthesis' in window)) {
                _context.next = 18;
                break;
              }

              _context.next = 11;
              return window.speechSynthesis.pause();

            case 11:
              _context.next = 13;
              return window.speechSynthesis.cancel();

            case 13:
              utterance = new SpeechSynthesisUtterance(_this.state.propsData.text);

              utterance.onend = function () {
                console.log("语音播放结束");
                _this.setState(function (prevState) {
                  return {
                    isPlayingAudio: false
                  };
                });
                // 在这里执行其他操作
              };
              utterance.onpause = function () {
                _this.setState(function (prevState) {
                  return {
                    isPlayingAudio: false
                  };
                });
                console.log("语音播放暂停", _this.state.isPlayingAudio);
                // 在这里执行其他操作
              };
              // utterance.onboundary = (event) => {
              //   console.log(event,'utterance.onboundary');
              //   if (event.charIndex === 0 && !window.speechSynthesis.paused) {
              //     window.speechSynthesis.pause()
              //     console.log("上一个 utterance 被中断");
              //     // 在这里处理上一个 utterance 被中断时的逻辑
              //   }
              // }
              // window.speechSynthesis.cancel()
              setTimeout(function () {
                window.speechSynthesis.speak(utterance);
              }, 500);
              console.log(window.speechSynthesis, '222222222222222');

            case 18:
              console.log('开始播放');

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.longPressStart = function () {
      !_this.props.maskShow && _this.props.longPressStart();
    };

    _this.longPressEnd = function () {
      !_this.props.maskShow && _this.props.longPressEnd();
    };

    _this.state.propsData = props.data;
    return _this;
  }

  (0, _createClass3.default)(TextAnimation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // const { text, direction, isHistory } = this.props.data;
      var _state$propsData = this.state.propsData,
          text = _state$propsData.text,
          direction = _state$propsData.direction,
          isHistory = _state$propsData.isHistory;
      // console.log(this.props.data)

      var currentIndex = 0;
      if (direction != "reply" || isHistory) {
        this.setState({
          displayText: text
        });
        return;
      }
      this.setState({
        generateing: true
      });
      var intervalId = setInterval(function () {
        if (currentIndex < text.length) {
          _this3.setState(function (prevState) {
            return {
              displayText: prevState.displayText + text[currentIndex]
            };
          });
          currentIndex++;
          // if(text[currentIndex] == '\n' || currentIndex%14 == 0){  // 换行时
          _this3.toBoxBottom();
          // }
        } else {
          clearInterval(intervalId);
          _this3.setState({
            generateing: false
          });
        }
      }, 40);
      this.setState({
        timer: intervalId
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
    //停止生成

    // 复制东西到剪切板

    // playAudio = () => {
    //   if ('speechSynthesis' in window) {
    // 	  const utterance = new SpeechSynthesisUtterance('要转化为语音的文本');
    // 	  window.speechSynthesis.speak(utterance);
    // 	}
    // }

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          displayText = _state.displayText,
          userInfo = _state.userInfo,
          isPlayingAudio = _state.isPlayingAudio,
          generateing = _state.generateing;
      var _state$propsData2 = this.state.propsData,
          direction = _state$propsData2.direction,
          noCopy = _state$propsData2.noCopy,
          timeStr = _state$propsData2.timeStr,
          isLoading = _state$propsData2.isLoading,
          err = _state$propsData2.err,
          is_audio = _state$propsData2.is_audio,
          isLongPress = _state$propsData2.isLongPress;

      if (direction == "reply") {
        return _react2.default.createElement(
          'div',
          { className: 'chat' },
          _react2.default.createElement(
            'div',
            { className: 'chat-bubble-left' },
            _react2.default.createElement(
              'div',
              { className: 'row fl_s' },
              _react2.default.createElement('img', { className: 'headimg', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log.png', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: this.props.highLight ? "chat-bubble-content highLight" : "chat-bubble-content" },
                displayText,
                _react2.default.createElement(
                  'div',
                  { className: 'btn_list' },
                  is_audio == '1' && _react2.default.createElement(
                    'div',
                    { className: 'audio_play', onClick: this.playAudio },
                    _react2.default.createElement('img', { className: 'btn_item', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/' + (isPlayingAudio ? 'audio-stop-gray' : 'audio-play-gray') + '.png', alt: '' }),
                    isPlayingAudio && _react2.default.createElement(
                      'div',
                      { className: 'record_animation' },
                      _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar1' }),
                      _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar2' }),
                      _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar3' }),
                      _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar4' })
                    )
                  ),
                  _react2.default.createElement('img', { className: 'mar-r16 btn_item', onClick: this.setClipboardData, 'data-content': displayText, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-copy-gray.png', alt: '' }),
                  _react2.default.createElement('img', { className: 'btn_item', onClick: this.startShare, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-gray.png', alt: '' })
                )
              )
            )
          ),
          generateing == true && _react2.default.createElement(
            'div',
            { className: 'stop_generate', onClick: this.stopGenerate },
            '\u505C\u6B62\u751F\u6210'
          ),
          timeStr && _react2.default.createElement(
            'div',
            { className: 'timetxt mar_l53' },
            timeStr
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'chat' },
        _react2.default.createElement(
          'div',
          { className: 'chat-bubble-right' },
          isLoading && _react2.default.createElement(_icon2.default, { type: 'loading' }),
          err && _react2.default.createElement('img', { className: 'copyimg', onClick: this.againSend, 'data-content': displayText, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/error.png', alt: '' }),
          _react2.default.createElement(
            'div',
            { className: 'row fl_s', onMouseDown: this.longPressStart, onMouseUp: this.longPressEnd, onTouchStart: this.longPressStart, onTouchEnd: this.longPressEnd },
            _react2.default.createElement(
              'div',
              { className: 'chat-bubble-content' },
              this.props.isLongPress && _react2.default.createElement(
                'div',
                { className: 'pop' },
                _react2.default.createElement(
                  'div',
                  { className: 'item', onClick: this.setClipboardData, 'data-content': displayText },
                  _react2.default.createElement('div', { className: 'icon', style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-copy-white.png)' } }),
                  '\u590D\u5236'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'item', onClick: this.startShare },
                  _react2.default.createElement('div', { className: 'icon', style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-white.png)' } }),
                  '\u5206\u4EAB'
                )
              ),
              displayText,
              is_audio == '1' && _react2.default.createElement(
                'div',
                { className: 'btn_list' },
                is_audio == '1' && _react2.default.createElement(
                  'div',
                  { className: 'audio_play', onClick: this.playAudio },
                  _react2.default.createElement('img', { className: 'btn_item', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/' + (isPlayingAudio ? 'audio-stop-white' : 'audio-play-white') + '.png', alt: '' }),
                  isPlayingAudio && _react2.default.createElement(
                    'div',
                    { className: 'record_animation' },
                    _react2.default.createElement('div', { className: 'spectrum_bar_r spectrum_bar_r1' }),
                    _react2.default.createElement('div', { className: 'spectrum_bar_r spectrum_bar_r2' }),
                    _react2.default.createElement('div', { className: 'spectrum_bar_r spectrum_bar_r3' }),
                    _react2.default.createElement('div', { className: 'spectrum_bar_r spectrum_bar_r4' })
                  )
                )
              )
            ),
            _react2.default.createElement('img', { className: 'headimg', onClick: this.toPage, src: userInfo.cover_thumb ? userInfo.cover_thumb : 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' })
          )
        ),
        timeStr && _react2.default.createElement(
          'div',
          { className: 'timetxt mar_r53' },
          timeStr
        )
      );
    }
  }]);
  return TextAnimation;
}(_react.Component);

exports.default = TextAnimation;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultTabBar = undefined;

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcTabs = __webpack_require__(646);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DefaultTabBar = exports.DefaultTabBar = function (_RMCDefaultTabBar) {
    (0, _inherits3['default'])(DefaultTabBar, _RMCDefaultTabBar);

    function DefaultTabBar() {
        (0, _classCallCheck3['default'])(this, DefaultTabBar);
        return (0, _possibleConstructorReturn3['default'])(this, (DefaultTabBar.__proto__ || Object.getPrototypeOf(DefaultTabBar)).apply(this, arguments));
    }

    return DefaultTabBar;
}(_rmcTabs.DefaultTabBar);

DefaultTabBar.defaultProps = (0, _extends3['default'])({}, _rmcTabs.DefaultTabBar.defaultProps, { prefixCls: 'am-tabs-default-bar' });

var Tabs = function (_React$PureComponent) {
    (0, _inherits3['default'])(Tabs, _React$PureComponent);

    function Tabs() {
        (0, _classCallCheck3['default'])(this, Tabs);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));

        _this2.renderTabBar = function (props) {
            var renderTab = _this2.props.renderTab;

            return React.createElement(DefaultTabBar, (0, _extends3['default'])({}, props, { renderTab: renderTab }));
        };
        return _this2;
    }

    (0, _createClass3['default'])(Tabs, [{
        key: 'render',
        value: function render() {
            return React.createElement(_rmcTabs.Tabs, (0, _extends3['default'])({ renderTabBar: this.renderTabBar }, this.props));
        }
    }]);
    return Tabs;
}(React.PureComponent);

exports['default'] = Tabs;

Tabs.DefaultTabBar = DefaultTabBar;
Tabs.defaultProps = {
    prefixCls: 'am-tabs'
};

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(106), __webpack_require__(656), __webpack_require__(657), __webpack_require__(68), __webpack_require__(69), __webpack_require__(146), __webpack_require__(204), __webpack_require__(658), __webpack_require__(205), __webpack_require__(659), __webpack_require__(660), __webpack_require__(661), __webpack_require__(147), __webpack_require__(662), __webpack_require__(59), __webpack_require__(28), __webpack_require__(663), __webpack_require__(664), __webpack_require__(665), __webpack_require__(666), __webpack_require__(667), __webpack_require__(668), __webpack_require__(669), __webpack_require__(670), __webpack_require__(671), __webpack_require__(672), __webpack_require__(673), __webpack_require__(674), __webpack_require__(675), __webpack_require__(676), __webpack_require__(677), __webpack_require__(678));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).RecorderManager=t()}(this,(function(){"use strict";function e(e,t,r,o){return new(r||(r=Promise))((function(n,a){function i(e){try{u(o.next(e))}catch(e){a(e)}}function s(e){try{u(o.throw(e))}catch(e){a(e)}}function u(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(i,s)}u((o=o.apply(e,t||[])).next())}))}function t(e,t){var r,o,n,a,i={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function s(s){return function(u){return function(s){if(r)throw new TypeError("Generator is already executing.");for(;a&&(a=0,s[0]&&(i=0)),i;)try{if(r=1,o&&(n=2&s[0]?o.return:s[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,s[1])).done)return n;switch(o=0,n&&(s=[2&s[0],n.value]),s[0]){case 0:case 1:n=s;break;case 4:return i.label++,{value:s[1],done:!1};case 5:i.label++,o=s[1],s=[0];continue;case 7:s=i.ops.pop(),i.trys.pop();continue;default:if(!(n=i.trys,(n=n.length>0&&n[n.length-1])||6!==s[0]&&2!==s[0])){i=0;continue}if(3===s[0]&&(!n||s[1]>n[0]&&s[1]<n[3])){i.label=s[1];break}if(6===s[0]&&i.label<n[1]){i.label=n[1],n=s;break}if(n&&i.label<n[2]){i.label=n[2],i.ops.push(s);break}n[2]&&i.ops.pop(),i.trys.pop();continue}s=t.call(e,i)}catch(e){s=[6,e],o=0}finally{r=n=0}if(5&s[0])throw s[1];return{value:s[0]?s[1]:void 0,done:!0}}([s,u])}}}function r(){var e,t=navigator,r=t.getUserMedia||t.webkitGetUserMedia||t.mozGetUserMedia;return(null===(e=t.mediaDevices)||void 0===e?void 0:e.getUserMedia)?t.mediaDevices.getUserMedia({audio:!0,video:!1}):r?new Promise((function(e,t){r.call(navigator,{audio:!0,video:!1},(function(t){e(t)}),(function(e){t(e)}))})):Promise.reject(new Error("不支持录音"))}var o;function n(r,n){return e(this,void 0,void 0,(function(){var e;return t(this,(function(t){switch(t.label){case 0:return[3,2];case 1:return t.sent(),[2,new AudioWorkletNode(r,"processor-worklet")];case 2:return(e=o)?[3,4]:[4,new Worker("".concat(n,""))];case 3:e=t.sent(),t.label=4;case 4:return[2,{port:o=e}]}}))}))}return function(){function o(e){this.processorPath=e,this.audioBuffers=[]}return o.prototype.start=function(o){var a,i=o.sampleRate,s=o.frameSize,u=o.arrayBufferType;return e(this,void 0,void 0,(function(){var e,o,c,l,f,d,p;return t(this,(function(t){switch(t.label){case 0:return t.trys.push([0,3,,4]),(e=this).audioBuffers=[],[4,r()];case 1:return o=t.sent(),this.audioTracks=o.getAudioTracks(),c=function(e,t){var r;try{(r=new(window.AudioContext||window.webkitAudioContext)({sampleRate:t})).createMediaStreamSource(e)}catch(t){null==r||r.close(),(r=new(window.AudioContext||window.webkitAudioContext)).createMediaStreamSource(e)}return r}(o,i),this.audioContext=c,l=c.createMediaStreamSource(o),[4,n(c,this.processorPath)];case 2:return f=t.sent(),this.audioWorklet=f,f.port.postMessage({type:"init",data:{frameSize:s,toSampleRate:i||c.sampleRate,fromSampleRate:c.sampleRate,arrayBufferType:u||"short16"}}),f.port.onmessage=function(t){var r=t.data,o=r.frameBuffer,n=r.isLastFrame;if(s&&e.onFrameRecorded)if(null==o?void 0:o.byteLength)for(var a=0;a<o.byteLength;)e.onFrameRecorded({isLastFrame:n&&a+s>=o.byteLength,frameBuffer:t.data.frameBuffer.slice(a,a+s)}),a+=s;else e.onFrameRecorded(t.data);e.onStop&&(o&&e.audioBuffers.push(o),n&&e.onStop(e.audioBuffers))},(d=c.createScriptProcessor(0,1,1)).onaudioprocess=function(e){f.port.postMessage({type:"message",data:e.inputBuffer.getChannelData(0)})},l.connect(d),d.connect(c.destination),c.resume(),null===(a=this.onStart)||void 0===a||a.call(this),[3,4];case 3:return p=t.sent(),console.error(p),[3,4];case 4:return[2]}}))}))},o.prototype.stop=function(){var e,t,r,o;null===(e=this.audioWorklet)||void 0===e||e.port.postMessage({type:"stop"}),null===(t=this.audioTracks)||void 0===t||t[0].stop(),"running"===(null===(r=this.audioContext)||void 0===r?void 0:r.state)&&(null===(o=this.audioContext)||void 0===o||o.close())},o}()}));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));
//# sourceMappingURL=html2canvas.js.map


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(52);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(15);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: external "ReactDOM"
var external__ReactDOM_ = __webpack_require__(19);
var external__ReactDOM__default = /*#__PURE__*/__webpack_require__.n(external__ReactDOM_);

// CONCATENATED MODULE: ./node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}



// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/contains.js
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}
// EXTERNAL MODULE: ./node_modules/add-dom-event-listener/lib/index.js
var lib = __webpack_require__(206);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/rc-util/es/Dom/addEventListener.js


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = external__ReactDOM__default.a.unstable_batchedUpdates ? function run(e) {
    external__ReactDOM__default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return lib_default()(target, eventType, callback, option);
}
// CONCATENATED MODULE: ./node_modules/rc-util/es/ContainerRender.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender_ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        external__ReactDOM__default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        external__ReactDOM__default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(external__React__default.a.Component);

ContainerRender_ContainerRender.propTypes = {
  autoMount: prop_types_default.a.bool,
  autoDestroy: prop_types_default.a.bool,
  visible: prop_types_default.a.bool,
  forceRender: prop_types_default.a.bool,
  parent: prop_types_default.a.any,
  getComponent: prop_types_default.a.func.isRequired,
  getContainer: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.func.isRequired
};
ContainerRender_ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};

// CONCATENATED MODULE: ./node_modules/rc-util/es/Portal.js
function Portal__typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Portal__typeof = function _typeof(obj) { return typeof obj; }; } else { Portal__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Portal__typeof(obj); }

function Portal__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Portal__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Portal__createClass(Constructor, protoProps, staticProps) { if (protoProps) Portal__defineProperties(Constructor.prototype, protoProps); if (staticProps) Portal__defineProperties(Constructor, staticProps); return Constructor; }

function Portal__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Portal__setPrototypeOf(subClass, superClass); }

function Portal__setPrototypeOf(o, p) { Portal__setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Portal__setPrototypeOf(o, p); }

function Portal__createSuper(Derived) { var hasNativeReflectConstruct = Portal__isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Portal__getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Portal__getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Portal__possibleConstructorReturn(this, result); }; }

function Portal__possibleConstructorReturn(self, call) { if (call && (Portal__typeof(call) === "object" || typeof call === "function")) { return call; } return Portal__assertThisInitialized(self); }

function Portal__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Portal__isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function Portal__getPrototypeOf(o) { Portal__getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Portal__getPrototypeOf(o); }





var Portal_Portal = /*#__PURE__*/function (_React$Component) {
  Portal__inherits(Portal, _React$Component);

  var _super = Portal__createSuper(Portal);

  function Portal() {
    Portal__classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  Portal__createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return external__ReactDOM__default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(external__React__default.a.Component);

Portal_Portal.propTypes = {
  getContainer: prop_types_default.a.func.isRequired,
  children: prop_types_default.a.node.isRequired,
  didUpdate: prop_types_default.a.func
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(16);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rc-trigger/es/utils.js

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return extends_default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// CONCATENATED MODULE: ./node_modules/dom-align/dist-web/index.js
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function dist_web__typeof(obj) {
  "@babel/helpers - typeof";

  return dist_web__typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, dist_web__typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (dist_web__typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function dist_web_alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* harmony default export */ var dist_web = (alignElement);

//# sourceMappingURL=index.js.map

// CONCATENATED MODULE: ./node_modules/rc-align/es/util.js


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function util_isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && contains(container, activeElement)) {
    activeElement.focus();
  }
}
// CONCATENATED MODULE: ./node_modules/rc-align/es/Align.js












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align_Align = function (_Component) {
  inherits_default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = external__ReactDOM__default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = alignElement(source, element, align);
        } else if (point) {
          result = dist_web_alignPoint(source, point, align);
        }

        restoreFocus(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = external__ReactDOM__default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (util_isWindow(lastElement) && util_isWindow(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !isSamePoint(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!isSimilarValue(preRect.width, sourceRect.width) || !isSimilarValue(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = addEventListenerWrap(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = external__React__default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return external__React__default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(external__React_["Component"]);

Align_Align.propTypes = {
  childrenProps: prop_types_default.a.object,
  align: prop_types_default.a.object.isRequired,
  target: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.shape({
    clientX: prop_types_default.a.number,
    clientY: prop_types_default.a.number,
    pageX: prop_types_default.a.number,
    pageY: prop_types_default.a.number
  })]),
  onAlign: prop_types_default.a.func,
  monitorBufferTime: prop_types_default.a.number,
  monitorWindowResize: prop_types_default.a.bool,
  disabled: prop_types_default.a.bool,
  children: prop_types_default.a.any
};
Align_Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ var es_Align = (Align_Align);
// CONCATENATED MODULE: ./node_modules/rc-align/es/index.js
// export this package's api


/* harmony default export */ var es = (es_Align);
// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 6 modules
var Animate = __webpack_require__(122);

// CONCATENATED MODULE: ./node_modules/rc-trigger/es/LazyRenderBox.js







var LazyRenderBox_LazyRenderBox = function (_Component) {
  inherits_default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    classCallCheck_default()(this, LazyRenderBox);

    return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = objectWithoutProperties_default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || external__React__default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return external__React__default.a.createElement('div', props);
    }

    return external__React__default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(external__React_["Component"]);

LazyRenderBox_LazyRenderBox.propTypes = {
  children: prop_types_default.a.any,
  className: prop_types_default.a.string,
  visible: prop_types_default.a.bool,
  hiddenClassName: prop_types_default.a.string
};


/* harmony default export */ var es_LazyRenderBox = (LazyRenderBox_LazyRenderBox);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/PopupInner.js







var PopupInner_PopupInner = function (_Component) {
  inherits_default()(PopupInner, _Component);

  function PopupInner() {
    classCallCheck_default()(this, PopupInner);

    return possibleConstructorReturn_default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return external__React__default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      external__React__default.a.createElement(
        es_LazyRenderBox,
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(external__React_["Component"]);

PopupInner_PopupInner.propTypes = {
  hiddenClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  prefixCls: prop_types_default.a.string,
  onMouseEnter: prop_types_default.a.func,
  onMouseLeave: prop_types_default.a.func,
  onMouseDown: prop_types_default.a.func,
  onTouchStart: prop_types_default.a.func,
  children: prop_types_default.a.any
};


/* harmony default export */ var es_PopupInner = (PopupInner_PopupInner);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/Popup.js













var Popup_Popup = function (_Component) {
  inherits_default()(Popup, _Component);

  function Popup(props) {
    classCallCheck_default()(this, Popup);

    var _this = possibleConstructorReturn_default()(this, _Component.call(this, props));

    Popup__initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = saveRef.bind(_this, 'popupInstance');
    _this.saveAlignRef = saveRef.bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return external__ReactDOM__default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = extends_default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return external__React__default.a.createElement(
        Animate["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? external__React__default.a.createElement(
          es,
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          external__React__default.a.createElement(
            es_PopupInner,
            extends_default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return external__React__default.a.createElement(
      Animate["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      external__React__default.a.createElement(
        es,
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        external__React__default.a.createElement(
          es_PopupInner,
          extends_default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = external__React__default.a.createElement(es_LazyRenderBox, {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = external__React__default.a.createElement(
          Animate["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return external__React__default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(external__React_["Component"]);

Popup_Popup.propTypes = {
  visible: prop_types_default.a.bool,
  style: prop_types_default.a.object,
  getClassNameFromAlign: prop_types_default.a.func,
  onAlign: prop_types_default.a.func,
  getRootDomNode: prop_types_default.a.func,
  align: prop_types_default.a.any,
  destroyPopupOnHide: prop_types_default.a.bool,
  className: prop_types_default.a.string,
  prefixCls: prop_types_default.a.string,
  onMouseEnter: prop_types_default.a.func,
  onMouseLeave: prop_types_default.a.func,
  onMouseDown: prop_types_default.a.func,
  onTouchStart: prop_types_default.a.func,
  stretch: prop_types_default.a.string,
  children: prop_types_default.a.node,
  point: prop_types_default.a.shape({
    pageX: prop_types_default.a.number,
    pageY: prop_types_default.a.number
  })
};

var Popup__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ var es_Popup = (Popup_Popup);
// CONCATENATED MODULE: ./node_modules/rc-trigger/es/index.js

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!external__ReactDOM_["createPortal"];

var contextTypes = {
  rcTrigger: prop_types_default.a.shape({
    onPopupMouseDown: prop_types_default.a.func
  })
};

var es_Trigger = function (_React$Component) {
  inherits_default()(Trigger, _React$Component);

  function Trigger(props) {
    classCallCheck_default()(this, Trigger);

    var _this = possibleConstructorReturn_default()(this, _React$Component.call(this, props));

    es__initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = addEventListenerWrap(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = addEventListenerWrap(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = addEventListenerWrap(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = external__React__default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = classnames_default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = external__React__default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return external__React__default.a.createElement(
        ContainerRender_ContainerRender,
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = external__React__default.a.createElement(
        Portal_Portal,
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(external__React__default.a.Component);

es_Trigger.propTypes = {
  children: prop_types_default.a.any,
  action: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.arrayOf(prop_types_default.a.string)]),
  showAction: prop_types_default.a.any,
  hideAction: prop_types_default.a.any,
  getPopupClassNameFromAlign: prop_types_default.a.any,
  onPopupVisibleChange: prop_types_default.a.func,
  afterPopupVisibleChange: prop_types_default.a.func,
  popup: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.func]).isRequired,
  popupStyle: prop_types_default.a.object,
  prefixCls: prop_types_default.a.string,
  popupClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  popupPlacement: prop_types_default.a.string,
  builtinPlacements: prop_types_default.a.object,
  popupTransitionName: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  popupAnimation: prop_types_default.a.any,
  mouseEnterDelay: prop_types_default.a.number,
  mouseLeaveDelay: prop_types_default.a.number,
  zIndex: prop_types_default.a.number,
  focusDelay: prop_types_default.a.number,
  blurDelay: prop_types_default.a.number,
  getPopupContainer: prop_types_default.a.func,
  getDocument: prop_types_default.a.func,
  forceRender: prop_types_default.a.bool,
  destroyPopupOnHide: prop_types_default.a.bool,
  mask: prop_types_default.a.bool,
  maskClosable: prop_types_default.a.bool,
  onPopupAlign: prop_types_default.a.func,
  popupAlign: prop_types_default.a.object,
  popupVisible: prop_types_default.a.bool,
  defaultPopupVisible: prop_types_default.a.bool,
  maskTransitionName: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  maskAnimation: prop_types_default.a.string,
  stretch: prop_types_default.a.string,
  alignPoint: prop_types_default.a.bool // Maybe we can support user pass position in the future
};
es_Trigger.contextTypes = contextTypes;
es_Trigger.childContextTypes = contextTypes;
es_Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var es__initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && contains(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(external__ReactDOM_["findDOMNode"])(_this4);
    if (!contains(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(external__ReactDOM_["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return external__React__default.a.createElement(
      es_Popup,
      extends_default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(external__ReactDOM_["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

polyfill(es_Trigger);

/* harmony default export */ var rc_trigger_es = (es_Trigger);
// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/placements.js
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* harmony default export */ var es_placements = (placements);
// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Content.js






var Content_Content = function (_React$Component) {
  inherits_default()(Content, _React$Component);

  function Content() {
    classCallCheck_default()(this, Content);

    return possibleConstructorReturn_default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return external__React__default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(external__React__default.a.Component);

Content_Content.propTypes = {
  prefixCls: prop_types_default.a.string,
  overlay: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.func]).isRequired,
  id: prop_types_default.a.string,
  trigger: prop_types_default.a.any
};
/* harmony default export */ var es_Content = (Content_Content);
// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/Tooltip.js











var Tooltip_Tooltip = function (_Component) {
  inherits_default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    classCallCheck_default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [external__React__default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), external__React__default.a.createElement(es_Content, {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = objectWithoutProperties_default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = extends_default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return external__React__default.a.createElement(
      rc_trigger_es,
      extends_default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: placements,
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(external__React_["Component"]);

Tooltip_Tooltip.propTypes = {
  trigger: prop_types_default.a.any,
  children: prop_types_default.a.any,
  defaultVisible: prop_types_default.a.bool,
  visible: prop_types_default.a.bool,
  placement: prop_types_default.a.string,
  transitionName: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  animation: prop_types_default.a.any,
  onVisibleChange: prop_types_default.a.func,
  afterVisibleChange: prop_types_default.a.func,
  overlay: prop_types_default.a.oneOfType([prop_types_default.a.node, prop_types_default.a.func]).isRequired,
  overlayStyle: prop_types_default.a.object,
  overlayClassName: prop_types_default.a.string,
  prefixCls: prop_types_default.a.string,
  mouseEnterDelay: prop_types_default.a.number,
  mouseLeaveDelay: prop_types_default.a.number,
  getTooltipContainer: prop_types_default.a.func,
  destroyTooltipOnHide: prop_types_default.a.bool,
  align: prop_types_default.a.object,
  arrowContent: prop_types_default.a.any,
  id: prop_types_default.a.string
};
Tooltip_Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ var es_Tooltip = (Tooltip_Tooltip);
// CONCATENATED MODULE: ./node_modules/rc-tooltip/es/index.js


/* harmony default export */ var rc_tooltip_es = __webpack_exports__["default"] = (es_Tooltip);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  var lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcCheckbox = __webpack_require__(195);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Checkbox = function (_React$Component) {
    (0, _inherits3['default'])(Checkbox, _React$Component);

    function Checkbox() {
        (0, _classCallCheck3['default'])(this, Checkbox);
        return (0, _possibleConstructorReturn3['default'])(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Checkbox, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                className = _a.className,
                style = _a.style,
                restProps = __rest(_a, ["className", "style"]);var prefixCls = restProps.prefixCls,
                children = restProps.children;

            var wrapCls = (0, _classnames2['default'])(prefixCls + '-wrapper', className);
            // Todo: wait for https://github.com/developit/preact-compat/issues/422, then we can remove class below
            if ('class' in restProps) {
                /* tslint:disable:no-string-literal */
                delete restProps['class'];
            }
            var mark = React.createElement(
                'label',
                { className: wrapCls, style: style },
                React.createElement(_rcCheckbox2['default'], restProps),
                children
            );
            if (this.props.wrapLabel) {
                return mark;
            }
            return React.createElement(_rcCheckbox2['default'], this.props);
        }
    }]);
    return Checkbox;
}(React.Component);

exports['default'] = Checkbox;

Checkbox.defaultProps = {
    prefixCls: 'am-checkbox',
    wrapLabel: true
};
module.exports = exports['default'];

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/warning/browser.js
var browser = __webpack_require__(40);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(15);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/history/esm/history.js + 5 modules
var esm_history = __webpack_require__(54);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var invariant_browser = __webpack_require__(55);
var invariant_browser_default = /*#__PURE__*/__webpack_require__.n(invariant_browser);

// CONCATENATED MODULE: ./node_modules/react-router/es/Router.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router_Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    invariant_browser_default()(children == null || external__React__default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    browser_default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? external__React__default.a.Children.only(children) : null;
  };

  return Router;
}(external__React__default.a.Component);

Router_Router.propTypes = {
  history: prop_types_default.a.object.isRequired,
  children: prop_types_default.a.node
};
Router_Router.contextTypes = {
  router: prop_types_default.a.object
};
Router_Router.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_Router = (Router_Router);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Router.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Router = (es_Router);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/BrowserRouter.js
function BrowserRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function BrowserRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function BrowserRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter_BrowserRouter = function (_React$Component) {
  BrowserRouter__inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    BrowserRouter__classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = BrowserRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["createBrowserHistory"])(_this.props), _temp), BrowserRouter__possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return external__React__default.a.createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(external__React__default.a.Component);

BrowserRouter_BrowserRouter.propTypes = {
  basename: prop_types_default.a.string,
  forceRefresh: prop_types_default.a.bool,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_BrowserRouter = (BrowserRouter_BrowserRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/HashRouter.js
function HashRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function HashRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function HashRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter_HashRouter = function (_React$Component) {
  HashRouter__inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    HashRouter__classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = HashRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["createHashHistory"])(_this.props), _temp), HashRouter__possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return external__React__default.a.createElement(react_router_dom_es_Router, { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(external__React__default.a.Component);

HashRouter_HashRouter.propTypes = {
  basename: prop_types_default.a.string,
  getUserConfirmation: prop_types_default.a.func,
  hashType: prop_types_default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: prop_types_default.a.node
};


/* harmony default export */ var es_HashRouter = (HashRouter_HashRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Link.js
var Link__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Link__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Link__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Link__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link_Link = function (_React$Component) {
  Link__inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    Link__classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Link__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), Link__possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    invariant_browser_default()(this.context.router, "You should not use <Link> outside a <Router>");

    invariant_browser_default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(esm_history["createLocation"])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return external__React__default.a.createElement("a", Link__extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(external__React__default.a.Component);

Link_Link.propTypes = {
  onClick: prop_types_default.a.func,
  target: prop_types_default.a.string,
  replace: prop_types_default.a.bool,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired,
  innerRef: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.func])
};
Link_Link.defaultProps = {
  replace: false
};
Link_Link.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired,
      createHref: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Link = (Link_Link);
// CONCATENATED MODULE: ./node_modules/react-router/es/MemoryRouter.js
function MemoryRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function MemoryRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function MemoryRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter_MemoryRouter = function (_React$Component) {
  MemoryRouter__inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    MemoryRouter__classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = MemoryRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(esm_history["createMemoryHistory"])(_this.props), _temp), MemoryRouter__possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return external__React__default.a.createElement(es_Router, { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(external__React__default.a.Component);

MemoryRouter_MemoryRouter.propTypes = {
  initialEntries: prop_types_default.a.array,
  initialIndex: prop_types_default.a.number,
  getUserConfirmation: prop_types_default.a.func,
  keyLength: prop_types_default.a.number,
  children: prop_types_default.a.node
};


/* harmony default export */ var es_MemoryRouter = (MemoryRouter_MemoryRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/MemoryRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_MemoryRouter = (es_MemoryRouter);
// EXTERNAL MODULE: ./node_modules/path-to-regexp/index.js
var path_to_regexp = __webpack_require__(155);
var path_to_regexp_default = /*#__PURE__*/__webpack_require__.n(path_to_regexp);

// CONCATENATED MODULE: ./node_modules/react-router/es/matchPath.js


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var matchPath_compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = path_to_regexp_default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = matchPath_compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ var es_matchPath = (matchPath);
// CONCATENATED MODULE: ./node_modules/react-router/es/Route.js
var Route__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Route__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Route__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Route__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Route_isEmptyChildren = function isEmptyChildren(children) {
  return external__React__default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route_Route = function (_React$Component) {
  Route__inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    Route__classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = Route__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), Route__possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: Route__extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    invariant_browser_default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return es_matchPath(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    browser_default()(!(this.props.component && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    browser_default()(!(this.props.render && this.props.children && !Route_isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    browser_default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    browser_default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? external__React__default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !Route_isEmptyChildren(children)) return external__React__default.a.Children.only(children);

    return null;
  };

  return Route;
}(external__React__default.a.Component);

Route_Route.propTypes = {
  computedMatch: prop_types_default.a.object, // private, from <Switch>
  path: prop_types_default.a.string,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  sensitive: prop_types_default.a.bool,
  component: prop_types_default.a.func,
  render: prop_types_default.a.func,
  children: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.node]),
  location: prop_types_default.a.object
};
Route_Route.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.object.isRequired,
    route: prop_types_default.a.object.isRequired,
    staticContext: prop_types_default.a.object
  })
};
Route_Route.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_Route = (Route_Route);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Route.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Route = (es_Route);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/NavLink.js
var NavLink__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function NavLink__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink_NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = NavLink__objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return external__React__default.a.createElement(react_router_dom_es_Route, {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return external__React__default.a.createElement(es_Link, NavLink__extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? NavLink__extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink_NavLink.propTypes = {
  to: es_Link.propTypes.to,
  exact: prop_types_default.a.bool,
  strict: prop_types_default.a.bool,
  location: prop_types_default.a.object,
  activeClassName: prop_types_default.a.string,
  className: prop_types_default.a.string,
  activeStyle: prop_types_default.a.object,
  style: prop_types_default.a.object,
  isActive: prop_types_default.a.func,
  "aria-current": prop_types_default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink_NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ var es_NavLink = (NavLink_NavLink);
// CONCATENATED MODULE: ./node_modules/react-router/es/Prompt.js
function Prompt__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Prompt__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Prompt__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt_Prompt = function (_React$Component) {
  Prompt__inherits(Prompt, _React$Component);

  function Prompt() {
    Prompt__classCallCheck(this, Prompt);

    return Prompt__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(external__React__default.a.Component);

Prompt_Prompt.propTypes = {
  when: prop_types_default.a.bool,
  message: prop_types_default.a.oneOfType([prop_types_default.a.func, prop_types_default.a.string]).isRequired
};
Prompt_Prompt.defaultProps = {
  when: true
};
Prompt_Prompt.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      block: prop_types_default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ var es_Prompt = (Prompt_Prompt);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Prompt.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Prompt = (es_Prompt);
// CONCATENATED MODULE: ./node_modules/react-router/es/generatePath.js


var generatePath_patternCache = {};
var generatePath_cacheLimit = 10000;
var generatePath_cacheCount = 0;

var generatePath_compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = generatePath_patternCache[cacheKey] || (generatePath_patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = path_to_regexp_default.a.compile(pattern);

  if (generatePath_cacheCount < generatePath_cacheLimit) {
    cache[pattern] = compiledGenerator;
    generatePath_cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = generatePath_compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ var es_generatePath = (generatePath);
// CONCATENATED MODULE: ./node_modules/react-router/es/Redirect.js
var Redirect__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function Redirect__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Redirect__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Redirect__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect_Redirect = function (_React$Component) {
  Redirect__inherits(Redirect, _React$Component);

  function Redirect() {
    Redirect__classCallCheck(this, Redirect);

    return Redirect__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(esm_history["createLocation"])(prevProps.to);
    var nextTo = Object(esm_history["createLocation"])(this.props.to);

    if (Object(esm_history["locationsAreEqual"])(prevTo, nextTo)) {
      browser_default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return es_generatePath(to, computedMatch.params);
      } else {
        return Redirect__extends({}, to, {
          pathname: es_generatePath(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(external__React__default.a.Component);

Redirect_Redirect.propTypes = {
  computedMatch: prop_types_default.a.object, // private, from <Switch>
  push: prop_types_default.a.bool,
  from: prop_types_default.a.string,
  to: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]).isRequired
};
Redirect_Redirect.defaultProps = {
  push: false
};
Redirect_Redirect.contextTypes = {
  router: prop_types_default.a.shape({
    history: prop_types_default.a.shape({
      push: prop_types_default.a.func.isRequired,
      replace: prop_types_default.a.func.isRequired
    }).isRequired,
    staticContext: prop_types_default.a.object
  }).isRequired
};


/* harmony default export */ var es_Redirect = (Redirect_Redirect);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Redirect.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Redirect = (es_Redirect);
// CONCATENATED MODULE: ./node_modules/react-router/es/StaticRouter.js
var StaticRouter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function StaticRouter__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function StaticRouter__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function StaticRouter__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function StaticRouter__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return StaticRouter__extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return StaticRouter__extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var StaticRouter_createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(esm_history["createPath"])(location);
};

var StaticRouter_staticHandler = function staticHandler(methodName) {
  return function () {
    invariant_browser_default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter_StaticRouter = function (_React$Component) {
  StaticRouter__inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    StaticRouter__classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = StaticRouter__possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + StaticRouter_createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(esm_history["createLocation"])(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(esm_history["createLocation"])(location));
      context.url = StaticRouter_createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), StaticRouter__possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    browser_default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = StaticRouter__objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(esm_history["createLocation"])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: StaticRouter_staticHandler("go"),
      goBack: StaticRouter_staticHandler("goBack"),
      goForward: StaticRouter_staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return external__React__default.a.createElement(es_Router, StaticRouter__extends({}, props, { history: history }));
  };

  return StaticRouter;
}(external__React__default.a.Component);

StaticRouter_StaticRouter.propTypes = {
  basename: prop_types_default.a.string,
  context: prop_types_default.a.object.isRequired,
  location: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object])
};
StaticRouter_StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter_StaticRouter.childContextTypes = {
  router: prop_types_default.a.object.isRequired
};


/* harmony default export */ var es_StaticRouter = (StaticRouter_StaticRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/StaticRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_StaticRouter = (es_StaticRouter);
// CONCATENATED MODULE: ./node_modules/react-router/es/Switch.js
function Switch__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Switch__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Switch__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch_Switch = function (_React$Component) {
  Switch__inherits(Switch, _React$Component);

  function Switch() {
    Switch__classCallCheck(this, Switch);

    return Switch__possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    invariant_browser_default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    browser_default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    browser_default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    external__React__default.a.Children.forEach(children, function (element) {
      if (match == null && external__React__default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = es_matchPath(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? external__React__default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(external__React__default.a.Component);

Switch_Switch.contextTypes = {
  router: prop_types_default.a.shape({
    route: prop_types_default.a.object.isRequired
  }).isRequired
};
Switch_Switch.propTypes = {
  children: prop_types_default.a.node,
  location: prop_types_default.a.object
};


/* harmony default export */ var es_Switch = (Switch_Switch);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/Switch.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_Switch = (es_Switch);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/generatePath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_generatePath = (es_generatePath);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/matchPath.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_matchPath = (es_matchPath);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__(156);
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// CONCATENATED MODULE: ./node_modules/react-router/es/withRouter.js
var withRouter__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function withRouter__objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter_withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = withRouter__objectWithoutProperties(props, ["wrappedComponentRef"]);

    return external__React__default.a.createElement(es_Route, {
      children: function children(routeComponentProps) {
        return external__React__default.a.createElement(Component, withRouter__extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: prop_types_default.a.func
  };

  return hoist_non_react_statics_default()(C, Component);
};

/* harmony default export */ var es_withRouter = (withRouter_withRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/withRouter.js
// Written in this round about way for babel-transform-imports


/* harmony default export */ var react_router_dom_es_withRouter = (es_withRouter);
// CONCATENATED MODULE: ./node_modules/react-router-dom/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return es_BrowserRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "HashRouter", function() { return es_HashRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Link", function() { return es_Link; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return react_router_dom_es_MemoryRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "NavLink", function() { return es_NavLink; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Prompt", function() { return react_router_dom_es_Prompt; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Redirect", function() { return react_router_dom_es_Redirect; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Route", function() { return react_router_dom_es_Route; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Router", function() { return react_router_dom_es_Router; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return react_router_dom_es_StaticRouter; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Switch", function() { return react_router_dom_es_Switch; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "generatePath", function() { return react_router_dom_es_generatePath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "matchPath", function() { return react_router_dom_es_matchPath; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "withRouter", function() { return react_router_dom_es_withRouter; });





























/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(71)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(51) && !__webpack_require__(63)(function () {
  return Object.defineProperty(__webpack_require__(108)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(57);
var toIObject = __webpack_require__(58);
var arrayIndexOf = __webpack_require__(223)(false);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(73);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(225), __esModule: true };

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(74);
var $export = __webpack_require__(46);
var redefine = __webpack_require__(162);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(64);
var $iterCreate = __webpack_require__(231);
var setToStringTag = __webpack_require__(90);
var getPrototypeOf = __webpack_require__(164);
var ITERATOR = __webpack_require__(35)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(56);


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(34).document;
module.exports = document && document.documentElement;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(57);
var toObject = __webpack_require__(75);
var IE_PROTO = __webpack_require__(113)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(158);
var hiddenKeys = __webpack_require__(115).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 166 */
/***/ (function(module, exports) {



/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: external "ReactDOM"
var external__ReactDOM_ = __webpack_require__(19);
var external__ReactDOM__default = /*#__PURE__*/__webpack_require__.n(external__ReactDOM_);

// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 6 modules
var Animate = __webpack_require__(122);

// CONCATENATED MODULE: ./node_modules/rmc-dialog/es/LazyRenderBox.js







var LazyRenderBox_LazyRenderBox = function (_React$Component) {
    inherits_default()(LazyRenderBox, _React$Component);

    function LazyRenderBox() {
        classCallCheck_default()(this, LazyRenderBox);

        return possibleConstructorReturn_default()(this, (LazyRenderBox.__proto__ || Object.getPrototypeOf(LazyRenderBox)).apply(this, arguments));
    }

    createClass_default()(LazyRenderBox, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
            return !!nextProps.hiddenClassName || !!nextProps.visible;
        }
    }, {
        key: "render",
        value: function render() {
            var className = this.props.className;
            if (!!this.props.hiddenClassName && !this.props.visible) {
                className += " " + this.props.hiddenClassName;
            }
            var props = extends_default()({}, this.props);
            delete props.hiddenClassName;
            delete props.visible;
            props.className = className;
            return external__React__default.a.createElement("div", extends_default()({}, props));
        }
    }]);

    return LazyRenderBox;
}(external__React__default.a.Component);

/* harmony default export */ var es_LazyRenderBox = (LazyRenderBox_LazyRenderBox);
// CONCATENATED MODULE: ./node_modules/rmc-dialog/es/Dialog.js








function noop() {}

var Dialog_Dialog = function (_React$Component) {
    inherits_default()(Dialog, _React$Component);

    function Dialog() {
        classCallCheck_default()(this, Dialog);

        var _this = possibleConstructorReturn_default()(this, (Dialog.__proto__ || Object.getPrototypeOf(Dialog)).apply(this, arguments));

        _this.getDialogElement = function () {
            var props = _this.props;
            var closable = props.closable;
            var prefixCls = props.prefixCls;
            var footer = void 0;
            if (props.footer) {
                footer = external__React__default.a.createElement("div", { className: prefixCls + '-footer', ref: function ref(el) {
                        return _this.footerRef = el;
                    } }, props.footer);
            }
            var header = void 0;
            if (props.title) {
                header = external__React__default.a.createElement("div", { className: prefixCls + '-header', ref: function ref(el) {
                        return _this.headerRef = el;
                    } }, external__React__default.a.createElement("div", { className: prefixCls + '-title' }, props.title));
            }
            var closer = void 0;
            if (closable) {
                closer = external__React__default.a.createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, external__React__default.a.createElement("span", { className: prefixCls + '-close-x' }));
            }
            var transitionName = _this.getTransitionName();
            var dialogElement = external__React__default.a.createElement(es_LazyRenderBox, { key: "dialog-element", role: "document", ref: function ref(el) {
                    return _this.dialogRef = el;
                }, style: props.style || {}, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, external__React__default.a.createElement("div", { className: prefixCls + '-content' }, closer, header, external__React__default.a.createElement("div", { className: prefixCls + '-body', style: props.bodyStyle, ref: function ref(el) {
                    return _this.bodyRef = el;
                } }, props.children), footer));
            return external__React__default.a.createElement(Animate["a" /* default */], { key: "dialog", showProp: "visible", onAppear: _this.onAnimateAppear, onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, dialogElement);
        };
        _this.onAnimateAppear = function () {
            document.body.style.overflow = 'hidden';
        };
        _this.onAnimateLeave = function () {
            document.body.style.overflow = '';
            if (_this.wrapRef) {
                _this.wrapRef.style.display = 'none';
            }
            if (_this.props.onAnimateLeave) {
                _this.props.onAnimateLeave();
            }
            if (_this.props.afterClose) {
                _this.props.afterClose();
            }
        };
        _this.close = function (e) {
            if (_this.props.onClose) {
                _this.props.onClose(e);
            }
        };
        _this.onMaskClick = function (e) {
            if (e.target === e.currentTarget) {
                _this.close(e);
            }
        };
        return _this;
    }

    createClass_default()(Dialog, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // fix: react@16 no dismissing animation
            document.body.style.overflow = '';
            if (this.wrapRef) {
                this.wrapRef.style.display = 'none';
            }
        }
    }, {
        key: 'getZIndexStyle',
        value: function getZIndexStyle() {
            var style = {};
            var props = this.props;
            if (props.zIndex !== undefined) {
                style.zIndex = props.zIndex;
            }
            return style;
        }
    }, {
        key: 'getWrapStyle',
        value: function getWrapStyle() {
            var wrapStyle = this.props.wrapStyle || {};
            return extends_default()({}, this.getZIndexStyle(), wrapStyle);
        }
    }, {
        key: 'getMaskStyle',
        value: function getMaskStyle() {
            var maskStyle = this.props.maskStyle || {};
            return extends_default()({}, this.getZIndexStyle(), maskStyle);
        }
    }, {
        key: 'getMaskTransitionName',
        value: function getMaskTransitionName() {
            var props = this.props;
            var transitionName = props.maskTransitionName;
            var animation = props.maskAnimation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getTransitionName',
        value: function getTransitionName() {
            var props = this.props;
            var transitionName = props.transitionName;
            var animation = props.animation;
            if (!transitionName && animation) {
                transitionName = props.prefixCls + '-' + animation;
            }
            return transitionName;
        }
    }, {
        key: 'getMaskElement',
        value: function getMaskElement() {
            var props = this.props;
            var maskElement = void 0;
            if (props.mask) {
                var maskTransition = this.getMaskTransitionName();
                maskElement = external__React__default.a.createElement(es_LazyRenderBox, extends_default()({ style: this.getMaskStyle(), key: "mask-element", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
                if (maskTransition) {
                    maskElement = external__React__default.a.createElement(Animate["a" /* default */], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
                }
            }
            return maskElement;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var props = this.props;
            var prefixCls = props.prefixCls,
                maskClosable = props.maskClosable;

            var style = this.getWrapStyle();
            if (props.visible) {
                style.display = null;
            }
            return external__React__default.a.createElement("div", null, this.getMaskElement(), external__React__default.a.createElement("div", extends_default()({ className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: function ref(el) {
                    return _this2.wrapRef = el;
                }, onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title, style: style }, props.wrapProps), this.getDialogElement()));
        }
    }]);

    return Dialog;
}(external__React__default.a.Component);

/* harmony default export */ var es_Dialog = (Dialog_Dialog);

Dialog_Dialog.defaultProps = {
    afterClose: noop,
    className: '',
    mask: true,
    visible: false,
    closable: true,
    maskClosable: true,
    prefixCls: 'rmc-dialog',
    onClose: noop
};
// CONCATENATED MODULE: ./node_modules/rmc-dialog/es/DialogWrap.js








function DialogWrap_noop() {}
var IS_REACT_16 = !!external__ReactDOM__default.a.createPortal;
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var DialogWrap_DialogWrap = function (_React$Component) {
    inherits_default()(DialogWrap, _React$Component);

    function DialogWrap() {
        classCallCheck_default()(this, DialogWrap);

        var _this = possibleConstructorReturn_default()(this, (DialogWrap.__proto__ || Object.getPrototypeOf(DialogWrap)).apply(this, arguments));

        _this.saveRef = function (node) {
            if (IS_REACT_16) {
                _this._component = node;
            }
        };
        _this.getComponent = function (visible) {
            var props = extends_default()({}, _this.props);
            ['visible', 'onAnimateLeave'].forEach(function (key) {
                if (props.hasOwnProperty(key)) {
                    delete props[key];
                }
            });
            return external__React__default.a.createElement(es_Dialog, extends_default()({}, props, { visible: visible, onAnimateLeave: _this.removeContainer, ref: _this.saveRef }));
        };
        _this.removeContainer = function () {
            if (_this.container) {
                if (!IS_REACT_16) {
                    external__ReactDOM__default.a.unmountComponentAtNode(_this.container);
                }
                _this.container.parentNode.removeChild(_this.container);
                _this.container = null;
            }
        };
        _this.getContainer = function () {
            if (!_this.container) {
                var container = document.createElement('div');
                var containerId = _this.props.prefixCls + '-container-' + new Date().getTime();
                container.setAttribute('id', containerId);
                document.body.appendChild(container);
                _this.container = container;
            }
            return _this.container;
        };
        return _this;
    }

    createClass_default()(DialogWrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.visible) {
                this.componentDidUpdate();
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(_ref) {
            var visible = _ref.visible;

            return !!(this.props.visible || visible);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.visible) {
                if (!IS_REACT_16) {
                    this.renderDialog(false);
                } else {
                    // TODO for react@16 createPortal animation
                    this.removeContainer();
                }
            } else {
                this.removeContainer();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!IS_REACT_16) {
                this.renderDialog(this.props.visible);
            }
        }
    }, {
        key: 'renderDialog',
        value: function renderDialog(visible) {
            external__ReactDOM__default.a.unstable_renderSubtreeIntoContainer(this, this.getComponent(visible), this.getContainer());
        }
    }, {
        key: 'render',
        value: function render() {
            if (!CAN_USE_DOM) {
                return null;
            }
            var visible = this.props.visible;

            if (IS_REACT_16 && (visible || this._component)) {
                return external__ReactDOM__default.a.createPortal(this.getComponent(visible), this.getContainer());
            }
            return null;
        }
    }]);

    return DialogWrap;
}(external__React__default.a.Component);

/* harmony default export */ var es_DialogWrap = __webpack_exports__["default"] = (DialogWrap_DialogWrap);

DialogWrap_DialogWrap.defaultProps = {
    visible: false,
    prefixCls: 'rmc-dialog',
    onClose: DialogWrap_noop
};

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 170 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var settle = __webpack_require__(267);
var buildURL = __webpack_require__(269);
var parseHeaders = __webpack_require__(270);
var isURLSameOrigin = __webpack_require__(271);
var createError = __webpack_require__(172);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(272);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(268);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LoginPage = __webpack_require__(92);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _UserInfoPage = __webpack_require__(281);

var _UserInfoPage2 = _interopRequireDefault(_UserInfoPage);

var _UserCenter = __webpack_require__(384);

var _UserCenter2 = _interopRequireDefault(_UserCenter);

var _BindPhonePage = __webpack_require__(396);

var _BindPhonePage2 = _interopRequireDefault(_BindPhonePage);

var _Recharge = __webpack_require__(398);

var _Recharge2 = _interopRequireDefault(_Recharge);

var _RechargeIntegral = __webpack_require__(400);

var _RechargeIntegral2 = _interopRequireDefault(_RechargeIntegral);

var _Balance = __webpack_require__(402);

var _Balance2 = _interopRequireDefault(_Balance);

var _GoodsDetail = __webpack_require__(405);

var _GoodsDetail2 = _interopRequireDefault(_GoodsDetail);

var _ShoppingCart = __webpack_require__(413);

var _ShoppingCart2 = _interopRequireDefault(_ShoppingCart);

var _MyOrder = __webpack_require__(416);

var _MyOrder2 = _interopRequireDefault(_MyOrder);

var _GoodsOrderDetail = __webpack_require__(418);

var _GoodsOrderDetail2 = _interopRequireDefault(_GoodsOrderDetail);

var _MyAddress = __webpack_require__(420);

var _MyAddress2 = _interopRequireDefault(_MyAddress);

var _GoodsOrderProgress = __webpack_require__(422);

var _GoodsOrderProgress2 = _interopRequireDefault(_GoodsOrderProgress);

var _LogisticsPage = __webpack_require__(424);

var _LogisticsPage2 = _interopRequireDefault(_LogisticsPage);

var _MakeComment = __webpack_require__(426);

var _MakeComment2 = _interopRequireDefault(_MakeComment);

var _PreviewGoodsRefund = __webpack_require__(428);

var _PreviewGoodsRefund2 = _interopRequireDefault(_PreviewGoodsRefund);

var _GoodsRefundPage = __webpack_require__(430);

var _GoodsRefundPage2 = _interopRequireDefault(_GoodsRefundPage);

var _PreviewGoodsOrder = __webpack_require__(432);

var _PreviewGoodsOrder2 = _interopRequireDefault(_PreviewGoodsOrder);

var _AddAddress = __webpack_require__(436);

var _AddAddress2 = _interopRequireDefault(_AddAddress);

var _GoodsOrderPaySuccess = __webpack_require__(438);

var _GoodsOrderPaySuccess2 = _interopRequireDefault(_GoodsOrderPaySuccess);

var _GoodsComment = __webpack_require__(441);

var _GoodsComment2 = _interopRequireDefault(_GoodsComment);

var _GoodsAdditionalInfo = __webpack_require__(443);

var _GoodsAdditionalInfo2 = _interopRequireDefault(_GoodsAdditionalInfo);

var _GoodsFavorites = __webpack_require__(445);

var _GoodsFavorites2 = _interopRequireDefault(_GoodsFavorites);

var _GoodsFootPrint = __webpack_require__(447);

var _GoodsFootPrint2 = _interopRequireDefault(_GoodsFootPrint);

var _GoodsCustomerService = __webpack_require__(449);

var _GoodsCustomerService2 = _interopRequireDefault(_GoodsCustomerService);

var _GoodsAfterSaleDetail = __webpack_require__(451);

var _GoodsAfterSaleDetail2 = _interopRequireDefault(_GoodsAfterSaleDetail);

var _SearchAddress = __webpack_require__(453);

var _SearchAddress2 = _interopRequireDefault(_SearchAddress);

var _CouponList = __webpack_require__(456);

var _CouponList2 = _interopRequireDefault(_CouponList);

var _GoodsReturnInfor = __webpack_require__(458);

var _GoodsReturnInfor2 = _interopRequireDefault(_GoodsReturnInfor);

var _GoodsDeliveryList = __webpack_require__(460);

var _GoodsDeliveryList2 = _interopRequireDefault(_GoodsDeliveryList);

var _GoodsAlreadyRefunded = __webpack_require__(462);

var _GoodsAlreadyRefunded2 = _interopRequireDefault(_GoodsAlreadyRefunded);

var _SeckillDetail = __webpack_require__(464);

var _SeckillDetail2 = _interopRequireDefault(_SeckillDetail);

var _CouponListPage = __webpack_require__(466);

var _CouponListPage2 = _interopRequireDefault(_CouponListPage);

var _CouponGoodsListPage = __webpack_require__(468);

var _CouponGoodsListPage2 = _interopRequireDefault(_CouponGoodsListPage);

var _CouponReceiveListPage = __webpack_require__(470);

var _CouponReceiveListPage2 = _interopRequireDefault(_CouponReceiveListPage);

var _VipCard = __webpack_require__(472);

var _VipCard2 = _interopRequireDefault(_VipCard);

var _VipBenefits = __webpack_require__(474);

var _VipBenefits2 = _interopRequireDefault(_VipBenefits);

var _PreviewSeckillOrder = __webpack_require__(476);

var _PreviewSeckillOrder2 = _interopRequireDefault(_PreviewSeckillOrder);

var _TransactionSuccess = __webpack_require__(478);

var _TransactionSuccess2 = _interopRequireDefault(_TransactionSuccess);

var _SameJourneyLogistic = __webpack_require__(480);

var _SameJourneyLogistic2 = _interopRequireDefault(_SameJourneyLogistic);

var _ShareGifts = __webpack_require__(482);

var _ShareGifts2 = _interopRequireDefault(_ShareGifts);

var _DiningOrderDetail = __webpack_require__(484);

var _DiningOrderDetail2 = _interopRequireDefault(_DiningOrderDetail);

var _RefundDishesDetail = __webpack_require__(486);

var _RefundDishesDetail2 = _interopRequireDefault(_RefundDishesDetail);

var _VerificationCodePage = __webpack_require__(488);

var _VerificationCodePage2 = _interopRequireDefault(_VerificationCodePage);

var _GoodsSameJourney = __webpack_require__(490);

var _GoodsSameJourney2 = _interopRequireDefault(_GoodsSameJourney);

var _MemberDay = __webpack_require__(492);

var _MemberDay2 = _interopRequireDefault(_MemberDay);

var _MemberDayDetail = __webpack_require__(495);

var _MemberDayDetail2 = _interopRequireDefault(_MemberDayDetail);

var _MemberDayList = __webpack_require__(497);

var _MemberDayList2 = _interopRequireDefault(_MemberDayList);

var _TransferPage = __webpack_require__(499);

var _TransferPage2 = _interopRequireDefault(_TransferPage);

var _CouponDescription = __webpack_require__(501);

var _CouponDescription2 = _interopRequireDefault(_CouponDescription);

var _MakeAppointment = __webpack_require__(503);

var _MakeAppointment2 = _interopRequireDefault(_MakeAppointment);

var _TransferOrderDetail = __webpack_require__(505);

var _TransferOrderDetail2 = _interopRequireDefault(_TransferOrderDetail);

var _TransferPaySuccess = __webpack_require__(507);

var _TransferPaySuccess2 = _interopRequireDefault(_TransferPaySuccess);

var _MyGroup = __webpack_require__(509);

var _MyGroup2 = _interopRequireDefault(_MyGroup);

var _PreviewAppointmentOrder = __webpack_require__(511);

var _PreviewAppointmentOrder2 = _interopRequireDefault(_PreviewAppointmentOrder);

var _AppointmentOrderDetail = __webpack_require__(513);

var _AppointmentOrderDetail2 = _interopRequireDefault(_AppointmentOrderDetail);

var _WinningRecord = __webpack_require__(515);

var _WinningRecord2 = _interopRequireDefault(_WinningRecord);

var _MyMessage = __webpack_require__(517);

var _MyMessage2 = _interopRequireDefault(_MyMessage);

var _MyIntegral = __webpack_require__(519);

var _MyIntegral2 = _interopRequireDefault(_MyIntegral);

var _GroupRules = __webpack_require__(521);

var _GroupRules2 = _interopRequireDefault(_GroupRules);

var _GroupOrderDetail = __webpack_require__(523);

var _GroupOrderDetail2 = _interopRequireDefault(_GroupOrderDetail);

var _GroupCenter = __webpack_require__(525);

var _GroupCenter2 = _interopRequireDefault(_GroupCenter);

var _VipCardList = __webpack_require__(527);

var _VipCardList2 = _interopRequireDefault(_VipCardList);

var _MyFormMessage = __webpack_require__(529);

var _MyFormMessage2 = _interopRequireDefault(_MyFormMessage);

var _OrderDetail = __webpack_require__(531);

var _OrderDetail2 = _interopRequireDefault(_OrderDetail);

var _ToStoreDetail = __webpack_require__(533);

var _ToStoreDetail2 = _interopRequireDefault(_ToStoreDetail);

var _CouponDetail = __webpack_require__(535);

var _CouponDetail2 = _interopRequireDefault(_CouponDetail);

var _BindCellphone = __webpack_require__(537);

var _BindCellphone2 = _interopRequireDefault(_BindCellphone);

var _AdvanceSearch = __webpack_require__(539);

var _AdvanceSearch2 = _interopRequireDefault(_AdvanceSearch);

var _ExtensionPage = __webpack_require__(541);

var _ExtensionPage2 = _interopRequireDefault(_ExtensionPage);

var _MapDetail = __webpack_require__(543);

var _MapDetail2 = _interopRequireDefault(_MapDetail);

var _Paying = __webpack_require__(544);

var _Paying2 = _interopRequireDefault(_Paying);

var _CollectStars = __webpack_require__(546);

var _CollectStars2 = _interopRequireDefault(_CollectStars);

var _LuckyWheelDetail = __webpack_require__(548);

var _LuckyWheelDetail2 = _interopRequireDefault(_LuckyWheelDetail);

var _GoldenEggs = __webpack_require__(550);

var _GoldenEggs2 = _interopRequireDefault(_GoldenEggs);

var _Scratch = __webpack_require__(552);

var _Scratch2 = _interopRequireDefault(_Scratch);

var _NumberOfStampsOrderDetail = __webpack_require__(554);

var _NumberOfStampsOrderDetail2 = _interopRequireDefault(_NumberOfStampsOrderDetail);

var _NumberOfStampsUsed = __webpack_require__(556);

var _NumberOfStampsUsed2 = _interopRequireDefault(_NumberOfStampsUsed);

var _ExchangeCouponDetail = __webpack_require__(558);

var _ExchangeCouponDetail2 = _interopRequireDefault(_ExchangeCouponDetail);

var _ExchangeCouponDetailOrder = __webpack_require__(566);

var _ExchangeCouponDetailOrder2 = _interopRequireDefault(_ExchangeCouponDetailOrder);

var _CheckRowNumberDetail = __webpack_require__(568);

var _CheckRowNumberDetail2 = _interopRequireDefault(_CheckRowNumberDetail);

var _PreviewRowNumberOrder = __webpack_require__(570);

var _PreviewRowNumberOrder2 = _interopRequireDefault(_PreviewRowNumberOrder);

var _RowNumberOrderDetail = __webpack_require__(572);

var _RowNumberOrderDetail2 = _interopRequireDefault(_RowNumberOrderDetail);

var _GpGoodsDetail = __webpack_require__(574);

var _GpGoodsDetail2 = _interopRequireDefault(_GpGoodsDetail);

var _GpPlayLaws = __webpack_require__(576);

var _GpPlayLaws2 = _interopRequireDefault(_GpPlayLaws);

var _PreviewGroupOrder = __webpack_require__(578);

var _PreviewGroupOrder2 = _interopRequireDefault(_PreviewGroupOrder);

var _GpPaySuccess = __webpack_require__(580);

var _GpPaySuccess2 = _interopRequireDefault(_GpPaySuccess);

var _GpMyOrder = __webpack_require__(582);

var _GpMyOrder2 = _interopRequireDefault(_GpMyOrder);

var _GpOrderDetail = __webpack_require__(584);

var _GpOrderDetail2 = _interopRequireDefault(_GpOrderDetail);

var _PreviewPresellOrder = __webpack_require__(586);

var _PreviewPresellOrder2 = _interopRequireDefault(_PreviewPresellOrder);

var _PresellPaySuccess = __webpack_require__(588);

var _PresellPaySuccess2 = _interopRequireDefault(_PresellPaySuccess);

var _PresellOrderDetail = __webpack_require__(590);

var _PresellOrderDetail2 = _interopRequireDefault(_PresellOrderDetail);

var _PresellOrderList = __webpack_require__(592);

var _PresellOrderList2 = _interopRequireDefault(_PresellOrderList);

var _PresellDetail = __webpack_require__(594);

var _PresellDetail2 = _interopRequireDefault(_PresellDetail);

var _PreviewOrderDetail = __webpack_require__(596);

var _PreviewOrderDetail2 = _interopRequireDefault(_PreviewOrderDetail);

var _PaySuccess = __webpack_require__(598);

var _PaySuccess2 = _interopRequireDefault(_PaySuccess);

var _ToStoreOrderDetail = __webpack_require__(600);

var _ToStoreOrderDetail2 = _interopRequireDefault(_ToStoreOrderDetail);

var _ToStoreComment = __webpack_require__(602);

var _ToStoreComment2 = _interopRequireDefault(_ToStoreComment);

var _MakeToStoreComment = __webpack_require__(604);

var _MakeToStoreComment2 = _interopRequireDefault(_MakeToStoreComment);

var _PreviewTakeoutOrder = __webpack_require__(606);

var _PreviewTakeoutOrder2 = _interopRequireDefault(_PreviewTakeoutOrder);

var _TakeoutOrderDetail = __webpack_require__(608);

var _TakeoutOrderDetail2 = _interopRequireDefault(_TakeoutOrderDetail);

var _OrderTracking = __webpack_require__(610);

var _OrderTracking2 = _interopRequireDefault(_OrderTracking);

var _CancelOrder = __webpack_require__(612);

var _CancelOrder2 = _interopRequireDefault(_CancelOrder);

var _TakeoutMakeComment = __webpack_require__(614);

var _TakeoutMakeComment2 = _interopRequireDefault(_TakeoutMakeComment);

var _TakeoutFeedback = __webpack_require__(616);

var _TakeoutFeedback2 = _interopRequireDefault(_TakeoutFeedback);

var _IndemnityOrder = __webpack_require__(618);

var _IndemnityOrder2 = _interopRequireDefault(_IndemnityOrder);

var _CommunityPage = __webpack_require__(620);

var _CommunityPage2 = _interopRequireDefault(_CommunityPage);

var _CommunityDetail = __webpack_require__(622);

var _CommunityDetail2 = _interopRequireDefault(_CommunityDetail);

var _videoActivityDetail = __webpack_require__(624);

var _videoActivityDetail2 = _interopRequireDefault(_videoActivityDetail);

var _videoActivityReward = __webpack_require__(626);

var _videoActivityReward2 = _interopRequireDefault(_videoActivityReward);

var _Index = __webpack_require__(628);

var _Index2 = _interopRequireDefault(_Index);

var _Entrance = __webpack_require__(679);

var _Entrance2 = _interopRequireDefault(_Entrance);

var _PcRegister = __webpack_require__(681);

var _PcRegister2 = _interopRequireDefault(_PcRegister);

var _PcLogin = __webpack_require__(683);

var _PcLogin2 = _interopRequireDefault(_PcLogin);

var _PcIndex = __webpack_require__(685);

var _PcIndex2 = _interopRequireDefault(_PcIndex);

var _AddphonePage = __webpack_require__(707);

var _AddphonePage2 = _interopRequireDefault(_AddphonePage);

var _SignIn = __webpack_require__(709);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _Recharge3 = __webpack_require__(711);

var _Recharge4 = _interopRequireDefault(_Recharge3);

var _AudioTest = __webpack_require__(713);

var _AudioTest2 = _interopRequireDefault(_AudioTest);

var _SharePage = __webpack_require__(715);

var _SharePage2 = _interopRequireDefault(_SharePage);

var _TapPay = __webpack_require__(717);

var _TapPay2 = _interopRequireDefault(_TapPay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var officialPageList = {
  // 登录页面
  'loginPage': function loginPage(props) {
    return React.createElement(_LoginPage2.default, props);
  },
  // 用户信息页面（旧版web）
  'userInfoPage': function userInfoPage(props) {
    return React.createElement(_UserInfoPage2.default, props);
  },
  // 用户信息页面（同步新版）
  'userCenter': function userCenter(props) {
    return React.createElement(_UserCenter2.default, props);
  },
  // 绑定手机页面（旧版web）
  'bindPhonePage': function bindPhonePage(props) {
    return React.createElement(_BindPhonePage2.default, props);
  },
  // 储值：充值页面
  'recharge': function recharge(props) {
    return React.createElement(_Recharge2.default, props);
  },
  // 积分：充值页面
  'rechargeIntegral': function rechargeIntegral(props) {
    return React.createElement(_RechargeIntegral2.default, props);
  },
  // 储值：充值页面
  'balance': function balance(props) {
    return React.createElement(_Balance2.default, props);
  },
  // 商品详情页面
  'goodsDetail': function goodsDetail(props) {
    return React.createElement(_GoodsDetail2.default, props);
  },
  // 底部导航购物车
  'shoppingCart': function shoppingCart(props) {
    return React.createElement(_ShoppingCart2.default, props);
  },
  // 购物车
  'goodsShoppingCart': function goodsShoppingCart(props) {
    return React.createElement(_ShoppingCart2.default, props);
  },
  // 我的订单页面
  'myOrder': function myOrder(props) {
    return React.createElement(_MyOrder2.default, props);
  },
  // 我的地址
  'myAddress': function myAddress(props) {
    return React.createElement(_MyAddress2.default, props);
  },
  // 订单详情页面
  'goodsOrderDetail': function goodsOrderDetail(props) {
    return React.createElement(_GoodsOrderDetail2.default, props);
  },
  // 订单进度页面
  'goodsOrderProgress': function goodsOrderProgress(props) {
    return React.createElement(_GoodsOrderProgress2.default, props);
  },
  // 物流信息页面
  'logisticsPage': function logisticsPage(props) {
    return React.createElement(_LogisticsPage2.default, props);
  },
  // 评价页面
  'makeComment': function makeComment(props) {
    return React.createElement(_MakeComment2.default, props);
  },
  // 申请退款页面
  'previewGoodsRefund': function previewGoodsRefund(props) {
    return React.createElement(_PreviewGoodsRefund2.default, props);
  },
  // 退款页面
  'goodsRefundPage': function goodsRefundPage(props) {
    return React.createElement(_GoodsRefundPage2.default, props);
  },
  // 确认支付页面
  'previewGoodsOrder': function previewGoodsOrder(props) {
    return React.createElement(_PreviewGoodsOrder2.default, props);
  },
  // 添加、编辑地址
  'addAddress': function addAddress(props) {
    return React.createElement(_AddAddress2.default, props);
  },
  // 支付成功页面
  'goodsOrderPaySuccess': function goodsOrderPaySuccess(props) {
    return React.createElement(_GoodsOrderPaySuccess2.default, props);
  },
  // 商品评价页面
  'goodsComment': function goodsComment(props) {
    return React.createElement(_GoodsComment2.default, props);
  },
  // 商品补充信息页面
  'goodsAdditionalInfo': function goodsAdditionalInfo(props) {
    return React.createElement(_GoodsAdditionalInfo2.default, props);
  },
  // 收藏夹页面
  'goodsFavorites': function goodsFavorites(props) {
    return React.createElement(_GoodsFavorites2.default, props);
  },
  // 足迹页面
  'goodsFootPrint': function goodsFootPrint(props) {
    return React.createElement(_GoodsFootPrint2.default, props);
  },
  // 售后订单页面
  'goodsCustomerService': function goodsCustomerService(props) {
    return React.createElement(_GoodsCustomerService2.default, props);
  },
  // 售后订单详情页面
  'goodsAfterSaleDetail': function goodsAfterSaleDetail(props) {
    return React.createElement(_GoodsAfterSaleDetail2.default, props);
  },
  // 地址搜索页面
  'searchAddress': function searchAddress(props) {
    return React.createElement(_SearchAddress2.default, props);
  },
  // 优惠券列表
  'couponList': function couponList(props) {
    return React.createElement(_CouponList2.default, props);
  },
  // 填写退货信息页面
  'goodsReturnInfor': function goodsReturnInfor(props) {
    return React.createElement(_GoodsReturnInfor2.default, props);
  },
  // 选择自提点页面
  'goodsDeliveryList': function goodsDeliveryList(props) {
    return React.createElement(_GoodsDeliveryList2.default, props);
  },
  // 已退商品页面
  'goodsAlreadyRefunded': function goodsAlreadyRefunded(props) {
    return React.createElement(_GoodsAlreadyRefunded2.default, props);
  },
  // 秒杀详情页面
  'seckillDetail': function seckillDetail(props) {
    return React.createElement(_SeckillDetail2.default, props);
  },
  // 多商家优惠券列表
  'couponListPage': function couponListPage(props) {
    return React.createElement(_CouponListPage2.default, props);
  },
  // 优惠券可用商品列表
  'couponGoodsListPage': function couponGoodsListPage(props) {
    return React.createElement(_CouponGoodsListPage2.default, props);
  },
  // 优惠券领取列表
  'couponReceiveListPage': function couponReceiveListPage(props) {
    return React.createElement(_CouponReceiveListPage2.default, props);
  },
  // 会员卡
  'vipCard': function vipCard(props) {
    return React.createElement(_VipCard2.default, props);
  },
  // 会员权益
  'vipBenefits': function vipBenefits(props) {
    return React.createElement(_VipBenefits2.default, props);
  },
  // 确认支付(秒杀)页面
  'previewSeckillOrder': function previewSeckillOrder(props) {
    return React.createElement(_PreviewSeckillOrder2.default, props);
  },
  // 评价成功页面
  'transactionSuccess': function transactionSuccess(props) {
    return React.createElement(_TransactionSuccess2.default, props);
  },
  // 同城配送信息页面
  'sameJourneyLogistic': function sameJourneyLogistic(props) {
    return React.createElement(_SameJourneyLogistic2.default, props);
  },
  // 分享有礼页面
  'shareGifts': function shareGifts(props) {
    return React.createElement(_ShareGifts2.default, props);
  },
  // 堂食订单详情页面
  'diningOrderDetail': function diningOrderDetail(props) {
    return React.createElement(_DiningOrderDetail2.default, props);
  },
  // 堂食订单退款详情页面
  'refundDishesDetail': function refundDishesDetail(props) {
    return React.createElement(_RefundDishesDetail2.default, props);
  },
  // 核销码页面
  'verificationCodePage': function verificationCodePage(props) {
    return React.createElement(_VerificationCodePage2.default, props);
  },
  // 同城配送点选择页面
  'goodsSameJourney': function goodsSameJourney(props) {
    return React.createElement(_GoodsSameJourney2.default, props);
  },
  // 会员日
  'memberDay': function memberDay(props) {
    return React.createElement(_MemberDay2.default, props);
  },
  // 会员日详情
  'memberDayDetail': function memberDayDetail(props) {
    return React.createElement(_MemberDayDetail2.default, props);
  },
  // 会员日列表
  'memberDayList': function memberDayList(props) {
    return React.createElement(_MemberDayList2.default, props);
  },
  // 当面付
  'transferPage': function transferPage(props) {
    return React.createElement(_TransferPage2.default, props);
  },
  // 优惠说明页面
  'couponDescription': function couponDescription(props) {
    return React.createElement(_CouponDescription2.default, props);
  },
  // 预约页面
  'makeAppointment': function makeAppointment(props) {
    return React.createElement(_MakeAppointment2.default, props);
  },
  // 当面付订单详情页
  'transferOrderDetail': function transferOrderDetail(props) {
    return React.createElement(_TransferOrderDetail2.default, props);
  },
  // 当面付支付成功页
  'transferPaySuccess': function transferPaySuccess(props) {
    return React.createElement(_TransferPaySuccess2.default, props);
  },
  // 我的拼团(旧版路由跳到新版)
  // 'myGroup': (props) => <MyGroup {...props} />,
  'myGroup': function myGroup(props) {
    return React.createElement(_GpMyOrder2.default, props);
  },
  // 预约订单确认支付页面
  'previewAppointmentOrder': function previewAppointmentOrder(props) {
    return React.createElement(_PreviewAppointmentOrder2.default, props);
  },
  // 预约订单详情页
  'appointmentOrderDetail': function appointmentOrderDetail(props) {
    return React.createElement(_AppointmentOrderDetail2.default, props);
  },
  // 中奖记录页面
  'winningRecord': function winningRecord(props) {
    return React.createElement(_WinningRecord2.default, props);
  },
  // 系统通知页面
  'myMessage': function myMessage(props) {
    return React.createElement(_MyMessage2.default, props);
  },
  // 个人积分页面
  'myIntegral': function myIntegral(props) {
    return React.createElement(_MyIntegral2.default, props);
  },
  // 拼团规则
  'groupRules': function groupRules(props) {
    return React.createElement(_GroupRules2.default, props);
  },
  // 拼团订单详情
  'groupOrderDetail': function groupOrderDetail(props) {
    return React.createElement(_GroupOrderDetail2.default, props);
  },
  // 拼团中心
  'groupCenter': function groupCenter(props) {
    return React.createElement(_GroupCenter2.default, props);
  },
  // 会员卡列表
  'vipCardList': function vipCardList(props) {
    return React.createElement(_VipCardList2.default, props);
  },
  // 表单提交信息
  'myFormMessage': function myFormMessage(props) {
    return React.createElement(_MyFormMessage2.default, props);
  },
  // 订单详情页
  'orderDetail': function orderDetail(props) {
    return React.createElement(_OrderDetail2.default, props);
  },
  // 到店详情
  'toStoreDetail': function toStoreDetail(props) {
    return React.createElement(_ToStoreDetail2.default, props);
  },
  // 优惠券详情
  'couponDetail': function couponDetail(props) {
    return React.createElement(_CouponDetail2.default, props);
  },
  // 绑定手机号码
  'bindCellphone': function bindCellphone(props) {
    return React.createElement(_BindCellphone2.default, props);
  },
  // 商品搜索页
  'advanceSearch': function advanceSearch(props) {
    return React.createElement(_AdvanceSearch2.default, props);
  },
  // 推广页
  'extensionPage': function extensionPage(props) {
    return React.createElement(_ExtensionPage2.default, props);
  },
  // 地图详情页
  'mapDetail': function mapDetail(props) {
    return React.createElement(_MapDetail2.default, props);
  },
  // 支付中间跳转页（微信h5支付，支付宝h5支付，支付宝pc支付）
  'paying': function paying(props) {
    return React.createElement(_Paying2.default, props);
  },
  // 集集乐
  'collectStars': function collectStars(props) {
    return React.createElement(_CollectStars2.default, props);
  },
  // 大转盘
  'luckyWheelDetail': function luckyWheelDetail(props) {
    return React.createElement(_LuckyWheelDetail2.default, props);
  },
  // 砸金蛋
  'goldenEggs': function goldenEggs(props) {
    return React.createElement(_GoldenEggs2.default, props);
  },
  // 刮刮乐
  'scratch': function scratch(props) {
    return React.createElement(_Scratch2.default, props);
  },
  // 兑换券订单详情
  'numberOfStampsOrderDetail': function numberOfStampsOrderDetail(props) {
    return React.createElement(_NumberOfStampsOrderDetail2.default, props);
  },
  // 兑换券核销码
  'numberOfStampsUsed': function numberOfStampsUsed(props) {
    return React.createElement(_NumberOfStampsUsed2.default, props);
  },
  // 兑换券详情
  'exchangeCouponDetail': function exchangeCouponDetail(props) {
    return React.createElement(_ExchangeCouponDetail2.default, props);
  },
  // 确认订单
  'exchangeCouponDetailOrder': function exchangeCouponDetailOrder(props) {
    return React.createElement(_ExchangeCouponDetailOrder2.default, props);
  },
  // 保存号单
  'checkRowNumberDetail': function checkRowNumberDetail(props) {
    return React.createElement(_CheckRowNumberDetail2.default, props);
  },
  // 确认支付
  'previewRowNumberOrder': function previewRowNumberOrder(props) {
    return React.createElement(_PreviewRowNumberOrder2.default, props);
  },
  // 订单详情
  'rowNumberOrderDetail': function rowNumberOrderDetail(props) {
    return React.createElement(_RowNumberOrderDetail2.default, props);
  },
  // 拼团商品详情
  'gpgoodsDetail': function gpgoodsDetail(props) {
    return React.createElement(_GpGoodsDetail2.default, props);
  },
  // 拼团须知
  'gpplaylaws': function gpplaylaws(props) {
    return React.createElement(_GpPlayLaws2.default, props);
  },
  // 拼团确认订单
  'previewGroupOrder': function previewGroupOrder(props) {
    return React.createElement(_PreviewGroupOrder2.default, props);
  },
  // 拼团支付成功
  'gppaySuccess': function gppaySuccess(props) {
    return React.createElement(_GpPaySuccess2.default, props);
  },
  // 我的拼团
  'gpmyOrder': function gpmyOrder(props) {
    return React.createElement(_GpMyOrder2.default, props);
  },
  // 拼团订单详情
  'gporderDetail': function gporderDetail(props) {
    return React.createElement(_GpOrderDetail2.default, props);
  },
  // 预售确认订单
  'previewPresellOrder': function previewPresellOrder(props) {
    return React.createElement(_PreviewPresellOrder2.default, props);
  },
  // 预售支付成功
  'presellPaySuccess': function presellPaySuccess(props) {
    return React.createElement(_PresellPaySuccess2.default, props);
  },
  // 预售订单详情
  'presellOrderDetail': function presellOrderDetail(props) {
    return React.createElement(_PresellOrderDetail2.default, props);
  },
  // 预售订单列表
  'presellOrderList': function presellOrderList(props) {
    return React.createElement(_PresellOrderList2.default, props);
  },
  // 预售商品详情
  'presellDetail': function presellDetail(props) {
    return React.createElement(_PresellDetail2.default, props);
  },
  // 到店确认支付
  'previewOrderDetail': function previewOrderDetail(props) {
    return React.createElement(_PreviewOrderDetail2.default, props);
  },
  // 到店支付成功
  'paySuccess': function paySuccess(props) {
    return React.createElement(_PaySuccess2.default, props);
  },
  // 到店订单详情
  'tostoreOrderDetail': function tostoreOrderDetail(props) {
    return React.createElement(_ToStoreOrderDetail2.default, props);
  },
  // 到店商品评价
  'tostoreComment': function tostoreComment(props) {
    return React.createElement(_ToStoreComment2.default, props);
  },
  // 到店评价
  'makeTostoreComment': function makeTostoreComment(props) {
    return React.createElement(_MakeToStoreComment2.default, props);
  },
  // 外卖确认支付
  'previewTakeoutOrder': function previewTakeoutOrder(props) {
    return React.createElement(_PreviewTakeoutOrder2.default, props);
  },
  // 外卖订单详情
  'takeoutOrderDetail': function takeoutOrderDetail(props) {
    return React.createElement(_TakeoutOrderDetail2.default, props);
  },
  // 外卖订单跟踪
  'orderTracking': function orderTracking(props) {
    return React.createElement(_OrderTracking2.default, props);
  },
  // 外卖取消订单
  'cancelOrder': function cancelOrder(props) {
    return React.createElement(_CancelOrder2.default, props);
  },
  // 外卖评价
  'takeoutMakeComment': function takeoutMakeComment(props) {
    return React.createElement(_TakeoutMakeComment2.default, props);
  },
  // 外卖问题反馈
  'takeoutFeedback': function takeoutFeedback(props) {
    return React.createElement(_TakeoutFeedback2.default, props);
  },
  // 外卖反馈详情
  'indemnityOrder': function indemnityOrder(props) {
    return React.createElement(_IndemnityOrder2.default, props);
  },
  // 圈组详情
  'communityPage': function communityPage(props) {
    return React.createElement(_CommunityPage2.default, props);
  },
  // 话题详情
  'communityDetail': function communityDetail(props) {
    return React.createElement(_CommunityDetail2.default, props);
  },
  // 发视频有礼活动详情
  'videoActivityDetail': function videoActivityDetail(props) {
    return React.createElement(_videoActivityDetail2.default, props);
  },
  // 发视频有礼活动领取奖励详情
  'videoActivityReward': function videoActivityReward(props) {
    return React.createElement('videoActivityReward', props);
  },
  // gpt问答页
  'gptIndex': function gptIndex(props) {
    return React.createElement(_Index2.default, props);
  },
  // gpt入口页
  'jisugpt': function jisugpt(props) {
    return React.createElement(_Entrance2.default, props);
  },
  'register-pc': function registerPc(props) {
    return React.createElement(_PcRegister2.default, props);
  },
  'login-pc': function loginPc(props) {
    return React.createElement(_PcLogin2.default, props);
  },
  'jisuSession': function jisuSession(props) {
    return React.createElement(_PcIndex2.default, props);
  },
  'add-phone': function addPhone(props) {
    return React.createElement(_AddphonePage2.default, props);
  },
  'signin': function signin(props) {
    return React.createElement(_SignIn2.default, props);
  },
  'gptrecharge': function gptrecharge(props) {
    return React.createElement(_Recharge4.default, props);
  },
  // 语音转文字测试页
  'audio-test': function audioTest(props) {
    return React.createElement(_AudioTest2.default, props);
  },
  'share-page': function sharePage(props) {
    return React.createElement(_SharePage2.default, props);
  },
  // 投流h5点击支付页
  'tap-pay': function tapPay(props) {
    return React.createElement(_TapPay2.default, props);
  }

};
exports.default = officialPageList;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.arrayTreeFilter = factory());
}(this, (function () { 'use strict';

function arrayTreeFilter(data, filterFn, options) {
    options = options || {};
    options.childrenKeyName = options.childrenKeyName || "children";
    var children = data || [];
    var result = [];
    var level = 0;
    do {
        var foundItem = children.filter(function (item) {
            return filterFn(item, level);
        })[0];
        if (!foundItem) {
            break;
        }
        result.push(foundItem);
        children = foundItem[options.childrenKeyName] || [];
        level += 1;
    } while (children.length > 0);
    return result;
}

return arrayTreeFilter;

})));


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _arrayTreeFilter = __webpack_require__(176);

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

var _MultiPicker = __webpack_require__(93);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(94);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Cascader = function (_React$Component) {
    (0, _inherits3['default'])(Cascader, _React$Component);

    function Cascader() {
        (0, _classCallCheck3['default'])(this, Cascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).apply(this, arguments));

        _this.state = {
            value: _this.getValue(_this.props.data, _this.props.defaultValue || _this.props.value)
        };
        _this.onValueChange = function (value, index) {
            var children = (0, _arrayTreeFilter2['default'])(_this.props.data, function (c, level) {
                return level <= index && c.value === value[level];
            });
            var data = children[index];
            var i = void 0;
            for (i = index + 1; data && data.children && data.children.length && i < _this.props.cols; i++) {
                data = data.children[0];
                value[i] = data.value;
            }
            value.length = i;
            _this.setState({ value: value });
            if (_this.props.onChange) {
                _this.props.onChange(value);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Cascader, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: this.getValue(nextProps.data, nextProps.value)
                });
            }
        }
    }, {
        key: 'getValue',
        value: function getValue(d, val) {
            var data = d || this.props.data;
            var value = val || this.props.value || this.props.defaultValue;
            if (!value || !value.length || value.indexOf(undefined) > -1) {
                value = [];
                for (var i = 0; i < this.props.cols; i++) {
                    if (data && data.length) {
                        value[i] = data[0].value;
                        data = data[0].children;
                    }
                }
            }
            return value;
        }
    }, {
        key: 'getCols',
        value: function getCols() {
            var _props = this.props,
                data = _props.data,
                cols = _props.cols,
                pickerPrefixCls = _props.pickerPrefixCls,
                disabled = _props.disabled,
                pickerItemStyle = _props.pickerItemStyle,
                indicatorStyle = _props.indicatorStyle;

            var value = this.state.value;
            var childrenTree = (0, _arrayTreeFilter2['default'])(data, function (c, level) {
                return c.value === value[level];
            }).map(function (c) {
                return c.children;
            });
            // in case the users data is async get when select change
            var needPad = cols - childrenTree.length;
            if (needPad > 0) {
                for (var i = 0; i < needPad; i++) {
                    childrenTree.push([]);
                }
            }
            childrenTree.length = cols - 1;
            childrenTree.unshift(data);
            return childrenTree.map(function () {
                var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var level = arguments[1];
                return _react2['default'].createElement(_Picker2['default'], { key: level, prefixCls: pickerPrefixCls, style: { flex: 1 }, disabled: disabled, itemStyle: pickerItemStyle, indicatorStyle: indicatorStyle }, children.map(function (item) {
                    return _react2['default'].createElement(_Picker2['default'].Item, { value: item.value, key: item.value }, item.label);
                }));
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var props = this.props;
            var prefixCls = props.prefixCls,
                className = props.className,
                rootNativeProps = props.rootNativeProps,
                style = props.style;

            var cols = this.getCols();
            var multiStyle = (0, _extends3['default'])({ flexDirection: 'row', alignItems: 'center' }, style);
            return _react2['default'].createElement(_MultiPicker2['default'], { style: multiStyle, prefixCls: prefixCls, className: className, selectedValue: this.state.value, rootNativeProps: rootNativeProps, onValueChange: this.onValueChange, onScrollChange: props.onScrollChange }, cols);
        }
    }]);
    return Cascader;
}(_react2['default'].Component);

Cascader.defaultProps = {
    cols: 3,
    prefixCls: 'rmc-cascader',
    pickerPrefixCls: 'rmc-picker',
    data: [],
    disabled: false
};
exports['default'] = Cascader;
module.exports = exports['default'];

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(5));

var _rmcDialog = _interopRequireDefault(__webpack_require__(167));

var _PopupMixin = _interopRequireDefault(__webpack_require__(287));

var _rmcFeedback = _interopRequireDefault(__webpack_require__(65));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var getModal = function getModal(props, visible, _ref) {
  var getContent = _ref.getContent,
      hide = _ref.hide,
      onDismiss = _ref.onDismiss,
      onOk = _ref.onOk;

  if (!visible) {
    return null;
  }

  var prefixCls = props.prefixCls;
  return React.createElement(_rmcDialog["default"], {
    prefixCls: "".concat(prefixCls),
    className: props.className || '',
    visible: true,
    closable: false,
    transitionName: props.transitionName || props.popupTransitionName,
    maskTransitionName: props.maskTransitionName,
    onClose: hide,
    style: props.style
  }, React.createElement("div", null, React.createElement("div", {
    className: "".concat(prefixCls, "-header")
  }, React.createElement(_rmcFeedback["default"], {
    activeClassName: "".concat(prefixCls, "-item-active")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-item ").concat(prefixCls, "-header-left"),
    onClick: onDismiss
  }, props.dismissText)), React.createElement("div", {
    className: "".concat(prefixCls, "-item ").concat(prefixCls, "-title")
  }, props.title), React.createElement(_rmcFeedback["default"], {
    activeClassName: "".concat(prefixCls, "-item-active")
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-item ").concat(prefixCls, "-header-right"),
    onClick: onOk
  }, props.okText))), getContent()));
};

var _default = (0, _PopupMixin["default"])(getModal, {
  prefixCls: 'rmc-picker-popup',
  WrapComponent: 'span',
  triggerType: 'onClick',
  pickerValueProp: 'selectedValue',
  pickerValueChangeProp: 'onValueChange'
});

exports["default"] = _default;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var IS_IOS = exports.IS_IOS = canUseDOM && /iphone|ipad|ipod/i.test(window.navigator.userAgent);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WhiteSpace = function (_React$Component) {
    (0, _inherits3['default'])(WhiteSpace, _React$Component);

    function WhiteSpace() {
        (0, _classCallCheck3['default'])(this, WhiteSpace);
        return (0, _possibleConstructorReturn3['default'])(this, (WhiteSpace.__proto__ || Object.getPrototypeOf(WhiteSpace)).apply(this, arguments));
    }

    (0, _createClass3['default'])(WhiteSpace, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                className = _props.className,
                style = _props.style,
                onClick = _props.onClick;

            var wrapCls = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + size, className);
            return React.createElement('div', { className: wrapCls, style: style, onClick: onClick });
        }
    }]);
    return WhiteSpace;
}(React.Component);

exports['default'] = WhiteSpace;

WhiteSpace.defaultProps = {
    prefixCls: 'am-whitespace',
    size: 'md'
};
module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(301);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(306);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(52);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(10);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__(37);
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/create-react-class/index.js
var create_react_class = __webpack_require__(311);
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// EXTERNAL MODULE: ./node_modules/async-validator/es/index.js
var es = __webpack_require__(313);
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ./node_modules/warning/browser.js
var browser = __webpack_require__(40);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(189);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/lodash/has.js
var has = __webpack_require__(191);
var has_default = /*#__PURE__*/__webpack_require__.n(has);

// EXTERNAL MODULE: ./node_modules/lodash/set.js
var set = __webpack_require__(193);
var set_default = /*#__PURE__*/__webpack_require__.n(set);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/index.js
var hoist_non_react_statics = __webpack_require__(156);
var hoist_non_react_statics_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics);

// CONCATENATED MODULE: ./node_modules/rc-form/es/utils.js



function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return hoist_non_react_statics_default()(Container, WrappedComponent);
}

function getValueFromEvent(e) {
  // support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function mirror(obj) {
  return obj;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return !!item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var callback = cb;
  var options = opt;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(ns)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    callback: callback,
    options: options
  };
}

var NAME_KEY_SEP = '.';
var NAME_INDEX_OPEN_SEP = '[';

function getNameIfNested(str) {
  var keyIndex = str.indexOf(NAME_KEY_SEP);
  var arrayIndex = str.indexOf(NAME_INDEX_OPEN_SEP);

  var index = void 0;

  if (keyIndex === -1 && arrayIndex === -1) {
    return {
      name: str
    };
  } else if (keyIndex === -1) {
    index = arrayIndex;
  } else if (arrayIndex === -1) {
    index = keyIndex;
  } else {
    index = Math.min(keyIndex, arrayIndex);
  }

  return {
    name: str.slice(0, index),
    isNested: true
  };
}

function flatFieldNames(names) {
  var ret = {};
  names.forEach(function (n) {
    ret[getNameIfNested(n).name] = 1;
  });
  return Object.keys(ret);
}

function clearVirtualField(name, fields, fieldsMeta) {
  if (fieldsMeta[name] && fieldsMeta[name].virtual) {
    /* eslint no-loop-func:0 */
    Object.keys(fields).forEach(function (ok) {
      if (getNameIfNested(ok).name === name) {
        delete fields[ok];
      }
    });
  }
}

function getVirtualPaths(fieldsMeta) {
  var virtualPaths = {};
  Object.keys(fieldsMeta).forEach(function (name) {
    var leadingName = fieldsMeta[name].leadingName;
    if (leadingName && fieldsMeta[leadingName].virtual) {
      if (leadingName in virtualPaths) {
        virtualPaths[leadingName].push(name);
      } else {
        virtualPaths[leadingName] = [name];
      }
    }
  });
  return virtualPaths;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = extends_default()({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}
// CONCATENATED MODULE: ./node_modules/rc-form/es/createFieldsStore.js









var atom = {};

var createFieldsStore_FieldsStore = function () {
  function FieldsStore(fields) {
    classCallCheck_default()(this, FieldsStore);

    createFieldsStore__initialiseProps.call(this);

    this.fields = fields;
    this.fieldsMeta = {};
  }

  createClass_default()(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      extends_default()(this.fields, fields);
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = extends_default()({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        var _getNameIfNested = getNameIfNested(f),
            name = _getNameIfNested.name,
            isNested = _getNameIfNested.isNested;

        if (isNested && fieldsMeta[name].exclusive) {
          return;
        }
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = fieldsMeta[f];
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = extends_default()({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var newFields = {};
      var fields = this.fields;

      var names = ns || Object.keys(fields);
      names.forEach(function (name) {
        var field = fields[name];
        if (field && 'value' in field) {
          newFields[name] = {};
        }
      });
      return newFields;
    }
  }, {
    key: 'getValueFromFieldsInternal',
    value: function getValueFromFieldsInternal(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.fieldsMeta[name];
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var _this2 = this;

      var fieldsMeta = this.fieldsMeta;

      if (fieldsMeta[name] && fieldsMeta[name].virtual) {
        var ret = {};
        Object.keys(fieldsMeta).forEach(function (fieldKey) {
          var nameIfNested = getNameIfNested(fieldKey);
          if (nameIfNested.name === name && nameIfNested.isNested) {
            set_default()(ret, fieldKey, _this2.getValueFromFieldsInternal(fieldKey, fields));
          }
        });
        return ret[name];
      }
      return this.getValueFromFieldsInternal(name, fields);
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var fieldsMeta = this.fieldsMeta;
      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !fieldsMeta[name].hidden;
      }) : [];
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var exclusive = fieldMeta.exclusive,
          leadingName = fieldMeta.leadingName,
          name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;
      var fieldsMeta = this.fieldsMeta;

      var field = exclusive ? this.getField(leadingName) : this.getField(name);
      var fieldValue = atom;
      if (field && 'value' in field) {
        fieldValue = field.value;
      }
      if (fieldValue === atom) {
        fieldValue = exclusive ? fieldsMeta[leadingName].initialValue : fieldMeta.initialValue;
      }
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return defineProperty_default()({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return extends_default()({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      if (!this.fieldsMeta[name]) {
        this.fieldsMeta[name] = {};
      }
      return this.fieldsMeta[name];
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);

  return FieldsStore;
}();

var createFieldsStore__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getFieldsValue = function (names) {
    var fields = names || flatFieldNames(_this3.getValidFieldsName());
    var allValues = {};
    fields.forEach(function (f) {
      set_default()(allValues, f, _this3.getFieldValue(f));
    });
    return allValues;
  };

  this.getFieldValue = function (name) {
    var fields = _this3.fields;

    return _this3.getValueFromFields(name, fields);
  };

  this.getFieldsError = function (names) {
    var fields = names || flatFieldNames(_this3.getValidFieldsName());
    var allErrors = {};
    fields.forEach(function (f) {
      set_default()(allErrors, f, _this3.getFieldError(f));
    });
    return allErrors;
  };

  this.getFieldError = function (name) {
    return getErrorStrs(_this3.getFieldMember(name, 'errors'));
  };

  this.setFieldsInitialValue = function (initialValues) {
    var fieldsMeta = _this3.fieldsMeta;
    var virtualPaths = getVirtualPaths(fieldsMeta);
    Object.keys(initialValues).forEach(function (name) {
      if (fieldsMeta[name] && fieldsMeta[name].virtual) {
        for (var i = 0, len = virtualPaths[name].length; i < len; i++) {
          var path = virtualPaths[name][i];
          if (has_default()(initialValues, path)) {
            fieldsMeta[path] = extends_default()({}, fieldsMeta[path], {
              initialValue: get_default()(initialValues, path)
            });
          }
        }
      } else if (fieldsMeta[name]) {
        fieldsMeta[name] = extends_default()({}, fieldsMeta[name], {
          initialValue: initialValues[name]
        });
      }
    });
  };

  this.isFieldValidating = function (name) {
    return _this3.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this3.getValidFieldsName();
    return names.some(function (n) {
      return _this3.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this3.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this3.getValidFieldsName();
    return names.some(function (n) {
      return _this3.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new createFieldsStore_FieldsStore(fields);
}
// CONCATENATED MODULE: ./node_modules/rc-form/es/createBaseForm.js














var DEFAULT_TRIGGER = 'onChange';

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? mirror : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      withRef = option.withRef;


  function decorate(WrappedComponent) {
    var Form = create_react_class_default()({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = createFieldsStore(fields || {});

        this.instances = {};
        this.cachedBind = {};
        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          return _this[key] = function () {
            var _fieldsStore;

            browser_default()(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      onCollectCommon: function onCollectCommon(name_, action, args) {
        var name = name_;
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, toConsumableArray_default()(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, toConsumableArray_default()(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, toConsumableArray_default()(args)) : getValueFromEvent.apply(undefined, toConsumableArray_default()(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          onValuesChange(this.props, set_default()({}, name, value));
        }
        var nameKeyObj = getNameIfNested(name);
        if (this.fieldsStore.getFieldMeta(nameKeyObj.name).exclusive) {
          name = nameKeyObj.name;
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: extends_default()({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;

        var fieldContent = extends_default()({}, field, {
          dirty: hasRules(validate)
        });
        this.setFields(defineProperty_default()({}, name, fieldContent));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var fieldContent = extends_default()({}, field, {
          dirty: true
        });
        this.validateFieldsInternal([fieldContent], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        var cache = this.cachedBind[name] = this.cachedBind[name] || {};
        if (!cache[action]) {
          cache[action] = fn.bind(this, name, action);
        }
        return cache[action];
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            warning(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            warning(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          return external__React__default.a.cloneElement(fieldElem, extends_default()({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }

        var nameIfNested = getNameIfNested(name);
        var leadingName = nameIfNested.name;
        var fieldOption = extends_default()({
          valuePropName: 'value',
          validate: [],
          trigger: DEFAULT_TRIGGER,
          leadingName: leadingName,
          name: name
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            exclusive = fieldOption.exclusive,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var leadingFieldMeta = this.fieldsStore.getFieldMeta(leadingName);
        if (nameIfNested.isNested) {
          leadingFieldMeta.virtual = !exclusive;
          // exclusive allow getFieldProps('x', {initialValue})
          // non-exclusive does not allow getFieldProps('x', {initialValue})
          leadingFieldMeta.hidden = !exclusive;
          leadingFieldMeta.exclusive = exclusive;
        }

        var inputProps = extends_default()({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = name;
        }

        var validateRules = normalizeValidateRules(validate, rules, validateTrigger);
        var validateTriggers = validateRules.filter(function (item) {
          return !!item.rules && item.rules.length;
        }).map(function (item) {
          return item.trigger;
        }).reduce(function (pre, curr) {
          return pre.concat(curr);
        }, []);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = extends_default()({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return flattenArray(actionRules);
      },
      setFields: function setFields(fields) {
        var _this4 = this;

        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = {};
          Object.keys(fields).forEach(function (f) {
            changedFields[f] = _this4.fieldsStore.getField(f);
          });
          onFieldsChange(this.props, changedFields);
        }
        this.forceUpdate();
      },
      resetFields: function resetFields(ns) {
        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
      },
      setFieldsValue: function setFieldsValue(fieldsValue) {
        if (onValuesChange) {
          onValuesChange(this.props, fieldsValue);
        }
        var newFields = {};
        var _fieldsStore2 = this.fieldsStore,
            fieldsMeta = _fieldsStore2.fieldsMeta,
            fields = _fieldsStore2.fields;

        var virtualPaths = getVirtualPaths(fieldsMeta);
        Object.keys(fieldsValue).forEach(function (name) {
          var value = fieldsValue[name];
          if (fieldsMeta[name] && fieldsMeta[name].virtual) {
            clearVirtualField(name, fields, fieldsMeta);
            for (var i = 0, len = virtualPaths[name].length; i < len; i++) {
              var path = virtualPaths[name][i];
              if (has_default()(fieldsValue, path)) {
                newFields[path] = {
                  name: path,
                  value: get_default()(fieldsValue, path)
                };
              }
            }
          } else if (fieldsMeta[name]) {
            newFields[name] = {
              name: name,
              value: value
            };
          } else {
            browser_default()(false, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
        });
        this.setFields(newFields);
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          // after destroy, delete data
          this.fieldsStore.clearField(name);
          delete this.instances[name];
          delete this.cachedBind[name];
          return;
        }
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            }
            ref(component);
          }
        }
        this.instances[name] = component;
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this5 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              set_default()(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this5.fieldsStore.getFieldMeta(name);
          var newField = extends_default()({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this5.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this5.fieldsStore.getFieldValue(f);
        });
        if (callback && isEmptyObject(allFields)) {
          callback(isEmptyObject(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(flatFieldNames(fieldNames)));
          return;
        }
        var validator = new es_default.a(allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = extends_default()({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var fieldName = e.field;
              if (!has_default()(errorsGroup, fieldName)) {
                set_default()(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = get_default()(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = get_default()(errorsGroup, name);
            var nowField = _this5.fieldsStore.getField(name);
            // avoid concurrency problems
            if (nowField.value !== allValues[name]) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this5.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref2) {
                var name = _ref2.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                set_default()(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback(isEmptyObject(errorsGroup) ? null : errorsGroup, _this5.fieldsStore.getFieldsValue(flatFieldNames(fieldNames)));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this6 = this;

        var _getParams = getParams(ns, opt, cb),
            names = _getParams.names,
            callback = _getParams.callback,
            options = _getParams.options;

        var fieldNames = names || this.fieldsStore.getValidFieldsName();
        var fields = fieldNames.filter(function (name) {
          var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
          return hasRules(fieldMeta.validate);
        }).map(function (name) {
          var field = _this6.fieldsStore.getField(name);
          field.value = _this6.fieldsStore.getFieldValue(name);
          return field;
        });
        if (!fields.length) {
          if (callback) {
            callback(null, this.fieldsStore.getFieldsValue(flatFieldNames(fieldNames)));
          }
          return;
        }
        if (!('firstFields' in options)) {
          options.firstFields = fieldNames.filter(function (name) {
            var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
            return !!fieldMeta.validateFirst;
          });
        }
        this.validateFieldsInternal(fields, {
          fieldNames: fieldNames,
          options: options
        }, callback);
      },
      isSubmitting: function isSubmitting() {
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this7 = this;

        var fn = function fn() {
          _this7.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = objectWithoutProperties_default()(_props, ['wrappedComponentRef']);

        var formProps = defineProperty_default()({}, formPropName, this.getForm());
        if (withRef) {
          browser_default()(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, extends_default()({}, formProps, restProps));
        return external__React__default.a.createElement(WrappedComponent, props);
      }
    });

    return argumentContainer(Form, WrappedComponent);
  }

  return decorate;
}

/* harmony default export */ var es_createBaseForm = (createBaseForm);
// CONCATENATED MODULE: ./node_modules/rc-form/es/createForm.js


var mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return es_createBaseForm(options, [mixin]);
}

/* harmony default export */ var es_createForm = (createForm);
// CONCATENATED MODULE: ./node_modules/rc-form/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createForm", function() { return es_createForm; });
// export this package's api



/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(48);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(64);
var ITERATOR = __webpack_require__(35)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(35)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(335);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 190 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(372),
    hasPath = __webpack_require__(373);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(377);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _rcCheckbox = __webpack_require__(195);

var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Radio = function (_React$Component) {
    (0, _inherits3['default'])(Radio, _React$Component);

    function Radio() {
        (0, _classCallCheck3['default'])(this, Radio);
        return (0, _possibleConstructorReturn3['default'])(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Radio, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                className = _a.className,
                style = _a.style,
                restProps = __rest(_a, ["className", "style"]);var prefixCls = restProps.prefixCls,
                children = restProps.children;

            var wrapCls = (0, _classnames2['default'])(prefixCls + '-wrapper', className);
            if ('class' in restProps) {
                // Todo https://github.com/developit/preact-compat/issues/422
                /* tslint:disable:no-string-literal */
                delete restProps['class'];
            }
            var mark = React.createElement(
                'label',
                { className: wrapCls, style: style },
                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, restProps, { type: 'radio' })),
                children
            );
            if (this.props.wrapLabel) {
                return mark;
            }
            return React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, this.props, { type: 'radio' }));
        }
    }]);
    return Radio;
}(React.Component);

exports['default'] = Radio;

Radio.defaultProps = {
    prefixCls: 'am-radio',
    wrapLabel: true
};
module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(10);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(52);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(15);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/rc-util/es/PureRenderMixin.js
var PureRenderMixin = __webpack_require__(391);
var PureRenderMixin_default = /*#__PURE__*/__webpack_require__.n(PureRenderMixin);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(16);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rc-checkbox/es/Checkbox.js












var Checkbox_Checkbox = function (_React$Component) {
  inherits_default()(Checkbox, _React$Component);

  function Checkbox(props) {
    classCallCheck_default()(this, Checkbox);

    var _this = possibleConstructorReturn_default()(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call(this, props));

    Checkbox__initialiseProps.call(_this);

    var checked = 'checked' in props ? props.checked : props.defaultChecked;

    _this.state = {
      checked: checked
    };
    return _this;
  }

  createClass_default()(Checkbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return PureRenderMixin_default.a.shouldComponentUpdate.apply(this, args);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          className = _props.className,
          style = _props.style,
          name = _props.name,
          type = _props.type,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          tabIndex = _props.tabIndex,
          onClick = _props.onClick,
          onFocus = _props.onFocus,
          onBlur = _props.onBlur,
          others = objectWithoutProperties_default()(_props, ['prefixCls', 'className', 'style', 'name', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur']);

      var globalProps = Object.keys(others).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
          prev[key] = others[key];
        }
        return prev;
      }, {});

      var checked = this.state.checked;

      var classString = classnames_default()(prefixCls, className, (_classNames = {}, defineProperty_default()(_classNames, prefixCls + '-checked', checked), defineProperty_default()(_classNames, prefixCls + '-disabled', disabled), _classNames));

      return external__React__default.a.createElement(
        'span',
        { className: classString, style: style },
        external__React__default.a.createElement('input', extends_default()({
          name: name,
          type: type,
          readOnly: readOnly,
          disabled: disabled,
          tabIndex: tabIndex,
          className: prefixCls + '-input',
          checked: !!checked,
          onClick: onClick,
          onFocus: onFocus,
          onBlur: onBlur,
          onChange: this.handleChange
        }, globalProps)),
        external__React__default.a.createElement('span', { className: prefixCls + '-inner' })
      );
    }
  }]);

  return Checkbox;
}(external__React__default.a.Component);

Checkbox_Checkbox.propTypes = {
  prefixCls: prop_types_default.a.string,
  className: prop_types_default.a.string,
  style: prop_types_default.a.object,
  name: prop_types_default.a.string,
  type: prop_types_default.a.string,
  defaultChecked: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.bool]),
  checked: prop_types_default.a.oneOfType([prop_types_default.a.number, prop_types_default.a.bool]),
  disabled: prop_types_default.a.bool,
  onFocus: prop_types_default.a.func,
  onBlur: prop_types_default.a.func,
  onChange: prop_types_default.a.func,
  onClick: prop_types_default.a.func,
  tabIndex: prop_types_default.a.string,
  readOnly: prop_types_default.a.bool
};
Checkbox_Checkbox.defaultProps = {
  prefixCls: 'rc-checkbox',
  className: '',
  style: {},
  type: 'checkbox',
  defaultChecked: false,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  onChange: function onChange() {}
};

var Checkbox__initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (e) {
    var props = _this2.props;

    if (props.disabled) {
      return;
    }
    if (!('checked' in props)) {
      _this2.setState({
        checked: e.target.checked
      });
    }
    props.onChange({
      target: extends_default()({}, props, {
        checked: e.target.checked
      }),
      stopPropagation: function stopPropagation() {
        e.stopPropagation();
      },
      preventDefault: function preventDefault() {
        e.preventDefault();
      }
    });
  };
};

/* harmony default export */ var es_Checkbox = (Checkbox_Checkbox);
// CONCATENATED MODULE: ./node_modules/rc-checkbox/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return es_Checkbox; });


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SinkingModal = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

__webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinkingModal = exports.SinkingModal = function (_CommonComponent) {
  (0, _inherits3.default)(SinkingModal, _CommonComponent);

  function SinkingModal(props) {
    (0, _classCallCheck3.default)(this, SinkingModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SinkingModal.__proto__ || Object.getPrototypeOf(SinkingModal)).call(this, props));

    _this.getUserSetNoticesList = function () {
      var that = _this;
      var newData = {};
      _app.appMethod.sendRequest({
        url: '/index.php?r=EventMessage/GetEventNoticeList',
        hideLoading: true,
        success: function success(res) {
          var noticesData = res.data;
          var isEmpty = !noticesData || JSON.stringify(noticesData) === '[]' || JSON.stringify(noticesData) === '{}';
          if (isEmpty) {
            return false;
          }
          // 弹窗id
          newData['sinkingModalData.id'] = res.id;
          // 点击事件的参数
          var eventParams = noticesData.page_url;
          eventParams = typeof eventParams === 'string' ? JSON.parse(eventParams) : eventParams;
          newData['sinkingModalData.eventParams'] = eventParams;
          // 是否显示弹窗
          newData['sinkingModalData.showModal'] = true;
          // 是否有下沉动画
          newData['sinkingModalData.isSinking'] = true;
          // 推送文案
          newData['sinkingModalData.pushContent'] = noticesData.content || '';
          that.setData(newData);
          // 弹窗2s后消失
          setTimeout(function () {
            that.setData({
              'sinkingModalData.isSinking': false
            });
          }, 3000);
        },
        fail: function fail(res) {
          console.log(res);
        }
      });
    };

    _this.tapEventCommonHandler = function (e) {
      var id = _this.data.sinkingModalData.id || '';
      var eventParams = e.currentTarget.dataset.eventParams;

      eventParams = JSON.parse(eventParams);
      _app.appMethod.sendRequest({
        url: '/index.php?r=EventMessage/SetMsgReadById',
        hideLoading: true,
        data: {
          'msg_id': id
        },
        success: function success() {
          if (eventParams && eventParams.action && eventParams.action != 'none') {
            (0, _customEvent.customEvent)({
              customFeature: eventParams
            });
          }
        }
      });
    };

    _this.state = {
      sinkingModalData: {
        showModal: false, // 是否显示弹窗
        isSinking: false, // 是否下沉动画
        pushContent: '', // 推送内容
        eventParams: {} // 点击事件
      }
    };
    return _this;
  }

  (0, _createClass3.default)(SinkingModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getUserSetNoticesList();
    }

    // 获取用户设置的下沉弹窗信息


    // 用户设置的点击事件跳转

  }, {
    key: 'render',
    value: function render() {
      var sinkingModalData = this.state.sinkingModalData;

      if (!sinkingModalData.showModal) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component sinking-modal-wrap ' + (sinkingModalData.isSinking ? 'show-modal' : 'hide-modal'), onClick: this.tapEventCommonHandler, 'data-event-params': JSON.stringify(sinkingModalData.eventParams) },
        _react2.default.createElement(
          'div',
          { className: 'sinking-modal' },
          _react2.default.createElement(
            'span',
            { className: 'tip-txt' },
            sinkingModalData.pushContent
          ),
          sinkingModalData.eventParams && _react2.default.createElement(
            'span',
            { className: 'btn-txt' },
            '\u67E5\u770B'
          )
        )
      );
    }
  }]);
  return SinkingModal;
}(_CommonComponent3.default);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(48);
var aFunction = __webpack_require__(85);
var SPECIES = __webpack_require__(35)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(62);
var invoke = __webpack_require__(636);
var html = __webpack_require__(163);
var cel = __webpack_require__(108);
var global = __webpack_require__(34);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(73)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(48);
var isObject = __webpack_require__(53);
var newPromiseCapability = __webpack_require__(142);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (props) {
    return Object.keys(props).reduce(function (prev, key) {
        if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
            prev[key] = props[key];
        }
        return prev;
    }, {});
};

module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(647);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(650);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(46);
var core = __webpack_require__(24);
var fails = __webpack_require__(63);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(106));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(688);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoadingPage;

__webpack_require__(719);

function LoadingPage() {
  return React.createElement(
    "div",
    { id: "loadingPage" },
    React.createElement(
      "div",
      { className: "container" },
      React.createElement(
        "div",
        { className: "spinner" },
        React.createElement("div", { className: "rect1" }),
        React.createElement("div", { className: "rect2" }),
        React.createElement("div", { className: "rect3" }),
        React.createElement("div", { className: "rect4" }),
        React.createElement("div", { className: "rect5" })
      )
    )
  );
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var ECLevel = __webpack_require__(152)

var EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

var EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var numeric = '[0-9]+'
var alphanumeric = '[A-Z $%*+\\-./:]+'
var kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

var byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

var TEST_KANJI = new RegExp('^' + kanji + '$')
var TEST_NUMERIC = new RegExp('^' + numeric + '$')
var TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}


/***/ }),
/* 211 */
/***/ (function(module, exports) {

function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  var hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  var hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  var margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0 ? 4 : options.margin

  var width = options.width && options.width >= 21 ? options.width : undefined
  var scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  var scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  var size = qr.modules.size
  var data = qr.modules.data
  var scale = exports.getScale(size, opts)
  var symbolSize = Math.floor((size + opts.margin * 2) * scale)
  var scaledMargin = opts.margin * scale
  var palette = [opts.color.light, opts.color.dark]

  for (var i = 0; i < symbolSize; i++) {
    for (var j = 0; j < symbolSize; j++) {
      var posDst = (i * symbolSize + j) * 4
      var pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        var iSrc = Math.floor((i - scaledMargin) / scale)
        var jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.isEventFromHandle = isEventFromHandle;
exports.isValueOutOfRange = isValueOutOfRange;
exports.isNotTouchEvent = isNotTouchEvent;
exports.getClosestPoint = getClosestPoint;
exports.getPrecision = getPrecision;
exports.getMousePosition = getMousePosition;
exports.getTouchPosition = getTouchPosition;
exports.getHandleCenterPosition = getHandleCenterPosition;
exports.ensureValueInRange = ensureValueInRange;
exports.ensureValuePrecision = ensureValuePrecision;
exports.pauseEvent = pauseEvent;

var _reactDom = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
var ActivityIndicator = function (_React$Component) {
    (0, _inherits3['default'])(ActivityIndicator, _React$Component);

    function ActivityIndicator() {
        (0, _classCallCheck3['default'])(this, ActivityIndicator);
        return (0, _possibleConstructorReturn3['default'])(this, (ActivityIndicator.__proto__ || Object.getPrototypeOf(ActivityIndicator)).apply(this, arguments));
    }

    (0, _createClass3['default'])(ActivityIndicator, [{
        key: 'render',
        value: function render() {
            var _classnames;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                animating = _props.animating,
                toast = _props.toast,
                size = _props.size,
                text = _props.text;

            var wrapClass = (0, _classnames4['default'])(prefixCls, className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-toast', !!toast), _classnames));
            var spinnerClass = (0, _classnames4['default'])(prefixCls + '-spinner', (0, _defineProperty3['default'])({}, prefixCls + '-spinner-lg', !!toast || size === 'large'));
            if (animating) {
                if (toast) {
                    return React.createElement(
                        'div',
                        { className: wrapClass },
                        text ? React.createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            React.createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                            React.createElement(
                                'span',
                                { className: prefixCls + '-toast' },
                                text
                            )
                        ) : React.createElement(
                            'div',
                            { className: prefixCls + '-content' },
                            React.createElement('span', { className: spinnerClass, 'aria-label': 'Loading' })
                        )
                    );
                } else {
                    return text ? React.createElement(
                        'div',
                        { className: wrapClass },
                        React.createElement('span', { className: spinnerClass, 'aria-hidden': 'true' }),
                        React.createElement(
                            'span',
                            { className: prefixCls + '-tip' },
                            text
                        )
                    ) : React.createElement(
                        'div',
                        { className: wrapClass },
                        React.createElement('span', { className: spinnerClass, 'aria-label': 'loading' })
                    );
                }
            } else {
                return null;
            }
        }
    }]);
    return ActivityIndicator;
}(React.Component);

exports['default'] = ActivityIndicator;

ActivityIndicator.defaultProps = {
    prefixCls: 'am-activity-indicator',
    animating: true,
    size: 'small',
    panelColor: 'rgba(34,34,34,0.6)',
    toast: false
};
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(884);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(885);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouterDom = __webpack_require__(154);

var _history = __webpack_require__(107);

var _App = __webpack_require__(751);

var _App2 = _interopRequireDefault(_App);

__webpack_require__(955);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_reactDom2.default.render(_react2.default.createElement(
  _reactRouterDom.Router,
  { history: _history.history },
  _react2.default.createElement(_App2.default, null)
), document.getElementById('app'));

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(218);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(220), __esModule: true };

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(221);
module.exports = __webpack_require__(24).Object.assign;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(46);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(222) });


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(51);
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(116);
var pIE = __webpack_require__(88);
var toObject = __webpack_require__(75);
var IObject = __webpack_require__(159);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(63)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(58);
var toLength = __webpack_require__(111);
var toAbsoluteIndex = __webpack_require__(224);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(112);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
var $Object = __webpack_require__(24).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(46);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(51), 'Object', { defineProperty: __webpack_require__(50).f });


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = alert;

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(117);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(89);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function alert(title, message) {
    var actions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [{ text: '确定' }];
    var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'ios';

    var closed = false;
    if (!title && !message) {
        // console.log('Must specify either an alert title, or message, or both');
        return {
            close: function close() {}
        };
    }
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    var prefixCls = 'am-modal';
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, title: title, transitionName: 'am-zoom', closable: false, maskClosable: false, footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-alert-content' },
            message
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(229), __esModule: true };

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
__webpack_require__(91);
module.exports = __webpack_require__(119).f('iterator');


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(112);
var defined = __webpack_require__(110);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(118);
var descriptor = __webpack_require__(72);
var setToStringTag = __webpack_require__(90);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(56)(IteratorPrototype, __webpack_require__(35)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(50);
var anObject = __webpack_require__(48);
var getKeys = __webpack_require__(86);

module.exports = __webpack_require__(51) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(234);
var step = __webpack_require__(235);
var Iterators = __webpack_require__(64);
var toIObject = __webpack_require__(58);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(161)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(237), __esModule: true };

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(238);
__webpack_require__(166);
__webpack_require__(243);
__webpack_require__(244);
module.exports = __webpack_require__(24).Symbol;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(34);
var has = __webpack_require__(57);
var DESCRIPTORS = __webpack_require__(51);
var $export = __webpack_require__(46);
var redefine = __webpack_require__(162);
var META = __webpack_require__(239).KEY;
var $fails = __webpack_require__(63);
var shared = __webpack_require__(114);
var setToStringTag = __webpack_require__(90);
var uid = __webpack_require__(87);
var wks = __webpack_require__(35);
var wksExt = __webpack_require__(119);
var wksDefine = __webpack_require__(120);
var enumKeys = __webpack_require__(240);
var isArray = __webpack_require__(241);
var anObject = __webpack_require__(48);
var isObject = __webpack_require__(53);
var toObject = __webpack_require__(75);
var toIObject = __webpack_require__(58);
var toPrimitive = __webpack_require__(109);
var createDesc = __webpack_require__(72);
var _create = __webpack_require__(118);
var gOPNExt = __webpack_require__(242);
var $GOPD = __webpack_require__(121);
var $GOPS = __webpack_require__(116);
var $DP = __webpack_require__(50);
var $keys = __webpack_require__(86);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(165).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(88).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(74)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(87)('meta');
var isObject = __webpack_require__(53);
var has = __webpack_require__(57);
var setDesc = __webpack_require__(50).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(63)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(116);
var pIE = __webpack_require__(88);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(73);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(58);
var gOPN = __webpack_require__(165).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120)('asyncIterator');


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(120)('observable');


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(246), __esModule: true };

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(247);
module.exports = __webpack_require__(24).Object.setPrototypeOf;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(46);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(248).set });


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(53);
var anObject = __webpack_require__(48);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(62)(Function.call, __webpack_require__(121).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(250), __esModule: true };

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(251);
var $Object = __webpack_require__(24).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(46);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(118) });


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(168);
} catch (err) {
  var index = __webpack_require__(168);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = operation;

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(117);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(89);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function operation() {
    var actions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{ text: '确定' }];
    var platform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ios';

    var closed = false;
    var prefixCls = 'am-modal';
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.am-modal-footer');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(_Modal2['default'], { visible: true, operation: true, transparent: true, prefixCls: prefixCls, transitionName: 'am-zoom', closable: false, maskClosable: true, onClose: close, footer: footer, maskTransitionName: 'am-fade', className: 'am-modal-operation', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } }), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = prompt;

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _closest = __webpack_require__(117);

var _closest2 = _interopRequireDefault(_closest);

var _Modal = __webpack_require__(89);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function prompt(title, message, callbackOrActions) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'default';
    var defaultValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var placeholders = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ['', ''];
    var platform = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'ios';

    var closed = false;
    defaultValue = typeof defaultValue === 'string' ? defaultValue : typeof defaultValue === 'number' ? '' + defaultValue : '';
    if (!callbackOrActions) {
        // console.log('Must specify callbackOrActions');
        return {
            close: function close() {}
        };
    }
    var prefixCls = 'am-modal';
    var data = {
        text: defaultValue
    };
    function onChange(e) {
        var target = e.target;
        var inputType = target.getAttribute('type');
        if (inputType !== null) {
            data[inputType] = target.value;
        }
    }
    // hotfix issue: https://github.com/ant-design/ant-design-mobile/issues/2177
    function onClick(e) {
        var target = e.currentTarget || e.target;
        if (target) {
            target.focus();
        }
    }
    function onBlurFixWechat() {
        // https://github.com/ant-design/ant-design-mobile/issues/3137
        if (/MicroMessenger/.test(navigator.userAgent)) {
            document.body.scrollTop = document.body.scrollTop;
        }
    }
    var inputDom = void 0;
    var focusFn = function focusFn(input) {
        setTimeout(function () {
            if (input) {
                input.focus();
            }
        }, 500);
    };
    switch (type) {
        case 'login-password':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, onClick: onClick, onChange: onChange, placeholder: placeholders[1], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'secure-text':
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'password', defaultValue: data.password, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
            break;
        case 'default':
        default:
            inputDom = React.createElement(
                'div',
                { className: prefixCls + '-input-container' },
                React.createElement(
                    'div',
                    { className: prefixCls + '-input' },
                    React.createElement(
                        'label',
                        null,
                        React.createElement('input', { type: 'text', defaultValue: data.text, ref: function ref(input) {
                                return focusFn(input);
                            }, onClick: onClick, onChange: onChange, placeholder: placeholders[0], onBlur: onBlurFixWechat })
                    )
                )
            );
    }
    var content = React.createElement(
        'div',
        null,
        message,
        inputDom
    );
    var div = document.createElement('div');
    document.body.appendChild(div);
    function close() {
        ReactDOM.unmountComponentAtNode(div);
        if (div && div.parentNode) {
            div.parentNode.removeChild(div);
        }
    }
    function handleConfirm(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        var _data$text = data.text,
            text = _data$text === undefined ? '' : _data$text,
            _data$password = data.password,
            password = _data$password === undefined ? '' : _data$password;

        var callbackArgs = type === 'login-password' ? [text, password] : type === 'secure-text' ? [password] : [text];
        return callback.apply(undefined, callbackArgs);
    }
    var actions = void 0;
    if (typeof callbackOrActions === 'function') {
        actions = [{
            text: '取消',
            onPress: function onPress() {}
        }, {
            text: '确定',
            onPress: function onPress() {
                handleConfirm(callbackOrActions);
            }
        }];
    } else {
        actions = callbackOrActions.map(function (item) {
            return {
                text: item.text,
                onPress: function onPress() {
                    return handleConfirm(item.onPress);
                }
            };
        });
    }
    var footer = actions.map(function (button) {
        // tslint:disable-next-line:only-arrow-functions
        var orginPress = button.onPress || function () {};
        button.onPress = function () {
            if (closed) {
                return;
            }
            var res = orginPress();
            if (res && res.then) {
                res.then(function () {
                    closed = true;
                    close();
                })['catch'](function () {});
            } else {
                closed = true;
                close();
            }
        };
        return button;
    });
    function onWrapTouchStart(e) {
        // exclude input element for focus
        if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
            return;
        }
        var pNode = (0, _closest2['default'])(e.target, '.' + prefixCls + '-content');
        if (!pNode) {
            e.preventDefault();
        }
    }
    ReactDOM.render(React.createElement(
        _Modal2['default'],
        { visible: true, transparent: true, prefixCls: prefixCls, title: title, closable: false, maskClosable: false, transitionName: 'am-zoom', footer: footer, maskTransitionName: 'am-fade', platform: platform, wrapProps: { onTouchStart: onWrapTouchStart } },
        React.createElement(
            'div',
            { className: prefixCls + '-propmt-content' },
            content
        )
    ), div);
    return {
        close: close
    };
}
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(52);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(10);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(15);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: external "ReactDOM"
var external__ReactDOM_ = __webpack_require__(19);
var external__ReactDOM__default = /*#__PURE__*/__webpack_require__.n(external__ReactDOM_);

// EXTERNAL MODULE: ./node_modules/rc-animate/es/Animate.js + 6 modules
var Animate = __webpack_require__(122);

// CONCATENATED MODULE: ./node_modules/rc-util/es/createChainedFunction.js
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @returns {function|null}
 */
function createChainedFunction() {
  var args = [].slice.call(arguments, 0);

  if (args.length === 1) {
    return args[0];
  }

  return function chainedFunction() {
    for (var i = 0; i < args.length; i++) {
      if (args[i] && args[i].apply) {
        args[i].apply(this, arguments);
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(16);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./node_modules/rmc-notification/es/Notice.js









var Notice_Notice = function (_Component) {
  inherits_default()(Notice, _Component);

  function Notice() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Notice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      _this.clearCloseTimer();
      _this.props.onClose();
    }, _this.startCloseTimer = function () {
      if (_this.props.duration) {
        _this.closeTimer = setTimeout(function () {
          _this.close();
        }, _this.props.duration * 1000);
      }
    }, _this.clearCloseTimer = function () {
      if (_this.closeTimer) {
        clearTimeout(_this.closeTimer);
        _this.closeTimer = null;
      }
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Notice, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startCloseTimer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearCloseTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _className;

      var props = this.props;
      var componentClass = props.prefixCls + '-notice';
      var className = (_className = {}, defineProperty_default()(_className, '' + componentClass, 1), defineProperty_default()(_className, componentClass + '-closable', props.closable), defineProperty_default()(_className, props.className, !!props.className), _className);
      return external__React__default.a.createElement(
        'div',
        { className: classnames_default()(className), style: props.style },
        external__React__default.a.createElement(
          'div',
          { className: componentClass + '-content' },
          props.children
        ),
        props.closable ? external__React__default.a.createElement(
          'a',
          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
          external__React__default.a.createElement('span', { className: componentClass + '-close-x' })
        ) : null
      );
    }
  }]);

  return Notice;
}(external__React_["Component"]);

Notice_Notice.propTypes = {
  duration: prop_types_default.a.number,
  onClose: prop_types_default.a.func,
  children: prop_types_default.a.any
};
Notice_Notice.defaultProps = {
  onEnd: function onEnd() {},
  onClose: function onClose() {},

  duration: 1.5,
  style: {
    right: '50%'
  }
};
/* harmony default export */ var es_Notice = (Notice_Notice);
// CONCATENATED MODULE: ./node_modules/rmc-notification/es/Notification.js















var seed = 0;
var now = Date.now();

function getUuid() {
  return 'rcNotification_' + now + '_' + seed++;
}

var Notification_Notification = function (_Component) {
  inherits_default()(Notification, _Component);

  function Notification() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck_default()(this, Notification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn_default()(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      notices: []
    }, _this.add = function (notice) {
      var key = notice.key = notice.key || getUuid();
      _this.setState(function (previousState) {
        var notices = previousState.notices;
        if (!notices.filter(function (v) {
          return v.key === key;
        }).length) {
          return {
            notices: notices.concat(notice)
          };
        }
      });
    }, _this.remove = function (key) {
      _this.setState(function (previousState) {
        return {
          notices: previousState.notices.filter(function (notice) {
            return notice.key !== key;
          })
        };
      });
    }, _temp), possibleConstructorReturn_default()(_this, _ret);
  }

  createClass_default()(Notification, [{
    key: 'getTransitionName',
    value: function getTransitionName() {
      var props = this.props;
      var transitionName = props.transitionName;
      if (!transitionName && props.animation) {
        transitionName = props.prefixCls + '-' + props.animation;
      }
      return transitionName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _className;

      var props = this.props;
      var noticeNodes = this.state.notices.map(function (notice) {
        var onClose = createChainedFunction(_this2.remove.bind(_this2, notice.key), notice.onClose);
        return external__React__default.a.createElement(
          es_Notice,
          extends_default()({
            prefixCls: props.prefixCls
          }, notice, {
            onClose: onClose
          }),
          notice.content
        );
      });
      var className = (_className = {}, defineProperty_default()(_className, props.prefixCls, 1), defineProperty_default()(_className, props.className, !!props.className), _className);
      return external__React__default.a.createElement(
        'div',
        { className: classnames_default()(className), style: props.style },
        external__React__default.a.createElement(
          Animate["a" /* default */],
          { transitionName: this.getTransitionName() },
          noticeNodes
        )
      );
    }
  }]);

  return Notification;
}(external__React_["Component"]);

Notification_Notification.propTypes = {
  prefixCls: prop_types_default.a.string,
  transitionName: prop_types_default.a.string,
  animation: prop_types_default.a.oneOfType([prop_types_default.a.string, prop_types_default.a.object]),
  style: prop_types_default.a.object
};
Notification_Notification.defaultProps = {
  prefixCls: 'rmc-notification',
  animation: 'fade',
  style: {
    top: 65,
    left: '50%'
  }
};


Notification_Notification.newInstance = function newNotificationInstance(properties, callback) {
  var _ref2 = properties || {},
      getContainer = _ref2.getContainer,
      props = objectWithoutProperties_default()(_ref2, ['getContainer']);

  var div = void 0;
  if (getContainer) {
    div = getContainer();
  } else {
    div = document.createElement('div');
    document.body.appendChild(div);
  }
  var called = false;
  function ref(notification) {
    if (called) {
      return;
    }
    called = true;
    callback({
      notice: function notice(noticeProps) {
        notification.add(noticeProps);
      },
      removeNotice: function removeNotice(key) {
        notification.remove(key);
      },

      component: notification,
      destroy: function destroy() {
        external__ReactDOM__default.a.unmountComponentAtNode(div);
        if (!getContainer) {
          document.body.removeChild(div);
        }
      }
    });
  }
  external__ReactDOM__default.a.render(external__React__default.a.createElement(Notification_Notification, extends_default()({}, props, { ref: ref })), div);
};

/* harmony default export */ var es_Notification = (Notification_Notification);
// CONCATENATED MODULE: ./node_modules/rmc-notification/es/index.js

/* harmony default export */ var es = __webpack_exports__["default"] = (es_Notification);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* tslint:disable:max-line-length */
// inspried by https://github.com/kisenka/svg-sprite-loader/blob/master/runtime/browser-sprite.js
// Much simplified, do make sure run this after document ready
var svgSprite = function svgSprite(contents) {
    return '\n  <svg\n    xmlns="http://www.w3.org/2000/svg"\n    xmlns:xlink="http://www.w3.org/1999/xlink"\n    id="__ANTD_MOBILE_SVG_SPRITE_NODE__"\n    style="display:none;overflow:hidden;width:0;height:0"\n  >\n    <defs>\n      ' + contents + '\n    </defs>\n  </svg>\n';
};
// both minified by https://github.com/svg/svgo
var icons = {
    check: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z"/></svg>',
    'check-circle': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zM13.1 23.2l-2.2 2.1 10 9.9L38.1 15l-2.2-2-15.2 17.8-7.6-7.6z" fill-rule="evenodd"/></svg>',
    'check-circle-o': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M12.2 23.2L10 25.3l10 9.9L37.2 15 35 13 19.8 30.8z"/></g></svg>',
    cross: '<svg viewBox="0 0 44 44"><path fill-rule="evenodd" d="M24.008 21.852l8.97-8.968L31.092 11l-8.97 8.968L13.157 11l-1.884 1.884 8.968 8.968-9.24 9.24 1.884 1.885 9.24-9.24 9.24 9.24 1.885-1.884-9.24-9.24z"/></svg>',
    'cross-circle': '<svg viewBox="0 0 48 48"><g fill-rule="evenodd"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3c11.598 0 21-9.402 21-21S35.598 3 24 3 3 12.402 3 24s9.402 21 21 21z"/><path d="M24.34 22.22l-7.775-7.775a1.5 1.5 0 1 0-2.12 2.12l7.773 7.775-7.774 7.775a1.5 1.5 0 1 0 2.12 2.12l7.775-7.773 7.774 7.774a1.5 1.5 0 1 0 2.12-2.12L26.46 24.34l7.774-7.774a1.5 1.5 0 1 0-2.12-2.12l-7.776 7.773z"/></g></svg>',
    'cross-circle-o': '<svg viewBox="0 0 48 48"><path d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm.353-25.77l-7.593-7.593c-.797-.8-1.538-.822-2.263-.207-.724.614-.56 1.617-.124 2.067l7.852 7.847-7.72 7.723c-.727.728-.56 1.646-.066 2.177.493.532 1.553.683 2.31-.174l7.588-7.584 7.644 7.623c.796.798 1.608.724 2.21.145.605-.58.72-1.442-.074-2.24l-7.657-7.67 7.545-7.52c.81-.697.9-1.76.297-2.34-.92-.885-1.85-.338-2.264.078l-7.685 7.667z" fill-rule="evenodd"/></svg>',
    // Todo: simplify direction to 2, use css transform
    left: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M16.247 21.4L28.48 9.165l2.12 2.12-10.117 10.12L30.6 31.524l-2.12 2.12-12.233-12.232.007-.006z"/></svg>',
    right: '<svg viewBox="0 0 44 44"><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a" overflow="visible"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M30.6 21.4L18.37 9.165l-2.12 2.12 10.117 10.12-10.118 10.118 2.12 2.12 12.234-12.232-.005-.006z"/></svg>',
    down: '<svg viewBox="0 0 44 44"><path d="M22.355 28.237l-11.483-10.9c-.607-.576-1.714-.396-2.48.41l.674-.71c-.763.802-.73 2.07-.282 2.496l11.37 10.793-.04.04 2.088 2.195L23.3 31.52l12.308-11.682c.447-.425.48-1.694-.282-2.496l.674.71c-.766-.806-1.873-.986-2.48-.41L22.355 28.237z" fill-rule="evenodd"/></svg>',
    up: '<svg viewBox="0 0 44 44"><path fill="none" d="M-1-1h46v46H-1z"/><defs><path id="a" d="M-129-845h24v24h-24z"/></defs><clipPath id="b"><use xlink:href="#a"/></clipPath><g clip-path="url(#b)"><defs><path id="c" d="M-903-949H947V996H-903z"/></defs></g><path d="M23.417 14.23L11.184 26.46l2.12 2.12 10.12-10.117 10.118 10.118 2.12-2.12L23.43 14.228l-.006.005z"/></svg>',
    loading: '<svg viewBox="0 -2 59.75 60.25"><path fill="#ccc" d="M29.69-.527C14.044-.527 1.36 12.158 1.36 27.806S14.043 56.14 29.69 56.14c15.65 0 28.334-12.686 28.334-28.334S45.34-.527 29.69-.527zm.185 53.75c-14.037 0-25.417-11.38-25.417-25.417S15.838 2.39 29.875 2.39s25.417 11.38 25.417 25.417-11.38 25.416-25.417 25.416z"/><path fill="none" stroke="#108ee9" stroke-width="3" stroke-linecap="round" stroke-miterlimit="10" d="M56.587 29.766c.37-7.438-1.658-14.7-6.393-19.552"/></svg>',
    search: '<svg viewBox="0 0 44 44"><path d="M32.98 29.255l8.915 8.293L39.603 40l-8.86-8.242a15.952 15.952 0 0 1-10.753 4.147C11.16 35.905 4 28.763 4 19.952 4 11.142 11.16 4 19.99 4s15.99 7.142 15.99 15.952c0 3.472-1.112 6.685-3 9.303zm.05-9.21c0 7.123-5.7 12.918-12.88 12.918-7.176 0-13.015-5.795-13.015-12.918 0-7.12 5.84-12.917 13.017-12.917 7.178 0 12.88 5.797 12.88 12.917z" fill-rule="evenodd"/></svg>',
    ellipsis: '<svg viewBox="0 0 44 44"><circle cx="21.888" cy="22" r="4.045"/><circle cx="5.913" cy="22" r="4.045"/><circle cx="37.863" cy="22" r="4.045"/></svg>',
    'ellipsis-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M22.13.11C10.05.11.255 9.902.255 21.983S10.05 43.86 22.13 43.86s21.875-9.795 21.875-21.876S34.21.11 22.13.11zm0 40.7c-10.396 0-18.825-8.43-18.825-18.826S11.735 3.16 22.13 3.16c10.396 0 18.825 8.428 18.825 18.824S32.525 40.81 22.13 40.81z"/><circle cx="21.888" cy="22.701" r="2.445"/><circle cx="12.23" cy="22.701" r="2.445"/><circle cx="31.546" cy="22.701" r="2.445"/></g></svg>',
    'exclamation-circle': '<svg viewBox="0 0 64 64"><path d="M59.58 40.89L41.193 9.11C39.135 5.382 35.723 3 31.387 3c-3.11 0-6.52 2.382-8.58 6.11L4.42 40.89c-2.788 4.635-3.126 8.81-1.225 12.22C5.015 56.208 7.572 58 13 58h36.773c5.428 0 9.21-1.792 11.03-4.89 1.9-3.41 1.565-7.583-1.224-12.22zm-2.452 11c-.635 1.694-3.802 2.443-7.354 2.443H13c-3.59 0-5.493-.75-6.13-2.444-1.71-2.41-1.374-5.263 0-8.557l18.387-31.777c2.116-3.168 4.394-4.89 6.13-4.89 2.96 0 5.238 1.722 7.354 4.89l18.387 31.777c1.374 3.294 1.713 6.146 0 8.556zm-25.74-33c-.405 0-1.227.835-1.227 2.443v15.89c0 1.608.823 2.444 1.227 2.444 1.628 0 2.452-.836 2.452-2.445v-15.89c0-1.607-.825-2.443-2.453-2.443zm0 23.22c-.405 0-1.227.79-1.227 1.223v2.445c0 .434.823 1.222 1.227 1.222 1.628 0 2.452-.788 2.452-1.222v-2.445c0-.434-.825-1.222-2.453-1.222z" fill-rule="evenodd"/></svg>',
    'info-circle': '<svg viewBox="0 0 44 44"><circle cx="13.828" cy="19.63" r="1.938"/><circle cx="21.767" cy="19.63" r="1.938"/><circle cx="29.767" cy="19.63" r="1.938"/><path d="M22.102 4.16c-9.918 0-17.958 7.147-17.958 15.962 0 4.935 2.522 9.345 6.48 12.273v5.667l.04.012a2.627 2.627 0 1 0 4.5 1.455h.002l5.026-3.54c.628.06 1.265.094 1.91.094 9.92 0 17.96-7.146 17.96-15.96C40.06 11.306 32.02 4.16 22.1 4.16zm-.04 29.902c-.902 0-1.78-.08-2.642-.207l-5.882 4.234c-.024.024-.055.04-.083.06l-.008.005a.51.51 0 0 1-.284.095.525.525 0 0 1-.525-.525l.005-6.375c-3.91-2.516-6.456-6.544-6.456-11.1 0-7.628 7.107-13.812 15.875-13.812s15.875 6.184 15.875 13.812-7.107 13.812-15.875 13.812z"/></svg>',
    'question-circle': '<svg viewBox="0 0 44 44"><g fill-rule="evenodd"><path d="M21.186 3c-10.853 0-19.36 8.506-19.36 19.358C1.827 32.494 10.334 41 21.187 41c10.133 0 18.64-8.506 18.64-18.642C39.827 11.506 31.32 3 21.187 3m15.64 19c0 8.823-7.178 16-16 16s-16-7.177-16-16 7.178-16 16-16 16 7.177 16 16z"/><path d="M22.827 31.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4-15.48c0 .957-.203 1.822-.61 2.593-.427.792-1.117 1.612-2.073 2.457-.867.734-1.453 1.435-1.754 2.096-.302.7-.453 1.693-.453 2.98a.828.828 0 0 1-.823.854.828.828 0 0 1-.584-.22.877.877 0 0 1-.24-.635c0-1.305.168-2.38.506-3.227.336-.883.93-1.682 1.78-2.4 1.01-.883 1.71-1.692 2.1-2.428.336-.645.503-1.38.503-2.21-.02-.935-.3-1.7-.85-2.288-.655-.717-1.62-1.075-2.897-1.075-1.506 0-2.596.535-3.27 1.6-.46.754-.688 1.645-.688 2.677a.92.92 0 0 1-.266.66.747.747 0 0 1-.56.25.73.73 0 0 1-.584-.194c-.16-.164-.24-.393-.24-.69 0-1.82.585-3.272 1.755-4.357C18.645 11.486 19.928 11 21.434 11h.293c1.452 0 2.638.414 3.56 1.24 1.028.903 1.54 2.163 1.54 3.78z"/></g></svg>',
    voice: '<svg viewBox="0 0 38 33"><g fill-rule="evenodd"><path d="M17.838 28.8c-.564-.468-1.192-.983-1.836-1.496-4.244-3.385-5.294-3.67-6.006-3.67-.014 0-.027.005-.04.005-.015 0-.028-.006-.042-.006H3.562c-.734 0-.903-.203-.903-.928v-12.62c0-.49.057-.8.66-.8H9.1c.694 0 1.76-.28 6.4-3.63.83-.596 1.638-1.196 2.337-1.722V28.8zM19.682.19c-.463-.22-1.014-.158-1.417.157-.02.016-1.983 1.552-4.152 3.125C10.34 6.21 9.243 6.664 9.02 6.737H3.676c-.027 0-.053.003-.08.004H1.183c-.608 0-1.1.487-1.1 1.086V25.14c0 .598.492 1.084 1.1 1.084h8.71c.22.08 1.257.55 4.605 3.24 1.947 1.562 3.694 3.088 3.712 3.103.25.22.568.333.89.333.186 0 .373-.038.55-.116.48-.213.79-.684.79-1.204V1.38c0-.506-.294-.968-.758-1.19z" mask="url(#mask-2)"/><path d="M31.42 16.475c0-3.363-1.854-6.297-4.606-7.876-.125-.067-.42-.193-.625-.193-.613 0-1.11.488-1.11 1.09 0 .404.22.764.55.952 2.13 1.19 3.566 3.44 3.566 6.024 0 2.627-1.486 4.913-3.677 6.087-.32.19-.53.54-.53.935 0 .602.495 1.09 1.106 1.09.26.002.568-.15.568-.15 2.835-1.556 4.754-4.538 4.754-7.96" mask="url(#mask-4)"/><path d="M30.14 3.057c-.205-.122-.41-.22-.658-.22-.608 0-1.1.485-1.1 1.084 0 .434.26.78.627.978 4.042 2.323 6.76 6.636 6.76 11.578 0 4.938-2.715 9.248-6.754 11.572-.354.19-.66.55-.66.993 0 .6.494 1.085 1.102 1.085.243 0 .438-.092.65-.213 4.692-2.695 7.848-7.7 7.848-13.435 0-5.723-3.142-10.718-7.817-13.418" mask="url(#mask-6)"/></g></svg>',
    plus: '<svg viewBox="0 0 30 30"><path d="M14 14H0v2h14v14h2V16h14v-2H16V0h-2v14z" fill-rule="evenodd"/></svg>',
    minus: '<svg viewBox="0 0 30 2"><path d="M0 0h30v2H0z" fill-rule="evenodd"/></svg>',
    dislike: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path fill="#FFF" d="M47 22h2v6h-2zm-24 0h2v6h-2z"/><path d="M21 51s4.6-7 15-7 15 7 15 7" stroke="#FFF" stroke-width="2"/></g></svg>',
    fail: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path d="M22 22l28.304 28.304m-28.304 0L50.304 22" stroke="#FFF" stroke-width="2"/></g></svg>',
    success: '<svg viewBox="0 0 72 72"><g fill="none" fill-rule="evenodd"><path d="M36 72c19.882 0 36-16.118 36-36S55.882 0 36 0 0 16.118 0 36s16.118 36 36 36zm0-2c18.778 0 34-15.222 34-34S54.778 2 36 2 2 17.222 2 36s15.222 34 34 34z" fill="#FFF"/><path stroke="#FFF" stroke-width="2" d="M19 34.54l11.545 11.923L52.815 24"/></g></svg>'
};
var renderSvgSprite = function renderSvgSprite() {
    var symbols = Object.keys(icons).map(function (iconName) {
        var svgContent = icons[iconName].split('svg')[1];
        return '<symbol id=' + iconName + svgContent + 'symbol>';
    }).join('');
    return svgSprite(symbols);
};
var loadSprite = function loadSprite() {
    if (!document) {
        return;
    }
    var existing = document.getElementById('__ANTD_MOBILE_SVG_SPRITE_NODE__');
    var mountNode = document.body;
    if (!existing) {
        mountNode.insertAdjacentHTML('afterbegin', renderSvgSprite());
    }
};
exports['default'] = loadSprite;
module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(263);

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var bind = __webpack_require__(169);
var Axios = __webpack_require__(265);
var defaults = __webpack_require__(124);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(174);
axios.CancelToken = __webpack_require__(278);
axios.isCancel = __webpack_require__(173);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(279);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 264 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(124);
var utils = __webpack_require__(41);
var InterceptorManager = __webpack_require__(273);
var dispatchRequest = __webpack_require__(274);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(172);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);
var transformData = __webpack_require__(275);
var isCancel = __webpack_require__(173);
var defaults = __webpack_require__(124);
var isAbsoluteURL = __webpack_require__(276);
var combineURLs = __webpack_require__(277);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(41);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(174);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wingBlank = __webpack_require__(282);

var _wingBlank2 = _interopRequireDefault(_wingBlank);

var _button = __webpack_require__(126);

var _button2 = _interopRequireDefault(_button);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _inputItem = __webpack_require__(290);

var _inputItem2 = _interopRequireDefault(_inputItem);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _whiteSpace = __webpack_require__(180);

var _whiteSpace2 = _interopRequireDefault(_whiteSpace);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(298);

__webpack_require__(128);

__webpack_require__(20);

__webpack_require__(303);

__webpack_require__(47);

__webpack_require__(182);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rcForm = __webpack_require__(183);

var _ImgUpload = __webpack_require__(100);

var _global = __webpack_require__(42);

var _app = __webpack_require__(4);

var _http = __webpack_require__(36);

var _TopNav = __webpack_require__(8);

__webpack_require__(383);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserAvatar = function UserAvatar(props) {
  return _react2.default.createElement(
    'div',
    { className: 'user-avator' },
    _react2.default.createElement('img', { src: props.url }),
    _react2.default.createElement(_ImgUpload.ImgUpload, { complete: function complete(url) {
        return props.change(url);
      } })
  );
};

var UserInfoPage = function (_React$Component) {
  (0, _inherits3.default)(UserInfoPage, _React$Component);

  function UserInfoPage(props) {
    (0, _classCallCheck3.default)(this, UserInfoPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserInfoPage.__proto__ || Object.getPrototypeOf(UserInfoPage)).call(this, props));

    _this.state = {
      isLoading: false
    };
    _this.sexPickerData = [{
      label: '男',
      value: 'man'
    }, {
      label: '女',
      value: 'woman'
    }];

    _this.getUserInfo = function () {
      (0, _http.ajax)({
        url: '/index.php?r=AppData/getUserInfo',
        type: 'get',
        data: {
          app_id: (0, _global.getAppId)()
        },
        success: function success(res) {
          var info = res.data;
          var state = {
            avatar: info.cover_thumb || 'http://cdn.jisuapp.cn/static/webapp/images/default_photo.png',
            nickname: info.nickname || null,
            phone: info.phone || null
          };
          if (info.sex) {
            state['sex'] = [info.sex === '0' ? 'man' : 'woman'];
          }
          _this.props.form.setFieldsValue(state);
        }
      });
    };

    _this.setAvatar = function (url) {
      _this.props.form.setFieldsValue({
        avatar: url
      });
    };

    _this.handleChangePhone = function () {
      _app.appMethod.turnToPage('bindPhonePage');
    };

    _this.handleSave = function () {
      var valid = true;
      _this.props.form.validateFields(function (errors) {
        if (!errors) {
          return;
        }
        valid = false;
        for (var field in errors) {
          var error = errors[field].errors[0];
          if (error) {
            _toast2.default.info(error.message);
            return;
          }
        }
      });
      if (!valid) {
        return;
      }
      _this.setState({
        isLoading: true
      });
      var fieldsValue = _this.props.form.getFieldsValue();
      (0, _http.ajax)({
        url: '/index.php?r=AppData/saveUserInfo',
        type: 'post',
        data: {
          app_id: (0, _global.getAppId)(),
          cover_thumb: fieldsValue['avatar'],
          nickname: fieldsValue['nickname'],
          sex: fieldsValue['sex'][0] === 'man' ? '0' : '1'
        },
        success: function success(res) {
          _this.setState({
            isLoading: false
          });
          if (res.status !== 0) {
            _toast2.default.info('保存失败');
          }
          _toast2.default.info('保存成功', 2);
        }
      });
    };

    _this.logout = function () {
      (0, _http.ajax)({
        url: '/index.php?r=AppUser/logout',
        data: {
          app_id: (0, _global.getAppId)()
        },
        success: function success() {
          _app.appMethod.setIsLogin(false);
        }
      });
    };

    document.title = '我的';
    return _this;
  }

  (0, _createClass3.default)(UserInfoPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_app.appMethod.isLogin()) {
        if (_app.appMethod.globalData.currentPages.length > 1) {
          this.turnToPage('loginPage', {}, 1);
        } else {
          this.turnToPage('loginPage');
        }
        return;
      }
      this.getUserInfo();
    }
    /**
     * 处理用户信息
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$form = this.props.form,
          getFieldProps = _props$form.getFieldProps,
          getFieldValue = _props$form.getFieldValue,
          isFieldsTouched = _props$form.isFieldsTouched;

      return _react2.default.createElement(
        'div',
        { id: 'userInfoPage', className: 'page' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u6211\u7684' }),
        _react2.default.createElement(_whiteSpace2.default, null),
        _react2.default.createElement(
          _list2.default,
          null,
          _react2.default.createElement(
            _list2.default.Item,
            (0, _extends3.default)({}, getFieldProps('avatar'), {
              extra: _react2.default.createElement(UserAvatar, (0, _extends3.default)({ url: getFieldValue('avatar'), change: function change(url) {
                  return _this2.setAvatar(url);
                } }, this.props))
            }),
            '\u6211\u7684\u5934\u50CF'
          ),
          _react2.default.createElement(
            _inputItem2.default,
            (0, _extends3.default)({}, getFieldProps('nickname', {
              rules: [{ required: true, message: '请填写昵称' }]
            }), {
              placeholder: '\u586B\u5199\u6635\u79F0',
              name: 'nickname'
            }),
            '\u6635\u79F0'
          ),
          _react2.default.createElement(
            _picker2.default,
            (0, _extends3.default)({
              title: '\u9009\u62E9\u6027\u522B',
              data: this.sexPickerData,
              cols: 1
            }, getFieldProps('sex')),
            _react2.default.createElement(
              _list2.default.Item,
              { arrow: 'horizontal' },
              '\u6027\u522B'
            )
          ),
          _react2.default.createElement(
            _list2.default.Item,
            (0, _extends3.default)({}, getFieldProps('phone'), { extra: getFieldValue('phone'), arrow: 'horizontal', onClick: this.handleChangePhone }),
            '\u624B\u673A\u53F7\u7801'
          )
        ),
        _react2.default.createElement(_whiteSpace2.default, { size: 'lg' }),
        _react2.default.createElement(
          _wingBlank2.default,
          { size: 'lg' },
          _react2.default.createElement(
            _button2.default,
            { type: 'primary', style: { fontSize: '16px', height: '38px', lineHeight: '38px' }, disabled: this.state.isLoading || !isFieldsTouched(), loading: this.state.isLoading, onClick: this.handleSave },
            '\u4FDD\u5B58'
          ),
          _react2.default.createElement(_whiteSpace2.default, null),
          _react2.default.createElement(
            _button2.default,
            { type: 'default', style: { fontSize: '16px', height: '38px', lineHeight: '38px' }, onClick: this.logout },
            '\u9000\u51FA\u767B\u5F55'
          )
        )
      );
    }
  }]);
  return UserInfoPage;
}(_react2.default.Component);

exports.default = (0, _rcForm.createForm)()(UserInfoPage);

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var WingBlank = function (_React$Component) {
    (0, _inherits3['default'])(WingBlank, _React$Component);

    function WingBlank() {
        (0, _classCallCheck3['default'])(this, WingBlank);
        return (0, _possibleConstructorReturn3['default'])(this, (WingBlank.__proto__ || Object.getPrototypeOf(WingBlank)).apply(this, arguments));
    }

    (0, _createClass3['default'])(WingBlank, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                size = _props.size,
                className = _props.className,
                children = _props.children,
                style = _props.style;

            var wrapCls = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + size, className);
            return React.createElement(
                'div',
                { className: wrapCls, style: style },
                children
            );
        }
    }]);
    return WingBlank;
}(React.Component);

exports['default'] = WingBlank;

WingBlank.defaultProps = {
    prefixCls: 'am-wingblank',
    size: 'lg'
};
module.exports = exports['default'];

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDefaultProps = getDefaultProps;

var _arrayTreeFilter = __webpack_require__(176);

var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _Cascader = __webpack_require__(177);

var _Cascader2 = _interopRequireDefault(_Cascader);

var _Popup = __webpack_require__(286);

var _Popup2 = _interopRequireDefault(_Popup);

var _MultiPicker = __webpack_require__(93);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(94);

var _Picker2 = _interopRequireDefault(_Picker);

var _getLocale = __webpack_require__(127);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */
function getDefaultProps() {
    var defaultFormat = function defaultFormat(values) {
        // label is JSX.Element or other
        if (values.length > 0 && typeof values[0] !== 'string') {
            return values;
        }
        return values.join(',');
    };
    return {
        triggerType: 'onClick',
        prefixCls: 'am-picker',
        pickerPrefixCls: 'am-picker-col',
        popupPrefixCls: 'am-picker-popup',
        format: defaultFormat,
        cols: 3,
        cascade: true,
        title: ''
    };
}

var AbstractPicker = function (_React$Component) {
    (0, _inherits3['default'])(AbstractPicker, _React$Component);

    function AbstractPicker() {
        (0, _classCallCheck3['default'])(this, AbstractPicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (AbstractPicker.__proto__ || Object.getPrototypeOf(AbstractPicker)).apply(this, arguments));

        _this.getSel = function () {
            var value = _this.props.value || [];
            var treeChildren = void 0;
            var data = _this.props.data;

            if (_this.props.cascade) {
                treeChildren = (0, _arrayTreeFilter2['default'])(data, function (c, level) {
                    return c.value === value[level];
                });
            } else {
                treeChildren = value.map(function (v, i) {
                    return data[i].filter(function (d) {
                        return d.value === v;
                    })[0];
                });
            }
            return _this.props.format && _this.props.format(treeChildren.map(function (v) {
                return v.label;
            }));
        };
        _this.getPickerCol = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                pickerPrefixCls = _this$props.pickerPrefixCls,
                itemStyle = _this$props.itemStyle,
                indicatorStyle = _this$props.indicatorStyle;

            return data.map(function (col, index) {
                return React.createElement(
                    _Picker2['default'],
                    { key: index, prefixCls: pickerPrefixCls, style: { flex: 1 }, itemStyle: itemStyle, indicatorStyle: indicatorStyle },
                    col.map(function (item) {
                        return React.createElement(
                            _Picker2['default'].Item,
                            { key: item.value, value: item.value },
                            item.label
                        );
                    })
                );
            });
        };
        _this.onOk = function (v) {
            if (_this.scrollValue !== undefined) {
                v = _this.scrollValue;
            }
            if (_this.props.onChange) {
                _this.props.onChange(v);
            }
            if (_this.props.onOk) {
                _this.props.onOk(v);
            }
        };
        _this.setScrollValue = function (v) {
            _this.scrollValue = v;
        };
        _this.setCasecadeScrollValue = function (v) {
            // 级联情况下保证数据正确性，滚动过程中只有当最后一级变化时才变更数据
            if (v && _this.scrollValue) {
                var length = _this.scrollValue.length;
                if (length === v.length && _this.scrollValue[length - 1] === v[length - 1]) {
                    return;
                }
            }
            _this.setScrollValue(v);
        };
        _this.fixOnOk = function (cascader) {
            if (cascader && cascader.onOk !== _this.onOk) {
                cascader.onOk = _this.onOk;
                cascader.forceUpdate();
            }
        };
        _this.onPickerChange = function (v) {
            _this.setScrollValue(v);
            if (_this.props.onPickerChange) {
                _this.props.onPickerChange(v);
            }
        };
        _this.onVisibleChange = function (visible) {
            _this.setScrollValue(undefined);
            if (_this.props.onVisibleChange) {
                _this.props.onVisibleChange(visible);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(AbstractPicker, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                children = _a.children,
                _a$value = _a.value,
                value = _a$value === undefined ? [] : _a$value,
                popupPrefixCls = _a.popupPrefixCls,
                itemStyle = _a.itemStyle,
                indicatorStyle = _a.indicatorStyle,
                okText = _a.okText,
                dismissText = _a.dismissText,
                extra = _a.extra,
                cascade = _a.cascade,
                prefixCls = _a.prefixCls,
                pickerPrefixCls = _a.pickerPrefixCls,
                data = _a.data,
                cols = _a.cols,
                onOk = _a.onOk,
                restProps = __rest(_a, ["children", "value", "popupPrefixCls", "itemStyle", "indicatorStyle", "okText", "dismissText", "extra", "cascade", "prefixCls", "pickerPrefixCls", "data", "cols", "onOk"]);
            // tslint:disable-next-line:variable-name
            var _locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'Picker', function () {
                return __webpack_require__(288);
            });
            var cascader = void 0;
            var popupMoreProps = {};
            if (cascade) {
                cascader = React.createElement(_Cascader2['default'], { prefixCls: prefixCls, pickerPrefixCls: pickerPrefixCls, data: data, cols: cols, onChange: this.onPickerChange, onScrollChange: this.setCasecadeScrollValue, pickerItemStyle: itemStyle, indicatorStyle: indicatorStyle });
            } else {
                cascader = React.createElement(
                    _MultiPicker2['default'],
                    { style: { flexDirection: 'row', alignItems: 'center' }, prefixCls: prefixCls, onScrollChange: this.setScrollValue },
                    this.getPickerCol()
                );
                popupMoreProps = {
                    pickerValueProp: 'selectedValue',
                    pickerValueChangeProp: 'onValueChange'
                };
            }
            return React.createElement(
                _Popup2['default'],
                (0, _extends3['default'])({ cascader: cascader }, this.popupProps, restProps, { prefixCls: popupPrefixCls, value: value, dismissText: dismissText || _locale.dismissText, okText: okText || _locale.okText }, popupMoreProps, { ref: this.fixOnOk, onVisibleChange: this.onVisibleChange }),
                children && typeof children !== 'string' && React.isValidElement(children) && React.cloneElement(children, {
                    extra: this.getSel() || extra || _locale.extra
                })
            );
        }
    }]);
    return AbstractPicker;
}(React.Component);

exports['default'] = AbstractPicker;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var React = _interopRequireWildcard(__webpack_require__(5));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _default(ComposedComponent) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_a, _React$Component);

    function _a() {
      var _this;

      _classCallCheck(this, _a);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).apply(this, arguments));

      _this.getValue = function () {
        var _this$props = _this.props,
            children = _this$props.children,
            selectedValue = _this$props.selectedValue;

        if (selectedValue && selectedValue.length) {
          return selectedValue;
        } else {
          if (!children) {
            return [];
          }

          return React.Children.map(children, function (c) {
            var cc = React.Children.toArray(c.children || c.props.children);
            return cc && cc[0] && cc[0].props.value;
          });
        }
      };

      _this.onChange = function (i, v, cb) {
        var value = _this.getValue().concat();

        value[i] = v;

        if (cb) {
          cb(value, i);
        }
      };

      _this.onValueChange = function (i, v) {
        _this.onChange(i, v, _this.props.onValueChange);
      };

      _this.onScrollChange = function (i, v) {
        _this.onChange(i, v, _this.props.onScrollChange);
      };

      return _this;
    }

    _createClass(_a, [{
      key: "render",
      value: function render() {
        return React.createElement(ComposedComponent, _extends({}, this.props, {
          getValue: this.getValue,
          onValueChange: this.onValueChange,
          onScrollChange: this.props.onScrollChange && this.onScrollChange
        }));
      }
    }]);

    return _a;
  }(React.Component), _a.defaultProps = {
    prefixCls: 'rmc-multi-picker',
    onValueChange: function onValueChange() {}
  }, _a;
}

;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var React = _interopRequireWildcard(__webpack_require__(5));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

;

var Item = function Item(_props) {
  return null;
};

function _default(ComposedComponent) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_a, _React$Component);

    function _a() {
      var _this;

      _classCallCheck(this, _a);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).apply(this, arguments));

      _this.select = function (value, itemHeight, scrollTo) {
        var children = React.Children.toArray(_this.props.children);

        for (var i = 0, len = children.length; i < len; i++) {
          if (children[i].props.value === value) {
            _this.selectByIndex(i, itemHeight, scrollTo);

            return;
          }
        }

        _this.selectByIndex(0, itemHeight, scrollTo);
      };

      _this.doScrollingComplete = function (top, itemHeight, fireValueChange) {
        var children = React.Children.toArray(_this.props.children);

        var index = _this.computeChildIndex(top, itemHeight, children.length);

        var child = children[index];

        if (child) {
          fireValueChange(child.props.value);
        } else if (console.warn) {
          console.warn('child not found', children, index);
        }
      };

      return _this;
    }

    _createClass(_a, [{
      key: "selectByIndex",
      value: function selectByIndex(index, itemHeight, zscrollTo) {
        if (index < 0 || index >= React.Children.count(this.props.children) || !itemHeight) {
          return;
        }

        zscrollTo(index * itemHeight);
      }
    }, {
      key: "computeChildIndex",
      value: function computeChildIndex(top, itemHeight, childrenLength) {
        var index = Math.round(top / itemHeight);
        return Math.min(index, childrenLength - 1);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(ComposedComponent, _extends({}, this.props, {
          doScrollingComplete: this.doScrollingComplete,
          computeChildIndex: this.computeChildIndex,
          select: this.select
        }));
      }
    }]);

    return _a;
  }(React.Component), _a.Item = Item, _a;
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__(178);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupCascader = function (_React$Component) {
    (0, _inherits3['default'])(PopupCascader, _React$Component);

    function PopupCascader() {
        (0, _classCallCheck3['default'])(this, PopupCascader);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PopupCascader.__proto__ || Object.getPrototypeOf(PopupCascader)).apply(this, arguments));

        _this.onOk = function (v) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                onOk = _this$props.onOk;

            if (onChange) {
                onChange(v);
            }
            if (onOk) {
                onOk(v);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(PopupCascader, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_Popup2['default'], (0, _extends3['default'])({ picker: this.props.cascader }, this.props, { onOk: this.onOk }));
        }
    }]);
    return PopupCascader;
}(_react2['default'].Component);

PopupCascader.defaultProps = {
    pickerValueProp: 'value',
    pickerValueChangeProp: 'onChange'
};
exports['default'] = PopupCascader;
module.exports = exports['default'];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupMixin;

var React = _interopRequireWildcard(__webpack_require__(5));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function PopupMixin(getModal, platformProps) {
  var _a;

  return _a =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_a, _React$Component);

    function _a(props) {
      var _this;

      _classCallCheck(this, _a);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(_a).call(this, props));

      _this.onPickerChange = function (pickerValue) {
        if (_this.state.pickerValue !== pickerValue) {
          _this.setState({
            pickerValue: pickerValue
          });

          var _this$props = _this.props,
              picker = _this$props.picker,
              pickerValueChangeProp = _this$props.pickerValueChangeProp;

          if (picker && picker.props[pickerValueChangeProp]) {
            picker.props[pickerValueChangeProp](pickerValue);
          }
        }
      };

      _this.saveRef = function (picker) {
        _this.picker = picker;
      };

      _this.onTriggerClick = function (e) {
        var child = _this.props.children;
        var childProps = child.props || {};

        if (childProps[_this.props.triggerType]) {
          childProps[_this.props.triggerType](e);
        }

        _this.fireVisibleChange(!_this.state.visible);
      };

      _this.onOk = function () {
        _this.props.onOk(_this.picker && _this.picker.getValue());

        _this.fireVisibleChange(false);
      };

      _this.getContent = function () {
        if (_this.props.picker) {
          var _React$cloneElement;

          var pickerValue = _this.state.pickerValue;

          if (pickerValue === null) {
            pickerValue = _this.props.value;
          }

          return React.cloneElement(_this.props.picker, (_React$cloneElement = {}, _defineProperty(_React$cloneElement, _this.props.pickerValueProp, pickerValue), _defineProperty(_React$cloneElement, _this.props.pickerValueChangeProp, _this.onPickerChange), _defineProperty(_React$cloneElement, "ref", _this.saveRef), _React$cloneElement));
        } else {
          return _this.props.content;
        }
      };

      _this.onDismiss = function () {
        _this.props.onDismiss();

        _this.fireVisibleChange(false);
      };

      _this.hide = function () {
        _this.fireVisibleChange(false);
      };

      _this.state = {
        pickerValue: 'value' in _this.props ? _this.props.value : null,
        visible: _this.props.visible || false
      };
      return _this;
    }

    _createClass(_a, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
          this.setState({
            pickerValue: nextProps.value
          });
        }

        if ('visible' in nextProps) {
          this.setVisibleState(nextProps.visible);
        }
      }
    }, {
      key: "setVisibleState",
      value: function setVisibleState(visible) {
        this.setState({
          visible: visible
        });

        if (!visible) {
          this.setState({
            pickerValue: null
          });
        }
      }
    }, {
      key: "fireVisibleChange",
      value: function fireVisibleChange(visible) {
        if (this.state.visible !== visible) {
          if (!('visible' in this.props)) {
            this.setVisibleState(visible);
          }

          this.props.onVisibleChange(visible);
        }
      }
    }, {
      key: "getRender",
      value: function getRender() {
        var props = this.props;
        var children = props.children;

        if (!children) {
          return getModal(props, this.state.visible, {
            getContent: this.getContent,
            onOk: this.onOk,
            hide: this.hide,
            onDismiss: this.onDismiss
          });
        }

        var _this$props2 = this.props,
            WrapComponent = _this$props2.WrapComponent,
            disabled = _this$props2.disabled;
        var child = children;
        var newChildProps = {};

        if (!disabled) {
          newChildProps[props.triggerType] = this.onTriggerClick;
        }

        return React.createElement(WrapComponent, {
          style: props.wrapStyle
        }, React.cloneElement(child, newChildProps), getModal(props, this.state.visible, {
          getContent: this.getContent,
          onOk: this.onOk,
          hide: this.hide,
          onDismiss: this.onDismiss
        }));
      }
    }, {
      key: "render",
      value: function render() {
        return this.getRender();
      }
    }]);

    return _a;
  }(React.Component), _a.defaultProps = _extends({
    onVisibleChange: function onVisibleChange(_) {},
    okText: 'Ok',
    dismissText: 'Dismiss',
    title: '',
    onOk: function onOk(_) {},
    onDismiss: function onDismiss() {}
  }, platformProps), _a;
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择'
};
module.exports = exports['default'];

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    WrapComponent: 'div',
    transitionName: 'am-slide-up',
    maskTransitionName: 'am-fade'
};
module.exports = exports['default'];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(15);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(65);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _getLocale = __webpack_require__(127);

var _CustomInput = __webpack_require__(291);

var _CustomInput2 = _interopRequireDefault(_CustomInput);

var _Input = __webpack_require__(295);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

function noop() {}
function normalizeValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value + '';
}

var InputItem = function (_React$Component) {
    (0, _inherits3['default'])(InputItem, _React$Component);

    function InputItem(props) {
        (0, _classCallCheck3['default'])(this, InputItem);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (InputItem.__proto__ || Object.getPrototypeOf(InputItem)).call(this, props));

        _this.onInputChange = function (e) {
            var el = e.target;
            var rawVal = el.value;

            var prePos = 0;
            try {
                // some input type do not support selection, see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
                prePos = el.selectionEnd || 0;
            } catch (error) {
                console.warn('Get selection error:', error);
            }
            var _this$state$value = _this.state.value,
                preCtrlVal = _this$state$value === undefined ? '' : _this$state$value;
            var type = _this.props.type;

            var ctrlValue = rawVal;
            switch (type) {
                case 'bankCard':
                    ctrlValue = rawVal.replace(/\D/g, '').replace(/(....)(?=.)/g, '$1 ');
                    break;
                case 'phone':
                    ctrlValue = rawVal.replace(/\D/g, '').substring(0, 11);
                    var valueLen = ctrlValue.length;
                    if (valueLen > 3 && valueLen < 8) {
                        ctrlValue = ctrlValue.substr(0, 3) + ' ' + ctrlValue.substr(3);
                    } else if (valueLen >= 8) {
                        ctrlValue = ctrlValue.substr(0, 3) + ' ' + ctrlValue.substr(3, 4) + ' ' + ctrlValue.substr(7);
                    }
                    break;
                case 'number':
                    ctrlValue = rawVal.replace(/\D/g, '');
                    break;
                case 'text':
                case 'password':
                default:
                    break;
            }
            _this.handleOnChange(ctrlValue, ctrlValue !== rawVal, function () {
                switch (type) {
                    case 'bankCard':
                    case 'phone':
                    case 'number':
                        // controlled input type needs to adjust the position of the caret
                        try {
                            // some input type do not support selection, see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
                            var pos = _this.calcPos(prePos, preCtrlVal, rawVal, ctrlValue, [' '], /\D/g);
                            if (type === 'phone' && (pos === 4 || pos === 9) || type === 'bankCard' && pos > 0 && pos % 5 === 0) {
                                pos -= 1;
                            }
                            el.selectionStart = el.selectionEnd = pos;
                        } catch (error) {
                            console.warn('Set selection error:', error);
                        }
                        break;
                    default:
                        break;
                }
            });
        };
        _this.handleOnChange = function (value) {
            var isMutated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var adjustPos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noop;
            var onChange = _this.props.onChange;

            if (!('value' in _this.props)) {
                _this.setState({ value: value });
            } else {
                _this.setState({ value: _this.props.value });
            }
            if (onChange) {
                if (isMutated) {
                    setTimeout(function () {
                        onChange(value);
                        adjustPos();
                    });
                } else {
                    onChange(value);
                    adjustPos();
                }
            } else {
                adjustPos();
            }
        };
        _this.onInputFocus = function (value) {
            if (_this.debounceTimeout) {
                clearTimeout(_this.debounceTimeout);
                _this.debounceTimeout = null;
            }
            _this.setState({
                focus: true
            });
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.onInputBlur = function (value) {
            if (_this.inputRef) {
                // this.inputRef may be null if customKeyboard unmount
                _this.debounceTimeout = window.setTimeout(function () {
                    if (document.activeElement !== (_this.inputRef && _this.inputRef.inputRef)) {
                        _this.setState({
                            focus: false
                        });
                    }
                }, 200);
            }
            if (_this.props.onBlur) {
                // fix autoFocus item blur with flash
                setTimeout(function () {
                    // fix ios12 wechat browser click failure after input
                    if (document.body) {
                        document.body.scrollTop = document.body.scrollTop;
                    }
                }, 100);
                _this.props.onBlur(value);
            }
        };
        _this.clearInput = function () {
            if (_this.props.type !== 'password' && _this.props.updatePlaceholder) {
                _this.setState({
                    placeholder: _this.props.value
                });
            }
            _this.setState({
                value: ''
            });
            if (_this.props.onChange) {
                _this.props.onChange('');
            }
            _this.focus();
        };
        // this is instance method for user to use
        _this.focus = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        // calculate the position of the caret
        _this.calcPos = function (prePos, preCtrlVal, rawVal, ctrlVal, placeholderChars, maskReg) {
            var editLength = rawVal.length - preCtrlVal.length;
            var isAddition = editLength > 0;
            var pos = prePos;
            if (isAddition) {
                var additionStr = rawVal.substr(pos - editLength, editLength);
                var ctrlCharCount = additionStr.replace(maskReg, '').length;
                pos -= editLength - ctrlCharCount;
                var placeholderCharCount = 0;
                while (ctrlCharCount > 0) {
                    if (placeholderChars.indexOf(ctrlVal.charAt(pos - ctrlCharCount + placeholderCharCount)) === -1) {
                        ctrlCharCount--;
                    } else {
                        placeholderCharCount++;
                    }
                }
                pos += placeholderCharCount;
            }
            return pos;
        };
        _this.state = {
            placeholder: props.placeholder,
            value: normalizeValue(props.value || props.defaultValue)
        };
        return _this;
    }

    (0, _createClass3['default'])(InputItem, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('placeholder' in nextProps && !nextProps.updatePlaceholder) {
                this.setState({
                    placeholder: nextProps.placeholder
                });
            }
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                window.clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _this2 = this;

            var props = (0, _extends3['default'])({}, this.props);
            delete props.updatePlaceholder;

            var prefixCls = props.prefixCls,
                prefixListCls = props.prefixListCls,
                editable = props.editable,
                style = props.style,
                clear = props.clear,
                children = props.children,
                error = props.error,
                className = props.className,
                extra = props.extra,
                labelNumber = props.labelNumber,
                type = props.type,
                onExtraClick = props.onExtraClick,
                onErrorClick = props.onErrorClick,
                moneyKeyboardAlign = props.moneyKeyboardAlign,
                moneyKeyboardWrapProps = props.moneyKeyboardWrapProps,
                moneyKeyboardHeader = props.moneyKeyboardHeader,
                onVirtualKeyboardConfirm = props.onVirtualKeyboardConfirm,
                autoAdjustHeight = props.autoAdjustHeight,
                disabledKeys = props.disabledKeys,
                restProps = __rest(props, ["prefixCls", "prefixListCls", "editable", "style", "clear", "children", "error", "className", "extra", "labelNumber", "type", "onExtraClick", "onErrorClick", "moneyKeyboardAlign", "moneyKeyboardWrapProps", "moneyKeyboardHeader", "onVirtualKeyboardConfirm", "autoAdjustHeight", "disabledKeys"]);

            var name = restProps.name,
                disabled = restProps.disabled,
                maxLength = restProps.maxLength;
            var value = this.state.value;
            // tslint:disable-next-line:variable-name

            var _locale = (0, _getLocale.getComponentLocale)(this.props, this.context, 'InputItem', function () {
                return __webpack_require__(296);
            });
            var confirmLabel = _locale.confirmLabel,
                backspaceLabel = _locale.backspaceLabel,
                cancelKeyboardLabel = _locale.cancelKeyboardLabel;
            var _state = this.state,
                focus = _state.focus,
                placeholder = _state.placeholder;

            var wrapCls = (0, _classnames4['default'])(prefixListCls + '-item', prefixCls + '-item', prefixListCls + '-item-middle', className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-error', error), (0, _defineProperty3['default'])(_classnames, prefixCls + '-focus', focus), (0, _defineProperty3['default'])(_classnames, prefixCls + '-android', focus), _classnames));
            var labelCls = (0, _classnames4['default'])(prefixCls + '-label', (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-2', labelNumber === 2), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-3', labelNumber === 3), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-4', labelNumber === 4), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-5', labelNumber === 5), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-6', labelNumber === 6), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-label-7', labelNumber === 7), _classnames2));
            var controlCls = prefixCls + '-control';
            var inputType = 'text';
            if (type === 'bankCard' || type === 'phone') {
                inputType = 'tel';
            } else if (type === 'password') {
                inputType = 'password';
            } else if (type === 'digit') {
                inputType = 'number';
            } else if (type !== 'text' && type !== 'number') {
                inputType = type;
            }
            var patternProps = void 0;
            if (type === 'number') {
                patternProps = {
                    pattern: '[0-9]*'
                };
            }
            var classNameProps = void 0;
            if (type === 'digit') {
                classNameProps = {
                    className: 'h5numInput'
                };
            }
            return React.createElement(
                'div',
                { className: wrapCls },
                React.createElement(
                    'div',
                    { className: prefixListCls + '-line' },
                    children ? React.createElement(
                        'div',
                        { className: labelCls },
                        children
                    ) : null,
                    React.createElement(
                        'div',
                        { className: controlCls },
                        type === 'money' ? React.createElement(_CustomInput2['default'], { value: normalizeValue(value), type: type, ref: function ref(el) {
                                return _this2.inputRef = el;
                            }, maxLength: maxLength, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, onVirtualKeyboardConfirm: onVirtualKeyboardConfirm, disabled: disabled, editable: editable, prefixCls: prefixCls, style: style, confirmLabel: confirmLabel, backspaceLabel: backspaceLabel, cancelKeyboardLabel: cancelKeyboardLabel, moneyKeyboardAlign: moneyKeyboardAlign, moneyKeyboardWrapProps: moneyKeyboardWrapProps, moneyKeyboardHeader: moneyKeyboardHeader, autoAdjustHeight: autoAdjustHeight, disabledKeys: disabledKeys }) : React.createElement(_Input2['default'], (0, _extends3['default'])({}, patternProps, restProps, classNameProps, { value: normalizeValue(value), defaultValue: undefined, ref: function ref(el) {
                                return _this2.inputRef = el;
                            }, style: style, type: inputType, maxLength: maxLength, name: name, placeholder: placeholder, onChange: this.onInputChange, onFocus: this.onInputFocus, onBlur: this.onInputBlur, readOnly: !editable, disabled: disabled }))
                    ),
                    clear && editable && !disabled && value && ('' + value).length > 0 ? React.createElement(
                        _rmcFeedback2['default'],
                        { activeClassName: prefixCls + '-clear-active' },
                        React.createElement('div', { className: prefixCls + '-clear', onClick: this.clearInput })
                    ) : null,
                    error ? React.createElement('div', { className: prefixCls + '-error-extra', onClick: onErrorClick }) : null,
                    extra !== '' ? React.createElement(
                        'div',
                        { className: prefixCls + '-extra', onClick: onExtraClick },
                        extra
                    ) : null
                )
            );
        }
    }]);
    return InputItem;
}(React.Component);

InputItem.defaultProps = {
    prefixCls: 'am-input',
    prefixListCls: 'am-list',
    type: 'text',
    editable: true,
    disabled: false,
    placeholder: '',
    clear: false,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    extra: '',
    onExtraClick: noop,
    error: false,
    onErrorClick: noop,
    onVirtualKeyboardConfirm: noop,
    labelNumber: 5,
    updatePlaceholder: false,
    moneyKeyboardAlign: 'right',
    moneyKeyboardWrapProps: {},
    moneyKeyboardHeader: null,
    disabledKeys: null
};
InputItem.contextTypes = {
    antLocale: PropTypes.object
};
exports['default'] = InputItem;
module.exports = exports['default'];

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

var _class = __webpack_require__(292);

var _CustomKeyboard = __webpack_require__(293);

var _CustomKeyboard2 = _interopRequireDefault(_CustomKeyboard);

var _Portal = __webpack_require__(294);

var _Portal2 = _interopRequireDefault(_Portal);

var _exenv = __webpack_require__(179);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var customNumberKeyboard = null;
var IS_REACT_16 = !!ReactDOM.createPortal;
function getBodyScrollTop() {
    var el = document.scrollingElement || document.documentElement;
    return el && el.scrollTop || 0;
}
function setBodyScrollTop(scrollTop) {
    var el = document.scrollingElement || document.documentElement;
    el.scrollTop = scrollTop;
}

var NumberInput = function (_React$Component) {
    (0, _inherits3['default'])(NumberInput, _React$Component);

    function NumberInput(props) {
        (0, _classCallCheck3['default'])(this, NumberInput);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput)).call(this, props));

        _this.onChange = function (value) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value.target.value });
            }
            _this.props.onChange(value);
        };
        _this.onConfirm = function (value) {
            _this.props.onVirtualKeyboardConfirm(value);
        };
        _this.addBlurListener = function () {
            document.addEventListener('click', _this.doBlur, false);
        };
        _this.removeBlurListener = function () {
            document.removeEventListener('click', _this.doBlur, false);
        };
        _this.saveRef = function (el) {
            if (IS_REACT_16 && el) {
                customNumberKeyboard = el;
            }
        };
        _this.doBlur = function (ev) {
            var value = _this.state.value;

            if (ev.target !== _this.inputRef) {
                _this.onInputBlur(value);
            }
        };
        _this.unLinkInput = function () {
            if (customNumberKeyboard && customNumberKeyboard.antmKeyboard && customNumberKeyboard.linkedInput && customNumberKeyboard.linkedInput === _this) {
                customNumberKeyboard.linkedInput = null;
                if (_this.props.autoAdjustHeight) {
                    _this.getContainer().style.height = '0';
                }
                (0, _class.addClass)(customNumberKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
            }
            // for unmount
            _this.removeBlurListener();
        };
        _this.onInputBlur = function (value) {
            if (IS_REACT_16) {
                _this.keyBoard = null;
            }
            var focus = _this.state.focus;

            if (focus) {
                _this.setState({
                    focus: false
                });
                _this.props.onBlur(value);
                setTimeout(function () {
                    _this.unLinkInput();
                }, 50);
            }
        };
        _this.onInputFocus = function () {
            var value = _this.state.value;

            _this.props.onFocus(value);
            _this.setState({
                focus: true
            }, function () {
                if (customNumberKeyboard) {
                    customNumberKeyboard.linkedInput = _this;
                    if (customNumberKeyboard.antmKeyboard) {
                        if (_this.props.autoAdjustHeight) {
                            var keyBoardHeight = customNumberKeyboard.antmKeyboard.offsetHeight;
                            _this.getContainer().style.height = keyBoardHeight + 'px';
                            if (_this.inputRef) {
                                var _this$inputRef$getBou = _this.inputRef.getBoundingClientRect(),
                                    bottom = _this$inputRef$getBou.bottom;

                                var clientHeight = window.innerHeight;
                                // 计算输入框距离视窗的底部距离
                                var distance = clientHeight - bottom;
                                if (distance < keyBoardHeight) {
                                    setBodyScrollTop(getBodyScrollTop() + keyBoardHeight - distance);
                                }
                            }
                        }
                        (0, _class.removeClass)(customNumberKeyboard.antmKeyboard, _this.props.keyboardPrefixCls + '-wrapper-hide');
                    }
                    customNumberKeyboard.confirmDisabled = value === '';
                    if (customNumberKeyboard.confirmKeyboardItem) {
                        if (value === '') {
                            (0, _class.addClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                        } else {
                            (0, _class.removeClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                        }
                    }
                }
            });
        };
        _this.onKeyboardClick = function (KeyboardItemValue) {
            var maxLength = _this.props.maxLength;
            var value = _this.state.value;
            // tslint:disable-next-line:no-this-assignment

            var onChange = _this.onChange;

            var valueAfterChange = void 0;
            // 删除键
            if (KeyboardItemValue === 'delete') {
                valueAfterChange = value.substring(0, value.length - 1);
                onChange({ target: { value: valueAfterChange } });
                // 确认键
            } else if (KeyboardItemValue === 'confirm') {
                valueAfterChange = value;
                onChange({ target: { value: valueAfterChange } });
                _this.onInputBlur(value);
                _this.onConfirm(value);
                // 收起键
            } else if (KeyboardItemValue === 'hide') {
                valueAfterChange = value;
                _this.onInputBlur(valueAfterChange);
            } else {
                if (maxLength !== undefined && +maxLength >= 0 && (value + KeyboardItemValue).length > maxLength) {
                    valueAfterChange = (value + KeyboardItemValue).substr(0, maxLength);
                    onChange({ target: { value: valueAfterChange } });
                } else {
                    valueAfterChange = value + KeyboardItemValue;
                    onChange({ target: { value: valueAfterChange } });
                }
            }
            if (customNumberKeyboard) {
                customNumberKeyboard.confirmDisabled = valueAfterChange === '';
                if (customNumberKeyboard.confirmKeyboardItem) {
                    if (valueAfterChange === '') {
                        (0, _class.addClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                    } else {
                        (0, _class.removeClass)(customNumberKeyboard.confirmKeyboardItem, _this.props.keyboardPrefixCls + '-item-disabled');
                    }
                }
            }
        };
        _this.onFakeInputClick = function () {
            _this.focus();
        };
        _this.focus = function () {
            // this focus may invocked by users page button click, so this click may trigger blurEventListener at the same time
            _this.renderCustomKeyboard();
            _this.removeBlurListener();
            var focus = _this.state.focus;

            if (!focus) {
                _this.onInputFocus();
            }
            setTimeout(function () {
                _this.addBlurListener();
            }, 50);
        };
        _this.state = {
            focus: false,
            value: props.value || ''
        };
        return _this;
    }

    (0, _createClass3['default'])(NumberInput, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('value' in nextProps) {
                this.setState({
                    value: nextProps.value
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // focus:true unmount 不能触发 blur
            if (this.state.focus) {
                this.props.onBlur(this.state.value);
            }
            this.unLinkInput();
        }
    }, {
        key: 'getComponent',
        value: function getComponent() {
            var _props = this.props,
                confirmLabel = _props.confirmLabel,
                backspaceLabel = _props.backspaceLabel,
                cancelKeyboardLabel = _props.cancelKeyboardLabel,
                keyboardPrefixCls = _props.keyboardPrefixCls,
                moneyKeyboardWrapProps = _props.moneyKeyboardWrapProps,
                moneyKeyboardHeader = _props.moneyKeyboardHeader,
                disabledKeys = _props.disabledKeys;

            return React.createElement(_CustomKeyboard2['default'], { ref: this.saveRef, onClick: this.onKeyboardClick, prefixCls: keyboardPrefixCls, confirmLabel: confirmLabel, backspaceLabel: backspaceLabel, cancelKeyboardLabel: cancelKeyboardLabel, wrapProps: moneyKeyboardWrapProps, header: moneyKeyboardHeader, disabledKeys: disabledKeys });
        }
    }, {
        key: 'getContainer',
        value: function getContainer() {
            var keyboardPrefixCls = this.props.keyboardPrefixCls;

            var container = document.querySelector('#' + keyboardPrefixCls + '-container');
            if (!container) {
                container = document.createElement('div');
                container.setAttribute('id', keyboardPrefixCls + '-container');
                document.body.appendChild(container);
            }
            this.container = container;
            return this.container;
        }
    }, {
        key: 'renderCustomKeyboard',
        value: function renderCustomKeyboard() {
            var _this2 = this;

            if (IS_REACT_16) {
                this.keyBoard = React.createElement(
                    _Portal2['default'],
                    { getContainer: function getContainer() {
                            return _this2.getContainer();
                        } },
                    this.getComponent()
                );
            } else {
                customNumberKeyboard = ReactDOM.unstable_renderSubtreeIntoContainer(this, this.getComponent(), this.getContainer());
            }
        }
    }, {
        key: 'renderPortal',
        value: function renderPortal() {
            if (!IS_REACT_16 || !_exenv.canUseDOM) {
                return null;
            }
            return this.keyBoard;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                placeholder = _props2.placeholder,
                disabled = _props2.disabled,
                editable = _props2.editable,
                moneyKeyboardAlign = _props2.moneyKeyboardAlign;
            var _state = this.state,
                focus = _state.focus,
                value = _state.value;

            var preventKeyboard = disabled || !editable;
            var fakeInputCls = (0, _classnames2['default'])('fake-input', {
                focus: focus,
                'fake-input-disabled': disabled
            });
            var fakeInputContainerCls = (0, _classnames2['default'])('fake-input-container', {
                'fake-input-container-left': moneyKeyboardAlign === 'left'
            });
            return React.createElement(
                'div',
                { className: fakeInputContainerCls },
                value === '' &&
                // tslint:disable-next-line:jsx-no-multiline-js
                React.createElement(
                    'div',
                    { className: 'fake-input-placeholder' },
                    placeholder
                ),
                React.createElement(
                    'div',
                    { role: 'textbox', 'aria-label': value || placeholder, className: fakeInputCls, ref: function ref(el) {
                            return _this3.inputRef = el;
                        }, onClick: preventKeyboard ? function () {} : this.onFakeInputClick },
                    value
                ),
                this.renderPortal()
            );
        }
    }]);
    return NumberInput;
}(React.Component);

NumberInput.defaultProps = {
    onChange: function onChange() {},
    onFocus: function onFocus() {},
    onBlur: function onBlur() {},
    onVirtualKeyboardConfirm: function onVirtualKeyboardConfirm() {},
    placeholder: '',
    disabled: false,
    editable: true,
    prefixCls: 'am-input',
    keyboardPrefixCls: 'am-number-keyboard',
    autoAdjustHeight: false
};
exports['default'] = NumberInput;
module.exports = exports['default'];

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
function hasClass(node, className) {
    if (node.classList) {
        return node.classList.contains(className);
    }
    var originClass = node.className;
    return (' ' + originClass + ' ').indexOf(' ' + className + ' ') > -1;
}
function addClass(node, className) {
    if (node.classList) {
        node.classList.add(className);
    } else {
        if (!hasClass(node, className)) {
            node.className = node.className + ' ' + className;
        }
    }
}
function removeClass(node, className) {
    if (node.classList) {
        node.classList.remove(className);
    } else {
        if (hasClass(node, className)) {
            var originClass = node.className;
            node.className = (' ' + originClass + ' ').replace(' ' + className + ' ', '');
        }
    }
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.KeyboardItem = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(65);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

var _exenv = __webpack_require__(179);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

/**
 * determines whether an array includes a certain value among its entries, returning true or false as appropriate.
 * @param {array} arr The array to search in
 * @param {any} item  The value to search for
 */
function includes(arr, item) {
    if (!arr || !arr.length || !item) {
        return false;
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        if (arr[i] === item) {
            return true;
        }
    }
    return false;
}

var KeyboardItem = exports.KeyboardItem = function (_React$Component) {
    (0, _inherits3['default'])(KeyboardItem, _React$Component);

    function KeyboardItem() {
        (0, _classCallCheck3['default'])(this, KeyboardItem);
        return (0, _possibleConstructorReturn3['default'])(this, (KeyboardItem.__proto__ || Object.getPrototypeOf(KeyboardItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(KeyboardItem, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                prefixCls = _a.prefixCls,
                _onClick = _a.onClick,
                className = _a.className,
                disabled = _a.disabled,
                children = _a.children,
                tdRef = _a.tdRef,
                label = _a.label,
                iconOnly = _a.iconOnly,
                restProps = __rest(_a, ["prefixCls", "onClick", "className", "disabled", "children", "tdRef", "label", "iconOnly"]);
            var value = children;
            if (className === 'keyboard-delete') {
                value = 'delete';
            } else if (className === 'keyboard-hide') {
                value = 'hide';
            } else if (className === 'keyboard-confirm') {
                value = 'confirm';
            }
            var extraCls = (0, _defineProperty3['default'])({}, prefixCls + '-item-disabled', disabled);
            var wrapCls = (0, _classnames2['default'])(prefixCls + '-item', className, extraCls);
            return React.createElement(
                _rmcFeedback2['default'],
                { disabled: disabled, activeClassName: prefixCls + '-item-active' },
                React.createElement(
                    'td',
                    (0, _extends3['default'])({ ref: tdRef
                        // tslint:disable-next-line:jsx-no-multiline-js
                        , onClick: function onClick(e) {
                            _onClick(e, value);
                        }, className: wrapCls }, restProps),
                    children,
                    iconOnly && React.createElement(
                        'i',
                        { className: 'sr-only' },
                        label
                    )
                )
            );
        }
    }]);
    return KeyboardItem;
}(React.Component);

KeyboardItem.defaultProps = {
    prefixCls: 'am-number-keyboard',
    onClick: function onClick() {},
    disabled: false
};

var CustomKeyboard = function (_React$Component2) {
    (0, _inherits3['default'])(CustomKeyboard, _React$Component2);

    function CustomKeyboard() {
        (0, _classCallCheck3['default'])(this, CustomKeyboard);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (CustomKeyboard.__proto__ || Object.getPrototypeOf(CustomKeyboard)).apply(this, arguments));

        _this2.onKeyboardClick = function (e) {
            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

            e.nativeEvent.stopImmediatePropagation();
            if (_this2.props.disabledKeys && includes(_this2.props.disabledKeys, value)) {
                return null;
            }
            if (value === 'confirm' && _this2.confirmDisabled) {
                return null;
            } else {
                if (_this2.linkedInput) {
                    _this2.linkedInput.onKeyboardClick(value);
                }
            }
        };
        _this2.renderKeyboardItem = function (item, index) {
            var disabled = false;
            if (_this2.props.disabledKeys && includes(_this2.props.disabledKeys, item)) {
                disabled = true;
            }
            return React.createElement(
                KeyboardItem,
                { onClick: _this2.onKeyboardClick, key: 'item-' + item + '-' + index, disabled: disabled },
                item
            );
        };
        return _this2;
    }

    (0, _createClass3['default'])(CustomKeyboard, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                confirmLabel = _props.confirmLabel,
                backspaceLabel = _props.backspaceLabel,
                cancelKeyboardLabel = _props.cancelKeyboardLabel,
                wrapProps = _props.wrapProps,
                header = _props.header;

            var wrapperCls = (0, _classnames2['default'])(prefixCls + '-wrapper', prefixCls + '-wrapper-hide');
            return React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapperCls, ref: function ref(el) {
                        return _this3.antmKeyboard = el;
                    } }, wrapProps),
                header && React.cloneElement(header, { onClick: this.onKeyboardClick }),
                React.createElement(
                    'table',
                    null,
                    React.createElement(
                        'tbody',
                        null,
                        React.createElement(
                            'tr',
                            null,
                            ['1', '2', '3'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(KeyboardItem, (0, _extends3['default'])({ className: 'keyboard-delete', rowSpan: 2, onClick: this.onKeyboardClick }, this.getAriaAttr(backspaceLabel)))
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['4', '5', '6'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            })
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['7', '8', '9'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(
                                KeyboardItem,
                                { className: 'keyboard-confirm', rowSpan: 2, onClick: this.onKeyboardClick, tdRef: function tdRef(el) {
                                        return _this3.confirmKeyboardItem = el;
                                    } },
                                confirmLabel
                            )
                        ),
                        React.createElement(
                            'tr',
                            null,
                            ['.', '0'].map(function (item, index) {
                                return (
                                    // tslint:disable-next-line:jsx-no-multiline-js
                                    _this3.renderKeyboardItem(item, index)
                                );
                            }),
                            React.createElement(KeyboardItem, (0, _extends3['default'])({ className: 'keyboard-hide', onClick: this.onKeyboardClick }, this.getAriaAttr(cancelKeyboardLabel)))
                        )
                    )
                )
            );
        }
    }, {
        key: 'getAriaAttr',
        value: function getAriaAttr(label) {
            if (_exenv.IS_IOS) {
                return { label: label, iconOnly: true };
            } else {
                return { role: 'button', 'aria-label': label };
            }
        }
    }]);
    return CustomKeyboard;
}(React.Component);

CustomKeyboard.defaultProps = {
    prefixCls: 'am-number-keyboard',
    disabledKeys: null
};
exports['default'] = CustomKeyboard;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createPortal = ReactDOM.createPortal;

var Portal = function (_React$Component) {
    (0, _inherits3['default'])(Portal, _React$Component);

    function Portal(props) {
        (0, _classCallCheck3['default'])(this, Portal);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props));

        _this.container = _this.props.getContainer();
        return _this;
    }

    (0, _createClass3['default'])(Portal, [{
        key: 'render',
        value: function render() {
            if (this.props.children) {
                return createPortal(this.props.children, this.container);
            }
            return null;
        }
    }]);
    return Portal;
}(React.Component);

exports['default'] = Portal;
module.exports = exports['default'];

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Input = function (_React$Component) {
    (0, _inherits3["default"])(Input, _React$Component);

    function Input() {
        (0, _classCallCheck3["default"])(this, Input);

        var _this = (0, _possibleConstructorReturn3["default"])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));

        _this.onInputBlur = function (e) {
            var value = e.target.value;
            if (_this.props.onBlur) {
                _this.props.onBlur(value);
            }
        };
        _this.onInputFocus = function (e) {
            // here should have a value definition but none.
            var value = e.target.value;
            if (_this.props.onFocus) {
                _this.props.onFocus(value);
            }
        };
        _this.focus = function () {
            if (_this.inputRef) {
                _this.inputRef.focus();
            }
        };
        return _this;
    }

    (0, _createClass3["default"])(Input, [{
        key: "render",
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                onBlur = _a.onBlur,
                onFocus = _a.onFocus,
                restProps = __rest(_a, ["onBlur", "onFocus"]);
            return React.createElement("input", (0, _extends3["default"])({ ref: function ref(el) {
                    return _this2.inputRef = el;
                }, onBlur: this.onInputBlur, onFocus: this.onInputFocus }, restProps));
        }
    }]);
    return Input;
}(React.Component);

exports["default"] = Input;
module.exports = exports["default"];

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    confirmLabel: '确定',
    backspaceLabel: '退格',
    cancelKeyboardLabel: '收起键盘'
};
module.exports = exports['default'];

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Brief = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames5 = __webpack_require__(16);

var _classnames6 = _interopRequireDefault(_classnames5);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _rmcFeedback = __webpack_require__(65);

var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};
/* tslint:disable:jsx-no-multiline-js */

var Brief = exports.Brief = function (_React$Component) {
    (0, _inherits3['default'])(Brief, _React$Component);

    function Brief() {
        (0, _classCallCheck3['default'])(this, Brief);
        return (0, _possibleConstructorReturn3['default'])(this, (Brief.__proto__ || Object.getPrototypeOf(Brief)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Brief, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: 'am-list-brief', style: this.props.style },
                this.props.children
            );
        }
    }]);
    return Brief;
}(React.Component);

var ListItem = function (_React$Component2) {
    (0, _inherits3['default'])(ListItem, _React$Component2);

    function ListItem(props) {
        (0, _classCallCheck3['default'])(this, ListItem);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).call(this, props));

        _this2.onClick = function (ev) {
            var _this2$props = _this2.props,
                onClick = _this2$props.onClick,
                platform = _this2$props.platform;

            var isAndroid = platform === 'android';
            if (!!onClick && isAndroid) {
                if (_this2.debounceTimeout) {
                    clearTimeout(_this2.debounceTimeout);
                    _this2.debounceTimeout = null;
                }
                var Item = ev.currentTarget;
                var RippleWidth = Math.max(Item.offsetHeight, Item.offsetWidth);
                var ClientRect = ev.currentTarget.getBoundingClientRect();
                var pointX = ev.clientX - ClientRect.left - Item.offsetWidth / 2;
                var pointY = ev.clientY - ClientRect.top - Item.offsetWidth / 2;
                var coverRippleStyle = {
                    width: RippleWidth + 'px',
                    height: RippleWidth + 'px',
                    left: pointX + 'px',
                    top: pointY + 'px'
                };
                _this2.setState({
                    coverRippleStyle: coverRippleStyle,
                    RippleClicked: true
                }, function () {
                    _this2.debounceTimeout = setTimeout(function () {
                        _this2.setState({
                            coverRippleStyle: { display: 'none' },
                            RippleClicked: false
                        });
                    }, 1000);
                });
            }
            if (onClick) {
                onClick(ev);
            }
        };
        _this2.state = {
            coverRippleStyle: { display: 'none' },
            RippleClicked: false
        };
        return _this2;
    }

    (0, _createClass3['default'])(ListItem, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
                this.debounceTimeout = null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames3,
                _classnames4,
                _this3 = this;

            var _a = this.props,
                prefixCls = _a.prefixCls,
                className = _a.className,
                activeStyle = _a.activeStyle,
                error = _a.error,
                align = _a.align,
                wrap = _a.wrap,
                disabled = _a.disabled,
                children = _a.children,
                multipleLine = _a.multipleLine,
                thumb = _a.thumb,
                extra = _a.extra,
                arrow = _a.arrow,
                onClick = _a.onClick,
                restProps = __rest(_a, ["prefixCls", "className", "activeStyle", "error", "align", "wrap", "disabled", "children", "multipleLine", "thumb", "extra", "arrow", "onClick"]);var platform = restProps.platform,
                otherProps = __rest(restProps, ["platform"]);var _state = this.state,
                coverRippleStyle = _state.coverRippleStyle,
                RippleClicked = _state.RippleClicked;

            var wrapCls = (0, _classnames6['default'])(prefixCls + '-item', className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-disabled', disabled), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-error', error), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-top', align === 'top'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-middle', align === 'middle'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-item-bottom', align === 'bottom'), _classnames));
            var rippleCls = (0, _classnames6['default'])(prefixCls + '-ripple', (0, _defineProperty3['default'])({}, prefixCls + '-ripple-animate', RippleClicked));
            var lineCls = (0, _classnames6['default'])(prefixCls + '-line', (_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, prefixCls + '-line-multiple', multipleLine), (0, _defineProperty3['default'])(_classnames3, prefixCls + '-line-wrap', wrap), _classnames3));
            var arrowCls = (0, _classnames6['default'])(prefixCls + '-arrow', (_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-horizontal', arrow === 'horizontal'), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-vertical', arrow === 'down' || arrow === 'up'), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-arrow-vertical-up', arrow === 'up'), _classnames4));
            var content = React.createElement(
                'div',
                (0, _extends3['default'])({}, otherProps, { onClick: function onClick(ev) {
                        _this3.onClick(ev);
                    }, className: wrapCls }),
                thumb ? React.createElement(
                    'div',
                    { className: prefixCls + '-thumb' },
                    typeof thumb === 'string' ? React.createElement('img', { src: thumb }) : thumb
                ) : null,
                React.createElement(
                    'div',
                    { className: lineCls },
                    children !== undefined && React.createElement(
                        'div',
                        { className: prefixCls + '-content' },
                        children
                    ),
                    extra !== undefined && React.createElement(
                        'div',
                        { className: prefixCls + '-extra' },
                        extra
                    ),
                    arrow && React.createElement('div', { className: arrowCls, 'aria-hidden': 'true' })
                ),
                React.createElement('div', { style: coverRippleStyle, className: rippleCls })
            );
            var touchProps = {};
            Object.keys(otherProps).forEach(function (key) {
                if (/onTouch/i.test(key)) {
                    touchProps[key] = otherProps[key];
                    delete otherProps[key];
                }
            });
            return React.createElement(
                _rmcFeedback2['default'],
                (0, _extends3['default'])({}, touchProps, { disabled: disabled || !onClick, activeStyle: activeStyle, activeClassName: prefixCls + '-item-active' }),
                content
            );
        }
    }]);
    return ListItem;
}(React.Component);

ListItem.defaultProps = {
    prefixCls: 'am-list',
    align: 'middle',
    error: false,
    multipleLine: false,
    wrap: false,
    platform: 'ios'
};
ListItem.Brief = Brief;
exports['default'] = ListItem;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(299);

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 301 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(47);

__webpack_require__(305);

/***/ }),
/* 304 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(308), __esModule: true };

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(77);
__webpack_require__(309);
module.exports = __webpack_require__(24).Array.from;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(62);
var $export = __webpack_require__(46);
var toObject = __webpack_require__(75);
var call = __webpack_require__(184);
var isArrayIter = __webpack_require__(185);
var toLength = __webpack_require__(111);
var createProperty = __webpack_require__(310);
var getIterFn = __webpack_require__(129);

$export($export.S + $export.F * !__webpack_require__(186)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(50);
var createDesc = __webpack_require__(72);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(5);
var factory = __webpack_require__(312);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(187);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(23);

var _validator = __webpack_require__(314);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(334);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(315);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(321);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(322);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(323);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(324);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(325);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(326);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(327);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(328);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(329);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(330);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(331);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(332);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(333);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(188);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(23);

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(38);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(131),
    toKey = __webpack_require__(139);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(95),
    isSymbol = __webpack_require__(132);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 339 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(341);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(342);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(343);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(344),
    mapCacheDelete = __webpack_require__(364),
    mapCacheGet = __webpack_require__(366),
    mapCacheHas = __webpack_require__(367),
    mapCacheSet = __webpack_require__(368);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(345),
    ListCache = __webpack_require__(357),
    Map = __webpack_require__(363);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(346),
    hashDelete = __webpack_require__(353),
    hashGet = __webpack_require__(354),
    hashHas = __webpack_require__(355),
    hashSet = __webpack_require__(356);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(348),
    isMasked = __webpack_require__(349),
    isObject = __webpack_require__(138),
    toSource = __webpack_require__(351);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(133),
    isObject = __webpack_require__(138);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(350);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(135);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(97);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(358),
    listCacheDelete = __webpack_require__(359),
    listCacheGet = __webpack_require__(360),
    listCacheHas = __webpack_require__(361),
    listCacheSet = __webpack_require__(362);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(98);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(137),
    root = __webpack_require__(135);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(99);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(99);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(99);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(99);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(370);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(134),
    arrayMap = __webpack_require__(371),
    isArray = __webpack_require__(95),
    isSymbol = __webpack_require__(132);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 372 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(131),
    isArguments = __webpack_require__(374),
    isArray = __webpack_require__(95),
    isIndex = __webpack_require__(192),
    isLength = __webpack_require__(376),
    toKey = __webpack_require__(139);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(375),
    isObjectLike = __webpack_require__(136);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(133),
    isObjectLike = __webpack_require__(136);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 376 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(378),
    castPath = __webpack_require__(131),
    isIndex = __webpack_require__(192),
    isObject = __webpack_require__(138),
    toKey = __webpack_require__(139);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(379),
    eq = __webpack_require__(190);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(380);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(137);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _datePicker = __webpack_require__(101);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _radio = __webpack_require__(79);

var _radio2 = _interopRequireDefault(_radio);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(102);

__webpack_require__(80);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _global = __webpack_require__(42);

var _ImgUpload = __webpack_require__(100);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(395);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function format2Date(date) {
  var pad = function pad(n) {
    return n < 10 ? '0' + n : n;
  };
  var dateStr = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  return '' + dateStr;
}

var CoverThumb = function CoverThumb(props) {
  return _react2.default.createElement(
    'div',
    { className: 'cover-thumb' },
    _react2.default.createElement('img', { src: props.url }),
    _react2.default.createElement(_ImgUpload.ImgUpload, { complete: function complete(url) {
        return props.change(url);
      } })
  );
};

var UserCenter = function (_OfficialPage) {
  (0, _inherits3.default)(UserCenter, _OfficialPage);

  function UserCenter(porps) {
    (0, _classCallCheck3.default)(this, UserCenter);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (UserCenter.__proto__ || Object.getPrototypeOf(UserCenter)).call(this, porps));

    _this2.state = {
      userInfo: {}, // 用户信息
      todayDate: '2018-8-10', // 今天的日期
      userCityArr: ['', ''], // 用户城市信息的集合   [country, pri, city]
      isGetPhoneNumber: false, // 是否获得手机授权
      isFromBack: false,
      collectConfig: {}, // 收集配置
      cardId: '', // 需要领取的会员卡id
      isNoConditionRecv: '', // 是否无门槛领卡
      franchisee: '', // 子店id
      backRouter: '', // 设置返回的路由
      isCantChangeBir: false, // 生日是否可改
      cityCol: 1, // WEBAPP PICKER COL
      cityData: [] // WEBAPP 存放城市数据
    };

    _this2.componentWillMount = function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var cardId = options.id || ''; // 存在cardId即为会员信息保存，否则为个人信息（不校验必填项）
      var isMember = options.is_member || '';
      var isNoConditionRecv = options.is_no_condition_recv || '';
      var r = options.r || '';
      var franchisee = options.franchisee || '';
      _this2.setData({
        cardId: cardId || isMember,
        isNoConditionRecv: isNoConditionRecv,
        backRouter: r,
        franchisee: franchisee
      });
      if (_this2.data.cardId) {
        _app.appMethod.setNavigationBarTitle({
          title: '会员信息'
        });
      }
      _this2.getCollectUserinfoConfig();
      _this2.infoInit();
      _this2.getXcxUserInfo();
      _this2.getCityData(0);
    };

    _this2.componentDidShow = function () {
      if (_this2.data.isFromBack) {
        _this2.getXcxUserInfo();
      } else {
        _this2.setData({
          isFromBack: true
        });
      }
    };

    _this2.getCollectUserinfoConfig = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getCollectUserinfoConfig',
        method: 'post',
        data: {},
        hideLoading: false,
        success: function success(res) {
          _this.setData({
            collectConfig: res.data
          });
        }
      });
    };

    _this2.getXcxUserInfo = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/getXcxUserInfo',
        success: function success(res) {
          if (res.status == 0) {
            var data = res.data;
            that.setData({
              'userInfo.phone': data.phone || ''
            });
          }
        }
      });
    };

    _this2.infoInit = function () {
      var date = new Date();
      var userInfo = _app.appMethod.getUserInfo();
      var userCityArr = [''];
      if (userInfo.birthday === '0000-00-00') {
        userInfo.birthday = '';
      }
      if (userInfo.province && userInfo.city) {
        userCityArr = [userInfo.province, userInfo.city];
      }
      _this2.setData({
        userInfo: userInfo,
        isCantChangeBir: userInfo.birthday && userInfo.birthday != '0000-00-00',
        userCityArr: userCityArr,
        isGetPhoneNumber: userInfo.phone ? true : false,
        todayDate: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
      });
    };

    _this2.choosePhoto = function (url) {
      var that = _this2;
      that.setData({
        'userInfo.cover_thumb': url
      });
    };

    _this2.selectedSex = function (e) {
      _this2.setData({
        'userInfo.sex': e.target.value
      });
    };

    _this2.bindBirthdayChange = function (v) {
      var value = format2Date(v);
      _this2.setData({
        'userInfo.birthday': value
      });
    };

    _this2.bindCityChange = function (v) {
      _this2.setData({
        userCityArr: v
      });
    };

    _this2.inputUserInfo = function (e) {
      var setData = {};
      if (e.currentTarget.dataset.type === 'nickname') {
        setData = { 'userInfo.nickname': e.target.value };
      } else if (e.currentTarget.dataset.type === 'weixinCode') {
        setData = { 'userInfo.weixin_code': e.target.value };
      } else if (e.currentTarget.dataset.type === 'email') {
        setData = { 'userInfo.email': e.target.value };
      } else if (e.currentTarget.dataset.type === 'company') {
        setData = { 'userInfo.company': e.target.value };
      }
      _this2.setData(setData);
    };

    _this2.getPhoneNumber = function (e) {
      if (_this2.data.isGetPhoneNumber) {
        return;
      }
      var _this = _this2;
      _app.appMethod.checkSession(function () {
        if (!e.target.encryptedData) {
          return;
        }
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppUser/GetPhoneNumber',
          data: {
            encryptedData: e.target.encryptedData || '',
            iv: e.target.iv || ''
          },
          success: function success(res) {
            _app.appMethod.setUserInfoStorage({
              phone: res.data
            });
            _this.setData({
              'userInfo.phone': res.data,
              isGetPhoneNumber: true
            });
          },
          successStatus5: function successStatus5() {
            _app.appMethod.showModal({
              content: '获取手机号失败，请再次点击授权获取'
            });
            // app.goLogin({
            //   success: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   },
            //   fail: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   }
            // })
          }
        });
      });
    };

    _this2.bindCellphonePage = function () {
      var page_router = _app.appMethod.getAppCurrentPage().route.split('/').pop();
      if (_this2.data.cardId) {
        // TODO: 后续更改为bindCellphone
        _app.appMethod.turnToPage('bindCellphone?r=' + page_router + '&is_member=1', 1);
      } else {
        // TODO: 后续更改为bindCellphone
        _app.appMethod.turnToPage('bindCellphone?r=' + page_router, 1);
      }
    };

    _this2.saveUserInfo = function (e) {
      var data = _this2.data.userInfo;
      var _this = _this2;
      var config = _this2.data.collectConfig;
      var params = {};
      var cardId = _this2.data.cardId;
      if (cardId && !_this2.validate()) {
        return;
      }
      if (data.email && !_this2.checkEmail(data.email)) {
        return;
      }
      params.nickname = data.nickname;
      params.phone = data.phone;
      params.sex = data.sex;
      params.birthday = data.birthday;
      params.cover_thumb = data.cover_thumb;
      config.collect_company != 0 ? params.company = data.company : '';
      config.collect_email != 0 ? params.email = data.email : '';
      if (config.collect_region != 0) {
        params.province = _this2.data.userCityArr[0];
        params.city = _this2.data.userCityArr[1];
      }
      config.collect_weixin_id != 0 ? params.weixin_code = data.weixin_code : '';
      cardId ? params.formId = e.target.formId : '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/saveUserInfo',
        method: 'post',
        data: params,
        success: function success(res) {
          if (res.status === 0) {
            _app.appMethod.setUserInfoStorage(params);
            if (_this.data.isNoConditionRecv) {
              _this.recvVipCard();
              return;
            }
            _this.savedAction();
          }
        }
      });
    };

    _this2.validate = function () {
      var config = _this2.data.collectConfig;
      var data = _this2.data.userInfo;
      if (config.collect_phone == 2 && !data.phone) {
        _app.appMethod.showModal({
          content: '请完善手机号'
        });
        return false;
      }
      if (config.collect_birthday == 2 && (!data.birthday || data.birthday === '0000-00-00')) {
        _app.appMethod.showModal({
          content: '请完善生日'
        });
        return false;
      }
      if (config.collect_weixin_id == 2 && !data.weixin_code) {
        _app.appMethod.showModal({
          content: '请完善微信号'
        });
        return false;
      }
      if (config.collect_email == 2 && !data.email) {
        _app.appMethod.showModal({
          content: '请完善邮箱'
        });
        return false;
      }
      if (config.collect_company == 2 && !data.company) {
        _app.appMethod.showModal({
          content: '请完善公司'
        });
        return false;
      }
      if (config.collect_region == 2 && !_this2.data.userCityArr[0] && !_this2.data.userCityArr[1]) {
        _app.appMethod.showModal({
          content: '请完善地址'
        });
        return false;
      }
      return true;
    };

    _this2.savedAction = function () {
      _app.appMethod.showToast({
        title: _this2.data.cardId ? '领取成功' : '保存成功',
        icon: 'success'
      });
      setTimeout(function () {
        _app.appMethod.turnToPage(_this2.data.backRouter || '/pages/userCenterComponentPage/userCenterComponentPage');
      }, 1000);
    };

    _this2.checkEmail = function (email) {
      var str = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (str.test(email)) {
        return true;
      } else {
        _app.appMethod.showModal({
          content: '请填写正确的邮箱'
        });
      }
    };

    _this2.recvVipCard = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        data: {
          vipcard_id: _this.data.cardId,
          sub_shop_app_id: _this.data.franchisee
        },
        url: '/index.php?r=AppVipCard/RecvVipCard',
        hideLoading: true,
        success: function success(res) {
          _this.savedAction();
        }
      });
    };

    _this2.times = 0;
    _this2.time = '';

    _this2.getCityData = function (id) {
      _app.appMethod.sendRequest({
        data: {
          pid: id
        },
        url: '/index.php?r=Region/getRegionList',
        success: function success(res) {
          if (id === 0) {
            _this2.setData({
              'cityData': [{
                label: '暂未选择',
                value: ''
              }].concat((0, _toConsumableArray3.default)(res.data.map(function (item) {
                return {
                  id: item.id,
                  label: item.name,
                  value: item.name,
                  children: []
                };
              })))
            });
          } else {
            var index = _this2.data.cityData.findIndex(function (province) {
              return province.id == id;
            });
            if (index > -1) {
              var _this2$setData;

              _this2.setData((_this2$setData = {}, (0, _defineProperty3.default)(_this2$setData, 'cityData[' + index + '].children', res.data.map(function (item) {
                return {
                  label: item.name,
                  value: item.name
                };
              }) || []), (0, _defineProperty3.default)(_this2$setData, 'cityCol', 2), _this2$setData));
            }
          }
          _this2.cityData = [];
        }
      });
    };

    _this2.handleCityDataLoad = function (val) {
      var arr = val;
      // 仅加载市级信息
      if (!arr[0] || arr[1]) {
        return;
      }
      _this2.setData({
        userCityArr: [].concat((0, _toConsumableArray3.default)(arr))
      });
      var index = _this2.data.cityData.findIndex(function (province) {
        return province.value == arr[0];
      });
      if (_this2.data.cityData[index].children.length === 0) {
        _this2.getCityData(_this2.data.cityData[index].id);
      }
    };

    _this2.logout = function () {
      _app.appMethod.showModal({
        content: '确定要退出登录?',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppUser/logout',
            data: {
              app_id: (0, _global.getAppId)()
            },
            success: function success() {
              _app.appMethod.setIsLogin(false);
              _app.appMethod.turnToPage(_app.appMethod.getHomepageRouter());
            }
          });
        },
        showCancel: function showCancel() {}
      });
    };

    document.title = '个人信息';
    return _this2;
  }

  (0, _createClass3.default)(UserCenter, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          collectConfig = _state.collectConfig,
          cardId = _state.cardId,
          userInfo = _state.userInfo,
          todayDate = _state.todayDate,
          isCantChangeBir = _state.isCantChangeBir,
          userCityArr = _state.userCityArr,
          cityCol = _state.cityCol,
          cityData = _state.cityData;

      return _react2.default.createElement(
        'div',
        { className: 'content' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u4E2A\u4EBA\u4FE1\u606F' }),
        _react2.default.createElement(
          'div',
          { className: 'info-wrapper' },
          (!cardId || collectConfig.collect_username && collectConfig.collect_username !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_username === '2' && cardId ? 'star' : '') },
              '\u6635\u79F0'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement('input', {
                style: {
                  width: '4.00rem'
                },
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u6635\u79F0',
                value: userInfo.nickname || '',
                'data-type': 'nickname',
                onInput: this.inputUserInfo,
                onChange: function onChange() {}
              }),
              _react2.default.createElement(CoverThumb, { url: userInfo.cover_thumb, change: function change(url) {
                  return _this3.choosePhoto(url);
                } }),
              _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
            )
          ),
          (!cardId || collectConfig.collect_phone && collectConfig.collect_phone !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_phone === '2' && cardId ? 'star' : '') },
              '\u624B\u673A\u53F7'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block', onClick: this.bindCellphonePage },
              _react2.default.createElement(
                'div',
                null,
                userInfo.phone || '请绑定手机号码'
              ),
              _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
            )
          ),
          (!cardId || collectConfig.collect_sex && collectConfig.collect_sex !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_sex === '2' && cardId ? 'star' : '') },
              '\u6027\u522B'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement(
                'div',
                { className: 'radio-group' },
                _react2.default.createElement(
                  'label',
                  { className: 'radio' },
                  _react2.default.createElement(
                    _radio2.default,
                    {
                      name: 'sex',
                      value: '0',
                      color: '#FF7100',
                      checked: userInfo.sex == 0,
                      onChange: function onChange(e) {
                        return _this3.selectedSex(e);
                      }
                    },
                    '\u7537'
                  )
                ),
                _react2.default.createElement(
                  'label',
                  { className: 'radio' },
                  _react2.default.createElement(
                    _radio2.default,
                    {
                      name: 'sex',
                      value: '1',
                      color: '#FF7100',
                      checked: userInfo.sex == 1,
                      onChange: function onChange(e) {
                        return _this3.selectedSex(e);
                      }
                    },
                    '\u5973'
                  )
                )
              )
            )
          ),
          (!cardId || collectConfig.collect_birthday && collectConfig.collect_birthday !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item birthday-info' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_birthday === '2' && cardId ? 'star' : '') },
              '\u751F\u65E5'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement(
                _datePicker2.default,
                {
                  disabled: isCantChangeBir,
                  mode: 'date',
                  format: 'YYYY-MM-DD',
                  onChange: function onChange(v) {
                    return _this3.bindBirthdayChange(v);
                  },
                  minDate: new Date(1900, 1, 1, 0, 0, 0),
                  maxDate: new Date(2030, 1, 1, 23, 59, 59)
                },
                _react2.default.createElement(
                  'div',
                  { className: 'birthday-picker' },
                  _react2.default.createElement(
                    'div',
                    { className: 'picker' },
                    !userInfo.birthday ? '请选择出生日期' : userInfo.birthday
                  )
                )
              ),
              !isCantChangeBir && _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              _react2.default.createElement(
                'div',
                { className: 'comment' },
                '\u6CE8:\u751F\u65E5\u4FDD\u5B58\u4E4B\u540E\u4E0D\u5141\u8BB8\u4FEE\u6539\uFF0C\u8BF7\u6B63\u786E\u586B\u5199'
              )
            )
          ),
          !!(collectConfig.collect_weixin_id && collectConfig.collect_weixin_id !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_weixin_id === '2' && cardId ? 'star' : '') },
              '\u5FAE\u4FE1\u53F7'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement('input', {
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u5FAE\u4FE1\u53F7',
                value: userInfo.weixin_code,
                'data-type': 'weixinCode',
                onInput: this.inputUserInfo || '',
                onChange: function onChange() {}
              })
            )
          ),
          !!(collectConfig.collect_email && collectConfig.collect_email !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_email === '2' && cardId ? 'star' : '') },
              '\u90AE\u7BB1'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement('input', {
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u90AE\u7BB1',
                value: userInfo.email || '',
                'data-type': 'email',
                onChange: this.inputUserInfo
              })
            )
          ),
          !!(collectConfig.collect_company && collectConfig.collect_company !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_company === '2' && cardId ? 'star' : '') },
              '\u516C\u53F8'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement('input', {
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u516C\u53F8',
                value: userInfo.company || '',
                'data-type': 'company',
                onInput: this.inputUserInfo,
                onChange: function onChange() {}
              })
            )
          ),
          !!(collectConfig.collect_region && collectConfig.collect_region !== '0') && _react2.default.createElement(
            'div',
            { className: 'info-item ' },
            _react2.default.createElement(
              'div',
              { className: 'name ' + (collectConfig.collect_region === '2' && cardId ? 'star' : '') },
              '\u6240\u5728\u5730'
            ),
            _react2.default.createElement(
              'div',
              { className: 'right-block' },
              _react2.default.createElement(
                _picker2.default,
                {
                  data: cityData,
                  value: userCityArr,
                  cols: cityCol,
                  onPickerChange: function onPickerChange(val) {
                    return _this3.handleCityDataLoad(val);
                  },
                  onOk: function onOk(e) {
                    return _this3.bindCityChange(e);
                  }
                },
                _react2.default.createElement(
                  'div',
                  { className: 'picker', style: {
                      color: userCityArr[0] === '' ? '#999' : '#000'
                    } },
                  userCityArr[0] === '' ? '请填写所在城市' : userCityArr.join('')
                )
              ),
              _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tip' },
          '\u8BF7\u5B8C\u5584\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u6211\u4EEC\u4E3A\u4F60\u63D0\u4F9B\u66F4\u597D\u7684\u4F1A\u5458\u670D\u52A1'
        ),
        _react2.default.createElement(
          'button',
          { className: 'save-btn', onClick: this.saveUserInfo },
          cardId ? '立即领取' : '保存'
        ),
        _react2.default.createElement(
          'button',
          { className: 'logout-btn', onClick: this.logout },
          '\u9000\u51FA\u767B\u5F55'
        )
      );
    }
  }]);
  return UserCenter;
}(_OfficialPage3.default);

exports.default = UserCenter;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _MultiPicker = __webpack_require__(93);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(94);

var _Picker2 = _interopRequireDefault(_Picker);

var _en_US = __webpack_require__(386);

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDaysInMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}
function pad(n) {
    return n < 10 ? '0' + n : n + '';
}
function cloneDate(date) {
    return new Date(+date);
}
function setMonth(date, month) {
    date.setDate(Math.min(date.getDate(), getDaysInMonth(new Date(date.getFullYear(), month))));
    date.setMonth(month);
}
var DATETIME = 'datetime';
var DATE = 'date';
var TIME = 'time';
var MONTH = 'month';
var YEAR = 'year';
var ONE_DAY = 24 * 60 * 60 * 1000;

var DatePicker = function (_React$Component) {
    (0, _inherits3['default'])(DatePicker, _React$Component);

    function DatePicker() {
        (0, _classCallCheck3['default'])(this, DatePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));

        _this.state = {
            date: _this.props.date || _this.props.defaultDate
        };
        _this.getNewDate = function (values, index) {
            var value = parseInt(values[index], 10);
            var props = _this.props;
            var mode = props.mode;

            var newValue = cloneDate(_this.getDate());
            if (mode === DATETIME || mode === DATE || mode === YEAR || mode === MONTH) {
                switch (index) {
                    case 0:
                        newValue.setFullYear(value);
                        break;
                    case 1:
                        // Note: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth
                        // e.g. from 2017-03-31 to 2017-02-28
                        setMonth(newValue, value);
                        break;
                    case 2:
                        newValue.setDate(value);
                        break;
                    case 3:
                        _this.setHours(newValue, value);
                        break;
                    case 4:
                        newValue.setMinutes(value);
                        break;
                    case 5:
                        _this.setAmPm(newValue, value);
                        break;
                    default:
                        break;
                }
            } else if (mode === TIME) {
                switch (index) {
                    case 0:
                        _this.setHours(newValue, value);
                        break;
                    case 1:
                        newValue.setMinutes(value);
                        break;
                    case 2:
                        _this.setAmPm(newValue, value);
                        break;
                    default:
                        break;
                }
            }
            return _this.clipDate(newValue);
        };
        _this.onValueChange = function (values, index) {
            var props = _this.props;
            var newValue = _this.getNewDate(values, index);
            if (!('date' in props)) {
                _this.setState({
                    date: newValue
                });
            }
            if (props.onDateChange) {
                props.onDateChange(newValue);
            }
            if (props.onValueChange) {
                props.onValueChange(values, index);
            }
        };
        _this.onScrollChange = function (values, index) {
            var props = _this.props;
            if (props.onScrollChange) {
                var newValue = _this.getNewDate(values, index);
                props.onScrollChange(newValue, values, index);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(DatePicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if ('date' in nextProps) {
                this.setState({
                    date: nextProps.date || nextProps.defaultDate
                });
            }
        }
    }, {
        key: 'setHours',
        value: function setHours(date, hour) {
            if (this.props.use12Hours) {
                var dh = date.getHours();
                var nhour = hour;
                nhour = dh >= 12 ? hour + 12 : hour;
                nhour = nhour >= 24 ? 0 : nhour; // Make sure no more than one day
                date.setHours(nhour);
            } else {
                date.setHours(hour);
            }
        }
    }, {
        key: 'setAmPm',
        value: function setAmPm(date, index) {
            if (index === 0) {
                date.setTime(+date - ONE_DAY / 2);
            } else {
                date.setTime(+date + ONE_DAY / 2);
            }
        }
    }, {
        key: 'getDefaultMinDate',
        value: function getDefaultMinDate() {
            if (!this.defaultMinDate) {
                this.defaultMinDate = new Date(2000, 1, 1, 0, 0, 0);
            }
            return this.defaultMinDate;
        }
    }, {
        key: 'getDefaultMaxDate',
        value: function getDefaultMaxDate() {
            if (!this.defaultMaxDate) {
                this.defaultMaxDate = new Date(2030, 1, 1, 23, 59, 59);
            }
            return this.defaultMaxDate;
        }
    }, {
        key: 'getDate',
        value: function getDate() {
            return this.clipDate(this.state.date || this.getDefaultMinDate());
        }
        // used by rmc-picker/lib/PopupMixin.js

    }, {
        key: 'getValue',
        value: function getValue() {
            return this.getDate();
        }
    }, {
        key: 'getMinYear',
        value: function getMinYear() {
            return this.getMinDate().getFullYear();
        }
    }, {
        key: 'getMaxYear',
        value: function getMaxYear() {
            return this.getMaxDate().getFullYear();
        }
    }, {
        key: 'getMinMonth',
        value: function getMinMonth() {
            return this.getMinDate().getMonth();
        }
    }, {
        key: 'getMaxMonth',
        value: function getMaxMonth() {
            return this.getMaxDate().getMonth();
        }
    }, {
        key: 'getMinDay',
        value: function getMinDay() {
            return this.getMinDate().getDate();
        }
    }, {
        key: 'getMaxDay',
        value: function getMaxDay() {
            return this.getMaxDate().getDate();
        }
    }, {
        key: 'getMinHour',
        value: function getMinHour() {
            return this.getMinDate().getHours();
        }
    }, {
        key: 'getMaxHour',
        value: function getMaxHour() {
            return this.getMaxDate().getHours();
        }
    }, {
        key: 'getMinMinute',
        value: function getMinMinute() {
            return this.getMinDate().getMinutes();
        }
    }, {
        key: 'getMaxMinute',
        value: function getMaxMinute() {
            return this.getMaxDate().getMinutes();
        }
    }, {
        key: 'getMinDate',
        value: function getMinDate() {
            return this.props.minDate || this.getDefaultMinDate();
        }
    }, {
        key: 'getMaxDate',
        value: function getMaxDate() {
            return this.props.maxDate || this.getDefaultMaxDate();
        }
    }, {
        key: 'getDateData',
        value: function getDateData() {
            var _props = this.props,
                locale = _props.locale,
                formatMonth = _props.formatMonth,
                formatDay = _props.formatDay,
                mode = _props.mode;

            var date = this.getDate();
            var selYear = date.getFullYear();
            var selMonth = date.getMonth();
            var minDateYear = this.getMinYear();
            var maxDateYear = this.getMaxYear();
            var minDateMonth = this.getMinMonth();
            var maxDateMonth = this.getMaxMonth();
            var minDateDay = this.getMinDay();
            var maxDateDay = this.getMaxDay();
            var years = [];
            for (var i = minDateYear; i <= maxDateYear; i++) {
                years.push({
                    value: i + '',
                    label: i + locale.year + ''
                });
            }
            var yearCol = { key: 'year', props: { children: years } };
            if (mode === YEAR) {
                return [yearCol];
            }
            var months = [];
            var minMonth = 0;
            var maxMonth = 11;
            if (minDateYear === selYear) {
                minMonth = minDateMonth;
            }
            if (maxDateYear === selYear) {
                maxMonth = maxDateMonth;
            }
            for (var _i = minMonth; _i <= maxMonth; _i++) {
                var label = formatMonth ? formatMonth(_i, date) : _i + 1 + locale.month + '';
                months.push({
                    value: _i + '',
                    label: label
                });
            }
            var monthCol = { key: 'month', props: { children: months } };
            if (mode === MONTH) {
                return [yearCol, monthCol];
            }
            var days = [];
            var minDay = 1;
            var maxDay = getDaysInMonth(date);
            if (minDateYear === selYear && minDateMonth === selMonth) {
                minDay = minDateDay;
            }
            if (maxDateYear === selYear && maxDateMonth === selMonth) {
                maxDay = maxDateDay;
            }
            for (var _i2 = minDay; _i2 <= maxDay; _i2++) {
                var _label = formatDay ? formatDay(_i2, date) : _i2 + locale.day + '';
                days.push({
                    value: _i2 + '',
                    label: _label
                });
            }
            return [yearCol, monthCol, { key: 'day', props: { children: days } }];
        }
    }, {
        key: 'getDisplayHour',
        value: function getDisplayHour(rawHour) {
            // 12 hour am (midnight 00:00) -> 12 hour pm (noon 12:00) -> 12 hour am (midnight 00:00)
            if (this.props.use12Hours) {
                if (rawHour === 0) {
                    rawHour = 12;
                }
                if (rawHour > 12) {
                    rawHour -= 12;
                }
                return rawHour;
            }
            return rawHour;
        }
    }, {
        key: 'getTimeData',
        value: function getTimeData(date) {
            var _props2 = this.props,
                _props2$minHour = _props2.minHour,
                minHour = _props2$minHour === undefined ? 0 : _props2$minHour,
                _props2$maxHour = _props2.maxHour,
                maxHour = _props2$maxHour === undefined ? 23 : _props2$maxHour,
                _props2$minMinute = _props2.minMinute,
                minMinute = _props2$minMinute === undefined ? 0 : _props2$minMinute,
                _props2$maxMinute = _props2.maxMinute,
                maxMinute = _props2$maxMinute === undefined ? 59 : _props2$maxMinute;
            var _props3 = this.props,
                mode = _props3.mode,
                locale = _props3.locale,
                minuteStep = _props3.minuteStep,
                use12Hours = _props3.use12Hours;

            var minDateMinute = this.getMinMinute();
            var maxDateMinute = this.getMaxMinute();
            var minDateHour = this.getMinHour();
            var maxDateHour = this.getMaxHour();
            var hour = date.getHours();
            if (mode === DATETIME) {
                var year = date.getFullYear();
                var month = date.getMonth();
                var day = date.getDate();
                var minDateYear = this.getMinYear();
                var maxDateYear = this.getMaxYear();
                var minDateMonth = this.getMinMonth();
                var maxDateMonth = this.getMaxMonth();
                var minDateDay = this.getMinDay();
                var maxDateDay = this.getMaxDay();
                if (minDateYear === year && minDateMonth === month && minDateDay === day) {
                    minHour = minDateHour;
                    if (minDateHour === hour) {
                        minMinute = minDateMinute;
                    }
                }
                if (maxDateYear === year && maxDateMonth === month && maxDateDay === day) {
                    maxHour = maxDateHour;
                    if (maxDateHour === hour) {
                        maxMinute = maxDateMinute;
                    }
                }
            } else {
                minHour = minDateHour;
                if (minDateHour === hour) {
                    minMinute = minDateMinute;
                }
                maxHour = maxDateHour;
                if (maxDateHour === hour) {
                    maxMinute = maxDateMinute;
                }
            }
            var hours = [];
            if (minHour === 0 && maxHour === 0 || minHour !== 0 && maxHour !== 0) {
                minHour = this.getDisplayHour(minHour);
            } else if (minHour === 0 && use12Hours) {
                minHour = 1;
                hours.push({ value: '0', label: locale.hour ? '12' + locale.hour : '12' });
            }
            maxHour = this.getDisplayHour(maxHour);
            for (var i = minHour; i <= maxHour; i++) {
                hours.push({
                    value: i + '',
                    label: locale.hour ? i + locale.hour + '' : pad(i)
                });
            }
            var minutes = [];
            var selMinute = date.getMinutes();
            for (var _i3 = minMinute; _i3 <= maxMinute; _i3 += minuteStep) {
                minutes.push({
                    value: _i3 + '',
                    label: locale.minute ? _i3 + locale.minute + '' : pad(_i3)
                });
                if (selMinute > _i3 && selMinute < _i3 + minuteStep) {
                    minutes.push({
                        value: selMinute + '',
                        label: locale.minute ? selMinute + locale.minute + '' : pad(selMinute)
                    });
                }
            }
            var cols = [{ key: 'hours', props: { children: hours } }, { key: 'minutes', props: { children: minutes } }].concat(use12Hours ? [{
                key: 'ampm',
                props: { children: [{ value: '0', label: locale.am }, { value: '1', label: locale.pm }] }
            }] : []);
            return { cols: cols, selMinute: selMinute };
        }
    }, {
        key: 'clipDate',
        value: function clipDate(date) {
            var mode = this.props.mode;

            var minDate = this.getMinDate();
            var maxDate = this.getMaxDate();
            if (mode === DATETIME) {
                if (date < minDate) {
                    return cloneDate(minDate);
                }
                if (date > maxDate) {
                    return cloneDate(maxDate);
                }
            } else if (mode === DATE || mode === YEAR || mode === MONTH) {
                // compare-two-dates: https://stackoverflow.com/a/14629978/2190503
                if (+date + ONE_DAY <= minDate) {
                    return cloneDate(minDate);
                }
                if (date >= +maxDate + ONE_DAY) {
                    return cloneDate(maxDate);
                }
            } else if (mode === TIME) {
                var maxHour = maxDate.getHours();
                var maxMinutes = maxDate.getMinutes();
                var minHour = minDate.getHours();
                var minMinutes = minDate.getMinutes();
                var hour = date.getHours();
                var minutes = date.getMinutes();
                if (hour < minHour || hour === minHour && minutes < minMinutes) {
                    return cloneDate(minDate);
                }
                if (hour > maxHour || hour === maxHour && minutes > maxMinutes) {
                    return cloneDate(maxDate);
                }
            }
            return date;
        }
    }, {
        key: 'getValueCols',
        value: function getValueCols() {
            var _props4 = this.props,
                mode = _props4.mode,
                use12Hours = _props4.use12Hours;

            var date = this.getDate();
            var cols = [];
            var value = [];
            if (mode === YEAR) {
                return {
                    cols: this.getDateData(),
                    value: [date.getFullYear() + '']
                };
            }
            if (mode === MONTH) {
                return {
                    cols: this.getDateData(),
                    value: [date.getFullYear() + '', date.getMonth() + '']
                };
            }
            if (mode === DATETIME || mode === DATE) {
                cols = this.getDateData();
                value = [date.getFullYear() + '', date.getMonth() + '', date.getDate() + ''];
            }
            if (mode === DATETIME || mode === TIME) {
                var time = this.getTimeData(date);
                cols = cols.concat(time.cols);
                var hour = date.getHours();
                var dtValue = [hour + '', time.selMinute + ''];
                var nhour = hour;
                if (use12Hours) {
                    nhour = hour > 12 ? hour - 12 : hour;
                    dtValue = [nhour + '', time.selMinute + '', (hour >= 12 ? 1 : 0) + ''];
                }
                value = value.concat(dtValue);
            }
            return {
                value: value,
                cols: cols
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _getValueCols = this.getValueCols(),
                value = _getValueCols.value,
                cols = _getValueCols.cols;

            var _props5 = this.props,
                disabled = _props5.disabled,
                pickerPrefixCls = _props5.pickerPrefixCls,
                prefixCls = _props5.prefixCls,
                rootNativeProps = _props5.rootNativeProps,
                className = _props5.className,
                style = _props5.style,
                itemStyle = _props5.itemStyle;

            var multiStyle = (0, _extends3['default'])({ flexDirection: 'row', alignItems: 'center' }, style);
            return _react2['default'].createElement(_MultiPicker2['default'], { style: multiStyle, rootNativeProps: rootNativeProps, className: className, prefixCls: prefixCls, selectedValue: value, onValueChange: this.onValueChange, onScrollChange: this.onScrollChange }, cols.map(function (p) {
                return _react2['default'].createElement(_Picker2['default'], { style: { flex: 1 }, key: p.key, disabled: disabled, prefixCls: pickerPrefixCls, itemStyle: itemStyle }, p.props.children.map(function (item) {
                    return _react2['default'].createElement(_Picker2['default'].Item, { key: item.value, value: item.value }, item.label);
                }));
            }));
        }
    }]);
    return DatePicker;
}(_react2['default'].Component);

DatePicker.defaultProps = {
    prefixCls: 'rmc-date-picker',
    pickerPrefixCls: 'rmc-picker',
    locale: _en_US2['default'],
    mode: DATE,
    disabled: false,
    minuteStep: 1,
    onDateChange: function onDateChange() {},

    use12Hours: false
};
exports['default'] = DatePicker;
module.exports = exports['default'];

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '',
    month: '',
    day: '',
    hour: '',
    minute: '',
    am: 'AM',
    pm: 'PM'
};
module.exports = exports['default'];

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _Popup = __webpack_require__(178);

var _Popup2 = _interopRequireDefault(_Popup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PopupDatePicker = function (_React$Component) {
    (0, _inherits3['default'])(PopupDatePicker, _React$Component);

    function PopupDatePicker() {
        (0, _classCallCheck3['default'])(this, PopupDatePicker);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PopupDatePicker.__proto__ || Object.getPrototypeOf(PopupDatePicker)).apply(this, arguments));

        _this.onOk = function (v) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                onOk = _this$props.onOk;

            if (onChange) {
                onChange(v);
            }
            if (onOk) {
                onOk(v);
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(PopupDatePicker, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement(_Popup2['default'], (0, _extends3['default'])({ picker: this.props.datePicker, value: this.props.date }, this.props, { onOk: this.onOk }));
        }
    }]);
    return PopupDatePicker;
}(_react2['default'].Component);

PopupDatePicker.defaultProps = {
    pickerValueProp: 'date',
    pickerValueChangeProp: 'onDateChange'
};
exports['default'] = PopupDatePicker;
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.formatFn = formatFn;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function formatIt(date, form) {
    var pad = function pad(n) {
        return n < 10 ? '0' + n : n;
    };
    var dateStr = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
    var timeStr = pad(date.getHours()) + ':' + pad(date.getMinutes());
    if (form === 'YYYY-MM-DD') {
        return dateStr;
    }
    if (form === 'HH:mm') {
        return timeStr;
    }
    return dateStr + ' ' + timeStr;
}
function formatFn(instance, value) {
    var formatsEnum = {
        date: 'YYYY-MM-DD',
        time: 'HH:mm',
        datetime: 'YYYY-MM-DD HH:mm'
    };
    var format = instance.props.format;

    var type = typeof format === 'undefined' ? 'undefined' : (0, _typeof3['default'])(format);
    if (type === 'string') {
        return formatIt(value, format);
    }
    if (type === 'function') {
        return format(value);
    }
    return formatIt(value, formatsEnum[instance.props.mode]);
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _zh_CN = __webpack_require__(390);

var _zh_CN2 = _interopRequireDefault(_zh_CN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    okText: '确定',
    dismissText: '取消',
    extra: '请选择',
    DatePickerLocale: _zh_CN2['default']
};
module.exports = exports['default'];

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '年',
    month: '月',
    day: '日',
    hour: '时',
    minute: '分',
    am: '上午',
    pm: '下午'
};
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentWithPureRenderMixin
 */
var shallowEqual = __webpack_require__(392);

function shallowCompare(instance, nextProps, nextState) {
  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
}
/**
 * If your React component's render function is "pure", e.g. it will render the
 * same result given the same props and state, provide this mixin for a
 * considerable performance boost.
 *
 * Most React components have pure render functions.
 *
 * Example:
 *
 *   var ReactComponentWithPureRenderMixin =
 *     require('ReactComponentWithPureRenderMixin');
 *   React.createClass({
 *     mixins: [ReactComponentWithPureRenderMixin],
 *
 *     render: function() {
 *       return <div className={this.props.className}>foo</div>;
 *     }
 *   });
 *
 * Note: This only checks shallow equality for props and state. If these contain
 * complex data structures this mixin may have false-negatives for deeper
 * differences. Only mixin to components which have simple props and state, or
 * use `forceUpdate()` when you know deep data structures have changed.
 *
 * See https://facebook.github.io/react/docs/pure-render-mixin.html
 */


var ReactComponentWithPureRenderMixin = {
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
};
module.exports = ReactComponentWithPureRenderMixin;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _Radio = __webpack_require__(194);

var _Radio2 = _interopRequireDefault(_Radio);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ListItem = _list2['default'].Item;
function noop() {}

var RadioItem = function (_React$Component) {
    (0, _inherits3['default'])(RadioItem, _React$Component);

    function RadioItem() {
        (0, _classCallCheck3['default'])(this, RadioItem);
        return (0, _possibleConstructorReturn3['default'])(this, (RadioItem.__proto__ || Object.getPrototypeOf(RadioItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(RadioItem, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                listPrefixCls = _a.listPrefixCls,
                onChange = _a.onChange,
                disabled = _a.disabled,
                radioProps = _a.radioProps,
                onClick = _a.onClick,
                otherProps = __rest(_a, ["listPrefixCls", "onChange", "disabled", "radioProps", "onClick"]);var prefixCls = otherProps.prefixCls,
                className = otherProps.className,
                children = otherProps.children;

            var wrapCls = (0, _classnames3['default'])(prefixCls + '-item', className, (0, _defineProperty3['default'])({}, prefixCls + '-item-disabled', disabled === true));
            // Note: if not omit `onChange`, it will trigger twice on check listitem
            if (!disabled) {
                otherProps.onClick = onClick || noop;
            }
            var extraProps = {};
            ['name', 'defaultChecked', 'checked', 'onChange', 'disabled'].forEach(function (i) {
                if (i in _this2.props) {
                    extraProps[i] = _this2.props[i];
                }
            });
            return React.createElement(
                ListItem,
                (0, _extends3['default'])({}, otherProps, { prefixCls: listPrefixCls, className: wrapCls, extra: React.createElement(_Radio2['default'], (0, _extends3['default'])({}, radioProps, extraProps)) }),
                children
            );
        }
    }]);
    return RadioItem;
}(React.Component);

exports['default'] = RadioItem;

RadioItem.defaultProps = {
    prefixCls: 'am-radio',
    listPrefixCls: 'am-list',
    radioProps: {}
};
module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(126);

var _button2 = _interopRequireDefault(_button);

var _whiteSpace = __webpack_require__(180);

var _whiteSpace2 = _interopRequireDefault(_whiteSpace);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(128);

__webpack_require__(182);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rcForm = __webpack_require__(183);

var _global = __webpack_require__(42);

var _tools = __webpack_require__(6);

var _http = __webpack_require__(36);

__webpack_require__(397);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 定时器
var timer = null;

var BindPhonePage = function (_React$Component) {
  (0, _inherits3.default)(BindPhonePage, _React$Component);

  function BindPhonePage(props) {
    (0, _classCallCheck3.default)(this, BindPhonePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BindPhonePage.__proto__ || Object.getPrototypeOf(BindPhonePage)).call(this, props));

    _this.state = {
      picCode: '',
      picCodeUrl: '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000),
      identifyCode: '',
      verifying: false,
      time: 60,
      nextSteping: false,
      currentStep: 0,
      newPhone: '',
      binding: false
    };

    _this.handleChange = function (name, event) {
      _this.setState((0, _defineProperty3.default)({}, name, event.target.value));
    };

    _this.getPicCode = function () {
      _this.setState({
        picCodeUrl: '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.getIdentifyCode = function () {
      if (_this.state.verifying) {
        return;
      }
      if (!_this.state.picCode) {
        _toast2.default.info('请输入图形验证码');
        return;
      }
      // 第二步才验证
      if (_this.state.currentStep === 1 && !(0, _tools.checkIfPhone)(_this.state.newPhone)) {
        _toast2.default.info('请输入正确的手机号');
        return;
      }
      _this.setState({
        verifying: true,
        time: 60
      });
      var url = '';
      var data = {
        app_id: (0, _global.getAppId)(),
        pic_code: _this.state.picCode
      };
      if (_this.state.currentStep === 0) {
        url = '/index.php?r=AppData/PhoneCode';
      } else if (_this.state.currentStep === 1) {
        url = '/index.php?r=AppData/NewPhoneCode';
        data['phone'] = _this.state.newPhone;
      }
      (0, _http.ajax)({
        url: url,
        data: data,
        success: function success() {
          timer = setInterval(function () {
            if (_this.state.time === 0) {
              clearInterval(timer);
              _this.setState({
                verifying: false,
                time: 60
              });
            }
            _this.setState({
              time: --_this.state.time
            });
          }, 1000);
        }
      });
    };

    _this.handleNextStep = function () {
      if (_this.state.nextSteping) {
        return;
      }
      if (!_this.state.identifyCode) {
        _toast2.default.info('请输入验证码');
        return;
      }
      _this.setState({
        nextSteping: true
      });
      (0, _http.ajax)({
        url: '/index.php?r=AppData/VerifyPhone',
        data: {
          app_id: (0, _global.getAppId)(),
          code: _this.state.identifyCode
        },
        success: function success(res) {
          // 还原下状态
          _this.setState({
            nextSteping: false,
            currentStep: 1,
            verifying: false,
            time: 60,
            newPhone: '',
            picCode: '',
            identifyCode: ''
          });
          _this.getPicCode(); // 更新图形验证码
        },
        error: function error() {
          _this.setState({
            nextSteping: false
          });
        }
      });
    };

    _this.handleBindPhone = function () {
      if (_this.state.binding) {
        return;
      }
      if (!(0, _tools.checkIfPhone)(_this.state.newPhone)) {
        _toast2.default.info('请输入正确的手机号');
        return;
      }
      if (!_this.state.identifyCode) {
        _toast2.default.info('请输入验证码');
        return;
      }
      _this.setState({
        binding: true
      });
      (0, _http.ajax)({
        url: '/index.php?r=AppData/VerifyNewPhone',
        data: {
          app_id: (0, _global.getAppId)(),
          code: _this.state.identifyCode,
          phone: _this.state.newPhone
        },
        success: function success(res) {
          // 还原下状态
          _this.setState({
            binding: false
          });
          if (res.status !== 0) {
            _toast2.default.info(res.data);
            return;
          }
          _this.props.history.goBack();
          _toast2.default.info('绑定成功');
        },
        error: function error() {
          _this.setState({
            binding: false
          });
        }
      });
    };

    document.title = '绑定手机号';
    return _this;
  }
  /**
   * 处理input的值的更改
   */

  /**
   * 更换图形验证码
   */

  /**
   * 获取验证码
   */

  /**
   * 下一步
   */

  /**
   * 绑定手机
   */


  (0, _createClass3.default)(BindPhonePage, [{
    key: 'render',
    value: function render() {
      if (this.state.currentStep === 0) {
        return _react2.default.createElement(
          'div',
          { id: 'bindPhonePage', className: 'page' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u7ED1\u5B9A\u624B\u673A\u53F7' }),
          _react2.default.createElement(_whiteSpace2.default, { size: 'lg' }),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement('input', { className: 'pic-code-input', type: 'text', placeholder: '\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
            _react2.default.createElement('img', { className: 'pic-code-url', src: this.state.picCodeUrl, onClick: this.getPicCode })
          ),
          _react2.default.createElement(_whiteSpace2.default, null),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement('input', { className: 'code-input', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.identifyCode, onChange: this.handleChange.bind(this, 'identifyCode') }),
            _react2.default.createElement(
              'span',
              { className: 'get-code-btn', onClick: this.getIdentifyCode },
              this.state.verifying && this.state.time !== 60 ? this.state.time + 's' : '获取验证码'
            )
          ),
          _react2.default.createElement(_whiteSpace2.default, { size: 'lg' }),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              _button2.default,
              { type: 'primary', style: { fontSize: '16px', height: '38px', lineHeight: '38px' }, onClick: this.handleNextStep },
              '\u4E0B\u4E00\u6B65'
            )
          )
        );
      } else if (this.state.currentStep === 1) {
        return _react2.default.createElement(
          'div',
          { id: 'bindPhonePage', className: 'page' },
          _react2.default.createElement(_whiteSpace2.default, { size: 'lg' }),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'phone-label' },
              '\u7ED1\u5B9A\u65B0\u624B\u673A\u53F7'
            ),
            _react2.default.createElement('input', { className: 'phone-input', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.newPhone, onChange: this.handleChange.bind(this, 'newPhone') })
          ),
          _react2.default.createElement(_whiteSpace2.default, null),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement('input', { className: 'pic-code-input', type: 'text', placeholder: '\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
            _react2.default.createElement('img', { className: 'pic-code-url', src: this.state.picCodeUrl, onClick: this.getPicCode })
          ),
          _react2.default.createElement(_whiteSpace2.default, null),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement('input', { className: 'code-input', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.identifyCode, onChange: this.handleChange.bind(this, 'identifyCode') }),
            _react2.default.createElement(
              'span',
              { className: 'get-code-btn', onClick: this.getIdentifyCode },
              this.state.verifying && this.state.time !== 60 ? this.state.time + 's' : '获取验证码'
            )
          ),
          _react2.default.createElement(_whiteSpace2.default, { size: 'lg' }),
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              _button2.default,
              { type: 'primary', style: { fontSize: '16px', height: '38px', lineHeight: '38px' }, onClick: this.handleBindPhone },
              '\u786E\u8BA4\u7ED1\u5B9A'
            )
          )
        );
      }
    }
  }]);
  return BindPhonePage;
}(_react2.default.Component);

exports.default = (0, _rcForm.createForm)()(BindPhonePage);

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

__webpack_require__(399);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Recharge = function (_OfficialPage) {
  (0, _inherits3.default)(Recharge, _OfficialPage);

  function Recharge(porps) {
    (0, _classCallCheck3.default)(this, Recharge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Recharge.__proto__ || Object.getPrototypeOf(Recharge)).call(this, porps));

    _this.state = {
      type: '', // 1:购买储值项 ／ 5: 储值券充值 / 6: 自定义金额充值
      itemList: [],
      selectedItem: {
        index: -1,
        id: '',
        description: '',
        price: 0,
        description_type: '1'
      },
      customItemInfo: {
        status: 0,
        tip: ''
      },
      customPrice: '',
      couponItemList: [],
      selectedCouponItem: {
        index: -1,
        id: ''
      },
      isPaying: false,
      storedId: 0
    };

    _this.getBalanceData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppUserBalance',
        hideLoading: true,
        success: function success(res) {
          that.setData({
            currentBalance: res.data.balance
          });
        }
      });
    };

    _this.getItemInfo = function () {
      var that = _this;
      var param = {
        ver: '2.2' //版本
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getStoredItems',
        data: param,
        hideLoading: true,
        success: function success(res) {
          if (res.data.length != 0) {
            that.setData({
              type: 1,
              itemList: that.parseItemData(res.data),
              'selectedItem.index': 0,
              'selectedItem.id': res.data[0].id,
              'selectedItem.description': res.data[0].description
            });
            that.defaultSelect(that.data.itemList);
          } else if (res.data.length == 0) {
            that.setData({
              type: 1,
              'selectedItem.index': -1
            });
          }
          that.setData({
            customItemInfo: that.parseCustomItemData(res.stored_custom_info),
            couponItemList: that.parseCouponItemData(res.user_coupon_list)
          });
        }
      });
    };

    _this.parseItemData = function (data) {
      var array = [];
      var item = {};
      data = _this.givingInstructions(data);
      for (var i = 0; i < data.length; i++) {
        item = {};
        item.id = data[i].id;
        item.rechargeMoney = Number(data[i].price);
        item.instructions = data[i].instructions;
        item.description = data[i].description;
        item.description_type = data[i].description_type;
        array.push(item);
      }
      return array;
    };

    _this.givingInstructions = function (data) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          var dataArr = [];
          var instructions = '';
          item.g_price = Number(item.g_price);
          if (item.g_price) {
            dataArr.push(item.g_price + '元');
          }
          item.g_integral = Number(item.g_integral);
          if (item.g_integral) {
            dataArr.push(item.g_integral + '积分');
          }
          if (item.g_vip_card && item.g_vip_card.title) {
            dataArr.push(item.g_vip_card.title);
          }
          if (item.g_coupon_list && item.g_coupon_list.length) {
            dataArr.push(item.g_coupon_list[0].num + '张' + item.g_coupon_list[0].title);
          }
          for (var i = 0; i < dataArr.length; i++) {
            if (i != dataArr.length - 1) {
              instructions = instructions + dataArr[i] + '、';
            } else {
              instructions = instructions + dataArr[i];
            }
          }
          if (instructions) {
            item.instructions = '赠送' + instructions;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return data;
    };

    _this.selectActiveItem = function (event) {
      var that = _this;
      var index = event.currentTarget.dataset.index;
      that.setData({
        type: 1,
        'selectedItem.index': index,
        'selectedItem.id': that.data.itemList[index].id,
        'selectedItem.description': that.data.itemList[index].description,
        'selectedItem.price': that.data.itemList[index].rechargeMoney,
        'selectedItem.description_type': that.data.itemList[index].description_type
      });
    };

    _this.parseCustomItemData = function (data) {
      return function (object) {
        object = data;
        if (data.type == 1) {
          object['tip'] = '按充值金额x' + data.value + '比例赠送储值金';
        } else if (data.type == 2) {
          object['tip'] = '每充值' + data.condition + '元，赠送' + data.value + '元';
        } else {
          object['tip'] = '';
        }
        return object;
      }({});
    };

    _this.selectCustomItem = function () {
      var that = _this;
      that.setData({
        type: 6
      });
    };

    _this.confirmCustomPrice = function (e) {
      var that = _this;
      var price = e.target.value;
      var customItemInfo = that.data.customItemInfo;
      var tip = '';
      if (price == '') {
        if (customItemInfo.type == 1) {
          tip = '按充值金额x' + customItemInfo.value + '比例赠送储值金';
        } else if (customItemInfo.type == 2) {
          tip = '每充值' + customItemInfo.condition + '元，赠送' + customItemInfo.value + '元';
        } else {
          tip = '';
        }
      } else if (!/^[0-9]+([.]{1}[0-9]{1,2})?$/.test(price)) {
        tip = '充值的金额必须>=0，精确到小数点后2位!';
      } else {
        if (customItemInfo.type == 1) {
          tip = '赠送储值金' + (price * customItemInfo.value).toFixed(2) + '元';
        } else if (customItemInfo.type == 2) {
          tip = '赠送储值金' + (Math.floor(price / customItemInfo.condition) * customItemInfo.value).toFixed(2) + '元';
        } else {
          tip = '';
        }
      }
      that.setData({
        customPrice: e.target.value,
        'customItemInfo.tip': tip
      });
    };

    _this.parseCouponItemData = function (data) {
      return function (array) {
        var item = {};
        for (var i = 0; i < data.length; i++) {
          item = {};
          item.id = data[i].id;
          item.price = Number(data[i].value);
          item.dateDuration = data[i].start_use_date.split('-').join('.') + '-' + data[i].end_use_date.split('-').join('.');
          item.otherCase = (data[i].exclude_holiday == 1 ? '除法定节假日' : '') + ' ' + (data[i].exclude_weekend == 1 ? '周一至周五' : '');
          item.timeDuration = data[i].start_use_time + '-' + data[i].end_use_time;
          array.push(item);
        }
        return array;
      }([]);
    };

    _this.selectActiveCouponItem = function (event) {
      var that = _this;
      var index = event.currentTarget.dataset.index;
      that.setData({
        type: 5,
        'selectedCouponItem.index': index,
        'selectedCouponItem.id': that.data.couponItemList[index].id
      });
    };

    _this.payLoading = false;

    _this.gotoRecharge = function (event) {
      var that = _this;
      var type = that.data.type;
      if (type == 1 && that.data.selectedItem.index == -1) {
        if (that.data.selectedItem.id == '') {
          return false;
        }
        _app.appMethod.showToast({
          title: '商家尚未建立储值项',
          icon: 'loading',
          success: function success() {}
        });
        return false;
      } else if (type == 6 && that.data.customPrice == '') {
        _app.appMethod.showToast({
          title: '请输入充值的金额',
          icon: 'loading',
          success: function success() {}
        });
        return false;
      }
      var param = {
        type: type,
        form_id: event.detail.formId
      };
      if (that.payLoading) {
        return;
      }
      _this.setIsPaying(true);
      if (type == 1) {
        param['stored_id'] = that.data.selectedItem.id;
      } else if (type == 5) {
        param['user_coupon_id'] = that.data.selectedCouponItem.id;
      } else if (type == 6) {
        param['price'] = that.data.customPrice;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/creatStoredItemOrder',
        data: param,
        hideLoading: true,
        success: function success(res) {
          var orderId = res.data;
          if (type == 1 || type == 6) {
            // app.sendRequest({
            //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
            //   data: {
            //     order_id: orderId
            //   },
            //   hideLoading: true,
            //   success: function(res) {
            //     var param = res.data
            //     param.orderId = orderId
            //     param.success = function() {
            //       app.showToast({
            //         title: '充值成功',
            //         success: function() {
            //           setTimeout(function() {
            //             app.turnToPage('/eCommerce/pages/balance/balance')
            //           }, 1500)
            //           that.setIsPaying(false)
            //         }
            //       })
            //     }
            //     param.fail = function() {
            //       that.setIsPaying(false)
            //     }
            //     console.log(param);
            //     app.wxPay(param)
            //   },
            //   fail: function() {
            //     that.setIsPaying(false)
            //   }
            // })
            _app.appMethod.goPay({
              orderId: orderId,
              successUrl: '/balance'
            });
            that.setIsPaying(false);
          } else if (type == 5) {
            _app.appMethod.showToast({
              title: '充值成功',
              success: function success() {
                setTimeout(function () {
                  _app.appMethod.turnToPage('/eCommerce/pages/balance/balance');
                }, 1500);
                that.setIsPaying(false);
              }
            });
          }
        },
        fail: function fail() {
          that.setIsPaying(false);
        },
        complete: function complete() {
          that.setIsPaying(false);
        }
      });
    };

    _this.setIsPaying = function (bool) {
      _this.payLoading = bool;
      _this.setData({
        isPaying: bool
      });
    };

    _this.defaultSelect = function (data) {
      var newData = {
        currentTarget: {
          dataset: {
            index: 0
          }
        }
      };
      if (_this.data.storedId) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].id == _this.data.storedId) {
            newData.currentTarget.dataset.index = i;
          }
        }
      }
      _this.selectActiveItem(newData);
    };

    _this.turnToRecords = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/balance/balance');
    };

    document.title = '储值金充值';
    return _this;
  }

  (0, _createClass3.default)(Recharge, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        storedId: options.storedId || 0
      });
      this.getBalanceData();
      this.getItemInfo();
    }
    // 获取当前储值金

    // 获取储值信息

    // 解析储值项数据

    // 拼接赠送说明

    // 选中储值项

    // 解析自定义储值数据

    // 选中自定义金额

    // 确定自定义金额

    // 解析储值券数据

    // 选中储值券

    // 充值按钮

    // 去充值

    // 设置是否在付款中

    // 默认选中

    // 跳转到充值记录

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          currentBalance = _state.currentBalance,
          itemList = _state.itemList,
          type = _state.type,
          selectedItem = _state.selectedItem,
          customItemInfo = _state.customItemInfo,
          couponItemList = _state.couponItemList,
          selectedCouponItem = _state.selectedCouponItem,
          isPaying = _state.isPaying;

      return (
        // TODO: 获取个人信息组件弹窗
        _react2.default.createElement(
          'div',
          { className: 'recharge-wrap page', id: 'recharge' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u50A8\u503C\u91D1\u5145\u503C' }),
          _react2.default.createElement(
            'div',
            { className: 'recharge-wrap-content' },
            _react2.default.createElement(
              'div',
              { className: 'stored-value-header' },
              _react2.default.createElement(
                'div',
                { className: 'stored-value-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-num' },
                  currentBalance
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-describe' },
                  '\u5F53\u524D\u50A8\u503C\u91D1 (\u5143)'
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'stored-value-record',
                  onClick: this.turnToRecords
                },
                '\u5145\u503C\u8BB0\u5F55'
              )
            ),
            (itemList.length > 0 || customItemInfo.status == 1) && _react2.default.createElement(
              'div',
              { className: 'select-area' },
              _react2.default.createElement(
                'div',
                { className: 'select-list' },
                itemList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: index,
                      className: 'select-item ' + (type == 1 && selectedItem.index == index ? 'active' : ''),
                      'data-index': index,
                      onClick: _this2.selectActiveItem
                    },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'recharge-money ' + (type == 1 && selectedItem.index == index ? 'active' : '')
                      },
                      item.rechargeMoney + '元'
                    ),
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'give-money ' + (type == 1 && selectedItem.index == index ? 'active' : '')
                      },
                      item.instructions
                    )
                  );
                })
              ),
              customItemInfo.status == 1 && _react2.default.createElement(
                'div',
                {
                  className: 'custom-item ' + (type == 6 ? 'active' : ''),
                  onClick: this.selectCustomItem
                },
                _react2.default.createElement(
                  'div',
                  { className: 'item-title' },
                  '\u81EA\u5B9A\u4E49\u91D1\u989D'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'item-price-block' },
                  _react2.default.createElement(
                    'span',
                    { className: 'item-price-symbol' },
                    '\xA5'
                  ),
                  _react2.default.createElement('input', {
                    className: 'item-price-input',
                    type: 'digit',
                    placeholder: '\u8BF7\u8F93\u5165\u91D1\u989D'
                    // placeholderStyle="color: #999999;"
                    , onFocus: this.selectCustomItem,
                    onBlur: this.confirmCustomPrice,
                    onInput: this.confirmCustomPrice
                  })
                ),
                customItemInfo.tip && _react2.default.createElement(
                  'div',
                  { className: 'item-tip' },
                  customItemInfo.tip
                )
              )
            ),
            type == 1 && selectedItem.description != '' && _react2.default.createElement(
              'div',
              {
                className: 'instruction-area',
                style: customItemInfo.status != 1 ? {
                  'paddingTop': '.34rem'
                } : null
              },
              _react2.default.createElement(
                'div',
                { className: 'area-title' },
                '\u50A8\u503C\u8BF4\u660E'
              ),
              selectedItem.description_type == '1' && _react2.default.createElement(
                'div',
                { className: 'area-content' },
                selectedItem.description
              ),
              selectedItem.description_type == '2' && _react2.default.createElement('img', {
                className: 'area-image',
                src: selectedItem.description
              })
            ),
            couponItemList.length > 0 && _react2.default.createElement(
              'div',
              { className: 'coupon-area' },
              _react2.default.createElement(
                'div',
                { className: 'area-title' },
                '\u50A8\u503C\u5238\u5145\u503C'
              ),
              _react2.default.createElement(
                'div',
                { className: 'coupon-list' },
                couponItemList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: index,
                      className: 'coupon-item ' + (type == 5 && selectedCouponItem.index == index ? 'active' : ''),
                      'data-index': index,
                      onClick: _this2.selectActiveCouponItem
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'item-title' },
                      '\xA5',
                      _react2.default.createElement(
                        'span',
                        { className: 'price' },
                        item.price
                      ),
                      '\u50A8\u503C\u5238'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'division-line' },
                      _react2.default.createElement('div', { className: 'left-semicircle' }),
                      _react2.default.createElement('div', { className: 'right-semicircle' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'bottom-section' },
                      _react2.default.createElement(
                        'div',
                        { className: 'date-duration' },
                        item.dateDuration
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'other-case' },
                        item.otherCase
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'time-duration' },
                        item.timeDuration
                      )
                    )
                  );
                })
              )
            ),
            itemList.length == 0 && customItemInfo.status != 1 && _react2.default.createElement(
              'div',
              { className: 'recharge-no-data' },
              _react2.default.createElement('img', {
                className: 'no-data-image',
                src: 'http://cdn.jisuapp.cn/static/webapp/images/stored-value/none-stored-record.png'
              }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65E0\u53EF\u5145\u503C\u9009\u9879'
              )
            )
          ),
          (itemList.length > 0 || customItemInfo.status == 1 || couponItemList.length > 0) && _react2.default.createElement(
            'div',
            { className: 'recharge-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'stored-value-form' },
              _react2.default.createElement(
                'button',
                {
                  className: 'recharge-btn',
                  onClick: this.gotoRecharge,
                  disabled: isPaying
                },
                '\u5145\u503C'
              )
            )
          )
        )
      );
    }
  }]);
  return Recharge;
}(_OfficialPage3.default);

exports.default = Recharge;

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(401);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RechargeIntegral = function (_OfficialPage) {
  (0, _inherits3.default)(RechargeIntegral, _OfficialPage);

  function RechargeIntegral(porps) {
    (0, _classCallCheck3.default)(this, RechargeIntegral);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RechargeIntegral.__proto__ || Object.getPrototypeOf(RechargeIntegral)).call(this, porps));

    _this.state = {
      type: '', // 1:购买充值项
      itemList: [],
      selectedItem: {
        index: -1,
        id: '',
        price: 0
      },
      customItemInfo: {
        status: 0,
        tip: ''
      },
      customPrice: '',
      couponItemList: [],
      selectedCouponItem: {
        index: -1,
        id: ''
      },
      isPaying: false,
      storedId: 0
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        hideLoading: true,
        success: function success(res) {
          that.setData({
            canUseIntegral: res.data.can_use_integral
          });
        }
      });
    };

    _this.getItemInfo = function () {
      var that = _this;
      var param = {
        app_id: _app.appMethod.getAppId()
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        data: param,
        hideLoading: true,
        success: function success(res) {
          if (res.data.length != 0) {
            that.setData({
              type: 1,
              itemList: that.parseItemData(res.data),
              'selectedItem.index': 0,
              'selectedItem.id': res.data[0].id
            });
            that.defaultSelect(that.data.itemList);
          } else if (res.data.length == 0) {
            that.setData({
              type: 1,
              'selectedItem.index': -1
            });
          }
          that.setData({
            // customItemInfo: that.parseCustomItemData(res.stored_custom_info),
          });
        }
      });
    };

    _this.parseItemData = function (data) {
      var array = [];
      var item = {};
      for (var i = 0; i < data.length; i++) {
        item = {};
        item.id = data[i].id;
        item.rechargeMoney = Number(data[i].price);
        item.rechargeNum = Number(data[i].num);
        array.push(item);
      }
      return array;
    };

    _this.selectActiveItem = function (event) {
      var that = _this;
      var index = event.currentTarget.dataset.index;
      that.setData({
        type: 1,
        'selectedItem.index': index,
        'selectedItem.id': that.data.itemList[index].id,
        'selectedItem.price': that.data.itemList[index].rechargeMoney
      });
    };

    _this.payLoading = false;

    _this.gotoRecharge = function () {
      var that = _this;
      var type = that.data.type;
      if (type == 1 && that.data.selectedItem.index == -1) {
        if (that.data.selectedItem.id == '') {
          return false;
        }
        _app.appMethod.showToast({
          title: '商家尚未建立充值项',
          icon: 'loading',
          success: function success() {}
        });
        return false;
      }
      var param = {
        app_id: _app.appMethod.getAppId(),
        integral_config_id: +_this.state.selectedItem.id,
        goods_type: 17
      };
      if (that.payLoading) {
        return;
      }
      _this.setIsPaying(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/CreateOrder',
        data: param,
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          var orderId = res.data;
          _app.appMethod.goPay({
            orderId: orderId,
            successUrl: '/myIntegral'
          });
        },
        fail: function fail() {
          that.setIsPaying(false);
        },
        complete: function complete() {
          that.setIsPaying(false);
        }
      });
    };

    _this.setIsPaying = function (bool) {
      _this.payLoading = bool;
      _this.setData({
        isPaying: bool
      });
    };

    _this.defaultSelect = function (data) {
      var newData = {
        currentTarget: {
          dataset: {
            index: 0
          }
        }
      };
      if (_this.data.storedId) {
        for (var i = 0; i < data.length; i++) {
          if (data[i].id == _this.data.storedId) {
            newData.currentTarget.dataset.index = i;
          }
        }
      }
      _this.selectActiveItem(newData);
    };

    _this.turnToRecords = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/myIntegral/myIntegral');
    };

    document.title = '积分充值';
    return _this;
  }

  (0, _createClass3.default)(RechargeIntegral, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        storedId: options.storedId || 0
      });
      this.getIntegralDetailData();
      this.getItemInfo();
    }
    // 获取当前积分

    // 获取AI积分配置

    // 解析充值项数据

    // 选中充值项

    // 解析自定义储值数据
    // parseCustomItemData = data => {
    //   return (function(object) {
    //     object = data
    //     if (data.type == 1) {
    //       object['tip'] = '按充值金额x' + data.value + '比例赠送储值金'
    //     } else if (data.type == 2) {
    //       object['tip'] =
    //         '每充值' + data.condition + '元，赠送' + data.value + '元'
    //     } else {
    //       object['tip'] = ''
    //     }
    //     return object
    //   })({})
    // }
    // 选中自定义金额
    // selectCustomItem = () => {
    //   let that = this
    //   that.setData({
    //     type: 6
    //   })
    // }
    // 确定自定义金额
    // confirmCustomPrice = e => {
    //   let that = this
    //   let price = e.target.value
    //   let customItemInfo = that.data.customItemInfo
    //   let tip = ''
    //   if (price == '') {
    //     if (customItemInfo.type == 1) {
    //       tip = '按充值金额x' + customItemInfo.value + '比例赠送储值金'
    //     } else if (customItemInfo.type == 2) {
    //       tip =
    //         '每充值' +
    //         customItemInfo.condition +
    //         '元，赠送' +
    //         customItemInfo.value +
    //         '元'
    //     } else {
    //       tip = ''
    //     }
    //   } else if (!/^[0-9]+([.]{1}[0-9]{1,2})?$/.test(price)) {
    //     tip = '充值的金额必须>=0，精确到小数点后2位!'
    //   } else {
    //     if (customItemInfo.type == 1) {
    //       tip = '赠送储值金' + (price * customItemInfo.value).toFixed(2) + '元'
    //     } else if (customItemInfo.type == 2) {
    //       tip =
    //         '赠送储值金' +
    //         (
    //           Math.floor(price / customItemInfo.condition) * customItemInfo.value
    //         ).toFixed(2) +
    //         '元'
    //     } else {
    //       tip = ''
    //     }
    //   }
    //   that.setData({
    //     customPrice: e.target.value,
    //     'customItemInfo.tip': tip
    //   })
    // }
    // 充值按钮

    // 去充值

    // 设置是否在付款中

    // 默认选中

    // 跳转到充值记录

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          canUseIntegral = _state.canUseIntegral,
          itemList = _state.itemList,
          type = _state.type,
          selectedItem = _state.selectedItem,
          customItemInfo = _state.customItemInfo,
          couponItemList = _state.couponItemList,
          selectedCouponItem = _state.selectedCouponItem,
          isPaying = _state.isPaying;

      return (
        // TODO: 获取个人信息组件弹窗
        _react2.default.createElement(
          'div',
          { className: 'recharge-wrap page', id: 'recharge' },
          _react2.default.createElement(
            'div',
            { className: 'recharge-wrap-content' },
            _react2.default.createElement(
              'div',
              { className: 'stored-value-header' },
              _react2.default.createElement(
                'div',
                { className: 'stored-value-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-num' },
                  canUseIntegral
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-describe' },
                  '\u5F53\u524D\u79EF\u5206'
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'stored-value-record',
                  onClick: this.turnToRecords
                },
                '\u5145\u503C\u8BB0\u5F55'
              )
            ),
            (itemList.length > 0 || customItemInfo.status == 1) && _react2.default.createElement(
              'div',
              { className: 'select-area' },
              _react2.default.createElement(
                'div',
                { className: 'select-list' },
                itemList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: index,
                      className: 'select-item ' + (type == 1 && selectedItem.index == index ? 'active' : ''),
                      'data-index': index,
                      onClick: _this2.selectActiveItem
                    },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'recharge-money ' + (type == 1 && selectedItem.index == index ? 'active' : '')
                      },
                      item.rechargeMoney + '元'
                    ),
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'give-money ' + (type == 1 && selectedItem.index == index ? 'active' : '')
                      },
                      item.rechargeNum + '分'
                    )
                  );
                })
              )
            ),
            itemList.length == 0 && customItemInfo.status != 1 && _react2.default.createElement(
              'div',
              { className: 'recharge-no-data' },
              _react2.default.createElement('img', {
                className: 'no-data-image',
                src: 'http://cdn.jisuapp.cn/static/webapp/images/stored-value/none-stored-record.png'
              }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65E0\u53EF\u5145\u503C\u9009\u9879'
              )
            )
          ),
          (itemList.length > 0 || customItemInfo.status == 1 || couponItemList.length > 0) && _react2.default.createElement(
            'div',
            { className: 'recharge-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'stored-value-form' },
              _react2.default.createElement(
                'button',
                {
                  className: 'recharge-btn',
                  onClick: this.gotoRecharge,
                  disabled: isPaying
                },
                '\u5145\u503C'
              )
            )
          )
        )
      );
    }
  }]);
  return RechargeIntegral;
}(_OfficialPage3.default);

exports.default = RechargeIntegral;

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _app = __webpack_require__(4);

var _ScrollView = __webpack_require__(11);

var _tools = __webpack_require__(6);

__webpack_require__(404);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Balance = function (_OfficialPage) {
  (0, _inherits3.default)(Balance, _OfficialPage);

  function Balance(porps) {
    (0, _classCallCheck3.default)(this, Balance);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Balance.__proto__ || Object.getPrototypeOf(Balance)).call(this, porps));

    _this.state = {
      currentBalance: 0, // 当前储值金
      nowTime: '',
      year: '',
      month: '',
      earlyTime: '',
      messageData: {},
      messageParam: {},
      systemHeight: 0,
      balanceHeight: 0,
      booleanData: {
        isHideCouponNav: true,
        isHideRecordNav: true
      },
      recordsListData: {
        type: 0,
        text: '全部'
      }
    };

    _this.componentWillMount = function () {
      _this.getSystemHeight();
      _this.getNowMonth();
      _this.getBalanceData();
      _this.getBalanceTime();
      _this.getAppECStoreConfig();
    };

    _this.gotoRecharge = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/recharge/recharge', true);
    };

    _this.getBalanceData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppUserBalance',
        hideLoading: true,
        success: function success(res) {
          that.setData({
            currentBalance: res.data.balance
          });
        }
      });
    };

    _this.getBalanceTime = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetUserEarliestStoredLog',
        hideLoading: true,
        data: {
          type: that.data.recordsListData.type
        },
        success: function success(res) {
          if (!res.status && res.data) {
            that.setData({
              earlyTime: res.data.month || ''
            });
            that.getMessageData();
          } else {
            that.setData({
              earlyTime: ''
            });
          }
        }
      });
    };

    _this.getMessageData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getStoredLogByUserToken',
        hideLoading: true,
        data: {
          page: that.data.messageParam.currentPage || 1,
          type: that.data.recordsListData.type,
          month: that.data.nowTime
        },
        success: function success(res) {
          var messageData = that.data.messageData;
          var data = messageData['time' + that.data.nowTime] = that.data.messageData['time' + that.data.nowTime] || {};data['data'] = (that.data.messageData['time' + that.data.nowTime].data ? that.data.messageData['time' + that.data.nowTime].data.concat(that.parseMessageData(res.data)) : that.parseMessageData(res.data)) || '', data['month'] = that.data.month;
          data['year'] = that.data.year;data['add'] = res.add || that.data.messageData['time' + that.data.nowTime].add || 0, data['reduce'] = res.reduce || that.data.messageData['time' + that.data.nowTime].reduce || 0, that.setData({
            messageData: messageData,
            'messageParam.isMore': res.is_more,
            'messageParam.currentPage': res.current_page || '',
            'messageParam.onload': false
          });
          if (that.data.balanceHeight <= that.data.systemHeight) {
            that.getBalanceHeight();
          }
        }
      });
    };

    _this.parseMessageData = function (data) {
      var that = _this;
      var array = [];
      var item = {};
      for (var i = 0; i < data.length; i++) {
        var type = data[i].type;
        var content = JSON.parse(data[i].stored_content);
        var num = '';
        if (type == 1) {
          num = Number(content.price) + Number(content.g_price);
        } else if (type == 2 || type == 3 || type == 4) {
          num = Number(content.price);
        } else if (type == 5) {
          num = Number(content.g_price);
        } else if (type == 6 || type == 10 || type == 11 || type == 12 || type == 13 || type == 14 || type == 15) {
          num = Number(content.price) + Number(content.g_price);
        } else if (type == 7 || type == 8 || type == 9 || type == 16 || type == 17 || type == 18) {
          num = Number(content.price);
        }
        var remark = content.remark;
        remark = remark ? remark.replace('\\n', '\n') : '';
        item = {
          type: type,
          num: num ? num.toFixed(2) : num,
          time: data[i].add_time,
          remark: remark || ''
        };
        array.push(item);
      }
      return array;
    };

    _this.checkMoreMessageData = function () {
      var that = _this;
      if (that.data.messageParam.isMore != 0 && !that.data.messageParam.onload) {
        that.data.messageParam.currentPage++;
        that.getMessageData();
        that.setData({
          'messageParam.onload': true
        });
      } else if (that.data.messageParam.isMore == 0 && that.data.nowTime != that.data.earlyTime && !that.data.messageParam.onload) {
        that.data.messageParam.currentPage = 0;
        that.computeTimeGetData();
        that.setData({
          'messageParam.onload': true
        });
      }
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config
        });
      });
    };

    _this.getNowMonth = function () {
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      var year = String(myDate.getFullYear());
      _this.data.year = year;
      _this.data.month = month;
      _this.data.nowTime = year + String(month);
      _this.setData({
        year: year,
        month: month,
        nowTime: year + String(month)
      });
    };

    _this.getSystemHeight = function () {
      var that = _this;
      _app.appMethod.getSystemInfo({
        success: function success(res) {
          that.setData({
            systemHeight: res.windowHeight
          });
        }
      });
    };

    _this.getBalanceHeight = function () {
      var that = _this;
      var rect = document.getElementById('balanceContent').getBoundingClientRect();
      that.setData({
        balanceHeight: rect.height
      });
      if (that.data.balanceHeight <= that.data.systemHeight) {
        that.computeTimeGetData();
      }
    };

    _this.computeTimeGetData = function () {
      if (_this.data.nowTime != _this.data.earlyTime) {
        var month = Number(_this.data.month);
        if (month == 1) {
          _this.data.month = 12;
          _this.data.year = _this.data.year - 1;
          _this.data.nowTime = String(_this.data.year) + String(_this.data.month);
        } else {
          month = month - 1;
          _this.data.month = month < 10 ? '0' + String(month) : String(month);
          _this.data.nowTime = _this.data.nowTime - 1;
        }
        _this.getMessageData();
      }
    };

    _this.toggleMoreType = function (e) {
      var dataObj = _this.data;
      var dataName = '';
      if (typeof e === 'string') {
        // js调用
        dataName = e;
      }
      if ((typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e)) === 'object' && e.currentTarget) {
        // wxml调用
        var datasetObj = e.currentTarget.dataset;
        dataName = datasetObj.name;
      }
      var isHide = dataObj.booleanData[dataName];
      isHide = !isHide;
      _this.setData((0, _defineProperty3.default)({}, 'booleanData.' + [dataName], isHide));
    };

    _this.selectRecordType = function (e) {
      e.stopPropagation();
      var tempArr = ['全部', '收入', '支出'];
      var index = e.currentTarget.dataset.index;
      if (_this.data.recordsListData.type != index) {
        _this.getNowMonth();
        _this.setData({
          'recordsListData.type': index,
          'recordsListData.text': tempArr[index],
          'messageParam.currentPage': 1,
          messageData: {},
          balanceHeight: 0
        });
        _this.getBalanceTime();
      }
      _this.toggleMoreType('isHideRecordNav');
    };

    document.title = '储值金';
    return _this;
  }

  (0, _createClass3.default)(Balance, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          currentBalance = _state.currentBalance,
          recordsListData = _state.recordsListData,
          booleanData = _state.booleanData,
          messageData = _state.messageData,
          storeStyle = _state.storeStyle,
          earlyTime = _state.earlyTime;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'balance-wrap page', id: 'balance' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u50A8\u503C\u91D1' }),
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'balance-contnet', 'scroll-y': 'true', 'lower-threshold': '116', bindscrolltolower: this.checkMoreMessageData },
            _react2.default.createElement(
              'div',
              { id: 'balanceContent' },
              _react2.default.createElement(
                'div',
                { className: 'balance-detail' },
                _react2.default.createElement(
                  'div',
                  { className: 'detail-text' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5F53\u524D\u50A8\u503C\u91D1\uFF08\u5143\uFF09'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail-num' },
                  _react2.default.createElement(
                    'span',
                    null,
                    currentBalance
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'detail-recharge', onClick: this.gotoRecharge },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u53BB\u5145\u503C'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'stored-value-filter' },
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-name' },
                  '\u50A8\u503C\u8BB0\u5F55'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'nav-content',
                    onClick: this.toggleMoreType,
                    'data-name': 'isHideRecordNav'
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'active' },
                    recordsListData.text
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' }),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'coupons-cate',
                      style: (0, _tools.convertLineStyleData)('height: ' + (booleanData.isHideRecordNav ? '0' : '270rpx'))
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'cate-list' },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'cate-item thin-bd-b',
                          'data-index': '0',
                          onClick: this.selectRecordType
                        },
                        _react2.default.createElement('span', { className: 'ico-moon icon-balance-all ico-moon-cover' }),
                        '\u5168\u90E8'
                      ),
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'cate-item thin-bd-b',
                          'data-index': '1',
                          onClick: this.selectRecordType
                        },
                        _react2.default.createElement('span', { className: 'ico-moon icon-balance-income ico-moon-cover' }),
                        '\u6536\u5165'
                      ),
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'cate-item thin-bd-b',
                          'data-index': '2',
                          onClick: this.selectRecordType
                        },
                        _react2.default.createElement('span', { className: 'ico-moon icon-balance-spending ico-moon-cover' }),
                        '\u652F\u51FA'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'message-content' },
                Object.values(messageData).map(function (message, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'message-data' },
                      _react2.default.createElement(
                        'div',
                        { className: 'message-item-header' },
                        _react2.default.createElement(
                          'div',
                          { className: 'message-month-year' },
                          _react2.default.createElement(
                            'span',
                            { className: 'message-month' },
                            message.month
                          ),
                          '/' + message.year
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'message-balance-payment' },
                          recordsListData.type != 2 && _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              'span',
                              { className: 'balance-symbol' },
                              '+'
                            ),
                            message.add
                          ),
                          recordsListData.type != 1 && _react2.default.createElement(
                            'div',
                            { className: 'message-reduce' },
                            _react2.default.createElement('span', { className: 'balance-symbol-reduce' }),
                            _react2.default.createElement(
                              'span',
                              { className: 'message-reduce-num' },
                              message.reduce
                            )
                          )
                        )
                      ),
                      message.data.map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          { key: index },
                          item.type == 1 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u81EA\u4E3B\u5145\u503C'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 2 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u5546\u5BB6\u5145\u503C'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 3 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u5546\u54C1\u4E70\u5356'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-num minus' },
                              item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 4 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u5546\u54C1\u9000\u6B3E'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 5 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u50A8\u503C\u5238\u5145\u503C'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 6 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u81EA\u5B9A\u4E49\u5145\u503C'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 7 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u7BA1\u7406\u5458\u624B\u52A8\u64A4\u56DE\u50A8\u503C\u91D1'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-num minus' },
                              item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 8 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u7528\u6237\u6570\u636E\u5408\u5E76'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-num minus' },
                              item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 9 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u7528\u6237\u6570\u636E\u5408\u5E76'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-num minus' },
                              item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 11 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u4E09\u65B9\u914D\u9001\u8D54\u4ED8'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 12 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u4F1A\u5458\u6743\u76CA\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 13 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u8FDE\u7EED\u7B7E\u5230\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 14 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u7D2F\u8BA1\u7B7E\u5230\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 15 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u50A8\u503C\u91D1\u5145\u503C\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 16 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u5206\u4EAB\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 17 ? _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u5206\u4EAB\u62C9\u65B0\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          ) : item.type == 18 && _react2.default.createElement(
                            'div',
                            { className: 'message-item' },
                            _react2.default.createElement(
                              'div',
                              { className: 'message-title' },
                              '\u6536\u85CF\u8D60\u9001'
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'message-num add',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '+' + item.num
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'message-time' },
                              item.time
                            ),
                            item.remark && _react2.default.createElement(
                              'div',
                              { className: 'message-remark' },
                              '备注：' + item.remark
                            )
                          )
                        );
                      })
                    )
                  );
                }),
                !earlyTime && _react2.default.createElement(
                  'div',
                  { className: 'recharge-no-data' },
                  _react2.default.createElement('img', {
                    className: 'no-data-image',
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/stored-value/none-stored-record.png'
                  }),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u65E0\u76F8\u5173\u6570\u636E'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Balance;
}(_OfficialPage3.default);

exports.default = Balance;

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _SinkingModal = __webpack_require__(196);

var _TopNav = __webpack_require__(8);

__webpack_require__(412);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsDetail, _OfficialPage);

  function GoodsDetail(props) {
    (0, _classCallCheck3.default)(this, GoodsDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsDetail.__proto__ || Object.getPrototypeOf(GoodsDetail)).call(this, props));

    _this2.state = {
      topNavBarData: {
        type: 3,
        isDefault: 0,
        title: '商品详情'
      },
      goodsId: '',
      cardtype: '',
      goodsInfo: {},
      vipCardStatus: 1,
      modelStrs: {},
      selectModelInfo: {
        models: [],
        stock: '',
        price: '',
        virtualPrice: '',
        buyCount: 1,
        models_text: ''
      },
      pageQRCodeData: {
        shareDialogShow: '100%',
        shareMenuShow: false
      },
      commentArr: [],
      commentNums: [],
      commentExample: '',
      commentPage: 1,
      commentType: 0,
      commentTotalPage: '',
      defaultPhoto: '',
      allStock: '',
      addToShoppingCartHidden: true,
      ifAddToShoppingCart: true,
      priceDiscountStr: '',
      page_hidden: true,
      appointmentPhone: '',
      detailCommetType: 'detail',
      carouselCurrentIndex: 1,
      imageOrVideo: 'image',
      storeStyle: '',
      footPrintIndex: 0,
      showFootPrint: false,
      animationData: {},
      pageStaySeconds: 0,
      userSetEventsArr: []
    };

    _this2.onReachBottom = function () {
      if (_this2.data.detailCommetType == 'comment' && _this2.data.commentPage <= _this2.data.commentTotalPage) {
        _this2.getAssessList(_this2.data.commentType, _this2.data.commentPage, 1);
      }
    };

    _this2.dataInitial = function () {
      var that = _this2;
      _this2.getAppECStoreConfig();
      _this2.getUserSetEvents();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: _this2.data.goodsId,
          sub_shop_app_id: _this2.data.franchiseeId,
          message_notice_type: 1,
          not_group_buy_goods: 1
        },
        success: that.modifyGoodsDetail,
        complete: function complete() {
          that.setData({
            page_hidden: false
          });
        }
      });
    };

    _this2.getAppBECStoreConfig = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=/AppEcommerce/getAppBECStoreConfig',
        success: function success(res) {
          if (res.data) {
            var cardtype = res.data.card_type;
            cardtype = cardtype && cardtype.length >= 1 ? cardtype[0] : 0;
            that.setData({
              appBECStoreConfig: res.data,
              cardtype: cardtype
            });
          }
        }
      });
    };

    _this2.onShareAppMessage = function () {
      _this2.setData({
        pageQRCodeData: {
          shareDialogShow: '100%',
          shareMenuShow: false
        }
      });
      var that = _this2,
          goodsId = _this2.data.goodsId,
          franchiseeId = _this2.data.franchiseeId,
          cartGoodsNum = _this2.data.cart_num || '',
          title = _this2.data.goodsInfo.share_title || _this2.data.goodsInfo.title,
          shareImage = _this2.data.goodsInfo.share_img || _this2.data.goodsInfo.cover,
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          path = '/pages/goodsDetail/goodsDetail?detail=' + goodsId + (franchiseeId ? '&franchisee=' + franchiseeId + '&cart_num=' + cartGoodsNum : '') + urlPromotion + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : '');

      return _app.appMethod.shareAppMessage({
        path: path,
        title: title,
        imageUrl: shareImage
      });
    };

    _this2.goToMyOrder = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/myOrder/myOrder?goodsType=' + _this2.data.goodsInfo.goods_type + '&currentIndex=0' + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath, true);
    };

    _this2.goToShoppingCart = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/shoppingCart/shoppingCart' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath, true);
    };

    _this2.gotoVipBenefits = function (e) {
      var id = e.currentTarget.dataset.id;
      var cardtype = e.currentTarget.dataset.cardtype;
      _app.appMethod.turnToPage('/eCommerce/pages/vipBenefits/vipBenefits?id=' + id + '&cardtype=' + cardtype);
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.data.franchiseeId;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({ delta: 2 });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
      }
    };

    _this2.goToCommentPage = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/goodsComment/goodsComment?detail=' + _this2.data.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.modifyGoodsDetail = function (res) {
      var _this = _this2,
          goods = res.data[0].form_data,
          unitType = goods.appointment_info && goods.appointment_info.unit_type || '',
          description = goods.description,
          goodsModel = [],
          selectModels = [],
          modifySelectModels = '',
          modelStrs = {},
          price = 0,
          discountStr = '',
          allStock = 0,
          selectStock,
          selectPrice,
          selectModelId,
          matchResult,
          selectVirtualPrice,
          selectText = '',
          vipPrice,
          selectImgurl = '',
          appointment_desc,
          appointmentPhone;
      _this2.setData({
        unitType: unitType || '',
        appointmentDesc: goods.appointment_info && goods.appointment_info.appointment_desc ? goods.appointment_info.appointment_desc.replace(/<br \/>/g, '\r\n') : '更多优惠资讯详情请联系商家!',
        appointmentPhone: goods.appointment_info && goods.appointment_info.appointment_phone ? goods.appointment_info.appointment_phone : '',
        displayComment: goods.appointment_info && goods.appointment_info.display_comment == '1' ? goods.appointment_info.display_comment : ''
      });
      description = description ? description.replace(/\u00A0|\u2028|\u2029|\uFEFF/g, '') : description;
      goods.description = description;
      goods.vip_price = goods.vip_min_price == goods.vip_max_price ? goods.vip_min_price : goods.vip_min_price + '~' + goods.vip_max_price;
      for (var key in goods.model) {
        // if (!('1' in goods.model)) {
        //   delete goods.model[0]
        // }
        if (key) {
          var model = goods.model[key];
          goodsModel.push(model);
          if (model && model.subModelName) {
            if (key == '1' && goods.goods_type == '1') {
              for (var index in model.subModelName) {
                var adjustTime = model.subModelName[index].split('-'),
                    submodel = model.subModelName[index].substring(6, 8),
                    endHours = submodel - 24 >= 10 ? submodel - 24 : '0' + (submodel - 24);
                model.subModelName[index] = submodel >= 24 ? adjustTime[0] + '-' + '次日' + endHours + ':' + adjustTime[1].split(':')[1] : adjustTime[0] + '-当日' + adjustTime[1];
              }
            }
            if (goods.goods_type == '1' && model.id == '0') {
              for (var index in model.subModelName) {
                model.subModelName[index] = model.subModelName[index] + (goods.appointment_info && goods.appointment_info.unit);
              }
            }
            modelStrs[model.id] = model.subModelName.join('、');
            selectModels.push(model.subModelId[0]);
            modifySelectModels = selectModels.toString();
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
      }
      if (goods.model_items.length) {
        var items = goods.model_items;
        for (var i = 0; i < items.length; i++) {
          price = Number(items[i].price);
          var virtualPrice = Number(items[i].virtual_price);
          var modifyGoodsmodel = items[i].model;
          goods.highPrice = goods.highPrice > price ? goods.highPrice : price;
          goods.lowPrice = goods.lowPrice < price ? goods.lowPrice : price;
          goods.virtual_price = goods.virtual_price > virtualPrice ? goods.virtual_price : virtualPrice;
          allStock += Number(items[i].stock);
          if (modifyGoodsmodel == modifySelectModels) {
            selectPrice = items[i].price;
            selectStock = items[i].stock;
            selectModelId = items[i].id;
            vipPrice = items[i].vip_price || items[i].price;
            selectImgurl = items[i].img_url;
            selectVirtualPrice = items[i].virtual_price;
          }
        }
      } else {
        selectPrice = goods.price;
        selectStock = goods.stock;
        selectVirtualPrice = goods.virtual_price;
        vipPrice = goods.vip_goods_price || goods.price;
        selectImgurl = goods.cover;
      }
      goods.model = goodsModel;
      if (Number(goods.max_can_use_integral) != 0) {
        discountStr = '（积分可抵扣' + Number(goods.max_can_use_integral) / 100 + '元）';
      }
      var expressSort = goods.goods_express_data.express_fee_sort;
      if (expressSort.length == 1) {
        var express = expressSort[0];
        if (express == 0) {
          goods.express_fee = '包邮';
        } else {
          goods.express_fee = express + '元';
        }
      } else {
        goods.express_fee = expressSort[0] + '~' + expressSort[1] + '元';
      }
      if (_this2.data.franchiseeId && goods.pick_up_type) {
        for (var _i = 0; _i < goods.pick_up_type.length; _i++) {
          goods.pick_up_type[_i] == 4 && goods.pick_up_type.splice(_i, 1);
        }
      }
      _this.setData({
        goodsInfo: goods,
        modelStrs: modelStrs,
        'selectModelInfo.models': selectModels || '',
        'selectModelInfo.stock': selectStock || '',
        'selectModelInfo.price': selectPrice || '',
        'selectModelInfo.modelId': selectModelId || '',
        'selectModelInfo.models_text': selectText || '',
        'selectModelInfo.imgurl': selectImgurl || '',
        'selectModelInfo.virtualPrice': selectVirtualPrice || '',
        'selectModelInfo.vipPrice': vipPrice || '',
        allStock: allStock || '',
        priceDiscountStr: discountStr || ''
      });
      _this.getAssessList(0, 1);
    };

    _this2.showBuyDirectly = function () {
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: false,
        imageOrVideo: 'image'
      });
    };

    _this2.showAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: true,
        imageOrVideo: 'image'
      });
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true
      });
    };

    _this2.selectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.selectModelInfo.models,
          model = _this2.data.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['selectModelInfo.models'] = selectModels;
      data['selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var _this = _this2,
          selectModelIds = _this2.data.selectModelInfo.models.join(','),
          modelItems = _this2.data.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['selectModelInfo.stock'] = modelItems[i].stock;
          data['selectModelInfo.price'] = modelItems[i].price;
          data['selectModelInfo.modelId'] = modelItems[i].id;
          data['selectModelInfo.imgurl'] = modelItems[i].img_url;
          data['selectModelInfo.vipPrice'] = modelItems[i].vip_price || modelItems[i].price;
          data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.clickMinusButton = function (e) {
      var count = _this2.data.selectModelInfo.buyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count - 1
      });
    };

    _this2.clickPlusButton = function (e) {
      var selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          count = selectModelInfo.buyCount,
          stock = selectModelInfo.stock;
      if (count >= stock) {
        _app.appMethod.showModal({ content: '购买数量不能大于库存' });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count + 1
      });
      console.log('增加', _this2.state);
    };

    _this2.sureAddToShoppingCart = function () {
      var that = _this2,
          param = {
        goods_id: _this2.data.goodsId,
        model_id: _this2.data.selectModelInfo.modelId || '',
        num: _this2.data.selectModelInfo.buyCount,
        sub_shop_app_id: _this2.data.franchiseeId || '',
        message_notice_type: 1
      };
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '添加成功',
            icon: 'success'
          });
          setTimeout(function () {
            that.hiddeAddToShoppingCart();
          }, 1000);
        }
      });
    };

    _this2.buyDirectlyNextStep = function (e) {
      var franchiseeId = _this2.data.franchiseeId,
          that = _this2,
          param = {
        goods_id: _this2.data.goodsId,
        model_id: _this2.data.selectModelInfo.modelId || '',
        num: _this2.data.selectModelInfo.buyCount,
        sub_shop_app_id: franchiseeId || '',
        message_notice_type: 1
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          var cart_arr = [res.data],
              pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cart_arr);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          that.hiddeAddToShoppingCart();
          _app.appMethod.turnToPage(pagePath);
        }
      });
    };

    _this2.makeAppointment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          unitTime = _this2.data.modelStrs[0] && _this2.data.modelStrs[0].substring(_this2.data.modelStrs[0].length - 1),
          unitType = _this2.data.unitType != 6 ? unitTime == '分' ? 1 : unitTime == '时' ? 2 : 3 : '6',
          pagePath = '/eCommerce/pages/makeAppointment/makeAppointment?detail=' + _this2.data.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + ('&param=' + unitType);
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.inputBuyCount = function (e) {
      var count = +e.target.value,
          selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          stock = +selectModelInfo.stock;
      if (count >= stock) {
        count = stock;
        _app.appMethod.showModal({ content: '购买数量不能大于库存' });
      }
      _this2.setData({
        'selectModelInfo.buyCount': +count
      });
    };

    _this2.showQRCodeComponent = function () {
      var that = _this2;
      var goodsInfo = _this2.data.goodsInfo;
      var param = {
        obj_id: that.data.goodsId,
        type: 1,
        text: goodsInfo.title,
        price: goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.price,
        goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
        max_can_use_integral: goodsInfo.max_can_use_integral,
        integral: goodsInfo.integral,
        sub_shop_id: that.data.franchiseeId,
        p_id: _app.appMethod.globalData.p_id || ''
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppDistribution/DistributionShareQRCode',
        data: param,
        hideLoading: false,
        success: function success(res) {
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': res.data
            }
          });
        }
      });
    };

    _this2.showShareMenu = function () {
      _app.appMethod.showShareMenu();
    };

    _this2.makePhoneCall = function () {
      _app.appMethod.makePhoneCall(_this2.data.appointmentPhone);
    };

    _this2.hideShareMenu = function () {
      _this2.setData({
        hideShareMenu: true
      });
    };

    _this2.showPageCode = function () {};

    _this2.oneSelectDetailCommet = function (e) {
      _this2.setData({
        detailCommetType: e.target.dataset.type
      });
    };

    _this2.getAssessList = function (commentType, page, append) {
      var that = _this2;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          idx_arr: {
            idx: 'level',
            idx_value: commentType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var commentData = res.data;
          if (append) {
            commentData = that.data.commentArr.concat(commentData);
          }
          that.setData({
            commentArr: commentData,
            commentNums: res.num,
            commentPage: that.data.commentPage + 1,
            commentExample: res.data[0] || '',
            commentTotalPage: res.total_page,
            displayComment: that.data.goodsInfo.goods_type === '0' ? +res.num[0] > 0 ? false : true : that.data.goodsInfo.appointment_info && that.data.goodsInfo.appointment_info.display_comment == '1' ? that.data.goodsInfo.appointment_info.display_comment : ''
          });
        }
      });
    };

    _this2.clickCommentLabel = function (e) {
      var commentType = e.currentTarget.dataset.type,
          data = {};
      data.commentPage = 1;
      data.commentType = commentType;
      _this2.setData(data);
      _this2.getAssessList(commentType, 1);
    };

    _this2.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    _this2.carouselIndex = function (index) {
      _this2.setData({
        carouselCurrentIndex: index + 1
      });
    };

    _this2.toCouponList = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/couponReceiveListPage/couponReceiveListPage');
    };

    _this2.changeImageOrVideo = function (event) {
      _this2.setData({
        videoPoster: false,
        imageOrVideo: event.currentTarget.dataset.type
      });
    };

    _this2.toRecommendGoodsDetail = function (event) {
      _app.appMethod.turnToGoodsDetail(event);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config,
          showStock: res.detail_fields && res.detail_fields.stock == 1 ? true : false,
          isShowVirtualPrice: res.detail_fields && res.detail_fields.virtual_price == 1 ? true : false
        });
      }, _this2.data.franchiseeId);
    };

    _this2.startPlayVideo = function () {
      _this2.setData({
        videoPoster: true
      });
      setTimeout(function () {
        var video = _app.appMethod.createVideoContext('carousel-video');
        video.play();
      }, 0);
    };

    _this2.footPrintRight = function () {
      var index = _this2.data.footPrintIndex - 1;
      if (index + _this2.data.goodsViewRecordList.length <= 0) {
        return;
      }
      _this2.setData({
        footPrintIndex: index
      });
    };

    _this2.footPrintLeft = function () {
      var index = _this2.data.footPrintIndex + 1;
      if (index > 0) {
        return;
      }
      _this2.setData({
        footPrintIndex: index
      });
    };

    _this2.hideCompeletFoot = function (event) {
      _this2.setData({
        showFootPrint: !_this2.data.showFootPrint
      });
    };

    _this2.hideFootPrint = function () {
      var animation = _this2.animation;
      animation.top('-100%').step();
      _this2.setData({
        animationData: animation.export()
      });
      setTimeout(function () {
        _this2.setData({
          footPrintIndex: 0,
          showFootPrint: false
        });
      }, 400);
    };

    _this2.stopPropagation = function (event) {};

    _this2.onPullDownRefresh = function () {
      if (_this2.data.franchiseeId) {
        _app.appMethod.stopPullDownRefresh();
        return;
      }
      _this2.getGoodsViewRecordList();
    };

    _this2.toGoodsFootPrint = function () {
      _this2.hideFootPrint();
      _app.appMethod.turnToPage('/eCommerce/pages/goodsFootPrint/goodsFootPrint');
    };

    _this2.getGoodsViewRecordList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/goodsViewRecordList',
        data: {
          page: 1,
          page_size: 10,
          goods_id: _this.data.goodsId
        },
        success: function success(res) {
          if (!res.data.length) {
            return;
          }
          var animation = _app.appMethod.createAnimation({
            duration: 500,
            timingFunction: 'linear'
          });
          _this.animation = animation;
          animation.top(0).step();
          _this.setData({
            showFootPrint: true,
            goodsViewRecordList: res.data
          });
          _this.setData({
            animationData: animation.export()
          });
        },
        complete: function complete() {
          _app.appMethod.stopPullDownRefresh();
        }
      });
    };

    _this2.goFootPrintDetail = function (event) {
      _this2.hideFootPrint();
      _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id);
    };

    _this2.addFavoriteGoods = function (event) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addFavoriteGoods',
        data: {
          form_id: event.detail.formId,
          goods_id: _this.data.goodsId,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goodsInfo.is_favorite': 1
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '收藏成功!',
            image: '/images/favorites.png'
          });
        }
      });
    };

    _this2.deleteFavoriteGoods = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteFavoriteGoods',
        method: 'post',
        data: {
          goods_id_arr: [_this.data.goodsId],
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goodsInfo.is_favorite': 0
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '取消收藏!',
            image: '/images/cancel-favorites.png'
          });
        }
      });
    };

    _this2.getUserSetEvents = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=EventMessage/getEventByBehavior',
        hideLoading: true,
        data: {
          behavior: 14,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          if (+res.status === 0) {
            var eventsData = res.data;
            var eventsDataLen = eventsData && eventsData.length;
            var eventsDataArr = [];
            if (eventsData && eventsDataLen) {
              for (var i = 0; i < eventsDataLen; i++) {
                var tempObj = {};
                var trigger = eventsData[i].trigger;
                tempObj.id = eventsData[i].id;
                tempObj.tally = trigger.condition.tally;
                eventsDataArr.push(tempObj);
              }
            }
            that.setData({
              userSetEventsArr: eventsDataArr
            });
            that.countPageStaySeconds();
          } else {
            console.log(res.data);
          }
        }
      });
    };

    _this2.countPageStaySeconds = function () {
      var that = _this2;
      var dataObj = _this2.data;
      var userEventsArr = dataObj.userSetEventsArr;
      var userEventsLen = userEventsArr && userEventsArr.length;
      var timerSeconds = dataObj.pageStaySeconds || 0;
      if (userEventsArr && userEventsLen) {
        var countPageStaySecondsTimer = setInterval(function () {
          timerSeconds += 1;
          for (var i = 0; i < userEventsLen; i++) {
            var eventId = userEventsArr[i].id;
            var currentTimer = userEventsArr[i].tally;
            if (+currentTimer === timerSeconds) {
              that.timerTriggerEvent(eventId);
            }
            if (timerSeconds > userEventsArr[userEventsLen - 1].tally) {
              clearInterval(countPageStaySecondsTimer);
              that.setData({
                countPageStaySecondsTimer: ''
              });
            }
          }
          that.setData({
            pageStaySeconds: timerSeconds
          });
        }, 1000);
        _this2.setData({
          countPageStaySecondsTimer: countPageStaySecondsTimer
        });
      }
    };

    _this2.timerTriggerEvent = function (eventId) {
      if (eventId) {
        var dataObj = _this2.data;
        var goodsId = dataObj.goodsId || '';
        var goodsName = dataObj.goodsInfo.title;
        _app.appMethod.sendRequest({
          url: '/index.php?r=EventMessage/triggerEvent',
          method: 'post',
          hideLoading: true,
          data: {
            event_id: eventId,
            form_data: {
              goods_id: goodsId,
              goods_name: goodsName
            },
            sub_shop_app_id: dataObj.franchiseeId
          },
          success: function success(res) {}
        });
      }
    };

    _this2.startFoot = function (event) {
      var startX = event.changedTouches[0].clientX;
      _this2.footStartX = startX;
    };

    _this2.endFoot = function (event) {
      var endX = event.changedTouches[0].clientX;
      var currentIndex = _this2.data.footPrintIndex;
      if (endX - _this2.footStartX > 0) {
        currentIndex++;
        if (currentIndex > 0) {
          return;
        }
      } else if (endX - _this2.footStartX < 0) {
        currentIndex--;
        if (currentIndex + _this2.data.goodsViewRecordList.length <= 0) {
          return;
        }
      }
      _this2.setData({
        footPrintIndex: currentIndex
      });
    };

    _this2.turnToGoodsRecommend = function () {
      var data = _this2.data;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/UpdateGoods',
        data: {
          form_data: JSON.stringify(data.goodsInfo)
        },
        method: 'post',
        success: function success(res) {
          if (res.status) {
            _app.appMethod.showToast({
              title: res.data
            });
          } else {
            if (_app.appMethod.openBusinessView) {
              _app.appMethod.openBusinessView({
                businessType: 'friendGoodsRecommend',
                extraData: {
                  product: {
                    item_code: data.goodsInfo.id,
                    title: data.goodsInfo.title,
                    image_list: data.goodsInfo.img_urls
                  }
                },
                success: function success(res) {},
                fail: function fail(res) {}
              });
            }
          }
        }
      });
    };

    document.title = '商品详情';
    return _this2;
  }

  (0, _createClass3.default)(GoodsDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var goodsId = options.detail,
          franchiseeId = options.franchisee || '',
          cartGoodsNum = options.cart_num || 0,
          defaultPhoto = _app.appMethod.getDefaultPhoto(),
          goodsType = options.goodsType || 0,
          userToken = options.user_token || '',
          sessionFrom = options.franchisee || _app.appMethod.getAppId() || '';
      this.setData({
        goodsId: goodsId,
        defaultPhoto: defaultPhoto,
        franchiseeId: franchiseeId,
        cartGoodsNum: cartGoodsNum,
        goodsType: goodsType,
        sessionFrom: sessionFrom,
        'topNavBarData.totalHeight': _app.appMethod.globalData.topNavBarHeight || 0
      });
      this.getAppBECStoreConfig();
      this.franchiseeId = franchiseeId;
      this.dataInitial();
      if (userToken) {
        _app.appMethod.globalData.PromotionUserToken = userToken;
      }
      // TODO
      // this.videoContext = app.createVideoContext('goodsDetail-video')
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcount) {
        this.downcount.clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _React$createElement;

      var _state = this.state,
          topNavBarData = _state.topNavBarData,
          pageQRCodeData = _state.pageQRCodeData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          page_hidden = _state.page_hidden,
          appointmentPhone = _state.appointmentPhone,
          goodsInfo = _state.goodsInfo,
          cartGoodsNum = _state.cartGoodsNum,
          imageOrVideo = _state.imageOrVideo,
          videoPoster = _state.videoPoster,
          storeStyle = _state.storeStyle,
          isShowVirtualPrice = _state.isShowVirtualPrice,
          priceDiscountStr = _state.priceDiscountStr,
          modelStrs = _state.modelStrs,
          showStock = _state.showStock,
          allStock = _state.allStock,
          cardtype = _state.cardtype,
          appBECStoreConfig = _state.appBECStoreConfig,
          appointmentDesc = _state.appointmentDesc,
          displayComment = _state.displayComment,
          commentNums = _state.commentNums,
          commentExample = _state.commentExample,
          defaultPhoto = _state.defaultPhoto,
          wxParseDescription = _state.wxParseDescription,
          franchiseeId = _state.franchiseeId,
          sessionFrom = _state.sessionFrom,
          carouselCurrentIndex = _state.carouselCurrentIndex,
          detailCommetType = _state.detailCommetType,
          commnetType = _state.commnetType,
          commentArr = _state.commentArr,
          addToShoppingCartHidden = _state.addToShoppingCartHidden,
          selectModelInfo = _state.selectModelInfo,
          ifAddToShoppingCart = _state.ifAddToShoppingCart,
          animationData = _state.animationData,
          footPrintIndex = _state.footPrintIndex,
          goodsViewRecordList = _state.goodsViewRecordList,
          showFootPrint = _state.showFootPrint;


      return React.createElement(
        'div',
        { className: 'official-page goods-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BE6\u60C5' }),
        React.createElement(_SinkingModal.SinkingModal, null),
        React.createElement(
          'div',
          { className: 'goods-detail-wrap', hidden: page_hidden },
          React.createElement(
            'div',
            {
              className: 'goods-detail-nav',
              style: { top: topNavBarData.totalHeight / 50 + 'rem' }
            },
            goodsInfo.goods_type == 1 ? React.createElement(
              'div',
              null,
              React.createElement('div', {
                className: 'pull-right ico-moon icon-takeout-cellphone',
                onClick: this.makePhoneCall,
                hidden: !appointmentPhone
              }),
              React.createElement('div', {
                className: 'pull-right ico-moon icon-share',
                onClick: this.showQRCodeComponent
              })
            ) : goodsInfo.goods_type == 0 && React.createElement(
              'div',
              null,
              (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && React.createElement('div', {
                className: 'pull-right ico-moon icon-notebook',
                onClick: this.goToMyOrder
              }),
              (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && React.createElement(
                'div',
                {
                  className: 'pull-right ico-moon icon-store2',
                  onClick: this.goToHomepage
                },
                !!cartGoodsNum && cartGoodsNum != 0 && React.createElement(
                  'div',
                  { className: 'goods-detail-cart-num' },
                  cartGoodsNum
                )
              ),
              goodsInfo.detail_type != 2 && React.createElement('div', {
                className: 'pull-right ico-moon icon-new-share',
                onClick: this.showQRCodeComponent
              })
            )
          ),
          (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && React.createElement(
            'div',
            { className: 'goods-detail-content oldStyle' },
            React.createElement(
              'div',
              { className: 'goods-detail-section' },
              imageOrVideo == 'image' && React.createElement(
                'div',
                { className: 'image-carousel-container' },
                !goodsInfo.img_urls ? React.createElement(
                  'div',
                  { className: 'goods-cover-container' },
                  !!goodsInfo.cover && React.createElement('img', {
                    'data-src': goodsInfo.cover,
                    onClick: this.clickPlusImages,
                    src: goodsInfo.cover,
                    mode: 'aspectFill' })
                ) : React.createElement(
                  'div',
                  { className: 'slick-carousel-container' },
                  goodsInfo.img_urls && !!goodsInfo.img_urls.length && React.createElement(
                    _carousel2.default,
                    {
                      dots: false,
                      infinite: true,
                      autoplay: true,
                      autoplayInterval: 5000,
                      afterChange: this.carouselIndex },
                    goodsInfo.img_urls.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement('img', {
                          'data-src': item,
                          'data-srcarr': JSON.stringify(goodsInfo.img_urls),
                          onClick: _this3.clickPlusImages,
                          src: item,
                          onLoad: function onLoad() {
                            // fire window resize event to change height
                            window.dispatchEvent(new Event('resize'));
                          },
                          className: 'slide-image' })
                      );
                    })
                  )
                ),
                goodsInfo.video_url && React.createElement(
                  'div',
                  { className: 'image-video-menu' },
                  React.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'image' ? 'active' : '',
                      'data-type': 'image',
                      onClick: this.changeImageOrVideo
                    },
                    '\u56FE\u7247'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'video' ? 'active' : '',
                      'data-type': 'video',
                      onClick: this.changeImageOrVideo
                    },
                    '\u89C6\u9891'
                  )
                )
              ),
              goodsInfo.video_url && imageOrVideo == 'video' && React.createElement(
                'div',
                { className: 'video-carousel-container' },
                videoPoster && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement('video', { src: goodsInfo.video_url, id: 'carousel-video' }),
                  React.createElement(
                    'div',
                    { className: 'image-video-menu' },
                    React.createElement(
                      'div',
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'videoele-cover-view', hidden: videoPoster },
                  React.createElement(
                    'div',
                    { className: 'videoele-poster-wrap' },
                    React.createElement('img', {
                      className: 'videoele-poster',
                      src: goodsInfo.video_img,
                      mode: 'scaleToFill' })
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'videoele-play-icon',
                      onClick: this.startPlayVideo
                    },
                    React.createElement('img', {
                      className: 'videoele-play-image',
                      src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                      mode: 'scaleToFill' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'image-video-menu' },
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'goods-header' },
                React.createElement(
                  'div',
                  { className: 'goods-title goods-title-zero' },
                  React.createElement(
                    'div',
                    { className: 'goodsInfo-title' },
                    goodsInfo.title
                  ),
                  goodsInfo.recommend_status && React.createElement(
                    'div',
                    {
                      className: 'goods-recommended',
                      onClick: this.turnToGoodsRecommend
                    },
                    React.createElement('span', { className: 'ico-moon icon-like-bold' }),
                    '\u597D\u7269\u63A8\u8350'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'goods-price' },
                  goodsInfo.is_vip_goods != 1 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      {
                        className: 'goods-current-price',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      goodsInfo.integral != '2' ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                          '\xA5'
                        ),
                        React.createElement(
                          'span',
                          { style: { fontWeight: 'bold', fontSize: '.4rem' } },
                          goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费'
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        goodsInfo.price != '0.00' && React.createElement(
                          'span',
                          { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                          '\xA5'
                        ),
                        goodsInfo.price != '0.00' && React.createElement(
                          'span',
                          { style: { fontSize: '.4rem' } },
                          goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费'
                        ),
                        goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            className: 'goods-price-discount price-integral',
                            style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                          },
                          '+'
                        ),
                        goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            className: 'goods-price-discount price-integral',
                            style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                          },
                          goodsInfo.max_can_use_integral + '积分'
                        )
                      ),
                      isShowVirtualPrice && goodsInfo.virtual_price != 0 && goodsInfo.goods_type != 1 && React.createElement(
                        'span',
                        { className: 'virtualPrice' },
                        '￥' + goodsInfo.virtual_price
                      )
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      {
                        className: 'goods-current-price member-status',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      React.createElement(
                        'div',
                        { className: 'member-price' },
                        React.createElement(
                          'span',
                          { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                          '\xA5'
                        ),
                        React.createElement(
                          'span',
                          { style: { fontWeight: 'bold', fontSize: '.4rem' } },
                          goodsInfo.vip_price
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'member-logo' },
                        '\u4F1A\u5458\u4EF7'
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'memebr-origin-price',
                          style: { color: '#999' }
                        },
                        goodsInfo.integral != '2' ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            { style: { marginRight: '.06rem', fontSize: '.24rem', color: '#999' } },
                            '\xA5'
                          ),
                          React.createElement(
                            'span',
                            { style: { fontWeight: 'normal', fontSize: '.24rem' } },
                            goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费'
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          goodsInfo.price != '0.00' && React.createElement(
                            'span',
                            { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                            '\xA5'
                          ),
                          goodsInfo.price != '0.00' && React.createElement(
                            'span',
                            { style: { fontSize: '.4rem' } },
                            goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费'
                          ),
                          goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                            'span',
                            {
                              className: 'goods-price-discount price-integral',
                              style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                            },
                            '+'
                          ),
                          goodsInfo.max_can_use_integral != 0 && React.createElement(
                            'span',
                            {
                              className: 'goods-price-discount price-integral',
                              style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                            },
                            goodsInfo.max_can_use_integral + '积分'
                          )
                        )
                      )
                    )
                  ),
                  priceDiscountStr != '' && goodsInfo.integral != '2' && React.createElement(
                    'div',
                    { className: 'goods-price-discount' },
                    priceDiscountStr
                  )
                ),
                goodsInfo.model_items && !!goodsInfo.model_items.length && React.createElement(
                  'div',
                  { className: 'goods-models' },
                  goodsInfo.model.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'goods-model-item',
                        key: item.id,
                        hidden: !item.subModelName
                      },
                      React.createElement(
                        'span',
                        { className: 'goods-model-cate' },
                        item.name
                      ),
                      React.createElement(
                        'span',
                        { className: 'goods-model-detail' },
                        modelStrs[item.id]
                      )
                    );
                  })
                ),
                goodsInfo.goods_type == 0 && React.createElement(
                  'div',
                  { className: 'goods-other-info' },
                  React.createElement(
                    'div',
                    null,
                    '配送费:' + (goodsInfo.express_fee || '包邮')
                  ),
                  showStock && React.createElement(
                    'div',
                    null,
                    '库存:' + (allStock || goodsInfo.stock)
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'goods-other-info' },
                  React.createElement(
                    'label',
                    null,
                    '\u53D6\u8D27\u65B9\u5F0F'
                  ),
                  React.createElement(
                    'div',
                    { className: 'address-pick-up' },
                    goodsInfo.pick_up_type && goodsInfo.pick_up_type.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: item },
                        React.createElement('span', {
                          style: { color: storeStyle.theme },
                          className: 'ico-moon icon-goods-support-delivery suporrt'
                        }),
                        React.createElement(
                          'span',
                          null,
                          item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                        )
                      );
                    })
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'vip-card-into vip-card1' },
              appBECStoreConfig && appBECStoreConfig.card_switch == 1 && (appBECStoreConfig.card_show_type == 1 && goodsInfo.is_vip_goods == 1 || appBECStoreConfig.card_show_type == 2) && React.createElement(
                React.Fragment,
                null,
                appBECStoreConfig.card_detail_type == 1 && React.createElement(
                  'div',
                  {
                    className: 'member-toast-wrap toast1',
                    'data-type': 'ordinary-vip',
                    'data-id': goodsInfo.vip_activity_id,
                    onClick: this.gotoVipBenefits,
                    'data-cardtype': cardtype
                  },
                  React.createElement(
                    'div',
                    { className: 'image-wrap' },
                    React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/a.png' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-toast' },
                    React.createElement(
                      'span',
                      { className: 'member-tips' },
                      appBECStoreConfig.card_title
                    )
                  )
                ),
                appBECStoreConfig.card_detail_type == 2 && React.createElement(
                  'div',
                  {
                    className: 'member-toast-wrap toast2',
                    'data-type': 'ordinary-vip',
                    'data-id': goodsInfo.vip_activity_id,
                    onClick: this.gotoVipBenefits,
                    'data-cardtype': cardtype
                  },
                  React.createElement(
                    'div',
                    { className: 'image-wrap' },
                    React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/b.png' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-toast' },
                    React.createElement(
                      'span',
                      { className: 'member-tips' },
                      appBECStoreConfig.card_title
                    )
                  )
                ),
                appBECStoreConfig.card_detail_type == 3 && React.createElement(
                  'div',
                  {
                    className: 'member-toast-wrap toast3',
                    'data-type': 'ordinary-vip',
                    'data-id': goodsInfo.vip_activity_id,
                    onClick: this.gotoVipBenefits,
                    'data-cardtype': cardtype
                  },
                  React.createElement(
                    'div',
                    { className: 'image-wrap' },
                    React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/c.png' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-toast' },
                    React.createElement(
                      'span',
                      { className: 'member-tips' },
                      appBECStoreConfig.card_title
                    )
                  )
                )
              )
            ),
            goodsInfo.goods_type == 1 && React.createElement(
              'div',
              { className: 'goods-appointment' },
              React.createElement(
                'div',
                {
                  className: 'appointment-instructions',
                  style: { color: '#666' }
                },
                '\u9884\u7EA6\u8BF4\u660E'
              ),
              React.createElement(
                'span',
                {
                  className: 'appointment-remarks',
                  style: { color: '#999', wordBreak: 'break-all' }
                },
                appointmentDesc
              )
            ),
            React.createElement(
              'div',
              {
                style: { padding: '.2rem', textAlign: 'center', background: '#f4f4f4', color: '#b2b2b2', fontSize: ' .24rem' },
                hidden: displayComment
              },
              React.createElement('div', { className: 'line' }),
              React.createElement('div', { className: 'ico-moon icon-good-comment goods-ico' }),
              React.createElement(
                'div',
                { style: { display: 'inline-block', verticalAlign: 'middle', marginRight: '.08rem' } },
                '\u8BC4\u4EF7'
              ),
              React.createElement('div', { className: 'line' })
            ),
            React.createElement(
              'div',
              { className: 'goods-detail-section', hidden: displayComment },
              React.createElement(
                'div',
                { className: 'comment-title' },
                React.createElement(
                  'div',
                  { style: { borderBottom: '1px solid #f4f4f4', paddingBottom: '.2rem' } },
                  '评价 (' + (commentNums[0] || 0) + ')'
                )
              ),
              React.createElement(
                'div',
                { className: 'block-item' },
                commentExample && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'comment-item' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        className: 'comment-user-photo',
                        src: commentExample.buyer_headimgurl || defaultPhoto }),
                      React.createElement(
                        'span',
                        { className: 'commentPersonName' },
                        commentExample.buyer_nickname
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'comment-date' },
                      commentExample.add_time
                    ),
                    React.createElement(
                      'div',
                      { className: 'comment-content' },
                      commentExample.assess_info.content
                    ),
                    !!commentExample.assess_info.has_img && React.createElement(
                      'div',
                      { className: 'comPage-comment-pics' },
                      commentExample.assess_info.img_arr.map(function (imgSrc, index) {
                        return React.createElement('img', {
                          src: imgSrc,
                          key: index,
                          'data-src': imgSrc,
                          'data-srcarr': JSON.stringify(commentExample.assess_info.img_arr),
                          onClick: _this3.clickPlusImages });
                      })
                    )
                  ),
                  React.createElement(
                    'div',
                    { style: { textAlign: 'center' } },
                    React.createElement(
                      'button',
                      {
                        className: 'btn lookAllComments',
                        style: {
                          color: storeStyle.theme,
                          borderColor: storeStyle.theme
                        },
                        onClick: this.goToCommentPage
                      },
                      '\u67E5\u770B\u5168\u90E8\u8BC4\u4EF7'
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { style: { padding: '.2rem', textAlign: 'center', background: '#f4f4f4', color: '#b2b2b2', fontSize: '.24rem' } },
              React.createElement('div', { className: 'line' }),
              React.createElement('div', { className: 'ico-moon icon-good-detail goods-ico' }),
              React.createElement(
                'div',
                { style: { display: 'inline-block', verticalAlign: 'middle', marginRight: '.08rem' } },
                '\u8BE6\u60C5'
              ),
              React.createElement('div', { className: 'line' })
            ),
            React.createElement(
              'div',
              { className: 'goods-detail-section' },
              React.createElement(
                'div',
                { className: 'comment-title' },
                React.createElement(
                  'div',
                  { style: { borderBottom: '1px solid #f4f4f4', paddingBottom: '.2rem' } },
                  '\u4EA7\u54C1\u8BE6\u60C5'
                )
              ),
              React.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g, '') } })
            ),
            goodsInfo.recommend_info && !!goodsInfo.recommend_info.length && React.createElement(
              'div',
              { className: 'goods-recommend' },
              React.createElement(
                'div',
                { className: 'two-recommend' },
                '\u5E97\u94FA\u63A8\u8350'
              ),
              React.createElement(
                _ScrollView.ScrollView,
                { className: 'recommend-content', 'scroll-x': 'true' },
                goodsInfo.recommend_info.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'recommend-goods',
                      key: item.form_data.id,
                      onClick: _this3.toRecommendGoodsDetail,
                      'data-id': item.form_data.id,
                      'data-goods-type': item.form_data.goods_type
                    },
                    React.createElement(
                      'div',
                      { className: 'width-fix-image' },
                      React.createElement('img', {
                        mode: 'widthFix',
                        src: item.form_data.cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'recommend-goods-title' },
                      item.form_data.title
                    ),
                    React.createElement(
                      'span',
                      { className: 'recommend-goods-price' },
                      '¥' + item.form_data.price
                    )
                  );
                })
              )
            )
          ),
          goodsInfo.detail_type != 2 && React.createElement(
            'div',
            { className: 'goods-bottom-opt' },
            goodsInfo.goods_type == 1 ? React.createElement(
              'div',
              { className: 'goods-appointment-bottom-bar' },
              React.createElement(
                'div',
                { className: 'appointment-logo-wrap' },
                React.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-2',
                    onClick: this.goToMyOrder
                  },
                  React.createElement('span', { className: 'ico-moon icon-notebook' }),
                  React.createElement(
                    'div',
                    null,
                    '\u8BA2\u5355'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-2',
                    onClick: this.goToHomepage
                  },
                  React.createElement('span', { className: 'ico-moon icon-store2' }),
                  React.createElement(
                    'div',
                    null,
                    '\u5E97\u94FA'
                  )
                )
              ),
              React.createElement(
                'label',
                {
                  className: 'btn btn-orange make-appointment',
                  onClick: this.makeAppointment
                },
                '\u53BB\u9884\u7EA6'
              )
            ) : goodsInfo.goods_type == 0 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                goodsInfo.integral != '2' && React.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-' + (franchiseeId ? '2' : '3'),
                    onClick: this.goToShoppingCart
                  },
                  React.createElement(
                    'div',
                    { className: 'bottom-border-right' },
                    React.createElement('span', { className: 'ico-moon icon-new-goods-shopping' }),
                    React.createElement(
                      'div',
                      { className: 'margig-top-2' },
                      '\u8D2D\u7269\u8F66'
                    )
                  )
                ),
                !franchiseeId && React.createElement(
                  'div',
                  { className: 'form-contain goods-opt-item flex-sub-box-3' },
                  React.createElement(
                    'form',
                    null,
                    React.createElement(
                      'button',
                      { type: 'button',
                        onClick: goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                      React.createElement(
                        'div',
                        { className: 'bottom-border-right' },
                        React.createElement('span', {
                          style: goodsInfo.is_favorite == 1 ? { color: storeStyle.theme } : {},
                          className: 'ico-moon icon-' + (goodsInfo.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites')
                        }),
                        React.createElement(
                          'div',
                          null,
                          '\u6536\u85CF'
                        )
                      )
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-' + (franchiseeId ? '2' : '3')
                  },
                  React.createElement('div', { className: 'ico-moon icon-service2' }),
                  React.createElement(
                    'div',
                    null,
                    '\u5BA2\u670D'
                  )
                )
              ),
              goodsInfo.integral != '2' && React.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                React.createElement(
                  'label',
                  {
                    style: {
                      background: storeStyle.secondary,
                      color: storeStyle.secondary == '#ACD3FA' || storeStyle.secondary == '#FFCFDF' || storeStyle.secondary == '#ffffff' || storeStyle.secondary == '#DFF3ED' || storeStyle.secondary == '#FAF7ED' ? storeStyle.theme : {}
                    },
                    className: 'btn addToShoppingCart ' + (goodsInfo.seckill_start_state == 2 ? 'disabled' : ''),
                    onClick: this.showAddToShoppingCart
                  },
                  '\u52A0\u5165\u8D2D\u7269\u8F66'
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'flex-sub-box-3',
                  style: goodsInfo.integral == '2' ? { width: '66.6%' } : {}
                },
                React.createElement(
                  'label',
                  {
                    style: { background: storeStyle.theme },
                    className: 'btn btn-orange buy-goods-directly',
                    onClick: this.showBuyDirectly
                  },
                  '\u7ACB\u5373\u8D2D\u4E70'
                )
              )
            )
          )
        ),
        goodsInfo.detail_type != 0 && goodsInfo.goods_type != 1 && React.createElement(
          'div',
          { className: 'goods-detail-section' },
          goodsInfo.buyer_list && !!goodsInfo.buyer_list.length && React.createElement(
            'div',
            { className: 'goods-buy-record' },
            React.createElement(
              _carousel2.default,
              {
                dots: false,
                infinite: true,
                autoplay: true,
                autoplayInterval: 3000 },
              goodsInfo.buyer_list.map(function (item, index) {
                return React.createElement(
                  'div',
                  { key: index },
                  React.createElement('img', { src: item.cover_thumb,
                    onLoad: function onLoad() {
                      // fire window resize event to change height
                      window.dispatchEvent(new Event('resize'));
                    } }),
                  React.createElement(
                    'span',
                    null,
                    item.nickname + '购买成功'
                  )
                );
              })
            )
          ),
          imageOrVideo == 'image' && React.createElement(
            'div',
            { className: 'image-carousel-container' },
            !goodsInfo.img_urls ? React.createElement(
              'div',
              { className: 'goods-cover-container' },
              !!goodsInfo.cover && React.createElement('img', {
                'data-src': goodsInfo.cover,
                onClick: this.clickPlusImages,
                src: goodsInfo.cover,
                mode: 'aspectFill' })
            ) : React.createElement(
              'div',
              { className: 'slick-carousel-container' },
              React.createElement(
                _carousel2.default,
                {
                  dots: false,
                  infinite: true,
                  autoplay: true,
                  autoplayInterval: 5000,
                  afterChange: this.carouselIndex },
                goodsInfo.img_urls.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { key: index },
                    React.createElement('img', {
                      'data-src': item,
                      'data-srcarr': JSON.stringify(goodsInfo.img_urls),
                      onClick: _this3.clickPlusImages,
                      src: item,
                      mode: 'aspectFit',
                      className: 'slide-image',
                      onLoad: function onLoad() {
                        // fire window resize event to change height
                        window.dispatchEvent(new Event('resize'));
                      } })
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'carousel-index' },
                carouselCurrentIndex + '/' + goodsInfo.img_urls.length
              )
            ),
            goodsInfo.video_url && React.createElement(
              'div',
              { className: 'image-video-menu' },
              React.createElement(
                'span',
                {
                  className: imageOrVideo == 'image' ? 'active' : '',
                  'data-type': 'image',
                  onClick: this.changeImageOrVideo
                },
                '\u56FE\u7247'
              ),
              React.createElement(
                'span',
                {
                  className: imageOrVideo == 'video' ? 'active' : '',
                  'data-type': 'video',
                  onClick: this.changeImageOrVideo
                },
                '\u89C6\u9891'
              )
            )
          ),
          goodsInfo.video_url && imageOrVideo == 'video' && React.createElement(
            'div',
            { className: 'video-carousel-container' },
            videoPoster && React.createElement(
              Video,
              { src: goodsInfo.video_url, id: 'carousel-video' },
              React.createElement(
                CoverView,
                { className: 'image-video-menu' },
                React.createElement(
                  CoverView,
                  {
                    className: imageOrVideo == 'image' ? 'active' : '',
                    'data-type': 'image',
                    onClick: this.changeImageOrVideo
                  },
                  '\u56FE\u7247'
                ),
                React.createElement(
                  CoverView,
                  {
                    className: imageOrVideo == 'video' ? 'active' : '',
                    'data-type': 'video',
                    onClick: this.changeImageOrVideo
                  },
                  '\u89C6\u9891'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'videoele-cover-view', hidden: videoPoster },
              React.createElement(
                'div',
                { className: 'videoele-poster-wrap' },
                React.createElement('img', {
                  className: 'videoele-poster',
                  src: goodsInfo.video_img,
                  mode: 'scaleToFill' })
              ),
              React.createElement(
                'div',
                {
                  className: 'videoele-play-icon',
                  onClick: this.startPlayVideo
                },
                React.createElement('img', {
                  className: 'videoele-play-image',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                  mode: 'scaleToFill' })
              ),
              React.createElement(
                'div',
                { className: 'image-video-menu' },
                React.createElement(
                  'span',
                  {
                    className: imageOrVideo == 'image' ? 'active' : '',
                    'data-type': 'image',
                    onClick: this.changeImageOrVideo
                  },
                  '\u56FE\u7247'
                ),
                React.createElement(
                  'span',
                  {
                    className: imageOrVideo == 'video' ? 'active' : '',
                    'data-type': 'video',
                    onClick: this.changeImageOrVideo
                  },
                  '\u89C6\u9891'
                )
              )
            )
          )
        ),
        goodsInfo.detail_type == 1 && React.createElement(
          'div',
          { className: 'goods-detail-content styleOne' },
          React.createElement(
            'div',
            { className: 'goods-header' },
            React.createElement(
              'div',
              { className: 'goods-title' },
              goodsInfo.title
            ),
            React.createElement(
              'div',
              { className: 'goods-price' },
              goodsInfo.is_vip_goods != 1 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'goods-current-price' },
                  goodsInfo.integral != '2' ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'real-price',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费')
                    ),
                    isShowVirtualPrice && goodsInfo.virtual_price != 0 && goodsInfo.goods_type != 1 && React.createElement(
                      'span',
                      { className: 'virtualPrice' },
                      '￥' + goodsInfo.virtual_price
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    goodsInfo.price != '0.00' && React.createElement(
                      'span',
                      {
                        className: 'real-price',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费')
                    ),
                    goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'span',
                      {
                        className: 'goods-price-discount price-integral',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '+'
                    ),
                    goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'span',
                      {
                        className: 'goods-price-discount price-integral',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      goodsInfo.max_can_use_integral + '积分'
                    ),
                    isShowVirtualPrice && goodsInfo.virtual_price != 0 && goodsInfo.goods_type != 1 && React.createElement(
                      'span',
                      { className: 'virtualPrice' },
                      '￥' + goodsInfo.virtual_price
                    )
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    className: 'goods-current-price member-status',
                    style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                  },
                  React.createElement(
                    'div',
                    { className: 'member-price' },
                    React.createElement(
                      'span',
                      { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                      '\xA5'
                    ),
                    React.createElement(
                      'span',
                      { style: { fontWeight: 'bold', fontSize: '.4rem' } },
                      goodsInfo.vip_price
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-logo' },
                    '\u4F1A\u5458\u4EF7'
                  ),
                  React.createElement(
                    'div',
                    { className: 'memebr-origin-price', style: { color: '#999' } },
                    goodsInfo.integral != '2' ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        {
                          className: 'real-price',
                          style: { color: '#999', fontSize: '.24rem' }
                        },
                        '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费')
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      goodsInfo.price != '0.00' && React.createElement(
                        'span',
                        {
                          className: 'real-price',
                          style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme, fontSize: '.24rem' }
                        },
                        '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费')
                      ),
                      goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'goods-price-discount price-integral',
                          style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                        },
                        '+'
                      ),
                      goodsInfo.max_can_use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'goods-price-discount price-integral',
                          style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                        },
                        goodsInfo.max_can_use_integral + '积分'
                      )
                    )
                  )
                )
              ),
              priceDiscountStr != '' && goodsInfo.integral != '2' && React.createElement(
                'div',
                { className: 'goods-price-discount' },
                priceDiscountStr
              ),
              goodsInfo.recommend_status && React.createElement(
                'div',
                {
                  className: 'goods-recommended-one',
                  onClick: this.turnToGoodsRecommend
                },
                React.createElement('span', { className: 'ico-moon icon-like-bold' }),
                '\u597D\u7269\u63A8\u8350'
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-coupon', onClick: this.toCouponList },
              React.createElement(
                'span',
                null,
                '\u6D3B\u52A8\uFF1A'
              ),
              React.createElement(
                'span',
                {
                  className: 'word-orange',
                  style: { color: storeStyle.theme }
                },
                '[\u6700\u65B0\u4F18\u60E0\u5238]'
              ),
              React.createElement(
                'span',
                { className: 'pull-right color-999' },
                '\u7ACB\u5373\u9886\u53D6',
                React.createElement('span', { className: 'ico-moon icon-rightarrow' })
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-freight' },
              React.createElement(
                'div',
                null,
                '配送费：' + (goodsInfo.express_fee || '包邮')
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-freight' },
              React.createElement(
                'label',
                null,
                '\u53D6\u8D27\u65B9\u5F0F'
              ),
              React.createElement(
                'div',
                { className: 'address-pick-up' },
                goodsInfo.pick_up_type.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { key: index },
                    React.createElement('span', {
                      style: { color: storeStyle.theme },
                      className: 'ico-moon icon-goods-support-delivery suporrt'
                    }),
                    React.createElement(
                      'span',
                      null,
                      item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                    )
                  );
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-freight', onClick: this.showBuyDirectly },
              React.createElement(
                'span',
                null,
                '\u9009\u62E9\u5546\u54C1\u89C4\u683C'
              ),
              React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow color-999' })
            )
          ),
          React.createElement(
            'div',
            { className: 'payment-record' },
            appBECStoreConfig.card_switch == 1 && (appBECStoreConfig.card_show_type == 1 && goodsInfo.is_vip_goods == 1 || appBECStoreConfig.card_show_type == 2) && React.createElement(
              'div',
              {
                className: 'vip-card-into vip-card' + appBECStoreConfig.card_detail_type
              },
              appBECStoreConfig.card_detail_type == 1 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast1',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/a.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              ),
              appBECStoreConfig.card_detail_type == 2 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast2',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/b.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              ),
              appBECStoreConfig.card_detail_type == 3 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast3',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/c.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'wx-payDialog' },
              React.createElement('img', {
                className: 'goods-style-wechat',
                src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/goods-style-wechat.png' }),
              React.createElement(
                'span',
                { className: 'payment-record-word' },
                '\u5FAE\u4FE1\u652F\u4ED8\u4EA4\u6613'
              ),
              React.createElement(
                'div',
                { className: 'pull-right' },
                React.createElement(
                  'div',
                  { className: 'buyer-list' },
                  goodsInfo.buyer_list.map(function (item, index) {
                    return React.createElement('img', {
                      key: index,
                      src: item.cover_thumb || 'http://img.zhichiwangluo.com/zcimgdir/album/file_55910ef341577.png' });
                  })
                ),
                React.createElement(
                  'span',
                  {
                    className: 'word-orange buy-number',
                    style: { color: storeStyle.theme }
                  },
                  '购买' + goodsInfo.sales + '+'
                ),
                React.createElement(
                  'span',
                  { className: 'color-999' },
                  '浏览' + goodsInfo.viewed_count + '+'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-recommend' },
            React.createElement(
              'div',
              { className: 'recommend-header' },
              React.createElement('img', {
                src: goodsInfo.app_cover,
                className: 'store-picture' }),
              React.createElement(
                'div',
                { className: 'store-des' },
                goodsInfo.app_name
              ),
              React.createElement(
                'div',
                {
                  className: 'pull-right go-to-store',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            ),
            !!goodsInfo.recommend_info.length && React.createElement(
              _ScrollView.ScrollView,
              { className: 'recommend-content', 'scroll-x': 'true' },
              goodsInfo.recommend_info.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'recommend-goods',
                    key: index,
                    onClick: _this3.toRecommendGoodsDetail,
                    'data-id': item.form_data.id,
                    'data-goods-type': item.form_data.goods_type
                  },
                  React.createElement(
                    'div',
                    { className: 'width-fix-image' },
                    React.createElement('img', {
                      mode: 'widthFix',
                      src: item.form_data.cover })
                  ),
                  React.createElement(
                    'div',
                    { className: 'recommend-goods-title' },
                    item.form_data.title
                  ),
                  React.createElement(
                    'span',
                    { className: 'recommend-goods-price' },
                    '¥' + item.form_data.price
                  )
                );
              })
            )
          ),
          React.createElement(
            'div',
            { style: { padding: '.3rem', textAlign: 'center', color: '#b2b2b2', fontSize: '.24rem' } },
            React.createElement('div', { className: 'line' }),
            React.createElement(
              'div',
              { style: { display: 'inline-block', verticalAlign: 'middle', margin: '0 .08rem' } },
              '\u7EE7\u7EED\u62D6\u52A8\uFF0C\u67E5\u770B\u5546\u54C1\u4FE1\u606F'
            ),
            React.createElement('div', { className: 'line' })
          ),
          React.createElement(
            'div',
            { className: 'detail-comment' },
            React.createElement(
              'div',
              { className: 'detail-comment-menu' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  {
                    'data-type': 'detail',
                    onClick: this.oneSelectDetailCommet,
                    style: detailCommetType == 'detail' ? { color: storeStyle.theme, borderColor: storeStyle.theme } : {},
                    className: detailCommetType == 'detail' ? 'active' : ''
                  },
                  '\u8BE6\u60C5'
                )
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  {
                    'data-type': 'comment',
                    onClick: this.oneSelectDetailCommet,
                    style: detailCommetType == 'comment' ? { color: storeStyle.theme, borderColor: storeStyle.theme } : {},
                    className: 'comment-num-box ' + (detailCommetType == 'comment' ? 'active' : '')
                  },
                  '\u8BC4\u8BBA',
                  React.createElement(
                    'span',
                    { className: 'comment-num' },
                    commentNums[0] == 0 ? '' : commentNums[0]
                  )
                )
              )
            ),
            detailCommetType != 'comment' && React.createElement('div', { className: 'sub-detail rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description } }),
            detailCommetType == 'comment' && React.createElement(
              'div',
              { className: 'sub-comment' },
              React.createElement(
                'div',
                { className: 'comPage-wrap page' },
                React.createElement(
                  'div',
                  { className: 'comPage-top-section' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '0',
                        style: commnetType == 0 ? (0, _defineProperty3.default)({ background: storeStyle.theme }, 'background', storeStyle.theme + '33') : { background: storeStyle.theme + '33' },
                        className: 'comPage-comment-label ' + (commnetType == 0 ? 'active' : '')
                      },
                      '\u5168\u90E8'
                    ),
                    React.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '1',
                        style: commnetType == 1 ? (0, _defineProperty3.default)({ background: storeStyle.theme }, 'background', storeStyle.theme + '33') : { background: storeStyle.theme + '33' },
                        className: 'comPage-comment-label ' + (commnetType == 1 ? 'active' : '')
                      },
                      '\u597D\u8BC4 (',
                      React.createElement(
                        'label',
                        { className: 'comPage-positive-comment' },
                        commentNums[1]
                      ),
                      ')'
                    ),
                    React.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '2',
                        style: commnetType == 2 ? (0, _defineProperty3.default)({ background: storeStyle.theme }, 'background', storeStyle.theme + '33') : { background: storeStyle.theme + '33' },
                        className: 'comPage-comment-label ' + (commnetType == 2 ? 'active' : '')
                      },
                      '\u4E2D\u8BC4 (',
                      React.createElement(
                        'label',
                        { className: 'comPage-neutral-comment' },
                        commentNums[2]
                      ),
                      ')'
                    ),
                    React.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '3',
                        style: commnetType == 3 ? (0, _defineProperty3.default)({ background: storeStyle.theme }, 'background', storeStyle.theme + '33') : { background: storeStyle.theme + '33' },
                        className: 'comPage-comment-label ' + (commnetType == 3 ? 'active' : '')
                      },
                      '\u5DEE\u8BC4 (',
                      React.createElement(
                        'label',
                        { className: 'comPage-negative-comment' },
                        commentNums[3]
                      ),
                      ')'
                    ),
                    React.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '4',
                        style: commnetType == 4 ? (0, _defineProperty3.default)({ background: storeStyle.theme }, 'background', storeStyle.theme + '33') : { background: storeStyle.theme + '33' },
                        className: 'comPage-comment-label ' + (commnetType == 4 ? 'active' : '')
                      },
                      '\u6709\u56FE (',
                      React.createElement(
                        'label',
                        { className: 'comPage-pic-comment' },
                        commentNums[4]
                      ),
                      ')'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'comPage-bottom-section',
                    hidden: displayComment
                  },
                  React.createElement(
                    'div',
                    { className: 'comPage-comment-list' },
                    commentArr.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { className: 'comPage-comment-item', key: index },
                        React.createElement(
                          'div',
                          null,
                          React.createElement('img', {
                            className: 'comPage-comment-photo',
                            src: item.buyer_headimgurl }),
                          React.createElement(
                            'span',
                            { className: 'comPage-comment-name' },
                            item.buyer_nickname
                          )
                        ),
                        React.createElement(
                          'span',
                          { className: 'comPage-comment-date' },
                          item.add_time
                        ),
                        React.createElement(
                          'div',
                          { className: 'comPage-comment-content' },
                          item.assess_info.content
                        ),
                        item.assess_info.has_img && React.createElement(
                          'div',
                          { className: 'comPage-comment-pics' },
                          item.assess_info.img_arr.map(function (imgSrc, index) {
                            return React.createElement('img', {
                              key: index,
                              src: imgSrc,
                              'data-src': imgSrc,
                              'data-srcarr': JSON.stringify(item.assess_info.img_arr),
                              onClick: _this3.clickPlusImages });
                          })
                        )
                      );
                    })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'no-comment', hidden: !displayComment },
                  '\u6682\u65E0\u8BC4\u8BBA'
                )
              )
            )
          )
        ),
        goodsInfo.detail_type == 2 && React.createElement(
          'div',
          { className: 'goods-detail-content styleTwo' },
          React.createElement(
            'div',
            { className: 'goods-header' },
            React.createElement(
              'div',
              { className: 'goods-price' },
              goodsInfo.is_vip_goods != 1 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'goods-current-price' },
                  goodsInfo.integral != '2' ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'real-price',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费')
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    goodsInfo.price != '0.00' && React.createElement(
                      'span',
                      {
                        className: 'real-price',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费')
                    ),
                    goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'span',
                      {
                        className: 'goods-price-discount price-integral',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      '+'
                    ),
                    goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'span',
                      {
                        className: 'goods-price-discount price-integral',
                        style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                      },
                      goodsInfo.max_can_use_integral + '积分'
                    )
                  ),
                  isShowVirtualPrice && goodsInfo.virtual_price != 0 && goodsInfo.goods_type != 1 && React.createElement(
                    'span',
                    { className: 'virtualPrice' },
                    '原价￥' + goodsInfo.virtual_price
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'goods-current-price member-status' },
                  React.createElement(
                    'div',
                    {
                      className: 'member-price real-price',
                      style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                    },
                    React.createElement(
                      'span',
                      { style: { marginRight: '.06rem', fontSize: '.36rem' } },
                      '\xA5'
                    ),
                    React.createElement(
                      'span',
                      { style: { fontWeight: 'bold', fontSize: '.4rem' } },
                      goodsInfo.vip_price
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-logo' },
                    '\u4F1A\u5458\u4EF7'
                  ),
                  React.createElement(
                    'div',
                    { className: 'memebr-origin-price', style: { color: '#999' } },
                    goodsInfo.integral != '2' ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        {
                          className: 'real-price',
                          style: { fontSize: '.24rem', color: '#999' }
                        },
                        '¥ ' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' ? goodsInfo.price : '免费')
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      goodsInfo.price != '0.00' && React.createElement(
                        'span',
                        {
                          className: 'real-price',
                          style: { fontSize: '.24rem', color: '#999' }
                        },
                        '¥' + (goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.goods_type != '1' ? goodsInfo.price : goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 ? goodsInfo.price : goodsInfo.max_can_use_integral != 0 ? '' : '免费')
                      ),
                      goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'goods-price-discount price-integral',
                          style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                        },
                        '+'
                      ),
                      goodsInfo.max_can_use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'goods-price-discount price-integral',
                          style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                        },
                        goodsInfo.max_can_use_integral + '积分'
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'share-goods',
                  onClick: this.showQRCodeComponent
                },
                React.createElement('span', { className: 'ico-moon icon-new-share' })
              ),
              priceDiscountStr != '' && goodsInfo.integral != '2' && React.createElement(
                'div',
                { className: 'goods-price-discount' },
                priceDiscountStr
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-title goods-title-zero' },
              React.createElement(
                'div',
                { className: 'goodsInfo-title' },
                goodsInfo.title
              ),
              goodsInfo.recommend_status && React.createElement(
                'div',
                {
                  className: 'goods-recommended',
                  onClick: this.turnToGoodsRecommend
                },
                React.createElement('span', { className: 'ico-moon icon-like-bold' }),
                '\u597D\u7269\u63A8\u8350'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-coupon', onClick: this.toCouponList },
            React.createElement(
              'span',
              {
                className: 'styleTwo-btn',
                style: { color: storeStyle.theme, borderColor: storeStyle.theme }
              },
              '\u4F18\u60E0\u5238'
            ),
            React.createElement(
              'span',
              null,
              '\u9886\u53D6\u4F18\u60E0\u5238'
            ),
            React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
          ),
          React.createElement(
            'div',
            { className: 'goods-freight' },
            React.createElement(
              'span',
              {
                className: 'styleTwo-btn',
                style: { color: storeStyle.theme, borderColor: storeStyle.theme }
              },
              '\u914D\u9001\u8D39'
            ),
            React.createElement(
              'span',
              null,
              '配送费' + (goodsInfo.express_fee || '包邮')
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-coupon' },
            React.createElement(
              'label',
              null,
              '\u53D6\u8D27\u65B9\u5F0F'
            ),
            React.createElement(
              'div',
              { className: 'address-pick-up' },
              goodsInfo.pick_up_type.map(function (item, index) {
                return React.createElement(
                  'div',
                  { key: index },
                  React.createElement('span', {
                    style: { color: storeStyle.theme },
                    className: 'ico-moon icon-goods-support-delivery suporrt'
                  }),
                  React.createElement(
                    'span',
                    null,
                    item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                  )
                );
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'vip-card-into vip-card3' },
            appBECStoreConfig.card_switch == 1 && (appBECStoreConfig.card_show_type == 1 && goodsInfo.is_vip_goods == 1 || appBECStoreConfig.card_show_type == 2) && React.createElement(
              React.Fragment,
              null,
              appBECStoreConfig.card_detail_type == 1 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast1',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/a.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              ),
              appBECStoreConfig.card_detail_type == 2 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast2',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/b.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              ),
              appBECStoreConfig.card_detail_type == 3 && React.createElement(
                'div',
                {
                  className: 'member-toast-wrap toast3',
                  'data-type': 'ordinary-vip',
                  'data-id': goodsInfo.vip_activity_id,
                  onClick: this.gotoVipBenefits,
                  'data-cardtype': cardtype
                },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: 'http://develop.zhichiwangluo.com/static/webapp/images/vip_price/c.png' })
                ),
                React.createElement(
                  'div',
                  { className: 'member-toast' },
                  React.createElement(
                    'span',
                    { className: 'member-tips' },
                    appBECStoreConfig.card_title
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-comment', hidden: displayComment },
            React.createElement(
              'div',
              { className: 'comment-title' },
              React.createElement(
                'div',
                { className: 'goods-comment-title' },
                '用户怎么说 (' + (commentNums[0] || 0) + ')'
              ),
              React.createElement(
                'div',
                { className: 'go-to-comment', onClick: this.goToCommentPage },
                '\u67E5\u770B\u5168\u90E8'
              )
            ),
            React.createElement(
              'div',
              { className: 'block-item' },
              React.createElement(
                _ScrollView.ScrollView,
                { className: 'comPage-comment-list', 'scroll-x': 'true' },
                commentArr.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { className: 'comPage-comment-item', key: index },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        className: 'comPage-comment-photo',
                        src: item.buyer_headimgurl }),
                      React.createElement(
                        'span',
                        { className: 'comPage-comment-name' },
                        item.buyer_nickname
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'comPage-comment-content' },
                      item.assess_info.content
                    )
                  );
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-recommend' },
            React.createElement(
              'div',
              { className: 'recommend-header' },
              React.createElement('img', {
                src: goodsInfo.app_cover,
                className: 'store-picture' }),
              React.createElement(
                'div',
                { className: 'store-name' },
                goodsInfo.app_name
              ),
              React.createElement(
                'div',
                {
                  className: 'pull-right go-to-store',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            )
          ),
          React.createElement(
            'div',
            { style: { padding: '.3rem', textAlign: 'center', color: '#b2b2b2', fontSize: '.24rem' } },
            React.createElement('div', { className: 'line' }),
            React.createElement(
              'div',
              { style: { display: 'inline-block', verticalAlign: 'middle', margin: '0 4px' } },
              '\u7EE7\u7EED\u62D6\u52A8\uFF0C\u67E5\u770B\u5546\u54C1\u4FE1\u606F'
            ),
            React.createElement('div', { className: 'line' })
          ),
          React.createElement(
            'div',
            { className: 'goods-detail-section' },
            React.createElement(
              'div',
              { className: 'comment-title' },
              React.createElement(
                'div',
                { style: { borderBottom: '1px solid #f4f4f4', paddingBottom: '.2rem' } },
                '\u5546\u54C1\u8BE6\u60C5'
              )
            ),
            React.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g, '') } })
          ),
          !!goodsInfo.recommend_info.length && React.createElement(
            'div',
            { className: 'goods-recommend' },
            React.createElement(
              'div',
              { className: 'two-recommend' },
              '\u5E97\u94FA\u63A8\u8350'
            ),
            React.createElement(
              _ScrollView.ScrollView,
              { className: 'recommend-content', 'scroll-x': 'true' },
              goodsInfo.recommend_info.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'recommend-goods',
                    key: item.form_data.id,
                    onClick: _this3.toRecommendGoodsDetail,
                    'data-id': item.form_data.id,
                    'data-goods-type': item.form_data.goods_type
                  },
                  React.createElement(
                    'div',
                    { className: 'width-fix-image' },
                    React.createElement('img', {
                      mode: 'widthFix',
                      src: item.form_data.cover })
                  ),
                  React.createElement(
                    'div',
                    { className: 'recommend-goods-title' },
                    item.form_data.title
                  ),
                  React.createElement(
                    'span',
                    { className: 'recommend-goods-price' },
                    '¥' + item.form_data.price
                  )
                );
              })
            )
          )
        ),
        goodsInfo.detail_type == 2 && React.createElement(
          'div',
          { className: 'goods-bottom-two' },
          React.createElement(
            'div',
            { className: 'bottom-two-left' },
            React.createElement(
              'div',
              null,
              React.createElement('div', { className: 'ico-moon icon-service2' }),
              React.createElement(
                'div',
                null,
                '\u5BA2\u670D'
              )
            ),
            !franchiseeId && React.createElement(
              'div',
              { className: 'form-two-contain' },
              React.createElement(
                'form',
                null,
                React.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                  React.createElement('span', {
                    style: goodsInfo.is_favorite == 1 ? { color: storeStyle.theme } : {},
                    className: 'ico-moon icon-' + (goodsInfo.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites')
                  }),
                  React.createElement(
                    'div',
                    null,
                    '\u6536\u85CF'
                  )
                )
              )
            ),
            goodsInfo.integral != '2' && React.createElement(
              'div',
              { onClick: this.goToShoppingCart },
              React.createElement('span', { className: 'ico-moon icon-new-goods-shopping' }),
              React.createElement(
                'div',
                null,
                '\u8D2D\u7269\u8F66'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'bottom-two-right' },
            goodsInfo.integral != '2' && React.createElement(
              'label',
              {
                className: 'add-to-shoppingCart',
                style: { borderColor: storeStyle.theme, color: storeStyle.theme },
                onClick: this.showAddToShoppingCart
              },
              '\u52A0\u5165\u8D2D\u7269\u8F66'
            ),
            React.createElement(
              'label',
              {
                className: 'buy-goods-directly',
                onClick: this.showBuyDirectly,
                style: goodsInfo.integral == '2' ? { width: '4.75rem', background: storeStyle.theme } : { background: storeStyle.theme }
              },
              '\u7ACB\u5373\u8D2D\u4E70'
            )
          )
        ),
        React.createElement(
          'div',
          {
            id: 'payDialog',
            className: 'page-dialog-wrap',
            hidden: addToShoppingCartHidden
          },
          React.createElement(
            'div',
            { className: 'page-bottom-dialog' },
            React.createElement(
              'div',
              {
                className: 'pay-close-dialog page-dialog-close',
                onClick: this.hiddeAddToShoppingCart
              },
              React.createElement('span', { className: 'ico-moon icon-closes' })
            ),
            React.createElement(
              'div',
              { className: 'dialog-goods-header' },
              React.createElement(
                'div',
                { className: 'thumb' },
                React.createElement(
                  'div',
                  { className: 'thumb-wrap' },
                  React.createElement('img', {
                    'data-src': selectModelInfo.imgurl || goodsInfo.cover,
                    onClick: this.clickPlusImages,
                    className: 'pay-goods-cover',
                    src: selectModelInfo.imgurl || goodsInfo.cover })
                )
              ),
              React.createElement(
                'div',
                { className: 'pay-goods-baseinfo' },
                React.createElement(
                  'div',
                  { className: 'pay-goods-price' },
                  goodsInfo.is_vip_goods != 1 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'pay-current-price' },
                      selectModelInfo.price != '0.00' && React.createElement(
                        'span',
                        {
                          style: { color: storeStyle.theme }
                        },
                        '¥' + selectModelInfo.price
                      ),
                      goodsInfo.integral == '2' ? React.createElement(
                        React.Fragment,
                        null,
                        selectModelInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                          },
                          '+'
                        ),
                        goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            style: goodsInfo.goods_type != 0 ? {} : { color: storeStyle.theme }
                          },
                          goodsInfo.max_can_use_integral + '积分'
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        priceDiscountStr != '' && React.createElement(
                          'span',
                          { className: 'goods-price-discount' },
                          priceDiscountStr
                        )
                      ),
                      isShowVirtualPrice && selectModelInfo.virtualPrice != 0 && goodsInfo.goods_type != 1 && React.createElement(
                        'span',
                        { className: 'virtualPrice' },
                        '￥' + selectModelInfo.virtualPrice
                      )
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'pay-current-price member-status' },
                      React.createElement(
                        'div',
                        { className: 'member-price' },
                        React.createElement(
                          'span',
                          null,
                          '\xA5'
                        ),
                        React.createElement(
                          'span',
                          null,
                          selectModelInfo.vipPrice
                        )
                      ),
                      selectModelInfo.vipPrice != selectModelInfo.price && React.createElement(
                        'div',
                        { className: 'member-logo', style: { bottom: 0 } },
                        '\u4F1A\u5458\u4EF7'
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'memebr-origin-price',
                          style: { color: '#999' }
                        },
                        isShowVirtualPrice && selectModelInfo.virtualPrice != 0 && goodsInfo.goods_type != 1 && React.createElement(
                          'span',
                          { className: 'virtualPrice' },
                          '￥' + selectModelInfo.virtualPrice
                        )
                      )
                    )
                  )
                ),
                showStock && React.createElement(
                  'div',
                  { className: 'pay-goods-stock' },
                  '库存 ' + selectModelInfo.stock
                ),
                selectModelInfo.models_text && React.createElement(
                  'div',
                  { className: 'pay-checked-text clearfix' },
                  '已选：' + selectModelInfo.models_text
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'payDialog-content' },
              React.createElement(
                'div',
                {
                  className: 'pay-goods-models',
                  hidden: !(goodsInfo.model_items && goodsInfo.model_items.length)
                },
                goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                  return React.createElement(
                    'div',
                    { key: modelIndex },
                    React.createElement(
                      'span',
                      { className: 'model-title' },
                      model.name
                    ),
                    React.createElement(
                      'label',
                      { className: 'pills-list' },
                      model && model.subModelName && model.subModelName.map(function (name, index) {
                        return React.createElement(
                          'label',
                          {
                            key: index,
                            'data-model-index': modelIndex,
                            'data-submodel-index': index,
                            className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                            'data-submodel-id': model.subModelId[index],
                            onClick: _this3.selectSubModel,
                            style: selectModelInfo.models[modelIndex] == model.subModelId[index] ? { background: storeStyle.theme } : {}
                          },
                          name
                        );
                      })
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                {
                  className: 'payDialog-buy-num',
                  style: { paddingLeft: '.2rem', paddingRight: '.2rem' }
                },
                React.createElement(
                  'div',
                  { className: 'clearfix' },
                  React.createElement(
                    'span',
                    null,
                    '\u8D2D\u4E70\u6570\u91CF'
                  ),
                  React.createElement(
                    'div',
                    { className: 'pull-right' },
                    React.createElement(
                      'div',
                      { className: 'quantity pull-left' },
                      React.createElement('label', {
                        className: 'minus ' + (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                      }),
                      React.createElement('input', (_React$createElement = {
                        className: 'pay-buy-count',
                        type: 'number'
                      }, (0, _defineProperty3.default)(_React$createElement, 'className', 'txt'), (0, _defineProperty3.default)(_React$createElement, 'value', selectModelInfo.buyCount), (0, _defineProperty3.default)(_React$createElement, 'onChange', this.inputBuyCount), _React$createElement)),
                      React.createElement('label', {
                        className: 'plus ' + (selectModelInfo.buyCount >= selectModelInfo.stock || selectModelInfo.buyCount >= goodsInfo.seckill_buy_limit ? 'disabled' : '')
                      }),
                      React.createElement('div', {
                        className: 'response-area response-area-minus',
                        onClick: this.clickMinusButton
                      }),
                      React.createElement('div', {
                        className: 'response-area response-area-plus',
                        onClick: this.clickPlusButton
                      })
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'dialog-bottom' },
              React.createElement(
                'div',
                { hidden: ifAddToShoppingCart },
                React.createElement(
                  'div',
                  {
                    style: { background: storeStyle.theme },
                    className: 'btn-orange pay-buy-next',
                    onClick: this.buyDirectlyNextStep
                  },
                  '\u4E0B\u4E00\u6B65'
                )
              ),
              React.createElement(
                'div',
                { hidden: !ifAddToShoppingCart },
                goodsInfo.integral != '2' && React.createElement(
                  'div',
                  {
                    style: { background: storeStyle.theme },
                    className: 'pay-add-to-shoppingcart',
                    onClick: this.sureAddToShoppingCart
                  },
                  '\u52A0\u5165\u8D2D\u7269\u8F66'
                )
              )
            )
          )
        ),
        showFootPrint && React.createElement(
          'div',
          { className: 'foot-print-contain', onClick: this.hideFootPrint },
          React.createElement(
            'div',
            {
              className: 'foot-print-box',
              animation: animationData,
              onClick: this.stopPropagation
            },
            React.createElement(
              'div',
              { className: 'foot-print-header' },
              '我的足迹(' + (1 - footPrintIndex) + '/' + goodsViewRecordList.length + ')'
            ),
            React.createElement(
              'div',
              {
                className: 'foot-print-list',
                style: { left: 2.76 * footPrintIndex + 'rem' },
                onTouchStart: this.startFoot,
                onTouchEnd: this.endFoot
              },
              goodsViewRecordList.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'foot-print-goods ' + (footPrintIndex + index == 0 ? 'selected' : ''),
                    'data-id': item.id,
                    onClick: footPrintIndex + index == 0 && item.status != 1 ? 'goFootPrintDetail' : '',
                    key: item.id
                  },
                  React.createElement('img', { src: item.cover }),
                  React.createElement(
                    'div',
                    { className: 'foot-print-title' },
                    item.title
                  ),
                  React.createElement(
                    'div',
                    { className: 'foot-print-price' },
                    '¥' + item.price,
                    item.status == 1 && React.createElement(
                      'span',
                      { className: 'foot-invalid' },
                      '\u5931\u6548'
                    )
                  )
                );
              })
            ),
            footPrintIndex < 0 && React.createElement('div', {
              className: 'ico-moon icon-leftarrow foot-print-right',
              onClick: this.footPrintLeft
            }),
            goodsViewRecordList.length + footPrintIndex > 1 && React.createElement('div', {
              className: 'ico-moon icon-rightarrow foot-print-left',
              onClick: this.footPrintRight
            }),
            1 - footPrintIndex >= 10 && React.createElement(
              'div',
              {
                className: 'foot-print-more',
                onClick: this.toGoodsFootPrint
              },
              React.createElement(
                'span',
                null,
                '\u67E5\u770B\u66F4\u591A'
              )
            )
          )
        )
      );
    }
  }]);
  return GoodsDetail;
}(_OfficialPage3.default);

exports.default = GoodsDetail;

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// CONCATENATED MODULE: ./node_modules/rmc-nuka-carousel/es/decorators.js







var DefaultDecorators = [{
    component: function (_React$Component) {
        inherits_default()(component, _React$Component);

        function component() {
            classCallCheck_default()(this, component);

            var _this = possibleConstructorReturn_default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));

            _this.handleClick = function (e) {
                e.preventDefault();
                _this.props.previousSlide();
            };
            return _this;
        }

        createClass_default()(component, [{
            key: 'render',
            value: function render() {
                return external__React__default.a.createElement(
                    'button',
                    { style: this.getButtonStyles(this.props.currentSlide === 0 && !this.props.wrapAround), onClick: this.handleClick },
                    'PREV'
                );
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(disabled) {
                return {
                    border: 0,
                    background: 'rgba(0,0,0,0.4)',
                    color: 'white',
                    padding: 10,
                    outline: 0,
                    opacity: disabled ? 0.3 : 1,
                    cursor: 'pointer'
                };
            }
        }]);

        return component;
    }(external__React__default.a.Component),
    position: 'CenterLeft'
}, {
    component: function (_React$Component2) {
        inherits_default()(component, _React$Component2);

        function component() {
            classCallCheck_default()(this, component);

            var _this2 = possibleConstructorReturn_default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));

            _this2.handleClick = function (e) {
                e.preventDefault();
                if (_this2.props.nextSlide) {
                    _this2.props.nextSlide();
                }
            };
            return _this2;
        }

        createClass_default()(component, [{
            key: 'render',
            value: function render() {
                return external__React__default.a.createElement(
                    'button',
                    { style: this.getButtonStyles(this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround), onClick: this.handleClick },
                    'NEXT'
                );
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(disabled) {
                return {
                    border: 0,
                    background: 'rgba(0,0,0,0.4)',
                    color: 'white',
                    padding: 10,
                    outline: 0,
                    opacity: disabled ? 0.3 : 1,
                    cursor: 'pointer'
                };
            }
        }]);

        return component;
    }(external__React__default.a.Component),
    position: 'CenterRight'
}, {
    component: function (_React$Component3) {
        inherits_default()(component, _React$Component3);

        function component() {
            classCallCheck_default()(this, component);

            return possibleConstructorReturn_default()(this, (component.__proto__ || Object.getPrototypeOf(component)).apply(this, arguments));
        }

        createClass_default()(component, [{
            key: 'render',
            value: function render() {
                var _this4 = this;

                var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
                return external__React__default.a.createElement(
                    'ul',
                    { style: this.getListStyles() },
                    indexes.map(function (index) {
                        return external__React__default.a.createElement(
                            'li',
                            { style: _this4.getListItemStyles(), key: index },
                            external__React__default.a.createElement(
                                'button',
                                { style: _this4.getButtonStyles(_this4.props.currentSlide === index), onClick: _this4.props.goToSlide && _this4.props.goToSlide.bind(null, index) },
                                '\u2022'
                            )
                        );
                    })
                );
            }
        }, {
            key: 'getIndexes',
            value: function getIndexes(count, inc) {
                var arr = [];
                for (var i = 0; i < count; i += inc) {
                    arr.push(i);
                }
                return arr;
            }
        }, {
            key: 'getListStyles',
            value: function getListStyles() {
                return {
                    position: 'relative',
                    margin: 0,
                    top: -10,
                    padding: 0
                };
            }
        }, {
            key: 'getListItemStyles',
            value: function getListItemStyles() {
                return {
                    listStyleType: 'none',
                    display: 'inline-block'
                };
            }
        }, {
            key: 'getButtonStyles',
            value: function getButtonStyles(active) {
                return {
                    border: 0,
                    background: 'transparent',
                    color: 'black',
                    cursor: 'pointer',
                    padding: 10,
                    outline: 0,
                    fontSize: 24,
                    opacity: active ? 1 : 0.5
                };
            }
        }]);

        return component;
    }(external__React__default.a.Component),
    position: 'BottomCenter'
}];
/* harmony default export */ var decorators = (DefaultDecorators);
// EXTERNAL MODULE: ./node_modules/exenv/index.js
var exenv = __webpack_require__(407);
var exenv_default = /*#__PURE__*/__webpack_require__.n(exenv);

// EXTERNAL MODULE: ./node_modules/raf/index.js
var raf = __webpack_require__(408);
var raf_default = /*#__PURE__*/__webpack_require__.n(raf);

// CONCATENATED MODULE: ./node_modules/rmc-nuka-carousel/es/carousel.js











// from https://github.com/chenglou/tween-functions
function easeOutCirc(t, b, _c, d) {
    var c = _c - b;
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
}
function linear(t, b, _c, d) {
    var c = _c - b;
    return c * t / d + b;
}
var DEFAULT_STACK_BEHAVIOR = 'ADDITIVE';
var DEFAULT_DURATION = 300;
var DEFAULT_DELAY = 0;
var stackBehavior = {
    ADDITIVE: 'ADDITIVE',
    DESTRUCTIVE: 'DESTRUCTIVE'
};
var addEvent = function addEvent(elem, type, eventHandle) {
    if (elem === null || typeof elem === 'undefined') {
        return;
    }
    if (elem.addEventListener) {
        elem.addEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.attachEvent('on' + type, eventHandle);
    } else {
        elem['on' + type] = eventHandle;
    }
};
var removeEvent = function removeEvent(elem, type, eventHandle) {
    if (elem === null || typeof elem === 'undefined') {
        return;
    }
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.detachEvent) {
        elem.detachEvent('on' + type, eventHandle);
    } else {
        elem['on' + type] = null;
    }
};

var carousel_Carousel = function (_React$Component) {
    inherits_default()(Carousel, _React$Component);

    function Carousel(props) {
        classCallCheck_default()(this, Carousel);

        var _this = possibleConstructorReturn_default()(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));

        _this._rafCb = function () {
            var state = _this.state;
            if (state.tweenQueue.length === 0) {
                return;
            }
            var now = Date.now();
            var newTweenQueue = [];
            for (var i = 0; i < state.tweenQueue.length; i++) {
                var item = state.tweenQueue[i];
                var initTime = item.initTime,
                    config = item.config;

                if (now - initTime < config.duration) {
                    newTweenQueue.push(item);
                } else {
                    if (config.onEnd) {
                        config.onEnd();
                    }
                }
            }
            // onEnd might trigger a parent callback that removes this component
            // -1 means we've canceled it in componentWillUnmount
            if (_this._rafID === -1) {
                return;
            }
            _this.setState({
                tweenQueue: newTweenQueue
            });
            _this._rafID = raf_default()(_this._rafCb);
        };
        _this.handleClick = function (e) {
            if (_this.clickSafe === true) {
                e.preventDefault();
                e.stopPropagation();
                if (e.nativeEvent) {
                    e.nativeEvent.stopPropagation();
                }
            }
        };
        _this.autoplayIterator = function () {
            if (_this.props.wrapAround) {
                return _this.nextSlide();
            }
            if (_this.state.currentSlide !== _this.state.slideCount - _this.state.slidesToShow) {
                _this.nextSlide();
            } else {
                _this.stopAutoplay();
            }
        };
        // Action Methods
        _this.goToSlide = function (index) {
            var _this$props = _this.props,
                beforeSlide = _this$props.beforeSlide,
                afterSlide = _this$props.afterSlide;

            if (index >= external__React__default.a.Children.count(_this.props.children) || index < 0) {
                if (!_this.props.wrapAround) {
                    return;
                }
                ;
                if (index >= external__React__default.a.Children.count(_this.props.children)) {
                    beforeSlide(_this.state.currentSlide, 0);
                    return _this.setState({
                        currentSlide: 0
                    }, function () {
                        _this.animateSlide(null, null, _this.getTargetLeft(null, index), function () {
                            _this.animateSlide(null, 0.01);
                            afterSlide(0);
                            _this.resetAutoplay();
                            _this.setExternalData();
                        });
                    });
                } else {
                    var endSlide = external__React__default.a.Children.count(_this.props.children) - _this.state.slidesToScroll;
                    beforeSlide(_this.state.currentSlide, endSlide);
                    return _this.setState({
                        currentSlide: endSlide
                    }, function () {
                        _this.animateSlide(null, null, _this.getTargetLeft(null, index), function () {
                            _this.animateSlide(null, 0.01);
                            afterSlide(endSlide);
                            _this.resetAutoplay();
                            _this.setExternalData();
                        });
                    });
                }
            }
            beforeSlide(_this.state.currentSlide, index);
            _this.setState({
                currentSlide: index
            }, function () {
                _this.animateSlide();
                _this.props.afterSlide(index);
                _this.resetAutoplay();
                _this.setExternalData();
            });
        };
        _this.nextSlide = function () {
            var childrenCount = external__React__default.a.Children.count(_this.props.children);
            var slidesToShow = _this.props.slidesToShow;
            if (_this.props.slidesToScroll === 'auto') {
                slidesToShow = _this.state.slidesToScroll;
            }
            if (_this.state.currentSlide >= childrenCount - slidesToShow && !_this.props.wrapAround) {
                return;
            }
            if (_this.props.wrapAround) {
                _this.goToSlide(_this.state.currentSlide + _this.state.slidesToScroll);
            } else {
                if (_this.props.slideWidth !== 1) {
                    return _this.goToSlide(_this.state.currentSlide + _this.state.slidesToScroll);
                }
                _this.goToSlide(Math.min(_this.state.currentSlide + _this.state.slidesToScroll, childrenCount - slidesToShow));
            }
        };
        _this.previousSlide = function () {
            if (_this.state.currentSlide <= 0 && !_this.props.wrapAround) {
                return;
            }
            if (_this.props.wrapAround) {
                _this.goToSlide(_this.state.currentSlide - _this.state.slidesToScroll);
            } else {
                _this.goToSlide(Math.max(0, _this.state.currentSlide - _this.state.slidesToScroll));
            }
        };
        _this.onResize = function () {
            _this.setDimensions();
        };
        _this.onReadyStateChange = function () {
            _this.setDimensions();
        };
        _this.state = {
            currentSlide: _this.props.slideIndex,
            dragging: false,
            frameWidth: 0,
            left: 0,
            slideCount: 0,
            slidesToScroll: _this.props.slidesToScroll,
            slideWidth: 0,
            top: 0,
            tweenQueue: []
        };
        _this.touchObject = {};
        _this.clickSafe = true;
        return _this;
    }

    createClass_default()(Carousel, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.setInitialDimensions();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setDimensions();
            this.bindEvents();
            this.setExternalData();
            if (this.props.autoplay) {
                this.startAutoplay();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({
                slideCount: nextProps.children.length
            });
            this.setDimensions(nextProps);
            if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide) {
                this.goToSlide(nextProps.slideIndex);
            }
            if (this.props.autoplay !== nextProps.autoplay) {
                if (nextProps.autoplay) {
                    this.startAutoplay();
                } else {
                    this.stopAutoplay();
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unbindEvents();
            this.stopAutoplay();
            raf_default.a.cancel(this._rafID);
            this._rafID = -1;
        }
        // react-tween-state

    }, {
        key: 'tweenState',
        value: function tweenState(path, _ref) {
            var _this2 = this;

            var easing = _ref.easing,
                duration = _ref.duration,
                delay = _ref.delay,
                beginValue = _ref.beginValue,
                endValue = _ref.endValue,
                onEnd = _ref.onEnd,
                configSB = _ref.stackBehavior;

            this.setState(function (state) {
                var cursor = state;
                var stateName = void 0;
                // see comment below on pash hash
                var pathHash = void 0;
                if (typeof path === 'string') {
                    stateName = path;
                    pathHash = path;
                } else {
                    for (var i = 0; i < path.length - 1; i++) {
                        cursor = cursor[path[i]];
                    }
                    stateName = path[path.length - 1];
                    pathHash = path.join('|');
                }
                // see the reasoning for these defaults at the top of file
                var newConfig = {
                    easing: easing,
                    duration: duration == null ? DEFAULT_DURATION : duration,
                    delay: delay == null ? DEFAULT_DELAY : delay,
                    beginValue: beginValue == null ? cursor[stateName] : beginValue,
                    endValue: endValue,
                    onEnd: onEnd,
                    stackBehavior: configSB || DEFAULT_STACK_BEHAVIOR
                };
                var newTweenQueue = state.tweenQueue;
                if (newConfig.stackBehavior === stackBehavior.DESTRUCTIVE) {
                    newTweenQueue = state.tweenQueue.filter(function (item) {
                        return item.pathHash !== pathHash;
                    });
                }
                // we store path hash, so that during value retrieval we can use hash
                // comparison to find the path. See the kind of shitty thing you have to
                // do when you don't have value comparison for collections?
                newTweenQueue.push({
                    pathHash: pathHash,
                    config: newConfig,
                    initTime: Date.now() + newConfig.delay
                });
                // sorry for mutating. For perf reasons we don't want to deep clone.
                // guys, can we please all start using persistent collections so that
                // we can stop worrying about nonesense like this
                cursor[stateName] = newConfig.endValue;
                if (newTweenQueue.length === 1) {
                    _this2._rafID = raf_default()(_this2._rafCb);
                }
                // this will also include the above mutated update
                return { tweenQueue: newTweenQueue };
            });
        }
    }, {
        key: 'getTweeningValue',
        value: function getTweeningValue(path) {
            var state = this.state;
            var tweeningValue = void 0;
            var pathHash = void 0;
            if (typeof path === 'string') {
                tweeningValue = state[path];
                pathHash = path;
            } else {
                tweeningValue = state;
                for (var i = 0; i < path.length; i++) {
                    tweeningValue = tweeningValue[path[i]];
                }
                pathHash = path.join('|');
            }
            var now = Date.now();
            for (var _i = 0; _i < state.tweenQueue.length; _i++) {
                var _state$tweenQueue$_i = state.tweenQueue[_i],
                    itemPathHash = _state$tweenQueue$_i.pathHash,
                    initTime = _state$tweenQueue$_i.initTime,
                    config = _state$tweenQueue$_i.config;

                if (itemPathHash !== pathHash) {
                    continue;
                }
                var progressTime = now - initTime > config.duration ? config.duration : Math.max(0, now - initTime);
                // `now - initTime` can be negative if initTime is scheduled in the
                // future by a delay. In this case we take 0
                // if duration is 0, consider that as jumping to endValue directly. This
                // is needed because the easing functino might have undefined behavior for
                // duration = 0
                var easeValue = config.duration === 0 ? config.endValue : config.easing(progressTime, config.beginValue, config.endValue, config.duration);
                var contrib = easeValue - config.endValue;
                tweeningValue += contrib;
            }
            return tweeningValue;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var children = external__React__default.a.Children.count(this.props.children) > 1 ? this.formatChildren(this.props.children) : this.props.children;
            return external__React__default.a.createElement(
                'div',
                { className: ['slider', this.props.className || ''].join(' '), ref: 'slider', style: extends_default()({}, this.getSliderStyles(), this.props.style) },
                external__React__default.a.createElement(
                    'div',
                    extends_default()({ className: 'slider-frame', ref: 'frame', style: this.getFrameStyles() }, this.getTouchEvents(), this.getMouseEvents(), { onClick: this.handleClick }),
                    external__React__default.a.createElement(
                        'ul',
                        { className: 'slider-list', ref: 'list', style: this.getListStyles() },
                        children
                    )
                ),
                this.props.decorators ? this.props.decorators.map(function (Decorator, index) {
                    return external__React__default.a.createElement(
                        'div',
                        { style: extends_default()({}, _this3.getDecoratorStyles(Decorator.position), Decorator.style || {}), className: 'slider-decorator-' + index, key: index },
                        external__React__default.a.createElement(Decorator.component, { currentSlide: _this3.state.currentSlide, slideCount: _this3.state.slideCount, frameWidth: _this3.state.frameWidth, slideWidth: _this3.state.slideWidth, slidesToScroll: _this3.state.slidesToScroll, cellSpacing: _this3.props.cellSpacing, slidesToShow: _this3.props.slidesToShow, wrapAround: _this3.props.wrapAround, nextSlide: _this3.nextSlide, previousSlide: _this3.previousSlide, goToSlide: _this3.goToSlide })
                    );
                }) : null,
                external__React__default.a.createElement('style', { type: 'text/css', dangerouslySetInnerHTML: { __html: this.getStyleTagStyles() } })
            );
        }
        // Touch Events

    }, {
        key: 'getTouchEvents',
        value: function getTouchEvents() {
            var self = this;
            if (this.props.swiping === false) {
                return null;
            }
            return {
                onTouchStart: function onTouchStart(e) {
                    self.touchObject = {
                        startX: e.touches[0].pageX,
                        startY: e.touches[0].pageY
                    };
                    self.handleMouseOver();
                },
                onTouchMove: function onTouchMove(e) {
                    var direction = self.swipeDirection(self.touchObject.startX, e.touches[0].pageX, self.touchObject.startY, e.touches[0].pageY);
                    if (direction !== 0) {
                        e.preventDefault();
                    }
                    var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - self.touchObject.startX, 2)));
                    self.touchObject = {
                        startX: self.touchObject.startX,
                        startY: self.touchObject.startY,
                        endX: e.touches[0].pageX,
                        endY: e.touches[0].pageY,
                        length: length,
                        direction: direction
                    };
                    self.setState({
                        left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
                        top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
                    });
                },
                onTouchEnd: function onTouchEnd(e) {
                    self.handleSwipe(e);
                    self.handleMouseOut();
                },
                onTouchCancel: function onTouchCancel(e) {
                    self.handleSwipe(e);
                }
            };
        }
    }, {
        key: 'getMouseEvents',
        value: function getMouseEvents() {
            var self = this;
            if (this.props.dragging === false) {
                return null;
            }
            return {
                onMouseOver: function onMouseOver() {
                    self.handleMouseOver();
                },
                onMouseOut: function onMouseOut() {
                    self.handleMouseOut();
                },
                onMouseDown: function onMouseDown(e) {
                    self.touchObject = {
                        startX: e.clientX,
                        startY: e.clientY
                    };
                    self.setState({
                        dragging: true
                    });
                },
                onMouseMove: function onMouseMove(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    var direction = self.swipeDirection(self.touchObject.startX, e.clientX, self.touchObject.startY, e.clientY);
                    if (direction !== 0) {
                        e.preventDefault();
                    }
                    var length = self.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - self.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - self.touchObject.startX, 2)));
                    self.touchObject = {
                        startX: self.touchObject.startX,
                        startY: self.touchObject.startY,
                        endX: e.clientX,
                        endY: e.clientY,
                        length: length,
                        direction: direction
                    };
                    self.setState({
                        left: self.props.vertical ? 0 : self.getTargetLeft(self.touchObject.length * self.touchObject.direction),
                        top: self.props.vertical ? self.getTargetLeft(self.touchObject.length * self.touchObject.direction) : 0
                    });
                },
                onMouseUp: function onMouseUp(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    self.handleSwipe(e);
                },
                onMouseLeave: function onMouseLeave(e) {
                    if (!self.state.dragging) {
                        return;
                    }
                    self.handleSwipe(e);
                }
            };
        }
    }, {
        key: 'handleMouseOver',
        value: function handleMouseOver() {
            if (this.props.autoplay) {
                this.autoplayPaused = true;
                this.stopAutoplay();
            }
        }
    }, {
        key: 'handleMouseOut',
        value: function handleMouseOut() {
            if (this.props.autoplay && this.autoplayPaused) {
                this.startAutoplay();
                this.autoplayPaused = null;
            }
        }
    }, {
        key: 'handleSwipe',
        value: function handleSwipe(_) {
            if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
                this.clickSafe = true;
            } else {
                this.clickSafe = false;
            }
            var _props = this.props,
                slidesToShow = _props.slidesToShow,
                slidesToScroll = _props.slidesToScroll,
                swipeSpeed = _props.swipeSpeed;
            // var slidesToShow = this.props.slidesToShow;

            if (slidesToScroll === 'auto') {
                slidesToShow = this.state.slidesToScroll;
            }
            if (external__React__default.a.Children.count(this.props.children) > 1 && this.touchObject.length > this.state.slideWidth / slidesToShow / swipeSpeed) {
                if (this.touchObject.direction === 1) {
                    if (this.state.currentSlide >= external__React__default.a.Children.count(this.props.children) - slidesToShow && !this.props.wrapAround) {
                        this.animateSlide(this.props.edgeEasing);
                    } else {
                        this.nextSlide();
                    }
                } else if (this.touchObject.direction === -1) {
                    if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
                        this.animateSlide(this.props.edgeEasing);
                    } else {
                        this.previousSlide();
                    }
                }
            } else {
                this.goToSlide(this.state.currentSlide);
            }
            this.touchObject = {};
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'swipeDirection',
        value: function swipeDirection(x1, x2, y1, y2) {
            var xDist = x1 - x2;
            var yDist = y1 - y2;
            var r = Math.atan2(yDist, xDist);
            var swipeAngle = Math.round(r * 180 / Math.PI);
            if (swipeAngle < 0) {
                swipeAngle = 360 - Math.abs(swipeAngle);
            }
            if (swipeAngle <= 45 && swipeAngle >= 0) {
                return 1;
            }
            if (swipeAngle <= 360 && swipeAngle >= 315) {
                return 1;
            }
            if (swipeAngle >= 135 && swipeAngle <= 225) {
                return -1;
            }
            if (this.props.vertical === true) {
                if (swipeAngle >= 35 && swipeAngle <= 135) {
                    return 1;
                } else {
                    return -1;
                }
            }
            return 0;
        }
    }, {
        key: 'startAutoplay',
        value: function startAutoplay() {
            if (external__React__default.a.Children.count(this.props.children) <= 1) {
                return;
            }
            this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
        }
    }, {
        key: 'resetAutoplay',
        value: function resetAutoplay() {
            if (this.props.resetAutoplay && this.props.autoplay && !this.autoplayPaused) {
                this.stopAutoplay();
                this.startAutoplay();
            }
        }
    }, {
        key: 'stopAutoplay',
        value: function stopAutoplay() {
            if (this.autoplayID) {
                clearInterval(this.autoplayID);
            }
        }
        // Animation

    }, {
        key: 'animateSlide',
        value: function animateSlide(easing, duration, endValue, callback) {
            this.tweenState(this.props.vertical ? 'top' : 'left', {
                easing: easing || this.props.easing,
                duration: duration || this.props.speed,
                endValue: endValue || this.getTargetLeft(),
                delay: null,
                beginValue: null,
                onEnd: callback || null,
                stackBehavior: stackBehavior
            });
        }
    }, {
        key: 'getTargetLeft',
        value: function getTargetLeft(touchOffset, slide) {
            var offset = void 0;
            var target = slide || this.state.currentSlide;
            var cellSpacing = this.props.cellSpacing;
            switch (this.props.cellAlign) {
                case 'left':
                    {
                        offset = 0;
                        offset -= cellSpacing * target;
                        break;
                    }
                case 'center':
                    {
                        offset = (this.state.frameWidth - this.state.slideWidth) / 2;
                        offset -= cellSpacing * target;
                        break;
                    }
                case 'right':
                    {
                        offset = this.state.frameWidth - this.state.slideWidth;
                        offset -= cellSpacing * target;
                        break;
                    }
                default:
                    break;
            }
            var left = this.state.slideWidth * target;
            var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;
            if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
                left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
                offset = 0;
                offset -= cellSpacing * (this.state.slideCount - 1);
            }
            offset -= touchOffset || 0;
            return (left - offset) * -1;
        }
        // Bootstrapping

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            if (exenv_default.a.canUseDOM) {
                addEvent(window, 'resize', this.onResize);
                addEvent(document, 'readystatechange', this.onReadyStateChange);
            }
        }
    }, {
        key: 'unbindEvents',
        value: function unbindEvents() {
            if (exenv_default.a.canUseDOM) {
                removeEvent(window, 'resize', this.onResize);
                removeEvent(document, 'readystatechange', this.onReadyStateChange);
            }
        }
    }, {
        key: 'formatChildren',
        value: function formatChildren(children) {
            var _this4 = this;

            var positionValue = this.props.vertical ? this.getTweeningValue('top') : this.getTweeningValue('left');
            return external__React__default.a.Children.map(children, function (child, index) {
                return external__React__default.a.createElement(
                    'li',
                    { className: 'slider-slide', style: _this4.getSlideStyles(index, positionValue), key: index },
                    child
                );
            });
        }
    }, {
        key: 'setInitialDimensions',
        value: function setInitialDimensions() {
            var _this5 = this;

            var _props2 = this.props,
                vertical = _props2.vertical,
                initialSlideHeight = _props2.initialSlideHeight,
                initialSlideWidth = _props2.initialSlideWidth,
                slidesToShow = _props2.slidesToShow,
                cellSpacing = _props2.cellSpacing,
                children = _props2.children;

            var slideWidth = vertical ? initialSlideHeight || 0 : initialSlideWidth || 0;
            var slideHeight = initialSlideHeight ? initialSlideHeight * slidesToShow : 0;
            var frameHeight = slideHeight + cellSpacing * (slidesToShow - 1);
            this.setState({
                slideHeight: slideHeight,
                frameWidth: vertical ? frameHeight : '100%',
                slideCount: external__React__default.a.Children.count(children),
                slideWidth: slideWidth
            }, function () {
                _this5.setLeft();
                _this5.setExternalData();
            });
        }
    }, {
        key: 'setDimensions',
        value: function setDimensions(props) {
            var _this6 = this;

            props = props || this.props;
            var frameWidth = void 0;
            var frameHeight = void 0;
            var slideHeight = void 0;
            var slideWidth = void 0;
            var slidesToScroll = props.slidesToScroll;
            var frame = this.refs.frame;
            var firstSlide = frame.childNodes[0].childNodes[0];
            if (firstSlide) {
                firstSlide.style.height = 'auto';
                slideHeight = this.props.vertical ? firstSlide.offsetHeight * props.slidesToShow : firstSlide.offsetHeight;
            } else {
                slideHeight = 100;
            }
            if (typeof props.slideWidth !== 'number') {
                slideWidth = parseInt(props.slideWidth, 10);
            } else {
                if (props.vertical) {
                    slideWidth = slideHeight / props.slidesToShow * props.slideWidth;
                } else {
                    slideWidth = frame.offsetWidth / props.slidesToShow * props.slideWidth;
                }
            }
            if (!props.vertical) {
                slideWidth -= props.cellSpacing * ((100 - 100 / props.slidesToShow) / 100);
            }
            frameHeight = slideHeight + props.cellSpacing * (props.slidesToShow - 1);
            frameWidth = props.vertical ? frameHeight : frame.offsetWidth;
            if (props.slidesToScroll === 'auto') {
                slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
            }
            this.setState({
                slideHeight: slideHeight,
                frameWidth: frameWidth,
                slideWidth: slideWidth,
                slidesToScroll: slidesToScroll,
                left: props.vertical ? 0 : this.getTargetLeft(),
                top: props.vertical ? this.getTargetLeft() : 0
            }, function () {
                _this6.setLeft();
            });
        }
    }, {
        key: 'setLeft',
        value: function setLeft() {
            this.setState({
                left: this.props.vertical ? 0 : this.getTargetLeft(),
                top: this.props.vertical ? this.getTargetLeft() : 0
            });
        }
        // Data

    }, {
        key: 'setExternalData',
        value: function setExternalData() {
            if (this.props.data) {
                this.props.data();
            }
        }
        // Styles

    }, {
        key: 'getListStyles',
        value: function getListStyles() {
            var listWidth = this.state.slideWidth * external__React__default.a.Children.count(this.props.children);
            var cellSpacing = this.props.cellSpacing;
            var spacingOffset = cellSpacing * external__React__default.a.Children.count(this.props.children);
            var transform = 'translate3d(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px, 0)';
            return {
                transform: transform,
                WebkitTransform: transform,
                msTransform: 'translate(' + this.getTweeningValue('left') + 'px, ' + this.getTweeningValue('top') + 'px)',
                position: 'relative',
                display: 'block',
                margin: this.props.vertical ? cellSpacing / 2 * -1 + 'px 0px' : '0px ' + cellSpacing / 2 * -1 + 'px',
                padding: 0,
                height: this.props.vertical ? listWidth + spacingOffset : this.state.slideHeight,
                width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
                cursor: this.state.dragging === true ? 'pointer' : 'inherit',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box'
            };
        }
    }, {
        key: 'getFrameStyles',
        value: function getFrameStyles() {
            return {
                position: 'relative',
                display: 'block',
                overflow: this.props.frameOverflow,
                height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
                margin: this.props.framePadding,
                padding: 0,
                transform: 'translate3d(0, 0, 0)',
                WebkitTransform: 'translate3d(0, 0, 0)',
                msTransform: 'translate(0, 0)',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box'
            };
        }
    }, {
        key: 'getSlideStyles',
        value: function getSlideStyles(index, positionValue) {
            var targetPosition = this.getSlideTargetPosition(index, positionValue);
            var cellSpacing = this.props.cellSpacing;
            return {
                position: 'absolute',
                left: this.props.vertical ? 0 : targetPosition,
                top: this.props.vertical ? targetPosition : 0,
                display: this.props.vertical ? 'block' : 'inline-block',
                listStyleType: 'none',
                verticalAlign: 'top',
                width: this.props.vertical ? '100%' : this.state.slideWidth,
                height: 'auto',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box',
                marginLeft: this.props.vertical ? 'auto' : cellSpacing / 2,
                marginRight: this.props.vertical ? 'auto' : cellSpacing / 2,
                marginTop: this.props.vertical ? cellSpacing / 2 : 'auto',
                marginBottom: this.props.vertical ? cellSpacing / 2 : 'auto'
            };
        }
    }, {
        key: 'getSlideTargetPosition',
        value: function getSlideTargetPosition(index, positionValue) {
            var slidesToShow = this.state.frameWidth / this.state.slideWidth;
            var targetPosition = (this.state.slideWidth + this.props.cellSpacing) * index;
            var end = (this.state.slideWidth + this.props.cellSpacing) * slidesToShow * -1;
            if (this.props.wrapAround) {
                var slidesBefore = Math.ceil(positionValue / this.state.slideWidth);
                if (this.state.slideCount - slidesBefore <= index) {
                    return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount - index) * -1;
                }
                var slidesAfter = Math.ceil((Math.abs(positionValue) - Math.abs(end)) / this.state.slideWidth);
                if (this.state.slideWidth !== 1) {
                    slidesAfter = Math.ceil((Math.abs(positionValue) - this.state.slideWidth) / this.state.slideWidth);
                }
                if (index <= slidesAfter - 1) {
                    return (this.state.slideWidth + this.props.cellSpacing) * (this.state.slideCount + index);
                }
            }
            return targetPosition;
        }
    }, {
        key: 'getSliderStyles',
        value: function getSliderStyles() {
            return {
                position: 'relative',
                display: 'block',
                width: this.props.width,
                height: 'auto',
                boxSizing: 'border-box',
                MozBoxSizing: 'border-box',
                visibility: this.state.slideWidth ? 'visible' : 'hidden'
            };
        }
    }, {
        key: 'getStyleTagStyles',
        value: function getStyleTagStyles() {
            return '.slider-slide > img {width: 100%; display: block;}';
        }
    }, {
        key: 'getDecoratorStyles',
        value: function getDecoratorStyles(position) {
            switch (position) {
                case 'TopLeft':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: 0
                        };
                    }
                case 'TopCenter':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            WebkitTransform: 'translateX(-50%)',
                            msTransform: 'translateX(-50%)'
                        };
                    }
                case 'TopRight':
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            right: 0
                        };
                    }
                case 'CenterLeft':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            left: 0,
                            transform: 'translateY(-50%)',
                            WebkitTransform: 'translateY(-50%)',
                            msTransform: 'translateY(-50%)'
                        };
                    }
                case 'CenterCenter':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%,-50%)',
                            WebkitTransform: 'translate(-50%, -50%)',
                            msTransform: 'translate(-50%, -50%)'
                        };
                    }
                case 'CenterRight':
                    {
                        return {
                            position: 'absolute',
                            top: '50%',
                            right: 0,
                            transform: 'translateY(-50%)',
                            WebkitTransform: 'translateY(-50%)',
                            msTransform: 'translateY(-50%)'
                        };
                    }
                case 'BottomLeft':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            left: 0
                        };
                    }
                case 'BottomCenter':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            width: '100%',
                            textAlign: 'center'
                        };
                    }
                case 'BottomRight':
                    {
                        return {
                            position: 'absolute',
                            bottom: 0,
                            right: 0
                        };
                    }
                default:
                    {
                        return {
                            position: 'absolute',
                            top: 0,
                            left: 0
                        };
                    }
            }
        }
    }]);

    return Carousel;
}(external__React__default.a.Component);

carousel_Carousel.defaultProps = {
    afterSlide: function afterSlide() {},
    autoplay: false,
    resetAutoplay: true,
    swipeSpeed: 12,
    autoplayInterval: 3000,
    beforeSlide: function beforeSlide() {},
    cellAlign: 'left',
    cellSpacing: 0,
    data: function data() {},
    decorators: decorators,
    dragging: true,
    easing: easeOutCirc,
    edgeEasing: linear,
    framePadding: '0px',
    frameOverflow: 'hidden',
    slideIndex: 0,
    slidesToScroll: 1,
    slidesToShow: 1,
    slideWidth: 1,
    speed: 500,
    swiping: true,
    vertical: false,
    width: '100%',
    wrapAround: false,
    style: {}
};
/* harmony default export */ var carousel = (carousel_Carousel);
// CONCATENATED MODULE: ./node_modules/rmc-nuka-carousel/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "default", function() { return carousel; });


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return ExecutionEnvironment;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(409)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(170)))

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _GoodsShoppingCart = __webpack_require__(103);

__webpack_require__(415);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShoppingCart = function (_OfficialPage) {
  (0, _inherits3.default)(ShoppingCart, _OfficialPage);

  function ShoppingCart(props) {
    var _this2$state;

    (0, _classCallCheck3.default)(this, ShoppingCart);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ShoppingCart.__proto__ || Object.getPrototypeOf(ShoppingCart)).call(this, props));

    _this2.state = (_this2$state = {
      originGoodsList: [],
      cartType: -1,
      deliveryMethod: -1,
      editing: false,
      goodsCount: 0,
      goodsCountToPay: 0,
      priceToPay: 0.0,
      goodsList: [],
      unableData: [],
      isFromBack: false,
      selectAll: false,
      notBussinessTimeGoodId: [],
      showDeleteWindow: false
    }, (0, _defineProperty3.default)(_this2$state, 'goodsList', []), (0, _defineProperty3.default)(_this2$state, 'currentSelectGoodsType', ''), (0, _defineProperty3.default)(_this2$state, 'showFastGoods', true), (0, _defineProperty3.default)(_this2$state, 'showAddress', false), (0, _defineProperty3.default)(_this2$state, 'storeStyle', {}), _this2$state);
    _this2.franchiseeId = '';
    _this2.isFromUserCenterEle = '';
    _this2.goodsShoppingCartRef = _react2.default.createRef();

    _this2.dataInitial = function () {
      _this2.getShoppingCartData('first');
      _this2.getAppECStoreConfig();
      _this2.isShowAddress();
      _this2.handleCurrentPage();
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          cartConfig: res.cart_config,
          storeStyle: res.color_config,
          tabExpress: res.express,
          tabIntraCity: res.intra_city,
          tabDelivery: res.is_self_delivery,
          tabDining: _this2.franchiseeId ? false : res.dining //暂时不兼容子店(如果是子店 不显示堂食tab选项)
        });
      }, _this2.franchiseeId);
    };

    _this2.getShoppingCartData = function (frequency) {
      var _this = _this2,
          franchiseeId = _this2.franchiseeId,
          fromUserCenterEle = _this2.data.isFromUserCenterEle;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 1000,
          sub_shop_app_id: franchiseeId,
          parent_shop_app_id: franchiseeId ? _app.appMethod.getAppId() : ''
        },
        success: function success(res) {
          var originGoodsList = res.data || [];
          var hasGoodsTypeObj = {};
          var cartType = 0;
          var goodsList = [];
          originGoodsList.map(function (item) {
            switch (item.goods_type) {
              case '0':
                hasGoodsTypeObj['hasGoods'] = true;
                break;
              case '2':
                hasGoodsTypeObj['hasWaimai'] = true;
                break;
              case '3':
                hasGoodsTypeObj['hasTostore'] = true;
                break;
            }
          });
          if (hasGoodsTypeObj['hasGoods']) {
            cartType = 0;
            frequency == 'first' && _this.getCurrentLocation();
          } else if (hasGoodsTypeObj['hasWaimai']) {
            cartType = 2;
          } else if (hasGoodsTypeObj['hasTostore']) {
            cartType = 3;
          }
          originGoodsList.map(function (item) {
            if (item.goods_type == cartType) {
              goodsList.push(item);
            }
          });
          _this.setData({
            cartType: cartType,
            originGoodsList: originGoodsList,
            goodsList: goodsList,
            hasGoodsTypeObj: hasGoodsTypeObj,
            takeoutInfo: res.take_out_info,
            goodsCount: originGoodsList.length,
            unableData: res.unable_data
          });
          _this.clickSelectAll();
          _this.getTostoreNotBusinessTime();
          _this.recalculateCountPrice();
        }
      });
    };

    _this2.switchToEdit = function () {
      _this2.setData({
        editing: true
      });
    };

    _this2.editComplete = function () {
      _this2.setData({
        editing: false
      });
    };

    _this2.clickSelectGoods = function (e) {
      var index = e.currentTarget.dataset.index;
      var goodsList = _this2.data.goodsList;
      var selectAll = true;
      var noSelectAll = true;
      goodsList[index].selected = !goodsList[index].selected;
      goodsList.map(function (item) {
        if (!item.selected) {
          selectAll = false;
        } else {
          noSelectAll = false;
        }
      });
      _this2.setData({
        goodsList: goodsList,
        selectAll: selectAll
      });
      _this2.recalculateCountPrice();
    };

    _this2.clickSelectAll = function () {
      var selectAll = _this2.data.selectAll;
      var goodsList = _this2.data.goodsList;
      goodsList.map(function (item) {
        item.selected = !selectAll;
      });
      _this2.setData({
        selectAll: !selectAll,
        goodsList: goodsList
      });
      _this2.recalculateCountPrice();
    };

    _this2.recalculateCountPrice = function () {
      var goodsList = _this2.data.goodsList,
          totalCount = 0,
          price = 0;
      goodsList.map(function (item) {
        if (item.selected) {
          totalCount += +item.num;
          price += +item.price * +item.num;
        }
      });
      _this2.setData({
        goodsCountToPay: totalCount,
        priceToPay: price.toFixed(2)
      });
    };

    _this2.getTostoreNotBusinessTime = function (payIdArr, sucfn) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/precheckShoppingCart',
        method: 'post',
        data: {
          sub_shop_app_id: that.franchiseeId,
          cart_arr: payIdArr || '',
          parent_shop_app_id: that.franchiseeId ? _app.appMethod.getAppId() : ''
        },
        success: function success(res) {
          sucfn && sucfn();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          if (res.status == 1) {
            var goodsId = res.expired_goods_arr || [],
                list = that.data.goodsList;
            if (goodsId && goodsId.length) {
              for (var i = 0; i < goodsId.length; i++) {
                var id = goodsId[i].goods_id;
                for (var j = list.length - 1; j >= 0; j--) {
                  if (id == list[j].goods_id) {
                    list[j].selected = false;
                  }
                }
              }
              that.setData({
                selectAll: false,
                goodsList: list,
                notBussinessTimeGoodId: goodsId
              });
              that.recalculateCountPrice();
            }
          }
        }
      });
    };

    _this2.goToPay = function (e) {
      var payIdArr = [];
      var franchiseeId = _this2.franchiseeId;
      var cartIdArray = [];
      var that = _this2;
      var notBusinessTimeFlag = false;
      var goodsList = _this2.data.goodsList;
      var cartType = _this2.data.cartType;
      goodsList.map(function (item) {
        if (item.selected) {
          cartIdArray.push(item.id);
          payIdArr.push({
            cart_id: item.id,
            goods_id: item.goods_id,
            model_id: item.model_id,
            model: item.model,
            num: item.num,
            goods_type: item.goods_type,
            is_seckill: item.is_seckill,
            seckill_start_state: item.seckill_start_state ? item.seckill_start_state : ''
          });
        }
      });
      if (!cartIdArray.length) {
        _app.appMethod.showModal({
          content: '请选择结算的商品'
        });
        return;
      }
      that.getTostoreNotBusinessTime(payIdArr, function () {
        if (cartType == 0) {
          var tabExpress = that.data.tabExpress;
          var tabDelivery = that.data.tabDelivery;
          var tabIntraCity = that.data.tabIntraCity;
          var addressId = that.data.selectSameJourneyId;
          if (cartIdArray.length == 1 || tabExpress == 1 && tabDelivery != 1 && tabIntraCity != 1 || tabExpress != 1 && tabDelivery == 1 && tabIntraCity != 1 || tabExpress != 1 && tabDelivery != 1 && tabIntraCity == 1) {
            var _pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
            franchiseeId && (_pagePath += '&franchisee=' + franchiseeId);
            addressId && (_pagePath += '&addressId=' + addressId);
            _app.appMethod.turnToPage(_pagePath);
            return;
          } else {
            that.showSettlement();
            return;
          }
        } else if (cartType == 1) {
          var pagePath = '/eCommerce/pages/previewAppointmentOrder/previewAppointmentOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          _app.appMethod.turnToPage(pagePath);
        } else if (cartType == 3) {
          var pagePath = '/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          _app.appMethod.turnToPage(pagePath);
        } else if (cartType == 2) {
          if (+that.data.takeoutInfo.min_deliver_price > +that.data.priceToPay) {
            _app.appMethod.showModal({
              content: '没有达到起送价(' + that.data.takeoutInfo.min_deliver_price + '元)'
            });
            return;
          }
          var pagePath = '/orderMeal/pages/previewTakeoutOrder/previewTakeoutOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          _app.appMethod.turnToPage(pagePath);
        }
      });
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goodsType = e.currentTarget.dataset.type;
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      var goodsType = e.currentTarget.dataset.type;
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.inputGoodsCount = function (e) {
      var goodsType = e.currentTarget.dataset.type;
      var count = e.target.value;
      var index = e.target.dataset.index;
      if (count == '') {
        return;
      }
      if (count == 0) {
        _app.appMethod.showModal({
          content: '请输入大于0的数字'
        });
        return;
      }
      _this2.changeGoodsNum(index, 'number', count);
    };

    _this2.changeGoodsNum = function (index, type, numberCount) {
      var goodsList = _this2.data.goodsList;
      var currentGoods = goodsList[index];
      var currentNum = +currentGoods.num,
          targetNum = void 0,
          _this = _this2,
          param = void 0;
      if (type == 'plus') {
        targetNum = currentNum + 1;
      } else if (type == 'minus') {
        targetNum = currentNum - 1;
        if (targetNum <= 0) {
          _this2.setData({
            singelDeleteId: currentGoods.id
          });
          _this2.showDeleteWindow('singel');
          return;
        }
      } else {
        targetNum = numberCount;
      }
      if (+targetNum > +currentGoods.stock) {
        _app.appMethod.showModal({
          content: '库存不足'
        });
        return;
      }
      if (currentGoods.form_data && currentGoods.form_data.seckill_activity_id) {
        param = {
          goods_id: currentGoods.goods_id,
          model_id: currentGoods.model_id || '',
          num: targetNum,
          sub_shop_app_id: _this2.franchiseeId,
          is_seckill: 1,
          form_data: {
            seckill_activity_id: currentGoods.form_data.seckill_activity_id,
            seckill_activity_time_id: currentGoods.form_data.seckill_activity_time_id
          }
        };
      } else {
        param = {
          goods_id: currentGoods.goods_id,
          model_id: currentGoods.model_id || '',
          num: targetNum,
          sub_shop_app_id: _this2.franchiseeId,
          is_seckill: currentGoods.is_seckill == 1 ? 1 : '',
          message_notice_type: 1
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          currentGoods.num = targetNum;
          _this.setData({
            goodsList: goodsList
          });
          _this.recalculateCountPrice();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          _app.appMethod.showModal({
            content: res.data
          });
        }
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.showDeleteWindow = function (type) {
      _this2.setData({
        deleteType: type,
        showDeleteWindow: true
      });
    };

    _this2.cancelDelete = function () {
      _this2.setData({
        showDeleteWindow: false
      });
    };

    _this2.sureDeleteGoods = function (e) {
      var _this = _this2;
      var goodsList = _this2.data.goodsList;
      var type = e.currentTarget.dataset.type;
      var deleteArr = [];
      if (type == 'singel') {
        deleteArr.push(_this2.data.singelDeleteId);
      } else {
        goodsList.map(function (item) {
          if (item.selected) {
            deleteArr.push(item.id);
          }
        });
      }
      if (deleteArr.length == 0) {
        _this.setData({
          showDeleteWindow: false,
          selectAll: false,
          currentSelectGoodsType: ''
        });
        _app.appMethod.showModal({
          content: '没有选择商品'
        });
        return;
      }
      _this2.deleteGoods(deleteArr);
    };

    _this2.deleteGoods = function (deleteArr) {
      var _this = _this2;
      var fromUserCenterEle = _this2.data.isFromUserCenterEle;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: deleteArr,
          sub_shop_app_id: fromUserCenterEle ? '' : _this.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            showDeleteWindow: false,
            selectAll: false,
            currentSelectGoodsType: ''
          });
          _this.getShoppingCartData();
        }
      });
    };

    _this2.deleteUnableGoods = function (event) {
      var index = event.currentTarget.dataset.index;
      var deleteId = _this2.data.unableData[index].id;
      _this2.setData({
        singelDeleteId: deleteId
      });
      _this2.showDeleteWindow('singel');
    };

    _this2.changeCartType = function (e) {
      var _e$currentTarget$data = e.currentTarget.dataset,
          type = _e$currentTarget$data.type,
          isFranchisee = _e$currentTarget$data.isFranchisee;
      var _this2$data = _this2.data,
          originGoodsList = _this2$data.originGoodsList,
          deliveryMethod = _this2$data.deliveryMethod,
          cartType = _this2$data.cartType;

      var appId = _this2.franchiseeId || _app.appMethod.getAppId();
      var goodsList = [];
      var setDataObj = {};
      if (type == cartType) {
        return;
      }
      originGoodsList.map(function (item) {
        item.selected = false;
        if (item.goods_type == type && item.app_id == appId) {
          goodsList.push(item);
        }
      });
      if (deliveryMethod != -1 && type == 0) {
        var filterGoodsList = [];
        goodsList.map(function (item) {
          if (item.pick_up_type.indexOf(deliveryMethod) >= 0) {
            filterGoodsList.push(item);
          }
        });
        goodsList = filterGoodsList;
      }
      setDataObj['cartType'] = type;
      setDataObj['selectAll'] = false;
      setDataObj['goodsList'] = goodsList;

      if (isFranchisee) {
        // 多商家多店
        var shopsList = _this2.data.shopsList;

        shopsList.forEach(function (shop) {
          shop.selected = false;
          shop['cartList'].forEach(function (cart) {
            return cart.selected = false;
          });
        });
        setDataObj['shopsList'] = shopsList;
      }
      _this2.setData(setDataObj);
      _this2.recalculateCountPrice();
    };

    _this2.goCommodityDetail = function (event) {
      var franchiseeParam = _this2.franchiseeId ? '&franchisee=' + _this2.franchiseeId : '';
      _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id + franchiseeParam);
    };

    _this2.stopPropagation = function () {};

    _this2.filterDeliveryMethod = function (e) {
      var originGoodsList = _this2.data.originGoodsList;
      var goodsList = [];
      var type = e.currentTarget.dataset.type;
      originGoodsList.map(function (item) {
        if (item.goods_type == 0) {
          goodsList.push(item);
        }
      });
      if (!goodsList) {
        return;
      }
      if (type != -1) {
        var filterGoodsList = [];
        goodsList.map(function (item) {
          if (item.pick_up_type.indexOf(type) >= 0) {
            filterGoodsList.push(item);
          }
        });
        goodsList = filterGoodsList;
      }
      _this2.setData({
        goodsList: goodsList,
        deliveryMethod: type
      });
      _this2.recalculateCountPrice();
    };

    _this2.getCurrentLocation = function () {
      var _this = _this2;
      _app.appMethod.getLocation({
        success: function success(res) {
          var latitude = res.latitude;
          var longitude = res.longitude;
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            method: 'post',
            data: {
              latitude: latitude,
              longitude: longitude
            },
            success: function success(res) {
              _this.setData({
                currentLocationData: res.data
              });
            }
          });
        },

        fail: function fail(res) {}
      });
    };

    _this2.selectGoodsSameJourney = function () {
      var selectSameJourney = _this2.data.selectSameJourney;
      _this2.closeSettlement();
      _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + _this2.franchiseeId);
    };

    _this2.showSettlement = function () {
      var _this = _this2;
      var goodsList = _this2.data.goodsList;
      var goodsIds = [];
      var expressData = {
        goodsIds: [],
        totalPrice: 0
      };
      var sameCityData = {
        goodsIds: [],
        totalPrice: 0
      };
      var selfLiftData = {
        goodsIds: [],
        totalPrice: 0
      };
      var currentLocationData = _this2.data.currentLocationData;
      var selectSameJourney = _this2.data.selectSameJourney;
      var lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
      var lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
      var regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
      goodsList.map(function (item) {
        if (item.selected) {
          if (item.pick_up_type.indexOf('1') >= 0) {
            expressData.goodsIds.push(item.id);
            expressData.totalPrice += +item.price;
          }
          if (item.pick_up_type.indexOf('2') >= 0) {
            sameCityData.goodsIds.push(item.id);
            sameCityData.totalPrice += +item.price;
          }
          if (item.pick_up_type.indexOf('3') >= 0) {
            selfLiftData.goodsIds.push(item.id);
            selfLiftData.totalPrice += +item.price;
          }
          goodsIds.push(+item.id);
        }
      });
      if (!goodsIds.length) {
        _app.appMethod.showModal({
          content: '请选择商品'
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
        method: 'post',
        data: {
          latitude: lat,
          longitude: lng,
          region_id: regionId,
          cart_id_arr: goodsIds,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var data = res.data;
          var cartIdArray = void 0;
          if (data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
            cartIdArray = data[1].cart_list;
          }
          if (!data.hasOwnProperty(1) && data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
            cartIdArray = data[2].cart_list;
          }
          if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
            cartIdArray = data[3].cart_list;
          }
          if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && data.hasOwnProperty(4)) {
            cartIdArray = data[4].cart_list;
          }
          if (cartIdArray) {
            var franchiseeId = _this.franchiseeId;
            var addressId = this.data.selectSameJourneyId;
            var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
            franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
            addressId && (pagePath += '&addressId=' + addressId);
            _app.appMethod.turnToPage(pagePath);
            return;
          }
          _this.setData({
            canUsePickUpType: data,
            intraCityData: data[2] && data[2].intra_city_data || '',
            diningData: data[4] && data[4].dining_data || '',
            showSettlementMask: true
          });
        }
      });
    };

    _this2.closeSettlement = function () {
      _this2.setData({
        showSettlementMask: false
      });
    };

    _this2.goodsPay = function (e) {
      var franchiseeId = _this2.franchiseeId,
          cartIdArray = [],
          type = e.currentTarget.dataset.type,
          cartId = e.currentTarget.dataset.cartId,
          addressId = _this2.data.selectSameJourneyId;
      cartIdArray = cartId;
      var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
      franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
      addressId && (pagePath += '&addressId=' + addressId);
      _this2.closeSettlement();
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.scanShopping = function () {
      _app.appMethod.showToast({ title: '暂不支持扫码购功能' });
      return;

      var _this = _this2;

      _app.appMethod.scanCode({
        success: function success(res) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/addCartByGoodsCode',
            data: {
              code: res.result,
              sub_shop_app_id: _this.franchiseeId
            },
            success: function success(res) {
              _this.afterSelectedGoods();
            }
          });
        },
        fail: function fail(res) {
          _app.appMethod.showModal({
            content: '未检索到商品'
          });
        }
      });
    };

    _this2.afterSelectedGoods = function () {
      _this2.setData({
        selectAll: false
      });
      _this2.getShoppingCartData();
    };

    _this2.scanMove = function (event) {
      var y = event.changedTouches[0].clientY;
      var width = window.innerWidth;
      var maxHeight = window.innerHeight - 208 / 750 * width;
      y = y < 0 ? 0 : y > maxHeight ? maxHeight : y;
      _this2.setData({
        widowTop: y
      });
    };

    _this2.addFavoriteGoods = function (e) {
      var goodsList = _this2.data.goodsList;
      var goodsIds = [];
      var _this = _this2;
      goodsList.map(function (item) {
        if (item.selected) {
          goodsIds.push(+item.goods_id);
        }
      });
      if (!goodsIds.length) {
        _app.appMethod.showModal({
          content: '未选中商品'
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addFavoriteGoods',
        method: 'post',
        data: {
          form_id: e.detail.formId,
          goods_ids: goodsIds,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          _app.appMethod.showModal({
            content: '成功加入收藏夹'
          });
        }
      });
    };

    _this2.showFastGoods = function () {
      var _this = _this2;
      _this2.setData({
        showFastGoods: !_this.data.showFastGoods
      });
    };

    _this2.selectGoodsDetail = function (event) {
      var newData = {
        goodsId: event.currentTarget.dataset.goodsId,
        franchisee: _this2.franchiseeId
      };
      _this2.goodsShoppingCartRef.current.show({ afterSelectedGoods: _this2.afterSelectedGoods });
      _this2.goodsShoppingCartRef.current.showDialog(newData);
    };

    _this2.isShowAddress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getSwitchBySwitchName',
        method: 'post',
        data: {
          switch_name: 'intra_city_address_position'
        },
        success: function success(res) {
          if (!res.status) {
            that.setData({
              showAddress: res.data == 1 ? true : false
            });
          }
        }
      });
    };

    document.title = '购物车';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData) {
      _this2.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this2;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(ShoppingCart, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      if (this.currentPage.callbackData) {
        this.setData(this.currentPage.callbackData);
        this.currentPage.clearCallbackData();
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchiseeId = options.franchisee || '';
      this.mode = options.fmode || '';
      this.isFromUserCenterEle = options.from || '';
      this.goodsScanCode = options.goodsScanCode;
      var isFranchisee = false;
      var _app$globalData = _app.appMethod.globalData,
          goodsStoreConfig = _app$globalData.goodsStoreConfig,
          hasFranchiseeList = _app$globalData.hasFranchiseeList,
          hasFranchiseeChain = _app$globalData.hasFranchiseeChain;

      if (goodsStoreConfig['cart_config'] && goodsStoreConfig['cart_config'].is_merge_shoppingcart == 1) {
        // 是否开启合并购物车
        if (hasFranchiseeList || hasFranchiseeChain) {
          isFranchisee = true;
        }
      }
      this.setData({
        franchiseeId: this.franchiseeId,
        isFranchisee: isFranchisee
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromBack) {
        this.dataInitial();
        this.setData({
          selectAll: false,
          deliveryMethod: -1
        });
      } else {
        this.isFromBack = true;
      }
      if (this.goodsScanCode) {
        this.scanShopping();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          originGoodsList = _state.originGoodsList,
          storeStyle = _state.storeStyle,
          cartType = _state.cartType,
          hasGoodsTypeObj = _state.hasGoodsTypeObj,
          editing = _state.editing,
          selectSameJourney = _state.selectSameJourney,
          currentLocationData = _state.currentLocationData,
          showAddress = _state.showAddress,
          deliveryMethod = _state.deliveryMethod,
          tabExpress = _state.tabExpress,
          tabDelivery = _state.tabDelivery,
          tabIntraCity = _state.tabIntraCity,
          tabDining = _state.tabDining,
          diningData = _state.diningData,
          goodsList = _state.goodsList,
          item = _state.item,
          unableData = _state.unableData,
          cartConfig = _state.cartConfig,
          showFastGoods = _state.showFastGoods,
          selectAll = _state.selectAll,
          goodsCountToPay = _state.goodsCountToPay,
          priceToPay = _state.priceToPay,
          franchiseeId = _state.franchiseeId,
          widowTop = _state.widowTop,
          deleteType = _state.deleteType,
          showDeleteWindow = _state.showDeleteWindow,
          canUsePickUpType = _state.canUsePickUpType,
          intraCityData = _state.intraCityData,
          showSettlementMask = _state.showSettlementMask;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'official-page shopping-cart' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u8D2D\u7269\u8F66' }),
          _react2.default.createElement(
            'div',
            { style: (0, _tools.convertLineStyleData)(originGoodsList.length ? 'padding-bottom: 100rpx' : '') },
            !!originGoodsList.length && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'cart-header' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'cart-type-box',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme)
                  },
                  hasGoodsTypeObj['hasGoods'] && _react2.default.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)('border-color:' + storeStyle.theme + (cartType == 0 ? ';background:' + storeStyle.theme : '')),
                      className: cartType == 0 ? 'selected' : '',
                      onClick: this.changeCartType,
                      'data-type': '0'
                    },
                    '\u57FA\u7840'
                  ),
                  hasGoodsTypeObj['hasTostore'] && _react2.default.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)('border-color:' + storeStyle.theme + (cartType == 3 ? ';background:' + storeStyle.theme : '')),
                      className: cartType == 3 ? 'selected' : '',
                      onClick: this.changeCartType,
                      'data-type': '3'
                    },
                    '\u5230\u5E97'
                  ),
                  hasGoodsTypeObj['hasWaimai'] && _react2.default.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)(cartType == 2 ? 'background:' + storeStyle.theme : ''),
                      className: cartType == 2 ? 'selected' : '',
                      onClick: this.changeCartType,
                      'data-type': '2'
                    },
                    '\u5916\u5356'
                  )
                ),
                editing && _react2.default.createElement('div', {
                  style: (0, _tools.convertLineStyleData)('color:' + (storeStyle.theme || '#ff7100')),
                  className: 'pull-right ico-moon icon-success-tip shopping-cart-editor border-left',
                  onClick: this.editComplete
                }),
                !editing && _react2.default.createElement('div', {
                  className: 'pull-right ico-moon icon-shopping-cart-set shopping-cart-editor border-left',
                  onClick: this.switchToEdit
                })
              ),
              cartType == 0 && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                showAddress && _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-location-box',
                    onClick: this.selectGoodsSameJourney
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'address-box' },
                    selectSameJourney ? selectSameJourney.address_info.province.text + selectSameJourney.address_info.city.text + selectSameJourney.address_info.district.text + selectSameJourney.detail_address : currentLocationData && currentLocationData.formatted_addresses && currentLocationData.formatted_addresses.recommend || '暂无地址,请点击选择地址'
                  ),
                  _react2.default.createElement('span', { className: 'trangel' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-delivery-method' },
                  _react2.default.createElement(
                    'span',
                    {
                      onClick: this.filterDeliveryMethod,
                      style: (0, _tools.convertLineStyleData)(deliveryMethod == -1 ? 'color:' + storeStyle.theme : ''),
                      'data-type': '-1',
                      className: deliveryMethod == -1 ? 'selected' : ''
                    },
                    '\u5168\u90E8',
                    _react2.default.createElement('span', {
                      className: 'bottom-line',
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                    })
                  ),
                  tabExpress == 1 && _react2.default.createElement(
                    'span',
                    {
                      onClick: this.filterDeliveryMethod,
                      style: (0, _tools.convertLineStyleData)(deliveryMethod == 1 ? 'color:' + storeStyle.theme : ''),
                      'data-type': '1',
                      className: deliveryMethod == 1 ? 'selected' : ''
                    },
                    '\u5FEB\u9012',
                    _react2.default.createElement('span', {
                      className: 'bottom-line',
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                    })
                  ),
                  tabDelivery == 1 && _react2.default.createElement(
                    'span',
                    {
                      onClick: this.filterDeliveryMethod,
                      style: (0, _tools.convertLineStyleData)(deliveryMethod == 3 ? 'color:' + storeStyle.theme : ''),
                      'data-type': '3',
                      className: deliveryMethod == 3 ? 'selected' : ''
                    },
                    '\u81EA\u63D0',
                    _react2.default.createElement('span', {
                      className: 'bottom-line',
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                    })
                  ),
                  tabIntraCity == 1 && _react2.default.createElement(
                    'span',
                    {
                      onClick: this.filterDeliveryMethod,
                      style: (0, _tools.convertLineStyleData)(deliveryMethod == 2 ? 'color:' + storeStyle.theme : ''),
                      'data-type': '2',
                      className: deliveryMethod == 2 ? 'selected' : ''
                    },
                    '\u540C\u57CE',
                    _react2.default.createElement('span', {
                      className: 'bottom-line',
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                    })
                  ),
                  tabDining == 1 && _react2.default.createElement(
                    'span',
                    {
                      onClick: this.filterDeliveryMethod,
                      style: (0, _tools.convertLineStyleData)(deliveryMethod == 4 ? 'color:' + storeStyle.theme : ''),
                      'data-type': '4',
                      className: deliveryMethod == 4 ? 'selected' : ''
                    },
                    '\u70B9\u9910',
                    _react2.default.createElement('span', {
                      className: 'bottom-line',
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                    })
                  )
                )
              )
            ),
            originGoodsList.length === 0 && _react2.default.createElement(
              'div',
              { className: 'shoppingCart-null' },
              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/shopping-cart-null.png' }),
              _react2.default.createElement(
                'div',
                { className: 'shoppingCart-null-label' },
                '\u8D2D\u7269\u8F66\u7A7A\u7A7A\u54D2'
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'go-home-page',
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                  onClick: this.goToHomepage
                },
                '\u53BB\u901B\u901B'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'shoppingCart-wrap page', id: 'shoppingCart' },
              _react2.default.createElement(
                'div',
                { className: 'shoppingCart-goods-list' },
                goodsList.map(function (goods, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: goods.id },
                    _react2.default.createElement('label', {
                      'data-index': index,
                      style: (0, _tools.convertLineStyleData)(goods.selected ? 'color:' + storeStyle.theme : ''),
                      className: 'shoppingCart-check-box ' + (goods.selected ? 'checked ico-moon icon-success-tip' : ''),
                      'data-type': goods.type,
                      onClick: _this3.clickSelectGoods
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: 'shoppingCart-goods-content' },
                      _react2.default.createElement(
                        'div',
                        { className: 'shoppingCart-goods-cover' },
                        _react2.default.createElement('img', { src: goods.cover })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-content-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-goods-title' },
                          goods.is_group_buy == 1 && _react2.default.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u62FC\u56E2'
                          ),
                          goods.is_seckill == 1 && _react2.default.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u79D2\u6740'
                          ),
                          goods.title
                        ),
                        goods.model_value_str && _react2.default.createElement(
                          'div',
                          { className: 'ellipsis shoppingCart-goods-model' },
                          goods.model_value_str
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-price-box' },
                          (goods.integral != '2' || goods.price != 0 && goods.price != '0.00') && _react2.default.createElement(
                            'span',
                            {
                              className: 'real-price',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          ),
                          goods.integral == '2' && (goods.price != 0 || goods.price != '0.00') && _react2.default.createElement(
                            'span',
                            {
                              className: 'real-price',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '+'
                          ),
                          goods.integral == '2' && _react2.default.createElement(
                            'span',
                            {
                              className: 'real-price',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            goods.max_can_use_integral + '积分'
                          ),
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'goods-number-box pull-right',
                              onClick: _this3.stopPropagation
                            },
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'goods-num-mius',
                                onClick: _this3.clickMinusButton,
                                'data-type': goods.type,
                                'data-index': index
                              },
                              '-'
                            ),
                            _react2.default.createElement('input', {
                              type: 'number',
                              className: 'goods-num-box',
                              value: goods.num,
                              'data-type': goods.type,
                              'data-index': index,
                              onChange: _this3.inputGoodsCount
                            }),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'goods-num-plus',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                'data-type': goods.type,
                                onClick: _this3.clickPlusButton,
                                'data-index': index
                              },
                              '+'
                            )
                          ),
                          goods.cart_vip_goods == 1 && _react2.default.createElement(
                            'span',
                            { className: 'vip-logo' },
                            '\u4F1A\u5458\u4EF7'
                          )
                        )
                      )
                    )
                  );
                })
              ),
              !!unableData.length && _react2.default.createElement(
                'div',
                { className: 'shoppingCart-goods-list unable-goods-list' },
                _react2.default.createElement(
                  'div',
                  { className: 'fast-goods-header' },
                  '\u5931\u6548\u5546\u54C1'
                ),
                unableData.map(function (goods, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: goods.id },
                    _react2.default.createElement(
                      'div',
                      { className: 'shoppingCart-goods-content' },
                      _react2.default.createElement(
                        'div',
                        { className: 'shoppingCart-goods-cover' },
                        _react2.default.createElement('img', { src: goods.cover })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-content-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-goods-title' },
                          goods.is_seckill == 1 && _react2.default.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u79D2\u6740'
                          ),
                          goods.title
                        ),
                        goods.model_value_str && _react2.default.createElement(
                          'div',
                          { className: 'ellipsis shoppingCart-goods-model' },
                          goods.model_value_str
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-price-box' },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u5DF2\u5931\u6548\uFF0C\u53BB\u770B\u770B\u5176\u5B83\u5546\u54C1\u5427'
                          ),
                          _react2.default.createElement('span', {
                            className: 'ico-moon icon-shopping-cart-delete pull-right',
                            onClick: _this3.deleteUnableGoods,
                            'data-index': index
                          })
                        )
                      )
                    )
                  );
                })
              )
            ),
            cartConfig && cartConfig.convenient_shopping && cartConfig.convenient_shopping.goods && cartType == 0 && _react2.default.createElement(
              'div',
              { className: 'fast-goods' },
              _react2.default.createElement(
                'div',
                { className: 'fast-goods-header', onClick: this.showFastGoods },
                cartConfig.convenient_shopping.name,
                _react2.default.createElement('span', {
                  className: 'pull-right ico-moon icon-rightarrow ' + (showFastGoods ? 'show' : '')
                })
              ),
              showFastGoods && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                cartConfig.convenient_shopping.goods.map(function (goods, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: goods.id },
                    _react2.default.createElement(
                      'div',
                      { className: 'shoppingCart-goods-content' },
                      _react2.default.createElement(
                        'div',
                        { className: 'shoppingCart-goods-cover' },
                        _react2.default.createElement('img', { src: goods.cover })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-content-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-goods-title' },
                          goods.is_seckill == 1 && _react2.default.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u79D2\u6740'
                          ),
                          goods.title
                        ),
                        goods.model_value_str && _react2.default.createElement(
                          'div',
                          { className: 'ellipsis shoppingCart-goods-model' },
                          goods.model_value_str
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'shoppingCart-price-box' },
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'real-price',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          ),
                          goods.is_seckill == 1 && _react2.default.createElement(
                            'span',
                            { className: 'seckill-price' },
                            '¥' + goods.original_price
                          ),
                          _react2.default.createElement('div', {
                            onClick: _this3.selectGoodsDetail,
                            'data-goods-id': goods.id,
                            className: 'pull-right addShoppingcart ico-moon icon-addshoppingcart3'
                          })
                        )
                      )
                    )
                  );
                })
              )
            )
          ),
          !!originGoodsList.length && _react2.default.createElement(
            'div',
            { className: 'shoppingCart-bottom-nav', style: {
                bottom: _app.appMethod.isTabBarPage() ? '48px' : ''
              } },
            _react2.default.createElement('label', {
              style: (0, _tools.convertLineStyleData)(selectAll ? 'color:' + storeStyle.theme : ''),
              className: 'shoppingCart-check-box ' + (selectAll ? 'checked ico-moon icon-success-tip' : ''),
              onClick: this.clickSelectAll
            }),
            _react2.default.createElement(
              'span',
              {
                className: 'select-all',
                style: (0, _tools.convertLineStyleData)(selectAll ? 'color:' + storeStyle.theme : '')
              },
              '\u5168\u9009'
            ),
            !editing ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'button',
                {
                  onClick: this.goToPay,
                  type: 'button',
                  'data-type': deliveryMethod,
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                  className: 'pull-right shoppingCart-goto-pay'
                },
                '结算(' + goodsCountToPay + ')'
              ),
              _react2.default.createElement(
                'div',
                { className: 'pull-right total-price-box' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'shoppingCart-all-price',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  '¥' + priceToPay
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'no-contain-freight' },
                  '\u4E0D\u542B\u8FD0\u8D39'
                )
              )
            ) : _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'span',
                {
                  className: 'pull-right mutiple-delete-btn',
                  onClick: this.showDeleteWindow
                },
                '\u5220\u9664'
              ),
              cartType == 0 && !franchiseeId && _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  onClick: this.addFavoriteGoods,
                  className: 'pull-right add-to-favorites'
                },
                '\u79FB\u5165\u6536\u85CF\u5939'
              )
            )
          ),
          cartConfig && cartConfig.shopping_by_scanning_code == 1 && _react2.default.createElement(
            'div',
            {
              className: 'scan-it',
              onClick: this.scanShopping,
              onTouchMove: this.scanMove,
              style: (0, _tools.convertLineStyleData)('box-shadow: 0 0 6rpx' + storeStyle.theme + ';background:' + storeStyle.theme + ';top:' + widowTop + 'px;')
            },
            _react2.default.createElement('span', { className: 'ico-moon icon-shopping-scan' }),
            _react2.default.createElement(
              'div',
              { className: 'scan-it-word' },
              '\u626B\u7801\u8D2D'
            )
          ),
          showDeleteWindow && _react2.default.createElement(
            'div',
            { className: 'delete-tip-window' },
            _react2.default.createElement(
              'div',
              { className: 'delete-box' },
              _react2.default.createElement(
                'div',
                { className: 'delete-tip' },
                '\u786E\u5B9A\u8981\u5220\u9664\u6240\u9009\u5546\u54C1\u5417\uFF1F'
              ),
              _react2.default.createElement(
                'div',
                { className: 'delete-btn-box' },
                _react2.default.createElement(
                  'span',
                  { onClick: this.cancelDelete },
                  '\u53D6\u6D88'
                ),
                deleteType == 'singel' ? _react2.default.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    'data-type': 'singel',
                    className: 'sure-delete',
                    onClick: this.sureDeleteGoods
                  },
                  '\u786E\u5B9A'
                ) : _react2.default.createElement(
                  'span',
                  {
                    className: 'sure-delete',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    'data-type': 'mutiple',
                    onClick: this.sureDeleteGoods
                  },
                  '\u786E\u5B9A'
                )
              )
            )
          ),
          showSettlementMask && _react2.default.createElement(
            'div',
            { className: 'settlement-mask', onTouchMove: this.stopPropagation },
            _react2.default.createElement(
              'div',
              { className: 'settlement-box' },
              _react2.default.createElement(
                'div',
                { className: 'settlement-title' },
                '\u8BF7\u9009\u62E9\u53D6\u8D27\u65B9\u5F0F'
              ),
              !!(canUsePickUpType[1] && canUsePickUpType[1].cart_list.length) && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'settlement-type-title',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      _react2.default.createElement('span', { className: 'ico-moon icon-goods-express-model' }),
                      '\u5FEB\u9012\u914D\u9001'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-express' },
                      '配送费' + (canUsePickUpType[1] && canUsePickUpType[1].express_data && canUsePickUpType[1].express_data.express_fee || 0) + '元'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'settlement-type-count' },
                    '共' + canUsePickUpType[1].goods_num + '件，合计：¥' + canUsePickUpType[1].goods_price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    {
                      'data-type': '1',
                      'data-cart-id': canUsePickUpType[1].cart_list,
                      className: 'settlement-btn',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.goodsPay
                    },
                    '\u9009\u62E9'
                  )
                )
              ),
              !!(canUsePickUpType[3] && canUsePickUpType[3].cart_list.length) && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'settlement-type-title',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      _react2.default.createElement('span', { className: 'ico-moon icon-goods-delivery-model' }),
                      '\u4E0A\u95E8\u81EA\u63D0'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'settlement-type-count' },
                    '共' + canUsePickUpType[3].goods_num + '件，合计：¥' + canUsePickUpType[3].goods_price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    {
                      'data-type': '3',
                      'data-cart-id': canUsePickUpType[3].cart_list,
                      className: 'settlement-btn',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.goodsPay
                    },
                    '\u9009\u62E9'
                  )
                )
              ),
              !!(canUsePickUpType[2] && canUsePickUpType[2].cart_list.length) && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'settlement-type-content ' + (intraCityData.is_enough_price != 1 || intraCityData.in_distance != 1 || intraCityData.in_business_time != 1 ? 'no-achieve-intra-box' : '')
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'settlement-type-title',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      _react2.default.createElement('span', { className: 'ico-moon icon-goods-city-model' }),
                      '\u540C\u57CE\u914D\u9001'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-express' },
                      '配送费' + intraCityData.express_fee + '元'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'settlement-type-count' },
                    '共' + canUsePickUpType[2].goods_num + '件，合计：￥' + canUsePickUpType[2].goods_price
                  ),
                  intraCityData.in_business_time != 1 ? _react2.default.createElement(
                    'div',
                    {
                      className: 'no-achieve-intra',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u5E97\u94FA\u5DF2\u6253\u70CA'
                  ) : intraCityData.is_enough_price != 1 ? _react2.default.createElement(
                    'div',
                    {
                      className: 'no-achieve-intra',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '未达到起送价 还差' + intraCityData.min_deliver_price_balance + '元'
                  ) : intraCityData.in_distance != 1 && _react2.default.createElement(
                    'div',
                    {
                      className: 'no-achieve-intra',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u4E0D\u5728\u914D\u9001\u8303\u56F4'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    {
                      'data-type': '2',
                      'data-cart-id': canUsePickUpType[3].cart_list,
                      className: 'settlement-btn ' + (intraCityData.is_enough_price != 1 || intraCityData.in_distance != 1 || intraCityData.in_business_time != 1 ? 'no-achieve-intra-btn' : ''),
                      style: { color: storeStyle.theme, borderColor: storeStyle.theme },
                      onClick: intraCityData.is_enough_price != 1 || intraCityData.in_distance != 1 || intraCityData.in_business_time != 1 ? null : this.goodsPay },
                    '\u9009\u62E9'
                  ),
                  intraCityData.in_business_time == 1 && intraCityData.is_enough_price == 1 && intraCityData.in_distance != 1 && _react2.default.createElement(
                    'div',
                    {
                      className: 'settlement-btn',
                      style: (0, _tools.convertLineStyleData)('margin-left: 20rpx;color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.selectGoodsSameJourney
                    },
                    '\u4FEE\u6539\u5730\u5740'
                  )
                )
              ),
              !!(canUsePickUpType[4] && canUsePickUpType[4].cart_list.length) && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'settlement-type-content ' + (diningData.in_business_time != 1 ? 'no-achieve-intra-box' : '')
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'settlement-type-title',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      _react2.default.createElement('span', { className: 'ico-moon icon-goods-store-model' }),
                      '\u5802\u98DF\u70B9\u9910'
                    ),
                    diningData.in_business_time != 1 && _react2.default.createElement(
                      'span',
                      { className: 'store-snoring' },
                      '\u5546\u5BB6\u5DF2\u6253\u70CA'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'settlement-type-count' },
                    '共' + canUsePickUpType[4].goods_num + '件，合计：¥' + canUsePickUpType[4].goods_price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    {
                      'data-type': '4',
                      'data-cart-id': canUsePickUpType[4].cart_list,
                      className: 'settlement-btn ' + (diningData.in_business_time != 1 ? 'no-achieve-intra-btn' : ''),
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: diningData.in_business_time != 1 ? null : this.goodsPay
                    },
                    '\u9009\u62E9'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'close-settlement-mask',
                onClick: this.closeSettlement
              },
              '\u5173\u95ED'
            )
          )
        ),
        _react2.default.createElement(_GoodsShoppingCart.GoodsShoppingCart, { ref: this.goodsShoppingCartRef })
      );
    }
  }]);
  return ShoppingCart;
}(_OfficialPage3.default);

exports.default = ShoppingCart;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(76);

var _modal2 = _interopRequireDefault(_modal);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(78);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(417);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatTime = _util2.default.formatTime;
var weekArr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];

var MyOrder = function (_OfficialPage) {
  (0, _inherits3.default)(MyOrder, _OfficialPage);

  function MyOrder(props) {
    var _this2$state;

    (0, _classCallCheck3.default)(this, MyOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MyOrder.__proto__ || Object.getPrototypeOf(MyOrder)).call(this, props));

    _this2.state = (_this2$state = {
      existGoodsIndex: 0,
      existGoodsType: [],
      currentGoodsType: '',
      orderLists: [],
      pages: 1,
      hiddenmodalput: true,
      untimes: '', // 次数券的次数
      numberOfStampsUrl: '',
      addLabelText: '',
      transportStatus: {
        0: '待创建',
        1: '待骑手接单',
        2: '骑手已接单', //蜂鸟已分配骑手
        3: '骑手配送中',
        4: '骑手配送已完成',
        5: '已取消',
        7: '已过期',
        8: '指派单',
        9: '妥投异常之物品返回中',
        10: '妥投异常之物品返回完成',
        11: '骑手已到店',
        12: '申请取消配送',
        1000: '订单异常'
      },
      noMore: false,
      currentTabIndex: 0,
      goodsTypeList: [],
      isFromBack: false,
      marker: [{
        latitude: 0,
        longitude: 0,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }],
      toStoreSetting: '',
      showWriteOffCodeBox: false,
      goodsOrderStatusName: ['待付款', '待发货', '待收货', '待评价', '退款审核中', '正在退款中', '已完成', '已关闭', '待接单', '', '', '', '', '', '', '退款失败'],
      showGoodsPickBox: false,
      selectGoodsPickIndex: ''
    }, (0, _defineProperty3.default)(_this2$state, 'selectGoodsPickIndex', 0), (0, _defineProperty3.default)(_this2$state, 'dayList', ['今天', '明天', '后天']), _this2$state);
    _this2.goodsType = [{
      type: 0,
      name: '基础'
    }, {
      type: 1,
      name: '预约'
    }, {
      type: 2,
      name: '外卖'
    }, {
      type: 3,
      name: '到店'
    }, {
      type: 5,
      name: '当面付'
    }, {
      type: 6,
      name: '排号'
    }, {
      type: 8,
      name: '购卡'
    }, {
      type: 9,
      name: '兑换券'
    }, {
      type: 10,
      name: '行业预约'
    }, {
      type: 21,
      name: '社区团购'
    }];
    _this2.types = {
      // 只有一种商品订单时，types保存商品订单的五个分类
      0: [undefined, 0, 1, 2, 3, [8, 16], 6, 7, 17], // 电商
      1: [undefined, 0, 1, 2, 3], // 预约
      2: [undefined, 0, 6, 7], // 外卖
      3: [undefined, 0, 1, 2, 3, 'refund_status', 7], // 到店
      5: [undefined, 0, 6, 7], // 当面付
      6: [undefined, 2, 6, 7], //排号
      10: [undefined, 0, 1, 2, 3],
      9: [undefined, 0, 1, 7], // 其他（兑换券）
      8: [undefined, 0, 1, 7], // 其他（购卡）
      21: [undefined, 0, 1, 2, 10, 3] //社区团购
    };
    _this2.verifiTimeInterval = '';

    _this2.dataInitial = function () {
      var _this = _this2;
      _this2.getTakeOutInfo();
      _this2.getAppECStoreConfig();
      _this2.getOrderList({
        tabIndex: _this.data.currentTabIndex,
        firstLoad: true
      });
    };

    _this2.getOrderList = function (param) {
      var that = _this2,
          data = {
        page: that.data.pages,
        page_size: 25
      },
          type;
      var good_type = _this2.data.currentGoodsType;
      if (_this2.data.currentGoodsType !== '') {
        data.screening_cond = {};
        type = _this2.types[good_type] && _this2.types[good_type][param.tabIndex];
        if (type != undefined) {
          data.screening_cond.status = type;
        }
        if (good_type == 0) {
          data.screening_cond.is_distribution_order = '';
          data.screening_cond.pick_up_type = _this2.data.selectGoodsPickIndex == 0 ? '' : _this2.data.selectGoodsPickIndex;
        }
        data.screening_cond.order_id = _this2.data.searchOrderId || '';
        if (good_type == 21) {
          good_type = 0;
          data.screening_cond.is_distribution_order = 2;
        }
        data.goods_type = good_type;
        if (data.goods_type == 10 && type == null) {
          data.idx_arr = {
            idx_value: ''
          };
        }
      } else {
        data.screening_cond = {
          is_distribution_order: ''
        };
      }
      data.parent_shop_app_id = _app.appMethod.getAppId(); // 获取订单列表时 传parent_shop_app_id获取本店以及所有子店的订单
      data.not_get_takeout = 1; //不获取店铺信息（在getTakeOutInfo请求）
      if (param.firstLoad && _this2.data.currentGoodsType == '') {
        data.use_default_goods_type = 1;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/orderList',
        method: 'post',
        data: data,
        success: function success(res) {
          var data = {},
              orders = res.data;
          for (var i = orders.length - 1; i >= 0; i--) {
            var formData = orders[i].form_data;
            if (formData.appointment_order_info && formData.appointment_order_info.appointment_unit_type == '6') {
              formData.timeDiff = Date.parse(new Date()) - Date.parse(new Date(formData.appointment_time.split('~')[1])) > 0 ? true : false;
            } else {
              formData.timeDiff = false;
            }
            if (formData.tostore_data && formData.tostore_data.appointed_time) {
              formData.tostore_data.appointed_time = formData.tostore_data.appointed_time.substr(11, 5);
            }
            if (formData.goods_type == 2 && formData.status == 2 && formData.take_out_info.deliver_type != 0 && formData.take_out_info.deliver_type != '' && (formData.take_out_transport_order.status == 2 || formData.take_out_transport_order.status == 3 || formData.take_out_transport_order.status == 11)) {
              that.getTransportInfo(formData.order_id, i);
            }
            if (formData.goods_type == 8 && formData.goods_info.num) {
              formData.goods_info.cNum = that.NumberToChinese(formData.goods_info.num);
            }
            if (formData.goods_type == 2) {
              var goodNum = 0;
              for (var j = 0; j < formData.goods_info.length; j++) {
                goodNum += +formData.goods_info[j].num;
              }
              data['goodsNum'] = goodNum;
            }
            var newAppointmentData = {};
            if (formData.goods_type == 10) {
              if (formData.service.is_hotel_appointment) {
                var service = formData.service,
                    interval = service.hotel_appointment[0],
                    now_day = service.now_date,
                    start_time = new Date(interval.start_time * 1000),
                    end_time = new Date(interval.end_time * 1000);
                newAppointmentData.title = formData.goods_info[0].goods_name;
                newAppointmentData.cover = formData.goods_info[0].cover;
                newAppointmentData.standard = interval.elem_type;
                newAppointmentData.count = interval.long;
                newAppointmentData.start_date = start_time.getMonth() + 1 + '\u6708' + start_time.getDate() + '\u65E5';
                newAppointmentData.end_date = end_time.getMonth() + 1 + '\u6708' + end_time.getDate() + '\u65E5';
                newAppointmentData.start_day = that.data.dayList[Math.floor((interval.start_time - now_day) / 86400)] || weekArr[start_time.getDay()];
                newAppointmentData.end_day = that.data.dayList[Math.floor((interval.end_time - now_day) / 86400)] || weekArr[end_time.getDay()];
                newAppointmentData.phone = service.new_appointment_user_phone;
                newAppointmentData.endDate = formatTime(end_time).slice(0, 10);
                formData.newAppointmentData = newAppointmentData;
              } else {
                newAppointmentData = {
                  serveInfo: [],
                  toStoreTime: '',
                  toStoreTimeEnd: '',
                  duration: '',
                  providerList: [],
                  providerTitle: '',
                  form: 2
                };
                var new_appointment = formData.service.new_appointment,
                    doc_info = new_appointment.doc_info,
                    elem_info = new_appointment.elem_info,
                    worker_info = new_appointment.worker_info;
                for (var _i = 0; _i < doc_info.length; _i++) {
                  newAppointmentData.serveInfo.push({
                    label: doc_info[_i].name,
                    value: elem_info[_i].name
                  });
                }
                for (var _i2 = 0; _i2 < worker_info.length; _i2++) {
                  newAppointmentData.providerList.push({
                    name: worker_info[_i2].name
                  });
                }
                newAppointmentData.toStoreTime = formatTime(new Date(+formData.service.new_appointment_info.spu[0].interval[0].new_appointment_start_date * 1000)).slice(0, 16);
                newAppointmentData.toStoreTimeEnd = formatTime(new Date(+formData.service.new_appointment_info.spu[0].interval[0].new_appointment_end_date * 1000)).slice(11, 16);
                newAppointmentData.duration = +formData.service.new_appointment_info.spu[0].new_appointment_work_sec / 60;
                newAppointmentData.goods_price = formData.service.goods_price;
                newAppointmentData.endDate = newAppointmentData.toStoreTime.slice(0, 10);
                newAppointmentData.providerTitle = new_appointment.manage_alias;
                formData.newAppointmentData = newAppointmentData;
              }
            }
            orders[i] = formData;
          }
          if (param.scrollLoad) {
            orders = that.data.orderLists.concat(orders);
          }
          data['orderLists'] = orders;
          data['pages'] = that.data.pages + 1;
          data['noMore'] = res.is_more == 0 ? true : false;
          if ((0, _typeof3.default)(res.current_goods_type) === 'object') {
            data['currentGoodsType'] = 9;
          } else {
            data['currentGoodsType'] = res.current_goods_type;
          }
          data['goodsTypeList'] = res.goods_type_list;
          if (data['goodsTypeList'].indexOf(data['currentGoodsType'].toString()) < 0) {
            data['goodsTypeList'].unshift(data['currentGoodsType']);
          }
          that._isAddCommunityOrder(function (res) {
            if (res.data != 0) {
              data['goodsTypeList'].push('21');
            }
            if (that.data.currentGoodsType == 21) {
              data['currentGoodsType'] = 21;
            }
            if (!that.data.existGoodsType.length) {
              data.existGoodsType = [];
              data.goodsTypeList.map(function (b) {
                that.goodsType.map(function (a) {
                  if (b == a.type) {
                    data.existGoodsType.push(a);
                  }
                });
              });
              data['existGoodsIndex'] = data.goodsTypeList.indexOf(data['currentGoodsType']);
            }
            that.setData(data);
          });
          if (param.firstLoad && data['goodsTypeList'].indexOf('6') >= 0) {
            that.getTostoreSetting();
          }
        }
      });
    };

    _this2.addLabelInput = function (e) {
      _this2.setData({ addLabelText: e.target.value });
    };

    _this2.goToUseStamps = function (event) {
      var couponId = event.currentTarget.dataset.couponid;
      var appid = _app.appMethod.globalData.appId;
      var franisee = '';
      var untimes = event.currentTarget.dataset.untimes;
      franisee = '&franchisee=' + appid;
      var url = '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' + couponId + franisee;
      _this2.setData({
        numberOfStampsUrl: url,
        hiddenmodalput: false,
        untimes: untimes
      });
    };

    _this2.confirm = function (e) {
      // if (e.keyCode !== 13) {
      //   return;
      // }
      if (+_this2.data.untimes < +_this2.data.addLabelText) {
        _app.appMethod.showModal({ content: '核销次数超过剩余次数' });
        _this2.setData({ hiddenmodalput: true, addLabelText: '' });
        return;
      }
      var url = _this2.data.numberOfStampsUrl + '&Number=' + _this2.data.addLabelText;
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
      _app.appMethod.turnToPage(url, false);
    };

    _this2.cancel = function () {
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
    };

    _this2.getTransportInfo = function (orderId, i) {
      var that = _this2,
          newdata = {};
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/queryTransporterInfo',
        data: {
          order_id: orderId
        },
        success: function success(res) {
          newdata['orderLists[' + i + '].transport'] = res.data;
          newdata['marker[0].latitude'] = res.data.transporterLat;
          newdata['marker[0].longitude'] = res.data.transporterLng;
          that.setData(newdata);
        }
      });
    };

    _this2.mapDetail = function (e) {
      var dataset = e.currentTarget.dataset,
          marker = [{
        latitude: dataset.lat,
        longitude: dataset.lng,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }];
      _app.appMethod.turnToPage('/default/pages/mapDetail/mapDetail?eventParams=' + JSON.stringify(marker));
    };

    _this2.clickOrderTab = function (e) {
      var dataset = e.target.dataset,
          index = dataset.index,
          data = {};
      data.currentTabIndex = index;
      data['pages'] = 1;
      data['orderLists'] = [];
      data['noMore'] = false;
      _this2.setData(data);
      _this2.getOrderList({ tabIndex: index });
    };

    _this2.clickMeanTab = function (pickerData) {
      var index = pickerData[0];
      var data = {};
      data.currentTabIndex = 0;
      data.existGoodsIndex = index;
      data['pages'] = 1;
      data['orderLists'] = [];
      data['noMore'] = false;
      data.currentGoodsType = _this2.data.existGoodsType[index].type;
      _this2.setData(data);
      _this2.hideGoodsPick();
      _this2.getOrderList({ tabIndex: 0 });
    };

    _this2.clickSubmenuTab = function (e) {
      var index = e.target.dataset.index;
      var data = {};
      data.currentTabIndex = index;
      data['pages'] = 1;
      data['orderLists'] = [];
      data['noMore'] = false;
      _this2.setData(data);
      _this2.getOrderList({ tabIndex: index });
    };

    _this2.goToOrderDetail = function (e) {
      var dataset = e.currentTarget.dataset,
          orderId = dataset.id,
          type = dataset.type,
          franchiseeId = dataset.franchisee,
          queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId,
          router;
      if (type === 'transfer') {
        router = '/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail=';
      } else if (type === 'tostore') {
        router = '/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail=';
      } else if (type === 'toDining') {
        router = '/eCommerce/pages/diningOrderDetail/diningOrderDetail?detail=';
      } else if (type === 'eBusiness') {
        router = '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=';
      } else if (type === 'takeout') {
        router = '/orderMeal/pages/takeoutOrderDetail/takeoutOrderDetail?detail=';
      } else if (type === 'rowNumber') {
        router = '/orderMeal/pages/rowNumberOrderDetail/rowNumberOrderDetail?detail=';
      } else if (type === 'newAppoint') {
        router = '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail=';
      } else if (type === 'ExchangeCoupon') {
        router = '/exchangeCoupon/pages/numberOfStampsOrderDetail/numberOfStampsOrderDetail?detail=';
      } else if (type === 'hotel') {
        router = '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?aptType=2&detail=';
      } else if (type === 'communityGroup') {
        router = '/promotion/pages/communityGroupOrderDetail/communityGroupOrderDetail?detail=';
      } else {
        router = '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=';
      }
      _app.appMethod.turnToPage(router + orderId + queryStr);
    };

    _this2.cancelOrder = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2;
      _app.appMethod.showModal({
        content: '你将要取消一笔付款订单，确认取消？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              app_id: appId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }
          });
        },
        cancel: function cancel() {}
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定删除此订单吗？删除后不可再恢复哦',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirmColor: '#FF7100',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              app_id: appId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }
          });
        }
      });
    };

    _this2.applyDrawback = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2,
          delivery = e.target.dataset.delivery;
      _app.appMethod.showModal({
        content: delivery == 1 ? '确定要取消订单？' : '确定要申请退款？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/applyRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }
          });
        }
      });
    };

    _this2.cancelRefund = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2,
          delivery = e.target.dataset.delivery;
      _app.appMethod.showModal({
        content: '是否撤销取消订单申请？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelRefund',
            data: {
              app_id: appId,
              order_id: orderId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }
          });
        }
      });
    };

    _this2.toCancelOrder = function (e) {
      var orderId = e.target.dataset.id;
      var deliverType = e.target.dataset.deliver;
      var dataset = e.currentTarget.dataset,
          franchiseeId = dataset.franchisee;
      _app.appMethod.turnToPage('/orderMeal/pages/cancelOrder/cancelOrder?orderId=' + orderId + '&deliverType=' + deliverType + '&franchisee=' + franchiseeId);
    };

    _this2.checkLogistics = function (e) {
      var orderLists = _this2.data.orderLists;
      var index = e.target.dataset.index;
      var orderId = orderLists[index].order_id;
      var usePickType = orderLists[index].ecommerce_info.dispatch_use_pick_up_type;
      var franchiseeId = e.target.dataset.franchisee;
      if (usePickType == 2) {
        var intraCityData = orderLists[index].ecommerce_info.intra_city_data;
        var type = intraCityData && intraCityData.deliver_type || '';
        var arriveTime = intraCityData && intraCityData.intra_city_appointment_arrive_time || '';
        _app.appMethod.turnToPage('/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' + orderId + '&type=' + type + '&arriveTime=' + arriveTime + '&franchiseeId=' + franchiseeId);
      } else {
        _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId + '&franchiseeId=' + franchiseeId);
      }
    };

    _this2.sureReceipt = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2,
          content = _this2.data.currentGoodsType == '1' ? '确认已消费?' : '确认收货代表您已经拿到货物，确认后将无法撤销！建议与商家联系后再操作';
      _app.appMethod.showModal({
        content: content,
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {},
                  addTime = Date.now();
              data['pages'] = 1;
              that.setData(data);
              if (that.data.currentGoodsType == 0) {
                _app.appMethod.turnToPage('/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' + orderId + '&franchiseeId=' + subShopId);
              } else {
                that.getOrderList({ tabIndex: index });
              }
              _app.appMethod.sendRequest({
                hideLoading: true,
                url: '/index.php?r=appShop/getIntegralLog',
                data: { add_time: addTime },
                success: function success(res) {
                  if (res.status == 0) {
                    res.data && that.setData({
                      rewardPointObj: {
                        showModal: true,
                        count: res.data,
                        callback: ''
                      }
                    });
                  }
                }
              });
            }
          });
        }
      });
    };

    _this2.makeComment = function (e) {
      var orderId = e.target.dataset.id,
          franchiseeId = e.target.dataset.franchisee,
          queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/makeComment/makeComment?detail=' + orderId + queryStr);
    };

    _this2.takeoutMakeComment = function (e) {
      var orderId = e.target.dataset.id,
          franchiseeId = e.target.dataset.franchisee,
          queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/orderMeal/pages/takeoutMakeComment/takeoutMakeComment?detail=' + orderId + queryStr);
    };

    _this2.scrollToListBottom = function () {
      var currentTabIndex = _this2.data.currentTabIndex;
      if (_this2.data.noMore) {
        return;
      }
      _this2.getOrderList({
        tabIndex: currentTabIndex,
        scrollLoad: true
      });
    };

    _this2.getTostoreSetting = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
        success: function success(res) {
          if (res.status == 0) {
            _this.setData({
              toStoreSetting: res.data
            });
          }
        }
      });
    };

    _this2.getWriteOffCodeBox = function (event) {
      var _this = _this2;
      var orderId = event.target.dataset.id;
      var franchiseeId = event.target.dataset.franchisee;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetOrderVerifyCode',
        data: {
          sub_shop_app_id: franchiseeId,
          order_id: orderId
        },
        success: _this.setVerificationCodeData
      });
    };

    _this2.setVerificationCodeData = function (res) {
      var _this = _this2;
      _this.setData({
        codeImgUrl: res.data.qrcode_url,
        codeNum: res.data.code,
        codeStatus: res.data.status,
        showWriteOffCodeBox: true
      });
      _this.connectSocket();
    };

    _this2.connectSocket = function () {
      var _this = _this2;
      _app.appMethod.connectSocket({
        url: 'wss://ceshi.zhichiwangluo.com',
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        _this.verifiTimeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_order_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_order_verify' && msg.status == 0) {
            _this.setData({
              codeStatus: 1
            });
            clearInterval(_this.verifiTimeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
    };

    _this2.hideWriteOffCodeBox = function () {
      var _this = _this2;
      _this2.setData({
        showWriteOffCodeBox: false
      });
      clearInterval(_this.verifiTimeInterval);
      _app.appMethod.closeSocket();
    };

    _this2.onemore = function () {};

    _this2.toPayOrder = function () {};

    _this2.payOrder = function (event) {
      var that = _this2,
          orderId,
          price = event.target.dataset.price;
      var franchiseeId = event.target.dataset.franchisee;
      orderId = event.target.dataset.id;
      if (price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            setTimeout(function () {
              _app.appMethod.showToast({
                title: '支付成功',
                icon: 'success'
              });
            });
            setTimeout(function () {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }, 1000);
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId,
      //     sub_shop_app_id: franchiseeId == app.getAppId() ? '' : franchiseeId
      //   },
      //   success: function(res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.goodsType = that.data.currentGoodsType
      //     param.success = function() {
      //       setTimeout(function() {
      //         var index = that.data.currentTabIndex,
      //           data = {}
      //         data['pages'] = 1
      //         that.setData(data)
      //         that.getOrderList({ tabIndex: index })
      //       }, 1500)
      //     }
      //     app.wxPay(param)
      //   }
      // })

      // TODO:支付成功回调要考虑一下怎么处理
      _app.appMethod.goPay({
        orderId: orderId,
        franchisee: franchiseeId == _app.appMethod.getAppId() ? '' : franchiseeId
      });
    };

    _this2.getTakeOutInfo = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getTakeOutInfo',
        success: function success(res) {
          that.setData({
            takeoutInfo: res.data || ''
          });
        }
      });
    };

    _this2.SectionToChinese = function (section) {
      var strIns = '',
          chnStr = '';
      var unitPos = 0;
      var zero = true;
      var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
      var chnUnitChar = ['', '十', '百', '千'];
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    };

    _this2.NumberToChinese = function (num) {
      var unitPos = 0;
      var strIns = '',
          chnStr = '';
      var needZero = false;
      var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
      var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      if (num === 0) {
        return chnNumChar[0];
      }
      while (num > 0) {
        var section = num % 10000;
        if (needZero) {
          chnStr = chnNumChar[0] + chnStr;
        }
        strIns = _this2.SectionToChinese(section);
        strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
        chnStr = strIns + chnStr;
        needZero = section < 1000 && section > 0;
        num = Math.floor(num / 10000);
        unitPos++;
      }
      return chnStr;
    };

    _this2.receiveDrawback = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['pages'] = 1;
              that.setData(data);
              that.getOrderList({ tabIndex: index });
            }
          });
        }
      });
    };

    _this2.SectionToChinese = function (section) {
      var strIns = '',
          chnStr = '';
      var unitPos = 0;
      var zero = true;
      var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
      var chnUnitChar = ['', '十', '百', '千'];
      while (section > 0) {
        var v = section % 10;
        if (v === 0) {
          if (!zero) {
            zero = true;
            chnStr = chnNumChar[v] + chnStr;
          }
        } else {
          zero = false;
          strIns = chnNumChar[v];
          strIns += chnUnitChar[unitPos];
          chnStr = strIns + chnStr;
        }
        unitPos++;
        section = Math.floor(section / 10);
      }
      return chnStr;
    };

    _this2.NumberToChinese = function (num) {
      var unitPos = 0;
      var strIns = '',
          chnStr = '';
      var needZero = false;
      var chnUnitSection = ['', '万', '亿', '万亿', '亿亿'];
      var chnNumChar = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      if (num === 0) {
        return chnNumChar[0];
      }
      while (num > 0) {
        var section = num % 10000;
        if (needZero) {
          chnStr = chnNumChar[0] + chnStr;
        }
        strIns = _this2.SectionToChinese(section);
        strIns += section !== 0 ? chnUnitSection[unitPos] : chnUnitSection[0];
        chnStr = strIns + chnStr;
        needZero = section < 1000 && section > 0;
        num = Math.floor(num / 10000);
        unitPos++;
      }
      return chnStr;
    };

    _this2.toSeeQrcode = function (event) {
      var orderId = event.target.dataset.id,
          franchiseeId = event.target.dataset.franchisee,
          codeEndDate = event.target.dataset.enddate,
          pagePath = '/newAppointment/pages/newAppointmentQrcode/newAppointmentQrcode?orderId=' + orderId + '&franchiseeId=' + franchiseeId + '&codeEndDate=' + codeEndDate;
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config,
          hasRecommendConfig: res.recommend_config ? true : false
        });
      });
    };

    _this2._isAddCommunityOrder = function (callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppDistributionExt/CountDistributionOrderByBuyerId',
        hideLoading: true,
        success: function success(res) {
          callback && callback(res);
        }
      });
    };

    _this2.showGoodsPick = function () {
      var _this = _this2;
      _this2.setData({
        showGoodsPickBox: !_this.data.showGoodsPickBox
      });
    };

    _this2.selectGoodsPick = function (e) {
      _this2.setData({
        selectGoodsPickIndex: e.currentTarget.dataset.type,
        pages: 1,
        showGoodsPickBox: false
      });
      _this2.getOrderList({
        tabIndex: _this2.data.currentTabIndex,
        firstLoad: true
      });
    };

    _this2.searchOrderId = function (e) {
      if (e.keyCode !== 13) {
        return;
      }
      _this2.setData({
        searchOrderId: e.target.value,
        pages: 1
      });
      _this2.getOrderList({
        tabIndex: _this2.data.currentTabIndex,
        firstLoad: true
      });
    };

    _this2.stopPropagation = function () {};

    _this2.hideGoodsPick = function () {
      _this2.setData({
        showGoodsPickBox: false
      });
    };

    _this2.inputOrderId = function (e) {
      _this2.setData({
        searchOrderId: e.currentTarget.value
      });
    };

    document.title = '订单列表';
    return _this2;
  }

  (0, _createClass3.default)(MyOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      if (options.goodsType && options.currentIndex) {
        this.setData({
          currentGoodsType: options.goodsType,
          currentTabIndex: options.currentIndex
        });
      }
      this.setData({
        franchiseeIdInfo: {
          id: options.franchisee || ''
        }
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        this.setData({
          pages: 1,
          currentTabIndex: this.data.currentTabIndex,
          noMore: false
        });
        this.getOrderList({ tabIndex: this.data.currentTabIndex });
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'privateStopNoop',
    value: function privateStopNoop(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          franchiseeIdInfo = _state.franchiseeIdInfo,
          existGoodsIndex = _state.existGoodsIndex,
          existGoodsType = _state.existGoodsType,
          selectGoodsPickIndex = _state.selectGoodsPickIndex,
          currentTabIndex = _state.currentTabIndex,
          currentGoodsType = _state.currentGoodsType,
          orderLists = _state.orderLists,
          goodsOrderStatusName = _state.goodsOrderStatusName,
          noMore = _state.noMore,
          takeoutInfo = _state.takeoutInfo,
          transportStatus = _state.transportStatus,
          marker = _state.marker,
          goodsNum = _state.goodsNum,
          toStoreSetting = _state.toStoreSetting,
          codeImgUrl = _state.codeImgUrl,
          codeStatus = _state.codeStatus,
          codeNum = _state.codeNum,
          showWriteOffCodeBox = _state.showWriteOffCodeBox,
          showGoodsPickBox = _state.showGoodsPickBox,
          hiddenmodalput = _state.hiddenmodalput,
          addLabelText = _state.addLabelText;

      // 处理成UI组件需要的数据格式

      var pickerData = [];
      if (existGoodsType.length) {
        existGoodsType.forEach(function (item, index) {
          pickerData.push({
            label: item.name,
            value: index
          });
        });
      }

      return React.createElement(
        'div',
        { className: 'official-page my-order' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u5217\u8868' }),
        React.createElement(
          'div',
          { className: 'app' },
          React.createElement(
            'div',
            { className: 'myOrder-wrap page', id: 'myOrder' },
            React.createElement(
              'div',
              { className: 'order-list-header' },
              React.createElement(
                _picker2.default,
                { cols: 1,
                  data: pickerData,
                  value: [existGoodsIndex],
                  onChange: this.clickMeanTab
                },
                React.createElement(
                  'div',
                  { className: 'picker-inner' },
                  React.createElement(
                    'span',
                    { className: 'exits-name' },
                    !!pickerData.length && pickerData[existGoodsIndex] && pickerData[existGoodsIndex].label
                  ),
                  React.createElement('span', { className: 'ico-moon icon-downarrow' })
                )
              ),
              React.createElement(
                'div',
                { className: 'order-list-search' },
                React.createElement('span', { className: 'ico-moon icon-search' }),
                React.createElement('input', {
                  onChange: this.inputOrderId,
                  type: 'text',
                  onKeyDown: this.searchOrderId,
                  placeholder: '\u8BF7\u8F93\u5165\u8BA2\u5355\u53F7'
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'myOrder-tab-list' },
              currentGoodsType == 0 && React.createElement(
                React.Fragment,
                null,
                selectGoodsPickIndex != 4 ? React.createElement(
                  'div',
                  {
                    className: 'tab-list-submenu goods-list-submenu',
                    onClick: this.clickSubmenuTab
                  },
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 0 ? 'active' : '',
                      'data-index': '0'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5168\u90E8'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 1 ? 'active' : '',
                      'data-index': '1'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u4ED8\u6B3E'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 5 ? 'active' : '',
                      'data-index': '5'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u63A5\u5355'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 2 ? 'active' : '',
                      'data-index': '2'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u53D1\u8D27'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 3 ? 'active' : '',
                      'data-index': '3'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u6536\u8D27'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 4 ? 'active' : '',
                      'data-index': '4'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u8BC4\u4EF7'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 6 ? 'active' : '',
                      'data-index': '6'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5DF2\u5B8C\u6210'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 7 ? 'active' : '',
                      'data-index': '7'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5DF2\u5173\u95ED'
                  ),
                  React.createElement(
                    'div',
                    {
                      onClick: this.showGoodsPick,
                      className: 'filter-goods-pick'
                    },
                    selectGoodsPickIndex == '0' ? '取货' : selectGoodsPickIndex == '1' ? '快递' : selectGoodsPickIndex == '2' ? '同城' : selectGoodsPickIndex == '3' ? '自提' : '堂食',
                    React.createElement('span', { className: 'trangel' })
                  )
                ) : selectGoodsPickIndex == 4 && React.createElement(
                  'div',
                  {
                    className: 'tab-list-submenu goods-list-submenu',
                    onClick: this.clickSubmenuTab
                  },
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 0 ? 'active' : '',
                      'data-index': '0'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5168\u90E8'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 5 ? 'active' : '',
                      'data-index': '5'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u5546\u5BB6\u63A5\u5355'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 8 ? 'active' : '',
                      'data-index': '8'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5DF2\u4E0B\u5355'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 1 ? 'active' : '',
                      'data-index': '1'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u4ED8\u6B3E'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 4 ? 'active' : '',
                      'data-index': '4'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5F85\u8BC4\u4EF7'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 6 ? 'active' : '',
                      'data-index': '6'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5DF2\u5B8C\u6210'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: currentTabIndex == 7 ? 'active' : '',
                      'data-index': '7'
                    },
                    React.createElement('span', { className: 'bottom-line' }),
                    '\u5DF2\u5173\u95ED'
                  ),
                  React.createElement(
                    'div',
                    {
                      onClick: this.showGoodsPick,
                      className: 'filter-goods-pick'
                    },
                    selectGoodsPickIndex == '0' ? '取货' : selectGoodsPickIndex == '1' ? '快递' : selectGoodsPickIndex == '2' ? '同城' : selectGoodsPickIndex == '3' ? '自提' : '堂食',
                    React.createElement('span', { className: 'trangel' })
                  )
                )
              ),
              currentGoodsType == 1 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u786E\u8BA4'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u6D88\u8D39'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 4 ? 'active' : '',
                    'data-index': '4'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u8BC4\u4EF7'
                )
              ),
              currentGoodsType == 3 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  'data-goods-type': '3',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u786E\u8BA4'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5546\u5BB6\u5DF2\u786E\u8BA4'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 4 ? 'active' : '',
                    'data-index': '4'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u8BC4\u4EF7'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 5 ? 'active' : '',
                    'data-index': '5'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u9000\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 6 ? 'active' : '',
                    'data-index': '6'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5173\u95ED'
                )
              ),
              currentGoodsType == 5 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u652F\u4ED8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5B8C\u6210'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5173\u95ED'
                )
              ),
              currentGoodsType == 2 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5B8C\u6210'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5173\u95ED'
                )
              ),
              currentGoodsType == 6 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4F7F\u7528'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u4F7F\u7528'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5931\u6548'
                )
              ),
              currentGoodsType == 10 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u786E\u8BA4'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u6D88\u8D39'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 4 ? 'active' : '',
                    'data-index': '4'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u8BC4\u4EF7'
                )
              ),
              currentGoodsType == 8 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5173\u95ED'
                )
              ),
              currentGoodsType == 9 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5DF2\u5173\u95ED'
                )
              ),
              currentGoodsType == 21 && React.createElement(
                'div',
                {
                  className: 'tab-list-submenu',
                  onClick: this.clickSubmenuTab
                },
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 0 ? 'active' : '',
                    'data-index': '0'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 1 ? 'active' : '',
                    'data-index': '1'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u4ED8\u6B3E'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 2 ? 'active' : '',
                    'data-index': '2'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u53D1\u8D27'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 3 ? 'active' : '',
                    'data-index': '3'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u914D\u9001\u4E2D'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 4 ? 'active' : '',
                    'data-index': '4'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u63D0\u8D27'
                ),
                React.createElement(
                  'div',
                  {
                    className: currentTabIndex == 5 ? 'active' : '',
                    'data-index': '5'
                  },
                  React.createElement('span', { className: 'bottom-line' }),
                  '\u5F85\u8BC4\u4EF7'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'myOrder-content-body' },
              currentGoodsType == 0 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        key: item.order_id || index,
                        className: 'myOrder-list-wrap',
                        onClick: function onClick(e) {
                          _this3.goToOrderDetail(e);e.stopPropagation();
                        },
                        'data-franchisee': item.app_id,
                        'data-id': item.order_id,
                        'data-type': item.pick_up_type == 4 ? 'toDining' : 'eBusiness',
                        style: (0, _tools.convertLineStyleData)(item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type == 4 ? 'padding: 0 24rpx;' : 'padding:0;')
                      },
                      item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type != 4 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'goods-order-header' },
                          React.createElement(
                            'div',
                            { style: (0, _tools.convertLineStyleData)('padding-bottom:2rpx;') },
                            item.is_pay_on_delivery == 1 && React.createElement(
                              'span',
                              { className: 'cash-delivery' },
                              '\u8D27\u5230\u4ED8\u6B3E'
                            ),
                            item.pick_up_type == 1 ? React.createElement(
                              'span',
                              { className: 'goods-order-time' },
                              item.add_time
                            ) : item.pick_up_type == 2 ? React.createElement(
                              'span',
                              { className: 'goods-order-time' },
                              '编号 : ' + item.ecommerce_info.intra_city_data.serial_number
                            ) : item.pick_up_type == 3 && React.createElement(
                              'span',
                              { className: 'goods-order-time' },
                              '流水号 : ' + (item.ecommerce_info.ec_tostore_data.formatted_queue_num || '')
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right myOrder-order-status' },
                              item.is_pay_on_delivery == 1 && item.status == 4 ? '审核中' : item.pick_up_type == 3 && item.status == 1 ? '待接单' : goodsOrderStatusName[item.status]
                            )
                          )
                        ),
                        item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                          'div',
                          { className: 'myOrder-franchisee-name' },
                          item.sub_shop_info.name
                        ),
                        item.goods_info.map(function (goods, index) {
                          return React.createElement(
                            'div',
                            { className: 'goods-order-content', key: goods.id || index },
                            !!+goods.use_integral && React.createElement(
                              'div',
                              { className: 'myOrder-goods-tips' },
                              React.createElement(
                                'div',
                                { className: 'myOrder-goods-tips-top' },
                                '\u79EF'
                              ),
                              React.createElement('div', { className: 'myOrder-goods-tips-left' }),
                              React.createElement('div', { className: 'myOrder-goods-tips-right' })
                            ),
                            React.createElement('img', {
                              className: 'cover',
                              src: goods.cover
                            }),
                            React.createElement(
                              'div',
                              { className: 'goods-order-detail' },
                              React.createElement(
                                'div',
                                { className: 'title' },
                                !!+goods.is_benefit_goods && React.createElement(
                                  'span',
                                  { className: 'goods-gift' },
                                  '\u8D60\u54C1'
                                ),
                                !!+goods.is_vip_goods && React.createElement(
                                  'span',
                                  { className: 'goods-gift' },
                                  '\u4F1A\u5458\u4EF7'
                                ),
                                goods.goods_name
                              ),
                              React.createElement(
                                'div',
                                { className: 'pull-right count' },
                                '×' + goods.num
                              ),
                              goods.use_integral == 0 ? React.createElement(
                                React.Fragment,
                                null,
                                React.createElement(
                                  'span',
                                  { className: 'myOrder-goods-price' },
                                  '¥' + goods.price
                                )
                              ) : React.createElement(
                                React.Fragment,
                                null,
                                (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                                  'span',
                                  { className: 'myOrder-goods-price' },
                                  '¥' + goods.price
                                ),
                                goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                                  'span',
                                  null,
                                  '+'
                                ),
                                goods.use_integral && React.createElement(
                                  'span',
                                  null,
                                  goods.use_integral + '积分'
                                )
                              )
                            )
                          );
                        }),
                        item.goods_info[0].is_presell == 1 ? React.createElement(
                          'div',
                          { className: 'presell-order-bottom' },
                          React.createElement(
                            'span',
                            { style: (0, _tools.convertLineStyleData)('margin-right:20rpx;') },
                            '定金已支付：¥ ' + item.total_bargain
                          ),
                          React.createElement(
                            'span',
                            null,
                            '尾款已支付：¥ ' + item.total_final_payment
                          )
                        ) : React.createElement(
                          'div',
                          { className: 'goods-order-bottom' },
                          React.createElement(
                            'span',
                            { className: 'myOrder-list-count' },
                            '共' + item.goods_num + '件商品'
                          ),
                          item.is_integral != '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            React.createElement(
                              'span',
                              { className: 'total-price' },
                              '¥' + item.original_price
                            )
                          ),
                          item.is_integral == '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            (item.original_price != 0 && item.original_price != '0.00' || !item.total_integral || item.total_integral == 0) && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '¥' + item.original_price
                            ),
                            item.total_integral && item.total_integral != 0 && item.original_price != 0 && item.original_price != '0.00' && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '+'
                            ),
                            item.total_integral && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              item.total_integral + '积分'
                            )
                          )
                        ),
                        item.status == 0 ? React.createElement(
                          'div',
                          { className: 'goods-btn-box' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              onClick: function onClick(e) {
                                _this3.cancelOrder(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToOrderDetail(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id,
                              'data-type': 'eBusiness'
                            },
                            '\u652F\u4ED8'
                          )
                        ) : item.status == 1 ? React.createElement(
                          'div',
                          { className: 'goods-btn-box' },
                          item.is_pay_on_delivery == 1 && React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              'data-delivery': item.is_pay_on_delivery,
                              onClick: function onClick(e) {
                                _this3.applyDrawback(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          )
                        ) : item.status == 2 ? React.createElement(
                          'div',
                          { className: 'goods-btn-box' },
                          item.is_pay_on_delivery == 1 && React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              'data-delivery': item.is_pay_on_delivery,
                              onClick: function onClick(e) {
                                _this3.applyDrawback(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          item.pick_up_type != 3 && React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-check-logistics',
                              onClick: _this3.checkLogistics,
                              'data-index': index,
                              'data-franchisee': item.app_id
                            },
                            '\u914D\u9001\u4FE1\u606F'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-sure-receipt',
                              onClick: function onClick(e) {
                                _this3.sureReceipt(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u786E\u8BA4\u6536\u8D27'
                          )
                        ) : item.status == 3 && React.createElement(
                          'div',
                          { className: 'goods-btn-box' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-make-comment',
                              onClick: function onClick(e) {
                                _this3.makeComment(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53BB\u8BC4\u4EF7'
                          )
                        )
                      ) : item.ecommerce_info && item.ecommerce_info.dispatch_use_pick_up_type == 4 && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'dialog-block-item myOrder-tostore-top' },
                          React.createElement(
                            'span',
                            { className: 'dialog-block-time' },
                            '下单时间: ' + item.add_time
                          ),
                          React.createElement(
                            'span',
                            { className: 'pull-right tostore-see-detail' },
                            '\u67E5\u770B\u8BE6\u60C5'
                          )
                        ),
                        item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                          'div',
                          { className: 'myOrder-franchisee-name' },
                          item.sub_shop_info.name
                        ),
                        React.createElement(
                          'div',
                          { className: 'myOrder-goods-list' },
                          item.goods_info.map(function (goods, index) {
                            return React.createElement(
                              'div',
                              {
                                className: 'goods-order-content',
                                style: (0, _tools.convertLineStyleData)('display:flex;'),
                                key: goods.id || index
                              },
                              !!+goods.use_integral && React.createElement(
                                'div',
                                { className: 'myOrder-goods-tips' },
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-tips-top' },
                                  '\u79EF'
                                ),
                                React.createElement('div', { className: 'myOrder-goods-tips-left' }),
                                React.createElement('div', { className: 'myOrder-goods-tips-right' })
                              ),
                              React.createElement('img', {
                                className: 'cover',
                                src: goods.cover
                              }),
                              React.createElement(
                                'div',
                                { className: 'goods-order-detail' },
                                React.createElement(
                                  'div',
                                  { className: 'title' },
                                  !!+goods.is_benefit_goods && React.createElement(
                                    'span',
                                    { className: 'goods-gift' },
                                    '\u8D60\u54C1'
                                  ),
                                  !!+goods.is_vip_goods && React.createElement(
                                    'span',
                                    { className: 'goods-gift' },
                                    '\u4F1A\u5458\u4EF7'
                                  ),
                                  goods.goods_name
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'pull-right count' },
                                  '×' + goods.num
                                ),
                                goods.use_integral == 0 ? React.createElement(
                                  React.Fragment,
                                  null,
                                  React.createElement(
                                    'span',
                                    { className: 'myOrder-goods-price' },
                                    '¥' + goods.price
                                  )
                                ) : React.createElement(
                                  React.Fragment,
                                  null,
                                  (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                                    'span',
                                    { className: 'myOrder-goods-price' },
                                    '¥' + goods.price
                                  ),
                                  goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                                    'span',
                                    null,
                                    '+'
                                  ),
                                  goods.use_integral && React.createElement(
                                    'span',
                                    null,
                                    goods.use_integral + '积分'
                                  )
                                )
                              )
                            );
                          })
                        ),
                        React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'div',
                            null,
                            item.tostore_data.formatted_queue_num && React.createElement(
                              'label',
                              { className: 'pull-left' },
                              '\u53D6\u9910\u53F7\uFF1A',
                              React.createElement(
                                'span',
                                null,
                                item.tostore_data.formatted_queue_num
                              )
                            ),
                            React.createElement(
                              'label',
                              null,
                              React.createElement(
                                'span',
                                { className: 'myOrder-list-count' },
                                '共' + item.goods_num + '件'
                              ),
                              item.is_integral != '1' ? React.createElement(
                                React.Fragment,
                                null,
                                React.createElement(
                                  'span',
                                  null,
                                  '¥ ' + item.original_price
                                )
                              ) : React.createElement(
                                React.Fragment,
                                null,
                                (item.original_price != '0.00' && item.original_price != 0 || !item.total_integral || item.total_integral == 0) && React.createElement(
                                  'span',
                                  null,
                                  '¥' + item.original_price
                                ),
                                item.original_price != '0.00' && item.original_price != 0 && item.total_integral && item.total_integral != 0 && React.createElement(
                                  'span',
                                  null,
                                  '+'
                                ),
                                item.total_integral && item.total_integral != 0 && React.createElement(
                                  'span',
                                  null,
                                  item.total_integral + '积分'
                                )
                              ),
                              item.status == 0 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5F85\u4ED8\u6B3E'
                              ) : item.status == 1 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u7B49\u5F85\u5546\u5BB6\u786E\u8BA4'
                              ) : item.status == 2 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5546\u5BB6\u5DF2\u786E\u8BA4'
                              ) : item.status == 3 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5F85\u8BC4\u4EF7'
                              ) : item.status == 4 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                              ) : item.status == 5 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u6B63\u5728\u9000\u6B3E\u4E2D'
                              ) : item.status == 6 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5DF2\u5B8C\u6210'
                              ) : item.status == 7 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5DF2\u5173\u95ED'
                              ) : item.status == 8 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5F85\u63A5\u5355'
                              ) : item.status == 16 ? React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5F85\u63A5\u5355'
                              ) : item.status == 17 && React.createElement(
                                'span',
                                { className: 'tostore-order-status' },
                                '\u5DF2\u4E0B\u5355'
                              )
                            )
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 1 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-appointment myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'myOrder-list-wrap', key: item.order_id || index },
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item' },
                        React.createElement(
                          'span',
                          { className: 'dialog-block-time' },
                          item.add_time
                        ),
                        item.status == 0 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u4ED8\u6B3E'
                        ) : item.status == 1 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u7B49\u5F85\u5546\u5BB6\u786E\u8BA4'
                        ) : item.status == 2 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u6D88\u8D39'
                        ) : item.status == 3 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u8BC4\u4EF7'
                        ) : item.status == 4 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                        ) : item.status == 5 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u6B63\u5728\u9000\u6B3E\u4E2D'
                        ) : item.status == 6 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u6D88\u8D39'
                        ) : item.status == 7 && React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u5173\u95ED'
                        )
                      ),
                      item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                        'div',
                        { className: 'myOrder-franchisee-name' },
                        item.sub_shop_info.name
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'myOrder-goods-list',
                          onClick: function onClick(e) {
                            _this3.goToOrderDetail(e);e.stopPropagation();
                          },
                          'data-franchisee': item.app_id,
                          'data-id': item.order_id
                        },
                        Array.isArray(item.goods_info) && item.goods_info.map(function (goods, index) {
                          return React.createElement(
                            'div',
                            { key: goods.id || index },
                            React.createElement(
                              'div',
                              { className: 'dialog-block-item' },
                              goods.use_integral && React.createElement(
                                'div',
                                { className: 'myOrder-goods-tips' },
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-tips-top' },
                                  '\u79EF'
                                ),
                                React.createElement('div', { className: 'myOrder-goods-tips-left' }),
                                React.createElement('div', { className: 'myOrder-goods-tips-right' })
                              ),
                              React.createElement('img', {
                                className: 'myOrder-goods-cover',
                                src: goods.cover
                              }),
                              React.createElement(
                                'div',
                                { className: 'myOrder-goods-title' },
                                !!+goods.is_vip_goods && React.createElement(
                                  'span',
                                  { className: 'goods-gift' },
                                  '\u4F1A\u5458\u4EF7'
                                ),
                                goods.goods_name
                              ),
                              React.createElement(
                                'div',
                                { className: 'myOrder-goods-right' },
                                React.createElement(
                                  'div',
                                  null,
                                  goods.use_integral == 0 ? React.createElement(
                                    React.Fragment,
                                    null,
                                    React.createElement(
                                      'span',
                                      { className: 'myOrder-goods-price' },
                                      '¥' + goods.price
                                    )
                                  ) : React.createElement(
                                    React.Fragment,
                                    null,
                                    (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                                      'span',
                                      { className: 'myOrder-goods-price' },
                                      '¥' + goods.price
                                    ),
                                    goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                                      'span',
                                      null,
                                      '+'
                                    ),
                                    goods.use_integral && React.createElement(
                                      'span',
                                      null,
                                      goods.use_integral + '积分'
                                    )
                                  )
                                ),
                                React.createElement(
                                  'div',
                                  null,
                                  '\xD7',
                                  React.createElement(
                                    'span',
                                    { className: 'myOrder-goods-count' },
                                    goods.num
                                  )
                                )
                              )
                            )
                          );
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item myOrder-total-item' },
                        item.is_integral != '1' && React.createElement(
                          'span',
                          null,
                          '\u5408\u8BA1\uFF1A',
                          React.createElement(
                            'span',
                            { className: 'myOrder-pay-price' },
                            '¥' + item.total_price
                          )
                        ),
                        item.is_integral == '1' && React.createElement(
                          'span',
                          null,
                          '\u5408\u8BA1\uFF1A',
                          (item.original_price != '0.00' && item.original_price != 0 || !item.total_integral || item.total_integral == 0) && React.createElement(
                            'span',
                            { className: 'myOrder-pay-price' },
                            '¥' + item.original_price
                          ),
                          item.total_integral && item.total_integral != 0 && item.original_price != 0 && item.original_price != '0.00' && React.createElement(
                            'span',
                            { className: 'myOrder-pay-price' },
                            '+'
                          ),
                          item.total_integral && React.createElement(
                            'span',
                            { className: 'myOrder-pay-price' },
                            item.total_integral + '积分'
                          )
                        )
                      ),
                      item.status == 0 ? React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-cancel-order',
                            onClick: function onClick(e) {
                              _this3.cancelOrder(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u53D6\u6D88\u8BA2\u5355'
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-pay-directly',
                            onClick: function onClick(e) {
                              _this3.goToOrderDetail(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u652F\u4ED8'
                        )
                      ) : item.status == 1 ? React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-verification-code',
                            onClick: function onClick(e) {
                              _this3.getWriteOffCodeBox(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u6838\u9500\u7801'
                        ),
                        !item.timeDiff && React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-apply-drawback',
                            onClick: function onClick(e) {
                              _this3.applyDrawback(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u7533\u8BF7\u9000\u6B3E'
                        )
                      ) : item.status == 2 ? React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        !item.timeDiff && React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-apply-drawback',
                            onClick: function onClick(e) {
                              _this3.applyDrawback(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u7533\u8BF7\u9000\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-sure-receipt',
                            onClick: function onClick(e) {
                              _this3.sureReceipt(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u786E\u8BA4\u6D88\u8D39'
                        )
                      ) : item.status == 3 && React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-make-comment',
                            onClick: function onClick(e) {
                              _this3.makeComment(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u53BB\u8BC4\u4EF7'
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 2 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-takeout myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap',
                        style: (0, _tools.convertLineStyleData)('margin-bottom: 16rpx;' + (item.status == 3 || item.status == 1 ? 'padding-bottom:0rpx;' : '')),
                        onClick: function onClick(e) {
                          _this3.goToOrderDetail(e);e.stopPropagation();
                        },
                        'data-franchisee': item.app_id,
                        'data-id': item.order_id,
                        'data-type': 'takeout',
                        key: item.order_id || index
                      },
                      React.createElement(
                        'div',
                        { className: 'myOrder-goods-list' },
                        index == 0 && React.createElement(
                          React.Fragment,
                          null,
                          Array.isArray(item.goods_info) && item.goods_info.map(function (goods, index) {
                            return React.createElement(
                              'div',
                              { key: goods.id || index },
                              React.createElement(
                                'div',
                                { className: 'dialog-block-item' },
                                item.sub_shop_info && item.sub_shop_info.name ? React.createElement('img', {
                                  className: 'myOrder-goods-cover',
                                  src: item.sub_shop_info.logo,
                                  mode: 'aspectFill'
                                }) : React.createElement('img', {
                                  className: 'myOrder-goods-cover',
                                  src: takeoutInfo && takeoutInfo.cover,
                                  mode: 'aspectFill'
                                }),
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-takeout-Info' },
                                  React.createElement(
                                    'div',
                                    { style: (0, _tools.convertLineStyleData)('font-size: 30rpx;font-weight: 400;height: 30rpx;') },
                                    item.sub_shop_info && item.sub_shop_info.name || takeoutInfo && takeoutInfo.title,
                                    item.status == 0 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size:26rpx;font-weight: normal;')
                                      },
                                      '\u5F85\u4ED8\u6B3E'
                                    ) : item.status == 8 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u5F85\u63A5\u5355'
                                    ) : item.status == 1 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u5F85\u914D\u9001'
                                    ) : item.status == 2 && (item.take_out_info.deliver_type == 0 || item.take_out_info.deliver_type == '') ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u914D\u9001\u4E2D'
                                    ) : item.status == 2 && (item.take_out_info.deliver_type == 3 || item.take_out_info.deliver_type == 1) ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      transportStatus[item.take_out_transport_order.status]
                                    ) : item.status == 3 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u5F85\u8BC4\u4EF7'
                                    ) : item.status == 4 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                                    ) : item.status == 5 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u6B63\u5728\u9000\u6B3E\u4E2D'
                                    ) : item.status == 6 ? React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u5DF2\u5B8C\u6210'
                                    ) : item.status == 7 && React.createElement(
                                      'span',
                                      {
                                        className: 'takeout-order-status pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-size: 26rpx;font-weight: normal;')
                                      },
                                      '\u5DF2\u5173\u95ED'
                                    )
                                  ),
                                  React.createElement(
                                    'div',
                                    { style: (0, _tools.convertLineStyleData)('font-size: 22rpx;margin-top: 12rpx;margin-bottom:32rpx;color: #999;') },
                                    item.add_time
                                  )
                                ),
                                item.transport && item.transport.statusCode >= 2 && React.createElement(Map, {
                                  onClick: _this3.mapDetail,
                                  'data-lat': item.transport.transporterLat,
                                  'data-lng': item.transport.transporterLng,
                                  style: (0, _tools.convertLineStyleData)('margin: 10rpx auto;'),
                                  longitude: item.transport.transporterLng,
                                  latitude: item.transport.transporterLat,
                                  scale: '18',
                                  markers: marker,
                                  showLocation: true
                                }),
                                goods.is_presell == 1 ? React.createElement(
                                  'div',
                                  { className: 'presell-order-bottom' },
                                  React.createElement(
                                    'span',
                                    null,
                                    '定金已支付：¥ ' + item.form_data.total_bargain
                                  ),
                                  React.createElement(
                                    'span',
                                    null,
                                    '尾款已支付：¥ ' + item.form_data.total_final_payment
                                  )
                                ) : React.createElement(
                                  'div',
                                  { className: 'takeout-goods-detail' },
                                  React.createElement(
                                    'div',
                                    { className: 'myOrder-takeout-title' },
                                    goods.goods_name + (goodsNum > 1 ? '等' : '') + goodsNum + '件商品',
                                    React.createElement(
                                      'span',
                                      {
                                        className: 'pull-right',
                                        style: (0, _tools.convertLineStyleData)('font-weight: 500;color: #333;')
                                      },
                                      React.createElement(
                                        'span',
                                        { style: (0, _tools.convertLineStyleData)('margin: 0 3px;font-size: 22rpx;font-weight: normal;') },
                                        '\xA5'
                                      ),
                                      item.total_price
                                    )
                                  )
                                ),
                                item.status == 0 && React.createElement(
                                  'div',
                                  { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: function onClick(e) {
                                        _this3.cancelOrder(e);e.stopPropagation();
                                      },
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;margin-right:23rpx;')
                                    },
                                    '\u53D6\u6D88\u8BA2\u5355'
                                  ),
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn btn-orange myOrder-make-comment',
                                      onClick: _this3.payOrder,
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      'data-price': item.total_price,
                                      style: (0, _tools.convertLineStyleData)('padding: 0px 10px;font-size: 24rpx;')
                                    },
                                    '\u53BB\u652F\u4ED8'
                                  )
                                ),
                                (item.status == 1 && !item.take_out_info.transport_shop_id || item.status == 8) && React.createElement(
                                  'div',
                                  { className: 'myOrder-list-bottom' },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: _this3.toCancelOrder,
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      'data-deliver': item.take_out_info.deliver_type,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;')
                                    },
                                    '\u53D6\u6D88\u8BA2\u5355'
                                  )
                                ),
                                item.status == 3 && React.createElement(
                                  'div',
                                  { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: function onClick(e) {
                                        _this3.orderDelete(e);e.stopPropagation();
                                      },
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;margin-right:16rpx;')
                                    },
                                    '\u5220\u9664\u8BA2\u5355'
                                  ),
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn btn-orange myOrder-make-comment',
                                      onClick: function onClick(e) {
                                        _this3.takeoutMakeComment(e);e.stopPropagation();
                                      },
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding: 0px 10px;font-size: 24rpx;')
                                    },
                                    '\u53BB\u8BC4\u4EF7'
                                  )
                                ),
                                item.status == 4 && React.createElement(
                                  'div',
                                  { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: _this3.cancelRefund,
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;')
                                    },
                                    '\u64A4\u9500\u7533\u8BF7'
                                  )
                                ),
                                item.status == 5 && React.createElement(
                                  'div',
                                  { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: function onClick(e) {
                                        _this3.receiveDrawback(e);e.stopPropagation();
                                      },
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;')
                                    },
                                    '\u6536\u5230\u9000\u6B3E'
                                  )
                                ),
                                (item.status == 6 || item.status == 7) && React.createElement(
                                  'div',
                                  { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                                  React.createElement(
                                    'span',
                                    {
                                      className: 'btn myOrder-apply-drawback',
                                      onClick: function onClick(e) {
                                        _this3.orderDelete(e);e.stopPropagation();
                                      },
                                      'data-franchisee': item.app_id,
                                      'data-id': item.order_id,
                                      style: (0, _tools.convertLineStyleData)('padding:1px 10px;font-size:24rpx;border-radius: 4px;')
                                    },
                                    '\u5220\u9664\u8BA2\u5355'
                                  )
                                )
                              )
                            );
                          })
                        ),
                        item.goods_info && item.goods_info[0] && item.goods_info[0].is_presell == 1 ? React.createElement(
                          'div',
                          { className: 'presell-order-bottom' },
                          React.createElement(
                            'span',
                            { style: (0, _tools.convertLineStyleData)('margin-right:20rpx;') },
                            '定金已支付：¥ ' + item.total_bargain
                          ),
                          React.createElement(
                            'span',
                            null,
                            '尾款已支付：¥ ' + item.total_final_payment
                          )
                        ) : React.createElement(
                          'div',
                          { className: 'goods-order-bottom' },
                          React.createElement(
                            'span',
                            { className: 'myOrder-list-count' },
                            '共' + item.goods_num + '件商品'
                          ),
                          item.is_integral != '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            React.createElement(
                              'span',
                              { className: 'total-price' },
                              '¥' + item.original_price
                            )
                          ),
                          item.is_integral == '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            (item.original_price != 0 && item.original_price != '0.00' || !item.total_integral || item.total_integral == 0) && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '¥' + item.original_price
                            ),
                            item.total_integral && item.total_integral != 0 && item.original_price != 0 && item.original_price != '0.00' && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '+'
                            ),
                            item.total_integral && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              item.total_integral + '积分'
                            )
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 3 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-tostore myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap',
                        key: item.order_id || index,
                        onClick: function onClick(e) {
                          _this3.goToOrderDetail(e);e.stopPropagation();
                        },
                        'data-franchisee': item.app_id,
                        'data-id': item.order_id,
                        'data-type': 'tostore'
                      },
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item myOrder-tostore-top' },
                        React.createElement(
                          'span',
                          { className: 'dialog-block-time' },
                          '下单时间: ' + item.add_time
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right tostore-see-detail' },
                          '\u67E5\u770B\u8BE6\u60C5'
                        )
                      ),
                      item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                        'div',
                        { className: 'myOrder-franchisee-name' },
                        item.sub_shop_info.name
                      ),
                      React.createElement(
                        'div',
                        { className: 'myOrder-goods-list' },
                        React.createElement(
                          React.Fragment,
                          null,
                          Object.values(item.goods_info).map(function (goods, index) {
                            return index == 0 && React.createElement(
                              'div',
                              { key: goods.id || index },
                              React.createElement(
                                'div',
                                { className: 'dialog-block-item' },
                                !!+goods.use_integral && React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-tips' },
                                  React.createElement(
                                    'div',
                                    { className: 'myOrder-goods-tips-top' },
                                    '\u79EF'
                                  ),
                                  React.createElement('div', { className: 'myOrder-goods-tips-left' }),
                                  React.createElement('div', { className: 'myOrder-goods-tips-right' })
                                ),
                                React.createElement('img', {
                                  className: 'myOrder-goods-cover',
                                  src: goods.cover,
                                  mode: 'aspectFill'
                                }),
                                React.createElement(
                                  'div',
                                  { className: 'tostore-goods-detail' },
                                  React.createElement(
                                    'div',
                                    { className: 'myOrder-tostore-title' },
                                    React.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('font-size: 28rpx;') },
                                      goods.goods_name
                                    ),
                                    !!goods.model_value.length && React.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('color: #999;margin-top: 8rpx;line-height: 32rpx;') },
                                      goods.model_name.map(function (item, index) {
                                        return React.createElement(
                                          'div',
                                          { key: index },
                                          item + ' : ' + goods.model_value[index]
                                        );
                                      })
                                    )
                                  ),
                                  React.createElement(
                                    'div',
                                    { className: 'tostorePrice-num' },
                                    React.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('font-size: 30rpx') },
                                      goods.use_integral == 0 ? React.createElement(
                                        React.Fragment,
                                        null,
                                        React.createElement(
                                          'span',
                                          null,
                                          '¥' + goods.price
                                        )
                                      ) : React.createElement(
                                        React.Fragment,
                                        null,
                                        (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                                          'span',
                                          null,
                                          '¥' + goods.price
                                        ),
                                        goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                                          'span',
                                          null,
                                          '+'
                                        ),
                                        goods.use_integral && React.createElement(
                                          'span',
                                          null,
                                          goods.use_integral + '积分'
                                        )
                                      )
                                    ),
                                    React.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('color: #999;') },
                                      '×' + goods.num
                                    )
                                  )
                                )
                              )
                            );
                          })
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'div',
                          null,
                          item.tostore_data && item.tostore_data.formatted_queue_num && React.createElement(
                            'label',
                            { className: 'pull-left' },
                            '\u53D6\u9910\u53F7\uFF1A',
                            React.createElement(
                              'span',
                              null,
                              item.tostore_data.formatted_queue_num
                            )
                          ),
                          React.createElement(
                            'label',
                            null,
                            React.createElement(
                              'span',
                              { className: 'myOrder-list-count' },
                              '共' + item.goods_num + '件'
                            ),
                            item.is_integral != '1' ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'span',
                                null,
                                '¥' + item.total_price
                              )
                            ) : React.createElement(
                              React.Fragment,
                              null,
                              (item.original_price != '0.00' && item.original_price != 0 || !item.total_integral || item.total_integral == 0) && React.createElement(
                                'span',
                                null,
                                '¥' + item.original_price
                              ),
                              item.original_price != '0.00' && item.original_price != 0 && item.total_integral && item.total_integral != 0 && React.createElement(
                                'span',
                                null,
                                '+'
                              ),
                              item.total_integral && item.total_integral != 0 && React.createElement(
                                'span',
                                null,
                                item.total_integral + '积分'
                              )
                            ),
                            item.status == 0 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u5F85\u4ED8\u6B3E'
                            ) : item.status == 1 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u7B49\u5F85\u5546\u5BB6\u786E\u8BA4'
                            ) : item.status == 2 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u5546\u5BB6\u5DF2\u786E\u8BA4'
                            ) : item.status == 3 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u5F85\u8BC4\u4EF7'
                            ) : item.status == 4 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                            ) : item.status == 5 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u6B63\u5728\u9000\u6B3E\u4E2D'
                            ) : item.status == 6 ? React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u5DF2\u5B8C\u6210'
                            ) : item.status == 7 && React.createElement(
                              'span',
                              { className: 'tostore-order-status' },
                              '\u5DF2\u5173\u95ED'
                            )
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 5 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-transfer myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap',
                        key: item.order_id || index,
                        onClick: function onClick(e) {
                          _this3.goToOrderDetail(e);e.stopPropagation();
                        },
                        'data-franchisee': item.app_id,
                        'data-id': item.order_id,
                        'data-type': 'transfer'
                      },
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item' },
                        React.createElement(
                          'span',
                          { className: 'dialog-block-time' },
                          item.add_time
                        ),
                        item.status == 0 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u4ED8\u6B3E'
                        ) : item.status == 6 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u5B8C\u6210'
                        ) : item.status == 7 && React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u5173\u95ED'
                        )
                      ),
                      item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                        'div',
                        { className: 'myOrder-franchisee-name' },
                        item.sub_shop_info.name
                      ),
                      React.createElement(
                        'div',
                        { className: 'myOrder-goods-list' },
                        React.createElement(
                          React.Fragment,
                          null,
                          Array.isArray(item.goods_info) && item.goods_info.map(function (goods, index) {
                            return index == 0 && React.createElement(
                              'div',
                              { key: goods.id || index },
                              React.createElement(
                                'div',
                                { className: 'dialog-block-item' },
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-cover transfer-order-cover' },
                                  React.createElement('img', {
                                    src: item.app_info.app_logo
                                  })
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-title' },
                                  '\u5F53\u9762\u4ED8\u8BA2\u5355'
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'myOrder-goods-right' },
                                  React.createElement(
                                    'div',
                                    null,
                                    '\xA5',
                                    React.createElement(
                                      'span',
                                      { className: 'myOrder-goods-price' },
                                      goods.price
                                    )
                                  )
                                )
                              )
                            );
                          })
                        ),
                        React.createElement(
                          'div',
                          { className: 'dialog-block-item myOrder-total-item' },
                          item.is_integral != '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '¥' + item.total_price
                            )
                          ),
                          item.is_integral == '1' && React.createElement(
                            'span',
                            null,
                            '\u5408\u8BA1\uFF1A',
                            (item.original_price != '0.00' && item.original_price != 0 || !item.total_integral || item.total_integral == 0) && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '¥' + item.original_price
                            ),
                            item.total_integral && item.total_integral != 0 && item.original_price != 0 && item.original_price != '0.00' && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              '+'
                            ),
                            item.total_integral && React.createElement(
                              'span',
                              { className: 'myOrder-pay-price' },
                              item.total_integral + '积分'
                            )
                          )
                        ),
                        item.status == 0 ? React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              onClick: function onClick(e) {
                                _this3.cancelOrder(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToOrderDetail(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u652F\u4ED8'
                          )
                        ) : item.status == 1 ? React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-verification-code',
                              onClick: function onClick(e) {
                                _this3.getWriteOffCodeBox(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u6838\u9500\u7801'
                          ),
                          !item.timeDiff && React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-apply-drawback',
                              onClick: function onClick(e) {
                                _this3.applyDrawback(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u7533\u8BF7\u9000\u6B3E'
                          )
                        ) : item.status == 2 ? React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          !item.timeDiff && React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-apply-drawback',
                              onClick: function onClick(e) {
                                _this3.applyDrawback(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u7533\u8BF7\u9000\u6B3E'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-sure-receipt',
                              onClick: function onClick(e) {
                                _this3.sureReceipt(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u786E\u8BA4\u6D88\u8D39'
                          )
                        ) : item.status == 3 && React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-make-comment',
                              onClick: function onClick(e) {
                                _this3.makeComment(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53BB\u8BC4\u4EF7'
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 6 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap row-number-box',
                        key: item.order_id || index,
                        onClick: function onClick(e) {
                          _this3.goToOrderDetail(e);e.stopPropagation();
                        },
                        'data-franchisee': item.app_id,
                        'data-id': item.order_id,
                        'data-type': 'rowNumber'
                      },
                      React.createElement(
                        'div',
                        { className: 'take-num-time' },
                        React.createElement(
                          'span',
                          null,
                          '取号时间：' + item.add_time
                        ),
                        React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
                      ),
                      React.createElement(
                        'div',
                        { className: 'myOrder-row-number-shop' },
                        React.createElement('img', { src: item.app_info && item.app_info.app_logo }),
                        React.createElement(
                          'span',
                          null,
                          item.app_info && item.app_info.app_name
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'row-num-content' },
                        React.createElement('span', { className: 'ico-moon icon-mine-row-number' }),
                        '我的排号：' + (item.line_up_data && (item.line_up_data.queue_num_name || '未排号'))
                      ),
                      React.createElement(
                        'div',
                        { className: 'row-num-content' },
                        React.createElement('span', { className: 'ico-moon icon-row-number-type' }),
                        '排号类型：' + (item.line_up_data && (item.line_up_data.line_up_type_data ? item.line_up_data.line_up_type_data.name : item.line_up_data.line_up_type_name))
                      ),
                      React.createElement(
                        'div',
                        { className: 'row-num-content' },
                        React.createElement('span', { className: 'ico-moon icon-row-number-wait' }),
                        '预计等待：' + ((item.line_up_data && item.line_up_data.prepare_wait_time) > 0 ? (item.line_up_data.prepare_wait_time > toStoreSetting.max_display_time ? '>' + toStoreSetting.max_display_time : item.line_up_data.prepare_wait_time) + '分钟' : '无需等待')
                      ),
                      React.createElement(
                        'div',
                        { className: 'myOrder-rowNum-bottom' },
                        React.createElement(
                          'span',
                          { className: 'myOrder-list-price' },
                          React.createElement('span', { className: 'ico-moon icon-row-number-fee' }),
                          '排号费：¥' + item.original_price
                        ),
                        item.status == 0 ? React.createElement(
                          'span',
                          { className: 'rowNum-order-status' },
                          '\u5F85\u4ED8\u6B3E'
                        ) : item.status == 2 ? React.createElement(
                          'span',
                          { className: 'rowNum-order-status' },
                          '\u5F85\u4F7F\u7528'
                        ) : item.status == 4 ? React.createElement(
                          'span',
                          { className: 'rowNum-order-status' },
                          '\u9000\u6B3E\u7533\u8BF7\u4E2D'
                        ) : item.status == 5 ? React.createElement(
                          'span',
                          { className: 'rowNum-order-status' },
                          '\u9000\u6B3E\u4E2D'
                        ) : item.status == 6 ? React.createElement(
                          'span',
                          { className: 'rowNum-order-status used-rowNum-order' },
                          '\u5DF2\u4F7F\u7528'
                        ) : item.status == 7 && React.createElement(
                          'span',
                          { className: 'rowNum-order-status' },
                          '\u5DF2\u5931\u6548'
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 10 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'newAppointment myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'newAppointment-list-wrap', key: index },
                      React.createElement(
                        'div',
                        { className: 'newAppointment-status' },
                        item.status == 0 ? React.createElement(
                          'span',
                          null,
                          '\u5F85\u4ED8\u6B3E'
                        ) : item.status == 1 ? React.createElement(
                          'span',
                          null,
                          '\u7B49\u5F85\u5546\u5BB6\u786E\u8BA4'
                        ) : item.status == 2 ? React.createElement(
                          'span',
                          null,
                          '\u5F85\u6D88\u8D39'
                        ) : item.status == 3 ? React.createElement(
                          'span',
                          null,
                          '\u5F85\u8BC4\u4EF7'
                        ) : item.status == 4 ? React.createElement(
                          'span',
                          null,
                          '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                        ) : item.status == 5 ? React.createElement(
                          'span',
                          null,
                          '\u6B63\u5728\u9000\u6B3E\u4E2D'
                        ) : item.status == 6 ? React.createElement(
                          'span',
                          null,
                          '\u5DF2\u5B8C\u6210'
                        ) : item.status == 7 && React.createElement(
                          'span',
                          null,
                          '\u5DF2\u5173\u95ED'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'newAppointment-goods-list',
                          onClick: function onClick(e) {
                            _this3.goToOrderDetail(e);e.stopPropagation();
                          },
                          'data-franchisee': item.app_id,
                          'data-id': item.order_id,
                          'data-type': item.service && item.service.is_hotel_appointment == 1 ? 'hotel' : 'newAppoint'
                        },
                        React.createElement(
                          'div',
                          null,
                          React.createElement(
                            'div',
                            { className: 'appointment-info' },
                            React.createElement('img', { src: item.goods_info && item.goods_info[0] && item.goods_info[0].cover }),
                            React.createElement(
                              'div',
                              { className: 'des' },
                              React.createElement(
                                'div',
                                { className: 'serve-title' },
                                React.createElement(
                                  'span',
                                  null,
                                  item.goods_info && item.goods_info[0] && item.goods_info[0].goods_name
                                ),
                                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                              ),
                              item.service && item.service.is_hotel_appointment == 1 ? React.createElement(
                                'div',
                                { className: 'hotel-info' },
                                React.createElement(
                                  'div',
                                  { className: 'time-box' },
                                  React.createElement(
                                    'div',
                                    { className: 'checkIn' },
                                    '\u5165\u4F4F',
                                    React.createElement(
                                      'span',
                                      null,
                                      item.newAppointmentData.start_date
                                    ),
                                    item.newAppointmentData.start_day
                                  ),
                                  React.createElement('div', {
                                    className: 'sLine',
                                    style: (0, _tools.convertLineStyleData)('margin:0 20rpx;')
                                  }),
                                  React.createElement(
                                    'div',
                                    { className: 'ckeckOut' },
                                    '\u79BB\u5E97',
                                    React.createElement(
                                      'span',
                                      null,
                                      item.newAppointmentData.end_date
                                    ),
                                    item.newAppointmentData.end_day
                                  )
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'day-count' },
                                  '共' + item.newAppointmentData.count + '晚'
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'price' },
                                  React.createElement(
                                    'span',
                                    null,
                                    '\u4EF7\u683C\uFF1A'
                                  ),
                                  '¥' + item.goods_info[0].price + ' x ' + item.goods_info[0].num
                                )
                              ) : React.createElement(
                                'div',
                                { className: 'section' },
                                item.newAppointmentData && item.newAppointmentData.serveInfo.map(function (wrap, index) {
                                  return React.createElement(
                                    'div',
                                    { className: 'area', key: index },
                                    React.createElement(
                                      'span',
                                      null,
                                      wrap.label + '：'
                                    ),
                                    wrap.value
                                  );
                                }),
                                item.newAppointmentData && !!item.newAppointmentData.providerList.length && React.createElement(
                                  'div',
                                  { className: 'area' },
                                  React.createElement(
                                    'span',
                                    null,
                                    item.newAppointmentData.providerTitle + '：'
                                  ),
                                  item.newAppointmentData.providerList.map(function (wrap, index) {
                                    return React.createElement(
                                      React.Fragment,
                                      { key: index },
                                      wrap.name
                                    );
                                  })
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'duration' },
                                  React.createElement(
                                    'span',
                                    null,
                                    '\u65F6\u95F4\uFF1A'
                                  ),
                                  item.newAppointmentData && item.newAppointmentData.duration + '分钟'
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'arrival-time' },
                                  React.createElement(
                                    'span',
                                    null,
                                    '\u5230\u5E97\u65F6\u95F4\uFF1A'
                                  ),
                                  React.createElement(
                                    'span',
                                    {
                                      className: item.status == 3 || item.status == 6 ? '' : 'arrival-detail-time'
                                    },
                                    item.newAppointmentData && item.newAppointmentData.toStoreTime + '-' + item.newAppointmentData.toStoreTimeEnd
                                  )
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'price' },
                                  React.createElement(
                                    'span',
                                    null,
                                    '\u4EF7\u683C\uFF1A'
                                  ),
                                  '¥' + (item.goods_info && item.goods_info[0] && item.goods_info[0].price + ' x ' + item.goods_info[0].num)
                                )
                              )
                            )
                          )
                        )
                      ),
                      item.status == 0 ? React.createElement(
                        'div',
                        { className: 'newAppointment-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-pay-directly',
                            onClick: function onClick(e) {
                              _this3.goToOrderDetail(e);e.stopPropagation();
                            },
                            'data-type': item.service && item.service.is_hotel_appointment == 1 ? 'hotel' : 'newAppoint',
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u652F\u4ED8'
                        )
                      ) : item.status == 1 ? React.createElement(
                        'div',
                        { className: 'newAppointment-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-verification-code',
                            onClick: _this3.toSeeQrcode,
                            'data-enddate': item.newAppointmentData && item.newAppointmentData.endDate,
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          React.createElement('span', { className: 'ico-moon icon-new-appointment-qrcode' }),
                          '\u67E5\u770B\u5238\u7801'
                        )
                      ) : item.status == 2 ? React.createElement(
                        'div',
                        { className: 'newAppointment-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-verification-code',
                            onClick: _this3.toSeeQrcode,
                            'data-enddate': item.newAppointmentData && item.newAppointmentData.endDate,
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          React.createElement('span', { className: 'ico-moon icon-new-appointment-qrcode' }),
                          '\u67E5\u770B\u5238\u7801'
                        )
                      ) : item.status == 3 ? React.createElement(
                        'div',
                        { className: 'newAppointment-list-bottom grade' },
                        React.createElement(
                          'div',
                          null,
                          [1, 2, 3, 4, 5].map(function (item, index) {
                            return React.createElement('div', {
                              key: index,
                              className: 'ico-moon icon-star'
                            });
                          })
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-make-comment',
                            onClick: function onClick(e) {
                              _this3.makeComment(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u8BC4\u5206'
                        )
                      ) : item.status == 6 && React.createElement(
                        'div',
                        { className: 'newAppointment-list-bottom grade' },
                        React.createElement(
                          'div',
                          { className: 'graded' },
                          React.createElement(
                            'span',
                            null,
                            '\u6211\u8BC4'
                          ),
                          [1, 2, 3, 4, 5].map(function (score, index) {
                            return React.createElement('div', {
                              key: index,
                              className: 'ico-moon icon-star ' + (score <= item.score ? 'orange' : '')
                            });
                          })
                        ),
                        item.status == 0 && React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              onClick: function onClick(e) {
                                _this3.cancelOrder(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToOrderDetail(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id,
                              'data-type': 'transfer'
                            },
                            '\u652F\u4ED8'
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 8 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-transfer myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap',
                        key: item.order_id || index,
                        'data-id': item.order_id,
                        'data-type': true
                      },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'dialog-block-item border-none' },
                          React.createElement(
                            'span',
                            null,
                            item.add_time
                          ),
                          item.status == 0 && React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5F85\u4ED8\u6B3E'
                          ),
                          item.status == 1 ? React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5DF2\u4ED8\u6B3E'
                          ) : item.status == 7 && React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5DF2\u5173\u95ED'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'paid-card-block' },
                          React.createElement(
                            'div',
                            { className: 'img-block' },
                            React.createElement('img', {
                              className: 'order-img',
                              src: item.goods_info.cover
                            })
                          ),
                          React.createElement(
                            'div',
                            { className: 'block-right' },
                            React.createElement(
                              'div',
                              { className: 'block-right-item' },
                              React.createElement(
                                'div',
                                { className: 'paid-card-name' },
                                item.goods_info.goods_name
                              ),
                              React.createElement(
                                'div',
                                { className: 'paid-card-price' },
                                item.goods_info.price
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'block-right-item' },
                              React.createElement(
                                'div',
                                { className: 'paid-card-combo' },
                                item.goods_info.num > 1 && React.createElement(
                                  'span',
                                  null,
                                  item.goods_info.cNum + '个月组合套餐'
                                )
                              ),
                              React.createElement(
                                'div',
                                { className: 'paid-card-num' },
                                'x' + item.goods_info.num
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'total-calculation' },
                              '\u5408\u8BA1:',
                              React.createElement(
                                'span',
                                { className: 'price' },
                                '¥' + item.total_price
                              )
                            )
                          )
                        ),
                        item.status == 0 && React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              onClick: function onClick(e) {
                                _this3.cancelOrder(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToOrderDetail(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id,
                              'data-type': 'transfer'
                            },
                            '\u652F\u4ED8'
                          )
                        ),
                        item.status != 0 && React.createElement(
                          'div',
                          { className: 'paid-card-bottom' },
                          React.createElement(
                            'div',
                            { className: 'order-id' },
                            '订单号: ' + item.order_id
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 9 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-transfer myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'myOrder-list-wrap',
                        key: item.order_id || index,
                        'data-id': item.order_id,
                        'data-type': true
                      },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'dialog-block-item border-none' },
                          React.createElement(
                            'span',
                            { className: 'dialog-block-time' },
                            item.add_time
                          ),
                          item.status == 0 && React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5F85\u4ED8\u6B3E'
                          ),
                          item.status == 1 && React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5DF2\u4ED8\u6B3E'
                          ),
                          item.status == 7 && React.createElement(
                            'span',
                            { className: 'pull-right myOrder-order-status' },
                            '\u5DF2\u5173\u95ED'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'paid-card-block',
                            onClick: function onClick(e) {
                              _this3.goToOrderDetail(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id,
                            'data-type': 'ExchangeCoupon'
                          },
                          React.createElement(
                            'div',
                            { className: 'img-block' },
                            React.createElement('img', {
                              className: 'order-img',
                              src: item.goods_info.logo
                            })
                          ),
                          React.createElement(
                            'div',
                            { className: 'block-right' },
                            React.createElement(
                              'div',
                              { className: 'block-right-item' },
                              React.createElement(
                                'div',
                                { className: 'paid-card-name' },
                                item.goods_info.goods_name
                              ),
                              React.createElement(
                                'div',
                                { className: 'paid-card-price' },
                                item.goods_info.price
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'block-right-item' },
                              React.createElement(
                                'div',
                                { className: 'paid-card-combo' },
                                item.goods_info.expire && React.createElement(
                                  'span',
                                  null,
                                  item.goods_info.expire
                                )
                              ),
                              React.createElement(
                                'div',
                                { className: 'paid-card-num' },
                                'x1'
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'total-calculation' },
                              '\u5408\u8BA1:',
                              React.createElement(
                                'span',
                                { className: 'price' },
                                '¥' + item.total_price
                              )
                            )
                          )
                        ),
                        item.status == 0 && React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          React.createElement(
                            'span',
                            {
                              className: 'btn myOrder-cancel-order',
                              onClick: function onClick(e) {
                                _this3.cancelOrder(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id
                            },
                            '\u53D6\u6D88\u8BA2\u5355'
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'btn btn-orange myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToOrderDetail(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-id': item.order_id,
                              'data-type': 'transfer'
                            },
                            '\u652F\u4ED8'
                          )
                        ),
                        item.status == 1 && React.createElement(
                          'div',
                          { className: 'myOrder-list-bottom' },
                          item.coupon_type == 6 && item.un_verify_times != 0 && React.createElement(
                            'span',
                            {
                              className: 'btn btn-grey myOrder-pay-directly',
                              onClick: function onClick(e) {
                                _this3.goToUseStamps(e);e.stopPropagation();
                              },
                              'data-franchisee': item.app_id,
                              'data-couponid': item.user_coupon_id,
                              'data-type': 'transfer',
                              'data-untimes': item.un_verify_times
                            },
                            '\u6838\u9500\u7801'
                          )
                        ),
                        item.status != 1 && item.status != 0 && React.createElement(
                          'div',
                          { className: 'paid-card-bottom' },
                          React.createElement(
                            'div',
                            { className: 'order-id' },
                            '订单号: ' + item.order_id
                          )
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              ),
              currentGoodsType == 21 && React.createElement(
                'div',
                { className: 'scrollContainer' },
                React.createElement(
                  _ScrollView.ScrollView,
                  {
                    className: 'myOrder-ebusiness myOrder-content-container',
                    'scroll-y': 'true',
                    lowerThreshold: '10',
                    bindscrolltolower: this.scrollToListBottom
                  },
                  orderLists.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'myOrder-list-wrap', key: item.order_id || index },
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item' },
                        item.is_pay_on_delivery == 1 && React.createElement(
                          'span',
                          { className: 'cash-delivery' },
                          '\u8D27\u5230\u4ED8\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'add-time' },
                          item.add_time
                        ),
                        item.status == 0 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u4ED8\u6B3E'
                        ) : item.status == 1 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u53D1\u8D27'
                        ) : item.status == 2 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u914D\u9001\u4E2D'
                        ) : item.status == 3 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u8BC4\u4EF7'
                        ) : item.status == 4 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          item.is_pay_on_delivery == 1 ? '审核中' : '退款审核中'
                        ) : item.status == 5 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u6B63\u5728\u9000\u6B3E\u4E2D'
                        ) : item.status == 6 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u5B8C\u6210'
                        ) : item.status == 7 ? React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5DF2\u5173\u95ED'
                        ) : item.status == 10 && React.createElement(
                          'span',
                          { className: 'pull-right myOrder-order-status' },
                          '\u5F85\u63D0\u8D27'
                        )
                      ),
                      item.sub_shop_info && item.sub_shop_info.name && React.createElement(
                        'div',
                        { className: 'myOrder-franchisee-name' },
                        item.sub_shop_info.name
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'myOrder-goods-list',
                          onClick: function onClick(e) {
                            _this3.goToOrderDetail(e);e.stopPropagation();
                          },
                          'data-franchisee': item.app_id,
                          'data-id': item.order_id,
                          'data-type': 'communityGroup'
                        },
                        Array.isArray(item.goods_info) && item.goods_info.map(function (goods, index) {
                          return React.createElement(
                            'div',
                            { key: goods.id || index },
                            React.createElement(
                              'div',
                              { className: 'dialog-block-item' },
                              React.createElement('img', {
                                className: 'myOrder-goods-cover',
                                src: goods.cover
                              }),
                              React.createElement(
                                'div',
                                { className: 'myOrder-goods-title' },
                                !!+goods.is_benefit_goods && React.createElement(
                                  'span',
                                  { className: 'goods-gift' },
                                  '\u8D60\u54C1'
                                ),
                                !!+goods.is_vip_goods && React.createElement(
                                  'span',
                                  { className: 'goods-gift' },
                                  '\u4F1A\u5458\u4EF7'
                                ),
                                goods.goods_name
                              ),
                              !goods.is_benefit_goods && React.createElement(
                                'div',
                                { className: 'myOrder-goods-right' },
                                React.createElement(
                                  'div',
                                  null,
                                  goods.price != '0.00' && React.createElement(
                                    'span',
                                    { className: 'myOrder-goods-price' },
                                    '¥' + goods.price
                                  ),
                                  goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                                    'span',
                                    null,
                                    '+'
                                  ),
                                  goods.use_integral && React.createElement(
                                    'span',
                                    null,
                                    goods.use_integral + '积分'
                                  )
                                ),
                                React.createElement(
                                  'div',
                                  null,
                                  '\xD7',
                                  React.createElement(
                                    'span',
                                    { className: 'myOrder-goods-count' },
                                    goods.num
                                  )
                                )
                              )
                            )
                          );
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'dialog-block-item myOrder-total-item' },
                        React.createElement(
                          'span',
                          null,
                          '\u5408\u8BA1\uFF1A',
                          React.createElement(
                            'span',
                            { className: 'myOrder-pay-price' },
                            '¥' + item.original_price
                          )
                        )
                      ),
                      item.status == 0 ? React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-cancel-order',
                            onClick: function onClick(e) {
                              _this3.cancelOrder(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u53D6\u6D88\u8BA2\u5355'
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-pay-directly',
                            onClick: function onClick(e) {
                              _this3.goToOrderDetail(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id,
                            'data-type': 'communityGroup'
                          },
                          '\u652F\u4ED8'
                        )
                      ) : item.status == 1 ? React.createElement('div', { className: 'myOrder-list-bottom' }) : item.status == 2 ? React.createElement('div', { className: 'myOrder-list-bottom' }) : item.status == 3 ? React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-make-comment',
                            onClick: function onClick(e) {
                              _this3.makeComment(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u53BB\u8BC4\u4EF7'
                        )
                      ) : item.status == 10 && React.createElement(
                        'div',
                        { className: 'myOrder-list-bottom' },
                        React.createElement(
                          'span',
                          {
                            className: 'btn myOrder-verification-code',
                            onClick: function onClick(e) {
                              _this3.getWriteOffCodeBox(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u6838\u9500\u7801'
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'btn btn-orange myOrder-sure-receipt',
                            onClick: function onClick(e) {
                              _this3.sureReceipt(e);e.stopPropagation();
                            },
                            'data-franchisee': item.app_id,
                            'data-id': item.order_id
                          },
                          '\u786E\u8BA4\u6536\u8D27'
                        )
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    { hidden: !noMore, className: 'noMoreNewDataTip' },
                    '\u5DF2\u7ECF\u6CA1\u6709\u65B0\u6570\u636E\u4E86'
                  )
                )
              )
            )
          )
        ),
        showWriteOffCodeBox && React.createElement(
          'div',
          {
            className: 'verification-code',
            onClick: this.hideWriteOffCodeBox
          },
          React.createElement(
            'div',
            { className: 'verification-code-tips' },
            '\u5411\u5546\u5BB6\u51FA\u793A\u4E8C\u7EF4\u7801\u6216\u6838\u9500\u7801\u540E\u5373\u53EF\u6D88\u8D39'
          ),
          React.createElement(
            'div',
            { className: 'verification-image-box' },
            React.createElement('img', { className: 'verification-code-img', src: codeImgUrl }),
            codeStatus == 1 && React.createElement(
              'div',
              { className: 'verification-code-finished' },
              React.createElement(
                'div',
                null,
                '\u5DF2\u6838\u9500'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'verification-code-text' },
            React.createElement(
              'span',
              null,
              '\u6838\u9500\u7801\uFF1A'
            ),
            React.createElement(
              'span',
              null,
              codeNum
            )
          )
        ),
        showGoodsPickBox && React.createElement(
          'div',
          {
            className: 'filter-goods-pick-mask',
            onClick: this.hideGoodsPick,
            onTouchMove: this.stopPropagation
          },
          React.createElement(
            'div',
            {
              className: 'filter-goods-pick-box',
              onClick: this.stopPropagation
            },
            React.createElement(
              'div',
              {
                onClick: this.selectGoodsPick,
                'data-type': '0',
                className: selectGoodsPickIndex == '0' ? 'selected' : ''
              },
              '\u5168\u90E8',
              selectGoodsPickIndex == '0' && React.createElement('span', { className: 'pull-right ico-moon icon-gou' })
            ),
            React.createElement(
              'div',
              {
                onClick: this.selectGoodsPick,
                'data-type': '1',
                className: selectGoodsPickIndex == '1' ? 'selected' : ''
              },
              '\u5FEB\u9012',
              selectGoodsPickIndex === '1' && React.createElement('span', { className: 'pull-right ico-moon icon-gou' })
            ),
            React.createElement(
              'div',
              {
                onClick: this.selectGoodsPick,
                'data-type': '2',
                className: selectGoodsPickIndex == '2' ? 'selected' : ''
              },
              '\u540C\u57CE\u914D\u9001',
              selectGoodsPickIndex === '2' && React.createElement('span', { className: 'pull-right ico-moon icon-gou' })
            ),
            React.createElement(
              'div',
              {
                onClick: this.selectGoodsPick,
                'data-type': '3',
                className: selectGoodsPickIndex == '3' ? 'selected' : ''
              },
              '\u4E0A\u95E8\u81EA\u63D0',
              selectGoodsPickIndex === '3' && React.createElement('span', { className: 'pull-right ico-moon icon-gou' })
            ),
            React.createElement(
              'div',
              {
                onClick: this.selectGoodsPick,
                'data-type': '4',
                className: selectGoodsPickIndex == '4' ? 'selected' : ''
              },
              '\u5802\u98DF\u70B9\u9910',
              selectGoodsPickIndex === '4' && React.createElement('span', { className: 'pull-right ico-moon icon-gou' })
            )
          )
        ),
        React.createElement(
          _modal2.default,
          {
            visible: !hiddenmodalput,
            transparent: true,
            title: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
            maskClosable: true,
            platform: '\'ios\'',
            footer: [{
              text: '取消',
              onPress: this.cancel
            }, {
              text: '确认',
              onPress: this.confirm
            }]
          },
          React.createElement('input', {
            type: 'number',
            placeholder: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
            maxLength: '6',
            onChange: this.addLabelInput,
            value: addLabelText,
            style: {
              background: '#F5F5F5',
              height: '.76rem',
              borderRadius: '.10rem',
              padding: '.10rem .10rem',
              boxSizing: 'border-box',
              border: 0
            }
          })
        )
      );
    }
  }]);
  return MyOrder;
}(_OfficialPage3.default);

exports.default = MyOrder;

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(419);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsOrderDetail, _OfficialPage);

  function GoodsOrderDetail(props) {
    (0, _classCallCheck3.default)(this, GoodsOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsOrderDetail.__proto__ || Object.getPrototypeOf(GoodsOrderDetail)).call(this, props));

    _this2.state = {
      orderInfo: {},
      orderStatus: {
        '0': '订单待付款',
        '1': '商家待发货',
        '2': '买家待收货',
        '3': '订单待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '订单已完成',
        '7': '已关闭',
        '8': '卖家待接单',
        '15': '退款失败'
      },
      orderIcon: {
        '0': 'goods-undone-payment',
        '1': 'goods-undone-ship',
        '2': 'goods-undone-receipt',
        '3': 'goods-undone-evaluation',
        '4': 'goods-refund',
        '5': 'goods-refund-doing',
        '6': 'goods-order-complete',
        '7': 'goods-order-close'
      },
      refundStatus: ['退款审核中', '', '', '等待买家退货', '商家待收货', '', '等待第三方退款结果'],
      refundIcon: ['goods-refund-review', '', '', 'goods-refund', 'goods-undone-receipt', '', 'goods-already-refund'],
      refundReason: ['多拍/拍错/不想要', '快递延期', '未按约定时间发货', '快递记录出错', '内容与描述不符', '其它'],
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      orderId: '',
      isFromTemplateMsg: false,
      originalPrice: '',
      useBalance: '',
      freightAdress: {},
      express_fee: '',
      discount_cut_price: '',
      isFromBack: false,
      showWriteOffCodeBox: false,
      showEventDialog: false,
      eventType: '',
      hasAlreadyGoods: false,
      sameCityStatus: {
        101: '配送中-待骑手接单',
        102: '配送中-待骑手取货',
        201: '配送中-待骑手取货',
        202: '配送中-待送达',
        301: '配送中-待送达',
        304: '订单配送失败，物品返回中',
        305: '订单拒收，物品返回中',
        401: '商品返还商户，等待重新配送',
        501: '订单异常',
        502: '订单异常'
      },
      sameCity: false,
      mapOverlay: {
        latitude: 22.52,
        longitude: 113.93,
        markers: []
      },
      storeStyle: {}
    };
    _this2.verifiTimeInterval = '';
    _this2.downcountArr = [];

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.getLogistics();
      _this2.getAppECStoreConfig();
      _this2.setData({
        appName: _app.appMethod.globalData.appTitle,
        appLogo: _app.appMethod.globalData.appLogo
      });
    };

    _this2.getOrderDetail = function (orderId) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0],
              form_data = data.form_data,
              hasAdditionalInfo = false,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              address_id = '';
          var usePickType = form_data.ecommerce_info.dispatch_use_pick_up_type;
          var intraCityStatus = '';
          if (usePickType == 2) {
            intraCityStatus = form_data.ecommerce_info.ecommerce_transport_order && form_data.ecommerce_info.ecommerce_transport_order.status;
          }
          if (form_data.additional_info) {
            for (var i = 0; i < form_data.goods_info.length; i++) {
              var deliveryId = form_data.goods_info[i].delivery_id,
                  goodsId = form_data.goods_info[i].goods_id;
              if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
                additional_info_goods.push(form_data.goods_info[i]);
                additional_goodsid_arr.push(goodsId);
                hasAdditionalInfo = true;
              }
            }
          }
          var remark = form_data.remark;
          form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark;
          for (var _i = 0; _i < form_data.goods_info.length; _i++) {
            if (form_data.goods_info[_i].is_seckill == 1) {
              form_data.goods_info[_i].downCount = {
                hours: '00',
                minutes: '00',
                seconds: '00'
              };
              if (form_data.goods_info[_i].seckill_start_state == 0) {
                form_data.goods_info[_i].downcount = _app.appMethod.beforeSeckillDownCount(form_data.goods_info[_i], that, 'orderInfo.goods_info[' + _i + ']');
              } else if (form_data.goods_info[_i].seckill_start_state == 1) {
                form_data.goods_info[_i].downcount = _app.appMethod.duringSeckillDownCount(form_data.goods_info[_i], that, 'orderInfo.goods_info[' + _i + ']');
              }
              form_data.goods_info[_i] && that.downcountArr.push(form_data.goods_info[_i].downcount);
            }
          }
          if (form_data.refunded_price) {
            that.setData({
              hasAlreadyGoods: true
            });
          }
          if (form_data.pick_up_type == 2) {
            var sytime = void 0;
            var nowTime = new Date().getTime();
            var addTime = form_data.add_time.replace(/\-/g, '/');
            var time = 15 * 60000 - (nowTime - new Date(addTime + '').getTime());
            if (time <= 0) {
              sytime = '0';
            } else {
              sytime = parseInt(time % (1000 * 60 * 60) / (60 * 1000));
            }
            form_data.cacelOrderCountDownTime = sytime;
          }
          if (form_data.wx_local_express_order) {
            var sameCity = true;
            var showMap = true;
            var orderStatus = form_data.status;
            if ([3, 4, 5, 6, 7].find(function (item) {
              return item == orderStatus;
            })) {
              showMap = false;
            }
            that.initMapInfo(form_data, sameCity, showMap);
          }
          that.setData({
            orderInfo: form_data,
            vip_cut_price: form_data.vip_cut_price,
            is_vip_goods: form_data.goods_info[0].is_vip_goods,
            hasAdditionalInfo: hasAdditionalInfo,
            discount_cut_price: form_data.discount_cut_price,
            useBalance: form_data['use_balance'],
            express_fee: res.data[0]['express_fee'],
            box_fee: form_data['box_fee'] || 0,
            intraCityStatus: intraCityStatus || '',
            usePickType: usePickType
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          _app.appMethod.setGoodsAdditionalInfo(form_data.additional_info || {});
          that.getRefundConfigByPickUpType(form_data.pick_up_type);
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/HideOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success(res) {
          _app.appMethod.turnBack();
        },
        complete: function complete() {
          _this.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cancelOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = 7;
          that.setData(data);
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderId = _this2.data.orderInfo.order_id;
      if (_this2.data.orderInfo.total_price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            setTimeout(function () {
              _app.appMethod.showToast({
                title: '支付成功',
                icon: 'success',
                success: function success() {
                  that.paySuccessCallback();
                }
              });
            });
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId;
      //     param.goodsType = that.data.orderInfo.goods_type
      //     param.success = function () {
      //       that.paySuccessCallback()
      //     }
      //     app.wxPay(param)
      //   }
      // })
      var franchiseeId = that.franchiseeId;
      var pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');

      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: pagePath
      });
    };

    _this2.applyDrawback = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/previewGoodsRefund/previewGoodsRefund?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.editorRefund = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = 7;
          that.setData(data);
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderId;
      var ecommerce_info = _this2.data.orderInfo.ecommerce_info;
      var sameCity = _this2.data.sameCity ? 1 : 0;
      var usePickType = _this2.data.usePickType;
      if (usePickType == 2) {
        var intraCityData = ecommerce_info.intra_city_data;
        var type = intraCityData && intraCityData.deliver_type || '';
        var arriveTime = intraCityData && intraCityData.intra_city_appointment_arrive_time || '';
        _app.appMethod.turnToPage('/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' + orderId + '&type=' + type + '&arriveTime=' + arriveTime + '&franchiseeId=' + _this2.franchiseeId + '&sameCity=' + sameCity);
      } else {
        _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId + '&franchiseeId=' + _this2.franchiseeId);
      }
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderId,
          that = _this2,
          addTime = Date.now();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          _app.appMethod.turnToPage('/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' + orderId + '&franchiseeId=' + that.franchiseeId);
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.franchiseeId,
          pagePath = '/eCommerce/pages/makeComment/makeComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.getFreigtAdress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        data: {
          app_id: _app.appMethod.getAppId(),
          sub_app_id: that.franchiseeId
        },
        success: function success(res) {
          that.setData({
            freightAdress: res.data
          });
        }
      });
    };

    _this2.seeAdditionalInfo = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail');
    };

    _this2.paySuccessCallback = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      if (!franchiseeId) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: franchiseeId
          },
          success: function success(res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1';
            }
            _app.appMethod.turnToPage(pagePath, 1);
          }
        });
      } else {
        _app.appMethod.turnToPage(pagePath, 1);
      }
    };

    _this2.copyOrderId = function () {
      var _this = _this2;
      _app.appMethod.setClipboardData({
        data: _this.data.orderId,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.getWriteOffCodeBox = function () {
      var _this = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetOrderVerifyCode',
        data: {
          sub_shop_app_id: franchiseeId,
          order_id: orderId
        },
        success: _this.setVerificationCodeData
      });
    };

    _this2.setVerificationCodeData = function (res) {
      var _this = _this2;
      _this.setData({
        codeImgUrl: res.data.qrcode_url,
        codeNum: res.data.code,
        codeStatus: res.data.status,
        showWriteOffCodeBox: true
      });
      _this.connectSocket();
    };

    _this2.connectSocket = function () {
      var _this = _this2;
      _app.appMethod.connectSocket({
        url: 'wss://xcx.zhichiwangluo.com', //testonly
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        _this.verifiTimeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_order_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_order_verify' && msg.status == 0) {
            _this.setData({
              codeStatus: 1
            });
            clearInterval(_this.verifiTimeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
    };

    _this2.hideWriteOffCodeBox = function () {
      var _this = _this2;
      _this2.setData({
        showWriteOffCodeBox: false
      });
      clearInterval(_this.verifiTimeInterval);
      _app.appMethod.closeSocket();
    };

    _this2.hideEventDialog = function () {
      _this2.setData({
        showEventDialog: false
      });
    };

    _this2.showEventDialog = function (event) {
      _this2.setData({
        eventType: event.currentTarget.dataset.type,
        showEventDialog: true
      });
    };

    _this2.goOrderProgress = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.returnInfor = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.cancelRefund = function () {
      var _this = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/cancelRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success() {
          _this.getOrderDetail(orderId);
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.deliveryDrawback = function () {
      var _this = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/applyRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success(res) {
          _this.getOrderDetail(orderId);
        },
        complete: function complete() {
          _this.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.goAlreadyGoodsPage = function () {
      var that = _this2;
      /**
       * WEBAPP: 与【已退商品】页面交互 start
       */
      var currentPage = _app.appMethod.getCurrentPage();
      currentPage.data = {
        orderInfo: {
          goods_info: that.data.orderInfo.goods_info,
          refunded_price: that.data.orderInfo.refunded_price
        }
        /**
         * WEBAPP: 与【已退商品】页面交互 end
         */
      };var pagePath = '/eCommerce/pages/goodsAlreadyRefunded/goodsAlreadyRefunded';
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.getLogistics = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/expressFlow',
        data: {
          order_id: _this.data.orderId
        },
        success: function success(res) {
          var info = res.data;
          if (!info) {
            return;
          }
          if (info.is_custom) {
            _this.setData({
              logisticsCustom: info.is_custom
            });
          } else {
            var logistics = info.Traces;
            if (info.waybill_id) {
              info.path_item_list.map(function (item) {
                item.AcceptTime = item.action_time;
                item.AcceptStation = item.action_msg;
              });
              logistics = info.path_item_list;
            }
            _this.setData({
              logistics: logistics
            });
          }
        }
      });
    };

    _this2.toGoodsAfterSaleDetail = function (event) {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var applyId = _this2.data.orderInfo.refund_apply.id;
      var router = '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' + applyId + '&detail=' + orderId + '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage(router);
    };

    _this2.goDeliveryNavigation = function () {
      _app.appMethod.openLocation({
        latitude: Number(_this2.data.orderInfo.self_delivery_info.latitude),
        longitude: Number(_this2.data.orderInfo.self_delivery_info.longitude),
        name: _this2.data.orderInfo.self_delivery_info.address
      });
    };

    _this2.sameJournyLogistic = function () {
      var orderId = _this2.data.orderId;
      _app.appMethod.turnToPage('/eCommerce/pages/sameJournyLogistic/sameJournyLogistic?detail=' + orderId);
    };

    _this2.getRefundConfigByPickUpType = function (type) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
        data: {
          pick_up_type: type,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          if (res.data && res.data.config_data) {
            var data = res.data.config_data;
            _this.setData({
              refundAdress: data.address || '',
              isFullRefund: data.is_full_refund
            });
          }
        }
      });
    };

    _this2.initMapInfo = function (form_data, sameCity, showMap) {
      var sameCityInfo = form_data.wx_local_express_order;
      var markers = [];
      var senderItem = {
        id: 0,
        latitude: sameCityInfo['sender']['lat'],
        longitude: sameCityInfo['sender']['lng'],
        iconPath: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
        width: 47,
        height: 51
      };
      var ridersItem = {
        id: 1,
        latitude: sameCityInfo['agent'] ? +sameCityInfo['agent']['lat'] : 22.52,
        longitude: sameCityInfo['agent'] ? +sameCityInfo['agent']['lng'] : 113.93,
        iconPath: 'http://develop.zhichiwangluo.com/zhichi_frontend/static/jisuapp_editor/images/rider.png',
        width: 38,
        height: 45
      };
      var receiverItem = {
        id: 2,
        latitude: sameCityInfo['receiver']['lat'],
        longitude: sameCityInfo['receiver']['lng'],
        iconPath: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
        width: 47,
        height: 51
      };
      markers = [senderItem, ridersItem, receiverItem];
      markers = _this2.transPosition(markers, sameCityInfo.order_status);
      _this2.setData({
        'mapOverlay.markers': markers,
        sameCityInfo: sameCityInfo,
        sameCity: sameCity,
        showMap: showMap
      });
    };

    _this2.transStatus = function (status) {
      switch (+status) {
        case 101:
          return '待骑手接单';
        case 102:
          return '骑手赶往商家';
        case 103:
        case 203:
        case 303:
          return '商家取消订单';
        case 201:
        case 202:
          return '骑手取货中';
        case 204:
        case 205:
          return '骑手取消订单';
        case 301:
          return '骑手配送中';
        case 302:
          return '订单已完成';
        case 304:
        case 305:
          return '配送失败';
        case 401:
        case 501:
        case 502:
          return '订单结束，等待重新配送';
      }
    };

    _this2.transPosition = function (mapOverlay, status) {
      var transStatus = _this2.transStatus(status);
      var obj = {
        callout: {
          content: transStatus,
          bgColor: '#ffffff',
          display: 'ALWAYS',
          padding: 4,
          borderRadius: 5
        }
      };
      switch (transStatus) {
        case '待骑手接单':
        case '商家取消订单':
        case '订单已完成':
        case '订单结束，等待重新配送':
          Object.assign(mapOverlay[0], obj);
          mapOverlay.splice(1, 1);
          _this2.setData({
            'mapOverlay.latitude': mapOverlay[0]['latitude'] + 0.0005,
            'mapOverlay.longitude': mapOverlay[0]['longitude']
          });
          break;
        case '骑手赶往商家':
        case '骑手取货中':
        case '骑手取消订单':
        case '骑手配送中':
        case '配送失败':
          Object.assign(mapOverlay[1], obj);
          _this2.setData({
            'mapOverlay.latitude': mapOverlay[1]['latitude'] + 0.0005,
            'mapOverlay.longitude': mapOverlay[1]['longitude']
          });
          break;
      }
      return mapOverlay;
    };

    _this2.callRider = function () {
      var phone = _this2.data.sameCityInfo.agent.phone[0];
      _app.appMethod.makePhoneCall(phone);
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(GoodsOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        sessionFrom: options.franchisee || _app.appMethod.getAppId() || ''
      });
      this.franchiseeId = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcountArr && this.downcountArr.length) {
        this.downcountArr = this.downcountArr.concat().reverse();
        for (var i = 0; i < this.downcountArr.length; i++) {
          this.downcountArr[i] && this.downcountArr[i].clear();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          storeStyle = _state.storeStyle,
          orderIcon = _state.orderIcon,
          orderInfo = _state.orderInfo,
          sameCity = _state.sameCity,
          sameCityStatus = _state.sameCityStatus,
          sameCityInfo = _state.sameCityInfo,
          orderStatus = _state.orderStatus,
          refundIcon = _state.refundIcon,
          refundStatus = _state.refundStatus,
          refundAdress = _state.refundAdress,
          logistics = _state.logistics,
          logisticsCustom = _state.logisticsCustom,
          usePickType = _state.usePickType,
          mapOverlay = _state.mapOverlay,
          showMap = _state.showMap,
          appLogo = _state.appLogo,
          appName = _state.appName,
          sessionFrom = _state.sessionFrom,
          discount_cut_price = _state.discount_cut_price,
          box_fee = _state.box_fee,
          express_fee = _state.express_fee,
          useBalance = _state.useBalance,
          hasAdditionalInfo = _state.hasAdditionalInfo,
          hasAlreadyGoods = _state.hasAlreadyGoods,
          intraCityStatus = _state.intraCityStatus,
          isFullRefund = _state.isFullRefund,
          codeImgUrl = _state.codeImgUrl,
          codeStatus = _state.codeStatus,
          codeNum = _state.codeNum,
          showWriteOffCodeBox = _state.showWriteOffCodeBox,
          eventType = _state.eventType,
          showEventDialog = _state.showEventDialog;


      return React.createElement(
        'div',
        { className: 'official-page goods-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          'div',
          { className: 'order-contain' },
          isFromTemplateMsg && React.createElement(
            'div',
            {
              className: 'orderDetail-goto-homepage',
              onClick: this.goToHomepage
            },
            '\u8FD4\u56DE\u9996\u9875'
          ),
          React.createElement(
            'div',
            {
              className: 'seller-shipped',
              style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
            },
            orderInfo.status != 4 ? React.createElement(
              'div',
              null,
              React.createElement('span', {
                className: 'order-icon ico-moon icon-' + orderIcon[orderInfo.status]
              }),
              React.createElement(
                'span',
                null,
                orderInfo.pick_up_type != 1 && orderInfo.status == 8 ? '商家待接单' : orderInfo.status == 2 && sameCity ? sameCityStatus[sameCityInfo.order_status] : orderStatus[orderInfo.status]
              )
            ) : React.createElement(
              'div',
              null,
              React.createElement('span', {
                className: 'order-icon ico-moon icon-' + refundIcon[orderInfo.refund_apply.status]
              }),
              React.createElement(
                'span',
                null,
                orderInfo.is_pay_on_delivery == 1 ? '审核中' : refundStatus[orderInfo.refund_apply.status]
              )
            )
          ),
          orderInfo.status == 0 && orderInfo.expire && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u8BF7\u5728\u5C3D\u5FEB\u5B8C\u6210\u4ED8\u6B3E\uFF0C\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.has_seckill == 1 ? orderInfo.close_order_time + '分' : orderInfo.expire
            ),
            '\uFF08\u8D85\u65F6\u6309',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              '\u53D6\u6D88\u8BA2\u5355'
            ),
            '\u5904\u7406\uFF09'
          ),
          orderInfo.status == 1 && orderInfo.expire && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u4ED8\u6B3E\u6210\u529F\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u53D1\u8D27'
          ),
          orderInfo.status == 2 && !sameCity && orderInfo.pick_up_type != 2 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u5546\u5BB6\u5DF2\u53D1\u8D27\uFF0C\u8DDD\u81EA\u52A8\u6536\u8D27\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.expire
            )
          ),
          orderInfo.status == 4 && orderInfo.refund_apply.status == 0 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u4F60\u5DF2\u6210\u529F\u53D1\u8D77\u9000\u6B3E\u7533\u8BF7\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u5904\u7406\uFF0C\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.refund_apply.expire
            ),
            '\uFF08\u8D85\u65F6\u6309',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.is_pay_on_delivery == 1 ? '拒绝取消订单' : '拒绝退款'
            ),
            '\u5904\u7406\uFF09'
          ),
          orderInfo.status == 4 && orderInfo.refund_apply.status == 3 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u5546\u5BB6\u5DF2\u540C\u610F\u9000\u8D27\u9000\u6B3E\u7533\u8BF7\uFF0C\u8BF7\u53CA\u65F6\u9000\u8D27\uFF0C\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.refund_apply.expire
            ),
            '\uFF08\u8D85\u65F6\u6309',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              '\u4E70\u5BB6\u64A4\u9500\u9000\u8D27'
            ),
            '\u5904\u7406\uFF09'
          ),
          orderInfo.status == 4 && orderInfo.refund_apply.status == 4 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u6536\u8D27\uFF0C\u6536\u8D27\u5B8C\u6210\u540E\u5C06\u4F1A\u8FDB\u884C\u9000\u6B3E'
          ),
          orderInfo.pick_up_type == 2 && orderInfo.status == 8 && React.createElement(
            'div',
            { className: 'order-prompt' },
            orderInfo.cacelOrderCountDownTime + '分钟未接单，订单将自动取消'
          ),
          orderInfo.pick_up_type == 2 && (orderInfo.status == 1 || orderInfo.status == 2) && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u9884\u8BA1\u9001\u8FBE\u65F6\u95F4\uFF1A',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              orderInfo.ecommerce_info.intra_city_data.intra_city_appointment_arrive_time
            )
          ),
          orderInfo.status == 4 && orderInfo.refund_apply.refund_type == 2 && orderInfo.is_pay_on_delivery != 1 && React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'refund-address-box' },
              React.createElement(
                'div',
                { className: 'refund-address-title' },
                React.createElement(
                  'span',
                  null,
                  '\u9000\u8D27\u5730\u5740'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  refundAdress.brand_name + ' ' + refundAdress.phone
                )
              ),
              React.createElement(
                'div',
                { className: 'pull-right refund-address' },
                refundAdress.region_info[2].name + refundAdress.region_info[1].name + refundAdress.region_info[0].name + refundAdress.detail_address
              )
            )
          ),
          (orderInfo.status == 2 || orderInfo.status == 3 || orderInfo.status == 5) && usePickType == 1 && React.createElement(
            'div',
            { onClick: this.checkLogistics },
            React.createElement(
              'div',
              { className: 'goods-logistics' },
              React.createElement('span', { className: 'ico-moon icon-goods-logistics' }),
              logistics && logistics.length ? React.createElement(
                'div',
                { className: 'goods-logistics-info' },
                React.createElement(
                  'div',
                  {
                    className: 'goods-logistics-title',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  logistics[0].AcceptStation
                ),
                React.createElement(
                  'div',
                  { className: 'goods-logistics-time' },
                  logistics[0].AcceptTime
                )
              ) : React.createElement(
                'div',
                { className: 'goods-logistics-info' },
                logisticsCustom == 1 ? '商家自主发货' : '暂无物流信息'
              ),
              React.createElement('span', {
                style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align: middle;'),
                className: 'colord2d2 ico-moon icon-rightarrow'
              })
            )
          ),
          orderInfo.status != 4 && React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'buyer-information self-delivery-info' },
              React.createElement('span', { className: 'ico-moon icon-goods-location' }),
              orderInfo.pick_up_type == 1 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'buyer-box' },
                  React.createElement(
                    'div',
                    { className: 'buyer-name-box' },
                    React.createElement(
                      'span',
                      {
                        className: 'cash-delivery shipping-type',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u5FEB\u9012'
                    ),
                    orderInfo.is_pay_on_delivery == 1 && React.createElement(
                      'span',
                      {
                        className: 'cash-delivery',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u5230\u4ED8'
                    ),
                    React.createElement(
                      'span',
                      { className: 'buyer-name' },
                      orderInfo.address_info.name
                    ),
                    React.createElement(
                      'span',
                      null,
                      orderInfo.address_info.contact
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'buyer-address' },
                    orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                  )
                )
              ),
              orderInfo.pick_up_type == 2 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'buyer-box' },
                  React.createElement(
                    'div',
                    { className: 'buyer-name-box' },
                    React.createElement(
                      'span',
                      {
                        className: 'cash-delivery shipping-type',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u540C\u57CE'
                    ),
                    orderInfo.is_pay_on_delivery == 1 && React.createElement(
                      'span',
                      {
                        className: 'cash-delivery',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u5230\u4ED8'
                    ),
                    React.createElement(
                      'span',
                      { className: 'buyer-name' },
                      orderInfo.address_info.name
                    ),
                    React.createElement(
                      'span',
                      null,
                      orderInfo.address_info.contact
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'buyer-address' },
                    orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                  )
                )
              ) : orderInfo.pick_up_type == 3 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'buyer-box' },
                  React.createElement(
                    'div',
                    { className: 'buyer-name-box' },
                    React.createElement(
                      'span',
                      {
                        className: 'cash-delivery shipping-type',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u81EA\u63D0'
                    ),
                    orderInfo.is_pay_on_delivery == 1 && React.createElement(
                      'span',
                      {
                        className: 'cash-delivery',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                      },
                      '\u5230\u4ED8'
                    ),
                    React.createElement(
                      'span',
                      { className: 'buyer-name' },
                      orderInfo.self_delivery_info.contact_name
                    ),
                    React.createElement(
                      'span',
                      null,
                      orderInfo.self_delivery_info.contact_phone
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'buyer-address' },
                    orderInfo.self_delivery_info.address
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'delivery-navigation',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    onClick: this.goDeliveryNavigation
                  },
                  '\u5BFC\u822A'
                )
              )
            )
          ),
          sameCity && showMap && React.createElement(
            'div',
            { className: 'same-city-map' },
            React.createElement(Map, {
              latitude: mapOverlay.latitude,
              longitude: mapOverlay.longitude,
              markers: mapOverlay.markers,
              enableRotate: true,
              scale: '17'
            }),
            sameCityInfo.agent.phone && React.createElement(
              'div',
              { className: 'rider-box' },
              React.createElement(
                'div',
                null,
                React.createElement('img', {
                  className: 'rider-logo',
                  src: 'http://develop.zhichiwangluo.com/zhichi_frontend/static/jisuapp_editor/images/rider-ico.png'
                }),
                React.createElement(
                  'span',
                  { className: 'rider-name' },
                  sameCityInfo.agent.name
                )
              ),
              React.createElement(
                'div',
                { className: 'rider-contact', onClick: this.callRider },
                React.createElement(
                  'span',
                  null,
                  '\u8054\u7CFB\u9A91\u624B'
                ),
                React.createElement(
                  'div',
                  { className: 'phone-box' },
                  React.createElement('span', { className: 'ico-moon icon-takeout-cellphone-left' })
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'app-box' },
            React.createElement(
              'div',
              null,
              React.createElement('img', { className: 'app-logo', src: appLogo }),
              React.createElement(
                'span',
                { className: 'app-name' },
                appName
              ),
              React.createElement(
                'div',
                { className: 'contact-service pull-right' },
                React.createElement(
                  'span',
                  null,
                  '\u8054\u7CFB\u5BA2\u670D'
                ),
                React.createElement('span', { className: 'ico-moon icon-goods-customer-service' }),
                React.createElement('button', null)
              )
            )
          ),
          orderInfo && orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
            return React.createElement(
              React.Fragment,
              { key: goodsIndex },
              goods.is_seckill == 1 && React.createElement(
                'div',
                { className: 'seckill-time' },
                React.createElement(
                  'div',
                  {
                    className: 'countdown',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  goods.seckill_start_state == 0 ? React.createElement(
                    'label',
                    null,
                    '\u8DDD\u5F00\u59CB'
                  ) : goods.seckill_start_state == 1 ? React.createElement(
                    'label',
                    null,
                    '\u8DDD\u7ED3\u675F\u8FD8\u5269'
                  ) : goods.seckill_start_state == 2 && React.createElement(
                    'label',
                    null,
                    '\u5DF2\u7ED3\u675F'
                  ),
                  !!goods.downCount.days && React.createElement(
                    'span',
                    { className: 'days' },
                    goods.downCount.days + '天'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'hours countdown-text',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                    },
                    goods.downCount.hours
                  ),
                  ':',
                  React.createElement(
                    'span',
                    {
                      className: 'minutes countdown-text',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                    },
                    goods.downCount.minutes
                  ),
                  ':',
                  React.createElement(
                    'span',
                    {
                      className: 'seconds countdown-text',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                    },
                    goods.downCount.seconds
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'goods-detail-box' },
                React.createElement('img', { src: goods.cover }),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'goods-name' },
                    orderInfo.is_group_buy_order != 0 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u62FC\u56E2'
                    ),
                    goods.is_presell == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u9884\u552E'
                    ),
                    goods.is_seckill == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u79D2\u6740'
                    ),
                    goods.is_vip_goods == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    goods.is_benefit_goods == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u8D60\u54C1'
                    ),
                    goods.goods_name
                  ),
                  goods.model_value && React.createElement(
                    'div',
                    { className: 'goods-rules' },
                    goods.model_value
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-price' },
                    !goods.use_integral || goods.use_integral == 0 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        {
                          className: 'colorff7',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '¥' + goods.price
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      goods.price != '0.00' && React.createElement(
                        'span',
                        {
                          className: 'colorff7',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '¥' + goods.price
                      ),
                      goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && goods.price != '0.00' && React.createElement(
                        'span',
                        {
                          className: 'colorff7',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '+'
                      ),
                      goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'colorff7',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        goods.max_can_use_integral + '积分'
                      )
                    ),
                    React.createElement(
                      'span',
                      { className: 'pull-right' },
                      'x ' + goods.num
                    )
                  )
                )
              )
            );
          }),
          orderInfo.status == 4 && orderInfo.refund_apply.id && React.createElement(
            'div',
            { className: 'refunding-btn-box' },
            React.createElement(
              'span',
              {
                className: 'refunding-btn',
                onClick: this.toGoodsAfterSaleDetail
              },
              '\u9000\u6B3E\u4E2D'
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-amount' },
            React.createElement(
              'span',
              null,
              '\u5546\u54C1\u91D1\u989D'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '¥' + (orderInfo.is_vip_order == 1 ? orderInfo.total_original_price : orderInfo.original_price)
            )
          ),
          orderInfo.has_seckill == 1 && React.createElement(
            'div',
            { className: 'spike-offer' },
            React.createElement(
              'span',
              null,
              '\u6D3B\u52A8\u4F18\u60E0'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '秒杀  - ¥' + orderInfo.seckill_cut_price
            )
          ),
          orderInfo.selected_benefit_info && React.createElement(
            'div',
            { className: 'promotion-method' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u4F18\u60E0\u65B9\u5F0F'
              ),
              React.createElement(
                'span',
                { className: 'pull-right promotion-method-title color999' },
                orderInfo.selected_benefit_info.title || '无'
              )
            ),
            React.createElement(
              'div',
              { className: 'pull-right color999' },
              '- ¥' + discount_cut_price
            )
          ),
          orderInfo && orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.title && React.createElement(
            'div',
            { className: 'promotion-method' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8054\u76DF\u4F18\u60E0'
              ),
              React.createElement(
                'span',
                { className: 'pull-right promotion-method-title color999' },
                orderInfo.extra_selected_benefit_info.title || '无'
              )
            ),
            React.createElement(
              'div',
              { className: 'pull-right color999' },
              '- ¥' + orderInfo.extra_discount_cut_price
            )
          ),
          orderInfo.is_vip_order == 1 && orderInfo.vip_cut_price != '0.00' && React.createElement(
            'div',
            { className: 'promotion-method' },
            React.createElement(
              'span',
              null,
              '\u4F1A\u5458\u4EF7\u4F18\u60E0'
            ),
            React.createElement(
              'span',
              { className: 'pull-right promotion-method-title color999' },
              '- ¥' + orderInfo.vip_cut_price
            )
          ),
          box_fee > 0 && (usePickType == 2 || usePickType == 4) && React.createElement(
            'div',
            { className: 'freight box-fee' },
            React.createElement(
              'span',
              null,
              '\u5305\u88C5\u8D39'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '￥ ' + box_fee
            )
          ),
          React.createElement(
            'div',
            { className: 'freight' },
            React.createElement(
              'span',
              null,
              orderInfo.pick_up_type == 2 ? '配送费' : '运费'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '¥' + express_fee
            )
          ),
          React.createElement(
            'div',
            { className: 'total-order-price' },
            React.createElement(
              'span',
              null,
              '\u8BA2\u5355\u603B\u4EF7'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '¥' + orderInfo.order_total_price
            )
          ),
          useBalance > 0 && React.createElement(
            'div',
            { className: 'stored-value-deduction' },
            React.createElement(
              'span',
              null,
              '\u50A8\u503C\u62B5\u6263'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '- ¥' + useBalance
            )
          ),
          orderInfo.coupon_fee && React.createElement(
            'div',
            null,
            '\u793E\u4EA4\u7ACB\u51CF\u91D1',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '- ¥' + orderInfo.coupon_fee
            )
          ),
          React.createElement(
            'div',
            { className: 'actual-payment' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u5B9E\u9645\u4ED8\u6B3E'
              ),
              React.createElement(
                'span',
                {
                  className: 'pull-right colorff7',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '¥' + orderInfo.total_price
              )
            )
          ),
          orderInfo.remark && React.createElement(
            'div',
            { className: 'buyer-message' },
            React.createElement(
              'span',
              null,
              '\u4E70\u5BB6\u7559\u8A00'
            ),
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo.remark
            )
          ),
          hasAdditionalInfo && React.createElement(
            'div',
            { className: 'addition-info', onClick: this.seeAdditionalInfo },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8865\u5145\u4FE1\u606F'
              ),
              React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
            )
          ),
          React.createElement(
            'div',
            {
              className: 'addition-info no-border',
              onClick: this.goOrderProgress
            },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8BA2\u5355\u8FDB\u5EA6'
              ),
              React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
            )
          ),
          hasAlreadyGoods && React.createElement(
            'div',
            {
              className: 'addition-info no-border already-refund-goods',
              onClick: this.goAlreadyGoodsPage
            },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u5DF2\u9000\u5546\u54C1'
              ),
              React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
            )
          ),
          React.createElement(
            'div',
            { className: 'order-number' },
            orderInfo.pick_up_type == 3 ? React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('margin-right:54rpx;') },
                '\u6D41\u6C34\u53F7'
              ),
              React.createElement(
                'span',
                null,
                orderInfo.ecommerce_info.ec_tostore_data.formatted_queue_num
              )
            ) : orderInfo.pick_up_type == 2 && React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('margin-right:80rpx;') },
                '\u7F16\u53F7'
              ),
              React.createElement(
                'span',
                null,
                orderInfo.ecommerce_info.intra_city_data.serial_number
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8BA2\u5355\u7F16\u53F7'
              ),
              React.createElement(
                'span',
                null,
                orderInfo.order_id
              ),
              React.createElement(
                'span',
                { className: 'pull-right', onClick: this.copyOrderId },
                '\u590D\u5236'
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u4E0B\u5355\u65F6\u95F4'
              ),
              React.createElement(
                'span',
                null,
                orderInfo.add_time
              )
            ),
            orderInfo.pick_up_type == 2 && React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u9884\u5B9A\u65F6\u95F4'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.ecommerce_info.intra_city_data.intra_city_appointment_arrive_time
                )
              ),
              orderInfo.wx_local_express_order && orderInfo.wx_local_express_order.add_resp.pickup_code && React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('display:inline-block;width:96rpx') },
                  '\u53D6\u8D27\u7801'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.wx_local_express_order.add_resp.pickup_code
                )
              )
            ),
            orderInfo.pick_up_type == 3 && React.createElement(
              React.Fragment,
              null,
              orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_appointment_time && React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u9884\u7EA6\u65F6\u95F4'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_appointment_time
                )
              ),
              orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_location_name && React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u5E97\u5185\u4F4D\u7F6E'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_location_name
                )
              ),
              orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_buyer_phone && React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u624B\u673A\u53F7\u7801'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_buyer_phone
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'order-bottom' },
            orderInfo.status == 0 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'cancelOrder'
                },
                '\u53D6\u6D88\u8BA2\u5355'
              ),
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange orderDetail-pay-directly',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.payOrder
                },
                '\u7ACB\u5373\u652F\u4ED8'
              )
            ),
            orderInfo.status == 1 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.getWriteOffCodeBox
                },
                '\u6838\u9500\u7801'
              ),
              intraCityStatus > 1 && intraCityStatus != 5 && intraCityStatus != 1000 && React.createElement(
                'span',
                { className: 'btn', onClick: this.checkLogistics },
                '\u914D\u9001\u4FE1\u606F'
              ),
              orderInfo.is_pay_on_delivery == 1 ? React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'deliveryDrawback'
                },
                '\u53D6\u6D88\u8BA2\u5355'
              ) : (orderInfo.is_group_buy_order != 0 && orderInfo.can_refund_order == 1 || orderInfo.is_group_buy_order == 0) && isFullRefund == 1 && React.createElement(
                'span',
                { className: 'apply-refund', onClick: this.applyDrawback },
                '\u7533\u8BF7\u9000\u6B3E'
              )
            ),
            orderInfo.status == 2 && React.createElement(
              React.Fragment,
              null,
              orderInfo.pick_up_type != 3 && React.createElement(
                'span',
                { className: 'btn', onClick: this.checkLogistics },
                '\u914D\u9001\u4FE1\u606F'
              ),
              orderInfo.is_pay_on_delivery == 1 ? React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'deliveryDrawback'
                },
                '\u53D6\u6D88\u8BA2\u5355'
              ) : (orderInfo.is_group_buy_order != 0 && orderInfo.can_refund_order == 1 || orderInfo.is_group_buy_order == 0) && isFullRefund == 1 && React.createElement(
                'span',
                { className: 'apply-refund', onClick: this.applyDrawback },
                '\u7533\u8BF7\u9000\u6B3E'
              ),
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.getWriteOffCodeBox
                },
                '\u6838\u9500\u7801'
              ),
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.showEventDialog,
                  'data-type': 'sureReceipt'
                },
                '\u786E\u8BA4\u6536\u8D27'
              )
            ),
            orderInfo.status == 3 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u8BA2\u5355'
              ),
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.getWriteOffCodeBox
                },
                '\u6838\u9500\u7801'
              ),
              React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.makeComment
                },
                '\u53BB\u8BC4\u4EF7'
              )
            ),
            orderInfo.status == 4 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                { className: 'btn', onClick: this.cancelRefund },
                orderInfo.refund_apply.status == 3 || orderInfo.refund_apply.status == 4 ? '撤销退货' : '撤销申请'
              ),
              orderInfo.is_pay_on_delivery != 1 && React.createElement(
                'span',
                { className: 'btn', onClick: this.editorRefund },
                '\u4FEE\u6539\u7533\u8BF7'
              ),
              orderInfo.refund_apply.status == 3 && React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.returnInfor
                },
                '\u586B\u5199\u9000\u8D27\u4FE1\u606F'
              )
            ),
            orderInfo.status == 5 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn',
                  onClick: this.showEventDialog,
                  'data-type': 'receiveDrawback'
                },
                '\u6536\u5230\u9000\u6B3E'
              )
            ),
            orderInfo.status == 6 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u8BA2\u5355'
              )
            ),
            orderInfo.status == 7 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u8BA2\u5355'
              )
            ),
            orderInfo.status == 8 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'cancelOrder'
                },
                '\u53D6\u6D88\u8BA2\u5355'
              )
            )
          )
        ),
        showWriteOffCodeBox && React.createElement(
          'div',
          {
            className: 'verification-code',
            onClick: this.hideWriteOffCodeBox
          },
          React.createElement(
            'div',
            { className: 'verification-code-tips' },
            '\u5411\u5546\u5BB6\u51FA\u793A\u4E8C\u7EF4\u7801\u6216\u6838\u9500\u7801\u540E\u5373\u53EF\u6D88\u8D39'
          ),
          React.createElement(
            'div',
            { className: 'verification-image-box' },
            React.createElement('img', { className: 'verification-code-img', src: codeImgUrl }),
            codeStatus == 1 && React.createElement(
              'div',
              { className: 'verification-code-finished' },
              React.createElement(
                'div',
                null,
                '\u5DF2\u6838\u9500'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'verification-code-text' },
            React.createElement(
              'span',
              null,
              '\u6838\u9500\u7801\uFF1A'
            ),
            React.createElement(
              'span',
              null,
              codeNum
            )
          )
        ),
        showEventDialog && React.createElement(
          'div',
          { className: 'event-dialog-mask' },
          React.createElement(
            'div',
            { className: 'event-dialog' },
            eventType == 'cancelOrder' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u786E\u8BA4\u53D6\u6D88\u8BA2\u5355\uFF1F'
            ),
            eventType == 'orderDelete' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u8BA2\u5355\u5220\u9664\u540E\u4E0D\u53EF\u627E\u56DE\uFF0C\u786E\u8BA4\u5220\u9664\uFF1F'
            ),
            eventType == 'receiveDrawback' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u786E\u5B9A\u5DF2\u6536\u5230\u9000\u6B3E\uFF1F'
            ),
            eventType == 'sureReceipt' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u786E\u8BA4\u6536\u8D27\u4EE3\u8868\u60A8\u5DF2\u7ECF\u62FF\u5230\u8D27\u7269\uFF0C\u786E\u8BA4\u540E\u5C06\u65E0\u6CD5\u64A4\u9500\uFF01\u5EFA\u8BAE\u4E0E\u5546\u5BB6\u8054\u7CFB\u540E\u518D\u64CD\u4F5C'
            ),
            eventType == 'deliveryDrawback' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u786E\u8BA4\u53D6\u6D88\u8BA2\u5355\uFF1F'
            ),
            React.createElement(
              'div',
              { className: 'event-dialog-bottom' },
              React.createElement(
                'span',
                { className: 'event-cancel', onClick: this.hideEventDialog },
                '\u53D6\u6D88'
              ),
              eventType == 'cancelOrder' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.cancelOrder
                },
                '\u786E\u8BA4'
              ),
              eventType == 'orderDelete' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.orderDelete
                },
                '\u786E\u8BA4'
              ),
              eventType == 'receiveDrawback' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.receiveDrawback
                },
                '\u786E\u8BA4'
              ),
              eventType == 'sureReceipt' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.sureReceipt
                },
                '\u786E\u8BA4'
              ),
              eventType == 'deliveryDrawback' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.deliveryDrawback
                },
                '\u786E\u8BA4'
              )
            )
          )
        )
      );
    }
  }]);
  return GoodsOrderDetail;
}(_OfficialPage3.default);

exports.default = GoodsOrderDetail;

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(421);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyAddress = function (_OfficialPage) {
  (0, _inherits3.default)(MyAddress, _OfficialPage);

  function MyAddress(props) {
    (0, _classCallCheck3.default)(this, MyAddress);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MyAddress.__proto__ || Object.getPrototypeOf(MyAddress)).call(this, props));

    _this2.state = {
      selectAddressId: '',
      orderId: '',
      addressList: [],
      afterInitial: false,
      isFromBack: false,
      from: '',
      fromAddAdress: false,
      showNewAddressDialog: true,
      address_id: '',
      changeLocal: 0,
      localAddress: '',
      selectProCityDirs: true,
      storeStyle: {}
    };
    _this2.subShopId = '';

    _this2.getAddressList = function (selectAddressId, orderId, from) {
      var that = _this2;
      var shopInfo = _app.appMethod.globalData.takeoutShopInfo;
      var addressList = [];
      var hasInDistance = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        success: function success(res) {
          var address = res.data;
          for (var i = 0, j = address.length - 1; i <= j; i++) {
            if (from == 'previewtakeout') {
              address[i].is_distance = _app.appMethod.calculationDistanceByLatLng(shopInfo.latitude, shopInfo.longitude, address[i].latitude, address[i].longitude) < shopInfo.deliver_distance ? 1 : 0;
            }
            if (address[i].is_distance == 0) {
              hasInDistance = false;
            }
            var addressInfo = address[i].address_info;
            var addressAry = [addressInfo.province && addressInfo.province.text || '', addressInfo.city && addressInfo.city.text || '', addressInfo.district && addressInfo.district.text || ''];
            var joinStr = '';
            if (+addressInfo.country.id !== 1) {
              if (addressAry[1] === addressAry[2] || addressAry[2] === '') {
                addressAry.pop();
              }
              joinStr = ' ';
            }
            addressAry.push(addressInfo.detailAddress || '');
            addressInfo.addressString = addressAry.join(joinStr);
            addressList.push(address[i]);
          }
          if (selectAddressId || orderId || from) {
            that.setData({
              addressList: addressList,
              selectAddressId: selectAddressId || '',
              orderId: orderId || '',
              from: from,
              hasInDistance: hasInDistance
            });
          } else {
            that.setData({
              addressList: addressList,
              hasInDistance: hasInDistance
            });
          }
        }
      });
    };

    _this2.addNewAddress = function () {
      _app.appMethod.turnToPage('/addAddress');
    };

    _this2.addWechatAddress = function () {
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.getAddressList(undefined, undefined, _this.data.from);
            }
          });
        }
      });
    };

    _this2.selectAddress = function (e) {
      var addressId = e.currentTarget.dataset.id,
          that = _this2,
          pages = _app.appMethod.getCurrentPages(),
          prePage = pages[pages.length - 2],
          addressList = _this2.data.addressList;
      if (!prePage) {
        _toast2.default.info('当前操作需要返回上一页');
        _app.appMethod.turnBack();
        return;
      }
      _this2.setData({
        selectAddressId: addressId || ''
      });
      for (var i = addressList.length - 1; i >= 0; i--) {
        if (addressList[i].id == addressId) {
          prePage.setData({
            selectAddress: addressList[i],
            selectAddressId: addressList[i].id
          });
          typeof prePage.selectAddressCallback === 'function' && prePage.selectAddressCallback(addressList[i]);
        }
      }
      _app.appMethod.turnBack();
    };

    _this2.editAddress = function (e) {
      var dataset = e.currentTarget.dataset;
      var addressId = dataset.id;
      var countryId = dataset.countryId;
      _app.appMethod.turnToPage('/addAddress?id=' + addressId + '&countryId=' + countryId);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.subShopId);
    };

    document.title = '我的地址';
    return _this2;
  }

  (0, _createClass3.default)(MyAddress, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var selectAddressId = options.id || '',
          orderId = options.oid || '',
          preTakeout = options.preTakeout || '',
          locateAddress = options.locateAddress || '',
          localLatLng = _app.appMethod.globalData.takeoutAddressInfoByLatLng || '',
          from = options.from || '';
      this.syncUserAddress = options.syncUserAddress || '';
      this.locateAddress = locateAddress;
      this.setData({
        orderId: orderId,
        preTakeout: preTakeout,
        localAddress: locateAddress,
        localLatLng: localLatLng,
        from: from
      });
      this.selectAddressId = selectAddressId;
      this.from = from;
      this.subShopId = options.sub_shop_id || '';
      this.getAppECStoreConfig();
      this.getAddressList(selectAddressId, orderId, from);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        this.getAddressList(this.selectAddressId, this.data.orderId, this.from);
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          addressList = _state.addressList,
          from = _state.from,
          hasInDistance = _state.hasInDistance,
          storeStyle = _state.storeStyle;

      return React.createElement(
        'div',
        { className: 'official-page my-address' },
        React.createElement(_TopNav.TopNav, { title: '\u6211\u7684\u5730\u5740' }),
        React.createElement(
          _ScrollView.ScrollView,
          { 'scroll-y': 'true', style: (0, _tools.convertLineStyleData)('height: calc(100% - 55px);') },
          React.createElement(
            'div',
            {
              className: 'myAddress-wrap page',
              id: 'myAddress',
              style: (0, _tools.convertLineStyleData)('height: 100%;')
            },
            React.createElement(
              'div',
              {
                className: 'get-wechat-address',
                onClick: this.addWechatAddress
              },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/goods-style-wechat.png' }),
              React.createElement(
                'span',
                null,
                '\u83B7\u53D6\u5FAE\u4FE1\u6536\u8D27\u5730\u5740'
              ),
              React.createElement('span', { className: 'ico-moon icon-rightarrow' })
            ),
            React.createElement(
              'div',
              { className: 'myAddress-content-container' },
              !addressList.length ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('color:#a8a8a8; padding:20px;') },
                  '\u6682\u65E0\u6536\u8D27\u5730\u5740'
                )
              ) : React.createElement(
                React.Fragment,
                null,
                addressList.map(function (item, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    (from == 'previewtakeout' && item.is_distance == 1 || from != 'previewtakeout') && React.createElement(
                      'div',
                      { className: 'myAddress-address' },
                      React.createElement(
                        'div',
                        {
                          className: 'myAddress-address-top',
                          'data-info': item,
                          onClick: from == 'userCenterEle' ? null : _this3.selectAddress,
                          'data-id': item.id
                        },
                        React.createElement(
                          'div',
                          null,
                          item.address_info.label == 0 && React.createElement(
                            'label',
                            { className: 'home address-label' },
                            '\u5BB6'
                          ),
                          item.address_info.label == 2 && React.createElement(
                            'label',
                            { className: 'company address-label' },
                            '\u516C\u53F8'
                          ),
                          item.address_info.label == 1 && React.createElement(
                            'label',
                            { className: 'school address-label' },
                            '\u5B66\u6821'
                          ),
                          React.createElement(
                            'span',
                            { className: 'address-person' },
                            item.address_info.name + ' ' + (item.address_info.sex == 1 ? '(先生)' : item.address_info.sex == 0 ? '(女士)' : '') + ' ' + item.address_info.contact
                          )
                        ),
                        React.createElement(
                          'span',
                          { className: 'address-detail' },
                          item.address_info.addressString
                        )
                      ),
                      React.createElement('span', {
                        className: 'myAddress-edit ico-moon icon-community-edit',
                        onClick: _this3.editAddress,
                        'data-id': item.id,
                        'data-country-id': item.address_info.country.id
                      })
                    )
                  );
                }),
                from == 'previewtakeout' && !hasInDistance && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'address-list-title' },
                    '\u4EE5\u4E0B\u5730\u5740\u4E0D\u5728\u914D\u9001\u8303\u56F4'
                  ),
                  addressList.map(function (item, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      (from == 'previewtakeout' && item.is_distance != 1 || from != 'previewtakeout') && React.createElement(
                        'div',
                        {
                          className: 'myAddress-address',
                          style: (0, _tools.convertLineStyleData)('background-color: #fdfdfd;')
                        },
                        React.createElement(
                          'div',
                          { className: 'myAddress-address-top' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement(
                              'span',
                              {
                                className: 'address-detail',
                                style: (0, _tools.convertLineStyleData)('color: #999;width:auto;')
                              },
                              item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + item.address_info.detailAddress
                            )
                          ),
                          React.createElement(
                            'span',
                            {
                              className: 'address-person',
                              style: (0, _tools.convertLineStyleData)('color: #999;')
                            },
                            item.address_info.name + ' ' + (item.address_info.sex == 1 ? '(先生)' : item.address_info.sex == 0 ? '(女士)' : '') + ' ' + item.address_info.contact
                          )
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'myAddress-bottom-nav',
            style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
            onClick: this.addNewAddress
          },
          '\u65B0\u589E\u6536\u8D27\u5730\u5740'
        )
      );
    }
  }]);
  return MyAddress;
}(_OfficialPage3.default);

exports.default = MyAddress;

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(423);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsOrderProgress = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsOrderProgress, _OfficialPage);

  function GoodsOrderProgress(props) {
    (0, _classCallCheck3.default)(this, GoodsOrderProgress);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsOrderProgress.__proto__ || Object.getPrototypeOf(GoodsOrderProgress)).call(this, props));

    _this2.state = {
      orderFlowData: []
    };
    _this2.orderId = '';

    _this2.getOrderFlow = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/getOrderFlow',
        data: {
          order_id: _this.orderId
        },
        success: function success(res) {
          var orderFlowData = res.data.reverse();
          _this.setData({
            orderFlowData: orderFlowData
          });
        }
      });
    };

    document.title = '订单进度';
    return _this2;
  }

  (0, _createClass3.default)(GoodsOrderProgress, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
      this.getOrderFlow();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          orderFlowData = _state.orderFlowData;

      return React.createElement(
        'div',
        { className: 'official-page goods-order-progress' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8FDB\u5EA6' }),
        React.createElement(
          'div',
          { className: 'progress-contain' },
          React.createElement(
            'div',
            { className: 'progress-header' },
            React.createElement(
              'div',
              null,
              '\u4E70\u5BB6\u64CD\u4F5C'
            ),
            React.createElement(
              'div',
              null,
              '\u5356\u5BB6\u64CD\u4F5C'
            )
          ),
          React.createElement(
            'div',
            { className: 'progress-content' },
            orderFlowData.map(function (item, index) {
              return React.createElement(
                'div',
                { className: 'content-box', key: item.id },
                React.createElement(
                  'div',
                  { className: 'progress-left' },
                  !!item.is_custom && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      null,
                      item.content.msg
                    ),
                    React.createElement(
                      'span',
                      { className: 'progress-time' },
                      item.op_time
                    )
                  )
                ),
                React.createElement('div', { className: 'progress-center' }),
                React.createElement(
                  'div',
                  { className: 'progress-right' },
                  !item.is_custom && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      null,
                      item.content.msg
                    ),
                    React.createElement(
                      'span',
                      { className: 'progress-time' },
                      item.op_time
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return GoodsOrderProgress;
}(_OfficialPage3.default);

exports.default = GoodsOrderProgress;

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(425);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogisticsPage = function (_OfficialPage) {
  (0, _inherits3.default)(LogisticsPage, _OfficialPage);

  function LogisticsPage(props) {
    (0, _classCallCheck3.default)(this, LogisticsPage);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (LogisticsPage.__proto__ || Object.getPrototypeOf(LogisticsPage)).call(this, props));

    _this2.state = {
      info: {},
      logistics: []
    };
    _this2.orderId = '';
    _this2.applyId = '';
    _this2.franchiseeId = '';
    _this2.isGroup = 0;

    _this2.getExpressFlow = function () {
      var _this = _this2;
      var data = {
        order_id: _this.orderId,
        sub_shop_app_id: _this.franchiseeId
      };
      var url = '/index.php?r=AppShop/expressFlow';
      if (_this2.isGroup) {
        url = '/index.php?r=AppDistributionExt/GetGroupExpressFlow';
        data = {
          app_id: _this.franchiseeId,
          group_order_id: _this.orderId
        };
      }
      _app.appMethod.sendRequest({
        url: url,
        data: data,
        success: function success(res) {
          var info = res.data;
          if (!info) {
            return;
          }
          if (info.is_custom) {
            var description = info.express_description.replace(/]/g, '[');
            var desArr = description.split('[');
            _this.setData({
              info: info,
              desArr: desArr
            });
          } else {
            var logistics = info.Traces;
            if (info.waybill_id) {
              info.path_item_list.map(function (item) {
                item.AcceptTime = item.action_time;
                item.AcceptStation = item.action_msg;
              });
              logistics = info.path_item_list;
            }
            _this.setData({
              info: info,
              logistics: logistics
            });
          }
        }
      });
    };

    _this2.getRefundExpress = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/getRefundExpress',
        data: {
          apply_id: _this.applyId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            info: res.data,
            logistics: res.data.Traces.reverse()
          });
        }
      });
    };

    _this2.dialNumber = function (event) {
      _app.appMethod.makePhoneCall(event.currentTarget.dataset.phone);
    };

    document.title = '物流信息';
    return _this2;
  }

  (0, _createClass3.default)(LogisticsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var form = options.form;
      this.orderId = options.detail;
      this.applyId = options.applyId;
      this.franchiseeId = options.franchiseeId || '';
      this.isGroup = options.isGroup || 0;
      if (form == 'afterSale') {
        this.getRefundExpress();
      } else {
        this.getExpressFlow();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          info = _state.info,
          desArr = _state.desArr,
          logistics = _state.logistics;

      return React.createElement(
        'div',
        { className: 'official-page logistics-page' },
        React.createElement(_TopNav.TopNav, { title: '\u7269\u6D41\u4FE1\u606F' }),
        React.createElement(
          'div',
          { id: 'logisticsPage' },
          React.createElement(
            'div',
            { className: 'logistics-header' },
            React.createElement(
              'div',
              { className: 'logistics-company' },
              '\u627F\u8FD0\u516C\u53F8\uFF1A',
              React.createElement(
                'span',
                null,
                info.express_name || info.delivery_name
              )
            ),
            React.createElement(
              'div',
              null,
              '\u8FD0\u5355\u7F16\u53F7\uFF1A',
              React.createElement(
                'span',
                null,
                info.LogisticCode || info.express_no || info.waybill_id
              )
            )
          ),
          info.is_custom && desArr.length || !info.is_custom && logistics.length ? React.createElement(
            'div',
            { className: 'logistics-container' },
            info.is_custom ? React.createElement(
              React.Fragment,
              null,
              desArr.map(function (item, index) {
                return React.createElement(
                  'span',
                  {
                    key: index,
                    className: 'self-express ' + (index % 2 == 1 ? 'express-phone' : ''),
                    onClick: index % 2 == 1 ? 'dialNumber' : '',
                    'data-phone': item
                  },
                  index % 2 == 1 ? '[' + item + ']' : item
                );
              })
            ) : React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { className: 'logistics-list' },
                logistics.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { key: index, className: 'logistics-item' },
                    React.createElement(
                      'div',
                      { className: 'logistics-location' },
                      item.AcceptStation
                    ),
                    React.createElement(
                      'div',
                      { className: 'logistics-time' },
                      item.AcceptTime
                    )
                  );
                })
              )
            )
          ) : React.createElement(
            'div',
            { className: 'no-logistics' },
            React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-logistics.png' }),
            React.createElement(
              'div',
              null,
              '\u6682\u65E0\u7269\u6D41\u4FE1\u606F'
            )
          )
        )
      );
    }
  }]);
  return LogisticsPage;
}(_OfficialPage3.default);

exports.default = LogisticsPage;

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(427);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MakeComment = function (_OfficialPage) {
  (0, _inherits3.default)(MakeComment, _OfficialPage);

  function MakeComment(props) {
    (0, _classCallCheck3.default)(this, MakeComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MakeComment.__proto__ || Object.getPrototypeOf(MakeComment)).call(this, props));

    _this.state = {
      goodsInfo: [],
      submitData: {
        order_id: '',
        goods: [],
        score: 5,
        appointment_score: 5,
        logistics_score: 5,
        appointment_worker_score: 5
      },
      goodsType: ''
    };
    _this.workName = [];

    _this.getOrderDetail = function () {
      var that = _this;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.submitData.order_id,
          sub_shop_app_id: _this.data.submitData.sub_shop_app_id
        },
        success: function success(res) {
          var goodsType = res.data[0].form_data.goods_type,
              goodsInfo = res.data[0].form_data.goods_info,
              pick_up_type = res.data[0].form_data.pick_up_type,
              goods = [],
              service = res.data[0].form_data.service;
          if (service && goodsType == '10') {
            if (service['spu'] && service['spu'].length > 0) {
              service['spu'].map(function (item, index) {
                that.workName.push(item['worker_name']);
              });
            }
          }
          for (var i = 0, j = goodsInfo.length - 1; i <= j; i++) {
            goods.push({
              goods_id: goodsInfo[i].goods_id,
              info: {
                content: '',
                level: 1,
                img_arr: []
              }
            });
            if (pick_up_type == 4) {
              goodsInfo[i].refunded_num >= goodsInfo[i].num && goodsInfo.splice(i, 1);
            }
          }
          that.setData({
            pick_up_type: pick_up_type,
            goodsInfo: goodsInfo,
            'submitData.goods': goods,
            goodsType: goodsType
          });
        }
      });
    };

    _this.setDescScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.score': score,
        'submitData.appointment_score': score
      });
    };

    _this.setWorkerScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.appointment_worker_score': score
      });
    };

    _this.setLogisticsScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.logistics_score': score
      });
    };

    _this.clickLevelSpan = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          level = e.currentTarget.dataset.level,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.level'] = level;
      _this.setData(data);
    };

    _this.commentInput = function (e) {
      var goodsIndex = e.target.dataset.goodsIndex,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.content'] = e.target.value;
      _this.setData(data);
    };

    _this.chooseImage = function (e) {
      var that = _this,
          goodsIndex = e.currentTarget.dataset.goodsIndex,
          img_arr = that.data.submitData.goods[goodsIndex].info.img_arr;
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr.concat(images);
        that.setData(data);
      }, 3 - img_arr.length);
    };

    _this.removePic = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          picIndex = e.currentTarget.dataset.picIndex,
          img_arr = _this.data.submitData.goods[goodsIndex].info.img_arr,
          data = {};
      img_arr.splice(picIndex, 1);
      data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr;
      _this.setData(data);
    };

    _this.makeComment = function () {
      var that = _this,
          submitData = that.data.submitData,
          modalText = '';
      if (that.workName.length) {
        submitData['appointment_worker_info'] = {};
        submitData['appointment_worker_info']['worker_name'] = that.workName;
      }
      for (var i = submitData.goods.length - 1; i >= 0; i--) {
        var goods = submitData.goods[i];
        if (!goods.info.level) {
          modalText = '尚未给商品评分';
          break;
        }
        if (goods.info.img_arr.length > 3) {
          modalText = '每个商品最多上传3张图片';
          break;
        }
      }
      if (modalText) {
        _app.appMethod.showModal({
          content: modalText
        });
        return;
      }
      var addTime = Date.now();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/AddAssessList',
        method: 'post',
        data: submitData,
        success: function success(res) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.data == 0) {
                _app.appMethod.showModal({
                  content: '评论成功',
                  confirm: function confirm() {
                    _app.appMethod.turnToPage('/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=comment&orderId=' + that.data.submitData.order_id + '&franchiseeId=' + that.data.submitData.sub_shop_app_id, 1);
                  }
                });
              } else {
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: function callback() {
                      _app.appMethod.turnToPage('/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=comment&orderId=' + that.data.submitData.order_id + '&franchiseeId=' + that.data.submitData.sub_shop_app_id, 1);
                    }
                  }
                });
              }
            }
          });
        }
      });
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config
        });
      }, _this.data.submitData.sub_shop_app_id);
    };

    document.title = '评价';
    return _this;
  }

  (0, _createClass3.default)(MakeComment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        'submitData.order_id': options.detail,
        'submitData.sub_shop_app_id': options.franchisee || ''
      });
      this.getOrderDetail();
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          goodsInfo = _state.goodsInfo,
          submitData = _state.submitData,
          storeStyle = _state.storeStyle,
          goodsType = _state.goodsType,
          pick_up_type = _state.pick_up_type;

      return React.createElement(
        'div',
        { className: 'official-page make-comment' },
        React.createElement(_TopNav.TopNav, { title: '\u8BC4\u4EF7' }),
        React.createElement(
          'div',
          { className: 'makeCom-wrap', id: 'makeComment' },
          goodsInfo.map(function (item, goodsIndex) {
            return React.createElement(
              'div',
              { className: 'makeCom-item makeCom-goods-comment', key: goodsIndex },
              React.createElement(
                'div',
                null,
                React.createElement('img', {
                  className: 'makeCom-goods-cover',
                  src: item.cover
                }),
                React.createElement(
                  'div',
                  { className: 'make-header-right' },
                  React.createElement(
                    'div',
                    { className: 'goods-name' },
                    item.goods_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'makeCom-level-container' },
                    React.createElement(
                      'label',
                      {
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level == 1 ? 'color:' + storeStyle.theme : ''),
                        className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 1 ? 'active' : ''),
                        'data-level': '1',
                        'data-goods-index': goodsIndex,
                        onClick: _this2.clickLevelSpan
                      },
                      React.createElement('label', { className: 'ico-moon icon-tostoreGoodComment' }),
                      '\u597D\u8BC4'
                    ),
                    React.createElement(
                      'label',
                      {
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level == 2 ? 'color:' + storeStyle.theme : ''),
                        className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 2 ? 'active' : ''),
                        'data-level': '2',
                        'data-goods-index': goodsIndex,
                        onClick: _this2.clickLevelSpan
                      },
                      React.createElement('label', { className: 'ico-moon icon-tostoreMiddleComment' }),
                      '\u4E2D\u8BC4'
                    ),
                    React.createElement(
                      'label',
                      {
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level == 3 ? 'color:' + storeStyle.theme : ''),
                        className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 3 ? 'active' : ''),
                        'data-level': '3',
                        'data-goods-index': goodsIndex,
                        onClick: _this2.clickLevelSpan
                      },
                      React.createElement('label', { className: 'ico-moon icon-tostoreBadComment' }),
                      '\u5DEE\u8BC4'
                    )
                  )
                )
              ),
              React.createElement('textarea', {
                'data-goods-index': goodsIndex,
                onInput: _this2.commentInput,
                className: 'makeCom-textarea',
                placeholder: '\u8BC4\u4EF7\u5546\u54C1\u7ED9\u5C0F\u4F19\u4F34\u4EEC\u53C2\u8003\uFF0C\u5EFA\u8BAE10\u5B57\u4EE5\u4E0A'
              }),
              React.createElement(
                'div',
                { className: 'makeCom-pic-container' },
                submitData.goods[goodsIndex].info.img_arr.map(function (imgUrl, index) {
                  return React.createElement(
                    'div',
                    (0, _defineProperty3.default)({ key: true, className: 'makeCom-pic-wrap' }, 'key', index),
                    React.createElement('img', { src: imgUrl, mode: 'aspectFit' }),
                    React.createElement('label', {
                      className: 'makeCom-remove-pic ico-moon icon-closes',
                      onClick: _this2.removePic,
                      'data-goods-index': goodsIndex,
                      'data-pic-index': index
                    })
                  );
                }),
                submitData.goods[goodsIndex].info.img_arr.length < 3 && React.createElement(
                  'div',
                  {
                    className: 'makeCom-upload-pic',
                    onClick: _this2.chooseImage,
                    'data-goods-index': goodsIndex
                  },
                  React.createElement('div', { className: 'ico-moon icon-goods-add-image' }),
                  React.createElement(
                    'span',
                    null,
                    '\u6DFB\u52A0\u56FE\u7247'
                  )
                )
              )
            );
          }),
          React.createElement(
            'div',
            { className: 'makeCom-item', style: (0, _tools.convertLineStyleData)('margin-top: 15rpx;') },
            React.createElement(
              'div',
              { className: 'shop-title' },
              React.createElement('span', { className: 'ico-moon icon-store2' }),
              React.createElement(
                'span',
                null,
                '\u5E97\u94FA\u8BC4\u5206'
              )
            ),
            React.createElement(
              'div',
              { className: 'evaluat-box' },
              React.createElement(
                'span',
                { className: 'evaluat-title' },
                '\u63CF\u8FF0\u76F8\u7B26\uFF1A'
              ),
              React.createElement(
                'div',
                { className: 'makeCom-mark-container pull-right' },
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.score >= 1 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.score >= 1 ? '' : '-empty'),
                  'data-score': '1',
                  onClick: this.setDescScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.score >= 2 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.score >= 2 ? '' : '-empty'),
                  'data-score': '2',
                  onClick: this.setDescScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.score >= 3 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.score >= 3 ? '' : '-empty'),
                  'data-score': '3',
                  onClick: this.setDescScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.score >= 4 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.score >= 4 ? '' : '-empty'),
                  'data-score': '4',
                  onClick: this.setDescScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.score >= 5 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.score >= 5 ? '' : '-empty'),
                  'data-score': '5',
                  onClick: this.setDescScore
                })
              )
            ),
            goodsType == '10' && React.createElement(
              'div',
              { className: 'evaluat-box' },
              React.createElement(
                'span',
                { className: 'evaluat-title' },
                '\u670D\u52A1\u8D28\u91CF\uFF1A'
              ),
              React.createElement(
                'div',
                { className: 'makeCom-mark-container pull-right' },
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.appointment_worker_score >= 1 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.appointment_worker_score >= 1 ? '' : '-empty'),
                  'data-score': '1',
                  onClick: this.setWorkerScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.appointment_worker_score >= 2 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.appointment_worker_score >= 2 ? '' : '-empty'),
                  'data-score': '2',
                  onClick: this.setWorkerScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.appointment_worker_score >= 3 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.appointment_worker_score >= 3 ? '' : '-empty'),
                  'data-score': '3',
                  onClick: this.setWorkerScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.appointment_worker_score >= 4 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.appointment_worker_score >= 4 ? '' : '-empty'),
                  'data-score': '4',
                  onClick: this.setWorkerScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.appointment_worker_score >= 5 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.appointment_worker_score >= 5 ? '' : '-empty'),
                  'data-score': '5',
                  onClick: this.setWorkerScore
                })
              )
            ),
            goodsType != '1' && goodsType != '10' && pick_up_type != 4 && React.createElement(
              'div',
              { className: 'evaluat-box' },
              React.createElement(
                'span',
                { className: 'evaluat-title' },
                '\u7269\u6D41\u670D\u52A1\uFF1A'
              ),
              React.createElement(
                'div',
                { className: 'makeCom-mark-container  pull-right' },
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.logistics_score >= 1 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.logistics_score >= 1 ? '' : '-empty'),
                  'data-score': '1',
                  onClick: this.setLogisticsScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.logistics_score >= 2 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.logistics_score >= 2 ? '' : '-empty'),
                  'data-score': '2',
                  onClick: this.setLogisticsScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.logistics_score >= 3 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.logistics_score >= 3 ? '' : '-empty'),
                  'data-score': '3',
                  onClick: this.setLogisticsScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.logistics_score >= 4 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.logistics_score >= 4 ? '' : '-empty'),
                  'data-score': '4',
                  onClick: this.setLogisticsScore
                }),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(submitData.logistics_score >= 5 ? 'color:' + storeStyle.theme : ''),
                  className: 'ico-moon icon-star' + (submitData.logistics_score >= 5 ? '' : '-empty'),
                  'data-score': '5',
                  onClick: this.setLogisticsScore
                })
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'submit-comment',
              style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
              onClick: this.makeComment
            },
            '\u53D1\u8868\u8BC4\u4EF7'
          )
        )
      );
    }
  }]);
  return MakeComment;
}(_OfficialPage3.default);

exports.default = MakeComment;

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(429);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewGoodsRefund = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewGoodsRefund, _OfficialPage);

  function PreviewGoodsRefund(props) {
    (0, _classCallCheck3.default)(this, PreviewGoodsRefund);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewGoodsRefund.__proto__ || Object.getPrototypeOf(PreviewGoodsRefund)).call(this, props));

    _this2.state = {
      goodsList: [],
      selectAll: true,
      is_vip_goods: '',
      dining_partner_source: 0, //餐饮三方订单标识 (1==客如云订单),
      storeStyle: {}
    };
    _this2.orderId = '';
    _this2.franchiseeId = '';

    _this2.getOrderDetail = function () {
      var _this = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this.orderId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var goodsData = res.data[0].form_data.goods_info;
          var is_vip_goods = res.data[0].vip_cut_price == 0 ? 0 : 1;
          for (var i = 0; i < goodsData.length; i++) {
            goodsData[i].preview_refund_num = goodsData[i].num - (goodsData[i].refunded_num || '0');
            goodsData[i].preview_refund_num > 0 && goodsData[i].is_benefit_goods != 1 ? goodsData[i].selected = true : '';
            goodsData[i].model_value_str = goodsData[i].model_value ? goodsData[i].model_value.join('； ') : '';
          }
          _this.setData({
            is_vip_goods: is_vip_goods,
            goodsList: goodsData,
            is_group_buy_order: res.data[0].form_data.is_group_buy_order || 0,
            dining_partner_source: res.data[0].form_data.dining_partner_source || 0
          });
        }
      });
    };

    _this2.clickSelectAll = function () {
      if (_this2.data.dining_partner_source) {
        return;
      }
      var alreadySelect = _this2.data.selectAll,
          list = _this2.data.goodsList;
      if (alreadySelect) {
        for (var i = list.length - 1; i >= 0; i--) {
          list[i].selected = false;
        }
      } else {
        for (var i = list.length - 1; i >= 0; i--) {
          list[i].selected = true;
        }
      }
      _this2.setData({
        selectAll: !alreadySelect,
        goodsList: list
      });
    };

    _this2.clickSelectGoods = function (e) {
      if (_this2.data.dining_partner_source) {
        return;
      }
      var index = e.currentTarget.dataset.index,
          list = _this2.data.goodsList,
          selectAll = true;
      list[index].selected = !list[index].selected;
      for (var i = list.length - 1; i >= 0; i--) {
        if (!list[i].selected) {
          selectAll = false;
          break;
        }
      }
      _this2.setData({
        goodsList: list,
        selectAll: selectAll
      });
    };

    _this2.sureRefund = function () {
      var orderId = _this2.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=apply&orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      var goodsList = _this2.data.goodsList;
      var flag = true;
      for (var i = 0; i < goodsList.length; i++) {
        if (goodsList[i].selected) {
          flag = false;
        }
      }
      if (flag) {
        _app.appMethod.showModal({
          content: '请选择需要退款的商品'
        });
        return;
      }
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      var previewRefundNum = _this2.data.goodsList[index].preview_refund_num;
      if (previewRefundNum - 1 <= 0) {
        return;
      }
      if (_this2.data.dining_partner_source) {
        return;
      }
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      var previewRefundNum = _this2.data.goodsList[index].preview_refund_num;
      var maxRefundNum = _this2.data.goodsList[index].num - (_this2.data.goodsList[index].refunded_num || '0');
      if (previewRefundNum + 1 > maxRefundNum) {
        return;
      }
      if (_this2.data.dining_partner_source) {
        return;
      }
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.changeGoodsNum = function (index, type) {
      var canRefundNum = _this2.data.goodsList[index].preview_refund_num;
      var targetNum = type == 'plus' ? canRefundNum + 1 : canRefundNum - 1;
      var data = {};
      data['goodsList[' + index + '].preview_refund_num'] = targetNum;
      _this2.setData(data);
    };

    _this2.inputGoodsCount = function (e) {
      var index = e.target.dataset.index;
      var previewRefundNum = e.target.value;
      var data = {};
      var maxRefundNum = _this2.data.goodsList[index].num - (_this2.data.goodsList[index].refunded_num || '0');
      if (previewRefundNum == '') {
        return;
      }
      if (previewRefundNum == 0) {
        _app.appMethod.showModal({
          content: '请输入大于0的数字'
        });
        return;
      }
      if (previewRefundNum > maxRefundNum) {
        _app.appMethod.showModal({
          content: '当前输入数量大于可退款数量'
        });
        return;
      }
      data['goodsList[' + index + '].preview_refund_num'] = previewRefundNum;
      _this2.setData(data);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    document.title = '申请退款';
    return _this2;
  }

  (0, _createClass3.default)(PreviewGoodsRefund, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
      this.franchiseeId = options.franchisee;
      this.getOrderDetail();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          goodsList = _state.goodsList,
          storeStyle = _state.storeStyle,
          is_group_buy_order = _state.is_group_buy_order,
          dining_partner_source = _state.dining_partner_source,
          selectAll = _state.selectAll;

      return React.createElement(
        'div',
        { className: 'official-page preview-goods-refund' },
        React.createElement(_TopNav.TopNav, { title: '\u7533\u8BF7\u9000\u6B3E' }),
        React.createElement(
          'div',
          { className: 'shoppingCart-wrap page', id: 'shoppingCart' },
          React.createElement(
            'div',
            { className: 'shoppingCart-top-nav' },
            React.createElement(
              'span',
              null,
              '\u9000\u6B3E\u5546\u54C1'
            )
          ),
          React.createElement(
            'div',
            { className: 'shoppingCart-list-wrap' },
            React.createElement(
              'div',
              { className: 'shoppingCart-goods-list' },
              goodsList.map(function (goods, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  goods.preview_refund_num > 0 && goods.is_benefit_goods != 1 && React.createElement(
                    'div',
                    null,
                    React.createElement('label', {
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                      'data-index': index,
                      className: 'shoppingCart-check-box ' + (goods.selected ? 'checked ico-moon icon-success-tip' : ''),
                      onClick: _this3.clickSelectGoods
                    }),
                    React.createElement(
                      'div',
                      { className: 'shoppingCart-goods-content' },
                      React.createElement(
                        'div',
                        { className: 'shoppingCart-goods-cover' },
                        React.createElement('img', { src: goods.cover })
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-content-box' },
                        React.createElement(
                          'div',
                          { className: 'shoppingCart-goods-title' },
                          is_group_buy_order != 0 && React.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u62FC\u56E2'
                          ),
                          goods.is_seckill == 1 && React.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u79D2\u6740'
                          ),
                          goods.is_vip_goods == 1 && React.createElement(
                            'span',
                            { className: 'is-seckill' },
                            '\u4F1A\u5458\u4EF7'
                          ),
                          goods.goods_name
                        ),
                        goods.model_value_str && React.createElement(
                          'div',
                          { className: 'ellipsis shoppingCart-goods-model' },
                          goods.model_value_str
                        ),
                        React.createElement(
                          'div',
                          { className: 'shoppingCart-price-box' },
                          goods.use_integral == 0 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'span',
                              {
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                className: 'real-price'
                              },
                              '¥' + goods.price
                            )
                          ) : React.createElement(
                            React.Fragment,
                            null,
                            (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                              'span',
                              {
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                className: 'real-price'
                              },
                              '¥' + goods.price
                            ),
                            goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                              'span',
                              {
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                className: 'real-price'
                              },
                              '+'
                            ),
                            goods.use_integral && React.createElement(
                              'span',
                              {
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                className: 'real-price'
                              },
                              goods.use_integral + '积分'
                            )
                          ),
                          goods.is_seckill == 1 && React.createElement(
                            'span',
                            { className: 'seckill-price' },
                            '¥' + goods.original_price
                          ),
                          React.createElement(
                            'div',
                            { className: 'goods-number-box pull-right' },
                            React.createElement(
                              'div',
                              {
                                className: 'goods-num-mius',
                                onClick: _this3.clickMinusButton,
                                'data-index': index
                              },
                              '-'
                            ),
                            React.createElement('input', {
                              type: 'number',
                              className: 'goods-num-box',
                              value: goods.preview_refund_num,
                              'data-index': index,
                              onInput: _this3.inputGoodsCount,
                              disabled: dining_partner_source ? false : true
                            }),
                            React.createElement(
                              'div',
                              {
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                                className: 'goods-num-plus',
                                onClick: _this3.clickPlusButton,
                                'data-index': index
                              },
                              '+'
                            )
                          )
                        )
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'shoppingCart-bottom-nav' },
          React.createElement('label', {
            style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
            className: 'shoppingCart-check-box ' + (selectAll ? 'checked ico-moon icon-success-tip' : ''),
            onClick: this.clickSelectAll
          }),
          React.createElement(
            'span',
            { className: 'select-all' },
            '\u5168\u9009'
          ),
          !!+dining_partner_source && React.createElement(
            'span',
            { className: 'select-all' },
            '\uFF08\u4E0D\u53EF\u90E8\u5206\u9000\u6B3E\uFF09'
          ),
          React.createElement(
            'div',
            {
              style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
              className: 'pull-right sure-refund-btn',
              onClick: this.sureRefund
            },
            '\u786E\u5B9A'
          )
        )
      );
    }
  }]);
  return PreviewGoodsRefund;
}(_OfficialPage3.default);

exports.default = PreviewGoodsRefund;

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(431);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsRefundPage = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsRefundPage, _OfficialPage);

  function GoodsRefundPage(props) {
    (0, _classCallCheck3.default)(this, GoodsRefundPage);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsRefundPage.__proto__ || Object.getPrototypeOf(GoodsRefundPage)).call(this, props));

    _this2.state = {
      orderInfoStatus: '',
      is_vip_goods: '',
      goodsList: [],
      refundTypeData: [{ title: '未收到货物/拒收货物（申请全额退款）' }, { title: '已收到货物，不退货，仅退款（申请部分退款）' }, { title: '已收到货物，退货退款（申请全额退款）' }],
      refundReasonData: [{ title: '多拍/拍错/不想要' }, { title: '快递延期' }, { title: '未按约定时间发货' }, { title: '快递记录出错' }, { title: '内容与描述不符' }, { title: '其它' }],
      refundWayData: [{ title: '原付款方式退回' }, { title: '退还为储值金' }],
      refundJourneyReasonData: [{ title: '未保持餐品完整' }, { title: '骑手服务态度恶劣' }, { title: '骑手额外索取费用' }, { title: '骑手诱导退单' }, { title: '骑手提前点击送达' }, { title: '骑手虚假标记异常' }, { title: '少餐错餐' }],
      showRefundType: true,
      showRefundReason: true,
      showRefundWay: true,
      typeIndex: '',
      reasonIndex: '',
      wayIndex: '',
      imagesArr: [],
      express: '',
      maxRefundPrice: '',
      refundPrice: '',
      refundDes: '',
      isShowPayInstruct: true,
      is_group_buy_order: 0,
      sameCity: 0,
      storeStyle: {}
    };
    _this2.orderId = '';
    _this2.franchiseeId = '';
    _this2.origin = '';
    _this2.applyRefundId = '';
    _this2.refundGoods = [];

    _this2.dataInitial = function () {
      _this2.getAppECStoreConfig();
      if (_this2.origin == 'apply') {
        var data = _app.appMethod.getCurrentPages()[_app.appMethod.getCurrentPages().length - 2].data.goodsList;
        var goodsList = [];
        var refundGoods = [];
        for (var i = 0; i < data.length; i++) {
          if (data[i].selected) {
            goodsList.push(data[i]);
            refundGoods.push({
              goods_id: data[i].goods_id,
              model_id: data[i].model_id,
              num: data[i].preview_refund_num
            });
          }
        }
        _this2.setData({
          goodsList: goodsList
        });
        _this2.refundGoods = refundGoods;
        _this2.calculateRefundPrice();
      }
      _this2.getOrderDetail();
    };

    _this2.getOrderDetail = function () {
      var _this = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this.orderId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var formData = res.data[0].form_data;
          var is_vip_goods = res.data[0].vip_cut_price == 0 ? 0 : 1;
          var deliverType = formData.ecommerce_info.intra_city_data && formData.ecommerce_info.intra_city_data.deliver_type || 0;
          var pickUpType = formData.pick_up_type;
          var sameCity = 0;
          if (formData.wx_local_express_order) {
            sameCity = 1;
          }
          if (_this.origin == 'editor') {
            var refundGoods = formData.refund_apply.refund_goods;
            for (var j = 0; j < refundGoods.length; j++) {
              refundGoods[j].goods_name = refundGoods[j].title;
              refundGoods[j].preview_refund_num = refundGoods[j].num;
              refundGoods[j].model_value = refundGoods[j].model_name;
            }
            _this.setData({
              goodsList: refundGoods,
              typeIndex: formData.refund_apply.refund_type,
              reasonIndex: formData.refund_apply.refund_reason,
              wayIndex: formData.refund_apply.refund_mode,
              imagesArr: formData.refund_apply.img_url || [],
              refundDes: formData.refund_apply.description,
              refundPrice: formData.refund_apply.refund_price
            });
            _this.applyRefundId = formData.refund_apply.id;
            _this.refundGoods = refundGoods;
            _this.calculateRefundPrice();
          }
          _this.setData({
            orignalStatus: formData.refund_info && formData.refund_info.orignal_status || '',
            orderInfoStatus: formData.status,
            is_group_buy_order: formData.is_group_buy_order || 0,
            is_vip_goods: is_vip_goods,
            pickUpType: pickUpType,
            deliveryStatus: formData.ecommerce_info.ecommerce_transport_order && formData.ecommerce_info.ecommerce_transport_order.status || '',
            sameCity: sameCity
          });
          _this.getRefundConfigByPickUpType(formData.pick_up_type);
          if (pickUpType == 2) {
            _this.getBuyerCancelReason(deliverType);
          }
        }
      });
    };

    _this2.calculateRefundPrice = function (type) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/calculateRefundPrice',
        method: 'post',
        data: {
          order_id: _this.orderId,
          refund_goods: _this.refundGoods,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var newData = {
            express: res.data.has_express,
            maxRefundPrice: res.data.refund_goods_price
          };
          _this.origin == 'editor' ? '' : newData['refundPrice'] = res.data.refund_goods_price;
          _this.setData(newData);
        }
      });
    };

    _this2.closeRefundBox = function () {
      _this2.setData({
        showRefundType: true,
        showRefundReason: true,
        showRefundWay: true
      });
    };

    _this2.showRefundBox = function (event) {
      var _this = _this2;
      var type = event.currentTarget.dataset.type;
      var newData = {};
      switch (type) {
        case 'type':
          newData.showRefundType = false;
          break;
        case 'reason':
          if (_this.data.typeIndex !== '') {
            newData.showRefundReason = false;
          }
          break;
        case 'way':
          if (_this.data.typeIndex !== '' && _this.data.reasonIndex !== '') {
            newData.showRefundWay = false;
          }
          break;
      }
      _this2.setData(newData);
    };

    _this2.selectReason = function (event) {
      var type = event.currentTarget.dataset.type;
      var index = event.currentTarget.dataset.index;
      var newData = {};
      var _this = _this2;
      switch (type) {
        case 'type':
          newData.typeIndex = index;
          if (index == 0) {
            newData.refundPrice = _this.data.maxRefundPrice;
          }
          newData.showRefundType = true;
          newData.showRefundReason = false;
          break;
        case 'reason':
          newData.reasonIndex = index;
          newData.showRefundReason = true;
          newData.showRefundWay = false;
          break;
        case 'way':
          newData.wayIndex = index;
          newData.showRefundWay = true;
          break;
      }
      _this2.setData(newData);
    };

    _this2.chooseImage = function () {
      var _this = _this2;
      var img_arr = _this.data.imagesArr || [];
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data.imagesArr = img_arr.concat(images);
        _this.setData(data);
      }, 8 - img_arr.length);
    };

    _this2.deleteImage = function (event) {
      var picIndex = event.currentTarget.dataset.index;
      var img_arr = _this2.data.imagesArr;
      var data = {};
      img_arr.splice(picIndex, 1);
      data.imagesArr = img_arr;
      _this2.setData(data);
    };

    _this2.previewImage = function (event) {
      var _this = _this2;
      var index = event.currentTarget.dataset.index;
      _app.appMethod.previewImage({
        current: _this.data.imagesArr[index],
        urls: _this.data.imagesArr
      });
    };

    _this2.prevRefundBox = function (event) {
      var type = event.currentTarget.dataset.type;
      var newData = {};
      switch (type) {
        case 'reason':
          newData.showRefundType = false;
          newData.showRefundReason = true;
          break;
        case 'way':
          newData.showRefundReason = false;
          newData.showRefundWay = true;
          break;
      }
      _this2.setData(newData);
    };

    _this2.cancelRefund = function () {
      _app.appMethod.turnBack();
    };

    _this2.stopPropagation = function (event) {};

    _this2.changeRefundPrice = function (event) {
      _this2.setData({
        refundPrice: event.target.value
      });
    };

    _this2.inputRefundDes = function (event) {
      _this2.setData({
        refundDes: event.target.value
      });
    };

    _this2.sureRefund = function () {
      var _this = _this2;
      if (_this.data.typeIndex === '') {
        _app.appMethod.showModal({
          content: '请填写退款类型'
        });
        return;
      }
      if (_this.data.reasonIndex === '') {
        _app.appMethod.showModal({
          content: '请填写退款原因'
        });
        return;
      }
      if (_this.data.wayIndex === '') {
        _app.appMethod.showModal({
          content: '请填写退款方式'
        });
        return;
      }
      if (_this.data.refund_price <= 0) {
        _app.appMethod.showModal({
          content: '退款金额有误'
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/applyRefund',
        method: 'post',
        data: {
          sub_shop_app_id: _this.franchiseeId,
          apply_id: _this.applyRefundId,
          order_id: _this.orderId,
          refund_price: _this.data.refundPrice,
          refund_goods: _this.refundGoods,
          refund_type: _this.data.typeIndex,
          refund_reason: _this.data.reasonIndex,
          refund_mode: _this.data.wayIndex,
          description: _this.data.refundDes.replace(/\n|\r\n/g, '<br />'),
          img_url: _this.data.imagesArr
        },
        success: function success(res) {
          if (_this.origin == 'apply') {
            _app.appMethod.turnBack({
              delta: 2
            });
          } else {
            _app.appMethod.turnBack();
          }
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.closeMask = function () {
      _this2.setData({
        isShowInstructionMask: false
      });
    };

    _this2.checkInstruction = function () {
      _this2.setData({
        isShowInstructionMask: true
      });
    };

    _this2.hidePaymentInstruct = function () {
      _this2.setData({
        isShowPayInstruct: false
      });
    };

    _this2.getRefundConfigByPickUpType = function (type) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
        data: {
          sub_shop_app_id: _this.franchiseeId,
          pick_up_type: type
        },
        success: function success(res) {
          var data = res.data.config_data;
          _this.setData({
            refundWithGoods: data.refund_with_goods,
            isFullRefund: data.is_full_refund,
            refundTobalance: data.refund_to_balance,
            contactPhone: data.address ? data.address.phone : ''
          });
        }
      });
    };

    _this2.getBuyerCancelReason = function (type) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getBuyerCancelReason',
        data: {
          deliver_type: type
        },
        success: function success(res) {
          var data = res.data;
          var refundJourneyReasonData = [];
          for (var i in data) {
            refundJourneyReasonData.push({
              title: data[i]
            });
          }
          _this.setData({
            refundJourneyReasonData: refundJourneyReasonData
          });
        }
      });
    };

    document.title = '申请退款';
    return _this2;
  }

  (0, _createClass3.default)(GoodsRefundPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
      this.franchiseeId = options.franchisee || '';
      this.origin = options.type;
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          storeStyle = _state.storeStyle,
          pickUpType = _state.pickUpType,
          isShowPayInstruct = _state.isShowPayInstruct,
          goodsList = _state.goodsList,
          is_group_buy_order = _state.is_group_buy_order,
          typeIndex = _state.typeIndex,
          refundTypeData = _state.refundTypeData,
          reasonIndex = _state.reasonIndex,
          refundJourneyReasonData = _state.refundJourneyReasonData,
          refundReasonData = _state.refundReasonData,
          wayIndex = _state.wayIndex,
          refundWayData = _state.refundWayData,
          refundPrice = _state.refundPrice,
          showRefundType = _state.showRefundType,
          showRefundReason = _state.showRefundReason,
          showRefundWay = _state.showRefundWay,
          maxRefundPrice = _state.maxRefundPrice,
          express = _state.express,
          refundDes = _state.refundDes,
          isShowInstructionMask = _state.isShowInstructionMask,
          imagesArr = _state.imagesArr,
          refundWithGoods = _state.refundWithGoods,
          orderInfoStatus = _state.orderInfoStatus,
          orignalStatus = _state.orignalStatus,
          deliveryStatus = _state.deliveryStatus,
          sameCity = _state.sameCity,
          refundTobalance = _state.refundTobalance,
          contactPhone = _state.contactPhone;


      return React.createElement(
        'div',
        { className: 'official-page goods-refund-page' },
        React.createElement(_TopNav.TopNav, { title: '\u7533\u8BF7\u9000\u6B3E' }),
        pickUpType == 2 && isShowPayInstruct && React.createElement(
          'div',
          {
            className: 'payment-instructions',
            style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '1A;' + 'color:' + storeStyle.theme)
          },
          React.createElement('span', {
            onClick: this.hidePaymentInstruct,
            className: 'ico-moon icon-closes'
          }),
          React.createElement(
            'span',
            null,
            '\u8D54\u4ED8\u8BF4\u660E'
          ),
          React.createElement(
            'span',
            {
              className: 'pull-right check-instructions',
              style: (0, _tools.convertLineStyleData)('border-color:' + storeStyle.theme),
              onClick: this.checkInstruction
            },
            '\u7ACB\u5373\u67E5\u770B'
          )
        ),
        React.createElement(
          'div',
          { className: 'refund-box' },
          goodsList.map(function (goods, index) {
            return React.createElement(
              'div',
              { className: 'goods-detail-box', key: goods.goods_id },
              React.createElement('img', { src: goods.cover }),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'goods-name' },
                  is_group_buy_order != 0 && React.createElement(
                    'span',
                    { className: 'is-seckill' },
                    '\u62FC\u56E2'
                  ),
                  goods.is_seckill == 1 && React.createElement(
                    'span',
                    { className: 'is-seckill' },
                    '\u79D2\u6740'
                  ),
                  goods.is_vip_goods == 1 && React.createElement(
                    'span',
                    { className: 'is-seckill' },
                    '\u4F1A\u5458\u4EF7'
                  ),
                  goods.goods_name
                ),
                goods.model_value && React.createElement(
                  'div',
                  { className: 'goods-rules' },
                  goods.model_value
                ),
                React.createElement(
                  'div',
                  { className: 'goods-price' },
                  goods.use_integral == 0 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'colorff7',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      '¥' + goods.price
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    (goods.price != '0.00' || !goods.use_integral || goods.use_integral == 0) && React.createElement(
                      'span',
                      {
                        className: 'colorff7',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      '¥' + goods.price
                    ),
                    goods.use_integral && goods.use_integral != 0 && goods.price != '0.00' && React.createElement(
                      'span',
                      {
                        className: 'colorff7',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      '+'
                    ),
                    goods.use_integral && React.createElement(
                      'span',
                      {
                        className: 'colorff7',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      goods.use_integral + '积分'
                    )
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    'x ' + goods.preview_refund_num
                  )
                )
              )
            );
          }),
          React.createElement(
            'div',
            { className: 'type-reason-way' },
            React.createElement(
              'div',
              { onClick: this.showRefundBox, 'data-type': 'type' },
              React.createElement(
                'span',
                { className: 'type-reason-way-title' },
                '\u9000\u6B3E\u7C7B\u578B'
              ),
              React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
              React.createElement(
                'span',
                {
                  className: 'pull-right select-reason ' + (typeIndex !== '' ? 'select' : '')
                },
                refundTypeData[typeIndex] && refundTypeData[typeIndex].title || '请选择'
              )
            ),
            React.createElement(
              'div',
              { onClick: this.showRefundBox, 'data-type': 'reason' },
              React.createElement(
                'span',
                { className: 'type-reason-way-title' },
                '\u9000\u6B3E\u539F\u56E0'
              ),
              React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
              React.createElement(
                'span',
                {
                  className: 'pull-right select-reason ' + (reasonIndex !== '' ? 'select' : '')
                },
                (pickUpType == 2 ? refundJourneyReasonData[reasonIndex] && refundJourneyReasonData[reasonIndex].title : refundReasonData[reasonIndex] && refundReasonData[reasonIndex].title) || '请选择退款原因'
              )
            ),
            React.createElement(
              'div',
              { onClick: this.showRefundBox, 'data-type': 'way' },
              React.createElement(
                'span',
                { className: 'type-reason-way-title' },
                '\u9000\u6B3E\u65B9\u5F0F'
              ),
              React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
              React.createElement(
                'span',
                {
                  className: 'pull-right select-reason ' + (wayIndex !== '' ? 'select' : '')
                },
                refundWayData[wayIndex] && refundWayData[wayIndex].title || '请选择退款方式'
              ),
              wayIndex == 1 && React.createElement(
                'div',
                { className: 'storage-tip' },
                '\u6CE8\uFF1A\u50A8\u503C\u91D1\u4E0D\u4F1A\u8DDF\u7740\u9000\u6B3E\u4E00\u8D77\u9000\u56DE\uFF0C\u5728\u5546\u5BB6\u540C\u610F\u9000\u6B3E\u540E\uFF0C\u8FD8\u9700\u7528\u6237\u70B9\u51FB\u201C\u786E\u8BA4\u9000\u6B3E\u201D\uFF0C\u624D\u4F1A\u9000\u56DE\u3002'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'refund-price-box' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'refund-price-title' },
                '\u9000\u6B3E\u91D1\u989D'
              ),
              typeIndex != 1 && React.createElement(
                'span',
                {
                  className: 'pull-right refund-price',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '¥' + refundPrice
              ),
              typeIndex == 1 && showRefundType && showRefundReason && showRefundWay && React.createElement('input', {
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                className: 'pull-right refund-price-input',
                type: 'digit',
                value: refundPrice,
                onChange: this.changeRefundPrice
              })
            ),
            React.createElement(
              'div',
              { className: 'refund-price-detail' },
              '最多退¥' + maxRefundPrice + '，含配送费¥' + express + '元'
            ),
            wayIndex == 1 && React.createElement(
              'div',
              { className: 'refund-price-detail' },
              '最终退款储值金额 ¥' + refundPrice + '元'
            )
          ),
          React.createElement(
            'div',
            { className: 'refund-instruct' },
            !isShowInstructionMask && React.createElement(
              'div',
              { className: 'refund-instruct-title' },
              React.createElement(
                'span',
                { className: 'refund-instruct-label' },
                '\u9000\u6B3E\u8BF4\u660E'
              ),
              showRefundType && showRefundReason && showRefundWay && React.createElement('input', {
                className: 'refund-instruct-input',
                type: 'text',
                value: refundDes,
                onChange: this.inputRefundDes,
                placeholder: '\u9009\u586B'
              })
            ),
            React.createElement(
              'div',
              { className: 'images-box' },
              imagesArr.map(function (item, index) {
                return React.createElement(
                  'div',
                  { key: index },
                  React.createElement('span', {
                    className: 'delete-image ico-moon icon-closes',
                    onClick: _this3.deleteImage,
                    'data-index': index
                  }),
                  React.createElement('img', {
                    src: item,
                    'data-index': index,
                    onClick: _this3.previewImage
                  })
                );
              }),
              imagesArr.length < 8 && React.createElement(
                'div',
                { className: 'add-images', onClick: this.chooseImage },
                React.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                React.createElement(
                  'div',
                  null,
                  '\u6DFB\u52A0\u56FE\u7247'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'images-length' },
              imagesArr.length + '/8'
            )
          ),
          React.createElement(
            'div',
            { className: 'refund-bottom' },
            React.createElement(
              'div',
              { className: 'refund-cancel', onClick: this.cancelRefund },
              '\u53D6\u6D88'
            ),
            React.createElement(
              'div',
              {
                className: 'refund-submit',
                onClick: this.sureRefund,
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              '\u63D0\u4EA4'
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'refund-type-mask',
            onClick: this.closeRefundBox,
            hidden: showRefundType
          },
          React.createElement(
            'div',
            { className: 'refund-type-box', onClick: this.stopPropagation },
            React.createElement(
              'div',
              { className: 'refund-type-title' },
              '\u9000\u6B3E\u7C7B\u578B'
            ),
            React.createElement(
              'div',
              { className: 'refund-type-menu' },
              refundTypeData.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    {
                      hidden: (refundWithGoods == 0 || orderInfoStatus == 1 || orignalStatus == 1 || deliveryStatus == 3 || pickUpType == 3) && index == 2 && !sameCity,
                      className: 'refund-type-list',
                      onClick: _this3.selectReason,
                      'data-index': index,
                      'data-type': 'type'
                    },
                    React.createElement(
                      'span',
                      {
                        style: (0, _tools.convertLineStyleData)(typeIndex === index ? 'color:' + storeStyle.theme : ''),
                        className: typeIndex === index ? 'select' : ''
                      },
                      item.title
                    ),
                    React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
                  )
                );
              })
            ),
            React.createElement(
              'div',
              {
                className: 'refund-type-close',
                onClick: this.closeRefundBox,
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              '\u5173\u95ED'
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'refund-type-mask',
            onClick: this.closeRefundBox,
            hidden: showRefundReason
          },
          React.createElement(
            'div',
            { className: 'refund-type-box', onClick: this.stopPropagation },
            React.createElement(
              'div',
              { className: 'refund-type-title' },
              '\u9000\u6B3E\u539F\u56E0'
            ),
            React.createElement(
              'div',
              { className: 'refund-type-menu' },
              (pickUpType == 2 ? refundJourneyReasonData : refundReasonData).map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    key: index,
                    className: 'refund-type-list',
                    onClick: _this3.selectReason,
                    'data-index': index,
                    'data-type': 'reason'
                  },
                  React.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)(reasonIndex === index ? 'color:' + storeStyle.theme : ''),
                      className: reasonIndex === index ? 'select' : ''
                    },
                    item.title
                  ),
                  React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'refund-reason-close' },
              React.createElement(
                'span',
                {
                  className: 'pre-btn',
                  onClick: this.prevRefundBox,
                  'data-type': 'reason'
                },
                '\u4E0A\u4E00\u6B65'
              ),
              React.createElement(
                'span',
                {
                  className: 'close-btn',
                  onClick: this.closeRefundBox,
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                },
                '\u5173\u95ED'
              )
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'refund-type-mask',
            onClick: this.closeRefundBox,
            hidden: showRefundWay
          },
          React.createElement(
            'div',
            { className: 'refund-type-box', onClick: this.stopPropagation },
            React.createElement(
              'div',
              { className: 'refund-type-title' },
              '\u9000\u6B3E\u65B9\u5F0F'
            ),
            React.createElement(
              'div',
              { className: 'refund-type-menu' },
              refundWayData.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    {
                      hidden: refundTobalance == 0 && index == 1,
                      className: 'refund-type-list',
                      onClick: _this3.selectReason,
                      'data-index': index,
                      'data-type': 'way'
                    },
                    React.createElement(
                      'span',
                      {
                        style: (0, _tools.convertLineStyleData)(wayIndex === index ? 'color:' + storeStyle.theme : ''),
                        className: wayIndex === index ? 'select' : ''
                      },
                      item.title
                    ),
                    React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'refund-reason-close' },
              React.createElement(
                'span',
                {
                  className: 'pre-btn',
                  onClick: this.prevRefundBox,
                  'data-type': 'way'
                },
                '\u4E0A\u4E00\u6B65'
              ),
              React.createElement(
                'span',
                {
                  className: 'close-btn',
                  onClick: this.closeRefundBox,
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                },
                '\u5173\u95ED'
              )
            )
          )
        ),
        isShowInstructionMask && React.createElement(
          'div',
          { className: 'payment-instructions-mask' },
          React.createElement(
            'div',
            { className: 'payment-instructions-box' },
            React.createElement(
              'div',
              { className: 'title' },
              '\u8D54\u4ED8\u8BF4\u660E'
            ),
            React.createElement(
              'div',
              null,
              '1.\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u5B9A\u4F4D\u9A91\u624B\u8FD8\u662F\u5546\u5BB6\u95EE\u9898\uFF0C\u5FC5\u8981\u65F6\u4E0A\u4F20\u4EA7\u54C1\u8BE6\u60C5\u7167\u72471-3\u5F20'
            ),
            React.createElement(
              'div',
              null,
              '2.\u6D41\u7A0B\uFF1A\u6295\u8BC9\u540E\u5546\u5BB6\u5C06\u4F1A\u6536\u5230\u60A8\u7684\u53CD\u9988\uFF0C\u5E76\u5728',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                '1-3'
              ),
              '\u4E2A\u5DE5\u4F5C\u65E5\u5185\u5BF9\u63D0\u4EA4\u7684\u5185\u5BB9\u8FDB\u884C\u5BA1\u6838\uFF0C\u5BA1\u6838\u65E0\u8BEF\u5C06\u4F1A\u8D54\u4ED8\u91D1\u989D\u5230\u60A8\u7684\u50A8\u503C\u8D26\u6237\u4E2D'
            ),
            React.createElement(
              'div',
              null,
              '3.\u6700\u9AD8\u8D54\u4ED8',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                maxRefundPrice
              ),
              '\u5143'
            ),
            contactPhone && refundWithGoods == 1 && React.createElement(
              'div',
              null,
              '4.\u82E5\u957F\u65F6\u95F4\u672A\u5904\u7406\uFF0C\u53EF\u62E8\u6253\u70ED\u7EBF\u7535\u8BDD',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                contactPhone
              )
            ),
            React.createElement(
              'div',
              {
                className: 'known-btn',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                onClick: this.closeMask
              },
              '\u77E5\u9053\u4E86'
            )
          )
        )
      );
    }
  }]);
  return GoodsRefundPage;
}(_OfficialPage3.default);

exports.default = GoodsRefundPage;

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _tools = __webpack_require__(6);

var _MemberDiscount = __webpack_require__(66);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(435);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateTrans = {
  date: function date(a) {
    var reg = new RegExp("-", "img");
    var c = a.replace(reg, '月') + '日';
    return c;
  },
  week: function week(a) {
    switch (a) {
      case '0':
        return '日';
      case '1':
        return '一';
      case '2':
        return '二';
      case '3':
        return '三';
      case '4':
        return '四';
      case '5':
        return '五';
      case '6':
        return '六';
    }
  }
};

// 可兑换券底部弹窗
var ExchangeCouponUseDialogTmpl = function ExchangeCouponUseDialogTmpl(options) {
  var data = options.data,
      self = options.self;
  var dialogHidden = data.dialogHidden,
      selectModelInfo = data.selectModelInfo,
      goodsInfo = data.goodsInfo,
      model = data.model,
      modelIndex = data.modelIndex,
      index = data.index,
      name = data.name;


  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'page-dialog-wrap', hidden: dialogHidden },
      _react2.default.createElement(
        'div',
        { className: 'page-bottom-dialog' },
        _react2.default.createElement(
          'div',
          { className: 'page-bottom-content' },
          _react2.default.createElement(
            'div',
            {
              className: 'pay-close-dialog page-dialog-close',
              onClick: self.exchangeCouponHideDialog
            },
            '\xD7'
          ),
          _react2.default.createElement(
            'div',
            { className: 'dialog-block-item' },
            _react2.default.createElement(
              'div',
              { className: 'thumb' },
              _react2.default.createElement(
                'div',
                { className: 'thumb-wrap' },
                _react2.default.createElement('img', {
                  className: 'pay-goods-cover',
                  src: selectModelInfo && selectModelInfo.imgurl || goodsInfo && goodsInfo.cover
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pay-goods-baseinfo' },
              _react2.default.createElement(
                'div',
                { className: 'pay-goods-title ellipsis' },
                _react2.default.createElement(
                  'span',
                  { className: 'gift-text' },
                  '\u8D60\u54C1'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'gift-title' },
                  goodsInfo && goodsInfo.title
                )
              ),
              selectModelInfo && selectModelInfo.models_text && _react2.default.createElement(
                'div',
                { className: 'pay-checked-text clearfix ellipsis' },
                '已选：' + selectModelInfo.models_text
              ),
              _react2.default.createElement(
                'span',
                { className: 'gift-price' },
                '¥' + (selectModelInfo && selectModelInfo.price)
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'exchange-rules-box' },
            _react2.default.createElement(
              'div',
              { className: 'pay-goods-models' },
              goodsInfo && goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                return _react2.default.createElement(
                  'div',
                  { key: modelIndex },
                  _react2.default.createElement(
                    'span',
                    { className: 'model-title' },
                    model.name
                  ),
                  _react2.default.createElement(
                    'label',
                    { className: 'pills-list' },
                    model.subModelName.map(function (name, index) {
                      return _react2.default.createElement(
                        'label',
                        {
                          key: index,
                          'data-model-index': modelIndex,
                          'data-submodel-index': index,
                          className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                          'data-submodel-id': model.subModelId[index],
                          onClick: self.exchangeCouponSelectSubModel
                        },
                        name
                      );
                    })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'confirm-goods',
              onClick: self.exchangeCouponConfirmGoods
            },
            '\u786E\u8BA4'
          )
        )
      )
    )
  );
};

var PreviewGoodsOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewGoodsOrder, _OfficialPage);

  function PreviewGoodsOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewGoodsOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewGoodsOrder.__proto__ || Object.getPrototypeOf(PreviewGoodsOrder)).call(this, props));

    _this2.state = {
      customNumArr: Array.from(new Array(101).keys()).slice(1),
      take_meal_type_index: 0,
      take_meal_type_arr: [],
      take_meal_type_text: ['', '送餐到桌', '前台自取'],
      dining_mode_arr: [{ label: '堂食', value: '1' }, { label: '打包', value: '2' }],
      take_meal_type: 1,
      people_num: 1,
      dining_mode: 1,
      is_addDishing: false,
      only_me: false,
      goodsList: [],
      selectAddress: '',
      discountList: [],
      selectDiscountInfo: {},
      orderRemark: '',
      express_fee: '',
      balance: '',
      useBalance: true,
      deduction: '',
      discount_cut_price: '',
      original_price: '',
      totalPayment: '',
      storeConfig: '',
      noAdditionalInfo: true,
      is_group: '',
      limit_buy: '',
      teamToken: '',
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      cashOnDelivery: false,
      selectDelivery: '',
      hasRequiredSuppInfo: false,
      additional_info: {},
      showPickMask: false,
      pickUpType: '',
      isShowSameJourneyTime: false,
      expressAddressNull: false,
      goodsIcon: {
        1: 'icon-goods-express-model',
        2: 'icon-goods-city-model',
        3: 'icon-goods-delivery-model',
        4: 'icon-goods-store-model'
      },
      leagueBenefitData: {
        benefitList: [], // 联盟优惠
        selectedBenefitInfo: {}, // 选中的联盟优惠
        benefitPrice: 0 // 联盟优惠价格
      },
      mulShopsInfo: {}, // 多店的信息
      storeStyle: {}
    };
    _this2.is_reload = true;
    _this2.timerId = 0;
    _this2.isFromSelectAddress = false;
    _this2.franchisee_id = '';
    _this2.cart_id_arr = [];
    _this2.cart_id_arr_my = [];
    _this2.cart_data_arr = [];
    _this2.requesting = false;
    _this2.is_group = '';
    _this2.inputTimer = '';
    _this2.isFranchisee = false;
    _this2.mulShopsParams = [];
    _this2.memberDiscountRef = _react2.default.createRef();

    _this2.getDiningData = function () {
      if (_this2.data.ec_location_id) {
        _this2.scanInitUserInfo('', _this2.data.ec_location_id, _this2.checkIsAddDishing);
      } else {
        _this2.getCalculationInfo();
      }
    };

    _this2.dataInitial = function () {
      _this2.getAppECStoreConfig();
      _this2.getCartList(function () {
        _this2.selectPickMethod('first');
      });
    };

    _this2.getCartList = function (callback) {
      var _this = _this2,
          franchisee_id = _this2.franchisee_id;
      _this.cart_id_arr_my = [];
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: _this.isFranchisee ? '' : franchisee_id,
          parent_shop_app_id: franchisee_id || _this.isFranchisee ? _app.appMethod.globalData.appId : '',
          is_app_shop: _this.isFranchisee ? 1 : 0
        },
        success: function success(res) {
          var data = [];
          var setDataObj = {};
          if (_this.cart_id_arr.length) {
            for (var i = 0; i <= res.data.length - 1; i++) {
              if (_this.cart_id_arr.indexOf(res.data[i].id) >= 0) {
                data.push(res.data[i]);
              }
            }
            if (_this.isFranchisee) {
              var shopsArr = [];
              res.appShopData.forEach(function (shop) {
                shop.cartList = shop.cartList.filter(function (cart) {
                  return _this.cart_id_arr.indexOf(cart.id) >= 0;
                });
              });
              shopsArr = res.appShopData.filter(function (shop) {
                return shop.cartList.length;
              });
              setDataObj['shopsList'] = shopsArr;
            }
          } else {
            data = res.data;
          }
          for (var i = 0; i <= data.length - 1; i++) {
            var goods = data[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? modelArr.join('； ') : '';
            _this.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
            _this.cart_id_arr_my.push(goods.id);
          }
          setDataObj['only_me'] = true;
          setDataObj['goodsList'] = data;
          _this.setData(setDataObj);
          typeof callback == 'function' && callback();
        }
      });
    };

    _this2.getCalculationInfo = function (callback) {
      if (_this2.isFranchisee) {
        // 多店
        _this2.getMulCalculationInfo();
        return;
      }
      var _this = _this2;
      var ecommerce_info = {};
      if (_this2.data.pickUpType == 4) {
        ecommerce_info = {
          ec_dining_data: {
            ordering_food_type: 1, // 点餐方式
            dining_mode: _this.data.dining_mode, // 就餐方式
            people_num: _this.data.people_num, // 就餐人数
            take_meal_type: _this.data.take_meal_type, // 取餐类型
            location_id: _this.data.ec_location_id, // 座位号码
            account_type: _this.data.account_type // 结账方式
          }
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          ecommerce_info: ecommerce_info,
          sub_shop_app_id: _this2.franchisee_id,
          address_id: _this2.data.pickUpType == 4 ? '' : _this2.data.pickUpType == 1 ? _this2.data.selectAddressId : _this2.data.selectSameJourneyId,
          cart_id_arr: _this2.cart_id_arr,
          is_balance: _this2.data.useBalance ? 1 : 0,
          pick_up_type: _this2.data.pickUpType,
          selected_benefit: _this2.data.pickUpType == 4 && _this2.data.account_type == 2 ? '' : _this2.data.selectDiscountInfo,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info
        },
        success: function success(res) {
          var _this$setData;

          var info = res.data;
          var benefits = info.can_use_benefit;
          var goods_info = info.goods_info;
          var additional_info_goods = [];
          var selectDiscountInfo = info.selected_benefit_info;
          var suppInfoArr = [];
          var additional_goodsid_arr = [];
          if (info.dining_status_data && _this.data.pickUpTypeArr.length == 1 && _this.data.pickUpType == 4) {
            var dining_in_business = info.dining_status_data.in_business_time == 0 ? false : true;
            if (!dining_in_business) {
              _app.appMethod.showModal({
                content: '店铺不在营业时间内',
                confirmText: '知道了',
                confirm: function confirm() {
                  _app.appMethod.turnBack();
                }
              });
            }
          }
          if (_this.data.pickUpType == 2 && info.intra_city_status_data) {
            if (info.intra_city_status_data.in_distance == 0) {
              _app.appMethod.showModal({
                content: '地址不在配送范围内',
                confirmText: '去更换',
                showCancel: true,
                confirm: function confirm() {
                  _this.goSameJourneyAddress();
                },
                cancel: function cancel() {
                  _this.setData({
                    selectSameJourney: ''
                  });
                }
              });
            } else if (info.intra_city_status_data.in_business_time == 0) {
              _app.appMethod.showModal({
                content: '店铺歇业中，请更换其他配送方式',
                confirmText: '去更换',
                confirm: function confirm() {
                  _this.setData({
                    isShowPickMask: true
                  });
                }
              });
            }
          }
          var goodsBenefitsData = [];
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          });
          if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && _this.data.exchangeCouponData.hasSelectGoods == false) {
            _this.exchangeCouponInit(parseInt(selectDiscountInfo.value));
          }
          for (var i = 0; i <= goods_info.length - 1; i++) {
            if (_this.data.pickUpType == 4) {
              (function () {
                var goodsList = _this.data.goodsList.length ? _this.data.goodsList : info.goods_info;
                var goodsIdArr = [];
                goodsList.forEach(function (item, index) {
                  goodsIdArr.push(item.goods_id);
                });
                goods_info.forEach(function (item, index) {
                  item.forEach(function (subItem) {
                    subItem.goods_list.forEach(function (childItem) {
                      if (childItem.delivery_id && childItem.delivery_id != 0 && additional_goodsid_arr.indexOf(childItem.goods_id) == -1 && goodsIdArr.indexOf(childItem.goods_id) > -1) {
                        suppInfoArr.push(childItem.delivery_id);
                        additional_goodsid_arr.push(childItem.goods_id);
                        additional_info_goods.push(childItem);
                      }
                    });
                  });
                });
              })();
            } else if (goods_info[i].delivery_id && goods_info[i].delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info[i].id) == -1) {
              suppInfoArr.push(goods_info[i].delivery_id);
              additional_goodsid_arr.push(goods_info[i].id);
              additional_info_goods.push(goods_info[i]);
            }
          }
          if (suppInfoArr.length && !_this.data.deliverydWrite) {
            _this.getSuppInfo(suppInfoArr);
          }
          if (_this.data.pickUpType == 4) {
            var buyer_list = _this.data.buyer_list || info.buyer_list;
            var goodsList = _this.data.goodsList.length ? _this.data.goodsList : info.goods_info;
            var my_self = _this.data.my_self || '';
            buyer_list.forEach(function (item, index) {
              if (item.buyer_id == my_self && buyer_list.length > 1) {
                buyer_list.splice(index, 1);
                buyer_list.unshift(item);
              }
              var sum = 0;
              goodsList.forEach(function (subItem) {
                if (item.buyer_id == subItem.buyer_id) {
                  sum += +subItem.num;
                  item.num = sum;
                }
              });
            });
            _this.setData({
              buyer_list: buyer_list
            });
          }
          var vip_goods_list = [];
          var vip_cart_info = {};
          if (_this.data.pickUpType == 4) {
            var _goodsList = _this.data.goodsList.length ? _this.data.goodsList : info.goods_info;
            _goodsList.forEach(function (item, index) {
              if (item.cart_vip_goods === 1) {
                vip_goods_list.push(item);
              }
            });
            _this.data.buyer_list.forEach(function (item) {
              if (item.buyer_id === info.dining_vip_card_info.user_token) {
                vip_cart_info = item;
                vip_cart_info.title = info.dining_vip_card_info.title;
              }
            });
          }
          _this.setData((_this$setData = {
            people_num: info.people_num,
            expressAddressNull: info.address ? false : _this.data.expressAddressNull,
            selectAddress: _this.data.pickUpType == 1 && info.address,
            selectSameJourney: _this.data.pickUpType == 2 && info.address,
            discountList: goodsBenefitsData,
            selectDiscountInfo: selectDiscountInfo,
            box_fee: info.box_fee,
            server_fee: info.server_fee,
            tissue_fee: info.tissue_fee,
            express_fee: info.express_fee,
            discount_cut_price: info.discount_cut_price,
            vip_cut_price: info.vip_cut_price,
            is_vip_goods: info.goods_info[0].is_vip_goods,
            is_vip_order: info.is_vip_order
          }, (0, _defineProperty3.default)(_this$setData, 'vip_cut_price', info.vip_cut_price), (0, _defineProperty3.default)(_this$setData, 'balance', info.balance), (0, _defineProperty3.default)(_this$setData, 'deduction', info.use_balance), (0, _defineProperty3.default)(_this$setData, 'original_price', info.is_vip_order == 1 ? info.total_original_price : info.original_price), (0, _defineProperty3.default)(_this$setData, 'totalPayment', info.price), (0, _defineProperty3.default)(_this$setData, 'canCashDelivery', info.is_pay_on_delivery), (0, _defineProperty3.default)(_this$setData, 'cashOnDelivery', info.price > 0 ? _this.data.cashOnDelivery : false), (0, _defineProperty3.default)(_this$setData, 'selfPayOnDelivery', info.self_pay_on_delivery), (0, _defineProperty3.default)(_this$setData, 'additional_goodsid_arr', additional_goodsid_arr), (0, _defineProperty3.default)(_this$setData, 'sameJourneyImmediatlyTime', info.intra_city_status_data && info.intra_city_status_data.deliver_time), (0, _defineProperty3.default)(_this$setData, 'vip_goods_list', vip_goods_list), (0, _defineProperty3.default)(_this$setData, 'vip_cart_info', vip_cart_info), (0, _defineProperty3.default)(_this$setData, 'total_discount_cut_price', info.total_discount_cut_price), _this$setData));
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
        },
        successStatusAbnormal: function successStatusAbnormal(re) {
          if (re.data == '商品不能混合下单') {
            _app.appMethod.showModal({
              content: re.data,
              confirmText: '知道了',
              confirm: function confirm(backdata) {
                _app.appMethod.turnBack();
              }
            });
            return false;
          }
          if (re.stop_loop) {
            clearTimeout(_this.timerId);
          }
        }
      });
    };

    _this2.getMulCalculationInfo = function () {
      var _this = _this2;
      var _this2$data = _this2.data,
          pickUpType = _this2$data.pickUpType,
          mulShopsInfo = _this2$data.mulShopsInfo,
          shopsList = _this2$data.shopsList,
          leagueBenefitData = _this2$data.leagueBenefitData,
          selectAddressId = _this2$data.selectAddressId,
          selectSameJourneyId = _this2$data.selectSameJourneyId;

      var mulShopsParams = {};
      var selectedBenefitInfo = leagueBenefitData.selectedBenefitInfo;
      if (selectedBenefitInfo && selectedBenefitInfo.no_use_benefit && selectedBenefitInfo.flag == false) {
        selectedBenefitInfo = '';
      }
      mulShopsParams = shopsList.map(function (shopItem) {
        var shopAppId = shopItem.app_id;
        var addressId = pickUpType == 1 ? selectAddressId || '' : selectSameJourneyId || '';
        var selectedBenefit = mulShopsInfo[shopAppId] && mulShopsInfo[shopAppId].selectDiscountInfo || '';
        var voucherCoupon = mulShopsInfo[shopAppId] && mulShopsInfo[shopAppId].exchangeCouponData && mulShopsInfo[shopAppId].exchangeCouponData.voucher_coupon_goods_info || '';
        var useBalance = shopAppId == _app.appMethod.getAppId() ? mulShopsInfo[shopAppId] && mulShopsInfo[shopAppId].useBalance : 0;
        var cashOnDelivery = mulShopsInfo[shopAppId] && mulShopsInfo[shopAppId].cashOnDelivery || 0;
        return {
          sub_shop_app_id: shopAppId,
          address_id: addressId,
          is_balance: useBalance == undefined ? 1 : useBalance ? 1 : 0,
          pick_up_type: pickUpType,
          selected_benefit: selectedBenefit,
          voucher_coupon_goods_info: voucherCoupon,
          cart_id_arr: shopItem.cartList.map(function (cart) {
            return cart.id;
          }),
          is_pay_on_delivery: cashOnDelivery
        };
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/MultiCalculationPrice',
        method: 'post',
        data: {
          multi_superimposed: 1,
          extra_selected_benefit: selectedBenefitInfo || '',
          multi_app_shops: mulShopsParams
        },
        success: function success(res) {
          var returnData = res.data;
          var shopsList = returnData.appData;
          var mulShopsInfo = _this.data.mulShopsInfo;

          Object.keys(shopsList).forEach(function (key) {
            var _this$setData3;

            var shop = shopsList[key];
            var benefits = shop.can_use_benefit;
            var selectDiscountInfo = shop.selected_benefit_info;
            if (pickUpType == 2 && shop.intra_city_status_data && shop.intra_city_status_data.in_distance == 0) {
              _app.appMethod.showModal({
                content: '地址不在配送范围内',
                confirmText: '去更换',
                showCancel: true,
                confirm: function confirm() {
                  _this.goSameJourneyAddress();
                },
                cancel: function cancel() {
                  _this.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + key + '.selectSameJourney', ''));
                }
              });
            }
            var goodsBenefitsData = [];
            benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
              label: 'coupon',
              value: benefits.coupon_benefit
            }) : '';
            benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
              label: 'vip',
              value: benefits.all_vip_benefit
            }) : '';
            Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
              label: 'integral',
              value: [benefits.integral_benefit]
            });
            if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && _this.data.exchangeCouponData.hasSelectGoods == false) {
              _this.exchangeCouponInit(parseInt(selectDiscountInfo.value));
            }
            var sameJourneyTimeType = mulShopsInfo[key] && mulShopsInfo[key].sameJourneyTimeType;
            var phone = mulShopsInfo[key] && mulShopsInfo[key].phone;
            _this.setData((_this$setData3 = {}, (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.discountList', goodsBenefitsData), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.selectDiscountInfo', selectDiscountInfo), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.box_fee', shop.box_fee), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.express_fee', shop.express_fee), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.discount_cut_price', shop.discount_cut_price), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.vip_cut_price', shop.vip_cut_price || ''), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.price', shop.price), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.is_vip_goods', shop.goods_info[0].is_vip_goods || ''), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.balance', shop.balance), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.deduction', shop.use_balance), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.original_price', shop.original_price), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.canCashDelivery', shop.is_pay_on_delivery), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.selfPayOnDelivery', shop.price > 0 ? shop.self_pay_on_delivery : false), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.sameJourneyImmediatlyTime', shop.intra_city_status_data && shop.intra_city_status_data.deliver_time), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.sameJourneyTimeType', sameJourneyTimeType ? sameJourneyTimeType : pickUpType == 2 ? 1 : ''), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.phone', phone ? phone : _app.appMethod.getUserInfo().phone), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.exchangeCouponData', {
              dialogHidden: true,
              goodsInfo: {},
              selectModelInfo: {},
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            }), (0, _defineProperty3.default)(_this$setData3, 'mulShopsInfo.' + key + '.useBalance', shop.use_balance), _this$setData3));
          });
          var leagueBenefitsData = [];
          var leagueBenefits = returnData.extra_can_use_benefit;
          leagueBenefits.coupon_benefit && leagueBenefits.coupon_benefit.length ? leagueBenefitsData.push({
            label: 'coupon',
            value: leagueBenefits.coupon_benefit
          }) : '';
          _this.setData({
            mulShopsInfo: mulShopsInfo,
            expressAddressNull: returnData.address ? false : _this.data.expressAddressNull, // 是否有快递地址
            selectAddress: pickUpType == 1 && returnData.address, // 快递地址
            selectSameJourney: pickUpType == 2 && returnData.address, // 同城地址
            'leagueBenefitData.benefitList': leagueBenefitsData,
            'leagueBenefitData.selectedBenefitInfo': returnData.extra_selected_benefit,
            'leagueBenefitData.benefitPrice': returnData.discount_cut_price,
            totalPayment: returnData.cart_total_price,
            payTotalPrice: returnData.pay_total_price || ''
          });
          if (pickUpType == 3) {
            _this.getSelfDeliveryList();
          }
          _this.getSuppInfo();
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeConfig: res,
          storeStyle: res.color_config
        });
      }, _this2.franchisee_id);
    };

    _this2.remarkInput = function (e) {
      var appId = e.currentTarget.dataset.appId;

      var setDataObj = {};
      if (appId) {
        // 多店
        setDataObj['mulShopsInfo.' + appId + '.orderRemark'] = e.target.value;
      } else {
        // 单店
        setDataObj['orderRemark'] = e.target.value;
      }
      _this2.setData(setDataObj);
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.clickMinusButton = function (e) {
      _this2.setSelectedGoodsInfo(e);
      if (+_this2.selectedGoodsInfo.num <= 0) return;
      _this2.changeGoodsNum(e, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      _this2.setSelectedGoodsInfo(e);
      if (_this2.data.limit_buy !== '' && +_this2.selectedGoodsInfo.num >= _this2.data.limit_buy) return;
      _this2.changeGoodsNum(e, 'plus');
    };

    _this2.inputGoodsCount = function (e) {
      _this2.setSelectedGoodsInfo(e);
      var value = +e.target.value;
      var index = e.target.dataset.index;
      if (isNaN(value) || value <= 0) {
        return;
      }
      clearTimeout(_this2.inputTimer);
      e.persist();
      _this2.inputTimer = setTimeout(function () {
        _this2.changeGoodsNum(e, value);
      }, 500);
    };

    _this2.changeGoodsNum = function (e, type) {
      var _e$currentTarget$data = e.currentTarget.dataset,
          index = _e$currentTarget$data.index,
          shopIndex = _e$currentTarget$data.shopIndex,
          isFranchisee = _e$currentTarget$data.isFranchisee;

      var goods = _this2.selectedGoodsInfo,
          currentNum = +goods.num,
          targetNum = type == 'plus' ? currentNum + 1 : type == 'minus' ? currentNum - 1 : Number(type),
          _this = _this2,
          data = {},
          param;
      if (targetNum == 0 && type == 'minus') {
        _app.appMethod.showModal({
          content: '确定从购物车删除该商品？',
          showCancel: true,
          confirm: function confirm() {
            if (isFranchisee) {
              data['shopsList[' + shopIndex + '].cartList[' + index + '].num'] = targetNum;
              data['mulShopsInfo.' + _this.selectedAppId + '.noAdditionalInfo'] = true;
              data['mulShopsInfo.' + _this.selectedAppId + '.aloneDeliveryShow'] = false;
            } else {
              _this.cart_data_arr[index].num = targetNum;
              data['goodsList[' + index + '].num'] = targetNum;
              data['noAdditionalInfo'] = true;
              data['aloneDeliveryShow'] = false;
            }
            _this.setData(data);
            _this.deleteGoods({ index: index, shopIndex: shopIndex, isFranchisee: isFranchisee });
          }
        });
        return;
      }
      param = {
        goods_id: goods.goods_id,
        model_id: goods.model_id || '',
        num: targetNum,
        sub_shop_app_id: isFranchisee ? _this.selectedAppId || _app.appMethod.getAppId() : _this.franchisee_id,
        is_seckill: goods.is_seckill == 1 ? 1 : '',
        location_id: _this2.data.pickUpType == 4 ? _this2.data.ec_location_id : '',
        cart_id: isFranchisee ? goods.id : _this2.cart_data_arr[index].cart_id
      };
      if (goods.form_data && goods.form_data.seckill_activity_id) {
        param.form_data = {};
        param.form_data.seckill_activity_id = goods.form_data.seckill_activity_id;
        param.form_data.seckill_activity_time_id = goods.form_data.seckill_activity_time_id;
      }
      if (_this2.data.is_group) {
        param.is_group_buy = _this2.data.is_group ? 1 : 0;
        param.num_of_group_buy_people = _this2.data.group_buy_people;
        param.team_token = _this2.data.teamToken;
      }
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        method: 'post',
        success: function success(res) {
          if (isFranchisee) {
            data['shopsList[' + shopIndex + '].cartList[' + index + '].num'] = targetNum;
            data['mulShopsInfo' + goods.app_id + '.selectedBenefitInfo'] = '';
            data['mulShopsInfo' + goods.app_id + '.exchangeCouponData'] = {
              dialogHidden: true,
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            };
          } else {
            _this.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            data.selectDiscountInfo = '';
            data.exchangeCouponData = {
              dialogHidden: true,
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            };
          }
          _this.setData(data);
          _this.getCalculationInfo();
        },
        fail: function fail(res) {
          data = {};
          if (isFranchisee) {
            data['shopsList[' + shopIndex + '].cartList[' + index + '].num'] = targetNum;
          } else {
            _this.cart_data_arr[index].num = currentNum;
            data['goodsList[' + index + '].num'] = targetNum;
          }
          _this.setData(data);
        }
      });
    };

    _this2.setSelectedGoodsInfo = function (e) {
      var _e$currentTarget$data2 = e.currentTarget.dataset,
          index = _e$currentTarget$data2.index,
          isFranchisee = _e$currentTarget$data2.isFranchisee,
          shopIndex = _e$currentTarget$data2.shopIndex,
          appId = _e$currentTarget$data2.appId;
      var _this2$data2 = _this2.data,
          goodsList = _this2$data2.goodsList,
          shopsList = _this2$data2.shopsList;

      _this2.selectedGoodsInfo = isFranchisee ? shopsList[shopIndex] && shopsList[shopIndex].cartList[index] : goodsList[index];
      _this2.selectedAppId = appId;
    };

    _this2.deleteGoods = function (params) {
      var index = params.index,
          isFranchisee = params.isFranchisee,
          shopIndex = params.shopIndex;

      var goodsList = _this2.data.goodsList,
          shopsList = _this2.data.shopsList,
          _this = _this2,
          listExcludeDelete,
          shopListExcludeDelete = [];
      var currentGoodsInfo = _this2.selectedGoodsInfo;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [isFranchisee ? currentGoodsInfo.id : _this2.cart_data_arr[index].cart_id],
          sub_shop_app_id: isFranchisee ? _this.selectedAppId || _app.appMethod.getAppId() : _this2.franchisee_id,
          location_id: _this2.data.ec_location_id
        },
        success: function success(res) {
          if (isFranchisee) {
            var _this$setData5;

            // 多商家多店
            shopListExcludeDelete = JSON.parse(JSON.stringify(shopsList));
            shopListExcludeDelete.map(function (shop) {
              shop.cartList = shop.cartList.filter(function (cart) {
                return cart.id != currentGoodsInfo.id;
              });
            });
            shopListExcludeDelete = shopListExcludeDelete.filter(function (shop) {
              return shop.cartList.length > 0;
            });
            if (shopListExcludeDelete.length == 0) {
              // 没有店铺
              _app.appMethod.turnBack();
              return;
            }
            var noSameCartId = true;
            var _mulShopsInfo = _this.data.mulShopsInfo;

            shopListExcludeDelete.forEach(function (shop) {
              noSameCartId = shop.cartList.some(function (cart) {
                return cart.id == currentGoodsInfo.id;
              });
            });
            if (noSameCartId && _mulShopsInfo[_this.selectedAppId].additional_info) {
              // 删除补充信息
              var newData = delete _mulShopsInfo[_this.selectedAppId].additional_info[currentGoodsInfo.id];
              _this.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + _this.selectedAppId + '.additional_info', newData));
            }
            _this.setData((_this$setData5 = {
              shopsList: shopListExcludeDelete
            }, (0, _defineProperty3.default)(_this$setData5, 'mulShopsInfo.' + _this.selectedAppId + '.selectDiscountInfo', ''), (0, _defineProperty3.default)(_this$setData5, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData', {
              dialogHidden: true,
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            }), _this$setData5));
          } else {
            ;(listExcludeDelete = goodsList.concat([])).splice(index, 1);
            if (listExcludeDelete.length == 0) {
              _app.appMethod.turnBack();
              return;
            }
            var deleteGoodsId = goodsList[index],
                noSameGoodsId = true;
            for (var i = listExcludeDelete.length - 1; i >= 0; i--) {
              if (listExcludeDelete[i].id == deleteGoodsId) {
                noSameGoodsId = false;
                break;
              }
            }
            if (noSameGoodsId && _this.data.additional_info) {
              var a = delete _this.data.additional_info[deleteGoodsId];
              _this.setData({
                additional_info: a
              });
            }
            if (_this.data.pickUpType == 4) {
              _this.data.buyer_list.forEach(function (item) {
                if (goodsList[index].buyer_id == item.buyer_id && item.num == 1) {
                  item.num = 0;
                }
              });
              _this.setData({
                buyer_list: _this.data.buyer_list
              });
            }
            _this.cart_data_arr.splice(index, 1);
            _this.setData({
              goodsList: listExcludeDelete,
              selectDiscountInfo: '',
              exchangeCouponData: {
                dialogHidden: true,
                hasSelectGoods: false,
                voucher_coupon_goods_info: {}
              }
            });
          }
          _this.getCalculationInfo();
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var _this = _this2,
          selected_benefit = _this2.data.selectDiscountInfo,
          tostoreOrderType = _this2.data.tostoreOrderType;
      if (_this2.data.pickUpType == 1 && !_this2.data.selectAddress) {
        _this2.setData({
          expressAddressNull: true
        });
        return;
      }
      if (_this2.data.pickUpType == 4 && _this2.data.location_status) {
        clearTimeout(_this2.timerId);
        if (!_this2.data.ec_location_id && _this2.data.take_meal_type == 1) {
          _app.appMethod.showModal({
            content: '请先扫码获取桌号！'
          });
          return;
        }
      }
      if (_this2.data.pickUpType == 2 && _this2.data.intraCityData.in_business_time == 0) {
        _app.appMethod.showModal({
          content: '店铺歇业中，请更换其他配送方式',
          confirmText: '去更换',
          confirm: function confirm() {
            _this.setData({
              isShowPickMask: true
            });
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.selectSameJourney) {
        _app.appMethod.showModal({
          content: '请选择同城地址',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.goSameJourneyAddress();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.sameJourneyDateTime && _this2.data.sameJourneyTimeType != 1) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && !_this2.data.selectDelivery) {
        _app.appMethod.showModal({
          content: '请选择上门自提地址',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.toDeliveryList();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && _this2.data.selfAppointmentSwitch && !tostoreOrderType) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      var year = new Date().getFullYear();
      var tostoreDateTime = year + '-' + _this2.data.tostoreDateTime + ' ' + (_this2.data.tostoreHourTime || '');
      if (_this2.data.pickUpType == 3 && _this2.data.selfDeliveryPhone == 1 && !/^[0-9]*$/.test(_this2.data.phone)) {
        _app.appMethod.showModal({
          content: '请输入正确的手机号'
        });
        return;
      }
      if (_this2.data.hasRequiredSuppInfo && !_this2.data.deliverydWrite && !_this2.data.aloneDeliveryShow) {
        _app.appMethod.showModal({
          content: '商品补充信息未填写，无法进行支付',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.goToAdditionalInfo();
          }
        });
        return;
      }
      if (_this2.data.aloneDeliveryShow) {
        var a = _this2.data.additional_info;
        var id = _this2.data.additional_goodsid_arr[0];
        if (a[id][0].is_required == 0 && a[id][0].value == '') {
          _app.appMethod.showModal({
            content: '请填写' + a[id][0].title,
            confirmText: '确认'
          });
          return;
        }
      }
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: {
          cart_id_arr: _this2.cart_id_arr,
          formId: e.target.formId,
          sub_shop_app_id: _this2.franchisee_id,
          selected_benefit: selected_benefit,
          is_balance: _this2.data.pickUpType == 4 && _this2.data.account_type == 2 ? 0 : _this2.data.useBalance ? 1 : 0,
          ecommerce_info: {
            ec_tostore_data: {
              ec_tostore_order_type: tostoreOrderType,
              ec_tostore_appointment_time: tostoreOrderType == 1 || !_this2.data.selfAppointmentSwitch ? '' : tostoreDateTime,
              ec_tostore_buyer_phone: _this2.data.phone || '',
              ec_tostore_appointment_time_type: _this2.data.tostoreTimeType || '',
              ec_tostore_location_id: _this2.data.locationId || ''
            },
            intra_city_data: {
              intra_city_appointment_arrive_time: _this2.data.sameJourneyTimeType == 1 ? '' : _this2.data.sameJourneyDateTime
            },
            ec_dining_data: {
              ordering_food_type: 1, // 点餐方式
              dining_mode: _this.data.dining_mode, // 就餐方式
              people_num: _this.data.people_num, // 就餐人数
              take_meal_type: _this.data.take_meal_type, // 取餐类型
              location_id: _this.data.ec_location_id, // 座位号码
              account_type: _this.data.account_type, // 结账方式
              allow_add_dish: _this.data.allow_add_dish, // 允许加菜
              allow_app_account: _this.data.allow_app_account // 允许结账
            }
          },
          pick_up_type: _this2.data.pickUpType,
          self_delivery_app_store_id: _this2.data.pickUpType == 3 ? _this2.data.selectDelivery.id : '',
          remark: _this2.data.orderRemark,
          address_id: _this2.data.pickUpType == 1 ? _this2.data.selectAddress.id : _this2.data.pickUpType == 4 ? '' : _this2.data.selectSameJourney.id,
          additional_info: _this2.data.additional_info,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info,
          is_pay_on_delivery: _this2.data.cashOnDelivery ? 1 : 0
        },
        success: function success(res) {
          _this.setData({
            totalPayment: res.total_price
          });
          if (_this.data.pickUpType == 4) {
            clearTimeout(_this.timerId);
            _this.data.ec_location_id && _this.clearCartCache();
            if (_this.data.account_type == 2) {
              var pagePath = '/eCommerce/pages/diningOrderDetail/diningOrderDetail?detail=' + res.data + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
              _app.appMethod.turnToPage(pagePath, 1);
              return;
            }
          }
          if (_this.data.cashOnDelivery) {
            var _pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + res.data + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
            _app.appMethod.turnToPage(_pagePath, 1);
          } else {
            _this.payOrder(res.data);
          }
        },
        fail: function fail() {
          _this.requesting = false;
          _this.loopRequestMultiOrder();
        },
        successStatusAbnormal: function successStatusAbnormal(re) {
          _this.requesting = false;
          if (re.status == 1) {
            _this.loopRequestMultiOrder();
          }
          if (re.turn_back == 1) {
            _app.appMethod.showModal({
              content: '当前正在结算，请勿重复操作',
              confirm: function confirm() {
                _app.appMethod.turnBack();
              }
            });
            return;
          }
        }
      });
      _this2.saveFormId(e.target.formId);
    };

    _this2.mulShopconfirmPayment = function (e) {
      var _this = _this2;
      var _this2$data3 = _this2.data,
          mulShopsInfo = _this2$data3.mulShopsInfo,
          leagueBenefitData = _this2$data3.leagueBenefitData,
          pickUpType = _this2$data3.pickUpType,
          shopsList = _this2$data3.shopsList,
          selectAddress = _this2$data3.selectAddress,
          selectSameJourney = _this2$data3.selectSameJourney;

      var selectedBenefitInfo = leagueBenefitData.selectedBenefitInfo;
      if (pickUpType == 1 && !selectAddress) {
        // 是否选了快递地址
        _this.setData({
          expressAddressNull: true
        });
        return;
      }
      if (pickUpType == 2 && !selectSameJourney) {
        // 是否选了同城地址
        _app.appMethod.showModal({
          content: '\u8BF7\u9009\u62E9\u540C\u57CE\u5730\u5740',
          confirmText: '\u53BB\u586B\u5199',
          confirm: function confirm() {
            _this.goSameJourneyAddress();
          }
        });
        return;
      }
      _this2.isWriteComplete = true;
      shopsList.forEach(function (shop, index) {
        if (!_this2.isWriteComplete) return;
        var shopAppId = shop.app_id;
        _this.selectedAppId = shopAppId;
        var shopName = shop.name;
        var shopItem = mulShopsInfo[shopAppId];
        if (pickUpType == 2) {
          // 同城
          if (!shopItem.sameJourneyDateTime && shopItem.sameJourneyTimeType != 1) {
            _app.appMethod.showModal({
              title: shopName,
              content: '\u8BF7\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
            });
            _this2.isWriteComplete = false;
            return;
          }
        }
        if (pickUpType == 3) {
          // 自提
          if (!shopItem.selectDelivery) {
            _app.appMethod.showModal({
              title: shopName,
              content: '\u8BF7\u9009\u62E9\u4E0A\u95E8\u81EA\u63D0\u5730\u5740',
              confirmText: '\u53BB\u586B\u5199',
              confirm: function confirm() {
                _this.toDeliveryList(key);
              }
            });
            _this2.isWriteComplete = false;
            return;
          }
          if (shopItem.selfAppointmentSwitch && !shopItem.tostoreOrderType) {
            _app.appMethod.showModal({
              title: shopName,
              content: '\u8BF7\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
            });
            _this2.isWriteComplete = false;
            return;
          }
          if (shopItem.selfDeliveryPhone == 1 && !util.isPhoneNumber(shopItem.phone)) {
            _app.appMethod.showModal({
              title: shopName,
              content: '\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7'
            });
            _this2.isWriteComplete = false;
            return;
          }
        }
        if (shopItem.hasRequiredSuppInfo) {
          if (!shopItem.deliverydWrite && !shopItem.aloneDeliveryShow) {
            // 多条补充信息
            _app.appMethod.showModal({
              title: shopName,
              content: '\u6709\u5546\u54C1\u8865\u5145\u4FE1\u606F\u672A\u586B\u5199\uFF0C\u65E0\u6CD5\u8FDB\u884C\u652F\u4ED8',
              confirmText: '\u53BB\u586B\u5199',
              confirm: function confirm() {
                _this.goToAdditionalInfo(shopAppId);
              }
            });
            _this2.isWriteComplete = false;
            return;
          }
          if (shopItem.aloneDeliveryShow) {
            // 单条补充信息
            var additionalInfoItem = shopItem.additional_info[shopItem.additional_goodsid_arr[0]][0];
            if (!additionalInfoItem.value) {
              _app.appMethod.showModal({
                title: shopName,
                content: '\u8BF7\u586B\u5199' + additionalInfoItem.title,
                confirmText: '\u786E\u8BA4'
              });
              _this2.isWriteComplete = false;
              return;
            }
          }
        }
      });
      if (!_this2.isWriteComplete || _this2.requesting) {
        return false;
      }
      _this2.requesting = true;
      var shopsOrderParams = [];
      Object.keys(mulShopsInfo).forEach(function (key) {
        var shopInfo = mulShopsInfo[key];
        var shopGoods = shopsList.filter(function (shop) {
          return shop.app_id == key;
        });
        var cartIdArr = shopGoods[0].cartList.map(function (cart) {
          return cart.id;
        });
        var year = new Date().getFullYear();
        var tostoreDateTime = year + '-' + shopInfo.tostoreDateTime + ' ' + (shopInfo.tostoreHourTime || '');
        shopsOrderParams.push({
          cart_id_arr: cartIdArr, // 购物车id
          sub_shop_app_id: key,
          formId: e.target.formId,
          selected_benefit: shopInfo.selectDiscountInfo || '', // 选中的优惠方式
          is_balance: shopInfo.useBalance ? 1 : 0, // 是否用储值金
          ecommerce_info: {
            ec_tostore_data: {
              // 自提
              ec_tostore_order_type: shopInfo.tostoreOrderType || '',
              ec_tostore_appointment_time: shopInfo.tostoreOrderType == 1 || !shopInfo.selfAppointmentSwitch ? '' : tostoreDateTime,
              ec_tostore_buyer_phone: shopInfo.phone || '', // 联系人手机号码
              ec_tostore_appointment_time_type: shopInfo.tostoreTimeType || '',
              ec_tostore_location_id: shopInfo.locationId || '' // 自提地址
            },
            intra_city_data: {
              // 同城
              intra_city_appointment_arrive_time: shopInfo.sameJourneyTimeType == 1 ? '' : shopInfo.sameJourneyDateTime || '' // 送达时间
            }
          },
          pick_up_type: pickUpType, // 取货方式
          self_delivery_app_store_id: pickUpType == 3 ? shopInfo.selectDelivery.id : '', // 自提店id
          remark: shopInfo.orderRemark || '', // 留言
          address_id: pickUpType == 1 ? _this.data.selectAddress.id : pickUpType == 4 ? '' : _this.data.selectSameJourney.id, // 地址id
          additional_info: shopInfo.additional_info || '', // 补充信息
          voucher_coupon_goods_info: shopInfo.exchangeCouponData && shopInfo.exchangeCouponData.voucher_coupon_goods_info || '', // 兑换券兑换商品
          is_pay_on_delivery: shopInfo.cashOnDelivery ? 1 : 0 // 是否货到付款
        });
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/MultiAddCartOrder',
        method: 'post',
        data: {
          multi_superimposed: 1,
          extra_selected_benefit: selectedBenefitInfo, // 联盟优惠
          multi_app_shops: shopsOrderParams
        },
        success: function success(res) {
          if (pickUpType == 4) {
            // 点餐
            clearInterval(_this.timerId);
            if (_this.data.account_type == 2) {
              var pagePath = '/eCommerce/pages/diningOrderDetail/diningOrderDetail?detail=' + res.data + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
              _app.appMethod.turnToPage(pagePath, 1);
              return;
            }
          }
          var allShopsCashOnDelivery = true;
          Object.keys(mulShopsInfo).forEach(function (key) {
            if (!mulShopsInfo[key].cashOnDelivery) {
              allShopsCashOnDelivery = false;
            }
          });
          if (allShopsCashOnDelivery) {
            // 货到付款直接支付成功
            var _pagePath2 = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?isFranchisee=1&detail=' + res.data.master_order.order_id + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
            _app.appMethod.turnToPage(_pagePath2, 1);
          } else {
            _this.payOrder(res);
          }
        },
        fail: function fail() {
          _this.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _this.requesting = false;
        }
      });
    };

    _this2.clearCartCache = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/clearLocationCartCache',
        method: 'post',
        data: {
          location_id: _this2.data.ec_location_id,
          cart_id_arr: _this2.cart_id_arr,
          sub_shop_app_id: _this2.franchisee_id
        },
        success: function success(res) {}
      });
    };

    _this2.saveFormId = function (form_id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function success(res) {}
      });
    };

    _this2.payOrder = function (data) {
      var _this = _this2;
      var orderId = '';
      var masterOrderId = '';
      if (_this2.isFranchisee) {
        orderId = data.extra.map(function (order) {
          return order.order_id;
        });
        masterOrderId = data.data.master_order.order_id;
      } else {
        orderId = data;
      }
      function paySuccess() {
        var router = _this.data.pickUpType == 4 && _this.data.account_type == 2 ? 'diningOrderDetail/diningOrderDetail?detail=' : 'goodsOrderPaySuccess/goodsOrderPaySuccess?detail=';
        var pagePath = '/eCommerce/pages/' + router + (_this.isFranchisee ? masterOrderId : orderId) + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') + '&is_group=' + !!_this.is_group + '&isFranchisee=' + (_this.isFranchisee ? 1 : 0);
        if (!_this.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: _this.isFranchisee ? masterOrderId : orderId,
              sub_app_id: _this.franchisee_id
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              _app.appMethod.turnToPage(pagePath, 1);
            }
          });
        } else {
          _app.appMethod.turnToPage(pagePath, 1);
        }
      }
      function payFail() {
        var router = _this.data.pickUpType == 4 ? 'diningOrderDetail/diningOrderDetail?detail=' : 'goodsOrderDetail/goodsOrderDetail?detail=';
        if (_this.is_group) {
          if (_this.data.teamToken) {
            _app.appMethod.turnBack();
            return;
          }
          _app.appMethod.turnToPage('/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
        } else {
          if (_this.isFranchisee) {
            _app.appMethod.turnToPage('/eCommerce/pages/myOrder/myOrder?goodsType=0&currentIndex=0', 1);
          } else {
            _app.appMethod.turnToPage('/eCommerce/pages/' + router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
          }
        }
      }
      var totalPayMoney = _this.isFranchisee ? _this.data.payTotalPrice : _this.data.totalPayment;
      if (totalPayMoney == 0) {
        var orderIdParam = '';
        if (typeof data === 'string') {
          // 单店
          orderIdParam = data;
        } else {
          // 多店 将货到付款的订单号去掉
          orderIdParam = data.extra.filter(function (order) {
            return order.is_pay_on_delivery == 0;
          });
          orderIdParam = orderIdParam.map(function (order) {
            return order.order_id;
          });
        }
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          method: 'post',
          data: {
            order_id: orderIdParam,
            total_price: 0,
            data: _this.isFranchisee ? orderIdParam : ''
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      var params = {};
      if (_this.isFranchisee) {
        params['data'] = data.extra.map(function (order) {
          return {
            order_id: order.order_id,
            is_master: order.is_master
          };
        });
      } else {
        params['order_id'] = orderId;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   method: 'post',
      //   data: params,
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     _this.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })
      function paySuccessUrl() {
        var router = _this.data.pickUpType == 4 && _this.data.account_type == 2 ? '/diningOrderDetail?detail=' : '/goodsOrderPaySuccess?detail=';
        var successUrl = router + (_this.isFranchisee ? masterOrderId : orderId) + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') + '&is_group=' + !!_this.is_group + '&isFranchisee=' + (_this.isFranchisee ? 1 : 0);

        return successUrl;
      }

      function payFailUrl() {
        var router = _this.data.pickUpType == 4 ? '/diningOrderDetail?detail=' : '/goodsOrderDetail?detail=';
        var failUrl = '';
        if (_this.is_group) {
          failUrl = '/groupOrderDetail?id=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
        } else {
          if (_this.isFranchisee) {
            failUrl = '/myOrder?goodsType=0&currentIndex=0';
          } else {
            failUrl = router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
          }
        }
        return failUrl;
      }

      _this.requesting = false;
      _app.appMethod.goPay({
        orderId: orderId,
        franchisee: _this.franchisee_id,
        successUrl: paySuccessUrl(),
        failUrl: payFailUrl(),
        cancel: payFail
      });
    };

    _this2.goToMyAddress = function (e) {
      var addressId = e.currentTarget.dataset.addressId;

      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId);
    };

    _this2.useBalanceChange = function (checked, appId) {
      var setDataObj = {};
      if (appId) {
        // 多店
        setDataObj['mulShopsInfo.' + appId + '.useBalance'] = checked;
      } else {
        // 单店
        setDataObj['useBalance'] = checked;
      }
      _this2.setData(setDataObj);
      _this2.getCalculationInfo();
    };

    _this2.useCashDelivery = function (checked, appId) {
      var setDataObj = {};
      if (appId) {
        setDataObj['mulShopsInfo.' + appId + '.cashOnDelivery'] = checked;
        var _mulShopsInfo2 = _this2.data.mulShopsInfo;

        var allShopsCashOnDelivery = true;
        Object.keys(_mulShopsInfo2).forEach(function (key) {
          if (!_mulShopsInfo2[key].cashOnDelivery) {
            allShopsCashOnDelivery = false;
          }
        });
        _this2.setData({
          allShopsCashOnDelivery: allShopsCashOnDelivery
        });
      } else {
        setDataObj['cashOnDelivery'] = checked;
      }
      _this2.setData(setDataObj);
      _this2.getCalculationInfo();
    };

    _this2.deliveryWayChange = function (event) {
      var type = event.currentTarget.dataset.type;
      // WEBAPP特殊处理: 设置 取货方式 参数
      (0, _tools.updateUrlParam)('type', type);
      _this2.setData({
        selectDiscountInfo: {}, // 清空已选优惠信息
        pickUpType: type,
        sameJourneyTimeType: type == 2 ? 1 : '',
        isShowPickMask: false,
        cashOnDelivery: false
      });
      if (type == 3) {
        _this2.getSelfDeliveryList();
      } else if (type == 4) {
        // 点餐
        _this2.getDiningFuncSetting(_this2.getDiningData);
      }
      type != 4 && _this2.getCalculationInfo();
    };

    _this2.goToAdditionalInfo = function (e) {
      var additionalInfo = {};
      var appId = '';
      if (_this2.isFranchisee) {
        appId = (typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e)) === 'object' ? e.currentTarget.dataset.appId : e ? e : _this2.selectedAppId;
        var _mulShopsInfo3 = _this2.data.mulShopsInfo;

        additionalInfo = _mulShopsInfo3[appId].additional_info || {};
        _app.appMethod.setPreviewGoodsInfo(_mulShopsInfo3[appId].goodsAdditionalInfo);
      } else {
        additionalInfo = _this2.data.additional_info;
      }
      _app.appMethod.setGoodsAdditionalInfo(additionalInfo);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?appId=' + appId);
    };

    _this2.exchangeCouponInit = function (id) {
      var _this = _this2;
      var params = {
        data_id: id
      };
      if (_this.isFranchisee) {
        params['app_id'] = _this.selectedAppId;
        params['_app_id'] = _this.selectedAppId;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: params,
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          if (_this.isFranchisee) {
            var _this$setData6;

            _this.setData((_this$setData6 = {}, (0, _defineProperty3.default)(_this$setData6, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.dialogHidden', false), (0, _defineProperty3.default)(_this$setData6, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.goodsInfo', goods), (0, _defineProperty3.default)(_this$setData6, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo', false), _this$setData6));
          } else {
            _this.setData({
              'exchangeCouponData.dialogHidden': false, // 显示模态框
              'exchangeCouponData.goodsInfo': goods,
              'exchangeCouponData.selectModelInfo': selectModelInfo
            });
          }
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _app.appMethod.showModal({
            content: '兑换的商品已下架'
          });
        }
      });
    };

    _this2.exchangeCouponHideDialog = function (e) {
      var setDataObj = {};
      var appId = e.currentTarget.dataset.appId;

      if (appId) {
        setDataObj['mulShopsInfo.' + appId + '.selectDiscountInfo'] = {
          title: '不使用优惠',
          name: '无',
          no_use_benefit: 1
        };
        setDataObj['mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.dialogHidden'] = true;
        setDataObj['mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.hasSelectGoods'] = false;
        setDataObj['mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.voucher_coupon_goods_info'] = {};
      } else {
        setDataObj['selectDiscountInfo'] = {
          title: '不使用优惠',
          name: '无',
          no_use_benefit: 1
        };
        setDataObj['exchangeCouponData.dialogHidden'] = true;
        setDataObj['exchangeCouponData.hasSelectGoods'] = false;
        setDataObj['exchangeCouponData.voucher_coupon_goods_info'] = {};
      }
      _this2.setData(setDataObj);
      _this2.getCalculationInfo();
    };

    _this2.exchangeCouponSelectSubModel = function (e) {
      var dataObj = {};
      if (_this2.isFranchisee) {
        dataObj = _this2.data.mulShopsInfo[_this2.selectedAppId];
      } else {
        dataObj = _this2.data;
      }
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = dataObj.exchangeCouponData.selectModelInfo.models,
          model = dataObj.exchangeCouponData.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      if (_this2.isFranchisee) {
        data['mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.selectModelInfo.models'] = selectModels;
        data['mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.selectModelInfo.models_text'] = text;
      } else {
        data['exchangeCouponData.selectModelInfo.models'] = selectModels;
        data['exchangeCouponData.selectModelInfo.models_text'] = text;
      }
      _this2.setData(data);
      _this2.exchangeCouponResetSelectCountPrice();
    };

    _this2.exchangeCouponResetSelectCountPrice = function () {
      var dataObj = {};
      if (_this2.isFranchisee) {
        dataObj = _this2.data.mulShopsInfo[_this2.selectedAppId];
      } else {
        dataObj = _this2.data;
      }
      var _this = _this2,
          selectModelIds = dataObj.exchangeCouponData.selectModelInfo.models.join(','),
          modelItems = dataObj.exchangeCouponData.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          if (_this.isFranchisee) {
            data['mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
            data['mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
            data['mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
            data['mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
            break;
          } else {
            data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
            data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
            data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
            data['exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
            break;
          }
        }
      }
      _this2.setData(data);
    };

    _this2.exchangeCouponConfirmGoods = function () {
      var _this = _this2;
      var dataObj = {};
      if (_this2.isFranchisee) {
        dataObj = _this2.data.mulShopsInfo[_this2.selectedAppId];
      } else {
        dataObj = _this2.data;
      }
      var goodsInfo = dataObj.exchangeCouponData.goodsInfo;
      var model = goodsInfo.model;
      var selectModels = dataObj.exchangeCouponData.selectModelInfo.models;
      var model_value_str = '';
      if (selectModels.length > 0) {
        for (var i = 0; i < selectModels.length; i++) {
          var selectSubModelId = model[i].subModelId;
          for (var j = 0; j < selectSubModelId.length; j++) {
            if (selectModels[i] == selectSubModelId[j]) {
              model_value_str += model[i].subModelName[j] + '； ';
            }
          }
        }
      }
      goodsInfo['model_value_str'] = model_value_str;
      if (_this.isFranchisee) {
        var _this$setData7;

        _this.setData((_this$setData7 = {}, (0, _defineProperty3.default)(_this$setData7, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.dialogHidden', true), (0, _defineProperty3.default)(_this$setData7, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.selectModelInfo', {}), (0, _defineProperty3.default)(_this$setData7, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.voucher_coupon_goods_info', {
          goods_id: goodsInfo.id,
          num: 1,
          model_id: dataObj.exchangeCouponData.selectModelInfo.modelId
        }), (0, _defineProperty3.default)(_this$setData7, 'mulShopsInfo.' + _this.selectedAppId + '.exchangeCouponData.goodsInfo', goodsInfo), _this$setData7));
      } else {
        _this.setData({
          'exchangeCouponData.dialogHidden': true,
          'exchangeCouponData.selectModelInfo': {},
          'exchangeCouponData.hasSelectGoods': true,
          'exchangeCouponData.voucher_coupon_goods_info': {
            goods_id: goodsInfo.id,
            num: 1,
            model_id: dataObj.exchangeCouponData.selectModelInfo.modelId
          },
          'exchangeCouponData.goodsInfo': goodsInfo
        });
      }
      _this.getCalculationInfo();
    };

    _this2.toDeliveryList = function (e) {
      var _this = _this2;
      var url = '';
      var selectDelivery = {};
      var appId = (typeof e === 'undefined' ? 'undefined' : (0, _typeof3.default)(e)) === 'object' ? e.currentTarget.dataset.appId : _this.selectedAppId;
      if (_this2.isFranchisee) {
        var _mulShopsInfo4 = _this.data.mulShopsInfo;

        selectDelivery = _mulShopsInfo4[appId].selectDelivery;
      } else {
        selectDelivery = _this.data.selectDelivery;
      }
      if (_this.franchisee_id || appId) {
        // 子店或者多店中的子店
        url += '?franchiseeId=' + (_this.franchisee_id || appId);
        url += selectDelivery.id ? '&deliveryId=' + selectDelivery.id : '';
      } else {
        url += selectDelivery.id ? '?deliveryId=' + selectDelivery.id : '';
      }
      if (_this2.data.onlyImmediatlyPickSwitch) {
        _this2.onlyImme = true;
      }
      _app.appMethod.turnToPage('/eCommerce/pages/goodsDeliveryList/goodsDeliveryList' + url);
    };

    _this2.showMemberDiscount = function (e) {
      var seletedDiscountInfo = {};
      if (_this2.isFranchisee) {
        // 多店
        var _e$currentTarget$data3 = e.currentTarget.dataset,
            appId = _e$currentTarget$data3.appId,
            isLeague = _e$currentTarget$data3.isLeague;
        var _this2$data4 = _this2.data,
            _mulShopsInfo5 = _this2$data4.mulShopsInfo,
            _leagueBenefitData = _this2$data4.leagueBenefitData;

        _this2.selectedAppId = appId;
        seletedDiscountInfo = isLeague ? _leagueBenefitData.selectedBenefitInfo : _mulShopsInfo5[appId].selectDiscountInfo;
        _this2.setData({
          selectedAppId: appId || '',
          isLeagueBenefit: isLeague || ''
        });
      } else {
        seletedDiscountInfo = _this2.data.selectDiscountInfo;
      }
      // 根据是否是多商家传递不同的数据
      var options = {
        franchisee: _this2.isFranchisee,
        afterSelectedDiscount: function afterSelectedDiscount(event) {
          _this2.afterSelectedBenefit(event);
        }
      };
      if (_this2.isFranchisee) {
        options.discountType = _this2.state.isLeagueBenefit ? leagueBenefitData.benefitList : mulShopsInfo[_this2.selectedAppId].discountList;
      } else {
        options.discountType = _this2.state.discountList;
      }
      _this2.memberDiscountRef.current.show(options);
      _this2.memberDiscountRef.current.showDialog(seletedDiscountInfo);
    };

    _this2.afterSelectedBenefit = function (options) {
      var isLeagueBenefit = _this2.data.isLeagueBenefit;

      if (_this2.isFranchisee) {
        // 多店
        if (isLeagueBenefit) {
          // 联盟优惠
          _this2.setData({
            'leagueBenefitData.selectedBenefitInfo': options.selectedDiscount
          });
        } else {
          var _this2$setData;

          // 本店优惠
          _this2.setData((_this2$setData = {}, (0, _defineProperty3.default)(_this2$setData, 'mulShopsInfo.' + _this2.selectedAppId + '.selectDiscountInfo', options.selectedDiscount), (0, _defineProperty3.default)(_this2$setData, 'mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.hasSelectedGoods', false), (0, _defineProperty3.default)(_this2$setData, 'mulShopsInfo.' + _this2.selectedAppId + '.exchangeCouponData.voucher_coupon_goods_info', {}), _this2$setData));
        }
      } else {
        // 单店
        _this2.setData({
          selectDiscountInfo: options.selectedDiscount,
          'exchangeCouponData.hasSelectedGoods': false,
          'exchangeCouponData.voucher_coupon_goods_info': {}
        });
      }
      _this2.getCalculationInfo();
    };

    _this2.getSuppInfo = function (suppInfoArr) {
      var _this = _this2;
      var deliveryArr = [];
      var _this2$data5 = _this2.data,
          shopsList = _this2$data5.shopsList,
          mulShopsInfo = _this2$data5.mulShopsInfo;

      if (_this2.isFranchisee) {
        deliveryArr = shopsList.map(function (shop) {
          var suppInfoArr = [];
          var additionalInfoGoodsId = [];
          var goodsAdditionalInfo = [];
          shop.cartList.map(function (cart) {
            var goodsInfo = cart.good_info;
            if (goodsInfo.delivery_id && goodsInfo.delivery_id != 0 && additionalInfoGoodsId.indexOf(goodsInfo.id) == -1) {
              suppInfoArr.push(goodsInfo.delivery_id);
              additionalInfoGoodsId.push(goodsInfo.id);
              goodsAdditionalInfo.push(goodsInfo);
            }
          });
          mulShopsInfo[shop.app_id]['additional_goodsid_arr'] = additionalInfoGoodsId;
          mulShopsInfo[shop.app_id]['goodsAdditionalInfo'] = goodsAdditionalInfo;
          mulShopsInfo[shop.app_id]['noAdditionalInfo'] = true;
          return {
            app_id: shop.app_id,
            delivery_id: suppInfoArr
          };
        });
        deliveryArr = deliveryArr.filter(function (shop) {
          return shop.delivery_id.length;
        });
        _this2.setData({
          mulShopsInfo: mulShopsInfo
        });
      }
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=pc/AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_ids: suppInfoArr,
          delivery_arr: deliveryArr
        },
        success: function success(res) {
          if (_this.isFranchisee) {
            var returnDataObj = res.data || {};
            Object.keys(returnDataObj).forEach(function (key) {
              var additionalInfoList = returnDataObj[key];
              additionalInfoList.forEach(function (goodsItem) {
                goodsItem.delivery_info.forEach(function (item) {
                  if (item.is_required == 0 && item.is_hidden == 1) {
                    // 是否必填
                    _this.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + key + '.hasRequiredSuppInfo', true));
                  }
                  if (item.is_hidden == 1) {
                    // 是否没有补充信息
                    _this.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + key + '.noAdditionalInfo', false));
                  }
                });
              });
              if (additionalInfoList[0].delivery_info.length == 1 && mulShopsInfo[key].additional_goodsid_arr.length == 1) {
                var deliveryIndex = 0;
                var showIndex = 0;
                additionalInfoList[0].delivery_info.forEach(function (item, index) {
                  if (item.is_hidden == 1) {
                    deliveryIndex++;
                    showIndex = index;
                  }
                });
                if (deliveryIndex == 1) {
                  var _this$setData10;

                  var data = {};
                  data[mulShopsInfo[key].additional_goodsid_arr[0]] = [];
                  data[mulShopsInfo[key].additional_goodsid_arr[0]].push({
                    title: additionalInfoList[0].delivery_info[showIndex].name,
                    type: additionalInfoList[0].delivery_info[showIndex].type,
                    is_required: additionalInfoList[0].delivery_info[showIndex].is_required,
                    value: ''
                  });
                  _this.setData((_this$setData10 = {}, (0, _defineProperty3.default)(_this$setData10, 'mulShopsInfo.' + key + '.additional_info', data), (0, _defineProperty3.default)(_this$setData10, 'mulShopsInfo.' + key + '.aloneDeliveryShow', true), _this$setData10));
                }
              }
            });
          } else {
            for (var i = 0; i < res.data.length; i++) {
              var suppInfo = res.data[i].delivery_info;
              for (var j = 0; j < suppInfo.length; j++) {
                if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
                  _this.setData({
                    hasRequiredSuppInfo: true
                  });
                }
                if (suppInfo[j].is_hidden == 1) {
                  _this.setData({
                    noAdditionalInfo: false
                  });
                }
              }
            }
            if (res.data.length == 1 && _this.data.additional_goodsid_arr.length == 1) {
              var deliveryIndex = 0;
              var showIndex = 0;
              for (var _i = 0; _i < res.data[0].delivery_info.length; _i++) {
                if (res.data[0].delivery_info[_i].is_hidden == 1) {
                  deliveryIndex++;
                  showIndex = _i;
                }
              }
              if (deliveryIndex == 1) {
                var data = {};
                data[_this.data.additional_goodsid_arr[0]] = [];
                data[_this.data.additional_goodsid_arr[0]].push({
                  title: res.data[0].delivery_info[showIndex].name,
                  type: res.data[0].delivery_info[showIndex].type,
                  is_required: res.data[0].delivery_info[showIndex].is_required,
                  value: ''
                });
                _this.setData({
                  additional_info: data,
                  aloneDeliveryShow: true
                });
              }
            }
          }
        }
      });
    };

    _this2.getSelfDeliveryList = function () {
      var _this = _this2;
      var params = {};
      if (_this.isFranchisee) {
        var shopsList = _this2.data.shopsList;

        var shopParams = [];
        shopParams = shopsList.map(function (shop) {
          return {
            app_id: shop.app_id,
            self_delivery_app_store_id: ''
          };
        });
        params['delivery_arr'] = shopParams;
      } else {
        params = {
          sub_shop_app_id: _this2.franchisee_id
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getSelfDeliveryList',
        method: 'post',
        data: params,
        success: function success(res) {
          if (_this.isFranchisee) {
            var _mulShopsInfo6 = _this.data.mulShopsInfo;

            Object.keys(res.data).forEach(function (key) {
              var storeList = res.data[key].store_list_data;
              if (!storeList) {
                _app.appMethod.showModal({
                  content: '商家暂无自提门店',
                  confirm: function confirm() {
                    _app.appMethod.turnBack();
                  }
                });
                return;
              }
              _mulShopsInfo6[key]['selectDelivery'] = res.data[key].store_list_data[0];
            });
            _this.setData({
              mulShopsInfo: _mulShopsInfo6
            });
            _this.getGoodsStoreSet(3);
          } else {
            var storeList = res.data.store_list_data;
            if (!storeList) {
              _app.appMethod.showModal({
                content: '商家暂无自提门店',
                confirm: function confirm() {
                  _app.appMethod.turnBack();
                }
              });
              return;
            }
            if (storeList.length == 1) {
              _this.setData({
                selectDelivery: storeList[0]
              });
            }
            console.log(_this.data.selectDelivery);
            if (storeList.length >= 2 && !_this.data.selectDelivery) {
              _app.appMethod.showModal({
                content: '当前尚未选择自提点',
                confirmText: '去设置',
                showCancel: true,
                confirm: function confirm() {
                  _this.toDeliveryList();
                }
              });
            }
            _this.getGoodsStoreSet(3);
          }
        }
      });
    };

    _this2.inputFormControl = function (e) {
      var appId = e.currentTarget.dataset.appId;

      if (appId) {
        // 多店
        var _mulShopsInfo7 = _this2.data.mulShopsInfo;

        var a = _mulShopsInfo7[appId].additional_info;
        var b = _mulShopsInfo7[appId].additional_goodsid_arr[0];
        a[b][0].value = e.target.value;
        _this2.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + appId + '.additional_info', a));
      } else {
        // 单店
        var _a = _this2.data.additional_info;
        var _b = _this2.data.additional_goodsid_arr[0];
        _a[_b][0].value = e.target.value;
        _this2.setData({
          additional_info: _a
        });
      }
    };

    _this2.addDeliveryImg = function (e) {
      var appId = e.currentTarget.dataset.appId;

      var _this = _this2;
      var info = '';
      var id = '';
      var setDataObj = {};
      if (appId) {
        var _mulShopsInfo8 = _this2.data.mulShopsInfo;

        info = _mulShopsInfo8[appId].additional_info;
        id = _mulShopsInfo8[appId].additional_goodsid_arr[0];
      } else {
        info = _this2.data.additional_info;
        id = _this2.data.additional_goodsid_arr[0];
      }
      var images = info[id][0].value || [];
      _app.appMethod.chooseImage(function (image) {
        info[id][0].value = images.concat(image);
        if (appId) {
          setDataObj['mulShopsInfo.' + appId + '.additional_info'] = info;
        } else {
          setDataObj['additional_info'] = info;
        }
        _this.setData(setDataObj);
      }, 9 - info[id][0].value.length);
    };

    _this2.deleteImage = function (e) {
      var _e$currentTarget$data4 = e.currentTarget.dataset,
          appId = _e$currentTarget$data4.appId,
          imageIndex = _e$currentTarget$data4.imageIndex;

      var _this = _this2;
      var info = '';
      var id = '';
      if (appId) {
        var _mulShopsInfo9 = _this2.data.mulShopsInfo;

        info = _mulShopsInfo9[appId].additional_info;
        id = _mulShopsInfo9[appId].additional_goodsid_arr[0];
      } else {
        info = _this2.data.additional_info;
        id = _this2.data.additional_goodsid_arr[0];
      }
      var images = info[id][0].value;
      images.splice(imageIndex, 1);
      info[id][0].value = images;
      if (appId) {
        _this.setData((0, _defineProperty3.default)({}, 'mulShopsInfo.' + appId + '.additional_info', info));
      } else {
        _this.setData({
          additional_info: info
        });
      }
    };

    _this2.closeGoodsPick = function () {
      _this2.setData({
        isShowPickMask: false,
        isShowServiceTime: false,
        isShowSameJourneyTime: false
      });
    };

    _this2.selectPickMethod = function (first) {
      var _this = _this2;
      var cartIdArr = _this2.cart_id_arr;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtAddOrder',
        method: 'post',
        data: {
          cart_id_arr: cartIdArr,
          sub_shop_app_id: _this.franchisee_id
        },
        success: function success(res) {
          var pickUpTypeArr = res.data.goods_pick_up_type_arr;
          // WEBAPP特殊处理: 设置 取货方式 参数
          (0, _tools.updateUrlParam)('type', !_this.data.pickUpType || _this.data.pickUpType == -1 ? res.data.goods_pick_up_type_arr[0] : _this.data.pickUpType);
          _this.setData({
            dining_data: res.data.dining_data,
            express_data: res.data.express_data,
            pickUpTypeArr: pickUpTypeArr,
            intraCityData: res.data.intra_city_data,
            isShowPickMask: first == 'first' ? false : true,
            pickUpType: !_this.data.pickUpType || _this.data.pickUpType == -1 ? res.data.goods_pick_up_type_arr[0] : _this.data.pickUpType
          });
          if (first == 'first') {
            switch (_this.data.pickUpType) {
              case '4':
                _this.getDiningFuncSetting(_this.getDiningData);
                break;
              case '3':
                if (!_this.isFranchisee) {
                  _this.getSelfDeliveryList();
                }
                break;
              case '2':
                if (res.data.intra_city_data.in_business_time == 0 && pickUpTypeArr.length == 1) {
                  _app.appMethod.showModal({
                    content: '店铺歇业中，不支持此配送！',
                    confirmText: '知道了',
                    confirm: function confirm(res) {
                      _app.appMethod.turnBack();
                    }
                  });
                  return;
                } else {
                  _this.setData({
                    sameJourneyTimeType: 1
                  });
                }
                break;
            }
            _this.data.pickUpType != 4 && _this.getCalculationInfo();
          }
        }
      });
    };

    _this2.showServiceTime = function (type) {
      var _this = _this2;
      var deliveryData = {};
      var appId = (typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) === 'object' ? type.currentTarget.dataset.appId : _this2.selectedAppId;
      _this2.selectedAppId = appId || '';
      var mulShopsInfo = _this2.data.mulShopsInfo;

      if (_this2.isFranchisee) {
        deliveryData = mulShopsInfo[appId].selectDelivery;
        _this2.setData({
          selectedAppId: appId
        });
      } else {
        deliveryData = _this2.data.selectDelivery;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetEcTostoreAppointmentDateList',
        data: {
          app_id: appId ? appId : _app.appMethod.getAppId(),
          _app_id: appId ? appId : _app.appMethod.getAppId(),
          sub_shop_app_id: _this.franchisee_id || '',
          self_delivery_app_store_id: deliveryData.id || ''
        },
        success: function success(res) {
          var data = res.data;
          if (type == 'onlyImme') {
            if (_this.isFranchisee) {
              var _this$setData12;

              _this.setData((_this$setData12 = {}, (0, _defineProperty3.default)(_this$setData12, 'mulShopsInof.' + _this.selectedAppId + '.waitingQueueTime', data.duration_time), (0, _defineProperty3.default)(_this$setData12, 'mulShopsInof.' + _this.selectedAppId + '.tostoreOrderType', 1), _this$setData12));
              return;
            } else {
              _this.setData({
                waitingQueueTime: data.duration_time,
                tostoreOrderType: 1
              });
              return;
            }
          }
          var tostoreTimeType = data.setting_data.appointment.appointment_time_type; //1为天 2为时 3为半小时
          var tostoreDateTime = '';
          var tostoreWeekTime = '';
          var dateArr = data.date_arr;
          var advanceAppointmentInfo = data.setting_data.appointment.advance_appointment_info;
          var startHours = new Date().getHours();
          var businessTimeRule = data.business_time_rule; //上门自提营业时间
          var maxEndHour = 24;
          var currentMinute = new Date().getMinutes();
          var showImmediatelyTime = false;
          var noImmediaPick = data.setting_data.immediate_info.status == 1 && advanceAppointmentInfo.type == 1 ? true : false; //判断上门自提立即取货开关开没开
          var noAppointmentShow = true; //是否显示暂无营业时间
          if (businessTimeRule.type == 2) {
            //获取自定义当天营业时间的终止小时
            var week = dateArr[0].week;
            var timeArr = void 0;
            businessTimeRule.custom.business_time.map(function (item) {
              if (week == 0) {
                week = 7;
              }
              if (item.business_week[week - 1] == 1) {
                timeArr = item.business_time_interval;
                maxEndHour = +timeArr[timeArr.length - 1].end_time.substring(0, 2);
              }
            });
            timeArr && timeArr.map(function (item) {
              var sH = Number(item.start_time.substring(0, 2));
              var eH = Number(item.end_time.substring(0, 2));
              var sT = Number(item.start_time.substring(3, 5));
              var eT = Number(item.end_time.substring(3, 5));
              if (startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) {
                showImmediatelyTime = true;
              }
            });
          } else {
            showImmediatelyTime = true;
          }
          for (var i = 0; i < dateArr.length; i++) {
            if (i == 0 && (advanceAppointmentInfo.type == 2 && +advanceAppointmentInfo.num + startHours >= maxEndHour || advanceAppointmentInfo.type == 1 && startHours >= maxEndHour)) {
              dateArr[i].is_vaild = 0;
            }
            if (dateArr[i].is_vaild == 1 && tostoreTimeType != 1) {
              tostoreDateTime = dateArr[i].date;
              tostoreWeekTime = dateArr[i].week;
              break;
            }
          }
          dateArr.map(function (item) {
            if (item.is_vaild == 1) {
              noAppointmentShow = false;
            }
          });
          _this.businessTimeType = businessTimeRule.type;
          if (_this.isFranchisee) {
            var _this$setData13;

            _this.setData((_this$setData13 = {}, (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.getEcTostoredate', data), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.waitingQueueTime', data.duration_time), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.tostoreTimeType', tostoreTimeType), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.noImmediaPick', noImmediaPick), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.tostoreDateTime', mulShopsInfo[_this.selectedAppId].tostoreDateTime ? mulShopsInfo[_this.selectedAppId].tostoreDateTime : tostoreDateTime), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.tostoreWeekTime', mulShopsInfo[_this.selectedAppId].tostoreWeekTime ? mulShopsInfo[_this.selectedAppId].tostoreWeekTime : tostoreWeekTime), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.businessTimeRule', businessTimeRule.type == 1 ? '' : businessTimeRule.custom.business_time), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.advanceAppointmentInfo', advanceAppointmentInfo), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.noAppointmentShow', noAppointmentShow), (0, _defineProperty3.default)(_this$setData13, 'mulShopsInfo.' + appId + '.showImmediatelyTime', showImmediatelyTime), (0, _defineProperty3.default)(_this$setData13, 'isShowServiceTime', true), _this$setData13));
          } else {
            _this.setData({
              getEcTostoredate: data,
              waitingQueueTime: data.duration_time,
              tostoreTimeType: tostoreTimeType,
              isShowServiceTime: true,
              noImmediaPick: noImmediaPick,
              tostoreDateTime: _this.data.tostoreDateTime ? _this.data.tostoreDateTime : tostoreDateTime,
              tostoreWeekTime: _this.data.tostoreWeekTime ? _this.data.tostoreWeekTime : tostoreWeekTime,
              businessTimeRule: businessTimeRule.type == 1 ? '' : businessTimeRule.custom.business_time,
              advanceAppointmentInfo: advanceAppointmentInfo,
              noAppointmentShow: noAppointmentShow,
              showImmediatelyTime: showImmediatelyTime
            });
          }
          if (tostoreTimeType != 1) {
            _this.getTostoreTime();
          }
          businessTimeRule.type == 2 && _this.getNoAppointmentWord();
        }
      });
    };

    _this2.getNoAppointmentWord = function () {
      var a = '商家营业时间：';
      var b = '';
      var dataObj = {};
      if (_this2.isFranchisee) {
        dataObj = _this2.data.mulShopsInfo[_this2.selectedAppId];
      } else {
        dataObj = _this2.data;
      }
      var businessTimeRule = dataObj.businessTimeRule;
      businessTimeRule.map(function (item) {
        for (var i = 0; i < item.business_week.length; i++) {
          if (item.business_week[i] == 1) {
            switch (i) {
              case 0:
                a += '周一、';
                break;
              case 1:
                a += '周二、';
                break;
              case 2:
                a += '周三、';
                break;
              case 3:
                a += '周四、';
                break;
              case 4:
                a += '周五、';
                break;
              case 5:
                a += '周六、';
                break;
              case 6:
                a += '周日、';
                break;
            }
          }
        }
        item.business_time_interval.map(function (item) {
          a += item.start_time + '-' + item.end_time + ' ';
        });
      });
      var appointment = dataObj.getEcTostoredate.setting_data.appointment;
      var advanceInfo = appointment.advance_appointment_info;
      switch (advanceInfo.type) {
        case '1':
          b += '无需提前，';
          break;
        case '2':
          b += '需提前' + advanceInfo.num + '小时，';
          break;
        case '3':
          b += '需提前' + advanceInfo.num + '天，';
          break;
      }
      b += '最多可预约' + appointment.valid_days + '天内时间';
      if (_this2.isFranchisee) {
        var _this2$setData3;

        _this2.setData((_this2$setData3 = {}, (0, _defineProperty3.default)(_this2$setData3, 'mulShopsInfo.' + _this2.selectedAppId + '.noAppointmentWorda', a), (0, _defineProperty3.default)(_this2$setData3, 'mulShopsInfo.' + _this2.selectedAppId + '.noAppointmentWordb', b), _this2$setData3));
      } else {
        _this2.setData({
          noAppointmentWorda: a,
          noAppointmentWordb: b
        });
      }
    };

    _this2.getPhoneNumber = function (e) {
      var that = _this2;
      if (/getPhoneNumber:fail/.test(e.target.errMsg)) {
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/GetPhoneNumber',
        data: {
          encryptedData: e.target.encryptedData,
          iv: e.target.iv
        },
        success: function success(res) {
          _app.appMethod.setUserInfoStorage({
            phone: res.data
          });
          if (that.isFranchisee) {
            var _mulShopsInfo10 = that.data.mulShopsInfo;

            Object.keys(_mulShopsInfo10).forEach(function (key) {
              var shopItem = _mulShopsInfo10[key];
              shopItem['phone'] = res.data;
            });
            that.setData({
              mulShopsInfo: _mulShopsInfo10
            });
          } else {
            that.setData({
              phone: res.data
            });
          }
        },
        successStatus5: function successStatus5() {
          _app.appMethod.showModal({
            content: '获取手机号失败，请再次点击授权获取'
          });
          // app.goLogin({
          //   success: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   },
          //   fail: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   }
          // })
        }
      });
    };

    _this2.inputPhoneNumber = function (e) {
      if (_this2.isFranchisee) {
        var appId = e.currentTarget.dataset.appId;
        var _mulShopsInfo11 = _this2.data.mulShopsInfo;

        Object.keys(_mulShopsInfo11).forEach(function (key) {
          var shopItem = _mulShopsInfo11[key];
          if (!shopItem.phone) {
            shopItem.phone = e.target.model_value;
          }
        });
        _this2.setData({
          mulShopsInfo: _mulShopsInfo11
        });
      } else {
        _this2.setData({
          phone: e.target.value
        });
      }
    };

    _this2.getInStoreSeat = function () {
      var _this = _this2;
      _app.appMethod.scanCode({
        success: function success(res) {
          var path = res.path;
          var locationId = path.split(/\?location_id=/)[1];
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppEcommerce/getEcLocationData',
            data: {
              id: locationId,
              sub_shop_app_id: _this.franchisee_id
            },
            success: function success(res) {
              if (res.data.status == 0) {
                _this.setData({
                  locationId: locationId,
                  inStoreSeatName: res.data.title
                });
              } else {
                _app.appMethod.showModal({
                  content: '未检索到座位号'
                });
              }
            }
          });
        },
        fail: function fail(res) {
          _app.appMethod.showModal({
            content: '未检索到座位号'
          });
        }
      });
    };

    _this2.goSameJourneyAddress = function (e) {
      var selectSameJourney = _this2.data.selectSameJourney;
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?from=preview&sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + _this2.franchisee_id);
    };

    _this2.getGoodsStoreSet = function (type) {
      var _this = _this2;
      var params = {};
      if (_this.isFranchisee) {
        var shopsList = _this2.data.shopsList;

        params['app_data_arr'] = shopsList.map(function (shop) {
          return {
            app_id: shop.app_id,
            pick_up_type: type
          };
        });
      } else {
        params = {
          pick_up_type: type,
          sub_shop_app_id: _this2.franchisee_id
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        method: 'post',
        data: params,
        success: function success(res) {
          if (_this.isFranchisee) {
            if (type == 3) {
              var _mulShopsInfo12 = _this.data.mulShopsInfo;

              Object.keys(res.data).forEach(function (key) {
                var configData = res.data[key].config_data;
                _mulShopsInfo12[key]['selfAppointmentSwitch'] = configData.pick_up_time_status == 1 && configData.appointment.status == 1 ? true : false;_mulShopsInfo12[key]['onlyImmediatlyPickSwitch'] = configData.pick_up_time_status == 1 && configData.appointment.status != 1 && configData.immediate_info.self_pcik_up_status == 1 ? true : false, _mulShopsInfo12[key]['selfDeliveryPhone'] = configData.is_phone;
                _mulShopsInfo12[key]['selfDeliveryScan'] = configData.pick_up_time_status == 1 && configData.immediate_info.status == 1 && configData.immediate_info.scan_qrcode_status == 1 ? true : false;
                if (_mulShopsInfo12[key].onlyImmediatlyPickSwitch) {
                  _this.selectedAppId = key;
                  _this.showServiceTime('onlyImme');
                }
              });
              _this.setData({
                mulShopsInfo: _mulShopsInfo12
              });
            } else if (type == 2) {
              var configData = res.data[_this.selectedAppId].config_data;
              _this.getsameJourneyTime(configData.business_rule);
            }
          } else {
            var _configData = res.data.config_data;
            if (type == 3 && _configData) {
              _this.setData({
                selfAppointmentSwitch: _configData.pick_up_time_status == 1 && _configData.appointment.status == 1 ? true : false,
                onlyImmediatlyPickSwitch: _configData.pick_up_time_status == 1 && _configData.appointment.status != 1 && _configData.immediate_info.self_pcik_up_status == 1 ? true : false,
                selfDeliveryPhone: _configData.is_phone,
                selfDeliveryScan: _configData.pick_up_time_status == 1 && _configData.immediate_info.status == 1 && _configData.immediate_info.scan_qrcode_status == 1 ? true : false
              });
              if (_this.data.onlyImmediatlyPickSwitch && _this.data.selectDelivery) {
                _this.showServiceTime('onlyImme');
              }
            } else if (type == 2 && _configData) {
              _this.getsameJourneyTime(_configData.business_rule);
            } else if (type == 4) {
              _this.setData({
                app_store_data: res.data.app_store_data || ''
              });
            }
          }
        }
      });
    };

    _this2.tostoreImmediately = function (e) {
      var setDataObj = {};
      if (_this2.isFranchisee) {
        var appId = e.currentTarget.dataset.appId;

        setDataObj['mulShopsInfo.' + appId + '.tostoreOrderType'] = 1;
        setDataObj['mulShopsInfo.' + appId + '.tostoreHourTime'] = '';
        setDataObj['isShowServiceTime'] = false;
      } else {
        setDataObj['tostoreOrderType'] = 1;
        setDataObj['tostoreHourTime'] = '';
        setDataObj['isShowServiceTime'] = false;
      }
      _this2.setData(setDataObj);
    };

    _this2.selectTostoreTime = function (e) {
      var _this = _this2;
      var mulShopsInfo = _this2.data.mulShopsInfo;

      var dateArr = _this2.isFranchisee ? mulShopsInfo[_this2.selectedAppId].getEcTostoredate.date_arr : _this2.data.getEcTostoredate.date_arr;
      var index = e.currentTarget.dataset.index;
      var tostoreDateTime = dateArr[index].date;
      var tostoreWeekTime = dateArr[index].week;
      if (_this2.isFranchisee) {
        var _this2$setData4;

        _this2.setData((_this2$setData4 = {}, (0, _defineProperty3.default)(_this2$setData4, 'mulShopsInfo.' + _this2.selectedAppId + '.tostoreOrderType', 2), (0, _defineProperty3.default)(_this2$setData4, 'mulShopsInfo.' + _this2.selectedAppId + '.dateIndex', index), (0, _defineProperty3.default)(_this2$setData4, 'mulShopsInfo.' + _this2.selectedAppId + '.tostoreDateTime', tostoreDateTime), (0, _defineProperty3.default)(_this2$setData4, 'mulShopsInfo.' + _this2.selectedAppId + '.tostoreWeekTime', tostoreWeekTime), (0, _defineProperty3.default)(_this2$setData4, 'isShowServiceTime', mulShopsInfo[_this.selectedAppId].tostoreTimeType != 1 ? true : false), _this2$setData4));
      } else {
        _this2.setData({
          tostoreOrderType: 2,
          dateIndex: index,
          tostoreDateTime: tostoreDateTime,
          tostoreWeekTime: tostoreWeekTime,
          isShowServiceTime: _this2.data.tostoreTimeType != 1 ? true : false
        });
      }
      _this2.getTostoreTime();
    };

    _this2.getTostoreTime = function () {
      var dataObj = {};
      if (_this2.isFranchisee) {
        var _mulShopsInfo13 = _this2.data.mulShopsInfo;

        dataObj = _mulShopsInfo13[_this2.selectedAppId];
      } else {
        dataObj = _this2.data;
      }
      var currentMonth = new Date().getMonth() + 1;
      var currentMinute = new Date().getMinutes();
      var startHours = new Date().getHours();
      var currentDay = new Date().getDate();
      var currentDate = (currentMonth < 10 ? '0' + currentMonth : currentMonth) + '-' + (currentDay < 10 ? '0' + currentDay : currentDay);
      var tostoreHoursArr = [];
      var currentLimitFlag = true;
      var businessTimeRule = dataObj.businessTimeRule;
      var tostoreWeekTime = Number(dataObj.tostoreWeekTime);
      var businessTime = void 0;
      var showImmediatelyTime = _this2.businessTimeType == 1 ? true : false; //1为全年 2为自定义
      var advanceAppointmentInfo = dataObj.advanceAppointmentInfo;
      var advanceTime = +advanceAppointmentInfo.num + startHours > 24 ? +advanceAppointmentInfo.num + startHours - 24 : +advanceAppointmentInfo.num + startHours;
      _this2.businessTimeType == 2 && businessTimeRule.map(function (item) {
        if (tostoreWeekTime == 0) {
          tostoreWeekTime = 7;
        }
        if (item.business_week[tostoreWeekTime - 1] == 1) {
          businessTime = item.business_time_interval;
        }
      });
      if (currentDate === dataObj.tostoreDateTime) {
        if (_this2.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = startHours; //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            if (startHours < advanceTime) {
              fSH = startHours = advanceTime;
            }
            if ((startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) && !advanceTime) {
              showImmediatelyTime = true;
            }
            if (startHours < sH) {
              startHours = sH;
              currentMinute = 0;
            } else if (startHours > eH) {
              return;
            }
            for (; startHours <= eH; startHours++) {
              if (dataObj.tostoreTimeType == 2) {
                if (startHours == fEH) {
                  continue;
                }
                tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
              } else {
                if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
                  tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                  continue;
                } else if (startHours == fSH && currentMinute > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (startHours == fEH && eT >= 30) {
                  tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                  continue;
                } else if (startHours == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
              }
            }
          });
        } else {
          if (startHours < advanceTime) {
            startHours = advanceTime;
          }
          for (; startHours < 24; startHours++) {
            if (dataObj.tostoreTimeType == 2) {
              if (currentLimitFlag && currentMinute > 0) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
            } else {
              if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
                currentLimitFlag = false;
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                continue;
              }
              if (currentLimitFlag && currentMinute > 30) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
              tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
            }
          }
        }
      } else {
        if (_this2.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = Number(item.start_time.substring(0, 2)); //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            if (dataObj.getEcTostoredate.date_arr[1].date == dataObj.tostoreDateTime && sH < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
              sH = advanceTime;
            }
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            for (; sH <= eH; sH++) {
              if (dataObj.tostoreTimeType == 2) {
                if (sH == fEH || sH == fSH && sT > 0) {
                  continue;
                }
                tostoreHoursArr.push(sH + ':00-' + (sH + 1) + ':00');
              } else {
                if (sH == fSH && sT <= 30 && sT != 0) {
                  tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
                  continue;
                } else if (sH == fSH && sT > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (sH == fEH && eT <= 30 && eT != 0) {
                  tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                  continue;
                } else if (sH == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
              }
            }
          });
        } else {
          var i = 0;
          if (dataObj.getEcTostoredate.date_arr[1].date == dataObj.tostoreDateTime && i < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
            i = advanceTime;
          }
          for (; i < 24; i++) {
            if (dataObj.tostoreTimeType == 2) {
              tostoreHoursArr.push(i + ':00-' + (i + 1) + ':00');
            } else {
              tostoreHoursArr.push(i + ':00-' + i + ':30');
              tostoreHoursArr.push(i + ':30-' + (i + 1) + ':00');
            }
          }
        }
      }
      if (_this2.isFranchisee) {
        var _this2$setData5;

        _this2.setData((_this2$setData5 = {}, (0, _defineProperty3.default)(_this2$setData5, 'mulShopsInfo.' + _this2.selectedAppId + '.tostoreHoursArr', tostoreHoursArr), (0, _defineProperty3.default)(_this2$setData5, 'mulShopsInfo.' + _this2.selectedAppId + '.showImmediatelyTime', showImmediatelyTime), _this2$setData5));
      } else {
        _this2.setData({
          tostoreHoursArr: tostoreHoursArr,
          showImmediatelyTime: showImmediatelyTime
        });
      }
    };

    _this2.selectTostoreHourTime = function (e) {
      var _this = _this2;
      var tostoreHoursArr = [];
      if (_this2.isFranchisee) {
        var _mulShopsInfo14 = _this2.data.mulShopsInfo;

        tostoreHoursArr = _mulShopsInfo14[_this2.selectedAppId].tostoreHoursArr;
      } else {
        tostoreHoursArr = _this2.data.tostoreHoursArr;
      }
      var index = e.currentTarget.dataset.index;
      var tostoreHourTime = tostoreHoursArr[index];
      if (_this2.isFranchisee) {
        var _this2$setData6;

        _this2.setData((_this2$setData6 = {}, (0, _defineProperty3.default)(_this2$setData6, 'mulShopsInfo.' + _this.selectedAppId + '.tostoreOrderType', 2), (0, _defineProperty3.default)(_this2$setData6, 'mulShopsInfo.' + _this.selectedAppId + '.tostoreHourTime', tostoreHourTime), (0, _defineProperty3.default)(_this2$setData6, 'isShowServiceTime', false), _this2$setData6));
      } else {
        _this2.setData({
          tostoreOrderType: 2,
          tostoreHourTime: tostoreHourTime,
          isShowServiceTime: false
        });
      }
    };

    _this2.showSameJourneyTime = function (e) {
      var appId = e.currentTarget.dataset.appId;

      _this2.selectedAppId = appId || '';
      if (_this2.isFranchisee) {
        // 多店
        _this2.setData({
          selectedAppId: appId
        });
      }
      if (!_this2.data.selectSameJourney.id) {
        _app.appMethod.showModal({
          content: '请先选择地址'
        });
        return;
      }
      _this2.getGoodsStoreSet(2);
    };

    _this2.getsameJourneyTime = function (businessRule) {
      var immediatlyTime = '';
      if (_this2.isFranchisee) {
        var _mulShopsInfo15 = _this2.data.mulShopsInfo;

        immediatlyTime = _mulShopsInfo15[_this2.selectedAppId].sameJourneyImmediatlyTime;
      } else {
        immediatlyTime = _this2.data.sameJourneyImmediatlyTime;
      }
      var sameJourneyHoursArr = [];
      var currentMinute = new Date().getMinutes() + Number(immediatlyTime);
      var startHours = new Date().getHours();
      if (currentMinute >= 60) {
        startHours++;
        currentMinute = currentMinute - 60;
      }
      if (businessRule.type == 1) {
        var currentLimitFlag = true;
        for (; startHours < 24; startHours++) {
          if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
            currentLimitFlag = false;
            sameJourneyHoursArr.push(startHours + ':30');
            continue;
          }
          if (currentLimitFlag && currentMinute > 30) {
            currentLimitFlag = false;
            startHours++;
          }
          sameJourneyHoursArr.push(startHours + ':00');
          sameJourneyHoursArr.push(startHours + ':30');
        }
      } else {
        var currentWeek = new Date().getDay();
        var businessTime = void 0;
        businessRule.type == 2 && businessRule.custom.business_time.map(function (item) {
          if (currentWeek == 0) {
            currentWeek = 7;
          }
          if (item.business_week[currentWeek - 1] == 1) {
            businessTime = item.business_time_interval;
          }
        });
        businessTime && businessTime.map(function (item) {
          var fSH = startHours; //是否要判断分钟，初始开始小时
          var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
          var sH = Number(item.start_time.substring(0, 2));
          var eH = Number(item.end_time.substring(0, 2));
          var sT = Number(item.start_time.substring(3, 5));
          var eT = Number(item.end_time.substring(3, 5));
          if (startHours <= sH) {
            startHours = sH;
            currentMinute = 0;
          } else if (startHours > eH) {
            return;
          }
          for (; startHours <= eH; startHours++) {
            if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
              sameJourneyHoursArr.push(startHours + ':30');
              continue;
            } else if (startHours == fSH && currentMinute > 30) {
              continue;
            } //开始分钟数大于三十分钟则跳过当前时间段
            if (startHours == fEH && eT < 30) {
              sameJourneyHoursArr.push(startHours + ':00');
              continue;
            } else if (startHours == fEH && eT == 0) {
              continue;
            } //结束分钟数等于0则跳过当前时间段
            sameJourneyHoursArr.push(startHours + ':00');
            sameJourneyHoursArr.push(startHours + ':30');
          }
        });
      }
      if (_this2.isFranchisee) {
        var _this2$setData7;

        _this2.setData((_this2$setData7 = {}, (0, _defineProperty3.default)(_this2$setData7, 'mulShopsInfo.' + _this2.selectedAppId + '.sameJourneyHoursArr', sameJourneyHoursArr), (0, _defineProperty3.default)(_this2$setData7, 'isShowSameJourneyTime', true), _this2$setData7));
      } else {
        _this2.setData({
          sameJourneyHoursArr: sameJourneyHoursArr,
          isShowSameJourneyTime: true
        });
      }
    };

    _this2.selectSameJourneyTime = function (e) {
      var _e$currentTarget$data5 = e.currentTarget.dataset,
          type = _e$currentTarget$data5.type,
          index = _e$currentTarget$data5.index;

      if (_this2.isFranchisee) {
        var _this2$setData8;

        var _this2$data6 = _this2.data,
            _mulShopsInfo16 = _this2$data6.mulShopsInfo,
            selectedAppId = _this2$data6.selectedAppId;

        var sameJourneyHoursArr = _mulShopsInfo16[selectedAppId].sameJourneyHoursArr;
        var sameJourneyDateTime = sameJourneyHoursArr[index];
        _this2.setData((_this2$setData8 = {}, (0, _defineProperty3.default)(_this2$setData8, 'mulShopsInfo.' + selectedAppId + '.sameJourneyTimeType', type == 'immedia' ? 1 : 2), (0, _defineProperty3.default)(_this2$setData8, 'mulShopsInfo.' + selectedAppId + '.sameJourneyDateTime', type == 'immedia' ? '' : sameJourneyDateTime), (0, _defineProperty3.default)(_this2$setData8, 'isShowSameJourneyTime', false), _this2$setData8));
      } else {
        var _sameJourneyHoursArr = _this2.data.sameJourneyHoursArr;
        var _index = e.currentTarget.dataset.index;
        var _sameJourneyDateTime = _sameJourneyHoursArr[_index];
        _this2.setData({
          sameJourneyTimeType: type == 'immedia' ? 1 : 2,
          sameJourneyDateTime: type == 'immedia' ? '' : _sameJourneyDateTime,
          isShowSameJourneyTime: false
        });
      }
    };

    _this2.inputPhone = function (e) {
      if (_this2.isFranchisee) {
        var appId = e.currentTarget.dataset.appId;
        var _mulShopsInfo17 = _this2.data.mulShopsInfo;

        Object.keys(_mulShopsInfo17).forEach(function (key) {
          var shopItem = _mulShopsInfo17[key];
          if (key == appId) {
            shopItem['phone'] = e.target.value;
          }
        });
        _this2.setData({
          mulShopsInfo: _mulShopsInfo17
        });
      } else {
        _this2.setData({
          phone: e.target.value
        });
      }
    };

    _this2.hidePerfectAddress = function () {
      _this2.setData({
        expressAddressNull: false
      });
    };

    _this2.manuallyAddAddress = function () {
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress');
    };

    _this2.importWeChatAddress = function () {
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.getCalculationInfo();
            }
          });
        }
      });
    };

    _this2.stopPropagation = function () {};

    _this2.showMoreGoods = function () {
      _this2.setData({
        showMoreGoods: !_this2.data.showMoreGoods
      });
    };

    _this2.needLoopRequest = true;

    _this2.loopRequestMultiOrder = function () {
      var that = _this2;
      _this2.timerId == 0 && _this2.getMultiOrder();
      clearTimeout(_this2.timerId);
      _this2.timerId = setTimeout(function () {
        that.getMultiOrder();
      }, 4000);
    };

    _this2.requestNum = 0;

    _this2.getMultiOrder = function () {
      var that = _this2;
      if (!that.needLoopRequest) return;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getMultiOrderingVerticalCart',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          location_id: _this2.data.ec_location_id,
          get_user_list: 1
        },
        hideLoading: true,
        success: function success(res) {
          that.needLoopRequest = false;
          if (res.is_notice) {
            clearTimeout(that.timerId);
            _app.appMethod.showModal({
              content: '您的同桌' + res.buyer_nickname + '已下单',
              confirmText: '知道了',
              confirm: function confirm() {
                _app.appMethod.turnBack();
              }
            });
            return;
          } else {
            clearTimeout(that.timerId);
            if (res.data.length == 0) {
              _app.appMethod.showModal({
                content: '商品被清空，请重新添加',
                confirmText: '知道了',
                confirm: function confirm() {
                  _app.appMethod.turnBack();
                }
              });
              return;
            }
          }
          that.loopRequestMultiOrder();
          if (!res.is_reload && that.requestNum > 0) return;
          that.requestNum += 1;
          that.is_reload = res.is_reload;
          that.cart_data_arr = []; // 清空购物车数据
          that.cart_id_arr = []; // 清空购物车id
          var buyer_list = res.buyer_info;
          var user_list = res.user_list;
          var data = [];
          data = res.data;
          for (var w = 0; w < user_list.length; w++) {
            if (user_list[w].is_myself == 1) {
              that.setData({
                my_self: user_list[w].buyer_id
              });
            }
          }
          for (var i = 0; i <= data.length - 1; i++) {
            var goods = data[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? modelArr.join('； ') : '';
            that.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
            goods.buyer_id == that.data.my_self ? that.cart_id_arr_my.push(data[i].id) : '';
            that.cart_id_arr.push(goods.id); // 多人购物车id_array
          }
          for (var a = 0; a < buyer_list.length; a++) {
            var num = 0;
            var buyer = buyer_list[a];
            for (var b = 0; b < data.length; b++) {
              var _goods = data[b];
              if (_goods.buyer_id == buyer.buyer_id) {
                num += _goods.num - 0;
                buyer.num = num;
              }
            }
          }
          that.setData({
            buyer_list: res.buyer_info,
            goodsList: data,
            only_me: false
          });
          data.length && that.getCalculationInfo();
        },
        fail: function fail() {
          _app.appMethod.showModal({
            content: '网络异常，请重新下单',
            confirm: function confirm() {
              _app.appMethod.turnBack();
            }
          });
        },
        complete: function complete(re) {
          that.needLoopRequest = true;
        }
      });
    };

    _this2.getDiningFuncSetting = function (callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getFuncSetting',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          ordering_food_type: 1, //1.堂食 2.预约
          pick_up_type: 4
        },
        success: function success(res) {
          var arr = res.data.take_meal_type || [];
          var brr = [];
          for (var i = 0; i < arr.length; i++) {
            brr.push({
              label: that.data.take_meal_type_text[arr[i]],
              value: arr[i]
            });
          }
          ;that.path = res.data.add_dish_info.page || '', that.setData({
            take_meal_type: arr[0],
            take_meal_type_arr: brr,
            location_status: res.data.location_status == 0 ? false : true,
            account_type: res.data.account_info.account_type,
            allow_add_dish: res.data.add_dish_info.allow_app_status == 1 ? true : false,
            allow_app_account: res.data.account_info.account_way[1] ? true : false
          });
          that.getGoodsStoreSet(4);
          typeof callback == 'function' && callback();
        }
      });
    };

    _this2.checkIsAddDishing = function () {
      var that = _this2;
      if (that.data.account_type == 1) {
        that.data.is_together ? that.loopRequestMultiOrder() : that.getCalculationInfo();
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/CheckLocationIsEmpty',
        data: {
          location_id: _this2.data.ec_location_id
        },
        success: function success(res) {
          that.setData({
            is_addDishing: !res.data,
            people_num: !res.data ? 0 : that.data.people_num
          });
          if (res.ec_dining_data) {
            if (res.ec_dining_data.dining_mode) {
              that.setData({
                dining_mode: res.ec_dining_data.dining_mode
              });
            }
            if (res.ec_dining_data.take_meal_type) {
              that.setData({
                take_meal_type: res.ec_dining_data.take_meal_type
              });
            }
          }
          that.data.is_together ? that.loopRequestMultiOrder() : that.getCalculationInfo();
        }
      });
    };

    _this2.turnToAddDish = function () {
      if (_this2.franchisee_id) {
        var that = _this2;
        _app.appMethod.showModal({
          title: '温馨提示',
          content: '子店商品继续点菜只能跳转子店首页或者连锁首页',
          showCancel: true,
          confirm: function confirm() {
            that.goToHomepage();
          }
        });
        return;
      }
      var form = JSON.parse(_this2.path);
      var action = form.action;
      customEvent.clickEventHandler[action] && customEvent.clickEventHandler[action](form, '', '');
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.franchisee_id;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({ delta: 2 });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
      }
    };

    _this2.selectCustomNum = function (e) {
      var people_num = e.target.value - 0;
      _this2.setData({
        people_num: people_num + 1
      });
      _this2.getCalculationInfo();
    };

    _this2.scanPlaceInfo = function (e) {
      var that = _this2;
      _this2.saveFormId(e.target.formId);
      _app.appMethod.scanCode({
        success: function success(res) {
          var path = res.path;
          if (!path) {
            _app.appMethod.showModal({
              content: '位置码错误，请重新扫码!',
              confirmText: '知道了'
            });
            return;
          }
          var args = path.split('?');
          if (args[0] == path) {
            return '';
          }
          var arr = args[1].split('&');
          var obj = {};
          for (var i = 0; i < arr.length; i++) {
            var arg = arr[i].split('=');
            obj[arg[0]] = arg[1];
          }
          var pre_location_id = that.data.ec_location_id;
          that.scanInitUserInfo(pre_location_id, obj.ec_location_id, that.checkIsAddDishing);
        },
        fail: function fail(re) {
          console.log(re);
        }
      });
    };

    _this2.scanInitUserInfo = function (pre_location_id, ec_location_id, callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/scanQrcodeInitCartUserInfo',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          pre_location_id: pre_location_id || '',
          location_id: ec_location_id || _this2.data.ec_location_id,
          cart_id_arr: _this2.cart_id_arr_my
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            if (that.franchisee_id) {
              _app.appMethod.globalData[that.franchisee_id] = {};
              _app.appMethod.globalData[that.franchisee_id].ec_location_id = ec_location_id;
            } else {
              _app.appMethod.globalData.ec_location_id = ec_location_id; // 更新全局座位id
            }
            that.setData({
              ec_location_id: ec_location_id,
              location_name: res.data.location_title || ''
            });
            typeof callback == 'function' && callback(that.getCalculationInfo);
          }
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          if (res.status == 1) {
            that.data.ec_location_id && that.data.is_together && that.loopRequestMultiOrder();
          }
        }
      });
    };

    _this2.changeTakeMealType = function (value) {
      var index = _this2.state.take_meal_type_arr.findIndex(function (item) {
        return item.value === value[0];
      });
      _this2.setData({
        take_meal_type_index: index,
        take_meal_type: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.changeDiningMode = function (value) {
      _this2.setData({
        dining_mode: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.changeCustomNum = function (value) {
      _this2.setData({
        people_num: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.turnToStore = function () {};

    _this2.callPhone = function (event) {
      _app.appMethod.callPhone(event);
    };

    _this2.showVipGoodsList = function () {
      _this2.setData({
        showVipGoodsList: true
      });
    };

    _this2.hideVipGoodsList = function () {
      _this2.setData({
        showVipGoodsList: false
      });
    };

    document.title = '确认支付';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData) {
      _this2.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this2;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(PreviewGoodsOrder, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      var callbackData = this.currentPage.callbackData;

      if (callbackData) {
        this.setData(callbackData);
        this.currentPage.clearCallbackData();
        if (this.currentPage.additional_info) {
          this.additional_info = this.currentPage.additional_info;
          delete this.currentPage.additional_info;
        }
        if (this.currentPage.hasRequiredSuppInfo) {
          this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
          delete this.currentPage.hasRequiredSuppInfo;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.isFranchisee = options.isFranchisee ? true : false;
      this.franchisee_id = options.franchisee || '';
      var is_together = options.is_together === 'true' ? true : false;
      var teamToken = options.team_token || '';
      var group_buy_people = options.group_buy_people || 0;
      var limit_buy = options.limit_buy || '';
      var pickUpType = options.type || ''; // TODO
      var addressId = options.addressId || '';
      var ec_location_id = '';
      if (this.franchisee_id) {
        ec_location_id = _app.appMethod.globalData[this.franchisee_id] ? _app.appMethod.globalData[this.franchisee_id].ec_location_id : '';
      } else {
        ec_location_id = options.ec_location_id || _app.appMethod.globalData.ec_location_id || '';
      }
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      this.is_group = options.is_group || '';
      this.setData({
        ec_location_id: ec_location_id,
        is_together: is_together,
        pickUpType: pickUpType,
        canChangeSelect: pickUpType == 4 ? false : true,
        sameJourneyTimeType: pickUpType == 2 ? 1 : '',
        selectSameJourneyId: pickUpType == 2 ? addressId : '',
        selectAddressId: pickUpType == 1 ? addressId : '',
        limit_buy: limit_buy,
        is_group: this.is_group,
        teamToken: teamToken,
        group_buy_people: group_buy_people,
        phone: _app.appMethod.getUserInfo().phone,
        isFranchisee: this.isFranchisee
      });
      this.dataInitial();
      // WEBAPP特殊处理(这里是有问题的，待解决)
      setTimeout(function () {
        _this3.handleCurrentPage();
      }, 0);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromSelectAddress) {
        this.getCalculationInfo();
        this.isFromSelectAddress = false;
      }
      if (this.onlyImme) {
        this.showServiceTime('onlyImme');
        this.onlyImme = false;
      }
    }
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {
      clearTimeout(this.timerId);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timerId);
      this.setState = function (staett, cb) {
        return;
      };
    }
    // wxPay = param => {
    //   app.requestPayment({
    //     timeStamp: param.timeStamp,
    //     nonceStr: param.nonceStr,
    //     package: param.package,
    //     signType: param.signType,
    //     paySign: param.paySign,
    //     success: function (res) {
    //       app.wxPaySuccess(param)
    //       param.success()
    //     },
    //     fail: function (res) {
    //       if (res.errMsg === 'requestPayment:fail cancel') {
    //         app.showModal({
    //           content: '支付已取消',
    //           complete: param.fail
    //         })
    //         return
    //       }
    //       app.showModal({
    //         content: '支付失败',
    //         complete: param.fail
    //       })
    //       app.wxPayFail(param, res.errMsg)
    //     }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _React$createElement,
          _this4 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          isLeagueBenefit = _state.isLeagueBenefit,
          leagueBenefitData = _state.leagueBenefitData,
          mulShopsInfo = _state.mulShopsInfo,
          selectedAppId = _state.selectedAppId,
          isFranchisee = _state.isFranchisee,
          discountList = _state.discountList,
          is_addDishing = _state.is_addDishing,
          location_name = _state.location_name,
          customNumArr = _state.customNumArr,
          people_num = _state.people_num,
          pickUpTypeArr = _state.pickUpTypeArr,
          canChangeSelect = _state.canChangeSelect,
          pickUpType = _state.pickUpType,
          storeStyle = _state.storeStyle,
          selectAddress = _state.selectAddress,
          selectDelivery = _state.selectDelivery,
          selectSameJourney = _state.selectSameJourney,
          dining_mode_arr = _state.dining_mode_arr,
          dining_mode = _state.dining_mode,
          take_meal_type_arr = _state.take_meal_type_arr,
          take_meal_type_index = _state.take_meal_type_index,
          take_meal_type = _state.take_meal_type,
          ec_location_id = _state.ec_location_id,
          app_store_data = _state.app_store_data,
          goodsList = _state.goodsList,
          showMoreGoods = _state.showMoreGoods,
          buyer_list = _state.buyer_list,
          my_self = _state.my_self,
          only_me = _state.only_me,
          is_group = _state.is_group,
          sameJourneyTimeType = _state.sameJourneyTimeType,
          sameJourneyImmediatlyTime = _state.sameJourneyImmediatlyTime,
          sameJourneyDateTime = _state.sameJourneyDateTime,
          tostoreDateTime = _state.tostoreDateTime,
          tostoreTimeType = _state.tostoreTimeType,
          tostoreOrderType = _state.tostoreOrderType,
          waitingQueueTime = _state.waitingQueueTime,
          tostoreHourTime = _state.tostoreHourTime,
          selfAppointmentSwitch = _state.selfAppointmentSwitch,
          onlyImmediatlyPickSwitch = _state.onlyImmediatlyPickSwitch,
          phone = _state.phone,
          selfDeliveryPhone = _state.selfDeliveryPhone,
          inStoreSeatName = _state.inStoreSeatName,
          selfDeliveryScan = _state.selfDeliveryScan,
          exchangeCouponData = _state.exchangeCouponData,
          tissue_fee = _state.tissue_fee,
          server_fee = _state.server_fee,
          box_fee = _state.box_fee,
          original_price = _state.original_price,
          express_fee = _state.express_fee,
          account_type = _state.account_type,
          selectDiscountInfo = _state.selectDiscountInfo,
          selectDiscountIndex = _state.selectDiscountIndex,
          discount_cut_price = _state.discount_cut_price,
          vip_cut_price = _state.vip_cut_price,
          is_vip_order = _state.is_vip_order,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          cashOnDelivery = _state.cashOnDelivery,
          totalPayment = _state.totalPayment,
          canCashDelivery = _state.canCashDelivery,
          selfPayOnDelivery = _state.selfPayOnDelivery,
          hasRequiredSuppInfo = _state.hasRequiredSuppInfo,
          deliverydWrite = _state.deliverydWrite,
          noAdditionalInfo = _state.noAdditionalInfo,
          aloneDeliveryShow = _state.aloneDeliveryShow,
          orderRemark = _state.orderRemark,
          total_discount_cut_price = _state.total_discount_cut_price,
          allow_add_dish = _state.allow_add_dish,
          dialogHidden = _state.dialogHidden,
          selectModelInfo = _state.selectModelInfo,
          goodsInfo = _state.goodsInfo,
          additional_info = _state.additional_info,
          additional_goodsid_arr = _state.additional_goodsid_arr,
          shopsList = _state.shopsList,
          is_vip_goods = _state.is_vip_goods,
          isMember = _state.isMember,
          allShopsCashOnDelivery = _state.allShopsCashOnDelivery,
          intraCityData = _state.intraCityData,
          dining_data = _state.dining_data,
          goodsIcon = _state.goodsIcon,
          express_data = _state.express_data,
          isShowPickMask = _state.isShowPickMask,
          noImmediaPick = _state.noImmediaPick,
          showImmediatelyTime = _state.showImmediatelyTime,
          getEcTostoredate = _state.getEcTostoredate,
          dateIndex = _state.dateIndex,
          tostoreHoursArr = _state.tostoreHoursArr,
          noAppointmentShow = _state.noAppointmentShow,
          noAppointmentWordb = _state.noAppointmentWordb,
          noAppointmentWorda = _state.noAppointmentWorda,
          isShowServiceTime = _state.isShowServiceTime,
          sameJourneyHoursArr = _state.sameJourneyHoursArr,
          isShowSameJourneyTime = _state.isShowSameJourneyTime,
          expressAddressNull = _state.expressAddressNull,
          vip_cart_info = _state.vip_cart_info,
          vip_goods_list = _state.vip_goods_list,
          showVipGoodsList = _state.showVipGoodsList;

      // 地址选择之后的回调数据

      var _app$getCurrentPage = _app.appMethod.getCurrentPage(),
          callbackData = _app$getCurrentPage.callbackData;

      if (callbackData) {
        selectAddress = callbackData.selectAddress;
        this.state.selectAddress = callbackData.selectAddress;
      }

      customNumArr = customNumArr.map(function (item) {
        return { label: item, value: item };
      });
      return _react2.default.createElement(
        'div',
        { className: 'official-page preview-goods-order' },
        !isFranchisee && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'preview-goods-wrap' },
            is_addDishing && _react2.default.createElement(
              'div',
              {
                className: 'pick-method flex-between',
                style: (0, _tools.convertLineStyleData)('font-weight:bold;')
              },
              _react2.default.createElement(
                'span',
                null,
                '\u684C\u4F4D\u53F7'
              ),
              _react2.default.createElement(
                'span',
                null,
                location_name
              )
            ),
            is_addDishing && _react2.default.createElement(
              'div',
              { className: 'pick-method', style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;') },
              _react2.default.createElement(
                _picker2.default,
                {
                  className: 'pick-method-box',
                  style: (0, _tools.convertLineStyleData)('border-bottom:0;'),
                  cols: 1,
                  data: customNumArr,
                  value: [1],
                  onChange: this.selectCustomNum
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                    '\u5C31\u9910\u4EBA\u6570'
                  ),
                  _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right pick-method-title',
                      style: (0, _tools.convertLineStyleData)('font-weight:bold;')
                    },
                    people_num
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'pick-method',
                onClick: pickUpTypeArr && pickUpTypeArr.length > 1 && canChangeSelect ? this.selectPickMethod : null,
                hidden: is_addDishing,
                style: (0, _tools.convertLineStyleData)(pickUpType == 4 ? 'margin-bottom:20rpx;' : '')
              },
              _react2.default.createElement(
                'div',
                { className: 'pick-method-box' },
                _react2.default.createElement('span', {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'ico-moon icon-goods-pick-model'
                }),
                '\u53D6\u8D27\u65B9\u5F0F',
                pickUpTypeArr && pickUpTypeArr.length > 1 && canChangeSelect && _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right pick-method-title' },
                  pickUpType == 1 ? '快递' : pickUpType == 2 ? '同城' : pickUpType == 3 ? '自提' : '堂食点餐'
                )
              )
            ),
            pickUpType == 1 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectAddress && selectAddress.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goToMyAddress,
                    'data-address-id': selectAddress.id
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectAddress.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectAddress.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-box',
                    onClick: this.goToMyAddress
                  },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u65B0\u589E\u5730\u5740'
                    )
                  )
                )
              )
            ),
            pickUpType == 3 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectDelivery && selectDelivery.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.toDeliveryList,
                    'data-address-id': selectDelivery.id
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u81EA\u63D0'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectDelivery.contact_name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectDelivery.contact_phone
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectDelivery.region_data.region_string + selectDelivery.address_detail
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-box',
                    onClick: this.toDeliveryList
                  },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u9009\u62E9\u81EA\u63D0\u70B9'
                    )
                  )
                )
              )
            ),
            pickUpType == 2 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectSameJourney && selectSameJourney.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goSameJourneyAddress
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u540C\u57CE'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectSameJourney.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectSameJourney.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectSameJourney.address_info.province.text + selectSameJourney.address_info.city.text + selectSameJourney.address_info.district.text + selectSameJourney.address_info.detailAddress
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'address-null-box' },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    { onClick: this.goSameJourneyAddress },
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u9009\u62E9\u540C\u57CE\u5730\u5740'
                    )
                  )
                )
              )
            ),
            pickUpType != 4 && _react2.default.createElement(
              'div',
              { className: 'address-bg' },
              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png' })
            ),
            pickUpType == 4 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              !is_addDishing && _react2.default.createElement(
                'div',
                { className: 'eating-info-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'eating-info-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { className: 'mustFill' },
                    '\u5C31\u9910\u4EBA\u6570'
                  ),
                  _react2.default.createElement(
                    _picker2.default,
                    {
                      className: 'eating-picker',
                      cols: 1,
                      data: customNumArr,
                      value: [+people_num],
                      onChange: this.changeCustomNum
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                        people_num || 1
                      ),
                      _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'eating-info-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { className: 'mustFill' },
                    '\u5C31\u9910\u65B9\u5F0F'
                  ),
                  _react2.default.createElement(
                    _picker2.default,
                    {
                      className: 'eating-picker',
                      cols: 1,
                      data: dining_mode_arr,
                      value: [dining_mode],
                      onChange: this.changeDiningMode
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                        dining_mode == 2 ? '打包' : '堂食'
                      ),
                      _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'eating-info-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { className: 'mustFill' },
                    '\u53D6\u9910\u65B9\u5F0F'
                  ),
                  _react2.default.createElement(
                    _picker2.default,
                    {
                      className: 'eating-picker',
                      cols: 1,
                      data: take_meal_type_arr,
                      onChange: this.changeTakeMealType,
                      value: [take_meal_type]
                    },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                        take_meal_type_arr[take_meal_type_index] && take_meal_type_arr[take_meal_type_index].label
                      ),
                      _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'eating-info-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: take_meal_type == 1 ? 'mustFill' : ''
                    },
                    '\u684C\u53F7'
                  ),
                  _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      'button',
                      (_React$createElement = {
                        type: 'button',
                        className: 'flex-between buryPoint',
                        style: (0, _tools.convertLineStyleData)('flex:1;')
                      }, (0, _defineProperty3.default)(_React$createElement, 'style', (0, _tools.convertLineStyleData)('color:#999;text-align:right;width:100%;')), (0, _defineProperty3.default)(_React$createElement, 'onClick', this.scanPlaceInfo), _React$createElement),
                      _react2.default.createElement(
                        'span',
                        null,
                        ec_location_id ? location_name : '扫码获取位置信息'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-shopping-scan',
                        style: (0, _tools.convertLineStyleData)('padding-left:20rpx;font-size:30rpx;color:#999;')
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'dining-shop-box' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'dining-shop flex-between',
                    onClick: this.turnToStore
                  },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:28rpx;font-weight:bold;') },
                    app_store_data && app_store_data.title
                  ),
                  _react2.default.createElement('span', {
                    className: 'ico-moon icon-fn-phone icon-right',
                    style: (0, _tools.convertLineStyleData)('font-size:44rpx;color:#D2D2D2;'),
                    'data-phone': app_store_data && app_store_data.contact_phone,
                    onClick: this.callPhone
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'order-info-wrapper',
                  style: (0, _tools.convertLineStyleData)('height:' + (goodsList.length > 3 && !showMoreGoods ? '300rpx' : 'auto') + ';overflow:hidden;')
                },
                buyer_list && buyer_list.map(function (buyer, buyerIndex) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: 'preview-buyer-list',
                      key: buyerIndex,
                      style: (0, _tools.convertLineStyleData)('background-color:#fff;')
                    },
                    buyer && buyer.num > 0 && _react2.default.createElement(
                      'div',
                      { className: 'custom-info-wrapper flex-between' },
                      _react2.default.createElement(
                        'div',
                        { className: 'flex-between' },
                        _react2.default.createElement(
                          'div',
                          { className: 'custom-info' },
                          _react2.default.createElement('img', { src: buyer.cover_thumb })
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'custom-name' },
                          buyer.nickname + (buyer.buyer_id == my_self || only_me ? '（我）' : '')
                        )
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'custom-selected' },
                        '已选' + buyer.num + '份商品'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-order-list' },
                      _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        goodsList.map(function (goods, goodsIndex) {
                          if (buyer.buyer_id == goods.buyer_id) {
                            return _react2.default.createElement(
                              'div',
                              {
                                className: 'preview-goods-order-item',
                                style: (0, _tools.convertLineStyleData)(goodsList.length < 3 && !showMoreGoods ? 'border-bottom:0;padding-bottom:0;' : ''),
                                key: goodsIndex
                              },
                              _react2.default.createElement('img', {
                                className: 'preview-goods-cover',
                                src: goods.cover,
                                mode: 'aspectFill'
                              }),
                              _react2.default.createElement(
                                'div',
                                { className: 'preview-goods-content' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'preview-goods-title' },
                                  goods.max_can_use_integral > 0 && _react2.default.createElement(
                                    'span',
                                    { className: 'goods-special' },
                                    '\u79EF'
                                  ),
                                  is_group && _react2.default.createElement(
                                    'span',
                                    { className: 'exchange-tip' },
                                    '\u62FC\u56E2'
                                  ),
                                  goods.is_seckill == 1 && _react2.default.createElement(
                                    'span',
                                    { className: 'exchange-tip' },
                                    '\u79D2\u6740'
                                  ),
                                  goods.title
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-type' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'type-taste' },
                                    goods.model_value_str
                                  )
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-price-box' },
                                  goods.integral != '2' ? _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    _react2.default.createElement(
                                      'span',
                                      {
                                        className: 'preview-goods-price',
                                        style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                      },
                                      '¥' + goods.original_price
                                    ),
                                    goods.virtual_price > 0 && _react2.default.createElement(
                                      'span',
                                      {
                                        className: 'preview-goods-price',
                                        style: (0, _tools.convertLineStyleData)('margin-left:10rpx;color:#999;text-decoration:line-through;')
                                      },
                                      '¥ ' + goods.virtual_price
                                    )
                                  ) : _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    goods.price != '0.00' && _react2.default.createElement(
                                      'span',
                                      {
                                        className: 'preview-goods-price',
                                        style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                      },
                                      '¥ ' + goods.price
                                    ),
                                    goods.price != '0.00' && goods.use_integral != 0 && _react2.default.createElement(
                                      'span',
                                      {
                                        className: 'preview-goods-price',
                                        style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                      },
                                      '+'
                                    ),
                                    goods.use_integral != 0 && _react2.default.createElement(
                                      'span',
                                      {
                                        className: 'preview-goods-price',
                                        style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                      },
                                      goods.max_can_use_integral + '积分'
                                    )
                                  ),
                                  !is_group && _react2.default.createElement(
                                    'div',
                                    { className: 'good-number-box pull-right' },
                                    _react2.default.createElement(
                                      'div',
                                      {
                                        className: 'goods-minus',
                                        'data-index': goodsIndex,
                                        onClick: _this4.clickMinusButton
                                      },
                                      '-'
                                    ),
                                    _react2.default.createElement('input', {
                                      className: 'goods-count',
                                      'data-index': goodsIndex,
                                      type: 'number',
                                      value: goods.num,
                                      onChange: _this4.inputGoodsCount
                                    }),
                                    _react2.default.createElement(
                                      'div',
                                      {
                                        className: 'goods-plus',
                                        style: (0, _tools.convertLineStyleData)('color:' + (goods.stock - 0 > goods.num - 0 && (goods.buyer_id == my_self || only_me) ? storeStyle.theme : '#d2d2d2')),
                                        'data-index': goodsIndex,
                                        onClick: goods.stock > goods.num && (goods.buyer_id == my_self || only_me) ? _this4.clickPlusButton : null
                                      },
                                      '+'
                                    )
                                  ),
                                  is_group && _react2.default.createElement(
                                    'div',
                                    { className: 'good-number-box pull-right' },
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'group-count' },
                                      '数量：' + goods.num
                                    )
                                  )
                                )
                              )
                            );
                          }
                        })
                      )
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'goods-showMore',
                  hidden: goodsList.length < 4
                },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-more',
                    hidden: showMoreGoods,
                    onClick: this.showMoreGoods
                  },
                  '\u5C55\u5F00\u66F4\u591A',
                  _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-more',
                    hidden: !showMoreGoods,
                    onClick: this.showMoreGoods
                  },
                  '\u70B9\u51FB\u6536\u8D77',
                  _react2.default.createElement('span', { className: 'ico-moon icon-uparrow' })
                )
              )
            ),
            pickUpType == 2 && _react2.default.createElement(
              'div',
              { className: 'preview-box border-bottom30' },
              _react2.default.createElement(
                'div',
                {
                  onClick: this.showSameJourneyTime,
                  className: 'single-box'
                },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    sameJourneyTimeType == 1 ? '尽快送达(预计' + (sameJourneyImmediatlyTime || '') + '分钟后送达)' : sameJourneyDateTime ? '大约' + sameJourneyDateTime + '送达' : '请选择送达时间'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              )
            ),
            pickUpType == 3 && _react2.default.createElement(
              'div',
              { className: 'preview-box border-bottom30' },
              selfAppointmentSwitch && _react2.default.createElement(
                'div',
                {
                  onClick: this.showServiceTime,
                  className: 'single-box'
                },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  tostoreTimeType == 1 && tostoreDateTime && tostoreOrderType == 2 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime)
                  ) : tostoreTimeType == 1 && tostoreOrderType == 1 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    waitingQueueTime == 0 ? '立即取货' : '大约等待' + waitingQueueTime + '分钟'
                  ) : tostoreTimeType != 1 && tostoreHourTime && tostoreOrderType == 2 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime) + ' ' + tostoreHourTime
                  ) : tostoreTimeType != 1 && tostoreOrderType == 1 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime) + (waitingQueueTime == 0 ? ' 立即取货' : '大约等待' + waitingQueueTime + '分钟')
                  ) : _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u8BF7\u9009\u62E9\u65F6\u95F4'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              onlyImmediatlyPickSwitch && waitingQueueTime >= 0 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟'
                  )
                )
              ),
              selfDeliveryPhone == 1 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u8054\u7CFB\u624B\u673A\u53F7',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right input-phone-box' },
                  _react2.default.createElement('input', {
                    type: 'text',
                    onChange: this.inputPhone,
                    value: phone,
                    placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
                  }),
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'get-phone-number'
                      // openType="getPhoneNumber"
                      , onClick: this.getPhoneNumber,
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u81EA\u52A8\u586B\u5199'
                  )
                )
              ),
              selfDeliveryScan && _react2.default.createElement(
                'div',
                {
                  className: 'single-box',
                  onClick: this.getInStoreSeat
                },
                '\u5E97\u5185\u4F4D\u7F6E',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right scan-seat-box' },
                  _react2.default.createElement(
                    'span',
                    null,
                    inStoreSeatName || '请扫码获取位置信息'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-shopping-scan' })
                )
              )
            ),
            pickUpType != 4 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              goodsList.map(function (goods, goodsIndex) {
                return _react2.default.createElement(
                  'div',
                  { className: 'preview-goods-order-list', key: goods.id },
                  _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-order-item' },
                    _react2.default.createElement('img', {
                      className: 'preview-goods-cover',
                      src: goods.cover,
                      mode: 'aspectFill'
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-content' },
                      _react2.default.createElement(
                        'div',
                        { className: 'preview-goods-title' },
                        is_group && _react2.default.createElement(
                          'span',
                          { className: 'exchange-tip' },
                          '\u62FC\u56E2'
                        ),
                        goods.cart_vip_goods == 1 && _react2.default.createElement(
                          'span',
                          {
                            className: 'exchange-tip',
                            style: (0, _tools.convertLineStyleData)('width:75rpx;')
                          },
                          '\u4F1A\u5458\u4EF7'
                        ),
                        goods.is_seckill == 1 && _react2.default.createElement(
                          'span',
                          { className: 'exchange-tip' },
                          '\u79D2\u6740'
                        ),
                        goods.title
                      ),
                      goods.model_value_str && _react2.default.createElement(
                        'div',
                        { className: 'preview-goods-model' },
                        goods.model_value_str
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-price-box' },
                        goods.integral != '2' ? _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'preview-goods-price',
                              style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                            },
                            '¥' + goods.price
                          )
                        ) : _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          goods.price != '0.00' && _react2.default.createElement(
                            'span',
                            {
                              className: 'preview-goods-price',
                              style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                            },
                            '¥' + goods.price
                          ),
                          goods.price != '0.00' && goods.use_integral != 0 && _react2.default.createElement(
                            'span',
                            {
                              className: 'preview-goods-price',
                              style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                            },
                            '+'
                          ),
                          goods.use_integral != 0 && _react2.default.createElement(
                            'span',
                            {
                              className: 'preview-goods-price',
                              style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                            },
                            goods.max_can_use_integral + '积分'
                          )
                        ),
                        !is_group && _react2.default.createElement(
                          'div',
                          { className: 'good-number-box pull-right' },
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'goods-minus',
                              'data-index': goodsIndex,
                              onClick: _this4.clickMinusButton
                            },
                            '-'
                          ),
                          _react2.default.createElement('input', {
                            className: 'goods-count',
                            'data-index': goodsIndex,
                            type: 'number',
                            value: goods.num,
                            onChange: _this4.inputGoodsCount
                          }),
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'goods-plus',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                              'data-index': goodsIndex,
                              onClick: _this4.clickPlusButton
                            },
                            '+'
                          )
                        ),
                        is_group && _react2.default.createElement(
                          'div',
                          { className: 'good-number-box pull-right' },
                          _react2.default.createElement(
                            'div',
                            { className: 'group-count' },
                            '数量：' + goods.num
                          )
                        )
                      )
                    )
                  )
                );
              })
            ),
            exchangeCouponData.hasSelectGoods && _react2.default.createElement(
              'div',
              { className: 'preview-goods-order-list' },
              _react2.default.createElement(
                'div',
                { className: 'preview-goods-order-item' },
                _react2.default.createElement('img', {
                  className: 'preview-goods-cover',
                  src: exchangeCouponData.goodsInfo.cover
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'preview-goods-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-title' },
                    _react2.default.createElement(
                      'span',
                      { className: 'exchange-tip' },
                      '\u8D60\u54C1'
                    ),
                    exchangeCouponData.goodsInfo.title
                  ),
                  exchangeCouponData.goodsInfo.model_value_str && _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-model' },
                    exchangeCouponData.goodsInfo.model_value_str
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-number-contain' },
                    _react2.default.createElement(
                      'div',
                      { className: 'exchange-num pull-right' },
                      'x1'
                    )
                  )
                )
              )
            ),
            pickUpType == 4 && _react2.default.createElement(
              'div',
              { className: 'other-price-wrpper' },
              tissue_fee > 0 && _react2.default.createElement(
                'div',
                {
                  className: 'other-price-item flex-between',
                  hidden: is_addDishing
                },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u7EB8\u5DFE\u8D39'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '¥' + tissue_fee
                )
              ),
              server_fee > 0 && _react2.default.createElement(
                'div',
                { className: 'other-price-item flex-between' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u670D\u52A1\u8D39'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '¥' + server_fee
                )
              ),
              box_fee > 0 && _react2.default.createElement(
                'div',
                { className: 'other-price-item flex-between' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u5305\u88C5\u8D39'
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '¥' + box_fee
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'preview-box' },
              !is_addDishing && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u5546\u54C1\u91D1\u989D',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + original_price
                )
              ),
              box_fee > 0 && pickUpType == 2 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u5305\u88C5\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + box_fee
                )
              ),
              pickUpType != 4 && pickUpType != 3 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u8FD0\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + (express_fee || 0)
                )
              ),
              !!discountList.length && _react2.default.createElement(
                'div',
                {
                  onClick: this.showMemberDiscount,
                  hidden: pickUpType == 4 && account_type == 2
                },
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'pull-right select-discount' },
                    selectDiscountInfo.name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    hidden: selectDiscountIndex == 0,
                    className: 'balance-price'
                  },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '- ¥' + discount_cut_price
                  )
                )
              ),
              is_vip_order == 1 && vip_cut_price != '0.00' && !is_addDishing && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                pickUpType == 4 && _react2.default.createElement(
                  'div',
                  {
                    className: 'balance-switch',
                    onClick: this.showVipGoodsList
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F1A\u5458\u4EF7\u4F18\u60E0'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'pull-right select-discount' },
                    '\u67E5\u770B\u8BE6\u60C5'
                  )
                ),
                pickUpType != 4 && _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F1A\u5458\u4EF7\u4F18\u60E0'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'balance-price' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';line-height:24rpx;')
                    },
                    '- ¥' + vip_cut_price
                  )
                )
              ),
              balance != 0 && _react2.default.createElement(
                'div',
                { hidden: pickUpType == 4 && account_type == 2 },
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F7F\u7528\u50A8\u503C\u91D1'
                  ),
                  _react2.default.createElement(_switch2.default, {
                    color: storeStyle.theme,
                    style: (0, _tools.convertLineStyleData)('transform:scale(0.7);'),
                    className: 'pull-right',
                    checked: useBalance,
                    onChange: function onChange(e) {
                      return _this4.useBalanceChange(e, '');
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { hidden: !useBalance, className: 'balance-price' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '- ¥' + deduction
                  )
                )
              ),
              totalPayment > 0 && (pickUpType == 1 && canCashDelivery == 1 || pickUpType == 3 && selfPayOnDelivery == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8D27\u5230\u4ED8\u6B3E\uFF08\u5148\u4E0B\u5355\uFF0C\u9A8C\u8D27\u540E\u652F\u4ED8\uFF09'
                  ),
                  _react2.default.createElement(_switch2.default, {
                    color: storeStyle.theme,
                    style: (0, _tools.convertLineStyleData)('transform:scale(0.8);'),
                    className: 'pull-right',
                    onChange: function onChange(e) {
                      return _this4.useCashDelivery(e, '');
                    },
                    checked: cashOnDelivery
                  })
                )
              )
            ),
            pickUpType == 4 ? _react2.default.createElement(
              'div',
              { className: 'preview-box' },
              !noAdditionalInfo && !aloneDeliveryShow && _react2.default.createElement(
                'div',
                {
                  className: 'border-top1 single-box',
                  onClick: this.goToAdditionalInfo
                },
                '\u8865\u5145\u4FE1\u606F',
                _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                _react2.default.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + (hasRequiredSuppInfo && !deliverydWrite ? storeStyle.theme : '#666')),
                    className: 'additional-tip pull-right'
                  },
                  deliverydWrite ? '已填写' : '未填写'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'buyer-message single-box' },
                '\u5907\u6CE8',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right' },
                  _react2.default.createElement('input', {
                    className: 'remark',
                    maxLength: '30',
                    value: orderRemark,
                    onChange: this.remarkInput,
                    placeholder: '\u5907\u6CE8\u53E3\u5473\u3001\u504F\u597D\u7B49'
                  })
                )
              )
            ) : pickUpType != 4 && _react2.default.createElement(
              'div',
              { className: 'preview-box' },
              _react2.default.createElement(
                'div',
                { className: 'buyer-message single-box' },
                '\u4E70\u5BB6\u7559\u8A00',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right' },
                  _react2.default.createElement('input', {
                    className: 'remark',
                    maxLength: '30',
                    value: orderRemark,
                    onChange: this.remarkInput,
                    placeholder: '\u4E70\u5BB6\u7559\u8A00'
                  })
                )
              ),
              !noAdditionalInfo && !aloneDeliveryShow && _react2.default.createElement(
                'div',
                {
                  className: 'border-top1 single-box',
                  onClick: this.goToAdditionalInfo
                },
                '\u8865\u5145\u4FE1\u606F',
                _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                _react2.default.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + (hasRequiredSuppInfo && !deliverydWrite ? storeStyle.theme : '#666')),
                    className: 'additional-tip pull-right'
                  },
                  deliverydWrite ? '已填写' : '未填写'
                )
              )
            ),
            aloneDeliveryShow && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              additional_goodsid_arr[0] && additional_info[additional_goodsid_arr[0]] && additional_info[additional_goodsid_arr[0]].map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'additional-list', key: index },
                  item.type == 'text' && _react2.default.createElement(
                    'div',
                    { className: 'additional-text' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      _react2.default.createElement('input', {
                        type: 'text',
                        onChange: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'mul-text' && _react2.default.createElement(
                    'div',
                    { className: 'additional-textarea' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      _react2.default.createElement('textarea', {
                        maxLength: '-1',
                        onInput: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'picture' && _react2.default.createElement(
                    'div',
                    { className: 'additional-picture' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      item.value && item.value.map(function (imgSrc, imageIndex) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'image-list', key: imageIndex },
                          _react2.default.createElement('img', { src: imgSrc }),
                          _react2.default.createElement(
                            'label',
                            {
                              className: 'delete-image ico-moon icon-closes',
                              onClick: _this4.deleteImage,
                              'data-image-index': imageIndex
                            },
                            '-'
                          )
                        );
                      }),
                      item.value.length < 9 && _react2.default.createElement(
                        'div',
                        {
                          className: 'add-images',
                          onClick: _this4.addDeliveryImg
                        },
                        _react2.default.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                        _react2.default.createElement(
                          'div',
                          null,
                          '\u6DFB\u52A0\u56FE\u7247'
                        )
                      )
                    )
                  )
                );
              })
            ),
            pickUpType == 4 ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              account_type == 1 && _react2.default.createElement(
                'div',
                { className: 'all-price-box flex-between' },
                _react2.default.createElement(
                  'div',
                  { className: 'all-price' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5408\u8BA1\uFF1A'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'all-price-now priceNow',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '￥' + totalPayment
                  ),
                  total_discount_cut_price > 0 && _react2.default.createElement(
                    'span',
                    {
                      className: 'discounted-price',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + ';')
                    },
                    '已优惠￥' + total_discount_cut_price
                  )
                ),
                _react2.default.createElement(
                  'form',
                  null,
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'all-price-calculate',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + '; width:210rpx;border-radius:0;font-size:28rpx;'),
                      onClick: this.confirmPayment
                    },
                    '\u53BB\u7ED3\u7B97'
                  )
                )
              ),
              account_type == 2 && _react2.default.createElement(
                'div',
                { className: 'all-price-box flex-between' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'add-dishs',
                    hidden: !allow_add_dish,
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';font-size:28rpx;'),
                    onClick: this.turnToAddDish
                  },
                  '\u7EE7\u7EED\u70B9\u83DC'
                ),
                _react2.default.createElement(
                  'form',
                  { style: (0, _tools.convertLineStyleData)('flex:1;') },
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'all-price-calculate',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + ';border-radius:0;'),
                      onClick: this.confirmPayment
                    },
                    '\u4E0B\u5355'
                  )
                )
              )
            ) : pickUpType != 4 && _react2.default.createElement(
              'div',
              { className: 'bottom-nav' },
              _react2.default.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                '\u5408\u8BA1:',
                _react2.default.createElement(
                  'span',
                  {
                    className: 'price-count',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  '¥ ' + totalPayment
                )
              ),
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  'button',
                  {
                    type: 'button',
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                    onClick: this.confirmPayment
                  },
                  cashOnDelivery ? '货到付款' : '在线支付'
                )
              )
            ),
            _react2.default.createElement(ExchangeCouponUseDialogTmpl, { data: exchangeCouponData, self: this })
          )
        ),
        isFranchisee && _react2.default.createElement(
          'div',
          { className: 'preview-goods-wrap franchisee' },
          (pickUpType == 1 || pickUpType == 2) && _react2.default.createElement(
            'div',
            { className: 'preview-section' },
            pickUpType == 1 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              selectAddress.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goToMyAddress,
                    'data-address-id': selectAddress.id
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectAddress.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectAddress.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-address-txt' },
                        selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-box',
                    onClick: this.goToMyAddress
                  },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u65B0\u589E\u5730\u5740'
                    )
                  )
                )
              )
            ),
            pickUpType == 2 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              selectSameJourney.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goSameJourneyAddress
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectSameJourney.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectSameJourney.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u540C\u57CE'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-address-txt' },
                        selectSameJourney.address_info.province.text + selectSameJourney.address_info.city.text + selectSameJourney.address_info.district.text + selectSameJourney.address_info.detailAddress
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'address-null-box' },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    { onClick: this.goSameJourneyAddress },
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u9009\u62E9\u540C\u57CE\u5730\u5740'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'address-bg' },
              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png' })
            )
          ),
          pickUpType == 3 && _react2.default.createElement(
            'div',
            { className: 'pick-method' },
            _react2.default.createElement(
              'div',
              { className: 'pick-method-box' },
              _react2.default.createElement('span', {
                className: 'ico-moon icon-goods-pick-model',
                style: (0, _tools.convertLineStyleData)('background:linear-gradient(-66deg,' + storeStyle.secondary + ' 0%,' + storeStyle.theme + ' 100%);')
              }),
              '\u53D6\u8D27\u65B9\u5F0F',
              _react2.default.createElement(
                'span',
                { className: 'pull-right pick-method-title' },
                '\u81EA\u63D0'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'preview-shops-list' },
            shopsList.map(function (shop, shopIndex) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: shop.app_id },
                mulShopsInfo[shop.app_id].additional_info[mulShopsInfo[shop.app_id].additional_goodsid_arr[0]].map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'preview-shops-item', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-shops-title' },
                      _react2.default.createElement('img', { src: shop.logo, mode: 'aspectFill' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        shop.name
                      )
                    ),
                    pickUpType == 3 && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'preview-section delivery' },
                        mulShopsInfo[shop.app_id].selectDelivery.id ? _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'address-box',
                              onClick: _this4.toDeliveryList,
                              'data-app-id': shop.app_id
                            },
                            _react2.default.createElement(
                              'div',
                              { className: 'address-detail' },
                              _react2.default.createElement(
                                'div',
                                { className: 'buyer-name-box' },
                                _react2.default.createElement(
                                  'span',
                                  { className: 'buyer-name' },
                                  mulShopsInfo[shop.app_id].selectDelivery.contact_name
                                ),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  mulShopsInfo[shop.app_id].selectDelivery.contact_phone
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'buyer-address' },
                                _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'store-config-label',
                                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                                  },
                                  '\u81EA\u63D0'
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'buyer-address-txt' },
                                  mulShopsInfo[shop.app_id].selectDelivery.region_data.region_string + mulShopsInfo[shop.app_id].selectDelivery.address_detail
                                )
                              )
                            ),
                            _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                          )
                        ) : _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'address-null-box',
                              onClick: _this4.toDeliveryList,
                              'data-app-id': shop.app_id
                            },
                            _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                            _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                              _react2.default.createElement(
                                'span',
                                { className: 'add-new-address' },
                                '\u9009\u62E9\u81EA\u63D0\u70B9'
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'address-bg' },
                          _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png' })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'preview-box delivery' },
                        mulShopsInfo[shop.app_id].selfAppointmentSwitch && _react2.default.createElement(
                          'div',
                          {
                            onClick: _this4.showServiceTime,
                            'data-app-id': shop.app_id,
                            className: 'single-box'
                          },
                          '\u53D6\u8D27\u65F6\u95F4',
                          _react2.default.createElement(
                            'div',
                            { className: 'pull-right appointment-time-box' },
                            mulShopsInfo[shop.app_id].tostoreTimeType == 1 && mulShopsInfo[shop.app_id].tostoreDateTime && mulShopsInfo[shop.app_id].tostoreOrderType == 2 ? _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              dateTrans.date(mulShopsInfo[shop.app_id].tostoreDateTime)
                            ) : mulShopsInfo[shop.app_id].tostoreTimeType == 1 && mulShopsInfo[shop.app_id].tostoreOrderType == 1 ? _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              mulShopsInfo[shop.app_id].waitingQueueTime == 0 ? '立即取货' : '大约等待' + mulShopsInfo[shop.app_id].waitingQueueTime + '分钟'
                            ) : mulShopsInfo[shop.app_id].tostoreTimeType != 1 && mulShopsInfo[shop.app_id].tostoreHourTime && mulShopsInfo[shop.app_id].tostoreOrderType == 2 ? _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              dateTrans.date(mulShopsInfo[shop.app_id].tostoreDateTime) + ' ' + mulShopsInfo[shop.app_id].tostoreHourTime
                            ) : mulShopsInfo[shop.app_id].tostoreTimeType != 1 && mulShopsInfo[shop.app_id].tostoreOrderType == 1 ? _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              dateTrans.date(mulShopsInfo[shop.app_id].tostoreDateTime) + (mulShopsInfo[shop.app_id].waitingQueueTime == 0 ? ' 立即取货' : '大约等待' + mulShopsInfo[shop.app_id].waitingQueueTime + '分钟')
                            ) : _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '\u8BF7\u9009\u62E9\u65F6\u95F4'
                            ),
                            _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                          )
                        ),
                        mulShopsInfo[shop.app_id].onlyImmediatlyPickSwitch && mulShopsInfo[shop.app_id].waitingQueueTime >= 0 && _react2.default.createElement(
                          'div',
                          { className: 'single-box' },
                          '\u53D6\u8D27\u65F6\u95F4',
                          _react2.default.createElement(
                            'div',
                            { className: 'pull-right appointment-time-box' },
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'appointment-time',
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              mulShopsInfo[shop.app_id].waitingQueueTime == 0 ? '无需等待' : '大约等待' + mulShopsInfo[shop.app_id].waitingQueueTime + '分钟'
                            )
                          )
                        ),
                        mulShopsInfo[shop.app_id].selfDeliveryPhone == 1 && _react2.default.createElement(
                          'div',
                          { className: 'single-box thin-bd-b' },
                          '\u8054\u7CFB\u624B\u673A\u53F7',
                          _react2.default.createElement(
                            'div',
                            { className: 'pull-right input-phone-box' },
                            _react2.default.createElement('input', {
                              type: 'text',
                              onChange: _this4.inputPhone,
                              'data-app-id': shop.app_id,
                              value: mulShopsInfo[shop.app_id].phone,
                              placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
                            }),
                            _react2.default.createElement(
                              'button',
                              {
                                className: 'get-phone-number'
                                // openType="getPhoneNumber"
                                , onClick: _this4.getPhoneNumber,
                                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                              },
                              '\u81EA\u52A8\u586B\u5199'
                            )
                          )
                        ),
                        mulShopsInfo[shop.app_id].selfDeliveryScan && _react2.default.createElement(
                          'div',
                          {
                            className: 'single-box',
                            onClick: _this4.getInStoreSeat
                          },
                          '\u5E97\u5185\u4F4D\u7F6E',
                          _react2.default.createElement(
                            'div',
                            { className: 'pull-right scan-seat-box' },
                            _react2.default.createElement(
                              'span',
                              null,
                              inStoreSeatName || '请扫码获取位置信息'
                            ),
                            _react2.default.createElement('span', { className: 'ico-moon icon-shopping-scan' })
                          )
                        )
                      )
                    ),
                    pickUpType != 4 && _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-order-list' },
                      shop.cartList.map(function (goods, goodsIndex) {
                        return _react2.default.createElement(
                          'div',
                          {
                            className: 'preview-goods-order-item ' + (goodsIndex == shop.cartList.length - 1 ? 'thin-bd-b' : ''),
                            key: goods.id
                          },
                          _react2.default.createElement('img', {
                            className: 'preview-goods-cover',
                            src: goods.cover,
                            mode: 'aspectFill'
                          }),
                          _react2.default.createElement(
                            'div',
                            { className: 'preview-goods-content' },
                            _react2.default.createElement(
                              'div',
                              { className: 'preview-goods-title' },
                              is_group && _react2.default.createElement(
                                'span',
                                { className: 'exchange-tip' },
                                '\u62FC\u56E2'
                              ),
                              goods.is_seckill == 1 && _react2.default.createElement(
                                'span',
                                { className: 'exchange-tip' },
                                '\u79D2\u6740'
                              ),
                              _react2.default.createElement(
                                'span',
                                null,
                                goods.title
                              )
                            ),
                            goods.model_value_str && _react2.default.createElement(
                              'div',
                              { className: 'preview-goods-model' },
                              _react2.default.createElement(
                                'span',
                                null,
                                goods.model_value_str
                              )
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'goods-price-box' },
                              goods.integral != '2' ? _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'preview-goods-price',
                                    style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                  },
                                  '¥' + goods.price
                                ),
                                is_vip_goods == 1 && _react2.default.createElement(
                                  'div',
                                  {
                                    className: 'vip-logo',
                                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';background:' + storeStyle.theme + '19;')
                                  },
                                  '\u4F1A\u5458\u4EF7'
                                )
                              ) : _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                goods.price != '0.00' && _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'preview-goods-price',
                                    style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                  },
                                  '¥' + goods.price
                                ),
                                is_vip_goods == 1 && _react2.default.createElement(
                                  'div',
                                  {
                                    className: 'vip-logo',
                                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';background:' + storeStyle.theme + '19;')
                                  },
                                  '\u4F1A\u5458\u4EF7'
                                ),
                                goods.price != '0.00' && goods.use_integral != 0 && _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'preview-goods-price',
                                    style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                  },
                                  '+'
                                ),
                                goods.use_integral != 0 && _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'preview-goods-price',
                                    style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                                  },
                                  goods.max_can_use_integral + '积分'
                                )
                              ),
                              !is_group && _react2.default.createElement(
                                'div',
                                { className: 'good-number-box pull-right' },
                                _react2.default.createElement(
                                  'div',
                                  {
                                    className: 'goods-minus',
                                    'data-index': goodsIndex,
                                    'data-shop-index': shopIndex,
                                    'data-is-franchisee': '1',
                                    'data-app-id': goods.app_id,
                                    onClick: _this4.clickMinusButton
                                  },
                                  '-'
                                ),
                                _react2.default.createElement('input', {
                                  className: 'goods-count',
                                  'data-index': goodsIndex,
                                  'data-shop-index': shopIndex,
                                  'data-is-franchisee': '1',
                                  'data-app-id': goods.app_id,
                                  type: 'number',
                                  value: goods.num,
                                  onChange: _this4.inputGoodsCount
                                }),
                                _react2.default.createElement(
                                  'div',
                                  {
                                    className: 'goods-plus',
                                    'data-index': goodsIndex,
                                    'data-shop-index': shopIndex,
                                    'data-is-franchisee': '1',
                                    'data-app-id': goods.app_id,
                                    onClick: _this4.clickPlusButton
                                  },
                                  '+'
                                )
                              ),
                              is_group && _react2.default.createElement(
                                'div',
                                { className: 'good-number-box pull-right' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'group-count' },
                                  '数量：' + goods.num
                                )
                              )
                            )
                          )
                        );
                      })
                    ),
                    mulShopsInfo[shop.app_id].exchangeCouponData.hasSelectGoods && _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-order-list' },
                      _react2.default.createElement(
                        'div',
                        { className: 'preview-goods-order-item thin-bd-b' },
                        _react2.default.createElement('img', {
                          className: 'preview-goods-cover',
                          src: mulShopsInfo[shop.app_id].exchangeCouponData.goodsInfo.cover
                        }),
                        _react2.default.createElement(
                          'div',
                          { className: 'preview-goods-content' },
                          _react2.default.createElement(
                            'div',
                            { className: 'preview-goods-title' },
                            _react2.default.createElement(
                              'span',
                              { className: 'exchange-tip' },
                              '\u8D60\u54C1'
                            ),
                            mulShopsInfo[shop.app_id].exchangeCouponData.goodsInfo.title
                          ),
                          mulShopsInfo[shop.app_id].exchangeCouponData.goodsInfo.model_value_str && _react2.default.createElement(
                            'div',
                            { className: 'preview-goods-model' },
                            mulShopsInfo[shop.app_id].exchangeCouponData.goodsInfo.model_value_str
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'goods-number-contain' },
                            _react2.default.createElement(
                              'div',
                              { className: 'exchange-num pull-right' },
                              'x1'
                            )
                          )
                        )
                      )
                    ),
                    pickUpType == 2 && _react2.default.createElement(
                      'div',
                      { className: 'preview-box' },
                      _react2.default.createElement(
                        'div',
                        {
                          onClick: _this4.showSameJourneyTime,
                          'data-app-id': shop.app_id,
                          className: 'single-box thin-bd-b'
                        },
                        '\u53D6\u8D27\u65F6\u95F4',
                        _react2.default.createElement(
                          'div',
                          { className: 'pull-right appointment-time-box' },
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'appointment-time',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            mulShopsInfo[shop.app_id].sameJourneyTimeType == 1 ? '尽快送达（预计' + (mulShopsInfo[shop.app_id].sameJourneyImmediatlyTime || '') + '分钟后送达）' : mulShopsInfo[shop.app_id].sameJourneyDateTime ? '大约' + mulShopsInfo[shop.app_id].sameJourneyDateTime + '送达' : '请选择送达时间'
                          ),
                          _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-box' },
                      mulShopsInfo[shop.app_id].box_fee && pickUpType == 2 && _react2.default.createElement(
                        'div',
                        { className: 'single-box thin-bd-b' },
                        '\u5305\u88C5\u8D39',
                        _react2.default.createElement(
                          'span',
                          { className: 'pull-right price-txt' },
                          '¥ ' + mulShopsInfo[shop.app_id].box_fee
                        )
                      ),
                      pickUpType != 4 && pickUpType != 3 && _react2.default.createElement(
                        'div',
                        { className: 'single-box thin-bd-b' },
                        '\u8FD0\u8D39',
                        _react2.default.createElement(
                          'span',
                          { className: 'pull-right price-txt' },
                          '¥ ' + mulShopsInfo[shop.app_id].express_fee
                        )
                      ),
                      !!mulShopsInfo[shop.app_id].discountList.length && _react2.default.createElement(
                        'div',
                        {
                          hidden: pickUpType == 4 && account_type == 2,
                          'data-app-id': shop.app_id,
                          onClick: _this4.showMemberDiscount
                        },
                        _react2.default.createElement(
                          'div',
                          { className: 'balance-switch' },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u4F18\u60E0\u65B9\u5F0F'
                          ),
                          _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                          _react2.default.createElement(
                            'span',
                            { className: 'pull-right select-discount' },
                            mulShopsInfo[shop.app_id].selectDiscountInfo.name
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'balance-price thin-bd-b',
                            hidden: mulShopsInfo[shop.app_id].selectDiscountIndex == 0
                          },
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'pull-right price-txt',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';')
                            },
                            '- ¥' + mulShopsInfo[shop.app_id].discount_cut_price
                          )
                        )
                      ),
                      isMember && _react2.default.createElement(
                        'div',
                        { className: 'single-box thin-bd-b' },
                        '\u4F1A\u5458\u4EF7\u4F18\u60E0',
                        _react2.default.createElement(
                          'span',
                          {
                            className: 'pull-right price-txt',
                            style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';')
                          },
                          '- ¥ ' + mulShopsInfo[shop.app_id].vip_cut_price
                        )
                      ),
                      mulShopsInfo[shop.app_id].balance != 0 && _react2.default.createElement(
                        'div',
                        {
                          className: 'thin-bd-b',
                          hidden: pickUpType == 4 && account_type == 2
                        },
                        _react2.default.createElement(
                          'div',
                          { className: 'balance-switch' },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u4F7F\u7528\u50A8\u503C\u91D1'
                          ),
                          _react2.default.createElement(_switch2.default, {
                            className: 'pull-right',
                            color: storeStyle.theme,
                            style: (0, _tools.convertLineStyleData)('transform:scale(0.7);'),
                            checked: mulShopsInfo[shop.app_id].useBalance > 0 ? true : false,
                            onChange: function onChange(e) {
                              return _this4.useBalanceChange(e, shop.app_id);
                            }
                          })
                        ),
                        _react2.default.createElement(
                          'div',
                          {
                            hidden: !mulShopsInfo[shop.app_id].useBalance,
                            className: 'balance-price'
                          },
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'pull-right price-txt',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '- ¥' + mulShopsInfo[shop.app_id].deduction
                          )
                        )
                      ),
                      mulShopsInfo[shop.app_id].price > 0 && (pickUpType == 1 && mulShopsInfo[shop.app_id].canCashDelivery == 1 || pickUpType == 3 && mulShopsInfo[shop.app_id].selfPayOnDelivery == 1) && _react2.default.createElement(
                        'div',
                        { className: 'thin-bd-b' },
                        _react2.default.createElement(
                          'div',
                          { className: 'balance-switch' },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u8D27\u5230\u4ED8\u6B3E\uFF08\u5148\u4E0B\u5355\uFF0C\u9A8C\u8D27\u540E\u652F\u4ED8\uFF09'
                          ),
                          _react2.default.createElement(_switch2.default, {
                            className: 'pull-right',
                            color: storeStyle.theme,
                            style: (0, _tools.convertLineStyleData)('transform:scale(0.8);'),
                            onChange: function onChange(e) {
                              return _this4.useCashDelivery(e, shop.app_id);
                            },
                            checked: mulShopsInfo[shop.app_id].cashOnDelivery
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'buyer-message single-box thin-bd-b' },
                        '\u4E70\u5BB6\u7559\u8A00',
                        _react2.default.createElement(
                          'div',
                          { className: 'pull-right' },
                          _react2.default.createElement('input', {
                            className: 'remark',
                            maxLength: '30',
                            value: mulShopsInfo[shop.app_id].orderRemark,
                            onChange: _this4.remarkInput,
                            'data-app-id': shop.app_id,
                            placeholder: '\u5EFA\u8BAE\u7559\u8A00\u524D\u5148\u4E0E\u5546\u5BB6\u6C9F\u901A'
                          })
                        )
                      ),
                      !mulShopsInfo[shop.app_id].noAdditionalInfo && !mulShopsInfo[shop.app_id].aloneDeliveryShow && _react2.default.createElement(
                        'div',
                        {
                          className: 'single-box thin-bd-b',
                          'data-app-id': shop.app_id,
                          onClick: _this4.goToAdditionalInfo
                        },
                        '\u8865\u5145\u4FE1\u606F',
                        _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                        _react2.default.createElement(
                          'span',
                          {
                            className: 'additional-tip pull-right',
                            style: (0, _tools.convertLineStyleData)('color:' + (mulShopsInfo[shop.app_id].hasRequiredSuppInfo && !mulShopsInfo[shop.app_id].deliverydWrite ? storeStyle.theme : '#666'))
                          },
                          mulShopsInfo[shop.app_id].deliverydWrite ? '已填写' : '未填写'
                        )
                      )
                    ),
                    mulShopsInfo[shop.app_id].aloneDeliveryShow && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      mulShopsInfo[shop.app_id].additional_info[mulShopsInfo[shop.app_id].additional_goodsid_arr[0]].map(function (item, index) {
                        return _react2.default.createElement(
                          'div',
                          {
                            className: 'additional-list thin-bd-b',
                            key: index
                          },
                          item.type == 'text' && _react2.default.createElement(
                            'div',
                            { className: 'additional-text' },
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                              },
                              item.title
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'additional-info' },
                              _react2.default.createElement('input', {
                                type: 'text',
                                onChange: _this4.inputFormControl,
                                'data-app-id': shop.app_id,
                                value: item.value
                              })
                            )
                          ),
                          item.type == 'mul-text' && _react2.default.createElement(
                            'div',
                            { className: 'additional-textarea' },
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                              },
                              item.title
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'additional-info' },
                              _react2.default.createElement('textarea', {
                                maxLength: '-1',
                                onInput: _this4.inputFormControl,
                                'data-app-id': shop.app_id,
                                value: item.value
                              })
                            )
                          ),
                          item.type == 'picture' && _react2.default.createElement(
                            'div',
                            { className: 'additional-picture' },
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                              },
                              item.title
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'additional-info' },
                              item.value.map(function (imgSrc, imageIndex) {
                                return _react2.default.createElement(
                                  'div',
                                  {
                                    className: 'image-list',
                                    key: imageIndex
                                  },
                                  _react2.default.createElement('img', { src: imgSrc }),
                                  _react2.default.createElement(
                                    'label',
                                    {
                                      className: 'delete-image ico-moon icon-closes',
                                      'data-app-id': shop.app_id,
                                      onClick: _this4.deleteImage,
                                      'data-image-index': imageIndex
                                    },
                                    '-'
                                  )
                                );
                              }),
                              item.value.length < 9 && _react2.default.createElement(
                                'div',
                                {
                                  className: 'add-images',
                                  'data-app-id': shop.app_id,
                                  onClick: _this4.addDeliveryImg
                                },
                                _react2.default.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                                _react2.default.createElement(
                                  'div',
                                  null,
                                  '\u6DFB\u52A0\u56FE\u7247'
                                )
                              )
                            )
                          )
                        );
                      })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'total single-box' },
                        _react2.default.createElement(
                          'div',
                          { className: 'pull-right' },
                          _react2.default.createElement(
                            'span',
                            null,
                            '\u5C0F\u8BA1\uFF1A'
                          ),
                          _react2.default.createElement(
                            'span',
                            {
                              className: 'price-txt',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';')
                            },
                            '￥' + mulShopsInfo[shop.app_id].price
                          )
                        )
                      )
                    )
                  );
                })
              );
            })
          ),
          !!leagueBenefitData.benefitList.length && _react2.default.createElement(
            'div',
            {
              className: 'league-coupon',
              'data-is-league': '1',
              onClick: this.showMemberDiscount,
              hidden: pickUpType == 4 && account_type == 2
            },
            _react2.default.createElement(
              'div',
              { className: 'balance-switch' },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'league-mark' },
                  '\u8054\u76DF'
                ),
                '\u8054\u76DF\u4F18\u60E0\u5238'
              ),
              _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
              _react2.default.createElement(
                'span',
                { className: 'pull-right select-discount' },
                leagueBenefitData.selectedBenefitInfo.name
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'balance-price',
                hidden: leagueBenefitData.selectedBenefitIndex == 0
              },
              _react2.default.createElement(
                'span',
                {
                  className: 'pull-right price-txt',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '- ¥' + leagueBenefitData.benefitPrice
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-nav thin-bd-t' },
            _react2.default.createElement(
              'div',
              { className: 'preview-goods-total-price' },
              '\u5408\u8BA1:',
              _react2.default.createElement(
                'span',
                {
                  className: 'price-count',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '¥ ' + totalPayment
              )
            ),
            _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  style: (0, _tools.convertLineStyleData)('background:linear-gradient(90deg,' + storeStyle.secondary + ',' + storeStyle.theme + ');'),
                  onClick: this.mulShopconfirmPayment
                },
                allShopsCashOnDelivery ? '货到付款' : '在线支付'
              )
            )
          ),
          selectedAppId && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            !mulShopsInfo[selectedAppId].exchangeCouponData.dialogHidden && _react2.default.createElement(
              'div',
              { className: 'page-dialog-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'page-bottom-dialog' },
                _react2.default.createElement(
                  'div',
                  { className: 'page-bottom-content' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'pay-close-dialog page-dialog-close',
                      'data-app-id': selectedAppId,
                      onClick: this.exchangeCouponHideDialog
                    },
                    '\xD7'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'dialog-block-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'thumb' },
                      _react2.default.createElement(
                        'div',
                        { className: 'thumb-wrap' },
                        _react2.default.createElement('img', {
                          className: 'pay-goods-cover',
                          src: mulShopsInfo[selectedAppId].exchangeCouponData.selectModelInfo.imgurl || mulShopsInfo[selectedAppId].exchangeCouponData.goodsInfo.cover
                        })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'pay-goods-baseinfo' },
                      _react2.default.createElement(
                        'div',
                        { className: 'pay-goods-title ellipsis' },
                        _react2.default.createElement(
                          'span',
                          { className: 'gift-text' },
                          '\u8D60\u54C1'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'gift-title' },
                          mulShopsInfo[selectedAppId].exchangeCouponData.goodsInfo.title
                        )
                      ),
                      mulShopsInfo[selectedAppId].exchangeCouponData.selectModelInfo.models_text && _react2.default.createElement(
                        'div',
                        { className: 'pay-checked-text clearfix' },
                        '已选：' + mulShopsInfo[selectedAppId].exchangeCouponData.selectModelInfo.models_text
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'gift-price' },
                        '¥' + mulShopsInfo[selectedAppId].exchangeCouponData.selectModelInfo.price
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'exchange-rules-box',
                      hidden: !mulShopsInfo[selectedAppId].exchangeCouponData.goodsInfo.model_items.length
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'pay-goods-models' },
                      mulShopsInfo[selectedAppId].exchangeCouponData.goodsInfo.model.map(function (model, modelIndex) {
                        return _react2.default.createElement(
                          'div',
                          { key: modelIndex },
                          _react2.default.createElement(
                            'span',
                            { className: 'model-title' },
                            model.name
                          ),
                          _react2.default.createElement(
                            'label',
                            { className: 'pills-list' },
                            model.subModelName.map(function (name, index) {
                              return _react2.default.createElement(
                                'label',
                                {
                                  key: index,
                                  'data-model-index': modelIndex,
                                  'data-submodel-index': index,
                                  className: 'subModel ' + (mulShopsInfo[selectedAppId].exchangeCouponData.selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                                  'data-submodel-id': model.subModelId[index],
                                  onClick: _this4.exchangeCouponSelectSubModel
                                },
                                name
                              );
                            })
                          )
                        );
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'confirm-goods',
                      onClick: this.exchangeCouponConfirmGoods
                    },
                    '\u786E\u8BA4'
                  )
                )
              )
            )
          )
        ),
        isShowPickMask && _react2.default.createElement(
          'div',
          { className: 'goods-pick-mask' },
          _react2.default.createElement(
            'div',
            { className: 'goods-pick-box' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-header' },
              '\u8BF7\u9009\u62E9\u53D6\u8D27\u65B9\u5F0F'
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-content' },
              pickUpTypeArr.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: item, className: 'goods-pick-menu' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'pick-detail ' + (item == 2 && (intraCityData.is_enough_price != 1 || intraCityData.in_business_time != 1 || intraCityData.in_business_time != 1) || item == 4 && dining_data.in_business_time != 1 ? 'no-achieve-price-box' : '')
                    },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'pick-style',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      _react2.default.createElement('span', {
                        className: 'ico-moon ' + goodsIcon[item]
                      }),
                      item == 1 ? '快递配送' : item == 2 ? '同城配送' : item == 3 ? '上门自提' : '堂食点餐'
                    ),
                    item == 1 && _react2.default.createElement(
                      'div',
                      { className: 'no-achieve-price' },
                      '配送费' + (express_data.express_fee || 0) + '元'
                    ),
                    item == 2 && _react2.default.createElement(
                      'div',
                      { className: 'no-achieve-price' },
                      '配送费' + (intraCityData.express_fee || 0) + '元'
                    ),
                    item == 2 && intraCityData.in_business_time != 1 ? _react2.default.createElement(
                      'div',
                      {
                        className: 'no-achieve-tips',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      '\u4E0D\u5728\u8425\u4E1A\u65F6\u95F4'
                    ) : item == 2 && intraCityData.is_enough_price != 1 && _react2.default.createElement(
                      'div',
                      {
                        className: 'no-achieve-tips',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      '未达到起送价 还差' + intraCityData.min_deliver_price_balance + '元'
                    ),
                    item == 4 && dining_data.in_business_time != 1 && _react2.default.createElement(
                      'div',
                      { className: 'no-achieve-price' },
                      '\u5546\u5BB6\u5DF2\u6253\u70CA'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'pick-btn-box' },
                    _react2.default.createElement(
                      'span',
                      {
                        style: (0, _tools.convertLineStyleData)(item == 1 || item == 3 || item == 2 && intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 || item == 4 && dining_data.in_business_time == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : 'color: #999;border-color: #D2D2D2'),
                        onClick: item == 1 || item == 3 || item == 2 && intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 || item == 4 && dining_data.in_business_time == 1 ? _this4.deliveryWayChange : null,
                        'data-type': item
                      },
                      '\u9009\u62E9'
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
              '\u5173\u95ED'
            )
          )
        ),
        isShowServiceTime && !isFranchisee && _react2.default.createElement(
          'div',
          { className: 'goods-pick-mask' },
          _react2.default.createElement(
            'div',
            { className: 'goods-pick-box' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-header' },
              '\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
            ),
            !noAppointmentShow ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              tostoreTimeType == 1 && _react2.default.createElement(
                'div',
                { className: 'goods-pick-content' },
                noImmediaPick && showImmediatelyTime && _react2.default.createElement(
                  'div',
                  {
                    onClick: this.tostoreImmediately,
                    className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : '')
                  },
                  '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                ),
                getEcTostoredate.date_arr.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    item.is_vaild == 1 && _react2.default.createElement(
                      'div',
                      {
                        onClick: _this4.selectTostoreTime,
                        'data-index': index,
                        className: 'goods-pick-time ' + (tostoreOrderType != 1 && tostoreDateTime == item.date ? 'selected' : '')
                      },
                      dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                    )
                  );
                })
              ),
              getEcTostoredate.setting_data && tostoreTimeType != 1 && _react2.default.createElement(
                'div',
                { className: 'double-column-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'double-time-day' },
                  getEcTostoredate.date_arr.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      item.is_vaild == 1 && _react2.default.createElement(
                        'div',
                        {
                          onClick: _this4.selectTostoreTime,
                          'data-index': index,
                          className: 'goods-pick-time ' + (tostoreDateTime == item.date ? 'selected' : '')
                        },
                        dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'double-time-hours' },
                  !dateIndex && showImmediatelyTime && noImmediaPick && _react2.default.createElement(
                    'div',
                    {
                      onClick: this.tostoreImmediately,
                      className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : '')
                    },
                    '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                  ),
                  tostoreHoursArr && tostoreHoursArr.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        onClick: _this4.selectTostoreHourTime,
                        'data-index': index,
                        className: tostoreHourTime == item ? 'selected' : '',
                        key: index
                      },
                      item
                    );
                  })
                )
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'none-appointment-time' },
              _react2.default.createElement('img', {
                className: 'no-reservation',
                src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-reservation.png'
              }),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u6682\u65E0\u53EF\u9884\u7EA6\u65F6\u95F4'
              ),
              _react2.default.createElement(
                'div',
                { className: 'tips' },
                noAppointmentWordb
              ),
              _react2.default.createElement(
                'div',
                { className: 'tips' },
                noAppointmentWorda
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
              '\u5173\u95ED'
            )
          )
        ),
        isShowServiceTime && isFranchisee && _react2.default.createElement(
          'div',
          { className: 'goods-pick-mask' },
          _react2.default.createElement(
            'div',
            { className: 'goods-pick-box' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-header' },
              '\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
            ),
            !mulShopsInfo[selectedAppId].noAppointmentShow ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              mulShopsInfo[selectedAppId].tostoreTimeType == 1 && _react2.default.createElement(
                'div',
                { className: 'goods-pick-content' },
                mulShopsInfo[selectedAppId].noImmediaPick && mulShopsInfo[selectedAppId].showImmediatelyTime && _react2.default.createElement(
                  'div',
                  {
                    'data-app-id': selectedAppId,
                    onClick: this.tostoreImmediately,
                    className: 'goods-pick-time ' + (mulShopsInfo[selectedAppId].tostoreOrderType == 1 ? 'selected' : '')
                  },
                  '立即取货（' + (mulShopsInfo[selectedAppId].waitingQueueTime == 0 ? '无需等待' : '大约等待' + mulShopsInfo[selectedAppId].waitingQueueTime + '分钟') + '）'
                ),
                mulShopsInfo[selectedAppId].getEcTostoredate.date_arr.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    item.is_vaild == 1 && _react2.default.createElement(
                      'div',
                      {
                        onClick: _this4.selectTostoreTime,
                        'data-index': index,
                        className: 'goods-pick-time ' + (mulShopsInfo[selectedAppId].tostoreOrderType != 1 && mulShopsInfo[selectedAppId].tostoreDateTime == item.date ? 'selected' : '')
                      },
                      dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                    )
                  );
                })
              ),
              mulShopsInfo[selectedAppId].getEcTostoredate.setting_data && mulShopsInfo[selectedAppId].tostoreTimeType != 1 && _react2.default.createElement(
                'div',
                { className: 'double-column-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'double-time-day' },
                  mulShopsInfo[selectedAppId].getEcTostoredate.date_arr.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      item.is_vaild == 1 && _react2.default.createElement(
                        'div',
                        {
                          onClick: _this4.selectTostoreTime,
                          'data-index': index,
                          className: 'goods-pick-time',
                          style: (0, _tools.convertLineStyleData)('color: ' + (mulShopsInfo[selectedAppId].tostoreDateTime == item.date ? storeStyle.theme : '#666') + ';')
                        },
                        dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'double-time-hours' },
                  !mulShopsInfo[selectedAppId].dateIndex && mulShopsInfo[selectedAppId].showImmediatelyTime && mulShopsInfo[selectedAppId].noImmediaPick && _react2.default.createElement(
                    'div',
                    {
                      onClick: this.tostoreImmediately,
                      'data-app-id': selectedAppId,
                      className: 'goods-pick-time',
                      style: (0, _tools.convertLineStyleData)('color: ' + (mulShopsInfo[selectedAppId].tostoreOrderType == 1 ? storeStyle.theme : '#666') + ';')
                    },
                    '立即取货（' + (mulShopsInfo[selectedAppId].waitingQueueTime == 0 ? '无需等待' : '大约等待' + mulShopsInfo[selectedAppId].waitingQueueTime + '分钟') + '）'
                  ),
                  mulShopsInfo[selectedAppId].tostoreHoursArr.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        onClick: _this4.selectTostoreHourTime,
                        'data-index': index,
                        style: (0, _tools.convertLineStyleData)('color: ' + (mulShopsInfo[selectedAppId].tostoreHourTime == item ? storeStyle.theme : '#666') + ';'),
                        key: index
                      },
                      item
                    );
                  })
                )
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'none-appointment-time' },
              _react2.default.createElement('img', {
                className: 'no-reservation',
                src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-reservation.png'
              }),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u6682\u65E0\u53EF\u9884\u7EA6\u65F6\u95F4'
              ),
              _react2.default.createElement(
                'div',
                { className: 'tips' },
                mulShopsInfo[selectedAppId].noAppointmentWordb
              ),
              _react2.default.createElement(
                'div',
                { className: 'tips' },
                mulShopsInfo[selectedAppId].noAppointmentWorda
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
              '\u5173\u95ED'
            )
          )
        ),
        isShowSameJourneyTime && _react2.default.createElement(
          'div',
          { className: 'goods-pick-mask' },
          _react2.default.createElement(
            'div',
            { className: 'goods-pick-box' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-header' },
              '\u9009\u62E9\u9001\u8FBE\u65F6\u95F4'
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-content goods-same-journey-time' },
              _react2.default.createElement(
                'div',
                {
                  onClick: this.selectSameJourneyTime,
                  'data-type': 'immedia',
                  className: 'goods-pick-time',
                  style: (0, _tools.convertLineStyleData)('color:' + (isFranchisee ? mulShopsInfo[selectedAppId].sameJourneyTimeType == 1 ? storeStyle.theme : '#666' : sameJourneyTimeType == 1 ? storeStyle.theme : '#666') + ';')
                },
                '尽快送达(预计' + (isFranchisee ? mulShopsInfo[selectedAppId].sameJourneyImmediatlyTime : sameJourneyImmediatlyTime) + '分钟后送达)'
              ),
              (isFranchisee ? mulShopsInfo[selectedAppId].sameJourneyHoursArr : sameJourneyHoursArr).map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: _this4.selectSameJourneyTime,
                      'data-type': 'appoint',
                      'data-index': index,
                      className: 'goods-pick-time',
                      style: (0, _tools.convertLineStyleData)('color:' + (isFranchisee ? mulShopsInfo[selectedAppId].sameJourneyTimeType != 1 && mulShopsInfo[selectedAppId].sameJourneyDateTime == item ? storeStyle.theme : '#666' : sameJourneyTimeType != 1 && sameJourneyDateTime == item ? storeStyle.theme : '#666') + ';')
                    },
                    item
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
              '\u5173\u95ED'
            )
          )
        ),
        expressAddressNull && _react2.default.createElement(
          'div',
          {
            className: 'perfect-address-mask',
            onClick: this.hidePerfectAddress
          },
          _react2.default.createElement(
            'div',
            {
              className: 'perfect-address-box',
              onClick: this.stopPropagation
            },
            _react2.default.createElement(
              'div',
              { className: 'perfect-address-title' },
              '\u63D0\u793A'
            ),
            _react2.default.createElement(
              'div',
              { className: 'perfect-address-tips' },
              '\u8BF7\u5B8C\u5584\u5730\u5740\u4FE1\u606F~'
            ),
            _react2.default.createElement(
              'div',
              { className: 'perfect-address-bottom' },
              _react2.default.createElement(
                'span',
                { onClick: this.manuallyAddAddress },
                '\u624B\u52A8\u65B0\u589E\u5730\u5740'
              ),
              _react2.default.createElement(
                'span',
                {
                  onClick: this.importWeChatAddress,
                  className: 'import-weChat-address'
                },
                '\u5BFC\u5165\u5FAE\u4FE1\u5730\u5740'
              )
            )
          )
        ),
        showVipGoodsList && _react2.default.createElement(
          'div',
          { className: 'vip_goods_mask', onClick: this.hideVipGoodsList },
          _react2.default.createElement(
            'div',
            { className: 'vipGoodsWarp' },
            vip_cart_info && _react2.default.createElement(
              'div',
              { className: 'custom-info-wrapper flex-between' },
              _react2.default.createElement(
                'div',
                { className: 'flex-between' },
                _react2.default.createElement(
                  'div',
                  { className: 'custom-info' },
                  _react2.default.createElement('img', { src: vip_cart_info.cover_thumb })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'custom-name' },
                  vip_cart_info.title
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pull-right' },
                _react2.default.createElement(
                  'span',
                  { className: 'cut_price_tip' },
                  '\u4F18\u60E0'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'vip_cut_price' },
                  '-¥' + vip_cut_price
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'preview-goods-order-list' },
              vip_goods_list.map(function (goods, goodsIndex) {
                return _react2.default.createElement(
                  'div',
                  { className: 'preview-goods-order-item', key: goods.id },
                  _react2.default.createElement('img', {
                    className: 'preview-goods-cover',
                    src: goods.cover,
                    mode: 'aspectFill'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-title' },
                      goods.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-type' },
                      _react2.default.createElement(
                        'div',
                        { className: 'type-taste' },
                        goods.model_value_str
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-price-box' },
                      _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                          'span',
                          {
                            className: 'preview-goods-price',
                            style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                          },
                          '¥' + goods.price
                        ),
                        goods.cart_vip_goods && _react2.default.createElement(
                          'span',
                          { className: 'dinning_vip_tips' },
                          '\u4F1A\u5458\u4EF7'
                        ),
                        _react2.default.createElement(
                          'span',
                          {
                            className: 'preview-goods-price',
                            style: (0, _tools.convertLineStyleData)('margin-left:10rpx;color:#999;')
                          },
                          '¥ ' + goods.original_price
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'pull-right' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-count' },
                          '×' + goods.num
                        )
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        _react2.default.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return PreviewGoodsOrder;
}(_OfficialPage3.default);

exports.default = PreviewGoodsOrder;

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(47);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(437);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddAddress = function (_OfficialPage) {
  (0, _inherits3.default)(AddAddress, _OfficialPage);

  function AddAddress(props) {
    (0, _classCallCheck3.default)(this, AddAddress);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (AddAddress.__proto__ || Object.getPrototypeOf(AddAddress)).call(this, props));

    _this2.state = {
      areaCodeArr: [{
        //区号
        label: '中国大陆 +86',
        value: 0
      }, {
        label: '中国澳门 +853',
        value: 1
      }, {
        label: '中国香港 +852',
        value: 2
      }, {
        label: '中国台湾 +886',
        value: 3
      }],
      areaCodeIndex: 0,
      nationListMap: [], // 国家列表字典
      nationSelectedIndex: [0], // 当前展示的国家索引下标
      nationList: [], // 国家名称列表
      nationId: 1, // 国家海外地图id (oversea_region_id)
      nationname: '', // 当前展示的国家名称
      regionInfoText: '', // 显示地区字符
      addressId: '',
      orderId: '',
      detail: '',
      isDefault: 0,
      selectAddressId: '',
      addressList: [],
      isFromBack: false,
      from: '',
      showNewAddressDialog: true,
      address_id: '',
      localAddress: '',
      address_info: {
        name: '',
        contact: '',
        country: {
          text: '',
          id: ''
        },
        province: {
          text: '',
          id: ''
        },
        city: {
          text: '',
          id: ''
        },
        district: {
          text: '',
          id: ''
        },
        detailAddress: '',
        sex: 1,
        label: 3
      },
      selectRegion: [0, 0, 0],
      selectRegionId: [0, 0, 0],
      detailAddress: '',
      storeStyle: {}
    };
    _this2.selectAddressBack = false;

    _this2.dataInitial = function () {
      _this2.getAppECStoreConfig();
      var id = _this2.data.addressId;
      if (id) {
        _this2.getAddressDetail(id);
      } else {
        // WEBAPP: 处理后一个页面回来的回调
        _this2.handleCurrentPage();
      }
      _this2.getNationList();
    };

    _this2.getNationList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=Region/getNationList',
        data: {
          page: 1,
          page_size: 10
        },
        success: function success(res) {
          var nationListMap = res.data.reverse();
          var selectedIndex = 0;
          var nationList = nationListMap.map(function (it, idx) {
            if (it.oversea_region_id == _this.data.nationId) {
              selectedIndex = idx;
            }
            return {
              label: it.nation_name,
              value: it.oversea_region_id
            };
          });
          var nationSelectedIndex = [selectedIndex];
          var defaultNation = nationListMap[selectedIndex];
          _this.setData({
            nationListMap: nationListMap,
            nationList: nationList,
            nationSelectedIndex: nationSelectedIndex,
            nationId: defaultNation.oversea_region_id,
            nationname: defaultNation.nation_name
          });
        }
      });
    };

    _this2.getAllPickUpConfig = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetAllPickUpConfig',
        data: {
          latitude: _this.location.lat,
          longitude: _this.location.lng
        },
        success: function success(res) {
          _this.setData({
            suportExpress: res.data.config_data.express,
            suportSameCity: res.data.config_data.intra_city,
            suportSelfDelivery: res.data.config_data.is_self_delivery
          });
        }
      });
    };

    _this2.getAddressDetail = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAddressById',
        data: { address_id: id },
        success: function success(res) {
          var data = res.data;
          var addressInfo = data.address_info;
          var regionAry = [addressInfo.province && addressInfo.province.text || '', addressInfo.city && addressInfo.city.text || '', addressInfo.district && addressInfo.district.text || ''],
              joinStr = '';
          var areaCodeIndex = 0;
          var contact = addressInfo.contact || data.telphone;
          if (contact.indexOf('+853-') == 0) {
            contact = contact.substring(5);
            areaCodeIndex = '1';
          } else if (contact.indexOf('+852-') == 0) {
            contact = contact.substring(5);
            areaCodeIndex = '2';
          } else if (contact.indexOf('+886-') == 0) {
            contact = contact.substring(5);
            areaCodeIndex = '3';
          } else if (contact.indexOf('1-') == 0) {
            // 加拿大
            contact = contact.substring(2);
          } else if (contact.indexOf('60-') == 0) {
            // 马来西亚
            contact = contact.substring(3);
          }
          if (regionAry[1] === regionAry[2] || regionAry[2] === '') {
            regionAry.pop();
          }
          if (data.address_info.country && data.address_info.country.id != 1) {
            joinStr = ' ';
          }
          that.data.detailAddress = addressInfo.detailAddress;
          that.setData({
            areaCodeIndex: areaCodeIndex,
            'address_info.name': addressInfo.name,
            'address_info.contact': contact,
            'address_info.country': addressInfo.country || { text: '', id: '' },
            nationId: addressInfo.country ? addressInfo.country.id || 1 : 1,
            'address_info.province': addressInfo.province || { text: '', id: '' },
            'address_info.city': addressInfo.city || { text: '', id: '' },
            'address_info.district': addressInfo.district || { text: '', id: '' },
            'address_info.detailAddress': addressInfo.detailAddress || data.detail_address,
            'address_info.sex': addressInfo.sex || 2,
            'address_info.label': addressInfo.label || 3,
            'address_info.regionInfoText': regionAry.join(joinStr),
            latitude: data.latitude,
            longitude: data.longitude
          });
          that.location = {
            lat: data.latitude,
            lng: data.longitude
          };
          that.getAllPickUpConfig();
          // WEBAPP: 处理后一个页面回来的回调
          that.handleCurrentPage();
        }
      });
    };

    _this2.nameInput = function (e) {
      _this2.setData({
        name: e.target.value
      });
    };

    _this2.contactInput = function (e) {
      _this2.setData({
        contact: e.target.value
      });
    };

    _this2.detailInput = function (e) {
      _this2.setData({
        detail: e.target.value
      });
    };

    _this2.setAddress = function (addressId) {
      var orderId = _this2.data.orderId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/setAddress',
        data: {
          order_id: orderId,
          address_id: addressId
        },
        success: function success(res) {
          _app.appMethod.turnBack();
        }
      });
    };

    _this2.setDefaultAddress = function (e) {
      var checked = e.target.value;
      if (checked) {
        _this2.setData({
          isDefault: 1
        });
      } else {
        _this2.setData({
          isDefault: 0
        });
      }
    };

    _this2.sureAddAddress = function () {
      var _this = _this2;
      var addressInfo = _this.data.address_info;
      var addressId = _this.data.addressId;
      var nationIsChina = +_this.data.nationId === 1;
      var areaCodeIndex = _this2.data.areaCodeIndex;
      if (!addressInfo.name) {
        _app.appMethod.showModal({
          content: '联系人不能为空'
        });
        return;
      }
      if (!addressInfo.contact) {
        _app.appMethod.showModal({
          content: '电话不能为空'
        });
        return;
      }
      if (nationIsChina && (areaCodeIndex == 0 && !/^1[0-9]{10}$/.test(addressInfo.contact) || areaCodeIndex != 1 && !/^\d+$/.test(addressInfo.contact))) {
        _app.appMethod.showModal({
          content: '请填写正确的手机号'
        });
        return;
      }
      if (!(addressInfo.province && addressInfo.province.text)) {
        _app.appMethod.showModal({
          content: '请选择收货地址'
        });
        return;
      }
      if (!addressInfo.detailAddress) {
        _app.appMethod.showModal({
          content: '详细地址不能为空'
        });
        return;
      }
      if (nationIsChina && ~['89', '233'].indexOf(addressInfo.country.id) || !nationIsChina && addressInfo.country.id == '1') {
        _app.appMethod.showModal({
          content: '所在地区与国家不匹配'
        });
        return;
      }
      if (nationIsChina && areaCodeIndex) {
        switch (areaCodeIndex) {
          case '1':
            addressInfo.contact = '+853-' + addressInfo.contact;
            break;
          case '2':
            addressInfo.contact = '+852-' + addressInfo.contact;
            break;
          case '3':
            addressInfo.contact = '+886-' + addressInfo.contact;
            break;
        }
      }
      if (_this2.data.nationId == 89) {
        addressInfo.contact = '1-' + addressInfo.contact;
      } else if (_this2.data.nationId == 233) {
        addressInfo.contact = '60-' + addressInfo.contact;
      }
      var addressInfoCopy = JSON.parse(JSON.stringify(addressInfo));
      if (addressInfoCopy.detailAddress) {
        addressInfoCopy.detailAddress = addressInfoCopy.address + addressInfoCopy.detailAddress;
        var index = addressInfoCopy.detailAddress.indexOf('区');
        addressInfoCopy.detailAddress = addressInfoCopy.detailAddress.substring(index + 1, addressInfoCopy.detailAddress.length);
      }
      if (addressInfoCopy.address) {
        delete addressInfoCopy.address;
      }
      if (_this2.data.address_info.detailAddress.indexOf(_this2.data.detailAddress) !== -1) {
        addressInfo.latitude = _this2.data.latitude;
        addressInfo.longitude = _this2.data.longitude;
      } else {
        delete addressInfo.latitude;
        delete addressInfo.longitude;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addAddress',
        method: 'post',
        data: {
          address_info: addressInfo,
          address_id: addressId,
          is_default: 0
        },
        success: function success(res) {
          _app.appMethod.showToast({
            title: '保存成功'
          });
          _app.appMethod.turnBack();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          console.log(res);
          if (res.data == '获取经纬度失败') {
            _app.appMethod.showModal({
              content: '该地址定位不到，请检查地址是否正确'
            });
            return false;
          }
        }
      });
    };

    _this2.deleteAddress = function (e) {
      var _this = _this2;
      _app.appMethod.showModal({
        content: '确定要删除地址？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/delAddress',
            data: {
              address_id: _this.data.addressId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.addAdressName = function (e) {
      _this2.setData({
        'address_info.name': e.target.value
      });
    };

    _this2.addAdressContact = function (e) {
      _this2.setData({
        'address_info.contact': e.target.value
      });
    };

    _this2.addAdressDetailAddress = function (e) {
      _this2.setData({
        'address_info.detailAddress': e.target.value
      });
    };

    _this2.selectAddressLabel = function (e) {
      _this2.setData({
        'address_info.label': e.currentTarget.dataset.label
      });
    };

    _this2.selectAddressSex = function (e) {
      _this2.setData({
        'address_info.sex': e.currentTarget.dataset.sex
      });
    };

    _this2.addSelectAddress = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/searchAddress/searchAddress?from=addAddress&nationId=' + _this2.data.nationId + '&nationname=' + _this2.data.nationname);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      });
    };

    _this2.selectNation = function (e) {
      var _this = _this2;
      var selectedNationId = e[0];
      var newData = {
        nationId: selectedNationId
      };
      _this2.data.nationList.some(function (n, nId) {
        var f = n.value == selectedNationId;
        if (f) {
          newData.nationSelectedIndex = [nId];
          newData.nationname = n.label;
        }
        return f;
      });
      _this.setData(newData);
    };

    _this2.selectAreaCode = function (e) {
      _this2.setData({
        areaCodeIndex: e[0]
      });
    };

    document.title = '新增收货地址';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().data || _app.appMethod.getCurrentPage().callbackData) {
      _this2.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this2;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(AddAddress, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      var _currentPage = this.currentPage,
          data = _currentPage.data,
          callbackData = _currentPage.callbackData;

      if (data) {
        this.setData(data);
      }
      if (callbackData) {
        this.setData(callbackData);
        this.currentPage.clearCallbackData();
        if (this.currentPage.location) {
          this.location = this.currentPage.location;
          delete this.currentPage.location;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var newData = {};
      var id = options.id || '';
      newData.addressId = id;
      var orderId = options.oid || '';
      newData.orderId = orderId;
      var countryId = options.countryId || false;
      if (countryId !== false) {
        newData.nationId = countryId;
      }
      if (id) {
        _app.appMethod.setPageTitle('编辑收货地址');
      }
      this.setData(newData);
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.selectAddressBack) {
        this.getAllPickUpConfig();
      }
      this.data.detailAddress = this.data.address_info.detailAddress;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          address_info = _state.address_info,
          storeStyle = _state.storeStyle,
          nationSelectedIndex = _state.nationSelectedIndex,
          nationList = _state.nationList,
          areaCodeArr = _state.areaCodeArr,
          areaCodeIndex = _state.areaCodeIndex,
          nationId = _state.nationId,
          suportExpress = _state.suportExpress,
          suportSameCity = _state.suportSameCity,
          suportSelfDelivery = _state.suportSelfDelivery,
          addressId = _state.addressId;

      return React.createElement(
        'div',
        { className: 'official-page add-address' },
        React.createElement(_TopNav.TopNav, { title: '\u65B0\u589E\u5730\u5740' }),
        React.createElement(
          'div',
          { id: 'newAddressDialog' },
          React.createElement(
            'div',
            { className: 'newAddressBox' },
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u6536\u8D27\u4EBA'
              ),
              React.createElement('input', {
                maxLength: '20',
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u6536\u8D27\u4EBA\u59D3\u540D',
                onInput: this.addAdressName,
                value: address_info.name || '',
                onChange: function onChange() {}
              })
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u6027\u522B'
              ),
              React.createElement(
                'div',
                { className: 'adress-label-box' },
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)(address_info.sex == 0 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme + ';background:' + storeStyle.theme + '33' : ''),
                    className: 'adressLabel ' + (address_info.sex == 0 ? 'active' : ''),
                    onClick: this.selectAddressSex,
                    'data-sex': '0'
                  },
                  '\u5973\u58EB'
                ),
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)(address_info.sex == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme + ';background:' + storeStyle.theme + '33' : ''),
                    className: 'adressLabel ' + (address_info.sex == 1 ? 'active' : ''),
                    onClick: this.selectAddressSex,
                    'data-sex': '1'
                  },
                  '\u5148\u751F'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u56FD\u5BB6'
              ),
              React.createElement(
                'div',
                { className: 'nationName content-flex-end' },
                !!nationList.length && React.createElement(
                  _picker2.default,
                  {
                    data: nationList,
                    cols: 1,
                    value: [nationList[nationSelectedIndex].value],
                    onOk: function onOk(v) {
                      return _this3.selectNation(v);
                    }
                  },
                  React.createElement(_list2.default.Item, null)
                )
              ),
              React.createElement('span', { className: 'ico-moon icon-rightarrow' })
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u533A\u53F7'
              ),
              React.createElement(
                'div',
                { className: 'area-code-picker content-flex-end' },
                nationId == 1 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    _picker2.default,
                    {
                      data: areaCodeArr,
                      cols: 1,
                      value: [areaCodeIndex],
                      onOk: function onOk(v) {
                        return _this3.selectAreaCode(v);
                      }
                    },
                    React.createElement(_list2.default.Item, null)
                  )
                ) : nationId == 89 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'area-code-picker' },
                    'Canada +1'
                  )
                ) : nationId == 233 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'area-code-picker' },
                    'Malaysia +60'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u624B\u673A\u53F7\u7801'
              ),
              React.createElement('input', {
                type: 'text',
                placeholder: '\u8BF7\u586B\u5199\u6536\u8D27\u4EBA\u624B\u673A\u53F7',
                onInput: this.addAdressContact,
                value: address_info.contact || '',
                onChange: function onChange() {}
              })
            ),
            React.createElement(
              'div',
              { className: 'newAddressView', onClick: this.addSelectAddress },
              React.createElement(
                'label',
                null,
                '\u6240\u5728\u5730\u533A'
              ),
              React.createElement('input', {
                type: 'text',
                placeholder: '\u8BF7\u9009\u62E9\u7701\u5E02\u533A',
                value: address_info.regionInfoText || '',
                onChange: function onChange() {}
              }),
              React.createElement('span', { className: 'ico-moon icon-rightarrow' })
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u8BE6\u7EC6\u5730\u5740'
              ),
              React.createElement('input', {
                type: 'text',
                placeholder: '\u8BE6\u7EC6\u5730\u5740\uFF08\u4F8B\u5982\u95E8\u724C\u53F7\u7B49\uFF09',
                onInput: this.addAdressDetailAddress,
                value: address_info.detailAddress || '',
                onChange: function onChange() {}
              })
            ),
            React.createElement(
              'div',
              { className: 'newAddressView' },
              React.createElement(
                'label',
                null,
                '\u9009\u62E9\u6807\u7B7E'
              ),
              React.createElement(
                'div',
                { className: 'adress-label-box' },
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)(address_info.label == 0 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme + ';background:' + storeStyle.theme + '33' : ''),
                    className: 'adressLabel ' + (address_info.label == 0 ? 'active' : ''),
                    onClick: this.selectAddressLabel,
                    'data-label': '0'
                  },
                  '\u5BB6'
                ),
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)(address_info.label == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme + ';background:' + storeStyle.theme + '33' : ''),
                    className: 'adressLabel ' + (address_info.label == 1 ? 'active' : ''),
                    onClick: this.selectAddressLabel,
                    'data-label': '1'
                  },
                  '\u5B66\u6821'
                ),
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)(address_info.label == 2 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme + ';background:' + storeStyle.theme + '33' : ''),
                    className: 'adressLabel ' + (address_info.label == 2 ? 'active' : ''),
                    onClick: this.selectAddressLabel,
                    'data-label': '2'
                  },
                  '\u516C\u53F8'
                )
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'label',
                null,
                '\u53D6\u8D27\u65B9\u5F0F'
              ),
              React.createElement(
                'div',
                { className: 'address-pick-up' },
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', {
                    style: (0, _tools.convertLineStyleData)(suportExpress ? 'color:' + storeStyle.theme : ''),
                    className: 'ico-moon icon-goods-support-delivery ' + (suportExpress ? 'suporrt' : '')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u5FEB\u9012'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', {
                    style: (0, _tools.convertLineStyleData)(suportSameCity ? 'color:' + storeStyle.theme : ''),
                    className: 'ico-moon icon-goods-support-delivery ' + (suportSameCity ? 'suporrt' : '')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u540C\u57CE'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', {
                    style: (0, _tools.convertLineStyleData)(suportSelfDelivery ? 'color:' + storeStyle.theme : ''),
                    className: 'ico-moon icon-goods-support-delivery ' + (suportSelfDelivery ? 'suporrt' : '')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u81EA\u63D0'
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'newAddressBottom' },
            React.createElement(
              'div',
              {
                className: 'sureAddAddress',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                onClick: this.sureAddAddress
              },
              '\u4FDD\u5B58\u5E76\u4F7F\u7528'
            ),
            addressId && React.createElement(
              'div',
              { className: 'cancelAddAddress', onClick: this.deleteAddress },
              '\u5220\u9664\u6536\u8D27\u5730\u5740'
            )
          )
        )
      );
    }
  }]);
  return AddAddress;
}(_OfficialPage3.default);

exports.default = AddAddress;

/***/ }),
/* 437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _tools = __webpack_require__(6);

var _Recommend = __webpack_require__(141);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(440);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsOrderPaySuccess = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsOrderPaySuccess, _OfficialPage);

  function GoodsOrderPaySuccess(props) {
    (0, _classCallCheck3.default)(this, GoodsOrderPaySuccess);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsOrderPaySuccess.__proto__ || Object.getPrototypeOf(GoodsOrderPaySuccess)).call(this, props));

    _this2.state = {
      status: 0, // 0: 普通页面 1:有集集乐的情况
      orderId: '',
      franchiseeId: '',
      collectBenefitData: {}, // 集集乐数据
      starData: [], //集集乐的星 light:已集样式 dark:未集样式
      isFail: true, //刮刮乐未中奖
      isWinning: true, //刮刮乐中奖
      isComfort: true, //刮刮乐安慰奖
      isWhole: true, //刮奖区域是否显示
      scratchId: '', //活动号
      isShowteam: false,
      winingTitle: '',
      isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false,
      storeStyle: {}
    };
    _this2.recommendRef = React.createRef();

    _this2.touchStart = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchMove = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchEnd = function (e) {
      if (!_this2.isStart) return;
      var canvasWidth = _this2.canvasWidth,
          canvasHeight = _this2.canvasHeight,
          minX = _this2.minX,
          minY = _this2.minY,
          maxX = _this2.maxX,
          maxY = _this2.maxY;

      if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
        _this2.ctx.draw();
        _this2.endCallBack && _this2.endCallBack();
        _this2.isStart = false;
        _this2.page.setData({
          isScroll: true
        });
      }
    };

    _this2.getGoldenData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(data) {
          if (data.data) {
            if (that.data.code) {
              that.setData({
                isWhole: true
              });
            } else {
              that.setData({
                isWhole: false,
                scratchId: data.data
              });
            }
          } else {
            that.setData({
              isWhole: true
            });
          }
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this2.showAreaClick = function () {
      var that = _this2;
      that.setData({
        isShowteam: false
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = res.data;
          that.scratch.start();
          if (data.title == '谢谢参与') {
            that.setData({
              isFail: false
            });
          } else {
            var params = {
              ifWxCoupon: data.card_id || false,
              timestamp: data.timestamp || '',
              signature: data.signature || ''
            };
            if (data.is_comfort) {
              params['isComfort'] = false;
            } else {
              params['isWinning'] = false;
              params['winingTitle'] = data.title;
            }
            that.setData(params);
          }
        }
      });
    };

    _this2.onShareAppMessage = function (res) {
      var that = _this2;
      var franchiseeParam = _this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '';
      return {
        path: '/awardManagement/pages/scratch/scratch?id=' + that.data.scratchId + franchiseeParam,
        success: function success(res) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/getTime',
            data: {
              activity_id: that.data.scratchId,
              type: 'share',
              sub_app_id: that.data.franchiseeId
            },
            success: function success(res) {}
          });
        },
        fail: function fail(res) {}
      };
    };

    _this2.getCollectBenefitData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var starData = [];
          for (var i = 0; i < res.data.star_num; i++) {
            starData.push('light');
          }
          for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
            starData.push('dark');
          }
          that.setData({
            collectBenefitData: res.data,
            starData: starData
          });
        }
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({
        url: '/pages/' + router + '/' + router
      });
    };

    _this2.goToOrderDetail = function (e) {
      var pickUpType = e.target.dataset.type || '';
      var path = pickUpType == 4 ? 'diningOrderDetail/diningOrderDetail?detail=' : 'goodsOrderDetail/goodsOrderDetail?detail=';
      var that = _this2;
      var pagePath = '/eCommerce/pages/' + path + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var groupPath = '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var appointmentPath = '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var newAppointmentPath = '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '') + '&aptType=' + _this2.data.is_newAppointment;
      var myOrderPage = '/eCommerce/pages/myOrder/myOrder?goodsType=0&currentIndex=0';
      if (_this2.data.is_group == 'true') {
        _app.appMethod.turnToPage(groupPath, true);
      } else if (_this2.data.code) {
        _app.appMethod.turnToPage(appointmentPath, true);
      } else if (_this2.data.is_newAppointment) {
        _app.appMethod.turnToPage(newAppointmentPath, true);
      } else if (_this2.data.isFranchisee) {
        _app.appMethod.turnToPage(myOrderPage, true);
      } else {
        _app.appMethod.turnToPage(pagePath, true);
      }
    };

    _this2.getOrderDetail = function () {
      var _this = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this.data.orderId,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            orderInfo: res.data[0].form_data
          });
        }
      });
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.scratchId
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
            }
          });
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config,
          hasRecommendConfig: res.recommend_config ? true : false
        });
      }, _this2.data.franchiseeId);
    };

    document.title = '支付成功';
    return _this2;
  }

  (0, _createClass3.default)(GoodsOrderPaySuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      if (options.collectBenefit == 1) {
        that.getCollectBenefitData(options.detail);
        that.setData({
          status: 1
        });
      }
      that.setData({
        orderId: options.detail,
        franchiseeId: options.franchisee || '',
        is_group: options.is_group || '',
        code: options.code || '',
        is_newAppointment: options.is_newAppointment || '',
        isFranchisee: options.isFranchisee == 1 ? true : false // 是否是多商家多店结算
      });
      that.getOrderDetail();
      this.getAppECStoreConfig();
      that.getGoldenData(options.detail);
      var systemInfo = _app.appMethod.globalData.systemInfo || {};
      var width = 558 * systemInfo.windowWidth / 750;
      var height = 258 * systemInfo.windowWidth / 750;
      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              isShowteam: true
            });
          }, 10);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          storeStyle = _state.storeStyle,
          orderInfo = _state.orderInfo,
          hasRecommendConfig = _state.hasRecommendConfig,
          collectBenefitData = _state.collectBenefitData,
          starData = _state.starData,
          status = _state.status,
          isWhole = _state.isWhole,
          isFail = _state.isFail,
          isWinning = _state.isWinning,
          winingTitle = _state.winingTitle,
          isComfort = _state.isComfort,
          ifGetComfort = _state.ifGetComfort,
          ifWxCoupon = _state.ifWxCoupon,
          hideCanvas = _state.hideCanvas,
          scratch = _state.scratch,
          isScroll = _state.isScroll,
          isShowteam = _state.isShowteam,
          franchiseeId = _state.franchiseeId;

      // 防报错处理,小程序wxml是不存在这种问题,web端需要解决

      orderInfo = orderInfo || {};
      scratch = scratch || {};

      return React.createElement(
        'div',
        { className: 'official-page goods-order-pay-success' },
        React.createElement(_TopNav.TopNav, { title: '\u652F\u4ED8\u6210\u529F' }),
        React.createElement(
          'div',
          null,
          hasRecommendConfig && React.createElement(
            'div',
            { className: 'normal-area' },
            React.createElement(
              'div',
              {
                className: 'order-price-box',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              React.createElement(
                'div',
                { className: 'order-success' },
                React.createElement('img', {
                  className: 'goods-complete-succes',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-success.png'
                }),
                React.createElement(
                  'span',
                  null,
                  '\u652F\u4ED8\u6210\u529F'
                )
              ),
              React.createElement(
                'div',
                { className: 'order-price' },
                '¥' + orderInfo.order_total_price
              ),
              React.createElement(
                'div',
                { className: 'btn-area' },
                React.createElement(
                  'div',
                  { onClick: this.goToHomepage },
                  '\u7EE7\u7EED\u8D2D\u7269'
                ),
                React.createElement(
                  'div',
                  {
                    onClick: this.goToOrderDetail,
                    'data-type': orderInfo.pick_up_type
                  },
                  '\u67E5\u770B\u8BA2\u5355'
                )
              )
            ),
            React.createElement('img', {
              className: 'goods-complete-bg',
              src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png'
            })
          ),
          !hasRecommendConfig && React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'no-recommend-box' },
              React.createElement(
                'div',
                {
                  className: 'normal-area',
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                },
                React.createElement('img', {
                  className: 'goods-complete-succes',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/big-goods-complete-success.png'
                }),
                React.createElement('img', {
                  className: 'goods-complete-bg',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png'
                })
              ),
              React.createElement(
                'div',
                {
                  className: 'goods-complete-title',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '¥' + orderInfo.order_total_price
              ),
              React.createElement(
                'div',
                { className: 'slogan' },
                '\u652F\u4ED8\u6210\u529F'
              ),
              React.createElement(
                'div',
                { className: 'btn-area' },
                React.createElement(
                  'div',
                  {
                    className: 'go-on-shopping',
                    onClick: this.goToHomepage,
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme)
                  },
                  '\u7EE7\u7EED\u8D2D\u7269'
                ),
                React.createElement(
                  'div',
                  {
                    onClick: this.goToOrderDetail,
                    'data-type': orderInfo.pick_up_type
                  },
                  '\u67E5\u770B\u8BA2\u5355'
                )
              )
            )
          ),
          status == 1 && React.createElement(
            'div',
            { className: 'collect-benefit-area' },
            React.createElement(
              'div',
              { className: 'activity-box' },
              React.createElement('div', { className: 'line' }),
              React.createElement(
                'div',
                { className: 'activity-title' },
                '\u6D3B\u52A8'
              ),
              React.createElement('div', { className: 'line' })
            ),
            React.createElement(
              'div',
              { className: 'collect-item' },
              React.createElement(
                'div',
                { className: 'star-num' },
                '集集乐个数: ' + collectBenefitData.star_num
              ),
              React.createElement(
                'div',
                { className: 'star-list' },
                starData.map(function (item, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    item == 'light' ? React.createElement('img', {
                      className: 'star-item',
                      src: collectBenefitData.light_img
                    }) : item == 'dark' && React.createElement('img', {
                      className: 'star-item',
                      src: collectBenefitData.dark_img
                    })
                  );
                })
              ),
              collectBenefitData.star_num == collectBenefitData.collect_num && React.createElement(
                'div',
                { className: 'star-full' },
                React.createElement(
                  'div',
                  { className: 'star-full-text' },
                  '\u6EE1'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'tip-item' },
              collectBenefitData.star_num == collectBenefitData.collect_num ? React.createElement(
                'div',
                null,
                '获得一张' + collectBenefitData.coupon_title
              ) : collectBenefitData.star_num != collectBenefitData.collect_num && React.createElement(
                'div',
                null,
                '消费' + (collectBenefitData.play_type == 0 ? '每满' : '超过') + collectBenefitData.value + '元，累计一颗星，集满可获得' + collectBenefitData.coupon_title + '一张'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'scratchWhole', hidden: isWhole },
            React.createElement(
              'div',
              { className: 'activity-box scratch-activity' },
              React.createElement('div', { className: 'line' }),
              React.createElement(
                'div',
                { className: 'activity-title' },
                '\u6D3B\u52A8'
              ),
              React.createElement('div', { className: 'line' })
            ),
            React.createElement(
              'div',
              { className: 'scratchArea' },
              React.createElement(
                'div',
                { className: 'scratchFail', hidden: isFail },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png' }),
                React.createElement(
                  'div',
                  { className: 'failTitle' },
                  React.createElement(
                    'div',
                    { className: 'failShare', onClick: this.shareClickEvent },
                    '\u5206\u4EAB'
                  ),
                  React.createElement(
                    'div',
                    { className: 'failText' },
                    '\u5F88\u9057\u61BE\u6CA1\u6709\u4E2D\u5956\u54E6'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchWinning', hidden: isWinning },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png' }),
                React.createElement(
                  'div',
                  { className: 'winningTitle' },
                  React.createElement(
                    'div',
                    { className: 'winningShare', onClick: this.shareClickEvent },
                    '\u5206\u4EAB'
                  ),
                  React.createElement(
                    'div',
                    { className: 'winningText' },
                    '\u606D\u559C\u4F60\u83B7\u5F97\u4E86'
                  ),
                  React.createElement(
                    'div',
                    { className: 'winningText winningValue' },
                    winingTitle
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchComfort', hidden: isComfort },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png' }),
                React.createElement(
                  'div',
                  { className: 'comfortTitle' },
                  React.createElement(
                    'div',
                    { className: 'comfortShare', onClick: this.shareClickEvent },
                    '\u5206\u4EAB'
                  ),
                  ifGetComfort ? React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                  ) : React.createElement(
                    'div',
                    (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                    '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                  ),
                  !ifWxCoupon && !ifGetComfort && React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '>\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'scratch_wp',
                  hidden: hideCanvas,
                  style: (0, _tools.convertLineStyleData)('width: ' + scratch.width + 'px; height: ' + scratch.height + 'px;')
                },
                React.createElement('canvas', {
                  className: 'scratch-canvas',
                  width: scratch && scratch.width,
                  height: scratch && scratch.height,
                  id: 'scratch-canvas',
                  onTouchStart: this.touchStart,
                  onTouchMove: this.touchMove,
                  onTouchEnd: this.touchEnd
                }),
                isShowteam && React.createElement(
                  'div',
                  { className: 'showArea' },
                  React.createElement(
                    'div',
                    { className: 'showTitle' },
                    '\u8D62\u53D6\u4F18\u60E0\u5927\u5956'
                  ),
                  React.createElement(
                    'div',
                    { className: 'showBtn', onClick: this.showAreaClick },
                    '\u70B9\u6211\u522E\u5956'
                  )
                )
              )
            )
          )
        ),
        React.createElement(_Recommend.Recommend, { id: 'component-recommend', franchiseeId: franchiseeId, ref: this.recommendRef })
      );
    }
  }]);
  return GoodsOrderPaySuccess;
}(_OfficialPage3.default);

exports.default = GoodsOrderPaySuccess;

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(442);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsComment = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsComment, _OfficialPage);

  function GoodsComment(props) {
    (0, _classCallCheck3.default)(this, GoodsComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoodsComment.__proto__ || Object.getPrototypeOf(GoodsComment)).call(this, props));

    _this.state = {
      goodsId: '',
      commentType: 0,
      comments: [],
      commentNums: [],
      loadPage: 1,
      total_page: 1,
      storeStyle: {}
    };

    _this.onReachBottom = function () {
      if (_this.data.loadPage > _this.data.total_page) {
        return;
      }
      _this.getAssessList(_this.data.commentType, _this.data.loadPage, 1);
    };

    _this.getAssessList = function (commentType, page, append) {
      var that = _this;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          idx_arr: {
            idx: 'level',
            idx_value: commentType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          var commentArr = res.data;
          if (append) {
            commentArr = that.data.comments.concat(commentArr);
          }
          that.setData({
            comments: commentArr,
            commentNums: res.num,
            loadPage: that.data.loadPage + 1,
            total_page: res.total_page
          });
        }
      });
    };

    _this.clickCommentLabel = function (e) {
      var commentType = e.currentTarget.dataset.type,
          data = {};
      data.loadPage = 1;
      data.commentType = commentType;
      _this.setData(data);
      _this.getAssessList(commentType, 1);
    };

    _this.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config
        });
      }, _this.data.franchiseeId);
    };

    document.title = '商品评价';
    return _this;
  }

  (0, _createClass3.default)(GoodsComment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var goodsId = options.detail || '',
          franchiseeId = options.franchisee || '';
      this.setData({
        goodsId: goodsId,
        franchiseeId: franchiseeId
      });
      this.getAssessList(0, 1);
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          commnetType = _state.commnetType,
          storeStyle = _state.storeStyle,
          commentNums = _state.commentNums,
          comments = _state.comments;

      return React.createElement(
        'div',
        { className: 'official-page goods-comment' },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BC4\u8BBA' }),
        React.createElement(
          'div',
          { className: 'comPage-wrap page', id: 'commentPage' },
          React.createElement(
            'div',
            { className: 'comPage-top-section' },
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('border-bottom:1px solid #f4f4f4;') },
              React.createElement(
                'label',
                {
                  style: (0, _tools.convertLineStyleData)('background:' + (commnetType == 0 ? storeStyle.theme : storeStyle.theme + '33')),
                  onClick: this.clickCommentLabel,
                  'data-type': '0',
                  className: 'comPage-comment-label ' + (commnetType == 0 ? 'active' : '')
                },
                '\u5168\u90E8'
              ),
              React.createElement(
                'label',
                {
                  style: (0, _tools.convertLineStyleData)('background:' + (commnetType == 1 ? storeStyle.theme : storeStyle.theme + '33')),
                  onClick: this.clickCommentLabel,
                  'data-type': '1',
                  className: 'comPage-comment-label ' + (commnetType == 1 ? 'active' : '')
                },
                '\u597D\u8BC4 (',
                React.createElement(
                  'label',
                  { className: 'comPage-positive-comment' },
                  commentNums[1]
                ),
                ')'
              ),
              React.createElement(
                'label',
                {
                  style: (0, _tools.convertLineStyleData)('background:' + (commnetType == 2 ? storeStyle.theme : storeStyle.theme + '33')),
                  onClick: this.clickCommentLabel,
                  'data-type': '2',
                  className: 'comPage-comment-label ' + (commnetType == 2 ? 'active' : '')
                },
                '\u4E2D\u8BC4 (',
                React.createElement(
                  'label',
                  { className: 'comPage-neutral-comment' },
                  commentNums[2]
                ),
                ')'
              ),
              React.createElement(
                'label',
                {
                  style: (0, _tools.convertLineStyleData)('background:' + (commnetType == 3 ? storeStyle.theme : storeStyle.theme + '33')),
                  onClick: this.clickCommentLabel,
                  'data-type': '3',
                  className: 'comPage-comment-label ' + (commnetType == 3 ? 'active' : '')
                },
                '\u5DEE\u8BC4 (',
                React.createElement(
                  'label',
                  { className: 'comPage-negative-comment' },
                  commentNums[3]
                ),
                ')'
              ),
              React.createElement(
                'label',
                {
                  style: (0, _tools.convertLineStyleData)('background:' + (commnetType == 4 ? storeStyle.theme : storeStyle.theme + '33')),
                  onClick: this.clickCommentLabel,
                  'data-type': '4',
                  className: 'comPage-comment-label ' + (commnetType == 4 ? 'active' : '')
                },
                '\u6709\u56FE (',
                React.createElement(
                  'label',
                  { className: 'comPage-pic-comment' },
                  commentNums[4]
                ),
                ')'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'comPage-bottom-section' },
            React.createElement(
              'div',
              { className: 'comPage-comment-list' },
              comments.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'comPage-comment-item', key: item.id },
                  React.createElement(
                    'div',
                    null,
                    React.createElement('img', {
                      className: 'comPage-comment-photo',
                      src: item.buyer_headimgurl
                    }),
                    React.createElement(
                      'span',
                      { className: 'comPage-comment-name' },
                      item.buyer_nickname
                    )
                  ),
                  React.createElement(
                    'span',
                    { className: 'comPage-comment-date' },
                    item.add_time
                  ),
                  React.createElement(
                    'div',
                    { className: 'comPage-comment-content' },
                    item.assess_info.content
                  ),
                  !!+item.assess_info.has_img && React.createElement(
                    'div',
                    { className: 'comPage-comment-pics' },
                    item.assess_info.img_arr.map(function (imgSrc, index) {
                      return React.createElement('img', {
                        key: index,
                        src: imgSrc,
                        'data-src': imgSrc,
                        'data-srcarr': JSON.stringify(item.assess_info.img_arr),
                        onClick: _this2.clickPlusImages
                      });
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return GoodsComment;
}(_OfficialPage3.default);

exports.default = GoodsComment;

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(444);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsAdditionalInfo = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsAdditionalInfo, _OfficialPage);

  function GoodsAdditionalInfo(props) {
    (0, _classCallCheck3.default)(this, GoodsAdditionalInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoodsAdditionalInfo.__proto__ || Object.getPrototypeOf(GoodsAdditionalInfo)).call(this, props));

    _this.state = {
      goods_info: [],
      additional_info_obj: {},
      from: ''
    };
    _this.delivery_id_arr = [];
    _this.goods_id_arr = [];

    _this.dataInitial = function () {
      _this.getAppECStoreConfig();
      var goodsInfo = _app.appMethod.getPreviewGoodsInfo(),
          additional_info = _app.appMethod.getGoodsAdditionalInfo(),
          additionalInfoWrited = false;
      _this.setData({
        goods_info: goodsInfo,
        additional_info_obj: additional_info
      });
      for (var key in additional_info) {
        if (key !== undefined) {
          additionalInfoWrited = true;
          break;
        }
      }
      if (additionalInfoWrited) {
        return;
      }
      for (var i = 0; i <= goodsInfo.length - 1; i++) {
        var id = goodsInfo[i].id || goodsInfo[i].goods_id;
        if (_this.goods_id_arr.indexOf(id) == -1) {
          _this.goods_id_arr.push(id);
          _this.delivery_id_arr.push(goodsInfo[i].delivery_id);
        }
      }
      if (_this.delivery_id_arr.length) {
        _this.getDeliveryInfo();
      }
    };

    _this.getDeliveryInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=pc/AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_ids: _this.delivery_id_arr
        },
        success: function success(res) {
          var goods_info = that.data.goods_info,
              delivery_arr = res.data,
              additional_info_obj = {};
          for (var i = 0; i <= delivery_arr.length - 1; i++) {
            var goods_id = goods_info[i].id || goods_info[i].goods_id,
                delivery_info = delivery_arr[i].delivery_info;
            additional_info_obj[goods_id] = [];
            for (var j = 0; j <= delivery_info.length - 1; j++) {
              if (delivery_info[j].is_hidden == 1) {
                // is_hidden = 1 时不隐藏字段
                additional_info_obj[goods_id].push({
                  title: delivery_info[j].name,
                  type: delivery_info[j].type,
                  is_required: delivery_info[j].is_required,
                  value: ''
                });
              }
            }
          }
          that.setData({
            additional_info_obj: additional_info_obj
          });
        }
      });
    };

    _this.inputFormControl = function (e) {
      var goodsId = e.currentTarget.dataset.goodsId,
          additionalIndex = e.currentTarget.dataset.additionalIndex,
          value = e.target.value,
          data = {};
      data['additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'] = value;
      _this.setData(data);
    };

    _this.uploadImg = function (e) {
      var that = _this,
          goodsId = e.currentTarget.dataset.goodsId,
          additionalIndex = e.currentTarget.dataset.additionalIndex,
          images = _this.data.additional_info_obj[goodsId][additionalIndex].value || [];
      _app.appMethod.chooseImage(function (imageArr) {
        var data = {};
        data['additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'] = images.concat(imageArr);
        that.setData(data);
      }, 9 - images.length);
    };

    _this.deleteImage = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsId = dataset.goodsId,
          additionalIndex = dataset.additionalIndex,
          imageIndex = dataset.imageIndex,
          images = _this.data.additional_info_obj[goodsId][additionalIndex].value,
          data = {};
      images.splice(imageIndex, 1);
      data['additional_info_obj.' + goodsId + '[' + additionalIndex + '].value'] = images;
      _this.setData(data);
    };

    _this.submitAdditionalInfo = function () {
      var additional_info_obj = _this.data.additional_info_obj,
          completeInfo = true;
      for (var goodsId in additional_info_obj) {
        if (!completeInfo) {
          break;
        }
        if (additional_info_obj[goodsId]) {
          var goods_additional_info = additional_info_obj[goodsId];
          for (var i = 0; i <= goods_additional_info.length - 1; i++) {
            if (goods_additional_info[i].is_required == 0 && (!goods_additional_info[i].value || goods_additional_info[i].value.length == 0)) {
              _app.appMethod.showModal({
                content: goods_additional_info[i].title + '不能为空'
              });
              completeInfo = false;
              break;
            }
          }
        }
      }
      if (!completeInfo) {
        return;
      }
      var pages = _app.appMethod.getCurrentPages();
      var prePage = pages[pages.length - 2];
      if (_this.selectedAppId) {
        var _prePage$setData;

        // 多店情况
        prePage.setData((_prePage$setData = {}, (0, _defineProperty3.default)(_prePage$setData, 'mulShopsInfo.' + _this.selectedAppId + '.additional_info', _this.data.additional_info_obj), (0, _defineProperty3.default)(_prePage$setData, 'mulShopsInfo.' + _this.selectedAppId + '.deliverydWrite', true), _prePage$setData));
      } else {
        prePage.setData({
          additional_info: _this.data.additional_info_obj,
          deliverydWrite: true
        });
      }
      prePage.additional_info = _this.data.additional_info_obj;
      prePage.hasRequiredSuppInfo = false;
      _app.appMethod.turnBack();
    };

    _this.previewImage = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsId = dataset.goodsId,
          additionalIndex = dataset.additionalIndex,
          imageIndex = dataset.imageIndex,
          urls = _this.data.additional_info_obj[goodsId][additionalIndex].value;
      _app.appMethod.previewImage({
        current: urls[imageIndex],
        urls: urls
      });
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config
        });
      });
    };

    document.title = '补充信息';
    return _this;
  }

  (0, _createClass3.default)(GoodsAdditionalInfo, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      if (options.hiddenSub) {
        this.setData({
          hiddenSub: options.hiddenSub
        });
      }
      if (options.from) {
        this.setData({
          from: options.from
        });
      }
      if (options.appId) {
        this.selectedAppId = options.appId;
      }
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          additional_info_obj = _state.additional_info_obj,
          storeStyle = _state.storeStyle,
          hiddenSub = _state.hiddenSub,
          from = _state.from,
          goods_info = _state.goods_info;


      return React.createElement(
        'div',
        { className: 'official-page goods-additional-info' },
        React.createElement(_TopNav.TopNav, { title: '\u8865\u5145\u4FE1\u606F' }),
        !from && React.createElement(
          'div',
          { className: 'editor-additional' },
          goods_info.map(function (goods, index) {
            return React.createElement(
              'div',
              { key: goods.id },
              React.createElement(
                'div',
                { className: 'additional-box' },
                React.createElement(
                  'div',
                  { className: 'goods-detail' },
                  React.createElement('img', { className: 'goods-cover', src: goods.cover }),
                  React.createElement(
                    'div',
                    { className: 'goods-info' },
                    React.createElement(
                      'div',
                      { className: 'goods-title' },
                      goods.title || goods.goods_name
                    ),
                    goods.model_value_str && React.createElement(
                      'div',
                      { className: 'goods-model' },
                      goods.model_value_str
                    )
                  )
                ),
                additional_info_obj[goods.id || goods.goods_id] && additional_info_obj[goods.id || goods.goods_id].map(function (item, additionalIndex) {
                  return React.createElement(
                    'div',
                    { className: 'additional-list', key: additionalIndex },
                    item.type == 'text' && React.createElement(
                      'div',
                      { className: 'additional-text' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        React.createElement('input', {
                          type: 'text',
                          onChange: _this2.inputFormControl,
                          'data-goods-id': goods.id || goods.goods_id,
                          'data-additional-index': additionalIndex,
                          value: item.value
                        })
                      )
                    ),
                    item.type == 'mul-text' && React.createElement(
                      'div',
                      { className: 'additional-textarea' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        React.createElement('textarea', {
                          maxLength: '-1',
                          onInput: _this2.inputFormControl,
                          'data-goods-id': goods.id || goods.goods_id,
                          'data-additional-index': additionalIndex,
                          value: item.value
                        })
                      )
                    ),
                    item.type == 'picture' && React.createElement(
                      'div',
                      { className: 'additional-picture' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        item.value && item.value.map(function (imgSrc, imageIndex) {
                          return React.createElement(
                            'div',
                            { className: 'image-list', key: imageIndex },
                            React.createElement('img', { src: imgSrc }),
                            React.createElement(
                              'label',
                              {
                                className: 'delete-image ico-moon icon-closes',
                                onClick: _this2.deleteImage,
                                'data-goods-id': goods.id || goods.goods_id,
                                'data-additional-index': additionalIndex,
                                'data-image-index': imageIndex
                              },
                              '-'
                            )
                          );
                        }),
                        item.value.length < 9 && React.createElement(
                          'div',
                          {
                            className: 'add-images',
                            onClick: _this2.uploadImg,
                            'data-goods-id': goods.id || goods.goods_id,
                            'data-additional-index': additionalIndex
                          },
                          React.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                          React.createElement(
                            'div',
                            null,
                            '\u6DFB\u52A0\u56FE\u7247'
                          )
                        )
                      )
                    )
                  );
                })
              )
            );
          }),
          React.createElement(
            'div',
            {
              className: 'additional-sure',
              style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
              onClick: this.submitAdditionalInfo,
              hidden: hiddenSub
            },
            '\u63D0\u4EA4'
          )
        ),
        (from == 'goodsOrderDetail' || from == 'diningOrderDetail') && React.createElement(
          'div',
          { className: 'show-additional' },
          goods_info.map(function (goods, index) {
            return React.createElement(
              'div',
              { key: goods.id },
              React.createElement(
                'div',
                { className: 'additional-box' },
                React.createElement(
                  'div',
                  { className: 'goods-detail' },
                  React.createElement('img', {
                    className: 'goods-cover',
                    mode: 'scaleToFill',
                    src: goods.cover
                  }),
                  React.createElement(
                    'div',
                    { className: 'goods-info' },
                    React.createElement(
                      'div',
                      { className: 'goods-title' },
                      goods.title || goods.goods_name
                    ),
                    goods.model_value_str && React.createElement(
                      'div',
                      { className: 'goods-model' },
                      goods.model_value_str
                    )
                  )
                ),
                additional_info_obj[goods.id || goods.goods_id] && additional_info_obj[goods.id || goods.goods_id].map(function (item, additionalIndex) {
                  return React.createElement(
                    'div',
                    { className: 'additional-list', key: additionalIndex },
                    item.type == 'text' && React.createElement(
                      'div',
                      { className: 'additionals-text' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        item.value
                      )
                    ),
                    item.type == 'mul-text' && React.createElement(
                      'div',
                      { className: 'additional-textarea' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        item.value
                      )
                    ),
                    item.type == 'picture' && React.createElement(
                      'div',
                      { className: 'additional-picture' },
                      React.createElement(
                        'span',
                        {
                          className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                        },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'additional-info' },
                        item.value.map(function (imgSrc, imageIndex) {
                          return React.createElement(
                            'div',
                            { className: 'image-list', key: imageIndex },
                            React.createElement('img', {
                              src: imgSrc,
                              onClick: _this2.previewImage,
                              'data-image-index': imageIndex,
                              'data-additional-index': additionalIndex,
                              'data-goods-id': goods.id || goods.goods_id
                            })
                          );
                        })
                      )
                    )
                  );
                })
              )
            );
          })
        )
      );
    }
  }]);
  return GoodsAdditionalInfo;
}(_OfficialPage3.default);

exports.default = GoodsAdditionalInfo;

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(47);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _GoodsShoppingCart = __webpack_require__(103);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(446);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsFavorites = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsFavorites, _OfficialPage);

  function GoodsFavorites(props) {
    (0, _classCallCheck3.default)(this, GoodsFavorites);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsFavorites.__proto__ || Object.getPrototypeOf(GoodsFavorites)).call(this, props));

    _this2.state = {
      topNavBarData: {
        title: '收藏夹',
        isDefault: 0
      },
      favoritesStatus: [{ label: '全部', value: 0 }, { label: '失效', value: 2 }, { label: '降价中', value: 3 }, { label: '低库存', value: 4 }],
      selectAll: false,
      showCheckedBox: false,
      favoritesList: [],
      selectStatus: [0],
      unSaleGoodsCount: 0,
      reducePriceGoodsNum: 0,
      hideTips: false,
      showReducePrice: true,
      search: '',
      storeStyle: {}
    };
    _this2.page = 1;
    _this2.isMore = 1;
    _this2.goodsShoppingCartRef = _react2.default.createRef();

    _this2.dataInitial = function () {
      _this2.getFavoriteGoodsList();
      _this2.getAppECStoreConfig();
    };

    _this2.getFavoriteGoodsList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/favoriteGoodsList',
        data: {
          page: _this.page,
          page_size: 10,
          status: _this.data.selectStatus[0],
          search: _this.data.search,
          parent_app_id: _app.appMethod.getShopTypeData() && _app.appMethod.getShopTypeData().is_parent_shop == 1 ? _app.appMethod.getAppId() : '' // 总店要把子店商品展示
        },
        success: function success(res) {
          _this.setData({
            favoritesList: _this.data.favoritesList.concat(res.data),
            unSaleGoodsCount: res.un_sale_goods_count || 0,
            reducePriceGoodsNum: res.reduce_price_goods_num || 0
          });
          _this.isMore = res.is_more;
        }
      });
    };

    _this2.addShoppingCart = function (event) {
      event.stopPropagation();
      _this2.goodsShoppingCartRef.current.showDialog({
        goodsId: event.currentTarget.dataset.id
      });
    };

    _this2.selectGoods = function (event) {
      var index = event.currentTarget.dataset.index;
      var favoritesList = _this2.data.favoritesList;
      var selectAll = true;
      favoritesList[index].selected = !favoritesList[index].selected;
      favoritesList.map(function (item) {
        if (!item.selected) selectAll = false;
      });
      _this2.setData({
        favoritesList: favoritesList,
        selectAll: selectAll
      });
    };

    _this2.clickSelectAll = function () {
      var _this = _this2;
      var selectAll = _this2.data.selectAll;
      var favoritesList = _this2.data.favoritesList;
      favoritesList.map(function (item) {
        item.selected = !selectAll;
      });
      _this2.setData({
        favoritesList: favoritesList,
        selectAll: !selectAll
      });
    };

    _this2.onReachBottom = function () {
      if (!_this2.isMore) {
        return;
      }
      _this2.page++;
      _this2.getFavoriteGoodsList();
    };

    _this2.selectFavoritesStatus = function (value) {
      _this2.setData({
        favoritesList: [],
        selectStatus: value
      });
      _this2.page = 1;
      _this2.getFavoriteGoodsList();
    };

    _this2.searchFavoritesGoods = function (event) {
      if (event.keyCode !== 13) {
        return;
      }
      _this2.page = 1;
      _this2.setData({
        search: event.target.value,
        favoritesList: []
      });
      _this2.getFavoriteGoodsList();
    };

    _this2.deleteGoods = function () {
      var _this = _this2;
      var deleteIdArr = [];
      var favoritesList = _this2.data.favoritesList;
      for (var i = 0; i < favoritesList.length; i++) {
        if (favoritesList[i].selected) {
          deleteIdArr.push(favoritesList[i].id);
          favoritesList.splice(i, 1);
          i--;
        }
      }
      if (deleteIdArr.length <= 0) {
        _app.appMethod.showToast({ title: '未选择商品', icon: 'none' });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteFavoriteGoods',
        method: 'post',
        data: {
          goods_id_arr: deleteIdArr
        },
        success: function success(res) {
          _this.setData({
            favoritesList: favoritesList,
            showCheckedBox: false
          });
        }
      });
    };

    _this2.favoritesOperat = function () {
      _this2.setData({
        showCheckedBox: true
      });
    };

    _this2.favoritesComplete = function () {
      _this2.setData({
        showCheckedBox: false
      });
    };

    _this2.cleanUpGoods = function () {
      _this2.setData({
        selectStatus: 1,
        favoritesList: []
      });
      _this2.page = 1;
      _this2.getFavoriteGoodsList();
    };

    _this2.hideTips = function () {
      _this2.setData({
        hideTips: true
      });
    };

    _this2.goHomePage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      });
    };

    _this2.checkReducePrice = function () {
      _this2.setData({
        selectStatus: 2,
        showReducePrice: false,
        favoritesList: []
      });
      _this2.page = 1;
      _this2.getFavoriteGoodsList();
    };

    _this2.hideReducePrice = function () {
      _this2.setData({
        showReducePrice: false
      });
    };

    _this2.goGoodsDetail = function (event) {
      _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id);
    };

    document.title = '收藏夹';
    return _this2;
  }

  (0, _createClass3.default)(GoodsFavorites, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          storeStyle = _state.storeStyle,
          favoritesList = _state.favoritesList,
          selectStatus = _state.selectStatus,
          search = _state.search,
          hideTips = _state.hideTips,
          unSaleGoodsCount = _state.unSaleGoodsCount,
          favoritesStatus = _state.favoritesStatus,
          showCheckedBox = _state.showCheckedBox,
          selectAll = _state.selectAll,
          showReducePrice = _state.showReducePrice,
          reducePriceGoodsNum = _state.reducePriceGoodsNum;


      return _react2.default.createElement(
        'div',
        { className: 'official-page goods-favorites' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u6536\u85CF\u5939' }),
        !favoritesList.length && selectStatus == 0 && !search ? _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'no-favorites-goods' },
            _react2.default.createElement('span', { className: 'ico-moon icon-favorites' }),
            _react2.default.createElement(
              'div',
              { className: 'no-favorites-title' },
              '\u60A8\u6682\u65F6\u8FD8\u672A\u6536\u85CF\u5546\u54C1'
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'no-favorites-btn',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                onClick: this.goHomePage
              },
              '\u53BB\u901B\u901B'
            )
          )
        ) : _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            {
              className: 'invalid-tips',
              hidden: hideTips || !unSaleGoodsCount
            },
            _react2.default.createElement('span', {
              className: 'ico-moon icon-closes',
              onClick: this.hideTips
            }),
            _react2.default.createElement(
              'span',
              null,
              '失效宝贝（' + unSaleGoodsCount + '个）'
            ),
            _react2.default.createElement(
              'span',
              {
                className: 'pull-right go-invalid-goods',
                onClick: this.cleanUpGoods
              },
              '\u524D\u5F80\u6E05\u7406'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'favorites-header' },
              _react2.default.createElement(
                'div',
                { className: 'favorites-status-select' },
                _react2.default.createElement(
                  _picker2.default,
                  {
                    cols: 1,
                    data: favoritesStatus,
                    onChange: this.selectFavoritesStatus,
                    value: selectStatus
                  },
                  _react2.default.createElement(_list2.default.Item, null)
                ),
                _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'favorites-search' },
                _react2.default.createElement('span', { className: 'ico-moon icon-search' }),
                _react2.default.createElement('input', {
                  type: 'text',
                  onKeyDown: this.searchFavoritesGoods,
                  placeholder: '\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9'
                })
              ),
              !showCheckedBox ? _react2.default.createElement(
                'span',
                {
                  className: 'favorites-operat',
                  onClick: this.favoritesOperat
                },
                '\u7BA1\u7406'
              ) : _react2.default.createElement(
                'span',
                {
                  className: 'favorites-operat',
                  onClick: this.favoritesComplete
                },
                '\u5B8C\u6210'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'favorites-content' },
              favoritesList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-list',
                    key: item.id,
                    onClick: item.status != 1 && !showCheckedBox ? _this3.goGoodsDetail : null,
                    'data-id': item.id
                  },
                  showCheckedBox && _react2.default.createElement('label', {
                    className: 'favorites-check-box ' + (item.selected ? 'checked ico-moon icon-success-tip' : ''),
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    onClick: _this3.selectGoods,
                    'data-index': index
                  }),
                  _react2.default.createElement('img', { src: item.cover }),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-detail-box' },
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-title' },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'collect-number' },
                      item.favorite_people_num + '人收藏'
                    ),
                    (item.reduce_price > 0 || item.stock <= 20) && _react2.default.createElement(
                      'div',
                      null,
                      item.reduce_price > 0 && _react2.default.createElement(
                        'span',
                        {
                          className: 'goods-reduce-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';background:' + storeStyle.theme + '19')
                        },
                        '比收藏时降价' + item.reduce_price + '元'
                      ),
                      item.stock <= 20 && _react2.default.createElement(
                        'span',
                        { className: 'almost-stock' },
                        '\u5E93\u5B58\u7D27\u5F20'
                      )
                    ),
                    item.status == 1 ? _react2.default.createElement(
                      'div',
                      { className: 'goods-price-box' },
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-invalid' },
                        '\u5931\u6548'
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'goods-price-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'goods-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '¥' + item.price
                      ),
                      _react2.default.createElement('span', {
                        className: 'pull-right ico-moon icon-addshoppingcart3',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                        'data-id': item.id,
                        onClick: showCheckedBox ? null : _this3.addShoppingCart
                      })
                    )
                  )
                );
              })
            )
          ),
          showCheckedBox && _react2.default.createElement(
            'div',
            { className: 'favorites-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'select-all' },
              _react2.default.createElement('label', {
                className: 'favorites-check-box ' + (selectAll ? 'checked ico-moon icon-success-tip' : ''),
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                onClick: this.clickSelectAll
              }),
              _react2.default.createElement(
                'span',
                null,
                '\u5168\u9009'
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'pull-right delete-goods',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                onClick: this.deleteGoods
              },
              '\u4E00\u952E\u5220\u9664'
            )
          )
        ),
        showReducePrice && reducePriceGoodsNum > 0 && _react2.default.createElement(
          'div',
          { className: 'reduce-price-mask' },
          _react2.default.createElement(
            'div',
            { className: 'reduce-price-contain' },
            _react2.default.createElement(
              'div',
              { className: 'reduce-title' },
              '\u5546\u54C1\u964D\u4EF7\u5566'
            ),
            _react2.default.createElement(
              'div',
              { className: 'reduce-content' },
              '\u60A8\u6536\u85CF\u7684\u5546\u54C1\u964D\u4EF7\u5566'
            ),
            _react2.default.createElement(
              'div',
              { className: 'reduce-content' },
              '\u5FEB\u53BB\u77A7\u77A7\u5427'
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'check-reduce-price',
                onClick: this.checkReducePrice
              },
              '\u7ACB\u5373\u67E5\u770B'
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'wait-reduce-price',
                onClick: this.hideReducePrice
              },
              '\u7A0D\u540E\u67E5\u770B'
            )
          )
        ),
        _react2.default.createElement(_GoodsShoppingCart.GoodsShoppingCart, { ref: this.goodsShoppingCartRef })
      );
    }
  }]);
  return GoodsFavorites;
}(_OfficialPage3.default);

exports.default = GoodsFavorites;

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _GoodsShoppingCart = __webpack_require__(103);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(448);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsFootPrint = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsFootPrint, _OfficialPage);

  function GoodsFootPrint(props) {
    (0, _classCallCheck3.default)(this, GoodsFootPrint);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsFootPrint.__proto__ || Object.getPrototypeOf(GoodsFootPrint)).call(this, props));

    _this2.state = {
      goodslist: [],
      search: '',
      selectAll: false,
      storeStyle: {}
    };
    _this2.page = 1;
    _this2.isMore = 1;
    _this2.goodsShoppingCartRef = _react2.default.createRef();

    _this2.dataInitial = function () {
      _this2.getGoodsViewRecordList();
      _this2.getAppECStoreConfig();
    };

    _this2.getGoodsViewRecordList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/goodsViewRecordList',
        data: {
          page: _this.page,
          page_size: 10,
          search: _this.data.search
        },
        success: function success(res) {
          _this.setData({
            goodslist: _this.data.goodslist.concat(res.data)
          });
          _this.isMore = res.is_more;
        }
      });
    };

    _this2.footPrintOperat = function () {};

    _this2.footPrintOperat = function () {
      _this2.setData({
        showCheckedBox: true
      });
    };

    _this2.footPrintComplete = function () {
      _this2.setData({
        showCheckedBox: false
      });
    };

    _this2.addShoppingCart = function (event) {
      event.stopPropagation();
      _this2.goodsShoppingCartRef.current.showDialog({
        goodsId: event.currentTarget.dataset.id
      });
    };

    _this2.goGoodsDetail = function (event) {
      _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + event.currentTarget.dataset.id);
    };

    _this2.selectGoods = function (event) {
      var index = event.currentTarget.dataset.index;
      var goodslist = _this2.data.goodslist;
      var selectAll = true;
      goodslist[index].selected = !goodslist[index].selected;
      goodslist.map(function (item) {
        if (!item.selected) {
          selectAll = false;
        }
      });
      _this2.setData({
        goodslist: goodslist,
        selectAll: selectAll
      });
    };

    _this2.clickSelectAll = function () {
      var selectAll = _this2.data.selectAll;
      var goodslist = _this2.data.goodslist;
      goodslist.map(function (item) {
        item.selected = !selectAll;
      });
      _this2.setData({
        goodslist: goodslist,
        selectAll: !selectAll
      });
    };

    _this2.onReachBottom = function () {
      if (!_this2.isMore) {
        return;
      }
      _this2.page++;
      _this2.getGoodsViewRecordList();
    };

    _this2.deleteGoods = function () {
      var _this = _this2;
      var deleteIdArr = [];
      var goodslist = _this2.data.goodslist;
      for (var i = 0; i < goodslist.length; i++) {
        if (goodslist[i].selected) {
          deleteIdArr.push(goodslist[i].id);
          goodslist.splice(i, 1);
          i--;
        }
      }
      if (deleteIdArr.length <= 0) {
        _app.appMethod.showToast({ title: '未选择商品', icon: 'none' });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteGoodsViewRecord',
        method: 'post',
        data: {
          goods_id_arr: deleteIdArr
        },
        success: function success(res) {
          _this.setData({
            goodslist: goodslist,
            showCheckedBox: false
          });
        }
      });
    };

    _this2.searchGoods = function (event) {
      if (event.keyCode !== 13) {
        return;
      }
      _this2.page = 1;
      _this2.setData({
        search: event.target.value,
        goodslist: []
      });
      _this2.getGoodsViewRecordList();
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      });
    };

    document.title = '足迹';
    return _this2;
  }

  (0, _createClass3.default)(GoodsFootPrint, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          showCheckedBox = _state.showCheckedBox,
          goodslist = _state.goodslist,
          storeStyle = _state.storeStyle,
          selectAll = _state.selectAll,
          search = _state.search;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'official-page goods-foot-print' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u53C2\u56E2\u8DB3\u8FF9' }),
          goodslist.length || search ? _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: showCheckedBox ? 'foot-print-container' : '' },
              _react2.default.createElement(
                'div',
                { className: 'foot-print-header' },
                _react2.default.createElement(
                  'div',
                  { className: 'foot-print-search' },
                  _react2.default.createElement('span', { className: 'ico-moon icon-search' }),
                  _react2.default.createElement('input', {
                    type: 'text',
                    onKeyDown: this.searchGoods,
                    placeholder: '\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9'
                  })
                ),
                !showCheckedBox ? _react2.default.createElement(
                  'span',
                  {
                    className: 'foot-print-operat',
                    onClick: this.footPrintOperat
                  },
                  '\u7BA1\u7406'
                ) : _react2.default.createElement(
                  'span',
                  {
                    className: 'foot-print-operat',
                    onClick: this.footPrintComplete
                  },
                  '\u5B8C\u6210'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'foot-print-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-content' },
                  goodslist.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        key: item.id,
                        onClick: item.status != 1 && !showCheckedBox ? _this3.goGoodsDetail : null,
                        'data-id': item.id
                      },
                      _react2.default.createElement('img', { className: 'goods-cover', src: item.cover }),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-detail' },
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-title' },
                          item.title
                        ),
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'goods-price',
                            style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                          },
                          '¥' + item.price
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-bottom' },
                          item.sales + '人付款',
                          item.status == 1 ? _react2.default.createElement(
                            'span',
                            { className: 'foot-invalid' },
                            '\u5931\u6548'
                          ) : _react2.default.createElement('span', {
                            onClick: showCheckedBox ? null : _this3.addShoppingCart,
                            'data-id': item.id,
                            className: 'ico-moon icon-addshoppingcart3 add-shopping-cart',
                            style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                          })
                        )
                      ),
                      showCheckedBox && _react2.default.createElement('label', {
                        'data-index': index,
                        className: 'foot-check-box ' + (item.selected ? 'checked ico-moon icon-success-tip' : ''),
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                        onClick: _this3.selectGoods
                      })
                    );
                  })
                )
              )
            ),
            showCheckedBox && _react2.default.createElement(
              'div',
              { className: 'foot-bottom' },
              _react2.default.createElement(
                'div',
                { className: 'select-all' },
                _react2.default.createElement('label', {
                  className: 'foot-check-box ' + (selectAll ? 'checked ico-moon icon-success-tip' : ''),
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  onClick: this.clickSelectAll
                }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u5168\u9009'
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'pull-right delete-goods',
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                  onClick: this.deleteGoods
                },
                '\u4E00\u952E\u5220\u9664'
              )
            )
          ) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'foot-null-box' },
              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/foot-print-null.png' }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65F6\u6CA1\u6709\u6D4F\u89C8\u8BB0\u5F55'
              )
            )
          )
        ),
        _react2.default.createElement(_GoodsShoppingCart.GoodsShoppingCart, { ref: this.goodsShoppingCartRef })
      );
    }
  }]);
  return GoodsFootPrint;
}(_OfficialPage3.default);

exports.default = GoodsFootPrint;

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(450);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsCustomerService = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsCustomerService, _OfficialPage);

  function GoodsCustomerService(props) {
    (0, _classCallCheck3.default)(this, GoodsCustomerService);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsCustomerService.__proto__ || Object.getPrototypeOf(GoodsCustomerService)).call(this, props));

    _this2.state = {
      orderStatus: ['待审核', '退款失败', '退款失败', '退货中', '待商家确认收货', '退款失败', '退款成功', '退款失败'],
      orderReason: ['待审核', '商家拒绝退款', '买家撤销退款', '待买家退货', '待商家确认收货', '商家超时未退货', '已退款', '商家超时未处理退款'],
      refundType: ['全额退款', '部分退款', '退货退款'],
      orderInfo: []
    };
    _this2.page = 1;
    _this2.isMore = 0;

    _this2.dataInitial = function () {
      _this2.setData({
        orderInfo: []
      });
      _this2.page = 1;
      _this2.getAfterSaleOrderList();
    };

    _this2.onReachBottom = function () {
      if (!_this2.isMore) {
        return;
      }
      _this2.page++;
      _this2.getAfterSaleOrderList();
    };

    _this2.getAfterSaleOrderList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAfterSaleOrderList',
        method: 'post',
        data: {
          page: _this.page,
          page_size: 10
        },
        success: function success(res) {
          _this.isMore = res.is_more;
          var orderInfo = _this.data.orderInfo.concat(res.data);
          _this.setData({
            orderInfo: orderInfo
          });
        }
      });
    };

    _this2.toGoodsOrderDetail = function (event) {
      var orderId = event.currentTarget.dataset.orderId;
      var franchiseeId = event.currentTarget.dataset.franchiseeId;
      var applyId = event.currentTarget.dataset.applyId;
      franchiseeId = franchiseeId != _app.appMethod.getAppId() ? franchiseeId : '';
      var router = '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' + applyId + '&detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(router);
    };

    _this2.deleteAfterSale = function (event) {
      var orderId = event.currentTarget.dataset.orderId;
      var applyId = event.currentTarget.dataset.applyId;
      var index = event.currentTarget.dataset.index;
      var _this = _this2;
      _app.appMethod.showModal({
        content: '确认删除记录？',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/deleteAfterSaleOrderLog',
            method: 'post',
            data: {
              order_id: orderId,
              apply_id: applyId
            },
            success: function success(res) {
              var orderInfo = _this.data.orderInfo;
              orderInfo.splice(index, 1);
              _this.setData({
                orderInfo: orderInfo
              });
            }
          });
        }
      });
    };

    _this2.cancelRefund = function (event) {
      var _this = _this2;
      var parentId = event.currentTarget.dataset.parentId;
      var orderId = event.currentTarget.dataset.orderId;
      var franchiseeId = parentId ? _app.appMethod.getAppId() : '';
      _app.appMethod.showModal({
        content: '确认撤销申请？',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appShop/cancelRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId
            },
            success: function success() {
              _this.dataInitial();
            }
          });
        }
      });
    };

    _this2.refuseReason = function (event) {
      var reason = event.currentTarget.dataset.reason;
      _app.appMethod.showModal({
        content: reason
      });
    };

    document.title = '售后订单';
    return _this2;
  }

  (0, _createClass3.default)(GoodsCustomerService, [{
    key: 'componentWillMount',
    value: function componentWillMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.dataInitial();
    }
    // TODO

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          orderInfo = _state.orderInfo,
          orderStatus = _state.orderStatus,
          refundType = _state.refundType,
          orderReason = _state.orderReason;

      return React.createElement(
        'div',
        { className: 'official-page goods-customer-service' },
        React.createElement(_TopNav.TopNav, { title: '\u552E\u540E\u8BA2\u5355' }),
        orderInfo.map(function (item, index) {
          return React.createElement(
            'div',
            { className: 'goods-customer-contain', key: item.id },
            React.createElement(
              'div',
              { className: 'goods-customer-header' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  { className: 'customer-add-time' },
                  item.add_time
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right ' + (item.status == 0 || item.status == 4 ? 'waiting-color' : '')
                  },
                  orderStatus[item.status]
                )
              )
            ),
            item.refund_goods_info.map(function (goods, index) {
              return React.createElement(
                'div',
                {
                  onClick: _this3.toGoodsOrderDetail,
                  'data-apply-id': item.id,
                  'data-order-id': item.order_id,
                  'data-franchisee-id': item.app_id,
                  className: 'goods-customer-content',
                  key: goods.goods_id
                },
                React.createElement('img', { src: goods.cover }),
                React.createElement(
                  'div',
                  { className: 'goods-detail-box' },
                  React.createElement(
                    'div',
                    { className: 'goods-title' },
                    goods.title
                  ),
                  goods.model_name && React.createElement(
                    'div',
                    { className: 'goods-model' },
                    goods.model_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-price-box' },
                    React.createElement(
                      'span',
                      null,
                      '¥' + goods.price
                    ),
                    React.createElement(
                      'span',
                      { className: 'pull-right goods-num' },
                      'x' + goods.num
                    )
                  )
                )
              );
            }),
            React.createElement(
              'div',
              { className: 'goods-customer-bottom' },
              React.createElement(
                'div',
                { className: 'order-refund-box' },
                React.createElement(
                  'div',
                  { className: 'order-status-explain' },
                  React.createElement('span', { className: 'ico-moon icon-goods-after-sale' }),
                  React.createElement(
                    'span',
                    null,
                    refundType[item.refund_type]
                  )
                ),
                (item.status == 1 || item.status == 2 || item.status == 5 || item.status == 7) && React.createElement(
                  'span',
                  { className: 'pull-right order-refund-price' },
                  orderReason[item.status]
                ),
                item.status == 3 && React.createElement(
                  'span',
                  { className: 'pull-right order-refund-price' },
                  '等待商家发货，还剩' + item.expire
                ),
                item.status == 6 && React.createElement(
                  'span',
                  { className: 'pull-right order-refund-price' },
                  '退款金额 ¥' + item.refund_price
                )
              ),
              React.createElement(
                'div',
                { className: 'customer-btn-box' },
                item.status == 0 && React.createElement(
                  'span',
                  {
                    className: 'customer-btn',
                    onClick: _this3.cancelRefund,
                    'data-order-id': item.order_id,
                    'data-apply-id': item.id,
                    'data-franchisee-id': item.app_id
                  },
                  '\u64A4\u9500\u7533\u8BF7'
                ),
                (item.status == 1 || item.status == 2 || item.status == 5 || item.status == 6) && React.createElement(
                  'span',
                  {
                    className: 'customer-btn',
                    onClick: _this3.deleteAfterSale,
                    'data-order-id': item.order_id,
                    'data-apply-id': item.id,
                    'data-index': index
                  },
                  '\u5220\u9664\u8BB0\u5F55'
                ),
                item.status == 1 && React.createElement(
                  'span',
                  {
                    className: 'customer-btn',
                    onClick: _this3.refuseReason,
                    'data-reason': item.refuse_msg
                  },
                  '\u62D2\u7EDD\u539F\u56E0'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'customer-btn',
                    onClick: _this3.toGoodsOrderDetail,
                    'data-apply-id': item.id,
                    'data-order-id': item.order_id,
                    'data-franchisee-id': item.app_id
                  },
                  '\u67E5\u770B\u8BA2\u5355'
                )
              )
            )
          );
        })
      );
    }
  }]);
  return GoodsCustomerService;
}(_OfficialPage3.default);

exports.default = GoodsCustomerService;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(452);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsAfterSaleDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsAfterSaleDetail, _OfficialPage);

  function GoodsAfterSaleDetail(props) {
    (0, _classCallCheck3.default)(this, GoodsAfterSaleDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsAfterSaleDetail.__proto__ || Object.getPrototypeOf(GoodsAfterSaleDetail)).call(this, props));

    _this2.state = {
      orderReason: ['商家待审核', '商家拒绝退款', '买家撤销退款', '待买家退货', '待商家确认收货', '卖家超时未退货', '已退款', '商家超时未处理退款'],
      refundReason: ['多拍/拍错/不想要', '快递延期', '未按约定时间发货', '快递记录出错', '内容与描述不符', '其它'],
      refundJourneyReason: ['未保持餐品完整', '骑手服务态度恶劣', '骑手额外索取费用', '骑手诱导退单', '骑手提前点击送达', '骑手虚假标记异常', '少餐错餐'],
      orderIcon: ['goods-undone-payment', 'goods-refund-doing', 'goods-refund-doing', 'goods-refund', 'goods-undone-receipt', 'goods-refund-doing', 'goods-already-refund', 'goods-refund-doing'],
      orderId: '',
      showEventDialog: false,
      eventType: '',
      storeStyle: {}
    };
    _this2.isFromBack = false;
    _this2.applyId = '';

    _this2.dataInitial = function () {
      _this2.getAfterSaleOrder();
      _this2.getAppECStoreConfig();
    };

    _this2.getAfterSaleOrder = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/getAfterSaleOrder',
        data: {
          apply_id: _this.applyId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            afterSaleData: res.data
          });
          _this.getRefundConfigByPickUpType();
          if (res.data.pick_up_type == 2) {
            _this.getBuyerCancelReason();
          }
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId;
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteAfterSaleOrderLog',
        method: 'post',
        data: {
          order_id: orderId,
          apply_id: _this.applyId
        },
        success: function success(res) {
          _app.appMethod.turnBack();
        },
        complete: function complete() {
          _this.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.editorRefund = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.checkLogistics = function () {
      var applyId = _this2.applyId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?applyId=' + applyId + '&form=afterSale' + (franchiseeId ? '&franchiseeId=' + franchiseeId : ''));
    };

    _this2.copyOrderId = function () {
      var _this = _this2;
      _app.appMethod.setClipboardData({
        data: _this.data.orderId,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.hideEventDialog = function () {
      _this2.setData({
        showEventDialog: false
      });
    };

    _this2.showEventDialog = function (event) {
      _this2.setData({
        eventType: event.currentTarget.dataset.type,
        showEventDialog: true
      });
    };

    _this2.goOrderProgress = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.returnInfor = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.cancelRefund = function () {
      var _this = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/cancelRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success() {
          _this.getAfterSaleOrder();
        },
        complete: function complete() {
          _this.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.getRefundConfigByPickUpType = function () {
      var _this = _this2;
      var type = _this2.data.afterSaleData.pick_up_type;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
        data: {
          pick_up_type: type,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var data = res.data.config_data;
          _this.setData({
            refundAdress: data.address || ''
          });
        }
      });
    };

    _this2.getBuyerCancelReason = function () {
      var type = _this2.data.afterSaleData.deliver_type || 0;
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getBuyerCancelReason',
        data: {
          deliver_type: type
        },
        success: function success(res) {
          var data = res.data;
          var refundJourneyReason = [];
          for (var i in data) {
            refundJourneyReason.push(data[i]);
          }
          _this.setData({
            refundJourneyReason: refundJourneyReason
          });
        }
      });
    };

    document.title = '售后详情';
    return _this2;
  }

  (0, _createClass3.default)(GoodsAfterSaleDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.applyId = options.applyId;
      this.franchiseeId = options.franchisee || '';
      this.setData({
        orderId: options.detail
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromBack) {
        this.getAfterSaleOrder();
      } else {
        this.isFromBack = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          storeStyle = _state.storeStyle,
          orderIcon = _state.orderIcon,
          afterSaleData = _state.afterSaleData,
          orderReason = _state.orderReason,
          refundAdress = _state.refundAdress,
          refundJourneyReason = _state.refundJourneyReason,
          refundReason = _state.refundReason,
          eventType = _state.eventType,
          showEventDialog = _state.showEventDialog;


      afterSaleData = afterSaleData || {};
      return React.createElement(
        'div',
        { className: 'official-page goods-after-sale-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u552E\u540E\u8BE6\u60C5' }),
        React.createElement(
          'div',
          { className: 'order-contain' },
          React.createElement(
            'div',
            {
              className: 'seller-shipped',
              style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
            },
            React.createElement('span', {
              className: 'order-icon ico-moon icon-' + orderIcon[afterSaleData.status]
            }),
            React.createElement(
              'span',
              null,
              orderReason[afterSaleData.status]
            ),
            React.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/goods-order-bg.png' })
          ),
          afterSaleData.status == 0 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u4F60\u5DF2\u6210\u529F\u53D1\u8D77\u9000\u6B3E\u7533\u8BF7\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u5904\u7406\uFF0C\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              afterSaleData.expire
            ),
            '\uFF08\u8D85\u65F6\u6309',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              '\u62D2\u7EDD\u9000\u6B3E'
            ),
            '\u5904\u7406\uFF09'
          ),
          afterSaleData.status == 3 && React.createElement(
            'div',
            { className: 'order-prompt' },
            '\u5546\u5BB6\u5DF2\u540C\u610F\u4F60\u7684\u9000\u8D27\u7533\u8BF7\uFF0C\u8BF7\u53CA\u65F6\u586B\u5199\u9000\u8D27\u4FE1\u606F\uFF0C\u8FD8\u5269',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              afterSaleData.expire
            ),
            '\uFF08\u8D85\u65F6\u6309',
            React.createElement(
              'span',
              { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
              '\u9000\u6B3E\u5931\u8D25'
            ),
            '\u5904\u7406\uFF09'
          ),
          afterSaleData.status == 3 && React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'refund-address-box' },
              React.createElement(
                'div',
                { className: 'refund-address-title' },
                React.createElement(
                  'span',
                  null,
                  '\u9000\u8D27\u5730\u5740'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  refundAdress && refundAdress.brand_name + ' ' + refundAdress.phone
                )
              ),
              React.createElement(
                'div',
                { className: 'pull-right refund-address' },
                refundAdress && refundAdress.region_info[2].name + refundAdress.region_info[1].name + refundAdress.region_info[0].name + refundAdress.detail_address
              )
            )
          ),
          afterSaleData.refuse_msg && React.createElement(
            'div',
            { className: 'refuse-message' },
            '商家拒绝退款原因：' + afterSaleData.refuse_msg
          ),
          React.createElement(
            'div',
            { className: 'app-box' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 'app-name' },
                '\u9000\u8D27\u4FE1\u606F'
              )
            )
          ),
          afterSaleData.refund_goods && afterSaleData.refund_goods.map(function (item, index) {
            return React.createElement(
              'div',
              { className: 'goods-detail-box', key: item.goods_id },
              React.createElement('img', { src: item.cover }),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'goods-name' },
                  afterSaleData.is_group_buy_order == 1 && React.createElement(
                    'span',
                    { className: 'is-seckill' },
                    '\u62FC\u56E2'
                  ),
                  afterSaleData.is_seckill == 1 && React.createElement(
                    'span',
                    { className: 'is-seckill' },
                    '\u79D2\u6740'
                  ),
                  item.title
                ),
                item.model_name && React.createElement(
                  'div',
                  { className: 'goods-rules' },
                  item.model_name
                ),
                React.createElement(
                  'div',
                  { className: 'goods-price' },
                  React.createElement(
                    'span',
                    {
                      className: 'colorff7',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '¥' + item.price
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    'x ' + item.num
                  )
                )
              )
            );
          }),
          React.createElement(
            'div',
            {
              className: 'goods-amount',
              hidden: afterSaleData.is_pay_on_delivery == 1
            },
            React.createElement(
              'span',
              null,
              '\u9000\u8D27\u539F\u56E0'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              afterSaleData.pick_up_type == 2 ? refundJourneyReason[afterSaleData.refund_reason] : refundReason[afterSaleData.refund_reason]
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-amount' },
            React.createElement(
              'span',
              null,
              '\u9000\u6B3E\u91D1\u989D'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              '¥' + afterSaleData.refund_price
            )
          ),
          React.createElement(
            'div',
            { className: 'goods-amount refund-apply-time' },
            React.createElement(
              'span',
              null,
              '\u7533\u8BF7\u65F6\u95F4'
            ),
            React.createElement(
              'span',
              { className: 'pull-right color999' },
              afterSaleData.add_time
            )
          ),
          React.createElement(
            'div',
            { className: 'actual-payment' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u5B9E\u9645\u4ED8\u6B3E'
              ),
              React.createElement(
                'span',
                {
                  className: 'pull-right colorff7',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '¥' + afterSaleData.total_price
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'addition-info no-border',
              onClick: this.goOrderProgress
            },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8BA2\u5355\u8FDB\u5EA6'
              ),
              React.createElement('span', { className: 'pull-right color999 ico-moon icon-rightarrow' })
            )
          ),
          React.createElement(
            'div',
            { className: 'order-number' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u8BA2\u5355\u7F16\u53F7'
              ),
              React.createElement(
                'span',
                null,
                afterSaleData.order_id
              ),
              React.createElement(
                'span',
                { className: 'pull-right', onClick: this.copyOrderId },
                '\u590D\u5236'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'order-bottom' },
            afterSaleData.status == 0 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn',
                  onClick: this.showEventDialog,
                  'data-type': 'cancelRefund'
                },
                '\u64A4\u9500\u7533\u8BF7'
              ),
              afterSaleData.is_pay_on_delivery != 1 && React.createElement(
                'span',
                { className: 'btn', onClick: this.editorRefund },
                '\u4FEE\u6539\u7533\u8BF7'
              )
            ),
            afterSaleData.status == 1 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u552E\u540E\u8BA2\u5355'
              )
            ),
            afterSaleData.status == 2 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u552E\u540E\u8BA2\u5355'
              )
            ),
            afterSaleData.status == 3 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'btn',
                  onClick: this.showEventDialog,
                  'data-type': 'cancelRefund'
                },
                '\u64A4\u9500\u7533\u8BF7'
              ),
              afterSaleData.is_pay_on_delivery != 1 && React.createElement(
                'span',
                { className: 'btn', onClick: this.editorRefund },
                '\u4FEE\u6539\u7533\u8BF7'
              ),
              afterSaleData.is_pay_on_delivery != 1 && React.createElement(
                'span',
                {
                  className: 'btn btn-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.returnInfor
                },
                '\u586B\u5199\u9000\u8D27\u4FE1\u606F'
              )
            ),
            afterSaleData.status == 4 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                { className: 'btn', onClick: this.checkLogistics },
                '\u67E5\u770B\u9000\u8D27\u7269\u6D41'
              )
            ),
            afterSaleData.status == 5 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u552E\u540E\u8BA2\u5355'
              )
            ),
            afterSaleData.status == 6 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u552E\u540E\u8BA2\u5355'
              )
            ),
            afterSaleData.status == 7 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'span',
                {
                  className: 'apply-refund',
                  onClick: this.showEventDialog,
                  'data-type': 'orderDelete'
                },
                '\u5220\u9664\u552E\u540E\u8BA2\u5355'
              )
            )
          )
        ),
        showEventDialog && React.createElement(
          'div',
          { className: 'event-dialog-mask' },
          React.createElement(
            'div',
            { className: 'event-dialog' },
            eventType == 'orderDelete' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u8BA2\u5355\u5220\u9664\u540E\u4E0D\u53EF\u627E\u56DE\uFF0C\u786E\u8BA4\u5220\u9664\uFF1F'
            ),
            eventType == 'cancelRefund' && React.createElement(
              'div',
              { className: 'event-dialog-title' },
              '\u662F\u5426\u64A4\u9500\u9000\u6B3E\u7533\u8BF7\uFF1F'
            ),
            React.createElement(
              'div',
              { className: 'event-dialog-bottom' },
              React.createElement(
                'span',
                { className: 'event-cancel', onClick: this.hideEventDialog },
                '\u53D6\u6D88'
              ),
              eventType == 'orderDelete' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.orderDelete
                },
                '\u786E\u8BA4'
              ),
              eventType == 'cancelRefund' && React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                  className: 'event-sure',
                  onClick: this.cancelRefund
                },
                '\u786E\u8BA4'
              )
            )
          )
        )
      );
    }
  }]);
  return GoodsAfterSaleDetail;
}(_OfficialPage3.default);

exports.default = GoodsAfterSaleDetail;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _Map = __webpack_require__(104);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchAddress = function (_OfficialPage) {
  (0, _inherits3.default)(SearchAddress, _OfficialPage);

  function SearchAddress(props) {
    (0, _classCallCheck3.default)(this, SearchAddress);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchAddress.__proto__ || Object.getPrototypeOf(SearchAddress)).call(this, props));

    _this.state = {
      nationId: '',
      selectAddressId: '',
      addressList: [],
      afterInitial: false,
      isFromBack: false,
      from: '',
      fromAddAdress: false,
      address_id: '',
      localAddress: '',
      selectProCityDirs: true,
      nationname: '',
      selectRegion: [0, 0, 0],
      selectRegionId: [0, 0, 0],
      latitude: '',
      longitude: '',
      showMap: true,
      show: false,
      regionMap: {},
      regionData: [],
      regionCols: 3,
      regionStr: [],
      searchAddress: [],
      nearbyAddress: []
    };
    _this.subShopId = '';
    _this.timer = 0;

    _this.isInCountry = function (id, callBack) {
      var that = _this;
      _app.appMethod.getLocation({
        success: function success(res) {
          if (!res.latitude) {
            that.setData({
              localAddress: '定位失败'
            });
            return;
          }
          _app.appMethod.sendRequest({
            url: '/index.php?r=map/IsInCountry',
            data: {
              nation_id: id,
              longitude: res.longitude,
              latitude: res.latitude
            },
            success: function success(res) {
              if (res.data === true) {
                that.getLocation();
              } else {
                that.showMap = false;
              }
            }
          });
        },
        fail: function fail() {
          // 模拟数据
          _app.appMethod.sendRequest({
            url: '/index.php?r=map/IsInCountry',
            data: {
              nation_id: id,
              longitude: 113.93041,
              latitude: 22.53332
            },
            success: function success(res) {
              if (res.data === true) {
                that.getLocation();
              } else {
                that.showMap = false;
              }
            }
          });
        }
      });
    };

    _this.getAddressList = function (from) {
      var that = _this;
      var takeoutLocate = _app.appMethod.globalData.takeoutLocate;
      var shopInfo = _app.appMethod.globalData.takeoutShopInfo;
      var addressList = [];
      var hasInDistance = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        success: function success(res) {
          var address = res.data;
          for (var i = 0, j = address.length - 1; i <= j; i++) {
            if (from == 'takeout') {
              address[i].is_distance = _app.appMethod.calculationDistanceByLatLng(shopInfo.latitude, shopInfo.longitude, address[i].latitude, address[i].longitude) < shopInfo.deliver_distance ? 1 : 0;
            }
            if (address[i].latitude == 0) {
              hasInDistance = false;
            }
            addressList.push(address[i]);
          }
          that.setData({
            addressList: addressList,
            from: from,
            hasInDistance: hasInDistance
          });
        }
      });
    };

    _this.selectAddress = function (e) {
      var pages = _app.appMethod.getCurrentPages(),
          prePage = pages[pages.length - 2],
          data = {},
          addressInfo = e.currentTarget.dataset.info;
      _app.appMethod.globalData.takeoutAddressSelected = addressInfo;
      data['eles[' + _this.compindex + '].location_address'] = addressInfo.address_info.detailAddress;
      prePage.setData(data);
      _app.appMethod.globalData.takeoutLocate.lat = addressInfo.latitude || '';
      _app.appMethod.globalData.takeoutLocate.lng = addressInfo.longitude || '';
      _app.appMethod.globalData.takeoutLocate.id = addressInfo.id || '';
      _app.appMethod.globalData.takeoutRefresh = true;
      _app.appMethod.turnBack();
    };

    _this.changeRegion = function (e) {
      var regionStr = [];
      var selectRegion = [];
      var selectRegionId = e;

      e.reduce(function (p, c, i) {
        for (var j = 0, l = p.length; j < l; j++) {
          if (p[j].value === c) {
            regionStr[i] = p[j].label;
            selectRegion[i] = j;
            return p[j].children || [];
          }
        }
      }, _this.data.regionData);

      _this.setData({
        regionStr: regionStr,
        selectRegion: selectRegion,
        selectRegionId: selectRegionId
      });
    };

    _this.getArea = function (id, callBack) {
      // var nationId = this.data.nationId
      // app.sendRequest({
      //   url: '/index.php?r=Region/getRegionList',
      //   data: {
      //     country_region_id: nationId,
      //     pid: id
      //   },
      //   success: res => {
      //     res.data = res.data.reverse()
      //     callBack(res.data)
      //   }
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAllRegionInfo',
        data: {
          country_region_id: id || _this.data.nationId
        },
        success: function success(_ref) {
          var data = _ref.data;

          callBack(data);
        }
      });
    };

    _this.formateRegionData = function (data) {
      if (!data) {
        return [];
      }
      return Object.keys(data).map(function (k) {
        var val = data[k];
        if (val.cities || val.towns) {
          return {
            label: val.name,
            value: val.id,
            children: _this.formateRegionData(val.cities || val.towns)
          };
        }
        return {
          label: val.name,
          value: val.id
        };
      });
    };

    _this.hideProCityDirs = function () {
      _app.appMethod.showLoading({
        title: '请稍等...'
      });
      setTimeout(function () {
        _app.appMethod.hideLoading();
        _this.setData({
          selectRegionId: _this.regionid,
          selectProCityDirs: true,
          regionStr: _this.oldRegionStr || ''
        });
      }, 1000);
    };

    _this.submitRegion = function () {
      _app.appMethod.showLoading({
        title: '请稍等...'
      });
      var that = _this;
      setTimeout(function () {
        _app.appMethod.hideLoading();
        that.setData({
          selectProCityDirs: true
        });
        that.oldRegionStr = that.data.regionStr;
        if (that.data.searchInput) {
          var region = '';
          switch (that.data.regionStr[1]) {
            case '县':
            case '自治区直辖县级行政区划':
            case '省直辖县级行政区划':
              region = that.data.regionStr[0] + that.data.regionStr[2];
              break;
            default:
              var regionAry = [];
              that.data.regionStr.forEach(function (item) {
                if (regionAry.indexOf(item) < 0) {
                  regionAry[regionAry.length] = item;
                }
              });
              region = regionAry.join(' ');
              break;
          }
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/suggestion&keyword=',
            data: {
              country_region_id: that.data.nationId,
              keyword: region + ' ' + that.data.searchInput,
              region: region
            },
            success: function success(res) {
              that.setData({
                searchInput: that.data.searchInput,
                searchAddress: res.data
              });
            }
          });
        }
      }, 1000);
    };

    _this.getLocation = function () {
      var that = _this;
      if (_app.appMethod.globalData.locationInfo.latitude) {
        var location = _app.appMethod.globalData.locationInfo;
        var info = location.info;
        var lacalAddresss = info.formatted_addresses ? info.formatted_addresses.recommend : info.address;
        that.oldRegionStr = [info.ad_info.province, info.ad_info.city, info.ad_info.district];
        that.setData({
          regionStr: info.formatted_addresses ? that.oldRegionStr : [info.address_component.nation, info.address_component.ad_level_3],
          localLatLng: info,
          localAddress: lacalAddresss,
          latitude: location.latitude,
          longitude: location.longitude,
          markers: [{
            latitude: location.latitude,
            longitude: location.longitude,
            iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
            width: 20,
            height: 20
          }, {
            latitude: location.latitude,
            longitude: location.longitude,
            iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
            width: 20,
            height: 30
          }]
        });
        that.locateAddress = lacalAddresss;
        that.nearbyAddress({
          lat: location.latitude,
          lng: location.longitude,
          keyword: lacalAddresss
        });
      } else {
        _app.appMethod.getLocation({
          success: function success(res) {
            if (!res.latitude) {
              that.setData({
                localAddress: '定位失败'
              });
              return;
            }
            _app.appMethod.getAddressByLatLng({
              lat: res.latitude,
              lng: res.longitude
            }, function (data) {
              var lacalAddresss = data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address;
              that.oldRegionStr = [data.data.ad_info.province, data.data.ad_info.city, data.data.ad_info.district];
              that.setData({
                regionStr: that.oldRegionStr,
                localLatLng: data.data,
                localAddress: lacalAddresss,
                latitude: res.latitude,
                longitude: res.longitude,
                markers: [{
                  latitude: res.latitude,
                  longitude: res.longitude,
                  iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
                  width: 20,
                  height: 20
                }, {
                  latitude: res.latitude,
                  longitude: res.longitude,
                  iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
                  width: 20,
                  height: 30
                }]
              });
              that.locateAddress = lacalAddresss;
              that.nearbyAddress({
                lat: res.latitude,
                lng: res.longitude,
                keyword: that.locateAddress
              });
              _app.appMethod.setLocationInfo({
                latitude: res.latitude,
                longitude: res.longitude,
                address: data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address,
                info: data.data
              });
            });
          },
          fail: function fail(res) {
            // 模拟数据
            res = {
              latitude: 22.53332,
              longitude: 113.93041
            };
            _app.appMethod.getAddressByLatLng({
              lat: 22.53332,
              lng: 113.93041
            }, function (data) {
              var lacalAddresss = data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address;
              that.oldRegionStr = [data.data.ad_info.province, data.data.ad_info.city, data.data.ad_info.district];
              that.setData({
                regionStr: that.oldRegionStr,
                localLatLng: data.data,
                localAddress: lacalAddresss,
                latitude: res.latitude,
                longitude: res.longitude,
                markers: [{
                  latitude: res.latitude,
                  longitude: res.longitude,
                  iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/circle.png',
                  width: 20,
                  height: 20
                }, {
                  latitude: res.latitude,
                  longitude: res.longitude,
                  iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
                  width: 20,
                  height: 30
                }]
              });
              that.locateAddress = lacalAddresss;
              that.nearbyAddress({
                lat: res.latitude,
                lng: res.longitude,
                keyword: that.locateAddress
              });
              _app.appMethod.setLocationInfo({
                latitude: res.latitude,
                longitude: res.longitude,
                address: data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address,
                info: data.data
              });
            });
          }
        });
      }
    };

    _this.searchAddress = function (e) {
      var that = _this;
      var searchInput = e.target.value;
      _this.searchFunc && clearTimeout(_this.searchFunc);
      if (searchInput.trim() != '') {
        _this.searchFunc = setTimeout(function () {
          if (that.data.regionStr === undefined || !that.data.regionStr[1] && !that.data.regionStr[2] || that.data.regionStr[1] == '请选择' && that.data.regionStr[2] == '请选择') {
            _app.appMethod.showModal({
              content: '请先选择地区，再输入地址',
              confirmText: '好的',
              confirmColor: '#3091F2'
            });
            return;
          }
          var region = '';
          switch (that.data.regionStr[1]) {
            case '县':
            case '自治区直辖县级行政区划':
            case '省直辖县级行政区划':
              region = that.data.regionStr[0] + that.data.regionStr[2];
              break;
            default:
              var regionAry = [];
              that.data.regionStr.forEach(function (item) {
                if (regionAry.indexOf(item) < 0) {
                  regionAry[regionAry.length] = item;
                }
              });
              region = regionAry.join(' ');
              break;
          }
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/suggestion&keyword=',
            data: {
              country_region_id: that.data.nationId,
              keyword: region + ' ' + searchInput,
              region: region
            },
            success: function success(res) {
              that.setData({
                searchInput: searchInput,
                searchAddress: res.data,
                showMap: false
              });
            }
          });
        }, 1000);
      } else {
        that.setData({
          searchAddress: [],
          showMap: true
        });
      }
    };

    _this.relocate = function (e) {
      var that = _this;
      _this.setData({
        localAddress: ''
      });
      _app.appMethod.getLocation({
        success: function success(res) {
          _app.appMethod.getAddressByLatLng({
            lat: res.latitude,
            lng: res.longitude
          }, function (data) {
            var lacalAddresss = data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address;
            that.setData({
              localLatLng: data.data,
              localAddress: lacalAddresss
            });
            that.nearbyAddress({
              lat: res.latitude,
              lng: res.longitude,
              keyword: lacalAddresss
            });
            _app.appMethod.setLocationInfo({
              latitude: res.latitude,
              longitude: res.longitude,
              address: data.data.formatted_addresses ? data.data.formatted_addresses.recommend : data.data.address,
              info: data.data
            });
          });
        }
      });
    };

    _this.selectTakeoutRelocate = function (e) {
      var info = e.currentTarget.dataset.info;
      _app.appMethod.globalData.takeoutLocate = {
        lat: info.latitude,
        lng: info.longitude
      };
      _app.appMethod.globalData.takeoutRefresh = true;
      _app.appMethod.turnBack();
    };

    _this.turnBackPageByLoacl = function (e) {
      _app.appMethod.globalData.takeoutAddressSelected = '';
      var pages = _app.appMethod.getCurrentPages();
      var prePage = pages[pages.length - 2];
      if (!prePage) {
        _toast2.default.info('当前操作需要返回上一页');
        _app.appMethod.turnBack();
        return;
      }
      var data = {},
          addressDetail = JSON.parse(e.currentTarget.dataset.addressinfo);
      data[_this.compid + '.location_address'] = addressDetail.formatted_addresses ? addressDetail.formatted_addresses.recommend : addressDetail.address;
      prePage.setData(data);
      _app.appMethod.globalData.takeoutLocate.lat = addressDetail.location.lat;
      _app.appMethod.globalData.takeoutLocate.lng = addressDetail.location.lng;
      _app.appMethod.globalData.takeoutRefresh = true;
      _app.appMethod.turnBack();
    };

    _this.turnBackPage = function (e) {
      _app.appMethod.globalData.takeoutAddressSelected = '';
      var pages = _app.appMethod.getCurrentPages();
      var prePage = pages[pages.length - 2];
      if (!prePage) {
        _toast2.default.info('当前操作需要返回上一页');
        _app.appMethod.turnBack();
        return;
      }
      var type = e.currentTarget.dataset.type;
      var addressDetail = JSON.parse(e.currentTarget.dataset.addressinfo);
      var regionId = _this.data.selectRegionId;
      if (_this.data.from == 'addAddress' && type == 'search') {
        var _this$data = _this.data,
            regionStr = _this$data.regionStr,
            nationId = _this$data.nationId,
            nationname = _this$data.nationname;

        var _addressInfo = addressDetail;
        var _regionAry = [_addressInfo.province || regionStr[0] || '', _addressInfo.city || regionStr[1] || '', _addressInfo.district || regionStr[2] || ''];
        var _joinStr = '';
        if (_regionAry[1] === _regionAry[2]) {
          _regionAry[2] = '';
        }
        if (_this.data.nationId != 1) {
          _joinStr = ' ';
        }
        prePage.setData({
          'address_info.country.id': nationId,
          'address_info.province.id': regionId[0],
          'address_info.city.id': regionId[1],
          'address_info.district.id': regionId[2],
          'address_info.country.text': nationname,
          'address_info.province.text': _regionAry[0],
          'address_info.city.text': _regionAry[1],
          'address_info.district.text': _regionAry[2],
          'address_info.detailAddress': _addressInfo.title || '',
          'address_info.regionInfoText': _regionAry.join(_joinStr) || '',
          'address_info.address': _addressInfo.address,
          latitude: _addressInfo.location.lat,
          longitude: _addressInfo.location.lng
        });
      } else if (_this.data.from == 'addAddress' && type == 'nearby') {
        var addressInfo = addressDetail.ad_info;
        var regionAry = [addressInfo.province || '', addressInfo.city || '', addressInfo.district || ''],
            joinStr = '';
        if (regionAry[1] === regionAry[2]) {
          regionAry[2] = '';
        }
        if (_this.data.nationId != 1) {
          joinStr = ' ';
        }
        prePage.setData({
          'address_info.country.id': _this.data.nationId,
          'address_info.province.text': regionAry[0],
          'address_info.province.id': '',
          'address_info.city.text': regionAry[1],
          'address_info.city.id': '',
          'address_info.district.text': regionAry[2],
          'address_info.district.id': '',
          'address_info.detailAddress': addressDetail.title,
          'address_info.regionInfoText': regionAry.join(joinStr),
          'address_info.address': addressDetail.address,
          latitude: addressDetail.location.lat,
          longitude: addressDetail.location.lng
        });
      } else if (_this.data.from == 'takeout') {
        var data = {};
        data[_this.compid + '.location_address'] = addressDetail.title;
        prePage.setData(data);
        _app.appMethod.globalData.takeoutLocate.lat = addressDetail.location.lat;
        _app.appMethod.globalData.takeoutLocate.lng = addressDetail.location.lng;
      } else if (_this.data.from == 'franchisee' && _this.compid) {
        var _prePage$setData;

        var _e$currentTarget$data = e.currentTarget.dataset.addressinfo,
            location = _e$currentTarget$data.location,
            address = _e$currentTarget$data.address;

        var franchiseeCompid = _this.compid;
        prePage.setData((_prePage$setData = {}, (0, _defineProperty3.default)(_prePage$setData, franchiseeCompid + '.location_address', address), (0, _defineProperty3.default)(_prePage$setData, franchiseeCompid + '.param.latitude', location.lat), (0, _defineProperty3.default)(_prePage$setData, franchiseeCompid + '.param.longitude', location.lng), _prePage$setData));
        _app.appMethod.globalData.locationInfo.address = address;
        _app.appMethod.globalData.locationInfo.latitude = location.lat;
        _app.appMethod.globalData.locationInfo.longitude = location.lng;
        _app.appMethod.globalData.franchiseeListCompsRefresh = true;
        if (Array.isArray(_app.appMethod.globalData.needRefreshFranchiseeListComps)) {
          if (~franchiseeCompid.indexOf(_app.appMethod.globalData.needRefreshFranchiseeListComps)) {} else {
            _app.appMethod.globalData.needRefreshFranchiseeListComps.push(franchiseeCompid);
          }
        } else {
          _app.appMethod.globalData.needRefreshFranchiseeListComps = [franchiseeCompid];
        }
      }
      _app.appMethod.globalData.takeoutRefresh = true;
      // prePage.selectAddressBack = true // TODO: 暂时不用处理
      prePage.location = addressDetail.location;
      _app.appMethod.turnBack();
    };

    _this.nearbyAddress = function (option) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/searchAreaInfo',
        data: {
          country_region_id: that.data.nationId,
          keyword: option.keyword,
          boundary: 'nearby(' + option.lat + ',' + option.lng + ',2000)'
        },
        success: function success(res) {
          _this.setData({
            nearbyAddress: res.data || [],
            showMap: true,
            show: true
          });
        }
      });
    };

    _this.regionchange = function (e) {
      if (e.type == 'end' && (e.causedBy == 'scale' || e.causedBy == 'drag')) {
        clearTimeout(_this.timer);
        var that = _this;
        var markers = _this.data.markers;
        _this.mapCtx = _this.mapRef.current;
        _this.mapCtx.getCenterLocation({
          type: 'gcj02',
          success: function success(res) {
            markers[1] = {
              latitude: res.latitude,
              longitude: res.longitude,
              iconPath: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/location.png',
              width: 20,
              height: 30
            };
            that.setData({
              latitude: res.latitude,
              longitude: res.longitude,
              circles: [{
                latitude: res.latitude,
                longitude: res.longitude,
                color: '#FF0000DD',
                fillColor: '#d1edff88',
                radius: 300, //定位点半径
                strokeWidth: 1
              }],
              markers: markers
            });
            that.timer = setTimeout(function () {
              _app.appMethod.sendRequest({
                url: '/index.php?r=Map/getAreaInfoByLatAndLng',
                data: {
                  latitude: res.latitude,
                  longitude: res.longitude
                },
                success: function success(result) {
                  that.nearbyAddress({
                    keyword: result.data.formatted_addresses.recommend,
                    lat: res.latitude,
                    lng: res.longitude
                  });
                }
              });
            }, 500);
          }
        });
      }
    };

    _this.addNewAddress = function () {
      var pages = _app.appMethod.getCurrentPages(),
          prePage = pages[pages.length - 2];
      prePage.setData({
        'address_info.country.id': _this.data.nationId,
        'address_info.province.text': _this.data.regionStr[0],
        'address_info.city.text': _this.data.regionStr[1],
        'address_info.district.text': _this.data.regionStr[2],
        'address_info.regionInfoText': _this.data.regionStr[0] + _this.data.regionStr[1] + _this.data.regionStr[2],
        detailAddress: '',
        'address_info.detailAddress': ''
      });
      _app.appMethod.turnBack();
    };

    _this.reset = function () {
      var markers = _this.data.markers;
      var that = _this;
      markers[1].latitude = _this.data.markers[0].latitude;
      markers[1].longitude = _this.data.markers[0].longitude;
      _this.setData({
        markers: markers,
        latitude: that.data.markers[0].latitude,
        longitude: that.data.markers[0].longitude
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/getAreaInfoByLatAndLng',
        data: {
          latitude: that.data.markers[0].latitude,
          longitude: that.data.markers[0].longitude
        },
        success: function success(result) {
          that.nearbyAddress({
            keyword: result.data.formatted_addresses.recommend,
            lat: that.data.markers[0].latitude,
            lng: that.data.markers[0].longitude
          });
        }
      });
    };

    document.title = '搜索地址';
    _this.mapRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(SearchAddress, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this,
          from = options.from,
          locateAddress = options.locateAddress || '',
          pid = options.nationId == '1' ? '0' : options.nationId;
      var newdata = {};
      if (options.nationId !== undefined && options.nationname !== undefined) {
        newdata.nationId = options.nationId;
        newdata.nationname = options.nationname;
      }
      if (options.latitude) {
        newdata.latitude = options.latitude;
        newdata.longitude = options.longitude;
      }
      newdata.from = from;
      newdata.locateAddress = locateAddress;
      this.setData(newdata);
      this.getArea(pid, function (data) {
        _this2.setData({
          regionCols: pid == 0 ? 3 : 2,
          regionMap: data,
          regionData: _this2.formateRegionData(data)
        });
      });
      this.compindex = options.compindex || '';
      this.locateAddress = locateAddress;
      if (from == 'addAddress') {
        _app.appMethod.setNavigationBarTitle({
          title: '选择收货地址'
        });
      } else if (from == 'takeout') {
        _app.appMethod.setNavigationBarTitle({
          title: '选择定位地址'
        });
      } else {
        _app.appMethod.setNavigationBarTitle({
          title: '搜索地址'
        });
      }
      this.subShopId = options.sub_shop_id || '';
      if (from == 'addAddress') {
        this.isInCountry(this.data.nationId);
      } else {
        this.getLocation();
      }
      this.getAddressList(from);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // var map = new qq.maps.Map(document.getElementById("search-address-map"), {
      //   // 地图的中心地理坐标。
      //   center: new qq.maps.LatLng(39.916527, 116.397128)
      // });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        var that = this;
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
    // showProDialog = () => {
    //   this.setData({
    //     selectProCityDirs: false,
    //     regionStr: this.oldRegionStr || ''
    //   })
    //   this.region = this.data.selectRegion
    //   this.regionid = this.data.selectRegionId
    //   this.oldRegionStr = this.data.regionStr
    // }

    // 格式化地区

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          regionStr = _state.regionStr,
          localLatLng = _state.localLatLng,
          localAddress = _state.localAddress,
          searchAddress = _state.searchAddress,
          addressList = _state.addressList,
          hasInDistance = _state.hasInDistance,
          from = _state.from,
          showMap = _state.showMap,
          longitude = _state.longitude,
          latitude = _state.latitude,
          markers = _state.markers,
          nationId = _state.nationId,
          show = _state.show,
          nearbyAddress = _state.nearbyAddress,
          selectProCityDirs = _state.selectProCityDirs,
          selectRegion = _state.selectRegion,
          province = _state.province,
          regionData = _state.regionData,
          regionCols = _state.regionCols,
          searchInput = _state.searchInput;

      // 去除无value的的值,无效数据
      // debugger: Each child in an array or iterator should have a unique "key" prop

      regionData.forEach(function (item, index) {
        if (!item.value) {
          regionData.splice(index, 1);
        }
      });

      return _react2.default.createElement(
        'div',
        { className: 'official-page search-address' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u641C\u7D22\u5730\u5740' }),
        _react2.default.createElement(
          'div',
          { className: 'search-address' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              _picker2.default,
              {
                data: regionData,
                value: ['', '', ''],
                cols: regionCols,
                onOk: function onOk(e) {
                  return _this3.changeRegion(e);
                }
              },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'address-text' },
                  regionStr[2] || regionStr[1] || '请选择'
                ),
                _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
              )
            )
          ),
          _react2.default.createElement('input', {
            type: 'text',
            placeholder: '\u67E5\u627E\u5C0F\u533A/\u5B66\u6821/\u5927\u53A6\u7B49',
            vaule: searchInput,
            onInput: function onInput(e) {
              return _this3.searchAddress(e);
            }
          })
        ),
        _react2.default.createElement(
          _ScrollView.ScrollView,
          { 'scroll-y': 'true', style: (0, _tools.convertLineStyleData)('height: calc(100% - 84rpx);') },
          _react2.default.createElement(
            'div',
            {
              className: 'myAddress-wrap page',
              id: 'myAddress',
              style: (0, _tools.convertLineStyleData)('height: 100%;')
            },
            from == 'takeout' && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'address-list-title' },
                '\u5F53\u524D\u5730\u5740'
              ),
              _react2.default.createElement(
                'div',
                { className: 'address-local' },
                _react2.default.createElement(
                  'span',
                  {
                    className: 'current-address',
                    'data-addressinfo': localLatLng,
                    onClick: this.turnBackPageByLoacl
                  },
                  localAddress || '定位中...'
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: 'ico-moon icon-relocate',
                    onClick: this.relocate
                  },
                  '\u91CD\u65B0\u5B9A\u4F4D'
                )
              ),
              searchAddress.length && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'address-list-title' },
                  '\u641C\u7D22\u5730\u5740'
                ),
                searchAddress.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'single-search-result ' + (index == 0 ? 'first' : ''),
                        'data-addressinfo': JSON.stringify(item),
                        'data-type': 'search',
                        onClick: _this3.turnBackPage
                      },
                      _react2.default.createElement(
                        'div',
                        { className: 'single-search-title' },
                        item.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'single-search-detail' },
                        item.address
                      )
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'address-list-title' },
                '\u6536\u8D27\u5730\u5740'
              ),
              !addressList.length ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('color:#a8a8a8; padding:20px;') },
                  '\u6682\u65E0\u6536\u8D27\u5730\u5740'
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                addressList.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    item.latitude != '' && _react2.default.createElement(
                      'div',
                      { className: 'myAddress-address' },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'myAddress-address-top',
                          'data-info': item,
                          onClick: _this3.selectAddress,
                          'data-id': item.id
                        },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.address_info.label == 0 && _react2.default.createElement(
                            'label',
                            { className: 'home address-label' },
                            '\u5BB6'
                          ),
                          item.address_info.label == 2 && _react2.default.createElement(
                            'label',
                            { className: 'company address-label' },
                            '\u516C\u53F8'
                          ),
                          item.address_info.label == 1 && _react2.default.createElement(
                            'label',
                            { className: 'school address-label' },
                            '\u5B66\u6821'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'address-detail' },
                            item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + item.address_info.detailAddress
                          )
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'address-person' },
                          item.address_info.name + ' ' + (item.address_info.sex == 1 ? '(先生)' : item.address_info.sex == 0 ? '(女士)' : '') + ' ' + item.address_info.contact
                        )
                      )
                    )
                  );
                }),
                !hasInDistance && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'address-list-title' },
                    '\u4EE5\u4E0B\u5730\u5740\u4FE1\u606F\u4E0D\u5168\uFF08\u9700\u91CD\u65B0\u7F16\u8F91\uFF09'
                  ),
                  addressList.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      item.latitude == '' && _react2.default.createElement(
                        'div',
                        {
                          className: 'myAddress-address',
                          style: (0, _tools.convertLineStyleData)('background-color:#eee;')
                        },
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'myAddress-address-top',
                            'data-info': item,
                            'data-id': item.id
                          },
                          _react2.default.createElement(
                            'div',
                            null,
                            item.address_info.label == 0 && _react2.default.createElement(
                              'label',
                              { className: 'home address-label' },
                              '\u5BB6'
                            ),
                            item.address_info.label == 2 && _react2.default.createElement(
                              'label',
                              { className: 'company address-label' },
                              '\u516C\u53F8'
                            ),
                            item.address_info.label == 1 && _react2.default.createElement(
                              'label',
                              { className: 'school address-label' },
                              '\u5B66\u6821'
                            ),
                            _react2.default.createElement(
                              'span',
                              { className: 'address-detail' },
                              item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + item.address_info.detailAddress
                            )
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'address-person' },
                            item.address_info.name + ' ' + (item.address_info.sex == 1 ? '(先生)' : item.address_info.sex == 0 ? '(女士)' : '') + ' ' + item.address_info.contact
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            !!searchAddress.length && from != 'takeout' && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'address-list-title' },
                '\u641C\u7D22\u5730\u5740'
              ),
              searchAddress.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: item.id },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'single-search-result ' + (index == 0 ? 'first' : ''),
                      'data-addressinfo': JSON.stringify(item),
                      'data-type': 'search',
                      onClick: _this3.turnBackPage
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'single-search-title' },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'single-search-detail' },
                      item.address
                    )
                  )
                );
              })
            ),
            !searchAddress.length && !showMap && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'address-null' },
                _react2.default.createElement(
                  'div',
                  { className: 'address-null-img' },
                  _react2.default.createElement('img', {
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-journey-null.png',
                    onClick: this.addNewAddress
                  })
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-title',
                    onClick: this.addNewAddress
                  },
                  '\u627E\u4E0D\u5230\u5730\u5740\uFF1F'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-tips',
                    onClick: this.addNewAddress
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8BF7\u5C1D\u8BD5\u53EA\u8F93\u5165\u5C0F\u533A\uFF0C\u5199\u5B57\u697C\u6216\u5B66\u6821\u540D'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4E5F\u53EF\u524D\u5F80\u8BE6\u60C5\u5730\u5740'
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#3091F2;') },
                    '\u624B\u52A8\u8F93\u5165'
                  ),
                  '~'
                )
              )
            ),
            showMap && (nationId === '' || nationId == 1) && show && _react2.default.createElement(
              'div',
              { id: 'search-address-map' },
              _react2.default.createElement(
                _Map.Map,
                {
                  ref: this.mapRef,
                  id: 'map',
                  longitude: longitude,
                  latitude: latitude,
                  markers: markers,
                  style: (0, _tools.convertLineStyleData)("width:100%;height:394rpx;"),
                  bindregionchange: this.regionchange
                },
                _react2.default.createElement(
                  'div',
                  { className: 'controls', onClick: this.reset },
                  _react2.default.createElement('img', { src: 'http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/reset.png' })
                )
              )
            ),
            !(nationId === '' || nationId == 1) && !regionStr && _react2.default.createElement(
              'div',
              { className: 'no-nearby' },
              '\u8BF7\u5148\u9009\u62E9\u5730\u533A'
            ),
            (nationId === '' || nationId == 1) && !!nearbyAddress.length && (from == 'takeout' || from == 'addAddress') && !searchAddress.length && showMap && _react2.default.createElement(
              _ScrollView.ScrollView,
              {
                className: 'myAddress-near-address',
                'scroll-y': 'true',
                style: (0, _tools.convertLineStyleData)('height:calc(100% - 394rpx);')
              },
              !!nearbyAddress.length && _react2.default.createElement(
                'div',
                { className: 'address-list-title' },
                '\u9644\u8FD1\u5730\u5740'
              ),
              nearbyAddress.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'single-nearby-address ' + (index == 0 ? 'first' : ''),
                      'data-addressinfo': JSON.stringify(item),
                      'data-type': 'nearby',
                      onClick: _this3.turnBackPage
                    },
                    _react2.default.createElement(
                      'div',
                      { className: 'nearby-title' },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'nearby-address' },
                      item.address
                    )
                  )
                );
              })
            ),
            (nationId === '' || nationId == 1) && !nearbyAddress.length && showMap && show && _react2.default.createElement(
              'div',
              { className: 'no-nearby' },
              '\u6682\u65E0\u9644\u8FD1\u5730\u5740'
            )
          )
        )
      );
    }
  }]);
  return SearchAddress;
}(_OfficialPage3.default);

exports.default = SearchAddress;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = __webpack_require__(126);

var _button2 = _interopRequireDefault(_button);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _modal = __webpack_require__(76);

var _modal2 = _interopRequireDefault(_modal);

__webpack_require__(128);

__webpack_require__(78);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

__webpack_require__(457);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prompt = _modal2.default.prompt;

var CouponList = function (_OfficialPage) {
  (0, _inherits3.default)(CouponList, _OfficialPage);

  function CouponList(props) {
    (0, _classCallCheck3.default)(this, CouponList);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CouponList.__proto__ || Object.getPrototypeOf(CouponList)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '优惠券'
      },
      type: 1,
      loadData: {
        currentPage: 1,
        isMore: 1,
        loading: false
      },
      hiddenmodalput: true,
      untimes: '', // 次数券的次数
      numberOfStampsUrl: '',
      couponList: [],
      addLabelText: '',
      rechargeSuccess: 0,
      storeStyle: {}
    };

    _this2.changeTab = function (event) {
      var _this = _this2;
      var type = event.target.dataset.type;
      _this.setData({
        type: type,
        couponList: [],
        loadData: {
          currentPage: 1,
          isMore: 1,
          loading: false
        }
      });
      if (_this.data.isParentShop) {
        _this.getMyAllCoupons();
      } else {
        _this.getMyCoupons();
      }
    };

    _this2.getMyCoupons = function () {
      var _this = _this2;
      if (_this.data.loadData.isMore == 0 || _this.data.loadData.loading) {
        return false;
      }
      _this.setData({
        'loadData.loading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getMyCoupons',
        data: {
          type: _this.data.type,
          page: _this.data.loadData.currentPage,
          page_size: 10
        },
        hideLoading: true,
        success: function success(res) {
          _this.setData({
            couponList: _this.data.couponList.concat(res.data),
            'loadData.currentPage': (res.current_page || 0) + 1,
            'loadData.isMore': res.is_more,
            'loadData.loading': false
          });
        }
      });
    };

    _this2.getMyAllCoupons = function () {
      var _this = _this2;
      if (_this.data.loadData.isMore == 0 || _this.data.loadData.loading) {
        return false;
      }
      _this.setData({
        'loadData.loading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetMyAllCoupons',
        data: {
          type: _this.data.type,
          latitude: _this.data.latitude,
          longitude: _this.data.longitude,
          page: _this.data.loadData.currentPage,
          page_size: 10
        },
        hideLoading: true,
        success: function success(res) {
          _this.setData({
            couponList: _this.data.couponList.concat(res.data),
            'loadData.currentPage': (res.current_page || 0) + 1,
            'loadData.isMore': res.is_more,
            'loadData.loading': false
          });
        }
      });
    };

    _this2.getLocation = function () {
      var that = _this2;
      _app.appMethod.getLocation({
        success: function success(res) {
          that.setData({
            longitude: res.longitude,
            latitude: res.latitude
          });
          that.getMyAllCoupons();
        },
        fail: function fail() {
          that.setData({
            longitude: '',
            latitude: ''
          });
          that.getMyAllCoupons();
        }
      });
    };

    _this2.gotoCouponDetail = function (event) {
      var couponId = event.currentTarget.dataset.id;
      var appid = event.currentTarget.dataset.appid;
      var franisee = '';
      if (_app.appMethod.globalData.appId != appid && _this2.data.isParentShop) {
        franisee = '&franchisee=' + appid;
      }
      var url = '/pages/couponDetail/couponDetail?status=use&detail=' + couponId + franisee;
      _app.appMethod.turnToPage(url, false);
    };

    _this2.gotoTransferPage = function () {
      var url = '/eCommerce/pages/transferPage/transferPage';
      _app.appMethod.turnToPage(url, false);
    };

    _this2.addLabelInputChange = function (e) {
      _this2.setData({ addLabelText: e.target.value });
    };

    _this2.gotoNumberPage = function (event) {
      event.stopPropagation();
      var couponId = event.currentTarget.dataset.id;
      var appid = event.currentTarget.dataset.appid;
      var untimes = event.currentTarget.dataset.untimes;
      var franisee = '';
      if (_app.appMethod.globalData.appId != appid && _this2.data.isParentShop) {
        franisee = '&franchisee=' + appid;
      }
      var url = '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' + couponId + franisee;
      _this2.setData({
        numberOfStampsUrl: url,
        hiddenmodalput: false,
        untimes: untimes
      });
    };

    _this2.confirm = function () {
      if (+_this2.data.untimes < +_this2.data.addLabelText) {
        _app.appMethod.showModal({ content: '核销次数超过剩余次数' });
        _this2.setData({ hiddenmodalput: true, addLabelText: '' });
        return;
      }
      var url = _this2.data.numberOfStampsUrl + '&Number=' + _this2.data.addLabelText;
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
      _app.appMethod.turnToPage(url, false);
    };

    _this2.cancel = function () {
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
    };

    _this2.gotoRecharge = function (event) {
      event.stopPropagation();
      var _this = _this2;
      var userCouponId = event.currentTarget.dataset.id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/useCoupon',
        data: {
          user_coupon_id: userCouponId
        },
        hideLoading: true,
        success: function success(res) {
          _this.setData({
            rechargeSuccess: 1
          });
          setTimeout(function () {
            _this.hideToast();
          }, 3000);
          var couponList = _this.data.couponList;
          for (var i = 0; i < couponList.length; i++) {
            if (couponList[i]['id'] == userCouponId) {
              var newData = {};
              newData['couponList[' + i + '].status'] = 2;
              _this.setData(newData);
            }
          }
        }
      });
    };

    _this2.hideToast = function () {
      _this2.setData({
        rechargeSuccess: 0
      });
    };

    _this2.gotoShop = function (e) {
      e.stopPropagation();
      var appid = e.currentTarget.dataset.appid;
      var mode = e.currentTarget.dataset.mode;
      var chainId = _app.appMethod.getChainId();
      if (_app.appMethod.globalData.appId == appid) {
        if (_app.appMethod.getChainId()) {
          _app.appMethod.clearChainInfo();
        }
        var home = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({
          url: '/pages/' + home + '/' + home
        });
      } else if (chainId == appid) {
        var _home = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({
          url: '/pages/' + _home + '/' + _home
        });
      } else {
        var param = {};
        param.detail = appid;
        _app.appMethod.goToFranchisee(mode, param);
      }
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      });
    };

    document.title = '优惠券';
    return _this2;
  }

  (0, _createClass3.default)(CouponList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this = this;
      var isParent = _app.appMethod.globalData.hasFranchiseeList;
      _this.setData({
        isParentShop: isParent,
        'topNavBarData.totalHeight': _app.appMethod.globalData.topNavBarHeight || 0
      });
      if (isParent) {
        _this.getLocation();
      } else {
        _this.getAppECStoreConfig();
        _this.getMyCoupons();
      }
    }
  }, {
    key: 'privateStopNoop',
    value: function privateStopNoop(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          type = _state.type,
          storeStyle = _state.storeStyle,
          couponList = _state.couponList,
          isParentShop = _state.isParentShop,
          rechargeSuccess = _state.rechargeSuccess,
          hiddenmodalput = _state.hiddenmodalput,
          addLabelText = _state.addLabelText,
          labelFocus = _state.labelFocus;

      return React.createElement(
        'div',
        { className: 'official-page coupon-list' },
        React.createElement(_TopNav.TopNav, { title: '\u4F18\u60E0\u5238' }),
        React.createElement(
          'div',
          { id: 'coupon-list' },
          React.createElement(
            'div',
            {
              className: 'tabs',
              style: (0, _tools.convertLineStyleData)('top:' + topNavBarData.totalHeight + 'px;')
            },
            React.createElement(
              'div',
              { className: 'tabs-wrap' },
              React.createElement(
                'div',
                {
                  'data-type': '1',
                  onClick: this.changeTab,
                  style: (0, _tools.convertLineStyleData)(type == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                  className: type == 1 ? 'active' : ''
                },
                '\u672A\u4F7F\u7528'
              ),
              React.createElement(
                'div',
                {
                  'data-type': '2',
                  onClick: this.changeTab,
                  style: (0, _tools.convertLineStyleData)(type == 2 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                  className: type == 2 ? 'active' : ''
                },
                '\u5DF2\u4F7F\u7528'
              ),
              React.createElement(
                'div',
                {
                  'data-type': '3',
                  onClick: this.changeTab,
                  style: (0, _tools.convertLineStyleData)(type == 3 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                  className: type == 3 ? 'active' : ''
                },
                '\u5DF2\u5931\u6548'
              )
            )
          ),
          isParentShop ? React.createElement(
            React.Fragment,
            null,
            React.createElement(
              _ScrollView.ScrollView,
              { className: 'ticket-list', 'scroll-y': 'true', 'lower-threshold': '100', bindscrolltolower: this.getMyAllCoupons },
              couponList.map(function (coupon, index) {
                return React.createElement(
                  React.Fragment,
                  { key: coupon.id },
                  React.createElement(
                    'div',
                    {
                      className: 'ticket franchisee-ticket',
                      onClick: _this3.gotoCouponDetail,
                      'data-id': coupon.id,
                      'data-appid': coupon.app_id
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'coupon-franchisee' },
                        React.createElement('img', {
                          className: 'coupon-franchisee-logo',
                          mode: 'aspectFill',
                          src: coupon.logo
                        }),
                        React.createElement(
                          'div',
                          {
                            className: 'coupon-franchisee-name',
                            onClick: _this3.gotoShop,
                            'data-mode': coupon.app_shop_info.mode_id,
                            'data-appid': coupon.app_id
                          },
                          coupon.app_shop_info.name,
                          React.createElement('label', { className: 'ico-moon icon-rightarrow' })
                        ),
                        React.createElement(
                          'div',
                          { className: 'coupon-franchisee-distance' },
                          '附近' + coupon.app_shop_info.distance + '米'
                        )
                      ),
                      coupon.type == 0 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '满' + coupon.condition + '可用'
                          )
                        )
                      ) : coupon.type == 1 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            coupon.value,
                            React.createElement(
                              'label',
                              null,
                              '\u6298'
                            )
                          ),
                          coupon.extra_goods == 'null' ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5168\u90E8\u5546\u54C1\u53EF\u4EAB\u4F18\u60E0'
                          ) : React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u90E8\u5206\u5546\u54C1\u53EF\u4EAB\u4F18\u60E0'
                          )
                        )
                      ) : coupon.type == 2 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5546\u54C1\u4EE3\u91D1\u5238'
                          )
                        )
                      ) : coupon.type == 3 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            '\u5151\u6362\u5238'
                          ),
                          coupon.extra_condition == '' ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '直接兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.price ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '消费满' + coupon.extra_condition.price + '元可兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.goods_id && React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '购买' + coupon.condition_goods_info.title + '可兑换' + coupon.coupon_goods_info.title
                          )
                        )
                      ) : coupon.type == 4 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5546\u54C1\u50A8\u503C\u91D1'
                          )
                        )
                      ) : coupon.type == 5 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            {
                              className: 'coupon-value',
                              style: (0, _tools.convertLineStyleData)('color:' + coupon.list_color)
                            },
                            '\u901A\u7528\u5238'
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            coupon.extra_condition
                          )
                        )
                      ) : coupon.type == 6 && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            '\u6B21\u6570\u5238'
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '使用条件: 可使用' + coupon.verify_times + '次'
                          )
                        )
                      ),
                      coupon.status == 1 && React.createElement(
                        'div',
                        {
                          className: 'receive-btn',
                          onClick: _this3.gotoShop,
                          'data-appid': coupon.app_id,
                          'data-mode': coupon.app_shop_info.mode_id,
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        },
                        '\u53BB\u4F7F\u7528'
                      ),
                      coupon.status == 2 && React.createElement(
                        'div',
                        { className: 'receive-btn receive-btn-use' },
                        '\u5DF2\u4F7F\u7528'
                      ),
                      coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'receive-btn receive-btn-use' },
                        '\u5DF2\u5931\u6548'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'bottom-section' },
                      React.createElement(
                        'div',
                        null,
                        '有效期 ' + (coupon.expire == '-1' ? coupon.start_use_date + '至' + coupon.end_use_date : coupon.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (coupon.react > 0 ? coupon.react + '天后' : '当天') + '生效，有效期' + coupon.expire + '天') + (coupon.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (coupon.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + coupon.start_use_time + '-' + coupon.end_use_time
                      )
                    )
                  )
                );
              })
            )
          ) : React.createElement(
            React.Fragment,
            null,
            React.createElement(
              _ScrollView.ScrollView,
              { className: 'ticket-list', 'scroll-y': 'true', 'lower-threshold': '100', bindscrolltolower: this.getMyCoupons },
              couponList.map(function (coupon, index) {
                return React.createElement(
                  React.Fragment,
                  { key: coupon.id },
                  React.createElement(
                    'div',
                    {
                      className: 'ticket ' + (coupon.status == 2 || coupon.status == 3 || coupon.status == 4 ? 'expired' : ''),
                      onClick: _this3.gotoCouponDetail,
                      'data-id': coupon.id
                    },
                    coupon.type == 0 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件：满' + coupon.condition + '元，减' + coupon.value + '元'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u51CF'
                        )
                      ),
                      coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 1 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 打' + coupon.value + '折'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u6298'
                        )
                      ),
                      coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 2 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件：可抵扣' + coupon.value + '元'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u4EE3'
                        )
                      ),
                      coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 3 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        coupon.extra_condition == '' ? React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 直接兑换' + coupon.coupon_goods_info.title
                        ) : coupon.extra_condition.price ? React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 消费满' + coupon.extra_condition.price + '元可兑换' + coupon.coupon_goods_info.title
                        ) : coupon.extra_condition.goods_id && React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 购买' + coupon.condition_goods_info.title + '可兑换' + coupon.coupon_goods_info.title
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u5151'
                        )
                      ),
                      coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 4 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 储值金可充值' + coupon.value + '元'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u50A8'
                        )
                      ),
                      coupon.status == 1 ? React.createElement(
                        'div',
                        {
                          className: 'use-btn',
                          onClick: _this3.gotoRecharge,
                          'data-id': coupon.id,
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        },
                        '\u7ACB\u5373\u5145\u503C'
                      ) : coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 5 ? React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: ' + coupon.extra_condition
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u901A'
                        )
                      ),
                      coupon.status == 1 ? React.createElement(
                        'div',
                        {
                          className: 'use-btn',
                          onClick: _this3.gotoCouponDetail,
                          'data-id': coupon.id,
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        },
                        '\u7ACB\u5373\u4F7F\u7528'
                      ) : coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      )
                    ) : coupon.type == 6 && React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                      },
                      React.createElement(
                        'div',
                        { className: 'detail-info' },
                        React.createElement(
                          'div',
                          { className: 'name' },
                          coupon.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'use-condition' },
                          '使用条件: 可使用' + coupon.verify_times + '次'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'background-word-area',
                          style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                        },
                        React.createElement('div', {
                          className: 'background-circle',
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                        }),
                        React.createElement(
                          'div',
                          { className: 'background-word' },
                          '\u6B21'
                        )
                      ),
                      coupon.status == 1 ? React.createElement(
                        'div',
                        {
                          className: 'use-btn',
                          onClick: function onClick(e) {
                            return _this3.gotoNumberPage(e);
                          },
                          'data-id': coupon.id,
                          'data-appid': coupon.app_id,
                          style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color),
                          'data-untimes': coupon.un_verify_times
                        },
                        '\u7ACB\u5373\u4F7F\u7528'
                      ) : coupon.status == 2 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u4F7F\u7528'
                      ) : coupon.status == 3 ? React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u5DF2\u5931\u6548'
                      ) : coupon.status == 4 && React.createElement(
                        'div',
                        { className: 'use-btn' },
                        '\u672A\u751F\u6548'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'bottom-section' },
                      React.createElement(
                        'div',
                        null,
                        '有效期 ' + (coupon.expire == '-1' ? coupon.start_use_date + '至' + coupon.end_use_date : coupon.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (coupon.react > 0 ? coupon.react + '天后' : '当天') + '生效，有效期' + coupon.expire + '天') + ' ' + (coupon.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (coupon.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + coupon.start_use_time + '-' + coupon.end_use_time
                      )
                    )
                  )
                );
              })
            )
          ),
          React.createElement(
            'div',
            {
              className: 'zc-toast-bg ' + (rechargeSuccess == 1 ? 'show' : ''),
              onClick: this.hideToast
            },
            React.createElement(
              'div',
              { className: 'zc-toast' },
              React.createElement('span', { className: 'icon', type: 'success', size: '20' }),
              React.createElement(
                'div',
                { className: 'title' },
                '\u5145\u503C\u6210\u529F!'
              ),
              React.createElement(
                'div',
                { className: 'content' },
                '\u8BF7\u5230\u50A8\u503C\u91D1\u4E2D\u67E5\u770B'
              )
            )
          ),
          React.createElement(
            _modal2.default,
            {
              className: 'modal-wrap',
              transparent: true,
              title: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
              visible: !hiddenmodalput,
              maskClosable: true
            },
            React.createElement('input', {
              className: 'modal-input',
              type: 'number',
              placeholder: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
              maxLength: '6',
              onInput: function onInput(e) {
                return _this3.addLabelInputChange(e);
              },
              focus: labelFocus,
              style: (0, _tools.convertLineStyleData)('background:#F5F5F5;height:76rpx;border-radius:10rpx;padding: 0 60rpx')
            }),
            React.createElement(
              'div',
              { className: 'modal-btn-wrap' },
              React.createElement(
                _button2.default,
                { className: 'cancel', onClick: this.cancel },
                '\u53D6\u6D88'
              ),
              React.createElement(
                _button2.default,
                { className: 'confirm', onClick: this.confirm },
                '\u786E\u8BA4'
              )
            )
          )
        )
      );
    }
  }]);
  return CouponList;
}(_OfficialPage3.default);

exports.default = CouponList;

/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(47);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(459);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsReturnInfor = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsReturnInfor, _OfficialPage);

  function GoodsReturnInfor(props) {
    (0, _classCallCheck3.default)(this, GoodsReturnInfor);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsReturnInfor.__proto__ || Object.getPrototypeOf(GoodsReturnInfor)).call(this, props));

    _this2.state = {
      goodsList: [],
      imagesArr: [],
      refundDes: '',
      shipment: '',
      phone: '',
      storeStyle: {}
    };
    _this2.applyId = '';
    _this2.orderId = '';
    _this2.franchiseeId = '';
    _this2.refundGoods = [];
    _this2.expressList = [];

    _this2.dataInitial = function () {
      _this2.getOrderDetail();
      _this2.expressList();
      _this2.getAppECStoreConfig();
      _this2.setData({
        phone: _app.appMethod.getUserInfo().phone || ''
      });
    };

    _this2.getOrderDetail = function (orderId) {
      var _this = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this.orderId,
          sub_shop_app_id: _this2.franchiseeId
        },
        success: function success(res) {
          _this.applyId = res.data[0].form_data.refund_apply.id;
          _this.setData({
            goodsList: res.data[0].form_data.refund_apply.refund_goods
          });
        }
      });
    };

    _this2.chooseImage = function () {
      var _this = _this2;
      var img_arr = _this.data.imagesArr;
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data.imagesArr = img_arr.concat(images);
        _this.setData(data);
      }, 9);
    };

    _this2.deleteImage = function (event) {
      var picIndex = event.currentTarget.dataset.index;
      var img_arr = _this2.data.imagesArr;
      var data = {};
      img_arr.splice(picIndex, 1);
      data.imagesArr = img_arr;
      _this2.setData(data);
    };

    _this2.previewImage = function (event) {
      var _this = _this2;
      var index = event.currentTarget.dataset.index;
      _app.appMethod.previewImage({
        current: _this.data.imagesArr[index],
        urls: _this.data.imagesArr
      });
    };

    _this2.cancelRefund = function () {
      _app.appMethod.turnBack();
    };

    _this2.stopPropagation = function (event) {};

    _this2.inputRefundDes = function (event) {
      _this2.setData({
        refundDes: event.target.value
      });
    };

    _this2.shipmentNumber = function (event) {
      _this2.setData({
        shipment: event.target.value
      });
    };

    _this2.phoneNumber = function (event) {
      _this2.setData({
        phone: event.target.value
      });
    };

    _this2.sureSubmit = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/updateRefundApply',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.franchiseeId,
          apply_id: _this.applyId,
          form_data: {
            express_code: _this.data.expressCode,
            express_no: _this.data.shipment,
            phone: _this.data.phone,
            description: _this.data.refundDes,
            img_url: _this.data.imagesArr
          }
        },
        success: function success(res) {
          _app.appMethod.turnBack();
        }
      });
    };

    _this2.expressList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/expressList',
        data: {
          page: -1
        },
        success: function success(res) {
          _this.setData({
            expressList: res.data
          });
        }
      });
    };

    _this2.selectExpress = function (value) {
      _this2.setData({
        expressCode: value[0]
      });
    };

    _this2.scanLogisticsNumber = function () {
      var _this = _this2;
      _app.appMethod.scanCode({
        success: function success(res) {
          _this.setData({
            shipment: res.result
          });
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config,
          hasRecommendConfig: res.recommend_config ? true : false
        });
      }, _this2.franchiseeId);
    };

    document.title = '填写退货信息';
    return _this2;
  }

  (0, _createClass3.default)(GoodsReturnInfor, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
      this.franchiseeId = options.franchisee;
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          goodsList = _state.goodsList,
          expressList = _state.expressList,
          expressCode = _state.expressCode,
          shipment = _state.shipment,
          phone = _state.phone,
          refundDes = _state.refundDes,
          imagesArr = _state.imagesArr,
          storeStyle = _state.storeStyle;

      // 转换成Picker所需要的数据

      if (expressList) {
        expressList = expressList.map(function (item) {
          return {
            label: item.name,
            value: item.code
          };
        });
      }

      return React.createElement(
        'div',
        { className: 'official-page goods-return-infor' },
        React.createElement(_TopNav.TopNav, { title: '\u586B\u5199\u9000\u8D27\u4FE1\u606F' }),
        React.createElement(
          'div',
          { className: 'refund-box' },
          React.createElement(
            'div',
            { className: 'goods-detail-contain' },
            goodsList.map(function (goods, index) {
              return React.createElement(
                'div',
                { key: true, className: 'goods-detail-box' },
                React.createElement('img', { src: goods.cover }),
                React.createElement(
                  'div',
                  { className: 'goods-detail-content' },
                  React.createElement(
                    'div',
                    { className: 'goods-name' },
                    goods.is_seckill == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u79D2\u6740'
                    ),
                    goods.title
                  ),
                  goods.model_name && React.createElement(
                    'div',
                    { className: 'goods-rules' },
                    goods.model_name
                  )
                )
              );
            })
          ),
          React.createElement(
            'div',
            { className: 'logistics-box' },
            React.createElement(
              'span',
              { className: 'logistics-title' },
              '\u7269\u6D41\u516C\u53F8'
            ),
            React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
            React.createElement(
              'div',
              { className: 'pull-right' },
              React.createElement(
                _picker2.default,
                {
                  cols: 1,
                  extra: '\u9009\u62E9\u7269\u6D41',
                  data: expressList,
                  value: [expressCode],
                  onChange: this.selectExpress
                },
                React.createElement(_list2.default.Item, null)
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'logistics-box' },
            React.createElement(
              'span',
              { className: 'logistics-title' },
              '\u7269\u6D41\u5355\u53F7'
            ),
            React.createElement('span', {
              className: 'ico-moon icon-shopping-scan pull-right',
              onClick: this.scanLogisticsNumber
            }),
            React.createElement('input', {
              value: shipment,
              onChange: this.shipmentNumber,
              className: 'pull-right',
              type: 'text',
              placeholder: '\u8BF7\u586B\u5199\u7269\u6D41\u5355\u53F7'
            })
          ),
          React.createElement(
            'div',
            { className: 'logistics-box logistics-contact' },
            React.createElement(
              'span',
              { className: 'logistics-title' },
              '\u8054\u7CFB\u7535\u8BDD'
            ),
            React.createElement('input', {
              onChange: this.phoneNumber,
              value: phone,
              className: 'pull-right',
              type: 'text',
              placeholder: '\u8BF7\u586B\u5199\u624B\u673A\u53F7\u7801'
            })
          ),
          React.createElement(
            'div',
            { className: 'refund-instruct' },
            React.createElement(
              'div',
              { className: 'refund-instruct-title' },
              '\u9000\u6B3E\u8BF4\u660E',
              React.createElement(
                'span',
                null,
                '\u9009\u586B'
              )
            ),
            React.createElement('textarea', {
              className: 'refund-des',
              value: refundDes,
              onInput: this.inputRefundDes
            }),
            React.createElement(
              'div',
              { className: 'images-box' },
              imagesArr.map(function (item, index) {
                return React.createElement(
                  'div',
                  { key: index },
                  React.createElement('span', {
                    className: 'delete-image ico-moon icon-closes',
                    onClick: _this3.deleteImage,
                    'data-index': index
                  }),
                  React.createElement('img', {
                    src: item,
                    'data-index': index,
                    onClick: _this3.previewImage
                  })
                );
              }),
              React.createElement(
                'div',
                { className: 'add-pic', onClick: this.chooseImage },
                React.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                React.createElement(
                  'div',
                  null,
                  '\u6DFB\u52A0\u56FE\u7247'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'refund-bottom' },
            React.createElement(
              'div',
              { className: 'refund-cancel', onClick: this.cancelRefund },
              '\u53D6\u6D88'
            ),
            React.createElement(
              'div',
              {
                className: 'refund-submit',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                onClick: this.sureSubmit
              },
              '\u63D0\u4EA4'
            )
          )
        )
      );
    }
  }]);
  return GoodsReturnInfor;
}(_OfficialPage3.default);

exports.default = GoodsReturnInfor;

/***/ }),
/* 459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _Map = __webpack_require__(104);

__webpack_require__(461);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsDeliveryList = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsDeliveryList, _OfficialPage);

  function GoodsDeliveryList(props) {
    (0, _classCallCheck3.default)(this, GoodsDeliveryList);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsDeliveryList.__proto__ || Object.getPrototypeOf(GoodsDeliveryList)).call(this, props));

    _this2.state = {
      deliveryList: [],
      centerLat: '',
      centerLng: '',
      markers: [{
        latitude: '',
        longitude: '',
        iconPath: '/images/delivery.png',
        width: 20,
        height: 20
      }],
      deliveryId: '',
      storeStyle: {}
    };
    _this2.callout = {
      content: '离您最近的门店地址',
      fontSize: 14,
      color: '#333333',
      borderRadius: 4,
      bgColor: '#ffffff',
      padding: 10,
      display: 'ALWAYS',
      textAlign: 'center'
    };
    _this2.franchiseeId = '';
    _this2.selfLocation = {};

    _this2.dataInitial = function () {
      _this2.getLocation();
      _this2.getAppECStoreConfig();
    };

    _this2.getLocation = function () {
      var _this = _this2;
      _app.appMethod.getLocation({
        success: function success(res) {
          _this.selfLocation = {
            lat: res.latitude,
            log: res.longitude
          };
        },
        fail: function fail() {
          _this.setData({
            statusFail: true
          });
        },
        complete: function complete() {
          _this.getSelfDeliveryList();
        }
      });
    };

    _this2.getSelfDeliveryList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getSelfDeliveryList',
        data: {
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          if (res.data.store_list_data) {
            var deliveryList = res.data.store_list_data;
            if (_this.data.statusFail) {
              var centerLat = deliveryList[0].latitude;
              var centerLng = deliveryList[0].longitude;
              var latitude = deliveryList[0].latitude;
              var longitude = deliveryList[0].longitude;
              var deliveryId = deliveryList[0].id;
              if (_this.data.deliveryId) {
                deliveryList.map(function (item) {
                  if (item.id == _this.data.deliveryId) {
                    centerLat = item.latitude;
                    centerLng = item.longitude;
                    latitude = item.latitude;
                    longitude = item.longitude;
                    deliveryId = item.id;
                  }
                });
              }
              _this.setData({
                showMap: true,
                deliveryList: deliveryList,
                centerLat: centerLat,
                centerLng: centerLng,
                'markers[0].latitude': latitude,
                'markers[0].longitude': longitude,
                'markers[0].callout': '',
                deliveryId: deliveryId
              });
            } else {
              _this.calculationDistance(deliveryList);
            }
          }
        }
      });
    };

    _this2.calculationDistance = function (data) {
      console.log(1);
      var deliveryList = data;
      var _this = _this2;
      for (var i = 0; i < deliveryList.length; i++) {
        deliveryList[i].distance = parseInt(_app.appMethod.calculationDistanceByLatLng(_this.selfLocation.lat, _this.selfLocation.log, deliveryList[i].latitude, deliveryList[i].longitude));
      }
      for (var _i = 0; _i < deliveryList.length; _i++) {
        for (var j = _i + 1; j < deliveryList.length; j++) {
          if (deliveryList[_i].distance > deliveryList[j].distance) {
            var tmp = deliveryList[_i];
            deliveryList[_i] = deliveryList[j];
            deliveryList[j] = tmp;
          }
        }
      }
      _this2.setData({
        showMap: true,
        deliveryList: deliveryList
      });
      _this.showCallout();
    };

    _this2.showCallout = function () {
      var deliveryList = _this2.data.deliveryList;
      var deliveryId = _this2.data.deliveryId;
      var _this = _this2;
      var index = -1;
      for (var i = 0; i < deliveryList.length; i++) {
        if (deliveryList[i].id == deliveryId) {
          index = i;
        }
      }
      index = index < 0 ? 0 : index;
      _this2.setData({
        centerLat: deliveryList[index].latitude,
        centerLng: deliveryList[index].longitude,
        'markers[0].latitude': deliveryList[index].latitude,
        'markers[0].longitude': deliveryList[index].longitude,
        'markers[0].callout': index == 0 ? _this.callout : '',
        deliveryId: deliveryList[index].id
      });
    };

    _this2.selectDelivery = function (event) {
      var index = event.currentTarget.dataset.index;
      var deliveryList = _this2.data.deliveryList;
      var _this = _this2;
      _this2.setData({
        centerLat: deliveryList[index].latitude,
        centerLng: deliveryList[index].longitude,
        'markers[0].latitude': deliveryList[index].latitude,
        'markers[0].longitude': deliveryList[index].longitude,
        'markers[0].callout': index == 0 && !_this.data.statusFail ? _this.callout : '',
        deliveryId: deliveryList[index].id
      });
    };

    _this2.sureDelivery = function () {
      var _this = _this2;
      var deliveryId = _this2.data.deliveryId;
      var pages = _app.appMethod.getCurrentPages();
      var prePage = pages[pages.length - 2];
      var deliveryList = _this2.data.deliveryList;
      for (var i = 0; i < deliveryList.length; i++) {
        if (deliveryList[i].id == deliveryId) {
          var setDataObj = {};
          if (_this.isFranchisee) {
            setDataObj['mulShopsInfo.' + _this.franchiseeId + '.selectDelivery'] = deliveryList[i];
            setDataObj['mulShopsInfo.' + _this.franchiseeId + '.tostoreOrderType'] = '';
            setDataObj['mulShopsInfo.' + _this.franchiseeId + '.dateIndex'] = '';
            setDataObj['mulShopsInfo.' + _this.franchiseeId + '.tostoreDateTime'] = '';
            setDataObj['mulShopsInfo.' + _this.franchiseeId + '.tostoreWeekTime'] = '';
          } else {
            setDataObj['selectDelivery'] = deliveryList[i];
            setDataObj['tostoreOrderType'] = '';
            setDataObj['dateIndex'] = '';
            setDataObj['tostoreDateTime'] = '';
            setDataObj['tostoreWeekTime'] = '';
          }
          prePage.setData(setDataObj);
        }
      }
      _app.appMethod.turnBack();
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    document.title = '选择自提点';
    return _this2;
  }

  (0, _createClass3.default)(GoodsDeliveryList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.isFranchisee = options.subAppId ? true : false;
      this.franchiseeId = options.subAppId || options.franchiseeId || '';
      this.setData({
        deliveryId: options.deliveryId || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          centerLng = _state.centerLng,
          centerLat = _state.centerLat,
          controls = _state.controls,
          markers = _state.markers,
          showMap = _state.showMap,
          deliveryList = _state.deliveryList,
          storeStyle = _state.storeStyle,
          statusFail = _state.statusFail,
          deliveryId = _state.deliveryId;

      console.log('this.state', this.state);

      return React.createElement(
        'div',
        { className: 'official-page goods-delivery-list' },
        React.createElement(_TopNav.TopNav, { title: '\u9009\u62E9\u81EA\u63D0\u70B9' }),
        showMap && React.createElement(
          'div',
          { className: 'map-wrap' },
          centerLng && centerLat && React.createElement(_Map.Map, {
            longitude: centerLng,
            latitude: centerLat,
            scale: '14',
            controls: controls,
            markers: markers
          })
        ),
        React.createElement(
          'div',
          { className: 'delivery-list-box' },
          deliveryList.map(function (item, index) {
            return React.createElement(
              'div',
              {
                className: 'delivery-list',
                key: item.id,
                onClick: _this3.selectDelivery,
                'data-index': index
              },
              React.createElement('span', { className: 'ico-moon icon-goods-location' }),
              React.createElement(
                'div',
                { className: 'delivery-list-content' },
                React.createElement(
                  'div',
                  { className: 'delivery-list-title' },
                  item.contact_name + ' ' + item.contact_phone
                ),
                React.createElement(
                  'div',
                  { className: 'delivery-list-detail' },
                  item.region_data.region_string + item.address_detail
                ),
                !statusFail && React.createElement(
                  'div',
                  null,
                  index == 0 && React.createElement(
                    'span',
                    {
                      className: 'delivery-lately',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme)
                    },
                    '\u79BB\u4F60\u6700\u8FD1'
                  ),
                  React.createElement(
                    'span',
                    { className: 'delivery-list-distance' },
                    '距离当前定位' + item.distance + '米'
                  )
                )
              ),
              React.createElement('label', {
                style: (0, _tools.convertLineStyleData)(deliveryId == item.id ? 'color:' + storeStyle.theme : ''),
                className: 'delivery-check-box ico-moon icon-success-tip ' + (deliveryId == item.id ? 'checked' : '')
              })
            );
          })
        ),
        React.createElement(
          'div',
          {
            className: 'sure-delivery',
            style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
            onClick: this.sureDelivery
          },
          '\u9009\u4E3A\u81EA\u63D0\u70B9'
        )
      );
    }
  }]);
  return GoodsDeliveryList;
}(_OfficialPage3.default);

exports.default = GoodsDeliveryList;

/***/ }),
/* 461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(463);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsAlreadyRefunded = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsAlreadyRefunded, _OfficialPage);

  function GoodsAlreadyRefunded(props) {
    (0, _classCallCheck3.default)(this, GoodsAlreadyRefunded);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoodsAlreadyRefunded.__proto__ || Object.getPrototypeOf(GoodsAlreadyRefunded)).call(this, props));

    _this.state = {
      alreadyGoods: []
    };

    _this.dataInitial = function () {
      _this.getAlreadyGoods();
    };

    _this.getAlreadyGoods = function () {
      var alreadyGoods = _app.appMethod.getCurrentPages()[_app.appMethod.getCurrentPages().length - 2].data.orderInfo.goods_info;
      var refundPrice = _app.appMethod.getCurrentPages()[_app.appMethod.getCurrentPages().length - 2].data.orderInfo.refunded_price;
      _this.setData({
        alreadyGoods: alreadyGoods,
        refundPrice: refundPrice
      });
    };

    document.title = '已退商品';
    return _this;
  }

  (0, _createClass3.default)(GoodsAlreadyRefunded, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          alreadyGoods = _state.alreadyGoods,
          refundPrice = _state.refundPrice;

      return React.createElement(
        'div',
        { className: 'official-page goods-already-refunded' },
        React.createElement(_TopNav.TopNav, { title: '\u5DF2\u9000\u5546\u54C1' }),
        React.createElement(
          'div',
          { className: 'already-goods-box' },
          alreadyGoods.map(function (item, index) {
            return React.createElement(
              React.Fragment,
              { key: index },
              item.refunded_num > 0 && React.createElement(
                'div',
                { className: 'goods-detail-box' },
                React.createElement('img', { src: item.cover }),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'goods-name' },
                    item.is_group_buy_order && item.is_group_buy_order != 0 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u62FC\u56E2'
                    ),
                    item.is_seckill == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u79D2\u6740'
                    ),
                    item.is_benefit_goods == 1 && React.createElement(
                      'span',
                      { className: 'is-seckill' },
                      '\u8D60\u54C1'
                    ),
                    item.goods_name
                  ),
                  item.model_value && React.createElement(
                    'div',
                    { className: 'goods-rules' },
                    item.model_value
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-price' },
                    React.createElement(
                      'span',
                      { className: 'colorff7' },
                      '¥' + item.price
                    ),
                    React.createElement(
                      'span',
                      { className: 'pull-right' },
                      'x ' + item.refunded_num
                    )
                  )
                )
              )
            );
          }),
          React.createElement(
            'div',
            { className: 'already-price' },
            '\u9000\u6B3E\u91D1\u989D',
            React.createElement(
              'span',
              { className: 'pull-right colorff7' },
              '¥' + refundPrice
            )
          )
        )
      );
    }
  }]);
  return GoodsAlreadyRefunded;
}(_OfficialPage3.default);

exports.default = GoodsAlreadyRefunded;

/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(465);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeckillDetail = function (_OfficialPage) {
  (0, _inherits3.default)(SeckillDetail, _OfficialPage);

  function SeckillDetail(props) {
    (0, _classCallCheck3.default)(this, SeckillDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (SeckillDetail.__proto__ || Object.getPrototypeOf(SeckillDetail)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '秒杀详情'
      },
      goodsId: '',
      goodsInfo: {},
      modelStrs: {},
      selectModelInfo: {
        models: [],
        stock: '',
        price: '',
        virtualPrice: '',
        buyCount: 1,
        models_text: ''
      },
      pageQRCodeData: {
        shareDialogShow: '100%',
        shareMenuShow: false
      },
      commentArr: [],
      commentNums: [],
      commentExample: '',
      commentPage: 1,
      commnetType: 0,
      commentTotalPage: '',
      defaultPhoto: '',
      allStock: '',
      addToShoppingCartHidden: true,
      ifAddToShoppingCart: true,
      priceDiscountStr: '',
      page_hidden: true,
      appointmentPhone: '',
      detailCommetType: 'detail',
      carouselCurrentIndex: 1,
      imageOrVideo: 'image',
      storeStyle: ''
    };

    _this2.onReachBottom = function () {
      if (_this2.data.detailCommetType == 'comment' && _this2.data.commentPage <= _this2.data.commentTotalPage) {
        _this2.getAssessList(_this2.data.commentType, _this2.data.commentPage, 1);
      }
    };

    _this2.dataInitial = function () {
      var that = _this2;
      if (!_this2.data.franchiseeId) {
        _this2.getAppECStoreConfig();
      }
      var data = {};
      if (_this2.data.seckillType == 1) {
        data = {
          data_id: _this2.data.goodsId,
          sub_shop_app_id: _this2.data.franchiseeId,
          is_seckill: 1,
          seckill_activity_arr: {
            seckill_activity_id: _this2.data.seckill_activity_id,
            seckill_activity_time_id: _this2.data.seckill_activity_time_id
          },
          is_seckill_activity: _this2.data.seckillType
        };
      } else {
        data = {
          data_id: _this2.data.goodsId,
          sub_shop_app_id: _this2.data.franchiseeId,
          is_seckill: 1,
          is_seckill_activity: _this2.data.seckillType
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: data,
        method: 'post',
        success: that.modifyGoodsDetail,
        complete: function complete() {
          that.setData({
            page_hidden: false
          });
        }
      });
    };

    _this2.onShareAppMessage = function () {
      _this2.setData({
        pageQRCodeData: {
          shareDialogShow: '100%',
          shareMenuShow: false
        }
      });
      var that = _this2,
          goodsId = _this2.data.goodsId,
          contact = _this2.data.contact,
          franchiseeId = _this2.data.franchiseeId,
          cartGoodsNum = _this2.data.cart_num || '',
          isSeckill = _this2.data.isSeckill,
          title = _this2.data.goodsInfo.share_title,
          shareImage = _this2.data.goodsInfo.share_image ? _this2.data.goodsInfo.share_image : _this2.data.goodsInfo.img_urls && _this2.data.goodsInfo.img_urls[0] ? _this2.data.goodsInfo.img_urls[0] : _this2.data.goodsInfo.cover,
          urlSeckill = isSeckill ? '&goodsType=seckill' : '',
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          path = '/seckill/pages/seckillDetail/seckillDetail?id=' + goodsId + '&contact=' + contact + (franchiseeId ? '&franchisee=' + franchiseeId + '&cart_num=' + cartGoodsNum : '') + urlSeckill + urlPromotion + '&seckill_activity_id=' + that.data.seckill_activity_id + '&seckill_activity_time_id=' + that.data.seckill_activity_time_id + '&seckillType=' + that.data.seckillType;
      return _app.appMethod.shareAppMessage({
        path: path,
        title: title,
        imageUrl: shareImage,
        success: function success(addTime) {
          _app.appMethod.showToast({ title: '转发成功', duration: 500 });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    _this2.goToMyOrder = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/myOrder/myOrder?goodsType=' + _this2.data.goodsInfo.goods_type + '&currentIndex=0' + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath, true);
    };

    _this2.goToShoppingCart = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/shoppingCart/shoppingCart' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath, true);
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.data.franchiseeId;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({ delta: 2 });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
      }
    };

    _this2.goToCommentPage = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/goodsComment/goodsComment?detail=' + _this2.data.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.goodsCoverOnload = function (e) {};

    _this2.modifyGoodsDetail = function (res) {
      var _this = _this2,
          goods = res.data[0].form_data,
          unitType = goods.appointment_info && goods.appointment_info.unit_type || '',
          description = goods.description,
          goodsModel = [],
          selectModels = [],
          modifySelectModels = '',
          modelStrs = {},
          price = 0,
          discountStr = '',
          allStock = 0,
          selectStock,
          selectPrice,
          selectModelId,
          matchResult,
          selectVirtualPrice,
          selectText = '',
          selectImgurl = '',
          appointment_desc,
          appointmentPhone;
      _this2.setData({
        unitType: unitType,
        appointmentDesc: goods.appointment_info && goods.appointment_info.appointment_desc ? goods.appointment_info.appointment_desc.replace(/<br \/>/g, '\r\n') : '更多优惠资讯详情请联系商家!',
        appointmentPhone: goods.appointment_info && goods.appointment_info.appointment_phone ? goods.appointment_info.appointment_phone : '',
        displayComment: goods.appointment_info && goods.appointment_info.display_comment == '1' ? goods.appointment_info.display_comment : ''
      });
      // makePhone: WxParse.wxParse(
      //   'wxParseDescription',
      //   'html',
      //   description,
      //   _this,
      //   10
      // )
      for (var key in goods.model) {
        if (key) {
          var model = goods.model[key];
          goodsModel.push(model);
          if (model && model.subModelName) {
            if (key == '1' && goods.goods_type == '1') {
              for (var index in model.subModelName) {
                var adjustTime = model.subModelName[index].split('-'),
                    submodel = model.subModelName[index].substring(6, 8),
                    endHours = submodel - 24 >= 10 ? submodel - 24 : '0' + (submodel - 24);
                model.subModelName[index] = submodel >= 24 ? adjustTime[0] + '-' + '次日' + endHours + ':' + adjustTime[1].split(':')[1] : adjustTime[0] + '-当日' + adjustTime[1];
              }
            }
            if (goods.goods_type == '1' && model.id == '0') {
              for (var index in model.subModelName) {
                model.subModelName[index] = model.subModelName[index] + (goods.appointment_info && goods.appointment_info.unit);
              }
            }
            modelStrs[model.id] = model.subModelName.join('、');
            selectModels.push(model.subModelId[0]);
            modifySelectModels = selectModels.toString();
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
      }
      if (goods.model_items.length) {
        var items = goods.model_items;
        for (var i = 0; i < items.length; i++) {
          var seckill_price = +items[i].seckill_price;
          var modifyGoodsmodelseckill = items[i].model;
          goods.seckill_highPrice = goods.seckill_highPrice >= seckill_price ? goods.seckill_highPrice : seckill_price;
          goods.seckill_lowPrice = goods.seckill_lowPrice <= seckill_price ? goods.seckill_lowPrice : seckill_price;
          allStock += Number(items[i].seckill_stock);
          if (modifyGoodsmodelseckill == modifySelectModels) {
            selectPrice = items[i].seckill_price;
            selectStock = items[i].seckill_stock;
            selectModelId = items[i].id;
            selectImgurl = items[i].img_url;
          }
        }
      } else {
        selectPrice = goods.seckill_price;
        selectStock = goods.seckill_stock;
        allStock = goods.seckill_stock;
        selectImgurl = goods.cover;
      }
      goods.model = goodsModel;
      if (Number(goods.max_can_use_integral) != 0) {
        discountStr = '（积分可抵扣' + Number(goods.max_can_use_integral) / 100 + '元）';
      }
      var expressSort = goods.goods_express_data.express_fee_sort;
      if (expressSort.length == 1) {
        var express = expressSort[0];
        if (express == 0) {
          goods.express_fee = '包邮';
        } else {
          goods.express_fee = express + '元';
        }
      } else {
        goods.express_fee = expressSort[0] + '~' + expressSort[1] + '元';
      }
      if (goods.is_seckill == 1) {
        goods.downCount = {
          hours: '00',
          minutes: '00',
          seconds: '00'
        };
        if (goods.seckill_start_state == 0) {
          _this.downcount = _app.appMethod.beforeSeckillDownCount(goods, _this, 'goodsInfo');
        } else if (goods.seckill_start_state == 1) {
          _this.downcount = _app.appMethod.duringSeckillDownCount(goods, _this, 'goodsInfo');
        }
      }
      var loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
      var tomorrowTime = loaclDayTime + 86400;
      var afterTomorrowTime = tomorrowTime + 86400;
      var date = new Date(goods.seckill_start_timestamp * 1000);
      var m = date.getMonth() + 1;
      var d = date.getDate();
      var h = date.getHours();
      var min = date.getMinutes();
      goods.seckill_startTime = '';
      if (goods.seckill_start_timestamp <= tomorrowTime) {
        goods.startDay = 1;
      } else if (goods.seckill_start_timestamp > tomorrowTime && goods.seckill_start_timestamp <= afterTomorrowTime) {
        goods.startDay = 2;
        if (min == '00') {
          goods.seckill_startTime = '明日' + h + '点整开抢';
        } else if (min != '00' && min < 10) {
          goods.seckill_startTime = '明日' + h + ':0' + min + '开抢';
        } else {
          goods.seckill_startTime = '明日' + h + ':' + min + '开抢';
        }
      } else if (goods.seckill_start_timestamp > afterTomorrowTime) {
        goods.startDay = 2;
        if (min == '00') {
          goods.seckill_startTime = m + '月' + d + '日' + h + '点整开抢';
        } else if (min != '00' && min < 10) {
          goods.seckill_startTime = m + '月' + d + '日' + h + ':0' + min + '开抢';
        } else {
          goods.seckill_startTime = m + '月' + d + '日' + h + ':' + min + '开抢';
        }
      }
      if (_this2.data.seckillType == 1) {
        // 配送方式过滤活动秒杀
        for (var _i = 0; _i < goods.pick_up_type.length; _i++) {
          goods.pick_up_type[_i] == 4 && goods.pick_up_type.splice(_i, 1);
        }
      }
      _this.setData({
        goodsInfo: goods,
        modelStrs: modelStrs,
        'selectModelInfo.models': selectModels || '',
        'selectModelInfo.stock': selectStock || '',
        'selectModelInfo.price': selectPrice || '',
        'selectModelInfo.modelId': selectModelId || '',
        'selectModelInfo.models_text': selectText || '',
        'selectModelInfo.imgurl': selectImgurl || '',
        'selectModelInfo.virtualPrice': selectVirtualPrice || '',
        allStock: allStock || '',
        priceDiscountStr: discountStr || ''
      });
      _this.getAssessList(0, 1);
    };

    _this2.showBuyDirectly = function () {
      if (_this2.data.isSeckill && _this2.data.goodsInfo.seckill_start_state != 1) {
        _app.appMethod.showModal({ content: '当前秒杀商品不在秒杀时间范围内，不能立即购买' });
        return;
      }
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: false,
        imageOrVideo: 'image'
      });
    };

    _this2.showAddToShoppingCart = function () {
      if (_this2.data.isSeckill && _this2.data.goodsInfo.seckill_start_state == 2) {
        _app.appMethod.showModal({ content: '当前秒杀已结束，不能加入购物车' });
        return;
      }
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: true,
        imageOrVideo: 'image'
      });
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true
      });
    };

    _this2.selectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.selectModelInfo.models,
          model = _this2.data.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['selectModelInfo.models'] = selectModels;
      data['selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var _this = _this2,
          selectModelIds = _this2.data.selectModelInfo.models.join(','),
          modelItems = _this2.data.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          if (_this.data.isSeckill) {
            //假如是秒杀
            data['selectModelInfo.stock'] = modelItems[i].seckill_stock;
            data['selectModelInfo.price'] = modelItems[i].seckill_price;
            data['selectModelInfo.modelId'] = modelItems[i].id;
            data['selectModelInfo.imgurl'] = modelItems[i].img_url;
            data['seckill_activity_goods_id'] = modelItems[i].seckill_activity_goods_id;
          } else {
            data['selectModelInfo.stock'] = modelItems[i].stock;
            data['selectModelInfo.price'] = modelItems[i].price;
            data['selectModelInfo.modelId'] = modelItems[i].id;
            data['selectModelInfo.imgurl'] = modelItems[i].img_url;
            data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price;
          }
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.clickMinusButton = function (e) {
      var count = _this2.data.selectModelInfo.buyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count - 1
      });
    };

    _this2.clickPlusButton = function (e) {
      var selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          count = selectModelInfo.buyCount,
          stock = selectModelInfo.stock;
      if (count >= stock) {
        _app.appMethod.showModal({ content: '购买数量不能大于库存' });
        return;
      }
      if (_this2.data.isSeckill && count >= goodsInfo.seckill_buy_limit) {
        _app.appMethod.showModal({ content: '购买数量不能大于秒杀限购数量' });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count + 1
      });
    };

    _this2.sureAddToShoppingCart = function () {
      var that = _this2,
          param = {};
      if (_this2.data.seckillType == 0) {
        param = {
          goods_id: _this2.data.goodsId,
          model_id: _this2.data.selectModelInfo.modelId || '',
          num: _this2.data.selectModelInfo.buyCount,
          sub_shop_app_id: _this2.data.franchiseeId || '',
          is_seckill: 1
        };
      } else {
        param = {
          goods_id: _this2.data.goodsId,
          model_id: _this2.data.selectModelInfo.modelId || '',
          num: _this2.data.selectModelInfo.buyCount,
          sub_shop_app_id: _this2.data.franchiseeId || '',
          is_seckill: 1,
          form_data: {
            seckill_activity_id: _this2.data.seckill_activity_id,
            seckill_activity_time_id: _this2.data.seckill_activity_time_id,
            seckill_activity_goods_id: _this2.data.seckill_activity_goods_id
          }
        };
      }
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        method: 'post',
        success: function success(res) {
          _app.appMethod.showToast({
            title: '添加成功',
            icon: 'success'
          });
          setTimeout(function () {
            that.hiddeAddToShoppingCart();
          }, 1000);
        }
      });
    };

    _this2.buyDirectlyNextStep = function (e) {
      var franchiseeId = _this2.data.franchiseeId,
          that = _this2,
          param = {};
      if (_this2.data.seckillType == 0) {
        param = {
          goods_id: _this2.data.goodsId,
          model_id: _this2.data.selectModelInfo.modelId || '',
          num: _this2.data.selectModelInfo.buyCount,
          sub_shop_app_id: franchiseeId || '',
          is_seckill: 1
        };
      } else {
        param = {
          goods_id: _this2.data.goodsId,
          model_id: _this2.data.selectModelInfo.modelId || '',
          num: _this2.data.selectModelInfo.buyCount,
          sub_shop_app_id: franchiseeId || '',
          is_seckill: 1,
          form_data: {
            seckill_activity_id: _this2.data.seckill_activity_id,
            seckill_activity_time_id: _this2.data.seckill_activity_time_id,
            seckill_activity_goods_id: _this2.data.seckill_activity_goods_id
          }
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        method: 'post',
        success: function success(res) {
          var cart_arr = [res.data],
              pagePath = '/seckill/pages/previewSeckillOrder/previewSeckillOrder?cart_arr=' + encodeURIComponent(cart_arr) + '&secType=' + that.data.seckillType;
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          that.hiddeAddToShoppingCart();
          _app.appMethod.turnToPage(pagePath);
        }
      });
    };

    _this2.makeAppointment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          unitTime = _this2.data.modelStrs[0] && _this2.data.modelStrs[0].substring(_this2.data.modelStrs[0].length - 1),
          unitType = unitTime == '分' ? 1 : unitTime == '时' ? 2 : 3,
          pagePath = '/eCommerce/pages/makeAppointment/makeAppointment?detail=' + _this2.data.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + ('&param=' + unitType);
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.inputBuyCount = function (e) {
      var count = +e.target.value,
          selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          stock = +selectModelInfo.stock;
      if (count >= stock) {
        count = stock;
        _app.appMethod.showModal({ content: '购买数量不能大于库存' });
      }
      if (_this2.data.isSeckill && count >= +goodsInfo.seckill_buy_limit) {
        count = goodsInfo.seckill_buy_limit;
        _app.appMethod.showModal({ content: '购买数量不能大于秒杀限购数量' });
      }
      _this2.setData({
        'selectModelInfo.buyCount': +count
      });
    };

    _this2.showQRCodeComponent = function () {
      var that = _this2;
      var goodsInfo = _this2.data.goodsInfo;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppDistribution/DistributionShareQRCode',
        data: {
          obj_id: that.data.goodsId,
          text: goodsInfo.share_title || goodsInfo.title,
          price: goodsInfo.highPrice > goodsInfo.lowPrice && goodsInfo.lowPrice != 0 ? goodsInfo.lowPrice + ' ~ ' + goodsInfo.highPrice : goodsInfo.price,
          goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
          sub_shop_id: that.data.franchiseeId,
          type: that.data.seckillType == 0 ? 5 : 21,
          seckill_activity_arr: {
            seckill_activity_id: that.data.seckillType == 1 ? _this2.data.seckill_activity_id : '',
            seckill_activity_time_id: that.data.seckillType == 1 ? _this2.data.seckill_activity_time_id : ''
          }
        },
        method: 'post',
        success: function success(res) {
          // animation.bottom('0').step()
          // that.setData({
          //   'pageQRCodeData.shareDialogShow': 0,
          //   'pageQRCodeData.shareMenuShow': true,
          //   'pageQRCodeData.goodsInfo': res.data,
          //   'pageQRCodeData.goodsInfo.isSeckill': 1,
          //   'pageQRCodeData.goodsInfo.seckill_price': goodsInfo.seckill_price,
          //   'pageQRCodeData.animation': animation.export()
          // })
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': (0, _extends3.default)({}, res.data, {
                isSeckill: 1,
                seckill_price: goodsInfo.seckill_price
              })
            }
          });
        }
      });
    };

    _this2.showShareMenu = function () {
      _app.appMethod.showShareMenu();
    };

    _this2.makePhoneCall = function () {
      _app.appMethod.makePhoneCall(_this2.data.appointmentPhone);
    };

    _this2.hideShareMenu = function () {
      _this2.setData({
        hideShareMenu: true
      });
    };

    _this2.showPageCode = function () {};

    _this2.oneSelectDetailCommet = function (e) {
      _this2.setData({
        detailCommetType: e.target.dataset.type
      });
    };

    _this2.getAssessList = function (commnetType, page, append) {
      var that = _this2;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          idx_arr: {
            idx: 'level',
            idx_value: commnetType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var commentData = res.data;
          if (append) {
            commentData = that.data.commentArr.concat(commentData);
          }
          that.setData({
            commentArr: commentData,
            commentNums: res.num,
            commentPage: that.data.commentPage + 1,
            commentExample: res.data[0] || '',
            commentTotalPage: res.total_page,
            displayComment: that.data.goodsInfo.goods_type === '0' ? +res.num[0] > 0 ? false : true : that.data.goodsInfo.appointment_info && that.data.goodsInfo.appointment_info.display_comment == '1' ? that.data.goodsInfo.appointment_info.display_comment : ''
          });
        }
      });
    };

    _this2.clickCommentLabel = function (e) {
      var commentType = e.target.dataset.type,
          data = {};
      data.commentPage = 1;
      data.commnetType = commentType;
      _this2.setData(data);
      _this2.getAssessList(commentType, 1);
    };

    _this2.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    _this2.carouselIndex = function (index) {
      _this2.setData({
        carouselCurrentIndex: index + 1
      });
    };

    _this2.toCouponList = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/couponReceiveListPage/couponReceiveListPage');
    };

    _this2.changeImageOrVideo = function (event) {
      _this2.setData({
        videoPoster: false,
        imageOrVideo: event.currentTarget.dataset.type
      });
    };

    _this2.toRecommendGoodsDetail = function (event) {
      _app.appMethod.turnToGoodsDetail(event);
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      });
    };

    _this2.startPlayVideo = function () {
      var video = _app.appMethod.createVideoContext('carousel-video');
      _this2.setData({
        videoPoster: true
      });
      video.play();
    };

    _this2.formSubmitRemind = function (e) {
      var _this = _this2;
      var formid = '';
      var goodsInfo = JSON.parse(e.currentTarget.dataset.goods);
      if (e.target.formId != 'the formId is a mock one') {
        formid = e.target.formId;
      }
      var loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
      var seventDay = 86400 * 7;
      if (goodsInfo.seckill_start_timestamp > loaclDayTime + seventDay) {
        _app.appMethod.showModal({ content: '请于开抢前7天来设置哦' });
        return;
      }
      var data = e.currentTarget.dataset;
      var newData = {};
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/setActivityGoodsCare',
        method: 'post',
        data: {
          data_id: goodsInfo.id,
          activity_type: 1,
          activity_id: goodsInfo.seckill_activity_id,
          seckill_activity_arr: {
            seckill_activity_time_id: goodsInfo.seckill_activity_time_id,
            form_id: formid
          },
          is_deleted: data.is_deleted
        },
        success: function success(res) {
          if (!res.status) {
            if (data.is_deleted == 0) {
              _app.appMethod.showModal({
                title: '提示',
                content: '开抢前3分钟提醒你哦',
                showCancel: false
              });
              newData['goodsInfo.is_seckill_activity_care'] = 1;
              newData['goodsInfo.seckill_activity_care'] = goodsInfo.seckill_activity_care + 1;
            } else {
              _app.appMethod.showModal({
                title: '提示',
                content: '提醒已取消，到时你会抢不到哦!',
                showCancel: false
              });
              newData['goodsInfo.is_seckill_activity_care'] = 0;
              newData['goodsInfo.seckill_activity_care'] = goodsInfo.seckill_activity_care - 1;
            }
            _this.setData(newData);
          }
        }
      });
    };

    _this2.addFavoriteGoods = function (event) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addFavoriteGoods',
        data: {
          form_id: event.target.formId,
          goods_id: _this.data.goodsId,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goodsInfo.is_favorite': 1
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '收藏成功!',
            image: '/images/favorites.png'
          });
        }
      });
    };

    _this2.deleteFavoriteGoods = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteFavoriteGoods',
        method: 'post',
        data: {
          goods_id_arr: [_this.data.goodsId],
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goodsInfo.is_favorite': 0
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '取消收藏!',
            image: '/images/cancel-favorites.png'
          });
        }
      });
    };

    document.title = '秒杀详情';
    return _this2;
  }

  (0, _createClass3.default)(SeckillDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var goodsId = options.id || options.detail,
          seckill_activity_id = options.seckill_activity_id || options.sec_act_id || 0,
          seckill_activity_time_id = options.seckill_activity_time_id || options.sec_t_id || 0,
          seckillType = options.seckillType || options.secType || 0,
          contact = options.contact || '',
          franchiseeId = options.franchisee || '',
          cartGoodsNum = options.cart_num || 0,
          defaultPhoto = _app.appMethod.getDefaultPhoto(),
          goodsType = options.goodsType || 0,
          userToken = options.user_token || '',
          hidestock = options.hidestock || '',
          isShowVirtualPrice = options.isShowVirtualPrice || '';
      this.setData({
        goodsId: goodsId,
        seckill_activity_id: seckill_activity_id,
        seckill_activity_time_id: seckill_activity_time_id,
        seckillType: seckillType,
        contact: contact,
        defaultPhoto: defaultPhoto,
        franchiseeId: franchiseeId,
        cartGoodsNum: cartGoodsNum,
        goodsType: goodsType,
        isSeckill: true,
        hidestock: hidestock == 'true' ? true : false,
        isShowVirtualPrice: isShowVirtualPrice == 'true' ? true : false,
        'topNavBarData.totalHeight': _app.appMethod.globalData.topNavBarHeight || 0,
        sessionFrom: options.franchisee || _app.appMethod.getAppId() || ''
      });
      this.dataInitial();
      if (userToken) {
        _app.appMethod.globalData.PromotionUserToken = userToken;
      }
      // TODO this.videoContext = app.createVideoContext('goodsDetail-video')
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcount) {
        this.downcount.clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _React$createElement2;

      var _state = this.state,
          pageQRCodeData = _state.pageQRCodeData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          page_hidden = _state.page_hidden,
          goodsInfo = _state.goodsInfo,
          cartGoodsNum = _state.cartGoodsNum,
          imageOrVideo = _state.imageOrVideo,
          videoPoster = _state.videoPoster,
          storeStyle = _state.storeStyle,
          modelStrs = _state.modelStrs,
          hidestock = _state.hidestock,
          allStock = _state.allStock,
          appointmentDesc = _state.appointmentDesc,
          displayComment = _state.displayComment,
          commentNums = _state.commentNums,
          commentExample = _state.commentExample,
          defaultPhoto = _state.defaultPhoto,
          wxParseDescription = _state.wxParseDescription,
          isSeckill = _state.isSeckill,
          franchiseeId = _state.franchiseeId,
          sessionFrom = _state.sessionFrom,
          carouselCurrentIndex = _state.carouselCurrentIndex,
          detailCommetType = _state.detailCommetType,
          commnetType = _state.commnetType,
          commentArr = _state.commentArr,
          addToShoppingCartHidden = _state.addToShoppingCartHidden,
          selectModelInfo = _state.selectModelInfo,
          isShowVirtualPrice = _state.isShowVirtualPrice,
          ifAddToShoppingCart = _state.ifAddToShoppingCart;


      return _react2.default.createElement(
        'div',
        { className: 'official-page seckill-detail' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BE6\u60C5' }),
        _react2.default.createElement(
          'div',
          { className: 'goods-detail-wrap', hidden: page_hidden },
          _react2.default.createElement(
            'div',
            {
              className: 'goods-detail-nav',
              style: (0, _tools.convertLineStyleData)('top:' + topNavBarData.totalHeight + 'px;')
            },
            _react2.default.createElement(
              'div',
              null,
              (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && _react2.default.createElement('div', {
                className: 'pull-right ico-moon icon-notebook',
                onClick: this.goToMyOrder
              }),
              (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && _react2.default.createElement(
                'div',
                {
                  className: 'pull-right ico-moon icon-store2',
                  onClick: this.goToHomepage
                },
                !!+cartGoodsNum && cartGoodsNum != 0 && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail-cart-num' },
                  cartGoodsNum
                )
              ),
              goodsInfo.detail_type != 2 && _react2.default.createElement('div', {
                className: 'pull-right ico-moon icon-new-share',
                onClick: this.showQRCodeComponent
              })
            )
          ),
          (!goodsInfo.detail_type || goodsInfo.detail_type == 0) && _react2.default.createElement(
            'div',
            { className: 'goods-detail-content oldStyle' },
            _react2.default.createElement(
              'div',
              { className: 'goods-detail-section' },
              imageOrVideo == 'image' && _react2.default.createElement(
                'div',
                { className: 'image-carousel-container' },
                !goodsInfo.img_urls ? _react2.default.createElement(
                  'div',
                  { className: 'goods-cover-container' },
                  _react2.default.createElement('img', {
                    'data-src': goodsInfo.cover,
                    onClick: this.clickPlusImages,
                    src: goodsInfo.cover,
                    mode: 'aspectFill'
                  })
                ) : _react2.default.createElement(
                  'div',
                  { className: 'slick-carousel-container' },
                  _react2.default.createElement(
                    _carousel2.default,
                    {
                      dots: false,
                      infinite: true,
                      autoplay: true,
                      autoplayInterval: 5000,
                      afterChange: this.carouselIndex },
                    goodsInfo.img_urls.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { key: index },
                        _react2.default.createElement('img', {
                          'data-src': item,
                          'data-srcarr': JSON.stringify(goodsInfo.img_urls),
                          onClick: _this3.clickPlusImages,
                          className: 'slide-image',
                          src: item,
                          onLoad: function onLoad() {
                            window.dispatchEvent(new Event('resize'));
                          } })
                      );
                    })
                  )
                ),
                goodsInfo.video_url && _react2.default.createElement(
                  'div',
                  { className: 'image-video-menu' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'image' ? 'active' : '',
                      'data-type': 'image',
                      onClick: this.changeImageOrVideo
                    },
                    '\u56FE\u7247'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'video' ? 'active' : '',
                      'data-type': 'video',
                      onClick: this.changeImageOrVideo
                    },
                    '\u89C6\u9891'
                  )
                )
              ),
              goodsInfo.video_url && imageOrVideo == 'video' && _react2.default.createElement(
                'div',
                { className: 'video-carousel-container' },
                _react2.default.createElement(
                  'video',
                  {
                    src: goodsInfo.video_url,
                    id: 'carousel-video',
                    hidden: !videoPoster
                  },
                  goodsInfo.video_url && _react2.default.createElement(
                    CoverView,
                    { className: 'image-video-menu' },
                    _react2.default.createElement(
                      CoverView,
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    _react2.default.createElement(
                      CoverView,
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'videoele-cover-view', hidden: videoPoster },
                  _react2.default.createElement(
                    'div',
                    { className: 'videoele-poster-wrap' },
                    _react2.default.createElement('img', {
                      className: 'videoele-poster',
                      src: goodsInfo.video_img,
                      mode: 'scaleToFill'
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'videoele-play-icon',
                      onClick: this.startPlayVideo
                    },
                    _react2.default.createElement('img', {
                      className: 'videoele-play-image',
                      src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                      mode: 'scaleToFill'
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'image-video-menu' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    _react2.default.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'goods-seckill',
                  style: (0, _tools.convertLineStyleData)('background:linear-gradient(to right,' + (storeStyle.theme ? storeStyle.theme : '#FF7100') + ',' + (storeStyle.secondary ? storeStyle.secondary : '#FFAC0C') + ');')
                },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-seckill-left' },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-seckill-current' },
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-current-price' },
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-price-unit' },
                        '\xA5'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-seckill-price' },
                        goodsInfo.seckill_price
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-seckill-original' },
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-original-price' },
                        '¥' + goodsInfo.price,
                        _react2.default.createElement('span', { className: 'goods-original-price-line' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'seckill-attention' },
                        goodsInfo.seckill_activity_care + '人关注'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-seckill-right ' + (goodsInfo.seckill_start_state == 2 ? 'seckill-end' : '')
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'countdown' },
                    goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 1 ? _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u5F00\u59CB\u8FD8\u5269'
                    ) : goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 2 ? _react2.default.createElement(
                      'label',
                      null,
                      _react2.default.createElement('span', { className: 'ico-moon icon-seckill-detail-alarm' }),
                      '\u5F00\u62A2\u65F6\u95F4'
                    ) : goodsInfo.seckill_start_state == 1 ? _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u7ED3\u675F\u8FD8\u5269'
                    ) : goodsInfo.seckill_start_state == 2 && _react2.default.createElement(
                      'label',
                      null,
                      '\u5DF2\u7ED3\u675F'
                    ),
                    (goodsInfo.seckill_start_state == 1 || goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 1) && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      !!goodsInfo.downCount.days && _react2.default.createElement(
                        'span',
                        { className: 'days' },
                        goodsInfo.downCount.days + '天'
                      ),
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'hours countdown-text',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        goodsInfo.downCount.hours
                      ),
                      ':',
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'minutes countdown-text',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        goodsInfo.downCount.minutes
                      ),
                      ':',
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'seconds countdown-text',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        goodsInfo.downCount.seconds
                      )
                    ),
                    goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 2 && _react2.default.createElement(
                      'div',
                      {
                        className: 'seckill-start-time',
                        style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                      },
                      goodsInfo.seckill_startTime
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-header' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-title' },
                  _react2.default.createElement('span', {
                    className: 'ico-moon icon-seckill-alarm cover-icon-seckill-alarm',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  }),
                  goodsInfo.title
                ),
                goodsInfo.model_items && !!goodsInfo.model_items.length && _react2.default.createElement(
                  'div',
                  { className: 'goods-models' },
                  goodsInfo.model.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        className: 'goods-model-item',
                        key: item.id,
                        hidden: !item.subModelName
                      },
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-model-cate' },
                        item.name
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-model-detail' },
                        modelStrs[item.id]
                      )
                    );
                  })
                ),
                goodsInfo.goods_type == 0 && _react2.default.createElement(
                  'div',
                  { className: 'goods-other-info' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '运费:' + (goodsInfo.express_fee || '包邮')
                  ),
                  !hidestock && _react2.default.createElement(
                    'div',
                    null,
                    '库存:' + (allStock || goodsInfo.stock)
                  )
                ),
                goodsInfo.goods_type == 0 && _react2.default.createElement(
                  'div',
                  { className: 'goods-other-info' },
                  _react2.default.createElement(
                    'label',
                    null,
                    '\u53D6\u8D27\u65B9\u5F0F'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-pick-up' },
                    goodsInfo.pick_up_type.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { key: item },
                        _react2.default.createElement('span', {
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                          className: 'ico-moon icon-goods-support-delivery suporrt'
                        }),
                        _react2.default.createElement(
                          'span',
                          null,
                          item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                        )
                      );
                    })
                  )
                )
              )
            ),
            goodsInfo.goods_type == 1 && _react2.default.createElement(
              'div',
              { className: 'goods-appointment' },
              _react2.default.createElement(
                'div',
                {
                  className: 'appointment-instructions',
                  style: (0, _tools.convertLineStyleData)('color:#666;')
                },
                '\u9884\u7EA6\u8BF4\u660E'
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'appointment-remarks',
                  style: (0, _tools.convertLineStyleData)('color:#999;word-break:break-all;')
                },
                appointmentDesc
              )
            ),
            _react2.default.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('padding: 20rpx;text-align:center;background:#f4f4f4;color:#b2b2b2;font-size:24rpx;'),
                hidden: displayComment
              },
              _react2.default.createElement('div', { className: 'line' }),
              _react2.default.createElement('div', { className: 'ico-moon icon-good-comment goods-ico' }),
              _react2.default.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align:middle;margin-right:4px;') },
                '\u8BC4\u4EF7'
              ),
              _react2.default.createElement('div', { className: 'line' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-detail-section', hidden: displayComment },
              _react2.default.createElement(
                'div',
                { className: 'comment-title' },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;') },
                  '评价 (' + (commentNums[0] || 0) + ')'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'block-item' },
                commentExample && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'comment-item' },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('img', {
                        className: 'comment-user-photo',
                        src: commentExample.buyer_headimgurl || defaultPhoto
                      }),
                      _react2.default.createElement(
                        'span',
                        { className: 'commentPersonName' },
                        commentExample.buyer_nickname
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'comment-date' },
                      commentExample.add_time
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'comment-content' },
                      commentExample.assess_info.content
                    ),
                    commentExample.assess_info.has_img && _react2.default.createElement(
                      'div',
                      { className: 'comPage-comment-pics' },
                      commentExample.assess_info.img_arr.map(function (imgSrc, index) {
                        return _react2.default.createElement('img', {
                          src: imgSrc,
                          key: index,
                          'data-src': imgSrc,
                          'data-srcarr': JSON.stringify(commentExample.assess_info.img_arr),
                          onClick: _this3.clickPlusImages
                        });
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('text-align:center;') },
                    _react2.default.createElement(
                      'button',
                      {
                        className: 'btn lookAllComments',
                        onClick: this.goToCommentPage
                      },
                      '\u67E5\u770B\u5168\u90E8\u8BC4\u4EF7'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('padding: 20rpx;text-align:center;background:#f4f4f4;color:#b2b2b2;font-size:24rpx;') },
              _react2.default.createElement('div', { className: 'line' }),
              _react2.default.createElement('div', { className: 'ico-moon icon-good-detail goods-ico' }),
              _react2.default.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align:middle;margin-right:4px;') },
                '\u8BE6\u60C5'
              ),
              _react2.default.createElement('div', { className: 'line' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-detail-section' },
              _react2.default.createElement(
                'div',
                { className: 'comment-title' },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;') },
                  '\u4EA7\u54C1\u8BE6\u60C5'
                )
              ),
              _react2.default.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g, '') } })
            ),
            goodsInfo.recommend_info && !!goodsInfo.recommend_info.length && _react2.default.createElement(
              'div',
              { className: 'goods-recommend' },
              _react2.default.createElement(
                'div',
                { className: 'two-recommend' },
                '\u5E97\u94FA\u63A8\u8350'
              ),
              _react2.default.createElement(
                _ScrollView.ScrollView,
                { className: 'recommend-content', 'scroll-x': 'true' },
                goodsInfo.recommend_info.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: 'recommend-goods',
                      key: item.form_data.id,
                      onClick: _this3.toRecommendGoodsDetail,
                      'data-id': item.form_data.id,
                      'data-goods-type': item.form_data.goods_type
                    },
                    _react2.default.createElement('img', { src: item.form_data.cover }),
                    _react2.default.createElement(
                      'div',
                      { className: 'recommend-goods-title' },
                      item.form_data.title
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'recommend-goods-price' },
                      '¥' + item.form_data.price
                    )
                  );
                })
              )
            )
          ),
          goodsInfo.detail_type != 2 && _react2.default.createElement(
            'div',
            { className: 'goods-bottom-opt' },
            _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-' + (isSeckill || franchiseeId ? '2' : '3'),
                    onClick: this.goToShoppingCart
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'bottom-border-right' },
                    _react2.default.createElement('span', { className: 'ico-moon icon-new-goods-shopping' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'margig-top-2' },
                      '\u8D2D\u7269\u8F66'
                    )
                  )
                ),
                !isSeckill && !franchiseeId && _react2.default.createElement(
                  'div',
                  { className: 'form-contain goods-opt-item flex-sub-box-3' },
                  _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      'button',
                      { type: 'button', onClick: goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                      _react2.default.createElement(
                        'div',
                        { className: 'bottom-border-right' },
                        _react2.default.createElement('span', {
                          style: (0, _tools.convertLineStyleData)(goodsInfo.is_favorite == 1 ? 'color:' + storeStyle.theme : ''),
                          className: 'ico-moon icon-' + (goodsInfo.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites')
                        }),
                        _react2.default.createElement(
                          'div',
                          null,
                          '\u6536\u85CF'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-' + (isSeckill || franchiseeId ? '2' : '3')
                  },
                  _react2.default.createElement('div', { className: 'ico-moon icon-service2' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u5BA2\u670D'
                  )
                )
              ),
              goodsInfo.seckill_progress != 100 && goodsInfo.seckill_start_state != 2 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                _react2.default.createElement(
                  'label',
                  {
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.secondary + ';color:' + (storeStyle.secondary == '#ACD3FA' || storeStyle.secondary == '#FFCFDF' || storeStyle.secondary == '#ffffff' || storeStyle.secondary == '#DFF3ED' || storeStyle.secondary == '#FAF7ED' ? storeStyle.theme : '')),
                    className: 'btn addToShoppingCart ' + (goodsInfo.seckill_start_state == 2 ? 'disabled' : ''),
                    onClick: this.showAddToShoppingCart
                  },
                  '\u52A0\u5165\u8D2D\u7269\u8F66'
                )
              ),
              goodsInfo.seckill_progress != 100 && goodsInfo.seckill_start_state == 1 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'btn btn-orange buy-goods-directly ' + (goodsInfo.seckill_start_state != 1 ? 'disabled' : ''),
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + ';'),
                    onClick: this.showBuyDirectly
                  },
                  '\u7ACB\u5373\u8D2D\u4E70'
                )
              ),
              goodsInfo.seckill_start_state == 0 && goodsInfo.is_seckill_activity_care == 0 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                _react2.default.createElement(
                  'form',
                  null,
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'form-button',
                      'data-goods': JSON.stringify(goodsInfo),
                      'data-is_deleted': '0',
                      onClick: this.formSubmitRemind },
                    _react2.default.createElement(
                      'label',
                      {
                        className: 'btn btn-orange buy-goods-directly ' + (goodsInfo.seckill_start_state != 1 ? 'disabled' : ''),
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + ';')
                      },
                      '\u8BBE\u7F6E\u63D0\u9192'
                    )
                  )
                )
              ),
              goodsInfo.seckill_start_state == 0 && goodsInfo.is_seckill_activity_care == 1 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-3' },
                _react2.default.createElement(
                  'form',
                  null,
                  _react2.default.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'form-button',
                      'data-goods': JSON.stringify(goodsInfo),
                      'daga-is_deleted': '1',
                      onClick: this.formSubmitRemind
                    },
                    _react2.default.createElement(
                      'label',
                      {
                        className: 'btn btn-orange buy-goods-directly ' + (goodsInfo.seckill_start_state != 1 ? 'disabled' : ''),
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + ';')
                      },
                      '\u53D6\u6D88\u63D0\u9192'
                    )
                  )
                )
              ),
              goodsInfo.seckill_progress == 100 && goodsInfo.seckill_start_state == 1 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-6' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'btn btn-orange buy-goods-directly ' + (goodsInfo.seckill_start_state != 1 ? 'disabled' : '') + '  background-cccccc'
                  },
                  '\u5546\u54C1\u5DF2\u62A2\u5149'
                )
              ),
              goodsInfo.seckill_start_state == 2 && _react2.default.createElement(
                'div',
                { className: 'flex-sub-box-6' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'btn btn-orange buy-goods-directly ' + (goodsInfo.seckill_start_state != 1 ? 'disabled' : '') + '  background-cccccc'
                  },
                  '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                )
              )
            )
          )
        ),
        goodsInfo.detail_type != 0 && _react2.default.createElement(
          'div',
          { className: 'goods-detail-section' },
          goodsInfo.buyer_list && !!goodsInfo.buyer_list.length && _react2.default.createElement(
            'div',
            { className: 'goods-buy-record' },
            _react2.default.createElement(
              _carousel2.default,
              {
                dots: false,
                infinite: true,
                autoplay: true,
                autoplayInterval: 3000 },
              goodsInfo.buyer_list.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index },
                  _react2.default.createElement('img', {
                    src: item.cover_thumb,
                    onLoad: function onLoad() {
                      window.dispatchEvent(new Event('resize'));
                    } }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.nickname + '购买成功'
                  )
                );
              })
            )
          ),
          imageOrVideo == 'image' && _react2.default.createElement(
            'div',
            { className: 'image-carousel-container' },
            !goodsInfo.img_urls ? _react2.default.createElement(
              'div',
              { className: 'goods-cover-container' },
              _react2.default.createElement('img', {
                'data-src': goodsInfo.cover,
                onClick: this.clickPlusImages,
                src: goodsInfo.cover,
                mode: 'aspectFill'
              })
            ) : _react2.default.createElement(
              'div',
              { className: 'slick-carousel-container' },
              _react2.default.createElement(
                _carousel2.default,
                {
                  dots: false,
                  infinite: true,
                  autoplay: true,
                  autoplayInterval: 5000,
                  afterChange: this.carouselIndex },
                goodsInfo.img_urls.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index },
                    _react2.default.createElement('img', {
                      'data-src': item,
                      'data-srcarr': JSON.stringify(goodsInfo.img_urls),
                      onClick: _this3.clickPlusImages,
                      className: 'slide-image',
                      src: item,
                      onLoad: function onLoad() {
                        window.dispatchEvent(new Event('resize'));
                      } })
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'carousel-index' },
                carouselCurrentIndex + '/' + goodsInfo.img_urls.length
              )
            ),
            goodsInfo.video_url && _react2.default.createElement(
              'div',
              { className: 'image-video-menu' },
              _react2.default.createElement(
                'span',
                {
                  className: imageOrVideo == 'image' ? 'active' : '',
                  'data-type': 'image',
                  onClick: this.changeImageOrVideo
                },
                '\u56FE\u7247'
              ),
              _react2.default.createElement(
                'span',
                {
                  className: imageOrVideo == 'video' ? 'active' : '',
                  'data-type': 'video',
                  onClick: this.changeImageOrVideo
                },
                '\u89C6\u9891'
              )
            )
          ),
          goodsInfo.video_url && imageOrVideo == 'video' && _react2.default.createElement(
            'div',
            { className: 'video-carousel-container' },
            _react2.default.createElement(
              'video',
              {
                src: goodsInfo.video_url,
                id: 'carousel-video',
                hidden: !videoPoster
              },
              goodsInfo.video_url && _react2.default.createElement(
                CoverView,
                { className: 'image-video-menu' },
                _react2.default.createElement(
                  CoverView,
                  {
                    className: imageOrVideo == 'image' ? 'active' : '',
                    'data-type': 'image',
                    onClick: this.changeImageOrVideo
                  },
                  '\u56FE\u7247'
                ),
                _react2.default.createElement(
                  CoverView,
                  {
                    className: imageOrVideo == 'video' ? 'active' : '',
                    'data-type': 'video',
                    onClick: this.changeImageOrVideo
                  },
                  '\u89C6\u9891'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'videoele-cover-view', hidden: videoPoster },
              _react2.default.createElement(
                'div',
                { className: 'videoele-poster-wrap' },
                _react2.default.createElement('img', {
                  className: 'videoele-poster',
                  src: goodsInfo.video_img,
                  mode: 'scaleToFill'
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'videoele-play-icon',
                  onClick: this.startPlayVideo
                },
                _react2.default.createElement('img', {
                  className: 'videoele-play-image',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                  mode: 'scaleToFill'
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'image-video-menu' },
                _react2.default.createElement(
                  'span',
                  {
                    className: imageOrVideo == 'image' ? 'active' : '',
                    'data-type': 'image',
                    onClick: this.changeImageOrVideo
                  },
                  '\u56FE\u7247'
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: imageOrVideo == 'video' ? 'active' : '',
                    'data-type': 'video',
                    onClick: this.changeImageOrVideo
                  },
                  '\u89C6\u9891'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'goods-seckill',
              style: (0, _tools.convertLineStyleData)('background:linear-gradient(to right,' + (storeStyle.theme ? storeStyle.theme : '#FF7100') + ',' + (storeStyle.secondary ? storeStyle.secondary : '#FFAC0C') + ');')
            },
            _react2.default.createElement(
              'div',
              { className: 'goods-seckill-left' },
              _react2.default.createElement(
                'div',
                { className: 'goods-seckill-current' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-current-price' },
                  _react2.default.createElement(
                    'span',
                    { className: 'seckill-price-unit' },
                    '\xA5'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'goods-seckill-price' },
                    goodsInfo.seckill_price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-seckill-original' },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-original-price' },
                    '¥' + goodsInfo.price,
                    _react2.default.createElement('span', { className: 'goods-original-price-line' })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-attention' },
                    goodsInfo.seckill_activity_care + '人关注'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'goods-seckill-right ' + (goodsInfo.seckill_start_state == 2 ? 'seckill-end' : '')
              },
              _react2.default.createElement(
                'div',
                { className: 'countdown' },
                goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 1 ? _react2.default.createElement(
                  'label',
                  null,
                  '\u8DDD\u5F00\u59CB\u8FD8\u5269'
                ) : goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 2 ? _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement('span', { className: 'ico-moon icon-seckill-detail-alarm' }),
                  '\u5F00\u62A2\u65F6\u95F4'
                ) : goodsInfo.seckill_start_state == 1 ? _react2.default.createElement(
                  'label',
                  null,
                  '\u8DDD\u7ED3\u675F\u8FD8\u5269'
                ) : goodsInfo.seckill_start_state == 2 && _react2.default.createElement(
                  'label',
                  null,
                  '\u5DF2\u7ED3\u675F'
                ),
                (goodsInfo.seckill_start_state == 1 || goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 1) && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  !!goodsInfo.downCount.days && _react2.default.createElement(
                    'span',
                    { className: 'days' },
                    goodsInfo.downCount.days + '天'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'hours countdown-text',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    goodsInfo.downCount.hours
                  ),
                  ':',
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'minutes countdown-text',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    goodsInfo.downCount.minutes
                  ),
                  ':',
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'seconds countdown-text',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    goodsInfo.downCount.seconds
                  )
                ),
                goodsInfo.seckill_start_state == 0 && goodsInfo.startDay == 2 && _react2.default.createElement(
                  'div',
                  {
                    className: 'seckill-start-time',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  goodsInfo.seckill_startTime
                )
              )
            )
          )
        ),
        goodsInfo.detail_type == 1 && _react2.default.createElement(
          'div',
          { className: 'goods-detail-content styleOne' },
          _react2.default.createElement(
            'div',
            { className: 'goods-header' },
            _react2.default.createElement(
              'div',
              { className: 'goods-title' },
              _react2.default.createElement('span', {
                className: 'ico-moon icon-seckill-alarm cover-icon-seckill-alarm',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
              }),
              goodsInfo.title
            ),
            _react2.default.createElement('div', { className: 'goods-price' }),
            _react2.default.createElement(
              'div',
              { className: 'goods-coupon', onClick: this.toCouponList },
              _react2.default.createElement(
                'span',
                null,
                '\u6D3B\u52A8\uFF1A'
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'word-orange',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '[\u6700\u65B0\u4F18\u60E0\u5238]'
              ),
              _react2.default.createElement(
                'span',
                { className: 'pull-right color-999' },
                '\u7ACB\u5373\u9886\u53D6',
                _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-freight' },
              _react2.default.createElement(
                'div',
                null,
                '运费：' + (goodsInfo.express_fee || '包邮')
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-freight', onClick: this.showBuyDirectly },
              _react2.default.createElement(
                'span',
                null,
                '\u9009\u62E9\u5546\u54C1\u89C4\u683C'
              ),
              _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow color-999' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-freight' },
              _react2.default.createElement(
                'label',
                null,
                '\u53D6\u8D27\u65B9\u5F0F'
              ),
              _react2.default.createElement(
                'div',
                { className: 'address-pick-up' },
                goodsInfo.pick_up_type.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: item },
                    _react2.default.createElement('span', {
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                      className: 'ico-moon icon-goods-support-delivery suporrt'
                    }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'payment-record' },
            _react2.default.createElement('img', {
              className: 'goods-style-wechat',
              src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/goods-style-wechat.png'
            }),
            _react2.default.createElement(
              'span',
              { className: 'payment-record-word' },
              '\u5FAE\u4FE1\u652F\u4ED8\u4EA4\u6613'
            ),
            _react2.default.createElement(
              'div',
              { className: 'pull-right' },
              _react2.default.createElement(
                'div',
                { className: 'buyer-list' },
                goodsInfo.buyer_list.map(function (item, index) {
                  return _react2.default.createElement('img', {
                    key: index,
                    src: item.cover_thumb || 'http://img.zhichiwangluo.com/zcimgdir/album/file_55910ef341577.png'
                  });
                })
              ),
              _react2.default.createElement(
                'span',
                {
                  className: 'word-orange buy-number',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                },
                '购买' + goodsInfo.seckill_sales + '+'
              ),
              _react2.default.createElement(
                'span',
                { className: 'color-999' },
                '浏览' + goodsInfo.viewed_count + '+'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-recommend' },
            _react2.default.createElement(
              'div',
              { className: 'recommend-header' },
              _react2.default.createElement('img', {
                src: goodsInfo.app_cover,
                className: 'store-picture'
              }),
              _react2.default.createElement(
                'div',
                { className: 'store-des' },
                goodsInfo.app_name
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'pull-right go-to-store',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            ),
            !!goodsInfo.recommend_info.length && _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'recommend-content', 'scroll-x': 'true' },
              goodsInfo.recommend_info.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    className: 'recommend-goods',
                    key: item.form_data.id,
                    onClick: _this3.toRecommendGoodsDetail,
                    'data-id': item.form_data.id,
                    'data-goods-type': item.form_data.goods_type
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'width-fix-image' },
                    _react2.default.createElement('img', {
                      mode: 'widthFix',
                      src: item.form_data.cover
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'recommend-goods-title' },
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'recommend-goods-price' },
                    '¥' + item.form_data.price
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: (0, _tools.convertLineStyleData)('padding: 30rpx;text-align:center;color:#b2b2b2;font-size:24rpx;') },
            _react2.default.createElement('div', { className: 'line' }),
            _react2.default.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align:middle;margin:0 4px;') },
              '\u7EE7\u7EED\u62D6\u52A8\uFF0C\u67E5\u770B\u5546\u54C1\u4FE1\u606F'
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'detail-comment' },
            _react2.default.createElement(
              'div',
              { className: 'detail-comment-menu' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  {
                    'data-type': 'detail',
                    onClick: this.oneSelectDetailCommet,
                    style: (0, _tools.convertLineStyleData)(detailCommetType == 'detail' ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                    className: detailCommetType == 'detail' ? 'active' : ''
                  },
                  '\u8BE6\u60C5'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  {
                    'data-type': 'comment',
                    onClick: this.oneSelectDetailCommet,
                    style: (0, _tools.convertLineStyleData)(detailCommetType == 'comment' ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                    className: 'comment-num-box ' + (detailCommetType == 'comment' ? 'active' : '')
                  },
                  '\u8BC4\u8BBA',
                  _react2.default.createElement(
                    'span',
                    { className: 'comment-num' },
                    commentNums[0] == 0 ? '' : commentNums[0]
                  )
                )
              )
            ),
            detailCommetType != 'comment' && _react2.default.createElement(
              'div',
              { className: 'sub-detail' },
              _react2.default.createElement(TaroParseTmpl, {
                data: { wxParseData: wxParseDescription.nodes }
              })
            ),
            detailCommetType == 'comment' && _react2.default.createElement(
              'div',
              { className: 'sub-comment' },
              _react2.default.createElement(
                'div',
                { className: 'comPage-wrap page' },
                _react2.default.createElement(
                  'div',
                  { className: 'comPage-top-section' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '0',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '33' + (commnetType == 0 ? ';background:' + storeStyle.theme : '')),
                        className: 'comPage-comment-label ' + (commnetType == 0 ? 'active' : '')
                      },
                      '\u5168\u90E8'
                    ),
                    _react2.default.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '1',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '33' + (commnetType == 1 ? ';background:' + storeStyle.theme : '')),
                        className: 'comPage-comment-label ' + (commnetType == 1 ? 'active' : '')
                      },
                      '\u597D\u8BC4 (',
                      _react2.default.createElement(
                        'label',
                        { className: 'comPage-positive-comment' },
                        commentNums[1]
                      ),
                      ')'
                    ),
                    _react2.default.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '2',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '33' + (commnetType == 2 ? ';background:' + storeStyle.theme : '')),
                        className: 'comPage-comment-label ' + (commnetType == 2 ? 'active' : '')
                      },
                      '\u4E2D\u8BC4 (',
                      _react2.default.createElement(
                        'label',
                        { className: 'comPage-neutral-comment' },
                        commentNums[2]
                      ),
                      ')'
                    ),
                    _react2.default.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '3',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '33' + (commnetType == 3 ? ';background:' + storeStyle.theme : '')),
                        className: 'comPage-comment-label ' + (commnetType == 3 ? 'active' : '')
                      },
                      '\u5DEE\u8BC4 (',
                      _react2.default.createElement(
                        'label',
                        { className: 'comPage-negative-comment' },
                        commentNums[3]
                      ),
                      ')'
                    ),
                    _react2.default.createElement(
                      'label',
                      {
                        onClick: this.clickCommentLabel,
                        'data-type': '4',
                        style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme + '33' + (commnetType == 4 ? ';background:' + storeStyle.theme : '')),
                        className: 'comPage-comment-label ' + (commnetType == 4 ? 'active' : '')
                      },
                      '\u6709\u56FE (',
                      _react2.default.createElement(
                        'label',
                        { className: 'comPage-pic-comment' },
                        commentNums[4]
                      ),
                      ')'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'comPage-bottom-section',
                    hidden: displayComment
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'comPage-comment-list' },
                    commentArr.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'comPage-comment-item', key: index },
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement('img', {
                            className: 'comPage-comment-photo',
                            src: item.buyer_headimgurl
                          }),
                          _react2.default.createElement(
                            'span',
                            { className: 'comPage-comment-name' },
                            item.buyer_nickname
                          )
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'comPage-comment-date' },
                          item.add_time
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'comPage-comment-content' },
                          item.assess_info.content
                        ),
                        item.assess_info.has_img && _react2.default.createElement(
                          'div',
                          { className: 'comPage-comment-pics' },
                          item.assess_info.img_arr.map(function (imgSrc, index) {
                            return _react2.default.createElement('img', {
                              key: index,
                              src: imgSrc,
                              'data-src': imgSrc,
                              'data-srcarr': JSON.stringify(item.assess_info.img_arr),
                              onClick: _this3.clickPlusImages
                            });
                          })
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'no-comment', hidden: !displayComment },
                  '\u6682\u65E0\u8BC4\u8BBA'
                )
              )
            )
          )
        ),
        goodsInfo.detail_type == 2 && _react2.default.createElement(
          'div',
          { className: 'goods-detail-content styleTwo' },
          _react2.default.createElement(
            'div',
            { className: 'goods-header' },
            _react2.default.createElement(
              'div',
              { className: 'goods-title' },
              _react2.default.createElement('span', {
                className: 'ico-moon icon-seckill-alarm cover-icon-seckill-alarm',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
              }),
              goodsInfo.title
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-share' },
              _react2.default.createElement('div', { className: 'goods-price-line' }),
              _react2.default.createElement(
                'div',
                { className: 'goods-price' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'share-goods',
                    onClick: this.showQRCodeComponent
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-news-sharefriends' })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-coupon', onClick: this.toCouponList },
            _react2.default.createElement(
              'span',
              {
                className: 'styleTwo-btn',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme)
              },
              '\u4F18\u60E0\u5238'
            ),
            _react2.default.createElement(
              'span',
              null,
              '\u9886\u53D6\u4F18\u60E0\u5238'
            ),
            _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-freight' },
            _react2.default.createElement(
              'span',
              {
                className: 'styleTwo-btn',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme)
              },
              '\u8FD0\u8D39'
            ),
            _react2.default.createElement(
              'span',
              null,
              '运费' + (goodsInfo.express_fee || '包邮')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-freight' },
            _react2.default.createElement(
              'label',
              null,
              '\u53D6\u8D27\u65B9\u5F0F'
            ),
            _react2.default.createElement(
              'div',
              { className: 'address-pick-up' },
              goodsInfo.pick_up_type.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: item },
                  _react2.default.createElement('span', {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'ico-moon icon-goods-support-delivery suporrt'
                  }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item == 1 ? '快递' : item == 2 ? '同城' : item == 3 ? '自提' : '点餐'
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-comment', hidden: displayComment },
            _react2.default.createElement(
              'div',
              { className: 'comment-title' },
              _react2.default.createElement(
                'div',
                { className: 'goods-comment-title' },
                '用户怎么说 (' + (commentNums[0] || 0) + ')'
              ),
              _react2.default.createElement(
                'div',
                { className: 'go-to-comment', onClick: this.goToCommentPage },
                '\u67E5\u770B\u5168\u90E8'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'block-item' },
              _react2.default.createElement(
                _ScrollView.ScrollView,
                { className: 'comPage-comment-list', 'scroll-x': 'true' },
                commentArr.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'comPage-comment-item', key: index },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('img', {
                        className: 'comPage-comment-photo',
                        src: item.buyer_headimgurl
                      }),
                      _react2.default.createElement(
                        'span',
                        { className: 'comPage-comment-name' },
                        item.buyer_nickname
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'comPage-comment-content' },
                      item.assess_info.content
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-recommend' },
            _react2.default.createElement(
              'div',
              { className: 'recommend-header' },
              _react2.default.createElement('img', {
                src: goodsInfo.app_cover,
                className: 'store-picture'
              }),
              _react2.default.createElement(
                'div',
                { className: 'store-name' },
                goodsInfo.app_name
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'pull-right go-to-store',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: (0, _tools.convertLineStyleData)('padding: 30rpx;text-align:center;color:#b2b2b2;font-size:24rpx;') },
            _react2.default.createElement('div', { className: 'line' }),
            _react2.default.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align:middle;margin:0 4px;') },
              '\u7EE7\u7EED\u62D6\u52A8\uFF0C\u67E5\u770B\u5546\u54C1\u4FE1\u606F'
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-detail-section' },
            _react2.default.createElement(
              'div',
              { className: 'comment-title' },
              _react2.default.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('border-bottom: 1px solid #f4f4f4;padding-bottom:20rpx;') },
                '\u5546\u54C1\u8BE6\u60C5'
              )
            ),
            _react2.default.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g, '') } })
          ),
          !!goodsInfo.recommend_info.length && _react2.default.createElement(
            'div',
            { className: 'goods-recommend' },
            _react2.default.createElement(
              'div',
              { className: 'two-recommend' },
              '\u5E97\u94FA\u63A8\u8350'
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'recommend-content', 'scroll-x': 'true' },
              goodsInfo.recommend_info.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    className: 'recommend-goods',
                    key: item.form_data.id,
                    onClick: _this3.toRecommendGoodsDetail,
                    'data-id': item.form_data.id,
                    'data-goods-type': item.form_data.goods_type
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'width-fix-image' },
                    _react2.default.createElement('img', {
                      mode: 'widthFix',
                      src: item.form_data.cover
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'recommend-goods-title' },
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'recommend-goods-price' },
                    '¥' + item.form_data.price
                  )
                );
              })
            )
          )
        ),
        goodsInfo.detail_type == 2 && _react2.default.createElement(
          'div',
          { className: 'goods-bottom-two' },
          _react2.default.createElement(
            'div',
            { className: 'bottom-two-left' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('div', { className: 'ico-moon icon-service2' }),
              _react2.default.createElement(
                'div',
                null,
                '\u5BA2\u670D'
              )
            ),
            !franchiseeId && _react2.default.createElement(
              'div',
              { className: 'form-two-contain' },
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  'button',
                  { type: 'button', onClick: goodsInfo.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                  _react2.default.createElement('span', {
                    style: (0, _tools.convertLineStyleData)(goodsInfo.is_favorite == 1 ? 'color:' + storeStyle.theme : ''),
                    className: 'ico-moon icon-' + (goodsInfo.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites')
                  }),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u6536\u85CF'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { onClick: this.goToShoppingCart },
              _react2.default.createElement('span', { className: 'ico-moon icon-new-goods-shopping' }),
              _react2.default.createElement(
                'div',
                null,
                '\u8D2D\u7269\u8F66'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom-two-right' },
            goodsInfo.seckill_progress != 100 && goodsInfo.seckill_start_state != 2 && _react2.default.createElement(
              'label',
              {
                className: 'add-to-shoppingCart',
                style: (0, _tools.convertLineStyleData)('border-color:' + storeStyle.theme + ';color:' + storeStyle.theme),
                onClick: this.showAddToShoppingCart
              },
              '\u52A0\u5165\u8D2D\u7269\u8F66'
            ),
            goodsInfo.seckill_progress != 100 && goodsInfo.seckill_start_state == 1 && _react2.default.createElement(
              'label',
              {
                className: 'buy-goods-directly',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                onClick: this.showBuyDirectly
              },
              '\u7ACB\u5373\u8D2D\u4E70'
            ),
            goodsInfo.seckill_start_state == 0 && goodsInfo.is_seckill_activity_care == 0 && _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'form-button',
                  'data-goods': JSON.stringify(goodsInfo),
                  'data-is_deleted': '0',
                  onClick: this.formSubmitRemind },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'buy-goods-directly',
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                  },
                  '\u8BBE\u7F6E\u63D0\u9192'
                )
              )
            ),
            goodsInfo.seckill_start_state == 0 && goodsInfo.is_seckill_activity_care == 1 && _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  className: 'form-button',
                  onClick: this.formSubmitRemind,
                  'data-goods': JSON.stringify(goodsInfo),
                  'data-is_deleted': '1' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'buy-goods-directly',
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                  },
                  '\u53D6\u6D88\u63D0\u9192'
                )
              )
            ),
            goodsInfo.seckill_progress == 100 && goodsInfo.seckill_start_state == 1 && _react2.default.createElement(
              'label',
              { className: 'buy-goods-directly buy-goods-directly-over' },
              '\u5546\u54C1\u5DF2\u62A2\u5149'
            ),
            goodsInfo.seckill_start_state == 2 && _react2.default.createElement(
              'label',
              { className: 'buy-goods-directly buy-goods-directly-over' },
              '\u6D3B\u52A8\u5DF2\u7ED3\u675F'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          {
            id: 'payDialog',
            className: 'page-dialog-wrap',
            hidden: addToShoppingCartHidden
          },
          _react2.default.createElement(
            'div',
            { className: 'page-bottom-dialog' },
            _react2.default.createElement(
              'div',
              {
                className: 'pay-close-dialog page-dialog-close',
                onClick: this.hiddeAddToShoppingCart
              },
              _react2.default.createElement('span', { className: 'ico-moon icon-closes' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'dialog-goods-header' },
              _react2.default.createElement(
                'div',
                { className: 'thumb' },
                _react2.default.createElement(
                  'div',
                  { className: 'thumb-wrap' },
                  _react2.default.createElement('img', {
                    'data-src': selectModelInfo.imgurl || goodsInfo.cover,
                    onClick: this.clickPlusImages,
                    className: 'pay-goods-cover',
                    src: selectModelInfo.imgurl || goodsInfo.cover
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'pay-goods-baseinfo' },
                _react2.default.createElement(
                  'div',
                  { className: 'pay-goods-price' },
                  _react2.default.createElement(
                    'div',
                    { className: 'pay-current-price' },
                    _react2.default.createElement(
                      'span',
                      (0, _defineProperty3.default)({
                        style: (0, _tools.convertLineStyleData)('font-size:28rpx;')
                      }, 'style', (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)),
                      '¥' + selectModelInfo.price
                    ),
                    isShowVirtualPrice && selectModelInfo.virtualPrice != 0 && _react2.default.createElement(
                      'span',
                      { className: 'virtualPrice' },
                      '¥' + selectModelInfo.virtualPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pay-goods-stock' },
                  '库存 ' + selectModelInfo.stock
                ),
                selectModelInfo.models_text && _react2.default.createElement(
                  'div',
                  { className: 'pay-checked-text clearfix' },
                  '已选：' + selectModelInfo.models_text
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'payDialog-content' },
              _react2.default.createElement(
                'div',
                {
                  className: 'pay-goods-models',
                  hidden: !(goodsInfo.model_items && goodsInfo.model_items.length)
                },
                goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                  return _react2.default.createElement(
                    'div',
                    { key: modelIndex },
                    _react2.default.createElement(
                      'span',
                      { className: 'model-title' },
                      model.name
                    ),
                    _react2.default.createElement(
                      'label',
                      { className: 'pills-list' },
                      model.subModelName.map(function (name, index) {
                        return _react2.default.createElement(
                          'label',
                          {
                            key: index,
                            'data-model-index': modelIndex,
                            'data-submodel-index': index,
                            className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                            'data-submodel-id': model.subModelId[index],
                            onClick: _this3.selectSubModel,
                            style: (0, _tools.convertLineStyleData)(selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'background:' + storeStyle.theme : '')
                          },
                          name
                        );
                      })
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'payDialog-buy-num',
                  style: (0, _tools.convertLineStyleData)('padding-left:10px;padding-right:10px;')
                },
                _react2.default.createElement(
                  'div',
                  { className: 'clearfix' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8D2D\u4E70\u6570\u91CF'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'buy-limit' },
                    '(限购' + goodsInfo.seckill_buy_limit + '件)'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'pull-right' },
                    _react2.default.createElement(
                      'div',
                      { className: 'quantity pull-left' },
                      _react2.default.createElement('label', {
                        className: 'minus ' + (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                      }),
                      _react2.default.createElement('input', (_React$createElement2 = {
                        className: 'pay-buy-count',
                        type: 'number'
                      }, (0, _defineProperty3.default)(_React$createElement2, 'className', 'txt'), (0, _defineProperty3.default)(_React$createElement2, 'value', selectModelInfo.buyCount), (0, _defineProperty3.default)(_React$createElement2, 'onChange', this.inputBuyCount), _React$createElement2)),
                      _react2.default.createElement('label', {
                        className: 'plus ' + (selectModelInfo.buyCount >= selectModelInfo.stock || selectModelInfo.buyCount >= goodsInfo.seckill_buy_limit ? 'disabled' : '')
                      }),
                      _react2.default.createElement('div', {
                        className: 'response-area response-area-minus',
                        onClick: this.clickMinusButton
                      }),
                      _react2.default.createElement('div', {
                        className: 'response-area response-area-plus',
                        onClick: this.clickPlusButton
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'dialog-bottom' },
              _react2.default.createElement(
                'div',
                { hidden: ifAddToShoppingCart },
                _react2.default.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                    className: 'btn-orange pay-buy-next',
                    onClick: this.buyDirectlyNextStep
                  },
                  '\u4E0B\u4E00\u6B65'
                )
              ),
              _react2.default.createElement(
                'div',
                { hidden: !ifAddToShoppingCart },
                _react2.default.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                    className: 'pay-add-to-shoppingcart',
                    onClick: this.sureAddToShoppingCart
                  },
                  '\u52A0\u5165\u8D2D\u7269\u8F66'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return SeckillDetail;
}(_OfficialPage3.default);

exports.default = SeckillDetail;

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponListPage = function (_OfficialPage) {
  (0, _inherits3.default)(CouponListPage, _OfficialPage);

  function CouponListPage(props) {
    (0, _classCallCheck3.default)(this, CouponListPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponListPage.__proto__ || Object.getPrototypeOf(CouponListPage)).call(this, props));

    _this.state = {
      topNavBarData: {
        isDefault: 0,
        title: '优惠券列表'
      },
      franchiseeId: '',
      franchiseeInfo: '',
      couponList: []
    };

    _this.turnToCouponDetail = function (e) {
      var id = e.currentTarget.dataset.id;
      _app.appMethod.turnToPage('/pages/couponDetail/couponDetail?detail=' + id + '&franchisee=' + _this.data.franchiseeId);
    };

    document.title = '优惠券列表';
    return _this;
  }

  (0, _createClass3.default)(CouponListPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchiseeId = options.franchisee,
          that = this;
      this.setData({
        franchiseeId: franchiseeId
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAllShopCouponList',
        data: {
          sub_app_id: franchiseeId,
          parent_app_id: _app.appMethod.getAppId(),
          page: -1
        },
        success: function success(res) {
          that.setData({
            couponList: res.data || []
          });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var couponList = this.state.couponList;

      return React.createElement(
        'div',
        { className: 'official-page coupon-list-page' },
        React.createElement(_TopNav.TopNav, { title: '\u4F18\u60E0\u5238\u5217\u8868' }),
        React.createElement(
          'div',
          { className: 'goods-coupon-list page' },
          React.createElement(
            'div',
            { className: 'franchisee-goods-coupon-container' },
            couponList.map(function (item, index) {
              return React.createElement(
                'div',
                {
                  className: 'coupon_ticket',
                  key: index,
                  'data-id': item.id,
                  onClick: _this2.turnToCouponDetail
                },
                item.type == 0 ? React.createElement(
                  'div',
                  { className: 'ticket-wrap' },
                  React.createElement(
                    'div',
                    { className: 'price' },
                    '\xA5',
                    React.createElement(
                      'span',
                      null,
                      item.value
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon_right' },
                    React.createElement(
                      'div',
                      { className: 'coupon_name' },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      null,
                      '消费满' + item.condition + '元减' + item.value
                    ),
                    React.createElement(
                      'div',
                      { className: 'coupon-time' },
                      (item.expire == '-1' ? item.start_use_date + '至' + item.end_use_date : item.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (item.react > 0 ? item.react + '天后' : '当天') + '生效，有效期' + item.expire + '天') + ' ' + (item.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (item.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + item.start_use_time + '-' + item.end_use_time
                    )
                  )
                ) : item.type == 1 ? React.createElement(
                  'div',
                  { className: 'ticket-wrap' },
                  React.createElement(
                    'div',
                    { className: 'price' },
                    React.createElement(
                      'span',
                      null,
                      item.value + '折'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon_right' },
                    React.createElement(
                      'div',
                      { className: 'coupon_name' },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      null,
                      '打' + item.value + '折优惠'
                    ),
                    React.createElement(
                      'div',
                      { className: 'coupon-time' },
                      (item.expire == '-1' ? item.start_use_date + '至' + item.end_use_date : item.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (item.react > 0 ? item.react + '天后' : '当天') + '生效，有效期' + item.expire + '天') + ' ' + (item.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (item.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + item.start_use_time + '-' + item.end_use_time
                    )
                  )
                ) : item.type == 2 && React.createElement(
                  'div',
                  { className: 'ticket-wrap' },
                  React.createElement(
                    'div',
                    { className: 'price' },
                    '\xA5',
                    React.createElement(
                      Span,
                      null,
                      item.value
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon_right' },
                    React.createElement(
                      'div',
                      { className: 'coupon_name' },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      null,
                      '可抵扣' + item.value + '元'
                    ),
                    React.createElement(
                      'div',
                      { className: 'coupon-time' },
                      (item.expire == '-1' ? item.start_use_date + '至' + item.end_use_date : item.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (item.react > 0 ? item.react + '天后' : '当天') + '生效，有效期' + item.expire + '天') + ' ' + (item.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (item.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + item.start_use_time + '-' + item.end_use_time
                    )
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return CouponListPage;
}(_OfficialPage3.default);

exports.default = CouponListPage;

/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(469);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponGoodsListPage = function (_OfficialPage) {
  (0, _inherits3.default)(CouponGoodsListPage, _OfficialPage);

  function CouponGoodsListPage(props) {
    (0, _classCallCheck3.default)(this, CouponGoodsListPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponGoodsListPage.__proto__ || Object.getPrototypeOf(CouponGoodsListPage)).call(this, props));

    _this.state = {
      param: {
        coupon_id: '',
        page: 1,
        page_size: 10
      },
      isLoading: false,
      noMore: false,
      goodsList: []
    };

    _this.getGoodsList = function () {
      var that = _this;
      if (that.data.noMore || that.data.isLoading) {
        return;
      }
      that.setData({ isLoading: true });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/getCouponConditionGoods',
        method: 'post',
        data: that.data.param,
        success: function success(res) {
          if (res.status == 0) {
            var newData = {},
                goodsList = that.data.goodsList,
                param = that.data.param;
            if (param.page > 1) {
              goodsList = goodsList.concat(res.data);
            } else {
              goodsList = res.data;
            }
            if (res.is_more == 0) {
              newData.noMore = true;
            }
            param.page = res.current_page + 1;
            newData.goodsList = goodsList;
            newData.param = param;
            newData.isLoading = false;
            that.setData(newData);
          } else {
            _app.appMethod.showModal({ content: res.data });
          }
        },
        fail: function fail(res) {
          that.setData({ isLoading: false });
        }
      });
    };

    _this.turnToGoodsDetail = function (event) {
      var appId = _app.appMethod.globalData.appId,
          dataset = event.currentTarget.dataset,
          id = dataset.id,
          goodsType = dataset.goodsType,
          group = dataset.group,
          subAppId = dataset.subAppId,
          isSeckill = dataset.isSeckill == 1,
          isSelf = appId === subAppId;
      if (group && group == 1) {
        if (isSelf) {
          _app.appMethod.turnToPage('/groupGoodsDetail?detail=' + id);
        } else {
          _app.appMethod.turnToPage('/groupGoodsDetail?detail=' + id + '&franchisee=' + subAppId);
        }
        return;
      }
      switch (+goodsType) {
        case 0:
        case 1:
          var url = '/goodsDetail?detail=' + id;
          if (isSeckill) {
            url += '&goodsType=seckill';
          }
          if (!isSelf) {
            url += '&franchisee=' + subAppId;
          }
          _app.appMethod.turnToPage(url);
          break;
        case 3:
          if (isSelf) {
            _app.appMethod.turnToPage('/toStoreDetail?detail=' + id);
          } else {
            _app.appMethod.turnToPage('/toStoreDetail?detail=' + id + '&franchisee=' + subAppId);
          }
          break;
      }
    };

    document.title = '可用商品';
    return _this;
  }

  (0, _createClass3.default)(CouponGoodsListPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      if (options.franchisee) {
        that.setData({
          'param.coupon_id': options.detail,
          'param.sub_app_id': options.franchisee
        });
      } else {
        that.setData({ 'param.coupon_id': options.detail });
      }
      that.getGoodsList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          goodsList = _state.goodsList,
          noMore = _state.noMore;

      return React.createElement(
        'div',
        { className: 'official-page coupon-goods-list-page' },
        React.createElement(_TopNav.TopNav, { title: '\u53EF\u7528\u5546\u54C1' }),
        React.createElement(
          _ScrollView.ScrollView,
          {
            id: 'couponGoodsList-wrap',
            'scroll-y': 'true',
            bindscrolltolower: this.getGoodsList,
            'lower-threshold': '50'
          },
          React.createElement(
            'div',
            { className: 'couponGoodsList-ul' },
            goodsList.map(function (goodsItem, goodsIdx) {
              return React.createElement(
                'div',
                {
                  className: 'couponGoods-li',
                  key: goodsItem.id,
                  'data-id': goodsItem.id,
                  'data-goods-type': goodsItem.goods_type,
                  'data-group': goodsItem.is_group_buy,
                  'data-groupid': goodsItem.group_buy_activity_id,
                  'data-sub-app-id': goodsItem.app_id,
                  onClick: _this2.turnToGoodsDetail,
                  'data-is-seckill': goodsItem.is_seckill
                },
                React.createElement(
                  'div',
                  { className: 'couponGoods-logo' },
                  React.createElement('img', { src: goodsItem.cover, mode: 'aspectFill', alt: '' })
                ),
                React.createElement(
                  'div',
                  { className: 'couponGoods-text' },
                  React.createElement(
                    'div',
                    { className: 'couponGoods-name' },
                    goodsItem.title
                  ),
                  React.createElement(
                    'div',
                    { className: 'couponGoods-price' },
                    '¥' + goodsItem.price
                  )
                )
              );
            }),
            noMore && React.createElement(
              'div',
              { className: 'no-more' },
              '\u6CA1\u6709\u66F4\u591A\u4E86'
            )
          )
        )
      );
    }
  }]);
  return CouponGoodsListPage;
}(_OfficialPage3.default);

exports.default = CouponGoodsListPage;

/***/ }),
/* 469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(471);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponReceiveListPage = function (_OfficialPage) {
  (0, _inherits3.default)(CouponReceiveListPage, _OfficialPage);

  function CouponReceiveListPage(props) {
    (0, _classCallCheck3.default)(this, CouponReceiveListPage);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CouponReceiveListPage.__proto__ || Object.getPrototypeOf(CouponReceiveListPage)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '优惠券领取列表'
      },
      couponList: [],
      receiveSuccess: 0, // 领取成功弹窗是否显示
      receiveCount: 0, // 已领取数量
      receiveLimitNum: 0, // 领取限制数量
      userInfo: {},
      couponsAndDiscount: {},
      totalUser: 0,
      category: [],
      currentCate: -1, // 默认选中全部分类 
      latitude: '',
      longitude: '',
      isParentShop: false,
      headquartersId: '',
      recvCouponPopFranchisee: false,
      recvCouponPopAppId: '',
      recvCouponPopAppMode: '',
      couponNoMore: false,
      recving: false // 领取中
    };

    _this2.getCoupons = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getCoupons',
        data: {
          in_use_date: 1, //0是全部，1是只显示可领取的优惠券
          in_show_list: 1, //0:不在列表内 1:在列表内
          enable_status: 1, //0:下架 1:上架
          stock: 1, //0:没有库存的 1:有库存的
          page: -1
        },
        hideLoading: true,
        success: function success(res) {
          _this.setData({
            couponList: res.data
          });
        }
      });
    };

    _this2.gotoCouponDetail = function (event) {
      var couponId = event.currentTarget.dataset.couponId;
      var appid = event.currentTarget.dataset.appid;
      var franisee = '';
      if (_this2.data.headquartersId != appid && _this2.data.isParentShop) {
        franisee = '&franchisee=' + appid;
      }
      var url = '/pages/couponDetail/couponDetail?detail=' + couponId + franisee;
      _app.appMethod.turnToPage(url, false);
    };

    _this2.formSubmit = function (event) {
      var _this = _this2,
          couponId = event.currentTarget.dataset.couponId,
          formId = event.detail.formId,
          index = event.currentTarget.dataset.index;
      if (_this2.data.recving) {
        return;
      }
      _this2.setRecving(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/recvCoupon',
        data: {
          coupon_id: couponId,
          form_id: formId
        },
        hideLoading: true,
        success: function success(res) {
          var newdata = {};
          if (res.data.is_already_recv == 1) {
            newdata['couponList[' + index + '].recv_status'] = 0;
          }
          newdata['receiveSuccess'] = 1;
          newdata['receiveCount'] = res.data.recv_count;
          newdata['receiveLimitNum'] = res.data.limit_num;
          _this.setData(newdata);
        },
        complete: function complete() {
          _this.setRecving(false);
        }
      });
    };

    _this2.setRecving = function (bool) {
      _this2.setData({
        recving: bool
      });
    };

    _this2.formSubmitFranchisee = function (event) {
      var that = _this2,
          dataset = event.currentTarget.dataset,
          index = dataset.index,
          formId = event.detail.formId,
          item = that.data.couponList[index],
          couponId = item.id,
          appid = item.app_id,
          mode = item.mode_id;
      if (_this2.data.recving) {
        return;
      }
      _this2.setRecving(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/recvCoupon',
        data: {
          coupon_id: couponId,
          form_id: formId,
          sub_app_id: appid
        },
        hideLoading: true,
        success: function success(res) {
          var newdata = {};
          if (res.data.is_already_recv == 1) {
            newdata['couponList[' + index + '].recv_status'] = 0;
          }
          newdata['recvCouponPopFranchisee'] = true;
          newdata['recvCouponPopAppId'] = appid;
          newdata['recvCouponPopAppMode'] = mode;
          newdata['couponsAndDiscount.coupons'] = that.data.couponsAndDiscount.coupons + 1;
          that.setData(newdata);
        },
        complete: function complete() {
          that.setRecving(false);
        }
      });
    };

    _this2.gotoCouponList = function () {
      var url = '/eCommerce/pages/couponList/couponList';
      _app.appMethod.turnToPage(url, false);
    };

    _this2.hideToast = function () {
      _this2.setData({
        receiveSuccess: 0,
        receiveCount: 0,
        receiveLimitNum: 0
      });
    };

    _this2.stopPropagation = function () {};

    _this2.getDiscountCut = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCouponsAndDiscountCutTotalPrice',
        data: {},
        hideLoading: true,
        success: function success(res) {
          that.setData({
            couponsAndDiscount: res.data
          });
        }
      });
    };

    _this2.getTotalUser = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetTotalUser',
        data: {},
        hideLoading: true,
        success: function success(res) {
          that.setData({
            totalUser: res.data
          });
        }
      });
    };

    _this2.getCategoryForCoupon = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCategoryForCoupon',
        data: {},
        hideLoading: true,
        success: function success(res) {
          that.setData({
            category: res.data
          });
        }
      });
    };

    _this2.getLocation = function () {
      var that = _this2;
      _app.appMethod.getLocation({
        success: function success(res) {
          that.setData({
            longitude: res.longitude,
            latitude: res.latitude
          });
          that.getAllShopCouponList();
        },
        fail: function fail() {
          that.getAllShopCouponList();
        }
      });
    };

    _this2.allCouponData = {
      page: 1,
      loading: false,
      nomore: false
    };

    _this2.getAllShopCouponList = function () {
      var that = _this2;
      if (that.allCouponData.loading || that.allCouponData.nomore) {
        return;
      }
      that.allCouponData.loading = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAllShopCouponList',
        data: {
          parent_app_id: _app.appMethod.globalData.appId,
          latitude: that.data.latitude,
          longitude: that.data.longitude,
          industry_type: that.data.currentCate,
          page: that.allCouponData.page,
          page_size: 10
        },
        success: function success(res) {
          var oldList = that.data.couponList;
          var data = res.data;
          if (that.allCouponData.page == 1) {
            oldList = [];
          }
          for (var index in data) {
            var distance = data[index].distance;
            data[index].distance = _util2.default.formatDistance(distance);
          }
          that.setData({
            couponList: oldList.concat(data),
            couponNoMore: res.is_more == 0
          });
          that.allCouponData.page++;
          that.allCouponData.nomore = res.is_more == 0;
        },
        complete: function complete() {
          that.allCouponData.loading = false;
        }
      });
    };

    _this2.gotoShop = function (e) {
      var appid = e.currentTarget.dataset.appid;
      var mode = e.currentTarget.dataset.mode;
      var chainId = _app.appMethod.getChainId();
      if (_this2.data.headquartersId == appid || chainId == appid) {
        var home = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({
          url: '/pages/' + home + '/' + home
        });
      } else {
        var param = {};
        param.detail = appid;
        _app.appMethod.goToFranchisee(mode, param);
      }
    };

    _this2.closeRecvCouponPopFranchisee = function () {
      _this2.setData({
        recvCouponPopFranchisee: false
      });
    };

    _this2.clickLoading = false;

    _this2.changeTab = function (e) {
      var id = e.currentTarget.dataset.id;
      if (id == _this2.data.currentCate) {
        return;
      }
      if (_this2.clickLoading) {
        _app.appMethod.showModal({ content: '请勿频繁点击分类' });
        return;
      }
      _this2.clickLoading = true;
      setTimeout(function () {
        _this2.clickLoading = false;
      }, 500);
      _this2.setData({
        currentCate: +id,
        couponNoMore: false
      });
      _this2.allCouponData.page = 1;
      _this2.allCouponData.nomore = false;
      _this2.allCouponData.loading = false;
      _this2.getAllShopCouponList();
    };

    _this2.onReachBottom = function (e) {
      var that = _this2;
      if (that.data.isParentShop) {
        that.getAllShopCouponList();
      }
    };

    document.title = '优惠券领取列表';
    return _this2;
  }

  (0, _createClass3.default)(CouponReceiveListPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var that = this;
      var isParent = _app.appMethod.globalData.hasFranchiseeList;
      that.setData({
        headquartersId: _app.appMethod.globalData.appId,
        isParentShop: isParent
      });
      if (isParent) {
        if (_app.appMethod.isLogin()) {
          that.setData({
            userInfo: _app.appMethod.globalData.userInfo
          });
        } else {
          _app.appMethod.goLogin({
            success: function success() {
              that.setData({
                userInfo: _app.appMethod.globalData.userInfo
              });
            }
          });
        }
        that.getLocation();
        that.getCategoryForCoupon();
        that.getDiscountCut();
        that.getTotalUser();
      } else {
        that.getCoupons();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          userInfo = _state.userInfo,
          totalUser = _state.totalUser,
          couponsAndDiscount = _state.couponsAndDiscount,
          currentCate = _state.currentCate,
          category = _state.category,
          couponList = _state.couponList,
          couponNoMore = _state.couponNoMore,
          isParentShop = _state.isParentShop,
          receiveSuccess = _state.receiveSuccess,
          receiveCount = _state.receiveCount,
          receiveLimitNum = _state.receiveLimitNum,
          recvCouponPopAppId = _state.recvCouponPopAppId,
          recvCouponPopAppMode = _state.recvCouponPopAppMode,
          recvCouponPopFranchisee = _state.recvCouponPopFranchisee;

      return React.createElement(
        'div',
        { className: 'official-page coupon-receive-list-page' },
        React.createElement(_TopNav.TopNav, { title: '\u4F18\u60E0\u5238\u9886\u53D6\u5217\u8868' }),
        React.createElement(
          'div',
          {
            id: 'coupon-receive-list-page',
            className: 'coupon-receive-list-page'
          },
          isParentShop ? React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'coupon-receive-head' },
              React.createElement(
                'div',
                { className: 'clearfix' },
                React.createElement(
                  'div',
                  { className: 'coupon-receive-user' },
                  React.createElement(
                    'div',
                    { className: 'coupon-receive-cover' },
                    React.createElement('img', {
                      src: userInfo.cover_thumb,
                      mode: 'aspectFill'
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon-receive-nickname' },
                    userInfo.nickname
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'coupon-receive-competitor' },
                  totalUser + '人正在抢'
                )
              ),
              React.createElement(
                'div',
                { className: 'coupon-pft-wrap' },
                React.createElement(
                  'div',
                  { className: 'coupon-pft-item' },
                  React.createElement(
                    'div',
                    {
                      className: 'coupon-pft-num',
                      onClick: this.gotoCouponList
                    },
                    couponsAndDiscount.coupons || 0
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon-pft-text' },
                    '\u5DF2\u62A2\u4F18\u60E0\u5238\uFF08\u5F20\uFF09'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'coupon-pft-item' },
                  React.createElement(
                    'div',
                    { className: 'coupon-pft-num' },
                    couponsAndDiscount.cut_total_price || 0
                  ),
                  React.createElement(
                    'div',
                    { className: 'coupon-pft-text' },
                    '\u5DF2\u8282\u7701\uFF08\u5143\uFF09'
                  )
                )
              )
            ),
            React.createElement(
              _ScrollView.ScrollView,
              { 'scroll-x': 'true', className: 'coupon-cate' },
              React.createElement(
                'div',
                {
                  className: 'coupon-cate-item ' + (currentCate === -1 ? 'active' : ''),
                  'data-id': -1,
                  onClick: this.changeTab
                },
                '\u5168\u90E8'
              ),
              Object.values(category).map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'coupon-cate-item ' + (currentCate === index ? 'active' : ''),
                    key: index,
                    'data-id': index,
                    onClick: _this3.changeTab
                  },
                  item
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'ticket-list' },
              couponList.map(function (coupon, index) {
                return React.createElement(
                  React.Fragment,
                  { key: coupon.id },
                  React.createElement(
                    'div',
                    {
                      className: 'ticket franchisee-ticket',
                      onClick: _this3.gotoCouponDetail,
                      'data-coupon-id': coupon.id,
                      'data-appid': coupon.app_id
                    },
                    React.createElement(
                      'div',
                      { className: 'top-section' },
                      React.createElement(
                        'div',
                        { className: 'coupon-franchisee' },
                        React.createElement('img', {
                          className: 'coupon-franchisee-logo',
                          mode: 'aspectFill',
                          src: coupon.logo
                        }),
                        React.createElement(
                          'div',
                          {
                            className: 'coupon-franchisee-name',
                            onClick: _this3.gotoShop,
                            'data-mode': coupon.mode_id,
                            'data-appid': coupon.app_id
                          },
                          coupon.name,
                          React.createElement('label', { className: 'ico-moon icon-rightarrow' })
                        ),
                        React.createElement(
                          'div',
                          { className: 'coupon-franchisee-distance' },
                          '附近' + coupon.distance
                        )
                      ),
                      coupon.type == 0 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '满' + coupon.condition + '可用'
                          )
                        )
                      ) : coupon.type == 1 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            coupon.value,
                            React.createElement(
                              'label',
                              null,
                              '\u6298'
                            )
                          ),
                          coupon.extra_goods == 'null' ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5168\u90E8\u5546\u54C1\u53EF\u4EAB\u4F18\u60E0'
                          ) : React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u90E8\u5206\u5546\u54C1\u53EF\u4EAB\u4F18\u60E0'
                          )
                        )
                      ) : coupon.type == 2 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5546\u54C1\u4EE3\u91D1\u5238'
                          )
                        )
                      ) : coupon.type == 3 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            '\u5151\u6362\u5238'
                          ),
                          coupon.extra_condition == '' ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '直接兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.price ? React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '消费满' + coupon.extra_condition.price + '元可兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.goods_id && React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '购买' + coupon.condition_goods_info.title + '可兑换' + coupon.coupon_goods_info.title
                          )
                        )
                      ) : coupon.type == 4 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            React.createElement(
                              'label',
                              null,
                              '\xA5'
                            ),
                            coupon.value
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '\u5546\u54C1\u50A8\u503C\u91D1'
                          )
                        )
                      ) : coupon.type == 5 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            '\u901A\u7528\u5238'
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            coupon.extra_condition
                          )
                        )
                      ) : coupon.type == 6 && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info-franchisee' },
                          React.createElement(
                            'div',
                            { className: 'coupon-value' },
                            '\u6B21\u6570\u5238'
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '可兑换' + coupon.limit_num + '次'
                          )
                        )
                      ),
                      React.createElement(
                        'form',
                        {
                          onSubmit: _this3.formSubmitFranchisee,
                          'data-index': index
                        },
                        coupon.recv_status == 1 ? React.createElement(
                          'button',
                          {
                            className: 'receive-btn',
                            onClick: _this3.stopPropagation
                          },
                          '\u9886\u53D6'
                        ) : coupon.recv_status == 0 && React.createElement(
                          'div',
                          {
                            className: 'receive-btn',
                            onClick: _this3.gotoShop,
                            'data-mode': coupon.mode_id,
                            'data-appid': coupon.app_id
                          },
                          '\u53BB\u4F7F\u7528'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'bottom-section' },
                      React.createElement(
                        'div',
                        null,
                        '有效期 ' + (coupon.expire == '-1' ? coupon.start_use_date + '至' + coupon.end_use_date : coupon.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (coupon.react > 0 ? coupon.react + '天后' : '当天') + '生效，有效期' + coupon.expire + '天') + ' ' + (coupon.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (coupon.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + coupon.start_use_time + '-' + coupon.end_use_time
                      )
                    )
                  )
                );
              })
            ),
            couponNoMore && React.createElement(
              'div',
              { className: 'coupon-no-more' },
              '\u6CA1\u6709\u66F4\u591A\u4E86'
            )
          ) : React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'ticket-list' },
              couponList.map(function (coupon, index) {
                return React.createElement(
                  React.Fragment,
                  { key: coupon.id },
                  React.createElement(
                    'div',
                    {
                      className: 'ticket ' + (coupon.recv_status == 1 ? '' : 'has-receive'),
                      onClick: _this3.gotoCouponDetail,
                      'data-coupon-id': coupon.id
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'top-section',
                        style: (0, _tools.convertLineStyleData)('border-color: ' + coupon.list_color)
                      },
                      coupon.type == 0 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件：满' + coupon.condition + '元，减' + coupon.value + '元'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u51CF'
                          )
                        )
                      ) : coupon.type == 1 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件: 打' + coupon.value + '折'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u6298'
                          )
                        )
                      ) : coupon.type == 2 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件：可抵扣' + coupon.value + '元'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u4EE3'
                          )
                        )
                      ) : coupon.type == 3 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          coupon.extra_condition == '' ? React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件：直接兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.price ? React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件：消费满' + coupon.extra_condition.price + '元可兑换' + coupon.coupon_goods_info.title
                          ) : coupon.extra_condition.goods_id && React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件：购买' + coupon.condition_goods_info.title + '可兑换' + coupon.coupon_goods_info.title
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u5151'
                          )
                        )
                      ) : coupon.type == 4 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件: 储值金可充值' + coupon.value + '元'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u50A8'
                          )
                        )
                      ) : coupon.type == 5 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'use-condition' },
                            '使用条件: ' + coupon.extra_condition
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u901A'
                          )
                        )
                      ) : coupon.type == 6 && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'detail-info' },
                          React.createElement(
                            'div',
                            { className: 'name' },
                            coupon.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'coupon-condition' },
                            '使用条件: 可使用' + coupon.value + '次'
                          )
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'background-word-area',
                            style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                          },
                          React.createElement('div', {
                            className: 'background-circle',
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          }),
                          React.createElement(
                            'div',
                            { className: 'background-word' },
                            '\u6B21'
                          )
                        )
                      ),
                      React.createElement(
                        'form',
                        {
                          onSubmit: _this3.formSubmit,
                          'data-coupon-id': coupon.id,
                          'data-index': index
                        },
                        coupon.recv_status == 1 ? React.createElement(
                          'button',
                          {
                            className: 'receive-btn',
                            onClick: _this3.stopPropagation,
                            style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                          },
                          '\u9886\u53D6'
                        ) : coupon.recv_status == 0 && React.createElement(
                          'div',
                          { className: 'receive-btn' },
                          '\u5DF2\u9886\u53D6'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'bottom-section' },
                      React.createElement(
                        'div',
                        null,
                        '有效期 ' + (coupon.expire == '-1' ? coupon.start_use_date + '至' + coupon.end_use_date : coupon.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (coupon.react > 0 ? coupon.react + '天后' : '当天') + '生效，有效期' + coupon.expire + '天') + ' ' + (coupon.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (coupon.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + coupon.start_use_time + '-' + coupon.end_use_time
                      )
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'goto-coupon-list' },
              React.createElement(
                'div',
                { onClick: this.gotoCouponList },
                '\u67E5\u770B\u6211\u7684\u4F18\u60E0\u5238>>>'
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : ''),
              onClick: this.hideToast
            },
            React.createElement(
              'div',
              { className: 'zc-toast' },
              React.createElement('span', { className: 'icon', type: 'success', size: '20' }),
              React.createElement(
                'div',
                { className: 'title' },
                '\u9886\u53D6\u6210\u529F!'
              ),
              React.createElement(
                'div',
                { className: 'content' },
                '已领' + receiveCount + '张，限领' + receiveLimitNum + '张'
              )
            )
          ),
          recvCouponPopFranchisee && React.createElement(
            'div',
            { className: 'pop-wrap' },
            React.createElement('div', {
              className: 'pop-bg',
              onClick: this.closeRecvCouponPopFranchisee
            }),
            React.createElement(
              'div',
              { className: 'pop-inner' },
              React.createElement('label', {
                className: 'pop-close ico-moon icon-closes',
                onClick: this.closeRecvCouponPopFranchisee
              }),
              React.createElement(
                'div',
                { className: 'recvCoupon-success' },
                React.createElement('span', { type: 'success', size: '14', color: '#FF7100' }),
                React.createElement(
                  'label',
                  null,
                  '\u606D\u559C\u9886\u53D6\u6210\u529F'
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'recvCoupon-pop-btn',
                  'data-appid': recvCouponPopAppId,
                  'data-mode': recvCouponPopAppMode,
                  onClick: this.gotoShop
                },
                '\u8FDB\u5E97\u8D2D\u7269\uFF0C\u7ACB\u4EAB\u4F18\u60E0'
              )
            )
          )
        )
      );
    }
  }]);
  return CouponReceiveListPage;
}(_OfficialPage3.default);

exports.default = CouponReceiveListPage;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(473);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VipCard = function (_OfficialPage) {
  (0, _inherits3.default)(VipCard, _OfficialPage);

  function VipCard(props) {
    (0, _classCallCheck3.default)(this, VipCard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VipCard.__proto__ || Object.getPrototypeOf(VipCard)).call(this, props));

    _this.state = {
      topNavBarData: {
        isDefault: 0,
        title: '会员卡'
      },
      appId: '',
      receiveCard: -1, // 默认不知道是否有领取
      cardDetail: {
        appName: '',
        logoUrl: '',
        duration: '',
        level: '',
        number: ''
      },
      vipRights: {
        freePostage: 0,
        discount: 0,
        giveCouponStr: '',
        integral: 0
      },
      vipNotice: {
        description: ''
      },
      vipPoints: {
        canUseIntegral: 0,
        totalIntegral: 0,
        consumeNum: 0
      },
      vipContact: {
        appName: '',
        phone: '无'
      },
      activeItem: '',
      vipInfo: {},
      isPaidVip: '0'
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPCardInfo',
        data: {
          app_id: that.data.franchiseeId,
          vip_id: that.data.vipId,
          is_paid_vip: that.data.isPaidVip
        },
        success: function success(res) {
          var cardBackground = '';
          var vip = res.data[0];
          if (parseInt(vip.background_type) == 0) {
            cardBackground = 'url(' + vip.background + ') 0% 0% / 100% 100%';
          } else {
            cardBackground = vip.background;
          }
          var giveCouponStr = '';
          for (var i = 0; i < vip.coupon_list.length; i++) {
            giveCouponStr = giveCouponStr + '免费赠送' + vip.coupon_list[i].num + '张' + vip.coupon_list[i].name + '的优惠券,';
          }
          var giveBirCouponStr = '';
          if (vip.birthday_coupon_list && vip.birthday_coupon_list.length) {
            var birthday_coupon_list = vip.birthday_coupon_list;
            for (var _i = 0; _i < birthday_coupon_list.length; _i++) {
              giveBirCouponStr = giveBirCouponStr + '免费赠送' + birthday_coupon_list[_i].num + '张' + birthday_coupon_list[_i].name + '的优惠券,';
            }
          }
          vip.description = vip.description ? vip.description.replace(/<br \/>/g, '\n') : vip.description;
          that.setData({
            vipInfo: vip,
            receiveCard: 1,
            'cardDetail.appName': vip.app_name,
            'cardDetail.logoUrl': vip.logo,
            'cardDetail.duration': vip.expired_time || '',
            'cardDetail.level': vip.title,
            'cardDetail.cardBackground': cardBackground,
            'cardDetail.number': vip.user_vip_id || '',
            'cardDetail.isShowVipid': vip.is_show_vipid || '',
            'vipRights.discount': vip.discount,
            'vipRights.giveCouponStr': giveCouponStr,
            'vipRights.giveBirCouponStr': giveBirCouponStr,
            'vipRights.integral': vip.integral,
            'vipRights.balance': vip.balance,
            'vipRights.freePostage': vip.is_free_postage,
            'vipNotice.description': vip.description,
            'vipPoints.canUseIntegral': vip.can_use_integral,
            'vipPoints.totalIntegral': vip.total_integral,
            'vipPoints.consumeNum': vip.consume_num,
            'vipContact.appName': vip.app_name,
            'vipContact.phone': vip.phone
          });
        }
      });
    };

    _this.getHeadquartersVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPInfo',
        data: {
          app_id: that.data.franchiseeId || '',
          is_all: 1
        },
        success: function success(res) {
          var cardBackground = '';
          if (parseInt(res.data.background_type) == 0) {
            cardBackground = 'url(' + res.data.background + ') 0% 0% / 100% 100%';
          } else {
            cardBackground = res.data.background;
          }
          var giveCouponStr = '';
          var giveBirCouponStr = '';
          if (res.data.is_vip != 0) {
            for (var i = 0; i < res.data.coupon_list.length; i++) {
              giveCouponStr = giveCouponStr + '免费赠送' + res.data.coupon_list[i].num + '张' + res.data.coupon_list[i].name + '的优惠券,';
            }
            if (res.data.birthday_coupon_list && res.data.birthday_coupon_list.length) {
              for (var _i2 = 0; _i2 < res.data.birthday_coupon_list.length; _i2++) {
                giveBirCouponStr = giveBirCouponStr + '免费赠送' + res.data.birthday_coupon_list[_i2].num + '张' + res.data.birthday_coupon_list[_i2].name + '的优惠券,';
              }
            }
          }
          res.data.description = res.data.description ? res.data.description.replace(/<br \/>/g, '\n') : res.data.description;
          that.setData({
            vipInfo: res.data,
            receiveCard: res.data.is_vip || 0,
            'cardDetail.appName': res.data.app_name,
            'cardDetail.logoUrl': res.data.logo,
            'cardDetail.duration': res.data.expire,
            'cardDetail.level': res.data.title,
            'cardDetail.cardBackground': cardBackground,
            'cardDetail.number': res.data.user_vip_id || '',
            'cardDetail.isShowVipid': res.data.is_show_vipid || '',
            'vipRights.discount': res.data.discount || '',
            'vipRights.giveCouponStr': giveCouponStr || '',
            'vipRights.giveBirCouponStr': giveBirCouponStr || '',
            'vipRights.integral': res.data.integral || '',
            'vipRights.balance': res.data.balance || '',
            'vipRights.freePostage': res.data.is_free_postage || '',
            'vipNotice.description': res.data.description || '',
            'vipPoints.canUseIntegral': res.data.can_use_integral || '',
            'vipPoints.totalIntegral': res.data.total_integral || '',
            'vipPoints.consumeNum': res.data.consume_num || '',
            'vipContact.appName': res.data.app_name || '',
            'vipContact.phone': res.data.phone || ''
          });
        }
      });
    };

    _this.showItemContent = function (event) {
      var that = _this;
      var _item = event.currentTarget.dataset.item;
      if (that.data.activeItem == _item) {
        _item = '';
      }
      that.setData({
        activeItem: _item
      });
    };

    _this.getVIPCardForUser = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPCardForUser',
        data: {
          parent_app_id: _app.appMethod.getAppId(),
          sub_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          _app.appMethod.showModal({
            content: '领取成功!'
          });
          that.setData({
            'vipInfo.is_owner': 1
          });
        },
        complete: function complete() {}
      });
    };

    document.title = '会员卡';
    return _this;
  }

  (0, _createClass3.default)(VipCard, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var vipId = options.detail || '';
      var franchiseeId = options.franchisee || '';
      var isPaidVip = options.is_paid_vip || '';
      this.setData({
        vipId: vipId,
        franchiseeId: franchiseeId,
        isPaidVip: isPaidVip
      });
      if (vipId) {
        this.getVipInfo();
      } else {
        this.getHeadquartersVipInfo();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          cardDetail = _state.cardDetail,
          activeItem = _state.activeItem,
          vipRights = _state.vipRights,
          vipNotice = _state.vipNotice,
          vipPoints = _state.vipPoints,
          vipContact = _state.vipContact,
          vipInfo = _state.vipInfo,
          receiveCard = _state.receiveCard;

      return React.createElement(
        'div',
        { className: 'official-page vip-card-page' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u5361' }),
        React.createElement(
          'div',
          { className: 'page', id: 'vipCard' },
          receiveCard == 1 ? React.createElement(
            'div',
            { className: 'yes-receive-card' },
            React.createElement(
              'div',
              { className: 'card-wrap' },
              React.createElement(
                'div',
                {
                  className: 'card',
                  style: (0, _tools.convertLineStyleData)('background: ' + cardDetail.cardBackground)
                },
                React.createElement('img', { className: 'logo', src: cardDetail.logoUrl }),
                React.createElement(
                  'div',
                  { className: 'title' },
                  cardDetail.appName
                ),
                React.createElement(
                  'div',
                  { className: 'level' },
                  cardDetail.level
                ),
                cardDetail.isShowVipid == 1 && cardDetail.number && React.createElement(
                  'div',
                  { className: 'number' },
                  'No.' + cardDetail.number
                ),
                cardDetail.duration == -1 ? React.createElement(
                  'div',
                  { className: 'duration' },
                  '\u6C38\u4E45\u6709\u6548'
                ) : React.createElement(
                  'div',
                  { className: 'duration' },
                  cardDetail.duration
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'card-content' },
              React.createElement(
                'div',
                { className: 'card-item' },
                React.createElement(
                  'div',
                  {
                    className: 'item-title ' + (activeItem == 'rights' ? 'active' : ''),
                    onClick: this.showItemContent,
                    'data-item': 'rights'
                  },
                  React.createElement(
                    'span',
                    null,
                    '\u4F1A\u5458\u6743\u76CA'
                  ),
                  React.createElement('label', { className: 'ico-moon icon-downarrow' })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'item-body vipCard-rights ' + (activeItem == 'rights' ? 'active' : '')
                  },
                  React.createElement(
                    'div',
                    { className: 'content' },
                    vipRights.discount != 0 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u6253\u6298'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u6240\u6709\u5546\u54C1\u4E00\u5F8B',
                        React.createElement(
                          'span',
                          null,
                          vipRights.discount
                        ),
                        '\u6298'
                      )
                    ),
                    vipRights.giveCouponStr != '' && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u4F18\u60E0\u5238'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        React.createElement(
                          'span',
                          null,
                          vipRights.giveCouponStr
                        ),
                        '\u8D2D\u4E70\u5546\u54C1\u65F6\u62B5\u7528'
                      )
                    ),
                    vipRights.giveBirCouponStr != '' && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u751F\u65E5\u4F18\u60E0\u5238'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        React.createElement(
                          'span',
                          null,
                          vipRights.giveBirCouponStr
                        ),
                        '\u8D2D\u4E70\u5546\u54C1\u65F6\u62B5\u7528'
                      )
                    ),
                    vipRights.integral != 0 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u79EF\u5206'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u6CE8\u518C\u6210\u529F\u5373\u8D60\u9001',
                        React.createElement(
                          'span',
                          null,
                          vipRights.integral
                        ),
                        '\u79EF\u5206'
                      )
                    ),
                    vipRights.balance && vipRights.balance != 0 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u50A8\u503C'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u6CE8\u518C\u6210\u529F\u5373\u8D60\u9001',
                        React.createElement(
                          'span',
                          null,
                          vipRights.balance
                        ),
                        '\u50A8\u503C'
                      )
                    ),
                    vipRights.freePostage == 1 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u5305\u90AE'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u6240\u6709\u5546\u54C1\u8D2D\u4E70\u540E\u7EDF\u7EDF\u5305\u90AE'
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'card-item' },
                React.createElement(
                  'div',
                  {
                    className: 'item-title ' + (activeItem == 'notice' ? 'active' : ''),
                    onClick: this.showItemContent,
                    'data-item': 'notice'
                  },
                  React.createElement(
                    'span',
                    null,
                    '\u4F7F\u7528\u987B\u77E5'
                  ),
                  React.createElement('label', { className: 'ico-moon icon-downarrow' })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'item-body vipCard-notice ' + (activeItem == 'notice' ? 'active' : '')
                  },
                  React.createElement(
                    'div',
                    { className: 'content' },
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u6743\u9650\u8BF4\u660E'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u4F1A\u5458\u6743\u9650\u4F1A\u968F\u7740\u4F1A\u5458\u5361\u7B49\u7EA7\u4E0A\u5347\u800C\u52A0\u5F3A\uFF0C\u76F8\u5E94\u7279\u6743\u8BF7\u7559\u610F\u4F1A\u5458\u5361\u4E0B\u65B9\u7684\u4F1A\u5458\u6743\u76CA\u3002'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u79EF\u5206\u8BF4\u660E'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u5728\u79EF\u5206\u5546\u54C1\u4E2D\uFF0C100\u79EF\u5206\u53EF\u4EE5\u4EE3\u66FF1\u5143\u4F7F\u7528\u3002'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u8865\u5145\u8BF4\u660E'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      React.createElement(
                        'span',
                        null,
                        vipNotice.description
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'card-item' },
                React.createElement(
                  'div',
                  {
                    className: 'item-title ' + (activeItem == 'points' ? 'active' : ''),
                    onClick: this.showItemContent,
                    'data-item': 'points'
                  },
                  React.createElement(
                    'span',
                    null,
                    '\u4E2A\u4EBA\u79EF\u5206'
                  ),
                  React.createElement('label', { className: 'ico-moon icon-downarrow' })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'item-body vipCard-points ' + (activeItem == 'points' ? 'active' : '')
                  },
                  React.createElement(
                    'div',
                    { className: 'content' },
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u73B0\u6709\u79EF\u5206'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      vipPoints.canUseIntegral
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u603B\u79EF\u5206'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      vipPoints.totalIntegral
                    ),
                    !!+vipPoints.consumeNum && vipPoints.consumeNum != 0 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '\u79EF\u7D2F\u89C4\u5219'
                      ),
                      React.createElement(
                        'div',
                        { className: 'item' },
                        '消费' + vipPoints.consumeNum + '元，获得1积分'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u4F7F\u7528\u89C4\u5219'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '100\u79EF\u5206 = 1\u5143'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u63D0\u9192'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u6D88\u8D39\u79EF\u5206\u5E76\u4E0D\u4F1A\u5F71\u54CD\u5347\u7EA7\u4F1A\u5458\u5361\uFF0C\u4E0E\u4F1A\u5458\u5361\u5347\u7EA7\u76F8\u5173\u7684\u662F\u603B\u79EF\u5206'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'card-item' },
                React.createElement(
                  'div',
                  {
                    className: 'item-title ' + (activeItem == 'contact' ? 'active' : ''),
                    onClick: this.showItemContent,
                    'data-item': 'contact'
                  },
                  React.createElement(
                    'span',
                    null,
                    '\u8054\u7CFB\u6211\u4EEC'
                  ),
                  React.createElement('label', { className: 'ico-moon icon-downarrow' })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'item-body vipCard-contact ' + (activeItem == 'contact' ? 'active' : '')
                  },
                  React.createElement(
                    'div',
                    { className: 'content' },
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u5E97\u94FA\u540D\u79F0'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      vipContact.appName
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      '\u8054\u7CFB\u7535\u8BDD'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item' },
                      vipContact.phone
                    )
                  )
                )
              )
            ),
            vipInfo.is_owner != 1 && React.createElement(
              'div',
              { className: 'receive-btn', onClick: this.getVIPCardForUser },
              '\u9886\u53D6\u4F1A\u5458\u5361'
            )
          ) : receiveCard == 0 && React.createElement(
            'div',
            { className: 'no-receive-card' },
            React.createElement(
              'div',
              { className: 'tip-area' },
              React.createElement('img', {
                className: 'tip-img',
                src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/no-vip.png'
              }),
              React.createElement(
                'span',
                { className: 'tip-text-1' },
                '\u6682\u65E0\u53EF\u7528\u4F1A\u5458\u5361'
              ),
              React.createElement(
                'span',
                { className: 'tip-text-2' },
                '\u83B7\u53D6\u65B9\u5F0F\uFF0C\u53EF\u7559\u610F\u5E97\u5BB6\u6D88\u606F'
              )
            )
          )
        )
      );
    }
  }]);
  return VipCard;
}(_OfficialPage3.default);

exports.default = VipCard;

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(475);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VipBenefits = function (_OfficialPage) {
  (0, _inherits3.default)(VipBenefits, _OfficialPage);

  function VipBenefits(props) {
    (0, _classCallCheck3.default)(this, VipBenefits);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (VipBenefits.__proto__ || Object.getPrototypeOf(VipBenefits)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '会员权益'
      },
      slideData: [], // 存的是会员卡的logo
      currentIndex: 0,
      startX: 0,
      moveX: 0,
      cardListData: [], // 会员卡列表信息
      currentCard: {}, // 当前会员卡信息
      requesting: false,
      currentComboIndex: 0, // 当前选中的优惠套餐的下标
      price: 0, // 价格
      cardId: '', // 会员卡id
      isPaidCard: '', // 是否为付费会员卡
      isRenew: '', // 是否为续费会员
      isNeedCollect: 0, // 是否需要收集会员信息
      userPaidVipCard: {}, // 用户付费卡
      userVipCard: {}, // 用户的规则卡
      specialNote: '', // 特别说明
      isVipBenefitDay: 0, // 是否存在会员日
      isUserDiyLogo: false, // 是否为用户自定义logo
      loading: true, // 首屏是否在加载
      franchiseeId: '' // 子店id
    };

    _this2.touchStart = function (e) {
      var startX = e.changedTouches[0].clientX;
      _this2.setData({
        startX: startX
      });
    };

    _this2.touchMove = function (e) {
      var endX = e.changedTouches[0].clientX;
      var moveX = endX - _this2.data.startX; // moveX：右移为负数，左移为正数，
      var currentIndex = _this2.data.currentIndex;
      var len = _this2.data.slideData.length;
      if (currentIndex <= 1 && moveX >= 0 || currentIndex >= len - 2 && moveX <= 0) {
        return;
      }
      _this2.setData({
        moveX: moveX
      });
      if (Math.abs(moveX) >= 250) {
        _this2.setData({
          startX: _this2.data.startX + moveX,
          moveX: 0
        });
        if (moveX > 0 && _this2.data.currentIndex > 0) {
          _this2.setData({
            startX: _this2.data.startX + moveX,
            currentIndex: _this2.data.currentIndex - 1,
            moveX: 0
          });
        } else if (moveX <= 0 && _this2.data.currentIndex < len) {
          _this2.setData({
            startX: _this2.data.startX + moveX,
            currentIndex: _this2.data.currentIndex + 1,
            moveX: 0
          });
        }
      }
      _this2.setCurrentCard();
    };

    _this2.touchEnd = function (e) {
      var endX = e.changedTouches[0].clientX;
      var moveX = endX - _this2.data.startX;
      var currentIndex = _this2.data.currentIndex;
      var len = _this2.data.slideData.length;
      if (currentIndex < 1 && moveX > 0 || currentIndex > len - 2 && moveX < 0 // ||
      ) {
          return;
        }
      _this2.setData({
        moveX: moveX
      });
      if (moveX === 0) {
        if (endX > 250 || endX < 125) {
          _this2.setData({
            currentIndex: endX > 250 ? _this2.data.currentIndex + 1 : endX < 125 ? _this2.data.currentIndex - 1 : '',
            moveX: 0
          });
        }
      } else {
        _this2.setData({
          currentIndex: moveX > 0 ? _this2.data.currentIndex - 1 : _this2.data.currentIndex + 1,
          moveX: 0
        });
      }
      _this2.setCurrentCard();
    };

    _this2.getAllVipCardInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchiseeId,
          card_type: _this.data.cardtype
        },
        hideLoading: false,
        success: function success(res) {
          var data = res.data.all_vip_card;
          var slideData = [];
          var isPaidCard = _this.data.isPaidCard;
          var cardId = _this.data.cardId;
          var cardListData = [];
          var userPaidVipCard = res.data.user_paid_vip_card ? res.data.user_paid_vip_card : {};
          var userVipCard = res.data.user_vip_card ? res.data.user_vip_card : {};
          data.map(function (item) {
            if (item.condition_type == 0 && (!isPaidCard || cardId)) {
              if (item.id === userVipCard.vip_id || item.id === userPaidVipCard.vip_id) {
                slideData.push(item.logo);
              } else {
                slideData.push(item.pre_logo || item.logo);
              }
              cardListData.push(item);
            } else if (item.condition_type == 1 && (!isPaidCard || cardId)) {
              if (item.id === userVipCard.vip_id || item.id === userPaidVipCard.vip_id) {
                slideData.push(item.logo);
              } else {
                slideData.push(item.pre_logo || item.logo);
              }
              cardListData.push(item);
            } else if (item.condition_type == 2) {
              if (item.id === userVipCard.vip_id || item.id === userPaidVipCard.vip_id) {
                slideData.push(item.logo);
              } else {
                slideData.push(item.pre_logo || item.logo);
              }
              cardListData.push(item);
            }
          });
          slideData.forEach(function (item, index) {
            if (item.indexOf('/vip-card/') !== -1) {
              // 如果为自定义logo则不在logo上显示卡名称
              cardListData[index].is_show_title = 1;
            } else {
              cardListData[index].is_show_title = 0;
            }
          });
          _this.setData({
            cardListData: cardListData,
            slideData: slideData,
            userPaidVipCard: userPaidVipCard,
            userVipCard: userVipCard,
            isVipBenefitDay: res.data.is_vip_benefit_day
          });
          if (_this.data.cardId) {
            _this.setCurrentIndex(_this.data.cardId);
          }
          _this.setCurrentCard();
        },
        complete: function complete(res) {
          _this.setData({
            loading: false
          });
        }
      });
    };

    _this2.setCurrentIndex = function (id) {
      var allCardData = _this2.data.cardListData;
      var currentIndex = 0;
      allCardData.forEach(function (item, index) {
        if (_this2.data.isPaidCard == 1 || _this2.data.isRenew == 1) {
          if (item.condition_type == 2 && item.id == id) {
            currentIndex = index;
          }
        } else {
          if ((item.condition_type == 0 || item.condition_type == 1) && item.id == id) {
            currentIndex = index;
          }
        }
      });
      _this2.setData({
        currentIndex: currentIndex
      });
    };

    _this2.setCurrentCard = function () {
      var info = _this2.data.cardListData[_this2.data.currentIndex];
      var price = 0;
      var specialNoteArr = [];
      var isUserDiyLogo = false;
      if (!info) {
        return;
      }
      if (info.condition_type == 0) {
        // condition_text：获取条件的文字说明
        info.condition_text = ['无门槛'];
      } else if (info.condition_type == 1) {
        info.condition_text = [];
        if (info.trade_count !== '-1') {
          info.condition_text.push('\u7D2F\u8BA1\u4EA4\u6613\u6210\u529F' + info.trade_count + '\u7B14');
        }
        if (info.consume_count !== '-1') {
          var text = '';
          if (info.condition_text.length) {
            text += '或';
          }
          text += '\u7D2F\u8BA1\u6D88\u8D39\u91D1\u989D' + info.consume_count + '\u5143';
          info.condition_text.push(text);
        }
        if (info.integral_count !== '-1') {
          var _text = '';
          if (info.condition_text.length) {
            _text += '或';
          }
          _text += '\u7D2F\u8BA1\u79EF\u5206\u8FBE\u5230' + info.integral_count + '\u5206';
          info.condition_text.push(_text);
        }
      } else if (info.condition_type == 2) {
        info.condition_text = ['付费购买'];
      }
      if (info.combo && !Array.isArray(info.combo)) {
        // combo：优惠套餐
        info.combo = JSON.parse(info.combo);
      }
      if (info.combo) {
        info.combo = info.combo.map(function (item) {
          if (item.price) {
            item.price = Number(item.price).toFixed(2);
          }
          return item;
        });
      }
      if (info.price) {
        price = info.price;
      }
      if (info.coupon_list && Array.isArray(info.coupon_list) && info.coupon_list.length) {
        info.coupon_list = info.coupon_list.map(function (coupon) {
          coupon.name = coupon.type === '0' ? '满减券' : coupon.type === '1' ? '打折券' : coupon.type === '2' ? '代金券' : coupon.type === '3' ? '兑换券' : coupon.type === '4' ? '储值券' : coupon.type === '5' ? '通用券' : coupon.type === '6' ? '次数券' : '';
          return coupon;
        });
      }
      if (info.birthday_coupon_list && Array.isArray(info.birthday_coupon_list) && info.birthday_coupon_list.length) {
        info.birthday_coupon_list = info.birthday_coupon_list.map(function (coupon) {
          coupon.name = coupon.type === '0' ? '满减券' : coupon.type === '1' ? '打折券' : coupon.type === '2' ? '代金券' : coupon.type === '3' ? '兑换券' : coupon.type === '4' ? '储值券' : coupon.type === '5' ? '通用券' : coupon.type === '6' ? '次数券' : '';
          return coupon;
        });
      }
      if (info.coupon_list && info.coupon_list.length) {
        specialNoteArr.push('优惠券');
      }
      if (info.balance && info.balance != 0) {
        specialNoteArr.push('储值');
      }
      if (info.integral && info.integral != 0) {
        specialNoteArr.push('积分');
      }
      if (_this2.data.slideData[_this2.data.currentIndex].indexOf('/vip-card/') === -1) {
        isUserDiyLogo = true;
      }
      _this2.setData({
        currentCard: info,
        currentComboIndex: 0,
        price: price,
        specialNote: specialNoteArr.join('、') + '在付费会员卡有效期限内每月赠送一次',
        isUserDiyLogo: isUserDiyLogo
      });
    };

    _this2.addPaidCardOrder = function () {
      var _this = _this2;
      _this2.setData({
        requesting: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/addPaidVipCardOrder',
        method: 'post',
        data: {
          data_id: _this.data.currentCard.id,
          price: _this.data.price,
          sub_shop_app_id: _this.data.franchiseeId
        },
        hideLoading: false,
        success: function success(res) {
          var orderId = res.data;
          _this.payOrder(orderId);
        }
      });
    };

    _this2.getCollectUserinfoConfig = function () {
      var _this = _this2;
      var userInfo = _app.appMethod.getUserInfo();
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getCollectUserinfoConfig',
        method: 'post',
        hideLoading: true,
        data: {
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            isNeedCollect: res.data.need_collect_info ? res.data.need_collect_info : 0
          });
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var _this = _this2;
      function paySuccess() {
        if (_this.data.isNeedCollect) {
          _app.appMethod.turnToPage('/pages/userCenter/userCenter?id=' + _this.data.currentCard.id);
        } else {
          _app.appMethod.turnToPage('/pages/userCenterComponentPage/userCenterComponentPage');
        }
      }
      function payFail() {
        _app.appMethod.turnToPage('/pages/userCenterComponentPage/userCenterComponentPage');
      }
      if (_this2.data.price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          complete: function complete() {
            _this.setData({
              requesting: false
            });
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function(res) {
      //     let param = res.data
      //     param.orderId = orderId
      //     param.goodsType = 8
      //     param.success = paySuccess
      //     param.fail = payFail
      //     _this.wxPay(param)
      //   },
      //   complete: function() {
      //     _this.setData({
      //       requesting: false
      //     })
      //   }
      // })
      var backurl = '/userCenterComponentPage';
      if (_this.data.isNeedCollect) {
        backurl = '/userCenter?id=' + _this.data.currentCard.id;
      }
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: backurl,
        failUrl: '/userCenterComponentPage',
        cancel: payFail
      });
      _this.setData({
        requesting: false
      });
    };

    _this2.selectCombo = function (e) {
      var index = +e.currentTarget.dataset.index;
      var currentCard = _this2.data.currentCard;
      var price = index == 0 ? currentCard.price : currentCard.combo[index - 1].price ? currentCard.combo[index - 1].price : currentCard.combo[index - 1].original_price;
      _this2.setData({
        currentComboIndex: index,
        price: price
      });
    };

    _this2.gotoMemberDay = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/memberDay/memberDay');
    };

    document.title = '会员权益';
    return _this2;
  }

  (0, _createClass3.default)(VipBenefits, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var id = options.id || '';
      var isPaidCard = options.is_paid_card || '';
      var isRenew = options.is_renew || '';
      var franchiseeId = options.franchisee || '';
      var cardtype = options.cardtype || '';
      this.setData({
        cardId: id,
        isPaidCard: isPaidCard,
        isRenew: isRenew,
        franchiseeId: franchiseeId,
        cardtype: cardtype
      });
      this.getAllVipCardInfo();
      this.getCollectUserinfoConfig();
    }
    // wxPay = param => {
    //   let _this = this
    //   Taro.requestPayment({
    //     timeStamp: param.timeStamp,
    //     nonceStr: param.nonceStr,
    //     package: param.package,
    //     signType: param.signType,
    //     paySign: param.paySign,
    //     success: function(res) {
    //       _this.wxPaySuccess(param)
    //       typeof param.success === 'function' && param.success()
    //     },
    //     fail: function(res) {
    //       if (res.errMsg === 'requestPayment:fail cancel') {
    //         _this.showModal({
    //           content: '支付已取消',
    //           complete: function() {
    //             typeof param.fail === 'function' && param.fail()
    //           }
    //         })
    //         return
    //       }
    //       if (res.errMsg === 'requestPayment:fail') {
    //         res.errMsg = '支付失败'
    //       }
    //       _this.showModal({
    //         content: res.errMsg
    //       })
    //       _this.wxPayFail(param, res.errMsg)
    //       typeof param.fail === 'function' && param.fail()
    //     }
    //   })
    // }
    // wxPaySuccess = param => {
    //   let orderId = param.orderId,
    //     formId = param.package.substr(10),
    //     _this = this
    //   app.sendRequest({
    //     hideLoading: true,
    //     url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
    //     data: {
    //       formId: formId,
    //       order_id: orderId
    //     }
    //   })
    //   if (
    //     this.isNeedCollect == 0 &&
    //     this.data.userPaidVipCard.vip_id != this.data.currentCard.id
    //   ) {
    //     app.sendRequest({
    //       hideLoading: true,
    //       url: '/index.php?r=appVipCard/sendRecvVipCardMsg',
    //       data: {
    //         formId: formId,
    //         vip_id: _this.data.currentCard.id,
    //         sub_shop_app_id: _this.data.franchiseeId
    //       }
    //     })
    //   }
    // }
    // wxPayFail = (param, errMsg) => {
    //   let orderId = param.orderId,
    //     formId = param.package.substr(10)
    //   app.sendRequest({
    //     hideLoading: true,
    //     url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
    //     data: {
    //       formId: formId,
    //       t_num: 'AT0010',
    //       order_id: orderId,
    //       fail_reason: errMsg
    //     }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          cardListData = _state.cardListData,
          currentCard = _state.currentCard,
          isVipBenefitDay = _state.isVipBenefitDay,
          currentIndex = _state.currentIndex,
          moveX = _state.moveX,
          slideData = _state.slideData,
          userVipCard = _state.userVipCard,
          userPaidVipCard = _state.userPaidVipCard,
          loading = _state.loading,
          isUserDiyLogo = _state.isUserDiyLogo,
          currentComboIndex = _state.currentComboIndex,
          specialNote = _state.specialNote,
          requesting = _state.requesting;

      return React.createElement(
        'div',
        { className: 'official-page vip-benefits' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u6743\u76CA' }),
        React.createElement(
          'div',
          {
            className: 'content',
            style: (0, _tools.convertLineStyleData)('background: ' + (cardListData.length ? 'url(https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/vip-card/more-power-bg.jpg)' : '#3e3935'))
          },
          React.createElement(
            'div',
            { className: 'slide-wrapper' },
            !!isVipBenefitDay && React.createElement(
              'div',
              { className: 'member-day-block', onClick: this.gotoMemberDay },
              React.createElement(
                'div',
                {
                  className: 'member-day',
                  style: (0, _tools.convertLineStyleData)('background-color: ' + (currentCard.style_config && currentCard.style_config.vip_benefit_day ? currentCard.style_config.vip_benefit_day : '#FF7100'))
                },
                '\u4F1A\u5458\u65E5'
              )
            ),
            slideData.map(function (item, index) {
              return React.createElement(
                'div',
                {
                  className: 'slide-item ' + (index === currentIndex ? 'active' : ''),
                  style: (0, _tools.convertLineStyleData)('left: ' + ((index + 1 - currentIndex) * 250 + moveX) + 'rpx'),
                  key: index,
                  onTouchStart: _this3.touchStart,
                  onTouchMove: _this3.touchMove,
                  onTouchEnd: _this3.touchEnd
                },
                React.createElement(
                  'div',
                  { className: 'image-block' },
                  React.createElement('img', { src: item }),
                  cardListData[index].is_show_title && React.createElement(
                    'div',
                    { className: 'card-name' },
                    React.createElement(
                      'span',
                      null,
                      cardListData[index].title
                    )
                  )
                )
              );
            }),
            (userVipCard.vip_id === currentCard.id || userPaidVipCard.vip_id === currentCard.id) && !!cardListData.length && React.createElement('img', {
              className: 'star-img',
              src: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/vip-card/vip-benefit-star.svg'
            })
          ),
          cardListData.length === 0 && !loading && React.createElement(
            'div',
            { className: 'empty-data' },
            '\u6682\u65E0\u4F1A\u5458\u5361'
          ),
          !!cardListData.length && React.createElement(
            'div',
            { className: 'detail' },
            !!isUserDiyLogo && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'top-block' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '\u540D\u79F0'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'condition',
                    style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                  },
                  currentCard.title
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'top-block' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '\u72B6\u6001'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'condition',
                    style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                  },
                  userPaidVipCard.vip_id == currentCard.id || userVipCard.vip_id == currentCard.id ? '已领取' : '未领取'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'top-block' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '\u83B7\u53D6\u6761\u4EF6'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'condition',
                    style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                  },
                  Array.isArray(currentCard.condition_text) && currentCard.condition_text.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'condition-item',
                        key: index
                      },
                      item
                    );
                  })
                )
              )
            ),
            currentCard.condition_type == 2 && React.createElement(
              'div',
              { className: 'detail-item detail-benefit' },
              React.createElement(
                'div',
                { className: 'top-block m-b-30' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '\u4F18\u60E0\u5957\u9910'
                )
              ),
              React.createElement(
                _ScrollView.ScrollView,
                { 'scroll-x': 'true', className: 'benefits' },
                React.createElement(
                  'div',
                  {
                    className: 'benefit-item ' + (currentComboIndex == 0 ? 'active' : ''),
                    'data-index': '0',
                    onClick: this.selectCombo
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'icon-block',
                      style: (0, _tools.convertLineStyleData)('border-color: ' + (currentComboIndex != 0 ? '#d5d5d5' : currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#ffebdc'))
                    },
                    currentComboIndex == 0 && React.createElement('label', {
                      className: 'ico-moon icon-gou',
                      style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'content-block' },
                    React.createElement(
                      'div',
                      { className: 'count' },
                      '1\u4E2A\u6708'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'price',
                        style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                      },
                      '\xA5',
                      React.createElement(
                        'label',
                        null,
                        currentCard.price
                      )
                    )
                  )
                ),
                currentCard.combo && currentCard.combo.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'benefit-item ' + (currentComboIndex === index + 1 ? 'active' : ''),
                      'data-index': index + 1,
                      key: index,
                      onClick: _this3.selectCombo
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'icon-block',
                        style: (0, _tools.convertLineStyleData)('border-color: ' + (currentComboIndex !== index + 1 ? '#d5d5d5' : currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#ffebdc'))
                      },
                      currentComboIndex === index + 1 && React.createElement('label', {
                        className: 'ico-moon icon-gou',
                        style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'content-block' },
                      React.createElement(
                        'div',
                        { className: 'count' },
                        item.num + '个月'
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'price',
                          style: (0, _tools.convertLineStyleData)('color: ' + (currentCard.style_config && currentCard.style_config.condition ? currentCard.style_config.condition : '#FF7100'))
                        },
                        '\xA5',
                        React.createElement(
                          'label',
                          null,
                          item.price ? item.price : item.original_price
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'cut-price' },
                        '\xA5',
                        React.createElement(
                          'label',
                          null,
                          item.original_price
                        )
                      )
                    )
                  );
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'top-block m-b-30' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '\u4F1A\u5458\u6743\u76CA'
                )
              ),
              React.createElement(
                'div',
                { className: 'about-wrapper' },
                currentCard.discount && currentCard.discount != 0 && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u6298\u6263'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    '所有商品一律' + currentCard.discount + '折'
                  )
                ),
                !!(currentCard.coupon_list && currentCard.coupon_list.length) && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u4F18\u60E0\u5238'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    currentCard.coupon_list.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        item.name + '-' + item.title + ' -' + item.num + '张'
                      );
                    })
                  )
                ),
                currentCard.integral && currentCard.integral != 0 && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u79EF\u5206'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    '开卡赠送' + currentCard.integral + '积分'
                  )
                ),
                currentCard.balance && currentCard.balance != 0 && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u50A8\u503C'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    '开卡赠送储值' + currentCard.balance + '元'
                  )
                ),
                currentCard.is_free_postage && currentCard.is_free_postage !== '0' && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u5305\u90AE'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    '\u6240\u6709\u5546\u54C1\u5305\u90AE'
                  )
                ),
                !!(currentCard.birthday_coupon_list && currentCard.birthday_coupon_list.length) && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u751F\u65E5\u4F18\u60E0'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    currentCard.birthday_coupon_list.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        item.name + '-' + item.title
                      );
                    })
                  )
                )
              )
            ),
            (currentCard.phone || currentCard.description || currentCard.condition_type == 2) && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'about-wrapper' },
                specialNote !== '' && currentCard.condition_type == 2 && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u7279\u522B\u8BF4\u660E'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    specialNote,
                    React.createElement(
                      'div',
                      null,
                      '\u4ED8\u8D39\u5361\u8D2D\u4E70\u6210\u529F\u540E\u4E0D\u652F\u6301\u9000\u6B3E'
                    )
                  )
                ),
                currentCard.phone && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u8054\u7CFB'
                  ),
                  React.createElement(
                    'div',
                    { className: 'about' },
                    currentCard.phone
                  )
                ),
                currentCard.description && React.createElement(
                  'div',
                  { className: 'about-item' },
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u4F7F\u7528\u987B\u77E5'
                  ),
                  React.createElement(
                    'span',
                    { className: 'about' },
                    currentCard.description
                  )
                )
              )
            )
          ),
          currentCard.condition_type == 2 && React.createElement(
            'form',
            { onSubmit: this.addPaidCardOrder },
            React.createElement(
              'button',
              {
                className: 'buy-btn',
                disabled: requesting,
                onClick: this.addPaidCardOrder,
                style: (0, _tools.convertLineStyleData)('background-color: ' + (currentCard.style_config && currentCard.style_config.recv_button ? currentCard.style_config.recv_button : '#FF7100'))
              },
              userPaidVipCard.vip_id == currentCard.id ? '续费会员' : '立即购买'
            )
          )
        )
      );
    }
  }]);
  return VipBenefits;
}(_OfficialPage3.default);

exports.default = VipBenefits;

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _MemberDiscount = __webpack_require__(66);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(477);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateTrans = {
  date: function date(a) {
    var reg = new RegExp("-", "img");
    var c = a.replace(reg, '月') + '日';
    return c;
  },
  week: function week(a) {
    switch (a) {
      case '0':
        return '日';
      case '1':
        return '一';
      case '2':
        return '二';
      case '3':
        return '三';
      case '4':
        return '四';
      case '5':
        return '五';
      case '6':
        return '六';
    }
  }
};

var PreviewSeckillOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewSeckillOrder, _OfficialPage);

  function PreviewSeckillOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewSeckillOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewSeckillOrder.__proto__ || Object.getPrototypeOf(PreviewSeckillOrder)).call(this, props));

    _this2.state = {
      customNumArr: Array.from(new Array(101).keys()).slice(1),
      take_meal_type_index: 0,
      take_meal_type_arr: [],
      take_meal_type_text: ['', '送餐到桌', '前台自取'],
      dining_mode_arr: ['堂食', '打包'],
      take_meal_type: 1,
      people_num: 1,
      dining_mode: 1,
      is_addDishing: false,
      only_me: false,
      goodsList: [],
      selectAddress: {},
      discountList: [],
      selectDiscountInfo: {},
      orderRemark: '',
      is_self_delivery: 0,
      express_fee: '',
      balance: '',
      useBalance: true,
      deduction: '',
      discount_cut_price: '',
      group_buy_price: '',
      original_price: '',
      totalPayment: '',
      storeConfig: '',
      noAdditionalInfo: true,
      is_group: '',
      limit_buy: '',
      teamToken: '',
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      pickUpType: '',
      cashOnDelivery: false,
      selectDelivery: '',
      isShowSameJourneyTime: false,
      expressAddressNull: false,
      seckillType: 0, // 秒杀类型 0： 单品秒杀， 1： 活动秒杀
      storeStyle: {}
    };
    _this2.isFromSelectAddress = false;
    _this2.franchisee_id = '';
    _this2.cart_id_arr = [];
    _this2.cart_id_arr_my = [];
    _this2.cart_data_arr = [];
    _this2.requesting = false;
    _this2.additional_info = {};
    _this2.is_group = '';
    _this2.inputTimer = '';
    _this2.hasRequiredSuppInfo = false;
    _this2.downcountArr = [];
    _this2.memberDiscountRef = _react2.default.createRef();

    _this2.getDiningData = function () {
      if (_this2.data.ec_location_id) {
        _this2.scanInitUserInfo('', _this2.data.ec_location_id, _this2.checkIsAddDishing);
      } else {
        _this2.getCalculationInfo();
      }
    };

    _this2.dataInitial = function () {
      _this2.getAppECStoreConfig();
      _this2.getCartList();
    };

    _this2.getCartList = function () {
      var that = _this2,
          franchisee_id = _this2.franchisee_id;
      _this2.cart_id_arr_my = [];
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: franchisee_id,
          parent_shop_app_id: franchisee_id ? _app.appMethod.globalData.appId : ''
        },
        success: function success(res) {
          var data = [];
          if (that.cart_id_arr.length) {
            for (var i = 0; i <= res.data.length - 1; i++) {
              if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
                data.push(res.data[i]);
              }
            }
          } else {
            data = res.data;
          }
          for (var i = 0; i <= data.length - 1; i++) {
            var goods = data[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? modelArr.join('； ') : '';
            that.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
            that.cart_id_arr_my.push(goods.id);
          }
          for (var i = 0; i < data.length; i++) {
            data[i].downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (data[i].seckill_start_state == 0) {
              data[i].downcount = _app.appMethod.beforeSeckillDownCount(data[i], that, 'goodsList[' + i + ']');
            } else if (data[i].seckill_start_state == 1) {
              data[i].downcount = _app.appMethod.duringSeckillDownCount(data[i], that, 'goodsList[' + i + ']');
            }
            data[i] && that.downcountArr.push(data[i].downcount);
          }
          that.setData({
            goodsList: data
          });
        }
      });
    };

    _this2.getCalculationInfo = function () {
      var _this = _this2;
      var ecommerce_info = {};
      if (_this2.data.pickUpType == 4) {
        ecommerce_info = {
          ec_dining_data: {
            ordering_food_type: 1, // 点餐方式
            dining_mode: _this.data.dining_mode, // 就餐方式
            people_num: _this.data.people_num, // 就餐人数
            take_meal_type: _this.data.take_meal_type, // 取餐类型
            location_id: _this.data.ec_location_id, // 座位号码
            account_type: _this.data.account_type // 结账方式
          }
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          ecommerce_info: ecommerce_info,
          sub_shop_app_id: _this2.franchisee_id,
          address_id: _this2.data.pickUpType == 4 ? '' : _this2.data.pickUpType == 1 ? _this2.data.selectAddressId : _this2.data.selectSameJourneyId,
          cart_id_arr: _this2.cart_id_arr,
          is_balance: _this2.data.useBalance ? 1 : 0,
          is_self_delivery: _this2.data.is_self_delivery,
          pick_up_type: _this2.data.pickUpType,
          selected_benefit: _this2.data.pickUpType == 4 && _this2.data.account_type == 2 ? '' : _this2.data.selectDiscountInfo,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info
        },
        success: function success(res) {
          var info = res.data;
          var benefits = info.can_use_benefit;
          var goods_info = info.goods_info;
          var additional_info_goods = [];
          var selectDiscountInfo = info.selected_benefit_info;
          var suppInfoArr = [];
          var additional_goodsid_arr = [];
          var activePreferential = 0; //活动优惠金额
          if (info.dining_status_data && _this.data.pickUpTypeArr.length == 1 && _this.data.pickUpType == 4) {
            var dining_in_business = info.dining_status_data.in_business_time == 0 ? false : true;
            if (!dining_in_business) {
              _app.appMethod.showModal({
                content: '店铺不在营业时间内',
                confirmText: '知道了',
                confirm: function confirm() {
                  _app.appMethod.turnBack();
                }
              });
            }
          }
          if (_this.data.pickUpType == 2 && info.intra_city_status_data) {
            if (info.intra_city_status_data.in_distance == 0) {
              _app.appMethod.showModal({
                content: '地址不在配送范围内',
                confirmText: '去更换',
                showCancel: true,
                confirm: function confirm() {
                  _this.goSameJourneyAddress();
                },
                cancel: function cancel() {
                  _this.setData({
                    selectSameJourney: ''
                  });
                }
              });
            } else if (info.intra_city_status_data.in_business_time == 0) {
              _app.appMethod.showModal({
                content: '店铺歇业中，请更换其他配送方式',
                confirmText: '去更换',
                confirm: function confirm() {
                  _this.setData({
                    isShowPickMask: true
                  });
                }
              });
            }
          }
          var goodsBenefitsData = [];
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          });
          if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && _this.data.exchangeCouponData.hasSelectGoods == false) {
            _this.exchangeCouponInit(parseInt(selectDiscountInfo.value));
          }
          for (var i = 0; i <= goods_info.length - 1; i++) {
            if (goods_info[i].delivery_id && goods_info[i].delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info[i].id) == -1) {
              suppInfoArr.push(goods_info[i].delivery_id);
              additional_goodsid_arr.push(goods_info[i].id);
              additional_info_goods.push(goods_info[i]);
            }
          }
          var group_buy_price = String(info.original_price - info.group_buy_discount_price);
          if (group_buy_price.split('.')[1]) {
            group_buy_price = Number(group_buy_price).toFixed(2);
          }
          if (suppInfoArr.length && !_this.hasRequiredSuppInfo) {
            _this.getSuppInfo(suppInfoArr);
          }
          activePreferential = (info.total_original_price - info.original_price).toFixed(2);
          _this.setData({
            expressAddressNull: info.address ? false : _this.data.expressAddressNull, //快递无地址时显示弹窗
            selectAddress: _this.data.pickUpType == 1 && info.address,
            discountList: goodsBenefitsData,
            selectDiscountInfo: selectDiscountInfo,
            people_num: info.people_num,
            box_fee: info.box_fee,
            server_fee: info.server_fee,
            tissue_fee: info.tissue_fee,
            express_fee: info.express_fee,
            discount_cut_price: info.discount_cut_price,
            balance: info.balance,
            deduction: info.use_balance,
            original_price: info.original_price,
            group_buy_price: group_buy_price,
            totalPayment: info.price,
            noAdditionalInfo: suppInfoArr.length ? false : true,
            canCashDelivery: info.is_pay_on_delivery,
            cashOnDelivery: info.price > 0 ? _this.data.cashOnDelivery : false,
            selfPayOnDelivery: info.self_pay_on_delivery,
            activePreferential: activePreferential,
            selectSameJourney: _this.data.pickUpType == 2 && info.address,
            additional_goodsid_arr: additional_goodsid_arr,
            sameJourneyImmediatlyTime: info.intra_city_status_data && info.intra_city_status_data.deliver_time
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeConfig: res,
          storeStyle: res.color_config
        });
      }, _this2.franchisee_id);
    };

    _this2.remarkInput = function (e) {
      var value = e.target.value;
      _this2.setData({
        orderRemark: value
      });
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goods = _this2.data.goodsList[index];
      if (+goods.num <= 0) return;
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goods = _this2.data.goodsList[index];
      if (_this2.data.limit_buy !== '' && +goods.num >= _this2.data.limit_buy) return;
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.changeGoodsNum = function (index, type) {
      var goods = _this2.data.goodsList[index],
          currentNum = +goods.num,
          targetNum = type == 'plus' ? currentNum + 1 : type == 'minus' ? currentNum - 1 : Number(type),
          that = _this2,
          data = {},
          param;
      if (targetNum == 0 && type == 'minus') {
        _app.appMethod.showModal({
          content: '确定从购物车删除该商品？',
          showCancel: true,
          confirm: function confirm() {
            that.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            that.setData(data);
            that.deleteGoods(index);
          }
        });
        return;
      }
      if (goods.form_data && goods.form_data.seckill_activity_id) {
        param = {
          goods_id: goods.goods_id,
          model_id: goods.model_id || '',
          num: targetNum,
          sub_shop_app_id: that.franchisee_id,
          is_seckill: goods.is_seckill == 1 ? 1 : '',
          form_data: goods.form_data
        };
      } else {
        param = {
          goods_id: goods.goods_id,
          model_id: goods.model_id || '',
          num: targetNum,
          sub_shop_app_id: that.franchisee_id,
          is_seckill: goods.is_seckill == 1 ? 1 : ''
        };
      }
      if (_this2.data.is_group) {
        param.is_group_buy = _this2.data.is_group ? 1 : 0;
        param.num_of_group_buy_people = _this2.data.group_buy_people;
        param.team_token = _this2.data.teamToken;
      }
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        method: 'post',
        success: function success(res) {
          that.cart_data_arr[index].num = targetNum;
          data['goodsList[' + index + '].num'] = targetNum;
          if (type == 'plus') {
            data['goodsList[' + index + '].stock'] = goods.stock - 1;
          } else {
            data['goodsList[' + index + '].stock'] = goods.stock + 1;
          }
          data.selectDiscountInfo = '';
          data.exchangeCouponData = {
            dialogHidden: true,
            hasSelectGoods: false,
            voucher_coupon_goods_info: {}
          };
          that.setData(data);
          that.getCalculationInfo();
        },
        fail: function fail(res) {
          data = {};
          that.cart_data_arr[index].num = currentNum;
          data['goodsList[' + index + '].num'] = currentNum;
          that.setData(data);
        }
      });
    };

    _this2.deleteGoods = function (index) {
      var goodsList = _this2.data.goodsList,
          that = _this2,
          listExcludeDelete;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [_this2.cart_data_arr[index].cart_id],
          sub_shop_app_id: _this2.franchisee_id
        },
        success: function success(res) {
          ;(listExcludeDelete = goodsList.concat([])).splice(index, 1);
          if (listExcludeDelete.length == 0) {
            _app.appMethod.turnBack();
            return;
          }
          var deleteGoodsId = goodsList[index],
              noSameGoodsId = true;
          for (var i = listExcludeDelete.length - 1; i >= 0; i--) {
            if (listExcludeDelete[i].id == deleteGoodsId) {
              noSameGoodsId = false;
              break;
            }
          }
          if (noSameGoodsId) {
            delete that.additional_info[deleteGoodsId];
          }
          that.cart_data_arr.splice(index, 1);
          that.setData({
            goodsList: listExcludeDelete,
            selectDiscountInfo: '',
            exchangeCouponData: {
              dialogHidden: true,
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            }
          });
          that.getCalculationInfo();
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var _this = _this2,
          selected_benefit = _this2.data.selectDiscountInfo,
          tostoreOrderType = _this2.data.tostoreOrderType;
      if (_this2.data.pickUpType == 1 && !_this2.data.selectAddress) {
        _this2.setData({
          expressAddressNull: true
        });
        return;
      }
      if (_this2.data.pickUpType == 4 && _this2.data.location_status) {
        if (!_this2.data.ec_location_id && _this2.data.take_meal_type == 1) {
          _app.appMethod.showModal({
            content: '请先扫码获取桌号！'
          });
          return;
        }
      }
      if (_this2.data.pickUpType == 1 && !_this2.data.selectAddress) {
        _app.appMethod.showModal({
          content: '请完善地址信息',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.goToMyAddress();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.selectSameJourney) {
        _app.appMethod.showModal({
          content: '请完善地址信息',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.goSameJourneyAddress();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.sameJourneyDateTime && _this2.data.sameJourneyTimeType != 1) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && !_this2.data.selectDelivery) {
        _app.appMethod.showModal({
          content: '请选择上门自提地址',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.toDeliveryList();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && _this2.data.selfAppointmentSwitch && !tostoreOrderType) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      var year = new Date().getFullYear();
      var tostoreDateTime = year + '-' + _this2.data.tostoreDateTime + ' ' + (_this2.data.tostoreHourTime || '');
      if (_this2.data.pickUpType == 3 && _this2.data.selfDeliveryPhone == 1 && !_util2.default.isPhoneNumber(_this2.data.phone)) {
        _app.appMethod.showModal({
          content: '请填写正确的手机号'
        });
        return;
      }
      if (_this2.data.hasRequiredSuppInfo && !_this2.data.deliverydWrite && !_this2.data.aloneDeliveryShow) {
        _app.appMethod.showModal({
          content: '商品补充信息未填写，无法进行支付',
          confirmText: '去填写',
          confirm: function confirm() {
            _this.goToAdditionalInfo();
          }
        });
        return;
      }
      if (_this2.data.aloneDeliveryShow) {
        var a = _this2.data.additional_info;
        var id = _this2.data.additional_goodsid_arr[0];
        if (a[id][0].is_required == 0 && a[id][0].value == '') {
          _app.appMethod.showModal({
            content: '请填写' + a[id][0].title,
            confirmText: '确认'
          });
          return;
        }
      }
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: {
          cart_id_arr: _this2.cart_id_arr,
          formId: e.detail.formId,
          sub_shop_app_id: _this2.franchisee_id,
          selected_benefit: selected_benefit,
          is_balance: _this2.data.pickUpType == 4 && _this2.data.account_type == 2 ? 0 : _this2.data.useBalance ? 1 : 0,
          ecommerce_info: {
            ec_tostore_data: {
              ec_tostore_order_type: tostoreOrderType,
              ec_tostore_appointment_time: tostoreOrderType == 1 || !_this2.data.selfAppointmentSwitch ? '' : tostoreDateTime,
              ec_tostore_buyer_phone: _this2.data.phone || '',
              ec_tostore_appointment_time_type: _this2.data.tostoreTimeType || '',
              ec_tostore_location_id: _this2.data.locationId || ''
            },
            intra_city_data: {
              intra_city_appointment_arrive_time: _this2.data.sameJourneyTimeType == 1 ? '' : _this2.data.sameJourneyDateTime
            },
            ec_dining_data: {
              ordering_food_type: 1, // 点餐方式
              dining_mode: _this.data.dining_mode, // 就餐方式
              people_num: _this.data.people_num, // 就餐人数
              take_meal_type: _this.data.take_meal_type, // 取餐类型
              location_id: _this.data.ec_location_id, // 座位号码
              account_type: _this.data.account_type, // 结账方式
              allow_add_dish: _this.data.allow_add_dish, // 允许加菜
              allow_app_account: _this.data.allow_app_account // 允许结账
            }
          },
          pick_up_type: _this2.data.pickUpType,
          self_delivery_app_store_id: _this2.data.pickUpType == 3 ? _this2.data.selectDelivery.id : '',
          remark: _this2.data.orderRemark,
          address_id: _this2.data.pickUpType == 1 ? _this2.data.selectAddress.id : _this2.data.pickUpType == 4 ? '' : _this2.data.selectSameJourney.id,
          additional_info: _this2.data.additional_info,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info,
          is_pay_on_delivery: _this2.data.cashOnDelivery ? 1 : 0
        },
        success: function success(res) {
          _this.setData({
            totalPayment: res.total_price
          });
          if (_this.data.pickUpType == 4) {
            if (_this.data.account_type == 2) {
              var pagePath = '/eCommerce/pages/diningOrderDetail/diningOrderDetail?detail=' + res.data + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
              _app.appMethod.turnToPage(pagePath, 1);
              return;
            }
          }
          if (_this.data.cashOnDelivery) {
            var _pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + res.data + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
            _app.appMethod.turnToPage(_pagePath, 1);
          } else {
            _this.payOrder(res.data);
          }
        },
        fail: function fail() {
          _this.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _this.requesting = false;
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var _this = _this2;
      function paySuccess() {
        var router = _this.data.pickUpType == 4 && _this.data.account_type == 2 ? 'diningOrderDetail/diningOrderDetail?detail=' : 'goodsOrderPaySuccess/goodsOrderPaySuccess?detail=';
        var pagePath = '/eCommerce/pages/' + router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') + '&is_group=' + !!_this.is_group;
        if (!_this.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_app_id: _this.franchisee_id
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              _app.appMethod.turnToPage(pagePath, 1);
            }
          });
        } else {
          _app.appMethod.turnToPage(pagePath, 1);
        }
      }
      function payFail() {
        var router = _this.data.pickUpType == 4 ? 'diningOrderDetail/diningOrderDetail?detail=' : 'goodsOrderDetail/goodsOrderDetail?detail=';
        if (_this.is_group) {
          if (_this.data.teamToken) {
            _app.appMethod.turnBack();
            return;
          }
          _app.appMethod.turnToPage('/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
        } else {
          _app.appMethod.turnToPage('/eCommerce/pages/' + router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
        }
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     _this.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })
      function paySuccessUrl() {
        var router = _this.data.pickUpType == 4 && _this.data.account_type == 2 ? '/diningOrderDetail?detail=' : '/goodsOrderPaySuccess?detail=';
        var pagePath = router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') + '&is_group=' + !!_this.is_group;
        return pagePath;
      }
      function payFailUrl() {
        var router = _this.data.pickUpType == 4 ? '/diningOrderDetail?detail=' : '/goodsOrderDetail?detail=';
        var pagePath = '';
        if (_this.is_group) {
          pagePath = '/groupOrderDetail?id=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
        } else {
          pagePath = router + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '');
        }
        return pagePath;
      }
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: paySuccessUrl(),
        failUrl: payFailUrl(),
        cancel: payFail
      });
    };

    _this2.goToMyAddress = function () {
      var addressId = _this2.data.selectAddress ? _this2.data.selectAddress.id : '';
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId);
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        useBalance: checked
      });
      _this2.getCalculationInfo();
    };

    _this2.useCashDelivery = function (e) {
      if (_this2.data.selfPayOnDelivery == 0 && e) {
        _this2.setData({
          is_self_delivery: false
        });
        _this2.deliveryWayChange({ currentTarget: { dataset: { type: 0 } } });
      }
      _this2.setData({
        cashOnDelivery: e
      });
    };

    _this2.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this2.additional_info);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
    };

    _this2.exchangeCouponInit = function (id) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: id
        },
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          _this.setData({
            'exchangeCouponData.dialogHidden': false, // 显示模态框
            'exchangeCouponData.goodsInfo': goods,
            'exchangeCouponData.selectModelInfo': selectModelInfo
          });
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _app.appMethod.showModal({
            content: '兑换的商品已下架'
          });
        }
      });
    };

    _this2.exchangeCouponHideDialog = function () {
      _this2.setData({
        selectDiscountInfo: {
          title: '不使用优惠',
          name: '无',
          no_use_benefit: 1
        },
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.exchangeCouponSelectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.exchangeCouponData.selectModelInfo.models,
          model = _this2.data.exchangeCouponData.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['exchangeCouponData.selectModelInfo.models'] = selectModels;
      data['exchangeCouponData.selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.exchangeCouponResetSelectCountPrice();
    };

    _this2.exchangeCouponResetSelectCountPrice = function () {
      var _this = _this2,
          selectModelIds = _this2.data.exchangeCouponData.selectModelInfo.models.join(','),
          modelItems = _this2.data.exchangeCouponData.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
          data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
          data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
          data['exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.exchangeCouponConfirmGoods = function () {
      var _this = _this2;
      var goodsInfo = _this.data.exchangeCouponData.goodsInfo;
      var model = goodsInfo.model;
      var selectModels = _this.data.exchangeCouponData.selectModelInfo.models;
      var model_value_str = '';
      if (selectModels.length > 0) {
        for (var i = 0; i < selectModels.length; i++) {
          var selectSubModelId = model[i].subModelId;
          for (var j = 0; j < selectSubModelId.length; j++) {
            if (selectModels[i] == selectSubModelId[j]) {
              model_value_str += model[i].subModelName[j] + '； ';
            }
          }
        }
      }
      goodsInfo['model_value_str'] = model_value_str;
      _this.setData({
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.selectModelInfo': {},
        'exchangeCouponData.hasSelectGoods': true,
        'exchangeCouponData.voucher_coupon_goods_info': {
          goods_id: goodsInfo.id,
          num: 1,
          model_id: _this.data.exchangeCouponData.selectModelInfo.modelId
        },
        'exchangeCouponData.goodsInfo': goodsInfo
      });
      _this.getCalculationInfo();
    };

    _this2.inputGoodsCount = function (e) {
      var value = +e.target.value;
      var index = e.target.dataset.index;
      if (isNaN(value) || value <= 0) {
        return;
      }
      clearTimeout(_this2.inputTimer);
      _this2.inputTimer = setTimeout(function () {
        _this2.changeGoodsNum(index, value);
      }, 500);
    };

    _this2.toDeliveryList = function () {
      var _this = _this2;
      var url = '';
      if (_this.franchisee_id) {
        url += '?franchiseeId=' + _this.franchisee_id;
        url += _this.data.selectDelivery.id ? '&deliveryId=' + _this.data.selectDelivery.id : '';
      } else {
        url += _this.data.selectDelivery.id ? '?deliveryId=' + _this.data.selectDelivery.id : '';
      }
      _app.appMethod.turnToPage('/eCommerce/pages/goodsDeliveryList/goodsDeliveryList' + url);
    };

    _this2.showMemberDiscount = function () {
      _this2.memberDiscountRef.current.show({
        discountType: _this2.data.discountList,
        afterSelectedDiscount: function afterSelectedDiscount(event) {
          _this2.afterSelectedBenefit(event);
        }
      });
      _this2.memberDiscountRef.current.showDialog(_this2.data.selectDiscountInfo);
    };

    _this2.afterSelectedBenefit = function (_ref) {
      var selectedDiscount = _ref.selectedDiscount;

      _this2.setData({
        selectDiscountInfo: selectedDiscount,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.getSuppInfo = function (suppInfoArr) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=pc/AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_ids: suppInfoArr
        },
        success: function success(res) {
          for (var i = 0; i < res.data.length; i++) {
            var suppInfo = res.data[i].delivery_info;
            for (var j = 0; j < suppInfo.length; j++) {
              if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
                _this.setData({
                  hasRequiredSuppInfo: true
                });
              }
              if (suppInfo[j].is_hidden == 1) {
                _this.setData({
                  noAdditionalInfo: false
                });
              }
            }
          }
          if (res.data.length == 1 && _this.data.additional_goodsid_arr.length == 1) {
            var deliveryIndex = 0;
            var showIndex = 0;
            for (var _i = 0; _i < res.data[0].delivery_info.length; _i++) {
              if (res.data[0].delivery_info[_i].is_hidden == 1) {
                deliveryIndex++;
                showIndex = _i;
              }
            }
            if (deliveryIndex == 1) {
              var _data = {};
              _data[_this.data.additional_goodsid_arr[0]] = [];
              _data[_this.data.additional_goodsid_arr[0]].push({
                title: res.data[0].delivery_info[showIndex].name,
                type: res.data[0].delivery_info[showIndex].type,
                is_required: res.data[0].delivery_info[showIndex].is_required,
                value: ''
              });
              _this.setData({
                additional_info: _data,
                aloneDeliveryShow: true
              });
            }
          }
        }
      });
    };

    _this2.selectPickMethod = function (first, secType) {
      var _this = _this2;
      var cartIdArr = _this2.cart_id_arr;
      var seckillType = secType || _this2.data.seckillType;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtAddOrder',
        method: 'post',
        data: {
          cart_id_arr: cartIdArr
        },
        success: function success(res) {
          var pickUpTypeArr = res.data.goods_pick_up_type_arr;
          if (seckillType == 1) {
            // 过滤活动秒杀商品
            for (var i = 0; i < pickUpTypeArr.length; i++) {
              if (pickUpTypeArr[i] == 4) {
                pickUpTypeArr.splice(i, 1);
              }
            }
          }
          // WEBAPP特殊处理: 设置 取货方式 参数
          (0, _tools.updateUrlParam)('type', !_this.data.pickUpType || _this.data.pickUpType == -1 ? res.data.goods_pick_up_type_arr[0] : _this.data.pickUpType);
          _this.setData({
            dining_data: res.data.dining_data || {},
            selectDiscountInfo: {}, // 清空已选优惠信息
            pickUpTypeArr: pickUpTypeArr,
            intraCityData: res.data.intra_city_data,
            isShowPickMask: first == 'first' ? false : true,
            pickUpType: !_this.data.pickUpType || !_this.data.pickUpType == -1 ? res.data.goods_pick_up_type_arr[0] : _this.data.pickUpType
          });
          if (first == 'first') {
            switch (_this.data.pickUpType) {
              case '4':
                _this.getDiningFuncSetting(_this.getDiningData);
                break;
              case '3':
                _this.getSelfDeliveryList();
                break;
              case '2':
                if (res.data.intra_city_data.in_business_time == 0 && pickUpTypeArr.length == 1) {
                  _app.appMethod.showModal({
                    content: '店铺歇业中，不支持此配送！',
                    confirmText: '知道了',
                    confirm: function confirm(res) {
                      _app.appMethod.turnBack();
                    }
                  });
                  return;
                } else {
                  _this.setData({
                    sameJourneyTimeType: 1
                  });
                }
                break;
            }
            _this.data.pickUpType != 4 && _this.getCalculationInfo();
          }
        },
        successShowModalConfirm: function successShowModalConfirm() {
          _app.appMethod.turnBack();
        }
      });
    };

    _this2.deliveryWayChange = function (event) {
      var type = event.currentTarget.dataset.type;
      // WEBAPP特殊处理: 设置 取货方式 参数
      (0, _tools.updateUrlParam)('type', type);
      _this2.setData({
        selectDiscountInfo: {}, // 清空已选优惠信息
        pickUpType: type,
        sameJourneyTimeType: type == 2 ? 1 : '',
        isShowPickMask: false,
        cashOnDelivery: false
      });
      if (type == 3) {
        _this2.getSelfDeliveryList();
      } else if (type == 4) {
        _this2.getDiningFuncSetting(_this2.getDiningData);
      }
      type != 4 && _this2.getCalculationInfo();
    };

    _this2.goSameJourneyAddress = function (e) {
      var selectSameJourney = _this2.data.selectSameJourney;
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?from=preview&sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + _this2.franchisee_id);
    };

    _this2.getGoodsStoreSet = function (type) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        data: {
          pick_up_type: type,
          sub_shop_app_id: _this2.franchisee_id
        },
        success: function success(res) {
          var configData = res.data.config_data;
          if (type == 3 && configData) {
            _this.setData({
              selfAppointmentSwitch: configData.pick_up_time_status == 1 && configData.appointment.status == 1 ? true : false,
              onlyImmediatlyPickSwitch: configData.pick_up_time_status == 1 && configData.appointment.status != 1 && configData.immediate_info.self_pcik_up_status == 1 ? true : false,
              selfDeliveryPhone: configData.is_phone,
              selfDeliveryScan: configData.pick_up_time_status == 1 && configData.immediate_info.status == 1 && configData.immediate_info.scan_qrcode_status == 1 ? true : false
            });
            if (_this.data.onlyImmediatlyPickSwitch) {
              _this.showServiceTime('onlyImme');
            }
          } else if (type == 2 && configData) {
            _this.getsameJourneyTime(configData.business_rule);
          } else if (type == 4) {
            _this.setData({
              app_store_data: res.data.app_store_data || ''
            });
          }
        }
      });
    };

    _this2.showSameJourneyTime = function () {
      if (!_this2.data.selectSameJourney.id) {
        _app.appMethod.showModal({
          content: '请先选择地址'
        });
        return;
      }
      _this2.getGoodsStoreSet(2);
    };

    _this2.getsameJourneyTime = function (businessRule) {
      var sameJourneyHoursArr = [];
      var currentMinute = new Date().getMinutes() + +Number(_this2.data.sameJourneyImmediatlyTime);
      var startHours = new Date().getHours();
      if (currentMinute >= 60) {
        startHours++;
        currentMinute = currentMinute - 60;
      }
      if (businessRule.type == 1) {
        var currentLimitFlag = true;
        for (; startHours < 24; startHours++) {
          if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
            currentLimitFlag = false;
            sameJourneyHoursArr.push(startHours + ':30');
            continue;
          }
          if (currentLimitFlag && currentMinute > 30) {
            currentLimitFlag = false;
            startHours++;
          }
          sameJourneyHoursArr.push(startHours + ':00');
          sameJourneyHoursArr.push(startHours + ':30');
        }
      } else {
        var currentWeek = new Date().getDay();
        var businessTime = void 0;
        businessRule.type == 2 && businessRule.custom.business_time.map(function (item) {
          if (currentWeek == 0) {
            currentWeek = 7;
          }
          if (item.business_week[currentWeek - 1] == 1) {
            businessTime = item.business_time_interval;
          }
        });
        console.log(businessTime);
        businessTime && businessTime.map(function (item) {
          var fSH = startHours; //是否要判断分钟，初始开始小时
          var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
          var sH = Number(item.start_time.substring(0, 2));
          var eH = Number(item.end_time.substring(0, 2));
          var sT = Number(item.start_time.substring(3, 5));
          var eT = Number(item.end_time.substring(3, 5));
          if (startHours <= sH) {
            startHours = sH;
            currentMinute = 0;
          } else if (startHours > eH) {
            return;
          }
          for (; startHours <= eH; startHours++) {
            if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
              sameJourneyHoursArr.push(startHours + ':30');
              continue;
            } else if (startHours == fSH && currentMinute > 30) {
              continue;
            } //开始分钟数大于三十分钟则跳过当前时间段
            if (startHours == fEH && eT < 30) {
              sameJourneyHoursArr.push(startHours + ':00');
              continue;
            } else if (startHours == fEH && eT == 0) {
              continue;
            } //结束分钟数等于0则跳过当前时间段
            sameJourneyHoursArr.push(startHours + ':00');
            sameJourneyHoursArr.push(startHours + ':30');
          }
        });
      }
      _this2.setData({
        sameJourneyHoursArr: sameJourneyHoursArr,
        isShowSameJourneyTime: true
      });
    };

    _this2.selectSameJourneyTime = function (e) {
      var type = e.currentTarget.dataset.type;
      var sameJourneyHoursArr = _this2.data.sameJourneyHoursArr;
      var index = e.currentTarget.dataset.index;
      var sameJourneyDateTime = sameJourneyHoursArr[index];
      _this2.setData({
        sameJourneyTimeType: type == 'immedia' ? 1 : 2,
        sameJourneyDateTime: type == 'immedia' ? '' : sameJourneyDateTime,
        isShowSameJourneyTime: false
      });
    };

    _this2.inputFormControl = function (e) {
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      a[b][0].value = e.target.value;
      _this2.setData({
        additional_info: a
      });
    };

    _this2.addDeliveryImg = function () {
      var _this = _this2;
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      var images = a[b][0].value || [];
      _app.appMethod.chooseImage(function (image) {
        a[b][0].value = images.concat(image);
        _this.setData({
          additional_info: a
        });
      }, 9 - a[b][0].value.length);
    };

    _this2.deleteImage = function (e) {
      var _this = _this2;
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      var index = e.currentTarget.dataset.imageIndex;
      var images = a[b][0].value;
      images.splice(index, 1);
      a[b][0].value = images;
      _this.setData({
        additional_info: a
      });
    };

    _this2.closeGoodsPick = function () {
      _this2.setData({
        isShowPickMask: false,
        isShowServiceTime: false,
        isShowSameJourneyTime: false
      });
    };

    _this2.showServiceTime = function (type) {
      var deliveryData = _this2.data.selectDelivery;
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetEcTostoreAppointmentDateList',
        data: {
          sub_shop_app_id: _this.franchisee_id,
          self_delivery_app_store_id: deliveryData.id || ''
        },
        success: function success(res) {
          var data = res.data;
          if (type == 'onlyImme') {
            _this.setData({
              waitingQueueTime: data.duration_time,
              tostoreOrderType: 1
            });
            return;
          }
          var tostoreTimeType = data.setting_data.appointment.appointment_time_type; //1为天 2为时 3为半小时
          var tostoreDateTime = '';
          var tostoreWeekTime = '';
          var dateArr = data.date_arr;
          var advanceAppointmentInfo = data.setting_data.appointment.advance_appointment_info;
          var startHours = new Date().getHours();
          var businessTimeRule = data.business_time_rule; //上门自提营业时间
          var maxEndHour = 24;
          var currentMinute = new Date().getMinutes();
          var showImmediatelyTime = false;
          var noImmediaPick = data.setting_data.immediate_info.status == 1 && advanceAppointmentInfo.type == 1 ? true : false; //判断上门自提立即取货开关开没开
          var noAppointmentShow = true; //是否显示暂无营业时间
          if (businessTimeRule.type == 2) {
            //获取自定义当天营业时间的终止小时
            var week = dateArr[0].week;
            var timeArr = void 0;
            businessTimeRule.custom.business_time.map(function (item) {
              if (week == 0) {
                week = 7;
              }
              if (item.business_week[week - 1] == 1) {
                timeArr = item.business_time_interval;
                maxEndHour = +timeArr[timeArr.length - 1].end_time.substring(0, 2);
              }
            });
            timeArr && timeArr.map(function (item) {
              var sH = Number(item.start_time.substring(0, 2));
              var eH = Number(item.end_time.substring(0, 2));
              var sT = Number(item.start_time.substring(3, 5));
              var eT = Number(item.end_time.substring(3, 5));
              if (startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) {
                showImmediatelyTime = true;
              }
            });
          } else {
            showImmediatelyTime = true;
          }
          for (var i = 0; i < dateArr.length; i++) {
            if (i == 0 && (advanceAppointmentInfo.type == 2 && +advanceAppointmentInfo.num + startHours >= maxEndHour || advanceAppointmentInfo.type == 1 && startHours >= maxEndHour)) {
              dateArr[i].is_vaild = 0;
              noImmediaPick = false;
            }
            if (dateArr[i].is_vaild == 1 && tostoreTimeType != 1) {
              tostoreDateTime = dateArr[i].date;
              tostoreWeekTime = dateArr[i].week;
              break;
            }
          }
          dateArr.map(function (item) {
            if (item.is_vaild == 1) {
              noAppointmentShow = false;
            }
          });
          _this.businessTimeType = businessTimeRule.type;
          _this.setData({
            getEcTostoredate: data,
            waitingQueueTime: data.duration_time,
            tostoreTimeType: tostoreTimeType,
            isShowServiceTime: true,
            noImmediaPick: noImmediaPick,
            tostoreDateTime: _this.data.tostoreDateTime ? _this.data.tostoreDateTime : tostoreDateTime,
            tostoreWeekTime: _this.data.tostoreWeekTime ? _this.data.tostoreWeekTime : tostoreWeekTime,
            businessTimeRule: businessTimeRule.type == 1 ? '' : businessTimeRule.custom.business_time,
            advanceAppointmentInfo: advanceAppointmentInfo,
            noAppointmentShow: noAppointmentShow,
            showImmediatelyTime: showImmediatelyTime
          });
          if (tostoreTimeType != 1) {
            _this.getTostoreTime();
          }
          businessTimeRule.type == 2 && _this.getNoAppointmentWord();
        }
      });
    };

    _this2.getNoAppointmentWord = function () {
      var a = '商家营业时间：';
      var b = '';
      var businessTimeRule = _this2.data.businessTimeRule;
      businessTimeRule.map(function (item) {
        for (var i = 0; i < item.business_week.length; i++) {
          if (item.business_week[i] == 1) {
            switch (i) {
              case 0:
                a += '周一、';
                break;
              case 1:
                a += '周二、';
                break;
              case 2:
                a += '周三、';
                break;
              case 3:
                a += '周四、';
                break;
              case 4:
                a += '周五、';
                break;
              case 5:
                a += '周六、';
                break;
              case 6:
                a += '周日、';
                break;
            }
          }
        }
        item.business_time_interval.map(function (item) {
          a += item.start_time + '-' + item.end_time + ' ';
        });
      });
      var appointment = _this2.data.getEcTostoredate.setting_data.appointment;
      var advanceInfo = appointment.advance_appointment_info;
      switch (advanceInfo.type) {
        case '1':
          b += '无需提前，';
          break;
        case '2':
          b += '需提前' + advanceInfo.num + '小时，';
          break;
        case '3':
          b += '需提前' + advanceInfo.num + '天，';
          break;
      }
      b += '最多可预约' + appointment.valid_days + '天内时间';
      _this2.setData({
        noAppointmentWorda: a,
        noAppointmentWordb: b
      });
    };

    _this2.selectTostoreTime = function (e) {
      var dateArr = _this2.data.getEcTostoredate.date_arr;
      var index = e.currentTarget.dataset.index;
      var tostoreDateTime = dateArr[index].date;
      var tostoreWeekTime = dateArr[index].week;
      _this2.setData({
        tostoreOrderType: 2,
        dateIndex: index,
        tostoreDateTime: tostoreDateTime,
        tostoreWeekTime: tostoreWeekTime,
        isShowServiceTime: _this2.data.tostoreTimeType != 1 ? true : false
      });
      _this2.getTostoreTime();
    };

    _this2.getTostoreTime = function () {
      var currentMonth = new Date().getMonth() + 1;
      var currentMinute = new Date().getMinutes();
      var startHours = new Date().getHours();
      var currentDay = new Date().getDate();
      var currentDate = (currentMonth < 10 ? '0' + currentMonth : currentMonth) + '-' + (currentDay < 10 ? '0' + currentDay : currentDay);
      var tostoreHoursArr = [];
      var currentLimitFlag = true;
      var businessTimeRule = _this2.data.businessTimeRule;
      var tostoreWeekTime = Number(_this2.data.tostoreWeekTime);
      var businessTime = void 0;
      var showImmediatelyTime = _this2.businessTimeType == 1 ? true : false; //1为全年 2为自定义
      var advanceAppointmentInfo = _this2.data.advanceAppointmentInfo;
      var advanceTime = +advanceAppointmentInfo.num + startHours > 24 ? +advanceAppointmentInfo.num + startHours - 24 : +advanceAppointmentInfo.num + startHours;
      _this2.businessTimeType == 2 && businessTimeRule.map(function (item) {
        if (tostoreWeekTime == 0) {
          tostoreWeekTime = 7;
        }
        if (item.business_week[tostoreWeekTime - 1] == 1) {
          businessTime = item.business_time_interval;
        }
      });
      if (currentDate === _this2.data.tostoreDateTime) {
        if (_this2.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = startHours; //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            if (startHours < advanceTime) {
              fSH = startHours = advanceTime;
            }
            if ((startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) && !advanceTime) {
              showImmediatelyTime = true;
            }
            if (startHours < sH) {
              startHours = sH;
              currentMinute = 0;
            } else if (startHours > eH) {
              return;
            }
            for (; startHours <= eH; startHours++) {
              if (_this2.data.tostoreTimeType == 2) {
                if (startHours == fEH) {
                  continue;
                }
                tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
              } else {
                if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
                  tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                  continue;
                } else if (startHours == fSH && currentMinute > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (startHours == fEH && eT >= 30) {
                  tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                  continue;
                } else if (startHours == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
              }
            }
          });
        } else {
          if (startHours < advanceTime) {
            startHours = advanceTime;
          }
          for (; startHours < 24; startHours++) {
            if (_this2.data.tostoreTimeType == 2) {
              if (currentLimitFlag && currentMinute > 0) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
            } else {
              if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
                currentLimitFlag = false;
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                continue;
              }
              if (currentLimitFlag && currentMinute > 30) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
              tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
            }
          }
        }
      } else {
        if (_this2.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = Number(item.start_time.substring(0, 2)); //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            if (_this2.data.getEcTostoredate.date_arr[1].date == _this2.data.tostoreDateTime && sH < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
              sH = advanceTime;
            }
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            for (; sH <= eH; sH++) {
              if (_this2.data.tostoreTimeType == 2) {
                if (sH == fEH || sH == fSH && sT > 0) {
                  continue;
                }
                tostoreHoursArr.push(sH + ':00-' + (sH + 1) + ':00');
              } else {
                if (sH == fSH && sT <= 30 && sT != 0) {
                  tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
                  continue;
                } else if (sH == fSH && sT > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (sH == fEH && eT <= 30 && eT != 0) {
                  tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                  continue;
                } else if (sH == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
              }
            }
          });
        } else {
          var i = 0;
          if (_this2.data.getEcTostoredate.date_arr[1].date == _this2.data.tostoreDateTime && i < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
            i = advanceTime;
          }
          for (; i < 24; i++) {
            if (_this2.data.tostoreTimeType == 2) {
              tostoreHoursArr.push(i + ':00-' + (i + 1) + ':00');
            } else {
              tostoreHoursArr.push(i + ':00-' + i + ':30');
              tostoreHoursArr.push(i + ':30-' + (i + 1) + ':00');
            }
          }
          dateArr.map(function (item) {
            if (item.is_vaild == 1) {
              noAppointmentShow = false;
            }
          });
          _this.businessTimeType = businessTimeRule.type;
          _this.setData({
            getEcTostoredate: data,
            waitingQueueTime: data.duration_time,
            tostoreTimeType: tostoreTimeType,
            isShowServiceTime: true,
            noImmediaPick: noImmediaPick,
            tostoreDateTime: _this.data.tostoreDateTime ? _this.data.tostoreDateTime : tostoreDateTime,
            tostoreWeekTime: _this.data.tostoreWeekTime ? _this.data.tostoreWeekTime : tostoreWeekTime,
            businessTimeRule: businessTimeRule.type == 1 ? '' : businessTimeRule.custom.business_time,
            advanceAppointmentInfo: advanceAppointmentInfo,
            noAppointmentShow: noAppointmentShow
          });
          if (tostoreTimeType != 1) {
            _this.getTostoreTime();
          }
          businessTimeRule.type == 2 && _this.getNoAppointmentWord();
        }
      }
      _this2.setData({
        tostoreHoursArr: tostoreHoursArr,
        showImmediatelyTime: showImmediatelyTime
      });
    };

    _this2.selectTostoreHourTime = function (e) {
      var tostoreHoursArr = _this2.data.tostoreHoursArr;
      var index = e.currentTarget.dataset.index;
      var tostoreHourTime = tostoreHoursArr[index];
      _this2.setData({
        tostoreOrderType: 2,
        tostoreHourTime: tostoreHourTime,
        isShowServiceTime: false
      });
      _this2.getTostoreTime();
    };

    _this2.getSelfDeliveryList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getSelfDeliveryList',
        data: {
          sub_shop_app_id: _this.franchisee_id
        },
        success: function success(res) {
          var storeList = res.data.store_list_data;
          if (!storeList) {
            _app.appMethod.showModal({
              content: '商家暂无自提门店',
              confirm: function confirm() {
                _app.appMethod.turnBack();
              }
            });
            return;
          }
          if (storeList.length == 1) {
            _this.setData({
              selectDelivery: storeList[0]
            });
          }
          if (storeList.length >= 2 && !_this.data.selectDelivery) {
            _app.appMethod.showModal({
              content: '当前尚未选择自提点',
              confirmText: '去设置',
              cancelText: '取消',
              showCancel: true,
              confirm: function confirm() {
                _this.toDeliveryList();
              }
            });
          }
          _this.getGoodsStoreSet(3);
        }
      });
    };

    _this2.tostoreImmediately = function () {
      _this2.setData({
        tostoreOrderType: 1,
        tostoreHourTime: '',
        isShowServiceTime: false
      });
    };

    _this2.getPhoneNumber = function (e) {
      var that = _this2;
      if (/getPhoneNumber:fail/.test(e.detail.errMsg)) {
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/GetPhoneNumber',
        data: {
          encryptedData: e.detail.encryptedData,
          iv: e.detail.iv
        },
        success: function success(res) {
          _app.appMethod.setUserInfoStorage({
            phone: res.data
          });
          that.setData({
            phone: res.data
          });
        },
        successStatus5: function successStatus5() {
          _app.appMethod.showModal({
            content: '获取手机号失败，请再次点击授权获取'
          });
          // app.goLogin({
          //   success: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   },
          //   fail: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   }
          // })
        }
      });
    };

    _this2.getInStoreSeat = function () {
      var _this = _this2;
      _app.appMethod.scanCode({
        success: function success(res) {
          var path = res.path;
          var locationId = path.split(/\?location_id=/)[1];
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppEcommerce/getEcLocationData',
            data: {
              id: locationId,
              sub_shop_app_id: _this.franchisee_id
            },
            success: function success(res) {
              if (res.data.status == 0) {
                _this.setData({
                  locationId: locationId,
                  inStoreSeatName: res.data.title
                });
              } else {
                _app.appMethod.showModal({
                  content: '未检索到座位号'
                });
              }
            }
          });
        },
        fail: function fail(res) {
          _app.appMethod.showModal({
            content: '未检索到座位号'
          });
        }
      });
    };

    _this2.inputPhone = function (e) {
      _this2.setData({
        phone: e.target.value
      });
    };

    _this2.hidePerfectAddress = function () {
      _this2.setData({
        expressAddressNull: false
      });
    };

    _this2.manuallyAddAddress = function () {
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress');
    };

    _this2.importWeChatAddress = function () {
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.getCalculationInfo();
            }
          });
        }
      });
    };

    _this2.getDiningFuncSetting = function (callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getFuncSetting',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          ordering_food_type: 1, //1.堂食 2.预约
          pick_up_type: 4
        },
        success: function success(res) {
          var arr = res.data.take_meal_type || [];
          var brr = [];
          for (var i = 0; i < arr.length; i++) {
            brr.push({
              label: arr[i],
              value: that.data.take_meal_type_text[arr[i]]
            });
          }
          ;that.path = res.data.add_dish_info.page || '', that.setData({
            take_meal_type: arr[0],
            take_meal_type_arr: brr,
            location_status: res.data.location_status == 0 ? false : true,
            account_type: res.data.account_info.account_type,
            allow_add_dish: res.data.add_dish_info.allow_app_status == 1 ? true : false,
            allow_app_account: res.data.account_info.account_way[1] ? true : false
          });
          typeof callback == 'function' && callback();
        }
      });
    };

    _this2.checkIsAddDishing = function () {
      var that = _this2;
      if (that.data.account_type == 1) {
        that.getCalculationInfo();
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/CheckLocationIsEmpty',
        data: {
          location_id: _this2.data.ec_location_id
        },
        success: function success(res) {
          that.setData({
            is_addDishing: !res.data,
            people_num: !res.data ? 0 : that.data.people_num
          });
          that.getCalculationInfo();
        }
      });
    };

    _this2.turnToAddDish = function () {
      if (_this2.franchisee_id) {
        var that = _this2;
        _app.appMethod.showModal({
          title: '温馨提示',
          content: '子店商品继续点菜只能跳转子店首页或者连锁首页',
          showCancel: true,
          confirm: function confirm() {
            that.goToHomepage();
          }
        });
        return;
      }
      var form = JSON.parse(_this2.path);
      var action = form.action;
      customEvent.clickEventHandler[action] && customEvent.clickEventHandler[action](form, '', '');
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.franchisee_id;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = Taro.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({ delta: 2 });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
      }
    };

    _this2.scanPlaceInfo = function (e) {
      var that = _this2;
      _this2.saveFormId(e.detail.formId);
      _app.appMethod.scanCode({
        success: function success(res) {
          var path = res.path;
          if (!path) {
            _app.appMethod.showModal({
              content: '位置码错误，请重新扫码!',
              confirmText: '知道了'
            });
            return;
          }
          var args = path.split('?');
          if (args[0] == path) {
            return '';
          }
          var arr = args[1].split('&');
          var obj = {};
          for (var i = 0; i < arr.length; i++) {
            var arg = arr[i].split('=');
            obj[arg[0]] = arg[1];
          }
          var pre_location_id = that.data.ec_location_id;
          that.scanInitUserInfo(pre_location_id, obj.ec_location_id, that.checkIsAddDishing);
        },
        fail: function fail(re) {
          console.log(re);
        }
      });
    };

    _this2.scanInitUserInfo = function (pre_location_id, ec_location_id, callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/scanQrcodeInitCartUserInfo',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          pre_location_id: pre_location_id || '',
          location_id: ec_location_id || _this2.data.ec_location_id,
          cart_id_arr: _this2.cart_id_arr_my
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            if (that.franchisee_id) {
              _app.appMethod.globalData[that.franchisee_id] = {};
              _app.appMethod.globalData[that.franchisee_id].ec_location_id = ec_location_id;
            } else {
              _app.appMethod.globalData.ec_location_id = ec_location_id; // 更新全局座位id
            }
            that.setData({
              ec_location_id: ec_location_id,
              location_name: res.data.location_title || ''
            });
            typeof callback == 'function' && callback(that.getCalculationInfo);
          }
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          if (res.status == 1) {
            that.data.ec_location_id && that.data.is_together && that.loopRequestMultiOrder();
          }
        }
      });
    };

    _this2.saveFormId = function (form_id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function success(res) {}
      });
    };

    _this2.changeTakeMealType = function (value) {
      var index = _this2.state.take_meal_type_arr.findIndex(function (item) {
        return item.value === value[0];
      });
      _this2.setData({
        take_meal_type_index: index,
        take_meal_type: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.changeDiningMode = function (value) {
      _this2.setData({
        dining_mode: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.changeCustomNum = function (value) {
      _this2.setData({
        people_num: value[0]
      });
      _this2.getCalculationInfo();
    };

    _this2.turnToStore = function () {};

    _this2.callPhone = function (event) {
      _app.appMethod.callPhone(event);
    };

    document.title = '确认支付';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData) {
      _this2.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this2;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(PreviewSeckillOrder, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      var callbackData = this.currentPage.callbackData;

      if (callbackData) {
        this.setData(callbackData);
        this.currentPage.clearCallbackData();
        if (this.currentPage.additional_info) {
          this.additional_info = this.currentPage.additional_info;
          delete this.currentPage.additional_info;
        }
        if (this.currentPage.hasRequiredSuppInfo) {
          this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
          delete this.currentPage.hasRequiredSuppInfo;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchisee_id = options.franchisee || '';
      var teamToken = options.team_token || '';
      var group_buy_people = options.group_buy_people || 0;
      var limit_buy = options.limit_buy || '';
      var pickUpType = options.type || '';
      var seckillType = options.secType || 0;
      this.franchisee_id = options.franchisee || '';
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      this.is_group = options.is_group || '';
      var ec_location_id = '';
      if (this.franchisee_id) {
        ec_location_id = _app.appMethod.globalData[this.franchisee_id] ? _app.appMethod.globalData[this.franchisee_id].ec_location_id : '';
      } else {
        ec_location_id = options.ec_location_id || _app.appMethod.globalData.ec_location_id || '';
      }
      this.setData({
        ec_location_id: ec_location_id,
        limit_buy: limit_buy,
        pickUpType: pickUpType,
        is_group: this.is_group,
        teamToken: teamToken,
        group_buy_people: group_buy_people,
        phone: _app.appMethod.getUserInfo().phone,
        seckillType: seckillType
      });
      this.selectPickMethod('first', seckillType);
      this.dataInitial();
      // WEBAPP特殊处理(这里是有问题的，待解决)
      setTimeout(function () {
        _this3.handleCurrentPage();
      }, 0);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromSelectAddress) {
        this.getCalculationInfo();
        this.isFromSelectAddress = false;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcountArr && this.downcountArr.length) {
        this.downcountArr = this.downcountArr.concat().reverse();
        for (var i = 0; i < this.downcountArr.length; i++) {
          this.downcountArr[i] && this.downcountArr[i].clear();
        }
      }
    }
    // wxPay = param => {
    //   var that = this
    //   app.requestPayment({
    //     timeStamp: param.timeStamp,
    //     nonceStr: param.nonceStr,
    //     package: param.package,
    //     signType: param.signType,
    //     paySign: param.paySign,
    //     success: function (res) {
    //       app.wxPaySuccess(param)
    //       param.success()
    //     },
    //     fail: function (res) {
    //       if (res.errMsg === 'requestPayment:fail cancel') {
    //         app.showModal({
    //           content: '支付已取消',
    //           complete: param.fail
    //         })
    //         return
    //       }
    //       app.showModal({
    //         content: '支付失败',
    //         complete: param.fail
    //       })
    //       app.wxPayFail(param, res.errMsg)
    //     }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          discountList = _state.discountList,
          location_name = _state.location_name,
          is_addDishing = _state.is_addDishing,
          customNumArr = _state.customNumArr,
          people_num = _state.people_num,
          pickUpTypeArr = _state.pickUpTypeArr,
          pickUpType = _state.pickUpType,
          selectAddress = _state.selectAddress,
          storeStyle = _state.storeStyle,
          selectDelivery = _state.selectDelivery,
          selectSameJourney = _state.selectSameJourney,
          dining_mode_arr = _state.dining_mode_arr,
          dining_mode = _state.dining_mode,
          take_meal_type_arr = _state.take_meal_type_arr,
          take_meal_type_index = _state.take_meal_type_index,
          take_meal_type = _state.take_meal_type,
          ec_location_id = _state.ec_location_id,
          sameJourneyTimeType = _state.sameJourneyTimeType,
          sameJourneyImmediatlyTime = _state.sameJourneyImmediatlyTime,
          sameJourneyDateTime = _state.sameJourneyDateTime,
          selfAppointmentSwitch = _state.selfAppointmentSwitch,
          tostoreDateTime = _state.tostoreDateTime,
          tostoreTimeType = _state.tostoreTimeType,
          tostoreOrderType = _state.tostoreOrderType,
          waitingQueueTime = _state.waitingQueueTime,
          tostoreHourTime = _state.tostoreHourTime,
          onlyImmediatlyPickSwitch = _state.onlyImmediatlyPickSwitch,
          selfDeliveryPhone = _state.selfDeliveryPhone,
          phone = _state.phone,
          selfDeliveryScan = _state.selfDeliveryScan,
          inStoreSeatName = _state.inStoreSeatName,
          goodsList = _state.goodsList,
          is_group = _state.is_group,
          exchangeCouponData = _state.exchangeCouponData,
          group_buy_price = _state.group_buy_price,
          original_price = _state.original_price,
          activePreferential = _state.activePreferential,
          express_fee = _state.express_fee,
          box_fee = _state.box_fee,
          server_fee = _state.server_fee,
          tissue_fee = _state.tissue_fee,
          account_type = _state.account_type,
          selectDiscountInfo = _state.selectDiscountInfo,
          selectDiscountIndex = _state.selectDiscountIndex,
          discount_cut_price = _state.discount_cut_price,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          cashOnDelivery = _state.cashOnDelivery,
          totalPayment = _state.totalPayment,
          canCashDelivery = _state.canCashDelivery,
          selfPayOnDelivery = _state.selfPayOnDelivery,
          orderRemark = _state.orderRemark,
          hasRequiredSuppInfo = _state.hasRequiredSuppInfo,
          deliverydWrite = _state.deliverydWrite,
          noAdditionalInfo = _state.noAdditionalInfo,
          aloneDeliveryShow = _state.aloneDeliveryShow,
          additional_info = _state.additional_info,
          additional_goodsid_arr = _state.additional_goodsid_arr,
          allow_add_dish = _state.allow_add_dish,
          dialogHidden = _state.dialogHidden,
          selectModelInfo = _state.selectModelInfo,
          goodsInfo = _state.goodsInfo,
          intraCityData = _state.intraCityData,
          dining_data = _state.dining_data,
          isShowPickMask = _state.isShowPickMask,
          noImmediaPick = _state.noImmediaPick,
          showImmediatelyTime = _state.showImmediatelyTime,
          getEcTostoredate = _state.getEcTostoredate,
          dateIndex = _state.dateIndex,
          tostoreHoursArr = _state.tostoreHoursArr,
          noAppointmentShow = _state.noAppointmentShow,
          noAppointmentWordb = _state.noAppointmentWordb,
          noAppointmentWorda = _state.noAppointmentWorda,
          isShowServiceTime = _state.isShowServiceTime,
          sameJourneyHoursArr = _state.sameJourneyHoursArr,
          isShowSameJourneyTime = _state.isShowSameJourneyTime,
          expressAddressNull = _state.expressAddressNull;

      customNumArr = customNumArr.map(function (item) {
        return { label: item, value: item };
      });
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'official-page preview-seckill-order' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u652F\u4ED8' }),
          _react2.default.createElement(
            'div',
            { className: 'preview-goods-wrap' },
            is_addDishing && _react2.default.createElement(
              'div',
              {
                className: 'pick-method flex-between',
                style: (0, _tools.convertLineStyleData)('font-weight:bold;')
              },
              _react2.default.createElement(
                'span',
                null,
                '\u684C\u4F4D\u53F7'
              ),
              _react2.default.createElement(
                'span',
                null,
                location_name
              )
            ),
            is_addDishing && _react2.default.createElement(
              'div',
              { className: 'pick-method', style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;') },
              _react2.default.createElement(
                _picker2.default,
                {
                  className: 'pick-method-box',
                  style: (0, _tools.convertLineStyleData)('border-bottom:0;'),
                  cols: 1,
                  data: customNumArr,
                  value: [+people_num],
                  onChange: this.changeCustomNum
                },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                    '\u5C31\u9910\u4EBA\u6570'
                  ),
                  _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right pick-method-title',
                      style: (0, _tools.convertLineStyleData)('font-weight:bold;')
                    },
                    people_num
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'pick-method',
                onClick: pickUpTypeArr && pickUpTypeArr.length > 1 ? this.selectPickMethod : null,
                hidden: is_addDishing
              },
              _react2.default.createElement(
                'div',
                { className: 'pick-method-box' },
                '\u53D6\u8D27\u65B9\u5F0F',
                (pickUpTypeArr && pickUpTypeArr.length) > 1 && _react2.default.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                _react2.default.createElement(
                  'span',
                  {
                    className: 'pull-right pick-method-title',
                    style: (0, _tools.convertLineStyleData)(pickUpType == 4 ? 'font-weight:bold;' : '')
                  },
                  pickUpType == 1 ? '快递' : pickUpType == 2 ? '同城' : pickUpType == 3 ? '自提' : '点餐'
                )
              )
            ),
            pickUpType == 1 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectAddress && selectAddress.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goToMyAddress,
                    'data-address-id': selectAddress.id
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectAddress.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectAddress.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-box',
                    onClick: this.goToMyAddress
                  },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u65B0\u589E\u5730\u5740'
                    )
                  )
                )
              )
            ),
            pickUpType == 3 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectDelivery.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.toDeliveryList,
                    'data-address-id': selectDelivery.id
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u81EA\u63D0'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectDelivery.contact_name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectDelivery.service_phone
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectDelivery.region_data.region_string + selectDelivery.address_detail
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-null-box',
                    onClick: this.toDeliveryList
                  },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u9009\u62E9\u81EA\u63D0\u70B9'
                    )
                  )
                )
              )
            ),
            pickUpType == 2 && _react2.default.createElement(
              'div',
              { className: 'preview-section' },
              selectSameJourney && selectSameJourney.id ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  {
                    className: 'address-box',
                    onClick: this.goSameJourneyAddress
                  },
                  _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'address-detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u540C\u57CE'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectSameJourney.address_info.name
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        selectSameJourney.address_info.contact
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectSameJourney.address_info.province.text + selectSameJourney.address_info.city.text + selectSameJourney.address_info.district.text + selectSameJourney.address_info.detailAddress
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'address-null-box' },
                  _react2.default.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  _react2.default.createElement(
                    'div',
                    { onClick: this.goSameJourneyAddress },
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u9009\u62E9\u540C\u57CE\u5730\u5740'
                    )
                  )
                )
              )
            ),
            pickUpType == 4 && !is_addDishing && _react2.default.createElement(
              'div',
              { className: 'eating-info-wrapper' },
              _react2.default.createElement(
                'div',
                { className: 'eating-info-item flex-between' },
                _react2.default.createElement(
                  'span',
                  { className: 'mustFill' },
                  '\u5C31\u9910\u4EBA\u6570'
                ),
                _react2.default.createElement(
                  _picker2.default,
                  {
                    className: 'eating-picker',
                    cols: 1,
                    data: customNumArr,
                    value: [+people_num],
                    onChange: this.changeCustomNum
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                      people_num || 1
                    ),
                    _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'eating-info-item flex-between' },
                _react2.default.createElement(
                  'span',
                  { className: 'mustFill' },
                  '\u5C31\u9910\u65B9\u5F0F'
                ),
                _react2.default.createElement(
                  _picker2.default,
                  {
                    className: 'eating-picker',
                    cols: 1,
                    data: dining_mode_arr,
                    value: [dining_mode],
                    onChange: this.changeDiningMode
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                      dining_mode == 2 ? '打包' : '堂食'
                    ),
                    _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'eating-info-item flex-between' },
                _react2.default.createElement(
                  'span',
                  { className: 'mustFill' },
                  '\u53D6\u9910\u65B9\u5F0F'
                ),
                _react2.default.createElement(
                  _picker2.default,
                  {
                    className: 'eating-picker',
                    cols: 1,
                    data: take_meal_type_arr,
                    onChange: this.changeTakeMealType,
                    value: [take_meal_type]
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                      take_meal_type_arr[take_meal_type_index] && take_meal_type_arr[take_meal_type_index].label
                    ),
                    _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'eating-info-item flex-between' },
                _react2.default.createElement(
                  'span',
                  { className: take_meal_type == 1 ? 'mustFill' : '' },
                  '\u684C\u53F7'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'flex-between',
                    onClick: this.scanPlaceInfo,
                    style: (0, _tools.convertLineStyleData)('flex:1;')
                  },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#999;text-align:right;width:100%;') },
                    ec_location_id ? location_name : '扫码获取位置信息'
                  ),
                  _react2.default.createElement('span', {
                    className: 'ico-moon icon-shopping-scan',
                    style: (0, _tools.convertLineStyleData)('padding-left:20rpx;font-size:30rpx;color:#999;')
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'address-bg' },
              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png' })
            ),
            pickUpType == 2 && _react2.default.createElement(
              'div',
              { className: 'preview-box margin-bottom-16' },
              _react2.default.createElement(
                'div',
                {
                  onClick: this.showSameJourneyTime,
                  className: 'single-box'
                },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    sameJourneyTimeType == 1 ? '尽快送达(预计' + (sameJourneyImmediatlyTime || '') + '分钟后送达)' : sameJourneyDateTime ? '大约' + sameJourneyDateTime + '送达' : '请选择送达时间'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              )
            ),
            pickUpType == 3 && _react2.default.createElement(
              'div',
              { className: 'preview-box border-bottom30' },
              selfAppointmentSwitch && _react2.default.createElement(
                'div',
                { onClick: this.showServiceTime, className: 'single-box' },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  tostoreTimeType == 1 && tostoreDateTime && tostoreOrderType == 2 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime)
                  ) : tostoreTimeType == 1 && tostoreOrderType == 1 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    waitingQueueTime == 0 ? '立即取货' : '大约等待' + waitingQueueTime + '分钟'
                  ) : tostoreTimeType != 1 && tostoreHourTime && tostoreOrderType == 2 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime) + ' ' + tostoreHourTime
                  ) : tostoreTimeType != 1 && tostoreOrderType == 1 ? _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    dateTrans.date(tostoreDateTime) + (waitingQueueTime == 0 ? ' 立即取货' : '大约等待' + waitingQueueTime + '分钟')
                  ) : _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u8BF7\u9009\u62E9\u65F6\u95F4'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              onlyImmediatlyPickSwitch && waitingQueueTime >= 0 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u53D6\u8D27\u65F6\u95F4',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right appointment-time-box' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'appointment-time',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟'
                  )
                )
              ),
              selfDeliveryPhone == 1 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u8054\u7CFB\u624B\u673A\u53F7',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right input-phone-box' },
                  _react2.default.createElement('input', {
                    type: 'text',
                    onChange: this.inputPhone,
                    value: phone,
                    placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
                  }),
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'get-phone-number',
                      onClick: this.getPhoneNumber,
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '\u81EA\u52A8\u6388\u6743'
                  )
                )
              ),
              selfDeliveryScan && _react2.default.createElement(
                'div',
                { className: 'single-box', onClick: this.getInStoreSeat },
                '\u5E97\u5185\u4F4D\u7F6E',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right scan-seat-box' },
                  _react2.default.createElement(
                    'span',
                    null,
                    inStoreSeatName || '请扫码获取位置信息'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-shopping-scan' })
                )
              )
            ),
            goodsList.map(function (goods, goodsIndex) {
              return _react2.default.createElement(
                'div',
                { className: 'preview-goods-order-list', key: goodsIndex },
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-time' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'countdown',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    goods.seckill_start_state == 0 ? _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u5F00\u59CB'
                    ) : goods.seckill_start_state == 1 ? _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u7ED3\u675F\u8FD8\u5269'
                    ) : goods.seckill_start_state == 2 && _react2.default.createElement(
                      'label',
                      null,
                      '\u5DF2\u7ED3\u675F'
                    ),
                    !!goods.downCount.days && _react2.default.createElement(
                      'span',
                      { className: 'days' },
                      goods.downCount.days + '天'
                    ),
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'hours countdown-text',
                        style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                      },
                      goods.downCount.hours
                    ),
                    ':',
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'minutes countdown-text',
                        style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                      },
                      goods.downCount.minutes
                    ),
                    ':',
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'seconds countdown-text',
                        style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme)
                      },
                      goods.downCount.seconds
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'preview-goods-order-item' },
                  _react2.default.createElement('img', {
                    className: 'preview-goods-cover',
                    src: goods.cover,
                    mode: 'aspectFill'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-title' },
                      _react2.default.createElement(
                        'span',
                        { className: 'exchange-tip' },
                        '\u79D2\u6740'
                      ),
                      goods.title
                    ),
                    goods.model_value_str && _react2.default.createElement(
                      'div',
                      { className: 'preview-goods-model' },
                      goods.model_value_str
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-price-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'preview-goods-price',
                          style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                        },
                        '¥' + goods.price
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-original-price' },
                        '¥' + goods.original_price
                      ),
                      !is_group && _react2.default.createElement(
                        'div',
                        { className: 'good-number-box pull-right' },
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'goods-minus',
                            'data-index': goodsIndex,
                            onClick: _this4.clickMinusButton
                          },
                          '-'
                        ),
                        _react2.default.createElement('input', {
                          className: 'goods-count',
                          'data-index': goodsIndex,
                          type: 'number',
                          value: goods.num,
                          onChange: _this4.inputGoodsCount
                        }),
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'goods-plus',
                            style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                            'data-index': goodsIndex,
                            onClick: _this4.clickPlusButton
                          },
                          '+'
                        )
                      ),
                      is_group && _react2.default.createElement(
                        'div',
                        { className: 'good-number-box pull-right' },
                        _react2.default.createElement(
                          'div',
                          { className: 'group-count' },
                          '数量：' + goods.num
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'seckill-remaining-num' },
                      '当前剩余件数：' + goods.stock
                    )
                  )
                )
              );
            }),
            exchangeCouponData.hasSelectGoods && _react2.default.createElement(
              'div',
              { className: 'preview-goods-order-list' },
              _react2.default.createElement(
                'div',
                { className: 'preview-goods-order-item' },
                _react2.default.createElement('img', {
                  className: 'preview-goods-cover',
                  src: exchangeCouponData.goodsInfo.cover
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'preview-goods-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-title' },
                    _react2.default.createElement(
                      'span',
                      { className: 'exchange-tip' },
                      '\u8D60\u54C1'
                    ),
                    exchangeCouponData.goodsInfo.title
                  ),
                  exchangeCouponData.goodsInfo.model_value_str && _react2.default.createElement(
                    'div',
                    { className: 'preview-goods-model' },
                    exchangeCouponData.goodsInfo.model_value_str
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-number-contain' },
                    _react2.default.createElement(
                      'div',
                      { className: 'exchange-num pull-right' },
                      'x1'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'preview-box' },
              _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u5546\u54C1\u91D1\u989D',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + (is_group ? group_buy_price : original_price)
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u6D3B\u52A8\u4F18\u60E0',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '秒杀-￥' + activePreferential
                )
              ),
              pickUpType != 4 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u8FD0\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + express_fee
                )
              ),
              pickUpType == 4 && box_fee > 0 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u9910\u76D2\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + box_fee
                )
              ),
              pickUpType == 4 && server_fee > 0 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u670D\u52A1\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + server_fee
                )
              ),
              pickUpType == 4 && tissue_fee > 0 && _react2.default.createElement(
                'div',
                { className: 'single-box' },
                '\u7EB8\u5DFE\u8D39',
                _react2.default.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + tissue_fee
                )
              ),
              !!discountList.length && _react2.default.createElement(
                'div',
                {
                  onClick: this.showMemberDiscount,
                  hidden: pickUpType == 4 && account_type == 2
                },
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'pull-right' },
                    selectDiscountInfo.name
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    hidden: selectDiscountIndex == 0,
                    className: 'balance-price'
                  },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '- ¥' + discount_cut_price
                  )
                )
              ),
              balance != 0 && _react2.default.createElement(
                'div',
                { hidden: pickUpType == 4 && account_type == 2 },
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F7F\u7528\u50A8\u503C\u91D1'
                  ),
                  _react2.default.createElement(_switch2.default, {
                    color: storeStyle.theme,
                    style: (0, _tools.convertLineStyleData)('transform:scale(0.7);'),
                    className: 'pull-right',
                    checked: useBalance,
                    onChange: this.useBalanceChange
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { hidden: !useBalance, className: 'balance-price' },
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    '- ¥' + deduction
                  )
                )
              ),
              totalPayment > 0 && (pickUpType == 1 && canCashDelivery == 1 || pickUpType == 3 && selfPayOnDelivery == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'balance-switch' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8D27\u5230\u4ED8\u6B3E\uFF08\u5148\u4E0B\u5355\uFF0C\u9A8C\u8D27\u540E\u652F\u4ED8\uFF09'
                  ),
                  _react2.default.createElement(_switch2.default, {
                    color: storeStyle.theme,
                    className: 'pull-right',
                    onChange: this.useCashDelivery,
                    checked: cashOnDelivery
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'preview-box' },
              _react2.default.createElement(
                'div',
                { className: 'buyer-message single-box' },
                '\u4E70\u5BB6\u7559\u8A00',
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right' },
                  _react2.default.createElement('input', {
                    className: 'remark',
                    value: orderRemark,
                    onChange: this.remarkInput,
                    placeholder: '\u4E70\u5BB6\u7559\u8A00'
                  })
                )
              ),
              !noAdditionalInfo && !aloneDeliveryShow && _react2.default.createElement(
                'div',
                {
                  className: 'border-top1 single-box',
                  onClick: this.goToAdditionalInfo
                },
                '\u8865\u5145\u4FE1\u606F',
                _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                _react2.default.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + (hasRequiredSuppInfo && !deliverydWrite ? storeStyle.theme : '#666')),
                    className: 'additional-tip pull-right'
                  },
                  deliverydWrite ? '已填写' : '未填写'
                )
              )
            ),
            aloneDeliveryShow && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              additional_info[additional_goodsid_arr[0]].map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'additional-list', key: index },
                  item.type == 'text' && _react2.default.createElement(
                    'div',
                    { className: 'additional-text' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      _react2.default.createElement('input', {
                        type: 'text',
                        onChange: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'mul-text' && _react2.default.createElement(
                    'div',
                    { className: 'additional-textarea' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      _react2.default.createElement('textarea', {
                        maxlength: '-1',
                        onInput: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'picture' && _react2.default.createElement(
                    'div',
                    { className: 'additional-picture' },
                    _react2.default.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'additional-info' },
                      item.value.map(function (imgSrc, imageIndex) {
                        return _react2.default.createElement(
                          'div',
                          { className: 'image-list', key: imageIndex },
                          _react2.default.createElement('img', { src: imgSrc }),
                          _react2.default.createElement(
                            'label',
                            {
                              className: 'delete-image ico-moon icon-closes',
                              onClick: _this4.deleteImage,
                              'data-image-index': imageIndex
                            },
                            '-'
                          )
                        );
                      }),
                      item.value.length < 9 && _react2.default.createElement(
                        'div',
                        {
                          className: 'add-images',
                          onClick: _this4.addDeliveryImg
                        },
                        _react2.default.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                        _react2.default.createElement(
                          'div',
                          null,
                          '\u6DFB\u52A0\u56FE\u7247'
                        )
                      )
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'bottom-nav',
                hidden: pickUpType == 4 && account_type == 2
              },
              _react2.default.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                '\u5408\u8BA1:',
                _react2.default.createElement(
                  'span',
                  {
                    className: 'price-count',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  '¥' + totalPayment
                )
              ),
              _react2.default.createElement(
                'form',
                null,
                _react2.default.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: this.confirmPayment,
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                  },
                  cashOnDelivery ? '货到付款' : '在线支付'
                )
              )
            ),
            pickUpType == 4 && account_type == 2 && _react2.default.createElement(
              'div',
              { className: 'all-price-box flex-between' },
              _react2.default.createElement(
                'div',
                {
                  className: 'add-dishs',
                  hidden: !allow_add_dish,
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';'),
                  onClick: this.turnToAddDish
                },
                '\u7EE7\u7EED\u70B9\u83DC'
              ),
              _react2.default.createElement(
                'form',
                {
                  style: (0, _tools.convertLineStyleData)('flex:1;')
                },
                _react2.default.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: this.confirmPayment,
                    className: 'all-price-calculate',
                    style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + ';border-radius:0;')
                  },
                  '\u4E0B\u5355'
                )
              )
            )
          ),
          isShowPickMask && _react2.default.createElement(
            'div',
            { className: 'goods-pick-mask' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-box' },
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u66F4\u6362\u53D6\u8D27\u65B9\u5F0F'
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-content' },
                pickUpTypeArr.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: item, className: 'goods-pick-menu' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'pick-detail ' + (item == 2 && (intraCityData.is_enough_price != 1 || intraCityData.in_business_time != 1) ? 'no-achieve-price-box' : '')
                      },
                      _react2.default.createElement(
                        'div',
                        { className: 'pick-style' },
                        item == 1 ? '快递' : item == 2 ? '同城配送' : item == 3 ? '上门自提' : '堂食点餐'
                      ),
                      item == 2 && intraCityData.in_business_time != 1 ? _react2.default.createElement(
                        'div',
                        {
                          className: 'no-achieve-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '\u4E0D\u5728\u8425\u4E1A\u65F6\u95F4'
                      ) : item == 2 && intraCityData.is_enough_price != 1 ? _react2.default.createElement(
                        'div',
                        {
                          className: 'no-achieve-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '未达到起送价 还差' + intraCityData.min_deliver_price_balance + '元'
                      ) : item == 4 && dining_data.in_business_time != 1 && _react2.default.createElement(
                        'div',
                        {
                          className: 'no-achieve-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '\u5E97\u94FA\u5DF2\u6253\u70CA'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'pick-btn-box' },
                      _react2.default.createElement(
                        'span',
                        {
                          style: (0, _tools.convertLineStyleData)(item == 1 || item == 3 || item == 2 && intraCityData && intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 || item == 4 && dining_data && dining_data.in_business_time == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : 'color: #999;border-color: #D2D2D2'),
                          onClick: item == 1 || item == 3 || item == 2 && intraCityData && intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 || item == 4 && dining_data && dining_data.in_business_time == 1 ? _this4.deliveryWayChange : null,
                          'data-type': item
                        },
                        '\u9009\u62E9'
                      )
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          isShowServiceTime && _react2.default.createElement(
            'div',
            { className: 'goods-pick-mask' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-box' },
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
              ),
              !noAppointmentShow ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                tostoreTimeType == 1 && _react2.default.createElement(
                  'div',
                  { className: 'goods-pick-content' },
                  noImmediaPick && showImmediatelyTime && _react2.default.createElement(
                    'div',
                    {
                      onClick: this.tostoreImmediately,
                      className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : ''),
                      style: (0, _tools.convertLineStyleData)(tostoreOrderType == 1 ? 'color:' + storeStyle.theme : '')
                    },
                    '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                  ),
                  getEcTostoredate.date_arr.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      item.is_vaild == 1 && _react2.default.createElement(
                        'div',
                        {
                          onClick: _this4.selectTostoreTime,
                          'data-index': index,
                          className: 'goods-pick-time ' + (tostoreOrderType != 1 && tostoreDateTime == item.date ? 'selected' : ''),
                          style: (0, _tools.convertLineStyleData)(tostoreOrderType != 1 && tostoreDateTime == item.date ? 'color:' + storeStyle.theme : '')
                        },
                        dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                      )
                    );
                  })
                ),
                getEcTostoredate.setting_data && tostoreTimeType != 1 && _react2.default.createElement(
                  'div',
                  { className: 'double-column-time' },
                  _react2.default.createElement(
                    'div',
                    { className: 'double-time-day' },
                    getEcTostoredate.date_arr.map(function (item, index) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: index },
                        item.is_vaild == 1 && _react2.default.createElement(
                          'div',
                          {
                            onClick: _this4.selectTostoreTime,
                            'data-index': index,
                            className: 'goods-pick-time  ' + (tostoreDateTime == item.date ? 'selected' : ''),
                            style: (0, _tools.convertLineStyleData)(tostoreDateTime == item.date ? 'color:' + storeStyle.theme : '')
                          },
                          dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                        )
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'double-time-hours' },
                    !dateIndex && showImmediatelyTime && noImmediaPick && _react2.default.createElement(
                      'div',
                      {
                        onClick: this.tostoreImmediately,
                        className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : ''),
                        style: (0, _tools.convertLineStyleData)(tostoreOrderType == 1 ? 'color:' + storeStyle.theme : '')
                      },
                      '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                    ),
                    tostoreHoursArr && tostoreHoursArr.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        {
                          onClick: _this4.selectTostoreHourTime,
                          'data-index': index,
                          className: tostoreHourTime == item ? 'selected' : '',
                          style: (0, _tools.convertLineStyleData)(tostoreHourTime == item ? 'color:' + storeStyle.theme : ''),
                          key: true
                        },
                        item
                      );
                    })
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'none-appointment-time' },
                _react2.default.createElement('img', {
                  className: 'no-reservation',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-reservation.png'
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  '\u6682\u65E0\u53EF\u9884\u7EA6\u65F6\u95F4'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'tips' },
                  noAppointmentWordb
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'tips' },
                  noAppointmentWorda
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          isShowSameJourneyTime && _react2.default.createElement(
            'div',
            { className: 'goods-pick-mask' },
            _react2.default.createElement(
              'div',
              { className: 'goods-pick-box' },
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u9009\u62E9\u9001\u8FBE\u65F6\u95F4'
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-content goods-same-journey-time' },
                _react2.default.createElement(
                  'div',
                  {
                    onClick: this.selectSameJourneyTime,
                    'data-type': 'immedia',
                    className: 'goods-pick-time ' + (sameJourneyTimeType == 1 ? 'selected' : ''),
                    style: (0, _tools.convertLineStyleData)(sameJourneyTimeType == 1 ? 'color:' + storeStyle.theme : '')
                  },
                  '尽快送达(预计' + sameJourneyImmediatlyTime + '分钟后送达)'
                ),
                sameJourneyHoursArr.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: _this4.selectSameJourneyTime,
                        'data-type': 'appoint',
                        'data-index': index,
                        className: 'goods-pick-time ' + (sameJourneyTimeType != 1 && sameJourneyDateTime == item ? 'selected' : ''),
                        style: (0, _tools.convertLineStyleData)(sameJourneyTimeType != 1 && sameJourneyDateTime == item ? 'color:' + storeStyle.theme : '')
                      },
                      item
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          expressAddressNull && _react2.default.createElement(
            'div',
            {
              className: 'perfect-address-mask',
              onClick: this.hidePerfectAddress
            },
            _react2.default.createElement(
              'div',
              {
                className: 'perfect-address-box',
                onClick: this.stopPropagation
              },
              _react2.default.createElement(
                'div',
                { className: 'perfect-address-title' },
                '\u63D0\u793A'
              ),
              _react2.default.createElement(
                'div',
                { className: 'perfect-address-tips' },
                '\u8BF7\u5B8C\u5584\u5730\u5740\u4FE1\u606F~'
              ),
              _react2.default.createElement(
                'div',
                { className: 'perfect-address-bottom' },
                _react2.default.createElement(
                  'span',
                  { onClick: this.manuallyAddAddress },
                  '\u624B\u52A8\u65B0\u589E\u5730\u5740'
                ),
                _react2.default.createElement(
                  'span',
                  {
                    onClick: this.importWeChatAddress,
                    className: 'import-weChat-address'
                  },
                  '\u5BFC\u5165\u5FAE\u4FE1\u5730\u5740'
                )
              )
            )
          )
        ),
        _react2.default.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return PreviewSeckillOrder;
}(_OfficialPage3.default);

exports.default = PreviewSeckillOrder;

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _Recommend = __webpack_require__(141);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(479);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransactionSuccess = function (_OfficialPage) {
  (0, _inherits3.default)(TransactionSuccess, _OfficialPage);

  function TransactionSuccess(props) {
    (0, _classCallCheck3.default)(this, TransactionSuccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TransactionSuccess.__proto__ || Object.getPrototypeOf(TransactionSuccess)).call(this, props));

    _this.state = {
      storeStyle: {}
    };
    _this.orderId = '';
    _this.recommendRef = React.createRef();

    _this.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({
        url: '/pages/' + router + '/' + router
      });
    };

    _this.goToComment = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/makeComment/makeComment?detail=' + _this.orderId + '&franchisee=' + _this.data.franchiseeId, 1);
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config,
          hasRecommendConfig: res.recommend_config ? true : false
        });
      }, _this.data.franchiseeId);
    };

    document.title = '交易成功';
    return _this;
  }

  (0, _createClass3.default)(TransactionSuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      if (options.pageFrom != 'transation') {
        _app.appMethod.setPageTitle('评价成功');
      }
      this.orderId = options.orderId;
      this.setData({
        franchiseeId: options.franchiseeId || '',
        pageFrom: options.pageFrom
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          storeStyle = _state.storeStyle,
          pageFrom = _state.pageFrom,
          hasRecommendConfig = _state.hasRecommendConfig,
          franchiseeId = _state.franchiseeId;

      return React.createElement(
        'div',
        { className: 'official-page transaction-success' },
        React.createElement(_TopNav.TopNav, { title: '\u4EA4\u6613\u6210\u529F' }),
        hasRecommendConfig ? React.createElement(
          'div',
          {
            className: 'success-box',
            style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
          },
          React.createElement(
            'div',
            { className: 'title' },
            React.createElement('img', {
              className: 'goods-complete-succes',
              src: 'http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-success.png'
            }),
            React.createElement(
              'span',
              null,
              pageFrom == 'transation' ? '交易成功' : '评价成功'
            )
          ),
          React.createElement(
            'div',
            { className: 'slogan' },
            pageFrom == 'transation' ? '去评价一下这次的购物体验吧~' : '再去逛逛店铺吧~'
          ),
          React.createElement(
            'div',
            { className: 'btn-area' },
            pageFrom == 'transation' && React.createElement(
              'div',
              { onClick: this.goToComment },
              '\u7ACB\u5373\u8BC4\u4EF7'
            ),
            React.createElement(
              'div',
              { onClick: this.goToHomepage },
              '\u8FD4\u56DE\u9996\u9875'
            )
          ),
          React.createElement('img', {
            className: 'goods-complete-bg',
            src: 'http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-bg.png'
          })
        ) : React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'no-recommend-box' },
            React.createElement(
              'div',
              {
                className: 'success-box',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              React.createElement(
                'div',
                { className: 'title' },
                React.createElement('img', {
                  className: 'goods-complete-succes',
                  src: 'http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/big-goods-complete-success.png'
                })
              ),
              React.createElement('img', {
                className: 'goods-complete-bg',
                src: 'http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/goods-complete-bg.png'
              })
            ),
            React.createElement(
              'div',
              {
                className: 'goods-complete-title',
                style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
              },
              pageFrom == 'transation' ? '交易成功' : '评价成功'
            ),
            React.createElement(
              'div',
              { className: 'slogan' },
              pageFrom == 'transation' ? '去评价一下这次的购物体验吧~' : '再去逛逛店铺吧~'
            ),
            React.createElement(
              'div',
              { className: 'btn-area' },
              pageFrom == 'transation' && React.createElement(
                'div',
                {
                  className: 'go-comment',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.goToComment
                },
                '\u7ACB\u5373\u8BC4\u4EF7'
              ),
              React.createElement(
                'div',
                {
                  className: pageFrom == 'transation' ? '' : 'comment-back-homepage',
                  style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                  onClick: this.goToHomepage
                },
                '\u8FD4\u56DE\u9996\u9875'
              )
            )
          )
        ),
        React.createElement(_Recommend.Recommend, { id: 'component-recommend', franchiseeId: franchiseeId, ref: this.recommendRef })
      );
    }
  }]);
  return TransactionSuccess;
}(_OfficialPage3.default);

exports.default = TransactionSuccess;

/***/ }),
/* 479 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(481);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SameJourneyLogistic = function (_OfficialPage) {
  (0, _inherits3.default)(SameJourneyLogistic, _OfficialPage);

  function SameJourneyLogistic(props) {
    (0, _classCallCheck3.default)(this, SameJourneyLogistic);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (SameJourneyLogistic.__proto__ || Object.getPrototypeOf(SameJourneyLogistic)).call(this, props));

    _this2.state = {
      info: {},
      logistics: [],
      arriveTime: '',
      sameCity: 0
    };
    _this2.orderId = '';
    _this2.franchiseeId = '';

    _this2.getTransporterInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/queryTransporterInfo',
        data: {
          order_id: _this.orderId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var data = res.data;
          var riderMakers = [{
            latitude: data.transporterLat,
            longitude: data.transporterLng,
            iconPath: '/images/transport.png',
            width: 50,
            height: 50,
            callout: {
              content: '距离店铺' + data.tripartite_info.distance + '米',
              fontSize: 11,
              color: '#333333',
              borderRadius: 4,
              bgColor: '#ffffff',
              padding: 10,
              display: 'ALWAYS',
              textAlign: 'center'
            }
          }];
          _this.setData({
            info: data,
            riderMakers: riderMakers,
            centerLatitude: +data.transporterLat + +0.0004,
            centerLongitude: data.transporterLng,
            showMap: true
          });
        }
      });
    };

    _this2.getTransportOrderFlow = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getTransportOrderFlow',
        data: {
          order_id: _this.orderId,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            logistics: res.data.reverse()
          });
        }
      });
    };

    _this2.getSameJourneySet = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        data: {
          pick_up_type: 2,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var storeData = res.data.app_store_data;
          var riderMakers = [{
            latitude: storeData.latitude,
            longitude: storeData.longitude,
            iconPath: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/merchant-delivery.png',
            width: 47,
            height: 51,
            callout: {
              content: '商家配送暂无配送信息',
              fontSize: 11,
              color: '#333333',
              borderRadius: 4,
              bgColor: '#ffffff',
              padding: 5,
              display: 'ALWAYS',
              textAlign: 'center'
            }
          }];
          _this.setData({
            riderMakers: riderMakers,
            centerLatitude: +storeData.latitude + 0.0004,
            centerLongitude: storeData.longitude,
            phone: storeData.contact_phone,
            showMap: true
          });
        }
      });
    };

    _this2.contactPhone = function (event) {
      _app.appMethod.makePhoneCall(event.currentTarget.dataset.phone);
    };

    document.title = '配送信息';
    return _this2;
  }

  (0, _createClass3.default)(SameJourneyLogistic, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var type = options.type;
      var sameCity = options.sameCity;
      this.orderId = options.orderId;
      this.franchiseeId = options.franchiseeId || '';
      this.getTransportOrderFlow();
      if (type == 0) {
        this.getSameJourneySet();
      } else {
        this.getTransporterInfo();
      }
      this.setData({
        type: type,
        arriveTime: options.arriveTime,
        sameCity: sameCity
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          type = _state.type,
          logistics = _state.logistics,
          arriveTime = _state.arriveTime,
          showMap = _state.showMap,
          centerLongitude = _state.centerLongitude,
          centerLatitude = _state.centerLatitude,
          riderMakers = _state.riderMakers,
          phone = _state.phone,
          info = _state.info,
          sameCity = _state.sameCity;


      return React.createElement(
        'div',
        { className: 'official-page same-journey-logistic' },
        React.createElement(_TopNav.TopNav, { title: '\u914D\u9001\u4FE1\u606F' }),
        sameCity == 0 && React.createElement(
          'div',
          { className: 'journey-logistics-header' },
          React.createElement(
            'div',
            { className: 'logistic-status' },
            type == 0 ? '商家自配送' : logistics[0] && logistics[0].content.msg
          ),
          arriveTime && React.createElement(
            'div',
            { className: 'service-time' },
            '\u9884\u8BA1\u9001\u8FBE\u65F6\u95F4\uFF1A',
            React.createElement(
              'span',
              null,
              arriveTime
            )
          ),
          showMap && React.createElement(React.Fragment, null),
          type == 0 ? React.createElement(
            'div',
            { className: 'rider-info' },
            '\u5546\u5BB6\u4FE1\u606F',
            React.createElement(
              'span',
              {
                onClick: this.contactPhone,
                'data-phone': phone,
                className: 'pull-right contact-rider'
              },
              '\u8054\u7CFB\u5546\u5BB6'
            )
          ) : React.createElement(
            'div',
            { className: 'rider-info' },
            '\u9A91\u624B\u4FE1\u606F',
            info.transporter_phone && React.createElement(
              'span',
              {
                onClick: this.contactPhone,
                'data-phone': info.transporter_phone,
                className: 'pull-right contact-rider'
              },
              '\u8054\u7CFB\u9A91\u624B'
            ),
            React.createElement(
              'span',
              { className: 'pull-right rider-name' },
              info.transporterName
            )
          )
        ),
        React.createElement(
          'div',
          { id: 'logisticsPage' },
          React.createElement(
            'div',
            { className: 'logistics-container' },
            React.createElement(
              'div',
              { className: 'logistics-list' },
              logistics.map(function (item, index) {
                return React.createElement(
                  'div',
                  { key: item.id, className: 'logistics-item' },
                  React.createElement(
                    'div',
                    { className: 'logistics-location' },
                    item.content.msg
                  ),
                  React.createElement(
                    'div',
                    { className: 'logistics-time' },
                    item.op_time
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return SameJourneyLogistic;
}(_OfficialPage3.default);

exports.default = SameJourneyLogistic;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(483);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareGifts = function (_OfficialPage) {
  (0, _inherits3.default)(ShareGifts, _OfficialPage);

  function ShareGifts(props) {
    (0, _classCallCheck3.default)(this, ShareGifts);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShareGifts.__proto__ || Object.getPrototypeOf(ShareGifts)).call(this, props));

    _this.state = {
      is_select: false,
      is_over: false,
      isMultiple: false,
      rebateNum: 0,
      activity_rewards: {},
      extra_times_limit: {},
      times_limit: {},
      recv_limit: 0,
      type: '',
      surplus_times: 0
    };

    _this.getEffectActivity = function () {
      var that = _this,
          type = '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=ShareGiftActivity/GetEffectActivity',
        success: function success(res) {
          var data = res.data;
          that.setData({
            rebateNum: 0,
            description: data.description,
            activity_rewards: data.extra_rewards,
            times_limit: data.times_limit,
            extra_times_limit: data.extra_times_limit,
            recv_limit: data.recv_limit,
            type: data.immediately,
            surplus_times: data.surplus_times,
            immediately: data.immediately
          });
        }
      });
    };

    _this.getRewards = function (isInit) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ShareGiftActivity/CanRecvRewards',
        data: {
          appoint_ids: that.data.ids,
          extra_appoint_ids: that.data.extraIds
        },
        success: function success(res) {
          if (res.data) {
            var data = res.data;
            var extra = data.extra_rewards[0] || '';
            if (extra) {
              extra = that.typeClassify(extra.type, extra);
            }
            for (var index in data.rewards) {
              var g = data.rewards[index];
              g = that.typeClassify(g.type, g);
            }
            that.setData({
              extra_rewards: extra
            });
            that.loadRewards(isInit, data);
          }
        }
      });
    };

    _this.loadRewards = function (isInit, data) {
      var that = _this,
          gifts = data.rewards || [],
          giftsLen = gifts.length,
          recv_chance = data.recv_chance,
          recv_limit = data.recv_limit,
          share_persons = data.share_persons,
          isMultiple = that.data.isMultiple,
          giftsModal = void 0;
      if (isInit) {
        if (recv_chance > 1 && recv_limit == 1 && giftsLen > 1) {
          isMultiple = true;
        }
      }
      for (var index in gifts) {
        var f = gifts[index];
        f.times = 0;
        f.is_select = false;
        if (isInit) {
          gifts[index].giftsModal = recv_limit == 0 || gifts.length == 1 ? '0' : recv_chance > 1 ? '2' : '1';
          gifts[index].is_select = false;
          if (gifts[index].type == 1) {
            if (gifts[index].stock == 0) {
              gifts[index].is_hide = true;
            } else {
              gifts[index].is_hide = false;
            }
          }
        } else {
          gifts[index].giftsModal = that.data.gifts[index].giftsModal;
          gifts[index].is_select = that.data.gifts[index].is_select;
          if (gifts[index].type == 1) {
            if (that.data.gifts[index].is_hide == true) {
              gifts[index].is_hide = true;
            } else {
              gifts[index].is_hide = false;
            }
          }
        }
        that.typeClassify(f.type, f);
      }
      that.setData({
        gifts: gifts,
        giftslen: giftsLen,
        share_persons: share_persons,
        isMultiple: isMultiple,
        rebateNum: 0,
        showModal: true,
        recv_chance: recv_chance,
        recv_limit: recv_limit,
        callback: ''
      });
    };

    _this.typeClassify = function (type, f) {
      switch (type) {
        case '1':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png';
          f.path = '/eCommerce/pages/couponList/couponList';
          break;
        case '2':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png';
          f.path = '/userCenter/pages/myIntegral/myIntegral';
          break;
        case '3':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png';
          f.path = '/eCommerce/pages/balance/balance';
          break;
        case '4':
        case '5':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png';
          f.path = '/eCommerce/pages/vipBenefits/vipBenefits';
          break;
        case '6':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png';
          f.path = '/awardManagement/pages/collectStars/collectStars';
          break;
        case '7':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png';
          f.path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail';
          break;
        case '8':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png';
          f.path = '/awardManagement/pages/scratch/scratch';
          break;
        case '9':
          f.image = 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png';
          f.path = '/awardManagement/pages/goldenEggs/goldenEggs';
          break;
      }
      return f;
    };

    _this.showGifts = function (e) {
      var type = e.target['dataset']['type'];
      var index = e.target['dataset']['index'];
      var f = _this.typeClassify(type, {});
      var path = f.path;
      if (type == 4 || type == 5) {
        path = path + '?id=' + _this.data.gifts[index].value;
      }
      _app.appMethod.turnToPage(path);
    };

    _this.recvReward = function (e) {
      var that = _this,
          dataset = e.currentTarget.dataset,
          index = dataset.index,
          type = dataset.type,
          rebateNum = that.data.rebateNum,
          paramGifts = that.data.gifts[index] || 'all',
          gifts = that.data.gifts,
          giftsArr = [];
      if (type != 'all') {
        paramGifts.times = 1;
        giftsArr.push(paramGifts);
      } else {
        giftsArr = gifts;
        if (rebateNum == 0) {
          return;
        }
      }
      for (var i in gifts) {
        if (gifts[i].times >= 1 || gifts[i].is_select) {
          gifts[i].is_select = true;
          gifts[i].giftsModal = 0;
        } else {
          gifts[i].is_select = false;
          gifts[i].giftsModal = 1;
        }
      }
      that.setData({
        gifts: gifts
      });
      that.getRecv(giftsArr);
    };

    _this.getRecv = function (giftsArr) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ShareGiftActivity/RecvRewards',
        method: 'POST',
        data: {
          rewards: giftsArr
        },
        success: function success(res) {
          that.getRewards(false);
          var data = res.data;
          var isAllRecv = true;
          if (data && data.length) {
            for (var i = 0; i < data.length; i++) {
              if (!data[i].recv_result) {
                _app.appMethod.showModal({
                  content: data[i].reason
                });
                isAllRecv = false;
              }
            }
          }
          if (isAllRecv) {
            _app.appMethod.showToast({
              title: '领取成功',
              icon: 'none',
              duration: 3000
            });
          }
        }
      });
    };

    _this.clickMinusButton = function (e) {
      _this.changeGiftsNums('minus', e);
    };

    _this.clickPlusButton = function (e) {
      _this.changeGiftsNums('plus', e);
    };

    _this.inputBuyCount = function (e) {
      _this.changeGiftsNums('input', e);
    };

    _this.changeGiftsNums = function (type, e) {
      var that = _this,
          data = e.currentTarget.dataset,
          index = data.index,
          value = +e.target.value,
          currentGifts = that.data.gifts,
          rebateNum = that.data.rebateNum,
          total = 0,
          inputIndex = 0,
          targetGiftsCount = type == 'plus' ? currentGifts[index].times + 1 : type == 'minus' ? currentGifts[index].times - 1 : value,
          newdata = {};
      _this.setData({
        is_select: false
      });
      if (type == 'input') {
        var re = /^[0-9]+$/;
        if (!re.test(value)) {
          newdata['gifts[' + index + '].times'] = currentGifts[index].times;
          that.setData(newdata);
          return;
        }
        rebateNum = 0;
        for (var i in currentGifts) {
          if (index != i) {
            rebateNum += currentGifts[i].times;
          }
        }
        total = rebateNum + value;
        if (total > that.data.recv_chance) {
          _app.appMethod.showToast({
            title: '已超过最大可领取奖励量',
            icon: 'none',
            duration: 1000
          });
          newdata['gifts[' + index + '].times'] = 1;
          newdata['is_select'] = true;
          newdata['rebateNum'] = rebateNum + 1;
          _this.setData(newdata);
          return;
        }
        if (currentGifts[index].times >= currentGifts[index].stock) {
          _app.appMethod.showToast({
            title: '已超过最大库存量',
            icon: 'none',
            duration: 1000
          });
          newdata['gifts[' + index + '].times'] = currentGifts[index].times;
          newdata['is_select'] = true;
          newdata['rebateNum'] = rebateNum + 1;
          _this.setData(newdata);
          return;
        }
        newdata['gifts[' + index + '].times'] = value;
      }
      if (type == 'plus') {
        total = rebateNum + 1;
        if (total > that.data.recv_chance) {
          _app.appMethod.showToast({
            title: '已超过最大可领取奖励量',
            icon: 'none',
            duration: 1000
          });
          _this.setData({
            is_select: true,
            rebateNum: rebateNum
          });
          return;
        }
        if (currentGifts[index].type == 1 && !currentGifts[index].stock) {
          _app.appMethod.showToast({
            title: '优惠券已领完',
            icon: 'none',
            duration: 1000
          });
          _this.setData({
            is_select: true,
            rebateNum: rebateNum
          });
          return;
        }
        if ((currentGifts[index].type == 4 || currentGifts[index].type == 5) && targetGiftsCount > 1) {
          _app.appMethod.showToast({
            title: '会员卡最多领取一次',
            icon: 'none',
            duration: 1000
          });
          _this.setData({
            is_select: true,
            rebateNum: rebateNum
          });
          return;
        }
        if (currentGifts[index].times >= currentGifts[index].stock) {
          _app.appMethod.showToast({
            title: '已超过最大库存量',
            icon: 'none',
            duration: 1000
          });
          _this.setData({
            is_select: true,
            rebateNum: rebateNum
          });
          return;
        }
        newdata['gifts[' + index + '].times'] = targetGiftsCount;
      } else if (type == 'minus') {
        total = rebateNum - 1;
        if (targetGiftsCount < 0) {
          return;
        }
        rebateNum = rebateNum;
        if (targetGiftsCount == 0) {
          newdata['gifts[' + index + '].times'] = 0;
        } else {
          newdata['gifts[' + index + '].times'] = targetGiftsCount;
        }
      }
      newdata['rebateNum'] = total;
      that.setData(newdata);
    };

    document.title = '分享有礼';
    return _this;
  }

  (0, _createClass3.default)(ShareGifts, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        ids: options.ids || '',
        extraIds: options.extraIds || ''
      });
      this.getEffectActivity();
      this.getRewards(true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          recv_limit = _state.recv_limit,
          giftslen = _state.giftslen,
          recv_chance = _state.recv_chance,
          isMultiple = _state.isMultiple,
          surplus_times = _state.surplus_times,
          type = _state.type,
          share_persons = _state.share_persons,
          gifts = _state.gifts,
          rebateNum = _state.rebateNum,
          extra_rewards = _state.extra_rewards,
          immediately = _state.immediately,
          times_limit = _state.times_limit,
          activity_rewards = _state.activity_rewards,
          extra_times_limit = _state.extra_times_limit,
          description = _state.description;


      return React.createElement(
        'div',
        { className: 'official-page share-gifts' },
        React.createElement(_TopNav.TopNav, { title: '\u5206\u4EAB\u6709\u793C' }),
        React.createElement(
          'div',
          { id: 'shareGifts' },
          React.createElement(
            'div',
            { className: 'banner-top' },
            React.createElement(
              'div',
              { className: 'image-wrap' },
              React.createElement('img', {
                src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/banner-top.png',
                mode: 'aspectFill'
              })
            )
          ),
          React.createElement(
            'div',
            { className: 'total-main-wrap' },
            React.createElement(
              'div',
              { className: 'methods-wrap' },
              React.createElement(
                'div',
                { className: 'share-gifts-title' },
                recv_limit == 0 || giftslen == 1 ? React.createElement(
                  React.Fragment,
                  null,
                  '\u606D\u559C\u4F60\u83B7\u5F97\u4EE5\u4E0B\u5956\u52B1'
                ) : recv_limit == 1 && React.createElement(
                  React.Fragment,
                  null,
                  recv_chance == 0 ? '奖励领取成功' : !isMultiple ? '以下奖励选一个' : '以下奖励可选',
                  isMultiple && React.createElement(
                    'div',
                    { className: 'no-normal' },
                    recv_chance > 0 && React.createElement(
                      React.Fragment,
                      null,
                      type == 1 && React.createElement(
                        React.Fragment,
                        null,
                        '\u6210\u529F\u5206\u4EAB',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('color:#FF7100;') },
                          surplus_times
                        ),
                        '\u6B21\uFF0C\u5269\u4F59',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('color:#FF7100;') },
                          recv_chance
                        ),
                        '\u6B21\u673A\u4F1A'
                      ),
                      type == 2 && React.createElement(
                        React.Fragment,
                        null,
                        '\u6210\u529F\u5206\u4EAB',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('color:#FF7100;') },
                          share_persons
                        ),
                        '\u4F4D\u597D\u53CB\uFF0C\u5269\u4F59',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('color:#FF7100;') },
                          recv_chance
                        ),
                        '\u6B21\u673A\u4F1A'
                      )
                    )
                  )
                )
              ),
              !isMultiple ? React.createElement(
                'div',
                { className: 'share-method-list' },
                gifts && gifts.map(function (item, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    !item.is_hide && React.createElement(
                      'div',
                      { className: 'main-wrap' },
                      React.createElement(
                        'div',
                        null,
                        React.createElement('img', { src: item.image }),
                        React.createElement(
                          'span',
                          { className: 'mian-title' },
                          item.title
                        ),
                        (recv_limit == 0 || gifts.length == 1) && item.already_times > 1 && React.createElement(
                          'span',
                          { space: 'ensp' },
                          '*' + item.already_times
                        )
                      ),
                      (item.type == 4 || item.type == 5) && item.already_recv || item.type == 1 && !item.is_hide && item.stock == 0 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          {
                            className: 'showGifts',
                            'data-type': item.type,
                            onClick: _this2.showGifts,
                            'data-index': index
                          },
                          '\u67E5\u770B'
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        item.giftsModal == 1 ? React.createElement(
                          React.Fragment,
                          null,
                          !item.is_select && recv_chance > 0 ? React.createElement(
                            'div',
                            {
                              onClick: _this2.recvReward,
                              className: 'getGifts no_select',
                              'data-type': item.type,
                              'data-index': index
                            },
                            '\u9886\u53D6'
                          ) : React.createElement(
                            'div',
                            {
                              className: 'getGifts select',
                              'data-type': item.type,
                              'data-index': index
                            },
                            '\u9886\u53D6'
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'div',
                            {
                              className: 'getGifts',
                              onClick: _this2.showGifts,
                              'data-index': index,
                              'data-type': item.type
                            },
                            '\u67E5\u770B'
                          )
                        )
                      )
                    )
                  );
                })
              ) : React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'share-method-list' },
                  gifts.map(function (item, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      !item.is_hide && React.createElement(
                        'div',
                        { className: 'main-wrap' },
                        React.createElement(
                          'div',
                          null,
                          React.createElement('img', { src: item.image }),
                          React.createElement(
                            'span',
                            { className: 'mian-title' },
                            item.title
                          ),
                          recv_limit == 0 && item.already_times > 1 && React.createElement(
                            'span',
                            { space: 'ensp' },
                            '*' + item.already_times
                          )
                        ),
                        (item.type == 4 || item.type == 5) && item.already_recv || item.type == 1 && !item.is_hide && item.stock == 0 ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'div',
                            {
                              className: 'showGifts',
                              'data-type': item.type,
                              onClick: _this2.showGifts,
                              'data-index': index
                            },
                            '\u67E5\u770B'
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          recv_chance == 0 ? React.createElement(
                            React.Fragment,
                            null,
                            item.is_select ? React.createElement(
                              'div',
                              {
                                className: 'showGifts',
                                'data-type': item.type,
                                onClick: _this2.showGifts,
                                'data-index': index
                              },
                              '\u67E5\u770B'
                            ) : React.createElement(
                              'div',
                              {
                                className: 'getGifts select',
                                'data-type': item.type,
                                'data-index': index
                              },
                              '\u9886\u53D6'
                            )
                          ) : React.createElement(
                            React.Fragment,
                            null,
                            recv_chance != 0 && React.createElement(
                              'div',
                              { className: 'quantity' },
                              React.createElement('label', { className: 'minus' }),
                              React.createElement('input', {
                                className: 'pay-buy-count txt',
                                type: 'number',
                                value: item.times,
                                'data-index': index,
                                onInput: _this2.inputBuyCount
                              }),
                              React.createElement('label', { className: 'plus' }),
                              React.createElement('div', {
                                className: 'response-area response-area-minus',
                                onClick: _this2.clickMinusButton,
                                'data-index': index
                              }),
                              React.createElement('div', {
                                className: 'response-area response-area-plus isRelative',
                                onClick: _this2.clickPlusButton,
                                'data-index': index
                              })
                            )
                          )
                        )
                      )
                    );
                  })
                ),
                recv_chance != 0 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('width:100%;padding-bottom:40rpx;background:#fff;') },
                    React.createElement(
                      'div',
                      {
                        className: 'getGifts ' + (rebateNum == 0 ? 'select' : 'no_select') + ' multi-getGifts',
                        onClick: this.recvReward,
                        'data-type': 'all',
                        'data-index': index
                      },
                      '\u9886\u53D6'
                    )
                  )
                )
              )
            ),
            extra_rewards && extra_rewards.num >= 1 && immediately == 2 && React.createElement(
              'div',
              { className: 'extra-wrap' },
              React.createElement(
                'div',
                { className: 'share-gifts-title' },
                '\u62C9\u65B0\u989D\u5916\u5956\u52B1'
              ),
              React.createElement(
                'div',
                { className: 'share-method-list' },
                React.createElement(
                  'div',
                  { className: 'main-wrap' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement('img', { src: extra_rewards.image }),
                    React.createElement(
                      'span',
                      { className: 'mian-title' },
                      extra_rewards.reward_title
                    ),
                    extra_rewards.num > 1 && React.createElement(
                      'span',
                      { space: 'ensp' },
                      '*' + extra_rewards.num
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'showGifts',
                      'data-type': extra_rewards.type,
                      onClick: this.showGifts
                    },
                    '\u67E5\u770B'
                  )
                )
              )
            ),
            description && React.createElement(
              'div',
              { className: 'toast-wrap' },
              React.createElement(
                'div',
                { className: 'tips' },
                '\u5206\u4EAB\u8BF4\u660E'
              ),
              React.createElement(
                'div',
                { className: 'content' },
                React.createElement(
                  'div',
                  null,
                  '\u5206\u4EAB\u5956\u52B1\uFF1A',
                  gifts && gifts.map(function (item, index) {
                    return React.createElement(
                      'span',
                      { key: index, style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      item.title + (index == gifts.length - 1 ? '' : '、')
                    );
                  }),
                  recv_limit == 1 && gifts.length > 1 ? '(' + gifts.length + '选1)' : ''
                ),
                React.createElement(
                  'div',
                  null,
                  '奖励限制：每个用户' + (times_limit.type == 2 ? '每天' : '') + '有',
                  React.createElement(
                    'span',
                    null,
                    times_limit.value
                  ),
                  '\u6B21\u9886\u53D6\u5956\u52B1\u673A\u4F1A'
                ),
                activity_rewards.length > 0 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '\u62C9\u65B0\u989D\u5916\u5956\u52B1\uFF1A',
                    React.createElement(
                      'span',
                      null,
                      activity_rewards[0].title
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    '拉新奖励限制：每个用户' + (extra_times_limit.type == 2 ? '每天' : '') + '有',
                    React.createElement(
                      'span',
                      null,
                      extra_times_limit.value
                    ),
                    '\u6B21\u5956\u52B1\u673A\u4F1A'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ShareGifts;
}(_OfficialPage3.default);

exports.default = ShareGifts;

/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _MemberDiscount = __webpack_require__(66);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(485);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiningOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(DiningOrderDetail, _OfficialPage);

  function DiningOrderDetail(props) {
    (0, _classCallCheck3.default)(this, DiningOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DiningOrderDetail.__proto__ || Object.getPrototypeOf(DiningOrderDetail)).call(this, props));

    _this2.state = {
      pageData: {
        useBalance: true,
        selectDiscountInfo: {},
        discountList: []
      },
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      changeOrder: false,
      showMoreBtn: false,
      showMoreGoods: false,
      showBenefitInfo: false,
      customNumArr: Array.from(new Array(101).keys()).slice(1),
      userToken: _app.appMethod.globalData.userInfo.user_token
    };
    _this2.franchisee_id = '';
    _this2.requesting = false;
    _this2.pickUpType = 0;
    _this2.memberDiscountRef = _react2.default.createRef();

    _this2.onPullDownRefresh = function () {
      _this2.dataInit();
      setTimeout(function () {
        _app.appMethod.stopPullDownRefresh();
      }, 3000);
    };

    _this2.dataInit = function () {
      _this2.getDiningBaseSetting();
      _this2.getDiningFuncSetting();
      _this2.getOrderDetail(_this2.noticeMethod);
    };

    _this2.showBtnStyle = function () {
      var showBtnNum = 0;
      _this2.data.pageData.allow_app_account ? showBtnNum++ : '';
      _this2.data.pageData.allow_add_dish && _this2.data.pageData.orderInfo.status == 17 ? showBtnNum++ : '';
      _this2.data.pageData.orderInfo.goods_reduced_nums && _this2.data.pageData.ec_dining_data.has_reduce_dishes ? showBtnNum++ : '';
      _this2.setData({
        showBtnNum: showBtnNum
      });
    };

    _this2.showMoreBtn = function () {
      _this2.setData({
        showMoreBtn: !_this2.data.showMoreBtn
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeConfig: res,
          storeStyle: res.color_config
        });
      }, _this2.franchisee_id);
    };

    _this2.getOrderDetail = function (callback) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getOrder',
        data: {
          order_id: _this2.data.orderId
        },
        method: 'post',
        success: function success(res) {
          var orderInfo = res.data[0].form_data;
          var ecommerce_info = orderInfo.ecommerce_info;
          var diningOrderList = ecommerce_info.ecommerce_dining_child_order;
          var goodsSum = 0;
          var newData = {};
          var additional_goodsid_arr = [];
          var additional_info_goods = [];
          var hasAdditionalInfo = false;
          var vip_goods_list = [];
          if (orderInfo.additional_info) {
            for (var i = 0; i < orderInfo.goods_info.length; i++) {
              var deliveryId = orderInfo.goods_info[i].delivery_id,
                  goodsId = orderInfo.goods_info[i].goods_id;
              if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
                additional_info_goods.push(orderInfo.goods_info[i]);
                additional_goodsid_arr.push(goodsId);
                hasAdditionalInfo = true;
              }
            }
            newData['hasAdditionalInfo'] = hasAdditionalInfo;
            _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
            _app.appMethod.setGoodsAdditionalInfo(orderInfo.additional_info || {});
          }
          for (var _i = 0; _i < diningOrderList.length; _i++) {
            var data = diningOrderList[_i].child_form_data;
            for (var j = 0; j < data.length; j++) {
              goodsSum += data[j].goods_list.length;
              for (var k = 0; k < data[j].goods_list.length; k++) {
                if (data[j].goods_list[k].model_value && data[j].goods_list[k].model_value.length) {
                  data[j].goods_list[k].model_value_str = data[j].goods_list[k].model_value.join('|');
                }
              }
            }
          }
          orderInfo.goods_info.forEach(function (item, index) {
            if (item.is_vip_goods) {
              if (item.model_value && item.model_value.length) {
                item.model_value_str = item.model_value.join('|');
              }
              if (ecommerce_info.ec_dining_data.account_type == 1) {
                if (item.refunded_num) {
                  item.count = item.num - item.refunded_num;
                } else {
                  item.count = item.num;
                }
              } else {
                item.count = item.num;
              }
              vip_goods_list.push(item);
            }
          });
          if (Array.isArray(orderInfo.selected_benefit_info)) {
            newData['pageData.show_benefit_info'] = false;
          } else {
            newData['pageData.show_benefit_info'] = true;
          }
          newData['pageData.box_fee'] = orderInfo.box_fee;
          newData['pageData.tissue_fee'] = orderInfo.tissue_fee;
          newData['pageData.server_fee'] = orderInfo.server_fee;
          newData['pageData.goodsSum'] = goodsSum;
          newData['pageData.totalPayment'] = orderInfo.total_price;
          newData['pageData.orderInfo'] = orderInfo;
          newData['pageData.people_num'] = orderInfo.people_num;
          newData['pageData.additional_info'] = orderInfo.additional_info;
          newData['pageData.ec_dining_data'] = ecommerce_info.ec_dining_data;
          newData['pageData.location_id'] = ecommerce_info.ec_dining_data.location_id || '';
          newData['pageData.account_type'] = ecommerce_info.ec_dining_data.account_type;
          newData['pageData.dining_mode'] = ecommerce_info.ec_dining_data.dining_mode;
          newData['pageData.diningOrderList'] = ecommerce_info.ecommerce_dining_child_order;
          newData['vip_goods_list'] = vip_goods_list;
          var coupon = orderInfo.selected_benefit_info;
          if (!Array.isArray(coupon)) {
            if (coupon.discount_type == 'coupon' && coupon.benefit_type == 2) {
              newData['exchangeCouponData.selectModelInfo'] = coupon;
              newData['exchangeCouponData.hasSelectGoods'] = true;
              newData['exchangeCouponData.goodsInfo.cover'] = coupon.goods_img;
              newData['exchangeCouponData.goodsInfo.title'] = coupon.goods_title || '';
              newData['exchangeCouponData.goodsInfo.model_value_str'] = coupon.model_name || '';
            }
          }
          that.pickUpType = orderInfo.pick_up_type;
          that.setData(newData);
          ecommerce_info.ec_dining_data.account_type == 2 ? that.showBtnStyle() : '';
          that.modifyTime(orderInfo);
          typeof callback == 'function' && callback();
        }
      });
    };

    _this2.noticeMethod = function () {
      var data = _this2.data.pageData;
      var newData = {};
      if (data.account_type == 1 && data.orderInfo.status == 3) {
        data.ec_dining_data.location_id ? newData['showNoticeModal'] = true : newData['showNoticeModal'] = false;
      } else {
        data.orderInfo.status == 17 ? newData['showNoticeModal'] = true : newData['showNoticeModal'] = false;
      }
      _this2.setData(newData);
    };

    _this2.showNoticeModalFn = function () {
      _this2.setData({
        showNoticeModal: false
      });
    };

    _this2.orderDelete = function () {
      var orderId = _this2.data.orderId,
          franchisee = _this2.franchisee_id,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2;
      _app.appMethod.showModal({
        content: '是否删除该订单？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirmColor: '#FF7100',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              app_id: appId,
              sub_shop_app_id: subShopId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.orderCancel = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cancelOrder',
        data: {
          order_id: _this2.data.orderId
        },
        success: function success(res) {
          that.getOrderDetail();
        }
      });
    };

    _this2.goOrderProgress = function () {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchisee_id;
      var pagePath = '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.turnToRufundDish = function () {
      var orderId = _this2.data.orderId;
      var type = _this2.data.pageData.account_type;
      _app.appMethod.turnToPage('/eCommerce/pages/refundDishesDetail/refundDishesDetail?detail=' + orderId + '&type=' + type);
    };

    _this2.turnToComment = function (e) {
      var orderId = _this2.data.orderId,
          franchiseeId = _this2.franchisee_id,
          queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/makeComment/makeComment?detail=' + orderId + queryStr);
    };

    _this2.changeDiningOrder = function () {
      _this2.setData({
        changeOrder: true,
        showMoreBtn: false
      });
    };

    _this2.changeCustomNum = function (e) {
      var value = +e.target.value + 1;
      if (value != _this2.data.pageData.people_num) {
        _this2.setData({
          'pageData.people_num': value
        });
        _this2.getCalculationInfo();
        _this2.changeOrderInfo();
      }
    };

    _this2.changeOrderInfo = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/ChangePeopleNum',
        data: {
          num: _this2.data.pageData.people_num,
          order_id: _this2.data.orderId
        },
        success: function success(res) {}
      });
    };

    _this2.saveOrderInfo = function () {
      _this2.setData({
        changeOrder: false
      });
    };

    _this2.turnToAddDish = function () {
      if (_this2.franchisee_id) {
        var that = _this2;
        _app.appMethod.showModal({
          title: '温馨提示',
          content: '子店商品继续点菜只能跳转子店首页或者连锁首页',
          showCancel: true,
          confirm: function confirm() {
            that.goToHomepage();
          }
        });
        return;
      }
      if (_this2.data.pageData.location_id) {
        _app.appMethod.globalData.ec_location_id = _this2.data.pageData.location_id;
      }
      var form = JSON.parse(_this2.path);
      var action = form.action;
      customEvent.clickEventHandler[action] && customEvent.clickEventHandler[action](form, '', '');
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.franchisee_id;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({ delta: 2 });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({ url: '/pages/' + router + '/' + router });
      }
    };

    _this2.getCalculationInfo = function (callback) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          dining_order_id: _this2.data.orderId,
          ecommerce_info: {
            ec_dining_data: {
              ordering_food_type: 1, // 点餐方式
              dining_mode: _this.data.pageData.dining_mode, // 就餐方式
              people_num: _this.data.pageData.people_num, // 就餐人数
              take_meal_type: _this.data.pageData.take_meal_type, // 取餐类型
              location_id: _this.data.pageData.location_id, // 座位号码
              account_type: _this.data.pageData.account_type // 结账方式
            }
          },
          sub_shop_app_id: _this2.franchisee_id,
          is_balance: _this2.data.pageData.useBalance ? 1 : 0,
          selected_benefit: _this2.data.pageData.selectDiscountInfo,
          pick_up_type: 4, // 写死 后面改
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info
        },
        success: function success(res) {
          var info = res.data;
          var benefits = info.can_use_benefit;
          var goods_info = info.goods_info;
          var additional_info_goods = [];
          var selectDiscountInfo = info.selected_benefit_info;
          var suppInfoArr = [];
          var additional_goodsid_arr = [];
          var newData = {};
          var goodsBenefitsData = [];
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          });
          if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && _this.data.exchangeCouponData.hasSelectGoods == false) {
            _this.exchangeCouponInit(parseInt(selectDiscountInfo.value));
          }
          goods_info.forEach(function (item) {
            if (item.delivery_id && item.delivery_id != 0 && additional_goodsid_arr.indexOf(item.goods_id) == -1) {
              suppInfoArr.push(item.delivery_id);
              additional_goodsid_arr.push(item.goods_id);
              additional_info_goods.push(item);
            }
          });
          newData['pageData.box_fee'] = info.box_fee;
          newData['pageData.server_fee'] = info.server_fee;
          newData['pageData.tissue_fee'] = info.tissue_fee;
          newData['pageData.discountList'] = goodsBenefitsData;
          newData['pageData.selectDiscountInfo'] = selectDiscountInfo;
          newData['pageData.discount_cut_price'] = info.discount_cut_price;
          newData['pageData.total_discount_cut_price'] = info.total_discount_cut_price;
          newData['pageData.balance'] = info.balance;
          newData['pageData.deduction'] = info.use_balance;
          newData['pageData.original_price'] = info.original_price;
          newData['pageData.totalPayment'] = _this.readyCount ? info.price : info.order_amount_price;
          newData['pageData.additional_goodsid_arr'] = additional_goodsid_arr;
          _this.setData(newData);
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          typeof callback == 'function' && callback();
        }
      });
    };

    _this2.showMemberDiscount = function () {
      _this2.memberDiscountRef.current.show({
        discountType: _this2.data.pageData.discountList,
        afterSelectedDiscount: function afterSelectedDiscount(event) {
          _this2.afterSelectedBenefit(event);
        }
      });
      _this2.memberDiscountRef.current.showDialog(_this2.data.pageData.selectDiscountInfo);
    };

    _this2.afterSelectedBenefit = function (_ref) {
      var selectedDiscount = _ref.selectedDiscount;

      _this2.setData({
        'pageData.selectDiscountInfo': selectedDiscount,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        'pageData.useBalance': e.target.value
      });
      _this2.getCalculationInfo();
    };

    _this2.exchangeCouponInit = function (id) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: id
        },
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          _this.setData({
            'exchangeCouponData.dialogHidden': false, // 显示模态框
            'exchangeCouponData.goodsInfo': goods,
            'exchangeCouponData.selectModelInfo': selectModelInfo
          });
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _app.appMethod.showModal({
            content: '兑换的商品已下架'
          });
        }
      });
    };

    _this2.exchangeCouponHideDialog = function () {
      _this2.setData({
        'pageData.selectDiscountInfo': {
          title: '不使用优惠',
          name: '无',
          no_use_benefit: 1
        },
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.exchangeCouponSelectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.exchangeCouponData.selectModelInfo.models,
          model = _this2.data.exchangeCouponData.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['exchangeCouponData.selectModelInfo.models'] = selectModels;
      data['exchangeCouponData.selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.exchangeCouponResetSelectCountPrice();
    };

    _this2.exchangeCouponResetSelectCountPrice = function () {
      var _this = _this2,
          selectModelIds = _this2.data.exchangeCouponData.selectModelInfo.models.join(','),
          modelItems = _this2.data.exchangeCouponData.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
          data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
          data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
          data['exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.exchangeCouponConfirmGoods = function () {
      var _this = _this2;
      var goodsInfo = _this.data.exchangeCouponData.goodsInfo;
      var model = goodsInfo.model;
      var selectModels = _this.data.exchangeCouponData.selectModelInfo.models;
      var model_value_str = '';
      if (selectModels.length > 0) {
        for (var i = 0; i < selectModels.length; i++) {
          var selectSubModelId = model[i].subModelId;
          for (var j = 0; j < selectSubModelId.length; j++) {
            if (selectModels[i] == selectSubModelId[j]) {
              model_value_str += model[i].subModelName[j] + '； ';
            }
          }
        }
      }
      goodsInfo['model_value_str'] = model_value_str;
      _this.setData({
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.selectModelInfo': {},
        'exchangeCouponData.hasSelectGoods': true,
        'exchangeCouponData.voucher_coupon_goods_info': {
          goods_id: goodsInfo.id,
          num: 1,
          model_id: _this.data.exchangeCouponData.selectModelInfo.modelId
        },
        'exchangeCouponData.goodsInfo': goodsInfo
      });
      _this.getCalculationInfo();
    };

    _this2.cancelPayment = function () {
      _this2.setData({
        'pageData.selectDiscountInfo': {},
        exchangeCouponData: {},
        changeOrder: false,
        showBenefitInfo: false
      });
      _this2.getOrderDetail();
    };

    _this2.confirmPayment = function (e) {
      var _data;

      var _this = _this2;
      var form_id = e.detail.formId || '';
      form_id && _this2.saveFormId(form_id);
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: (_data = {
          dining_order_id: _this2.data.orderId,
          formId: e.detail.formId,
          sub_shop_app_id: _this2.franchisee_id,
          selected_benefit: _this2.data.pageData.selectDiscountInfo,
          is_balance: _this2.data.pageData.useBalance ? 1 : 0,
          ecommerce_info: {
            ec_dining_data: {
              ordering_food_type: 1, // 点餐方式
              dining_mode: _this.data.pageData.dining_mode, // 就餐方式
              people_num: _this.data.pageData.people_num, // 就餐人数
              take_meal_type: _this.data.pageData.take_meal_type, // 取餐类型
              location_id: _this.data.pageData.location_id, // 座位号码
              account_type: _this.data.pageData.account_type // 结账方式
            }
          },
          pick_up_type: 4 }, (0, _defineProperty3.default)(_data, 'dining_order_id', _this2.data.orderId), (0, _defineProperty3.default)(_data, 'remark', _this2.data.pageData.orderInfo.orderRemark), (0, _defineProperty3.default)(_data, 'voucher_coupon_goods_info', _this2.data.exchangeCouponData.voucher_coupon_goods_info), _data),
        success: function success(res) {
          _this.setData({
            'pageData.totalPayment': res.total_price
          });
          if (!_this.data.pageData.allow_app_account) return;
          _this.payOrder(res.data);
        },
        fail: function fail() {
          _this.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _this.requesting = false;
        }
      });
    };

    _this2.goPayOrder = function () {
      _this2.payOrder(_this2.data.orderId);
    };

    _this2.payOrder = function (orderId) {
      var _this = _this2;
      function paySuccess() {
        var pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : '') + '&is_group=' + !!_this.is_group;
        if (!_this.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_app_id: _this.franchisee_id
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              _app.appMethod.turnToPage(pagePath, 1);
            }
          });
        } else {
          _app.appMethod.turnToPage(pagePath, 1);
        }
      }
      function payFail() {
        if (_this.is_group) {
          if (_this.data.teamToken) {
            _app.appMethod.turnBack();
            return;
          }
          _app.appMethod.turnToPage('/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
        } else {
          if (_this.pickUpType == 4) {
            _this.getOrderDetail();
            _this.setData({
              changeOrder: false,
              showBenefitInfo: false
            });
            return;
          }
          _app.appMethod.turnToPage('/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + orderId + (_this.franchisee_id ? '&franchisee=' + _this.franchisee_id : ''), 1);
        }
      }
      if (_this2.data.pageData.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     _this.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })

      // TODO:支付成功回调要考虑一下怎么处理
      _app.appMethod.goPay({
        orderId: orderId
      });
    };

    _this2.setClipboardData = function (e) {
      var content = e.currentTarget.dataset.content;
      _app.appMethod.setClipboardData({
        data: content
      });
    };

    _this2.callPhone = function (event) {
      _app.appMethod.callPhone(event);
    };

    _this2.showMoreGoods = function () {
      _this2.setData({
        showMoreGoods: !_this2.data.showMoreGoods
      });
    };

    _this2.getDiningBaseSetting = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        data: {
          pick_up_type: 4,
          sub_shop_app_id: that.franchisee_id
        },
        success: function success(res) {
          that.setData({
            app_store_data: res.data.app_store_data
          });
        }
      });
    };

    _this2.getDiningFuncSetting = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getFuncSetting',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          ordering_food_type: 1, //1.堂食 2.预约
          pick_up_type: 4
        },
        success: function success(res) {
          ;that.path = res.data.add_dish_info.page || '', that.setData({
            'pageData.allow_add_dish': res.data.add_dish_info.allow_app_status == 1 ? true : false,
            'pageData.allow_app_account': res.data.account_info.account_way[1] ? true : false
          });
        }
      });
    };

    _this2.saveFormId = function (form_id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function success(res) {
          console.log(res);
        }
      });
    };

    _this2.readyCount = false;

    _this2.showBenefitInfo = function (e) {
      _this2.getOrderDetail();
      if (_this2.data.pageData.ec_dining_data.account_type == 2 && _this2.data.pageData.orderInfo.status == 17) {
        _this2.getCalculationInfo(_this2.afterShowBeneft);
        _this2.readyCount = true;
      }
    };

    _this2.afterShowBeneft = function () {
      _this2.setData({
        showBenefitInfo: true,
        changeOrder: true
      });
    };

    _this2.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this2.data.pageData.additional_info);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=diningOrderDetail');
    };

    _this2.modifyTime = function (orderInfo) {
      var newData = {};newData['pageData.add_time'] = _util2.default.formatTimeYMD(orderInfo.add_time, 'YYYY-MM-DD'), newData['pageData.payment_time'] = _util2.default.formatTimeYMD(orderInfo.payment_time);
      _this2.data.pageData.diningOrderList.forEach(function (item, index) {
        newData['pageData.diningOrderList[' + index + '].add_time'] = _util2.default.formatTimeYMD(item.add_time, 'hh:mm:ss');
      });
      _this2.setData(newData);
    };

    _this2.showVipGoodsList = function () {
      _this2.setData({
        showVipGoodsList: true
      });
    };

    _this2.hideVipGoodsList = function () {
      _this2.setData({
        showVipGoodsList: false
      });
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(DiningOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var orderId = options.detail || '';
      this.franchisee_id = options.franchisee || '';
      this.setData({
        orderId: orderId,
        franchisee_id: this.franchisee_id,
        'pageData.useBalance': this.franchisee_id ? false : true
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.dataInit();
    }
    // wxPay = param => {
    //   var _this = this
    //   app.requestPayment({
    //     timeStamp: param.timeStamp,
    //     nonceStr: param.nonceStr,
    //     package: param.package,
    //     signType: param.signType,
    //     paySign: param.paySign,
    //     success: function (res) {
    //       app.wxPaySuccess(param)
    //       param.success()
    //     },
    //     fail: function (res) {
    //       if (res.errMsg === 'requestPayment:fail cancel') {
    //         app.showModal({
    //           content: '支付已取消',
    //           complete: param.fail
    //         })
    //         return
    //       }
    //       app.showModal({
    //         content: '支付失败',
    //         complete: param.fail
    //       })
    //       app.wxPayFail(param, res.errMsg)
    //     }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageData = _state.pageData,
          showNoticeModal = _state.showNoticeModal,
          orderId = _state.orderId,
          changeOrder = _state.changeOrder,
          showMoreBtn = _state.showMoreBtn,
          showBtnNum = _state.showBtnNum,
          showBenefitInfo = _state.showBenefitInfo,
          hasAdditionalInfo = _state.hasAdditionalInfo,
          customNumArr = _state.customNumArr,
          app_store_data = _state.app_store_data,
          showMoreGoods = _state.showMoreGoods,
          userToken = _state.userToken,
          exchangeCouponData = _state.exchangeCouponData,
          balance = _state.balance,
          franchisee_id = _state.franchisee_id,
          dialogHidden = _state.dialogHidden,
          selectModelInfo = _state.selectModelInfo,
          goodsInfo = _state.goodsInfo,
          storeStyle = _state.storeStyle,
          vip_goods_list = _state.vip_goods_list,
          showVipGoodsList = _state.showVipGoodsList;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'official-page dining-order-detail' },
          _react2.default.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
          _react2.default.createElement(
            'div',
            { className: 'dining-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'order-bg-wrapper' },
              _react2.default.createElement('div', { className: 'order-bg-pic' }),
              showNoticeModal && _react2.default.createElement(
                'div',
                {
                  className: 'dining-notice',
                  hidden: pageData.ec_dining_data.take_meal_type == 2
                },
                _react2.default.createElement('span', { className: 'ico-moon icon-community-report dining-notice-icon' }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u60A8\u5DF2\u4E0B\u5355\u6210\u529F\uFF0C\u8BF7\u4E0D\u8981\u8F7B\u6613\u6362\u684C\uFF01'
                ),
                _react2.default.createElement('span', {
                  className: 'ico-moon icon-closes dining-notice-close',
                  onClick: this.showNoticeModalFn
                })
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'dining-order-status  flex-between',
                  style: (0, _tools.convertLineStyleData)('padding-top:' + (showNoticeModal ? '50' : '40') + 'rpx;')
                },
                pageData.account_type == 1 && !changeOrder && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  pageData.orderInfo.status == 0 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u4ED8\u6B3E'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'order-info-tips' },
                      '20\u5206\u949F\u5185\u672A\u4ED8\u6B3E\uFF0C\u5C06\u81EA\u52A8\u53D6\u6D88\u8BA2\u5355'
                    )
                  ) : pageData.orderInfo.status == 3 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u8BC4\u4EF7'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    ),
                    pageData.ec_dining_data.duration_time > 0 && _react2.default.createElement(
                      'span',
                      { className: 'order-info-tips' },
                      '预计等待' + pageData.ec_dining_data.duration_time + '分钟'
                    )
                  ) : pageData.orderInfo.status == 6 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5DF2\u5B8C\u6210'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ) : pageData.orderInfo.status == 7 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5DF2\u5173\u95ED'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ) : pageData.orderInfo.status == 8 && _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u5546\u5BB6\u63A5\u5355'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'order-info-tips' },
                      '15\u5206\u949F\u5185\u5546\u5BB6\u672A\u63A5\u5355\uFF0C\u5C06\u81EA\u52A8\u53D6\u6D88\u8BA2\u5355'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'order-operate-box' },
                    (pageData.orderInfo.status == 6 || pageData.orderInfo.status == 3 || pageData.orderInfo.status == 7) && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate',
                        onClick: this.orderDelete
                      },
                      '\u5220\u9664\u8BA2\u5355'
                    ),
                    pageData.orderInfo.status == 0 && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        style: (0, _tools.convertLineStyleData)('height:56rpx;'),
                        onClick: this.goPayOrder
                      },
                      '\u7ACB\u5373\u652F\u4ED8'
                    ),
                    pageData.orderInfo.status == 3 && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        'data-id': orderId,
                        onClick: this.turnToComment
                      },
                      '\u7ACB\u5373\u8BC4\u4EF7'
                    ),
                    !!+pageData.ec_dining_data.has_reduce_dishes && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        onClick: this.turnToRufundDish
                      },
                      '\u9000\u6B3E\u8BE6\u60C5'
                    )
                  )
                ),
                pageData.account_type == 2 && !changeOrder && !showBenefitInfo && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  pageData.orderInfo.status == 0 && _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u4ED8\u6B3E'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ),
                  pageData.orderInfo.status == 17 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5DF2\u4E0B\u5355'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    ),
                    pageData.ec_dining_data.duration_time > 0 && _react2.default.createElement(
                      'span',
                      { className: 'order-info-tips' },
                      '预计等待' + pageData.ec_dining_data.duration_time + '分钟'
                    )
                  ) : pageData.orderInfo.status == 16 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u5546\u5BB6\u63A5\u5355'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'order-info-tips' },
                      '15\u5206\u949F\u5185\u5546\u5BB6\u672A\u63A5\u5355\uFF0C\u5C06\u81EA\u52A8\u53D6\u6D88\u8BA2\u5355'
                    )
                  ) : pageData.orderInfo.status == 7 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5DF2\u5173\u95ED'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ) : pageData.orderInfo.status == 3 ? _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5F85\u8BC4\u4EF7'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ) : pageData.orderInfo.status == 6 && _react2.default.createElement(
                    'div',
                    { className: 'order-info' },
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'order-info-title',
                        onClick: this.goOrderProgress
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5DF2\u5B8C\u6210'
                      ),
                      _react2.default.createElement('span', {
                        className: 'ico-moon icon-rightarrow',
                        style: (0, _tools.convertLineStyleData)('font-size:32rpx;margin-left:10rpx;color:#fff;')
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'order-operate-box' },
                    showBtnNum == 3 && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate showMoreBtn',
                        onClick: this.showMoreBtn
                      },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u66F4\u591A'
                        ),
                        _react2.default.createElement('span', {
                          className: 'ico-moon ' + (showMoreBtn ? 'icon-uparrow' : 'icon-downarrow'),
                          style: (0, _tools.convertLineStyleData)('font-size:24rpx;margin-left:10rpx;')
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'moreBtn-box', hidden: !showMoreBtn },
                        pageData.orderInfo.status == 17 && _react2.default.createElement(
                          'div',
                          {
                            style: (0, _tools.convertLineStyleData)('color:#FE782F;'),
                            onClick: this.changeDiningOrder
                          },
                          '\u4FEE\u6539\u8BA2\u5355'
                        ),
                        (pageData.orderInfo.status == 0 || pageData.orderInfo.status == 17) && _react2.default.createElement(
                          'div',
                          {
                            style: (0, _tools.convertLineStyleData)('height:56rpx;top:120rpx;color:#FE782F;'),
                            onClick: pageData.orderInfo.status == 0 ? 'goPayOrder' : 'showBenefitInfo',
                            hidden: !pageData.allow_app_account
                          },
                          '\u7ACB\u5373\u652F\u4ED8'
                        ),
                        pageData.orderInfo.status == 3 && _react2.default.createElement(
                          'div',
                          {
                            style: (0, _tools.convertLineStyleData)('color:#FE782F;'),
                            'data-id': orderId,
                            onClick: this.turnToComment
                          },
                          '\u7ACB\u5373\u8BC4\u4EF7'
                        )
                      )
                    ),
                    pageData.orderInfo.status == 17 && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate',
                        onClick: this.changeDiningOrder,
                        hidden: showBtnNum == 3
                      },
                      '\u4FEE\u6539\u8BA2\u5355'
                    ),
                    pageData.ec_dining_data.has_reduce_dishes && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        onClick: this.turnToRufundDish
                      },
                      '\u9000\u83DC\u8BE6\u60C5'
                    ),
                    (pageData.orderInfo.status == 6 || pageData.orderInfo.status == 3 || pageData.orderInfo.status == 7) && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate',
                        onClick: this.orderDelete
                      },
                      '\u5220\u9664\u8BA2\u5355'
                    ),
                    (pageData.orderInfo.status == 0 || pageData.orderInfo.status == 17 && showBtnNum != 3) && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        style: (0, _tools.convertLineStyleData)('height:56rpx;'),
                        onClick: pageData.orderInfo.status == 0 ? 'goPayOrder' : 'showBenefitInfo',
                        hidden: !pageData.allow_app_account
                      },
                      '\u7ACB\u5373\u652F\u4ED8'
                    ),
                    pageData.orderInfo.status == 3 && showBtnNum != 3 && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate',
                        'data-id': orderId,
                        onClick: this.turnToComment
                      },
                      '\u7ACB\u5373\u8BC4\u4EF7'
                    ),
                    pageData.orderInfo.status == 17 && pageData.allow_add_dish && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate change',
                        onClick: this.turnToAddDish
                      },
                      '\u52A0\u83DC'
                    ),
                    (pageData.orderInfo.status == 16 || pageData.orderInfo.status == 8) && _react2.default.createElement(
                      'div',
                      {
                        className: 'order-operate cancel',
                        onClick: this.orderCancel
                      },
                      '\u53D6\u6D88\u8BA2\u5355'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'eating-place-wrapper',
                style: (0, _tools.convertLineStyleData)('margin-top:' + (changeOrder || showBenefitInfo ? '-160' : '-100') + 'rpx;')
              },
              _react2.default.createElement('div', { className: 'half-shadow', style: (0, _tools.convertLineStyleData)('left: 0rpx;') }),
              _react2.default.createElement('div', { className: 'half-shadow', style: (0, _tools.convertLineStyleData)('right: -60rpx;') }),
              _react2.default.createElement(
                'div',
                { className: 'eating-type flex-between' },
                _react2.default.createElement(
                  'div',
                  null,
                  pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 1 ? '堂食' : '打包'
                ),
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-weight:bold;color:#333;font-size:28rpx;') },
                  pageData.ec_dining_data && pageData.ec_dining_data.take_meal_type == 1 ? '送餐到桌' : '前台自取'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'eating-place-num' },
                _react2.default.createElement(
                  'div',
                  { className: 'eating-num-item' },
                  _react2.default.createElement(
                    'div',
                    {
                      style: (0, _tools.convertLineStyleData)('font-size:68rpx;'),
                      className: 'ellipsis ' + (pageData.ec_dining_data && pageData.ec_dining_data.take_meal_type == 2 ? 'max_width' : 'limit_width')
                    },
                    pageData.ec_dining_data && pageData.ec_dining_data.formatted_queue_num || '------'
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color:#666;') },
                    '\u6D41\u6C34\u53F7'
                  )
                ),
                pageData.location_id && _react2.default.createElement(
                  'div',
                  { className: 'eating-num-item' },
                  _react2.default.createElement(
                    'div',
                    {
                      style: (0, _tools.convertLineStyleData)('font-size:68rpx;'),
                      className: 'ellipsis limit_width'
                    },
                    pageData.ec_dining_data.location_name || '------'
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color:#666;') },
                    '\u684C\u53F7'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'eating-info-detail' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'flex-between',
                    style: (0, _tools.convertLineStyleData)(!(pageData.orderInfo && pageData.orderInfo.remark) && !hasAdditionalInfo ? '' : 'margin-bottom:20rpx;')
                  },
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color:#999;') },
                    '\u5C31\u9910\u4EBA\u6570'
                  ),
                  changeOrder && _react2.default.createElement(
                    Picker,
                    {
                      className: 'eating-picker',
                      onChange: this.changeCustomNum,
                      range: customNumArr
                    },
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-weight:bold;') },
                      (pageData.people_num || 1) + '人'
                    ),
                    _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                  ),
                  !changeOrder && _react2.default.createElement(
                    'div',
                    null,
                    pageData.people_num + '人'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    hidden: !(pageData.orderInfo && pageData.orderInfo.remark),
                    className: 'flex-between',
                    style: (0, _tools.convertLineStyleData)(!hasAdditionalInfo ? '' : 'margin-bottom:20rpx;')
                  },
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color:#999;') },
                    '\u8BA2\u5355\u5907\u6CE8'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    pageData.orderInfo && pageData.orderInfo.remark || '无'
                  )
                ),
                hasAdditionalInfo && _react2.default.createElement(
                  'div',
                  {
                    className: 'flex-between',
                    onClick: this.goToAdditionalInfo
                  },
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color:#999;') },
                    '\u8865\u5145\u4FE1\u606F'
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'dining-shop-box' },
              _react2.default.createElement(
                'div',
                { className: 'dining-shop flex-between' },
                _react2.default.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:28rpx;font-weight:bold;') },
                  app_store_data && app_store_data.title
                ),
                _react2.default.createElement('span', {
                  className: 'ico-moon icon-fn-phone icon-right',
                  style: (0, _tools.convertLineStyleData)('font-size:44rpx;'),
                  'data-phone': app_store_data && app_store_data.contact_phone,
                  onClick: this.callPhone
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'order-info-wrapper' },
              _react2.default.createElement(
                'div',
                {
                  style: (0, _tools.convertLineStyleData)('height:' + (pageData.goodsSum < 4 || showMoreGoods ? '' : '240rpx') + ';overflow:hidden;')
                },
                pageData.diningOrderList && pageData.diningOrderList.map(function (orderData, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'order-info-box', key: 'order_index' },
                    orderData.child_form_data.map(function (item, key) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: item.buyer_info.buyer_id },
                        _react2.default.createElement(
                          'div',
                          { className: 'custom-info-wrapper flex-between' },
                          _react2.default.createElement(
                            'div',
                            { className: 'flex-between' },
                            orderData.from_admin == 1 ? _react2.default.createElement(
                              'div',
                              { className: 'custom-info' },
                              _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-dining/default.png' })
                            ) : orderData.from_admin == 0 && _react2.default.createElement(
                              'div',
                              { className: 'custom-info' },
                              _react2.default.createElement('img', {
                                src: item.buyer_info.cover_thumb
                              })
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'custom-name',
                                'data-id': item.buyer_info.buyer_id
                              },
                              item.buyer_info.nickname + (item.buyer_info.buyer_id == userToken ? '（我）' : '') + (orderData.from_admin == 1 ? '（商家）' : '')
                            )
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'custom-selected' },
                            orderData.add_time
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-info-wrapper' },
                          item.goods_list.map(function (goods, index) {
                            return _react2.default.createElement(
                              _react2.default.Fragment,
                              { key: index },
                              !!+goods.reduced_num && _react2.default.createElement(
                                'div',
                                {
                                  className: 'goods-info-item',
                                  style: (0, _tools.convertLineStyleData)(index == 0 && pageData.goodsSum > 3 && !showMoreGoods ? 'border-bottom:0;padding-bottom:0;' : '')
                                },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-image' },
                                  _react2.default.createElement('img', {
                                    src: goods.cover,
                                    mode: 'aspectFill'
                                  })
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-detail' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'flex-between' },
                                    _react2.default.createElement(
                                      'div',
                                      {
                                        style: (0, _tools.convertLineStyleData)('max-width:400rpx;'),
                                        className: 'ellipsis'
                                      },
                                      goods.max_can_use_integral > 0 && _react2.default.createElement(
                                        'span',
                                        { className: 'goods-special' },
                                        '\u79EF'
                                      ),
                                      goods.is_seckill == 1 && _react2.default.createElement(
                                        'span',
                                        { className: 'goods-special' },
                                        '\u79D2\u6740'
                                      ),
                                      _react2.default.createElement(
                                        'span',
                                        {
                                          className: 'goods-name',
                                          style: (0, _tools.convertLineStyleData)('text-decoration:line-through;')
                                        },
                                        goods.goods_name
                                      )
                                    ),
                                    orderData.status == 10 ? _react2.default.createElement(
                                      'span',
                                      { className: 'goods-status2' },
                                      '\u5DF2\u62D2\u7EDD'
                                    ) : orderData.status == 40 ? _react2.default.createElement(
                                      'span',
                                      { className: 'goods-status2' },
                                      '\u5DF2\u5173\u95ED'
                                    ) : (orderData.status == 0 || orderData.status == 20 || orderData.status == 30) && _react2.default.createElement(
                                      'span',
                                      { className: 'goods-status2' },
                                      pageData.account_type == 1 ? '已退款' : '已退菜'
                                    )
                                  ),
                                  goods.model_value_str && _react2.default.createElement(
                                    'div',
                                    { className: 'goods-type' },
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'type-size ellipsis' },
                                      goods.model_value_str
                                    )
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'goods-price flex-between' },
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'price-box' },
                                      _react2.default.createElement(
                                        'span',
                                        { className: 'priceNow' },
                                        _react2.default.createElement(
                                          'span',
                                          { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                          '\xA5'
                                        ),
                                        goods.price
                                      ),
                                      !pageData.orderInfo && _react2.default.createElement(
                                        'span',
                                        { className: 'priceBefore' },
                                        _react2.default.createElement(
                                          'span',
                                          { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                          '\uFFE5'
                                        ),
                                        goods.virtual_price || 0
                                      )
                                    ),
                                    _react2.default.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('color:#999;font-size:24rpx;') },
                                      _react2.default.createElement('span', {
                                        className: 'ico-moon icon-closes',
                                        style: (0, _tools.convertLineStyleData)('font-size:20rpx;')
                                      }),
                                      goods.reduced_num
                                    )
                                  )
                                )
                              ),
                              !!+goods.num && _react2.default.createElement(
                                'div',
                                {
                                  className: 'goods-info-item',
                                  style: (0, _tools.convertLineStyleData)(index == 0 && pageData.goodsSum > 3 && !showMoreGoods ? 'border-bottom:0;padding-bottom:0;' : '')
                                },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-image' },
                                  _react2.default.createElement('img', {
                                    src: goods.cover,
                                    mode: 'aspectFill'
                                  })
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'goods-detail' },
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'flex-between' },
                                    _react2.default.createElement(
                                      'div',
                                      {
                                        style: (0, _tools.convertLineStyleData)('max-width:400rpx;'),
                                        className: 'ellipsis'
                                      },
                                      goods.max_can_use_integral > 0 && _react2.default.createElement(
                                        'span',
                                        { className: 'goods-special' },
                                        '\u79EF'
                                      ),
                                      goods.is_seckill == 1 && _react2.default.createElement(
                                        'span',
                                        { className: 'goods-special' },
                                        '\u79D2\u6740'
                                      ),
                                      _react2.default.createElement(
                                        'span',
                                        { className: 'goods-name' },
                                        goods.goods_name
                                      )
                                    ),
                                    (orderData.status == 20 || orderData.status == 30) && _react2.default.createElement(
                                      'span',
                                      { className: 'goods-status3' },
                                      '\u5DF2\u51FA\u53A8'
                                    )
                                  ),
                                  goods.model_value_str && _react2.default.createElement(
                                    'div',
                                    { className: 'goods-type' },
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'type-taste ellipsis' },
                                      goods.model_value_str
                                    )
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'goods-price flex-between' },
                                    _react2.default.createElement(
                                      'div',
                                      { className: 'price-box' },
                                      _react2.default.createElement(
                                        'span',
                                        { className: 'priceNow' },
                                        _react2.default.createElement(
                                          'span',
                                          { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                          '\xA5'
                                        ),
                                        goods.price
                                      ),
                                      !pageData.orderInfo && _react2.default.createElement(
                                        'span',
                                        { className: 'priceBefore' },
                                        _react2.default.createElement(
                                          'span',
                                          { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                          '\uFFE5'
                                        ),
                                        goods.virtual_price || 0
                                      )
                                    ),
                                    !pageData.orderInfo && _react2.default.createElement(
                                      'div',
                                      { className: 'calculate-wrapper' },
                                      _react2.default.createElement(
                                        'div',
                                        {
                                          className: 'calculate-sub',
                                          onClick: _this3.subGoods,
                                          'data-key': key,
                                          'data-index': index,
                                          'data-value': goods.goodsNum
                                        },
                                        '-'
                                      ),
                                      _react2.default.createElement(
                                        'div',
                                        { className: 'calculate-num' },
                                        goods.goodsNum
                                      ),
                                      _react2.default.createElement(
                                        'div',
                                        {
                                          className: 'calculate-add',
                                          onClick: _this3.addGoods,
                                          'data-key': key,
                                          'data-index': index,
                                          'data-value': goods.goodsNum
                                        },
                                        '+'
                                      )
                                    ),
                                    pageData.orderInfo && _react2.default.createElement(
                                      'div',
                                      { style: (0, _tools.convertLineStyleData)('color:#999;font-size:24rpx;') },
                                      _react2.default.createElement('span', {
                                        className: 'ico-moon icon-closes',
                                        style: (0, _tools.convertLineStyleData)('font-size:20rpx;')
                                      }),
                                      goods.num
                                    )
                                  )
                                )
                              )
                            );
                          })
                        )
                      );
                    })
                  );
                })
              ),
              pageData.goodsSum > 3 && _react2.default.createElement(
                'div',
                { className: 'goods-showMore' },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-more',
                    hidden: showMoreGoods,
                    onClick: this.showMoreGoods
                  },
                  '\u5C55\u5F00\u66F4\u591A',
                  _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'goods-more',
                    hidden: !showMoreGoods,
                    onClick: this.showMoreGoods
                  },
                  '\u70B9\u51FB\u6536\u8D77',
                  _react2.default.createElement('span', { className: 'ico-moon icon-uparrow' })
                )
              ),
              exchangeCouponData.hasSelectGoods && !exchangeCouponData.selectModelInfo.is_refunded && _react2.default.createElement(
                'div',
                { className: 'goods-voucher' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-image' },
                  _react2.default.createElement('img', {
                    src: exchangeCouponData.goodsInfo.cover,
                    mode: 'aspectFill'
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-detail' },
                  _react2.default.createElement(
                    'div',
                    { className: 'flex-between' },
                    _react2.default.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('max-width:400rpx;'), className: 'ellipsis' },
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-special' },
                        '\u8D60\u54C1'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'goods-name' },
                        exchangeCouponData.goodsInfo.title
                      )
                    )
                  ),
                  goods.model_value_str && _react2.default.createElement(
                    'div',
                    { className: 'goods-type' },
                    _react2.default.createElement(
                      'div',
                      { className: 'type-taste ellipsis' },
                      goods.model_value_str
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('text-align: right;') },
                    'x1'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  className: 'other-price-wrapper',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:' + (showBenefitInfo ? '20rpx' : '') + ';')
                },
                _react2.default.createElement(
                  'div',
                  {
                    className: 'other-price-item flex-between',
                    hidden: pageData.tissue_fee == 0
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u7EB8\u5DFE\u8D39'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '￥' + pageData.tissue_fee
                  )
                ),
                pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 1 ? _react2.default.createElement(
                  'div',
                  {
                    className: 'other-price-item flex-between',
                    hidden: pageData.server_fee == 0
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u670D\u52A1\u8D39'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '￥' + pageData.server_fee
                  )
                ) : pageData.ec_dining_data && pageData.ec_dining_data.dining_mode == 2 && _react2.default.createElement(
                  'div',
                  {
                    className: 'other-price-item flex-between',
                    hidden: pageData.box_fee == 0
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5305\u88C5\u8D39'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '￥' + pageData.box_fee
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'discounted-item flex-between' },
                  _react2.default.createElement(
                    'div',
                    { className: 'discounted-item-detail' },
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                      '\u5546\u54C1\u91D1\u989D'
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '￥' + (pageData.orderInfo && pageData.orderInfo.total_original_price)
                  )
                ),
                pageData.account_type == 1 ? _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  !(pageData.orderInfo.status == 7) && pageData.show_benefit_info && _react2.default.createElement(
                    'div',
                    { className: 'discounted-item flex-between' },
                    _react2.default.createElement(
                      'div',
                      { className: 'discounted-item-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'other-type' },
                        '\u4F18\u60E0'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                        pageData.orderInfo.selected_benefit_info.name
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '￥' + pageData.orderInfo.discount_cut_price
                    )
                  ),
                  pageData.orderInfo.use_balance > 0 && _react2.default.createElement(
                    'div',
                    { className: 'discounted-item flex-between' },
                    _react2.default.createElement(
                      'div',
                      { className: 'discounted-item-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'other-type' },
                        '\u50A8\u503C'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                        '\u50A8\u503C\u4F18\u60E0'
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '-¥' + pageData.orderInfo.use_balance
                    )
                  )
                ) : (pageData.account_type == 2 && pageData.orderInfo && pageData.orderInfo.status == 0 || pageData.orderInfo && pageData.orderInfo.status == 3 || pageData.orderInfo && pageData.orderInfo.status == 6) && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  pageData.show_benefit_info && _react2.default.createElement(
                    'div',
                    { className: 'discounted-item flex-between' },
                    _react2.default.createElement(
                      'div',
                      { className: 'discounted-item-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'other-type' },
                        '\u4F18\u60E0'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                        pageData.orderInfo.selected_benefit_info.name
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '￥' + pageData.orderInfo.selected_benefit_info.discount_price
                    )
                  ),
                  pageData.orderInfo.use_balance > 0 && _react2.default.createElement(
                    'div',
                    { className: 'discounted-item flex-between' },
                    _react2.default.createElement(
                      'div',
                      { className: 'discounted-item-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'other-type' },
                        '\u50A8\u503C'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                        '\u50A8\u503C\u4F18\u60E0'
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '-￥' + pageData.orderInfo.use_balance
                    )
                  )
                ),
                (pageData.orderInfo && pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00' && !showBenefitInfo || !pageData.discountList.length) && _react2.default.createElement(
                  'div',
                  {
                    className: 'discounted-item flex-between',
                    style: (0, _tools.convertLineStyleData)('padding-bottom:0;')
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'discounted-item-detail' },
                    _react2.default.createElement(
                      'span',
                      { className: 'other-type' },
                      '\u4F18\u60E0'
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                      '\u4F1A\u5458\u4EF7'
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                    '-¥' + (pageData.orderInfo && pageData.orderInfo.vip_cut_price)
                  )
                ),
                (pageData.orderInfo && pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00' && !showBenefitInfo || !pageData.discountList.length) && _react2.default.createElement(
                  'div',
                  {
                    className: 'discounted-item vip_goods_detail',
                    onClick: this.showVipGoodsList,
                    style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;')
                  },
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'pull-right select-discount' },
                    '\u67E5\u770B\u8BE6\u60C5'
                  )
                )
              ),
              showBenefitInfo && _react2.default.createElement(
                'div',
                {
                  className: 'payment-wrapper',
                  hidden: !pageData.discountList.length
                },
                pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00' && _react2.default.createElement(
                  'div',
                  {
                    className: 'discounted-item flex-between',
                    style: (0, _tools.convertLineStyleData)('padding-bottom:0;padding-top:30rpx;border:none;')
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'discounted-item-detail' },
                    _react2.default.createElement(
                      'span',
                      { className: 'other-type' },
                      '\u4F18\u60E0'
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size:24rpx;') },
                      '\u4F1A\u5458\u4EF7'
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                    '-¥' + pageData.orderInfo.vip_cut_price
                  )
                ),
                pageData.orderInfo.is_vip_order == 1 && pageData.orderInfo.vip_cut_price != '0.00' && _react2.default.createElement(
                  'div',
                  {
                    className: 'discounted-item vip_goods_detail',
                    onClick: this.showVipGoodsList
                  },
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'pull-right select-discount' },
                    '\u67E5\u770B\u8BE6\u60C5'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'discounts-item flex-between',
                    style: (0, _tools.convertLineStyleData)('align-items:baseline;'),
                    onClick: this.showMemberDiscount
                  },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'discounts-type' },
                    _react2.default.createElement(
                      'div',
                      { className: 'discounts-name' },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'ellipsis',
                          style: (0, _tools.convertLineStyleData)('max-width:400rpx;display:inline-block;')
                        },
                        pageData.selectDiscountInfo.title
                      ),
                      _react2.default.createElement('span', { className: 'ico-moon icon-rightarrow icon-right' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'discounts-price' },
                      '-￥' + (pageData.selectDiscountInfo.discount_cut_price || 0)
                    )
                  )
                ),
                balance != 0 && !franchisee_id && _react2.default.createElement(
                  'div',
                  {
                    className: 'discounts-item flex-between',
                    style: (0, _tools.convertLineStyleData)('align-items: flex-start;')
                  },
                  _react2.default.createElement(
                    'span',
                    { className: 'discounts-name', style: (0, _tools.convertLineStyleData)('margin-top:14rpx;') },
                    '\u4F7F\u7528\u50A8\u503C\u91D1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'discounts-type' },
                    _react2.default.createElement(Switch, {
                      color: '#FF7100',
                      style: (0, _tools.convertLineStyleData)('transform:scale(.75);margin-right:-20rpx;'),
                      checked: pageData.useBalance,
                      onChange: this.useBalanceChange
                    }),
                    _react2.default.createElement(
                      'div',
                      {
                        hidden: !pageData.useBalance,
                        className: 'balance-price'
                      },
                      _react2.default.createElement(
                        'span',
                        { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color:#FF7100;') },
                        '- ¥' + pageData.deduction
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'price-count-box', hidden: showBenefitInfo },
                _react2.default.createElement(
                  'div',
                  { className: 'price-count' },
                  pageData.orderInfo && pageData.orderInfo.total_discount_cut_price > 0 && _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#999;font-size:26rpx;margin-right:28rpx;') },
                    '已优惠¥' + pageData.orderInfo.total_discount_cut_price + '元'
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:28rpx;vertical-align:text-bottom;') },
                    '\u603B\u8BA1:'
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:40rpx;color:#ff7100;') },
                    '￥' + pageData.totalPayment
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'order-baseInfo' },
                _react2.default.createElement(
                  'div',
                  { className: 'baseInfo-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#666;') },
                    '\u4E0B\u5355\u65E5\u671F'
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#999;') },
                    pageData.add_time
                  )
                ),
                pageData.orderInfo && !!+pageData.orderInfo.payment_time && _react2.default.createElement(
                  'div',
                  { className: 'baseInfo-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#666;') },
                    '\u652F\u4ED8\u65F6\u95F4'
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#999;') },
                    pageData.payment_time
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'baseInfo-item flex-between' },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#666;') },
                    '\u8BA2\u5355\u7F16\u53F7'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#999;') },
                      orderId
                    ),
                    _react2.default.createElement('span', { style: (0, _tools.convertLineStyleData)('margin:0 20rpx;width:1px;height:20rpx;background-color:#f1f1f1;display:inline-block;') }),
                    _react2.default.createElement(
                      'span',
                      {
                        style: (0, _tools.convertLineStyleData)('color:#ff7100;'),
                        onClick: this.setClipboardData,
                        'data-content': orderId
                      },
                      '\u590D\u5236'
                    )
                  )
                )
              )
            ),
            pageData.account_type == 2 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              changeOrder && !showBenefitInfo && _react2.default.createElement(
                'div',
                { className: 'changeOrder-wrapper all-price-box' },
                pageData.allow_add_dish && _react2.default.createElement(
                  'div',
                  {
                    className: 'changeOrder add',
                    onClick: this.turnToAddDish,
                    hidden: !pageData.location_id
                  },
                  '\u52A0\u83DC'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'changeOrder',
                    style: (0, _tools.convertLineStyleData)('color:#ff7100;padding:0 25rpx;'),
                    onClick: this.showBenefitInfo,
                    hidden: !pageData.allow_app_account
                  },
                  '\u4FDD\u5B58\u5E76\u652F\u4ED8'
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: 'changeOrder save',
                    onClick: this.saveOrderInfo,
                    hidden: showBenefitInfo,
                    style: (0, _tools.convertLineStyleData)(!pageData.allow_app_account && !pageData.allow_add_dish ? 'flex:1;' : '')
                  },
                  '\u4FDD\u5B58'
                )
              ),
              showBenefitInfo && _react2.default.createElement(
                'div',
                {
                  className: 'all-price-box flex-between',
                  hidden: !changeOrder
                },
                _react2.default.createElement(
                  'div',
                  { className: 'all-price' },
                  _react2.default.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('white-space:nowrap;') },
                    '\u5408\u8BA1\uFF1A'
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'all-price-now priceNow ellipse',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';max-width:200rpx;')
                    },
                    '￥' + pageData.totalPayment
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'discounted-price',
                      style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + ';')
                    },
                    '已优惠¥' + pageData.total_discount_cut_price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'flex-between' },
                  _react2.default.createElement(
                    'div',
                    { className: 'cancel_pay', onClick: this.cancelPayment },
                    '\u53D6\u6D88'
                  ),
                  _react2.default.createElement(
                    'form',
                    { reportSubmit: 'true', onSubmit: this.confirmPayment },
                    _react2.default.createElement(
                      'button',
                      {
                        formType: 'submit',
                        className: 'all-price-calculate',
                        style: (0, _tools.convertLineStyleData)('background-color:' + storeStyle.theme + '; width:190rpx;border-radius:0;')
                      },
                      '\u53BB\u7ED3\u7B97'
                    )
                  )
                )
              )
            )
          ),
          showVipGoodsList && _react2.default.createElement(
            'div',
            { className: 'vip_goods_mask', onClick: this.hideVipGoodsList },
            _react2.default.createElement(
              'div',
              { className: 'vipGoodsWarp' },
              pageData.orderInfo.dining_vip_card_info && _react2.default.createElement(
                'div',
                { className: 'custom-info-wrapper flex-between' },
                _react2.default.createElement(
                  'div',
                  { className: 'flex-between' },
                  _react2.default.createElement(
                    'div',
                    { className: 'custom-info' },
                    _react2.default.createElement('img', {
                      src: pageData.orderInfo.dining_vip_card_info.cover_thumb
                    })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'custom-name' },
                    pageData.orderInfo.dining_vip_card_info.title
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right' },
                  _react2.default.createElement(
                    'span',
                    { className: 'cut_price_tip' },
                    '\u4F18\u60E0'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'vip_cut_price' },
                    '-¥' + pageData.orderInfo.vip_cut_price
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-info-wrapper' },
                vip_goods_list.map(function (goods, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: 'items' },
                    !!+goods.refunded_num && _react2.default.createElement(
                      'div',
                      {
                        className: 'goods-info-item',
                        style: (0, _tools.convertLineStyleData)(index == 0 && pageData.goodsSum > 3 && !showMoreGoods ? 'border-bottom:0;padding-bottom:0;' : '')
                      },
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-image' },
                        _react2.default.createElement('img', { src: goods.cover, mode: 'aspectFill' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-detail' },
                        _react2.default.createElement(
                          'div',
                          { className: 'flex-between' },
                          _react2.default.createElement(
                            'div',
                            {
                              style: (0, _tools.convertLineStyleData)('max-width:400rpx;'),
                              className: 'ellipsis'
                            },
                            goods.max_can_use_integral > 0 && _react2.default.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79EF'
                            ),
                            goods.is_seckill == 1 && _react2.default.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79D2\u6740'
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'goods-name',
                                style: (0, _tools.convertLineStyleData)('text-decoration:line-through;')
                              },
                              goods.goods_name
                            )
                          ),
                          orderData.status == 10 ? _react2.default.createElement(
                            'span',
                            { className: 'goods-status2' },
                            '\u5DF2\u62D2\u7EDD'
                          ) : orderData.status == 40 && _react2.default.createElement(
                            'span',
                            { className: 'goods-status2' },
                            '\u5DF2\u5173\u95ED'
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'goods-status2' },
                            '\u5DF2\u9000'
                          )
                        ),
                        goods.model_value_str && _react2.default.createElement(
                          'div',
                          { className: 'goods-type' },
                          _react2.default.createElement(
                            'div',
                            { className: 'type-size ellipsis' },
                            goods.model_value_str
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-price flex-between' },
                          _react2.default.createElement(
                            'div',
                            { className: 'price-box' },
                            _react2.default.createElement(
                              'span',
                              { className: 'priceNow' },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                '\xA5'
                              ),
                              goods.price
                            ),
                            pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods && _react2.default.createElement(
                              'span',
                              { className: 'dinning_vip_tips' },
                              '\u4F1A\u5458\u4EF7'
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'priceBefore',
                                style: (0, _tools.convertLineStyleData)('margin-left:12rpx;font-size:28rpx;text-decoration:none;')
                              },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                '\xA5'
                              ),
                              goods.original_price
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { style: (0, _tools.convertLineStyleData)('color:#999;font-size:24rpx;') },
                            _react2.default.createElement('span', {
                              className: 'ico-moon icon-closes',
                              style: (0, _tools.convertLineStyleData)('font-size:20rpx;')
                            }),
                            goods.refunded_num
                          )
                        )
                      )
                    ),
                    goods.count && _react2.default.createElement(
                      'div',
                      {
                        className: 'goods-info-item',
                        style: (0, _tools.convertLineStyleData)(index == 0 && pageData.goodsSum > 3 && !showMoreGoods ? 'border-bottom:0;padding-bottom:0;' : '')
                      },
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-image' },
                        _react2.default.createElement('img', { src: goods.cover, mode: 'aspectFill' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-detail' },
                        _react2.default.createElement(
                          'div',
                          { className: 'flex-between' },
                          _react2.default.createElement(
                            'div',
                            {
                              style: (0, _tools.convertLineStyleData)('max-width:400rpx;'),
                              className: 'ellipsis'
                            },
                            goods.max_can_use_integral > 0 && _react2.default.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79EF'
                            ),
                            goods.is_seckill == 1 && _react2.default.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79D2\u6740'
                            ),
                            _react2.default.createElement(
                              'span',
                              { className: 'goods-name' },
                              goods.goods_name
                            )
                          ),
                          (orderData.status == 20 || orderData.status == 30) && _react2.default.createElement(
                            'span',
                            { className: 'goods-status3' },
                            '\u5DF2\u51FA\u53A8'
                          )
                        ),
                        goods.model_value_str && _react2.default.createElement(
                          'div',
                          { className: 'goods-type' },
                          _react2.default.createElement(
                            'div',
                            {
                              className: 'type-taste ellipsis',
                              style: (0, _tools.convertLineStyleData)('max-width:400rpx;')
                            },
                            goods.model_value_str
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-price flex-between' },
                          _react2.default.createElement(
                            'div',
                            { className: 'price-box' },
                            _react2.default.createElement(
                              'span',
                              { className: 'priceNow' },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                '\xA5'
                              ),
                              goods.price
                            ),
                            pageData.orderInfo.is_vip_order == 1 && goods.is_vip_goods && _react2.default.createElement(
                              'span',
                              { className: 'dinning_vip_tips' },
                              '\u4F1A\u5458\u4EF7'
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                className: 'priceBefore',
                                style: (0, _tools.convertLineStyleData)('margin-left:12rpx;font-size:28rpx;text-decoration:none;')
                              },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                                '\xA5'
                              ),
                              goods.original_price
                            )
                          ),
                          !pageData.orderInfo && _react2.default.createElement(
                            'div',
                            { className: 'calculate-wrapper' },
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'calculate-sub',
                                onClick: _this3.subGoods,
                                'data-key': key,
                                'data-index': index,
                                'data-value': goods.goodsNum
                              },
                              '-'
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'calculate-num' },
                              goods.goodsNum
                            ),
                            _react2.default.createElement(
                              'div',
                              {
                                className: 'calculate-add',
                                onClick: _this3.addGoods,
                                'data-key': key,
                                'data-index': index,
                                'data-value': goods.goodsNum
                              },
                              '+'
                            )
                          ),
                          pageData.orderInfo && _react2.default.createElement(
                            'div',
                            { style: (0, _tools.convertLineStyleData)('color:#999;font-size:24rpx;') },
                            _react2.default.createElement('span', {
                              className: 'ico-moon icon-closes',
                              style: (0, _tools.convertLineStyleData)('font-size:20rpx;')
                            }),
                            goods.count
                          )
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return DiningOrderDetail;
}(_OfficialPage3.default);

exports.default = DiningOrderDetail;

/***/ }),
/* 485 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(487);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RefundDishesDetail = function (_OfficialPage) {
  (0, _inherits3.default)(RefundDishesDetail, _OfficialPage);

  function RefundDishesDetail(props) {
    (0, _classCallCheck3.default)(this, RefundDishesDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RefundDishesDetail.__proto__ || Object.getPrototypeOf(RefundDishesDetail)).call(this, props));

    _this.state = {};

    _this.getModifyOrderList = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getModifiedOrderList',
        data: {
          order_id: _this.data.orderId
        },
        success: function success(res) {
          for (var i = 0; i < res.data.length; i++) {
            var goods = res.data[i].form_data.apply_goods;
            for (var j = 0; j < goods.length; j++) {
              if (!goods[j].model_value) break;
              goods[j].model_value_str = goods[j].model_value.join('|');
            }
          }
          that.setData({
            diningOrderList: res.data
          });
        }
      });
    };

    _this.getRufundDetail = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=/AppEcommerce/getOrderRefundApplyByOrderId',
        data: {
          order_id: _this.data.orderId
        },
        success: function success(res) {
          that.setData({
            orderInfo: res.data
          });
          that.modifyTime(res.data[0].add_time);
        }
      });
    };

    _this.modifyTime = function (time) {
      var add_time = _util2.default.formatTimeYMD(time);
      _this.setData({
        add_time: add_time
      });
    };

    document.title = '退款详情';
    return _this;
  }

  (0, _createClass3.default)(RefundDishesDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var account_type = options.type;
      var orderId = options.detail;
      this.setData({
        account_type: account_type,
        orderId: orderId
      });
      account_type == 1 ? this.getRufundDetail() : this.getModifyOrderList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          add_time = _state.add_time,
          account_type = _state.account_type,
          orderInfo = _state.orderInfo,
          diningOrderList = _state.diningOrderList;


      return React.createElement(
        'div',
        { className: 'official-page refund-dishes-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u9000\u6B3E\u8BE6\u60C5' }),
        account_type == 1 ? React.createElement(
          'div',
          { className: 'refund-wrapper' },
          orderInfo && orderInfo.map(function (item, index) {
            return React.createElement(
              React.Fragment,
              { key: index },
              React.createElement(
                'div',
                { className: 'refund-head flex-between' },
                React.createElement(
                  'div',
                  null,
                  '第' + (index + 1) + '次退款'
                ),
                React.createElement(
                  'div',
                  null,
                  '申请时间：' + add_time
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'refund-goods-wrapper',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:10rpx;')
                },
                React.createElement(
                  'div',
                  { className: 'refund-title', hidden: index > 0 },
                  '\u9000\u6B3E\u5546\u54C1'
                ),
                item.form_data.refund_goods.map(function (goods, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    React.createElement(
                      'div',
                      { className: 'goods-info-item' },
                      React.createElement(
                        'div',
                        { className: 'goods-image' },
                        React.createElement('img', {
                          src: goods.cover,
                          mode: 'aspectFill'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-detail' },
                        React.createElement(
                          'div',
                          { className: 'flex-between' },
                          React.createElement(
                            'div',
                            { style: (0, _tools.convertLineStyleData)('display:flex;align-items:center;') },
                            goods.max_can_use_integral > 0 && React.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79EF'
                            ),
                            goods.is_seckill == 1 && React.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79D2\u6740'
                            ),
                            React.createElement(
                              'span',
                              {
                                className: 'goods-name ellipsis',
                                style: (0, _tools.convertLineStyleData)('max-width:400rpx;')
                              },
                              goods.title
                            )
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'goods-type' },
                          goods.model_name && React.createElement(
                            'div',
                            { className: 'type-size' },
                            goods.model_name
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'goods-price flex-between' },
                          React.createElement(
                            'div',
                            { className: 'price-box' },
                            React.createElement(
                              'span',
                              { className: 'priceNow' },
                              React.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:30rpx;') },
                                '\uFFE5'
                              ),
                              goods.is_vip_goods ? goods.price : goods.original_price || goods.price
                            ),
                            goods.is_vip_goods && React.createElement(
                              'span',
                              { className: 'dinning_vip_tips' },
                              '\u4F1A\u5458\u4EF7'
                            ),
                            goods.is_vip_goods && React.createElement(
                              'span',
                              { style: (0, _tools.convertLineStyleData)('color:#999;font-size:26rpx;') },
                              '¥' + goods.original_price
                            )
                          ),
                          React.createElement(
                            'div',
                            {
                              className: 'calculate-wrapper',
                              style: (0, _tools.convertLineStyleData)('color:#999;')
                            },
                            'x' + goods.num
                          )
                        )
                      )
                    )
                  );
                }),
                React.createElement(
                  'div',
                  { className: 'refunds-price-wrapper' },
                  React.createElement(
                    'div',
                    { className: 'refund-info-item flex-between' },
                    React.createElement(
                      'span',
                      { id: 'refund-price', style: (0, _tools.convertLineStyleData)('color:#999;') },
                      '\u9000\u6B3E\u91D1\u989D'
                    ),
                    React.createElement(
                      'span',
                      null,
                      '￥' + item.refund_price
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'refund-info-item flex-between' },
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#999;') },
                      '\u9000\u6B3E\u65B9\u5F0F'
                    ),
                    React.createElement(
                      'span',
                      null,
                      '\u539F\u4ED8\u6B3E\u65B9\u5F0F\u9000\u56DE'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'refund-info-item flex-between' },
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#999;') },
                      '\u9000\u6B3E\u8BF4\u660E'
                    ),
                    React.createElement(
                      'span',
                      null,
                      item.form_data.refund_reason_info
                    )
                  )
                )
              )
            );
          })
        ) : account_type == 2 && React.createElement(
          'div',
          { className: 'refund-wrapper', style: (0, _tools.convertLineStyleData)('padding-top:30rpx;') },
          diningOrderList.map(function (item, index) {
            return React.createElement(
              React.Fragment,
              { key: index },
              React.createElement(
                'div',
                { className: 'refund-head flex-between' },
                React.createElement(
                  'div',
                  null,
                  '第' + (index + 1) + '次退菜' + (item.from_admin == 1 ? '（商家）' : '')
                ),
                React.createElement(
                  'div',
                  null,
                  '申请时间：' + item.apply_time
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'refund-goods-wrapper',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:10rpx;')
                },
                React.createElement(
                  'div',
                  { className: 'refund-title' },
                  '\u9000\u83DC\u5546\u54C1'
                ),
                item.form_data.apply_goods.map(function (goods, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    React.createElement(
                      'div',
                      { className: 'goods-info-item' },
                      React.createElement(
                        'div',
                        { className: 'goods-image' },
                        React.createElement('img', {
                          src: goods.cover,
                          mode: 'aspectFill'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-detail' },
                        React.createElement(
                          'div',
                          { className: 'flex-between' },
                          React.createElement(
                            'div',
                            { style: (0, _tools.convertLineStyleData)('display:flex;align-items:center;') },
                            goods.max_can_use_integral > 0 && React.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79EF'
                            ),
                            goods.is_seckill == 1 && React.createElement(
                              'span',
                              { className: 'goods-special' },
                              '\u79D2\u6740'
                            ),
                            React.createElement(
                              'span',
                              {
                                className: 'goods-name ellipsis',
                                style: (0, _tools.convertLineStyleData)('max-width:400rpx;')
                              },
                              goods.goods_name
                            )
                          )
                        ),
                        goods.model_value_str && React.createElement(
                          'div',
                          { className: 'goods-type' },
                          React.createElement(
                            'div',
                            { className: 'type-size ellipsis' },
                            goods.model_value_str
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'goods-price flex-between' },
                          React.createElement(
                            'div',
                            { className: 'price-box' },
                            React.createElement(
                              'span',
                              { className: 'priceNow' },
                              React.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:30rpx;') },
                                '\uFFE5'
                              ),
                              goods.is_vip_goods ? goods.price : goods.original_price || goods.price
                            ),
                            goods.is_vip_goods && React.createElement(
                              'span',
                              { className: 'dinning_vip_tips' },
                              '\u4F1A\u5458\u4EF7'
                            ),
                            goods.is_vip_goods && React.createElement(
                              'span',
                              { style: (0, _tools.convertLineStyleData)('color:#999;font-size:26rpx;') },
                              '¥' + goods.original_price
                            )
                          ),
                          React.createElement(
                            'div',
                            {
                              className: 'calculate-wrapper',
                              style: (0, _tools.convertLineStyleData)('color:#999;')
                            },
                            'x' + goods.num
                          )
                        )
                      )
                    )
                  );
                })
              )
            );
          })
        )
      );
    }
  }]);
  return RefundDishesDetail;
}(_OfficialPage3.default);

exports.default = RefundDishesDetail;

/***/ }),
/* 487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(489);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VerificationCodePage = function (_OfficialPage) {
  (0, _inherits3.default)(VerificationCodePage, _OfficialPage);

  function VerificationCodePage(props) {
    (0, _classCallCheck3.default)(this, VerificationCodePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VerificationCodePage.__proto__ || Object.getPrototypeOf(VerificationCodePage)).call(this, props));

    _this.state = {
      codeImgUrl: '',
      codeNum: '',
      codeStatus: 0
    };

    _this.setVerificationCodeData = function (res) {
      var that = _this;
      that.setData({
        codeImgUrl: res.data.qrcode_url,
        codeNum: res.data.code,
        codeStatus: res.data.status
      });
      // TODO that.connectSocket()
    };

    _this.timeInterval = '';

    _this.connectSocket = function () {
      var that = _this;
      _app.appMethod.connectSocket({
        url: 'wss://test.zhichiwangluo.com',
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.timeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_order_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_order_verify' && msg.status == 0) {
            that.setData({
              codeStatus: 1
            });
            clearInterval(that.timeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
    };

    document.title = '核销码';
    return _this;
  }

  (0, _createClass3.default)(VerificationCodePage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var subShopAppId = option.sub_shop_app_id;
      var orderId = option.detail;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetOrderVerifyCode',
        data: {
          sub_shop_app_id: subShopAppId,
          order_id: orderId
        },
        success: that.setVerificationCodeData
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearInterval(that.timeInterval);
      // TODO app.closeSocket()
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          codeStatus = _state.codeStatus,
          codeImgUrl = _state.codeImgUrl,
          codeNum = _state.codeNum;

      return React.createElement(
        'div',
        { className: 'official-page verification-code-page' },
        React.createElement(_TopNav.TopNav, { title: '\u6838\u9500\u7801' }),
        React.createElement(
          'div',
          { className: 'page', id: 'verificationCodePage' },
          React.createElement(
            'div',
            {
              className: 'verification-code-area ' + (codeStatus == 1 ? 'finished' : '')
            },
            React.createElement('img', { className: 'verification-code-img', src: codeImgUrl }),
            React.createElement(
              'div',
              { className: 'verification-code-text' },
              React.createElement(
                'div',
                null,
                '\u6838\u9500\u7801:'
              ),
              React.createElement(
                'div',
                { className: 'num' },
                codeNum
              )
            ),
            React.createElement(
              'div',
              { className: 'verification-code-finished' },
              React.createElement(
                'div',
                { className: 'text' },
                '\u5DF2\u5B8C\u6210'
              )
            )
          )
        )
      );
    }
  }]);
  return VerificationCodePage;
}(_OfficialPage3.default);

exports.default = VerificationCodePage;

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(491);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoodsSameJourney = function (_OfficialPage) {
  (0, _inherits3.default)(GoodsSameJourney, _OfficialPage);

  function GoodsSameJourney(props) {
    (0, _classCallCheck3.default)(this, GoodsSameJourney);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoodsSameJourney.__proto__ || Object.getPrototypeOf(GoodsSameJourney)).call(this, props));

    _this2.state = {
      centerLat: '',
      centerLng: '',
      addressListMakers: [],
      circles: [{
        latitude: '',
        longitude: '',
        fillColor: '#ff710033',
        radius: 2000
      }],
      sameJourneyId: '',
      notInRange: false,
      showAddress: false,
      storeStyle: {}
    };
    _this2.callout = {
      content: '门店地址',
      fontSize: 14,
      color: '#333333',
      borderRadius: 4,
      bgColor: '#ffffff',
      padding: 10,
      display: 'ALWAYS',
      textAlign: 'center',
      notInRange: false
    };
    _this2.franchiseeId = '';

    _this2.dataInitial = function () {
      _this2.getAppECStoreConfig();
      _this2.getAddressList();
      _this2.getCurrentLocation();
      _this2.getPickUpGoodsType();
      _this2.isShowAddress();
    };

    _this2.getPickUpGoodsType = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        data: {
          pick_up_type: 2,
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          if (!res.data.app_store_data) {
            return;
          }
          var centerLng = res.data.app_store_data.longitude;
          var centerLat = res.data.app_store_data.latitude;
          var addressListMakers = _this.data.addressListMakers;
          addressListMakers.push({
            latitude: centerLat,
            longitude: centerLng,
            iconPath: '/images/delivery.png',
            width: 20,
            height: 20
          });
          _this.setData({
            centerLng: centerLng,
            centerLat: centerLat,
            'circles[0].longitude': centerLng,
            'circles[0].latitude': centerLat,
            'circles[0].radius': +res.data.config_data.deliver_distance,
            addressListMakers: addressListMakers,
            showMap: true
          });
        }
      });
    };

    _this2.getAddressList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        data: {
          sub_shop_app_id: _this.franchiseeId
        },
        success: function success(res) {
          var addressList = res.data;
          var addressListMakers = _this.data.addressListMakers;
          var notInRange = false;
          addressList.map(function (item) {
            var iconPath = void 0;
            if (item.address_info.label == 0) {
              iconPath = 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-home.png';
            } else if (item.address_info.label == 1) {
              iconPath = 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-school.png';
            } else if (item.address_info.label == 2) {
              iconPath = 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-company.png';
            } else {
              iconPath = 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-other.png';
            }
            addressListMakers.push({
              latitude: item.latitude,
              longitude: item.longitude,
              iconPath: iconPath,
              width: 24,
              height: 28
            });
            if (item.config && item.config.intra_city != 1) {
              notInRange = true;
            }
          });
          var sameJourneyId = _this.data.sameJourneyId ? _this.data.sameJourneyId : addressList.length && addressList[0].id;
          _this.setData({
            notInRange: notInRange,
            addressList: addressList,
            sameJourneyId: sameJourneyId,
            addressListMakers: addressListMakers
          });
        }
      });
    };

    _this2.selectDelivery = function (event) {
      var index = event.currentTarget.dataset.index;
      var addressList = _this2.data.addressList;
      _this2.setData({
        sameJourneyId: addressList[index].id
      });
      _this2.sureDelivery();
    };

    _this2.sureDelivery = function () {
      var sameJourneyId = _this2.data.sameJourneyId;
      var pages = _app.appMethod.getCurrentPages();
      var prePage = pages[pages.length - 2];
      if (!prePage) {
        Toast.info('当前操作需要返回上一页');
        _app.appMethod.turnBack();
        return;
      }
      var addressList = _this2.data.addressList;
      if (!sameJourneyId) {
        _app.appMethod.showModal({
          content: '请选择配送点'
        });
        return;
      }
      // 对前一个页面的竖版列表列表组件进行设置 vertical-list
      if (_this2.data.compindex && _this2.data.compindex > -1) {
        var compindex = _this2.data.compindex;
        for (var i = 0; i < addressList.length; i++) {
          if (addressList[i].id == sameJourneyId) {
            var _prePage$setData;

            prePage.setData((_prePage$setData = {}, (0, _defineProperty3.default)(_prePage$setData, 'eles[' + compindex + '].selectSameJourneyId', sameJourneyId), (0, _defineProperty3.default)(_prePage$setData, 'eles[' + compindex + '].selectSameJourney', addressList[i]), (0, _defineProperty3.default)(_prePage$setData, 'eles[' + compindex + '].sameJourneyTimeType', ''), (0, _defineProperty3.default)(_prePage$setData, 'eles[' + compindex + '].sameJourneyDateTime', ''), _prePage$setData));
          }
        }
      } else {
        for (var _i = 0; _i < addressList.length; _i++) {
          if (addressList[_i].id == sameJourneyId) {
            prePage.setData({
              selectSameJourneyId: sameJourneyId,
              selectSameJourney: addressList[_i],
              sameJourneyTimeType: '',
              sameJourneyDateTime: ''
            });
          }
        }
      }
      _app.appMethod.turnBack();
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.getCurrentLocation = function () {
      var _this = _this2;
      _app.appMethod.getLocation({
        success: function success(res) {
          var latitude = res.latitude;
          var longitude = res.longitude;
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            method: 'post',
            data: {
              latitude: latitude,
              longitude: longitude
            },
            success: function success(res) {
              var addressListMakers = _this.data.addressListMakers;
              addressListMakers.push({
                latitude: latitude,
                longitude: longitude,
                iconPath: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-city-me.png',
                width: 20,
                height: 20
              });
              _this.setData({
                currentLocationData: res.data,
                addressListMakers: addressListMakers
              });
            }
          });
        }
      });
    };

    _this2.opratAddress = function () {
      _this2.isBack = true;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?from=form');
    };

    _this2.isShowAddress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getSwitchBySwitchName',
        method: 'post',
        data: {
          switch_name: 'intra_city_address_position'
        },
        success: function success(res) {
          if (!res.status) {
            that.setData({
              showAddress: res.data == 1 ? true : false
            });
          }
        }
      });
    };

    document.title = '选择配送点';
    return _this2;
  }

  (0, _createClass3.default)(GoodsSameJourney, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchiseeId = options.franchiseeId || '';
      this.setData({
        from: options.from || '',
        sameJourneyId: options.sameJourneyId || '',
        compindex: options.compindex || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isBack) {
        this.getAddressList();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          currentLocationData = _state.currentLocationData,
          storeStyle = _state.storeStyle,
          showAddress = _state.showAddress,
          centerLng = _state.centerLng,
          centerLat = _state.centerLat,
          circles = _state.circles,
          addressListMakers = _state.addressListMakers,
          showMap = _state.showMap,
          addressList = _state.addressList,
          sameJourneyId = _state.sameJourneyId,
          from = _state.from,
          notInRange = _state.notInRange;


      return React.createElement(
        'div',
        { className: 'official-page goods-same-journey' },
        React.createElement(_TopNav.TopNav, { title: '\u9009\u62E9\u914D\u9001\u70B9' }),
        showAddress && React.createElement(
          'div',
          {
            className: 'current-location-box',
            onClick: this.selectGoodsSameJourney
          },
          React.createElement('span', { className: 'ico-moon icon-goods-location' }),
          React.createElement(
            'span',
            null,
            currentLocationData && currentLocationData.formatted_addresses && currentLocationData.formatted_addresses.recommend || '暂无地址'
          ),
          React.createElement(
            'span',
            {
              onClick: this.getCurrentLocation,
              className: 'pull-right renew-position',
              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
            },
            '\u91CD\u65B0\u5B9A\u4F4D'
          )
        ),
        showMap && showAddress && React.createElement('div', null),
        React.createElement(
          'div',
          { className: 'receipt-header' },
          '\u6536\u8D27\u5730\u5740'
        ),
        React.createElement(
          'div',
          { className: 'delivery-list-box' },
          addressList && addressList.map(function (item, index) {
            return React.createElement(
              React.Fragment,
              { key: item.id },
              (from != 'preview' || item.config && item.config.intra_city == 1) && React.createElement(
                'div',
                {
                  className: 'delivery-list',
                  onClick: _this3.selectDelivery,
                  'data-index': index
                },
                React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                React.createElement(
                  'div',
                  { className: 'delivery-list-content' },
                  React.createElement(
                    'div',
                    { className: 'delivery-list-title' },
                    item.config && item.config.intra_city == 1 && React.createElement(
                      'label',
                      { className: 'support-same-city address-label' },
                      '\u53EF\u540C\u57CE'
                    ),
                    item.address_info.label == 0 && React.createElement(
                      'label',
                      { className: 'home address-label' },
                      '\u5BB6'
                    ),
                    item.address_info.label == 2 && React.createElement(
                      'label',
                      { className: 'company address-label' },
                      '\u516C\u53F8'
                    ),
                    item.address_info.label == 1 && React.createElement(
                      'label',
                      { className: 'school address-label' },
                      '\u5B66\u6821'
                    ),
                    item.address_info.name + ' ' + item.address_info.contact
                  ),
                  React.createElement(
                    'div',
                    { className: 'delivery-list-detail' },
                    item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + (item.detail_address || '')
                  )
                ),
                React.createElement('label', {
                  style: (0, _tools.convertLineStyleData)(sameJourneyId == item.id ? 'color:' + storeStyle.theme : ''),
                  className: 'delivery-check-box ico-moon icon-success-tip ' + (sameJourneyId == item.id ? 'checked' : '')
                })
              )
            );
          })
        ),
        from == 'preview' && addressList && !!addressList.length && notInRange && React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'receipt-header no-support-header' },
            '\u4EE5\u4E0B\u5730\u5740\u8D85\u51FA\u914D\u9001\u8303\u56F4'
          ),
          React.createElement(
            'div',
            { className: 'delivery-list-box no-support-pick' },
            addressList.map(function (item, index) {
              return React.createElement(
                React.Fragment,
                { key: item.id },
                item.config && item.config.intra_city != 1 && React.createElement(
                  'div',
                  { className: 'delivery-list' },
                  React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  React.createElement(
                    'div',
                    { className: 'delivery-list-content' },
                    React.createElement(
                      'div',
                      { className: 'delivery-list-title' },
                      item.address_info.label == 0 && React.createElement(
                        'label',
                        { className: 'address-label' },
                        '\u5BB6'
                      ),
                      item.address_info.label == 2 && React.createElement(
                        'label',
                        { className: 'address-label' },
                        '\u516C\u53F8'
                      ),
                      item.address_info.label == 1 && React.createElement(
                        'label',
                        { className: 'address-label' },
                        '\u5B66\u6821'
                      ),
                      item.address_info.name + ' ' + item.address_info.contact
                    ),
                    React.createElement(
                      'div',
                      { className: 'delivery-list-detail' },
                      item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + (item.detail_address || '')
                    )
                  ),
                  React.createElement('label', { className: 'delivery-check-box ico-moon icon-success-tip' })
                )
              );
            })
          )
        ),
        !(addressList && addressList.length) && React.createElement(
          'div',
          { className: 'same-journey-null' },
          React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/same-journey-null.png' }),
          React.createElement(
            'div',
            { onClick: this.opratAddress },
            '\u6682\u65E0\u6536\u8D27\u5730\u5740,',
            React.createElement(
              'span',
              {
                style: (0, _tools.convertLineStyleData)(storeStyle.theme ? 'color:' + storeStyle.theme : 'color:' + '#ff7100')
              },
              '\u53BB\u6DFB\u52A0\u5730\u5740'
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'sure-delivery',
            style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
            onClick: this.opratAddress
          },
          '\u7BA1\u7406\u6536\u8D27\u5730\u5740'
        )
      );
    }
  }]);
  return GoodsSameJourney;
}(_OfficialPage3.default);

exports.default = GoodsSameJourney;

/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(493);

var _lunar = __webpack_require__(494);

var _lunar2 = _interopRequireDefault(_lunar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var minYear = 1900;
var maxYear = 2099;

var MemberDay = function (_OfficialPage) {
  (0, _inherits3.default)(MemberDay, _OfficialPage);

  function MemberDay(props) {
    (0, _classCallCheck3.default)(this, MemberDay);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MemberDay.__proto__ || Object.getPrototypeOf(MemberDay)).call(this, props));

    _this2.state = {
      year: new Date().getFullYear(), // 年份
      month: new Date().getMonth() + 1, // 月份1~12
      day: new Date().getDate(), // 日期
      startDate: '2018-01', // 日历范围起点
      endDate: '2099-12', // 日历范围终点
      header: true, // 是否显示标题
      next: true, // 是否显示下个月按钮
      prev: true, // 是否显示上个月按钮
      showMoreDays: true, // 显示额外上下月份日期
      weeks: true, // 是否显示周标题
      weeksType: 'cn', // 周标题类型
      cellSize: 32, // 单元格大小
      lunar: false, // 是否显示农历
      days_array: [], // 日期数组
      memberDays: [],
      weekTitle: ['日', '一', '二', '三', '四', '五', '六'],
      max_year: 2099, // 最大年份
      max_month: 12, // 最大月份
      min_year: 1900, // 最小年份
      min_month: 1, // 最小月份
      franchiseeId: '', //子店id
      monthsData: []
    };

    _this2.getMemberDayInfo = function () {
      var daysArray = _this2.data.days_array;
      var len = daysArray.length;
      var startInfo = daysArray[0][0];
      var endInfo = daysArray[len - 1][6];
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/vipBenefitDayCalendar',
        method: 'post',
        data: {
          start_time: startInfo.year + '-' + startInfo.month + '-' + startInfo.day,
          end_time: endInfo.year + '-' + endInfo.month + '-' + endInfo.day,
          sub_shop_app_id: _this.data.franchiseeId
        },
        hideLoading: false,
        success: function success(res) {
          var data = res.data;
          var memberDays = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              if (data[key].length && key.split('-').length === 3) {
                (function () {
                  var ids = [];
                  data[key].map(function (item) {
                    ids.push(item.id);
                  });
                  memberDays.push({
                    id: ids,
                    year: key.split('-')[0],
                    month: key.split('-')[1],
                    day: key.split('-')[2]
                  });
                })();
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          _this.setData({
            memberDays: memberDays
          });
          _this._setMemberDay();
        }
      });
    };

    _this2._setMemberDay = function () {
      _this2.setData({
        days_array: _this2._setCalendarData(_this2.data.year, _this2.data.month)
      });
    };

    _this2._checkYear = function (year) {
      if (year < minYear) {
        throw new RangeError('年份不能小于' + minYear + '年');
      } else if (year > maxYear) {
        throw new RangeError('年份不能大于' + maxYear + '年');
      }
      return true;
    };

    _this2._checkMonth = function (month) {
      if (month < 1) {
        throw new RangeError('月份不能小于1');
      } else if (month > 12) {
        throw new RangeError('月份不能大于12');
      }
      return true;
    };

    _this2._checkDay = function (day) {
      if (day < 1) {
        throw new RangeError('日期不能小于1');
      } else if (day > 31) {
        throw new RangeError('日期不能大于31');
      }
      return true;
    };

    _this2._yearChange = function (newYear, oldYear) {
      if (_this2._checkYear(newYear)) {
        _this2.setData({
          year: newYear,
          days_array: _this2._setCalendarData(newYear, _this2.data.month)
        });
      }
    };

    _this2._monthChange = function (newMonth, oldMonth) {
      if (_this2._checkMonth(newMonth)) {
        _this2.setData({
          month: newMonth,
          days_array: _this2._setCalendarData(_this2.data.year, newMonth)
        });
      }
    };

    _this2._dayChange = function (newDay, oldDay) {
      if (_this2._checkDay(newDay)) {
        _this2.setData({
          day: newDay
        });
      }
    };

    _this2._setStartDate = function (newDate, oldDate) {
      if (newDate.length == 7 && newDate.indexOf('-') == 4) {
        var year = parseInt(newDate.split('-')[0]);
        var month = parseInt(newDate.split('-')[1]);
        if (!isNaN(year) && year >= minYear && !isNaN(month) && month >= 1 && month <= 12) {
          _this2.setData({
            startDate: newDate,
            min_year: year,
            min_month: month
          });
        } else {
          throw new Error('起始日期必须是YYYY-MM格式，且大于等于1900-01');
        }
      } else {
        throw new Error('起始日期必须是YYYY-MM格式');
      }
    };

    _this2._setEndDate = function (newDate, oldDate) {
      if (newDate.length == 7 && newDate.indexOf('-') == 4) {
        var year = parseInt(newDate.split('-')[0]);
        var month = parseInt(newDate.split('-')[1]);
        if (!isNaN(year) && year <= 2099 && !isNaN(month) && month >= 1 && month <= 12) {
          _this2.setData({
            endDate: newDate,
            max_year: year,
            max_month: month
          });
        } else {
          throw new Error('结束日期必须是YYYY-MM格式，且小于等于2099-12');
        }
      } else {
        throw new Error('结束日期必须是YYYY-MM格式');
      }
    };

    _this2._headerChange = function (newHeader, oldHeader) {
      _this2.setData({
        header: !!newHeader
      });
    };

    _this2._moreChange = function (newMore, oldMore) {
      _this2.setData({
        showMoreDays: !!newMore,
        days_array: _this2._setCalendarData(_this2.data.year, _this2.data.month)
      });
    };

    _this2._weeksTypeChange = function (newVal, oldVal) {
      switch (newVal) {
        case 'en':
          _this2.setData({
            weeksType: 'en',
            weekTitle: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
          });
          break;
        case 'cn':
          _this2.setData({
            weeksType: 'cn',
            weekTitle: ['日', '一', '二', '三', '四', '五', '六']
          });
          break;
        case 'full-en':
          _this2.setData({
            weeksType: 'full-en',
            weekTitle: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
          });
          break;
        default:
          _this2.setData({
            weeksType: 'en',
            weekTitle: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
          });
          break;
      }
    };

    _this2._showWeeksChange = function (newVal, oldVal) {
      _this2.setData({
        weeks: !!newVal
      });
    };

    _this2._setCellSize = function (newSize, oldSize) {
      _this2.setData({
        cellSize: newSize
      });
    };

    _this2._showLunar = function (newConfig, oldConfig) {
      _this2.setData({
        lunar: !!newConfig
      });
    };

    _this2._setCalendarData = function (year, month) {
      var empty_days_count = new Date(year, month - 1, 1).getDay(); // 本月第一天是周几，0是星期日，6是星期六
      var empty_days = new Array();
      var prev_month = month - 1 == 0 ? 12 : month - 1; // 上个月的月份数
      var prev_year = month - 1 == 0 ? _this2.data.year - 1 : _this2.data.year;
      var today = new Date();
      for (var i = 0; i < empty_days_count; i++) {
        empty_days.push({
          state: 'inactive',
          day: -1,
          month: prev_month,
          year: prev_year,
          info: 'prev',
          color: '#c3c6d1',
          background: 'transparent'
        });
      }
      var last_day = new Date(year, month, 0); // 本月最后一天
      var days_count = last_day.getDate(); // 本月最后一天是几号
      var last_date = last_day.getDay(); // 本月最后一天是星期几
      var next_month = month + 1 == 13 ? 1 : month + 1; // 下个月的月份数
      var next_year = month + 1 == 13 ? _this2.data.year + 1 : _this2.data.year;
      var empty_days_last = new Array();
      for (var _i = 0; _i < 6 - last_date; _i++) {
        empty_days_last.push({
          state: 'inactive',
          day: -2,
          month: next_month,
          year: next_year,
          info: 'next',
          color: '#c3c6d1',
          background: 'transparent'
        });
      }
      var temp = new Array();
      for (var _i2 = 1; _i2 <= days_count; _i2++) {
        temp.push({
          state: 'inactive',
          day: _i2,
          month: month,
          year: year,
          info: 'current',
          color: '#4a4f74',
          background: 'transparent'
        });
      }
      var days_range = temp; // 本月
      var days = empty_days.concat(days_range, empty_days_last); // 上个月 + 本月 + 下个月
      for (var _i3 = 0; _i3 < _this2.data.memberDays.length; _i3++) {
        var item = _this2.data.memberDays[_i3];
        for (var j = 0; j < days.length; j++) {
          if (days[j].year == item.year && days[j].month == item.month && days[j].day == item.day) {
            days[j].is_member_day = 1;
          }
          if (days[j].year == today.getFullYear() && days[j].month === today.getMonth() + 1 && days[j].day === today.getDate()) {
            days[j].is_today = 1;
          }
        }
      }
      if (_this2.data.showMoreDays) {
        var index = days.findIndex(function (element) {
          return element.day == -2;
        });
        if (index != -1) {
          var length = days.length;
          var count = length - index;
          for (var _i4 = 1; _i4 <= count; _i4++) {
            days[index + _i4 - 1].day = _i4;
          }
        }
        index = days.findIndex(function (element) {
          return element.day == 1;
        }) - 1;
        if (index != -1) {
          var last_month_day = new Date(year, month - 1, 0).getDate();
          for (var _i5 = 0; _i5 <= index; _i5++) {
            days[_i5].day = last_month_day - index + _i5;
          }
        }
      }
      for (var _i6 = 0; _i6 < days.length; _i6++) {
        var _item = days[_i6];
        var solarDay = _item.day;
        var solarMonth = _item.month;
        var solarYear = year;
        if (solarDay > 0) {
          var lunarDate = _lunar2.default.solarToLunar(year, solarMonth, solarDay);
          days[_i6]['lunarMonth'] = lunarDate.monthStr;
          days[_i6]['lunarDay'] = lunarDate.dayStr;
          if (lunarDate.dayStr == '初一') {
            days[_i6]['lunarDay'] = lunarDate.monthStr;
          }
        }
      }
      var days_array = new Array();
      var week = new Array();
      for (var _i7 = 0; _i7 < days.length; _i7++) {
        week.push(days[_i7]);
        if (_i7 % 7 == 6) {
          days_array.push(week);
          week = new Array();
        }
      }
      if (week.length > 0) {
        days_array.push(week);
      }
      return days_array;
    };

    _this2.nextMonth = function () {
      var eventDetail = {
        prevYear: _this2.data.year,
        prevMonth: _this2.data.month
      };
      if (_this2.data.month == 12) {
        _this2.setData({
          year: _this2.data.year + 1,
          month: 1
        });
      } else {
        _this2.setData({
          month: _this2.data.month + 1
        });
      }
      _this2.setData({
        days_array: _this2._setCalendarData(_this2.data.year, _this2.data.month)
      });
      eventDetail['currentYear'] = _this2.data.year;
      eventDetail['currentMonth'] = _this2.data.month;
      _this2.getMemberDayInfo();
    };

    _this2.prevMonth = function () {
      var eventDetail = {
        prevYear: _this2.data.year,
        prevMonth: _this2.data.month
      };
      if (_this2.data.month == 1) {
        _this2.setData({
          year: _this2.data.year - 1,
          month: 12
        });
      } else {
        _this2.setData({
          month: _this2.data.month - 1
        });
      }
      _this2.setData({
        days_array: _this2._setCalendarData(_this2.data.year, _this2.data.month)
      });
      eventDetail['currentYear'] = _this2.data.year;
      eventDetail['currentMonth'] = _this2.data.month;
      _this2.getMemberDayInfo();
    };

    _this2.dateChange = function (event) {
      var eventDetail = {
        prevYear: _this2.data.year,
        prevMonth: _this2.data.month
      };
      var year = event[0];
      var month = event[1];
      _this2.setData({
        year: year,
        month: month,
        days_array: _this2._setCalendarData(year, month)
      });
      eventDetail['currentYear'] = year;
      eventDetail['currentMonth'] = month;
      _this2.getMemberDayInfo();
    };

    _this2.dayClick = function (event) {
      var detail = {
        year: event.year,
        month: event.month,
        day: event.day,
        color: event.color,
        lunarMonth: event.lunarMonth,
        lunarDay: event.lunarDay,
        background: event.background
      };
      console.log(detail);
      _this2.data.memberDays.map(function (item) {
        if (item.year == detail.year && item.month == detail.month && item.day == detail.day) {
          var pagePath = '';
          if (item.id.length > 1) {
            pagePath = '/memberDayList?date=' + detail.year + '-' + detail.month + '-' + detail.day;
          } else {
            pagePath = '/memberDayDetail?id=' + item.id[0];
          }
          _app.appMethod.turnToPage(pagePath, false);
        }
      });
    };

    _this2.attached = function () {
      var year = _this2.data.year;
      var month = _this2.data.month;
      _this2.setData({
        days_array: _this2._setCalendarData(year, month)
      });
    };

    _this2.createYearMonthData = function () {
      var result = [];
      var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (m) {
        return { value: m, label: m + '月' };
      });
      for (var y = minYear; y < maxYear; y++) {
        result.push({
          value: y,
          label: y + '年',
          children: months
        });
      }
      return result;
    };

    document.title = '会员日日历';
    return _this2;
  }

  (0, _createClass3.default)(MemberDay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchiseeId = options.franchisee || '';
      this.setData({
        franchiseeId: franchiseeId,
        monthsData: this.createYearMonthData()
      });
      this._yearChange(this.data.year);
      this._monthChange(this.data.month);
      this._dayChange(this.data.day);
      this._setStartDate(this.data.startDate);
      this._setEndDate(this.data.endDate);
      this._headerChange(this.data.header);
      this._moreChange(this.data.showMoreDays);
      this._showWeeksChange(this.data.weeks);
      this._weeksTypeChange(this.data.weeksType);
      this._setCellSize(this.data.cellSize);
      this._showLunar(this.data.weeksType);
      this.getMemberDayInfo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          year = _state.year,
          min_year = _state.min_year,
          month = _state.month,
          min_month = _state.min_month,
          prev = _state.prev,
          startDate = _state.startDate,
          endDate = _state.endDate,
          max_year = _state.max_year,
          max_month = _state.max_month,
          next = _state.next,
          header = _state.header,
          weeks = _state.weeks,
          weekTitle = _state.weekTitle,
          days_array = _state.days_array,
          cellSize = _state.cellSize,
          monthsData = _state.monthsData;

      return React.createElement(
        'div',
        { className: 'official-page member-day' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u65E5\u65E5\u5386' }),
        React.createElement(
          'div',
          { className: 'calendar calendar-style' },
          header && React.createElement(
            'div',
            { className: 'calendar-header header-style' },
            year == min_year && month == min_month ? React.createElement('span', null) : prev ? React.createElement('span', {
              className: 'ico-moon icon-leftarrow',
              onClick: this.prevMonth
            }) : React.createElement('span', null),
            React.createElement(
              _picker2.default,
              {
                data: monthsData,
                cols: '2',
                value: [year, month],
                onOk: function onOk(date) {
                  return _this3.dateChange(date);
                }
              },
              React.createElement(
                'span',
                { className: 'date-text' },
                year + '年' + month + '月'
              )
            ),
            year == max_year && month == max_month ? React.createElement('span', null) : next ? React.createElement('span', {
              className: 'ico-moon icon-rightarrow',
              onClick: this.nextMonth
            }) : React.createElement('span', null)
          ),
          React.createElement(
            'div',
            { className: 'calendar-board board-style' },
            weeks && weekTitle.length == 7 && React.createElement(
              'div',
              { className: 'calendar-weeks' },
              weekTitle.map(function (item, index) {
                return React.createElement(
                  'span',
                  { className: 'calendar-weekday', key: index },
                  item
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'calendar-days' },
              days_array.map(function (item, i) {
                return React.createElement(
                  React.Fragment,
                  { key: i },
                  React.createElement(
                    'div',
                    { className: 'calendar-row' },
                    days_array[i].map(function (day, index) {
                      return React.createElement(
                        React.Fragment,
                        { key: index },
                        day.day <= 0 ? React.createElement(
                          'div',
                          {
                            className: 'calendar-cell',
                            style: (0, _tools.convertLineStyleData)('background: ' + day.background + '; width: ' + cellSize + 'px; height: ' + cellSize + 'px;')
                          },
                          day.is_member_day && React.createElement('img', { className: 'member-day-img', src: '' })
                        ) : React.createElement(
                          'div',
                          {
                            className: 'calendar-cell cell-rounded ' + (day.is_today === 1 ? 'today' : ''),
                            style: (0, _tools.convertLineStyleData)('background: ' + day.background + '; width: ' + cellSize + 'px; height: ' + cellSize + 'px;'),
                            onClick: function onClick() {
                              return _this3.dayClick(day);
                            },
                            'data-day': day
                          },
                          day.is_member_day && React.createElement('img', {
                            className: 'member-day-img',
                            src: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/vip-card/member-day.png'
                          }),
                          React.createElement(
                            'span',
                            {
                              className: 'calendar-day',
                              style: (0, _tools.convertLineStyleData)('color: ' + day.color + ';')
                            },
                            day.day
                          )
                        )
                      );
                    })
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);
  return MemberDay;
}(_OfficialPage3.default);

MemberDay.externalClasses = ['calendar-style', // 日历整体样式
'header-style', // 标题样式
'board-style'];
exports.default = MemberDay;

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var lunarInfo = new Array(0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0, 0x09ad0, 0x055d2, // 1900年~1909年
0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540, 0x0d6a0, 0x0ada2, 0x095b0, 0x14977, // 1910年~1919年
0x04970, 0x0a4b0, 0x0b4b5, 0x06a50, 0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970, // 1920年~1929年
0x06566, 0x0d4a0, 0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950, // 1930年~1939年
0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2, 0x0a950, 0x0b557, // 1940年~1949年
0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5d0, 0x14573, 0x052d0, 0x0a9a8, 0x0e950, 0x06aa0, // 1950年~1959年
0x0aea6, 0x0ab50, 0x04b60, 0x0aae4, 0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0, // 1960年~1969年
0x096d0, 0x04dd5, 0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b5a0, 0x195a6, // 1970年~1979年
0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46, 0x0ab60, 0x09570, // 1980年~1989年
0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58, 0x055c0, 0x0ab60, 0x096d5, 0x092e0, // 1990年~1999年
0x0c960, 0x0d954, 0x0d4a0, 0x0da50, 0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5, // 2000年~2009年
0x0a950, 0x0b4a0, 0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930, // 2010年~2019年
0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260, 0x0ea65, 0x0d530, // 2020年~2029年
0x05aa0, 0x076a3, 0x096d0, 0x04bd7, 0x04ad0, 0x0a4d0, 0x1d0b6, 0x0d250, 0x0d520, 0x0dd45, // 2030年~2039年
0x0b5a0, 0x056d0, 0x055b2, 0x049b0, 0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0, // 2040年~2049年
0x14b63, 0x09370, 0x049f8, 0x04970, 0x064b0, 0x168a6, 0x0ea50, 0x06b20, 0x1a6c4, 0x0aae0, // 2050年~2059年
0x0a2e0, 0x0d2e3, 0x0c960, 0x0d557, 0x0d4a0, 0x0da50, 0x05d55, 0x056a0, 0x0a6d0, 0x055d4, // 2060年~2069年
0x052d0, 0x0a9b8, 0x0a950, 0x0b4a0, 0x0b6a6, 0x0ad50, 0x055a0, 0x0aba4, 0x0a5b0, 0x052b0, // 2070年~2079年
0x0b273, 0x06930, 0x07337, 0x06aa0, 0x0ad50, 0x14b55, 0x04b60, 0x0a570, 0x054e4, 0x0d160, // 2080年~2089年
0x0e968, 0x0d520, 0x0daa0, 0x16aa6, 0x056d0, 0x04ae0, 0x0a9d4, 0x0a2d0, 0x0d150, 0x0f252, // 2090年~2099年
0x0d520 // 2100年
);
var minYear = 1900; // 能计算的最小年份
var maxYear = 2100; // 能计算的最大年份
var solarMonth = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
var monthName = new Array('正月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '冬月', '腊月');
var solarTerm = new Array('小寒', '大寒', '立春', '雨水', '惊蛰', '春分', '清明', '谷雨', '立夏', '小满', '芒种', '夏至', '小暑', '大暑', '立秋', '处暑', '白露', '秋分', '寒露', '霜降', '立冬', '小雪', '大雪', '冬至');
var termInfo = new Array(0, 21208, 42467, 63836, 85337, 107014, 128867, 150921, 173149, 195551, 218072, 240693, 263343, 285989, 308563, 331033, 353350, 375494, 397447, 419210, 440795, 462224, 483532, 504758);
function _checkYear(year) {
	if (year < minYear) {
		throw new RangeError('年份不能小于' + minYear + '年');
	} else if (year > maxYear) {
		throw new RangeError('年份不能大于' + maxYear + '年');
	}
	return true;
}
function _checkMonth(month) {
	if (month < 1) {
		throw new RangeError('月份不能小于1');
	} else if (month > 12) {
		throw new RangeError('月份不能大于12');
	}
	return true;
}
function _checkDay(day) {
	if (day < 1) {
		throw new RangeError('日期不能小于1');
	} else if (day > 31) {
		throw new RangeError('日期不能大于31');
	}
	return true;
}
function getLunarLeapMonth(year) {
	if (_checkYear(year)) {
		return lunarInfo[year - minYear] & 0xf; // 最后4位，代表这一年的闰月月份，为0则今年没有闰月
	}
}
function getLeapMonthDaysCount(year) {
	if (getLunarLeapMonth(year)) {
		return lunarInfo[year - minYear] & 0x10000 ? 30 : 29; // 前4位，即0在这一年是闰年时才有意义，它代表这年闰月的大小月
	}
	return 0;
}
function getLunarYearDaysCount(year) {
	if (_checkYear(year)) {
		var sum = 348; // 29天 * 12个月 = 348日
		for (var i = 0x8000; i > 0x8; i >>= 1) {
			sum += lunarInfo[year - minYear] & i ? 1 : 0;
		}
		return sum + getLeapMonthDaysCount(year);
	}
}
function getLunarYearMonthDaysCount(year, month) {
	if (_checkYear(year) && _checkMonth(month)) {
		return lunarInfo[year - minYear] & 0x10000 >> month ? 30 : 29;
	}
}
function getLunarDayString(day) {
	if (_checkDay(day)) {
		var nStr1 = new Array('日', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十');
		var nStr2 = new Array('初', '十', '廿', '卅');
		var str = '';
		switch (day) {
			case 10:
				str = '初十';
				break;
			case 20:
				str = '二十';
				break;
			case 30:
				str = '三十';
				break;
			default:
				str = nStr2[Math.floor(day / 10)];
				str += nStr1[day % 10];
				break;
		}
		return str;
	}
}
function getLunarTermDay(year, n) {
	if (_checkYear(year) && n <= 23 && n >= 0) {
		var sTermInfo = new Array(0, 21208, 42467, 63836, 85337, 107014, 128867, 150921, 173149, 195551, 218072, 240693, 263343, 285989, 308563, 331033, 353350, 375494, 397447, 419210, 440795, 462224, 483532, 504758);
		var offDate = new Date(31556925974.7 * (year - minYear) + sTermInfo[n] * 60000 + Date.UTC(minYear, 0, 6, 2, 5));
		return offDate.getUTCDate();
	}
}
function solarToLunar(year, month, day) {
	if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
		var baseDate = new Date(minYear, 0, 31); // 基础日期1900年1月31日
		var objDate = new Date(year, month - 1, day); // 目标日期
		var offset = (objDate - baseDate) / 86400000; // 偏移天数 60 * 60 * 24 * 1000 = 86400000，1天的毫秒数
		var monCycle = 14;
		var temp = 0;
		var i = 0;
		for (i = minYear; i < maxYear && offset > 0; i++) {
			temp = getLunarYearDaysCount(i); // 农历year年的总天数
			if (offset - temp < 0) {
				break;
			} else {
				offset -= temp;
			}
			monCycle += 12;
		}
		var lunarYear = i; // 农历年份
		var leap = getLunarLeapMonth(lunarYear); // 当年闰月是哪个月
		var isLeapYear = leap > 0 ? true : false; // 当年是否有闰月
		var isLeapMonth = false; // 当前农历月份是否是闰月
		for (i = 1; i <= 12 && offset > 0; i++) {
			if (leap > 0 && i == leap + 1 && !isLeapMonth) {
				--i;
				isLeapMonth = true;
				temp = getLeapMonthDaysCount(year);
			} else {
				temp = getLunarYearMonthDaysCount(year, i);
			}
			if (isLeapMonth && i == leap + 1) {
				isLeapMonth = false;
			}
			offset -= temp;
			if (!isLeapMonth) {
				monCycle++;
			}
		}
		if (offset == 0 && leap > 0 && i == leap + 1) {
			if (isLeapMonth) {
				isLeapMonth = false;
			} else {
				isLeapMonth = true;
				--i;
				--monCycle;
			}
		}
		if (offset < 0) {
			offset += temp;
			--i;
			--monCycle;
		}
		var lunarMonth = i; // 农历月份
		var lunarDay = offset + 1; // 农历日期
		var monthStr = '';
		if (isLeapYear) {
			if (lunarMonth < leap) {
				monthStr = monthName[lunarMonth - 1];
			} else if (lunarMonth == leap) {
				monthStr = '闰' + monthName[lunarMonth - 1];
			} else {
				monthStr = monthName[lunarMonth - 2];
			}
		} else {
			monthStr = monthName[lunarMonth - 1];
		}
		return {
			year: lunarYear, // 农历年份
			month: lunarMonth, // 农历月份
			day: lunarDay, // 农历日期
			isLeap: isLeapMonth, // 是否闰月
			monthStr: monthStr, // 月份字符串
			dayStr: getLunarDayString(lunarDay) // 日期字符串
		};
	}
}
function getSolarMonthDaysCount(year, month) {
	if (_checkYear(year) && _checkMonth(month)) {
		if (month == 2) {
			return year % 4 == 0 && year % 100 != 0 || year % 400 == 0 ? 29 : 28;
		} else {
			return solarMonth[month - 1];
		}
	}
}
function getSolarDayNumber(year, month, day) {
	if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
		var date = new Date(year, month - 1, day);
		var d = date.getDate(); // 本月第几天
		var m = month - 1;
		var sum = d;
		for (var i = 0; i < m; i++) {
			sum += solarMonth[i];
		}
		if (m > 1 && year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
			sum += 1;
		}
		return sum;
	}
}
function getLunar24Days(year, month, day) {
	if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
		var baseDate = new Date(1900, 0, 6, 2, 5, 0);
		var str = false;
		for (var i = 1; i <= 24; i++) {
			var num = 525948.76 * (year - 1900) + termInfo[i];
			var timestamp = baseDate.getTime() + num * 60 * 1000;
			var newDate = new Date(timestamp);
			if (getSolarDayNumber(newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()) == getSolarDayNumber(year, month, day)) {
				str = solarTerm[i];
				break;
			}
		}
		return str;
	}
}
exports.default = {
	getLunarLeapMonth: getLunarLeapMonth, // 返回农历year年中哪个月是闰月，没有闰月返回0
	getLeapMonthDaysCount: getLeapMonthDaysCount, // 返回农历year年闰月的天数（如果没有闰月则返回0）
	getLunarYearDaysCount: getLunarYearDaysCount, // 返回农历year年的总天数
	getLunarYearMonthDaysCount: getLunarYearMonthDaysCount, // 返回农历year年month月的天数
	getLunarDayString: getLunarDayString, // 农历日期的中文字符串
	getLunarTermDay: getLunarTermDay, // 返回某年的第n个节气为第几日
	getSolarMonthDaysCount: getSolarMonthDaysCount, // 获取阳历某个月份有多少天
	getSolarDayNumber: getSolarDayNumber, // 获取指定日期是阳历年中的第几天
	getLunar24Days: getLunar24Days, // 计算指定日期是否属于24节气
	solarToLunar: solarToLunar // 阳历日期转农历日期
};

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(496);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberDayDetail = function (_OfficialPage) {
  (0, _inherits3.default)(MemberDayDetail, _OfficialPage);

  function MemberDayDetail(props) {
    (0, _classCallCheck3.default)(this, MemberDayDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MemberDayDetail.__proto__ || Object.getPrototypeOf(MemberDayDetail)).call(this, props));

    _this2.state = {
      memberDayInfo: {}, // 会员日信息
      weekData: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, { label: '周三', value: 3 }, { label: '周四', value: 4 }, { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }],
      franchiseeId: ''
    };

    _this2.getMemberDetail = function (id) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getVipBenefitDay',
        method: 'post',
        data: {
          data_id: id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var data = res.data;
          if (data.date_type === '0') {
            if (data.start_date === data.end_date) {
              data.date = data.start_date;
            } else {
              data.date = data.start_date + ' 至 ' + data.end_date;
            }
          } else if (data.date_type === '1') {
            var len = data.date_arr.length;
            data.date = '';
            data.date_arr.forEach(function (date, ind) {
              ind === len - 1 ? data.date += _this.data.weekData[date - 1]['label'] : data.date += _this.data.weekData[date - 1]['label'] + '、';
            });
          } else if (data.date_type === '2') {
            var _len = data.date_arr.length;
            data.date = '每月';
            data.date_arr.forEach(function (date, ind) {
              ind === _len - 1 ? data.date += date + '号' : data.date += date + '号、';
            });
          }
          data.benefits = [];
          if (data.discount && data.discount != 0) {
            data.benefits.push({
              category: 'discount',
              discount: data.discount
            });
          }
          if (data.user_coupon_list && Array.isArray(data.user_coupon_list) && data.user_coupon_list.length) {
            data.user_coupon_list.map(function (coupon) {
              coupon.category = 'coupon';
              coupon.name = coupon.type === '0' ? '满减券' : coupon.type === '1' ? '打折券' : coupon.type === '2' ? '代金券' : coupon.type === '3' ? '兑换券' : coupon.type === '4' ? '储值券' : coupon.type === '5' ? '通用券' : '';
              data.benefits.push(coupon);
            });
          }
          _this.setData({
            memberDayInfo: res.data
          });
          console.log(_this.data.memberDayInfo);
        }
      });
    };

    document.title = '会员日详情';
    return _this2;
  }

  (0, _createClass3.default)(MemberDayDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var id = options.id ? options.id : '';
      var franchiseeId = options.franchisee || '';
      this.setData({
        franchiseeId: franchiseeId
      });
      this.getMemberDetail(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var memberDayInfo = this.state.memberDayInfo;

      return React.createElement(
        'div',
        { className: 'official-page member-day-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u65E5\u8BE6\u60C5' }),
        React.createElement(
          'div',
          { className: 'content' },
          React.createElement(
            'div',
            { className: 'info-item space-between' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u540D\u79F0'
            ),
            React.createElement(
              'div',
              { className: 'right-block' },
              memberDayInfo.title
            )
          ),
          React.createElement(
            'div',
            { className: 'info-item space-between' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u65E5\u671F'
            ),
            React.createElement(
              'div',
              { className: 'right-block' },
              memberDayInfo.date
            )
          ),
          React.createElement(
            'div',
            { className: 'info-item space-between' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u65F6\u95F4\u6BB5'
            ),
            React.createElement(
              'div',
              { className: 'right-block' },
              memberDayInfo.start_time + ' - ' + memberDayInfo.end_time
            )
          ),
          React.createElement(
            'div',
            { className: 'info-item space-between' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u53EF\u9886\u53D6\u7528\u6237'
            ),
            memberDayInfo.user_condition === '0' ? React.createElement(
              'div',
              { className: 'right-block' },
              '\u6240\u6709\u7528\u6237'
            ) : memberDayInfo.user_condition === '1' ? React.createElement(
              'div',
              { className: 'right-block' },
              '\u6240\u6709\u4F1A\u5458'
            ) : React.createElement(
              'div',
              { className: 'right-block' },
              Array.isArray(memberDayInfo.user_condition_list) && memberDayInfo.user_condition_list.map(function (item, idx) {
                return React.createElement(
                  'div',
                  { key: idx },
                  idx === memberDayInfo.user_condition_list.length - 1 ? item : item + '、'
                );
              })
            )
          ),
          memberDayInfo.benefits && memberDayInfo.benefits.length && React.createElement(
            'div',
            { className: 'info-item' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u57FA\u672C\u6743\u76CA'
            ),
            React.createElement(
              'div',
              { className: 'about-block' },
              memberDayInfo.benefits.map(function (item, idx) {
                return React.createElement(
                  'div',
                  { className: 'about-item', key: idx },
                  item.category === 'discount' ? idx + 1 + '.所有商品打' + item.discount + '折；（仅会员日活动期间有效）' : item.category === 'coupon' ? idx + 1 + '.' + item.name + '-' + item.title : ''
                );
              })
            )
          ),
          memberDayInfo.description !== '' && React.createElement(
            'div',
            { className: 'info-item' },
            React.createElement(
              'div',
              { className: 'name' },
              '\u5546\u5BB6\u7559\u8A00'
            ),
            React.createElement(
              'div',
              { className: 'about-block' },
              React.createElement(
                'div',
                { className: 'about-item' },
                memberDayInfo.description
              )
            )
          )
        )
      );
    }
  }]);
  return MemberDayDetail;
}(_OfficialPage3.default);

exports.default = MemberDayDetail;

/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MemberDayList = function (_OfficialPage) {
  (0, _inherits3.default)(MemberDayList, _OfficialPage);

  function MemberDayList(props) {
    (0, _classCallCheck3.default)(this, MemberDayList);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MemberDayList.__proto__ || Object.getPrototypeOf(MemberDayList)).call(this, props));

    _this2.state = {
      listData: [], // 会员日列表数据
      screenHeight: 1624, // 屏幕高度
      weekData: [{ label: '周一', value: 1 }, { label: '周二', value: 2 }, { label: '周三', value: 3 }, { label: '周四', value: 4 }, { label: '周五', value: 5 }, { label: '周六', value: 6 }, { label: '周日', value: 7 }],
      franchiseeId: ''
    };

    _this2.getSystemInfo = function () {
      var _this = _this2;
      _app.appMethod.getSystemInfo({
        success: function success(res) {
          _this.setData({
            screenHeight: res.screenHeight * 2
          });
        }
      });
    };

    _this2.getMemberDayList = function (date) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/vipBenefitDayCalendar',
        method: 'post',
        data: {
          start_time: date,
          end_time: date,
          sub_shop_app_id: _this.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var data = [];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = Object.keys(res.data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              data = res.data[key];
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          data.map(function (item) {
            if (item.date_type === '0') {
              if (item.start_date === item.end_date) {
                item.date = item.start_date;
              } else {
                item.date = item.start_date + ' 至 ' + item.end_date;
              }
            } else if (item.date_type === '1') {
              var len = item.date_arr.length;
              item.date = '';
              item.date_arr.forEach(function (date, ind) {
                ind === len - 1 ? item.date += _this.data.weekData[date - 1]['label'] : item.date += _this.data.weekData[date - 1]['label'] + '、';
              });
            } else if (item.date_type === '2') {
              var _len = item.date_arr.length;
              item.date = '每月';
              item.date_arr.forEach(function (date, ind) {
                ind === _len - 1 ? item.date += date + '号' : item.date += date + '号、';
              });
            }
          });
          _this.setData({
            listData: data
          });
        }
      });
    };

    _this2.gotoDetail = function (e) {
      var id = e.currentTarget.dataset.id;
      var pagePath = '/eCommerce/pages/memberDayDetail/memberDayDetail?id=' + id;
      _app.appMethod.turnToPage(pagePath, false);
    };

    document.title = '会员日列表';
    return _this2;
  }

  (0, _createClass3.default)(MemberDayList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var date = options.date ? options.date : '';
      var franchiseeId = options.franchisee || '';
      this.setData({
        franchiseeId: franchiseeId
      });
      this.getSystemInfo();
      this.getMemberDayList(date);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var listData = this.state.listData;

      return React.createElement(
        'div',
        { className: 'official-page member-day-list' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u65E5\u5217\u8868' }),
        React.createElement(
          'div',
          { className: 'content' },
          listData.map(function (item, index) {
            return React.createElement(
              'div',
              { className: 'memberdDay-item', key: index },
              React.createElement(
                'div',
                { className: 'top-block' },
                React.createElement(
                  'div',
                  { className: 'name' },
                  '名称：' + item.title
                ),
                React.createElement(
                  'div',
                  {
                    className: 'more-btn',
                    'data-id': item.id,
                    onClick: _this3.gotoDetail
                  },
                  '\u67E5\u770B\u8BE6\u60C5'
                )
              ),
              React.createElement('div', { className: 'line' }),
              React.createElement(
                'div',
                { className: 'bottom-block' },
                React.createElement(
                  'div',
                  { className: 'date' },
                  '日期:  ' + item.date
                )
              )
            );
          })
        )
      );
    }
  }]);
  return MemberDayList;
}(_OfficialPage3.default);

exports.default = MemberDayList;

/***/ }),
/* 498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _MemberDiscount = __webpack_require__(66);

var _ScrollView = __webpack_require__(11);

__webpack_require__(500);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferPage = function (_OfficialPage) {
  (0, _inherits3.default)(TransferPage, _OfficialPage);

  function TransferPage() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, TransferPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = TransferPage.__proto__ || Object.getPrototypeOf(TransferPage)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '当面付'
      },
      isShowNoJoinPrice: false,
      appTitle: '',
      franchisee: '', // 子店id
      balanceState: false, // 储值的状态
      storeState: true, // 店铺优惠的状态
      totalDiscountPrice: '',
      totalPayment: '',
      inputPrice: '', // 输入的金额
      oldInputPrice: '', // 上一次输入的金额
      noJoinPrice: '', // 不参与优惠金额
      oldNoJoinPrice: '', // 上一次不参与优惠金额
      requesting: false,
      transferConfig: {}, // 当面付配置信息
      userInfo: {}, // 会员信息
      vipCardInfo: {
        // 会员卡信息
        isShow: false,
        logo: 'cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/transfer/default-vip-card-logo.png'
      },
      memberDiscount: [], // 会员优惠
      aloneBenefitState: 0, // 唯一的会员优惠的状态 0->不使用 | 1->使用
      selectedBenefit: {}, // 选中的会员优惠
      storeBenefitInfo: { discount_price: '0.00' }, // 店铺优惠
      useBalancePrice: '0.00', // 储值使用金额
      currentStoreBenefitInfo: {}, // 当前店铺满减活动
      storeBenefitActivityList: [], // 店铺优惠列表
      isShowPriceLimitTip: false, // 是否显示价格限制提示
      combineBenefit: {}, // 自定义优惠
      combineState: {
        // 自定义优惠的使用状态 0->不使用 | 1->使用
        vip: 0,
        coupon: 0,
        integral: 0
      },
      combineEnable: {
        // 自定义优惠的可用状态 0->不可用 | 1->可用
        vip: 0,
        coupon: 0,
        integral: 0
      },
      balanceItemInfo: [], // 储值项（用于充值）
      balancePayLoading: false, // 储值充值loading
      remark: '', // 备注
      inputState: 0, // 输入的状态 0->用户手动输入 1->扫码输入（关联金额） 2->扫码输入（关联订单）
      relatedOrderInfo: '', // 关联订单的数据 id、优惠信息
      benefitType: {
        vip: '会员卡',
        paid_vip: '会员卡',
        vip_benefit_day: '会员卡',
        coupon: '优惠券',
        integral: '积分'
      },
      relatedData: {}, // 关联订单的相关数据
      isShowBalanceItem: false // 是否显示储值项
    }, _this2.calculateReqNum = 0, _this2.memberDiscountRef = _react2.default.createRef(), _this2.resetData = function (isInit) {
      _this2.setData({
        userInfo: _app.appMethod.getUserInfo(),
        selectedBenefit: {},
        storeBenefitInfo: { discount_price: '0.00' },
        totalPayment: '',
        balanceState: false,
        aloneBenefitState: 0,
        remark: '',
        useBalancePrice: '0.00',
        combineState: {
          vip: 0,
          coupon: 0,
          integral: 0
        },
        storeState: true,
        combineBenefit: {},
        inputState: 0,
        relatedOrderInfo: '',
        isShowBalanceItem: false,
        relatedData: {},
        oldInputPrice: '',
        oldNoJoinPrice: '',
        requesting: false
      });
      if (isInit) {
        _this2.setData({
          inputPrice: '',
          noJoinPrice: ''
        });
      }
    }, _this2.getTransferOrderConfig = function (callback) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransferOrder/GetTransferOrderConfig',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var data = res.data,
              status = res.status;

          if (status === 0) {
            var get_vipcard_directly = data.get_vipcard_directly,
                vipcard_id = data.vipcard_id,
                background_color = data.background_color,
                scan_mode = data.scan_mode,
                input_mode = data.input_mode;

            data.background_color = background_color || '#FF7100';
            if (scan_mode === '1' && input_mode === '0') {
              _this2.scanPaymentCode();
            }
            if (get_vipcard_directly == 1 && vipcard_id && vipcard_id != 0) {
              _this2.vipCardInit(vipcard_id);
            }
            if (callback) {
              callback();
            }
            _this2.setData({
              transferConfig: data
            });
            _this2.resetCombineEnable();
          }
        }
      });
    }, _this2.resetCombineEnable = function () {
      var _this2$data$transferC = _this2.data.transferConfig,
          combine_benefit_enable = _this2$data$transferC.combine_benefit_enable,
          vip_card_benefit_enable = _this2$data$transferC.vip_card_benefit_enable,
          coupon_benefit_enable = _this2$data$transferC.coupon_benefit_enable,
          integral_benefit_enable = _this2$data$transferC.integral_benefit_enable;

      _this2.setData({
        combineEnable: {
          vip: combine_benefit_enable == 1 && vip_card_benefit_enable == 1 ? 1 : 0,
          coupon: combine_benefit_enable == 1 && coupon_benefit_enable == 1 ? 1 : 0,
          integral: combine_benefit_enable == 1 && integral_benefit_enable == 1 ? 1 : 0
        }
      });
    }, _this2.vipCardInit = function (id) {
      _this2.getEnableVipCardList(id, function () {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/GetVIPCardInfo',
          data: {
            vip_id: id,
            sub_shop_app_id: _this2.data.franchisee
          },
          hideLoading: true,
          success: function success(res) {
            var status = res.status,
                data = res.data;

            if (status === 0) {
              _this2.getUserVipLevel(data[0]);
            }
          }
        });
      });
    }, _this2.getUserVipLevel = function (cardInfo) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPInfo',
        data: {
          sub_shop_app_id: _this2.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var data = res.data,
              status = res.status;

          if (status === 0) {
            var level = data.level ? data.level : 0;
            var id = data.vip_id ? data.vip_id : 0;
            if (level <= +cardInfo.level && id !== cardInfo.id) {
              cardInfo.isShow = true;
              cardInfo.logo = cardInfo.logo || _this2.data.vipCardInfo.logo;
              _this2.setData({
                vipCardInfo: cardInfo
              });
            }
          }
        }
      });
    }, _this2.getEnableVipCardList = function (id, callback) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppVipCard/GetEnableVipCardList',
        data: {
          sub_shop_app_id: _this2.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var data = res.data || [];
          data.forEach(function (val) {
            if (val.id === id) {
              callback();
            }
          });
        }
      });
    }, _this2.getCurrentStoreBenefitInfo = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppStoreBenefit/GetCurrentStoreBenefitInfo',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var data = res.data,
              status = res.status;

          if (status === 0) {
            if (data) {
              data.rule_titles = data.rule_titles.map(function (rule) {
                rule = rule.replace('分阶段满减<br>', '');
                rule = rule.replace('阶段满减<br>', '');
                return rule;
              });
            }
            _this2.setData({
              currentStoreBenefitInfo: data || {}
            });
          }
        }
      });
    }, _this2.goToCouponDesc = function () {
      var pagePath = '/eCommerce/pages/couponDescription/couponDescription?franchisee=' + _this2.data.franchisee;
      _app.appMethod.turnToPage(pagePath, false);
    }, _this2.handleVipCard = function () {
      _this2.getCollectUserinfoConfig(function () {
        _app.appMethod.turnToPage('/pages/userCenter/userCenter?r=' + '/eCommerce/pages/transferPage/transferPage' + '&id=' + _this2.data.transferConfig.vipcard_id + '&is_no_condition_recv=' + 1 + '&franchisee=' + _this2.data.franchisee);
      });
    }, _this2.recvVipCard = function () {
      _app.appMethod.sendRequest({
        data: {
          vipcard_id: _this2.data.transferConfig.vipcard_id,
          sub_shop_app_id: _this2.data.franchisee
        },
        url: '/index.php?r=AppVipCard/RecvVipCard',
        hideLoading: true,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '开卡成功',
            icon: 'success'
          });
          _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice();
          _this2.setData({
            'vipCardInfo.isShow': false
          });
        }
      });
    }, _this2.getCollectUserinfoConfig = function (callback) {
      _app.appMethod.sendRequest({
        data: {},
        url: '/index.php?r=AppVipCard/GetCollectUserinfoConfig',
        hideLoading: true,
        success: function success(res) {
          if (res.data.need_collect_info) {
            callback();
          } else {
            _this2.recvVipCard();
          }
        }
      });
    }, _this2.showMemberDiscount = function (e) {
      var memberDiscount = [];
      var selectedBenefit = {};
      var combineBenefit = _this2.data.combineBenefit;
      var type = e.currentTarget.dataset.type;
      if (type === 'vip') {
        memberDiscount.push({
          label: 'vip',
          value: combineBenefit.all_vip_benefit
        });
        selectedBenefit = {
          type: 'combine',
          discount_type: combineBenefit.selected_user_vip.type || 'vip',
          vip_id: combineBenefit.selected_user_vip.id || 0,
          no_use_benefit: combineBenefit.vip_benefit_discount_price === '0.00' ? 1 : 0
        };
      } else if (type === 'coupon') {
        if (!combineBenefit.coupon_benefit) {
          combineBenefit.coupon_benefit = [];
        }
        memberDiscount.push({
          label: 'coupon',
          value: combineBenefit.coupon_benefit.concat(combineBenefit.cant_use_coupon_benefit || [])
        });
        selectedBenefit = {
          type: 'combine',
          discount_type: 'coupon',
          coupon_id: combineBenefit.selected_user_coupon_id,
          no_use_benefit: combineBenefit.coupon_benefit_discount_price === '0.00' ? 1 : 0
        };
      } else if (type === 'integral') {
        memberDiscount.push({
          label: 'integral',
          value: combineBenefit.integral_benefit instanceof Array ? combineBenefit.integral_benefit : [combineBenefit.integral_benefit]
        });
        selectedBenefit = {
          type: 'combine',
          discount_type: 'integral',
          no_use_benefit: combineBenefit.integral_benefit.discount_price === '0.00' ? 1 : 0
        };
      } else {
        memberDiscount = _this2.data.memberDiscount;
        selectedBenefit = _this2.data.selectedBenefit;
      }
      _this2.setData({
        memberDiscount: memberDiscount,
        selectedBenefit: selectedBenefit
      });
      _this2.memberDiscountRef.current.show({
        discountType: memberDiscount,
        franchisee: _this2.data.franchisee,
        themeColor: _this2.data.transferConfig.background_color,
        afterSelectedDiscount: function afterSelectedDiscount(event) {
          _this2.afterSelectedBenefit(event);
        }
      });
      _this2.memberDiscountRef.current.showDialog(_this2.data.selectedBenefit, _this2.data.franchisee);
    }, _this2.inputPrice = function (e) {
      var re = /^\d{1,5}(\.\d{0,2})?$/,
          isShowPriceLimitTip = false,
          price = e.target.value.split('¥').length === 2 ? e.target.value.split('¥')[1] : e.target.value;
      price = price.replace(/\s+/g, '');
      if (!re.test(price) && price !== '') {
        _app.appMethod.showToast({
          title: '价格区间仅支持0.01~99999.99元',
          icon: 'none',
          duration: 1000
        });
        price = _this2.data.oldInputPrice;
        isShowPriceLimitTip = true;
      }
      _this2.setData({
        inputState: 0,
        storeState: true,
        selectedBenefit: {},
        combineBenefit: {},
        oldInputPrice: price,
        inputPrice: price,
        isShowPriceLimitTip: isShowPriceLimitTip,
        noJoinPrice: +price < +_this2.data.noJoinPrice ? '' : _this2.data.noJoinPrice,
        oldNoJoinPrice: +price < +_this2.data.oldNoJoinPrice ? '' : _this2.data.oldNoJoinPrice
      });
      if (price == 0) {
        var timer = setInterval(function () {
          if (!_this2.data.requesting && _this2.data.inputPrice == 0) {
            _this2.resetData();
            clearInterval(timer);
          } else if (!_this2.data.requesting && _this2.data.inputPrice != 0) {
            clearInterval(timer);
          }
        }, 10);
        return;
      }
      if (_this2.data.transferConfig.combine_benefit_enable == 1) {
        _this2.resetCombineEnable();
        _this2.calulateTransferOrderPrice();
      } else {
        _this2.calculateTotalPrice({});
      }
    }, _this2.noJoinPriceInput = function (e) {
      var re = /^\d{1,5}(\.\d{0,2})?$/,
          price = e.target.value.split('¥').length === 2 ? e.target.value.split('¥')[1] : e.target.value;
      price = price.replace(/\s+/g, '');
      if (!re.test(price)) {
        price = '';
      }
      if (!+_this2.data.inputPrice) {
        price = _this2.data.oldNoJoinPrice;
        _app.appMethod.showToast({
          title: '请先输入消费金额',
          icon: 'none',
          duration: 1000
        });
      } else if (+price >= +_this2.data.inputPrice) {
        price = _this2.data.oldNoJoinPrice;
        _app.appMethod.showToast({
          title: '需小于消费金额',
          icon: 'none',
          duration: 1000
        });
      }
      _this2.setData({
        storeState: true,
        selectedBenefit: {},
        combineBenefit: {},
        noJoinPrice: price,
        oldNoJoinPrice: price
      });
      _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice({});
    }, _this2.priceBlur = function (e) {
      var price = e.target.value.split('¥').length === 2 ? e.target.value.split('¥')[1] : e.target.value;
      var type = e.currentTarget.dataset.type;
      var dataSet = {};
      if (typeof +price === 'number') {
        price = (+price).toFixed(2);
      }
      if (type === 'price') {
        dataSet = { inputPrice: price };
      } else if (type === 'no-join-price') {
        dataSet = { noJoinPrice: price };
      }
      _this2.setData(dataSet);
    }, _this2.confirmPay = function () {
      var inputPrice = _this2.data.inputPrice,
          totalPayment = _this2.data.totalPayment,
          selected_store_benefit = {},
          selected_combination_benefit = {},
          benefits = _this2.data.selectedBenefit,
          relatedOrderInfo = _this2.data.relatedOrderInfo;
      var combine_benefit_enable = _this2.data.transferConfig.combine_benefit_enable;

      if (_this2.data.requesting) {
        return;
      }
      _this2.setData({ requesting: true });
      if (isNaN(inputPrice) || (+inputPrice).toFixed(2) <= 0) {
        _app.appMethod.showModal({
          content: '请输入正确的金额'
        });
        _this2.setData({ requesting: false });
        return;
      }
      if (isNaN(totalPayment) || totalPayment < 0) {
        alertTip('error payment amount');
        _this2.setData({ requesting: false });
        return;
      }
      if (_this2.data.storeState && _this2.data.storeBenefitInfo.discount_price) {
        selected_store_benefit = _this2.data.storeBenefitInfo;
      }
      if (_this2.data.inputState !== 2) {
        selected_combination_benefit = _this2.filterCombinationBenefit();
      }
      var params = {
        price: inputPrice,
        least_cost: _this2.data.noJoinPrice,
        check_price: totalPayment,
        message: _this2.data.remark,
        goods_type: 5,
        sub_shop_app_id: _this2.data.franchisee
      };
      if (_this2.data.inputState === 2) {
        params = Object.assign(params, {
          selected_benefit: relatedOrderInfo.selected_benefit_info,
          is_balance: +relatedOrderInfo.use_balance ? 1 : 0
        });
      } else {
        params = Object.assign(params, {
          selected_benefit: combine_benefit_enable == 1 ? '' : benefits,
          selected_store_benefit: combine_benefit_enable == 1 ? '' : selected_store_benefit,
          is_balance: _this2.data.balanceState ? 1 : 0,
          selected_combination_benefit: combine_benefit_enable == 1 ? selected_combination_benefit : ''
        });
      }
      if (_this2.data.relatedData.order_id) {
        params.scan_code_order_id = _this2.data.relatedData.order_id;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/createTransferOrder',
        method: 'post',
        data: params,
        success: function success(res) {
          var orderId = res.data;
          _this2.payOrder(orderId);
        },
        fail: function fail() {
          _this2.setData({ requesting: false });
        }
      });
    }, _this2.filterCombinationBenefit = function () {
      var benefit = _this2.data.combineBenefit,
          combineEnable = _this2.data.combineEnable;
      benefit.use_balance = +_this2.data.useBalancePrice;
      benefit.total_price = +_this2.data.totalPayment;
      benefit.total_discount_price = +_this2.data.totalDiscountPrice;
      if (combineEnable.vip === 0) {
        delete benefit.vip_benefit;
      }
      if (combineEnable.coupon === 0) {
        delete benefit.coupon_benefit;
        delete benefit.selected_user_coupon_id;
      } else if (combineEnable.coupon === 1) {
        var selectedCouponBenefit = {};
        benefit.coupon_benefit.map(function (val) {
          if (val.user_coupon_id == benefit.selected_user_coupon_id) {
            selectedCouponBenefit = val;
          }
        });
        if (selectedCouponBenefit.user_coupon_id) {
          benefit.coupon_benefit = selectedCouponBenefit;
        }
      }
      if (combineEnable.integral === 0) {
        delete benefit.integral_benefit;
      }
      if (!_this2.data.storeState) {
        delete benefit.store_benefit;
      }
      return benefit;
    }, _this2.payOrder = function (orderId) {
      var _this = _this2;
      function paySuccess() {
        var pagePath = '/eCommerce/pages/transferPaySuccess/transferPaySuccess?detail=' + orderId + '?franchisee=' + _this.data.franchisee;
        _this.setData({ requesting: false });
        _app.appMethod.turnToPage(pagePath, 1);
      }
      function payFail() {
        _this.setData({ requesting: false });
        _app.appMethod.turnToPage('/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail=' + orderId, 1);
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: res => {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.goodsType = 5
      //     param.success = paySuccess
      //     param.fail = payFail
      //     app.wxPay(param)
      //   },
      //   fail: function () {
      //     this.setData({ requesting: false })
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: '/transferPaySuccess?detail=' + orderId + '?franchisee=' + _this.data.franchisee,
        failUrl: '/transferOrderDetail?detail=' + orderId,
        cancel: payFail
      });
      _this2.setData({ requesting: false });
    }, _this2.calculateTotalPrice = function () {
      var selectedBenefit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.data.selectedBenefit;

      // 计算唯一优惠
      if (+_this2.data.inputPrice === 0) {
        return;
      }
      _this2.calculateReqNum++;
      var price = +_this2.data.inputPrice,
          calculateReqNum = _this2.calculateReqNum;
      _this2.setData({
        requesting: true
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          price: price,
          selected_benefit: selectedBenefit,
          is_balance: _this2.data.balanceState ? 1 : 0,
          not_use_store_benefit: _this2.data.storeState ? 0 : 1,
          sub_shop_app_id: _this2.data.franchisee,
          least_cost: +_this2.data.noJoinPrice
        },
        success: function success(res) {
          var data = res.data,
              benefits = data.can_use_benefit,
              aloneBenefitState = 0,
              selectedBenefit = {},
              transferConfig = _this2.data.transferConfig,
              memberDiscount = [],
              isShowBalanceItem = false,
              totalDiscountCutPrice = data.total_discount_cut_price | data.discount_cut_price,
              coupon_benefit = benefits.coupon_benefit,
              cant_use_coupon_benefit = benefits.cant_use_coupon_benefit,
              all_vip_benefit = benefits.all_vip_benefit,
              integral_benefit = benefits.integral_benefit;

          if (_this2.calculateReqNum !== calculateReqNum) {
            return;
          }
          _this2.calculateReqNum = 0;
          if (+price === 0) {
            _this2.setData({
              selectedBenefit: {},
              useBalancePrice: '0.00',
              totalPayment: '',
              balanceState: false,
              aloneBenefitState: 0,
              'storeBenefitInfo.discount_price': '0.00'
            });
            return;
          }
          if (transferConfig.coupon_benefit_enable == 1) {
            if (cant_use_coupon_benefit && cant_use_coupon_benefit.length) {
              benefits.cant_use_coupon_benefit = cant_use_coupon_benefit.map(function (val) {
                val.disabled = true;
                return val;
              });
            }
            memberDiscount.push({
              label: 'coupon',
              value: coupon_benefit.concat(benefits.cant_use_coupon_benefit || [])
            });
          }
          if (transferConfig.vip_card_benefit_enable == 1) {
            memberDiscount.push({
              label: 'vip',
              value: all_vip_benefit
            });
          }
          if (transferConfig.integral_benefit_enable == 1) {
            memberDiscount.push({
              label: 'integral',
              value: integral_benefit instanceof Array ? integral_benefit : [integral_benefit]
            });
          }
          if (benefits.data.length) {
            memberDiscount.map(function (val) {
              if (val.value.length > 0) {
                aloneBenefitState = 1;
              }
            });
          }
          if (aloneBenefitState) {
            selectedBenefit = data.selected_benefit_info || {};
            selectedBenefit.discount_cut_price = (+data.selected_benefit_info.discount_cut_price || 0).toFixed(2);
          }
          if (!data.store_benefit_info) {
            data.store_benefit_info = { discount_price: '0.00' };
          }
          data.store_benefit_info.discount_price = (+data.store_benefit_info.discount_price).toFixed(2);
          data.store_benefit_info.discount_price = (+data.store_benefit_info.discount_price).toFixed(2);
          if (price - totalDiscountCutPrice > +data.balance) {
            isShowBalanceItem = true;
          }
          _this2.setData({
            totalPayment: data.price,
            memberDiscount: memberDiscount,
            selectedBenefit: selectedBenefit,
            aloneBenefitState: aloneBenefitState,
            storeBenefitInfo: data.store_benefit_info,
            useBalancePrice: (+data.use_balance).toFixed(2),
            isShowBalanceItem: isShowBalanceItem,
            requesting: false
          });
        },
        fail: function fail() {
          if (_this2.calculateReqNum !== calculateReqNum) {
            return;
          }
          _this2.calculateReqNum = 0;
          _this2.setData({ requesting: false });
        }
      });
    }, _this2.calulateTransferOrderPrice = function () {
      // 计算多种优惠叠加
      if (+_this2.data.inputPrice === 0) {
        return;
      }
      _this2.calculateReqNum++;
      var price = +_this2.data.inputPrice,
          combineEnable = _this2.data.combineEnable,
          calculateReqNum = _this2.calculateReqNum;
      _this2.setData({
        requesting: true
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppTransferOrder/CalulateTransferOrderPrice',
        method: 'post',
        data: {
          price: price,
          no_use_vip_benefit: combineEnable.vip ? 0 : 1,
          no_use_coupon_benefit: combineEnable.coupon ? 0 : 1,
          no_use_integral_benefit: combineEnable.integral ? 0 : 1,
          selected_user_coupon_id: _this2.data.combineBenefit.selected_user_coupon_id || 0,
          selected_user_vip: _this2.data.combineBenefit.selected_user_vip || {},
          no_use_balance: _this2.data.balanceState ? 0 : 1,
          no_use_store_benefit: _this2.data.storeState ? 0 : 1,
          sub_shop_app_id: _this2.data.franchisee,
          least_cost: +_this2.data.noJoinPrice
        },
        success: function success(res) {
          var data = res.data,
              combine_benefit = data.combine_benefit,
              combineState = {
            vip: 0,
            coupon: 0,
            integral: 0
          },
              isShowBalanceItem = false,
              all_vip_benefit = combine_benefit.all_vip_benefit,
              vip_benefit = combine_benefit.vip_benefit,
              coupon_benefit = combine_benefit.coupon_benefit,
              integral_benefit = combine_benefit.integral_benefit,
              cant_use_coupon_benefit = combine_benefit.cant_use_coupon_benefit;

          if (_this2.calculateReqNum !== calculateReqNum) {
            return;
          }
          _this2.calculateReqNum = 0;
          if (all_vip_benefit.length && vip_benefit.discount_price) {
            combineState.vip = 1;
            combine_benefit.vip_benefit_discount_price = '0.00';
            all_vip_benefit.forEach(function (val) {
              if (val.vip_id == combine_benefit.selected_user_vip.id && val.discount_type == combine_benefit.selected_user_vip.type) {
                combine_benefit.vip_benefit_discount_price = combineEnable.vip ? (+val.discount_price).toFixed(2) : '0.00';
              }
            });
          }
          if (coupon_benefit.length) {
            combineState.coupon = 1;
            combine_benefit.coupon_benefit_discount_price = '0.00';
            coupon_benefit.forEach(function (val) {
              if (val.user_coupon_id == combine_benefit.selected_user_coupon_id) {
                combine_benefit.coupon_benefit_discount_price = combineEnable.coupon ? (+val.discount_price).toFixed(2) : '0.00';
              }
            });
          } else {
            combine_benefit.coupon_benefit_discount_price = '0.00';
          }
          if (cant_use_coupon_benefit.length) {
            combine_benefit.cant_use_coupon_benefit = cant_use_coupon_benefit.map(function (val) {
              val.disabled = true;
              return val;
            });
          }
          if (integral_benefit.max_can_use_integral) {
            combineState.integral = 1;
            combine_benefit.integral_benefit.discount_price = combineEnable.integral ? (+integral_benefit.discount_price).toFixed(2) : '0.00';
          }
          if (!combine_benefit.store_benefit) {
            combine_benefit.store_benefit = { discount_price: '0.00' };
          }
          if (price - data.total_discount_price > +_this2.data.userInfo.balance) {
            isShowBalanceItem = true;
          }
          combine_benefit.store_benefit.discount_price = (+combine_benefit.store_benefit.discount_price).toFixed(2);
          _this2.setData({
            totalPayment: data.total_price,
            totalDiscountPrice: data.total_discount_price,
            combineBenefit: combine_benefit,
            storeBenefitInfo: combine_benefit.store_benefit,
            useBalancePrice: (+data.use_balance).toFixed(2),
            combineState: combineState,
            isShowBalanceItem: isShowBalanceItem,
            requesting: false
          });
        },
        fail: function fail() {
          if (_this2.calculateReqNum !== calculateReqNum) {
            return;
          }
          _this2.calculateReqNum = 0;
          _this2.setData({ requesting: false });
        }
      });
    }, _this2.inputRemark = function (e) {
      _this2.setData({
        remark: e.target.value
      });
    }, _this2.updateBalanceState = function (checked) {
      _this2.setData({
        balanceState: checked
      });
      _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice();
    }, _this2.updateStoreState = function (checked) {
      _this2.setData({
        storeState: checked,
        selectedBenefit: {}
      });
      _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice();
    }, _this2.getAppShopByPage = function () {
      var franchiseeId = _this2.data.franchisee;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAppShopByPage',
        data: {
          sub_shop_app_id: franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var newdata = {},
              data = res.data[0];
          newdata['franchiseeInfo'] = data;
          newdata['appTitle'] = data.name;
          _this2.setData(newdata);
        }
      });
    }, _this2.afterSelectedBenefit = function (options) {
      var selectedDiscount = options.selectedDiscount,
          combineEnable = _this2.data.combineEnable,
          combineBenefit = _this2.data.combineBenefit;
      if (selectedDiscount.type === 'combine') {
        // 自定义优惠
        if (selectedDiscount.discount_type === 'coupon') {
          if (selectedDiscount.no_use_benefit) {
            combineBenefit.selected_user_coupon_id = 0;
            combineEnable.coupon = 0;
          } else {
            combineBenefit.selected_user_coupon_id = selectedDiscount.coupon_id;
            combineEnable.coupon = 1;
          }
        } else if (selectedDiscount.discount_type === 'vip' || selectedDiscount.discount_type === 'paid_vip' || selectedDiscount.discount_type === 'vip_benefit_day') {
          if (selectedDiscount.no_use_benefit) {
            combineBenefit.selected_user_vip = {};
            combineEnable.vip = 0;
          } else {
            combineBenefit.selected_user_vip = {
              id: selectedDiscount.vip_id,
              type: selectedDiscount.discount_type
            };
            combineEnable.vip = 1;
          }
        } else if (selectedDiscount.discount_type === 'integral') {
          combineEnable.integral = selectedDiscount.no_use_benefit ? 0 : 1;
        }
        _this2.setData({
          combineEnable: combineEnable,
          combineBenefit: combineBenefit
        });
      } else {
        // 唯一会员优惠
        _this2.setData({
          selectedBenefit: selectedDiscount
        });
      }
      _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice();
    }, _this2.getStoreBenefitActivityList = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppStoreBenefit/GetStoreBenefitActivityList',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.data.franchisee
        },
        hideLoading: true,
        success: function success(res) {
          var data = [];
          res.data.map(function (val) {
            val.activity_start_date = val.activity_start_date.substr(0, 16);
            val.activity_end_date = val.activity_end_date.substr(0, 16);
            if (val.expired !== 1) {
              data.push(val);
            }
          });
          _this2.setData({
            storeBenefitActivityList: data
          });
        }
      });
    }, _this2.getBalanceData = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppUserBalance',
        hideLoading: true,
        success: function success(res) {
          _this2.setData({
            'userInfo.balance': (+res.data.balance).toFixed(2)
          });
        }
      });
    }, _this2.scanPaymentCode = function () {
      _app.appMethod.scanCode({
        onlyFromCamera: false,
        success: function success(res) {
          var path = res.path;

          var sceneValue = _this2.getQueryString(path, 'scene');
          _this2.getSceneData(sceneValue);
        }
      });
    }, _this2.getBalanceInfo = function () {
      var param = {
        ver: '2.2' //版本
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getStoredItems',
        data: param,
        hideLoading: true,
        success: function success(res) {
          var status = res.status,
              data = res.data;

          if (status === 0) {
            data = data.map(function (item) {
              var discounts = [];
              item.g_price = Number(item.g_price);
              item.g_integral = Number(item.g_integral);
              if (item.g_price) {
                discounts.push(item.g_price + '元');
              }
              if (item.g_integral) {
                discounts.push(item.g_integral + '积分');
              }
              if (item.g_vip_card && item.g_vip_card.title) {
                discounts.push(item.g_vip_card.title);
              }
              if (item.g_coupon_list && item.g_coupon_list.length) {
                item.g_coupon_list.forEach(function (coupon) {
                  discounts.push(coupon.num + '张' + coupon.title);
                });
              }
              if (discounts.length) {
                discounts[0] = '赠送' + discounts[0];
              }
              item.discounts = discounts.join('、');
              return item;
            });
            _this2.setData({
              balanceItemInfo: data
            });
          }
        }
      });
    }, _this2.gotoRecharge = function (e) {
      var index = e.target.dataset.index; // 储值的索引
      var balanceItem = _this2.data.balanceItemInfo[index];
      var param = {
        type: '1',
        stored_id: balanceItem.id,
        form_id: e.target.formId
      };
      _app.appMethod.showModal({
        title: '\u5373\u5C06\u5145\u503C' + balanceItem.price + '\u5143\u50A8\u503C',
        success: function success(res) {
          if (res.confirm) {
            _app.appMethod.sendRequest({
              url: '/index.php?r=AppShop/creatStoredItemOrder',
              data: param,
              hideLoading: true,
              success: function success(res) {
                _this2.balancePay(res.data);
              }
            });
          }
        }
      });
    }, _this2.balancePay = function (orderId) {
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   hideLoading: true,
      //   success: res => {
      //     let { data } = res
      //     data = Object.assign(data, {
      //       orderId,
      //       success: () => {
      //         app.showToast({
      //           title: '充值成功'
      //         })
      //       }
      //     })
      //     app.wxPay(data)
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId
      });
    }, _this2.getSceneData = function (scene) {
      var options = { scene: scene, sub_shop_app_id: _this2.data.franchisee };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransferOrder/GetSceneData',
        data: options,
        hideLoading: true,
        success: function success(res) {
          var status = res.status,
              data = res.data;

          if (status === 0 && data.order_id) {
            var original_price = data.original_price,
                total_price = data.total_price,
                not_discount_price = data.not_discount_price,
                related_order_id = data.related_order_id;

            if (!data.selected_benefit_info) {
              data.selected_benefit_info = {};
            }
            data.selected_benefit_info.discount_price = (+data.selected_benefit_info.discount_price || 0).toFixed(2);
            data.use_balance = (+data.use_balance || 0).toFixed(2);
            data.coupon_fee = (+data.coupon_fee || 0).toFixed(2);
            _this2.setData({
              relatedData: data,
              inputPrice: (+original_price || 0).toFixed(2),
              noJoinPrice: (+not_discount_price || 0).toFixed(2),
              isShowNoJoinPrice: !!+not_discount_price,
              relatedOrderInfo: data,
              inputState: related_order_id ? 2 : 1
            });
            if (!related_order_id) {
              _this2.data.transferConfig.combine_benefit_enable == 1 ? _this2.calulateTransferOrderPrice() : _this2.calculateTotalPrice();
            } else {
              _this2.setData({
                totalPayment: (+total_price || 0).toFixed(2)
              });
            }
          }
        }
      });
    }, _this2.getQueryString = function (path, name) {
      if (!path) {
        return '';
      }
      var paramsStr = path.split('?')[1] || '';
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = paramsStr.match(reg);
      if (r != null) return unescape(r[2]);
      return '';
    }, _this2.config = {
      navigationBarTitleText: '当面付',
      navigationBarTextStyle: 'black',
      navigationStyle: 'custom'
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(TransferPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchisee = options.franchisee || '';
      var scene = options.scene;
      var appTitle = franchisee ? '' : _app.appMethod.getAppTitle();
      this.setData({
        appTitle: appTitle,
        franchisee: franchisee,
        userInfo: _app.appMethod.getUserInfo(),
        franchiseeIdInfo: {
          id: franchisee
        }
      });
      if (franchisee) {
        this.getAppShopByPage();
      }
      this.getBalanceData();
      this.getTransferOrderConfig(function () {
        if (scene) {
          _this3.getSceneData(scene);
        }
      });
      this.getCurrentStoreBenefitInfo();
      this.getStoreBenefitActivityList();
      this.getBalanceInfo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          franchiseeIdInfo = _state.franchiseeIdInfo,
          memberDiscount = _state.memberDiscount,
          franchisee = _state.franchisee,
          transferConfig = _state.transferConfig,
          appTitle = _state.appTitle,
          storeBenefitActivityList = _state.storeBenefitActivityList,
          inputPrice = _state.inputPrice,
          inputState = _state.inputState,
          isShowPriceLimitTip = _state.isShowPriceLimitTip,
          noJoinPrice = _state.noJoinPrice,
          currentStoreBenefitInfo = _state.currentStoreBenefitInfo,
          storeState = _state.storeState,
          storeBenefitInfo = _state.storeBenefitInfo,
          vipCardInfo = _state.vipCardInfo,
          aloneBenefitState = _state.aloneBenefitState,
          selectedBenefit = _state.selectedBenefit,
          combineState = _state.combineState,
          combineBenefit = _state.combineBenefit,
          userInfo = _state.userInfo,
          balanceState = _state.balanceState,
          useBalancePrice = _state.useBalancePrice,
          relatedOrderInfo = _state.relatedOrderInfo,
          benefitType = _state.benefitType,
          balanceItemInfo = _state.balanceItemInfo,
          isShowBalanceItem = _state.isShowBalanceItem,
          remark = _state.remark,
          totalPayment = _state.totalPayment,
          requesting = _state.requesting;

      return _react2.default.createElement(
        'div',
        { className: 'official-page transfer-page' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u5F53\u9762\u4ED8' }),
        _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'transfer-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'transfer-header' },
              _react2.default.createElement(
                'div',
                { className: 'transfer-name' },
                '\u4ED8\u6B3E\u7ED9',
                _react2.default.createElement(
                  'span',
                  { className: 'account' },
                  appTitle
                )
              ),
              !!storeBenefitActivityList.length && _react2.default.createElement(
                'div',
                {
                  className: 'coupon-desc',
                  onClick: this.goToCouponDesc,
                  style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                },
                '\u4F18\u60E0\u8BF4\u660E'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'transfer-input consumption-block' },
              _react2.default.createElement(
                'div',
                { className: 'space-between' },
                _react2.default.createElement(
                  'div',
                  { className: 'input-text' },
                  '\u6D88\u8D39\u91D1\u989D'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'input-price-block' },
                  _react2.default.createElement('input', {
                    value: inputPrice !== '' ? '¥' + inputPrice : '',
                    className: 'input-price ' + (transferConfig.scan_mode == 1 ? 'm-r-40' : ''),
                    placeholder: transferConfig.input_mode === '0' ? '' : '请输入金额',
                    onChange: this.inputPrice,
                    onBlur: this.priceBlur,
                    disabled: inputState === 1 || inputState === 2 || transferConfig.input_mode === '0',
                    'data-type': 'price'
                  }),
                  transferConfig.scan_mode == 1 && _react2.default.createElement('span', {
                    className: 'ico-moon icon-shopping-scan',
                    onClick: this.scanPaymentCode
                  })
                )
              ),
              isShowPriceLimitTip && _react2.default.createElement(
                'div',
                { className: 'price-limit' },
                '\u4EF7\u683C\u533A\u95F4\u4EC5\u652F\u63010.01~99999.99\u5143'
              )
            ),
            transferConfig.scan_mode == 1 && _react2.default.createElement(
              'div',
              { className: 'scan-tip-block' },
              _react2.default.createElement(
                'span',
                { className: 'scan-tip' },
                '\u626B\u7801\u53EF\u5FEB\u901F\u586B\u5145'
              )
            ),
            transferConfig.least_cost == 1 && inputState !== 2 && _react2.default.createElement(
              'div',
              { className: 'transfer-input no-join-block' },
              _react2.default.createElement(
                'div',
                { className: 'input-text' },
                '\u4E0D\u53C2\u4E0E\u91D1\u989D'
              ),
              _react2.default.createElement(
                'div',
                { className: 'input-price-block' },
                _react2.default.createElement('input', {
                  value: noJoinPrice !== '' ? '¥' + noJoinPrice : '',
                  className: 'input-price',
                  style: (0, _tools.convertLineStyleData)('font-size: 32rpx'),
                  placeholder: transferConfig.input_mode === '0' ? '' : '请输入金额',
                  onChange: this.noJoinPriceInput,
                  onBlur: this.priceBlur,
                  disabled: inputState === 1 || inputState === 2 || transferConfig.input_mode === '0',
                  'data-type': 'no-join-price'
                })
              )
            ),
            inputState !== 2 && _react2.default.createElement(
              'div',
              { className: 'discount-block' },
              currentStoreBenefitInfo.activity_title && _react2.default.createElement(
                'div',
                { className: 'item space-between store-discount' },
                _react2.default.createElement(
                  'span',
                  { className: 'store-title' },
                  '\u5E97\u94FA\u6EE1\u51CF'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'discount-text', hidden: inputPrice },
                    currentStoreBenefitInfo.rule_titles.map(function (item, index) {
                      return _react2.default.createElement(
                        'span',
                        { key: index },
                        index === 0 ? item : ', ' + item
                      );
                    })
                  ),
                  inputPrice && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(_switch2.default, {
                      checked: storeState,
                      onChange: this.updateStoreState
                    }),
                    storeBenefitInfo.discount_price && storeBenefitInfo.discount_price != 0 && storeState && _react2.default.createElement(
                      'div',
                      {
                        className: 'discount-price',
                        style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                      },
                      '-¥' + storeBenefitInfo.discount_price
                    ),
                    storeBenefitInfo.discount_price == 0 && storeState && _react2.default.createElement(
                      'div',
                      { className: 'store-tip' },
                      '\u4E0D\u6EE1\u8DB3\u6EE1\u51CF\u6761\u4EF6'
                    )
                  )
                )
              ),
              vipCardInfo.isShow && _react2.default.createElement(
                'div',
                { className: 'item vip-card-block' },
                _react2.default.createElement(
                  'div',
                  { className: 'vip-card' },
                  _react2.default.createElement('img', { className: 'card-img', src: vipCardInfo.logo }),
                  _react2.default.createElement(
                    'div',
                    { className: 'card-info' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-name' },
                      vipCardInfo.app_name + ' ' + vipCardInfo.title
                    ),
                    vipCardInfo.discount != 0 ? _react2.default.createElement(
                      'div',
                      { className: 'card-mess' },
                      '免费开卡享 ' + vipCardInfo.discount + '折'
                    ) : vipCardInfo.coupon_list && vipCardInfo.coupon_list != '' ? _react2.default.createElement(
                      'div',
                      { className: 'card-mess' },
                      '\u514D\u8D39\u5F00\u5361\u4EAB \u8D60\u9001\u4F18\u60E0\u5238'
                    ) : vipCardInfo.integral != 0 && _react2.default.createElement(
                      'div',
                      { className: 'card-mess' },
                      '免费开卡享 赠送' + vipCardInfo.integral + '积分'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'card-btn', onClick: this.handleVipCard },
                    '\u7ACB\u5373\u5F00\u5361'
                  )
                )
              ),
              !!+aloneBenefitState && _react2.default.createElement(
                'div',
                {
                  className: 'item space-between member-discount',
                  onClick: this.showMemberDiscount
                },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u4F1A\u5458\u4F18\u60E0'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  selectedBenefit.discount_cut_price && selectedBenefit.discount_cut_price !== '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + selectedBenefit.discount_cut_price
                  ),
                  selectedBenefit.discount_cut_price && selectedBenefit.discount_cut_price === '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '\u672A\u4F7F\u7528'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              !!+combineState.vip && transferConfig.vip_card_benefit_enable == 1 && _react2.default.createElement(
                'div',
                {
                  className: 'item member-discount',
                  'data-type': 'vip',
                  onClick: this.showMemberDiscount
                },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u4F1A\u5458\u5361\u4F18\u60E0'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  combineBenefit.vip_benefit && combineBenefit.vip_benefit_discount_price !== '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + combineBenefit.vip_benefit_discount_price
                  ),
                  combineBenefit.vip_benefit && combineBenefit.vip_benefit_discount_price === '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '\u672A\u4F7F\u7528'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              transferConfig.combine_benefit_enable == 1 && inputPrice && transferConfig.coupon_benefit_enable == 1 && _react2.default.createElement(
                'div',
                {
                  className: 'item member-discount',
                  'data-type': 'coupon',
                  onClick: this.showMemberDiscount
                },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u4F18\u60E0\u5238\u51CF\u514D'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  combineState.coupon === 1 && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    combineBenefit.coupon_benefit_discount_price && combineBenefit.coupon_benefit_discount_price !== '0.00' && _react2.default.createElement(
                      'div',
                      {
                        className: 'price',
                        style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                      },
                      '-¥' + combineBenefit.coupon_benefit_discount_price
                    ),
                    combineBenefit.coupon_benefit_discount_price && combineBenefit.coupon_benefit_discount_price === '0.00' && _react2.default.createElement(
                      'div',
                      {
                        className: 'price',
                        style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                      },
                      '\u672A\u4F7F\u7528'
                    )
                  ),
                  combineState.coupon === 0 && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      {
                        className: 'price',
                        style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                      },
                      '\u65E0\u53EF\u7528\u4F18\u60E0\u5238'
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              !!+combineState.integral && transferConfig.integral_benefit_enable == 1 && _react2.default.createElement(
                'div',
                {
                  className: 'item member-discount',
                  'data-type': 'integral',
                  onClick: this.showMemberDiscount
                },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u79EF\u5206\u62B5\u6263'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  combineBenefit.integral_benefit && combineBenefit.integral_benefit.discount_price !== '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + combineBenefit.integral_benefit.discount_price
                  ),
                  combineBenefit.integral_benefit && combineBenefit.integral_benefit.discount_price === '0.00' && _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '\u672A\u4F7F\u7528'
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              transferConfig.use_balance_enable !== '0' && franchisee === '' && userInfo.balance && userInfo.balance != 0 && _react2.default.createElement(
                'div',
                { className: 'item space-between stored-value-discount' },
                _react2.default.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '储值抵扣（余额：￥' + userInfo.balance + '）'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'stored-value-block' },
                  _react2.default.createElement(_switch2.default, {
                    onChange: this.updateBalanceState,
                    checked: balanceState
                  }),
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'stored-value-price',
                      hidden: !balanceState || useBalancePrice == 0,
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + useBalancePrice
                  )
                )
              )
            ),
            inputState === 2 && _react2.default.createElement(
              'div',
              { className: 'discount-block' },
              relatedOrderInfo.selected_benefit_info.discount_type && _react2.default.createElement(
                'div',
                { className: 'item member-discount' },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  benefitType[relatedOrderInfo.selected_benefit_info.discount_type] + '优惠'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + relatedOrderInfo.selected_benefit_info.discount_price
                  )
                )
              ),
              relatedOrderInfo.use_balance !== '0.00' && _react2.default.createElement(
                'div',
                { className: 'item member-discount' },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u50A8\u503C\u62B5\u6263'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + relatedOrderInfo.use_balance
                  )
                )
              ),
              relatedOrderInfo.coupon_fee !== '0.00' && _react2.default.createElement(
                'div',
                { className: 'item member-discount' },
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 28rpx') },
                  '\u793E\u4EA4\u7ACB\u51CF\u91D1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'member-discount-detail' },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'price',
                      style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                    },
                    '-¥' + relatedOrderInfo.coupon_fee
                  )
                )
              )
            ),
            isShowBalanceItem && balanceItemInfo.length && transferConfig.use_balance_enable !== '0' && inputState !== 2 && franchisee === '' && _react2.default.createElement(
              'div',
              { className: 'balance-block' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u50A8\u503C\u4F18\u60E0'
              ),
              balanceItemInfo.length === 1 && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'detail' },
                  balanceItemInfo.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        className: 'balance-item-first',
                        key: index,
                        style: (0, _tools.convertLineStyleData)('border-color: ' + transferConfig.background_color)
                      },
                      _react2.default.createElement(
                        'div',
                        {
                          className: 'price',
                          style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                        },
                        '￥' + item.price
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'discount-wrapper' },
                        _react2.default.createElement(
                          'div',
                          { className: 'discount-item' },
                          item.discounts
                        )
                      ),
                      _react2.default.createElement(
                        'form',
                        { className: 'balance-form' },
                        _react2.default.createElement(
                          'button',
                          {
                            className: 'pay-btn',
                            type: 'button',
                            'data-index': index,
                            onClick: _this4.gotoRecharge,
                            style: (0, _tools.convertLineStyleData)('background-color: ' + transferConfig.background_color)
                          },
                          '\u7ACB\u5373\u5145\u503C'
                        )
                      )
                    );
                  })
                )
              ),
              balanceItemInfo.length > 1 && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  _ScrollView.ScrollView,
                  { 'scroll-x': 'true', className: 'balance-scroll' },
                  balanceItemInfo.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        className: 'balance-item-second',
                        key: index,
                        style: (0, _tools.convertLineStyleData)('border-color: ' + transferConfig.background_color + '; width: ' + (balanceItemInfo.length === 2 ? '258rpx' : '216rpx'))
                      },
                      _react2.default.createElement(
                        'div',
                        { className: 'price-block' },
                        _react2.default.createElement(
                          'div',
                          {
                            className: 'price',
                            style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color)
                          },
                          '￥' + item.price
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'discount-wrapper' },
                          _react2.default.createElement(
                            'div',
                            { className: 'discount-item' },
                            item.discounts
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'form',
                        { className: 'balance-form' },
                        _react2.default.createElement(
                          'button',
                          {
                            className: 'pay-btn',
                            type: 'button',
                            'data-index': index,
                            onClick: _this4.gotoRecharge,
                            style: (0, _tools.convertLineStyleData)('color: ' + transferConfig.background_color + ';')
                          },
                          '\u7ACB\u5373\u5145\u503C'
                        )
                      )
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'transfer-input remark' },
              _react2.default.createElement(
                'div',
                { className: 'input-text' },
                '\u5907\u6CE8'
              ),
              _react2.default.createElement('input', {
                style: (0, _tools.convertLineStyleData)('font-size: 28rpx; text-overflow: ellipsis;'),
                maxLength: '30',
                placeholder: '\u8BF7\u586B\u5199\u5907\u6CE8\u4FE1\u606F',
                onChange: this.inputRemark
              })
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'submit-btn',
                disabled: totalPayment === '' || requesting,
                onClick: this.confirmPay,
                style: (0, _tools.convertLineStyleData)('background: ' + transferConfig.background_color)
              },
              (totalPayment === '' ? '' : totalPayment + '元  ') + '确认支付'
            )
          )
        ),
        _react2.default.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return TransferPage;
}(_OfficialPage3.default);

exports.default = TransferPage;

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(502);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponDescription = function (_OfficialPage) {
  (0, _inherits3.default)(CouponDescription, _OfficialPage);

  function CouponDescription(props) {
    (0, _classCallCheck3.default)(this, CouponDescription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponDescription.__proto__ || Object.getPrototypeOf(CouponDescription)).call(this, props));

    _this.state = {
      artivityList: [],
      franchisee: '',
      statusOptions: {
        '-1': { label: '未开始' },
        '0': { label: '进行中', className: 'active' },
        '1': { label: '已结束' },
        '2': { label: '即将开始', className: 'begin' }
      }
    };

    _this.getStoreBenefitActivityList = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppStoreBenefit/GetStoreBenefitActivityList',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchisee
        },
        success: function success(res) {
          var status = res.status,
              data = res.data;

          if (status === 0) {
            var activitys = [];
            data.forEach(function (val) {
              var activity_start_date = val.activity_start_date,
                  activity_end_date = val.activity_end_date,
                  expired = val.expired,
                  rule_titles = val.rule_titles,
                  periods = val.periods;

              val.activity_start_date = activity_start_date.substr(0, 10);
              val.activity_end_date = activity_end_date.substr(0, 10);
              if (val.activity_rules && val.activity_rules.length > 0) {
                var _val$activity_rules = val.activity_rules[val.activity_rules.length - 1],
                    discount_price = _val$activity_rules.discount_price,
                    discount_limit = _val$activity_rules.discount_limit;

                if (discount_limit == -1) {
                  val.max_discount_price = discount_price;
                } else {
                  val.max_discount_price = discount_price * discount_limit % 1 === 0 ? discount_price * discount_limit : (discount_price * discount_limit).toFixed(2);
                }
              }
              if (activity_end_date.indexOf('9999') !== -1) {
                val.activity_end_date = '长期';
              }
              if (!Object.keys(_this.data.statusOptions).includes('' + expired)) {
                // 订单不在statusOptions中，默认为已结束
                val.expired = 1;
              }
              if (rule_titles.length) {
                val.rule_titles = rule_titles.map(function (ruleItem) {
                  // ruleItem = ruleItem.replace(/<br>/g, '\n')
                  return ruleItem;
                });
              }
              if (periods.length) {
                val.periodsText = periods.join(';');
              }
              if (expired != 1) {
                activitys.push(val);
              }
            });
            var activity0 = activitys.filter(function (v) {
              return v.expired == 0;
            });
            var activity2 = activitys.filter(function (v) {
              return v.expired == 2;
            });
            var activity1 = activitys.filter(function (v) {
              return v.expired == -1;
            });
            var newActivitys = activity0.concat(activity2, activity1);
            _this.setData({
              artivityList: newActivitys
            });
          }
        }
      });
    };

    document.title = '优惠券';
    return _this;
  }

  (0, _createClass3.default)(CouponDescription, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchisee = options.franchisee || '';
      this.setData({
        franchisee: franchisee
      });
      this.getStoreBenefitActivityList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          artivityList = _state.artivityList,
          statusOptions = _state.statusOptions;


      return React.createElement(
        'div',
        { className: 'official-page coupon-description' },
        React.createElement(_TopNav.TopNav, { title: '\u4F18\u60E0\u5238' }),
        React.createElement(
          'div',
          { className: 'coupon-desc' },
          React.createElement(
            'div',
            {
              className: 'top-block',
              style: (0, _tools.convertLineStyleData)('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/coupon-desc-head.png)')
            },
            React.createElement(
              'div',
              { className: 'tip' },
              '\u4E70\u5355\u4EAB\u4F18\u60E0'
            ),
            React.createElement(
              'div',
              { className: 'tip' },
              '\u8D76\u5FEB\u53C2\u4E0E\u5427'
            )
          ),
          React.createElement(
            'div',
            { className: 'coupon-wrappr' },
            artivityList.map(function (item, index) {
              return React.createElement(
                'div',
                { className: 'coupon-item', key: index },
                React.createElement(
                  'div',
                  { className: 'title' },
                  React.createElement(
                    'div',
                    {
                      className: 'status ' + (statusOptions[item.expired].className || '')
                    },
                    statusOptions[item.expired].label || ''
                  ),
                  item.activity_title
                ),
                React.createElement(
                  'div',
                  { className: 'detail coupon-detail' },
                  React.createElement(
                    'div',
                    { className: 'left' },
                    '\u4F18\u60E0\u89C4\u5219\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'right' },
                    item.rule_titles.map(function (rule, ruleIndex) {
                      return React.createElement('span', { className: 'detail-item rich-text', key: ruleIndex, dangerouslySetInnerHTML: { __html: rule && rule.replace(/href=".*?"/g, '') } });
                    })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail' },
                  React.createElement(
                    'div',
                    { className: 'left' },
                    '\u4F7F\u7528\u65F6\u95F4\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'right' },
                    React.createElement(
                      'span',
                      null,
                      item.periodsText
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail' },
                  '活动日期：' + item.activity_start_date + ' 至 ' + item.activity_end_date
                )
              );
            })
          )
        )
      );
    }
  }]);
  return CouponDescription;
}(_OfficialPage3.default);

exports.default = CouponDescription;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _datePicker = __webpack_require__(101);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(102);

__webpack_require__(47);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(504);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hotel = {
  dateFilter: function dateFilter(dateStr) {
    var currentTime = getDate().getHours(),
        newDateStr = dateStr;
    if (currentTime < 6) {
      var newDate = getDate(getDate(newDateStr).getTime() - 86400000),
          year = newDate.getFullYear(),
          month = newDate.getMonth() + 1 >= 10 ? newDate.getMonth() + 1 : '0' + (newDate.getMonth() + 1),
          date = newDate.getDate() >= 10 ? newDate.getDate() : '0' + newDate.getDate();
      newDateStr = year + '-' + month + '-' + date;
    }
    return newDateStr;
  }
};

var MakeAppointment = function (_OfficialPage) {
  (0, _inherits3.default)(MakeAppointment, _OfficialPage);

  function MakeAppointment(props) {
    (0, _classCallCheck3.default)(this, MakeAppointment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MakeAppointment.__proto__ || Object.getPrototypeOf(MakeAppointment)).call(this, props));

    _this.state = {
      appointmentInfo: {},
      goodsId: '',
      longRangeIndex: 0,
      periodRangeIndex: 0,
      selectedDate: '',
      selectedDateIfBusiness: 0,
      selectedPeriod: '',
      serviceTimeUnit: '',
      unitType: '',
      date: '',
      time: '12:00',
      color: '',
      isHotelService: true
    };

    _this.dataInitialName = function () {
      var unitType = _this.data.unitType,
          isHotelService = _this.data.isHotelService,
          serviceTimeUnit,
          servicePrice,
          unitTime;
      if (unitType != 6) {
        switch (unitType) {
          case '1':
            unitTime = '请先选择预约日期';
            servicePrice = '请先选择预约日期';
            break;
          case '2':
            unitTime = '请先选择预约日期';
            servicePrice = '请先选择预约日期';
            break;
          case '3':
            unitTime = '请先选择起始日期';
            servicePrice = '请先选择起始日期';
            break;
        }
        isHotelService = false;
      } else {
        unitTime = '请先选择起始日期';
        servicePrice = '请先选择起始日期';
        isHotelService = true;
      }
      _this.setData({
        'appointmentInfo.serviceLongRange[0]': unitTime,
        'appointmentInfo.servicePrice': servicePrice,
        isHotelService: isHotelService
      });
    };

    _this.dataInitial = function () {
      _this.getAppointmentList({
        app_id: _app.appMethod.getAppId(),
        data_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId,
        ck_id: eaa3f988dc6905c67674e708d0752fc2
      }, true);
    };

    _this.getAppointmentList = function (param, initial) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppAppointment/getAppointmentList',
        data: param,
        success: function success(res) {
          var data = {},
              response,
              selectedDay,
              selectedEndDay,
              selectedStartDay,
              serviceTimeUnit,
              response = res.data,
              canSelectTimeLong,
              appointmentInfo = response.appointment_info;
          data['color'] = '#F05B10';
          if (initial) {
            switch (res.unit_type) {
              case '1':
                serviceTimeUnit = '分';
                break;
              case '2':
                serviceTimeUnit = '小时';
                break;
              case '3':
                serviceTimeUnit = '天';
                break;
              case '6':
                serviceTimeUnit = '天';
                break;
            }
            if (serviceTimeUnit == '天') {
              selectedStartDay = response.selected_start_day.substring(0, 4) + '-' + response.selected_start_day.substring(4, 6) + '-' + response.selected_start_day.substring(6, 8);
              selectedEndDay = response.selected_end_day.substring(0, 4) + '-' + response.selected_end_day.substring(4, 6) + '-' + response.selected_end_day.substring(6, 8);
              data['appointmentInfo.appointmentStartDateRange'] = selectedStartDay;
              data['appointmentInfo.appointmentEndDateRange'] = selectedEndDay;
            } else {
              var sortArr = function sortArr(a, b) {
                return a - b;
              };

              selectedDay = response.selected_day.substring(0, 4) + '-' + response.selected_day.substring(4, 6) + '-' + response.selected_day.substring(6, 8);

              canSelectTimeLong = response.can_select_time_long.sort(sortArr);
              data['appointmentInfo.serviceLongRange'] = canSelectTimeLong;
              for (var index in response.can_select_interval) {
                var can_select_interval = response.can_select_interval[index].split('-');
                if (response.can_select_interval[index].substring(6, 8) >= 24) {
                  var endHours = can_select_interval[1].split(':')[0] - 24 >= 10 ? can_select_interval[1].split(':')[0] - 24 : '0' + (can_select_interval[1].split(':')[0] - 24);
                  response.can_select_interval[index] = can_select_interval[0] + '-' + '次日' + endHours + ':' + can_select_interval[1].split(':')[1];
                } else {
                  response.can_select_interval[index] = can_select_interval[0] + '-' + '当日' + can_select_interval[1];
                }
              }
              data['appointmentInfo.servicePeriodRange'] = response.can_select_interval;
              data['appointmentInfo.appointmentDateRange'] = selectedDay;
            }
            data['selectedDate'] = 1;
            data['selectedDateIfBusiness'] = 1;
            data['serviceTimeUnit'] = serviceTimeUnit;
          }
          for (var index in appointmentInfo) {
            var periodInterval = appointmentInfo[index].interval,
                startHours = periodInterval.split('-')[0].split(':')[0],
                startMin = periodInterval.split('-')[0].split(':')[1],
                endHours = periodInterval.split('-')[1].split(':')[0],
                endMin = periodInterval.split('-')[1].split(':')[1],
                startTime = startHours >= 24 ? '次日' + (startHours * 1 - 24) + ':' + startMin : '当日' + startHours * 1 + ':' + startMin,
                endTime = endHours >= 24 ? '次日' + (endHours * 1 - 24) + ':' + endMin : '当日' + endHours * 1 + ':' + endMin;
            appointmentInfo[index].interval = startTime + '-' + endTime;
          }
          data['appointmentInfo.servicePeriodList'] = appointmentInfo || '';
          data['appointmentInfo.servicePrice'] = response.appointment_price != '0' ? response.appointment_price + '元' : '免费';
          that.setData(data);
        },
        fail: function fail(res) {
          console.log(res);
        }
      });
    };

    _this.serviceLongChange = function (e) {
      var value = _this.state.appointmentInfo.serviceLongRange.indexOf(e[0]);
      _this.setData({
        longRangeIndex: value
      });
      _this.serviceConditionChange();
    };

    _this.setTime = function (appointmentTime, timeNum) {
      var appointmentTimeStr, hours, sec, totalSec, totalTime;
      appointmentTimeStr = appointmentTime.split(':');
      hours = appointmentTimeStr[0].replace(/[^0-9]/gi, '');
      sec = appointmentTimeStr[1].replace(/[^0-9]/gi, '');
      totalSec = sec * 1 + timeNum * 1;
      sec = totalSec > 59 ? totalSec - Math.floor(totalSec / 60) * 60 : totalSec;
      sec = sec > 9 ? sec : '0' + sec;
      hours = totalSec > 59 ? Math.floor(totalSec / 60) + hours * 1 : hours;
      totalTime = hours + ':' + sec;
      return totalTime;
    };

    _this.bindDateAppointmentChange = function (date) {
      var date = (0, _util.formatTimeYMD)(date, 'YYYY-MM-DD'),
          servicePeriodRange = _this.data.appointmentInfo.servicePeriodRange[_this.data.periodRangeIndex],
          interval,
          startTime,
          timeLong;
      _this.setData({
        'appointmentInfo.appointmentDay': date
      });
      if (_this.data.appointmentInfo.servicePrice != '?') {
        var str = servicePeriodRange.split('-');
        if (_this.data.unitType == 2 && _this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期') {
          interval = str[1].substring(0, 2) == '当日' ? str[0] + '-' + str[1].substring(2) : str[0] + '-' + (parseInt(str[1].substring(2, 4)) + 24) + str[1].substring(4);
        } else if (_this.data.unitType == 1 && _this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期') {
          startTime = _this.data.time;
        }
        if (_this.data.appointmentInfo.serviceLongRange[0] != '请先选择预约日期') {
          timeLong = _this.data.appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
        }
      }
      _this.getAppointmentList({
        day: _this.data.appointmentInfo.appointmentDay.split('-').join(''),
        app_id: _app.appMethod.getAppId(),
        data_id: _this.data.goodsId,
        interval: interval ? interval : '',
        start_time: startTime ? startTime : '',
        time_long: timeLong ? timeLong : '',
        sub_shop_app_id: _this.data.franchiseeId
      }, true);
    };

    _this.bindStartDateChange = function (e) {
      var value = (0, _util.formatTimeYMD)(e, 'YYYY-MM-DD'),
          endValueStamp = _this.data.isHotelService ? new Date(value).getTime() + 86400000 : new Date(value).getTime(),
          endValue = _this.timestampToTime(endValueStamp);
      _this.setData({
        'appointmentInfo.appointmentStartDateRange': value,
        'appointmentInfo.appointmentEndDateRange': endValue
      });
      _this.getAppointmentList({
        start_date: value.split('-').join(''),
        end_date: _this.data.appointmentInfo.appointmentEndDateRange.split('-').join(''),
        app_id: _app.appMethod.getAppId(),
        data_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId
      }, true);
    };

    _this.bindEndDateChange = function (e) {
      var value = (0, _util.formatTimeYMD)(e, 'YYYY-MM-DD'),
          endValueStamp = new Date(value).getTime(),
          startValueStamp = new Date(_this.data.appointmentInfo.appointmentStartDateRange).getTime();
      if (endValueStamp < startValueStamp || endValueStamp <= startValueStamp && _this.data.isHotelService) {
        _app.appMethod.showModal({
          content: '结束日期有误，请重新选择'
        });
        return false;
      }
      _this.setData({
        'appointmentInfo.appointmentEndDateRange': value
      });
      _this.getAppointmentList({
        start_date: _this.data.appointmentInfo.appointmentStartDateRange ? _this.data.appointmentInfo.appointmentStartDateRange.split('-').join('') : _this.data.appointmentInfo.appointmentDay.split('-').join(''),
        end_date: value.split('-').join(''),
        app_id: _app.appMethod.getAppId(),
        data_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId
      }, true);
    };

    _this.bindTimeChange = function (e, unit) {
      var value = (0, _util.formatTimeYMD)(e, 'hh:mm');
      _this.setData({
        time: value
      });
      if (unit == 6) {
        return false;
      }
      _this.serviceConditionChange();
    };

    _this.servicePeriodSelectChange = function (e) {
      var value = _this.state.appointmentInfo.servicePeriodRange.indexOf(e[0]);
      _this.setData({
        periodRangeIndex: value
      });
      if (_this.data.serviceTimeUnit == '小时') {
        _this.serviceConditionChange();
      }
    };

    _this.serviceDateChange = function (e) {
      var dataset = e.currentTarget.dataset,
          ifBusinessDay = dataset.ifbusinessday,
          date = dataset.date,
          data = {};
      data['selectedDate'] = date;
      if (!ifBusinessDay) {
        data['appointmentInfo.servicePeriodList'] = '';
      }
      _this.setData(data);
      if (ifBusinessDay) {
        _this.serviceConditionChange();
      }
    };

    _this.servicePeriodListChange = function (e) {
      var dataset = e.currentTarget.dataset,
          canBuy = dataset.canBuy,
          expired = dataset.expired;
      if (expired == 1 || canBuy == 0) {
        return;
      }
      _this.setData({
        selectedPeriod: e.currentTarget.dataset.interval
      });
    };

    _this.serviceConditionChange = function () {
      var param = _this.getParam();
      _this.getAppointmentList(param, false);
      _this.setData({
        selectedPeriod: ''
      });
    };

    _this.hiddeAddToShoppingCart = function () {
      _this.setData({
        addToShoppingCartHidden: true
      });
    };

    _this.getParam = function () {
      var appointmentInfo = _this.data.appointmentInfo;
      if (_this.data.appointmentInfo.serviceLongRange) {
        var timeNum = _this.data.appointmentInfo.serviceLongRange[0];
      }
      if (appointmentInfo.serviceLongRange) {
        var serviceLongRange = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
      }
      var param = {
        app_id: _app.appMethod.getAppId(),
        data_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId
      };
      if (_this.data.unitType == 2) {
        var periodsSelected = appointmentInfo.servicePeriodRange[_this.data.periodRangeIndex],
            startDay = periodsSelected.substring(6, 8) == '当日' ? periodsSelected.split('当日').join('') : periodsSelected.substring(0, 6) + (periodsSelected.substring(8, 10) * 1 + 24) + periodsSelected.substring(10);
        param.interval = startDay;
        param.day = _this.data.appointmentInfo.appointmentDay.split('-').join('');
        param.time_long = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
      } else if (_this.data.unitType == 1) {
        param.day = _this.data.appointmentInfo.appointmentDay.split('-').join('');
        param.start_time = _this.data.time;
        param.time_long = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
      } else if (_this.data.unitType == 3) {
        param.start_date = _this.data.appointmentInfo.appointmentStartDateRange.split('-').join('');
        param.end_date = _this.data.appointmentInfo.appointmentEndDateRange.split('-').join('');
      }
      return param;
    };

    _this.timestampToTime = function (timestamp) {
      var date = new Date(timestamp);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      return Y + M + D;
    };

    _this.getShopParam = function () {
      var appointmentInfo = _this.data.appointmentInfo;
      if (_this.data.appointmentInfo.serviceLongRange) {
        var timeNum = _this.data.appointmentInfo.serviceLongRange[0];
      }
      if (appointmentInfo.serviceLongRange) {
        var serviceLongRange = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
      }
      var param = {
        app_id: _app.appMethod.getAppId(),
        goods_id: _this.data.goodsId,
        sub_shop_app_id: _this.data.franchiseeId
      };
      if (_this.data.serviceTimeUnit == '小时') {
        var startHours = _this.data.selectedPeriod.split('-')[0].split(':')[0],
            startHour = startHours.substring(2) * 1,
            startMin = _this.data.selectedPeriod.split('-')[0].split(':')[1],
            endHoursLog = _this.data.selectedPeriod.split('-')[1].split(':')[0].substring(0, 2),
            endHours = parseInt(_this.data.selectedPeriod.split('-')[1].split(':')[0].substring(2)),
            endHours = endHoursLog == '次日' ? endHours + 24 : endHours,
            endMin = _this.data.selectedPeriod.split('-')[1].split(':')[1],
            startTime = startHours.substring(0, 2) == '当日' ? startHour + ':' + startMin : startHour + 24 + ':' + startMin,
            endTime = endHours < startHour || startTime.split(':')[0] >= 24 ? endHours + 24 + ':' + endMin : endHours + ':' + endMin,
            period = startTime + '-' + endTime;
        param.appointment_interval = period;
        param.appointment_unit_type = 2;
        param.appointment_day = _this.data.appointmentInfo.appointmentDay.split('-').join('');
        param.appointment_time_long = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
      } else if (_this.data.serviceTimeUnit == '分') {
        param.appointment_unit_type = 1;
        param.appointment_day = _this.data.appointmentInfo.appointmentDay.split('-').join('');
        param.appointment_time_long = appointmentInfo.serviceLongRange[_this.data.longRangeIndex];
        param.appointment_interval = _this.data.time + '-' + _this.setTime(_this.data.time, appointmentInfo.serviceLongRange[_this.data.longRangeIndex]);
      } else if (_this.data.serviceTimeUnit == '天') {
        if (_this.data.unitType == '6') {
          param.appointment_day = _this.data.appointmentInfo.appointmentStartDateRange.split('-').join('');
        }
        param.appointment_unit_type = _this.data.unitType;
        param.appointment_start_date = _this.data.appointmentInfo.appointmentStartDateRange.split('-').join('');
        param.appointment_end_date = _this.data.appointmentInfo.appointmentEndDateRange.split('-').join('');
      }
      return param;
    };

    _this.sureMakeAppointment = function (e) {
      var selectPeriod = _this.data.selectedPeriod,
          franchiseeId = _this.data.franchiseeId,
          servicePrice = _this.data.appointmentInfo.servicePrice,
          serviceTimeUnit = _this.data.serviceTimeUnit,
          param,
          time = _this.data.time,
          that = _this;
      if (!servicePrice) {
        _app.appMethod.showModal({
          content: '该时间段已被预约，请选择其他时间段'
        });
        return;
      }
      if (serviceTimeUnit == '小时' && !selectPeriod) {
        _app.appMethod.showModal({
          content: '请选择具体时间'
        });
        return;
      }
      param = _this.getShopParam();
      param.model_id = 0;
      param.num = 1;
      param.is_appointment = 1;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/AddCart',
        data: param,
        success: function success(res) {
          var cart_arr = [res.data],
              pagePath = '/eCommerce/pages/previewAppointmentOrder/previewAppointmentOrder?cart_arr=' + encodeURIComponent(cart_arr) + ('&to_store=' + JSON.stringify(time));
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          that.hiddeAddToShoppingCart();
          _app.appMethod.turnToPage(pagePath, true);
        }
      });
    };

    document.title = '预约';
    return _this;
  }

  (0, _createClass3.default)(MakeAppointment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var goodsId = options.detail,
          franchiseeId = options.franchisee || '',
          unitType = options.param,
          appointmentInfo = {},
          date = new Date(),
          timeObj;
      timeObj = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1 >= 10 ? new Date().getMonth() + 1 : '0' + (new Date().getMonth() + 1),
        date: new Date().getDate() >= 10 ? new Date().getDate() : '0' + new Date().getDate(),
        startHours: new Date().getHours() + 1 >= 10 ? new Date().getHours() + 1 : '0' + (new Date().getHours() + 1),
        endHours: new Date().getHours() + 2 >= 10 ? new Date().getHours() + 2 : '0' + (new Date().getHours() + 2)
      };
      appointmentInfo['appointmentDay'] = '请先选择预约日期';
      appointmentInfo['appointmentStartDateRange'] = '请先选择起始日期';
      appointmentInfo['appointmentEndDateRange'] = '请先选择起始日期';
      appointmentInfo['serviceLongRange'] = ['1小时'];
      appointmentInfo['servicePeriodRange'] = [timeObj.startHours + ':00-当日' + timeObj.endHours + ':00'];
      appointmentInfo['intervalStart'] = [timeObj.year + '-' + timeObj.month + '-' + timeObj.date];
      this.setData({
        goodsId: goodsId,
        franchiseeId: franchiseeId,
        unitType: unitType,
        appointmentInfo: appointmentInfo
      });
      this.dataInitialName();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          unitType = _state.unitType,
          appointmentInfo = _state.appointmentInfo,
          color = _state.color,
          serviceTimeUnit = _state.serviceTimeUnit,
          periodRangeIndex = _state.periodRangeIndex,
          appointmentTime = _state.appointmentTime,
          time = _state.time,
          longRangeIndex = _state.longRangeIndex,
          selectedDate = _state.selectedDate,
          selectedPeriod = _state.selectedPeriod;

      // 转换Picker组件需要的数据格式

      var periodData = appointmentInfo.servicePeriodRange.map(function (item) {
        return {
          label: item,
          value: item
        };
      });
      var serviceLenData = appointmentInfo.serviceLongRange.map(function (item) {
        return {
          label: item + serviceTimeUnit,
          value: item
        };
      });

      return React.createElement(
        'div',
        { className: 'official-page make-appointment' },
        React.createElement(_TopNav.TopNav, { title: '\u9884\u7EA6' }),
        React.createElement(
          'div',
          {
            className: 'appointmentPage-wrap page',
            id: 'appointmentPage',
            'data-router': 'appointmentPage'
          },
          React.createElement(
            'div',
            { style: (0, _tools.convertLineStyleData)('position:sticky;') },
            React.createElement(
              'div',
              { className: 'appointment-top-section' },
              (serviceTimeUnit == '天' || unitType == 3 || unitType == 6) && React.createElement(
                'div',
                { className: 'appointment-model-field' },
                React.createElement(
                  'span',
                  null,
                  '\u8D77\u59CB\u65E5\u671F'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _datePicker2.default,
                    {
                      mode: 'date',
                      extra: appointmentInfo.appointmentStartDateRange,
                      value: unitType == 6 ? new Date(hotel.dateFilter(appointmentInfo.intervalStart[0])) : isNaN(new Date(appointmentInfo.appointmentStartDateRange).getTime()) ? null : new Date(appointmentInfo.appointmentStartDateRange),
                      minDate: unitType == 6 ? new Date(hotel.dateFilter(appointmentInfo.intervalStart[0])) : isNaN(new Date(appointmentInfo.intervalStart).getTime()) ? null : new Date(appointmentInfo.intervalStart),
                      maxDate: new Date('3030-09-01'),
                      onChange: this.bindStartDateChange
                    },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              (serviceTimeUnit == '天' || unitType == 3 || unitType == 6) && React.createElement(
                'div',
                { className: 'appointment-model-field' },
                React.createElement(
                  'span',
                  null,
                  '\u7ED3\u675F\u65E5\u671F'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _datePicker2.default,
                    {
                      mode: 'date',
                      extra: appointmentInfo.appointmentEndDateRange,
                      value: isNaN(new Date(appointmentInfo.appointmentEndDateRange).getTime()) ? null : new Date(appointmentInfo.appointmentEndDateRange),
                      minDate: new Date(appointmentInfo.intervalStart),
                      maxDate: new Date('3030-09-01'),
                      onChange: this.bindEndDateChange
                    },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              (serviceTimeUnit == '分' || serviceTimeUnit == '时' || unitType == 2 || unitType == 1) && React.createElement(
                'div',
                { className: 'appointment-model-field' },
                React.createElement(
                  'span',
                  null,
                  '\u9884\u7EA6\u65E5\u671F'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _datePicker2.default,
                    {
                      mode: 'date',
                      extra: appointmentInfo.appointmentDay,
                      value: isNaN(new Date(appointmentInfo.appointmentDay).getTime()) ? null : new Date(appointmentInfo.appointmentDay),
                      minDate: new Date(appointmentInfo.intervalStart[0]),
                      maxDate: new Date('3030-09-01'),
                      onChange: this.bindDateAppointmentChange },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'appointment-model-field',
                  hidden: serviceTimeUnit == '天' || unitType == 3 || unitType == 6
                },
                React.createElement(
                  'span',
                  null,
                  '\u8425\u4E1A\u65F6\u6BB5'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _picker2.default,
                    {
                      className: 'appointment-field-selection',
                      cols: 1,
                      data: periodData,
                      value: [periodData[periodRangeIndex].value],
                      onChange: this.servicePeriodSelectChange
                    },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              (serviceTimeUnit == '天' || serviceTimeUnit == '分' || unitType == 1 || unitType == 3 || unitType == 6) && React.createElement(
                'div',
                { className: 'appointment-model-field' },
                React.createElement(
                  'span',
                  null,
                  '\u9884\u7EA6\u65F6\u95F4'
                ),
                React.createElement(
                  'span',
                  (0, _defineProperty3.default)({ style: (0, _tools.convertLineStyleData)('float:right;') }, 'style', (0, _tools.convertLineStyleData)('color: ' + color)),
                  appointmentTime
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _datePicker2.default,
                    {
                      className: 'appointment-field-selection',
                      mode: 'time',
                      value: new Date('2010-10-10 ' + time),
                      onChange: function onChange(e) {
                        return _this2.bindTimeChange(e, unitType);
                      }
                    },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'appointment-model-field',
                  hidden: serviceTimeUnit == '天' || unitType == 3 || unitType == 6
                },
                React.createElement(
                  'span',
                  null,
                  '\u670D\u52A1\u65F6\u957F'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    _picker2.default,
                    {
                      className: 'appointment-field-selection',
                      cols: 1,
                      extra: '\u8BF7\u5148\u9009\u62E9\u9884\u7EA6\u65E5\u671F',
                      data: serviceLenData,
                      value: [serviceLenData[longRangeIndex].value],
                      onChange: this.serviceLongChange
                    },
                    React.createElement(_list2.default.Item, { style: (0, _tools.convertLineStyleData)('color: ' + color) })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'appointment-model-field', style: (0, _tools.convertLineStyleData)('border:none;') },
                React.createElement(
                  'span',
                  null,
                  '\u670D\u52A1\u4EF7\u683C'
                ),
                React.createElement(
                  'div',
                  { className: 'appointment-model-right' },
                  React.createElement(
                    'span',
                    {
                      className: 'appointment-service-price',
                      style: (0, _tools.convertLineStyleData)('color: ' + color)
                    },
                    appointmentInfo.servicePrice
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'appointment-time-section' },
              React.createElement(
                'div',
                { className: 'appointment-date-list' },
                appointmentInfo && appointmentInfo.serviceDateList && appointmentInfo.serviceDateList.map(function (date, index) {
                  return React.createElement(
                    'div',
                    {
                      key: date.date,
                      className: 'appointment-date-item ' + (selectedDate == date.date ? 'selected' : '') + ' ' + (!date.ifBusiness ? 'disabled' : ''),
                      'data-date': date.date,
                      'data-ifBusinessDay': date.ifBusiness,
                      onClick: _this2.serviceDateChange
                    },
                    React.createElement(
                      'div',
                      null,
                      date.week,
                      !date.ifBusiness && React.createElement(
                        'span',
                        null,
                        '(\u4E0D\u8425\u4E1A)'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      date.modifiedDate
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'appointment-period-list' },
                appointmentInfo && appointmentInfo.servicePeriodList && appointmentInfo.servicePeriodList.map(function (period, index) {
                  return React.createElement(
                    'div',
                    {
                      key: index,
                      className: 'appointment-period-item ' + (selectedPeriod == period.interval ? 'selected' : '') + ' ' + (period.can_buy == 0 || period.expired == 1 ? 'disabled' : ''),
                      onClick: _this2.servicePeriodListChange,
                      'data-expired': period.expired,
                      'data-can-buy': period.can_buy,
                      'data-interval': period.interval
                    },
                    React.createElement(
                      'div',
                      null,
                      period.interval
                    ),
                    (period.can_buy == 0 || period.expired == 1) && React.createElement(
                      'span',
                      null,
                      '(' + (period.expired == 1 ? '过期' : '约满') + ')'
                    )
                  );
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'appointment-bottom-bar' },
            React.createElement(
              'form',
              null,
              React.createElement(
                'button',
                {
                  type: 'button',
                  onClick: this.sureMakeAppointment,
                  className: 'btn btn-block sure-make-appointment'
                },
                '\u786E\u8BA4'
              )
            )
          )
        )
      );
    }
  }]);
  return MakeAppointment;
}(_OfficialPage3.default);

exports.default = MakeAppointment;

/***/ }),
/* 504 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(506);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(TransferOrderDetail, _OfficialPage);

  function TransferOrderDetail() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, TransferOrderDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = TransferOrderDetail.__proto__ || Object.getPrototypeOf(TransferOrderDetail)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      orderInfo: {},
      combinationBenefit: {},
      orderStatus: { '0': '待付款', '6': '已完成', '7': '已关闭' },
      isFromBack: false,
      isFromTemplateMsg: false,
      orderId: '',
      discountList: []
    }, _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
    }, _this2.turnToFormDetail = function () {
      var pay_form_data = _this2.data.orderInfo.pay_form_data;
      _app.appMethod.turnToPage('/userCenter/pages/myMessage/myMessage?from=transforDetail&formid=' + pay_form_data.pay_form_id + '&form=' + pay_form_data.pay_form + '&formDataId=' + pay_form_data.pay_form_data_id);
    }, _this2.getOrderDetail = function (orderId, isFromAddrSelect) {
      var that = _this2,
          combinationBenefit = {};
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var orderInfo = res.data[0].form_data,
              address_id = '';
          if (orderInfo.selected_combination_benefit) {
            combinationBenefit = orderInfo.selected_combination_benefit; // 保留两位小数处理
            combinationBenefit.store_benefit && combinationBenefit.store_benefit.discount_price ? combinationBenefit.store_benefit.discount_price = (+combinationBenefit.store_benefit.discount_price).toFixed(2) : '';
            combinationBenefit.vip_benefit_discount_price ? combinationBenefit.vip_benefit_discount_price = (+combinationBenefit.vip_benefit_discount_price).toFixed(2) : '';
            combinationBenefit.coupon_benefit_discount_price ? combinationBenefit.coupon_benefit_discount_price = (+combinationBenefit.coupon_benefit_discount_price).toFixed(2) : '';
            combinationBenefit.integral_benefit && combinationBenefit.integral_benefit.discount_price ? combinationBenefit.integral_benefit.discount_price = (+combinationBenefit.integral_benefit.discount_price).toFixed(2) : '';
          }
          orderInfo.store_benefit_info && orderInfo.store_benefit_info.discount_price ? orderInfo.store_benefit_info.discount_price = (+orderInfo.store_benefit_info.discount_price).toFixed(2) : '';
          orderInfo.selected_benefit_info && orderInfo.selected_benefit_info.discount_cut_price ? orderInfo.selected_benefit_info.discount_cut_price = (+orderInfo.selected_benefit_info.discount_cut_price).toFixed(2) : '';
          orderInfo.use_balance ? orderInfo.use_balance = (+orderInfo.use_balance).toFixed(2) : '';
          orderInfo.coupon_fee ? orderInfo.coupon_fee = (+orderInfo.coupon_fee).toFixed(2) : '';
          delete orderInfo.can_use_benefit.coupon_benefit;
          that.setData({
            orderInfo: orderInfo,
            combinationBenefit: combinationBenefit,
            discountList: orderInfo.can_use_benefit.data,
            index: orderInfo.can_use_benefit.selected_index
          });
        }
      });
    }, _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderId,
          that = _this2;
      _app.appMethod.showModal({
        content: '是否取消订单？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = '7';
              that.setData(data);
            }
          });
        }
      });
    }, _this2.payOrder = function (e) {
      var that = _this2,
          orderId = _this2.data.orderId;
      if (_this2.data.orderInfo.total_price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            that.getOrderDetail(that.data.orderId);
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function(res) {
      //     var param = res.data,
      //       orderId = that.data.orderId
      //     param.orderId = orderId
      //     param.goodsType = that.data.orderInfo.goods_type
      //     param.success = function() {
      //       setTimeout(function() {
      //         that.getOrderDetail(orderId)
      //       }, 1500)
      //     }
      //     app.wxPay(param)
      //   }
      // })

      _app.appMethod.goPay({
        orderId: orderId
      });
    }, _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    }, _this2.changeDiscount = function (e) {
      var _this = _this2;
      var index = _this.data.orderInfo.can_use_benefit.selected_index;
      var value = parseInt(e.target.value);
      _this2.setData({
        index: value
      });
      var discount_type = _this.data.orderInfo.can_use_benefit.data[value].discount_type,
          coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderId,
          discount_type: discount_type,
          coupon_id: coupon_id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.getOrderDetail(_this.data.orderId);
        }
      });
    }, _this2.verificationCode = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' + _this2.data.orderId + '&sub_shop_app_id=' + _this2.data.franchiseeId);
    }, _this2.toFixed2 = function (num) {
      return (+num).toFixed(2);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(TransferOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderId) {
          this.getOrderDetail(this.data.orderId, 1);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          orderInfo = _state.orderInfo,
          combinationBenefit = _state.combinationBenefit;

      return React.createElement(
        'div',
        { className: 'official-page transfer-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u5F53\u9762\u4ED8\u8BA2\u5355' }),
        React.createElement(
          'div',
          { className: 'transfer-wrap' },
          React.createElement(
            'div',
            { className: 'top-block' },
            orderInfo.status === '6' && React.createElement('img', {
              className: 'icon-img',
              src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/finish-icon.svg'
            }),
            (orderInfo.status === '0' || orderInfo.status === '7') && React.createElement('img', {
              className: 'icon-img',
              src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/no-finish-icon.svg'
            }),
            React.createElement(
              'div',
              { className: 'text' },
              orderInfo.status === '0' ? '订单未完成' : orderInfo.status === '6' ? '订单已完成' : orderInfo.status === '7' ? '订单已关闭' : ''
            ),
            React.createElement('img', {
              className: 'bg-img',
              src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/wave.png'
            })
          ),
          React.createElement(
            'div',
            { className: 'total-payment' },
            React.createElement(
              'div',
              { className: 'content' },
              React.createElement(
                'div',
                { className: 'text' },
                '\u5B9E\u4ED8\u91D1\u989D'
              ),
              React.createElement(
                'div',
                { className: 'price' },
                '¥' + orderInfo.total_price
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'transfer-detail' },
            React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u6D88\u8D39\u91D1\u989D'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '¥' + orderInfo.original_price
              )
            ),
            orderInfo.store_benefit_info && orderInfo.store_benefit_info.discount_price && orderInfo.store_benefit_info.discount_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u5E97\u94FA\u6EE1\u51CF'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.store_benefit_info.discount_price
              )
            ),
            orderInfo.selected_benefit_info && (orderInfo.selected_benefit_info.discount_type === 'vip' || orderInfo.selected_benefit_info.discount_type === 'paid_vip' || orderInfo.selected_benefit_info.discount_type === 'vip_benefit_day') && orderInfo.selected_benefit_info.discount_cut_price && orderInfo.selected_benefit_info.discount_cut_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u4F1A\u5458\u5361\u4F18\u60E0'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.selected_benefit_info.discount_cut_price
              )
            ),
            orderInfo.selected_benefit_info && orderInfo.selected_benefit_info.discount_type === 'coupon' && orderInfo.selected_benefit_info.discount_cut_price && orderInfo.selected_benefit_info.discount_cut_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u5238\u7C7B\u4F18\u60E0'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.selected_benefit_info.discount_cut_price
              )
            ),
            orderInfo.selected_benefit_info && orderInfo.selected_benefit_info.discount_type === 'integral' && orderInfo.selected_benefit_info.discount_cut_price && orderInfo.selected_benefit_info.discount_cut_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u79EF\u5206\u62B5\u6263'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.selected_benefit_info.discount_cut_price
              )
            ),
            combinationBenefit.store_benefit && combinationBenefit.store_benefit.discount_price && combinationBenefit.store_benefit.discount_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u5E97\u94FA\u6EE1\u51CF'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + combinationBenefit.store_benefit.discount_price
              )
            ),
            combinationBenefit.vip_benefit_discount_price && combinationBenefit.vip_benefit_discount_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u4F1A\u5458\u5361\u4F18\u60E0'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + combinationBenefit.vip_benefit_discount_price
              )
            ),
            combinationBenefit.coupon_benefit_discount_price && combinationBenefit.coupon_benefit_discount_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u5238\u7C7B\u4F18\u60E0'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + combinationBenefit.coupon_benefit_discount_price
              )
            ),
            combinationBenefit.integral_benefit && combinationBenefit.integral_benefit.discount_price && combinationBenefit.integral_benefit.discount_price != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u79EF\u5206\u62B5\u6263'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + combinationBenefit.integral_benefit.discount_price
              )
            ),
            orderInfo.use_balance && orderInfo.use_balance != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u50A8\u503C'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.use_balance
              )
            ),
            orderInfo.coupon_fee && orderInfo.coupon_fee != 0 && React.createElement(
              'div',
              { className: 'detail-item' },
              React.createElement(
                'div',
                { className: 'detail-text' },
                '\u793E\u4EA4\u7ACB\u51CF\u91D1'
              ),
              React.createElement(
                'div',
                { className: 'detail-content' },
                '-¥' + orderInfo.coupon_fee
              )
            )
          ),
          orderInfo.remark && React.createElement(
            'div',
            { className: 'remarks' },
            React.createElement(
              'div',
              { className: 'text' },
              '\u5907\u6CE8'
            ),
            React.createElement(
              'div',
              { className: 'content' },
              orderInfo.remark
            )
          ),
          orderInfo.status === '0' && React.createElement(
            'div',
            { className: 'transfer-bottom-operation' },
            React.createElement(
              'span',
              { className: 'btn carry-btn', onClick: this.payOrder },
              '\u652F\u4ED8'
            ),
            React.createElement(
              'span',
              { className: 'btn cancel-btn', onClick: this.cancelOrder },
              '\u53D6\u6D88\u652F\u4ED8'
            )
          )
        )
      );
    }
  }]);
  return TransferOrderDetail;
}(_OfficialPage3.default);

exports.default = TransferOrderDetail;

/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(508);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TransferPaySuccess = function (_OfficialPage) {
  (0, _inherits3.default)(TransferPaySuccess, _OfficialPage);

  function TransferPaySuccess(props) {
    (0, _classCallCheck3.default)(this, TransferPaySuccess);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TransferPaySuccess.__proto__ || Object.getPrototypeOf(TransferPaySuccess)).call(this, props));

    _this2.state = {
      totalPayment: '',
      payInfo: {},
      hideScratchCanvas: true,
      isShowScratchBtn: '',
      scratchIsFail: true, // 显示未中奖
      scratchIsPrize: true, // 显示中奖
      scratchIsDurMax: false,
      scratchIsLimit: false,
      scratchIsComfort: true, // 显示安慰奖
      scratchIsDegree: false,
      scratchInfo: {}, // 获取活动信息
      scratchTimes: 0, // 剩余次数
      scratchId: '', // 活动号
      scratchIsScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
      time_limit: '',
      scratchPrizeTitle: '', // 中奖名称
      vipCardInfo: { isShow: false }, // 会员卡信息
      couponList: [
      // 优惠券列表
      {
        active_title: '领取后立即生效，',
        condition: '10.00',
        discount: '10.00',
        discount_type: 'coupon',
        end_use_date: '9999-12-31',
        end_use_time: '23:59:00',
        expire_day_count: 0,
        name: '满10减9.9',
        start_use_date: '1000-01-01',
        start_use_time: '00:00:00',
        title: '满10减9.9（满10.00减9.90）',
        type: '0',
        value: '9.90'
      }],
      benefitConfig: {},
      collectBenefitData: {}, // 集集乐数据
      starData: [], // 集集乐的星 light:已集样式 dark:未集样式
      payActivity: '', // 支付营销活动类型
      isShowVipCardDialog: false, // 是否显示会员卡弹窗
      ifUserInfo: false, // 是否存在相应的用户信息
      userCityArr: ['', '', ''], // 用户城市信息的集合   [country, pri, city]
      userInfo: {}, // 会员信息
      isRecvVipCard: false, // 是否已会员卡领取
      transferConfig: {}, // 当面付配置
      appTitle: '',
      isGetPhoneNumber: false, // 是否获得手机授权
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false
    };
    _this2.orderId = '';

    _this2.getTransferOrderConfig = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransferOrder/GetTransferOrderConfig',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchisee
        },
        success: function success(res) {
          _this.setData({
            transferConfig: res.data
          });
        }
      });
    };

    _this2.setPaySuccessBenefitConfig = function (config) {
      var that = _this2;
      var payActivity = '';
      if (Number(that.data.payInfo.total_price) + Number(that.data.payInfo.use_balance) < config.condition_price) {
        return;
      }
      if (config.type === 'scratch_card') {
        that.activityInit();
      } else if (config.type === 'vipcard_permission') {
        that.judgmentVipCard(config.vipcard_id);
      } else if (config.type === 'coupon') {
        that.setCouponInfo(config.coupon_id);
        payActivity = config.type;
      } else if (config.type === 'collectme') {
        that.checkAppCollectmeStatus();
      } else if (config.type === 'balance') {
        if (config.balance_type == 1) {
          config.balance = config.balance_value * _this2.data.totalPayment % 1 === 0 ? config.balance_value * _this2.data.totalPayment : Math.floor(config.balance_value * _this2.data.totalPayment * 100) / 100;
        } else {
          config.balance = config.balance_value;
        }
        payActivity = config.type;
      } else {
        payActivity = config.type;
      }
      that.setData({
        benefitConfig: config,
        payActivity: payActivity
      });
    };

    _this2.activityInit = function () {
      var that = _this2;
      if (_app.appMethod.isLogin()) {
        that.getScratchData();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getScratchData();
          }
        });
      }
    };

    _this2.getScratchData = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getActivity',
        method: 'post',
        data: { category: 3 },
        success: function success(res) {
          var mes = res.data;
          that.scratchInit();
          that.setData({
            scratchInfo: mes,
            scratchId: mes.id,
            scratchTimes: mes.times,
            time_limit: mes.time_limit
          });
        }
      });
    };

    _this2.scratchInit = function () {
      var that = _this2;
      var systemInfo = _app.appMethod.globalData.systemInfo;
      var width = 722 * systemInfo.windowWidth / 750;
      var height = 290 * systemInfo.windowWidth / 750;
      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideScratchCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              hideScratchCanvas: false,
              isShowScratchBtn: true,
              payActivity: that.data.benefitConfig.type
            });
          }, 10);
        }
      });
    };

    _this2.startScratch = function () {
      var that = _this2;
      if (!that.data.scratchId) {
        return;
      }
      if (that.data.time_limit == 0) {
        that.setData({
          scratchIsLimit: true,
          hideScratchCanvas: true,
          isShowScratchBtn: false
        });
      } else {
        console.log(that.data.scratchTimes);
        if (that.data.scratchTimes <= 0) {
          if (that.data.scratchInfo.time_share == 0) {
            that.setData({
              scratchIsDegree: true,
              hideScratchCanvas: true,
              isShowScratchBtn: false
            });
          } else {
            that.setData({
              scratchIsDurMax: true,
              hideScratchCanvas: true,
              isShowScratchBtn: false
            });
          }
        } else {
          if (that.scratchLoading) {
            return false;
          }
          that.setData({
            isShowScratchBtn: false
          });
          that.scratchLoading = true;
          that.getLottery();
        }
      }
    };

    _this2.getLottery = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          app_id: _app.appMethod.globalData.appId
        },
        success: function success(res) {
          var data = res.data,
              newData = {};
          that.scratch.start();
          if (data.title == '谢谢参与') {
            newData = {};
            newData['scratchIsFail'] = false;
            newData['scratchTimes'] = data.time;
            newData['time_limit'] = data.time_limit;
            that.setData(newData);
          } else {
            newData = {};
            if (data.is_comfort == 1) {
              newData['scratchIsComfort'] = false;
            } else {
              newData['scratchIsPrize'] = false;
              newData['scratchPrizeTitle'] = data.title;
            }
            var ifWxCoupon = data.card_id || false;
            newData['ifWxCoupon'] = ifWxCoupon;
            newData['timestamp'] = data.timestamp || '';
            newData['signature'] = data.signature || '';
            newData['scratchTimes'] = data.time;
            newData['time_limit'] = data.time_limit;
            that.setData(newData);
          }
          that.scratchLoading = false;
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          that.scratchLoading = false;
          if (res.status == 1) {
            that.setData({
              isShowScratchBtn: true
            });
          }
        }
      });
    };

    _this2.failBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideScratchCanvas: false,
        scratchIsFail: true
      });
      setTimeout(function () {
        that.setData({
          isShowScratchBtn: true
        });
      }, 100);
    };

    _this2.winningBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideScratchCanvas: false,
        scratchIsPrize: true
      });
      setTimeout(function () {
        that.setData({
          isShowScratchBtn: true
        });
      }, 100);
    };

    _this2.comfortBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideScratchCanvas: false,
        scratchIsComfort: true
      });
      setTimeout(function () {
        that.setData({
          isShowScratchBtn: true
        });
      }, 100);
    };

    _this2.getGoldenData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          sub_app_id: that.data.franchisee
        },
        success: function success(data) {
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this2.getOrderDetail = function () {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this2.orderId
        },
        success: function success(res) {
          var form_data = res.data[0].form_data;
          that.setData({
            totalPayment: form_data.total_price,
            payInfo: form_data
          });
          if (form_data.pay_success_benefit_info && form_data.pay_success_benefit_info[0] && form_data.pay_success_benefit_info[0].status === 0) {
            that.setPaySuccessBenefitConfig(form_data.pay_success_benefit_info[0].benefit_info);
          }
        }
      });
    };

    _this2.transferSuccessCallback = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.goToOrderDetail = function () {
      var franchiseeParam = _this2.data.franchisee ? '&franchisee=' + _this2.data.franchisee : '';
      _app.appMethod.turnToPage('/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail=' + _this2.orderId + franchiseeParam, 1);
    };

    _this2.setCouponInfo = function (id) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCouponInfo',
        data: {
          coupon_id: id
        },
        hideLoading: true,
        success: function success(res) {
          var couponList = [];
          couponList.push(res.data);
          _this.setData({
            couponList: couponList
          });
        }
      });
    };

    _this2.recvCoupon = function (e) {
      var _this = _this2,
          couponId = e.currentTarget.dataset.couponid;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/recvCoupon',
        data: {
          coupon_id: couponId
        },
        hideLoading: true,
        success: function success(res) {}
      });
    };

    _this2.checkAppCollectmeStatus = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
        data: {
          order_id: that.orderId
        },
        success: function success(res) {
          if (res.valid === 1) {
            return;
          }
          that.getCollectBenefitData(that.orderId);
        }
      });
    };

    _this2.getCollectBenefitData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
        data: {
          order_id: id
        },
        hideLoading: true,
        success: function success(res) {
          var starData = [];
          for (var i = 0; i < res.data.star_num; i++) {
            starData.push('light');
          }
          for (var _i = 0; _i < res.data.collect_num - res.data.star_num; _i++) {
            starData.push('dark');
          }
          that.setData({
            collectBenefitData: res.data,
            starData: starData,
            payActivity: that.data.benefitConfig.type
          });
        }
      });
    };

    _this2.goToWheelDetail = function () {
      var franchiseeParam = _this2.data.franchisee ? '?franchisee=' + _this2.data.franchisee : '';
      _app.appMethod.turnToPage('/awardManagement/pages/luckyWheelDetail/luckyWheelDetail' + franchiseeParam, 1);
    };

    _this2.goToGoldenEggs = function () {
      var franchiseeParam = _this2.data.franchisee ? '?franchisee=' + _this2.data.franchisee : '';
      _app.appMethod.turnToPage('/awardManagement/pages/goldenEggs/goldenEggs' + franchiseeParam, 1);
    };

    _this2.touchStart = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchMove = function (e) {
      console.log(e);
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchEnd = function (e) {
      console.log(e);
      if (!_this2.isStart) return;
      var canvasWidth = _this2.canvasWidth,
          canvasHeight = _this2.canvasHeight,
          minX = _this2.minX,
          minY = _this2.minY,
          maxX = _this2.maxX,
          maxY = _this2.maxY;

      if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
        _this2.ctx.draw();
        _this2.endCallBack && _this2.endCallBack();
        _this2.isStart = false;
        _this2.page.setData({
          scratchIsScroll: true
        });
      }
    };

    _this2.goToUserCenter = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.judgmentVipCard = function (id) {
      var _this = _this2;
      _this2.getEnableVipCardList(id, function () {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/GetVIPCardInfo',
          data: { vip_id: id },
          success: function success(res) {
            var cardInfo = res.data[0];
            _this.getUserVipLevel(cardInfo);
          }
        });
      });
    };

    _this2.getUserVipLevel = function (cardInfo) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetVIPInfo',
        data: {},
        success: function success(res) {
          var user_vip_level = res.data.level ? res.data.level : 0;
          var user_vip_id = res.data.vip_id ? res.data.vip_id : 0;
          if (user_vip_level <= +cardInfo.level && user_vip_id !== cardInfo.id) {
            cardInfo.isShow = true;
            _this.setData({
              vipCardInfo: cardInfo,
              payActivity: _this.data.benefitConfig.type
            });
          }
        }
      });
    };

    _this2.getEnableVipCardList = function (id, callback) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppVipCard/GetEnableVipCardList',
        data: {
          sub_shop_app_id: _this.data.franchisee
        },
        success: function success(res) {
          res.data.map(function (val) {
            if (val.id === id) {
              callback();
            }
          });
        }
      });
    };

    _this2.handleVipCard = function () {
      _this2.getCollectUserinfoConfig(function () {
        _app.appMethod.turnToPage('/pages/userCenter/userCenter?card_id=' + _this2.data.vipCardInfo.id + '&is_no_condition_recv=' + 1 + '&franchisee=' + _this2.data.franchisee);
      });
    };

    _this2.recvVipCard = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        data: {
          vipcard_id: _this.data.vipCardInfo.id,
          sub_shop_app_id: _this.data.franchisee
        },
        url: '/index.php?r=AppVipCard/RecvVipCard',
        hideLoading: true,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '开卡成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.saveUserInfo = function () {
      var data = _this2.data.userInfo;
      var _this = _this2;
      var config = _this2.data.userInfoCollectConfig;
      var newData = {};
      if (data.country === 'China') {
        data.country = '中国';
      }
      data.province = _this2.data.userCityArr[0];
      data.city = _this2.data.userCityArr[1];
      if (config.collect_username == 1 && data.nickname === '' || config.collect_phone == 1 && !data.phone || config.collect_birthday == 1 && data.birthday === '' || config.collect_region == 1 && (data.province === '' || data.city === '')) {
        _app.appMethod.showModal({
          content: '请填写完整的会员信息'
        });
        return;
      }
      newData.nickname = data.nickname;
      newData.phone = data.phone;
      newData.birthday = data.birthday;
      newData.country = data.country;
      newData.province = data.province;
      newData.city = data.city;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/saveUserInfo',
        method: 'post',
        data: newData,
        success: function success(res) {
          if (res.status === 0) {
            _app.appMethod.setUserInfoStorage(data);
            _this.recvVipCard();
          }
        }
      });
    };

    _this2.getCollectUserinfoConfig = function (callback) {
      var _this = _this2;
      var userInfo = JSON.parse(JSON.stringify(_app.appMethod.getUserInfo()));
      _app.appMethod.sendRequest({
        data: {},
        url: '/index.php?r=AppVipCard/GetCollectUserinfoConfig',
        hideLoading: true,
        success: function success(res) {
          if (res.data.need_collect_info) {
            callback();
          } else {
            _this.recvVipCard();
          }
        }
      });
    };

    _this2.closeVipCardDialog = function (e) {
      if (e.target.dataset.type === 'shadow') {
        _this2.setData({
          isShowVipCardDialog: false
        });
      }
    };

    _this2.getAppShopByPage = function () {
      var that = _this2;
      var franchiseeId = _this2.data.franchisee;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAppShopByPage',
        data: {
          sub_shop_app_id: franchiseeId
        },
        success: function success(res) {
          var newdata = {},
              data = res.data[0];
          newdata['appTitle'] = data.name;
          that.setData(newdata);
        }
      });
    };

    _this2.getPhoneNumber = function (e) {
      if (_this2.data.isGetPhoneNumber && userInfo.phone.length === 11) {
        return;
      }
      var _this = _this2;
      _app.appMethod.checkSession(function () {
        if (!e.detail.encryptedData) {
          return;
        }
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppUser/GetPhoneNumber',
          data: {
            encryptedData: e.detail.encryptedData || '',
            iv: e.detail.iv || ''
          },
          success: function success(res) {
            _app.appMethod.setUserInfoStorage({
              phone: res.data
            });
            _this.setData({
              'userInfo.phone': res.data,
              isGetPhoneNumber: true
            });
          },
          successStatus5: function successStatus5() {
            _app.appMethod.showModal({
              content: '获取手机号失败，请再次点击授权获取'
            });
            // app.goLogin({
            //   success: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   },
            //   fail: function() {
            //     app.showModal({
            //       content: '获取手机号失败，请再次点击授权获取'
            //     })
            //   }
            // })
          }
        });
      });
    };

    _this2.inputUserInfo = function (e) {
      var setData = {};
      if (e.currentTarget.dataset.type === 'name') {
        setData = { 'userInfo.name': e.target.value };
      } else if (e.currentTarget.dataset.type === 'phone') {
        setData = { 'userInfo.phone': e.target.value };
      }
      _this2.setData(setData);
    };

    _this2.bindBirthdayChange = function (e) {
      _this2.setData({
        'userInfo.birthday': e.target.value
      });
    };

    _this2.bindCityChange = function (e) {
      _this2.setData({
        userCityArr: e.target.value
      });
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.scratchId
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
            }
          });
        }
      });
    };

    _this2.shadeClose = function (el) {
      var _this = _this2,
          type = el.currentTarget.dataset.type;
      _app.appMethod.showModal({
        title: '提示',
        content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
        showCancel: true,
        confirm: function confirm(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: false
          });
          if (type == 1) {
            _this.winningBtnClick();
          } else if (type == 2) {
            _this.comfortBtnClick();
          }
        }
      });
    };

    _this2.config = {
      navigationBarTitleText: '支付成功'
    };

    document.title = '交易成功';
    return _this2;
  }

  (0, _createClass3.default)(TransferPaySuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var franchisee = options.franchisee || '';
      var appTitle = franchisee ? '' : _app.appMethod.getAppTitle();
      this.setData({
        appTitle: appTitle,
        franchisee: franchisee
      });
      if (franchisee) {
        this.getAppShopByPage();
      }
      this.orderId = options.detail || '';
      this.getTransferOrderConfig();
      this.getGoldenData(options.detail);
      setTimeout(function () {
        _this3.getOrderDetail();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          appTitle = _state.appTitle,
          totalPayment = _state.totalPayment,
          payInfo = _state.payInfo,
          transferConfig = _state.transferConfig,
          benefitConfig = _state.benefitConfig,
          vipCardInfo = _state.vipCardInfo,
          payActivity = _state.payActivity,
          collectBenefitData = _state.collectBenefitData,
          starData = _state.starData,
          couponList = _state.couponList,
          isRecvVipCard = _state.isRecvVipCard,
          scratchIsFail = _state.scratchIsFail,
          scratchIsPrize = _state.scratchIsPrize,
          scratchPrizeTitle = _state.scratchPrizeTitle,
          ifWxCoupon = _state.ifWxCoupon,
          scratchIsDurMax = _state.scratchIsDurMax,
          scratchIsLimit = _state.scratchIsLimit,
          scratchIsComfort = _state.scratchIsComfort,
          ifGetComfort = _state.ifGetComfort,
          scratchIsDegree = _state.scratchIsDegree,
          hideScratchCanvas = _state.hideScratchCanvas,
          scratch = _state.scratch,
          scratchIsScroll = _state.scratchIsScroll,
          isShowScratchBtn = _state.isShowScratchBtn;

      return React.createElement(
        'div',
        { className: 'official-page transfer-pay-success' },
        React.createElement(_TopNav.TopNav, { title: '\u4EA4\u6613\u6210\u529F' }),
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'top-block' },
            React.createElement('div', { className: 'success-block' }),
            React.createElement(
              'div',
              { className: 'transfer-mess' },
              React.createElement(
                'div',
                { className: 'beneficiary' },
                appTitle
              ),
              React.createElement(
                'div',
                { className: 'price-block' },
                '\xA5',
                React.createElement(
                  'span',
                  { className: 'actually-price' },
                  totalPayment
                ),
                React.createElement(
                  'span',
                  { className: 'original-price' },
                  '¥' + payInfo.original_price
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'discount-wrapper' },
              payInfo.discount_cut_price && payInfo.discount_cut_price !== '0.00' && React.createElement(
                'div',
                { className: 'discount-item' },
                React.createElement(
                  'span',
                  null,
                  '\u4F18\u60E0\u91D1\u989D'
                ),
                React.createElement(
                  'span',
                  null,
                  '-¥' + payInfo.discount_cut_price
                )
              ),
              !!+payInfo.use_balance && payInfo.use_balance !== '0.00' && React.createElement(
                'div',
                { className: 'discount-item' },
                React.createElement(
                  'span',
                  null,
                  '\u50A8\u503C\u62B5\u6263'
                ),
                React.createElement(
                  'span',
                  null,
                  '-¥' + payInfo.use_balance
                )
              ),
              payInfo.send_integral_info && !!+payInfo.send_integral_info.consume_send_integral && React.createElement(
                'div',
                { className: 'discount-item' },
                React.createElement(
                  'span',
                  null,
                  '\u83B7\u5F97\u79EF\u5206'
                ),
                React.createElement(
                  'span',
                  { className: 'count' },
                  '+' + payInfo.send_integral_info.consume_send_integral
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'btn-wrapper' },
              React.createElement(
                'div',
                {
                  className: 'btn ok-btn',
                  onClick: this.transferSuccessCallback
                },
                '\u5B8C\u6210'
              ),
              React.createElement(
                'div',
                { className: 'btn view-btn', onClick: this.goToOrderDetail },
                '\u67E5\u770B\u8BA2\u5355'
              )
            )
          ),
          payActivity && React.createElement(
            'div',
            { className: 'activity' },
            React.createElement(
              'div',
              { className: 'copyWriting' },
              React.createElement('div', { className: 'line' }),
              React.createElement(
                'span',
                { className: 'text' },
                '\u6D3B\u52A8'
              )
            ),
            (benefitConfig.type === 'coupon' || benefitConfig.type === 'vipcard_permission' && vipCardInfo.isShow || benefitConfig.type === 'integral' || benefitConfig.type === 'balance' || benefitConfig.type === 'lucky_wheel' || benefitConfig.type === 'golden_eggs') && React.createElement(
              'div',
              { className: 'get-reward-text' },
              '本次交易获得' + (benefitConfig.type === 'coupon' ? '优惠券' : benefitConfig.type === 'vipcard_permission' ? '会员卡' : benefitConfig.type === 'integral' ? '积分' : benefitConfig.type === 'balance' ? '储值金' : benefitConfig.type === 'lucky_wheel' ? '大转盘' : benefitConfig.type === 'golden_eggs' ? '砸金蛋' : '') + '奖励'
            ),
            payActivity === 'collectme' && React.createElement(
              'div',
              { className: 'collect' },
              React.createElement(
                'div',
                { className: 'text' },
                '集集乐个数: ' + collectBenefitData.star_num
              ),
              React.createElement(
                'div',
                {
                  className: 'star-block ' + (starData && starData.length === 6 ? 'star-six' : '')
                },
                starData.map(function (item, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    item == 'light' ? React.createElement('img', {
                      className: 'star',
                      src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/start@2x.png'
                    }) : item == 'dark' && React.createElement('img', {
                      className: 'star',
                      src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/star-empty@2x.png'
                    })
                  );
                })
              ),
              collectBenefitData.star_num == collectBenefitData.collect_num && React.createElement(
                'div',
                { className: 'star-full' },
                React.createElement(
                  'div',
                  { className: 'star-full-text' },
                  '\u6EE1'
                )
              ),
              React.createElement(
                'div',
                { className: 'about' },
                '消费满' + collectBenefitData.value + '元，累计一颗心，积满可获得优惠券' + collectBenefitData.coupon_title + '一张'
              )
            ),
            payActivity === 'coupon' && React.createElement(
              'div',
              { className: 'coupon' },
              couponList.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'coupon-item', key: item.id },
                  React.createElement(
                    'div',
                    { className: 'info' },
                    React.createElement(
                      'div',
                      { className: 'coupon-title' },
                      item.title
                    ),
                    item.type == 0 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      '使用条件：满' + item.condition + '元，减' + item.value + '元'
                    ),
                    item.type == 1 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      '使用条件: 打' + item.value + '折'
                    ),
                    item.type == 2 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      '使用条件：可抵扣' + item.value + '元'
                    ),
                    item.type == 3 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      item.extra_condition == '' ? React.createElement(
                        'span',
                        null,
                        '使用条件: 直接兑换' + item.coupon_goods_info.title
                      ) : item.extra_condition.price ? React.createElement(
                        'span',
                        null,
                        '使用条件: 消费满' + item.extra_condition.price + '元可兑换' + item.coupon_goods_info.title
                      ) : item.extra_condition.goods_id && React.createElement(
                        'span',
                        null,
                        '使用条件: 购买' + item.condition_goods_info.title + '可兑换' + item.coupon_goods_info.title
                      )
                    ),
                    item.type == 4 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      '使用条件: 储值金可充值' + item.value + '元'
                    ),
                    item.type == 5 && React.createElement(
                      'div',
                      { className: 'use-condition' },
                      '使用条件: ' + item.extra_condition
                    ),
                    couponList.length === 1 && React.createElement(
                      'div',
                      {
                        className: 'pending-btn2',
                        'data-couponid': item.id
                      },
                      '\u5DF2\u9886\u53D6'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'background-word-area' },
                    React.createElement('div', { className: 'background-circle' }),
                    item.type == 0 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u51CF'
                    ),
                    item.type == 1 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u6298'
                    ),
                    item.type == 2 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u4EE3'
                    ),
                    item.type == 3 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u5151'
                    ),
                    item.type == 4 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u50A8'
                    ),
                    item.type == 5 && React.createElement(
                      'div',
                      { className: 'background-word' },
                      '\u901A'
                    )
                  )
                );
              })
            ),
            payActivity === 'vipcard_permission' && vipCardInfo.isShow && React.createElement(
              'div',
              {
                className: 'vip-card',
                style: (0, _tools.convertLineStyleData)('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-default.png)')
              },
              React.createElement('img', {
                className: 'card-img',
                src: vipCardInfo.logo ? vipCardInfo.logo : 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/default-vip-card-logo.png'
              }),
              React.createElement(
                'div',
                { className: 'card-info' },
                React.createElement(
                  'div',
                  { className: 'card-name' },
                  vipCardInfo.app_name + ' ' + vipCardInfo.title
                ),
                vipCardInfo.discount != 0 ? React.createElement(
                  'div',
                  { className: 'card-mess' },
                  '开卡可享 ' + vipCardInfo.discount + '折'
                ) : vipCardInfo.coupon_list && vipCardInfo.coupon_list != '' ? React.createElement(
                  'div',
                  { className: 'card-mess' },
                  '\u5F00\u5361\u53EF\u4EAB \u8D60\u9001\u4F18\u60E0\u5238'
                ) : vipCardInfo.integral != 0 && React.createElement(
                  'div',
                  { className: 'card-mess' },
                  '开卡可享 赠送' + vipCardInfo.integral + '积分'
                )
              ),
              !isRecvVipCard && React.createElement(
                'div',
                { className: 'card-btn', onClick: this.handleVipCard },
                '\u7ACB\u5373\u5F00\u5361'
              ),
              isRecvVipCard && React.createElement(
                'div',
                { className: 'card-btn', onClick: this.goToUserCenter },
                '\u7ACB\u5373\u4F7F\u7528'
              )
            ),
            payActivity === 'integral' && React.createElement(
              'div',
              { className: 'integral' },
              React.createElement(
                'div',
                { className: 'integral-block' },
                React.createElement(
                  'div',
                  { className: 'text' },
                  '\u83B7\u5F97\u989D\u5916\u79EF\u5206'
                ),
                React.createElement(
                  'div',
                  { className: 'num' },
                  '+' + payInfo.send_integral_info.pay_success_benefit_send_integral
                )
              )
            ),
            payActivity === 'balance' && React.createElement(
              'div',
              { className: 'recharge' },
              React.createElement(
                'div',
                { className: 'recharge-block' },
                React.createElement(
                  'div',
                  { className: 'text' },
                  '\u83B7\u5F97\u989D\u5916\u50A8\u503C\u91D1'
                ),
                React.createElement(
                  'div',
                  { className: 'num' },
                  '+' + benefitConfig.balance
                )
              )
            ),
            payActivity === 'lucky_wheel' && React.createElement(
              'div',
              { className: 'turntable', onClick: this.goToWheelDetail },
              React.createElement(
                'div',
                { className: 'tip' },
                '\u7ACB\u5373\u524D\u5F80'
              )
            ),
            payActivity === 'golden_eggs' && React.createElement(
              'div',
              { className: 'gold-egg', onClick: this.goToGoldenEggs },
              React.createElement(
                'div',
                { className: 'tip' },
                '\u7ACB\u5373\u524D\u5F80'
              )
            ),
            payActivity === 'scratch_card' && React.createElement(
              'div',
              { id: 'scratch' },
              React.createElement(
                'div',
                { className: 'scratchFail', hidden: scratchIsFail },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png' }),
                React.createElement(
                  'div',
                  { className: 'failTitle' },
                  React.createElement(
                    'div',
                    { className: 'failText' },
                    '\u5F88\u9057\u61BE\u6CA1\u6709\u4E2D\u5956\u54E6'
                  ),
                  React.createElement(
                    'div',
                    { className: 'failBtn', onClick: this.failBtnClick },
                    '\u518D\u6765\u4E00\u6B21'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchWinning', hidden: scratchIsPrize },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg2.png' }),
                React.createElement(
                  'div',
                  { className: 'winningTitle' },
                  React.createElement(
                    'div',
                    { className: 'winningText' },
                    '\u606D\u559C\u4F60\u83B7\u5F97\u4E86'
                  ),
                  React.createElement(
                    'div',
                    { className: 'winningText winningValue' },
                    scratchPrizeTitle
                  ),
                  ifWxCoupon ? React.createElement(
                    'div',
                    { className: 'btnGroup' },
                    React.createElement(
                      'div',
                      { className: 'winningBtn', onClick: this.toAddCard },
                      '\u7ACB\u5373\u9886\u53D6'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'winningBtn',
                        onClick: this.shadeClose,
                        'data-type': '1'
                      },
                      '\u518D\u6765\u4E00\u6B21'
                    )
                  ) : React.createElement(
                    'div',
                    {
                      className: 'winningBtn',
                      onClick: this.winningBtnClick
                    },
                    '\u518D\u6765\u4E00\u6B21'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchDurMax', hidden: !scratchIsDurMax },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png' }),
                React.createElement(
                  'div',
                  { className: 'durMaxTitle' },
                  React.createElement(
                    'div',
                    { className: 'durMaxText' },
                    '\u5BF9\u4E0D\u8D77\uFF0C\u60A8\u7684\u522E\u5956\u6B21\u6570\u4E0D\u8DB3\uFF0C'
                  ),
                  React.createElement(
                    'div',
                    { className: 'durMaxText' },
                    '\u5206\u4EAB\u5373\u53EF\u83B7\u53D6\u6B21\u6570\u54E6~'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchLimit', hidden: !scratchIsLimit },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png' }),
                React.createElement(
                  'div',
                  { className: 'limitTitle' },
                  React.createElement(
                    'div',
                    { className: 'limitText' },
                    '\u4ECA\u65E5\u522E\u5956\u6B21\u6570\u5DF2\u8FBE\u5230\u4E0A\u9650\uFF0C'
                  ),
                  React.createElement(
                    'div',
                    { className: 'limitText' },
                    '\u660E\u65E5\u53EF\u7EE7\u7EED\u53C2\u4E0E\u522E\u5956\u54E6~'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchComfort', hidden: scratchIsComfort },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg2.png' }),
                React.createElement(
                  'div',
                  { className: 'comfortTitle' },
                  ifGetComfort ? React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                  ) : React.createElement(
                    'div',
                    (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                    '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                  ),
                  !ifWxCoupon && !ifGetComfort && React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '>\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                  ),
                  ifWxCoupon ? React.createElement(
                    'div',
                    { className: 'btnGroup' },
                    React.createElement(
                      'div',
                      { className: 'comfortBtn', onClick: this.toAddCard },
                      '\u7ACB\u5373\u9886\u53D6'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'comfortBtn',
                        onClick: this.shadeClose,
                        'data-type': '2'
                      },
                      '\u77E5\u9053\u4E86'
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    !ifGetComfort && React.createElement(
                      'div',
                      { className: 'comfortText' },
                      '\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'comfortBtn',
                        onClick: this.comfortBtnClick
                      },
                      '\u77E5\u9053\u4E86'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchDegree', hidden: !scratchIsDegree },
                React.createElement('img', { src: 'http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png' }),
                React.createElement(
                  'div',
                  { className: 'degreeTitle' },
                  React.createElement(
                    'div',
                    { className: 'degreeText' },
                    '\u5BF9\u4E0D\u8D77\uFF0C\u60A8\u672C\u6B21\u83B7\u53D6\u7684\u522E\u5956\u6B21\u6570\u4E0D\u8DB3'
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  hidden: hideScratchCanvas,
                  className: 'scratch_wp',
                  style: (0, _tools.convertLineStyleData)('width: ' + scratch.width + 'px; height: ' + scratch.height + 'px;')
                },
                React.createElement('canvas', {
                  className: 'scratch-canvas',
                  width: scratch && scratch.width,
                  height: scratch && scratch.height,
                  id: 'scratch-canvas',
                  onTouchStart: this.touchStart,
                  onTouchMove: this.touchMove,
                  onTouchEnd: this.touchEnd
                }),
                isShowScratchBtn && React.createElement(
                  'div',
                  { className: 'showArea' },
                  React.createElement(
                    'div',
                    { className: 'showTitle' },
                    '\u8D62\u53D6\u4F18\u60E0\u5927\u5956'
                  ),
                  React.createElement(
                    'div',
                    { className: 'showBtn', onClick: this.showAreaClick },
                    '\u70B9\u6211\u522E\u5956'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TransferPaySuccess;
}(_OfficialPage3.default);

exports.default = TransferPaySuccess;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(510);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyGroup = function (_OfficialPage) {
  (0, _inherits3.default)(MyGroup, _OfficialPage);

  function MyGroup(props) {
    (0, _classCallCheck3.default)(this, MyGroup);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (MyGroup.__proto__ || Object.getPrototypeOf(MyGroup)).call(this, props));

    _this2.state = {
      list: [],
      param: {
        page: 1,
        page_size: 5,
        is_leader_order: 1,
        current_status: 0
      },
      isLeader: 1,
      status: 0,
      noMore: false
    };

    _this2.getMyGroupBuy = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/MyGroupBuy',
        data: _this.data.param,
        success: function success(data) {
          _this.setData({ list: data.data });
        }
      });
    };

    _this2.onShareAppMessage = function (e) {
      var that = _this2,
          url = '/pages/myGroup/myGroup',
          title = '',
          imageUrl = '';
      if (e.from == 'button') {
        var index = e.target.dataset.index,
            info = _this2.data.list[index],
            groupInfo = info.form_data.group_buy_order_info,
            teamToken = info.team_token,
            goodsInfo = info.form_data.goods_info[0],
            franchisee = info.app_id == _app.appMethod.getAppId() ? '' : '&franchisee=' + info.app_id;
        url = '/joinGroupDetail?detail=' + groupInfo.goods_id + '&teamToken=' + teamToken + franchisee + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : '');
        title = _app.appMethod.getUserInfo('nickname') + ' 喊你拼单啦~ ' + goodsInfo.price + '元拼' + goodsInfo.goods_name + '，火爆抢购中......';
        imageUrl = 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg';
      }
      return _app.appMethod.shareAppMessage({
        title: title,
        path: url,
        imageUrl: imageUrl,
        success: function success(addTime) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    _this2.getGroupOrders = function (e) {
      _this2.setData({ isLeader: e.currentTarget.dataset.status });
      _this2.setData({
        'param.page': 1,
        'param.current_status': 0,
        'param.is_leader_order': e.currentTarget.dataset.status
      });
      _this2.setData({ status: 0, noMore: false });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/MyGroupBuy',
        data: _this.data.param,
        success: function success(data) {
          _this.setData({ list: data.data });
        }
      });
    };

    _this2.getGroupOrderByStatus = function (e) {
      _this2.setData({
        'param.page': 1,
        'param.current_status': e.currentTarget.dataset.status
      });
      _this2.setData({ status: e.currentTarget.dataset.status });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/MyGroupBuy',
        data: _this.data.param,
        success: function success(data) {
          _this.setData({ list: data.data });
        }
      });
    };

    _this2.turnToDetail = function (e) {
      var id = e.currentTarget.dataset.orderid;
      var franchiseeId = e.currentTarget.dataset.franchisee;
      var queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + id + queryStr);
    };

    _this2.getMore = function (e) {
      console.warn('more');
      if (e.target.dataset.page !== _this2.data.param.page) {
        return;
      }
      if (_this2.data.noMore) {
        return;
      }
      var _this = _this2;
      _this2.data.param.page = e.target.dataset.page + 1;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/MyGroupBuy',
        data: _this.data.param,
        success: function success(data) {
          if (data.is_more == 0) {
            _this.setData({ noMore: true });
          }
          if (data.data.length != 0) {
            var list = _this.data.list.concat(data.data);
            _this.setData({ list: list });
            _this.setData({ 'param.page': _this.data.param.page });
          }
        }
      });
    };

    _this2.retrieveMoney = function (e) {
      var _this = _this2;
      var franchiseeId = e.currentTarget.dataset.franchisee;
      franchiseeId = franchiseeId === _app.appMethod.getAppId() ? '' : franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ComfirmRefund',
        data: {
          order_id: e.target.dataset.id,
          sub_shop_app_id: franchiseeId
        },
        success: function success(data) {
          if (data.status === 0) {
            _app.appMethod.showToast({
              title: '确认成功'
            });
            _this.componentWillMount();
          }
        }
      });
    };

    _this2.onceMore = function (e) {
      var id = e.currentTarget.dataset.id;
      var franchiseeId = e.currentTarget.dataset.franchisee;
      var queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/pages/groupGoodsDetail/groupGoodsDetail?detail=' + id + queryStr);
    };

    _this2.pay = function (e) {
      var _this = _this2;
      var franchiseeId = e.currentTarget.dataset.franchisee;
      franchiseeId = franchiseeId === _app.appMethod.getAppId() ? '' : franchiseeId;
      var queryStr = franchiseeId ? '' : '&franchisee=' + franchiseeId;
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: e.target.dataset.id,
      //     sub_shop_app_id: franchiseeId
      //   },
      //   success: function(res) {
      //     var param = res.data,
      //       orderId = e.target.dataset.id
      //     param.orderId = orderId
      //     param.goodsType = e.target.dataset.type
      //     param.success = function() {
      //       setTimeout(function() {
      //         app.turnToPage(
      //           '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' +
      //           orderId +
      //           queryStr
      //         )
      //       }, 1500)
      //     }
      //     app.wxPay(param)
      //   }
      // })
      _app.appMethod.goPay({
        orderId: e.target.dataset.id,
        franchisee: franchiseeId,
        successUrl: '/groupOrderDetail?id=' + orderId + queryStr
      });
    };

    _this2.goToOrderDetail = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/myOrder/myOrder');
    };

    _this2.cancelOrder = function (e) {
      var that = _this2;
      var franchiseeId = e.currentTarget.dataset.franchisee;
      franchiseeId = franchiseeId === _app.appMethod.getAppId() ? '' : franchiseeId;
      _app.appMethod.showModal({
        content: '是否取消拼团？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/CancelOrder',
            data: {
              order_id: e.target.dataset.id,
              sub_app_id: franchiseeId
            },
            success: function success(res) {
              console.log(res);
              that.componentWillMount();
            }
          });
        }
      });
    };

    document.title = '我的拼团';
    return _this2;
  }

  (0, _createClass3.default)(MyGroup, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var _this = this;
      _app.appMethod.globalData.myGroupRefresh = false;
      _this.getMyGroupBuy();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.globalData.myGroupRefresh) {
        this.setData({
          param: {
            page: 1,
            page_size: 5,
            is_leader_order: 1,
            current_status: 0
          }
        });
        this.getMyGroupBuy();
        _app.appMethod.globalData.myGroupRefresh = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          isLeader = _state.isLeader,
          status = _state.status,
          param = _state.param,
          list = _state.list;

      return React.createElement(
        'div',
        { className: 'official-page my-group' },
        React.createElement(_TopNav.TopNav, { title: '\u6211\u7684\u62FC\u56E2' }),
        React.createElement(
          'div',
          { className: 'wrap' },
          React.createElement(
            'div',
            { className: 'tabs' },
            React.createElement(
              'div',
              {
                className: 'content ' + (isLeader == 1 ? ' active-tab' : ''),
                'data-status': '1',
                onClick: this.getGroupOrders
              },
              '\u6211\u53D1\u8D77\u7684\u56E2'
            ),
            React.createElement(
              'div',
              {
                className: 'content ' + (isLeader == 0 ? ' active-tab' : ''),
                'data-status': '0',
                onClick: this.getGroupOrders
              },
              '\u6211\u53C2\u4E0E\u7684\u56E2'
            )
          ),
          React.createElement(
            _ScrollView.ScrollView,
            { className: 'sub-tabs', 'scroll-x': 'true' },
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 0 ? ' active-sub-tab' : ''),
                'data-status': '0',
                onClick: this.getGroupOrderByStatus
              },
              '\u5168\u90E8'
            ),
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 1 ? ' active-sub-tab' : ''),
                'data-status': '1',
                hidden: isLeader == 0,
                onClick: this.getGroupOrderByStatus
              },
              '\u672A\u5F00\u56E2'
            ),
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 2 ? ' active-sub-tab' : ''),
                'data-status': '2',
                onClick: this.getGroupOrderByStatus
              },
              '\u62FC\u56E2\u4E2D'
            ),
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 3 ? ' active-sub-tab' : ''),
                'data-status': '3',
                onClick: this.getGroupOrderByStatus
              },
              '\u62FC\u56E2\u6210\u529F'
            ),
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 4 ? ' active-sub-tab' : ''),
                'data-status': '4',
                onClick: this.getGroupOrderByStatus
              },
              '\u62FC\u56E2\u5931\u8D25'
            ),
            React.createElement(
              'div',
              {
                className: 'status ' + (status == 5 ? ' active-sub-tab' : ''),
                'data-status': '5',
                onClick: this.getGroupOrderByStatus
              },
              '\u5DF2\u5173\u95ED'
            )
          ),
          React.createElement(
            _ScrollView.ScrollView,
            {
              className: 'list',
              'scroll-y': 'true',
              'data-page': param.page,
              bindscrolltolower: this.getMore,
              'enable-back-to-top': 'true'
            },
            list.map(function (item, index) {
              return React.createElement(
                'div',
                { className: 'orders', key: index },
                React.createElement(
                  'div',
                  { className: 'head' },
                  React.createElement(
                    'div',
                    { className: 'order-time' },
                    '下单时间:' + item.add_time
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'order-status',
                      hidden: !(item.form_data.group_buy_order_info.current_status == 1)
                    },
                    '\u672A\u5F00\u56E2'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'order-status',
                      hidden: !(item.form_data.group_buy_order_info.current_status == 2)
                    },
                    '\u62FC\u56E2\u4E2D'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'order-status',
                      hidden: !(item.form_data.group_buy_order_info.current_status == 3)
                    },
                    '\u62FC\u56E2\u6210\u529F'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'order-status',
                      hidden: !(item.form_data.group_buy_order_info.current_status == 4)
                    },
                    '\u62FC\u56E2\u5931\u8D25'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'order-status',
                      hidden: !(item.form_data.group_buy_order_info.current_status == 5)
                    },
                    '\u5DF2\u5173\u95ED'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'goods-detail',
                    'data-orderid': item.order_id,
                    'data-franchisee': item.app_id,
                    onClick: _this3.turnToDetail
                  },
                  React.createElement(
                    'div',
                    { className: 'goods-wrap' },
                    React.createElement('img', { src: item.form_data.goods_info[0].cover }),
                    React.createElement(
                      'div',
                      { className: 'middle' },
                      React.createElement(
                        'div',
                        { className: 'goods-name' },
                        item.form_data.goods_info[0].goods_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-spec' },
                        item.form_data.goods_info[0].model_value
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'price' },
                      React.createElement(
                        'div',
                        { className: 'pay-price' },
                        '¥' + item.form_data.goods_info[0].price
                      ),
                      React.createElement(
                        'div',
                        { className: 'origin-price' },
                        '¥' + item.form_data.original_price
                      ),
                      React.createElement(
                        'div',
                        { className: 'num' },
                        'x' + item.form_data.goods_info[0].num
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'group-info' },
                    React.createElement(
                      'div',
                      { className: 'info' },
                      '团长昵称：' + item.form_data.group_buy_order_info.leader_username
                    ),
                    React.createElement(
                      'div',
                      { className: 'info' },
                      '拼团进度：' + item.form_data.group_buy_order_info.max_user_num + '人团|已拼' + item.form_data.group_buy_order_info.current_user_count + '人，还差' + (item.form_data.group_buy_order_info.max_user_num - item.form_data.group_buy_order_info.current_user_count) + '人成团'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'info ' + (item.form_data.group_buy_order_info.current_status == 1 || item.form_data.group_buy_order_info.current_status == 5 ? 'hide' : '')
                      },
                      '结束时间：' + item.form_data.group_buy_order_info.expired_time
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'order-info' },
                  '共' + item.form_data.goods_info[0].num + '件商品 合计：¥',
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:30rpx;') },
                    item.total_price
                  ),
                  '(含运费¥' + item.express_fee + ')'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'order-btn',
                    hidden: !(item.form_data.group_buy_order_info.current_status == 1)
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn white',
                      'data-id': item.order_id,
                      'data-franchisee': item.app_id,
                      onClick: _this3.cancelOrder
                    },
                    '\u53D6\u6D88\u62FC\u56E2'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn red',
                      'data-id': item.order_id,
                      'data-type': item.goods_type,
                      'data-franchisee': item.app_id,
                      onClick: _this3.pay
                    },
                    '\u7ACB\u5373\u652F\u4ED8'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'order-btn',
                    hidden: !(item.form_data.group_buy_order_info.current_status == 2)
                  },
                  React.createElement(
                    'button',
                    {
                      openType: 'share',
                      className: 'group-btn red',
                      'data-detail': item.form_data.goods_info[0].goods_id,
                      'data-franchisee': item.app_id,
                      'data-index': index,
                      onClick: _this3.shareClickEvent
                    },
                    '\u5206\u4EAB'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'order-btn',
                    hidden: !(item.form_data.group_buy_order_info.current_status == 3)
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn white',
                      'data-franchisee': item.app_id,
                      onClick: _this3.goToOrderDetail
                    },
                    '\u67E5\u770B\u8BA2\u5355'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn yellow',
                      'data-id': item.form_data.goods_info[0].goods_id,
                      'data-franchisee': item.app_id,
                      onClick: _this3.onceMore
                    },
                    '\u518D\u62FC\u4E00\u6B21'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'order-btn',
                    hidden: !(item.form_data.group_buy_order_info.current_status == 4)
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn white',
                      'data-id': item.order_id,
                      'data-franchisee': item.app_id,
                      onClick: _this3.retrieveMoney
                    },
                    '\u5DF2\u6536\u5230\u9000\u6B3E'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn yellow',
                      'data-id': item.form_data.goods_info[0].goods_id,
                      'data-franchisee': item.app_id,
                      onClick: _this3.onceMore
                    },
                    '\u518D\u62FC\u4E00\u6B21'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'order-btn',
                    hidden: !(item.form_data.group_buy_order_info.current_status == 5)
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'group-btn yellow',
                      'data-id': item.form_data.goods_info[0].goods_id,
                      'data-franchisee': item.app_id,
                      onClick: _this3.onceMore
                    },
                    '\u518D\u62FC\u4E00\u6B21'
                  )
                )
              );
            }),
            React.createElement(
              'div',
              { className: 'no-more' },
              '\u6CA1\u6709\u66F4\u591A\u6570\u636E\u4E86~'
            )
          )
        )
      );
    }
  }]);
  return MyGroup;
}(_OfficialPage3.default);

exports.default = MyGroup;

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(512);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewAppointmentOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewAppointmentOrder, _OfficialPage);

  function PreviewAppointmentOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewAppointmentOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewAppointmentOrder.__proto__ || Object.getPrototypeOf(PreviewAppointmentOrder)).call(this, props));

    _this2.state = {
      goodsList: [],
      selectAddress: {},
      appointment_user_name: '',
      appointment_user_phone: '',
      discountList: [],
      selectDiscountInfo: {},
      selectDiscountIndex: '',
      orderRemark: '',
      is_self_delivery: 0,
      express_fee: '',
      balance: '',
      useBalance: true,
      deduction: '',
      discount_cut_price: '',
      original_price: '',
      totalPayment: '',
      shopAddress: '',
      noAdditionalInfo: true,
      is_group: '',
      to_store: '',
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      }
    };
    _this2.isFromSelectAddress = false;
    _this2.hasRequiredSuppInfo = false;
    _this2.franchisee_id = '';
    _this2.cart_id_arr = [];
    _this2.cart_data_arr = [];
    _this2.requesting = false;
    _this2.additional_info = {};
    _this2.is_group = '';

    _this2.dataInitial = function () {
      _this2.getCalculationInfo();
      _this2.getShopAddress();
      _this2.getCartList();
    };

    _this2.getCartList = function () {
      var that = _this2,
          franchisee_id = _this2.franchisee_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: franchisee_id,
          parent_shop_app_id: franchisee_id ? _app.appMethod.globalData.appId : ''
        },
        success: function success(res) {
          var data = [];
          var startDate, endDate, service_period, intervalDate;
          if (that.cart_id_arr.length) {
            for (var i = 0; i <= res.data.length - 1; i++) {
              if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
                data.push(res.data[i]);
              }
            }
          } else {
            data = res.data;
          }
          for (var i = 0; i <= data.length - 1; i++) {
            var goods = data[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? '(' + modelArr.join('|') + ')' : '';
            that.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
          }
          startDate = {
            month: data[0].appointment_start.substring(4, 6),
            day: data[0].appointment_start.substring(6, 8),
            hours: data[0].appointment_start.substring(8)
          };
          endDate = {
            month: data[0].appointment_end.substring(4, 6),
            day: data[0].appointment_end.substring(6, 8),
            hours: data[0].appointment_end.substring(8)
          };
          intervalDate = endDate.day > startDate.day || endDate.month > startDate.month ? endDate.month + '月' + endDate.day + '日' : '当日';
          service_period = startDate.month + '月' + startDate.day + '日 ' + startDate.hours + ' - ' + intervalDate + endDate.hours;
          that.setData({
            goodsList: data,
            service_period: service_period
          });
        }
      });
    };

    _this2.getCalculationInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          address_id: _this2.data.selectAddress.id,
          cart_id_arr: _this2.cart_id_arr,
          is_balance: _this2.data.useBalance ? 1 : 0,
          is_self_delivery: _this2.data.is_self_delivery,
          selected_benefit: _this2.data.selectDiscountInfo,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info
        },
        success: function success(res) {
          var info = res.data,
              benefits = info.can_use_benefit.data,
              goods_info = info.goods_info,
              need_user_address = goods_info[0].appointment_info.need_user_address,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              suppInfoArr = [],
              selectDiscountIndex,
              selectDiscountInfo;
          if (benefits && benefits.length) {
            benefits.unshift({
              title: '不使用优惠',
              name: '无',
              no_use_benefit: 1
            });
          }
          if (_this.data.selectDiscountInfo && _this.data.selectDiscountInfo.no_use_benefit == 1) {
            selectDiscountInfo = _this.data.selectDiscountInfo;
            selectDiscountIndex = 0;
          } else {
            selectDiscountInfo = info.selected_benefit_info;
            if (selectDiscountInfo && selectDiscountInfo.discount_type) {
              for (var i = 0; i <= benefits.length - 1; i++) {
                if (selectDiscountInfo.discount_type === benefits[i].discount_type) {
                  if (selectDiscountInfo.discount_type === 'coupon') {
                    if (selectDiscountInfo.coupon_id === benefits[i].coupon_id) {
                      selectDiscountIndex = i;
                      break;
                    }
                  } else {
                    selectDiscountIndex = i;
                    break;
                  }
                }
              }
              if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && _this.data.exchangeCouponData.hasSelectGoods == false) {
                _this.exchangeCouponInit(parseInt(selectDiscountInfo.value));
              }
            }
          }
          for (var i = 0; i <= goods_info.length - 1; i++) {
            if (goods_info[i].delivery_id && goods_info[i].delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info[i].id) == -1) {
              suppInfoArr.push(goods_info[i].delivery_id);
              additional_goodsid_arr.push(goods_info[i].id);
              additional_info_goods.push(goods_info[i]);
            }
          }
          _this.setData({
            selectAddress: info.address || {},
            discountList: benefits || [],
            selectDiscountIndex: selectDiscountIndex || '',
            selectDiscountInfo: selectDiscountInfo || '',
            express_fee: info.express_fee,
            discount_cut_price: info.discount_cut_price,
            balance: info.balance,
            deduction: info.use_balance,
            original_price: info.original_price || '免费',
            totalPayment: info.price,
            noAdditionalInfo: suppInfoArr.length ? false : true,
            need_user_address: need_user_address
          });
          if (suppInfoArr.length && !_this.hasRequiredSuppInfo) {
            _this.getSuppInfo(suppInfoArr);
          }
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          setTimeout(function () {
            _app.appMethod.turnBack();
          }, 2000);
        }
      });
    };

    _this2.getShopAddress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        success: function success(res) {
          that.setData({
            shopAddress: res.data
          });
        }
      });
    };

    _this2.remarkInput = function (e) {
      var value = e.target.value;
      _this2.setData({
        orderRemark: value
      });
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goods = _this2.data.goodsList[index];
      if (+goods.num <= 0) return;
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.changeGoodsNum = function (index, type) {
      var goods = _this2.data.goodsList[index],
          currentNum = +goods.num,
          targetNum = type == 'plus' ? currentNum + 1 : currentNum - 1,
          that = _this2,
          data = {},
          param;
      if (targetNum == 0 && type == 'minus') {
        _app.appMethod.showModal({
          content: '确定从购物车删除该商品？',
          showCancel: true,
          confirm: function confirm() {
            that.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            that.setData(data);
            that.deleteGoods(index);
          }
        });
        return;
      }
      param = {
        goods_id: goods.goods_id,
        model_id: goods.model_id || '',
        num: targetNum,
        sub_shop_app_id: that.franchisee_id,
        is_seckill: goods.is_seckill == 1 ? 1 : ''
      };
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          that.cart_data_arr[index].num = targetNum;
          data['goodsList[' + index + '].num'] = targetNum;
          data.selectDiscountInfo = '';
          that.setData(data);
          that.getCalculationInfo();
        },
        fail: function fail(res) {
          data = {};
          that.cart_data_arr[index].num = currentNum;
          data['goodsList[' + index + '].num'] = currentNum;
          that.setData(data);
        }
      });
    };

    _this2.deleteGoods = function (index) {
      var goodsList = _this2.data.goodsList,
          that = _this2,
          listExcludeDelete;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [_this2.cart_data_arr[index].cart_id],
          sub_shop_app_id: _this2.franchisee_id
        },
        success: function success(res) {
          ;(listExcludeDelete = goodsList.concat([])).splice(index, 1);
          if (listExcludeDelete.length == 0) {
            _app.appMethod.turnBack();
            return;
          }
          var deleteGoodsId = goodsList[index],
              noSameGoodsId = true;
          for (var i = listExcludeDelete.length - 1; i >= 0; i--) {
            if (listExcludeDelete[i].id == deleteGoodsId) {
              noSameGoodsId = false;
              break;
            }
          }
          if (noSameGoodsId) {
            delete that.additional_info[deleteGoodsId];
          }
          that.cart_data_arr.splice(index, 1);
          that.setData({
            goodsList: listExcludeDelete,
            selectDiscountInfo: ''
          });
          that.getCalculationInfo();
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var list = _this2.data.goodsList,
          that = _this2,
          selected_benefit = _this2.data.selectDiscountInfo,
          hasWritedAdditionalInfo = false;
      if (_this2.data.need_user_address != '0' && _this2.data.is_self_delivery == 0 && !_this2.data.selectAddress.id) {
        _app.appMethod.showModal({
          content: '请添加个人信息'
        });
        return;
      }
      for (var key in _this2.additional_info) {
        if (key !== undefined) {
          hasWritedAdditionalInfo = true;
          break;
        }
      }
      if (_this2.data.need_user_address == '0' && !(_this2.data.appointment_user_phone && _this2.data.appointment_user_name)) {
        _app.appMethod.showModal({
          content: '请填写个人信息'
        });
        return;
      }
      if (that.hasRequiredSuppInfo) {
        _app.appMethod.showModal({
          content: '请填写商品补充信息'
        });
        return;
      }
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: {
          cart_arr: _this2.cart_data_arr,
          formId: e.detail.formId,
          sub_shop_app_id: _this2.franchisee_id,
          selected_benefit: selected_benefit,
          is_balance: _this2.data.useBalance ? 1 : 0,
          is_self_delivery: _this2.data.is_self_delivery,
          remark: _this2.data.orderRemark,
          address_id: _this2.data.selectAddress.id,
          additional_info: _this2.additional_info,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info,
          appointment_to_store_time: _this2.data.to_store,
          appointment_user_phone: _this2.data.appointment_user_phone,
          appointment_user_name: _this2.data.appointment_user_name
        },
        success: function success(res) {
          that.payOrder(res.data);
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var that = _this2;
      function paySuccess() {
        var pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&code=code';
        if (!that.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_app_id: that.franchisee_id
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              _app.appMethod.turnToPage(pagePath, 1);
            }
          });
        } else {
          _app.appMethod.turnToPage(pagePath, 1);
        }
      }
      function payFail() {
        _app.appMethod.turnToPage('/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' + orderId, 1);
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.goodsType = 1
      //     param.success = paySuccess
      //     param.fail = payFail
      //     that.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })

      var pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&code=code';
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: pagePath,
        failUrl: '/appointmentOrderDetail?detail=' + orderId,
        cancel: payFail
      });
    };

    _this2.discountChange = function (checked) {
      console.log(checked);
      var index = checked[0];
      _this2.setData({
        selectDiscountInfo: _this2.data.discountList[index],
        selectDiscountIndex: index,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.goToMyAddress = function () {
      var addressId = _this2.data.selectAddress.id;
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId + '&need_address=' + _this2.data.need_user_address);
    };

    _this2.appointmentUserName = function (e) {
      _this2.setData({
        appointment_user_name: e.target.value
      });
    };

    _this2.appointmentUserPhone = function (e) {
      _this2.setData({
        appointment_user_phone: e.target.value
      });
    };

    _this2.showAddAddress = function () {
      var _this = _this2;
      _this2.isFromSelectAddress = true;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.dataInitial();
            }
          });
        },
        fail: function fail() {
          _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress');
        }
      });
    };

    _this2.makeStorePhoneCall = function () {
      _app.appMethod.makePhoneCall(_this2.data.shopAddress.shop_contact);
    };

    _this2.openStoreLocation = function () {
      var infor = _this2.data.shopAddress.region_string + _this2.data.shopAddress.shop_location;
      infor = infor.replace(/\s/g, '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
        data: {
          location_info: infor
        },
        success: function success(res) {
          if (res.result) {
            _app.appMethod.openLocation({
              latitude: res.result.location.lat,
              longitude: res.result.location.lng
            });
          }
        }
      });
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        useBalance: checked
      });
      _this2.getCalculationInfo();
    };

    _this2.deliveryWayChange = function (e) {
      _this2.setData({
        is_self_delivery: e.target.value
      });
      _this2.getCalculationInfo();
    };

    _this2.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this2.additional_info);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
    };

    _this2.exchangeCouponInit = function (id) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: id
        },
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          _this.setData({
            'exchangeCouponData.dialogHidden': false, // 显示模态框
            'exchangeCouponData.goodsInfo': goods,
            'exchangeCouponData.selectModelInfo': selectModelInfo
          });
        }
      });
    };

    _this2.exchangeCouponHideDialog = function () {
      _this2.setData({
        selectDiscountInfo: _this2.data.discountList[0],
        selectDiscountIndex: 0,
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.exchangeCouponSelectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.exchangeCouponData.selectModelInfo.models,
          model = _this2.data.exchangeCouponData.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['exchangeCouponData.selectModelInfo.models'] = selectModels;
      data['exchangeCouponData.selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.exchangeCouponResetSelectCountPrice();
    };

    _this2.exchangeCouponResetSelectCountPrice = function () {
      var _this = _this2,
          selectModelIds = _this2.data.exchangeCouponData.selectModelInfo.models.join(','),
          modelItems = _this2.data.exchangeCouponData.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
          data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
          data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
          data['exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.exchangeCouponConfirmGoods = function () {
      var _this = _this2;
      var goodsInfo = _this.data.exchangeCouponData.goodsInfo;
      var model = goodsInfo.model;
      var selectModels = _this.data.exchangeCouponData.selectModelInfo.models;
      var model_value_str = '';
      if (selectModels.length > 0) {
        model_value_str = '(';
        for (var i = 0; i < selectModels.length; i++) {
          var selectSubModelId = model[i].subModelId;
          for (var j = 0; j < selectSubModelId.length; j++) {
            if (selectModels[i] == selectSubModelId[j]) {
              model_value_str += model[i].subModelName[j] + '|';
            }
          }
        }
        model_value_str += ')';
      }
      goodsInfo['model_value_str'] = model_value_str;
      _this.setData({
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.selectModelInfo': {},
        'exchangeCouponData.hasSelectGoods': true,
        'exchangeCouponData.voucher_coupon_goods_info': {
          goods_id: goodsInfo.id,
          num: 1,
          model_id: _this.data.exchangeCouponData.selectModelInfo.modelId
        },
        'exchangeCouponData.goodsInfo': goodsInfo
      });
      _this.getCalculationInfo();
    };

    _this2.getSuppInfo = function (suppInfoArr) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_id: suppInfoArr[0]
        },
        success: function success(res) {
          if (res.data) {
            var suppInfo = res.data.delivery_info;
            for (var j = 0; j < suppInfo.length; j++) {
              if (suppInfo[j].is_required == 0) {
                _this.hasRequiredSuppInfo = true;
                return;
              }
            }
          } else {
            _this.setData({
              noAdditionalInfo: true
            });
          }
        }
      });
    };

    document.title = '确认支付';
    return _this2;
  }

  (0, _createClass3.default)(PreviewAppointmentOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchisee_id = options.franchisee || '';
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      this.dataInitial();
      this.is_group = options.is_group || '';
      this.setData({
        is_group: this.is_group,
        to_store: options.to_store ? JSON.parse(options.to_store) : ''
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromSelectAddress) {
        this.getCalculationInfo();
        this.isFromSelectAddress = false;
      }
    }
    // wxPay = param => {
    //   var that = this
    //   app.requestPayment({
    //     timeStamp: param.timeStamp,
    //     nonceStr: param.nonceStr,
    //     package: param.package,
    //     signType: param.signType,
    //     paySign: param.paySign,
    //     success: function (res) {
    //       app.wxPaySuccess(param)
    //       param.success()
    //     },
    //     fail: function (res) {
    //       if (res.errMsg === 'requestPayment:fail cancel') {
    //         app.showModal({
    //           content: '支付已取消',
    //           complete: param.fail
    //         })
    //         return
    //       }
    //       app.showModal({
    //         content: '支付失败',
    //         complete: param.fail
    //       })
    //       app.wxPayFail(param, res.errMsg)
    //     }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          goodsList = _state.goodsList,
          is_group = _state.is_group,
          service_period = _state.service_period,
          original_price = _state.original_price,
          exchangeCouponData = _state.exchangeCouponData,
          orderRemark = _state.orderRemark,
          is_self_delivery = _state.is_self_delivery,
          selectAddress = _state.selectAddress,
          need_user_address = _state.need_user_address,
          appointmentUserName = _state.appointmentUserName,
          appointmentUserPhone = _state.appointmentUserPhone,
          shopAddress = _state.shopAddress,
          selectDiscountIndex = _state.selectDiscountIndex,
          discountList = _state.discountList,
          selectDiscountInfo = _state.selectDiscountInfo,
          discount_cut_price = _state.discount_cut_price,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          noAdditionalInfo = _state.noAdditionalInfo,
          totalPayment = _state.totalPayment,
          dialogHidden = _state.dialogHidden,
          selectModelInfo = _state.selectModelInfo,
          goodsInfo = _state.goodsInfo;

      // 处理成Picker组件需要的数据内容

      discountList = discountList.map(function (item, index) {
        return { label: item.title, value: index };
      });

      return React.createElement(
        'div',
        { className: 'official-page preview-appointment-order' },
        React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u652F\u4ED8' }),
        React.createElement(
          'div',
          { className: 'preview-goods-order-wrap', id: 'preview-goods-order' },
          React.createElement(
            'div',
            { className: 'preview-goods-order-list preview-goods-order-section' },
            goodsList.map(function (goods, goodsIndex) {
              return React.createElement(
                React.Fragment,
                { key: goods.id },
                React.createElement(
                  'div',
                  { className: 'preview-goods-order-item' },
                  React.createElement('img', {
                    className: 'preview-goods-cover ' + (is_group ? 'group-buy' : ''),
                    src: goods.cover,
                    mode: 'aspectFill'
                  }),
                  React.createElement(
                    'div',
                    { className: 'preview-goods-content' },
                    React.createElement(
                      'div',
                      { className: 'preview-goods-title' },
                      goods.title
                    ),
                    goods.model_value_str && React.createElement(
                      'div',
                      { className: 'preview-goods-model' },
                      goods.model_value_str
                    ),
                    React.createElement(
                      'div',
                      { className: 'preview-appointment-service-period' },
                      service_period
                    ),
                    React.createElement(
                      'div',
                      { className: 'preview-quantity-section' },
                      React.createElement(
                        'div',
                        { className: 'preview-goods-price' },
                        goods.integral != '2' ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'div',
                            { className: 'preview-goods-price' },
                            '¥' + (original_price == '0' ? '免费' : original_price)
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          !(goods.use_integral != 0 && original_price == '0.00') && React.createElement(
                            'span',
                            null,
                            original_price == '0.00' && goods.use_integral == 0 ? '免费' : '¥' + original_price
                          ),
                          goods.use_integral != 0 && original_price != '0.00' && React.createElement(
                            'span',
                            null,
                            '+'
                          ),
                          goods.use_integral != 0 && React.createElement(
                            'span',
                            null,
                            goods.use_integral + '积分'
                          )
                        )
                      )
                    )
                  )
                )
              );
            }),
            exchangeCouponData.hasSelectGoods && React.createElement(
              'div',
              { className: 'preview-goods-order-item' },
              React.createElement('img', {
                className: 'preview-goods-cover',
                src: exchangeCouponData.goodsInfo.cover,
                mode: 'aspectFill'
              }),
              React.createElement(
                'div',
                { className: 'preview-goods-content' },
                React.createElement(
                  'div',
                  { className: 'preview-goods-title' },
                  exchangeCouponData.goodsInfo.title
                ),
                exchangeCouponData.goodsInfo.model_value_str && React.createElement(
                  'div',
                  { className: 'preview-goods-model' },
                  exchangeCouponData.goodsInfo.model_value_str
                ),
                React.createElement(
                  'div',
                  { className: 'preview-quantity-section' },
                  React.createElement(
                    'div',
                    { className: 'gift-text' },
                    '\u8D60\u54C1'
                  ),
                  React.createElement(
                    'div',
                    { className: 'quantity pull-right' },
                    React.createElement(
                      'span',
                      null,
                      '\u6570\u91CF\uFF1A'
                    ),
                    React.createElement(
                      'span',
                      { className: 'buy-goods-count' },
                      '1'
                    )
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'preview-goods-order-section' },
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('color:#333;margin-bottom:10px;') },
              '\u4E70\u5BB6\u7559\u8A00'
            ),
            React.createElement('textarea', {
              value: orderRemark,
              maxLength: '30',
              onInput: this.remarkInput,
              placeholder: '\u4E70\u5BB6\u7559\u8A00'
            })
          ),
          need_user_address == '1' ? React.createElement(
            'div',
            {
              className: 'preview-goods-order-section',
              hidden: is_self_delivery == 1
            },
            selectAddress.id ? React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('position:relative;') },
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-bottom:7px;width:250px;') },
                  selectAddress.address_info.name + ' ' + selectAddress.address_info.contact
                ),
                React.createElement(
                  'div',
                  null,
                  selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                ),
                React.createElement(
                  'div',
                  { className: 'preview-address-options' },
                  React.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)('margin-right:15px;'),
                      onClick: this.goToMyAddress,
                      'data-address-id': selectAddress.id
                    },
                    '\u66F4\u6362'
                  ),
                  React.createElement(
                    'span',
                    { onClick: this.showAddAddress },
                    '\u6DFB\u52A0\u4E2A\u4EBA\u4FE1\u606F'
                  )
                )
              )
            ) : React.createElement(
              React.Fragment,
              null,
              React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
              React.createElement(
                'div',
                { onClick: this.showAddAddress },
                '\u6DFB\u52A0\u4E2A\u4EBA\u4FE1\u606F'
              )
            )
          ) : React.createElement(
            'div',
            { className: 'preview-goods-order-section' },
            React.createElement(
              'div',
              null,
              '\u4E2A\u4EBA\u4FE1\u606F'
            ),
            React.createElement(
              'label',
              { style: (0, _tools.convertLineStyleData)('margin-top:5px;color:#666;padding-left:10px;display:block;') },
              '\u60A8\u7684\u59D3\u540D',
              React.createElement('input', {
                onBlur: this.appointmentUserName,
                placeholder: '\u8BF7\u8F93\u5165\u59D3\u540D',
                className: 'appointment-user-name',
                value: appointmentUserName
              })
            ),
            React.createElement(
              'label',
              { style: (0, _tools.convertLineStyleData)('margin-top:5px;color:#666;padding-left:10px;display:block;') },
              '\u8054\u7CFB\u65B9\u5F0F',
              React.createElement('input', {
                onBlur: this.appointmentUserPhone,
                placeholder: '\u8BF7\u8F93\u5165\u8054\u7CFB\u65B9\u5F0F',
                className: 'appointment-user-phone',
                value: appointmentUserPhone
              })
            )
          ),
          React.createElement(
            'div',
            {
              className: 'preview-goods-order-section',
              hidden: is_self_delivery == 0
            },
            React.createElement(
              'div',
              { onClick: this.openStoreLocation },
              React.createElement('label', { className: 'ico-moon icon-location' }),
              shopAddress.region_string + shopAddress.shop_location
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('margin:12px 0;'), onClick: this.makeStorePhoneCall },
              React.createElement('label', { className: 'ico-moon icon-phone' }),
              shopAddress.shop_contact
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('font-size:12px;color:#aaa;margin-left:2px;') },
              '\u4EB2,\u52FE\u9009\u4E0A\u95E8\u5E97\u81EA\u63D0,\u9700\u8981\u81EA\u5DF1\u53BB\u95E8\u5E97\u53D6\u8D27\u54E6\uFF01'
            )
          ),
          React.createElement(
            'div',
            {
              className: 'preview-goods-order-section',
              style: (0, _tools.convertLineStyleData)('margin-bottom:1px;')
            },
            '\u9884\u7EA6\u91D1\u989D',
            React.createElement(
              'span',
              { className: 'pull-right price-count' },
              '¥' + original_price
            )
          ),
          !!discountList.length && React.createElement(
            'div',
            {
              className: 'preview-goods-order-section',
              style: (0, _tools.convertLineStyleData)('margin-bottom:1px;')
            },
            React.createElement(
              'div',
              { className: 'preview-section-title' },
              '\u4F18\u60E0\u65B9\u5F0F:',
              React.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ),
            React.createElement(
              _picker2.default,
              {
                onChange: this.discountChange,
                cols: 1,
                value: [selectDiscountIndex],
                data: discountList,
                style: (0, _tools.convertLineStyleData)('margin-bottom:-12rpx;')
              },
              React.createElement(
                'div',
                {
                  className: 'select-discount-title',
                  style: (0, _tools.convertLineStyleData)('display: flex; justify-content: space-between')
                },
                React.createElement(
                  'span',
                  { className: 'pull-left' },
                  selectDiscountInfo.name
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    hidden: selectDiscountIndex == 0
                  },
                  '-¥' + discount_cut_price
                )
              )
            )
          ),
          balance != 0 && React.createElement(
            'div',
            { className: 'preview-goods-order-section' },
            React.createElement(
              'div',
              { className: 'use-balance-option' },
              React.createElement(
                'span',
                null,
                '\u4F7F\u7528\u50A8\u503C\u91D1'
              ),
              React.createElement(_switch2.default, {
                className: 'pull-right',
                checked: useBalance,
                onChange: this.useBalanceChange
              })
            ),
            React.createElement(
              'div',
              {
                hidden: !useBalance,
                className: 'select-discount-title',
                style: (0, _tools.convertLineStyleData)('margin-top:9px;margin-bottom:-12rpx;')
              },
              '\u50A8\u503C\u91D1\u62B5\u73B0',
              React.createElement(
                'span',
                { className: 'pull-right' },
                '- ¥' + deduction
              )
            )
          ),
          !noAdditionalInfo && React.createElement(
            'div',
            {
              className: 'preview-goods-order-section',
              onClick: this.goToAdditionalInfo
            },
            '\u8865\u5145\u4FE1\u606F',
            React.createElement('div', {
              className: 'ico-moon icon-rightarrow pull-right',
              style: (0, _tools.convertLineStyleData)('color:#aaa;')
            })
          ),
          React.createElement(
            'div',
            { className: 'bottom-nav' },
            React.createElement(
              'div',
              { className: 'preview-goods-total-price' },
              '\u5408\u8BA1:',
              React.createElement(
                'span',
                { className: 'price-count' },
                '¥' + totalPayment
              )
            ),
            React.createElement(
              'form',
              null,
              React.createElement(
                'button',
                { type: 'button', onClick: this.confirmPayment },
                '\u53BB\u4ED8\u6B3E'
              )
            )
          )
        )
      );
    }
  }]);
  return PreviewAppointmentOrder;
}(_OfficialPage3.default);

exports.default = PreviewAppointmentOrder;

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(514);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppointmentOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(AppointmentOrderDetail, _OfficialPage);

  function AppointmentOrderDetail(props) {
    (0, _classCallCheck3.default)(this, AppointmentOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (AppointmentOrderDetail.__proto__ || Object.getPrototypeOf(AppointmentOrderDetail)).call(this, props));

    _this2.state = {
      orderData: {},
      orderInfo: {},
      orderStatus: {
        '0': '待付款',
        '1': '待商家确认',
        '2': '待消费',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已消费',
        '7': '已关闭'
      },
      selectAddressId: '',
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      orderId: '',
      isFromTemplateMsg: false,
      originalPrice: '',
      useBalance: '',
      freightAdress: {},
      express_fee: '',
      discount_cut_price: '',
      isFromBack: false
    };

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.initialAddressId();
    };

    _this2.getOrderDetail = function (orderId) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0],
              form_data = data.form_data,
              hasAdditionalInfo = false,
              start_date = form_data.appointment_order_info.appointment_start_date,
              end_date = form_data.appointment_order_info.appointment_end_date,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              address_id = '';
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id,
                goodsId = form_data.goods_info[i].id;
            if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
              additional_info_goods.push(form_data.goods_info[i]);
              additional_goodsid_arr.push(goodsId);
              hasAdditionalInfo = true;
            }
          }
          form_data.remark = form_data.remark ? form_data.remark.replace(/\n|\\n/g, '\n') : form_data.remark;
          if (start_date && end_date) {
            if (start_date.substring(0, 4) == end_date.substring(0, 4)) {
              form_data.appointment_order_info.appointment_start_date = start_date.substring(4, 6) + '-' + start_date.substring(6);
              form_data.appointment_order_info.appointment_end_date = end_date.substring(4, 6) + '-' + end_date.substring(6);
            } else {
              form_data.appointment_order_info.appointment_start_date = start_date.substring(0, 4) + '-' + start_date.substring(4, 6) + '-' + start_date.substring(6);
              form_data.appointment_order_info.appointment_end_date = end_date.substring(0, 4) + '-' + end_date.substring(4, 6) + '-' + end_date.substring(6);
            }
          }
          if (form_data.appointment_order_info.appointment_unit_type == '6') {
            form_data.timeDiff = Date.parse(new Date()) - Date.parse(new Date(form_data.appointment_time.split('~')[1])) > 0 ? true : false;
          } else {
            form_data.timeDiff = false;
          }
          that.setData({
            orderData: data,
            orderInfo: form_data,
            hasAdditionalInfo: hasAdditionalInfo,
            appointment_interval: form_data.appointment_order_info.appointment_interval && form_data.appointment_order_info.appointment_interval.substring(6, 8) >= 24 ? form_data.appointment_order_info.appointment_interval.substring(0, 6) + '次日' + (form_data.appointment_order_info.appointment_interval.substring(6, 8) * 1 - 24) + form_data.appointment_order_info.appointment_interval.substring(8) : form_data.appointment_order_info.appointment_interval,
            discount_cut_price: form_data.discount_cut_price,
            useBalance: Number(form_data['use_balance']),
            express_fee: res.data[0]['express_fee']
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          _app.appMethod.setGoodsAdditionalInfo(form_data.additional_info || {});
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId,
          that = _this2,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.showModal({
        content: '订单删除后不可找回，确认删除？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '是否取消订单？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderId;
      orderId = _this2.data.orderInfo.order_id;
      if (_this2.data.orderInfo.total_price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            setTimeout(function () {
              _app.appMethod.showToast({
                title: '支付成功',
                icon: 'success',
                success: function success() {
                  that.paySuccessCallback();
                }
              });
            });
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data,
      //       orderId = that.data.orderInfo.order_id
      //     param.orderId = orderId
      //     param.goodsType = that.data.orderInfo.goods_type
      //     param.success = function () {
      //       that.paySuccessCallback()
      //     }
      //     app.wxPay(param)
      //   }
      // })
      var pagePath = '/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + '&code=code';
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: pagePath
      });
    };

    _this2.applyDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定要申请退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/applyRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 4;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId);
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已消费？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 3;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/makeComment/makeComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.showAddressList = function () {
      var addressId = _this2.data.selectAddressId,
          orderId = _this2.data.orderInfo.order_id,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId + '&oid=' + orderId + '&sub_shop_id=' + franchiseeId, true);
    };

    _this2.showAddAddress = function () {
      var orderId = _this2.data.orderInfo.order_id;
      var _this = _this2;
      if (_app.appMethod.chooseAddress) {
        _app.appMethod.chooseAddress({
          success: function success(res) {
            _app.appMethod.sendRequest({
              method: 'post',
              url: '/index.php?r=AppShop/AddWxAddress',
              data: {
                detailInfo: res.detailInfo || '',
                cityName: res.cityName || '',
                provinceName: res.provinceName || '',
                UserName: res.userName || '',
                telNumber: res.telNumber || '',
                district: res.district || '',
                countyName: res.countyName || '',
                order_id: orderId
              },
              success: function success() {
                _this.dataInitial();
              }
            });
          }
        });
      } else {
        var orderId = _this2.data.orderInfo.order_id;
        _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress?oid=' + orderId);
      }
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.verificationCode = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' + _this2.data.orderInfo.order_id + '&sub_shop_app_id=' + _this2.data.franchiseeId);
    };

    _this2.getFreigtAdress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          that.setData({
            freightAdress: res.data
          });
        }
      });
    };

    _this2.freightGoMap = function () {
      var _this = _this2,
          infor = _this.data.freightAdress.region_string + _this.data.freightAdress.shop_location;
      infor = infor.replace(/\s+/g, '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
        data: {
          location_info: infor
        },
        success: function success(res) {
          if (res.result) {
            _app.appMethod.openLocation({
              latitude: res.result.location.lat,
              longitude: res.result.location.lng
            });
          }
        }
      });
    };

    _this2.initialAddressId = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            that.setData({
              selectAddressId: res.data[0].id
            });
          }
        }
      });
    };

    _this2.freightPlayPhone = function () {
      var that = _this2;
      _app.appMethod.makePhoneCall(that.data.freightAdress.shop_contact);
    };

    _this2.seeAdditionalInfo = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail');
    };

    _this2.paySuccessCallback = function () {
      var orderId = _this2.data.orderInfo.order_id;
      var franchiseeId = _this2.data.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsOrderPaySuccess/goodsOrderPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + '&code=code';
      if (!franchiseeId) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: franchiseeId
          },
          success: function success(res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1';
            }
            _app.appMethod.turnToPage(pagePath, 1);
          }
        });
      } else {
        _app.appMethod.turnToPage(pagePath, 1);
      }
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(AppointmentOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          orderStatus = _state.orderStatus,
          orderInfo = _state.orderInfo,
          appointment_interval = _state.appointment_interval,
          discount_cut_price = _state.discount_cut_price,
          useBalance = _state.useBalance,
          hasAdditionalInfo = _state.hasAdditionalInfo;


      return React.createElement(
        'div',
        { className: 'official-page appointment-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          'div',
          null,
          isFromTemplateMsg && React.createElement(
            'div',
            {
              className: 'order-detail-section orderDetail-goto-homepage',
              onClick: this.goToHomepage,
              style: (0, _tools.convertLineStyleData)('margin-bottom:0;')
            },
            React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
            '\u8FD4\u56DE\u9996\u9875'
          ),
          React.createElement(
            'div',
            { className: 'order-detail-section top-section' },
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('margin-bottom: 18rpx;') },
              '订单状态: ' + orderStatus[orderInfo.status]
            ),
            React.createElement(
              'div',
              null,
              '订单号: ' + orderInfo.order_id
            )
          ),
          +orderInfo.status === 0 && React.createElement(
            'div',
            {
              className: 'order-detail-section',
              style: (0, _tools.convertLineStyleData)('border-top:1px solid #e8e8e8;')
            },
            '\u7B49\u5F85\u4E70\u5BB6\u4ED8\u6B3E'
          ),
          !(orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_user_phone) ? React.createElement(
            'div',
            { className: 'order-detail-section' },
            React.createElement(
              'div',
              { className: 'address-info-section' },
              orderInfo.is_self_delivery == 0 || !(orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_user_phone) ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-bottom: 3px') },
                  orderInfo.address_info && orderInfo.address_info.name + ' ' + orderInfo.address_info.contact
                ),
                (orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.need_user_address) != 0 && React.createElement(
                  'div',
                  null,
                  orderInfo && orderInfo.address_info && orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-bottom: 3px') },
                  orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_user_name + ' ' + orderInfo.appointment_order_info.appointment_user_phone
                )
              )
            )
          ) : React.createElement(
            'div',
            { className: 'order-detail-section' },
            React.createElement(
              'div',
              { className: 'address-info-section' },
              (orderInfo.is_self_delivery == 0 || !orderInfo.appointment_order_info.appointment_user_phone) && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-bottom: 3px') },
                  orderInfo.appointment_order_info.appointment_user_name + ' ' + orderInfo.appointment_order_info.appointment_user_phone
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'order-detail-section',
              style: (0, _tools.convertLineStyleData)('margin-bottom: 0; padding-bottom: 0; border-bottom: none;')
            },
            orderInfo && orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
              return React.createElement(
                'div',
                { className: 'goods-list-item', key: goods.id },
                React.createElement('img', { className: 'goods-cover', src: goods.cover }),
                goods.is_seckill == 1 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'goods-content goods-seckill-content' },
                    React.createElement(
                      'div',
                      null,
                      goods.goods_name
                    ),
                    goods.model_value && React.createElement(
                      'div',
                      { className: 'goods-model' },
                      goods.model_value
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-right goods-seckill-right' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'span',
                        { className: 'goods-seckill-price' },
                        '¥' + goods.price
                      ),
                      React.createElement(
                        'span',
                        { className: 'goods-original-price' },
                        '¥' + goods.original_price
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'goods-seckill-sign' },
                      '\u79D2\u6740\u5546\u54C1'
                    ),
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('margin-top: 5px;') },
                      '× ' + goods.num
                    )
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'goods-content' },
                    React.createElement(
                      'div',
                      null,
                      goods.goods_name
                    ),
                    goods.model_value && React.createElement(
                      'div',
                      { className: 'goods-model' },
                      goods.model_value
                    ),
                    goods.is_benefit_goods && React.createElement(
                      'div',
                      { className: 'gift-text' },
                      '\u8D60\u54C1'
                    )
                  ),
                  !goods.is_benefit_goods && React.createElement(
                    'div',
                    { className: 'goods-right' },
                    React.createElement(
                      'div',
                      null,
                      '¥' + goods.price
                    ),
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('margin-top: 5px;') },
                      '× ' + goods.num
                    )
                  )
                )
              );
            })
          ),
          orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 || orderInfo.appointment_order_info.appointment_unit_type == 6) ? React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u8D77\u59CB\u65E5\u671F',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo.appointment_order_info.appointment_start_date
            )
          ) : React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u9884\u7EA6\u65E5\u671F',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_day
            )
          ),
          orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 || orderInfo.appointment_order_info.appointment_unit_type == 6) ? React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u7ED3\u675F\u65E5\u671F',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_end_date
            )
          ) : React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u9884\u7EA6\u65F6\u6BB5',
            React.createElement(
              'span',
              { className: 'pull-right' },
              appointment_interval
            )
          ),
          orderInfo && orderInfo.appointment_order_info && (orderInfo.appointment_order_info.appointment_unit_type == 3 || orderInfo.appointment_order_info.appointment_unit_type == 6) ? React.createElement(
            'div',
            { className: 'order-detail-section' },
            '\u9884\u7EA6\u65F6\u95F4',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo.appointment_order_info.appointment_to_store_time
            )
          ) : React.createElement(
            'div',
            { className: 'order-detail-section' },
            '\u670D\u52A1\u65F6\u957F',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo && orderInfo.appointment_order_info && orderInfo.appointment_order_info.appointment_time_long
            )
          ),
          orderInfo.has_seckill == 1 ? React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u9884\u7EA6\u91D1\u989D',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '¥' + orderInfo.seckill_original_price
            )
          ) : React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u9884\u7EA6\u91D1\u989D',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '¥' + (orderInfo.original_price || '免费')
            )
          ),
          orderInfo.has_seckill == 1 && React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u6D3B\u52A8\u4F18\u60E0',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '秒杀  - ¥' + orderInfo.seckill_cut_price
            )
          ),
          React.createElement(
            'div',
            { className: 'order-detail-section' },
            '\u4F18\u60E0\u62B5\u6263',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '- ¥' + discount_cut_price
            )
          ),
          !!+orderInfo.total_integral && orderInfo.total_integral != 0 && orderInfo.total_integral != '0' && React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u8BA2\u5355\u79EF\u5206',
            React.createElement(
              'span',
              { className: 'pull-right' },
              orderInfo.total_integral + '积分'
            )
          ),
          React.createElement(
            'div',
            { className: 'order-detail-section' },
            '\u8BA2\u5355\u603B\u4EF7',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '¥' + (orderInfo.original_price ? orderInfo.order_total_price : '免费')
            )
          ),
          (orderInfo.status || orderInfo.coupon_fee) && React.createElement('div', { style: (0, _tools.convertLineStyleData)('margin-bottom: 0; border-top:1px solid #e8e8e8;') }),
          orderInfo.status != 0 && React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u50A8\u503C\u62B5\u6263',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '- ¥' + useBalance
            )
          ),
          !!+orderInfo.coupon_fee && React.createElement(
            'div',
            { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
            '\u793E\u4EA4\u7ACB\u51CF\u91D1',
            React.createElement(
              'span',
              { className: 'pull-right' },
              '- ¥' + orderInfo.coupon_fee
            )
          ),
          React.createElement(
            'div',
            { className: 'order-detail-section' },
            '\u9700\u4ED8\u6B3E',
            React.createElement(
              'span',
              { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color: #ff7100;') },
              '¥' + (orderInfo.total_price != '0.00' ? orderInfo.total_price : '免费')
            )
          ),
          !!+hasAdditionalInfo && React.createElement(
            'div',
            {
              className: 'order-detail-section',
              onClick: this.seeAdditionalInfo,
              style: (0, _tools.convertLineStyleData)('border-top:1px solid #e8e8e8;')
            },
            '\u8865\u5145\u4FE1\u606F',
            React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' })
          ),
          orderInfo.remark && React.createElement(
            'div',
            {
              className: 'order-detail-section',
              style: (0, _tools.convertLineStyleData)('border-top:1px solid #e8e8e8;')
            },
            React.createElement(
              'div',
              { className: 'section-title' },
              '\u7559\u8A00'
            ),
            React.createElement(
              'div',
              { className: 'section-content' },
              React.createElement(
                'span',
                null,
                orderInfo.remark
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'bottom-nav' },
            React.createElement(
              'div',
              { className: 'txt-r' },
              orderInfo.status == 0 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.cancelOrder },
                  '\u53D6\u6D88\u8BA2\u5355'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'btn btn-orange orderDetail-pay-directly',
                    onClick: this.payOrder
                  },
                  '\u7ACB\u5373\u652F\u4ED8'
                )
              ),
              orderInfo.status == 1 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.verificationCode },
                  '\u6838\u9500\u7801'
                ),
                !orderInfo.timeDiff && React.createElement(
                  'span',
                  { className: 'btn', onClick: this.applyDrawback },
                  '\u7533\u8BF7\u9000\u6B3E'
                )
              ),
              orderInfo.status == 2 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.verificationCode },
                  '\u6838\u9500\u7801'
                ),
                !orderInfo.timeDiff && React.createElement(
                  'span',
                  { className: 'btn', onClick: this.applyDrawback },
                  '\u7533\u8BF7\u9000\u6B3E'
                ),
                React.createElement(
                  'span',
                  { className: 'btn btn-orange', onClick: this.sureReceipt },
                  '\u786E\u8BA4\u6D88\u8D39'
                )
              ),
              orderInfo.status == 3 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.orderDelete },
                  '\u522A\u9664\u8BA2\u5355'
                ),
                React.createElement(
                  'span',
                  { className: 'btn btn-orange', onClick: this.makeComment },
                  '\u53BB\u8BC4\u4EF7'
                )
              ),
              orderInfo.status == 4 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  null,
                  '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                )
              ),
              orderInfo.status == 5 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.receiveDrawback },
                  '\u6536\u5230\u9000\u6B3E'
                )
              ),
              orderInfo.status == 6 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.verificationCode },
                  '\u6838\u9500\u7801'
                ),
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.orderDelete },
                  '\u522A\u9664\u8BA2\u5355'
                )
              ),
              orderInfo.status == 7 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  { className: 'btn', onClick: this.orderDelete },
                  '\u522A\u9664\u8BA2\u5355'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AppointmentOrderDetail;
}(_OfficialPage3.default);

exports.default = AppointmentOrderDetail;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(516);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WinningRecord = function (_OfficialPage) {
  (0, _inherits3.default)(WinningRecord, _OfficialPage);

  function WinningRecord(props) {
    (0, _classCallCheck3.default)(this, WinningRecord);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WinningRecord.__proto__ || Object.getPrototypeOf(WinningRecord)).call(this, props));

    _this.state = {
      currentTabIndex: 1,
      myPrizeList: [],
      storeStyle: {}
    };

    _this.clickTap = function (e) {
      var that = _this;
      var index = e.currentTarget.dataset.index,
          data = {};
      data.currentTabIndex = index;
      that.setData(data);
      that.getMyPrizeCenter(index);
    };

    _this.getMyPrizeCenter = function (category) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/myPrizeCenter',
        method: 'post',
        data: {
          category: category,
          page: 1,
          page_size: 999,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            myPrizeList: res.data
          });
        }
      });
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config
        });
      }, _this.data.franchisee);
    };

    document.title = '中奖记录';
    return _this;
  }

  (0, _createClass3.default)(WinningRecord, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        franchisee: options.franchisee || ''
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount(options) {
      var that = this;
      that.getMyPrizeCenter(1);
      this.getAppECStoreConfig();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          currentTabIndex = _state.currentTabIndex,
          storeStyle = _state.storeStyle,
          myPrizeList = _state.myPrizeList;

      return React.createElement(
        'div',
        { className: 'official-page winning-record' },
        React.createElement(_TopNav.TopNav, { title: '\u4E2D\u5956\u8BB0\u5F55' }),
        React.createElement(
          'div',
          { className: 'winningRecord page', id: 'winningRecord' },
          React.createElement(
            'div',
            { className: 'record-tab-list' },
            React.createElement(
              'div',
              {
                'data-index': '1',
                style: (0, _tools.convertLineStyleData)(currentTabIndex == 1 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                className: currentTabIndex == 1 ? 'active' : '',
                onClick: this.clickTap
              },
              '\u5927\u8F6C\u76D8'
            ),
            React.createElement(
              'div',
              {
                'data-index': '2',
                style: (0, _tools.convertLineStyleData)(currentTabIndex == 2 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                className: currentTabIndex == 2 ? 'active' : '',
                onClick: this.clickTap
              },
              '\u7838\u91D1\u86CB'
            ),
            React.createElement(
              'div',
              {
                'data-index': '3',
                style: (0, _tools.convertLineStyleData)(currentTabIndex == 3 ? 'color:' + storeStyle.theme + ';border-color:' + storeStyle.theme : ''),
                className: currentTabIndex == 3 ? 'active' : '',
                onClick: this.clickTap
              },
              '\u522E\u522E\u4E50'
            )
          ),
          React.createElement(
            'div',
            { className: 'record-content-body' },
            React.createElement(
              'div',
              { className: 'scrollContainer' },
              React.createElement(
                _ScrollView.ScrollView,
                { 'scroll-y': 'true' },
                myPrizeList.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'record-wrap-list',
                      key: item.id,
                      'data-id': item.id,
                      hidden: myPrizeList == ''
                    },
                    React.createElement(
                      'div',
                      { className: 'record-name' },
                      item.prize_level + ':' + item.custom_prize_title
                    ),
                    item.custom_prize_title != item.prize_title && React.createElement(
                      'div',
                      { className: 'record-name custom-record-name' },
                      React.createElement(
                        'span',
                        null,
                        '\u5956\u54C1'
                      ),
                      item.prize_title
                    ),
                    React.createElement(
                      'div',
                      { className: 'record-start' },
                      React.createElement(
                        'div',
                        { className: 'record-apply' },
                        '使用日期：' + item.start_use_date + '至' + item.end_use_date
                      )
                    ),
                    item.coupon_type != 1 && React.createElement('div', {
                      className: 'record-staus ico-moon icon-winning-record-' + (item.is_selected == '0' ? 'nouse' : 'used'),
                      style: (0, _tools.convertLineStyleData)('color:' + (item.is_selected == '0' ? '#FF7100' : '#999999'))
                    }),
                    React.createElement(
                      'div',
                      { className: 'record-end' },
                      '中奖时间：' + item.add_time
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'record-none', hidden: myPrizeList != '' },
                '\u6682\u65E0\u4EFB\u4F55\u4E2D\u5956\u8BB0\u5F55'
              )
            )
          )
        )
      );
    }
  }]);
  return WinningRecord;
}(_OfficialPage3.default);

exports.default = WinningRecord;

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(518);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyMessage = function (_OfficialPage) {
  (0, _inherits3.default)(MyMessage, _OfficialPage);

  function MyMessage(props) {
    (0, _classCallCheck3.default)(this, MyMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyMessage.__proto__ || Object.getPrototypeOf(MyMessage)).call(this, props));

    _this.state = {
      messageType: 5, // 5:默认展示系统消息列表
      systemBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      interactBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      pushBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      messageDetail: 0, // 控制是否展开 0:不展示消息详情页 3:展示表单详情页
      messageDetailFormData: [], //消息详情页：表单数据
      review_switch: 0, //  表单是否开启审核
      form_data: {
        review_status: 3,
        review_result: ''
      }
    };

    _this.getMessageData = function (type, page) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppNotify/GetUserAppNotifyMsg',
        data: {
          app_id: _app.appMethod.globalData.appId,
          types: type || '5,6,16',
          page: page || ''
        },
        success: function success(res) {
          for (var key in res.data) {
            switch (parseInt(key)) {
              case 5:
                that.setData({
                  'systemBranch.data': that.data.systemBranch.data ? that.data.systemBranch.data.concat(that.parseMessageData(res.data[key].data)) : that.parseMessageData(res.data[key].data),
                  'systemBranch.isMore': res.data[key].is_more || '',
                  'systemBranch.currentPage': res.data[key].current_page || '',
                  'systemBranch.onload': false,
                  'systemBranch.unreadCount': res.data[key].unread_count || ''
                });
                break;
              case 6:
                that.setData({
                  'interactBranch.data': that.data.interactBranch.data ? that.data.interactBranch.data.concat(that.parseMessageData(res.data[key].data)) : that.parseMessageData(res.data[key].data),
                  'interactBranch.isMore': res.data[key].is_more || '',
                  'interactBranch.currentPage': res.data[key].current_page || '',
                  'interactBranch.onload': false,
                  'interactBranch.unreadCount': res.data[key].unread_count || ''
                });
                break;
              case 16:
                var newData = {};
                var currentPushBranchData = that.data.pushBranch.data || [];
                var returnData = res.data[key];
                newData['pushBranch.data'] = currentPushBranchData ? currentPushBranchData.concat(that.parseMessageData(returnData.data)) : that.parseMessageData(returnData.data);
                newData['pushBranch.isMore'] = returnData.is_more || '';
                newData['pushBranch.currentPage'] = returnData.current_page || '';
                newData['pushBranch.onload'] = false;
                newData['pushBranch.unreadCount'] = returnData.unread_count || '';
                that.setData(newData);
                break;
            }
          }
        }
      });
    };

    _this.parseMessageData = function (data) {
      var array = [];
      var contentJson = void 0;
      var item = void 0;
      for (var i = 0; i < data.length; i++) {
        switch (parseInt(data[i].type)) {
          case 1:
            contentJson = data[i].content && JSON.parse(data[i].content);
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-system';
            item.messageTitle = contentJson.title;
            item.messageTime = data[i].add_time;
            item.messageImg = contentJson.pic;
            item.messageContent = contentJson.description;
            item.messagePageUrl = data[i].page_url;
            array.push(item);
            break;
          case 2:
            contentJson = data[i].content && JSON.parse(data[i].content);
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-pay';
            item.messageTitle = '支付成功';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-message-pay';
            item.messagePrice = contentJson.total_price;
            item.messageOrderId = contentJson.order_id;
            array.push(item);
            break;
          case 3:
            contentJson = data[i].content && JSON.parse(data[i].content);
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-form';
            item.messageTitle = '表单提交成功';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-message-form';
            item.messageContent = contentJson.form_name;
            item.messageForm = contentJson.form;
            item.messageFormId = contentJson.form_id;
            item.messageFormDataId = data[i].sub_id;
            item.review_status = data[i].data_info.length ? data[i].data_info[0].form_data.review_status : 3;
            item.review_switch = data[i].data_info.length ? data[i].data_info[0].form_data.review_switch : 0;
            array.push(item);
            break;
          case 4:
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-comment';
            item.messageTitle = '评论消息';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-message-comment';
            item.messageContent = data[i].content + ' 回复了你的话题';
            array.push(item);
            break;
          case 8:
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-Administrators';
            item.messageTitle = '管理员通知';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-notify';
            item.messageContent = data[i].content.replace(/\\n/g, '\n');
            array.push(item);
            break;
          case 16:
            contentJson = data[i].content && JSON.parse(data[i].content);
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-push';
            item.messageTitle = '推送消息';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-message-push';
            item.messageContent = contentJson && contentJson.content || '';
            item.messageEventParams = contentJson.page_url || '';
            array.push(item);
            break;
        }
      }
      return array;
    };

    _this.checkMoreMessageData = function (event) {
      var that = _this;
      var targetId = event.target.id;
      switch (targetId) {
        case 'myMessage-system-message':
          if (that.data.systemBranch.isMore != 0 && !that.data.systemBranch.onload) {
            that.getMessageData(5, that.data.systemBranch.currentPage + 1);
            that.setData({
              'systemBranch.onload': true
            });
          }
          break;
        case 'myMessage-interact-message':
          if (that.data.interactBranch.isMore != 0 && !that.data.interactBranch.onload) {
            that.getMessageData(6, that.data.interactBranch.currentPage + 1);
            that.setData({
              'interactBranch.onload': true
            });
          }
          break;
        case 'myMessage-push-message':
          var pushBranchData = that.data.pushBranch;
          if (pushBranchData.isMore != 0 && !pushBranchData.onload) {
            that.getMessageData(16, pushBranchData.currentPage + 1);
            that.setData({
              'pushBranch.onload': true
            });
          }
          break;
      }
    };

    _this.changeMessageType = function (event) {
      if (event.target.dataset.messageType == 6) {
        _this.setData({
          'interactBranch.unreadCount': 0
        });
      }
      _this.setData({
        messageType: event.target.dataset.messageType
      });
    };

    _this.jumpToPage = function (event) {
      var router = event.currentTarget.dataset.pageUrl;
      if (!router) {
        return;
      }
      var url = '/pages/' + router + '/' + router;
      _app.appMethod.turnToPage(url, true);
    };

    _this.showMessageDetailForm = function (event) {
      var that = _this;
      var _form = event.currentTarget.dataset.form;
      var _formId = event.currentTarget.dataset.formId;
      var _formDataId = event.currentTarget.dataset.formDataId;
      var _formData_list = []; // 该表单对应的字段详情数组
      _app.appMethod.setPageTitle('表单消息');
      _app.appMethod.sendRequest({
        url: '/index.php?r=pc/WebAppMgr/getForm',
        data: {
          app_id: _app.appMethod.globalData.appId,
          form_id: _formId
        },
        success: function success(res) {
          _formData_list = res.data.field_arr;
          for (var i in _formData_list) {
            if (_formData_list[i].field === 'region_id') {
              _formData_list.splice(i, 1);
            }
          }
          that.setData({ review_switch: res.data.review_switch });
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppData/getFormData',
            data: {
              app_id: _app.appMethod.globalData.appId,
              form: _form,
              data_id: _formDataId
            },
            success: function success(res) {
              var _array = []; // 临时存放表单提交详情的显示数据
              var _form_data = res.data['0'].form_data;
              for (var key in _form_data) {
                var _index = -1; // 判断改表单提交详情对应在字段详情数组的位置
                for (var i = 0; i < _formData_list.length; i++) {
                  if (_formData_list[i]['field'] == key) {
                    _index = i;
                  }
                }
                if (_index == -1) continue;
                var _item = {}; // 临时存放
                switch (parseInt(_formData_list[_index]['type'])) {
                  case 1:
                    _item = {};
                    _item.dataType = 1;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = _form_data[key];
                    _array.push(_item);
                    break;
                  case 2:
                    _item = {};
                    _item.dataType = 2;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = _form_data[key];
                    _array.push(_item);
                    break;
                  case 3:
                    _item = {};
                    _item.dataType = 3;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = '富文本类型';
                    _array.push(_item);
                    break;
                  case 12:
                    _item = {};
                    _item.dataType = 12;
                    _item.dataName = _formData_list[_index]['name'];
                    _form_data[key].map(function (item) {
                      item.virtual = '';
                    });
                    _item.dataContent = _form_data[key];
                    _array.push(_item);
                    break;
                }
                _index++;
              }
              that.setData({
                messageDetail: 3,
                messageDetailFormData: _array,
                form_data: _form_data
              });
            }
          });
        }
      });
    };

    _this.confirmMessageDetailForm = function () {
      _app.appMethod.setPageTitle('系统通知');
      if (_this.options.from === 'transforDetail') {
        _this.getMessageData();
      }
      _this.setData({
        messageDetail: 0,
        messageDetailFormData: []
      });
    };

    _this.tapEventCommonHandler = function (e) {
      var eventParams = e.currentTarget.dataset.eventParams;

      if (eventParams && eventParams.action && eventParams.action != 'none') {
        _app.appMethod.tapEventCommonHandler(e);
      }
    };

    _this.getReviewConfig = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppConfig/GetAppDataReviewTextConfig',
        method: 'post',
        hideLoading: true,
        success: function success(res) {
          _this.setData({ reviewList: res.data });
        }
      });
    };

    _this.bindplay = function (e) {
      var dataset = e.currentTarget.dataset;
      var tag = dataset.tag;
      var index = dataset.index;
      var id = dataset.id;
      var videoList = _this.data.messageDetailFormData[tag].dataContent;
      var contextData = _this.data.contextData || {};
      Taro.showLoading({ title: '加载中' });
      videoList[index].virtual = videoList[index].fileName;
      if (!contextData[id]) {
        contextData[id] = Taro.createVideoContext(id);
      }
      _this.setData((0, _defineProperty3.default)({
        contextData: contextData
      }, 'messageDetailFormData[' + tag + '].dataContent', videoList));
      setTimeout(function () {
        contextData[id].play();
        contextData[id].requestFullScreen();
        Taro.hideLoading();
      }, 600);
    };

    _this.bindPlayVideo = function (e) {
      var id = e.currentTarget.dataset.id;
      var contextData = _this.data.contextData || {};
      if (Object.keys(contextData).length > 0) {
        Object.keys(contextData).forEach(function (val, key) {
          if (id != val) contextData[val].pause();
        });
      }
    };

    document.title = '系统通知';
    return _this;
  }

  (0, _createClass3.default)(MyMessage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.options = options;
      this.getReviewConfig();
      if (options.from === 'transforDetail') {
        this.setData({
          messageDetail: 3
        });
        this.showMessageDetailForm({
          currentTarget: {
            dataset: {
              form: options.form,
              formDataId: options.formDataId,
              formId: options.formid
            }
          }
        });
      } else {
        this.getMessageData();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          messageType = _state.messageType,
          interactBranch = _state.interactBranch,
          messageDetail = _state.messageDetail,
          systemBranch = _state.systemBranch,
          reviewList = _state.reviewList,
          pushBranch = _state.pushBranch,
          messageDetailFormData = _state.messageDetailFormData,
          review_switch = _state.review_switch,
          form_data = _state.form_data;

      return React.createElement(
        'div',
        { className: 'official-page my-message' },
        React.createElement(_TopNav.TopNav, { title: '\u7CFB\u7EDF\u901A\u77E5' }),
        React.createElement(
          'div',
          { className: 'myMessage-wrap page', id: 'myMessage' },
          messageDetail == 0 && React.createElement(
            'div',
            { className: 'myMessage-top-nav' },
            React.createElement(
              'div',
              { className: 'myMessage-type-list' },
              React.createElement(
                'div',
                {
                  className: 'myMessage-type-item ' + (messageType == 5 ? 'active' : ''),
                  onClick: this.changeMessageType,
                  'data-message-type': '5'
                },
                '\u7CFB\u7EDF\u6D88\u606F'
              ),
              React.createElement(
                'div',
                {
                  className: 'myMessage-type-item ' + (messageType == 6 ? 'active' : '') + ' ' + (interactBranch.unreadCount > 0 ? 'has-noread' : ''),
                  onClick: this.changeMessageType,
                  'data-message-type': '6'
                },
                '\u4E92\u52A8\u6D88\u606F'
              ),
              React.createElement(
                'div',
                {
                  className: 'myMessage-type-item ' + (messageType == 16 ? 'active' : '') + ' ' + (interactBranch.unreadCount > 0 ? 'has-noread' : ''),
                  onClick: this.changeMessageType,
                  'data-message-type': '16'
                },
                '\u63A8\u9001\u6D88\u606F'
              )
            )
          ),
          messageDetail == 0 && React.createElement(
            'div',
            { className: 'myMessage-content-container' },
            React.createElement(
              _ScrollView.ScrollView,
              {
                id: 'myMessage-system-message',
                className: 'myMessage-content ' + (messageType == 5 ? 'active' : ''),
                'scroll-y': 'true',
                lowerThreshold: '116',
                bindscrolltolower: this.checkMoreMessageData
              },
              systemBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: item.messageOrderId },
                  item.messageType == 1 ? React.createElement(
                    'div',
                    {
                      className: 'message-item ' + item.className,
                      onClick: _this2.jumpToPage,
                      'data-page-url': item.messagePageUrl
                    },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement('img', {
                      className: 'message-img',
                      src: item.messageImg
                    }),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      item.messageContent
                    )
                  ) : item.messageType == 2 ? React.createElement(
                    'div',
                    { className: 'message-item ' + item.className },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      React.createElement(
                        'div',
                        { className: 'message-price' },
                        React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          '\u652F\u4ED8\u91D1\u989D\uFF1A'
                        ),
                        React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          '¥' + item.messagePrice
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'message-orderNum' },
                        React.createElement(
                          'div',
                          { className: 'message-orderNum-text' },
                          '\u8BA2\u5355\u53F7\uFF1A'
                        ),
                        React.createElement(
                          'div',
                          { className: 'message-orderNum-text' },
                          item.messageOrderId
                        )
                      )
                    )
                  ) : item.messageType == 3 ? React.createElement(
                    'div',
                    {
                      className: 'message-item ' + item.className,
                      'data-form': item.messageForm,
                      'data-form-id': item.messageFormId,
                      'data-form-data-id': item.messageFormDataId,
                      onClick: _this2.showMessageDetailForm
                    },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      React.createElement(
                        'div',
                        { className: 'message-price' },
                        React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          item.messageContent
                        ),
                        (item.review_status || item.review_status >= 0) && item.review_switch == 1 && React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          '\u72B6\u6001\uFF1A',
                          React.createElement(
                            'span',
                            {
                              className: item.review_status == 0 ? '' : item.review_status == 1 ? 'success-examine' : 'faile-examine'
                            },
                            item.review_status == 0 ? reviewList.applying_text || '待审核' : item.review_status == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                          )
                        )
                      )
                    )
                  ) : item.messageType == 8 && React.createElement(
                    'div',
                    { className: 'message-item ' + item.className },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      React.createElement(
                        'span',
                        null,
                        item.messageContent
                      )
                    )
                  )
                );
              }),
              !systemBranch.data.length && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'request-none' },
                  React.createElement('img', {
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png',
                    mode: 'widthFix'
                  }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            ),
            React.createElement(
              _ScrollView.ScrollView,
              {
                id: 'myMessage-interact-message',
                className: 'myMessage-content ' + (messageType == 6 ? 'active' : ''),
                'scroll-y': 'true',
                lowerThreshold: '116',
                bindscrolltolower: this.checkMoreMessageData
              },
              interactBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: item.messageOrderId },
                  item.messageType == 4 && React.createElement(
                    'div',
                    { className: 'message-item ' + item.className },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      item.messageContent
                    )
                  )
                );
              }),
              !interactBranch.data.length && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'request-none' },
                  React.createElement('img', {
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png',
                    mode: 'widthFix'
                  }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            ),
            React.createElement(
              _ScrollView.ScrollView,
              {
                id: 'myMessage-push-message',
                className: 'myMessage-content ' + (messageType == 16 ? 'active' : ''),
                'scroll-y': 'true',
                lowerThreshold: '116',
                bindscrolltolower: this.checkMoreMessageData
              },
              pushBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: item.messageOrderId },
                  item.messageType == 16 && React.createElement(
                    'div',
                    {
                      className: 'message-item ' + item.className,
                      'data-event-params': item.messageEventParams,
                      onClick: _this2.tapEventCommonHandler
                    },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      item.messageContent
                    )
                  )
                );
              }),
              !pushBranch.data.length && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'request-none' },
                  React.createElement('img', {
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png',
                    mode: 'widthFix'
                  }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            )
          ),
          messageDetail == 3 && React.createElement(
            'div',
            { className: 'myMessage-detail-form' },
            React.createElement(
              'div',
              { className: 'myMessage-form-list' },
              messageDetailFormData.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'myMessage-form-item', key: index },
                  React.createElement(
                    'div',
                    { className: 'data-name' },
                    item.dataName
                  ),
                  item.dataType != 2 && item.dataType != 12 ? React.createElement(
                    'div',
                    { className: 'data-content' },
                    item.dataContent
                  ) : item.dataType == 2 ? React.createElement(
                    React.Fragment,
                    null,
                    pictureWxsModule.isArray(item.dataContent) ? React.createElement(
                      React.Fragment,
                      null,
                      item.dataContent.map(function (pic, index) {
                        return React.createElement('img', {
                          key: index,
                          className: 'data-img',
                          src: pic
                        });
                      })
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      React.createElement('img', {
                        key: true,
                        className: 'data-img',
                        src: item.dataContent
                      })
                    )
                  ) : item.dataType == 12 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'data-content' },
                      item.dataContent.map(function (videoItem, videoIndex) {
                        return React.createElement(
                          'div',
                          { className: 'video-item', key: videoIndex },
                          React.createElement(
                            'video',
                            {
                              id: 'wxParse' + videoIndex,
                              className: 'video',
                              poster: videoItem.previewImageUrl,
                              src: videoItem.fileName,
                              'data-id': 'wxParse' + videoIndex,
                              onPlay: _this2.bindPlayVideo,
                              controls: true
                            },
                            React.createElement(CoverView, {
                              className: 'controls',
                              'data-tag': index,
                              'data-index': videoIndex,
                              hidden: videoItem.fileName == videoItem.virtual,
                              'data-id': 'wxParse' + videoIndex,
                              onClick: _this2.bindplay
                            })
                          )
                        );
                      })
                    )
                  )
                );
              })
            ),
            review_switch == 1 && React.createElement(
              'div',
              { className: 'myMessage-form-list' },
              React.createElement(
                'div',
                { className: 'myMessage-form-item' },
                React.createElement(
                  'div',
                  { className: 'data-name' },
                  '\u72B6\u6001'
                ),
                React.createElement(
                  'div',
                  { className: 'data-content' },
                  form_data.review_status == 0 ? reviewList.applying_text || '待审核' : form_data.review_status == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                )
              ),
              form_data.review_result && React.createElement(
                'div',
                { className: 'myMessage-form-item' },
                React.createElement(
                  'div',
                  { className: 'data-name' },
                  '\u5907\u6CE8'
                ),
                React.createElement(
                  'div',
                  { className: 'data-content' },
                  form_data.review_result
                )
              )
            ),
            React.createElement(
              'div',
              {
                className: 'myMessage-form-confirm',
                onClick: this.confirmMessageDetailForm
              },
              '\u5173\u95ED'
            )
          )
        )
      );
    }
  }]);
  return MyMessage;
}(_OfficialPage3.default);

exports.default = MyMessage;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(520);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyIntegral = function (_OfficialPage) {
  (0, _inherits3.default)(MyIntegral, _OfficialPage);

  function MyIntegral(props) {
    (0, _classCallCheck3.default)(this, MyIntegral);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyIntegral.__proto__ || Object.getPrototypeOf(MyIntegral)).call(this, props));

    _this.state = {
      integralPage: 0, // 控制是否展开 0:显示主页 1:显示积分规则页
      canUseIntegral: 0, // 现有积分
      totalIntegral: 0, // 总积分
      integralFontSize: 60, // 根据积分长度改变积分字体大小
      currentMessageType: 'income', // income:收入 / outcome:支出
      navFixed: false, // 固定导航条
      integralRule: {
        convertNum: 100, // xx积分对应1元
        consumeNum: 0, // 消费xx元积累1积分
        loginNum: 0, // 每天登录送xx积分
        postCommentNum: 0, // 商品评论送xx积分
        shareNum: 0 // 推荐好友送xx积分
      },
      incomeBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false
      },
      outcomeBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false
      }
    };
    _this.headHeight = 180;

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          var integralLength = ('' + res.data.can_use_integral).length + ('' + res.data.total_integral).length;
          var fontSize = integralLength > 0 ? 60 - integralLength * 2 : 60;
          that.setData({
            canUseIntegral: res.data.can_use_integral,
            totalIntegral: res.data.total_integral,
            integralFontSize: fontSize
          });
        }
      });
    };

    _this.getIntegralRuleData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/IntegralRule',
        success: function success(res) {
          that.setData({
            'integralRule.convertNum': res.data.convert_num || 0,
            'integralRule.consumeNum': res.data.consume_num,
            'integralRule.loginNum': res.data.login_num || 0,
            'integralRule.postCommentNum': res.data.post_comment_num,
            'integralRule.shareNum': res.data.share_num
          });
        }
      });
    };

    _this.getMessageData = function (type, page) {
      var that = _this;
      var action = '';
      if (type == 'income') {
        action = 'add';
      } else if (type = 'outcome') {
        action = 'minus';
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/UserIntegralAction',
        data: {
          action: action,
          page: page || 1
        },
        success: function success(res) {
          switch (type) {
            case 'income':
              that.setData({
                'incomeBranch.data': (that.data.incomeBranch.data ? that.data.incomeBranch.data.concat(that.parseMessageData(res.data)) : that.parseMessageData(res.data)) || '',
                'incomeBranch.isMore': res.is_more,
                'incomeBranch.currentPage': res.current_page || '',
                'incomeBranch.onload': false
              });
              break;
            case 'outcome':
              that.setData({
                'outcomeBranch.data': (that.data.outcomeBranch.data ? that.data.outcomeBranch.data.concat(that.parseMessageData(res.data)) : that.parseMessageData(res.data)) || '',
                'outcomeBranch.isMore': res.is_more,
                'outcomeBranch.currentPage': res.current_page || '',
                'outcomeBranch.onload': false
              });
              break;
          }
        }
      });
    };

    _this.parseMessageData = function (data) {
      var that = _this;
      var array = [];
      var item = {};
      for (var i = 0; i < data.length; i++) {
        item = {
          content: data[i].content,
          num: data[i].num,
          time: data[i].time
        };
        array.push(item);
      }
      return array;
    };

    _this.checkMoreMessageData = function () {
      var that = _this;
      switch (that.data.currentMessageType) {
        case 'income':
          if (that.data.incomeBranch.isMore != 0 && !that.data.incomeBranch.onload) {
            that.getMessageData('income', that.data.incomeBranch.currentPage + 1);
            that.setData({
              'incomeBranch.onload': true
            });
          }
          break;
        case 'outcome':
          if (that.data.outcomeBranch.isMore != 0 && !that.data.outcomeBranch.onload) {
            that.getMessageData('outcome', that.data.outcomeBranch.currentPage + 1);
            that.setData({
              'outcomeBranch.onload': true
            });
          }
          break;
      }
    };

    _this.fixedMessageNav = function (event) {
      var that = _this;
      if (event.target.scrollTop <= _this.headHeight) {
        that.setData({
          navFixed: false
        });
      } else {
        that.setData({
          navFixed: true
        });
      }
    };

    _this.setCurrentMessageType = function (event) {
      _this.setData({
        currentMessageType: event.target.dataset.type
      });
    };

    _this.showIntegralRule = function () {
      _app.appMethod.setPageTitle('积分规则');
      _this.setData({
        integralPage: 1
      });
    };

    _this.hideIntegralRule = function () {
      _app.appMethod.setPageTitle('个人积分');
      _this.setData({
        integralPage: 0
      });
    };

    _this.gotoRecharge = function () {
      _app.appMethod.turnToPage('/gptrecharge');
    };

    document.title = '个人积分';
    return _this;
  }

  (0, _createClass3.default)(MyIntegral, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getIntegralDetailData();
      this.getIntegralRuleData();
      this.getMessageData('income');
      this.getMessageData('outcome');
      this.headHeight = 360 / (_app.appMethod.globalData.systemInfo && _app.appMethod.globalData.systemInfo.rpxRatio ? _app.appMethod.globalData.systemInfo.rpxRatio : 2);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          integralFontSize = _state.integralFontSize,
          canUseIntegral = _state.canUseIntegral,
          totalIntegral = _state.totalIntegral,
          currentMessageType = _state.currentMessageType,
          navFixed = _state.navFixed,
          incomeBranch = _state.incomeBranch,
          outcomeBranch = _state.outcomeBranch,
          integralPage = _state.integralPage,
          integralRule = _state.integralRule;

      return React.createElement(
        'div',
        { className: 'official-page my-integral' },
        React.createElement(_TopNav.TopNav, { title: '\u4E2A\u4EBA\u79EF\u5206' }),
        React.createElement(
          'div',
          { className: 'myIntegral-wrap page', id: 'myIntegral' },
          integralPage == 0 && React.createElement(
            _ScrollView.ScrollView,
            {
              className: 'myIntegral-content',
              bindscroll: this.fixedMessageNav,
              'scroll-y': 'true',
              lowerThreshold: '116',
              bindscrolltolower: this.checkMoreMessageData
            },
            React.createElement(
              'div',
              { className: 'integral-detail' },
              React.createElement(
                'div',
                null,
                React.createElement('img', {
                  src: 'https://cdn.jisuapp.cn/zhichi_frontend/static/jisuapp_editor/images/integralBg.png',
                  className: 'integral-bg-img'
                })
              ),
              React.createElement('div', { className: 'integral-card-bg' }),
              React.createElement(
                'div',
                { className: 'integral-card' },
                React.createElement('div', { className: 'integral-detail-circle' }),
                React.createElement(
                  'div',
                  {
                    className: 'detail-num',
                    style: (0, _tools.convertLineStyleData)('font-size:' + integralFontSize + 'rpx')
                  },
                  React.createElement(
                    'span',
                    null,
                    canUseIntegral + ' / ' + totalIntegral
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail-name' },
                  React.createElement(
                    'span',
                    null,
                    '\u73B0\u6709\u79EF\u5206/\u603B\u79EF\u5206'
                  )
                ),
                React.createElement('div', { className: 'integral-detail-bottomline' })
              ),
              React.createElement(
                'div',
                { className: 'integral-recharge', onClick: this.gotoRecharge },
                React.createElement(
                  'span',
                  null,
                  '\u53BB\u5145\u503C'
                )
              ),
              React.createElement(
                'div',
                { className: 'detail-rule', onClick: this.showIntegralRule },
                React.createElement(
                  'span',
                  null,
                  '\u79EF\u5206\u89C4\u5219'
                ),
                React.createElement(
                  'div',
                  { className: 'single-icon' },
                  '?'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'message-nav' },
              React.createElement(
                'div',
                {
                  className: 'type-item ' + (currentMessageType == 'income' ? 'active' : ''),
                  onClick: this.setCurrentMessageType,
                  'data-type': 'income'
                },
                '\u6536\u5165'
              ),
              React.createElement(
                'div',
                {
                  className: 'type-item ' + (currentMessageType == 'outcome' ? 'active' : ''),
                  onClick: this.setCurrentMessageType,
                  'data-type': 'outcome'
                },
                '\u652F\u51FA'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'message-nav ' + (navFixed ? 'fixed' : 'nofixed')
              },
              React.createElement(
                'div',
                {
                  className: 'type-item ' + (currentMessageType == 'income' ? 'active' : ''),
                  onClick: this.setCurrentMessageType,
                  'data-type': 'income'
                },
                '\u6536\u5165'
              ),
              React.createElement(
                'div',
                {
                  className: 'type-item ' + (currentMessageType == 'outcome' ? 'active' : ''),
                  onClick: this.setCurrentMessageType,
                  'data-type': 'outcome'
                },
                '\u652F\u51FA'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'message-content ' + (currentMessageType == 'income' ? 'active' : '')
              },
              incomeBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    { className: 'message-item' },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.content
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.time
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-num' },
                      item.num
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              {
                className: 'message-content ' + (currentMessageType == 'outcome' ? 'active' : '')
              },
              outcomeBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    { className: 'message-item' },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.content
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.time
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-num' },
                      item.num
                    )
                  )
                );
              })
            )
          ),
          integralPage == 1 && React.createElement(
            'div',
            { className: 'myIntegral-rule' },
            React.createElement(
              'div',
              { className: 'rule-list' },
              !!+integralRule.consumeNum && integralRule.consumeNum != 0 && React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u79EF\u7D2F\u89C4\u5219'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  '消费 ' + integralRule.consumeNum + ' 元，获得 1 积分'
                )
              ),
              integralRule.loginNum != 0 && React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u989D\u5916\u79EF\u5206'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  '每天登录送 ' + integralRule.loginNum + ' 积分'
                )
              ),
              integralRule.shareNum != 0 && React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u989D\u5916\u79EF\u5206'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  '推荐好友送 ' + integralRule.shareNum + ' 积分'
                )
              ),
              integralRule.postCommentNum != 0 && React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u989D\u5916\u79EF\u5206'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  '商品评论送 ' + integralRule.postCommentNum + ' 积分'
                )
              ),
              React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u4F7F\u7528\u79EF\u5206'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  (integralRule.convertNum || '100') + ' 积分 = 1元'
                )
              ),
              React.createElement(
                'div',
                { className: 'rule-item' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u63D0\u9192'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  '\u6D88\u8D39\u79EF\u5206\u5E76\u4E0D\u4F1A\u5F71\u54CD\u5347\u7EA7\u4F1A\u5458\u5361\uFF0C\u4E0E\u4F1A\u5458\u5347\u7EA7\u76F8\u5173\u7684\u662F\u603B\u79EF\u5206'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'confirm-btn', onClick: this.hideIntegralRule },
              '\u786E\u5B9A'
            )
          )
        )
      );
    }
  }]);
  return MyIntegral;
}(_OfficialPage3.default);

exports.default = MyIntegral;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(522);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupRules = function (_OfficialPage) {
  (0, _inherits3.default)(GroupRules, _OfficialPage);

  function GroupRules(props) {
    (0, _classCallCheck3.default)(this, GroupRules);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupRules.__proto__ || Object.getPrototypeOf(GroupRules)).call(this, props));

    _this.state = {};

    _this.onPullDownRefresh = function () {};

    _this.onReachBottom = function () {};

    document.title = '拼团须知';
    return _this;
  }

  (0, _createClass3.default)(GroupRules, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'official-page group-rules' },
        React.createElement(_TopNav.TopNav, { title: '\u62FC\u56E2\u987B\u77E5' }),
        React.createElement(
          'div',
          { className: 'wrap' },
          React.createElement(
            'div',
            { className: 'title' },
            '\u53C2\u4E0E\u6761\u4EF6'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '1. \u53C2\u4E0E\u7528\u6237\uFF08\u5305\u62EC\u5F00\u56E2\u7528\u6237\u548C\u53C2\u56E2\u7528\u6237\uFF09\u9700\u5728\u5C0F\u7A0B\u5E8F\u5185\u5141\u8BB8\u6388\u6743\uFF0C\u5E76\u7ED1\u5B9A\u6709\u6548\u624B\u673A\u53F7\u7801\uFF0C\u624D\u80FD\u53C2\u52A0\u62FC\u56E2\u6D3B\u52A8\u3002\uFF08\u82E5\u8FDB\u5165\u65F6\u672A\u5141\u8BB8\u6388\u6743\uFF0C\u8BF7\u70B9\u51FB\u53F3\u4E0A\u89D2\uFF0C\u9009\u62E9\u5173\u4E8E\uFF0C\u5728\u8BBE\u7F6E\u91CC\u6253\u5F00\u6388\u6743\u3002\uFF09'
          ),
          React.createElement(
            'div',
            { className: 'title' },
            '\u73A9\u6CD5\u4ECB\u7ECD'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '1. \u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u4E0B\u5355\u53D1\u8D77\u62FC\u56E2\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '2. \u7528\u6237\u53EA\u6709\u4ED8\u6B3E\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u5F00\u56E2\u6216\u8005\u6210\u529F\u53C2\u56E2\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u4ED8\u6B3E\u4E0D\u7B97\u6709\u6548\u53C2\u4E0E\u62FC\u56E2\u73A9\u6CD5\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '3. \u62FC\u56E2\u5217\u8868\u4E2D\u663E\u793AN\u4EBA\u56E2\uFF0C\u4E3AN\u4EBA\u6210\u56E2\uFF08\u4F8B\uFF1A3\u4EBA\u56E2\u542B\u4E49\u4E3A3\u4EBA\u6210\u56E2\uFF0C\u5148\u4ED8\u6B3E\u7684\u6210\u5458\u5148\u52A0\u5165\u56E2\uFF0C\u4EBA\u6570\u6EE13\u4EBA\u5373\u4E3A\u62FC\u56E2\u6210\u529F\uFF09\u3002\u6BCF\u4F4D\u7528\u6237\u5728\u540C\u4E00\u4E2A\u56E2\u5185\u53EA\u53601\u4E2A\u62FC\u56E2\u4EBA\u6570\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '4. \u7528\u6237\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u62FC\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u5982\u679C\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u62FC\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u89E6\u53D1\u9000\u6B3E\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '5. \u4E3A\u4FDD\u8BC1\u62FC\u56E2\u6210\u529F\uFF0C\u5F00\u56E2\u65F6\u8BF7\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u9009\u62E9\u5408\u9002\u7684\u62FC\u56E2\u4EBA\u6570\u3002'
          ),
          React.createElement(
            'div',
            { className: 'title' },
            '\u6CE8\u610F\u4E8B\u9879'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '1. \u7528\u6237\u9700\u5728\u5F00\u56E2\u540E\u89C4\u5B9A\u7684\u62FC\u56E2\u65F6\u9650\u5185\u5B8C\u6210\u62FC\u56E2\uFF0C\u5982\u679C\u5728\u62FC\u56E2\u65F6\u9650\u5185\u5546\u54C1\u62FC\u56E2\u6D3B\u52A8\u7ED3\u675F\uFF0C\u62FC\u56E2\u4ECD\u672A\u6210\u529F\uFF0C\u5219\u9ED8\u8BA4\u7528\u6237\u62FC\u56E2\u5931\u8D25\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '2. \u5546\u54C1\u5F00\u56E2\u671F\u95F4\uFF0C\u7528\u6237\u8FDB\u884C\u4E2D\u7684\u56E2\uFF08\u5305\u62EC\u81EA\u884C\u5F00\u56E2\u4E0E\u53C2\u56E2\uFF09\u6570\u91CF\u4E0D\u5F97\u8D85\u8FC7\u5546\u5BB6\u9650\u5236\u7684\u6570\u91CF\uFF08\u62FC\u56E2\u6210\u529F\u4E0E\u62FC\u56E2\u5931\u8D25\u7684\u56E2\u4E0D\u8BA1\u5165\u8FDB\u884C\u4E2D\u7684\u56E2\uFF09\uFF0C\u5728\u6BCF\u4E2A\u56E2\u4E2D\u8D2D\u4E70\u7684\u5546\u54C1\u6570\u91CF\u4E0D\u5F97\u8D85\u8FC7\u5546\u5BB6\u9650\u5236\u7684\u6570\u91CF\u3002'
          ),
          React.createElement(
            'div',
            { className: 'content' },
            '3. \u7528\u6237\u4ED8\u6B3E\u6210\u529F\u540E\uFF0C\u5728\u62FC\u56E2\u8FDB\u884C\u65F6\u4E0D\u53EF\u7533\u8BF7\u9000\u6B3E\u3002'
          )
        )
      );
    }
  }]);
  return GroupRules;
}(_OfficialPage3.default);

exports.default = GroupRules;

/***/ }),
/* 522 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(524);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GroupOrderDetail, _OfficialPage);

  function GroupOrderDetail(props) {
    (0, _classCallCheck3.default)(this, GroupOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GroupOrderDetail.__proto__ || Object.getPrototypeOf(GroupOrderDetail)).call(this, props));

    _this2.state = {
      list: {},
      more_members_arr: [],
      orderId: ''
    };

    _this2.getOrderInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/GetGroupBuyOrderInfo',
        data: {
          order_id: _this.data.orderId,
          sub_app_id: _this.data.franchisee
        },
        success: function success(res) {
          var data = res.data;
          var remark = data.form_data.remark;
          var more_members_arr = [];
          var max_user_num = Number(data.form_data.group_buy_order_info.max_user_num);
          var length = 0;
          if (max_user_num <= 5) {
            length = max_user_num - data.form_data.group_buy_order_info.team_member_list.length;
            for (var i = 0; i < length; i++) {
              more_members_arr.push('');
            }
          } else {
            length = 3 - data.form_data.group_buy_order_info.team_member_list.length;
            for (var _i = 0; _i < length; _i++) {
              more_members_arr.push('');
            }
          }
          data.form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark;
          _this.setData({
            list: data,
            more_members_arr: more_members_arr
          });
        }
      });
    };

    _this2.onShareAppMessage = function (e) {
      var that = _this2,
          goodsInfo = _this2.data.list.form_data.goods_info[0],
          teamToken = _this2.data.list.form_data.team_token,
          id = e.from == 'button' ? e.target.dataset.detail : goodsInfo.goods_id,
          franchisee = _this2.data.franchisee,
          url = '/joinGroupDetail?detail=' + goodsInfo.goods_id + '&teamToken=' + teamToken + (franchisee ? '&franchisee=' + franchisee : '') + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : ''),
          title = _app.appMethod.getUserInfo('nickname') + ' 喊你拼单啦~ ' + goodsInfo.price + '元拼' + goodsInfo.goods_name + '，火爆抢购中......';
      return _app.appMethod.shareAppMessage({
        title: title,
        path: url,
        imageUrl: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
        success: function success(addTime) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    _this2.pay = function (e) {
      var _this = _this2;
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: e.target.dataset.id,
      //     sub_shop_app_id: _this.data.franchisee
      //   },
      //   success: function(res) {
      //     var param = res.data,
      //       orderId = e.target.dataset.id
      //     param.orderId = orderId
      //     param.goodsType = e.target.dataset.type
      //     param.success = function() {
      //       setTimeout(function() {
      //         let franchiseeParam = _this.data.franchisee
      //           ? '&franchisee=' + _this.data.franchisee
      //           : ''
      //         app.turnToPage(
      //           '/groupOrderDetail?id=' +
      //           orderId +
      //           franchiseeParam
      //         )
      //       }, 1500)
      //     }
      //     app.wxPay(param)
      //   }
      // })
      var franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
      var path = '/groupOrderDetail?id=' + orderId + franchiseeParam;
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: path
      });
    };

    _this2.retrieveMoney = function (e) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ComfirmRefund',
        data: {
          order_id: e.target.dataset.id,
          sub_shop_app_id: _this.data.franchisee
        },
        success: function success(data) {
          if (data.status === 0) {
            Taro.showToast({
              title: '确认成功'
            });
            _this.getOrderInfo();
            _app.appMethod.globalData.myGroupRefresh = true;
          }
        }
      });
    };

    _this2.onceMore = function (e) {
      var id = e.currentTarget.dataset.id;
      var franchiseeParam = _this2.data.franchisee ? '&franchisee=' + _this2.data.franchisee : '';
      _app.appMethod.turnToPage('/groupGoodsDetail?detail=' + id + franchiseeParam);
    };

    _this2.goToOrderDetail = function () {
      _app.appMethod.turnToPage('/myOrder');
    };

    document.title = '拼团详情';
    return _this2;
  }

  (0, _createClass3.default)(GroupOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var _this = this;
      _this.setData({
        orderId: options.id || '',
        franchisee: options.franchisee || ''
      });
      _this.getOrderInfo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          list = _state.list,
          more_members_arr = _state.more_members_arr;

      return React.createElement(
        'div',
        { className: 'official-page group-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u62FC\u56E2\u8BE6\u60C5' }),
        list.form_data && React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'order-status' },
            React.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;'),
                hidden: !(list.form_data.group_buy_order_info.current_status == 1)
              },
              '\u672A\u5F00\u56E2'
            ),
            React.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;'),
                hidden: !(list.form_data.group_buy_order_info.current_status == 2)
              },
              '\u62FC\u56E2\u4E2D'
            ),
            React.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;'),
                hidden: !(list.form_data.group_buy_order_info.current_status == 3)
              },
              '\u62FC\u56E2\u6210\u529F'
            ),
            React.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;'),
                hidden: !(list.form_data.group_buy_order_info.current_status == 4)
              },
              '\u62FC\u56E2\u5931\u8D25'
            ),
            React.createElement(
              'div',
              {
                style: (0, _tools.convertLineStyleData)('margin-bottom:20rpx;'),
                hidden: !(list.form_data.group_buy_order_info.current_status == 5)
              },
              '\u62FC\u56E2\u7ED3\u675F'
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('font-size:26rpx;') },
              '团号：' + list.form_data.team_token
            )
          ),
          React.createElement(
            'div',
            { className: 'contact-info container' },
            React.createElement('div', { className: 'ico-moon icon-location' }),
            React.createElement(
              'div',
              { className: 'detail-info' },
              React.createElement(
                'div',
                { className: 'address' },
                list.form_data.is_self_delivery != 1 ? '配送地址：' + list.form_data.address_info.province.text + list.form_data.address_info.city.text + list.form_data.address_info.district.text + list.form_data.address_info.detailAddress : '自提地址：' + list.form_data.self_delivery_info.address
              ),
              React.createElement(
                'div',
                { className: 'address' },
                '联系人：' + (list.form_data.is_self_delivery != 1 ? list.form_data.address_info.name : list.form_data.self_delivery_info.contact_name)
              ),
              React.createElement(
                'div',
                { className: 'address' },
                '联系电话：' + (list.form_data.is_self_delivery != 1 ? list.form_data.address_info.contact : list.form_data.self_delivery_info.contact_phone)
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'contact-info container' },
            React.createElement('div', { className: 'ico-moon icon-comment' }),
            React.createElement(
              'div',
              { className: 'detail-info' },
              React.createElement(
                'div',
                { className: 'address' },
                '\u4E70\u5BB6\u7559\u8A00'
              ),
              React.createElement(
                'div',
                { className: 'address' },
                React.createElement(
                  'span',
                  null,
                  list.form_data.remark
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'container order-detail' },
            React.createElement(
              'div',
              { className: 'order-id' },
              '订单号：' + list.form_data.order_id
            ),
            React.createElement(
              'div',
              { className: 'goods-wrap' },
              React.createElement('img', { src: list.form_data.goods_info[0].cover }),
              React.createElement(
                'div',
                { className: 'price' },
                React.createElement(
                  'div',
                  { className: 'space-between' },
                  React.createElement(
                    'div',
                    { className: 'goods-name text-overflow' },
                    list.form_data.goods_info[0].goods_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'pay-price' },
                    '¥' + list.form_data.goods_info[0].original_price
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'origin-price' },
                  '拼团(-¥' + list.form_data.group_buy_order_info.discount_price + ')'
                ),
                React.createElement(
                  'div',
                  { className: 'space-between' },
                  React.createElement(
                    'div',
                    { className: 'goods-spec text-overflow' },
                    list.form_data.goods_info[0].model_value
                  ),
                  React.createElement(
                    'div',
                    { className: 'num' },
                    'x' + list.form_data.goods_info[0].num
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'discount' },
              React.createElement(
                'div',
                { className: 'content' },
                React.createElement('div', { className: 'ico-moon icon-group-pay' }),
                '储值金：' + list.form_data.use_balance
              ),
              React.createElement(
                'div',
                { className: 'content' },
                React.createElement('div', { className: 'ico-moon icon-coupon' }),
                '优惠方式：' + list.form_data.selected_benefit.title
              )
            ),
            React.createElement(
              'div',
              { className: 'order-info' },
              '共' + list.form_data.goods_info[0].num + '件商品 实付：',
              React.createElement(
                'span',
                { className: 'red-price' },
                '¥' + list.form_data.total_price
              ),
              '(含运费¥' + list.express_fee + ')'
            ),
            React.createElement(
              'div',
              {
                className: 'progress',
                hidden: list.form_data.group_buy_order_info.team_member_list.length === 0
              },
              React.createElement(
                'div',
                { className: 'title' },
                '\u62FC\u56E2\u8FDB\u5EA6\uFF1A'
              ),
              React.createElement(
                'div',
                { className: 'head-logo' },
                React.createElement(
                  'div',
                  { className: 'group-leader' },
                  React.createElement('img', {
                    src: list.form_data.group_buy_order_info.team_member_list[0].thumb
                  }),
                  React.createElement(
                    'div',
                    { className: 'tag' },
                    '\u56E2\u957F'
                  )
                ),
                list.form_data.group_buy_order_info.max_user_num <= 5 && React.createElement(
                  'div',
                  { className: 'group-number' },
                  list.form_data.group_buy_order_info.team_member_list.map(function (item, index) {
                    return React.createElement('img', {
                      key: index,
                      hidden: index === 0,
                      className: 'members',
                      src: item.thumb
                    });
                  }),
                  more_members_arr.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index, className: 'more-members' },
                      '?'
                    );
                  })
                ),
                list.form_data.group_buy_order_info.max_user_num > 5 && React.createElement(
                  'div',
                  { className: 'group-number' },
                  list.form_data.group_buy_order_info.team_member_list.map(function (item, index) {
                    return React.createElement('img', {
                      key: index,
                      className: 'members',
                      hidden: index === 0 || index > 2,
                      src: item.thumb
                    });
                  }),
                  more_members_arr.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index, className: 'more-members' },
                      '?'
                    );
                  }),
                  React.createElement(
                    'div',
                    { className: 'omit' },
                    '...'
                  ),
                  list.form_data.group_buy_order_info.team_member_list.length < list.form_data.group_buy_order_info.max_user_num && React.createElement(
                    'div',
                    { className: 'more-members' },
                    '?'
                  ),
                  list.form_data.group_buy_order_info.team_member_list.length == list.form_data.group_buy_order_info.max_user_num && React.createElement('img', {
                    className: 'members',
                    src: list.form_data.group_buy_order_info.team_member_list[list.form_data.group_buy_order_info.max_user_num - 1].thumb
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'total-mumber' },
                '\u5DF2\u62FC',
                React.createElement(
                  'span',
                  { className: 'red-price' },
                  list.form_data.group_buy_order_info.current_user_count
                ),
                '\u4EBA\uFF0C\u8FD8\u5DEE',
                React.createElement(
                  'span',
                  { className: 'red-price' },
                  list.form_data.group_buy_order_info.max_user_num - list.form_data.group_buy_order_info.current_user_count
                ),
                '\u4EBA\u6210\u56E2'
              )
            ),
            React.createElement(
              'div',
              { className: 'group-info' },
              React.createElement(
                'div',
                { className: 'centent' },
                '下单时间：' + list.form_data.add_time
              ),
              React.createElement(
                'div',
                { className: 'centent' },
                '拼团人数：' + list.form_data.group_buy_order_info.max_user_num + '人团'
              ),
              React.createElement(
                'div',
                { className: 'centent' },
                '拼团时限：' + list.form_data.group_buy_order_info.hour_of_duration + '小时' + list.form_data.group_buy_order_info.minute_of_duration + '分钟'
              ),
              React.createElement(
                'div',
                {
                  className: 'centent',
                  hidden: !(list.form_data.group_buy_order_info.current_status == 3)
                },
                '结束时间：' + list.form_data.group_buy_order_info.expired_time
              ),
              React.createElement(
                'div',
                {
                  className: 'centent',
                  hidden: !(list.form_data.group_buy_order_info.current_status == 3)
                },
                '成功时间：' + list.form_data.group_buy_order_info.success_time
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'group-btn',
              hidden: !(list.form_data.group_buy_order_info.current_status == 1)
            },
            React.createElement(
              'div',
              { className: 'btn white hide' },
              '\u53D6\u6D88\u62FC\u56E2'
            ),
            React.createElement(
              'div',
              {
                className: 'btn red',
                'data-id': list.form_data.order_id,
                'data-type': list.form_data.goods_type,
                onClick: this.pay
              },
              '\u7ACB\u5373\u652F\u4ED8'
            )
          ),
          React.createElement(
            'div',
            {
              className: 'group-btn',
              hidden: !(list.form_data.group_buy_order_info.current_status == 2)
            },
            React.createElement(
              'button',
              {
                className: 'btn red',
                openType: 'share',
                'data-detail': list.form_data.goods_info[0].goods_id,
                onClick: this.shareClickEvent
              },
              '\u5206\u4EAB'
            )
          ),
          React.createElement(
            'div',
            {
              className: 'group-btn',
              hidden: !(list.form_data.group_buy_order_info.current_status == 3)
            },
            React.createElement(
              'div',
              {
                className: 'btn white',
                style: (0, _tools.convertLineStyleData)('color:#000;'),
                onClick: this.goToOrderDetail
              },
              '\u67E5\u770B\u8BA2\u5355'
            ),
            React.createElement(
              'div',
              {
                className: 'btn yellow',
                'data-id': list.form_data.goods_info[0].goods_id,
                onClick: this.onceMore
              },
              '\u518D\u62FC\u4E00\u6B21'
            )
          ),
          React.createElement(
            'div',
            {
              className: 'group-btn',
              hidden: !(list.form_data.group_buy_order_info.current_status == 4)
            },
            React.createElement(
              'div',
              {
                className: 'btn white',
                'data-id': list.form_data.order_id,
                onClick: this.retrieveMoney,
                hidden: list.form_data.group_buy_order_info.current_status == 7
              },
              '\u5DF2\u6536\u5230\u9000\u6B3E'
            ),
            React.createElement(
              'div',
              {
                className: 'btn yellow',
                'data-id': list.form_data.goods_info[0].goods_id,
                onClick: this.onceMore
              },
              '\u518D\u62FC\u4E00\u6B21'
            )
          )
        )
      );
    }
  }]);
  return GroupOrderDetail;
}(_OfficialPage3.default);

exports.default = GroupOrderDetail;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _TopNav = __webpack_require__(8);

__webpack_require__(526);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupCenter = function (_OfficialPage) {
  (0, _inherits3.default)(GroupCenter, _OfficialPage);

  function GroupCenter(props) {
    (0, _classCallCheck3.default)(this, GroupCenter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupCenter.__proto__ || Object.getPrototypeOf(GroupCenter)).call(this, props));

    _this.state = {
      status: 4,
      formid: [],
      goodsData: {
        goods_list: []
      }
    };
    _this.page = 1;
    _this.isMore = 1;
    _this.seckillFunc = [];

    _this.pageInit = function () {
      var that = _this;
      if (_app.appMethod.isLogin()) {
        that.loadAll();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.loadAll();
          }
        });
      }
    };

    _this.loadAll = function () {
      var that = _this;
      that.loadList();
    };

    _this.loadList = function () {
      var that = _this;
      var goodsData = _this.data.goodsData;
      if (goodsData.is_more == 0 || goodsData.loading) {
        return;
      }
      that.setData({
        'goodsData.loading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/goodsList',
        data: {
          page: that.page,
          page_size: 10,
          status: 0,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var rdata = res.data,
              newdata = {},
              oldData = that.data.goodsData.goods_list || [],
              oldLen = oldData.length,
              downcountArr = that.downcountArr || [];
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i],
                dc = void 0;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00',
              day: '00'
            };
            f.server_time = rdata.current_time || Date.parse(new Date()) / 1000;
            f.seckill_end_time = _util2.default.formatTime(new Date(f.end_date * 1000));
            f.seckill_start_time = _util2.default.formatTime(new Date(f.start_date * 1000));
            f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
            if (f.status == 0 || f.status == 1 || f.status == 2) {
              dc = _app.appMethod.beforeGroupDownCount(f, that, 'goodsData.goods_list[' + (oldLen + i) + ']');
            } else if (f.status == 3) {
              if (f.end_date != '-1') {
                dc = _app.appMethod.duringGroupDownCount(f, that, 'goodsData.goods_list[' + (oldLen + i) + ']');
              }
            }
            dc && downcountArr.push(dc);
          }
          if (that.page == 1) {
            oldData = [];
          }
          newdata['goodsData.goods_list'] = oldData.concat(rdata);
          newdata['goodsData.is_more'] = res.is_more;
          that.downcountArr = downcountArr;
          that.setData(newdata);
          that.page++;
        },
        complete: function complete() {
          var newdata = {};
          newdata['goodsData.loading'] = false;
          that.setData(newdata);
        }
      });
    };

    _this.gotoDetail = function (e) {
      var that = _this,
          data = e.currentTarget.dataset;
      var franchisee = that.data.franchiseeId;
      var chainParam = franchisee ? '&franchisee=' + franchisee : '';
      _this.saveUserFormId(function () {
        var pageUrl = data.status == 4 ? '/goodsDetail?detail=' + data.goodsid + chainParam : '/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + chainParam;
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this.remainMe = function (e) {
      var that = _this,
          data = e.currentTarget.dataset,
          index = data.index,
          goodsList = that.data.goodsData.goods_list;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/careActivity',
        data: {
          data_id: data.goodsid,
          activity_id: data.activityid,
          activity_type: 0,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          for (var i = 0; i < goodsList.length; i++) {
            if (index == i) {
              _app.appMethod.showToast({
                title: '设置开团提醒成功！',
                duration: 2000
              });
              var newdata = {};
              newdata['goodsData.goods_list[' + i + '].status'] = 2;
              _this.setData(newdata);
            }
          }
        }
      });
    };

    _this.formSubmit_collect = function (e) {
      var formid = _this.data.formid;
      formid.push(e.detail.formId);
    };

    _this.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: that.data.franchiseeId,
          form_id: that.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          that.setData({
            formid: []
          });
        }
      });
    };

    _this.onPullDownRefresh = function () {
      _this.page = 1;
      _this.loadList();
      _this.pullRefreshTime = setTimeout(function () {
        Taro.stopPullDownRefresh();
      }, 3000);
    };

    _this.onReachBottom = function () {
      _this.loadList();
    };

    _this.onShareAppMessage = function () {};

    document.title = '拼团中心';
    return _this;
  }

  (0, _createClass3.default)(GroupCenter, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      that.setData({
        franchiseeId: options.franchisee || '',
        franchiseeIdInfo: {
          id: options.franchisee || ''
        }
      });
      that.pageInit();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcountArr && this.downcountArr.length) {
        this.downcountArr = this.downcountArr.concat().reverse();
        for (var i = 0; i < this.downcountArr.length; i++) {
          this.downcountArr[i] && this.downcountArr[i].clear();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var goodsData = this.state.goodsData;

      return React.createElement(
        'div',
        { className: 'official-page group-center' },
        React.createElement(_TopNav.TopNav, { title: '\u62FC\u56E2\u4E2D\u5FC3' }),
        React.createElement(
          'div',
          { className: 'app' },
          React.createElement(
            'div',
            { className: 'collage-goodsList' },
            React.createElement(
              'div',
              { className: 'collage-section' },
              React.createElement(
                'div',
                { className: 'goods-list list' },
                goodsData.goods_list.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'goods-item isRelative',
                      key: index,
                      onClick: _this2.gotoDetail,
                      'data-goodsid': item.goods_id,
                      'data-activityid': item.activity_id,
                      'data-status': item.status
                    },
                    React.createElement(
                      'div',
                      { className: 'image-wrap' },
                      React.createElement('img', { src: item.cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'content-wrap' },
                      React.createElement(
                        'div',
                        { className: 'title' },
                        React.createElement(
                          'div',
                          { className: 'type' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', { className: 'ico-moon icon-number-people' })
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.activity_type == 0 ? item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团'
                          )
                        ),
                        item.title
                      ),
                      !(item.status == 3 && item.end_date == '-1') ? React.createElement(
                        'div',
                        { className: 'same-line' },
                        React.createElement(
                          'div',
                          { className: 'first-line' },
                          React.createElement(
                            'div',
                            { className: 'price-detail' },
                            React.createElement(
                              'span',
                              { className: 'min-price' },
                              '\xA5',
                              React.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:36rpx;') },
                                item.group_buy_price
                              )
                            ),
                            React.createElement(
                              'span',
                              { className: 'origin-price' },
                              '¥' + item.original_price
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'to-join' },
                            item.status == 0 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'ready' },
                                '\u5373\u5C06\u5F00\u56E2'
                              )
                            ) : item.status == 1 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                {
                                  className: 'remain',
                                  onClick: _this2.remainMe,
                                  'data-goodsid': item.goods_id,
                                  'data-activityid': item.activity_id,
                                  'data-index': index
                                },
                                '\u63D0\u9192\u6211'
                              )
                            ) : item.status == 2 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'reminded' },
                                '\u5DF2\u63D0\u9192'
                              )
                            ) : item.status == 3 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'go' },
                                item.activity_type == 4 ? '参与抽奖' : '去拼团'
                              )
                            ) : item.status == 4 && React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'over' },
                                '\u5DF2\u7ED3\u675F'
                              )
                            )
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'second-line' },
                          React.createElement(
                            'div',
                            { className: 'sales-num' },
                            React.createElement(
                              React.Fragment,
                              null,
                              '已团' + item.goods_count + '件'
                            )
                          ),
                          !(item.status == 3 && item.end_date == '-1') && item.status != 4 && React.createElement(
                            'div',
                            { className: 'count-big-down' },
                            (item.status != 3 ? '距开始' : '距结束') + ' ' + (item.downCount.days != '00' && item.downCount.days != '0' ? item.downCount.days + '天' : '') + ' ' + item.downCount.hours + ' : ' + item.downCount.minutes + ' : ' + item.downCount.seconds
                          )
                        )
                      ) : React.createElement(
                        'div',
                        { className: 'differ-line' },
                        React.createElement(
                          'div',
                          { className: 'first-line' },
                          React.createElement(
                            'div',
                            { className: 'price-detail' },
                            React.createElement(
                              'span',
                              { className: 'min-price' },
                              '\xA5',
                              React.createElement(
                                'span',
                                { style: (0, _tools.convertLineStyleData)('font-size:36rpx;') },
                                item.group_buy_price
                              )
                            ),
                            React.createElement(
                              'span',
                              { className: 'origin-price' },
                              '¥' + item.original_price
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'sales-num' },
                            React.createElement(
                              React.Fragment,
                              null,
                              '已团' + item.goods_count + '件'
                            )
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'second-line' },
                          React.createElement(
                            'div',
                            { className: 'to-join' },
                            item.status == 0 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'ready' },
                                '\u5373\u5C06\u5F00\u56E2'
                              )
                            ) : item.status == 1 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                {
                                  className: 'remain',
                                  onClick: _this2.remainMe,
                                  'data-goodsid': item.goods_id,
                                  'data-activityid': item.activity_id,
                                  'data-index': index
                                },
                                '\u63D0\u9192\u6211'
                              )
                            ) : item.status == 2 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'reminded' },
                                '\u5DF2\u63D0\u9192'
                              )
                            ) : item.status == 3 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'go' },
                                item.activity_type == 4 ? '参与抽奖' : '去拼团'
                              )
                            ) : item.status == 4 && React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'over' },
                                '\u5DF2\u7ED3\u675F'
                              )
                            )
                          )
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return GroupCenter;
}(_OfficialPage3.default);

exports.default = GroupCenter;

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(528);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VipCardList = function (_OfficialPage) {
  (0, _inherits3.default)(VipCardList, _OfficialPage);

  function VipCardList(props) {
    (0, _classCallCheck3.default)(this, VipCardList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VipCardList.__proto__ || Object.getPrototypeOf(VipCardList)).call(this, props));

    _this.state = {
      topNavBarData: {
        title: '会员卡',
        isDefault: 0
      },
      vipList: []
    };

    _this.getVIPCardList = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetUserVIPCardList',
        data: {
          parent_app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          that.setData({
            vipList: res.data
          });
        },
        complete: function complete() {}
      });
    };

    _this.turnToVipCard = function (e) {
      var id = e.currentTarget.dataset.id;
      var appid = e.currentTarget.dataset.appid;
      var isPaidCard = e.currentTarget.dataset.ispaidcard;
      _app.appMethod.turnToPage('/eCommerce/pages/vipCard/vipCard?detail=' + id + '&franchisee=' + appid + '&is_paid_vip=' + isPaidCard);
    };

    document.title = '会员卡';
    return _this;
  }

  (0, _createClass3.default)(VipCardList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.getVIPCardList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          vipList = _state.vipList;

      return React.createElement(
        'div',
        { className: 'official-page vip-card-list' },
        React.createElement(_TopNav.TopNav, { title: '\u4F1A\u5458\u5361' }),
        React.createElement(
          'div',
          { className: 'page' },
          React.createElement(
            'div',
            { className: 'vip-banner' },
            React.createElement('img', {
              src: 'http://cdn.jisuapp.cn/static/webapp/images/franchisee/vip-banner.jpg',
              mode: 'aspectFill'
            })
          ),
          React.createElement(
            'div',
            { className: 'vip-list' },
            vipList.map(function (item, index) {
              return React.createElement(
                React.Fragment,
                { key: item.id },
                React.createElement(
                  'div',
                  {
                    className: 'vip-item',
                    style: (0, _tools.convertLineStyleData)('background: ' + (item.background_type == 1 ? item.background : 'url(' + item.background + ')') + ';background-size:cover;background-position:center center;'),
                    'data-appid': item.app_id,
                    'data-id': item.id,
                    'data-ispaidcard': item.is_paid_vip,
                    onClick: _this2.turnToVipCard
                  },
                  React.createElement(
                    'div',
                    { className: 'vip-item-cover' },
                    React.createElement('img', { src: item.logo, mode: 'aspectFill' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'vip-item-info' },
                    React.createElement(
                      'div',
                      { className: 'vip-item-title' },
                      item.app_name + ' ' + item.title
                    ),
                    item.discount != 0 ? React.createElement(
                      'div',
                      { className: 'vip-item-rights' },
                      '可享 ' + item.discount + '折'
                    ) : item.coupon_list && item.coupon_list != '' ? React.createElement(
                      'div',
                      { className: 'vip-item-rights' },
                      '\u53EF\u4EAB \u8D60\u9001\u4F18\u60E0\u5238'
                    ) : item.integral != 0 ? React.createElement(
                      'div',
                      { className: 'vip-item-rights' },
                      '可享 赠送' + item.integral + '积分'
                    ) : item.birthday_coupon_list && item.birthday_coupon_list != '' ? React.createElement(
                      'div',
                      { className: 'vip-item-rights' },
                      '\u751F\u65E5 \u8D60\u9001\u4F18\u60E0\u5238'
                    ) : item.is_free_postage && item.is_free_postage == 1 && React.createElement(
                      'div',
                      { className: 'vip-item-rights' },
                      '\u53EF\u4EAB \u5305\u90AE'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'vip-item-bottom' },
                    '有效日期: ' + (item.expired_time == -1 ? '永久有效' : item.expired_time)
                  )
                )
              );
            })
          ),
          vipList.length == 0 && React.createElement(
            'div',
            { className: 'no-receive-card' },
            React.createElement(
              'div',
              { className: 'tip-area' },
              React.createElement('img', {
                className: 'tip-img',
                src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/no-vip.png'
              }),
              React.createElement(
                'span',
                { className: 'tip-text-1' },
                '\u6682\u65E0\u53EF\u7528\u4F1A\u5458\u5361'
              ),
              React.createElement(
                'span',
                { className: 'tip-text-2' },
                '\u83B7\u53D6\u65B9\u5F0F\uFF0C\u53EF\u7559\u610F\u5E97\u5BB6\u6D88\u606F'
              )
            )
          )
        )
      );
    }
  }]);
  return VipCardList;
}(_OfficialPage3.default);

exports.default = VipCardList;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(530);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyFormMessage = function (_OfficialPage) {
  (0, _inherits3.default)(MyFormMessage, _OfficialPage);

  function MyFormMessage(props) {
    (0, _classCallCheck3.default)(this, MyFormMessage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyFormMessage.__proto__ || Object.getPrototypeOf(MyFormMessage)).call(this, props));

    _this.state = {
      messageType: 5, // 5:默认展示系统消息列表
      systemBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      interactBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      pushBranch: {
        data: [],
        isMore: 0,
        currentPage: 1,
        onload: false,
        unreadCount: 0
      },
      messageDetail: 0, // 控制是否展开 0:不展示消息详情页 3:展示表单详情页
      messageDetailFormData: [], //消息详情页：表单数据
      review_switch: 0 //  表单是否开启审核
    };

    _this.getMessageData = function (type, page) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppNotify/GetUserAppNotifyMsg',
        data: {
          app_id: _app.appMethod.globalData.appId,
          types: type || '5,6,16',
          page: page || ''
        },
        success: function success(res) {
          for (var key in res.data) {
            switch (parseInt(key)) {
              case 5:
                that.setData({
                  'systemBranch.data': that.data.systemBranch.data ? that.data.systemBranch.data.concat(that.parseMessageData(res.data[key].data)) : that.parseMessageData(res.data[key].data),
                  'systemBranch.isMore': res.data[key].is_more || '',
                  'systemBranch.currentPage': res.data[key].current_page || '',
                  'systemBranch.onload': false,
                  'systemBranch.unreadCount': res.data[key].unread_count || ''
                });
                break;
            }
          }
        }
      });
    };

    _this.parseMessageData = function (data) {
      var array = [];
      var contentJson = void 0;
      var item = void 0;
      for (var i = 0; i < data.length; i++) {
        switch (parseInt(data[i].type)) {
          case 3:
            contentJson = data[i].content && JSON.parse(data[i].content);
            item = {};
            item.messageType = parseInt(data[i].type);
            item.className = 'type-form';
            item.messageTitle = '表单提交成功';
            item.messageTime = data[i].add_time;
            item.messageImg = 'icon-message-form';
            item.messageContent = contentJson.form_name;
            item.messageForm = contentJson.form;
            item.messageFormId = contentJson.form_id;
            item.messageFormDataId = data[i].sub_id;
            item.review_status = data[i].data_info.length ? data[i].data_info[0].form_data.review_status : 3;
            item.review_switch = data[i].data_info ? data[i].data_info[0].form_data.review_switch : 0;
            array.push(item);
            break;
        }
      }
      return array;
    };

    _this.checkMoreMessageData = function (event) {
      var that = _this;
      var targetId = event.target.id;
      switch (targetId) {
        case 'myMessage-system-message':
          if (that.data.systemBranch.isMore != 0 && !that.data.systemBranch.onload) {
            that.getMessageData(5, that.data.systemBranch.currentPage + 1);
            that.setData({
              'systemBranch.onload': true
            });
          }
          break;
        case 'myMessage-interact-message':
          if (that.data.interactBranch.isMore != 0 && !that.data.interactBranch.onload) {
            that.getMessageData(6, that.data.interactBranch.currentPage + 1);
            that.setData({
              'interactBranch.onload': true
            });
          }
          break;
        case 'myMessage-push-message':
          var pushBranchData = that.data.pushBranch;
          if (pushBranchData.isMore != 0 && !pushBranchData.onload) {
            that.getMessageData(16, pushBranchData.currentPage + 1);
            that.setData({
              'pushBranch.onload': true
            });
          }
          break;
      }
    };

    _this.showMessageDetailForm = function (event) {
      var that = _this;
      var _form = event.currentTarget.dataset.form;
      var _formId = event.currentTarget.dataset.formId;
      var _formDataId = event.currentTarget.dataset.formDataId;
      var _formData_list = []; // 该表单对应的字段详情数组
      _app.appMethod.setPageTitle('表单消息');
      _app.appMethod.sendRequest({
        url: '/index.php?r=pc/WebAppMgr/getForm',
        data: {
          app_id: _app.appMethod.globalData.appId,
          form_id: _formId
        },
        success: function success(res) {
          _formData_list = res.data.field_arr;
          for (var i in _formData_list) {
            if (_formData_list[i].field === 'region_id') {
              _formData_list.splice(i, 1);
            }
          }
          that.setData({ review_switch: res.data.review_switch });
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppData/getFormData',
            data: {
              app_id: _app.appMethod.globalData.appId,
              form: _form,
              data_id: _formDataId
            },
            success: function success(res) {
              var _array = []; // 临时存放表单提交详情的显示数据
              var _form_data = res.data['0'].form_data;
              for (var key in _form_data) {
                var _index = -1; // 判断改表单提交详情对应在字段详情数组的位置
                for (var i = 0; i < _formData_list.length; i++) {
                  if (_formData_list[i]['field'] == key) {
                    _index = i;
                  }
                }
                if (_index == -1) continue;
                var _item = {}; // 临时存放
                switch (parseInt(_formData_list[_index]['type'])) {
                  case 1:
                    _item = {};
                    _item.dataType = 1;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = _form_data[key];
                    _array.push(_item);
                    break;
                  case 2:
                    _item = {};
                    _item.dataType = 2;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = _form_data[key];
                    _array.push(_item);
                    break;
                  case 3:
                    _item = {};
                    _item.dataType = 3;
                    _item.dataName = _formData_list[_index]['name'];
                    _item.dataContent = '富文本类型';
                    _array.push(_item);
                    break;
                }
                _index++;
              }
              that.setData({
                messageDetail: 3,
                messageDetailFormData: _array,
                form_data: _form_data
              });
            }
          });
        }
      });
    };

    _this.confirmMessageDetailForm = function () {
      _app.appMethod.setPageTitle('表单提交信息');
      _this.setData({
        messageDetail: 0,
        messageDetailFormData: []
      });
    };

    _this.getReviewConfig = function () {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppConfig/GetAppDataReviewTextConfig',
        method: 'post',
        hideLoading: true,
        success: function success(res) {
          _this.setData({ reviewList: res.data });
        }
      });
    };

    _this.bindplay = function (e) {
      var dataset = e.currentTarget.dataset;
      var tag = dataset.tag;
      var index = dataset.index;
      var id = dataset.id;
      var videoList = _this.data.messageDetailFormData[tag].dataContent;
      var contextData = _this.data.contextData || {};
      Taro.showLoading({ title: '加载中' });
      videoList[index].virtual = videoList[index].fileName;
      if (!contextData[id]) {
        contextData[id] = Taro.createVideoContext(id);
      }
      _this.setData((0, _defineProperty3.default)({
        contextData: contextData
      }, 'messageDetailFormData[' + tag + '].dataContent', videoList));
      setTimeout(function () {
        contextData[id].play();
        contextData[id].requestFullScreen();
        Taro.hideLoading();
      }, 600);
    };

    _this.bindPlayVideo = function (e) {
      var id = e.currentTarget.dataset.id;
      var contextData = _this.data.contextData || {};
      if (Object.keys(contextData).length > 0) {
        Object.keys(contextData).forEach(function (val, key) {
          if (id != val) contextData[val].pause();
        });
      }
    };

    document.title = '表单提交信息';
    return _this;
  }

  (0, _createClass3.default)(MyFormMessage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.options = options;
      this.getReviewConfig();
      if (options.from === 'transforDetail') {
        this.setData({
          messageDetail: 3
        });
        this.showMessageDetailForm({
          currentTarget: {
            dataset: {
              form: options.form,
              formDataId: options.formDataId,
              formId: options.formid
            }
          }
        });
      } else {
        this.getMessageData();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          messageType = _state.messageType,
          systemBranch = _state.systemBranch,
          reviewList = _state.reviewList,
          messageDetail = _state.messageDetail,
          messageDetailFormData = _state.messageDetailFormData,
          review_switch = _state.review_switch,
          form_data = _state.form_data;

      return React.createElement(
        'div',
        { className: 'official-page my-form-message' },
        React.createElement(_TopNav.TopNav, { title: '\u8868\u5355\u63D0\u4EA4\u4FE1\u606F' }),
        React.createElement(
          'div',
          { className: 'myMessage-wrap page', id: 'myMessage' },
          messageDetail == 0 && React.createElement(
            'div',
            { className: 'myMessage-content-container' },
            React.createElement(
              _ScrollView.ScrollView,
              {
                id: 'myMessage-system-message',
                className: 'myMessage-content ' + (messageType == 5 ? 'active' : ''),
                'scroll-y': 'true',
                lowerThreshold: '116',
                bindscrolltolower: this.checkMoreMessageData
              },
              systemBranch.data.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  item.messageType == 3 && React.createElement(
                    'div',
                    {
                      className: 'message-item ' + item.className,
                      'data-form': item.messageForm,
                      'data-form-id': item.messageFormId,
                      'data-form-data-id': item.messageFormDataId,
                      onClick: _this2.showMessageDetailForm
                    },
                    React.createElement(
                      'div',
                      { className: 'message-title' },
                      item.messageTitle
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-time' },
                      item.messageTime
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-img' },
                      React.createElement('div', {
                        className: 'ico-moon ' + item.messageImg
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'message-content' },
                      React.createElement(
                        'div',
                        { className: 'message-price' },
                        React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          item.messageContent
                        ),
                        (item.review_status || item.review_status >= 0) && item.review_switch == 1 && React.createElement(
                          'div',
                          { className: 'message-price-text' },
                          '\u72B6\u6001\uFF1A',
                          React.createElement(
                            'span',
                            {
                              className: item.review_status == 0 ? '' : item.review_status == 1 ? 'success-examine' : 'faile-examine'
                            },
                            item.review_status == 0 ? reviewList.applying_text || '待审核' : item.review_status == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                          )
                        )
                      )
                    )
                  )
                );
              }),
              !systemBranch.data.length && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'request-none' },
                  React.createElement('img', {
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png',
                    mode: 'widthFix'
                  }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            )
          ),
          messageDetail == 3 && React.createElement(
            'div',
            { className: 'myMessage-detail-form' },
            React.createElement(
              'div',
              { className: 'myMessage-form-list' },
              messageDetailFormData.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'myMessage-form-item', key: index },
                  React.createElement(
                    'div',
                    { className: 'data-name' },
                    item.dataName
                  ),
                  item.dataType != 2 && item.dataType != 12 ? React.createElement(
                    'div',
                    { className: 'data-content' },
                    item.dataContent
                  ) : item.dataType == 2 ? React.createElement(
                    React.Fragment,
                    null,
                    pictureWxsModule.isArray(item.dataContent) ? React.createElement(
                      React.Fragment,
                      null,
                      item.dataContent.map(function (pic, index) {
                        return React.createElement('img', {
                          key: true,
                          className: 'data-img',
                          src: pic
                        });
                      })
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      React.createElement('img', {
                        key: true,
                        className: 'data-img',
                        src: item.dataContent
                      })
                    )
                  ) : item.dataType == 12 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'data-content' },
                      item.dataContent.map(function (videoItem, videoIndex) {
                        return React.createElement(
                          'div',
                          { className: 'video-item', key: index },
                          React.createElement(
                            'video',
                            {
                              id: 'wxParse' + videoIndex,
                              className: 'video',
                              poster: videoItem.previewImageUrl,
                              src: videoItem.fileName,
                              'data-id': 'wxParse' + videoIndex,
                              onPlay: _this2.bindPlayVideo,
                              controls: true
                            },
                            React.createElement(CoverView, {
                              className: 'controls',
                              'data-tag': index,
                              'data-index': videoIndex,
                              hidden: videoItem.fileName == videoItem.virtual,
                              'data-id': 'wxParse' + videoIndex,
                              onClick: _this2.bindplay
                            })
                          )
                        );
                      })
                    )
                  )
                );
              })
            ),
            review_switch == 1 && React.createElement(
              'div',
              { className: 'myMessage-form-list' },
              React.createElement(
                'div',
                { className: 'myMessage-form-item' },
                React.createElement(
                  'div',
                  { className: 'data-name' },
                  '\u72B6\u6001'
                ),
                React.createElement(
                  'div',
                  { className: 'data-content' },
                  form_data.review_status == 0 ? reviewList.applying_text || '待审核' : form_data.review_status == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过'
                )
              ),
              form_data.review_result && React.createElement(
                'div',
                { className: 'myMessage-form-item' },
                React.createElement(
                  'div',
                  { className: 'data-name' },
                  '\u5907\u6CE8'
                ),
                React.createElement(
                  'div',
                  { className: 'data-content' },
                  form_data.review_result
                )
              )
            ),
            React.createElement(
              'div',
              {
                className: 'myMessage-form-confirm',
                onClick: this.confirmMessageDetailForm
              },
              '\u5173\u95ED'
            )
          )
        )
      );
    }
  }]);
  return MyFormMessage;
}(_OfficialPage3.default);

exports.default = MyFormMessage;

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(532);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(OrderDetail, _OfficialPage);

  function OrderDetail(props) {
    (0, _classCallCheck3.default)(this, OrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (OrderDetail.__proto__ || Object.getPrototypeOf(OrderDetail)).call(this, props));

    _this2.state = {
      orderInfo: {},
      orderStatus: [{
        '0': '待付款',
        '1': '待发货',
        '2': '待收货',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      }, {
        '0': '待付款',
        '1': '待确认',
        '2': '待消费',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      }, {
        '0': '待付款',
        '1': '待接单',
        '2': '待送餐',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      }, {
        '0': '待付款',
        '1': '待商家确认',
        '2': '商家已确认',
        '3': '已完成',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭'
      }],
      addressList: [],
      selectAddressId: '',
      addressDialogHidden: true,
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      isFromBack: false,
      orderId: '',
      isFromTemplateMsg: false,
      discountList: [],
      toStoreInfo: {},
      originalPrice: '',
      openBalance: true, //开启储值金功能
      currentBalance: '', // 当前储值金
      useBalance: '',
      freghtSwitch: '',
      freightAdress: {},
      delivery: '',
      express_fee: '',
      discount_cut_price: ''
    };

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.getFreigtAdress();
      _this2.initialAddressId();
    };

    _this2.getOrderDetail = function (orderId, isFromAddrSelect) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var form_data = res.data[0].form_data,
              hasAdditionalInfo = that.data.hasAdditionalInfo,
              address_id = '';
          form_data.totalPay = form_data.total_price;
          if (!isFromAddrSelect) {
            for (var i = 0; i < form_data.goods_info.length; i++) {
              var deliveryId = form_data.goods_info[i].delivery_id;
              if (deliveryId && deliveryId != '0') {
                that.getGoodsCustomField(i, deliveryId);
                hasAdditionalInfo = true;
              }
            }
          }
          if (form_data.address_info && that.data.freghtSwitch) {
            address_id = form_data.address_info.address_id;
            that.setData({
              selectAddressId: address_id
            });
          }
          if (form_data.tostore_data && form_data.tostore_data.appointed_time) form_data.tostore_data.format_appointed_time = form_data.tostore_data.appointed_time.substr(11, 5);
          that.setData({
            orderInfo: form_data,
            discountList: form_data.can_use_benefit.data,
            index: form_data.can_use_benefit.selected_index,
            hasAdditionalInfo: hasAdditionalInfo,
            toStoreInfo: form_data.tostore_data,
            discount_cut_price: form_data.discount_cut_price,
            currentBalance: Number(res.data[0]['balance']),
            useBalance: Number(form_data['use_balance']),
            express_fee: res.data[0]['express_fee']
          });
          if (that.data.franchiseeId) {
            that.setData({
              openBalance: false
            });
          } else {
            if (that.data.orderInfo.status == 0 && that.data.currentBalance < that.data.useBalance) {
              _app.appMethod.showToast({
                title: '储值金不足，请及时充值',
                success: function success() {
                  that.isUseBalance();
                }
              });
            }
          }
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId,
          that = _this2,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.showModal({
        content: '订单删除后不可找回，确认删除？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.getGoodsCustomField = function (goodsIndex, deliveryId) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=pc/AppShop/GetDelivery',
        data: {
          delivery_id: deliveryId
        },
        success: function success(res) {
          var deliveryInfo = res.data.delivery_info,
              goodsId = that.data.orderInfo.goods_info[goodsIndex].goods_id,
              data = {},
              fields = [];
          data['goodsAdditionalInfo.' + goodsId + ''] = deliveryInfo;
          for (var i = 0; i < deliveryInfo.length; i++) {
            var info = {};
            info.type = deliveryInfo[i].type;
            info.title = deliveryInfo[i].name;
            fields.push(info);
          }
          data['customFields[' + goodsIndex + ']'] = fields;
          that.setData(data);
        }
      });
    };

    _this2.customFieldInput = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          value = e.target.value,
          data = {};
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = value;
      _this2.setData(data);
    };

    _this2.uploadCustomFieldImage = function (e) {
      var that = _this2,
          dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          data = {};
      _app.appMethod.chooseImage(function (paths) {
        data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = paths;
        that.setData(data);
      }, 9);
    };

    _this2.deleteCustomFieldImage = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          imageArray = _this2.data.customFields[goodsIndex][fieldIndex].value,
          imageIndex = dataset.imageIndex,
          data = {};
      imageArray.splice(imageIndex, 1);
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = imageArray;
      _this2.setData(data);
    };

    _this2.sendDeliveryInfo = function () {
      var additional_info = {},
          goodsInfo = _this2.data.orderInfo.goods_info;
      for (var i = 0; i < goodsInfo.length; i++) {
        additional_info[goodsInfo[i].goods_id] = _this2.data.customFields[i];
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/SetAdditional',
        method: 'POST',
        data: {
          order_id: _this2.data.orderInfo.order_id,
          additional_info: additional_info
        },
        success: function success(res) {}
      });
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '是否取消订单？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderId;
      if (!address_info && _this2.data.orderInfo.goods_type != 3) {
        _app.appMethod.showModal({
          content: '请选择邮寄地址'
        });
        return;
      }
      if (_this2.data.hasAdditionalInfo) {
        _this2.sendDeliveryInfo();
      }
      orderId = _this2.data.orderInfo.order_id;
      if (_this2.data.orderInfo.totalPay == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            _app.appMethod.showToast({
              title: '支付成功',
              success: function success() {
                that.getOrderDetail(that.data.orderInfo.order_id);
              }
            });
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data,
      //       orderId = that.data.orderInfo.order_id
      //     param.orderId = orderId
      //     param.goodsType = that.data.orderInfo.goods_type
      //     param.success = function () {
      //       setTimeout(function () {
      //         that.getOrderDetail(orderId)
      //       }, 1500)
      //     }
      //     app.wxPay(param)
      //   }
      // })

      // TODO:支付成功回调要考虑一下怎么处理
      _app.appMethod.goPay({
        orderId: that.data.orderInfo.order_id
      });
    };

    _this2.applyDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定要申请退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/applyRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 4;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId);
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到货物？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 3;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/makeComment/makeComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.addAddress = function () {
      var orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress?oid=' + orderId);
    };

    _this2.selectAddress = function (e) {
      var index = e.currentTarget.dataset.index,
          orderId = _this2.data.orderInfo.order_id,
          newAddress = _this2.data.addressList[index],
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/setAddress',
        data: {
          order_id: orderId,
          address_id: newAddress.id,
          sub_shop_app_id: that.data.franchiseeId,
          is_self_delivery: delivery
        },
        success: function success(res) {
          that.setData({
            'orderInfo.address_info': newAddress.address_info
          });
          that.hideAddressList();
          that.changeFreightWay();
        }
      });
    };

    _this2.editAddress = function (e) {
      var index = e.currentTarget.dataset.index,
          addressId = _this2.data.addressList[index].id,
          orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress?id=' + addressId + '&oid=' + orderId);
    };

    _this2.showAddressList = function () {
      var addressId = _this2.data.selectAddressId,
          orderId = _this2.data.orderInfo.order_id,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId + '&oid=' + orderId + '&sub_shop_id=' + franchiseeId, true);
    };

    _this2.showAddAddress = function () {
      var orderId = _this2.data.orderInfo.order_id;
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || '',
              order_id: orderId
            },
            success: function success() {
              _this.dataInitial();
            }
          });
        }
      });
    };

    _this2.hideAddressList = function () {
      _this2.setData({
        addressDialogHidden: true
      });
    };

    _this2.deleteAddress = function (e) {
      var index = e.currentTarget.dataset.index,
          id = _this2.data.addressList[index].id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定要删除地址？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/delAddress',
            data: {
              address_id: id
            },
            success: function success(res) {
              var list = that.data.addressList,
                  data = {};
              list.splice(index, 1);
              data.addressList = list;
              if (id == that.data.orderInfo.address_info.id) {
                data['orderInfo.address_info'] = null;
              }
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.changeDiscount = function (e) {
      var _this = _this2;
      var index = _this.data.orderInfo.can_use_benefit.selected_index;
      var value = parseInt(e.target.value);
      _this2.setData({
        index: value
      });
      var discount_type = _this.data.orderInfo.can_use_benefit.data[value].discount_type,
          coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderInfo.order_id,
          discount_type: discount_type,
          coupon_id: coupon_id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.getOrderDetail(res.data[0].form_data.order_id);
        }
      });
    };

    _this2.verificationCode = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' + _this2.data.orderInfo.order_id + '&sub_shop_app_id=' + _this2.data.franchiseeId);
    };

    _this2.customerConfirm = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/CompleteTostoreOrder',
        data: {
          order_id: _this2.data.orderInfo.order_id
        },
        success: function success() {
          var data = {};
          data['orderInfo.status'] = 6;
          that.setData(data);
        }
      });
    };

    _this2.isUseBalance = function (e) {
      var _this = _this2;
      var isBalance = '';
      if (e) {
        isBalance = Number(e.target.value);
      } else {
        isBalance = 0;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderInfo.order_id,
          sub_shop_app_id: _this.data.franchiseeId,
          is_balance: isBalance
        },
        success: function success(res) {
          _this.getOrderDetail(res.data[0].form_data.order_id);
        }
      });
    };

    _this2.freghtRadioChange = function (e) {
      var data = '',
          _this = _this2,
          orderId = _this2.data.orderInfo.order_id,
          delivery = '';
      if (e.target.value == 2) {
        data = true;
        delivery = 1;
      } else {
        data = false;
        delivery = 0;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/setAddress',
        data: {
          is_self_delivery: delivery,
          order_id: orderId,
          address_id: _this.data.selectAddressId,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.changeFreightWay();
        }
      });
      _this2.setData({
        freghtSwitch: data,
        delivery: delivery
      });
    };

    _this2.getFreigtAdress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          that.setData({
            freightAdress: res.data
          });
        }
      });
    };

    _this2.freightGoMap = function () {
      var _this = _this2,
          infor = _this.data.freightAdress.region_string + _this.data.freightAdress.shop_location;
      infor = infor.replace(/\s+/g, '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
        data: {
          location_info: infor
        },
        success: function success(res) {
          if (res.result) {
            Taro.openLocation({
              latitude: res.result.location.lat,
              longitude: res.result.location.lng
            });
          }
        }
      });
    };

    _this2.initialAddressId = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            that.setData({
              selectAddressId: res.data[0].id
            });
          }
        }
      });
    };

    _this2.changeFreightWay = function () {
      var _this = _this2;
      var isBalance = Number(e.target.value);
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderInfo.order_id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.getOrderDetail(res.data[0].form_data.order_id);
        }
      });
    };

    _this2.freightPlayPhone = function () {
      var that = _this2;
      _app.appMethod.makePhoneCall(that.data.freightAdress.shop_contact);
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(OrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id, 1);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          orderStatus = _state.orderStatus,
          orderInfo = _state.orderInfo,
          freightAdress = _state.freightAdress,
          freghtSwitch = _state.freghtSwitch,
          toStoreInfo = _state.toStoreInfo,
          customFields = _state.customFields,
          goodsAdditionalInfo = _state.goodsAdditionalInfo,
          express_fee = _state.express_fee,
          discountList = _state.discountList,
          discount_cut_price = _state.discount_cut_price,
          openBalance = _state.openBalance,
          useBalance = _state.useBalance,
          currentBalance = _state.currentBalance;


      return React.createElement(
        'div',
        { className: 'official-page order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          'div',
          { className: 'orderDetail-wrap page', id: 'orderDetail' },
          isFromTemplateMsg && React.createElement(
            'div',
            {
              className: 'orderDetail-section orderDetail-goto-homepage',
              onClick: this.goToHomepage,
              style: (0, _tools.convertLineStyleData)('margin-bottom:0;')
            },
            React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
            '\u8FD4\u56DE\u9996\u9875'
          ),
          React.createElement(
            'div',
            {
              className: 'orderDetail-section',
              style: (0, _tools.convertLineStyleData)('color:#fff;background-color:#535961;')
            },
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('margin-bottom:4px;') },
              '订单状态：' + orderInfo.goods_type && orderInfo.status && orderStatus[orderInfo.goods_type][orderInfo.status]
            ),
            React.createElement(
              'div',
              null,
              '订单号：' + orderInfo.order_id
            )
          ),
          freightAdress.is_self_delivery != 0 && orderInfo.goods_type == 0 && React.createElement(
            'div',
            { className: 'orderDetail-section' },
            React.createElement(
              RadioGroup,
              {
                className: 'freght-radio',
                onChange: this.freghtRadioChange
              },
              React.createElement(
                'label',
                { className: 'radio' },
                React.createElement(Radio, { value: '1', checked: 'checked' }),
                '\u5FEB\u9012'
              ),
              React.createElement(
                'label',
                { className: 'radio' },
                React.createElement(Radio, { value: '2' }),
                '\u4E0A\u95E8\u81EA\u63D0'
              )
            )
          ),
          (orderInfo.goods_type == 0 || orderInfo.goods_type == 1 || orderInfo.goods_type == 2) && React.createElement(
            'div',
            {
              className: 'orderDetail-section orderDetail-address-detail right-arrow-bar',
              'data-id': orderInfo.address_info ? orderInfo.address_info.address_id : '',
              hidden: freghtSwitch
            },
            orderInfo.address_info ? React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { onClick: this.showAddressList },
                React.createElement(
                  'div',
                  null,
                  orderInfo.address_info.name + ' ' + orderInfo.address_info.contact
                ),
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('color:#aaa;') },
                  orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                )
              ),
              orderInfo.status < 1 && React.createElement(
                'div',
                { className: 'orderDetail-address-ops' },
                React.createElement(
                  'span',
                  { onClick: this.showAddressList },
                  '\u66F4\u6362\u5730\u5740'
                )
              )
            ) : React.createElement(
              React.Fragment,
              null,
              React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              React.createElement(
                'div',
                { onClick: this.goToMyAddress },
                '\u6DFB\u52A0\u5730\u5740'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'orderDetail-section', hidden: !freghtSwitch },
            React.createElement(
              'div',
              { onClick: this.freightGoMap, className: 'locationName' },
              React.createElement('label', { className: 'ico-moon icon-location freightAdress-ico' }),
              freightAdress.region_string + ' ' + freightAdress.shop_location
            ),
            React.createElement(
              'div',
              {
                className: 'freightAdress-phone',
                onClick: this.freightPlayPhone
              },
              React.createElement('label', { className: 'ico-moon icon-phone freightAdress-ico' }),
              freightAdress.shop_contact
            ),
            React.createElement(
              'div',
              { className: 'freightAdress-tip' },
              '\u4EB2\uFF0C\u52FE\u9009\u4E0A\u95E8\u5E97\u81EA\u63D0,\u9700\u8981\u81EA\u5DF1\u53BB\u95E8\u5E97\u53D6\u8D27\u54E6\uFF01'
            )
          ),
          orderInfo.goods_type == 3 && React.createElement(
            React.Fragment,
            null,
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              React.createElement(
                'div',
                { className: 'tostore-queue-section' },
                React.createElement(
                  'span',
                  null,
                  '取餐号: ' + toStoreInfo.formatted_queue_num
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '取餐时间 ' + toStoreInfo.format_appointed_time
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u4F4D\u7F6E\u4FE1\u606F:',
                React.createElement(
                  'span',
                  null,
                  orderInfo.location_name
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u5C31\u9910\u65B9\u5F0F:',
                toStoreInfo.tostore_order_type == 1 ? React.createElement(
                  'span',
                  null,
                  '\u70B9\u9910'
                ) : React.createElement(
                  'span',
                  null,
                  '预约 ' + toStoreInfo.tostore_appointment_time
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u624B\u673A\u53F7\u7801:',
                React.createElement(
                  'span',
                  null,
                  toStoreInfo.tostore_buyer_phone
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u5907\u6CE8\u4FE1\u606F:',
                React.createElement(
                  'span',
                  null,
                  toStoreInfo.tostore_remark || '无'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'orderDetail-section' },
            React.createElement(
              'div',
              { className: 'orderDetail-order-list' },
              orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
                return React.createElement(
                  React.Fragment,
                  { key: goodsIndex },
                  React.createElement(
                    'div',
                    { className: 'dialog-block-item' },
                    React.createElement('img', {
                      className: 'list-goods-cover',
                      src: goods.cover
                    }),
                    React.createElement(
                      'div',
                      { className: 'list-goods-content' },
                      React.createElement(
                        'div',
                        null,
                        goods.goods_name
                      ),
                      goods.model_value && React.createElement(
                        'div',
                        { className: 'list-goods-model' },
                        goods.model_value
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'list-goods-right' },
                      React.createElement(
                        'div',
                        null,
                        '¥' + goods.price
                      ),
                      React.createElement(
                        'div',
                        null,
                        '× ' + goods.num
                      )
                    )
                  ),
                  goodsAdditionalInfo[goods.goods_id] && React.createElement(
                    'div',
                    { className: 'dialog-block-item' },
                    goodsAdditionalInfo[goods.goods_id].map(function (field, fieldIndex) {
                      return React.createElement(
                        'div',
                        { className: 'customField-container', key: fieldIndex },
                        orderInfo.additional_info && orderInfo.additional_info[goods.goods_id] ? React.createElement(
                          React.Fragment,
                          null,
                          field.type === 'text' || field.type === 'mul-text' ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              null,
                              field.name + ':' + orderInfo.additional_info[goods.goods_id][fieldIndex].value
                            )
                          ) : field.type === 'picture' && React.createElement(
                            React.Fragment,
                            null,
                            orderInfo.additional_info[goods.goods_id][fieldIndex].value.map(function (imgUrl, index) {
                              return React.createElement(
                                'div',
                                {
                                  className: 'custom-field-image',
                                  key: true
                                },
                                React.createElement('img', {
                                  src: imgUrl,
                                  mode: 'aspectFit',
                                  onClick: _this3.previewImage,
                                  'data-src': imgUrl
                                })
                              );
                            })
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          field.type === 'text' ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement('input', {
                              'data-name': field.name,
                              'data-goods-index': goodsIndex,
                              'data-field-index': fieldIndex,
                              placeholder: field.name,
                              onInput: _this3.customFieldInput
                            })
                          ) : field.type === 'mul-text' ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement('textarea', {
                              'data-name': field.name,
                              'data-goods-index': goodsIndex,
                              'data-field-index': fieldIndex,
                              placeholder: field.name,
                              onInput: _this3.customFieldInput
                            })
                          ) : field.type === 'picture' && React.createElement(
                            React.Fragment,
                            null,
                            customFields[goodsIndex][fieldIndex].value.map(function (fieldImg, imageIndex) {
                              return React.createElement(
                                'div',
                                {
                                  className: 'custom-field-image',
                                  key: true
                                },
                                React.createElement('img', {
                                  src: fieldImg,
                                  mode: 'aspectFit',
                                  onClick: _this3.previewImage,
                                  'data-src': fieldImg
                                }),
                                React.createElement(
                                  'label',
                                  {
                                    className: 'delete-img',
                                    onClick: _this3.deleteCustomFieldImage,
                                    'data-goods-index': goodsIndex,
                                    'data-field-index': fieldIndex,
                                    'data-image-index': imageIndex
                                  },
                                  '\xD7'
                                )
                              );
                            }),
                            React.createElement(
                              'div',
                              {
                                className: 'upload-field-image',
                                onClick: _this3.uploadCustomFieldImage,
                                'data-name': field.name,
                                'data-goods-index': goodsIndex,
                                'data-field-index': fieldIndex
                              },
                              field.name
                            )
                          )
                        )
                      );
                    })
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'dialog-block-item' },
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u5546\u54C1\u603B\u989D\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + orderInfo.original_price
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'orderDetail-item-row',
                  hidden: orderInfo.goods_type == 3
                },
                '\u7269\u6D41\u8D39\u7528\uFF1A',
                express_fee && express_fee != 0 && React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + express_fee
                ),
                (!express_fee || express_fee == 0) && React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '\u5305\u90AE'
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'orderDetail-item-row',
                  hidden: orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null
                },
                React.createElement(
                  _picker2.default,
                  {
                    disabled: orderInfo.status == 0 ? false : true,
                    onChange: this.changeDiscount,
                    rangeKey: 'title',
                    value: index,
                    range: discountList
                  },
                  React.createElement(
                    'div',
                    { className: 'picker' },
                    '\u5E97\u94FA\u4F18\u60E0\uFF1A',
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('float:right;') },
                      discountList[index].title
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'orderDetail-item-row',
                  hidden: orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null
                },
                '\u4F18\u60E0\u62B5\u6263\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '- ¥' + discount_cut_price
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'dialog-block-item' },
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u4E0B\u5355\u65F6\u95F4\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  orderInfo.add_time
                )
              ),
              openBalance == true && orderInfo.status == 0 && React.createElement(
                'div',
                { className: 'orderDetail-item-row balance' },
                '\u50A8\u503C\u91D1\uFF1A',
                React.createElement(_switch2.default, {
                  className: 'pull-right',
                  checked: useBalance != 0 ? true : false,
                  type: 'switch',
                  onChange: this.isUseBalance
                }),
                React.createElement(
                  'span',
                  { className: 'pull-right balance-num' },
                  '¥' + currentBalance
                )
              ),
              orderInfo.status != 0 && React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u50A8\u503C\u62B5\u6263\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '- ¥' + useBalance
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                '\u5B9E\u4ED8\u4EF7\u683C\uFF1A',
                React.createElement(
                  'span',
                  { className: 'orderDetail-pay-count pull-right' },
                  '¥' + orderInfo.totalPay
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'txt-r orderDetail-btn-status' },
              orderInfo.status == 0 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-cancel-order',
                    onClick: this.cancelOrder
                  },
                  '\u53D6\u6D88\u8BA2\u5355'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'btn btn-orange orderDetail-pay-directly',
                    onClick: this.payOrder
                  },
                  '\u7ACB\u5373\u652F\u4ED8'
                )
              ),
              orderInfo.status == 1 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  null,
                  orderStatus[orderInfo.goods_type][1]
                ),
                React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-verification-code',
                    onClick: this.verificationCode
                  },
                  '\u6838\u9500\u7801'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-apply-drawback',
                    onClick: this.applyDrawback
                  },
                  '\u7533\u8BF7\u9000\u6B3E'
                )
              ),
              orderInfo.status == 2 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-verification-code',
                    onClick: this.verificationCode
                  },
                  '\u6838\u9500\u7801'
                ),
                orderInfo.goods_type == 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-verification-code',
                    onClick: this.customerConfirm
                  },
                  '\u786E\u8BA4'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-check-logistics',
                    onClick: this.checkLogistics
                  },
                  '\u67E5\u770B\u7269\u6D41'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-apply-drawback',
                    onClick: this.applyDrawback
                  },
                  '\u7533\u8BF7\u9000\u6B3E'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn btn-orange orderDetail-sure-receipt',
                    onClick: this.sureReceipt
                  },
                  '\u786E\u8BA4\u6536\u8D27'
                )
              ),
              orderInfo.status == 3 && React.createElement(
                React.Fragment,
                null,
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn myOrder-delete',
                    onClick: this.orderDelete
                  },
                  '\u522A\u9664\u8BA2\u5355'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-check-logistics',
                    onClick: this.checkLogistics
                  },
                  '\u67E5\u770B\u7269\u6D41'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn btn-orange orderDetail-make-comment',
                    onClick: this.makeComment
                  },
                  '\u53BB\u8BC4\u4EF7'
                )
              ),
              orderInfo.status == 4 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  null,
                  '\u9000\u6B3E\u5BA1\u6838\u4E2D'
                )
              ),
              orderInfo.status == 5 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-receive-drawback',
                    onClick: this.receiveDrawback
                  },
                  '\u6536\u5230\u9000\u6B3E'
                )
              ),
              orderInfo.status == 6 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-verification-code',
                    onClick: this.verificationCode
                  },
                  '\u6838\u9500\u7801'
                ),
                orderInfo.goods_type != 3 && React.createElement(
                  'span',
                  {
                    className: 'btn orderDetail-check-logistics',
                    onClick: this.checkLogistics
                  },
                  '\u67E5\u770B\u7269\u6D41'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'btn myOrder-delete',
                    onClick: this.orderDelete
                  },
                  '\u522A\u9664\u8BA2\u5355'
                )
              ),
              orderInfo.status == 7 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'span',
                  {
                    className: 'btn myOrder-delete',
                    onClick: this.orderDelete
                  },
                  '\u522A\u9664\u8BA2\u5355'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return OrderDetail;
}(_OfficialPage3.default);

exports.default = OrderDetail;

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(534);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToStoreDetail = function (_OfficialPage) {
  (0, _inherits3.default)(ToStoreDetail, _OfficialPage);

  function ToStoreDetail(props) {
    (0, _classCallCheck3.default)(this, ToStoreDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ToStoreDetail.__proto__ || Object.getPrototypeOf(ToStoreDetail)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '商品详情'
      },
      goodsInfo: {},
      addToShoppingCartCount: 0,
      selectModelInfo: {
        models: [],
        stock: '',
        price: '',
        buyCount: 0
      },
      pageQRCodeData: {
        shareDialogShow: '100%',
        shareMenuShow: false
      },
      defaultPhoto: '',
      addToShoppingCartHidden: true,
      ifAddToShoppingCart: true,
      priceDiscountStr: '',
      cartGoodsNum: 0,
      cartGoodsTotalPrice: 0,
      pageNavigating: false
    };
    _this2.numChangeTimeout = '';
    _this2.goodsId = '';
    _this2.models = '';
    _this2.cartData = '';
    _this2.cart_id = '';
    _this2.fromBack = false;
    _this2.franchiseeId = '';
    _this2.touchStartPos = {};

    _this2.dataInitial = function () {
      _this2.getGoodsDetail();
    };

    _this2.getGoodsDetail = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: _this2.goodsId,
          sub_shop_app_id: _this2.franchiseeId
        },
        success: function success(res) {
          that.modifyGoodsDetail(res);
          that.getCartList();
        }
      });
    };

    _this2.getCartList = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: _this2.franchiseeId,
          parent_shop_app_id: _this2.franchiseeId ? _app.appMethod.globalData.appId : ''
        },
        success: function success(res) {
          var price = 0,
              num = 0,
              addToShoppingCartCount = 0,
              tostoreTypeFlag = false;
          that.cartData = res.data;
          for (var i = res.data.length - 1; i >= 0; i--) {
            var data = res.data[i];
            if (data.goods_type == 3) {
              tostoreTypeFlag = true;
              price += +data.num * +data.price;
              num += +data.num;
            }
            if (that.goodsId == data.goods_id) {
              if (data.model) {
                if (data.model == that.models) {
                  addToShoppingCartCount = data.num;
                  that.cart_id = data.id;
                }
              } else {
                addToShoppingCartCount = data.num;
                that.cart_id = data.id;
              }
            }
          }
          that.setData({
            tostoreTypeFlag: tostoreTypeFlag,
            cartGoodsNum: num,
            cartGoodsTotalPrice: price.toFixed(2),
            addToShoppingCartCount: addToShoppingCartCount
          });
        }
      });
    };

    _this2.onShareAppMessage = function () {
      var that = _this2,
          goodsId = _this2.goodsId,
          contact = _this2.data.contact,
          franchiseeId = _this2.franchiseeId,
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          url = '/pages/toStoreDetail/toStoreDetail?detail=' + goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '') + urlPromotion + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : '');
      return _app.appMethod.shareAppMessage({
        path: url,
        success: function success(addTime) {
          _app.appMethod.showToast({ title: '转发成功', duration: 500 });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    _this2.goToShoppingCart = function () {
      var franchiseeId = _this2.franchiseeId,
          pagePath = '/eCommerce/pages/shoppingCart/shoppingCart' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.modifyGoodsDetail = function (res) {
      // TODO var pages = app.getCurrentPages(),
      var _this = _app.appMethod.getAppCurrentPage(),
          goods = res.data[0].form_data,
          description = goods.description,
          goodsModel = [],
          selectModels = [],
          price = 0,
          discountStr = '',
          data = {},
          that = _this2,
          selectStock,
          selectPrice,
          selectModelId,
          matchResult,
          i,
          j;
      // WxParse.wxParse('wxParseDescription', 'html', description, _this, 34)
      if (goods.business_time && goods.business_time.business_time) {
        var goodBusinesssTime = goods.business_time.business_time,
            businesssTimeString = '';
        for (var i = 0; i < goodBusinesssTime.length; i++) {
          businesssTimeString += goodBusinesssTime[i].start_time.substring(0, 2) + ':' + goodBusinesssTime[i].start_time.substring(2, 4) + '-' + goodBusinesssTime[i].end_time.substring(0, 2) + ':' + goodBusinesssTime[i].end_time.substring(2, 4) + '/';
        }
        businesssTimeString = '出售时间：' + businesssTimeString.substring(0, businesssTimeString.length - 1);
        that.setData({
          businesssTimeString: businesssTimeString
        });
      }
      if (goods.model_items.length) {
        _this2.models = goods.model_items[0].model;
        var items = goods.model_items;
        selectPrice = items[0].price;
        selectStock = items[0].stock;
        selectModelId = items[0].id;
      } else {
        selectPrice = goods.price;
        selectStock = goods.stock;
      }
      for (var key in goods.model) {
        if (key) {
          var model = goods.model[key];
          goodsModel.push(model);
          selectModels.push(model.subModelId[0]);
        }
      }
      goods.model = goodsModel;
      if (Number(goods.max_can_use_integral) != 0) {
        discountStr = '（积分可抵扣' + Number(goods.max_can_use_integral) / 100 + '元）';
      }
      data = {
        goodsInfo: goods,
        'selectModelInfo.models': selectModels,
        'selectModelInfo.stock': selectStock,
        'selectModelInfo.price': selectPrice,
        'selectModelInfo.modelId': selectModelId || '',
        priceDiscountStr: discountStr,
        goodsRate: (goods.goods_rate.level_1 * 100).toFixed(0)
      };
      goods.model.length ? data.showSelectModel = true : data.showChangeCount = true;
      _this.setData(data);
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true
      });
    };

    _this2.selectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          addToShoppingCartCount = 0,
          data = {};
      var firstModels = _this2.models.split(',');
      firstModels[modelIndex] = dataset.submodelId;
      _this2.models = firstModels.join(',');
      for (var i = _this2.cartData.length - 1; i >= 0; i--) {
        var _data = _this2.cartData[i];
        if (_this2.goodsId == _data.goods_id) {
          if (_data.model) {
            if (_data.model == _this2.models) {
              addToShoppingCartCount = _data.num;
              _this2.cart_id = _data.id;
            }
          } else {
            addToShoppingCartCount = _data.num;
            _this2.cart_id = _data.id;
          }
        }
      }
      _this2.setData({
        addToShoppingCartCount: addToShoppingCartCount
      });
      data['selectModelInfo.models[' + modelIndex + ']'] = _this2.data.goodsInfo.model[modelIndex].subModelId[submodelIndex];
      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var selectModelIds = _this2.data.selectModelInfo.models.join(','),
          modelItems = _this2.data.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['selectModelInfo.stock'] = modelItems[i].stock;
          data['selectModelInfo.price'] = modelItems[i].price;
          data['selectModelInfo.modelId'] = modelItems[i].id;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.clickMinusButton = function (e) {
      if (+_this2.data.addToShoppingCartCount <= 0) return;
      _this2.changeCartGoodsNum('minus');
    };

    _this2.clickPlusButton = function (e) {
      _this2.changeCartGoodsNum('plus');
    };

    _this2.changeCartGoodsNum = function (type) {
      if (_this2.numChangeTimeout) {
        clearTimeout(_this2.numChangeTimeout);
      }
      var goods = _this2.data.goodsInfo,
          currentGoodsNum = +_this2.data.addToShoppingCartCount,
          targetGoodsNum = type == 'plus' ? currentGoodsNum + 1 : currentGoodsNum - 1,
          currentCartNum = +_this2.data.cartGoodsNum,
          targetCartNum = type == 'plus' ? currentCartNum + 1 : currentCartNum - 1,
          currentTotalPrice = +_this2.data.cartGoodsTotalPrice,
          targetTotalPrice = type == 'plus' ? currentTotalPrice + +goods.price : currentTotalPrice - +goods.price,
          that = _this2,
          param;
      if (targetGoodsNum > +goods.stock) {
        _app.appMethod.showModal({
          content: '库存不足'
        });
        return;
      }
      if (targetGoodsNum == 0 && type == 'minus') {
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/deleteCart',
          method: 'post',
          data: {
            cart_id_arr: [that.cart_id],
            sub_shop_app_id: that.franchiseeId
          },
          success: function success(res) {
            that.getCartList();
          },
          fail: function fail(res) {
            that.setData({
              addToShoppingCartCount: currentGoodsNum,
              cartGoodsNum: currentCartNum,
              cartGoodsTotalPrice: currentTotalPrice
            });
          }
        });
        return;
      }
      param = {
        goods_id: goods.id,
        model_id: goods.modelId || '',
        num: targetGoodsNum,
        sub_shop_app_id: that.franchiseeId
      };
      _this2.numChangeTimeout = setTimeout(function () {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/addCart',
          data: param,
          success: function success(res) {
            that.cart_id = res.data;
            that.getCartList();
          },
          successStatusAbnormal: function successStatusAbnormal(res) {
            that.setData({
              addToShoppingCartCount: 0
            });
          }
        });
      }, 300);
    };

    _this2.clickModelMinusButton = function () {
      var count = +_this2.data.addToShoppingCartCount,
          that = _this2;
      if (count <= 0) {
        return;
      }
      if (count <= 1) {
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/deleteCart',
          method: 'post',
          data: {
            cart_id_arr: [that.cart_id],
            sub_shop_app_id: that.franchiseeId
          },
          success: function success() {
            that.setData({
              addToShoppingCartCount: count - 1
            });
            that.getCartList();
          },
          fail: function fail(res) {
            that.setData({
              addToShoppingCartCount: currentGoodsNum,
              cartGoodsNum: currentCartNum,
              cartGoodsTotalPrice: currentTotalPrice
            });
          }
        });
        return;
      }
      _this2.sureAddToShoppingCart();
    };

    _this2.clickModelPlusButton = function () {
      var selectModelInfo = _this2.data.selectModelInfo,
          count = +_this2.data.addToShoppingCartCount;
      if (count + 1 > +selectModelInfo.stock) {
        _app.appMethod.showModal({
          content: '库存不足'
        });
        return;
      }
      _this2.sureAddToShoppingCart('plus');
    };

    _this2.sureAddToShoppingCart = function (type) {
      var that = _this2,
          addcount = +_this2.data.addToShoppingCartCount;
      if (type == 'plus') {
        addcount = addcount + 1;
      } else {
        addcount = addcount - 1;
      }
      var param = {
        goods_id: _this2.goodsId,
        model_id: _this2.data.selectModelInfo.modelId || '',
        num: addcount,
        sub_shop_app_id: _this2.franchiseeId || ''
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          that.cart_id = res.data.data;
          that.setData({
            addToShoppingCartCount: addcount
          });
          that.getCartList();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          that.setData({
            addToShoppingCartCount: 0
          });
        }
      });
    };

    _this2.readyToPay = function () {
      if (_this2.data.cartGoodsNum <= 0 || !_this2.data.tostoreTypeFlag) return;
      var franchiseeId = _this2.franchiseeId,
          pagePath = '/orderMeal/pages/previewOrderDetail/previewOrderDetail' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.goTostoreComment = function () {
      var franchiseeId = _this2.franchiseeId,
          pagePath = '/orderMeal/pages/tostoreComment/tostoreComment?detail=' + _this2.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.showQRCodeComponent = function () {
      var that = _this2;
      var goodsInfo = _this2.data.goodsInfo;
      var animation = _app.appMethod.createAnimation({
        timingFunction: 'ease',
        duration: 400
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppDistribution/DistributionShareQRCode',
        data: {
          obj_id: that.goodsId,
          type: 3,
          text: goodsInfo.title,
          price: that.data.showChangeCount ? goodsInfo.price : that.data.selectModelInfo.price,
          goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
          sub_shop_id: that.franchiseeId,
          p_id: _app.appMethod.globalData.p_id || ''
        },
        success: function success(res) {
          animation.bottom('0').step();
          that.setData({
            'pageQRCodeData.shareDialogShow': 0,
            'pageQRCodeData.shareMenuShow': true,
            'pageQRCodeData.goodsInfo': res.data,
            'pageQRCodeData.animation': animation.export()
          });
        }
      });
    };

    _this2.getValidateTostore = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/precheckShoppingCart',
        data: {
          sub_shop_app_id: that.franchiseeId || '',
          parent_shop_app_id: that.franchiseeId ? _app.appMethod.getAppId() : ''
        },
        success: function success(res) {
          that.readyToPay();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          _app.appMethod.showModal({
            content: res.data,
            confirm: function confirm() {
              res.status == 1 && that.goToShoppingCart();
            }
          });
        }
      });
    };

    _this2.pageTouchStart = function (e) {
      var touches = e.touches;
      if (touches.length > 1) return;
      _this2.touchStartPos = {
        clientX: touches[0].clientX,
        clientY: touches[0].clientY
      };
    };

    _this2.pageTouchMove = function (e) {};

    _this2.stopPropagation = function () {};

    document.title = '商品详情';
    return _this2;
  }

  (0, _createClass3.default)(ToStoreDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var contact = options.contact || '',
          defaultPhoto = _app.appMethod.getDefaultPhoto(),
          userToken = options.user_token;
      this.setData({
        contact: contact,
        defaultPhoto: defaultPhoto
      });
      if (userToken) {
        _app.appMethod.globalData.PromotionUserToken = userToken;
      }
      this.goodsId = options.detail || '';
      this.franchiseeId = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.fromBack) {
        this.getCartList();
        this.resetSelectCountPrice();
      } else this.fromBack = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          topNavBarData = _state.topNavBarData,
          pageQRCodeData = _state.pageQRCodeData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          goodsInfo = _state.goodsInfo,
          indicatorDots = _state.indicatorDots,
          wxParseDescription = _state.wxParseDescription,
          addToShoppingCartCount = _state.addToShoppingCartCount,
          showChangeCount = _state.showChangeCount,
          selectModelInfo = _state.selectModelInfo,
          showSelectModel = _state.showSelectModel,
          businesssTimeString = _state.businesssTimeString,
          goodsRate = _state.goodsRate,
          cartGoodsNum = _state.cartGoodsNum,
          cartGoodsTotalPrice = _state.cartGoodsTotalPrice,
          tostoreTypeFlag = _state.tostoreTypeFlag;


      return React.createElement(
        'div',
        { className: 'official-page to-store-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BE6\u60C5' }),
        React.createElement(
          'div',
          {
            className: 'toStore-detail-wrap',
            onTouchStart: this.pageTouchStart,
            onTouchMove: this.pageTouchMove
          },
          React.createElement(
            'div',
            { className: 'toStore-detail-content' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'toStore-detail-nav' },
                React.createElement('div', {
                  className: 'pull-right ico-moon icon-share',
                  onClick: this.showQRCodeComponent
                })
              ),
              !goodsInfo.img_urls ? React.createElement(
                'div',
                { className: 'toStore-cover-container' },
                React.createElement('img', {
                  src: goodsInfo.cover,
                  mode: 'aspectFill',
                  onLoad: this.toStoreCoverOnload
                })
              ) : React.createElement(
                'div',
                { className: 'slick-carousel-container' },
                React.createElement(
                  _carousel2.default,
                  {
                    dots: indicatorDots,
                    infinite: true,
                    autoplay: true,
                    autoplayInterval: 5000 },
                  goodsInfo.img_urls.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index, className: 'slider-img-wrap' },
                      React.createElement('img', {
                        src: item,
                        className: 'slide-image'
                      })
                    );
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'toStore-goods-info' },
                React.createElement(
                  'div',
                  { className: 'toStore-goods-title' },
                  goodsInfo.title
                ),
                React.createElement('div', { className: 'toStore-goods-details rich-text', dangerouslySetInnerHTML: { __html: goodsInfo.description && goodsInfo.description.replace(/href=".*?"/g, '') } }),
                showChangeCount && React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-top: 30px;margin-bottom:10px;overflow: hidden;') },
                  goodsInfo.integral != '2' ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'toStore-price' },
                      '¥' + goodsInfo.price
                    )
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    goodsInfo.price != '0.00' && React.createElement(
                      'div',
                      { className: 'toStore-price' },
                      '¥' + goodsInfo.price
                    ),
                    goodsInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'div',
                      { className: 'toStore-price' },
                      '+'
                    ),
                    goodsInfo.max_can_use_integral != 0 && React.createElement(
                      'div',
                      { className: 'toStore-price' },
                      goodsInfo.max_can_use_integral + '积分'
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'quantity',
                      style: (0, _tools.convertLineStyleData)('position:absolute;right:20px;')
                    },
                    React.createElement('label', {
                      className: 'minus ' + (addToShoppingCartCount <= 0 ? 'disabled' : '')
                    }),
                    React.createElement(
                      'span',
                      { className: 'buy-goods-count' },
                      addToShoppingCartCount
                    ),
                    React.createElement('label', { className: 'plus' }),
                    React.createElement('div', {
                      className: 'response-area response-area-minus',
                      onClick: this.clickMinusButton
                    }),
                    React.createElement('div', {
                      className: 'response-area response-area-plus',
                      onClick: this.clickPlusButton
                    })
                  )
                ),
                showSelectModel && React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('text-align:left') },
                  React.createElement(
                    'div',
                    { className: 'pay-toStore-models' },
                    goodsInfo.model.map(function (model, modelIndex) {
                      return React.createElement(
                        'div',
                        { key: modelIndex },
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('vertical-align:top;line-height:32px;width:120rpx;display:inline-block;text-align:right;margin-left:-25px;font-size:24rpx;') },
                          model.name + '：'
                        ),
                        React.createElement(
                          'label',
                          { className: 'pills-list', style: (0, _tools.convertLineStyleData)('width:528rpx;') },
                          model.subModelName.map(function (name, index) {
                            return React.createElement(
                              'label',
                              {
                                key: index,
                                'data-model-index': modelIndex,
                                'data-submodel-index': index,
                                className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                                'data-submodel-id': model.subModelId[index],
                                onClick: _this3.selectSubModel
                              },
                              name
                            );
                          })
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'dialog-block-item' },
                    React.createElement(
                      'div',
                      { className: 'clearfix' },
                      goodsInfo.integral != '2' ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'pay-current-price pull-left' },
                          '¥' + selectModelInfo.price
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        selectModelInfo.price != '0.00' && React.createElement(
                          'div',
                          { className: 'pay-current-price pull-left' },
                          '¥' + selectModelInfo.price
                        ),
                        selectModelInfo.price != '0.00' && goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'div',
                          { className: 'pay-current-price pull-left' },
                          '+'
                        ),
                        goodsInfo.max_can_use_integral != 0 && React.createElement(
                          'div',
                          { className: 'pay-current-price pull-left' },
                          goodsInfo.max_can_use_integral + '积分'
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'pull-right' },
                        React.createElement(
                          'div',
                          { className: 'quantity' },
                          React.createElement('label', {
                            className: 'minus ' + (selectModelInfo.buyCount < 1 ? 'disabled' : '')
                          }),
                          React.createElement(
                            'span',
                            { className: 'buy-goods-count' },
                            addToShoppingCartCount
                          ),
                          React.createElement('label', { className: 'plus' }),
                          React.createElement('div', {
                            className: 'response-area response-area-minus',
                            onClick: this.clickModelMinusButton
                          }),
                          React.createElement('div', {
                            className: 'response-area response-area-plus',
                            onClick: this.clickModelPlusButton
                          })
                        )
                      )
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'businesssTime' },
                  businesssTimeString
                )
              ),
              React.createElement(
                'div',
                { className: 'tostore-goods-comment' },
                React.createElement(
                  'span',
                  { onClick: this.goTostoreComment },
                  '\u67E5\u770B\u8BC4\u4EF7\uFF08\u597D\u8BC4\u5EA6',
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #ff7100;') },
                    goodsRate + '%'
                  ),
                  '\uFF09'
                ),
                React.createElement('label', {
                  className: 'ico-moon icon-rightarrow',
                  style: (0, _tools.convertLineStyleData)('vertical-align:middle;')
                })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'toStore-bottom-nav' },
            React.createElement(
              'div',
              { className: 'bottom-nav-detail', onClick: this.goToShoppingCart },
              React.createElement(
                'label',
                { className: 'icon-shoppingcart ico-moon' },
                cartGoodsNum != 0 && React.createElement(
                  'label',
                  { className: 'toStore-cart-tip' },
                  cartGoodsNum
                )
              ),
              React.createElement(
                'span',
                null,
                '¥' + cartGoodsTotalPrice
              )
            ),
            React.createElement(
              'div',
              {
                className: 'bottom-nav-ready ' + (cartGoodsNum == 0 ? 'disabled' : '') + ' ' + (tostoreTypeFlag ? '' : 'disabled'),
                onClick: this.getValidateTostore
              },
              '\u9009\u597D\u4E86'
            )
          )
        )
      );
    }
  }]);
  return ToStoreDetail;
}(_OfficialPage3.default);

exports.default = ToStoreDetail;

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CouponDetail = function (_OfficialPage) {
  (0, _inherits3.default)(CouponDetail, _OfficialPage);

  function CouponDetail(props) {
    (0, _classCallCheck3.default)(this, CouponDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CouponDetail.__proto__ || Object.getPrototypeOf(CouponDetail)).call(this, props));

    _this.state = {
      topNavBarData: {
        title: '优惠券',
        isDefault: 0
      },
      detailShow: false,
      status: 'receive', // receive、use 默认为receive，从优惠券列表进入的则为use
      couponId: '', // receive时为商家设置优惠券id，use时为用户领取优惠券id
      franchiseeId: '',
      couponDetail: {},
      receiveSuccess: 0, // 领取成功弹窗是否显示
      receiveCount: 0, // 已领取数量
      receiveLimitNum: 0, // 领取限制数量
      rechargeSuccess: 0, // 充值成功弹窗是否显示
      verifySuccess: false,
      verifyQrcodeUrl: '',
      verifyShow: false,
      verifyData: {
        success: false,
        qrcodeUrl: ''
      },
      recving: false, // 领取中
      recv_type: '', // 领取渠道
      coupon: {}
    };

    _this.getCouponInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCouponInfo',
        data: {
          sub_app_id: that.data.franchiseeId,
          coupon_id: that.data.couponId
        },
        hideLoading: true,
        success: function success(res) {
          that.setCouponData(res.data);
        }
      });
    };

    _this.getUserListCouponInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getUserListCouponInfo',
        data: {
          sub_app_id: that.data.franchiseeId,
          user_coupon_id: that.data.couponId,
          verify_log_order_by: 'desc'
        },
        hideLoading: true,
        success: function success(res) {
          var coupon = res.data[0];
          if (!coupon) {
            that.setData({
              status: 'receive'
            });
            that.getCouponInfo();
            return;
          }
          var verifyLogList = coupon.form_data && coupon.form_data.verify_log || [];
          if (verifyLogList && verifyLogList.length !== 0) {
            verifyLogList.forEach(function (item) {
              item.add_time = _util2.default.formatTimeYMD(item.add_time, 'YYYY/MM/DD hh:mm:ss');
            });
          }
          that.setCouponData(coupon);
        }
      });
    };

    _this.setCouponData = function (data) {
      var that = _this;
      var useCondition = '';
      var stampsUser = '';
      if (data.type == 0) {
        useCondition = '满' + data.condition + '，减' + data.value + '元';
      } else if (data.type == 1) {
        useCondition = '打' + data.value + '折';
      } else if (data.type == 2) {
        useCondition = '可抵扣' + data.value + '元';
      } else if (data.type == 3) {
        if (data.extra_condition == '') {
          useCondition = '直接兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.price) {
          useCondition = '消费满' + data.extra_condition.price + '元可兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.goods_id) {
          useCondition = '购买' + data.condition_goods_info.title + '可兑换' + data.coupon_goods_info.title;
        }
      } else if (data.type == 4) {
        useCondition = '储值金可充值' + data.value + '元';
      } else if (data.type == 5) {
        useCondition = data.extra_condition;
      } else if (data.type == 6) {
        useCondition = '可使用' + parseInt(data.value) + '次';
      }
      if (data.user_condition_list && data.user_condition_list.length > 0) {
        data.user_condition_list.forEach(function (res, i) {
          if (i == data.user_condition_list.length - 1) {
            stampsUser = stampsUser + res;
          } else {
            stampsUser = stampsUser + res + ',';
          }
        });
      } else {
        if (data.user_condition == '0') {
          stampsUser = '所有用户';
        }
        if (data.user_condition == '1') {
          stampsUser = '所有会员';
        }
      }
      var newData = data;
      newData['useCondition'] = useCondition;
      newData['stampsUser'] = stampsUser;
      that.setData({
        couponDetail: newData
      });
      that.setData({
        detailShow: true
      });
    };

    _this.goToHomepage = function () {
      var homepageRouter = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + homepageRouter + '/' + homepageRouter, 1);
    };

    _this.formSubmit = function (event) {
      var that = _this,
          formId = event.detail.formId;
      if (_this.data.recving) {
        return;
      }
      _this.setRecving(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/RecvCoupon',
        data: {
          coupon_id: that.data.couponId,
          sub_app_id: that.data.franchiseeId,
          form_id: formId,
          recv_type: that.data.recv_type
        },
        hideLoading: true,
        success: function success(res) {
          that.setData({
            receiveSuccess: 1,
            receiveCount: res.data.recv_count,
            receiveLimitNum: res.data.limit_num,
            'couponDetail.is_already_recv': res.data.is_already_recv
          });
          setTimeout(function () {
            that.hideReceiveToast();
          }, 3000);
        },
        complete: function complete() {
          that.setRecving(false);
        }
      });
    };

    _this.setRecving = function (bool) {
      _this.setData({
        recving: bool
      });
    };

    _this.gotoTransferPage = function () {
      var url = '/eCommerce/pages/transferPage/transferPage';
      if (_this.data.franchiseeId) {
        url += '?franchisee=' + _this.data.franchiseeId;
      }
      _app.appMethod.turnToPage(url, false);
    };

    _this.gotoRecharge = function (event) {
      var that = _this;
      var userCouponId = event.currentTarget.dataset.id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/useCoupon',
        data: {
          user_coupon_id: userCouponId
        },
        hideLoading: true,
        success: function success(res) {
          that.setData({
            rechargeSuccess: 1,
            'couponDetail.status': 2
          });
          setTimeout(function () {
            that.hideRechargeToast();
          }, 3000);
        }
      });
    };

    _this.hideReceiveToast = function () {
      _this.setData({
        receiveSuccess: 0,
        receiveCount: 0,
        receiveLimitNum: 0
      });
    };

    _this.hideRechargeToast = function () {
      _this.setData({
        rechargeSuccess: 0
      });
    };

    _this.onShareAppMessage = function (res) {
      var that = _this;
      var franchiseeId = that.data.franchiseeId;
      var couponId = '';
      if (that.data.status == 'receive') {
        couponId = that.data.couponId;
      } else if (that.data.status == 'use') {
        couponId = that.data.couponDetail.coupon_id;
      }
      return {
        title: '速抢！限量优惠券，别说我不爱你~',
        path: '/pages/couponDetail/couponDetail?status=' + (that.data.status || 'receive') + '&detail=' + couponId + '&franchisee=' + franchiseeId,
        success: function success(res) {},
        fail: function fail(res) {}
      };
    };

    _this.showCouponVerify = function () {
      var qrcodeUrl = '' + _app.appMethod.globalData.siteBaseUrl + ('/index.php?r=AppShop/couponQrcode&app_id=' + (_this.data.franchiseeId ? _this.data.franchiseeId : _app.appMethod.globalData.appId)) + ('&user_coupon_id=' + _this.data.couponId);
      _this.setData({
        detailShow: false,
        verifyShow: true,
        'verifyData.qrcodeUrl': qrcodeUrl
      });
      _this.connectSocket();
    };

    _this.hideCouponVerify = function () {
      _this.setData({
        detailShow: true,
        verifyShow: false
      });
      clearInterval(_this.timeInterval);
      _this.socketOpen && _app.appMethod.closeSocket();
    };

    _this.timeInterval = '';
    _this.socketOpen = false;

    _this.connectSocket = function () {
      var that = _this;
      _app.appMethod.connectSocket({
        url: 'wss://ceshi.zhichiwangluo.com', //线下test
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        that.socketOpen = true;
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.timeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_coupon_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var couponDetail = that.data.couponDetail;

        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_coupon_verify' && msg.status == 0) {
            if (couponDetail.type != 6) {
              that.setData({
                'couponDetail.status': 2
              });
            } else {
              // 次数券
              var unVerfiyTimes = couponDetail.un_verify_times - 1;
              var verifiedTimes = couponDetail.verified_times + 1;
              that.setData({
                'couponDetail.un_verify_times': unVerfiyTimes,
                'couponDetail.verified_times': verifiedTimes
              });
              if (unVerfiyTimes == 0) {
                that.setData({
                  'couponDetail.status': 2
                });
              }
            }
            that.setData({
              'verifyData.success': true
            });
            clearInterval(that.timeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
      _app.appMethod.onSocketClose(function (res) {
        that.socketOpen = false;
        clearInterval(that.timeInterval);
        console.log('WebSocket 已关闭！');
      });
      _app.appMethod.onSocketError(function (res) {
        that.socketOpen = false;
        console.log('WebSocket连接打开错误，请检查！');
      });
    };

    _this.turnToCouponGoodsList = function (event) {
      var couponId = _this.data.status === 'receive' ? _this.data.couponId : _this.data.couponDetail.coupon_id;
      var franchiseeId = _this.data.franchiseeId;
      var url = '/eCommerce/pages/couponGoodsListPage/couponGoodsListPage?detail=' + couponId;
      if (franchiseeId) {
        url += '&franchisee=' + franchiseeId;
      }
      _app.appMethod.turnToPage(url);
    };

    _this.toggleVerificationDetail = function () {
      var verificationDetailShow = _this.data.verificationDetailShow;

      var isShow = verificationDetailShow ? false : true;
      var title = isShow ? '核销详情' : '优惠券';
      _this.setData({
        detailShow: !isShow,
        verificationDetailShow: isShow,
        'topNavBarData.title': title
      });
    };

    document.title = '优惠券';
    return _this;
  }

  (0, _createClass3.default)(CouponDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var status = options.status || 'receive'; // receive、use
      var couponId = options.detail || ''; // receive时为优惠券Id, use时为用户领取的优惠券Id
      var franchiseeId = options.franchisee || '';
      var recv_type = options.recv_type || ''; // 优惠券来源
      that.setData({
        status: status,
        couponId: couponId,
        franchiseeId: franchiseeId,
        recv_type: recv_type
      });
      if (status == 'receive') {
        that.getCouponInfo();
      } else if (status == 'use') {
        that.getUserListCouponInfo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearInterval(that.timeInterval);
      that.socketOpen && _app.appMethod.closeSocket();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          couponDetail = _state.couponDetail,
          detailShow = _state.detailShow,
          status = _state.status,
          coupon = _state.coupon,
          receiveSuccess = _state.receiveSuccess,
          receiveCount = _state.receiveCount,
          receiveLimitNum = _state.receiveLimitNum,
          rechargeSuccess = _state.rechargeSuccess,
          verifyShow = _state.verifyShow,
          verifyData = _state.verifyData,
          verificationDetailShow = _state.verificationDetailShow;

      return React.createElement(
        'div',
        { className: 'official-page coupon-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u4F18\u60E0\u5238' }),
        React.createElement(
          'div',
          {
            className: 'page',
            id: 'couponDetail',
            style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
          },
          React.createElement(
            'div',
            { className: 'coupon-detail-wrap ' + (detailShow ? 'show' : '') },
            React.createElement(
              'div',
              { className: 'top-section' },
              React.createElement('img', { className: 'logo', src: couponDetail.logo }),
              React.createElement(
                'div',
                { className: 'name' },
                couponDetail.app_name
              ),
              React.createElement(
                'div',
                {
                  className: 'ico-moon icon-share-new share',
                  hidden: status == 'use' && couponDetail.in_show_list == 0 || status == 'receive' && (couponDetail.enable_status == 0 || couponDetail.stock == 0 || couponDetail.in_show_list == 0)
                },
                React.createElement('button', {
                  className: 'share-btn',
                  onClick: this.shareClickEvent
                  // openType="share"
                })
              ),
              React.createElement(
                'div',
                { className: 'division-line' },
                React.createElement('div', {
                  className: 'left-circle',
                  style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
                }),
                React.createElement('div', {
                  className: 'right-circle',
                  style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'middle-section' },
              React.createElement(
                'div',
                {
                  className: 'title',
                  style: (0, _tools.convertLineStyleData)(status == 'use' && couponDetail.type != 4 ? 'padding-right:90rpx;' : '')
                },
                couponDetail.title
              ),
              React.createElement(
                'div',
                { className: 'sub-title' },
                couponDetail.sub_title
              ),
              status == 'use' && couponDetail.type != 4 && React.createElement('div', {
                className: 'ico-moon icon-qrcode-new qrcode',
                onClick: this.showCouponVerify
              }),
              React.createElement(
                'div',
                null,
                status == 'receive' && (couponDetail.enable_status == 0 || couponDetail.in_show_list == 0) && couponDetail.exchangeable != 2 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u5DF2\u4E0B\u67B6'
                ) : status == 'receive' && couponDetail.stock == 0 && couponDetail.exchangeable != 2 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u5DF2\u9886\u5B8C'
                ) : status == 'receive' && couponDetail.is_already_recv == 1 && couponDetail.exchangeable != 2 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u5DF2\u9886\u53D6'
                ) : status == 'receive' && couponDetail.is_already_recv == 0 && couponDetail.exchangeable != 2 ? React.createElement(
                  'button',
                  {
                    className: 'function-btn'
                    // formType="submit"
                    // type="submit"
                    , onClick: this.formSubmit,
                    'data-coupon-id': coupon.id,
                    style: (0, _tools.convertLineStyleData)('background-color:' + couponDetail.button_color)
                  },
                  '\u7ACB\u5373\u9886\u53D6'
                ) : status == 'use' && couponDetail.status == 2 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u5DF2\u4F7F\u7528'
                ) : status == 'use' && couponDetail.status == 3 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u5DF2\u5931\u6548'
                ) : status == 'use' && couponDetail.status == 4 ? React.createElement(
                  'div',
                  { className: 'function-btn disabled' },
                  '\u672A\u751F\u6548'
                ) : status == 'use' && couponDetail.type == 3 ? React.createElement('div', null) : status == 'use' && couponDetail.type == 4 ? React.createElement(
                  'div',
                  {
                    className: 'function-btn',
                    onClick: this.gotoRecharge,
                    'data-id': couponDetail.id,
                    style: (0, _tools.convertLineStyleData)('background-color:' + couponDetail.button_color)
                  },
                  '\u7ACB\u5373\u5145\u503C'
                ) : status == 'use' && couponDetail.type == 5 && React.createElement('div', null)
              ),
              React.createElement(
                'div',
                { className: 'detail-item condition' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u4F7F\u7528\u6761\u4EF6\uFF1A'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  couponDetail.useCondition
                )
              ),
              React.createElement(
                'div',
                { className: 'detail-item time' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u53EF\u7528\u65F6\u95F4\uFF1A'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  React.createElement(
                    'div',
                    { className: 'date-duration' },
                    couponDetail.expire == '-1' ? couponDetail.start_use_date + '至' + couponDetail.end_use_date : couponDetail.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (couponDetail.react > 0 ? couponDetail.react + '天后' : '当天') + '生效，有效期' + couponDetail.expire + '天'
                  ),
                  React.createElement(
                    'div',
                    { className: 'other-case' },
                    (couponDetail.exclude_holiday == 1 ? '除法定节假日' : '') + ' ' + (couponDetail.exclude_weekend == 1 ? '周一至周五' : '')
                  ),
                  React.createElement(
                    'div',
                    { className: 'time-duration' },
                    couponDetail.start_use_time + '-' + couponDetail.end_use_time
                  )
                )
              )
            ),
            couponDetail.type == 6 && status == 'use' && React.createElement(
              'div',
              {
                className: 'middle-section',
                onClick: this.toggleVerificationDetail
              },
              React.createElement(
                'div',
                { className: 'detail-item verify' },
                React.createElement(
                  'div',
                  { className: 'item-right' },
                  React.createElement(
                    'span',
                    { className: 'item-name' },
                    '\u6838\u9500\u8BE6\u60C5'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    React.createElement(
                      'span',
                      null,
                      '已核销：' + couponDetail.verified_times
                    ),
                    React.createElement(
                      'span',
                      null,
                      '未核销：' + (couponDetail.verify_times - couponDetail.verified_times)
                    )
                  )
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              )
            ),
            React.createElement(
              'div',
              { className: 'bottom-section' },
              couponDetail.extra_goods && couponDetail.extra_goods != 'null' && React.createElement(
                'div',
                {
                  className: 'detail-item couponGoods',
                  onClick: this.turnToCouponGoodsList
                },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u90E8\u5206\u53EF\u7528\u5546\u54C1'
                ),
                React.createElement(
                  'div',
                  { className: 'item-right' },
                  React.createElement(
                    'span',
                    null,
                    '\u67E5\u770B'
                  ),
                  React.createElement('label', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              couponDetail.address != '' && React.createElement(
                'div',
                { className: 'detail-item address' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u5E97\u94FA\u5730\u5740\uFF1A'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  couponDetail.address
                )
              ),
              couponDetail.stampsUser != '' && React.createElement(
                'div',
                { className: 'detail-item detail-item-user' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u53EF\u9886\u53D6\u7528\u6237\uFF1A'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  couponDetail.stampsUser
                )
              ),
              couponDetail.phone != '' && React.createElement(
                'div',
                { className: 'detail-item phone' },
                React.createElement(
                  'div',
                  { className: 'item-name' },
                  '\u8054\u7CFB\u7535\u8BDD\uFF1A'
                ),
                React.createElement(
                  'div',
                  { className: 'item-content' },
                  couponDetail.phone
                )
              ),
              React.createElement(
                'div',
                { className: 'goto-homepage', onClick: this.goToHomepage },
                React.createElement(
                  'div',
                  { className: 'goto-homepage-text' },
                  '\u8FD4\u56DE\u9996\u9875'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : ''),
              onClick: this.hideReceiveToast
            },
            React.createElement(
              'div',
              { className: 'zc-toast receive-success' },
              React.createElement('span', { className: 'icon', type: 'success', size: '20' }),
              React.createElement(
                'div',
                { className: 'title' },
                '\u9886\u53D6\u6210\u529F!'
              ),
              React.createElement(
                'div',
                { className: 'content' },
                '已领' + receiveCount + '张，限领' + receiveLimitNum + '张'
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'zc-toast-bg ' + (rechargeSuccess == 1 ? 'show' : ''),
              onClick: this.hideToast
            },
            React.createElement(
              'div',
              { className: 'zc-toast recharge-success' },
              React.createElement('span', { className: 'icon', type: 'success', size: '20' }),
              React.createElement(
                'div',
                { className: 'title' },
                '\u5145\u503C\u6210\u529F!'
              ),
              React.createElement(
                'div',
                { className: 'content' },
                '\u8BF7\u5230\u50A8\u503C\u91D1\u4E2D\u67E5\u770B'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'coupon-verify-wrap ' + (verifyShow ? 'show' : '') },
            React.createElement(
              'div',
              { className: 'top-section' },
              React.createElement(
                'div',
                {
                  className: 'cancel',
                  onClick: this.hideCouponVerify,
                  hidden: verifyData.success
                },
                '\u53D6\u6D88'
              ),
              React.createElement(
                'div',
                { className: 'name' },
                couponDetail.app_name
              ),
              React.createElement(
                'div',
                { className: 'title' },
                couponDetail.title
              )
            ),
            React.createElement(
              'div',
              { className: 'division-line' },
              React.createElement('div', {
                className: 'left-circle',
                style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
              }),
              React.createElement('div', {
                className: 'right-circle',
                style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
              })
            ),
            React.createElement(
              'div',
              { className: 'bottom-section' },
              !verifyData.success ? React.createElement(
                'div',
                { className: 'verify-block' },
                React.createElement('img', { className: 'qrcode', src: verifyData.qrcodeUrl }),
                React.createElement(
                  'div',
                  { className: 'code' },
                  '核销码：' + couponDetail.verify_code
                ),
                React.createElement(
                  'div',
                  { className: 'tip' },
                  '\u63D0\u793A\uFF1A\u8BF7\u63D0\u793A\u5546\u5BB6\u626B\u7801\u6838\u9500'
                )
              ) : verifyData.success && React.createElement(
                'div',
                { className: 'success-block' },
                React.createElement(
                  'div',
                  { className: 'success-tip' },
                  React.createElement('span', {
                    className: 'success-tip-icon',
                    type: 'success',
                    size: '20'
                  }),
                  React.createElement(
                    'span',
                    { className: 'success-tip-text' },
                    '\u6838\u9500\u6210\u529F!'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'back-tip', onClick: this.hideCouponVerify },
                  '>>>\u8FD4\u56DE'
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'coupon-cerification-detail ' + (verificationDetailShow ? 'show' : '')
            },
            React.createElement(
              'div',
              { className: 'detail-title' },
              React.createElement(
                'span',
                { className: 'detail-num num' },
                '\u5E8F\u53F7'
              ),
              React.createElement(
                'span',
                { className: 'detail-time' },
                '\u6838\u9500\u65F6\u95F4'
              )
            ),
            couponDetail.form_data && couponDetail.form_data.verify_log && couponDetail.form_data.verify_log.length !== 0 ? React.createElement(
              'div',
              { className: 'detail-list' },
              couponDetail.form_data.verify_log.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'detail-item', key: index },
                  React.createElement(
                    'span',
                    { className: 'item-num num' },
                    index + 1
                  ),
                  React.createElement(
                    'span',
                    { className: 'item-time' },
                    item.add_time
                  )
                );
              })
            ) : React.createElement(
              'div',
              { className: 'detail-nodata' },
              '- \u6682\u65E0\u6570\u636E -'
            ),
            React.createElement(
              'div',
              {
                className: 'detail-back-btn',
                onClick: this.toggleVerificationDetail
              },
              '\u8FD4\u56DE'
            )
          )
        )
      );
    }
  }]);
  return CouponDetail;
}(_OfficialPage3.default);

exports.default = CouponDetail;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(538);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BindCellphone = function (_OfficialPage) {
  (0, _inherits3.default)(BindCellphone, _OfficialPage);

  function BindCellphone(props) {
    (0, _classCallCheck3.default)(this, BindCellphone);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BindCellphone.__proto__ || Object.getPrototypeOf(BindCellphone)).call(this, props));

    _this.state = {
      hideVerifyPhone: true,
      hideBindNewPhone: true,
      appLogo: '',
      appTitleLen: 0,
      appTitle: '',
      isQuick: true,
      oldCode: '',
      oldCodeBtnDisabled: false,
      oldCodeStatus: '获取验证码',
      nextStepDisabled: false,
      newPhone: '',
      nationCode: '86',
      intlCode: '',
      newCode: '',
      newCodeBtnDisabled: false,
      newCodeStatus: '获取验证码',
      bindNewPhoneBtnDisabled: false,
      codeInterval: 60,
      phonePreFix: [{
        value: 86,
        label: '中国大陆',
        intlCode: 'CN'
      }, {
        value: 852,
        label: '中国香港',
        intlCode: 'HK'
      }, {
        value: 853,
        label: '中国澳门',
        intlCode: 'MO'
      }, {
        value: 886,
        label: '中国台湾',
        intlCode: 'TW'
      }, {
        value: 1,
        label: '美国',
        intlCode: 'US'
      }, {
        value: 1,
        label: '加拿大',
        intlCode: 'CA'
      }, {
        value: 81,
        label: '日本',
        intlCode: 'JP'
      }, {
        value: 60,
        label: '马来西亚',
        intlCode: 'MY'
      }],
      selectPhonePreFix: [86],
      oldPhonePicCodeUrl: '',
      newPhonePicCodeUrl: '',
      hasMerged: false,
      accountList: [],
      isPageBottom: false,
      isMember: 0
    };
    _this.oldPhonePicCode = '';
    _this.newPhonePicCode = '';
    _this.formerPageRouter = '';
    _this.formerOtherRouter = '';

    _this.dataInitial = function () {
      if (_app.appMethod.isLogin()) {
        _this.pageDataInitial();
        _this.getXcxUserInfo();
      } else {
        _app.appMethod.goLogin({
          success: function success(res) {
            _this.pageDataInitial();
            _this.getXcxUserInfo();
          }
        });
      }
    };

    _this.pageDataInitial = function () {
      _this.setData({
        appLogo: _app.appMethod.globalData.appLogo,
        appTitle: _app.appMethod.globalData.appTitle,
        appTitleLen: _app.appMethod.globalData.appTitle.length
      });
    };

    _this.getXcxUserInfo = function () {
      var has_merged = _app.appMethod.getUserInfo('has_merged');
      _this.setData({
        hasMerged: has_merged == undefined ? true : has_merged == 0
      });
    };

    _this.changeType = function (e) {
      var self = _this,
          isQuick = true,
          data = e.currentTarget.dataset;
      if (data.type == 'quick') {
        isQuick = true;
      } else {
        isQuick = false;
      }
      self.setData({
        isQuick: isQuick
      });
    };

    _this.getAccountInfo = function (callback) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetAccountIfCouldMerge',
        data: {},
        success: function success(res) {
          that.setData({
            accountList: res.data.list || []
          });
          typeof callback === 'function' && callback(res);
        }
      });
    };

    _this.sendCodeToOldPhone = function () {
      var that = _this;
      if (_this.data.oldCodeBtnDisabled) {
        return;
      }
      if (!_this.oldPhonePicCode) {
        _app.appMethod.showModal({
          content: '请输入图形验证码'
        });
        return;
      }
      _this.setData({
        oldCodeStatus: '正在发送...',
        oldCodeBtnDisabled: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/PhoneCode',
        data: {
          pic_code: _this.oldPhonePicCode
        },
        success: function success() {
          var second = that.data.codeInterval,
              interval;
          interval = setInterval(function () {
            if (second < 0) {
              clearInterval(interval);
              that.setData({
                oldCodeStatus: '获取验证码',
                oldCodeBtnDisabled: false
              });
            } else {
              that.setData({
                oldCodeStatus: second + 's'
              });
              second--;
            }
          }, 1000);
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.setData({
            oldCodeStatus: '获取验证码',
            oldCodeBtnDisabled: false
          });
        },
        fail: function fail() {
          that.setData({
            oldCodeStatus: '获取验证码',
            oldCodeBtnDisabled: false
          });
        }
      });
    };

    _this.inputOldCode = function (e) {
      _this.setData({
        oldCode: e.target.value
      });
    };

    _this.nextStep = function () {
      var that = _this;
      if (!_this.data.oldCode) {
        _app.appMethod.showModal({
          content: '请输入验证码'
        });
        return;
      }
      if (_this.data.nextStepDisabled) {
        return;
      }
      _this.setData({
        nextStepDisabled: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/VerifyPhone',
        method: 'post',
        data: {
          code: _this.data.oldCode
        },
        success: function success() {
          that.setData({
            hideVerifyPhone: true,
            hideBindNewPhone: false
          });
          that.refreshNewPhonePicCode();
        },
        complete: function complete() {
          that.setData({
            nextStepDisabled: false
          });
        }
      });
    };

    _this.inputPhone = function (e) {
      _this.setData({
        newPhone: e.target.value
      });
    };

    _this.inputNewCode = function (e) {
      _this.setData({
        newCode: e.target.value
      });
    };

    _this.sendCodeToNewPhone = function () {
      var that = _this,
          newPhone = _this.data.newPhone,
          phone = _this.data.nationCode != '86' ? _this.data.nationCode + '-' + newPhone : newPhone,
          isPhoneNumber = /^1\d{10}$/.test(phone) || /^\+?\d+-\d+$/.test(phone);
      _app.appMethod.getStorage({
        key: 'session_key',
        success: function success(res) {
          if (res.data == '') {
            _app.appMethod.showModal({
              content: '未获取授权，验证码获取失败'
            });
            return;
          }
        }
      });
      if (!_this.newPhonePicCode) {
        _app.appMethod.showModal({
          content: '请输入图形验证码'
        });
        return;
      }
      if (!isPhoneNumber) {
        _app.appMethod.showModal({
          content: '请输入正确的手机号码'
        });
        return;
      }
      if (_this.data.newCodeBtnDisabled) {
        return;
      }
      _this.setData({
        newCodeStatus: '正在发送...',
        newCodeBtnDisabled: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/NewPhoneCode',
        method: 'post',
        data: {
          phone: phone,
          pic_code: _this.newPhonePicCode
        },
        success: function success(res) {
          var second = that.data.codeInterval,
              interval;
          interval = setInterval(function () {
            if (second < 0) {
              clearInterval(interval);
              that.setData({
                newCodeStatus: '获取验证码',
                newCodeBtnDisabled: false
              });
            } else {
              that.setData({
                newCodeStatus: second + 's'
              });
              second--;
            }
          }, 1000);
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.setData({
            newCodeStatus: '获取验证码',
            newCodeBtnDisabled: false
          });
        },
        fail: function fail() {
          that.setData({
            newCodeStatus: '获取验证码',
            newCodeBtnDisabled: false
          });
        }
      });
    };

    _this.bindNewPhone = function () {
      var that = _this,
          newPhone = _this.data.newPhone,
          newCode = _this.data.newCode,
          nationCode = _this.data.nationCode != '86' ? _this.data.nationCode : '',
          intlCode = _this.data.intlCode,
          phone = nationCode ? nationCode + '-' + newPhone : newPhone,
          isPhoneNumber = /^1\d{10}$/.test(phone) || /^\+?\d+-\d+$/.test(phone);
      if (!newPhone || !newCode) {
        return;
      }
      if (!isPhoneNumber) {
        _app.appMethod.showModal({
          content: '请输入正确的手机号码'
        });
        return;
      }
      if (_this.data.bindNewPhoneBtnDisabled) {
        return;
      }
      _this.setData({
        bindNewPhoneBtnDisabled: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/XcxVerifyNewPhone',
        mehtod: 'post',
        data: {
          phone: phone,
          code: newCode,
          nationCode: nationCode,
          intlCode: intlCode
        },
        success: function success(res) {
          _app.appMethod.setUserInfoStorage({
            phone: newPhone
          });
          _app.appMethod.showToast({
            title: '绑定成功',
            icon: 'success',
            success: function success() {
              that.getAccountInfo(function () {
                if (that.data.hasMerged && that.data.accountList.length > 0) {
                  _app.appMethod.turnToPage('/userCollect', 1);
                } else if (that.formerOtherRouter) {
                  _app.appMethod.turnToPage('/' + that.formerOtherRouter + '&from=bindCellphone', true);
                } else if (that.data.isMember === 1) {
                  _app.appMethod.turnToPage('/' + that.formerPageRouter + '?is_member=1', 1);
                } else {
                  _app.appMethod.turnToPage('/' + that.formerPageRouter, 1);
                }
              });
            }
          });
        },
        fail: function fail(res) {
          _app.appMethod.showModal({
            content: '绑定失败' + res.data
          });
        },
        complete: function complete() {
          that.setData({
            bindNewPhoneBtnDisabled: false
          });
        }
      });
    };

    _this.getPhoneNumber = function (e) {
      var that = _this;
      if (e.detail.errMsg == 'getPhoneNumber:fail user deny' || e.detail.errMsg == 'getPhoneNumber:fail:user denied' || e.detail.errMsg == 'getPhoneNumber:fail:cancel to confirm login') {
        console.log(e.detail.errMsg);
        _app.appMethod.addLog(e.detail);
      } else if (e.detail.errMsg == 'getPhoneNumber:fail 该 appid 没有权限' || e.detail.errMsg == 'getPhoneNumber:fail jsapi has no permission, event…sg=permission got, detail=jsapi has no permission') {
        _app.appMethod.showModal({
          content: '该appid没有权限，目前该功能针对非个人开发者，且完成了认证的小程序开放（不包含海外主体）'
        });
        _app.appMethod.addLog(e.detail);
      } else if (e.detail.encryptedData) {
        _app.appMethod.checkSession(function () {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppUser/GetPhoneNumber',
            data: {
              encryptedData: e.detail.encryptedData,
              iv: e.detail.iv
            },
            success: function success(res) {
              _app.appMethod.setUserInfoStorage({
                phone: res.data
              });
              _app.appMethod.showToast({
                title: '授权成功',
                icon: 'success',
                success: function success() {
                  that.getAccountInfo(function () {
                    if (that.data.hasMerged && that.data.accountList.length > 0) {
                      _app.appMethod.turnToPage('/userCollect', 1);
                    } else if (that.formerOtherRouter) {
                      _app.appMethod.turnToPage('/' + that.formerOtherRouter + '&from=bindCellphone', true);
                    } else if (that.data.isMember) {
                      _app.appMethod.turnToPage('/' + that.formerPageRouter + '?is_member=1', 1);
                    } else {
                      _app.appMethod.turnToPage('/' + that.formerPageRouter, 1);
                    }
                  });
                }
              });
            },
            successStatus5: function successStatus5() {
              _app.appMethod.showModal({
                content: '获取手机号失败，请再次点击授权获取'
              });
              // app.goLogin({
              //   success: function() {
              //     app.showModal({
              //       content: '获取手机号失败，请再次点击授权获取'
              //     })
              //   },
              //   fail: function() {
              //     app.showModal({
              //       content: '获取手机号失败，请再次点击授权获取'
              //     })
              //   }
              // })
            }
          });
        });
      } else {
        _app.appMethod.showModal({
          content: '无法获取到手机号，请检查该appid是否有权限'
        });
        _app.appMethod.addLog(e);
      }
    };

    _this.inputOldPhonePicCode = function (e) {
      var value = e.target.value;
      _this.oldPhonePicCode = value;
    };

    _this.inputNewPhonePicCode = function (e) {
      var value = e.target.value;
      _this.newPhonePicCode = value;
    };

    _this.refreshOldPhonePicCode = function () {
      _this.setData({
        oldPhonePicCodeUrl: (_app.appMethod.getSiteBaseUrl() || '') + '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.refreshNewPhonePicCode = function () {
      _this.setData({
        newPhonePicCodeUrl: (_app.appMethod.getSiteBaseUrl() || '') + '/index.php?r=Login/GetIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.backToHomePage = function () {
      _app.appMethod.turnToPage('/' + _app.appMethod.globalData.homepageRouter);
    };

    _this.bindPickerChange = function (e) {
      var nationCode = void 0;
      var intlCode = void 0;
      _this.state.phonePreFix.some(function (ppf) {
        var f = ppf.value === e[0];
        if (f) {
          nationCode = ppf.value;
          intlCode = ppf.intlCode;
        }
        return f;
      });
      _this.setData({
        selectPhonePreFix: e,
        nationCode: nationCode,
        intlCode: intlCode
      });
    };

    document.title = '手机绑定';
    return _this;
  }

  (0, _createClass3.default)(BindCellphone, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var userInfo = _app.appMethod.getUserInfo();
      if (options.p) {
        this.formerOtherRouter = decodeURIComponent(options.p);
      }
      if (options.is_member == 1) {
        this.setData({
          isMember: 1
        });
      }
      this.formerPageRouter = options.r || '';
      if (userInfo.phone) {
        this.setData({
          hideVerifyPhone: false
        });
        this.refreshOldPhonePicCode();
        this.getAccountInfo();
      } else {
        this.setData({
          hideBindNewPhone: false
        });
        this.refreshNewPhonePicCode();
      }
      var tabPage = _app.appMethod.getTabPagePathArr();
      var pageUrl = this.formerPageRouter;
      if (tabPage.indexOf(pageUrl) > -1) {
        this.setData({
          showBackHomeButton: true
        });
      }
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isPageBottom = _state.isPageBottom,
          appLogo = _state.appLogo,
          appTitleLen = _state.appTitleLen,
          appTitle = _state.appTitle,
          hideVerifyPhone = _state.hideVerifyPhone,
          oldPhonePicCodeUrl = _state.oldPhonePicCodeUrl,
          oldCodeStatus = _state.oldCodeStatus,
          hideBindNewPhone = _state.hideBindNewPhone,
          isQuick = _state.isQuick,
          nationCode = _state.nationCode,
          phonePreFix = _state.phonePreFix,
          selectPhonePreFix = _state.selectPhonePreFix,
          newPhonePicCodeUrl = _state.newPhonePicCodeUrl,
          newCodeStatus = _state.newCodeStatus,
          newPhone = _state.newPhone,
          newCode = _state.newCode,
          showBackHomeButton = _state.showBackHomeButton;

      return React.createElement(
        'div',
        { className: 'official-page bind-cellphone' },
        React.createElement(_TopNav.TopNav, { title: '\u624B\u673A\u7ED1\u5B9A' }),
        React.createElement(
          'div',
          { id: 'bindPhonePage' },
          React.createElement(
            'div',
            {
              className: 'page bindPhone-wrap',
              id: 'bindPhonePage',
              'data-router': 'bindPhonePage',
              style: (0, _tools.convertLineStyleData)(isPageBottom ? 'padding-bottom:600rpx' : '')
            },
            React.createElement(
              'div',
              { className: 'header-wrap' },
              React.createElement(
                'div',
                { className: 'image-wrap' },
                React.createElement('img', { src: appLogo })
              ),
              React.createElement(
                'div',
                {
                  className: 'title-wrap',
                  style: (0, _tools.convertLineStyleData)('font-size:' + (appTitleLen >= 8 ? '30rpx' : '55rpx'))
                },
                appTitle
              )
            ),
            React.createElement(
              'div',
              { className: 'verify-wrap', hidden: hideVerifyPhone },
              React.createElement(
                'div',
                { className: 'verify-row getCode' },
                React.createElement('input', {
                  // placeholderClass="phcolor"
                  className: 'pic-code-input',
                  onInput: this.inputOldPhonePicCode,
                  placeholder: '\u56FE\u7247\u9A8C\u8BC1\u7801'
                }),
                React.createElement(
                  'div',
                  { className: 'pic-code-wrap' },
                  React.createElement('img', {
                    className: 'pic-code',
                    mode: 'aspectFit',
                    src: oldPhonePicCodeUrl,
                    onClick: this.refreshOldPhonePicCode
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'verify-row postCode' },
                React.createElement('input', {
                  // placeholderClass="phcolor"
                  onInput: this.inputOldCode,
                  placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801'
                }),
                React.createElement(
                  'div',
                  {
                    className: 'get-code-btn',
                    onClick: this.sendCodeToOldPhone
                  },
                  oldCodeStatus
                )
              ),
              React.createElement(
                'div',
                { className: 'option-btn next-step', onClick: this.nextStep },
                '\u4E0B\u4E00\u6B65'
              )
            ),
            React.createElement(
              'div',
              { className: 'bind-new-tel-wrap', hidden: hideBindNewPhone },
              React.createElement(
                'div',
                { className: 'main-wrap' },
                React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'any-message' },
                    React.createElement(
                      'div',
                      { className: 'verify-row phonenum' },
                      React.createElement(
                        _picker2.default,
                        {
                          className: 'prefix-code',
                          data: phonePreFix,
                          value: selectPhonePreFix,
                          cols: 1,
                          onOk: function onOk(v) {
                            return _this2.bindPickerChange(v);
                          }
                        },
                        React.createElement(
                          'div',
                          null,
                          '+' + nationCode
                        )
                      ),
                      React.createElement('span', { className: 'ico-moon icon-rightarrow' }),
                      React.createElement('input', {
                        // placeholderClass="phcolor"
                        className: 'code-tel',
                        onInput: this.inputPhone,
                        placeholder: '\u624B\u673A\u53F7'
                        // cursorSpacing="200"
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'verify-row getCode' },
                      React.createElement('input', {
                        // placeholderClass="phcolor"
                        className: 'pic-code-input'
                        // cursorSpacing="140"
                        , onInput: this.inputNewPhonePicCode,
                        placeholder: '\u56FE\u7247\u9A8C\u8BC1\u7801'
                      }),
                      React.createElement(
                        'div',
                        { className: 'pic-code-wrap' },
                        React.createElement('img', {
                          className: 'pic-code',
                          mode: 'aspectFit',
                          src: newPhonePicCodeUrl,
                          onClick: this.refreshNewPhonePicCode
                        })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'verify-row postCode' },
                      React.createElement('input', {
                        // placeholderClass="phcolor"
                        onInput: this.inputNewCode,
                        placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801'
                        // cursorSpacing="80"
                      }),
                      React.createElement(
                        'div',
                        {
                          className: 'get-code-btn',
                          onClick: this.sendCodeToNewPhone
                        },
                        newCodeStatus
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'option-btn bind-new-tel-btn ' + (!newPhone || !newCode ? 'disabled' : ''),
                      onClick: this.bindNewPhone
                    },
                    '\u767B\u5F55'
                  )
                )
              )
            ),
            showBackHomeButton && React.createElement('div', {
              className: 'back-home-btn icon-back-to-home ico-moon',
              onClick: this.backToHomePage
            })
          )
        )
      );
    }
  }]);
  return BindCellphone;
}(_OfficialPage3.default);

exports.default = BindCellphone;

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(540);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdvanceSearch = function (_OfficialPage) {
  (0, _inherits3.default)(AdvanceSearch, _OfficialPage);

  function AdvanceSearch(props) {
    (0, _classCallCheck3.default)(this, AdvanceSearch);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (AdvanceSearch.__proto__ || Object.getPrototypeOf(AdvanceSearch)).call(this, props));

    _this2.state = {
      history: [],
      inputContent: ''
    };

    _this2.searchList = function () {
      var history = _this2.data.history;
      var content = _this2.data.inputContent;
      var index = history.indexOf(content);
      if (index > -1) {
        history.splice(index, 1);
      }
      history.unshift(content);
      _this2.setData({ history: history });
      _app.appMethod.setStorage({
        key: 'history',
        data: history
      });
      if (_this2.data.comeSearch) {
        _app.appMethod.setStorage({
          key: 'current-search',
          data: content
        });
        _app.appMethod.turnBack();
        _app.appMethod.globalData.classifyGoodsListPageRefresh = true;
      } else {
        _this2.turnToClassifyGoodsListPage(content);
      }
    };

    _this2.quickSearch = function (e) {
      var tag = e.target.dataset.tag;
      _this2.setData({ inputContent: tag });
      if (_this2.data.comeSearch) {
        _app.appMethod.setStorage({
          key: 'current-search',
          data: tag
        });
        _app.appMethod.turnBack();
        _app.appMethod.globalData.classifyGoodsListPageRefresh = true;
      } else {
        _this2.turnToClassifyGoodsListPage(tag);
      }
    };

    _this2.turnToClassifyGoodsListPage = function (word) {
      var data = _this2.data;
      var param = '';
      if (data.isHideStock != '') {
        param += '&isHideStock=' + data.isHideStock;
      }
      if (data.isHideSales != '') {
        param += '&isHideSales=' + data.isHideSales;
      }
      if (data.integral != '') {
        param += '&integral=' + data.integral;
      }
      if (data.isShowVirtualPrice != '') {
        param += '&isShowVirtualPrice=' + data.isShowVirtualPrice;
      }
      if (data.isShoppingCart != '') {
        param += '&isShoppingCart=' + data.isShoppingCart;
      }
      if (data.isBuyNow != '') {
        param += '&isBuyNow=' + data.isBuyNow;
      }
      if (data.category != '') {
        param += '&category_id=' + data.category;
      }
      if (+data.isShowFG === 1) {
        param += '&isShowFG=' + 1;
      }
      _app.appMethod.turnToPage('/pages/classifyGoodsListPage/classifyGoodsListPage?form=' + data.form + '&search=' + word + param, true);
    };

    _this2.bindChange = function (e) {
      var _value = e.target.value;
      _this2.setData({ inputContent: _value });
    };

    _this2.clearSearch = function () {
      _this2.setData({
        inputContent: '',
        showResult: false
      });
    };

    _this2.clearHistory = function () {
      var _this = _this2;
      _app.appMethod.removeStorage({
        key: 'history',
        success: function success(res) {
          _this.setData({ history: [] });
        }
      });
    };

    _this2.navigateBack = function () {
      _app.appMethod.turnBack();
    };

    document.title = '搜索';
    return _this2;
  }

  (0, _createClass3.default)(AdvanceSearch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        form: options.form || '',
        comeSearch: options.search ? true : false,
        inputContent: options.search || '',
        isHideStock: options.isHideStock || '',
        isHideSales: options.isHideSales || '',
        integral: options.integral || '',
        isShowVirtualPrice: options.isShowVirtualPrice || '',
        isShoppingCart: options.isShoppingCart || '',
        isBuyNow: options.isBuyNow || '',
        category: options.category || '',
        isShowFG: options.isShowFG || ''
      });
      var _this = this;
      _app.appMethod.getStorage({
        key: 'history',
        success: function success(res) {
          _this.setData({ history: res.data || [] });
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          inputContent = _state.inputContent,
          history = _state.history;

      return React.createElement(
        'div',
        { className: 'official-page advance-search' },
        React.createElement(_TopNav.TopNav, { title: '\u641C\u7D22' }),
        React.createElement(
          'div',
          { className: 'comp-search' },
          React.createElement(
            'div',
            {
              className: 'ico-moon icon-location locate hide',
              onClick: this.filterByLocation
            },
            '\u5168\u56FD'
          ),
          React.createElement(
            'div',
            { className: 'search-wrap' },
            React.createElement('span', { size: '14', type: 'search', onClick: this.searchList }),
            React.createElement('input', {
              id: 'search',
              value: inputContent,
              onInput: this.bindChange,
              onBlur: this.searchList
              // focus="true"
              , name: 'input',
              placeholder: '\u8BF7\u8F93\u5165\u641C\u7D22\u5173\u952E\u8BCD'
              // confirmType="search"
            }),
            React.createElement(
              'div',
              {
                className: 'cross ' + (inputContent == '' ? 'hide' : ''),
                onClick: this.clearSearch
              },
              '\xD7'
            )
          ),
          React.createElement(
            'button',
            { className: 'cancel', onClick: this.navigateBack },
            '\u53D6\u6D88'
          )
        ),
        React.createElement(
          'div',
          { className: 'history' },
          React.createElement(
            'div',
            { className: 'title' },
            React.createElement(
              'span',
              { className: 'left' },
              '\u5386\u53F2\u641C\u7D22'
            ),
            React.createElement(
              'span',
              { className: 'right', onClick: this.clearHistory },
              '\u6E05\u9664'
            )
          ),
          React.createElement(
            'div',
            { className: 'content' },
            history && history.map(function (item, index) {
              return React.createElement(
                'div',
                {
                  className: 'history-item',
                  key: true,
                  'data-tag': item,
                  onClick: _this3.quickSearch
                },
                item
              );
            })
          )
        )
      );
    }
  }]);
  return AdvanceSearch;
}(_OfficialPage3.default);

exports.default = AdvanceSearch;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(542);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExtensionPage = function (_OfficialPage) {
  (0, _inherits3.default)(ExtensionPage, _OfficialPage);

  function ExtensionPage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ExtensionPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ExtensionPage.__proto__ || Object.getPrototypeOf(ExtensionPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      appTitle: '',
      appLogo: '',
      extensionId: '', // 推广页id
      extensionItemData: {}, // 推广页面配置信息
      currentPage: ''
    }, _this.dataInitial = function () {
      _this.getExtensionPageData(_this.data.extensionId);
    }, _this.getExtensionPageData = function (id) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppExtensionInfo/getOneExtensionInfo',
        data: {
          id: id
        },
        hideLoading: true,
        success: function success(res) {
          var configData = JSON.parse(res.data.config_data);
          that.setData({
            extensionItemData: configData
          });
          _app.appMethod.setPageTitle(that.data.appTitle || '即速应用 webapp');
        }
      });
    }, _this.jumpToHome = function () {
      var router = _app.appMethod.globalData.homepageRouter;
      var url = '/' + router;
      _app.appMethod.turnToPage(url, true);
    }, _this.jumpToPage = function (event) {
      var url = event.currentTarget.dataset.pageUrl;
      _app.appMethod.turnToPage(url, false);
    }, _this.jumpToRouter = function (event) {
      var router = event.currentTarget.dataset.pageUrl;
      var url = '/' + router;
      _app.appMethod.turnToPage(url, false);
    }, _this.copyWifiPassword = function () {
      _app.appMethod.setClipboardData({
        data: _this.data.extensionItemData['wifi']['wifi_password'],
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            success: function success() {}
          });
        }
      });
    }, _this.showWifiPage = function () {
      var router = 'extensionPage';
      var url = '/extensionPage?extension_id=' + _this.data.extensionId + '&current_page=wifi';
      _app.appMethod.turnToPage(url, false);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ExtensionPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        appTitle: _app.appMethod.globalData.appTitle,
        appLogo: _app.appMethod.globalData.appLogo,
        extensionId: options.extension_id,
        currentPage: options.current_page || 'home'
      });
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          appLogo = _state.appLogo,
          appTitle = _state.appTitle,
          extensionItemData = _state.extensionItemData,
          currentPage = _state.currentPage;

      return React.createElement(
        'div',
        { className: 'official-page extension-page' },
        React.createElement(_TopNav.TopNav, { title: '\u63A8\u5E7F' }),
        React.createElement(
          'div',
          { className: 'extensionPage-wrap page', id: 'extensionPage' },
          currentPage == 'home' ? React.createElement(
            'div',
            { className: 'home-page' },
            React.createElement(
              'div',
              { className: 'goto-home-item', onClick: this.jumpToHome },
              React.createElement('img', { className: 'app-logo', src: appLogo }),
              React.createElement(
                'span',
                { className: 'app-title' },
                appTitle
              ),
              React.createElement(
                'span',
                { className: 'tip' },
                '\u8FDB\u5165\u9996\u9875'
              ),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ),
            extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 && extensionItemData['wifi']['is_main'] == 1 ? React.createElement(
              'div',
              { className: 'main-extension-item wifi' },
              React.createElement(
                'div',
                { className: 'wifi-setting' },
                React.createElement(
                  'span',
                  { className: 'setting-field' },
                  'Wi-Fi\u540D\u79F0:'
                ),
                React.createElement(
                  'span',
                  { className: 'setting-text' },
                  extensionItemData['wifi']['wifi_name']
                )
              ),
              React.createElement(
                'div',
                { className: 'wifi-setting' },
                React.createElement(
                  'span',
                  { className: 'setting-field' },
                  'Wi-Fi\u5BC6\u7801:'
                ),
                React.createElement(
                  'span',
                  { className: 'setting-text' },
                  extensionItemData['wifi']['wifi_password']
                ),
                React.createElement(
                  'div',
                  {
                    className: 'copy-password',
                    onClick: this.copyWifiPassword
                  },
                  '\u590D\u5236'
                )
              )
            ) : extensionItemData['facetoface_pay'] && extensionItemData['facetoface_pay']['show'] == 1 && extensionItemData['facetoface_pay']['is_main'] == 1 ? React.createElement(
              'div',
              {
                className: 'main-extension-item facetoface-pay',
                'data-page-url': '/eCommerce/pages/transferPage/transferPage',
                onClick: this.jumpToPage
              },
              React.createElement(
                'div',
                { className: 'main-item-icon' },
                React.createElement('div', { className: 'ico-moon icon-facetoface-pay' })
              ),
              React.createElement(
                'span',
                { className: 'main-item-name' },
                '\u9762\u5BF9\u9762\u4ED8\u6B3E'
              ),
              React.createElement(
                'span',
                { className: 'main-item-tip' },
                '\u7ACB\u5373\u524D\u5F80'
              ),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ) : extensionItemData['coupon'] && extensionItemData['coupon']['show'] == 1 && extensionItemData['coupon']['is_main'] == 1 ? React.createElement(
              'div',
              {
                className: 'main-extension-item coupon',
                'data-page-url': '/eCommerce/pages/couponList/couponList',
                onClick: this.jumpToPage
              },
              React.createElement(
                'div',
                { className: 'main-item-icon' },
                React.createElement('div', { className: 'ico-moon icon-coupon' })
              ),
              React.createElement(
                'span',
                { className: 'main-item-name' },
                '\u4F18\u60E0\u5238'
              ),
              React.createElement('span', { className: 'main-item-tip' }),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ) : extensionItemData['vip_card'] && extensionItemData['vip_card']['show'] == 1 && extensionItemData['vip_card']['is_main'] == 1 && React.createElement(
              'div',
              {
                className: 'main-extension-item vip-card',
                'data-page-url': '/eCommerce/pages/vipCard/vipCard',
                onClick: this.jumpToPage
              },
              React.createElement(
                'div',
                { className: 'main-item-icon' },
                React.createElement('div', { className: 'ico-moon icon-vip-card' })
              ),
              React.createElement(
                'span',
                { className: 'main-item-name' },
                '\u4F1A\u5458\u5361'
              ),
              React.createElement('span', { className: 'main-item-tip' }),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ),
            React.createElement(
              'div',
              { className: 'extension-item-list' },
              extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 && extensionItemData['wifi']['is_main'] == 0 && React.createElement(
                'div',
                {
                  className: 'extension-item',
                  onClick: this.showWifiPage
                },
                React.createElement('div', { className: 'item-icon ico-moon icon-wifi' }),
                React.createElement(
                  'span',
                  { className: 'item-text' },
                  'Wi-Fi'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              ),
              extensionItemData['facetoface_pay'] && extensionItemData['facetoface_pay']['show'] == 1 && extensionItemData['facetoface_pay']['is_main'] == 0 && React.createElement(
                'div',
                {
                  className: 'extension-item',
                  'data-page-url': '/eCommerce/pages/transferPage/transferPage',
                  onClick: this.jumpToPage
                },
                React.createElement('div', { className: 'item-icon ico-moon icon-facetoface-pay' }),
                React.createElement(
                  'span',
                  { className: 'item-text' },
                  '\u9762\u5BF9\u9762\u4ED8\u6B3E'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              ),
              extensionItemData['coupon'] && extensionItemData['coupon']['show'] == 1 && extensionItemData['coupon']['is_main'] == 0 && React.createElement(
                'div',
                {
                  className: 'extension-item',
                  'data-page-url': '/eCommerce/pages/couponList/couponList',
                  onClick: this.jumpToPage
                },
                React.createElement('div', { className: 'item-icon ico-moon icon-coupon' }),
                React.createElement(
                  'span',
                  { className: 'item-text' },
                  '\u4F18\u60E0\u5238'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              ),
              extensionItemData['vip_card'] && extensionItemData['vip_card']['show'] == 1 && extensionItemData['vip_card']['is_main'] == 0 && React.createElement(
                'div',
                {
                  className: 'extension-item',
                  'data-page-url': '/eCommerce/pages/vipCard/vipCard',
                  onClick: this.jumpToPage
                },
                React.createElement('div', { className: 'item-icon ico-moon icon-vip-card' }),
                React.createElement(
                  'span',
                  { className: 'item-text' },
                  '\u4F1A\u5458\u5361'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              )
            ),
            extensionItemData['advert_img'] && extensionItemData['advert_img']['show'] == 1 && React.createElement(
              'div',
              { className: 'advert-img-item' },
              React.createElement(
                _carousel2.default,
                {
                  autoplay: true
                },
                extensionItemData['advert_img']['img_list'].map(function (val, index) {
                  return React.createElement(
                    'a',
                    {
                      key: index,
                      style: { display: 'inline-block', width: '100%', height: '1.95rem' }
                    },
                    React.createElement('img', {
                      src: val['url'],
                      className: 'slide-image',
                      mode: 'widthFix',
                      onClick: _this2.jumpToRouter,
                      'data-page-url': val['link'],
                      style: { width: '100%', verticalAlign: 'top', height: '100%' }
                    })
                  );
                })
              )
            )
          ) : currentPage == 'wifi' && React.createElement(
            'div',
            { className: 'second-page' },
            extensionItemData['wifi'] && extensionItemData['wifi']['show'] == 1 && React.createElement(
              'div',
              { className: 'main-extension-item wifi' },
              React.createElement(
                'div',
                { className: 'wifi-setting' },
                React.createElement(
                  'span',
                  { className: 'setting-field' },
                  'Wi-Fi\u540D\u79F0:'
                ),
                React.createElement(
                  'span',
                  { className: 'setting-text' },
                  extensionItemData['wifi']['wifi_name']
                )
              ),
              React.createElement(
                'div',
                { className: 'wifi-setting' },
                React.createElement(
                  'span',
                  { className: 'setting-field' },
                  'Wi-Fi\u5BC6\u7801:'
                ),
                React.createElement(
                  'span',
                  { className: 'setting-text' },
                  extensionItemData['wifi']['wifi_password']
                ),
                React.createElement(
                  'div',
                  {
                    className: 'copy-password',
                    onClick: this.copyWifiPassword
                  },
                  '\u590D\u5236'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ExtensionPage;
}(_OfficialPage3.default);

exports.default = ExtensionPage;

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _Map = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import './MapDetail.less';

var MapDetail = function (_OfficialPage) {
  (0, _inherits3.default)(MapDetail, _OfficialPage);

  function MapDetail(props) {
    (0, _classCallCheck3.default)(this, MapDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MapDetail.__proto__ || Object.getPrototypeOf(MapDetail)).call(this, props));

    _this.state = {};

    document.title = '地图';
    return _this;
  }

  (0, _createClass3.default)(MapDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var parsed_params = JSON.parse(options.eventParams);
      var new_marker = {};
      new_marker['markers'] = parsed_params;
      new_marker['longitude'] = parsed_params[0].longitude;
      new_marker['latitude'] = parsed_params[0].latitude;
      this.setData(new_marker);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          longitude = _state.longitude,
          latitude = _state.latitude,
          markers = _state.markers;

      return React.createElement(
        'div',
        { className: 'map-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u5730\u56FE' }),
        React.createElement(_Map.Map, {
          longitude: longitude,
          latitude: latitude,
          scale: '17',
          markers: markers, style: {
            width: '100%',
            height: '100%'
          }
        })
      );
    }
  }]);
  return MapDetail;
}(_OfficialPage3.default);

exports.default = MapDetail;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(545);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paying = function (_React$Component) {
  (0, _inherits3.default)(Paying, _React$Component);

  function Paying(props) {
    (0, _classCallCheck3.default)(this, Paying);
    return (0, _possibleConstructorReturn3.default)(this, (Paying.__proto__ || Object.getPrototypeOf(Paying)).call(this, props));
  }

  (0, _createClass3.default)(Paying, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      console.log(options);
      this.orderId = options.orderId;
      if (!this.orderId) {
        console.error('orderId 参数未传');
        return;
      }
      if (options && options.isPayBack == 1) {
        this.getOrder();
      } else {
        history.replaceState(null, null, location.href + '&isPayBack=1');
      }
    }
  }, {
    key: 'getOrder',
    value: function getOrder() {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getOrder',
        data: {
          order_id: this.orderId,
          sub_shop_app_id: this.franchisee
        },
        success: function success(res) {
          var payCallbackUrl = _app.appMethod.getStorageSync('payCallbackUrl');
          if (res.data[0].form_data.status != 0) {
            payCallbackUrl.successUrl && _app.appMethod.turnToPage(payCallbackUrl.successUrl, {}, true);
          } else {
            payCallbackUrl.failUrl && _app.appMethod.turnToPage(payCallbackUrl.failUrl, {}, true);
          }
          _app.appMethod.removeStorage({ key: 'payCallbackUrl' });
        },
        fail: function fail() {}
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'paying-tip' },
        '\u6B63\u5728\u652F\u4ED8\u3002\u3002\u3002'
      );
    }
  }]);
  return Paying;
}(_react2.default.Component);

exports.default = Paying;

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(547);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectStars = function (_OfficialPage) {
  (0, _inherits3.default)(CollectStars, _OfficialPage);

  function CollectStars(props) {
    (0, _classCallCheck3.default)(this, CollectStars);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CollectStars.__proto__ || Object.getPrototypeOf(CollectStars)).call(this, props));

    _this.state = {
      selectedCollectType: '电商',
      isHideTypeNav: true,
      recordTabType: 0,
      collectStarsData: {
        collectedNum: 0,
        collectNum: 8,
        starStyleArr: ['dark', 'dark', 'dark', 'dark', 'dark', 'dark', 'dark', 'dark'],
        dark_img: 'http://img.zhichiwangluo.com/zcimgdir/album/file_5afac25ca94fb.png'
      },
      starRecordList: {
        list: [],
        isNull: false,
        loadingData: {
          isLoading: false
        }
      },
      awardRecordList: {
        list: [],
        isNull: false,
        loadingData: {
          isLoading: false
        }
      }
    };

    _this.onReachBottom = function () {};

    _this.initialLoadingData = function () {
      _this.setData({
        starRecordList: {
          list: [],
          isNull: false,
          loadingData: {
            isLoading: false
          }
        },
        awardRecordList: {
          list: [],
          isNull: false,
          loadingData: {
            isLoading: false
          }
        }
      });
    };

    _this.getCollectStarsData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appMarketing/GetUserCollectNum',
        data: {
          sub_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var returnData = res.data;
          var tempArr = [];
          var tempNum = 0;
          if (returnData.togetherNum != undefined) {
            // 合计计算
            tempNum = returnData.togetherNum;
            for (var i = 0; i < returnData.collectNum; i++) {
              if (i < returnData.togetherNum) {
                tempArr.push('light');
              } else {
                tempArr.push('dark');
              }
            }
          } else {
            // 单独计算
            tempNum = returnData.ecommerceNum;
            for (var _i = 0; _i < returnData.collectNum; _i++) {
              if (_i < returnData.ecommerceNum) {
                tempArr.push('light');
              } else {
                tempArr.push('dark');
              }
            }
          }
          if (returnData.status == 0) {
            _app.appMethod.showModal({
              content: '没有进行中的活动'
            });
          }
          if (returnData.status == 0 && returnData.isReset == 1) {
            tempNum = 0;
            tempArr = ['dark', 'dark', 'dark', 'dark', 'dark', 'dark', 'dark', 'dark'];
          }
          returnData.collectedNum = tempNum;
          returnData.starStyleArr = tempArr;
          that.setData({
            collectStarsData: returnData
          });
        }
      });
    };

    _this.getStarsRecordData = function () {
      var that = _this;
      var starRecordList = _this.data.starRecordList;
      var list = starRecordList.list,
          loadingData = starRecordList.loadingData,
          isNull = starRecordList.isNull;

      if (loadingData.isLoading) {
        return;
      }
      that.setData({
        'starRecordList.loadingData.isLoading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appMarketing/GetUserCollectRecord',
        data: {
          sub_app_id: that.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var returnList = res.data;
          if (returnList && returnList.length !== 0) {
            loadingData = {
              isLoading: false
            };
            that.setData({
              'starRecordList.list': list.concat(returnList),
              'starRecordList.loadingData': loadingData
            });
          } else {
            that.setData({
              'starRecordList.isNull': true
            });
          }
        },
        complete: function complete() {
          that.setData({
            'starRecordList.loadingData.isLoading': false
          });
        }
      });
    };

    _this.getAwardRecordData = function () {
      var that = _this;
      var awardRecordList = _this.data.awardRecordList;
      var list = awardRecordList.list,
          loadingData = awardRecordList.loadingData,
          isNull = awardRecordList.isNull;

      if (loadingData.isLoading) {
        return;
      }
      that.setData({
        'awardRecordList.loadingData.isLoading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appMarketing/GetUserRewardsRecord',
        data: {
          sub_app_id: that.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var returnList = res.data;
          if (returnList && returnList.length !== 0) {
            loadingData = {
              isLoading: false
            };
            that.setData({
              'awardRecordList.list': list.concat(returnList),
              'awardRecordList.loadingData': loadingData
            });
          } else {
            that.setData({
              'awardRecordList.isNull': true
            });
          }
        },
        complete: function complete() {
          that.setData({
            'awardRecordList.loadingData.isLoading': false
          });
        }
      });
    };

    _this.toggleMoreType = function () {
      var isHideTypeNav = _this.data.isHideTypeNav;

      _this.setData({
        isHideTypeNav: isHideTypeNav ? false : true
      });
    };

    _this.selectCollectType = function (e) {
      var collectTypeArr = ['电商', '到店', '当面付', '分享赠送', '拉新赠送', '收藏赠送'];
      var type = e.target.dataset.type;
      var collectStarsData = _this.data.collectStarsData;

      var tempArr = [],
          tempNum = 0;
      if (type == 0) {
        tempNum = collectStarsData.ecommerceNum || 0;
      }
      if (type == 1) {
        tempNum = collectStarsData.toStoreNum || 0;
      } else if (type == 2) {
        tempNum = collectStarsData.facePayNum || 0;
      } else if (type == 3) {
        tempNum = collectStarsData.shareBaseNum || 0;
      } else if (type == 4) {
        tempNum = collectStarsData.shareExtraNum || 0;
      } else if (type == 5) {
        tempNum = collectStarsData.collectActivityNum || 0;
      }
      for (var i = 0; i < collectStarsData.collectNum; i++) {
        if (i < tempNum) {
          tempArr.push('light');
        } else {
          tempArr.push('dark');
        }
      }
      _this.setData({
        selectedCollectType: collectTypeArr[type] || '',
        'collectStarsData.collectedNum': tempNum,
        'collectStarsData.starStyleArr': tempArr
      });
      _this.toggleMoreType();
    };

    _this.recordTabSwitch = function (e) {
      var recordType = e.currentTarget.dataset.recordType;

      if (_this.data.recordTabType == recordType) {
        return;
      }
      _this.setData({
        recordTabType: recordType
      });
      _this.initialLoadingData();
      if (recordType == 1) {
        _this.getAwardRecordData();
      } else {
        _this.getStarsRecordData();
      }
    };

    document.title = '集集乐';
    return _this;
  }

  (0, _createClass3.default)(CollectStars, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        franchiseeId: options.franchisee || ''
      });
      this.getCollectStarsData();
      this.getStarsRecordData();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          selectedCollectType = _state.selectedCollectType,
          isHideTypeNav = _state.isHideTypeNav,
          collectStarsData = _state.collectStarsData,
          undefined = _state.undefined,
          recordTabType = _state.recordTabType,
          starRecordList = _state.starRecordList,
          awardRecordList = _state.awardRecordList;

      return React.createElement(
        'div',
        { className: 'official-page collect-starts' },
        React.createElement(_TopNav.TopNav, { title: '\u96C6\u96C6\u4E50' }),
        React.createElement(
          'div',
          { className: 'collectStar-container' },
          collectStarsData.togetherNum == undefined && React.createElement(
            'div',
            { className: 'collect-type-wrapper' },
            React.createElement(
              'div',
              { className: 'type-selected', onClick: this.toggleMoreType },
              React.createElement(
                'span',
                null,
                selectedCollectType
              ),
              React.createElement('span', {
                className: 'ico-moon icon-' + (isHideTypeNav ? 'downarrow' : 'uparrow')
              })
            ),
            React.createElement(
              'div',
              {
                className: 'type-list-wrapper',
                style: (0, _tools.convertLineStyleData)('height: ' + (isHideTypeNav ? '0' : '480rpx') + ';')
              },
              React.createElement(
                'div',
                { className: 'type-list', onClick: this.selectCollectType },
                React.createElement(
                  'span',
                  { 'data-type': '0' },
                  '\u7535\u5546'
                ),
                React.createElement(
                  'span',
                  { 'data-type': '1' },
                  '\u5230\u5E97'
                ),
                React.createElement(
                  'span',
                  { 'data-type': '2' },
                  '\u5F53\u9762\u4ED8'
                ),
                React.createElement(
                  'span',
                  { 'data-type': '3' },
                  '\u5206\u4EAB\u8D60\u9001'
                ),
                React.createElement(
                  'span',
                  { 'data-type': '4' },
                  '\u62C9\u65B0\u8D60\u9001'
                ),
                React.createElement(
                  'span',
                  { 'data-type': '5' },
                  '\u6536\u85CF\u8D60\u9001'
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'collect-info-wrapper',
              style: (0, _tools.convertLineStyleData)('margin-top:' + (collectStarsData.countMethod == 0 ? '10rpx' : '0') + ';')
            },
            React.createElement(
              'div',
              { className: 'info-num' },
              React.createElement(
                'span',
                null,
                '集集乐个数：' + collectStarsData.collectedNum + '个'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'info-star info-star-' + collectStarsData.collectNum
              },
              collectStarsData.starStyleArr.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'star-item', key: index },
                  item == 'light' && React.createElement('img', {
                    className: 'star-item',
                    src: collectStarsData.light_img,
                    mode: 'aspectFill'
                  }),
                  item == 'dark' && React.createElement('img', {
                    className: 'star-item',
                    src: collectStarsData.dark_img,
                    mode: 'aspectFill'
                  })
                );
              })
            ),
            collectStarsData.status == 1 ? React.createElement(
              'div',
              { className: 'info-desc' },
              React.createElement(
                'span',
                { className: 'info-desc-condition' },
                '消费' + (collectStarsData.playType == 0 ? '每满' : '超过') + collectStarsData.value + '元，累计1颗星，集满可获' + collectStarsData.coupon + '一张'
              ),
              collectStarsData.isReset == 1 ? React.createElement(
                'span',
                { className: 'info-desc-time' },
                '\u6D3B\u52A8\u7ED3\u675F\u661F\u6570\u6E05\u7A7A'
              ) : React.createElement(
                'span',
                { className: 'info-desc-time' },
                '\u6D3B\u52A8\u7ED3\u675F\u661F\u6570\u4FDD\u7559'
              )
            ) : React.createElement(
              'div',
              { className: 'info-desc' },
              React.createElement(
                'span',
                null,
                '\u5F53\u524D\u6682\u65E0\u6D3B\u52A8'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'collect-record-wrapper' },
            React.createElement(
              'div',
              { className: 'record-tab' },
              React.createElement(
                'div',
                {
                  className: recordTabType == 0 ? 'active' : '',
                  'data-record-type': '0',
                  onClick: this.recordTabSwitch
                },
                React.createElement(
                  'span',
                  null,
                  '\u96C6\u661F\u8BB0\u5F55'
                ),
                React.createElement('span', { className: 'line' })
              ),
              React.createElement(
                'div',
                {
                  className: recordTabType == 1 ? 'active' : '',
                  'data-record-type': '1',
                  onClick: this.recordTabSwitch
                },
                React.createElement(
                  'span',
                  null,
                  '\u5956\u52B1\u8BB0\u5F55'
                ),
                React.createElement('span', { className: 'line' })
              )
            ),
            React.createElement(
              'div',
              { className: 'record-content' },
              recordTabType == 0 && React.createElement(
                'div',
                { className: 'record-star' },
                React.createElement(
                  'div',
                  { className: 'record-star-title' },
                  React.createElement(
                    'span',
                    { className: 'time' },
                    '\u96C6\u661F\u65F6\u95F4'
                  ),
                  React.createElement(
                    'span',
                    { className: 'origin' },
                    '\u96C6\u661F\u6765\u6E90'
                  ),
                  React.createElement(
                    'span',
                    { className: 'num' },
                    '\u96C6\u661F\u6570\u91CF'
                  )
                ),
                starRecordList.list && starRecordList.list.length > 0 && React.createElement(
                  'div',
                  { className: 'record-star-list' },
                  starRecordList.list.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'record-star-item', key: index },
                      React.createElement(
                        'span',
                        { className: 'time' },
                        item.collect_time
                      ),
                      React.createElement(
                        'span',
                        { className: 'origin' },
                        item.collect_type
                      ),
                      React.createElement(
                        'span',
                        { className: 'num' },
                        item.collect_num
                      )
                    );
                  })
                ),
                starRecordList.loadingData.isLoading && React.createElement(
                  'div',
                  { className: 'loading-wrap' },
                  React.createElement(
                    'div',
                    { className: 'loading-view' },
                    React.createElement('div', { className: 'loading-dot1' }),
                    React.createElement('div', { className: 'loading-dot2' })
                  )
                ),
                starRecordList.isNull && React.createElement(
                  'div',
                  { className: 'record-list-null' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png' }),
                  React.createElement(
                    'span',
                    null,
                    '~ \u6682\u65E0\u96C6\u661F\u8BB0\u5F55 ~'
                  )
                )
              ),
              recordTabType == 1 && React.createElement(
                'div',
                { className: 'record-award' },
                !awardRecordList.isNull && React.createElement(
                  'div',
                  { className: 'record-award-list' },
                  awardRecordList.list.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'record-award-item', key: index },
                      React.createElement(
                        'span',
                        { className: 'item-title' },
                        item.coupon_title
                      ),
                      React.createElement(
                        'div',
                        { className: 'item-use-time' },
                        React.createElement(
                          'span',
                          null,
                          '\u4F7F\u7528\u65F6\u95F4\uFF1A'
                        ),
                        React.createElement(
                          'span',
                          { className: 'item-itme-txt' },
                          item.start_use_date + '至' + item.end_use_date
                        )
                      ),
                      React.createElement(
                        'span',
                        { className: 'item-award-time' },
                        '中奖时间：' + item.recv_time
                      ),
                      item.status == 1 && React.createElement('span', { className: 'ico-moon icon-winning-record-nouse' }),
                      item.status == 2 && React.createElement('span', { className: 'ico-moon icon-winning-record-used' }),
                      item.status == 3 && React.createElement('span', { className: 'ico-moon icon-winning-record-invalid' })
                    );
                  })
                ),
                awardRecordList.loadingData.isLoading && React.createElement(
                  'div',
                  { className: 'loading-wrap' },
                  React.createElement(
                    'div',
                    { className: 'loading-view' },
                    React.createElement('div', { className: 'loading-dot1' }),
                    React.createElement('div', { className: 'loading-dot2' })
                  )
                ),
                awardRecordList.isNull && React.createElement(
                  'div',
                  { className: 'record-list-null' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png' }),
                  React.createElement(
                    'span',
                    null,
                    '~ \u6682\u65E0\u5956\u52B1\u8BB0\u5F55 ~'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CollectStars;
}(_OfficialPage3.default);

exports.default = CollectStars;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(549);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var luckyWheelDetail = function (_OfficialPage) {
  (0, _inherits3.default)(luckyWheelDetail, _OfficialPage);

  function luckyWheelDetail(props) {
    (0, _classCallCheck3.default)(this, luckyWheelDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (luckyWheelDetail.__proto__ || Object.getPrototypeOf(luckyWheelDetail)).call(this, props));

    _this2.state = {
      topNavBarData: {
        title: '参与活动赢大奖',
        isDefault: 0
      },
      activityId: '',
      activityData: {}, //
      winnerList: [], //中奖名单
      recordSick: 0, //我的奖品弹窗是否显示
      animationData: {}, //圆盘动画
      awardsList: {}, //奖项列表
      opportunities: '', //抽奖机会次数
      text: 'Page animation',
      congratulation: 0, //中奖弹窗是否显示
      prizeTitle: '', //奖品名称
      prizeFail: 0, //未中奖弹窗是否显示
      colorAwardDefault: '#FE7F3A', //奖品默认颜色
      colorAwardSelect: 'rgba(255,113,0,.5)', //奖品选中颜色
      indexSelect: '', //被选中的奖品index
      isRunning: false, //是否正在抽奖
      runDegs: 0,
      duraMax: 0, //抽奖次数弹窗是否显示
      comfort: 0, //安慰奖弹窗
      isPlay: false,
      isExchange: 0, //兑换次数弹窗
      exchangeMessage: {}, //兑换次数数据
      chanageMes: '',
      inputValue: '',
      isdegree: 0, //次数用尽不可分享好有弹窗
      RecordSickArr: [],
      winListData: {},
      winListData2: {},
      franchisee: '',
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false,
      isShare: false
    };

    _this2.getShareKey = function (id) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getShareKey',
        data: dataObj,
        success: function success(res) {
          var data = res;
          if (data.status == 0) {
            that.setData({
              shareKey: data.data
            });
          }
        }
      });
    };

    _this2.getTimeByShareKey = function (id, shareKey) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      dataObj['share_key'] = shareKey;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
        data: dataObj,
        success: function success(res) {}
      });
    };

    _this2.getWinnerList = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getWinnerList',
        method: 'post',
        data: {
          activity_id: id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var winHeight = (res.count + 5) * 44;
          that.setData({
            winnerList: res.data
          });
          that.animationTop(winHeight, true);
        }
      });
    };

    _this2.animation = '';
    _this2.animation2 = '';

    _this2.animationTop = function (h, isreset) {
      var that = _this2;
      var $winconList1 = document.querySelector('.winconList1');
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      if (isreset) {
        // that.animation
        //   .top({start: '1.9rem'})
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.animation2
        //   .top({start: '1.9rem'})
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   winListData: that.animation.export(),
        //   winListData2: that.animation2.export()
        // })
        setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          $winconList1.animate(that.animation.keyframes, that.animation.options);
          // that.setData({
          //   winListData: that.animation.export()
          // })
          that.animationTopCopy(h, isreset);
        }, 50);
      } else {
        that.timeer = setTimeout(function () {
          // that.animation
          //   .top({start: '1.9rem'})
          //   .step({ duration: 0, timingFunction: 'step-start' })
          // that.setData({
          //   winListData: that.animation.export()
          // })
        }, 200 / (h + 200) * 15000);
        that.timeer2 = setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          $winconList1.animate(that.animation.keyframes, that.animation.options);
          // that.setData({
          //   winListData: that.animation.export()
          // })
          that.animationTopCopy(h);
        }, h / (h + 200) * 15000);
      }
    };

    _this2.animationTopCopy = function (h, isreset) {
      var that = _this2;
      var $winconList2 = document.querySelector('.winconList2');
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
      if (!isreset) {
        that.timeer3 = setTimeout(function () {
          // that.animation2
          //   .top({start: '1.9rem'})
          //   .step({ duration: 0, timingFunction: 'step-start' })
          // that.setData({
          //   winListData2: that.animation2.export()
          // })
        }, 200 / (h + 200) * 15000);
      }
      that.timeer4 = setTimeout(function () {
        that.animation2.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
        $winconList2.animate(that.animation2.keyframes, that.animation2.options);
        // that.setData({
        //   winListData2: that.animation2.export()
        // })
        that.animationTop(h);
      }, h / (h + 200) * 15000);
    };

    _this2.clickpagePrize = function () {
      var that = _this2;
      that.setData({ recordSick: 1 });
      that.getMyPrize();
    };

    _this2.clickRecordSick = function (e) {
      _this2.setData({ recordSick: 0 });
    };

    _this2.stopPropagation = function () {};

    _this2.confirmClick = function () {
      _this2.setData({ congratulation: 0 });
    };

    _this2.dataInitial = function () {
      var that = _this2,
          dataObj = new Object();
      dataObj['category'] = 0;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getActivity',
        method: 'post',
        data: dataObj,
        success: function success(res) {
          var mes = res.data;
          // TODO
          // that.audioCtx = app.createAudioContext('luckyAudio')
          // if (mes.bgm != 0) {
          //   that.audioCtx.play()
          // } else {
          //   that.audioCtx.pause()
          // }
          mes.description = mes.description.replace(/\\n/g, '\n');
          that.setData({
            activityData: mes,
            opportunities: mes.times
          });
          _app.appMethod.setNavigationBarTitle({
            title: res.data.title
          });
          that.getWinnerList(that.data.activityData.id);
          if (that.data.shareKey) {
            that.getTimeByShareKey(that.data.activityData.id, that.data.shareKey);
          }
          that.getShareKey(that.data.activityData.id);
        }
      });
    };

    _this2.getLottery = function (winId) {
      var that = _this2;
      var awardsConfig = that.data.activityData.turntable;
      var runNum = 8;
      var awardIndex = 0;
      if (winId.turntable_id == -1) {
        awardIndex = that.getNotWinIndex();
      } else {
        awardIndex = that.drawClick(winId.turntable_id);
      }
      var runDegs = that.data.runDegs;
      var startDegs = runDegs;
      runDegs = runDegs - runDegs % 360 + (360 * runNum - awardIndex * (360 / 8) - 22.5);
      var animationRun = _app.appMethod.createAnimation({
        duration: 4000,
        timingFunction: 'ease'
      });
      var $animationWrap = document.querySelector('#animationWrap');
      that.animationRun = animationRun;
      animationRun.rotate({ start: startDegs, end: runDegs, dom: $animationWrap }).step();
      $animationWrap.animate(animationRun.keyframes, animationRun.options);
      that.setData({
        // animationData: animationRun.export(),
        opportunities: that.data.opportunities - 1,
        runDegs: runDegs
      });
      setTimeout(function () {
        var title = awardsConfig[awardIndex].prize_title;
        if (winId.is_comfort == 1) {
          that.setData({
            comfort: 1,
            isRunning: false,
            ifWxCoupon: winId.card_id || false,
            timestamp: winId.timestamp || '',
            signature: winId.signature || ''
          });
          if (winId.card_id) {
            that.toAddCard();
          } else {
            that.getWinnerList(that.data.activityData.id);
          }
        } else {
          if (title == '谢谢参与') {
            that.setData({
              prizeFail: 1,
              isRunning: false
            });
          } else {
            that.setData({
              congratulation: 1,
              prize_title: title,
              isRunning: false,
              ifWxCoupon: winId.card_id || false,
              timestamp: winId.timestamp || '',
              signature: winId.signature || ''
            });
            if (winId.card_id) {
              that.toAddCard();
            } else {
              that.getWinnerList(that.data.activityData.id);
            }
          }
        }
      }, 5000);
    };

    _this2.notwinningClick = function () {
      _this2.setData({
        prizeFail: 0
      });
    };

    _this2.tipClick = function () {
      var that = _this2;
      if (!that.data.activityData.id) {
        return;
      }
      if (that.data.opportunities <= 0) {
        if (that.data.activityData.time_share == 0) {
          that.setData({
            isdegree: 1
          });
        } else {
          that.setData({
            duraMax: 1
          });
        }
        return;
      }
      if (that.data.isRunning) {
        return;
      }
      that.setData({
        isRunning: true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        method: 'post',
        data: {
          activity_id: that.data.activityData.id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          if (that.data.activityData.category == 0) {
            that.getLottery(res.data);
          } else {
            that.startGame(res.data);
          }
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.setData({
            isRunning: false
          });
        }
      });
    };

    _this2.startGame = function (winId) {
      var _this = _this2;
      var indexSelect = _this.data.indexSelect;
      var i = 0;
      var awardIndex = 0;
      if (winId.turntable_id == -1) {
        awardIndex = _this.getNotWinIndex();
      } else {
        awardIndex = _this.drawClick(winId.turntable_id);
      }
      var num = awardIndex + 24 - indexSelect;
      _this.setData({
        opportunities: _this.data.opportunities - 1
      });
      var timer = setInterval(function () {
        indexSelect++;
        i += 1;
        if (i > num) {
          clearInterval(timer);
          if (winId.is_comfort == 1) {
            _this.setData({
              comfort: 1,
              isRunning: false,
              ifWxCoupon: winId.card_id || false,
              timestamp: winId.timestamp || '',
              signature: winId.signature || ''
            });
            if (winId.card_id) {
              _this.toAddCard();
            } else {
              _this.getWinnerList(_this.data.activityData.id);
            }
          } else {
            if (_this.data.activityData.turntable[_this.data.indexSelect].prize_title == '谢谢参与') {
              _this.setData({
                prizeFail: 1,
                isRunning: false
              });
            } else {
              var ifWxCoupon = winId.card_id || false;
              _this.setData({
                congratulation: 1,
                prize_title: _this.data.activityData.turntable[_this.data.indexSelect].prize_title,
                isRunning: false,
                ifWxCoupon: ifWxCoupon,
                timestamp: winId.timestamp || '',
                signature: winId.signature || ''
              });
              if (ifWxCoupon) {
                _this.toAddCard();
              } else {
                _this.getWinnerList(_this.data.activityData.id);
              }
            }
          }
          return;
        }
        indexSelect = indexSelect % 8;
        _this.setData({
          indexSelect: indexSelect
        });
      }, 100);
    };

    _this2.drawClick = function (winId) {
      var that = _this2,
          list = that.data.activityData.turntable,
          idx = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].id == winId) {
          idx = i;
        }
      }
      return idx;
    };

    _this2.getNotWinIndex = function () {
      var that = _this2,
          list = that.data.activityData.turntable,
          idx = 0;
      for (var i = 0; i < list.length; i++) {
        if (list[i].coupon_id == -1) {
          idx = i;
        }
      }
      return idx;
    };

    _this2.playMusics = function () {
      if (_this2.data.activityData.bgm) {
        if (_this2.data.isPlay) {
          _this2.audioCtx.pause();
        } else {
          _this2.audioCtx.play();
        }
      } else {
        _app.appMethod.showToast({
          title: '活动未开始，没有音乐',
          icon: 'none'
        });
      }
    };

    _this2.audioPlay = function () {
      _this2.setData({
        isPlay: true
      });
    };

    _this2.audioPause = function () {
      _this2.setData({
        isPlay: false
      });
    };

    _this2.onShareAppMessage = function (res) {
      _this2.setData({
        isShare: true
      });
      var franchiseeParam = _this2.data.franchisee ? '&franchisee=' + _this2.data.franchisee : '';
      var that = _this2;
      return _app.appMethod.shareAppMessage({
        title: that.data.activityData.title,
        path: '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail?id=' + _this2.data.activityId + '&shareKey=' + that.data.shareKey + franchiseeParam,
        success: function success(res) {
          if (that.data.ifWxCoupon) {
            return;
          }
          that.setData({
            prizeFail: 0,
            duraMax: 0,
            congratulation: 0
          });
        },
        fail: function fail(res) {},
        complete: function complete() {
          that.setData({
            isShare: false
          });
        }
      });
    };

    _this2.sureClick = function () {
      _this2.setData({
        duraMax: 0
      });
    };

    _this2.comfortClick = function () {
      _this2.setData({
        comfort: 0,
        ifGetComfort: false
      });
    };

    _this2.exchangeCancel = function () {
      _this2.setData({
        isExchange: 0
      });
    };

    _this2.exchangePrize = function () {
      _this2.getMyIntegral();
    };

    _this2.getMyIntegral = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
        method: 'post',
        data: {
          activity_id: that.data.activityData.id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            isExchange: 1,
            exchangeMessage: res.data
          });
        }
      });
    };

    _this2.degreeClick = function () {
      _this2.setData({
        isdegree: 0
      });
    };

    _this2.exchangeAll = function () {
      var that = _this2;
      that.setData({
        inputValue: that.data.exchangeMessage.exchange_times
      });
    };

    _this2.bindReplaceInput = function (e) {
      _this2.setData({
        inputValue: e.target.value
      });
    };

    _this2.exchangeConfirm = function () {
      var that = _this2;
      that.getTime();
    };

    _this2.getTime = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTime',
        method: 'post',
        data: {
          activity_id: that.data.activityData.id,
          type: 'integral',
          times: that.data.inputValue,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            opportunities: res.data, //抽奖机会次数
            isExchange: 0,
            inputValue: ''
          });
        }
      });
    };

    _this2.getMyPrize = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyPrize',
        method: 'post',
        data: {
          activity_id: that.data.activityData.id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            RecordSickArr: res.data
          });
        }
      });
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.activityData.id,
              app_id: _data.activityData.app_id
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
              _this.getWinnerList(_this.data.activityData.id);
            }
          });
        }
      });
    };

    _this2.shadeClose = function () {
      if (_this2.data.isShare) {
        return;
      }
      var _this = _this2,
          ifWxCoupon = _this.data.ifWxCoupon;
      if (ifWxCoupon) {
        _app.appMethod.showModal({
          title: '提示',
          content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
          showCancel: true,
          confirm: function confirm(res) {
            _this.setData({
              congratulation: 0,
              comfort: 0,
              ifWxCoupon: false,
              ifGetComfort: false
            });
          }
        });
      } else {
        _this2.setData({
          congratulation: 0,
          comfort: 0,
          ifGetComfort: false
        });
      }
    };

    document.title = '大转盘';
    return _this2;
  }

  (0, _createClass3.default)(luckyWheelDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var id = that.data.activityData.id;
      var franchisee = options.franchisee || '';
      this.setData({
        franchisee: franchisee,
        shareKey: options.shareKey || '',
        'topNavBarData.topNavBarHeight': _app.appMethod.globalData.topNavBarHeight || 0
      });
      if (_app.appMethod.isLogin()) {
        that.dataInitial();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.dataInitial();
          },
          fail: function fail() {
            _app.appMethod.turnBack();
          }
        });
      }
      this.animation = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
      this.animation2 = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          activityData = _state.activityData,
          isPlay = _state.isPlay,
          goldenData = _state.goldenData,
          opportunities = _state.opportunities,
          indexSelect = _state.indexSelect,
          colorAwardSelect = _state.colorAwardSelect,
          colorAwardDefault = _state.colorAwardDefault,
          animationData = _state.animationData,
          winnerList = _state.winnerList,
          winListData = _state.winListData,
          winListData2 = _state.winListData2,
          duraMax = _state.duraMax,
          isdegree = _state.isdegree,
          prize_title = _state.prize_title,
          ifWxCoupon = _state.ifWxCoupon,
          congratulation = _state.congratulation,
          RecordSickArr = _state.RecordSickArr,
          recordSick = _state.recordSick,
          ifGetComfort = _state.ifGetComfort,
          comfort = _state.comfort,
          exchangeMessage = _state.exchangeMessage,
          inputValue = _state.inputValue,
          isExchange = _state.isExchange,
          prizeFail = _state.prizeFail;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page lucky-wheel-detail' },
          React.createElement(_TopNav.TopNav, { title: '\u5927\u8F6C\u76D8' }),
          React.createElement(
            'div',
            { className: 'luckyWheelDetail page', id: 'luckyWheelDetail' },
            React.createElement('img', {
              className: 'lucky-cantaniner',
              style: (0, _tools.convertLineStyleData)(topNavBarData.topNavBarHeight ? 'top:' + topNavBarData.topNavBarHeight + 'px' : ''),
              src: activityData.background || 'http://cdn.jisuapp.cn/static/webapp/images/phone-container.png'
            }),
            activityData.bgm != 0 && React.createElement(
              'div',
              {
                className: 'pageMusic ' + (isPlay == true ? 'active' : ''),
                onClick: this.playMusics,
                style: (0, _tools.convertLineStyleData)(topNavBarData.topNavBarHeight ? 'top:' + (topNavBarData.topNavBarHeight + 8) + 'px' : '')
              },
              isPlay == true && React.createElement('span', { className: 'ico-moon icon-luckyMusic' }),
              isPlay == false && React.createElement('span', { className: 'ico-moon icon-luckyMute' }),
              goldenData && goldenData.bgm != 0 && React.createElement(Audio, {
                id: 'luckyAudio',
                src: activityData.bgm,
                onPlay: this.audioPlay,
                onPause: this.audioPause,
                loop: true
              })
            ),
            React.createElement(
              'div',
              { className: 'lucky-wheel-content' },
              activityData.category == '1' ? React.createElement(
                'div',
                { className: 'motive-square' },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/phone-surprise.png' })
              ) : React.createElement(
                'div',
                { className: 'motive' },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/phone-motive.png' })
              ),
              React.createElement(
                'div',
                {
                  className: 'wholeDiv',
                  style: (0, _tools.convertLineStyleData)('background:' + (activityData.category == 1 ? 'rgba(97, 65, 116, 0.6)' : 'rgba(243,190,30,.3)'))
                },
                React.createElement(
                  'div',
                  {
                    className: 'todayChance',
                    style: (0, _tools.convertLineStyleData)('color:' + (activityData.category == 1 ? '#fff' : '#6b3600'))
                  },
                  '\u4F60\u4ECA\u65E5\u8FD8\u5269',
                  React.createElement(
                    'label',
                    {
                      style: (0, _tools.convertLineStyleData)('color:' + (activityData.category == 1 ? '#fed932' : '#ff090f'))
                    },
                    opportunities
                  ),
                  '\u6B21\u62BD\u5956\u673A\u4F1A'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'personNum',
                    style: (0, _tools.convertLineStyleData)('color:' + (activityData.category == 1 ? '#fff' : '#6b3600') + ';display:' + (activityData.joined_show == '-1' ? 'none' : 'inline-block'))
                  },
                  ',\u5171\u6709',
                  React.createElement(
                    'label',
                    {
                      style: (0, _tools.convertLineStyleData)('color:' + (activityData.category == 1 ? '#fed932' : '#ff090f'))
                    },
                    activityData.joined_show
                  ),
                  '\u4EBA\u53C2\u52A0\u6D3B\u52A8'
                )
              ),
              activityData.category == '1' ? React.createElement(
                'div',
                { id: 'plateDiv' },
                React.createElement('img', {
                  id: 'plate_img',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/startSquare.png',
                  onClick: this.tipClick
                }),
                React.createElement(
                  'div',
                  { className: 'plate-cont' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/phone-square.gif' }),
                  activityData.turntable.map(function (item, groupindex) {
                    return React.createElement(
                      'div',
                      {
                        className: 'zf zf' + groupindex,
                        'data-id': item.id,
                        style: (0, _tools.convertLineStyleData)('background-color:' + (groupindex === indexSelect ? colorAwardSelect : colorAwardDefault) + ';'),
                        key: groupindex
                      },
                      React.createElement('img', { src: item.prize_logo }),
                      React.createElement(
                        'div',
                        null,
                        item.prize_title
                      )
                    );
                  })
                )
              ) : React.createElement(
                'div',
                { id: 'outDiv' },
                React.createElement('img', {
                  id: 'tip',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/phone-start.png',
                  onClick: this.tipClick,
                  'data-id': activityData.id
                }),
                React.createElement(
                  'div',
                  { className: 'outer-cont', id: 'animationWrap' },
                  React.createElement('img', {
                    className: 'img',
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/phone-wheel.gif'
                  }),
                  activityData.turntable && activityData.turntable.map(function (item, groupindex) {
                    return React.createElement(
                      'div',
                      {
                        className: 'zp zp' + groupindex,
                        'data-id': item.id,
                        key: item.id
                      },
                      React.createElement(
                        'label',
                        null,
                        item.prize_title
                      ),
                      React.createElement('img', { src: item.prize_logo })
                    );
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'structurePrize' },
                React.createElement(
                  'div',
                  { className: 'lookPrize', onClick: this.clickpagePrize },
                  '\u67E5\u770B\u5956\u54C1'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'exchangePrize',
                    style: (0, _tools.convertLineStyleData)('display:' + (activityData.integral_exchange == 0 ? 'none' : 'inline-block')),
                    onClick: this.exchangePrize
                  },
                  '\u79EF\u5206\u5151\u6362'
                )
              ),
              React.createElement(
                'div',
                { className: 'winList' },
                React.createElement(
                  'div',
                  { className: 'wintitle' },
                  '\u4E2D\u5956\u540D\u5355'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'winCon',
                    style: (0, _tools.convertLineStyleData)('background:' + (activityData.category == 1 ? '#6b4780' : '#AE2C53'))
                  },
                  winnerList.length === 0 ? React.createElement(
                    'div',
                    { className: 'no-winner-list' },
                    '\u6682\u65E0\u4E2D\u5956\u540D\u5355'
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'winconList winconList1', animation: winListData },
                      winnerList.map(function (item, index) {
                        return React.createElement(
                          'div',
                          { key: index },
                          item.nickname + '抽中' + item.prize_title
                        );
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'winconList winconList2', animation: winListData2 },
                      winnerList.map(function (item, index) {
                        return React.createElement(
                          'div',
                          { key: index },
                          item.nickname + '抽中' + item.prize_title
                        );
                      })
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'active-rule' },
                React.createElement(
                  'div',
                  { className: 'active-rule-title' },
                  '\u6D3B\u52A8\u89C4\u5219'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'strip-content',
                    style: (0, _tools.convertLineStyleData)('background:' + (activityData.category == 1 ? '#6b4780' : '#AE2C53'))
                  },
                  React.createElement(
                    'div',
                    { className: 'strip-time' },
                    React.createElement(
                      'label',
                      null,
                      '\u6D3B\u52A8\u65F6\u95F4\uFF1A'
                    ),
                    React.createElement(
                      'label',
                      { className: 'specific-time' },
                      activityData.start_time,
                      '-',
                      activityData.end_time
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'textValue', style: (0, _tools.convertLineStyleData)('word-break:break-all;') },
                    React.createElement(
                      'span',
                      null,
                      activityData.description
                    )
                  ),
                  activityData.user_times_initial > 0 && React.createElement(
                    'div',
                    { className: 'prizedTotalBox' },
                    React.createElement(
                      'label',
                      { className: 'prizeDisc' },
                      '\xB7'
                    ),
                    '\u7528\u6237\u6BCF\u65E5\u9996\u6B21\u767B\u5F55\u53EF\u83B7\u53D6',
                    React.createElement(
                      'label',
                      null,
                      activityData.user_times_initial
                    ),
                    '\u6B21\u62BD\u5956\u673A\u4F1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'drawTotalTimes' },
                    React.createElement(
                      'label',
                      { className: 'prizeDisc' },
                      '\xB7'
                    ),
                    '\u6BCF\u65E5\u62BD\u5956\u673A\u4F1A\u6700\u591A\u4E3A',
                    React.createElement(
                      'label',
                      null,
                      activityData.user_times == '-1' ? '无数' : activityData.user_times
                    ),
                    '\u6B21'
                  ),
                  activityData.integral_exchange != '0' && React.createElement(
                    'div',
                    { className: 'exchangeTimes' },
                    React.createElement(
                      'label',
                      { className: 'prizeDisc' },
                      '\xB7'
                    ),
                    '\u6BCF',
                    React.createElement(
                      'label',
                      null,
                      activityData.integral_exchange == '0' ? '0' : activityData.integral_exchange
                    ),
                    '\u79EF\u5206\u53EF\u5151\u6362\u4E00\u6B21\u62BD\u5956\u673A\u4F1A'
                  ),
                  activityData.time_share != '0' && React.createElement(
                    'div',
                    { className: 'sharesTimes' },
                    React.createElement(
                      'label',
                      { className: 'prizeDisc' },
                      '\xB7'
                    ),
                    '\u6BCF\u6210\u529F\u5206\u4EAB1\u4E2A\u597D\u53CB\u53EF\u589E\u52A0',
                    React.createElement(
                      'label',
                      null,
                      activityData.time_share == '0' ? '0' : activityData.time_share
                    ),
                    '\u6B21\u62BD\u5956\u673A\u4F1A\uFF0C\u6700\u591A\u53EF\u589E\u52A0',
                    React.createElement(
                      'label',
                      null,
                      activityData.time_share_limit == '0' ? '0' : activityData.time_share_limit
                    ),
                    '\u6B21\u673A\u4F1A'
                  )
                )
              )
            ),
            duraMax == 1 && React.createElement(
              'div',
              { className: 'duraMaxDiv' },
              React.createElement(
                'div',
                { className: 'duraMaxDiv-wrap' },
                React.createElement(
                  'div',
                  { className: 'duraMaxDiv-con' },
                  React.createElement(
                    'div',
                    null,
                    '\u5BF9\u4E0D\u8D77,\u60A8\u7684\u62BD\u5956',
                    React.createElement(
                      'label',
                      { className: 'balance' },
                      '\u6B21\u6570\u4E0D\u8DB3'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'duraMaxDiv-btns' },
                  React.createElement(
                    'div',
                    { className: 'duraMaxDiv-cancel', onClick: this.sureClick },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'button',
                    { className: 'duraMaxDiv-confirm' },
                    '\u83B7\u53D6\u66F4\u591A'
                  )
                )
              )
            ),
            isdegree == 1 && React.createElement(
              'div',
              { className: 'degreeDiv' },
              React.createElement(
                'div',
                { className: 'degreeDiv-wrap' },
                React.createElement(
                  'div',
                  { className: 'degreeDiv-con' },
                  React.createElement(
                    'div',
                    null,
                    '\u5BF9\u4E0D\u8D77,\u60A8\u7684\u62BD\u5956',
                    React.createElement(
                      'label',
                      { className: 'balance' },
                      '\u6B21\u6570\u4E0D\u8DB3'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'degreeDiv-btns' },
                  React.createElement(
                    'div',
                    {
                      className: 'degreeDiv-confirm',
                      onClick: this.degreeClick
                    },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'degreeDiv-cancel', onClick: this.degreeClick },
                    '\u53D6\u6D88'
                  )
                )
              )
            ),
            congratulation == 1 && React.createElement(
              'div',
              { className: 'Congratulations_sick', onClick: this.shadeClose },
              React.createElement(
                'div',
                { className: 'Congratulations_wrap' },
                React.createElement(
                  'div',
                  { className: 'Congratulations-con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/Congratulations.png' }),
                  React.createElement(
                    'label',
                    null,
                    prize_title
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'Congratulations-btns' },
                  ifWxCoupon ? React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-confirm',
                      style: (0, _tools.convertLineStyleData)('margin-left: 62px;'),
                      onClick: this.toAddCard
                    },
                    '\u7ACB\u5373\u9886\u53D6'
                  ) : React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-confirm',
                      style: (0, _tools.convertLineStyleData)('margin-left: 62px;'),
                      onClick: this.confirmClick
                    },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-share',
                      style: (0, _tools.convertLineStyleData)('margin-left: 25px;'),
                      onClick: this.shareClickEvent
                    },
                    '\u4F20\u8FBE\u559C\u60A6'
                  )
                )
              )
            ),
            recordSick == 1 && React.createElement(
              'div',
              { className: 'record_sick', onClick: this.clickRecordSick },
              React.createElement(
                'div',
                { className: 'record_wrap', onClick: this.stopPropagation },
                React.createElement('div', { className: 'record_header' }),
                React.createElement(
                  'div',
                  { className: 'record_content' },
                  React.createElement('img', {
                    className: 'img_con',
                    style: (0, _tools.convertLineStyleData)('display:' + (RecordSickArr == '' ? 'none' : 'block')),
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/prize_con.png'
                  }),
                  React.createElement(
                    'div',
                    { className: 'content_title' },
                    React.createElement('div', { className: 'record_line' }),
                    React.createElement(
                      'label',
                      null,
                      '\u4E2D\u5956\u65F6\u95F4'
                    ),
                    React.createElement(
                      'label',
                      null,
                      '\u83B7\u5F97\u5956\u54C1'
                    )
                  ),
                  React.createElement(
                    _ScrollView.ScrollView,
                    {
                      'scroll-y': 'true',
                      className: 'prizeList',
                      hidden: RecordSickArr == ''
                    },
                    RecordSickArr.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement(
                          'label',
                          null,
                          item.add_time
                        ),
                        React.createElement(
                          'label',
                          null,
                          item.prize_title
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'record_fail', hidden: RecordSickArr != '' },
                    React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/prize_fail.png' }),
                    React.createElement(
                      'div',
                      null,
                      '\u6682\u672A\u83B7\u5F97\u4EFB\u4F55\u5956\u54C1\u54E6~'
                    )
                  )
                )
              )
            ),
            comfort == 1 && React.createElement(
              'div',
              { className: 'consolation_sick', onClick: this.shadeClose },
              React.createElement(
                'div',
                { className: 'consolation_wrap' },
                React.createElement(
                  'div',
                  { className: 'consolation_title' },
                  '\u5B89\u6170\u5956',
                  React.createElement('div', { className: 'conBefore' }),
                  React.createElement('div', { className: 'conAfter' })
                ),
                React.createElement(
                  'div',
                  { className: 'consolation_con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/consolation.png' }),
                  ifGetComfort ? React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                  ) : React.createElement(
                    'div',
                    (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                    '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                  ),
                  !ifWxCoupon && !ifGetComfort && React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                  )
                ),
                ifWxCoupon ? React.createElement(
                  'div',
                  { className: 'comfortCouponBtn' },
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_share',
                      onClick: this.toAddCard
                    },
                    '\u7ACB\u5373\u9886\u53D6'
                  ),
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_confirm',
                      onClick: this.shadeClose
                    },
                    '\u786E\u5B9A'
                  )
                ) : React.createElement(
                  'div',
                  { className: 'consolation_btns' },
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_confirm',
                      onClick: this.comfortClick
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            ),
            isExchange == 1 && React.createElement(
              'div',
              { className: 'exchange' },
              React.createElement(
                'div',
                { className: 'exchange-wrap' },
                React.createElement(
                  'div',
                  { className: 'exchange-con' },
                  React.createElement(
                    'div',
                    { className: 'exchangeCan' },
                    '\u53EF\u5151\u6362\u6B21\u6570\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.exchange_times
                    ),
                    React.createElement(
                      'label',
                      null,
                      '\u6B21'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeLimit' },
                    '\u5151\u6362\u6B21\u6570\uFF1A',
                    React.createElement('input', {
                      type: 'text',
                      onInput: this.bindReplaceInput,
                      onChange: function onChange() {},
                      value: inputValue
                    }),
                    React.createElement(
                      'label',
                      { className: 'exchangeAll', onClick: this.exchangeAll },
                      '\u5168\u90E8\u5151\u6362'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeRule' },
                    '\u5151\u6362\u89C4\u5219\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.integral_exchange
                    ),
                    '\u5206/\u6B21'
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeBalance' },
                    '\u79EF\u5206\u4F59\u989D\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.can_use_integral
                    ),
                    '\u5206'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'exchange-btns' },
                  React.createElement(
                    'div',
                    {
                      className: 'exchange-cancel',
                      onClick: this.exchangeCancel
                    },
                    '\u53D6\u6D88'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'exchange-confirm',
                      onClick: this.exchangeConfirm
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            ),
            prizeFail == 1 && React.createElement(
              'div',
              { className: 'notwinning_sick' },
              React.createElement(
                'div',
                { className: 'notwinning_wrap' },
                React.createElement(
                  'div',
                  { className: 'notwinning_title' },
                  '\u672A\u4E2D\u5956',
                  React.createElement('div', { className: 'conBefore' }),
                  React.createElement('div', { className: 'conAfter' })
                ),
                React.createElement(
                  'div',
                  { className: 'notwinning_con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/notWinning.png' }),
                  React.createElement(
                    'div',
                    null,
                    '\u5F88\u9057\u61BE\uFF01'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '\u60A8\u4EC0\u4E48\u90FD\u6CA1\u62BD\u4E2D\u54E6~'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'notwinning_btns' },
                  React.createElement(
                    'button',
                    {
                      className: 'push notwinning_confirm',
                      onClick: this.notwinningClick
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return luckyWheelDetail;
}(_OfficialPage3.default);

exports.default = luckyWheelDetail;

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(551);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoldenEggs = function (_OfficialPage) {
  (0, _inherits3.default)(GoldenEggs, _OfficialPage);

  function GoldenEggs(props) {
    (0, _classCallCheck3.default)(this, GoldenEggs);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GoldenEggs.__proto__ || Object.getPrototypeOf(GoldenEggs)).call(this, props));

    _this2.state = {
      topNavBarData: {
        isDefault: 0,
        title: '参与活动赢大奖'
      },
      activityId: '', //活动号
      goldenData: {}, //活动信息
      winnerList: [], //中奖名单
      exchangeMessage: {}, //兑换次数信息
      isExchange: 0, //是否关闭兑换次数弹窗
      isRecord: 0, //是否关闭查看奖品弹窗
      eggsList: [{
        hasAnimate: false
      }, {
        hasAnimate: false
      }, {
        hasAnimate: false
      }],
      comfort: 0, //是否显示安慰奖弹窗
      prizeFail: 0, //是否显示未中奖弹窗
      congratulation: 0, //是否显示中奖弹窗
      eggNum: '', //砸蛋次数
      isdegree: 0, //次数用尽不可分享
      duraMax: 0, //次数用尽可分享
      isPlay: false, //音乐是否播放
      inputValue: '', //兑换次数
      myPrize: [], //我的奖品记录
      isSinker: false,
      isWin: false, //是否中奖
      animationData: {}, //中奖名单动画
      animationData2: {},
      franchisee: '',
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false,
      isShare: false
    };

    _this2.getGoldenInfo = function () {
      var that = _this2,
          dataObj = new Object();
      dataObj['category'] = 2;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getActivity',
        method: 'post',
        data: dataObj,
        success: function success(res) {
          var mes = res.data;
          mes.description = mes.description.replace(/\\n/g, '\n');
          that.setData({
            goldenData: mes,
            eggNum: mes.times
          });
          _app.appMethod.setNavigationBarTitle({
            title: mes.title
          });
          // TODO
          // that.audioCtx = app.createAudioContext('goldenAudio')
          // if (mes.bgm != 0) {
          //   that.audioCtx.play()
          // } else {
          //   that.audioCtx.pause()
          // }
          that.getWinnerList(that.data.goldenData.id);
          if (that.data.shareKey) {
            that.getTimeByShareKey(that.data.goldenData.id, that.data.shareKey);
          }
          that.getShareKey(that.data.goldenData.id);
        }
      });
    };

    _this2.getShareKey = function (id) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getShareKey',
        data: dataObj,
        success: function success(res) {
          var data = res;
          if (data.status == 0) {
            that.setData({
              shareKey: data.data
            });
          }
        }
      });
    };

    _this2.getTimeByShareKey = function (id, shareKey) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      dataObj['share_key'] = shareKey;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
        data: dataObj,
        success: function success(res) {}
      });
    };

    _this2.getWinnerList = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getWinnerList',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var winHeight = (res.count + 5) * 44;
          that.setData({
            winnerList: res.data
          });
          that.animationTop(winHeight, true);
        }
      });
    };

    _this2.getMyIntegral = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
        method: 'post',
        data: {
          activity_id: that.data.goldenData.id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            exchangeMessage: res.data
          });
        }
      });
    };

    _this2.exchangePrizeClick = function () {
      var that = _this2;
      that.getMyIntegral();
      that.setData({
        isExchange: 1
      });
    };

    _this2.exchangeCancel = function () {
      _this2.setData({
        isExchange: 0
      });
    };

    _this2.recordClick = function () {
      var that = _this2;
      that.setData({
        isRecord: 1
      });
      that.getMyPrize();
    };

    _this2.recordWrapClick = function () {
      _this2.setData({
        isRecord: 0
      });
    };

    _this2.stopPropagation = function () {};

    _this2.startEgg = function (event) {
      var that = _this2;
      var index = event.currentTarget.dataset.index;
      if (!that.data.goldenData.id) {
        return;
      }
      if (that.eggsLoading) {
        return;
      }
      that.eggsLoading = true;
      if (that.data.eggNum <= 0) {
        if (that.data.goldenData.time_share == 0) {
          that.setData({
            isdegree: 1
          });
        } else {
          that.setData({
            duraMax: 1
          });
        }
        that.eggsLoading = false;
        return;
      } else {
        that.eggsClick(index);
      }
      that.setData({
        isSinker: true
      });
    };

    _this2.eggsLoading = false;

    _this2.eggsClick = function (index) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: that.data.goldenData.id,
          app_id: _app.appMethod.globalData.appId,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var data = res.data;
          var newdata = {};
          if (data.title == '谢谢参与') {
            newdata['isWin'] = false;
            setTimeout(function () {
              newdata = {};
              newdata['eggsList[' + index + '].hasAnimate'] = false;
              newdata['prizeFail'] = 1;
              that.setData(newdata);
              that.eggsLoading = false;
            }, 2200);
          } else {
            newdata['isWin'] = true;
            setTimeout(function () {
              newdata = {};
              if (data.is_comfort == 1) {
                newdata['comfort'] = 1;
              } else {
                newdata['congratulation'] = 1;
                newdata['prize_title'] = data.title;
              }
              var ifWxCoupon = data.card_id || false;
              newdata['ifWxCoupon'] = ifWxCoupon;
              newdata['timestamp'] = data.timestamp || '';
              newdata['signature'] = data.signature || '';
              newdata['eggsList[' + index + '].hasAnimate'] = false;
              that.setData(newdata);
              that.eggsLoading = false;
              if (ifWxCoupon) {
                that.toAddCard();
              }
            }, 2200);
            if (!that.data.ifWxCoupon) {
              that.getWinnerList(that.data.goldenData.id);
            }
          }
          newdata.eggNum = that.data.eggNum - 1;
          newdata['eggsList[' + index + '].hasAnimate'] = true;
          that.setData(newdata);
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.eggsLoading = false;
        }
      });
    };

    _this2.notwinningClick = function () {
      _this2.setData({
        prizeFail: 0
      });
    };

    _this2.confirmClick = function () {
      _this2.setData({
        congratulation: 0
      });
    };

    _this2.duraClick = function () {
      _this2.setData({
        duraMax: 0
      });
    };

    _this2.comfortClick = function () {
      _this2.setData({
        comfort: 0,
        ifGetComfort: false
      });
    };

    _this2.degreeClick = function () {
      _this2.setData({
        isdegree: 0
      });
    };

    _this2.onShareAppMessage = function (res) {
      _this2.setData({
        isShare: true
      });
      var that = _this2;
      that.getShareKey(that.data.goldenData.id);
      var franchiseeParam = _this2.data.franchisee ? '&franchisee=' + _this2.data.franchisee : '';
      return _app.appMethod.shareAppMessage({
        title: that.data.goldenData.title,
        path: '/awardManagement/pages/goldenEggs/goldenEggs?id=' + that.data.activityId + '&shareKey=' + that.data.shareKey + franchiseeParam,
        success: function success(res) {
          if (that.data.ifWxCoupon) {
            return;
          }
          that.setData({
            prizeFail: 0,
            duraMax: 0,
            congratulation: 0
          });
        },
        fail: function fail(res) {},
        complete: function complete() {
          that.setData({
            isShare: false
          });
        }
      });
    };

    _this2.playMusics = function () {
      if (_this2.data.goldenData.bgm) {
        if (_this2.data.isPlay) {
          _this2.audioCtx.pause();
        } else {
          _this2.audioCtx.play();
        }
      } else {
        _app.appMethod.showToast({
          title: '活动未开始，没有音乐',
          icon: 'none'
        });
      }
    };

    _this2.audioPlay = function () {
      _this2.setData({
        isPlay: true
      });
    };

    _this2.audioPause = function () {
      _this2.setData({
        isPlay: false
      });
    };

    _this2.bindReplaceInput = function (e) {
      _this2.setData({
        inputValue: e.target.value
      });
    };

    _this2.exchangeAll = function () {
      var that = _this2;
      that.setData({
        inputValue: that.data.exchangeMessage.exchange_times
      });
    };

    _this2.exchangeConfirm = function () {
      var that = _this2;
      if (that.data.goldenData.id) {
        that.getIntegralTime();
      }
    };

    _this2.getIntegralTime = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTime',
        method: 'post',
        data: {
          activity_id: that.data.goldenData.id,
          type: 'integral',
          times: that.data.inputValue,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            eggNum: res.data,
            isExchange: 0,
            inputValue: ''
          });
        }
      });
    };

    _this2.getMyPrize = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyPrize',
        method: 'post',
        data: {
          activity_id: that.data.goldenData.id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            myPrize: res.data
          });
        }
      });
    };

    _this2.animation = '';
    _this2.animation2 = '';

    _this2.animationTop = function (h, isreset) {
      var that = _this2;
      var $winnerList1 = document.querySelector('.winner-list1');
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      if (isreset) {
        // that.animation
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.animation2
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })

        // that.setData({
        //   animationData: that.animation.export(),
        //   animationData2: that.animation2.export()
        // })
        setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          // that.setData({
          //   animationData: that.animation.export()
          // })
          $winnerList1.animate(that.animation.keyframes, that.animation.options);
          that.animationTopCopy(h, isreset);
        }, 50);
      } else {
        that.timeer = setTimeout(function () {
          // that.animation
          //   .top('190rpx')
          //   .step({ duration: 0, timingFunction: 'step-start' })
          // that.setData({
          //   animationData: that.animation.export()
          // })
        }, 200 / (h + 200) * 15000);
        that.timeer2 = setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          // that.setData({
          //   animationData: that.animation.export()
          // })
          $winnerList1.animate(that.animation.keyframes, that.animation.options);
          that.animationTopCopy(h);
        }, h / (h + 200) * 15000);
      }
    };

    _this2.animationTopCopy = function (h, isreset) {
      var that = _this2;
      var $winnerList2 = document.querySelector('.winner-list2');
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
      if (!isreset) {
        that.timeer3 = setTimeout(function () {
          // that.animation2
          //   .top('190rpx')
          //   .step({ duration: 0, timingFunction: 'step-start' })
          // that.setData({
          //   animationData2: that.animation2.export()
          // })
        }, 200 / (h + 200) * 15000);
      }
      that.timeer4 = setTimeout(function () {
        that.animation2.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
        $winnerList2.animate(that.animation.keyframes, that.animation.options);
        // that.setData({
        //   animationData2: that.animation2.export()
        // })
        that.animationTop(h);
      }, h / (h + 200) * 15000);
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.goldenData.id,
              app_id: _data.goldenData.app_id
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
              _this.getWinnerList(_this.data.goldenData.id);
            }
          });
        }
      });
    };

    _this2.shadeClose = function () {
      if (_this2.data.isShare) {
        return;
      }
      var _this = _this2,
          ifWxCoupon = _this.data.ifWxCoupon;
      if (ifWxCoupon) {
        _app.appMethod.showModal({
          title: '提示',
          content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
          showCancel: true,
          confirm: function confirm(res) {
            _this.setData({
              congratulation: 0,
              comfort: 0,
              ifWxCoupon: false,
              ifGetComfort: false
            });
          }
        });
      } else {
        _this2.setData({
          congratulation: 0,
          comfort: 0,
          ifGetComfort: false
        });
      }
    };

    document.title = '砸金蛋';
    return _this2;
  }

  (0, _createClass3.default)(GoldenEggs, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this,
          id = that.data.goldenData.id;
      var franchisee = options.franchisee || '';
      this.setData({
        franchisee: franchisee,
        shareKey: options.shareKey || ''
      });
      if (_app.appMethod.isLogin()) {
        that.getGoldenInfo();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getGoldenInfo();
          },
          fail: function fail() {
            _app.appMethod.turnBack();
          }
        });
      }
      this.animation = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
      this.animation2 = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          goldenData = _state.goldenData,
          isPlay = _state.isPlay,
          isSinker = _state.isSinker,
          eggsList = _state.eggsList,
          isWin = _state.isWin,
          eggNum = _state.eggNum,
          winnerList = _state.winnerList,
          animationData = _state.animationData,
          animationData2 = _state.animationData2,
          exchangeMessage = _state.exchangeMessage,
          inputValue = _state.inputValue,
          isExchange = _state.isExchange,
          myPrize = _state.myPrize,
          isRecord = _state.isRecord,
          duraMax = _state.duraMax,
          isdegree = _state.isdegree,
          prize_title = _state.prize_title,
          ifWxCoupon = _state.ifWxCoupon,
          congratulation = _state.congratulation,
          prizeFail = _state.prizeFail,
          ifGetComfort = _state.ifGetComfort,
          comfort = _state.comfort;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page golden-eggs' },
          React.createElement(_TopNav.TopNav, { title: '\u7838\u91D1\u86CB' }),
          React.createElement(
            'div',
            { className: 'page', id: 'goldenEggs' },
            React.createElement('img', {
              className: 'golden_cantaniner',
              src: goldenData.background || 'http://cdn.jisuapp.cn/static/webapp/images/goldenContainer.png'
            }),
            goldenData.bgm != 0 && React.createElement(
              'div',
              {
                className: 'goldenMusic ' + (isPlay == true ? 'active' : ''),
                onClick: this.playMusics
              },
              isPlay == true && React.createElement('span', { className: 'ico-moon icon-luckyMusic' }),
              isPlay == false && React.createElement('span', { className: 'ico-moon icon-luckyMute' })
            ),
            React.createElement(
              'div',
              { className: 'scatter' },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/goldenMotive.png' })
            ),
            React.createElement(
              'div',
              { className: 'goldenHouse' },
              React.createElement(
                'div',
                { className: 'goldenSinker', hidden: isSinker == true },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/goldenSinker.gif' })
              ),
              React.createElement(
                'div',
                { className: 'goldenEgg' },
                eggsList.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      onClick: _this3.startEgg,
                      key: index,
                      'data-index': index,
                      className: 'egg' + index
                    },
                    React.createElement('div', {
                      className: 'egg-gif ' + (isWin ? 'egg-win' : 'egg-notwin'),
                      hidden: !item.hasAnimate,
                      'data-index': index
                    }),
                    React.createElement('div', { className: 'egg-png', hidden: item.hasAnimate })
                  );
                }),
                React.createElement('img', {
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/golden-eggs-win.png',
                  hidden: true
                }),
                React.createElement('img', {
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/golden-eggs-notwin.png',
                  hidden: true
                })
              ),
              React.createElement(
                'div',
                { className: 'activeData' },
                React.createElement(
                  'div',
                  {
                    className: 'activepopNum',
                    style: (0, _tools.convertLineStyleData)('margin-top:' + (goldenData.joined_show == -1 ? '35rpx' : '11rpx'))
                  },
                  '\u4F60\u6709',
                  React.createElement(
                    'span',
                    null,
                    eggNum
                  ),
                  '\u6B21\u7838\u86CB\u673A\u4F1A'
                ),
                goldenData.joined_show != -1 && React.createElement(
                  'div',
                  { className: 'phone-personNum' },
                  '\u5DF2\u6709',
                  React.createElement(
                    'span',
                    null,
                    goldenData.joined_show
                  ),
                  '\u4EBA\u53C2\u52A0\u6D3B\u52A8'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'structurePrize' },
              React.createElement(
                'div',
                { className: 'lookPrize', onClick: this.recordClick },
                '\u67E5\u770B\u5956\u54C1'
              ),
              React.createElement(
                'div',
                {
                  className: 'exchangePrize',
                  onClick: this.exchangePrizeClick,
                  style: (0, _tools.convertLineStyleData)('display:' + (goldenData.integral_exchange == 0 ? 'none' : 'inline-block'))
                },
                '\u79EF\u5206\u5151\u6362'
              )
            ),
            React.createElement(
              'div',
              { className: 'golden-winner' },
              React.createElement(
                'div',
                { className: 'winner-header' },
                React.createElement(
                  'span',
                  null,
                  '\u4E2D\u5956\u540D\u5355'
                )
              ),
              React.createElement(
                'div',
                { className: 'winner-content' },
                winnerList.length === 0 ? React.createElement(
                  'div',
                  { className: 'no-winner-list' },
                  '\u6682\u65E0\u4E2D\u5956\u540D\u5355'
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'winner-list winner-list1', animation: animationData },
                    winnerList.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement(
                          'span',
                          null,
                          item.nickname
                        ),
                        React.createElement(
                          'span',
                          null,
                          item.prize_title
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'winner-list winner-list2', animation: animationData2 },
                    winnerList.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement(
                          'span',
                          null,
                          item.nickname
                        ),
                        React.createElement(
                          'span',
                          null,
                          item.prize_title
                        )
                      );
                    })
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'golden-rule' },
              React.createElement(
                'div',
                { className: 'rule-header' },
                React.createElement(
                  'span',
                  null,
                  '\u5151\u5956\u8BF4\u660E'
                )
              ),
              React.createElement(
                'div',
                { className: 'rule-content' },
                React.createElement(
                  'div',
                  { className: 'rule-startTime' },
                  '\u5F00\u59CB\u65F6\u95F4\uFF1A',
                  React.createElement(
                    'span',
                    null,
                    goldenData.start_time
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'rule-endTime' },
                  '\u7ED3\u675F\u65F6\u95F4\uFF1A',
                  React.createElement(
                    'span',
                    null,
                    goldenData.end_time
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'rule-prizeMes' },
                  React.createElement(
                    'span',
                    null,
                    goldenData.description
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  '\u83B7\u53D6\u7838\u91D1\u86CB\u6B21\u6570\uFF1A'
                ),
                goldenData.user_times_initial > 0 && React.createElement(
                  'div',
                  { className: 'rule-goldenNum' },
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u7528\u6237\u6BCF\u65E5\u9996\u6B21\u767B\u5F55\u53EF\u83B7\u53D6',
                  React.createElement(
                    'span',
                    null,
                    goldenData.user_times_initial
                  ),
                  '\u6B21\u7838\u91D1\u86CB\u673A\u4F1A\u3002'
                ),
                React.createElement(
                  'div',
                  { className: 'rule-most' },
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u6BCF\u65E5\u7838\u91D1\u86CB\u673A\u4F1A\u6700\u591A\u4E3A',
                  React.createElement(
                    'span',
                    null,
                    goldenData.user_times == '-1' ? '无限' : goldenData.user_times
                  ),
                  '\u6B21\u3002'
                ),
                goldenData.integral_exchange != 0 && React.createElement(
                  'div',
                  { className: 'rule-exchanage' },
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u6BCF',
                  React.createElement(
                    'span',
                    null,
                    goldenData.integral_exchange
                  ),
                  '\u79EF\u5206\u53EF\u5151\u6362\u4E00\u6B21\u7838\u91D1\u86CB\u673A\u4F1A\u3002'
                ),
                goldenData.time_share != 0 && React.createElement(
                  'div',
                  { className: 'rule-share' },
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u6BCF\u6210\u529F\u5206\u4EAB\u7ED91\u4E2A\u597D\u53CB\u53EF\u589E\u52A0',
                  React.createElement(
                    'span',
                    null,
                    goldenData.time_share
                  ),
                  '\u6B21\u7838\u91D1\u86CB\u673A\u4F1A\uFF0C\u6700\u591A\u53EF\u589E\u52A0',
                  React.createElement(
                    'span',
                    null,
                    goldenData.time_share_limit
                  ),
                  '\u6B21\u673A\u4F1A\u3002'
                ),
                goldenData.consume_money == 0 && goldenData.consume_times != 0 && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u6D88\u8D39\u5373\u8D60\u9001',
                  React.createElement(
                    'span',
                    null,
                    goldenData.consume_times
                  ),
                  '\u6B21\u7838\u91D1\u86CB\u673A\u4F1A\u3002'
                ),
                goldenData.consume_money != 0 && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'label',
                    { className: 'goldenDisc' },
                    '\xB7'
                  ),
                  '\u5355\u6B21\u6D88\u8D39\u6BCF\u6EE1',
                  React.createElement(
                    'span',
                    null,
                    goldenData.consume_money
                  ),
                  '\u5143\uFF0C\u5219\u8D60\u9001',
                  React.createElement(
                    'span',
                    null,
                    goldenData.consume_times
                  ),
                  '\u6B21\u7838\u91D1\u86CB\u673A\u4F1A\uFF0C\u6700\u591A\u589E\u52A0',
                  React.createElement(
                    'span',
                    null,
                    goldenData.consume_times_limit
                  ),
                  '\u6B21\u673A\u4F1A\u3002'
                ),
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin-top: 5px;') },
                  '\u6B64\u6D3B\u52A8\u6700\u7EC8\u89E3\u91CA\u6743\u5F52\u672C\u5E97\u6240\u6709;'
                ),
                React.createElement(
                  'div',
                  null,
                  'ps\uFF1A\u4F18\u60E0\u5238\u5956\u54C1\u76F4\u63A5\u53D1\u653E\uFF0C\u53EF\u5728\u5C0F\u7A0B\u5E8F\u6211\u7684\u4F18\u60E0\u5238\u4E2D\u67E5\u770B\u3002'
                )
              )
            ),
            isExchange == 1 && React.createElement(
              'div',
              { className: 'exchange' },
              React.createElement(
                'div',
                { className: 'exchange-wrap' },
                React.createElement(
                  'div',
                  { className: 'exchange-con' },
                  React.createElement(
                    'div',
                    { className: 'exchangeCan' },
                    '\u53EF\u5151\u6362\u6B21\u6570\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.exchange_times
                    ),
                    React.createElement(
                      'label',
                      null,
                      '\u6B21'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeLimit' },
                    '\u5151\u6362\u6B21\u6570\uFF1A',
                    React.createElement('input', {
                      type: 'text',
                      onInput: this.bindReplaceInput,
                      value: inputValue
                    }),
                    React.createElement(
                      'label',
                      { className: 'exchangeAll', onClick: this.exchangeAll },
                      '\u5168\u90E8\u5151\u6362'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeRule' },
                    '\u5151\u6362\u89C4\u5219\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.integral_exchange
                    ),
                    '/\u6B21'
                  ),
                  React.createElement(
                    'div',
                    { className: 'exchangeBalance' },
                    '\u79EF\u5206\u4F59\u989D\uFF1A',
                    React.createElement(
                      'label',
                      null,
                      exchangeMessage.can_use_integral
                    ),
                    '\u5206'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'exchange-btns' },
                  React.createElement(
                    'div',
                    {
                      className: 'exchange-cancel',
                      onClick: this.exchangeCancel
                    },
                    '\u53D6\u6D88'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'exchange-confirm',
                      onClick: this.exchangeConfirm
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            ),
            isRecord == 1 && React.createElement(
              'div',
              { className: 'golden-record', onClick: this.recordWrapClick },
              React.createElement(
                'div',
                { className: 'record-wrap', onClick: this.stopPropagation },
                React.createElement(
                  'div',
                  { className: 'record-wrap-header' },
                  '\u6211\u7684\u4E2D\u5956\u8BB0\u5F55'
                ),
                React.createElement(
                  'div',
                  { className: 'record-wrap-edge' },
                  React.createElement(
                    'div',
                    { className: 'record-wrap-con' },
                    React.createElement(
                      'div',
                      { className: 'record-wrap-title' },
                      React.createElement('div', { className: 'record_line' }),
                      React.createElement(
                        'span',
                        null,
                        '\u4E2D\u5956\u65F6\u95F4'
                      ),
                      React.createElement(
                        'span',
                        null,
                        '\u83B7\u5F97\u5956\u54C1'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'record-list', hidden: myPrize == '' },
                      myPrize.map(function (item, index) {
                        return React.createElement(
                          'div',
                          { key: index },
                          React.createElement(
                            'span',
                            null,
                            item.add_time
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.prize_title
                          )
                        );
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'record_fail', hidden: myPrize != '' },
                      React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/golden-fail.png' }),
                      React.createElement(
                        'div',
                        null,
                        '\u6682\u672A\u83B7\u5F97\u4EFB\u4F55\u5956\u54C1\u54E6~'
                      )
                    )
                  )
                )
              )
            ),
            duraMax == 1 && React.createElement(
              'div',
              { className: 'duraMaxDiv' },
              React.createElement(
                'div',
                { className: 'duraMaxDiv-wrap' },
                React.createElement(
                  'div',
                  { className: 'duraMaxDiv-con' },
                  React.createElement(
                    'div',
                    null,
                    '\u5BF9\u4E0D\u8D77,\u60A8\u7684\u7838\u91D1\u86CB',
                    React.createElement(
                      'label',
                      { className: 'balance' },
                      '\u6B21\u6570\u4E0D\u8DB3'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'duraMaxDiv-btns' },
                  React.createElement(
                    'div',
                    { className: 'duraMaxDiv-cancel', onClick: this.duraClick },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'button',
                    { className: 'duraMaxDiv-confirm', openType: 'share', onClick: this.shareClickEvent },
                    '\u83B7\u53D6\u66F4\u591A'
                  )
                )
              )
            ),
            isdegree == 1 && React.createElement(
              'div',
              { className: 'degreeDiv' },
              React.createElement(
                'div',
                { className: 'degreeDiv-wrap' },
                React.createElement(
                  'div',
                  { className: 'degreeDiv-con' },
                  React.createElement(
                    'div',
                    null,
                    '\u5BF9\u4E0D\u8D77,\u60A8\u7684\u7838\u91D1\u86CB',
                    React.createElement(
                      'label',
                      { className: 'balance' },
                      '\u6B21\u6570\u4E0D\u8DB3'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'degreeDiv-btns' },
                  React.createElement(
                    'div',
                    { className: 'degreeDiv-cancel', onClick: this.degreeClick },
                    '\u53D6\u6D88'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'degreeDiv-confirm',
                      onClick: this.degreeClick
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            ),
            congratulation == 1 && React.createElement(
              'div',
              { className: 'Congratulations_sick', onClick: this.shadeClose },
              React.createElement(
                'div',
                { className: 'Congratulations_wrap' },
                React.createElement(
                  'div',
                  { className: 'Congratulations-con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/Congratulations.png' }),
                  React.createElement(
                    'label',
                    null,
                    prize_title
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'Congratulations-btns' },
                  ifWxCoupon ? React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-confirm',
                      style: (0, _tools.convertLineStyleData)('margin-left: 112rpx;'),
                      onClick: this.toAddCard
                    },
                    '\u7ACB\u5373\u9886\u53D6'
                  ) : React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-confirm',
                      style: (0, _tools.convertLineStyleData)('margin-left: 112rpx;'),
                      onClick: this.confirmClick
                    },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'button',
                    {
                      className: 'btns Congratulations-share',
                      style: (0, _tools.convertLineStyleData)('margin-left: 58rpx;'),
                      openType: 'share',
                      onClick: this.shareClickEvent
                    },
                    '\u4F20\u8FBE\u559C\u60A6'
                  )
                )
              )
            ),
            prizeFail == 1 && React.createElement(
              'div',
              { className: 'notwinning_sick' },
              React.createElement(
                'div',
                { className: 'notwinning_wrap' },
                React.createElement(
                  'div',
                  { className: 'notwinning_title' },
                  '\u672A\u4E2D\u5956',
                  React.createElement('div', { className: 'conBefore' }),
                  React.createElement('div', { className: 'conAfter' })
                ),
                React.createElement(
                  'div',
                  { className: 'notwinning_con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/notWinning.png' }),
                  React.createElement(
                    'div',
                    null,
                    '\u5F88\u9057\u61BE\uFF01'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '\u60A8\u4EC0\u4E48\u90FD\u6CA1\u7838\u4E2D\u54E6~'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'notwinning_btns' },
                  React.createElement(
                    'button',
                    {
                      className: 'push notwinning_confirm',
                      onClick: this.notwinningClick
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            ),
            comfort == 1 && React.createElement(
              'div',
              { className: 'consolation_sick', onClick: this.shadeClose },
              React.createElement(
                'div',
                { className: 'consolation_wrap' },
                React.createElement(
                  'div',
                  { className: 'consolation_title' },
                  '\u5B89\u6170\u5956',
                  React.createElement('div', { className: 'conBefore' }),
                  React.createElement('div', { className: 'conAfter' })
                ),
                React.createElement(
                  'div',
                  { className: 'consolation_con' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/consolation.png' }),
                  ifGetComfort ? React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                  ) : React.createElement(
                    'div',
                    (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                    '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                  ),
                  !ifWxCoupon && !ifGetComfort && React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '>\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                  )
                ),
                ifWxCoupon ? React.createElement(
                  'div',
                  { className: 'comfortCouponBtn' },
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_confirm',
                      onClick: this.shadeClose
                    },
                    '\u786E\u5B9A'
                  ),
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_share',
                      onClick: this.toAddCard
                    },
                    '\u7ACB\u5373\u9886\u53D6'
                  )
                ) : React.createElement(
                  'div',
                  { className: 'consolation_btns' },
                  React.createElement(
                    'button',
                    {
                      className: 'push consolation_confirm',
                      onClick: this.comfortClick
                    },
                    '\u786E\u5B9A'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return GoldenEggs;
}(_OfficialPage3.default);

exports.default = GoldenEggs;

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Scratch = function (_OfficialPage) {
  (0, _inherits3.default)(Scratch, _OfficialPage);

  function Scratch(props) {
    (0, _classCallCheck3.default)(this, Scratch);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Scratch.__proto__ || Object.getPrototypeOf(Scratch)).call(this, props));

    _this2.state = {
      topNavBarData: {
        title: '刮刮乐',
        isDefault: 0
      },
      isShowBtn: false, //点我刮奖显示与隐藏
      scratchInfo: {}, //获取活动信息
      scratchTimes: '', //剩余次数
      scratchId: '', //活动号
      winnerList: [], //获奖名单信息
      isPrizeSick: false, //中奖纪录弹窗显示与隐藏
      isIntel: false, //兑奖次数弹窗显示
      myPrize: [], //中奖记录
      intelMes: {}, //兑换信息
      inputValue: '', //兑换次数
      isFail: true, //显示未中奖
      isPrize: true, //显示中奖
      isComfort: true, //显示安慰奖
      hideCanvas: false,
      isDegree: false,
      isDurMax: false,
      scratchPrizeTitle: '', //中奖名称
      animationData: {},
      animationData2: {},
      isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
      isPlay: false,
      isLimit: false,
      time_limit: '',
      isRoll: true,
      scratchStatus: '',
      franchisee: '',
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false
    };

    _this2.getShareKey = function (id) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getShareKey',
        data: dataObj,
        success: function success(res) {
          var data = res;
          if (data.status == 0) {
            that.setData({
              shareKey: data.data
            });
          }
        }
      });
    };

    _this2.getTimeByShareKey = function (id, shareKey) {
      var that = _this2,
          dataObj = new Object();
      dataObj['activity_id'] = id;
      dataObj['share_key'] = shareKey;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeByShareKey',
        data: dataObj,
        success: function success(res) {}
      });
    };

    _this2.startScratch = function () {
      var that = _this2;
      if (!that.data.scratchId) {
        return;
      }
      if (that.data.time_limit == 0) {
        that.setData({
          isLimit: true,
          hideCanvas: true,
          isShowBtn: false
        });
      } else {
        if (that.data.scratchTimes <= 0) {
          if (that.data.scratchInfo.time_share == 0) {
            that.setData({
              isDegree: true,
              hideCanvas: true,
              isShowBtn: false
            });
          } else {
            that.setData({
              isDurMax: true,
              hideCanvas: true,
              isShowBtn: false
            });
          }
        } else {
          if (that.scratchLoading) {
            return false;
          }
          that.setData({
            isShowBtn: false
          });
          that.scratchLoading = true;
          that.getLottery();
        }
      }
    };

    _this2.getScratchData = function () {
      var that = _this2,
          dataObj = new Object();
      dataObj['category'] = 3;
      if (that.data.franchisee) {
        dataObj['sub_app_id'] = that.data.franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getActivity',
        method: 'post',
        data: dataObj,
        success: function success(res) {
          var mes = res.data;
          mes.description = mes.description.replace(/\\n/g, '\n');
          that.setData({
            scratchInfo: mes,
            scratchTimes: mes.times,
            scratchId: mes.id,
            time_limit: mes.time_limit
          });
          _app.appMethod.setNavigationBarTitle({
            title: mes.title
          });
          // TODO
          // that.audioCtx = app.createAudioContext('scratchAudio')
          // if (mes.bgm != 0) {
          //   that.audioCtx.play()
          // } else {
          //   that.audioCtx.pause()
          // }
          that.getWinnerList(mes.id);
          if (that.data.shareKey) {
            that.getTimeByShareKey(mes.id, that.data.shareKey);
          }
          that.getShareKey(that.data.scratchId);
        }
      });
    };

    _this2.scratchLoading = false;

    _this2.getLottery = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var data = res.data,
              newData = {};
          that.scratch.start();
          if (data.title == '谢谢参与') {
            newData = {};
            newData['isFail'] = false;
            newData['scratchTimes'] = data.time;
            newData['time_limit'] = data.time_limit;
            that.setData(newData);
          } else {
            newData = {};
            if (data.is_comfort == 1) {
              newData['isComfort'] = false;
            } else {
              newData['isPrize'] = false;
              newData['scratchPrizeTitle'] = data.title;
            }
            var ifWxCoupon = data.card_id || false;
            newData['ifWxCoupon'] = ifWxCoupon;
            newData['timestamp'] = data.timestamp || '';
            newData['signature'] = data.signature || '';
            newData['scratchTimes'] = data.time;
            newData['time_limit'] = data.time_limit;
            that.setData(newData);
            that.getWinnerList(that.data.scratchId);
          }
          that.scratchLoading = false;
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          that.scratchLoading = false;
          if (res.status == 1) {
            that.setData({
              isShowBtn: true
            });
          }
        }
      });
    };

    _this2.getWinnerList = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getWinnerList',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: id,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var winHeight = (res.count + 5) * 44;
          that.setData({
            winnerList: res.data
          });
          that.animationTop(winHeight, true);
        }
      });
    };

    _this2.animation = '';
    _this2.animation2 = '';

    _this2.animationTop = function (h, isreset) {
      var that = _this2;
      var $rosterList1 = document.querySelector('.rosterList1');
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      if (isreset) {
        // that.animation
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.animation2
        //   .top('190rpx')
        //   .step({ duration: 0, timingFunction: 'step-start' })
        // that.setData({
        //   animationData: that.animation.export(),
        //   animationData2: that.animation2.export()
        // })
        setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          $rosterList1.animate(that.animation.keyframes, that.animation.options);
          // that.setData({
          //   animationData: that.animation.export()
          // })
          that.animationTopCopy(h, isreset);
        }, 50);
      } else {
        that.timeer = setTimeout(function () {
          // that.animation
          //   .top('190rpx')
          //   .step({ duration: 0, timingFunction: 'step-start' })
          // that.setData({
          //   animationData: that.animation.export()
          // })
        }, 200 / (h + 200) * 15000);
        that.timeer2 = setTimeout(function () {
          that.animation.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
          $rosterList1.animate(that.animation.keyframes, that.animation.options);
          // that.setData({
          //   animationData: that.animation.export()
          // })
          that.animationTopCopy(h);
        }, h / (h + 200) * 15000);
      }
    };

    _this2.animationTopCopy = function (h, isreset) {
      var that = _this2;
      var $rosterList2 = document.querySelector('.rosterList2');
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
      // if (!isreset) {
      // that.timeer3 = setTimeout(function () {
      // that.animation2
      //   .top('190rpx')
      //   .step({ duration: 0, timingFunction: 'step-start' })
      // that.setData({
      //   animationData2: that.animation2.export()
      // })
      // }, (200 / (h + 200)) * 15000)
      // }
      that.timeer4 = setTimeout(function () {
        that.animation2.top({ start: '1.9rem', end: '-' + h / 100 + 'rem' }).step({ duration: 15000, timingFunction: 'linear' });
        $rosterList2.animate(that.animation2.keyframes, that.animation2.options);
        // that.setData({
        //   animationData2: that.animation2.export()
        // })
        that.animationTop(h);
      }, h / (h + 200) * 15000);
    };

    _this2.playMusics = function () {
      if (_this2.data.scratchInfo.bgm) {
        if (_this2.data.isPlay) {
          _this2.audioCtx.pause();
        } else {
          _this2.audioCtx.play();
        }
      } else {
        _app.appMethod.showToast({
          title: '活动未开始，没有音乐',
          icon: 'none'
        });
      }
    };

    _this2.audioPlay = function () {
      _this2.setData({
        isPlay: true
      });
    };

    _this2.audioPause = function () {
      _this2.setData({
        isPlay: false
      });
    };

    _this2.lookPrize = function () {
      var that = _this2;
      if (that.data.scratchId) {
        that.setData({
          isPrizeSick: true,
          hideCanvas: true,
          isShowBtn: false,
          isRoll: false
        });
        that.getMyPrize();
      }
    };

    _this2.wrapPrize = function () {
      var that = _this2;
      _this2.scratch.reset();
      _this2.setData({
        isPrizeSick: false,
        hideCanvas: false,
        isRoll: true
      });
      setTimeout(function () {
        that.setData({
          isShowBtn: true
        });
      }, 100);
    };

    _this2.stopPropagation = function () {};

    _this2.intelClick = function () {
      if (_this2.data.scratchId) {
        _this2.setData({
          isIntel: true,
          hideCanvas: true,
          isShowBtn: false
        });
        _this2.getMyIntegral();
      }
    };

    _this2.intelClose = function () {
      var that = _this2;
      _this2.scratch.reset();
      _this2.setData({
        isIntel: false,
        hideCanvas: false,
        isFail: true, //显示未中奖
        isPrize: true, //显示中奖
        isComfort: true //显示安慰奖
      });
      setTimeout(function () {
        that.setData({
          isShowBtn: true
        });
      }, 50);
    };

    _this2.failBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideCanvas: false,
        isFail: true
      });
      setTimeout(function () {
        that.setData({
          isShowBtn: true
        });
      }, 100);
    };

    _this2.winningBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideCanvas: false,
        isPrize: true
      });
      setTimeout(function () {
        that.setData({
          isShowBtn: true
        });
      }, 100);
    };

    _this2.comfortBtnClick = function () {
      var that = _this2;
      that.scratch.reset();
      that.setData({
        hideCanvas: false,
        isComfort: true,
        ifGetComfort: false
      });
      setTimeout(function () {
        that.setData({
          isShowBtn: true
        });
      }, 100);
    };

    _this2.bindReplaceInput = function (e) {
      _this2.setData({
        inputValue: e.target.value
      });
    };

    _this2.intelConfirm = function () {
      var that = _this2;
      if (that.data.scratchId) {
        that.getIntegralTime();
      }
    };

    _this2.scratchInteAll = function () {
      var that = _this2;
      that.setData({
        inputValue: that.data.intelMes.exchange_times
      });
    };

    _this2.getMyPrize = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyPrize',
        method: 'post',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            myPrize: res.data
          });
        }
      });
    };

    _this2.getMyIntegral = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getMyIntegralExchangeTimes',
        method: 'post',
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.setData({
            intelMes: res.data
          });
        }
      });
    };

    _this2.getIntegralTime = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTime',
        method: 'post',
        data: {
          activity_id: that.data.scratchId,
          type: 'integral',
          times: that.data.inputValue,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          that.scratch.reset();
          that.setData({
            scratchTimes: res.data,
            isIntel: false,
            inputValue: '',
            hideCanvas: false,
            isDurMax: false,
            isDegree: false
          });
          setTimeout(function () {
            that.setData({
              isShowBtn: true
            });
          }, 200);
        }
      });
    };

    _this2.onShareAppMessage = function (res) {
      var that = _this2;
      var franchiseeParam = _this2.data.franchisee ? '&franchisee=' + _this2.data.franchisee : '';
      return _app.appMethod.shareAppMessage({
        title: that.data.scratchInfo.title,
        path: '/awardManagement/pages/scratch/scratch?id=' + that.data.scratchId + '&shareKey=' + that.data.shareKey + franchiseeParam,
        success: function success(res) {},
        fail: function fail(res) {}
      });
    };

    _this2.touchStart = function () {};

    _this2.touchEnd = function () {};

    _this2.touchMove = function () {};

    _this2.imgOnLoad = function () {};

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.scratchInfo.id,
              app_id: _data.scratchInfo.app_id
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
              _this.setData({
                ifGetComfort: true
              });
              _this.getWinnerList(_this.data.scratchId);
            }
          });
        }
      });
    };

    _this2.shadeClose = function (el) {
      var _this = _this2,
          type = el.currentTarget.dataset.type;
      _app.appMethod.showModal({
        title: '提示',
        content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
        showCancel: true,
        confirm: function confirm(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: false
          });
          if (type == 1) {
            _this.winningBtnClick();
          } else if (type == 2) {
            _this.comfortBtnClick();
          }
        }
      });
    };

    document.title = '刮刮乐';
    return _this2;
  }

  (0, _createClass3.default)(Scratch, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var franchisee = options.franchisee || '';
      var systemInfo = _app.appMethod.globalData.systemInfo;
      var width = 558 * systemInfo.windowWidth / 750;
      var height = 258 * systemInfo.windowWidth / 750;
      that.setData({
        franchisee: franchisee,
        shareKey: options.shareKey || ''
      });
      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              isShowBtn: true
            });
          }, 10);
        }
      });
      if (_app.appMethod.isLogin()) {
        that.getScratchData();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getScratchData();
          },
          fail: function fail() {
            _app.appMethod.turnBack();
          }
        });
      }
      this.animation = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
      this.animation2 = _app.appMethod.createAnimation({
        duration: 0,
        timingFunction: 'step-start'
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearTimeout(that.timeer);
      clearTimeout(that.timeer2);
      clearTimeout(that.timeer3);
      clearTimeout(that.timeer4);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          scratchInfo = _state.scratchInfo,
          isPlay = _state.isPlay,
          scratchTimes = _state.scratchTimes,
          isFail = _state.isFail,
          isPrize = _state.isPrize,
          scratchPrizeTitle = _state.scratchPrizeTitle,
          ifWxCoupon = _state.ifWxCoupon,
          isDurMax = _state.isDurMax,
          isLimit = _state.isLimit,
          isComfort = _state.isComfort,
          ifGetComfort = _state.ifGetComfort,
          isDegree = _state.isDegree,
          hideCanvas = _state.hideCanvas,
          scratch = _state.scratch,
          isShowBtn = _state.isShowBtn,
          winnerList = _state.winnerList,
          animationData = _state.animationData,
          animationData2 = _state.animationData2,
          myPrize = _state.myPrize,
          isPrizeSick = _state.isPrizeSick,
          intelMes = _state.intelMes,
          inputValue = _state.inputValue,
          isIntel = _state.isIntel;

      return React.createElement(
        'div',
        { className: 'official-page scratch' },
        React.createElement(_TopNav.TopNav, { title: '\u641C\u7D22' }),
        React.createElement(
          'div',
          { className: 'page scratch', id: 'scratch' },
          React.createElement('img', {
            className: 'scratch-cantaniner',
            src: scratchInfo.background || 'http://cdn.jisuapp.cn/static/webapp/images/scratchContainer.png'
          }),
          scratchInfo.bgm != 0 && React.createElement(
            'div',
            {
              className: 'scratchMusic ' + (isPlay == true ? 'active' : ''),
              onClick: this.playMusics
            },
            isPlay == true && React.createElement('span', { className: 'ico-moon icon-luckyMusic' }),
            isPlay == false && React.createElement('span', { className: 'ico-moon icon-luckyMute' })
          ),
          React.createElement(
            'div',
            { className: 'scratch-scater' },
            React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchPonter.png' })
          ),
          React.createElement(
            'div',
            { className: 'phoneCx' },
            React.createElement(
              'div',
              { className: 'phone-todayChance' },
              '\u60A8\u4ECA\u65E5\u8FD8\u5269',
              React.createElement(
                'span',
                null,
                scratchTimes
              ),
              '\u6B21\u522E\u5956\u673A\u4F1A'
            ),
            scratchInfo.joined_show != -1 && React.createElement(
              'div',
              { className: 'phone-personNum' },
              ',\u5171\u6709',
              React.createElement(
                'span',
                null,
                scratchInfo.joined_show
              ),
              '\u4EBA\u53C2\u52A0\u6D3B\u52A8'
            )
          ),
          React.createElement(
            'div',
            { className: 'scratchArea' },
            React.createElement(
              'div',
              { className: 'scratchFail', hidden: isFail },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png' }),
              React.createElement(
                'div',
                { className: 'failTitle' },
                React.createElement(
                  'div',
                  { className: 'failShare', onClick: this.shareClickEvent },
                  '\u5206\u4EAB'
                ),
                React.createElement(
                  'div',
                  { className: 'failText' },
                  '\u5F88\u9057\u61BE\u6CA1\u6709\u4E2D\u5956\u54E6'
                ),
                React.createElement(
                  'div',
                  { className: 'failBtn', onClick: this.failBtnClick },
                  '\u518D\u6765\u4E00\u6B21'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchWinning', hidden: isPrize },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png' }),
              React.createElement(
                'div',
                { className: 'winningTitle' },
                React.createElement(
                  'div',
                  { className: 'winningShare', onClick: this.shareClickEvent },
                  '\u5206\u4EAB'
                ),
                React.createElement(
                  'div',
                  { className: 'winningText' },
                  '\u606D\u559C\u4F60\u83B7\u5F97\u4E86'
                ),
                React.createElement(
                  'div',
                  { className: 'winningText winningValue' },
                  scratchPrizeTitle
                ),
                ifWxCoupon ? React.createElement(
                  'div',
                  { className: 'btnGroup' },
                  React.createElement(
                    'div',
                    { className: 'winningBtn', onClick: this.toAddCard },
                    '\u7ACB\u5373\u9886\u53D6'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'winningBtn',
                      onClick: this.shadeClose,
                      'data-type': '1'
                    },
                    '\u518D\u6765\u4E00\u6B21'
                  )
                ) : React.createElement(
                  'div',
                  { className: 'winningBtn', onClick: this.winningBtnClick },
                  '\u518D\u6765\u4E00\u6B21'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchDurMax', hidden: !isDurMax },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png' }),
              React.createElement(
                'div',
                { className: 'durMaxTitle' },
                React.createElement(
                  'div',
                  { className: 'durMaxShare', onClick: this.shareClickEvent },
                  '\u5206\u4EAB'
                ),
                React.createElement(
                  'div',
                  { className: 'durMaxText' },
                  '\u5BF9\u4E0D\u8D77\uFF0C\u60A8\u7684\u522E\u5956\u6B21\u6570\u4E0D\u8DB3\uFF0C'
                ),
                React.createElement(
                  'div',
                  { className: 'durMaxText' },
                  '\u5206\u4EAB\u5373\u53EF\u83B7\u53D6\u6B21\u6570\u54E6~'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchLimit', hidden: !isLimit },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png' }),
              React.createElement(
                'div',
                { className: 'limitTitle' },
                React.createElement(
                  'div',
                  { className: 'limitShare', onClick: this.shareClickEvent },
                  '\u5206\u4EAB'
                ),
                React.createElement(
                  'div',
                  { className: 'limitText' },
                  '\u4ECA\u65E5\u522E\u5956\u6B21\u6570\u5DF2\u8FBE\u5230\u4E0A\u9650\uFF0C'
                ),
                React.createElement(
                  'div',
                  { className: 'limitText' },
                  '\u660E\u65E5\u53EF\u7EE7\u7EED\u53C2\u4E0E\u522E\u5956\u54E6~'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchComfort', hidden: isComfort },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png' }),
              React.createElement(
                'div',
                { className: 'comfortTitle' },
                React.createElement(
                  'div',
                  { className: 'comfortShare', onClick: this.shareClickEvent },
                  '\u5206\u4EAB'
                ),
                ifGetComfort ? React.createElement(
                  'div',
                  { className: 'comfortText' },
                  '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                ) : React.createElement(
                  'div',
                  (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                  '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                ),
                ifWxCoupon ? React.createElement(
                  'div',
                  { className: 'btnGroup' },
                  React.createElement(
                    'div',
                    { className: 'comfortBtn', onClick: this.toAddCard },
                    '\u7ACB\u5373\u9886\u53D6'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'comfortBtn',
                      onClick: this.shadeClose,
                      'data-type': '2'
                    },
                    '\u77E5\u9053\u4E86'
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  !ifGetComfort && React.createElement(
                    'div',
                    { className: 'comfortText' },
                    '\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                  ),
                  React.createElement(
                    'div',
                    { className: 'comfortBtn', onClick: this.comfortBtnClick },
                    '\u77E5\u9053\u4E86'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchDegree', hidden: !isDegree },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchLimit.png' }),
              React.createElement(
                'div',
                { className: 'degreeTitle' },
                React.createElement(
                  'div',
                  { className: 'degreeText' },
                  '\u5BF9\u4E0D\u8D77\uFF0C\u60A8\u7684\u522E\u5956\u6B21\u6570\u4E0D\u8DB3'
                )
              )
            ),
            React.createElement(
              'div',
              {
                hidden: hideCanvas,
                className: 'scratch_wp',
                style: (0, _tools.convertLineStyleData)('width: ' + (scratch && scratch.width) + 'px; height: ' + (scratch && scratch.height) + 'px;')
              },
              React.createElement(
                'div',
                { hidden: isShowBtn },
                React.createElement('canvas', {
                  className: 'scratch-canvas',
                  width: scratch && scratch.width,
                  height: scratch && scratch.height,
                  id: 'scratch-canvas',
                  onTouchStart: this.touchStart,
                  onTouchMove: this.touchMove,
                  onTouchEnd: this.touchEnd
                })
              ),
              isShowBtn && React.createElement(
                'div',
                { className: 'showArea' },
                React.createElement(
                  'div',
                  { className: 'showTitle' },
                  '\u8D62\u53D6\u4F18\u60E0\u5927\u5956'
                ),
                React.createElement(
                  'div',
                  { className: 'showBtn', onClick: this.startScratch },
                  '\u70B9\u6211\u522E\u5956'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'structurePrize' },
            React.createElement(
              'div',
              { className: 'scratch-lookPrize', onClick: this.lookPrize },
              '\u67E5\u770B\u5956\u54C1'
            ),
            React.createElement(
              'div',
              {
                className: 'scratch-exchangePrize',
                onClick: this.intelClick,
                style: (0, _tools.convertLineStyleData)('display:' + (scratchInfo.integral_exchange == 0 ? 'none' : 'inline-block'))
              },
              '\u79EF\u5206\u5151\u6362'
            )
          ),
          React.createElement(
            'div',
            { className: 'scratchRoster' },
            React.createElement(
              'div',
              { className: 'rosterTitle' },
              React.createElement('div', { className: 'rosterStar' })
            ),
            React.createElement(
              'div',
              { className: 'rosterCon' },
              winnerList.length === 0 ? React.createElement(
                'div',
                { className: 'no-roster-list' },
                '\u6682\u65E0\u4E2D\u5956\u540D\u5355'
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'rosterList rosterList1', animation: animationData },
                  winnerList.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      item.nickname + ' 抽中 ' + item.prize_title
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'rosterList rosterList2', animation: animationData2 },
                  winnerList.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      item.nickname + ' 抽中 ' + item.prize_title
                    );
                  })
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'scratchExplain' },
            React.createElement(
              'div',
              { className: 'explainTitle' },
              React.createElement('div', { className: 'explainStar' })
            ),
            React.createElement(
              'div',
              { className: 'explainCon' },
              React.createElement(
                'div',
                { className: 'explainTimeDiv' },
                React.createElement(
                  'span',
                  null,
                  '\u6D3B\u52A8\u65F6\u95F4\uFF1A'
                ),
                React.createElement(
                  'span',
                  { className: 'explainTime' },
                  scratchInfo.start_time,
                  '-',
                  scratchInfo.end_time
                )
              ),
              React.createElement(
                'div',
                { className: 'explainRule' },
                React.createElement(
                  'span',
                  null,
                  scratchInfo.description
                )
              ),
              React.createElement(
                'div',
                null,
                '\u83B7\u53D6\u522E\u5956\u6B21\u6570\uFF1A'
              ),
              scratchInfo.user_times_initial > 0 && React.createElement(
                'div',
                { className: 'explainDayTime' },
                React.createElement(
                  'label',
                  { className: 'scratchDisc' },
                  '\xB7'
                ),
                '\u7528\u6237\u6BCF\u65E5\u9996\u6B21\u767B\u5F55\u53EF\u83B7\u53D6',
                React.createElement(
                  'span',
                  null,
                  scratchInfo.user_times_initial
                ),
                '\u6B21\u522E\u5956\u673A\u4F1A'
              ),
              React.createElement(
                'div',
                { className: 'explainLimit' },
                React.createElement(
                  'label',
                  { className: 'scratchDisc' },
                  '\xB7'
                ),
                '\u6BCF\u65E5\u62BD\u5956\u673A\u4F1A\u6700\u591A\u4E3A',
                React.createElement(
                  'span',
                  { className: 'explainValue' },
                  scratchInfo.user_times == '-1' ? '无限' : scratchInfo.user_times
                ),
                '\u6B21'
              ),
              scratchInfo.integral_exchange != 0 && React.createElement(
                'div',
                { className: 'explainIntegral' },
                React.createElement(
                  'label',
                  { className: 'scratchDisc' },
                  '\xB7'
                ),
                '\u6BCF',
                React.createElement(
                  'span',
                  null,
                  scratchInfo.integral_exchange
                ),
                '\u79EF\u5206\u53EF\u5151\u6362\u4E00\u6B21\u62BD\u5956\u673A\u4F1A'
              ),
              scratchInfo.time_share != 0 && React.createElement(
                'div',
                { className: 'explainShare' },
                React.createElement(
                  'label',
                  { className: 'scratchDisc' },
                  '\xB7'
                ),
                React.createElement(
                  'div',
                  null,
                  '\u6BCF\u6210\u529F\u5206\u4EAB1\u4E2A\u597D\u53CB\u53EF\u589E\u52A0',
                  React.createElement(
                    'span',
                    null,
                    scratchInfo.time_share
                  ),
                  '\u6B21\u62BD\u5956\u673A\u4F1A\uFF0C\u6700\u591A\u53EF\u589E\u52A0',
                  React.createElement(
                    'span',
                    null,
                    scratchInfo.time_share_limit
                  ),
                  '\u6B21\u673A\u4F1A'
                )
              ),
              scratchInfo.consume_times != 0 && React.createElement(
                'div',
                { className: 'explainMoney' },
                React.createElement(
                  'label',
                  { className: 'scratchDisc' },
                  '\xB7'
                ),
                '\u6D88\u8D39\u5373\u8D60\u9001\u4E00\u6B21\u522E\u5956\u673A\u4F1A\u3002'
              )
            )
          ),
          isPrizeSick == true && React.createElement(
            'div',
            { className: 'scratchPrize-sick', onClick: this.wrapPrize },
            React.createElement('div', { className: 'scratchPrize-bg' }),
            React.createElement(
              'div',
              {
                className: 'scratchPrize-wrap',
                onClick: this.stopPropagation
              },
              React.createElement('div', { className: 'scratchPrize-header' }),
              React.createElement(
                'div',
                { className: 'scratchPrize-con' },
                React.createElement('img', {
                  className: 'scratchImg',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/prize_con.png',
                  hidden: myPrize == ''

                }),
                React.createElement(
                  'div',
                  { className: 'scratchPrize-title' },
                  React.createElement('div', { className: 'scratchPrize-line' }),
                  React.createElement(
                    'label',
                    null,
                    '\u4E2D\u5956\u65F6\u95F4'
                  ),
                  React.createElement(
                    'label',
                    null,
                    '\u83B7\u5F97\u5956\u54C1'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchprize-list', hidden: myPrize == '' },
                  myPrize.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      React.createElement(
                        'label',
                        null,
                        item.add_time
                      ),
                      React.createElement(
                        'label',
                        null,
                        item.prize_title
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'scratchPrize-fail', hidden: myPrize != '' },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/prize_fail.png' }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u672A\u83B7\u5F97\u4EFB\u4F55\u5956\u54C1\u54E6~'
                  )
                )
              )
            )
          ),
          isIntel == true && React.createElement(
            'div',
            { className: 'scratchInte' },
            React.createElement(
              'div',
              { className: 'scratchInte-wrap' },
              React.createElement(
                'div',
                { className: 'scratchInte-con' },
                React.createElement(
                  'div',
                  { className: 'scratchInteCan' },
                  '\u53EF\u5151\u6362\u6B21\u6570:',
                  React.createElement(
                    'label',
                    null,
                    intelMes.exchange_times
                  ),
                  React.createElement(
                    'label',
                    null,
                    '\u6B21'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchInteLimit' },
                  '\u5151\u6362\u6B21\u6570:',
                  React.createElement('input', {
                    type: 'text',
                    onChange: this.bindReplaceInput,
                    value: inputValue
                  }),
                  React.createElement(
                    'label',
                    {
                      className: 'scratchInteAll',
                      onClick: this.scratchInteAll
                    },
                    '\u5168\u90E8\u5151\u6362'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchInteRule' },
                  '\u5151\u6362\u89C4\u5219:',
                  React.createElement(
                    'label',
                    null,
                    intelMes.integral_exchange
                  ),
                  '\u5206/\u6B21'
                ),
                React.createElement(
                  'div',
                  { className: 'scratchInteBalance' },
                  '\u79EF\u5206\u4F59\u989D:',
                  React.createElement(
                    'label',
                    null,
                    intelMes.can_use_integral
                  ),
                  '\u5206'
                )
              ),
              React.createElement(
                'div',
                { className: 'scratchInte-btns' },
                React.createElement(
                  'div',
                  {
                    className: 'scratchInte-cancel',
                    onClick: this.intelClose
                  },
                  '\u53D6\u6D88'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'scratchInte-confirm',
                    onClick: this.intelConfirm
                  },
                  '\u786E\u5B9A'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Scratch;
}(_OfficialPage3.default);

exports.default = Scratch;

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(76);

var _modal2 = _interopRequireDefault(_modal);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(78);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(555);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberOfStampsOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(NumberOfStampsOrderDetail, _OfficialPage);

  function NumberOfStampsOrderDetail(props) {
    (0, _classCallCheck3.default)(this, NumberOfStampsOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (NumberOfStampsOrderDetail.__proto__ || Object.getPrototypeOf(NumberOfStampsOrderDetail)).call(this, props));

    _this2.state = {
      orderData: {},
      orderInfo: {},
      hiddenmodalput: true,
      untimes: '', // 次数券的次数
      numberOfStampsUrl: '',
      addLabelText: '',
      status_name: {},
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      orderId: '',
      isFromTemplateMsg: false,
      originalPrice: '',
      useBalance: '',
      freightAdress: {},
      express_fee: '',
      discount_cut_price: '',
      isFromBack: false,
      showWriteOffCodeBox: false,
      showEventDialog: false,
      eventType: '',
      detailShow: true,
      cerificationShow: false,
      verifyShow: false,
      verifyData: {
        success: false,
        qrcodeUrl: ''
      }
    };
    _this2.verifiTimeInterval = '';

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.setData({
        appName: _app.appMethod.globalData.appTitle,
        appLogo: _app.appMethod.globalData.appLogo
      });
    };

    _this2.getVerificationInfo = function () {
      _this2.setData({
        detailShow: false,
        cerificationShow: true
      });
    };

    _this2.getOrderDetail = function (orderId) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.data.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0],
              form_data = data.form_data,
              hasAdditionalInfo = false,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              address_id = '';
          if (form_data.additional_info) {
            for (var i = 0; i < form_data.goods_info.length; i++) {
              var deliveryId = form_data.goods_info[i].delivery_id,
                  goodsId = form_data.goods_info[i].goods_id;
              if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
                additional_info_goods.push(form_data.goods_info[i]);
                additional_goodsid_arr.push(goodsId);
                hasAdditionalInfo = true;
              }
            }
          }
          var remark = form_data.remark;
          var status_name = void 0;
          form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark;
          switch (form_data.status) {
            case '0':
              status_name = '未付款';
              break;
            case '1':
              status_name = '已付款';
              break;
            case '7':
              status_name = '已关闭';
              break;
          }
          that.setData({
            orderData: data,
            orderInfo: form_data,
            hasAdditionalInfo: hasAdditionalInfo,
            discount_cut_price: form_data.discount_cut_price,
            useBalance: form_data['use_balance'],
            express_fee: res.data[0]['express_fee'],
            status_name: status_name
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          _app.appMethod.setGoodsAdditionalInfo(form_data.additional_info || {});
        }
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.copyOrderId = function () {
      var _this = _this2;
      _app.appMethod.setClipboardData({
        data: _this.data.orderId,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.addLabelInput = function (e) {
      _this2.setData({ addLabelText: e.target.value });
    };

    _this2.confirm = function () {
      if (+_this2.data.orderInfo.un_verify_times < +_this2.data.addLabelText) {
        _app.appMethod.showModal({ content: '核销次数超过剩余次数' });
        _this2.setData({ hiddenmodalput: true, addLabelText: '' });
        return;
      }
      var url = _this2.data.numberOfStampsUrl + '&Number=' + _this2.data.addLabelText;
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
      _app.appMethod.turnToPage(url, false);
    };

    _this2.cancel = function () {
      _this2.setData({ hiddenmodalput: true, addLabelText: '' });
    };

    _this2.getWriteOffCodeBox = function () {
      var couponId = _this2.data.orderInfo.user_coupon_id;
      var franisee = _this2.data.franchiseeId ? _this2.data.franchiseeId : _app.appMethod.globalData.appId;
      var url = '/exchangeCoupon/pages/numberOfStampsUsed/numberOfStampsUsed?detail=' + couponId + '&franchisee=' + franisee;
      _this2.setData({ numberOfStampsUrl: url, hiddenmodalput: false });
    };

    _this2.hideCouponVerify = function () {
      _this2.setData({
        detailShow: true,
        verifyShow: false,
        cerificationShow: false
      });
      clearInterval(_this2.timeInterval);
      _this2.socketOpen && Taro.closeSocket();
    };

    _this2.timeInterval = '';
    _this2.socketOpen = false;

    _this2.connectSocket = function () {
      var that = _this2;
      Taro.connectSocket({
        url: 'wss://ceshi.zhichiwangluo.com', //线下test
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      Taro.onSocketOpen(function (res) {
        that.socketOpen = true;
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        Taro.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.timeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_coupon_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          Taro.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      Taro.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_coupon_verify' && msg.status == 0) {
            that.setData({
              'verifyData.success': true
            });
            clearInterval(that.timeInterval);
            Taro.closeSocket();
          }
        }
      });
      Taro.onSocketClose(function (res) {
        that.socketOpen = false;
        clearInterval(that.timeInterval);
        console.log('WebSocket 已关闭！');
      });
      Taro.onSocketError(function (res) {
        that.socketOpen = false;
        console.log('WebSocket连接打开错误，请检查！');
      });
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(NumberOfStampsOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'component',
    value: function component() {
      var that = this;
      clearInterval(that.timeInterval);
      that.socketOpen && Taro.closeSocket();
    }
  }, {
    key: 'privateStopNoop',
    value: function privateStopNoop(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          detailShow = _state.detailShow,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          status_name = _state.status_name,
          orderInfo = _state.orderInfo,
          appLogo = _state.appLogo,
          hiddenmodalput = _state.hiddenmodalput,
          addLabelText = _state.addLabelText,
          labelFocus = _state.labelFocus,
          cerificationShow = _state.cerificationShow;

      return React.createElement(
        'div',
        { className: 'official-page number-of-stamps-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'order-contain ' + (detailShow ? 'show' : '') },
            isFromTemplateMsg && React.createElement(
              'div',
              {
                className: 'orderDetail-goto-homepage',
                onClick: this.goToHomepage
              },
              '\u8FD4\u56DE\u9996\u9875'
            ),
            React.createElement(
              'div',
              { className: 'seller-shipped' },
              React.createElement(
                'div',
                null,
                '订单状态：' + status_name
              )
            ),
            React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { className: 'app-box' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'app-name' },
                    '\u4E0B\u5355\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'contact-service pull-right' },
                    React.createElement(
                      'span',
                      null,
                      orderInfo.add_time
                    )
                  )
                )
              ),
              React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'goods-detail-box' },
                  React.createElement('img', { src: appLogo }),
                  React.createElement(
                    'div',
                    null,
                    orderInfo.goods_info && orderInfo.goods_info.goods_name && React.createElement(
                      'div',
                      {
                        className: 'goods-rules',
                        style: (0, _tools.convertLineStyleData)('color: #333;font-size:26rpx')
                      },
                      orderInfo.goods_info.goods_name
                    ),
                    React.createElement(
                      'div',
                      { className: 'goods-rules' },
                      '使用时间' + (orderInfo.goods_info && orderInfo.goods_info.expire)
                    ),
                    React.createElement(
                      'div',
                      { className: 'goods-price' },
                      orderInfo.goods_info && orderInfo.goods_info.price != 0 && orderInfo.goods_info.price != '0.00' && React.createElement(
                        'span',
                        { className: 'color333' },
                        '¥' + orderInfo.goods_info.price
                      ),
                      orderInfo.goods_info && orderInfo.goods_info.price != 0 && orderInfo.goods_info.price != '0.00' && orderInfo.goods_info.integral && React.createElement(
                        'span',
                        { className: 'color333' },
                        '+'
                      ),
                      orderInfo.goods_info && orderInfo.goods_info.integral && React.createElement(
                        'span',
                        { className: 'color333' },
                        orderInfo.goods_info.integral + '积分'
                      ),
                      React.createElement(
                        'span',
                        { className: 'pull-right' },
                        'x 1'
                      )
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'actual-payment' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u5B9E\u9645\u4ED8\u6B3E'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right colorff7' },
                  '¥' + orderInfo.total_price
                )
              )
            ),
            orderInfo.status != 0 && orderInfo.coupon_type == 6 && React.createElement(
              'div',
              { className: 'order-used' },
              React.createElement(
                'div',
                {
                  className: 'order-used-title',
                  onClick: this.getVerificationInfo
                },
                React.createElement(
                  'span',
                  null,
                  '\u6838\u9500\u60C5\u51B5'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow' })
              ),
              React.createElement(
                'div',
                { className: 'order-used-line order-used-bottom' },
                React.createElement(
                  'div',
                  null,
                  '\u5DF2\u6838\u9500'
                ),
                React.createElement(
                  'div',
                  { className: 'colorff7' },
                  orderInfo.verified_times + '次'
                )
              ),
              React.createElement(
                'div',
                { className: 'order-used-line' },
                React.createElement(
                  'div',
                  null,
                  '\u672A\u6838\u9500'
                ),
                React.createElement(
                  'div',
                  { className: 'colorff7' },
                  orderInfo.un_verify_times + '次'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'order-number' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u8BA2\u5355\u7F16\u53F7'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.order_id
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right', onClick: this.copyOrderId },
                  '\u590D\u5236'
                )
              )
            ),
            orderInfo.coupon_type == 6 && orderInfo.can_verify == 1 && orderInfo.status != 0 && orderInfo.un_verify_times != 0 && React.createElement(
              'div',
              { className: 'order-bottom' },
              React.createElement(
                'span',
                { className: 'btn', onClick: this.getWriteOffCodeBox },
                '\u6838\u9500\u7801'
              )
            )
          ),
          React.createElement(
            _modal2.default,
            {
              visible: !hiddenmodalput,
              transparent: true,
              title: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
              maskClosable: true,
              platform: '\'ios\'',
              footer: [{
                text: '取消',
                onPress: this.cancel
              }, {
                text: '确认',
                onPress: this.confirm
              }]
            },
            React.createElement('input', {
              type: 'number',
              placeholder: '\u8BF7\u8F93\u5165\u672C\u6B21\u6838\u9500\u6B21\u6570',
              maxLength: '6',
              onChange: this.addLabelInput,
              value: addLabelText,
              style: {
                background: '#F5F5F5',
                height: '.76rem',
                borderRadius: '.10rem',
                padding: '.10rem .10rem',
                boxSizing: 'border-box',
                border: 0
              }
            })
          ),
          React.createElement(
            'div',
            {
              className: 'coupon-cerification-info ' + (cerificationShow ? 'show' : '')
            },
            orderInfo.verify_log && orderInfo.verify_log.length > 0 && React.createElement(
              'div',
              { className: 'ceification-info-title' },
              React.createElement(
                'span',
                { className: 'ceification-info-left' },
                '\u6838\u9500\u6B21\u6570'
              ),
              React.createElement(
                'span',
                null,
                '\u6838\u9500\u65F6\u95F4'
              )
            ),
            orderInfo.verify_log && orderInfo.verify_log.length > 0 && React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('min-height:300rpx;background: #fff;') },
              orderInfo.verify_log.map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'ceification-info-line', key: 'key' },
                  React.createElement(
                    'span',
                    { className: 'ceification-info-left' },
                    item.consume_times
                  ),
                  React.createElement(
                    'span',
                    null,
                    item.add_time
                  )
                );
              })
            ),
            orderInfo.verify_log && orderInfo.verify_log.length == 0 && React.createElement(
              'div',
              { className: 'coupon-cerification-nodata' },
              '- \u6682\u65E0\u6570\u636E -'
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('text-align:center') },
              React.createElement(
                'div',
                {
                  className: 'ceification-info-back',
                  onClick: this.hideCouponVerify
                },
                '\u8FD4\u56DE'
              )
            )
          )
        )
      );
    }
  }]);
  return NumberOfStampsOrderDetail;
}(_OfficialPage3.default);

exports.default = NumberOfStampsOrderDetail;

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(557);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NumberOfStampsUsed = function (_OfficialPage) {
  (0, _inherits3.default)(NumberOfStampsUsed, _OfficialPage);

  function NumberOfStampsUsed(props) {
    (0, _classCallCheck3.default)(this, NumberOfStampsUsed);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NumberOfStampsUsed.__proto__ || Object.getPrototypeOf(NumberOfStampsUsed)).call(this, props));

    _this.state = {
      verifyData: {
        success: false,
        qrcodeUrl: ''
      },
      useNumber: 1,
      couponDetail: {}
    };

    _this.getWriteOffCodeBox = function () {
      var qrcodeUrl = '' + _app.appMethod.globalData.siteBaseUrl + ('/index.php?r=AppShop/couponQrcode&app_id=' + (_this.data.franchiseeId ? _this.data.franchiseeId : _app.appMethod.globalData.appId)) + ('&user_coupon_id=' + _this.data.couponDetail.id + '&consume_times=' + _this.data.useNumber);
      _this.setData({
        'verifyData.qrcodeUrl': qrcodeUrl
      });
      _this.connectSocket();
    };

    _this.hideCouponVerify = function () {
      var that = _this;
      clearInterval(_this.timeInterval);
      _this.socketOpen && _app.appMethod.closeSocket();
      _app.appMethod.turnBack();
    };

    _this.timeInterval = '';
    _this.socketOpen = false;

    _this.connectSocket = function () {
      var that = _this;
      _app.appMethod.connectSocket({
        url: 'wss://xcx.zhichiwangluo.com', //testonly
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        that.socketOpen = true;
        console.log('打开WebSocket');
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.timeInterval = setInterval(function () {
          console.log('打开轮询');
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_coupon_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          console.log(msg);
          if (msg.type == 'app_coupon_verify' && msg.status == 0) {
            that.setData({
              'verifyData.success': true
            });
            clearInterval(that.timeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
      _app.appMethod.onSocketClose(function (res) {
        that.socketOpen = false;
        clearInterval(that.timeInterval);
        console.log('WebSocket 已关闭！');
      });
      _app.appMethod.onSocketError(function (res) {
        that.socketOpen = false;
        console.log('WebSocket连接打开错误，请检查！');
      });
    };

    document.title = '核销码';
    return _this;
  }

  (0, _createClass3.default)(NumberOfStampsUsed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var couponId = options.detail || ''; // receive时为优惠券Id, use时为用户领取的优惠券Id
      var franchiseeId = options.franchisee || '';
      var useNumber = options.Number || 1;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getUserListCouponInfo',
        data: {
          sub_app_id: franchiseeId,
          user_coupon_id: couponId
        },
        hideLoading: true,
        success: function success(res) {
          that.setData({ couponDetail: res.data[0], useNumber: useNumber });
          that.getWriteOffCodeBox();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearInterval(that.timeInterval);
      that.socketOpen && _app.appMethod.closeSocket();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          verifyData = _state.verifyData,
          couponDetail = _state.couponDetail;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page number-of-stamps-used' },
          React.createElement(_TopNav.TopNav, { title: '\u6838\u9500\u7801' }),
          React.createElement(
            'div',
            { className: 'coupon-verify-wrap show' },
            React.createElement(
              'div',
              { className: 'bottom-section' },
              !verifyData.success ? React.createElement(
                'div',
                { className: 'verify-block' },
                React.createElement(
                  'div',
                  { className: 'qrcode' },
                  React.createElement('img', { src: verifyData.qrcodeUrl })
                ),
                React.createElement(
                  'div',
                  { className: 'code' },
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('color: #FF7100') },
                    '\u6838\u9500\u7801'
                  ),
                  React.createElement(
                    'div',
                    null,
                    couponDetail.verify_code
                  )
                )
              ) : verifyData.success && React.createElement(
                'div',
                { className: 'success-block' },
                React.createElement(
                  'div',
                  { className: 'success-tip' },
                  React.createElement(_icon2.default, {
                    className: 'success-tip-icon',
                    type: 'success',
                    size: 'xxs'
                  }),
                  React.createElement(
                    'span',
                    { className: 'success-tip-text' },
                    '\u6838\u9500\u6210\u529F!'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'back-tip', onClick: this.hideCouponVerify },
                  '>>>\u8FD4\u56DE'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NumberOfStampsUsed;
}(_OfficialPage3.default);

exports.default = NumberOfStampsUsed;

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _slicedToArray2 = __webpack_require__(105);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(565);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExchangeCouponDetail = function (_OfficialPage) {
  (0, _inherits3.default)(ExchangeCouponDetail, _OfficialPage);

  function ExchangeCouponDetail(props) {
    (0, _classCallCheck3.default)(this, ExchangeCouponDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExchangeCouponDetail.__proto__ || Object.getPrototypeOf(ExchangeCouponDetail)).call(this, props));

    _this.state = {
      couponId: '', // receive时为商家设置优惠券id，use时为用户领取优惠券id
      couponDetail: {},
      receiveSuccess: 0, // 领取成功弹窗是否显示
      receiveCount: 0, // 已领取数量
      receiveLimitNum: 0, // 领取限制数量
      rechargeSuccess: 0, // 充值成功弹窗是否显示
      verifySuccess: false,
      verifyQrcodeUrl: '',
      verifyShow: false,
      style: {},
      verifyData: {
        success: false,
        qrcodeUrl: ''
      }
    };

    _this.cutStyle = function (str) {
      if (typeof str !== 'string') {
        return str;
      }
      // 截取style样式
      var obj = str.split(';').reduce(function (p, e) {
        var _e$split = e.split(':'),
            _e$split2 = (0, _slicedToArray3.default)(_e$split, 2),
            k = _e$split2[0],
            v = _e$split2[1];

        v = v && v.trim() || '';
        if (v) {
          p[k] = v;
        }
        return p;
      }, {});
      return obj;
    };

    _this.setCouponData = function (data) {
      var that = _this;
      var useCondition = '';
      var stampsType = void 0,
          stampsUser = '';
      if (data.type == 0) {
        useCondition = '满' + data.condition + '，减' + data.value + '元';
        stampsType = '满减券';
      } else if (data.type == 1) {
        useCondition = '打' + data.value + '折';
        stampsType = '打折券';
      } else if (data.type == 2) {
        useCondition = '可抵扣' + data.value + '元';
        stampsType = '代金券';
      } else if (data.type == 3) {
        if (data.extra_condition == '') {
          useCondition = '直接兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.price) {
          useCondition = '消费满' + data.extra_condition.price + '元可兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.goods_id) {
          useCondition = '购买' + data.condition_goods_info.title + '可兑换' + data.coupon_goods_info.title;
        }
        stampsType = '兑换券';
      } else if (data.type == 4) {
        useCondition = '储值金可充值' + data.value + '元';
        stampsType = '储值券';
      } else if (data.type == 5) {
        useCondition = data.extra_condition;
        stampsType = '通用券';
      } else if (data.type == 6) {
        useCondition = '可使用' + parseInt(data.value) + '次';
        stampsType = '次数券';
      }
      var newData = data;
      if (data.user_condition_list && data.user_condition_list.length > 0) {
        data.user_condition_list.forEach(function (res, i) {
          if (i == data.user_condition_list.length - 1) {
            stampsUser = stampsUser + res;
          } else {
            stampsUser = stampsUser + res + ',';
          }
        });
      } else {
        if (data.user_condition == '0') {
          stampsUser = '所有用户';
        }
        if (data.user_condition == '1') {
          stampsUser = '所有会员';
        }
      }
      newData['useCondition'] = useCondition;
      newData['stampsType'] = stampsType;
      newData['stampsUser'] = stampsUser;
      that.setData({
        couponDetail: newData
      });
    };

    _this.formSubmit = function (event) {
      var that = _this;
      var couponDetail = that.data.couponDetail;
      if (couponDetail.recv_status == 0) {
        _app.appMethod.showModal({ content: '超过可兑换次数' });
        return;
      }
      if (couponDetail.exchange_condition.price !== 0) {
        _app.appMethod.turnToPage('/exchangeCoupon/pages/exchangeCouponDetailOrder/exchangeCouponDetailOrder?id=' + couponDetail.id);
        return;
      }
      _app.appMethod.showModal({
        title: '是否确认兑换？',
        content: '注：兑换成功后不支持退换',
        showCancel: true,
        cancelText: '否',
        confirmText: '是',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appCoupon/addCouponOrder',
            data: {
              app_id: _app.appMethod.globalData.appId,
              id: couponDetail.id
            },
            hideLoading: true,
            success: function success(res) {
              if (res.status !== 0) {
                return;
              }
              if (couponDetail.limit_num >= couponDetail.user_recv_num + 1) {
                var newData = couponDetail;
                newData.user_recv_num++;
                that.setData({
                  receiveSuccess: 1,
                  couponDetail: newData
                });
              } else {
                var _newData = couponDetail;
                _newData.recv_status = 0;
                that.setData({
                  receiveSuccess: 1,
                  couponDetail: _newData
                });
              }
              setTimeout(function () {
                that.hideReceiveToast();
              }, 3000);
            },
            complete: function complete(res) {}
          });
        }
      });
    };

    _this.hideReceiveToast = function () {
      _this.setData({
        receiveSuccess: 0
      });
    };

    _this.hideRechargeToast = function () {
      _this.setData({
        rechargeSuccess: 0
      });
    };

    _this.timeInterval = '';
    _this.socketOpen = false;

    _this.connectSocket = function () {
      var that = _this;
      _app.appMethod.connectSocket({
        url: 'wss://ceshi.zhichiwangluo.com', //线下test
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      _app.appMethod.onSocketOpen(function (res) {
        that.socketOpen = true;
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_coupon_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        _app.appMethod.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.timeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_coupon_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          _app.appMethod.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      _app.appMethod.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_coupon_verify' && msg.status == 0) {
            that.setData({
              'verifyData.success': true,
              'couponDetail.status': 2
            });
            clearInterval(that.timeInterval);
            _app.appMethod.closeSocket();
          }
        }
      });
      _app.appMethod.onSocketClose(function (res) {
        that.socketOpen = false;
        clearInterval(that.timeInterval);
        console.log('WebSocket 已关闭！');
      });
      _app.appMethod.onSocketError(function (res) {
        that.socketOpen = false;
        console.log('WebSocket连接打开错误，请检查！');
      });
    };

    document.title = '兑换券详情';
    return _this;
  }

  (0, _createClass3.default)(ExchangeCouponDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var exchangeCouponDetail = _app.appMethod.globalData.exchangeCouponStyle;
      var style = {};
      if (exchangeCouponDetail) {
        var styleArr = this.cutStyle(exchangeCouponDetail.style);
        style.strStyle = styleArr;
        style.lineBackgroundColor = exchangeCouponDetail.customFeature.lineBackgroundColor;
        style.secColor = exchangeCouponDetail.customFeature.secColor;
      }
      var id = options.id;
      that.setData({
        couponId: id,
        style: style
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCouponInfo',
        data: {
          app_id: _app.appMethod.globalData.appId,
          coupon_id: id
        },
        hideLoading: true,
        success: function success(res) {
          that.setCouponData(res.data);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var that = this;
      clearInterval(that.timeInterval);
      that.socketOpen && _app.appMethod.closeSocket();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          couponDetail = _state.couponDetail,
          style = _state.style,
          receiveSuccess = _state.receiveSuccess;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page exchange-coupon-detail' },
          React.createElement(_TopNav.TopNav, { title: '\u5151\u6362\u5238\u8BE6\u60C5' }),
          React.createElement(
            'div',
            {
              className: 'page',
              id: 'couponDetail',
              style: (0, _tools.convertLineStyleData)('background: ' + couponDetail.background)
            },
            React.createElement(
              'div',
              { className: 'exchange-coupon-wrap show' },
              React.createElement(
                'div',
                { className: 'exchange-coupon-bg' },
                React.createElement(
                  'div',
                  {
                    className: 'ticket certificate-ticket',
                    onClick: this.gotoCouponDetail,
                    style: (0, _tools.convertLineStyleData)('background-color: ' + style.lineBackgroundColor)
                  },
                  React.createElement('div', {
                    className: 'top-section',
                    style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                  }),
                  couponDetail.type == 0 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u51CF'
                      )
                    )
                  ) : couponDetail.type == 1 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u6298'
                      )
                    )
                  ) : couponDetail.type == 2 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u4EE3'
                      )
                    )
                  ) : couponDetail.type == 3 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u5151'
                      )
                    )
                  ) : couponDetail.type == 4 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u50A8'
                      )
                    )
                  ) : couponDetail.type == 5 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u901A'
                      )
                    )
                  ) : couponDetail.type == 6 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'detail-info' },
                      React.createElement(
                        'div',
                        { className: 'name' },
                        couponDetail.title
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'use-condition',
                          style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                        },
                        couponDetail.exchange_condition.price > 0 && React.createElement(
                          'span',
                          null,
                          '¥' + couponDetail.exchange_condition.price
                        ),
                        couponDetail.exchange_condition.price > 0 && couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          '+'
                        ),
                        couponDetail.exchange_condition.integral > 0 && React.createElement(
                          'span',
                          null,
                          couponDetail.exchange_condition.integral + '积分'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'background-word-area',
                        style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                      },
                      React.createElement('div', {
                        className: 'background-circle',
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      }),
                      React.createElement(
                        'div',
                        { className: 'background-word' },
                        '\u6B21'
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'bottom-section',
                      style: (0, _tools.convertLineStyleData)('background-color: ' + style.lineBackgroundColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '有效期 ' + (couponDetail.expire == '-1' ? couponDetail.start_use_date + '至' + couponDetail.end_use_date : couponDetail.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (couponDetail.react > 0 ? couponDetail.react + '天后' : '当天') + '生效，有效期' + couponDetail.expire + '天') + ' ' + (couponDetail.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (couponDetail.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + couponDetail.start_use_time + '-' + couponDetail.end_use_time
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'function-btn-wrap' },
                  React.createElement(
                    'form',
                    null,
                    couponDetail.stock != 0 && couponDetail.user_recv_num == 0 ? React.createElement(
                      'button',
                      {
                        className: 'function-btn',
                        type: 'button',
                        onClick: this.formSubmit,
                        'data-coupon-id': couponDetail.id,
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      },
                      '\u7ACB\u5373\u5151\u6362'
                    ) : couponDetail.stock == 0 ? React.createElement(
                      'button',
                      { className: 'function-btn disabled' },
                      '\u5DF2\u62A2\u5B8C'
                    ) : couponDetail.stock != 0 && couponDetail.user_recv_num !== 0 && React.createElement(
                      'button',
                      {
                        className: 'function-btn',
                        type: 'button',
                        onClick: this.formSubmit,
                        'data-coupon-id': couponDetail.id,
                        style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                      },
                      '\u518D\u6B21\u5151\u6362'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'middle-section' },
                React.createElement(
                  'div',
                  { className: 'detail-item condition' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u4F18\u60E0\u5238\u7C7B\u578B\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    couponDetail.stampsType
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail-item condition' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u4F18\u60E0\u5238\u540D\u79F0\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    couponDetail.title
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail-item condition' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u53EF\u9886\u53D6\u7528\u6237\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    couponDetail.stampsUser
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'detail-item time' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u53EF\u7528\u65F6\u95F4\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'item-content',
                      style: (0, _tools.convertLineStyleData)('position:relative;top:-5rpx')
                    },
                    React.createElement(
                      'div',
                      { className: 'date-duration' },
                      couponDetail.expire == '-1' ? couponDetail.start_use_date + '至' + couponDetail.end_use_date : couponDetail.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (couponDetail.react > 0 ? couponDetail.react + '天后' : '当天') + '生效，有效期' + couponDetail.expire + '天'
                    ),
                    React.createElement(
                      'div',
                      { className: 'other-case' },
                      (couponDetail.exclude_holiday == 1 ? '除法定节假日' : '') + ' ' + (couponDetail.exclude_weekend == 1 ? '周一至周五' : '')
                    ),
                    React.createElement(
                      'div',
                      { className: 'time-duration' },
                      couponDetail.start_use_time + '-' + couponDetail.end_use_time
                    )
                  )
                ),
                couponDetail.type == 6 && React.createElement(
                  'div',
                  { className: 'detail-item condition' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u53EF\u5151\u6362\u6B21\u6570\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    couponDetail.useCondition
                  )
                ),
                couponDetail.type != 6 && React.createElement(
                  'div',
                  { className: 'detail-item condition' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u4F18\u60E0\u65B9\u5F0F\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    couponDetail.useCondition
                  )
                )
              )
            ),
            React.createElement(
              'div',
              {
                className: 'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : ''),
                onClick: this.hideReceiveToast
              },
              React.createElement(
                'div',
                { className: 'zc-toast receive-success' },
                React.createElement(_icon2.default, { className: 'icon', type: 'success', size: 'xss' }),
                React.createElement(
                  'div',
                  { className: 'title' },
                  '\u5151\u6362\u6210\u529F!'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ExchangeCouponDetail;
}(_OfficialPage3.default);

exports.default = ExchangeCouponDetail;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(560), __esModule: true };

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91);
__webpack_require__(77);
module.exports = __webpack_require__(561);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(130);
var ITERATOR = __webpack_require__(35)('iterator');
var Iterators = __webpack_require__(64);
module.exports = __webpack_require__(24).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(563), __esModule: true };

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91);
__webpack_require__(77);
module.exports = __webpack_require__(564);


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(48);
var get = __webpack_require__(129);
module.exports = __webpack_require__(24).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _slicedToArray2 = __webpack_require__(105);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _MemberDiscount = __webpack_require__(66);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TopNav = __webpack_require__(8);

__webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExchangeCouponDetailOrder = function (_OfficialPage) {
  (0, _inherits3.default)(ExchangeCouponDetailOrder, _OfficialPage);

  function ExchangeCouponDetailOrder(props) {
    var _this$state;

    (0, _classCallCheck3.default)(this, ExchangeCouponDetailOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExchangeCouponDetailOrder.__proto__ || Object.getPrototypeOf(ExchangeCouponDetailOrder)).call(this, props));

    _this.state = (_this$state = {
      useBalance: true,
      balance: '',
      couponId: '',
      couponDetail: '',
      payInfo: '',
      discountList: [],
      isFromSelectAddress: false,
      franchisee_id: '',
      cart_id_arr: [],
      cart_data_arr: []
    }, (0, _defineProperty3.default)(_this$state, 'balance', ''), (0, _defineProperty3.default)(_this$state, 'requesting', false), (0, _defineProperty3.default)(_this$state, 'additional_info', {}), (0, _defineProperty3.default)(_this$state, 'is_group', ''), (0, _defineProperty3.default)(_this$state, 'inputTimer', ''), (0, _defineProperty3.default)(_this$state, 'style', ''), (0, _defineProperty3.default)(_this$state, 'exchangeCouponData', {
      dialogHidden: true,
      goodsInfo: {},
      selectModelInfo: {},
      hasSelectGoods: false,
      voucher_coupon_goods_info: {}
    }), _this$state);
    _this.hasRequiredSuppInfo = false;
    _this.memberDiscountRef = React.createRef();

    _this.cutStyle = function (str) {
      if (typeof str !== 'string') {
        return str;
      }
      // 截取style样式
      var obj = str.split(';').reduce(function (p, e) {
        var _e$split = e.split(':'),
            _e$split2 = (0, _slicedToArray3.default)(_e$split, 2),
            k = _e$split2[0],
            v = _e$split2[1];

        v = v && v.trim() || '';
        if (v) {
          p[k] = v;
        }
        return p;
      }, {});
      return obj;
    };

    _this.getExchangeCouponInfo = function () {
      // 兑换券详情
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetCouponInfo',
        data: {
          app_id: _app.appMethod.globalData.appId,
          coupon_id: that.data.couponId
        },
        hideLoading: true,
        success: function success(res) {
          that.setCouponData(res.data);
        }
      });
    };

    _this.setCouponData = function (data) {
      // 处理兑换券的使用方式
      var that = _this;
      var useCondition = '';
      if (data.type == 0) {
        useCondition = '满' + data.condition + '，减' + data.value + '元';
      } else if (data.type == 1) {
        useCondition = '打' + data.value + '折';
      } else if (data.type == 2) {
        useCondition = '可抵扣' + data.value + '元';
      } else if (data.type == 3) {
        if (data.extra_condition == '') {
          useCondition = '直接兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.price) {
          useCondition = '消费满' + data.extra_condition.price + '元可兑换' + data.coupon_goods_info.title;
        } else if (data.extra_condition.goods_id) {
          useCondition = '购买' + data.condition_goods_info.title + '可兑换' + data.coupon_goods_info.title;
        }
      } else if (data.type == 4) {
        useCondition = '储值金可充值' + data.value + '元';
      } else if (data.type == 5) {
        useCondition = data.extra_condition;
      }
      var newData = data;
      newData['useCondition'] = useCondition;
      that.setData({
        couponDetail: newData
      });
    };

    _this.useBalanceChange = function (checked) {
      // 是否使用储值金
      _this.setData({
        useBalance: checked
      });
      _this.changePayInfo();
    };

    _this.changePayInfo = function () {
      // 改变支付优惠
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appCoupon/calculateCouponPrice',
        data: {
          app_id: _app.appMethod.globalData.appId,
          id: that.data.couponId,
          select_benefit: that.data.selectDiscountInfo.no_use_benefit ? 'no_use_benefit' : '',
          no_use_balance: that.data.useBalance ? 0 : 1,
          'select_benefit[discount_type]': that.data.selectDiscountInfo.discount_type,
          'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
          'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
          'select_benefit[discount_title]': that.data.selectDiscountInfo.discount_title
        },
        hideLoading: true,
        method: 'post',
        success: function success(res) {
          var newData = res.data;
          that.setData({
            payInfo: newData,
            balance: newData.balance
          });
        }
      });
    };

    _this.getPayInfo = function () {
      // 第一次拿取支付信息
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appCoupon/calculateCouponPrice',
        data: {
          app_id: _app.appMethod.globalData.appId,
          id: that.data.couponId
        },
        hideLoading: true,
        method: 'post',
        success: function success(res) {
          var newData = res.data;
          var info = res.data;
          var benefits = info.benefit;
          var goodsBenefitsData = [];
          var selectDiscountInfo = {};
          if (info.selected_benefit) {
            selectDiscountInfo = {
              discount_title: info.selected_benefit.discount_title,
              discount_type: info.selected_benefit.discount_type,
              coupon_id: info.selected_benefit.coupon_id,
              vip_id: info.selected_benefit.vip_id
            };
          }
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          that.setData({
            balance: newData.balance,
            payInfo: newData,
            discountList: goodsBenefitsData,
            selectDiscountInfo: selectDiscountInfo
          });
        },
        complete: function complete(res) {
          if (res.status === 0) {
            return;
          }
          setTimeout(function () {
            _app.appMethod.turnBack();
          }, 1000);
        }
      });
    };

    _this.confirmPayment = function (e) {
      var list = _this.data.goodsList,
          that = _this,
          no_use_balance = that.data.useBalance ? 0 : 1,
          selected_benefit = _this.data.selectDiscountInfo.discount_type ? '' : 'no_use_benefit';
      if (_this.requesting) {
        return;
      }
      var data = void 0;
      _this.requesting = true;
      if (selected_benefit == '') {
        data = {
          app_id: _app.appMethod.globalData.appId,
          id: that.data.couponId,
          'select_benefit[discount_type]': that.data.selectDiscountInfo.discount_type,
          'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
          'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
          'select_benefit[discount_title]': that.data.selectDiscountInfo.discount_title,
          no_use_balance: no_use_balance
        };
      } else {
        data = {
          app_id: _app.appMethod.globalData.appId,
          id: that.data.couponId,
          select_benefit: selected_benefit,
          'select_benefit[discount_type]': that.data.selectDiscountInfo.discount_type,
          'select_benefit[vip_id]': that.data.selectDiscountInfo.vip_id,
          'select_benefit[coupon_id]': that.data.selectDiscountInfo.coupon_id,
          'select_benefit[discount_title]': that.data.selectDiscountInfo.discount_title,
          no_use_balance: no_use_balance
        };
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appCoupon/addCouponOrder',
        method: 'post',
        data: data,
        success: function success(res) {
          that.payOrder(res.data);
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this.cancelOrder = function (orderId) {
      var appId = _app.appMethod.getAppId(),
          that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cancelOrder',
        data: {
          order_id: orderId,
          app_id: appId,
          sub_shop_app_id: appId
        },
        success: function success(res) {}
      });
    };

    _this.payOrder = function (orderId) {
      var that = _this;
      function paySuccess() {
        _app.appMethod.showModal({ content: '兑换成功！' });
        setTimeout(function () {
          _app.appMethod.turnBack();
        }, 1000);
      }
      function payFail() {
        _app.appMethod.showModal({ content: '兑换失败！' });
        that.cancelOrder(orderId.order_id);
        setTimeout(function () {
          _app.appMethod.turnBack();
        }, 1000);
      }
      if (orderId.total_price == 0) {
        _app.appMethod.showModal({ content: '兑换成功！' });
        setTimeout(function () {
          _app.appMethod.turnBack();
        }, 1000);
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId.order_id
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId.order_id
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     that.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId.order_id,
        cancel: payFail
      });
    };

    _this.wxPay = function (param) {
      var that = _this;
      _app.appMethod.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _app.appMethod.wxPaySuccess(param);
          param.success();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消'
            });
            that.cancelOrder(param.orderId);
            setTimeout(function () {
              _app.appMethod.turnBack();
            }, 1000);
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败'
          });
          setTimeout(function () {
            _app.appMethod.turnBack();
          }, 1000);
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    _this.showMemberDiscount = function () {
      _this.memberDiscountRef.current.show({
        discountType: discountList,
        afterSelectedBenefit: _this.afterSelectedBenefit
      });
      _this.memberDiscountRef.current.showDialog(_this.data.selectDiscountInfo);
    };

    _this.afterSelectedBenefit = function (event) {
      _this.setData({
        selectDiscountInfo: event.detail.selectedDiscount
      });
      _this.changePayInfo();
    };

    document.title = '确认订单';
    return _this;
  }

  (0, _createClass3.default)(ExchangeCouponDetailOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      var id = options.id;
      var exchangeCouponDetail = _app.appMethod.globalData.exchangeCouponStyle;
      var style = {};
      if (exchangeCouponDetail) {
        var styleArr = this.cutStyle(exchangeCouponDetail.style);
        style.strStyle = styleArr;
        style.lineBackgroundColor = exchangeCouponDetail.customFeature.lineBackgroundColor;
        style.secColor = exchangeCouponDetail.customFeature.secColor;
      }
      that.setData({
        couponId: id,
        style: style
      });
      this.getExchangeCouponInfo();
      this.getPayInfo();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          discountList = _state.discountList,
          style = _state.style,
          couponDetail = _state.couponDetail,
          data = _state.data,
          payInfo = _state.payInfo,
          selectDiscountInfo = _state.selectDiscountInfo,
          selectDiscountIndex = _state.selectDiscountIndex,
          useBalance = _state.useBalance,
          balance = _state.balance;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page exchange-coupon-detail-order' },
          React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u4E0B\u5355' }),
          React.createElement(
            'div',
            { className: 'preview-goods-wrap' },
            React.createElement(
              'div',
              { className: 'exchange-coupon' },
              React.createElement(
                'div',
                { className: 'exchange-coupon-wrapper' },
                couponDetail.recv_status == 1 ? React.createElement('div', {
                  className: 'exchange-coupon-linetop',
                  style: (0, _tools.convertLineStyleData)('background:' + style.secColor)
                }) : couponDetail.recv_status == 0 && React.createElement('div', {
                  className: 'exchange-coupon-linetop',
                  style: (0, _tools.convertLineStyleData)('background-color:#CCCCCC')
                }),
                React.createElement(
                  'div',
                  {
                    className: 'exchange-coupon-top',
                    style: (0, _tools.convertLineStyleData)('background-color: ' + style.lineBackgroundColor)
                  },
                  React.createElement(
                    'div',
                    { className: 'exchange-coupon-left' },
                    React.createElement(
                      'div',
                      { className: 'exchange-coupon-left-first' },
                      couponDetail.title
                    ),
                    couponDetail.recv_status == 1 ? React.createElement(
                      'div',
                      {
                        className: 'exchange-coupon-left-second',
                        style: (0, _tools.convertLineStyleData)('color:' + (style.strStyle && style.strStyle.color) + ';font-size:' + (style.strStyle && style.strStyle['font-size']))
                      },
                      couponDetail.exchange_condition.price > 0 && React.createElement(
                        'span',
                        null,
                        '¥' + couponDetail.exchange_condition.price
                      ),
                      couponDetail.exchange_condition.price > 0 && !!+couponDetail.exchange_condition.integral && couponDetail.exchange_condition.integral > 0 && React.createElement(
                        'span',
                        null,
                        '+'
                      ),
                      !!+couponDetail.exchange_condition.integral && couponDetail.exchange_condition.integral > 0 && React.createElement(
                        'span',
                        null,
                        couponDetail.exchange_condition.integral + '积分'
                      )
                    ) : couponDetail.recv_status == 0 && React.createElement(
                      'div',
                      {
                        className: 'exchange-coupon-left-second',
                        style: (0, _tools.convertLineStyleData)('color:#333')
                      },
                      couponDetail.exchange_condition.price > 0 && React.createElement(
                        'span',
                        null,
                        '¥' + couponDetail.exchange_condition.price
                      ),
                      couponDetail.exchange_condition.price > 0 && !!+couponDetail.exchange_condition.integral && couponDetail.exchange_condition.integral > 0 && React.createElement(
                        'span',
                        null,
                        '+'
                      ),
                      !!+couponDetail.exchange_condition.integral && couponDetail.exchange_condition.integral > 0 && React.createElement(
                        'span',
                        null,
                        couponDetail.exchange_condition.integral + '积分'
                      )
                    )
                  ),
                  couponDetail.type == 1 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u6298'
                    )
                  ) : couponDetail.type == 1 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u6298'
                    )
                  ) : couponDetail.type == 2 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u4EE3'
                    )
                  ) : couponDetail.type == 2 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u4EE3'
                    )
                  ) : couponDetail.type == 0 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u51CF'
                    )
                  ) : couponDetail.type == 0 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u51CF'
                    )
                  ) : couponDetail.type == 3 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u5151'
                    )
                  ) : couponDetail.type == 3 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u5151'
                    )
                  ) : couponDetail.type == 4 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u50A8'
                    )
                  ) : couponDetail.type == 4 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u50A8'
                    )
                  ) : couponDetail.type == 5 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u901A'
                    )
                  ) : couponDetail.type == 5 && couponDetail.recv_status == 0 ? React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u901A'
                    )
                  ) : couponDetail.type == 6 && couponDetail.recv_status == 1 ? React.createElement(
                    'div',
                    {
                      className: 'exchange-coupon-icon',
                      style: (0, _tools.convertLineStyleData)('background-color:' + style.secColor)
                    },
                    React.createElement(
                      'div',
                      null,
                      '\u6B21'
                    )
                  ) : couponDetail.type == 6 && couponDetail.recv_status == 0 && React.createElement(
                    'div',
                    { className: 'exchange-coupon-icon exchange-coupon-icon-used' },
                    React.createElement(
                      'div',
                      null,
                      '\u6B21'
                    )
                  ),
                  couponDetail.recv_status == 1 ? React.createElement('div', {
                    className: 'exchange-coupon-icon-wrapper',
                    style: (0, _tools.convertLineStyleData)('border-color:' + style.secColor)
                  }) : couponDetail.recv_status == 0 && React.createElement('div', {
                    className: 'exchange-coupon-icon-wrapper',
                    style: (0, _tools.convertLineStyleData)('background-color:#ccc')
                  })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'exchange-coupon-bottom',
                    style: (0, _tools.convertLineStyleData)('background-color: ' + style.lineBackgroundColor)
                  },
                  React.createElement('div', { className: 'exchange-coupon-cut', style: data ? (0, _tools.convertLineStyleData)(data.style) : {} }),
                  React.createElement(
                    'div',
                    { className: 'desc' },
                    '有效期 ' + (couponDetail.expire == '-1' ? couponDetail.start_use_date + '至' + couponDetail.end_use_date : couponDetail.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (couponDetail.react > 0 ? couponDetail.react + '天后' : '当天') + '生效，有效期' + (couponDetail.expire || '') + '天') + ' ' + (couponDetail.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (couponDetail.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + (couponDetail.start_use_time || '') + '-' + (couponDetail.end_use_time || '')
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-box' },
              React.createElement(
                'div',
                { className: 'single-box' },
                '\u5546\u54C1\u91D1\u989D',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  React.createElement(
                    'span',
                    null,
                    '¥' + (payInfo.original_price || '')
                  ),
                  payInfo.integral != 0 && React.createElement(
                    'span',
                    null,
                    '+'
                  ),
                  payInfo.integral != 0 && React.createElement(
                    'span',
                    null,
                    (payInfo.integral || '') + '积分'
                  )
                )
              ),
              (payInfo.benefit && payInfo.benefit.all_vip_benefit.length != 0 || payInfo.benefit && payInfo.benefit.coupon_benefit.length != 0) && React.createElement(
                'div',
                { onClick: this.showMemberDiscount },
                React.createElement(
                  'div',
                  { className: 'balance-switch' },
                  React.createElement(
                    'span',
                    null,
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    selectDiscountInfo.discount_title || selectDiscountInfo.title
                  )
                ),
                React.createElement(
                  'div',
                  {
                    hidden: selectDiscountIndex == 0,
                    className: 'balance-price'
                  },
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + payInfo.discount_price
                  )
                )
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'balance-switch' },
                  React.createElement(
                    'span',
                    null,
                    '\u4F7F\u7528\u50A8\u503C\u91D1'
                  ),
                  React.createElement(_switch2.default, {
                    className: 'pull-right',
                    checked: useBalance,
                    onChange: this.useBalanceChange
                  })
                ),
                React.createElement(
                  'div',
                  { hidden: !useBalance, className: 'balance-price' },
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + balance
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'bottom-nav' },
              React.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                '\u5408\u8BA1:',
                React.createElement(
                  'span',
                  { className: 'price-count' },
                  '¥' + (payInfo.final_price || '')
                )
              ),
              React.createElement(
                'form',
                null,
                React.createElement(
                  'button',
                  { type: 'button', onClick: this.confirmPayment },
                  '\u7ACB\u5373\u4ED8\u6B3E'
                )
              )
            )
          )
        ),
        React.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return ExchangeCouponDetailOrder;
}(_OfficialPage3.default);

exports.default = ExchangeCouponDetailOrder;

/***/ }),
/* 567 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(569);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CheckRowNumberDetail = function (_OfficialPage) {
  (0, _inherits3.default)(CheckRowNumberDetail, _OfficialPage);

  function CheckRowNumberDetail(props) {
    (0, _classCallCheck3.default)(this, CheckRowNumberDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CheckRowNumberDetail.__proto__ || Object.getPrototypeOf(CheckRowNumberDetail)).call(this, props));

    _this2.state = {
      orderData: '',
      orderInfo: '',
      userInfo: ''
    };
    _this2.orderId = '';
    _this2.franchiseeId = '';

    _this2.dataInitial = function () {
      _this2.getOrderDetail();
      _this2.getTostoreSetting();
      _this2.setData({
        userInfo: _app.appMethod.getUserInfo()
      });
    };

    _this2.getOrderDetail = function () {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0];
          that.setData({
            orderData: data,
            orderInfo: data.form_data
          });
        }
      });
    };

    _this2.getTostoreSetting = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
        success: function success(res) {
          if (res.status == 0) {
            _this.setData({
              toStoreSetting: res.data
            });
          }
        }
      });
    };

    document.title = '保存号单';
    return _this2;
  }

  (0, _createClass3.default)(CheckRowNumberDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
      this.franchiseeId = options.franchiseeId;
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          orderInfo = _state.orderInfo,
          toStoreSetting = _state.toStoreSetting,
          userInfo = _state.userInfo;

      return React.createElement(
        'div',
        { className: 'official-page check-row-number-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u4FDD\u5B58\u5355\u53F7' }),
        React.createElement(
          'div',
          { className: 'shop-setting' },
          React.createElement('img', { src: orderInfo.app_info && orderInfo.app_info.app_logo }),
          React.createElement(
            'span',
            { className: 'shop-name' },
            orderInfo.app_info && orderInfo.app_info.app_name
          )
        ),
        React.createElement(
          'div',
          { className: 'row-num-content-box' },
          React.createElement(
            'div',
            { className: 'row-num-content' },
            React.createElement('div', { className: 'people-icon' }),
            React.createElement('div', { className: 'top-background' }),
            React.createElement(
              'div',
              { className: 'take-num-content' },
              React.createElement(
                'div',
                { className: 'row-number-title', style: { fontSize: orderInfo.line_up_data && orderInfo.line_up_data.line_up_type_data.name.length > 3 ? '.60rem' : null } },
                orderInfo.line_up_data && orderInfo.line_up_data.line_up_type_data.name + orderInfo.line_up_data.queue_num_name || ''
              ),
              React.createElement(
                'div',
                { className: 'row-number-wait' },
                React.createElement('span', { className: 'line' }),
                (orderInfo.line_up_data && orderInfo.line_up_data.prepare_wait_time) > 0 ? '等待时间' + (orderInfo.line_up_data.prepare_wait_time > toStoreSetting.max_display_time ? ' >' + toStoreSetting.max_display_time : orderInfo.line_up_data.prepare_wait_time) + 'min' : '无需等待',
                React.createElement('span', { className: 'line' })
              )
            ),
            React.createElement(
              'div',
              { className: 'add-time' },
              React.createElement('span', { className: 'ico-moon icon-row-number-wait' }),
              '取号时间： ' + (orderInfo.add_time || '')
            )
          ),
          React.createElement(
            'div',
            { className: 'avatar' },
            React.createElement('img', { src: userInfo.cover_thumb })
          )
        ),
        React.createElement(
          'div',
          { className: 'dividing-line-box' },
          React.createElement('span', { className: 'tip-line' }),
          React.createElement('span', { className: 'tip-square' }),
          React.createElement('span', { className: 'tip-line' })
        ),
        React.createElement(
          'div',
          { className: 'shop-tip' },
          toStoreSetting && toStoreSetting.additional_info && toStoreSetting.additional_info.info
        )
      );
    }
  }]);
  return CheckRowNumberDetail;
}(_OfficialPage3.default);

exports.default = CheckRowNumberDetail;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(571);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewRowNumberOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewRowNumberOrder, _OfficialPage);

  function PreviewRowNumberOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewRowNumberOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewRowNumberOrder.__proto__ || Object.getPrototypeOf(PreviewRowNumberOrder)).call(this, props));

    _this2.state = {
      calculationData: '',
      lineUpSettingData: ''
    };
    _this2.lineUpId = '';
    _this2.franchiseeId = '';

    _this2.dataInitial = function () {
      _this2.getCalculationInfo();
      _this2.getLineUpSetting();
    };

    _this2.getCalculationInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.franchiseeId,
          line_up_type_id: _this2.lineUpId,
          is_balance: 0,
          selected_benefit: { no_use_benefit: 1 }
        },
        success: function success(res) {
          var info = res.data;
          _this.setData({
            calculationData: info
          });
        }
      });
    };

    _this2.getLineUpSetting = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
        data: {
          sub_app_id: that.franchiseeId
        },
        success: function success(res) {
          that.setData({
            lineUpSettingData: res.data
          });
        }
      });
    };

    _this2.confirmOrder = function (event) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/addLineUpOrder',
        method: 'post',
        data: {
          line_up_type_id: that.lineUpId,
          formId: event.detail.formId,
          sub_app_id: that.franchiseeId,
          selected_benefit: that.data.selectDiscountInfo,
          is_balance: 0
        },
        success: function success(res) {
          that.payOrder(res.data);
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var that = _this2;
      function turnToRowNumOrderDetail() {
        _app.appMethod.turnToPage('/orderMeal/pages/rowNumberOrderDetail/rowNumberOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''), 1);
      }
      if (_this2.data.calculationData.price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            turnToRowNumOrderDetail();
          },
          fail: function fail() {
            turnToRowNumOrderDetail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            turnToRowNumOrderDetail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.turnToRowNumOrderDetail = turnToRowNumOrderDetail
      //     param.goodsType = 0
      //     that.wxPay(param)
      //   },
      //   fail: function () {
      //     turnToRowNumOrderDetail()
      //   },
      //   successStatusAbnormal: function () {
      //     turnToRowNumOrderDetail()
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId,
        franchisee: that.franchisee_id,
        successUrl: '/rowNumberOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''),
        cancel: '/rowNumberOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : '')
      });
    };

    _this2.wxPay = function (param) {
      var that = _this2;
      _app.appMethod.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _app.appMethod.wxPaySuccess(param);
          param.turnToRowNumOrderDetail();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消',
              complete: function complete() {
                _app.appMethod.turnBack();
              }
            });
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败',
            complete: param.fail
          });
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    document.title = '确认支付';
    return _this2;
  }

  (0, _createClass3.default)(PreviewRowNumberOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.lineUpId = options.detail;
      this.franchiseeId = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          lineUpSettingData = _state.lineUpSettingData,
          calculationData = _state.calculationData;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page preview-row-number-order' },
          React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u652F\u4ED8' }),
          React.createElement(
            'div',
            { className: 'row-number-header' },
            React.createElement(
              'div',
              { className: 'shop-setting' },
              React.createElement('img', { src: lineUpSettingData.app_info && lineUpSettingData.app_info.app_logo }),
              React.createElement(
                'div',
                null,
                lineUpSettingData.app_info && lineUpSettingData.app_info.app_name
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u6392\u53F7\u8D39\uFF1A'
              ),
              React.createElement(
                'span',
                null,
                '¥' + lineUpSettingData.line_up_price
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'row-number-contain' },
            React.createElement(
              'div',
              null,
              '排号类型：' + (calculationData.line_up_data && calculationData.line_up_data.line_up_type_data.name || '')
            ),
            React.createElement(
              'div',
              null,
              '预计等待：' + ((calculationData.line_up_data && calculationData.line_up_data.line_up_count_info && calculationData.line_up_data.line_up_count_info[0].prepare_wait_time) > 0 ? (calculationData.line_up_data.line_up_count_info[0].prepare_wait_time > lineUpSettingData.max_display_time ? '>' + lineUpSettingData.max_display_time : calculationData.line_up_data.line_up_count_info[0].prepare_wait_time) + '分钟' : '无需等待')
            )
          ),
          React.createElement(
            'div',
            { className: 'row-number-contain' },
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                null,
                '\u5B9E\u4ED8\u91D1\u989D\uFF1A'
              ),
              React.createElement(
                'span',
                null,
                '¥' + (calculationData.price || '')
              )
            )
          ),
          React.createElement(
            'form',
            { className: 'confirm-order-wrap' },
            React.createElement(
              'button',
              { type: 'button', onClick: this.confirmOrder, className: 'comfirm-order' },
              '\u786E\u8BA4\u652F\u4ED8'
            )
          )
        )
      );
    }
  }]);
  return PreviewRowNumberOrder;
}(_OfficialPage3.default);

exports.default = PreviewRowNumberOrder;

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(573);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RowNumberOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(RowNumberOrderDetail, _OfficialPage);

  function RowNumberOrderDetail(props) {
    (0, _classCallCheck3.default)(this, RowNumberOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (RowNumberOrderDetail.__proto__ || Object.getPrototypeOf(RowNumberOrderDetail)).call(this, props));

    _this2.state = {
      orderId: '',
      orderInfo: '',
      orderData: '',
      isShowCancelWindow: false,
      toStoreSetting: '',
      billingStatus: ['未支付', '', '待使用', '', '退款申请中', '退款中', '已使用', '已关闭']
    };
    _this2.franchiseeId = '';

    _this2.dataInitial = function () {
      var _this = _this2;
      _this2.getTostoreSetting();
      setTimeout(function () {
        _this.getOrderDetail();
      }, 2000);
    };

    _this2.getOrderDetail = function () {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0];
          that.setData({
            orderData: data,
            orderInfo: data.form_data
          });
        }
      });
    };

    _this2.cancelTakeNumber = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/lineUpOrderRefund',
        method: 'post',
        data: {
          order_id: that.data.orderId
        },
        success: function success(res) {
          that.getOrderDetail();
          that.hideCancelWindow();
        }
      });
    };

    _this2.showCancelWindow = function () {
      _this2.setData({
        isShowCancelWindow: true
      });
    };

    _this2.hideCancelWindow = function () {
      _this2.setData({
        isShowCancelWindow: false
      });
    };

    _this2.goToCheckRowNunberDetail = function () {
      var that = _this2;
      _app.appMethod.turnToPage('/orderMeal/pages/checkRowNumberDetail/checkRowNumberDetail?orderId=' + that.data.orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''));
    };

    _this2.getTostoreSetting = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
        success: function success(res) {
          if (res.status == 0) {
            _this.setData({
              toStoreSetting: res.data
            });
          }
        }
      });
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(RowNumberOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail
      });
      this.franchiseeId = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          orderInfo = _state.orderInfo,
          billingStatus = _state.billingStatus,
          toStoreSetting = _state.toStoreSetting,
          isShowCancelWindow = _state.isShowCancelWindow;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page row-number-order-detail' },
          React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
          React.createElement(
            'div',
            { className: 'row-num-head' },
            React.createElement(
              'span',
              null,
              '\u6211\u7684\u6392\u53F7\uFF1A'
            ),
            React.createElement(
              'span',
              null,
              orderInfo.line_up_data && (orderInfo.line_up_data.queue_num_name || '未排号')
            )
          ),
          React.createElement(
            'div',
            { className: 'row-num-contain' },
            React.createElement(
              'div',
              null,
              '号单状态：' + (billingStatus[orderInfo['status']] || '')
            ),
            React.createElement(
              'div',
              null,
              '取号时间：' + (orderInfo['add_time'] || '')
            ),
            React.createElement(
              'div',
              null,
              '订单号：' + (orderInfo['order_id'] || '')
            )
          ),
          React.createElement(
            'div',
            { className: 'row-num-contain' },
            React.createElement(
              'div',
              null,
              '排号类型：' + (orderInfo && orderInfo.line_up_data && (orderInfo.line_up_data.line_up_type_data ? orderInfo.line_up_data.line_up_type_data.name : orderInfo.line_up_data.line_up_type_name))
            ),
            React.createElement(
              'div',
              null,
              '预计等待：' + ((orderInfo.line_up_data && orderInfo.line_up_data.prepare_wait_time) > 0 ? (orderInfo.line_up_data.prepare_wait_time > toStoreSetting.max_display_time ? '>' + toStoreSetting.max_display_time : orderInfo.line_up_data.prepare_wait_time) + '分钟' : '无需等待')
            )
          ),
          React.createElement(
            'div',
            { className: 'shop-name-contain' },
            React.createElement(
              'div',
              { className: 'shop-name' },
              React.createElement('img', { src: orderInfo.app_info && orderInfo.app_info.app_logo }),
              React.createElement(
                'span',
                null,
                orderInfo.app_info && orderInfo.app_info.app_name
              )
            ),
            React.createElement(
              'div',
              { className: 'cost-box' },
              React.createElement(
                'div',
                null,
                '\u6392\u53F7\u8D39\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + (orderInfo.original_price || '')
                )
              ),
              React.createElement(
                'div',
                null,
                '\u5B9E\u4ED8\u91D1\u989D\uFF1A',
                React.createElement(
                  'span',
                  { className: 'pull-right orange' },
                  '¥' + (orderInfo.total_price || '')
                )
              )
            )
          ),
          orderInfo['status'] == 2 && React.createElement(
            'div',
            { className: 'row-num-btn-box' },
            React.createElement(
              'span',
              { onClick: this.showCancelWindow },
              '\u53D6\u6D88\u6392\u961F'
            ),
            React.createElement(
              'span',
              { className: 'color-btn', onClick: this.goToCheckRowNunberDetail },
              '\u67E5\u770B\u53F7\u5355'
            )
          ),
          isShowCancelWindow && React.createElement(
            'div',
            { className: 'cancel-window' },
            React.createElement(
              'div',
              { className: 'cancel-window-box' },
              React.createElement(
                'div',
                { className: 'cancel-window-content' },
                '\u53D6\u6D88\u540E\u60A8\u7684\u6392\u53F7\u4FE1\u606F\u65E0\u6CD5\u6062\u590D\u6392\u53F7\u8D39\u5C06\u9000\u6B3E\u3002\u786E\u5B9A\u53D6\u6D88\uFF1F'
              ),
              React.createElement(
                'div',
                { className: 'cancel-window-btn' },
                React.createElement(
                  'span',
                  { onClick: this.cancelTakeNumber },
                  '\u53D6\u6D88\u6392\u53F7'
                ),
                React.createElement(
                  'span',
                  { className: 'orange', onClick: this.hideCancelWindow },
                  '\u7EE7\u7EED\u6392\u53F7'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RowNumberOrderDetail;
}(_OfficialPage3.default);

exports.default = RowNumberOrderDetail;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(105);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpGoodsDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GpGoodsDetail, _OfficialPage);

  function GpGoodsDetail(props) {
    var _this2$state;

    (0, _classCallCheck3.default)(this, GpGoodsDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GpGoodsDetail.__proto__ || Object.getPrototypeOf(GpGoodsDetail)).call(this, props));

    _this2.state = (_this2$state = {
      topNavBarData: {
        isDefault: 0,
        title: '商品详情'
      },
      addToShoppingCartHidden: true,
      addToGroupBuyCart: true,
      displayComment: true,
      imageOrVideo: 'image',
      ifOpenNewGroup: true,
      showTips: true,
      team_token: '',
      discountInfo: [],
      discountInfoArr: [],
      storeStyle: '',
      formid: [],
      isShowTopBar: true,
      selectModelInfo: {
        models: [],
        stock: '',
        price: '',
        virtualPrice: '',
        buyCount: 1,
        models_text: '',
        leader_price: 0,
        member_price: 0,
        num_of_people: 0,
        groupBuyCount: 1,
        groupNum: ''
      },
      progress: '',
      teamInfo: {
        team_list: [],
        is_more: 1,
        curpage: 1,
        loading: false
      }
    }, (0, _defineProperty3.default)(_this2$state, 'imageOrVideo', 'image'), (0, _defineProperty3.default)(_this2$state, 'scrollType', 'goods'), (0, _defineProperty3.default)(_this2$state, 'carouselCurrentIndex', 1), (0, _defineProperty3.default)(_this2$state, 'isParticipate', false), (0, _defineProperty3.default)(_this2$state, 'isGroupMask', false), (0, _defineProperty3.default)(_this2$state, 'defaultPhoto', ''), (0, _defineProperty3.default)(_this2$state, 'rect', []), (0, _defineProperty3.default)(_this2$state, 'screenHeight', 667), _this2$state);
    _this2.seckillFunc = [];
    _this2.page = 1;
    _this2.isMore = 1;
    _this2.allStock = '';

    _this2.loadAll = function () {
      var _this = _this2;
      _this.getAppECStoreConfig();
      _this.loadGoods();
    };

    _this2.loadGoods = function () {
      var _this = _this2,
          goodsModel = [],
          selectModels = [],
          modelStrs = {},
          description = '',
          modifySelectModels = '',
          price = 0,
          allStock = 0,
          selectStock,
          selectPrice,
          selectModelId,
          matchResult,
          selectVirtualPrice,
          selectText = '',
          selectGroupNum,
          leaderPrice,
          memberPrice,
          numOfPeople,
          i,
          j,
          selectImgurl = '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/getGoods',
        data: {
          activity_id: _this.data.activityId,
          goods_id: _this.data.goodsId,
          sub_shop_app_id: _this.data.franchiseeId || '',
          team_token: _this.data.team_token
        },
        header: {
          activity_id: _this.data.activityId
        },
        success: function success(res) {
          var goods = res.data.goods_info,
              groupData = res.data.group_buy_goods_info,
              discountInfo = groupData.discount_info,
              discountInfoArr = [],
              progress = Number(res.data.current_user_count / res.data.max_user_num) * 100,
              team_token = res.data.team_token,
              compid = 'goodsData';
          goods.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          description = goods.description;
          goods.server_time = res.current_time;
          goods.seckill_end_time = _util2.default.formatTime(new Date(res.data.end_date * 1000));
          goods.seckill_start_time = _util2.default.formatTime(new Date(res.data.start_date * 1000));
          goods.status = res.data.status;
          if (goods.status == 0 || goods.status == 1 || goods.status == 2) {
            _this.downcount = _this.beforeGroupDownCount(goods, res.data, _this, 'goodsInfo');
          } else if (goods.status == 3) {
            if (res.data.end_date != '-1') {
              _this.downcount = _this.duringGroupDownCount(goods, _this, 'goodsInfo');
            }
          }
          description = description ? description.replace(/\u00A0|\u2028|\u2029|\uFEFF/g, '') : description;
          goods.description = description;
          goods.virtual_price = goods.virtual_price == '0.00' && goods.virtual_price ? '' : goods.virtual_price;
          for (var key in goods.model) {
            if (key) {
              var model = goods.model[key];
              goodsModel.push(model);
              if (model && model.subModelName) {
                modelStrs[model.id] = model.subModelName.join('、');
                selectModels.push(model.subModelId[0]);
                modifySelectModels = selectModels.toString();
                selectText += '“' + model.subModelName[0] + '” ';
              }
            }
          }
          if (goods.model_items.length) {
            var items = goods.model_items;
            for (i = 0, j = items.length; i < j; i++) {
              price = items[i].price;
              goods.highPrice = goods.highPrice > price ? goods.highPrice : price;
              goods.lowPrice = goods.lowPrice < price ? goods.lowPrice : price;
              allStock += Number(items[i].stock);
              if (i == 0) {
                selectPrice = price;
                selectGroupNum = Number(items[i].num_of_people);
                memberPrice = items[i].member_price || 0;
                leaderPrice = items[i].leader_price || 0;
                selectStock = items[0].stock;
                selectModelId = items[0].id;
                selectImgurl = items[i].img_url;
                selectVirtualPrice = items[i].virtual_price != '0.00' && items[i].virtual_price ? items[i].virtual_price : '';
              }
            }
            allStock = allStock / groupData.num_of_people.length;
          } else {
            selectPrice = goods.price;
            selectStock = goods.stock;
            selectImgurl = goods.cover;
            selectGroupNum = Number(discountInfo[0].num_of_people || groupData.goods_num);
            memberPrice = discountInfo[0].member_price || 0;
            leaderPrice = discountInfo[0].leader_price || 0;
            selectVirtualPrice = goods.virtual_price != '0.00' && goods.virtual_price ? goods.virtual_price : '';
          }
          for (var i = 0; i < discountInfo.length; i++) {
            if (discountInfo[i].model_id == selectModelId) {
              discountInfoArr.push(discountInfo[i]);
            }
          }
          goods.model = goodsModel;
          var expressSort = goods.goods_express_data.express_fee_sort;
          if (expressSort.length == 1) {
            var express = expressSort[0];
            if (express == 0) {
              goods.express_fee = '包邮';
            } else {
              goods.express_fee = express + '元';
            }
          } else {
            goods.express_fee = expressSort[0] + '~' + expressSort[1] + '元';
          }
          _this.setData({
            'selectModelInfo.models': selectModels || '',
            'selectModelInfo.stock': selectStock || '',
            'selectModelInfo.price': selectPrice || '',
            'selectModelInfo.groupNum': selectGroupNum || '',
            'selectModelInfo.modelId': selectModelId || '',
            'selectModelInfo.models_text': selectText || '',
            'selectModelInfo.imgurl': selectImgurl || '',
            'selectModelInfo.virtualPrice': selectVirtualPrice || '',
            'selectModelInfo.leader_price': leaderPrice || 0,
            'selectModelInfo.member_price': memberPrice || 0,
            'selectModelInfo.num_of_people': selectGroupNum,
            goods: res.data,
            goodsInfo: goods,
            discountInfoArr: discountInfoArr,
            team_token: team_token || '',
            groupInfo: groupData,
            discountInfo: groupData.discount_info,
            progress: progress
          });
          _this.getAssessList(0, 1);
          if (res.data.type == '4' || res.data.type == '3') {} else {
            _this.loadTeamList(goods.id, groupData.activity_id, _this2.pageSize);
          }
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config,
          hidestock: res.detail_fields && res.detail_fields.stock == 0 ? true : false,
          isShowVirtualPrice: res.detail_fields && res.detail_fields.virtual_price == 1 ? true : false
        });
      }, _this2.data.franchiseeId);
    };

    _this2.beforeGroupDownCount = function (formData, res, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 3;
          newData[path + '.current_status'] = 3;
          newData[path + '.server_time'] = formData.seckill_start_time;
          page.setData(newData);
          page.loadGoods();
          formData.server_time = formData.seckill_start_time;
          if (res.end_date != '-1') {
            _this.downcount = _this.duringGroupDownCount(formData, page, path);
          }
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.duringGroupDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 4;
          newData[path + '.current_status'] = 4;
          page.setData(newData);
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.loadTeamList = function (goodsId, activityId) {
      var _this = _this2,
          teamInfo = _this2.data.teamInfo;
      if (teamInfo.is_more == 0 && teamInfo.loading) {
        return;
      }
      _this2.setData({
        'teamInfo.loading': true
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/getTeamListByGoods',
        data: {
          activity_id: activityId,
          goods_id: goodsId,
          sub_shop_app_id: _this.data.franchiseeId || '',
          page: _this2.page,
          page_size: 2
        },
        success: function success(res) {
          var rdata = res.data,
              newdata = {},
              teamList = teamInfo.team_list,
              length = teamList.length,
              downcountArr = _this.downcountArr || [];

          var _loop = function _loop(i) {
            var f = rdata[i],
                dc = void 0,
                teamLen = i + length;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            f.server_time = res.current_time;
            f.seckill_end_time = _util2.default.formatTime(new Date(f.expired_time * 1000));
            var path = 'teamInfo.team_list[' + teamLen + ']';
            dc = _app.appMethod.seckillDownCount({
              startTime: f.server_time,
              endTime: f.seckill_end_time,
              callback: function callback() {
                var data = {};
                data[path + '.current_status'] = 3;
                data['teamInfo.count'] = teamInfo.count - 1;
                _this.setData(data);
              }
            }, _this, path + '.downCount');
            dc && downcountArr.push(dc);
          };

          for (var i = 0; i < rdata.length; i++) {
            _loop(i);
          }
          newdata['teamInfo.team_list'] = teamList.concat(res.data);
          newdata['teamInfo.count'] = res.count;
          newdata['teamInfo.is_more'] = res.is_more;
          newdata['teamInfo.curpage'] = 1;
          newdata['teamInfo.loading'] = false;
          _this.downcountArr = downcountArr;
          _this.setData(newdata);
          _this.page++;
          _this.getRect();
        }
      });
    };

    _this2.showMoreTeams = function () {
      var pageSize = 10 + _this2.pageSize;
      _this2.loadTeamList(_this2.data.goodsId, _this2.data.activityId, pageSize);
      _this2.pageSize = pageSize;
    };

    _this2.singleBuy = function () {
      _this2.showCartHidden();
      _this2.setData({
        isGroupMask: false,
        isShowTopBar: false
      });
    };

    _this2.showProductSpecify = function () {
      _this2.showCartHidden();
      _this2.setData({
        isGroupMask: true
      });
    };

    _this2.groupBuy = function () {
      _this2.showCartHidden();
      _this2.setData({
        isGroupMask: true
      });
    };

    _this2.showCartHidden = function () {
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: true,
        imageOrVideo: 'image'
      });
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true,
        isShowTopBar: true
      });
    };

    _this2.participateGroup = function (e) {
      var dataset = e.currentTarget.dataset;
      if (dataset.joined == '1') {
        if (dataset.type == '1') {
          _app.appMethod.showModal({
            content: '您已参加过拼团活动，无法参加该新人团'
          });
          return;
        } else {
          _app.appMethod.showModal({
            content: '您已参加过该团，不能重新参团'
          });
          return;
        }
      }
      _this2.setData({
        addToGroupBuyCart: false,
        ifOpenNewGroup: false,
        isParticipate: true,
        isShowTopBar: false,
        'selectModelInfo.groupNum': e.currentTarget.dataset.num,
        team_token: e.currentTarget.dataset.token
      });
      _this2.resetSelectCountPrice();
    };

    _this2.hideGroupBuyCart = function () {
      _this2.setData({
        addToGroupBuyCart: true,
        isShowTopBar: true
      });
    };

    _this2.showMoreTips = function () {
      var showTips = !_this2.data.showTips;
      _this2.setData({
        showTips: showTips
      });
    };

    _this2.hideMask = function () {
      _this2.setData({
        showTips: true
      });
    };

    _this2.getRect = function () {
      _this2.selectQuery('goods');
      _this2.selectQuery('group');
      _this2.selectQuery('comment');
      _this2.selectQuery('detail');
    };

    _this2.selectQuery = function (id) {
      var _this = _this2;
      var idIndex = {
        goods: 0,
        group: 1,
        comment: 2,
        detail: 3
      };
      _app.appMethod.getBoundingClientRect('#' + id, function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            res = _ref2[0];

        var newdata = {},
            compid = id;
        newdata['rect[' + idIndex[compid] + '].top'] = res ? res.top : 0;
        newdata['rect[' + idIndex[compid] + '].name'] = compid;
        _this.setData(newdata);
      });
      document.documentElement.scrollTop = document.documentElement.scrollTop;
      document.body.scrollTop = document.body.scrollTop;
    };

    _this2.goToPlaylaws = function () {
      var path = '/group/pages/gpplaylaws/gpplaylaws?activityType=' + _this2.data.goods.type + '&autoRefund=' + _this2.data.goods.auto_refund + '&refundMode=' + _this2.data.goods.refund_mode + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(path);
      });
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true,
        isShowTopBar: true
      });
    };

    _this2.carouselIndex = function (index) {
      _this2.setData({
        carouselCurrentIndex: index + 1
      });
    };

    _this2.showQRCodeComponent = function () {
      var that = _this2;
      var goodsInfo = _this2.data.goodsInfo;
      var groupInfo = _this2.data.groupInfo;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/getShareQRCode',
        data: {
          goods_id: that.data.goodsId,
          activity_id: that.data.activityId,
          sub_shop_app_id: that.data.franchiseeId || '',
          virtual_price: goodsInfo.virtual_price = '0.00' && goodsInfo.virtual_price ? goodsInfo.price : goodsInfo.virtual_price,
          type: 6,
          text: goodsInfo.title,
          price: groupInfo.group_buy_price,
          goods_img: goodsInfo.img_urls ? goodsInfo.img_urls[0] : goodsInfo.cover,
          user_token: _app.appMethod.globalData.PromotionUserToken || ''
        },
        success: function success(res) {
          // animation.bottom('0').step()
          // that.setData({
          //   'pageQRCodeData.shareDialogShow': 0,
          //   'pageQRCodeData.shareMenuShow': true,
          //   'pageQRCodeData.goodsInfo': res.data,
          //   'pageQRCodeData.animation': animation.export()
          // })
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': res.data
            }
          });
        }
      });
    };

    _this2.getAssessList = function (commnetType, page, append) {
      var that = _this2;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          idx_arr: {
            idx: 'level',
            idx_value: commnetType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this2.data.franchiseeId || ''
        },
        success: function success(res) {
          var commentData = res.data;
          if (append) {
            commentData = that.data.commentArr.concat(commentData);
          }
          that.setData({
            commentArr: commentData,
            commentNums: res.num,
            commentPage: that.data.commentPage + 1,
            commentExample: res.data[0] || '',
            commentTotalPage: res.total_page,
            displayComment: +res.num[0] > 0 ? false : true,
            'rect[2].isShow': +res.num[0] > 0
          });
        }
      });
    };

    _this2.selectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModelsInfo = _this2.data.selectModelInfo,
          selectModels = _this2.data.selectModelInfo.models,
          model = _this2.data.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['selectModelInfo.models'] = selectModels;
      data['selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var selectModelIds = _this2.data.selectModelInfo.models.join(','),
          modelItems = _this2.data.goodsInfo.model_items,
          discountInfo = _this2.data.discountInfo,
          groupType = _this2.data.goods.type,
          discountInfoArr = [],
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model) {
          if (modelItems[i].model == selectModelIds) {
            if (groupType == 4 || groupType != 4 && modelItems[i].num_of_people == _this2.data.selectModelInfo.groupNum) {
              // 特殊处理：抽奖团没有成团人数
              data['selectModelInfo.stock'] = modelItems[i].stock;
              data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price != '0.00' && modelItems[i].virtual_price ? modelItems[i].virtual_price || '' : '';
              data['selectModelInfo.price'] = modelItems[i].price;
              data['selectModelInfo.member_price'] = modelItems[i].member_price || 0;
              data['selectModelInfo.leader_price'] = modelItems[i].leader_price || 0;
              data['selectModelInfo.modelId'] = modelItems[i].id || '';
              data['selectModelInfo.imgurl'] = modelItems[i].img_url || '';
              break;
            }
          }
        } else {
          if (groupType == 4 || groupType != 4 && modelItems[i].num_of_people == _this2.data.selectModelInfo.groupNum) {
            data['selectModelInfo.stock'] = modelItems[i].stock;
            data['selectModelInfo.price'] = modelItems[i].price;
            data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price != '0.00' && modelItems[i].virtual_price ? modelItems[i].virtual_price : '';
            data['selectModelInfo.member_price'] = modelItems[i].member_price || 0;
            data['selectModelInfo.leader_price'] = modelItems[i].leader_price || 0;
            data['selectModelInfo.modelId'] = modelItems[i].id || '';
            data['selectModelInfo.imgurl'] = modelItems[i].img_url || '';
            break;
          }
        }
      }
      for (var _i = 0; _i < discountInfo.length; _i++) {
        if (discountInfo[_i].model_id == data['selectModelInfo.modelId'] || discountInfo[_i].model_id === undefined && !data['selectModelInfo.modelId']) {
          discountInfoArr.push(discountInfo[_i]);
        }
      }
      data['discountInfoArr'] = discountInfoArr;
      _this2.setData(data);
    };

    _this2.clickMinusButton = function (e) {
      var count = _this2.data.selectModelInfo.buyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count - 1,
        'selectModelInfo.groupBuyCount': count - 1
      });
    };

    _this2.sureJoinGroup = function (e) {
      var that = _this2;
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin({
          success: function success() {
            that.sureJoinGroup(e);
          }
        });
        return;
      }
      var franchiseeId = _this2.data.franchiseeId,
          selectmodel = JSON.stringify(_this2.data.selectModelInfo),
          goodsId = _this2.data.goodsId,
          activityId = _this2.data.activityId,
          modelId = _this2.data.selectModelInfo.modelId || '',
          num = _this2.data.selectModelInfo.groupBuyCount,
          numOfPeople = _this2.data.selectModelInfo.groupNum || '',
          sub_shop_app_id = franchiseeId || '',
          is_group_buy = 1,
          limit_buy = that.data.goods.user_limit_buy,
          team_token = that.data.team_token || '';
      if (_this2.data.selectModelInfo.stock == 0) {
        _app.appMethod.showModal({
          content: '商品库存不足'
        });
        return;
      }
      if (that.data.goods.type == 3 && that.data.goods.is_leader == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=appGroupBuy/addOrder',
          method: 'post',
          data: {
            goods_id: goodsId,
            activity_id: activityId,
            sub_shop_app_id: that.data.franchiseeId || _this2.data.groupInfo.parent_app_id || '',
            model_id: modelId || '',
            num: num,
            num_of_people: numOfPeople,
            team_token: team_token,
            select_benefit: '',
            is_balance: 0,
            use_balance: 0,
            address_id: ''
          },
          success: function success(res) {
            var data = res.data;
            if (res.status == 0) {
              if (that.data.cashOnDelivery) {
                var _pagePath = '/group/pages/gppaySuccess/gppaySuccess?detail=' + res.data.order_id + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&orderid=' + res.data.order_id + '&teamToken=' + res.data.team_token;
                that.saveUserFormId(function () {
                  _app.appMethod.turnToPage(_pagePath, 1);
                });
              } else {
                that.payOrder(res.data.order_id, res.data.team_token);
              }
            } else {
              _app.appMethod.showModal({
                content: res.data
              });
              return;
            }
          },
          fail: function fail() {
            that.requesting = false;
          },
          successStatusAbnormal: function successStatusAbnormal() {
            that.requesting = false;
          }
        });
      } else {
        var pagePath = '/group/pages/previewGroupOrder/previewGroupOrder?goodsid=' + goodsId + '&activityid=' + that.data.activityId + '&num=' + num + '&modelId=' + modelId + '&numOfPeople=' + numOfPeople + '&is_group=true' + '&group_buy_people=' + that.data.selectModelInfo.groupNum + '&is_group_buy=' + is_group_buy + '&limit_buy=' + limit_buy + '&selectmodel=' + selectmodel + '&groupType=' + that.data.goods.type + '&team_token=' + team_token + '&isFrom=true' + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '') + '&parent_app_id=' + _this2.data.groupInfo.parent_app_id;
        that.saveUserFormId(function () {
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          that.setData({
            addToGroupBuyCart: true,
            isShowTopBar: true
          });
          _app.appMethod.turnToPage(pagePath);
        });
      }
    };

    _this2.payOrder = function (orderId, teamToken) {
      var that = _this2;
      function paySuccess() {
        var pagePath = '/group/pages/gppaySuccess/gppaySuccess?detail=' + orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '') + '&is_group=' + !!that.is_group + '&teamToken=' + teamToken;
        if (!that.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId || ''
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              that.saveUserFormId(function () {
                _app.appMethod.turnToPage(pagePath, 1);
              });
            }
          });
        } else {
          that.saveUserFormId(function () {
            _app.appMethod.turnToPage(pagePath, 1);
          });
        }
      }
      function payFail() {
        that.saveUserFormId(function () {
          _app.appMethod.turnToPage('../pluginOrderDetail/pluginOrderDetail?order_id=' + orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : ''), 1);
        });
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            sub_shop_app_id: that.data.franchiseeId || '',
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId || ''
        },
        success: function success(res) {
          var param = res.data;
          param.orderId = orderId;
          param.success = paySuccess;
          param.goodsType = 0;
          param.fail = payFail;
          _app.appMethod.wxPay(param);
        },
        fail: function fail() {
          payFail();
        },
        successStatusAbnormal: function successStatusAbnormal() {
          payFail();
        }
      });
    };

    _this2.confirmPayment = function (e) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/addOrder',
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          activity_id: that.data.activityId,
          sub_shop_app_id: that.data.franchiseeId || _this2.data.groupInfo.parent_app_id || '',
          model_id: modelId = _this2.data.selectModelInfo.modelId || '',
          num: _this2.data.selectModelInfo.groupBuyCount,
          num_of_people: _this2.data.selectModelInfo.groupNum || '',
          team_token: that.data.team_token || '',
          formId: e.target.formId,
          select_benefit: that.data.selectDiscountInfo,
          is_balance: that.data.useBalance ? 1 : 0,
          is_self_delivery: that.data.is_self_delivery,
          self_delivery_app_store_id: that.data.is_self_delivery == 1 ? that.data.selectDelivery.id : '',
          remark: that.data.description,
          address_id: that.data.selectAddress.id || that.data.selectDelivery.id,
          is_pay_on_delivery: that.data.cashOnDelivery ? 1 : 0,
          additional_info: that.additional_info,
          express_fee: that.data.express_fee
        },
        success: function success(res) {
          var data = res.data;
          if (res.status == 0) {
            if (that.data.cashOnDelivery) {
              var pagePath = '/group/pages/gppaySuccess/gppaySuccess?detail=' + res.data.order_id + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '') + '&is_group=' + !!that.is_group + '&orderid=' + res.data.order_id + '&teamToken=' + res.data.team_token;
              that.saveUserFormId(function () {
                _app.appMethod.turnToPage(pagePath, 1);
              });
            } else {
              that.payOrder(res.data.order_id, res.data.team_token);
            }
          } else {
            _app.appMethod.showModal({
              content: res.data
            });
            return;
          }
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this2.clickPlusButton = function (e) {
      var type = e.currentTarget.dataset.type,
          selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          count = selectModelInfo.buyCount,
          limit_buy = +_this2.data.goods.user_limit_buy,
          stock = selectModelInfo.stock;
      if (limit_buy != 0 && selectModelInfo.buyCount >= limit_buy && type == 'group') {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        _this2.setData({
          'selectModelInfo.buyCount': limit_buy,
          'selectModelInfo.groupBuyCount': limit_buy
        });
        return;
      }
      if (count >= stock && _this2.data.goods.type != 4) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        _this2.setData({
          'selectModelInfo.buyCount': stock,
          'selectModelInfo.groupBuyCount': stock
        });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count + 1,
        'selectModelInfo.groupBuyCount': count + 1
      });
    };

    _this2.clickGroupMinusButton = function (e) {
      var count = _this2.data.selectModelInfo.groupBuyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectModelInfo.groupBuyCount': count - 1
      });
    };

    _this2.clickGroupPlusButton = function (e) {
      var selectModelInfo = _this2.data.selectModelInfo,
          count = selectModelInfo.groupBuyCount,
          stock = selectModelInfo.stock,
          max = _this2.data.goods.user_limit_buy;
      if (count >= stock || count >= max) {
        return;
      }
      _this2.setData({
        'selectModelInfo.groupBuyCount': count + 1
      });
    };

    _this2.selectGroupNum = function (e) {
      _this2.setData({
        'selectModelInfo.groupNum': e.currentTarget.dataset.num
      });
      _this2.resetSelectCountPrice();
    };

    _this2.inputBuyCount = function (e) {
      var count = +e.target.value,
          selectModelInfo = _this2.data.selectModelInfo,
          goodsInfo = _this2.data.goodsInfo,
          stock = +selectModelInfo.stock,
          limit_buy = +_this2.data.goods.user_limit_buy;
      if (count > limit_buy && limit_buy != 0) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        _this2.setData({
          'selectModelInfo.buyCount': +limit_buy,
          'selectModelInfo.groupBuyCount': +limit_buy
        });
        return;
      }
      if (count == 0) {
        _this2.setData({
          'selectModelInfo.buyCount': 1
        });
        return;
      }
      if (count >= stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        _this2.setData({
          'selectModelInfo.buyCount': +stock,
          'selectModelInfo.groupBuyCount': +stock
        });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': +count,
        'selectModelInfo.groupBuyCount': +count
      });
    };

    _this2.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.data.franchiseeId;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (p && p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({
            delta: 2
          });
        } else {
          customEvent.clickEventHandler['to-franchisee']({
            'franchisee-id': franchiseeId
          });
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({
          url: '/pages/' + router + '/' + router
        });
      }
    };

    _this2.changeImageOrVideo = function (event) {
      _this2.setData({
        videoPoster: false,
        imageOrVideo: event.currentTarget.dataset.type
      });
    };

    _this2.startPlayVideo = function () {
      var video = _app.appMethod.createVideoContext('carousel-video');
      _this2.setData({
        videoPoster: true
      });
      video.play();
    };

    _this2.addFavoriteGoods = function (event) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addFavoriteGoods',
        data: {
          form_id: event.target.formId,
          goods_id: _this.data.goodsId,
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        success: function success(res) {
          _this.setData({
            'goods.is_favorite': 1
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '收藏成功!',
            image: '/images/favorites.png'
          });
        }
      });
    };

    _this2.deleteFavoriteGoods = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteFavoriteGoods',
        method: 'post',
        data: {
          goods_id_arr: [_this.data.goodsId],
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        success: function success(res) {
          _this.setData({
            'goods.is_favorite': 0
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '取消收藏!',
            image: '/images/cancel-favorites.png'
          });
        }
      });
    };

    _this2.sureAddToShoppingCart = function () {
      if (_this2.data.goods.type == 4) {
        _app.appMethod.showModal({
          content: '参与抽奖商品不能加入购物车'
        });
        return;
      }
      var that = _this2,
          param = {
        goods_id: _this2.data.goodsId,
        model_id: _this2.data.selectModelInfo.modelId || '',
        num: _this2.data.selectModelInfo.buyCount,
        sub_shop_app_id: _this2.data.franchiseeId || '',
        is_seckill: _this2.data.isSeckill ? 1 : ''
      };
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '添加成功',
            icon: 'success'
          });
          setTimeout(function () {
            that.hiddeAddToShoppingCart();
          }, 1000);
        }
      });
    };

    _this2.showGroupBuy = function () {
      var team_token = _this2.data.team_token,
          goodsInfo = _this2.data.goodsInfo;
      if (goodsInfo.status == 4) {
        _app.appMethod.showModal({
          content: '当前拼团已结束'
        });
        return;
      }
      if (goodsInfo.status == 0 || goodsInfo.status == 1 || goodsInfo.status == 2) {
        _app.appMethod.showModal({
          content: '当前拼团活动未开启'
        });
        return;
      }
      if (_this2.data.goods.type != 4) {
        team_token = '';
      }
      _this2.setData({
        team_token: team_token,
        addToGroupBuyCart: false,
        ifOpenNewGroup: false,
        isParticipate: false,
        isShowTopBar: false
      });
    };

    _this2.buyDirectlyNextStep = function (e) {
      var franchiseeId = _this2.data.franchiseeId,
          that = _this2,
          param = {
        goods_id: _this2.data.goodsId,
        model_id: _this2.data.selectModelInfo.modelId || '',
        num: _this2.data.selectModelInfo.buyCount,
        sub_shop_app_id: franchiseeId || '',
        is_seckill: _this2.data.isSeckill ? 1 : ''
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          var cart_arr = [res.data],
              pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cart_arr);
          that.saveUserFormId(function () {
            franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
            that.hiddeAddToShoppingCart();
            _app.appMethod.turnToPage(pagePath);
          });
        }
      });
    };

    _this2.remainMe = function (e) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/careActivity',
        data: {
          data_id: _this.data.goodsId,
          activity_id: _this.data.activityId,
          sub_shop_app_id: _this.data.franchiseeId || '',
          activity_type: 0
        },
        success: function success(res) {
          var newdata = {};
          _app.appMethod.showToast({
            title: '提醒成功！',
            duration: 2000
          });
          newdata['goodsInfo.status'] = 2;
          _this.setData(newdata);
        }
      });
      _this.saveUserFormId();
    };

    _this2.goToCommentPage = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/goodsComment/goodsComment?detail=' + _this2.data.goodsId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath);
      });
    };

    _this2.clickCommentLabel = function (e) {
      var commentType = e.target.dataset.type,
          data = {};
      data.commentPage = 1;
      data.commnetType = commentType;
      _this2.setData(data);
      _this2.getAssessList(commentType, 1);
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (callback) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchiseeId || '',
          form_id: _this.data.formid || []
        },
        complete: function complete() {
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    _this2.soonOpen = function () {
      _app.appMethod.showModal({
        content: '当前拼团未开启'
      });
    };

    _this2.onPullDownRefresh = function () {};

    _this2.onReachBottom = function () {};

    _this2.onPageScroll = function (e) {
      var officialPageDom = _this2.officialPageRef.current;
      e = (0, _extends3.default)({}, e, {
        scrollTop: officialPageDom.scrollTop,
        scrollLeft: officialPageDom.scrollLeft,
        scrollWidth: officialPageDom.scrollWidth,
        scrollHeight: officialPageDom.scrollHeight
      });
      var _this = _this2,
          rect = _this2.data.rect,
          scrollTop = e.scrollTop,
          oldScrollTop = _this2.data.scrollTop,
          slidMask,
          topName = 'goods',
          showBottomKan,
          screenHeight = _this2.data.screenHeight;
      for (var i = 0; i < rect.length; i++) {
        var topData = rect[i];
        if (topData && scrollTop + 40 > topData.top && topData.isShow !== false) {
          topName = topData.name;
        }
      }
      _this2.setData({
        scrollType: topName,
        scrollTop: scrollTop
      });
    };

    _this2.onShareAppMessage = function () {
      var that = _this2,
          goodsId = _this2.data.goodsId,
          groupInfo = _this2.data.groupInfo,
          activityId = _this2.data.activityId,
          contact = _this2.data.contact,
          franchiseeId = _this2.data.franchiseeId,
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          url = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + goodsId + '&activity_id=' + activityId + '&contact=' + contact + (franchiseeId ? '&franchisee=' + franchiseeId : '') + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : '') + urlPromotion,
          share_cover = groupInfo.share_cover ? groupInfo.share_cover : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
          nickname = _app.appMethod.getUserInfo('nickname'),
          title = groupInfo.share_title ? groupInfo.share_title : (nickname ? nickname + ' 喊你' : '') + '拼单啦~ ' + _this2.data.groupInfo.group_buy_price + '元拼' + _this2.data.goodsInfo.title + '，火爆抢购中......';
      return _app.appMethod.shareAppMessage({
        title: title,
        path: url,
        imageUrl: share_cover,
        success: function success(addTime) {
          _app.appMethod.showToast({
            title: '转发成功',
            duration: 500
          });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: {
              sub_shop_app_id: _this.data.franchiseeId,
              add_time: addTime
            },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    document.title = '商品详情';
    return _this2;
  }

  (0, _createClass3.default)(GpGoodsDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var _this = this,
          goodsId = options.goods_id,
          franchiseeId = options.franchisee,
          activityId = options.activity_id,
          defaultPhoto = _app.appMethod.getDefaultPhoto();
      var height = _app.appMethod.getSystemInfoData().screenHeight || 667;
      _this.setData({
        team_token: options.teamToken || '',
        goodsId: goodsId || '',
        franchiseeId: franchiseeId || '',
        defaultPhoto: defaultPhoto,
        activityId: activityId,
        screenHeight: height,
        sessionFrom: options.franchisee || _app.appMethod.getAppId() || '',
        'topNavBarData.totalHeight': _app.appMethod.globalData.topNavBarHeight || 0
      });
      _this.loadAll();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {}
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcount) {
        this.downcount.clear();
      }
      if (this.downcountArr && this.downcountArr.length) {
        this.downcountArr = this.downcountArr.concat().reverse();
        for (var i = 0; i < this.downcountArr.length; i++) {
          this.downcountArr[i] && this.downcountArr[i].clear();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this,
          _React$createElement,
          _React$createElement2;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          topNavBarData = _state.topNavBarData,
          pageQRCodeData = _state.pageQRCodeData,
          scrollType = _state.scrollType,
          goodsInfo = _state.goodsInfo,
          displayComment = _state.displayComment,
          imageOrVideo = _state.imageOrVideo,
          videoPoster = _state.videoPoster,
          status = _state.status,
          groupInfo = _state.groupInfo,
          goods = _state.goods,
          progress = _state.progress,
          teamInfo = _state.teamInfo,
          commentNums = _state.commentNums,
          commentExample = _state.commentExample,
          defaultPhoto = _state.defaultPhoto,
          storeStyle = _state.storeStyle,
          franchiseeId = _state.franchiseeId,
          sessionFrom = _state.sessionFrom,
          addToShoppingCartHidden = _state.addToShoppingCartHidden,
          selectModelInfo = _state.selectModelInfo,
          isShowVirtualPrice = _state.isShowVirtualPrice,
          isSeckill = _state.isSeckill,
          addToGroupBuyCart = _state.addToGroupBuyCart,
          isParticipate = _state.isParticipate,
          showTips = _state.showTips,
          discountInfoArr = _state.discountInfoArr,
          godos = _state.godos;

      return React.createElement(
        'div',
        { ref: this.officialPageRef, className: 'official-page gp-goods-detail', onScroll: this.onPageScroll },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BE6\u60C5' }),
        React.createElement(
          'div',
          {
            className: 'transition',
            style: (0, _tools.convertLineStyleData)('top:' + topNavBarData.totalHeight + 'px;')
          },
          React.createElement(
            'div',
            { 'data-type': 'goods', className: 'isRelative' },
            React.createElement(
              'span',
              { className: scrollType == 'goods' ? 'active' : '' },
              '\u5546\u54C1'
            )
          ),
          React.createElement(
            'div',
            { 'data-type': 'group', className: 'isRelative' },
            React.createElement(
              'span',
              { className: scrollType == 'group' ? 'active' : '' },
              '\u62FC\u56E2'
            )
          ),
          !displayComment && React.createElement(
            'div',
            { 'data-type': 'comment', className: 'isRelative' },
            React.createElement(
              'span',
              { className: scrollType == 'comment' ? 'active' : '' },
              '\u8BC4\u8BBA'
            )
          ),
          React.createElement(
            'div',
            { 'data-type': 'detail', className: 'isRelative' },
            React.createElement(
              'span',
              { className: scrollType == 'detail' ? 'active' : '' },
              '\u8BE6\u60C5'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'goods-main' },
          React.createElement(
            'div',
            { className: 'collage-goodsDetail' },
            React.createElement(
              'div',
              { className: 'collage-section  goods-message', id: 'goods' },
              imageOrVideo == 'image' && React.createElement(
                'div',
                { className: 'image-carousel-container' },
                !(goodsInfo && goodsInfo.img_urls) ? React.createElement(
                  'div',
                  { className: 'goods-cover-container' },
                  React.createElement('img', {
                    'data-src': goodsInfo && goodsInfo.cover,
                    onClick: this.clickPlusImages,
                    src: goodsInfo && goodsInfo.cover
                  })
                ) : React.createElement(
                  'div',
                  { className: 'slick-carousel-container' },
                  React.createElement(
                    _carousel2.default,
                    {
                      dots: false,
                      infinite: true,
                      autoplay: true,
                      autoplayInterval: 5000,
                      afterChange: this.carouselIndex },
                    goodsInfo.img_urls.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement('img', {
                          'data-src': item,
                          'data-srcarr': JSON.stringify(goodsInfo.img_urls),
                          onClick: _this3.clickPlusImages,
                          className: 'slide-image',
                          src: item,
                          onLoad: function onLoad() {
                            window.dispatchEvent(new Event('resize'));
                          } })
                      );
                    })
                  )
                ),
                goodsInfo && goodsInfo.video_url && React.createElement(
                  'div',
                  { className: 'image-video-menu' },
                  React.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'image' ? 'active' : '',
                      'data-type': 'image',
                      onClick: this.changeImageOrVideo
                    },
                    '\u56FE\u7247'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: imageOrVideo == 'video' ? 'active' : '',
                      'data-type': 'video',
                      onClick: this.changeImageOrVideo
                    },
                    '\u89C6\u9891'
                  )
                )
              ),
              goodsInfo && goodsInfo.video_url && imageOrVideo == 'video' && React.createElement(
                'div',
                { className: 'video-carousel-container' },
                React.createElement(
                  'video',
                  {
                    src: goodsInfo.video_url,
                    id: 'carousel-video',
                    hidden: !videoPoster
                  },
                  goodsInfo.video_url && React.createElement(
                    CoverView,
                    { className: 'image-video-menu' },
                    React.createElement(
                      CoverView,
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    React.createElement(
                      CoverView,
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'videoele-cover-view', hidden: videoPoster },
                  React.createElement(
                    'div',
                    { className: 'videoele-poster-wrap' },
                    React.createElement('img', {
                      className: 'videoele-poster',
                      src: goodsInfo.video_img,
                      mode: 'scaleToFill'
                    })
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'videoele-play-icon',
                      onClick: this.startPlayVideo
                    },
                    React.createElement('img', {
                      className: 'videoele-play-image',
                      src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                      mode: 'scaleToFill'
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'image-video-menu' },
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'collage-price-info ' + (status == 1 ? 'ready' : 'start')
                },
                React.createElement(
                  'div',
                  { className: 'content-wrap' },
                  React.createElement(
                    'div',
                    { className: 'min-price' },
                    React.createElement(
                      'span',
                      null,
                      '\xA5'
                    ),
                    React.createElement(
                      'span',
                      null,
                      groupInfo && groupInfo.group_buy_price
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'origin-price' },
                    '¥' + (goodsInfo && (goodsInfo.virtual_price || goodsInfo.goods_price))
                  ),
                  React.createElement(
                    'div',
                    { className: 'remaining-time' },
                    goodsInfo && (goodsInfo.status == 0 || goodsInfo.status == 1 || goodsInfo.status == 2) ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        null,
                        '\u8DDD\u62FC\u8D2D\u5F00\u59CB\u8FD8\u5269 :'
                      ),
                      React.createElement(
                        'div',
                        null,
                        goodsInfo.downCount.days != '00' && goodsInfo.downCount.days != '0' && React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            null,
                            goodsInfo.downCount.days
                          ),
                          React.createElement(
                            'span',
                            null,
                            '\u5929'
                          )
                        ),
                        React.createElement(
                          'span',
                          null,
                          goodsInfo.downCount.hours
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          goodsInfo.downCount.minutes
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          goodsInfo.downCount.seconds
                        )
                      )
                    ) : goodsInfo && goodsInfo.status == 3 && goods.end_date != '-1' && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        null,
                        '\u8DDD\u62FC\u8D2D\u7ED3\u675F\u8FD8\u5269 :'
                      ),
                      React.createElement(
                        'div',
                        null,
                        goodsInfo.downCount.days != '00' && goodsInfo.downCount.days != '0' && React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            null,
                            goodsInfo.downCount.days
                          ),
                          React.createElement(
                            'span',
                            null,
                            '\u5929'
                          )
                        ),
                        React.createElement(
                          'span',
                          null,
                          goodsInfo.downCount.hours
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          goodsInfo.downCount.minutes
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          goodsInfo.downCount.seconds
                        )
                      )
                    )
                  )
                ),
                React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/detail-mask.png' })
              ),
              React.createElement(
                'div',
                { className: 'collage-title-info' },
                React.createElement(
                  'div',
                  { className: 'title-info' },
                  React.createElement(
                    'div',
                    { className: 'goods-title' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      React.createElement(
                        'div',
                        { className: 'classify-type' },
                        React.createElement(
                          'div',
                          null,
                          React.createElement('i', { className: 'ico-moon icon-number-people' })
                        ),
                        React.createElement(
                          'span',
                          null,
                          goods && goods.type == 0 ? groupInfo.num_of_people.length > 1 ? '多人团' : groupInfo.num_of_people[0] + '人团' : goods && goods.type == 1 ? '新人团' : goods && goods.type == 2 ? '阶梯团' : goods && goods.type == 3 ? '帮帮团' : '抽奖团'
                        )
                      ),
                      goodsInfo && goodsInfo.title
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'share-jbtn isRelative',
                        onClick: this.showQRCodeComponent
                      },
                      React.createElement('span', { className: 'ico-moon icon-news-sharefriends' })
                    )
                  ),
                  goods && goods.type != 4 && React.createElement(
                    'div',
                    null,
                    goods && goods.group_buy_discount_tips
                  )
                )
              ),
              goods && goods.successful_team_leader.length > 0 && React.createElement(
                'div',
                { className: 'successful_team_leader' },
                React.createElement(
                  'div',
                  null,
                  goods.successful_team_leader.map(function (item, index) {
                    return React.createElement('img', { src: item, key: index });
                  })
                ),
                React.createElement(
                  'div',
                  null,
                  '\u62FC\u56E2\u6210\u529F\u5566'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section' },
              React.createElement(
                'div',
                { className: 'express-info' },
                '运费 : ' + (goodsInfo && goodsInfo.express_fee)
              ),
              React.createElement(
                'div',
                {
                  className: 'specification-info isRelative',
                  onClick: this.showGroupBuy
                },
                React.createElement(
                  'div',
                  null,
                  '\u9009\u62E9\u4EA7\u54C1\u89C4\u683C'
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              React.createElement(
                'div',
                { className: 'goods-other-info' },
                React.createElement(
                  'label',
                  null,
                  '\u53D6\u8D27\u65B9\u5F0F'
                ),
                React.createElement(
                  'div',
                  { className: 'address-pick-up' },
                  goodsInfo && goodsInfo.pick_up_type.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: item },
                      React.createElement('span', { className: 'ico-moon icon-goods-support-delivery suporrt' }),
                      React.createElement(
                        'span',
                        null,
                        item == 1 ? '快递' : item == 2 ? '同城' : '自提'
                      )
                    );
                  })
                )
              )
            ),
            goods && goods.type == 4 && goodsInfo.status == 3 && React.createElement(
              'div',
              { className: 'collage-section progress-message' },
              React.createElement(
                'div',
                { className: 'progress' },
                React.createElement('div', {
                  className: 'success',
                  style: (0, _tools.convertLineStyleData)('width:' + progress + '%;')
                })
              ),
              React.createElement(
                'div',
                { className: 'tip' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    goods.current_user_count
                  ),
                  '\u4EBA\u5DF2\u53C2\u4E0E'
                ),
                React.createElement(
                  'div',
                  null,
                  '满' + goods.max_user_num + '人开奖'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section', id: 'group' },
              teamInfo.count == 0 || goods && goods.type == 3 || goods && goods.type == 4 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    className: 'collage-play-title isRelative',
                    onClick: this.goToPlaylaws
                  },
                  React.createElement(
                    'div',
                    null,
                    '\u62FC\u56E2\u73A9\u6CD5'
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-category' },
                  goods.type == 0 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-regiment-leader icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5F00\u56E2'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-invite-friends  icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u9080\u8BF7\u597D\u53CB'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-group-success  icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u62FC\u56E2\u6210\u529F'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-wait-shipment  icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u7B49\u5F85\u53D1\u8D27'
                      )
                    )
                  ) : goods.type == 1 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-regiment-leader icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5F00\u56E2'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-invite-news icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u9080\u8BF7\u65B0\u4EBA'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-group-success icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u62FC\u56E2\u6210\u529F'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-wait-shipment icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u7B49\u5F85\u53D1\u8D27'
                      )
                    )
                  ) : goods.type == 2 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-regiment-leader icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5F00\u56E2'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-invite-friends icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u9080\u8BF7\u597D\u53CB'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-peoplemore-pricelow icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u4EBA\u6570\u591A\u4EF7\u683C\u4F4E'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-wait-shipment icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u7B49\u5F85\u53D1\u8D27'
                      )
                    )
                  ) : goods.type == 3 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-regiment-leader icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5F00\u56E2'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-friends-pay icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u597D\u53CB\u4EE3\u4ED8'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-reach-num icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u8FBE\u5230\u4EBA\u6570'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon  icon-wait-shipment icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5355\u72EC\u53D1\u8D27'
                      )
                    )
                  ) : goods.type == 4 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon  icon-regiment-leader icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u56E2\u957F\u5F00\u56E2'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-invite-friends icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u9080\u8BF7\u597D\u53CB'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-reach-num icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u8FBE\u5230\u4EBA\u6570'
                      )
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-draw-lucky icon-step' }),
                      React.createElement(
                        'div',
                        null,
                        '\u62BD\u53D6\u5E78\u8FD0\u513F'
                      )
                    )
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'collage-section list-message' },
                  React.createElement(
                    'div',
                    { className: 'title' },
                    React.createElement(
                      'span',
                      null,
                      teamInfo.count + ' 人正在火拼中'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'collage-play-title isRelative',
                        onClick: this.goToPlaylaws
                      },
                      React.createElement(
                        'div',
                        null,
                        '\u62FC\u56E2\u73A9\u6CD5'
                      ),
                      React.createElement(
                        'div',
                        null,
                        React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'collage-list' },
                    teamInfo.team_list.map(function (item, index) {
                      return React.createElement(
                        React.Fragment,
                        { key: index },
                        item.current_status == 2 && React.createElement(
                          'div',
                          {
                            className: 'collage-item isRelative',
                            'data-num': item.max_user_num,
                            'data-token': item.team_token,
                            'data-joined': item.joined,
                            'data-type': item.activity_type,
                            onClick: _this3.participateGroup
                          },
                          React.createElement(
                            'div',
                            null,
                            React.createElement(
                              'div',
                              { className: 'image-wrap' },
                              React.createElement(
                                'div',
                                null,
                                React.createElement('img', {
                                  src: item.leader_info.cover_thumb
                                })
                              ),
                              React.createElement(
                                'div',
                                null,
                                React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png' })
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'content-wrap' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                item.leader_info.nickname
                              ),
                              React.createElement(
                                'div',
                                { className: 'status' },
                                React.createElement(
                                  'div',
                                  { className: 'condition' },
                                  item.activity_type == '2' ? React.createElement(
                                    React.Fragment,
                                    null,
                                    '\u5DF2\u62FC',
                                    React.createElement(
                                      'span',
                                      null,
                                      item.current_user_count
                                    ),
                                    '\u4EBA'
                                  ) : React.createElement(
                                    React.Fragment,
                                    null,
                                    '\u8FD8\u5DEE',
                                    React.createElement(
                                      'span',
                                      null,
                                      item.need_user_count
                                    ),
                                    '\u4EBA'
                                  )
                                ),
                                React.createElement(
                                  'div',
                                  { className: 'remain' },
                                  '距结束仅剩' + (item.downCount.days != '00' && item.downCount.days != '0' ? item.downCount.days || '' : '') + item.downCount.hours + ':' + item.downCount.minutes + ':' + item.downCount.seconds
                                )
                              )
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'btn-wrap' },
                            React.createElement(
                              'button',
                              { type: 'button' },
                              '\u7ACB\u5373\u53C2\u56E2'
                            )
                          )
                        )
                      );
                    })
                  ),
                  teamInfo.is_more != 0 && React.createElement(
                    'div',
                    { className: 'show-more', onClick: this.showMoreTeams },
                    '\u67E5\u770B\u66F4\u591A',
                    React.createElement('span', { className: 'ico-moon icon-downarrow' })
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section shop-message' },
              React.createElement(
                'div',
                { className: 'collage-shop-info' },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: goods && goods.app_cover })
                ),
                React.createElement(
                  'div',
                  { className: 'shop-info' },
                  React.createElement(
                    'div',
                    null,
                    goods && goods.app_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'sales-num' },
                    '\u5728\u552E',
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#d2d2d2;margin:0 10rpx;') },
                      '|'
                    ),
                    React.createElement(
                      'span',
                      null,
                      goods && goods.total_goods
                    ),
                    '\u4EF6\u5546\u54C1'
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'collage-shop-into isRelative',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'collage-section  comment-message',
                hidden: displayComment,
                id: 'comment'
              },
              React.createElement(
                'div',
                { className: 'comment-title' },
                React.createElement(
                  'div',
                  null,
                  '晒单评价 (' + (commentNums && commentNums[0] || 0) + ')'
                ),
                React.createElement(
                  'div',
                  { onClick: this.goToCommentPage },
                  '\u67E5\u770B\u5168\u90E8 >'
                )
              ),
              React.createElement(
                'div',
                { className: 'block-item' },
                commentExample && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'comment-item' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        className: 'comment-user-photo',
                        src: commentExample.buyer_headimgurl || defaultPhoto
                      }),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { className: 'commentPersonName' },
                          commentExample.buyer_nickname
                        ),
                        React.createElement(
                          'div',
                          { className: 'comment-date' },
                          commentExample.add_time
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'comment-content' },
                      commentExample.assess_info.content
                    ),
                    !!+commentExample.assess_info.has_img && React.createElement(
                      'div',
                      { className: 'comPage-comment-pics' },
                      commentExample.assess_info.img_arr.map(function (imgSrc, index) {
                        return React.createElement('img', {
                          src: imgSrc,
                          key: index,
                          'data-src': imgSrc,
                          'data-srcarr': JSON.stringify(commentExample.assess_info.img_arr),
                          onClick: _this3.clickPlusImages
                        });
                      })
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-detail-section', id: 'detail' },
              React.createElement(
                'div',
                { className: 'goodsDetail-title' },
                React.createElement(
                  'div',
                  null,
                  '\u5546\u54C1\u8BE6\u60C5'
                )
              ),
              React.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goods && goods.goods_info.description && goods.goods_info.description.replace(/href=".*?"/g, '') } })
            )
          ),
          React.createElement(
            'div',
            { className: 'collage-bottom' },
            React.createElement(
              'div',
              { className: 'anthor-btn' },
              !franchiseeId && React.createElement(
                'div',
                { className: 'form-contain goods-opt-item flex-sub-box-3' },
                React.createElement(
                  'form',
                  null,
                  React.createElement(
                    'button',
                    { type: 'button',
                      onClick: goods && goods.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                    React.createElement(
                      'div',
                      { className: 'bottom-border-right' },
                      React.createElement('span', {
                        style: (0, _tools.convertLineStyleData)(goods && goods.is_favorite == 1 ? 'color:' + storeStyle.theme : ''),
                        className: 'ico-moon icon-' + (goods && goods.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites')
                      }),
                      React.createElement(
                        'div',
                        null,
                        '\u6536\u85CF'
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'goods-opt-item flex-sub-box-' + (franchiseeId ? '2' : '3')
                },
                React.createElement('div', {
                  className: 'ico-moon icon-service2',
                  style: (0, _tools.convertLineStyleData)('font-size:36rpx;')
                }),
                React.createElement(
                  'div',
                  null,
                  '\u5BA2\u670D'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'group-buy-btn' },
              !(goods && goods.type == 4 && goods.can_buy_alone == 0) && React.createElement(
                'div',
                { className: 'separate-purchase isRelative' },
                React.createElement(
                  'div',
                  { onClick: this.singleBuy },
                  React.createElement(
                    'div',
                    null,
                    '¥' + (goodsInfo && goodsInfo.goods_price)
                  ),
                  React.createElement(
                    'span',
                    null,
                    '\u5355\u72EC\u8D2D\u4E70'
                  )
                )
              ),
              goodsInfo && goodsInfo.status == 0 ? React.createElement(
                'div',
                { className: 'soon-draw isRelative', onClick: this.soonOpen },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    null,
                    '¥' + groupInfo.group_buy_price
                  ),
                  React.createElement(
                    'span',
                    null,
                    '\u5373\u5C06\u5F00\u56E2'
                  )
                )
              ) : goodsInfo && goodsInfo.status == 1 ? React.createElement(
                'div',
                { className: 'reminded isRelative', onClick: this.remainMe },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    null,
                    '¥' + groupInfo.group_buy_price
                  ),
                  React.createElement(
                    'span',
                    null,
                    '\u63D0\u9192\u6211'
                  )
                )
              ) : goodsInfo && goodsInfo.status == 2 ? React.createElement(
                'div',
                { className: 'reminded isRelative' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    null,
                    '¥' + groupInfo.group_buy_price
                  ),
                  React.createElement(
                    'span',
                    null,
                    '\u5DF2\u63D0\u9192'
                  )
                )
              ) : goodsInfo && (goodsInfo.status == 3 || goodsInfo.end_date != -1) && React.createElement(
                'div',
                {
                  className: 'group-buying isRelative',
                  onClick: this.showGroupBuy
                },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    null,
                    '¥' + groupInfo.group_buy_price
                  ),
                  React.createElement(
                    'span',
                    null,
                    goods.type == 4 ? '参与抽奖' : '拼团购'
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              id: 'payDialog',
              className: 'page-dialog-wrap',
              hidden: addToShoppingCartHidden
            },
            React.createElement(
              'div',
              { className: 'page-bottom-dialog' },
              React.createElement(
                'div',
                {
                  className: 'pay-close-dialog page-dialog-close',
                  onClick: this.hiddeAddToShoppingCart
                },
                React.createElement('span', { className: 'ico-moon icon-closes' })
              ),
              React.createElement(
                'div',
                { className: 'dialog-goods-header' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'thumb' },
                    React.createElement(
                      'div',
                      { className: 'thumb-wrap' },
                      React.createElement('img', {
                        'data-src': selectModelInfo.imgurl || goodsInfo && goodsInfo.cover,
                        onClick: this.clickPlusImages,
                        className: 'pay-goods-cover',
                        src: selectModelInfo.imgurl || goodsInfo && goodsInfo.cover
                      })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'pay-goods-baseinfo' },
                    React.createElement(
                      'div',
                      { className: 'pay-goods-price' },
                      React.createElement(
                        'div',
                        { className: 'pay-current-price' },
                        selectModelInfo.price != '0.00' && React.createElement(
                          'div',
                          { style: (0, _tools.convertLineStyleData)('font-size:28rpx;') },
                          '¥' + selectModelInfo.price
                        ),
                        isShowVirtualPrice && selectModelInfo.virtualPrice != 0 && React.createElement(
                          'span',
                          { className: 'virtualPrice' },
                          '¥' + selectModelInfo.virtualPrice
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'pay-goods-stock' },
                      '库存 ' + selectModelInfo.stock
                    ),
                    selectModelInfo.models_text && React.createElement(
                      'div',
                      { className: 'pay-checked-text clearfix' },
                      '已选 :' + selectModelInfo.models_text
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'payDialog-content' },
                React.createElement(
                  'div',
                  {
                    className: 'pay-goods-models',
                    hidden: !(goodsInfo && goodsInfo.model_items.length)
                  },
                  goodsInfo && goodsInfo.model.map(function (model, modelIndex) {
                    return React.createElement(
                      'div',
                      { key: modelIndex },
                      React.createElement(
                        'span',
                        { className: 'model-title' },
                        model.name
                      ),
                      React.createElement(
                        'label',
                        { className: 'pills-list' },
                        model.subModelName.map(function (name, index) {
                          return React.createElement(
                            'label',
                            {
                              key: index,
                              'data-model-index': modelIndex,
                              'data-submodel-index': index,
                              className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                              'data-submodel-id': model.subModelId[index],
                              onClick: _this3.selectSubModel
                            },
                            name
                          );
                        })
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'payDialog-buy-num',
                    style: (0, _tools.convertLineStyleData)('padding-left:10px;padding-right:10px;')
                  },
                  React.createElement(
                    'div',
                    { className: 'clearfix' },
                    React.createElement(
                      'span',
                      null,
                      '\u8D2D\u4E70\u6570\u91CF :'
                    ),
                    React.createElement(
                      'div',
                      { className: 'pull-right' },
                      React.createElement(
                        'div',
                        { className: 'quantity pull-left' },
                        React.createElement('label', {
                          className: 'minus ' + (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                        }),
                        React.createElement('input', (_React$createElement = {
                          className: 'pay-buy-count',
                          type: 'number'
                        }, (0, _defineProperty3.default)(_React$createElement, 'className', 'txt'), (0, _defineProperty3.default)(_React$createElement, 'value', selectModelInfo.buyCount), (0, _defineProperty3.default)(_React$createElement, 'onChange', this.inputBuyCount), _React$createElement)),
                        React.createElement('label', {
                          className: 'plus ' + (selectModelInfo.buyCount >= selectModelInfo.stock || isSeckill && selectModelInfo.buyCount >= goodsInfo.seckill_buy_limit ? 'disabled' : '')
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-minus',
                          onClick: this.clickMinusButton
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-plus',
                          onClick: this.clickPlusButton
                        })
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'dialog-bottom noGroupSureMask' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'pay-add-to-shoppingcart isRelative',
                      onClick: this.sureAddToShoppingCart
                    },
                    '\u52A0\u5165\u8D2D\u7269\u8F66'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'btn-orange pay-buy-next isRelative',
                      onClick: this.buyDirectlyNextStep
                    },
                    '\u7ACB\u5373\u8D2D\u4E70'
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              id: 'groupPayDialog',
              className: 'page-dialog-wrap',
              hidden: addToGroupBuyCart,
              onClick: this.hideMask
            },
            React.createElement(
              'div',
              { className: 'page-bottom-dialog' },
              React.createElement(
                'div',
                {
                  className: 'pay-close-dialog page-dialog-close',
                  onClick: this.hideGroupBuyCart
                },
                React.createElement('span', { className: 'ico-moon icon-closes' })
              ),
              React.createElement(
                'div',
                { className: 'dialog-goods-header' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'thumb' },
                    React.createElement(
                      'div',
                      { className: 'thumb-wrap' },
                      React.createElement('img', {
                        'data-src': selectModelInfo.imgurl || goodsInfo && goodsInfo.cover,
                        onClick: this.clickPlusImages,
                        className: 'pay-goods-cover',
                        src: selectModelInfo.imgurl || goodsInfo && goodsInfo.cover
                      })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'pay-goods-baseinfo' },
                    React.createElement(
                      'div',
                      { className: 'pay-goods-price' },
                      React.createElement(
                        'div',
                        { className: 'pay-current-price groupMaskPrice' },
                        goods && goods.type != 4 ? React.createElement(
                          React.Fragment,
                          null,
                          goods.is_leader == 0 || isParticipate ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'type' },
                              React.createElement('span', { className: 'ico-moon icon-number-people' }),
                              '\u56E2\u5458\u4EF7'
                            ),
                            React.createElement(
                              'div',
                              { style: (0, _tools.convertLineStyleData)('width:calc(100% - 104rpx);') },
                              React.createElement(
                                'div',
                                { className: 'member_price' },
                                '¥' + selectModelInfo.member_price
                              ),
                              React.createElement(
                                'div',
                                { className: 'price' },
                                '¥' + (selectModelInfo.virtualPrice || selectModelInfo.price)
                              )
                            )
                          ) : React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'type' },
                              React.createElement('span', { className: 'ico-moon icon-leader-logo' }),
                              '\u56E2\u957F\u4EF7'
                            ),
                            React.createElement(
                              'div',
                              { style: (0, _tools.convertLineStyleData)('width:calc(100% - 104rpx);') },
                              React.createElement(
                                'div',
                                { className: 'leader_price' },
                                '¥' + selectModelInfo.leader_price
                              ),
                              React.createElement(
                                'div',
                                { className: 'price' },
                                '¥' + (selectModelInfo.virtualPrice || selectModelInfo.price)
                              )
                            )
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'div',
                            { className: 'type' },
                            React.createElement('span', { className: 'ico-moon icon-number-people' }),
                            '\u62BD\u5956\u56E2'
                          ),
                          React.createElement(
                            'div',
                            { className: 'member_price' },
                            '¥' + (groupInfo && groupInfo.group_buy_price)
                          ),
                          React.createElement(
                            'div',
                            { className: 'price' },
                            '¥' + (selectModelInfo.virtualPrice || goodsInfo && goodsInfo.price)
                          )
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'pay-goods-stock' },
                      '库存 ' + selectModelInfo.stock
                    ),
                    selectModelInfo.models_text && React.createElement(
                      'div',
                      { className: 'pay-checked-text clearfix' },
                      '已选 :' + selectModelInfo.models_text
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'tip' },
                  goods && (goods.type == 0 || goods.type == 1 || goods.type == 3) ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      '成团人数: ' + selectModelInfo.groupNum + '人团'
                    )
                  ) : goods && goods.type == 2 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      'TIPS :',
                      goods.current_user_count ? React.createElement(
                        React.Fragment,
                        null,
                        '已拼' + goods.current_user_count + '人，人数越多，价格越低'
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        '\u4EBA\u6570\u8D8A\u591A\uFF0C\u4EF7\u683C\u8D8A\u4F4E'
                      )
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'showMoreTips',
                        onClick: function onClick(e) {
                          _this3.showMoreTips(e);e.stopPropagation();
                        }
                      },
                      '\u67E5\u770B\u66F4\u591A',
                      showTips ? React.createElement('span', { className: 'ico-moon icon-downarrow' }) : React.createElement('span', { className: 'ico-moon icon-uparrow' }),
                      React.createElement(
                        'div',
                        { className: 'mask-tips', hidden: showTips },
                        discountInfoArr.map(function (item, index) {
                          return React.createElement(
                            'div',
                            { key: index },
                            React.createElement(
                              'span',
                              null,
                              '满' + item.num_of_people + '人'
                            ),
                            React.createElement(
                              'span',
                              null,
                              '¥' + (isParticipate ? item.member_price : item.leader_price)
                            )
                          );
                        })
                      )
                    )
                  ) : goods && goods.type == 4 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      null,
                      'TIPS : 满' + goods.least_cost + '元开奖'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'payDialog-content' },
                goods && goods.type == 0 && !isParticipate && React.createElement(
                  'div',
                  { className: 'pay-goods-models' },
                  React.createElement(
                    'div',
                    { className: 'group-info group-buy-num' },
                    React.createElement(
                      'div',
                      { className: 'model-title' },
                      '\u6210\u56E2\u4EBA\u6570'
                    ),
                    React.createElement(
                      'label',
                      { className: 'pills-list' },
                      groupInfo.num_of_people.map(function (num, index) {
                        return React.createElement(
                          'label',
                          {
                            key: index,
                            className: 'subModel ' + (selectModelInfo.groupNum == num ? 'select' : '') + ' isRelative',
                            'data-num': num,
                            onClick: _this3.selectGroupNum
                          },
                          num + '人团'
                        );
                      })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pay-goods-models',
                    hidden: !(goodsInfo && goodsInfo.model_items.length)
                  },
                  goodsInfo && goodsInfo.model.map(function (model, modelIndex) {
                    return React.createElement(
                      'div',
                      { key: modelIndex },
                      React.createElement(
                        'span',
                        { className: 'model-title' },
                        model.name
                      ),
                      React.createElement(
                        'label',
                        { className: 'pills-list' },
                        model.subModelName.map(function (name, index) {
                          return React.createElement(
                            'label',
                            {
                              key: index,
                              'data-model-index': modelIndex,
                              'data-submodel-index': index,
                              className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                              'data-submodel-id': model.subModelId[index],
                              onClick: _this3.selectSubModel
                            },
                            name
                          );
                        })
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'payDialog-buy-num' },
                  React.createElement(
                    'div',
                    { className: 'clearfix' },
                    React.createElement(
                      'span',
                      null,
                      '\u8D2D\u4E70\u6570\u91CF'
                    ),
                    React.createElement(
                      'div',
                      { className: 'pull-right' },
                      React.createElement(
                        'div',
                        { className: 'quantity pull-left' },
                        React.createElement('label', {
                          className: 'minus ' + (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                        }),
                        React.createElement('input', (_React$createElement2 = {
                          className: 'pay-buy-count',
                          type: 'number'
                        }, (0, _defineProperty3.default)(_React$createElement2, 'className', 'txt'), (0, _defineProperty3.default)(_React$createElement2, 'value', selectModelInfo.buyCount), (0, _defineProperty3.default)(_React$createElement2, 'onChange', this.inputBuyCount), _React$createElement2)),
                        React.createElement('label', {
                          className: 'plus ' + (selectModelInfo.buyCount >= selectModelInfo.stock || isSeckill && selectModelInfo.buyCount >= goodsInfo.seckill_buy_limit ? 'disabled' : '')
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-minus',
                          onClick: this.clickMinusButton
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-plus',
                          onClick: this.clickPlusButton,
                          'data-type': 'group'
                        })
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'dialog-bottom groupSureMask' },
                React.createElement(
                  'div',
                  null,
                  goods && (goods.is_leader == 0 || isParticipate) ? React.createElement(
                    'div',
                    {
                      className: 'pay-add-to-shoppingcart isRelative',
                      onClick: this.sureJoinGroup
                    },
                    '\u9A6C\u4E0A\u53C2\u56E2'
                  ) : React.createElement(
                    'div',
                    {
                      className: 'pay-add-to-shoppingcart isRelative',
                      onClick: this.sureJoinGroup
                    },
                    goods && goods.type == 4 ? '参与抽奖' : '马上开团'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return GpGoodsDetail;
}(_OfficialPage3.default);

exports.default = GpGoodsDetail;

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(577);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpPlayLaws = function (_OfficialPage) {
  (0, _inherits3.default)(GpPlayLaws, _OfficialPage);

  function GpPlayLaws() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, GpPlayLaws);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = GpPlayLaws.__proto__ || Object.getPrototypeOf(GpPlayLaws)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
      activityType: 0,
      autoRefund: '',
      refundMode: ''
    }, _this2.getPlayMessage = function () {}, _this2.onPullDownRefresh = function () {}, _this2.onReachBottom = function () {}, _this2.onShareAppMessage = function () {}, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(GpPlayLaws, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var _this = this,
          titleType = '';
      _this.getPlayMessage();
      _this.setData({
        activityType: options.activityType,
        autoRefund: options.autoRefund,
        refundMode: options.refundMode
      });
      switch (options.activityType) {
        case '0':
          titleType = '';
          break;
        case '1':
          titleType = '新人团';
          break;
        case '2':
          titleType = '阶梯团';
          break;
        case '3':
          titleType = '帮帮团';
          break;
        case '4':
          titleType = '抽奖团';
          break;
      }
      _app.appMethod.setNavigationBarTitle({
        title: titleType + '拼团须知'
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageQRCodeData = _state.pageQRCodeData,
          activityType = _state.activityType,
          autoRefund = _state.autoRefund,
          refundMode = _state.refundMode;

      return React.createElement(
        'div',
        { className: 'official-page gp-play-laws' },
        React.createElement(_TopNav.TopNav, { title: '\u62FC\u56E2\u987B\u77E5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'collage-playlaws' },
            React.createElement(
              'div',
              { className: 'collage-section collage-play-category' },
              activityType != 4 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '1'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u56E2\u957F\u5F00\u56E2'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/start-immediately(ordinary).png',
                        style: (0, _tools.convertLineStyleData)('height:308rpx')
                      })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '2'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u9009\u62E9\u6210\u56E2\u4EBA\u6570'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/select-num(ordinary).png',
                        style: (0, _tools.convertLineStyleData)('height:357rpx;')
                      })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '3'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u9080\u8BF7\u597D\u53CB\u53C2\u56E2'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/invite-friends(ordinary).png' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u5728\u65F6\u9650\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u62FC\u56E2\u6210\u529F'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/groupSuccess(ordinary).png' })
                    )
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '1'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u56E2\u957F\u5F00\u56E2'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/join-draw(draw).png',
                        style: (0, _tools.convertLineStyleData)('height:308rpx;')
                      })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '2'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u6D3B\u52A8\u7ED3\u675F\u524D\uFF0C\u9080\u8BF7\u597D\u53CB\u53C2\u56E2'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/friends-join(draw).png',
                        style: (0, _tools.convertLineStyleData)('height:360rpx;')
                      })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'collage-play-sort' },
                  React.createElement(
                    'div',
                    { className: 'serial-number' },
                    '3'
                  ),
                  React.createElement(
                    'div',
                    { className: 'serial-intro' },
                    React.createElement(
                      'div',
                      { className: 'title' },
                      '\u8FBE\u5230\u62BD\u5956\u4EBA\u6570\uFF0C\u81EA\u52A8\u5F00\u56E2'
                    ),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/automatic-lottery(draw).png' })
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section collage-play-intro' },
              React.createElement(
                'div',
                { className: 'title' },
                '\u8BE6\u7EC6\u8BF4\u660E'
              ),
              React.createElement(
                'div',
                { className: 'collage-intro-step' },
                activityType == 0 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '1.\u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u4E0B\u5355\u53D1\u8D77\u62FC\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '2.\u7528\u6237\u652F\u4ED8\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u5F00\u56E2\u6216\u53C2\u56E2\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u652F\u4ED8\u4E0D\u7B97\u6709\u6548\u53C2\u4E0E\u62FC\u56E2\u73A9\u6CD5\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '3.\u5148\u4ED8\u6B3E\u7684\u6210\u5458\u5148\u52A0\u5165\u56E2\uFF0C\u6BCF\u4F4D\u7528\u6237\u5728\u540C\u4E00\u56E2\u5185\u53EF\u8D2D\u4E70\u591A\u4EF6\uFF0C\u4F46\u53EA\u53601\u4E2A\u62FC\u56E2\u4EBA\u6570\uFF0C\u4E14\u4E0D\u53EF\u91CD\u590D\u53C2\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    autoRefund == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u9000\u6B3E\u3002'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6700\u4F4E\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u8054\u7CFB\u5546\u5BB6\u7533\u8BF7\u9000\u6B3E\u3002'
                    )
                  )
                ) : activityType == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '1.\u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u4E0B\u5355\u53D1\u8D77\u62FC\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '2.\u7528\u6237\u652F\u4ED8\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u5F00\u56E2\u6216\u53C2\u56E2\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u652F\u4ED8\u4E0D\u7B97\u6709\u6548\u53C2\u4E0E\u62FC\u56E2\u73A9\u6CD5\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '3.\u65B0\u4EBA\u56E2\u9700\u5C0F\u7A0B\u5E8F\u65B0\u7528\u6237\uFF08\u537324\u5C0F\u65F6\u5185\u9996\u6B21\u767B\u9646\uFF0C\u4E14\u672A\u53C2\u4E0E\u8FC7\u62FC\u56E2\u7684\u7528\u6237\uFF09\u65B9\u53EF\u53C2\u56E2\uFF0C\u5148\u4ED8\u6B3E\u7684\u6210\u5458\u5148\u52A0\u5165\u56E2\uFF0C\u6BCF\u4F4D\u7528\u6237\u5728\u540C\u4E00\u56E2\u53EF\u8D2D\u4E70\u591A\u4EF6\uFF0C\u4F46\u53EA\u53601\u4E2A\u62FC\u56E2\u4EBA\u6570\uFF0C\u4E14\u4E0D\u53EF\u91CD\u590D\u53C2\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    autoRefund == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u9000\u6B3E\u3002'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6700\u4F4E\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u8054\u7CFB\u5546\u5BB6\u7533\u8BF7\u9000\u6B3E\u3002'
                    )
                  )
                ),
                activityType == 2 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '1.\u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u4E0B\u5355\u53D1\u8D77\u62FC\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '2.\u7528\u6237\u652F\u4ED8\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u5F00\u56E2\u6216\u53C2\u56E2\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u652F\u4ED8\u4E0D\u7B97\u6709\u6548\u53C2\u4E0E\u62FC\u56E2\u73A9\u6CD5\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    refundMode == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      '3.\u9636\u68AF\u56E2\u53C2\u56E2\u4EBA\u6570\u8D8A\u591A\uFF0C\u4EF7\u683C\u8D8A\u4F4E\uFF0C\u652F\u4ED8\u5DEE\u4EF7\u5C06\u5728\u786E\u8BA4\u6536\u8D27\u540E\u8FD4\u8FD8\u6210\u50A8\u503C\u91D1\u3002\u6BCF\u4F4D\u7528\u6237\u5728\u540C\u4E00\u56E2\u5185\u53EF\u8D2D\u4E70\u591A\u4EF6\uFF0C\u4F46\u53EA\u53601\u4E2A\u62FC\u56E2\u4EBA\u6570\uFF0C\u4E14\u4E0D\u53EF\u91CD\u590D\u53C2\u56E2\u3002'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '3.\u9636\u68AF\u56E2\u53C2\u56E2\u4EBA\u6570\u8D8A\u591A\uFF0C\u4EF7\u683C\u8D8A\u4F4E\uFF0C\u652F\u4ED8\u5DEE\u4EF7\u5C06\u5728\u786E\u8BA4\u6536\u8D27\u540E\u8FD4\u8FD8\u5230\u652F\u4ED8\u8D26\u53F7\u3002\u6BCF\u4F4D\u7528\u6237\u5728\u540C\u4E00\u56E2\u5185\u53EF\u8D2D\u4E70\u591A\u4EF6\uFF0C\u4F46\u53EA\u53601\u4E2A\u62FC\u56E2\u4EBA\u6570\uFF0C\u4E14\u4E0D\u53EF\u91CD\u590D\u53C2\u56E2'
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    autoRefund == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6700\u4F4E\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u9000\u6B3E\u3002'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6700\u4F4E\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u5546\u5BB6\u5206\u522B\u53D1\u8D27\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u8054\u7CFB\u5546\u5BB6\u7533\u8BF7\u9000\u6B3E\u3002'
                    )
                  )
                ) : activityType == 3 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '1.\u5E2E\u5E2E\u56E2\u7684\u7406\u5FF5\u662F\u9080\u8BF7\u597D\u53CB\u5E2E\u52A9\u652F\u4ED8\u83B7\u5F97\u5546\u54C1\uFF0C\u62FC\u56E2\u6210\u529F\u540E\uFF0C\u5546\u5BB6\u53EA\u7ED9\u56E2\u957F\u53D1\u8D27\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '2.\u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u4E0B\u5355\u53D1\u8D77\u62FC\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '3.\u7528\u6237\u652F\u4ED8\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u5E2E\u52A9\u6210\u56E2\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u652F\u4ED8\u4E0D\u7B97\u6709\u6548\u53C2\u4E0E\u5E2E\u5E2E\u56E2\uFF0C\u5148\u4ED8\u6B3E\u7684\u6210\u5458\u5148\u52A0\u5165\u56E2\uFF0C\u7528\u6237\u4E0D\u53EF\u91CD\u590D\u53C2\u540C\u4E00\u56E2\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '4.\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u5E2E\u5E2E\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u6210\u529F\uFF0C\u56E2\u957F\u83B7\u5F97\u5546\u54C1\uFF1B\u672A\u80FD\u5728\u89C4\u5B9A\u65F6\u95F4\u5185\u8FBE\u5230\u6210\u56E2\u4EBA\u6570\uFF0C\u5219\u62FC\u56E2\u5931\u8D25\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u9000\u6B3E\u3002'
                  )
                ) : activityType == 4 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    null,
                    '1.\u7528\u6237\u652F\u4ED8\u4E00\u5B9A\u91D1\u989D\u83B7\u5F97\u62BD\u5956\u673A\u4F1A\uFF0C\u5F53\u53C2\u52A0\u62BD\u5956\u7528\u6237\u652F\u4ED8\u91D1\u989D\u8FBE\u5230\u62BD\u5956\u95E8\u69DB\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u62BD\u53D61\u540D\u4E2D\u5956\u7528\u6237\uFF0C\u5176\u4ED6\u672A\u4E2D\u5956\u7528\u6237\u5C06\u83B7\u5F97\u7B49\u989D\u50A8\u503C\u91D1\u3002\u6D3B\u52A8\u7ED3\u675F\u4ECD\u672A\u8FBE\u5230\u62BD\u5956\u95E8\u69DB\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u9000\u6B3E\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '2.\u6D3B\u52A8\u671F\u95F4\uFF0C\u7528\u6237\u53EF\u4EE5\u5728\u62FC\u56E2\u5546\u54C1\u8BE6\u60C5\u652F\u4ED8\u53C2\u4E0E\u62BD\u5956\u3002\u8D2D\u4E70\u6570\u91CF\u8D8A\u591A\uFF0C\u4E2D\u5956\u6982\u7387\u8D8A\u5927\u3002'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '3.\u7528\u6237\u652F\u4ED8\u6210\u529F\uFF0C\u624D\u7B97\u6210\u529F\u53C2\u4E0E\u62BD\u5956\uFF0C\u521B\u5EFA\u8BA2\u5355\u672A\u652F\u4ED8\u4E0D\u7B97\u6709\u6548\u53C2\u56E2\u73A9\u6CD5\u3002'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return GpPlayLaws;
}(_OfficialPage3.default);

exports.default = GpPlayLaws;

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _MemberDiscount = __webpack_require__(66);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(579);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateTrans = {
  date: function date(a) {
    var reg = new RegExp("-", "img");
    var c = a.replace(reg, '月') + '日';
    return c;
  },
  week: function week(a) {
    switch (a) {
      case '0':
        return '日';
      case '1':
        return '一';
      case '2':
        return '二';
      case '3':
        return '三';
      case '4':
        return '四';
      case '5':
        return '五';
      case '6':
        return '六';
    }
  }
};

var PreviewGroupOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewGroupOrder, _OfficialPage);

  function PreviewGroupOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewGroupOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PreviewGroupOrder.__proto__ || Object.getPrototypeOf(PreviewGroupOrder)).call(this, props));

    _this.state = {
      id: 0,
      selectmodel: '',
      order: {},
      formid: [],
      isFrom: true,
      goodsInfo: {},
      groupPrice: '',
      goodsPrice: '',
      kanfriends: [],
      cart_id_arr: [],
      kanprice: 0,
      description: '',
      num_of_people: 0,
      num: 0,
      status: 'P',
      storeConfig: '',
      express_fee: 0,
      box_fee: 0,
      selectAddress: '',
      shop: {
        id: '0'
      },
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      useBalance: true,
      selectDiscountInfo: {},
      cashOnDelivery: false,
      is_self_delivery: 0,
      deliverytype: 'express',
      noAdditionalInfo: true,
      additional_info_obj: {},
      goodsType: '',
      selectDelivery: '',
      pickUpType: '',
      expressAddressNull: false,
      additional_info: {},
      payGiftOptions: {}, // 支付有礼计算金额参数
      settlementActivityFreePrice: 0
    };
    _this.memberDiscountRef = React.createRef();

    _this.getLocation = function () {
      var that = _this,
          pickUpType = that.data.pickUpType;
      _app.appMethod.getLocation({
        success: function success(res) {
          if (!res.longitude) {
            return;
          }
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            data: {
              longitude: res.longitude,
              latitude: res.latitude
            },
            success: function success(data) {
              that.setData({
                currentRegionId: data.data.region_id
              });
              if (pickUpType == 3) {
                that.getSelfDeliveryList();
              }
            }
          });
          that.setData({
            longitude: res.longitude,
            latitude: res.latitude
          });
        },
        fail: function fail(res) {
          console.log(res);
          _app.appMethod.addLog(res);
        }
      });
    };

    _this.selectPickMethod = function (first) {
      var that = _this;
      var cartIdArr = _this.cart_id_arr;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppGroupBuy/getCanUsePickUpTypeAtAddOrder',
        method: 'post',
        data: {
          num: that.data.num,
          goods_id: that.data.goods_id,
          activity_id: that.data.activityid,
          model_id: that.data.model_id || '',
          num_of_people: that.data.num_of_people,
          team_token: that.data.team_token || '',
          latitude: that.data.latitude || '',
          longitude: that.data.longitude || '',
          region_id: that.data.currentRegionId || '',
          sub_shop_app_id: that.franchisee_id || ''
        },
        success: function success(res) {
          // WEBAPP特殊处理: 设置 取货方式 参数
          (0, _tools.updateUrlParam)('type', !that.data.pickUpType ? res.data.goods_pick_up_type_arr[0] : that.data.pickUpType);
          that.setData({
            pickUpTypeArr: res.data.goods_pick_up_type_arr,
            intraCityData: res.data.intra_city_data,
            isShowPickMask: first == 'first' ? false : true,
            pickUpType: !that.data.pickUpType ? res.data.goods_pick_up_type_arr[0] : that.data.pickUpType
          });
          if (first == 'first') {
            switch (that.data.pickUpType) {
              case '3':
                that.getSelfDeliveryList();
                break;
              case '2':
                that.setData({
                  sameJourneyTimeType: 1
                });
                break;
            }
            that.getCalculationInfo();
          }
        }
      });
    };

    _this.getGoodsStoreSet = function (type) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
        data: {
          pick_up_type: type,
          sub_shop_app_id: _this.franchisee_id
        },
        success: function success(res) {
          var configData = res.data.config_data;
          if (type == 3 && configData) {
            that.setData({
              selfAppointmentSwitch: configData.pick_up_time_status == 1 && configData.appointment.status == 1 ? true : false,
              onlyImmediatlyPickSwitch: configData.pick_up_time_status == 1 && configData.appointment.status != 1 && configData.immediate_info.self_pcik_up_status == 1 ? true : false,
              selfDeliveryPhone: configData.is_phone,
              selfDeliveryScan: configData.pick_up_time_status == 1 && configData.immediate_info.status == 1 && configData.immediate_info.scan_qrcode_status == 1 ? true : false
            });
            if (that.data.onlyImmediatlyPickSwitch) {
              that.showServiceTime('onlyImme');
            }
          } else if (type == 2 && configData) {
            that.getsameJourneyTime(configData.business_rule);
          }
        }
      });
    };

    _this.tostoreImmediately = function () {
      _this.setData({
        tostoreOrderType: 1,
        tostoreHourTime: '',
        isShowServiceTime: false
      });
    };

    _this.selectTostoreTime = function (e) {
      var dateArr = _this.data.getEcTostoredate.date_arr;
      var index = e.currentTarget.dataset.index;
      var tostoreDateTime = dateArr[index].date;
      var tostoreWeekTime = dateArr[index].week;
      _this.setData({
        tostoreOrderType: 2,
        dateIndex: index,
        tostoreDateTime: tostoreDateTime,
        tostoreWeekTime: tostoreWeekTime,
        isShowServiceTime: _this.data.tostoreTimeType != 1 ? true : false
      });
      _this.getTostoreTime();
    };

    _this.getTostoreTime = function () {
      var currentMonth = new Date().getMonth() + 1;
      var currentMinute = new Date().getMinutes();
      var startHours = new Date().getHours();
      var currentDay = new Date().getDate();
      var currentDate = (currentMonth < 10 ? '0' + currentMonth : currentMonth) + '-' + (currentDay < 10 ? '0' + currentDay : currentDay);
      var tostoreHoursArr = [];
      var currentLimitFlag = true;
      var businessTimeRule = _this.data.businessTimeRule;
      var tostoreWeekTime = Number(_this.data.tostoreWeekTime);
      var businessTime = void 0;
      var showImmediatelyTime = _this.businessTimeType == 1 ? true : false; //1为全年 2为自定义
      var advanceAppointmentInfo = _this.data.advanceAppointmentInfo;
      var advanceTime = +advanceAppointmentInfo.num + startHours > 24 ? +advanceAppointmentInfo.num + startHours - 24 : +advanceAppointmentInfo.num + startHours;
      _this.businessTimeType == 2 && businessTimeRule.map(function (item) {
        if (tostoreWeekTime == 0) {
          tostoreWeekTime = 7;
        }
        if (item.business_week[tostoreWeekTime - 1] == 1) {
          businessTime = item.business_time_interval;
        }
      });
      if (currentDate === _this.data.tostoreDateTime) {
        if (_this.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = startHours; //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            if (startHours < advanceTime) {
              fSH = startHours = advanceTime;
            }
            if ((startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) && !advanceTime) {
              showImmediatelyTime = true;
            }
            if (startHours < sH) {
              startHours = sH;
              currentMinute = 0;
            } else if (startHours > eH) {
              return;
            }
            for (; startHours <= eH; startHours++) {
              if (_this.data.tostoreTimeType == 2) {
                if (startHours == fEH) {
                  continue;
                }
                tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
              } else {
                if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
                  tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                  continue;
                } else if (startHours == fSH && currentMinute > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (startHours == fEH && eT >= 30) {
                  tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                  continue;
                } else if (startHours == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
              }
            }
          });
        } else {
          if (startHours < advanceTime) {
            startHours = advanceTime;
          }
          for (; startHours < 24; startHours++) {
            if (_this.data.tostoreTimeType == 2) {
              if (currentLimitFlag && currentMinute > 0) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + (startHours + 1) + ':00');
            } else {
              if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
                currentLimitFlag = false;
                tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
                continue;
              }
              if (currentLimitFlag && currentMinute > 30) {
                currentLimitFlag = false;
                startHours++;
              }
              if (startHours >= 24) {
                continue;
              }
              tostoreHoursArr.push(startHours + ':00-' + startHours + ':30');
              tostoreHoursArr.push(startHours + ':30-' + (startHours + 1) + ':00');
            }
          }
        }
      } else {
        if (_this.businessTimeType == 2) {
          businessTime && businessTime.map(function (item) {
            var fSH = Number(item.start_time.substring(0, 2)); //是否要判断分钟，初始开始小时
            var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
            var sH = Number(item.start_time.substring(0, 2));
            if (_this.data.getEcTostoredate.date_arr[1].date == _this.data.tostoreDateTime && sH < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
              sH = advanceTime;
            }
            var eH = Number(item.end_time.substring(0, 2));
            var sT = Number(item.start_time.substring(3, 5));
            var eT = Number(item.end_time.substring(3, 5));
            for (; sH <= eH; sH++) {
              if (_this.data.tostoreTimeType == 2) {
                if (sH == fEH || sH == fSH && sT > 0) {
                  continue;
                }
                tostoreHoursArr.push(sH + ':00-' + (sH + 1) + ':00');
              } else {
                if (sH == fSH && sT <= 30 && sT != 0) {
                  tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
                  continue;
                } else if (sH == fSH && sT > 30) {
                  continue;
                } //开始分钟数大于三十分钟则跳过当前时间段
                if (sH == fEH && eT <= 30 && eT != 0) {
                  tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                  continue;
                } else if (sH == fEH && eT == 0) {
                  continue;
                } //结束分钟数等于0则跳过当前时间段
                tostoreHoursArr.push(sH + ':00-' + sH + ':30');
                tostoreHoursArr.push(sH + ':30-' + (sH + 1) + ':00');
              }
            }
          });
        } else {
          var i = 0;
          if (_this.data.getEcTostoredate.date_arr[1].date == _this.data.tostoreDateTime && i < advanceTime && +advanceAppointmentInfo.num + startHours > 24) {
            i = advanceTime;
          }
          for (; i < 24; i++) {
            if (_this.data.tostoreTimeType == 2) {
              tostoreHoursArr.push(i + ':00-' + (i + 1) + ':00');
            } else {
              tostoreHoursArr.push(i + ':00-' + i + ':30');
              tostoreHoursArr.push(i + ':30-' + (i + 1) + ':00');
            }
          }
        }
      }
      _this.setData({
        tostoreHoursArr: tostoreHoursArr,
        showImmediatelyTime: showImmediatelyTime
      });
    };

    _this.selectTostoreHourTime = function (e) {
      var tostoreHoursArr = _this.data.tostoreHoursArr;
      var index = e.currentTarget.dataset.index;
      var tostoreHourTime = tostoreHoursArr[index];
      _this.setData({
        tostoreOrderType: 2,
        tostoreHourTime: tostoreHourTime,
        isShowServiceTime: false
      });
    };

    _this.showSameJourneyTime = function () {
      if (!_this.data.selectSameJourney.id) {
        _app.appMethod.showModal({
          content: '请先选择地址'
        });
        return;
      }
      _this.getGoodsStoreSet(2);
    };

    _this.getsameJourneyTime = function (businessRule) {
      var sameJourneyHoursArr = [];
      var currentMinute = new Date().getMinutes() + Number(_this.data.sameJourneyImmediatlyTime);
      var startHours = new Date().getHours();
      if (currentMinute >= 60) {
        startHours++;
        currentMinute = currentMinute - 60;
      }
      if (businessRule.type == 1) {
        var currentLimitFlag = true;
        for (; startHours < 24; startHours++) {
          if (currentLimitFlag && currentMinute > 0 && currentMinute <= 30) {
            currentLimitFlag = false;
            sameJourneyHoursArr.push(startHours + ':30');
            continue;
          }
          if (currentLimitFlag && currentMinute > 30) {
            currentLimitFlag = false;
            startHours++;
          }
          sameJourneyHoursArr.push(startHours + ':00');
          sameJourneyHoursArr.push(startHours + ':30');
        }
      } else {
        var currentWeek = new Date().getDay();
        var businessTime = void 0;
        businessRule.type == 2 && businessRule.custom.business_time.map(function (item) {
          if (currentWeek == 0) {
            currentWeek = 7;
          }
          if (item.business_week[currentWeek - 1] == 1) {
            businessTime = item.business_time_interval;
          }
        });
        businessTime.map(function (item) {
          var fSH = startHours; //是否要判断分钟，初始开始小时
          var fEH = Number(item.end_time.substring(0, 2)); //是否要判断分钟，初始结束小时
          var sH = Number(item.start_time.substring(0, 2));
          var eH = Number(item.end_time.substring(0, 2));
          var sT = Number(item.start_time.substring(3, 5));
          var eT = Number(item.end_time.substring(3, 5));
          if (startHours <= sH) {
            startHours = sH;
            currentMinute = 0;
          } else if (startHours > eH) {
            return;
          }
          for (; startHours <= eH; startHours++) {
            if (startHours == fSH && currentMinute <= 30 && currentMinute != 0) {
              sameJourneyHoursArr.push(startHours + ':30');
              continue;
            } else if (startHours == fSH && currentMinute > 30) {
              continue;
            } //开始分钟数大于三十分钟则跳过当前时间段
            if (startHours == fEH && eT < 30) {
              sameJourneyHoursArr.push(startHours + ':00');
              continue;
            } else if (startHours == fEH && eT == 0) {
              continue;
            } //结束分钟数等于0则跳过当前时间段
            sameJourneyHoursArr.push(startHours + ':00');
            sameJourneyHoursArr.push(startHours + ':30');
          }
        });
      }
      _this.setData({
        sameJourneyHoursArr: sameJourneyHoursArr,
        isShowSameJourneyTime: true
      });
    };

    _this.getAppECStoreConfig = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appShop/getAppECStoreConfig',
        data: {
          sub_shop_app_id: that.franchisee_id || ''
        },
        success: function success(res) {
          if (res.data.express == 0) {
            that.getSelfDeliveryList();
          }
          that.setData({
            storeConfig: res.data,
            is_self_delivery: res.data.express == 0 && res.data.is_self_delivery == 1 ? 1 : 0,
            storeStyle: that.franchisee_id ? '' : res.data.color_config
          });
          that.getCalculationInfo();
        }
      });
    };

    _this.selectSameJourneyTime = function (e) {
      var type = e.currentTarget.dataset.type;
      var sameJourneyHoursArr = _this.data.sameJourneyHoursArr;
      var index = e.currentTarget.dataset.index;
      var sameJourneyDateTime = sameJourneyHoursArr[index];
      _this.setData({
        sameJourneyTimeType: type == 'immedia' ? 1 : 2,
        sameJourneyDateTime: type == 'immedia' ? '' : sameJourneyDateTime,
        isShowSameJourneyTime: false
      });
    };

    _this.deliveryWayChange = function (event) {
      var type = event.currentTarget.dataset.type;
      // WEBAPP特殊处理: 设置 取货方式 参数
      (0, _tools.updateUrlParam)('type', type);
      if (type == 3) {
        _this.getSelfDeliveryList();
      }
      _this.setData({
        pickUpType: type,
        sameJourneyTimeType: type == 2 ? 1 : '',
        isShowPickMask: false,
        cashOnDelivery: false
      });
      _this.getCalculationInfo();
    };

    _this.getSelfDeliveryList = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getSelfDeliveryList',
        data: {
          sub_shop_app_id: that.franchisee_id || ''
        },
        success: function success(res) {
          var storeList = res.data.store_list_data;
          if (!storeList) {
            _app.appMethod.showModal({
              content: '商家暂无自提门店',
              confirm: function confirm() {
                _app.appMethod.turnBack();
              }
            });
            return;
          }
          if (storeList.length == 1) {
            that.setData({
              selectDelivery: storeList[0]
            });
          }
          if (storeList.length >= 2 && !that.data.selectDelivery) {
            _app.appMethod.showModal({
              content: '当前尚未选择自提点',
              confirmText: '去设置',
              cancelText: '取消',
              showCancel: true,
              confirm: function confirm() {
                that.toDeliveryList();
              }
            });
          }
          that.getGoodsStoreSet(3);
        }
      });
    };

    _this.toDeliveryList = function () {
      var that = _this;
      var url = '';
      if (that.franchisee_id) {
        url += '?franchiseeId=' + that.franchisee_id;
        url += that.data.selectDelivery.id ? '&deliveryId=' + that.data.selectDelivery.id : '';
      } else {
        url += that.data.selectDelivery.id ? '?deliveryId=' + that.data.selectDelivery.id : '';
      }
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage('/eCommerce/pages/goodsDeliveryList/goodsDeliveryList' + url);
      });
    };

    _this.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this.data.additional_info);
      _this.saveUserFormId(function () {
        _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
      });
    };

    _this.goToMyAddress = function () {
      var addressId = _this.data.selectAddress && _this.data.selectAddress.id;
      _this.isFromSelectAddress = true;
      _this.saveUserFormId(function () {
        _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId);
      });
    };

    _this.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          num = _this.data.num;
      if (+num <= 0) return;
      _this.changeGoodsNum(index, 'minus');
    };

    _this.inputBuyCount = function (e) {
      var count = +e.target.value,
          goodsInfo = _this.data.goodsInfo,
          limit_buy = +_this.data.limit_buy,
          stock = +goodsInfo.stock;
      if (_this.data.groupType != '4' && count > limit_buy && limit_buy != 0) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + _this.data.limit_buy + '件）'
        });
        _this.setData({
          num: limit_buy
        });
        return;
      }
      if (count == 0) {
        _this.setData({
          num: 1
        });
        return;
      }
      if (count >= stock) {
        count = stock;
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
      }
      _this.setData({
        num: +count
      });
      _this.getCalculationInfo();
    };

    _this.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          stock = +_this.data.goodsInfo.stock,
          limit_buy = +_this.data.limit_buy,
          num = _this.data.num;
      if (_this.data.groupType != '4' && limit_buy !== '' && limit_buy != 0 && +num >= limit_buy) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        _this.setData({
          num: limit_buy
        });
        return;
      }
      _this.changeGoodsNum(index, 'plus');
    };

    _this.changeGoodsNum = function (index, type) {
      var goods = _this.data.goodsInfo,
          stock = +goods.stock,
          currentNum = _this.data.num,
          targetNum = type == 'plus' ? currentNum + 1 : type == 'minus' ? currentNum - 1 : Number(type),
          that = _this,
          data = {},
          param;
      if (targetNum == 0 && type == 'minus') {
        _this.setData({
          num: 1
        });
        return;
      }
      if (targetNum > stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        _this.setData({
          num: stock
        });
        return;
      }
      _this.setData({
        num: targetNum
      });
      _this.getCalculationInfo();
    };

    _this.getCalculationInfo = function () {
      var that = _this,
          goods_id = that.data.goods_id,
          activity_id = that.data.activityid,
          model_id = that.data.model_id || '',
          tostoreOrderType = _this.data.tostoreOrderType;
      var year = new Date().getFullYear();
      var tostoreDateTime = year + '-' + _this.data.tostoreDateTime + ' ' + (_this.data.tostoreHourTime || '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/calculatePrice',
        method: 'post',
        data: {
          goods_id: goods_id,
          activity_id: activity_id,
          pick_up_type: _this.data.pickUpType,
          model_id: model_id || '',
          sub_shop_app_id: that.franchisee_id || '',
          address_id: _this.data.pickUpType == 1 ? _this.data.selectAddressId : _this.data.selectSameJourneyId,
          cart_id_arr: _this.cart_id_arr,
          is_balance: _this.data.useBalance ? 1 : 0,
          is_self_delivery: _this.data.is_self_delivery,
          select_benefit: _this.data.selectDiscountInfo,
          num_of_people: _this.data.num_of_people,
          num: _this.data.num,
          team_token: _this.data.team_token || '',
          ecommerce_info: {
            ec_tostore_data: {
              ec_tostore_order_type: tostoreOrderType || 1,
              ec_tostore_appointment_time: tostoreOrderType == 1 || !_this.data.selfAppointmentSwitch ? '' : tostoreDateTime,
              ec_tostore_buyer_phone: _this.data.phone || '',
              ec_tostore_appointment_time_type: _this.data.tostoreTimeType || '',
              ec_tostore_location_id: _this.data.locationId || ''
            },
            intra_city_data: {
              intra_city_appointment_arrive_time: _this.data.sameJourneyTimeType == 1 ? '' : _this.data.sameJourneyDateTime
            }
          },
          voucher_coupon_goods_info: _this.data.exchangeCouponData.voucher_coupon_goods_info,
          settlement_activity_info: _this.data.payGiftOptions
        },
        success: function success(res) {
          if (typeof res.data == 'string') {
            if (!that.data.isFrom && res.data == '已达到抽奖机会购买上限') {
              _app.appMethod.showModal({
                content: res.data
              });
              that.setData({
                num: 1
              });
              return;
            } else {
              _app.appMethod.showModal({
                content: res.data,
                confirm: function confirm() {
                  _app.appMethod.turnBack();
                }
              });
              return;
            }
          }
          var info = res.data;
          var benefits = info.benefit;
          var goods_info = info.goods_info;
          var additional_info_goods = [];
          var selectDiscountInfo = info.select_benefit;
          var suppInfoArr = [];
          var additional_goodsid_arr = [];
          if (that.data.pickUpType == 2 && info.intra_city_status_data && info.intra_city_status_data.in_distance == 0) {
            _app.appMethod.showModal({
              content: '地址不在配送范围内',
              confirmText: '去更换',
              cancelText: '取消',
              showCancel: true,
              confirm: function confirm() {
                that.goSameJourneyAddress();
              },
              cancel: function cancel() {
                that.setData({
                  selectSameJourney: ''
                });
              }
            });
            return;
          }
          var goodsBenefitsData = [],
              goodsPrice = goods_info.virtual_price == '0.00' ? goods_info.original_price : goods_info.virtual_price,
              groupPrice = info.original_price;
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          });
          if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && that.data.exchangeCouponData.hasSelectGoods == false) {
            that.exchangeCouponInit(parseInt(selectDiscountInfo.value));
          }
          if (goods_info.delivery_id && goods_info.delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info.id) == -1) {
            suppInfoArr.push(goods_info.delivery_id);
            additional_goodsid_arr.push(goods_info.goods_id);
            additional_info_goods.push(goods_info);
          }
          var group_buy_price = String(info.original_price - info.group_buy_discount_price);
          if (group_buy_price.split('.')[1]) {
            group_buy_price = Number(group_buy_price).toFixed(2);
          }
          if (suppInfoArr.length && !that.data.deliverydWrite) {
            that.getSuppInfo(suppInfoArr);
          }
          if (+info.settlement_activity_item_price) {
            info.final_price = (+info.final_price + +info.settlement_activity_item_price).toFixed(2);
          }
          that.setData({
            expressAddressNull: info.address ? false : that.data.expressAddressNull,
            goodsPrice: goodsPrice,
            groupPrice: groupPrice,
            goodsInfo: goods_info,
            isFrom: false,
            selectAddress: that.data.pickUpType == 1 && info.address,
            discountList: goodsBenefitsData,
            selectDiscountInfo: selectDiscountInfo,
            express_fee: info.express_fee,
            box_fee: info.box_fee,
            discount_price: info.discount_price,
            balance: info.balance,
            deduction: info.use_balance,
            original_price: info.original_price,
            group_buy_price: group_buy_price,
            totalPayment: info.final_price,
            canCashDelivery: info.is_pay_on_delivery || '',
            noAdditionalInfo: suppInfoArr.length ? false : true,
            cashOnDelivery: info.price > 0 ? that.data.cashOnDelivery : false,
            additional_goodsid_arr: additional_goodsid_arr,
            selectSameJourney: that.data.pickUpType == 2 && info.address,
            sameJourneyImmediatlyTime: info.intra_city_status_data && info.intra_city_status_data.deliver_time || '',
            settlementActivityFreePrice: info.settlement_activity_free_bills_item_price
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
        },
        fail: function fail() {
          _app.appMethod.turnBack();
        }
      });
    };

    _this.closeGoodsPick = function () {
      _this.setData({
        isShowPickMask: false,
        isShowServiceTime: false,
        isShowSameJourneyTime: false
      });
    };

    _this.showServiceTime = function (type) {
      var deliveryData = _this.data.selectDelivery;
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetEcTostoreAppointmentDateList',
        data: {
          sub_shop_app_id: that.franchisee_id || '',
          self_delivery_app_store_id: deliveryData.id || ''
        },
        success: function success(res) {
          var data = res.data;
          if (type == 'onlyImme') {
            that.setData({
              waitingQueueTime: data.duration_time,
              tostoreOrderType: 1
            });
            return;
          }
          var tostoreTimeType = data.setting_data.appointment.appointment_time_type; //1为天 2为时 3为半小时
          var tostoreDateTime = '';
          var tostoreWeekTime = '';
          var dateArr = data.date_arr;
          var advanceAppointmentInfo = data.setting_data.appointment.advance_appointment_info;
          var startHours = new Date().getHours();
          var businessTimeRule = data.business_time_rule; //上门自提营业时间
          var maxEndHour = 24;
          var currentMinute = new Date().getMinutes();
          var showImmediatelyTime = false;
          var noImmediaPick = data.setting_data.immediate_info.status == 1 && advanceAppointmentInfo.type == 1 ? true : false; //判断上门自提立即取货开关开没开
          var noAppointmentShow = true; //是否显示暂无营业时间
          if (businessTimeRule.type == 2) {
            //获取自定义当天营业时间的终止小时
            var week = dateArr[0].week;
            var timeArr = void 0;
            businessTimeRule.custom.business_time.map(function (item) {
              if (week == 0) {
                week = 7;
              }
              if (item.business_week[week - 1] == 1) {
                timeArr = item.business_time_interval;
                maxEndHour = +timeArr[timeArr.length - 1].end_time.substring(0, 2);
              }
            });
            timeArr && timeArr.map(function (item) {
              var sH = Number(item.start_time.substring(0, 2));
              var eH = Number(item.end_time.substring(0, 2));
              var sT = Number(item.start_time.substring(3, 5));
              var eT = Number(item.end_time.substring(3, 5));
              if (startHours > sH && startHours < eH || startHours == sH && currentMinute >= sT) {
                showImmediatelyTime = true;
              }
            });
          } else {
            showImmediatelyTime = true;
          }
          for (var i = 0; i < dateArr.length; i++) {
            if (i == 0 && (advanceAppointmentInfo.type == 2 && +advanceAppointmentInfo.num + startHours >= maxEndHour || advanceAppointmentInfo.type == 1 && startHours >= maxEndHour)) {
              dateArr[i].is_vaild = 0;
            }
            if (dateArr[i].is_vaild == 1 && tostoreTimeType != 1) {
              tostoreDateTime = dateArr[i].date;
              tostoreWeekTime = dateArr[i].week;
              break;
            }
          }
          dateArr.map(function (item) {
            if (item.is_vaild == 1) {
              noAppointmentShow = false;
            }
          });
          that.businessTimeType = businessTimeRule.type;
          that.setData({
            getEcTostoredate: data,
            waitingQueueTime: data.duration_time,
            tostoreTimeType: tostoreTimeType,
            isShowServiceTime: true,
            noImmediaPick: noImmediaPick,
            tostoreDateTime: that.data.tostoreDateTime ? that.data.tostoreDateTime : tostoreDateTime,
            tostoreWeekTime: that.data.tostoreWeekTime ? that.data.tostoreWeekTime : tostoreWeekTime,
            businessTimeRule: businessTimeRule.type == 1 ? '' : businessTimeRule.custom.business_time,
            advanceAppointmentInfo: advanceAppointmentInfo,
            noAppointmentShow: noAppointmentShow,
            showImmediatelyTime: showImmediatelyTime
          });
          if (tostoreTimeType != 1) {
            that.getTostoreTime();
          }
          businessTimeRule.type == 2 && that.getNoAppointmentWord();
        }
      });
    };

    _this.goSameJourneyAddress = function (e) {
      var selectSameJourney = _this.data.selectSameJourney;
      _this.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?from=preview&sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + _this.franchisee_id);
    };

    _this.commentChange = function (e) {
      var value = e.target.value;
      if (value.length > 30) {
        _app.appMethod.showModal({
          content: '最多只能输入30个字'
        });
        value = value.slice(0, 30);
      }
      _this.setData({
        description: value
      });
    };

    _this.inputFormControl = function (e) {
      var a = _this.data.additional_info;
      var b = _this.data.additional_goodsid_arr[0];
      a[b][0].value = e.target.value;
      _this.setData({
        additional_info: a
      });
    };

    _this.getSuppInfo = function (suppInfoArr) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=pc/AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_ids: suppInfoArr,
          sub_shop_app_id: that.franchisee_id || ''
        },
        success: function success(res) {
          for (var i = 0; i < res.data.length; i++) {
            var suppInfo = res.data[i].delivery_info;
            for (var j = 0; j < suppInfo.length; j++) {
              if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
                that.setData({
                  hasRequiredSuppInfo: true
                });
              }
            }
          } // 单商品单补充信息时直接展示
          if (res.data.length == 1 && that.data.additional_goodsid_arr.length == 1) {
            var deliveryIndex = 0;
            var showIndex = 0;
            res.data[0].delivery_info.map(function (item) {
              showIndex++;
              if (item.is_hidden == 1) {
                deliveryIndex++;
              }
            });
            if (deliveryIndex == 1) {
              var data = {};
              data[that.data.additional_goodsid_arr[0]] = [];
              data[that.data.additional_goodsid_arr[0]].push({
                title: res.data[0].delivery_info[showIndex - 1].name,
                type: res.data[0].delivery_info[showIndex - 1].type,
                is_required: res.data[0].delivery_info[showIndex - 1].is_required,
                value: ''
              });
              that.setData({
                additional_info: data,
                aloneDeliveryShow: true
              });
            }
          }
        }
      });
    };

    _this.confirmPayment = function (e) {
      var _data;

      var formid = _this.data.formid,
          that = _this,
          list = _this.data.goodsList,
          tostoreOrderType = _this.data.tostoreOrderType,
          select_benefit = _this.data.selectDiscountInfo,
          hasWritedAdditionalInfo = false;
      formid.push(e.target.formId);
      if (_this.data.pickUpType == 1 && !_this.data.selectAddress) {
        _this.setData({
          expressAddressNull: true
        });
        return;
      }
      if (_this.data.pickUpType == 2 && !_this.data.selectSameJourney) {
        _app.appMethod.showModal({
          content: '请完善地址信息',
          confirmText: '去填写',
          confirm: function confirm() {
            that.goToMyAddress();
          }
        });
        return;
      }
      if (_this.data.pickUpType == 2 && !_this.data.selectSameJourney) {
        _app.appMethod.showModal({
          content: '请选择同城地址',
          confirmText: '去填写',
          confirm: function confirm() {
            that.goSameJourneyAddress();
          }
        });
        return;
      }
      if (_this.data.pickUpType == 2 && !_this.data.sameJourneyDateTime && _this.data.sameJourneyTimeType != 1) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      if (_this.data.pickUpType == 3 && !_this.data.selectDelivery) {
        _app.appMethod.showModal({
          content: '请选择上门自提地址',
          confirmText: '去填写',
          confirm: function confirm() {
            that.toDeliveryList();
          }
        });
        return;
      }
      for (var key in _this.data.additional_info) {
        if (key !== undefined) {
          hasWritedAdditionalInfo = true;
          break;
        }
      }
      if (_this.data.pickUpType == 3 && _this.data.selfAppointmentSwitch && !tostoreOrderType) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      var year = new Date().getFullYear();
      var tostoreDateTime = year + '-' + _this.data.tostoreDateTime + ' ' + (_this.data.tostoreHourTime || '');
      if (_this.data.pickUpType == 3 && _this.data.selfDeliveryPhone == 1 && !util.isPhoneNumber(_this.data.phone)) {
        _app.appMethod.showModal({
          content: '请输入正确的手机号'
        });
        return;
      }
      if (_this.data.hasRequiredSuppInfo && !_this.data.deliverydWrite && !_this.data.aloneDeliveryShow) {
        _app.appMethod.showModal({
          content: '商品补充信息未填写，无法进行支付',
          confirmText: '去填写',
          confirm: function confirm() {
            that.goToAdditionalInfo();
          }
        });
        return;
      }
      if (_this.data.aloneDeliveryShow) {
        var a = _this.data.additional_info;
        var id = _this.data.additional_goodsid_arr[0];
        if (a[id][0].is_required == 0 && a[id][0].value == '') {
          _app.appMethod.showModal({
            content: '请填写' + a[id][0].title,
            confirmText: '确认'
          });
          return;
        }
      }
      if (_this.requesting) {
        return;
      }
      _this.requesting = true;
      var data = {};
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/addOrder',
        method: 'post',
        data: (_data = {
          goods_id: that.data.goods_id,
          activity_id: that.data.activityid,
          sub_shop_app_id: that.franchisee_id || _this.data.parentAppId || '',
          model_id: that.data.model_id || '',
          num: that.data.num,
          num_of_people: that.data.num_of_people,
          team_token: that.data.team_token || '',
          formId: e.target.formId,
          select_benefit: that.data.selectDiscountInfo,
          is_balance: that.data.useBalance ? 1 : 0,
          is_self_delivery: that.data.is_self_delivery,
          self_delivery_app_store_id: that.data.is_self_delivery == 1 ? that.data.selectDelivery.id : '',
          remark: that.data.description,
          address_id: _this.data.pickUpType == 1 ? _this.data.selectAddress.id : _this.data.selectSameJourney.id,
          is_pay_on_delivery: that.data.cashOnDelivery ? 1 : 0,
          additional_info: that.data.additional_info,
          express_fee: that.data.express_fee,
          box_fee: that.data.box_fee,
          ecommerce_info: {
            ec_tostore_data: {
              ec_tostore_order_type: tostoreOrderType || 1,
              ec_tostore_appointment_time: tostoreOrderType == 1 || !_this.data.selfAppointmentSwitch ? '' : tostoreDateTime,
              ec_tostore_buyer_phone: _this.data.phone || '',
              ec_tostore_appointment_time_type: _this.data.tostoreTimeType || '',
              ec_tostore_location_id: _this.data.locationId || ''
            },
            intra_city_data: {
              intra_city_appointment_arrive_time: _this.data.sameJourneyTimeType == 1 ? '' : _this.data.sameJourneyDateTime
            }
          },
          pick_up_type: _this.data.pickUpType
        }, (0, _defineProperty3.default)(_data, 'self_delivery_app_store_id', _this.data.pickUpType == 3 ? _this.data.selectDelivery.id : ''), (0, _defineProperty3.default)(_data, 'voucher_coupon_goods_info', _this.data.exchangeCouponData.voucher_coupon_goods_info), (0, _defineProperty3.default)(_data, 'settlement_activity_info', _this.data.payGiftOptions), _data),
        success: function success(res) {
          var data = res.data;
          if (res.status == 0) {
            if (that.data.cashOnDelivery) {
              var pagePath = '/group/pages/gppaySuccess/gppaySuccess?detail=' + res.data.order_id + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&orderid=' + res.data.order_id + '&teamToken=' + res.data.team_token;
              that.saveUserFormId(function () {
                _app.appMethod.turnToPage(pagePath);
              });
            } else {
              that.payOrder(res.data.order_id, res.data.team_token);
            }
            that.setData({
              team_token: res.data.team_token
            });
          } else {
            _app.appMethod.showModal({
              content: res.data
            });
            return;
          }
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this.additionInfo = function (orderId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/info',
        data: {
          additional_info: that.data.additional_info,
          sub_shop_app_id: that.franchisee_id || '',
          order_id: orderId
        },
        success: function success(res) {}
      });
    };

    _this.payOrder = function (orderId, teamToken) {
      var that = _this;
      function paySuccess() {
        var pagePath = '/group/pages/gppaySuccess/gppaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&teamToken=' + teamToken;
        if (!that.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              sub_shop_app_id: that.franchisee_id || '',
              order_id: orderId
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              that.saveUserFormId(function () {
                _app.appMethod.turnToPage(pagePath, 1);
              });
            }
          });
        } else {
          that.saveUserFormId(function () {
            _app.appMethod.turnToPage(pagePath, 1);
          });
        }
      }
      function payFail() {
        _app.appMethod.sendRequest({
          url: '/index.php?r=appShop/cancelOrder',
          data: {
            sub_shop_app_id: that.franchisee_id || '',
            order_id: orderId
          },
          success: function success() {
            _app.appMethod.turnBack();
          }
        });
      }
      if (_this.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            sub_shop_app_id: that.franchisee_id || '',
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail(orderId);
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail(orderId);
          },
          successShowModalConfirm: function successShowModalConfirm() {
            _app.appMethod.turnBack();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     sub_shop_app_id: that.franchisee_id || '',
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     app.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   },
      //   successShowModalConfirm: function () {
      //     app.turnBack()
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId,
        franchisee: that.franchisee_id,
        successUrl: 'gppaySuccess?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '') + '&is_group=' + !!that.is_group + '&teamToken=' + teamToken,
        cancel: payFail
      });
    };

    _this.showMemberDiscount = function () {
      _this.memberDiscountRef.current.show({
        discountType: _this.data.discountList,
        afterSelectedDiscount: function afterSelectedDiscount(event) {
          _this.afterSelectedBenefit(event);
        }
      });
      _this.memberDiscountRef.current.showDialog(_this.data.selectDiscountInfo);
    };

    _this.afterSelectedBenefit = function (_ref) {
      var selectedDiscount = _ref.selectedDiscount;

      _this.setData({
        selectDiscountInfo: selectedDiscount.name == '无' ? 'no_use_benefit' : selectedDiscount,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this.getCalculationInfo();
    };

    _this.useBalanceChange = function (checked) {
      _this.setData({
        useBalance: checked
      });
      _this.getCalculationInfo();
    };

    _this.useCashDelivery = function (e) {
      if (_this.data.selfPayOnDelivery == 0 && e) {
        _this.setData({
          is_self_delivery: false
        });
      }
      _this.setData({
        cashOnDelivery: e
      });
      _this.getCalculationInfo();
    };

    _this.formSubmit_collect = function (e) {
      var formid = _this.data.formid;
      formid.push(e.target.formId);
    };

    _this.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: that.franchisee_id || '',
          form_id: that.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          that.setData({
            formid: []
          });
        }
      });
    };

    _this.addDeliveryImg = function () {
      var that = _this;
      var a = _this.data.additional_info;
      var b = _this.data.additional_goodsid_arr[0];
      var images = a[b][0].value || [];
      _app.appMethod.chooseImage(function (image) {
        a[b][0].value = images.concat(image);
        that.setData({
          additional_info: a
        });
      }, 9 - a[b][0].value.length);
    };

    _this.deleteImage = function (e) {
      var that = _this;
      var a = _this.data.additional_info;
      var b = _this.data.additional_goodsid_arr[0];
      var index = e.currentTarget.dataset.imageIndex;
      var images = a[b][0].value;
      images.splice(index, 1);
      a[b][0].value = images;
      that.setData({
        additional_info: a
      });
    };

    _this.getNoAppointmentWord = function () {
      var a = '商家营业时间：';
      var b = '';
      var businessTimeRule = _this.data.businessTimeRule;
      businessTimeRule.map(function (item) {
        for (var i = 0; i < item.business_week.length; i++) {
          if (item.business_week[i] == 1) {
            switch (i) {
              case 0:
                a += '周一、';
                break;
              case 1:
                a += '周二、';
                break;
              case 2:
                a += '周三、';
                break;
              case 3:
                a += '周四、';
                break;
              case 4:
                a += '周五、';
                break;
              case 5:
                a += '周六、';
                break;
              case 6:
                a += '周日、';
                break;
            }
          }
        }
        item.business_time_interval.map(function (item) {
          a += item.start_time + '-' + item.end_time + ' ';
        });
      });
      var appointment = _this.data.getEcTostoredate.setting_data.appointment;
      var advanceInfo = appointment.advance_appointment_info;
      switch (advanceInfo.type) {
        case '1':
          b += '无需提前，';
          break;
        case '2':
          b += '需提前' + advanceInfo.num + '小时，';
          break;
        case '3':
          b += '需提前' + advanceInfo.num + '天，';
          break;
      }
      b += '最多可预约' + appointment.valid_days + '天内时间';
      _this.setData({
        noAppointmentWorda: a,
        noAppointmentWordb: b
      });
    };

    _this.getPhoneNumber = function (e) {
      var that = _this;
      if (/getPhoneNumber:fail/.test(e.target.errMsg)) {
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/GetPhoneNumber',
        data: {
          encryptedData: e.target.encryptedData,
          iv: e.target.iv
        },
        success: function success(res) {
          _app.appMethod.setUserInfoStorage({
            phone: res.data
          });
          that.setData({
            phone: res.data
          });
        },
        successStatus5: function successStatus5() {
          _app.appMethod.showModal({
            content: '获取手机号失败，请再次点击授权获取'
          });
          // app.goLogin({
          //   success: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   },
          //   fail: function () {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   }
          // })
        }
      });
    };

    _this.inputPhone = function (e) {
      _this.setData({
        phone: e.target.value
      });
    };

    _this.hidePerfectAddress = function () {
      _this.setData({
        expressAddressNull: false
      });
    };

    _this.getInStoreSeat = function () {
      var that = _this;
      _app.appMethod.scanCode({
        success: function success(res) {
          var path = res.path;
          var locationId = path.split(/\?location_id=/)[1];
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppEcommerce/getEcLocationData',
            data: {
              id: locationId,
              sub_shop_app_id: that.franchisee_id
            },
            success: function success(res) {
              if (res.data.status == 0) {
                that.setData({
                  locationId: locationId,
                  inStoreSeatName: res.data.title
                });
              } else {
                _app.appMethod.showModal({
                  content: '未检索到座位号'
                });
              }
            }
          });
        },
        fail: function fail(res) {
          _app.appMethod.showModal({
            content: '未检索到座位号'
          });
        }
      });
    };

    _this.manuallyAddAddress = function () {
      _this.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress');
    };

    _this.importWeChatAddress = function () {
      var that = _this;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              that.getCalculationInfo();
            }
          });
        }
      });
    };

    _this.selectedPayGift = function (e) {
      var detail = e.detail;

      _this.setData({
        payGiftOptions: detail.options || {}
      });
      _this.getCalculationInfo();
    };

    document.title = '确认订单';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData) {
      _this.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(PreviewGroupOrder, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      var callbackData = this.currentPage.callbackData;

      if (callbackData) {
        this.setData(callbackData);
        this.currentPage.clearCallbackData();
        if (this.currentPage.additional_info) {
          this.additional_info = this.currentPage.additional_info;
          delete this.currentPage.additional_info;
        }
        if (this.currentPage.hasRequiredSuppInfo) {
          this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
          delete this.currentPage.hasRequiredSuppInfo;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this,
          selectmodelObj = JSON.parse(options.selectmodel),
          goods_id = options.goodsid,
          activityid = options.activityid,
          addressId = options.addressId || '',
          pickUpType = options.type || '',
          team_token = options.team_token || '',
          groupType = options.groupType,
          limit_buy = options.limit_buy,
          model_id = selectmodelObj.modelId || '',
          isFrom = options.isFrom,
          selectmodel = selectmodelObj.models_text,
          session_key = _app.appMethod.getStorageSync('session_key');
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      this.franchisee_id = options.franchisee || '';
      this.setData({
        selectmodel: selectmodel,
        team_token: team_token,
        model_id: model_id,
        goods_id: goods_id,
        activityid: activityid,
        num_of_people: options.group_buy_people,
        num: Number(options.num),
        limit_buy: limit_buy,
        isFrom: isFrom,
        groupType: groupType,
        pickUpType: pickUpType,
        sameJourneyTimeType: pickUpType == 2 ? 1 : '',
        selectSameJourneyId: pickUpType == 2 ? addressId : '',
        selectAddressId: pickUpType == 1 ? addressId : '',
        phone: _app.appMethod.getUserInfo().phone,
        parentAppId: options.parent_app_id || ''
      });
      this.getLocation();
      setTimeout(function () {
        that.selectPickMethod('first');
      }, 500);
      // WEBAPP特殊处理(这里是有问题的，待解决)
      setTimeout(function () {
        _this2.handleCurrentPage();
      }, 0);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isFromSelectAddress) {
        this.getCalculationInfo();
        this.isFromSelectAddress = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          discountList = _state.discountList,
          pickUpTypeArr = _state.pickUpTypeArr,
          pickUpType = _state.pickUpType,
          selectAddress = _state.selectAddress,
          selectDelivery = _state.selectDelivery,
          selectSameJourney = _state.selectSameJourney,
          sameJourneyTimeType = _state.sameJourneyTimeType,
          sameJourneyImmediatlyTime = _state.sameJourneyImmediatlyTime,
          sameJourneyDateTime = _state.sameJourneyDateTime,
          selfAppointmentSwitch = _state.selfAppointmentSwitch,
          tostoreDateTime = _state.tostoreDateTime,
          tostoreTimeType = _state.tostoreTimeType,
          tostoreOrderType = _state.tostoreOrderType,
          waitingQueueTime = _state.waitingQueueTime,
          tostoreHourTime = _state.tostoreHourTime,
          onlyImmediatlyPickSwitch = _state.onlyImmediatlyPickSwitch,
          selfDeliveryPhone = _state.selfDeliveryPhone,
          phone = _state.phone,
          selfDeliveryScan = _state.selfDeliveryScan,
          inStoreSeatName = _state.inStoreSeatName,
          goodsInfo = _state.goodsInfo,
          groupType = _state.groupType,
          selectmodel = _state.selectmodel,
          goodsPrice = _state.goodsPrice,
          goodsIndex = _state.goodsIndex,
          num = _state.num,
          is_group = _state.is_group,
          groupPrice = _state.groupPrice,
          selectDiscountInfo = _state.selectDiscountInfo,
          selectDiscountIndex = _state.selectDiscountIndex,
          discount_price = _state.discount_price,
          box_fee = _state.box_fee,
          express_fee = _state.express_fee,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          settlementActivityFreePrice = _state.settlementActivityFreePrice,
          cashOnDelivery = _state.cashOnDelivery,
          totalPayment = _state.totalPayment,
          canCashDelivery = _state.canCashDelivery,
          selfPayOnDelivery = _state.selfPayOnDelivery,
          comment = _state.comment,
          hasRequiredSuppInfo = _state.hasRequiredSuppInfo,
          deliverydWrite = _state.deliverydWrite,
          noAdditionalInfo = _state.noAdditionalInfo,
          aloneDeliveryShow = _state.aloneDeliveryShow,
          additional_info = _state.additional_info,
          additional_goodsid_arr = _state.additional_goodsid_arr,
          intraCityData = _state.intraCityData,
          storeStyle = _state.storeStyle,
          isShowPickMask = _state.isShowPickMask,
          noImmediaPick = _state.noImmediaPick,
          showImmediatelyTime = _state.showImmediatelyTime,
          getEcTostoredate = _state.getEcTostoredate,
          dateIndex = _state.dateIndex,
          tostoreHoursArr = _state.tostoreHoursArr,
          noAppointmentShow = _state.noAppointmentShow,
          noAppointmentWordb = _state.noAppointmentWordb,
          noAppointmentWorda = _state.noAppointmentWorda,
          isShowServiceTime = _state.isShowServiceTime,
          sameJourneyHoursArr = _state.sameJourneyHoursArr,
          isShowSameJourneyTime = _state.isShowSameJourneyTime,
          expressAddressNull = _state.expressAddressNull;

      // 地址选择之后的回调数据

      var _app$getCurrentPage = _app.appMethod.getCurrentPage(),
          callbackData = _app$getCurrentPage.callbackData;

      if (callbackData) {
        selectAddress = callbackData.selectAddress;
        this.state.selectAddress = callbackData.selectAddress;
      }

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          { className: 'official-page preview-group-order' },
          React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u4E0B\u5355' }),
          React.createElement(
            'div',
            { className: 'preview-group-order-wrap', id: 'preview-group-order' },
            React.createElement(
              'div',
              { className: 'preview-group-order-section delivery-method-wrap' },
              React.createElement(
                'div',
                {
                  className: 'pick-method',
                  onClick: pickUpTypeArr && pickUpTypeArr.length > 1 ? this.selectPickMethod : null
                },
                React.createElement(
                  'div',
                  { className: 'pick-method-box' },
                  '\u53D6\u8D27\u65B9\u5F0F',
                  pickUpTypeArr && pickUpTypeArr.length > 1 && React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                  React.createElement(
                    'span',
                    { className: 'pull-right pick-method-title' },
                    pickUpType == 1 ? '快递' : pickUpType == 2 ? '同城' : '自提'
                  )
                )
              ),
              pickUpType == 1 && React.createElement(
                'div',
                { className: 'preview-section' },
                selectAddress && selectAddress.id ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'address-box',
                      onClick: this.goToMyAddress,
                      'data-address-id': selectAddress.id
                    },
                    React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    React.createElement(
                      'div',
                      { className: 'address-detail' },
                      React.createElement(
                        'div',
                        { className: 'buyer-name-box' },
                        React.createElement(
                          'span',
                          { className: 'store-config-label' },
                          '\u5FEB\u9012'
                        ),
                        React.createElement(
                          'span',
                          { className: 'buyer-name' },
                          selectAddress.address_info.name
                        ),
                        React.createElement(
                          'span',
                          null,
                          selectAddress.address_info.contact
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'buyer-address' },
                        selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                      )
                    ),
                    React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'address-null-box',
                      onClick: this.goToMyAddress
                    },
                    React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                      React.createElement(
                        'span',
                        { className: 'add-new-address' },
                        '\u65B0\u589E\u5730\u5740'
                      )
                    )
                  )
                )
              ),
              pickUpType == 3 && React.createElement(
                'div',
                { className: 'preview-section' },
                selectDelivery.id ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'address-box',
                      onClick: this.toDeliveryList,
                      'data-address-id': selectDelivery.id
                    },
                    React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    React.createElement(
                      'div',
                      { className: 'address-detail' },
                      React.createElement(
                        'div',
                        { className: 'buyer-name-box' },
                        React.createElement(
                          'span',
                          { className: 'store-config-label' },
                          '\u81EA\u63D0'
                        ),
                        React.createElement(
                          'span',
                          { className: 'buyer-name' },
                          selectDelivery.contact_name
                        ),
                        React.createElement(
                          'span',
                          null,
                          selectDelivery.service_phone
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'buyer-address' },
                        selectDelivery.region_data.region_string + selectDelivery.address_detail
                      )
                    ),
                    React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'address-null-box',
                      onClick: this.toDeliveryList
                    },
                    React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                    React.createElement(
                      'div',
                      null,
                      React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                      React.createElement(
                        'span',
                        { className: 'add-new-address' },
                        '\u9009\u62E9\u81EA\u63D0\u70B9'
                      )
                    )
                  )
                )
              ),
              pickUpType == 2 && React.createElement(
                'div',
                { className: 'preview-section' },
                selectSameJourney && selectSameJourney.id ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      className: 'address-box',
                      onClick: this.goSameJourneyAddress
                    },
                    React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    React.createElement(
                      'div',
                      { className: 'address-detail' },
                      React.createElement(
                        'div',
                        { className: 'buyer-name-box' },
                        React.createElement(
                          'span',
                          { className: 'store-config-label' },
                          '\u540C\u57CE'
                        ),
                        React.createElement(
                          'span',
                          { className: 'buyer-name' },
                          selectSameJourney.address_info.name
                        ),
                        React.createElement(
                          'span',
                          null,
                          selectSameJourney.address_info.contact
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'buyer-address' },
                        selectSameJourney.address_info.province.text + selectSameJourney.address_info.city.text + selectSameJourney.address_info.district.text + selectSameJourney.address_info.detailAddress
                      )
                    ),
                    React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'address-null-box' },
                    React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                    React.createElement(
                      'div',
                      { onClick: this.goSameJourneyAddress },
                      React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                      React.createElement(
                        'span',
                        { className: 'add-new-address' },
                        '\u9009\u62E9\u540C\u57CE\u5730\u5740'
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'address-bg' },
                React.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/goods-address-bg.png' })
              ),
              pickUpType == 2 && React.createElement(
                'div',
                { className: 'preview-box border-bottom30' },
                React.createElement(
                  'div',
                  {
                    onClick: this.showSameJourneyTime,
                    className: 'single-box'
                  },
                  '\u53D6\u8D27\u65F6\u95F4',
                  React.createElement(
                    'div',
                    { className: 'pull-right appointment-time-box' },
                    React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      sameJourneyTimeType == 1 ? '尽快送达(预计' + (sameJourneyImmediatlyTime || '') + '分钟后送达)' : sameJourneyDateTime ? '大约' + sameJourneyDateTime + '送达' : '请选择送达时间'
                    ),
                    React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                  )
                )
              ),
              pickUpType == 3 && React.createElement(
                'div',
                { className: 'preview-box border-bottom30' },
                selfAppointmentSwitch && React.createElement(
                  'div',
                  {
                    onClick: this.showServiceTime,
                    className: 'single-box'
                  },
                  '\u53D6\u8D27\u65F6\u95F4',
                  React.createElement(
                    'div',
                    { className: 'pull-right appointment-time-box' },
                    tostoreTimeType == 1 && tostoreDateTime && tostoreOrderType == 2 ? React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      dateTrans.date(tostoreDateTime)
                    ) : tostoreTimeType == 1 && tostoreOrderType == 1 ? React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      waitingQueueTime == 0 ? '立即取货' : '大约等待' + waitingQueueTime + '分钟'
                    ) : tostoreTimeType != 1 && tostoreHourTime && tostoreOrderType == 2 ? React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      dateTrans.date(tostoreDateTime) + ' ' + tostoreHourTime
                    ) : tostoreTimeType != 1 && tostoreOrderType == 1 ? React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      dateTrans.date(tostoreDateTime) + (waitingQueueTime == 0 ? ' 立即取货' : '大约等待' + waitingQueueTime + '分钟')
                    ) : React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      '\u8BF7\u9009\u62E9\u65F6\u95F4'
                    ),
                    React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                  )
                ),
                onlyImmediatlyPickSwitch && waitingQueueTime >= 0 && React.createElement(
                  'div',
                  { className: 'single-box' },
                  '\u53D6\u8D27\u65F6\u95F4',
                  React.createElement(
                    'div',
                    { className: 'pull-right appointment-time-box' },
                    React.createElement(
                      'span',
                      { className: 'appointment-time' },
                      waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟'
                    )
                  )
                ),
                selfDeliveryPhone == 1 && React.createElement(
                  'div',
                  { className: 'single-box' },
                  '\u8054\u7CFB\u624B\u673A\u53F7',
                  React.createElement(
                    'div',
                    { className: 'pull-right input-phone-box phone-number-input' },
                    React.createElement('input', {
                      type: 'text',
                      onChange: this.inputPhone,
                      value: phone,
                      placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7'
                    }),
                    React.createElement(
                      'button',
                      {
                        className: 'get-phone-number',
                        onClick: this.getPhoneNumber
                      },
                      '\u81EA\u52A8\u6388\u6743'
                    )
                  )
                ),
                selfDeliveryScan && React.createElement(
                  'div',
                  {
                    className: 'single-box',
                    onClick: this.getInStoreSeat
                  },
                  '\u5E97\u5185\u4F4D\u7F6E',
                  React.createElement(
                    'div',
                    { className: 'pull-right scan-seat-box' },
                    React.createElement(
                      'span',
                      null,
                      inStoreSeatName || '请扫码获取位置信息'
                    ),
                    React.createElement('span', { className: 'ico-moon icon-shopping-scan' })
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-group-order-list preview-group-order-section' },
              React.createElement(
                'div',
                { className: 'preview-group-order-item' },
                React.createElement('img', {
                  className: 'preview-goods-cover',
                  src: goodsInfo.cover,
                  mode: 'aspectFill'
                }),
                React.createElement(
                  'div',
                  { className: 'preview-goods-content' },
                  React.createElement(
                    'div',
                    { className: 'preview-goods-title' },
                    React.createElement(
                      'div',
                      null,
                      groupType != 4 ? React.createElement(
                        React.Fragment,
                        null,
                        '\u62FC\u56E2'
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        '\u62BD\u5956'
                      )
                    ),
                    goodsInfo.goods_name
                  ),
                  selectmodel && React.createElement(
                    'div',
                    { className: 'preview-goods-model' },
                    selectmodel == '""' ? '' : selectmodel
                  ),
                  React.createElement(
                    'div',
                    { className: 'preview-quantity-section' },
                    groupType != 4 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { style: (0, _tools.convertLineStyleData)('display:inline-block;') },
                        React.createElement(
                          'div',
                          { className: 'preview-goods-price' },
                          '¥' + goodsInfo.price
                        ),
                        React.createElement(
                          'div',
                          { className: 'preview-init-price' },
                          '¥' + goodsPrice
                        )
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'preview-goods-price' },
                        '商品价值：¥' + goodsPrice
                      )
                    ),
                    !is_group && React.createElement(
                      'div',
                      { className: 'good-number-box pull-right' },
                      React.createElement(
                        'div',
                        {
                          className: 'goods-minus',
                          'data-index': goodsIndex,
                          onClick: this.clickMinusButton
                        },
                        '-'
                      ),
                      React.createElement('input', {
                        className: 'goods-count',
                        'data-index': goodsIndex,
                        type: 'number',
                        value: num,
                        onChange: this.inputBuyCount
                      }),
                      React.createElement(
                        'div',
                        {
                          className: 'goods-plus',
                          'data-index': goodsIndex,
                          onClick: this.clickPlusButton
                        },
                        '+'
                      )
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-group-order-section preview-box' },
              React.createElement(
                'div',
                { className: 'single-box' },
                groupType != '4' ? React.createElement(
                  React.Fragment,
                  null,
                  '\u5546\u54C1\u62FC\u56E2\u4EF7',
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '¥' + groupPrice
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  '\u62BD\u5956\u91D1\u989D',
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '¥' + groupPrice
                  )
                )
              ),
              discountList && !!discountList.length && React.createElement(
                'div',
                { onClick: this.showMemberDiscount },
                React.createElement(
                  'div',
                  { className: 'balance-switch' },
                  React.createElement(
                    'span',
                    null,
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                  React.createElement(
                    'span',
                    { className: 'pull-right select-discount' },
                    selectDiscountInfo.name
                  )
                ),
                React.createElement(
                  'div',
                  {
                    hidden: selectDiscountIndex == 0,
                    className: 'balance-price'
                  },
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + discount_price
                  )
                )
              ),
              box_fee != 0 && React.createElement(
                'div',
                { className: 'single-box' },
                '\u9910\u76D2\u8D39',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + box_fee
                )
              ),
              React.createElement(
                'div',
                { className: 'single-box' },
                '\u8FD0\u8D39',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + express_fee
                )
              ),
              balance != 0 && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'balance-switch' },
                  React.createElement(
                    'span',
                    null,
                    '\u4F7F\u7528\u50A8\u503C\u91D1'
                  ),
                  React.createElement(_switch2.default, {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('transform:scale(0.8);'),
                    checked: useBalance,
                    onChange: this.useBalanceChange
                  })
                ),
                React.createElement(
                  'div',
                  { hidden: !useBalance, className: 'balance-price' },
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + deduction
                  )
                )
              ),
              totalPayment > 0 && (pickUpType == 1 && canCashDelivery == 1 || pickUpType == 3 && selfPayOnDelivery == 1) && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'balance-switch' },
                  React.createElement(
                    'span',
                    null,
                    '\u8D27\u5230\u4ED8\u6B3E\uFF08\u5148\u4E0B\u5355\uFF0C\u9A8C\u8D27\u540E\u652F\u4ED8\uFF09'
                  ),
                  React.createElement(_switch2.default, {
                    className: 'pull-right',
                    onChange: this.useCashDelivery,
                    checked: cashOnDelivery
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-box' },
              React.createElement(
                'div',
                { className: 'buyer-message single-box' },
                '\u4E70\u5BB6\u7559\u8A00',
                React.createElement(
                  'div',
                  { className: 'pull-right' },
                  React.createElement('input', {
                    className: 'remark',
                    value: comment,
                    onChange: this.commentChange,
                    placeholder: '\u5EFA\u8BAE\u7559\u8A00\u524D\u5148\u4E0E\u5546\u5BB6\u6C9F\u901A'
                  })
                )
              ),
              !noAdditionalInfo && !aloneDeliveryShow && React.createElement(
                'div',
                {
                  className: 'border-top1 single-box',
                  onClick: this.goToAdditionalInfo
                },
                '\u8865\u5145\u4FE1\u606F',
                React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + (hasRequiredSuppInfo && !deliverydWrite ? '#ff7100' : '#666')),
                    className: 'additional-tip pull-right'
                  },
                  deliverydWrite ? '已填写' : '未填写'
                )
              )
            ),
            aloneDeliveryShow && React.createElement(
              React.Fragment,
              null,
              additional_info[additional_goodsid_arr[0]].map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'additional-list preview-box', key: index },
                  item.type == 'text' && React.createElement(
                    'div',
                    { className: 'additional-text' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      React.createElement('input', {
                        type: 'text',
                        onChange: _this3.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'mul-text' && React.createElement(
                    'div',
                    { className: 'additional-textarea' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      React.createElement('textarea', {
                        maxlength: '-1',
                        onChange: _this3.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'picture' && React.createElement(
                    'div',
                    { className: 'additional-picture' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      item.value.map(function (imgSrc, imageIndex) {
                        return React.createElement(
                          'div',
                          { className: 'image-list', key: imageIndex },
                          React.createElement('img', { src: imgSrc }),
                          React.createElement(
                            'label',
                            {
                              className: 'delete-image ico-moon icon-closes',
                              onClick: _this3.deleteImage,
                              'data-image-index': imageIndex
                            },
                            '-'
                          )
                        );
                      }),
                      item.value.length < 9 && React.createElement(
                        'div',
                        {
                          className: 'add-images',
                          onClick: _this3.addDeliveryImg
                        },
                        React.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                        React.createElement(
                          'div',
                          null,
                          '\u6DFB\u52A0\u56FE\u7247'
                        )
                      )
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'bottom-nav' },
              React.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                '\u5408\u8BA1:',
                React.createElement(
                  'span',
                  { className: 'price-count' },
                  '\xA5',
                  React.createElement(
                    'span',
                    null,
                    totalPayment
                  )
                )
              ),
              React.createElement(
                'form',
                null,
                React.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: this.confirmPayment },
                  cashOnDelivery ? '货到付款' : '立即下单'
                )
              )
            )
          ),
          isShowPickMask && React.createElement(
            'div',
            { className: 'goods-pick-mask' },
            React.createElement(
              'div',
              { className: 'goods-pick-box' },
              React.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u66F4\u6362\u53D6\u8D27\u65B9\u5F0F'
              ),
              React.createElement(
                'div',
                { className: 'goods-pick-content' },
                pickUpTypeArr.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { key: index, className: 'goods-pick-menu' },
                    React.createElement(
                      'div',
                      {
                        className: 'pick-detail ' + (item == 2 && (intraCityData.is_enough_price != 1 || intraCityData.in_business_time != 1) ? 'no-achieve-price-box' : '')
                      },
                      React.createElement(
                        'div',
                        { className: 'pick-style' },
                        item == 1 ? '快递' : item == 2 ? '同城配送' : '上门自提'
                      ),
                      item == 2 && intraCityData.in_business_time != 1 ? React.createElement(
                        'div',
                        { className: 'no-achieve-price' },
                        '\u4E0D\u5728\u8425\u4E1A\u65F6\u95F4'
                      ) : item == 2 && intraCityData.is_enough_price != 1 && React.createElement(
                        'div',
                        { className: 'no-achieve-price' },
                        '未达到起送价 还差' + intraCityData.min_deliver_price_balance + '元'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'pick-btn-box' },
                      React.createElement(
                        'span',
                        {
                          style: (0, _tools.convertLineStyleData)(item != 2 || intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 ? 'color:#ff7100;border-color:#ff7100' + (storeStyle && storeStyle.theme) : 'color: #D2D2D2;border-color: #D2D2D2'),
                          onClick: item != 2 || intraCityData.is_enough_price == 1 && intraCityData.in_business_time == 1 ? _this3.deliveryWayChange : null,
                          'data-type': item
                        },
                        '\u9009\u62E9'
                      )
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          isShowServiceTime && React.createElement(
            'div',
            { className: 'goods-pick-mask' },
            React.createElement(
              'div',
              { className: 'goods-pick-box' },
              React.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u9009\u62E9\u53D6\u8D27\u65F6\u95F4'
              ),
              !noAppointmentShow ? React.createElement(
                React.Fragment,
                null,
                tostoreTimeType == 1 && React.createElement(
                  'div',
                  { className: 'goods-pick-content' },
                  noImmediaPick && showImmediatelyTime && React.createElement(
                    'div',
                    {
                      onClick: this.tostoreImmediately,
                      className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : '')
                    },
                    '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                  ),
                  getEcTostoredate.date_arr.map(function (item, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      item.is_vaild == 1 && React.createElement(
                        'div',
                        {
                          onClick: _this3.selectTostoreTime,
                          'data-index': index,
                          className: 'goods-pick-time ' + (tostoreOrderType != 1 && tostoreDateTime == item.date ? 'selected' : '')
                        },
                        dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                      )
                    );
                  })
                ),
                getEcTostoredate.setting_data && tostoreTimeType != 1 && React.createElement(
                  'div',
                  { className: 'double-column-time' },
                  React.createElement(
                    'div',
                    { className: 'double-time-day' },
                    getEcTostoredate.date_arr.map(function (item, index) {
                      return React.createElement(
                        React.Fragment,
                        { key: index },
                        item.is_vaild == 1 && React.createElement(
                          'div',
                          {
                            onClick: _this3.selectTostoreTime,
                            'data-index': index,
                            className: 'goods-pick-time ' + (tostoreDateTime == item.date ? 'selected' : '')
                          },
                          dateTrans.date(item.date) + '(星期' + dateTrans.week(item.week) + ')'
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'double-time-hours' },
                    !dateIndex && showImmediatelyTime && noImmediaPick && React.createElement(
                      'div',
                      {
                        onClick: this.tostoreImmediately,
                        className: 'goods-pick-time ' + (tostoreOrderType == 1 ? 'selected' : '')
                      },
                      '立即取货（' + (waitingQueueTime == 0 ? '无需等待' : '大约等待' + waitingQueueTime + '分钟') + '）'
                    ),
                    tostoreHoursArr && tostoreHoursArr.map(function (item, index) {
                      return React.createElement(
                        'div',
                        {
                          onClick: _this3.selectTostoreHourTime,
                          'data-index': index,
                          className: tostoreHourTime == item ? 'selected' : '',
                          key: index
                        },
                        item
                      );
                    })
                  )
                )
              ) : React.createElement(
                'div',
                { className: 'none-appointment-time' },
                React.createElement('img', {
                  className: 'no-reservation',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/no-reservation.png'
                }),
                React.createElement(
                  'div',
                  { className: 'title' },
                  '\u6682\u65E0\u53EF\u9884\u7EA6\u65F6\u95F4'
                ),
                React.createElement(
                  'div',
                  { className: 'tips' },
                  noAppointmentWordb
                ),
                React.createElement(
                  'div',
                  { className: 'tips' },
                  noAppointmentWorda
                )
              ),
              React.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          isShowSameJourneyTime && React.createElement(
            'div',
            { className: 'goods-pick-mask' },
            React.createElement(
              'div',
              { className: 'goods-pick-box' },
              React.createElement(
                'div',
                { className: 'goods-pick-header' },
                '\u9009\u62E9\u9001\u8FBE\u65F6\u95F4'
              ),
              React.createElement(
                'div',
                { className: 'goods-pick-content goods-same-journey-time' },
                React.createElement(
                  'div',
                  {
                    onClick: this.selectSameJourneyTime,
                    'data-type': 'immedia',
                    className: 'goods-pick-time ' + (sameJourneyTimeType == 1 ? 'selected' : '')
                  },
                  '尽快送达(预计' + sameJourneyImmediatlyTime + '分钟后送达)'
                ),
                sameJourneyHoursArr.map(function (item, index) {
                  return React.createElement(
                    React.Fragment,
                    { key: index },
                    React.createElement(
                      'div',
                      {
                        onClick: _this3.selectSameJourneyTime,
                        'data-type': 'appoint',
                        'data-index': index,
                        className: 'goods-pick-time ' + (sameJourneyTimeType != 1 && sameJourneyDateTime == item ? 'selected' : '')
                      },
                      item
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'goods-pick-bottom', onClick: this.closeGoodsPick },
                '\u5173\u95ED'
              )
            )
          ),
          expressAddressNull && React.createElement(
            'div',
            {
              className: 'perfect-address-mask',
              onClick: this.hidePerfectAddress
            },
            React.createElement(
              'div',
              { className: 'perfect-address-box' },
              React.createElement(
                'div',
                { className: 'perfect-address-title' },
                '\u63D0\u793A'
              ),
              React.createElement(
                'div',
                { className: 'perfect-address-tips' },
                '\u8BF7\u5B8C\u5584\u5730\u5740\u4FE1\u606F~'
              ),
              React.createElement(
                'div',
                { className: 'perfect-address-bottom' },
                React.createElement(
                  'span',
                  { onClick: this.manuallyAddAddress },
                  '\u624B\u52A8\u65B0\u589E\u5730\u5740'
                ),
                React.createElement(
                  'span',
                  {
                    onClick: this.importWeChatAddress,
                    className: 'import-weChat-address'
                  },
                  '\u5BFC\u5165\u5FAE\u4FE1\u5730\u5740'
                )
              )
            )
          )
        ),
        React.createElement(_MemberDiscount.MemberDiscount, { ref: this.memberDiscountRef })
      );
    }
  }]);
  return PreviewGroupOrder;
}(_OfficialPage3.default);

exports.default = PreviewGroupOrder;

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpPaySuccess = function (_OfficialPage) {
  (0, _inherits3.default)(GpPaySuccess, _OfficialPage);

  function GpPaySuccess(props) {
    (0, _classCallCheck3.default)(this, GpPaySuccess);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GpPaySuccess.__proto__ || Object.getPrototypeOf(GpPaySuccess)).call(this, props));

    _this2.state = {
      page: 1,
      status: 0, // 0: 普通页面 1:有集集乐的情况
      orderId: '',
      modelId: '',
      franchiseeId: '',
      collectBenefitData: {}, // 集集乐数据
      starData: [], //集集乐的星 light:已集样式 dark:未集样式
      isFail: true, //刮刮乐未中奖
      isWinning: true, //刮刮乐中奖
      isComfort: true, //刮刮乐安慰奖
      isWhole: true, //刮奖区域是否显示
      scratchId: '', //活动号
      isShowteam: false,
      winingTitle: '',
      isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false,
      goodsData: {
        goods_list: [],
        is_more: 1,
        curpage: 1,
        loading: false,
        loadingFail: false
      },
      needNum: 0,
      formid: []
    };
    _this2.seckillFunc = [];
    _this2.isMore = 1;
    _this2.page = 1;

    _this2.onReachBottom = function () {
      if (_this2.isMore) {
        _this2.loadList();
      }
    };

    _this2.loadList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/goodsList',
        data: {
          page: _this.page,
          page_size: 4,
          status: 1,
          app_id: _this.data.appId,
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        success: function success(res) {
          var rdata = res.data,
              newdata = {},
              compid = 'goodsData',
              goodsList = _this2.data.goodsData.goods_list,
              length = goodsList.length,
              downcountArr = _this.downcountArr || [];
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i];
            f.description = '';
            f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
          }
          var dataArr = res.data;
          newdata[compid + '.goods_list'] = goodsList.concat(dataArr);
          newdata[compid + '.is_more'] = res.is_more;
          newdata[compid + '.curpage'] = 1;
          newdata[compid + '.loading'] = false;
          newdata[compid + '.loadingFail'] = false;
          _this.downcountArr = downcountArr;
          _this.setData(newdata);
          _this.page++;
          _this.isMore = res.is_more;
        }
      });
    };

    _this2.loadMyTeams = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/teamInfo',
        data: {
          team_token: _this.data.team_token
        },
        success: function success(res) {
          if (!res.data.order_info) {
            // 因微信接口有时会很慢，做了个递归处理
            setTimeout(function () {
              _this.loadMyTeams();
            }, 500);
            return;
          }
          var coverList = [],
              myTeams = res.data,
              coverObj = {},
              orderInfo = myTeams.order_info || '',
              goodsDetail = orderInfo.goods_info[0],
              originPrice = goodsDetail.virtual_price == '0.00' ? goodsDetail.original_price : goodsDetail.virtual_price,
              modelId = myTeams.model_id || '',
              maxNum = Number(myTeams.max_user_num) || 0,
              needNum = maxNum - myTeams.current_user_count || '',
              originPrice = myTeams.virtual_price == '0.00' ? myTeams.goods_price : myTeams.virtual_price;
          myTeams.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          if (myTeams.member) {
            var coverTotalArr = myTeams.member || '',
                coverArr = [],
                numLack = myTeams.activity_type == 3 ? maxNum - coverTotalArr.length + 1 : maxNum - coverTotalArr.length,
                numLen = 0,
                coverLoading = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/loading-portrait.png'
            },
                coverUser = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png'
            },
                coverSuccess = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/success-loading.png'
            };
            for (var arrIndex in coverTotalArr) {
              coverObj = {
                isNum: 1,
                image: coverTotalArr[arrIndex]
              };
              coverArr.push(coverObj);
            }
            if (maxNum > 5) {
              switch (coverArr.length) {
                case 1:
                  numLen = 2;
                  break;
                case 2:
                  numLen = 1;
                  break;
                case 3:
                  numLen = 0;
                  break;
              }
              if (coverArr.length < 3) {
                //显示3个用户+1个等待+1个用户
                coverList = coverArr;
                for (var i = 0; i < numLen; i++) {
                  coverList.push(coverUser);
                }
                coverList.push(coverLoading);
                coverList.push(coverUser);
              } else if (coverArr.length >= 3 && coverArr.length < 5) {
                for (var index in coverArr) {
                  if (index < 3) {
                    coverList.push(coverArr[index]);
                  }
                }
                coverList.push(coverLoading);
                coverList.push(coverUser);
              } else if (coverArr.length >= 5) {
                if (coverArr.length < maxNum) {
                  for (var index in coverArr) {
                    if (index < 3) {
                      coverList.push(coverArr[index]);
                    }
                  }
                  coverList.push(coverLoading);
                  coverList.push(coverUser);
                } else {
                  for (var index in coverArr) {
                    if (index < 4) {
                      coverList.push(coverArr[index]);
                    }
                  }
                  coverList.push(coverSuccess);
                }
              }
            } else {
              coverList = coverArr;
              for (var _i = 0; _i < numLack; _i++) {
                coverList.push(coverUser);
              }
            }
          }
          myTeams.server_time = res.current_time;
          myTeams.seckill_end_time = _util2.default.formatTime(new Date(myTeams.expired_time * 1000));
          if (myTeams.current_status == 0 || myTeams.current_status == 1) {
            _this.downcount = _this.beforeGroupDownCount(myTeams, _this, 'myTeams');
          } else if (myTeams.current_status == 2) {
            _this.downcount = _this.duringGroupDownCount(myTeams, _this, 'myTeams');
          }
          if (myTeams.parent_shop_app_id) {
            _this.setData({
              appId: myTeams.parent_shop_app_id,
              franchiseeId: myTeams.app_id
            });
          }
          _this.setData({
            originPrice: originPrice,
            myTeams: myTeams,
            modelId: modelId,
            goodsId: myTeams.goods_id,
            activityId: myTeams.activity_id,
            orderId: orderInfo.order_id,
            member: coverList,
            goodsDetail: orderInfo.goods_info[0],
            needNum: needNum
          });
          _this.loadList();
        }
      });
    };

    _this2.beforeGroupDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 3;
          newData[path + '.current_status'] = 3;
          newData[path + '.server_time'] = formData.seckill_start_time;
          page.setData(newData);
          formData.server_time = formData.seckill_start_time;
          _this.downcount = _this.duringGroupDownCount(formData, page, path);
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.duringGroupDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 4;
          newData[path + '.current_status'] = 4;
          page.setData(newData);
          if (path == 'myTeams') {
            page.loadMyTeams();
          }
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.touchStart = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchMove = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchEnd = function (e) {
      if (!_this2.isStart) return;
      var canvasWidth = _this2.canvasWidth,
          canvasHeight = _this2.canvasHeight,
          minX = _this2.minX,
          minY = _this2.minY,
          maxX = _this2.maxX,
          maxY = _this2.maxY;

      if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
        _this2.ctx.draw();
        _this2.endCallBack && _this2.endCallBack();
        _this2.isStart = false;
        _this2.page.setData({
          isScroll: true
        });
      }
    };

    _this2.getGoldenData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          app_id: that.data.appId,
          sub_shop_app_id: that.data.franchiseeId || ''
        },
        success: function success(data) {
          if (data.data) {
            if (that.data.code) {
              that.setData({
                isWhole: true
              });
            } else {
              that.setData({
                isWhole: false,
                scratchId: data.data
              });
            }
          } else {
            that.setData({
              isWhole: true
            });
          }
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this2.showAreaClick = function () {
      var that = _this2;
      that.setData({
        isShowteam: false
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          app_id: that.data.appId,
          sub_shop_app_id: that.data.franchiseeId || ''
        },
        success: function success(res) {
          var data = res.data;
          that.scratch.start();
          if (data.title == '谢谢参与') {
            that.setData({
              isFail: false
            });
          } else {
            var params = {
              ifWxCoupon: data.card_id || false,
              timestamp: data.timestamp || '',
              signature: data.signature || ''
            };
            if (data.is_comfort) {
              params['isComfort'] = false;
            } else {
              params['isWinning'] = false;
              params['winingTitle'] = data.title;
            }
            that.setData(params);
          }
        }
      });
    };

    _this2.onShareAppMessage = function (res) {
      var that = _this2,
          goods = that.data.goodsDetail,
          myTeams = _this2.data.myTeams || {},
          team_token = myTeams.order_info && myTeams.order_info.team_token,
          type = myTeams.activity_type,
          modelId = _this2.data.modelId,
          joined = myTeams.joined,
          franchiseeParam = _this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '',
          share_path = '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' + team_token + '&orderId=' + that.data.orderId + franchiseeParam,
          share_cover = myTeams.share_cover ? myTeams.share_cover : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
          nickname = _app.appMethod.getUserInfo('nickname'),
          title = myTeams.share_title ? myTeams.share_title : (nickname ? nickname + ' 喊你' : '') + '拼单啦~ ' + (that.data.myTeams && that.data.myTeams.group_buy_price) + '元拼' + (that.data.myTeams && that.data.myTeams.goods_title) + '，火爆抢购中......';
      return {
        path: share_path,
        title: title,
        imageUrl: share_cover,
        success: function success(res) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/getTime',
            data: {
              activity_id: that.data.scratchId,
              type: 'share',
              app_id: that.data.appId,
              sub_shop_app_id: that.data.franchiseeId || ''
            },
            success: function success(res) {}
          });
        },
        fail: function fail(res) {}
      };
    };

    _this2.getCollectBenefitData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
        data: {
          order_id: id,
          app_id: that.data.appId,
          sub_shop_app_id: that.data.franchiseeId || ''
        },
        hideLoading: true,
        success: function success(res) {
          var starData = [];
          for (var i = 0; i < res.data.star_num; i++) {
            starData.push('light');
          }
          for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
            starData.push('dark');
          }
          that.setData({
            collectBenefitData: res.data,
            starData: starData
          });
        }
      });
    };

    _this2.showMyTeam = function () {
      var path = '/group/pages/gpmyOrder/gpmyOrder' + (_this2.data.franchiseeId ? '?franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(path, 1);
      });
    };

    _this2.openNewGroup = function () {
      var myTeams = _this2.data.myTeams;
      if (myTeams.enable_status == '0') {
        _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + myTeams.goods_id + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : ''));
        return;
      }
      var pathUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + _this2.data.myTeams.goods_id + '&activity_id=' + _this2.data.myTeams.activity_id + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pathUrl);
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({
        url: '/pages/' + router + '/' + router
      });
    };

    _this2.gotoDetail = function (e) {
      var _this = _this2,
          data = e.currentTarget.dataset,
          pageUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + (_this.data.franchiseeId ? '&franchisee=' + _this.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this2.goToOrderDetail = function () {
      var that = _this2;
      var groupPath = '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var pagePath = '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var appointmentPath = '/eCommerce/pages/appointmentOrderDetail/appointmentOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      var newAppointmentPath = '/newAppointment/pages/newAppointmentOrderDetail/newAppointmentOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      that.saveUserFormId(function () {
        if (this.data.is_group == 'true') {
          _app.appMethod.turnToPage(groupPath, true);
        } else if (this.data.code) {
          _app.appMethod.turnToPage(appointmentPath, true);
        } else if (this.data.is_newAppointment) {
          _app.appMethod.turnToPage(newAppointmentPath, true);
        } else {
          _app.appMethod.turnToPage(pagePath, true);
        }
      });
    };

    _this2.goToGroupDetail = function () {
      var pageUrl = '/group/pages/gporderDetail/gporderDetail?from=paySuccess' + '&teamtoken=' + _this2.data.myTeams.order_info.team_token + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this2.getOrderDetail = function () {
      var _this = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: _this.data.orderId,
          app_id: _this.data.appId,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            orderInfo: res.data[0].form_data
          });
        }
      });
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              app_id: _this.data.appId,
              sub_shop_app_id: _data.franchiseeId || '',
              activity_id: _data.scratchId
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
            }
          });
        }
      });
    };

    _this2.turnToGoodsDetail = function () {
      var pageUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + _this2.data.myTeams.goods_id + '&activity_id=' + _this2.data.myTeams.activity_id + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this2.inviteFriends = function () {
      var that = _this2;
      var myTeams = _this2.data.myTeams;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/getShareQRCode',
        data: {
          goods_id: myTeams.goods_id,
          activity_id: myTeams.activity_id,
          app_id: that.data.appId,
          sub_shop_app_id: that.data.franchiseeId || '',
          type: 6,
          text: myTeams.goods_title,
          price: myTeams.group_buy_price,
          virtual_price: that.data.originPrice,
          goods_img: myTeams.img_urls ? myTeams.img_urls[0] : myTeams.goods_cover,
          sub_shop_id: that.data.franchiseeId,
          user_token: _app.appMethod.globalData.PromotionUserToken || '',
          team_token: myTeams.order_info.team_token,
          order_id: myTeams.order_info.order_id
        },
        success: function success(res) {
          // animation.bottom('0').step()
          // that.setData({
          //   'pageQRCodeData.shareDialogShow': 0,
          //   'pageQRCodeData.shareMenuShow': true,
          //   'pageQRCodeData.goodsInfo': res.data,
          //   'pageQRCodeData.animation': animation.export()
          // })
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': res.data
            }
          });
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.data.franchiseeId);
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          app_id: _this.data.appId,
          sub_shop_app_id: _this.data.franchiseeId || '',
          form_id: _this.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    document.title = '支付成功';
    return _this2;
  }

  (0, _createClass3.default)(GpPaySuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      if (options.collectBenefit == 1) {
        that.getCollectBenefitData(options.detail);
        that.setData({
          status: 1
        });
      }
      that.setData({
        team_token: options.teamToken,
        orderId: options.detail,
        franchiseeId: options.franchisee || '',
        is_group: options.is_group || '',
        code: options.code || '',
        is_newAppointment: options.is_newAppointment || ''
      });
      that.getOrderDetail();
      this.loadMyTeams();
      this.getAppECStoreConfig();
      that.getGoldenData(options.detail);
      var systemInfo = _app.appMethod.globalData.systemInfo || {};
      var width = 558 * systemInfo.windowWidth / 750;
      var height = 258 * systemInfo.windowWidth / 750;

      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              isShowteam: true
            });
          }, 10);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcount) {
        this.downcount.clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageQRCodeData = _state.pageQRCodeData,
          myTeams = _state.myTeams,
          goodsDetail = _state.goodsDetail,
          originPrice = _state.originPrice,
          goodsInfo = _state.goodsInfo,
          needNum = _state.needNum,
          member = _state.member,
          collectBenefitData = _state.collectBenefitData,
          starData = _state.starData,
          status = _state.status,
          isWhole = _state.isWhole,
          isFail = _state.isFail,
          isWinning = _state.isWinning,
          winingTitle = _state.winingTitle,
          isComfort = _state.isComfort,
          ifGetComfort = _state.ifGetComfort,
          ifWxCoupon = _state.ifWxCoupon,
          hideCanvas = _state.hideCanvas,
          scratch = _state.scratch,
          isScroll = _state.isScroll,
          isShowteam = _state.isShowteam,
          ifUserInfo = _state.ifUserInfo,
          userInfo = _state.userInfo,
          userInfoCollectConfig = _state.userInfoCollectConfig,
          isGetPhoneNumber = _state.isGetPhoneNumber,
          todayDate = _state.todayDate,
          userCityArr = _state.userCityArr,
          vipCardInfo = _state.vipCardInfo,
          isShowVipCardDialog = _state.isShowVipCardDialog,
          orderId = _state.orderId,
          franchisee = _state.franchisee,
          goodsData = _state.goodsData;


      return React.createElement(
        'div',
        { className: 'official-page gp-pay-success' },
        React.createElement(_TopNav.TopNav, { title: '\u652F\u4ED8\u6210\u529F' }),
        React.createElement(
          'div',
          { className: 'collage-paySuccess' },
          React.createElement(
            'div',
            {
              className: 'collage-section collage-goods',
              style: (0, _tools.convertLineStyleData)('background:url(' + (myTeams && myTeams.activity_info && myTeams.activity_info.pay_success_img || 'https://img.zhichiwangluo.com/zcimgdir/album/file_5c35b5412bd8d.jpg') + ') no-repeat top;background-size:100%;')
            },
            React.createElement(
              'div',
              {
                className: 'goods-infor  isRelative',
                onClick: this.turnToGoodsDetail
              },
              React.createElement(
                'div',
                { className: 'goods-detail' },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: myTeams && myTeams.goods_cover })
                ),
                React.createElement(
                  'div',
                  { className: 'content-wrap' },
                  React.createElement(
                    'div',
                    { className: 'title' },
                    React.createElement(
                      'div',
                      { className: 'classify-type' },
                      React.createElement(
                        'div',
                        null,
                        React.createElement('i', { className: 'ico-moon icon-number-people' })
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams && myTeams.activity_type == 0 ? myTeams.max_user_num + '人团' : myTeams && myTeams.activity_type == 1 ? '新人团' : myTeams && myTeams.activity_type == 2 ? '阶梯团' : myTeams && myTeams.activity_type == 3 ? '帮帮团' : '抽奖团'
                      )
                    ),
                    goodsDetail && goodsDetail.goods_name
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    React.createElement(
                      'label',
                      { className: 'min-price' },
                      '\xA5',
                      React.createElement(
                        'span',
                        null,
                        myTeams && myTeams.group_buy_price
                      )
                    ),
                    React.createElement(
                      'span',
                      { className: 'origin-price' },
                      '¥' + originPrice
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section collage-infor' },
              myTeams && myTeams.activity_type != 4 ? React.createElement(
                React.Fragment,
                null,
                myTeams.current_status == 2 && React.createElement(
                  'div',
                  { className: 'loading-stand' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    React.createElement(
                      'div',
                      null,
                      myTeams.activity_type != '2' ? React.createElement(
                        React.Fragment,
                        null,
                        '\u8FD8\u5DEE',
                        React.createElement(
                          'span',
                          { className: 'needNum' },
                          needNum + '人'
                        ),
                        '\u62FC\u8D2D\u6210\u529F, \u5269\u4F59'
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        '\u4EBA\u6570\u8D8A\u591A, \u4EF7\u683C\u8D8A\u4F4E, \u5269\u4F59'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'countDown' },
                      (myTeams.downCount.days != '00' || myTeams.downCount.days != '0') && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          null,
                          myTeams.downCount.days
                        ),
                        React.createElement(
                          'span',
                          null,
                          '\u5929'
                        )
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams.downCount.hours
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                        myTeams.downCount.minutes
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                        myTeams.downCount.seconds
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-cover' },
                    member.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement('img', {
                          src: item.image,
                          style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                        }),
                        index == 0 && React.createElement(
                          'div',
                          { className: 'leader-logo' },
                          '\u56E2\u957F'
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'btn-wrap' },
                    React.createElement(
                      'div',
                      {
                        className: 'open-new isRelative',
                        onClick: this.inviteFriends
                      },
                      '\u9080\u8BF7\u597D\u53CB\u53C2\u56E2'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'show-own isRelative',
                        onClick: this.showMyTeam
                      },
                      '\u67E5\u770B\u6211\u7684\u62FC\u56E2'
                    )
                  )
                ),
                myTeams.current_status == 3 && React.createElement(
                  'div',
                  { className: 'success-stand' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    myTeams.activity_type == 3 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                        '\u62FC\u56E2\u6210\u529F\uFF0C'
                      ),
                      '\u5546\u5BB6\u5C06\u7ED9\u56E2\u957F\u53D1\u8D27'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                        '\u62FC\u8D2D\u6210\u529F\uFF0C'
                      ),
                      '\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u53D1\u8D27'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-cover' },
                    member.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement('img', {
                          src: item.image,
                          style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                        }),
                        index == 0 && React.createElement(
                          'div',
                          { className: 'leader-logo' },
                          '\u56E2\u957F'
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'btn-wrap' },
                    React.createElement(
                      'div',
                      {
                        className: 'open-new isRelative',
                        onClick: this.openNewGroup
                      },
                      '\u5F00\u542F\u65B0\u56E2'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'show-own isRelative',
                        onClick: this.showMyTeam
                      },
                      '\u67E5\u770B\u6211\u7684\u62FC\u56E2'
                    )
                  )
                ),
                (myTeams.current_status == 4 || myTeams.current_status == 5) && React.createElement(
                  'div',
                  { className: 'fail-stand' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    React.createElement(
                      'div',
                      null,
                      '\u8D85\u8FC7\u65F6\u9650,',
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                        '\u56E2\u5DF2\u8FC7\u671F'
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-cover' },
                    member.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement('img', {
                          src: item.image,
                          style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                        }),
                        index == 0 && React.createElement(
                          'div',
                          { className: 'leader-logo' },
                          '\u56E2\u957F'
                        )
                      );
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'btn-wrap' },
                    React.createElement(
                      'div',
                      {
                        className: 'open-new isRelative',
                        onClick: this.openNewGroup
                      },
                      '\u5F00\u542F\u65B0\u56E2'
                    )
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                myTeams && myTeams.current_status == 2 && React.createElement(
                  'div',
                  { className: 'success-draw' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    React.createElement(
                      'div',
                      null,
                      '\u62BD\u5956\u7ED3\u679C\u5C06\u4E8E',
                      React.createElement(
                        'div',
                        { className: 'countDown' },
                        (myTeams.downCount.days != '00' || myTeams.downCount.days != '0') && React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            null,
                            myTeams.downCount.days
                          ),
                          React.createElement(
                            'span',
                            null,
                            '\u5929'
                          )
                        ),
                        React.createElement(
                          'span',
                          null,
                          myTeams.downCount.hours
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          myTeams.downCount.minutes
                        ),
                        React.createElement(
                          'span',
                          null,
                          ':'
                        ),
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                          myTeams.downCount.seconds
                        )
                      ),
                      '\u540E\u63ED\u6653'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-cover' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/question-mask.png'
                      })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'btn-wrap' },
                    React.createElement(
                      'div',
                      {
                        className: 'open-new isRelative',
                        onClick: this.inviteFriends
                      },
                      '\u9080\u8BF7\u597D\u53CB'
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'show-own isRelative',
                        onClick: this.showMyTeam
                      },
                      '\u67E5\u770B\u6211\u7684\u62FC\u56E2',
                      React.createElement(
                        'form',
                        { className: 'getFormId' },
                        React.createElement('button', {
                          type: 'button',
                          onClick: this.formSubmit_collect,
                          'data-id': goodsInfo && goodsInfo.id,
                          'data-orderid': goodsInfo && goodsInfo.order_id,
                          'data-bargainid': goodsInfo && goodsInfo.bargain_id,
                          className: 'invisibleclass'
                        })
                      )
                    )
                  )
                ),
                myTeams && myTeams.current_status == 3 && myTeams.is_winner == 1 && React.createElement(
                  'div',
                  { className: 'success-draw' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    React.createElement(
                      'div',
                      null,
                      '\u8FD0\u6C14\u7206\u68DA\uFF01',
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                        '\u4E2D\u5956\u5566'
                      ),
                      '\uFF5E'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'member-cover' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        src: myTeams.winner,
                        style: (0, _tools.convertLineStyleData)('border: 2rpx solid #ff7100;')
                      })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'btn-wrap' },
                    React.createElement(
                      'div',
                      {
                        className: 'open-new isRelative',
                        onClick: this.goToGroupDetail
                      },
                      '\u67E5\u770B\u6211\u7684\u62FC\u56E2'
                    )
                  )
                ),
                myTeams && (myTeams.current_status == 4 || myTeams.current_status == 5 || myTeams.is_winner == 0) && React.createElement(
                  'div',
                  { className: 'loading-draw' },
                  React.createElement(
                    'div',
                    { className: 'tip' },
                    myTeams.is_winner == 0 ? React.createElement(
                      React.Fragment,
                      null,
                      '\u5F88\u9057\u61BE\uFF0C\u60A8\u672A\u4E2D\u5956'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '\u5F88\u9057\u61BE\uFF0C\u672C\u6B21\u6D3B\u52A8\u672A\u8FBE\u5230\u5F00\u5956\u95E8\u69DB'
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'member-cover',
                      style: (0, _tools.convertLineStyleData)('margin-bottom:50rpx;width:165rpx;height:165rpx;')
                    },
                    React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/draw-fail.png' })
                  )
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'collage-section' },
            status == 1 && React.createElement(
              'div',
              { className: 'collect-benefit-area' },
              React.createElement(
                'div',
                { className: 'activity-box' },
                React.createElement('div', { className: 'line' }),
                React.createElement(
                  'div',
                  { className: 'activity-title' },
                  '\u6D3B\u52A8'
                ),
                React.createElement('div', { className: 'line' })
              ),
              React.createElement(
                'div',
                { className: 'collect-item' },
                React.createElement(
                  'div',
                  { className: 'star-num' },
                  '集集乐个数: ' + collectBenefitData.star_num
                ),
                React.createElement(
                  'div',
                  { className: 'star-list' },
                  starData.map(function (item, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      item == 'light' ? React.createElement('img', {
                        className: 'star-item',
                        src: collectBenefitData.light_img
                      }) : item == 'dark' && React.createElement('img', {
                        className: 'star-item',
                        src: collectBenefitData.dark_img
                      })
                    );
                  })
                ),
                collectBenefitData.star_num == collectBenefitData.collect_num && React.createElement(
                  'div',
                  { className: 'star-full' },
                  React.createElement(
                    'div',
                    { className: 'star-full-text' },
                    '\u6EE1'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'tip-item' },
                collectBenefitData.star_num == collectBenefitData.collect_num ? React.createElement(
                  'div',
                  null,
                  '获得一张' + collectBenefitData.coupon_title
                ) : collectBenefitData.star_num != collectBenefitData.collect_num && React.createElement(
                  'div',
                  null,
                  '消费' + (collectBenefitData.play_type == 0 ? '每满' : '超过') + collectBenefitData.value + '元，累计一颗星，集满可获得' + collectBenefitData.coupon_title + '一张'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchWhole', hidden: isWhole },
              React.createElement(
                'div',
                { className: 'activity-box scratch-activity' },
                React.createElement('div', { className: 'line' }),
                React.createElement(
                  'div',
                  { className: 'activity-title' },
                  '\u6D3B\u52A8'
                ),
                React.createElement('div', { className: 'line' })
              ),
              React.createElement(
                'div',
                { className: 'scratchArea' },
                React.createElement(
                  'div',
                  { className: 'scratchFail', hidden: isFail },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png' }),
                  React.createElement(
                    'div',
                    { className: 'failTitle' },
                    React.createElement(
                      'div',
                      { className: 'failShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    React.createElement(
                      'div',
                      { className: 'failText' },
                      '\u5F88\u9057\u61BE\u6CA1\u6709\u4E2D\u5956\u54E6'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchWinning', hidden: isWinning },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png' }),
                  React.createElement(
                    'div',
                    { className: 'winningTitle' },
                    React.createElement(
                      'div',
                      { className: 'winningShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    React.createElement(
                      'div',
                      { className: 'winningText' },
                      '\u606D\u559C\u4F60\u83B7\u5F97\u4E86'
                    ),
                    React.createElement(
                      'div',
                      { className: 'winningText winningValue' },
                      winingTitle
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchComfort', hidden: isComfort },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png' }),
                  React.createElement(
                    'div',
                    { className: 'comfortTitle' },
                    React.createElement(
                      'div',
                      { className: 'comfortShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    ifGetComfort ? React.createElement(
                      'div',
                      { className: 'comfortText' },
                      '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                    ) : React.createElement(
                      'div',
                      (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                      '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                    ),
                    !ifWxCoupon && !ifGetComfort && React.createElement(
                      'div',
                      { className: 'comfortText' },
                      '>\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'scratch_wp',
                    hidden: hideCanvas,
                    style: (0, _tools.convertLineStyleData)('width: ' + (scratch && scratch.width) + 'px; height: ' + (scratch && scratch.height) + 'px;')
                  },
                  React.createElement('canvas', {
                    className: 'scratch-canvas',
                    width: scratch && scratch.width,
                    height: scratch && scratch.height,
                    id: 'scratch-canvas',
                    onTouchStart: this.touchStart,
                    onTouchMove: this.touchMove,
                    onTouchEnd: this.touchEnd
                  }),
                  isShowteam && React.createElement(
                    'div',
                    { className: 'showArea' },
                    React.createElement(
                      'div',
                      { className: 'showTitle' },
                      '\u8D62\u53D6\u4F18\u60E0\u5927\u5956'
                    ),
                    React.createElement(
                      'div',
                      { className: 'showBtn', onClick: this.showAreaClick },
                      '\u70B9\u6211\u522E\u5956'
                    )
                  )
                )
              )
            ),
            isShowVipCardDialog && React.createElement(
              'div',
              {
                className: 'vipCard-dialog',
                onClick: this.closeVipCardDialog,
                'data-type': 'shadow'
              },
              !ifUserInfo && React.createElement(
                'div',
                { className: 'content' },
                React.createElement(
                  'div',
                  {
                    className: 'top-block',
                    style: (0, _tools.convertLineStyleData)('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-dialog-head2.png);')
                  },
                  React.createElement(
                    'span',
                    { className: 'text' },
                    '\u8BF7\u586B\u5199\u4F1A\u5458\u4FE1\u606F'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'vip-info' },
                  userInfoCollectConfig.collect_username == 1 && React.createElement(
                    'div',
                    { className: 'info-item' },
                    React.createElement(
                      'div',
                      { className: 'item-name' },
                      '\u59D3\u540D'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item-right' },
                      React.createElement('input', {
                        type: 'text',
                        placeholder: '\u8BF7\u586B\u5199\u59D3\u540D',
                        maxlength: '10',
                        value: userInfo.nickname,
                        'data-type': 'name',
                        onInput: this.inputUserInfo
                      })
                    )
                  ),
                  userInfoCollectConfig.collect_phone == 1 && React.createElement(
                    'div',
                    { className: 'info-item' },
                    React.createElement(
                      'div',
                      { className: 'item-name' },
                      '\u7535\u8BDD'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item-right' },
                      React.createElement('input', {
                        type: 'number',
                        disabled: 'true',
                        placeholder: '\u8BF7\u6388\u6743\u624B\u673A\u53F7\u7801',
                        value: userInfo.phone,
                        'data-type': 'phone',
                        onInput: this.inputUserInfo
                      }),
                      isGetPhoneNumber && React.createElement(
                        'button',
                        {
                          className: 'get-authorize',
                          style: (0, _tools.convertLineStyleData)('background-color: #D2D2D2')
                        },
                        '\u5DF2\u6388\u6743'
                      ),
                      !isGetPhoneNumber && React.createElement(
                        'button',
                        {
                          className: 'get-authorize',
                          style: (0, _tools.convertLineStyleData)('background-color: #FF7100'),
                          onGetphonenumber: this.getPhoneNumber
                        },
                        '\u83B7\u5F97\u6388\u6743'
                      )
                    )
                  ),
                  userInfoCollectConfig.collect_birthday == 1 && React.createElement(
                    'div',
                    { className: 'info-item' },
                    React.createElement(
                      'div',
                      { className: 'item-name' },
                      '\u751F\u65E5'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item-right' },
                      React.createElement(
                        _picker2.default,
                        {
                          mode: 'date',
                          value: userInfo.birthday,
                          start: '1900-01-01',
                          end: todayDate,
                          onChange: this.bindBirthdayChange
                        },
                        React.createElement(
                          'div',
                          {
                            className: 'picker',
                            style: (0, _tools.convertLineStyleData)('color: ' + (userInfo.birthday === '' ? '#999' : '#000'))
                          },
                          userInfo.birthday === '' ? '请选择生日信息' : userInfo.birthday
                        )
                      ),
                      React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                    )
                  ),
                  userInfoCollectConfig.collect_region == 1 && React.createElement(
                    'div',
                    { className: 'info-item' },
                    React.createElement(
                      'div',
                      { className: 'item-name' },
                      '\u57CE\u5E02'
                    ),
                    React.createElement(
                      'div',
                      { className: 'item-right' },
                      React.createElement(
                        _picker2.default,
                        {
                          mode: 'region',
                          onChange: this.bindCityChange,
                          value: userCityArr
                        },
                        React.createElement(
                          'div',
                          {
                            className: 'picker',
                            style: (0, _tools.convertLineStyleData)('color: ' + (userCityArr[0] === '' ? '#999' : '#000'))
                          },
                          userCityArr[0] === '' ? '请填写所在城市' : userCityArr[0] + userCityArr[1] + userCityArr[2]
                        )
                      ),
                      React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'save-btn', onClick: this.saveUserInfo },
                    '\u7ACB\u5373\u9886\u53D6'
                  )
                ),
                React.createElement('div', {
                  className: 'ico-moon icon-closed',
                  'data-type': 'shadow'
                })
              ),
              ifUserInfo && React.createElement(
                'div',
                { className: 'content' },
                React.createElement(
                  'div',
                  {
                    className: 'top-block',
                    style: (0, _tools.convertLineStyleData)('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-dialog-head.png);')
                  },
                  React.createElement(
                    'div',
                    { className: 'text-block' },
                    React.createElement(
                      'div',
                      { className: 'success-text' },
                      '\u6CE8\u518C\u4F1A\u5458\u6210\u529F'
                    ),
                    React.createElement(
                      'div',
                      { className: 'success-text' },
                      '\u606D\u559C\u83B7\u5F97\u4EE5\u4E0B\u6743\u76CA'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'interests-block' },
                  vipCardInfo.discount && React.createElement(
                    'div',
                    { className: 'interests-item' },
                    React.createElement('img', {
                      className: 'icon',
                      src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/discount-icon.svg'
                    }),
                    React.createElement(
                      'div',
                      { className: 'count' },
                      vipCardInfo.discount + '折'
                    ),
                    React.createElement(
                      'div',
                      { className: 'text' },
                      '\u4F1A\u5458\u6298\u6263'
                    )
                  ),
                  vipCardInfo.coupon_list && vipCardInfo.coupon_list.length && React.createElement(
                    'div',
                    { className: 'interests-item' },
                    React.createElement('img', {
                      className: 'icon',
                      src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/coupon-icon.svg'
                    }),
                    React.createElement(
                      'div',
                      { className: 'count' },
                      vipCardInfo.coupon_list.length + '张'
                    ),
                    React.createElement(
                      'div',
                      { className: 'text' },
                      '\u4F1A\u5458\u8D60\u9001'
                    )
                  ),
                  vipCardInfo.integral && vipCardInfo.integral != 0 && React.createElement(
                    'div',
                    { className: 'interests-item' },
                    React.createElement('img', {
                      className: 'icon',
                      src: 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/integral-icon.svg'
                    }),
                    React.createElement(
                      'div',
                      { className: 'count' },
                      vipCardInfo.integral + '+'
                    ),
                    React.createElement(
                      'div',
                      { className: 'text' },
                      '\u79EF\u5206\u8D60\u9001'
                    )
                  )
                ),
                React.createElement('div', {
                  className: 'ico-moon icon-closed',
                  'data-type': 'shadow'
                })
              )
            )
          ),
          goodsData.goods_list.length > 0 && React.createElement(
            'div',
            { className: 'collage-section collage-more' },
            React.createElement(
              'div',
              { className: 'collage-section title' },
              '\u66F4\u591A\u7CBE\u5F69\u62FC\u56E2'
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'goods-list opposite' },
                goodsData.goods_list.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'goods-item isRelative',
                      key: item.goods_id,
                      'data-goodsid': item.goods_id,
                      'data-activityid': item.activity_id,
                      onClick: _this3.gotoDetail
                    },
                    React.createElement(
                      'div',
                      { className: 'image-wrap' },
                      React.createElement('img', { src: item.cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'content-wrap' },
                      React.createElement(
                        'div',
                        { className: 'title' },
                        React.createElement(
                          'div',
                          { className: 'classify-type' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('i', { className: 'ico-moon icon-number-people' })
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.activity_type == 0 ? item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团'
                          )
                        ),
                        item.title
                      ),
                      item.salesnum ? React.createElement(
                        'div',
                        { className: 'hava-sales' },
                        React.createElement(
                          'div',
                          { className: 'price' },
                          React.createElement(
                            'span',
                            { className: 'min-price' },
                            '\xA5',
                            React.createElement(
                              'span',
                              null,
                              item.group_buy_price
                            )
                          ),
                          React.createElement(
                            'span',
                            { className: 'origin-price' },
                            '¥' + item.original_price
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'status' },
                          React.createElement(
                            'div',
                            { className: 'sales' },
                            '已团' + item.salesnum + '件'
                          ),
                          React.createElement(
                            'div',
                            { className: 'to-join' },
                            item.status == 0 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'ready' },
                                '\u5373\u5C06\u5F00\u56E2'
                              )
                            ) : item.status == 1 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'remain' },
                                '\u63D0\u9192\u6211'
                              )
                            ) : item.status == 2 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'reminded' },
                                '\u5DF2\u63D0\u9192'
                              )
                            ) : item.status == 3 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'go' },
                                '\u53BB\u62FC\u56E2'
                              )
                            ) : item.status == 4 && React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'over' },
                                '\u5DF2\u7ED3\u675F'
                              )
                            )
                          )
                        )
                      ) : React.createElement(
                        'div',
                        { className: 'no-sales' },
                        React.createElement(
                          'div',
                          { className: 'price' },
                          React.createElement(
                            'div',
                            { className: 'min-price' },
                            '\xA5',
                            React.createElement(
                              'span',
                              null,
                              item.group_buy_price
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'origin-price' },
                            '¥' + item.original_price
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'to-join' },
                          item.status == 0 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'ready' },
                              '\u5373\u5C06\u5F00\u56E2'
                            )
                          ) : item.status == 1 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'remain' },
                              '\u63D0\u9192\u6211'
                            )
                          ) : item.status == 2 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'reminded' },
                              '\u5DF2\u63D0\u9192'
                            )
                          ) : item.status == 3 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'go' },
                              '\u53BB\u62FC\u56E2'
                            )
                          ) : item.status == 4 && React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'over' },
                              '\u5DF2\u7ED3\u675F'
                            )
                          )
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return GpPaySuccess;
}(_OfficialPage3.default);

exports.default = GpPaySuccess;

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(583);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpMyOrder = function (_OfficialPage) {
  (0, _inherits3.default)(GpMyOrder, _OfficialPage);

  function GpMyOrder(props) {
    (0, _classCallCheck3.default)(this, GpMyOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GpMyOrder.__proto__ || Object.getPrototypeOf(GpMyOrder)).call(this, props));

    _this2.state = {
      haveData: true,
      goodsList: [],
      isLeader: true,
      sub_shop_app_id: '',
      type: 0,
      formid: [],
      shareInfo: {
        group_price: '',
        share_cover: '',
        share_title: ''
      }
    };
    _this2.page = 1;
    _this2.isMore = 1;

    _this2.pageInit = function () {
      var _this = _this2;
      if (_app.appMethod.isLogin()) {
        _this.loadAll();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            _this.loadAll();
          }
        });
      }
    };

    _this2.loadAll = function () {
      var _this = _this2;
      _this.loadMyTeams();
    };

    _this2.loadMyTeams = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/myTeams',
        data: {
          page: _this.page,
          status: _this.data.type,
          is_leader: _this.data.isLeader ? '1' : '0',
          page_size: 10,
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        success: function success(res) {
          if (_this.isMore === 0) {
            return;
          }
          var expired = '',
              nowdate = '',
              goodsList = _this.data.goodsList.concat(res.data);
          for (var index in goodsList) {
            ;goodsList[index].index = index, nowdate = res.current_time * 1000;
            expired = _this.countTime(goodsList[index].expired_time * 1000 - nowdate);
            goodsList[index].expired = '(距结束约' + (expired[0] != '00' ? expired[0] + '天' : expired[1] != '00' ? expired[1] + '小时' : expired[2] != '00' ? expired[2] + '分' : expired[3] != '00' ? '1分' : '') + ')';
          }
          _this.setData({
            goodsList: goodsList,
            haveData: goodsList.length > 0 ? true : false
          });
          _this.page++;
          _this.isMore = res.is_more;
        }
      });
    };

    _this2.goToGroupDetail = function (e) {
      var franchisee = e.currentTarget.dataset.subid;
      var chainParam = franchisee ? '&franchisee=' + franchisee : '';
      var data = e.currentTarget.dataset,
          pageUrl = '/group/pages/gporderDetail/gporderDetail?from=myOrder' + '&teamtoken=' + data.teamtoken + chainParam;
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this2.inviteFriends = function (e) {
      var that = _this2;
      var data = e.currentTarget.dataset;
      var franchisee = data.subid;
      var indexTeams = e.currentTarget.dataset.index;
      var myTeams = _this2.data.goodsList[indexTeams];
      var goodsInfo = myTeams.goods_info[0];
      var goods_id = myTeams.goods_id;
      var activity_id = myTeams.activity_id;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/GetGoodsShareInfo',
        data: {
          goods_id: goods_id,
          activity_id: activity_id,
          sub_shop_app_id: franchisee || ''
        },
        success: function success(res) {
          var data = {};
          data['shareInfo.group_price'] = res.data.price;
          data['shareInfo.share_cover'] = res.data.share_cover;
          data['shareInfo.share_title'] = res.data.share_title;
          that.setData(data);
          _app.appMethod.sendRequest({
            url: '/index.php?r=appGroupBuy/getShareQRCode',
            data: {
              goods_id: goods_id,
              activity_id: activity_id,
              sub_shop_app_id: franchisee || '',
              type: 6,
              text: goodsInfo.goods_name,
              price: goodsInfo.price,
              virtual_price: goodsInfo.virtual_price == '0.00' ? goodsInfo.original_price : goodsInfo.virtual_price,
              goods_img: goodsInfo.cover,
              user_token: _app.appMethod.globalData.PromotionUserToken || '',
              team_token: myTeams.team_token,
              order_id: myTeams.order_id
            },
            success: function success(res) {
              // animation.bottom('0').step()
              // that.setData({
              //   'pageQRCodeData.shareDialogShow': 0,
              //   'pageQRCodeData.shareMenuShow': true,
              //   'pageQRCodeData.goodsInfo': res.data,
              //   'pageQRCodeData.animation': animation.export(),
              //   goodsShareData: myTeams
              // })
              _app.appInstance.pageQrcodeRef.current.show({
                pageQRCodeData: {
                  'shareDialogShow': 0,
                  'shareMenuShow': true,
                  'goodsInfo': res.data
                }
              });
              that.setData({
                goodsShareData: myTeams
              });
            }
          });
        }
      });
    };

    _this2.changeIdentity = function (e) {
      var data = e.currentTarget.dataset;
      _this2.setData({
        isLeader: data.isleader == 'true' ? true : false,
        type: 0,
        goodsList: []
      });
      _this2.page = 1;
      _this2.isMore = 1;
      _this2.loadMyTeams();
    };

    _this2.changeType = function (e) {
      var data = e.currentTarget.dataset;
      _this2.setData({
        type: data.type,
        goodsList: []
      });
      _this2.page = 1;
      _this2.isMore = 1;
      _this2.loadMyTeams();
    };

    _this2.openNewGroup = function (e) {
      var data = e.currentTarget.dataset;
      var franchisee = data.subid === _app.appMethod.getAppId() ? '' : data.subid;
      var chainParam = franchisee ? '&franchisee=' + franchisee : '';
      var pathUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + chainParam;
      if (data.status == 3 && data.type == 4 || data.groupbuy == 0) {
        _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + data.goodsid + chainParam);
        return;
      }
      if (data.status == '5') {
        _app.appMethod.showModal({
          content: '该拼团活动已结束'
        });
        return;
      }
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pathUrl);
      });
    };

    _this2.gotoGoodsOrder = function (e) {
      var franchisee = e.currentTarget.dataset.subid;
      var chainParam = franchisee ? '&franchisee=' + franchisee : '';
      var pathUrl = '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + e.currentTarget.dataset.orderid + chainParam;
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pathUrl);
      });
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          form_id: _this.data.formid || [],
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    _this2.countTime = function (difference) {
      if (difference < 0) {
        return ['00', '00', '00'];
      }
      var _second = 1000,
          _minute = _second * 60,
          _hour = _minute * 60,
          _date = _hour * 24,
          time = [];
      var dates = Math.floor(difference / _date),
          hours = Math.floor(difference % _date / _hour),
          minutes = Math.floor(difference % _hour / _minute),
          seconds = Math.floor(difference % _minute / _second);
      dates = String(dates).length >= 2 ? dates : +dates;
      hours = String(hours).length >= 2 ? hours : '0' + hours;
      minutes = String(minutes).length >= 2 ? minutes : '0' + minutes;
      seconds = String(seconds).length >= 2 ? seconds : '0' + seconds;
      time[0] = dates;
      time[1] = hours;
      time[2] = minutes;
      time[3] = seconds;
      return time;
    };

    _this2.onPullDownRefresh = function () {};

    _this2.onReachBottom = function () {
      if (_this2.isMore) {
        _this2.loadAll();
      }
    };

    _this2.onShareAppMessage = function (e) {
      var that = _this2,
          myTeams = _this2.data.goodsShareData,
          goodsInfo = myTeams.goods_info[0],
          shareInfo = _this2.data.shareInfo,
          team_token = myTeams.team_token,
          type = myTeams.activity_type,
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          url = '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' + team_token,
          nickname = _app.appMethod.getUserInfo('nickname'),
          share_cover = shareInfo.share_cover ? shareInfo.share_cover : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
          title = shareInfo.share_title ? shareInfo.share_title : (nickname ? nickname + ' 喊你' : '') + '拼单啦~ ' + shareInfo.group_price + '元拼' + goodsInfo.goods_name + '，火爆抢购中......';
      return _app.appMethod.shareAppMessage({
        title: title,
        path: url,
        imageUrl: share_cover,
        success: function success(addTime) {
          _app.appMethod.showToast({
            title: '转发成功',
            duration: 500
          });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: {
              add_time: addTime,
              sub_shop_app_id: that.data.franchiseeId || ''
            },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    document.title = '我的拼团';
    return _this2;
  }

  (0, _createClass3.default)(GpMyOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        franchiseeId: options.franchisee || ''
      });
      this.pageInit();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {}
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageQRCodeData = _state.pageQRCodeData,
          isLeader = _state.isLeader,
          goodsInfo = _state.goodsInfo,
          type = _state.type,
          goodsList = _state.goodsList,
          haveData = _state.haveData;

      return React.createElement(
        'div',
        { className: 'official-page gp-my-order' },
        React.createElement(_TopNav.TopNav, { title: '\u6211\u7684\u62FC\u56E2' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'collage-myOrder' },
            React.createElement(
              'div',
              { className: 'collage-section collage-classify' },
              React.createElement(
                'div',
                { className: 'total-classify' },
                React.createElement(
                  'div',
                  {
                    className: (isLeader ? 'active' : '') + '  isRelative',
                    onClick: this.changeIdentity,
                    'data-isleader': 'true'
                  },
                  '\u6211\u53D1\u8D77\u7684\u56E2'
                ),
                React.createElement(
                  'div',
                  {
                    className: (!isLeader ? 'active' : '') + ' isRelative',
                    onClick: this.changeIdentity,
                    'data-isleader': 'false'
                  },
                  '\u6211\u53C2\u4E0E\u7684\u56E2'
                )
              ),
              React.createElement(
                _ScrollView.ScrollView,
                { className: 'branch-classify', 'scroll-x': 'true' },
                React.createElement(
                  'div',
                  {
                    className: (type == '0' ? 'active' : '') + ' isRelative',
                    onClick: this.changeType,
                    'data-type': '0'
                  },
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'div',
                  {
                    className: (type == '2' ? 'active' : '') + ' isRelative',
                    onClick: this.changeType,
                    'data-type': '2'
                  },
                  '\u62FC\u56E2\u4E2D'
                ),
                React.createElement(
                  'div',
                  {
                    className: (type == '3' ? 'active' : '') + ' isRelative',
                    onClick: this.changeType,
                    'data-type': '3'
                  },
                  '\u62FC\u56E2\u6210\u529F'
                ),
                React.createElement(
                  'div',
                  {
                    className: (type == '4' ? 'active' : '') + ' isRelative',
                    onClick: this.changeType,
                    'data-type': '4'
                  },
                  '\u62FC\u56E2\u7ED3\u675F'
                ),
                isLeader && React.createElement(
                  'div',
                  {
                    className: (type == '5' ? 'active' : '') + ' isRelative',
                    onClick: this.changeType,
                    'data-type': '5'
                  },
                  '\u5DF2\u5173\u95ED'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'collage-section collage-content' },
              haveData ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'data-list' },
                  goodsList.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'data-item  isRelative',
                        key: index,
                        onClick: _this3.goToGroupDetail,
                        'data-teamtoken': item.team_token
                      },
                      React.createElement(
                        'div',
                        { className: 'state-wrap' },
                        React.createElement(
                          'div',
                          { className: 'timetable' },
                          item.add_time
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'status',
                            style: (0, _tools.convertLineStyleData)('color: ' + (item.current_status_title != '拼团中' ? '#666' : '#ff7100'))
                          },
                          item.current_status_title + (item.current_status == 2 ? item.expired : '')
                        )
                      ),
                      item.parent_shop_app_id && React.createElement(
                        'div',
                        { className: 'sub_name' },
                        '店铺：' + item.app_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'infor-wrap' },
                        React.createElement(
                          'div',
                          { className: 'image-wrap' },
                          React.createElement('img', { src: item.goods_info[0].cover })
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-wrap' },
                          React.createElement(
                            'div',
                            { className: 'title' },
                            item.goods_info[0].goods_name
                          ),
                          React.createElement(
                            'div',
                            { className: 'buy-infor' },
                            React.createElement(
                              'div',
                              { className: 'price' },
                              React.createElement(
                                'span',
                                null,
                                (item.activity_type == 0 ? item.max_user_num + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团') + ' ' + (item.data ? item.data.type : '') + ' ¥'
                              ),
                              React.createElement(
                                'span',
                                null,
                                item.goods_info[0].price
                              )
                            ),
                            React.createElement(
                              'div',
                              { className: 'num' },
                              'x' + item.goods_info[0].num
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'btn-wrap' },
                            item.current_status == 1 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                { className: 'buy-now orange' },
                                '\u7ACB\u5373\u652F\u4ED8'
                              ),
                              React.createElement(
                                'div',
                                { className: 'not-spelling empty' },
                                '\u4E0D\u62FC\u4E86'
                              )
                            ) : item.current_status == 2 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                {
                                  className: 'invite-friends orange',
                                  onClick: function onClick(e) {
                                    _this3.inviteFriends(e);e.stopPropagation();
                                  },
                                  'data-index': item.index,
                                  'data-subid': item.app_id
                                },
                                '\u9080\u8BF7\u597D\u53CB'
                              )
                            ) : item.current_status == 3 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                {
                                  className: 'spell-again orange',
                                  onClick: function onClick(e) {
                                    _this3.openNewGroup(e);e.stopPropagation();
                                  },
                                  'data-goodsid': item.goods_id,
                                  'data-activityid': item.activity_id,
                                  'data-status': item.current_status,
                                  'data-type': item.activity_type,
                                  'data-groupbuy': item.is_group_buy,
                                  'data-subid': item.app_id
                                },
                                '\u518D\u62FC\u4E00\u6B21'
                              ),
                              item.order_status != 7 && React.createElement(
                                'div',
                                {
                                  className: 'order-progress empty',
                                  onClick: function onClick(e) {
                                    _this3.gotoGoodsOrder(e);e.stopPropagation();
                                  },
                                  'data-teamtoken': item.team_token,
                                  'data-orderid': item.order_id,
                                  'data-subid': item.app_id
                                },
                                '\u8BA2\u5355\u8FDB\u5EA6'
                              )
                            ) : item.current_status == 4 && React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                {
                                  className: 'spell-again orange',
                                  onClick: function onClick(e) {
                                    _this3.openNewGroup(e);e.stopPropagation();
                                  },
                                  'data-goodsid': item.goods_id,
                                  'data-activityid': item.activity_id,
                                  'data-status': item.current_status,
                                  'data-groupbuy': item.is_group_buy,
                                  'data-subid': item.app_id
                                },
                                '\u518D\u62FC\u4E00\u6B21'
                              )
                            )
                          )
                        )
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'no-more' },
                  '\u6682\u65E0\u66F4\u591A\u62FC\u8D2D'
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'no-collage' },
                  React.createElement(
                    'div',
                    { className: 'image-wrap' },
                    React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/no-collage.png' })
                  ),
                  React.createElement(
                    'div',
                    { className: 'tip-wrap' },
                    '\u6682\u65E0\u62FC\u56E2'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return GpMyOrder;
}(_OfficialPage3.default);

exports.default = GpMyOrder;

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(585);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GpOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(GpOrderDetail, _OfficialPage);

  function GpOrderDetail(props) {
    (0, _classCallCheck3.default)(this, GpOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GpOrderDetail.__proto__ || Object.getPrototypeOf(GpOrderDetail)).call(this, props));

    _this2.state = {
      page: 1,
      myTeams: {},
      formid: [],
      hasAdditionalInfo: false,
      coverList: [],
      goodsData: {
        goods_list: [],
        is_more: 1,
        curpage: 1,
        loading: false,
        loadingFail: false
      },
      orderId: '',
      status: 4,
      teamToken: '',
      needNum: 0,
      progress: 0,
      modelId: 0,
      storeStyle: {}
    };
    _this2.seckillFunc = [];
    _this2.isMore = 1;
    _this2.page = 1;

    _this2.pageInit = function () {
      var _this = _this2;
      if (_app.appMethod.isLogin()) {
        _this.loadAll();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            _this.loadAll();
          }
        });
      }
    };

    _this2.loadAll = function () {
      var _this = _this2;
      _this.loadMyTeams();
      _this2.setData({
        appName: _app.appMethod.globalData.appTitle,
        appLogo: _app.appMethod.globalData.appLogo
      });
    };

    _this2.loadMyTeams = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/teamInfo',
        data: {
          team_token: _this.data.team_token
        },
        success: function success(res) {
          var coverList = [],
              myTeams = res.data,
              modelId = myTeams.model_id || '',
              coverObj = {},
              orderInfo = myTeams.order_info || '',
              goodsDetail = orderInfo.goods_info[0],
              orderId = orderInfo.order_id,
              progress = parseInt(Number(res.data.current_user_count / res.data.max_user_num) * 100),
              maxNum = Number(myTeams.max_user_num) || 0,
              needNum = maxNum - myTeams.current_user_count || '',
              hasAdditionalInfo = false,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              originPrice = myTeams.virtual_price == '0.00' ? myTeams.goods_price : myTeams.virtual_price;
          myTeams.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          if (orderInfo.additional_info) {
            for (var i = 0; i < orderInfo.goods_info.length; i++) {
              var deliveryId = orderInfo.goods_info[i].delivery_id,
                  goodsId = orderInfo.goods_info[i].goods_id;
              if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
                additional_info_goods.push(orderInfo.goods_info[i]);
                additional_goodsid_arr.push(goodsId);
                hasAdditionalInfo = true;
              }
            }
          }
          if (myTeams.member) {
            var coverTotalArr = myTeams.member || '',
                coverArr = [],
                numLack = myTeams.activity_type == 3 ? maxNum - coverTotalArr.length + 1 : maxNum - coverTotalArr.length,
                numLen = 0,
                coverLoading = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/loading-portrait.png'
            },
                coverUser = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/missing-head.png'
            },
                coverSuccess = {
              isNum: 0,
              image: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/success-loading.png'
            };
            for (var arrIndex in coverTotalArr) {
              coverObj = {
                isNum: 1,
                image: coverTotalArr[arrIndex]
              };
              coverArr.push(coverObj);
            }
            if (maxNum > 5) {
              switch (coverArr.length) {
                case 1:
                  numLen = 2;
                  break;
                case 2:
                  numLen = 1;
                  break;
                case 3:
                  numLen = 0;
                  break;
              }
              if (coverArr.length < 3) {
                //显示3个用户+1个等待+1个用户
                coverList = coverArr;
                for (var i = 0; i < numLen; i++) {
                  coverList.push(coverUser);
                }
                coverList.push(coverLoading);
                coverList.push(coverUser);
              } else if (coverArr.length >= 3 && coverArr.length < 5) {
                for (var index in coverArr) {
                  if (index < 3) {
                    coverList.push(coverArr[index]);
                  }
                }
                coverList.push(coverLoading);
                coverList.push(coverUser);
              } else if (coverArr.length >= 5) {
                if (coverArr.length < maxNum) {
                  for (var index in coverArr) {
                    if (index < 3) {
                      coverList.push(coverArr[index]);
                    }
                  }
                  coverList.push(coverLoading);
                  coverList.push(coverUser);
                } else {
                  for (var index in coverArr) {
                    if (index < 4) {
                      coverList.push(coverArr[index]);
                    }
                  }
                  coverList.push(coverSuccess);
                }
              }
            } else {
              coverList = coverArr;
              for (var _i = 0; _i < numLack; _i++) {
                coverList.push(coverUser);
              }
            }
          }
          myTeams.server_time = res.current_time;
          myTeams.seckill_end_time = _util2.default.formatTime(new Date(myTeams.expired_time * 1000));
          if (myTeams.current_status == 0 || myTeams.current_status == 1) {
            _this.downcount = _this.beforeGroupDownCount(myTeams, _this, 'myTeams');
          } else if (myTeams.current_status == 2) {
            _this.downcount = _this.duringGroupDownCount(myTeams, _this, 'myTeams');
          }
          if (myTeams.parent_shop_app_id) {
            _this.setData({
              appId: myTeams.parent_shop_app_id,
              franchiseeId: myTeams.app_id
            });
          }
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          _app.appMethod.setGoodsAdditionalInfo(orderInfo.additional_info || {});
          _this.setData({
            progress: progress,
            myTeams: myTeams,
            modelId: modelId,
            hasAdditionalInfo: hasAdditionalInfo,
            orderId: orderId,
            originPrice: originPrice,
            goodsId: myTeams.goods_id,
            activityId: myTeams.activity_id,
            team_token: orderInfo.team_token,
            member: coverList,
            goodsDetail: orderInfo.goods_info[0],
            needNum: needNum
          });
          _this.loadList();
        }
      });
    };

    _this2.seeAdditionalInfo = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
    };

    _this2.beforeGroupDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_start_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 3;
          newData[path + '.current_status'] = 3;
          newData[path + '.server_time'] = formData.seckill_start_time;
          page.setData(newData);
          formData.server_time = formData.seckill_start_time;
          _this.downcount = _this.duringGroupDownCount(formData, page, path);
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.duringGroupDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.seckill_end_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.status'] = 4;
          newData[path + '.current_status'] = 4;
          page.setData(newData);
          if (path == 'myTeams') {
            page.loadMyTeams();
          }
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.loadList = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/goodsList',
        data: {
          page: _this.page,
          page_size: 4,
          status: 1,
          app_id: _this.data.appId || '',
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        success: function success(res) {
          var rdata = res.data,
              newdata = {},
              compid = 'goodsData',
              goodsList = _this2.data.goodsData.goods_list,
              length = goodsList.length,
              downcountArr = _this.downcountArr || [];
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i];
            f.description = '';
            f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
          }
          var dataArr = res.data;
          newdata[compid + '.goods_list'] = goodsList.concat(dataArr);
          newdata[compid + '.is_more'] = res.is_more;
          newdata[compid + '.curpage'] = 1;
          newdata[compid + '.loading'] = false;
          newdata[compid + '.loadingFail'] = false;
          _this.downcountArr = downcountArr;
          _this.setData(newdata);
          _this.page++;
          _this.isMore = res.is_more;
        }
      });
    };

    _this2.gotoDetail = function (e) {
      var _this = _this2,
          data = e.currentTarget.dataset,
          pageUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pageUrl);
      });
    };

    _this2.copyOrderId = function () {
      var _this = _this2;
      _app.appMethod.setClipboardData({
        data: _this.data.team_token,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.openNewGroup = function () {
      var myTeams = _this2.data.myTeams;
      if (myTeams.enable_status == '0') {
        _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + myTeams.goods_id + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : ''));
        return;
      }
      var pathUrl = '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + _this2.data.myTeams.goods_id + '&activity_id=' + _this2.data.myTeams.activity_id + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pathUrl);
      });
    };

    _this2.showMyTeamList = function () {
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage('/group/pages/gpmyOrder/gpmyOrder' + (this.data.franchiseeId ? '&franchisee=' + this.data.franchiseeId : ''));
      });
    };

    _this2.inviteFriends = function () {
      var that = _this2;
      var myTeams = _this2.data.myTeams;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=appGroupBuy/getShareQRCode',
        data: {
          goods_id: myTeams.goods_id,
          activity_id: myTeams.activity_id,
          type: 6,
          text: myTeams.goods_title,
          price: myTeams.group_buy_price,
          virtual_price: that.data.originPrice,
          goods_img: myTeams.img_urls ? myTeams.img_urls[0] : myTeams.goods_cover,
          app_id: that.data.appId || '',
          sub_shop_app_id: that.data.franchiseeId || '',
          user_token: _app.appMethod.globalData.PromotionUserToken || '',
          team_token: myTeams.order_info.team_token,
          order_id: myTeams.order_info.order_id
        },
        success: function success(res) {
          // animation.bottom('0').step()
          // that.setData({
          //   'pageQRCodeData.shareDialogShow': 0,
          //   'pageQRCodeData.shareMenuShow': true,
          //   'pageQRCodeData.goodsInfo': res.data,
          //   'pageQRCodeData.animation': animation.export()
          // })
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': res.data
            }
          });
        }
      });
    };

    _this2.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          form_id: _this.data.formid || [],
          app_id: _this.data.appId || '',
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    _this2.gotoOrderDetail = function () {
      var pageUrl = '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + _this2.data.orderId + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _app.appMethod.turnToPage(pageUrl);
    };

    _this2.goDeliveryNavigation = function () {
      _app.appMethod.openLocation({
        latitude: Number(_this2.data.myTeams.order_info.self_delivery_info.latitude),
        longitude: Number(_this2.data.myTeams.order_info.self_delivery_info.longitude),
        name: _this2.data.myTeams.order_info.self_delivery_info.address
      });
    };

    _this2.onPullDownRefresh = function () {};

    _this2.onReachBottom = function () {
      if (_this2.isMore) {
        _this2.loadList();
      }
    };

    _this2.onShareAppMessage = function () {
      var that = _this2,
          team_token = _this2.data.team_token,
          myTeams = _this2.data.myTeams,
          type = myTeams.activity_type,
          modelId = _this2.data.modelId,
          urlPromotion = _app.appMethod.globalData.PromotionUserToken ? '&user_token=' + _app.appMethod.globalData.PromotionUserToken : '',
          franchiseeParam = _this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '',
          url = '/group/pages/gpgroupDetail/gpgroupDetail?teamtoken=' + team_token + '&orderId=' + that.data.orderId + franchiseeParam,
          nickname = _app.appMethod.getUserInfo('nickname'),
          share_cover = myTeams.share_cover ? myTeams.share_cover : 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg',
          title = myTeams.share_title ? myTeams.share_title : (nickname ? nickname + ' 喊你' : '') + '拼单啦~ ' + that.data.myTeams.group_buy_price + '元拼' + that.data.myTeams.goods_title + '，火爆抢购中......';
      return _app.appMethod.shareAppMessage({
        title: title,
        path: url,
        imageUrl: share_cover,
        success: function success(addTime) {
          _app.appMethod.showToast({
            title: '转发成功',
            duration: 500
          });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: {
              add_time: addTime,
              app_id: that.data.appId || '',
              sub_shop_app_id: that.data.franchiseeId || ''
            },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        }
      });
    };

    _this2.scrollAllowBottom = true;

    _this2.onPageScroll = function (e) {
      var officialPageDom = _this2.officialPageRef.current;
      e = (0, _extends3.default)({}, e, {
        scrollTop: officialPageDom.scrollTop,
        scrollLeft: officialPageDom.scrollLeft,
        scrollWidth: officialPageDom.scrollWidth,
        scrollHeight: officialPageDom.scrollHeight
      });
      if (officialPageDom.scrollTop + officialPageDom.clientHeight >= officialPageDom.scrollHeight - 100 && _this2.scrollAllowBottom) {
        _this2.scrollAllowBottom = false;
        _this2.onReachBottom();
      } else if (officialPageDom.scrollTop + officialPageDom.clientHeight < officialPageDom.scrollHeight - 100) {
        _this2.scrollAllowBottom = true;
      }
    };

    document.title = '拼团订单详情';
    return _this2;
  }

  (0, _createClass3.default)(GpOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        team_token: options.teamtoken,
        franchiseeId: options.franchisee || ''
      });
      this.pageInit();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {}
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcount) {
        this.downcount.clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageQRCodeData = _state.pageQRCodeData,
          myTeams = _state.myTeams,
          goodsDetail = _state.goodsDetail,
          originPrice = _state.originPrice,
          needNum = _state.needNum,
          member = _state.member,
          goodsInfo = _state.goodsInfo,
          progress = _state.progress,
          appLogo = _state.appLogo,
          appName = _state.appName,
          storeStyle = _state.storeStyle,
          hasAdditionalInfo = _state.hasAdditionalInfo,
          team_token = _state.team_token,
          goodsData = _state.goodsData;

      return React.createElement(
        'div',
        { ref: this.officialPageRef, className: 'official-page gp-order-detail', onScroll: this.onPageScroll },
        React.createElement(_TopNav.TopNav, { title: '\u62FC\u56E2\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          'div',
          { className: 'collage-orderInfo' },
          React.createElement(
            'div',
            { className: 'collage-section goods-infor' },
            React.createElement(
              'div',
              { className: 'goods-detail' },
              React.createElement(
                'div',
                { className: 'image-wrap' },
                React.createElement('img', { src: myTeams.goods_cover })
              ),
              React.createElement(
                'div',
                { className: 'content-wrap' },
                React.createElement(
                  'div',
                  { className: 'title' },
                  React.createElement(
                    'div',
                    { className: 'classify-type' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('i', { className: 'ico-moon icon-number-people' })
                    ),
                    React.createElement(
                      'span',
                      null,
                      myTeams.activity_type == 0 ? myTeams.max_user_num + '人团' : myTeams.activity_type == 1 ? '新人团' : myTeams.activity_type == 2 ? '阶梯团' : myTeams.activity_type == 3 ? '帮帮团' : '抽奖团'
                    )
                  ),
                  goodsDetail && goodsDetail.goods_name
                ),
                React.createElement(
                  'div',
                  { className: 'price' },
                  React.createElement(
                    'span',
                    { className: 'min-price' },
                    '\xA5',
                    React.createElement(
                      'span',
                      null,
                      myTeams.group_buy_price
                    )
                  ),
                  React.createElement(
                    'span',
                    { className: 'origin-price' },
                    '¥' + originPrice
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'num' },
                  '已团' + myTeams.goods_count + '件'
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'collage-section collage-infor' },
            myTeams.activity_type != 4 ? React.createElement(
              React.Fragment,
              null,
              myTeams.current_status == 2 && React.createElement(
                'div',
                { className: 'loading-stand' },
                React.createElement(
                  'div',
                  { className: 'tip' },
                  React.createElement(
                    'div',
                    null,
                    myTeams.activity_type != '2' ? React.createElement(
                      React.Fragment,
                      null,
                      '\u8FD8\u5DEE',
                      React.createElement(
                        'span',
                        { className: 'needNum' },
                        needNum + '人'
                      ),
                      '\u62FC\u8D2D\u6210\u529F, \u5269\u4F59'
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      '\u4EBA\u6570\u8D8A\u591A, \u4EF7\u683C\u8D8A\u4F4E, \u5269\u4F59'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'countDown' },
                    (myTeams.downCount.days != '00' || myTeams.downCount.days != '0') && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        myTeams.downCount.days
                      ),
                      React.createElement(
                        'span',
                        null,
                        '\u5929'
                      )
                    ),
                    React.createElement(
                      'span',
                      null,
                      myTeams.downCount.hours
                    ),
                    React.createElement(
                      'span',
                      null,
                      ':'
                    ),
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                      myTeams.downCount.minutes
                    ),
                    React.createElement(
                      'span',
                      null,
                      ':'
                    ),
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                      myTeams.downCount.seconds
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'member-cover' },
                  member.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      React.createElement('img', {
                        src: item.image,
                        style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                      }),
                      index == 0 && React.createElement(
                        'div',
                        { className: 'leader-logo' },
                        '\u56E2\u957F'
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  React.createElement(
                    'div',
                    {
                      className: 'open-new  isRelative',
                      onClick: this.inviteFriends
                    },
                    '\u9080\u8BF7\u597D\u53CB\u53C2\u56E2'
                  )
                )
              ),
              myTeams.current_status == 3 && React.createElement(
                'div',
                { className: 'success-stand' },
                React.createElement(
                  'div',
                  { className: 'tip' },
                  myTeams.activity_type == 3 ? React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '\u62FC\u56E2\u6210\u529F\uFF0C'
                    ),
                    '\u5546\u5BB6\u5C06\u7ED9\u56E2\u957F\u53D1\u8D27'
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '\u62FC\u56E2\u6210\u529F\uFF0C'
                    ),
                    '\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u53D1\u8D27'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'member-cover' },
                  member.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      React.createElement('img', {
                        src: item.image,
                        style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                      }),
                      index == 0 && React.createElement(
                        'div',
                        { className: 'leader-logo' },
                        '\u56E2\u957F'
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  React.createElement(
                    'div',
                    {
                      className: 'open-new isRelative',
                      onClick: this.openNewGroup
                    },
                    '\u5F00\u542F\u65B0\u56E2'
                  )
                )
              ),
              (myTeams.current_status == 4 || myTeams.current_status == 5) && React.createElement(
                'div',
                { className: 'fail-stand' },
                React.createElement(
                  'div',
                  { className: 'tip' },
                  '\u6765\u8FDF\u4E00\u6B65\uFF0C\u8FD9\u4E2A\u56E2\u5DF2\u7ECF\u62FC\u5B8C\u5566\uFF5E'
                ),
                React.createElement(
                  'div',
                  { className: 'member-cover' },
                  member.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { key: index },
                      React.createElement('img', {
                        src: item.image,
                        style: (0, _tools.convertLineStyleData)('border: ' + (item.isNum == 1 ? '2rpx solid #ff7100' : ''))
                      }),
                      index == 0 && React.createElement(
                        'div',
                        { className: 'leader-logo' },
                        '\u56E2\u957F'
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  React.createElement(
                    'div',
                    {
                      className: 'open-new isRelative',
                      onClick: this.openNewGroup
                    },
                    '\u5F00\u542F\u65B0\u56E2'
                  )
                )
              )
            ) : React.createElement(
              React.Fragment,
              null,
              myTeams.current_status == 2 && React.createElement(
                'div',
                { className: 'loading-draw' },
                React.createElement(
                  'div',
                  { className: 'progress' },
                  React.createElement(
                    'div',
                    {
                      className: 'success',
                      style: (0, _tools.convertLineStyleData)('width:' + progress + '%;')
                    },
                    React.createElement(
                      'div',
                      { className: 'inner' },
                      '已抢' + myTeams.current_user_count + '件'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'percent' },
                    progress + '%'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'tip' },
                  React.createElement(
                    'div',
                    null,
                    '\u5DF2\u6709',
                    React.createElement(
                      'span',
                      { className: 'needNum' },
                      myTeams.current_user_count
                    ),
                    '人参与，满' + myTeams.max_user_num + '人开奖，快去邀请小伙伴吧～'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '\u5269\u4F59',
                    React.createElement(
                      'div',
                      { className: 'countDown' },
                      (myTeams.downCount.days != '00' || myTeams.downCount.days != '0') && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          null,
                          myTeams.downCount.days
                        ),
                        React.createElement(
                          'span',
                          null,
                          '\u5929'
                        )
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams.downCount.hours
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                        myTeams.downCount.minutes
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('width:48rpx;') },
                        myTeams.downCount.seconds
                      )
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'btn-wrap' },
                  React.createElement(
                    'div',
                    {
                      className: 'open-new isRelative',
                      onClick: this.inviteFriends
                    },
                    '\u9080\u8BF7\u597D\u53CB'
                  )
                )
              ),
              myTeams.current_status == 3 && myTeams.is_winner == 1 && React.createElement(
                'div',
                { className: 'success-draw' },
                React.createElement(
                  'div',
                  { className: 'tip' },
                  React.createElement(
                    'div',
                    null,
                    '\u8FD0\u6C14\u7206\u68DA\uFF01',
                    React.createElement(
                      'span',
                      null,
                      '\u4E2D\u5956\u5566'
                    ),
                    '\uFF5E'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'member-cover' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement('img', {
                      src: myTeams.winner,
                      style: (0, _tools.convertLineStyleData)('border: 2rpx solid #ff7100')
                    })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'btn-wrap', onClick: this.gotoOrderDetail },
                  React.createElement(
                    'div',
                    { className: 'open-new' },
                    '\u67E5\u770B\u8BA2\u5355'
                  )
                )
              ),
              (myTeams.current_status == 4 || myTeams.current_status == 5 || myTeams.is_winner == 0) && React.createElement(
                'div',
                { className: 'loading-draw' },
                React.createElement(
                  'div',
                  { className: 'tip' },
                  myTeams.is_winner == 0 ? React.createElement(
                    React.Fragment,
                    null,
                    '\u5F88\u9057\u61BE\uFF0C\u60A8\u672A\u4E2D\u5956'
                  ) : React.createElement(
                    React.Fragment,
                    null,
                    '\u5F88\u9057\u61BE\uFF0C\u672C\u6B21\u6D3B\u52A8\u672A\u8FBE\u5230\u5F00\u5956\u95E8\u69DB'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'member-cover',
                    style: (0, _tools.convertLineStyleData)('padding:40rpx 0 50rpx;margin:0 auto;width:165rpx;height:165rpx;')
                  },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn//zhichi_frontend/static/webapp/images/group/draw-fail.png' })
                )
              )
            )
          ),
          (myTeams.activity_type != 4 || myTeams.activity_type == 4 && myTeams.current_status == 3 && myTeams.is_winner == 1) && React.createElement(
            'div',
            { className: 'collage-section detail-infor' },
            React.createElement(
              'div',
              { className: 'mutual-infor' },
              React.createElement(
                'div',
                { className: 'custom' },
                React.createElement(
                  'div',
                  { className: 'app-box' },
                  React.createElement('img', { className: 'app-logo', src: appLogo }),
                  React.createElement(
                    'span',
                    { className: 'app-name' },
                    appName
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'goods-opt-item' },
                  React.createElement(
                    'div',
                    null,
                    '\u8054\u7CFB\u5BA2\u670D'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'buyer-information' },
                React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                myTeams.order_info && myTeams.order_info.pick_up_type == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      myTeams.order_info.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        myTeams.order_info.address_info.name
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams.order_info.address_info.contact
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      myTeams.order_info.address_info.province.text + myTeams.order_info.address_info.city.text + myTeams.order_info.address_info.district.text + myTeams.order_info.address_info.detailAddress
                    )
                  )
                ),
                myTeams.order_info && myTeams.order_info.pick_up_type == 2 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u540C\u57CE'
                      ),
                      myTeams.order_info.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        myTeams.order_info.address_info.name
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams.order_info.address_info.contact
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      myTeams.order_info.address_info.province.text + myTeams.order_info.address_info.city.text + myTeams.order_info.address_info.district.text + myTeams.order_info.address_info.detailAddress
                    )
                  )
                ) : myTeams.order_info && myTeams.order_info.pick_up_type == 3 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u81EA\u63D0'
                      ),
                      myTeams.order_info.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        myTeams.order_info.self_delivery_info.contact_name
                      ),
                      React.createElement(
                        'span',
                        null,
                        myTeams.order_info.self_delivery_info.contact_phone
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      myTeams.order_info.self_delivery_info.address
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'delivery-navigation',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                      onClick: this.goDeliveryNavigation
                    },
                    '\u5BFC\u822A'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'price-statis' },
              React.createElement(
                'div',
                { className: 'incidental-pay' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u5546\u54C1\u62FC\u56E2\u4EF7'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '¥' + (myTeams.order_info ? myTeams.order_info.original_price : '')
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u4F18\u60E0\u62B5\u6263'
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    React.createElement(
                      'div',
                      null,
                      myTeams.order_info && myTeams.order_info.selected_benefit_info && myTeams.order_info.selected_benefit_info.discount_title
                    ),
                    React.createElement(
                      'div',
                      null,
                      '¥' + (myTeams.order_info ? myTeams.order_info.discount_cut_price : '')
                    )
                  )
                ),
                myTeams.order_info && myTeams.order_info.box_fee != 0 && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u9910\u76D2\u8D39'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '¥' + myTeams.order_info.box_fee
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u8FD0\u8D39'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '¥' + (myTeams.order_info ? myTeams.order_info.express_fee : '')
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u8BA2\u5355\u603B\u4EF7'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '¥' + (myTeams.order_info ? myTeams.order_info.order_total_price : '')
                  )
                ),
                myTeams.order_info && myTeams.order_info.settlement_activity && myTeams.order_info.settlement_activity.discount_cut_price && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u652F\u4ED8\u6709\u793C'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '-¥' + myTeams.order_info.settlement_activity.discount_cut_price
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    { className: 'name' },
                    '\u50A8\u503C\u62B5\u6263'
                  ),
                  React.createElement(
                    'span',
                    { className: 'price' },
                    '-¥' + (myTeams.order_info ? myTeams.order_info.use_balance : '')
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'actual-pay' },
                React.createElement(
                  'span',
                  null,
                  '\u5B9E\u9645\u4ED8\u6B3E'
                ),
                React.createElement(
                  'span',
                  { className: 'price' },
                  '¥' + (myTeams.order_info ? myTeams.order_info.total_price : '')
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'custom-remark' },
              React.createElement(
                'span',
                { className: 'name' },
                '\u4E70\u5BB6\u7559\u8A00'
              ),
              React.createElement(
                'span',
                { className: 'remark' },
                myTeams.order_info && myTeams.order_info.remark
              )
            ),
            hasAdditionalInfo && React.createElement(
              'div',
              {
                className: 'addition-info',
                onClick: this.seeAdditionalInfo
              },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u8865\u5145\u4FE1\u606F'
                ),
                React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
              )
            ),
            React.createElement(
              'div',
              { className: 'list-infor' },
              myTeams.activity_type != 4 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'hasBtn' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { className: 'name' },
                      '\u56E2\u53F7'
                    ),
                    React.createElement(
                      'div',
                      { className: 'msg' },
                      team_token
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'copy-btn isRelative',
                      onClick: this.copyOrderId
                    },
                    '\u590D\u5236'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u4E0B\u5355\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'msg' },
                    myTeams.order_info && myTeams.order_info.add_time
                  )
                ),
                myTeams.current_status == 3 && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u6210\u56E2\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'msg' },
                    myTeams.success_time
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { className: 'hasBtn' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { className: 'name' },
                      '\u4E0B\u5355\u65F6\u95F4'
                    ),
                    React.createElement(
                      'div',
                      { className: 'msg' },
                      myTeams.order_info.add_time
                    )
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u5F00\u5956\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'msg' },
                    myTeams.seckill_end_time
                  )
                )
              ),
              myTeams.order_info && myTeams.order_info.ecommerce_info.dispatch_use_pick_up_type == 2 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u5230\u8FBE\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    myTeams.order_info.ecommerce_info.intra_city_data.intra_city_appointment_arrive_time
                  )
                )
              ) : myTeams.order_info && myTeams.order_info.ecommerce_info.dispatch_use_pick_up_type == 3 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u53D6\u8D27\u65F6\u95F4'
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    myTeams.order_info.ecommerce_info.ec_tostore_data.ec_tostore_appointment_time
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u624B\u673A\u53F7\u7801'
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    myTeams.order_info.ecommerce_info.ec_tostore_data.ec_tostore_buyer_phone
                  )
                ),
                myTeams.order_info.ecommerce_info.ec_tostore_data.ec_tostore_location_name && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'name' },
                    '\u5E97\u5185\u4F4D\u7F6E'
                  ),
                  React.createElement(
                    'div',
                    { className: 'price' },
                    myTeams.order_info.ecommerce_info.ec_tostore_data.ec_tostore_location_name
                  )
                )
              )
            )
          ),
          goodsData.goods_list.length > 0 && React.createElement(
            'div',
            { className: 'collage-section collage-more' },
            React.createElement(
              'div',
              { className: 'title' },
              '\u66F4\u591A\u7CBE\u5F69\u62FC\u56E2'
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'goods-list opposite' },
                goodsData.goods_list.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'goods-item  isRelative',
                      key: index,
                      'data-goodsid': item.goods_id,
                      'data-activityid': item.activity_id,
                      onClick: _this3.gotoDetail
                    },
                    React.createElement(
                      'div',
                      { className: 'image-wrap' },
                      React.createElement('img', { src: item.cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'content-wrap' },
                      React.createElement(
                        'div',
                        { className: 'title' },
                        React.createElement(
                          'div',
                          { className: 'classify-type' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('i', { className: 'ico-moon icon-number-people' })
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.activity_type == 0 ? item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团'
                          )
                        ),
                        item.title
                      ),
                      item.salesnum ? React.createElement(
                        'div',
                        { className: 'hava-sales' },
                        React.createElement(
                          'div',
                          { className: 'price' },
                          React.createElement(
                            'span',
                            { className: 'min-price' },
                            '\xA5',
                            React.createElement(
                              'span',
                              null,
                              item.group_buy_price
                            )
                          ),
                          React.createElement(
                            'span',
                            { className: 'origin-price' },
                            '¥' + item.original_price
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'status' },
                          React.createElement(
                            'div',
                            { className: 'sales' },
                            '已团' + item.salesnum + '件'
                          ),
                          React.createElement(
                            'div',
                            { className: 'to-join' },
                            item.status == 0 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'ready' },
                                '\u5373\u5C06\u5F00\u56E2'
                              )
                            ) : item.status == 1 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'remain' },
                                '\u63D0\u9192\u6211'
                              )
                            ) : item.status == 2 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'reminded' },
                                '\u5DF2\u63D0\u9192'
                              )
                            ) : item.status == 3 ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'go' },
                                '\u53BB\u62FC\u56E2'
                              )
                            ) : item.status == 4 && React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'button',
                                { className: 'over' },
                                '\u5DF2\u7ED3\u675F'
                              )
                            )
                          )
                        )
                      ) : React.createElement(
                        'div',
                        { className: 'no-sales' },
                        React.createElement(
                          'div',
                          { className: 'price' },
                          React.createElement(
                            'div',
                            { className: 'min-price' },
                            '\xA5',
                            React.createElement(
                              'span',
                              null,
                              item.group_buy_price
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'origin-price' },
                            '¥' + item.original_price
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'to-join' },
                          item.status == 0 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'ready' },
                              '\u5373\u5C06\u5F00\u56E2'
                            )
                          ) : item.status == 1 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'remain' },
                              '\u63D0\u9192\u6211'
                            )
                          ) : item.status == 2 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'reminded' },
                              '\u5DF2\u63D0\u9192'
                            )
                          ) : item.status == 3 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'go' },
                              '\u53BB\u62FC\u56E2'
                            )
                          ) : item.status == 4 && React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'button',
                              { className: 'over' },
                              '\u5DF2\u7ED3\u675F'
                            )
                          )
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return GpOrderDetail;
}(_OfficialPage3.default);

exports.default = GpOrderDetail;

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewPresellOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewPresellOrder, _OfficialPage);

  function PreviewPresellOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewPresellOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewPresellOrder.__proto__ || Object.getPrototypeOf(PreviewPresellOrder)).call(this, props));

    _this2.state = {
      selectmodel: '',
      storeConfig: '',
      limit_buy: '',
      presell_status: '',
      description: '',
      goodsPrice: '',
      selectAddress: '',
      selectDelivery: '',
      pickUpType: '',
      presell_price: '',
      total_bargain: '',
      total_final_payment: '',
      final_payment_start_time: '',
      orderRemark: '',
      is_self_delivery: 0,
      totalPrice: 0,
      useBalance: true,
      cashOnDelivery: false,
      agreePayment: false,
      noAdditionalInfo: true,
      expressAddressNull: false,
      nums: 0,
      express_fee: 0,
      formid: [],
      cart_id_arr: [],
      goodsInfo: {},
      selectDiscountInfo: {},
      additional_info: {},
      shop: {
        id: '0'
      },
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      storeStyle: {}
    };

    _this2.loadInit = function () {
      var that = _this2;
      if (_app.appMethod.isLogin()) {
        _this2.getCalculationInfo();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getCalculationInfo();
          }
        });
      }
    };

    _this2.getCalculationInfo = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppPreSell/Calculate',
        method: 'POST',
        data: {
          sub_shop_app_id: that.franchisee_id,
          selected_benefit: that.data.selectDiscountInfo,
          is_balance: that.data.useBalance ? 1 : 0,
          address_id: that.data.pickUpType == 1 ? that.data.selectAddressId : that.data.selectSameJourneyId,
          pick_up_type: that.data.pickUpType,
          bargain_order_id: that.data.bargain_order_id || '',
          presell_shopping_cart: [{
            goods_id: that.data.goods_id,
            model_id: that.data.model_id,
            num: that.data.nums
          }]
        },
        success: function success(res) {
          var info = res.data;
          var benefits = info.can_use_benefit;
          var goods_info = info.goods_info;
          var additional_info_goods = [];
          var selectDiscountInfo = info.selected_benefit_info;
          var suppInfoArr = [];
          var additional_goodsid_arr = []; // 不在配送范围内直接弹窗
          var goodsBenefitsData = [];
          var final_payment_name = goods_info[0].server_time > info.final_payment_start_time * 1 ? _util2.default.formatTimeYMD(new Date(info.final_payment_end_time * 1000), 'M月DD日 hh:mm') + ' 结束支付尾款' : _util2.default.formatTimeYMD(new Date(info.final_payment_start_time * 1000), 'M月DD日 hh:mm') + ' 开始支付尾款';
          benefits.coupon_benefit && benefits.coupon_benefit.length ? goodsBenefitsData.push({
            label: 'coupon',
            value: benefits.coupon_benefit
          }) : '';
          benefits.all_vip_benefit && benefits.all_vip_benefit.length ? goodsBenefitsData.push({
            label: 'vip',
            value: benefits.all_vip_benefit
          }) : '';
          Array.isArray(benefits.integral_benefit) ? '' : benefits.integral_benefit && goodsBenefitsData.push({
            label: 'integral',
            value: [benefits.integral_benefit]
          });
          if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && that.data.exchangeCouponData.hasSelectGoods == false) {
            that.exchangeCouponInit(parseInt(selectDiscountInfo.value));
          }
          for (var i = 0; i <= goods_info.length - 1; i++) {
            if (goods_info[i].delivery_id && goods_info[i].delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info[i].id) == -1) {
              suppInfoArr.push(goods_info[i].delivery_id);
              additional_goodsid_arr.push(goods_info[i].id);
              additional_info_goods.push(goods_info[i]);
            }
          }
          if (suppInfoArr.length && !that.data.deliverydWrite) {
            that.getSuppInfo(suppInfoArr);
          }
          that.setData({
            goodsInfo: info.goods_info[0],
            total_price: info.price,
            presell_price: info.goods_info[0].price || '',
            total_bargain: info.total_bargain || '',
            total_final_payment: info.total_final_payment || '',
            expressAddressNull: info.address ? false : that.data.expressAddressNull,
            selectAddress: that.data.pickUpType == 1 && info.address,
            selectSameJourney: that.data.pickUpType == 2 && info.address,
            discountList: goodsBenefitsData,
            selectDiscountInfo: selectDiscountInfo,
            express_fee: info.express_fee,
            discount_cut_price: info.discount_cut_price,
            balance: info.balance,
            deduction: info.use_balance,
            original_price: info.original_price,
            totalPayment: info.price,
            canCashDelivery: info.is_pay_on_delivery || '', //快递货到付款
            cashOnDelivery: info.price > 0 ? that.data.cashOnDelivery : false,
            selfPayOnDelivery: info.self_pay_on_delivery || '', //自提货到付款
            additional_goodsid_arr: additional_goodsid_arr,
            final_payment_name: final_payment_name,
            sameJourneyImmediatlyTime: info.intra_city_status_data && info.intra_city_status_data.deliver_time
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
        },
        successShowModalConfirm: function successShowModalConfirm(res) {
          _app.appMethod.turnBack();
          return false;
        }
      });
    };

    _this2.exchangeCouponInit = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: id
        },
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          that.setData({
            'exchangeCouponData.dialogHidden': false, // 显示模态框
            'exchangeCouponData.goodsInfo': goods,
            'exchangeCouponData.selectModelInfo': selectModelInfo
          });
        },
        successStatusAbnormal: function successStatusAbnormal() {
          _app.appMethod.showModal({
            content: '兑换的商品已下架'
          });
        }
      });
    };

    _this2.clickMinusButton = function (e) {
      var goods = _this2.data.goodsInfo,
          num = +_this2.data.nums;
      if (+num <= 0) return;
      _this2.changeGoodsNum('minus');
    };

    _this2.clickPlusButton = function (e) {
      var goods = _this2.data.goodsInfo,
          num = +_this2.data.nums;
      _this2.changeGoodsNum('plus');
    };

    _this2.inputGoodsCount = function (e) {
      var value = +e.target.value,
          limit_buy = _this2.data.limit_buy,
          newdata = {};
      if (limit_buy !== '' && limit_buy != 0 && value > limit_buy) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + _this2.data.limit_buy + '件）'
        });
        newdata['nums'] = limit_buy;
        _this2.setData(newdata);
        return;
      }
      clearTimeout(_this2.inputTimer);
      if (isNaN(value) || value <= 0) {} else {
        _this2.inputTimer = setTimeout(function () {
          _this2.changeGoodsNum(value);
        }, 500);
      }
    };

    _this2.verifyName = function (e) {
      var value = +e.target.value;
      if (isNaN(value) || value <= 0) {
        _app.appMethod.showToast({
          title: '最少购买一件哦！',
          icon: 'none'
        });
        _this2.setData({
          nums: 1
        });
        _this2.inputTimer = setTimeout(function () {
          _this2.changeGoodsNum(1);
        }, 500);
        return;
      }
    };

    _this2.changeGoodsNum = function (type) {
      var that = _this2,
          stock = +that.data.models_stock,
          limit_buy = +that.data.limit_buy,
          currentNum = +_this2.data.nums,
          targetNum = type == 'plus' ? currentNum + 1 : type == 'minus' ? currentNum - 1 : Number(type),
          newdata = {};
      if (_this2.data.presell_status == 3) {
        _app.appMethod.showModal({
          content: '不支持修改数量',
          confirm: function confirm() {
            that.setData({
              nums: currentNum
            });
          }
        });
        return;
      }
      if (type == 'plus' && limit_buy && +targetNum > limit_buy) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        newdata['nums'] = limit_buy;
        _this2.setData(newdata);
        return;
      }
      if (+targetNum == 0 && type == 'minus') {
        newdata['nums'] = 1;
        _this2.setData(newdata);
        return;
      }
      if (+targetNum > stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        newdata['nums'] = stock;
        _this2.setData(newdata);
        return;
      }
      newdata['nums'] = +targetNum;
      _this2.setData(newdata);
      _this2.getCalculationInfo();
    };

    _this2.payOrder = function (orderId) {
      var that = _this2;
      function paySuccess() {
        var pagePath = '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' + (that.data.bargain_order_id || orderId) + '&presell_status=' + that.data.presell_status + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '');
        if (!that.franchisee_id) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_app_id: that.franchisee_id
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              that.saveUserFormId(pagePath, 1);
            }
          });
        } else {
          that.saveUserFormId(pagePath, 1);
        }
      }
      function payFail() {
        var pagePath = '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' + (that.data.bargain_order_id || orderId) + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '');
        that.saveUserFormId(pagePath, 1);
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.success = paySuccess
      //     param.goodsType = 0
      //     param.fail = payFail
      //     that.wxPay(param)
      //   },
      //   fail: function () {
      //     payFail()
      //   },
      //   successStatusAbnormal: function () {
      //     payFail()
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId,
        franchisee: that.franchisee_id,
        successUrl: '/presellPaySuccess?detail=' + (that.data.bargain_order_id || orderId) + '&presell_status=' + that.data.presell_status + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : ''),
        failUrl: '/presellOrderDetail?detail=' + (that.data.bargain_order_id || orderId) + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : ''),
        cancel: payFail
      });
    };

    _this2.wxPay = function (param) {
      var that = _this2;
      _app.appMethod.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _app.appMethod.wxPaySuccess(param);
          param.success();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消',
              complete: param.fail
            });
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败',
            complete: param.fail
          });
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var that = _this2,
          formid = that.data.formid,
          selected_benefit = _this2.data.selectDiscountInfo,
          tostoreOrderType = _this2.data.tostoreOrderType;
      formid.push(e.target.formId);
      that.setData({
        formid: formid
      });
      if (_this2.data.pickUpType == 1 && !_this2.data.selectAddress) {
        _this2.setData({
          expressAddressNull: true
        });
        return;
      }
      if (!_this2.data.agreePayment && _this2.data.presell_status != 3) {
        _app.appMethod.showModal({
          content: '请先开启同意支付定金'
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.selectSameJourney) {
        _app.appMethod.showModal({
          content: '请选择同城地址',
          confirmText: '去填写',
          confirm: function confirm() {
            that.goSameJourneyAddress();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 2 && !_this2.data.sameJourneyDateTime && _this2.data.sameJourneyTimeType != 1) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && !_this2.data.selectDelivery) {
        _app.appMethod.showModal({
          content: '请选择上门自提地址',
          confirmText: '去填写',
          confirm: function confirm() {
            that.toDeliveryList();
          }
        });
        return;
      }
      if (_this2.data.pickUpType == 3 && _this2.data.selfAppointmentSwitch && !tostoreOrderType) {
        _app.appMethod.showModal({
          content: '请选择取货时间'
        });
        return;
      }
      var year = new Date().getFullYear();
      var tostoreDateTime = year + '-' + _this2.data.tostoreDateTime + ' ' + (_this2.data.tostoreHourTime || '');
      if (_this2.data.pickUpType == 3 && _this2.data.selfDeliveryPhone == 1 && !_util2.default.isPhoneNumber(_this2.data.phone)) {
        _app.appMethod.showModal({
          content: '请输入正确的手机号'
        });
        return;
      }
      if (_this2.data.hasRequiredSuppInfo && !_this2.data.deliverydWrite && !_this2.data.aloneDeliveryShow && _this2.data.presell_status == 3) {
        _app.appMethod.showModal({
          content: '商品补充信息未填写，无法进行支付',
          confirmText: '去填写',
          confirm: function confirm() {
            that.goToAdditionalInfo();
          }
        });
        return;
      }
      if (_this2.data.aloneDeliveryShow && _this2.data.presell_status == 3) {
        var a = _this2.data.additional_info;
        var id = _this2.data.additional_goodsid_arr[0];
        if (a[id][0].is_required == 0 && a[id][0].value == '') {
          _app.appMethod.showModal({
            content: '请填写' + a[id][0].title,
            confirmText: '确认'
          });
          return;
        }
      }
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppPreSell/AddOrder',
        method: 'post',
        data: {
          sub_shop_app_id: that.franchisee_id,
          selected_benefit: selected_benefit,
          is_balance: that.data.useBalance ? 1 : 0,
          address_id: that.data.pickUpType == 1 ? that.data.selectAddress.id : that.data.selectSameJourney.id,
          pick_up_type: that.data.pickUpType,
          self_delivery_app_store_id: that.data.pickUpType == 3 ? that.data.selectDelivery.id : '',
          bargain_order_id: that.data.bargain_order_id || '',
          form_id: that.data.form_id || [],
          remark: _this2.data.orderRemark,
          presell_shopping_cart: [{
            goods_id: that.data.goods_id,
            model_id: that.data.model_id,
            num: that.data.nums
          }],
          additional_info: _this2.data.additional_info
        },
        success: function success(res) {
          if (that.data.cashOnDelivery) {
            var pagePath = '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' + (that.data.bargain_order_id || res.data) + '&presell_status=' + that.data.presell_status + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '');
            that.saveUserFormId(pagePath, 1);
          } else {
            that.setData({
              totalPayment: res.total_price
            });
            that.payOrder(res.data);
          }
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
        },
        successShowModalConfirm: function successShowModalConfirm(res) {
          _app.appMethod.turnBack();
          return false;
        },
        fail: function fail() {
          that.requesting = false;
        },
        successStatusAbnormal: function successStatusAbnormal() {
          that.requesting = false;
        }
      });
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        useBalance: checked
      });
      _this2.getCalculationInfo();
    };

    _this2.agreePayment = function (e) {
      var agreePayment = !_this2.data.agreePayment;
      _this2.setData({
        agreePayment: agreePayment
      });
    };

    _this2.goToMyAddress = function () {
      var addressId = _this2.data.selectAddress && _this2.data.selectAddress.id;
      var pagePath = '/eCommerce/pages/myAddress/myAddress?id=' + addressId;
      _this2.isFromSelectAddress = true;
      _this2.saveUserFormId(pagePath, 0);
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (path, isRedirect) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: that.data.franchiseeId || '',
          form_id: that.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          _app.appMethod.turnToPage(path, isRedirect);
          that.setData({
            formid: []
          });
        }
      });
    };

    _this2.remarkInput = function (e) {
      var value = e.target.value;
      _this2.setData({
        orderRemark: value
      });
    };

    _this2.manuallyAddAddress = function () {
      _this2.isFromSelectAddress = true;
      _app.appMethod.turnToPage('/eCommerce/pages/addAddress/addAddress');
    };

    _this2.importWeChatAddress = function () {
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.getCalculationInfo();
            }
          });
        }
      });
    };

    _this2.showMemberDiscount = function () {
      _this2.selectComponent('#component-memberDiscount').showDialog(_this2.data.selectDiscountInfo);
    };

    _this2.afterSelectedBenefit = function (event) {
      _this2.setData({
        selectDiscountInfo: event.detail.selectedDiscount,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationInfo();
    };

    _this2.getSuppInfo = function (suppInfoArr) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=pc/AppShop/GetDelivery',
        method: 'post',
        data: {
          delivery_ids: suppInfoArr
        },
        success: function success(res) {
          for (var i = 0; i < res.data.length; i++) {
            var suppInfo = res.data[i].delivery_info;
            for (var j = 0; j < suppInfo.length; j++) {
              if (suppInfo[j].is_required == 0 && suppInfo[j].is_hidden == 1) {
                _this.setData({
                  hasRequiredSuppInfo: true
                });
              }
              if (suppInfo[j].is_hidden == 1) {
                _this.setData({
                  noAdditionalInfo: false
                });
              }
            }
          }
          if (res.data.length == 1 && _this.data.additional_goodsid_arr.length == 1) {
            var deliveryIndex = 0;
            var showIndex = 0;
            for (var _i = 0; _i < res.data[0].delivery_info.length; _i++) {
              if (res.data[0].delivery_info[_i].is_hidden == 1) {
                deliveryIndex++;
                showIndex = _i;
              }
            }
            if (deliveryIndex == 1) {
              var data = {};
              data[_this.data.additional_goodsid_arr[0]] = [];
              data[_this.data.additional_goodsid_arr[0]].push({
                title: res.data[0].delivery_info[showIndex].name,
                type: res.data[0].delivery_info[showIndex].type,
                is_required: res.data[0].delivery_info[showIndex].is_required,
                value: ''
              });
              _this.setData({
                additional_info: data,
                aloneDeliveryShow: true
              });
            }
          }
        }
      });
    };

    _this2.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this2.data.additional_info);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
    };

    _this2.inputFormControl = function (e) {
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      a[b][0].value = e.target.value;
      _this2.setData({
        additional_info: a
      });
    };

    _this2.addDeliveryImg = function () {
      var _this = _this2;
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      var images = a[b][0].value || [];
      _app.appMethod.chooseImage(function (image) {
        a[b][0].value = images.concat(image);
        _this.setData({
          additional_info: a
        });
      }, 9 - a[b][0].value.length);
    };

    _this2.deleteImage = function (e) {
      var _this = _this2;
      var a = _this2.data.additional_info;
      var b = _this2.data.additional_goodsid_arr[0];
      var index = e.currentTarget.dataset.imageIndex;
      var images = a[b][0].value;
      images.splice(index, 1);
      a[b][0].value = images;
      _this.setData({
        additional_info: a
      });
    };

    document.title = '确认订单';
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData) {
      _this2.currentPage = _app.appMethod.getCurrentPage();
    }
    return _this2;
  }

  // WEBAPP: 处理后一个页面回来的回调


  (0, _createClass3.default)(PreviewPresellOrder, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      var callbackData = this.currentPage.callbackData;

      if (callbackData) {
        this.setData(callbackData);
        this.currentPage.clearCallbackData();
        if (this.currentPage.additional_info) {
          this.additional_info = this.currentPage.additional_info;
          delete this.currentPage.additional_info;
        }
        if (this.currentPage.hasRequiredSuppInfo) {
          this.hasRequiredSuppInfo = this.currentPage.hasRequiredSuppInfo;
          delete this.currentPage.hasRequiredSuppInfo;
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this,
          param = JSON.parse(decodeURIComponent(options.param)),
          pickUpType = param.type || 1,
          addressId = param.address_id;
      that.setData({
        goods_id: param.goods_id || '',
        activity_id: param.activity_id || '',
        model_id: param.model_id || '',
        nums: param.nums || '',
        franchiseeId: param.sub_shop_app_id || '',
        address_id: param.address_id || '',
        pickUpType: pickUpType,
        models_text: param.models_text,
        models_stock: param.models_stock,
        final_payment_start_time: param.final_payment_start_time,
        bargain_order_id: param.bargain_order_id || '',
        presell_status: param.presell_status,
        limit_buy: param.limit_buy,
        sameJourneyTimeType: pickUpType == 2 ? 1 : '',
        selectSameJourneyId: pickUpType == 2 ? addressId : '',
        selectAddressId: pickUpType == 1 ? addressId : ''
      });
      this.loadInit();
      // WEBAPP特殊处理(这里是有问题的，待解决)
      setTimeout(function () {
        _this3.handleCurrentPage();
      }, 1000);
    }
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {
      if (this.isFromSelectAddress) {
        this.getCalculationInfo();
        this.isFromSelectAddress = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          discountList = _state.discountList,
          presell_status = _state.presell_status,
          selectAddress = _state.selectAddress,
          storeStyle = _state.storeStyle,
          goodsInfo = _state.goodsInfo,
          models_text = _state.models_text,
          presell_price = _state.presell_price,
          is_group = _state.is_group,
          goodsIndex = _state.goodsIndex,
          goods = _state.goods,
          nums = _state.nums,
          exchangeCouponData = _state.exchangeCouponData,
          total_bargain = _state.total_bargain,
          total_final_payment = _state.total_final_payment,
          final_payment_name = _state.final_payment_name,
          selectDiscountInfo = _state.selectDiscountInfo,
          selectDiscountIndex = _state.selectDiscountIndex,
          discount_cut_price = _state.discount_cut_price,
          express_fee = _state.express_fee,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          agreePayment = _state.agreePayment,
          orderRemark = _state.orderRemark,
          noAdditionalInfo = _state.noAdditionalInfo,
          aloneDeliveryShow = _state.aloneDeliveryShow,
          hasRequiredSuppInfo = _state.hasRequiredSuppInfo,
          deliverydWrite = _state.deliverydWrite,
          additional_info = _state.additional_info,
          additional_goodsid_arr = _state.additional_goodsid_arr,
          total_price = _state.total_price,
          expressAddressNull = _state.expressAddressNull;

      return React.createElement(
        'div',
        { className: 'official-page preview-presell-order' },
        React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u8BA2\u5355' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'preview-goods-wrap' },
            React.createElement(
              'div',
              { className: 'preview-section' },
              selectAddress.id ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    className: 'address-box isRelative',
                    onClick: presell_status == 3 ? null : this.goToMyAddress,
                    'data-address-id': selectAddress.id
                  },
                  React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                  React.createElement(
                    'div',
                    { className: 'address-detail' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'store-config-label',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        selectAddress.address_info.name
                      ),
                      React.createElement(
                        'span',
                        null,
                        selectAddress.address_info.contact
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                    )
                  ),
                  presell_status != 3 && React.createElement('div', { className: 'ico-moon icon-rightarrow' })
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    className: 'address-null-box isRelative',
                    onClick: presell_status == 3 ? null : this.goToMyAddress
                  },
                  presell_status != 3 && React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' }),
                  React.createElement(
                    'div',
                    null,
                    React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                    React.createElement(
                      'span',
                      { className: 'add-new-address' },
                      '\u65B0\u589E\u5730\u5740'
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'address-bg' },
              React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-address-bg.png' })
            ),
            React.createElement(
              'div',
              { className: 'preview-goods-order-list' },
              React.createElement(
                'div',
                { className: 'preview-goods-order-item' },
                React.createElement('img', {
                  className: 'preview-goods-cover',
                  src: goodsInfo.cover,
                  mode: 'aspectFill'
                }),
                React.createElement(
                  'div',
                  { className: 'preview-goods-content' },
                  React.createElement(
                    'div',
                    { className: 'preview-goods-title' },
                    React.createElement(
                      'span',
                      { className: 'exchange-tip' },
                      '\u9884\u552E'
                    ),
                    goodsInfo.title
                  ),
                  models_text && React.createElement(
                    'div',
                    { className: 'preview-goods-model' },
                    models_text
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-price-box' },
                    goodsInfo.integral != '2' ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        {
                          className: 'preview-goods-price',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                        },
                        '¥ ' + presell_price
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      goodsInfo.price != '0.00' && React.createElement(
                        'span',
                        {
                          className: 'preview-goods-price',
                          style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                        },
                        '¥ ' + presell_price
                      ),
                      goodsInfo.price != '0.00' && goodsInfo.use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'preview-goods-price',
                          style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                        },
                        '+'
                      ),
                      goodsInfo.use_integral != 0 && React.createElement(
                        'span',
                        {
                          className: 'preview-goods-price',
                          style: (0, _tools.convertLineStyleData)(!is_group ? 'color:' + storeStyle.theme : '')
                        },
                        goodsInfo.max_can_use_integral + '积分'
                      )
                    ),
                    presell_status == 3 ? React.createElement(
                      'div',
                      { className: 'good-number-box  pull-right' },
                      'x ' + goodsInfo.num
                    ) : React.createElement(
                      'div',
                      { className: 'good-number-box pull-right' },
                      React.createElement(
                        'div',
                        {
                          className: 'goods-minus isRelative',
                          'data-index': goodsIndex,
                          onClick: this.clickMinusButton
                        },
                        '-'
                      ),
                      React.createElement('input', {
                        className: 'goods-count',
                        'data-index': goodsIndex,
                        type: 'number',
                        value: nums,
                        onChange: this.inputGoodsCount,
                        onBlur: this.verifyName
                      }),
                      React.createElement(
                        'div',
                        {
                          className: 'goods-plus isRelative',
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                          'data-index': goodsIndex,
                          onClick: this.clickPlusButton
                        },
                        '+'
                      )
                    )
                  )
                )
              )
            ),
            exchangeCouponData.hasSelectGoods && React.createElement(
              'div',
              { className: 'preview-goods-order-list' },
              React.createElement(
                'div',
                { className: 'preview-goods-order-item' },
                React.createElement('img', {
                  className: 'preview-goods-cover',
                  src: exchangeCouponData.goodsInfo.cover
                }),
                React.createElement(
                  'div',
                  { className: 'preview-goods-content' },
                  React.createElement(
                    'div',
                    { className: 'preview-goods-title' },
                    React.createElement(
                      'span',
                      { className: 'exchange-tip' },
                      '\u9884\u552E'
                    ),
                    exchangeCouponData.goodsInfo.title
                  ),
                  exchangeCouponData.goodsInfo.model_value_str && React.createElement(
                    'div',
                    { className: 'preview-goods-model' },
                    exchangeCouponData.goodsInfo.model_value_str
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-number-contain' },
                    React.createElement(
                      'div',
                      { className: 'exchange-num pull-right' },
                      'x1'
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'presell-price-item' },
              React.createElement(
                'div',
                { className: 'presell-tips' },
                React.createElement('div', {
                  className: 'role ' + (presell_status != 3 ? 'active' : '')
                }),
                React.createElement('div', { className: 'line' }),
                React.createElement('div', {
                  className: 'role ' + (presell_status == 3 ? 'active' : '')
                })
              ),
              React.createElement(
                'div',
                { className: 'presell-price' },
                React.createElement(
                  'div',
                  {
                    className: 'presell-section',
                    style: (0, _tools.convertLineStyleData)('color: ' + (presell_status != 3 ? '#FF4D4F' : ''))
                  },
                  '阶段1 ：定金 ¥ ' + total_bargain
                ),
                React.createElement(
                  'div',
                  { className: 'presell-section' },
                  React.createElement(
                    'div',
                    {
                      style: (0, _tools.convertLineStyleData)('color: ' + (presell_status == 3 ? '#FF4D4F' : ''))
                    },
                    '阶段2 ：尾款 ¥ ' + total_final_payment
                  ),
                  React.createElement(
                    'div',
                    null,
                    final_payment_name
                  )
                )
              )
            ),
            discountList && !!discountList.length && React.createElement(
              'div',
              {
                onClick: this.showMemberDiscount,
                className: 'isRelative showMemberDiscount'
              },
              React.createElement(
                'div',
                { className: 'balance-switch' },
                React.createElement(
                  'span',
                  null,
                  '\u4F18\u60E0\u65B9\u5F0F'
                ),
                React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                React.createElement(
                  'span',
                  { className: 'pull-right select-discount' },
                  selectDiscountInfo.name
                )
              ),
              React.createElement(
                'div',
                {
                  hidden: selectDiscountIndex == 0,
                  className: 'balance-price'
                },
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                  },
                  '- ¥ ' + discount_cut_price
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-goods-express-fee' },
              React.createElement(
                'span',
                null,
                '\u8FD0\u8D39'
              ),
              React.createElement(
                'span',
                { className: 'pull-right' },
                express_fee == '0' ? '包邮' : '¥' + express_fee
              )
            ),
            balance != 0 && React.createElement(
              'div',
              { className: 'payment-balance' },
              React.createElement(
                'div',
                { className: 'balance-switch' },
                React.createElement(
                  'span',
                  null,
                  '\u4F7F\u7528\u50A8\u503C\u91D1'
                ),
                React.createElement(_switch2.default, {
                  style: (0, _tools.convertLineStyleData)("transform: scale(.8)"),
                  className: 'pull-right',
                  checked: useBalance,
                  onChange: this.useBalanceChange
                })
              ),
              React.createElement(
                'div',
                { hidden: !useBalance, className: 'balance-price' },
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '- ¥ ' + deduction
                )
              )
            ),
            presell_status != 3 && React.createElement(
              'div',
              { className: 'payment-deposit' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  null,
                  '\u540C\u610F\u652F\u4ED8\u5B9A\u91D1'
                ),
                React.createElement(
                  'div',
                  { className: 'tips' },
                  '\u9884\u552E\u5546\u54C1\uFF0C\u5B9A\u91D1\u4E0D\u9000\u54E6\uFF5E'
                )
              ),
              React.createElement(_switch2.default, {
                color: storeStyle.theme,
                style: (0, _tools.convertLineStyleData)("transform: scale(.8)"),
                className: 'pull-right',
                checked: agreePayment,
                onChange: this.agreePayment
              })
            ),
            presell_status == 3 && React.createElement(
              'div',
              { className: 'preview-box' },
              React.createElement(
                'div',
                { className: 'buyer-message single-box' },
                '\u4E70\u5BB6\u7559\u8A00',
                React.createElement(
                  'div',
                  { className: 'pull-right' },
                  React.createElement('input', {
                    className: 'remark',
                    maxLength: '30',
                    value: orderRemark,
                    onChange: this.remarkInput,
                    placeholder: '\u4E70\u5BB6\u7559\u8A00'
                  })
                )
              ),
              !noAdditionalInfo && !aloneDeliveryShow && React.createElement(
                'div',
                {
                  className: 'border-top1 single-box',
                  onClick: this.goToAdditionalInfo
                },
                '\u8865\u5145\u4FE1\u606F',
                React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' }),
                React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + (hasRequiredSuppInfo && !deliverydWrite ? storeStyle.theme : '#666')),
                    className: 'additional-tip pull-right'
                  },
                  deliverydWrite ? '已填写' : '未填写'
                )
              )
            ),
            aloneDeliveryShow && presell_status == 3 && React.createElement(
              React.Fragment,
              null,
              additional_info[additional_goodsid_arr[0]].map(function (item, index) {
                return React.createElement(
                  'div',
                  { className: 'additional-list', key: index },
                  item.type == 'text' && React.createElement(
                    'div',
                    { className: 'additional-text' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      React.createElement('input', {
                        type: 'text',
                        onChange: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'mul-text' && React.createElement(
                    'div',
                    { className: 'additional-textarea' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      React.createElement('textarea', {
                        maxLength: '-1',
                        onInput: _this4.inputFormControl,
                        value: item.value
                      })
                    )
                  ),
                  item.type == 'picture' && React.createElement(
                    'div',
                    { className: 'additional-picture' },
                    React.createElement(
                      'span',
                      {
                        className: 'additional-name ' + (item.is_required == 0 ? 'is-required' : '')
                      },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'additional-info' },
                      item.value.map(function (imgSrc, imageIndex) {
                        return React.createElement(
                          'div',
                          { className: 'image-list', key: imageIndex },
                          React.createElement('img', { src: imgSrc }),
                          React.createElement(
                            'label',
                            {
                              className: 'delete-image ico-moon icon-closes isRelative',
                              onClick: _this4.deleteImage,
                              'data-image-index': imageIndex
                            },
                            '-'
                          )
                        );
                      }),
                      item.value.length < 9 && React.createElement(
                        'div',
                        {
                          className: 'add-images isRelative',
                          onClick: _this4.addDeliveryImg
                        },
                        React.createElement('span', { className: 'ico-moon icon-goods-add-image' }),
                        React.createElement(
                          'div',
                          null,
                          '\u6DFB\u52A0\u56FE\u7247'
                        )
                      )
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'bottom-nav' },
              React.createElement(
                'form',
                null,
                presell_status == 3 ? React.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: this.confirmPayment,
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                    className: 'paymentDeposit'
                  },
                  '支付尾款 ¥ ' + total_price
                ) : React.createElement(
                  'button',
                  {
                    type: 'button',
                    onClick: this.confirmPayment,
                    style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                    className: 'paymentDeposit'
                  },
                  '支付定金 ¥ ' + total_price
                )
              )
            ),
            expressAddressNull && React.createElement(
              'div',
              {
                className: 'perfect-address-mask',
                onClick: this.hidePerfectAddress
              },
              React.createElement(
                'div',
                {
                  className: 'perfect-address-box',
                  onClick: this.stopPropagation
                },
                React.createElement(
                  'div',
                  { className: 'perfect-address-title' },
                  '\u63D0\u793A'
                ),
                React.createElement(
                  'div',
                  { className: 'perfect-address-tips' },
                  '\u8BF7\u5B8C\u5584\u5730\u5740\u4FE1\u606F~'
                ),
                React.createElement(
                  'div',
                  { className: 'perfect-address-bottom' },
                  React.createElement(
                    'span',
                    { onClick: this.manuallyAddAddress },
                    '\u624B\u52A8\u65B0\u589E\u5730\u5740'
                  ),
                  React.createElement(
                    'span',
                    {
                      onClick: this.importWeChatAddress,
                      className: 'import-weChat-address'
                    },
                    '\u5BFC\u5165\u5FAE\u4FE1\u5730\u5740'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PreviewPresellOrder;
}(_OfficialPage3.default);

exports.default = PreviewPresellOrder;

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _Recommend = __webpack_require__(141);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(589);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresellPaySuccess = function (_OfficialPage) {
  (0, _inherits3.default)(PresellPaySuccess, _OfficialPage);

  function PresellPaySuccess(props) {
    (0, _classCallCheck3.default)(this, PresellPaySuccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PresellPaySuccess.__proto__ || Object.getPrototypeOf(PresellPaySuccess)).call(this, props));

    _this.state = {
      status: 0, // 0: 普通页面 1:有集集乐的情况
      orderId: '',
      franchiseeId: '',
      final_payment_start_time: '',
      presell_status: '',
      collectBenefitData: {}, // 集集乐数据
      starData: [], //集集乐的星 light:已集样式 dark:未集样式
      isFail: true, //刮刮乐未中奖
      isWinning: true, //刮刮乐中奖
      isComfort: true, //刮刮乐安慰奖
      isWhole: true, //刮奖区域是否显示
      scratchId: '', //活动号
      isShowteam: false,
      winingTitle: '',
      isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
      ifWxCoupon: false,
      presell_bargain: '',
      timestamp: '',
      signature: '',
      ifGetComfort: false,
      formid: []
    };
    _this.recommendRef = _react2.default.createRef();

    _this.touchStart = function (e) {
      if (!_this.isStart) return;
      var pos = _this.drawRect(e.touches[0].x, e.touches[0].y);
      _this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this.ctx.draw(true);
    };

    _this.touchMove = function (e) {
      if (!_this.isStart) return;
      var pos = _this.drawRect(e.touches[0].x, e.touches[0].y);
      _this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this.ctx.draw(true);
    };

    _this.touchEnd = function (e) {
      if (!_this.isStart) return;
      var canvasWidth = _this.canvasWidth,
          canvasHeight = _this.canvasHeight,
          minX = _this.minX,
          minY = _this.minY,
          maxX = _this.maxX,
          maxY = _this.maxY;

      if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
        _this.ctx.draw();
        _this.endCallBack && _this.endCallBack();
        _this.isStart = false;
        _this.page.setData({
          isScroll: true
        });
      }
    };

    _this.getGoldenData = function (id) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(data) {
          if (data.data) {
            if (that.data.code) {
              that.setData({
                isWhole: true
              });
            } else {
              that.setData({
                isWhole: false,
                scratchId: data.data
              });
            }
          } else {
            that.setData({
              isWhole: true
            });
          }
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this.showAreaClick = function () {
      var that = _this;
      that.setData({
        isShowteam: false
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = res.data;
          that.scratch.start();
          if (data.title == '谢谢参与') {
            that.setData({
              isFail: false
            });
          } else {
            var params = {
              ifWxCoupon: data.card_id || false,
              timestamp: data.timestamp || '',
              signature: data.signature || ''
            };
            if (data.is_comfort) {
              params['isComfort'] = false;
            } else {
              params['isWinning'] = false;
              params['winingTitle'] = data.title;
            }
            that.setData(params);
          }
        }
      });
    };

    _this.onShareAppMessage = function (res) {
      var that = _this;
      var franchiseeParam = _this.data.franchiseeId ? '&franchisee=' + _this.data.franchiseeId : '';
      return {
        path: '/awardManagement/pages/scratch/scratch?id=' + that.data.scratchId + franchiseeParam,
        success: function success(res) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/getTime',
            data: {
              activity_id: that.data.scratchId,
              type: 'share',
              sub_app_id: that.data.franchiseeId
            },
            success: function success(res) {}
          });
        },
        fail: function fail(res) {}
      };
    };

    _this.getCollectBenefitData = function (id) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var starData = [];
          for (var i = 0; i < res.data.star_num; i++) {
            starData.push('light');
          }
          for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
            starData.push('dark');
          }
          that.setData({
            collectBenefitData: res.data,
            starData: starData
          });
        }
      });
    };

    _this.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({
        url: '/pages/' + router + '/' + router
      });
    };

    _this.goToOrderDetail = function () {
      var that = _this;
      var presellPath = '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' + that.data.orderId + (that.data.franchiseeId ? '&franchisee=' + that.data.franchiseeId : '');
      that.saveUserFormId(presellPath, 1);
    };

    _this.getOrderDetail = function () {
      var that = _this;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var form_data = res.data[0].form_data,
              final_payment_start_time = form_data.presell_shopping_cart[0].final_payment_start_time * 1,
              presell_bargain = form_data.total_bargain;
          final_payment_start_time = _util2.default.formatTimeYMD(new Date(final_payment_start_time * 1000), 'MM月DD日 hh:mm');
          that.setData({
            orderInfo: form_data,
            presell_bargain: presell_bargain,
            final_payment_start_time: final_payment_start_time
          });
        }
      });
    };

    _this.toAddCard = function () {
      var _data = _this.data,
          wxcouponId = _data.ifWxCoupon,
          that = _this;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          that.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.scratchId
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
            }
          });
        }
      });
    };

    _this.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this.setData({
          storeStyle: res.color_config,
          hasRecommendConfig: res.recommend_config ? false : true
        });
      }, _this.data.franchiseeId);
    };

    _this.formSubmit_collect = function (e) {
      var formid = _this.data.formid;
      formid.push(e.detail.formId);
    };

    _this.saveUserFormId = function (path, isRedirect) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: that.data.franchiseeId || '',
          form_id: that.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          _app.appMethod.turnToPage(path, isRedirect);
          that.setData({
            formid: []
          });
        }
      });
    };

    document.title = '支付成功';
    return _this;
  }

  (0, _createClass3.default)(PresellPaySuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      if (options.collectBenefit == 1) {
        that.getCollectBenefitData(options.detail);
        that.setData({
          status: 1
        });
      }
      that.setData({
        orderId: options.detail,
        franchiseeId: options.franchisee || '',
        is_group: options.is_group || '',
        code: options.code || '',
        is_newAppointment: options.is_newAppointment || '',
        presell_status: options.presell_status || ''
      });
      that.getOrderDetail();
      this.getAppECStoreConfig();
      that.getGoldenData(options.detail);
      var systemInfo = _app.appMethod.globalData.systemInfo || {};
      var width = 558 * systemInfo.windowWidth / 750;
      var height = 258 * systemInfo.windowWidth / 750;
      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              isShowteam: true
            });
          }, 10);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          showGetUserInfo = _state.showGetUserInfo,
          storeStyle = _state.storeStyle,
          hasRecommendConfig = _state.hasRecommendConfig,
          orderInfo = _state.orderInfo,
          goods = _state.goods,
          presell_status = _state.presell_status,
          final_payment_start_time = _state.final_payment_start_time,
          franchiseeId = _state.franchiseeId;

      return _react2.default.createElement(
        'div',
        { className: 'official-page presell-pay-success' },
        _react2.default.createElement(_TopNav.TopNav, { title: '\u652F\u4ED8\u6210\u529F' }),
        _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            null,
            hasRecommendConfig && _react2.default.createElement(
              'div',
              {
                className: 'normal-area',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              _react2.default.createElement(
                'div',
                {
                  className: 'order-price-box',
                  style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                },
                _react2.default.createElement(
                  'div',
                  { className: 'order-success' },
                  _react2.default.createElement('img', {
                    className: 'goods-complete-succes',
                    src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-success.png'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('background:#fff;') },
                _react2.default.createElement('img', {
                  className: 'goods-complete-bg',
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/xcx-goods/goods-complete-bg.png'
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'normal-area-status' },
              presell_status == 3 ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'order-price' },
                  '¥' + orderInfo.final_order_total_price
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pay-tips' },
                  '\u5C3E\u6B3E\u652F\u4ED8\u6210\u529F'
                ),
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('padding-bottom:60rpx;') },
                  _react2.default.createElement(
                    'div',
                    { className: 'btn-area' },
                    _react2.default.createElement(
                      'div',
                      { onClick: this.goToHomepage, className: 'isRelative' },
                      '\u7EE7\u7EED\u8D2D\u7269'
                    ),
                    _react2.default.createElement(
                      'div',
                      { onClick: this.goToOrderDetail, className: 'isRelative' },
                      '\u67E5\u770B\u8BA2\u5355'
                    )
                  )
                )
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'order-price' },
                  '¥' + (orderInfo ? orderInfo.bargain_order_total_price : '')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pay-tips' },
                  '\u5B9A\u91D1\u652F\u4ED8\u6210\u529F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'icons' },
                  _react2.default.createElement('div', null),
                  _react2.default.createElement('div', null)
                ),
                _react2.default.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('height:296rpx;') },
                  _react2.default.createElement(
                    'div',
                    { className: 'order-tips' },
                    _react2.default.createElement(
                      'div',
                      null,
                      '\u8BF7\u5728\u6211\u7684\u9884\u552E\u4E2D\u652F\u4ED8\u5C3E\u6B3E'
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        null,
                        final_payment_start_time
                      ),
                      '\u5F00\u59CB\u652F\u4ED8\u5C3E\u6B3E'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'btn-area' },
                    _react2.default.createElement(
                      'div',
                      { onClick: this.goToHomepage, className: 'isRelative' },
                      '\u7EE7\u7EED\u8D2D\u7269'
                    ),
                    _react2.default.createElement(
                      'div',
                      { onClick: this.goToOrderDetail, className: 'isRelative' },
                      '\u67E5\u770B\u8BA2\u5355'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_Recommend.Recommend, { id: 'component-recommend', franchiseeId: franchiseeId, ref: this.recommendRef })
        )
      );
    }
  }]);
  return PresellPaySuccess;
}(_OfficialPage3.default);

exports.default = PresellPaySuccess;

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(591);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresellOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(PresellOrderDetail, _OfficialPage);

  function PresellOrderDetail(props) {
    (0, _classCallCheck3.default)(this, PresellOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PresellOrderDetail.__proto__ || Object.getPrototypeOf(PresellOrderDetail)).call(this, props));

    _this2.state = {
      orderInfo: {},
      orderStatus: {
        '0': '订单待付款',
        '1': '商家待发货',
        '2': '买家待收货',
        '3': '订单待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '订单已完成',
        '7': '已退款',
        '8': '卖家待接单'
      },
      presellStatus: {
        '0': '定金待付款',
        '1': '定金待付款',
        '2': '定金支付成功',
        '3': '尾款待付款',
        '4': '商家待发货',
        '5': '订单已取消',
        '6': '退款审核中',
        '7': '商家已退定金',
        '8': '定金退款失败',
        '9': '已关闭',
        '10': '尾款超时未支付',
        '11': '尾款支付成功，请到电商订单查看订单状态',
        '12': '定金超时未支付',
        '13': '退款失败'
      },
      presellIcon: {
        '0': 'goods-undone-payment',
        '1': 'goods-undone-payment',
        '2': 'bargain-pay-success',
        '3': 'goods-undone-payment',
        '4': 'goods-undone-ship',
        '5': 'goods-order-close',
        '6': 'goods-refund',
        '7': 'goods-order-close',
        '8': 'bargain-refund-fail',
        '9': 'goods-order-close',
        '10': 'presell-payment-overtime',
        '11': 'presell-completed',
        '12': 'presell-payment-overtime'
      },
      orderIcon: {
        '0': 'goods-undone-payment',
        '1': 'goods-undone-ship',
        '2': 'goods-undone-receipt',
        '3': 'goods-undone-evaluation',
        '4': 'goods-refund',
        '5': 'goods-refund-doing',
        '6': 'goods-order-complete',
        '7': 'goods-order-close'
      },
      refundStatus: ['退款审核中', '', '', '等待买家退货', '商家待收货', '', '已退款'],
      refundIcon: ['goods-refund-review', '', '', 'goods-refund', 'goods-undone-receipt', '', 'goods-already-refund'],
      refundReason: ['多拍/拍错/不想要', '快递延期', '未按约定时间发货', '快递记录出错', '内容与描述不符', '其它'],
      formid: [],
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      orderId: '',
      isFromTemplateMsg: false,
      originalPrice: '',
      useBalance: '',
      freightAdress: {},
      express_fee: '',
      discount_cut_price: '',
      status: 1,
      isFromBack: false,
      showWriteOffCodeBox: false,
      showEventDialog: false,
      eventType: '',
      hasAlreadyGoods: false,
      final_payment_start_time: '',
      storeStyle: {}
    };
    _this2.verifiTimeInterval = '';
    _this2.downcountArr = [];

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.getLogistics();
      _this2.getAppECStoreConfig();
      _this2.setData({
        appName: _app.appMethod.globalData.appTitle,
        appLogo: _app.appMethod.globalData.appLogo
      });
    };

    _this2.getOrderDetail = function (orderId) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.franchiseeId
        },
        success: function success(res) {
          var data = res.data[0],
              form_data = data.form_data,
              hasAdditionalInfo = false,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              address_id = '',
              presell_shopping_cart = form_data.presell_shopping_cart[0],
              is_presell_order = form_data.is_presell_order,
              final_payment_start_time = presell_shopping_cart.final_payment_start_time * 1,
              final_payment_end_time = presell_shopping_cart.final_payment_end_time * 1,
              server_time = form_data.goods_info[0].server_time,
              is_end = final_payment_end_time < server_time ? true : false,
              status = form_data.status,
              presell_status,
              under_sales;
          data.final_payment_name = server_time > final_payment_start_time * 1 ? _util2.default.formatTimeYMD(new Date(final_payment_end_time * 1000), 'M月DD日 hh:mm') + ' 结束支付尾款' : _util2.default.formatTimeYMD(new Date(final_payment_start_time * 1000), 'M月DD日 hh:mm') + ' 开始支付尾款';
          var usePickType = form_data.ecommerce_info.dispatch_use_pick_up_type;
          var intraCityStatus = '';
          if (usePickType == 2) {
            intraCityStatus = form_data.ecommerce_info.ecommerce_transport_order && form_data.ecommerce_info.ecommerce_transport_order.status;
          }
          switch (is_presell_order) {
            case '1':
              switch (status) {
                case '0':
                  presell_status = final_payment_start_time <= server_time ? 0 : 1; // 定金未付款,未到尾款支付时间
                  under_sales = true;
                  break;
                case '11':
                  presell_status = final_payment_start_time <= server_time ? 3 : 2; //定金已付款，尾款未付款/未到尾款支付时间
                  under_sales = true;
                  break;
                case '4':
                  // 定金退款审核中
                  presell_status = 6;
                  under_sales = false;
                  break;
                case '7':
                  presell_status = form_data.refund_time != '0' ? 7 : 5; // 商家已退定金/订单已取消
                  under_sales = false;
                  break;
                case '14':
                  presell_status = 5; //商品已取消
                  under_sales = false;
                  break;
                case '15':
                  presell_status = 8; //退款失败
                  under_sales = false;
                  break;
                case '12':
                  presell_status = 12;
                  under_sales = true;
                  break;
              }
              break;
            case '2':
              switch (status) {
                case '0':
                  presell_status = is_end ? '10' : '3'; // 定金已付款，尾款未付款
                  under_sales = true;
                  break;
                default:
                  presell_status = 4; // 定金已付款，尾款已付款
                  under_sales = true;
              }
              break;
            default:
              switch (status) {
                case '0':
                  presell_status = 11; // 尾款阶段
                  break;
                case '1':
                  presell_status = 11; // 尾款阶段
                  break;
                case '2':
                  presell_status = 11; // 尾款阶段
                  break;
                case '3':
                  presell_status = 11; // 尾款阶段
                  break;
                case '4':
                  presell_status = 11; // 尾款阶段
                  break;
                case '5':
                  presell_status = 11; // 尾款阶段
                  break;
                case '6':
                  presell_status = 11; // 尾款阶段
                  break;
                case '7':
                  presell_status = 11; // 尾款阶段
                  break;
                case '8':
                  presell_status = 11; // 尾款阶段
                  break;
                case '15':
                  presell_status = 13; // 退款失败
                  break;
                default:
                  presell_status = 4; // 定金已付款，尾款已付款
                  break;
              }
              under_sales = true;
              break;
          }
          if ((status == 11 || status == 7 && is_presell_order == 1) && server_time > final_payment_end_time * 1) {
            under_sales = true;
            presell_status = form_data.refund_time != '0' ? 7 : 10;
          }
          if (form_data.additional_info && is_presell_order == 3) {
            for (var i = 0; i < form_data.goods_info.length; i++) {
              var deliveryId = form_data.goods_info[i].delivery_id,
                  goodsId = form_data.goods_info[i].goods_id;
              if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
                additional_info_goods.push(form_data.goods_info[i]);
                additional_goodsid_arr.push(goodsId);
                hasAdditionalInfo = true;
              }
            }
          }
          var remark = form_data.remark;
          form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark;
          for (var _i = 0; _i < form_data.goods_info.length; _i++) {
            if (form_data.goods_info[_i].is_seckill == 1) {
              form_data.goods_info[_i].downCount = {
                hours: '00',
                minutes: '00',
                seconds: '00'
              };
              if (form_data.goods_info[_i].seckill_start_state == 0) {
                form_data.goods_info[_i].downcount = _app.appMethod.beforeSeckillDownCount(form_data.goods_info[_i], that, 'orderInfo.goods_info[' + _i + ']');
              } else if (form_data.goods_info[_i].seckill_start_state == 1) {
                form_data.goods_info[_i].downcount = _app.appMethod.duringSeckillDownCount(form_data.goods_info[_i], that, 'orderInfo.goods_info[' + _i + ']');
              }
              form_data.goods_info[_i] && that.downcountArr.push(form_data.goods_info[_i].downcount);
            }
          }
          if (form_data.refunded_price && is_presell_order == 3) {
            that.setData({
              hasAlreadyGoods: true
            });
          }
          if (form_data.pick_up_type == 2) {
            var sytime = void 0;
            var nowTime = new Date().getTime();
            var addTime = form_data.add_time.replace(/\-/g, '/');
            var time = 15 * 60000 - (nowTime - new Date(addTime + '').getTime());
            if (time <= 0) {
              sytime = '0';
            } else {
              sytime = parseInt(time % (1000 * 60 * 60) / (60 * 1000));
            }
            form_data.cacelOrderCountDownTime = sytime;
          }
          final_payment_start_time = _util2.default.formatTimeYMD(new Date(final_payment_start_time * 1000), 'MM月DD日 hh:mm');
          final_payment_end_time = _util2.default.formatTimeYMD(new Date(final_payment_end_time * 1000), 'MM月DD日 hh:mm');
          that.setData({
            orderInfo: form_data,
            order_total_price: that.formatMoney(form_data.goods_info[0].price * 1 + form_data.use_balance * 1),
            hasAdditionalInfo: hasAdditionalInfo,
            discount_cut_price: form_data.discount_cut_price,
            useBalance: form_data['use_balance'],
            express_fee: res.data[0]['express_fee'],
            intraCityStatus: intraCityStatus || '',
            usePickType: usePickType,
            presell_status: presell_status,
            under_sales: under_sales,
            is_presell_order: is_presell_order,
            final_payment_start_time: final_payment_start_time,
            final_payment_end_time: final_payment_end_time
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          _app.appMethod.setGoodsAdditionalInfo(form_data.additional_info || {});
          that.getRefundConfigByPickUpType(form_data.pick_up_type);
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/HideOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success(res) {
          _app.appMethod.turnBack();
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.formatMoney = function (number, places, symbol, thousand, decimal) {
      number = number || 0;
      places = !isNaN(places = Math.abs(places)) ? places : 2;
      symbol = symbol !== undefined ? symbol : '';
      thousand = thousand || ',';
      decimal = decimal || '.';
      var negative = number < 0 ? '-' : '',
          i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '',
          j = (j = i.length) > 3 ? j % 3 : 0;
      return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '¥1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cancelOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId || ''
        },
        success: function success(res) {
          var data = {};
          data['presell_status'] = 5;
          that.setData(data);
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderInfo = _this2.data.orderInfo,
          goodsInfo = orderInfo.goods_info[0],
          paymentOrder = orderInfo._presell_final_payment_order,
          presell_shopping_cart = orderInfo.presell_shopping_cart[0],
          orderId = orderInfo.order_id;
      if (_this2.data.presell_status == 3 && presell_shopping_cart.is_presell_order == 1 && !paymentOrder) {
        var that = _this2,
            franchiseeId = that.data.franchiseeId,
            param = {
          goods_id: goodsInfo.goods_id,
          activity_id: goodsInfo.presell_activity_id || '',
          model_id: goodsInfo.modelId || '',
          nums: goodsInfo.num,
          sub_shop_app_id: franchiseeId || '',
          final_payment_start_time: that.data.final_payment_start_time || '',
          address_id: '',
          type: '1',
          models_text: goodsInfo.model_value == null ? '' : goodsInfo.model_value,
          models_stock: presell_shopping_cart.presell_stock_left,
          bargain_order_id: orderInfo.order_id,
          presell_status: that.data.presell_status,
          limit_buy: presell_shopping_cart.buy_limit_num
        },
            pagePath = '/presell/pages/previewPresellOrder/previewPresellOrder?param=' + encodeURIComponent(JSON.stringify(param));
        that.saveUserFormId(function () {
          _app.appMethod.turnToPage(pagePath, 0);
        });
        return;
      }
      that.saveUserFormId();
      if (_this2.data.orderInfo.total_price == 0 && !paymentOrder) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppPreSell/AddOrder',
          method: 'Post',
          data: {
            sub_shop_app_id: that.data.franchiseeId,
            is_balance: that.data.useBalance ? 1 : 0,
            address_id: orderInfo.address_id,
            pick_up_type: 1,
            presell_shopping_cart: [{
              goods_id: goodsInfo.goods_id,
              num: goodsInfo.num,
              model_id: goodsInfo.model_id
            }],
            bargain_order_id: orderId
          },
          success: function success(res) {
            setTimeout(function () {
              _app.appMethod.showToast({
                title: '支付成功',
                icon: 'success',
                success: function success() {
                  that.paySuccessCallback();
                }
              });
            });
          }
        });
        return;
      }
      orderId = paymentOrder ? paymentOrder.order_id : orderInfo.order_id;
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data
      //     param.orderId = orderId
      //     param.goodsType = that.data.orderInfo.goods_type
      //     param.success = function () {
      //       that.paySuccessCallback()
      //     }
      //     app.wxPay(param)
      //   }
      // })
      var paySuccessUrl = function paySuccessUrl() {
        var orderId = _this2.data.orderId;
        var franchiseeId = _this2.franchiseeId;
        return '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      };
      _app.appMethod.goPay({
        orderId: orderId,
        successUrl: paySuccessUrl()
      });
    };

    _this2.wxPay = function (param) {
      var that = _this2;
      Taro.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _app.appMethod.wxPaySuccess(param);
          param.success();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消',
              complete: param.fail
            });
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败',
            complete: param.fail
          });
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    _this2.applyDrawback = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/previewGoodsRefund/previewGoodsRefund?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.remindCustomer = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppPreSell/RemindCustomer',
        data: {
          order_id: that.data.orderInfo.order_id
        },
        success: function success() {
          var data = {};
          data['orderInfo.status'] = 7;
          data['presell_status'] = 8;
          that.setData(data);
        }
      });
    };

    _this2.editorRefund = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = 7;
          that.setData(data);
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderId;
      var ecommerce_info = _this2.data.orderInfo.ecommerce_info;
      var usePickType = _this2.data.usePickType;
      if (usePickType == 2) {
        var intraCityData = ecommerce_info.intra_city_data;
        var type = intraCityData && intraCityData.deliver_type || '';
        var arriveTime = intraCityData && intraCityData.intra_city_appointment_arrive_time || '';
        _this2.saveUserFormId(function () {
          _app.appMethod.turnToPage('/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' + orderId + '&type=' + type + '&arriveTime=' + arriveTime + '&franchiseeId=' + this.franchiseeId, 0);
        });
      } else {
        _this2.saveUserFormId(function () {
          _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId + '&franchiseeId=' + this.franchiseeId, 0);
        });
      }
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderId,
          that = _this2,
          addTime = Date.now();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          that.saveUserFormId(function () {
            _app.appMethod.turnToPage('/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' + orderId + '&franchiseeId=' + that.franchiseeId, 0);
          });
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: {
              add_time: addTime
            },
            success: function success(res) {
              if (res.status == 0) {
                res.data && that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                });
              }
            }
          });
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.franchiseeId,
          pagePath = '/eCommerce/pages/makeComment/makeComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage('/pages/' + router + '/' + router, 1);
      });
    };

    _this2.getFreigtAdress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        data: {
          app_id: _app.appMethod.getAppId(),
          sub_app_id: that.franchiseeId
        },
        success: function success(res) {
          that.setData({
            freightAdress: res.data
          });
        }
      });
    };

    _this2.seeAdditionalInfo = function () {
      _this2.saveUserFormId(function () {
        _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail', 0);
      });
    };

    _this2.paySuccessCallback = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      if (!franchiseeId) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: franchiseeId
          },
          success: function success(res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1';
            }
            that.saveUserFormId(function () {
              _app.appMethod.turnToPage(pagePath, 0);
            });
          }
        });
      } else {
        that.saveUserFormId(function () {
          _app.appMethod.turnToPage(pagePath, 0);
        });
      }
    };

    _this2.copyOrderId = function () {
      var that = _this2;
      _app.appMethod.setClipboardData({
        data: that.data.orderId,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.showGoodsDetail = function (e) {
      var orderId = e.currentTarget.dataset.orderid;
      _app.appMethod.turnToPage('/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + _this2.data.orderInfo.order_id);
    };

    _this2.getWriteOffCodeBox = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetOrderVerifyCode',
        data: {
          sub_shop_app_id: franchiseeId,
          order_id: orderId
        },
        success: that.setVerificationCodeData
      });
    };

    _this2.setVerificationCodeData = function (res) {
      var that = _this2;
      that.setData({
        codeImgUrl: res.data.qrcode_url,
        codeNum: res.data.code,
        codeStatus: res.data.status,
        showWriteOffCodeBox: true
      });
      that.connectSocket();
    };

    _this2.connectSocket = function () {
      var that = _this2;
      Taro.connectSocket({
        url: 'wss://ceshi.zhichiwangluo.com', //线下test
        header: {
          'content-type': 'application/json'
        },
        method: 'GET'
      });
      Taro.onSocketOpen(function (res) {
        var data = {
          action: 'mark_client',
          user_token: _app.appMethod.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: _app.appMethod.globalData.sessionKey
        };
        Taro.sendSocketMessage({
          data: JSON.stringify(data)
        });
        that.verifiTimeInterval = setInterval(function () {
          var data = {
            action: 'heartbeat',
            user_token: _app.appMethod.globalData.userInfo.user_token,
            scenario_name: 'app_order_verify',
            session_key: _app.appMethod.globalData.sessionKey
          };
          Taro.sendSocketMessage({
            data: JSON.stringify(data)
          });
        }, 30000);
      });
      Taro.onSocketMessage(function (res) {
        var data = JSON.parse(res.data);
        if (data.action == 'push_to_client') {
          var msg = JSON.parse(data.msg);
          if (msg.type == 'app_order_verify' && msg.status == 0) {
            that.setData({
              codeStatus: 1
            });
            clearInterval(that.verifiTimeInterval);
            Taro.closeSocket();
          }
        }
      });
    };

    _this2.hideWriteOffCodeBox = function () {
      var that = _this2;
      _this2.setData({
        showWriteOffCodeBox: false
      });
      clearInterval(that.verifiTimeInterval);
      Taro.closeSocket();
    };

    _this2.hideEventDialog = function () {
      _this2.setData({
        showEventDialog: false
      });
    };

    _this2.showEventDialog = function (event) {
      _this2.setData({
        eventType: event.currentTarget.dataset.type,
        showEventDialog: true
      });
    };

    _this2.goOrderProgress = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.returnInfor = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var pagePath = '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.cancelRefund = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.showModal({
        content: '确认取消退款吗？',
        showCancel: true,
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=appShop/cancelRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId,
              _app_id: 'GumaC311tx'
            },
            success: function success() {
              that.getOrderDetail(orderId);
            }
          });
        }
      });
    };

    _this2.getAppECStoreConfig = function () {
      _app.appMethod.getAppECStoreConfig(function (res) {
        _this2.setData({
          storeStyle: res.color_config
        });
      }, _this2.franchiseeId);
    };

    _this2.deliveryDrawback = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/applyRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: franchiseeId
        },
        success: function success(res) {
          that.getOrderDetail(orderId);
        },
        complete: function complete() {
          that.setData({
            showEventDialog: false
          });
        }
      });
    };

    _this2.goAlreadyGoodsPage = function () {
      var that = _this2;
      var pagePath = '/eCommerce/pages/goodsAlreadyRefunded/goodsAlreadyRefunded';
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(pagePath, 0);
      });
    };

    _this2.getLogistics = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/expressFlow',
        data: {
          order_id: that.data.orderId
        },
        success: function success(res) {
          if (!res.data) {
            return;
          }
          if (res.data.is_custom) {
            that.setData({
              logisticsCustom: res.data.is_custom
            });
          } else {
            that.setData({
              info: res.data,
              logistics: res.data.Traces
            });
          }
        }
      });
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (callback) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchiseeId || '',
          form_id: _this.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    _this2.toGoodsAfterSaleDetail = function (event) {
      var that = _this2;
      var orderId = _this2.data.orderId;
      var franchiseeId = _this2.franchiseeId;
      var applyId = _this2.data.orderInfo.refund_apply.id;
      var router = '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' + applyId + '&detail=' + orderId + '&franchisee=' + franchiseeId;
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage(router);
      });
    };

    _this2.goDeliveryNavigation = function () {
      Taro.openLocation({
        latitude: Number(_this2.data.orderInfo.self_delivery_info.latitude),
        longitude: Number(_this2.data.orderInfo.self_delivery_info.longitude),
        name: _this2.data.orderInfo.self_delivery_info.address
      });
    };

    _this2.sameJournyLogistic = function () {
      var that = _this2;
      var orderId = _this2.data.orderId;
      that.saveUserFormId(function () {
        _app.appMethod.turnToPage('/eCommerce/pages/sameJournyLogistic/sameJournyLogistic?detail=' + orderId, 0);
      });
    };

    _this2.getRefundConfigByPickUpType = function (type) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
        data: {
          pick_up_type: type
        },
        success: function success(res) {
          if (res.data && res.data.config_data) {
            var data = res.data.config_data;
            that.setData({
              refundAdress: data.address || '',
              isFullRefund: data.is_full_refund
            });
          }
        }
      });
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(PresellOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false
      });
      this.franchiseeId = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.downcountArr && this.downcountArr.length) {
        this.downcountArr = this.downcountArr.concat().reverse();
        for (var i = 0; i < this.downcountArr.length; i++) {
          this.downcountArr[i] && this.downcountArr[i].clear();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          rewardPointObj = _state.rewardPointObj,
          presell_status = _state.presell_status,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          storeStyle = _state.storeStyle,
          presellIcon = _state.presellIcon,
          presellStatus = _state.presellStatus,
          is_presell_order = _state.is_presell_order,
          orderInfo = _state.orderInfo,
          orderIcon = _state.orderIcon,
          orderStatus = _state.orderStatus,
          refundIcon = _state.refundIcon,
          refundStatus = _state.refundStatus,
          refundAdress = _state.refundAdress,
          logistics = _state.logistics,
          logisticsCustom = _state.logisticsCustom,
          usePickType = _state.usePickType,
          appLogo = _state.appLogo,
          appName = _state.appName,
          useBalance = _state.useBalance,
          final_payment_start_time = _state.final_payment_start_time,
          final_payment_end_time = _state.final_payment_end_time,
          discount_cut_price = _state.discount_cut_price,
          express_fee = _state.express_fee,
          under_sales = _state.under_sales,
          hasAdditionalInfo = _state.hasAdditionalInfo,
          hasAlreadyGoods = _state.hasAlreadyGoods,
          prsell_status = _state.prsell_status,
          intraCityStatus = _state.intraCityStatus,
          isFullRefund = _state.isFullRefund,
          codeImgUrl = _state.codeImgUrl,
          codeStatus = _state.codeStatus,
          codeNum = _state.codeNum,
          showWriteOffCodeBox = _state.showWriteOffCodeBox,
          eventType = _state.eventType,
          showEventDialog = _state.showEventDialog;


      return React.createElement(
        'div',
        { className: 'official-page presell-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            {
              className: 'order-contain',
              style: (0, _tools.convertLineStyleData)('height:' + (presell_status == 2 || presell_status == 10 || presell_status == 12 ? '100%' : 'calc(100% - 88rpx)') + ';')
            },
            isFromTemplateMsg && React.createElement(
              'div',
              {
                className: 'orderDetail-goto-homepage',
                onClick: this.goToHomepage
              },
              '\u8FD4\u56DE\u9996\u9875'
            ),
            React.createElement(
              'div',
              {
                className: 'seller-shipped',
                style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
              },
              is_presell_order == 1 || is_presell_order == 3 ? React.createElement(
                'div',
                null,
                React.createElement('span', {
                  className: 'order-icon ico-moon icon-' + presellIcon[presell_status]
                }),
                React.createElement(
                  'span',
                  null,
                  presellStatus[presell_status]
                )
              ) : orderInfo.status != 4 ? React.createElement(
                'div',
                null,
                React.createElement('span', {
                  className: 'order-icon ico-moon icon-' + orderIcon[orderInfo.status]
                }),
                React.createElement(
                  'span',
                  null,
                  orderInfo.pick_up_type != 1 && orderInfo.status == 8 ? '商家待接单' : orderStatus[orderInfo.status]
                )
              ) : React.createElement(
                'div',
                null,
                React.createElement('span', {
                  className: 'order-icon ico-moon icon-' + refundIcon[orderInfo.refund_apply.status]
                }),
                React.createElement(
                  'span',
                  null,
                  orderInfo.is_pay_on_delivery == 1 ? '审核中' : refundStatus[orderInfo.refund_apply.status]
                )
              )
            ),
            orderInfo.status == 0 && orderInfo.expire && presell_status != 5 && is_presell_order != 3 && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u8BF7\u5C3D\u5FEB\u5B8C\u6210\u4ED8\u6B3E\uFF0C\u8FD8\u5269',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                orderInfo.has_seckill == 1 ? orderInfo.close_order_time + '分' : orderInfo.expire
              ),
              '(\u8D85\u65F6\u6309',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                '\u53D6\u6D88\u8BA2\u5355'
              ),
              '\u5904\u7406)'
            ),
            orderInfo.status == 1 && orderInfo.expire && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u4ED8\u6B3E\u6210\u529F\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u53D1\u8D27'
            ),
            orderInfo.status == 2 && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u5546\u5BB6\u5DF2\u53D1\u8D27\uFF0C\u8DDD\u81EA\u52A8\u6536\u8D27\u8FD8\u5269',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                orderInfo.has_seckill == 1 ? orderInfo.close_order_time + '分' : orderInfo.expire
              )
            ),
            orderInfo.status == 4 && orderInfo.refund_apply.status == 0 && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u4F60\u5DF2\u6210\u529F\u53D1\u8D77\u9000\u6B3E\u7533\u8BF7\uFF0C\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u5904\u7406\uFF0C\u8FD8\u5269',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                orderInfo.refund_apply.expire
              ),
              '\uFF08\u8D85\u65F6\u6309',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                orderInfo.is_pay_on_delivery == 1 ? '拒绝取消订单' : '拒绝退款'
              ),
              '\u5904\u7406\uFF09'
            ),
            orderInfo.status == 4 && orderInfo.refund_apply.status == 3 && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u5546\u5BB6\u5DF2\u540C\u610F\u9000\u8D27\u9000\u6B3E\u7533\u8BF7\uFF0C\u8BF7\u53CA\u65F6\u9000\u8D27\uFF0C\u8FD8\u5269',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                orderInfo.refund_apply.expire
              ),
              '\uFF08\u8D85\u65F6\u6309',
              React.createElement(
                'span',
                { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                '\u4E70\u5BB6\u64A4\u9500\u9000\u8D27'
              ),
              '\u5904\u7406\uFF09'
            ),
            orderInfo.status == 4 && orderInfo.refund_apply.status == 4 && React.createElement(
              'div',
              { className: 'order-prompt' },
              '\u8BF7\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u6536\u8D27\uFF0C\u6536\u8D27\u5B8C\u6210\u540E\u5C06\u4F1A\u8FDB\u884C\u9000\u6B3E'
            ),
            (presell_status == 7 || presell_status == 8 || presell_status == 9 || presell_status == 6) && orderInfo.refund_apply.refund_remark && React.createElement(
              'div',
              { className: 'order-prompt' },
              '退款备注：' + (orderInfo.refund_apply.refund_remark || '')
            ),
            orderInfo.pick_up_type == 2 && orderInfo.status == 8 && React.createElement(
              'div',
              { className: 'order-prompt' },
              orderInfo.cacelOrderCountDownTime + '分钟未接单，订单将自动取消'
            ),
            orderInfo.status == 4 && orderInfo.refund_apply.refund_type == 2 && orderInfo.is_pay_on_delivery != 1 && React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { className: 'refund-address-box' },
                React.createElement(
                  'div',
                  { className: 'refund-address-title' },
                  React.createElement(
                    'span',
                    null,
                    '\u9000\u8D27\u5730\u5740'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    refundAdress.brand_name + ' ' + refundAdress.phone
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'pull-right refund-address' },
                  refundAdress.region_info[2].name + refundAdress.region_info[1].name + refundAdress.region_info[0].name + refundAdress.detail_address
                )
              )
            ),
            (orderInfo.status == 2 || orderInfo.status == 3 || orderInfo.status == 5) && usePickType == 1 && React.createElement(
              'div',
              { onClick: this.checkLogistics },
              React.createElement(
                'div',
                { className: 'goods-logistics' },
                React.createElement('span', { className: 'ico-moon icon-goods-logistics' }),
                logistics.length ? React.createElement(
                  'div',
                  { className: 'goods-logistics-info' },
                  React.createElement(
                    'div',
                    {
                      className: 'goods-logistics-title',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                    },
                    logistics[0].AcceptStation
                  ),
                  React.createElement(
                    'div',
                    { className: 'goods-logistics-time' },
                    logistics[0].AcceptTime
                  )
                ) : React.createElement(
                  'div',
                  { className: 'goods-logistics-info' },
                  logisticsCustom == 1 ? '商家自主发货' : '暂无物流信息'
                ),
                React.createElement('span', {
                  style: (0, _tools.convertLineStyleData)('display: inline-block;vertical-align: middle;'),
                  className: 'colord2d2 ico-moon icon-rightarrow'
                })
              )
            ),
            is_presell_order == 1 || is_presell_order == 3 ? React.createElement(
              React.Fragment,
              null,
              presell_status != 7 && React.createElement(
                'div',
                { className: 'buyer-information self-delivery-info' },
                React.createElement('span', { className: 'ico-moon icon-goods-location' }),
                orderInfo.pick_up_type == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5FEB\u9012'
                      ),
                      orderInfo.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        orderInfo.address_info.name
                      ),
                      React.createElement(
                        'span',
                        null,
                        orderInfo.address_info.contact
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                    )
                  )
                ),
                orderInfo.pick_up_type == 2 ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u540C\u57CE'
                      ),
                      orderInfo.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        orderInfo.address_info.name
                      ),
                      React.createElement(
                        'span',
                        null,
                        orderInfo.address_info.contact
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                    )
                  )
                ) : orderInfo.pick_up_type == 3 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'buyer-box' },
                    React.createElement(
                      'div',
                      { className: 'buyer-name-box' },
                      React.createElement(
                        'span',
                        {
                          className: 'cash-delivery shipping-type',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u81EA\u63D0'
                      ),
                      orderInfo.is_pay_on_delivery == 1 && React.createElement(
                        'span',
                        {
                          className: 'cash-delivery',
                          style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme)
                        },
                        '\u5230\u4ED8'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buyer-name' },
                        orderInfo.self_delivery_info.contact_name
                      ),
                      React.createElement(
                        'span',
                        null,
                        orderInfo.self_delivery_info.contact_phone
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'buyer-address' },
                      orderInfo.self_delivery_info.address
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'delivery-navigation',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                      onClick: this.goDeliveryNavigation
                    },
                    '\u5BFC\u822A'
                  )
                )
              ),
              presell_status != 7 && presell_status != 6 ? React.createElement(
                'div',
                { className: 'app-box' },
                React.createElement(
                  'div',
                  null,
                  React.createElement('img', { className: 'app-logo', src: appLogo }),
                  React.createElement(
                    'span',
                    { className: 'app-name' },
                    appName
                  ),
                  React.createElement(
                    'div',
                    { className: 'contact-service pull-right' },
                    React.createElement(
                      'span',
                      null,
                      '\u8054\u7CFB\u5BA2\u670D'
                    ),
                    React.createElement('span', { className: 'ico-moon icon-goods-customer-service' }),
                    React.createElement('button', null)
                  )
                )
              ) : React.createElement(
                'div',
                { className: 'refund-msg' },
                '\u9000\u8D27\u4FE1\u606F'
              ),
              orderInfo.goods_info.map(function (goods, goodsIndex) {
                return React.createElement(
                  React.Fragment,
                  { key: goodsIndex },
                  React.createElement(
                    'div',
                    { className: 'goods-detail-box' },
                    React.createElement('img', { src: goods.cover }),
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        { className: 'goods-name' },
                        React.createElement(
                          'span',
                          { className: 'is-seckill' },
                          '\u9884\u552E'
                        ),
                        goods.goods_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-rules' },
                        goods.model_value == null ? '' : goods.model_value
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-price' },
                        !goods.use_integral || goods.use_integral == 0 ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          goods.price != '0.00' && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          ),
                          goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && goods.price != '0.00' && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '+'
                          ),
                          goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            goods.max_can_use_integral + '积分'
                          )
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          'x ' + goods.num
                        )
                      )
                    )
                  )
                );
              }),
              orderInfo.status == 4 && presell_status != 6 && orderInfo.refund_apply.id && React.createElement(
                'div',
                { className: 'refunding-btn-box' },
                React.createElement(
                  'span',
                  {
                    className: 'refunding-btn',
                    onClick: this.toGoodsAfterSaleDetail
                  },
                  '\u9000\u6B3E\u4E2D'
                )
              ),
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('padding:0 30rpx;') },
                under_sales ? React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'section-presell section-one' },
                    presell_status == 0 || presell_status == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB51\uFF1A\u7B49\u5F85\u4E70\u5BB6\u4ED8\u6B3E'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'presell-amount' },
                            React.createElement(
                              'span',
                              null,
                              '\u5546\u54C1\u5B9A\u91D1'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥' + orderInfo.total_bargain
                            )
                          ),
                          presell_status != 0 && presell_status != 1 && React.createElement(
                            React.Fragment,
                            null,
                            orderInfo.bargain_use_balance && orderInfo.bargain_use_balance > 0 ? React.createElement(
                              'div',
                              { className: 'stored-value-deduction' },
                              React.createElement(
                                'span',
                                null,
                                '\u50A8\u503C\u62B5\u6263'
                              ),
                              React.createElement(
                                'span',
                                { className: 'pull-right' },
                                '- ¥ ' + orderInfo.bargain_use_balance
                              )
                            ) : is_presell_order == 1 && useBalance && React.createElement(
                              'div',
                              { className: 'stored-value-deduction' },
                              React.createElement(
                                'span',
                                null,
                                '\u50A8\u503C\u62B5\u6263'
                              ),
                              React.createElement(
                                'span',
                                { className: 'pull-right' },
                                '- ¥ ' + useBalance
                              )
                            )
                          )
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'actual-presell-amount' },
                        React.createElement(
                          'span',
                          null,
                          '\u5B9A\u91D1\u9700\u4ED8\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥' + orderInfo.total_bargain
                        )
                      )
                    ) : presell_status != 0 && presell_status != 1 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            presell_status == 5 ? '阶段1：已取消' : presell_status == 12 ? '阶段1：未完成' : '阶段1：已完成'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'presell-amount' },
                            React.createElement(
                              'span',
                              null,
                              '\u5546\u54C1\u5B9A\u91D1'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥' + orderInfo.total_bargain
                            )
                          ),
                          orderInfo.bargain_use_balance && orderInfo.bargain_use_balance > 0 ? React.createElement(
                            'div',
                            { className: 'stored-value-deduction' },
                            React.createElement(
                              'span',
                              null,
                              '\u50A8\u503C\u62B5\u6263'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '- ¥ ' + orderInfo.bargain_use_balance
                            )
                          ) : is_presell_order == 1 && useBalance && React.createElement(
                            'div',
                            { className: 'stored-value-deduction' },
                            React.createElement(
                              'span',
                              null,
                              '\u50A8\u503C\u62B5\u6263'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '- ¥ ' + useBalance
                            )
                          )
                        )
                      ),
                      presell_status != 5 && React.createElement(
                        'div',
                        { className: 'actual-presell-amount' },
                        React.createElement(
                          'span',
                          null,
                          presell_status == 5 ? '定金未支付' : presell_status == 12 ? '定金未支付' : '定金实付款'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥' + orderInfo.total_bargain
                        )
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'section-presell section-two' },
                    React.createElement(
                      'div',
                      null,
                      presell_status == 2 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB52\uFF1A\u672A\u5F00\u59CB'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'surplus-tips' },
                            React.createElement(
                              'span',
                              null,
                              final_payment_start_time + ' 开始支付尾款'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥ ' + orderInfo.total_final_payment
                            )
                          )
                        )
                      ) : presell_status == 1 || presell_status == 3 || presell_status == 0 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB52\uFF1A\u7B49\u5F85\u4E70\u5BB6\u4ED8\u6B3E'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'final_payment_end_time' },
                            React.createElement(
                              'span',
                              null,
                              final_payment_end_time + ' 结束支付尾款'
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'goods-amount' },
                            React.createElement(
                              'span',
                              null,
                              '\u5546\u54C1\u5C3E\u6B3E'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥ ' + orderInfo.total_final_payment
                            )
                          )
                        )
                      ) : presell_status == 4 || is_presell_order == 3 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB52\uFF1A\u5DF2\u5B8C\u6210'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'goods-amount' },
                            React.createElement(
                              'span',
                              null,
                              '\u5546\u54C1\u5C3E\u6B3E'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥ ' + orderInfo.total_final_payment
                            )
                          ),
                          orderInfo.has_seckill == 1 && React.createElement(
                            'div',
                            { className: 'spike-offer' },
                            React.createElement(
                              'span',
                              null,
                              '\u6D3B\u52A8\u4F18\u60E0'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '秒杀  - ¥ ' + orderInfo.seckill_cut_price
                            )
                          ),
                          orderInfo.selected_benefit_info && React.createElement(
                            'div',
                            { className: 'promotion-method' },
                            React.createElement(
                              'div',
                              { style: (0, _tools.convertLineStyleData)('overflow:hidden;') },
                              React.createElement(
                                'span',
                                null,
                                '\u4F18\u60E0\u62B5\u6263'
                              ),
                              React.createElement(
                                'span',
                                {
                                  className: 'pull-right promotion-method-title',
                                  style: (0, _tools.convertLineStyleData)('color:#999;')
                                },
                                orderInfo.selected_benefit_info.title || '无'
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'pull-right',
                                style: (0, _tools.convertLineStyleData)('margin-top:20rpx;')
                              },
                              '- ¥ ' + discount_cut_price
                            )
                          ),
                          useBalance > 0 && React.createElement(
                            'div',
                            { className: 'stored-value-deduction' },
                            React.createElement(
                              'span',
                              null,
                              '\u50A8\u503C\u62B5\u6263'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '- ¥ ' + orderInfo.final_use_balance
                            )
                          )
                        )
                      ) : presell_status == 5 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB52\uFF1A\u5DF2\u53D6\u6D88'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'goods-amount' },
                            React.createElement(
                              'span',
                              null,
                              '\u5546\u54C1\u5C3E\u6B3E'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥ ' + orderInfo.total_final_payment
                            )
                          )
                        )
                      ) : (presell_status == 10 || presell_status == 12) && React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'div',
                          { className: 'section-tips' },
                          React.createElement(
                            'div',
                            null,
                            React.createElement('span', null),
                            React.createElement('span', null)
                          ),
                          React.createElement(
                            'div',
                            null,
                            '\u9636\u6BB52\uFF1A\u672A\u5B8C\u6210'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'detail-msg' },
                          React.createElement(
                            'div',
                            { className: 'surplus-tips' },
                            React.createElement(
                              'span',
                              null,
                              final_payment_end_time + ' 结束支付尾款'
                            ),
                            React.createElement(
                              'span',
                              { className: 'pull-right' },
                              '¥ ' + orderInfo.presell_shopping_cart[0].final_payment
                            )
                          )
                        )
                      )
                    ),
                    !(orderInfo.status == 7 && is_presell_order != 3 || presell_status == 0 || presell_status == 1 || presell_status == 5) && React.createElement(
                      'div',
                      { className: 'actual-payment' },
                      presell_status == 3 || presell_status == 2 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          null,
                          '\u5C3E\u6B3E\u5F85\u4ED8\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color:#333;') },
                          '¥ ' + orderInfo.total_final_payment
                        )
                      ) : presell_status == 10 || presell_status == 12 ? React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          null,
                          '\u5C3E\u6B3E\u672A\u652F\u4ED8'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color:#333;') },
                          '¥ ' + orderInfo.total_final_payment
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        React.createElement(
                          'span',
                          null,
                          '\u5C3E\u6B3E\u5B9E\u4ED8\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color:#333;') },
                          '¥ ' + orderInfo.final_payment_total_price
                        )
                      )
                    )
                  ),
                  presell_status != 10 && presell_status != 12 && React.createElement(
                    'div',
                    { className: 'freight' },
                    React.createElement(
                      'span',
                      null,
                      '\u8FD0\u8D39'
                    ),
                    React.createElement(
                      'span',
                      { className: 'pull-right' },
                      '¥ ' + express_fee
                    )
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { className: 'detail-msg' },
                    presell_status == 5 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'presell-amount' },
                        React.createElement(
                          'span',
                          null,
                          '\u5546\u54C1\u5B9A\u91D1'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥' + orderInfo.total_bargain
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-amount' },
                        React.createElement(
                          'span',
                          null,
                          '\u5546\u54C1\u5C3E\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥ ' + orderInfo.presell_shopping_cart[0].final_payment
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'freight' },
                        React.createElement(
                          'span',
                          null,
                          '\u8FD0\u8D39'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥ ' + express_fee
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'actual-payment' },
                        React.createElement(
                          'span',
                          null,
                          '\u5B9E\u9645\u4ED8\u6B3E'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥ ' + (presell_status == 5 ? '0.00' : orderInfo.total_price)
                        )
                      )
                    ) : React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'refund-amount' },
                        React.createElement(
                          'span',
                          null,
                          '\u9000\u6B3E\u91D1\u989D'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          '¥' + orderInfo.refund_apply.refund_price
                        )
                      ),
                      (presell_status == 7 || presell_status == 9 || presell_status == 6) && React.createElement(
                        'div',
                        {
                          className: 'refund-time',
                          style: (0, _tools.convertLineStyleData)('padding-bottom:30rpx;')
                        },
                        React.createElement(
                          'span',
                          null,
                          '\u9000\u6B3E\u65F6\u95F4'
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          orderInfo.refund_apply.add_time
                        )
                      )
                    )
                  )
                )
              ),
              is_presell_order == 3 && React.createElement(
                'div',
                { className: 'total-payment' },
                React.createElement(
                  'span',
                  null,
                  '\u5408\u8BA1'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + orderInfo.actual_amount_of_order
                )
              )
            ) : React.createElement(
              React.Fragment,
              null,
              orderInfo.status == 4 && React.createElement(
                'div',
                { className: 'refund-msg' },
                '\u9000\u8D27\u4FE1\u606F'
              ),
              orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
                return React.createElement(
                  React.Fragment,
                  { key: goodsIndex },
                  React.createElement(
                    'div',
                    { className: 'goods-detail-box' },
                    React.createElement('img', { src: goods.cover }),
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        { className: 'goods-name' },
                        React.createElement(
                          'span',
                          { className: 'is-seckill' },
                          '\u9884\u552E'
                        ),
                        goods.goods_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-rules' },
                        goods.model_value == null ? '' : goods.model_value
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-price' },
                        !goods.use_integral || goods.use_integral == 0 ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          goods.price != '0.00' && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '¥' + goods.price
                          ),
                          goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && goods.price != '0.00' && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            '+'
                          ),
                          goods.max_can_use_integral && goods.max_can_use_integral != '0' && goods.max_can_use_integral != 0 && React.createElement(
                            'span',
                            {
                              className: 'colorff7',
                              style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme)
                            },
                            goods.max_can_use_integral + '积分'
                          )
                        ),
                        React.createElement(
                          'span',
                          { className: 'pull-right' },
                          'x ' + goods.num
                        )
                      )
                    )
                  )
                );
              }),
              React.createElement(
                'div',
                { className: 'detail-msg' },
                React.createElement(
                  'div',
                  { className: 'goods-amount' },
                  React.createElement(
                    'span',
                    null,
                    '\u5546\u54C1\u91D1\u989D'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '¥ ' + orderInfo.original_price
                  )
                ),
                orderInfo.has_seckill == 1 && React.createElement(
                  'div',
                  { className: 'spike-offer' },
                  React.createElement(
                    'span',
                    null,
                    '\u6D3B\u52A8\u4F18\u60E0'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '秒杀  - ¥ ' + orderInfo.seckill_cut_price
                  )
                ),
                orderInfo.selected_benefit_info && React.createElement(
                  'div',
                  { className: 'promotion-method' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '\u4F18\u60E0\u65B9\u5F0F'
                    ),
                    React.createElement(
                      'span',
                      { className: 'pull-right promotion-method-title' },
                      orderInfo.selected_benefit_info.title || '无'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'pull-right', style: (0, _tools.convertLineStyleData)('margin-top:20rpx;') },
                    '- ¥ ' + discount_cut_price
                  )
                ),
                useBalance > 0 && React.createElement(
                  'div',
                  { className: 'stored-value-deduction' },
                  React.createElement(
                    'span',
                    null,
                    '\u50A8\u503C\u62B5\u6263'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥ ' + useBalance
                  )
                ),
                orderInfo.coupon_fee && React.createElement(
                  'div',
                  null,
                  '\u793E\u4EA4\u7ACB\u51CF\u91D1',
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥ ' + orderInfo.coupon_fee
                  )
                ),
                hasAdditionalInfo && React.createElement(
                  'div',
                  {
                    className: 'addition-info',
                    onClick: this.seeAdditionalInfo
                  },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '\u8865\u5145\u4FE1\u606F'
                    ),
                    React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'freight' },
                React.createElement(
                  'span',
                  null,
                  '\u8FD0\u8D39'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥ ' + express_fee
                )
              ),
              React.createElement(
                'div',
                { className: 'actual-payment' },
                React.createElement(
                  'span',
                  null,
                  '\u5B9E\u9645\u4ED8\u6B3E'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '¥' + orderInfo.total_price
                )
              )
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('margin-top:16rpx;') },
              hasAdditionalInfo && React.createElement(
                'div',
                {
                  className: 'addition-info isRelative',
                  onClick: this.seeAdditionalInfo
                },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u8865\u5145\u4FE1\u606F'
                  ),
                  React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
                )
              ),
              orderInfo.remark && React.createElement(
                'div',
                { className: 'buyer-message' },
                React.createElement(
                  'span',
                  null,
                  '\u4E70\u5BB6\u7559\u8A00'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  orderInfo.remark
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'addition-info no-border isRelative',
                  onClick: this.goOrderProgress,
                  style: (0, _tools.convertLineStyleData)('margin-top:0;')
                },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u8BA2\u5355\u8FDB\u5EA6'
                  ),
                  React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
                )
              )
            ),
            hasAlreadyGoods && React.createElement(
              'div',
              {
                className: 'addition-info no-border already-refund-goods',
                onClick: this.goAlreadyGoodsPage
              },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u5DF2\u9000\u5546\u54C1'
                ),
                React.createElement('span', { className: 'pull-right colord2d2 ico-moon icon-rightarrow' })
              )
            ),
            React.createElement(
              'div',
              { className: 'order-number' },
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u8BA2\u5355\u7F16\u53F7'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.order_id
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right copy-btn', onClick: this.copyOrderId },
                  '\u590D\u5236'
                )
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u4E0B\u5355\u65F6\u95F4'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.add_time
                )
              ),
              orderInfo.pick_up_type == 2 && React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  null,
                  '\u9001\u8FBE\u65F6\u95F4'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.ecommerce_info.intra_city_data.intra_city_appointment_arrive_time
                )
              ),
              orderInfo.pick_up_type == 3 && React.createElement(
                React.Fragment,
                null,
                orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_appointment_time && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u9884\u7EA6\u65F6\u95F4'
                  ),
                  React.createElement(
                    'span',
                    null,
                    orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_appointment_time
                  )
                ),
                orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_location_name && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u5E97\u5185\u4F4D\u7F6E'
                  ),
                  React.createElement(
                    'span',
                    null,
                    orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_location_name
                  )
                ),
                orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_buyer_phone && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u624B\u673A\u53F7\u7801'
                  ),
                  React.createElement(
                    'span',
                    null,
                    orderInfo.ecommerce_info.ec_tostore_data.ec_tostore_buyer_phone
                  )
                )
              )
            ),
            presell_status != 2 && presell_status != 10 && presell_status != 12 && React.createElement(
              'div',
              { className: 'order-bottom' },
              is_presell_order == 1 || is_presell_order == 3 ? React.createElement(
                React.Fragment,
                null,
                (presell_status == 0 || presell_status == 1 || presell_status == 3) && React.createElement(
                  React.Fragment,
                  null,
                  presell_status != 3 && React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'cancelOrder'
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-pay-directly isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.payOrder
                    },
                    '\u7ACB\u5373\u652F\u4ED8'
                  )
                ),
                presell_status == 4 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.applyDrawback
                    },
                    '\u7533\u8BF7\u9000\u6B3E'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.getWriteOffCodeBox
                    },
                    '\u6838\u9500\u7801'
                  )
                ),
                (presell_status == 5 || presell_status == 7 || presell_status == 9) && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'isRelative btn',
                      onClick: this.showEventDialog,
                      'data-type': 'orderDelete'
                    },
                    '\u5220\u9664\u8BA2\u5355'
                  )
                ),
                presell_status == 8 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'isRelative btn',
                      onClick: this.remindCustomer,
                      'data-type': 'remindCustomer'
                    },
                    '\u63D0\u9192\u5546\u5BB6'
                  )
                ),
                is_presell_order == 3 && React.createElement(
                  React.Fragment,
                  null,
                  presell_status != 4 && presell_status != 9 && prsell_status != 6 && React.createElement(
                    'span',
                    {
                      className: 'isRelative btn',
                      onClick: this.showGoodsDetail,
                      'data-type': 'remindCustomer',
                      style: (0, _tools.convertLineStyleData)('border:1px solid #ff7100;color:#ff7100;')
                    },
                    '\u53BB\u67E5\u770B'
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                orderInfo.status == 0 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'cancelOrder'
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-pay-directly isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.payOrder
                    },
                    '\u7ACB\u5373\u652F\u4ED8'
                  )
                ),
                orderInfo.status == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.getWriteOffCodeBox
                    },
                    '\u6838\u9500\u7801'
                  ),
                  intraCityStatus > 1 && intraCityStatus != 5 && intraCityStatus != 1000 && React.createElement(
                    'span',
                    {
                      className: 'btn isRelative',
                      onClick: this.checkLogistics
                    },
                    '\u914D\u9001\u4FE1\u606F'
                  ),
                  orderInfo.is_pay_on_delivery == 1 ? React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'deliveryDrawback'
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  ) : (orderInfo.is_group_buy_order != 0 && orderInfo.can_refund_order == 1 || orderInfo.is_group_buy_order == 0) && isFullRefund == 1 && React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.applyDrawback
                    },
                    '\u7533\u8BF7\u9000\u6B3E'
                  )
                ),
                orderInfo.status == 2 && React.createElement(
                  React.Fragment,
                  null,
                  orderInfo.pick_up_type != 3 && React.createElement(
                    'span',
                    {
                      className: 'btn isRelative',
                      onClick: this.checkLogistics
                    },
                    '\u914D\u9001\u4FE1\u606F'
                  ),
                  orderInfo.is_pay_on_delivery == 1 ? React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'deliveryDrawback'
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  ) : (orderInfo.is_group_buy_order != 0 && orderInfo.can_refund_order == 1 || orderInfo.is_group_buy_order == 0) && isFullRefund == 1 && React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.applyDrawback
                    },
                    '\u7533\u8BF7\u9000\u6B3E'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.getWriteOffCodeBox
                    },
                    '\u6838\u9500\u7801'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.showEventDialog,
                      'data-type': 'sureReceipt'
                    },
                    '\u786E\u8BA4\u6536\u8D27'
                  )
                ),
                orderInfo.status == 3 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund  isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'orderDelete'
                    },
                    '\u5220\u9664\u8BA2\u5355'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.getWriteOffCodeBox
                    },
                    '\u6838\u9500\u7801'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.makeComment
                    },
                    '\u53BB\u8BC4\u4EF7'
                  )
                ),
                orderInfo.status == 4 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn isRelative',
                      onClick: this.cancelRefund
                    },
                    orderInfo.refund_apply.status == 3 || orderInfo.refund_apply.status == 4 ? '撤销退货' : '撤销申请'
                  ),
                  orderInfo.is_pay_on_delivery != 1 && React.createElement(
                    'span',
                    {
                      className: 'btn isRelative',
                      onClick: this.editorRefund
                    },
                    '\u4FEE\u6539\u7533\u8BF7'
                  ),
                  orderInfo.refund_apply.status == 3 && React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange isRelative',
                      style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';border-color:' + storeStyle.theme),
                      onClick: this.returnInfor
                    },
                    '\u586B\u5199\u9000\u8D27\u4FE1\u606F'
                  )
                ),
                orderInfo.status == 5 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'receiveDrawback'
                    },
                    '\u6536\u5230\u9000\u6B3E'
                  )
                ),
                orderInfo.status == 6 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'orderDelete'
                    },
                    '\u5220\u9664\u8BA2\u5355'
                  )
                ),
                orderInfo.status == 7 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'orderDelete'
                    },
                    '\u5220\u9664\u8BA2\u5355'
                  )
                ),
                orderInfo.status == 8 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'apply-refund isRelative',
                      onClick: this.showEventDialog,
                      'data-type': 'cancelOrder'
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  )
                )
              )
            )
          ),
          showWriteOffCodeBox && React.createElement(
            'div',
            {
              className: 'verification-code',
              onClick: this.hideWriteOffCodeBox
            },
            React.createElement(
              'div',
              { className: 'verification-code-tips' },
              '\u5411\u5546\u5BB6\u51FA\u793A\u4E8C\u7EF4\u7801\u6216\u6838\u9500\u7801\u540E\u5373\u53EF\u6D88\u8D39'
            ),
            React.createElement(
              'div',
              { className: 'verification-image-box' },
              React.createElement('img', { className: 'verification-code-img', src: codeImgUrl }),
              codeStatus == 1 && React.createElement(
                'div',
                { className: 'verification-code-finished' },
                React.createElement(
                  'div',
                  null,
                  '\u5DF2\u6838\u9500'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'verification-code-text' },
              React.createElement(
                'span',
                null,
                '\u6838\u9500\u7801\uFF1A'
              ),
              React.createElement(
                'span',
                null,
                codeNum
              )
            )
          ),
          showEventDialog && React.createElement(
            'div',
            { className: 'event-dialog-mask' },
            React.createElement(
              'div',
              { className: 'event-dialog' },
              eventType == 'cancelOrder' && React.createElement(
                'div',
                { className: 'event-dialog-title' },
                '\u786E\u8BA4\u53D6\u6D88\u8BA2\u5355\uFF1F'
              ),
              eventType == 'orderDelete' && React.createElement(
                'div',
                { className: 'event-dialog-title' },
                '\u8BA2\u5355\u5220\u9664\u540E\u4E0D\u53EF\u627E\u56DE\uFF0C\u786E\u8BA4\u5220\u9664\uFF1F'
              ),
              eventType == 'receiveDrawback' && React.createElement(
                'div',
                { className: 'event-dialog-title' },
                '\u786E\u5B9A\u5DF2\u6536\u5230\u9000\u6B3E\uFF1F'
              ),
              eventType == 'sureReceipt' && React.createElement(
                'div',
                { className: 'event-dialog-title' },
                '\u786E\u5B9A\u5DF2\u6536\u5230\u8D27\u7269\uFF1F'
              ),
              eventType == 'deliveryDrawback' && React.createElement(
                'div',
                { className: 'event-dialog-title' },
                '\u786E\u8BA4\u53D6\u6D88\u8BA2\u5355\uFF1F'
              ),
              React.createElement(
                'div',
                { className: 'event-dialog-bottom' },
                React.createElement(
                  'span',
                  { className: 'event-cancel', onClick: this.hideEventDialog },
                  '\u53D6\u6D88'
                ),
                eventType == 'cancelOrder' && React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'event-sure',
                    onClick: this.cancelOrder
                  },
                  '\u786E\u8BA4'
                ),
                eventType == 'orderDelete' && React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'event-sure',
                    onClick: this.orderDelete
                  },
                  '\u786E\u8BA4'
                ),
                eventType == 'receiveDrawback' && React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'event-sure',
                    onClick: this.receiveDrawback
                  },
                  '\u786E\u8BA4'
                ),
                eventType == 'sureReceipt' && React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'event-sure',
                    onClick: this.sureReceipt
                  },
                  '\u786E\u8BA4'
                ),
                eventType == 'deliveryDrawback' && React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme),
                    className: 'event-sure',
                    onClick: this.deliveryDrawback
                  },
                  '\u786E\u8BA4'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PresellOrderDetail;
}(_OfficialPage3.default);

exports.default = PresellOrderDetail;

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresellOrderList = function (_OfficialPage) {
  (0, _inherits3.default)(PresellOrderList, _OfficialPage);

  function PresellOrderList(props) {
    (0, _classCallCheck3.default)(this, PresellOrderList);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PresellOrderList.__proto__ || Object.getPrototypeOf(PresellOrderList)).call(this, props));

    _this2.state = {
      type: 0,
      is_more: 1,
      haveData: true,
      page: 1,
      loading: false,
      orderList: [],
      formid: []
    };
    _this2.presellOrderListRefresh = false;

    _this2.getOrderList = function () {
      var that = _this2,
          param = {
        show_presell_order: 2,
        page: that.data.page,
        goods_type: 0,
        page_size: 10
      };
      that.setData({
        loading: true
      });
      param.idx_arr = {
        idx: that.data.type == 7 ? 'status' : 'bargain_status',
        idx_value: that.data.type
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/orderList',
        method: 'post',
        data: param,
        success: function success(res) {
          var rdata = res.data || [];
          if (rdata.length == 0) {
            _this2.setData({
              haveData: false
            });
            return;
          }
          var newdata = {},
              server_time = rdata[0].form_data.server_time,
              oldData = that.data.orderList || [],
              oldLen = oldData.length;
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i].form_data,
                status = f.status,
                goodsInfo = f.goods_info[0],
                presell_status = void 0,
                presell_type = void 0,
                under_sale = void 0,
                presell_shopping_cart = f.presell_shopping_cart[0],
                modelArr = goodsInfo.model_value,
                is_presell_order = f.is_presell_order,
                final_payment_start_time = presell_shopping_cart.final_payment_start_time * 1;
            switch (is_presell_order) {
              case '1':
                switch (status) {
                  case '0':
                    presell_status = final_payment_start_time <= server_time ? 0 : 1; // 定金未付款,未到尾款支付时间
                    presell_type = '定金待付';
                    under_sale = true;
                    break;
                  case '4':
                    presell_status = 6;
                    presell_type = '退款审核中';
                    under_sale = false;
                    break;
                  case '11':
                    presell_status = final_payment_start_time <= server_time ? 3 : 2; //定金已付款，尾款未付款/未到尾款支付时间
                    presell_type = final_payment_start_time <= server_time ? '尾款待付' : '定金已付';
                    under_sale = true;
                    break;
                  case '7':
                    presell_status = f.refund_time != '0' ? 7 : 5; // 商家已退定金/订单已取消
                    presell_type = f.refund_time != '0' ? '定金退款成功' : '已取消';
                    under_sale = false;
                    break;
                  case '12':
                    presell_type = '定金超时未支付'; //
                    under_sale = false;
                    presell_status = 12;
                    break;
                  case '14':
                    presell_status = 5; //商品已取消
                    presell_type = '已取消'; //
                    under_sale = false;
                    break;
                  case '15':
                    presell_status = 8; //退款失败
                    presell_type = '退款失败';
                    under_sale = false;
                    break;
                }
                break;
              case '2':
                switch (status) {
                  case '0':
                    presell_status = 3; // 定金已付款，尾款未付款
                    presell_type = '尾款待付';
                    under_sale = true;
                    break;
                  default:
                    presell_status = 4; // 定金已付款，尾款已付款
                    presell_type = '尾款已付';
                    under_sale = false;
                }
                break;
              default:
                switch (status) {
                  case '0':
                    presell_type = '订单待付款';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '1':
                    presell_type = '商家待发货';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '2':
                    presell_type = '买家待收货';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '3':
                    presell_type = '订单待评价';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '4':
                    presell_type = '退款审核中';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '5':
                    presell_type = '退款中';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '6':
                    presell_type = '订单已完成';
                    presell_status = 11; // 尾款阶段
                    break;
                  case '7':
                    presell_status = 11; // 尾款阶段
                    presell_type = '已退款';
                    break;
                  case '8':
                    presell_status = 11; // 尾款阶段
                    presell_type = '卖家待接单';
                    break;
                  case '15':
                    presell_status = 8; // 尾款阶段
                    presell_type = '退款失败';
                    break;
                  default:
                    presell_status = 4; // 定金已付款，尾款已付款
                    presell_type = '尾款已付';
                    break;
                }
                under_sale = true;
                break;
            }
            if ((status == 11 || status == 7 && is_presell_order == 1) && f.server_time > f.final_payment_end_time) {
              under_sale = false;
              presell_type = f.refund_time != '0' ? '退款成功' : '尾款超时未支付';
            }
            f.model_value_str = modelArr && modelArr.join ? modelArr.join('； ') : '';
            f.presell_status = presell_status;
            f.presell_type = presell_type;
            f.under_sale = under_sale;
            var param_str = {
              goods_id: goodsInfo.goods_id,
              activity_id: goodsInfo.presell_activity_id || '',
              model_id: goodsInfo.model_id || '',
              nums: goodsInfo.num,
              address_id: f.address_id,
              models_text: f.model_value_str,
              models_stock: presell_shopping_cart.presell_stock_left,
              final_payment_start_time: final_payment_start_time || '',
              bargain_order_id: '',
              presell_status: presell_status,
              limit_buy: presell_shopping_cart.buy_limit_num
            };
            if (presell_status == 3 || presell_status == 4) {
              param_str.bargain_order_id = f.order_id;
            }
            f.param_str = JSON.stringify(param_str);
          }
          if (param.page == 1) {
            oldData = [];
          }
          newdata['orderList'] = oldData.concat(rdata);
          newdata['is_more'] = res.is_more;
          newdata['haveData'] = true;
          newdata['page'] = param.page + 1;
          that.setData(newdata);
        },
        complete: function complete() {
          var newdata = {};
          newdata['loading'] = false;
          that.setData(newdata);
        }
      });
    };

    _this2.changeType = function (e) {
      var data = e.currentTarget.dataset;
      if (_this2.data.type == data.type) {
        return;
      }
      _this2.setData({
        page: 1,
        is_more: 1,
        type: data.type,
        orderList: []
      });
      _this2.getOrderList();
    };

    _this2.gotoPresellOrder = function (e) {
      var presellPath = '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' + e.currentTarget.dataset.orderid + (_this2.data.franchiseeId ? '&franchisee=' + _this2.data.franchiseeId : '');
      _this2.presellOrderListRefresh = true;
      _app.appMethod.turnToPage(presellPath);
    };

    _this2.showGoodsDetail = function (e) {
      var orderId = e.currentTarget.dataset.orderid;
      _app.appMethod.turnToPage('/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' + orderId);
    };

    _this2.payOrder = function (e) {
      var that = _this2,
          data = e.currentTarget.dataset,
          param_str = JSON.parse(data.paramstr),
          payorderid = data.payorderid,
          pagePath = '/presell/pages/presellOrderDetail/presellOrderDetail?detail=' + payorderid;
      _this2.presellOrderListRefresh = true;
      _this2.saveUserFormId();
      if (payorderid) {
        // app.sendRequest({
        //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        //   data: {
        //     order_id: payorderid
        //   },
        //   success: function (res) {
        //     var param = res.data
        //     param.orderId = payorderid
        //     param.success = function () {
        //       setTimeout(function () {
        //         that.setData({
        //           page: 1
        //         })
        //         that.getOrderList()
        //       }, 1000)
        //     }
        //     app.wxPay(param)
        //   }
        // })
        _app.appMethod.goPay({
          orderId: payorderid
        });
      } else {
        _app.appMethod.turnToPage(pagePath);
      }
    };

    _this2.cancelOrder = function (e) {
      var orderId = e.target.dataset.id,
          franchisee = e.target.dataset.franchisee,
          appId = _app.appMethod.getAppId(),
          subShopId = franchisee == _app.appMethod.getAppId() ? '' : franchisee,
          that = _this2;
      _app.appMethod.showModal({
        content: '你将要取消一笔付款订单，确认取消？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          that.saveUserFormId();
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              app_id: appId,
              sub_shop_app_id: subShopId || ''
            },
            success: function success(res) {
              var index = that.data.currentTabIndex,
                  data = {};
              data['page'] = 1;
              that.setData(data);
              that.getOrderList({
                tabIndex: index
              });
            }
          });
        },
        cancel: function cancel() {}
      });
    };

    _this2.onReachBottom = function () {
      if (_this2.data.is_more == 0 || _this2.data.loading) {
        return;
      }
      _this2.getOrderList();
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (callback) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchiseeId || '',
          form_id: _this.data.formid || []
        },
        hideLoading: true,
        complete: function complete() {
          callback && callback();
          _this.setData({
            formid: []
          });
        }
      });
    };

    document.title = '订单列表';
    return _this2;
  }

  (0, _createClass3.default)(PresellOrderList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.getOrderList();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setData({
        page: 1
      });
      if (this.presellOrderListRefresh) {
        this.getOrderList();
        this.presellOrderListRefresh = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          type = _state.type,
          goodsInfo = _state.goodsInfo,
          haveData = _state.haveData,
          orderList = _state.orderList,
          is_more = _state.is_more;

      return React.createElement(
        'div',
        { className: 'official-page presell-order-list' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u5217\u8868' }),
        React.createElement(
          'div',
          { className: 'presell-list' },
          React.createElement(
            _ScrollView.ScrollView,
            { className: 'branch-classify', 'scroll-x': 'true' },
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '0' },
              React.createElement(
                'div',
                { className: type == '0' ? 'active' : '' },
                '\u5168\u90E8'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '1' },
              React.createElement(
                'div',
                { className: type == '1' ? 'active' : '' },
                '\u5B9A\u91D1\u5F85\u4ED8'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '2' },
              React.createElement(
                'div',
                { className: type == '2' ? 'active' : '' },
                '\u5B9A\u91D1\u5DF2\u4ED8'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '3' },
              React.createElement(
                'div',
                { className: type == '3' ? 'active' : '' },
                '\u5C3E\u6B3E\u5F85\u4ED8'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '4' },
              React.createElement(
                'div',
                { className: type == '4' ? 'active' : '' },
                '\u5C3E\u6B3E\u5DF2\u4ED8'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '6' },
              React.createElement(
                'div',
                { className: type == '6' ? 'active' : '' },
                '\u9000\u6B3E\u5931\u8D25'
              )
            ),
            React.createElement(
              'div',
              { className: 'isRelative', onClick: this.changeType, 'data-type': '7' },
              React.createElement(
                'div',
                { className: type == '7' ? 'active' : '' },
                '\u5DF2\u5173\u95ED'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'item-list' },
            haveData ? React.createElement(
              React.Fragment,
              null,
              orderList.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'item',
                    key: item.form_data.order_id,
                    onClick: _this3.gotoPresellOrder,
                    'data-orderid': item.form_data.order_id
                  },
                  React.createElement(
                    'div',
                    { className: 'item-tabbar' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        null,
                        item.form_data.add_time
                      ),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          React.Fragment,
                          null,
                          item.form_data.presell_type
                        )
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content' },
                    React.createElement(
                      'div',
                      { className: 'image-wrap' },
                      React.createElement('img', { src: item.form_data.goods_info[0].cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'detail-wrap' },
                      React.createElement(
                        'div',
                        { className: 'title' },
                        React.createElement(
                          'span',
                          null,
                          '\u9884\u552E'
                        ),
                        item.form_data.goods_info[0].goods_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'model-str' },
                        item.form_data.model_value_str
                      ),
                      React.createElement(
                        'div',
                        { className: 'total-price' },
                        React.createElement(
                          'span',
                          null,
                          '¥ ' + item.form_data.goods_info[0].price
                        ),
                        React.createElement(
                          'span',
                          null,
                          'X' + item.form_data.goods_info[0].num
                        )
                      )
                    )
                  ),
                  (item.form_data.under_sale || item.form_data.presell_status == 4) && React.createElement(
                    'div',
                    { className: 'presell-price' },
                    item.form_data.presell_status == 0 || item.form_data.presell_status == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        '定金待支付：¥ ' + item.form_data.total_bargain
                      )
                    ) : item.form_data.presell_status == 2 || item.form_data.presell_status == 3 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        '定金已支付：¥ ' + item.form_data.total_bargain
                      ),
                      React.createElement(
                        'span',
                        null,
                        '尾款待支付：¥ ' + item.form_data.total_final_payment
                      )
                    ) : item.form_data.presell_status == 10 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        '定金已支付：¥ ' + item.form_data.total_bargain
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#999;') },
                        '\u5C3E\u6B3E\u8D85\u65F6\u672A\u652F\u4ED8'
                      )
                    ) : item.form_data.is_presell_order == 3 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        '定金已支付：¥ ' + item.form_data.total_bargain
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:#999999;') },
                        '尾款已支付：¥ ' + item.form_data.total_final_payment
                      )
                    ),
                    item.form_data.presell_status == 5 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'span',
                        null,
                        '\u5DF2\u5173\u95ED'
                      )
                    )
                  ),
                  item.form_data.under_sale && React.createElement(
                    'div',
                    { className: 'item-bottom' },
                    item.form_data.presell_status == 0 || item.form_data.presell_status == 1 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        {
                          className: 'item-btn cancel-order',
                          onClick: function onClick(e) {
                            _this3.cancelOrder(e);e.stopPropagation();
                          },
                          'data-id': item.form_data.order_id
                        },
                        '\u53D6\u6D88\u8BA2\u5355'
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'item-btn handsel-pay',
                          onClick: function onClick(e) {
                            _this3.payOrder(e);e.stopPropagation();
                          },
                          'data-paramstr': JSON.stringify(item.form_data.param_str),
                          'data-payorderid': item.form_data.order_id
                        },
                        '\u652F\u4ED8\u5B9A\u91D1'
                      )
                    ) : item.form_data.presell_status == 2 ? React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { className: 'item-btn surplus-stay' },
                        '\u672A\u5230\u5C3E\u6B3E\u652F\u4ED8\u65F6\u95F4'
                      )
                    ) : item.form_data.presell_status == 3 ? React.createElement(
                      React.Fragment,
                      null,
                      item.form_data._presell_final_payment_order ? React.createElement(
                        'div',
                        {
                          className: 'item-btn surplus-pay',
                          onClick: function onClick(e) {
                            _this3.payOrder(e);e.stopPropagation();
                          },
                          'data-paramstr': JSON.stringify(item.form_data.param_str),
                          'data-payorderid': item.form_data._presell_final_payment_order.order_id
                        },
                        '\u652F\u4ED8\u5C3E\u6B3E'
                      ) : React.createElement(
                        'div',
                        {
                          className: 'item-btn surplus-pay',
                          onClick: function onClick(e) {
                            _this3.gotoPresellOrder(e);e.stopPropagation();
                          },
                          'data-orderid': item.form_data.order_id
                        },
                        '\u652F\u4ED8\u5C3E\u6B3E'
                      )
                    ) : item.form_data.is_presell_order == 3 && React.createElement(
                      React.Fragment,
                      null,
                      React.createElement(
                        'div',
                        { style: (0, _tools.convertLineStyleData)('display:flex;justify-content:space-between;width:100%;align-item:center;') },
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#999;') },
                          '\u5C3E\u6B3E\u652F\u4ED8\u6210\u529F\uFF0C\u8BF7\u5230\u7535\u5546\u8BA2\u5355\u67E5\u770B\u8BA2\u5355\u72B6\u6001'
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'show-goods-detail item-btn',
                            onClick: function onClick(e) {
                              _this3.showGoodsDetail(e);e.stopPropagation();
                            },
                            'data-orderid': item.form_data.order_id
                          },
                          '\u53BB\u67E5\u770B'
                        )
                      )
                    )
                  )
                );
              })
            ) : React.createElement(
              React.Fragment,
              null,
              React.createElement(
                'div',
                { className: 'no-collage' },
                React.createElement(
                  'div',
                  { className: 'tip-wrap' },
                  '\u6682\u65E0\u76F8\u5173\u8BA2\u5355'
                )
              )
            )
          ),
          is_more == 0 && React.createElement(
            'div',
            { style: (0, _tools.convertLineStyleData)('padding: 15px 0;text-align: center;font-size: 12px;color: #949494;') },
            '\u6CA1\u6709\u66F4\u591A\u4E86\u54E6\uFF5E'
          )
        )
      );
    }
  }]);
  return PresellOrderList;
}(_OfficialPage3.default);

exports.default = PresellOrderList;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PresellDetail = function (_OfficialPage) {
  (0, _inherits3.default)(PresellDetail, _OfficialPage);

  function PresellDetail(props) {
    (0, _classCallCheck3.default)(this, PresellDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PresellDetail.__proto__ || Object.getPrototypeOf(PresellDetail)).call(this, props));

    _this2.state = {
      defaultPhoto: '',
      storeStyle: '',
      imageOrVideo: 'image',
      displayComment: true,
      addToShoppingCartHidden: true,
      isStart: true,
      isPageScroll: true,
      formid: [],
      selectModelInfo: {
        models: [],
        stock: '',
        price: '',
        virtualPrice: '',
        buyCount: 1,
        models_text: '',
        discountInfo: {}
      },
      carouselCurrentIndex: 1
    };

    _this2.loadDetails = function () {
      var that = _this2,
          goodsModel = [],
          selectModels = [],
          activityArr = [],
          modelStrs = {},
          description = '',
          modifySelectModels = '',
          price = 0,
          allStock = 0,
          selectStock,
          selectPrice,
          selectModelId,
          matchResult,
          selectVirtualPrice,
          selectText = '',
          presell_status,
          start_time,
          end_time,
          selectDiscountInfo,
          i,
          j,
          disIndex,
          selectImgurl = '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppPreSell/GetPreSellGoodsDetail',
        data: {
          activity_id: that.data.activity_id,
          goods_id: that.data.goods_id,
          sub_app_id: that.data.franchiseeId || ''
        },
        success: function success(res) {
          if (!res.data.length) {
            _app.appMethod.showModal({
              content: '很抱歉，您查看的宝贝不存在，可能已经下架或者移除',
              confirm: function confirm() {
                _app.appMethod.turnBack();
              }
            });
            return;
          }
          var _presell_activity = res._presell_activity,
              goods = res.data[0].form_data,
              _presell_discount_info = goods._presell_discount_info,
              _presell_goods = goods._presell_goods;
          goods.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          description = goods.description;
          for (var key in goods.model) {
            if (key) {
              var model = goods.model[key];
              goodsModel.push(model);
              if (model && model.subModelName) {
                modelStrs[model.id] = model.subModelName.join('、');
                selectModels.push(model.subModelId[0]);
                modifySelectModels = selectModels.toString();
                selectText += '“' + model.subModelName[0] + '” ';
              }
            }
          }
          if (goods.model_items.length) {
            var items = goods.model_items;
            for (i = 0, j = items.length; i < j; i++) {
              price = items[i].price;
              goods.highPrice = goods.highPrice > price ? goods.highPrice : price;
              goods.lowPrice = goods.lowPrice < price ? goods.lowPrice : price;
              allStock += Number(items[i].stock);
              if (i == 0) {
                selectPrice = price;
                selectStock = items[0].stock;
                selectModelId = items[0].id;
                selectImgurl = items[i].img_url;
                selectVirtualPrice = items[i].virtual_price != '0.00' && items[i].virtual_price ? items[i].virtual_price : '';
                for (disIndex = 0; disIndex < _presell_discount_info.length; disIndex++) {
                  if (_presell_discount_info[disIndex].model_id == selectModelId) {
                    selectDiscountInfo = _presell_discount_info[disIndex];
                  }
                }
              }
            }
          } else {
            selectPrice = goods.price;
            selectStock = goods.stock;
            selectImgurl = goods.cover;
            selectVirtualPrice = goods.virtual_price != '0.00' && goods.virtual_price ? goods.virtual_price : '';
            selectDiscountInfo = _presell_discount_info[0];
          }
          goods.price_inter = goods._presell_goods.presell_min_price == goods._presell_goods.presell_max_price ? goods._presell_goods.presell_min_price : goods._presell_goods.presell_min_price + '~' + goods._presell_goods.presell_max_price;
          goods.final_price_inter = _presell_goods.presell_min_final_payment == _presell_goods.presell_max_final_payment ? _presell_goods.presell_min_final_payment : _presell_goods.presell_min_final_payment + '~' + _presell_goods.presell_max_final_payment;
          goods.model = goodsModel;
          start_time = _presell_activity.bargain_start_time * 1;
          end_time = _presell_activity.bargain_end_time * 1;
          goods.server_time = goods.server_time || Date.parse(new Date()) / 1000;
          goods.start_time = _util2.default.formatTime(new Date(start_time * 1000));
          goods.end_time = _util2.default.formatTime(new Date(end_time * 1000));
          goods.presell_status = end_time > goods.server_time ? start_time * 1 > goods.server_time ? '0' : '1' : '2';
          goods.final_payment_start_time = _util2.default.formatTimeYMD(new Date(_presell_activity.final_payment_start_time * 1000), 'M月DD日 hh:mm');
          goods.final_payment_end_time = _util2.default.formatTimeYMD(new Date(_presell_activity.final_payment_end_time * 1000), 'M月DD日 hh:mm');
          if (goods.presell_status == 0) {
            that.downcount = that.beforeDownCount(goods, res.data, that, 'goods');
          } else if (goods.presell_status == 1) {
            that.downcount = that.duringDownCount(goods, that, 'goods');
          }
          description = description ? description.replace(/\u00A0|\u2028|\u2029|\uFEFF/g, '') : description;
          goods.description = description;
          goods.virtual_price = goods.virtual_price == '0.00' && goods.virtual_price ? '' : goods.virtual_price;
          that.setData({
            'selectModelInfo.models': selectModels || '',
            'selectModelInfo.stock': selectStock || '',
            'selectModelInfo.price': selectPrice || '',
            'selectModelInfo.modelId': selectModelId || '',
            'selectModelInfo.discountInfo': selectDiscountInfo || '',
            'selectModelInfo.models_text': selectText || '',
            'selectModelInfo.imgurl': selectImgurl || '',
            'selectModelInfo.virtualPrice': selectVirtualPrice || '',
            goods: goods
          });
          that.getAssessList(0, 1);
        }
      });
    };

    _this2.getAssessList = function (commnetType, page, append) {
      var that = _this2;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goods_id,
          idx_arr: {
            idx: 'level',
            idx_value: commnetType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this2.data.franchiseeId || ''
        },
        success: function success(res) {
          var commentData = res.data;
          if (append) {
            commentData = that.data.commentArr.concat(commentData);
          }
          that.setData({
            commentArr: commentData,
            commentNums: res.num,
            commentPage: that.data.commentPage + 1,
            commentExample: res.data[0] || '',
            commentTotalPage: res.total_page,
            displayComment: +res.num[0] > 0 ? false : true,
            'rect[2].isShow': +res.num[0] > 0
          });
        }
      });
    };

    _this2.beforeDownCount = function (formData, res, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.start_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.presell_status'] = 1;
          newData[path + '.server_time'] = formData.start_time;
          page.setData(newData);
          page.loadDetails();
          formData.server_time = formData.start_time;
          if (res.end_date != '-1') {
            _this.downcount = _this.duringDownCount(formData, page, path);
          }
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.duringDownCount = function (formData, page, path) {
      var _this = _this2,
          downcount = void 0;
      downcount = _app.appMethod.seckillDownCount({
        startTime: formData.server_time,
        endTime: formData.end_time,
        showDays: true,
        callback: function callback() {
          var newData = {};
          newData[path + '.presell_status'] = 2;
          page.setData(newData);
        }
      }, page, path + '.downCount');
      return downcount;
    };

    _this2.paymentDeposit = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
      _this2.setData({
        addToShoppingCartHidden: false,
        ifAddToShoppingCart: false,
        isPageScroll: false,
        imageOrVideo: 'image'
      });
    };

    _this2.buyDirectlyNextStep = function (e) {
      var that = _this2;
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin({
          success: function success() {
            that.buyDirectlyNextStep(e);
          }
        });
        return;
      }
      var franchiseeId = that.data.franchiseeId,
          param = {
        goods_id: that.data.goods_id || '',
        activity_id: that.data.activity_id || '',
        model_id: that.data.selectModelInfo.modelId || '',
        nums: that.data.selectModelInfo.buyCount || 1,
        sub_shop_app_id: franchiseeId || '',
        final_payment_start_time: that.data.goods.final_payment_start_time || '',
        address_id: '',
        type: '1',
        models_text: that.data.selectModelInfo.models_text,
        models_stock: that.data.selectModelInfo.discountInfo.presell_stock_left || that.data.goods._presell_discount_info[0].presell_stock_left,
        bargain_order_id: '',
        presell_status: 1,
        limit_buy: that.data.selectModelInfo.discountInfo.buy_limit_num || ''
      },
          buyer_num = that.data.goods._presell_goods.buyer_num,
          pagePath = '/presell/pages/previewPresellOrder/previewPresellOrder?param=' + encodeURIComponent(JSON.stringify(param));
      franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
      if (param.limit_buy && param.nums > param.limit_buy - buyer_num) {
        _app.appMethod.showModal({
          content: '您已买' + buyer_num + '件，每人限购' + param.limit_buy + '件'
        });
        return;
      }
      if (param.nums > param.models_stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        return;
      }
      that.hiddeAddToShoppingCart();
      that.saveUserFormId(pagePath, 0);
    };

    _this2.selectSubModel = function (e) {
      var dataset = e.currentTarget.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModelsInfo = _this2.data.selectModelInfo,
          selectModels = _this2.data.selectModelInfo.models,
          model = _this2.data.goods.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['selectModelInfo.models'] = selectModels;
      data['selectModelInfo.models_text'] = text;
      data['selectModelInfo.buyCount'] = 1;
      _this2.setData(data);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var selectModelIds = _this2.data.selectModelInfo.models.join(','),
          modelItems = _this2.data.goods.model_items,
          discountInfo = _this2.data.goods._presell_discount_info,
          discountInfoArr = [],
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model) {
          if (modelItems[i].model == selectModelIds) {
            data['selectModelInfo.stock'] = modelItems[i].stock;
            data['selectModelInfo.virtualPrice'] = modelItems[i].virtual_price != '0.00' && modelItems[i].virtual_price ? modelItems[i].virtual_price || '' : '';
            data['selectModelInfo.price'] = modelItems[i].price;
            data['selectModelInfo.modelId'] = modelItems[i].id || '';
            data['selectModelInfo.imgurl'] = modelItems[i].img_url || '';
            for (var disIndex = 0; disIndex < discountInfo.length; disIndex++) {
              if (discountInfo[disIndex].model_id == modelItems[i].id) {
                data['selectModelInfo.discountInfo'] = discountInfo[disIndex];
              }
            }
            break;
          }
        }
      }
      _this2.setData(data);
    };

    _this2.clickMinusButton = function (e) {
      var count = _this2.data.selectModelInfo.buyCount;
      if (count <= 1) {
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count - 1
      });
    };

    _this2.clickPlusButton = function (e) {
      var selectModelInfo = _this2.data.selectModelInfo,
          limit_buy = +_this2.data.selectModelInfo.discountInfo.buy_limit_num,
          count = selectModelInfo.buyCount,
          buyer_num = +_this2.data.goods._presell_goods.buyer_num,
          stock = +selectModelInfo.discountInfo.presell_stock_left;
      if (limit_buy && count >= limit_buy) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        _this2.setData({
          'selectModelInfo.buyCount': limit_buy
        });
        return;
      }
      if (limit_buy && count >= limit_buy - buyer_num) {
        _app.appMethod.showModal({
          content: '您已买' + buyer_num + '件，每人限购' + limit_buy + '件'
        });
        _this2.setData({
          'selectModelInfo.buyCount': limit_buy - buyer_num
        });
        return;
      }
      if (count >= stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        _this2.setData({
          'selectModelInfo.buyCount': stock
        });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count + 1
      });
    };

    _this2.inputBuyCount = function (e) {
      var count = +e.target.value,
          selectModelInfo = _this2.data.selectModelInfo,
          stock = +selectModelInfo.discountInfo.presell_stock_left,
          limit_buy = +_this2.data.selectModelInfo.discountInfo.buy_limit_num,
          buyer_num = +_this2.data.goods._presell_goods.buyer_num;
      if (count > limit_buy && limit_buy != 0) {
        _app.appMethod.showModal({
          content: '已超过该商品的限购件数（每人限购' + limit_buy + '件）'
        });
        _this2.setData({
          'selectModelInfo.buyCount': +limit_buy
        });
        return;
      }
      if (limit_buy && count >= limit_buy - buyer_num) {
        _app.appMethod.showModal({
          content: '您已买' + buyer_num + '件，每人限购' + limit_buy + '件'
        });
        _this2.setData({
          'selectModelInfo.buyCount': limit_buy - buyer_num
        });
        return;
      }
      if (count >= stock) {
        _app.appMethod.showModal({
          content: '购买数量不能大于库存'
        });
        _this2.setData({
          'selectModelInfo.buyCount': stock
        });
        return;
      }
      _this2.setData({
        'selectModelInfo.buyCount': count
      });
    };

    _this2.blurBuyCount = function (e) {
      var value = +e.target.value;
      if (isNaN(value) || value <= 0) {
        _app.appMethod.showToast({
          title: '最少购买一件哦！',
          icon: 'none'
        });
        _this2.setData({
          'selectModelInfo.buyCount': 1
        });
        return;
      }
    };

    _this2.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    _this2.carouselIndex = function (event) {
      _this2.setData({
        carouselCurrentIndex: event.target.current + 1
      });
    };

    _this2.goToHomepage = function () {
      var that = _this2;
      var franchiseeId = that.data.franchiseeId;
      var chainId = _app.appMethod.getChainId();
      if (franchiseeId && franchiseeId != chainId) {
        var pages = _app.appMethod.getCurrentPages();
        var p = pages[pages.length - 2];
        if (!p) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/GetAppShopByAppId',
            data: {
              parent_app_id: _app.appMethod.getAppId(),
              sub_app_id: franchiseeId
            },
            success: function success(res) {
              var data = res.data;
              if (data) {
                var mode = data.mode_id;
                var param = {};
                param.detail = franchiseeId;
                if (data.audit == 2) {
                  param.shop_id = data.id;
                }
                _app.appMethod.goToFranchisee(mode, param, true);
              }
            }
          });
        } else if (p.route == 'franchisee/pages/goodsMore/goodsMore') {
          _app.appMethod.turnBack({
            delta: 2
          });
        } else {
          _app.appMethod.turnBack();
        }
      } else {
        var router = _app.appMethod.getHomepageRouter();
        _app.appMethod.reLaunch({
          url: '/pages/' + router + '/' + router
        });
      }
    };

    _this2.goToCommentPage = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/goodsComment/goodsComment?detail=' + _this2.data.goods_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _this2.saveUserFormId(pagePath, 0);
    };

    _this2.showQRCodeComponent = function () {
      var that = _this2;
      var goodsInfo = _this2.data.goods;
      // let animation = app.createAnimation({
      //   timingFunction: 'ease',
      //   duration: 400
      // })
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppPreSell/GetShareQRCode',
        data: {
          goods_id: that.data.goods_id,
          sub_app_id: that.data.franchiseeId || ''
        },
        success: function success(res) {
          // animation.bottom('0').step()
          // that.setData({
          //   'pageQRCodeData.shareDialogShow': 0,
          //   'pageQRCodeData.shareMenuShow': true,
          //   'pageQRCodeData.goodsInfo': res.data,
          //   'pageQRCodeData.animation': animation.export()
          // })
          _app.appInstance.pageQrcodeRef.current.show({
            pageQRCodeData: {
              'shareDialogShow': 0,
              'shareMenuShow': true,
              'goodsInfo': res.data
            }
          });
        }
      });
    };

    _this2.hiddeAddToShoppingCart = function () {
      _this2.setData({
        addToShoppingCartHidden: true,
        isPageScroll: true
      });
    };

    _this2.addFavoriteGoods = function (event) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addFavoriteGoods',
        data: {
          form_id: event.target.formId,
          goods_id: _this.data.goods_id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goods.is_favorite': 1
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '收藏成功!',
            image: '/images/favorites.png'
          });
        }
      });
    };

    _this2.deleteFavoriteGoods = function (event) {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteFavoriteGoods',
        method: 'post',
        data: {
          goods_id_arr: [_this.data.goods_id],
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.setData({
            'goods.is_favorite': 0
          });
        },
        complete: function complete() {
          _app.appMethod.showToast({
            title: '取消收藏!',
            image: '/images/cancel-favorites.png'
          });
        }
      });
    };

    _this2.formSubmit_collect = function (e) {
      var formid = _this2.data.formid;
      formid.push(e.target.formId);
    };

    _this2.saveUserFormId = function (path, isRedirect) {
      _app.appMethod.showLoading({
        title: '加载中'
      });
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
        method: 'post',
        data: {
          sub_shop_app_id: _this.data.franchiseeId || '',
          form_id: _this.data.formid || []
        },
        complete: function complete() {
          _app.appMethod.hideLoading();
          _app.appMethod.turnToPage(path, isRedirect);
          _this.setData({
            formid: []
          });
        }
      });
    };

    _this2.changeImageOrVideo = function (event) {
      _this2.setData({
        videoPoster: false,
        imageOrVideo: event.currentTarget.dataset.type
      });
    };

    _this2.startPlayVideo = function () {
      var video = _app.appMethod.createVideoContext('carousel-video');
      _this2.setData({
        videoPoster: true
      });
      video.play();
    };

    _this2.onShareAppMessage = function () {
      _this2.setData({
        pageQRCodeData: {
          shareDialogShow: '100%',
          shareMenuShow: false
        }
      });
      var that = _this2,
          goodsid = _this2.data.goods_id,
          franchiseeId = _this2.data.franchiseeId,
          title = _this2.data.goods.share_title || _this2.data.goods.title,
          shareImage = _this2.data.goods.share_img || _this2.data.goods.cover,
          path = '/presell/pages/presellDetail/presellDetail?detail=' + goodsid + (franchiseeId ? '&franchisee=' + franchiseeId : '') + (_app.appMethod.globalData.pageShareKey ? '&psid=' + _app.appMethod.globalData.pageShareKey : '');
      return _app.appMethod.shareAppMessage({
        path: path,
        title: title,
        imageUrl: shareImage
      });
    };

    document.title = '商品详情';
    return _this2;
  }

  (0, _createClass3.default)(PresellDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        goods_id: options.detail || '',
        franchiseeId: options.franchisee || ''
      });
      this.loadDetails();
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement,
          _this3 = this,
          _React$createElement2;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          pageQRCodeData = _state.pageQRCodeData,
          isPageScroll = _state.isPageScroll,
          goods = _state.goods,
          goodsInfo = _state.goodsInfo,
          imageOrVideo = _state.imageOrVideo,
          videoPoster = _state.videoPoster,
          selectModelInfo = _state.selectModelInfo,
          displayComment = _state.displayComment,
          commentNums = _state.commentNums,
          commentExample = _state.commentExample,
          defaultPhoto = _state.defaultPhoto,
          franchiseeId = _state.franchiseeId,
          isSeckill = _state.isSeckill,
          addToShoppingCartHidden = _state.addToShoppingCartHidden,
          storeStyle = _state.storeStyle,
          priceDiscountStr = _state.priceDiscountStr,
          isShowVirtualPrice = _state.isShowVirtualPrice,
          ifAddToShoppingCart = _state.ifAddToShoppingCart;


      return React.createElement(
        'div',
        { className: 'official-page presell-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            {
              id: 'presell-goodsDetail',
              style: (0, _tools.convertLineStyleData)(isPageScroll ? '' : 'overflow:hidden;height:calc(100vh - 84rpx);')
            },
            React.createElement(
              'div',
              { className: 'goods-header goods-section' },
              React.createElement(
                'div',
                { className: 'goods-cover' },
                imageOrVideo == 'image' && React.createElement(
                  'div',
                  { className: 'image-carousel-container' },
                  !(goods && goods.img_urls) ? React.createElement(
                    'div',
                    { className: 'goods-cover-container isRelative' },
                    React.createElement('img', (_React$createElement = {
                      'data-src': goods && goods.cover,
                      onClick: this.clickPlusImages,
                      src: goods && goods.cover
                    }, (0, _defineProperty3.default)(_React$createElement, 'data-src', goods && goods.cover), (0, _defineProperty3.default)(_React$createElement, 'mode', 'aspectFill'), _React$createElement))
                  ) : React.createElement(
                    'div',
                    { className: 'slick-carousel-container' },
                    React.createElement(
                      _carousel2.default,
                      {
                        dots: false,
                        infinite: true,
                        autoplay: true,
                        autoplayInterval: 5000 },
                      goods.img_urls.map(function (item, index) {
                        return React.createElement(
                          'div',
                          { key: index },
                          React.createElement('img', {
                            'data-src': item,
                            'data-srcarr': goods && JSON.stringify(goods.img_urls),
                            onClick: _this3.clickPlusImages,
                            src: item,
                            mode: 'aspectFit',
                            className: 'slide-image'
                          })
                        );
                      })
                    )
                  ),
                  goods && goods.video_url && React.createElement(
                    'div',
                    { className: 'image-video-menu' },
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'image' ? 'active' : '',
                        'data-type': 'image',
                        onClick: this.changeImageOrVideo
                      },
                      '\u56FE\u7247'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: imageOrVideo == 'video' ? 'active' : '',
                        'data-type': 'video',
                        onClick: this.changeImageOrVideo
                      },
                      '\u89C6\u9891'
                    )
                  )
                ),
                goods && goods.video_url && imageOrVideo == 'video' && React.createElement(
                  'div',
                  { className: 'video-carousel-container' },
                  videoPoster && React.createElement(
                    'video',
                    { src: goods.video_url, id: 'carousel-video' },
                    goods.video_url && React.createElement(
                      CoverView,
                      { className: 'image-video-menu' },
                      React.createElement(
                        CoverView,
                        {
                          className: imageOrVideo == 'image' ? 'active' : '',
                          'data-type': 'image',
                          onClick: this.changeImageOrVideo
                        },
                        '\u56FE\u7247'
                      ),
                      React.createElement(
                        CoverView,
                        {
                          className: imageOrVideo == 'video' ? 'active' : '',
                          'data-type': 'video',
                          onClick: this.changeImageOrVideo
                        },
                        '\u89C6\u9891'
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'videoele-cover-view', hidden: videoPoster },
                    React.createElement(
                      'div',
                      { className: 'videoele-poster-wrap' },
                      React.createElement('img', {
                        className: 'videoele-poster',
                        src: goods.video_img,
                        mode: 'scaleToFill'
                      })
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'videoele-play-icon',
                        onClick: this.startPlayVideo
                      },
                      React.createElement('img', {
                        className: 'videoele-play-image',
                        src: 'http://cdn.jisuapp.cn/static/webapp/images/play.png',
                        mode: 'scaleToFill'
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'image-video-menu' },
                      React.createElement(
                        'span',
                        {
                          className: imageOrVideo == 'image' ? 'active' : '',
                          'data-type': 'image',
                          onClick: this.changeImageOrVideo
                        },
                        '\u56FE\u7247'
                      ),
                      React.createElement(
                        'span',
                        {
                          className: imageOrVideo == 'video' ? 'active' : '',
                          'data-type': 'video',
                          onClick: this.changeImageOrVideo
                        },
                        '\u89C6\u9891'
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'goods-tabbar',
                  style: (0, _tools.convertLineStyleData)('background: ' + (goods && goods.presell_status != 0 ? 'rgba(255, 179, 188, .29)' : 'rgba(190, 146, 255, .29)'))
                },
                React.createElement('img', {
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/presell/' + (goods && goods.presell_status != 0 ? 'price-bar2' : 'price-bar1') + '.png'
                }),
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('position:absolute;top:0;left:0;') },
                  React.createElement(
                    'div',
                    { className: 'presell-price' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'span',
                        null,
                        '\u5B9A\u91D1'
                      ),
                      React.createElement(
                        'span',
                        null,
                        '\xA5'
                      ),
                      React.createElement(
                        'span',
                        null,
                        selectModelInfo.discountInfo.bargain
                      )
                    ),
                    goods && goods.presell_status != 0 && React.createElement(
                      'span',
                      { className: 'sales-num' },
                      '已售' + (goods && goods._presell_goods && goods._presell_goods.bargain_payment_count) + '件'
                    )
                  ),
                  goods && goods.presell_status == 0 ? React.createElement(
                    'div',
                    { className: 'count-down preview-presell' },
                    React.createElement(
                      'div',
                      { className: 'remain-tip' },
                      React.createElement(
                        'span',
                        null,
                        '\u8DDD\u9884\u552E\u5F00\u59CB'
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'remain-time' },
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.days
                      ),
                      React.createElement(
                        'span',
                        null,
                        '\u5929'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.hours
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.minutes
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.seconds
                      )
                    )
                  ) : goods && goods.presell_status == 1 && React.createElement(
                    'div',
                    { className: 'count-down start-presell' },
                    React.createElement(
                      'div',
                      { className: 'remain-tip' },
                      React.createElement(
                        'span',
                        null,
                        '\u8DDD\u9884\u552E\u7ED3\u675F'
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'remain-time' },
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.days
                      ),
                      React.createElement(
                        'span',
                        null,
                        '\u5929'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.hours
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.minutes
                      ),
                      React.createElement(
                        'span',
                        null,
                        ':'
                      ),
                      React.createElement(
                        'span',
                        null,
                        goods.downCount.seconds
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'goods-infor' },
                React.createElement(
                  'div',
                  { className: 'goods-title' },
                  React.createElement(
                    'div',
                    { className: 'text' },
                    goods && goods.title
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'share-jbtn isRelative',
                      onClick: this.showQRCodeComponent
                    },
                    React.createElement('span', { className: 'ico-moon icon-news-sharefriends' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'goods-price' },
                  React.createElement(
                    'div',
                    {
                      className: 'first-price ' + (goods && goods.presell_status == 1 ? 'start-presell' : 'preview-presell')
                    },
                    React.createElement(
                      'span',
                      null,
                      '¥ ' + (goods ? goods.price_inter : '')
                    ),
                    React.createElement(
                      'span',
                      { className: 'price-tip' },
                      '\u9884\u552E\u4EF7'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'final-price' },
                    React.createElement(
                      'span',
                      null,
                      '\u5C3E\u6B3E :'
                    ),
                    React.createElement(
                      'span',
                      null,
                      '¥ ' + (goods ? goods.final_price_inter : '')
                    ),
                    React.createElement(
                      'span',
                      null,
                      '(' + (goods ? goods.final_payment_start_time : '') + ' ~ ' + (goods ? goods.final_payment_end_time : '') + ')'
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-express goods-section' },
              '运费 : ' + (goods ? goods.express_fee : '')
            ),
            React.createElement(
              'div',
              { className: 'goods-flow goods-section' },
              React.createElement(
                'div',
                { className: 'flow-tip isRelative' },
                React.createElement(
                  'span',
                  null,
                  '\u6D41\u7A0B'
                ),
                React.createElement('span', { className: 'ico-moon icon-rightarrow' })
              ),
              React.createElement(
                'div',
                { className: 'flow-play' },
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', {
                    className: 'ico-moon icon-presell-handsel',
                    style: (0, _tools.convertLineStyleData)('padding-left:4rpx;')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u4ED8\u5B9A\u91D1'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', {
                    className: 'ico-moon icon-presell-surplus',
                    style: (0, _tools.convertLineStyleData)('padding-left:4rpx;')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u4ED8\u5C3E\u6B3E'
                  )
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'ico-moon icon-fillet-rectangle' })
                ),
                React.createElement(
                  'div',
                  null,
                  React.createElement('span', { className: 'ico-moon icon-presell-consign' }),
                  React.createElement(
                    'span',
                    null,
                    '\u53D1\u8D27'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'shop-message goods-section' },
              React.createElement(
                'div',
                { className: 'goods-shop-info' },
                React.createElement(
                  'div',
                  { className: 'image-wrap' },
                  React.createElement('img', { src: goods && goods.app_cover })
                ),
                React.createElement(
                  'div',
                  { className: 'shop-info' },
                  React.createElement(
                    'div',
                    { className: 'app-name' },
                    goods && goods.app_name || ''
                  ),
                  React.createElement(
                    'div',
                    { className: 'sales-num' },
                    '\u5728\u552E',
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#909090;margin:0 10rpx;') },
                      '|'
                    ),
                    React.createElement(
                      'span',
                      null,
                      goods && goods._presell_goods && goods._presell_goods.onsale_goods_count || goods && goods.sales
                    ),
                    '\u4EF6\u5546\u54C1'
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'goods-shop-into isRelative',
                  onClick: this.goToHomepage
                },
                '\u8FDB\u5165\u5E97\u94FA'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'comment-message  goods-section',
                hidden: displayComment,
                id: 'comment'
              },
              React.createElement(
                'div',
                { className: 'comment-title' },
                React.createElement(
                  'div',
                  null,
                  '晒单评价 (' + (commentNums && commentNums[0] || 0) + ')'
                ),
                React.createElement(
                  'div',
                  { onClick: this.goToCommentPage, className: 'isRelative' },
                  React.createElement(
                    'span',
                    null,
                    '\u67E5\u770B\u5168\u90E8'
                  ),
                  React.createElement('span', { className: 'ico-moon icon-rightarrow' })
                )
              ),
              React.createElement(
                'div',
                { className: 'block-item' },
                !!commentExample && React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'comment-item' },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        className: 'comment-user-photo',
                        src: commentExample.buyer_headimgurl || defaultPhoto
                      }),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { className: 'commentPersonName' },
                          commentExample.buyer_nickname
                        ),
                        React.createElement(
                          'div',
                          { className: 'comment-date' },
                          commentExample.add_time
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'comment-content' },
                      commentExample.assess_info.content
                    ),
                    !!commentExample.assess_info.has_img && React.createElement(
                      'div',
                      { className: 'comPage-comment-pics' },
                      commentExample.assess_info.img_arr.map(function (imgSrc, index) {
                        return React.createElement('img', {
                          key: index,
                          src: imgSrc,
                          'data-src': imgSrc,
                          'data-srcarr': JSON.stringify(commentExample.assess_info.img_arr),
                          onClick: _this3.clickPlusImages
                        });
                      })
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'goods-detail-section goods-section', id: 'detail' },
              React.createElement(
                'div',
                { className: 'goodsDetail-title isRelative' },
                '\u5546\u54C1\u8BE6\u60C5'
              ),
              React.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: goods && goods.description && goods.description.replace(/href=".*?"/g, '') } })
            ),
            React.createElement(
              'div',
              { className: 'goods-bottom' },
              React.createElement(
                'div',
                { className: 'anthor-btn' },
                !franchiseeId && React.createElement(
                  'div',
                  { className: 'form-contain goods-opt-item flex-sub-box-3' },
                  React.createElement(
                    'form',
                    null,
                    React.createElement(
                      'button',
                      {
                        type: 'button',
                        onClick: goods && goods.is_favorite == 1 ? this.deleteFavoriteGoods : this.addFavoriteGoods },
                      React.createElement(
                        'div',
                        { className: 'bottom-border-right' },
                        React.createElement('span', {
                          className: 'ico-moon icon-' + (goods && goods.is_favorite == 1 ? 'collect-solid' : 'goods-detail-favorites') + ' icon-collect-cover'
                        }),
                        React.createElement(
                          'div',
                          { className: 'ico-text ico-text-cover' },
                          '\u6536\u85CF'
                        )
                      )
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'goods-opt-item flex-sub-box-' + (isSeckill || franchiseeId ? '2' : '3') + ' isRelative'
                  },
                  React.createElement('div', { className: 'ico-moon icon-service2' }),
                  React.createElement(
                    'div',
                    { className: 'ico-text' },
                    '\u5BA2\u670D'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'group-buy-btn' },
                goods && goods.presell_status == 1 ? React.createElement(
                  'div',
                  { className: 'payment-deposit isRelative' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      null,
                      '¥ ' + selectModelInfo.discountInfo.bargain
                    ),
                    React.createElement(
                      'span',
                      null,
                      '\u652F\u4ED8\u5B9A\u91D1'
                    ),
                    React.createElement(
                      'form',
                      { className: 'getFormId' },
                      React.createElement('button', {
                        type: 'button',
                        className: 'invisibleclass',
                        'data-id': goods && goods.id,
                        'data-orderid': goods && goods.order_id,
                        onClick: this.paymentDeposit
                      })
                    )
                  )
                ) : React.createElement(
                  'div',
                  { className: 'preview-presell isRelative' },
                  goods && goods.presell_status == 0 ? '未开售' : '支付定金'
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              id: 'payDialog',
              className: 'page-dialog-wrap',
              hidden: addToShoppingCartHidden
            },
            React.createElement(
              'div',
              { className: 'page-bottom-dialog' },
              React.createElement(
                'div',
                {
                  className: 'pay-close-dialog page-dialog-close',
                  onClick: this.hiddeAddToShoppingCart
                },
                React.createElement('span', { className: 'ico-moon icon-closes' })
              ),
              React.createElement(
                'div',
                { className: 'dialog-goods-header' },
                React.createElement(
                  'div',
                  { className: 'thumb' },
                  React.createElement(
                    'div',
                    { className: 'thumb-wrap' },
                    React.createElement('img', {
                      'data-src': selectModelInfo.imgurl || goods && goods.cover,
                      onClick: this.clickPlusImages,
                      className: 'pay-goods-cover',
                      src: selectModelInfo.imgurl || goods && goods.cover
                    })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'pay-goods-baseinfo' },
                  React.createElement(
                    'div',
                    { className: 'pay-goods-price' },
                    React.createElement(
                      'div',
                      { className: 'pay-current-price' },
                      selectModelInfo.price != '0.00' && React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme) },
                        '定金 ¥ ' + selectModelInfo.discountInfo.bargain
                      ),
                      selectModelInfo.price != '0.00' && React.createElement(
                        'span',
                        {
                          style: (0, _tools.convertLineStyleData)('color:' + storeStyle.theme + ';margin-left:22rpx;')
                        },
                        '预售价 ¥ ' + selectModelInfo.discountInfo.presell_price
                      ),
                      goods && goods.integral == '2' ? React.createElement(
                        React.Fragment,
                        null,
                        selectModelInfo.price != '0.00' && goods.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            style: (0, _tools.convertLineStyleData)(goods.goods_type != 0 ? '' : 'color:' + storeStyle.theme)
                          },
                          '+'
                        ),
                        goods.max_can_use_integral != 0 && React.createElement(
                          'span',
                          {
                            style: (0, _tools.convertLineStyleData)(goods.goods_type != 0 ? '' : 'color:' + storeStyle.theme)
                          },
                          goods.max_can_use_integral + '积分'
                        )
                      ) : React.createElement(
                        React.Fragment,
                        null,
                        priceDiscountStr != '' && React.createElement(
                          'span',
                          { className: 'goods-price-discount' },
                          priceDiscountStr
                        )
                      ),
                      isShowVirtualPrice && selectModelInfo.virtualPrice != 0 && goods.goods_type != 1 && React.createElement(
                        'span',
                        { className: 'virtualPrice' },
                        '¥' + selectModelInfo.virtualPrice
                      )
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'pay-goods-stock' },
                    '库存 ' + selectModelInfo.discountInfo.presell_stock_left
                  ),
                  selectModelInfo.models_text && React.createElement(
                    'div',
                    { className: 'pay-checked-text clearfix' },
                    '已选：' + selectModelInfo.models_text
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'payDialog-content' },
                React.createElement(
                  'div',
                  {
                    className: 'pay-goods-models',
                    hidden: !(goods && goods.model_items && goods.model_items.length)
                  },
                  goods && goods.model && goods.model.map(function (model, modelIndex) {
                    return React.createElement(
                      'div',
                      { key: modelIndex },
                      React.createElement(
                        'span',
                        { className: 'model-title' },
                        model.name
                      ),
                      React.createElement(
                        'label',
                        { className: 'pills-list' },
                        model.subModelName.map(function (name, index) {
                          return React.createElement(
                            'label',
                            {
                              key: index,
                              'data-model-index': modelIndex,
                              'data-submodel-index': index,
                              className: 'subModel isRelative ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                              'data-submodel-id': model.subModelId[index],
                              onClick: _this3.selectSubModel,
                              style: (0, _tools.convertLineStyleData)(selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'background:' + storeStyle.theme : '')
                            },
                            name
                          );
                        })
                      )
                    );
                  })
                ),
                React.createElement(
                  'div',
                  {
                    className: 'payDialog-buy-num',
                    style: (0, _tools.convertLineStyleData)('padding-left:10px;padding-right:10px;')
                  },
                  React.createElement(
                    'div',
                    { className: 'clearfix' },
                    React.createElement(
                      'span',
                      null,
                      '\u8D2D\u4E70\u6570\u91CF \uFF1A'
                    ),
                    React.createElement(
                      'div',
                      { className: 'pull-right' },
                      React.createElement(
                        'div',
                        { className: 'quantity pull-left' },
                        React.createElement('label', {
                          className: 'minus ' + (selectModelInfo.buyCount <= 1 ? 'disabled' : '')
                        }),
                        React.createElement('input', (_React$createElement2 = {
                          className: 'pay-buy-count',
                          type: 'number'
                        }, (0, _defineProperty3.default)(_React$createElement2, 'className', 'txt'), (0, _defineProperty3.default)(_React$createElement2, 'value', selectModelInfo.buyCount), (0, _defineProperty3.default)(_React$createElement2, 'onChange', this.inputBuyCount), (0, _defineProperty3.default)(_React$createElement2, 'onBlur', this.blurBuyCount), _React$createElement2)),
                        React.createElement('label', {
                          className: 'plus ' + (selectModelInfo.buyCount >= selectModelInfo.stock || selectModelInfo.buyCount >= goods.seckill_buy_limit ? 'disabled' : '')
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-minus',
                          onClick: this.clickMinusButton
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-plus isRelative',
                          onClick: this.clickPlusButton
                        })
                      )
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'dialog-bottom' },
                React.createElement(
                  'div',
                  { hidden: ifAddToShoppingCart },
                  React.createElement(
                    'div',
                    {
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                      className: 'btn-orange pay-buy-next',
                      onClick: this.buyDirectlyNextStep
                    },
                    '\u786E\u5B9A'
                  )
                ),
                React.createElement(
                  'div',
                  { hidden: !ifAddToShoppingCart },
                  goods && goods.integral != '2' && React.createElement(
                    'div',
                    {
                      style: (0, _tools.convertLineStyleData)('background:' + storeStyle.theme),
                      className: 'pay-add-to-shoppingcart',
                      onClick: this.sureAddToShoppingCart
                    },
                    '\u52A0\u5165\u8D2D\u7269\u8F66'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PresellDetail;
}(_OfficialPage3.default);

exports.default = PresellDetail;

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _radio = __webpack_require__(79);

var _radio2 = _interopRequireDefault(_radio);

var _datePicker = __webpack_require__(101);

var _datePicker2 = _interopRequireDefault(_datePicker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

__webpack_require__(80);

__webpack_require__(102);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 可兑换券底部弹窗
var ExchangeCouponUseDialogTmpl = function ExchangeCouponUseDialogTmpl(options) {
  var data = options.data,
      self = options.self;
  var dialogHidden = data.dialogHidden,
      selectModelInfo = data.selectModelInfo,
      goodsInfo = data.goodsInfo,
      model = data.model,
      modelIndex = data.modelIndex,
      index = data.index,
      name = data.name;


  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      'div',
      {
        className: 'page-dialog-wrap page-addshoppingcart-dialog tostorePay-coupon-wrap',
        hidden: dialogHidden
      },
      React.createElement(
        'div',
        { className: 'page-bottom-dialog', style: (0, _tools.convertLineStyleData)('padding-bottom: 65px;') },
        React.createElement(
          'div',
          { className: 'page-bottom-content' },
          React.createElement(
            'div',
            {
              className: 'pay-close-dialog page-dialog-close',
              onClick: self.exchangeCouponHideDialog
            },
            '\xD7'
          ),
          React.createElement(
            'div',
            { className: 'dialog-block-item' },
            React.createElement(
              'div',
              { className: 'thumb' },
              React.createElement(
                'div',
                { className: 'thumb-wrap' },
                React.createElement('img', {
                  className: 'pay-goods-cover',
                  src: selectModelInfo.imgurl || goodsInfo.cover
                })
              )
            ),
            React.createElement(
              'div',
              { className: 'pay-goods-baseinfo' },
              React.createElement(
                'div',
                {
                  className: 'pay-goods-title ellipsis',
                  style: (0, _tools.convertLineStyleData)('text-align: left;')
                },
                React.createElement(
                  'span',
                  null,
                  goodsInfo.title
                ),
                React.createElement(
                  'span',
                  { className: 'gift-text' },
                  '\u8D60\u54C1'
                )
              ),
              selectModelInfo.models_text && React.createElement(
                'div',
                { className: 'pay-checked-text clearfix' },
                '已选：' + selectModelInfo.models_text
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'dialog-block-item',
              hidden: !(goodsInfo.model_items && goodsInfo.model_items.length)
            },
            React.createElement(
              'div',
              { className: 'pay-goods-models' },
              goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                return React.createElement(
                  'div',
                  { key: modelIndex },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('vertical-align:top;float: left;margin-top: 5px;width:120rpx;display:inline-block;text-align:right;font-size:24rpx;') },
                    model.name + '：'
                  ),
                  React.createElement(
                    'label',
                    {
                      className: 'pills-list',
                      style: (0, _tools.convertLineStyleData)('text-align:center;max-width:528rpx;')
                    },
                    model.subModelName.map(function (name, index) {
                      return React.createElement(
                        'label',
                        {
                          key: index,
                          'data-model-index': modelIndex,
                          'data-submodel-index': index,
                          className: 'subModel ' + (selectModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''),
                          'data-submodel-id': model.subModelId[index],
                          onClick: self.exchangeCouponSelectSubModel
                        },
                        name
                      );
                    })
                  )
                );
              })
            )
          ),
          React.createElement(
            'div',
            {
              className: 'toStore-bottom-nav',
              style: (0, _tools.convertLineStyleData)('background-color:#3f3f3f;')
            },
            React.createElement('div', { className: 'bottom-nav-detail' }),
            React.createElement(
              'div',
              {
                className: 'bottom-nav-ready',
                onClick: self.exchangeCouponConfirmGoods
              },
              '\u9009\u597D\u4E86'
            )
          )
        )
      )
    )
  );
};

var PreviewOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewOrderDetail, _OfficialPage);

  function PreviewOrderDetail(props) {
    (0, _classCallCheck3.default)(this, PreviewOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewOrderDetail.__proto__ || Object.getPrototypeOf(PreviewOrderDetail)).call(this, props));

    _this2.state = {
      goodsList: [],
      wayOfDine: 1, // 1: 点餐, 2: 预约
      discountDialogHidden: true,
      discountList: [],
      selectDiscountInfo: '',
      selectDiscountIndex: -1,
      discount_cut_price: '',
      appointmentTime: '',
      phone: '',
      orderRemark: '',
      optionalTimeStart: '',
      optionalTimeEnd: '',
      location_data_arr: '',
      locationNum: '',
      locationId: 0,
      changeValue: 0,
      selectLocationId: '',
      locationTitle: '',
      isUrlLocationId: '',
      balance: '',
      useBalance: true,
      deduction: '',
      exchangeCouponData: {
        dialogHidden: true,
        goodsInfo: {},
        selectModelInfo: {},
        hasSelectGoods: false,
        voucher_coupon_goods_info: {}
      },
      leagueBenefitList: [], // 联盟优惠列表
      selectedLeagueBenefitInfo: '', // 选中的联盟优惠
      selectedLeagueBenefitIndex: -1, // // 联盟优惠下标
      leagueBenefitPrice: '' // 联盟优惠优惠价格
    };
    _this2.changeNumTimeout = [];
    _this2.franchiseeId = '';
    _this2.cartIdArr = [];
    _this2.cartGoodsIdArr = [];
    _this2.cart_data_arr = [];
    _this2.cart_id_arr = [];
    _this2.isPaysuccessFlag = false;
    _this2.isFranchisee = false;

    _this2.dataInitial = function () {
      _this2.getCartList();
      _this2.location();
      _this2.GetTostoreWaitingRule();
    };

    _this2.getCartList = function () {
      var that = _this2,
          franchiseeId = _this2.franchiseeId;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: franchiseeId,
          parent_shop_app_id: franchiseeId ? _app.appMethod.globalData.appId : ''
        },
        success: function success(res) {
          var shoppingCartdata = [],
              tostoreData = [];
          if (that.cart_id_arr.length) {
            for (var i = 0; i <= res.data.length - 1; i++) {
              if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
                shoppingCartdata.push(res.data[i]);
              }
            }
          } else {
            shoppingCartdata = res.data;
          }
          for (var i = 0; i < shoppingCartdata.length; i++) {
            if (shoppingCartdata[i].goods_type == 3) {
              tostoreData.push(shoppingCartdata[i]);
            }
          }
          for (var i = 0; i <= tostoreData.length - 1; i++) {
            var goods = tostoreData[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? '(' + modelArr.join('|') + ')' : '';
            that.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
            that.cartIdArr.push(goods.id);
            that.cartGoodsIdArr.push(goods.goods_id);
          }
          that.setData({
            goodsList: tostoreData,
            phone: _app.appMethod.getUserInfo().phone
          });
          that.getCalculationPrice();
          that.getOptionalTime();
        }
      });
    };

    _this2.getCalculationPrice = function (changeBenefit) {
      var that = _this2,
          franchiseeId = _this2.franchiseeId,
          selectDiscountInfo = _this2.data.selectDiscountInfo,
          selectedLeagueBenefitInfo = _this2.data.selectedLeagueBenefitInfo,

      // 联盟优惠
      selectDiscountIndex = '',
          selectedLeagueBenefitIndex = '';
      if (changeBenefit == 'changeGoodNum') {
        selectDiscountInfo = '';
      }
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          sub_shop_app_id: franchiseeId || (_this2.isFranchisee ? _app.appMethod.getAppId() : ''),
          cart_id_arr: that.cartIdArr,
          is_self_delivery: 1,
          is_balance: _this2.data.useBalance ? 1 : 0,
          selected_benefit: selectDiscountInfo,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info,
          superimposed: _this2.isFranchisee ? 1 : 0,
          extra_selected_benefit: selectedLeagueBenefitInfo
        },
        success: function success(res) {
          var discounts = res.data.can_use_benefit.data;
          var newData = {};
          if (discounts && discounts.length) {
            discounts.unshift({
              title: '不使用优惠',
              name: '无',
              no_use_benefit: 1
            });
          }
          selectDiscountInfo = res.data.selected_benefit_info;
          if (selectDiscountInfo && selectDiscountInfo.discount_type) {
            for (var i = 0; i <= discounts.length - 1; i++) {
              if (selectDiscountInfo.discount_type === discounts[i].discount_type) {
                if (selectDiscountInfo.discount_type === 'coupon') {
                  if (selectDiscountInfo.coupon_id === discounts[i].coupon_id) {
                    selectDiscountIndex = i;
                    break;
                  }
                } else {
                  selectDiscountIndex = i;
                  break;
                }
              }
            }
            if (selectDiscountInfo.discount_type == 'coupon' && selectDiscountInfo.type == 3 && that.data.exchangeCouponData.hasSelectGoods == false) {
              that.exchangeCouponInit(parseInt(selectDiscountInfo.value));
            }
          }
          newData['selectDiscountIndex'] = selectDiscountIndex;
          newData['discountList'] = discounts;
          newData['selectDiscountInfo'] = selectDiscountInfo;
          newData['discount_cut_price'] = res.data.discount_cut_price;
          newData['totalPayment'] = (+res.data.price).toFixed(2);
          newData['balance'] = res.data.balance;
          newData['deduction'] = res.data.use_balance;
          if (that.isFranchisee) {
            // 多商家联盟优惠
            var leagueBenefitList = res.data.extra_can_use_benefit.data;
            if (leagueBenefitList && leagueBenefitList.length) {
              leagueBenefitList.unshift({
                title: '不使用优惠',
                name: '无',
                no_use_benefit: 1
              });
            }
            selectedLeagueBenefitInfo = res.data.extra_selected_benefit;
            if (selectedLeagueBenefitInfo && !selectedLeagueBenefitInfo.no_use_benefit) {
              leagueBenefitList.forEach(function (coupon, index) {
                if (selectedLeagueBenefitInfo.discount_type === coupon.discount_type) {
                  if (selectedLeagueBenefitInfo.discount_type === 'coupon') {
                    if (selectedLeagueBenefitInfo.coupon_id === coupon.coupon_id) {
                      selectedLeagueBenefitIndex = index;
                    }
                  } else {
                    selectedLeagueBenefitIndex = index;
                  }
                }
              });
            }
            newData['leagueBenefitList'] = leagueBenefitList;
            newData['selectedLeagueBenefitInfo'] = selectedLeagueBenefitInfo;
            newData['selectedLeagueBenefitIndex'] = selectedLeagueBenefitIndex;
            newData['leagueBenefitPrice'] = res.data.extra_discount_cut_price;
          }
          that.setData(newData);
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          setTimeout(function () {
            _app.appMethod.navigateBack();
          }, 2000);
        }
      });
    };

    _this2.getOptionalTime = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetTostoreNearestAppointmentTime',
        data: {
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          that.setData({
            optionalTimeStart: res.data.substr(11, 5)
          });
        }
      });
    };

    _this2.remarkInput = function (e) {
      var value = e.target.value;
      if (value.length > 30) {
        _this2.setData({
          remarkColor: 'red'
        });
      } else {
        _this2.setData({
          remarkColor: ''
        });
      }
      _this2.setData({
        orderRemark: value,
        remarkLength: value.length
      });
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goods = _this2.data.goodsList[index];
      if (+goods.num <= 0) return;
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.changeGoodsNum = function (index, type) {
      clearTimeout(_this2.changeNumTimeout[index]);
      var goods = _this2.data.goodsList[index],
          currentNum = +goods.num,
          targetNum = type == 'plus' ? currentNum + 1 : currentNum - 1,
          that = _this2,
          data = {},
          changeGoodNum = 'changeGoodNum',
          param;
      _this2.changeNumTimeout[index] = setTimeout(function () {
        if (targetNum == 0 && type == 'minus') {
          _app.appMethod.showModal({
            content: '确定从购物车删除该商品？',
            showCancel: true,
            confirm: function confirm() {
              that.deleteGoods(index);
            }
          });
          return;
        }
        that.cart_data_arr[index].num = targetNum;
        param = {
          _app_id: _app.appMethod.getAppId(),
          app_id: _app.appMethod.getAppId(),
          session_key: _app.appMethod.getSessionKey(),
          goods_id: goods.goods_id,
          model_id: goods.model_id || '',
          num: targetNum,
          sub_shop_app_id: that.franchiseeId
        };
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/addCart',
          data: param,
          success: function success(res) {
            that.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            that.setData(data);
            that.getCalculationPrice(changeGoodNum);
          },
          successStatusAbnormal: function successStatusAbnormal(res) {
            data = {};
            that.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            data['goodsList[' + index + '].num'] = currentNum;
            that.setData(data);
            _app.appMethod.showModal({
              content: res.data
            });
          },
          fail: function fail(res) {
            data = {};
            that.cart_data_arr[index].num = currentNum;
            data['goodsList[' + index + '].num'] = currentNum;
            that.setData(data);
          }
        });
      }, 500);
    };

    _this2.deleteGoods = function (index) {
      var goodsList = _this2.data.goodsList,
          that = _this2,
          listExcludeDelete,
          changeGoodNum = 'changeGoodNum';
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [_this2.cart_data_arr[index].cart_id],
          sub_shop_app_id: _this2.franchiseeId
        },
        success: function success(res) {
          ;(listExcludeDelete = goodsList.concat([])).splice(index, 1);
          if (listExcludeDelete.length == 0) {
            _app.appMethod.turnBack();
            return;
          }
          that.changeNumTimeout.splice(index, 1);
          that.cart_data_arr.splice(index, 1);
          that.setData({
            goodsList: listExcludeDelete,
            exchangeCouponData: {
              dialogHidden: true,
              hasSelectGoods: false,
              voucher_coupon_goods_info: {}
            }
          });
          that.getCalculationPrice(changeGoodNum);
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var list = _this2.data.goodsList,
          appointmentTime = _this2.data.appointmentTime,
          that = _this2,
          phone = _this2.data.phone,
          locationId = _this2.data.locationId;
      if (_this2.data.wayOfDine == 1 && _this2.data.changeValue == 1 && !locationId) {
        _app.appMethod.showModal({
          content: '请选择位置'
        });
        return;
      }
      if (_this2.data.shopInfo.is_phone == 1 && !_util2.default.isPhoneNumber(phone) || phone && _this2.data.shopInfo.is_phone == 0 && !_util2.default.isPhoneNumber(phone)) {
        _app.appMethod.showModal({
          content: '请填写正确的手机号码'
        });
        return;
      }
      if (_this2.data.orderRemark.length > 30) {
        _app.appMethod.showModal({
          content: '备注字数超过限制'
        });
        return;
      }
      if (_this2.data.wayOfDine == 2) {
        if (!appointmentTime) {
          _app.appMethod.showModal({
            content: '请选择预约时间'
          });
          return;
        }
        appointmentTime = _util2.default.formatTime(new Date()).slice(0, 11) + appointmentTime;
      }
      if (that.isPaysuccessFlag) {
        return;
      }
      that.isPaysuccessFlag = true;
      var utc = new Date().getTimezoneOffset() / 60;
      var time_difference = 8 + utc;
      var timezone_name = utc > 0 ? '西' + utc + '区' : '东' + utc * -1 + '区';
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: {
          cart_arr: _this2.cart_data_arr,
          formId: e.target.formId,
          sub_shop_app_id: _this2.franchiseeId,
          selected_benefit: _this2.data.selectDiscountInfo,
          tostore_order_type: _this2.data.wayOfDine,
          tostore_appointment_time: _this2.data.wayOfDine == 2 ? appointmentTime : '',
          tostore_buyer_phone: _this2.data.phone,
          tostore_remark: _this2.data.orderRemark,
          location_id: _this2.data.wayOfDine == 2 ? '' : locationId,
          is_balance: _this2.data.useBalance ? 1 : 0,
          voucher_coupon_goods_info: _this2.data.exchangeCouponData.voucher_coupon_goods_info,
          time_difference: time_difference,
          timezone_name: timezone_name,
          superimposed: _this2.isFranchisee ? 1 : 0,
          is_multi: _this2.isFranchisee ? 1 : 0,
          extra_selected_benefit: _this2.data.selectedLeagueBenefitInfo
        },
        success: function success(res) {
          setTimeout(function () {
            that.payOrder(res.data);
          }, 100);
          _app.appMethod.globalData.tostoreRefresh = true;
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          _app.appMethod.showModal({
            content: res.data,
            confirm: function confirm() {
              ;(res.status == 11 || res.status == 12) && _app.appMethod.turnBack();
            }
          });
        },
        complete: function complete() {
          that.isPaysuccessFlag = false;
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var that = _this2;
      function paySuccess() {
        var pagePath = '/orderMeal/pages/paySuccess/paySuccess?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : '');
        if (!that.franchiseeId) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
            data: {
              order_id: orderId,
              sub_app_id: that.franchiseeId
            },
            success: function success(res) {
              if (res.valid == 0) {
                pagePath += '&collectBenefit=1';
              }
              _app.appMethod.turnToPage(pagePath, 1);
            }
          });
        } else {
          _app.appMethod.turnToPage(pagePath, 1);
        }
      }
      function payFail() {
        _app.appMethod.turnToPage('/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''), 1);
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          hideLoading: false,
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      _app.appMethod.sendRequest({
        hideLoading: false,
        url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.franchiseeId
        },
        success: function success(res) {
          var param = res.data;
          param.orderId = orderId;
          param.goodsType = 3;
          param.success = paySuccess;
          param.fail = payFail;
          that.wxPay(param);
        },
        fail: function fail() {
          payFail();
        },
        successStatusAbnormal: function successStatusAbnormal() {
          payFail();
        }
      });
    };

    _this2.wxPay = function (param) {
      var that = _this2;
      _app.appMethod.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _app.appMethod.wxPaySuccess(param);
          param.success();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消',
              complete: param.fail
            });
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败',
            complete: param.fail
          });
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    _this2.showDiscount = function () {
      _this2.setData({
        discountDialogHidden: false
      });
    };

    _this2.hideDiscount = function () {
      _this2.setData({
        discountDialogHidden: true
      });
    };

    _this2.chooseWayOfDine = function (e) {
      var wayOfDine = e.currentTarget.dataset.way,
          that = _this2;
      _this2.setData({
        wayOfDine: wayOfDine
      });
      if (wayOfDine == 2) {
        _this2.getTostoreAppointBusinessTime();
      }
    };

    _this2.getTostoreAppointBusinessTime = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/getAvaliableTostoreAppointBusinessTime',
        method: 'post',
        data: {
          good_ids: that.cartGoodsIdArr,
          sub_shop_app_id: that.franchiseeId || ''
        },
        success: function success(res) {
          if (res.data.length) {
            var businesssTimeString = '';
            for (var i = 0; i < res.data.length; i++) {
              businesssTimeString += res.data[i].start_time.substring(0, 2) + ':' + res.data[i].start_time.substring(2, 4) + '-' + res.data[i].end_time.substring(0, 2) + ':' + res.data[i].end_time.substring(2, 4) + '/';
            }
            businesssTimeString = '可选时间：' + businesssTimeString.substring(0, businesssTimeString.length - 1);
            that.setData({
              businesssTimeString: businesssTimeString
            });
          }
        }
      });
    };

    _this2.bindTimeChange = function (date) {
      var time = date.getHours() + ':' + date.getMinutes();
      _this2.setData({
        appointmentTime: time
      });
    };

    _this2.inputPhone = function (e) {
      var phone = e.target.value;
      _this2.setData({
        phone: phone
      });
      _app.appMethod.setUserInfoStorage({
        phone: phone
      });
    };

    _this2.discountChange = function (index) {
      var that = _this2;
      setTimeout(function () {
        that.setData({
          selectDiscountInfo: that.data.discountList[index],
          selectDiscountIndex: index,
          discountDialogHidden: true,
          'exchangeCouponData.hasSelectGoods': false,
          'exchangeCouponData.voucher_coupon_goods_info': {}
        });
        that.getCalculationPrice();
      }, 500);
    };

    _this2.location = function (e) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/locationDataList',
        data: {
          page_size: 1000,
          sub_shop_app_id: that.franchiseeId || ''
        },
        success: function success(res) {
          if (res.data.length) {
            that.setData({
              location_data_arr: res.data
            });
          }
        }
      });
    };

    _this2.bindLocationChange = function (index) {
      var that = _this2;
      that.setData({
        locationNum: that.data.location_data_arr[index].title,
        selectLocationId: that.data.location_data_arr[index].id,
        locationId: that.data.location_data_arr[index].id,
        locationSelect: true,
        changeValue: 1
      });
    };

    _this2.radioLocationChange = function (e) {
      var that = _this2,
          changeValue,
          locationId = '',
          value = e.target.value;
      if (value == 0) {
        locationId = 0;
        changeValue = 0;
      } else if (value == 1) {
        locationId = that.data.selectLocationId;
        changeValue = 1;
      } else {
        locationId = _app.appMethod.globalData.urlLocationId;
        changeValue = 2;
      }
      that.setData({
        locationId: locationId,
        changeValue: changeValue
      });
    };

    _this2.getDataId = function (e) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getLocationData',
        data: {
          id: _app.appMethod.globalData.urlLocationId,
          sub_shop_app_id: that.franchiseeId || ''
        },
        success: function success(res) {
          that.setData({
            locationTitle: res.data.title
          });
        }
      });
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        useBalance: checked
      });
      _this2.getCalculationPrice();
    };

    _this2.exchangeCouponInit = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: id
        },
        success: function success(res) {
          var goods = res.data[0].form_data;
          var goodsModel = [];
          var selectModelInfo = {
            models: [],
            price: 0,
            modelId: '',
            models_text: '',
            imgurl: ''
          };
          if (goods.model_items.length) {
            selectModelInfo['price'] = Number(goods.model_items[0].price);
            selectModelInfo['imgurl'] = goods.model_items[0].img_url;
            selectModelInfo['modelId'] = goods.model_items[0].id;
          } else {
            selectModelInfo['price'] = Number(goods.price);
            selectModelInfo['imgurl'] = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              goodsModel.push(goods.model[key]); // 转成数组
              selectModelInfo['models'].push(goods.model[key].subModelId[0]);
              selectModelInfo['models_text'] += '“' + goods.model[key].subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel; // 将原来的结构转换成数组
          that.setData({
            'exchangeCouponData.dialogHidden': false, // 显示模态框
            'exchangeCouponData.goodsInfo': goods,
            'exchangeCouponData.selectModelInfo': selectModelInfo
          });
        }
      });
    };

    _this2.exchangeCouponHideDialog = function () {
      _this2.setData({
        selectDiscountInfo: _this2.data.discountList[0],
        selectDiscountIndex: 0,
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.hasSelectGoods': false,
        'exchangeCouponData.voucher_coupon_goods_info': {}
      });
      _this2.getCalculationPrice();
    };

    _this2.exchangeCouponSelectSubModel = function (e) {
      var dataset = e.target.dataset,
          modelIndex = dataset.modelIndex,
          submodelIndex = dataset.submodelIndex,
          data = {},
          selectModels = _this2.data.exchangeCouponData.selectModelInfo.models,
          model = _this2.data.exchangeCouponData.goodsInfo.model,
          text = '';
      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      data['exchangeCouponData.selectModelInfo.models'] = selectModels;
      data['exchangeCouponData.selectModelInfo.models_text'] = text;
      _this2.setData(data);
      _this2.exchangeCouponResetSelectCountPrice();
    };

    _this2.exchangeCouponResetSelectCountPrice = function () {
      var that = _this2,
          selectModelIds = _this2.data.exchangeCouponData.selectModelInfo.models.join(','),
          modelItems = _this2.data.exchangeCouponData.goodsInfo.model_items,
          data = {};
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['exchangeCouponData.selectModelInfo.stock'] = modelItems[i].stock;
          data['exchangeCouponData.selectModelInfo.price'] = modelItems[i].price;
          data['exchangeCouponData.selectModelInfo.modelId'] = modelItems[i].id;
          data['exchangeCouponData.selectModelInfo.imgurl'] = modelItems[i].img_url;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.exchangeCouponConfirmGoods = function () {
      var that = _this2;
      var goodsInfo = that.data.exchangeCouponData.goodsInfo;
      var model = goodsInfo.model;
      var selectModels = that.data.exchangeCouponData.selectModelInfo.models;
      var model_value_str = '';
      if (selectModels.length > 0) {
        model_value_str = '(';
        for (var i = 0; i < selectModels.length; i++) {
          var selectSubModelId = model[i].subModelId;
          for (var j = 0; j < selectSubModelId.length; j++) {
            if (selectModels[i] == selectSubModelId[j]) {
              model_value_str += model[i].subModelName[j] + '|';
            }
          }
        }
        model_value_str += ')';
      }
      goodsInfo['model_value_str'] = model_value_str;
      that.setData({
        'exchangeCouponData.dialogHidden': true,
        'exchangeCouponData.selectModelInfo': {},
        'exchangeCouponData.hasSelectGoods': true,
        'exchangeCouponData.voucher_coupon_goods_info': {
          goods_id: goodsInfo.id,
          num: 1,
          model_id: that.data.exchangeCouponData.selectModelInfo.modelId
        },
        'exchangeCouponData.goodsInfo': goodsInfo
      });
      that.getCalculationPrice();
    };

    _this2.GetTostoreWaitingRule = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetTostoreWaitingRule',
        data: {
          sub_shop_app_id: _this.franchiseeId || ''
        },
        method: 'get',
        success: function success(res) {
          var wayOfDine = 1;
          for (var i in res.data.tostore_type) {
            if (res.data.tostore_type[i].tostore_order_type == 2 && res.data.tostore_type[i].use == 1 && res.data.used_tostore_type == 1) {
              wayOfDine = 2;
              setTimeout(function () {
                _this.getTostoreAppointBusinessTime();
              }, 100);
            }
          }
          _this.setData({
            shopInfo: res.data,
            wayOfDine: wayOfDine
          });
        }
      });
    };

    _this2.leagueDiscountChange = function (index) {
      var that = _this2;
      setTimeout(function () {
        that.setData({
          selectedLeagueBenefitInfo: that.data.leagueBenefitList[index],
          selectedLeagueBenefitIndex: index
        });
        that.getCalculationPrice();
      }, 500);
    };

    document.title = '确认支付';
    return _this2;
  }

  (0, _createClass3.default)(PreviewOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchiseeId = options.franchisee || '';
      var isFranchisee = options.isFranchisee ? true : false;
      if (!this.isFranchisee) {
        var _app$globalData = _app.appMethod.globalData,
            goodsStoreConfig = _app$globalData.goodsStoreConfig,
            hasFranchiseeList = _app$globalData.hasFranchiseeList,
            hasFranchiseeChain = _app$globalData.hasFranchiseeChain;

        if (goodsStoreConfig['cart_config'] && goodsStoreConfig['cart_config'].is_merge_shoppingcart == 1) {
          // 是否开启合并购物车
          if (hasFranchiseeList || hasFranchiseeChain) {
            isFranchisee = true;
          }
        }
      }
      this.isFranchisee = isFranchisee;
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      this.dataInitial();
      if (_app.appMethod.globalData.urlLocationId) {
        this.setData({
          isUrlLocationId: _app.appMethod.globalData.urlLocationId,
          locationId: _app.appMethod.globalData.urlLocationId,
          changeValue: 2
        });
        this.getDataId();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          goodsList = _state.goodsList,
          exchangeCouponData = _state.exchangeCouponData,
          remarkColor = _state.remarkColor,
          remarkLength = _state.remarkLength,
          wayOfDine = _state.wayOfDine,
          shopInfo = _state.shopInfo,
          businesssTimeString = _state.businesssTimeString,
          optionalTimeStart = _state.optionalTimeStart,
          optionalTimeEnd = _state.optionalTimeEnd,
          appointmentTime = _state.appointmentTime,
          changeValue = _state.changeValue,
          locationTitle = _state.locationTitle,
          isUrlLocationId = _state.isUrlLocationId,
          location_data_arr = _state.location_data_arr,
          locationNum = _state.locationNum,
          selectDiscountIndex = _state.selectDiscountIndex,
          discountList = _state.discountList,
          selectDiscountInfo = _state.selectDiscountInfo,
          discount_cut_price = _state.discount_cut_price,
          selectedLeagueBenefitIndex = _state.selectedLeagueBenefitIndex,
          leagueBenefitList = _state.leagueBenefitList,
          selectedLeagueBenefitInfo = _state.selectedLeagueBenefitInfo,
          leagueBenefitPrice = _state.leagueBenefitPrice,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          phone = _state.phone,
          totalPayment = _state.totalPayment,
          dialogHidden = _state.dialogHidden,
          selectModelInfo = _state.selectModelInfo,
          goodsInfo = _state.goodsInfo;

      // Picker组件数据转换

      if (Array.isArray(discountList)) {
        discountList = discountList.map(function (item, index) {
          return { label: item.title, value: index };
        });
      }
      if (Array.isArray(leagueBenefitList)) {
        leagueBenefitList = leagueBenefitList.map(function (item, index) {
          return { label: item.title, value: index };
        });
      }
      if (Array.isArray(location_data_arr)) {
        location_data_arr = location_data_arr.map(function (item, index) {
          return { label: item.title, value: index };
        });
      }

      return React.createElement(
        'div',
        { className: 'official-page preview-order-detail' },
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'previewOrder-wrap page', id: 'previewOrder' },
            goodsList.map(function (goods, goodsIndex) {
              return React.createElement(
                React.Fragment,
                { key: goodsIndex },
                React.createElement(
                  'div',
                  { className: 'previewOrder-goods-list previewOrder-section' },
                  React.createElement(
                    'div',
                    { className: 'previewOrder-goods-item' },
                    React.createElement('img', {
                      className: 'list-goods-cover',
                      src: goods.cover,
                      mode: 'aspectFill'
                    }),
                    React.createElement(
                      'div',
                      { className: 'list-goods-content' },
                      React.createElement(
                        'div',
                        { className: 'list-goods-title' },
                        goods.title
                      ),
                      goods.model_value_str && React.createElement(
                        'div',
                        { className: 'list-goods-model' },
                        goods.model_value_str
                      ),
                      React.createElement(
                        'div',
                        { className: 'list-goods-price' },
                        goods.integral != '2' ? React.createElement(
                          React.Fragment,
                          null,
                          React.createElement(
                            'span',
                            null,
                            '¥' + goods.price
                          )
                        ) : React.createElement(
                          React.Fragment,
                          null,
                          goods.price != '0.00' && React.createElement(
                            'span',
                            null,
                            '¥' + goods.price
                          ),
                          goods.price != '0.00' && goods.use_integral != 0 && React.createElement(
                            'span',
                            null,
                            '+'
                          ),
                          goods.use_integral != 0 && React.createElement(
                            'span',
                            null,
                            goods.use_integral + '积分'
                          )
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'list-goods-right', style: (0, _tools.convertLineStyleData)('top:13px;') },
                      React.createElement(
                        'div',
                        { className: 'quantity' },
                        React.createElement('label', { className: 'minus' }),
                        React.createElement(
                          'span',
                          { className: 'buy-goods-count' },
                          goods.num
                        ),
                        React.createElement('label', { className: 'plus' }),
                        React.createElement('div', {
                          className: 'response-area response-area-minus',
                          'data-index': goodsIndex,
                          onClick: _this3.clickMinusButton
                        }),
                        React.createElement('div', {
                          className: 'response-area response-area-plus',
                          'data-index': goodsIndex,
                          onClick: _this3.clickPlusButton
                        })
                      )
                    )
                  )
                )
              );
            }),
            exchangeCouponData.hasSelectGoods && React.createElement(
              'div',
              { className: 'previewOrder-goods-list previewOrder-section' },
              React.createElement(
                'div',
                { className: 'previewOrder-goods-item' },
                React.createElement('img', {
                  className: 'list-goods-cover',
                  src: exchangeCouponData.goodsInfo.cover,
                  mode: 'aspectFill'
                }),
                React.createElement(
                  'div',
                  { className: 'list-goods-content' },
                  React.createElement(
                    'div',
                    { className: 'list-goods-title' },
                    exchangeCouponData.goodsInfo.title
                  ),
                  exchangeCouponData.goodsInfo.model_value_str && React.createElement(
                    'div',
                    { className: 'list-goods-model' },
                    exchangeCouponData.goodsInfo.model_value_str
                  ),
                  React.createElement(
                    'div',
                    { className: 'list-goods-price' },
                    React.createElement(
                      'div',
                      { className: 'gift-text' },
                      '\u8D60\u54C1'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'list-goods-right', style: (0, _tools.convertLineStyleData)('top:13px;') },
                    React.createElement(
                      'div',
                      { className: 'quantity' },
                      React.createElement(
                        'span',
                        null,
                        '\u6570\u91CF\uFF1A'
                      ),
                      React.createElement(
                        'span',
                        { className: 'buy-goods-count' },
                        '1'
                      )
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'previewOrder-section' },
              React.createElement(
                'div',
                { className: 'previewOrder-section-title' },
                '\u5907\u6CE8:'
              ),
              React.createElement('textarea', {
                onInput: this.remarkInput,
                style: (0, _tools.convertLineStyleData)('border: none;')
              }),
              React.createElement(
                'span',
                {
                  style: (0, _tools.convertLineStyleData)('background-color:#e9e7e8;display:block;font-size:12px;text-align:right;padding-right:4px;color:' + (remarkColor || 'black') + ';')
                },
                (remarkLength || 0) + '/30'
              )
            ),
            React.createElement(
              'div',
              { className: 'previewOrder-section' },
              shopInfo && shopInfo.used_tostore_type == 2 && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'options-group' },
                  React.createElement(
                    'div',
                    {
                      className: 'options-item-left',
                      onClick: this.chooseWayOfDine,
                      'data-way': '1'
                    },
                    React.createElement('div', {
                      className: 'options-item-circle ' + (wayOfDine == 1 ? 'selected' : '')
                    }),
                    React.createElement(
                      'div',
                      null,
                      shopInfo.tostore_type[0].name || '点餐'
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'options-item-right',
                      onClick: this.chooseWayOfDine,
                      'data-way': '2'
                    },
                    React.createElement('div', {
                      className: 'options-item-circle ' + (wayOfDine == 2 ? 'selected' : '')
                    }),
                    React.createElement(
                      'div',
                      null,
                      shopInfo.tostore_type[1].name || '预约'
                    )
                  ),
                  React.createElement('div', { className: 'options-group-crossband' })
                )
              ),
              shopInfo && shopInfo.tostore_type.map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  shopInfo.used_tostore_type != 2 && item.tostore_order_type == 2 && item.use == 1 && wayOfDine == 2 && React.createElement(
                    'div',
                    null,
                    React.createElement('div', {
                      className: 'options-item-circle selected',
                      style: (0, _tools.convertLineStyleData)('display:inline-block;vertical-align:middle;margin-right:5px;')
                    }),
                    item.name
                  ),
                  shopInfo.used_tostore_type != 2 && item.tostore_order_type == 1 && item.use == 1 && wayOfDine == 1 && React.createElement(
                    'div',
                    null,
                    React.createElement('div', {
                      className: 'options-item-circle selected',
                      style: (0, _tools.convertLineStyleData)('display:inline-block;vertical-align:middle;margin-right:5px;')
                    }),
                    item.name
                  ),
                  item.tostore_order_type == 2 && item.use == 1 && wayOfDine == 2 && React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('font-size:12px;color:#ffcc01;margin: 3px 0;') },
                      businesssTimeString
                    ),
                    React.createElement(
                      'div',
                      { className: 'previewOrder-time-picker' },
                      React.createElement(
                        _datePicker2.default,
                        {
                          mode: 'time',
                          minDate: new Date(2000 + ' ' + optionalTimeStart),
                          maxDate: optionalTimeEnd ? new Date(2000 + ' ' + optionalTimeEnd) : new Date(2030, 1, 1, 23, 59, 59),
                          value: isNaN(new Date(2000 + ' ' + appointmentTime).getTime()) ? null : new Date(2000 + ' ' + appointmentTime),
                          onChange: _this3.bindTimeChange },
                        React.createElement(
                          'div',
                          { className: 'picker' },
                          appointmentTime || '请点击选择到店时间'
                        )
                      )
                    )
                  ),
                  location_data_arr && item.tostore_order_type == 1 && item.use == 1 && wayOfDine == 1 && React.createElement(
                    'div',
                    { className: 'previewOrder-section-location' },
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('text-align:left;margin-bottom:10px;') },
                      shopInfo.project_title + ':'
                    ),
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('color:#919191;font-size: 13px;') },
                      isUrlLocationId && React.createElement(
                        'label',
                        { style: (0, _tools.convertLineStyleData)('margin-right:10px;') },
                        React.createElement(_radio2.default, {
                          checked: changeValue == 2,
                          color: '#ff7100',
                          value: '2',
                          onChange: _this3.radioLocationChange
                        }),
                        locationTitle
                      ),
                      React.createElement(
                        'label',
                        { style: (0, _tools.convertLineStyleData)('margin-right:10px;') },
                        React.createElement(
                          _radio2.default,
                          { className: 'radio', value: '0', checked: changeValue == 0, onChange: _this3.radioLocationChange },
                          '\u81EA\u52A9'
                        )
                      ),
                      React.createElement(
                        'label',
                        { style: (0, _tools.convertLineStyleData)('margin-right:10px;') },
                        React.createElement(
                          _radio2.default,
                          { className: 'radio', value: '1', checked: changeValue == 1, onChange: _this3.radioLocationChange },
                          '\u6362\u4F4D\u7F6E'
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'location-section' },
                        React.createElement(
                          _picker2.default,
                          {
                            cols: 1,
                            onChange: _this3.bindLocationChange,
                            value: [index],
                            data: location_data_arr
                          },
                          React.createElement(
                            'div',
                            { className: 'picker' },
                            locationNum || '请选择'
                          )
                        )
                      )
                    )
                  )
                );
              })
            ),
            !!discountList.length && React.createElement(
              'div',
              {
                className: 'previewOrder-section discount-way',
                onClick: this.showDiscount
              },
              React.createElement(
                'div',
                { className: 'previewOrder-section-title' },
                '\u4F18\u60E0\u65B9\u5F0F:'
              ),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              React.createElement(
                _picker2.default,
                {
                  cols: 1,
                  onChange: this.discountChange,
                  value: [selectDiscountIndex],
                  data: discountList,
                  style: (0, _tools.convertLineStyleData)('margin-bottom:-12rpx;')
                },
                React.createElement(
                  'div',
                  { className: 'select-discount-title' },
                  React.createElement(
                    'span',
                    { className: 'pull-left' },
                    selectDiscountInfo.name
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      hidden: selectDiscountIndex == 0
                    },
                    '- ¥' + discount_cut_price
                  )
                )
              )
            ),
            !!leagueBenefitList.length && React.createElement(
              'div',
              { className: 'previewOrder-section discount-way' },
              React.createElement(
                'div',
                { className: 'previewOrder-section-title' },
                '\u8054\u76DF\u4F18\u60E0:'
              ),
              React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              React.createElement(
                _picker2.default,
                {
                  onChange: this.leagueDiscountChange,
                  value: [selectedLeagueBenefitIndex],
                  data: leagueBenefitList,
                  style: (0, _tools.convertLineStyleData)('margin-bottom:-12rpx;')
                },
                React.createElement(
                  'div',
                  { className: 'select-discount-title' },
                  React.createElement(
                    'span',
                    { className: 'pull-left' },
                    selectedLeagueBenefitInfo.name
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'pull-right',
                      hidden: selectedLeagueBenefitIndex == 0
                    },
                    '- ¥' + leagueBenefitPrice
                  )
                )
              )
            ),
            balance != 0 && React.createElement(
              'div',
              { className: 'previewOrder-section' },
              React.createElement(
                'div',
                { className: 'use-balance-option' },
                React.createElement(
                  'span',
                  null,
                  '\u4F7F\u7528\u50A8\u503C\u91D1'
                ),
                React.createElement(_switch2.default, {
                  className: 'pull-right',
                  checked: useBalance,
                  onChange: this.useBalanceChange,
                  color: '#ff7100'
                })
              ),
              React.createElement(
                'div',
                {
                  hidden: !useBalance,
                  className: 'select-discount-title',
                  style: (0, _tools.convertLineStyleData)('margin-top:9px;margin-bottom:-12rpx;')
                },
                '\u50A8\u503C\u91D1\u62B5\u73B0',
                React.createElement(
                  'span',
                  { className: 'pull-right' },
                  '- ¥' + deduction
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'previewOrder-section' },
              React.createElement(
                'div',
                { className: 'previewOrder-section-title' },
                '手机号码' + (shopInfo && shopInfo.is_phone == 1 ? '(必填)' : '') + ':'
              ),
              React.createElement('input', {
                type: 'number',
                placeholder: '\u8BF7\u8F93\u516511\u4F4D\u624B\u673A\u53F7\u7801',
                onInput: this.inputPhone,
                value: phone,
                onChange: function onChange() {}
              })
            ),
            React.createElement(
              'form',
              null,
              React.createElement(
                'button',
                { type: 'button', onClick: this.confirmPayment, className: 'previewOrder-pay-btn' },
                '确认支付 ¥' + totalPayment
              )
            ),
            React.createElement(ExchangeCouponUseDialogTmpl, { data: exchangeCouponData, self: this })
          )
        )
      );
    }
  }]);
  return PreviewOrderDetail;
}(_OfficialPage3.default);

exports.default = PreviewOrderDetail;

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _scratch = __webpack_require__(67);

var _scratch2 = _interopRequireDefault(_scratch);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(599);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaySuccess = function (_OfficialPage) {
  (0, _inherits3.default)(PaySuccess, _OfficialPage);

  function PaySuccess(props) {
    (0, _classCallCheck3.default)(this, PaySuccess);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PaySuccess.__proto__ || Object.getPrototypeOf(PaySuccess)).call(this, props));

    _this2.state = {
      status: 0, // 0: 普通页面 1:有集集乐的情况
      orderId: '', // 订单号
      franchiseeId: '', // 子店id
      wayOfDine: 0, // 1:点餐, 2:预约
      queueNum: 0, // 取餐号
      durationTime: 0,
      appointmentTime: 0,
      collectBenefitData: {}, // 集集乐数据
      starData: [], // 集集乐的星 light:已集样式 dark:未集样式
      isFail: true, //刮刮乐未中奖
      isWinning: true, //刮刮乐中奖
      isComfort: true, //刮刮乐安慰奖
      isWhole: true, //刮奖区域是否显示
      scratchId: '', //活动号
      isShowteam: false,
      winingTitle: '',
      isScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新，
      ifWxCoupon: false,
      timestamp: '',
      signature: '',
      ifGetComfort: false
    };

    _this2.getOrderDetail = function () {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var tostore_data = res.data[0].form_data.tostore_data;
          that.setData({
            wayOfDine: tostore_data.tostore_order_type,
            queueNum: tostore_data.formatted_queue_num,
            appointmentTime: tostore_data.tostore_appointment_time.substr(11, 5),
            durationTime: tostore_data.duration_time
          });
        }
      });
    };

    _this2.getCollectBenefitData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        hideLoading: true,
        success: function success(res) {
          var starData = [];
          for (var i = 0; i < res.data.star_num; i++) {
            starData.push('light');
          }
          for (var i = 0; i < res.data.collect_num - res.data.star_num; i++) {
            starData.push('dark');
          }
          that.setData({
            collectBenefitData: res.data,
            starData: starData
          });
        }
      });
    };

    _this2.touchStart = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchMove = function (e) {
      if (!_this2.isStart) return;
      var pos = _this2.drawRect(e.touches[0].x, e.touches[0].y);
      _this2.ctx.clearRect(pos[0], pos[1], pos[2], pos[2]);
      _this2.ctx.draw(true);
    };

    _this2.touchEnd = function (e) {
      if (!_this2.isStart) return;
      var canvasWidth = _this2.canvasWidth,
          canvasHeight = _this2.canvasHeight,
          minX = _this2.minX,
          minY = _this2.minY,
          maxX = _this2.maxX,
          maxY = _this2.maxY;

      if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
        _this2.ctx.draw();
        _this2.endCallBack && _this2.endCallBack();
        _this2.isStart = false;
        _this2.page.setData({
          isScroll: true
        });
      }
    };

    _this2.getGoldenData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(data) {
          if (data.data) {
            that.setData({
              isWhole: false,
              scratchId: data.data
            });
          } else {
            that.setData({
              isWhole: true
            });
          }
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this2.showAreaClick = function () {
      var that = _this2;
      that.setData({
        isShowteam: false
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/lottery',
        hideLoading: true,
        data: {
          activity_id: that.data.scratchId,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = res.data;
          that.scratch.start();
          if (data.title == '谢谢参与') {
            that.setData({
              isFail: false
            });
          } else {
            var params = {
              ifWxCoupon: data.card_id || false,
              timestamp: data.timestamp || '',
              signature: data.signature || ''
            };
            if (data.is_comfort) {
              params['isComfort'] = false;
            } else {
              params['isWinning'] = false;
              params['winingTitle'] = data.title;
            }
            that.setData(params);
          }
        }
      });
    };

    _this2.goToHomepage = function () {
      var homepageRouter = _app.appMethod.getHomepageRouter();
      _app.appMethod.reLaunch({
        url: '/pages/' + homepageRouter + '/' + homepageRouter
      });
    };

    _this2.goToOrderDetail = function () {
      var franchisee = _this2.data.franchiseeId || '';
      _app.appMethod.turnToPage('/orderMeal/pages/tostoreOrderDetail/tostoreOrderDetail?detail=' + _this2.data.orderId + '&franchisee=' + franchisee, 1);
    };

    _this2.toAddCard = function () {
      var _data = _this2.data,
          wxcouponId = _data.ifWxCoupon,
          _this = _this2;
      _app.appMethod.addCard({
        cardList: [{
          cardId: wxcouponId,
          cardExt: '{"nonce_str":"' + _data.timestamp + '","timestamp":"' + _data.timestamp + '", "signature":"' + _data.signature + '"}'
        }],
        success: function success(res) {
          _this.setData({
            ifWxCoupon: false,
            ifGetComfort: true
          });
          _app.appMethod.sendRequest({
            url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
            data: {
              card_id: res.cardList[0].cardId,
              sub_app_id: _data.franchisee,
              activity_id: _data.scratchId
            },
            success: function success(res) {
              _app.appMethod.showModal({
                title: '提示',
                content: '领取卡券成功',
                showCancel: false
              });
            }
          });
        }
      });
    };

    document.title = '支付成功';
    return _this2;
  }

  (0, _createClass3.default)(PaySuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      that.setData({
        orderId: options.detail,
        franchiseeId: options.franchisee || ''
      });
      that.getOrderDetail();
      if (options.collectBenefit == 1) {
        that.getCollectBenefitData(options.detail);
        that.setData({
          status: 1
        });
      }
      that.getGoldenData(options.detail);
      var systemInfo = _app.appMethod.globalData.systemInfo || {};
      var width = 558 * systemInfo.windowWidth / 750;
      var height = 258 * systemInfo.windowWidth / 750;
      that.scratch = new _scratch2.default(that, {
        canvasWidth: width,
        canvasHeight: height,
        imageResource: _app.appMethod.getSiteBaseUrl() + '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/zhichi_frontend/static/webapp/images/scratchMovie.png',
        maskColor: 'red',
        r: 18,
        callback: function callback() {
          that.setData({
            hideCanvas: true
          });
          if (that.data.ifWxCoupon) {
            setTimeout(function () {
              that.toAddCard();
            }, 500);
          }
        },
        imgLoadCallback: function imgLoadCallback() {
          setTimeout(function () {
            that.setData({
              isShowteam: true
            });
          }, 10);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          queueNum = _state.queueNum,
          durationTime = _state.durationTime,
          wayOfDine = _state.wayOfDine,
          appointmentTime = _state.appointmentTime,
          status = _state.status,
          collectBenefitData = _state.collectBenefitData,
          starData = _state.starData,
          isWhole = _state.isWhole,
          isFail = _state.isFail,
          isWinning = _state.isWinning,
          winingTitle = _state.winingTitle,
          isComfort = _state.isComfort,
          ifGetComfort = _state.ifGetComfort,
          ifWxCoupon = _state.ifWxCoupon,
          hideCanvas = _state.hideCanvas,
          scratch = _state.scratch,
          isScroll = _state.isScroll,
          isShowteam = _state.isShowteam;


      return React.createElement(
        'div',
        { className: 'official-page pay-success' },
        React.createElement(_TopNav.TopNav, { title: '\u652F\u4ED8\u6210\u529F' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            null,
            status == 0 && React.createElement(
              'div',
              { className: 'normal-area' },
              React.createElement(
                'div',
                null,
                React.createElement(_icon2.default, { type: 'check-circle', color: '#09BB07', size: 'lg' })
              ),
              React.createElement(
                'div',
                { className: 'paySuccess-tip' },
                '\u652F\u4ED8\u6210\u529F'
              ),
              React.createElement(
                'div',
                { className: 'paySuccess-detail' },
                React.createElement(
                  'div',
                  null,
                  '\u60A8\u7684\u6392\u961F\u53F7\u4E3A:',
                  React.createElement(
                    'span',
                    { className: 'paySuccess-queue-num' },
                    queueNum
                  )
                ),
                wayOfDine == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('margin-top:15px;') },
                    '大约' + durationTime + '分钟后到店消费'
                  )
                ),
                wayOfDine == 2 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('margin-top:15px;') },
                    '请在预约到店时间 ' + appointmentTime + ' 到店消费'
                  )
                )
              )
            ),
            status == 1 && React.createElement(
              'div',
              { className: 'has-collect-benefit' },
              React.createElement(
                'div',
                { className: 'pay-success-item' },
                React.createElement(_icon2.default, { className: 'icon', type: 'check-circle', color: '#09BB07', size: 'lg' }),
                React.createElement(
                  'div',
                  { className: 'text' },
                  '\u652F\u4ED8\u6210\u529F'
                )
              ),
              React.createElement(
                'div',
                { className: 'to-store-area' },
                React.createElement(
                  'div',
                  { className: 'info-item' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u6392\u961F\u53F7\uFF1A'
                  ),
                  React.createElement(
                    'div',
                    { className: 'item-content queue-num' },
                    queueNum
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'info-item' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u5230\u5E97\u65F6\u95F4\uFF1A'
                  ),
                  wayOfDine == 1 && React.createElement(
                    'div',
                    { className: 'item-content' },
                    '大约' + durationTime + '分钟后到店消费'
                  ),
                  wayOfDine == 2 && React.createElement(
                    'div',
                    { className: 'item-content' },
                    '请在预约到店时间 ' + appointmentTime + ' 到店消费'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'info-item' },
                  React.createElement(
                    'div',
                    { className: 'item-name' },
                    '\u5230\u5E97\u65B9\u5F0F\uFF1A'
                  ),
                  wayOfDine == 1 && React.createElement(
                    'div',
                    { className: 'item-content' },
                    '\u7ACB\u5373\u5230\u5E97'
                  ),
                  wayOfDine == 2 && React.createElement(
                    'div',
                    { className: 'item-content' },
                    '\u9884\u7EA6\u5230\u5E97'
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'collect-benefit-area' },
                React.createElement(
                  'div',
                  { className: 'collect-item' },
                  React.createElement(
                    'div',
                    { className: 'star-num' },
                    '集集乐个数: ' + collectBenefitData.star_num
                  ),
                  React.createElement(
                    'div',
                    { className: 'star-list' },
                    starData.map(function (item, index) {
                      return React.createElement(
                        React.Fragment,
                        { key: index },
                        item == 'light' ? React.createElement('img', {
                          className: 'star-item',
                          src: collectBenefitData.light_img
                        }) : item == 'dark' && React.createElement('img', {
                          className: 'star-item',
                          src: collectBenefitData.dark_img
                        })
                      );
                    })
                  ),
                  collectBenefitData.star_num == collectBenefitData.collect_num && React.createElement(
                    'div',
                    { className: 'star-full' },
                    React.createElement(
                      'div',
                      { className: 'star-full-text' },
                      '\u6EE1'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'tip-item' },
                  collectBenefitData.star_num == collectBenefitData.collect_num ? React.createElement(
                    'div',
                    null,
                    '获得一张' + collectBenefitData.coupon_title
                  ) : collectBenefitData.star_num != collectBenefitData.collect_num && React.createElement(
                    'div',
                    null,
                    '消费' + (collectBenefitData.play_type == 0 ? '每满' : '超过') + collectBenefitData.value + '元，累计一颗星，集满可获得' + collectBenefitData.coupon_title + '一张'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'scratchWhole', hidden: isWhole },
              React.createElement(
                'div',
                { className: 'scratchArea' },
                React.createElement(
                  'div',
                  { className: 'scratchFail', hidden: isFail },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchFail.png' }),
                  React.createElement(
                    'div',
                    { className: 'failTitle' },
                    React.createElement(
                      'div',
                      { className: 'failShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    React.createElement(
                      'div',
                      { className: 'failText' },
                      '\u5F88\u9057\u61BE\u6CA1\u6709\u4E2D\u5956\u54E6'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchWinning', hidden: isWinning },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchPrize.png' }),
                  React.createElement(
                    'div',
                    { className: 'winningTitle' },
                    React.createElement(
                      'div',
                      { className: 'winningShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    React.createElement(
                      'div',
                      { className: 'winningText' },
                      '\u606D\u559C\u4F60\u83B7\u5F97\u4E86'
                    ),
                    React.createElement(
                      'div',
                      { className: 'winningText winningValue' },
                      winingTitle
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'scratchComfort', hidden: isComfort },
                  React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/scratchComfort.png' }),
                  React.createElement(
                    'div',
                    { className: 'comfortTitle' },
                    React.createElement(
                      'div',
                      { className: 'comfortShare', onClick: this.shareClickEvent },
                      '\u5206\u4EAB'
                    ),
                    ifGetComfort ? React.createElement(
                      'div',
                      { className: 'comfortText' },
                      '\u5DF2\u9886\u53D6\uFF0C\u5728\u5FAE\u4FE1\u5361\u5305\u4E2D\u67E5\u770B\u54E6~'
                    ) : React.createElement(
                      'div',
                      (0, _defineProperty3.default)({ className: 'comfortText' }, 'className', 'comfortText'),
                      '\u53C8\u6CA1\u4E2D\u5956\uFF0C\u9001\u4F60\u4E00\u4E2A\u5C0F\u793C\u54C1'
                    ),
                    !ifWxCoupon && !ifGetComfort && React.createElement(
                      'div',
                      { className: 'comfortText' },
                      '>\u5728\u4F18\u60E0\u5238\u5361\u5305\u8FDB\u884C\u67E5\u6536\u54E6~'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'scratch_wp',
                    hidden: hideCanvas,
                    style: (0, _tools.convertLineStyleData)('width: ' + (scratch && scratch.width) + 'px; height: ' + (scratch && scratch.height) + 'px;')
                  },
                  React.createElement('canvas', {
                    className: 'scratch-canvas',
                    width: scratch && scratch.width,
                    height: scratch && scratch.height,
                    id: 'scratch-canvas',
                    onTouchStart: this.touchStart,
                    onTouchMove: this.touchMove,
                    onTouchEnd: this.touchEnd
                  }),
                  isShowteam && React.createElement(
                    'div',
                    { className: 'showArea' },
                    React.createElement(
                      'div',
                      { className: 'showTitle' },
                      '\u8D62\u53D6\u4F18\u60E0\u5927\u5956'
                    ),
                    React.createElement(
                      'div',
                      { className: 'showBtn', onClick: this.showAreaClick },
                      '\u70B9\u6211\u522E\u5956'
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'btn-area' },
              React.createElement(
                'div',
                { className: 'finish-btn', onClick: this.goToHomepage },
                '\u5B8C\u6210'
              ),
              React.createElement(
                'div',
                { className: 'check-order-btn', onClick: this.goToOrderDetail },
                '\u67E5\u770B\u8BA2\u5355'
              )
            )
          )
        )
      );
    }
  }]);
  return PaySuccess;
}(_OfficialPage3.default);

exports.default = PaySuccess;

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = __webpack_require__(79);

var _radio2 = _interopRequireDefault(_radio);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(80);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(601);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToStoreOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(ToStoreOrderDetail, _OfficialPage);

  function ToStoreOrderDetail(props) {
    (0, _classCallCheck3.default)(this, ToStoreOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ToStoreOrderDetail.__proto__ || Object.getPrototypeOf(ToStoreOrderDetail)).call(this, props));

    _this2.state = {
      orderInfo: {},
      orderStatus: ['待付款', '待商家确认', '商家已确认', '待评价', '退款审核中', '退款中', '已完成', '已关闭'],
      addressList: [],
      selectAddressId: '',
      addressDialogHidden: true,
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      isFromBack: false,
      orderId: '',
      isFromTemplateMsg: false,
      discountList: '',
      toStoreInfo: {},
      originalPrice: '',
      balance: '',
      useBalance: '',
      freghtSwitch: '',
      delivery: '',
      express_fee: '',
      refund: false,
      applyRefund: false,
      refundType: 0,
      refundMoneyType: 0,
      withdrawRefund: false
    };

    _this2.dataInitial = function () {
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.GetTostoreWaitingRule();
    };

    _this2.getOrderDetail = function (orderId, isFromAddrSelect) {
      var that = _this2;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var form_data = res.data[0].form_data,
              hasAdditionalInfo = false,
              address_id = '';
          form_data.totalPay = form_data.total_price;
          if (!isFromAddrSelect) {
            for (var i = 0; i < form_data.goods_info.length; i++) {
              var deliveryId = form_data.goods_info[i].delivery_id;
              if (deliveryId && deliveryId != '0') {
                that.getGoodsCustomField(i, deliveryId);
                hasAdditionalInfo = true;
              }
            }
          }
          if (form_data.address_info && that.data.freghtSwitch) {
            address_id = form_data.address_info.address_id;
            that.setData({
              selectAddressId: address_id
            });
          }
          if (form_data.tostore_data && form_data.tostore_data.appointed_time) form_data.tostore_data.format_appointed_time = form_data.tostore_data.appointed_time;
          that.setData({
            orderInfo: form_data,
            discountList: form_data.selected_benefit,
            index: form_data.can_use_benefit.selected_index,
            hasAdditionalInfo: hasAdditionalInfo,
            toStoreInfo: form_data.tostore_data,
            benefitPrice: form_data.discount_cut_price,
            balance: Number(res.data[0]['balance']),
            useBalance: form_data['use_balance'],
            express_fee: res.data[0]['express_fee']
          });
        }
      });
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId,
          that = _this2,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.showModal({
        content: '订单删除后不可找回，确认删除？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.getGoodsCustomField = function (goodsIndex, deliveryId) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=pc/AppShop/GetDelivery',
        data: {
          app_id: _app.appMethod.getAppId(),
          delivery_id: deliveryId
        },
        success: function success(res) {
          var deliveryInfo = res.data.delivery_info,
              goodsId = that.data.orderInfo.goods_info[goodsIndex].goods_id,
              data = {},
              fields = [];
          data['goodsAdditionalInfo.' + goodsId + ''] = deliveryInfo;
          for (var i = 0; i < deliveryInfo.length; i++) {
            var info = {};
            info.type = deliveryInfo[i].type;
            info.title = deliveryInfo[i].name;
            fields.push(info);
          }
          data['customFields[' + goodsIndex + ']'] = fields;
          that.setData(data);
        }
      });
    };

    _this2.customFieldInput = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          value = e.target.value,
          data = {};
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = value;
      _this2.setData(data);
    };

    _this2.uploadCustomFieldImage = function (e) {
      var that = _this2,
          dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          data = {};
      _app.appMethod.chooseImage(function (paths) {
        data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = paths;
        that.setData(data);
      }, 9);
    };

    _this2.deleteCustomFieldImage = function (e) {
      var dataset = e.currentTarget.dataset,
          goodsIndex = dataset.goodsIndex,
          fieldIndex = dataset.fieldIndex,
          imageArray = _this2.data.customFields[goodsIndex][fieldIndex].value,
          imageIndex = dataset.imageIndex,
          data = {};
      imageArray.splice(imageIndex, 1);
      data['customFields[' + goodsIndex + '][' + fieldIndex + '].value'] = imageArray;
      _this2.setData(data);
    };

    _this2.sendDeliveryInfo = function () {
      var additional_info = {},
          goodsInfo = _this2.data.orderInfo.goods_info;
      for (var i = 0; i < goodsInfo.length; i++) {
        additional_info[goodsInfo[i].goods_id] = _this2.data.customFields[i];
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/SetAdditional',
        method: 'POST',
        data: {
          order_id: _this2.data.orderInfo.order_id,
          additional_info: additional_info
        },
        success: function success(res) {}
      });
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '是否取消订单？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderId;
      if (!address_info && _this2.data.orderInfo.goods_type != 3) {
        _app.appMethod.showModal({
          content: '请选择邮寄地址'
        });
        return;
      }
      if (_this2.data.hasAdditionalInfo) {
        _this2.sendDeliveryInfo();
      }
      orderId = _this2.data.orderInfo.order_id;
      if (_this2.data.orderInfo.totalPay == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            _app.appMethod.showToast({
              title: '支付成功',
              success: function success() {
                that.paySuccessCallback();
              }
            });
          }
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var param = res.data,
              orderId = that.data.orderInfo.order_id;
          param.orderId = orderId;
          param.goodsType = that.data.orderInfo.goods_type;
          param.success = function () {
            that.paySuccessCallback();
          };
          _app.appMethod.wxPay(param);
        }
      });
    };

    _this2.confirmRefund = function (e) {
      var type = _this2.data.refundType;
      switch (+type) {
        case 0:
          _this2.applyDrawback();
          break;
        case 1:
          _this2.sureReceipt();
          break;
        case 2:
          _this2.withdrawRefund();
          break;
        case 3:
          _this2.receiveDrawback();
          break;
      }
    };

    _this2.applyDrawback = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          money = _this2.data.refundMoneyType == 0 ? '' : +_this2.data.refundMoney,
          that = _this2;
      if (_this2.data.refundMoneyType != 0 && !_this2.data.refundMoney) {
        _app.appMethod.showModal({
          content: '请输入退款金额'
        });
        return;
      }
      if (money && !/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/.test(money) && money == 0) {
        _app.appMethod.showModal({
          content: '请输入正确的金额'
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/applyRefund',
        data: {
          refund_price: money,
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = 4;
          data['refund'] = false;
          data['orderInfo.refund_info'] = {
            refund_fee: 0,
            refund_balance: +money || +that.data.orderInfo.totalPay + +that.data.useBalance
          };
          that.setData(data);
        }
      });
    };

    _this2.withdrawRefund = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cancelRefund',
        data: {
          order_id: that.data.orderInfo.order_id,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = +res.data;
          data['refund'] = false;
          data['refundMoney'] = '';
          data['orderInfo.refund_info'] = '';
          that.setData(data);
        }
      });
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmRefund',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          that.getOrderDetail(that.data.orderId);
          that.setData({
            refund: false
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId);
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var data = {};
          data['orderInfo.status'] = 3;
          data['refund'] = false;
          that.setData(data);
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/eCommerce/pages/makeComment/makeComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.changeDiscount = function (e) {
      var _this = _this2;
      var index = _this.data.orderInfo.can_use_benefit.selected_index;
      var value = parseInt(e.target.value);
      _this2.setData({
        index: value
      });
      var discount_type = _this.data.orderInfo.can_use_benefit.data[value].discount_type,
          coupon_id = _this.data.orderInfo.can_use_benefit.data[value].coupon_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderInfo.order_id,
          discount_type: discount_type,
          coupon_id: coupon_id,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          _this.getOrderDetail(res.data[0].form_data.order_id);
        }
      });
    };

    _this2.verificationCode = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' + _this2.data.orderInfo.order_id + '&sub_shop_app_id=' + _this2.data.franchiseeId);
    };

    _this2.changeRefundType = function (e) {
      _this2.setData({
        refundMoneyType: e.target.value
      });
    };

    _this2.refundMoney = function (e) {
      _this2.setData({
        refundMoney: e.target.value
      });
    };

    _this2.refund = function (e) {
      _this2.setData({
        refundMoney: '',
        refund: true,
        refundType: +e.currentTarget.dataset.type
      });
    };

    _this2.cancelRefund = function () {
      _this2.setData({
        refund: false
      });
    };

    _this2.customerConfirm = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/comfirmOrder',
        data: {
          order_id: _this2.data.orderInfo.order_id
        },
        success: function success() {
          var data = {};
          data['orderInfo.status'] = 3;
          that.setData(data);
        }
      });
    };

    _this2.isUseBalance = function (e) {
      var _this = _this2;
      var isBalance = Number(e.target.value);
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/ChangeOrder',
        data: {
          app_id: _app.appMethod.getAppId(),
          order_id: _this.data.orderInfo.order_id,
          sub_shop_app_id: _this.data.franchiseeId,
          is_balance: isBalance
        },
        success: function success(res) {
          _this.getOrderDetail(res.data[0].form_data.order_id);
        }
      });
    };

    _this2.paySuccessCallback = function () {
      var orderId = _this2.data.orderInfo.order_id;
      var franchiseeId = _this2.data.franchiseeId;
      var pagePath = '/orderMeal/pages/paySuccess/paySuccess?detail=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      if (!franchiseeId) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
          data: {
            order_id: orderId,
            sub_app_id: franchiseeId
          },
          success: function success(res) {
            if (res.valid == 0) {
              pagePath += '&collectBenefit=1';
            }
            _app.appMethod.turnToPage(pagePath, 1);
          }
        });
      } else {
        _app.appMethod.turnToPage(pagePath, 1);
      }
    };

    _this2.GetTostoreWaitingRule = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetTostoreWaitingRule',
        data: {
          sub_shop_app_id: _this.data.franchiseeId || ''
        },
        method: 'get',
        success: function success(res) {
          _this.setData({
            shopInfo: res.data
          });
        }
      });
    };

    _this2.makeComment = function () {
      var franchiseeId = _this2.data.franchiseeId,
          pagePath = '/orderMeal/pages/makeTostoreComment/makeTostoreComment?detail=' + _this2.data.orderInfo.order_id + (franchiseeId ? '&franchisee=' + franchiseeId : '');
      _app.appMethod.turnToPage(pagePath);
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(ToStoreOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        if (!!this.data.orderInfo.order_id) {
          this.getOrderDetail(this.data.orderInfo.order_id, 1);
        }
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          orderStatus = _state.orderStatus,
          orderInfo = _state.orderInfo,
          toStoreInfo = _state.toStoreInfo,
          shopInfo = _state.shopInfo,
          customFields = _state.customFields,
          goodsAdditionalInfo = _state.goodsAdditionalInfo,
          discountList = _state.discountList,
          benefitPrice = _state.benefitPrice,
          useBalance = _state.useBalance,
          refund = _state.refund,
          refundType = _state.refundType,
          refundMoneyType = _state.refundMoneyType,
          refundMoney = _state.refundMoney;


      return React.createElement(
        'div',
        { className: 'official-page to-store-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'orderDetail-wrap page', id: 'orderDetail' },
            isFromTemplateMsg && React.createElement(
              'div',
              {
                className: 'orderDetail-section orderDetail-goto-homepage',
                onClick: this.goToHomepage,
                style: (0, _tools.convertLineStyleData)('margin-bottom:0;')
              },
              React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              '\u8FD4\u56DE\u9996\u9875'
            ),
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('margin-bottom:4px;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u8BA2\u5355\u72B6\u6001\uFF1A'
                ),
                React.createElement(
                  'span',
                  { className: 'orderDetail-pay-count' },
                  orderStatus[orderInfo.status]
                )
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u8BA2\u5355\u53F7\uFF1A'
                ),
                orderInfo.order_id
              )
            ),
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('margin-bottom:4px;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u6392\u961F\u53F7:'
                ),
                toStoreInfo.formatted_queue_num
              ),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u5230\u5E97\u65F6\u95F4:'
                ),
                toStoreInfo.format_appointed_time
              )
            ),
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              orderInfo.location_name && React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u5230\u5E97\u4F4D\u7F6E:'
                ),
                React.createElement(
                  'span',
                  null,
                  orderInfo.location_name
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u5230\u5E97\u65B9\u5F0F:'
                ),
                toStoreInfo.tostore_order_type == 1 ? React.createElement(
                  'span',
                  null,
                  shopInfo && shopInfo.tostore_type[0].name || '点餐'
                ) : React.createElement(
                  'span',
                  null,
                  (shopInfo && shopInfo.tostore_type[1].name || '预约') + ' ' + toStoreInfo.tostore_appointment_time
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u624B\u673A\u53F7\u7801:'
                ),
                React.createElement(
                  'span',
                  null,
                  toStoreInfo.tostore_buyer_phone
                )
              ),
              React.createElement(
                'div',
                { className: 'orderDetail-item-row' },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#888;') },
                  '\u5907\u6CE8\u4FE1\u606F:'
                ),
                React.createElement(
                  'span',
                  null,
                  toStoreInfo.tostore_remark || '无'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'orderDetail-section' },
              React.createElement(
                'div',
                { className: 'orderDetail-order-list' },
                orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
                  return React.createElement(
                    React.Fragment,
                    { key: goodsIndex },
                    React.createElement(
                      'div',
                      { className: 'dialog-block-item' },
                      React.createElement('img', {
                        className: 'list-goods-cover',
                        src: goods.cover
                      }),
                      React.createElement(
                        'div',
                        { className: 'list-goods-content' },
                        React.createElement(
                          'div',
                          { style: (0, _tools.convertLineStyleData)('overflow:hidden;white-space:nowrap;text-overflow:ellipsis;') },
                          goods.goods_name
                        ),
                        goods.model_value && React.createElement(
                          'div',
                          { className: 'list-goods-model' },
                          goods.model_value
                        ),
                        goods.is_benefit_goods && React.createElement(
                          'div',
                          { className: 'gift-text' },
                          '\u8D60\u54C1'
                        )
                      ),
                      !goods.is_benefit_goods ? React.createElement(
                        'div',
                        { className: 'list-goods-right' },
                        React.createElement(
                          'div',
                          { className: 'orderDetail-pay-count' },
                          '¥' + goods.price
                        ),
                        React.createElement(
                          'div',
                          null,
                          '× ' + goods.num
                        )
                      ) : goods.is_benefit_goods && React.createElement(
                        'div',
                        { className: 'list-goods-right' },
                        React.createElement(
                          'div',
                          null,
                          '\xD7 1'
                        )
                      )
                    ),
                    goodsAdditionalInfo[goods.goods_id] && React.createElement(
                      'div',
                      { className: 'dialog-block-item' },
                      goodsAdditionalInfo[goods.goods_id].map(function (field, fieldIndex) {
                        return React.createElement(
                          'div',
                          { className: 'customField-container', key: fieldIndex },
                          orderInfo.additional_info && orderInfo.additional_info[goods.goods_id] ? React.createElement(
                            React.Fragment,
                            null,
                            field.type === 'text' || field.type === 'mul-text' ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                null,
                                field.name + ':' + orderInfo.additional_info[goods.goods_id][fieldIndex].value
                              )
                            ) : field.type === 'picture' && React.createElement(
                              React.Fragment,
                              null,
                              orderInfo.additional_info[goods.goods_id][fieldIndex].value.map(function (imgUrl, index) {
                                return React.createElement(
                                  'div',
                                  {
                                    className: 'custom-field-image',
                                    key: index
                                  },
                                  React.createElement('img', {
                                    src: imgUrl,
                                    mode: 'aspectFit',
                                    onClick: _this3.previewImage,
                                    'data-src': imgUrl
                                  })
                                );
                              })
                            )
                          ) : React.createElement(
                            React.Fragment,
                            null,
                            field.type === 'text' ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement('input', {
                                'data-name': field.name,
                                'data-goods-index': goodsIndex,
                                'data-field-index': fieldIndex,
                                placeholder: field.name,
                                onInput: _this3.customFieldInput
                              })
                            ) : field.type === 'mul-text' ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement('textarea', {
                                'data-name': field.name,
                                'data-goods-index': goodsIndex,
                                'data-field-index': fieldIndex,
                                placeholder: field.name,
                                onInput: _this3.customFieldInput
                              })
                            ) : field.type === 'picture' && React.createElement(
                              React.Fragment,
                              null,
                              customFields[goodsIndex][fieldIndex].value.map(function (fieldImg, imageIndex) {
                                return React.createElement(
                                  'div',
                                  {
                                    className: 'custom-field-image',
                                    key: imageIndex
                                  },
                                  React.createElement('img', {
                                    src: fieldImg,
                                    mode: 'aspectFit',
                                    onClick: _this3.previewImage,
                                    'data-src': fieldImg
                                  }),
                                  React.createElement(
                                    'label',
                                    {
                                      className: 'delete-img',
                                      onClick: _this3.deleteCustomFieldImage,
                                      'data-goods-index': goodsIndex,
                                      'data-field-index': fieldIndex,
                                      'data-image-index': imageIndex
                                    },
                                    '\xD7'
                                  )
                                );
                              }),
                              React.createElement(
                                'div',
                                {
                                  className: 'upload-field-image',
                                  onClick: _this3.uploadCustomFieldImage,
                                  'data-name': field.name,
                                  'data-goods-index': goodsIndex,
                                  'data-field-index': fieldIndex
                                },
                                field.name
                              )
                            )
                          )
                        );
                      })
                    )
                  );
                })
              ),
              React.createElement(
                'div',
                { className: 'dialog-block-item' },
                React.createElement(
                  'div',
                  { className: 'orderDetail-item-row' },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u5546\u54C1\u603B\u989D\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '¥' + orderInfo.original_price
                  )
                ),
                !!+orderInfo.total_integral && orderInfo.total_integral != 0 && orderInfo.total_integral != '0' && React.createElement(
                  'div',
                  { className: 'orderDetail-item-row' },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u8BA2\u5355\u79EF\u5206\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    orderInfo.total_integral + '积分'
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null
                  },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#888;') },
                      '\u5E97\u94FA\u4F18\u60E0\uFF1A'
                    ),
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('float:right;word-break:break-all;') },
                      discountList.title
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: orderInfo.selected_benefit && orderInfo.selected_benefit.discount_type == null
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u4F18\u60E0\u62B5\u6263\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + benefitPrice
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.discount_type == null
                  },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('color:#888;') },
                      '\u8054\u76DF\u4F18\u60E0\uFF1A'
                    ),
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('float:right;word-break:break-all;') },
                      orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.title
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: orderInfo.extra_selected_benefit_info && orderInfo.extra_selected_benefit_info.discount_type == null
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u8054\u76DF\u4F18\u60E0\u62B5\u6263\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + orderInfo.extra_discount_cut_price
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: orderInfo.status == 0
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u50A8\u503C\u62B5\u6263\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + useBalance
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'orderDetail-item-row',
                    hidden: !orderInfo.coupon_fee
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u793E\u4EA4\u7ACB\u51CF\u91D1\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '- ¥' + orderInfo.coupon_fee
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'dialog-block-item' },
                React.createElement(
                  'div',
                  { className: 'orderDetail-item-row' },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u4E0B\u5355\u65F6\u95F4\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    orderInfo.add_time
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'orderDetail-item-row' },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u5B9E\u4ED8\u4EF7\u683C\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'orderDetail-pay-count pull-right' },
                    '¥' + orderInfo.totalPay
                  )
                ),
                orderInfo.refund_info && React.createElement(
                  'div',
                  { className: 'orderDetail-item-row' },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#888;') },
                    '\u9000\u6B3E\u91D1\u989D\uFF1A'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    '¥' + (orderInfo.refund_info.refund_fee + orderInfo.refund_info.refund_balance)
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'txt-c orderDetail-btn-status' },
                orderInfo.status == 0 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn orderDetail-cancel-order',
                      onClick: this.cancelOrder
                    },
                    '\u53D6\u6D88\u8BA2\u5355'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-pay-directly',
                      onClick: this.payOrder
                    },
                    '\u7ACB\u5373\u652F\u4ED8'
                  )
                ),
                orderInfo.status == 1 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    { className: 'btn', onClick: this.refund, 'data-type': '0' },
                    '\u7533\u8BF7\u9000\u6B3E'
                  )
                ),
                orderInfo.status == 2 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    { className: 'btn', onClick: this.refund, 'data-type': '0' },
                    '\u7533\u8BF7\u9000\u6B3E'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-verification-code',
                      onClick: this.verificationCode
                    },
                    '\u6838\u9500\u7801'
                  ),
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-verification-code',
                      'data-type': '1',
                      onClick: this.refund
                    },
                    '\u786E\u8BA4\u5DF2\u5230\u5E97'
                  )
                ),
                orderInfo.status == 3 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-verification-code',
                      onClick: this.makeComment
                    },
                    '\u8BC4\u4EF7'
                  )
                ),
                orderInfo.status == 4 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-verification-code',
                      onClick: this.refund,
                      'data-type': '2'
                    },
                    '\u64A4\u9500\u9000\u6B3E\u7533\u8BF7'
                  )
                ),
                orderInfo.status == 5 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange orderDetail-verification-code',
                      onClick: this.refund,
                      'data-type': '3'
                    },
                    '\u6536\u5230\u9000\u6B3E'
                  )
                ),
                orderInfo.status == 6 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange myOrder-delete',
                      onClick: this.orderDelete
                    },
                    '\u522A\u9664\u8BA2\u5355'
                  )
                ),
                orderInfo.status == 7 && React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'btn btn-orange myOrder-delete',
                      onClick: this.orderDelete
                    },
                    '\u522A\u9664\u8BA2\u5355'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'applyRefund', hidden: !refund },
              React.createElement(
                'div',
                { className: 'applyRefundMain' },
                refundType == 0 && React.createElement(
                  'div',
                  { className: 'refundTitle' },
                  '\u786E\u8BA4\u9000\u6B3E\u91D1\u989D'
                ),
                refundType == 0 && React.createElement(
                  'label',
                  { style: (0, _tools.convertLineStyleData)('margin-top: 0;') },
                  React.createElement(_radio2.default, {
                    value: '0',
                    checked: refundMoneyType == 0,
                    color: '#ff7100',
                    className: 'radio',
                    onChange: this.changeRefundType }),
                  React.createElement(
                    'span',
                    { className: 'radioText' },
                    '\u5168\u989D\u9000\u6B3E'
                  )
                ),
                refundType == 0 && React.createElement(
                  'label',
                  null,
                  React.createElement(_radio2.default, {
                    value: '1',
                    checked: refundMoneyType != 0,
                    color: '#ff7100',
                    className: 'radio',
                    onChange: this.changeRefundType
                  }),
                  React.createElement(
                    'span',
                    { className: 'radioText' },
                    '\u90E8\u5206\u9000\u6B3E'
                  ),
                  React.createElement('input', {
                    onChange: function onChange() {},
                    onInput: this.refundMoney,
                    value: refundMoney,
                    type: 'text',
                    style: (0, _tools.convertLineStyleData)(refundMoneyType == 0 ? 'display: none;' : 'dispaly:inline-block;')
                  })
                ),
                refundType == 1 && React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('text-align:center;margin:20px 0 10px;font-size: 30rpx;') },
                  '\u63D0\u793A'
                ),
                refundType == 1 && React.createElement(
                  'div',
                  { className: 'WithdrawRefundTitle-sec' },
                  '\u786E\u8BA4\u5230\u5E97\u540E\u8BA2\u5355\u5B8C\u6210\uFF0C\u65E0\u6CD5\u6838\u9500\u3002\u8BF7\u5230\u5E97\u8054\u7CFB\u5DE5\u4F5C\u4EBA\u5458\u540E\u786E\u8BA4\uFF01'
                ),
                refundType == 2 && React.createElement(
                  'div',
                  { className: 'WithdrawRefundTitle' },
                  '\u786E\u5B9A\u64A4\u9500\u9000\u6B3E\u7533\u8BF7'
                ),
                refundType == 3 && React.createElement(
                  'div',
                  { className: 'WithdrawRefundTitle' },
                  '\u786E\u5B9A\u5DF2\u6536\u5230\u9000\u6B3E'
                ),
                React.createElement(
                  'div',
                  { className: 'applyRefundBtn' },
                  React.createElement(
                    'span',
                    { onClick: this.cancelRefund },
                    '\u53D6\u6D88'
                  ),
                  refundType == 1 && React.createElement(
                    'span',
                    {
                      className: 'commitBtn',
                      'data-refundtype': refundMoneyType,
                      onClick: this.confirmRefund
                    },
                    '\u6211\u5DF2\u5230\u5E97'
                  ),
                  refundType != 1 && React.createElement(
                    'span',
                    {
                      className: 'commitBtn',
                      'data-refundtype': refundMoneyType,
                      onClick: this.confirmRefund
                    },
                    '\u786E\u8BA4'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ToStoreOrderDetail;
}(_OfficialPage3.default);

exports.default = ToStoreOrderDetail;

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _ScrollView = __webpack_require__(11);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(603);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToStoreComment = function (_OfficialPage) {
  (0, _inherits3.default)(ToStoreComment, _OfficialPage);

  function ToStoreComment(props) {
    (0, _classCallCheck3.default)(this, ToStoreComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ToStoreComment.__proto__ || Object.getPrototypeOf(ToStoreComment)).call(this, props));

    _this.state = {
      goodsId: '',
      commnetType: 0,
      comments: [],
      commentNums: [],
      loadPage: 1
    };

    _this.getAssessList = function (commnetType, page, append) {
      var that = _this;
      _app.appMethod.getAssessList({
        method: 'post',
        data: {
          goods_id: that.data.goodsId,
          idx_arr: {
            idx: 'level',
            idx_value: commnetType
          },
          page: page,
          page_size: 20,
          sub_shop_app_id: _this.data.franchiseeId
        },
        success: function success(res) {
          var commentArr = res.data;
          if (append) {
            commentArr = that.data.comments.concat(commentArr);
          }
          that.setData({
            comments: commentArr,
            commentNums: res.num,
            loadPage: that.data.loadPage + 1
          });
        }
      });
    };

    _this.clickCommentLabel = function (e) {
      var commentType = e.target.dataset.type,
          data = {};
      data.loadPage = 1;
      data.commnetType = commentType;
      _this.setData(data);
      _this.getAssessList(commentType, 1);
    };

    _this.scrollLoadComment = function () {
      _this.getAssessList(_this.data.commentType, _this.data.loadPage, 1);
    };

    _this.clickPlusImages = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src,
        urls: e.currentTarget.dataset.srcarr && JSON.parse(e.currentTarget.dataset.srcarr)
      });
    };

    document.title = '商品评价';
    return _this;
  }

  (0, _createClass3.default)(ToStoreComment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var goodsId = options.detail,
          franchiseeId = options.franchisee || '';
      this.setData({
        goodsId: goodsId,
        franchiseeId: franchiseeId
      });
      this.getAssessList(0, 1);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          commnetType = _state.commnetType,
          commentNums = _state.commentNums,
          comments = _state.comments;

      return React.createElement(
        'div',
        { className: 'official-page to-store-comment' },
        React.createElement(_TopNav.TopNav, { title: '\u5546\u54C1\u8BC4\u8BBA' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'comPage-wrap page', id: 'commentPage' },
            React.createElement(
              'div',
              { className: 'comPage-top-section' },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('border-bottom:1px solid #f4f4f4;') },
                React.createElement(
                  'label',
                  {
                    onClick: this.clickCommentLabel,
                    'data-type': '0',
                    className: 'comPage-comment-label ' + (commnetType == 0 ? 'active' : '')
                  },
                  '\u5168\u90E8'
                ),
                React.createElement(
                  'label',
                  {
                    onClick: this.clickCommentLabel,
                    'data-type': '1',
                    className: 'comPage-comment-label ' + (commnetType == 1 ? 'active' : '')
                  },
                  '\u597D\u8BC4 (',
                  React.createElement(
                    'label',
                    { className: 'comPage-positive-comment' },
                    commentNums[1]
                  ),
                  ')'
                ),
                React.createElement(
                  'label',
                  {
                    onClick: this.clickCommentLabel,
                    'data-type': '2',
                    className: 'comPage-comment-label ' + (commnetType == 2 ? 'active' : '')
                  },
                  '\u4E2D\u8BC4 (',
                  React.createElement(
                    'label',
                    { className: 'comPage-neutral-comment' },
                    commentNums[2]
                  ),
                  ')'
                ),
                React.createElement(
                  'label',
                  {
                    onClick: this.clickCommentLabel,
                    'data-type': '3',
                    className: 'comPage-comment-label ' + (commnetType == 3 ? 'active' : '')
                  },
                  '\u5DEE\u8BC4 (',
                  React.createElement(
                    'label',
                    { className: 'comPage-negative-comment' },
                    commentNums[3]
                  ),
                  ')'
                ),
                React.createElement(
                  'label',
                  {
                    onClick: this.clickCommentLabel,
                    'data-type': '4',
                    className: 'comPage-comment-label ' + (commnetType == 4 ? 'active' : '')
                  },
                  '\u6709\u56FE (',
                  React.createElement(
                    'label',
                    { className: 'comPage-pic-comment' },
                    commentNums[4]
                  ),
                  ')'
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'comPage-bottom-section' },
              React.createElement(
                _ScrollView.ScrollView,
                {
                  className: 'comPage-comment-list',
                  'scroll-y': 'true',
                  bindscrolltolower: this.scrollLoadComment
                },
                comments.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { className: 'comPage-comment-item', key: index },
                    React.createElement(
                      'div',
                      null,
                      React.createElement('img', {
                        className: 'comPage-comment-photo',
                        src: item.buyer_headimgurl
                      }),
                      React.createElement(
                        'span',
                        { className: 'comPage-comment-name' },
                        item.buyer_nickname
                      )
                    ),
                    React.createElement(
                      'span',
                      { className: 'comPage-comment-date' },
                      item.add_time
                    ),
                    React.createElement(
                      'div',
                      { className: 'comPage-comment-content' },
                      item.assess_info.content
                    ),
                    item.assess_info.has_img && React.createElement(
                      'div',
                      { className: 'comPage-comment-pics' },
                      item.assess_info.img_arr.map(function (imgSrc, index) {
                        return React.createElement('img', {
                          key: index,
                          src: imgSrc,
                          'data-src': imgSrc,
                          'data-srcarr': JSON.stringify(item.assess_info.img_arr),
                          onClick: _this2.clickPlusImages
                        });
                      })
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);
  return ToStoreComment;
}(_OfficialPage3.default);

exports.default = ToStoreComment;

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(605);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MakeToStoreComment = function (_OfficialPage) {
  (0, _inherits3.default)(MakeToStoreComment, _OfficialPage);

  function MakeToStoreComment(props) {
    (0, _classCallCheck3.default)(this, MakeToStoreComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MakeToStoreComment.__proto__ || Object.getPrototypeOf(MakeToStoreComment)).call(this, props));

    _this.state = {
      goodsInfo: [],
      submitData: {
        order_id: '',
        goods: [],
        tostore_score: 5,
        tostore_environment_score: 5,
        tostore_seller_serve_score: 5
      }
    };

    _this.getOrderDetail = function () {
      var that = _this;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.submitData.order_id,
          sub_shop_app_id: _this.data.submitData.sub_shop_app_id
        },
        success: function success(res) {
          var goodsInfo = res.data[0].form_data.goods_info,
              goods = [];
          for (var i = 0, j = goodsInfo.length - 1; i <= j; i++) {
            goods.push({
              goods_id: goodsInfo[i].goods_id,
              info: {
                content: '',
                level: 1,
                img_arr: []
              }
            });
          }
          that.setData({
            goodsInfo: goodsInfo,
            'submitData.goods': goods
          });
        }
      });
    };

    _this.setTostoreScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.tostore_score': score
      });
    };

    _this.setTostoreEnvironmentScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.tostore_environment_score': score
      });
    };

    _this.setTostoreSellerServeScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.tostore_seller_serve_score': score
      });
    };

    _this.clickLevelSpan = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          level = e.currentTarget.dataset.level,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.level'] = level;
      _this.setData(data);
    };

    _this.commentInput = function (e) {
      var goodsIndex = e.target.dataset.goodsIndex,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.content'] = e.target.value;
      _this.setData(data);
    };

    _this.chooseImage = function (e) {
      var that = _this,
          goodsIndex = e.currentTarget.dataset.goodsIndex,
          img_arr = that.data.submitData.goods[goodsIndex].info.img_arr;
      if (img_arr.length >= 3) {
        _app.appMethod.showModal({
          content: '每个商品最多上传3张图片'
        });
        return;
      }
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr.concat(images);
        that.setData(data);
      }, 3 - img_arr.length);
    };

    _this.removePic = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          picIndex = e.currentTarget.dataset.picIndex,
          img_arr = _this.data.submitData.goods[goodsIndex].info.img_arr,
          data = {};
      img_arr.splice(picIndex, 1);
      data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr;
      _this.setData(data);
    };

    _this.makeComment = function () {
      var that = _this,
          submitData = that.data.submitData,
          modalText = '';
      for (var i = submitData.goods.length - 1; i >= 0; i--) {
        var goods = submitData.goods[i];
        if (!goods.info.level) {
          modalText = '尚未给商品评分';
          break;
        }
        if (goods.info.img_arr.length > 3) {
          modalText = '每个商品最多上传3张图片';
          break;
        }
      }
      if (modalText) {
        _app.appMethod.showModal({
          content: modalText
        });
        return;
      }
      var addTime = Date.now();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/AddAssessList',
        method: 'post',
        data: submitData,
        success: function success(res) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.status == 0) {
                _app.appMethod.showModal({
                  content: '评论成功',
                  confirm: function confirm() {
                    _app.appMethod.turnBack();
                  }
                });
              } else {
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: 'turnBack'
                  }
                });
              }
            }
          });
        }
      });
    };

    document.title = '评价';
    return _this;
  }

  (0, _createClass3.default)(MakeToStoreComment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        'submitData.order_id': options.detail,
        'submitData.sub_shop_app_id': options.franchisee || ''
      });
      this.getOrderDetail();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          goodsInfo = _state.goodsInfo,
          submitData = _state.submitData;

      return React.createElement(
        'div',
        { className: 'official-page make-to-store-comment' },
        React.createElement(_TopNav.TopNav, { title: '\u8BC4\u4EF7' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'makeCom-wrap page', id: 'makeComment' },
            goodsInfo.map(function (item, goodsIndex) {
              return React.createElement(
                'div',
                { className: 'makeCom-item makeCom-goods-comment', key: goodsIndex },
                React.createElement(
                  'div',
                  null,
                  React.createElement('img', {
                    className: 'makeCom-goods-cover',
                    src: item.cover
                  }),
                  React.createElement('textarea', {
                    'data-goods-index': goodsIndex,
                    onInput: _this2.commentInput,
                    className: 'makeCom-textarea',
                    placeholder: '\u5199\u4E0B\u8D2D\u4E70\u4F53\u4F1A\u4E3A\u5176\u4ED6\u5C0F\u4F19\u4F34\u63D0\u4F9B\u53C2\u8003'
                  })
                ),
                React.createElement(
                  'div',
                  { className: 'makeCom-pic-container' },
                  submitData.goods[goodsIndex].info.img_arr.map(function (imgUrl, index) {
                    return React.createElement(
                      'div',
                      { key: index, className: 'makeCom-pic-wrap' },
                      React.createElement('img', { src: imgUrl, mode: 'aspectFit' }),
                      React.createElement(
                        'label',
                        {
                          className: 'makeCom-remove-pic',
                          onClick: _this2.removePic,
                          'data-goods-index': goodsIndex,
                          'data-pic-index': index
                        },
                        '\xD7'
                      )
                    );
                  }),
                  React.createElement(
                    'div',
                    {
                      className: 'makeCom-upload-pic',
                      onClick: _this2.chooseImage,
                      'data-goods-index': goodsIndex
                    },
                    React.createElement(
                      'div',
                      null,
                      '\uFF0B'
                    ),
                    React.createElement(
                      'span',
                      null,
                      '\u6DFB\u52A0\u56FE\u7247'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'makeCom-level-container' },
                  React.createElement(
                    'label',
                    {
                      className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 1 ? 'active' : ''),
                      'data-level': '1',
                      'data-goods-index': goodsIndex,
                      onClick: _this2.clickLevelSpan
                    },
                    React.createElement('label', { className: 'ico-moon icon-tostoreGoodComment' }),
                    '\u597D\u8BC4'
                  ),
                  React.createElement(
                    'label',
                    {
                      className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 2 ? 'active' : ''),
                      'data-level': '2',
                      'data-goods-index': goodsIndex,
                      onClick: _this2.clickLevelSpan
                    },
                    React.createElement('label', { className: 'ico-moon icon-tostoreMiddleComment' }),
                    '\u4E2D\u8BC4'
                  ),
                  React.createElement(
                    'label',
                    {
                      className: 'makeCom-level-span ' + (submitData.goods[goodsIndex].info.level == 3 ? 'active' : ''),
                      'data-level': '3',
                      'data-goods-index': goodsIndex,
                      onClick: _this2.clickLevelSpan
                    },
                    React.createElement('label', { className: 'ico-moon icon-tostoreBadComment' }),
                    '\u5DEE\u8BC4'
                  )
                )
              );
            }),
            React.createElement(
              'div',
              {
                className: 'makeCom-item',
                style: (0, _tools.convertLineStyleData)('padding:10px; line-height:30px;')
              },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('font-size:16px;') },
                '\u5E97\u94FA\u8BC4\u5206'
              ),
              React.createElement(
                'div',
                null,
                '\u63CF\u8FF0\u76F8\u7B26\uFF1A',
                React.createElement(
                  'div',
                  { className: 'makeCom-mark-container makeCom-fit-score' },
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_score >= 1 ? '' : '-empty'),
                    'data-score': '1',
                    onClick: this.setTostoreScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_score >= 2 ? '' : '-empty'),
                    'data-score': '2',
                    onClick: this.setTostoreScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_score >= 3 ? '' : '-empty'),
                    'data-score': '3',
                    onClick: this.setTostoreScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_score >= 4 ? '' : '-empty'),
                    'data-score': '4',
                    onClick: this.setTostoreScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_score >= 5 ? '' : '-empty'),
                    'data-score': '5',
                    onClick: this.setTostoreScore
                  })
                )
              ),
              React.createElement(
                'div',
                null,
                '\u5E97\u94FA\u73AF\u5883\uFF1A',
                React.createElement(
                  'div',
                  { className: 'makeCom-mark-container makeCom-logistics-score' },
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_environment_score >= 1 ? '' : '-empty'),
                    'data-score': '1',
                    onClick: this.setTostoreEnvironmentScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_environment_score >= 2 ? '' : '-empty'),
                    'data-score': '2',
                    onClick: this.setTostoreEnvironmentScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_environment_score >= 3 ? '' : '-empty'),
                    'data-score': '3',
                    onClick: this.setTostoreEnvironmentScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_environment_score >= 4 ? '' : '-empty'),
                    'data-score': '4',
                    onClick: this.setTostoreEnvironmentScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_environment_score >= 5 ? '' : '-empty'),
                    'data-score': '5',
                    onClick: this.setTostoreEnvironmentScore
                  })
                )
              ),
              React.createElement(
                'div',
                null,
                '\u5546\u5BB6\u670D\u52A1\uFF1A',
                React.createElement(
                  'div',
                  { className: 'makeCom-mark-container makeCom-logistics-score' },
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_seller_serve_score >= 1 ? '' : '-empty'),
                    'data-score': '1',
                    onClick: this.setTostoreSellerServeScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_seller_serve_score >= 2 ? '' : '-empty'),
                    'data-score': '2',
                    onClick: this.setTostoreSellerServeScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_seller_serve_score >= 3 ? '' : '-empty'),
                    'data-score': '3',
                    onClick: this.setTostoreSellerServeScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_seller_serve_score >= 4 ? '' : '-empty'),
                    'data-score': '4',
                    onClick: this.setTostoreSellerServeScore
                  }),
                  React.createElement('label', {
                    className: 'ico-moon icon-star' + (submitData.tostore_seller_serve_score >= 5 ? '' : '-empty'),
                    'data-score': '5',
                    onClick: this.setTostoreSellerServeScore
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'makeCom-bottom-nav', onClick: this.makeComment },
              React.createElement(
                'label',
                { className: 'makeCom-make-comment btn btn-orange' },
                '\u53D1\u8868\u8BC4\u4EF7'
              )
            )
          )
        )
      );
    }
  }]);
  return MakeToStoreComment;
}(_OfficialPage3.default);

exports.default = MakeToStoreComment;

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(607);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var price = {
  price: function price(a, b) {
    var c = (a * b).toFixed(2);
    return c;
  }
};

var PreviewTakeoutOrder = function (_OfficialPage) {
  (0, _inherits3.default)(PreviewTakeoutOrder, _OfficialPage);

  function PreviewTakeoutOrder(props) {
    (0, _classCallCheck3.default)(this, PreviewTakeoutOrder);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PreviewTakeoutOrder.__proto__ || Object.getPrototypeOf(PreviewTakeoutOrder)).call(this, props));

    _this2.state = {
      takeoutShopName: '',
      takeoutShopImg: '',
      goodsList: [],
      selectAddress: {},
      discountList: [],
      selectDiscountInfo: {},
      selectDiscountIndex: '',
      orderRemark: '',
      is_self_delivery: 0,
      express_fee: '',
      balance: '',
      useBalance: true,
      deduction: '',
      discount_cut_price: '',
      original_price: '',
      totalPayment: '',
      shopAddress: '',
      noAdditionalInfo: true,
      fullTimeList: [],
      leagueBenefitList: [], // 联盟优惠券列表
      selectedLeagueBenefitInfo: {}, // 选中的联盟优惠券
      selectedLeagueBenefitIndex: -1, // 联盟优惠下标
      leagueBenefitPrice: '' // 联盟优惠券优惠价格
    };
    _this2.isFromBack = false;
    _this2.franchisee_id = '';
    _this2.cart_id_arr = [];
    _this2.cart_data_arr = [];
    _this2.requesting = false;
    _this2.additional_info = {};
    _this2.takeoutShopInfo = {};

    _this2.dataInitial = function () {
      _this2.getCalculationInfo();
      _this2.getShopAddress();
      _this2.getCartList();
    };

    _this2.getTakeoutShopInfo = function (successFn) {
      var that = _this2;
      var franchiseeId = that.franchisee_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getTakeOutInfo',
        data: {
          sub_app_id: franchiseeId
        },
        success: function success(res) {
          that.setData({
            takeoutInfo: res.data
          });
          typeof successFn == 'function' && successFn(res);
        }
      });
    };

    _this2.getCartList = function () {
      var that = _this2,
          franchisee_id = _this2.franchisee_id;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: franchisee_id,
          parent_shop_app_id: franchisee_id ? _app.appMethod.globalData.appId : ''
        },
        success: function success(res) {
          var data = [];
          if (that.cart_id_arr.length) {
            for (var i = 0; i <= res.data.length - 1; i++) {
              if (that.cart_id_arr.indexOf(res.data[i].id) >= 0) {
                data.push(res.data[i]);
              }
            }
          } else {
            data = res.data;
          }
          for (var i = 0; i <= data.length - 1; i++) {
            var goods = data[i],
                modelArr = goods.model_value;
            goods.model_value_str = modelArr && modelArr.join ? '(' + modelArr.join('|') + ')' : '';
            that.cart_data_arr.push({
              cart_id: goods.id,
              goods_id: goods.goods_id,
              model_id: goods.model_id,
              num: goods.num
            });
          }
          that.setData({
            goodsList: data,
            takeoutShopName: res.take_out_info.title,
            takeoutShopImg: res.take_out_info.cover
          });
        }
      });
    };

    _this2.getCalculationInfo = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: {
          sub_shop_app_id: _this2.franchisee_id,
          address_id: _this2.data.selectAddress.id || _app.appMethod.globalData.takeoutLocate.id,
          cart_id_arr: _this2.cart_id_arr,
          is_balance: _this2.data.useBalance ? 1 : 0,
          is_self_delivery: _this2.data.is_self_delivery,
          selected_benefit: _this2.data.selectDiscountInfo,
          superimposed: _this2.isFranchisee ? 1 : 0,
          extra_selected_benefit: _this2.data.selectedLeagueBenefitInfo
        },
        success: function success(res) {
          if (res.status === 0) {
            var info = res.data,
                benefits = info.can_use_benefit.data,
                goods_info = info.goods_info,
                additional_info_goods = [],
                additional_goodsid_arr = [],
                selectDiscountIndex,
                selectDiscountInfo,
                arriveTime = new Date().getTime() + res.data.deliver_time * 60000,
                arriveTimeList = [],
                endTime = _this.takeoutShopInfo.business_time[_this.takeoutShopInfo.business_time.length - 1].end_time + '',
                newData = {};
            arriveTimeList = _this.timeList(arriveTime, endTime);
            if (benefits.length) {
              benefits.unshift({
                title: '不使用优惠',
                name: '无',
                no_use_benefit: 1
              });
            }
            if (_this.data.selectDiscountInfo && _this.data.selectDiscountInfo.no_use_benefit == 1) {
              selectDiscountInfo = _this.data.selectDiscountInfo;
              selectDiscountIndex = 0;
            } else {
              selectDiscountInfo = info.selected_benefit_info;
              if (selectDiscountInfo && selectDiscountInfo.discount_type) {
                for (var i = 0; i <= benefits.length - 1; i++) {
                  if (selectDiscountInfo.discount_type === benefits[i].discount_type) {
                    if (selectDiscountInfo.discount_type === 'coupon') {
                      if (selectDiscountInfo.coupon_id === benefits[i].coupon_id) {
                        selectDiscountIndex = i;
                        break;
                      }
                    } else {
                      selectDiscountIndex = i;
                      break;
                    }
                  }
                }
              }
            }
            for (var i = 0; i <= goods_info.length - 1; i++) {
              if (goods_info[i].delivery_id && goods_info[i].delivery_id != 0 && additional_goodsid_arr.indexOf(goods_info[i].id) == -1) {
                additional_goodsid_arr.push(goods_info[i].id);
                additional_info_goods.push(goods_info[i]);
              }
            }
            var shopInfo = _this.takeoutShopInfo;
            if (_app.appMethod.globalData.takeoutAddressSelected && !info.address) {
              info.address = _app.appMethod.globalData.takeoutAddressSelected;
            }
            if (info.address.latitude) {
              info.address.is_distance = _app.appMethod.calculationDistanceByLatLng(shopInfo.latitude, shopInfo.longitude, info.address.latitude, info.address.longitude) < shopInfo.deliver_distance ? 1 : 0;
            } else {
              info.address = {};
            }
            newData['disablePay'] = info.is_take_deliver;
            newData['selectAddress'] = info.address;
            newData['discountList'] = benefits;
            newData['selectDiscountIndex'] = selectDiscountIndex || '';
            newData['selectDiscountInfo'] = selectDiscountInfo;
            newData['express_fee'] = info.deliver_fee;
            newData['discount_cut_price'] = +info.discount_cut_price || 0;
            newData['balance'] = info.balance;
            newData['deduction'] = info.use_balance;
            newData['original_price'] = info.original_price;
            newData['totalPayment'] = info.price;
            newData['takeoutShopName'] = _this.takeoutShopInfo.title;
            newData['takeoutShopImg'] = _this.takeoutShopInfo.cover;
            newData['noAdditionalInfo'] = additional_info_goods.length ? false : true;
            newData['arriveTime'] = _this.formatDate(arriveTime);
            newData['arriveTimeList'] = arriveTimeList;
            newData['box_fee'] = info.box_fee;
            newData['totalDiscountCutPrice'] = +info.total_benefit_price || 0;
            if (_this.isFranchisee) {
              // 联盟优惠
              var leagueBenefitList = info.extra_can_use_benefit.data,
                  selectedLeagueBenefitIndex = '',
                  selectedLeagueBenefitInfo = void 0;
              if (leagueBenefitList && leagueBenefitList.length) {
                leagueBenefitList.unshift({
                  title: '不使用优惠',
                  name: '无',
                  no_use_benefit: 1
                });
              }
              if (_this.data.selectedLeagueBenefitInfo && _this.data.selectedLeagueBenefitInfo.no_use_benefit) {
                selectedLeagueBenefitInfo = _this.data.selectedLeagueBenefitInfo;
                selectedLeagueBenefitIndex = 0;
              } else {
                selectedLeagueBenefitInfo = info.extra_selected_benefit;
                if (selectedLeagueBenefitInfo && selectedLeagueBenefitInfo.discount_type) {
                  leagueBenefitList.forEach(function (coupon, index) {
                    if (selectedLeagueBenefitInfo.discount_type === coupon.discount_type) {
                      if (selectedLeagueBenefitInfo.discount_type === 'coupon') {
                        if (selectedLeagueBenefitInfo.coupon_id == coupon.coupon_id) {
                          selectedLeagueBenefitIndex = index;
                        }
                      }
                    } else {
                      selectedLeagueBenefitIndex = index;
                    }
                  });
                }
              }
              newData['leagueBenefitList'] = leagueBenefitList;
              newData['selectedLeagueBenefitIndex'] = selectedLeagueBenefitIndex;
              newData['selectedLeagueBenefitInfo'] = selectedLeagueBenefitInfo;
              newData['leagueBenefitPrice'] = +info.extra_discount_cut_price || 0;
            }
            _this.setData(newData);
            _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          }
        },
        complete: function complete(res) {
          if (res.status === 1) {
            _this.setData({
              selectAddress: {}
            });
          }
        }
      });
    };

    _this2.getShopAddress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        success: function success(res) {
          that.setData({
            shopAddress: res.data
          });
        }
      });
    };

    _this2.remarkInput = function (e) {
      var value = e.target.value;
      if (value.length > 30) {
        value = value.slice(0, 30);
      }
      _this2.setData({
        orderRemark: value
      });
    };

    _this2.previewImage = function (e) {
      _app.appMethod.previewImage({
        current: e.currentTarget.dataset.src
      });
    };

    _this2.clickMinusButton = function (e) {
      var index = e.currentTarget.dataset.index,
          goods = _this2.data.goodsList[index];
      if (+goods.num <= 0) return;
      _this2.changeGoodsNum(index, 'minus');
    };

    _this2.clickPlusButton = function (e) {
      var index = e.currentTarget.dataset.index;
      _this2.changeGoodsNum(index, 'plus');
    };

    _this2.changeGoodsNum = function (index, type) {
      var goods = _this2.data.goodsList[index],
          currentNum = +goods.num,
          targetNum = type == 'plus' ? currentNum + 1 : currentNum - 1,
          that = _this2,
          data = {},
          param;
      if (targetNum == 0 && type == 'minus') {
        _app.appMethod.showModal({
          content: '确定从购物车删除该商品？',
          showCancel: true,
          confirm: function confirm() {
            that.cart_data_arr[index].num = targetNum;
            data['goodsList[' + index + '].num'] = targetNum;
            that.setData(data);
            that.deleteGoods(index);
          }
        });
        return;
      }
      that.cart_data_arr[index].num = targetNum;
      data['goodsList[' + index + '].num'] = targetNum;
      that.setData(data);
      param = {
        goods_id: goods.goods_id,
        model_id: goods.model_id || '',
        num: targetNum,
        sub_shop_app_id: that.franchisee_id
      };
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          that.getCalculationInfo();
        },
        fail: function fail(res) {
          data = {};
          that.cart_data_arr[index].num = currentNum;
          data['goodsList[' + index + '].num'] = currentNum;
          that.setData(data);
        }
      });
    };

    _this2.deleteGoods = function (index) {
      var goodsList = _this2.data.goodsList,
          that = _this2,
          listExcludeDelete;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/deleteCart',
        method: 'post',
        data: {
          cart_id_arr: [_this2.cart_data_arr[index].cart_id],
          sub_shop_app_id: _this2.franchisee_id
        },
        success: function success(res) {
          ;(listExcludeDelete = goodsList.concat([])).splice(index, 1);
          if (listExcludeDelete.length == 0) {
            _app.appMethod.turnBack();
            return;
          }
          var deleteGoodsId = goodsList[index],
              noSameGoodsId = true;
          for (var i = listExcludeDelete.length - 1; i >= 0; i--) {
            if (listExcludeDelete[i].id == deleteGoodsId) {
              noSameGoodsId = false;
              break;
            }
          }
          if (noSameGoodsId) {
            delete that.additional_info[deleteGoodsId];
          }
          that.cart_data_arr.splice(index, 1);
          that.setData({
            goodsList: listExcludeDelete
          });
          that.getCalculationInfo();
        }
      });
    };

    _this2.confirmPayment = function (e) {
      var list = _this2.data.goodsList,
          that = _this2,
          selected_benefit = _this2.data.selectDiscountInfo,
          selectedLeagueBenefitInfo = _this2.data.selectedLeagueBenefitInfo,
          hasWritedAdditionalInfo = false;
      if (_this2.data.is_self_delivery == 0 && _this2.data.selectAddress.is_distance == 0 || !_this2.data.selectAddress.id || _this2.data.selectAddress.is_distance == 0) {
        _app.appMethod.showModal({
          content: '请选择地址'
        });
        return;
      }
      for (var key in _this2.additional_info) {
        if (key !== undefined) {
          hasWritedAdditionalInfo = true;
          break;
        }
      }
      if (_this2.requesting) {
        return;
      }
      _this2.requesting = true;
      var utc = new Date().getTimezoneOffset() / 60;
      var time_difference = 8 + utc;
      var timezone_name = utc > 0 ? '西' + utc + '区' : '东' + utc * -1 + '区';
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCartOrder',
        method: 'post',
        data: {
          cart_arr: that.cart_data_arr,
          formId: e.target.formId,
          sub_shop_app_id: that.franchisee_id,
          selected_benefit: selected_benefit,
          is_balance: that.data.useBalance ? 1 : 0,
          is_self_delivery: that.data.is_self_delivery,
          remark: that.data.orderRemark,
          address_id: that.data.selectAddress.id,
          additional_info: that.additional_info,
          takeout_appointment_arrive_time: that.data.arriveTime,
          time_difference: time_difference,
          timezone_name: timezone_name,
          superimposed: that.isFranchisee ? 1 : 0,
          is_multi: that.isFranchisee ? 1 : 0,
          extra_selected_benefit: that.data.selectedLeagueBenefitInfo
        },
        success: function success(res) {
          _app.appMethod.globalData.takeoutRefresh = true;
          that.payOrder(res.data);
        },
        complete: function complete() {
          that.requesting = false;
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var that = _this2;
      function paySuccess() {
        var pagePath = '/orderMeal/pages/takeoutOrderDetail/takeoutOrderDetail?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : '');
        _app.appMethod.turnToPage(pagePath, 1);
      }
      function payFail() {
        _app.appMethod.turnToPage('/orderMeal/pages/takeoutOrderDetail/takeoutOrderDetail?detail=' + orderId + (that.franchisee_id ? '&franchisee=' + that.franchisee_id : ''), 1);
      }
      if (_this2.data.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          },
          successStatusAbnormal: function successStatusAbnormal() {
            payFail();
          }
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        data: {
          order_id: orderId
        },
        success: function success(res) {
          var param = res.data;
          param.orderId = orderId;
          param.goodsType = 2;
          param.success = paySuccess;
          param.fail = payFail;
          that.wxPay(param);
        },
        fail: function fail() {
          payFail();
        },
        successStatusAbnormal: function successStatusAbnormal() {
          payFail();
        }
      });
    };

    _this2.wxPay = function (param) {
      var that = _this2;
      _app.appMethod.requestPayment({
        timeStamp: param.timeStamp,
        nonceStr: param.nonceStr,
        package: param.package,
        signType: param.signType,
        paySign: param.paySign,
        success: function success(res) {
          _this2.isFromBack = false;
          _app.appMethod.wxPaySuccess(param);
          param.success();
        },
        fail: function fail(res) {
          if (res.errMsg === 'requestPayment:fail cancel') {
            _app.appMethod.showModal({
              content: '支付已取消',
              complete: param.fail
            });
            return;
          }
          _app.appMethod.showModal({
            content: '支付失败',
            complete: param.fail
          });
          _app.appMethod.wxPayFail(param, res.errMsg);
        }
      });
    };

    _this2.discountChange = function (e) {
      var index = e[0];
      _this2.setData({
        selectDiscountInfo: _this2.data.discountList[index],
        selectDiscountIndex: index
      });
      _this2.getCalculationInfo();
    };

    _this2.leagueDiscountChange = function (e) {
      var that = _this2;
      var index = e[0];
      setTimeout(function () {
        that.setData({
          selectedLeagueBenefitInfo: that.data.leagueBenefitList[index],
          selectDiscountIndex: index
        });
        that.getCalculationInfo();
      }, 500);
    };

    _this2.goToMyAddress = function () {
      var addressId = _this2.data.selectAddress.id;
      _this2.isFromBack = true;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?from=previewtakeout&id=' + addressId);
    };

    _this2.showAddAddress = function () {
      var _this = _this2;
      _app.appMethod.chooseAddress({
        success: function success(res) {
          _app.appMethod.sendRequest({
            method: 'post',
            url: '/index.php?r=AppShop/AddWxAddress',
            data: {
              detailInfo: res.detailInfo || '',
              cityName: res.cityName || '',
              provinceName: res.provinceName || '',
              UserName: res.userName || '',
              telNumber: res.telNumber || '',
              district: res.district || '',
              countyName: res.countyName || ''
            },
            success: function success() {
              _this.dataInitial();
            }
          });
        }
      });
    };

    _this2.makeStorePhoneCall = function () {
      _app.appMethod.makePhoneCall(_this2.data.shopAddress.shop_contact);
    };

    _this2.openStoreLocation = function () {
      var infor = _this2.data.shopAddress.region_string + _this2.data.shopAddress.shop_location;
      infor = infor.replace(/\s/g, '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
        data: {
          location_info: infor
        },
        success: function success(res) {
          if (res.result) {
            _app.appMethod.openLocation({
              latitude: res.result.location.lat,
              longitude: res.result.location.lng
            });
          }
        }
      });
    };

    _this2.useBalanceChange = function (checked) {
      _this2.setData({
        useBalance: checked
      });
      _this2.getCalculationInfo();
    };

    _this2.deliveryWayChange = function (e) {
      _this2.setData({
        is_self_delivery: e.target.value
      });
      _this2.getCalculationInfo();
    };

    _this2.goToAdditionalInfo = function () {
      _app.appMethod.setGoodsAdditionalInfo(_this2.additional_info);
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo');
    };

    _this2.turnBackPage = function () {
      _app.appMethod.turnBack();
    };

    _this2.returnDeliveryTime = function (time) {
      var HM = (new Date(time).toISOString().split('T')[0] + ' ' + new Date(time).toTimeString().split(' ')[0]).split(' ')[1];
      HM = HM.split(':')[0] + ':' + HM.split(':')[1];
      return HM;
    };

    _this2.timeChange = function (e) {
      var index = e[0],
          that = _this2;
      _this2.setData({
        arriveTime: that.data.fullTimeList[index]
      });
    };

    _this2.timeList = function (arriveTime, endTime) {
      var arriveTimeList = [],
          arriveDeliveryTime = _this2.returnDeliveryTime(arriveTime);
      var arriveH = (arriveDeliveryTime + '').split(':')[0],
          arriveM = (arriveDeliveryTime + '').split(':')[1],
          firstTime = 0;
      if (arriveM % 15 === 0) {
        firstTime = new Date(new Date().setHours(arriveH, arriveM, 0, 0)).getTime();
      } else {
        arriveTimeList.push('尽快送达 | 预计' + arriveDeliveryTime);
        _this2.data.fullTimeList.push(_this2.formatDate(arriveTime));
        if (Math.ceil(arriveM / 15) * 15 > 60) {
          arriveH = arriveH - 0 + 1;
          firstTime = new Date(new Date().setHours(arriveH, 0, 0, 0)).getTime();
        } else {
          arriveM = Math.ceil(arriveM / 15) * 15;
          firstTime = new Date(new Date().setHours(arriveH, arriveM, 0, 0)).getTime();
        }
      }
      var timeStamp = new Date(new Date().setHours(+endTime.split(':')[0], +endTime.split(':')[1], 0, 0)).getTime() - firstTime;
      if (timeStamp > 15 * 60000) {
        var temp = Math.ceil(timeStamp / 15 / 60000);
        for (var i = 0; i < temp; i++) {
          if (i == 0 && (arriveDeliveryTime + '').split(':')[1] % 15 === 0) {
            arriveTimeList.push('尽快送达 | 预计' + _this2.returnDeliveryTime(firstTime));
            _this2.data.fullTimeList.push(_this2.formatDate(firstTime));
          } else {
            arriveTimeList.push(_this2.returnDeliveryTime(firstTime + 15 * 60000 * i));
            if (firstTime >= arriveTime) {
              _this2.data.fullTimeList.push(_this2.formatDate(firstTime + 15 * 60000 * i));
            } else {
              _this2.data.fullTimeList.push(_this2.formatDate(firstTime + 15 * 60000 * i + 24 * 60 * 60000));
            }
          }
        }
      }
      return arriveTimeList;
    };

    _this2.formatDate = function (time) {
      function add0(m) {
        return m < 10 ? '0' + m : m;
      }
      var time = new Date(time);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm);
    };

    document.title = '确认支付';
    return _this2;
  }

  (0, _createClass3.default)(PreviewTakeoutOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.franchisee_id = options.franchisee || '';
      var isFranchisee = options.isFranchisee ? true : false;
      if (!this.isFranchisee) {
        var _app$globalData = _app.appMethod.globalData,
            goodsStoreConfig = _app$globalData.goodsStoreConfig,
            hasFranchiseeList = _app$globalData.hasFranchiseeList,
            hasFranchiseeChain = _app$globalData.hasFranchiseeChain;

        if (goodsStoreConfig['cart_config'] && goodsStoreConfig['cart_config'].is_merge_shoppingcart == 1) {
          // 是否开启合并购物车
          if (hasFranchiseeList || hasFranchiseeChain) {
            isFranchisee = true;
          }
        }
      }
      this.isFranchisee = isFranchisee;
      this.cart_id_arr = options.cart_arr ? decodeURIComponent(options.cart_arr).split(',') : [];
      var that = this;
      this.getTakeoutShopInfo(function (data) {
        _app.appMethod.globalData.takeoutShopInfo = data.data;
        that.takeoutShopInfo = data.data;
        that.dataInitial();
      });
    }
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {
      if (this.isFromBack) {
        this.getCalculationInfo();
        this.isFromBack = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          is_self_delivery = _state.is_self_delivery,
          selectAddress = _state.selectAddress,
          index = _state.index,
          arriveTimeList = _state.arriveTimeList,
          arriveTime = _state.arriveTime,
          takeoutShopImg = _state.takeoutShopImg,
          takeoutShopName = _state.takeoutShopName,
          goodsList = _state.goodsList,
          box_fee = _state.box_fee,
          express_fee = _state.express_fee,
          selectDiscountIndex = _state.selectDiscountIndex,
          discountList = _state.discountList,
          selectDiscountInfo = _state.selectDiscountInfo,
          discount_cut_price = _state.discount_cut_price,
          selectedLeagueBenefitIndex = _state.selectedLeagueBenefitIndex,
          leagueBenefitList = _state.leagueBenefitList,
          selectedLeagueBenefitInfo = _state.selectedLeagueBenefitInfo,
          leagueBenefitPrice = _state.leagueBenefitPrice,
          useBalance = _state.useBalance,
          deduction = _state.deduction,
          balance = _state.balance,
          noAdditionalInfo = _state.noAdditionalInfo,
          totalDiscountCutPrice = _state.totalDiscountCutPrice,
          shopAddress = _state.shopAddress,
          totalPayment = _state.totalPayment,
          disablePay = _state.disablePay;

      // Picker组件所需格式转换

      if (Array.isArray(arriveTimeList)) {
        arriveTimeList = arriveTimeList.map(function (item, index) {
          return { label: item, value: index };
        });
      }
      if (Array.isArray(discountList)) {
        discountList = discountList.map(function (item, index) {
          return { label: item.title, value: index };
        });
      }
      if (Array.isArray(leagueBenefitList)) {
        leagueBenefitList = leagueBenefitList.map(function (item, index) {
          return { label: item.title, value: index };
        });
      }

      return React.createElement(
        'div',
        { className: 'official-page preview-takeout-order' },
        React.createElement(_TopNav.TopNav, { title: '\u786E\u8BA4\u652F\u4ED8' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'preview-goods-order-wrap', id: 'preview-goods-order' },
            React.createElement(
              'div',
              {
                className: 'preview-goods-order-section preview-address',
                hidden: is_self_delivery == 1
              },
              selectAddress.id && selectAddress.is_distance != 0 ? React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)('position:relative;margin-left:56rpx;'),
                    onClick: this.goToMyAddress,
                    'data-address-id': selectAddress.id
                  },
                  React.createElement('div', { className: 'ico-moon icon-fesadress' }),
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('font-size:30rpx;margin-bottom:18rpx;padding-right:40rpx;word-break:break-all;') },
                    selectAddress.address_info.province.text + selectAddress.address_info.city.text + selectAddress.address_info.district.text + selectAddress.address_info.detailAddress
                  ),
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('margin-bottom:30rpx;font-size:26rpx;') },
                    selectAddress.address_info.name + ' ' + selectAddress.address_info.contact
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'preview-address-options',
                      style: (0, _tools.convertLineStyleData)('top:20rpx;color:#D2D2D2;')
                    },
                    React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' })
                  )
                )
              ) : React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('position:relative;margin-left:50rpx;') },
                  React.createElement('div', {
                    className: 'ico-moon icon-fesadress',
                    style: (0, _tools.convertLineStyleData)('top:6rpx;')
                  }),
                  React.createElement('div', {
                    className: 'pull-right ico-moon icon-rightarrow',
                    style: (0, _tools.convertLineStyleData)('color:#D2D2D2;')
                  }),
                  React.createElement(
                    'div',
                    { onClick: this.goToMyAddress },
                    '\u65B0\u589E\u5730\u5740'
                  )
                )
              ),
              selectAddress.id && selectAddress.is_distance != 0 && React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)('position:relative;padding-left:56rpx;padding-top:30rpx;border-top:1px solid #f2f2f2'),
                    'data-address-id': selectAddress.id
                  },
                  React.createElement('div', { className: 'ico-moon icon-business-time' }),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      _picker2.default,
                      {
                        cols: 1,
                        style: (0, _tools.convertLineStyleData)('font-size:30rpx;'),
                        onChange: this.timeChange,
                        value: [arriveTimeList.findIndex(function (time) {
                          return time.label === arriveTime.split(' ')[1];
                        })],
                        data: arriveTimeList
                      },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('font-size:26rpx;color:#FF7100;') },
                          '大约' + arriveTime + '送达'
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'preview-address-options',
                            style: (0, _tools.convertLineStyleData)('top:30rpx;color:#D2D2D2;')
                          },
                          React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' })
                        )
                      )
                    )
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-goods-order-content' },
              React.createElement(
                'div',
                {
                  className: 'preview-goods-order-list preview-goods-order-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:0px;')
                },
                React.createElement(
                  'div',
                  {
                    className: 'preview-shop preview-goods-order-item',
                    onClick: this.turnBackPage
                  },
                  React.createElement(
                    'div',
                    { className: 'preview-shop-img fl' },
                    React.createElement('img', { src: takeoutShopImg })
                  ),
                  React.createElement(
                    'div',
                    { className: 'preview-shop-name' },
                    takeoutShopName
                  ),
                  React.createElement('div', { className: 'pull-right ico-moon icon-rightarrow' })
                ),
                goodsList.map(function (goods, goodsIndex) {
                  return React.createElement(
                    React.Fragment,
                    { key: goodsIndex },
                    React.createElement(
                      'div',
                      { className: 'preview-goods-order-item' },
                      React.createElement(
                        'div',
                        { className: 'preview-goods-img' },
                        React.createElement('img', { src: goods.cover })
                      ),
                      React.createElement(
                        'div',
                        { className: 'preview-goods-detal' },
                        React.createElement(
                          'div',
                          { className: 'preview-goods-title' },
                          goods.title
                        ),
                        !!goods.model_value_str.length && React.createElement(
                          'div',
                          { className: 'preview-goods-model' },
                          goods.model_value_str
                        ),
                        React.createElement(
                          'div',
                          { className: 'preview-goods-num' },
                          'x' + goods.num
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'preview-goods-price' },
                        React.createElement(
                          'span',
                          null,
                          '¥' + price.price(goods.price, goods.num)
                        )
                      )
                    )
                  );
                }),
                box_fee && React.createElement(
                  'div',
                  {
                    className: 'preview-goods-order-section',
                    style: (0, _tools.convertLineStyleData)('margin:0 0 1px;padding:30rpx 0;font-size:28rpx;padding-bottom:0;')
                  },
                  React.createElement(
                    'span',
                    { className: 'preview-goods-Change' },
                    '\u5305\u88C5'
                  ),
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                    '\u9910\u76D2\u8D39'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size: 24rpx;margin-right: 3px;') },
                      '\xA5'
                    ),
                    box_fee
                  )
                ),
                selectAddress.id && selectAddress.is_distance != 0 && React.createElement(
                  'div',
                  {
                    className: 'preview-goods-order-section',
                    style: (0, _tools.convertLineStyleData)('margin:0 0 1px;padding:30rpx 0;font-size:28rpx;border-bottom: 1px solid #f3f3f3;')
                  },
                  React.createElement(
                    'span',
                    { className: 'preview-goods-Change' },
                    '\u914D\u9001\u8D39'
                  ),
                  React.createElement(
                    'span',
                    { className: 'pull-right' },
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size: 24rpx;margin-right: 3px;') },
                      '\xA5'
                    ),
                    express_fee
                  )
                )
              ),
              !!discountList.length && React.createElement(
                'div',
                {
                  className: 'preview-goods-order-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:0px;padding:0 28rpx;line-height:84rpx;')
                },
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('border-bottom:1px solid #f3f3f3;') },
                  React.createElement(
                    'div',
                    {
                      className: 'preview-section-title',
                      style: (0, _tools.convertLineStyleData)('font-size:28rpx;display:inline-block;margin-bottom:0;')
                    },
                    '\u4F18\u60E0\u65B9\u5F0F'
                  ),
                  React.createElement(
                    _picker2.default,
                    {
                      cols: 1,
                      className: 'discountPicker',
                      onChange: this.discountChange,
                      value: [selectDiscountIndex],
                      data: discountList,
                      style: (0, _tools.convertLineStyleData)('margin-top:20rpx;')
                    },
                    React.createElement(
                      'div',
                      { className: 'select-discount-title' },
                      '（ ' + selectDiscountInfo.name + ' ）',
                      React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                      React.createElement(
                        'span',
                        {
                          className: 'pull-right',
                          style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#ff7100;margin-right:14rpx;'),
                          hidden: selectDiscountIndex == 0
                        },
                        '-',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('font-size: 22rpx;margin: 0 3px;') },
                          '\xA5'
                        ),
                        discount_cut_price
                      )
                    )
                  )
                )
              ),
              !!leagueBenefitList.length && React.createElement(
                'div',
                {
                  className: 'preview-goods-order-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:0px;padding:0 28rpx;line-height:84rpx;')
                },
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('border-bottom:1px solid #f3f3f3;') },
                  React.createElement(
                    'div',
                    {
                      className: 'preview-section-title',
                      style: (0, _tools.convertLineStyleData)('font-size:28rpx;display:inline-block;margin-bottom:0;')
                    },
                    '\u8054\u76DF\u4F18\u60E0'
                  ),
                  React.createElement(
                    _picker2.default,
                    {
                      cols: 1,
                      className: 'discountPicker',
                      onChange: this.leagueDiscountChange,
                      value: [selectedLeagueBenefitIndex],
                      data: leagueBenefitList,
                      style: (0, _tools.convertLineStyleData)('margin-top:20rpx;')
                    },
                    React.createElement(
                      'div',
                      { className: 'select-discount-title' },
                      '（ ' + selectedLeagueBenefitInfo.name + ' ）',
                      React.createElement('span', { className: 'pull-right ico-moon icon-rightarrow' }),
                      React.createElement(
                        'span',
                        {
                          className: 'pull-right',
                          style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#ff7100;margin-right:14rpx;'),
                          hidden: selectedLeagueBenefitIndex == 0
                        },
                        '-',
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('font-size: 22rpx;margin: 0 3px;') },
                          '\xA5'
                        ),
                        leagueBenefitPrice
                      )
                    )
                  )
                )
              ),
              balance != 0 && selectAddress.id && selectAddress.is_distance != 0 && React.createElement(
                'div',
                {
                  className: 'preview-goods-order-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:0px;padding:0;')
                },
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('margin:0 28rpx;overflow:hidden;padding:18rpx 0;border-bottom:1px solid #f3f3f3;') },
                  React.createElement(
                    'div',
                    { className: 'use-balance-option' },
                    React.createElement(
                      'span',
                      null,
                      '\u4F7F\u7528\u50A8\u503C\u91D1'
                    ),
                    React.createElement(_switch2.default, {
                      className: 'pull-right',
                      style: { transform: 'scale(.9)' },
                      checked: useBalance,
                      onChange: this.useBalanceChange
                    })
                  ),
                  React.createElement(
                    'div',
                    {
                      hidden: !useBalance,
                      className: 'select-discount-title',
                      style: (0, _tools.convertLineStyleData)('margin-top:9px;margin-bottom:-12rpx;')
                    },
                    React.createElement(
                      'span',
                      { className: 'pull-right', style: (0, _tools.convertLineStyleData)('color:#ff7100;') },
                      '- ¥' + deduction
                    )
                  )
                )
              ),
              !noAdditionalInfo && React.createElement(
                'div',
                {
                  className: 'preview-goods-order-section h84',
                  onClick: this.goToAdditionalInfo
                },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    null,
                    '\u8865\u5145\u4FE1\u606F'
                  ),
                  React.createElement('div', {
                    className: 'ico-moon icon-rightarrow pull-right',
                    style: (0, _tools.convertLineStyleData)('color:#aaa;')
                  })
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'preview-goods-order-section total-price h84',
                  style: (0, _tools.convertLineStyleData)('margin-bottom:16px;text-align:right;color:#333;font-size:26rpx')
                },
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size:28rpx;') },
                  React.createElement(
                    'span',
                    { className: 'pull-left' },
                    '\u4F18\u60E0\u603B\u91D1\u989D'
                  ),
                  '¥' + (totalDiscountCutPrice || '0')
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'preview-goods-order-section preview-goods-words h84' },
              React.createElement(
                'span',
                { className: 'preview-section-title', style: (0, _tools.convertLineStyleData)('font-size:28rpx;') },
                '\u5907\u6CE8:'
              ),
              React.createElement('input', {
                onInput: this.remarkInput,
                onChange: function onChange() {},
                maxLength: '30',
                placeholder: '\u8BF7\u586B\u5199\u60A8\u7684\u5907\u6CE8\u4FE1\u606F'
              })
            ),
            React.createElement(
              'div',
              {
                className: 'preview-goods-order-section',
                hidden: is_self_delivery == 0
              },
              React.createElement(
                'div',
                { onClick: this.openStoreLocation },
                React.createElement('label', { className: 'ico-moon icon-location' }),
                shopAddress.region_string + shopAddress.shop_location
              ),
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('margin:12px 0;'), onClick: this.makeStorePhoneCall },
                React.createElement('label', { className: 'ico-moon icon-phone' }),
                shopAddress.shop_contact
              )
            ),
            React.createElement(
              'div',
              { className: 'bottom-nav' },
              selectAddress.id && selectAddress.is_distance != 0 ? React.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                React.createElement(
                  'span',
                  {
                    className: 'price-count',
                    style: (0, _tools.convertLineStyleData)('font-weight: 500;font-size: 30rpx;')
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('margin-right: 3px;') },
                    '\xA5'
                  ),
                  totalPayment
                ),
                React.createElement(
                  'span',
                  { className: 'bottom-nav-line' },
                  '|'
                ),
                React.createElement(
                  'span',
                  { className: 'bottom-nav-discount' },
                  '已优惠¥' + totalDiscountCutPrice
                )
              ) : React.createElement(
                'div',
                { className: 'preview-goods-total-price' },
                React.createElement(
                  'span',
                  {
                    className: 'price-count',
                    style: (0, _tools.convertLineStyleData)('font-weight: 500;font-size: 30rpx;')
                  },
                  '\u8BF7\u5148\u9009\u62E9\u5730\u5740'
                )
              ),
              React.createElement(
                'form',
                null,
                React.createElement(
                  'button',
                  {
                    type: 'button',
                    disabled: disablePay ? false : true,
                    onClick: this.confirmPayment,
                    style: (0, _tools.convertLineStyleData)('font-size:30rpx;')
                  },
                  '\u53BB\u652F\u4ED8'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PreviewTakeoutOrder;
}(_OfficialPage3.default);

exports.default = PreviewTakeoutOrder;

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _Map = __webpack_require__(104);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(609);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TakeoutOrderDetail = function (_OfficialPage) {
  (0, _inherits3.default)(TakeoutOrderDetail, _OfficialPage);

  function TakeoutOrderDetail(props) {
    (0, _classCallCheck3.default)(this, TakeoutOrderDetail);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TakeoutOrderDetail.__proto__ || Object.getPrototypeOf(TakeoutOrderDetail)).call(this, props));

    _this2.state = {
      orderData: {},
      orderInfo: {},
      orderStatus: {
        '0': '待付款',
        '1': '待发货',
        '2': '待收货',
        '3': '待评价',
        '4': '退款审核中',
        '5': '退款中',
        '6': '已完成',
        '7': '已关闭',
        '8': '外卖未接单'
      },
      orderStatusText: [{ name: '待付款剩余时间:', orderName: '请在提交订单20分钟内完成付款' }, { name: '待商家安排配送', orderName: '预计送达时间：' }, { name: '配送中', orderName: '预计送达时间：' }, { name: '订单待评价', orderName: '感谢您的信任，期待下次光临' }, { name: '退款审核中', orderName: '你已成功发起退款，请耐心等待商家处理' }, { name: '退款中', orderName: '订单退款中' }, { name: '订单已完成', orderName: '感谢您的信任，期待下次光临' }, { name: '已关闭', orderName: '订单已取消' }, { name: '等待商家接单', orderName: '20分钟商家未接单，订单将自动取消' }],
      transportStatus: {
        0: '待创建',
        1: '待骑手接单',
        2: '骑手已接单', //蜂鸟已分配骑手
        3: '骑手配送中',
        4: '骑手配送已完成',
        5: '已取消',
        7: '已过期',
        8: '指派单',
        9: '妥投异常之物品返回中',
        10: '妥投异常之物品返回完成',
        11: '骑手已到店',
        12: '申请取消配送',
        1000: '订单异常'
      },
      selectAddressId: '',
      goodsAdditionalInfo: {},
      hasAdditionalInfo: false,
      customFields: [],
      orderId: '',
      isFromTemplateMsg: false,
      originalPrice: '',
      useBalance: '',
      freightAdress: {},
      express_fee: '',
      discount_cut_price: '',
      isFromBack: false,
      marker: [{
        latitude: 0,
        longitude: 0,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }],
      ismore: false,
      isShowInstruction: false
    };

    _this2.onPullDownRefresh = function () {
      _this2.dataInitial();
    };

    _this2.mapDetail = function (e) {
      var dataset = e.currentTarget.dataset,
          marker = [{
        latitude: dataset.lat,
        longitude: dataset.lng,
        iconPath: '/images/transport.png',
        width: 75,
        height: 75
      }];
      _app.appMethod.turnToPage('/default/pages/mapDetail/mapDetail?eventParams=' + JSON.stringify(marker));
    };

    _this2.canvas = function (acceptTime, needTime) {
      var nowTime = new Date().getTime(),
          winWidth = _app.appMethod.getSystemInfoSync().windowWidth / 750;
      // TODO createCanvasContext
      //   ctx = app.createCanvasContext('canvasArcCir'),
      //   x = 80 * winWidth,
      //   y = 80 * winWidth,
      //   radius = 65 * winWidth,
      //   gradient = ctx.createLinearGradient(0, 0 * winWidth, 0, 160 * winWidth),
      //   angle =
      //     (((nowTime / 1000 - acceptTime) / 60 / needTime) * 2 - 0.5) * Math.PI
      // this.setData({
      //   isOverTime:
      //     (nowTime / 1000 - acceptTime) / 60 / needTime > 1 ? true : false,
      //   deliveryTime: acceptTime
      //     ? this.returnDeliveryTime(acceptTime, needTime)
      //     : ''
      // })
      // gradient.addColorStop('0', '#FF5900')
      // gradient.addColorStop('0.5', '#FFA156')
      // gradient.addColorStop('1', '#FF8838')
      // if (acceptTime) {
      //   ctx.draw()
      //   ctx.setTextAlign('center')
      //   ctx.setTextBaseline('bottom')
      //   ctx.setFontSize(36 * winWidth)
      //   ctx.fillText(
      //     this.returnDeliveryTime(acceptTime, needTime),
      //     x,
      //     90 * winWidth
      //   )
      //   ctx.setTextBaseline('top')
      //   ctx.setFontSize(21 * winWidth)
      //   ctx.setFillStyle('#a3a3a3')
      //   ctx.fillText('预计送达', x, 90 * winWidth)
      // } else {
      //   ctx.save()
      //   ctx.beginPath()
      //   ctx.arc(x, y, 55 * winWidth, 0, 2 * Math.PI)
      //   ctx.clip()
      //   ctx.drawImage(
      //     'http://img.weiye.me/tmp_file/df5be6203a516ea94b792b357551fbe81.png',
      //     15 * winWidth,
      //     15 * winWidth,
      //     130 * winWidth,
      //     130 * winWidth
      //   )
      //   ctx.restore()
      // }
      // ctx.setLineWidth(12 * winWidth)
      // ctx.setStrokeStyle(gradient)
      // ctx.setLineCap('round')
      // ctx.beginPath()
      // ctx.arc(x, y, radius, 1.5 * Math.PI, angle, true)
      // ctx.stroke()
      // ctx.draw()
    };

    _this2.getGoldenData = function (id) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
        method: 'post',
        data: {
          order_id: id,
          sub_app_id: that.data.franchiseeId
        },
        success: function success(data) {
          if (data.integral) {
            //支付获取积分
            that.setData({
              rewardPointObj: {
                showModal: true,
                count: data.integral,
                callback: ''
              }
            });
          }
        }
      });
    };

    _this2.makePhoneCall = function (e) {
      var phone = e.currentTarget.dataset.phone;
      _app.appMethod.makePhoneCall(phone);
    };

    _this2.dataInitial = function () {
      _this2.getTakeOutInfo();
      _this2.getOrderDetail(_this2.data.orderId);
      _this2.initialAddressId();
    };

    _this2.turnToOrderTracking = function () {
      _app.appMethod.turnToPage('/orderMeal/pages/orderTracking/orderTracking?orderId=' + _this2.data.orderId);
    };

    _this2.getOrderStatus = function (orderId) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/queryTransporterInfo',
        data: {
          order_id: orderId
        },
        success: function success(res) {
          var newdata = {};
          newdata['marker[0].latitude'] = res.data.transporter_latitude;
          newdata['marker[0].longitude'] = res.data.transporter_longitude;
          newdata['transporterInfo'] = res.data;
          that.setData(newdata);
        }
      });
    };

    _this2.getOrderDetail = function (orderId) {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getOrder',
        data: {
          order_id: orderId,
          sub_shop_app_id: _this2.data.franchiseeId,
          is_get_indemnity_order: 1,
          is_buyer: 1,
          not_get_takeout: 1
        },
        success: function success(res) {
          var data = res.data[0],
              form_data = data.form_data,
              hasAdditionalInfo = false,
              additional_info_goods = [],
              additional_goodsid_arr = [],
              address_id = '';
          if (form_data.status != 0) {
            that.getGoldenData(orderId);
            if (form_data.status == 2 && form_data.take_out_info.deliver_type != 0 && form_data.take_out_info.deliver_type != '' && (form_data.take_out_transport_order.status == 2 || form_data.take_out_transport_order.status == 3 || form_data.take_out_transport_order.status == 11)) {
              that.getOrderStatus(that.data.orderId);
            }
          }
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id,
                goodsId = form_data.goods_info[i].goods_id;
            if (deliveryId && deliveryId != '0' && additional_goodsid_arr.indexOf(goodsId) == -1) {
              additional_info_goods.push(form_data.goods_info[i]);
              additional_goodsid_arr.push(goodsId);
              if (form_data.additional_info && form_data.additional_info[goodsId]) {
                for (var _i = 0; _i < form_data.additional_info[goodsId].length; _i++) {
                  if (form_data.additional_info[goodsId][_i].value) {
                    hasAdditionalInfo = true;
                  }
                }
              }
            }
          }
          var estimateTime = void 0;
          if (data.form_data.take_out_info.accept_time) {
            estimateTime = that.returnDeliveryTime(+data.form_data.take_out_info.accept_time, +data.form_data.take_out_info.deliver_time);
          }
          var sytime;
          if (data.form_data.add_time) {
            var nowTime = new Date().getTime();
            var addTime = data.form_data.add_time.replace(/\-/g, '/');
            var time = 20 * 60000 - (nowTime - new Date(addTime + '').getTime());
            if (time <= 0) {
              sytime = '0:00';
            } else {
              sytime = that.returHM(time);
            }
          }
          that.setData({
            orderData: data,
            orderInfo: form_data,
            estimateTime: estimateTime || '',
            hasAdditionalInfo: hasAdditionalInfo,
            discount_cut_price: form_data.discount_cut_price,
            useBalance: form_data['use_balance'],
            express_fee: res.data[0]['express_fee'],
            sytime: sytime
          });
          _app.appMethod.setPreviewGoodsInfo(additional_info_goods);
          that.canvas(data.form_data.take_out_info.accept_time, +data.form_data.take_out_info.deliver_time);
          if (form_data.is_self_delivery == 1) {
            that.getFreigtAdress();
          } else {
            address_id = form_data.address_info.address_id;
            that.setData({
              selectAddressId: address_id
            });
          }
          _app.appMethod.setGoodsAdditionalInfo(form_data.additional_info || {});
        }
      });
    };

    _this2.returnDeliveryTime = function (accept_time, deliver_time) {
      var time = accept_time * 1000 + deliver_time * 60000,
          HM = (new Date(time).toISOString().split('T')[0] + ' ' + new Date(time).toTimeString().split(' ')[0]).split(' ')[1];
      HM = HM.split(':')[0] + ':' + HM.split(':')[1];
      return HM;
    };

    _this2.returHM = function (time) {
      var minutes = parseInt(time % (1000 * 60 * 60) / (1000 * 60));
      var seconds = parseInt(time % (1000 * 60) / 1000);
      minutes < 10 ? minutes = '0' + minutes : minutes = minutes;
      seconds < 10 ? seconds = '0' + seconds : seconds = seconds;
      var HM = minutes + ':' + seconds;
      return HM;
    };

    _this2.makeComment = function (e) {
      var orderId = _this2.data.orderId,
          franchiseeId = _this2.data.franchiseeId,
          queryStr = franchiseeId === _app.appMethod.getAppId() ? '' : '&franchisee=' + franchiseeId;
      _app.appMethod.turnToPage('/orderMeal/pages/takeoutMakeComment/takeoutMakeComment?detail=' + orderId + queryStr);
    };

    _this2.orderDelete = function (e) {
      var orderId = _this2.data.orderId,
          that = _this2,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.showModal({
        content: '订单删除后不可找回，确认删除？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/HideOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: franchiseeId
            },
            success: function success(res) {
              _app.appMethod.turnBack();
            }
          });
        }
      });
    };

    _this2.cancelOrder = function (e) {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '你将要取消一笔付款订单，确认取消？',
        showCancel: true,
        confirmText: '是',
        cancelText: '否',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.payOrder = function (e) {
      var address_info = _this2.data.orderInfo.address_info,
          that = _this2,
          orderId;
      if (!address_info && _this2.data.orderInfo.goods_type != 3) {
        _app.appMethod.showModal({
          content: '请选择邮寄地址'
        });
        return;
      }
      orderId = _this2.data.orderInfo.order_id;
      if (_this2.data.orderInfo.total_price == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            setTimeout(function () {
              _app.appMethod.showToast({
                title: '支付成功',
                icon: 'success'
              });
            });
            setTimeout(function () {
              that.getOrderDetail(that.data.orderInfo.order_id);
            }, 1000);
          }
        });
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
        data: {
          order_id: orderId,
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var param = res.data,
              orderId = that.data.orderInfo.order_id;
          param.orderId = orderId;
          param.goodsType = that.data.orderInfo.goods_type;
          param.success = function () {
            setTimeout(function () {
              that.getOrderDetail(orderId);
            }, 1500);
          };
          _app.appMethod.wxPay(param);
        }
      });
    };

    _this2.applyDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定申请退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/applyRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 4;
              that.setData(data);
            },
            successShowModalConfirm: function successShowModalConfirm() {
              that.dataInitial();
            }
          });
        }
      });
    };

    _this2.toCancelOrder = function (e) {
      _app.appMethod.turnToPage('/orderMeal/pages/cancelOrder/cancelOrder?orderId=' + _this2.data.orderId + '&deliverType=' + _this2.data.orderInfo.take_out_info.deliver_type + '&franchisee=' + _this2.data.franchiseeId);
    };

    _this2.receiveDrawback = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到退款？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmRefund',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 7;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.checkLogistics = function () {
      var orderId = _this2.data.orderInfo.order_id;
      _app.appMethod.turnToPage('/eCommerce/pages/logisticsPage/logisticsPage?detail=' + orderId);
    };

    _this2.sureReceipt = function () {
      var orderId = _this2.data.orderInfo.order_id,
          that = _this2;
      _app.appMethod.showModal({
        content: '确定已收到货物？',
        showCancel: true,
        confirmText: '确定',
        cancelText: '取消',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/comfirmOrder',
            data: {
              order_id: orderId,
              sub_shop_app_id: that.data.franchiseeId
            },
            success: function success(res) {
              var data = {};
              data['orderInfo.status'] = 3;
              that.setData(data);
            }
          });
        }
      });
    };

    _this2.showAddressList = function () {
      var addressId = _this2.data.selectAddressId,
          orderId = _this2.data.orderInfo.order_id,
          franchiseeId = _this2.data.franchiseeId;
      _app.appMethod.turnToPage('/eCommerce/pages/myAddress/myAddress?id=' + addressId + '&oid=' + orderId + '&sub_shop_id=' + franchiseeId, true);
    };

    _this2.goToHomepage = function () {
      var router = _app.appMethod.getHomepageRouter();
      _app.appMethod.turnToPage('/pages/' + router + '/' + router, true);
    };

    _this2.verificationCode = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/verificationCodePage/verificationCodePage?detail=' + _this2.data.orderInfo.order_id + '&sub_shop_app_id=' + _this2.data.franchiseeId);
    };

    _this2.getFreigtAdress = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAppShopLocationInfo',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          that.setData({
            freightAdress: res.data
          });
        }
      });
    };

    _this2.freightGoMap = function () {
      var _this = _this2,
          infor = _this.data.freightAdress.region_string + _this.data.freightAdress.shop_location;
      infor = infor.replace(/\s+/g, '');
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetLatAndLngByAreaInfo',
        data: {
          location_info: infor
        },
        success: function success(res) {
          if (res.result) {
            _app.appMethod.openLocation({
              latitude: res.result.location.lat,
              longitude: res.result.location.lng
            });
          }
        }
      });
    };

    _this2.initialAddressId = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            that.setData({
              selectAddressId: res.data[0].id
            });
          }
        }
      });
    };

    _this2.freightPlayPhone = function () {
      var that = _this2;
      _app.appMethod.makePhoneCall(that.data.freightAdress.shop_contact);
    };

    _this2.seeAdditionalInfo = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail');
    };

    _this2.callTakeout = function (event) {
      var phone = event.currentTarget.dataset.phone;
      _app.appMethod.makePhoneCall(phone);
    };

    _this2.copyOrder = function (e) {
      var that = _this2;
      var dataset = e.currentTarget.dataset;
      _app.appMethod.setClipboardData({
        data: dataset.order,
        success: function success() {
          _app.appMethod.showToast({
            title: '复制成功',
            icon: 'success'
          });
        }
      });
    };

    _this2.selectMore = function (e) {
      var that = _this2;
      var dataset = e.currentTarget.dataset;
      _this2.setData({ ismore: !dataset.ismore });
    };

    _this2.hideMore = function (e) {
      _this2.setData({ ismore: false });
    };

    _this2.toFeedback = function (e) {
      _app.appMethod.turnToPage('/orderMeal/pages/takeoutFeedback/takeoutFeedback?orderId=' + _this2.data.orderId + '&deliverType=' + _this2.data.orderInfo.take_out_info.deliver_type);
    };

    _this2.toFeedbackDetail = function (e) {
      _app.appMethod.turnToPage('/orderMeal/pages/indemnityOrder/indemnityOrder?orderId=' + _this2.data.orderId + '&deliverType=' + _this2.data.orderInfo.take_out_info.deliver_type);
    };

    _this2.cancelRefund = function (e) {
      var that = _this2;
      _app.appMethod.showModal({
        content: '是否撤销取消订单申请？',
        showCancel: true,
        cancelText: '取消',
        confirmText: '确定',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppShop/cancelRefund',
            data: {
              app_id: _app.appMethod.getAppId(),
              order_id: that.data.orderInfo.order_id
            },
            success: function success(res) {
              that.getOrderDetail(that.data.orderId);
            }
          });
        }
      });
    };

    _this2.getTakeOutInfo = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getTakeOutInfo',
        success: function success(res) {
          that.setData({
            takeoutInfo: res.data || ''
          });
        }
      });
    };

    _this2.cancelReason = function () {
      _this2.setData({
        isShowInstruction: true
      });
    };

    _this2.hideInstruction = function () {
      _this2.setData({
        isShowInstruction: false
      });
    };

    document.title = '订单详情';
    return _this2;
  }

  (0, _createClass3.default)(TakeoutOrderDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.detail,
        isFromTemplateMsg: options.from === 'template_msg' ? true : false,
        franchiseeId: options.franchisee || ''
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {
      if (this.data.isFromBack) {
        this.dataInitial();
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          isFromTemplateMsg = _state.isFromTemplateMsg,
          orderInfo = _state.orderInfo,
          transporterInfo = _state.transporterInfo,
          sytime = _state.sytime,
          orderStatusText = _state.orderStatusText,
          estimateTime = _state.estimateTime,
          deliveryTime = _state.deliveryTime,
          orderData = _state.orderData,
          ismore = _state.ismore,
          marker = _state.marker,
          franchiseeId = _state.franchiseeId,
          takeoutInfo = _state.takeoutInfo,
          discount_cut_price = _state.discount_cut_price,
          useBalance = _state.useBalance,
          hasAdditionalInfo = _state.hasAdditionalInfo,
          isShowInstruction = _state.isShowInstruction;


      return React.createElement(
        'div',
        { className: 'official-page takeout-order-detail' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { onClick: this.hideMore },
            isFromTemplateMsg && React.createElement(
              'div',
              {
                className: 'order-detail-section orderDetail-goto-homepage',
                onClick: this.goToHomepage,
                style: (0, _tools.convertLineStyleData)('margin-bottom:0;')
              },
              React.createElement('div', { className: 'ico-moon icon-rightarrow' }),
              '\u8FD4\u56DE\u9996\u9875'
            ),
            React.createElement(
              'div',
              { className: 'takeoutInfo' },
              React.createElement(
                'div',
                {
                  style: (0, _tools.convertLineStyleData)(orderInfo.status == 2 && transporterInfo && transporterInfo.transport_order_data.status >= 2 ? 'float:left;margin-left:30rpx;text-align:left;' : '')
                },
                React.createElement(
                  'div',
                  { onClick: this.turnToOrderTracking },
                  orderData.form_data && orderData.form_data.take_out_info.deliver_type == 0 || orderData.form_data && orderData.form_data.take_out_info.deliver_type == '' ? orderStatusText[orderInfo.status].name : orderInfo.status == 2 ? transportStatus[orderInfo.take_out_transport_order.status] : orderStatusText[orderInfo.status] && orderStatusText[orderInfo.status].name,
                  orderInfo.status == 0 && React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #FF7100;') },
                    sytime
                  ),
                  React.createElement('div', {
                    className: 'ico-moon icon-rightarrow',
                    style: (0, _tools.convertLineStyleData)('font-size:24rpx;')
                  })
                ),
                React.createElement(
                  'div',
                  { style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color:#999;margin-top:16rpx;font-weight: normal;') },
                  orderStatusText[orderInfo.status] && orderStatusText[orderInfo.status].orderName,
                  orderInfo.status == 1 && React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #FF7100;') },
                    orderInfo.take_out_info.takeout_appointment_arrive_time || estimateTime
                  ),
                  orderInfo.status == 2 && React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #FF7100;') },
                    deliveryTime
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'status-btn',
                  style: (0, _tools.convertLineStyleData)(orderInfo.status == 4 || orderInfo.take_out_transport_order && orderInfo.take_out_transport_order.status == 1 || orderInfo.status == 1 && orderInfo.take_out_info.transport_shop_id ? 'height:auto' : 'height:70rpx;')
                },
                React.createElement(
                  'div',
                  { className: 'txt-c' },
                  orderInfo.status == 3 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'btn btn-orange orderDetail-pay-directly',
                        onClick: this.makeComment,
                        'data-id': orderData.form_data.order_id
                      },
                      '\u7ACB\u5373\u8BC4\u4EF7'
                    )
                  ),
                  orderInfo.status == 0 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'btn btn-orange orderDetail-pay-directly',
                        onClick: this.payOrder
                      },
                      '\u7ACB\u5373\u652F\u4ED8'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.cancelOrder,
                        style: (0, _tools.convertLineStyleData)('color:#999999')
                      },
                      '\u53D6\u6D88\u652F\u4ED8'
                    )
                  ),
                  orderInfo.status == 1 && React.createElement(
                    React.Fragment,
                    null,
                    !orderInfo.take_out_info.transport_shop_id && React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.toCancelOrder,
                        style: (0, _tools.convertLineStyleData)('color:#999999')
                      },
                      '\u53D6\u6D88\u8BA2\u5355'
                    ),
                    orderInfo.refund_info && orderInfo.refund_info.refuse_msg && React.createElement(
                      'span',
                      {
                        className: 'btn',
                        style: (0, _tools.convertLineStyleData)('color:#999999'),
                        onClick: this.cancelReason
                      },
                      '\u53D6\u6D88\u539F\u56E0'
                    )
                  ),
                  orderInfo.status == 2 && React.createElement(
                    React.Fragment,
                    null,
                    (orderInfo.take_out_transport_order.status == 4 || orderInfo.take_out_transport_order.status == 3 && orderInfo.take_out_info.deliver_type == 3 || orderInfo.take_out_info.deliver_type == 0) && React.createElement(
                      'span',
                      {
                        className: 'btn btn-orange',
                        onClick: this.sureReceipt,
                        style: (0, _tools.convertLineStyleData)(orderInfo.status == 2 && transporterInfo && transporterInfo.transport_order_data.status >= 2 ? 'float:right;' : 'margin-right:20rpx;')
                      },
                      '\u786E\u8BA4\u6536\u8D27'
                    ),
                    orderInfo.take_out_transport_order.status == 5 && React.createElement(
                      'span',
                      { className: 'btn', onClick: this.orderDelete },
                      '\u522A\u9664\u8BA2\u5355'
                    )
                  ),
                  orderInfo.status == 3 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'div',
                      { className: 'selectMore' },
                      React.createElement(
                        'div',
                        { onClick: this.selectMore, 'data-ismore': ismore },
                        '\u66F4\u591A',
                        React.createElement('label', {
                          className: 'ico-moon icon-downarrow',
                          style: (0, _tools.convertLineStyleData)('color:#D2D2D2;')
                        })
                      ),
                      ismore && React.createElement(
                        'div',
                        { onClick: this.orderDelete },
                        '\u5220\u9664\u8BA2\u5355'
                      ),
                      ismore && !orderInfo.take_out_indemnity_order && React.createElement(
                        'div',
                        {
                          onClick: this.toFeedback,
                          'data-order': orderInfo.order_id
                        },
                        '\u95EE\u9898\u53CD\u9988'
                      ),
                      ismore && orderInfo.take_out_indemnity_order && React.createElement(
                        'div',
                        {
                          onClick: this.toFeedbackDetail,
                          'data-order': orderInfo.order_id
                        },
                        '\u53CD\u9988\u8BE6\u60C5'
                      )
                    )
                  ),
                  orderInfo.status == 4 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.cancelRefund,
                        style: (0, _tools.convertLineStyleData)('margin-bottom:16rpx;')
                      },
                      '\u64A4\u9500\u7533\u8BF7'
                    ),
                    React.createElement('div', { style: (0, _tools.convertLineStyleData)('height:1px;margin:10rpx 28rpx 20rpx;background-color:#F3F3F3;') }),
                    React.createElement(
                      'div',
                      { className: 'refund' },
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('margin-bottom:24rpx;') },
                        '\u5546\u5BB6\u540C\u610F\u6216\u8005\u8D85\u65F6\u8D85\u65F6\u5904\u7406\uFF0C\u7CFB\u7EDF\u5C06\u9000\u6B3E\u7ED9\u60A8'
                      ),
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('margin-right:0;') },
                        '\u5982\u679C\u5546\u5BB6\u62D2\u7EDD\uFF0C\u60A8\u53EF\u4EE5\u4FEE\u6539\u9000\u6B3E\u7533\u8BF7\u540E\u518D\u6B21\u53D1\u8D77\uFF0C\u5546\u5BB6\u4F1A\u91CD\u65B0\u5904\u7406'
                      )
                    )
                  ),
                  orderInfo.status == 5 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      { className: 'btn', onClick: this.receiveDrawback },
                      '\u6536\u5230\u9000\u6B3E'
                    )
                  ),
                  orderInfo.status == 6 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      { className: 'btn', onClick: this.orderDelete },
                      '\u522A\u9664\u8BA2\u5355'
                    ),
                    !orderInfo.take_out_indemnity_order && React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.toFeedback,
                        'data-order': orderInfo.order_id
                      },
                      '\u95EE\u9898\u53CD\u9988'
                    ),
                    orderInfo.take_out_indemnity_order && React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.toFeedbackDetail,
                        'data-order': orderInfo.order_id
                      },
                      '\u53CD\u9988\u8BE6\u60C5'
                    )
                  ),
                  orderInfo.status == 7 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      { className: 'btn', onClick: this.orderDelete },
                      '\u522A\u9664\u8BA2\u5355'
                    )
                  ),
                  orderInfo.status == 8 && React.createElement(
                    React.Fragment,
                    null,
                    React.createElement(
                      'span',
                      {
                        className: 'btn',
                        onClick: this.toCancelOrder,
                        style: (0, _tools.convertLineStyleData)('color:#999999')
                      },
                      '\u53D6\u6D88\u8BA2\u5355'
                    ),
                    orderInfo.refund_info && orderInfo.refund_info.refuse_msg && React.createElement(
                      'span',
                      {
                        className: 'btn',
                        style: (0, _tools.convertLineStyleData)('color:#999999'),
                        onClick: this.cancelReason
                      },
                      '\u53D6\u6D88\u539F\u56E0'
                    )
                  )
                )
              )
            ),
            orderInfo.status == 2 && transporterInfo && transporterInfo.transport_order_data.status >= 2 && React.createElement(
              'div',
              {
                className: 'order-detail-section',
                style: (0, _tools.convertLineStyleData)('margin:20rpx;padding:26rpx 30rpx;margin-top:0;padding-top:0;')
              },
              React.createElement(_Map.Map, {
                onClick: this.mapDetail,
                'data-lat': transporterInfo.transporter_latitude,
                'data-lng': transporterInfo.transporter_longitude,
                style: (0, _tools.convertLineStyleData)('margin:0px auto 20rpx;width:100%;'),
                longitude: transporterInfo.transporter_longitude,
                latitude: transporterInfo.transporter_latitude,
                scale: '18',
                markers: marker,
                showLocation: true
              })
            ),
            React.createElement(
              'div',
              {
                className: 'order-detail-section',
                style: (0, _tools.convertLineStyleData)('margin-bottom: 0; padding:0 30rpx; border-bottom: none;margin:20rpx;')
              },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('padding:26rpx 0rpx;background:#fff;font-weight: 500;border-bottom:1px solid #F3F3F3;') },
                React.createElement('img', {
                  className: 'shopImage',
                  src: franchiseeId ? orderInfo.sub_shop_info.logo : takeoutInfo && takeoutInfo.cover
                }),
                React.createElement(
                  'span',
                  null,
                  franchiseeId ? orderInfo.sub_shop_info.name : takeoutInfo && takeoutInfo.title
                ),
                franchiseeId ? React.createElement(
                  React.Fragment,
                  null,
                  orderInfo.sub_shop_info.phone && React.createElement(
                    'div',
                    {
                      onClick: this.callTakeout,
                      'data-phone': orderInfo.sub_shop_info.phone,
                      className: 'info-takeout-phone'
                    },
                    React.createElement('label', {
                      className: 'ico-moon icon-fn-phone',
                      style: (0, _tools.convertLineStyleData)('font-size:40rpx;color:#d2d2d2;')
                    })
                  )
                ) : React.createElement(
                  React.Fragment,
                  null,
                  React.createElement(
                    'div',
                    {
                      onClick: this.callTakeout,
                      'data-phone': takeoutInfo && takeoutInfo.phone,
                      className: 'info-takeout-phone'
                    },
                    React.createElement('label', {
                      className: 'ico-moon icon-fn-phone',
                      style: (0, _tools.convertLineStyleData)('font-size:40rpx;color:#d2d2d2;')
                    })
                  )
                )
              ),
              orderInfo.goods_info && orderInfo.goods_info.map(function (goods, goodsIndex) {
                return React.createElement(
                  'div',
                  { className: 'goods-list-item', key: goodsIndex },
                  React.createElement(
                    'div',
                    { className: 'inner-content' },
                    React.createElement('img', { className: 'waimai-img', src: goods.cover }),
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('width: initial;'), className: 'waimai-title' },
                      React.createElement(
                        'div',
                        { className: 'waimai-title-text' },
                        goods.goods_name
                      ),
                      React.createElement(
                        'div',
                        { style: (0, _tools.convertLineStyleData)('word-break: break-all;max-width: 300rpx;overflow: hidden;height: 28rpx;line-height: 28rpx;text-overflow: ellipsis;white-space: nowrap;') },
                        goods.model_value && React.createElement(
                          'span',
                          { className: 'goods-model' },
                          '(' + goods.model_value + ')'
                        )
                      ),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { style: (0, _tools.convertLineStyleData)('color: #999;font-size: 28rpx;') },
                          'x ' + goods.num
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'totle-price' },
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                        '\xA5'
                      ),
                      goods.price * goods.num
                    )
                  )
                );
              }),
              orderInfo.take_out_info && orderInfo.take_out_info.box_fee && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { className: 'classname orange' },
                  '\u5305\u88C5'
                ),
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                  '\u9910\u76D2\u8D39'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right', style: (0, _tools.convertLineStyleData)('font-size:26rpx;') },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '\xA5'
                  ),
                  orderInfo.take_out_info.box_fee
                )
              ),
              React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { className: 'classname orange' },
                  '\u914D\u9001\u8D39'
                ),
                orderInfo.status > 1 && orderInfo.status != 8 && React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                  orderInfo.take_out_info.deliver_type == 0 ? '商家配送' : orderInfo.take_out_info.deliver_type == 3 ? '达达配送' : '蜂鸟配送'
                ),
                React.createElement(
                  'span',
                  { className: 'pull-right', style: (0, _tools.convertLineStyleData)('font-size:26rpx;') },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '\xA5'
                  ),
                  orderInfo.take_out_info && orderInfo.take_out_info.deliver_fee
                )
              ),
              discount_cut_price > 0 && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { className: 'classname pink' },
                  '\u4F18\u60E0'
                ),
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                  orderInfo.selected_benefit.name
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size:26rpx;color:#FF7100;')
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '- \xA5'
                  ),
                  discount_cut_price
                )
              ),
              orderInfo.extra_discount_cut_price > 0 && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { className: 'classname pink' },
                  '\u8054\u76DF\u4F18\u60E0'
                ),
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                  orderInfo.extra_selected_benefit_info.name
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size:26rpx;color:#FF7100;')
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '- \xA5'
                  ),
                  orderInfo.extra_discount_cut_price
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'order-detail-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom: 0;border-bottom:1px solid #F3F3F3;')
                },
                React.createElement(
                  'span',
                  { className: 'classname pink' },
                  '\u50A8\u503C'
                ),
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#333333;') },
                  '\u50A8\u503C\u4F18\u60E0'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size:26rpx;color:#FF7100;')
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '- \xA5'
                  ),
                  useBalance
                )
              ),
              orderInfo.coupon_fee && React.createElement(
                'div',
                {
                  className: 'order-detail-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom: 0;margin-top:20rpx;border-bottom:1px solid #F3F3F3;')
                },
                React.createElement(
                  'span',
                  null,
                  '\u793E\u4EA4\u7ACB\u51CF\u91D1'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size:26rpx;color:#FF7100;')
                  },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:20rpx;') },
                    '- \xA5'
                  ),
                  orderInfo.coupon_fee
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'order-detail-section',
                  style: (0, _tools.convertLineStyleData)('margin-top:28rpx;border-bottom:none;')
                },
                '\u5B9E\u4ED8',
                React.createElement(
                  'span',
                  { className: 'pull-right', style: (0, _tools.convertLineStyleData)('font-size:26rpx;') },
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:26rpx;') },
                    '\xA5'
                  ),
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('font-size:34rpx;') },
                    orderInfo.total_price
                  )
                )
              )
            ),
            React.createElement(
              'div',
              {
                className: 'order-detail-section',
                style: (0, _tools.convertLineStyleData)('margin-bottom: 0; padding:0 30rpx; border-bottom: none;margin:20rpx;')
              },
              React.createElement(
                'div',
                { className: 'deliver_title' },
                '\u914D\u9001\u4FE1\u606F'
              ),
              orderInfo.take_out_info && orderInfo.take_out_info.takeout_appointment_arrive_time && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u9001\u8FBE\u65F6\u95F4'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  React.createElement(
                    'span',
                    null,
                    orderInfo.take_out_info.takeout_appointment_arrive_time || estimateTime
                  )
                )
              ),
              orderInfo.status > 1 && orderInfo.status != 8 && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u914D\u9001\u65B9\u5F0F'
                ),
                React.createElement(
                  'span',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  orderInfo.take_out_info.deliver_type == 0 ? '商家配送' : orderInfo.take_out_info.deliver_type == 3 ? '达达配送' : '蜂鸟配送'
                )
              ),
              React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('border-bottom:none;') },
                React.createElement(
                  'div',
                  {
                    style: (0, _tools.convertLineStyleData)('display:inline-block;width: 130rpx;vertical-align:top;color:#666666;')
                  },
                  '\u914D\u9001\u5730\u5740'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'address-info-section',
                    style: (0, _tools.convertLineStyleData)('text-align:right;font-size:26rpx;vertical-align:middle;display:inline-block;width:calc(100% - 130rpx);color:#666;')
                  },
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('margin-bottom: 12rpx;display:inline-block;') },
                    orderInfo.address_info && orderInfo.address_info.name + ' ' + orderInfo.address_info.contact
                  ),
                  React.createElement(
                    'div',
                    null,
                    orderInfo.address_info && orderInfo.address_info.province.text + orderInfo.address_info.city.text + orderInfo.address_info.district.text + orderInfo.address_info.detailAddress
                  )
                )
              ),
              transporterInfo && transporterInfo.transport_order_data.status >= 2 && React.createElement(
                'div',
                {
                  className: 'order-detail-section',
                  style: (0, _tools.convertLineStyleData)('margin-bottom: 0;')
                },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u9A91\u624B\u4FE1\u606F'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  React.createElement(
                    'span',
                    null,
                    transporterInfo.transport_order_data.transporter_data.transporter_name
                  ),
                  React.createElement('span', { className: 'line' }),
                  React.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)('color:#FF7100'),
                      onClick: this.makePhoneCall,
                      'data-phone': transporterInfo.transport_order_data.transporter_data.transporter_phone
                    },
                    '\u8054\u7CFB\u9A91\u624B'
                  )
                )
              )
            ),
            hasAdditionalInfo && React.createElement(
              'div',
              {
                className: 'order-detail-section',
                onClick: this.seeAdditionalInfo,
                style: (0, _tools.convertLineStyleData)('border-top:1px solid #f2f2f2;margin:0 20rpx;padding:26rpx 30rpx;border: none;')
              },
              '\u8865\u5145\u4FE1\u606F',
              React.createElement('div', { className: 'ico-moon icon-rightarrow pull-right' })
            ),
            orderInfo.remark && React.createElement(
              'div',
              {
                className: 'order-detail-section',
                style: (0, _tools.convertLineStyleData)('border-top:1px solid #f2f2f2;padding:26rpx 30rpx;margin:0 20rpx 18rpx;')
              },
              React.createElement(
                'div',
                { className: 'section-title' },
                '\u7559\u8A00'
              ),
              React.createElement(
                'div',
                { className: 'section-content order-remark' },
                orderInfo.remark
              )
            ),
            React.createElement(
              'div',
              {
                className: 'order-detail-section',
                style: (0, _tools.convertLineStyleData)('padding:0 30rpx; border-bottom: none;margin:20rpx;margin-bottom: 56rpx;')
              },
              React.createElement(
                'div',
                { className: 'deliver_title', style: (0, _tools.convertLineStyleData)('margin-top:0;') },
                '\u8BA2\u5355\u4FE1\u606F'
              ),
              React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u4E0B\u5355\u65F6\u95F4'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  React.createElement(
                    'span',
                    null,
                    orderInfo.add_time
                  )
                )
              ),
              React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u8BA2\u5355\u7F16\u53F7'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  React.createElement(
                    'span',
                    null,
                    orderInfo.order_id
                  ),
                  React.createElement('span', { className: 'line' }),
                  React.createElement(
                    'span',
                    {
                      style: (0, _tools.convertLineStyleData)('color:#FF7100'),
                      onClick: this.copyOrder,
                      'data-order': orderInfo.order_id
                    },
                    '\u590D\u5236'
                  )
                )
              ),
              orderInfo.remark && React.createElement(
                'div',
                { className: 'order-detail-section', style: (0, _tools.convertLineStyleData)('margin-bottom: 0;') },
                React.createElement(
                  'span',
                  { style: (0, _tools.convertLineStyleData)('color:#666666;') },
                  '\u8BA2\u5355\u5907\u6CE8'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'pull-right',
                    style: (0, _tools.convertLineStyleData)('font-size: 26rpx;color: #666;')
                  },
                  React.createElement(
                    'span',
                    null,
                    orderInfo.remark
                  )
                )
              )
            ),
            isShowInstruction && React.createElement(
              'div',
              { className: 'instruction-warp' },
              React.createElement(
                'div',
                { className: 'instruction-container' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'instruction-container' },
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('padding: 0 27px;wxcs_style_padding: 0 50rpx;') },
                      React.createElement(
                        'div',
                        { className: 'instruction-title' },
                        React.createElement(
                          'span',
                          null,
                          '\u5546\u5BB6\u62D2\u7EDD\u53D6\u6D88\u8BA2\u5355\u539F\u56E0'
                        )
                      ),
                      React.createElement(
                        'span',
                        {
                          className: 'instruction-item',
                          style: (0, _tools.convertLineStyleData)('text-align:center;font-size:26rpx;')
                        },
                        orderInfo.refund_info.refuse_msg
                      )
                    ),
                    React.createElement(
                      'span',
                      {
                        className: 'instruction-close',
                        onClick: this.hideInstruction
                      },
                      '\u77E5\u9053\u4E86'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TakeoutOrderDetail;
}(_OfficialPage3.default);

exports.default = TakeoutOrderDetail;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderTracking = function (_OfficialPage) {
  (0, _inherits3.default)(OrderTracking, _OfficialPage);

  function OrderTracking(props) {
    (0, _classCallCheck3.default)(this, OrderTracking);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OrderTracking.__proto__ || Object.getPrototypeOf(OrderTracking)).call(this, props));

    _this.state = {};

    _this.getTransport = function (order_id) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getTransportOrderFlow',
        method: 'post',
        data: {
          order_id: order_id
        },
        success: function success(res) {
          console.log(res.data.reverse());
          console.log(res.data);
          that.setData({
            orderFlow: res.data
          });
        }
      });
    };

    document.title = '订单跟踪';
    return _this;
  }

  (0, _createClass3.default)(OrderTracking, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.orderId = options.orderId;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getTransport(this.orderId);
    }
  }, {
    key: 'render',
    value: function render() {
      var orderFlow = this.state.orderFlow;

      return React.createElement(
        'div',
        { className: 'official-page order-tracking' },
        React.createElement(_TopNav.TopNav, { title: '\u8BA2\u5355\u8DDF\u8E2A' }),
        orderFlow && orderFlow.map(function (item, index) {
          return React.createElement(
            'div',
            { className: 'order-block', key: index },
            React.createElement('label', { className: 'order-point' }),
            React.createElement(
              'div',
              { className: 'order-content' },
              React.createElement(
                'span',
                { className: 'order-message' },
                item.content.msg
              ),
              React.createElement(
                'span',
                { className: 'order-time' },
                item.op_time
              ),
              React.createElement('div', null)
            ),
            React.createElement('span', { className: 'order-line' })
          );
        })
      );
    }
  }]);
  return OrderTracking;
}(_OfficialPage3.default);

exports.default = OrderTracking;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(613);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CancelOrder = function (_OfficialPage) {
  (0, _inherits3.default)(CancelOrder, _OfficialPage);

  function CancelOrder(props) {
    (0, _classCallCheck3.default)(this, CancelOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CancelOrder.__proto__ || Object.getPrototypeOf(CancelOrder)).call(this, props));

    _this.state = {
      cancelReason: [],
      orderId: '',
      deliverType: 0,
      submitData: {
        order_id: '',
        app_id: '',
        sub_shop_app_id: '',
        refund_reason: '',
        description: '',
        img_url: []
      },
      reasonIndex: '',
      isShowInstruction: false,
      isFromBack: false,
      isShowText: true
    };

    _this.onPullDownRefresh = function () {};

    _this.onReachBottom = function () {};

    _this.onShareAppMessage = function () {};

    _this.dataInitial = function () {
      _this.getBuyerCancelReason();
    };

    _this.getBuyerCancelReason = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getBuyerCancelReason',
        data: {
          deliver_type: _this.data.deliverType
        },
        success: function success(res) {
          if (res.status === 0) {
            that.setData({
              cancelReason: res.data
            });
          }
        }
      });
    };

    _this.chooseImage = function (e) {
      var that = _this,
          img_url = that.data.submitData.img_url;
      if (img_url.length >= 3) {
        _app.appMethod.showModal({
          content: '每个商品最多上传3张图片'
        });
        return;
      }
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data['submitData.img_url'] = img_url.concat(images);
        that.setData(data);
      }, 3 - img_url.length);
    };

    _this.removePic = function (e) {
      var picIndex = e.currentTarget.dataset.picIndex,
          img_url = _this.data.submitData.img_url,
          data = {};
      img_url.splice(picIndex, 1);
      data['submitData.img_url'] = img_url;
      _this.setData(data);
    };

    _this.chooseReason = function (e) {
      var chooseIndex = e.currentTarget.dataset.reasonIndex,
          data = {};
      data['submitData.refund_reason'] = chooseIndex;
      data.reasonIndex = chooseIndex;
      _this.setData(data);
    };

    _this.applyDrawback = function (e) {
      var that = _this,
          submitData = that.data.submitData;
      submitData.order_id = _this.data.orderId;
      submitData.app_id = _app.appMethod.getAppId();
      if (!submitData.refund_reason) {
        _app.appMethod.showModal({
          content: '选择一个原因'
        });
        return;
      }
      if (submitData.img_url.length > 3) {
        _app.appMethod.showModal({
          content: '最多上传3张图片'
        });
        return;
      }
      that.showInstruction();
      that.setData({
        isShowText: false
      });
    };

    _this.showInstruction = function () {
      _this.setData({ isShowInstruction: true });
    };

    _this.hideInstruction = function () {
      var that = _this,
          submitData = that.data.submitData;
      submitData.order_id = _this.data.orderId;
      submitData.app_id = _app.appMethod.getAppId();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/applyRefund',
        method: 'post',
        data: submitData,
        success: function success(res) {
          that.setData({ isShowInstruction: false });
          _app.appMethod.turnBack();
        },
        complete: function complete() {
          that.setData({ isShowInstruction: false });
        }
      });
    };

    _this.commentInput = function (e) {
      _this.data.submitData.description = e.target.value;
    };

    document.title = '取消订单';
    return _this;
  }

  (0, _createClass3.default)(CancelOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.data.orderId = options.orderId;
      this.data.deliverType = options.deliverType;
      this.data.submitData.app_id = _app.appMethod.getAppId();
      this.data.submitData.sub_shop_app_id = options.franchisee || '';
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        this.dataInitial();
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          cancelReason = _state.cancelReason,
          reasonIndex = _state.reasonIndex,
          isShowText = _state.isShowText,
          submitData = _state.submitData,
          isShowInstruction = _state.isShowInstruction;


      return React.createElement(
        'div',
        { className: 'official-page cancel-order' },
        React.createElement(_TopNav.TopNav, { title: '\u53D6\u6D88\u8BA2\u5355' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'contain' },
            React.createElement(
              'div',
              { className: 'takeoutFeedback' },
              React.createElement(
                'div',
                { className: 'selectFeedback feedbackItem' },
                React.createElement(
                  'span',
                  null,
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #F2303E;font-size:28rpx;') },
                    '*'
                  ),
                  '\u8BF7\u9009\u62E9\u53D6\u6D88\u539F\u56E0'
                )
              ),
              Object.values(cancelReason).map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    {
                      className: 'feedbackItem',
                      onClick: _this2.chooseReason,
                      'data-reason-index': index,
                      'data-reason-str': item
                    },
                    React.createElement(
                      'span',
                      null,
                      item
                    ),
                    index == reasonIndex && React.createElement(_icon2.default, {
                      type: 'check-circle',
                      color: '#FF7100',
                      className: 'fr'
                    }),
                    index != reasonIndex && React.createElement('label', { className: 'circle fr' })
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'takeoutFeedback', style: (0, _tools.convertLineStyleData)('margin-bottom:40rpx;') },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('padding: 30rpx 0;') },
                '\u4E0A\u4F20\u51ED\u8BC1\uFF08\u6700\u591A\u4E0A\u4F203\u5F20\uFF09'
              ),
              React.createElement(
                'div',
                { className: 'feedbackInfo' },
                isShowText && React.createElement('textarea', {
                  placeholder: '\u5176\u4ED6\u8865\u5145\u4FE1\u606F',
                  onInput: this.commentInput
                })
              ),
              React.createElement(
                'div',
                { className: 'makeCom-pic-container' },
                submitData.img_url.map(function (imgUrl, index) {
                  return React.createElement(
                    'div',
                    { key: index, className: 'makeCom-pic-wrap' },
                    React.createElement('img', { src: imgUrl, mode: 'aspectFit' }),
                    React.createElement(
                      'label',
                      {
                        className: 'makeCom-remove-pic',
                        onClick: _this2.removePic,
                        'data-pic-index': index
                      },
                      '\xD7'
                    )
                  );
                }),
                submitData.img_url.length < 3 && React.createElement(
                  'div',
                  { className: 'makeCom-upload-pic', onClick: this.chooseImage },
                  React.createElement('div', {
                    className: 'ico-moon icon-fn-camera',
                    style: (0, _tools.convertLineStyleData)('display:block; font-size: 60rpx;')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u6DFB\u52A0\u56FE\u7247'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'bottom-container', onClick: this.applyDrawback },
              React.createElement(
                'label',
                { className: 'make-comment' },
                '\u63D0\u4EA4'
              )
            ),
            isShowInstruction && React.createElement(
              'div',
              { className: 'instruction-warp' },
              React.createElement(
                'div',
                { className: 'instruction-container' },
                React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'div',
                    { className: 'instruction-container' },
                    React.createElement(
                      'div',
                      { style: (0, _tools.convertLineStyleData)('padding: 0 27px;') },
                      React.createElement(
                        'div',
                        { className: 'instruction-title' },
                        React.createElement(_icon2.default, { type: 'check-circle', color: '#FF7100' }),
                        React.createElement(
                          'span',
                          null,
                          '\u9000\u6B3E\u7533\u8BF7\u5DF2\u63D0\u4EA4'
                        )
                      ),
                      React.createElement(
                        'span',
                        {
                          className: 'instruction-item',
                          style: (0, _tools.convertLineStyleData)('text-align:center;font-size:26rpx;')
                        },
                        '\u5546\u5BB6\u540C\u610F\u540E\u9000\u6B3E\u5C06\u539F\u8DEF\u9000\u56DE\u5230\u60A8\u7684\u652F\u4ED8\u8D26\u6237,\u8BE6\u60C5\u8BF7\u67E5\u770B\u8BA2\u5355\u8FDB\u5EA6'
                      )
                    ),
                    React.createElement(
                      'span',
                      {
                        className: 'instruction-close',
                        onClick: this.hideInstruction
                      },
                      '\u77E5\u9053\u4E86'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CancelOrder;
}(_OfficialPage3.default);

exports.default = CancelOrder;

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(615);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TakeoutMakeComment = function (_OfficialPage) {
  (0, _inherits3.default)(TakeoutMakeComment, _OfficialPage);

  function TakeoutMakeComment(props) {
    (0, _classCallCheck3.default)(this, TakeoutMakeComment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TakeoutMakeComment.__proto__ || Object.getPrototypeOf(TakeoutMakeComment)).call(this, props));

    _this.state = {
      goodsInfo: [],
      submitData: {
        order_id: '',
        goods: [],
        takeout_score: 5,
        takeout_serve_score: 5
      },
      isShowTextArea: true
    };

    _this.getOrderDetail = function () {
      var that = _this;
      _app.appMethod.getOrderDetail({
        data: {
          order_id: that.data.submitData.order_id,
          sub_shop_app_id: _this.data.submitData.sub_shop_app_id
        },
        success: function success(res) {
          var goodsInfo = res.data[0].form_data.goods_info,
              is_dining = res.data[0].form_data.is_dining == 1 ? true : false,
              goods = [];
          for (var i = 0, j = goodsInfo.length - 1; i <= j; i++) {
            goods.push({
              goods_id: goodsInfo[i].goods_id,
              info: {
                content: '',
                level: 1,
                img_arr: []
              }
            });
          }
          that.setData({
            takeoutInfo: res.data[0].take_out_info,
            is_dining: is_dining,
            goodsInfo: goodsInfo,
            'submitData.goods': goods
          });
        }
      });
    };

    _this.setDescScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.takeout_score': score
      });
    };

    _this.setScore = function (e) {
      var score = e.target.dataset.score;
      _this.setData({
        'submitData.takeout_serve_score': score
      });
    };

    _this.setGoodsScore = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          score = e.currentTarget.dataset.score,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.level'] = score;
      _this.setData(data);
    };

    _this.commentInput = function (e) {
      var goodsIndex = e.target.dataset.goodsIndex,
          data = {};
      data['submitData.goods[' + goodsIndex + '].info.content'] = e.target.value;
      _this.setData(data);
    };

    _this.chooseImage = function (e) {
      var that = _this,
          goodsIndex = e.currentTarget.dataset.goodsIndex,
          img_arr = that.data.submitData.goods[goodsIndex].info.img_arr;
      if (img_arr.length >= 3) {
        _app.appMethod.showModal({
          content: '每个商品最多上传3张图片'
        });
        return;
      }
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr.concat(images);
        that.setData(data);
      }, 3 - img_arr.length);
    };

    _this.removePic = function (e) {
      var goodsIndex = e.currentTarget.dataset.goodsIndex,
          picIndex = e.currentTarget.dataset.picIndex,
          img_arr = _this.data.submitData.goods[goodsIndex].info.img_arr,
          data = {};
      img_arr.splice(picIndex, 1);
      data['submitData.goods[' + goodsIndex + '].info.img_arr'] = img_arr;
      _this.setData(data);
    };

    _this.makeComment = function () {
      var that = _this,
          submitData = that.data.submitData,
          modalText = '';
      for (var i = submitData.goods.length - 1; i >= 0; i--) {
        var goods = submitData.goods[i];
        if (!goods.info.level) {
          modalText = '尚未给商品评分';
          break;
        }
        if (goods.info.img_arr.length > 3) {
          modalText = '每个商品最多上传3张图片';
          break;
        }
      }
      if (modalText) {
        _app.appMethod.showModal({
          content: modalText
        });
        return;
      }
      var addTime = Date.now();
      for (var _i = 0; _i < submitData.goods.length; _i++) {
        if (submitData.goods[_i].info.level > 2 && submitData.goods[_i].info.level < 5) {
          submitData.goods[_i].info.level = 2;
        } else if (submitData.goods[_i].info.level > 4) {
          submitData.goods[_i].info.level = 3;
        }
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/AddAssessList',
        method: 'post',
        data: submitData,
        success: function success(res) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=appShop/getIntegralLog',
            data: { add_time: addTime },
            success: function success(res) {
              if (res.data == 0) {
                _app.appMethod.showModal({
                  content: '评论成功',
                  confirm: function confirm() {
                    _app.appMethod.turnBack();
                  }
                });
              } else {
                that.setData({
                  isShowTextArea: false,
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: 'turnBack'
                  }
                });
              }
            }
          });
        }
      });
    };

    document.title = '评价';
    return _this;
  }

  (0, _createClass3.default)(TakeoutMakeComment, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        'submitData.order_id': options.detail || '',
        'submitData.sub_shop_app_id': options.franchisee || ''
      });
      this.getOrderDetail();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          takeoutInfo = _state.takeoutInfo,
          goodsInfo = _state.goodsInfo,
          submitData = _state.submitData,
          isShowTextArea = _state.isShowTextArea;


      return React.createElement(
        'div',
        { className: 'official-page takeout-make-comment' },
        React.createElement(_TopNav.TopNav, { title: '\u8BC4\u4EF7' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'makeCom-wrap page', id: 'makeComment' },
            React.createElement(
              'div',
              { className: 'takeoutTitle' },
              React.createElement('img', { src: takeoutInfo && takeoutInfo.cover }),
              React.createElement(
                'span',
                null,
                takeoutInfo && takeoutInfo.title
              )
            ),
            React.createElement(
              'div',
              {
                className: 'takeoutEvaluate',
                style: (0, _tools.convertLineStyleData)('height: 80rpx;margin-top: 16rpx;line-height: 80rpx;padding: 0 30rpx;background-color: #fff;border-bottom: 1px solid #f3f3f3;font-size: 28rpx;')
              },
              '\u5546\u54C1\u8BC4\u4EF7'
            ),
            React.createElement(
              'div',
              { style: (0, _tools.convertLineStyleData)('background-color: #fff;') },
              goodsInfo.map(function (item, goodsIndex) {
                return React.createElement(
                  'div',
                  { className: 'makeCom-item makeCom-goods-comment', key: goodsIndex },
                  React.createElement(
                    'div',
                    { style: (0, _tools.convertLineStyleData)('padding:0 0 30rpx;font-size: 32rpx;word-break: break-all;') },
                    item.goods_name,
                    React.createElement(
                      'div',
                      {
                        className: 'makeCommentLeval pull-right',
                        style: (0, _tools.convertLineStyleData)('color:#dcdcdc')
                      },
                      React.createElement('span', {
                        className: 'ico-moon icon-fullstar',
                        onClick: _this2.setGoodsScore,
                        'data-score': '5',
                        'data-goods-index': goodsIndex,
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level <= 5 ? 'color:#fc9e20;' : 'color:#dcdcdc;')
                      }),
                      React.createElement('span', {
                        className: 'ico-moon icon-fullstar',
                        onClick: _this2.setGoodsScore,
                        'data-score': '4',
                        'data-goods-index': goodsIndex,
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level <= 4 ? 'color:#fc9e20;' : 'color:#dcdcdc;')
                      }),
                      React.createElement('span', {
                        className: 'ico-moon icon-fullstar',
                        onClick: _this2.setGoodsScore,
                        'data-score': '3',
                        'data-goods-index': goodsIndex,
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level <= 3 ? 'color:#fc9e20;' : 'color:#dcdcdc;')
                      }),
                      React.createElement('span', {
                        className: 'ico-moon icon-fullstar',
                        onClick: _this2.setGoodsScore,
                        'data-score': '2',
                        'data-goods-index': goodsIndex,
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level <= 2 ? 'color:#fc9e20;' : 'color:#dcdcdc;')
                      }),
                      React.createElement('span', {
                        className: 'ico-moon icon-fullstar',
                        onClick: _this2.setGoodsScore,
                        'data-score': '1',
                        'data-goods-index': goodsIndex,
                        style: (0, _tools.convertLineStyleData)(submitData.goods[goodsIndex].info.level == 1 ? 'color:#fc9e20;' : 'color:#dcdcdc;')
                      })
                    ),
                    React.createElement('div', { style: (0, _tools.convertLineStyleData)('font-size:24rpx;color:#666;') })
                  ),
                  React.createElement(
                    'div',
                    null,
                    isShowTextArea && React.createElement('textarea', {
                      'data-goods-index': goodsIndex,
                      onInput: _this2.commentInput,
                      className: 'makeCom-textarea',
                      placeholder: '\u8BF4\u8BF4\u54EA\u91CC\u6EE1\u610F\uFF0C\u6765\u5E2E\u52A9\u5927\u5BB6\u9009\u62E9'
                    })
                  ),
                  React.createElement(
                    'div',
                    { className: 'makeCom-pic-container' },
                    submitData.goods[goodsIndex].info.img_arr.map(function (imgUrl, index) {
                      return React.createElement(
                        'div',
                        { key: index, className: 'makeCom-pic-wrap' },
                        React.createElement('img', { src: imgUrl, mode: 'aspectFit' }),
                        React.createElement(
                          'label',
                          {
                            className: 'makeCom-remove-pic',
                            onClick: _this2.removePic,
                            'data-goods-index': goodsIndex,
                            'data-pic-index': index
                          },
                          '\xD7'
                        )
                      );
                    }),
                    submitData.goods[goodsIndex].info.img_arr.length < 3 && React.createElement(
                      'div',
                      {
                        className: 'makeCom-upload-pic',
                        onClick: _this2.chooseImage,
                        'data-goods-index': goodsIndex
                      },
                      React.createElement('div', {
                        className: 'ico-moon icon-addassessimg',
                        style: (0, _tools.convertLineStyleData)('display:block; font-size: 60rpx;')
                      }),
                      React.createElement(
                        'span',
                        null,
                        '\u6DFB\u52A0\u56FE\u7247'
                      )
                    )
                  )
                );
              })
            ),
            React.createElement(
              'div',
              {
                className: 'makeCom-item',
                style: (0, _tools.convertLineStyleData)('padding:0;line-height:30px;margin: 16rpx 0 0;border-bottom: none;')
              },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('font-size:28rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx;') },
                '\u8BC4\u4EF7\u5546\u5BB6\u670D\u52A1'
              ),
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('font-size: 32rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx') },
                '\u670D\u52A1\u6001\u5EA6\uFF1A',
                React.createElement(
                  'div',
                  {
                    className: 'makeCommentLeval pull-right',
                    style: (0, _tools.convertLineStyleData)('color:#dcdcdc')
                  },
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_serve_score >= 1 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setScore,
                    'data-score': '1'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_serve_score >= 2 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setScore,
                    'data-score': '2'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_serve_score >= 3 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setScore,
                    'data-score': '3'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_serve_score >= 4 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setScore,
                    'data-score': '4'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_serve_score >= 5 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setScore,
                    'data-score': '5'
                  })
                )
              ),
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('font-size: 32rpx; height:80rpx;line-height:80rpx;padding: 0 30rpx') },
                '\u914D\u9001\u670D\u52A1\uFF1A',
                React.createElement(
                  'div',
                  {
                    className: 'makeCommentLeval pull-right',
                    style: (0, _tools.convertLineStyleData)('color:#dcdcdc')
                  },
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_score >= 1 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setDescScore,
                    'data-score': '1'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_score >= 2 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setDescScore,
                    'data-score': '2'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_score >= 3 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setDescScore,
                    'data-score': '3'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_score >= 4 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setDescScore,
                    'data-score': '4'
                  }),
                  React.createElement('span', {
                    className: 'ico-moon icon-fullstar',
                    style: (0, _tools.convertLineStyleData)(submitData.takeout_score >= 5 ? 'color:#fc9e20;' : 'color:#dcdcdc;'),
                    onClick: this.setDescScore,
                    'data-score': '5'
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'makeCom-bottom-nav', onClick: this.makeComment },
              React.createElement(
                'label',
                { className: 'makeCom-make-comment btn btn-orange' },
                '\u53D1\u8868\u8BC4\u4EF7'
              )
            )
          )
        )
      );
    }
  }]);
  return TakeoutMakeComment;
}(_OfficialPage3.default);

exports.default = TakeoutMakeComment;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(617);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TakeoutFeedback = function (_OfficialPage) {
  (0, _inherits3.default)(TakeoutFeedback, _OfficialPage);

  function TakeoutFeedback(props) {
    (0, _classCallCheck3.default)(this, TakeoutFeedback);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TakeoutFeedback.__proto__ || Object.getPrototypeOf(TakeoutFeedback)).call(this, props));

    _this.state = {
      complaintReason: [],
      orderId: '',
      deliverType: 0,
      submitData: {
        order_id: '',
        complaint_pics: [],
        complaint_reason_id: '',
        complaint_reason: '',
        complaint_additional_reason: ''
      },
      reasonIndex: '',
      isShowInstruction: false,
      isFromBack: false,
      indemnityExplain: {},
      isTurn: false,
      isShowText: true
    };

    _this.onPullDownRefresh = function () {};

    _this.onReachBottom = function () {};

    _this.onShareAppMessage = function () {};

    _this.dataInitial = function () {
      _this.getBuyerComplaintReason();
    };

    _this.getBuyerComplaintReason = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getBuyerComplaintReason',
        data: {
          deliver_type: _this.data.deliverType
        },
        success: function success(res) {
          if (res.status === 0) {
            that.setData({
              complaintReason: res.data
            });
          }
        }
      });
    };

    _this.chooseImage = function (e) {
      var that = _this,
          complaint_pics = that.data.submitData.complaint_pics;
      if (complaint_pics.length >= 3) {
        _app.appMethod.showModal({
          content: '每个商品最多上传3张图片'
        });
        return;
      }
      _app.appMethod.chooseImage(function (images) {
        var data = {};
        data['submitData.complaint_pics'] = complaint_pics.concat(images);
        that.setData(data);
      }, 3 - complaint_pics.length);
    };

    _this.removePic = function (e) {
      var picIndex = e.currentTarget.dataset.picIndex,
          complaint_pics = _this.data.submitData.complaint_pics,
          data = {};
      complaint_pics.splice(picIndex, 1);
      data['submitData.complaint_pics'] = complaint_pics;
      _this.setData(data);
    };

    _this.chooseReason = function (e) {
      var chooseIndex = e.currentTarget.dataset.reasonIndex,
          data = {};
      data['submitData.complaint_reason_id'] = chooseIndex;
      data['submitData.complaint_reason'] = e.currentTarget.dataset.reasonStr;
      data.reasonIndex = chooseIndex;
      _this.setData(data);
    };

    _this.makeComment = function (e) {
      var that = _this,
          submitData = that.data.submitData;
      submitData.order_id = _this.data.orderId;
      submitData.deliver_type = _this.data.deliverType;
      if (!submitData.complaint_reason_id) {
        _app.appMethod.showModal({
          content: '选择一个反馈项'
        });
        return;
      }
      if (submitData.complaint_pics.length > 3) {
        _app.appMethod.showModal({
          content: '最多上传3张图片'
        });
        return;
      }
      that.showInstruction();
      _this.data.isTurn = true;
    };

    _this.showInstruction = function () {
      _this.setData({ isShowInstruction: true });
      _this.setData({
        isShowText: false
      });
      if (!_this.data.indemnityExplain.account_type) {
        _this.getIndemnityExplainParam();
      }
    };

    _this.hideInstruction = function () {
      var that = _this;
      _this.setData({
        isShowText: true
      });
      if (_this.data.isTurn) {
        _this.data.isTurn = false;
        var submitData = that.data.submitData;
        submitData.order_id = _this.data.orderId;
        submitData.deliver_type = _this.data.deliverType;
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppTransport/buyerComplaint',
          method: 'post',
          data: submitData,
          success: function success(res) {
            if (res.status === 0) {
              _app.appMethod.turnToPage('/orderMeal/pages/indemnityOrder/indemnityOrder?orderId=' + that.data.orderId + '&deliverType=' + that.data.deliverType, 1);
            }
            that.setData({ isShowInstruction: false });
          },
          complete: function complete() {
            that.setData({ isShowInstruction: false });
          }
        });
      } else {
        _this.setData({ isShowInstruction: false });
      }
    };

    _this.commentInput = function (e) {
      _this.data.submitData.complaint_additional_reason = e.target.value;
    };

    _this.getIndemnityExplainParam = function () {
      var submitData = {
        order_id: _this.data.orderId
      };
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getIndemnityExplainParam',
        method: 'post',
        data: submitData,
        success: function success(res) {
          that.setData({
            indemnityExplain: res.data
          });
        }
      });
    };

    document.title = '问题反馈';
    return _this;
  }

  (0, _createClass3.default)(TakeoutFeedback, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.data.orderId = options.orderId;
      this.data.deliverType = options.deliverType;
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.data.isFromBack) {
        this.dataInitial();
      } else {
        this.setData({
          isFromBack: true
        });
      }
    }
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          complaintReason = _state.complaintReason,
          reasonIndex = _state.reasonIndex,
          isShowText = _state.isShowText,
          submitData = _state.submitData,
          indemnityExplain = _state.indemnityExplain,
          isShowInstruction = _state.isShowInstruction;


      return React.createElement(
        'div',
        { className: 'official-page takeout-feedback' },
        React.createElement(_TopNav.TopNav, { title: '\u53CD\u9988' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'contain' },
            React.createElement(
              'div',
              { className: 'takeoutFeedback' },
              React.createElement(
                'div',
                { className: 'selectFeedback feedbackItem' },
                React.createElement(
                  'span',
                  null,
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color: #F2303E;font-size:28rpx;') },
                    '*'
                  ),
                  '\u8BF7\u9009\u62E9\u53CD\u9988\u9879'
                ),
                React.createElement(
                  'span',
                  {
                    style: (0, _tools.convertLineStyleData)('color:#FF7100;'),
                    className: 'fr',
                    onClick: this.showInstruction
                  },
                  '\u8D54\u4ED8\u8BF4\u660E'
                )
              ),
              Object.values(complaintReason).map(function (item, index) {
                return React.createElement(
                  React.Fragment,
                  { key: index },
                  React.createElement(
                    'div',
                    {
                      className: 'feedbackItem',
                      onClick: _this2.chooseReason,
                      'data-reason-index': index,
                      'data-reason-str': item
                    },
                    React.createElement(
                      'span',
                      null,
                      item
                    ),
                    index == reasonIndex && React.createElement(_icon2.default, {
                      type: 'check-circle',
                      color: '#FF7100',
                      className: 'fr'
                    }),
                    index != reasonIndex && React.createElement('label', { className: 'circle fr' })
                  )
                );
              })
            ),
            React.createElement(
              'div',
              { className: 'takeoutFeedback', style: (0, _tools.convertLineStyleData)('margin-bottom:40rpx;') },
              React.createElement(
                'div',
                { style: (0, _tools.convertLineStyleData)('padding: 30rpx 0;') },
                '\u4E0A\u4F20\u51ED\u8BC1\uFF08\u6700\u591A\u4E0A\u4F203\u5F20\uFF09'
              ),
              isShowText && React.createElement(
                'div',
                { className: 'feedbackInfo' },
                React.createElement('textarea', {
                  placeholder: '\u5176\u4ED6\u8865\u5145\u4FE1\u606F',
                  onInput: this.commentInput
                })
              ),
              React.createElement(
                'div',
                { className: 'makeCom-pic-container' },
                submitData.complaint_pics.map(function (imgUrl, index) {
                  return React.createElement(
                    'div',
                    { key: true, className: 'makeCom-pic-wrap' },
                    React.createElement('img', { src: imgUrl, mode: 'aspectFit' }),
                    React.createElement(
                      'label',
                      {
                        className: 'makeCom-remove-pic',
                        onClick: _this2.removePic,
                        'data-pic-index': index
                      },
                      '\xD7'
                    )
                  );
                }),
                submitData.complaint_pics.length < 3 && React.createElement(
                  'div',
                  { className: 'makeCom-upload-pic', onClick: this.chooseImage },
                  React.createElement('div', {
                    className: 'ico-moon icon-fn-camera',
                    style: (0, _tools.convertLineStyleData)('display:block; font-size: 60rpx;')
                  }),
                  React.createElement(
                    'span',
                    null,
                    '\u6DFB\u52A0\u56FE\u7247'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'bottom-container', onClick: this.makeComment },
              React.createElement(
                'label',
                { className: 'make-comment' },
                '\u63D0\u4EA4'
              )
            ),
            isShowInstruction && React.createElement(
              'div',
              { className: 'instruction-warp' },
              React.createElement(
                'div',
                { className: 'instruction-container' },
                React.createElement(
                  'span',
                  { className: 'instruction-title' },
                  '\u8D54\u4ED8\u8BF4\u660E'
                ),
                React.createElement(
                  'span',
                  { className: 'instruction-item' },
                  '1.\u6839\u636E\u5B9E\u9645\u60C5\u51B5\u5B9A\u4F4D\u9A91\u624B\u8FD8\u662F\u5546\u5BB6\u95EE\u9898\uFF0C\u5FC5\u8981\u65F6\u4E0A\u4F20\u4EA7\u54C1\u8BE6\u60C5\u7167\u72471-3\u5F20'
                ),
                React.createElement(
                  'span',
                  { className: 'instruction-item' },
                  '2.\u6D41\u7A0B\uFF1A\u6295\u8BC9\u540E\u5546\u5BB6\u5C06\u4F1A\u6536\u5230\u60A8\u7684\u53CD\u9988\uFF0C\u5E76\u5728',
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#FF7100;display:inline;') },
                    '1-3'
                  ),
                  '个工作日内对提交的内容进行审核，审核无误将会赔付金额到您的' + (indemnityExplain.account_type == 1 ? '储值账户' : '') + '中'
                ),
                React.createElement(
                  'span',
                  { className: 'instruction-item' },
                  '3.\u6700\u9AD8\u8D54\u4ED8',
                  React.createElement(
                    'span',
                    { style: (0, _tools.convertLineStyleData)('color:#FF7100;display:inline;') },
                    indemnityExplain.indemnity_fee
                  ),
                  '\u5143'
                ),
                React.createElement(
                  'span',
                  { className: 'instruction-item' },
                  '4.若长时间未处理，可拨打热线电话' + (indemnityExplain.contact_phone || '')
                ),
                React.createElement(
                  'span',
                  {
                    className: 'instruction-close',
                    onClick: this.hideInstruction
                  },
                  '\u77E5\u9053\u4E86'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TakeoutFeedback;
}(_OfficialPage3.default);

exports.default = TakeoutFeedback;

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _TopNav = __webpack_require__(8);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(619);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndemnityOrder = function (_OfficialPage) {
  (0, _inherits3.default)(IndemnityOrder, _OfficialPage);

  function IndemnityOrder(props) {
    (0, _classCallCheck3.default)(this, IndemnityOrder);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IndemnityOrder.__proto__ || Object.getPrototypeOf(IndemnityOrder)).call(this, props));

    _this.state = {
      orderId: '',
      deliverType: 0,
      indemnityOrderData: {},
      isFromBack: false,
      indemnityExplain: {},
      isShowBtn: true
    };

    _this.onPullDownRefresh = function () {};

    _this.onReachBottom = function () {};

    _this.onShareAppMessage = function () {};

    _this.dataInitial = function () {
      _this.getTransportIndemnityOrder();
      _this.getIndemnityExplainParam();
    };

    _this.getTransportIndemnityOrder = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getTransportIndemnityOrder',
        data: {
          order_id: that.data.orderId
        },
        success: function success(res) {
          that.setData({
            indemnityOrderData: res.data
          });
          if (res.data.length > 3) {
            that.setData({
              isShowBtn: false
            });
            return;
          }
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].status == 1) {
              that.setData({
                isShowBtn: false
              });
              return;
            }
          }
        }
      });
    };

    _this.indemnity = function () {
      _app.appMethod.turnToPage('/orderMeal/pages/takeoutFeedback/takeoutFeedback?orderId=' + _this.data.orderId + '&deliverType=' + _this.data.deliverType);
    };

    _this.toBalance = function () {
      _app.appMethod.turnToPage('/eCommerce/pages/balance/balance');
    };

    _this.getIndemnityExplainParam = function () {
      var submitData = {
        order_id: _this.data.orderId
      };
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppTransport/getIndemnityExplainParam',
        method: 'post',
        data: submitData,
        success: function success(res) {
          that.setData({
            indemnityExplain: res.data
          });
        }
      });
    };

    _this.previewImage = function (e) {
      var dataset = e.currentTarget.dataset;
      _app.appMethod.previewImage({
        current: dataset.src,
        urls: JSON.parse(dataset.previewImgarr)
      });
    };

    document.title = '反馈详情';
    return _this;
  }

  (0, _createClass3.default)(IndemnityOrder, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      this.setData({
        orderId: options.orderId,
        deliverType: options.deliverType
      });
      this.dataInitial();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.dataInitial();
    }
  }, {
    key: 'componentDidHide',
    value: function componentDidHide() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          shareGiftsObj = _state.shareGiftsObj,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj,
          showGetUserInfo = _state.showGetUserInfo,
          indemnityOrderData = _state.indemnityOrderData,
          indemnityExplain = _state.indemnityExplain,
          isShowBtn = _state.isShowBtn;


      return React.createElement(
        'div',
        { className: 'official-page indemnity-order' },
        React.createElement(_TopNav.TopNav, { title: '\u53CD\u9988\u8BE6\u60C5' }),
        React.createElement(
          React.Fragment,
          null,
          React.createElement(
            'div',
            { className: 'container' },
            Object.values(indemnityOrderData).map(function (item, index) {
              return React.createElement(
                'div',
                { key: true, className: 'indemnityItem' },
                item.status == 1 && React.createElement(
                  'div',
                  { className: 'tips' },
                  React.createElement(
                    'div',
                    null,
                    '\u8010\u5FC3\u7B49\u5F85\u5546\u5BB6\u5904\u7406\uFF0C\u4E00\u822C\u5904\u7406\u65F6\u95F4\u57281-3\u5929\u5185'
                  ),
                  React.createElement(
                    'div',
                    null,
                    '如果对方长时间不处理，可以拨打电话' + indemnityExplain.contact_phone
                  )
                ),
                (item.status == 2 || item.status == 3) && React.createElement(
                  'div',
                  { className: 'tips' },
                  React.createElement(
                    'div',
                    null,
                    '\u6B64\u5355\u6295\u8BC9\u5386\u53F2\u8BB0\u5F55'
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'complaints' },
                  React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      { style: (0, _tools.convertLineStyleData)('font-size:30rpx;') },
                      '\u6295\u8BC9\u8BE6\u60C5'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u53CD\u9988\u9879'
                    ),
                    React.createElement(
                      'span',
                      { className: 'fr' },
                      item.complaint_data.complaint_reason
                    )
                  ),
                  item.complaint_data.complaint_pics && React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u51ED\u8BC1'
                    ),
                    React.createElement(
                      'div',
                      { className: 'imageContain' },
                      item.complaint_data.complaint_pics.map(function (imgUrl, index) {
                        return React.createElement(
                          React.Fragment,
                          { key: index },
                          React.createElement('img', {
                            src: imgUrl,
                            onClick: _this2.previewImage,
                            'data-src': imgUrl,
                            'data-preview-imgarr': JSON.stringify(item.complaint_data.complaint_pics)
                          })
                        );
                      })
                    )
                  ),
                  item.complaint_data.complaint_additional_reason && React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u8865\u5145\u4FE1\u606F'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: 'fr',
                        style: (0, _tools.convertLineStyleData)('max-width:500rpx;text-align:right;white-space:pre-line;word-break:break-all;')
                      },
                      item.complaint_data.complaint_additional_reason
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u63D0\u4EA4\u65F6\u95F4'
                    ),
                    React.createElement(
                      'span',
                      { className: 'fr' },
                      item.add_time
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'complaints' },
                  React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u5904\u7406\u60C5\u51B5'
                    )
                  ),
                  React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u72B6\u6001'
                    ),
                    React.createElement(
                      'span',
                      { className: 'fr' },
                      item.status == 1 ? '待处理' : item.status == 2 ? '已拒绝' : '已赔付'
                    )
                  ),
                  item.handle_data.description && React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u539F\u56E0'
                    ),
                    React.createElement(
                      'span',
                      {
                        className: 'fr',
                        style: (0, _tools.convertLineStyleData)('max-width:276px;text-align:right;white-space:pre-line;word-break:break-all;')
                      },
                      item.handle_data.description
                    )
                  ),
                  item.status == 3 && React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u8D54\u4ED8\u91D1\u989D'
                    ),
                    React.createElement(
                      'div',
                      { className: 'fr' },
                      '¥' + item.indemnity_fee + '，请到',
                      React.createElement(
                        'span',
                        { style: (0, _tools.convertLineStyleData)('color: #FF7100;'), onClick: _this2.toBalance },
                        '\u4EA4\u6613\u8BB0\u5F55'
                      ),
                      '\u67E5\u770B'
                    )
                  ),
                  item.status != 1 && React.createElement(
                    'div',
                    { className: 'complaintsItem' },
                    React.createElement(
                      'span',
                      null,
                      '\u5904\u7406\u65F6\u95F4'
                    ),
                    React.createElement(
                      'span',
                      { className: 'fr' },
                      item.update_time
                    )
                  )
                )
              );
            }),
            isShowBtn && React.createElement(
              'div',
              { className: 'indemnityBtn', onClick: this.indemnity },
              React.createElement(
                'span',
                null,
                '\u7EE7\u7EED\u53CD\u9988'
              )
            )
          )
        )
      );
    }
  }]);
  return IndemnityOrder;
}(_OfficialPage3.default);

exports.default = IndemnityOrder;

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _noDevPageList = __webpack_require__(125);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _customEvent = __webpack_require__(18);

var _TopNav = __webpack_require__(8);

__webpack_require__(621);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTurnToDetail = false;
var likeTap = false; //防止重复点击
var isReply = false; //防止重复点击
var dataType = function dataType(data) {
  return Object.prototype.toString.call(data).match(/^\[object\s(\w+)\]$/)[1];
};
var checkDataType = function checkDataType(data, typeString) {
  return dataType(data).toLowerCase() === typeString.toLowerCase();
};
var hasOwnProperty = function hasOwnProperty(data, property) {
  if (typeof data.hasOwnProperty === 'function') {
    return data.hasOwnProperty(property);
  }
  return Object.prototype.hasOwnProperty.call(data, property);
};
var ifHasDataType = function ifHasDataType(data, typeArr) {
  return typeArr.some(function (_type) {
    return checkDataType(data, _type);
  });
};
var getRightAttrVal = function getRightAttrVal(path, target) {
  ;/\]$/.test(path) && (path = path.slice(0, -1));
  var pathArr = path.replace(/\]?\[|\]\.?/g, '.').split(/\./);
  var len = pathArr.length;
  var key = void 0;
  var result = target;
  while (ifHasDataType(result, ['object', 'array']) && len > 0) {
    key = pathArr.shift();
    result = result[key];
    len--;
  }
  return result;
};
var pickAttrObject = function pickAttrObject(attrs, target) {
  var result = {};
  if (checkDataType(attrs, 'object') && checkDataType(target, 'object')) {
    for (var k in attrs) {
      if (hasOwnProperty(attrs, k)) {
        result[k] = getRightAttrVal(attrs[k], target);
      }
    }
  }
  return result;
};

var CommunityPage = function (_OfficialPage) {
  (0, _inherits3.default)(CommunityPage, _OfficialPage);

  function CommunityPage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CommunityPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CommunityPage.__proto__ || Object.getPrototypeOf(CommunityPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      topNavBarData: {
        isDefault: 0,
        type: 3,
        title: '圈组'
      },
      communityId: '',
      communityInfo: {},
      memberInfo: [],
      memberCount: '',
      category: [{
        value: 0,
        name: '全部',
        attr: 'category_id'
      }],
      activeCategory: {
        value: 0,
        name: '全部',
        attr: 'category_id'
      },
      carouselImg: [],
      sectionList: [],
      getSectionData: {
        page: 1,
        loading: false,
        nomore: false
      },
      search_value: '',
      imgData: {},
      showAddArticleBtn: true,
      hasCarousel: false,
      backTop: 0,
      showActionSheet: false,
      phoneNumCall: '',
      showBackTopBtn: false,
      showContact: false,
      showReplyBox: false,
      replyBoxFocus: false,
      closeDec: false,
      noticeDec: '',
      keyboardHeight: '50%',
      replyPlaceholder: '我来说两句',
      video_url: '',
      listOtherParam: {
        orderby: '', // 排序(默认按板块排序走)
        top_flag: 0, //如果为1 筛选置顶帖
        hot_flag: 0, //如果为1 筛选精品贴
        start_date: '', // 查询开始日期
        end_date: '', //查询结束日期
        latitude: '', // 纬度
        longitude: '' // 经度
      },
      currentSortbyName: '', // 当前显示的排序名称
      sortModal: {
        // 排序弹窗
        show: false,
        data: [{
          name: '最热话题',
          value: 'comment_count'
        }, {
          name: '最新发表',
          value: 'add_time'
        }, {
          name: '距离最近',
          value: 'distance'
        }, {
          name: '最热回复',
          value: 'last_comment_time'
        }]
      },
      replyParam: {
        text: '',
        agent_user_token: '',
        address: '',
        latitude: '',
        longitude: '',
        comment_img_url: '',
        comment_id: '',
        parent_comment_id: '',
        sub_app_id: ''
      },
      commentContentMaxHeight: 0,
      commentContentHeight: 40,
      currentTab: 0,
      topicMoreOperationModal: {
        mode: '', // 话题风格
        show: false, // 是否显示话题操作弹窗
        index: 0, // 当前被操作话题下标
        isAuthor: false, // 是否是作者自己的话题
        articleId: '', // 话题id
        sectionId: '', // 版块id
        franchisee: '', // 子店app_id
        isChargeTop: false, // 是否为置顶收费话题
        phone: '' // 联系手机号
      },
      vistorUserToken: '',
      sectionCommentLikeCounts: {
        comment_count: 0, // 社区话题被评论的次数
        like_count: 0, // 社区话题被点赞的次数
        show_type: 0 // 最新消息类型 0： 评论， 1： 点赞
      }
    }, _this.getSectionInfo = function (sId, callback) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetSectionByPage',
        data: {
          section_id: sId,
          page: 1,
          page_size: 100,
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data[0] || {};
            that.setData({
              communityInfo: info,
              showContact: info.require_phone == 1,
              showArticleComment: info.show_article_comment == 1,
              'topNavBarData.type': info.article_style == 3 ? '4' : '3'
            });
            _app.appMethod.setStorage({
              key: 'communityThemeColor-' + info.id,
              data: info.theme_color
            });
            if (info.has_carousel == 1) {
              that.getCarousel(sId);
              that.setData({
                hasCarousel: true
              });
            }
            typeof callback == 'function' && callback(res);
          }
        }
      });
    }, _this.getMemberInfo = function (sId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetSectionJoinUserList',
        data: {
          section_id: sId
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var memberInfo = res.data;
            var memberCount = res.user_total;
            that.setData({
              memberInfo: memberInfo,
              memberCount: memberCount
            });
          }
        }
      });
    }, _this.getCategory = function (sId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetCategoryByPage',
        data: {
          section_id: sId,
          page: 1,
          page_size: 100,
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data,
                cData = that.data.category;
            cData = cData.concat(info.map(function (item) {
              return Object.assign({
                attr: 'category_id'
              }, pickAttrObject({
                value: 'id',
                name: 'name'
              }, item));
            }));
            cData.splice(1, 0, {
              value: 1,
              attr: 'hot_flag',
              name: '精品'
            });
            that.setData({
              category: cData
            });
            that.getSectionList();
          }
        }
      });
    }, _this.getSectionList = function () {
      var that = _this,
          sdata = that.data.getSectionData;
      if (sdata.loading || sdata.nomore) {
        return;
      }
      sdata.loading = true;
      var param = pickAttrObject({
        section_id: 'communityId',
        category_id: 'activeCategory.value',
        article_style: 'communityInfo.article_style',
        search_value: 'search_value', // 查询值
        sub_app_id: 'franchisee'
      }, _this.data);
      param.page = sdata.page;
      param.page_size = 10;
      param.is_advertise = 1;
      param.is_publish = 1;
      param = Object.assign({}, param, _this.data.listOtherParam);
      if (param.hot_flag > 0) {
        param.category_id = 0;
      }
      if (param.orderby === 'distance') {
        // 距离最近排序需要添加参数order，其他排序不用
        param.order = 'asc';
      } else if ('order' in param) {
        delete param.order;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetArticleByPage',
        data: param,
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data,
                oldData = that.data.sectionList,
                newData = [];
            for (var i = 0; i < info.length; i++) {
              var _idata = info[i];
              if (!_idata.wechat_id) {
                var ctext = that.showEllipsis(_idata.content.text || '');
                _idata.title = unescape(_idata.title.replace(/\\u/g, '%u'));
                _idata.content_text = ctext.text;
                _idata.isellipsis = ctext.isellipsis;
                if (_idata.content.type == 2) {
                  if (_idata.content.url.article) {
                    delete _idata.content.url.article.body;
                    if (_idata.content.url.article.type == 3) {
                      _idata.content.url.article.cover = _app.appMethod.globalData.cdnUrl + '/zhichi_frontend/static/webapp/images/audio_default.png';
                    }
                  }
                }
                var listRecomItem = getRightAttrVal('form_data.list_recommend.recommend_goods[0]', _idata);
                if (listRecomItem) {
                  _idata.form_data.list_recommend.recommend_goods[0] = pickAttrObject({
                    name: 'title',
                    price: 'price',
                    image: 'cover',
                    id: 'id',
                    goods_type: 'goods_type',
                    app_id: 'app_id'
                  }, listRecomItem);
                }
              }
              if ((_idata.style == 2 || _idata.style == 3) && _idata.video_data) {
                _idata['video_url'] = '';
              }
              var date = new Date(_idata.update_time * 1000);
              _idata['month'] = date.getMonth() + 1;
              _idata['day'] = date.getDate();
              if (_idata['month'] < 10) {
                _idata['month'] = '0' + String(_idata['month']);
              }
              if (_idata['day'] < 10) {
                _idata['day'] = '0' + String(_idata['day']);
              }
              _idata.topicMoreOperationModal = {
                index: i,
                isAuthor: _idata.user_token === (_app.appMethod.getUserInfo() || {})['user_token'],
                articleId: _idata.id,
                sectionId: _idata.section_id,
                isChargeTop: !!(_idata.top_flag == 1 && _idata.order_id)
              };
              newData.push(_idata);
            }
            if (sdata.page > 1) {
              newData = oldData.concat(newData);
            }
            that.setData({
              sectionList: newData,
              'getSectionData.page': sdata.page + 1
            });
          }
          that.setData({
            'getSectionData.loading': false,
            'getSectionData.nomore': res.is_more == 0 ? true : false
          });
        },
        fail: function fail(res) {
          that.setData({
            'getSectionData.loading': false
          });
        }
      });
    }, _this.getCarousel = function (sId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetArticleByPage',
        data: {
          page: 1,
          section_id: sId,
          is_carousel: 1,
          orderby: 'id',
          page_size: 10,
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data;
            that.setData({
              carouselImg: info
            });
          }
        }
      });
    }, _this.turnToAdDetail = function (event) {
      if (event.target.dataset.articleType == 3) {
        _this.bindEventTapHandler(event);
        return;
      }
      var id = event.target.dataset.id;
      var franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
      _app.appMethod.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + franchiseeParam);
    }, _this.bindEventTapHandler = function (e) {
      var form = e.target.dataset.eventParams;
      var action = form.action;
      var sub_app_id = _this.data.franchisee;
      if (action && form && sub_app_id) {
        _customEvent.customEvent.clickEventHandler[action](form, sub_app_id);
        return;
      }
      _customEvent.customEvent.clickEventHandler[action] && _customEvent.customEvent.clickEventHandler[action](form);
    }, _this.clickTab = function (e) {
      var that = _this;
      if (_this.data.currentTab === e.target.dataset.current) {
        return false;
      } else {
        that.setData({
          currentTab: e.target.dataset.current
        });
      }
    }, _this.announceModal = function (e) {
      _this.setData({
        closeDec: true,
        noticeDec: e.target.dataset.text
      });
    }, _this.showIcon = function () {
      _this.setData({
        closeDec: true
      });
    }, _this.closeIcon = function () {
      _this.setData({
        closeDec: false
      });
    }, _this.stopEvent = function (e) {
      var that = _this;
      var video_id = e.target.dataset.id;
      var index = e.target.dataset.index;
      var sectionList = that.data.sectionList;
      if (!sectionList[index].video_url) {
        _app.appMethod.getVideoUrlById(video_id, function (res) {
          sectionList[index].video_url = res;
          that.setData({
            sectionList: sectionList,
            video_url: res
          });
        });
      }
      return false;
    }, _this.tapCategory = function (event) {
      var _event$target$dataset = event.target.dataset,
          attr = _event$target$dataset.attr,
          value = _event$target$dataset.value,
          index = _event$target$dataset.index,
          activeCategory = _this.data.category[index],
          newdata = {};

      if (attr === 'hot_flag') {
        newdata['listOtherParam.hot_flag'] = value;
      } else if (attr === 'category_id') {
        newdata['listOtherParam.hot_flag'] = 0;
      }
      newdata.activeCategory = activeCategory;
      newdata.sectionList = [];
      newdata.getSectionData = {
        page: 1,
        loading: false,
        nomore: false
      };
      _this.setData(newdata);
      _this.getSectionList();
    }, _this.onReachBottom = function (event) {
      _this.getSectionList();
    }, _this.oldscrolltop = 0, _this.onPageScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      var showBackTopBtn = _this.data.showBackTopBtn,
          showFlag = scrollTop < _this.oldscrolltop && scrollTop;
      if (showBackTopBtn ^ showFlag) {
        _this.setData({
          showBackTopBtn: showFlag
        });
      }
      _this.oldscrolltop = scrollTop;
    }, _this.bindKeyInput = function (event) {
      var val = event.target.value;
      _this.setData({
        search_value: val
      });
    }, _this.bindconfirmInput = function (event) {
      _this.setData({
        sectionList: [],
        getSectionData: {
          page: 1,
          loading: false,
          nomore: false
        }
      });
      _this.getSectionList();
    }, _this.imgLoad = function (event) {
      var owidth = event.detail.width,
          oheight = event.detail.height,
          index = event.target.dataset.index,
          path = event.target.dataset.path,
          oscale = owidth / oheight,
          cwidth = 290,
          cheight = 120,
          ewidth = void 0,
          eheight = void 0;
      if (_this.data.communityInfo.article_style == 2) {
        cwidth = 240;
      }
      if (oscale > cwidth / cheight) {
        ewidth = cwidth;
        eheight = cwidth / oscale;
      } else {
        ewidth = cheight * oscale;
        eheight = cheight;
      }
      _this.setData((0, _defineProperty3.default)({}, path, 'width:' + ewidth + 'px;height:' + eheight + 'px;'));
    }, _this.showEllipsis = function (oldtext) {
      var that = _this,
          padding = that.data.communityInfo.article_style == 2 ? 70 : 25,
          newtext = '',
          newtextarr = [],
          textarr = oldtext.split(/\n|\\n/),
          eachline = (_app.appMethod.getSystemInfoData().windowWidth - padding) / 12 * 2,
          total_line_num = 2,
          has_line_num = 0,
          isellipsis = false;
      for (var i = 0; i < textarr.length; i++) {
        var len = that.stringLength(textarr[i]),
            lenline = Math.ceil(len / eachline);
        if (has_line_num + lenline >= total_line_num) {
          var spare_line = total_line_num - has_line_num;
          newtextarr.push(that.subString(textarr[i], spare_line * eachline - 16) + '...');
          isellipsis = true;
          break;
        } else {
          has_line_num += lenline;
          newtextarr.push(textarr[i]);
        }
      }
      if (isellipsis) {
        newtext = newtextarr;
      } else {
        newtext = textarr;
      }
      return {
        text: newtext,
        isellipsis: isellipsis
      };
    }, _this.stringLength = function (str) {
      var realLength = 0,
          len = str.length,
          charCode = -1;
      for (var i = 0; i < len; i++) {
        charCode = str.charCodeAt(i);
        if (charCode > 128) {
          realLength += 2;
        } else {
          realLength += 1;
        }
      }
      return realLength;
    }, _this.subString = function (str, len) {
      var newLength = 0,
          newStr = '',
          chineseRegex = /[^\x00-\xff]/g,
          singleChar = '',
          strLength = str.replace(chineseRegex, '**').length;
      for (var i = 0; i < strLength; i++) {
        singleChar = str.charAt(i).toString();
        if (singleChar.match(chineseRegex) != null) {
          newLength += 2;
        } else {
          newLength++;
        }
        if (newLength > len) {
          break;
        }
        newStr += singleChar;
      }
      if (strLength > len) {
        newStr += '...';
      }
      return newStr;
    }, _this.turnToDetail = function (event) {
      if (isTurnToDetail) {
        return;
      }
      isTurnToDetail = true;
      var id = event.currentTarget.dataset.id,
          dataLiked = event.currentTarget.dataset.liked,
          phoneNumber = event.currentTarget.dataset.phone,
          article_style = _this.data.communityInfo.article_style,
          communityId = _this.data.communityId;
      var newData = {};
      newData.sectionList = _this.data.sectionList.map(function (item, idx) {
        if (item.showCom) {
          delete item.showCom;
        }
        if (item.id === id) {
          item.read_count = +item.read_count + 1;
        }
        return item;
      });
      _this.setData(newData);
      var franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
      _app.appMethod.turnToPage('/informationManagement/pages/communityDetail/communityDetail?detail=' + id + '&articleStyle=' + article_style + '&dataLiked=' + dataLiked + '&phoneNumber=' + phoneNumber + '&sectionid=' + communityId + franchiseeParam);
      isTurnToDetail = false;
    }, _this.turnToUsercenter = function (event) {
      var userInfo = _app.appMethod.getUserInfo();
      if (!userInfo || !userInfo.user_token) {
        _app.appMethod.showModal({
          content: '您暂未登陆，请先登陆'
        });
        return;
      }
      var _event$target$dataset2 = event.target.dataset,
          usertoken = _event$target$dataset2.usertoken,
          sourcetype = _event$target$dataset2.sourcetype;

      var franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
      if (usertoken) {
        franchiseeParam += '&usertoken=' + usertoken + '&sourcetype=' + sourcetype;
      }
      _app.appMethod.turnToPage('/informationManagement/pages/communityUsercenter/communityUsercenter?detail=' + _this.data.communityId + franchiseeParam);
    }, _this.turnToNotify = function (event) {
      var franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '';
      var sectionCommentLikeCounts = _this.data.sectionCommentLikeCounts;
      var commentCount = sectionCommentLikeCounts.comment_count;
      var likeCount = sectionCommentLikeCounts.like_count;
      var showType = sectionCommentLikeCounts.show_type;
      var commentLikeInfo = (commentCount > 0 ? '&comment=' + commentCount : '') + (likeCount > 0 ? '&like=' + likeCount : '') + '&showtype=' + showType;
      _app.appMethod.turnToPage('/informationManagement/pages/communityNotify/communityNotify?detail=' + _this.data.communityId + franchiseeParam + commentLikeInfo);
    }, _this.turnToPublish = function (event) {
      _this.setData({
        'communityPublishType.show': true,
        'communityPublishType.communityPublish': {
          franchisee: _this.data.franchisee,
          detail: _this.data.communityId,
          reqAudit: _this.data.communityInfo.require_audit,
          from: 'communityPage'
        }
      });
    }, _this.eventStoppropagation = function (event) {
      event.stopPropagation();
    }, _this.turnComment = function (event) {
      var requireArticlePost = _this.data.communityInfo.require_article_post;
      var requireArticleComment = _this.data.communityInfo.require_article_comment;
      if (requireArticlePost == 0 || requireArticleComment == 0) {
        _app.appMethod.showModal({
          content: '当前话题圈组不允许评论'
        });
        return;
      }
      var _event$currentTarget$ = event.currentTarget.dataset,
          sectionId = _event$currentTarget$.sectionId,
          commentId = _event$currentTarget$.commentId,
          parentCommentId = _event$currentTarget$.parentCommentId,
          replyto = _event$currentTarget$.replyto,
          articleId = _event$currentTarget$.articleId,
          index = _event$currentTarget$.index,
          agentUserToken = _event$currentTarget$.agentUserToken;

      var newData = {};
      if (_this.data.communityInfo.article_style == 2) {
        newData['sectionList[' + index + '].showCom'] = false;
      }
      newData['showReplyBox'] = true;
      newData['replyPlaceholder'] = '评论话题...';
      newData['replyParam.section_id'] = sectionId;
      newData['replyParam.article_id'] = articleId;
      newData['replyParam.comment_id'] = commentId;
      newData['replyParam.parent_comment_id'] = parentCommentId;
      newData['replyParam.agent_user_token'] = agentUserToken;
      _this.setData(newData);
      setTimeout(function () {
        _this.setData({
          replyBoxFocus: true
        });
      }, 500);
    }, _this.articleLike = function (event) {
      var that = _this,
          liked = event.currentTarget.dataset.liked,
          id = event.currentTarget.dataset.id,
          index = event.currentTarget.dataset.index,
          likeCount = +event.currentTarget.dataset.likeCount;
      if (likeTap) {
        return;
      }
      likeTap = true;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppSNS/PerformLike',
        data: {
          obj_type: 1, // obj_type 1-话题 2-评论
          obj_id: id, // obj_id 话题或评论的id
          sub_app_id: that.data.franchisee || _app.appMethod.getChainId()
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            if (liked == 1) {
              var newData = {};
              newData['sectionList[' + index + '].is_liked'] = 0;
              newData['sectionList[' + index + '].like_count'] = likeCount - 1;
              that.setData(newData);
              _app.appMethod.showToast({
                title: '点赞取消'
              });
            } else {
              var _newData = {};
              _newData['sectionList[' + index + '].is_liked'] = 1;
              _newData['sectionList[' + index + '].like_count'] = likeCount + 1;
              that.setData(_newData);
              _app.appMethod.showToast({
                title: '点赞成功'
              });
            }
            that.getArticleLikeImgs(event);
            setTimeout(function () {
              var newData = {};
              newData['sectionList[' + index + '].showCom'] = false;
              that.setData(newData);
            }, 480);
            that.getSectionCommentLikeCount();
          }
        },
        complete: function complete() {
          likeTap = false;
        }
      });
    }, _this.showCommentBox = function (event) {
      event.stopPropagation();
      var index = event.currentTarget.dataset.index,
          flag = _this.data.sectionList[index].showCom,
          newData = {};
      newData.sectionList = _this.data.sectionList.map(function (item, idx) {
        if (item.showCom) {
          delete item.showCom;
        }
        return item;
      });
      if (!flag) {
        newData.sectionList[index].showCom = true;
      }
      _this.setData(newData);
    }, _this.getArticleLikeImgs = function (event) {
      var that = _this,
          id = event.target.dataset.id,
          index = event.target.dataset.index;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppSNS/GetLikeLogByPage',
        data: {
          obj_type: 1, // obj_type 1-话题 2-评论
          obj_id: id, // obj_id 话题或评论的id
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var dataArr = res.data,
                headImgArr = [],
                newData = {};
            dataArr.map(function (item, idx) {
              headImgArr.push({
                headimgurl: item.headimgurl,
                nickname: item.nickname
              });
            });
            newData['sectionList[' + index + '].like'] = headImgArr;
            that.setData(newData);
          }
        }
      });
    }, _this.showActionSheet = function (event) {
      if (_this.data.topicMoreOperationModal.show) {
        _this.setData({
          'topicMoreOperationModal.show': false
        });
      }
      var that = _this,
          telNum = event.target.dataset.tel,
          telArr = [telNum.substr(0, 3), telNum.substr(3, 4), telNum.substr(7)],
          isIphone = /ios/i.test(_app.appMethod.globalData.systemInfo.platform);
      if (isIphone) {
        _app.appMethod.makePhoneCall({
          phoneNumber: telNum,
          success: function success() {},
          fail: function fail() {}
        });
      } else {
        that.setData({
          phoneNumCall: telArr.join('-'),
          showActionSheet: true
        });
      }
    }, _this.backPageTop = function (event) {
      _app.appMethod.pageScrollTo({
        scrollTop: 0
      });
    }, _this.onShareAppMessage = function (res) {
      if (_this.data.topicMoreOperationModal.show) {
        _this.setData({
          'topicMoreOperationModal.show': false
        });
      }
      var shareTitle = _this.data.communityInfo.name;
      var sharePath = '/informationManagement/pages/communityPage/communityPage';
      if (res && res.from === 'button') {
        var index = res.target.dataset.index,
            id = res.target.dataset.id,
            articleTitle = _this.data.sectionList[index].title,
            franchiseeParam = _this.data.franchisee ? '&franchisee=' + _this.data.franchisee : '',
            articlePath = '/informationManagement/pages/communityDetail/communityDetail?detail=' + id + franchiseeParam;
        shareTitle = articleTitle;
        sharePath = articlePath;
      }
      sharePath += '&from_share=1';
      return _app.appMethod.shareAppMessage({
        title: shareTitle,
        path: sharePath,
        success: function success(res) {
          _app.appMethod.showToast({
            title: '转发成功'
          });
        },
        fail: function fail(res) {}
      });
    }, _this.stopPropagation = function (event) {}, _this.closeActionSheet = function (event) {
      _this.setData({
        showActionSheet: false
      });
    }, _this.makePhoneCall = function (event) {
      var phoneNumCall = _this.data.phoneNumCall;
      _app.appMethod.makePhoneCall({
        phoneNumber: phoneNumCall.replace(/\-/g, ''),
        success: function success() {},
        fail: function fail() {
          _app.appMethod.showModal({
            content: '播打电话失败'
          });
        }
      });
      _this.closeActionSheet();
    }, _this.cancelReply = function () {
      _this.setData({
        showReplyBox: false,
        replyBoxFocus: false
      });
      _this.clearCommentInput();
    }, _this.replyInput = function (event) {
      _this.setData({
        'replyParam.text': event.target.value
      });
    }, _this.replyTimer = null, _this.submitReply = function (event, repeat) {
      var that = _this,
          _this$data = _this.data,
          replyParam = _this$data.replyParam,
          franchisee = _this$data.franchisee;

      if (_this.replyTimer) {
        clearTimeout(_this.replyTimer);
        _this.replyTimer = null;
      }
      replyParam.text = replyParam.text.trim(); // 去除两端的空格
      if (!replyParam.text) {
        if (repeat === undefined) {
          _this.replyTimer = setTimeout(function () {
            return _this.submitReply(event, true);
          }, 500);
          return;
        }
        _app.appMethod.showModal({
          content: '请填写回复内容'
        });
        return;
      }
      if (isReply) {
        return;
      }
      isReply = true;
      if (!replyParam.sub_app_id && franchisee) {
        // 子店话题详情回复评论
        replyParam.sub_app_id = franchisee;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/AddComment',
        data: replyParam,
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            _app.appMethod.showToast({
              title: '回复成功',
              success: function success() {
                that.setData({
                  showReplyBox: false,
                  replyBoxFocus: false
                });
              }
            });
            that.relatePagesRefresh();
            that.clearCommentInput();
          }
          that.refreshOneTopicData({
            articleId: replyParam.article_id
          });
          that.getSectionCommentLikeCount();
        },
        complete: function complete(res) {
          isReply = false;
        }
      });
    }, _this.tapPrevewPictureHandler = function (e) {
      _app.appMethod.tapPrevewPictureHandler(e);
    }, _this.replyFocus = function (e) {
      if (e.detail.height) {
        var curKbHeight = e.detail.height;
        kbHeight = e.detail.height;
        if (/iPhone\s?X/i.test(_app.appMethod.globalData.systemInfo.model)) {
          curKbHeight = 365;
        }
        _this.setData({
          replyBoxFocus: true,
          keyboardHeight: curKbHeight + 'px'
        });
        return;
      }
      _this.setData({
        replyBoxFocus: true
      });
    }, _this.replyBlur = function (e) {
      _this.setData({
        replyBoxFocus: false,
        'replyParam.text': e.detail.value
      });
    }, _this.tapShowSortModal = function () {
      _this.setData((0, _defineProperty3.default)({}, 'sortModal.show', true));
    }, _this.tapCloseSortModal = function () {
      _this.setData((0, _defineProperty3.default)({}, 'sortModal.show', false));
    }, _this.tapSelectSortItem = function (e) {
      var _this$setData4;

      var that = _this;
      var _e$target$dataset = e.target.dataset,
          orderby = _e$target$dataset.orderby,
          name = _e$target$dataset.name;

      _this.setData((_this$setData4 = {}, (0, _defineProperty3.default)(_this$setData4, 'listOtherParam.orderby', orderby), (0, _defineProperty3.default)(_this$setData4, 'currentSortbyName', name), (0, _defineProperty3.default)(_this$setData4, 'getSectionData', {
        page: 1,
        loading: false,
        nomore: false
      }), _this$setData4));
      if (orderby === 'distance' && !_this.data.listOtherParam.latitude) {
        _this.getCurrentLocation().then(function (_ref3) {
          var _that$setData;

          var latitude = _ref3.latitude,
              longitude = _ref3.longitude;

          that.setData((_that$setData = {}, (0, _defineProperty3.default)(_that$setData, 'listOtherParam.latitude', latitude), (0, _defineProperty3.default)(_that$setData, 'listOtherParam.longitude', longitude), _that$setData));
          _this.getSectionList();
        }).catch(function (err) {
          console.log(err);
        });
        return;
      }
      _this.getSectionList();
    }, _this.getCurrentLocation = function () {
      var locationInfo = _app.appMethod.globalData.locationInfo;
      return new Promise(function (resolve, reject) {
        if (locationInfo.latitude) {
          resolve(locationInfo);
        }
        _app.appMethod.getLocation({
          success: resolve,
          fail: reject
        });
      });
    }, _this.replyLineChange = function (e) {
      var that = _this;
      var lineHeight = 40;
      var marginTop = 45;
      var commentContentHeight = lineHeight;
      var maxHeight = _this.data.commentContentMaxHeight;
      _app.appMethod.getBoundingClientRect('#comment-box', function (rect) {
        if (Array.isArray(rect) && rect[0]) {
          commentContentHeight = e.detail.lineCount * lineHeight;
          if (rect[0].top > marginTop && e.detail.lineCount >= 1) {
            if (rect[0].top - marginTop <= lineHeight) {
              maxHeight = commentContentHeight + lineHeight;
              that.setData({
                commentContentMaxHeight: maxHeight
              });
            }
            that.setData({
              commentContentHeight: commentContentHeight
            });
          }
          if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
            that.setData({
              commentContentHeight: commentContentHeight
            });
          }
        }
      });
    }, _this.replyImageChoose = function () {
      var that = _this;
      _app.appMethod.chooseImage(function (imageUrls) {
        that.setData((0, _defineProperty3.default)({}, 'replyParam.comment_img_url', imageUrls[0]));
      }, 1);
    }, _this.replyImagePreview = function () {
      var commentImage = _this.data.replyParam.comment_img_url;
      _app.appMethod.previewImage({
        current: commentImage
      });
    }, _this.replyImageDelete = function () {
      _this.setData((0, _defineProperty3.default)({}, 'replyParam.comment_img_url', ''));
    }, _this.replyLocationChoose = function () {
      var that = _this;
      _app.appMethod.chooseLocation({
        success: function success(_ref4) {
          var name = _ref4.name,
              address = _ref4.address,
              latitude = _ref4.latitude,
              longitude = _ref4.longitude;

          var newdata = {};
          newdata['replyParam.latitude'] = latitude;
          newdata['replyParam.longitude'] = longitude;
          if (name || address) {
            newdata['replyParam.address'] = name || address;
          } else {
            that.getLocByLatAndLng(latitude, longitude, function (res) {
              address = res.address || '';
              that.setData((0, _defineProperty3.default)({}, 'replyParam.address', address));
            });
          }
          that.setData(newdata);
        }
      });
    }, _this.replyLocationDelete = function () {
      var _this$setData6;

      _this.setData((_this$setData6 = {}, (0, _defineProperty3.default)(_this$setData6, 'replyParam.address', ''), (0, _defineProperty3.default)(_this$setData6, 'replyParam.latitude', ''), (0, _defineProperty3.default)(_this$setData6, 'replyParam.longitude', ''), _this$setData6));
    }, _this.turnToGoodsDetail = function (event) {
      var dataset = event.target.dataset;
      var id = dataset.id;
      var style = dataset.goodsType;
      var appId = dataset.appId;
      var franchiseeId = appId === _app.appMethod.getAppId() ? _this.data.franchisee : appId;
      var franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
      if (style == 3) {
        _app.appMethod.turnToPage('/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam);
      } else {
        _app.appMethod.turnToPage('/detailPage/pages/goodsDetail/goodsDetail?detail=' + id + franchiseeParam);
      }
    }, _this.getLocByLatAndLng = function (lat, lng, cb) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
        data: {
          latitude: lat,
          longitude: lng
        },
        method: 'post',
        success: function success(data) {
          if (data.status == 0 && typeof cb == 'function') {
            cb(data.data);
          }
        }
      });
    }, _this.clearCommentInput = function () {
      var _this$setData7;

      _this.setData((_this$setData7 = {}, (0, _defineProperty3.default)(_this$setData7, 'replyParam.text', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.agent_user_token', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.address', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.latitude', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.longitude', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.comment_img_url', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.comment_id', ''), (0, _defineProperty3.default)(_this$setData7, 'replyParam.parent_comment_id', ''), _this$setData7));
    }, _this.suspensionTouchEvent = function (e) {
      var _this$systemInfo = _this.systemInfo,
          windowWidth = _this$systemInfo.windowWidth,
          windowHeight = _this$systemInfo.windowHeight;
      var _e$touches$ = e.touches[0],
          clientX = _e$touches$.clientX,
          clientY = _e$touches$.clientY;

      if (e.type === 'touchstart') {
        var _e$target = e.target,
            offsetLeft = _e$target.offsetLeft,
            offsetTop = _e$target.offsetTop;

        var itemOffsetWidth = windowWidth / 750 * 80,
            itemOffsetHeight = windowWidth / 750 * 100,
            count = _this.data.showBackTopBtn ? 3 : 2;
        if (_this.data.communityInfo.require_custom_service != 1) {
          // 考虑关闭客服情况
          count = count - 1;
        }
        _this.suspensionStyle = {
          width: itemOffsetWidth,
          height: itemOffsetHeight * count,
          deltX: clientX - offsetLeft,
          deltY: clientY - offsetTop
        };
        return;
      }
      var _this$suspensionStyle = _this.suspensionStyle,
          width = _this$suspensionStyle.width,
          height = _this$suspensionStyle.height,
          deltX = _this$suspensionStyle.deltX,
          deltY = _this$suspensionStyle.deltY;

      var leftVal = clientX - deltX;
      var topVal = clientY - deltY;
      var maxLeftVal = windowWidth - width;
      var maxTopVal = windowHeight - height;
      leftVal < 0 && (rightVal = 0);
      leftVal > maxLeftVal && (leftVal = maxLeftVal);
      topVal < 0 && (topVal = 0);
      topVal > maxTopVal && (topVal = maxTopVal);
      _this.setData({
        suspensionStyle: 'top:' + topVal + 'px;left:' + leftVal + 'px;'
      });
    }, _this.showTopicOperateModal = function (event) {
      var dataset = event.target.dataset;
      var index = dataset.index;
      var targetTopic = _this.data.sectionList[index];
      var topicMoreOperationModal = _this.data.topicMoreOperationModal;
      var articleStyle = _this.data.communityInfo.article_style;
      var newData = {
        'topicMoreOperationModal.show': true,
        'topicMoreOperationModal.index': index,
        'topicMoreOperationModal.isAuthor': targetTopic.user_token === (_app.appMethod.getUserInfo() || {})['user_token'],
        'topicMoreOperationModal.articleId': targetTopic.id,
        'topicMoreOperationModal.sectionId': targetTopic.section_id,
        'topicMoreOperationModal.isChargeTop': !!(targetTopic.top_flag == 1 && targetTopic.order_id)
      };
      if (topicMoreOperationModal.mode != articleStyle) {
        newData['topicMoreOperationModal.mode'] = articleStyle;
      }
      if (topicMoreOperationModal.franchisee !== _this.data.franchisee) {
        newData['topicMoreOperationModal.franchisee'] = _this.data.franchisee;
      }
      if (_this.data.communityInfo.require_phone == 1 && targetTopic.phone) {
        newData['topicMoreOperationModal.phone'] = targetTopic.phone;
      }
      _this.setData(newData);
    }, _this.cancelTopicMoreOperate = function () {
      _this.setData({
        topicMoreOperationModal: {
          mode: '', // 话题风格
          show: false, // 是否显示话题操作弹窗
          index: 0, // 当前被操作话题下标
          isAuthor: false, // 是否是作者自己的话题
          articleId: '', // 话题id
          sectionId: '', // 版块id
          franchisee: '', // 子店app_id
          isChargeTop: false, // 是否为置顶收费话题
          phone: ''
        }
      });
    }, _this.deleteTopicAct = function (event) {
      var that = _this;
      var data = event.target.dataset.data;
      var index = data.index;
      var articleId = data.articleId;
      var sectionId = data.sectionId;
      var isChargeTop = data.isChargeTop;
      var franchiseeId = data.franchisee;
      var content = isChargeTop ? '该话题为付费置顶话题，' : '';
      content += '是否删除这个话题？';
      _app.appMethod.showModal({
        content: content,
        showCancel: true,
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppSNS/DeleteArticle',
            data: {
              article_id: articleId,
              section_id: sectionId,
              sub_app_id: franchiseeId || that.data.franchisee
            },
            method: 'post',
            success: function success(res) {
              var list = that.data.sectionList;
              list.splice(index, 1);
              that.setData({
                sectionList: list
              });
              that.getSectionInfo(sectionId);
              that.cancelTopicMoreOperate();
              _app.appMethod.globalData.communityPageRefresh = true;
              _app.appMethod.showModal({
                content: '删除成功'
              });
            }
          });
        }
      });
    }, _this.getSectionCommentLikeCount = function (sectionId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetSectionCommentOrLikeCount',
        data: {
          section_id: sectionId || _this.data.communityId,
          sub_app_id: that.data.franchisee
        },
        success: function success(res) {
          var data = res.data;
          that.setData({
            sectionCommentLikeCounts: data
          });
        }
      });
    }, _this.refreshOneTopicData = function (param) {
      if (!param.articleId) {
        return;
      }
      var that = _this;
      var index = _this.data.sectionList.findIndex(function (article) {
        return article.id === param.articleId;
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppSNS/GetArticleByPage',
        data: {
          article_id: param.articleId,
          sub_app_id: that.data.franchisee,
          page: 1,
          page_size: 10
        },
        method: 'post',
        success: function success(res) {
          if (!res.data.length) {
            return;
          }
          var topic = res.data[0];
          if (topic.form_data.list_recommend && topic.form_data.list_recommend.recommend_goods && topic.form_data.list_recommend.recommend_goods[0]) {
            var _topic$form_data$list = topic.form_data.list_recommend.recommend_goods[0],
                title = _topic$form_data$list.title,
                price = _topic$form_data$list.price,
                cover = _topic$form_data$list.cover,
                id = _topic$form_data$list.id,
                goods_type = _topic$form_data$list.goods_type,
                app_id = _topic$form_data$list.app_id;

            topic.form_data.list_recommend.recommend_goods[0] = {
              name: title,
              price: price,
              image: cover,
              id: id,
              goods_type: goods_type,
              app_id: app_id
            };
          }
          topic.topicMoreOperationModal = {
            index: index,
            isAuthor: idata.user_token === (_app.appMethod.getUserInfo() || {})['user_token'],
            articleId: idata.id,
            sectionId: idata.section_id,
            isChargeTop: !!(idata.top_flag == 1 && idata.order_id)
          };
          if (index > -1) {
            that.setData((0, _defineProperty3.default)({}, 'sectionList[' + index + ']', topic));
          }
        },
        fail: function fail() {}
      });
    }, _this.relatePagesRefresh = function () {
      _app.appMethod.globalData.topicRefresh = true;
      _app.appMethod.globalData.communityPageRefresh = true;
      _app.appMethod.globalData.communityUsercenterRefresh = true;
      _app.appMethod.globalData.franchiseeCommunity = true;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CommunityPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _setData,
          _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var communityId = options.detail;
      var that = this;
      var franchisee = options.franchisee || '';
      this.setData((_setData = {
        communityId: communityId,
        franchisee: franchisee
      }, (0, _defineProperty3.default)(_setData, 'replyParam.sub_app_id', franchisee), (0, _defineProperty3.default)(_setData, 'sessionFrom', options.franchisee || _app.appMethod.getAppId() || ''), _setData));
      _app.appMethod.globalData.communityPageRefresh = false;
      if (_app.appMethod.isLogin()) {
        that.getSectionInfo(communityId, function () {
          that.getMemberInfo(communityId);
          that.getCategory(communityId);
        });
        this.setData({
          vistorUserToken: (_app.appMethod.getUserInfo() || {})['user_token'] || ''
        });
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getSectionInfo(communityId, function () {
              that.getMemberInfo(communityId);
              that.getCategory(communityId);
            });
            that.setData({
              vistorUserToken: (_app.appMethod.getUserInfo() || {})['user_token'] || ''
            });
          }
        });
      }
      this.systemInfo = _app.appMethod.getSystemInfoSync();
      this.getSysnInfoTimer = setTimeout(function () {
        var systemInfo = _app.appMethod.getSystemInfoSync();
        if (systemInfo.windowHeight !== _this2.systemInfo.windowHeight) {
          _this2.systemInfo = systemInfo;
        }
      }, 500);
      that.getSectionCommentLikeCount();
    }
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {
      if (_app.appMethod.globalData.communityPageRefresh) {
        this.setData({
          getSectionData: {
            page: 1,
            loading: false,
            nomore: false
          },
          sectionList: []
        });
        _app.appMethod.globalData.communityPageRefresh = false;
        this.getSectionList();
        this.getSectionCommentLikeCount();
      }
      isTurnToDetail = false;
    }
  }, {
    key: 'privateStopNoop',
    value: function privateStopNoop(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          backTop = _state.backTop,
          communityInfo = _state.communityInfo,
          sectionCommentLikeCounts = _state.sectionCommentLikeCounts,
          carouselImg = _state.carouselImg,
          hasCarousel = _state.hasCarousel,
          memberInfo = _state.memberInfo,
          memberCount = _state.memberCount,
          currentTab = _state.currentTab,
          closeDec = _state.closeDec,
          noticeDec = _state.noticeDec,
          categoryActive = _state.categoryActive,
          activeCategory = _state.activeCategory,
          category = _state.category,
          currentSortbyName = _state.currentSortbyName,
          sortModal = _state.sortModal,
          sectionList = _state.sectionList,
          topic = _state.topic,
          vistorUserToken = _state.vistorUserToken,
          video_url = _state.video_url,
          getSectionData = _state.getSectionData,
          suspensionStyle = _state.suspensionStyle,
          showBackTopBtn = _state.showBackTopBtn,
          showActionSheet = _state.showActionSheet,
          phoneNumCall = _state.phoneNumCall,
          listOtherParam = _state.listOtherParam,
          showReplyBox = _state.showReplyBox,
          replyBoxFocus = _state.replyBoxFocus,
          keyboardHeight = _state.keyboardHeight,
          replyPlaceholder = _state.replyPlaceholder,
          replyParam = _state.replyParam,
          commentContentHeight = _state.commentContentHeight;

      return React.createElement(
        'div',
        { className: 'official-page community-page' },
        React.createElement(_TopNav.TopNav, { title: '\u5708\u7EC4' }),
        React.createElement(
          'div',
          {
            className: 'communityPage-wrap',
            id: 'communityPage',
            scrolly: 'true',
            scrollx: 'false'
            // onScrollToLower={this.scrollTolower}
            , onScroll: this.scrollEvent,
            lowerthreshold: '100',
            scrolltop: backTop
          },
          React.createElement(
            'div',
            {
              className: 'communityPage-head ' + (communityInfo.require_article_post == 1 ? '' : 'fullSearch'),
              hidden: communityInfo.article_style == 3
            },
            React.createElement(
              'div',
              { className: 'communityPage-search' },
              React.createElement(
                'div',
                {
                  className: 'communityPage-search-btn',
                  onClick: this.bindconfirmInput
                },
                React.createElement(_icon2.default, { size: 'xxs', type: 'search', color: '#999' })
              ),
              React.createElement('input', {
                className: 'communityPage-search-input',
                id: 'communityPage-search-input',
                type: 'text',
                maxLength: '64',
                onInput: this.bindKeyInput,
                onClick: this.bindconfirmInput,
                placeholder: '\u641C\u7D22',
                placeholderstyle: 'color: #59607b;'
              })
            ),
            communityInfo.require_article_post == 1 && React.createElement('div', {
              className: 'communityPage-notify-btn ico-moon icon-communityPage-news' + ((sectionCommentLikeCounts.comment_count > 0 || sectionCommentLikeCounts.like_count > 0) && ' have-messages' || ''),
              onClick: this.turnToNotify,
              style: (0, _tools.convertLineStyleData)('color:' + communityInfo.theme_color + ';')
            }),
            communityInfo.require_article_post == 1 && React.createElement('div', {
              className: 'communityPage-topic-btn ico-moon icon-usercenter',
              onClick: this.turnToUsercenter,
              style: (0, _tools.convertLineStyleData)('color:' + communityInfo.theme_color + ';')
            })
          ),
          carouselImg.length > 0 && React.createElement(
            'div',
            {
              className: 'communityPage-banner',
              hidden: communityInfo.article_style == 3
            },
            React.createElement(
              _carousel2.default,
              {
                className: 'communityPage-carousel',
                circular: 'true',
                id: 'communityPage-carousel',
                indicatorDots: 'true',
                autoplay: 'true',
                interval: '5000',
                duration: '1000',
                indicatorColor: 'rgba(255,255,255,.45)',
                indicatorActiveColor: 'rgba(255,255,255,1)'
              },
              carouselImg.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    key: index,
                    'data-id': item.id,
                    style: (0, _tools.convertLineStyleData)("height: 3.5rem"),
                    onClick: _this3.turnToDetail
                  },
                  React.createElement('img', {
                    src: item.carousel_img,
                    className: 'slide-image',
                    lazyload: 'true'
                  })
                );
              })
            )
          ),
          React.createElement(
            'div',
            {
              className: 'communityPage-main',
              hidden: communityInfo.article_style == 3
            },
            React.createElement(
              'div',
              {
                className: 'communityPage-info ' + (hasCarousel ? '' : 'nobanner'),
                style: (0, _tools.convertLineStyleData)('background-image: url(' + (hasCarousel ? '' : communityInfo.background_pic || communityInfo.img) + ');')
              },
              React.createElement('img', {
                className: 'communityPage-img',
                src: communityInfo.img,
                lazyload: 'true'
              }),
              React.createElement(
                'div',
                null,
                React.createElement(
                  'span',
                  { className: 'communityPage-title' },
                  communityInfo.name
                ),
                React.createElement(
                  'div',
                  { className: 'communityPage-num' },
                  communityInfo.require_article_post == 1 && React.createElement(
                    'span',
                    null,
                    '\u8BDD\u9898',
                    React.createElement(
                      'span',
                      { className: 'communityPage-topic-num' },
                      communityInfo.xcx_article_count
                    )
                  ),
                  communityInfo.require_article_post == 1 && React.createElement(
                    'span',
                    null,
                    '\u56DE\u590D',
                    React.createElement(
                      'span',
                      { className: 'communityPage-comment-num' },
                      communityInfo.xcx_comment_count
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'communityPage-headImg' },
                  memberInfo[0] && memberInfo[0].headimgurl && React.createElement('img', {
                    className: 'headImg',
                    src: memberInfo[0].headimgurl
                  }),
                  memberInfo[1] && memberInfo[1].headimgurl && React.createElement('img', {
                    className: 'headImg',
                    src: memberInfo[1].headimgurl
                  }),
                  memberInfo[2] && memberInfo[2].headimgurl && React.createElement('img', {
                    className: 'headImg',
                    src: memberInfo[2].headimgurl
                  }),
                  memberInfo[3] && memberInfo[3].headimgurl && React.createElement('img', {
                    className: 'headImg',
                    src: memberInfo[3].headimgurl
                  }),
                  memberInfo[4] && memberInfo[4].headimgurl && React.createElement('img', {
                    className: 'headImg',
                    src: memberInfo[4].headimgurl
                  }),
                  React.createElement(
                    'span',
                    { className: 'communityPage-description' },
                    memberCount + '个用户参与'
                  )
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'notice-section' },
              React.createElement(
                'div',
                { className: 'notice-items' },
                React.createElement(
                  'div',
                  {
                    className: 'notice-item ' + (currentTab == 0 ? 'current' : ''),
                    'data-current': '0',
                    onClick: this.clickTab
                  },
                  '\u516C\u544A'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'notice-item ' + (currentTab == 1 ? 'current' : ''),
                    'data-current': '1',
                    onClick: this.clickTab
                  },
                  '\u7B80\u4ECB'
                ),
                React.createElement(
                  'div',
                  {
                    className: 'notice-item ' + (currentTab == 2 ? 'current' : ''),
                    'data-current': '2',
                    onClick: this.clickTab
                  },
                  '\u6210\u5458'
                )
              ),
              React.createElement(
                'div',
                { className: 'notice-content' },
                communityInfo.section_notice && communityInfo.section_notice[0] && React.createElement(
                  'div',
                  {
                    className: 'content-announce ' + (currentTab == 0 ? 'show' : 'hidden')
                  },
                  React.createElement('div', { className: 'announce-icon ico-moon icon-announce2' }),
                  React.createElement(
                    _carousel2.default,
                    {
                      className: 'announce-textList',
                      vertical: 'true',
                      autoplay: 'true',
                      circular: 'true',
                      interval: '5000'
                    },
                    communityInfo.section_notice.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        React.createElement(
                          'div',
                          {
                            className: 'announce-one',
                            'data-text': item,
                            onClick: _this3.announceModal
                          },
                          item
                        )
                      );
                    })
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'announceModal',
                    style: (0, _tools.convertLineStyleData)('display:' + (closeDec ? 'block' : 'none')),
                    onClick: this.closeIcon
                  },
                  React.createElement(
                    'div',
                    {
                      className: 'announce-description',
                      onClick: this.showIcon
                    },
                    React.createElement(
                      'div',
                      { className: 'closeButton', onClick: this.closeIcon },
                      React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/close.png' })
                    ),
                    React.createElement(
                      'div',
                      { className: 'closeModal' },
                      noticeDec
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'content-desc ' + (currentTab == 1 ? 'show' : 'hidden'),
                    'data-text': communityInfo.description,
                    style: (0, _tools.convertLineStyleData)(currentTab == 1 ? 'display: -webkit-box;' : ''),
                    onClick: this.announceModal
                  },
                  React.createElement(
                    'span',
                    { className: 'desc-text' },
                    communityInfo.description
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'content-member ' + (currentTab == 2 ? 'show' : 'hidden')
                  },
                  memberInfo.map(function (item, index) {
                    return React.createElement(
                      'div',
                      { className: 'member-item', key: index },
                      React.createElement(
                        'div',
                        {
                          className: 'member-icon',
                          onClick: _this3.turnToUsercenter,
                          'data-usertoken': item.user_token
                        },
                        React.createElement('img', { src: item.headimgurl })
                      ),
                      React.createElement(
                        'span',
                        { className: 'member-name' },
                        item.nickname
                      )
                    );
                  })
                )
              )
            ),
            React.createElement(
              'div',
              { className: 'category-section' },
              React.createElement(
                'div',
                { className: 'communityPage-category', id: 'communityPage-topic' },
                category.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      key: index,
                      className: 'navli ' + (categoryActive == item.value ? 'active' : ''),
                      style: (0, _tools.convertLineStyleData)('color:' + (activeCategory.attr == item.attr && activeCategory.value == item.value ? communityInfo.theme_color : '') + ';border-color:' + (activeCategory.attr == item.attr && activeCategory.value == item.value ? communityInfo.theme_color : '') + ';'),
                      'data-value': item.value,
                      'data-attr': item.attr,
                      'data-index': index,
                      onClick: _this3.tapCategory
                    },
                    item.name
                  );
                })
              ),
              React.createElement(
                'div',
                {
                  className: 'sort-present-aside',
                  onClick: this.tapShowSortModal
                },
                React.createElement(
                  'span',
                  null,
                  currentSortbyName || '默认排序'
                )
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'communityPage-type-3-header',
              hidden: communityInfo.article_style != 3
            },
            React.createElement('img', {
              className: 'communityPage-header-background',
              src: communityInfo.background_pic || communityInfo.img
            }),
            React.createElement(
              'div',
              { className: 'communityPage-header-name' },
              communityInfo.name
            ),
            React.createElement('img', {
              className: 'communityPage-header-image',
              src: communityInfo.headimgurl
            })
          ),
          React.createElement(
            'div',
            { className: 'communityPage-list' },
            React.createElement(
              'div',
              { className: 'communityPage-ul', id: 'communityPage-ul' },
              sectionList.map(function (item, sInd) {
                return React.createElement(
                  'div',
                  { key: sInd },
                  !item.article_type && !item.wechat_id && communityInfo.article_style == 0 && React.createElement(
                    'div',
                    {
                      className: 'tcommunity-topic-type-2',
                      'data-liked': item.is_liked,
                      'data-id': item.id,
                      'data-phone': item.phone
                    },
                    React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        {
                          className: 'card-headimgurl',
                          onClick: _this3.turnToUsercenter,
                          'data-usertoken': item.user_token,
                          'data-sourcetype': item.source_type
                        },
                        React.createElement('img', {
                          src: item.headimgurl,
                          'data-headimgurl': item.headimgurl,
                          lazyload: 'true'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'card-authorInfo' },
                        React.createElement(
                          'span',
                          { className: 'card-publish-author' },
                          item.nickname
                        ),
                        item.top_flag == 1 && React.createElement('span', { className: 'community-stick' }),
                        item.hot_flag == 1 && React.createElement('span', { className: 'community-hot' }),
                        React.createElement(
                          'div',
                          { className: 'card-publish-time' },
                          item.add_time
                        )
                      ),
                      React.createElement('span', {
                        className: 'ico-moon icon-more',
                        'data-index': sInd,
                        onClick: _this3.showTopicOperateModal
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'card-title', onClick: _this3.turnToDetail },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      {
                        className: 'card-description',
                        style: (0, _tools.convertLineStyleData)('color:#333;font-size:30rpx;'),
                        onClick: _this3.turnToDetail
                      },
                      item.content.text
                    ),
                    item.content.imgs && item.content.imgs[0] && React.createElement(
                      'div',
                      { className: 'card-decImg' },
                      React.createElement('img', {
                        src: item.content.imgs[0],
                        mode: 'aspectFill',
                        'data-img': item.content.imgs[0],
                        'data-imgarr': item.content.imgs,
                        onClick: _this3.tapPrevewPictureHandler,
                        lazyload: 'true'
                      })
                    ),
                    item.content.type == 2 && item.content.url.article && React.createElement(
                      'div',
                      { className: 'tcommunity-topic-link' },
                      React.createElement(
                        'div',
                        { className: 'link-logo-wrap' },
                        React.createElement('img', {
                          className: 'link-logo',
                          src: item.content.url.article.cover || item.content.url.article.logo,
                          mode: 'aspectFill',
                          lazyload: 'true'
                        }),
                        item.content.url.article.type == 4 && React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                      ),
                      React.createElement(
                        'span',
                        { className: 'link-text' },
                        item.content.url.article.title
                      )
                    ),
                    item.content.type == 2 && item.content.url.video && React.createElement(
                      'div',
                      { className: 'tcommunity-topic-video' },
                      React.createElement('img', {
                        className: 'video-cover',
                        src: item.content.url.video.cover || '',
                        mode: 'aspectFill',
                        lazyload: 'true'
                      }),
                      React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                    ),
                    item.form_data.list_recommend.recommend_goods && React.createElement(
                      'div',
                      {
                        className: 'card-goods',
                        'data-id': item.form_data.list_recommend.recommend_goods[0].id,
                        'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type,
                        'data-app-id': item.form_data.list_recommend.recommend_goods[0].app_id,
                        onClick: _this3.turnToGoodsDetail
                      },
                      React.createElement(
                        'div',
                        { className: 'card-goods-img' },
                        React.createElement('img', {
                          src: item.form_data.list_recommend.recommend_goods[0].image
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'card-goods-dec' },
                        React.createElement(
                          'div',
                          { className: 'card-goods-title' },
                          item.form_data.list_recommend.recommend_goods[0].name
                        ),
                        React.createElement(
                          'div',
                          { className: 'card-goods-price' },
                          '¥' + item.form_data.list_recommend.recommend_goods[0].price
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'card-goods-button' },
                        '\u53BB\u8D2D\u4E70'
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'card-bottom' },
                      React.createElement(
                        'div',
                        {
                          className: 'card-reading',
                          'data-id': item.id,
                          'data-index': sInd
                        },
                        React.createElement('span', { className: 'ico-moon icon-communityPage-read icon-communityPage-read-cover' }),
                        item.read_count
                      ),
                      React.createElement(
                        'div',
                        { style: (0, _tools.convertLineStyleData)('width:50%;text-align:right;') },
                        React.createElement(
                          'div',
                          {
                            className: 'card-thumbs',
                            'data-id': item.id,
                            'data-liked': item.is_liked,
                            'data-index': sInd,
                            'data-like-count': item.like_count,
                            onClick: _this3.articleLike
                          },
                          React.createElement('span', {
                            className: 'ico-moon icon-community-group-thumb',
                            style: (0, _tools.convertLineStyleData)('font-size: 30rpx;')
                          }),
                          React.createElement(
                            'span',
                            { className: 'card-num' },
                            item.like_count
                          )
                        ),
                        communityInfo.require_article_post == 1 && communityInfo.require_article_comment == 1 && React.createElement(
                          'div',
                          {
                            className: 'card-reply',
                            'data-comment-id': '0',
                            'data-parent-comment-id': '0',
                            'data-article-id': item.id,
                            'data-section-id': item.section_id,
                            'data-index': sInd,
                            onClick: _this3.turnComment,
                            'data-replyto': item.nickname,
                            'data-agent-user-token': item.agent_user_token
                          },
                          React.createElement('span', { className: 'ico-moon icon-goods-customer-service' }),
                          item.comment_count > 0 ? React.createElement(
                            'span',
                            { className: 'card-num' },
                            item.comment_count
                          ) : ''
                        )
                      )
                    )
                  ),
                  !item.article_type && !item.wechat_id && communityInfo.article_style == 2 && React.createElement(
                    'div',
                    {
                      className: 'communityPage-li friendType-li'
                    },
                    React.createElement(
                      'div',
                      { className: 'community-li-top' },
                      React.createElement(
                        'div',
                        {
                          className: 'community-li-cover',
                          onClick: _this3.turnToUsercenter,
                          'data-usertoken': item.user_token,
                          'data-sourcetype': item.source_type
                        },
                        React.createElement('img', {
                          src: item.headimgurl,
                          'data-headimgurl': item.headimgurl,
                          lazyload: 'true'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'community-li-author' },
                        React.createElement(
                          'span',
                          { className: 'community-li-name' },
                          item.nickname
                        ),
                        item.top_flag == 1 && React.createElement('span', { className: 'community-stick' }),
                        item.hot_flag == 1 && React.createElement('span', { className: 'community-hot' }),
                        React.createElement('span', {
                          className: 'ico-moon icon-more',
                          'data-index': sInd,
                          onClick: _this3.showTopicOperateModal
                        }),
                        React.createElement(
                          'span',
                          { className: 'communityPage-li-title', 'data-liked': item.is_liked,
                            'data-phone': item.phone,
                            'data-id': item.id,
                            onClick: _this3.turnToDetail },
                          item.title
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityPage-li-content', 'data-liked': item.is_liked,
                        'data-phone': item.phone,
                        'data-id': item.id,
                        onClick: _this3.turnToDetail },
                      item.content_text.map(function (ii, iind) {
                        return React.createElement(
                          'span',
                          { key: iind, className: 'text-p' },
                          ii,
                          item.isellipsis && iind == item.content_text.length - 1 && React.createElement(
                            'span',
                            { className: 'ellipsis-a' },
                            '\u5168\u6587'
                          )
                        );
                      }),
                      item.content.type == 2 && item.content.url.article && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-link' },
                        React.createElement(
                          'div',
                          { className: 'link-logo-wrap' },
                          React.createElement('img', {
                            className: 'link-logo',
                            src: item.content.url.article.cover || topic.content.url.article.logo,
                            mode: 'aspectFill',
                            lazyload: 'true'
                          }),
                          item.content.url.article.type == 4 && React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                        ),
                        React.createElement(
                          'span',
                          { className: 'link-text' },
                          item.content.url.article.title
                        )
                      ),
                      item.content.type == 2 && item.content.url.video && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-video' },
                        React.createElement('img', {
                          className: 'video-cover',
                          src: item.content.url.video.cover || '',
                          mode: 'aspectFill',
                          lazyload: 'true'
                        }),
                        React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                      )
                    ),
                    item.content.imgs && item.content.imgs[0] && React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        { className: 'communityPage-li-imgli-wrap' },
                        React.createElement(
                          React.Fragment,
                          null,
                          item.content.imgs.map(function (it, itIdx) {
                            return itIdx < 9 ? React.createElement(
                              'div',
                              {
                                key: itIdx,
                                style: (0, _tools.convertLineStyleData)('display:inline-block'),
                                className: 'communityPage-li-imgli'
                              },
                              React.createElement('img', {
                                src: it,
                                mode: 'aspectFill',
                                'data-img': it,
                                'data-imgarr': item.content.imgs,
                                onClick: _this3.tapPrevewPictureHandler,
                                lazyload: 'true'
                              })
                            ) : '';
                          })
                        )
                      )
                    ),
                    item.form_data.list_recommend.recommend_goods && React.createElement(
                      'div',
                      {
                        className: 'community-topic-one-goods',
                        onClick: _this3.turnToGoodsDetail,
                        'data-id': item.form_data.list_recommend.recommend_goods[0].id,
                        'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type,
                        'data-app-id': item.form_data.list_recommend.recommend_goods[0].app_id
                      },
                      React.createElement(
                        'div',
                        { className: 'topic-goods-left' },
                        React.createElement('img', {
                          src: item.form_data.list_recommend.recommend_goods[0].image,
                          lazyload: 'true'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'topic-goods-right' },
                        React.createElement(
                          'div',
                          { className: 'topic-goods-name' },
                          React.createElement(
                            'span',
                            null,
                            item.form_data.list_recommend.recommend_goods[0].name
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'topic-goods-price' },
                          '\xA5',
                          React.createElement(
                            'span',
                            null,
                            item.form_data.list_recommend.recommend_goods[0].price
                          ),
                          React.createElement(
                            'button',
                            null,
                            '\u8D2D\u4E70'
                          )
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityPage-li-center' },
                      React.createElement(
                        'span',
                        { className: 'community-li-time' },
                        item.add_time
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'community-li-read',
                          'data-id': item.id,
                          'data-index': sInd,
                          onClick: _this3.turnToDetail
                        },
                        React.createElement(
                          'span',
                          null,
                          item.read_count + '浏览量'
                        )
                      ),
                      React.createElement(
                        'div',
                        {
                          className: 'community-li-comment',
                          onClick: _this3.showCommentBox,
                          'data-index': sInd
                        },
                        React.createElement(
                          'div',
                          { className: 'li-comments' },
                          React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/comments.png' })
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'comment-box ' + (item.showCom ? 'show' : '')
                          },
                          React.createElement(
                            'div',
                            {
                              'data-id': item.id,
                              'data-liked': item.is_liked,
                              'data-index': sInd,
                              'data-like-count': item.like_count,
                              onClick: _this3.articleLike
                            },
                            React.createElement('label', {
                              className: 'ico-moon ' + (item.is_liked == 1 ? 'icon-community-thumb-up' : 'icon-collect')
                            }),
                            React.createElement(
                              'span',
                              null,
                              item.like_count > 0 ? item.like_count : '点赞'
                            )
                          ),
                          communityInfo.require_article_post == 1 && communityInfo.require_article_comment == 1 && React.createElement(
                            'div',
                            {
                              'data-comment-id': '0',
                              'data-parent-comment-id': '0',
                              'data-article-id': item.id,
                              'data-section-id': item.section_id,
                              'data-index': sInd,
                              onClick: _this3.turnComment,
                              'data-replyto': item.nickname,
                              'data-agent-user-token': item.agent_user_token
                            },
                            React.createElement('label', { className: 'ico-moon icon-community_message' }),
                            React.createElement(
                              'span',
                              null,
                              item.forum_comment_count > 0 ? item.forum_comment_count : '评论'
                            )
                          )
                        )
                      )
                    ),
                    communityInfo.article_style == 2 && item.like_count > 0 && React.createElement(
                      'div',
                      {
                        className: 'communityPage-li-likes ' + (item.comment.length ? 'border' : '')
                      },
                      React.createElement('label', { className: 'ico-moon icon-community_like' }),
                      item.like.map(function (item, likeIdx) {
                        return React.createElement(
                          'span',
                          { key: likeIdx },
                          likeIdx > 0 && React.createElement(
                            'span',
                            null,
                            ','
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.nickname
                          )
                        );
                      })
                    ),
                    communityInfo.article_style == 2 && item.comment.length ? React.createElement(
                      'div',
                      { className: 'commuinty-li-replyList',
                        onClick: _this3.turnToDetail },
                      item.comment.map(function (replyItem, replyIdx) {
                        return React.createElement(
                          'div',
                          { key: replyIdx },
                          replyItem.nickname,
                          replyItem.content.reply_to && React.createElement(
                            'div',
                            { className: 'replyto' },
                            React.createElement(
                              'span',
                              null,
                              '\u56DE\u590D'
                            ),
                            replyItem.content.reply_to.nickname
                          ),
                          '：' + replyItem.content.text
                        );
                      }),
                      React.createElement(
                        'div',
                        {
                          style: (0, _tools.convertLineStyleData)('color: ' + communityInfo.theme_color)
                        },
                        '\u67E5\u770B\u5168\u90E8\u56DE\u590D',
                        React.createElement('span', { className: 'ico-moon icon-downarrow' })
                      )
                    ) : ''
                  ),
                  !item.article_type && !item.wechat_id && communityInfo.article_style == 1 && React.createElement(
                    'div',
                    {
                      className: 'communityPage-li'
                    },
                    React.createElement(
                      'div',
                      { className: 'community-li-top' },
                      React.createElement(
                        'div',
                        {
                          className: 'community-li-cover',
                          onClick: _this3.turnToUsercenter,
                          'data-usertoken': item.user_token,
                          'data-sourcetype': item.source_type
                        },
                        item.headimgurl ? React.createElement('img', { src: item.headimgurl }) : React.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/pc2/user/images/default-avatar2.jpg' })
                      ),
                      React.createElement(
                        'div',
                        { className: 'community-li-author' },
                        React.createElement(
                          'span',
                          { className: 'community-li-name' },
                          item.nickname
                        ),
                        item.top_flag == 1 && React.createElement('span', { className: 'community-stick' }),
                        item.hot_flag == 1 && React.createElement('span', { className: 'community-hot' }),
                        React.createElement('span', {
                          className: 'ico-moon icon-more',
                          'data-index': sInd,
                          onClick: _this3.showTopicOperateModal
                        })
                      )
                    ),
                    React.createElement(
                      'span',
                      { className: 'communityPage-li-title', 'data-liked': item.is_liked,
                        'data-phone': item.phone,
                        'data-id': item.id,
                        onClick: _this3.turnToDetail },
                      item.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityPage-li-content', 'data-liked': item.is_liked,
                        'data-phone': item.phone,
                        'data-id': item.id,
                        onClick: _this3.turnToDetail },
                      item.content_text.map(function (ii, iind) {
                        return React.createElement(
                          'span',
                          { key: iind, className: 'text-p' },
                          ii,
                          item.isellipsis && iind == item.content_text.length - 1 && React.createElement(
                            'span',
                            { className: 'ellipsis-a' },
                            '\u5168\u6587'
                          )
                        );
                      }),
                      item.content.type == 2 && item.content.url.article && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-link' },
                        React.createElement(
                          'div',
                          { className: 'link-logo-wrap' },
                          React.createElement('img', {
                            className: 'link-logo',
                            src: item.content.url.article.cover || topic.content.url.article.logo,
                            mode: 'aspectFill',
                            lazyload: 'true'
                          }),
                          item.content.url.article.type == 4 && React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                        ),
                        React.createElement(
                          'span',
                          { className: 'link-text' },
                          item.content.url.article.title
                        )
                      ),
                      item.content.type == 2 && item.content.url.video && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-video' },
                        React.createElement('img', {
                          className: 'video-cover',
                          src: item.content.url.video.cover || '',
                          mode: 'aspectFill',
                          lazyload: 'true'
                        }),
                        React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                      )
                    ),
                    item.content.imgs && item.content.imgs[0] && React.createElement(
                      'div',
                      null,
                      React.createElement(
                        'div',
                        { className: "communityPage-li-imgli-wrap communityPage-li-imgli-wrap" + communityInfo.article_style },
                        React.createElement(
                          React.Fragment,
                          null,
                          item.content.imgs.map(function (it, itIdx) {
                            return itIdx < 9 ? React.createElement(
                              'div',
                              {
                                key: itIdx,
                                style: (0, _tools.convertLineStyleData)('display:inline-block'),
                                className: 'communityPage-li-imgli'
                              },
                              React.createElement('img', {
                                src: it,
                                mode: 'aspectFill',
                                'data-img': it,
                                'data-imgarr': item.content.imgs,
                                onClick: _this3.tapPrevewPictureHandler,
                                lazyload: 'true'
                              })
                            ) : '';
                          })
                        )
                      )
                    ),
                    item.form_data.list_recommend.recommend_goods && React.createElement(
                      'div',
                      {
                        className: 'communityPage-li-goods',
                        onClick: _this3.turnToGoodsDetail,
                        'data-id': item.form_data.list_recommend.recommend_goods[0].id,
                        'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type,
                        'data-app-id': item.form_data.list_recommend.recommend_goods[0].app_id
                      },
                      React.createElement(
                        'div',
                        { className: 'goods-left' },
                        React.createElement('img', {
                          src: item.form_data.list_recommend.recommend_goods[0].image,
                          lazyload: 'true'
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-center' },
                        React.createElement(
                          'div',
                          { className: 'goods-name' },
                          React.createElement(
                            'span',
                            null,
                            item.form_data.list_recommend.recommend_goods[0].name
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'goods-price' },
                          '\xA5',
                          React.createElement(
                            'span',
                            null,
                            item.form_data.list_recommend.recommend_goods[0].price
                          )
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'goods-right' },
                        React.createElement(
                          'button',
                          null,
                          '\u53BB\u8D2D\u4E70'
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityPage-li-foot' },
                      React.createElement(
                        'div',
                        { className: 'communityPage-li-foot-top' },
                        React.createElement(
                          'div',
                          { className: 'community-li-time' },
                          item.add_time
                        ),
                        item.address && React.createElement(
                          'div',
                          { className: 'communityPage-li-location' },
                          React.createElement('label', { className: 'ico-moon icon-community-location' }),
                          item.address
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'comunityPage-shareBox-wrap', onClick: _this3.eventStoppropagation },
                        React.createElement(
                          'div',
                          { className: 'comunityPage-li-shareBox' },
                          React.createElement(
                            'span',
                            { className: 'topic-share', onClick: _noDevPageList.showNoDevToast },
                            React.createElement('i', { className: 'ico-moon icon-community_share' }),
                            React.createElement(
                              'span',
                              null,
                              item.spread_count > 0 ? item.spread_count : '分享'
                            )
                          ),
                          React.createElement(
                            'span',
                            { className: 'topic-viewcount', onClick: _noDevPageList.showNoDevToast },
                            React.createElement('i', { className: 'ico-moon icon-community_view' }),
                            React.createElement(
                              'span',
                              null,
                              item.read_count > 0 ? item.read_count : '浏览'
                            )
                          ),
                          React.createElement(
                            'span',
                            { className: 'topic-rating',
                              'data-comment-id': '0',
                              'data-parent-comment-id': '0',
                              'data-article-id': item.id,
                              'data-section-id': item.section_id,
                              'data-index': sInd,
                              onClick: _this3.turnComment,
                              'data-replyto': item.nickname,
                              'data-agent-user-token': item.agent_user_token },
                            React.createElement('i', { className: 'ico-moon icon-community_message' }),
                            React.createElement(
                              'span',
                              null,
                              item.comment_count > 0 ? item.comment_count : '评论'
                            )
                          ),
                          React.createElement(
                            'span',
                            { className: 'topic-voteup',
                              'data-id': item.id,
                              'data-liked': item.is_liked,
                              'data-index': sInd,
                              onClick: _this3.articleLike,
                              'data-like-count': item.like_count,
                              style: (0, _tools.convertLineStyleData)('color:' + (item.is_liked == 1 ? '#59607b' : '')) },
                            React.createElement('i', { className: 'ico-moon ' + (item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise') }),
                            React.createElement(
                              'span',
                              null,
                              item.like_count > 0 ? item.like_count : '点赞'
                            )
                          )
                        )
                      )
                    )
                  ),
                  !item.article_type && !item.wechat_id && communityInfo.article_style == 3 && React.createElement(
                    'div',
                    {
                      className: 'communityPage-li friendType-li margin-top0'
                    },
                    React.createElement(
                      'div',
                      { className: 'community-li-top' },
                      React.createElement(
                        'div',
                        {
                          className: 'community-li-style-4',
                          onClick: _this3.turnToUsercenter,
                          'data-usertoken': item.user_token,
                          'data-sourcetype': item.source_type
                        },
                        React.createElement(
                          'span',
                          null,
                          item.day
                        ),
                        React.createElement(
                          'span',
                          { className: 'community-li-month' },
                          item.month + '月'
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'community-li-author community-li-author-4' },
                        React.createElement(
                          'span',
                          { className: 'community-li-name community-li-name-4' },
                          item.nickname
                        ),
                        item.top_flag == 1 && React.createElement('span', { className: 'community-stick' }),
                        item.hot_flag == 1 && React.createElement('span', { className: 'community-hot' }),
                        React.createElement(
                          'span',
                          { className: 'communityPage-li-title communityPage-li-title-4', 'data-liked': item.is_liked,
                            'data-phone': item.phone,
                            'data-id': item.id,
                            onClick: _this3.turnToDetail },
                          item.title
                        )
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityPage-li-content communityPage-li-content-4', 'data-liked': item.is_liked,
                        'data-phone': item.phone,
                        'data-id': item.id,
                        onClick: _this3.turnToDetail },
                      item.content_text.map(function (ii, iind) {
                        return React.createElement(
                          'span',
                          { key: iind, className: 'text-p' },
                          ii,
                          item.isellipsis && iind == item.content_text.length - 1 && React.createElement(
                            'span',
                            { className: 'ellipsis-a' },
                            '\u5168\u6587'
                          )
                        );
                      }),
                      item.content.type == 2 && item.content.url.article && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-link' },
                        React.createElement(
                          'div',
                          { className: 'link-logo-wrap' },
                          React.createElement('img', {
                            className: 'link-logo',
                            src: item.content.url.article.cover || topic.content.url.article.logo,
                            mode: 'aspectFill',
                            lazyload: 'true'
                          }),
                          item.content.url.article.type == 4 && React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                        ),
                        React.createElement(
                          'span',
                          { className: 'link-text' },
                          item.content.url.article.title
                        )
                      ),
                      item.content.type == 2 && item.content.url.video && React.createElement(
                        'div',
                        { className: 'tcommunity-topic-video' },
                        React.createElement('img', {
                          className: 'video-cover',
                          src: item.content.url.video.cover || '',
                          mode: 'aspectFill',
                          lazyload: 'true'
                        }),
                        React.createElement('label', { className: 'ico-moon icon-news-video-play' })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'style-4-padding' },
                      item.content.imgs && item.content.imgs[0] && React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'communityPage-li-imgli-wrap' },
                          React.createElement(
                            React.Fragment,
                            null,
                            item.content.imgs.map(function (it, itIdx) {
                              return itIdx < 9 ? React.createElement(
                                'div',
                                {
                                  key: itIdx,
                                  style: (0, _tools.convertLineStyleData)('display:inline-block'),
                                  className: 'communityPage-li-imgli'
                                },
                                React.createElement('img', {
                                  src: it,
                                  mode: 'aspectFill',
                                  'data-img': it,
                                  'data-imgarr': item.content.imgs,
                                  onClick: _this3.tapPrevewPictureHandler,
                                  lazyload: 'true'
                                })
                              ) : '';
                            })
                          )
                        )
                      ),
                      item.form_data.list_recommend.recommend_goods && React.createElement(
                        'div',
                        {
                          className: 'community-topic-one-goods community-topic-one-goods-4',
                          onClick: _this3.turnToGoodsDetail,
                          'data-id': item.form_data.list_recommend.recommend_goods[0].id,
                          'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type,
                          'data-app-id': item.form_data.list_recommend.recommend_goods[0].app_id
                        },
                        React.createElement(
                          'div',
                          { className: 'topic-goods-left' },
                          React.createElement('img', {
                            src: item.form_data.list_recommend.recommend_goods[0].image,
                            lazyload: 'true'
                          })
                        ),
                        React.createElement(
                          'div',
                          { className: 'topic-goods-right topic-goods-right-4' },
                          React.createElement(
                            'div',
                            { className: 'topic-goods-name' },
                            React.createElement(
                              'span',
                              null,
                              item.form_data.list_recommend.recommend_goods[0].name
                            )
                          ),
                          React.createElement(
                            'div',
                            { className: 'topic-goods-price' },
                            '\xA5',
                            React.createElement(
                              'span',
                              null,
                              item.form_data.list_recommend.recommend_goods[0].price
                            ),
                            React.createElement(
                              'button',
                              null,
                              '\u8D2D\u4E70'
                            )
                          )
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'communityPage-li-center style-4-li-center' },
                        React.createElement(
                          'span',
                          { className: 'community-li-time' },
                          item.add_time
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'community-li-read',
                            'data-id': item.id,
                            'data-index': sInd,
                            onClick: _this3.turnToDetail
                          },
                          React.createElement(
                            'span',
                            null,
                            item.read_count + '浏览量'
                          )
                        ),
                        item.topicMoreOperationModal.isAuthor && React.createElement(
                          'span',
                          {
                            className: 'community-li-detete',
                            'data-data': item.topicMoreOperationModal,
                            onClick: _this3.deleteTopicAct
                          },
                          '\u5220\u9664'
                        ),
                        React.createElement(
                          'div',
                          {
                            className: 'community-li-comment',
                            onClick: _this3.showCommentBox,
                            'data-index': sInd
                          },
                          React.createElement(
                            'div',
                            { className: 'li-comments' },
                            React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/comments.png' })
                          ),
                          React.createElement(
                            'div',
                            {
                              className: 'comment-box ' + (item.showCom ? 'show' : '')
                            },
                            React.createElement(
                              'div',
                              {
                                'data-id': item.id,
                                'data-liked': item.is_liked,
                                'data-index': sInd,
                                'data-like-count': item.like_count,
                                onClick: _this3.articleLike
                              },
                              React.createElement('label', {
                                className: 'ico-moon ' + (item.is_liked == 1 ? 'icon-community-thumb-up' : 'icon-collect')
                              }),
                              React.createElement(
                                'span',
                                null,
                                item.like_count > 0 ? item.like_count : '点赞'
                              )
                            ),
                            communityInfo.require_article_post == 1 && communityInfo.require_article_comment == 1 && React.createElement(
                              'div',
                              {
                                'data-comment-id': '0',
                                'data-parent-comment-id': '0',
                                'data-article-id': item.id,
                                'data-section-id': item.section_id,
                                'data-index': sInd,
                                onClick: _this3.turnComment,
                                'data-replyto': item.nickname,
                                'data-agent-user-token': item.agent_user_token
                              },
                              React.createElement('label', { className: 'ico-moon icon-community_message' }),
                              React.createElement(
                                'span',
                                null,
                                item.forum_comment_count > 0 ? item.forum_comment_count : '评论'
                              )
                            )
                          )
                        )
                      ),
                      communityInfo.article_style == 3 && item.like_count > 0 && React.createElement(
                        'div',
                        {
                          className: 'communityPage-li-likes ' + (item.comment.length ? 'border' : '')
                        },
                        React.createElement('label', { className: 'ico-moon icon-community_like' }),
                        item.like.map(function (item, likeIdx) {
                          return React.createElement(
                            'span',
                            { key: likeIdx },
                            likeIdx > 0 && React.createElement(
                              'span',
                              null,
                              ','
                            ),
                            React.createElement(
                              'span',
                              null,
                              item.nickname
                            )
                          );
                        })
                      ),
                      communityInfo.article_style == 3 && item.comment.length ? React.createElement(
                        'div',
                        { className: 'commuinty-li-replyList',
                          onClick: _this3.turnToDetail
                        },
                        item.comment.map(function (replyItem, replyIdx) {
                          return React.createElement(
                            'div',
                            { key: replyIdx },
                            replyItem.nickname,
                            replyItem.content.reply_to && React.createElement(
                              'div',
                              { className: 'replyto' },
                              React.createElement(
                                'span',
                                null,
                                '\u56DE\u590D'
                              ),
                              replyItem.content.reply_to.nickname
                            ),
                            '\uFF1A',
                            React.createElement(
                              'span',
                              { style: (0, _tools.convertLineStyleData)('color:#333') },
                              replyItem.content.text
                            )
                          );
                        }),
                        React.createElement(
                          'div',
                          {
                            style: (0, _tools.convertLineStyleData)('color: ' + communityInfo.theme_color)
                          },
                          '\u67E5\u770B\u5168\u90E8\u56DE\u590D',
                          React.createElement('span', { className: 'ico-moon icon-downarrow' })
                        )
                      ) : ''
                    )
                  ),
                  item.wechat_id && React.createElement(Ad, { className: 'ad-block', unitId: item.id }),
                  item.article_type == 3 && item.style == 1 && React.createElement(
                    'div',
                    {
                      onClick: _this3.turnToAdDetail,
                      className: 'advertise-recommend',
                      'data-id': item.id,
                      'data-article-type': item.article_type,
                      'data-event-params': item.form_data.event
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'advertise-author-logo',
                        onClick: _this3.topicTurnToUsercenter
                      },
                      React.createElement('img', {
                        src: item.cover,
                        alt: '\u5934\u50CF',
                        lazyload: 'true'
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'advertise-top-right' },
                      React.createElement(
                        'div',
                        { className: 'advertise-author-name' },
                        item.app_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-extension' },
                        '\u63A8\u5E7F'
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-text' },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-dec' },
                        item.content
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-publish-info' },
                        React.createElement(
                          'div',
                          { className: 'advertise-publish-time' },
                          item.add_time
                        )
                      )
                    )
                  ),
                  item.article_type == 3 && item.style == 2 && React.createElement(
                    'div',
                    {
                      onClick: _this3.turnToAdDetail,
                      className: 'advertise-recommend',
                      'data-id': item.id,
                      'data-article-type': item.article_type,
                      'data-event-params': item.form_data.event
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'advertise-author-logo',
                        onClick: _this3.topicTurnToUsercenter
                      },
                      React.createElement('img', {
                        src: item.cover,
                        alt: '\u5934\u50CF',
                        lazyload: 'true'
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'advertise-top-right' },
                      React.createElement(
                        'div',
                        { className: 'advertise-author-name' },
                        item.app_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-extension' },
                        '\u63A8\u5E7F'
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-text' },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-dec' },
                        item.content
                      ),
                      item.imgs != '' && React.createElement(
                        'div',
                        { className: 'advertise-image' },
                        React.createElement('img', { src: item.imgs })
                      ),
                      item.video_data != '' && React.createElement(
                        'div',
                        {
                          className: 'advertise-image',
                          onClick: _this3.stopEvent,
                          'data-index': sInd,
                          'data-id': item.video_data.video_id
                        },
                        React.createElement('video', {
                          id: 'ad_video',
                          poster: item.video_data.video_lib_img,
                          src: video_url,
                          controls: true
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-publish-info' },
                        React.createElement(
                          'div',
                          { className: 'advertise-publish-time' },
                          item.add_time
                        )
                      )
                    )
                  ),
                  item.article_type == 3 && item.style == 3 && React.createElement(
                    'div',
                    {
                      onClick: _this3.turnToAdDetail,
                      className: 'advertise-recommend',
                      'data-id': item.id,
                      'data-article-type': item.article_type,
                      'data-event-params': item.form_data.event
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'advertise-author-logo',
                        onClick: _this3.topicTurnToUsercenter
                      },
                      React.createElement('img', {
                        src: item.cover,
                        alt: '\u5934\u50CF',
                        lazyload: 'true'
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'advertise-top-right' },
                      React.createElement(
                        'div',
                        { className: 'advertise-author-name' },
                        item.app_name
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-extension' },
                        '\u63A8\u5E7F'
                      ),
                      item.imgs != '' && React.createElement(
                        'div',
                        { className: 'advertise-image' },
                        React.createElement('img', { src: item.imgs })
                      ),
                      item.video_data != '' && React.createElement(
                        'div',
                        {
                          className: 'advertise-image',
                          onClick: _this3.stopEvent,
                          'data-index': sInd,
                          'data-id': item.video_data.video_id
                        },
                        React.createElement('video', {
                          id: 'ad_video',
                          src: video_url,
                          poster: item.video_data.video_lib_img,
                          controls: true
                        })
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-text' },
                        item.title
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-dec' },
                        item.content
                      ),
                      React.createElement(
                        'div',
                        { className: 'advertise-publish-info' },
                        React.createElement(
                          'div',
                          { className: 'advertise-publish-time' },
                          item.add_time
                        )
                      )
                    )
                  ),
                  item.article_type == 3 && item.style == 4 && React.createElement(
                    'div',
                    {
                      onClick: _this3.turnToAdDetail,
                      className: 'advertise-recommend',
                      'data-id': item.id,
                      'data-article-type': item.article_type,
                      'data-event-params': item.form_data.event
                    },
                    React.createElement(
                      'div',
                      {
                        className: 'advertise-author-logo',
                        onClick: _this3.topicTurnToUsercenter
                      },
                      React.createElement('img', {
                        src: item.cover,
                        alt: '\u5934\u50CF',
                        lazyload: 'true'
                      })
                    ),
                    item.imgs.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { className: 'advertise-top-right', key: index },
                        React.createElement(
                          'div',
                          {
                            className: 'advertise-author-name',
                            style: (0, _tools.convertLineStyleData)('margin-bottom:7rpx')
                          },
                          item.app_name
                        ),
                        React.createElement(
                          'div',
                          { className: 'advertise-extension' },
                          '\u63A8\u5E7F'
                        ),
                        React.createElement(
                          'div',
                          { className: 'advertise-text' },
                          item.title
                        ),
                        React.createElement(
                          'div',
                          { className: 'advertise-dec' },
                          item.content
                        ),
                        item.imgs != '' && React.createElement(
                          React.Fragment,
                          null,
                          item.imgs.map(function (one, index) {
                            return React.createElement(
                              'div',
                              {
                                className: 'advertise-image-list',
                                key: index
                              },
                              React.createElement('img', { src: one })
                            );
                          })
                        ),
                        React.createElement(
                          'div',
                          { className: 'advertise-publish-info' },
                          React.createElement(
                            'div',
                            { className: 'advertise-publish-time' },
                            item.add_time
                          )
                        )
                      );
                    })
                  )
                );
              }),
              !!!sectionList.length && React.createElement(
                'div',
                { className: 'communityPage-li-none' },
                React.createElement('img', {
                  src: 'http://cdn.jisuapp.cn/static/webapp/images/none.png',
                  mode: 'aspectFill',
                  lazyload: 'true'
                }),
                React.createElement(
                  'span',
                  null,
                  '\u6682\u65E0\u5185\u5BB9'
                )
              ),
              getSectionData.nomore && sectionList.length > 0 && React.createElement(
                'div',
                { className: 'communityPage-li-nomore' },
                '\u6CA1\u6709\u66F4\u591A\u4E86'
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'communityPage-btns-group',
              style: (0, _tools.convertLineStyleData)(suspensionStyle || 'bottom:40rpx;right:30rpx;')
            },
            communityInfo.require_article_post == 1 && React.createElement(
              'div',
              {
                className: 'communityPage-publish-btn',
                onClick: _noDevPageList.showNoDevToast,
                style: (0, _tools.convertLineStyleData)('background-color:' + communityInfo.theme_color + ';')
              },
              React.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/community/suspension-edit1.png' })
            ),
            communityInfo.require_custom_service == 1 && React.createElement(
              'div',
              {
                className: 'communityPage-service-btn',
                style: (0, _tools.convertLineStyleData)('background-color:' + communityInfo.theme_color + ';'),
                onClick: _noDevPageList.showNoDevToast
              },
              React.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/community/suspension-customer1.png' }),
              React.createElement('button', {
                opentype: 'contact',
                size: '20',
                sessionfrom: 'goodsDetail'
              })
            ),
            showBackTopBtn && React.createElement(
              'div',
              {
                className: 'communityPage-backtop-btn',
                onClick: this.backPageTop,
                style: (0, _tools.convertLineStyleData)('background-color:' + communityInfo.theme_color + ';')
              },
              React.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/community/suspension-top1.png' })
            )
          )
        ),
        React.createElement(
          'div',
          {
            className: 'actionSheet-wrap',
            hidden: !showActionSheet,
            onTouchMove: this.privateStopNoop
          },
          React.createElement(
            'div',
            { className: 'actionSheet-buttons' },
            React.createElement(
              'button',
              { className: 'phoneNum-btn' },
              phoneNumCall
            ),
            React.createElement(
              'button',
              { className: 'call-btn', onClick: this.makePhoneCall },
              '\u547C\u53EB'
            ),
            React.createElement(
              'button',
              { className: 'cancel-btn', onClick: this.closeActionSheet },
              '\u53D6\u6D88'
            )
          )
        ),
        sortModal.show && React.createElement(
          'div',
          { className: 'topic-sort-modal', onClick: this.tapCloseSortModal },
          React.createElement(
            'div',
            { className: 'modal-main', onClick: this.tapSelectSortItem },
            sortModal.data.map(function (item, index) {
              return React.createElement(
                'div',
                {
                  key: index,
                  'data-orderby': item.value,
                  'data-name': item.name,
                  className: 'btn ' + (listOtherParam.orderby === item.value ? 'active' : '')
                },
                item.name
              );
            })
          )
        ),
        showReplyBox && React.createElement('div', {
          className: 'communityPage-comment-mask',
          onClick: this.cancelReply
        }),
        showReplyBox && React.createElement(
          'div',
          {
            className: 'communityPage-comment-box',
            id: 'comment-box'
          },
          React.createElement(
            'div',
            { className: 'communityPage-comment-top' },
            React.createElement('textarea', {
              className: 'communityPage-comment-input',
              placeholder: replyPlaceholder,
              maxLength: '-1',
              value: replyParam.text,
              onInput: this.replyInput,
              onChange: function onChange() {}
            }),
            (replyParam.comment_img_url || replyParam.address) && React.createElement(
              'div',
              { className: 'communityPage-comment-others' },
              replyParam.comment_img_url && React.createElement(
                'div',
                {
                  className: 'communityPage-comment-others-image',
                  style: (0, _tools.convertLineStyleData)('margin-bottom: ' + (replyParam.address ? '36' : '0') + 'rpx;')
                },
                React.createElement('img', {
                  src: replyParam.comment_img_url,
                  mode: 'aspectFill',
                  onClick: this.replyImagePreview,
                  lazyload: 'true'
                }),
                React.createElement('div', {
                  className: 'image-close-icon-box',
                  onClick: this.replyImageDelete
                })
              ),
              replyParam.address && React.createElement(
                'div',
                {
                  className: 'communityPage-comment-others-location',
                  onClick: this.replyLocationDelete
                },
                React.createElement(
                  'span',
                  null,
                  replyParam.address
                )
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'communityPage-comment-bottom' },
            React.createElement('div', { className: 'communityPage-comment-bottom-left' }),
            React.createElement(
              'div',
              { className: 'communityPage-comment-bottom-right' },
              React.createElement(
                'div',
                {
                  className: 'communityPage-comment-bottom-right-cancel',
                  onClick: this.cancelReply
                },
                React.createElement(
                  'span',
                  null,
                  '\u53D6\u6D88'
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'communityPage-comment-bottom-right-send',
                  onClick: this.submitReply
                },
                React.createElement(
                  'span',
                  null,
                  '\u53D1\u5E03'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CommunityPage;
}(_OfficialPage3.default);

exports.default = CommunityPage;

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _noDevPageList = __webpack_require__(125);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _customEvent = __webpack_require__(18);

var _ScrollView = __webpack_require__(11);

__webpack_require__(623);

var _TopNav = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSubmiting = false; //防止重复点击
var likeTap = false; //防止重复点击

var eventSource = [{ action: 'get-coupon', name: '优惠券详情', local_icon: 'icon-news-coupon' }, {
  action: 'goods-trade',
  name: '商品详情',
  local_icon: 'icon-news-goodsdetail'
}, { action: 'community', name: '社区详情', local_icon: 'icon-news-community' }, {
  action: 'to-franchisee',
  name: '商家详情',
  local_icon: 'icon-news-business'
}, {
  action: 'coupon-receive-list',
  name: '优惠券列表',
  local_icon: 'icon-news-coupon'
}, { action: 'recharge', name: '储值', local_icon: 'icon-news-storage' }, { action: 'transfer', name: '付款', local_icon: 'icon-news-payment' }, {
  action: 'to-promotion',
  name: '代言人中心',
  local_icon: 'icon-news-extension'
}, { action: 'scratch-card', name: '刮刮乐', local_icon: 'icon-news-scratch' }, { action: 'lucky-wheel', name: '大转盘', local_icon: 'icon-news-turntable' }, { action: 'golden-eggs', name: '砸金蛋', local_icon: 'icon-news-goldegg' }, { action: 'call', name: '拨打电话', local_icon: 'icon-tokeout-phone' }, {
  action: 'turn-to-xcx',
  name: '跳转action小程序',
  local_icon: 'icon-news-jump'
}, { action: 'share', name: '分享好友', local_icon: 'icon-share' }, {
  action: 'page-share',
  name: '分享朋友圈',
  local_icon: 'icon-news-sharecircle'
}, {
  action: 'refresh-list',
  name: '刷新列表',
  local_icon: 'icon-news-refreshlist'
}, {
  action: 'refresh-page',
  name: '刷新页面',
  local_icon: 'icon-news-refreshpage'
}, { action: 'contact', name: '联系客服', local_icon: 'icon-news-custom' }, {
  action: 'preview-picture',
  name: '预览大图',
  local_icon: 'icon-news-coupon'
}, { action: 'to-seckill', name: '秒杀', local_icon: 'icon-news-kill' }, {
  action: 'video-detail',
  name: '视频详情',
  local_icon: 'icon-news-videodetail'
}, { action: 'topic', name: '话题详情', local_icon: 'icon-news-topic' }, { action: 'news', name: '资讯详情', local_icon: 'icon-news-news' }, { action: 'vcard', name: '名片详情', local_icon: 'icon-vcard' }, {
  action: 'vcard-msg-list',
  name: '名片消息列表',
  local_icon: 'icon-vcard-msg-list'
}];

function ArticleRecommendItemTmpl(props) {
  var item = props.data;
  return React.createElement(
    'div',
    { className: 'recommend-item', onClick: _noDevPageList.showNoDevToast },
    React.createElement(
      'div',
      { className: 'recommend-article', style: { width: item.style != 1 || item.form_data.url.video ? '70%' : '100%' } },
      React.createElement(
        'div',
        { className: 'recommend-content' },
        item.title
      ),
      item.article_type == 3 ? React.createElement(
        'div',
        { className: 'recommend-adver-footer' },
        React.createElement(
          'span',
          { className: 'recommend-adver-tag' },
          '\u63A8\u8350'
        ),
        React.createElement(
          'span',
          { className: 'recommend-publish-time' },
          item.publish_time
        )
      ) : React.createElement(
        'div',
        { className: 'recommend-key-words' },
        React.createElement(
          'span',
          { className: 'recommend-comment-text' },
          item.comment_count,
          '\u8BC4\u8BBA'
        ),
        React.createElement(
          'span',
          { className: 'recommend-comment-text' },
          item.publish_time
        )
      )
    ),
    (item.style != 1 || item.form_data.url.video || item.form_data.video[0]) && React.createElement(
      'div',
      { className: 'img-wrap' },
      React.createElement('img', { src: item.imgs || item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url'] || item['form_data'] && item['form_data']['video'] && item['form_data']['url']['video']['cover'] }),
      (item['form_data'] && item['form_data']['url'] && item['form_data']['url']['video'] && item['form_data']['url']['video']['cover'] || item['form_data'] && item['form_data']['video'] && item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) && React.createElement(
        'div',
        { className: 'icon-wrap' },
        React.createElement('label', { className: 'ico-moon icon-news-video-play' })
      )
    )
  );
}

var CommunityDetail = function (_OfficialPage) {
  (0, _inherits3.default)(CommunityDetail, _OfficialPage);

  function CommunityDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CommunityDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CommunityDetail.__proto__ || Object.getPrototypeOf(CommunityDetail)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CommunityDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var that = this;
      _app.appMethod.getStorage({
        key: 'communityThemeColor-' + options.sectionid,
        success: function success(res) {
          that.setData({ themeColor: res.data });
        }
      });
      var articleId = options.detail,
          onlyOwnRecord = options.onlyOwnRecord || '';
      var franchisee = options.franchisee || '';
      this.setData((0, _defineProperty3.default)({
        articleId: articleId,
        onlyOwnRecord: onlyOwnRecord,
        franchisee: franchisee
      }, 'replyParam.sub_app_id', franchisee));
      if (_app.appMethod.isLogin()) {
        // 判断是否登录
        this.getComment();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getComment();
          }
        });
      }
      this.getArticleInfo();
      this.getLikeLog();
      this.countReadCount(articleId);
      _app.appMethod.globalData.communityDetailRefresh = false;
    }
  }, {
    key: 'componentDidShow',
    value: function componentDidShow() {
      if (_app.appMethod.globalData.topicTurnToDetail) {
        _app.appMethod.globalData.topicTurnToDetail = false;
      }
      if (_app.appMethod.globalData.communityDetailRefresh) {
        this.setData({
          getCommentData: {
            page: 1,
            loading: false,
            nomore: false
          },
          commentList: []
        });
        _app.appMethod.globalData.communityDetailRefresh = false;
        this.getComment();
      }
    }
  }, {
    key: 'privateStopNoop',
    value: function privateStopNoop(e) {
      e.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showModal = _state.showModal,
          sectionInfo = _state.sectionInfo,
          articleInfo = _state.articleInfo,
          undefined = _state.undefined,
          wxParseDescription = _state.wxParseDescription,
          showReplyBox = _state.showReplyBox,
          showActionSheet = _state.showActionSheet,
          innerAudioContext = _state.innerAudioContext,
          requireComment = _state.requireComment,
          showHiddenContent = _state.showHiddenContent,
          address = _state.address,
          newsItem = _state.newsItem,
          commentTab = _state.commentTab,
          commentList = _state.commentList,
          isAuthorSelf = _state.isAuthorSelf,
          getCommentData = _state.getCommentData,
          likeLogItems = _state.likeLogItems,
          phoneNumCall = _state.phoneNumCall,
          replyBoxFocus = _state.replyBoxFocus,
          keyboardHeight = _state.keyboardHeight,
          replyPlaceholder = _state.replyPlaceholder,
          replyParam = _state.replyParam,
          commentContentHeight = _state.commentContentHeight;

      return React.createElement(
        'div',
        null,
        React.createElement(_TopNav.TopNav, { title: '\u8BE6\u60C5' }),
        React.createElement(
          'div',
          {
            className: 'communityDetail-wrap ' + (showModal ? 'notRoll' : ''),
            id: 'communityDetail'
          },
          React.createElement(
            'div',
            { className: 'communityDetail-main' },
            React.createElement(
              'div',
              { className: 'community-flex' },
              React.createElement(
                'div',
                {
                  className: 'communityDetail-cover community-li-cover ' + (sectionInfo.article_style == 0 ? 'circle' : 'square'),
                  onClick: this.turnToUsercenter,
                  'data-usertoken': articleInfo.user_token,
                  'data-sourcetype': articleInfo.source_type
                },
                React.createElement('img', {
                  className: 'communityDetail-head',
                  src: articleInfo.headimgurl,
                  lazyload: 'true'
                })
              ),
              React.createElement(
                'div',
                { className: 'communityDetail-author community-li-author' },
                React.createElement(
                  'div',
                  { className: 'communityDetail-name-box' },
                  React.createElement(
                    'span',
                    {
                      className: 'communityDetail-name community-li-name',
                      selectable: 'true'
                    },
                    articleInfo.nickname
                  ),
                  articleInfo.hot_flag == 1 && React.createElement(
                    'div',
                    { className: 'community-hot-wrap' },
                    React.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/topic.png' })
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'communityDetail-time community-li-time communityDetail-name-box' },
                  React.createElement(
                    'span',
                    { className: 'communityDetail-time-time', selectable: 'true' },
                    articleInfo.add_time
                  ),
                  React.createElement(
                    'span',
                    null,
                    '\u4EBA\u6C14'
                  ),
                  articleInfo.comment_count > 0 && React.createElement(
                    'span',
                    { className: 'communityDetail-popularity' },
                    articleInfo.comment_count
                  )
                )
              )
            ),
            articleInfo.content && articleInfo.content.imgs && React.createElement(
              'div',
              { className: 'main-content' },
              (articleInfo.content.type == undefined || articleInfo.content.type == 0 || articleInfo.content.url.video) && React.createElement(
                'div',
                { className: 'communityDetail-title' },
                articleInfo.title
              ),
              (articleInfo.content.type == undefined || articleInfo.content.type == 0) && React.createElement(
                'div',
                { className: 'communityDetail-content' },
                React.createElement(
                  'span',
                  { className: 'text-p', selectable: 'true' },
                  articleInfo.content_text
                )
              ),
              (articleInfo.content.type == undefined || articleInfo.content.type == 0) && React.createElement(
                'div',
                { className: 'communityDetail-img' },
                articleInfo.content.imgs.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      key: index,
                      className: articleInfo.content.imgs.length == 1 ? 'communityDetail-imgli-one' : 'communityDetail-imgli'
                    },
                    articleInfo.content.imgs.length == 1 ? React.createElement('img', {
                      src: item,
                      'data-img': item,
                      'data-imgs-arr': articleInfo.content.imgs,
                      mode: 'widthFix',
                      onClick: _this2.previewImage,
                      lazyload: 'true'
                    }) : React.createElement('img', {
                      src: item,
                      'data-img': item,
                      'data-imgs-arr': articleInfo.content.imgs,
                      mode: 'widthFix',
                      onClick: _this2.previewImage,
                      lazyload: 'true'
                    })
                  );
                })
              ),
              articleInfo.content.type == 2 && articleInfo.content.url.article && React.createElement(
                'div',
                null,
                React.createElement(
                  'div',
                  { className: 'communityDetail-title' },
                  articleInfo.content.url.article.title
                ),
                React.createElement(
                  'div',
                  { className: 'article-from' },
                  articleInfo.content.url.article.author && React.createElement(
                    'span',
                    { className: 'author', selectable: 'true' },
                    articleInfo.content.url.article.author
                  ),
                  React.createElement(
                    'span',
                    { className: 'nickname', selectable: 'true' },
                    articleInfo.content.url.article.nickname
                  ),
                  React.createElement(
                    'span',
                    { className: 'publish-time', selectable: 'true' },
                    articleInfo.content.url.article.publish_time
                  )
                )
              ),
              articleInfo.content.type == 2 && articleInfo.content.url.article && React.createElement(
                'div',
                { className: 'communityDetail-link-content' },
                false && React.createElement('video', null),
                React.createElement(TaroParseTmpl, {
                  data: { wxParseData: wxParseDescription.nodes }
                }),
                articleInfo.content.url.article.type == 4 && React.createElement(
                  'div',
                  { className: 'communityDetail-link-video' },
                  React.createElement('video', {
                    className: 'myVideo',
                    src: articleInfo.content.url.article.video_url,
                    controls: true,
                    hidden: showReplyBox || showActionSheet
                  })
                ),
                articleInfo.content.url.article.type == 3 && React.createElement(
                  'div',
                  {
                    className: 'communityDetail-link-audio' + (innerAudioContext.play ? ' communityDetail-link-audio-play' : '')
                  },
                  React.createElement('div', {
                    className: 'audio-logo',
                    onClick: this.audioPlayAct
                  }),
                  React.createElement(
                    'div',
                    { className: 'audio-info' },
                    React.createElement(
                      'div',
                      { className: 'audio-title' },
                      articleInfo.content.url.article.title
                    ),
                    React.createElement(
                      'div',
                      { className: 'audio-progress-bg' },
                      React.createElement(
                        'div',
                        {
                          className: 'audio-progress',
                          style: (0, _tools.convertLineStyleData)('width:' + audioTools.playProgress(innerAudioContext.currentTime, innerAudioContext.duration))
                        },
                        React.createElement('span', { className: 'audio-progress-point' })
                      )
                    ),
                    React.createElement(
                      'div',
                      { className: 'audio-time' },
                      React.createElement(
                        'span',
                        { className: 'audio-currentTime' },
                        audioTools.timeStampChangeTime(innerAudioContext.currentTime)
                      ),
                      React.createElement(
                        'span',
                        { className: 'audio-duration' },
                        audioTools.timeStampChangeTime(innerAudioContext.duration)
                      )
                    )
                  )
                )
              ),
              articleInfo.content.type == 2 && articleInfo.content.url.video && React.createElement(
                'div',
                { className: 'communityDetail-topic-video' },
                React.createElement('video', {
                  src: articleInfo.content.url.video.url,
                  hidden: showReplyBox || showActionSheet,
                  controls: true
                })
              ),
              articleInfo.hidden_content && React.createElement(
                React.Fragment,
                null,
                requireComment && showHiddenContent ? React.createElement(
                  'div',
                  null,
                  React.createElement(
                    'span',
                    {
                      className: 'hidden-content',
                      space: 'true',
                      decode: 'true',
                      selectable: 'true'
                    },
                    articleInfo.hidden_content
                  )
                ) : React.createElement(
                  'div',
                  { className: 'seemore-after-comment' },
                  React.createElement(
                    'div',
                    { className: 'arrow-group' },
                    React.createElement('span', { className: 'ico-moon icon-downarrow arrow-1' }),
                    React.createElement('span', { className: 'ico-moon icon-downarrow arrow-2' })
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'comment-btn',
                      onClick: this.turnComment,
                      'data-section-id': articleInfo.section_id,
                      'data-article-id': articleInfo.id,
                      'data-replyto': '\u6211\u6765\u8BF4\u4E24\u53E5',
                      'data-comment-id': '0',
                      'data-parent-comment-id': '0'
                    },
                    '\u8BC4\u8BBA\u540E\u67E5\u770B\u66F4\u591A'
                  )
                )
              )
            ),
            articleInfo.content && articleInfo.content.type == 2 && React.createElement(
              'div',
              { className: 'communityDetail-state' },
              '\u672C\u9875\u9762\u91C7\u7528\u5E94\u7528\u5185\u641C\u7D22\u6280\u672F\u81EA\u52A8\u6293\u53D6\uFF0C\u5728\u4E3A\u91CD\u65B0\u7F16\u8F91\u539F\u59CB\u5185\u5BB9\u7684\u60C5\u51B5\u4E0B\u5BF9\u7248\u5F0F\u505A\u4E86\u4F18\u5316\uFF0C\u4EE5\u63D0\u5347\u9605\u8BFB\u4F53\u9A8C\u3002'
            ),
            React.createElement(
              'div',
              { className: 'communityDetail-location-report' },
              address && React.createElement(
                'div',
                {
                  className: 'communityDetail-location',
                  onClick: this.openWXMap
                },
                React.createElement('label', { className: 'ico-moon icon-community-location' }),
                address
              ),
              React.createElement(
                'div',
                {
                  className: 'communityDetail-report-wrap',
                  onClick: this.turnToReport
                },
                React.createElement('label', { className: 'ico-moon icon-community-report' }),
                React.createElement(
                  'span',
                  { className: 'communityDetail-report' },
                  '\u4E3E\u62A5'
                )
              )
            )
          ),
          articleInfo.is_recommend == 1 && React.createElement(
            React.Fragment,
            null,
            articleInfo.form_data.recommend.map(function (recItem, index) {
              return React.createElement(
                'div',
                { className: 'newsDetail-recommend', key: index },
                recItem.recommend_good_type == 3 && React.createElement(
                  'div',
                  { className: 'more-operations' },
                  recItem.recommend_goods.length != 0 && React.createElement(
                    'div',
                    { className: 'title' },
                    '\u66F4\u591A\u64CD\u4F5C'
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'operations' + (recItem.recommend_goods.length < 3 ? recItem.recommend_goods.length : '3'),
                      onClick: _noDevPageList.showNoDevToast
                    },
                    recItem.recommend_goods.map(function (recList, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        recList.action == 'share' ? React.createElement(
                          'span',
                          {
                            className: 'sharefriends',
                            opentype: 'share',
                            'data-eventParams': recList
                          },
                          React.createElement(
                            'div',
                            { className: 'icon-wrap' },
                            recList.local_icon ? React.createElement('span', { className: 'ico-moon icon-share' }) : React.createElement('img', {
                              src: recList.iconImg,
                              lazyload: 'true'
                            })
                          ),
                          React.createElement(
                            'div',
                            { className: 'name' },
                            '\u5206\u4EAB\u597D\u53CB'
                          )
                        ) : recList.action == 'contact' ? React.createElement(
                          'div',
                          { className: 'concat-custom' },
                          React.createElement(
                            'div',
                            { className: 'icon-wrap' },
                            recList.local_icon ? React.createElement('span', { className: 'ico-moon icon-news-custom' }) : React.createElement('img', {
                              src: recList.iconImg,
                              lazyload: 'true'
                            }),
                            React.createElement('span', {
                              opentype: 'contact',
                              sessionFrom: 'newsDetail'
                            })
                          ),
                          React.createElement(
                            'div',
                            { className: 'name' },
                            '\u8054\u7CFB\u5BA2\u670D'
                          )
                        ) : recList.action == 'turn-to-xcx' ? React.createElement(
                          'div',
                          null,
                          React.createElement(
                            Navigator,
                            {
                              target: 'miniProgram',
                              opentype: 'navigate',
                              appId: recList['xcx-appid'],
                              path: recList['xcx-page-url'],
                              extraData: true,
                              version: 'release'
                            },
                            React.createElement(
                              'div',
                              { className: 'icon-wrap' },
                              recList.local_icon ? React.createElement('span', {
                                className: 'ico-moon ' + recList.local_icon
                              }) : React.createElement('img', {
                                src: recList.iconImg,
                                lazyload: 'true'
                              })
                            ),
                            React.createElement(
                              'div',
                              { className: 'name' },
                              recList.name
                            )
                          )
                        ) : React.createElement(
                          'div',
                          {
                            onClick: _this2.bindEventTapHandler,
                            'data-event-params': recList
                          },
                          React.createElement(
                            'div',
                            { className: 'icon-wrap' },
                            recList.local_icon ? React.createElement('span', {
                              className: 'ico-moon ' + recList.local_icon
                            }) : React.createElement('img', {
                              src: recList.iconImg,
                              lazyload: 'true'
                            })
                          ),
                          React.createElement(
                            'div',
                            { className: 'name' },
                            recList.name
                          )
                        )
                      );
                    })
                  )
                )
              );
            })
          ),
          articleInfo.is_recommend == 1 && React.createElement(
            React.Fragment,
            null,
            articleInfo.form_data.recommend.map(function (recItem, index) {
              return React.createElement(
                'div',
                { className: 'newsDetail-recommend', key: index },
                recItem.recommend_good_type == 0 && recItem.recommend_goods.length > 0 ? React.createElement(
                  'div',
                  { className: 'recommmend-list' },
                  React.createElement(
                    'div',
                    { className: 'catalog' },
                    '\u63A8\u8350\u6587\u7AE0'
                  ),
                  React.createElement(
                    React.Fragment,
                    null,
                    recItem.recommend_goods.map(function (item, index) {
                      return React.createElement(
                        'div',
                        { key: index },
                        item.article_type == 3 && item.event_params.action == 'turn-to-xcx' ? React.createElement(
                          Navigator,
                          {
                            target: 'miniProgram',
                            opentype: 'navigate',
                            appId: item.event_params['xcx-appid'],
                            path: item.event_params['xcx-page-url'],
                            extraData: true,
                            version: 'release'
                          },
                          React.createElement(ArticleRecommendItemTmpl, {
                            data: item
                          })
                        ) : item.article_type == 3 && item.event_params.action == 'share' ? React.createElement(
                          'div',
                          null,
                          React.createElement(
                            'span',
                            {
                              className: 'news-share-button',
                              opentype: 'share',
                              'data-eventParams': newsItem.event_params,
                              onClick: _this2.onShareAppMessage
                            },
                            React.createElement(ArticleRecommendItemTmpl, {
                              data: item
                            })
                          )
                        ) : item.article_type == 3 && item.event_params.action == 'contact' ? React.createElement(
                          'div',
                          null,
                          React.createElement(
                            'div',
                            { className: 'contact-button' },
                            React.createElement('span', {
                              opentype: 'contact',
                              sessionFrom: 'newsDetail'
                            }),
                            React.createElement(ArticleRecommendItemTmpl, {
                              data: item
                            })
                          )
                        ) : React.createElement(
                          'div',
                          {
                            'data-id': item.id,
                            onClick: _this2.turnToArticle,
                            'data-article-type': item.article_type,
                            'data-event-params': item.event_params
                          },
                          React.createElement(ArticleRecommendItemTmpl, {
                            data: item
                          })
                        )
                      );
                    })
                  )
                ) : recItem.recommend_good_type == 1 && recItem.recommend_goods.length > 0 ? React.createElement(
                  'div',
                  { className: 'recommmend-list goods-list' },
                  React.createElement(
                    'div',
                    { className: 'catalog' },
                    '\u63A8\u8350\u5546\u54C1'
                  ),
                  recItem.recommend_goods.map(function (item, index) {
                    return React.createElement(
                      'div',
                      {
                        className: 'recommend-item',
                        'data-id': item.id,
                        'data-app-id': item.app_id,
                        onClick: _this2.turnToGoodsDetail,
                        key: index
                      },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'div',
                          { className: 'img-wrap' },
                          React.createElement('img', {
                            src: item.cover,
                            lazyload: 'true'
                          })
                        ),
                        React.createElement(
                          'div',
                          { className: 'recommend-article' },
                          React.createElement(
                            'div',
                            { className: 'recommend-content' },
                            item.title
                          ),
                          React.createElement(
                            'div',
                            { className: 'recommend-goods-price' },
                            React.createElement(
                              'span',
                              { style: (0, _tools.convertLineStyleData)('color:#FC4541;') },
                              '¥' + item.price
                            )
                          ),
                          React.createElement(
                            'div',
                            {
                              className: 'recommend-goods-sales',
                              style: (0, _tools.convertLineStyleData)('color:#999;font-size:20rpx;margin-bottom:0;')
                            },
                            '月销' + item.sales + '件'
                          )
                        )
                      )
                    );
                  })
                ) : recItem.recommend_good_type == 2 && recItem.recommend_goods.length > 0 ? React.createElement(
                  'div',
                  {
                    className: 'recommmend-list',
                    style: (0, _tools.convertLineStyleData)('padding: 20rpx 30rpx;')
                  },
                  React.createElement(
                    'div',
                    { className: 'catalog' },
                    '\u4F18\u60E0\u5238'
                  ),
                  recItem.recommend_goods.map(function (coupon, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      React.createElement(
                        'div',
                        {
                          className: 'ticket',
                          onClick: _this2.gotoCouponDetail,
                          'data-coupon-id': coupon.id
                        },
                        React.createElement(
                          'div',
                          {
                            className: 'top-section',
                            style: (0, _tools.convertLineStyleData)('border-color: ' + coupon.list_color)
                          },
                          coupon.type == 0 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件：满' + coupon.condition + '元，减' + coupon.value + '元'
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u51CF'
                              )
                            )
                          ) : coupon.type == 1 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件: 打' + coupon.value + '折'
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u6298'
                              )
                            )
                          ) : coupon.type == 2 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件：可抵扣' + coupon.value + '元'
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u4EE3'
                              )
                            )
                          ) : coupon.type == 3 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              coupon.extra_condition == '' ? React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件：直接兑换' + coupon.coupon_goods_info.title
                              ) : coupon.extra_condition.price ? React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件：消费满' + coupon.extra_condition.price + '元可兑换' + coupon.coupon_goods_info.title
                              ) : coupon.extra_condition.goods_id && coupon.condition_goods_info ? React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件：购买' + coupon.condition_goods_info.title + '可兑换' + coupon.coupon_goods_info.title
                              ) : ''
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u5151'
                              )
                            )
                          ) : coupon.type == 4 ? React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件: 储值金可充值' + coupon.value + '元'
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u50A8'
                              )
                            )
                          ) : coupon.type == 5 && React.createElement(
                            React.Fragment,
                            null,
                            React.createElement(
                              'div',
                              { className: 'detail-info' },
                              React.createElement(
                                'div',
                                { className: 'name' },
                                coupon.title
                              ),
                              React.createElement(
                                'div',
                                { className: 'use-condition' },
                                '使用条件: ' + coupon.extra_condition
                              )
                            ),
                            React.createElement(
                              'div',
                              {
                                className: 'background-word-area',
                                style: (0, _tools.convertLineStyleData)('border-color:' + coupon.list_color)
                              },
                              React.createElement('div', {
                                className: 'background-circle',
                                style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                              }),
                              React.createElement(
                                'div',
                                { className: 'background-word' },
                                '\u901A'
                              )
                            )
                          ),
                          React.createElement(
                            'div',
                            {
                              className: 'receive-btn',
                              onClick: _this2.gotoCouponDetail,
                              'data-coupon-id': coupon.id,
                              style: (0, _tools.convertLineStyleData)('background-color:' + coupon.list_color)
                            },
                            '\u9886\u53D6'
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'bottom-section' },
                          React.createElement(
                            'div',
                            null,
                            '有效期 ' + coupon.start_use_date + '至' + coupon.end_use_date + ' ' + (coupon.exclude_holiday == 0 ? '' : '除去法定节假日') + ' ' + (coupon.exclude_weekend == 0 ? '' : '周一至周五') + ' ' + coupon.start_use_time + '-' + coupon.end_use_time
                          )
                        )
                      )
                    );
                  })
                ) : recItem.recommend_good_type == 7 && recItem.recommend_goods.length > 0 && React.createElement(
                  'div',
                  { className: 'live-list' },
                  React.createElement(
                    'div',
                    { className: 'catalog' },
                    '\u63A8\u8350\u76F4\u64AD'
                  ),
                  recItem.recommend_goods.map(function (live, index) {
                    return React.createElement(
                      React.Fragment,
                      { key: index },
                      React.createElement(
                        'div',
                        {
                          className: 'live-wrap',
                          'data-id': live.roomid,
                          onClick: _this2.goLivePlay
                        },
                        React.createElement(
                          'div',
                          { className: 'live-room' },
                          live.live_status == 101 && React.createElement(
                            'div',
                            { className: 'live-online' },
                            '\u6B63\u5728\u76F4\u64AD'
                          ),
                          live.live_status == 102 && React.createElement(
                            'div',
                            { className: 'live-notice' },
                            React.createElement(
                              'div',
                              { className: 'live-notice-title green-color' },
                              '\u9884\u544A'
                            ),
                            React.createElement(
                              'div',
                              { className: 'live-notice-time' },
                              live.start_time
                            )
                          ),
                          live.live_status == 103 && React.createElement(
                            'div',
                            { className: 'live-notice' },
                            React.createElement(
                              'div',
                              { className: 'live-notice-title blue-color' },
                              '\u56DE\u770B'
                            ),
                            React.createElement(
                              'div',
                              { className: 'live-notice-time' },
                              live.end_time
                            )
                          ),
                          React.createElement('img', {
                            src: live.cover_img,
                            mode: 'aspectFill'
                          }),
                          React.createElement(
                            'div',
                            { className: 'live-anchor' },
                            live.anchor_img ? React.createElement(
                              React.Fragment,
                              null,
                              React.createElement('img', {
                                className: 'live-anchor-head',
                                src: live.anchor_img,
                                mode: 'aspectFill'
                              }),
                              React.createElement(
                                'div',
                                { className: 'live-anchor-name' },
                                live.anchor_name
                              )
                            ) : React.createElement(
                              React.Fragment,
                              null,
                              React.createElement(
                                'div',
                                { className: 'live-anchor-name' },
                                '主播：' + live.anchor_name
                              )
                            )
                          )
                        ),
                        React.createElement(
                          'div',
                          { className: 'live-title ellipsis' },
                          live.name
                        ),
                        live.goods && live.goods.length > 0 && React.createElement(
                          'div',
                          { className: 'live-goods' },
                          React.createElement('img', {
                            className: 'live-goods-img',
                            src: live.goods[0].cover_img,
                            mode: 'aspectFill'
                          }),
                          React.createElement(
                            'div',
                            { className: 'live-goods-info' },
                            React.createElement(
                              'div',
                              { className: 'live-goods-name ellipsis' },
                              live.goods[0].name
                            ),
                            React.createElement(
                              'div',
                              { className: 'live-goods-price' },
                              '¥' + live.goods[0].price
                            )
                          ),
                          React.createElement('div', { className: 'ico-moon icon-community-group-arrow' })
                        )
                      )
                    );
                  })
                )
              );
            })
          ),
          sectionInfo.name && React.createElement(
            'div',
            {
              className: 'relative-section-info',
              onClick: this.turnToCommunityPage
            },
            React.createElement(
              'div',
              { className: 'section-logo' },
              React.createElement('img', {
                src: sectionInfo.img || sectionInfo.background_pic,
                lazyload: 'true'
              })
            ),
            React.createElement(
              'div',
              { className: 'section-text' },
              React.createElement(
                'div',
                { className: 'section-name' },
                sectionInfo.name
              ),
              React.createElement(
                'div',
                { className: 'section-otherinfo' },
                React.createElement('span', { className: 'ico-moon icon-community-follow' }),
                React.createElement(
                  'span',
                  { className: 'otherinfo-item' },
                  sectionInfo.xcx_comment_count + '人关注'
                ),
                React.createElement('span', { className: 'ico-moon icon-community-topic' }),
                React.createElement(
                  'span',
                  { className: 'otherinfo-item' },
                  sectionInfo.xcx_article_count + '个话题'
                )
              )
            )
          ),
          articleInfo.audit_status == 2 && React.createElement(
            'div',
            { className: 'refuse-detail' },
            React.createElement(
              'div',
              { className: 'refuse-reason' },
              React.createElement(
                'span',
                { className: 'refuse-title' },
                '\u62D2\u7EDD\u539F\u56E0'
              ),
              React.createElement(
                'span',
                { className: 'refuse-explain' },
                !articleInfo.audit_reason ? '无' : articleInfo.audit_reason
              )
            ),
            React.createElement(
              'div',
              null,
              React.createElement(
                'span',
                { className: 're-publish', onClick: this.rePublish },
                '\u91CD\u65B0\u53D1\u5E03'
              )
            )
          ),
          React.createElement(
            'div',
            {
              className: 'communityDetail-art',
              hidden: articleInfo.audit_status == 2
            },
            React.createElement(
              'div',
              { className: 'communityDetail-comment-list-box' },
              React.createElement(
                'div',
                { className: 'communityDetail-comment-list-top' },
                React.createElement(
                  'div',
                  {
                    className: 'communityDetail-comment-list-top-reply-box ' + (commentTab === 0 ? 'communityDetail-comment-list-top-selected' : ''),
                    onClick: this.switchCommentTab,
                    'data-num': '0'
                  },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '\u56DE\u590D'
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '(' + articleInfo.comment_count + ')'
                    )
                  )
                ),
                React.createElement(
                  'div',
                  {
                    className: 'communityDetail-comment-list-top-like-box ' + (commentTab === 1 ? 'communityDetail-comment-list-top-selected' : ''),
                    onClick: this.switchCommentTab,
                    'data-num': '1'
                  },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '\u70B9\u8D5E'
                    )
                  ),
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'span',
                      null,
                      '(' + articleInfo.like_count + ')'
                    )
                  )
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'communityDetail-comment-list',
                  hidden: commentTab !== 0
                },
                commentList.map(function (item, index) {
                  return React.createElement(
                    'div',
                    {
                      className: 'communityDetail-comment-list-item',
                      key: index
                    },
                    React.createElement(
                      'div',
                      { className: 'communityDetail-comment-list-left' },
                      React.createElement('img', {
                        className: 'communityDetail-comment-list-avatar',
                        src: item.headimgurl,
                        onClick: _this2.turnToUsercenter,
                        'data-usertoken': item.user_token,
                        'data-sourcetype': item.source_type,
                        lazyload: 'true'
                      })
                    ),
                    React.createElement(
                      'div',
                      { className: 'communityDetail-comment-list-right' },
                      React.createElement(
                        'div',
                        { className: 'communityDetail-comment-list-right-top' },
                        React.createElement(
                          'span',
                          { className: 'communityDetail-comment-list-nickname' },
                          item.nickname
                        ),
                        React.createElement(
                          'div',
                          { className: 'communityDetail-comment-list-operation' },
                          React.createElement('span', {
                            className: 'ico-moon icon-news-comment',
                            onClick: _this2.turnComment,
                            'data-section-id': articleInfo.section_id,
                            'data-article-id': articleInfo.id,
                            'data-replyto': item.nickname,
                            'data-comment-id': item.id,
                            'data-parent-comment-id': item.id
                          }),
                          React.createElement('span', {
                            className: 'ico-moon icon-news-' + (item.is_liked == 1 ? '' : 'un') + 'like',
                            style: (0, _tools.convertLineStyleData)(item.is_liked == 1 ? 'color: #59607b;' : ''),
                            onClick: _this2.commentLike,
                            'data-liked': item.is_liked,
                            'data-id': item.id,
                            'data-index': index,
                            'data-like-count': item.like_count
                          }),
                          React.createElement(
                            'span',
                            null,
                            item.like_count
                          )
                        )
                      ),
                      React.createElement(
                        'span',
                        {
                          className: 'communityDetail-comment-list-content',
                          onClick: _this2.goCommentDetail,
                          'data-type': 'simple',
                          'data-id': item.id,
                          'data-article-id': articleInfo.id
                        },
                        item.content.text
                      ),
                      item.content.comment_img_url && React.createElement(
                        'div',
                        {
                          className: 'communityDetail-comment-list-image',
                          style: (0, _tools.convertLineStyleData)(item.content.comment_img_style),
                          onClick: _this2.previewImage,
                          'data-img': item.content.comment_img_url
                        },
                        React.createElement('img', {
                          src: item.content.comment_img_url,
                          mode: 'aspectFill',
                          onLoad: _this2.commentImageLoad,
                          'data-path': 'commentList[' + index + '].content.comment_img_style',
                          lazyload: 'true'
                        }),
                        React.createElement(
                          'div',
                          null,
                          React.createElement(
                            'span',
                            null,
                            '\u67E5\u770B\u539F\u56FE'
                          )
                        )
                      ),
                      React.createElement(
                        'div',
                        { className: 'communityDetail-comment-list-otherInfo' },
                        React.createElement(
                          'div',
                          { className: 'communityDetail-comment-list-otherInfo-left' },
                          item.content.address && React.createElement(
                            React.Fragment,
                            null,
                            React.createElement('span', { className: 'ico-moon icon-community-location' }),
                            React.createElement(
                              'span',
                              { className: 'communityDetail-comment-list-otherInfo-location' },
                              item.content.address
                            )
                          ),
                          React.createElement(
                            'span',
                            null,
                            item.content.add_time
                          )
                        )
                      ),
                      item.child_comment && item.child_comment.data && item.child_comment.data.length ? React.createElement(
                        'div',
                        { className: 'communityDetail-comment-list-reply-box' },
                        item.child_comment.data.map(function (childComment, cIdx) {
                          return React.createElement(
                            'div',
                            {
                              className: 'communityDetail-comment-list-reply',
                              key: cIdx
                            },
                            React.createElement(
                              'span',
                              { className: 'communityDetail-comment-list-reply-nickname' },
                              childComment.content.nickname
                            ),
                            React.createElement(
                              'span',
                              {
                                className: 'communityDetail-comment-list-reply-content',
                                onClick: _this2.turnComment,
                                'data-section-id': articleInfo.section_id,
                                'data-article-id': articleInfo.id,
                                'data-replyto': childComment.content.nickname,
                                'data-comment-id': childComment.id,
                                'data-parent-comment-id': item.id
                              },
                              ': ' + childComment.content.text
                            ),
                            childComment.content.comment_img_url && React.createElement(
                              'div',
                              { className: 'comment-img-text' },
                              React.createElement('span', {
                                className: 'ico-moon icon-news-comment-image',
                                onClick: _this2.previewImage,
                                'data-img': childComment.content.comment_img_url
                              }),
                              React.createElement(
                                'span',
                                {
                                  className: true,
                                  onClick: _this2.previewImage,
                                  'data-img': childComment.content.comment_img_url
                                },
                                '\u67E5\u770B\u56FE\u7247'
                              )
                            )
                          );
                        }),
                        React.createElement(
                          'div',
                          {
                            className: 'communityDetail-comment-list-reply-more',
                            onClick: _this2.goCommentDetail,
                            'data-type': 'simple',
                            'data-id': item.id,
                            'data-article-id': articleInfo.id
                          },
                          React.createElement(
                            'span',
                            null,
                            '共' + item.child_comment.count + '条评论 >'
                          )
                        )
                      ) : ''
                    )
                  );
                }),
                articleInfo.owner_visible == 1 && !isAuthorSelf ? React.createElement(
                  'div',
                  { className: 'commmunityDetail-comment-author-canseen' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement('span', { className: 'ico-moon icon-community-nosee' })
                  ),
                  React.createElement(
                    'div',
                    null,
                    '\u8BC4\u8BBA\u4EC5\u4F5C\u8005\u53EF\u89C1'
                  )
                ) : getCommentData.nomore && commentList.length <= 0 ? React.createElement(
                  'div',
                  { className: 'communityDetail-comment-list-nocomment' },
                  React.createElement('span', { className: 'ico-moon icon-no-criticism' }),
                  React.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u8BC4\u8BBA'
                  )
                ) : React.createElement('div', null)
              ),
              likeLogItems.map(function (item, index) {
                return React.createElement(
                  'div',
                  {
                    className: 'communityDetail-like-list',
                    hidden: commentTab !== 1,
                    key: index
                  },
                  likeLogItems.length > 0 && React.createElement(
                    React.Fragment,
                    null,
                    likeLogItems.map(function (item, index) {
                      return React.createElement(
                        'div',
                        {
                          className: 'communityDetail-like-list-item',
                          key: index,
                          onClick: _this2.turnToUsercenter,
                          'data-usertoken': item.user_token,
                          'data-sourcetype': item.source_type
                        },
                        React.createElement('img', {
                          src: item.headimgurl,
                          lazyload: 'true'
                        }),
                        React.createElement(
                          'span',
                          null,
                          item.nickname
                        )
                      );
                    })
                  ),
                  likeLogItems.length == 0 && React.createElement(
                    'div',
                    { className: 'communityDetail-like-list-nolike' },
                    React.createElement('span', { className: 'ico-moon icon-community-group-thumb' }),
                    React.createElement(
                      'div',
                      null,
                      '\u6682\u65E0\u70B9\u8D5E'
                    )
                  )
                );
              })
            )
          ),
          !showReplyBox && React.createElement(
            'div',
            {
              className: 'communityDetail-bottom',
              hidden: articleInfo.audit_status == 2
            },
            React.createElement(
              'div',
              { className: 'bottom-icons-group' },
              React.createElement('span', {
                className: 'communityDetail-likebtn2 ico-moon ' + (articleInfo.is_liked == 1 ? 'icon-community-thumb-up' : 'icon-collect'),
                'data-liked': articleInfo.is_liked,
                'data-like-count': articleInfo.like_count,
                onClick: this.articleLike,
                style: (0, _tools.convertLineStyleData)((articleInfo.is_liked == 1 ? 'color :#59607b;' : '') + ';font-size:19px;')
              }),
              articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.length > 0 && React.createElement(
                'div',
                {
                  className: 'communityDetail-review',
                  'data-section-id': articleInfo.section_id,
                  'data-article-id': articleInfo.id,
                  'data-comment-id': '0',
                  'data-parent-comment-id': '0',
                  onClick: this.turnComment,
                  'data-replyto': '\u6211\u6765\u8BC4\u8BBA'
                },
                React.createElement('span', { className: 'ico-moon icon-communityDetail-reply' })
              ),
              React.createElement(
                'span',
                {
                  className: 'communityDetail-likebtn2',
                  onClick: _noDevPageList.showNoDevToast },
                React.createElement('span', { className: 'ico-moon icon-communityDetail-share' })
              ),
              articleInfo.phone && React.createElement(
                'div',
                {
                  className: 'communityDetail-phone',
                  onClick: this.showActionSheet
                },
                React.createElement('span', { className: 'ico-moon icon-telephone' })
              )
            ),
            articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.length > 0 ? React.createElement(
              'div',
              {
                className: 'communityDetail-goods',
                onClick: this.showGoods
              },
              articleInfo.form_data && articleInfo.form_data.show_recommend && '文中商品(' + articleInfo.form_data.show_recommend.recommend_goods.length + ')'
            ) : React.createElement(
              'span',
              {
                className: 'communityDetail-btn',
                onClick: this.turnComment,
                'data-section-id': articleInfo.section_id,
                'data-article-id': articleInfo.id,
                'data-replyto': '\u6211\u6765\u8BF4\u4E24\u53E5',
                'data-comment-id': '0',
                'data-parent-comment-id': '0'
              },
              '\u6765\u8BF4\u8BF4\u6211\u7684\u770B\u6CD5...'
            )
          ),
          React.createElement(
            'div',
            {
              className: 'goodsModal',
              style: (0, _tools.convertLineStyleData)('display:' + (showModal ? 'block' : 'none')),
              onClick: this.closeModal
            },
            React.createElement(
              'div',
              { className: 'goodsWrap-bg', onClick: this.showModal },
              React.createElement(
                'div',
                { className: 'goodsHidden', onClick: this.closeModal },
                React.createElement('span', { className: 'ico-moon icon-downarrow' })
              ),
              React.createElement(
                _ScrollView.ScrollView,
                { scrollY: true, className: 'goodsWrap' },
                React.createElement(
                  'div',
                  { className: 'goodsWrap-title' },
                  articleInfo.form_data && articleInfo.form_data.show_recommend && '文中商品(' + articleInfo.form_data.show_recommend.recommend_goods.length + ')'
                ),
                articleInfo.form_data && articleInfo.form_data.show_recommend && articleInfo.form_data.show_recommend.recommend_goods.map(function (item, index) {
                  return React.createElement(
                    'div',
                    { className: 'goods-item', key: index },
                    React.createElement(
                      'div',
                      { className: 'goods-item-img' },
                      React.createElement('img', { src: item.cover })
                    ),
                    React.createElement(
                      'div',
                      { className: 'introduce-text' },
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { className: 'goods-item-detail' },
                          item.title
                        )
                      ),
                      React.createElement(
                        'div',
                        null,
                        React.createElement(
                          'span',
                          { className: 'goods-item-price' },
                          '¥' + item.price
                        ),
                        React.createElement(
                          'span',
                          {
                            className: 'goods-item-toShop',
                            'data-id': item.id,
                            'data-app-id': item.app_id,
                            onClick: _this2.turnToGoodsDetail
                          },
                          '\u53BB\u8D2D\u4E70'
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        ),
        showActionSheet && React.createElement(
          'div',
          { className: 'actionSheet-wrap', onTouchMove: this.privateStopNoop },
          React.createElement(
            'div',
            { className: 'actionSheet-buttons' },
            React.createElement(
              'div',
              { className: 'phoneNum-btn' },
              phoneNumCall
            ),
            React.createElement(
              'div',
              { className: 'call-btn', onClick: this.makePhoneCall },
              '\u547C\u53EB'
            ),
            React.createElement(
              'div',
              { className: 'cancel-btn', onClick: this.closeActionSheet },
              '\u53D6\u6D88'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'goback-top', onClick: this.tapBackPageTop },
          React.createElement('span', { className: 'ico-moon icon-news-totop' })
        ),
        showReplyBox && React.createElement('div', {
          className: 'communityDetail-comment-mask',
          onClick: this.cancelReply
        }),
        showReplyBox && React.createElement(
          'div',
          {
            className: 'communityDetail-comment-box',
            id: 'comment-box'
          },
          React.createElement(
            'div',
            { className: 'communityDetail-comment-top' },
            React.createElement('textarea', {
              className: 'communityDetail-comment-input',
              id: 'communityDetail-comment-input',
              placeholder: replyPlaceholder,
              maxLength: '-1',
              value: replyParam.text,
              onInput: this.replyInput,
              onChange: function onChange() {}
            }),
            (replyParam.comment_img_url || replyParam.address) && React.createElement(
              'div',
              { className: 'communityDetail-comment-others' },
              replyParam.comment_img_url && React.createElement(
                'div',
                {
                  className: 'communityDetail-comment-others-image',
                  style: (0, _tools.convertLineStyleData)('margin-bottom: ' + (replyParam.address ? '36' : '0') + 'rpx;')
                },
                React.createElement('img', {
                  src: replyParam.comment_img_url,
                  mode: 'aspectFill',
                  onClick: this.replyImagePreview,
                  lazyload: 'true'
                }),
                React.createElement(
                  'div',
                  {
                    className: 'image-close-icon-box',
                    onClick: this.replyImageDelete
                  },
                  React.createElement('span', { className: 'image-close-icon ico-moon icon-closes' })
                )
              ),
              replyParam.address && React.createElement(
                'div',
                {
                  className: 'communityDetail-comment-others-location',
                  onClick: this.replyLocationDelete
                },
                React.createElement(
                  'span',
                  null,
                  replyParam.address
                ),
                React.createElement('span', { className: 'location-close-icon ico-moon icon-closes' })
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'communityDetail-comment-bottom' },
            React.createElement(
              'div',
              { className: 'communityDetail-comment-bottom-left' },
              React.createElement('span', {
                className: 'communityDetail-comment-bottom-icon ico-moon icon-community-location',
                onClick: this.replyLocationChoose
              })
            ),
            React.createElement(
              'div',
              { className: 'communityDetail-comment-bottom-right' },
              React.createElement(
                'div',
                {
                  className: 'communityDetail-comment-bottom-right-cancel',
                  onClick: this.cancelReply
                },
                React.createElement(
                  'span',
                  null,
                  '\u53D6\u6D88'
                )
              ),
              React.createElement(
                'div',
                {
                  className: 'communityDetail-comment-bottom-right-send',
                  onClick: this.submitReply
                },
                React.createElement(
                  'span',
                  null,
                  '\u53D1\u5E03'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return CommunityDetail;
}(_OfficialPage3.default);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    topNavBarData: {
      isDefault: 0,
      title: '详情'
    },
    articleId: '',
    articleInfo: {},
    likeLogItems: [],
    commentList: [],
    getCommentData: {
      page: 1,
      loading: false,
      nomore: false
    },
    likeLogData: {
      page: 1,
      loading: false,
      nomore: false
    },
    imgData: {},
    showAddArticleBtn: true,
    themeColor: '#00b6f8',
    address: '',
    showActionSheet: false,
    phoneNumCall: '',
    showReplyBox: false,
    replyBoxFocus: false,
    keyboardHeight: '50%',
    replyPlaceholder: '我来说两句',
    innerAudioContext: {
      currentTime: 0,
      duration: 0,
      canPlay: false,
      play: false
    },
    franchisee: '',
    sectionInfo: {}, // 板块详情
    requireComment: false, // 需要评论
    showHiddenContent: false, // 是否发表过评论
    replyParam: {
      text: '',
      agent_user_token: '',
      address: '',
      latitude: '',
      longitude: '',
      comment_img_url: '',
      comment_id: '',
      parent_comment_id: '',
      sub_app_id: ''
    },
    commentContentMaxHeight: 0,
    commentContentHeight: 40,
    commentTab: 0,
    showGoodsModal: false,
    showModal: false,
    communityPublish: {}
  };

  this.getArticleInfo = function (own) {
    var that = _this3,
        param = {
      article_id: that.data.articleId,
      page: 1,
      page_size: 100,
      sub_app_id: that.data.franchisee
    };
    if (that.data.onlyOwnRecord == 1) {
      param.only_own_record = 1;
    }
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: param,
      method: 'post',
      success: function success(res) {
        if (res.status == 0 && Array.isArray(res.data) && res.data[0]) {
          var info = res.data[0];
          var newdata = {};
          info.title = unescape(info.title.replace(/\\u/g, '%u'));
          if (info.content.type == 2) {
            if (info.content.url.article) {
              var artBody = info.content.url.article.body;
              if (/[>]\s+/.test(artBody)) {
                // 替换空格
                artBody = artBody.replace(/(\>)(\s+)/g, function ($0, $1, $2) {
                  return $1 + new Array($2.length + 1).join('&nbsp;');
                });
              }
              if (/\'/.test(artBody)) {
                // 过滤掉单引号
                artBody = artBody.replace(/\'/g, '"');
              }
              if (/\<img[^<>]*['"]\s*\>/.test(artBody)) {
                // 筛选过滤掉图片标签有错误的属性
                artBody = artBody.replace(/\<img([^<>]*['"])\s*\>/g, function ($0, $1) {
                  return '<img' + $1.match(/\s[^'"=\s]+\=['"][^"]+['"]/g).join('') + '/>';
                });
              }
              if (/<mpvoice/.test(artBody)) {
                // 替换音频
                artBody = artBody.replace(/\<mpvoice[^<>]*\>\<\/mpvoice\>/g, function ($0, $1) {
                  return $0.replace(/\s(\w+)\=\"([^"]*)\"/g, function ($00, $01, $03) {
                    if (/voice\_encode\_fileid/.test($01)) {
                      return ' src="https://res.wx.qq.com/voice/getvoice?mediaid=' + $03 + '"';
                    } else if (/name|author/.test($01)) {
                      return $00;
                    } else {}
                    return '';
                  });
                });
              }
              info.content_text = artBody;
              delete info.content.url.article.body;
              if (info.content.url.article.type == 3) {
                that.createAudioPlayer(info.content.url.article);
              }
            }
          } else {
            info.content_text = info.content.text.replace(/\n|\\n/g, '\n');
          }
          info.form_data.recommend = info.form_data.recommend.map(function (rg) {
            if (rg.recommend_good_type == 3) {
              rg.recommend_goods = rg.recommend_goods.map(function (ri) {
                if (!ri.name) {
                  ri.name = ri.pageRouterName ? ri.pageRouterName.split('/').pop() : '';
                }
                ri.iconImg = ri.iconImg ? ri.iconImg : ri.icon;
                if (!ri.name || !ri.iconImg || /click_event.*svg$/.test(ri.iconImg)) {
                  var eventObj = eventSource.find(function (eb) {
                    return eb.action == ri.action;
                  });
                  if (eventObj) {
                    ri.name || (ri.name = eventObj.name);
                    if (!ri.iconImg || /click_event.*svg$/.test(ri.iconImg)) {
                      ri.local_icon = eventObj.local_icon;
                    }
                  }
                }
                return ri;
              });
            } else if (rg.recommend_good_type == 0) {
              rg.recommend_goods = rg.recommend_goods.map(function (ri) {
                if (ri.article_type == 3 && ri.form_data.event.action) {
                  var oldEventParams = ri.form_data.event,
                      newEventParams = {};
                  delete ri.form_data;
                  Object.keys(oldEventParams).forEach(function (k) {
                    if (/\-/.test(k)) {
                      newEventParams[k.replace(/\-/g, '_')] = oldEventParams[k];
                    } else {
                      newEventParams[k] = oldEventParams[k];
                    }
                  });
                  ri.event_params = newEventParams;
                } else {
                  ri.event_params = '';
                }
                if (ri.form_data && ri.form_data.recommend) {
                  delete ri.form_data.recommend;
                }
                return ri;
              });
            } else if (rg.recommend_good_type == 1) {
              info.form_data.show_recommend = rg;
            } else {}
            return rg;
          });
          if (info.hidden_content) {
            info.hidden_content = info.hidden_content.replace(/\n|\\n/g, '\n'); // 处理隐藏内容换行
          }
          delete info.comment;
          newdata.articleInfo = info;
          newdata.address = info.address;
          if (info.visible_after_comment == 1) {
            // 话题是否评论后可见
            newdata.requireComment = true;
          }
          newdata.showHiddenContent = info.show_hidden_content == 1;
          if (info.agent_user_token) {
            // 代理
            newdata['replyParam.agent_user_token'] = info.agent_user_token;
          }
          if (_app.appMethod.globalData.userInfo.user_token === info.user_token) {
            newdata.isAuthorSelf = true;
          }
          that.setData(newdata);
          // WxParse.wxParse(
          //   'wxParseDescription',
          //   'html',
          //   info.content_text,
          //   that,
          //   10
          // )
          that.getThemeColor(info.section_id);
          if (info.content.type == 2 && info.content.url.video) {
            that.getCurVideoUrl(info.content.url.video.url);
          }
        }
      }
    });
  };

  this.getLikeLog = function () {
    var that = _this3;
    var _data = _this3.data,
        articleId = _data.articleId,
        franchisee = _data.franchisee,
        likeLogItems = _data.likeLogItems,
        _data$likeLogData = _data.likeLogData,
        page = _data$likeLogData.page,
        loading = _data$likeLogData.loading,
        nomore = _data$likeLogData.nomore;

    if (loading || nomore) {
      return;
    }
    _this3.setData({
      'likeLogData.loading': true
    });
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetLikeLogByPage',
      data: {
        page: page,
        obj_type: 1,
        obj_id: articleId,
        page_size: 10,
        sub_app_id: franchisee
      },
      method: 'post',
      success: function success(_ref2) {
        var data = _ref2.data,
            current_page = _ref2.current_page,
            is_more = _ref2.is_more;

        if (current_page === 1) {
          likeLogItems = data;
        } else {
          likeLogItems = likeLogItems.concat(data);
        }
        that.setData({
          likeLogItems: likeLogItems,
          'likeLogData.page': current_page + 1,
          'likeLogData.loading': false,
          'likeLogData.nomore': is_more != 1
        });
      },
      fail: function fail() {
        that.setData({
          'likeLogData.loading': false,
          'likeLogData.nomore': false
        });
      }
    });
  };

  this.getComment = function () {
    var that = _this3,
        sdata = that.data.getCommentData;
    if (sdata.loading || sdata.nomore) {
      return;
    }
    sdata.loading = true;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/GetCommentByPage',
      data: {
        page: sdata.page,
        article_id: that.data.articleId,
        page_size: 10,
        article_style: 0,
        sub_app_id: that.data.franchisee,
        child_page: 1,
        child_page_size: 5
      },
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          var info = res.data,
              oldData = that.data.commentList,
              newData = info;
          for (var i = 0; i < newData.length; i++) {
            var item = newData[i],
                likecount = item.like_count;
            item.like_count_text = likecount <= 0 ? '赞' : likecount > 10000 ? Math.floor(likecount / 10000) + '万' : likecount;
            item.likeAnimateShow = true;
          }
          newData = oldData.concat(newData);
          that.setData({
            commentList: newData,
            'getCommentData.page': sdata.page + 1
          });
        }
        that.setData({
          'getCommentData.loading': false,
          'getCommentData.nomore': res.is_more == 0 ? true : false
        });
      },
      fail: function fail(res) {
        that.setData({
          'getCommentData.loading': false
        });
      }
    });
  };

  this.onReachBottom = function (e) {
    _this3.scrollTolower(e);
  };

  this.onPageScroll = function (e) {
    _this3.scrollEvent(e);
  };

  this.scrollTolower = function (event) {
    switch (_this3.data.commentTab) {
      case 0:
        _this3.getComment();
        break;
      case 1:
        _this3.getLikeLog();
        break;
    }
  };

  this.oldscrolltop = 0;

  this.scrollEvent = function (event) {
    var scrolltop = event.scrollTop,
        oldscrolltop = _this3.oldscrolltop;
    if (scrolltop - oldscrolltop > 60) {
      _this3.oldscrolltop = scrolltop;
      _this3.setData({
        showAddArticleBtn: false
      });
    } else if (oldscrolltop - scrolltop > 60) {
      _this3.oldscrolltop = scrolltop;
      _this3.setData({
        showAddArticleBtn: true
      });
    }
  };

  this.getThemeColor = function (section_id) {
    var that = _this3;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: {
        page: 1,
        section_id: section_id,
        sub_app_id: that.data.franchisee
      },
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          var info = res.data[0];
          that.setData({
            themeColor: info.theme_color,
            sectionInfo: info
          });
        }
      }
    });
  };

  this.turnReply = function (event) {
    event.currentTarget.dataset.parentid = event.currentTarget.dataset.id;
    _this3.turnComment(event);
  };

  this.turnComment = function (event) {
    var _this3$setData;

    var requireArticlePost = _this3.data.articleInfo.require_article_post;
    var requireArticleComment = _this3.data.articleInfo.require_article_comment;
    if (requireArticlePost == 0 || requireArticleComment == 0) {
      _app.appMethod.showModal({
        content: '当前话题圈组不允许评论'
      });
      return;
    }
    var _event$currentTarget$ = event.currentTarget.dataset,
        sectionId = _event$currentTarget$.sectionId,
        commentId = _event$currentTarget$.commentId,
        parentCommentId = _event$currentTarget$.parentCommentId,
        replyto = _event$currentTarget$.replyto,
        articleId = _event$currentTarget$.articleId;

    _this3.setData((_this3$setData = {
      showReplyBox: true,
      replyPlaceholder: '回复：' + replyto
    }, (0, _defineProperty3.default)(_this3$setData, 'replyParam.section_id', sectionId), (0, _defineProperty3.default)(_this3$setData, 'replyParam.article_id', articleId), (0, _defineProperty3.default)(_this3$setData, 'replyParam.comment_id', commentId), (0, _defineProperty3.default)(_this3$setData, 'replyParam.parent_comment_id', parentCommentId), _this3$setData));
  };

  this.turnToPublish = function (event) {
    _app.appMethod.turnToPage('/informationManagement/pages/communityPublish/communityPublish?detail=' + _this3.data.articleInfo.section_id + (_this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : ''));
  };

  this.articleLike = function (event) {
    var that = _this3,
        liked = event.currentTarget.dataset.liked,
        likeCount = +event.currentTarget.dataset.likeCount;
    if (likeTap) {
      return;
    }
    likeTap = true;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 1, // obj_type 1-话题 2-评论
        obj_id: that.data.articleId, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee || _app.appMethod.getChainId()
      },
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          that.getLikeLog();
          if (liked == 1) {
            that.setData({
              'articleInfo.is_liked': 0,
              'articleInfo.like_count': likeCount - 1
            });
            _app.appMethod.showToast({ title: '点赞取消' });
          } else {
            that.setData({
              'articleInfo.is_liked': 1,
              'articleInfo.like_count': likeCount + 1
            });
            _app.appMethod.showToast({ title: '点赞成功' });
          }
          that.relatePagesRefresh();
          that.setData({
            likeLogData: {
              pageL: 1,
              loading: false,
              nomore: false
            }
          });
          that.getLikeLog();
        }
      },
      complete: function complete() {
        likeTap = false;
      }
    });
  };

  this.commentLike = function (event) {
    var that = _this3,
        liked = event.currentTarget.dataset.liked,
        id = event.currentTarget.dataset.id,
        index = +event.currentTarget.dataset.index,
        likeCount = +event.currentTarget.dataset.likeCount;
    if (likeTap) {
      return;
    }
    likeTap = true;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 2, // obj_type 1-话题 2-评论
        obj_id: id, // obj_id 话题或评论的id
        sub_app_id: that.data.franchisee || _app.appMethod.getChainId()
      },
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          if (liked == 1) {
            var newData = {},
                likecount = likeCount - 1;
            newData['commentList[' + index + '].is_liked'] = 0;
            newData['commentList[' + index + '].like_count'] = likecount;
            newData['commentList[' + index + '].like_count_text'] = likecount <= 0 ? '赞' : likecount > 10000 ? Math.floor(likecount / 10000) + '万' : likecount;
            newData['commentList[' + index + '].likeAnimateShow'] = false;
            that.setData(newData);
            _app.appMethod.showToast({ title: '点赞取消' });
          } else {
            var newData = {},
                likecount = likeCount + 1;
            newData['commentList[' + index + '].is_liked'] = 1;
            newData['commentList[' + index + '].like_count'] = likecount;
            newData['commentList[' + index + '].like_count_text'] = likecount <= 0 ? '赞' : likecount > 10000 ? Math.floor(likecount / 10000) + '万' : likecount;
            newData['commentList[' + index + '].likeAnimateShow'] = false;
            that.setData(newData);
            _app.appMethod.showToast({ title: '点赞成功' });
          }
          that.relatePagesRefresh();
          setTimeout(function () {
            var newData = {};
            newData['commentList[' + index + '].likeAnimateShow'] = true;
            that.setData(newData);
          }, 480);
        }
      },
      complete: function complete() {
        likeTap = false;
      }
    });
  };

  this.previewImage = function (event) {
    var _event$currentTarget$2 = event.currentTarget.dataset,
        img = _event$currentTarget$2.img,
        imgsArr = _event$currentTarget$2.imgsArr;

    if (!Array.isArray(imgsArr)) {
      imgsArr = [img];
    }
    _app.appMethod.previewImage({
      current: img,
      urls: imgsArr
    });
  };

  this.showActionSheet = function (event) {
    var that = _this3,
        telNum = that.data.articleInfo.phone,
        telArr = [telNum.substr(0, 3), telNum.substr(3, 4), telNum.substr(7)],
        isIphone = /ios/i.test(_app.appMethod.globalData.systemInfo.platform);
    if (isIphone) {
      _app.appMethod.makePhoneCall({
        phoneNumber: telNum,
        success: function success() {},
        fail: function fail() {}
      });
    } else {
      that.setData({
        phoneNumCall: telArr.join('-'),
        showActionSheet: true
      });
    }
  };

  this.rePublish = function (e) {
    var newdata = {
      'communityPublish.show': true,
      'communityPublish.articleId': _this3.data.articleId
    };
    if (_this3.data.articleInfo.content.type == 2) {
      newdata['communityPublish.publishType'] = 2;
    }
    _this3.setData(newdata);
  };

  this.showGoods = function () {
    _this3.setData({
      showModal: true
    });
  };

  this.closeModal = function () {
    _this3.setData({
      showModal: false
    });
  };

  this.showModal = function () {
    _this3.setData({
      showModal: true
    });
  };

  this.onShareAppMessage = function (res) {
    var that = _this3;
    var shareTitle = _this3.data.articleInfo.title;
    var sharePath = '/informationManagement/pages/communityDetail/communityDetail';
    sharePath += '?from_share=1';
    return _app.appMethod.shareAppMessage({
      title: shareTitle,
      path: sharePath,
      success: function success(res) {
        _app.appMethod.showToast({ title: '转发成功' });
        _app.appMethod.CountSpreadCount(that.data.articleId);
        that.relatePagesRefresh();
      },
      fail: function fail(res) {}
    });
  };

  this.turnToReport = function () {
    _app.appMethod.turnToPage('/informationManagement/pages/communityReport/communityReport?detail=' + _this3.data.articleId + '&sectionid=' + _this3.data.articleInfo.section_id + (_this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : ''));
  };

  this.getLocByLatAndLng = function (lat, lng, cb) {
    _app.appMethod.sendRequest({
      url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
      data: {
        latitude: lat,
        longitude: lng
      },
      method: 'post',
      success: function success(data) {
        if (data.status == 0 && typeof cb == 'function') {
          cb(data.data);
        }
      }
    });
  };

  this.backToPre = function () {
    _app.appMethod.navigateBack();
  };

  this.closeActionSheet = function (event) {
    _this3.setData({ showActionSheet: false });
  };

  this.makePhoneCall = function (event) {
    _app.appMethod.makePhoneCall({
      phoneNumber: _this3.data.articleInfo.phone,
      success: function success() {},
      fail: function fail() {
        _app.appMethod.showModal({ content: '拨打电话失败' });
      }
    });
    _this3.closeActionSheet();
  };

  this.cancelReply = function () {
    _this3.setData({ showReplyBox: false, replyBoxFocus: false });
    _this3.clearCommentInput();
  };

  this.replyTimer = null;

  this.submitReply = function (event, repeat) {
    var that = _this3,
        _data2 = _this3.data,
        replyParam = _data2.replyParam,
        franchisee = _data2.franchisee;

    if (_this3.replyTimer) {
      clearTimeout(_this3.replyTimer);
      _this3.replyTimer = null;
    }
    replyParam.text = replyParam.text; // 去除两端的空格
    if (!replyParam.text) {
      if (repeat === undefined) {
        _this3.replyTimer = setTimeout(function () {
          return _this3.submitReply(event, true);
        }, 500);
        return;
      }
      return;
    }
    if (isSubmiting) {
      return;
    }
    isSubmiting = true;
    if (!replyParam.sub_app_id && franchisee) {
      // 子店话题详情回复评论
      replyParam.sub_app_id = franchisee;
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/AddComment',
      data: replyParam,
      method: 'post',
      success: function success(res) {
        _app.appMethod.showToast({
          title: '回复成功',
          success: function success() {
            var comment_count = that.data.articleInfo.comment_count;

            that.setData({
              showReplyBox: false,
              replyBoxFocus: false,
              'articleInfo.comment_count': +comment_count + 1
            });
          }
        });
        that.relatePagesRefresh();
        that.clearCommentInput();
        var _that$data = that.data,
            requireComment = _that$data.requireComment,
            showHiddenContent = _that$data.showHiddenContent;

        if (requireComment && !showHiddenContent) {
          that.setData({
            showHiddenContent: true
          });
        }
        that.setData({
          'getCommentData.page': 1,
          'getCommentData.loading': false,
          'getCommentData.nomore': false,
          commentList: []
        });
        that.getComment();
      },
      complete: function complete(res) {
        isSubmiting = false;
      }
    });
  };

  this.replyInput = function (event) {
    _this3.setData({
      'replyParam.text': event.target.value
    });
  };

  this.openWXMap = function () {
    var articleInfo = _this3.data.articleInfo;
    _app.appMethod.openLocation({
      latitude: +articleInfo.latitude,
      longitude: +articleInfo.longitude,
      address: articleInfo.address
    });
  };

  this.countReadCount = function (articleId) {
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/CountReadCount',
      method: 'get',
      data: {
        article_id: articleId || _this3.data.communityId,
        sub_app_id: _this3.data.franchisee
      },
      success: function success() {}
    });
  };

  this.replyFocus = function (e) {
    if (e.detail.height) {
      var curKbHeight = e.detail.height;
      kbHeight = e.detail.height;
      if (/iPhone\s?X/i.test(_app.appMethod.globalData.systemInfo.model)) {
        curKbHeight = 365;
      }
      _this3.setData({
        replyBoxFocus: true,
        keyboardHeight: curKbHeight + 'px'
      });
      return;
    }
    _this3.setData({ replyBoxFocus: true });
  };

  this.replyBlur = function (e) {
    _this3.setData({ replyBoxFocus: false });
  };

  this.createAudioPlayer = function (article) {
    var innerAudioContext = _app.appMethod.createInnerAudioContext();
    _this3.innerAudioContext = innerAudioContext;
    innerAudioContext.src = article.audio_url;
    innerAudioContext.onCanplay(function () {
      _this3.setData({
        'innerAudioContext.canPlay': true,
        'innerAudioContext.duration': article.duration || 0
      });
    });
    innerAudioContext.onError(function (res) {
      _app.appMethod.showModal({ content: res.errCode + ':' + res.errMsg });
    });
  };

  this.audioPlayAct = function () {
    if (!_this3.data.innerAudioContext.canPlay) {
      return;
    }
    _this3.audioTimer && clearInterval(_this3.audioTimer);
    if (_this3.data.innerAudioContext.play) {
      _this3.setData({
        'innerAudioContext.play': false,
        'innerAudioContext.currentTime': _this3.innerAudioContext.currentTime
      });
      _this3.innerAudioContext.pause();
      return;
    }
    _this3.innerAudioContext.play();
    _this3.audioTimer = setInterval(function () {
      _this3.setData({
        'innerAudioContext.play': true,
        'innerAudioContext.currentTime': _this3.innerAudioContext.currentTime
      });
      if (!_this3.data.innerAudioContext.duration) {
        _this3.setData({
          'innerAudioContext.duration': _this3.innerAudioContext.duration
        });
      }
    }, 1000);
  };

  this.getCurVideoUrl = function (url) {
    var that = _this3;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppNews/GetVideoUrl',
      data: { argv: url },
      success: function success(res) {
        that.setData({
          'articleInfo.content.url.video.url': res.data
        });
      }
    });
  };

  this.replyLineChange = function (e) {
    var that = _this3;
    var lineHeight = 40;
    var marginTop = 45;
    var commentContentHeight = lineHeight;
    var maxHeight = _this3.data.commentContentMaxHeight;
    _app.appMethod.getBoundingClientRect('#comment-box', function (rect) {
      if (Array.isArray(rect) && rect[0]) {
        commentContentHeight = e.detail.lineCount * lineHeight;
        if (rect[0].top > marginTop && e.detail.lineCount >= 1) {
          if (rect[0].top - marginTop <= lineHeight) {
            maxHeight = commentContentHeight + lineHeight;
            that.setData({
              commentContentMaxHeight: maxHeight
            });
          }
          that.setData({
            commentContentHeight: commentContentHeight
          });
        }
        if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
          that.setData({
            commentContentHeight: commentContentHeight
          });
        }
      }
    });
  };

  this.replyImageChoose = function () {
    var that = _this3;
    _app.appMethod.chooseImage(function (imageUrls) {
      that.setData((0, _defineProperty3.default)({}, 'replyParam.comment_img_url', imageUrls[0]));
    }, 1);
  };

  this.replyImagePreview = function () {
    var commentImage = _this3.data.replyParam.comment_img_url;
    _app.appMethod.previewImage({
      current: commentImage
    });
  };

  this.replyImageDelete = function () {
    _this3.setData((0, _defineProperty3.default)({}, 'replyParam.comment_img_url', ''));
  };

  this.replyLocationChoose = function () {
    var that = _this3;
    _app.appMethod.chooseLocation({
      success: function success(_ref3) {
        var name = _ref3.name,
            address = _ref3.address,
            latitude = _ref3.latitude,
            longitude = _ref3.longitude;

        var newdata = {};
        newdata['replyParam.latitude'] = latitude;
        newdata['replyParam.longitude'] = longitude;
        if (name || address) {
          newdata['replyParam.address'] = name || address;
        } else {
          that.getLocByLatAndLng(latitude, longitude, function (res) {
            address = res.address || '';
            that.setData((0, _defineProperty3.default)({}, 'replyParam.address', address));
          });
        }
        that.setData(newdata);
      }
    });
  };

  this.replyLocationDelete = function () {
    var _this3$setData3;

    _this3.setData((_this3$setData3 = {}, (0, _defineProperty3.default)(_this3$setData3, 'replyParam.address', ''), (0, _defineProperty3.default)(_this3$setData3, 'replyParam.latitude', ''), (0, _defineProperty3.default)(_this3$setData3, 'replyParam.longitude', ''), _this3$setData3));
  };

  this.switchCommentTab = function (e) {
    _this3.setData({
      commentTab: Number(e.currentTarget.dataset.num)
    });
  };

  this.goCommentDetail = function (e) {
    var _e$currentTarget$data = e.currentTarget.dataset,
        id = _e$currentTarget$data.id,
        articleId = _e$currentTarget$data.articleId;
    var franchisee = _this3.data.franchisee,
        franchiseeParam = franchisee ? '&franchisee=' + franchisee : '';

    _app.appMethod.turnToPage('/informationManagement/pages/communityComments/communityComments?detail=' + id + '&articleId=' + articleId + franchiseeParam);
  };

  this.turnToCommunityPage = function (e) {
    var section_id = _this3.data.articleInfo.section_id;

    if (!section_id) {
      _app.appMethod.showModal({
        content: '板块不存在'
      });
      return;
    }
    var franchiseeParam = _this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : '';
    _app.appMethod.turnToPage('/informationManagement/pages/communityPage/communityPage?detail=' + section_id + franchiseeParam);
  };

  this.commentImageLoad = function (e) {
    var ow = e.currentTarget.width,
        oh = e.currentTarget.height,
        path = e.currentTarget.dataset.path,
        dw = 375,
        dh = 240,
        sw = void 0,
        sh = void 0;
    if (ow / oh > dw / dh) {
      sw = dw;
      sh = dw * oh / ow;
    } else {
      sh = dh;
      sw = dh * ow / oh;
    }
    _this3.setData((0, _defineProperty3.default)({}, path, 'width:' + sw + 'rpx;height:' + sh + 'rpx;'));
  };

  this.turnToUsercenter = function (event) {
    var userInfo = _app.appMethod.getUserInfo();
    if (!userInfo || !userInfo.user_token) {
      _app.appMethod.showModal({
        content: '您暂未登陆，请先登陆'
      });
      return;
    }
    var _event$currentTarget$3 = event.currentTarget.dataset,
        usertoken = _event$currentTarget$3.usertoken,
        sourcetype = _event$currentTarget$3.sourcetype;

    var franchiseeParam = _this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : '';
    if (sourcetype === undefined) {
      return;
    }
    if (usertoken) {
      franchiseeParam += '&usertoken=' + usertoken + '&sourcetype=' + sourcetype;
    }
    _app.appMethod.turnToPage('/informationManagement/pages/communityUsercenter/communityUsercenter?detail=' + franchiseeParam);
  };

  this.tapBackPageTop = function () {
    _app.appMethod.pageScrollTo({
      scrollTop: 0
    });
  };

  this.clearCommentInput = function () {
    var _this3$setData5;

    _this3.setData((_this3$setData5 = {}, (0, _defineProperty3.default)(_this3$setData5, 'replyParam.text', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.agent_user_token', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.address', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.latitude', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.longitude', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.comment_img_url', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.comment_id', ''), (0, _defineProperty3.default)(_this3$setData5, 'replyParam.parent_comment_id', ''), _this3$setData5));
  };

  this.bindEventTapHandler = function (e) {
    var form = e.currentTarget.dataset.eventParams;
    var action = form.action;
    var args = [form];
    if (_this3.data.franchisee) {
      args.push(_this3.data.franchisee);
    }
    _customEvent.customEvent.clickEventHandler[action] && _customEvent.customEvent.clickEventHandler[action].apply(null, args);
  };

  this.turnToGoodsDetail = function (event) {
    var dataset = event.currentTarget.dataset;
    var id = dataset.id;
    var style = dataset.style;
    var appId = dataset.appId;
    var franchiseeId = appId === _app.appMethod.getAppId() ? _this3.data.franchisee : appId;
    var franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
    if (style == 3) {
      _app.appMethod.turnToPage('/pages/toStoreDetail/toStoreDetail?detail=' + id + franchiseeParam);
    } else {
      _app.appMethod.turnToPage('/detailPage/pages/goodsDetail/goodsDetail?detail=' + id + franchiseeParam);
    }
  };

  this.turnToArticle = function (event) {
    if (event.currentTarget.dataset.articleType == 3) {
      _this3.bindEventTapHandler(event);
      return;
    }
    var id = event.currentTarget.dataset.id;
    var franchiseeParam = _this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : '';
    _app.appMethod.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + franchiseeParam);
  };

  this.gotoCouponDetail = function (event) {
    var id = event.currentTarget.dataset.couponId;
    var franchiseeParam = _this3.data.franchisee ? '&franchisee=' + _this3.data.franchisee : '';
    _app.appMethod.turnToPage('/pages/couponDetail/couponDetail?couponStatus=recieve&detail=' + id + franchiseeParam);
  };

  this.relatePagesRefresh = function () {
    _app.appMethod.globalData.topicRefresh = true;
    _app.appMethod.globalData.communityPageRefresh = true;
    _app.appMethod.globalData.communityUsercenterRefresh = true;
    _app.appMethod.globalData.franchiseeCommunity = true;
  };

  this.goLivePlay = function (e) {
    var liveId = e.currentTarget.dataset.id;
    var paramstr = '';
    if (_app.appMethod.globalData.PromotionUserToken) {
      paramstr = '&custom_params=' + encodeURIComponent(JSON.stringify({
        user_token: _app.appMethod.globalData.PromotionUserToken
      }));
    }
    _app.appMethod.turnToPage('plugin-private://wx2b03c6e691cd7370/pages/live-player-plugin?room_id=' + liveId + paramstr);
  };
};

exports.default = CommunityDetail;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(625);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoActivityDetail = function (_OfficialPage) {
  (0, _inherits3.default)(VideoActivityDetail, _OfficialPage);

  function VideoActivityDetail() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, VideoActivityDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = VideoActivityDetail.__proto__ || Object.getPrototypeOf(VideoActivityDetail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activityId: '',
      activityInfo: {},
      shopInfo: {},
      franchiseeId: '',
      hasReward: false,
      videoSrc: '',
      showRewardBtn: false,
      hideVideo: true,
      fromClickEvent: false,
      hasAuth: false, // 授权成功参数
      isMixVideos: false
    }, _this.getActivityDetail = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetVideoActivityByPage',
        data: {
          sub_shop_app_id: that.data.franchiseeId || '',
          id: that.data.activityId,
          in_activity: that.data.fromClickEvent ? 1 : ''
        },
        method: 'post',
        success: function success(res) {
          if (!res.data.length) {
            return;
          }

          var activityInfo = res.data[0].form_data;
          var shopInfo = {};
          var newData = {};
          activityInfo.status = res.data[0].status;
          var getAuthInfo = _app.appMethod.getStorageSync('getAuthInfo');

          if (that.data.hasAuth) {
            that.setData({
              hasReward: true,
              showRewardBtn: true
            });
            // 返回时路径会一直携带hasAuth，需根据getAuthInfo判断是否授权返回
            if (getAuthInfo) {
              _app.appMethod.removeStorage({ key: 'getAuthInfo' });
              _app.appMethod.showToast({
                title: '视频发布成功！',
                icon: 'success',
                duration: 1000
              });
              setTimeout(function () {
                // 若设置了领取成功跳转页面
                var success_page_url = activityInfo.success_page_url;
                if (success_page_url) {
                  window.location.href = success_page_url;
                }
              }, 1000);
            }
          }
          if (activityInfo['store'] && activityInfo['store']['title'] && !this.data.franchiseeId) {
            var store = activityInfo['store'];
            shopInfo = {
              name: store['title'],
              address: '' + store.country + store.province + store.city + store.district + store.address_detail,
              phone: store['phone'],
              latitude: +store['latitude'] || '',
              longitude: +store['longitude'] || '',
              detailAddress: store.address_detail || ''
            };
            newData['shopInfo'] = shopInfo;
          } else if (that.data.franchiseeId) {
            that.getSubShopInfo();
          }
          newData['activityInfo'] = activityInfo;
          newData['activityId'] = res.data[0].id;
          newData['isMixVideos'] = +activityInfo.video.mode === 1 ? true : false;
          that.setData(newData);
          if (that.data.isMixVideos) {
            that.getVideo(activityInfo['video']['struct']['top'][0]['id']);
          } else {
            that.getVideo(activityInfo['video']['struct'][0]['id']);
          }
        }
      });
    }, _this.getSubShopInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetAppShopByPage',
        data: {
          sub_shop_app_id: that.data.franchiseeId
        },
        success: function success(res) {
          var info = res.data[0];
          var shopInfo = {
            name: info.name,
            address: info.country_region_id == 1 && info.city_name ? '' + info.province_name + info.city_name + info.county_name + info.address_detail : '' + info.address_detail + info.county_name + info.city_name + info.province_name,
            phone: info.phone,
            latitude: +info['latitude'] || '',
            longitude: +info['longitude'] || '',
            detailAddress: info.address_detail || ''
          };
          that.setData({
            shopInfo: shopInfo
          });
        }
      });
    }, _this.getVideo = function (id) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppVideo/GetVideoLibURL',
        data: {
          id: id
        },
        success: function success(res) {
          that.setData({
            videoSrc: res.data
          });
        }
      });
    }, _this.openDouyinAuth = function () {
      var that = _this;
      if (_app.appMethod.isLogin()) {
        _this.getRewards();
      } else {
        _app.appMethod.goLogin({
          success: function success() {
            that.getRewards();
          }
        });
      }
    }, _this.getRewards = function (ticket) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppEcommerce/ReceiveVideoActivityGift',
        data: {
          sub_shop_app_id: that.data.franchiseeId || '',
          id: that.data.activityId,
          code: ticket || ''
        },
        success: function success(res) {
          that.setData({
            hasReward: true,
            showRewardBtn: true
          });
          _app.appMethod.showToast({
            title: '视频发布成功！',
            icon: 'success',
            duration: 1000
          });
          setTimeout(function () {
            // 若设置了领取成功跳转页面
            var success_page_url = that.data.activityInfo.success_page_url;
            if (success_page_url) {
              window.location.href = success_page_url;
            }
          }, 1000);
        },
        fail: function fail(res) {
          console.log(res);
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          if (res.status == 8) {
            var url = encodeURIComponent(window.location.href);
            _app.appMethod.setStorage({ key: 'getAuthInfo', data: 1 });
            window.location.href = '/index.php?r=ByteM/WebLogin&app_id=' + _app.appMethod.getAppId() + '&redirect_url=' + url;
            return false;
          } else if (res.status == 1) {
            that.setData({
              showRewardBtn: true,
              hasReward: true
            });
          }
        }
      });
    }, _this.tapMakePhoneCall = function () {
      var that = _this;
      if (!that.data.shopInfo.phone) {
        _app.appMethod.showModal({
          content: '未设置联系方式'
        });
        return;
      }
      _app.appMethod.makePhoneCall(that.data.shopInfo.phone);
    }, _this.toCouponList = function () {
      _this.setData({
        hasReward: false
      });
      _app.appMethod.turnToPage('/pages/couponList/couponList');
    }, _this.playVideo = function () {
      _this.setData({
        hideVideo: false
      });
    }, _this.videoClose = function () {
      _this.setData({
        hideVideo: true
      });
    }, _this.toCheckRewards = function (e) {
      var success_page_url = _this.data.activityInfo.success_page_url;
      if (success_page_url) {
        window.location.href = success_page_url;
      }
      return;
      // 多个奖励去奖励列表
      var rewardList = _this.data.activityInfo.reward_list;
      if (rewardList.length > 1) {
        _app.appMethod.turnToPage('/pages/videoActivityReward/videoActivityReward?id=' + _this.data.activityId + '&sub_app_id=' + _this.data.franchiseeId);
        return;
      }
      var _rewardList$ = rewardList[0],
          type = _rewardList$.type,
          value = _rewardList$.value;

      var path = '';
      switch (type.toString()) {
        case '1':
          path = '/pages/couponDetail/couponDetail?detail=' + value; // 优惠券列表
          break;
        case '2':
          path = '/pages/myIntegral/myIntegral'; // 积分详情
          break;
        case '3':
          path = '/pages/balance/balance'; // 储值
          break;
        case '4':
          path = '/pages/vipCardList/vipCardList'; // 会员卡列表
          break;
        case '5':
          path = '/pages/vipBenefits/vipBenefits?id=' + _this.data.activityId; // 会员权益
          break;
        case '6':
          path = '/pages/collectStars/collectStars'; // 集集乐
          break;
        case '7':
          path = '/pages/luckyWheelDetail/luckyWheelDetail'; // 大转盘
          break;
        case '8':
          path = '/pages/scratch/scratch'; // 刮刮乐
          break;
        case '9':
          path = '/pages/goldenEggs/goldenEggs'; //砸金蛋
          break;
      }
      if (_this.data.franchiseeId) {
        if (/\?/.test(path)) {
          path = path + '&franchisee=' + _this.data.franchiseeId;
        } else {
          path = path + '?franchisee=' + _this.data.franchiseeId;
        }
      }
      _app.appMethod.turnToPage(path);
    }, _this.toLocation = function () {
      var _this$data$shopInfo = _this.data.shopInfo,
          latitude = _this$data$shopInfo.latitude,
          longitude = _this$data$shopInfo.longitude,
          address = _this$data$shopInfo.address,
          detailAddress = _this$data$shopInfo.detailAddress;

      if (latitude) {
        _app.appMethod.openLocation({
          latitude: latitude,
          longitude: longitude,
          scale: 18,
          name: detailAddress || address,
          address: address,
          fail: function fail(res) {
            _app.appMethod.showModal({ content: res });
          }
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(VideoActivityDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchisee = options.sub_app_id || options.franchisee || '';
      var activityId = options.id || '';
      var hasAuth = !!options.hasAuth || false;
      this.setData({
        hasAuth: hasAuth,
        franchiseeId: franchisee,
        activityId: activityId,
        fromClickEvent: !!options.fromClickEvent
      });
      this.getActivityDetail();
      var str = '';
      // console.log(convertHtmlTag(convertTagStyle(str)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          activityInfo = _state.activityInfo,
          hideVideo = _state.hideVideo,
          shopInfo = _state.shopInfo,
          wxParseDescription = _state.wxParseDescription,
          hasReward = _state.hasReward,
          videoSrc = _state.videoSrc,
          isMixVideos = _state.isMixVideos;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            null,
            activityInfo.status == 1 ? React.createElement(
              'div',
              null,
              React.createElement(
                'div',
                { className: 'phone-banner' },
                React.createElement(
                  'div',
                  { className: 'video-image' },
                  !isMixVideos ? React.createElement('img', {
                    src: activityInfo && activityInfo.video && (activityInfo.video.struct[0].preview_img || activityInfo.video.struct[0].preview_img_default),
                    mode: 'aspectFill',
                    hidden: !hideVideo
                  }) : React.createElement('img', {
                    src: activityInfo.video.cover,
                    mode: 'aspectFill',
                    hidden: !hideVideo
                  }),
                  React.createElement(
                    'div',
                    { className: 'tiktok-video-play', onClick: this.playVideo },
                    React.createElement(
                      'div',
                      { className: 'play-btn' },
                      React.createElement('div', { className: 'icon-play ico-moon' })
                    )
                  )
                ),
                React.createElement(
                  'div',
                  { className: 'shop-info' },
                  React.createElement(
                    'div',
                    null,
                    React.createElement(
                      'div',
                      null,
                      shopInfo.name || '店铺名称'
                    ),
                    React.createElement(
                      'div',
                      { onClick: this.toLocation },
                      shopInfo.address || '店铺地址'
                    )
                  ),
                  React.createElement('img', {
                    src: 'http://cdn.zhichiwangluo.com/zhichi_frontend/static/management/assets/img/tiktok-video/phone.png',
                    onClick: this.tapMakePhoneCall
                  })
                )
              ),
              React.createElement(
                'div',
                { className: 'step' },
                React.createElement(
                  'div',
                  { className: 'step-title' },
                  '\u6D3B\u52A8\u6B65\u9AA4'
                ),
                React.createElement('img', { src: 'http://cdn.zhichiwangluo.com/zhichi_frontend/static/management/assets/img/tiktok-video/tiktok-activity-step.png' })
              ),
              React.createElement(
                'div',
                { className: 'phone-desc' },
                React.createElement(
                  'div',
                  { className: 'phone-desc-title' },
                  '\u6D3B\u52A8\u8BF4\u660E'
                ),
                React.createElement(
                  'div',
                  { className: 'phone-desc-editor' },
                  React.createElement('div', { className: 'goods-details rich-text', dangerouslySetInnerHTML: { __html: activityInfo.desc && activityInfo.desc.replace(/href=".*?"/g, '') } })
                )
              ),
              React.createElement(
                'div',
                { className: 'reward-bot' },
                hasReward ? React.createElement(
                  'div',
                  {
                    className: 'reward-btn',
                    onClick: this.toCheckRewards },
                  '\u5DF2\u9886\u53D6\u5956\u52B1, \u53BB\u67E5\u770B'
                ) : React.createElement(
                  'div',
                  {
                    className: 'reward-btn',
                    onClick: this.openDouyinAuth },
                  '\u53D1\u89C6\u9891\u9886\u5956\u54C1'
                )
              )
            ) : React.createElement(
              'div',
              { className: 'attention-none' },
              React.createElement('img', {
                src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-goods/order-null.png',
                alt: '\u56FE\u7247'
              }),
              React.createElement(
                'div',
                { className: 'tips' },
                '\u5F53\u524D\u6682\u65E0\u6D3B\u52A8'
              )
            )
          ),
          !hideVideo && React.createElement(
            'div',
            { className: 'video-wrap' },
            React.createElement('video', {
              src: videoSrc,
              controls: true,
              autoPlay: true,
              poster: !isMixVideos ? activityInfo && activityInfo.video && (activityInfo.video.struct[0].preview_img || activityInfo.video.struct[0].preview_img_default) : activityInfo.video.cover
            }),
            React.createElement('div', {
              className: 'videoPlay-close icon-closes ico-moon',
              onClick: this.videoClose
            })
          )
        )
      );
    }
  }]);
  return VideoActivityDetail;
}(_OfficialPage3.default);

exports.default = VideoActivityDetail;

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _tools = __webpack_require__(6);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(627);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var videoActivityReward = function (_OfficialPage) {
  (0, _inherits3.default)(videoActivityReward, _OfficialPage);

  function videoActivityReward() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, videoActivityReward);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = videoActivityReward.__proto__ || Object.getPrototypeOf(videoActivityReward)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activityId: '',
      activityInfo: {},
      franchiseeId: '',
      rewards: [],
      rewardLogo: {
        1: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-coupon.png',
        2: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-integral.png',
        3: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-storeValue.png',
        4: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-vip.png',
        6: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-collect.png',
        7: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-circle.png',
        8: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-scratch.png',
        9: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/xcx-newcomer/newcomer-egg.png'
      }
    }, _this.getRewardDetail = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/GetUserReward',
        data: {
          sub_shop_app_id: that.data.franchiseeId || '',
          id: that.data.activityId
        },
        method: 'post',
        success: function success(res) {
          if (!res.data) {
            return;
          }
          that.setData({
            rewards: res.data.received_reward
          });
        }
      });
    }, _this.toCouponList = function () {
      _this.setData({
        showModal: false
      });
      _app.appMethod.turnToPage('/pages/couponList/couponList');
    }, _this.toCheckRewards = function (e) {
      var _e$currentTarget$data = e.currentTarget.dataset,
          type = _e$currentTarget$data.type,
          value = _e$currentTarget$data.value;

      var path = '';
      switch (type.toString()) {
        case '1':
          path = '/pages/couponDetail/couponDetail?detail=' + value; // 优惠券列表
          break;
        case '2':
          path = '/pages/myIntegral/myIntegral'; // 积分详情
          break;
        case '3':
          path = '/pages/balance/balance'; // 储值
          break;
        case '4':
          path = '/pages/vipCardList/vipCardList'; // 会员卡列表
          break;
        case '5':
          path = '/pages/vipBenefits/vipBenefits?id=' + _this.data.activityId; // 会员权益
          break;
        case '6':
          path = '/pages/collectStars/collectStars'; // 集集乐
          break;
        case '7':
          path = '/pages/luckyWheelDetail/luckyWheelDetail'; // 大转盘
          break;
        case '8':
          path = '/pages/scratch/scratch'; // 刮刮乐
          break;
        case '9':
          path = '/pages/goldenEggs/goldenEggs'; //砸金蛋
          break;
      }
      if (_this.data.franchiseeId) {
        if (/\?/.test(path)) {
          path = path + '&franchisee=' + _this.data.franchiseeId;
        } else {
          path = path + '?franchisee=' + _this.data.franchiseeId;
        }
      }
      _app.appMethod.turnToPage(path);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(videoActivityReward, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      var franchisee = options.sub_app_id || '';
      var activityId = options.id || '';
      this.setData({
        franchiseeId: franchisee,
        activityId: activityId
      });
      this.getRewardDetail();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          showGetUserInfo = _state.showGetUserInfo,
          rewards = _state.rewards,
          item = _state.item,
          rewardLogo = _state.rewardLogo;

      return React.createElement(
        React.Fragment,
        null,
        React.createElement(
          'div',
          null,
          React.createElement(
            'div',
            { className: 'container' },
            Array.isArray(rewards) && rewards.map(function (item, index) {
              return React.createElement(
                React.Fragment,
                null,
                React.createElement(
                  'div',
                  {
                    className: 'reward-wrap',
                    'data-type': item.type,
                    'data-value': item.value
                  },
                  React.createElement(
                    'div',
                    { className: 'reward-logo' },
                    React.createElement('img', { src: rewardLogo[item.type] }),
                    React.createElement(
                      'span',
                      null,
                      item.title
                    )
                  ),
                  React.createElement(
                    'div',
                    {
                      className: 'look-detail',
                      'data-type': item.type,
                      'data-value': item.value,
                      onClick: _this2.toCheckRewards
                    },
                    '\u67E5\u770B'
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return videoActivityReward;
}(_OfficialPage3.default);

exports.default = videoActivityReward;

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _regenerator = __webpack_require__(82);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(83);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(643);

var _TextAnimation = __webpack_require__(143);

var _TextAnimation2 = _interopRequireDefault(_TextAnimation);

var _tools = __webpack_require__(6);

var _Dialog = __webpack_require__(84);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _cryptoJs = __webpack_require__(145);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _indexUmd = __webpack_require__(148);

var _indexUmd2 = _interopRequireDefault(_indexUmd);

var _LoginPage = __webpack_require__(92);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _html2canvas = __webpack_require__(149);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _weixinSdkConfig = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4',
  '2': '文心一言-4.0',
  '3': 'GPT-4omini',
  '4': '通义千问',
  '5': 'kimi',
  '6': 'GPT-4o',
  '7': '字节豆包',
  '8': '百川智能',
  '9': 'GPT-o1-preview',
  '10': 'GPT-o1-mini',
  '11': '腾讯混元',
  '12': '讯飞星火-Max',
  '13': 'Azure-OpenAI',
  '14': 'deepseek（官网）',
  '15': 'deepseek（腾讯云版本）',
  '16': 'UI TARS',
  '17': 'GPT-o3-mini',
  '18': 'GPT-o4-mini',
  '19': '通义千问3'
};
var APPID = "2dcb30a7";
var API_SECRET = "Mzg2ZmYzNDIyZGQ1M2MzMDU4OWY5Yzc1";
var API_KEY = "9449a5280ed944fa8f53b23d5c1e90fd";

var longPressTimeout = void 0;

var GptIndex = function (_OfficialPage) {
  (0, _inherits3.default)(GptIndex, _OfficialPage);

  function GptIndex(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, GptIndex);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GptIndex.__proto__ || Object.getPrototypeOf(GptIndex)).call(this, props));

    _this.countdownInterval = null;
    _this.recorder = null;
    _this.iatWS = null;
    _this.state = {
      canUseIntegral: 0,
      userVipCardInfo: null,
      historyNum: 0,
      roleList: [{
        role_id: 0,
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }],
      roleListAll: [],
      selectedRoleId: '',
      switchSelectedRoleId: '',
      sessionId: '', //会话id
      dialogueList: [],
      is_more: 0,
      current_page: 1,
      content: '', //提问内容
      is_audio: 0, //提问方式   0打字提问 1语音提问
      shareKey: '',
      sharePoliteData: {},
      isWeiXinBrowser: false,
      isSub: false,
      isShowAllRole: false,
      searchValue: '',
      modalType: 0, // 模型
      modalName: 'GPT-3.5', // 模型名称
      modalId: '',
      modalList: [],
      isShowModalConfig: false,
      isNeedVip: false,
      isNeedIntegral: false,

      // 录音相关数据
      isAudio: true, // 是否切换为录音
      isRecording: false, // 正在录音
      // iatWS:null, //websocket
      resultText: '', // 文字结果
      resultTextTemp: '', // 文字修正结果
      // countdownInterval:null, // 时间计数器
      seconds: 60, // 倒计时
      recordInterrupt: false,
      // recorder:null,

      maskShow: false,
      isShare: false, // 正在分享
      shareDialogList: [], // 选择分享的内容
      lastDialogId: 0,
      shareImgUrl: '',
      qrCodeImg: '',
      isLongPress: false,
      longPressInx: -1
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              userVipCardInfo: res.data.user_paid_vip_card,
              isNeedVip: Boolean(res.data.all_vip_card.length)
            });
            _this.getSupportTypeSet();
          }
        }
      });
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          that.setState({
            canUseIntegral: res.data.can_use_integral
          });
        }
      });
    };

    _this.getIntegralInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          if (res.status != 0) {
            return;
          }
          that.setState({
            isNeedIntegral: Boolean(res.data.length)
          });
        }
      });
    };

    _this.getPrologue = function () {
      var roleList = _this.state.roleList;
      var currentRoleId = _this.state.selectedRoleId;
      // 获取开场白
      var prologueData = roleList.filter(function (item) {
        return currentRoleId == item.id || currentRoleId == item.role_id;
      })[0];
      var prologue = prologueData.prologue || ''; //prologueData.content
      var dialoguearr = _this.state.dialogueList;
      if (prologue) {
        dialoguearr.unshift({ // 将开场白插入对话
          text: prologue,
          direction: 'reply',
          id: '0000',
          isHistory: true
        });
      }
      _this.setData({
        selectedRolePrologue: prologue,
        dialogueList: dialoguearr
      });
    };

    _this.getHistoryList = function () {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/SessionList',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: -1,
          page_size: 1
        },
        method: 'POST',
        success: function success(res) {
          _app.appMethod.hideLoading();
          that.setData({
            historyNum: res.data.length
          });
        }
      });
    };

    _this.getSessionList = function () {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      var that = _this;
      // 初始化 
      var currentSessionId = '';
      var currentRoleId = '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetRole',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: 1,
          page_size: 5
        },
        method: 'POST',
        success: function success(res) {
          if (res.data.length != 0) {
            _app.appMethod.hideLoading();
            var user_roles = res.data.user_roles || [];
            var roleList = [].concat((0, _toConsumableArray3.default)(that.data.roleList), (0, _toConsumableArray3.default)(user_roles), (0, _toConsumableArray3.default)(res.data.system_role));
            roleList.forEach(function (item) {
              if (item.id) {
                item.role_id = item.id;
              }
              if (item.title) {
                item.role_name = item.title;
              }
              if (item.is_default == '1') {
                //设置了默认角色时
                currentRoleId = item.id;
              }
            });
            that.setData({
              roleList: roleList,
              roleListAll: roleList
            });
            // 从入口页历史对话进入
            if (that.data.sessionId && that.data.selectedRoleId) {
              currentSessionId = that.data.sessionId;
              currentRoleId = that.data.selectedRoleId;
            } else {
              // 获取历史当前打开的历史对话页
              var getSt = _app.appMethod.getStorageSync('nowSessionData');
              if (getSt) {
                currentSessionId = getSt.sessionId;
                currentRoleId = that.data.roleList.filter(function (item) {
                  return item.role_id == getSt.roleId;
                })[0].role_id;
              }
            }
            that.setData({
              sessionId: currentSessionId,
              selectedRoleId: currentRoleId,
              switchSelectedRoleId: currentRoleId
            });
            if (currentSessionId) {
              that.getSessionHistory({
                session_id: currentSessionId,
                page: that.data.current_page
              });
            }
          }
        }
      });
    };

    _this.creatSession = function (id) {
      var that = _this;
      return new Promise(function (resolve, reject) {
        var parms = {
          app_id: _app.appMethod.getAppId()
        };
        if (id) {
          parms['role_play_id'] = id;
        }
        _app.appMethod.sendRequest({
          url: '/index.php?r=ChatAI/CreateSession',
          data: parms,
          hideLoading: true,
          method: 'POST',
          complete: function complete(res) {
            if (res.status == 0) {
              _app.appMethod.setStorage({
                key: 'nowSessionData',
                data: {
                  sessionId: res.data,
                  roleId: id ? id : 0
                }
              });
              that.setData({
                sessionId: res.data
              });
              resolve(res.data);
            } else {
              reject();
            }
          }
        });
      });
    };

    _this.selectActiveItem = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      if (_this.state.historyNum > 3 && !_this.state.userVipCardInfo) {
        if (!_this.state.isNeedVip) {
          _Dialog2.default.showModal({
            title: '会话已达上限',
            confirm: function confirm() {}
          });
          return;
        }
        _Dialog2.default.showModal({
          title: '会话已达上限',
          content: '请删除重新创建或开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            _app.appMethod.turnToPage('gptrecharge');
          }
        });
        return;
      }
      var session = that.data.roleList.filter(function (item) {
        return item.role_id == id || item.id == id;
      })[0];
      var title = session.role_name || session.title;
      _Dialog2.default.showModal({
        title: '是否切换对话角色为' + title,
        confirm: function confirm() {
          that.setData({
            selectedRoleId: session.role_id,
            dialogueList: [],
            is_more: 0,
            isShowAllRole: false,
            searchValue: '',
            roleListAll: that.data.roleList,
            switchSelectedRoleId: session.role_id
          });
          _app.appMethod.removeStorage({ key: 'nowSessionData' });
          if (id == 0 || id == '0') {
            //普通会话
            that.creatSession().then(function () {
              _this.getHistoryList();
            });
            return;
          }
          that.creatSession(id).then(function () {
            _this.getHistoryList();
          });
        }
      });
    };

    _this.bindTextInput = function (event) {
      var val = event.target.value;
      if (val) {
        _this.setData({
          isSub: true
        });
      } else {
        _this.setData({
          isSub: false
        });
      }
      _this.setData({
        'content': val
      });
    };

    _this.getSessionHistory = function (option) {
      var ismore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hideloading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new Promise(function (resovle) {
        var _app$sendRequest;

        var diaArr = _this.state.dialogueList;
        var that = _this;
        _app.appMethod.showLoading({
          title: '加载中..'
        });
        _app.appMethod.sendRequest((_app$sendRequest = {
          hideLoading: true,
          url: '/index.php?r=ChatAI/SessionChatList'
        }, (0, _defineProperty3.default)(_app$sendRequest, 'hideLoading', hideloading), (0, _defineProperty3.default)(_app$sendRequest, 'method', 'POST'), (0, _defineProperty3.default)(_app$sendRequest, 'data', (0, _extends3.default)({
          app_id: _app.appMethod.getAppId(),
          page_size: 20
        }, option)), (0, _defineProperty3.default)(_app$sendRequest, 'success', function success(res) {
          if (res.status == 0) {
            if (res.data.length) {
              resovle(res.data[0].id);
            }
            if (ismore) {
              // 从顶部插入
              var data = res.data.reverse();
              for (var j = data.length - 1; j >= 0; j--) {
                diaArr.unshift({
                  text: data[j].content,
                  direction: data[j].role == '0' ? 'ques' : 'reply',
                  id: data[j].id,
                  isHistory: true,
                  is_audio: data[j].is_audio
                });
              }
            } else {
              for (var i = res.data.length - 1; i >= 0; i--) {
                diaArr.push({
                  text: res.data[i].content,
                  direction: res.data[i].role == '0' ? 'ques' : 'reply',
                  id: res.data[i].id,
                  isHistory: true,
                  is_audio: res.data[i].is_audio
                });
              }
            }
            that.setData({
              dialogueList: diaArr,
              is_more: res.is_more,
              current_page: res.current_page || 1
            });
            that.getPrologue();
            var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
            // 聊天记录聚焦最新会话 
            if (!ismore) {
              dialogEle.scrollTop = dialogEle.scrollHeight;
            }
          }
        }), _app$sendRequest));
      });
    };

    _this.getMore = function () {
      _this.getSessionHistory({
        session_id: _this.data.sessionId,
        page: _this.data.current_page + 1
      }, true);
    };

    _this.tipsModalFn = function () {
      var _this$state = _this.state,
          isNeedVip = _this$state.isNeedVip,
          isNeedIntegral = _this$state.isNeedIntegral,
          userVipCardInfo = _this$state.userVipCardInfo,
          canUseIntegral = _this$state.canUseIntegral,
          freeNum = _this$state.freeNum;

      var dsc = '';
      var confirmText = '';

      if (isNeedVip && isNeedIntegral && !userVipCardInfo && canUseIntegral < 2) {
        dsc = '积分不足，请先购买会员或积分';
      } else if (isNeedVip && !isNeedIntegral && !userVipCardInfo && canUseIntegral < 2 && freeNum < 1) {
        dsc = '提问次数不足，去开通会员';
        confirmText = '去开通';
      } else if (!isNeedVip && isNeedIntegral && canUseIntegral < 2) {
        dsc = '积分不足，去购买积分';
        confirmText = '去购买';
      } else if (!isNeedVip && !isNeedIntegral && canUseIntegral < 2 && freeNum < 1) {
        dsc = '提问次数不足';
        confirmText = '确定';
      } else {

        return;
      }
      _Dialog2.default.showModal({
        title: dsc,
        confirmText: confirmText,
        confirm: function confirm() {
          that.renewVip();
        }
      });
    };

    _this.goQuestion = function (option) {
      var that = _this;
      var diaArr = _this.state.dialogueList;
      var oldId = diaArr.length && Number(diaArr[diaArr.length - 1].id) || 0; // 暂存最后对话的id,没有就对话时赋值0
      // if(this.state.canUseIntegral < 2){
      //   Dialog.showModal({
      //     title: '积分不足，请先购买会员或积分',
      //     confirm: function () {
      //       app.turnToPage('gptrecharge');
      //     }
      //   })
      //   return
      // }
      _this.tipsModalFn();
      diaArr.push({
        text: that.data.content,
        direction: 'ques',
        id: diaArr.length ? diaArr.at(-1).id + 1 : new Date().getTime(),
        isLoading: true,
        is_audio: that.data.is_audio
      });
      that.setData({
        dialogueList: diaArr,
        content: ''
      });
      var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
      var scrollTimer = setTimeout(function () {
        dialogEle.scrollTop = dialogEle.scrollHeight;
        clearTimeout(scrollTimer);
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        hideModal: true,
        url: '/index.php?r=ChatAI/AskQues',
        timeout: 40000,
        method: 'POST',
        data: (0, _extends3.default)({
          app_id: _app.appMethod.getAppId()
        }, option),
        complete: function complete(res) {
          if (!res && oldId) {
            // 请求超时时，轮询获取聊天记录
            var getNewTimer = setInterval(function () {
              that.getSessionHistory({
                session_id: that.data.sessionId,
                page: 1
              }, false, true).then(function (newId) {
                if (Number(newId) > oldId) {
                  clearInterval(getNewTimer);
                }
              });
            }, 3000);
          } else {
            if (res.status == 0 && res.data.response) {
              diaArr[diaArr.length - 1].isLoading = false;
              diaArr.push({
                text: res.data.response,
                direction: 'reply',
                // id: res.data.id // 这里的设置有点奇怪，接口返回的数据没有id
                id: diaArr.at(-1).id + 1,
                is_audio: that.data.is_audio
              });
              that.setData({
                dialogueList: diaArr
              });
            } else {
              diaArr[diaArr.length - 1].isLoading = false;
              diaArr[diaArr.length - 1].err = true;
              _Dialog2.default.showModal({
                title: '对话异常' + res.data,
                confirm: function confirm() {}
              });
            }
          }
          that.setData({
            content: '',
            is_audio: 0
          });
          scrollTimer = setTimeout(function () {
            dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
            clearTimeout(scrollTimer);
          });
        }
      });
    };

    _this.askQuestions = function () {
      var _this$state2 = _this.state,
          content = _this$state2.content,
          sessionId = _this$state2.sessionId,
          is_audio = _this$state2.is_audio;

      var that = _this;
      if (content == '') {
        _toast2.default.info('来说点什么吧');
        return;
      }
      if (_this.state.historyNum >= 4 && !_this.state.userVipCardInfo && !sessionId) {
        if (!_this.state.isNeedVip) {
          _Dialog2.default.showModal({
            title: '会话已达上限',
            confirm: function confirm() {}
          });
          return;
        }
        _Dialog2.default.showModal({
          title: '会话已达上限',
          content: '请删除重新创建或开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            _app.appMethod.turnToPage('gptrecharge');
          }
        });
        return;
      }
      if (sessionId == '' || sessionId == 0) {
        that.creatSession().then(function (id) {
          that.goQuestion({
            session_id: id,
            question: content,
            type: that.state.modalType,
            is_audio: is_audio
          });
        });
      } else {
        that.goQuestion({
          session_id: sessionId,
          question: content,
          type: that.state.modalType,
          is_audio: is_audio
        });
      }
    };

    _this.goBack = function () {
      // app.turnBack();
      _app.appMethod.turnToPage('jisugpt');
    };

    _this.toPage = function () {
      _app.appMethod.turnToPage('signin');
    };

    _this.toPage2 = function () {
      _app.appMethod.turnToPage('myIntegral?from=userCenterEle');
    };

    _this.shareClickEvent = function () {
      var that = _this;
      var sharePoliteData = _this.data.sharePoliteData;
      _app.appMethod.showModal({
        content: sharePoliteData.title,
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: function confirm() {
          sharePoliteData.rewards.map(function (item) {
            that.getRecvChance(item.type, that.data.shareKey);
          });
        }
      });
    };

    _this.getShareKey = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: "/index.php?r=AppShare/GetAppShareKey",
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              shareKey: res.data
            });
          }
        }
      });
    };

    _this.getRecvChance = function (type, token) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ShareGiftActivity/GetRecvChance',
        method: 'POST',
        data: {
          share_type: type,
          share_token: token
        },
        success: function success(res) {
          if (!res.data.get_chance) {
            _app.appMethod.shareClickEvent();
          }
        }
      });
    };

    _this.getShareData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ShareGiftActivity/GetEffectActivity',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              sharePoliteData: res.data
            });
          }
        }
      });
    };

    _this.againSend = function (data) {
      var list = JSON.parse(JSON.stringify(_this.data.dialogueList));
      list.pop();
      _this.setData({
        content: data,
        dialogueList: list
      });
      _this.askQuestions();
    };

    _this.toBoxBottom = function () {
      var dialogEle = _reactDom2.default.findDOMNode(_this.myRef.current);
      var scrollTimer = setTimeout(function () {
        dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
        clearTimeout(scrollTimer);
      });
    };

    _this.showAllRolePage = function () {
      _this.setData({
        isShowAllRole: true,
        isShowModalConfig: false
      });
    };

    _this.hiddenAllRolePage = function () {
      _this.setData({
        isShowAllRole: false
      });
    };

    _this.bindSearInput = function (event) {
      var val = event.target.value;
      var reg = new RegExp(val);
      var Arr = _this.data.roleList.filter(function (item) {
        if (val == item.role_name || val == item.title || reg.test(item.role_name) || reg.test(item.title)) {
          return item;
        }
      });
      _this.setData({
        searchValue: val,
        roleListAll: Arr
      });
    };

    _this.selectSwitchItem = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      that.setData({
        switchSelectedRoleId: id
      });
    };

    _this.confirmSelect = function () {
      _this.selectActiveItem({ currentTarget: { dataset: { id: _this.data.switchSelectedRoleId } } });
    };

    _this.getUserAiModel = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/GetUserAiModel',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              modalType: res.data,
              modalName: GPTModal[res.data],
              modalId: res.data
            });
          }
        }
      });
    };

    _this.changeAiModel = function (type) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/ChangeAiModel',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId(),
          model_type: type
        },
        success: function success(res) {
          if (res.status == 0) {
            _toast2.default.info('切换完成');
            that.getUserAiModel();
            that.setData({
              isShowModalConfig: false
            });
          }
        }
      });
    };

    _this.getSupportTypeSet = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/GetSupportTypeSet',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            var list = res.data.map(function (item) {
              if (that.state.isNeedVip) {
                return res[item];
              } else {
                if (res[item].require_vip_permission != '1') {
                  return res[item];
                }
              }
            }).filter(function (value) {
              return value !== undefined;
            });
            that.setData({
              modalList: list
            });
          }
        }
      });
    };

    _this.selectModal = function (event) {
      // app.showLoading({
      //   title: '切换中..',
      // })
      var that = _this;
      _app.appMethod.showLoading({
        title: '切换中..'
      });
      var type = event.currentTarget.dataset.type;
      var isvip = event.currentTarget.dataset.isvip;
      if (Number(isvip) && !_this.state.userVipCardInfo) {
        _this.setData({
          isShowModalConfig: false
        });
        _Dialog2.default.showModal({
          title: '请开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            _app.appMethod.turnToPage('gptrecharge');
          }
        });
        return;
      }
      _this.changeAiModel(type);
    };

    _this.showSelectModalBox = function () {
      _this.setData({
        isShowModalConfig: !_this.data.isShowModalConfig
      });
    };

    _this.startSpeech = function () {
      if (!_this.data.isRecording) {
        _this.connectWebSocket();
      } else {
        _this.recorder.stop();
      }
    };

    _this.getWebSocketUrl = function () {
      // 请求地址根据语种不同变化
      var url = "wss://iat-api.xfyun.cn/v2/iat";
      var host = "iat-api.xfyun.cn";
      var apiKey = API_KEY;
      var apiSecret = API_SECRET;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = 'host: ' + host + '\ndate: ' + date + '\nGET /v2/iat HTTP/1.1';
      var signatureSha = _cryptoJs2.default.HmacSHA256(signatureOrigin, apiSecret);
      var signature = _cryptoJs2.default.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = 'api_key="' + apiKey + '", algorithm="' + algorithm + '", headers="' + headers + '", signature="' + signature + '"';
      var authorization = btoa(authorizationOrigin);
      url = url + '?authorization=' + authorization + '&date=' + date + '&host=' + host;
      return url;
    };

    _this.toBase64 = function (buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    };

    _this.createRecorder = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var localWorkerUrl, codeString;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localWorkerUrl = '';
              // 得到字符串化的 JS 代码

              _context.next = 3;
              return fetch('https://cdn.jisuapp.cn/static/webapp/js/processor/processor.worker.js').then(function (res) {
                return res.text();
              });

            case 3:
              codeString = _context.sent;


              // 在这里我没有使用 new Worker(`data:application/javascript, ${codeString}`) 这种方式
              // 而是使用了 URL.createObjectURL 以及 new Blob, 会将 JavaScript 字符串转换为如下格式
              // blob:http://same-domain/cd2930c0-f4ca-4a9f-b6b1-8242e520dd62
              // 因此不再会有跨域问题
              localWorkerUrl = window.URL.createObjectURL(new Blob([codeString], {
                type: 'application/javascript'
              }));
              _this.recorder = new _indexUmd2.default(localWorkerUrl);
              // console.warn("process.env.BUILD_ENV: ", process.env.BUILD_ENV)
              _this.recorder.onStart = function () {
                console.log('录音开始');
                _this.setData({ isRecording: true });
              };
              _this.recorder.onFrameRecorded = function (_ref2) {
                var isLastFrame = _ref2.isLastFrame,
                    frameBuffer = _ref2.frameBuffer;

                // console.log(frameBuffer,this.toBase64(frameBuffer));
                if (_this.iatWS.readyState === _this.iatWS.OPEN) {
                  _this.iatWS.send(JSON.stringify({
                    data: {
                      status: isLastFrame ? 2 : 1,
                      format: "audio/L16;rate=16000",
                      encoding: "raw",
                      audio: _this.toBase64(frameBuffer)
                    }
                  }));
                  if (isLastFrame) {
                    _this.setData({ isRecording: false });
                  }
                }
              };
              _this.recorder.onStop = function () {
                console.log('录音结束');
                _this.setData({ resultText: '', isRecording: false });
                clearInterval(_this.countdownInterval);
              };

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.connectWebSocket = function () {
      var websocketUrl = _this.getWebSocketUrl();
      if ("WebSocket" in window) {
        _this.iatWS = new WebSocket(websocketUrl);
      } else if ("MozWebSocket" in window) {
        _this.iatWS = new MozWebSocket(websocketUrl);
      } else {
        alert("浏览器不支持WebSocket");
        return;
      }
      _this.iatWS.onopen = function (e) {
        _this.countdown();
        // 开始录音
        _this.recorder.start({
          sampleRate: 16000,
          frameSize: 1280
        });
        var params = {
          common: {
            app_id: APPID
          },
          business: {
            language: "zh_cn",
            domain: "iat",
            accent: "mandarin",
            vad_eos: 5000,
            dwa: "wpgs"
          },
          data: {
            status: 0,
            format: "audio/L16;rate=16000",
            encoding: "raw"
          }
        };
        _this.iatWS.send(JSON.stringify(params));
      };
      _this.iatWS.onmessage = function (e) {
        _this.renderResult(e.data);
        console.log('iatWS.onmessage: ', e.data);
      };
      _this.iatWS.onerror = function (e) {
        console.error(e);
        _this.recorder.stop();
      };
      _this.iatWS.onclose = function (e) {
        console.log(333);
        _this.recorder.stop();
        if (!_this.data.recordInterrupt && _this.data.resultText) {
          _this.setData({ content: _this.data.resultText, is_audio: 1 });
          console.log('发出去', _this.data.resultText);
          _this.askQuestions();
        }
        _this.setData({ recordInterrupt: false });
      };
    };

    _this.countdown = function () {
      _this.setData({ seconds: 60 });
      _this.countdownInterval = setInterval(function () {
        // seconds.value = seconds.value - 1;
        _this.setData({ seconds: _this.data.seconds - 1 });
        if (_this.data.seconds <= 0) {
          clearInterval(_this.countdownInterval);
          _this.recorder.stop();
        }
      }, 1000);
    };

    _this.renderResult = function (resultData) {
      // 识别结束
      var jsonData = JSON.parse(resultData);
      if (jsonData.data && jsonData.data.result) {
        var data = jsonData.data.result;
        var str = "";
        var ws = data.ws;
        for (var i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w;
        }
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === "apd") {
            // 将resultTextTemp同步给resultText
            _this.setData({ resultText: _this.data.resultTextTemp });
          }
          // 将结果存储在resultTextTemp中
          _this.setData({ resultTextTemp: _this.data.resultText + str });
        } else {
          _this.setData({ resultText: _this.data.resultText + str });
        }
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        _this.iatWS.close();
      }
      if (jsonData.code !== 0) {
        _this.iatWS.close();
        console.error(jsonData);
      }
    };

    _this.cancelRecord = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(type, 'cancelRecord', _this);
                _this.setData({ recordInterrupt: true });
                _context2.next = 4;
                return _this.recorder.stop();

              case 4:
                type && _this.textareaRef.current && _this.textareaRef.current.focus();
                type && console.log(_this.textareaRef, '33333');
                // console.log(type,'222222');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.closeMask = function (event) {
      event.persist();
      event.target.id == 'mask' && _this.setData({ maskShow: false });
    };

    _this.startShare = function (index) {
      var diaArr = _this.state.dialogueList;
      diaArr.forEach(function (ele) {
        ele.isHistory = true;
      });
      _this.setData({
        dialogueList: diaArr
      });
      _this.setData({ isShare: true });
      _this.selectThisDialog(index);
    };

    _this.cancelShare = function () {
      _this.setData({ isShare: false, shareDialogList: [], maskShow: false, shareImgUrl: '' });
    };

    _this.selectThisDialog = function (index) {
      var item = _this.data.dialogueList[index];
      var shareDialogList = _this.data.shareDialogList;
      var inx = shareDialogList.findIndex(function (ele) {
        return item.id == ele.id;
      });

      if (item.direction == 'reply') {
        var item2 = _this.data.dialogueList[index - 1];
        if (inx == -1) {
          shareDialogList.push(item2, item);
        } else {
          shareDialogList.splice(inx - 1, 2);
        }
      } else {
        var _item = _this.data.dialogueList[index + 1];
        if (inx == -1) {
          shareDialogList.push(item, _item);
        } else {
          shareDialogList.splice(inx, 2);
        }
      }
      shareDialogList.sort(function (a, b) {
        return a.id - b.id;
      });
      _this.setData({ shareDialogList: shareDialogList });
    };

    _this.isInShareDialogList = function (item) {
      // console.log(item,this.data.shareDialogList.some(ele=>item.id == ele.id),'isInShareDialogList');
      return _this.data.shareDialogList.some(function (ele) {
        return item.id == ele.id;
      });
    };

    _this.createShareImg = function () {
      _this.setData({ maskShow: true });
      _this.exportPictureDownPNG();
    };

    _this.saveShareImg = function () {
      _app.appMethod.showLoading({
        title: '图片加载中..'
      });
      var intervalId = setInterval(function () {
        if (_this.data.shareImgUrl) {
          _app.appMethod.hideLoading();
          var link = document.createElement('a');
          link.href = _this.state.shareImgUrl;
          link.download = 'shareImg.png';

          // 模拟点击下载链接，触发下载
          link.click();
          // document.body.removeChild(link);
          _this.cancelShare();
          clearInterval(intervalId);
        }
      }, 100);
      setTimeout(function () {
        clearInterval(intervalId); // 停止定时器的执行
      }, 10000);
    };

    _this.shareWechat = function () {
      // wx.onMenuShareAppMessage({
      //   title: 'xxx', // 分享标题
      //   desc: 'xxx', // 分享描述
      //   link: 'www.baidu.com', // 分享链接
      //   imgUrl: '', // 分享图标
      // })
      // console.log(wx,'wwx');
      // configWxShare({
      //   title: this.shareData.title || 'xxx',
      //   link: this.shareData.path || 'www.baidu.com',
      //   imgUrl: this.shareData.imageUrl || 'xxx',
      //   desc: this.shareData.desc || 'xxx'
      // })
      _Dialog2.default.showModal({
        title: '功能正在开发，可保存图片分享',
        confirm: function confirm() {
          console.log('好的');
        }
      });
    };

    _this.shareCircle = function () {
      _Dialog2.default.showModal({
        title: '功能正在开发，可保存图片分享',
        confirm: function confirm() {
          console.log('好的');
        }
      });
    };

    _this.stopAudio = function () {
      window.speechSynthesis.pause();
    };

    _this.exportPictureDownPNG = function () {
      var that = _this;
      setTimeout(function () {
        if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE8.0" || navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {
          //IE亲测
          alert("请升级您的IE浏览器版本，暂不支持IE9及以下版本导出图片。");
        }
        // html2canvas(document.getElementById('shareImg'), {
        //   onrendered: function(canvas) {
        //     var imgData = canvas.toDataURL('image/octet-stream');
        //     if (canvas.msToBlob) {     // IE 9+浏览器
        //       var blob = canvas.msToBlob();
        //       window.navigator.msSaveBlob(blob, pngName);
        //       console.log('22222222');

        //     }else {
        //       console.log('1111111111');
        //       // saveFile(imgData,pngName);
        //     }
        //     console.log('333333333',imgData);

        //   }
        // });
        (0, _html2canvas2.default)(document.getElementById('shareImg'), {
          scale: 10,
          useCORS: true
        }).then(function (canvas) {
          var dataUrl = canvas.toDataURL();
          var blob = that.dataURLtoBlob(dataUrl);
          // 创建临时URL
          var url = URL.createObjectURL(blob);
          that.setData({ shareImgUrl: url });
        });
      }, 1000);
    };

    _this.dataURLtoBlob = function (dataURL) {
      var arr = dataURL.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    };

    _this.closeAndSend = function () {
      _this.iatWS.close();
    };

    _this.getQrCodeImg = function () {
      // console.log(window.location.href);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/CreateQrCode',
        data: {
          app_id: _app.appMethod.getAppId(),
          path: window.location.href

        },
        success: function success(res) {
          if (res.status == 0) {
            // console.log(res.data);
            _this.setData({
              qrCodeImg: res.data
            });
          }
        }
      });
    };

    _this.longPressStart = function (longPressInx) {
      longPressTimeout = setTimeout(function () {
        _this.setData({
          isLongPress: true,
          longPressInx: longPressInx
        });
        console.log(666);
      }, 1000);
    };

    _this.longPressEnd = function () {
      console.log(77, longPressTimeout);
      longPressTimeout && clearTimeout(longPressTimeout);
      console.log(777, longPressTimeout);
    };

    _this.cancleLongPress = function () {
      _this.setData({
        isLongPress: false
      });
      longPressTimeout && clearTimeout(longPressTimeout);
      console.log(888, longPressTimeout);
    };

    document.title = '即速对话';
    _this.myRef = _react2.default.createRef();
    _this.textareaRef = _react2.default.createRef();
    if (_app.appMethod.isWeixin()) {
      _this.state.isWeiXinBrowser = true;
    }
    return _this;
  }

  (0, _createClass3.default)(GptIndex, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      // this.textareaRef.current && this.textareaRef.current.focus()
      // console.log(this.textareaRef,'33333')
      _app.appMethod.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
      // 为进入历史对话时
      if (options.sid && options.rid) {
        this.setData({
          sessionId: options.sid,
          selectedRoleId: options.rid,
          switchSelectedRoleId: options.rid
        });
        _app.appMethod.setStorage({
          key: 'nowSessionData',
          data: {
            sessionId: options.sid,
            roleId: options.rid
          }
        });
      }
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin();
        return;
      }
      if (!_app.appMethod.getUserInfo().phone) {
        _toast2.default.info('请补充用户信息', 1, function () {
          _app.appMethod.turnToPage('add-phone');
        });
        return;
      }
      this.getSessionList();
      this.getIntegralDetailData();
      this.getVipInfo();
      this.getIntegralInfo();
      this.getHistoryList();

      this.createRecorder();
      this.getQrCodeImg();
      this.getUserAiModel();
      // app.getAppCurrentPage().shareData.path = 'https://test2.zhichiwangluo.com/zc_webapp/jisugpt?app_id=' + app.getAppId()
      // this.getShareKey();
      // this.getShareData();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _Dialog2.default.cancel();
    }
    // 获取会员信息

    // 获取积分信息

    //获取开场白 

    // 获取历史对话

    // 获取会话角色

    // 创建会话

    // 选中角色

    // 获取会话聊天记录

    // 点击加载更多

    // 提问

    // 分享的点击事件（对小程序分享按钮的另种实现）

    // 重新发送

    // 

    // 获取模型选择

    // 切换模型

    // 获取可用的配置模型


    // 语音转文字功能函数

    // openShare = () => {
    //   this.setData({maskShow : true})
    // }

    // 生成图片

    // convertUrlToBase64 = (url) => {
    //   return new Promise((resolve) => {
    //       let img = new Image();
    //       img.crossOrigin = 'Anonymous';
    //       img.src = url;
    //       img.onload = function () {
    //           let canvas = document.createElement('canvas');
    //           canvas.width = img.width;
    //           canvas.height = img.height;
    //           let ctx = canvas.getContext('2d');
    //           ctx.drawImage(img, 0, 0, img.width, img.height);
    //           let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    //           let dataURL = canvas.toDataURL('image/' + ext);
    //           let base64 = {
    //               dataURL: dataURL,
    //               type: 'image/' + ext,
    //               ext: ext
    //           };
    //           resolve(base64)
    //       }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          content = _state.content,
          roleList = _state.roleList,
          selectedRoleId = _state.selectedRoleId,
          is_more = _state.is_more,
          userVipCardInfo = _state.userVipCardInfo,
          isWeiXinBrowser = _state.isWeiXinBrowser,
          isSub = _state.isSub,
          roleListAll = _state.roleListAll,
          switchSelectedRoleId = _state.switchSelectedRoleId,
          isShowAllRole = _state.isShowAllRole,
          searchValue = _state.searchValue,
          modalName = _state.modalName,
          isNeedIntegral = _state.isNeedIntegral,
          isNeedVip = _state.isNeedVip,
          modalId = _state.modalId,
          modalList = _state.modalList,
          isShowModalConfig = _state.isShowModalConfig,
          isAudio = _state.isAudio,
          isRecording = _state.isRecording,
          seconds = _state.seconds,
          resultText = _state.resultText,
          maskShow = _state.maskShow,
          isShare = _state.isShare,
          qrCodeImg = _state.qrCodeImg,
          shareImgUrl = _state.shareImgUrl,
          isLongPress = _state.isLongPress,
          longPressInx = _state.longPressInx;

      return _react2.default.createElement(
        'div',
        { className: 'gpt_page', onClick: this.cancleLongPress },
        !isWeiXinBrowser && _react2.default.createElement(
          'div',
          { className: 'head' },
          !isShare && _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png', alt: 'back', onClick: this.goBack }),
          isShare && _react2.default.createElement(
            'div',
            { className: 'head_btn', onClick: this.cancelShare },
            '\u53D6\u6D88'
          ),
          _react2.default.createElement(
            'div',
            null,
            isShare ? '选择分享内容' : '即速对话'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main ' + (isWeiXinBrowser ? '' : 'pd_t35'), ref: this.myRef },
          _react2.default.createElement(
            'div',
            { className: 'tab_box' },
            _react2.default.createElement(
              'div',
              null,
              '\u89D2\u8272\u5207\u6362'
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab_list' },
              roleList.map(function (item, index) {
                if (index < 5) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'tab ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'active' : ''),
                      'data-id': item.role_id || item.id, key: index, onClick: _this3.selectActiveItem },
                    item.url && _react2.default.createElement('img', { className: 'roleimg', src: item.url }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.role_name || item.title
                    )
                  );
                }
              }),
              roleList.length > 6 && _react2.default.createElement(
                'div',
                { className: 'tab', onClick: this.showAllRolePage },
                '\u66F4\u591A',
                '  >'
              )
            )
          ),
          is_more == 1 && _react2.default.createElement(
            'div',
            { className: 'request-all', onClick: this.getMore },
            '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
          ),
          this.state.dialogueList.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: item.id + '-' + index, className: 'text_animation_box' },
              item.direction != "reply" && isShare && _react2.default.createElement('div', { className: 'select_share_btn img', onClick: _this3.selectThisDialog.bind(_this3, index), style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/' + (_this3.isInShareDialogList.bind(_this3, item)() ? 'audio-share-selected' : 'audio-share-select') + '.png)' } }),
              item.direction != "reply" && !isShare && _react2.default.createElement('div', { className: 'select_share_btn' }),
              _react2.default.createElement(_TextAnimation2.default, { data: item, againSend: _this3.againSend, toBoxBottom: _this3.toBoxBottom, startShare: _this3.startShare.bind(_this3, index), longPressStart: _this3.longPressStart.bind(_this3, index), longPressEnd: _this3.longPressEnd.bind(_this3, index), isLongPress: longPressInx == index ? isLongPress : false, highLight: isShare && _this3.isInShareDialogList.bind(_this3, item)() })
            );
          })
        ),
        !isShare && _react2.default.createElement(
          'div',
          { className: 'footer' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: this.goBack },
              '< ',
              '\u5386\u53F2\u5BF9\u8BDD'
            ),
            isNeedIntegral == true && _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'nav', onClick: this.toPage },
                '\u7B7E\u5230\u9001\u79EF\u5206'
              ),
              _react2.default.createElement(
                'div',
                { className: 'nav', onClick: this.toPage2 },
                '\u6211\u7684\u79EF\u5206'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: modalList.length >= 1 ? this.showSelectModalBox : null },
              '\u6A21\u578B\u9009\u62E9',
              isShowModalConfig && _react2.default.createElement(
                'div',
                { className: 'tool_config' },
                modalList.map(function (item) {
                  return item.require_vip_permission == '1' ? _react2.default.createElement(
                    'div',
                    { className: modalId == item.type ? 'config_item config_item_vip config_vip_select' : 'config_item_vip config_item', key: item.type,
                      onClick: _this3.selectModal, 'data-type': item.type, 'data-isvip': item.require_vip_permission },
                    _react2.default.createElement('img', { className: 'little-img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog3.png' }),
                    GPTModal[item.type]
                  ) : _react2.default.createElement(
                    'div',
                    { className: modalId == item.type ? 'config_item config_item_select' : 'config_item', key: item.type,
                      onClick: _this3.selectModal, 'data-type': item.type, 'data-isvip': item.require_vip_permission },
                    GPTModal[item.type]
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row say_box jc_sa' },
            _react2.default.createElement('textarea', { ref: this.textareaRef, className: 'ipt_box', placeholder: !userVipCardInfo && isNeedIntegral ? "来说点什么吧（消耗2积分）" : "来说点什么吧", onInput: this.bindTextInput, onChange: this.bindTextInput, value: content }),
            content !== '' && isSub && _react2.default.createElement(
              'div',
              { className: isSub ? 'sub_btn' : 'sub_btn un_sub', onClick: isSub ? this.askQuestions : null },
              '\u53D1\u9001'
            ),
            content == '' && _react2.default.createElement('div', { className: 'microphone_icon', onClick: this.startSpeech })
          )
        ),
        isRecording && _react2.default.createElement(
          'div',
          { className: 'record_box' },
          _react2.default.createElement(
            'div',
            { className: 'record_text_box' },
            _react2.default.createElement(
              'p',
              { className: 'timeText' },
              '00:',
              seconds
            ),
            resultText.length > 0 && _react2.default.createElement(
              'p',
              { className: 'record_text' },
              resultText
            ),
            seconds <= 5 && _react2.default.createElement(
              'p',
              { className: 'timeText' },
              _react2.default.createElement(
                'span',
                { style: { color: '#F24545' } },
                seconds,
                '\u201D'
              ),
              '\u540E\u505C\u6B62\u5F55\u97F3'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row jc_sa record_btn_box' },
            _react2.default.createElement('div', { className: 'record_btn img', style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-close.png)' }, onClick: function onClick(e) {
                return _this3.cancelRecord(e);
              } }),
            _react2.default.createElement(
              'div',
              { className: 'record_animation', onClick: this.closeAndSend },
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar1' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar2' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar3' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar4' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar5' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar6' })
            ),
            _react2.default.createElement('div', { className: 'record_btn img', onClick: function onClick(e) {
                return _this3.cancelRecord(e, true);
              }, style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-type.png)' } })
          )
        ),
        isShare && _react2.default.createElement(
          'div',
          { className: 'row jc_sa share_btm_box' },
          _react2.default.createElement('div', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancelShare }),
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.shareWechat },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u5FAE\u4FE1\u597D\u53CB'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.shareCircle },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u670B\u53CB\u5708'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.createShareImg },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-pic.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u751F\u6210\u56FE\u7247'
            )
          ),
          this.state.shareDialogList.length == 0 && _react2.default.createElement('div', { className: 'prevent_share' })
        ),
        isShowAllRole == true && _react2.default.createElement(
          'div',
          { className: 'drawer_box' },
          _react2.default.createElement('div', { className: 'mask', onClick: this.hiddenAllRolePage }),
          _react2.default.createElement(
            'div',
            { className: 'drawer' },
            _react2.default.createElement(
              'div',
              { className: 'drawer_head' },
              _react2.default.createElement(
                'div',
                { className: 'd_title_line' },
                _react2.default.createElement(
                  'div',
                  { className: 'd_title' },
                  '\u89D2\u8272\u5207\u6362'
                ),
                _react2.default.createElement(_icon2.default, { type: 'cross-circle-o', size: 'xs', onClick: this.hiddenAllRolePage })
              ),
              _react2.default.createElement(
                'div',
                { className: 'ipt_box' },
                _react2.default.createElement('label', { className: 'ico-moon icon-search' }),
                _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u89D2\u8272\u540D\u79F0', value: searchValue, onInput: this.bindSearInput, onChange: this.bindSearInput, onClick: this.debubbling })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'drawer_main' },
              roleListAll.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'role_item ' + (switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id ? 'active' : ''),
                    'data-id': item.role_id || item.id, key: index, onClick: _this3.selectSwitchItem },
                  item.url && _react2.default.createElement('img', { src: item.url }),
                  _react2.default.createElement(
                    'div',
                    null,
                    item.role_name || item.title
                  ),
                  _react2.default.createElement('input', { type: 'radio', checked: switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id, onChange: function onChange() {
                      return false;
                    } })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'drawer_footer' },
              _react2.default.createElement(
                'div',
                { className: 'drawer_btn', onClick: this.confirmSelect },
                '\u786E\u5B9A'
              )
            )
          )
        ),
        maskShow && _react2.default.createElement(
          'div',
          { id: 'mask', className: 'mask', onClick: this.closeMask },
          _react2.default.createElement(
            'div',
            { id: 'shareImg', className: 'share_content_box' },
            _react2.default.createElement(
              'div',
              { className: 'share_content_head' },
              _react2.default.createElement('img', { className: 'share_logo', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-logo.png', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_content' },
              this.state.shareDialogList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: item.id + '-' + index, className: 'text_animation_box' },
                  _react2.default.createElement(_TextAnimation2.default, { data: item, againSend: _this3.againSend, toBoxBottom: _this3.toBoxBottom, startShare: _this3.startShare, highLight: false, maskShow: maskShow })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_content_foot' },
              _react2.default.createElement('img', { className: 'share_tips', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-tips.png', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: 'code_box' },
                _react2.default.createElement('img', { className: 'share_qrcode', src: qrCodeImg, alt: '' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row jc_sa share_btm_box' },
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', onClick: this.shareWechat },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u5FAE\u4FE1\u597D\u53CB'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', onClick: this.shareCircle },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u670B\u53CB\u5708'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', style: shareImgUrl ? {} : { opacity: 0.5 }, onClick: this.saveShareImg },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-download.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u4FDD\u5B58\u56FE\u7247'
              )
            )
          )
        )
      );
    }
  }]);
  return GptIndex;
}(_OfficialPage3.default);

exports.default = GptIndex;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(630);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 630 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(632), __esModule: true };

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(166);
__webpack_require__(77);
__webpack_require__(91);
__webpack_require__(633);
__webpack_require__(641);
__webpack_require__(642);
module.exports = __webpack_require__(24).Promise;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(74);
var global = __webpack_require__(34);
var ctx = __webpack_require__(62);
var classof = __webpack_require__(130);
var $export = __webpack_require__(46);
var isObject = __webpack_require__(53);
var aFunction = __webpack_require__(85);
var anInstance = __webpack_require__(634);
var forOf = __webpack_require__(635);
var speciesConstructor = __webpack_require__(197);
var task = __webpack_require__(198).set;
var microtask = __webpack_require__(637)();
var newPromiseCapabilityModule = __webpack_require__(142);
var perform = __webpack_require__(199);
var userAgent = __webpack_require__(638);
var promiseResolve = __webpack_require__(200);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(35)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(639)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(90)($Promise, PROMISE);
__webpack_require__(640)(PROMISE);
Wrapper = __webpack_require__(24)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(186)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(62);
var call = __webpack_require__(184);
var isArrayIter = __webpack_require__(185);
var anObject = __webpack_require__(48);
var toLength = __webpack_require__(111);
var getIterFn = __webpack_require__(129);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 636 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var macrotask = __webpack_require__(198).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(73)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(34);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(56);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(34);
var core = __webpack_require__(24);
var dP = __webpack_require__(50);
var DESCRIPTORS = __webpack_require__(51);
var SPECIES = __webpack_require__(35)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(46);
var core = __webpack_require__(24);
var global = __webpack_require__(34);
var speciesConstructor = __webpack_require__(197);
var promiseResolve = __webpack_require__(200);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(46);
var newPromiseCapability = __webpack_require__(142);
var perform = __webpack_require__(199);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Item = undefined;

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _getDataAttr = __webpack_require__(201);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _tabs = __webpack_require__(144);

var _tabs2 = _interopRequireDefault(_tabs);

var _Tab = __webpack_require__(653);

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Item = exports.Item = function (_React$Component) {
    (0, _inherits3['default'])(Item, _React$Component);

    function Item() {
        (0, _classCallCheck3['default'])(this, Item);
        return (0, _possibleConstructorReturn3['default'])(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Item, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                style = _props.style;

            return React.createElement(
                'div',
                { className: prefixCls, style: style },
                this.props.children
            );
        }
    }]);
    return Item;
}(React.Component);

Item.defaultProps = {
    prefixCls: 'am-tab-bar-item',
    title: ''
};

var AntTabBar = function (_React$Component2) {
    (0, _inherits3['default'])(AntTabBar, _React$Component2);

    function AntTabBar() {
        (0, _classCallCheck3['default'])(this, AntTabBar);

        var _this2 = (0, _possibleConstructorReturn3['default'])(this, (AntTabBar.__proto__ || Object.getPrototypeOf(AntTabBar)).apply(this, arguments));

        _this2.getTabs = function () {
            var tabs = [];
            React.Children.forEach(_this2.props.children, function (c) {
                if (c) {
                    tabs.push((0, _extends3['default'])({}, c.props));
                }
            });
            return tabs;
        };
        _this2.renderTabBar = function () {
            var _this2$props = _this2.props,
                barTintColor = _this2$props.barTintColor,
                prefixCls = _this2$props.prefixCls,
                tintColor = _this2$props.tintColor,
                unselectedTintColor = _this2$props.unselectedTintColor,
                hidden = _this2$props.hidden,
                tabBarPosition = _this2$props.tabBarPosition;

            var tabsData = _this2.getTabs();
            var content = Array.isArray(tabsData) ? tabsData.map(function (cProps, index) {
                return React.createElement(_Tab2['default'], { key: index, prefixCls: _this2.props.prefixCls + '-tab', badge: cProps.badge, dot: cProps.dot, selected: cProps.selected, icon: cProps.icon, selectedIcon: cProps.selectedIcon, title: cProps.title, tintColor: tintColor, unselectedTintColor: unselectedTintColor, dataAttrs: (0, _getDataAttr2['default'])(cProps), onClick: function onClick() {
                        return cProps.onPress && cProps.onPress();
                    } });
            }) : null;
            var cls = prefixCls + '-bar';
            if (hidden) {
                cls += ' ' + prefixCls + '-bar-hidden-' + tabBarPosition;
            }
            return React.createElement(
                'div',
                { className: cls, style: { backgroundColor: barTintColor } },
                content
            );
        };
        return _this2;
    }

    (0, _createClass3['default'])(AntTabBar, [{
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                children = _props2.children,
                animated = _props2.animated,
                swipeable = _props2.swipeable,
                noRenderContent = _props2.noRenderContent,
                prerenderingSiblingsNumber = _props2.prerenderingSiblingsNumber,
                tabBarPosition = _props2.tabBarPosition;

            var tabs = this.getTabs();
            var activeIndex = 0;
            if (Array.isArray(tabs)) {
                tabs.forEach(function (tab, index) {
                    if (tab.selected) {
                        activeIndex = index;
                    }
                });
            }
            return React.createElement(
                'div',
                { className: prefixCls },
                React.createElement(
                    _tabs2['default'],
                    { tabs: tabs, renderTabBar: this.renderTabBar, tabBarPosition: tabBarPosition, page: activeIndex < 0 ? undefined : activeIndex, animated: animated, swipeable: swipeable, noRenderContent: noRenderContent, prerenderingSiblingsNumber: prerenderingSiblingsNumber },
                    children
                )
            );
        }
    }]);
    return AntTabBar;
}(React.Component);

AntTabBar.defaultProps = {
    prefixCls: 'am-tab-bar',
    barTintColor: 'white',
    tintColor: '#108ee9',
    hidden: false,
    unselectedTintColor: '#888',
    placeholder: '正在加载',
    animated: false,
    swipeable: false,
    prerenderingSiblingsNumber: 1,
    tabBarPosition: 'bottom'
};
AntTabBar.Item = Item;
exports['default'] = AntTabBar;

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(9);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__(3);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/get.js
var get = __webpack_require__(202);
var get_default = /*#__PURE__*/__webpack_require__.n(get);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__(0);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(1);
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__(2);
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: external "React"
var external__React_ = __webpack_require__(5);
var external__React__default = /*#__PURE__*/__webpack_require__.n(external__React_);

// CONCATENATED MODULE: ./node_modules/rc-gesture/es/config.js
/* tslint:disable:no-bitwise */
// http://hammerjs.github.io/api/#directions
var DIRECTION_NONE = 1; // 00001
var DIRECTION_LEFT = 2; // 00010
var DIRECTION_RIGHT = 4; // 00100
var DIRECTION_UP = 8; // 01000
var DIRECTION_DOWN = 16; // 10000
var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT; // 00110 6
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN; // 11000 24
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL; // 11110  30
// http://hammerjs.github.io/recognizer-press/
var PRESS = {
    time: 251
};
// http://hammerjs.github.io/recognizer-swipe/
var SWIPE = {
    threshold: 10,
    velocity: 0.3
};
// CONCATENATED MODULE: ./node_modules/rc-gesture/es/util.js
/* tslint:disable:no-bitwise */

function _calcTriangleDistance(x, y) {
    return Math.sqrt(x * x + y * y);
}
function _calcAngle(x, y) {
    var radian = Math.atan2(y, x);
    return 180 / (Math.PI / radian);
}
function now() {
    return Date.now();
}
function calcMutliFingerStatus(touches) {
    if (touches.length < 2) {
        return;
    }
    var _touches$ = touches[0],
        x1 = _touches$.x,
        y1 = _touches$.y;
    var _touches$2 = touches[1],
        x2 = _touches$2.x,
        y2 = _touches$2.y;

    var deltaX = x2 - x1;
    var deltaY = y2 - y1;
    return {
        x: deltaX,
        y: deltaY,
        z: _calcTriangleDistance(deltaX, deltaY),
        angle: _calcAngle(deltaX, deltaY)
    };
}
function calcMoveStatus(startTouches, touches, time) {
    var _startTouches$ = startTouches[0],
        x1 = _startTouches$.x,
        y1 = _startTouches$.y;
    var _touches$3 = touches[0],
        x2 = _touches$3.x,
        y2 = _touches$3.y;

    var deltaX = x2 - x1;
    var deltaY = y2 - y1;
    var deltaZ = _calcTriangleDistance(deltaX, deltaY);
    return {
        x: deltaX,
        y: deltaY,
        z: deltaZ,
        time: time,
        velocity: deltaZ / time,
        angle: _calcAngle(deltaX, deltaY)
    };
}
function calcRotation(startMutliFingerStatus, mutliFingerStatus) {
    var startAngle = startMutliFingerStatus.angle;
    var angle = mutliFingerStatus.angle;

    return angle - startAngle;
}
function getEventName(prefix, status) {
    return prefix + status[0].toUpperCase() + status.slice(1);
}
function shouldTriggerSwipe(delta, velocity) {
    return Math.abs(delta) >= SWIPE.threshold && Math.abs(velocity) > SWIPE.velocity;
}
function shouldTriggerDirection(direction, directionSetting) {
    if (directionSetting & direction) {
        return true;
    }
    return false;
}
/**
 * @private
 * get the direction between two points
 * Note: will change next version
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }
    if (Math.abs(x) >= Math.abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}
/**
 * @private
 * get the direction between tow points when touch moving
 * Note: will change next version
 * @param {Object} point1 coordinate point, include x & y attributes
 * @param {Object} point2 coordinate point, include x & y attributes
 * @return {Number} direction
 */
function getMovingDirection(point1, point2) {
    var x1 = point1.x,
        y1 = point1.y;
    var x2 = point2.x,
        y2 = point2.y;

    var deltaX = x2 - x1;
    var deltaY = y2 - y1;
    if (deltaX === 0 && deltaY === 0) {
        return DIRECTION_NONE;
    }
    if (Math.abs(deltaX) >= Math.abs(deltaY)) {
        return deltaX < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return deltaY < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}
function getDirectionEventName(direction) {
    var name = void 0;
    switch (direction) {
        case DIRECTION_NONE:
            break;
        case DIRECTION_LEFT:
            name = 'left';
            break;
        case DIRECTION_RIGHT:
            name = 'right';
            break;
        case DIRECTION_UP:
            name = 'up';
            break;
        case DIRECTION_DOWN:
            name = 'down';
            break;
        default:
    }
    return name;
}
// CONCATENATED MODULE: ./node_modules/rc-gesture/es/index.js





/* tslint:disable:no-console */



;
;
var directionMap = {
    all: DIRECTION_ALL,
    vertical: DIRECTION_VERTICAL,
    horizontal: DIRECTION_HORIZONTAL
};

var es_Gesture = function (_Component) {
    inherits_default()(Gesture, _Component);

    function Gesture(props) {
        classCallCheck_default()(this, Gesture);

        var _this = possibleConstructorReturn_default()(this, (Gesture.__proto__ || Object.getPrototypeOf(Gesture)).call(this, props));

        _this.state = {};
        _this.triggerEvent = function (name) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            var cb = _this.props[name];
            if (typeof cb === 'function') {
                // always give user gesture object as first params first
                cb.apply(undefined, [_this.getGestureState()].concat(args));
            }
        };
        _this.triggerCombineEvent = function (mainEventName, eventStatus) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
            }

            _this.triggerEvent.apply(_this, [mainEventName].concat(args));
            _this.triggerSubEvent.apply(_this, [mainEventName, eventStatus].concat(args));
        };
        _this.triggerSubEvent = function (mainEventName, eventStatus) {
            for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                args[_key3 - 2] = arguments[_key3];
            }

            if (eventStatus) {
                var subEventName = getEventName(mainEventName, eventStatus);
                _this.triggerEvent.apply(_this, [subEventName].concat(args));
            }
        };
        _this.triggerPinchEvent = function (mainEventName, eventStatus) {
            for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
                args[_key4 - 2] = arguments[_key4];
            }

            var scale = _this.gesture.scale;

            if (eventStatus === 'move' && typeof scale === 'number') {
                if (scale > 1) {
                    _this.triggerEvent('onPinchOut');
                }
                if (scale < 1) {
                    _this.triggerEvent('onPinchIn');
                }
            }
            _this.triggerCombineEvent.apply(_this, [mainEventName, eventStatus].concat(args));
        };
        _this.initPressTimer = function () {
            _this.cleanPressTimer();
            _this.pressTimer = setTimeout(function () {
                _this.setGestureState({
                    press: true
                });
                _this.triggerEvent('onPress');
            }, PRESS.time);
        };
        _this.cleanPressTimer = function () {
            /* tslint:disable:no-unused-expression */
            _this.pressTimer && clearTimeout(_this.pressTimer);
        };
        _this.setGestureState = function (params) {
            if (!_this.gesture) {
                _this.gesture = {};
            }
            // cache the previous touches
            if (_this.gesture.touches) {
                _this.gesture.preTouches = _this.gesture.touches;
            }
            _this.gesture = extends_default()({}, _this.gesture, params);
        };
        _this.getGestureState = function () {
            if (!_this.gesture) {
                return _this.gesture;
            } else {
                // shallow copy
                return extends_default()({}, _this.gesture);
            }
        };
        _this.cleanGestureState = function () {
            delete _this.gesture;
        };
        _this.getTouches = function (e) {
            return Array.prototype.slice.call(e.touches).map(function (item) {
                return {
                    x: item.screenX,
                    y: item.screenY
                };
            });
        };
        _this.triggerUserCb = function (status, e) {
            var cbName = getEventName('onTouch', status);
            if (cbName in _this.props) {
                _this.props[cbName](e);
            }
        };
        _this._handleTouchStart = function (e) {
            _this.triggerUserCb('start', e);
            _this.event = e;
            if (e.touches.length > 1) {
                e.preventDefault();
            }
            _this.initGestureStatus(e);
            _this.initPressTimer();
            _this.checkIfMultiTouchStart();
        };
        _this.initGestureStatus = function (e) {
            _this.cleanGestureState();
            // store the gesture start state
            var startTouches = _this.getTouches(e);
            var startTime = now();
            var startMutliFingerStatus = calcMutliFingerStatus(startTouches);
            _this.setGestureState({
                startTime: startTime,
                startTouches: startTouches,
                startMutliFingerStatus: startMutliFingerStatus,
                /* copy for next time touch move cala convenient*/
                time: startTime,
                touches: startTouches,
                mutliFingerStatus: startMutliFingerStatus,
                srcEvent: _this.event
            });
        };
        _this.checkIfMultiTouchStart = function () {
            var _this$props = _this.props,
                enablePinch = _this$props.enablePinch,
                enableRotate = _this$props.enableRotate;
            var touches = _this.gesture.touches;

            if (touches.length > 1 && (enablePinch || enableRotate)) {
                if (enablePinch) {
                    var startMutliFingerStatus = calcMutliFingerStatus(touches);
                    _this.setGestureState({
                        startMutliFingerStatus: startMutliFingerStatus,
                        /* init pinch status */
                        pinch: true,
                        scale: 1
                    });
                    _this.triggerCombineEvent('onPinch', 'start');
                }
                if (enableRotate) {
                    _this.setGestureState({
                        /* init rotate status */
                        rotate: true,
                        rotation: 0
                    });
                    _this.triggerCombineEvent('onRotate', 'start');
                }
            }
        };
        _this._handleTouchMove = function (e) {
            _this.triggerUserCb('move', e);
            _this.event = e;
            if (!_this.gesture) {
                // sometimes weird happen: touchstart -> touchmove..touchmove.. --> touchend --> touchmove --> touchend
                // so we need to skip the unnormal event cycle after touchend
                return;
            }
            // not a long press
            _this.cleanPressTimer();
            _this.updateGestureStatus(e);
            _this.checkIfSingleTouchMove();
            _this.checkIfMultiTouchMove();
        };
        _this.checkIfMultiTouchMove = function () {
            var _this$gesture = _this.gesture,
                pinch = _this$gesture.pinch,
                rotate = _this$gesture.rotate,
                touches = _this$gesture.touches,
                startMutliFingerStatus = _this$gesture.startMutliFingerStatus,
                mutliFingerStatus = _this$gesture.mutliFingerStatus;

            if (!pinch && !rotate) {
                return;
            }
            if (touches.length < 2) {
                _this.setGestureState({
                    pinch: false,
                    rotate: false
                });
                // Todo: 2 finger -> 1 finger, wait to test this situation
                pinch && _this.triggerCombineEvent('onPinch', 'cancel');
                rotate && _this.triggerCombineEvent('onRotate', 'cancel');
                return;
            }
            if (pinch) {
                var scale = mutliFingerStatus.z / startMutliFingerStatus.z;
                _this.setGestureState({
                    scale: scale
                });
                _this.triggerPinchEvent('onPinch', 'move');
            }
            if (rotate) {
                var rotation = calcRotation(startMutliFingerStatus, mutliFingerStatus);
                _this.setGestureState({
                    rotation: rotation
                });
                _this.triggerCombineEvent('onRotate', 'move');
            }
        };
        _this.allowGesture = function () {
            return shouldTriggerDirection(_this.gesture.direction, _this.directionSetting);
        };
        _this.checkIfSingleTouchMove = function () {
            var _this$gesture2 = _this.gesture,
                pan = _this$gesture2.pan,
                touches = _this$gesture2.touches,
                moveStatus = _this$gesture2.moveStatus,
                preTouches = _this$gesture2.preTouches,
                _this$gesture2$availa = _this$gesture2.availablePan,
                availablePan = _this$gesture2$availa === undefined ? true : _this$gesture2$availa;

            if (touches.length > 1) {
                _this.setGestureState({
                    pan: false
                });
                // Todo: 1 finger -> 2 finger, wait to test this situation
                pan && _this.triggerCombineEvent('onPan', 'cancel');
                return;
            }
            // add avilablePan condition to fix the case in scrolling, which will cause unavailable pan move.
            if (moveStatus && availablePan) {
                var direction = getMovingDirection(preTouches[0], touches[0]);
                _this.setGestureState({ direction: direction });
                var eventName = getDirectionEventName(direction);
                if (!_this.allowGesture()) {
                    // if the first move is unavailable, then judge all of remaining touch movings are also invalid.
                    if (!pan) {
                        _this.setGestureState({ availablePan: false });
                    }
                    return;
                }
                if (!pan) {
                    _this.triggerCombineEvent('onPan', 'start');
                    _this.setGestureState({
                        pan: true,
                        availablePan: true
                    });
                } else {
                    _this.triggerCombineEvent('onPan', eventName);
                    _this.triggerSubEvent('onPan', 'move');
                }
            }
        };
        _this.checkIfMultiTouchEnd = function (status) {
            var _this$gesture3 = _this.gesture,
                pinch = _this$gesture3.pinch,
                rotate = _this$gesture3.rotate;

            if (pinch) {
                _this.triggerCombineEvent('onPinch', status);
            }
            if (rotate) {
                _this.triggerCombineEvent('onRotate', status);
            }
        };
        _this.updateGestureStatus = function (e) {
            var time = now();
            _this.setGestureState({
                time: time
            });
            if (!e.touches || !e.touches.length) {
                return;
            }
            var _this$gesture4 = _this.gesture,
                startTime = _this$gesture4.startTime,
                startTouches = _this$gesture4.startTouches,
                pinch = _this$gesture4.pinch,
                rotate = _this$gesture4.rotate;

            var touches = _this.getTouches(e);
            var moveStatus = calcMoveStatus(startTouches, touches, time - startTime);
            var mutliFingerStatus = void 0;
            if (pinch || rotate) {
                mutliFingerStatus = calcMutliFingerStatus(touches);
            }
            _this.setGestureState({
                /* update status snapshot */
                touches: touches,
                mutliFingerStatus: mutliFingerStatus,
                /* update duration status */
                moveStatus: moveStatus
            });
        };
        _this._handleTouchEnd = function (e) {
            _this.triggerUserCb('end', e);
            _this.event = e;
            if (!_this.gesture) {
                return;
            }
            _this.cleanPressTimer();
            _this.updateGestureStatus(e);
            _this.doSingleTouchEnd('end');
            _this.checkIfMultiTouchEnd('end');
        };
        _this._handleTouchCancel = function (e) {
            _this.triggerUserCb('cancel', e);
            _this.event = e;
            // Todo: wait to test cancel case
            if (!_this.gesture) {
                return;
            }
            _this.cleanPressTimer();
            _this.updateGestureStatus(e);
            _this.doSingleTouchEnd('cancel');
            _this.checkIfMultiTouchEnd('cancel');
        };
        _this.triggerAllowEvent = function (type, status) {
            if (_this.allowGesture()) {
                _this.triggerCombineEvent(type, status);
            } else {
                _this.triggerSubEvent(type, status);
            }
        };
        _this.doSingleTouchEnd = function (status) {
            var _this$gesture5 = _this.gesture,
                moveStatus = _this$gesture5.moveStatus,
                pinch = _this$gesture5.pinch,
                rotate = _this$gesture5.rotate,
                press = _this$gesture5.press,
                pan = _this$gesture5.pan,
                direction = _this$gesture5.direction;

            if (pinch || rotate) {
                return;
            }
            if (moveStatus) {
                var z = moveStatus.z,
                    velocity = moveStatus.velocity;

                var swipe = shouldTriggerSwipe(z, velocity);
                _this.setGestureState({
                    swipe: swipe
                });
                if (pan) {
                    // pan need end, it's a process
                    // sometimes, start with pan left, but end with pan right....
                    _this.triggerAllowEvent('onPan', status);
                }
                if (swipe) {
                    var directionEvName = getDirectionEventName(direction);
                    // swipe just need a direction, it's a endpoint
                    _this.triggerAllowEvent('onSwipe', directionEvName);
                    return;
                }
            }
            if (press) {
                _this.triggerEvent('onPressUp');
                return;
            }
            _this.triggerEvent('onTap');
        };
        _this.getTouchAction = function () {
            var _this$props2 = _this.props,
                enablePinch = _this$props2.enablePinch,
                enableRotate = _this$props2.enableRotate;
            var directionSetting = _this.directionSetting;

            if (enablePinch || enableRotate || directionSetting === DIRECTION_ALL) {
                return 'pan-x pan-y';
            }
            if (directionSetting === DIRECTION_VERTICAL) {
                return 'pan-x';
            }
            if (directionSetting === DIRECTION_HORIZONTAL) {
                return 'pan-y';
            }
            return 'auto';
        };
        _this.directionSetting = directionMap[props.direction];
        return _this;
    }

    createClass_default()(Gesture, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.cleanPressTimer();
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;

            var child = external__React__default.a.Children.only(children);
            var touchAction = this.getTouchAction();
            var events = {
                onTouchStart: this._handleTouchStart,
                onTouchMove: this._handleTouchMove,
                onTouchCancel: this._handleTouchCancel,
                onTouchEnd: this._handleTouchEnd
            };
            return external__React__default.a.cloneElement(child, extends_default()({}, events, { style: extends_default()({ touchAction: touchAction }, child.props.style || {}) }));
        }
    }]);

    return Gesture;
}(external__React_["Component"]);

/* harmony default export */ var es = (es_Gesture);

es_Gesture.defaultProps = {
    enableRotate: false,
    enablePinch: false,
    direction: 'all'
};
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/util/index.js
function getTransformPropValue(v) {
    return {
        transform: v,
        WebkitTransform: v,
        MozTransform: v
    };
}
function getPxStyle(value) {
    var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
    var vertical = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    value = vertical ? '0px, ' + value + unit + ', 0px' : '' + value + unit + ', 0px, 0px';
    return 'translate3d(' + value + ')';
}
function setPxStyle(el, value) {
    var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'px';
    var vertical = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var useLeft = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (useLeft) {
        if (vertical) {
            el.style.top = '' + value + unit;
        } else {
            el.style.left = '' + value + unit;
        }
    } else {
        setTransform(el.style, getPxStyle(value, unit, vertical));
    }
}
function setTransform(style, v) {
    style.transform = v;
    style.webkitTransform = v;
    style.mozTransform = v;
}
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/TabPane.js





var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};


var TabPane_TabPane = function (_React$PureComponent) {
    inherits_default()(TabPane, _React$PureComponent);

    function TabPane() {
        classCallCheck_default()(this, TabPane);

        var _this = possibleConstructorReturn_default()(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));

        _this.offsetX = 0;
        _this.offsetY = 0;
        _this.setLayout = function (div) {
            _this.layout = div;
        };
        return _this;
    }

    createClass_default()(TabPane, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.active !== nextProps.active) {
                if (nextProps.active) {
                    this.offsetX = 0;
                    this.offsetY = 0;
                } else {
                    this.offsetX = this.layout.scrollLeft;
                    this.offsetY = this.layout.scrollTop;
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _a = this.props,
                active = _a.active,
                fixX = _a.fixX,
                fixY = _a.fixY,
                props = __rest(_a, ["active", "fixX", "fixY"]);
            var style = extends_default()({}, fixX && this.offsetX ? getTransformPropValue(getPxStyle(-this.offsetX, 'px', false)) : {}, fixY && this.offsetY ? getTransformPropValue(getPxStyle(-this.offsetY, 'px', true)) : {});
            return external__React__default.a.createElement(
                'div',
                extends_default()({}, props, { style: style, ref: this.setLayout }),
                props.children
            );
        }
    }]);

    return TabPane;
}(external__React__default.a.PureComponent);
TabPane_TabPane.defaultProps = {
    fixX: true,
    fixY: true
};
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/DefaultTabBar.js





var DefaultTabBar___rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};



var DefaultTabBar_StateType = function StateType() {
    classCallCheck_default()(this, StateType);

    this.transform = '';
    this.isMoving = false;
    this.showPrev = false;
    this.showNext = false;
};
var DefaultTabBar_DefaultTabBar = function (_React$PureComponent) {
    inherits_default()(DefaultTabBar, _React$PureComponent);

    function DefaultTabBar(props) {
        classCallCheck_default()(this, DefaultTabBar);

        var _this = possibleConstructorReturn_default()(this, (DefaultTabBar.__proto__ || Object.getPrototypeOf(DefaultTabBar)).call(this, props));

        _this.onPan = function () {
            var lastOffset = 0;
            var finalOffset = 0;
            var getLastOffset = function getLastOffset() {
                var isVertical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.isTabBarVertical();

                var offset = +('' + lastOffset).replace('%', '');
                if (('' + lastOffset).indexOf('%') >= 0) {
                    offset /= 100;
                    offset *= isVertical ? _this.layout.clientHeight : _this.layout.clientWidth;
                }
                return offset;
            };
            return {
                onPanStart: function onPanStart() {
                    _this.setState({ isMoving: true });
                },
                onPanMove: function onPanMove(status) {
                    if (!status.moveStatus || !_this.layout) return;
                    var isVertical = _this.isTabBarVertical();
                    var offset = getLastOffset() + (isVertical ? status.moveStatus.y : status.moveStatus.x);
                    var canScrollOffset = isVertical ? -_this.layout.scrollHeight + _this.layout.clientHeight : -_this.layout.scrollWidth + _this.layout.clientWidth;
                    offset = Math.min(offset, 0);
                    offset = Math.max(offset, canScrollOffset);
                    setPxStyle(_this.layout, offset, 'px', isVertical);
                    finalOffset = offset;
                    _this.setState({
                        showPrev: -offset > 0,
                        showNext: offset > canScrollOffset
                    });
                },
                onPanEnd: function onPanEnd() {
                    var isVertical = _this.isTabBarVertical();
                    lastOffset = finalOffset;
                    _this.setState({
                        isMoving: false,
                        transform: getPxStyle(finalOffset, 'px', isVertical)
                    });
                },
                setCurrentOffset: function setCurrentOffset(offset) {
                    return lastOffset = offset;
                }
            };
        }();
        _this.getTransformByIndex = function (props) {
            var activeTab = props.activeTab,
                tabs = props.tabs,
                _props$page = props.page,
                page = _props$page === undefined ? 0 : _props$page;

            var isVertical = _this.isTabBarVertical();
            var size = _this.getTabSize(page, tabs.length);
            var center = page / 2;
            var pos = Math.min(activeTab, tabs.length - center - .5);
            var skipSize = Math.min(-(pos - center + .5) * size, 0);
            _this.onPan.setCurrentOffset(skipSize + '%');
            return {
                transform: getPxStyle(skipSize, '%', isVertical),
                showPrev: activeTab > center - .5 && tabs.length > page,
                showNext: activeTab < tabs.length - center - .5 && tabs.length > page
            };
        };
        _this.onPress = function (index) {
            var _this$props = _this.props,
                goToTab = _this$props.goToTab,
                onTabClick = _this$props.onTabClick,
                tabs = _this$props.tabs;

            onTabClick && onTabClick(tabs[index], index);
            goToTab && goToTab(index);
        };
        _this.isTabBarVertical = function () {
            var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.tabBarPosition;
            return position === 'left' || position === 'right';
        };
        _this.renderTab = function (t, i, size, isTabBarVertical) {
            var _this$props2 = _this.props,
                prefixCls = _this$props2.prefixCls,
                renderTab = _this$props2.renderTab,
                activeTab = _this$props2.activeTab,
                tabBarTextStyle = _this$props2.tabBarTextStyle,
                tabBarActiveTextColor = _this$props2.tabBarActiveTextColor,
                tabBarInactiveTextColor = _this$props2.tabBarInactiveTextColor,
                instanceId = _this$props2.instanceId;

            var textStyle = extends_default()({}, tabBarTextStyle);
            var cls = prefixCls + '-tab';
            var ariaSelected = false;
            if (activeTab === i) {
                cls += ' ' + cls + '-active';
                ariaSelected = true;
                if (tabBarActiveTextColor) {
                    textStyle.color = tabBarActiveTextColor;
                }
            } else if (tabBarInactiveTextColor) {
                textStyle.color = tabBarInactiveTextColor;
            }
            return external__React__default.a.createElement(
                'div',
                { key: 't_' + i, style: extends_default()({}, textStyle, isTabBarVertical ? { height: size + '%' } : { width: size + '%' }), id: 'm-tabs-' + instanceId + '-' + i, role: 'tab', 'aria-selected': ariaSelected, className: cls, onClick: function onClick() {
                        return _this.onPress(i);
                    } },
                renderTab ? renderTab(t) : t.title
            );
        };
        _this.setContentLayout = function (div) {
            _this.layout = div;
        };
        _this.getTabSize = function (page, tabLength) {
            return 100 / Math.min(page, tabLength);
        };
        _this.state = extends_default()({}, new DefaultTabBar_StateType(), _this.getTransformByIndex(props));
        return _this;
    }

    createClass_default()(DefaultTabBar, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.activeTab !== nextProps.activeTab || this.props.tabs !== nextProps.tabs || this.props.tabs.length !== nextProps.tabs.length) {
                this.setState(extends_default()({}, this.getTransformByIndex(nextProps)));
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                animated = _props.animated,
                _props$tabs = _props.tabs,
                tabs = _props$tabs === undefined ? [] : _props$tabs,
                _props$page2 = _props.page,
                page = _props$page2 === undefined ? 0 : _props$page2,
                _props$activeTab = _props.activeTab,
                activeTab = _props$activeTab === undefined ? 0 : _props$activeTab,
                tabBarBackgroundColor = _props.tabBarBackgroundColor,
                tabBarUnderlineStyle = _props.tabBarUnderlineStyle,
                tabBarPosition = _props.tabBarPosition,
                renderUnderline = _props.renderUnderline;
            var _state = this.state,
                isMoving = _state.isMoving,
                transform = _state.transform,
                showNext = _state.showNext,
                showPrev = _state.showPrev;

            var isTabBarVertical = this.isTabBarVertical();
            var needScroll = tabs.length > page;
            var size = this.getTabSize(page, tabs.length);
            var Tabs = tabs.map(function (t, i) {
                return _this2.renderTab(t, i, size, isTabBarVertical);
            });
            var cls = prefixCls;
            if (animated && !isMoving) {
                cls += ' ' + prefixCls + '-animated';
            }
            var style = {
                backgroundColor: tabBarBackgroundColor || ''
            };
            var transformStyle = needScroll ? extends_default()({}, getTransformPropValue(transform)) : {};
            var _a = this.onPan,
                setCurrentOffset = _a.setCurrentOffset,
                onPan = DefaultTabBar___rest(_a, ["setCurrentOffset"]);
            var underlineProps = {
                style: extends_default()({}, isTabBarVertical ? { height: size + '%' } : { width: size + '%' }, isTabBarVertical ? { top: size * activeTab + '%' } : { left: size * activeTab + '%' }, tabBarUnderlineStyle),
                className: prefixCls + '-underline'
            };
            return external__React__default.a.createElement(
                'div',
                { className: cls + ' ' + prefixCls + '-' + tabBarPosition, style: style },
                showPrev && external__React__default.a.createElement('div', { className: prefixCls + '-prevpage' }),
                external__React__default.a.createElement(
                    es,
                    extends_default()({}, onPan, { direction: isTabBarVertical ? 'vertical' : 'horizontal' }),
                    external__React__default.a.createElement(
                        'div',
                        { role: 'tablist', className: prefixCls + '-content', style: transformStyle, ref: this.setContentLayout },
                        Tabs,
                        renderUnderline ? renderUnderline(underlineProps) : external__React__default.a.createElement('div', underlineProps)
                    )
                ),
                showNext && external__React__default.a.createElement('div', { className: prefixCls + '-nextpage' })
            );
        }
    }]);

    return DefaultTabBar;
}(external__React__default.a.PureComponent);
DefaultTabBar_DefaultTabBar.defaultProps = {
    prefixCls: 'rmc-tabs-tab-bar',
    animated: true,
    tabs: [],
    goToTab: function goToTab() {},
    activeTab: 0,
    page: 5,
    tabBarUnderlineStyle: {},
    tabBarBackgroundColor: '#fff',
    tabBarActiveTextColor: '',
    tabBarInactiveTextColor: '',
    tabBarTextStyle: {}
};
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/Tabs.base.js






var Tabs_base_StateType = function StateType() {
    classCallCheck_default()(this, StateType);
};
var Tabs_base_instanceId = 0;
var Tabs_base_Tabs = function (_React$PureComponent) {
    inherits_default()(Tabs, _React$PureComponent);

    function Tabs(props) {
        classCallCheck_default()(this, Tabs);

        var _this = possibleConstructorReturn_default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

        _this.tabCache = {};
        _this.isTabVertical = function () {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props.tabDirection;
            return direction === 'vertical';
        };
        _this.shouldRenderTab = function (idx) {
            var _this$props$prerender = _this.props.prerenderingSiblingsNumber,
                prerenderingSiblingsNumber = _this$props$prerender === undefined ? 0 : _this$props$prerender;
            var _this$state$currentTa = _this.state.currentTab,
                currentTab = _this$state$currentTa === undefined ? 0 : _this$state$currentTa;

            return currentTab - prerenderingSiblingsNumber <= idx && idx <= currentTab + prerenderingSiblingsNumber;
        };
        _this.getOffsetIndex = function (current, width) {
            var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props.distanceToChangeTab || 0;

            var ratio = Math.abs(current / width);
            var direction = ratio > _this.state.currentTab ? '<' : '>';
            var index = Math.floor(ratio);
            switch (direction) {
                case '<':
                    return ratio - index > threshold ? index + 1 : index;
                case '>':
                    return 1 - ratio + index > threshold ? index : index + 1;
                default:
                    return Math.round(ratio);
            }
        };
        _this.getSubElements = function () {
            var children = _this.props.children;

            var subElements = {};
            return function () {
                var defaultPrefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '$i$-';
                var allPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$ALL$';

                if (Array.isArray(children)) {
                    children.forEach(function (child, index) {
                        if (child.key) {
                            subElements[child.key] = child;
                        }
                        subElements['' + defaultPrefix + index] = child;
                    });
                } else if (children) {
                    subElements[allPrefix] = children;
                }
                return subElements;
            };
        };
        _this.state = {
            currentTab: _this.getTabIndex(props)
        };
        _this.nextCurrentTab = _this.state.currentTab;
        _this.instanceId = Tabs_base_instanceId++;
        return _this;
    }

    createClass_default()(Tabs, [{
        key: 'getTabIndex',
        value: function getTabIndex(props) {
            var page = props.page,
                initialPage = props.initialPage,
                tabs = props.tabs;

            var param = (page !== undefined ? page : initialPage) || 0;
            var index = 0;
            if (typeof param === 'string') {
                tabs.forEach(function (t, i) {
                    if (t.key === param) {
                        index = i;
                    }
                });
            } else {
                index = param || 0;
            }
            return index < 0 ? 0 : index;
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.page !== nextProps.page && nextProps.page !== undefined) {
                this.goToTab(this.getTabIndex(nextProps), true, {}, nextProps);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.prevCurrentTab = this.state.currentTab;
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.prevCurrentTab = this.state.currentTab;
        }
    }, {
        key: 'goToTab',
        value: function goToTab(index) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var newState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props;

            if (!force && this.nextCurrentTab === index) {
                return false;
            }
            this.nextCurrentTab = index;
            var tabs = props.tabs,
                onChange = props.onChange;

            if (index >= 0 && index < tabs.length) {
                if (!force) {
                    onChange && onChange(tabs[index], index);
                    if (props.page !== undefined) {
                        return false;
                    }
                }
                this.setState(extends_default()({ currentTab: index }, newState));
            }
            return true;
        }
    }, {
        key: 'tabClickGoToTab',
        value: function tabClickGoToTab(index) {
            this.goToTab(index);
        }
    }, {
        key: 'getTabBarBaseProps',
        value: function getTabBarBaseProps() {
            var currentTab = this.state.currentTab;
            var _props = this.props,
                animated = _props.animated,
                onTabClick = _props.onTabClick,
                tabBarActiveTextColor = _props.tabBarActiveTextColor,
                tabBarBackgroundColor = _props.tabBarBackgroundColor,
                tabBarInactiveTextColor = _props.tabBarInactiveTextColor,
                tabBarPosition = _props.tabBarPosition,
                tabBarTextStyle = _props.tabBarTextStyle,
                tabBarUnderlineStyle = _props.tabBarUnderlineStyle,
                tabs = _props.tabs;

            return {
                activeTab: currentTab,
                animated: !!animated,
                goToTab: this.tabClickGoToTab.bind(this),
                onTabClick: onTabClick,
                tabBarActiveTextColor: tabBarActiveTextColor,
                tabBarBackgroundColor: tabBarBackgroundColor,
                tabBarInactiveTextColor: tabBarInactiveTextColor,
                tabBarPosition: tabBarPosition,
                tabBarTextStyle: tabBarTextStyle,
                tabBarUnderlineStyle: tabBarUnderlineStyle,
                tabs: tabs,
                instanceId: this.instanceId
            };
        }
    }, {
        key: 'renderTabBar',
        value: function renderTabBar(tabBarProps, DefaultTabBar) {
            var renderTabBar = this.props.renderTabBar;

            if (renderTabBar === false) {
                return null;
            } else if (renderTabBar) {
                // return React.cloneElement(this.props.renderTabBar(props), props);
                return renderTabBar(tabBarProps);
            } else {
                return external__React__default.a.createElement(DefaultTabBar, tabBarProps);
            }
        }
    }, {
        key: 'getSubElement',
        value: function getSubElement(tab, index, subElements) {
            var defaultPrefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '$i$-';
            var allPrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '$ALL$';

            var key = tab.key || '' + defaultPrefix + index;
            var elements = subElements(defaultPrefix, allPrefix);
            var component = elements[key] || elements[allPrefix];
            if (component instanceof Function) {
                component = component(tab, index);
            }
            return component || null;
        }
    }]);

    return Tabs;
}(external__React__default.a.PureComponent);
Tabs_base_Tabs.defaultProps = {
    tabBarPosition: 'top',
    initialPage: 0,
    swipeable: true,
    animated: true,
    prerenderingSiblingsNumber: 1,
    tabs: [],
    destroyInactiveTab: false,
    usePaged: true,
    tabDirection: 'horizontal',
    distanceToChangeTab: .3
};
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/Tabs.js












var getPanDirection = function getPanDirection(direction) {
    switch (direction) {
        case 2:
        case 4:
            return 'horizontal';
        case 8:
        case 16:
            return 'vertical';
        default:
            return 'none';
    }
};
var Tabs_StateType = function (_BaseStateType) {
    inherits_default()(StateType, _BaseStateType);

    function StateType() {
        classCallCheck_default()(this, StateType);

        var _this = possibleConstructorReturn_default()(this, (StateType.__proto__ || Object.getPrototypeOf(StateType)).apply(this, arguments));

        _this.contentPos = '';
        _this.isMoving = false;
        return _this;
    }

    return StateType;
}(Tabs_base_StateType);
var Tabs_Tabs = function (_Component) {
    inherits_default()(Tabs, _Component);

    function Tabs(props) {
        classCallCheck_default()(this, Tabs);

        var _this2 = possibleConstructorReturn_default()(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

        _this2.onPan = function () {
            var lastOffset = 0;
            var finalOffset = 0;
            var panDirection = void 0;
            var getLastOffset = function getLastOffset() {
                var isVertical = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.isTabVertical();

                var offset = +('' + lastOffset).replace('%', '');
                if (('' + lastOffset).indexOf('%') >= 0) {
                    offset /= 100;
                    offset *= isVertical ? _this2.layout.clientHeight : _this2.layout.clientWidth;
                }
                return offset;
            };
            return {
                onPanStart: function onPanStart(status) {
                    if (!_this2.props.swipeable || !_this2.props.animated) return;
                    panDirection = getPanDirection(status.direction);
                    _this2.setState({
                        isMoving: true
                    });
                },
                onPanMove: function onPanMove(status) {
                    var _this2$props = _this2.props,
                        swipeable = _this2$props.swipeable,
                        animated = _this2$props.animated,
                        useLeftInsteadTransform = _this2$props.useLeftInsteadTransform;

                    if (!status.moveStatus || !_this2.layout || !swipeable || !animated) return;
                    var isVertical = _this2.isTabVertical();
                    var offset = getLastOffset();
                    if (isVertical) {
                        offset += panDirection === 'horizontal' ? 0 : status.moveStatus.y;
                    } else {
                        offset += panDirection === 'vertical' ? 0 : status.moveStatus.x;
                    }
                    var canScrollOffset = isVertical ? -_this2.layout.scrollHeight + _this2.layout.clientHeight : -_this2.layout.scrollWidth + _this2.layout.clientWidth;
                    offset = Math.min(offset, 0);
                    offset = Math.max(offset, canScrollOffset);
                    setPxStyle(_this2.layout, offset, 'px', isVertical, useLeftInsteadTransform);
                    finalOffset = offset;
                },
                onPanEnd: function onPanEnd() {
                    if (!_this2.props.swipeable || !_this2.props.animated) return;
                    lastOffset = finalOffset;
                    var isVertical = _this2.isTabVertical();
                    var offsetIndex = _this2.getOffsetIndex(finalOffset, isVertical ? _this2.layout.clientHeight : _this2.layout.clientWidth);
                    _this2.setState({
                        isMoving: false
                    });
                    if (offsetIndex === _this2.state.currentTab) {
                        if (_this2.props.usePaged) {
                            setTransform(_this2.layout.style, _this2.getContentPosByIndex(offsetIndex, _this2.isTabVertical(), _this2.props.useLeftInsteadTransform));
                        }
                    } else {
                        _this2.goToTab(offsetIndex);
                    }
                },
                setCurrentOffset: function setCurrentOffset(offset) {
                    return lastOffset = offset;
                }
            };
        }();
        _this2.onSwipe = function (status) {
            var _this2$props2 = _this2.props,
                tabBarPosition = _this2$props2.tabBarPosition,
                swipeable = _this2$props2.swipeable,
                usePaged = _this2$props2.usePaged;

            if (!swipeable || !usePaged || _this2.isTabVertical()) return;
            // DIRECTION_NONE	1
            // DIRECTION_LEFT	2
            // DIRECTION_RIGHT	4
            // DIRECTION_UP	8
            // DIRECTION_DOWN	16
            // DIRECTION_HORIZONTAL	6
            // DIRECTION_VERTICAL	24
            // DIRECTION_ALL	30
            switch (tabBarPosition) {
                case 'top':
                case 'bottom':
                    switch (status.direction) {
                        case 2:
                            if (!_this2.isTabVertical()) {
                                _this2.goToTab(_this2.prevCurrentTab + 1);
                            }
                        case 8:
                            if (_this2.isTabVertical()) {
                                _this2.goToTab(_this2.prevCurrentTab + 1);
                            }
                            break;
                        case 4:
                            if (!_this2.isTabVertical()) {
                                _this2.goToTab(_this2.prevCurrentTab - 1);
                            }
                        case 16:
                            if (_this2.isTabVertical()) {
                                _this2.goToTab(_this2.prevCurrentTab - 1);
                            }
                            break;
                    }
                    break;
            }
        };
        _this2.setContentLayout = function (div) {
            _this2.layout = div;
        };
        _this2.state = extends_default()({}, _this2.state, new Tabs_StateType(), { contentPos: _this2.getContentPosByIndex(_this2.getTabIndex(props), _this2.isTabVertical(props.tabDirection), props.useLeftInsteadTransform) });
        return _this2;
    }

    createClass_default()(Tabs, [{
        key: 'goToTab',
        value: function goToTab(index) {
            var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var usePaged = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.usePaged;
            var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props;
            var tabDirection = props.tabDirection,
                useLeftInsteadTransform = props.useLeftInsteadTransform;

            var newState = {};
            if (usePaged) {
                newState = {
                    contentPos: this.getContentPosByIndex(index, this.isTabVertical(tabDirection), useLeftInsteadTransform)
                };
            }
            return get_default()(Tabs.prototype.__proto__ || Object.getPrototypeOf(Tabs.prototype), 'goToTab', this).call(this, index, force, newState, props);
        }
    }, {
        key: 'tabClickGoToTab',
        value: function tabClickGoToTab(index) {
            this.goToTab(index, false, true);
        }
    }, {
        key: 'getContentPosByIndex',
        value: function getContentPosByIndex(index, isVertical) {
            var useLeft = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var value = -index * 100 + '%';
            this.onPan.setCurrentOffset(value);
            if (useLeft) {
                return '' + value;
            } else {
                var translate = isVertical ? '0px, ' + value : value + ', 0px';
                // fix: content overlay TabBar on iOS 10. ( 0px -> 1px )
                return 'translate3d(' + translate + ', 1px)';
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var _this3 = this;

            var getSubElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSubElements();
            var _props = this.props,
                prefixCls = _props.prefixCls,
                tabs = _props.tabs,
                animated = _props.animated,
                destroyInactiveTab = _props.destroyInactiveTab,
                useLeftInsteadTransform = _props.useLeftInsteadTransform;
            var _state = this.state,
                currentTab = _state.currentTab,
                isMoving = _state.isMoving,
                contentPos = _state.contentPos;

            var isTabVertical = this.isTabVertical();
            var contentCls = prefixCls + '-content-wrap';
            if (animated && !isMoving) {
                contentCls += ' ' + contentCls + '-animated';
            }
            var contentStyle = animated ? useLeftInsteadTransform ? extends_default()({ position: 'relative' }, this.isTabVertical() ? { top: contentPos } : { left: contentPos }) : getTransformPropValue(contentPos) : extends_default()({ position: 'relative' }, this.isTabVertical() ? { top: -currentTab * 100 + '%' } : { left: -currentTab * 100 + '%' });

            var _getTabBarBaseProps = this.getTabBarBaseProps(),
                instanceId = _getTabBarBaseProps.instanceId;

            return external__React__default.a.createElement(
                'div',
                { className: contentCls, style: contentStyle, ref: this.setContentLayout },
                tabs.map(function (tab, index) {
                    var cls = prefixCls + '-pane-wrap';
                    if (_this3.state.currentTab === index) {
                        cls += ' ' + cls + '-active';
                    } else {
                        cls += ' ' + cls + '-inactive';
                    }
                    var key = tab.key || 'tab_' + index;
                    // update tab cache
                    if (_this3.shouldRenderTab(index)) {
                        _this3.tabCache[index] = _this3.getSubElement(tab, index, getSubElements);
                    } else if (destroyInactiveTab) {
                        _this3.tabCache[index] = undefined;
                    }
                    return external__React__default.a.createElement(
                        TabPane_TabPane,
                        { key: key, className: cls, active: currentTab === index, role: 'tabpanel', 'aria-hidden': currentTab !== index, 'aria-labelledby': 'm-tabs-' + instanceId + '-' + index, fixX: isTabVertical, fixY: !isTabVertical },
                        _this3.tabCache[index]
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                prefixCls = _props2.prefixCls,
                tabBarPosition = _props2.tabBarPosition,
                tabDirection = _props2.tabDirection,
                useOnPan = _props2.useOnPan,
                noRenderContent = _props2.noRenderContent;

            var isTabVertical = this.isTabVertical(tabDirection);
            var tabBarProps = extends_default()({}, this.getTabBarBaseProps());
            var onPan = !isTabVertical && useOnPan ? this.onPan : {};
            var content = [external__React__default.a.createElement(
                'div',
                { key: 'tabBar', className: prefixCls + '-tab-bar-wrap' },
                this.renderTabBar(tabBarProps, DefaultTabBar_DefaultTabBar)
            ), !noRenderContent && external__React__default.a.createElement(
                es,
                extends_default()({ key: '$content', onSwipe: this.onSwipe }, onPan),
                this.renderContent()
            )];
            return external__React__default.a.createElement(
                'div',
                { className: prefixCls + ' ' + prefixCls + '-' + tabDirection + ' ' + prefixCls + '-' + tabBarPosition },
                tabBarPosition === 'top' || tabBarPosition === 'left' ? content : content.reverse()
            );
        }
    }]);

    return Tabs;
}(Tabs_base_Tabs);
Tabs_Tabs.DefaultTabBar = DefaultTabBar_DefaultTabBar;
Tabs_Tabs.defaultProps = extends_default()({}, Tabs_base_Tabs.defaultProps, { prefixCls: 'rmc-tabs', useOnPan: true });
// CONCATENATED MODULE: ./node_modules/rmc-tabs/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Tabs", function() { return Tabs_Tabs; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "DefaultTabBar", function() { return DefaultTabBar_DefaultTabBar; });



/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(648), __esModule: true };

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(649);
module.exports = __webpack_require__(24).Object.getPrototypeOf;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(75);
var $getPrototypeOf = __webpack_require__(164);

__webpack_require__(203)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(651), __esModule: true };

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(652);
var $Object = __webpack_require__(24).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(58);
var $getOwnPropertyDescriptor = __webpack_require__(121).f;

__webpack_require__(203)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _badge = __webpack_require__(654);

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Tab = function (_React$PureComponent) {
    (0, _inherits3['default'])(Tab, _React$PureComponent);

    function Tab() {
        (0, _classCallCheck3['default'])(this, Tab);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));

        _this.renderIcon = function () {
            var _this$props = _this.props,
                dot = _this$props.dot,
                badge = _this$props.badge,
                selected = _this$props.selected,
                selectedIcon = _this$props.selectedIcon,
                icon = _this$props.icon,
                title = _this$props.title,
                prefixCls = _this$props.prefixCls;

            var iconRes = selected ? selectedIcon : icon;
            var iconDom = React.isValidElement(iconRes) ? iconRes : React.createElement('img', { className: prefixCls + '-image', src: iconRes ? iconRes.uri : iconRes, alt: title });
            if (badge) {
                return React.createElement(
                    _badge2['default'],
                    { text: badge, className: prefixCls + '-badge tab-badge' },
                    ' ',
                    iconDom,
                    ' '
                );
            }
            if (dot) {
                return React.createElement(
                    _badge2['default'],
                    { dot: true, className: prefixCls + '-badge tab-dot' },
                    iconDom
                );
            }
            return iconDom;
        };
        _this.onClick = function () {
            var onClick = _this.props.onClick;
            if (onClick) {
                onClick();
            }
        };
        return _this;
    }

    (0, _createClass3['default'])(Tab, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                prefixCls = _props.prefixCls,
                selected = _props.selected,
                unselectedTintColor = _props.unselectedTintColor,
                tintColor = _props.tintColor;

            var iconColor = selected ? tintColor : unselectedTintColor;
            return React.createElement(
                'div',
                (0, _extends3['default'])({}, this.props.dataAttrs, { onClick: this.onClick, className: '' + prefixCls }),
                React.createElement(
                    'div',
                    { className: prefixCls + '-icon', style: { color: iconColor } },
                    this.renderIcon()
                ),
                React.createElement(
                    'p',
                    { className: prefixCls + '-title', style: { color: selected ? tintColor : unselectedTintColor } },
                    title
                )
            );
        }
    }]);
    return Tab;
}(React.PureComponent);

exports['default'] = Tab;
module.exports = exports['default'];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames3 = __webpack_require__(16);

var _classnames4 = _interopRequireDefault(_classnames3);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var Badge = function (_React$Component) {
    (0, _inherits3['default'])(Badge, _React$Component);

    function Badge() {
        (0, _classCallCheck3['default'])(this, Badge);
        return (0, _possibleConstructorReturn3['default'])(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Badge, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            // tslint:disable:prefer-const
            var _a = this.props,
                className = _a.className,
                prefixCls = _a.prefixCls,
                children = _a.children,
                text = _a.text,
                size = _a.size,
                overflowCount = _a.overflowCount,
                dot = _a.dot,
                corner = _a.corner,
                hot = _a.hot,
                restProps = __rest(_a, ["className", "prefixCls", "children", "text", "size", "overflowCount", "dot", "corner", "hot"]);
            overflowCount = overflowCount;
            text = typeof text === 'number' && text > overflowCount ? overflowCount + '+' : text;
            // dot mode don't need text
            if (dot) {
                text = '';
            }
            var scrollNumberCls = (0, _classnames4['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-dot', dot), (0, _defineProperty3['default'])(_classnames, prefixCls + '-dot-large', dot && size === 'large'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-text', !dot && !corner), (0, _defineProperty3['default'])(_classnames, prefixCls + '-corner', corner), (0, _defineProperty3['default'])(_classnames, prefixCls + '-corner-large', corner && size === 'large'), _classnames));
            var badgeCls = (0, _classnames4['default'])(prefixCls, className, (_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-not-a-wrapper', !children), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-corner-wrapper', corner), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-hot', !!hot), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-corner-wrapper-large', corner && size === 'large'), _classnames2));
            return React.createElement(
                'span',
                { className: badgeCls },
                children,
                (text || dot) &&
                // tslint:disable-next-line:jsx-no-multiline-js
                React.createElement(
                    'sup',
                    (0, _extends3['default'])({ className: scrollNumberCls }, restProps),
                    text
                )
            );
        }
    }]);
    return Badge;
}(React.Component);

exports['default'] = Badge;

Badge.defaultProps = {
    prefixCls: 'am-badge',
    size: 'small',
    overflowCount: 99,
    dot: false,
    corner: false
};
module.exports = exports['default'];

/***/ }),
/* 655 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(204));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(106), __webpack_require__(205));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(106));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(146), __webpack_require__(147));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(68), __webpack_require__(69), __webpack_require__(59), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(68), __webpack_require__(69), __webpack_require__(59), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(68), __webpack_require__(69), __webpack_require__(59), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(68), __webpack_require__(69), __webpack_require__(59), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(14), __webpack_require__(68), __webpack_require__(69), __webpack_require__(59), __webpack_require__(28));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(680);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _Dialog = __webpack_require__(84);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Entrance = function (_OfficialPage) {
  (0, _inherits3.default)(Entrance, _OfficialPage);

  function Entrance(props) {
    (0, _classCallCheck3.default)(this, Entrance);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Entrance.__proto__ || Object.getPrototypeOf(Entrance)).call(this, props));

    _this.state = {
      islogin: false,
      isHavePhone: false,
      historyList: [],
      canUseIntegral: 0,
      userVipCardInfo: null, //会员信息
      isShowHead: true,
      twiceScroll: false,
      isNeedVip: false,
      isNeedIntegral: false
    };

    _this.handleScroll = function () {
      var ele = _reactDom2.default.findDOMNode(_this.myRef.current);
      var top = ele.getBoundingClientRect().top;
      if (top <= 74) {
        _this.setState({
          isShowHead: false
        });
      }
    };

    _this.historyScroll = function (event) {
      var scrollTop = event.target.scrollTop;

      if (scrollTop > 20) {
        _this.setState({
          twiceScroll: true
        });
      }
      if (!_this.state.isShowHead && scrollTop < 18 && _this.state.twiceScroll) {
        _this.setState({
          isShowHead: true,
          twiceScroll: false
        });
      }
    };

    _this.goTop = function () {
      _this.setState({
        isShowHead: true
      });
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              userVipCardInfo: res.data.user_paid_vip_card,
              isNeedVip: Boolean(res.data.all_vip_card.length)
            });
          }
        }
      });
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          var integralLength = ('' + res.data.can_use_integral).length + ('' + res.data.total_integral).length;
          var fontSize = integralLength > 0 ? 60 - integralLength * 2 : 60;
          that.setState({
            canUseIntegral: res.data.can_use_integral,
            totalIntegral: res.data.total_integral,
            integralFontSize: fontSize
          });
        }
      });
    };

    _this.getIntegralInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          if (res.status != 0) {
            return;
          }
          that.setState({
            isNeedIntegral: Boolean(res.data.length)
          });
        }
      });
    };

    _this.getSessionList = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/SessionList',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: 1,
          page_size: 10
        },
        method: 'POST',
        success: function success(res) {
          _app.appMethod.hideLoading();
          var hisArr = res.data.map(function (item) {
            if (!item.content) {
              item.content = '暂无对话';
            }
            item.isEdit = false;
            return item;
          });
          that.setData({
            historyList: hisArr
          });
        }
      });
    };

    _this.goStart = function () {
      if (_this.state.islogin) {
        if (_this.state.isHavePhone) {
          _app.appMethod.removeStorage({ key: 'nowSessionData' });
          _app.appMethod.turnToPage('gptIndex');
        } else {
          _toast2.default.info('请补充用户信息', 1, function () {
            _app.appMethod.turnToPage('add-phone');
          });
        }
      } else {
        _app.appMethod.goLogin();
      }
    };

    _this.goHistoryDetail = function (event) {
      var id = event.currentTarget.dataset.id;
      var rid = event.currentTarget.dataset.rid;
      _app.appMethod.turnToPage('gptIndex?sid=' + id + '&rid=' + rid);
    };

    _this.goUserCenter = function () {
      _app.appMethod.turnToPage('userCenterComponentPage');
    };

    _this.debubbling = function (e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    };

    _this.edit = function (event) {
      _this.debubbling(event);
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.isEdit = true;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr
      });
    };

    _this.bindTextInput = function (event) {
      var val = event.target.value;
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.content = val;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr
      });
    };

    _this.noConf = function (event) {
      _this.debubbling(event);
      _this.getSessionList();
      // let id = event.currentTarget.dataset.id;
      // let hisArr = this.data.historyList.map(item => {
      //   if(item.id == id){
      //     item.isEdit = false;
      //   }
      //   return item;
      // })
      // this.setData({
      //   historyList: hisArr
      // })
    };

    _this.conf = function (event) {
      _this.debubbling(event);
      var that = _this;
      var id = event.currentTarget.dataset.id;
      var val = event.currentTarget.dataset.val;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/UpdateSessionTitle',
        data: {
          app_id: _app.appMethod.getAppId(),
          id: id,
          title: val
        },
        method: 'POST',
        success: function success(res) {
          if (!res.status) {
            _app.appMethod.hideLoading();
            that.getSessionList();
          }
        }
      });
    };

    _this.delete = function (event) {
      _this.debubbling(event);
      var id = event.currentTarget.dataset.id;
      var that = _this;
      _Dialog2.default.showModal({
        title: '是否确定删除对话',
        content: '删除后无法恢复，请谨慎操作',
        confirmText: '删除',
        status: 'delete',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=ChatAI/CreateSession',
            data: {
              app_id: _app.appMethod.getAppId(),
              is_deleted: 1,
              id: id
            },
            hideLoading: true,
            method: 'POST',
            success: function success(res) {
              if (res.status == 0) {
                _toast2.default.info('删除完成');
                that.getSessionList();
              } else {
                _toast2.default.info(res.data);
              }
            }
          });
        }
      });
    };

    _this.goRecharge = function () {
      _app.appMethod.turnToPage('gptrecharge');
    };

    document.title = '即速对话';
    window.addEventListener('scroll', _this.handleScroll);
    _this.myRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(Entrance, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _app.appMethod.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
      if (_app.appMethod.isLogin()) {
        this.setState({
          islogin: true
        });
        if (_app.appMethod.getUserInfo().phone) {
          this.getSessionList();
          this.getIntegralDetailData();
          this.getIntegralInfo();
          this.getVipInfo();
          this.setState({
            isHavePhone: true
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
    // 获取会员信息

    // 获取列表

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var userInfo = _app.appMethod.getUserInfo();
      var _state = this.state,
          canUseIntegral = _state.canUseIntegral,
          islogin = _state.islogin,
          historyList = _state.historyList,
          isHavePhone = _state.isHavePhone,
          userVipCardInfo = _state.userVipCardInfo,
          isShowHead = _state.isShowHead,
          isNeedVip = _state.isNeedVip,
          isNeedIntegral = _state.isNeedIntegral;

      return _react2.default.createElement(
        "div",
        { className: "historical_page" },
        !isShowHead && _react2.default.createElement(
          "div",
          { className: "top", onClick: this.goTop },
          _react2.default.createElement("img", { src: "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/top.png" })
        ),
        !isHavePhone ? _react2.default.createElement(
          "div",
          { className: "slogan" },
          _react2.default.createElement(
            "div",
            { className: "line1" },
            "\u4F60\u597D\uFF01"
          ),
          _react2.default.createElement(
            "div",
            { className: "line2" },
            "\u6B22\u8FCE\u8FDB\u5165\u5373\u901F\u5BF9\u8BDD~"
          )
        ) : isShowHead && _react2.default.createElement(
          "div",
          { className: "head" },
          _react2.default.createElement("img", { className: "headimg", onClick: this.goUserCenter, src: userInfo.cover_thumb ? userInfo.cover_thumb : 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: "" }),
          _react2.default.createElement(
            "div",
            { className: "head_con" },
            _react2.default.createElement(
              "div",
              { className: "row" },
              _react2.default.createElement(
                "div",
                null,
                userInfo.phone
              ),
              isNeedVip == true && _react2.default.createElement(
                "div",
                { className: "vipimg_box" },
                _react2.default.createElement("img", { className: "vipimg",
                  onClick: !userVipCardInfo ? this.goRecharge : null,
                  src: !userVipCardInfo ? "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/novip.png" : "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog2.png" })
              )
            ),
            _react2.default.createElement(
              "div",
              null,
              "\u79EF\u5206\uFF1A",
              canUseIntegral
            )
          ),
          (isNeedVip == true || isNeedIntegral == true) && _react2.default.createElement(
            "div",
            { className: "head_btn", onClick: this.goRecharge },
            "\u53BB\u5145\u503C"
          )
        ),
        isHavePhone && _react2.default.createElement(
          "div",
          { className: isShowHead ? "main" : "main fixed", ref: this.myRef },
          _react2.default.createElement(
            "div",
            { className: "title" },
            "\u5386\u53F2\u5BF9\u8BDD"
          ),
          _react2.default.createElement(
            "div",
            { className: isShowHead ? "historical" : "historical histor_box", onScroll: this.historyScroll },
            historyList.map(function (item, index) {
              return _react2.default.createElement(
                "div",
                { className: "historical_item", key: index, onClick: _this2.goHistoryDetail, "data-id": item.id, "data-rid": item.role_play_id },
                _react2.default.createElement("img", { src: "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/dialogue2.png", alt: "dialogue", className: "it_l" }),
                _react2.default.createElement(
                  "div",
                  { className: "it_r" },
                  _react2.default.createElement(
                    "div",
                    { className: "it_r_t" },
                    _react2.default.createElement(
                      "div",
                      null,
                      item.humanized_time
                    ),
                    _react2.default.createElement(
                      "div",
                      { className: "it_r_t_btn" },
                      _react2.default.createElement(
                        "div",
                        { className: "btn_img", onClick: _this2.edit, "data-id": item.id },
                        _react2.default.createElement("img", { src: "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/edit.png", alt: "edit" })
                      ),
                      _react2.default.createElement(
                        "div",
                        { className: "btn_img", onClick: _this2.delete, "data-id": item.id },
                        _react2.default.createElement("img", { src: "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/del.png", alt: "del" })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: "it_r_b" },
                    item.isEdit ? _react2.default.createElement(
                      "div",
                      { className: "row edit_line", onClick: _this2.debubbling },
                      _react2.default.createElement("input", { type: "text", onInput: _this2.bindTextInput, onChange: _this2.bindTextInput, "data-id": item.id, value: item.content }),
                      _react2.default.createElement("label", { className: "ico-moon icon-gou mar_rl8", onClick: _this2.conf, "data-id": item.id, "data-val": item.content }),
                      _react2.default.createElement("label", { className: "ico-moon icon-closes mar_rl8", onClick: _this2.noConf, "data-id": item.id })
                    ) : _react2.default.createElement(
                      "span",
                      null,
                      item.content
                    )
                  )
                )
              );
            }),
            historyList.length == 0 && _react2.default.createElement(
              "div",
              null,
              "\u6682\u65E0\u5386\u53F2\u8BB0\u5F55"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: "footer" },
          !userVipCardInfo && isHavePhone && (isNeedVip == true ? _react2.default.createElement(
            "div",
            { className: "foot_dsc" },
            "\u975E\u4F1A\u5458\u6700\u591A\u4EC5\u80FD\u521B\u5EFA\u56DB\u4E2A\u4F1A\u8BDD\uFF0C\u4F1A\u5458\u65E0\u9650\uFF0C",
            _react2.default.createElement(
              "a",
              { onClick: this.goRecharge },
              "\u53BB\u5F00\u901A"
            )
          ) : _react2.default.createElement(
            "div",
            { className: "foot_dsc" },
            "\u6700\u591A\u4EC5\u80FD\u521B\u5EFA\u56DB\u4E2A\u4F1A\u8BDD"
          )),
          _react2.default.createElement(
            "div",
            { className: "gobtn", onClick: this.goStart },
            "\u5F00\u542F\u5BF9\u8BDD"
          )
        )
      );
    }
  }]);
  return Entrance;
}(_OfficialPage3.default);

exports.default = Entrance;

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(682);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _tools = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 定时器
var AREA_CODE = {
  0: '',
  8: '60'
};
var step2timer = null;
var step3timer = null;

var Step = function (_React$Component) {
  (0, _inherits3.default)(Step, _React$Component);

  function Step(props) {
    (0, _classCallCheck3.default)(this, Step);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Step.__proto__ || Object.getPrototypeOf(Step)).call(this, props));

    _this.state = {
      // step1
      codeImg: '',
      pause: false,
      timer: null,
      scanTimeout: null,
      requestNum: 1,
      totalRequestNum: 15,
      tNum: 1,
      // step2
      areaCode: 0,
      phoneNumber: '',
      picCode: '',
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
      identifyCode: '',
      verifying: false,
      step2time: 60,
      isAgreement: false,
      // step3
      step3Time: 10
    };

    _this.componentWillUnmount = function () {
      _this.setState = function (state, callback) {
        return;
      };
      clearTimeout(_this.state.timer);
      clearTimeout(_this.state.scanTimeout);
      clearTimeout(step2timer);
      clearTimeout(step3timer);
    };

    _this.step1Init = function () {
      if (_this.props.status == 1) {
        _this.scanCodeTimeout();
        _this.getLoginQrcode();
      }
    };

    _this.scanCodeTimeout = function () {
      var that = _this;
      var _this$state = _this.state,
          scanTimeout = _this$state.scanTimeout,
          timer = _this$state.timer;

      clearTimeout(scanTimeout);
      var timeout = setTimeout(function () {
        if (timer) {
          clearTimeout(timer);
        }
        that.setState({
          pause: true
        });
        _app.appMethod.showModal({
          content: '扫码超时，请重新扫码',
          showCancel: false,
          confirmColor: '#437eff',
          confirm: function confirm() {
            that.setState({
              pause: false
            }, function () {
              that.getLoginQrcode();
            });
          }
        });
      }, 30000);
      _this.setState({
        scanTimeout: timeout
      });
    };

    _this.getLoginQrcode = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=Login/loginQrcode',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        complete: function complete(res) {
          if (res && res.status == 0) {
            that.setState({
              codeImg: res.data
            });
          } else {
            _toast2.default.fail('二维码请求失败,请检查相关配置');
          }
        }
      });
      that.setState({
        requestNum: 1
      });
      that.cometRequest();
    };

    _this.cometRequest = function () {
      var that = _this;
      var _this$state2 = _this.state,
          requestNum = _this$state2.requestNum,
          tNum = _this$state2.tNum,
          totalRequestNum = _this$state2.totalRequestNum,
          timer = _this$state2.timer,
          scanCodeTimeout = _this$state2.scanCodeTimeout,
          pause = _this$state2.pause;

      if (pause) {
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=Login/CheckLogin',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        complete: function complete(res) {
          if (res.status == 0) {
            clearTimeout(scanCodeTimeout);
            if (res.is_complete == 1) {
              //  is_complete=1 表示手机号已存在
              // 直接登录
              _app.appMethod.turnToPage('jisuSession');
            } else if (res.is_complete == 2) {
              that.handleClick(2);
            }
          } else if (res.status == 1) {
            if (requestNum < totalRequestNum) {
              var num = requestNum + 1;
              if (timer) {
                clearTimeout(timer);
              }
              var timeout = setTimeout(function () {
                that.cometRequest();
              }, 5000);
              that.setState({
                timer: timeout,
                requestNum: num
              });
            } else {
              if (tNum < 5) {
                var _num = tNum + 1;
                that.getLoginQrcode();
                that.setState({
                  tNum: _num
                });
              }
            }
          }
        },
        fail: function fail() {
          //Ajax请求超时，继续查询
          setTimeout(function () {
            that.cometRequest();
          }, 5000);
        }
      });
    };

    _this.handleChange = function (name, event) {
      _this.setState((0, _defineProperty3.default)({}, name, event.target.value));
    };

    _this.getPicCode = function () {
      _this.setState({
        picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.checkboxChange = function (event) {
      var checked = event.target.checked;
      _this.setState({
        isAgreement: checked
      });
    };

    _this.getIdentifyCode = function () {
      console.log(_this.state.verifying);
      if (_this.state.verifying) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.picCode) {
        _toast2.default.info('请输入图形验证码');
        return;
      }
      _this.setState({
        verifying: true,
        step2time: 60
      });
      var that = _this;
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/phoneCode',
        data: {
          app_id: _app.appMethod.getAppId(),
          phone: phone,
          pic_code: that.state.picCode
        },
        complete: function complete(res) {
          console.log('res', res);
          if (res.status != 0) {
            // Toast.fail(res.data);
            that.setState({
              verifying: false,
              step2time: 60
            });
            return;
          }
          step2timer = setInterval(function () {
            if (that.state.step2time === 0) {
              clearInterval(step2timer);
              that.setState({
                verifying: false,
                step2time: 60
              });
            }
            that.setState({
              step2time: --that.state.step2time
            });
          }, 1000);
        }
      });
    };

    _this.handleRegister = function () {
      var that = _this;
      if (_this.state.logining) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.identifyCode) {
        _toast2.default.info('请输入验证码');
        return;
      }
      if (!_this.state.isAgreement) {
        _toast2.default.info('请同意咫尺网络用户注册协议');
        return;
      }
      _this.setState({
        logining: true
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          app_id: _app.appMethod.getAppId(),
          phone: phone,
          code: _this.state.identifyCode
        },
        complete: function complete(res) {
          if (res.status !== 0) {
            _this.setState({
              logining: false
            });
            // Toast.fail(res.data);
            return;
          }
          _app.appMethod.setIsLogin(true);
          _app.appMethod.bindUserAccount();
          var nickname = res.nickname;
          var cover = res.cover_thumb;
          if (nickname && cover) {
            _toast2.default.info('登录成功', 1);
            that.handleClick(3);
            that.step3Init();
            // 请求用户数据存到本地
            _app.appMethod.requestUserInfo();
          }
        },
        fail: function fail() {
          _this.setState({
            logining: false
          });
          _toast2.default.fail(res.data);
        }
      });
    };

    _this.step3Init = function () {
      var that = _this;
      step3timer = setInterval(function () {
        if (that.state.step3Time === 0) {
          clearInterval(step3timer);
          _app.appMethod.turnToPage('jisuSession');
        }
        that.setState({
          time: --that.state.step3Time
        });
      }, 1000);
    };

    _this.goStart = function () {
      _app.appMethod.turnToPage('jisuSession');
    };

    _this.handleClick = function (data) {
      _this.props.handler(data);
    };

    return _this;
  }

  (0, _createClass3.default)(Step, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var sonRenderTimer = setTimeout(function () {
        //让step组件初始化滞后
        _this2.step1Init();
        clearTimeout(sonRenderTimer);
      });
    }
    // 第一步

    // 扫码超时提醒

    // 第二步
    // 处理input的值的更改

    // 更换图形验证码

    // 获取验证码

    // step3

  }, {
    key: 'render',
    value: function render() {
      var status = this.props.status;
      var _state = this.state,
          codeImg = _state.codeImg,
          step3Time = _state.step3Time,
          isAgreement = _state.isAgreement;

      if (status == 1) {
        return _react2.default.createElement(
          'div',
          { className: 'step1' },
          _react2.default.createElement(
            'div',
            { className: 'step_title' },
            '\u7B2C\u4E00\u6B65\uFF1A\u626B\u7801\u5173\u6CE8\u516C\u4F17\u53F7'
          ),
          _react2.default.createElement(
            'div',
            { className: 'step_con' },
            codeImg != '' && _react2.default.createElement('img', { src: codeImg, className: 'zc_code' })
          ),
          _react2.default.createElement('div', { className: 'step_btnbox' })
        );
      } else if (status == 2) {
        return _react2.default.createElement(
          'div',
          { className: 'step2' },
          _react2.default.createElement(
            'div',
            { className: 'step_title' },
            '\u7B2C\u4E8C\u6B65\uFF1A\u5B8C\u5584\u4FE1\u606F'
          ),
          _react2.default.createElement(
            'div',
            { className: 'step_con' },
            _react2.default.createElement(
              'div',
              { className: 'line1' },
              _react2.default.createElement('input', { type: 'radio', checked: true, readOnly: true }),
              _react2.default.createElement(
                'span',
                null,
                '\u60A8\u5DF2\u901A\u8FC7\u5FAE\u4FE1\u8D26\u53F7\u767B\u5F55\u6210\u529F\uFF0C\u8BF7\u7ED1\u5B9A\u624B\u673A\u53F7\uFF0C\u4EE5\u540E\u767B\u5F55\u66F4\u65B9\u4FBF\uFF01'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'login_phone' },
              _react2.default.createElement(
                'select',
                { value: this.state.areaCode, onChange: this.handleChange.bind(this, 'areaCode') },
                _react2.default.createElement(
                  'option',
                  { value: '0' },
                  '\u4E2D\u56FD\u5927\u9646+86'
                ),
                _react2.default.createElement(
                  'option',
                  { value: '8' },
                  'Malaysia+60'
                )
              ),
              _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNumber, onChange: this.handleChange.bind(this, 'phoneNumber') })
            ),
            _react2.default.createElement(
              'div',
              { className: 'register_GraphocVerification' },
              _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
              _react2.default.createElement('img', { className: 'pic_code', src: this.state.picCodeUrl, onClick: this.getPicCode })
            ),
            _react2.default.createElement(
              'div',
              { className: 'short_message_code' },
              _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u77ED\u4FE1\u9A8C\u8BC1\u7801', value: this.state.identifyCode, onChange: this.handleChange.bind(this, 'identifyCode') }),
              _react2.default.createElement(
                'div',
                { className: 'get_code', onClick: this.getIdentifyCode },
                this.state.verifying && this.state.step2time !== 60 ? this.state.step2time + 's' : '获取验证码'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'line2' },
              _react2.default.createElement('input', { type: 'checkbox', checked: isAgreement, onChange: this.checkboxChange }),
              _react2.default.createElement(
                'span',
                null,
                '\u540C\u610F'
              ),
              _react2.default.createElement(
                'a',
                { href: 'http://www.jisuapp.cn/index.php?r=Login/UserProtocal', target: '_blank' },
                '\u300A\u54AB\u5C3A\u7F51\u7EDC\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'step_btnbox' },
            _react2.default.createElement(
              'div',
              { className: 'step_btn', onClick: this.handleRegister },
              '\u63D0\u4EA4'
            )
          )
        );
      } else if (status == 3) {
        return _react2.default.createElement(
          'div',
          { className: 'step3' },
          _react2.default.createElement(
            'div',
            { className: 'step3_con' },
            _react2.default.createElement(
              'div',
              { className: 'column' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u6CE8\u518C\u6210\u529F!'
              ),
              _react2.default.createElement(
                'div',
                { className: 'timeline' },
                _react2.default.createElement(
                  'span',
                  { className: 'col' },
                  step3Time
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u79D2\u540E\u8FDB\u5165\u4E3B\u9875\u9762'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'step_btnbox' },
            _react2.default.createElement(
              'div',
              { className: 'step_btn', onClick: this.goStart },
              '\u7ACB\u5373\u4F53\u9A8C'
            )
          )
        );
      } else {
        return null;
      }
    }
  }]);
  return Step;
}(_react2.default.Component);

var PcRegister = function (_OfficialPage) {
  (0, _inherits3.default)(PcRegister, _OfficialPage);

  function PcRegister(props) {
    (0, _classCallCheck3.default)(this, PcRegister);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (PcRegister.__proto__ || Object.getPrototypeOf(PcRegister)).call(this, props));

    _this3.state = {
      stepStatus: 1,
      islogin: false
    };

    _this3.componentWillUnmount = function () {
      _this3.setState = function (state, callback) {
        return;
      };
    };

    _this3.logout = function () {
      _app.appMethod.showModal({
        content: '确定要退出登录?',
        confirmColor: '#437eff',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppUser/logout',
            success: function success() {
              _app.appMethod.setIsLogin(false);
              _app.appMethod.turnToPage('login-pc');
            }
          });
        },
        showCancel: function showCancel() {}
      });
    };

    _this3.goLogin = function () {
      _app.appMethod.turnToPage('login-pc');
    };

    _this3.handler = function (data) {
      _this3.setData({
        stepStatus: data
      });
      if (data == 3) {
        if (_app.appMethod.isLogin()) {
          _this3.setData({
            islogin: true
          });
        }
      }
    };

    document.title = '即速注册';
    return _this3;
  }

  (0, _createClass3.default)(PcRegister, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      if (_app.appMethod.isLogin()) {
        this.setData({
          islogin: true
        });
      }
      if (options.step && options.step == '2') {
        this.setData({
          stepStatus: options.step
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          stepStatus = _state2.stepStatus,
          islogin = _state2.islogin;


      return _react2.default.createElement(
        'div',
        { className: 'pczc_page' },
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'div',
            { className: 'head_con' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'page_t' },
                '\u5373\u901F\u5BF9\u8BDD'
              ),
              islogin == false && _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'fz_d fz_20 mar_l16' },
                  '|'
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fz_d mar_l16' },
                  '\u6B22\u8FCE\u6CE8\u518C'
                )
              )
            ),
            islogin ? _react2.default.createElement(
              'div',
              { className: 'fz_d cur_p', onClick: this.logout },
              '\u9000\u51FA\u767B\u5F55'
            ) : _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'fz_d' },
                '\u5DF2\u6709\u8D26\u53F7\uFF1F'
              ),
              _react2.default.createElement(
                'div',
                { className: 'loginbtn cur_p', onClick: this.goLogin },
                '\u767B\u5F55'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main' },
          _react2.default.createElement(
            'div',
            { className: 'main_head' },
            _react2.default.createElement(
              'div',
              { className: 'main_head_item active' },
              _react2.default.createElement(
                'div',
                { className: 'num' },
                '1'
              ),
              _react2.default.createElement(
                'span',
                null,
                '\u626B\u7801\u5173\u6CE8'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_head_item ' + (stepStatus == 2 || stepStatus == 3 ? 'active' : '') },
              _react2.default.createElement(
                'div',
                { className: 'num' },
                '2'
              ),
              _react2.default.createElement(
                'span',
                null,
                '\u5B8C\u5584\u4FE1\u606F'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main_head_item ' + (stepStatus == 3 ? 'active' : '') },
              _react2.default.createElement(
                'div',
                { className: 'num' },
                '3'
              ),
              _react2.default.createElement(
                'span',
                null,
                '\u6CE8\u518C\u6210\u529F'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main_con' },
            _react2.default.createElement(Step, { status: stepStatus, handler: this.handler })
          )
        )
      );
    }
  }]);
  return PcRegister;
}(_OfficialPage3.default);

exports.default = PcRegister;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(684);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var step2timer = null;

var PcLogin = function (_OfficialPage) {
  (0, _inherits3.default)(PcLogin, _OfficialPage);

  function PcLogin(props) {
    (0, _classCallCheck3.default)(this, PcLogin);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PcLogin.__proto__ || Object.getPrototypeOf(PcLogin)).call(this, props));

    _this.state = {
      codeImg: '',
      timer: null,
      requestNum: 1,
      totalRequestNum: 15,
      tNum: 1,
      areaCode: 0,
      phoneNumber: '',
      picCode: '',
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
      identifyCode: '',
      verifying: false,
      step2time: 60,
      isAgreement: false,
      logining: false
    };

    _this.componentWillUnmount = function () {
      _this.setState = function () {
        return;
      };
      clearTimeout(_this.state.timer);
    };

    _this.getLoginQrcode = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=Login/loginQrcode',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        complete: function complete(res) {
          if (res && res.status == 0) {
            that.setState({
              codeImg: res.data
            });
          } else {
            _toast2.default.fail('二维码请求失败,请检查相关配置');
          }
        }
      });
      that.setState({
        requestNum: 1
      });
      that.cometRequest();
    };

    _this.cometRequest = function () {
      var that = _this;
      var _this$state = _this.state,
          requestNum = _this$state.requestNum,
          tNum = _this$state.tNum,
          totalRequestNum = _this$state.totalRequestNum,
          timer = _this$state.timer;

      _app.appMethod.sendRequest({
        url: '/index.php?r=Login/CheckLogin',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        complete: function complete(res) {
          if (res.status == 0) {
            if (res.is_complete == 1) {
              //  is_complete=1 表示手机号已存在
              // 直接登录
              _app.appMethod.setIsLogin(true);
              _app.appMethod.turnToPage('jisuSession');
            } else if (res.is_complete == 2) {
              // 未登录，注册第二步
              _app.appMethod.showModal({
                content: '您还没有注册账号，请前往注册',
                confirmText: '去注册',
                showCancel: true,
                confirmColor: '#437eff',
                confirm: function confirm() {
                  _app.appMethod.turnToPage('register-pc?step=2');
                }
              });
            }
          } else if (res.status == 1) {
            if (requestNum < totalRequestNum) {
              var num = requestNum + 1;
              if (timer) {
                clearTimeout(timer);
              }
              var timeout = setTimeout(function () {
                that.cometRequest();
              }, 5000);
              that.setState({
                timer: timeout,
                requestNum: num
              });
            } else {
              if (tNum < 5) {
                var _num = tNum + 1;
                that.getLoginQrcode();
                that.setState({
                  tNum: _num
                });
              }
            }
          }
        },
        fail: function fail() {
          //Ajax请求超时，继续查询
          setTimeout(function () {
            that.cometRequest();
          }, 5000);
        }
      });
    };

    _this.handleChange = function (name, event) {
      _this.setState((0, _defineProperty3.default)({}, name, event.target.value));
    };

    _this.getPicCode = function () {
      _this.setState({
        picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.getIdentifyCode = function () {
      if (_this.state.verifying) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.picCode) {
        _toast2.default.info('请输入图形验证码');
        return;
      }
      _this.setState({
        verifying: true,
        step2time: 60
      });
      var that = _this;
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/phoneCode',
        data: {
          app_id: _app.appMethod.getAppId(),
          phone: phone,
          pic_code: that.state.picCode
        },
        complete: function complete(res) {
          if (res.status !== 0) {
            // Toast.fail(res.data);
            that.setState({
              verifying: false,
              step2time: 60
            });
            return;
          }
          step2timer = setInterval(function () {
            if (that.state.step2time === 0) {
              clearInterval(step2timer);
              that.setState({
                verifying: false,
                step2time: 60
              });
            }
            that.setState({
              step2time: --that.state.step2time
            });
          }, 1000);
        }
      });
    };

    _this.handleLogin = function () {
      if (_this.state.logining) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.identifyCode) {
        _toast2.default.info('请输入验证码');
        return;
      }
      if (!_this.state.isAgreement) {
        _toast2.default.info('请同意咫尺网络用户注册协议');
        return;
      }
      _this.setState({
        logining: true
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          app_id: _app.appMethod.getAppId(),
          phone: phone,
          code: _this.state.identifyCode
        },
        complete: function complete(res) {
          if (res.status !== 0) {
            _this.setState({
              logining: false
            });
            // Toast.fail(res.data);
            return;
          }
          _app.appMethod.setIsLogin(true);
          _app.appMethod.bindUserAccount();
          // 请求用户数据存到本地
          _app.appMethod.requestUserInfo().then(function () {
            _toast2.default.info('登录成功', 1);
            var timer = setTimeout(function () {
              if (timer) {
                clearTimeout(timer);
              }
              _app.appMethod.turnToPage('jisuSession');
            }, 1000);
          });
        },
        fail: function fail() {
          _this.setState({
            logining: false
          });
          // Toast.fail(res.data);
        }
      });
    };

    _this.checkboxChange = function (event) {
      var checked = event.target.checked;
      _this.setState({
        isAgreement: checked
      });
    };

    _this.goRegister = function () {
      _app.appMethod.turnToPage('register-pc');
    };

    document.title = '即速登录';
    return _this;
  }

  (0, _createClass3.default)(PcLogin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.isLogin()) {
        _app.appMethod.turnToPage('jisuSession');
        return;
      }
      this.getLoginQrcode();
    }
    // 处理input的值的更改

    // 更换图形验证码

    // 获取验证码

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          codeImg = _state.codeImg,
          isAgreement = _state.isAgreement;

      return _react2.default.createElement(
        'div',
        { className: 'pcdl_page' },
        _react2.default.createElement(
          'div',
          { className: 'header' },
          _react2.default.createElement(
            'div',
            { className: 'head_con' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'page_t' },
                '\u5373\u901F\u5BF9\u8BDD'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main' },
          _react2.default.createElement(
            'div',
            { className: 'main_l' },
            _react2.default.createElement(
              'div',
              { className: 'box' },
              _react2.default.createElement(
                'div',
                { className: 'main_title' },
                '\u5FAE\u4FE1\u767B\u5F55'
              ),
              _react2.default.createElement(
                'div',
                { className: 'main_con' },
                codeImg != '' && _react2.default.createElement('img', { src: codeImg, className: 'zc_code' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main_r' },
            _react2.default.createElement(
              'div',
              { className: 'box' },
              _react2.default.createElement(
                'div',
                { className: 'main_title' },
                '\u8D26\u53F7\u767B\u5F55'
              ),
              _react2.default.createElement(
                'div',
                { className: 'main_con' },
                _react2.default.createElement(
                  'div',
                  { className: 'login_phone' },
                  _react2.default.createElement(
                    'select',
                    { value: this.state.areaCode, onChange: this.handleChange.bind(this, 'areaCode') },
                    _react2.default.createElement(
                      'option',
                      { value: '0' },
                      '\u4E2D\u56FD\u5927\u9646+86'
                    ),
                    _react2.default.createElement(
                      'option',
                      { value: '8' },
                      'Malaysia+60'
                    )
                  ),
                  _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNumber, onChange: this.handleChange.bind(this, 'phoneNumber') })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'login_GraphocVerification' },
                  _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
                  _react2.default.createElement('img', { className: 'pic_code', src: this.state.picCodeUrl, onClick: this.getPicCode })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'short_message_code' },
                  _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u52A8\u6001\u5BC6\u7801', value: this.state.identifyCode, onChange: this.handleChange.bind(this, 'identifyCode') }),
                  _react2.default.createElement(
                    'div',
                    { className: 'get_code', onClick: this.getIdentifyCode },
                    this.state.verifying && this.state.step2time !== 60 ? this.state.step2time + 's' : '获取动态密码'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line1' },
                  _react2.default.createElement(
                    'span',
                    { onClick: this.goRegister },
                    '\u6CE8\u518C\u8D26\u53F7'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line2' },
                  _react2.default.createElement('input', { type: 'checkbox', checked: isAgreement, onChange: this.checkboxChange }),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u540C\u610F'
                  ),
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.jisuapp.cn/index.php?r=Login/UserProtocal', target: '_blank' },
                    '\u300A\u54AB\u5C3A\u7F51\u7EDC\u7528\u6237\u6CE8\u518C\u534F\u8BAE\u300B'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'sub_btnbox' },
                  _react2.default.createElement(
                    'div',
                    { className: 'sub_btn', onClick: this.handleLogin },
                    '\u767B\u5F55'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PcLogin;
}(_OfficialPage3.default);

exports.default = PcLogin;

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _regenerator = __webpack_require__(82);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(83);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(686);

var _http = __webpack_require__(36);

var _lrz = __webpack_require__(123);

var _lrz2 = _interopRequireDefault(_lrz);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _TextAnimationPc = __webpack_require__(687);

var _TextAnimationPc2 = _interopRequireDefault(_TextAnimationPc);

var _IntegralDetail = __webpack_require__(691);

var _IntegralDetail2 = _interopRequireDefault(_IntegralDetail);

var _OrderList = __webpack_require__(693);

var _OrderList2 = _interopRequireDefault(_OrderList);

var _VipRecharge = __webpack_require__(695);

var _VipRecharge2 = _interopRequireDefault(_VipRecharge);

var _PaySuccess = __webpack_require__(697);

var _PaySuccess2 = _interopRequireDefault(_PaySuccess);

var _IntegralRecharge = __webpack_require__(699);

var _IntegralRecharge2 = _interopRequireDefault(_IntegralRecharge);

var _RechargeCenter = __webpack_require__(701);

var _RechargeCenter2 = _interopRequireDefault(_RechargeCenter);

var _MemoryBank = __webpack_require__(703);

var _MemoryBank2 = _interopRequireDefault(_MemoryBank);

var _Dialog = __webpack_require__(84);

var _Dialog2 = _interopRequireDefault(_Dialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @Author: ht 1724552153@qq.com
 * @Date: 2024-08-05 13:56:40
 * @LastEditors: ht 1724552153@qq.com
 * @LastEditTime: 2025-07-08 09:35:56
 * @FilePath: \jisuapp_webapp\src\chatgpt-page\pc-index\PcIndex.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4',
  '2': '文心一言-4.0',
  '3': 'GPT-4omini',
  '4': '通义千问',
  '5': 'kimi',
  '6': 'GPT-4o',
  '7': '字节豆包',
  '8': '百川智能',
  '9': 'GPT-o1-preview',
  '10': 'GPT-o1-mini',
  '11': '腾讯混元',
  '12': '讯飞星火-Max',
  '13': 'Azure-OpenAI',
  '14': 'deepseek（官网）',
  '15': 'deepseek（腾讯云版本）',
  '16': 'UI TARS',
  '17': 'GPT-o3-mini',
  '18': 'GPT-o4-mini',
  '19': '通义千问3',
  '20': 'deepseek-r1'
};

var PcIndex = function (_OfficialPage) {
  (0, _inherits3.default)(PcIndex, _OfficialPage);

  function PcIndex(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, PcIndex);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PcIndex.__proto__ || Object.getPrototypeOf(PcIndex)).call(this, props));

    _this.state = {
      canUseIntegral: 0,
      userInfo: {},
      historyList: [],
      historyNum: 0,
      historyTitled: '',
      roleList: [{
        role_id: '0',
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }],
      roleListAll: [],
      selectedRoleId: '',
      selectedRoleName: '',
      selectedRoleLLM: '',
      selectedRolePrologue: '',
      sessionId: '', //会话id
      dialogueList: [],
      is_more: 0,
      current_page: 1,
      content: '', //提问内容
      isSub: false,
      userVipCardInfo: null,
      memoryDialogShow: false, // 记忆弹窗
      integralDialogShow: false, // 积分列表弹窗
      orderDialogShow: false, // 订单列表弹窗
      integralRechargeShow: false, // 积分充值弹窗
      vipRechargeShow: false, // 会员充值弹窗

      vipShow: false, // 会员开通套餐
      paySuccessShow: false,
      rechargeCenterShow: false,
      modalType: 0, // 模型
      modalName: 'GPT-3.5', // 模型名称
      modalId: '',
      modalList: [],
      isShowModalConfig: false,
      isRefreshPosition: true,
      isQuestioning: false, // 正在提问中
      isShowAllRole: false,
      searchValue: '',
      isShowAside: true,
      isNeedVip: false,
      isNeedIntegral: false,
      freeNum: 0,
      filesList: [],
      // isStorageVisible:false,//显示多选框
      // isAllStorage:false,//全选
      isShowFunList: false,
      funList: [],

      deepSwitch: false, // 深度解析开关
      is_use_cot: false // 是否显示深度解析开关
    };

    _this.debubbling = function (e) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    };

    _this.logout = function () {
      _Dialog2.default.showModal({
        title: '确定要退出登录?',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppUser/logout',
            success: function success() {
              _app.appMethod.setIsLogin(false);
              _app.appMethod.turnToPage('login-pc');
              _app.appMethod.removeStorage({ key: 'nowSessionData' });
              _app.appMethod.removeStorage({ key: 'userInfo' });
            }
          });
        }
      });
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              userVipCardInfo: res.data.user_paid_vip_card,
              isNeedVip: Boolean(res.data.all_vip_card.length)
            });
            _this.getSupportTypeSet();
          }
        }
      });
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          if (res.status != 0) {
            return;
          }
          that.setState({
            canUseIntegral: res.data.can_use_integral
          });
        }
      });
    };

    _this.getUserAskQues = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetUserAskQues',
        success: function success(res) {
          if (res.status != 0) {
            return;
          }
          that.setState({
            freeNum: Number(res.data)
          });
        }
      });
    };

    _this.getIntegralInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          if (res.status != 0) {
            return;
          }
          that.setState({
            isNeedIntegral: Boolean(res.data.length)
          });
        }
      });
    };

    _this.getRoleList = function () {
      var that = _this;
      // 初始化 
      var currentSessionId = '';
      var currentRoleId = '';
      var currentRoleName = '';
      var currentRoleLLM = '';
      that.setData({
        roleList: [{
          role_id: 0,
          role_name: '会话',
          url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
        }]
      });
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetRole',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        method: 'POST',
        success: function success(res) {
          _app.appMethod.hideLoading();
          var user_roles = res.data.user_roles || [];
          var roleList = [].concat((0, _toConsumableArray3.default)(that.data.roleList), (0, _toConsumableArray3.default)(user_roles), (0, _toConsumableArray3.default)(res.data.system_role));
          roleList.forEach(function (item) {
            if (item.id) {
              item.role_id = item.id;
            }
            if (item.title) {
              item.role_name = item.title;
            }
            if (item.is_default == '1') {
              //设置了默认对话时
              currentRoleId = item.id;
            }
          });
          that.setData({
            roleList: roleList,
            roleListAll: roleList
          });
          // 从左侧历史对话进入
          if (that.data.sessionId && that.data.selectedRoleId) {
            currentSessionId = that.data.sessionId;
            currentRoleId = that.data.selectedRoleId;
            currentRoleName = that.data.selectedRoleName;
            currentRoleLLM = that.data.selectedRoleLLM;
          } else {
            // 获取历史当前打开的历史对话页
            var getSt = _app.appMethod.getStorageSync('nowSessionData');
            if (getSt) {
              currentSessionId = getSt.sessionId;
              var session = that.data.roleList.filter(function (item) {
                return item.role_id == getSt.roleId;
              })[0];
              // console.log(session)
              currentRoleId = session.role_id;
              currentRoleName = session.role_name || session.title;
              currentRoleLLM = session.llm_type;
            }
          }
          that.setData({
            sessionId: currentSessionId,
            selectedRoleId: currentRoleId,
            selectedRoleName: currentRoleName,
            selectedRoleLLM: currentRoleLLM
          });
          that.getFunList();
          if (currentSessionId) {
            that.getSessionHistory({
              session_id: currentSessionId,
              page: that.data.current_page
            });
          }
        }
      });
    };

    _this.getPrologue = function () {
      var roleList = _this.state.roleList;
      var currentRoleId = _this.state.selectedRoleId;
      // 获取开场白
      var prologueData = roleList.filter(function (item) {
        return currentRoleId == item.id || currentRoleId == item.role_id;
      })[0];
      var prologue = prologueData.prologue || ''; //prologueData.content
      var ques = prologueData.opening_ques && (typeof prologueData.opening_ques === 'string' ? JSON.parse(prologueData.opening_ques) : prologueData.opening_ques) || [];
      var dialoguearr = _this.state.dialogueList;
      if (prologue) {
        dialoguearr.unshift({ // 将开场白插入对话
          text: prologue,
          direction: 'reply',
          id: '0000',
          isHistory: true,
          quesList: !dialoguearr.length && ques,
          // isStorageFlag:false
          // 是否显示深度解析
          showDeep: 0
        });
      }
      _this.setData({
        selectedRolePrologue: prologue,
        dialogueList: dialoguearr,
        is_use_cot: prologueData.is_use_cot == 1 ? true : false
      });
    };

    _this.getHistoryList = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/SessionList',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: -1,
          page_size: 1
        },
        method: 'POST',
        success: function success(res) {
          _app.appMethod.hideLoading();
          var hisArr = res.data.map(function (item) {
            if (!item.content) {
              item.content = '暂无对话';
            }
            item.isEdit = false;
            item.isDel = false;
            return item;
          });
          that.setData({
            historyList: hisArr,
            historyNum: res.data.length,
            historyTitled: ''
          });
        }
      });
    };

    _this.goHistoryDetail = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      var rid = event.currentTarget.dataset.rid;
      var session = that.data.roleList.filter(function (item) {
        return item.role_id == rid;
      })[0];
      var rname = session.role_name || session.title;
      _this.setData({
        selectedRoleId: rid,
        selectedRoleName: rname,
        sessionId: id,
        dialogueList: []
      });
      _app.appMethod.setStorage({
        key: 'nowSessionData',
        data: {
          sessionId: id,
          roleId: rid
        }
      });
      _this.getSessionHistory({
        session_id: id,
        page: that.data.current_page
      });
    };

    _this.edit = function (event) {
      _this.debubbling(event);
      var id = event.currentTarget.dataset.id;
      var title = void 0;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.isEdit = true;
          title = item.content;
        } else {
          item.isEdit = false;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr,
        historyTitled: title
      });
    };

    _this.bindHisInput = function (event) {
      var val = event.target.value;
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.content = val;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr
      });
    };

    _this.conf = function (event) {
      _this.debubbling(event);
      var that = _this;
      var id = event.currentTarget.dataset.id;
      var val = event.currentTarget.dataset.val;
      if (val == '') {
        _toast2.default.info('对话标题不能为空');
        that.getHistoryList();
        return;
      }
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/UpdateSessionTitle',
        data: {
          app_id: _app.appMethod.getAppId(),
          id: id,
          title: val
        },
        method: 'POST',
        complete: function complete(res) {
          if (!res.status) {
            _app.appMethod.hideLoading();
            that.getHistoryList();
          }
        }
      });
    };

    _this.noConf = function (event) {
      _this.debubbling(event);
      // this.getHistoryList();
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          if (item.content == _this.state.historyTitled) {
            item.isEdit = false;
          } else {
            item.isEdit = false;
            item.content = _this.state.historyTitled;
          }
        }
        return item;
      });
      _this.setData({
        historyList: hisArr,
        historyTitled: ''
      });
    };

    _this.preDel = function (event) {
      _this.debubbling(event);
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.isDel = true;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr
      });
    };

    _this.cancelPreDel = function (event) {
      event.stopPropagation();
      var id = event.currentTarget.dataset.id;
      var hisArr = _this.data.historyList.map(function (item) {
        if (item.id == id) {
          item.isDel = false;
        }
        return item;
      });
      _this.setData({
        historyList: hisArr
      });
    };

    _this.delect = function (event) {
      event.stopPropagation();
      var id = event.currentTarget.dataset.id;
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/CreateSession',
        data: {
          app_id: _app.appMethod.getAppId(),
          is_deleted: 1,
          id: id
        },
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          if (res.status == 0) {
            _toast2.default.info('删除完成');
            if (id == that.data.sessionId) {
              _app.appMethod.removeStorage({ key: 'nowSessionData' });
              that.setData({
                selectedRoleId: '',
                selectedRoleName: '',
                selectedRoleLLM: '',
                sessionId: '',
                dialogueList: []
              });
            }
            that.getHistoryList();
          }
        }
      });
    };

    _this.creatSession = function () {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var that = _this;
      return new Promise(function (resolve, reject) {
        var parms = {
          app_id: _app.appMethod.getAppId()
        };
        if (id || that.data.selectedRoleId) {
          parms['role_play_id'] = id || that.data.selectedRoleId;
        }
        _app.appMethod.sendRequest({
          url: '/index.php?r=ChatAI/CreateSession',
          data: parms,
          hideLoading: true,
          method: 'POST',
          complete: function complete(res) {
            if (res.status == 0) {
              _app.appMethod.setStorage({
                key: 'nowSessionData',
                data: {
                  sessionId: res.data,
                  roleId: id ? id : that.data.selectedRoleId || 0
                }
              });
              that.setData({
                sessionId: res.data,
                dialogueList: [],
                roleList: [{
                  role_id: 0,
                  role_name: '会话',
                  url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
                }]
              });
              that.getRoleList();
              that.getHistoryList();
              resolve(res.data);
            } else {
              reject();
            }
          }
        });
      });
    };

    _this.startNewSession = function () {
      var that = _this;
      if (_this.state.historyNum >= 4 && !_this.state.userVipCardInfo) {
        if (!_this.state.isNeedVip) {
          _Dialog2.default.showModal({
            title: '会话已达上限',
            confirm: function confirm() {}
          });
          return;
        }
        _Dialog2.default.showModal({
          title: '会话已达上限',
          content: '请删除重新创建或开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            that.renewVip();
          }
        });
        return;
      }
      if (!_this.state.dialogueList.length) {
        _toast2.default.info('已是最新对话');
        return;
      }
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      that.creatSession();
    };

    _this.selectActiveItem = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      if (_this.state.historyNum > 3 && !_this.state.userVipCardInfo) {
        if (!_this.state.isNeedVip) {
          _Dialog2.default.showModal({
            title: '会话已达上限',
            confirm: function confirm() {}
          });
          return;
        }
        _Dialog2.default.showModal({
          title: '会话已达上限',
          content: '请删除重新创建或开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            that.renewVip();
          }
        });
        return;
      }
      var session = that.data.roleList.filter(function (item) {
        return item.role_id == id || item.id == id;
      })[0];
      var title = session.role_name || session.title;
      _Dialog2.default.showModal({
        title: '是否切换对话角色为' + title,
        confirm: function confirm() {
          that.setData({
            selectedRoleId: session.role_id,
            selectedRoleName: title,
            selectedRoleLLM: session.llm_type,
            dialogueList: [],
            is_more: 0,
            isShowAllRole: false,
            searchValue: '',
            roleListAll: that.data.roleList
          });
          if (id == 0 || id == '0') {
            //普通会话
            _app.appMethod.removeStorage({ key: 'nowSessionData' });
            that.creatSession();
            return;
          }
          that.creatSession(id);
          that.getFunList();
        }
      });
    };

    _this.bindTextInput = function (event) {
      var textarea = document.getElementById('auto-resize-textarea');
      function autoResize() {
        textarea.style.height = 'auto'; // 重置高度
        textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px'; // 动态调整高度，不超过最大高度
      }
      // 初始调用一次以确保初始状态正确
      autoResize();
      var val = event.target.value;
      if (val) {
        _this.setData({
          isSub: true
        });
      } else {
        _this.setData({
          isSub: false
        });
      }
      _this.setData({
        'content': val
      });
    };

    _this.getSessionHistory = function (option) {
      var ismore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hideloading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new Promise(function (resovle) {
        var diaArr = _this.state.dialogueList;
        var that = _this;
        if (option.page = 1) {
          diaArr = [];
        }
        _app.appMethod.showLoading({
          title: '加载中..'
        });
        _app.appMethod.sendRequest({
          url: '/index.php?r=ChatAI/SessionChatList',
          hideLoading: hideloading,
          method: 'POST',
          data: (0, _extends3.default)({
            app_id: _app.appMethod.getAppId(),
            page_size: 20
          }, option),
          success: function success(res) {
            if (res.status == 0) {
              if (res.data.length) {
                resovle(res.data[0].id);
              }
              if (ismore) {
                // 从顶部插入
                var data = res.data.reverse();
                for (var j = data.length - 1; j >= 0; j--) {
                  // diaArr.unshift({
                  //   text: data[j].content,
                  //   direction: data[j].role == '0' ? 'ques':'reply',
                  //   id: data[j].id,
                  //   isHistory: true,
                  //   type: data[j].type,
                  //   chunks:data[j].reference.chunks
                  // })
                  var item = {
                    text: data[j].content.replace(/\\n/g, '\n'),
                    direction: data[j].role == '0' ? 'ques' : 'reply',
                    id: data[j].id,
                    isHistory: true,
                    type: data[j].type,
                    reference_url: data[j].reference_url,
                    files: res.data[j].role == '0' ? res.data[j].multi_content_struct || [] : [],
                    // 深度思考
                    showDeep: 0
                    // isStorageFlag:false
                  };
                  if (data[j].reference && data[j].reference.chunks) {
                    item.chunks = data[j].reference.chunks;
                  }
                  diaArr.unshift(item);
                }
              } else {
                for (var i = res.data.length - 1; i >= 0; i--) {
                  // diaArr.push({
                  //   text: res.data[i].content,
                  //   direction: res.data[i].role == '0' ? 'ques':'reply',
                  //   id: res.data[i].id,
                  //   isHistory: true,
                  //   type: res.data[i].type,
                  //   chunks:res.data[i].reference.chunks
                  // })
                  var _item = {
                    text: res.data[i].content.replace(/\\n/g, '\n'),
                    direction: res.data[i].role == '0' ? 'ques' : 'reply',
                    id: res.data[i].id,
                    isHistory: true,
                    type: res.data[i].type,
                    reference_url: res.data[i].reference_url,
                    files: res.data[i].role == '0' ? res.data[i].multi_content_struct || [] : [],
                    // 是否显示深度思考
                    showDeep: 0
                    // isStorageFlag:false
                  };
                  if (res.data[i].reference && res.data[i].reference.chunks) {
                    _item.chunks = res.data[i].reference.chunks;
                  }
                  diaArr.push(_item);
                }
              }
              that.setData({
                dialogueList: diaArr,
                is_more: res.is_more,
                current_page: res.current_page || 1
              });
              that.getPrologue();
              var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
              // 聊天记录聚焦最新会话 
              if (!ismore) {
                dialogEle.scrollTop = dialogEle.scrollHeight;
              }
            }
          }
        });
      });
    };

    _this.getMore = function () {
      _this.getSessionHistory({
        session_id: _this.data.sessionId,
        page: _this.data.current_page + 1
      }, true);
    };

    _this.tipsModalFn = function () {
      var _this$state = _this.state,
          isNeedVip = _this$state.isNeedVip,
          isNeedIntegral = _this$state.isNeedIntegral,
          userVipCardInfo = _this$state.userVipCardInfo,
          canUseIntegral = _this$state.canUseIntegral,
          freeNum = _this$state.freeNum;

      var dsc = '';
      var confirmText = '';

      if (isNeedVip && isNeedIntegral && !userVipCardInfo && canUseIntegral < 2) {
        dsc = '积分不足，请先购买会员或积分';
      } else if (isNeedVip && !isNeedIntegral && !userVipCardInfo && canUseIntegral < 2 && freeNum < 1) {
        dsc = '提问次数不足，去开通会员';
        confirmText = '去开通';
      } else if (!isNeedVip && isNeedIntegral && canUseIntegral < 2) {
        dsc = '积分不足，去购买积分';
        confirmText = '去购买';
      } else if (!isNeedVip && !isNeedIntegral && canUseIntegral < 2 && freeNum < 1) {
        dsc = '提问次数不足';
        confirmText = '确定';
      } else {

        return;
      }
      _Dialog2.default.showModal({
        title: dsc,
        confirmText: confirmText,
        confirm: function confirm() {
          that.renewVip();
        }
      });
    };

    _this.goQuestion = function (option) {
      var that = _this;
      var diaArr = _this.state.dialogueList;
      var question = option.question;
      var oldId = diaArr.length && Number(diaArr[diaArr.length - 1].id) || 0; // 暂存最后对话的id,没有就对话时赋值0
      _this.tipsModalFn();
      diaArr.push({
        text: that.data.content,
        direction: 'ques',
        id: new Date().getTime(), // 生成一个虚拟id
        isLoading: true,
        files: JSON.parse(option.multi_content)
      });
      that.setData({
        dialogueList: diaArr,
        content: '',
        isQuestioning: true
      });
      var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
      var scrollTimer = setTimeout(function () {
        dialogEle.scrollTop = dialogEle.scrollHeight;
        clearTimeout(scrollTimer);
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        hideModal: true,
        url: '/index.php?r=ChatAI/AskQues',
        method: 'POST',
        timeout: 60000,
        data: (0, _extends3.default)({
          app_id: _app.appMethod.getAppId(),
          role_id: _this.state.selectedRoleId
        }, _this.state.deepSwitch ? { is_use_cot: 1 } : {}, {
          scene: 3
        }, option),
        complete: function complete(res) {
          if (!res && oldId) {
            // 请求超时时，轮询获取聊天记录
            var num = 0;
            that.endQuestion();
            var getNewTimer = setInterval(function () {
              num++;
              that.getSessionHistory({
                session_id: that.data.sessionId,
                page: 1
              }, false, true).then(function (newId) {
                if (Number(newId) > oldId) {
                  clearInterval(getNewTimer);
                } else if (num >= 7) {
                  clearInterval(getNewTimer);
                  that.setData({
                    content: question,
                    isSub: true,
                    isQuestioning: false
                  });
                  _Dialog2.default.showModal({
                    title: '看来你的请求超时了',
                    content: '敬请原谅,请稍候再试。。。'
                  });
                }
              });
            }, 3000);
          } else {
            if (res.status == 0 && res.data.response && typeof res.data.response == 'string') {
              diaArr[diaArr.length - 1].isLoading = false;
              // diaArr.push({
              //   text: res.data.response,
              //   direction: 'reply',
              //   id: res.data.id,
              //   type: option.type,
              //   chunks: res.data.reference.chunks
              // })
              var item = {
                text: res.data.response.replace(/\\n/g, '\n'),
                direction: 'reply',
                id: res.data.result.id,
                type: option.type,
                // isStorageFlag:false
                // 是否显示深度思考
                showDeep: res.data.result.choices[0].message.reasoning_content !== undefined ? 1 : 0,
                showDeepContent: false,
                reasoningContent: res.data.result.choices[0].message.reasoning_content || '',
                reasoningFinsh: false
              };
              if (res.data.reference && res.data.reference.chunks) {
                item.chunks = res.data.reference.chunks;
              }
              diaArr.push(item);
              that.setData({
                dialogueList: diaArr,
                filesList: []
              });
              that.getIntegralDetailData(); //更新积分信息
            } else {
              console.log(3333);
              diaArr[diaArr.length - 1].isLoading = false;
              diaArr[diaArr.length - 1].err = true;
              _Dialog2.default.showModal({
                title: '对话异常',
                content: res.data,
                confirm: function confirm() {}
              });
              that.endQuestion();
            }
            that.setData({
              content: '',
              isSub: false,
              isQuestioning: false
            });
          }
          scrollTimer = setTimeout(function () {
            dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
            clearTimeout(scrollTimer);
          });
        }
      });
    };

    _this.askQuestions = function () {
      var _this$state2 = _this.state,
          content = _this$state2.content,
          sessionId = _this$state2.sessionId,
          isSub = _this$state2.isSub,
          isQuestioning = _this$state2.isQuestioning,
          filesList = _this$state2.filesList;

      var that = _this;
      if (!isSub || isQuestioning) {
        return;
      }
      var filesInfo = [];
      if (filesList.length) {
        content = !content ? '帮我将这些文件的内容总结一下' : content;
        filesList.forEach(function (item) {
          filesInfo.push({
            type: item.type !== 'image' ? 'corpus_file' : 'image',
            name: item.name,
            file_url: item.url,
            size: item.size,
            file_type: item.type
          });
        });
        _this.comfirmFile(filesInfo);
        _this.setData({
          content: content
        });
      }
      console.log(that.data.selectedRoleId);
      if (sessionId == '' || sessionId == 0) {
        that.creatSession().then(function (id) {
          that.goQuestion((0, _defineProperty3.default)({
            session_id: id,
            question: content,
            type: that.state.modalType,
            scene: 3,
            multi_content: JSON.stringify(filesInfo),
            role_id: that.data.selectedRoleId
          }, 'type', that.state.selectedRoleLLM || that.state.modalType));
        });
      } else {
        var _that$goQuestion2;

        that.goQuestion((_that$goQuestion2 = {
          session_id: sessionId,
          question: content,
          type: that.state.modalType,
          scene: 3,
          role_id: that.data.selectedRoleId
        }, (0, _defineProperty3.default)(_that$goQuestion2, 'type', that.state.selectedRoleLLM || that.state.modalType), (0, _defineProperty3.default)(_that$goQuestion2, 'multi_content', JSON.stringify(filesInfo)), _that$goQuestion2));
      }
    };

    _this.askQuestionsKeyEnter = function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        _this.askQuestions();
      } else if (e.key === "Enter" && e.shiftKey) {
        e.preventDefault();
        _this.setData({
          content: _this.data.content + "\n"
        });
      }
    };

    _this.cancelDialog = function (type, ispays) {
      _this.setData((0, _defineProperty3.default)({}, type + 'Show', false));
      if (ispays) {
        //支付成功弹窗
        _this.setState({
          paySuccessShow: true
        });
      }
      if (type == 'rechargeCenter') {
        _this.getVipInfo();
        _this.getIntegralDetailData();
      }
    };

    _this.clickNav = function (event) {
      var _this$setData2;

      var type = event.currentTarget.dataset.type;
      _this.setData((_this$setData2 = {}, (0, _defineProperty3.default)(_this$setData2, type + 'Show', true), (0, _defineProperty3.default)(_this$setData2, 'isShowModalConfig', false), _this$setData2));
    };

    _this.renewVip = function () {
      _this.setData({
        rechargeCenterShow: true
      });
    };

    _this.againSend = function (data, isQues) {
      var list = JSON.parse(JSON.stringify(_this.data.dialogueList));
      _this.setData({
        content: data,
        isSub: true
      });
      if (isQues) {
        delete list[0].quesList;
        _this.setData({
          dialogueList: list
        });
      } else {
        list.pop();
        _this.setData({
          dialogueList: list
        });
      }
      _this.askQuestions();
    };

    _this.showDeepChange = function (ids) {
      var newDialogueList = _this.data.dialogueList.map(function (item) {
        if (item.id === ids) {
          return (0, _extends3.default)({}, item, {
            showDeepContent: !item.showDeepContent
          });
        }
        return item;
      });
      _this.setData({
        dialogueList: newDialogueList
      });
    };

    _this.showDeepFinshed = function (id) {
      var newDialogueList = _this.data.dialogueList.map(function (item) {
        if (item.id === id) {
          return (0, _extends3.default)({}, item, {
            reasoningFinsh: true
          });
        }
        return item;
      });
      _this.setData({
        dialogueList: newDialogueList
      });
    };

    _this.handleScroll = function () {
      var dialogTop = _this.myRef.current.childNodes[_this.myRef.current.childNodes.length - 1].getBoundingClientRect().top;
      var toolTop = _this.heRef.current.getBoundingClientRect().top;
      if (dialogTop > toolTop) {
        _this.setData({
          isRefreshPosition: false
        });
      } else {
        _this.setData({
          isRefreshPosition: true
        });
      }
    };

    _this.toBoxBottom = function () {
      if (_this.data.isRefreshPosition) {
        var dialogEle = _reactDom2.default.findDOMNode(_this.myRef.current);
        var scrollTimer = setTimeout(function () {
          dialogEle.scrollTop = dialogEle.scrollHeight;
          clearTimeout(scrollTimer);
        });
      }
    };

    _this.endQuestion = function () {
      _this.setData({
        isQuestioning: false
      });
    };

    _this.getUserAiModel = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/GetUserAiModel',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              modalType: res.data,
              modalName: GPTModal[res.data],
              modalId: res.data
            });
          }
        }
      });
    };

    _this.changeAiModel = function (type) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/ChangeAiModel',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId(),
          model_type: type
        },
        success: function success(res) {
          if (res.status == 0) {
            _toast2.default.info('切换完成');
            that.getUserAiModel();
            that.setData({
              isShowModalConfig: false
            });
          }
        }
      });
    };

    _this.getSupportTypeSet = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/GetSupportTypeSet',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            var list = res.data.map(function (item) {
              if (that.state.isNeedVip) {
                return res[item];
              } else {
                // if(res[item]?.require_vip_permission != '1'){
                //   return res[item]
                // }
                if (res[item] && res[item].require_vip_permission !== '1') {
                  return res[item];
                }
              }
            }).filter(function (value) {
              return value !== undefined;
            });
            that.setData({
              modalList: list
            });
          }
        }
      });
    };

    _this.selectModal = function (event) {
      var that = _this;
      var type = event.currentTarget.dataset.type;
      var isvip = event.currentTarget.dataset.isvip;
      if (Number(isvip) && !_this.state.userVipCardInfo) {
        _this.setData({
          isShowModalConfig: false
        });
        _Dialog2.default.showModal({
          title: '请开通会员',
          confirmText: '开通会员',
          confirm: function confirm() {
            that.renewVip();
          }
        });
        return;
      }
      _this.changeAiModel(type);
    };

    _this.showSelectModalBox = function () {
      _this.setData({
        isShowModalConfig: !_this.data.isShowModalConfig
      });
    };

    _this.showAllRolePage = function () {
      _this.setData({
        isShowAllRole: true
      });
    };

    _this.hiddenAllRolePage = function () {
      _this.setData({
        isShowAllRole: false
      });
    };

    _this.showFunList = function () {
      _this.setData({
        isShowFunList: true
      });
    };

    _this.hiddenFunList = function () {
      _this.setData({
        isShowFunList: false
      });
    };

    _this.bindSearInput = function (event) {
      var val = event.target.value;
      _this.setData({
        searchValue: val
      });
    };

    _this.searchRole = function () {
      var val = _this.data.searchValue;
      var reg = new RegExp(val);
      var Arr = _this.data.roleList.filter(function (item) {
        if (val == item.role_name || val == item.title || reg.test(item.role_name) || reg.test(item.title)) {
          return item;
        }
      });
      _this.setData({
        roleListAll: Arr
      });
    };

    _this.changeAside = function () {
      _this.setData({
        isShowAside: !_this.state.isShowAside
      });
    };

    _this.getFunList = function () {
      if (!_this.data.selectedRoleId) {
        return;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/getFuncList',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: -1,
          page_size: 1,
          role_id: _this.data.selectedRoleId
        },
        method: 'POST',
        success: function success(res) {
          _this.setData({
            funList: res.data || []
          });
        }
      });
    };

    _this.useFunByAI = function (event) {
      var prompt = event.currentTarget.dataset.prompt;
      _this.setData({
        content: prompt
      });
      _this.goQuestion({
        session_id: _this.state.sessionId,
        question: prompt,
        type: _this.state.modalType
      });
      _this.setData({
        isShowFunList: false
      });
    };

    _this.iconUploadFiles = function () {
      if (_this.fileInputRef.current && _this.data.filesList.length < 10) {
        _this.fileInputRef.current.click();
      }
    };

    _this.removeFile = function (event) {
      var index = event.currentTarget.dataset.index;
      _this.data.filesList.splice(index, 1);
      _this.setData({
        filesList: _this.data.filesList
      });
    };

    _this.uploadFiles = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var files, currentFiles, maxFileSize, maxFiles, validTypes, fileDetails, i, file, type, size, fileDetail;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = e.target.files;
                currentFiles = _this.data.filesList;
                maxFileSize = 20 * 1024 * 1024; // 20MB

                maxFiles = 10;

                if (files.length) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                if (!(files.length + currentFiles.length > maxFiles)) {
                  _context2.next = 9;
                  break;
                }

                _toast2.default.info('\u6700\u591A\u53EA\u80FD\u4E0A\u4F20' + maxFiles + '\u4E2A\u6587\u4EF6\uFF01');
                return _context2.abrupt('return');

              case 9:

                // 检查每个文件的大小和类型，并返回详细信息
                validTypes = new Set(['image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'text/plain']);
                fileDetails = [];
                i = 0;

              case 12:
                if (!(i < files.length)) {
                  _context2.next = 27;
                  break;
                }

                file = files[i];

                if (!(file.size > maxFileSize)) {
                  _context2.next = 17;
                  break;
                }

                _toast2.default.info(file.name + ' \u5927\u5C0F\u8D85\u8FC720MB\uFF0C\u65E0\u6CD5\u4E0A\u4F20\u3002');
                return _context2.abrupt('continue', 24);

              case 17:
                if (validTypes.has(file.type)) {
                  _context2.next = 20;
                  break;
                }

                _toast2.default.info(file.name + ' \u7C7B\u578B\u4E0D\u652F\u6301\uFF0C\u65E0\u6CD5\u4E0A\u4F20\u3002');
                return _context2.abrupt('continue', 24);

              case 20:
                type = _this.getFileType(file.type);
                size = _this.getFileSize(file.size);
                fileDetail = {
                  name: file.name,
                  type: type,
                  size: size,
                  url: '',
                  status: 1
                };


                fileDetails.push(fileDetail);

              case 24:
                i++;
                _context2.next = 12;
                break;

              case 27:

                _this.setData({
                  filesList: currentFiles.concat(fileDetails)
                });

                _context2.next = 30;
                return Promise.all(fileDetails.map(function () {
                  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fileDetail, index) {
                    var file, result;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            file = files[index];
                            _context.prev = 1;

                            if (!(fileDetail.type !== 'image')) {
                              _context.next = 6;
                              break;
                            }

                            (0, _http.ajax)({
                              url: '/index.php?r=ChatAI/UploadFile',
                              data: {
                                name: file
                              },
                              success: function success(res) {
                                if (res.status === 0) {
                                  fileDetail.url = res.data;
                                  fileDetail.status = 2;
                                } else {
                                  fileDetail.url = '';
                                  fileDetail.status = 3;
                                }
                                // if(fileDetail.status == 2){
                                //   this.comfirmFile(fileDetail)
                                // }
                                currentFiles.push(fileDetail);
                                _this.setData({
                                  filesList: currentFiles
                                });
                              }
                            });
                            _context.next = 10;
                            break;

                          case 6:
                            _context.next = 8;
                            return (0, _lrz2.default)(file);

                          case 8:
                            result = _context.sent;

                            (0, _http.ajax)({
                              url: '/index.php?r=AppData/uploadImg',
                              data: {
                                img_data: result.base64,
                                org: 1
                              },
                              success: function success(res) {
                                if (res.status === 0) {
                                  fileDetail.url = res.data;
                                  fileDetail.status = 2;
                                } else {
                                  fileDetail.url = '';
                                  fileDetail.status = 3;
                                }
                                // if(fileDetail.status == 2){
                                //   this.comfirmFile(fileDetail)
                                // }
                                currentFiles.push(fileDetail);
                                _this.setData({
                                  filesList: currentFiles
                                });
                              }
                            });

                          case 10:
                            _context.next = 18;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](1);

                            fileDetail.url = '';
                            fileDetail.status = 3;
                            currentFiles.push(fileDetail);
                            _this.setData({
                              filesList: currentFiles
                            });

                          case 18:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2, [[1, 12]]);
                  }));

                  return function (_x5, _x6) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x4) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.comfirmFile = function (fileobj) {
      var filesListJson = JSON.stringify(fileobj);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/Upload2User',
        data: {
          app_id: _app.appMethod.getAppId(),
          session_key: '',
          multi_files: filesListJson,
          role_id: -1
        },
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          // if(res.status == 0){
          //   Toast.success('文件上传成功');
          // }else{
          //   Toast.fail('文件上传失败');
          // }
        }
      });
    };

    _this.useComfirmFile = function (e) {
      _this.setData({
        memoryDialogShow: false
      });
      var currentFiles = _this.data.filesList;
      if (currentFiles.length > 9) {
        _toast2.default.info('最多只能添加十个文件图片');
        return;
      }
      var fileDetail = {
        name: e.file_name,
        type: e.file_type,
        size: e.file_size,
        url: e.file_url,
        status: 2
      };
      var fileDetails = [];
      fileDetails.push(fileDetail);
      _this.setData({
        filesList: currentFiles.concat(fileDetails)
      });
      console.log(_this.state.filesList);
    };

    _this.getFileType = function (mimeType) {
      var typeMap = {
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
        'application/pdf': 'pdf',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
        'text/plain': 'txt',
        'application/vnd.ms-excel': 'excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
        'image/jpeg': 'image',
        'image/png': 'image'
      };

      return typeMap[mimeType] || mimeType;
    };

    _this.getFileSize = function (sizeInBytes) {
      if (sizeInBytes < 1024) {
        return sizeInBytes + ' B';
      } else if (sizeInBytes < 1024 * 1024) {
        return (sizeInBytes / 1024).toFixed(2) + ' KB';
      } else {
        return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
      }
    };

    _this.deepSwitchChange = function (e) {
      _this.setData({
        deepSwitch: e
      });
    };

    document.title = '即速对话';
    _this.myRef = _react2.default.createRef();
    _this.heRef = _react2.default.createRef();
    _this.fileInputRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(PcIndex, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _app.appMethod.globalData.homepageRouter = 'jisuSession'; //将首页路径设置为gpt入口页
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.turnToPage('login-pc');
        return;
      }
      this.setData({
        userInfo: _app.appMethod.getUserInfo()
      });
      this.getIntegralDetailData();
      this.getIntegralInfo();
      this.getUserAskQues();
      this.getRoleList();
      this.getHistoryList();
      this.getVipInfo();
      this.getUserAiModel();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState = function () {
        return;
      };
    }
    // 获取会员信息

    // 获取积分信息

    // 获取角色

    //获取开场白 

    // 获取历史对话列表

    // 创建会话

    // 开启新对话

    // 选中角色

    // 获取会话聊天记录

    // 点击加载更多

    // 

    // 提问

    // 侧边导航

    // 充值

    // 重新发送

    // 展示 深度解析下拉

    // 深度解析完成

    //聚焦优化

    // 聊天记录聚焦最新会话

    // 获取所有配置模型
    // getGetChatConfig = () => {
    //   let that = this;
    //   app.sendRequest({
    //     hideLoading: true,
    //     url: '/index.php?r=pc/ChatAI/GetChatConfig',
    //     method: 'POST',
    //     data: {
    //       app_id: app.getAppId(),
    //       type: -1
    //     },
    //     success: function(res) {
    //       that.setData({
    //         modalList: res.data,
    //         modalName: GPTModal[res.data[0].type],
    //         modalType: res.data[0].type
    //       })
    //     }
    //   })
    // }
    // 获取模型选择

    // 切换模型

    // 获取可用的配置模型


    // 获取功能列表


    // 文件确定上传

    // 开启长期记忆多选选择
    // setStorageData = ()=>{
    //   this.setState({
    //     isStorageVisible:true
    //   })
    // }

    // 关闭长期记忆多选选择
    // closeStorage = ()=>{
    //   this.setState({
    //     isStorageVisible:false
    //   })
    //   this.resetStorage()
    // }

    // 全选按钮
    // checkAllboxChange = event => {
    //   let checked = event.target.checked;
    //   this.setState({
    //     isAllStorage: checked
    //   },()=>{
    //     const { dialogueList,isAllStorage } = this.state
    //     const newDialogueList = dialogueList.map(item => ({
    //         ...item,
    //         isStorageFlag: isAllStorage
    //     }));
    //     this.setState({
    //       dialogueList:newDialogueList
    //     })
    //   })
    // }

    // 单选按钮
    // checkboxChange = (ids,flag)=>{
    //   const { dialogueList } = this.state
    //   const newDialogueList = dialogueList.map(item => {
    //       if(item.id == ids) {
    //         return { ...item, isStorageFlag: flag };
    //       }
    //       return item; 
    //   });
    //   const isAllStorage = newDialogueList.every(item => item.isStorageFlag === true);
    //   this.setState({
    //     dialogueList:newDialogueList,
    //     isAllStorage: isAllStorage
    //   })
    // }

    // 添加记忆
    // addStorage = ()=>{
    //   const { dialogueList } = this.state
    //   const newDialogueList = dialogueList.filter(item => item.isStorageFlag === true);
    //   console.log(newDialogueList);
    //   if(newDialogueList.length == 0) {
    //     Toast.info('请先选择对话内容添加到长期记忆');
    //     return
    //   }
    //   this.resetStorage()

    // }

    // 清空选择的对话内容
    // resetStorage = ()=>{
    //   const { dialogueList } = this.state
    //   const newDialogueList = dialogueList.map(item => ({
    //       ...item,
    //       isStorageFlag: false
    //   }));
    //   this.setState({
    //     dialogueList:newDialogueList,
    //     isAllStorage:false
    //   })
    // }

    // 深度解析

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          canUseIntegral = _state.canUseIntegral,
          userInfo = _state.userInfo,
          historyList = _state.historyList,
          roleList = _state.roleList,
          roleListAll = _state.roleListAll,
          selectedRoleId = _state.selectedRoleId,
          selectedRoleName = _state.selectedRoleName,
          selectedRoleLLM = _state.selectedRoleLLM,
          sessionId = _state.sessionId,
          userVipCardInfo = _state.userVipCardInfo,
          modalName = _state.modalName,
          modalId = _state.modalId,
          modalList = _state.modalList,
          isShowModalConfig = _state.isShowModalConfig,
          is_more = _state.is_more,
          dialogueList = _state.dialogueList,
          content = _state.content,
          searchValue = _state.searchValue,
          isSub = _state.isSub,
          memoryDialogShow = _state.memoryDialogShow,
          integralDialogShow = _state.integralDialogShow,
          orderDialogShow = _state.orderDialogShow,
          rechargeCenterShow = _state.rechargeCenterShow,
          vipRechargeShow = _state.vipRechargeShow,
          paySuccessShow = _state.paySuccessShow,
          integralRechargeShow = _state.integralRechargeShow,
          isQuestioning = _state.isQuestioning,
          isShowAllRole = _state.isShowAllRole,
          isShowAside = _state.isShowAside,
          isNeedVip = _state.isNeedVip,
          isNeedIntegral = _state.isNeedIntegral,
          filesList = _state.filesList,
          isShowFunList = _state.isShowFunList,
          funList = _state.funList,
          deepSwitch = _state.deepSwitch,
          is_use_cot = _state.is_use_cot;

      return _react2.default.createElement(
        'div',
        { className: 'pcgpt_page' },
        isShowAside == true ? _react2.default.createElement(
          'div',
          { className: 'aside' },
          _react2.default.createElement(
            'div',
            { className: 'head_l' },
            _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/jisulog2.png' })
          ),
          _react2.default.createElement('div', { className: 'parting_line' }),
          _react2.default.createElement(
            'div',
            { className: 'ais_con' },
            _react2.default.createElement(
              'div',
              { className: 'history_t' },
              '\u5386\u53F2\u5BF9\u8BDD'
            ),
            _react2.default.createElement(
              'div',
              { className: 'history_list' },
              historyList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'history_item ' + (item.isDel ? 'predel ' : '') + (sessionId == item.id ? 'active' : ''), key: index, onClick: _this3.goHistoryDetail, 'data-id': item.id, 'data-rid': item.role_play_id },
                  !item.isEdit == true && _react2.default.createElement(
                    'div',
                    { className: 'history_item_t' },
                    _react2.default.createElement('img', { className: 'diaimg', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/dialogue2.png' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'line1' },
                      item.role_name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'history_item_con' },
                    item.isEdit ? _react2.default.createElement(
                      'div',
                      { className: 'edit_line' },
                      _react2.default.createElement('input', { type: 'text', onInput: _this3.bindHisInput, onChange: _this3.bindHisInput, onClick: _this3.debubbling, 'data-id': item.id, value: item.content }),
                      _react2.default.createElement('label', { className: 'pcgpt_label ico-moon icon-gpt-gou', onClick: _this3.conf, 'data-id': item.id, 'data-val': item.content }),
                      _react2.default.createElement('label', { className: 'pcgpt_label ico-moon icon-gpt-cha mar_l8', onClick: _this3.noConf, 'data-id': item.id })
                    ) : _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'line2' },
                        _react2.default.createElement(
                          'span',
                          null,
                          item.content
                        ),
                        item.isDel == false && _react2.default.createElement(
                          'span',
                          { style: { width: '34px' }, className: 'config_span' },
                          _react2.default.createElement('label', { className: 'pcgpt_label ico-moon icon-gpt-edit', onClick: _this3.edit, 'data-id': item.id }),
                          _react2.default.createElement('label', { className: 'pcgpt_label ico-moon icon-gpt-del mar_l8', onClick: _this3.preDel, 'data-id': item.id })
                        )
                      )
                    )
                  ),
                  item.isDel == true && _react2.default.createElement(
                    'div',
                    { className: 'del_prompt' },
                    _react2.default.createElement(
                      'div',
                      { className: 'del_prompt_t' },
                      '\u5220\u9664\u540E\u65E0\u6CD5\u6062\u590D\uFF0C\u662F\u5426\u7EE7\u7EED\u5220\u9664\uFF1F'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'del_prompt_btn' },
                      _react2.default.createElement(
                        'div',
                        { onClick: _this3.cancelPreDel, 'data-id': item.id },
                        '\u53D6\u6D88'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'btndelete', onClick: _this3.delect, 'data-id': item.id },
                        '\u5220\u9664'
                      )
                    )
                  )
                );
              }),
              historyList.length == 0 && _react2.default.createElement(
                'div',
                { className: 'mar_l10' },
                '\u6682\u65E0\u5386\u53F2\u5BF9\u8BDD'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'nav_list' },
            _react2.default.createElement(
              'div',
              { className: 'nav_item', onClick: this.startNewSession },
              _react2.default.createElement('label', { className: 'ico-moon icon-add' }),
              _react2.default.createElement(
                'span',
                null,
                '\u65B0\u5EFA\u5BF9\u8BDD'
              )
            ),
            isNeedIntegral == true && _react2.default.createElement(
              'div',
              { className: 'nav_item', onClick: this.clickNav, 'data-type': 'rechargeCenter' },
              _react2.default.createElement('label', { className: 'ico-moon icon-points' }),
              _react2.default.createElement(
                'span',
                null,
                '\u79EF\u5206\u5145\u503C'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'aside_footer_box' },
            _react2.default.createElement(
              'div',
              { className: 'aside_footer' },
              _react2.default.createElement('label', { className: 'ico-moon icon-close', onClick: this.changeAside })
            )
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'unfold_aside', onClick: this.changeAside },
          _react2.default.createElement(
            'span',
            null,
            '\u5C55\u5F00'
          ),
          _react2.default.createElement('label', { className: 'ico-moon icon-unfold' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'main' },
          _react2.default.createElement(
            'div',
            { className: 'head' },
            _react2.default.createElement(
              'div',
              { className: 'head_r' },
              _react2.default.createElement(
                'div',
                { className: 'head_item head_item_order', onClick: this.clickNav, 'data-type': 'memoryDialog' },
                _react2.default.createElement('img', { src: '//cdn.jisuapp.cn/static/management/assets/img/ai/basic/term22.png', alt: '' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u8BB0\u5FC6'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'head_item head_item_order', onClick: this.clickNav, 'data-type': 'integralDialog' },
                _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item_6_2.png' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u79EF\u5206\uFF1A',
                  canUseIntegral,
                  '\u5206'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'head_item head_item_order', onClick: this.clickNav, 'data-type': 'orderDialog' },
                _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item_7_2.png' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u8BA2\u5355\u8BB0\u5F55'
                )
              ),
              (isNeedVip == true || isNeedIntegral == true) && _react2.default.createElement(
                'div',
                { className: 'head_item head_item_vip', onClick: !userVipCardInfo ? this.clickNav : '', 'data-type': 'rechargeCenter' },
                _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog3.png' }),
                !userVipCardInfo ? '立即开通' : '会员用户'
              ),
              _react2.default.createElement(
                'div',
                { className: 'head_item' },
                _react2.default.createElement('img', { src: userInfo.cover_thumb ? userInfo.cover_thumb : 'http://img.zhichiwangluo.com/zc_app_default_photo.png' }),
                _react2.default.createElement(
                  'div',
                  { className: 'logout_box' },
                  _react2.default.createElement('div', { className: 'sj' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'logout' },
                    _react2.default.createElement(
                      'div',
                      { className: 'phone' },
                      userInfo.phone
                    ),
                    _react2.default.createElement(
                      'div',
                      { onClick: this.logout },
                      '\u9000\u51FA\u767B\u5F55'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'session_box' },
            _react2.default.createElement(
              'div',
              { className: 'session_con' },
              _react2.default.createElement(
                'div',
                { className: 'dialog_box', ref: this.myRef, onScroll: this.handleScroll },
                !dialogueList.length && _react2.default.createElement(
                  'div',
                  { className: 'tab_box' },
                  _react2.default.createElement('img', { className: 'headimg', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log.png', alt: '' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'tab_list' },
                    _react2.default.createElement(
                      'div',
                      { className: 'role_box' },
                      _react2.default.createElement(
                        'div',
                        { className: 'tabtitle' },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u9009\u62E9\u4E00\u4E2A\u4F60\u60F3\u5BF9\u8BDD\u7684\u89D2\u8272\uFF1A'
                        ),
                        _react2.default.createElement(
                          'span',
                          { onClick: this.showAllRolePage, style: { cursor: 'pointer' } },
                          '\u66F4\u591A',
                          _react2.default.createElement('label', { className: 'ico-moon little-icon icon-rightarrow' })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'tab_con' },
                        roleList.map(function (item, index) {
                          if (index < 6) {
                            return _react2.default.createElement(
                              'div',
                              { className: 'tab ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'role_active' : ''),
                                'data-id': item.role_id || item.id, key: index, onClick: _this3.selectActiveItem },
                              _react2.default.createElement(
                                'div',
                                { className: 'tab_dsc' },
                                _react2.default.createElement(
                                  'div',
                                  null,
                                  item.role_name || item.title
                                ),
                                _react2.default.createElement('label', { className: 'ico-moon little-icon icon-rightarrow' })
                              ),
                              item.url && _react2.default.createElement('img', { className: 'roleimg', src: item.url })
                            );
                          }
                        })
                      )
                    )
                  )
                ),
                is_more == 1 && _react2.default.createElement(
                  'div',
                  { className: 'request-all', onClick: this.getMore },
                  '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
                ),
                dialogueList.map(function (item, index) {
                  return _react2.default.createElement(_TextAnimationPc2.default, { key: item.id + '-' + index, data: item, againSend: _this3.againSend, className: 'head_r', toBoxBottom: _this3.toBoxBottom, endQuestion: _this3.endQuestion, showDeepChange: _this3.showDeepChange, showDeepFinshed: _this3.showDeepFinshed });
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'ipt_field' },
                _react2.default.createElement(
                  'div',
                  { className: 'tool_box', ref: this.heRef },
                  _react2.default.createElement(
                    'div',
                    { className: 'tool' },
                    !selectedRoleLLM && _react2.default.createElement(
                      'div',
                      { className: 'tool_item', onClick: modalList.length > 1 ? this.showSelectModalBox : null },
                      '\u6A21\u578B\uFF1A',
                      modalName,
                      modalList.length > 1 && (isShowModalConfig ? _react2.default.createElement('img', { className: 'check_mode', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_top.png' }) : _react2.default.createElement('img', { className: 'check_mode', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_down.png' }))
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'tool_item' },
                      '\u5BF9\u8BDD\u89D2\u8272\uFF1A',
                      selectedRoleName,
                      ' ',
                      _react2.default.createElement('img', { className: isShowAllRole ? 'check_mode check_btn_cha' : 'check_mode', onClick: this.showAllRolePage, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_add.png' })
                    ),
                    funList.length > 0 && _react2.default.createElement(
                      'div',
                      { className: 'tool_item' },
                      '\u529F\u80FD\u5217\u8868',
                      _react2.default.createElement('img', { className: 'check_mode', onClick: this.showFunList, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_add.png' })
                    ),
                    is_use_cot && _react2.default.createElement(
                      'div',
                      { className: 'tool_item' },
                      '\u6DF1\u5EA6\u89E3\u6790\uFF1A',
                      _react2.default.createElement(_switch2.default, {
                        className: 'switch',
                        checked: deepSwitch,
                        onChange: this.deepSwitchChange
                      })
                    )
                  ),
                  isShowModalConfig && _react2.default.createElement(
                    'div',
                    { className: 'tool_config' },
                    modalList.map(function (item) {
                      return item.require_vip_permission == '1' ? _react2.default.createElement(
                        'div',
                        { className: modalId == item.type ? 'config_item config_item_vip config_vip_select' : 'config_item_vip config_item', key: item.type,
                          onClick: _this3.selectModal, 'data-type': item.type, 'data-isvip': item.require_vip_permission },
                        _react2.default.createElement('img', { className: 'little-img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog3.png' }),
                        GPTModal[item.type]
                      ) : _react2.default.createElement(
                        'div',
                        { className: modalId == item.type ? 'config_item config_item_select' : 'config_item', key: item.type,
                          onClick: _this3.selectModal, 'data-type': item.type, 'data-isvip': item.require_vip_permission },
                        GPTModal[item.type]
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'ipt_file_list' },
                  filesList.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'file_item', key: index },
                      item.status === 1 && _react2.default.createElement(
                        'div',
                        { className: 'file_loading' },
                        _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_file_loading.png', alt: '' }),
                        _react2.default.createElement('div', { className: 'loading-spinner' })
                      ),
                      item.status === 2 && item.type === 'image' && _react2.default.createElement('img', { className: 'icon_file', src: item.url, alt: '' }),
                      item.status === 2 && item.type !== 'image' && _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + item.type + '.png', alt: '' }),
                      item.status === 3 && _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + (item.type === 'image' ? 'img_fail.png' : 'file_fail.png'), alt: '' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'file_dsc' },
                        _react2.default.createElement(
                          'span',
                          { className: 'file_name' },
                          item.name
                        ),
                        item.status === 1 && _react2.default.createElement(
                          'span',
                          { className: 'file_state' },
                          '\u4E0A\u4F20\u4E2D...'
                        ),
                        item.status === 2 && _react2.default.createElement(
                          'span',
                          { className: 'file_state' },
                          item.type,
                          '\uFF0C',
                          item.size
                        ),
                        item.status === 3 && _react2.default.createElement(
                          'span',
                          { className: 'file_state fail' },
                          '\u4E0A\u4F20\u5931\u8D25'
                        )
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-close-btn', onClick: _this3.removeFile, 'data-index': index })
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'ipt_wrapper' },
                  _react2.default.createElement('textarea', { id: 'auto-resize-textarea', className: 'ipt_box', placeholder: !userVipCardInfo && isNeedIntegral ? "来说点什么吧（消耗2积分）" : "来说点什么吧", onKeyPress: this.askQuestionsKeyEnter, onInput: this.bindTextInput, onChange: this.bindTextInput, value: content })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'ipt_btns' },
                  _react2.default.createElement(
                    'div',
                    { className: 'icon_ipt_file ' + (filesList.length > 9 ? 'disabled' : ''), onClick: this.iconUploadFiles },
                    _react2.default.createElement('label', { className: 'ico-moon icon-comNote' })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'ipt_tips' },
                    '\u652F\u6301\u4E0A\u4F20\u6587\u4EF6(\u6700\u591A10\u4E2A\uFF0C\u6BCF\u4E2A20 MB)\u3002\u63A5\u53D7 pdf\u3001doc\u3001ppt\u3001txt\u3001excel\u3001\u56FE\u7247\u7B49'
                  ),
                  _react2.default.createElement('input', { type: 'file', disabled: filesList.length > 9, ref: this.fileInputRef, id: 'fileInput', multiple: true, accept: '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.txt', onChange: this.uploadFiles }),
                  _react2.default.createElement(
                    'div',
                    { className: 'sub_btn ' + (isSub && !isQuestioning || filesList.length ? 'btn_t' : ''), onClick: this.askQuestions, title: isSub && !isQuestioning ? '' : '说点什么吧' },
                    isQuestioning ? '回答中' : '发送'
                  )
                )
              )
            )
          )
        ),
        isShowAllRole == true && _react2.default.createElement(
          'div',
          { className: 'drawer_box' },
          _react2.default.createElement('div', { className: 'mask', onClick: this.hiddenAllRolePage }),
          _react2.default.createElement(
            'div',
            { className: 'drawer_bth', onClick: this.hiddenAllRolePage },
            '\u6536\u8D77'
          ),
          _react2.default.createElement(
            'div',
            { className: 'drawer' },
            _react2.default.createElement(
              'div',
              { className: 'head' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u89D2\u8272\u5207\u6362'
              ),
              _react2.default.createElement(
                'div',
                { className: 'ipt_box' },
                _react2.default.createElement('input', { type: 'text', value: searchValue, onInput: this.bindSearInput, onChange: this.bindSearInput, onClick: this.debubbling }),
                _react2.default.createElement(
                  'div',
                  { onClick: this.searchRole },
                  _react2.default.createElement('label', { className: 'ico-moon icon-search' }),
                  '\u641C\u7D22'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main' },
              roleListAll.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'role_item ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'active' : ''),
                    'data-id': item.role_id || item.id, key: index, onClick: _this3.selectActiveItem },
                  item.url && _react2.default.createElement('img', { src: item.url }),
                  _react2.default.createElement(
                    'div',
                    null,
                    item.role_name || item.title
                  )
                );
              })
            )
          )
        ),
        isShowFunList == true && _react2.default.createElement(
          'div',
          { className: 'drawer_box fun' },
          _react2.default.createElement('div', { className: 'mask', onClick: this.hiddenFunList }),
          _react2.default.createElement(
            'div',
            { className: 'drawer_bth', onClick: this.hiddenFunList },
            '\u6536\u8D77'
          ),
          _react2.default.createElement(
            'div',
            { className: 'drawer' },
            _react2.default.createElement(
              'div',
              { className: 'head' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                '\u529F\u80FD\u5217\u8868'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'main' },
              funList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'role_item',
                    'data-prompt': item.prompt, key: index, onClick: _this3.useFunByAI },
                  item.icon && _react2.default.createElement('img', { src: item.icon }),
                  _react2.default.createElement(
                    'div',
                    { className: 'fun_name' },
                    item.name
                  )
                );
              })
            )
          )
        ),
        integralDialogShow == true && _react2.default.createElement(_IntegralDetail2.default, { cancelDialog: this.cancelDialog }),
        orderDialogShow == true && _react2.default.createElement(_OrderList2.default, { cancelDialog: this.cancelDialog }),
        vipRechargeShow == true && _react2.default.createElement(_VipRecharge2.default, { cancelDialog: this.cancelDialog }),
        integralRechargeShow == true && _react2.default.createElement(_IntegralRecharge2.default, { cancelDialog: this.cancelDialog }),
        paySuccessShow == true && _react2.default.createElement(_PaySuccess2.default, { cancelDialog: this.cancelDialog }),
        rechargeCenterShow == true && _react2.default.createElement(_RechargeCenter2.default, { cancelDialog: this.cancelDialog }),
        memoryDialogShow == true && _react2.default.createElement(_MemoryBank2.default, { cancelDialog: this.cancelDialog, useComfirmFile: this.useComfirmFile })
      );
    }
  }]);
  return PcIndex;
}(_OfficialPage3.default);

exports.default = PcIndex;

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

__webpack_require__(27);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _rcTooltip = __webpack_require__(150);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

__webpack_require__(151);

__webpack_require__(690);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4',
  '2': '文心一言-4.0',
  '3': 'GPT-4omini',
  '4': '通义千问',
  '5': 'kimi',
  '6': 'GPT-4o',
  '7': '字节豆包',
  '8': '百川智能',
  '9': 'GPT-o1-preview',
  '10': 'GPT-o1-mini',
  '11': '腾讯混元',
  '12': '讯飞星火-Max',
  '13': 'Azure-OpenAI',
  '14': 'deepseek（官网）',
  '15': 'deepseek（腾讯云版本）',
  '16': 'UI TARS',
  '17': 'GPT-o3-mini',
  '18': 'GPT-o4-mini',
  '19': '通义千问3'
}; /*
    * @Author: ht 1724552153@qq.com
    * @Date: 2024-08-05 13:56:40
    * @LastEditors: ht 1724552153@qq.com
    * @LastEditTime: 2025-07-08 09:36:23
    * @FilePath: \jisuapp_webapp\src\chatgpt-page\component\TextAnimationPc\TextAnimationPc.jsx
    * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
    */

var TextAnimationPc = function (_Component) {
  (0, _inherits3.default)(TextAnimationPc, _Component);

  function TextAnimationPc() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TextAnimationPc);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextAnimationPc.__proto__ || Object.getPrototypeOf(TextAnimationPc)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayText: "",
      userInfo: _app.appMethod.getUserInfo(),
      generateing: false,
      timer: null,
      chunks: [],
      previewUrl: '',
      files: [],
      // 深度思考
      reasoningTimer: null,
      displayDeepText: ""
    }, _this.startReasoningContentPolling = function (content, callback) {
      var currentIndex = 0;
      var intervalId = setInterval(function () {
        if (currentIndex < content.length) {
          _this.setState(function (prevState) {
            return {
              displayDeepText: prevState.displayDeepText + content[currentIndex]
            };
          });
          currentIndex++;
          _this.toBoxBottom();
        } else {
          clearInterval(intervalId);
          callback(); // 轮询完成后执行回调
        }
      }, 40);

      _this.setState({ reasoningTimer: intervalId });
    }, _this.startTextPolling = function (text, chunks) {
      var currentIndex = 0;
      var intervalId = setInterval(function () {
        if (currentIndex < text.length) {
          _this.setState(function (prevState) {
            return {
              displayText: prevState.displayText + text[currentIndex],
              chunks: chunks
            };
          });
          currentIndex++;
          // if(text[currentIndex] == '\n' || currentIndex%44 == 0){  // 换行时
          _this.toBoxBottom();
          // }
        } else {
          clearInterval(intervalId);
          _this.endQuestion();
          _this.setState({
            generateing: false
          });
        }
      }, 40);
      _this.setState({
        timer: intervalId
      });
    }, _this.stopGenerate = function () {
      clearInterval(_this.state.timer);
      clearInterval(_this.state.reasoningTimer);
      _this.endQuestion();
    }, _this.replaceTextWithComponent = function (text, chunks, url) {
      var regex = /`?##(\d+|\{\d+\})(##|\$\$)`?/g;
      var parts = [];
      var lastIndex = 0;
      var tooltipIndex = 0;

      text.replace(regex, function (match, p1, p2, offset) {
        // 添加文本部分
        if (offset > lastIndex) {
          parts.push(text.substring(lastIndex, offset));
        }

        var index = void 0;
        if (p1.startsWith('{')) {
          index = parseInt(p1.slice(1, -1), 10) - 1;
        } else {
          index = parseInt(p1, 10) - 1;
        }

        var chunk = chunks[index] || '';

        // 添加图标组件
        if (chunk) {
          parts.push(_react2.default.createElement(
            _rcTooltip2.default,
            {
              key: 'tooltip-' + tooltipIndex++ + '-' + index + '-' + p1,
              placement: 'top',
              overlay: _react2.default.createElement(
                'div',
                { className: 'custom-tooltip-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'custom-tooltip-wrapper' },
                  _react2.default.createElement(
                    'span',
                    null,
                    chunk.content_with_weight
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'custom-tooltip' },
                  _react2.default.createElement('img', {
                    src: 'https://test2.zhichiwangluo.com/static/management/assets/img/ai/learn-7.png',
                    alt: ''
                  }),
                  _react2.default.createElement(
                    'span',
                    {
                      onClick: function onClick() {
                        return _this.handleFileNameClick(chunk.docnm_kwd);
                      },
                      style: { cursor: 'pointer' } // 添加手势样式，让用户知道这是可点击的
                    },
                    chunk.file_name
                  )
                )
              ),
              trigger: ['hover']
            },
            _react2.default.createElement(_icon2.default, { type: 'question-circle', title: '\u8FD9\u662F\u4E00\u4E2A\u63D0\u793A\u4FE1\u606F', className: 'icon-container' })
          ));
        }

        lastIndex = offset + match.length;
      });

      // 添加剩余文本部分
      if (lastIndex < text.length) {
        parts.push(text.substring(lastIndex));
      }

      return parts;
    }, _this.handleFileNameClick = function (docnmkwd) {
      console.log(docnmkwd);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetFileUrl',
        hideLoading: true,
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId(),
          file_name: docnmkwd
        },
        success: function success(res) {
          if (res.status === 0) {
            var fileUrl = res.data;
            // 使用 fetch 请求文件内容
            fetch(fileUrl).then(function (response) {
              return response.blob();
            }).then(function (blob) {
              // 创建一个对象 URL 用于下载
              var objectUrl = URL.createObjectURL(blob);
              var a = document.createElement('a');
              a.href = objectUrl;
              a.download = docnmkwd; // 设置下载的文件名
              // 触发点击事件以下载文件
              a.click();
              // 释放对象 URL
              URL.revokeObjectURL(objectUrl);
            }).catch(function (error) {
              console.error('Error fetching the file:', error);
            });
          }
        }
      });
    }, _this.setClipboardData = function (e) {
      var content = e.currentTarget.dataset.content;
      _app.appMethod.setClipboardData({
        data: content
      });
      _toast2.default.info('复制完成', 1);
    }, _this.toPage = function () {
      _app.appMethod.turnToPage('userCenterComponentPage');
    }, _this.sendQues = function (e) {
      var content = e.currentTarget.dataset.content;
      _this.props.againSend(content, true);
    }, _this.againSend = function (e) {
      var content = e.currentTarget.dataset.content;
      _this.props.againSend(content);
    }, _this.toBoxBottom = function () {
      _this.props.toBoxBottom();
    }, _this.endQuestion = function () {
      _this.props.endQuestion();
    }, _this.showDeepChange = function (e) {
      var ids = e.currentTarget.dataset.id;
      _this.props.showDeepChange(ids);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TextAnimationPc, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var _props$data = this.props.data,
          text = _props$data.text,
          direction = _props$data.direction,
          isHistory = _props$data.isHistory,
          chunks = _props$data.chunks,
          reference_url = _props$data.reference_url,
          files = _props$data.files,
          showDeep = _props$data.showDeep,
          reasoningContent = _props$data.reasoningContent,
          id = _props$data.id;
      // let currentIndex = 0;

      if (direction != "reply" || isHistory) {
        this.setState({
          displayText: text,
          chunks: chunks,
          files: files || []
        });
        return;
      }
      // 深度思考逻辑
      if (showDeep == 1 && reasoningContent && reasoningContent != '') {
        this.startReasoningContentPolling(reasoningContent, function () {
          // 深度思考内容轮询完成后的回调
          _this2.props.showDeepFinshed(id);
          _this2.startTextPolling(text, chunks); // 开始轮询主文本
        });
      } else {
        this.startTextPolling(text, chunks); // 开始轮询主文本
      }

      // const intervalId = setInterval(() => {
      //   if (currentIndex < text.length) {
      //     this.setState((prevState) => ({
      //       displayText: prevState.displayText + text[currentIndex],
      //     }));
      //     currentIndex++;
      //     // if(text[currentIndex] == '\n' || currentIndex%44 == 0){  // 换行时
      //       this.toBoxBottom();
      //     // }
      //   } else {
      //     clearInterval(intervalId);
      //     this.endQuestion();
      //     this.setState({
      //       generateing: false
      //     })
      //   }
      // }, 40);
      // this.setState({
      //   timer: intervalId
      // })
    }
    // 轮询深度思考内容


    // 轮询主文本内容

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // clearInterval(this.intervalId);
      clearInterval(this.state.timer);
      clearInterval(this.state.reasoningTimer);
    }
    //停止生成


    // 正则表达式 替换#标识符


    // 点击链接事件


    // 复制东西到剪切板


    // 存储记忆
    // setStorageData = ()=>{
    //   this.props.setStorageData()
    // }

    // // 单选按钮
    // checkboxChange = e =>{
    //   let checked = e.target.checked;
    //   this.props.checkboxChange(this.props.data.id,checked)
    // }


  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          displayText = _state.displayText,
          userInfo = _state.userInfo,
          generateing = _state.generateing,
          chunks = _state.chunks,
          files = _state.files,
          displayDeepText = _state.displayDeepText;
      var _props$data2 = this.props.data,
          direction = _props$data2.direction,
          isLoading = _props$data2.isLoading,
          err = _props$data2.err,
          type = _props$data2.type,
          showDeep = _props$data2.showDeep,
          id = _props$data2.id,
          showDeepContent = _props$data2.showDeepContent,
          reasoningFinsh = _props$data2.reasoningFinsh,
          reasoningContent = _props$data2.reasoningContent,
          quesList = _props$data2.quesList,
          reference_url = _props$data2.reference_url,
          text = _props$data2.text;
      // const { isStorageVisible } = this.props

      if (direction == "reply") {
        return _react2.default.createElement(
          'div',
          { className: 'chat_pc' },
          _react2.default.createElement(
            'div',
            { className: 'chat-bubble-left' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement('img', { className: 'headimg', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/log2.png', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: 'chat-bubble-item' },
                showDeep == 1 && _react2.default.createElement(
                  'div',
                  { className: '' + (!showDeepContent ? "chat-bubble-deep" : "chat-bubble-deepdowan") },
                  _react2.default.createElement(
                    'div',
                    { className: 'chat-deep-title' },
                    _react2.default.createElement(
                      'span',
                      null,
                      reasoningFinsh ? '已深度思考' : '正在深度思考中'
                    ),
                    !showDeepContent && _react2.default.createElement('label', { 'data-id': id, onClick: this.showDeepChange, className: 'ico-moon icon-uparrow' }),
                    showDeepContent && _react2.default.createElement('label', { 'data-id': id, onClick: this.showDeepChange, className: 'ico-moon icon-downarrow' })
                  ),
                  !showDeepContent && _react2.default.createElement(
                    'div',
                    { className: 'chat-deep-content' },
                    displayDeepText
                  )
                ),
                showDeep == 0 && _react2.default.createElement(
                  'div',
                  { className: 'chat-bubble-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    this.replaceTextWithComponent(displayText, chunks, reference_url)
                  ),
                  displayText != '' && _react2.default.createElement(
                    'div',
                    { className: 'con_operate' },
                    _react2.default.createElement('label', { className: 'ico-moon icon-copy', onClick: this.setClipboardData, 'data-content': displayText })
                  ),
                  !!type == true && _react2.default.createElement(
                    'div',
                    { className: 'mode' },
                    GPTModal[type]
                  )
                ),
                showDeep == 1 && reasoningFinsh && _react2.default.createElement(
                  'div',
                  { className: 'chat-bubble-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    this.replaceTextWithComponent(displayText, chunks, reference_url)
                  ),
                  displayText != '' && _react2.default.createElement(
                    'div',
                    { className: 'con_operate' },
                    _react2.default.createElement('label', { className: 'ico-moon icon-copy', onClick: this.setClipboardData, 'data-content': displayText })
                  ),
                  !!type == true && _react2.default.createElement(
                    'div',
                    { className: 'mode' },
                    GPTModal[type]
                  )
                )
              )
            )
          ),
          quesList && quesList.length > 0 && _react2.default.createElement(
            'div',
            { className: 'ques_list' },
            quesList.map(function (q, i) {
              return _react2.default.createElement(
                'p',
                { className: 'ques_item', key: i, onClick: _this3.sendQues, 'data-content': q },
                q
              );
            })
          ),
          generateing == true && _react2.default.createElement(
            'div',
            { className: 'stop_btn', onClick: this.stopGenerate },
            _react2.default.createElement('label', { className: 'ico-moon icon-stop' }),
            _react2.default.createElement(
              'span',
              null,
              '\u505C\u6B62\u56DE\u7B54'
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'chat_pc' },
        _react2.default.createElement(
          'div',
          { className: 'chat-bubble-right' },
          _react2.default.createElement(
            'div',
            { className: 'row' },
            _react2.default.createElement(
              'div',
              { className: 'chat-bubble-content' },
              displayText,
              _react2.default.createElement(
                'div',
                { className: 'copy_box' },
                _react2.default.createElement(
                  'div',
                  { className: 'copy' },
                  _react2.default.createElement('label', { className: 'ico-moon icon-copy', onClick: this.setClipboardData, 'data-content': displayText }),
                  _react2.default.createElement(
                    'div',
                    { className: 'copy_dsc' },
                    '\u590D\u5236'
                  )
                )
              )
            ),
            _react2.default.createElement('img', { className: 'headimg', onClick: this.toPage, src: userInfo.cover_thumb ? userInfo.cover_thumb : 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'file_list' },
          files.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'file_item' },
              item.type === 'image' && _react2.default.createElement('img', { className: 'icon_file', src: item.file_url, alt: '' }),
              item.type !== 'image' && _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + item.file_type + '.png', alt: '' }),
              _react2.default.createElement(
                'div',
                { className: 'file_dsc' },
                _react2.default.createElement(
                  'span',
                  { className: 'file_name' },
                  item.name
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'file_state' },
                  item.file_type,
                  '\uFF0C',
                  item.size
                )
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'ques_status' },
          isLoading && _react2.default.createElement(_icon2.default, { type: 'loading', className: 'loadicon' }),
          err && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { onClick: this.againSend, 'data-content': displayText, src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/error.png', alt: '' }),
            '\u53D1\u9001\u5931\u8D25'
          )
        )
      );
    }
  }]);
  return TextAnimationPc;
}(_react.Component);

exports.default = TextAnimationPc;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(689);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(187);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(692);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegralDetail = function (_React$Component) {
  (0, _inherits3.default)(IntegralDetail, _React$Component);

  function IntegralDetail(props) {
    (0, _classCallCheck3.default)(this, IntegralDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IntegralDetail.__proto__ || Object.getPrototypeOf(IntegralDetail)).call(this, props));

    _this.state = {
      tabStatus: '1',
      list: [],
      isMore: '',
      currentPage: 1
    };

    _this.cancel = function () {
      _this.props.cancelDialog('integralDialog');
    };

    _this.getMessageData = function (type, page) {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      var that = _this;
      var action = '';
      if (type == '1') {
        action = 'add';
      } else if (type = '2') {
        action = 'minus';
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/UserIntegralAction',
        data: {
          action: action,
          page: page || 1,
          page_size: 4
        },
        success: function success(res) {
          _app.appMethod.hideLoading();
          that.setState({
            list: res.data,
            isMore: res.is_more,
            currentPage: res.current_page || '1'
          });
        }
      });
    };

    _this.checkTap = function (event) {
      var type = event.currentTarget.dataset.type;
      _this.setState({
        tabStatus: type,
        list: []
      });
      _this.getMessageData(type);
    };

    _this.nextPage = function () {
      if (_this.state.isMore != 1) {
        _toast2.default.info('已经是最后一页了');
        return;
      }
      var page = _this.state.currentPage + 1;
      _this.getMessageData(_this.state.tabStatus, page);
    };

    _this.prePage = function () {
      if (_this.state.currentPage == 1) {
        _toast2.default.info('已经是第一页了');
        return;
      }
      var page = _this.state.currentPage > 2 ? _this.state.currentPage - 1 : 1;
      _this.getMessageData(_this.state.tabStatus, page);
    };

    return _this;
  }

  (0, _createClass3.default)(IntegralDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.isLogin()) {
        this.getMessageData('1');
      } else {
        _app.appMethod.turnToPage('login-pc');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'integraLDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'title_line' },
            _react2.default.createElement(
              'div',
              { className: this.state.tabStatus == '1' ? 'active' : '', onClick: this.checkTap, 'data-type': '1' },
              '\u6536\u5165'
            ),
            _react2.default.createElement(
              'div',
              { className: this.state.tabStatus == '2' ? 'active' : '', onClick: this.checkTap, 'data-type': '2' },
              '\u652F\u51FA'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main' },
            this.state.list.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'inteItem', key: index },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    item.content
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'time' },
                    item.time
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'integral_num' },
                  item.num
                )
              );
            }),
            this.state.list.length == 0 && _react2.default.createElement(
              'div',
              { className: 'no_data' },
              _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png' }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65E0\u6570\u636E~'
              )
            )
          ),
          this.state.list.length != 0 && _react2.default.createElement(
            'div',
            { className: 'btn_box' },
            _react2.default.createElement('label', { className: 'ico-moon icon-leftarrow', onClick: this.prePage }),
            _react2.default.createElement(
              'div',
              { className: 'btn_page' },
              this.state.currentPage
            ),
            _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow', onClick: this.nextPage })
          )
        )
      );
    }
  }]);
  return IntegralDetail;
}(_react2.default.Component);

exports.default = IntegralDetail;

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(694);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderList = function (_Component) {
  (0, _inherits3.default)(OrderList, _Component);

  function OrderList(props) {
    (0, _classCallCheck3.default)(this, OrderList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OrderList.__proto__ || Object.getPrototypeOf(OrderList)).call(this, props));

    _this.state = {
      tabStatus: '1',
      list: [],
      isMore: '',
      currentPage: 1,
      isNeedVip: false,
      isNeedIntegral: false
    };

    _this.getVipInfo = function () {
      var that = _this;
      return new Promise(function (resolve) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=appVipCard/getUserAccountSurvey',
          data: {
            app_id: _app.appMethod.getAppId(),
            card_type: 2
          },
          hideLoading: true,
          success: function success(res) {
            if (res.status == 0) {
              that.setState({
                isNeedVip: Boolean(res.data.all_vip_card.length)
              });
              resolve();
            }
          }
        });
      });
    };

    _this.getIntegralInfo = function () {
      var that = _this;
      return new Promise(function (resolve) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
          hideLoading: true,
          data: {
            app_id: _app.appMethod.getAppId(),
            card_type: 2
          },
          success: function success(res) {
            if (res.status != 0) {
              return;
            }
            that.setState({
              isNeedIntegral: Boolean(res.data.length)
            });
            resolve();
          }
        });
      });
    };

    _this.cancel = function () {
      _this.props.cancelDialog('orderDialog');
    };

    _this.getMessageData = function (type, page) {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      var that = _this;
      var action = '';
      var status = null;
      if (type == '1') {
        action = '8';
        status = 1;
      } else if (type = '2') {
        action = '17';
        status = 6;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/orderList',
        method: 'POST',
        data: {
          goods_type: action,
          page: page || 1,
          page_size: 4,
          screening_cond: {
            status: status
          }
        },
        success: function success(res) {
          _app.appMethod.hideLoading();
          that.setState({
            list: res.data,
            isMore: res.is_more,
            currentPage: res.current_page || '1'
          });
        }
      });
    };

    _this.checkTap = function (event) {
      var type = event.currentTarget.dataset.type;
      _this.setState({
        tabStatus: type,
        list: []
      });
      _this.getMessageData(type);
    };

    _this.nextPage = function () {
      if (_this.state.isMore != 1) {
        _toast2.default.info('已经是最后一页了');
        return;
      }
      var page = _this.state.currentPage + 1;
      _this.getMessageData(_this.state.tabStatus, page);
    };

    _this.prePage = function () {
      if (_this.state.currentPage == 1) {
        _toast2.default.info('已经是第一页了');
        return;
      }
      var page = _this.state.currentPage > 2 ? _this.state.currentPage - 1 : 1;
      _this.getMessageData(_this.state.tabStatus, page);
    };

    return _this;
  }

  (0, _createClass3.default)(OrderList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (_app.appMethod.isLogin()) {
        Promise.all([this.getVipInfo(), this.getIntegralInfo()]).then(function () {
          if (!_this2.state.isNeedVip && _this2.state.isNeedIntegral) {
            _this2.setState({
              tabStatus: '2'
            });
            _this2.getMessageData('2');
          } else {
            _this2.setState({
              tabStatus: '1'
            });
            _this2.getMessageData('1');
          }
        });
      } else {
        _app.appMethod.turnToPage('login-pc');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var orderStatusName = {
        8: ['待付款', '已付款', '', '', '', '', '', '已关闭'], //会员卡
        17: ['待付款', '已付款', '', '', '', '', '已完成', '已关闭'] //积分
      };
      var _state = this.state,
          isNeedVip = _state.isNeedVip,
          isNeedIntegral = _state.isNeedIntegral;

      return _react2.default.createElement(
        'div',
        { className: 'orderListDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            '\u8BA2\u5355\u8BB0\u5F55'
          ),
          _react2.default.createElement(
            'div',
            { className: 'tab_line' },
            isNeedVip == true && _react2.default.createElement(
              'div',
              { className: this.state.tabStatus == '1' ? 'active' : '', onClick: this.checkTap, 'data-type': '1' },
              '\u4F1A\u5458\u5361\u8BA2\u5355'
            ),
            isNeedIntegral == true && _react2.default.createElement(
              'div',
              { className: this.state.tabStatus == '2' ? 'active' : '', onClick: this.checkTap, 'data-type': '2' },
              '\u79EF\u5206\u5145\u503C\u8BA2\u5355'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main' },
            _react2.default.createElement(
              'div',
              { className: 'tabel_head' },
              _react2.default.createElement(
                'div',
                null,
                '\u8BA2\u5355\u53F7'
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u5546\u54C1\u540D\u79F0'
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u5546\u54C1\u4EF7\u683C'
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u8BA2\u5355\u72B6\u6001'
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u521B\u5EFA\u65F6\u95F4'
              )
            ),
            this.state.list.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'tabel_item', key: index },
                _react2.default.createElement(
                  'div',
                  null,
                  item.form_data.order_id
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _this3.state.tabStatus == '1' ? item.form_data.goods_info.goods_name : item.form_data.chat_ai && item.form_data.chat_ai.chat_send_nums + '积分/' + item.form_data.chat_ai.chat_price + '元'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  '\uFFE5',
                  item.form_data.total_price
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  orderStatusName[item.form_data.goods_type][item.form_data.status]
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  item.form_data.add_time
                )
              );
            }),
            this.state.list.length == 0 && _react2.default.createElement(
              'div',
              { className: 'no_data' },
              _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png' }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65E0\u6570\u636E~'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bottom_line' },
            _react2.default.createElement('div', { className: 'underline ' + (this.state.list.length != 0 ? '' : 'w_808') }),
            this.state.list.length != 0 && _react2.default.createElement(
              'div',
              { className: 'btn_box' },
              _react2.default.createElement('label', { className: 'ico-moon icon-leftarrow', onClick: this.prePage }),
              _react2.default.createElement(
                'div',
                { className: 'btn_page' },
                this.state.currentPage
              ),
              _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow', onClick: this.nextPage })
            )
          )
        )
      );
    }
  }]);
  return OrderList;
}(_react.Component);

exports.default = OrderList;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(696);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VipRecharge = function (_React$Component) {
  (0, _inherits3.default)(VipRecharge, _React$Component);

  function VipRecharge(props) {
    (0, _classCallCheck3.default)(this, VipRecharge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VipRecharge.__proto__ || Object.getPrototypeOf(VipRecharge)).call(this, props));

    _this.state = {
      list: [],
      showList: [],
      page: 1,
      totalPage: 0,
      code: '',
      selectId: '',
      selectPrice: null,
      selectComboid: '',
      shouldPayPrice: 0,
      timer: null,
      orderId: ''
    };

    _this.cancel = function () {
      _this.props.cancelDialog('vipRecharge');
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          var returnVipList = res.data.all_vip_card || [];
          that.setState({
            list: returnVipList,
            totalPage: Math.ceil(returnVipList.length / 4),
            showList: returnVipList.slice(0, 4),
            selectId: returnVipList.length ? returnVipList[0].id : '',
            selectPrice: returnVipList.length ? returnVipList[0].price : null,
            selectComboid: returnVipList.length ? returnVipList[0].combo[0].id : ''
          });
          if (returnVipList.length) {
            that.selectItem();
          }
        }
      });
    };

    _this.nextPage = function () {
      var _this$state = _this.state,
          page = _this$state.page,
          list = _this$state.list,
          totalPage = _this$state.totalPage;

      if (page >= totalPage) {
        _toast2.default.info('后面已经没有了');
        return;
      }
      var c_page = page + 1;
      var start = page * 4;
      var end = start + 4;
      _this.setState({
        page: c_page,
        showList: list.slice(start, end)
      });
    };

    _this.prePage = function () {
      var _this$state2 = _this.state,
          page = _this$state2.page,
          list = _this$state2.list;

      if (page <= 1) {
        _toast2.default.info('前面已经没有了');
        return;
      }
      var c_page = page - 1;
      var start = c_page * 4 - 4;
      var end = start + 4;
      _this.setState({
        page: c_page,
        showList: list.slice(start, end)
      });
    };

    _this.selectItem = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var that = _this;
      var id = event ? event.currentTarget.dataset.id : that.state.selectId;
      var price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
      var comboid = event ? event.currentTarget.dataset.comboid : that.state.selectComboid;
      that.setState({
        selectId: id,
        shouldPayPrice: price
      });
      if (that.state.timer) {
        clearInterval(that.state.timer);
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/addPaidVipCardOrder',
        method: 'post',
        data: {
          app_id: _app.appMethod.getAppId(),
          data_id: id,
          price: price,
          combo_id: comboid
        },
        hideLoading: false,
        complete: function complete(res) {
          if (res.status != 0) {
            that.setState({
              selectId: '',
              selectPrice: null,
              selectComboid: '',
              shouldPayPrice: 0
            });
            return;
          }
          var orderId = res.data;
          that.setState({
            orderId: orderId
          });
          that.getPayCode(orderId);
        }
      });
    };

    _this.getPayCode = function (orderId) {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=pay/Pay/GetUniPay',
        data: {
          order_id: orderId,
          payment_id: 0
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              code: res.data
            });
            var timer = setInterval(function () {
              that.isPay(orderId);
            }, 3000);
            that.setState({
              timer: timer
            });
          }
        }
      });
    };

    _this.isPay = function (orderId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/CheckOrder',
        method: 'post',
        data: {
          order_id: orderId || that.state.orderId
        },
        success: function success(res) {
          if (res.status != 0) {
            _toast2.default.info(res.data);
            return;
          }
          switch (res.data.status) {
            case '0':
              // 订单未支付
              break;
            case '1':
              // 订单支付完成
              _toast2.default.info('订单支付完成');
              clearInterval(that.state.timer);
              that.props.cancelDialog('vipRecharge', 1);
              break;
            case '2':
              // 订单取消
              break;
          }
        }
      });
    };

    return _this;
  }

  (0, _createClass3.default)(VipRecharge, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.isLogin()) {
        this.getVipInfo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState = function (state, callback) {
        return;
      };
      clearInterval(this.state.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'vipDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'titel' },
            '\u9009\u62E9VIP\u5957\u9910'
          ),
          _react2.default.createElement(
            'div',
            { className: 'main' },
            _react2.default.createElement('img', { className: 'next_item', src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/next.png', onClick: this.nextPage }),
            _react2.default.createElement('img', { className: 'pre_item', src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/next.png', onClick: this.prePage }),
            _react2.default.createElement(
              'div',
              { className: 'item_list' },
              this.state.showList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'item ' + (_this2.state.selectId == item.id ? 'active' : ''), key: index, onClick: _this2.selectItem, 'data-id': item.id, 'data-comboid': item.combo[0].id, 'data-price': item.price },
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    item.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price' },
                    '\uFFE5',
                    item.combo[0].price
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'dsc' },
                    '\u5F53\u524D\u7B49\u7EA7\uFF1Av',
                    item.level
                  )
                );
              })
            ),
            this.state.code != '' && _react2.default.createElement(
              'div',
              { className: 'recharge_box' },
              _react2.default.createElement(
                'div',
                { className: 'code' },
                _react2.default.createElement('img', { src: this.state.code })
              ),
              _react2.default.createElement(
                'div',
                { className: 'info' },
                _react2.default.createElement(
                  'div',
                  { className: 'wxzf' },
                  _react2.default.createElement('img', { src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/wxlog.png', alt: '' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5FAE\u4FE1\u652F\u4ED8'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info_line' },
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    '\u5E94\u4ED8\u91D1\u989D:'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price' },
                    '\uFFE5',
                    _react2.default.createElement(
                      'span',
                      null,
                      this.state.shouldPayPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dsc' },
                  '\u652F\u4ED8\u89C6\u4E3A\u60A8\u540C\u610F\u300A\u4F1A\u5458\u534F\u8BAE\u300B'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return VipRecharge;
}(_react2.default.Component);

exports.default = VipRecharge;

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(698);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaySuccess = function (_Component) {
  (0, _inherits3.default)(PaySuccess, _Component);

  function PaySuccess(props) {
    (0, _classCallCheck3.default)(this, PaySuccess);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PaySuccess.__proto__ || Object.getPrototypeOf(PaySuccess)).call(this, props));

    _this.cancel = function () {
      _this.props.cancelDialog('paySuccess');
    };

    return _this;
  }

  (0, _createClass3.default)(PaySuccess, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'paySuccessDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'tips' },
            _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/successlog.png' }),
            _react2.default.createElement(
              'div',
              null,
              '\xA0\xA0\u8D2D\u4E70\u6210\u529F\uFF01'
            )
          )
        )
      );
    }
  }]);
  return PaySuccess;
}(_react.Component);

exports.default = PaySuccess;

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(700);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntegralRecharge = function (_React$Component) {
  (0, _inherits3.default)(IntegralRecharge, _React$Component);

  function IntegralRecharge(props) {
    (0, _classCallCheck3.default)(this, IntegralRecharge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IntegralRecharge.__proto__ || Object.getPrototypeOf(IntegralRecharge)).call(this, props));

    _this.state = {
      list: [],
      showList: [],
      page: 1,
      totalPage: 0,
      code: '',
      selectId: '',
      selectPrice: null,
      shouldPayPrice: 0,
      timer: null,
      orderId: ''
    };

    _this.cancel = function () {
      _this.props.cancelDialog('integralRecharge');
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          var returnIntegralList = res.data || [];
          that.setState({
            list: returnIntegralList,
            totalPage: Math.ceil(returnIntegralList.length / 4),
            showList: returnIntegralList.slice(0, 4),
            selectId: returnIntegralList.length ? returnIntegralList[0].id : '',
            selectPrice: returnIntegralList.length ? returnIntegralList[0].price : null
          });
          if (returnIntegralList.length) {
            that.selectItem();
          }
        }
      });
    };

    _this.nextPage = function () {
      var _this$state = _this.state,
          page = _this$state.page,
          list = _this$state.list,
          totalPage = _this$state.totalPage;

      if (page >= totalPage) {
        _toast2.default.info('后面已经没有了');
        return;
      }
      var c_page = page + 1;
      var start = page * 4;
      var end = start + 4;
      _this.setState({
        page: c_page,
        showList: list.slice(start, end)
      });
    };

    _this.prePage = function () {
      var _this$state2 = _this.state,
          page = _this$state2.page,
          list = _this$state2.list;

      if (page <= 1) {
        _toast2.default.info('前面已经没有了');
        return;
      }
      var c_page = page - 1;
      var start = c_page * 4 - 4;
      var end = start + 4;
      _this.setState({
        page: c_page,
        showList: list.slice(start, end)
      });
    };

    _this.selectItem = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var that = _this;
      var id = event ? event.currentTarget.dataset.id : that.state.selectId;
      var price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
      _this.setState({
        selectId: id,
        shouldPayPrice: price
      });
      if (that.state.timer) {
        clearInterval(that.state.timer);
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/CreateOrder',
        method: 'post',
        data: {
          app_id: _app.appMethod.getAppId(),
          integral_config_id: id,
          goods_type: 17
        },
        hideLoading: false,
        success: function success(res) {
          if (res.status != 0) {
            _toast2.default.info(res.data);
            return;
          }
          var orderId = res.data;
          that.setState({
            orderId: orderId
          });
          that.getPayCode(orderId);
        }
      });
    };

    _this.getPayCode = function (orderId) {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=pay/Pay/GetUniPay',
        data: {
          order_id: orderId,
          payment_id: 0
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              code: res.data
            });
            var timer = setInterval(function () {
              that.isPay(orderId);
            }, 3000);
            that.setState({
              timer: timer
            });
          }
        }
      });
    };

    _this.isPay = function (orderId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/CheckOrder',
        method: 'post',
        data: {
          order_id: orderId || that.state.orderId
        },
        success: function success(res) {
          if (res.status != 0) {
            _toast2.default.info(res.data);
            return;
          }
          switch (res.data.status) {
            case '0':
              // 订单未支付
              break;
            case '6':
              // 订单支付完成
              _toast2.default.info('订单支付完成');
              clearInterval(that.state.timer);
              that.props.cancelDialog('integralRecharge', 1);
              break;
          }
        }
      });
    };

    return _this;
  }

  (0, _createClass3.default)(IntegralRecharge, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.isLogin()) {
        this.getVipInfo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState = function (state, callback) {
        return;
      };
      clearInterval(this.state.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'integralRechargeDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'main' },
            _react2.default.createElement(
              'div',
              { className: 'r_item_box' },
              _react2.default.createElement(
                'div',
                { className: 'titel' },
                '\u79EF\u5206\u5145\u503C'
              ),
              _react2.default.createElement('img', { className: 'next_item', src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/next.png', onClick: this.nextPage }),
              _react2.default.createElement('img', { className: 'pre_item', src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/next.png', onClick: this.prePage }),
              _react2.default.createElement(
                'div',
                { className: 'item_list' },
                this.state.showList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'item ' + (_this2.state.selectId == item.id ? 'active' : ''), key: index, onClick: _this2.selectItem, 'data-id': item.id, 'data-price': item.price },
                    _react2.default.createElement(
                      'div',
                      { className: 'num' },
                      item.num,
                      '\u79EF\u5206'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'price' },
                      item.price,
                      '\u5143'
                    )
                  );
                })
              )
            ),
            this.state.code != '' && _react2.default.createElement(
              'div',
              { className: 'recharge_box' },
              _react2.default.createElement(
                'div',
                { className: 'code' },
                _react2.default.createElement('img', { src: this.state.code })
              ),
              _react2.default.createElement(
                'div',
                { className: 'info' },
                _react2.default.createElement(
                  'div',
                  { className: 'wxzf' },
                  _react2.default.createElement('img', { src: 'http://test2.zhichiwangluo.com/static/webapp/images/chatgpt/wxlog.png', alt: '' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5FAE\u4FE1\u652F\u4ED8'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info_line' },
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    '\u5E94\u4ED8\u91D1\u989D:'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price' },
                    '\uFFE5',
                    _react2.default.createElement(
                      'span',
                      null,
                      this.state.shouldPayPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dsc' },
                  '\u652F\u4ED8\u89C6\u4E3A\u60A8\u540C\u610F\u300A\u79EF\u5206\u5145\u503C\u534F\u8BAE\u300B'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return IntegralRecharge;
}(_react2.default.Component);

exports.default = IntegralRecharge;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(702);

var _app = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RechargeCenter = function (_React$Component) {
  (0, _inherits3.default)(RechargeCenter, _React$Component);

  function RechargeCenter(props) {
    (0, _classCallCheck3.default)(this, RechargeCenter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RechargeCenter.__proto__ || Object.getPrototypeOf(RechargeCenter)).call(this, props));

    _this.state = {
      intergal: {
        list: [],
        showList: [],
        page: 1,
        totalPage: 0
      },
      vip: {
        list: [],
        showList: [],
        page: 1,
        totalPage: 0
      },
      type: null,
      code: '',
      selectId: '',
      selectPrice: null,
      shouldPayPrice: 0,
      timer: null,
      orderId: ''
    };

    _this.cancel = function () {
      _this.props.cancelDialog('rechargeCenter');
    };

    _this.getIntegralInfo = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          var returnIntegralList = res.data || [];
          that.setState({
            intergal: {
              list: returnIntegralList,
              showList: returnIntegralList.slice(0, 4),
              totalPage: Math.ceil(returnIntegralList.length / 4),
              page: 1
            }
            // selectId: returnIntegralList.length?returnIntegralList[0].id:'',
            // selectPrice: returnIntegralList.length?returnIntegralList[0].price:null,
          });
          // if(returnIntegralList.length){
          //   that.selectItem();
          // }
        }
      });
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        hideLoading: true,
        data: {
          app_id: _app.appMethod.getAppId(),
          card_type: 2
        },
        success: function success(res) {
          var returnVipList = res.data.all_vip_card || [];
          that.setState({
            vip: {
              list: returnVipList,
              totalPage: Math.ceil(returnVipList.length / 4),
              showList: returnVipList.slice(0, 4),
              page: 1
              // selectId: returnVipList.length?returnVipList[0].id:'',
              // selectPrice: returnVipList.length?returnVipList[0].price:null,
              // selectComboid: returnVipList.length?returnVipList[0].combo[0].id:''
            } });
          // if(returnVipList.length){
          //   that.selectItem();
          // }
        }
      });
    };

    _this.nextPage = function () {
      var _this$state$intergal = _this.state.intergal,
          page = _this$state$intergal.page,
          list = _this$state$intergal.list,
          totalPage = _this$state$intergal.totalPage;

      console.log(page);
      if (page >= totalPage) {
        _toast2.default.info('后面已经没有了');
        return;
      }
      var c_page = page + 1;
      var start = page * 4;
      var end = start + 4;
      _this.setState({
        intergal: {
          page: c_page,
          showList: list.slice(start, end)
        }
      });
    };

    _this.prePage = function () {
      var _this$state$intergal2 = _this.state.intergal,
          page = _this$state$intergal2.page,
          list = _this$state$intergal2.list;

      if (page <= 1) {
        _toast2.default.info('前面已经没有了');
        return;
      }
      var c_page = page - 1;
      var start = c_page * 4 - 4;
      var end = start + 4;
      _this.setState({
        intergal: {
          page: c_page,
          showList: list.slice(start, end)
        }
      });
    };

    _this.nextPage2 = function () {
      var _this$state$vip = _this.state.vip,
          page = _this$state$vip.page,
          list = _this$state$vip.list,
          totalPage = _this$state$vip.totalPage;

      console.log(page);
      if (page >= totalPage) {
        _toast2.default.info('后面已经没有了');
        return;
      }
      var c_page = page + 1;
      var start = page * 4;
      var end = start + 4;
      _this.setState({
        intergal: {
          page: c_page,
          showList: list.slice(start, end)
        }
      });
    };

    _this.prePage2 = function () {
      var _this$state$vip2 = _this.state.vip,
          page = _this$state$vip2.page,
          list = _this$state$vip2.list;

      if (page <= 1) {
        _toast2.default.info('前面已经没有了');
        return;
      }
      var c_page = page - 1;
      var start = c_page * 4 - 4;
      var end = start + 4;
      _this.setState({
        intergal: {
          page: c_page,
          showList: list.slice(start, end)
        }
      });
    };

    _this.selectItem = function () {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var that = _this;
      var id = event ? event.currentTarget.dataset.id : that.state.selectId;
      var type = event ? event.currentTarget.dataset.type : that.state.type;
      var price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
      var comboid = type == 2 ? event.currentTarget.dataset.comboid : '';

      var integralurl = '/index.php?r=ChatAI/CreateOrder';
      var vipurl = '/index.php?r=appVipCard/addPaidVipCardOrder';
      var parms1 = {
        app_id: _app.appMethod.getAppId(),
        integral_config_id: id,
        goods_type: 17
      };
      var parms2 = {
        app_id: _app.appMethod.getAppId(),
        data_id: id,
        price: price,
        combo_id: comboid
      };
      _this.setState({
        selectId: id,
        shouldPayPrice: price,
        type: type
      });
      if (that.state.timer) {
        clearInterval(that.state.timer);
      }
      _app.appMethod.sendRequest({
        url: type == 1 ? integralurl : vipurl,
        method: 'post',
        data: type == 1 ? parms1 : parms2,
        hideLoading: false,
        complete: function complete(res) {
          if (res.status != 0) {
            that.setState({
              selectId: '',
              selectPrice: null,
              selectComboid: '',
              shouldPayPrice: 0,
              type: null
            });
            return;
          }
          var orderId = res.data;
          that.setState({
            orderId: orderId
          });
          that.getPayCode(orderId);
        }
      });
    };

    _this.getPayCode = function (orderId) {
      var that = _this;
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=pay/Pay/GetUniPay',
        data: {
          order_id: orderId,
          payment_id: 0
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              code: res.data
            });
            var timer = setInterval(function () {
              that.isPay(orderId);
            }, 3000);
            that.setState({
              timer: timer
            });
          }
        }
      });
    };

    _this.isPay = function (orderId) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/CheckOrder',
        method: 'post',
        data: {
          order_id: orderId || that.state.orderId
        },
        success: function success(res) {
          if (res.status != 0) {
            _toast2.default.info(res.data);
            return;
          }
          switch (res.data.status) {
            case '0':
              // 订单未支付
              break;
            case '1':
              // 订单支付完成
              _toast2.default.info('订单支付完成');
              clearInterval(that.state.timer);
              that.props.cancelDialog('rechargeCenter', that.state.type);
              break;
            case '6':
              // 订单支付完成
              _toast2.default.info('订单支付完成');
              clearInterval(that.state.timer);
              that.props.cancelDialog('rechargeCenter', that.state.type);
              break;
          }
        }
      });
    };

    return _this;
  }

  (0, _createClass3.default)(RechargeCenter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_app.appMethod.isLogin()) {
        this.getVipInfo();
        this.getIntegralInfo();
      } else {
        _app.appMethod.turnToPage('login-pc');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState = function (state, callback) {
        return;
      };
      clearInterval(this.state.timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'rechargeCenterDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'head' },
            '\u5145\u503C\u4E2D\u5FC3'
          ),
          _react2.default.createElement(
            'div',
            { className: 'main' },
            this.state.intergal.showList.length != 0 && _react2.default.createElement(
              'div',
              { className: 'r_item_box' },
              _react2.default.createElement(
                'div',
                { className: 'item_title' },
                _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/item5.png' }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u79EF\u5206\u5145\u503C'
                )
              ),
              _react2.default.createElement('img', { className: 'next_item', src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png', onClick: this.nextPage }),
              _react2.default.createElement('img', { className: 'pre_item', src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png', onClick: this.prePage }),
              _react2.default.createElement(
                'div',
                { className: 'item_list' },
                this.state.intergal.showList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'item ' + (_this2.state.selectId == item.id && _this2.state.type == 1 ? 'active' : ''), key: index, onClick: _this2.selectItem, 'data-type': 1, 'data-id': item.id, 'data-price': item.price },
                    _react2.default.createElement(
                      'div',
                      { className: 'num' },
                      item.num,
                      '\u79EF\u5206'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'price' },
                      item.price,
                      '\u5143'
                    )
                  );
                })
              )
            ),
            this.state.vip.showList.length != 0 && _react2.default.createElement(
              'div',
              { className: 'r_item_box mar_t20' },
              _react2.default.createElement(
                'div',
                { className: 'item_title' },
                _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/item4.png' }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u5F00\u901A\u4F1A\u5458'
                )
              ),
              _react2.default.createElement('img', { className: 'next_item', src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png', onClick: this.nextPage2 }),
              _react2.default.createElement('img', { className: 'pre_item', src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/next.png', onClick: this.prePage2 }),
              _react2.default.createElement(
                'div',
                { className: 'item_list' },
                this.state.vip.showList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'vipitem ' + (_this2.state.selectId == item.id && _this2.state.type == 2 ? 'active' : ''), key: index, onClick: _this2.selectItem, 'data-type': 2, 'data-comboid': item.combo[0].id, 'data-id': item.id, 'data-price': item.combo[0].price },
                    _react2.default.createElement(
                      'div',
                      { className: 'name' },
                      item.title
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'price2' },
                      _react2.default.createElement(
                        'div',
                        { className: 'mar_r10' },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\uFFE5'
                        ),
                        item.combo[0].price
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'dsc through' },
                        '\u539F\u4EF7\uFFE5',
                        item.price
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'dsc' },
                      (item.combo[0].price / 30).toFixed(2),
                      '\u5143/\u5929'
                    )
                  );
                })
              )
            ),
            this.state.code != '' && _react2.default.createElement(
              'div',
              { className: 'recharge_box' },
              _react2.default.createElement(
                'div',
                { className: 'code' },
                _react2.default.createElement('img', { src: this.state.code })
              ),
              _react2.default.createElement(
                'div',
                { className: 'info' },
                _react2.default.createElement(
                  'div',
                  { className: 'wxzf' },
                  _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/chatgpt/wxlog.png', alt: '' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5FAE\u4FE1\u652F\u4ED8'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info_line' },
                  _react2.default.createElement(
                    'div',
                    { className: 'name' },
                    '\u5E94\u4ED8\u91D1\u989D:'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price' },
                    '\uFFE5',
                    _react2.default.createElement(
                      'span',
                      null,
                      this.state.shouldPayPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'dsc' },
                  '\u652F\u4ED8\u89C6\u4E3A\u60A8\u540C\u610F',
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', href: 'http://bbs.zhichiwangluo.com/forum.php?mod=viewthread&tid=11189&page=1&extra=#pid12695' },
                    '\u300A\u54AB\u5C3A\u652F\u4ED8\u534F\u8BAE\u300B'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return RechargeCenter;
}(_react2.default.Component);

exports.default = RechargeCenter;

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__(76);

var _modal2 = _interopRequireDefault(_modal);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(78);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(704);

var _app = __webpack_require__(4);

var _rcTooltip = __webpack_require__(150);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

__webpack_require__(151);

var _FileList = __webpack_require__(705);

var _FileList2 = _interopRequireDefault(_FileList);

var _http = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileIcons = {
  pdf: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term7.png',
  doc: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term8.png',
  ppt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term9.png',
  txt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term10.png',
  excel: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term11.png'
};

var MemoryBank = function (_Component) {
  (0, _inherits3.default)(MemoryBank, _Component);

  function MemoryBank(props) {
    (0, _classCallCheck3.default)(this, MemoryBank);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MemoryBank.__proto__ || Object.getPrototypeOf(MemoryBank)).call(this, props));

    _this.state = {
      tabStatus: '1',
      tabFileStatus: '0',
      flieList: [],
      longList: [],
      isMore: '',
      currentPage: 1,
      searchValue: '',
      fileDialogShow: false,
      hiddenmodalput: false,
      inputText: '',
      editIds: ''
    };

    _this.cancel = function () {
      _this.props.cancelDialog('memoryDialog');
    };

    _this.GetUserFile = function (page) {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetUserFile',
        data: {
          app_id: _app.appMethod.getAppId(),
          session_key: '',
          role_id: -1,
          type: Number(_this.state.tabFileStatus),
          file_name: _this.state.searchValue,
          page: page || 1,
          page_size: 8
        },
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          if (res.status == 0) {
            _app.appMethod.hideLoading();
            _this.setState({
              flieList: res.data,
              searchValue: '',
              isMore: res.is_more,
              currentPage: res.current_page || '1'
            });
          }
        }
      });
    };

    _this.cancelDialog = function () {
      _this.setState({
        fileDialogShow: false
      });
    };

    _this.comfirmDialog = function () {
      _this.GetUserFile(_this.state.currentPage);
      _this.setState({
        fileDialogShow: false
      });
    };

    _this.checkTap = function (event) {
      var type = event.currentTarget.dataset.type;
      _this.setState({
        tabStatus: type,
        currentPage: 1,
        isMore: ''
      }, function () {
        var _this$state = _this.state,
            tabStatus = _this$state.tabStatus,
            currentPage = _this$state.currentPage;

        if (tabStatus === '1') {
          _this.setState({
            longList: []
          });
          _this.GetUserFile(currentPage);
        } else {
          _this.setState({
            flieList: []
          });
          _this.UserMemory(currentPage, 'add');
        }
      });
    };

    _this.checkFile = function (event) {
      var type = event.currentTarget.dataset.type;
      _this.setState({
        tabFileStatus: type,
        flieList: []
      }, function () {
        _this.GetUserFile(_this.state.currentPage);
      });
    };

    _this.nextPage = function () {
      var tabStatus = _this.state.tabStatus;

      if (_this.state.isMore != 1) {
        _toast2.default.info('已经是最后一页了');
        return;
      }
      var page = _this.state.currentPage + 1;
      if (tabStatus === '1') {
        _this.GetUserFile(page);
      } else {
        _this.UserMemory(page, 'add');
      }
    };

    _this.prePage = function () {
      var tabStatus = _this.state.tabStatus;

      if (_this.state.currentPage == 1) {
        _toast2.default.info('已经是第一页了');
        return;
      }
      var page = _this.state.currentPage > 2 ? _this.state.currentPage - 1 : 1;
      if (tabStatus === '1') {
        _this.GetUserFile(page);
      } else {
        _this.UserMemory(page, 'add');
      }
    };

    _this.bindSearInput = function (event) {
      var val = event.target.value;
      _this.setState({
        searchValue: val
      });
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.GetUserFile(_this.state.currentPage);
      }
    };

    _this.fileUpload = function () {
      _this.setState({
        fileDialogShow: true
      });
    };

    _this.deleteFile = function (ids, status) {
      var confirmationMessage = '';
      if (status == '0') {
        confirmationMessage = '确定要删除该图片吗?';
      } else if (status == '1') {
        confirmationMessage = '确定要删除该文件吗?';
      }
      var idsArray = [ids];
      var jsonString = JSON.stringify(idsArray);
      _app.appMethod.showModal({
        content: confirmationMessage,
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: function confirm() {
          _app.appMethod.sendRequest({
            url: '/index.php?r=ChatAI/DelUserFile',
            data: {
              ids: jsonString
            },
            method: 'POST',
            success: function success(res) {
              if (res.status == 0) {
                _toast2.default.info('删除成功');
                if (_this.state.flieList.length === 1) {
                  if (_this.state.currentPage > 1) {
                    _this.GetUserFile(_this.state.currentPage - 1);
                  } else {
                    _this.GetUserFile(_this.state.currentPage);
                  }
                } else {
                  // 否则重新获取当前页面的数据
                  _this.GetUserFile(_this.state.currentPage);
                }
              } else {
                _toast2.default.fail('删除失败');
              }
            }
          });
        }
      });
    };

    _this.deleteLongterm = function (ids) {
      var idsArray = [ids];
      var jsonString = JSON.stringify(idsArray);
      _app.appMethod.showModal({
        content: '你确定要删除该条长期记忆吗?',
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: function confirm() {
          (0, _http.ajax)({
            url: '/index.php?r=ChatAI/UserMemory' + '&ids=' + jsonString,
            type: 'Delete',
            success: function success(res) {
              if (res.status === 0) {
                var totalLength = 0;
                for (var year in _this.state.longList) {
                  if (_this.state.longList.hasOwnProperty(year)) {
                    totalLength += _this.state.longList[year].length; // 累加每个年份数组的长度
                  }
                }
                if (totalLength === 1) {
                  if (_this.state.currentPage > 1) {
                    setTimeout(function () {
                      _toast2.default.info('删除成功');
                      _this.UserMemory(_this.state.currentPage - 1, 'add');
                    }, 500);
                  } else {
                    setTimeout(function () {
                      _toast2.default.info('删除成功');
                      _this.UserMemory(_this.state.currentPage, 'add');
                    }, 500);
                  }
                } else {
                  setTimeout(function () {
                    _toast2.default.info('删除成功');
                    _this.UserMemory(_this.state.currentPage, 'add');
                  }, 500);
                }
              }
            }
          });
        }
      });
    };

    _this.searchClick = function () {
      _this.GetUserFile();
    };

    _this.useFile = function (items) {
      _this.props.useComfirmFile(items);
    };

    _this.UserMemory = function (page, status) {
      var metheds = void 0,
          memorys = void 0;
      var pages = void 0;
      var pageSize = void 0;
      var edits = void 0;
      var structString = void 0;
      if (status === 'add') {
        metheds = 'GET';
        pages = page || 1;
        pageSize = 10;
      } else if (status === 'edit') {
        metheds = 'POST';
        memorys = _this.state.inputText;
        edits = _this.state.editIds;
        var struct = [{
          _id: edits,
          memory: memorys
        }];
        structString = JSON.stringify(struct);
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/UserMemory',
        data: {
          app_id: _app.appMethod.getAppId(),
          session_key: '',
          page: pages,
          page_size: pageSize,
          struct: structString
        },
        hideLoading: true,
        method: metheds,
        success: function success(res) {
          if (res.status == 0) {
            if (status === 'add') {
              var totalPages = Math.ceil(res.data.count / pageSize);
              var isMore = page < totalPages ? 1 : 0;
              var newData = _this.groupByDate(res.data.data);

              _this.setState({
                longList: newData,
                currentPage: page,
                isMore: isMore
              });
            } else if (status === 'edit') {
              setTimeout(function () {
                _this.UserMemory(_this.state.currentPage, 'add');
                _toast2.default.info('修改成功');
              }, 500);
              // this.UserMemory(this.state.currentPage,'add')
            }
          }
        }
      });
    };

    _this.groupByDate = function (data) {
      return data.reduce(function (acc, item) {
        var date = item.date.split(' ')[0]; // 获取日期部分
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(item);
        return acc;
      }, {});
    };

    _this.canceledits = function () {
      _this.setState({ hiddenmodalput: false });
    };

    _this.confirm = function () {
      _this.setState({ hiddenmodalput: false });
      _this.UserMemory(_this.state.currentPage, 'edit');
    };

    _this.editLongterm = function (contents, ids) {
      _this.setState({ hiddenmodalput: true, inputText: contents, editIds: ids });
    };

    _this.handleInputChange = function (event) {
      _this.setState({
        inputText: event.target.value // 更新状态为文本框中的值
      });
    };

    _this.GetUserFile(_this.state.currentPage);
    return _this;
  }

  (0, _createClass3.default)(MemoryBank, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
    // 获取用户文件列表


    // 取消

    // 确认

    // 记忆tab切换


    // 文件类型tab切换

    // 处理按下Enter键的事件


    // 文件上传弹窗


    // 删除文件


    // 删除长期记忆


    // 长期记忆文件


    // 按日期分组


    // 关闭编辑弹窗


    // 确认弹窗


    // 编辑长期记忆

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          tabStatus = _state.tabStatus,
          tabFileStatus = _state.tabFileStatus,
          searchValue = _state.searchValue,
          fileDialogShow = _state.fileDialogShow,
          longList = _state.longList,
          hiddenmodalput = _state.hiddenmodalput,
          inputText = _state.inputText;


      return _react2.default.createElement(
        'div',
        { className: 'memnoryBankDialog' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'tab_line' },
            _react2.default.createElement(
              'div',
              { className: tabStatus == '1' ? 'active' : '', onClick: this.checkTap, 'data-type': '1' },
              '\u6587\u4EF6\u8BB0\u5FC6'
            ),
            _react2.default.createElement(
              'div',
              { className: tabStatus == '2' ? 'active' : '', onClick: this.checkTap, 'data-type': '2' },
              '\u957F\u671F\u8BB0\u5FC6'
            )
          ),
          tabStatus == '1' && _react2.default.createElement(
            'div',
            { className: 'file_box' },
            _react2.default.createElement(
              'div',
              { className: 'file_hd' },
              _react2.default.createElement(
                'div',
                { className: 'file_tab' },
                _react2.default.createElement(
                  'div',
                  { className: tabFileStatus == '0' ? 'active' : '', onClick: this.checkFile, 'data-type': '0' },
                  '\u7167\u7247'
                ),
                _react2.default.createElement(
                  'div',
                  { className: tabFileStatus == '1' ? 'active' : '', onClick: this.checkFile, 'data-type': '1' },
                  '\u6587\u4EF6'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'file_upload' },
                _react2.default.createElement(
                  'div',
                  { className: 'file_ipt' },
                  _react2.default.createElement(
                    'div',
                    { className: 'file_icon', onClick: this.searchClick },
                    _react2.default.createElement('label', { className: 'ico-moon icon-search' })
                  ),
                  _react2.default.createElement('input', {
                    type: 'text',
                    value: searchValue,
                    placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
                    onChange: this.bindSearInput,
                    onKeyDown: this.handleKeyDown
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'file_btn', onClick: this.fileUpload },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u4E0A\u4F20'
                  )
                )
              )
            ),
            tabFileStatus == '0' && _react2.default.createElement(
              'div',
              { className: 'file_contetnt' },
              _react2.default.createElement(
                'div',
                { className: 'file_list' },
                this.state.flieList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'file_box_cnt', key: index },
                    _react2.default.createElement('div', { className: 'file_img', style: { backgroundImage: 'url(' + item.file_url + ')' } }),
                    _react2.default.createElement(
                      'span',
                      { className: 'img_name' },
                      item.file_name
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'file_icon' },
                      _react2.default.createElement(
                        'span',
                        null,
                        item.add_time
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'file_use' },
                        _react2.default.createElement(
                          _rcTooltip2.default,
                          { placement: 'top', overlay: '\u4F7F\u7528', trigger: ['hover'] },
                          _react2.default.createElement('img', { onClick: function onClick() {
                              return _this2.useFile(item);
                            }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term4.png', alt: 'tooltip-icon' })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'file_close', onClick: function onClick() {
                          return _this2.deleteFile(item.id, '0');
                        } },
                      _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term5.png', alt: 'tooltip-icon' })
                    )
                  );
                }),
                this.state.flieList.length == 0 && _react2.default.createElement(
                  'div',
                  { className: 'no_data' },
                  _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            ),
            tabFileStatus == '1' && _react2.default.createElement(
              'div',
              { className: 'file_contetnt' },
              _react2.default.createElement(
                'div',
                { className: 'main' },
                _react2.default.createElement(
                  'div',
                  { className: 'tabel_head' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u6587\u4EF6\u540D\u79F0'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u6587\u4EF6\u5927\u5C0F'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u4E0A\u4F20\u65F6\u95F4'
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u64CD\u4F5C'
                  )
                ),
                this.state.flieList.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'tabel_item', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'tabel_img' },
                      fileIcons[item.file_type] && _react2.default.createElement('img', {
                        className: 'icon_file',
                        src: '' + fileIcons[item.file_type]
                      }),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.file_name
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      item.file_size
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      item.add_time
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'tabel_opera' },
                      _react2.default.createElement(
                        _rcTooltip2.default,
                        { placement: 'top', overlay: '\u4F7F\u7528', trigger: ['hover'] },
                        _react2.default.createElement('img', { onClick: function onClick() {
                            return _this2.useFile(item);
                          }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term4.png', alt: 'tooltip-icon' })
                      ),
                      _react2.default.createElement(
                        _rcTooltip2.default,
                        { placement: 'top', overlay: '\u5220\u9664', trigger: ['hover'] },
                        _react2.default.createElement('img', { onClick: function onClick() {
                            return _this2.deleteFile(item.id, '1');
                          }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png', alt: 'tooltip-icon' })
                      )
                    )
                  );
                }),
                this.state.flieList.length == 0 && _react2.default.createElement(
                  'div',
                  { className: 'no_data' },
                  _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png' }),
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u6682\u65E0\u6570\u636E~'
                  )
                )
              )
            )
          ),
          tabStatus == '2' && _react2.default.createElement(
            'div',
            { className: 'longterm_box' },
            Object.keys(longList).map(function (date) {
              return _react2.default.createElement(
                'div',
                { key: date, className: 'longterm_list' },
                _react2.default.createElement(
                  'span',
                  { className: 'longterm_title' },
                  date
                ),
                longList[date].map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { key: item._id, className: 'longterm_item' },
                    _react2.default.createElement(
                      'span',
                      { className: 'longterm_timer' },
                      item.date.split(' ')[1].split(':')[0],
                      ':',
                      item.date.split(' ')[1].split(':')[1]
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'longterm_content' },
                      item.content
                    ),
                    _react2.default.createElement(
                      _rcTooltip2.default,
                      { placement: 'top', overlay: '\u7F16\u8F91', trigger: ['hover'] },
                      _react2.default.createElement('img', { onClick: function onClick() {
                          return _this2.editLongterm(item.content, item._id);
                        }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term14.png', alt: 'tooltip-icon' })
                    ),
                    _react2.default.createElement(
                      _rcTooltip2.default,
                      { placement: 'top', overlay: '\u5220\u9664', trigger: ['hover'] },
                      _react2.default.createElement('img', { onClick: function onClick() {
                          return _this2.deleteLongterm(item._id);
                        }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png', alt: 'tooltip-icon' })
                    )
                  );
                })
              );
            }),
            this.state.longList.length == 0 && _react2.default.createElement(
              'div',
              { className: 'no_data' },
              _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png' }),
              _react2.default.createElement(
                'div',
                null,
                '\u6682\u65E0\u6570\u636E~'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'btn_box' },
            _react2.default.createElement('label', { className: 'ico-moon icon-leftarrow', onClick: this.prePage }),
            _react2.default.createElement(
              'div',
              { className: 'btn_page' },
              this.state.currentPage
            ),
            _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow', onClick: this.nextPage })
          )
        ),
        _react2.default.createElement(
          _modal2.default,
          {
            className: 'modal-wrap',
            transparent: true,
            title: '\u7F16\u8F91\u540D\u79F0',
            visible: hiddenmodalput
          },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            _react2.default.createElement('textarea', {
              className: 'input-textarea',
              value: inputText // 绑定文本框的值
              , onChange: this.handleInputChange // 处理输入变化
              , placeholder: '\u8BF7\u8F93\u5165\u5185\u5BB9...'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-btn-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'cancel', onClick: this.canceledits },
              '\u53D6\u6D88'
            ),
            _react2.default.createElement(
              'div',
              { className: 'confirm', onClick: this.confirm },
              '\u786E\u8BA4'
            )
          )
        ),
        fileDialogShow == true && _react2.default.createElement(_FileList2.default, { cancelDialog: this.cancelDialog, comfirmDialog: this.comfirmDialog })
      );
    }
  }]);
  return MemoryBank;
}(_react.Component);

exports.default = MemoryBank;

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(82);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _asyncToGenerator2 = __webpack_require__(83);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(706);

var _app = __webpack_require__(4);

var _rcTooltip = __webpack_require__(150);

var _rcTooltip2 = _interopRequireDefault(_rcTooltip);

__webpack_require__(151);

var _http = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fileIcons = {
  pdf: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term7.png',
  doc: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term8.png',
  ppt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term9.png',
  txt: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term10.png',
  excel: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term11.png'
};

var FileList = function (_Component) {
  (0, _inherits3.default)(FileList, _Component);

  function FileList(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, FileList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FileList.__proto__ || Object.getPrototypeOf(FileList)).call(this, props));

    _this.state = {
      filesList: []
    };

    _this.iconUploadFiles = function () {
      console.log(_app.appMethod.globalData.sessionKey);
      if (_this.fileInputRef.current && _this.state.filesList.length < 10) {
        _this.fileInputRef.current.click();
      }
    };

    _this.handleDragEnter = function (e) {
      e.preventDefault();
      console.log(_this.fileUploadBoxRef.current);
      _this.fileUploadBoxRef.current.classList.add('dragging');
    };

    _this.handleDragLeave = function (e) {
      e.preventDefault();
      _this.fileUploadBoxRef.current.classList.remove('dragging');
    };

    _this.handleDragOver = function (e) {
      e.preventDefault(); // 阻止默认的处理，允许文件拖拽
    };

    _this.handleDrop = function (e) {
      e.preventDefault();
      var files = e.dataTransfer.files; // 获取拖拽的文件
      _this.fileUploadBoxRef.current.classList.remove('dragging');
      if (files.length) {
        // 将文件传递给 uploadFiles 方法处理上传
        _this.uploadFiles({ target: { files: files } });
      }
    };

    _this.getFileType = function (mimeType) {
      var typeMap = {
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
        'application/pdf': 'pdf',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
        'text/plain': 'txt',
        'application/vnd.ms-excel': 'excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
        'image/jpeg': 'image',
        'image/png': 'image'
      };

      return typeMap[mimeType] || mimeType;
    };

    _this.getFileSize = function (sizeInBytes) {
      if (sizeInBytes < 1024) {
        return sizeInBytes + ' B';
      } else if (sizeInBytes < 1024 * 1024) {
        return (sizeInBytes / 1024).toFixed(2) + ' KB';
      } else {
        return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
      }
    };

    _this.uploadFiles = function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var files, currentFiles, maxFileSize, maxFiles, validTypes, fileDetails, i, file, type, size, fileDetail;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                files = e.target.files;
                currentFiles = _this.state.filesList;
                maxFileSize = 20 * 1024 * 1024; // 20MB

                maxFiles = 10;

                if (files.length) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return');

              case 6:
                if (!(files.length + currentFiles.length > maxFiles)) {
                  _context2.next = 9;
                  break;
                }

                _toast2.default.info('\u6700\u591A\u53EA\u80FD\u4E0A\u4F20' + maxFiles + '\u4E2A\u6587\u4EF6\uFF01');
                return _context2.abrupt('return');

              case 9:

                // 检查每个文件的大小和类型，并返回详细信息
                validTypes = new Set(['image/jpeg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/pdf', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'text/plain']);
                fileDetails = [];
                i = 0;

              case 12:
                if (!(i < files.length)) {
                  _context2.next = 27;
                  break;
                }

                file = files[i];

                if (!(file.size > maxFileSize)) {
                  _context2.next = 17;
                  break;
                }

                _toast2.default.info(file.name + ' \u5927\u5C0F\u8D85\u8FC720MB\uFF0C\u65E0\u6CD5\u4E0A\u4F20\u3002');
                return _context2.abrupt('continue', 24);

              case 17:
                if (validTypes.has(file.type)) {
                  _context2.next = 20;
                  break;
                }

                _toast2.default.info(file.name + ' \u7C7B\u578B\u4E0D\u652F\u6301\uFF0C\u65E0\u6CD5\u4E0A\u4F20\u3002');
                return _context2.abrupt('continue', 24);

              case 20:
                type = _this.getFileType(file.type);
                size = _this.getFileSize(file.size);
                fileDetail = {
                  name: file.name,
                  type: type,
                  size: size,
                  url: '',
                  status: 1
                };


                fileDetails.push(fileDetail);

              case 24:
                i++;
                _context2.next = 12;
                break;

              case 27:

                _this.setState({
                  filesList: currentFiles.concat(fileDetails)
                });

                _context2.next = 30;
                return Promise.all(fileDetails.map(function () {
                  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(fileDetail, index) {
                    var file, result;
                    return _regenerator2.default.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            file = files[index];
                            _context.prev = 1;

                            if (!(fileDetail.type !== 'image')) {
                              _context.next = 6;
                              break;
                            }

                            (0, _http.ajax)({
                              url: '/index.php?r=ChatAI/UploadFile',
                              data: {
                                name: file
                              },
                              success: function success(res) {
                                if (res.status === 0) {
                                  fileDetail.url = res.data;
                                  fileDetail.status = 2;
                                } else {
                                  fileDetail.url = '';
                                  fileDetail.status = 3;
                                }
                                currentFiles.push(fileDetail);
                                _this.setState({
                                  filesList: currentFiles
                                });
                              }
                            });
                            _context.next = 10;
                            break;

                          case 6:
                            _context.next = 8;
                            return lrz(file);

                          case 8:
                            result = _context.sent;

                            (0, _http.ajax)({
                              url: '/index.php?r=AppData/uploadImg',
                              data: {
                                img_data: result.base64,
                                org: 1
                              },
                              success: function success(res) {
                                if (res.status === 0) {
                                  fileDetail.url = res.data;
                                  fileDetail.status = 2;
                                } else {
                                  fileDetail.url = '';
                                  fileDetail.status = 3;
                                }
                                currentFiles.push(fileDetail);
                                _this.setState({
                                  filesList: currentFiles
                                });
                              }
                            });

                          case 10:
                            _context.next = 18;
                            break;

                          case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](1);

                            fileDetail.url = '';
                            fileDetail.status = 3;
                            currentFiles.push(fileDetail);
                            _this.setState({
                              filesList: currentFiles
                            });

                          case 18:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2, [[1, 12]]);
                  }));

                  return function (_x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.deleteFile = function (index) {
      _app.appMethod.showModal({
        content: '确定要删除该文件吗?',
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: function confirm() {
          _this.setState(function (prevState) {
            return {
              filesList: prevState.filesList.filter(function (_, i) {
                return i !== index;
              })
            };
          });
        }
      });
    };

    _this.cancel = function () {
      _this.props.cancelDialog('fileDialogShow');
    };

    _this.comfirmFile = function () {
      if (_this.state.filesList.length === 0) {
        _toast2.default.info('请选择文件');
        return;
      }
      var filteredFiles = _this.state.filesList.filter(function (item) {
        return item.status === 2;
      });
      var filesInfo = [];
      filteredFiles.forEach(function (item) {
        filesInfo.push({
          type: item.type !== 'image' ? 'corpus_file' : 'image',
          name: item.name,
          file_url: item.url,
          size: item.size,
          file_type: item.type
        });
      });
      var filesListJson = JSON.stringify(filesInfo);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/Upload2User',
        data: {
          app_id: _app.appMethod.getAppId(),
          session_key: '',
          multi_files: filesListJson,
          role_id: -1
        },
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          if (res.status == 0) {
            _toast2.default.success('文件上传成功');
          } else {
            _toast2.default.fail('文件上传失败');
          }
          _this.props.comfirmDialog();
        }
      });
    };

    _this.fileInputRef = _react2.default.createRef();
    _this.fileUploadBoxRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(FileList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {}
    // 上传文件


    // 类型检验


    // 删除

    //  取消

    // 确定

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var filesList = this.state.filesList;

      return _react2.default.createElement(
        'div',
        { className: 'filelist' },
        _react2.default.createElement('div', { className: 'mask', onClick: this.cancel }),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes closes_btn', onClick: this.cancel }),
          _react2.default.createElement(
            'div',
            { className: 'title' },
            '\u6587\u4EF6\u4E0A\u4F20'
          ),
          _react2.default.createElement(
            'div',
            { className: 'file_upload_box', ref: this.fileUploadBoxRef, onDragOver: this.handleDragOver, onDrop: this.handleDrop, onDragEnter: this.handleDragEnter,
              onDragLeave: this.handleDragLeave },
            _react2.default.createElement('img', { className: filesList.length > 1 ? 'disabled' : '', onClick: this.iconUploadFiles, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term12.png', alt: 'tooltip-icon' }),
            _react2.default.createElement(
              'div',
              { className: 'file_title ' + (filesList.length > 1 ? 'disabled' : ''), onClick: this.iconUploadFiles },
              '\u70B9\u51FB\u4E0A\u4F20\u6216\u62D6\u62FD\u56FE\u7247\u5230\u8FD9\u91CC'
            ),
            _react2.default.createElement(
              'div',
              { className: 'file_warm ' + (filesList.length > 1 ? 'disabled' : ''), onClick: this.iconUploadFiles },
              '\u652F\u6301\u4E0A\u4F20\u6587\u4EF6(\u6700\u591A10\u4E2A\uFF0C\u6BCF\u4E2A20 MB)\u3002\u63A5\u53D7 pdf\u3001doc\u3001ppt\u3001txt\u3001excel\u3001\u56FE\u7247\u7B49'
            ),
            _react2.default.createElement('input', { type: 'file', disabled: filesList.length > 9, ref: this.fileInputRef, id: 'fileInput', multiple: true, accept: '.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf,.ppt,.pptx,.txt', onChange: this.uploadFiles })
          ),
          _react2.default.createElement(
            'div',
            { className: 'file_list_box' },
            filesList.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'file_box1', key: index },
                _react2.default.createElement(
                  'div',
                  { className: 'file_lf' },
                  item.status === 1 && _react2.default.createElement(
                    'div',
                    { className: 'file_loading' },
                    _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_file_loading.png', alt: '' }),
                    _react2.default.createElement('div', { className: 'loading-spinner' })
                  ),
                  item.status === 2 && item.type === 'image' && _react2.default.createElement('img', { className: 'icon_file', src: item.url, alt: '' }),
                  item.status === 2 && item.type !== 'image' && fileIcons[item.type] && _react2.default.createElement('img', {
                    className: 'icon_file',
                    src: '' + fileIcons[item.type]
                  }),
                  item.status === 3 && _react2.default.createElement('img', { className: 'icon_file', src: 'https://test2.zhichiwangluo.com/static/webapp/images/chatgpt/icon_' + (item.type === 'image' ? 'img_fail.png' : 'file_fail.png'), alt: '' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'file_cnt' },
                    _react2.default.createElement(
                      'span',
                      { className: 'file_name' },
                      item.name
                    ),
                    item.status === 1 && _react2.default.createElement(
                      'span',
                      { className: 'file_state' },
                      '\u4E0A\u4F20\u4E2D...'
                    ),
                    item.status === 2 && _react2.default.createElement(
                      'span',
                      { className: 'file_state' },
                      item.type,
                      '\uFF0C',
                      item.size
                    ),
                    item.status === 3 && _react2.default.createElement(
                      'span',
                      { className: 'file_state fail' },
                      '\u4E0A\u4F20\u5931\u8D25'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'file_rf' },
                  _react2.default.createElement(
                    _rcTooltip2.default,
                    { placement: 'top', overlay: '\u5220\u9664', trigger: ['hover'] },
                    _react2.default.createElement('img', { onClick: function onClick() {
                        return _this3.deleteFile(index);
                      }, src: 'https://cdn.jisuapp.cn/static/management/assets/img/ai/basic/term6.png', alt: 'tooltip-icon' })
                  )
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'file_btn' },
            _react2.default.createElement(
              'div',
              { className: 'file_close', onClick: this.cancel },
              '\u53D6\u6D88'
            ),
            _react2.default.createElement(
              'div',
              { className: 'file_comfirm', onClick: this.comfirmFile },
              '\u786E\u5B9A'
            )
          )
        )
      );
    }
  }]);
  return FileList;
}(_react.Component);

exports.default = FileList;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

var _app = __webpack_require__(4);

__webpack_require__(708);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 定时器
var timer = null;
var AREA_CODE = {
  0: '',
  8: '60'
};

var AddphonePage = function (_React$Component) {
  (0, _inherits3.default)(AddphonePage, _React$Component);

  function AddphonePage(props) {
    (0, _classCallCheck3.default)(this, AddphonePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AddphonePage.__proto__ || Object.getPrototypeOf(AddphonePage)).call(this, props));

    _this.state = {
      areaCode: 0,
      phoneNumber: '',
      picCode: '',
      picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000),
      identifyCode: '',
      verifying: false,
      time: 60,
      logining: false
    };

    _this.getPicCode = function () {
      _this.setState({
        picCodeUrl: '/index.php?r=Login/GetNewIdentifyCode&i=' + parseInt(Math.random() * 10000000)
      });
    };

    _this.getIdentifyCode = function () {
      if (_this.state.verifying) {
        return;
      }
      if (!_this.state.phoneNumber) {
        _toast2.default.info('请输入手机号');
        return;
      }
      if (_this.state.phoneNumber.includes(' ')) {
        _toast2.default.info('手机号不能有空格');
        return;
      }
      if (!_this.state.picCode) {
        _toast2.default.info('请输入图形验证码');
        return;
      }
      _this.setState({
        verifying: true,
        time: 60
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      (0, _http.ajax)({
        url: '/index.php?r=AppUser/phoneCode',
        data: {
          app_id: (0, _global.getAppId)(),
          phone: phone,
          pic_code: _this.state.picCode
        },
        success: function success(res) {
          if (res.status !== 0) {
            _toast2.default.fail(res.data);
            _this.setState({
              verifying: false,
              time: 60
            });
            return;
          }
          timer = setInterval(function () {
            if (_this.state.time === 0) {
              clearInterval(timer);
              _this.setState({
                verifying: false,
                time: 60
              });
            }
            _this.setState({
              time: --_this.state.time
            });
          }, 1000);
        }
      });
    };

    _this.handleChange = function (name, event) {
      _this.setState((0, _defineProperty3.default)({}, name, event.target.value));
    };

    _this.handleLogin = function () {
      if (_this.state.logining) {
        return;
      }
      // if (!this.state.phoneNumber) {
      //   Toast.info('请输入手机号');
      //   return;
      // }
      // if (this.state.phoneNumber.includes(' ')) {
      //   Toast.info('手机号不能有空格');
      //   return;
      // }
      // if (!this.state.identifyCode) {
      //   Toast.info('请输入验证码');
      //   return;
      // }
      _this.setState({
        logining: true
      });
      var phone = +_this.state.areaCode === 0 ? _this.state.phoneNumber : AREA_CODE[_this.state.areaCode] + '-' + _this.state.phoneNumber;
      (0, _http.ajax)({
        url: '/index.php?r=AppUser/phoneReg',
        data: {
          app_id: (0, _global.getAppId)(),
          phone: phone,
          code: _this.state.identifyCode
        },
        success: function success(res) {
          if (res.status !== 0) {
            _this.setState({
              logining: false
            });
            _toast2.default.fail(res.data);
            return;
          }
          _app.appMethod.setIsLogin(true);
          _app.appMethod.bindUserAccount();
          var nickname = res.nickname;
          var cover = res.cover_thumb;
          if (nickname && cover) {
            _toast2.default.info('补充完成', 1);
            // 请求用户数据存到本地
            _app.appMethod.requestUserInfo().then(function () {
              _app.appMethod.turnToPage('gptIndex');
            });
            return;
          }
        },
        error: function error() {
          _this.setState({
            logining: false
          });
          _toast2.default.fail(res.data);
        }
      });
    };

    document.title = '补充信息';
    if (_app.appMethod.getUserInfo().phone) {
      _app.appMethod.turnToPage('gptIndex');
    }
    return _this;
  }
  /**
   * 更换图形验证码
   */

  /**
   * 获取验证码
   */

  /**
   * 处理input的值的更改
   */

  /**
   * 登录
   */


  (0, _createClass3.default)(AddphonePage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'loginPage', className: 'page' },
        _react2.default.createElement(
          'div',
          { className: 'center-wrap' },
          _react2.default.createElement(
            'header',
            null,
            '\u5373\u901F\u5E94\u7528'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { className: 'phone-wrap' },
              _react2.default.createElement(
                'select',
                { value: this.state.areaCode, onChange: this.handleChange.bind(this, 'areaCode') },
                _react2.default.createElement(
                  'option',
                  { value: '0' },
                  '\u4E2D\u56FD\u5927\u9646+86'
                ),
                _react2.default.createElement(
                  'option',
                  { value: '8' },
                  'Malaysia+60'
                )
              ),
              _react2.default.createElement('input', { id: 'login-phone', className: 'js-phone-input', type: 'number', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', value: this.state.phoneNumber, onChange: this.handleChange.bind(this, 'phoneNumber') })
            ),
            _react2.default.createElement(
              'p',
              { className: 'code-p' },
              _react2.default.createElement('input', { className: 'pic-code-input', type: 'text', placeholder: '\u56FE\u5F62\u9A8C\u8BC1\u7801', value: this.state.picCode, onChange: this.handleChange.bind(this, 'picCode') }),
              _react2.default.createElement('img', { className: 'pic-code-url', src: this.state.picCodeUrl, onClick: this.getPicCode })
            ),
            _react2.default.createElement(
              'p',
              { className: 'code-p' },
              _react2.default.createElement('input', { id: 'login-code', className: 'code-input', placeholder: '\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801', value: this.state.c, onChange: this.handleChange.bind(this, 'identifyCode') }),
              _react2.default.createElement(
                'span',
                { className: 'get-code-btn', onClick: this.getIdentifyCode },
                this.state.verifying && this.state.time !== 60 ? this.state.time + 's' : '获取验证码'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'lrf-btn', onClick: this.handleLogin },
              '\u786E\u5B9A'
            )
          )
        )
      );
    }
  }]);
  return AddphonePage;
}(_react2.default.Component);

exports.default = AddphonePage;
;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(47);

__webpack_require__(33);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(710);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'sign-in'
 * 组件：每日签到组件
 */
var SignIn = function (_OfficialPage) {
  (0, _inherits3.default)(SignIn, _OfficialPage);

  function SignIn(props) {
    (0, _classCallCheck3.default)(this, SignIn);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(0, _this);
    return _this;
  }

  // 获取活动详情


  // 获取已连续签到的天数


  // 可领取的奖励列表


  // 获取用户连续签到提醒开关


  // 判断当天有无签到


  // 签到


  // 只获取时间轴


  // 获取日期数组


  // 查看每日可领取的奖励


  // 获取所有已签到的日期


  // 关闭领取成功窗口


  // 关闭领取奖励弹窗


  // 获取用户积分


  // 格式化时间轴数组


  // 阻止滚动穿透


  // 跳转路径页面


  // 推送模板消息


  // switch开关


  // 领取额外奖励按钮formId


  // 关闭领取奖励弹窗


  // 领取额外奖励


  (0, _createClass3.default)(SignIn, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.state.eles[0];

      if (!data) {
        return _react2.default.createElement('div', null);
      }
      var activityData = data.activityData,
          nodata = data.nodata,
          showSignMask = data.showSignMask,
          default_style = data.default_style,
          style_settings = data.style_settings,
          advance = data.advance,
          can_use_integral = data.can_use_integral,
          continuous_sign = data.continuous_sign,
          showDateArr = data.showDateArr,
          hasSign = data.hasSign,
          giftTips_con = data.giftTips_con,
          giftTips_acc = data.giftTips_acc,
          continuous_notice = data.continuous_notice,
          continuous_notice_user = data.continuous_notice_user,
          continuous_array = data.continuous_array,
          accumulate_array = data.accumulate_array,
          showSignSus = data.showSignSus,
          successTips = data.successTips,
          signInProgressWidth = data.signInProgressWidth,
          cur_date = data.cur_date;

      activityData = activityData || {};
      style_settings = style_settings || {};

      /**
       * @desc 活动未开始
       */
      var activityNoStart = function activityNoStart() {
        var content = null;
        if (!activityData.id && nodata) {
          content = _react2.default.createElement(
            'div',
            { className: 'signIn-notActive' },
            _react2.default.createElement(
              'div',
              { className: 'signIn-showImage' },
              _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/retroactive/notActive.png' }),
              _react2.default.createElement(
                'div',
                { className: 'signIn-notActive-exp' },
                '\u6D3B\u52A8\u672A\u5F00\u59CB\uFF0C\u656C\u8BF7\u671F\u5F85'
              )
            )
          );
        }
        return content;
      };

      /**
       * @desc 有活动的情况
       */
      var signWrap = function signWrap() {
        return _react2.default.createElement(
          'div',
          null,
          activityData.id && _react2.default.createElement(
            'div',
            { className: 'qiandao-sign' },
            _react2.default.createElement('div', { className: 'signIn-sign-mask',
              style: { display: showSignMask ? 'block' : 'none' },
              onTouchMove: _this2.signInNotMove }),
            (default_style == 1 || default_style == 2) && _react2.default.createElement(
              'div',
              { className: 'signIn-sign-bg',
                style: { background: style_settings.background_image ? "url(" + style_settings.background_image + ") no-repeat center /100% 100%;" : style_settings.background_color
                } },
              _react2.default.createElement(
                'div',
                { className: 'signIn-cur-integral',
                  style: { color: advance.color_style ? advance.color_style.main : "" } },
                '\u5F53\u524D\u79EF\u5206'
              ),
              _react2.default.createElement(
                'div',
                { className: 'signIn-cur-integral-num',
                  style: { color: advance.color_style ? advance.color_style.main : "" } },
                can_use_integral || 0
              ),
              _react2.default.createElement(
                'div',
                { className: 'signIn-integral-record',
                  style: { color: advance.color_style ? advance.color_style.main : "",
                    border: '.01rem solid ' + (advance.color_style ? advance.color_style.main : "#fff")
                  },
                  'data-type': 1,
                  onClick: _this2.signInNavigatorTo },
                '\u79EF\u5206\u8BB0\u5F55'
              )
            ),
            default_style == 3 && _react2.default.createElement(
              'div',
              { style: { paddingBottom: "1.8rem" } },
              _react2.default.createElement(
                'div',
                { className: 'sign-bg3',
                  style: { background: style_settings.background_image ? 'url("' + style_settings.background_image + '") no-repeat center /100% 100%;' : style_settings.background_color
                  } },
                _react2.default.createElement(
                  'div',
                  { className: 'sign-accumulateDays', style: { color: advance.color_style.sign_day } },
                  '\u7D2F\u8BA1\u7B7E\u5230',
                  _react2.default.createElement(
                    'span',
                    { style: { fontSize: ".48rem" } },
                    signedDays
                  ),
                  '\u5929'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'sign-signIn3' },
                  _react2.default.createElement(
                    'form',
                    { style: { margin: "0 auto" } },
                    _react2.default.createElement(
                      'button',
                      { type: 'button',
                        className: 'signIn-signactive',
                        style: { background: advance.color_style ? advance.color_style.main : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                          color: "#4D4338",
                          display: hasSign ? 'none' : 'hidden'
                        },
                        'data-compindex': 0,
                        onClick: _this2.signInSubmit },
                      '\u7B7E\u5230'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-signed',
                        style: { background: advance.color_style ? advance.color_style.main : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                          color: '#4D4338',
                          display: hasSign ? 'flex' : 'none'
                        } },
                      '\u5DF2\u7B7E\u5230'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-box' },
              _react2.default.createElement(
                'div',
                { className: 'signIn-sign-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-sign-info' },
                  _react2.default.createElement(
                    'span',
                    { className: 'signIn-sign-sum' },
                    '\u5DF2\u8FDE\u7EED\u7B7E\u5230',
                    _react2.default.createElement(
                      'span',
                      { style: { color: advance.color_style ? advance.color_style.rule_span : "#F00",
                          margin: '0 .05rem',
                          fontWeight: 'bold'
                        } },
                      continuous_sign
                    ),
                    '\u5929'
                  )
                ),
                showDateArr.length > 1 && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'signIn-sign-progress-box',
                      style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.background, 0.2) : "#fff0b8"
                      } },
                    _react2.default.createElement('div', { className: 'signIn-sign-progress',
                      style: { width: +signInProgressWidth * 0.01 + 'rem',
                        backgroundColor: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "#FF7235" : "#930bd4"
                      } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'signIn-sign-date' },
                    showDateArr.map(function (item) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: item.date },
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-date-item' },
                          item.date === cur_date ? '今天' : item.date,
                          _react2.default.createElement('div', { className: 'signIn-date-dot',
                            style: { backgroundColor: advance.color_style ? advance.color_style.background : default_style === 1 ? "#ffaf52" : "#FFC568"
                            } }),
                          _react2.default.createElement(
                            'div',
                            { className: 'signIn-date-integral',
                              style: { background: advance.color_style ? advance.color_style.background : "linear-gradient(180deg, rgba(255, 223, 32, 1) 0%, rgba(255, 189, 31, 1) 100%)",
                                color: advance.color_style ? advance.color_style.rule : "#674444",
                                display: item.isSign ? 'none' : 'block'
                              } },
                            '+',
                            item.integral,
                            _react2.default.createElement('div', { className: 'signIn-date-triangle',
                              style: { borderTopColor: advance.color_style ? advance.color_style.background : "#ffc61f",
                                display: item.isSign ? 'none' : 'block'
                              } })
                          ),
                          item.isSign && _react2.default.createElement('div', { className: 'signIn-date-signIn',
                            style: { background: 'url(' + (advance ? advance.signed_icons : default_style === 1 ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn.png) no-repeat center/contain" : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn2.png) no-repeat center/contain")
                            } }),
                          (item.accumulatedReward || item.continuousReward) && _react2.default.createElement('div', { className: 'signIn-date-gift',
                            style: { background: 'url(' + (advance ? advance.gift_icons : default_style === 1 ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift.png) no-repeat center/contain" : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift2.png) no-repeat center/contain"),
                              display: item.date === cur_date && hasSign ? 'none' : 'block'
                            } })
                        )
                      );
                    })
                  )
                ),
                showDateArr.length === 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-last-date-box' },
                  _react2.default.createElement('img', { className: 'signIn-lastIcon', src: 'https://cdn.jisuapp.cn/static/webapp/images/retroactive/' + (hasSign ? "signIn.png" : "lastCoin.png") }),
                  _react2.default.createElement(
                    'span',
                    { className: 'signIn-lastTxt', style: { color: hasSign ? "#999" : "#674444" } },
                    hasSign ? "成功完成签到，你真棒" : '+' + showDateArr[showDateArr.length - 1].integral
                  ),
                  _react2.default.createElement('span', { className: 'signIn-lastTxt' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-sign-button' },
                  _react2.default.createElement(
                    'form',
                    { style: { margin: '0 auto' } },
                    _react2.default.createElement(
                      'button',
                      { type: 'button',
                        className: 'signIn-signactive',
                        style: { background: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                          display: hasSign ? 'none' : 'block'
                        },
                        'data-compindex': 0,
                        onClick: _this2.signInSubmit },
                      '\u7B7E\u5230'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-signed',
                        style: { background: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "#ff6c19" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                          display: hasSign ? 'flex' : 'none'
                        } },
                      '\u5DF2\u7B7E\u5230'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-gift-tips' },
                  giftTips_con,
                  giftTips_con && giftTips_acc ? "，" : "",
                  giftTips_acc
                )
              ),
              continuous_notice == 1 && _react2.default.createElement(
                'div',
                { className: 'signIn-sign-remind' },
                _react2.default.createElement(
                  _list2.default,
                  null,
                  _react2.default.createElement(
                    _list2.default.Item,
                    {
                      extra: _react2.default.createElement(_switch2.default, { className: 'switch',
                        color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? '#fe4739' : '#801dfe',
                        checked: continuous_notice_user,
                        onChange: function onChange(e) {
                          return _this2.signInChangeSwitch(e, _this2.props.index);
                        } }) },
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-remind-box' },
                      _react2.default.createElement('div', { className: 'signIn-icon-shalou' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'signIn-remind-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-remind-info-t' },
                          '\u8FDE\u7EED\u7B7E\u5230\u63D0\u9192'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-remind-info-b' },
                          '\u5F00\u542F\u5F00\u5173\uFF0C\u6BCF\u592912:00\u5C06\u4F1A\u4EE5\u6A21\u677F\u6D88\u606F\u65B9\u5F0F\u63D0\u9192'
                        )
                      )
                    )
                  )
                )
              ),
              continuous_array && continuous_array.rewards && continuous_array.rewards.length > 0 && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u8FDE\u7EED\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#FE4739" : "#6240FE",
                      display: continuous_array.kind_limit == 99999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  continuous_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  continuous_array.rewards.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      (item.received || continuous_array.received_times != continuous_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          continuous_array.kind_limit != continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          continuous_array.kind_limit == continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && continuous_array.received_times < continuous_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                padding: 0
                              },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.rule_text, 0.1) : default_style === 1 ? "rgba(255, 240, 219, 1)" : "rgba(128, 29, 254, 0.1)",
                                color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f" : "#6240FE"
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && continuous_array.received_times == continuous_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              ),
              accumulate_array && accumulate_array.rewards && accumulate_array.rewards.length > 0 && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                accumulate_array.accumulate_type == 2 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u5F53\u6708\u7D2F\u8BA1\u7B7E\u5230\u6EE1',
                  accumulate_array.hit_day,
                  '\u5929\u989D\u5916\u5956\u52B1'
                ),
                accumulate_array.accumulate_type == 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u7D2F\u8BA1\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#FE4739" : "#6240FE",
                      display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  accumulate_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  accumulate_array.rewards.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      (item.received || accumulate_array.received_times != accumulate_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          accumulate_array.kind_limit != accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          accumulate_array.kind_limit == accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && accumulate_array.received_times < accumulate_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                padding: 0
                              },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.rule_text, 0.1) : default_style === 1 ? "rgba(255, 240, 219, 1)" : "rgba(128, 29, 254, 0.1)",
                                color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f" : "#6240FE"
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && accumulate_array.received_times >= accumulate_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            default_style == 3 && _react2.default.createElement(
              'div',
              { className: 'signIn-sign-box',
                style: { paddingBottom: continuous_array.rewards.length || accumulate_array.rewards.length ? "1.5rem" : "" } },
              continuous_array.rewards.length && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u8FDE\u7EED\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.main : "",
                      display: continuous_array.kind_limit == 99999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  continuous_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  continuous_array.rewards.map(function (item) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: item.id },
                      (item.received || continuous_array.received_times != continuous_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          continuous_array.kind_limit != continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          continuous_array.kind_limit == _this2.continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && continuous_array.received_times < continuous_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.main : "", padding: 0 },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.main, 0.1) : "",
                                color: advance.color_style ? advance.color_style.main : ""
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: function onClick(e) {
                                return _this2.signInNavigatorTo(e);
                              } },
                            '\u67E5\u770B'
                          ),
                          !item.received && continuous_array.received_times == continuous_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              ),
              accumulate_array.rewards.length && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                accumulate_array.accumulate_type == 2 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u5F53\u6708\u7D2F\u8BA1\u7B7E\u5230\u6EE1',
                  accumulate_array.hit_day,
                  '\u5929\u989D\u5916\u5956\u52B1'
                ),
                accumulate_array.accumulate_type == 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u7D2F\u8BA1\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.main : '',
                      display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  accumulate_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  accumulate_array.rewards.map(function (item) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: item.id },
                      (item.received || accumulate_array.received_times != accumulate_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          accumulate_array.kind_limit != accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          accumulate_array.kind_limit == accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && accumulate_array.received_times < accumulate_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.main : '', padding: 0 },
                              'data-type': item.type,
                              'data-method': 3,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.main, 0.1) : '',
                                color: advance.color_style ? advance.color_style.main : ''
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && accumulate_array.received_times >= accumulate_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            successWrap()
          )
        );
      };

      var successWrap = function successWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'signIn-sign-success',
            onTouchMove: _this2.signInNotMove,
            style: { display: showSignSus ? 'block' : 'none' } },
          _react2.default.createElement('div', { className: 'signIn-sign-success-bg' }),
          _react2.default.createElement(
            'div',
            { className: 'signIn-sign-success-box' },
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-success-tip' },
              successTips
            ),
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-success-btn signIn-index',
                'data-compindex': _this2.props.index,
                onClick: _this2.signInSusClose },
              '\u786E\u5B9A'
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component sign-in' },
        activityNoStart(),
        signWrap()
      );
    }
  }]);
  return SignIn;
}(_OfficialPage3.default);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    eles: []
  };

  this.init = function (compindex, pageInstance) {
    _app.appMethod.getStorage({
      'key': 'activityData',
      success: function success(res) {
        if (res.data) {
          _this3.signInExtraRewards(compindex, pageInstance, Number(res && res.data && res.data.id));
        }
      }
    });
    _this3.signInGetActivity(compindex, pageInstance);
  };

  this.signInGetActivity = function (compindex, pageInstance) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetEffectActivity',
      data: {},
      success: function success(res) {
        _app.appMethod.setStorage({
          key: 'activityData',
          data: res.data
        });
        var start_time = new Date(res.data.start_time * 1000).toLocaleDateString();
        var end_time = new Date(res.data.end_time * 1000).toLocaleDateString();
        var activityData = res.data;
        var style_settings = res.data.style_settings;
        var advance = res.data.style_settings.advance || '';
        var cur_date = _util2.default.formatTimeYMD('', 'MM.DD'); // 获取当前时间
        newData['eles[' + compindex + '].start_time'] = start_time;
        newData['eles[' + compindex + '].end_time'] = end_time;
        newData['eles[' + compindex + '].cur_date'] = cur_date;
        newData['eles[' + compindex + '].sign_type'] = res.data.sign_type;
        newData['eles[' + compindex + '].continuous_notice'] = res.data.continuous_notice;
        newData['eles[' + compindex + '].activity_id'] = Number(res.data.id);
        newData['eles[' + compindex + '].activityData'] = activityData;
        newData['eles[' + compindex + '].style_settings'] = style_settings;
        newData['eles[' + compindex + '].default_style'] = style_settings.default_style;
        newData['eles[' + compindex + '].advance'] = advance;
        newData['eles[' + compindex + '].isLoading'] = false;

        newData['eles[' + compindex + '].showDateArr'] = [];
        newData['eles[' + compindex + '].sendFormIdTimes'] = 0;
        newData['eles[' + compindex + '].showGetRetroModal'] = false;
        newData['eles[' + compindex + '].showSignMask'] = false;
        newData['eles[' + compindex + '].showSignSus'] = false;
        newData['eles[' + compindex + '].showExchangeModal'] = false;
        newData['eles[' + compindex + '].timer'] = null;

        pageInstance.setData(newData);
        _this3.signInGetContinuousDay(compindex, pageInstance); // 连续签到日期
        _this3.signInExtraRewards(compindex, pageInstance); // 查看可领额外奖励
        _this3.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        if (res.data.continuous_notice === '1') {
          _this3.signInGetUserNotice(compindex, pageInstance); // 查询用户连续签到提醒设置
        }
      },
      successStatusAbnormal: function successStatusAbnormal() {
        newData['eles[' + compindex + '].nodata'] = true;
        pageInstance.setData(newData);
        return false;
      }
    });
  };

  this.signInGetContinuousDay = function (compindex, pageInstance) {
    var newData = {};
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetContinuousDay',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_sign'] = res.data.continuous_sign;
        pageInstance.setData(newData);
        _this3.signInDateIsSign(compindex, pageInstance); // 判断今日是否签到
      }
    });
  };

  this.signInExtraRewards = function (compindex, pageInstance, id) {
    var newData = {};
    var activity_id = id || pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetExtraRewards',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_array'] = res.data.continuous;
        newData['eles[' + compindex + '].accumulate_array'] = res.data.accumulate;
        pageInstance.setData(newData);
      },
      successStatusAbnormal: function successStatusAbnormal() {
        return false;
      }
    });
  };

  this.signInGetUserNotice = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetUserNoticeSwitch',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_notice_user'] = res.data == 0 ? false : true;
        pageInstance.setData(newData);
      },
      successStatusAbnormal: function successStatusAbnormal() {
        return false;
      }
    });
  };

  this.signInDateIsSign = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/DateIsSign',
      data: {
        activity_id: activity_id,
        sign_date: new Date().toDateString()
      },
      success: function success(res) {
        var newData = {};
        if (res.data.is_sign) {
          newData['eles[' + compindex + '].hasSign'] = true;
          pageInstance.setData(newData);
        } else if (pageInstance.data.eles[compindex].sign_type == 2) {
          // 开启极速签到 
          _this3.signIn(compindex, pageInstance, '');
        }
        _this3.getTimeLength(compindex, pageInstance);
      }
    });
  };

  this.signIn = function (compindex, pageInstance, form_id) {
    var width = 0;
    var newData = {};
    var sign_type = pageInstance.data.eles[compindex].sign_type;
    var cur_date = pageInstance.data.eles[compindex].cur_date;
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var hasSign = pageInstance.data.eles[compindex].hasSign;
    var showDateArr = [].concat((0, _toConsumableArray3.default)(pageInstance.data.eles[compindex].showDateArr));
    var isLoading = pageInstance.data.eles[compindex].isLoading; // false
    if (isLoading) return;
    newData['eles[' + compindex + '].isLoading'] = true;
    pageInstance.setData(newData);
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/SignIn',
      method: 'post',
      data: {
        activity_id: activity_id,
        homepageRouter: 'pages/' + _app.appMethod.globalData.homepageRouter + '/' + _app.appMethod.globalData.homepageRouter,
        form_id: form_id
      },
      success: function success(res) {
        for (var i = 0; i < showDateArr.length; i++) {
          if (showDateArr[i].date === cur_date) {
            showDateArr[i].isSign = true;
            // 展示数组的总宽度是 630 去掉前端和后端 应为540 
            if (!hasSign && i === 0) {
              width = 20;
            } else {
              width = i / (showDateArr.length - 1) * 540 + 60;
            }
            newData['eles[' + compindex + '].signInProgressWidth'] = width;
          }
        }
        newData['eles[' + compindex + '].hasSign'] = true;
        newData['eles[' + compindex + '].showDateArr'] = showDateArr;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].successTips'] = sign_type == 2 ? '极速签到成功' : '签到成功';
        pageInstance.setData(newData, function () {
          _this3.signInRewardCheck(compindex, pageInstance); // 获取每日额外奖励
          _this3.signInExtraRewards(compindex, pageInstance); //  查看可额外领取的奖励
          _this3.signInGetSignedDates(compindex, pageInstance); // 查询所有已签到的日期
          _this3.signInGetContinuousDay(compindex, pageInstance); // 获取已连续签到的天数
          _this3.signInCloseSignModal(compindex, pageInstance); // 关闭弹窗
          _this3.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        });
      },
      complete: function complete(res) {}
    });
  };

  this.getTimeLength = function (compindex, pageInstance) {
    // 拿到今天的日期，连续签到的天数,
    var st = new Date();
    var et = new Date();
    var day1 = pageInstance.data.eles[compindex].start_time;
    var day2 = pageInstance.data.eles[compindex].end_time;
    var continuous_sign = pageInstance.data.eles[compindex].continuous_sign;
    var hasSign = pageInstance.data.eles[compindex].hasSign;
    // 若连续签到为7天的倍数  开始时间则为今天
    if (continuous_sign % 7 == 0 && !hasSign) {} else {
      // 否则开始时间则往前算连续签到的天数 取余
      continuous_sign = hasSign ? continuous_sign - 1 : continuous_sign;
      st = new Date(st.getTime() - continuous_sign % 7 * 24 * 60 * 60 * 1000);
    }
    // 时间轴长度
    var date_length = Math.floor((new Date(day2).getTime() - st.getTime()) / (24 * 60 * 60 * 1000)) + 1;
    if (date_length >= 7) {
      et = _util2.default.formatTimeYMD(new Date(st.getTime() + 6 * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD');
    } else {
      et = _util2.default.formatTimeYMD(new Date(st.getTime() + date_length * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD');
    }
    st = _util2.default.formatTimeYMD(st, 'YYYY/MM/DD');
    var dateArr = _this3.signInGetDays(st, et);
    var newData = {};
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    pageInstance.setData(newData);
    _this3.signInRewardCheck(compindex, pageInstance); // 查询每日奖励
  };

  this.signInGetDays = function (day1, day2) {
    var st = new Date(day1);
    var et = new Date(day2);
    var arr = [];
    // 获取开始的日期 (年，月，日)
    var yyyy = st.getFullYear(),
        mm = st.getMonth(),
        dd = st.getDate();
    // 循环
    while (st.getTime() <= et.getTime()) {
      arr.push(_util2.default.formatNumber(st.getMonth() + 1) + '.' + _util2.default.formatNumber(st.getDate()));
      // 使用dd++进行天数的自增
      st = new Date(yyyy, mm, ++dd);
    };
    var brr = arr.map(function (item, index) {
      return {
        isSign: false,
        date: item
      };
    });
    return brr;
  };

  this.signInRewardCheck = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var dateArr = pageInstance.data.eles[compindex].dateArr;
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/DaysRewards',
      data: {
        'activity_id': activity_id,
        'days': dateArr.length
      },
      success: function success(res) {
        for (var i = 0; i < dateArr.length; i++) {
          for (var j = 0; j < res.data.length; j++) {
            // 获取当日日期
            if (_util2.default.formatTimeYMD(res.data[j].timestamps, 'MM.DD') == dateArr[i].date) {
              dateArr[i].accumulatedReward = res.data[j].accumulatedReward;
              dateArr[i].continuousReward = res.data[j].continuousReward;
              dateArr[i].integral = res.data[j].integral;
            }
          }
        }
        newData['eles[' + compindex + '].giftTips_con'] = res.continuous_str;
        newData['eles[' + compindex + '].giftTips_acc'] = res.accumulated_str;
        newData['eles[' + compindex + '].dateArr'] = [].concat((0, _toConsumableArray3.default)(dateArr));
        pageInstance.setData(newData);
        _this3.signInGetSignedDates(compindex, pageInstance, _this3.signInFn); // 查询所有已签到的日期
      }
    });
  };

  this.signInGetSignedDates = function (compindex, pageInstance, fn) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetSignedDates',
      data: {
        activity_id: activity_id,
        include_today: 1
      },
      success: function success(res) {
        typeof fn == 'function' && fn(compindex, pageInstance, res.data);
      }
    });
  };

  this.signInCloseSignModal = function (compindex, pageInstance) {
    clearTimeout(pageInstance.data.eles[compindex].timer);
    pageInstance.data.eles[compindex].timer = setTimeout(function () {
      _this3.signInGetIntegral(compindex, pageInstance);
    }, 3000);
  };

  this.signInGetIntegral = function (compindex, pageInstance) {
    var newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  };

  this.signInGetIntegralInfo = function (compindex, pageInstance) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      data: {},
      success: function success(res) {
        newData['eles[' + compindex + '].can_use_integral'] = res.data.can_use_integral;
        pageInstance.setData(newData);
        console.log(pageInstance);
      }
    });
  };

  this.signInFn = function (compindex, pageInstance, opt) {
    var dateArr = pageInstance.data.eles[compindex].dateArr;

    var cur_date = pageInstance.data.eles[compindex].cur_date;
    var hasSign = pageInstance.data.eles[compindex].hasSign;

    var newArray = opt.map(function (item) {
      return _util2.default.formatTimeYMD(item, 'MM.DD');
    });

    for (var i = 0; i < dateArr.length; i++) {
      for (var j = 0; j < newArray.length; j++) {
        if (dateArr[i].date === newArray[j]) {
          dateArr[i].isSign = true;
        }
      }
    }

    var showDateArr = dateArr;
    var newData = {};
    var width = 0;
    // 设置进度条长度
    for (var k = 0; k < showDateArr.length; k++) {
      if (showDateArr[k].date === cur_date) {
        // 展示数组的总宽度是 630 去掉前端和后端 应为540 
        if (!hasSign && k === 0) {
          width = 20;
        } else {
          width = k / (showDateArr.length - 1) * 540 + 60;
        }
        newData['eles[' + compindex + '].signInProgressWidth'] = width;
      }
    }
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    newData['eles[' + compindex + '].showDateArr'] = showDateArr;
    newData['eles[' + compindex + '].signedDays'] = opt.length;
    pageInstance.setData(newData);
  };

  this.signInNotMove = function (e) {};

  this.signInNavigatorTo = function (e) {
    var type = e.currentTarget.dataset.type.toString();
    var url = '';
    switch (type) {
      case '1':
        url = '/userCenter/pages/myIntegral/myIntegral';
        break;
      case '2':
        url = '/eCommerce/pages/balance/balance';
        break;
      case '3':
        url = '/eCommerce/pages/couponList/couponList';
        break;
      case '4':
        var detail = e.target.dataset.detail;
        url = '/eCommerce/pages/vipCard/vipCard?is_paid_vip=1&detail=' + detail;
        break;
      case '5':
        var start_time = e.target.dataset.start;
        var end_time = e.target.dataset.end;
        url = '/signIn/pages/calendar/calendar' + '?start_time=' + start_time + '&end_time=' + end_time;
        break;
      case '6':
        url = '/signIn/pages/retroactive/retroactive';
        break;
      case '7':
        url = '/signIn/pages/rule/rule';
        break;
    }
    _app.appMethod.turnToPage(url, false);
  };

  this.signInSubmit = function (e) {
    // TODO
    // let form_id = e.detail.formId || '';
    var form_id = '';
    var compindex = e.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();

    _this3.signIn(compindex, pageInstance, form_id);
    _this3.signInSendForm(compindex, pageInstance, form_id);
  };

  this.signInSendForm = function (compindex, pageInstance, form_id) {
    var sendFormIdTimes = pageInstance.data.eles[compindex].sendFormIdTimes;
    var newData = {};
    if (sendFormIdTimes === 0) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function success(res) {
          newData['eles[' + compindex + '].sendFormIdTimes'] = 2;
          pageInstance.setData(newData);
        }
      });
    }
  };

  this.signInChangeSwitch = function (checked, compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    // TODO
    // let checked = e.target.value;
    var newData = {};
    newData['eles[' + compindex + '].continuous_notice_user'] = checked;
    pageInstance.setData(newData);
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/SignNoticeSwitch',
      data: {
        'activity_id': activity_id,
        'switch': checked ? 1 : 0
      },
      success: function success(res) {
        if (res.status !== 0) {
          newData['eles[' + compindex + '].continuous_notice_user'] = !checked;
          pageInstance.setData(newData);
        }
      }
    });
  };

  this.signInReceiveExtReward = function (e) {
    // TODO
    // let form_id = e.detail.formId;
    var form_id = '';
    var type = e.currentTarget.dataset.type;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var method = e.currentTarget.dataset.method;
    _this3.signInGetReward(compindex, pageInstance, form_id, type, method);
  };

  this.signInSusClose = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.target.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  };

  this.signInGetReward = function (compindex, pageInstance, form_id, type, method) {
    var newData = {};
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/ReceiveExtraReward',
      data: {
        activity_id: activity_id,
        reward_type: type,
        received_method: method,
        form_id: form_id
      },
      success: function success(res) {
        switch (type) {
          case 1:
            type = '积分';
            break;
          case 2:
            type = '储值';
            break;
          case 3:
            type = '优惠券';
            break;
          case 4:
            type = '会员卡';
            break;
        }
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].successTips'] = type + '领取成功';
        pageInstance.setData(newData);
        _this3.signInExtraRewards(compindex, pageInstance); // 查看
        if (type == '积分') {
          _this3.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        }
      },
      successStatusAbnormal: function successStatusAbnormal() {
        _app.appMethod.showToast({
          title: '库存不足',
          icon: 'none',
          duration: 1500
        });
        return false;
      }
    });
    _this3.signInCloseSignModal(compindex, pageInstance);
  };

  this.getRgbColor = function (sHex) {
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    arr = [sHex.substring(1, 3), sHex.substring(3, 5), sHex.substring(5)];
    brr = arr.map(function (item, index) {
      return parseInt(item, 16);
    });
    return 'rgba(' + brr.join(',') + ',' + alpha + ')';
  };
};

exports.default = SignIn;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(712);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RechargeGpt = function (_OfficialPage) {
  (0, _inherits3.default)(RechargeGpt, _OfficialPage);

  function RechargeGpt(props) {
    (0, _classCallCheck3.default)(this, RechargeGpt);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RechargeGpt.__proto__ || Object.getPrototypeOf(RechargeGpt)).call(this, props));

    _this.state = {
      isWeiXinBrowser: false,
      userInfo: _app.appMethod.getUserInfo(),
      canUseIntegral: 0,
      userVipCardInfo: null, //会员信息
      integralList: [],
      vipList: [],
      selectId: '',
      selectPrice: null,
      comboid: '',
      shouldPayPrice: 0,
      timer: null,
      orderId: '',
      type: null, // 1:积分，2：会员
      isPaying: true
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        data: {
          card_type: 2
        },
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              userVipCardInfo: res.data.user_paid_vip_card,
              vipList: res.data.all_vip_card
            });
          }
        }
      });
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          that.setState({
            canUseIntegral: res.data.can_use_integral
          });
        }
      });
    };

    _this.goBack = function () {
      _app.appMethod.turnBack();
    };

    _this.getIntegralLit = function () {
      var that = _this;
      var param = {
        app_id: _app.appMethod.getAppId()
      };
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetChatIntegralConfigList',
        data: param,
        hideLoading: true,
        success: function success(res) {
          if (res.data.length != 0) {
            that.setData({
              integralList: res.data
            });
          }
        }
      });
    };

    _this.selectItem = function (event) {
      var that = _this;
      var id = event ? event.currentTarget.dataset.id : that.state.selectId;
      var type = event ? event.currentTarget.dataset.type : that.state.type;
      var price = event ? event.currentTarget.dataset.price : that.state.selectPrice;
      var comboid = type == 2 ? event.currentTarget.dataset.comboid : '';
      _this.setData({
        selectId: id,
        selectPrice: price,
        shouldPayPrice: price,
        type: type,
        comboid: comboid,
        isPaying: false
      });
    };

    _this.gotoRechargeIntegral = function () {
      var that = _this;
      var param = {
        app_id: _app.appMethod.getAppId(),
        integral_config_id: +_this.state.selectId,
        goods_type: 17
      };
      if (that.state.isPaying) {
        return;
      }
      _this.setIsPaying(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/CreateOrder',
        data: param,
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          var orderId = res.data;
          _app.appMethod.goPay({
            orderId: orderId,
            successUrl: '/gptIndex'
          });
        },
        fail: function fail() {
          that.setIsPaying(false);
        },
        complete: function complete() {
          that.setIsPaying(false);
        }
      });
    };

    _this.gotoRechargeVip = function () {
      var that = _this;
      var param = {
        app_id: _app.appMethod.getAppId(),
        data_id: +_this.state.selectId,
        price: +_this.state.selectPrice,
        combo_id: _this.state.comboid
      };
      if (that.state.isPaying) {
        return;
      }
      _this.setIsPaying(true);
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/addPaidVipCardOrder',
        data: param,
        hideLoading: true,
        method: 'POST',
        success: function success(res) {
          var orderId = res.data;
          _app.appMethod.goPay({
            orderId: orderId,
            successUrl: '/gptIndex'
          });
        },
        fail: function fail() {
          that.setIsPaying(false);
        },
        complete: function complete() {
          that.setIsPaying(false);
        }
      });
    };

    _this.setIsPaying = function (bool) {
      _this.setData({
        isPaying: bool
      });
    };

    document.title = '充值中心';
    if (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger') {
      _this.state.isWeiXinBrowser = true;
    }
    return _this;
  }

  (0, _createClass3.default)(RechargeGpt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      _app.appMethod.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin();
        return;
      }

      this.getIntegralDetailData();
      this.getVipInfo();
      this.getIntegralLit();
    }
    // 获取会员信息

    // 获取积分详情


    // 获取AI积分配置


    // 去充值积分


    // 去充值会员卡


    // 设置是否在付款中

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          isWeiXinBrowser = _state.isWeiXinBrowser,
          canUseIntegral = _state.canUseIntegral,
          userInfo = _state.userInfo,
          userVipCardInfo = _state.userVipCardInfo,
          integralList = _state.integralList,
          vipList = _state.vipList,
          selectId = _state.selectId,
          type = _state.type,
          shouldPayPrice = _state.shouldPayPrice,
          isPaying = _state.isPaying;

      return _react2.default.createElement(
        'div',
        { className: 'recharge_page' },
        !isWeiXinBrowser && _react2.default.createElement(
          'div',
          { className: 'nav' },
          _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png', alt: 'back', onClick: this.goBack }),
          _react2.default.createElement(
            'div',
            null,
            '\u5145\u503C\u4E2D\u5FC3'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: isWeiXinBrowser ? 'head_box' : 'head_box mar_t6vh' },
          _react2.default.createElement(
            'div',
            { className: 'head' },
            _react2.default.createElement('img', { className: 'headimg', src: userInfo.cover_thumb ? userInfo.cover_thumb : 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' }),
            _react2.default.createElement(
              'div',
              { className: 'head_con' },
              _react2.default.createElement(
                'div',
                { className: 'row' },
                _react2.default.createElement(
                  'div',
                  null,
                  userInfo.phone
                ),
                vipList.length > 0 && _react2.default.createElement(
                  'div',
                  { className: 'vipimg_box' },
                  _react2.default.createElement('img', { className: 'vipimg',
                    src: !userVipCardInfo ? "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/novip.png" : "https://cdn.jisuapp.cn/static/webapp/images/chatgpt/viplog2.png" })
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u79EF\u5206\uFF1A',
                canUseIntegral
              )
            )
          )
        ),
        integralList.length != 0 && _react2.default.createElement(
          'div',
          { className: 'item_box mar_b8' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item5.png' }),
            _react2.default.createElement(
              'div',
              null,
              '\u79EF\u5206\u5145\u503C'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            integralList.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: selectId == item.id && type == 1 ? 'item active' : 'item', key: index, onClick: _this2.selectItem, 'data-type': 1, 'data-id': item.id, 'data-price': item.price },
                _react2.default.createElement(
                  'div',
                  { className: 'line1' },
                  _react2.default.createElement(
                    'span',
                    null,
                    Number(item.num)
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u79EF\u5206'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line2' },
                  item.price,
                  '\u5143'
                )
              );
            })
          )
        ),
        vipList.length != 0 && _react2.default.createElement(
          'div',
          { className: 'item_box' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/item4.png' }),
            _react2.default.createElement(
              'div',
              null,
              '\u9009\u62E9VIP\u5957\u9910'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            vipList.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: selectId == item.id && type == 2 ? 'item rech_item active' : 'item rech_item', key: index, onClick: _this2.selectItem, 'data-type': 2, 'data-comboid': item.combo[0].id, 'data-id': item.id, 'data-price': item.combo[0].price },
                _react2.default.createElement(
                  'div',
                  { className: 'line3 txt-line-1' },
                  item.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line4' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\uFFE5'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.combo[0].price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line5' },
                  '\u539F\u4EF7\uFFE5',
                  item.price
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'line6' },
                  (item.combo[0].price / 30).toFixed(2),
                  '\u5143/\u5929'
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'footer' },
          _react2.default.createElement(
            'div',
            { className: 'info' },
            _react2.default.createElement(
              'div',
              { className: 'total' },
              '\u5408\u8BA1:\uFFE5',
              _react2.default.createElement(
                'span',
                null,
                selectId ? shouldPayPrice : '-'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'agree' },
              '\u652F\u4ED8\u89C6\u4E3A\u60A8\u540C\u610F',
              _react2.default.createElement(
                'span',
                null,
                '\u300A',
                _react2.default.createElement(
                  'a',
                  { target: '_blank', href: 'http://bbs.zhichiwangluo.com/forum.php?mod=viewthread&tid=11189&page=1&extra=#pid12695' },
                  '\u54AB\u5C3A\u652F\u4ED8\u534F\u8BAE'
                ),
                '\u300B'
              )
            )
          ),
          _react2.default.createElement(
            'button',
            { className: !isPaying ? 'paybtn' : 'paybtn nopaybtn', onClick: type == 1 ? this.gotoRechargeIntegral : this.gotoRechargeVip },
            '\u7ACB\u5373\u652F\u4ED8'
          )
        )
      );
    }
  }]);
  return RechargeGpt;
}(_OfficialPage3.default);

exports.default = RechargeGpt;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _regenerator = __webpack_require__(82);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(83);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(714);

var _TextAnimation = __webpack_require__(143);

var _TextAnimation2 = _interopRequireDefault(_TextAnimation);

var _tools = __webpack_require__(6);

var _Dialog = __webpack_require__(84);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _cryptoJs = __webpack_require__(145);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _indexUmd = __webpack_require__(148);

var _indexUmd2 = _interopRequireDefault(_indexUmd);

var _LoginPage = __webpack_require__(92);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _html2canvas = __webpack_require__(149);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4'
};
var APPID = "2dcb30a7";
var API_SECRET = "Mzg2ZmYzNDIyZGQ1M2MzMDU4OWY5Yzc1";
var API_KEY = "9449a5280ed944fa8f53b23d5c1e90fd";

var AudioTest = function (_OfficialPage) {
  (0, _inherits3.default)(AudioTest, _OfficialPage);

  function AudioTest(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, AudioTest);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AudioTest.__proto__ || Object.getPrototypeOf(AudioTest)).call(this, props));

    _this.countdownInterval = null;
    _this.recorder = null;
    _this.iatWS = null;
    _this.state = {
      canUseIntegral: 0,
      userVipCardInfo: null,
      historyNum: 0,
      roleList: [{
        role_id: 0,
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }],
      roleListAll: [],
      selectedRoleId: '',
      switchSelectedRoleId: '',
      sessionId: '', //会话id
      dialogueList: [],
      is_more: 0,
      current_page: 1,
      content: '', //提问内容
      is_audio: 0, //提问方式   0打字提问 1语音提问
      shareKey: '',
      sharePoliteData: {},
      isWeiXinBrowser: false,
      isSub: false,
      isShowAllRole: false,
      searchValue: '',
      modalType: 0, // 模型
      modalName: 'GPT-3.5', // 模型名称
      modalId: '',
      modalList: [],
      isShowModalConfig: false,

      // 录音相关数据
      isAudio: true, // 是否切换为录音
      isRecording: false, // 正在录音
      // iatWS:null, //websocket
      resultText: '', // 文字结果
      resultTextTemp: '', // 文字修正结果
      // countdownInterval:null, // 时间计数器
      seconds: 60, // 倒计时
      recordInterrupt: false,
      // recorder:null,

      maskShow: false,
      isShare: false, // 正在分享
      shareDialogList: [], // 选择分享的内容
      lastDialogId: 0,
      shareImgUrl: ''
    };

    _this.getVipInfo = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=appVipCard/getUserAccountSurvey',
        hideLoading: true,
        success: function success(res) {
          if (res.status == 0) {
            that.setState({
              userVipCardInfo: res.data.user_paid_vip_card
            });
          }
        }
      });
    };

    _this.getIntegralDetailData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/GetIntegralInfo',
        success: function success(res) {
          that.setState({
            canUseIntegral: res.data.can_use_integral
          });
        }
      });
    };

    _this.getHistoryList = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/SessionList',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: -1,
          page_size: 1
        },
        method: 'POST',
        success: function success(res) {
          that.setData({
            historyNum: res.data.length
          });
        }
      });
    };

    _this.getSessionList = function () {
      _app.appMethod.showLoading({
        title: '加载中..'
      });
      var that = _this;
      // 初始化 
      var currentSessionId = '';
      var currentRoleId = '';
      _app.appMethod.sendRequest({
        url: '/index.php?r=ChatAI/GetRole',
        data: {
          app_id: _app.appMethod.getAppId(),
          page: 1,
          page_size: 5
        },
        method: 'POST',
        success: function success(res) {
          if (res.data.length != 0) {
            _app.appMethod.hideLoading();
            var user_roles = res.data.user_roles || [];
            var roleList = [].concat((0, _toConsumableArray3.default)(that.data.roleList), (0, _toConsumableArray3.default)(user_roles), (0, _toConsumableArray3.default)(res.data.system_role));
            roleList.forEach(function (item) {
              if (item.id) {
                item.role_id = item.id;
              }
              if (item.title) {
                item.role_name = item.title;
              }
              if (item.is_default == '1') {
                //设置了默认对话时
                currentRoleId = item.id;
              }
            });
            that.setData({
              roleList: roleList,
              roleListAll: roleList
            });
            // 从入口页历史对话进入
            if (that.data.sessionId && that.data.selectedRoleId) {
              currentSessionId = that.data.sessionId;
              currentRoleId = that.data.selectedRoleId;
            } else {
              // 获取历史当前打开的历史对话页
              var getSt = _app.appMethod.getStorageSync('nowSessionData');
              if (getSt) {
                currentSessionId = getSt.sessionId;
                currentRoleId = that.data.roleList.filter(function (item) {
                  return item.role_id == getSt.roleId;
                })[0].role_id;
              }
            }
            that.setData({
              sessionId: currentSessionId,
              selectedRoleId: currentRoleId,
              switchSelectedRoleId: currentRoleId
            });
            if (currentSessionId) {
              that.getSessionHistory({
                session_id: currentSessionId,
                page: that.data.current_page
              });
            }
          }
        }
      });
    };

    _this.creatSession = function (id) {
      var that = _this;
      return new Promise(function (resolve, reject) {
        var parms = {
          app_id: _app.appMethod.getAppId()
        };
        if (id) {
          parms['role_play_id'] = id;
        }
        _app.appMethod.sendRequest({
          url: '/index.php?r=ChatAI/CreateSession',
          data: parms,
          hideLoading: true,
          method: 'POST',
          complete: function complete(res) {
            if (res.status == 0) {
              _app.appMethod.setStorage({
                key: 'nowSessionData',
                data: {
                  sessionId: res.data,
                  roleId: id ? id : 0
                }
              });
              that.setData({
                sessionId: res.data
              });
              resolve(res.data);
            } else {
              reject();
            }
          }
        });
      });
    };

    _this.selectActiveItem = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      if (_this.state.historyNum >= 5 && !_this.state.userVipCardInfo) {
        _toast2.default.info('会话已达上限，请删除重新创建或开通会员');
        return;
      }
      var session = that.data.roleList.filter(function (item) {
        return item.role_id == id || item.id == id;
      })[0];
      var title = session.role_name || session.title;
      _Dialog2.default.showModal({
        title: '是否切换对话角色为' + title,
        confirm: function confirm() {
          that.setData({
            selectedRoleId: session.role_id,
            dialogueList: [],
            is_more: 0,
            isShowAllRole: false,
            searchValue: '',
            roleListAll: that.data.roleList,
            switchSelectedRoleId: session.role_id
          });
          if (id == 0 || id == '0') {
            //普通会话
            _app.appMethod.removeStorage({ key: 'nowSessionData' });
            that.creatSession();
            return;
          }
          that.creatSession(id);
        }
      });
    };

    _this.bindTextInput = function (event) {
      var val = event.target.value;
      if (val) {
        _this.setData({
          isSub: true
        });
      } else {
        _this.setData({
          isSub: false
        });
      }
      _this.setData({
        'content': val
      });
    };

    _this.getSessionHistory = function (option) {
      var ismore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var hideloading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      return new Promise(function (resovle) {
        var _app$sendRequest;

        var diaArr = _this.state.dialogueList;
        var that = _this;
        _app.appMethod.showLoading({
          title: '加载中..'
        });
        _app.appMethod.sendRequest((_app$sendRequest = {
          hideLoading: true,
          url: '/index.php?r=ChatAI/SessionChatList'
        }, (0, _defineProperty3.default)(_app$sendRequest, 'hideLoading', hideloading), (0, _defineProperty3.default)(_app$sendRequest, 'method', 'POST'), (0, _defineProperty3.default)(_app$sendRequest, 'data', (0, _extends3.default)({
          app_id: _app.appMethod.getAppId(),
          page_size: 20
        }, option)), (0, _defineProperty3.default)(_app$sendRequest, 'success', function success(res) {
          if (res.status == 0) {
            if (res.data.length) {
              resovle(res.data[0].id);
            }
            if (ismore) {
              // 从顶部插入
              var data = res.data.reverse();
              for (var j = data.length - 1; j >= 0; j--) {
                diaArr.unshift({
                  text: data[j].content,
                  direction: data[j].role == '0' ? 'ques' : 'reply',
                  id: data[j].id,
                  isHistory: true,
                  is_audio: data[j].is_audio
                });
              }
            } else {
              for (var i = res.data.length - 1; i >= 0; i--) {
                diaArr.push({
                  text: res.data[i].content,
                  direction: res.data[i].role == '0' ? 'ques' : 'reply',
                  id: res.data[i].id,
                  isHistory: true,
                  is_audio: res.data[i].is_audio
                });
              }
            }
            that.setData({
              dialogueList: diaArr,
              is_more: res.is_more,
              current_page: res.current_page || 1
            });
            var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
            // 聊天记录聚焦最新会话 
            if (!ismore) {
              dialogEle.scrollTop = dialogEle.scrollHeight;
            }
          }
        }), _app$sendRequest));
      });
    };

    _this.getMore = function () {
      _this.getSessionHistory({
        session_id: _this.data.sessionId,
        page: _this.data.current_page + 1
      }, true);
    };

    _this.goQuestion = function (option) {
      var that = _this;
      var diaArr = _this.state.dialogueList;
      var oldId = diaArr.length && Number(diaArr[diaArr.length - 1].id) || 0; // 暂存最后对话的id,没有就对话时赋值0
      if (_this.state.canUseIntegral < 2) {
        _Dialog2.default.showModal({
          title: '积分不足，请先购买会员或积分',
          confirm: function confirm() {
            _app.appMethod.turnToPage('gptrecharge');
          }
        });
        return;
      }
      diaArr.push({
        text: that.data.content,
        direction: 'ques',
        // id: new Date().getTime(),
        id: diaArr.at(-1).id + 1,
        isLoading: true,
        is_audio: that.data.is_audio
      });
      that.setData({
        dialogueList: diaArr,
        content: ''
      });
      var dialogEle = _reactDom2.default.findDOMNode(that.myRef.current);
      var scrollTimer = setTimeout(function () {
        dialogEle.scrollTop = dialogEle.scrollHeight;
        clearTimeout(scrollTimer);
      });
      _app.appMethod.sendRequest({
        hideLoading: true,
        hideModal: true,
        url: '/index.php?r=ChatAI/AskQues',
        timeout: 40000,
        method: 'POST',
        data: (0, _extends3.default)({
          app_id: _app.appMethod.getAppId()
        }, option),
        complete: function complete(res) {
          if (!res && oldId) {
            // 请求超时时，轮询获取聊天记录
            var getNewTimer = setInterval(function () {
              that.getSessionHistory({
                session_id: that.data.sessionId,
                page: 1
              }, false, true).then(function (newId) {
                if (Number(newId) > oldId) {
                  clearInterval(getNewTimer);
                }
              });
            }, 3000);
          } else {
            if (res.status == 0 && res.data.response) {
              diaArr[diaArr.length - 1].isLoading = false;
              diaArr.push({
                text: res.data.response,
                direction: 'reply',
                // id: res.data.id // 这里的设置有点奇怪，接口返回的数据没有id
                id: diaArr.at(-1).id + 1,
                is_audio: that.data.is_audio
              });
              that.setData({
                dialogueList: diaArr
              });
            } else {
              diaArr[diaArr.length - 1].isLoading = false;
              diaArr[diaArr.length - 1].err = true;
              _Dialog2.default.showModal({
                title: '对话异常' + res.data,
                confirm: function confirm() {}
              });
            }
          }
          that.setData({
            content: '',
            is_audio: 0
          });
          scrollTimer = setTimeout(function () {
            dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
            clearTimeout(scrollTimer);
          });
        }
      });
    };

    _this.askQuestions = function () {
      var _this$state = _this.state,
          content = _this$state.content,
          sessionId = _this$state.sessionId,
          is_audio = _this$state.is_audio;

      var that = _this;
      if (content == '') {
        _toast2.default.info('来说点什么吧');
        return;
      }
      if (_this.state.historyNum >= 5 && !_this.state.userVipCardInfo) {
        _toast2.default.info('会话已达上限，请删除重新创建或开通会员');
        return;
      }
      if (sessionId == '' || sessionId == 0) {
        that.creatSession().then(function (id) {
          that.goQuestion({
            session_id: id,
            question: content,
            type: that.state.modalType,
            is_audio: is_audio
          });
        });
      } else {
        that.goQuestion({
          session_id: sessionId,
          question: content,
          type: that.state.modalType,
          is_audio: is_audio
        });
      }
    };

    _this.goBack = function () {
      // app.turnBack();
      _app.appMethod.turnToPage('jisugpt');
    };

    _this.toPage = function () {
      _app.appMethod.turnToPage('signin');
    };

    _this.toPage2 = function () {
      _app.appMethod.turnToPage('myIntegral?from=userCenterEle');
    };

    _this.shareClickEvent = function () {
      var that = _this;
      var sharePoliteData = _this.data.sharePoliteData;
      _app.appMethod.showModal({
        content: sharePoliteData.title,
        showCancel: true,
        confirmColor: '#437eff',
        cancelColor: '#437eff',
        confirm: function confirm() {
          sharePoliteData.rewards.map(function (item) {
            that.getRecvChance(item.type, that.data.shareKey);
          });
        }
      });
    };

    _this.getShareKey = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: "/index.php?r=AppShare/GetAppShareKey",
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              shareKey: res.data
            });
          }
        }
      });
    };

    _this.getRecvChance = function (type, token) {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ShareGiftActivity/GetRecvChance',
        method: 'POST',
        data: {
          share_type: type,
          share_token: token
        },
        success: function success(res) {
          if (!res.data.get_chance) {
            _app.appMethod.shareClickEvent();
          }
        }
      });
    };

    _this.getShareData = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=ShareGiftActivity/GetEffectActivity',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.status == 0) {
            that.setData({
              sharePoliteData: res.data
            });
          }
        }
      });
    };

    _this.againSend = function (data) {
      var list = JSON.parse(JSON.stringify(_this.data.dialogueList));
      list.pop();
      _this.setData({
        content: data,
        dialogueList: list
      });
      _this.askQuestions();
    };

    _this.toBoxBottom = function () {
      var dialogEle = _reactDom2.default.findDOMNode(_this.myRef.current);
      var scrollTimer = setTimeout(function () {
        dialogEle.scrollTop = dialogEle.scrollHeight; // 聊天记录聚焦最新会话
        clearTimeout(scrollTimer);
      });
    };

    _this.showAllRolePage = function () {
      _this.setData({
        isShowAllRole: true
      });
    };

    _this.hiddenAllRolePage = function () {
      _this.setData({
        isShowAllRole: false
      });
    };

    _this.bindSearInput = function (event) {
      var val = event.target.value;
      var reg = new RegExp(val);
      var Arr = _this.data.roleList.filter(function (item) {
        if (val == item.role_name || val == item.title || reg.test(item.role_name) || reg.test(item.title)) {
          return item;
        }
      });
      _this.setData({
        searchValue: val,
        roleListAll: Arr
      });
    };

    _this.selectSwitchItem = function (event) {
      var that = _this;
      var id = event.currentTarget.dataset.id;
      that.setData({
        switchSelectedRoleId: id
      });
    };

    _this.confirmSelect = function () {
      _this.selectActiveItem({ currentTarget: { dataset: { id: _this.data.switchSelectedRoleId } } });
    };

    _this.GetSupportTypeSet = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=ChatAI/GetSupportTypeSet',
        method: 'POST',
        data: {
          app_id: _app.appMethod.getAppId()
        },
        success: function success(res) {
          if (res.data.length) {
            that.setData({
              modalList: res.data,
              modalName: GPTModal[res.data[res.data.length - 1]],
              modalId: res.data[res.data.length - 1],
              modalType: res.data[res.data.length - 1]
            });
          }
        }
      });
    };

    _this.selectModal = function (event) {
      var type = event.currentTarget.dataset.type;
      _this.setData({
        modalType: type,
        modalName: GPTModal[type],
        modalId: type,
        isShowModalConfig: false
      });
    };

    _this.showSelectModalBox = function () {
      _this.setData({
        isShowModalConfig: !_this.data.isShowModalConfig
      });
    };

    _this.startSpeech = function () {
      if (!_this.data.isRecording) {
        _this.connectWebSocket();
      } else {
        _this.recorder.stop();
      }
    };

    _this.getWebSocketUrl = function () {
      // 请求地址根据语种不同变化
      var url = "wss://iat-api.xfyun.cn/v2/iat";
      var host = "iat-api.xfyun.cn";
      var apiKey = API_KEY;
      var apiSecret = API_SECRET;
      var date = new Date().toGMTString();
      var algorithm = "hmac-sha256";
      var headers = "host date request-line";
      var signatureOrigin = 'host: ' + host + '\ndate: ' + date + '\nGET /v2/iat HTTP/1.1';
      var signatureSha = _cryptoJs2.default.HmacSHA256(signatureOrigin, apiSecret);
      var signature = _cryptoJs2.default.enc.Base64.stringify(signatureSha);
      var authorizationOrigin = 'api_key="' + apiKey + '", algorithm="' + algorithm + '", headers="' + headers + '", signature="' + signature + '"';
      var authorization = btoa(authorizationOrigin);
      url = url + '?authorization=' + authorization + '&date=' + date + '&host=' + host;
      return url;
    };

    _this.toBase64 = function (buffer) {
      var binary = "";
      var bytes = new Uint8Array(buffer);
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return btoa(binary);
    };

    _this.createRecorder = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var localWorkerUrl, codeString;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              localWorkerUrl = '';
              // 得到字符串化的 JS 代码

              _context.next = 3;
              return fetch('https://cdn.jisuapp.cn/static/webapp/js/processor/processor.worker.js').then(function (res) {
                return res.text();
              });

            case 3:
              codeString = _context.sent;


              // 在这里我没有使用 new Worker(`data:application/javascript, ${codeString}`) 这种方式
              // 而是使用了 URL.createObjectURL 以及 new Blob, 会将 JavaScript 字符串转换为如下格式
              // blob:http://same-domain/cd2930c0-f4ca-4a9f-b6b1-8242e520dd62
              // 因此不再会有跨域问题
              localWorkerUrl = window.URL.createObjectURL(new Blob([codeString], {
                type: 'application/javascript'
              }));
              _this.recorder = new _indexUmd2.default(localWorkerUrl);
              // console.warn("process.env.BUILD_ENV: ", process.env.BUILD_ENV)
              _this.recorder.onStart = function () {
                console.log('录音开始');
                _this.setData({ isRecording: true });
              };
              _this.recorder.onFrameRecorded = function (_ref2) {
                var isLastFrame = _ref2.isLastFrame,
                    frameBuffer = _ref2.frameBuffer;

                // console.log(frameBuffer,this.toBase64(frameBuffer));
                if (_this.iatWS.readyState === _this.iatWS.OPEN) {
                  _this.iatWS.send(JSON.stringify({
                    data: {
                      status: isLastFrame ? 2 : 1,
                      format: "audio/L16;rate=16000",
                      encoding: "raw",
                      audio: _this.toBase64(frameBuffer)
                    }
                  }));
                  if (isLastFrame) {
                    _this.setData({ isRecording: false });
                  }
                }
              };
              _this.recorder.onStop = function () {
                console.log('录音结束');
                _this.setData({ resultText: '', isRecording: false });
                clearInterval(_this.countdownInterval);
              };

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.connectWebSocket = function () {
      var websocketUrl = _this.getWebSocketUrl();
      if ("WebSocket" in window) {
        _this.iatWS = new WebSocket(websocketUrl);
      } else if ("MozWebSocket" in window) {
        _this.iatWS = new MozWebSocket(websocketUrl);
      } else {
        alert("浏览器不支持WebSocket");
        return;
      }
      _this.iatWS.onopen = function (e) {
        _this.countdown();
        // 开始录音
        _this.recorder.start({
          sampleRate: 16000,
          frameSize: 1280
        });
        var params = {
          common: {
            app_id: APPID
          },
          business: {
            language: "zh_cn",
            domain: "iat",
            accent: "mandarin",
            vad_eos: 5000,
            dwa: "wpgs"
          },
          data: {
            status: 0,
            format: "audio/L16;rate=16000",
            encoding: "raw"
          }
        };
        _this.iatWS.send(JSON.stringify(params));
      };
      _this.iatWS.onmessage = function (e) {
        _this.renderResult(e.data);
        console.log('iatWS.onmessage: ', e.data);
      };
      _this.iatWS.onerror = function (e) {
        console.error(e);
        _this.recorder.stop();
      };
      _this.iatWS.onclose = function (e) {
        console.log(333);
        _this.recorder.stop();
        if (!_this.data.recordInterrupt && _this.data.resultText) {
          _this.setData({ content: _this.data.resultText, is_audio: 1 });
          console.log('发出去', _this.data.resultText);
          _this.askQuestions();
        }
        _this.setData({ recordInterrupt: false });
      };
    };

    _this.countdown = function () {
      _this.setData({ seconds: 60 });
      _this.countdownInterval = setInterval(function () {
        // seconds.value = seconds.value - 1;
        _this.setData({ seconds: _this.data.seconds - 1 });
        if (_this.data.seconds <= 0) {
          clearInterval(_this.countdownInterval);
          _this.recorder.stop();
        }
      }, 1000);
    };

    _this.renderResult = function (resultData) {
      // 识别结束
      var jsonData = JSON.parse(resultData);
      if (jsonData.data && jsonData.data.result) {
        var data = jsonData.data.result;
        var str = "";
        var ws = data.ws;
        for (var i = 0; i < ws.length; i++) {
          str = str + ws[i].cw[0].w;
        }
        // 开启wpgs会有此字段(前提：在控制台开通动态修正功能)
        // 取值为 "apd"时表示该片结果是追加到前面的最终结果；取值为"rpl" 时表示替换前面的部分结果，替换范围为rg字段
        if (data.pgs) {
          if (data.pgs === "apd") {
            // 将resultTextTemp同步给resultText
            _this.setData({ resultText: _this.data.resultTextTemp });
          }
          // 将结果存储在resultTextTemp中
          _this.setData({ resultTextTemp: _this.data.resultText + str });
        } else {
          _this.setData({ resultText: _this.data.resultText + str });
        }
      }
      if (jsonData.code === 0 && jsonData.data.status === 2) {
        _this.iatWS.close();
      }
      if (jsonData.code !== 0) {
        _this.iatWS.close();
        console.error(jsonData);
      }
    };

    _this.cancelRecord = function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log(type, 'cancelRecord', _this);
                _this.setData({ recordInterrupt: true });
                _context2.next = 4;
                return _this.recorder.stop();

              case 4:
                type && _this.textareaRef.current && _this.textareaRef.current.focus();
                type && console.log(_this.textareaRef, '33333');
                // console.log(type,'222222');

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.closeMask = function (event) {
      event.persist();
      event.target.id == 'mask' && _this.setData({ maskShow: false });
    };

    _this.openShare = function () {
      _this.setData({ maskShow: true });
    };

    _this.startShare = function (index) {
      _this.setData({ isShare: true });
      _this.selectThisDialog(index);
    };

    _this.cancelShare = function () {
      _this.setData({ isShare: false, shareDialogList: [], maskShow: false, shareImgUrl: '' });
    };

    _this.selectThisDialog = function (index) {
      var item = _this.data.dialogueList[index];
      var shareDialogList = _this.data.shareDialogList;
      var inx = shareDialogList.findIndex(function (ele) {
        return item.id == ele.id;
      });

      if (item.direction == 'reply') {
        var item2 = _this.data.dialogueList[index - 1];
        if (inx == -1) {
          shareDialogList.push(item2, item);
        } else {
          shareDialogList.splice(inx - 1, 2);
        }
      } else {
        var _item = _this.data.dialogueList[index + 1];
        if (inx == -1) {
          shareDialogList.push(item, _item);
        } else {
          shareDialogList.splice(inx, 2);
        }
      }
      shareDialogList.sort(function (a, b) {
        return a.id - b.id;
      });
      _this.setData({ shareDialogList: shareDialogList });
    };

    _this.isInShareDialogList = function (item) {
      // console.log(item,this.data.shareDialogList.some(ele=>item.id == ele.id),'isInShareDialogList');
      return _this.data.shareDialogList.some(function (ele) {
        return item.id == ele.id;
      });
    };

    _this.createShareImg = function () {
      _this.setData({ maskShow: true });
      _this.exportPictureDownPNG();
    };

    _this.saveShareImg = function () {
      var link = document.createElement('a');
      link.href = _this.state.shareImgUrl;
      link.download = 'shareImg.png';

      // 模拟点击下载链接，触发下载
      link.click();
      // document.body.removeChild(link);
      _this.cancelShare();
    };

    _this.shareWechat = function () {
      _Dialog2.default.showModal({
        title: '功能正在开发，可保存图片分享',
        confirm: function confirm() {
          console.log('好的');
        }
      });
    };

    _this.shareCircle = function () {
      _Dialog2.default.showModal({
        title: '功能正在开发，可保存图片分享',
        confirm: function confirm() {
          console.log('好的');
        }
      });
    };

    _this.stopAudio = function () {
      window.speechSynthesis.pause();
    };

    _this.exportPictureDownPNG = function () {
      var that = _this;
      setTimeout(function () {
        if (navigator.appName == "Microsoft Internet Explorer" && navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE8.0" || navigator.appVersion.split(";")[1].replace(/[ ]/g, "") == "MSIE9.0") {
          //IE亲测
          alert("请升级您的IE浏览器版本，暂不支持IE9及以下版本导出图片。");
        }
        // html2canvas(document.getElementById('shareImg'), {
        //   onrendered: function(canvas) {
        //     var imgData = canvas.toDataURL('image/octet-stream');
        //     if (canvas.msToBlob) {     // IE 9+浏览器
        //       var blob = canvas.msToBlob();
        //       window.navigator.msSaveBlob(blob, pngName);
        //       console.log('22222222');

        //     }else {
        //       console.log('1111111111');
        //       // saveFile(imgData,pngName);
        //     }
        //     console.log('333333333',imgData);

        //   }
        // });
        (0, _html2canvas2.default)(document.getElementById('shareImg'), {
          useCORS: true
        }).then(function (canvas) {
          var dataUrl = canvas.toDataURL();
          var blob = that.dataURLtoBlob(dataUrl);
          // 创建临时URL
          var url = URL.createObjectURL(blob);
          that.setData({ shareImgUrl: url });
        });
      }, 1000);
    };

    _this.dataURLtoBlob = function (dataURL) {
      var arr = dataURL.split(',');
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    };

    _this.closeAndSend = function () {
      _this.iatWS.close();
    };

    document.title = '即速对话';
    _this.myRef = _react2.default.createRef();
    _this.textareaRef = _react2.default.createRef();
    if (_app.appMethod.isWeixin()) {
      _this.state.isWeiXinBrowser = true;
    }
    return _this;
  }

  (0, _createClass3.default)(AudioTest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      // this.textareaRef.current && this.textareaRef.current.focus()
      // console.log(this.textareaRef,'33333')
      _app.appMethod.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
      // 为进入历史对话时
      if (options.sid && options.rid) {
        this.setData({
          sessionId: options.sid,
          selectedRoleId: options.rid,
          switchSelectedRoleId: options.rid
        });
        _app.appMethod.setStorage({
          key: 'nowSessionData',
          data: {
            sessionId: options.sid,
            roleId: options.rid
          }
        });
      }
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin();
        return;
      }
      if (!_app.appMethod.getUserInfo().phone) {
        _toast2.default.info('请补充用户信息', 1, function () {
          _app.appMethod.turnToPage('add-phone');
        });
        return;
      }
      this.getSessionList();
      this.getIntegralDetailData();
      this.getVipInfo();
      this.getHistoryList();
      this.GetSupportTypeSet();
      this.createRecorder();
      // app.getAppCurrentPage().shareData.path = 'https://test2.zhichiwangluo.com/zc_webapp/jisugpt?app_id=' + app.getAppId()
      // this.getShareKey();
      // this.getShareData();
    }
    // 获取会员信息

    // 获取积分信息

    // 获取历史对话

    // 获取会话角色

    // 创建会话

    // 选中角色

    // 获取会话聊天记录

    // 点击加载更多

    // 提问

    // 分享的点击事件（对小程序分享按钮的另种实现）

    // 重新发送

    // 


    // 获取可用的配置模型


    // 语音转文字功能函数

    // 生成图片

    // convertUrlToBase64 = (url) => {
    //   return new Promise((resolve) => {
    //       let img = new Image();
    //       img.crossOrigin = 'Anonymous';
    //       img.src = url;
    //       img.onload = function () {
    //           let canvas = document.createElement('canvas');
    //           canvas.width = img.width;
    //           canvas.height = img.height;
    //           let ctx = canvas.getContext('2d');
    //           ctx.drawImage(img, 0, 0, img.width, img.height);
    //           let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
    //           let dataURL = canvas.toDataURL('image/' + ext);
    //           let base64 = {
    //               dataURL: dataURL,
    //               type: 'image/' + ext,
    //               ext: ext
    //           };
    //           resolve(base64)
    //       }
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          content = _state.content,
          roleList = _state.roleList,
          selectedRoleId = _state.selectedRoleId,
          is_more = _state.is_more,
          isWeiXinBrowser = _state.isWeiXinBrowser,
          isSub = _state.isSub,
          roleListAll = _state.roleListAll,
          switchSelectedRoleId = _state.switchSelectedRoleId,
          isShowAllRole = _state.isShowAllRole,
          searchValue = _state.searchValue,
          modalName = _state.modalName,
          modalId = _state.modalId,
          modalList = _state.modalList,
          isShowModalConfig = _state.isShowModalConfig,
          isAudio = _state.isAudio,
          isRecording = _state.isRecording,
          seconds = _state.seconds,
          resultText = _state.resultText,
          maskShow = _state.maskShow,
          isShare = _state.isShare;

      return _react2.default.createElement(
        'div',
        { className: 'gpt_page' },
        !isWeiXinBrowser && _react2.default.createElement(
          'div',
          { className: 'head' },
          !isShare && _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png', alt: 'back', onClick: this.goBack }),
          isShare && _react2.default.createElement(
            'div',
            { className: 'head_btn', onClick: this.cancelShare },
            '\u53D6\u6D88'
          ),
          _react2.default.createElement(
            'div',
            null,
            isShare ? '选择分享内容' : '即速对话'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main ' + (isWeiXinBrowser ? '' : 'pd_t35'), ref: this.myRef },
          _react2.default.createElement(
            'div',
            { className: 'tab_box' },
            _react2.default.createElement(
              'div',
              null,
              '\u89D2\u8272\u5207\u6362'
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab_list' },
              roleList.map(function (item, index) {
                if (index < 5) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'tab ' + (selectedRoleId == item.role_id || selectedRoleId == item.id ? 'active' : ''),
                      'data-id': item.role_id || item.id, key: index, onClick: _this3.selectActiveItem },
                    item.url && _react2.default.createElement('img', { className: 'roleimg', src: item.url }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.role_name || item.title
                    )
                  );
                }
              }),
              roleList.length > 6 && _react2.default.createElement(
                'div',
                { className: 'tab', onClick: this.showAllRolePage },
                '\u66F4\u591A',
                '  >'
              )
            )
          ),
          is_more == 1 && _react2.default.createElement(
            'div',
            { className: 'request-all', onClick: this.getMore },
            '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
          ),
          this.state.dialogueList.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: item.id + '-' + index, className: 'text_animation_box' },
              item.direction != "reply" && isShare && _react2.default.createElement('div', { className: 'select_share_btn img', onClick: _this3.selectThisDialog.bind(_this3, index), style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/' + (_this3.isInShareDialogList.bind(_this3, item)() ? 'audio-share-selected' : 'audio-share-select') + '.png)' } }),
              item.direction != "reply" && !isShare && _react2.default.createElement('div', { className: 'select_share_btn' }),
              _react2.default.createElement(_TextAnimation2.default, { data: item, againSend: _this3.againSend, toBoxBottom: _this3.toBoxBottom, startShare: _this3.startShare.bind(_this3, index), highLight: isShare && _this3.isInShareDialogList.bind(_this3, item)() })
            );
          })
        ),
        !isShare && _react2.default.createElement(
          'div',
          { className: 'footer' },
          _react2.default.createElement(
            'div',
            { className: 'row jc_sb' },
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: this.goBack },
              '< ',
              '\u5386\u53F2\u5BF9\u8BDD'
            ),
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: this.toPage },
              '\u7B7E\u5230\u9001\u79EF\u5206'
            ),
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: this.toPage2 },
              '\u6211\u7684\u79EF\u5206'
            ),
            _react2.default.createElement(
              'div',
              { className: 'nav', onClick: modalList.length > 1 ? this.showSelectModalBox : null },
              '\u6A21\u578B\u9009\u62E9'
            )
          ),
          isShowModalConfig && _react2.default.createElement(
            'div',
            { className: 'tool_config' },
            modalList.map(function (item) {
              return _react2.default.createElement(
                'div',
                { className: modalId == item ? 'config_item config_item_select' : 'config_item', key: item, onClick: _this3.selectModal, 'data-type': item },
                ' ',
                GPTModal[item]
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'row say_box jc_sa' },
            _react2.default.createElement('textarea', { ref: this.textareaRef, className: 'ipt_box', placeholder: '\u6765\u8BF4\u70B9\u4EC0\u4E48\u5427\uFF08\u6D88\u80172\u79EF\u5206\uFF09', onInput: this.bindTextInput, onChange: this.bindTextInput, value: content }),
            content.length !== '' && isSub && _react2.default.createElement(
              'div',
              { className: isSub ? 'sub_btn' : 'sub_btn un_sub', onClick: isSub ? this.askQuestions : null },
              '\u53D1\u9001'
            ),
            content.length == '' && !isSub && _react2.default.createElement('div', { className: 'microphone_icon', onClick: this.startSpeech })
          )
        ),
        isRecording && _react2.default.createElement(
          'div',
          { className: 'record_box' },
          _react2.default.createElement(
            'div',
            { className: 'record_text_box' },
            _react2.default.createElement(
              'p',
              { className: 'timeText' },
              '00:',
              seconds < 10 ? '0' + seconds : seconds
            ),
            resultText.length > 0 && _react2.default.createElement(
              'p',
              { className: 'record_text' },
              resultText
            ),
            seconds <= 5 && _react2.default.createElement(
              'p',
              { className: 'timeText' },
              _react2.default.createElement(
                'span',
                { style: { color: '#F24545' } },
                seconds,
                '\u201D'
              ),
              '\u540E\u505C\u6B62\u5F55\u97F3'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row jc_sa record_btn_box' },
            _react2.default.createElement('div', { className: 'record_btn img', style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-close.png)' }, onClick: function onClick(e) {
                return _this3.cancelRecord(e);
              } }),
            _react2.default.createElement(
              'div',
              { className: 'record_animation', onClick: this.closeAndSend },
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar1' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar2' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar3' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar4' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar5' }),
              _react2.default.createElement('div', { className: 'spectrum_bar spectrum_bar6' })
            ),
            _react2.default.createElement('div', { className: 'record_btn img', onClick: function onClick(e) {
                return _this3.cancelRecord(e, true);
              }, style: { backgroundImage: 'url(https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-type.png)' } })
          )
        ),
        isShare && _react2.default.createElement(
          'div',
          { className: 'row jc_sa share_btm_box' },
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.shareWechat },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u5FAE\u4FE1\u597D\u53CB'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.shareCircle },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u670B\u53CB\u5708'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'share_btm_item', onClick: this.createShareImg },
            _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-pic.png', alt: '' }),
            _react2.default.createElement(
              'p',
              { className: 'share_btm_text' },
              '\u751F\u6210\u56FE\u7247'
            )
          ),
          this.state.shareDialogList.length == 0 && _react2.default.createElement('div', { className: 'prevent_share' })
        ),
        isShowAllRole == true && _react2.default.createElement(
          'div',
          { className: 'drawer_box' },
          _react2.default.createElement('div', { className: 'mask', onClick: this.hiddenAllRolePage }),
          _react2.default.createElement(
            'div',
            { className: 'drawer' },
            _react2.default.createElement(
              'div',
              { className: 'drawer_head' },
              _react2.default.createElement(
                'div',
                { className: 'd_title_line' },
                _react2.default.createElement(
                  'div',
                  { className: 'd_title' },
                  '\u89D2\u8272\u5207\u6362'
                ),
                _react2.default.createElement(_icon2.default, { type: 'cross-circle-o', size: 'xs', onClick: this.hiddenAllRolePage })
              ),
              _react2.default.createElement(
                'div',
                { className: 'ipt_box' },
                _react2.default.createElement('label', { className: 'ico-moon icon-search' }),
                _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u89D2\u8272\u540D\u79F0', value: searchValue, onInput: this.bindSearInput, onChange: this.bindSearInput, onClick: this.debubbling })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'drawer_main' },
              roleListAll.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'role_item ' + (switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id ? 'active' : ''),
                    'data-id': item.role_id || item.id, key: index, onClick: _this3.selectSwitchItem },
                  item.url && _react2.default.createElement('img', { src: item.url }),
                  _react2.default.createElement(
                    'div',
                    null,
                    item.role_name || item.title
                  ),
                  _react2.default.createElement('input', { type: 'radio', checked: switchSelectedRoleId == item.role_id || switchSelectedRoleId == item.id, onChange: function onChange() {
                      return false;
                    } })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'drawer_footer' },
              _react2.default.createElement(
                'div',
                { className: 'drawer_btn', onClick: this.confirmSelect },
                '\u786E\u5B9A'
              )
            )
          )
        ),
        maskShow && _react2.default.createElement(
          'div',
          { id: 'mask', className: 'mask', onClick: this.closeMask },
          _react2.default.createElement(
            'div',
            { id: 'shareImg', className: 'share_content_box' },
            _react2.default.createElement(
              'div',
              { className: 'share_content_head' },
              _react2.default.createElement('img', { className: 'share_logo', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-logo.png', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_content' },
              this.state.shareDialogList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: item.id + '-' + index, className: 'text_animation_box' },
                  _react2.default.createElement(_TextAnimation2.default, { data: item, againSend: _this3.againSend, toBoxBottom: _this3.toBoxBottom, startShare: _this3.startShare, highLight: isShare && _this3.isInShareDialogList.bind(_this3, item)() })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_content_foot' },
              _react2.default.createElement('img', { className: 'share_tips', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-tips.png', alt: '' }),
              _react2.default.createElement('div', { className: 'code_box' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'row jc_sa share_btm_box' },
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', onClick: this.shareWechat },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-wechat.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u5FAE\u4FE1\u597D\u53CB'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', onClick: this.shareCircle },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-circle.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u670B\u53CB\u5708'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'share_btm_item', onClick: this.saveShareImg },
              _react2.default.createElement('img', { className: 'share_btm_img', src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/audio/audio-share-download.png', alt: '' }),
              _react2.default.createElement(
                'p',
                { className: 'share_btm_text' },
                '\u4FDD\u5B58\u56FE\u7247'
              )
            )
          )
        )
      );
    }
  }]);
  return AudioTest;
}(_OfficialPage3.default);

exports.default = AudioTest;

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

var _reactDom = __webpack_require__(19);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(716);

var _TextAnimation = __webpack_require__(143);

var _TextAnimation2 = _interopRequireDefault(_TextAnimation);

var _tools = __webpack_require__(6);

var _Dialog = __webpack_require__(84);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _cryptoJs = __webpack_require__(145);

var _cryptoJs2 = _interopRequireDefault(_cryptoJs);

var _indexUmd = __webpack_require__(148);

var _indexUmd2 = _interopRequireDefault(_indexUmd);

var _LoginPage = __webpack_require__(92);

var _LoginPage2 = _interopRequireDefault(_LoginPage);

var _html2canvas = __webpack_require__(149);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

var _weixinSdkConfig = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GPTModal = {
  '0': 'GPT-3.5',
  '1': 'GPT-4'
};
var APPID = "2dcb30a7";
var API_SECRET = "Mzg2ZmYzNDIyZGQ1M2MzMDU4OWY5Yzc1";
var API_KEY = "9449a5280ed944fa8f53b23d5c1e90fd";

var longPressTimeout = void 0;

var SharePage = function (_OfficialPage) {
  (0, _inherits3.default)(SharePage, _OfficialPage);

  function SharePage(props) {
    (0, _classCallCheck3.default)(this, SharePage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SharePage.__proto__ || Object.getPrototypeOf(SharePage)).call(this, props));

    _this.countdownInterval = null;
    _this.recorder = null;
    _this.iatWS = null;
    _this.state = {
      canUseIntegral: 0,
      userVipCardInfo: null,
      historyNum: 0,
      roleList: [{
        role_id: 0,
        role_name: '会话',
        url: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/session_role.png'
      }],
      roleListAll: [],
      selectedRoleId: '',
      switchSelectedRoleId: '',
      sessionId: '', //会话id
      dialogueList: [{
        "text": "你好。",
        "direction": "ques",
        "id": "805",
        "isHistory": true,
        "is_audio": "1"
      }, {
        "text": "你好！有什么我可以帮助你的吗？",
        "direction": "reply",
        "id": "806",
        "isHistory": true,
        "is_audio": "1"
      }],
      is_more: 0,
      current_page: 1,
      content: '', //提问内容
      is_audio: 0, //提问方式   0打字提问 1语音提问
      shareKey: '',
      sharePoliteData: {},
      isWeiXinBrowser: false,
      isSub: false,
      isShowAllRole: false,
      searchValue: '',
      modalType: 0, // 模型
      modalName: 'GPT-3.5', // 模型名称
      modalId: '',
      modalList: [],
      isShowModalConfig: false,

      // 录音相关数据
      isAudio: true, // 是否切换为录音
      isRecording: false, // 正在录音
      // iatWS:null, //websocket
      resultText: '', // 文字结果
      resultTextTemp: '', // 文字修正结果
      // countdownInterval:null, // 时间计数器
      seconds: 60, // 倒计时
      recordInterrupt: false,
      // recorder:null,

      maskShow: false,
      isShare: false, // 正在分享
      shareDialogList: [], // 选择分享的内容
      lastDialogId: 0,
      shareImgUrl: '',
      qrCodeImg: '',
      isLongPress: false,
      longPressInx: -1
    };

    document.title = '即速对话';
    _this.myRef = _react2.default.createRef();
    _this.textareaRef = _react2.default.createRef();
    if (_app.appMethod.isWeixin()) {
      _this.state.isWeiXinBrowser = true;
    }
    return _this;
  }

  (0, _createClass3.default)(SharePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      // this.textareaRef.current && this.textareaRef.current.focus()
      // console.log(this.textareaRef,'33333')
      _app.appMethod.globalData.homepageRouter = 'jisugpt'; //将首页路径设置为gpt入口页
      // 为进入历史对话时
      if (options.sid && options.rid) {
        this.setData({
          sessionId: options.sid,
          selectedRoleId: options.rid,
          switchSelectedRoleId: options.rid
        });
        _app.appMethod.setStorage({
          key: 'nowSessionData',
          data: {
            sessionId: options.sid,
            roleId: options.rid
          }
        });
      }
      if (!_app.appMethod.isLogin()) {
        _app.appMethod.goLogin();
        return;
      }
      if (!_app.appMethod.getUserInfo().phone) {
        _toast2.default.info('请补充用户信息', 1, function () {
          _app.appMethod.turnToPage('add-phone');
        });
        return;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          content = _state.content,
          roleList = _state.roleList,
          selectedRoleId = _state.selectedRoleId,
          is_more = _state.is_more,
          isWeiXinBrowser = _state.isWeiXinBrowser,
          isSub = _state.isSub,
          roleListAll = _state.roleListAll,
          switchSelectedRoleId = _state.switchSelectedRoleId,
          isShowAllRole = _state.isShowAllRole,
          searchValue = _state.searchValue,
          modalName = _state.modalName,
          modalId = _state.modalId,
          modalList = _state.modalList,
          isShowModalConfig = _state.isShowModalConfig,
          isAudio = _state.isAudio,
          isRecording = _state.isRecording,
          seconds = _state.seconds,
          resultText = _state.resultText,
          maskShow = _state.maskShow,
          isShare = _state.isShare,
          qrCodeImg = _state.qrCodeImg,
          isLongPress = _state.isLongPress,
          longPressInx = _state.longPressInx;

      return _react2.default.createElement(
        'div',
        { className: 'gpt_page', onClick: this.cancleLongPress },
        !isWeiXinBrowser && _react2.default.createElement(
          'div',
          { className: 'head' },
          !isShare && _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/chatgpt/icon_l_big.png', alt: 'back', onClick: this.goBack }),
          isShare && _react2.default.createElement(
            'div',
            { className: 'head_btn', onClick: this.cancelShare },
            '\u53D6\u6D88'
          ),
          _react2.default.createElement(
            'div',
            null,
            isShare ? '选择分享内容' : '即速对话'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'main ' + (isWeiXinBrowser ? '' : 'pd_t35'), ref: this.myRef },
          is_more == 1 && _react2.default.createElement(
            'div',
            { className: 'request-all', onClick: this.getMore },
            '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
          ),
          this.state.dialogueList.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { key: item.id + '-' + index, className: 'text_animation_box' },
              item.direction != "reply" && !isShare && _react2.default.createElement('div', { className: 'select_share_btn' }),
              _react2.default.createElement(_TextAnimation2.default, { data: item, againSend: _this2.againSend, toBoxBottom: _this2.toBoxBottom })
            );
          })
        )
      );
    }
  }]);
  return SharePage;
}(_OfficialPage3.default);

exports.default = SharePage;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _app = __webpack_require__(4);

var _OfficialPage2 = __webpack_require__(7);

var _OfficialPage3 = _interopRequireDefault(_OfficialPage2);

__webpack_require__(718);

var _tools = __webpack_require__(6);

var _LoadingPage = __webpack_require__(207);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

var _qrcode = __webpack_require__(720);

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * @Author: ht 1724552153@qq.com
 * @Date: 2024-12-02 11:36:52
 * @LastEditors: ht 1724552153@qq.com
 * @LastEditTime: 2025-02-19 13:53:22
 * @FilePath: \jisuapp_webapp\src\official-page\tap-pay\TapPay.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
var timer = null;
// import { TopNav } from '@common/top-nav/TopNav';

var TapPay = function (_OfficialPage) {
  (0, _inherits3.default)(TapPay, _OfficialPage);

  function TapPay(props) {
    (0, _classCallCheck3.default)(this, TapPay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TapPay.__proto__ || Object.getPrototypeOf(TapPay)).call(this, props));

    _this.state = {
      paylist: [],
      currentIndex: 0,
      iscomplete: false,
      payUrl: ''
    };

    _this.startPolling = function (appids, uniqids) {
      timer = setInterval(function () {
        _this.GetLivePromotionPendingPayList(appids, uniqids);
      }, 1000);
    };

    _this.stopPolling = function () {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    };

    _this.GetLivePromotionPendingPayList = function (appids, uniqids) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppChannelsPromote/GetLivePromotionPendingPayList',
        // hideLoading: true,
        method: 'post',
        data: {
          app_id: appids,
          uniq_id: uniqids
        },
        success: function success(res) {
          if (res.status == 1) {
            _this.stopPolling();
            return;
          }
          if (res.status == 0) {
            that.setState({
              paylist: res.data
            });
            if (that.state.currentIndex + 1 > that.state.paylist.length) {

              _this.stopPolling();
              return;
            }
            if (that.state.paylist[that.state.currentIndex].status == '10') {
              // console.log('生成二维码');
              var canvas = document.createElement('canvas');
              canvas.width = 180;
              canvas.height = 180;
              console.log(that.state.paylist[that.state.currentIndex].pay_url);
              _qrcode2.default.toCanvas(canvas, that.state.paylist[that.state.currentIndex].pay_url, { errorCorrectionLevel: 'H' });
              _this.setState({
                payUrl: canvas.toDataURL()
              });
            } else if (that.state.paylist[that.state.currentIndex].status !== '10') {
              that.setState({
                currentIndex: that.state.currentIndex + 1
              });
            }
          }
        },
        fail: function fail(res) {
          console.log(res);
        }
      });
    };

    _this.skipplan = function () {
      _app.appMethod.showModal({
        content: '确定要跳过该计划吗？',
        // confirmText: '去注册',
        showCancel: true,
        confirmColor: '#437eff',
        confirm: function confirm() {
          _this.setState({
            currentIndex: _this.state.currentIndex + 1
          });
          if (_this.state.currentIndex + 1 >= _this.state.paylist.length) {
            _this.setState({
              iscomplete: true
            });
            _this.stopPolling();
          }
        }
      });
    };

    document.title = '视频号支付';
    return _this;
  }

  (0, _createClass3.default)(TapPay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();


      // this.GetLivePromotionPendingPayList(options.app_id,options.uniq_id)
      this.startPolling(options.app_id, options.uniq_id);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // 开启定时


    // 暂停轮询


    // 获取投手号下所有待支付计划订单


    // 跳过计划

  }, {
    key: 'render',


    // 获取生成待支付h5页面二维码
    // GetLivePromotionPendingPayQrCode = ()=>{
    //   let that = this
    //   app.sendRequest({
    //     url: '/index.php?r=pc/AppChannelsPromote/GetLivePromotionPendingPayQrCode',
    //     hideLoading: true,
    //     method: 'POST',
    //     data: {
    //       app_id:'y37X6lY43k',
    //       uniq_id:'sph51OT21my6gO1'
    //     },
    //     success: (res) => {
    //      if(res.status == 0){

    //      }
    //     }
    //   })

    // }


    value: function render() {
      var _state = this.state,
          paylist = _state.paylist,
          currentIndex = _state.currentIndex,
          iscomplete = _state.iscomplete,
          payUrl = _state.payUrl;

      if (!paylist || paylist.length === 0) {
        return React.createElement(_LoadingPage2.default, null);
      }
      return React.createElement(
        'div',
        { className: 'tap-pay' },
        React.createElement(
          'div',
          { className: 'pay-hd' },
          React.createElement(
            'div',
            { className: 'pay-hd-lf' },
            React.createElement('img', { src: paylist[0].headimg_url, alt: '' })
          ),
          React.createElement(
            'div',
            { className: 'pay-hd-rf' },
            React.createElement(
              'span',
              null,
              paylist[0].nick_name
            ),
            React.createElement(
              'span',
              null,
              '\u5907\u6CE8\uFF1A'
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'pay-md' },
          React.createElement(
            'div',
            { className: 'pay-md-top' },
            !iscomplete && React.createElement(
              'div',
              { className: 'md-top-lf' },
              React.createElement(
                'span',
                null,
                '\u7B2C',
                currentIndex + 1,
                '\u6761\u8BA1\u5212'
              ),
              React.createElement(
                'span',
                null,
                'ID:',
                paylist[currentIndex].promotion_id
              )
            ),
            !iscomplete && React.createElement(
              'div',
              { className: 'md-top-rf', onClick: this.skipplan },
              React.createElement(
                'span',
                null,
                '\u8DF3\u8FC7\u8BE5\u8BA1\u5212'
              )
            )
          ),
          React.createElement(
            'div',
            { className: 'pay-md-code' },
            !iscomplete && payUrl && React.createElement(
              'div',
              { className: 'code' },
              React.createElement('img', { src: payUrl, alt: '' })
            ),
            iscomplete && React.createElement(
              'div',
              { className: 'code-complete' },
              React.createElement(_icon2.default, { className: 'code-icon', color: '#00FF00', type: 'check-circle-o', size: 'xs' }),
              React.createElement(
                'span',
                null,
                '\u8BA2\u5355\u5168\u90E8\u652F\u4ED8\u5B8C\u6210'
              )
            ),
            React.createElement(
              'span',
              { className: 'code-tip' },
              '\u957F\u6309\u8BC6\u522B\u56FE\u4E2D\u4E8C\u7EF4\u7801\u652F\u4ED8'
            ),
            React.createElement(
              'div',
              { className: 'code-btn' },
              React.createElement(
                'span',
                null,
                '\u5269\u4F59',
                paylist.length - currentIndex,
                '\u6761\u5F85\u652F\u4ED8'
              )
            )
          )
        ),
        React.createElement(
          'div',
          { className: 'pay-bd' },
          React.createElement(
            'div',
            { className: 'pay-bd-tip' },
            React.createElement('div', { className: 'bd-icon' }),
            React.createElement(
              'span',
              { className: 'bd-tip' },
              '\u6E29\u99A8\u63D0\u793A'
            ),
            React.createElement('div', { className: 'bd-icon' })
          ),
          React.createElement(
            'div',
            { className: 'pay-bd-content' },
            React.createElement(
              'span',
              null,
              '1.\u6B64\u94FE\u63A5\u5305\u542B\u8BE5\u6295\u624B\u53F7\u7684\u6240\u6709\u5F85\u652F\u4ED8\u8BA1\u5212\uFF0C\u4F7F\u7528\u81EA\u52A8\u652F\u4ED8\u811A\u672C\u9700\u8981 \u5173\u505C\u65E0\u9700\u652F\u4ED8\u7684\u8BA1\u5212\uFF0C\u907F\u514D\u9519\u8BEF;'
            ),
            React.createElement(
              'span',
              null,
              '2.\u53EF\u8054\u7CFB\u5BA2\u670D\u9886\u53D6\u81EA\u52A8\u652F\u4ED8\u811A\u672C\u3002'
            )
          )
        )
      );
    }
  }]);
  return TapPay;
}(_OfficialPage3.default);

exports.default = TapPay;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {


var canPromise = __webpack_require__(721)

var QRCode = __webpack_require__(722)
var CanvasRenderer = __webpack_require__(742)
var SvgRenderer = __webpack_require__(743)

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  var args = [].slice.call(arguments, 1)
  var argsNum = args.length
  var isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        var data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    var data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)
var Utils = __webpack_require__(60)
var ECLevel = __webpack_require__(152)
var BitBuffer = __webpack_require__(723)
var BitMatrix = __webpack_require__(724)
var AlignmentPattern = __webpack_require__(725)
var FinderPattern = __webpack_require__(726)
var MaskPattern = __webpack_require__(727)
var ECCode = __webpack_require__(208)
var ReedSolomonEncoder = __webpack_require__(728)
var Version = __webpack_require__(734)
var FormatInfo = __webpack_require__(735)
var Mode = __webpack_require__(61)
var Segments = __webpack_require__(736)
var isArray = __webpack_require__(71)

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  var size = matrix.size
  var pos = FinderPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (var c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  var size = matrix.size

  for (var r = 8; r < size - 8; r++) {
    var value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  var pos = AlignmentPattern.getPositions(version)

  for (var i = 0; i < pos.length; i++) {
    var row = pos[i][0]
    var col = pos[i][1]

    for (var r = -2; r <= 2; r++) {
      for (var c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  var size = matrix.size
  var bits = Version.getEncodedBits(version)
  var row, col, mod

  for (var i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  var size = matrix.size
  var bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  var i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix} matrix Modules matrix
 * @param  {Buffer}    data   Data codewords
 */
function setupData (matrix, data) {
  var size = matrix.size
  var inc = -1
  var row = size - 1
  var bitIndex = 7
  var byteIndex = 0

  for (var col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          var dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Buffer}                        Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  var buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  var totalCodewords = Utils.getSymbolTotalCodewords(version)
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  var remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (var i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Buffer}                         Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  var ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  var blocksInGroup2 = totalCodewords % ecTotalBlocks
  var blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  var totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  var dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  var dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  var ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  var rs = new ReedSolomonEncoder(ecCount)

  var offset = 0
  var dcData = new Array(ecTotalBlocks)
  var ecData = new Array(ecTotalBlocks)
  var maxDataSize = 0
  var buffer = BufferUtil.from(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (var b = 0; b < ecTotalBlocks; b++) {
    var dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  var data = BufferUtil.alloc(totalCodewords)
  var index = 0
  var i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  var segments

  if (isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    var estimatedVersion = version

    if (!estimatedVersion) {
      var rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments,
        errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  var bestVersion = Version.getBestVersionForData(segments,
      errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  var dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  var moduleCount = Utils.getSymbolSize(version)
  var modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  var errorCorrectionLevel = ECLevel.M
  var version
  var mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}


/***/ }),
/* 723 */
/***/ (function(module, exports) {

function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    var bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = BufferUtil.alloc(size * size)
  this.reservedBit = BufferUtil.alloc(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  var index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

var getSymbolSize = __webpack_require__(60).getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  var posCount = Math.floor(version / 7) + 2
  var size = getSymbolSize(version)
  var intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  var positions = [size - 7] // Last coord is always (size - 7)

  for (var i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * var pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var coords = []
  var pos = exports.getRowColCoords(version)
  var posLength = pos.length

  for (var i = 0; i < posLength; i++) {
    for (var j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) ||             // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var getSymbolSize = __webpack_require__(60).getSymbolSize
var FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  var size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}


/***/ }),
/* 727 */
/***/ (function(module, exports) {

/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
var PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  var size = data.size
  var points = 0
  var sameCountCol = 0
  var sameCountRow = 0
  var lastCol = null
  var lastRow = null

  for (var row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (var col = 0; col < size; col++) {
      var module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  var size = data.size
  var points = 0

  for (var row = 0; row < size - 1; row++) {
    for (var col = 0; col < size - 1; col++) {
      var last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  var size = data.size
  var points = 0
  var bitsCol = 0
  var bitsRow = 0

  for (var row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (var col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  var darkCount = 0
  var modulesCount = data.data.length

  for (var i = 0; i < modulesCount; i++) darkCount += data.data[i]

  var k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  var size = data.size

  for (var col = 0; col < size; col++) {
    for (var row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  var numPatterns = Object.keys(exports.Patterns).length
  var bestPattern = 0
  var lowerPenalty = Infinity

  for (var p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    var penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)
var Polynomial = __webpack_require__(729)
var Buffer = __webpack_require__(731).Buffer

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Buffer} data Buffer containing input data
 * @return {Buffer}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  var pad = BufferUtil.alloc(this.degree)
  var paddedData = Buffer.concat([data, pad], data.length + this.degree)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  var remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  var start = this.degree - remainder.length
  if (start > 0) {
    var buff = BufferUtil.alloc(this.degree)
    remainder.copy(buff, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)
var GF = __webpack_require__(730)

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Buffer} p1 Polynomial
 * @param  {Buffer} p2 Polynomial
 * @return {Buffer}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  var coeff = BufferUtil.alloc(p1.length + p2.length - 1)

  for (var i = 0; i < p1.length; i++) {
    for (var j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Buffer} divident Polynomial
 * @param  {Buffer} divisor  Polynomial
 * @return {Buffer}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  var result = BufferUtil.from(divident)

  while ((result.length - divisor.length) >= 0) {
    var coeff = result[0]

    for (var i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    var offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Buffer}        Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  var poly = BufferUtil.from([1])
  for (var i = 0; i < degree; i++) {
    poly = exports.mul(poly, [1, GF.exp(i)])
  }

  return poly
}


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)

var EXP_TABLE = BufferUtil.alloc(512)
var LOG_TABLE = BufferUtil.alloc(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  var x = 1
  for (var i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(732)
var ieee754 = __webpack_require__(733)
var isArray = __webpack_require__(71)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 733 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(60)
var ECCode = __webpack_require__(208)
var ECLevel = __webpack_require__(152)
var Mode = __webpack_require__(61)
var VersionCheck = __webpack_require__(209)
var isArray = __webpack_require__(71)

// Generator polynomial used to encode version information
var G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
var G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  var totalBits = 0

  segments.forEach(function (data) {
    var reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (var currentVersion = 1; currentVersion <= 40; currentVersion++) {
    var length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  var totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  var ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  var dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  var usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  var seg

  var ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  var d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(60)

var G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
var G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
var G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  var data = ((errorCorrectionLevel.bit << 3) | mask)
  var d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(61)
var NumericData = __webpack_require__(737)
var AlphanumericData = __webpack_require__(738)
var ByteData = __webpack_require__(739)
var KanjiData = __webpack_require__(740)
var Regex = __webpack_require__(210)
var Utils = __webpack_require__(60)
var dijkstra = __webpack_require__(741)

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  var segments = []
  var result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  var numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  var alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  var byteSegs
  var kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  var segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    var prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  var nodes = []
  for (var i = 0; i < segs.length; i++) {
    var seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  var table = {}
  var graph = {'start': {}}
  var prevNodeIds = ['start']

  for (var i = 0; i < nodes.length; i++) {
    var nodeGroup = nodes[i]
    var currentNodeIds = []

    for (var j = 0; j < nodeGroup.length; j++) {
      var node = nodeGroup[j]
      var key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (var n = 0; n < prevNodeIds.length; n++) {
        var prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]]['end'] = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  var mode
  var bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  var segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  var nodes = buildNodes(segs)
  var graph = buildGraph(nodes, version)
  var path = dijkstra.find_path(graph.map, 'start', 'end')

  var optimizedSegs = []
  for (var i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(61)

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  var i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  var remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(61)

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
var ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  var i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    var value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var BufferUtil = __webpack_require__(70)
var Mode = __webpack_require__(61)

function ByteData (data) {
  this.mode = Mode.BYTE
  this.data = BufferUtil.from(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (var i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var Mode = __webpack_require__(61)
var Utils = __webpack_require__(60)

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  var i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    var value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (true) {
  module.exports = dijkstra;
}


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(211)

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  var opts = options
  var canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  var size = Utils.getImageWidth(qrData.modules.size, opts)

  var ctx = canvasEl.getContext('2d')
  var image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  var opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  var canvasEl = exports.render(qrData, canvas, opts)

  var type = opts.type || 'image/png'
  var rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var Utils = __webpack_require__(211)

function getColorAttrib (color, attrib) {
  var alpha = color.a / 255
  var str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  var str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  var path = ''
  var moveBy = 0
  var newRow = false
  var lineLength = 0

  for (var i = 0; i < data.length; i++) {
    var col = Math.floor(i % size)
    var row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  var opts = Utils.getOptions(options)
  var size = qrData.modules.size
  var data = qrData.modules.data
  var qrcodesize = size + opts.margin * 2

  var bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  var path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  var viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  var width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  var svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var transformParams = function transformParams(params, obj) {
  var new2old = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var key in obj) {
    params += (new2old[key] || key) + '=' + (obj[key] || '') + '&';
  }
  return params;
};
var oldPageList = {
  // 优惠券详情
  'couponDetail': function couponDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // 转成旧有参数, key转换
    var new2old = {
      'franchisee': 'sub_id'
    };
    return transformParams('router=couponDetail&', obj, new2old);
  },
  'videoDetail': function videoDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=videoDetail&', obj);
  },
  // 'goodsDetail': (obj = {}) => {
  //   return transformParams('router=goodsDetail&', obj);
  // },
  'toStoreDetail': function toStoreDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=toStoreDetail&', obj);
  },
  'franchiseeDetail': function franchiseeDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=franchiseeDetail&', obj);
  },
  // 拼团中心
  'groupCenter': function groupCenter() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=groupCenter&', obj);
  },
  'communityPage': function communityPage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=communityPage&', obj);
  },
  // 优惠券领取列表
  'couponReceiveListPage': function couponReceiveListPage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=couponReceiveListPage&', obj);
  },
  // 储值
  'recharge': function recharge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=recharge&', obj);
  },
  // 当面付
  'transferPage': function transferPage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=transferPay&', obj);
  },
  // 大转盘
  'luckyWheelDetail': function luckyWheelDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=luckyWheelDetail&', obj);
  },
  // 刮刮乐
  'scratch': function scratch() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=scratch&', obj);
  },
  // 砸金蛋
  'goldenEggs': function goldenEggs() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=goldenEggs&', obj);
  },
  // 商家入驻
  'franchiseeEnter': function franchiseeEnter() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=franchiseeEnter&', obj);
  },
  // 个人中心（应该删除）
  'userCenterComponentPage': function userCenterComponentPage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=userCenterComponentPage&', obj);
  },
  // 门店单页
  'storeSinglePage': function storeSinglePage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=storeSinglePage&', obj);
  },
  // 系统通知
  'myMessage': function myMessage() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var params = 'router=myMessage&';
    return transformParams('router=myMessage&', obj);
  },
  // 购物车
  'shoppingCart': function shoppingCart() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=shoppingCart&', obj);
  },
  // 我的订单
  'myOrder': function myOrder() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=myOrder&', obj);
  },
  // 资讯详情
  'newsDetail': function newsDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=newsDetail&', obj);
  },
  // 社区详情
  'communityDetail': function communityDetail() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return transformParams('router=communityDetail&', obj);
  }
};
exports.default = oldPageList;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewImage = undefined;

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(746);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewImage = exports.PreviewImage = function (_React$Component) {
  (0, _inherits3.default)(PreviewImage, _React$Component);

  function PreviewImage(props) {
    (0, _classCallCheck3.default)(this, PreviewImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PreviewImage.__proto__ || Object.getPrototypeOf(PreviewImage)).call(this, props));

    _this.options = _this.props.options;
    var current = _this.options.current;
    _this.urls = _this.options.urls || (current ? [current] : []);
    var index = _this.urls.indexOf(current);
    _this.selectedIndex = index > -1 ? index : 0;

    _this.state = {
      selectedIndex: _this.selectedIndex
    };

    _this.carouselAfterChange = _this.carouselAfterChange.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PreviewImage, [{
    key: 'carouselAfterChange',
    value: function carouselAfterChange(index) {
      this.setState({ selectedIndex: index });
    }
  }, {
    key: 'imgClick',
    value: function imgClick(event) {
      event.stopPropagation();
    }
  }, {
    key: 'close',
    value: function close(event) {
      ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'common-api preview-image' },
        _react2.default.createElement(
          'div',
          { className: 'preivew-image-dots' },
          this.state.selectedIndex + 1,
          '/',
          this.urls.length
        ),
        _react2.default.createElement(
          _carousel2.default,
          {
            selectedIndex: this.selectedIndex,
            dots: false,
            afterChange: this.carouselAfterChange
          },
          this.urls.map(function (item, itemIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'preview-image-item', key: itemIndex, onClick: _this2.close },
              _react2.default.createElement('img', {
                src: item,
                alt: '',
                onClick: _this2.imgClick
              })
            );
          })
        )
      );
    }
  }]);
  return PreviewImage;
}(_react2.default.Component);

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChooseLocation = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(748);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChooseLocation = exports.ChooseLocation = function (_React$Component) {
  (0, _inherits3.default)(ChooseLocation, _React$Component);

  function ChooseLocation(props) {
    (0, _classCallCheck3.default)(this, ChooseLocation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ChooseLocation.__proto__ || Object.getPrototypeOf(ChooseLocation)).call(this, props));

    _this.options = _this.props.options;
    // console.log(this.options);
    _this.mapInstance = null;
    _this.searchService = null;
    _this.geocoder = null;
    _this.marker = null;

    _this.state = {
      locationPoi: '',
      nearPois: [],
      chooseIndex: -1,
      showSearch: false,
      searchValue: '',
      searchList: []
    };

    _this.textInput = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(ChooseLocation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var mapInstance = this.mapInstance = new qq.maps.Map(document.getElementById("choose-location-map"), {
        zoom: 15,
        zoomControl: false,
        panControl: false,
        mapTypeControl: false
      });

      this.getLocation();
      this.locationIcon();
      this.centerIcon();

      qq.maps.event.addListener(mapInstance, 'dragend', function () {
        _this2.mapLocationList(mapInstance.getCenter());
      });
    }

    // 获取定位

  }, {
    key: 'getLocation',
    value: function getLocation() {
      var _this3 = this;

      _app.appMethod.getLocation({
        success: function success(res) {
          var latlng = new qq.maps.LatLng(res.latitude, res.longitude);
          _this3.mapInstance.panTo(latlng);
          _this3.mapLocationList(latlng);
        },
        fail: function fail(res) {
          // 定位失败，用ip获取城市定位
          var citylocation = new qq.maps.CityService({
            complete: function complete(result) {
              _this3.mapInstance.panTo(result.detail.latLng);
              _this3.mapLocationList(result.detail.latLng);
            },
            error: function error() {
              // 城市定位失败，则就是默认的
              _this3.mapLocationList(mapInstance.getCenter());
            }
          });
          citylocation.searchLocalCity();
        }
      });
    }

    // 添加定位自定义控件

  }, {
    key: 'locationIcon',
    value: function locationIcon() {
      var _this4 = this;

      var locatioControl = document.createElement("div");
      locatioControl.style.cssText = 'width:35px;height:35px;border:1px solid #e9e9e9;border-radius: 20px;margin-right:10px;text-align: center;line-height: 35px;font-size: 20px;color: #07c160;background-color:#ffffff;';
      locatioControl.innerHTML = '<span class="icon-moon icon-relocate" style="line-height: 35px;"><span>';
      locatioControl.index = 3;

      this.mapInstance.controls[qq.maps.ControlPosition.RIGHT_BOTTOM].push(locatioControl);

      qq.maps.event.addListener(locatioControl, "click", function () {
        _this4.getLocation();
      });
    }

    // 添加中心点

  }, {
    key: 'centerIcon',
    value: function centerIcon() {
      var centerControl = document.createElement("div");
      centerControl.style.cssText = 'font-size: 20px;color: red;';
      centerControl.innerHTML = '<span class="icon-moon icon-fes_adress"><span>';
      centerControl.index = 3;

      this.mapInstance.controls[qq.maps.ControlPosition.CENTER].push(centerControl);
    }

    // 根据经纬度去设置地图中心点和拿附近的推荐点

  }, {
    key: 'mapLocationList',
    value: function mapLocationList(latLng, searchAddress) {
      var _this5 = this;

      var geocoder = new qq.maps.Geocoder({
        complete: function complete(result) {
          // this.marker && this.marker.setMap(null);
          // this.marker = new qq.maps.Marker({
          //     map: this.mapInstance,
          //     position: result.detail.location
          // });
          var nearPois = result.detail.nearPois;
          if (searchAddress && nearPois[0].name != searchAddress.name) {
            nearPois.unshift(searchAddress);
          }
          _this5.setState({
            locationPoi: searchAddress ? '' : result.detail,
            nearPois: nearPois,
            chooseIndex: searchAddress ? 0 : -1
          });
        }
      });
      geocoder.getAddress(latLng);
    }

    // 点击事件-选择定位地址

  }, {
    key: 'chooseLocationPoi',
    value: function chooseLocationPoi() {
      this.setState({
        chooseIndex: -1
      });
      this.mapInstance.panTo(this.state.locationPoi.location);
    }

    // 点击事件-列表选择位置

  }, {
    key: 'chooseNearPois',
    value: function chooseNearPois(index) {
      this.setState({
        chooseIndex: index
      });
      this.mapInstance.panTo(this.state.nearPois[index].latLng);
    }
    // 确定选择位置

  }, {
    key: 'chooseConfirm',
    value: function chooseConfirm() {
      var address = {};
      var chooseIndex = this.state.chooseIndex;
      if (chooseIndex == -1) {
        var choose = this.state.locationPoi;
        address = {
          name: choose.addressComponents.streetNumber,
          address: choose.address,
          latitude: choose.location.lat,
          longitude: choose.location.lng
        };
      } else {
        var _choose = this.state.nearPois[chooseIndex];
        address = {
          name: _choose.name,
          address: _choose.address,
          latitude: _choose.latLng.lat,
          longitude: _choose.latLng.lng
        };
      }
      ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
      typeof this.options.success === 'function' && this.options.success(address);
    }

    // 取消选择位置

  }, {
    key: 'chooseCancel',
    value: function chooseCancel() {
      ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
      typeof this.options.fail === 'function' && this.options.fail();
    }

    // 去搜索

  }, {
    key: 'gotoSearch',
    value: function gotoSearch() {
      this.setState({
        showSearch: true
      });
      this.textInput.current.focus();
    }

    // 取消搜索

  }, {
    key: 'cencelSearch',
    value: function cencelSearch() {
      this.setState({
        showSearch: false,
        searchValue: '',
        searchList: []
      });
    }

    // 删除搜索文字

  }, {
    key: 'deleteSearchText',
    value: function deleteSearchText() {
      this.setState({
        searchValue: '',
        searchList: []
      });
      this.textInput.current.focus();
    }

    // 搜索输入框输入事件

  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var _this6 = this;

      var value = e.target.value;

      this.setState({
        searchValue: value
      });

      if (!this.searchService) {
        this.searchService = new qq.maps.SearchService({
          complete: function complete(results) {
            var pois = results.detail.pois;
            console.log(results);
            if (results.type == "POI_LIST") {
              _this6.setState({
                searchList: pois
              });
            }
          }
        });
        this.searchService.setPageCapacity(15);
      }
      if (this.searchService) {
        var region = this.state.locationPoi ? this.state.locationPoi.addressComponents.city : '深圳';
        this.searchService.setLocation(region);
        this.searchService.search(value);
      }
    }

    // 选择搜索列表

  }, {
    key: 'chooseSearchPois',
    value: function chooseSearchPois(index) {
      var address = this.state.searchList[index];

      this.mapInstance.panTo(address.latLng);
      this.mapLocationList(address.latLng, address);
      this.setState({
        showSearch: false,
        searchValue: '',
        searchList: []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      return _react2.default.createElement(
        'div',
        { className: 'common-api choose-location' },
        _react2.default.createElement(
          'div',
          { className: 'choose-location-head' },
          _react2.default.createElement(
            'button',
            { className: 'choose-location-cancel', onClick: this.chooseCancel.bind(this) },
            '\u53D6\u6D88'
          ),
          _react2.default.createElement(
            'button',
            { className: 'choose-location-confirm', onClick: this.chooseConfirm.bind(this) },
            '\u786E\u5B9A'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'choose-location-search', onClick: this.gotoSearch.bind(this) },
          _react2.default.createElement('label', { className: 'icon-moon icon-search' }),
          _react2.default.createElement(
            'span',
            null,
            '\u641C\u7D22\u5730\u70B9'
          )
        ),
        _react2.default.createElement('div', { className: 'choose-location-map', id: 'choose-location-map' }),
        _react2.default.createElement(
          'div',
          { className: 'choose-location-address' },
          this.state.locationPoi && _react2.default.createElement(
            'div',
            { className: 'choose-address-current', onClick: this.chooseLocationPoi.bind(this) },
            _react2.default.createElement(
              'div',
              { className: 'choose-address-left' },
              _react2.default.createElement(
                'div',
                { className: 'choose-address-name' },
                this.state.locationPoi.address
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'choose-address-right' },
              this.state.chooseIndex == -1 ? _react2.default.createElement('label', { className: 'icon-moon icon-gou' }) : ''
            )
          ),
          this.state.nearPois.map(function (item, itemIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'choose-address-list', key: itemIndex, onClick: _this7.chooseNearPois.bind(_this7, itemIndex) },
              _react2.default.createElement(
                'div',
                { className: 'choose-address-left' },
                _react2.default.createElement(
                  'div',
                  { className: 'choose-address-name' },
                  item.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'choose-address-address' },
                  item.address
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'choose-address-right' },
                _this7.state.chooseIndex == itemIndex ? _react2.default.createElement('label', { className: 'icon-moon icon-gou' }) : ''
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'location-search-wrap', hidden: !this.state.showSearch },
          _react2.default.createElement(
            'div',
            { className: 'location-search-head' },
            _react2.default.createElement(
              'div',
              { className: 'location-search-input-wrap' },
              _react2.default.createElement('label', { className: 'icon-moon icon-search', htmlFor: 'location-search-input' }),
              _react2.default.createElement('input', { id: 'location-search-input', ref: this.textInput, type: 'text', placeholder: '\u641C\u7D22\u5730\u70B9', value: this.state.searchValue, onInput: function onInput(e) {
                  return _this7.handleInputChange(e);
                }, onChange: function onChange(e) {
                  return _this7.handleInputChange(e);
                } }),
              _react2.default.createElement('label', { className: 'location-search-input-delete icon-moon icon-close-btn', onClick: this.deleteSearchText.bind(this) })
            ),
            _react2.default.createElement(
              'div',
              { className: 'location-search-cancel', onClick: this.cencelSearch.bind(this) },
              '\u53D6\u6D88'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'location-search-list' },
            this.state.searchList.map(function (item, itemIndex) {
              return _react2.default.createElement(
                'div',
                { className: 'search-address-list', key: itemIndex, onClick: _this7.chooseSearchPois.bind(_this7, itemIndex) },
                _react2.default.createElement(
                  'div',
                  { className: 'search-address-name' },
                  item.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'search-address-address' },
                  item.address
                )
              );
            })
          )
        )
      );
    }
  }]);
  return ChooseLocation;
}(_react2.default.Component);

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenLocation = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(750);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenLocation = exports.OpenLocation = function (_React$Component) {
  (0, _inherits3.default)(OpenLocation, _React$Component);

  function OpenLocation(props) {
    (0, _classCallCheck3.default)(this, OpenLocation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OpenLocation.__proto__ || Object.getPrototypeOf(OpenLocation)).call(this, props));

    _this.options = _this.props.options;
    _this.mapInstance = null;
    _this.marker = null;

    return _this;
  }

  (0, _createClass3.default)(OpenLocation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.options || !this.options.latitude || !this.options.longitude) {
        _app.appMethod.showToast({
          title: '经纬度是必填参数'
        });
        console.error('openLocation接口，经纬度是必填参数');
        return;
      }

      // this.mapInstance = new qq.maps.Map(document.getElementById("open-location-map") , {
      //   zoom: 15,
      //   zoomControl: false,
      //   panControl: false,
      //   mapTypeControl: false
      // });

      // let latlng = new qq.maps.LatLng(this.options.latitude, this.options.longitude);
      // this.mapInstance.panTo(latlng);
      // this.setMarker(latlng);
      // this.locationIcon();
      // this.backIcon();
    }

    // 添加定位自定义控件

  }, {
    key: 'locationIcon',
    value: function locationIcon() {
      var _this2 = this;

      var locatioControl = document.createElement("div");
      locatioControl.style.cssText = 'width:35px;height:35px;border:1px solid #e9e9e9;border-radius: 20px;margin-right:10px;text-align: center;line-height: 35px;font-size: 20px;color: #07c160;background-color:#ffffff;';
      locatioControl.innerHTML = '<span class="icon-moon icon-relocate" style="line-height: 35px;"><span>';
      locatioControl.index = 3;

      this.mapInstance.controls[qq.maps.ControlPosition.RIGHT_BOTTOM].push(locatioControl);

      qq.maps.event.addListener(locatioControl, "click", function () {
        _this2.getLocation();
      });
    }

    // 添加返回按钮

  }, {
    key: 'backIcon',
    value: function backIcon() {
      var backControl = document.createElement("div");
      backControl.style.cssText = 'width:30px;height:30px;border-radius: 2px;margin:10px;text-align: center;line-height: 30px;font-size: 18px;color: #ffffff;background-color:rgba(0,0,0,.5);';
      backControl.innerHTML = '<span class="icon-moon icon-leftarrow" style="line-height: 30px;"><span>';
      backControl.index = 3;

      this.mapInstance.controls[qq.maps.ControlPosition.LEFT_TOP].push(backControl);

      qq.maps.event.addListener(backControl, "click", function () {
        ReactDOM.unmountComponentAtNode(document.getElementById('popup'));
      });
    }

    // 获取定位

  }, {
    key: 'getLocation',
    value: function getLocation() {
      var _this3 = this;

      _app.appMethod.getLocation({
        success: function success(res) {
          var latlng = new qq.maps.LatLng(res.latitude, res.longitude);
          _this3.mapInstance.panTo(latlng);
          _this3.setMarker(latlng);
        },
        fail: function fail(res) {
          // 定位失败，用ip获取城市定位
          var citylocation = new qq.maps.CityService({
            complete: function complete(result) {
              _this3.mapInstance.panTo(result.detail.latLng);
              _this3.setMarker(result.detail.latLng);
            },
            error: function error() {
              _app.appMethod.showToast({
                title: '定位失败'
              });
            }
          });
          citylocation.searchLocalCity();
        }
      });
    }

    // 设置标记

  }, {
    key: 'setMarker',
    value: function setMarker(latlng) {
      this.marker && this.marker.setMap(null);
      this.marker = new qq.maps.Marker({
        map: this.mapInstance,
        position: latlng
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'common-api open-location' },
        _react2.default.createElement('div', { className: 'open-location-map', id: 'open-location-map' })
      );
    }
  }]);
  return OpenLocation;
}(_react2.default.Component);

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(154);

var _history = __webpack_require__(107);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _CustomPage = __webpack_require__(752);

var _CustomPage2 = _interopRequireDefault(_CustomPage);

var _LoadingPage = __webpack_require__(207);

var _LoadingPage2 = _interopRequireDefault(_LoadingPage);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _officialPageList = __webpack_require__(175);

var _officialPageList2 = _interopRequireDefault(_officialPageList);

var _GoodsShoppingCart = __webpack_require__(103);

var _TostoreShoppingCart = __webpack_require__(945);

var _RewardPointModal = __webpack_require__(947);

var _ShowVipModal = __webpack_require__(949);

var _PageQrcode = __webpack_require__(951);

var _Pay = __webpack_require__(953);

var _weixinSdkConfig = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import AlloyLever from 'alloylever';

// import '@mock/appdata'; // TODO：test 仅开发环境
// import '@mock/formdata'; // TODO：test 仅开发环境

/**
 * 用户页面路由数据(空数组)
 */
var customRoutes = [];
/**
 * 官方页面路由数据(所有的页面的对应路由)
 */
var officialRoutes = Object.keys(_officialPageList2.default);
/**
 * 官方页面外层包一层
 */
function wrapperOfficialPage(route, props) {

  // 控制台输出当前页面信息
  console.log('\u3010\u5F53\u524D\u5E94\u7528\u3011' + _app.appMethod.getAppId() + '\n\u3010\u9875\u9762\u8DEF\u7531\u3011' + route + ' \n\u3010\u53EF\u590D\u73B0\u8DEF\u5F84\u3011' + window.location.href);
  // 是否为底部导航
  var isTabBarPage = _app.appMethod.globalData.tabBarPagePathArr.indexOf(route) > -1;
  // 底部导航组件
  var $tabNav = function $tabNav() {
    // 当前页面设为底部导航
    if (isTabBarPage) {
      var appData = _app.appInstance.state.appData;
      var tabBarData = appData.data['tab-bar']; // 底部导航数据
      var bottomNarData = {
        type: 'tab-nav',
        content: tabBarData.list,
        customFeature: {
          color: tabBarData.color || '#59607B',
          selectedColor: tabBarData.selectedColor || 'inherit',
          backgroundColor: tabBarData.backgroundColor || '#fff',
          borderStyle: tabBarData.borderStyle || 'black',
          position: 'bottom'
        }
      };
      return _react2.default.createElement(_CustomComponent2.default, (0, _extends3.default)({}, props, { data: bottomNarData }));
    }
  };
  return _react2.default.createElement(
    'div',
    { className: 'official-page ' + route, style: {
        height: isTabBarPage ? 'calc(100vh - 48px)' : null
      } },
    _officialPageList2.default[route](props),
    $tabNav()
  );
}
/**
 * 设置app导航数据
 */
function setTabBarData(appData) {
  var tabBarData = appData.data['tab-bar']; // 底部导航数据
  if (!tabBarData) {
    return;
  }
  var bottomNarData = { // 底部导航组件
    type: 'tab-nav',
    content: tabBarData.list,
    customFeature: {
      color: tabBarData.color || '#59607B',
      selectedColor: tabBarData.selectedColor || 'inherit',
      backgroundColor: tabBarData.backgroundColor || '#fff',
      borderStyle: tabBarData.borderStyle || 'black',
      position: 'bottom'
    }
  };
  var arr = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = tabBarData.list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      var router = item.router;
      // TODO: 还没处理完  
      if (router.indexOf('tabbar') > -1) {
        router = router.replace(/tabbar/gi, '');
        item.router = router = router.replace(router[0], router[0].toLowerCase());
      }
      if (router && appData[router]) {
        appData[router].eles.push(bottomNarData);
      }
      arr.push(router);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  _app.appMethod.globalData.tabBarPagePathArr = arr;
}
/**
 * 判断当前AppData是否有某个组件
 */
function hasCustomComponent(appData, componentType) {
  // 当前应用数据
  var data = appData;
  // 当前组件类型
  var type = componentType;
  // 标记是否有当前组件
  var flag = false;
  var findComponent = function findComponent(ele) {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (ele.type === type) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = ele.content[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var subEle = _step2.value;

          findComponent(subEle);
          if (flag) {
            return;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else if (ele.type === 'layout-vessel') {
      // 双栏组件的content不为数组
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = Object.keys(ele.content)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var attr = _step3.value;
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = ele.content[attr][Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var _subEle = _step4.value;

              findComponent(_subEle);
              if (flag) {
                return;
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  };
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = Object.keys(data)[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var key = _step5.value;

      if (key.includes('page') || key.includes('Page')) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = data[key]['eles'][Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var ele = _step6.value;

            findComponent(ele);
            if (flag) {
              break;
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        if (flag) {
          break;
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return flag;
}

var App = function (_React$Component) {
  (0, _inherits3.default)(App, _React$Component);

  function App(props) {
    (0, _classCallCheck3.default)(this, App);

    var _this = (0, _possibleConstructorReturn3.default)(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      allData: null,
      appData: null,
      loading: true,
      pathname: ''
    };
    _this.goodsShoppingCartRef = _react2.default.createRef();
    _this.tostoreShoppingCartRef = _react2.default.createRef();
    _this.pageQrcodeRef = _react2.default.createRef();
    _this.payRef = _react2.default.createRef();
    _this.rewardPointModalRef = _react2.default.createRef();
    _this.showVipModalRef = _react2.default.createRef();

    var url = window.location.href; // 获取当前页面 URL
    var parsedUrl = new URL(url);
    var pathname = parsedUrl.pathname.split('/').pop();
    console.log('路由路径:', pathname);

    var appId = (0, _tools.getQueryString)('app_id') || _app.appMethod.getAppId();
    // appId = 'mGM61666Ma'; // TODO: 临时测试使用，之后要删掉
    if (!appId) {
      return (0, _possibleConstructorReturn3.default)(_this);
    }
    _app.appMethod.setAppId(appId);
    (0, _app.setApp)(_this);
    // 保存当前初始化时的参数
    _app.appMethod.setQueryParams();
    /**
     * 设置是否登录（微信浏览器中处理/抖音浏览器/游客登录(在预览页中嵌套)）
     */
    if (_app.appMethod.isWeixin()) {
      // 判断是否登录
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/LoginState',
        success: function success(res) {
          if (res.data) {
            // 设置登录成功
            _app.appMethod.setIsLogin(true);
            // 请求用户信息
            _app.appMethod.requestUserInfo();
            // 绑定用户微信号信息
            _app.appMethod.bindUserAccount();
          } else {
            _app.appMethod.goLogin();
          }
        }
      });
    } else if (_app.appMethod.isDouyin()) {
      // 判断是否登录
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppUser/LoginState',
        success: function success(res) {
          if (res.data) {
            // 设置登录成功
            _app.appMethod.setIsLogin(true);
            // 请求用户信息
            _app.appMethod.requestUserInfo();
            // 绑定用户微信号信息
            _app.appMethod.bindUserAccount();
          }
        }
      });
    } else if (localStorage.getItem('is_preview') == 1 || (0, _tools.getQueryString)('is_preview')) {
      // 游客登录 去登录（在预览页中嵌套中用此登录）
      _app.appMethod.autoTouristLogin().then(function () {
        _this.init();
      });
      return (0, _possibleConstructorReturn3.default)(_this);
    }

    if (pathname !== 'tap-pay') {
      _this.init();
    }

    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var url = window.location.href;
      var parsedUrl = new URL(url);
      var pathname = parsedUrl.pathname.split('/').pop();
      if (pathname == 'tap-pay') {
        this.setState({ loading: false }); // 否则直接更新 loading 状态
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      if (_app.appMethod.isLogin()) {
        _app.appMethod.globalData.isLogin = true;
      }
      // 请求app全局数据
      (0, _http.ajax)({
        url: '/index.php?r=AppData/detail',
        type: 'post',
        data: {
          app_id: (0, _global.getAppId)(),
          from: (0, _tools.getQueryString)('from'),
          history_id: (0, _tools.getQueryString)('history_id')
        },
        success: function success(res) {
          if (res.status !== 0) {
            if (res.status === 3 && res.data === '应用被屏蔽') {
              window.location.href = 'https://u513199.jisuapp.cn/zc_webapp/page10000?app_id=Wp06QHZ4MW';
              return;
            }
            _toast2.default.info(res.data);
            return;
          }
          var allData = res.data;
          if (!allData.app_data) {
            _toast2.default.info('您的应用没有内容哦');
            return;
          }
          var appData = JSON.parse(allData.app_data);
          // 处理APP的页面，放入【自定义页面列表】
          for (var i in appData) {
            if (!appData.hasOwnProperty(i)) {
              continue;
            }
            if (/page\d{5}/g.test(i) || i === 'storeSinglePage' || i === 'userCenterComponentPage') {
              customRoutes.push(appData[i]['router']);
            }
          }
          // 设置首页
          _app.appMethod.globalData['homepageRouter'] = appData.data['xcx-homepage-router'] || appData.data['homepage-router'];
          // 设置历史版本
          _app.appMethod.globalData['historyDataId'] = allData['his_id'];
          // 设置APP名称
          _app.appMethod.globalData['appTitle'] = allData['app_name'];
          // 设置APP详情
          _app.appMethod.globalData['appDescription'] = allData['description'];
          // 设置APP的logo
          _app.appMethod.globalData['appLogo'] = allData['logo'];
          /**
           * 设置当前APP是否有某个组件
           */
          // 是否有多商家
          _app.appMethod.globalData['hasFranchiseeList'] = hasCustomComponent(appData, 'franchisee-list');
          // 是否有多商家连锁组件
          _app.appMethod.globalData['hasFranchiseeChain'] = hasCustomComponent(appData, 'franchisee-chain');
          /**
           * 设置app导航数据
           */
          setTabBarData(appData);

          /**
           * 设置当前页面栈(要在导航数据设置完之后处理)
           */
          _app.appMethod.globalData.currentPages = [{
            route: _history.location.pathname.split('/')[1] || _app.appMethod.globalData['homepageRouter'],
            callbackData: null,
            setData: function setData(data) {
              if (this.callbackData) {
                this.callbackData = (0, _extends3.default)({}, this.callbackData, data);
              } else {
                this.callbackData = data;
              }
            },
            clearCallbackData: function clearCallbackData() {
              this.callbackData = null;
            }
          }];
          /**
           * 设置初始化
           */
          _app.appMethod.onLaunch();
          _app.appMethod.onShow();
          _this2.configSDK();
          _this2.setState({
            allData: allData,
            appData: appData,
            loading: false
          });
          // this.setAlloyLever();
          /**
           * 初始化，发送消息, 传递给父级窗口message
           */
          // if (window.top !== window) {
          //   var data = JSON.stringify({
          //     name: 'appInit',
          //     url: window.location.href,
          //     router: location.pathname.replace('/', '') || app.globalData['homepageRouter'],
          //   })
          //   window.parent.postMessage(data, '*');
          // }
          /**
           * 接收消息
           */
          window.addEventListener("message", function (event) {

            try {
              if (event && event.data) {
                if (typeof event.data !== 'string') {
                  return;
                }
                // 获取父级窗口message并跳转页面
                var data = JSON.parse(event.data);
                _app.appMethod.turnToPage(data.router);
              }
            } catch (err) {
              console.log(err);
            }
          }, false);
        },
        error: function error(err) {
          console.error(err);
          _toast2.default.info(err, 2);
        }
      });
    }
  }, {
    key: 'configSDK',
    value: function configSDK() {
      if (_app.appMethod.isWeixin()) {
        (0, _weixinSdkConfig.configWxSDK)();
      }
    }

    // // 设置调试面板vConsole。一般不要调用这个，只有需要才调用。 参考 https://github.com/AlloyTeam/AlloyLever
    // setAlloyLever(){
    //   AlloyLever.config({
    //     cdn:'//s.url.cn/qqun/qun/qqweb/m/qun/confession/js/vconsole.min.js',  //vconsole的CDN地址
    //     reportUrl: "",  //错误上报地址
    //     reportPrefix: 'web',    //错误上报msg前缀，一般用于标识业务类型
    //     reportKey: 'msg',        //错误上报msg前缀的key，用户上报系统接收存储msg
    //     otherReport: {              //需要上报的其他信息

    //     },
    //     entry: ""          //请点击这个DOM元素6次召唤vConsole。//你可以通过AlloyLever.entry('#entry2')设置多个机关入口召唤神龙
    //   })
    // }

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          appData = _state.appData,
          loading = _state.loading;

      var homepageRouter = _app.appMethod.globalData['homepageRouter'];
      if (loading) {
        return _react2.default.createElement(_LoadingPage2.default, null);
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _reactRouterDom.Switch,
          null,
          customRoutes.map(function (route) {
            return _react2.default.createElement(_reactRouterDom.Route, { key: route, path: '/' + route, render: function render(props) {
                return _react2.default.createElement(_CustomPage2.default, (0, _extends3.default)({ data: appData[route] }, props));
              } });
          }),
          officialRoutes.map(function (route) {
            return _react2.default.createElement(_reactRouterDom.Route, { key: route, path: '/' + route, render: function render(props) {
                return wrapperOfficialPage(route, props);
              } });
          }),
          _react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: '/', to: homepageRouter })
        ),
        _react2.default.createElement(_GoodsShoppingCart.GoodsShoppingCart, { ref: this.goodsShoppingCartRef }),
        _react2.default.createElement(_TostoreShoppingCart.TostoreShoppingCart, { ref: this.tostoreShoppingCartRef }),
        _react2.default.createElement(_PageQrcode.PageQrcode, { ref: this.pageQrcodeRef }),
        _react2.default.createElement(_RewardPointModal.RewardPointModal, { ref: this.rewardPointModalRef }),
        _react2.default.createElement(_ShowVipModal.ShowVipModal, { ref: this.showVipModalRef }),
        _react2.default.createElement(_Pay.Pay, { ref: this.payRef })
      );
    }
  }]);
  return App;
}(_react2.default.Component);

exports.default = App;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _common = __webpack_require__(140);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

var _tools = __webpack_require__(6);

var _TechSupport = __webpack_require__(935);

var _Filter = __webpack_require__(936);

var _FormPay = __webpack_require__(938);

var _SinkingModal = __webpack_require__(196);

var _CommunityPublish = __webpack_require__(940);

var _CommunityPublishType = __webpack_require__(942);

var _TopNav = __webpack_require__(8);

var _weixinSdkConfig = __webpack_require__(81);

__webpack_require__(944);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var safeSet = function safeSet(object, path, value) {
  return object == null ? object : (0, _common.baseSet)(object, path, value);
};

function defineGetter(component, key, getter) {
  Object.defineProperty(component, key, {
    enumerable: true,
    configurable: true,
    get: function get() {
      if (getter === 'props') {
        return component.props;
      }
      return (0, _extends3.default)({}, component.props, component.state);
    }
  });
}

/**
 * 处理当前组件列表
 * @param {*} eles 组件数组
 */
var dealEles = function dealEles(eles) {
  // 个人中心组件 旧版=>新版
  var userCenterIndex = eles.findIndex(function (ele) {
    return ele.type === 'user-center';
  });
  if (userCenterIndex > -1) {
    var dealUserCenterHead = function dealUserCenterHead(oldData) {
      var newData = JSON.parse(JSON.stringify(oldData));
      newData.customFeature = (0, _extends3.default)({}, oldData.customFeature, {
        'member': oldData.customFeature["member"] || (oldData.customFeature["personal-mode"] == 3 ? 2 : 1),
        'personal-mode': oldData.customFeature["personal-mode"] || 1,
        'senior-mode': oldData.customFeature["senior-mode"] || 1
      });
      return newData;
    };
    // 个人中心头部


    var dealUserCenterContent = function dealUserCenterContent(oldData) {
      var newData = JSON.parse(JSON.stringify(oldData));
      return newData;
    };
    // 个人中心内容


    var userCenterHead = JSON.parse(JSON.stringify(eles[userCenterIndex]));
    userCenterHead = dealUserCenterHead(eles[userCenterIndex]);
    userCenterHead['type'] = 'user-center-head';
    var userCenterContent = JSON.parse(JSON.stringify(eles[userCenterIndex]));
    userCenterContent = dealUserCenterContent(eles[userCenterIndex]);
    userCenterContent['type'] = 'user-center-content';
    eles.splice(userCenterIndex, 1, userCenterHead, userCenterContent);
  }
};

var CustomPage = function (_React$Component) {
  (0, _inherits3.default)(CustomPage, _React$Component);

  function CustomPage(props) {
    (0, _classCallCheck3.default)(this, CustomPage);

    // 绑定data到state上
    var _this = (0, _possibleConstructorReturn3.default)(this, (CustomPage.__proto__ || Object.getPrototypeOf(CustomPage)).call(this, props));

    _this.id = (0, _tools.randomWord)(8);
    _this.route = _this.props.location.pathname.split('/')[1];
    _this.shareData = {};
    _this.downcountObject = {};
    _this.requesting = false;
    _this.requestNum = 1;
    _this.page_router = _this.props.data.router;
    _this.filterRef = _react2.default.createRef();
    _this.formPayRef = _react2.default.createRef();
    _this.communityPublishRef = _react2.default.createRef();
    _this.communityPublishTypeRef = _react2.default.createRef();

    _this.setData = function (obj, callback) {
      var state = Object.assign({}, _this.state);
      Object.keys(obj).forEach(function (key) {
        safeSet(state, key, obj[key]);
      });
      Object.assign(_this.state, state);
      _this.setState(state);
      setTimeout(function () {
        typeof callback == 'function' && callback();
      }, 0);
    };

    _this.setComponentRef = function (index, ref) {
      _page.pageComponentRefs[index] = ref;
    };

    _this.callComponentMethod = function (_ref) {
      var componentIndex = _ref.componentIndex,
          methodName = _ref.methodName,
          argvs = _ref.argvs;

      if (componentIndex > -1 && _page.pageComponentRefs[componentIndex].current) {
        var _pageComponentRefs$co;

        return (_pageComponentRefs$co = _page.pageComponentRefs[componentIndex].current)[methodName].apply(_pageComponentRefs$co, (0, _toConsumableArray3.default)(argvs));
      }
    };

    _this.setShareData = function () {
      if (!_this.onShareAppMessage) {
        return;
      }
      _this.shareData = _this.onShareAppMessage();
      var url = _this.shareData.path;
      var urlArr = url.split('/');
      url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
      if (!/app_id/.test(url)) {
        if (url.indexOf('?') < 0) {
          url = url + '?app_id=' + _app.appMethod.getAppId();
        } else {
          url = url + '&app_id=' + _app.appMethod.getAppId();
        }
      }
      _this.shareData.path = url;
      if (_app.appMethod.isWeixin()) {
        (0, _weixinSdkConfig.configWxShare)({
          title: _this.shareData.title,
          link: _this.shareData.path,
          imgUrl: _this.shareData.imageUrl,
          desc: _this.shareData.desc
        });
      }
    };

    _this.shareClickEvent = function () {
      _app.appMethod.shareClickEvent();
    };

    _this.onShareAppMessage = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // if (e.from == 'button') {
      //   if (e.target.dataset && e.target.dataset.from == 'topicButton') {
      //     let franchiseeId = app.getPageFranchiseeId();
      //     let chainParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
      //     return app.shareAppMessage({
      //       path: '/informationManagement/pages/communityDetail/communityDetail?detail=' + e.target.dataset.id + chainParam,
      //       desc: e.target.dataset.desc
      //     });
      //   }
      // };
      return _app.appMethod.onPageShareAppMessage(e);
    };

    _this.scrollAllowBottom = true;

    _this.onPageScroll = function (event) {
      var customPageDom = _this.customPageRef.current;
      event = (0, _extends3.default)({}, event, {
        scrollTop: customPageDom.scrollTop,
        scrollLeft: customPageDom.scrollLeft,
        scrollWidth: customPageDom.scrollWidth,
        scrollHeight: customPageDom.scrollHeight
      });
      _app.appMethod.onPageScroll(event);
      var scrollDom = _this.customPageRef.current;
      if (scrollDom.scrollTop + scrollDom.clientHeight >= scrollDom.scrollHeight - 100 && _this.scrollAllowBottom) {
        _this.scrollAllowBottom = false;
        _app.appMethod.onPageReachBottom(_this.reachBottomFuc);
      } else if (scrollDom.scrollTop + scrollDom.clientHeight < scrollDom.scrollHeight - 100) {
        _this.scrollAllowBottom = true;
      }
    };

    defineGetter(_this, 'data', 'state');
    var data = props.data;
    // 判断当前页是否需要登录

    if (data.customFeature.needLogin && !_app.appMethod.isLogin()) {
      _app.appMethod.goLogin();
      return (0, _possibleConstructorReturn3.default)(_this);
    }
    // 设置当前页面标题
    document.title = data.customFeature.name || data.customFeature.title;
    // 处理当前组件列表
    dealEles(data.eles);
    // 设置当前页面state
    _this.state = Object.assign({
      detailData: null // 详情页数据
    }, data);
    _this.customPageRef = _react2.default.createRef();
    // 设置当前页组件实例
    (0, _page.setPage)(_this);
    // WEBAPP: 处理后一个页面回来的回调
    if (_app.appMethod.getCurrentPage().callbackData || _app.appMethod.getCurrentPage().callbackFun) {
      _this.currentPage = _app.appMethod.getCurrentPage();
    }
    // 设置分享数据
    setTimeout(function () {
      _this.setShareData();
    }, 3000);
    // 控制台输出当前页面信息
    console.log('\u3010\u5F53\u524D\u5E94\u7528\u3011' + _app.appMethod.getAppId() + '\n\u3010\u5F53\u524D\u9875\u9762\u3011' + document.title + '\n\u3010\u9875\u9762\u8DEF\u7531\u3011' + data.router + ' \n\u3010\u53EF\u590D\u73B0\u8DEF\u5F84\u3011' + window.location.href);
    return _this;
  }

  // WEBAPP: 处理后一个页面回来的回调
  //页面倒计时实例对象

  /**
   * 页面变量
   */


  (0, _createClass3.default)(CustomPage, [{
    key: 'handleCurrentPage',
    value: function handleCurrentPage() {
      if (!this.currentPage) {
        return;
      }
      if (this.currentPage.callbackData) {
        this.setData(this.currentPage.callbackData);
        this.currentPage.clearCallbackData();
      }
      if (this.currentPage.callbackFun) {
        this.currentPage.calllbackFun();
        delete this.currentPage.calllbackFun;
      }
    }

    // 组件挂载完成

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _tools.getCurrentPageQueryParams)();

      // 防止未设置state时进行跳转，则不进行页面初始化
      if (!this.state) {
        return;
      }
      _app.appMethod.onPageLoad(options);
      _app.appMethod.onPageShow();
      // 判断是否需要登录
      _app.appMethod.isNeedRewardModal();
      // WEBAPP: 处理后一个页面回来的回调
      this.handleCurrentPage();
    }
    /**
     * 设置数据
     */

    /**
     * 设置组件ref
     */

    /**
     * 调用组件方法
     */


    // 分享的点击事件（对小程序分享按钮的另种实现）

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 防止未设置state时进行跳转
      if (!this.state) {
        return null;
      }
      var _state = this.state,
          eles = _state.eles,
          detailData = _state.detailData,
          customFeature = _state.customFeature,
          techSupport = _state.techSupport;

      var styleObj = {
        backgroundColor: customFeature['background-color'],
        backgroundImage: customFeature['background-image'],
        paddingBottom: _app.appMethod.isTabBarPage() ? '48px' : null
      };
      var isTabBarPage = _app.appMethod.isTabBarPage();
      return _react2.default.createElement(
        'div',
        { ref: this.customPageRef, className: 'custom-page', style: styleObj, onScroll: this.onPageScroll },
        _react2.default.createElement(_TopNav.TopNav, { title: customFeature.name }),
        eles.map(function (ele, index) {
          var ref = _react2.default.createRef();
          _this2.setComponentRef(index, ref);
          return _react2.default.createElement(_CustomComponent2.default, (0, _extends3.default)({}, _this2.props, { ref: ref, key: index, index: index, data: ele, detailData: detailData }));
        }),
        isTabBarPage && techSupport == 'not_vip' && _react2.default.createElement(_TechSupport.TechSupport, null),
        _react2.default.createElement(_Filter.Filter, { ref: this.filterRef }),
        _react2.default.createElement(_FormPay.FormPay, { ref: this.formPayRef }),
        _react2.default.createElement(_SinkingModal.SinkingModal, null),
        _react2.default.createElement(_CommunityPublish.CommunityPublish, { ref: this.communityPublishRef }),
        _react2.default.createElement(_CommunityPublishType.CommunityPublishType, { ref: this.communityPublishTypeRef })
      );
    }
  }]);
  return CustomPage;
}(_react2.default.Component);

exports.default = CustomPage;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _TextCustomComponent = __webpack_require__(754);

var _TextCustomComponent2 = _interopRequireDefault(_TextCustomComponent);

var _PictureCustomComponent = __webpack_require__(756);

var _PictureCustomComponent2 = _interopRequireDefault(_PictureCustomComponent);

var _ListVesselCustomComponent = __webpack_require__(758);

var _ListVesselCustomComponent2 = _interopRequireDefault(_ListVesselCustomComponent);

var _DynamicClassifyCustomComponent = __webpack_require__(762);

var _DynamicClassifyCustomComponent2 = _interopRequireDefault(_DynamicClassifyCustomComponent);

var _DynamicVesselCustomComponent = __webpack_require__(764);

var _DynamicVesselCustomComponent2 = _interopRequireDefault(_DynamicVesselCustomComponent);

var _FormVesselCustomComponent = __webpack_require__(766);

var _FormVesselCustomComponent2 = _interopRequireDefault(_FormVesselCustomComponent);

var _InputEleCustomComponent = __webpack_require__(768);

var _InputEleCustomComponent2 = _interopRequireDefault(_InputEleCustomComponent);

var _TextareaEleCustomComponent = __webpack_require__(770);

var _TextareaEleCustomComponent2 = _interopRequireDefault(_TextareaEleCustomComponent);

var _GradeEleCustomComponent = __webpack_require__(772);

var _GradeEleCustomComponent2 = _interopRequireDefault(_GradeEleCustomComponent);

var _SelectEleCustomComponent = __webpack_require__(784);

var _SelectEleCustomComponent2 = _interopRequireDefault(_SelectEleCustomComponent);

var _UploadImgCustomComponent = __webpack_require__(791);

var _UploadImgCustomComponent2 = _interopRequireDefault(_UploadImgCustomComponent);

var _TimeEleCustomComponent = __webpack_require__(793);

var _TimeEleCustomComponent2 = _interopRequireDefault(_TimeEleCustomComponent);

var _DropDownCustomComponent = __webpack_require__(795);

var _DropDownCustomComponent2 = _interopRequireDefault(_DropDownCustomComponent);

var _PicOptionsCustomComponent = __webpack_require__(797);

var _PicOptionsCustomComponent2 = _interopRequireDefault(_PicOptionsCustomComponent);

var _AddressEleCustomComponent = __webpack_require__(799);

var _AddressEleCustomComponent2 = _interopRequireDefault(_AddressEleCustomComponent);

var _FormButtonCustomComponent = __webpack_require__(801);

var _FormButtonCustomComponent2 = _interopRequireDefault(_FormButtonCustomComponent);

var _FreeVesselCustomComponent = __webpack_require__(803);

var _FreeVesselCustomComponent2 = _interopRequireDefault(_FreeVesselCustomComponent);

var _TabNavCustomComponent = __webpack_require__(805);

var _TabNavCustomComponent2 = _interopRequireDefault(_TabNavCustomComponent);

var _GoodsListCustomComponent = __webpack_require__(807);

var _GoodsListCustomComponent2 = _interopRequireDefault(_GoodsListCustomComponent);

var _ButtonCustomComponent = __webpack_require__(809);

var _ButtonCustomComponent2 = _interopRequireDefault(_ButtonCustomComponent);

var _LayoutVesselCustomComponent = __webpack_require__(811);

var _LayoutVesselCustomComponent2 = _interopRequireDefault(_LayoutVesselCustomComponent);

var _TitleEleCustomComponent = __webpack_require__(813);

var _TitleEleCustomComponent2 = _interopRequireDefault(_TitleEleCustomComponent);

var _NewsCustomComponent = __webpack_require__(815);

var _NewsCustomComponent2 = _interopRequireDefault(_NewsCustomComponent);

var _CarouselCustomComponent = __webpack_require__(817);

var _CarouselCustomComponent2 = _interopRequireDefault(_CarouselCustomComponent);

var _BreaklineCustomComponent = __webpack_require__(819);

var _BreaklineCustomComponent2 = _interopRequireDefault(_BreaklineCustomComponent);

var _StaticVesselCustomComponent = __webpack_require__(821);

var _StaticVesselCustomComponent2 = _interopRequireDefault(_StaticVesselCustomComponent);

var _AudioCustomComponent = __webpack_require__(823);

var _AudioCustomComponent2 = _interopRequireDefault(_AudioCustomComponent);

var _AlbumCustomComponent = __webpack_require__(825);

var _AlbumCustomComponent2 = _interopRequireDefault(_AlbumCustomComponent);

var _AnnounceCustomComponent = __webpack_require__(827);

var _AnnounceCustomComponent2 = _interopRequireDefault(_AnnounceCustomComponent);

var _ListCustomComponent = __webpack_require__(833);

var _ListCustomComponent2 = _interopRequireDefault(_ListCustomComponent);

var _SuspensionCustomComponent = __webpack_require__(835);

var _SuspensionCustomComponent2 = _interopRequireDefault(_SuspensionCustomComponent);

var _VideoCustomComponent = __webpack_require__(837);

var _VideoCustomComponent2 = _interopRequireDefault(_VideoCustomComponent);

var _NewSuspensionCustomComponent = __webpack_require__(839);

var _NewSuspensionCustomComponent2 = _interopRequireDefault(_NewSuspensionCustomComponent);

var _PopupWindowCustomComponent = __webpack_require__(841);

var _PopupWindowCustomComponent2 = _interopRequireDefault(_PopupWindowCustomComponent);

var _SlidingPanelCustomComponent = __webpack_require__(843);

var _SlidingPanelCustomComponent2 = _interopRequireDefault(_SlidingPanelCustomComponent);

var _FranchiseeListCustomComponent = __webpack_require__(845);

var _FranchiseeListCustomComponent2 = _interopRequireDefault(_FranchiseeListCustomComponent);

var _FranchiseeChainCustomComponent = __webpack_require__(847);

var _FranchiseeChainCustomComponent2 = _interopRequireDefault(_FranchiseeChainCustomComponent);

var _SidebarCustomComponent = __webpack_require__(849);

var _SidebarCustomComponent2 = _interopRequireDefault(_SidebarCustomComponent);

var _AdvertisingCustomComponent = __webpack_require__(851);

var _AdvertisingCustomComponent2 = _interopRequireDefault(_AdvertisingCustomComponent);

var _PluginCustomComponent = __webpack_require__(853);

var _PluginCustomComponent2 = _interopRequireDefault(_PluginCustomComponent);

var _OfficialAccountCustomComponent = __webpack_require__(855);

var _OfficialAccountCustomComponent2 = _interopRequireDefault(_OfficialAccountCustomComponent);

var _ClassifyCustomComponent = __webpack_require__(857);

var _ClassifyCustomComponent2 = _interopRequireDefault(_ClassifyCustomComponent);

var _CountCustomComponent = __webpack_require__(859);

var _CountCustomComponent2 = _interopRequireDefault(_CountCustomComponent);

var _NewCountCustomComponent = __webpack_require__(861);

var _NewCountCustomComponent2 = _interopRequireDefault(_NewCountCustomComponent);

var _MapCustomComponent = __webpack_require__(863);

var _MapCustomComponent2 = _interopRequireDefault(_MapCustomComponent);

var _SearchCustomComponent = __webpack_require__(865);

var _SearchCustomComponent2 = _interopRequireDefault(_SearchCustomComponent);

var _SortCustomComponent = __webpack_require__(867);

var _SortCustomComponent2 = _interopRequireDefault(_SortCustomComponent);

var _CitylocationCustomComponent = __webpack_require__(869);

var _CitylocationCustomComponent2 = _interopRequireDefault(_CitylocationCustomComponent);

var _NewClassifyCustomComponent = __webpack_require__(873);

var _NewClassifyCustomComponent2 = _interopRequireDefault(_NewClassifyCustomComponent);

var _FilterCustomComponent = __webpack_require__(875);

var _FilterCustomComponent2 = _interopRequireDefault(_FilterCustomComponent);

var _CommunityGroupCustomComponent = __webpack_require__(877);

var _CommunityGroupCustomComponent2 = _interopRequireDefault(_CommunityGroupCustomComponent);

var _ExchangeCouponCustomComponent = __webpack_require__(879);

var _ExchangeCouponCustomComponent2 = _interopRequireDefault(_ExchangeCouponCustomComponent);

var _RowNumCustomComponent = __webpack_require__(881);

var _RowNumCustomComponent2 = _interopRequireDefault(_RowNumCustomComponent);

var _TakeoutCustomComponent = __webpack_require__(883);

var _TakeoutCustomComponent2 = _interopRequireDefault(_TakeoutCustomComponent);

var _TostoreCustomComponent = __webpack_require__(887);

var _TostoreCustomComponent2 = _interopRequireDefault(_TostoreCustomComponent);

var _CommunityCustomComponent = __webpack_require__(889);

var _CommunityCustomComponent2 = _interopRequireDefault(_CommunityCustomComponent);

var _TopicCustomComponent = __webpack_require__(891);

var _TopicCustomComponent2 = _interopRequireDefault(_TopicCustomComponent);

var _SignInCustomComponent = __webpack_require__(893);

var _SignInCustomComponent2 = _interopRequireDefault(_SignInCustomComponent);

var _GroupBuyListCustomComponent = __webpack_require__(895);

var _GroupBuyListCustomComponent2 = _interopRequireDefault(_GroupBuyListCustomComponent);

var _GroupBuyStatusCustomComponent = __webpack_require__(897);

var _GroupBuyStatusCustomComponent2 = _interopRequireDefault(_GroupBuyStatusCustomComponent);

var _SeckillCustomComponent = __webpack_require__(899);

var _SeckillCustomComponent2 = _interopRequireDefault(_SeckillCustomComponent);

var _TimelineCustomComponent = __webpack_require__(904);

var _TimelineCustomComponent2 = _interopRequireDefault(_TimelineCustomComponent);

var _BbsCustomComponent = __webpack_require__(906);

var _BbsCustomComponent2 = _interopRequireDefault(_BbsCustomComponent);

var _VideoListCustomComponent = __webpack_require__(908);

var _VideoListCustomComponent2 = _interopRequireDefault(_VideoListCustomComponent);

var _TopicClassifyCustomComponent = __webpack_require__(910);

var _TopicClassifyCustomComponent2 = _interopRequireDefault(_TopicClassifyCustomComponent);

var _TopicSortCustomComponent = __webpack_require__(912);

var _TopicSortCustomComponent2 = _interopRequireDefault(_TopicSortCustomComponent);

var _UserCenterHeadCustomComponent = __webpack_require__(914);

var _UserCenterHeadCustomComponent2 = _interopRequireDefault(_UserCenterHeadCustomComponent);

var _UserCenterContentCustomComponent = __webpack_require__(916);

var _UserCenterContentCustomComponent2 = _interopRequireDefault(_UserCenterContentCustomComponent);

var _CustomTopNavCustomComponent = __webpack_require__(918);

var _CustomTopNavCustomComponent2 = _interopRequireDefault(_CustomTopNavCustomComponent);

var _PresellCustomComponent = __webpack_require__(920);

var _PresellCustomComponent2 = _interopRequireDefault(_PresellCustomComponent);

var _VerticalListCustomComponent = __webpack_require__(922);

var _VerticalListCustomComponent2 = _interopRequireDefault(_VerticalListCustomComponent);

var _StoredValueCustomComponent = __webpack_require__(924);

var _StoredValueCustomComponent2 = _interopRequireDefault(_StoredValueCustomComponent);

var _UploadVideoCustomComponent = __webpack_require__(926);

var _UploadVideoCustomComponent2 = _interopRequireDefault(_UploadVideoCustomComponent);

var _AnonymousEleCustomComponent = __webpack_require__(928);

var _AnonymousEleCustomComponent2 = _interopRequireDefault(_AnonymousEleCustomComponent);

var _CommunityGoodsListCustomComponent = __webpack_require__(930);

var _CommunityGoodsListCustomComponent2 = _interopRequireDefault(_CommunityGoodsListCustomComponent);

var _DrinkVerticalListCustomComponent = __webpack_require__(932);

var _DrinkVerticalListCustomComponent2 = _interopRequireDefault(_DrinkVerticalListCustomComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 组件声明
 */
var customComponentList = {
  // 文本组件
  'text': function text(props) {
    return React.createElement(_TextCustomComponent2.default, props);
  },
  // 图片组件：单图片
  'picture': function picture(props) {
    return React.createElement(_PictureCustomComponent2.default, props);
  },
  // 动态列表
  'list-vessel': function listVessel(props, ref) {
    return React.createElement(_ListVesselCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 动态分类
  'dynamic-classify': function dynamicClassify(props, ref) {
    return React.createElement(_DynamicClassifyCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 动态容器
  'dynamic-vessel': function dynamicVessel(props, ref) {
    return React.createElement(_DynamicVesselCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 动态表单
  'form-vessel': function formVessel(props, ref) {
    return React.createElement(_FormVesselCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 动态表单: 单行文本输入框
  'input-ele': function inputEle(props) {
    return React.createElement(_InputEleCustomComponent2.default, props);
  },
  // 动态表单: 多行文本输入框
  'textarea-ele': function textareaEle(props) {
    return React.createElement(_TextareaEleCustomComponent2.default, props);
  },
  // 动态表单: 评分
  'grade-ele': function gradeEle(props) {
    return React.createElement(_GradeEleCustomComponent2.default, props);
  },
  // 动态表单: 选项
  'select-ele': function selectEle(props) {
    return React.createElement(_SelectEleCustomComponent2.default, props);
  },
  // 动态表单: 添加图片
  'upload-img': function uploadImg(props) {
    return React.createElement(_UploadImgCustomComponent2.default, props);
  },
  // 动态表单: 时间
  'time-ele': function timeEle(props) {
    return React.createElement(_TimeEleCustomComponent2.default, props);
  },
  // 动态表单: 下拉选项
  'drop-down': function dropDown(props) {
    return React.createElement(_DropDownCustomComponent2.default, props);
  },
  // 动态表单: 图片选项
  'pic-options': function picOptions(props) {
    return React.createElement(_PicOptionsCustomComponent2.default, props);
  },
  // 动态表单: 地址
  'address-ele': function addressEle(props) {
    return React.createElement(_AddressEleCustomComponent2.default, props);
  },
  // 动态表单: 提交按钮
  'form-button': function formButton(props) {
    return React.createElement(_FormButtonCustomComponent2.default, props);
  },
  // 动态表单: 添加视频
  'upload-video': function uploadVideo(props, ref) {
    return React.createElement(_UploadVideoCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 动态表单：匿名组件
  'anonymous-ele': function anonymousEle(props) {
    return React.createElement(_AnonymousEleCustomComponent2.default, props);
  },
  // 自由面板
  'free-vessel': function freeVessel(props) {
    return React.createElement(_FreeVesselCustomComponent2.default, props);
  },
  // 底部导航(函数)
  'tab-nav': function tabNav(props) {
    return React.createElement(_TabNavCustomComponent2.default, props);
  },
  // 商品列表(电商、到店、预约)
  'goods-list': function goodsList(props, ref) {
    return React.createElement(_GoodsListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 按钮组件
  'button': function button(props) {
    return React.createElement(_ButtonCustomComponent2.default, props);
  },
  // 双栏布局组件
  'layout-vessel': function layoutVessel(props) {
    return React.createElement(_LayoutVesselCustomComponent2.default, props);
  },
  // 标题组件
  'title-ele': function titleEle(props) {
    return React.createElement(_TitleEleCustomComponent2.default, props);
  },
  // 资讯组件
  'news': function news(props, ref) {
    return React.createElement(_NewsCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 轮播组件
  'carousel': function carousel(props) {
    return React.createElement(_CarouselCustomComponent2.default, props);
  },
  // 分割线组件
  'breakline': function breakline(props) {
    return React.createElement(_BreaklineCustomComponent2.default, props);
  },
  // 面板组件
  'static-vessel': function staticVessel(props) {
    return React.createElement(_StaticVesselCustomComponent2.default, props);
  },
  // 轮播组件
  'audio': function audio(props, ref) {
    return React.createElement(_AudioCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 图片列表组件
  'album': function album(props) {
    return React.createElement(_AlbumCustomComponent2.default, props);
  },
  // 公告组件
  'announce': function announce(props) {
    return React.createElement(_AnnounceCustomComponent2.default, props);
  },
  // 图文集组件
  'list': function list(props) {
    return React.createElement(_ListCustomComponent2.default, props);
  },
  // 固定悬浮窗组件
  'suspension': function suspension(props) {
    return React.createElement(_SuspensionCustomComponent2.default, props);
  },
  // 视频组件
  'video': function video(props, ref) {
    return React.createElement(_VideoCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 收缩悬浮窗组件
  'new-suspension': function newSuspension(props, ref) {
    return React.createElement(_NewSuspensionCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 弹窗组件
  'popup-window': function popupWindow(props, ref) {
    return React.createElement(_PopupWindowCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 滑动面板组件
  'sliding-panel': function slidingPanel(props, ref) {
    return React.createElement(_SlidingPanelCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 多商家组件
  'franchisee-list': function franchiseeList(props, ref) {
    return React.createElement(_FranchiseeListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 连锁多商家组件
  'franchisee-chain': function franchiseeChain(props, ref) {
    return React.createElement(_FranchiseeChainCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 侧边栏组件
  'sidebar': function sidebar(props, ref) {
    return React.createElement(_SidebarCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 广告组件（仅微信可用）
  'advertising': function advertising(props) {
    return React.createElement(_AdvertisingCustomComponent2.default, props);
  },
  // 插件组件（仅微信可用）
  'plugin': function plugin(props) {
    return React.createElement(_PluginCustomComponent2.default, props);
  },
  // 公众号关注组件（仅微信可用）
  'official-account': function officialAccount(props) {
    return React.createElement(_OfficialAccountCustomComponent2.default, props);
  },
  // 旧版分类组件（暂不预览）
  'classify': function classify(props) {
    return React.createElement(_ClassifyCustomComponent2.default, props);
  },
  // 旧版计数器组件（暂不预览）
  'count': function count(props) {
    return React.createElement(_CountCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 新版计数器组件
  'new-count': function newCount(props) {
    return React.createElement(_NewCountCustomComponent2.default, props);
  },
  // 地图组件
  'map': function map(props, ref) {
    return React.createElement(_MapCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 列表相关：搜索
  'search': function search(props) {
    return React.createElement(_SearchCustomComponent2.default, props);
  },
  // 列表相关：排序
  'sort': function sort(props) {
    return React.createElement(_SortCustomComponent2.default, props);
  },
  // 列表相关：城市定位
  'citylocation': function citylocation(props) {
    return React.createElement(_CitylocationCustomComponent2.default, props);
  },
  // 列表相关：列表分类
  'new-classify': function newClassify(props, ref) {
    return React.createElement(_NewClassifyCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 列表相关：筛选
  'filter': function filter(props, ref) {
    return React.createElement(_FilterCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 社区团购活动列表组件
  'community-group': function communityGroup(props, ref) {
    return React.createElement(_CommunityGroupCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 社区团购单商品列表组件
  'community-goods-list': function communityGoodsList(props, ref) {
    return React.createElement(_CommunityGoodsListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 可兑换优惠券组件
  'exchange-coupon': function exchangeCoupon(props, ref) {
    return React.createElement(_ExchangeCouponCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 排号组件
  'row-num': function rowNum(props, ref) {
    return React.createElement(_RowNumCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 外卖组件
  'waimai': function waimai(props, ref) {
    return React.createElement(_TakeoutCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 到店组件
  'tostore': function tostore(props, ref) {
    return React.createElement(_TostoreCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 社区：圈组列表 组件
  'community': function community(props, ref) {
    return React.createElement(_CommunityCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 社区：话题列表 组件
  'topic': function topic(props, ref) {
    return React.createElement(_TopicCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 每日签到组件
  'sign-in': function signIn(props, ref) {
    return React.createElement(_SignInCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 拼团列表列表组件
  'group-buy-list': function groupBuyList(props, ref) {
    return React.createElement(_GroupBuyListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 拼团状态组件
  'group-buy-status': function groupBuyStatus(props, ref) {
    return React.createElement(_GroupBuyStatusCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 秒杀组件
  'seckill': function seckill(props, ref) {
    return React.createElement(_SeckillCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 秒杀时间轴组件
  'timeline': function timeline(props, ref) {
    return React.createElement(_TimelineCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 评论组件
  'bbs': function bbs(props, ref) {
    return React.createElement(_BbsCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 视频列表组件
  'video-list': function videoList(props, ref) {
    return React.createElement(_VideoListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 话题分类组件
  'topic-classify': function topicClassify(props, ref) {
    return React.createElement(_TopicClassifyCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 话题排序组件
  'topic-sort': function topicSort(props, ref) {
    return React.createElement(_TopicSortCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 个人中心 头部
  'user-center-head': function userCenterHead(props, ref) {
    return React.createElement(_UserCenterHeadCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 个人中心 内容
  'user-center-content': function userCenterContent(props, ref) {
    return React.createElement(_UserCenterContentCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 自定义顶部导航
  'custom-top-nav': function customTopNav(props) {
    return React.createElement(_CustomTopNavCustomComponent2.default, props);
  },
  // 预售组件
  'presell': function presell(props, ref) {
    return React.createElement(_PresellCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 竖版列表组件
  'vertical-list': function verticalList(props, ref) {
    return React.createElement(_VerticalListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 储值列表组件
  'stored-value': function storedValue(props, ref) {
    return React.createElement(_StoredValueCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  },
  // 饮品列表
  'drink-vertical-list': function drinkVerticalList(props, ref) {
    return React.createElement(_DrinkVerticalListCustomComponent2.default, (0, _extends3.default)({ ref: ref }, props));
  }
};
exports.default = customComponentList;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(755);

function TextCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  styleObj['height'] = 'auto';
  if (data.customFeature.isWordWrap == 1) {
    styleObj['WebkitLineClamp'] = data.customFeature['word-wrap'];
  }
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 返回组件
   */
  return React.createElement('div', {
    className: 'custom-component text ' + (data.customFeature.isWordWrap == 1 ? 'text-word-wrap' : '') + ' ' + (+data.customFeature['word-wrap'] > 1 ? 'multi-line' : 'single-line') + ' rich-text',
    style: styleObj, onClick: function onClick() {
      return (0, _customEvent.customEvent)({ customFeature: customFeature });
    },
    dangerouslySetInnerHTML: { __html: content } });
}

/***/ }),
/* 755 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PictureCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(757);

function PictureCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  var realValue = null;
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      realValue = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      realValue = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段
    }
    if (customFeature.action === 'call' && customFeature.phoneDisplayContent === 'static') {
      // 拨打电话点击事件： 电话号码设为手动填写并且显示内容设为组件内容
      content = content;
    } else {
      // 有动态数据则赋值给content
      content = realValue;
    }
  }
  if (!Array.isArray(content)) {
    // 图片数据 string[] / string, 将不为数组的数据处理为数组
    content = [content];
  }
  /**
   * 返回组件
   */
  return content.map(function (url, index) {
    return React.createElement(
      'div',
      { className: 'custom-component picture', key: index, style: styleObj, onClick: function onClick() {
          return (0, _customEvent.customEvent)({ customFeature: customFeature, realValue: realValue });
        } },

      // 是否设为纯色
      !customFeature.backgroundType && React.createElement('img', { src: url })
    );
  });
}

/***/ }),
/* 757 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _app = __webpack_require__(4);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(761);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vesselCheckIfCount = function vesselCheckIfCount(compData) {
  // 标记是否有计数器组件
  var flag = false;
  var types = {
    'count-ele': true,
    'new-count': true
  };
  var checkHasEle = function checkHasEle(ele) {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (types[ele.type]) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = ele.content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var subEle = _step.value;

          checkHasEle(subEle);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (ele.type === 'layout-vessel') {
      // 双栏组件的content不为数组
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(ele.content)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var attr = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = ele.content[attr][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _subEle = _step3.value;

              checkHasEle(_subEle);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  };
  checkHasEle(compData);
  if (flag) {
    return 1;
  }
  return 0;
};

var ListVesselCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(ListVesselCustomComponent, _React$Component);

  function ListVesselCustomComponent(props) {
    (0, _classCallCheck3.default)(this, ListVesselCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ListVesselCustomComponent.__proto__ || Object.getPrototypeOf(ListVesselCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(ListVesselCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this,
          _React$createElement;

      /**
       * 传入数据
       */
      var data = this.props.data;
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      if (customFeature.vesselAutoheight == 0) {
        styleObj['height'] = (0, _tools.transformPx2Rem)(customFeature['height'], 320);
      }
      /**
       * 组件内容处理
       */
      var content = data.content;

      var hor = data.customFeature.mode == 2 && data.curpage > 0;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        _ScrollView.ScrollView,
        (_React$createElement = {
          className: 'custom-component list-vessel ' + (data.customFeature.mode ? 'mode-' + data.customFeature.mode : '') + ' ' + (hor ? 'hor-request-status' : ''), style: styleObj
        }, (0, _defineProperty3.default)(_React$createElement, 'style', styleObj), (0, _defineProperty3.default)(_React$createElement, 'data-type', 'list-vessel'), (0, _defineProperty3.default)(_React$createElement, 'data-compindex', this.props.index), (0, _defineProperty3.default)(_React$createElement, 'scroll-y', data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0 ? false : true), (0, _defineProperty3.default)(_React$createElement, 'scroll-x', data.customFeature.mode == 2 ? true : false), (0, _defineProperty3.default)(_React$createElement, 'lower-threshold', '100'), (0, _defineProperty3.default)(_React$createElement, 'bindscrolltolower', this.pageScrollFunc), _React$createElement),
        data.list_data && data.list_data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'list-vessel-item', key: index,
              onClick: _this3.listVesselTurnToPage,
              'data-compindex': _this3.props.index,
              'data-index': index,
              'data-dataid': customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
              'data-router': customFeature.link,
              'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || ''
            },
            content.map(function (componentData, componentIndex) {
              return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
            })
          );
        }),
        data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading', hor: hor }),
        data.is_more == 0 && data.list_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无数据~' }, hor: hor }),
        data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'pageScrollFunc', compindex: this.props.index }, hor: hor }),
        data.is_more == 0 && data.list_data.length > 0 && customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll', hor: hor }),
        !!(customFeature.vesselAutoheight == 1 && customFeature.loadingMethod == 1 && customFeature.mode != 2 && data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail) && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.pageScrollFunc, 'data-compindex': this.props.index })
      );
    }
  }]);
  return ListVesselCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.state = {
    listData: [],
    loading: false,
    loadingFail: false, // TODO
    page: 1,
    isMore: 0
  };

  this.init = function (compindex, pageInstance, isPullRefresh) {
    var that = _this4;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var url = '/index.php?r=AppData/getFormDataList';

    var param = {
      id: customFeature['id'],
      form: customFeature['form'],
      page: 1,
      app_id: _app.appMethod.getAppId(),
      is_count: vesselCheckIfCount(compData)
    };
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));

    if (!param['form']) {
      _toast2.default.info('动态列表未绑定数据对象');
      return;
    }
    if (customFeature.form == 'group_buy') {
      url = "/index.php?r=AppGroupBuy/GetGroupBuyGoodsList";
      param.current_status = 0;
    }
    if (customFeature.source && customFeature.source !== 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }
    if (customFeature.form === 'goods' && customFeature.pickUpArr && compData.type == "list-vessel") {
      param.pick_up_type = [];
      if (customFeature.pickUpArr.express) {
        param.pick_up_type.push(1);
      }

      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }

      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }

      if (customFeature.pickUpArr.dining) {
        param.pick_up_type.push(4);
      }
    }
    param.page_size = customFeature.loadingNum || 10;

    var field = _app.appMethod.getListVessel(compData);
    var fieldData = {};

    param.need_column_arr = field.concat('app_id', 'id', 'is_seckill', 'mode_id', 'goods_id', 'is_group_buy', 'seckill_activity_id', 'seckill_activity_time_id', 'is_seckill_activity');

    fieldData['eles[' + compindex + '].listField'] = field;
    fieldData['eles[' + compindex + '].need_column_arr'] = param.need_column_arr;
    fieldData['eles[' + compindex + '].loading'] = true;
    fieldData['eles[' + compindex + '].loadingFail'] = false;
    fieldData['eles[' + compindex + '].list_data'] = [];
    fieldData['eles[' + compindex + '].param'] = param;
    fieldData['eles[' + compindex + '].is_more'] = 1;
    fieldData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(fieldData);

    if (_app.appMethod.getInvolvedFromRefreshObject(customFeature.id, "new-classify")) {
      return;
    }

    if (customFeature.form == 'app_shop' && field.indexOf('distance') > -1 && !isPullRefresh) {
      var locationInfo = _app.appMethod.globalData.locationInfo;
      if (locationInfo.latitude) {
        param.extra_cond_arr = {};
        param.extra_cond_arr.latitude = locationInfo.latitude;
        param.extra_cond_arr.longitude = locationInfo.longitude;
      } else {
        _app.appMethod.getLatLng({
          success: function success(latlng) {
            var extra_cond_arr = {};
            extra_cond_arr.latitude = latlng.latitude;
            extra_cond_arr.longitude = latlng.longitude;
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param.extra_cond_arr', extra_cond_arr));
            that.init(compindex, pageInstance, true);
          },
          fail: function fail() {
            _app.appMethod.showToast({
              title: '定位失败，店铺距离将获取不到',
              icon: 'none'
            });
            that.init(compindex, pageInstance, true);
          }
        });
        return;
      }
    }

    if (customFeature.showSingleData && compData.type == "list-vessel") {
      _this4.requestSingleData(pageInstance, customFeature, compindex, field, param);
    } else {
      _this4.getReviewConfig(function (reviewList) {
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: url,
          data: param,
          method: 'post',
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function success(res) {
            if (res.status == 0) {
              var newdata = {};

              if (param.form !== 'form') {
                for (var j in res.data) {
                  if (customFeature.form == 'group_buy') {
                    res.data[j] = {
                      form_data: Object.assign({}, res.data[j])
                    };
                  }
                  for (var k in res.data[j].form_data) {
                    if (k == 'review_status') {
                      res.data[j].form_data[k] = res.data[j].form_data[k] == 0 ? reviewList.applying_text || '待审核' : res.data[j].form_data[k] == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过';
                    }
                    if (k == 'review_result') {
                      res.data[j].form_data[k] = res.data[j].form_data[k].replace(/\\n/, '');
                    }
                    if (k == 'category') {
                      continue;
                    }
                    if (/region/.test(k)) {
                      continue;
                    }
                    if (k == 'goods_model') {
                      res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
                    }
                    if (k == 'distance') {
                      res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
                    }
                    var description = res.data[j].form_data[k];

                    if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                      //没有绑定的字段的富文本置为空
                      res.data[j].form_data[k] = '';
                    }
                  }
                }
              }

              newdata['eles[' + compindex + '].list_data'] = res.data;
              newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
              newdata['eles[' + compindex + '].curpage'] = 1;
              newdata['eles[' + compindex + '].loading'] = false;
              newdata['eles[' + compindex + '].loadingFail'] = false;

              pageInstance.setData(newdata);
            }
          },
          fail: function fail(res) {
            var newdata = {};
            newdata['eles[' + compindex + '].loadingFail'] = true;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        });
      });
    }
  };

  this.getReviewConfig = function (callBack) {
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppConfig/GetAppDataReviewTextConfig',
      method: 'post',
      hideLoading: true,
      success: function success(res) {
        callBack && callBack(res.data);
      }
    });
  };

  this.requestSingleData = function (pageInstance, customFeature, compindex, field, param) {
    _this4.getReviewConfig(function (reviewList) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/GetDatasByUserToken',
        data: {
          form: param.form,
          page: param.page,
          page_size: customFeature.loadingNum || 10
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var newdata = {};
            if (param.form !== 'form') {
              for (var j in res.data) {
                if (customFeature.form == 'group_buy') {
                  res.data[j] = {
                    form_data: Object.assign({}, res.data[j])
                  };
                }
                for (var k in res.data[j].form_data) {
                  if (k == 'review_status') {
                    res.data[j].form_data[k] = res.data[j].form_data[k] == 0 ? reviewList.applying_text || '待审核' : res.data[j].form_data[k] == 1 ? reviewList.apply_passed_text || '审核通过' : reviewList.apply_unpassed_text || '审核不通过';
                  }
                  if (k == 'review_result') {
                    res.data[j].form_data[k] = res.data[j].form_data[k].replace(/\\n/, '');
                  }
                  if (k == 'category') {
                    continue;
                  }
                  if (/region/.test(k)) {
                    continue;
                  }
                  if (k == 'goods_model') {
                    res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
                  }
                  if (k == 'distance') {
                    res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
                  }
                  var description = res.data[j].form_data[k];

                  if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                    //没有绑定的字段的富文本置为空
                    res.data[j].form_data[k] = '';
                  }
                }
              }
            }

            newdata['eles[' + compindex + '].list_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loading'] = false;
            newdata['eles[' + compindex + '].loadingFail'] = false;

            pageInstance.setData(newdata);
          }
        },
        fail: function fail(res) {
          var newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    });
  };

  this._refreshListVessel = function (targetCompIndex, requestData, pageInstance, isGetLatLng) {
    var _this = _this4;
    var targetCompData = pageInstance.data.eles[targetCompIndex];
    var customFeature = targetCompData.customFeature;
    requestData.page_size = customFeature.loadingNum || 10;
    var needColumnArr = targetCompData.need_column_arr || [];
    var newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].list_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    if (needColumnArr.length) {
      // 优化请求速度
      requestData.need_column_arr = needColumnArr;
    } else if (requestData.page == 1) {
      needColumnArr = _app.appMethod.getListVessel(targetCompData);
      needColumnArr = needColumnArr.concat('app_id', 'id', 'is_seckill', 'mode_id', 'goods_id', 'is_group_buy', 'seckill_activity_id', 'seckill_activity_time_id', 'is_seckill_activity');
      requestData.need_column_arr = needColumnArr;
    }
    requestData.form = customFeature.form;

    if (customFeature.form == 'app_shop' && needColumnArr.indexOf('distance') > -1 && !isGetLatLng) {
      _app.appMethod.getLatLng({
        success: function success(latlng) {
          requestData.extra_cond_arr = {};
          requestData.extra_cond_arr.latitude = latlng.latitude;
          requestData.extra_cond_arr.longitude = latlng.longitude;
          _this._refreshListVessel(targetCompIndex, requestData, pageInstance, true);
        },
        fail: function fail() {
          _app.appMethod.showToast({
            title: '定位失败，店铺距离将获取不到',
            icon: 'none'
          });
          _this._refreshListVessel(targetCompIndex, requestData, pageInstance, true);
        }
      });
      return;
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: requestData,
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO
      success: function success(res) {
        var newData = {};
        var listField = pageInstance.data.eles[targetCompIndex].listField;
        for (var j in res.data) {
          for (var k in res.data[j].form_data) {
            if (k == 'category') {
              continue;
            }
            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
            }
            if (k == 'distance') {
              res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
            }
            var description = res.data[j].form_data[k];
            if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
              //没有绑定的字段的富文本置为空
              res.data[j].form_data[k] = '';
            } else if (_app.appMethod.needParseRichText(description)) {
              res.data[j].form_data[k] = _app.appMethod.getWxParseResult(description);
            }
          }
        }
        newData['eles[' + targetCompIndex + '].list_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.pageScrollFunc = function (event) {
    _app.appMethod.pageScrollFunc(event);
  };

  this.listVesselTurnToPage = function (event) {
    _app.appMethod.listVesselTurnToPage(event);
  };
};

exports.default = ListVesselCustomComponent;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(105);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _customEvent = __webpack_require__(18);

var customEvent = _interopRequireWildcard(_customEvent);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(763);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DynamicClassifyModule = {
  pxToRpx: function pxToRpx(size) {
    return (0, _tools.transformPx2Rem)(size, 320);
  },
  isImage: function isImage(string, childStr) {
    var a = string || childStr + '1';
    return a.indexOf(childStr);
  },
  RGB2RGBA: function RGB2RGBA(rgb_color, alp) {
    if (rgb_color && rgb_color.indexOf('rgb') >= 0) {
      var rgba = rgb_color.split(')')[0] + ',' + alp + ')';
      return rgba.replace('rgb', 'rgba');
    } else if (rgb_color && rgb_color.indexOf('#') >= 0) {
      var sColor = rgb_color.toLowerCase();
      if (sColor.length === 4) {
        var sColorNew = "#";
        for (var i = 1; i < 4; i++) {
          sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
        }
        sColor = sColorNew;
      }
      var sColorChange = [];
      for (var i = 1; i < 7; i += 2) {
        sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)));
      }
      return "rgba(" + sColorChange.join(",") + ',' + alp + ")";
    } else {
      return '';
    }
  },
  getCategoryLen: function getCategoryLen(data, id) {
    var len = 0;
    data.map(function (item) {
      if (item.category_id == id) {
        len = item.subclass.length;
      }
    });
    return len;
  }
  /**
   * type: "dynamic-classify" 
   * 组件：动态分类组件
   */
};
var DynamicClassifyCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(DynamicClassifyCustomComponent, _React$Component);

  function DynamicClassifyCustomComponent(props) {
    (0, _classCallCheck3.default)(this, DynamicClassifyCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DynamicClassifyCustomComponent.__proto__ || Object.getPrototypeOf(DynamicClassifyCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  // 初始化动态分类组件


  // 动态分类设置节点信息


  // 动态分类: 点击不同分类对应的数据


  // 动态分类：点击下拉选择


  // 动态分类二级分类列表的滚动事件


  // 顶部悬停


  //监控列表是否离开视口


  //隐藏蒙层


  (0, _createClass3.default)(DynamicClassifyCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;
      var classifyType = data.classifyType;
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var content = data.content;
      // 是否有底部导航
      var isTabBarPage = _app.appMethod.isTabBarPage();
      /**
       * 加载状态/点击按钮
       */
      var Others = function Others() {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          data.is_more == 0 && data.list_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无数据~' } }),
          !!data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'pageScrollFunc', compindex: _this3.props.index } }),
          data.is_more == 0 && data.list_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.is_more == 1 && !data.isLoading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: data.customFeature, onClick: _this3.pageScrollFunc, 'data-compindex': _this3.props.index })
        );
      };

      // 一级横版
      var $level1Horizontal = function $level1Horizontal() {
        styleObj = (0, _extends3.default)({}, styleObj, {
          height: 'auto',
          backgroundColor: data.vesselStyle['background-color'],
          backgroundImage: data.vesselStyle['background-image']
        });
        var $dynamicClassifyItemList = function $dynamicClassifyItemList(data) {
          return data.classifyData && data.classifyData.map(function (item, index) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: index },
              item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                'div',
                { className: 'dynamic-classify-item selected', style: { color: data.classifyStyle.selectedColor, height: '100%' },
                  onClick: function onClick(e) {
                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                  },
                  'data-level': '1',
                  'data-category-id': item.category_id,
                  'data-compindex': _this3.props.index,
                  'data-index': index },
                data.classifyStyle.mode == 0 && _react2.default.createElement(
                  'span',
                  { style: { fontSize: data.classifyStyle.selectedFontSize, fontStyle: data.classifyStyle.selectedFontStyle, fontWeight: data.classifyStyle.selectedFontWidget, textDecoration: data.classifyStyle.selectedTextDecoration, backgroundColor: data.classifyStyle.selectedColor } },
                  item.name
                ),
                data.classifyStyle.mode == 1 && _react2.default.createElement(
                  'span',
                  { style: { color: data.classifyStyle.selectedColor, fontSize: data.classifyStyle.selectedFontSize, fontStyle: data.classifyStyle.selectedFontStyle, fontWeight: data.classifyStyle.selectedFontWidget, textDecoration: data.classifyStyle.selectedTextDecoration } },
                  item.name
                ),
                data.classifyStyle.mode == 2 && _react2.default.createElement(
                  'span',
                  { style: { fontSize: data.classifyStyle.selectedFontSize, fontStyle: data.classifyStyle.selectedFontStyle, fontWeight: data.classifyStyle.selectedFontWidget, textDecoration: data.classifyStyle.selectedTextDecoration } },
                  item.name
                ),
                !!data.classifyStyle.isShowUnderLine && _react2.default.createElement('i', { className: 'underline', style: { background: data.classifyStyle.selectedColor, width: data.classifyStyle.underLineWidth } })
              ) : _react2.default.createElement(
                'div',
                { className: 'dynamic-classify-item', onClick: function onClick(e) {
                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                  },
                  'data-level': '1',
                  'data-category-id': item.category_id,
                  'data-compindex': _this3.props.index,
                  'data-index': index },
                _react2.default.createElement(
                  'span',
                  null,
                  item.name
                )
              )
            );
          });
        };
        return _react2.default.createElement(
          'div',
          {
            className: 'element dynamic-classify type-level1-horizontal',
            style: (0, _extends3.default)({}, styleObj, { height: 'auto', backgroundColor: data.vesselStyle['background-color'], backgroundImage: data.vesselStyle['background-image'] })
            // bindanimationend="animationEnd"
            , 'data-compindex': _this3.props.index },
          _react2.default.createElement('div', { className: data.customFeature.topHover ? 'topHover' : '', style: { height: '.02rem' } }),
          _react2.default.createElement(
            'div',
            { className: 'fixed ' + (data.topHover ? 'hover' : ''), style: { width: '100%', top: (data.topNavBarHeight || 0) + 'px' } },
            data.classifyStyle.mode == 2 && _react2.default.createElement(
              'div',
              { className: 'classify-area-open-btn',
                style: { backgroundColor: data.classifyStyle['background-color'], height: data.classifyStyle['height'], lineHeight: data.classifyStyle['line-height'], opacity: data.classifyStyle['opacity'] }
              },
              data.customFeature.horizontalImageSrc && DynamicClassifyModule.isImage(data.customFeature.horizontalImageSrc, 'dynamic-classify') >= 0 && _react2.default.createElement('span', { className: 'ico-moon icon-' + (data.customFeature.horizontalImageSrc || 'dynamic-classify1'), onClick: function onClick(e) {
                  _this3.tapDynamicShowAllClassify(e);e.stopPropagation();
                }, 'data-compindex': _this3.props.index }),
              data.customFeature.horizontalImageSrc && DynamicClassifyModule.isImage(data.customFeature.horizontalImageSrc, 'dynamic-classify') < 0 && _react2.default.createElement('img', { onClick: function onClick(e) {
                  _this3.tapDynamicShowAllClassify(e);e.stopPropagation();
                }, 'data-compindex': _this3.props.index, src: data.customFeature.horizontalImageSrc })
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'classify-area mode-' + data.classifyStyle.mode, 'scroll-x': true,
                style: { lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'], backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'], width: data.classifyStyle.mode == 2 ? 'calc(100% - 75rpx - 30rpx)' : '' },
                'scroll-left': data.CAScrollLeft
              },
              _react2.default.createElement(
                'div',
                { className: 'classify-area-main mode-' + data.classifyStyle.mode },
                $dynamicClassifyItemList(data)
              )
            ),
            data.classifyStyle.mode == 2 && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { hidden: !data.showClassifySelect, className: 'classify-mode2' },
                _react2.default.createElement(
                  'div',
                  { className: 'classify-area-main mode-2', style: { height: '100%' } },
                  $dynamicClassifyItemList(data)
                )
              )
            )
          ),
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'vessel-area scroll-ele ' + (data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode : ''),
              'data-compindex': _this3.props.index,
              'scroll-y': true,
              'lower-threshold': '100',
              'data-curpage': data.curpage,
              bindscrolltolower: _this3.pageScrollFunc,
              style: { opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'], height: data.customFeature.height }
            },
            _react2.default.createElement(
              'div',
              { className: 'js-list-container', 'data-list-index': '0', style: { minHeight: data.is_more == 1 ? '' : 'auto' } },
              data.list_data && data.list_data.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: index,
                    className: 'list-vessel clearfix ' + (data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : '') + ' background-ele',
                    style: { backgroundColor: data.vesselStyle['lineBackgroundColor'], backgroundImage: data.vesselStyle['lineBackgroundImage'], marginBottom: data.vesselStyle['margin'] + 'px' },
                    'data-dataid': data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
                    'data-router': data.customFeature.link,
                    'data-compindex': _this3.props.index,
                    'data-index': index,
                    'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || '',
                    onClick: function onClick(e) {
                      _this3.listVesselTurnToPage(e);e.stopPropagation();
                    }
                  },
                  content.map(function (componentData, componentIndex) {
                    return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
                  })
                );
              })
            ),
            _react2.default.createElement(Others, null),
            !!(data.classifyStyle.mode == 2 && data.showClassifySelect) && _react2.default.createElement(
              'div',
              { className: 'dynamic-classify-cover', onClick: _this3.hideCover, 'data-compindex': _this3.props.index },
              _react2.default.createElement('div', { className: 'dynamic-classify-cover' })
            )
          ),
          _react2.default.createElement('div', { className: data.customFeature.topHover ? 'bottomHover' : '', style: { height: '0.02rem' } })
        );
      };
      // 一级竖版
      var $level1Vertical = function $level1Vertical() {
        return _react2.default.createElement(
          'div',
          {
            className: 'element dynamic-classify type-level1-vertical',
            style: (0, _extends3.default)({}, styleObj, { height: data.customFeature.autoHeight == 1 ? 'calc(100vh - ' + (isTabBarPage ? '48px' : '0') + ')' : '' })
            // bindanimationend="animationEnd"
            , 'data-compindex': _this3.props.index },
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'classify-area mode-' + data.classifyStyle.mode,
              'scroll-y': true,
              style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] }
            },
            data.classifyData && data.classifyData.map(function (item, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                  'div',
                  { className: 'dynamic-classify-item selected',
                    style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                    onClick: function onClick(e) {
                      _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                    },
                    'data-level': '1',
                    'data-category-id': item.category_id,
                    'data-compindex': _this3.props.index },
                  !!+(item.category_id && item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement(
                    'span',
                    { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                    item.name
                  ),
                  !!+(item.category_id && item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                ) : _react2.default.createElement(
                  'div',
                  { className: 'dynamic-classify-item', onClick: function onClick(e) {
                      _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                    },
                    style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                    'data-level': '1',
                    'data-category-id': item.category_id,
                    'data-compindex': _this3.props.index },
                  !!+(item.category_id && item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement(
                    'span',
                    { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                    item.name
                  ),
                  !!+(item.category_id && item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) })
                )
              );
            })
          ),
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'vessel-area scroll-ele ' + (data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode : ''),
              'data-compindex': _this3.props.index,
              'scroll-y': true,
              'lower-threshold': '100',
              'data-curpage': data.curpage,
              bindscrolltolower: _this3.pageScrollFunc,
              style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'] }
            },
            !!(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && _react2.default.createElement(
              'div',
              { className: 'active-image' },
              _react2.default.createElement('img', { src: data.customFeature.activeImage, onClick: _this3.bindEventTapHandler, 'data-eventparams': JSON.stringify(data.customFeature),
                style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth), height: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius']) } })
            ),
            _react2.default.createElement(
              'div',
              { className: 'js-list-container', 'data-list-index': '0', style: { minHeight: data.is_more == 1 ? '' : 'auto', backgroundColor: data.vesselStyle['background-color'], backgroundImage: data.vesselStyle['background-image'] } },
              data.list_data && data.list_data.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: index,
                    className: 'list-vessel clearfix ' + (data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : '') + ' background-ele',
                    style: { backgroundColor: data.vesselStyle['lineBackgroundColor'], backgroundImage: data.vesselStyle['lineBackgroundImage'], marginBottom: data.vesselStyle['margin'] + 'px' },
                    'data-dataid': data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
                    'data-router': data.customFeature.link,
                    'data-compindex': _this3.props.index,
                    'data-index': index,
                    'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || '',
                    onClick: function onClick(e) {
                      _this3.listVesselTurnToPage(e);e.stopPropagation();
                    }
                  },
                  content.map(function (componentData, componentIndex) {
                    return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
                  })
                );
              })
            ),
            _react2.default.createElement(Others, null)
          )
        );
      };
      // 一级竖版带图
      var $level1VerticalWithpic = function $level1VerticalWithpic() {
        return _react2.default.createElement(
          'div',
          { className: 'element dynamic-classify type-level1-vertical-withpic',
            style: styleObj,
            bindanimationend: 'animationEnd',
            'data-compindex': _this3.props.index },
          _react2.default.createElement(
            'div',
            { className: 'classify-area large-picture-style ' + (data.customFeature.structure == 2 ? 'horizontal-style' : ''),
              style: { marginTop: data.classifyStyle['margin-top'], backgroundImage: data.classifyStyle['backgroundImage'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], color: data.classifyStyle['color'] }
            },
            data.customFeature.showAllClassify && _react2.default.createElement(
              'div',
              { className: 'dynamic-classify-item',
                style: (0, _extends3.default)({}, data.classifyItemStyle),
                onClick: function onClick(e) {
                  _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                },
                'data-level': '1',
                'data-compindex': _this3.props.index,
                'data-category-id': '0' },
              !!+(!data.customFeature.showClassifyIcon && data.customFeature.showAllClassifyImageSrc && DynamicClassifyModule.isImage(data.customFeature.showAllClassifyImageSrc, 'showclassify') >= 0) && _react2.default.createElement('i', { className: 'ico-moon icon-' + (data.customFeature.showAllClassifyImageSrc || 'showclassify1'), style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius) }, data.imgStyle, { fontStyle: 'normal' }) }),
              !!+(!data.customFeature.showClassifyIcon && data.customFeature.showAllClassifyImageSrc && DynamicClassifyModule.isImage(data.customFeature.showAllClassifyImageSrc, 'showclassify') < 0) && _react2.default.createElement('img', { style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius) }, data.imgStyle), mode: 'scaleToFill', src: data.customFeature.showAllClassifyImageSrc }),
              _react2.default.createElement(
                'span',
                { style: (0, _extends3.default)({}, data.textStyle) },
                '\u5168\u90E8'
              )
            ),
            data.classifyData && data.classifyData.map(function (item, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                !!+(item.category_id || data.customFeature.showAllClassify) && _react2.default.createElement(
                  'div',
                  { className: 'dynamic-classify-item',
                    style: (0, _extends3.default)({}, data.classifyItemStyle),
                    onClick: function onClick(e) {
                      _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                    },
                    'data-level': '1',
                    'data-category-id': item.category_id,
                    'data-compindex': _this3.props.index },
                  !data.customFeature.showClassifyIcon && _react2.default.createElement('img', { style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius) }, data.imgStyle), mode: 'scaleToFill', src: item.cover }),
                  _react2.default.createElement(
                    'span',
                    { style: (0, _extends3.default)({}, data.textStyle) },
                    item.name
                  )
                )
              );
            })
          )
        );
      };
      // 二级横版
      var $level2Horizontal = function $level2Horizontal() {
        return _react2.default.createElement(
          'div',
          {
            className: 'element dynamic-classify type-level2-horizontal',
            style: (0, _extends3.default)({}, styleObj, { height: 'auto', backgroundImage: data.vesselStyle['background-image'], backgroundColor: data.vesselStyle['background-color'] })
            // bindanimationend="animationEnd"
            , 'data-compindex': _this3.props.index
          },
          _react2.default.createElement('div', { className: data.customFeature.topHover ? 'topHover' : '', style: { height: '.02rem' } }),
          _react2.default.createElement(
            'div',
            { className: 'fixed ' + (data.topHover ? 'hover' : ''), style: { width: '100%', top: data.topNavBarHeight + 'px' } },
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'classify-area mode-' + data.classifyStyle.mode, 'scroll-x': true,
                style: { lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'], backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] }
              },
              data.classifyData && data.classifyData.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  item.category_id == '' ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected', style: { color: data.classifyStyle.selectedColor },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        'data-level': '2',
                        'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        '\u5168\u90E8'
                      ),
                      index != data.classifyData.length - 1 && _react2.default.createElement('i', { className: 'divide-line', style: { backgroundColor: data.classifyStyle.divideLineColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        'data-level': '2',
                        'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        '\u5168\u90E8'
                      ),
                      index != data.classifyData.length - 1 && _react2.default.createElement('i', { className: 'divide-line', style: { backgroundColor: data.classifyStyle.divideLineColor } })
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected', style: { color: data.classifyStyle.selectedColor },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        'data-level': '1',
                        'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index,
                        'data-has-subclass': item.subclass && item.subclass.length },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      data.classifyStyle.mode == 0 && _react2.default.createElement('i', { className: 'triangle', style: { borderTop: '.10rem solid ' + data.classifyStyle.selectedColor } }),
                      data.classifyStyle.mode == 1 && _react2.default.createElement('i', { className: 'triangle', style: { borderColor: data.classifyStyle.selectedColor } }),
                      index != data.classifyData.length - 1 && _react2.default.createElement('i', { className: 'divide-line', style: { backgroundColor: data.classifyStyle.divideLineColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        'data-level': '1',
                        'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index,
                        'data-has-subclass': item.subclass && item.subclass.length },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      _react2.default.createElement('i', { className: 'triangle' }),
                      index != data.classifyData.length - 1 && _react2.default.createElement('i', { className: 'divide-line', style: { backgroundColor: data.classifyStyle.divideLineColor } })
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'sub-classify-area',
                hidden: !data.classifyAreaLevel2Show,
                onClick: function onClick(e) {
                  _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                },
                'data-hide-subclass': '1',
                'data-compindex': _this3.props.index,
                'scroll-y': true,
                style: { top: data.classifyStyle['height'] } },
              data.classifyData && data.classifyData.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  !data.customFeature.level2ClassifyStyle && _react2.default.createElement(
                    'div',
                    { className: 'sub-classify-item-list',
                      hidden: item.category_id != data.currentCategory[0],
                      style: { backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] }
                    },
                    item.subclass && item.subclass.map(function (subItem, subIndex) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: subIndex },
                        subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item selected',
                            onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            },
                            'data-level': '2',
                            'data-category-id': subItem.category_id,
                            'data-compindex': _this3.props.index,
                            style: { color: data.classifyStyle.selectedColor, lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'] } },
                          _react2.default.createElement(
                            'span',
                            { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                            subItem.name
                          ),
                          _react2.default.createElement('i', { className: 'ico-moon icon-gou' })
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item',
                            onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            },
                            'data-level': '2', 'data-category-id': subItem.category_id,
                            'data-compindex': _this3.props.index,
                            style: { lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'], textDecoration: data.classifyStyle['text-decoration'] } },
                          subItem.name
                        )
                      );
                    })
                  ),
                  !!+data.customFeature.level2ClassifyStyle && _react2.default.createElement(
                    'div',
                    { className: 'sub-classify-item-list-mode2',
                      hidden: item.category_id != data.currentCategory[0],
                      style: { backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] } },
                    item.subclass && item.subclass.map(function (subItem, subIndex) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: subIndex },
                        subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item-mode2 selected',
                            onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            },
                            'data-level': '2',
                            'data-category-id': subItem.category_id,
                            'data-compindex': _this3.props.index,
                            style: { color: data.classifyStyle.selectedColor, borderColor: data.classifyStyle.selectedColor, lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'], flex: '0 0 calc(' + (100 / data.customFeature.level2ClassifyColumn + '% - .30rem') + ')', textDecoration: data.classifyStyle['text-decoration'] } },
                          subItem.name
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item-mode2',
                            onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            },
                            'data-level': '2', 'data-category-id': subItem.category_id,
                            'data-compindex': _this3.props.index, style: { lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'], flex: '0 0 calc(' + (100 / data.customFeature.level2ClassifyColumn + '% - .30rem') + ')', textDecoration: data.classifyStyle['text-decoration'] } },
                          subItem.name
                        )
                      );
                    })
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'vessel-area scroll-ele ' + (data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode : ''),
              'data-compindex': _this3.props.index,
              'scroll-y': true,
              'lower-threshold': '100',
              'data-curpage': data.curpage,
              bindscrolltolower: _this3.pageScrollFunc,
              style: { opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'], height: data.customFeature.height } },
            _react2.default.createElement(
              'div',
              { className: 'js-list-container', 'data-list-index': '0', style: { minHeight: data.is_more == 1 ? '' : 'auto' } },
              data.list_data && data.list_data.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'list-vessel clearfix ' + (data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : '') + ' background-ele',
                    style: { backgroundColor: data.vesselStyle['lineBackgroundColor'], backgroundImage: data.vesselStyle['lineBackgroundImage'], marginBottom: data.vesselStyle['margin'] + 'px' },
                    'data-dataid': data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
                    'data-router': data.customFeature.link,
                    'data-compindex': _this3.props.index,
                    'data-index': index,
                    'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || '',
                    onClick: function onClick(e) {
                      _this3.listVesselTurnToPage(e);e.stopPropagation();
                    } },
                  content.map(function (componentData, componentIndex) {
                    return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
                  })
                );
              })
            ),
            _react2.default.createElement(Others, null),
            !!data.classifyAreaLevel2Show && _react2.default.createElement(
              'div',
              { className: 'dynamic-classify-cover', onClick: _this3.hideCover, 'data-compindex': _this3.props.index },
              _react2.default.createElement('div', { className: 'dynamic-classify-cover' })
            )
          ),
          _react2.default.createElement('div', { className: data.customFeature.topHover ? 'bottomHover' : '', style: { height: '.02rem' } })
        );
      };
      // 二级竖版
      var $level2VerticalNopic = function $level2VerticalNopic() {
        var _React$createElement, _React$createElement2;

        return _react2.default.createElement(
          'div',
          {
            className: 'element dynamic-classify type-level2-vertical-nopic',
            style: (0, _extends3.default)({}, styleObj, { height: data.customFeature.autoHeight == 1 ? 'calc(100vh -  ' + (isTabBarPage ? '48px' : '0') + ' + ' + (data.topNavBarHeight || 0) + 'px)' : '' })
            // bindanimationend="animationEnd"
            , 'data-compindex': _this3.props.index },
          !data.customFeature.level2ClassifyStyle ? _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'classify-area mode-' + data.classifyStyle.mode, 'scroll-y': true,
                style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), marginTop: data.classifyStyle['margin-top'], backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] } },
              data.classifyData && data.classifyData.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  item.category_id == '' ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected',
                        style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        }, 'data-level': '2', 'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        '\u5168\u90E8'
                      ),
                      _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        'data-level': '2', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        '\u5168\u90E8'
                      )
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected',
                        style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        }, 'data-level': '1', 'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index, 'data-has-subclass': item.subclass && item.subclass.length, 'data-subclass-id': item.subclass && item.subclass.length ? item.subclass[0]['category_id'] : '' },
                      !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        'data-level': '1', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index,
                        'data-has-subclass': item.subclass && item.subclass.length, 'data-subclass-id': item.subclass && item.subclass.length ? item.subclass[0]['category_id'] : '' },
                      !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) })
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'sub-classify-area', hidden: !data.classifyAreaLevel2Show,
                onClick: function onClick(e) {
                  _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                }, 'data-hide-subclass': '1', 'data-compindex': _this3.props.index,
                style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')' },
                'scroll-y': true },
              data.classifyData && data.classifyData.map(function (item, index) {
                var _ref;

                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  item.category_id == data.currentCategory[0] && _react2.default.createElement(
                    'div',
                    { className: 'sub-classify-item-list',
                      style: (_ref = { fontSize: data.customFeature['secFontSize'], fontWeight: data.customFeature['secFontWeight'] }, (0, _defineProperty3.default)(_ref, 'fontWeight', data.customFeature['secFontStyle']), (0, _defineProperty3.default)(_ref, 'color', data.customFeature['secColor']), _ref) },
                    item.subclass && item.subclass.map(function (subItem, subIndex) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item selected', onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            }, 'data-level': '2',
                            'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                            style: { backgroundColor: data.classifyStyle['selectedBackgroundColor'], color: data.classifyStyle['sec-select-font-color'], lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'] } },
                          subItem.name
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item', onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            }, 'data-level': '2',
                            'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                            style: { backgroundColor: data.classifyStyle['sec-background-color'], color: data.classifyStyle['sec-font-color'], lineHeight: data.classifyStyle['line-height'], height: data.classifyStyle['height'] } },
                          subItem.name
                        )
                      );
                    })
                  )
                );
              })
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'vessel-area scroll-ele ' + (data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode : ''),
                'data-compindex': _this3.props.index, 'scroll-y': true, 'lower-threshold': '100', 'data-curpage': data.curpage,
                bindscrolltolower: _this3.pageScrollFunc,
                style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'] } },
              !!+(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && _react2.default.createElement(
                'div',
                { className: 'active-image' },
                _react2.default.createElement('img', { src: data.customFeature.activeImage, onClick: _this3.bindEventTapHandler,
                  'data-eventparams': JSON.stringify(data.customFeature),
                  style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth), height: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius']) } })
              ),
              _react2.default.createElement(
                'div',
                { className: 'js-list-container', 'data-list-index': '0',
                  style: { backgroundColor: data.vesselStyle['background-color'], backgroundImage: data.vesselStyle['background-image'], minHeight: data.is_more == 1 ? '' : 'auto' } },
                data.list_data && data.list_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      key: index,
                      className: 'list-vessel clearfix ' + (data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : '') + ' background-ele',
                      style: { backgroundColor: data.vesselStyle['lineBackgroundColor'], backgroundImage: data.vesselStyle['lineBackgroundImage'], marginBottom: data.vesselStyle['margin'] + 'px' },
                      'data-dataid': data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
                      'data-router': data.customFeature.link, 'data-compindex': _this3.props.index, 'data-index': index,
                      'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || '',
                      onClick: function onClick(e) {
                        _this3.listVesselTurnToPage(e);e.stopPropagation();
                      } },
                    content.map(function (componentData, componentIndex) {
                      return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
                    })
                  );
                })
              ),
              _react2.default.createElement(Others, null)
            )
          ) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'classify-area mode-' + data.classifyStyle.mode, 'scroll-y': true,
                style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), marginTop: data.classifyStyle['margin-top'], backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] } },
              data.classifyData && data.classifyData.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  item.category_id == '' ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected',
                        style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        }, 'data-level': '2', 'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5168\u90E8'
                      ),
                      _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        'data-level': '2', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u5168\u90E8'
                      )
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item selected',
                        style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        }, 'data-level': '1', 'data-category-id': item.category_id,
                        'data-compindex': _this3.props.index, 'data-has-subclass': item.subclass && item.subclass.length, 'data-subclass-id': item.subclass && item.subclass.length ? item.subclass[0]['category_id'] : '' },
                      !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'dynamic-classify-item', onClick: function onClick(e) {
                          _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                        },
                        style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'] },
                        'data-level': '1', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index,
                        'data-has-subclass': item.subclass && item.subclass.length, 'data-subclass-id': item.subclass && item.subclass.length ? item.subclass[0]['category_id'] : '' },
                      !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      ),
                      !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) })
                    )
                  )
                );
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              !data.customFeature.isShowSecondIcon ?
              // 子分类不带图标
              _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.currentCategory && data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) && _react2.default.createElement(
                  'div',
                  { className: 'sub-classify-style2-box', style: { position: 'relative', width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')' } },
                  data.currentCategory && _react2.default.createElement(
                    _ScrollView.ScrollView,
                    (_React$createElement = { className: '', onClick: function onClick(e) {
                        _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                      }, 'data-hide-subclass': '1', 'data-compindex': _this3.props.index }, (0, _defineProperty3.default)(_React$createElement, 'className', 'sub-classify-style2'), (0, _defineProperty3.default)(_React$createElement, 'style', { height: '.74rem', left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) }), (0, _defineProperty3.default)(_React$createElement, 'scroll-x', true), _React$createElement),
                    data.classifyData && data.classifyData.map(function (item, index) {
                      var _ref2;

                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: index },
                        item.category_id == data.currentCategory[0] && _react2.default.createElement(
                          'div',
                          {
                            key: index,
                            className: 'sub-classify-item-list style2',
                            style: (_ref2 = { fontSize: data.customFeature['secFontSize'], fontWeight: data.customFeature['secFontWeight'] }, (0, _defineProperty3.default)(_ref2, 'fontWeight', data.customFeature['secFontStyle']), (0, _defineProperty3.default)(_ref2, 'color', data.customFeature['secColor']), (0, _defineProperty3.default)(_ref2, 'marginRight', DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) <= 6 ? '0' : '.74rem'), _ref2) },
                          item.subclass && item.subclass.map(function (subItem, subIndex) {
                            return _react2.default.createElement(
                              _react2.default.Fragment,
                              { key: subIndex },
                              subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                                'div',
                                { className: 'sub-classify-item style2 selected', onClick: function onClick(e) {
                                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                                  }, 'data-level': '2',
                                  'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                                  style: (0, _extends3.default)({ textDecoration: data.customFeature['secTextDecoration'], backgroundColor: DynamicClassifyModule.RGB2RGBA(data.classifyStyle['sec-select-font-color'], 0.2) }, data.textStyle, { color: data.classifyStyle['sec-select-font-color'], marginRight: DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right']) }) },
                                subItem.name
                              ) : _react2.default.createElement(
                                'div',
                                { className: 'sub-classify-item style2', onClick: function onClick(e) {
                                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                                  }, 'data-level': '2',
                                  'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                                  style: (0, _extends3.default)({ textDecoration: data.customFeature['secTextDecoration'] }, data.textStyle, { color: data.classifyStyle['sec-font-color'], marginRight: DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right']) }) },
                                subItem.name
                              )
                            );
                          })
                        )
                      );
                    })
                  ),
                  data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) > 6 && _react2.default.createElement(
                    'div',
                    { className: 'show-all-classify ' + (data.showAllSubclassifySelect ? 'active' : ''), 'data-compindex': _this3.props.index, onClick: function onClick(e) {
                        _this3.showAllSubclassify(e);e.stopPropagation();
                      }, style: { right: '-' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) } },
                    _react2.default.createElement('span', { className: 'icon-downarrow ico-moon' })
                  )
                )
              ) :
              // 子分类带图标
              _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.currentCategory && data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) && _react2.default.createElement(
                  'div',
                  { className: 'sub-classify-style2-box', style: { position: 'relative', width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')' } },
                  data.currentCategory && _react2.default.createElement(
                    _ScrollView.ScrollView,
                    (_React$createElement2 = { className: '', onClick: function onClick(e) {
                        _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                      }, 'data-hide-subclass': '1', 'data-compindex': _this3.props.index }, (0, _defineProperty3.default)(_React$createElement2, 'className', 'sub-classify-style2'), (0, _defineProperty3.default)(_React$createElement2, 'style', { backgroundColor: data.classifyStyle['sec-background-color'], height: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size']) + ' + .60rem)', left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) }), (0, _defineProperty3.default)(_React$createElement2, 'scroll-x', true), _React$createElement2),
                    data.classifyData && data.classifyData.map(function (item, index) {
                      var _ref3;

                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: index },
                        item.category_id == data.currentCategory[0] && _react2.default.createElement(
                          'div',
                          {
                            key: index,
                            className: 'sub-classify-item-list style2',
                            style: (_ref3 = { fontSize: data.customFeature['secFontSize'], fontWeight: data.customFeature['secFontWeight'] }, (0, _defineProperty3.default)(_ref3, 'fontWeight', data.customFeature['secFontStyle']), (0, _defineProperty3.default)(_ref3, 'color', data.customFeature['secColor']), (0, _defineProperty3.default)(_ref3, 'marginRight', DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) <= 6 ? '0' : '.74rem'), _ref3) },
                          item.subclass && item.subclass.map(function (subItem, subIndex) {
                            return _react2.default.createElement(
                              _react2.default.Fragment,
                              { key: subIndex },
                              subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                                'div',
                                { className: 'sub-classify-item style2-hasicon selected', onClick: function onClick(e) {
                                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                                  }, 'data-level': '2',
                                  'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                                  style: { color: data.classifyStyle['sec-select-font-color'], height: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size']) + ' + .60rem)', maxWidth: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + .40rem)', marginRight: DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right']) } },
                                _react2.default.createElement('img', { className: 'classify-iamge', src: item.category_id == subItem.category_id ? item.cover : subItem.cover, style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']), height: DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']) } }),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'text', style: (0, _extends3.default)({ textDecoration: data.customFeature['secTextDecoration'] }, data.textStyle, { color: data.classifyStyle['sec-select-font-color'] }) },
                                  subItem.name
                                )
                              ) : _react2.default.createElement(
                                'div',
                                { className: 'sub-classify-item style2-hasicon', onClick: function onClick(e) {
                                    _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                                  }, 'data-level': '2',
                                  'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                                  style: { color: data.classifyStyle['sec-font-color'], height: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size']) + ' + .60rem)', maxWidth: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + .40rem)', marginRight: DynamicClassifyModule.pxToRpx(data.classifyStyle['level2-margin-right']) } },
                                _react2.default.createElement('img', { className: 'classify-iamge', src: item.category_id == subItem.category_id ? item.cover : subItem.cover, style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']), height: DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']) } }),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'text', style: (0, _extends3.default)({ textDecoration: data.customFeature['secTextDecoration'] }, data.textStyle) },
                                  subItem.name
                                )
                              )
                            );
                          })
                        )
                      );
                    })
                  ),
                  data.currentCategory[0] && DynamicClassifyModule.getCategoryLen(data.classifyData, data.currentCategory[0]) > 6 && _react2.default.createElement(
                    'div',
                    { className: 'show-all-classify-hasicon', 'data-compindex': _this3.props.index, onClick: function onClick(e) {
                        _this3.showAllSubclassify(e);e.stopPropagation();
                      }, style: { height: 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size']) + ' + .60rem)', right: '-' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) } },
                    !data.showAllSubclassifySelect ? _react2.default.createElement(
                      'div',
                      { className: 'hasicon-inner' },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u67E5\u770B\u5168\u90E8'
                      ),
                      _react2.default.createElement('span', { className: 'icon-downarrow ico-moon' })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'hasicon-inner' },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u6536\u8D77'
                      ),
                      _react2.default.createElement('span', { className: 'icon-downarrow ico-moon', style: { transform: 'rotate(180deg)' } })
                    )
                  )
                )
              ),
              !!+data.showAllSubclassifySelect && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.classifyData && data.classifyData.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    item.category_id == data.currentCategory[0] && _react2.default.createElement(
                      'div',
                      { className: 'all-sub-clssify-box style2', style: { width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', top: data.customFeature.isShowSecondIcon ? 'calc(' + DynamicClassifyModule.pxToRpx(data.classifyStyle['icon-size']) + ' + ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['font-size']) + ' + .60rem)' : '.76rem', right: '0' } },
                      item.subclass && item.subclass.map(function (subItem, subIndex) {
                        return _react2.default.createElement(
                          _react2.default.Fragment,
                          { key: subIndex },
                          subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                            'div',
                            { className: 'sub-classify-box-item style2 selected', onClick: function onClick(e) {
                                _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                              }, 'data-level': '2',
                              'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                              style: (0, _extends3.default)({}, data.textStyle, { backgroundColor: DynamicClassifyModule.RGB2RGBA(data.classifyStyle['sec-select-font-color'], 0.2), color: data.classifyStyle['sec-select-font-color'] }) },
                            subItem.name
                          ) : _react2.default.createElement(
                            'div',
                            { className: 'sub-classify-box-item style2', onClick: function onClick(e) {
                                _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                              }, 'data-level': '2',
                              'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                              style: (0, _extends3.default)({}, data.textStyle, { backgroundColor: '#f0f0f0', color: data.classifyStyle['sec-font-color'] }) },
                            subItem.name
                          )
                        );
                      })
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { className: 'vessel-area scroll-ele ' + (data.vesselStyle.mode ? 'mode-' + data.vesselStyle.mode : ''),
                'data-compindex': _this3.props.index, 'scroll-y': true, 'lower-threshold': '100', 'data-curpage': data.curpage,
                bindscrolltolower: _this3.pageScrollFunc,
                style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'] } },
              _react2.default.createElement(
                'div',
                { className: 'js-list-container', 'data-list-index': '0', style: { minHeight: data.is_more == 1 ? '' : 'auto' } },
                _react2.default.createElement(
                  'div',
                  { className: 'classify-style2-item', style: { backgroundColor: data.vesselStyle['background-color'], paddingTop: data.currentCategory && (!data.currentCategory[0] ? '' : data.customFeature.isShowSecondIcon ? '1.6rem' : '.74rem') } },
                  !!+data.showAllSubclassifySelect && _react2.default.createElement('div', { className: 'show-all-subclassify-laybox', 'data-compindex': _this3.props.index, bindtap: 'showAllSubclassify', style: { left: '0', width: '100%', opacity: data.vesselStyle['opacity'], marginTop: data.vesselStyle['margin-top'] } }),
                  !!+(data.customFeature.showActiveImage && data.currentCategory && data.currentCategory[0] == data.classifyData[0].category_id) && _react2.default.createElement(
                    'div',
                    { className: 'active-image' },
                    _react2.default.createElement('img', { src: data.customFeature.activeImage, onClick: _this3.bindEventTapHandler,
                      'data-eventparams': JSON.stringify(data.customFeature),
                      style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth), height: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius']) } })
                  ),
                  data.list_data && data.list_data.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      {
                        key: index,
                        className: 'list-vessel clearfix ' + (data.vesselStyle.mode == 1 ? 'double-list' : data.vesselStyle.mode == 2 ? 'three-list' : '') + ' background-ele',
                        style: { backgroundColor: data.vesselStyle['lineBackgroundColor'], backgroundImage: data.vesselStyle['lineBackgroundImage'], marginBottom: data.vesselStyle['margin'] + 'px' },
                        'data-dataid': data.customFeature.link == 'franchiseeDetail' ? item.form_data.app_id : item.id || item.form_data.id,
                        'data-router': data.customFeature.link, 'data-compindex': _this3.props.index, 'data-index': index,
                        'data-isseckill': item.form_data.is_seckill && item.form_data.is_seckill || '', onClick: function onClick(e) {
                          _this3.listVesselTurnToPage(e);e.stopPropagation();
                        } },
                      content.map(function (componentData, componentIndex) {
                        return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
                      })
                    );
                  })
                )
              ),
              _react2.default.createElement(Others, null)
            )
          )
        );
      };
      // 二级大图
      var $level2VerticalWithpic = function $level2VerticalWithpic() {
        return _react2.default.createElement(
          'div',
          { className: 'element dynamic-classify type-level2-vertical-withpic', style: (0, _extends3.default)({}, styleObj, { height: 'calc(100vh - ' + (isTabBarPage ? '48px' : '0') + ' - ' + (data.searchHeight || 0) + 'px)' })
            // bindanimationend="animationEnd"
            , 'data-compindex': _this3.props.index },
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'classify-area mode-' + data.classifyStyle.mode, 'scroll-y': true, style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), marginTop: data.classifyStyle['margin-top'], backgroundImage: data.classifyStyle['background-image'], backgroundColor: data.classifyStyle['background-color'], opacity: data.classifyStyle['opacity'], fontSize: data.classifyStyle['font-size'], fontWeight: data.classifyStyle['font-weight'], fontStyle: data.classifyStyle['font-style'], textDecoration: data.classifyStyle['text-decoration'], color: data.classifyStyle['color'] } },
            data.classifyData && data.classifyData.map(function (item, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                item.category_id == data.currentCategory[0] ? _react2.default.createElement(
                  'div',
                  { className: 'dynamic-classify-item selected', style: { backgroundColor: data.classifyStyle.selectedBackgroundColor, color: data.classifyStyle.selectedColor, height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'], textDecoration: data.classifyStyle['text-decoration'] },
                    onClick: function onClick(e) {
                      _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                    }, 'data-level': '1', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index, 'data-index': index },
                  !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement(
                    'span',
                    { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                    item.name
                  ),
                  !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement('i', { className: 'leftline', style: { borderColor: data.classifyStyle.selectedColor } })
                ) : _react2.default.createElement(
                  'div',
                  { className: 'dynamic-classify-item', style: { height: data.classifyStyle.height, lineHeight: data.classifyStyle['line-height'], textDecoration: data.classifyStyle['text-decoration'] }, onClick: function onClick(e) {
                      _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                    }, 'data-level': '1', 'data-category-id': item.category_id, 'data-compindex': _this3.props.index, 'data-index': index },
                  !!+(item.cover && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginRight: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) }),
                  _react2.default.createElement(
                    'span',
                    { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                    item.name
                  ),
                  !!+(item.cover && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon) && _react2.default.createElement('img', { src: item.cover, style: (0, _extends3.default)({ verticalAlign: 'middle', display: 'inline-block', marginLeft: '.10rem', width: '.30rem', height: '.30rem', borderRadius: data.classifyStyle['first-border-radius'] }, data.listIconStyle) })
                )
              );
            })
          ),
          !data.customFeature.scrollChangeClassify && _react2.default.createElement(
            'div',
            null,
            data.classifyData && data.classifyData.map(function (item, index) {
              var _ref4;

              return _react2.default.createElement(
                _ScrollView.ScrollView,
                { key: index, className: 'sub-classify-area', hidden: index != data.customFeature.selected,
                  style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', backgroundColor: data.classifyStyle['sec-background-color'] || '' },
                  'scroll-y': true, bindscroll: '', 'data-compindex': _this3.props.index, 'scroll-top': '' },
                data.customFeature.showActiveImage && index === 0 && _react2.default.createElement(
                  'div',
                  { className: 'active-image' },
                  _react2.default.createElement('img', { src: data.customFeature.activeImage, onClick: _this3.bindEventTapHandler, 'data-eventparams': JSON.stringify(data.customFeature),
                    style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth), height: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius']) } })
                ),
                _react2.default.createElement(
                  'div',
                  { style: { minHeight: data.SCAMinHeight } },
                  _react2.default.createElement(
                    'div',
                    { className: 'sub-classify-item-list',
                      style: (_ref4 = { fontSize: data.customFeature['secFontSize'], fontWeight: data.customFeature['secFontWeight'] }, (0, _defineProperty3.default)(_ref4, 'fontWeight', data.customFeature['secFontStyle']), (0, _defineProperty3.default)(_ref4, 'color', data.customFeature['secColor']), _ref4) },
                    _react2.default.createElement(
                      'div',
                      { className: 'first-classify-name' },
                      _react2.default.createElement(
                        'span',
                        { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                        item.name
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'sub-classify-main ' + (data.customFeature.structure == 2 ? 'horizontal-style' : '') },
                      item.subclass && item.subclass.map(function (subItem, subIndex) {
                        return _react2.default.createElement(
                          _react2.default.Fragment,
                          { key: subIndex },
                          subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                            'div',
                            { className: 'sub-classify-item selected', onClick: function onClick(e) {
                                _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                              }, 'data-level': '2',
                              'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                              style: (0, _extends3.default)({}, data.classifyItemStyle) },
                            !data.customFeature.showClassifyIcon && _react2.default.createElement('img', { style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius) }, data.imgStyle), mode: 'scaleToFill', src: subItem.cover }),
                            _react2.default.createElement(
                              'div',
                              { className: 'name', style: (0, _extends3.default)({}, data.textStyle) },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _extends3.default)({}, data.textStyle) },
                                subItem.name
                              )
                            )
                          ) : _react2.default.createElement(
                            'div',
                            { className: 'sub-classify-item selected', onClick: function onClick(e) {
                                _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                              }, 'data-level': '2',
                              'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index,
                              style: (0, _extends3.default)({}, data.classifyItemStyle) },
                            !data.customFeature.showClassifyIcon && _react2.default.createElement('img', { style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.customFeature.iconRadius) }, data.imgStyle), mode: 'scaleToFill', src: subItem.cover }),
                            _react2.default.createElement(
                              'div',
                              { className: 'name', style: (0, _extends3.default)({}, data.textStyle) },
                              _react2.default.createElement(
                                'span',
                                { style: (0, _extends3.default)({}, data.textStyle) },
                                subItem.name
                              )
                            )
                          )
                        );
                      })
                    )
                  )
                )
              );
            })
          ),
          !!data.customFeature.scrollChangeClassify && _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'sub-classify-area', style: { left: DynamicClassifyModule.pxToRpx(data.classifyStyle['width']), width: 'calc(100% - ' + DynamicClassifyModule.pxToRpx(data.classifyStyle['width']) + ')', backgroundColor: data.classifyStyle['sec-background-color'] || '' }, 'scroll-y': true, bindscroll: _this3.dynamicSubClassifyAreaScrollEvent, 'data-compindex': _this3.props.index, 'data-offset-height': JSON.stringify(data.SCAOffHeight), 'data-offset-top-arr': JSON.stringify(data.SCILOffsetTopArr), 'scroll-top': data.SCAScrollTop },
            data.customFeature.showActiveImage && _react2.default.createElement(
              'div',
              { className: 'active-image' },
              _react2.default.createElement('img', { src: data.customFeature.activeImage, onClick: _this3.bindEventTapHandler, 'data-eventparams': JSON.stringify(data.customFeature), style: { width: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgWidth), height: DynamicClassifyModule.pxToRpx(data.classifyStyle.classifyImgHeight), borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['recommendation-border-radius']) } })
            ),
            _react2.default.createElement(
              'div',
              { style: { minHeight: data.SCAMinHeight } },
              data.classifyData && data.classifyData.map(function (item, index) {
                var _ref5;

                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'sub-classify-item-list', style: (_ref5 = { fontSize: data.customFeature['secFontSize'], fontWeight: data.customFeature['secFontWeight'] }, (0, _defineProperty3.default)(_ref5, 'fontWeight', data.customFeature['secFontStyle']), (0, _defineProperty3.default)(_ref5, 'color', data.customFeature['secColor']), _ref5) },
                  _react2.default.createElement(
                    'div',
                    { className: 'first-classify-name' },
                    _react2.default.createElement(
                      'span',
                      { style: { textDecoration: data.classifyStyle['text-decoration'] } },
                      item.name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sub-classify-main ' + (data.customFeature.structure == 2 ? 'horizontal-style' : '') },
                    item.subclass && item.subclass.map(function (subItem, subIndex) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: subIndex },
                        subItem.category_id == data.currentCategory[1] ? _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item selected', onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            }, 'data-level': '2', 'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index, style: (0, _extends3.default)({}, data.classifyItemStyle) },
                          !data.customFeature.showClassifyIcon && _react2.default.createElement('img', { mode: 'scaleToFill', style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']) }, data.imgStyle), src: subItem.cover }),
                          _react2.default.createElement(
                            'div',
                            { className: 'name', style: (0, _extends3.default)({}, data.textStyle) },
                            _react2.default.createElement(
                              'span',
                              { style: (0, _extends3.default)({}, data.textStyle) },
                              subItem.name
                            )
                          )
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'sub-classify-item selected', onClick: function onClick(e) {
                              _this3.tapDynamicClassifyFunc(e);e.stopPropagation();
                            }, 'data-level': '2', 'data-category-id': subItem.category_id, 'data-compindex': _this3.props.index, style: (0, _extends3.default)({}, data.classifyItemStyle) },
                          !data.customFeature.showClassifyIcon && _react2.default.createElement('img', { mode: 'scaleToFill', style: (0, _extends3.default)({ borderRadius: DynamicClassifyModule.pxToRpx(data.classifyStyle['second-border-radius']) }, data.imgStyle), src: subItem.cover }),
                          _react2.default.createElement(
                            'div',
                            { className: 'name', style: (0, _extends3.default)({}, data.textStyle) },
                            _react2.default.createElement(
                              'span',
                              { style: (0, _extends3.default)({}, data.textStyle) },
                              subItem.name
                            )
                          )
                        )
                      );
                    })
                  )
                );
              })
            )
          )
        );
      };
      return _react2.default.createElement(
        'div',
        { className: 'custom-component dynamic-classify' },
        classifyType === 'level1-horizontal' && $level1Horizontal(),
        classifyType === 'level1-vertical' && $level1Vertical(),
        classifyType === 'level1-vertical-withpic' && $level1VerticalWithpic(),
        classifyType === 'level2-horizontal' && $level2Horizontal(),
        classifyType === 'level2-vertical-nopic' && $level2VerticalNopic(),
        classifyType === 'level2-vertical-withpic' && $level2VerticalWithpic()
      );
    }
  }]);
  return DynamicClassifyCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var _this = _this4;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var cateReqUrl = '/index.php?r=appData/getCategoryByGroup';
    var cateParam = { group_id: customFeature.dynamicClassifyGroupId || '' };
    var newdata = {};

    var classifyType = compData.classifyType;
    var classifyStyle = compData.classifyStyle;
    // 一级竖版、一级竖版带图、二级竖版带图、二级竖版无图
    if (compData.classifyType === 'level1-vertical' || compData.classifyType === 'level1-vertical-withpic' || compData.classifyType === 'level2-vertical-withpic' || compData.classifyType === 'level2-vertical-nopic') {
      var classifyItemStyle = {
        width: Math.floor(10000 / customFeature.everyLineNum) / 100 + '%',
        marginBottom: (0, _tools.transformPx2Rem)(classifyStyle['margin-bottom'], 320)
      };
      var listIconStyle = (0, _tools.convertStyleData)({
        width: classifyStyle['classify-icon-size'],
        height: classifyStyle['classify-icon-size']
      });
      var imgStyle = (0, _tools.convertStyleData)({
        'width': classifyStyle['icon-size'],
        'height': classifyStyle['icon-size'],
        'font-size': classifyStyle['icon-size']
      });

      var textStyle = {};
      if (compData.classifyType === 'level1-vertical-withpic') {
        textStyle = {
          fontSize: (0, _tools.transformPx2Rem)(classifyStyle['font-size'], 320),
          fontWeight: classifyStyle['font-weight'] || 'normal',
          fontStyle: classifyStyle['font-style'] || 'normal',
          textDecoration: classifyStyle['text-decoration'] || 'none',
          lineHeight: (0, _tools.transformPx2Rem)(classifyStyle['line-height'], 320),
          color: classifyStyle['color'] || ''
        };
      } else {
        textStyle = {
          fontSize: (0, _tools.transformPx2Rem)(customFeature.secFontSize, 320),
          fontWeight: customFeature.secFontWeight || 'nomal',
          fontStyle: customFeature.secFontStyle || 'normal',
          textDecoration: customFeature.secTextDecoration || 'none',
          color: customFeature.secColor || ''
        };
      }
      newdata['eles[' + compindex + '].classifyItemStyle'] = classifyItemStyle;
      newdata['eles[' + compindex + '].listIconStyle'] = listIconStyle;
      newdata['eles[' + compindex + '].imgStyle'] = imgStyle;
      newdata['eles[' + compindex + '].textStyle'] = textStyle;
    }

    if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
      newdata['eles[' + compindex + '].customFeature.height'] = 'auto';
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].list_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    // WEBAPP不存在顶部导航
    if (pageInstance.data.page_hasNavBar) {
      newdata['eles[' + compindex + '].topNavBarHeight'] = _app.appMethod.globalData.topNavBarHeight;
      newdata['eles[' + compindex + '].page_hasNavBar'] = true;
    } else {
      newdata['eles[' + compindex + '].topNavBarHeight'] = 0;
      newdata['eles[' + compindex + '].page_hasNavBar'] = false;
    }
    pageInstance.setData(newdata);

    if (compData.classifyType === 'level2-vertical-withpic') {
      _this.dynamicSetBoundingClientRectInfo(pageInstance, compindex);
    }

    if (customFeature.classifyType == 2) {
      // 自定义分类
      _this.initDynamicClassifyEle(pageInstance, compindex, customFeature.classifyList, {}, compData);
    } else {
      // 非自定义分类
      if (cateParam.group_id == '') {
        // 选择 '无'
        _app.appMethod.showToast({
          title: '动态分类组件未绑定分类组',
          icon: 'none'
        });
      } else {
        if (cateParam.group_id == -1) {
          // 选择 '全部'
          cateReqUrl = '/index.php?r=AppData/ListCategory';
          if (['goods', 'appointment', 'waimai', 'tostore'].indexOf(customFeature.form) > -1) {
            cateParam = {
              form: 'goods',
              goods_type: _util2.default.getGoodsTypeByForm(customFeature.form)
            };
          } else {
            cateParam = {
              form: customFeature.form
            };
          }
        }
        _app.appMethod.sendRequest({
          hideModal: true,
          hideLoading: true,
          url: cateReqUrl,
          data: cateParam,
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function success(res) {
            _this.initDynamicClassifyEle(pageInstance, compindex, res.data.item || res.data, cateParam, compData);
          },
          fail: function fail(res) {
            var newdata = {};
            newdata['eles[' + compindex + '].loadingFail'] = true;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          },
          hideTemplateLoading: function hideTemplateLoading() {
            var newdata = {};
            newdata['eles[' + compindex + '].loading'] = false;
            newdata['eles[' + compindex + '].is_more'] = 0;
            newdata['eles[' + compindex + '].list_data'] = [];
            pageInstance.setData(newdata);
          }
        });
      }
    }
    if (compData.customFeature.topHover) {
      compData.classify_observer && compData.classify_observer.disconnect();
      _this4.topHover(pageInstance, compindex);
    }
    if (compData.customFeature.topHover) {
      compData.list_observer && compData.list_observer.disconnect();
      _this4.bottomHover(pageInstance, compindex);
    }
  };

  this.initDynamicClassifyEle = function (pageIns, compindex, cateData, cateParam, compData) {
    var _this = _this4;
    var pageInstance = pageIns || _app.appMethod.getAppCurrentPage();
    var classifyLevel = compData.classifyType.charAt(5);
    var classifyData = [];
    var newData = {};
    var currentCategory = [];
    if (cateParam.group_id) {
      classifyData = cateData;
      if (compData.classifyType === 'level1-vertical-withpic' || compData.classifyType === 'level2-vertical-withpic') {
        // 设置默认图片
        classifyData.forEach(function (item) {
          item.cover = /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(item.cover) ? item.cover : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png';
          item.subclass.forEach(function (sitem) {
            sitem.cover = /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(sitem.cover) ? sitem.cover : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png';
          });
        });
      }
    } else {
      // 处理默认选择全部分类的情况
      classifyData = cateData.map(function (item) {
        return {
          category_id: item.id,
          group_id: '',
          name: item.name,
          cover: /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(item.logo) ? item.logo : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
          pid: 0,
          weight: item.weight || '',
          subclass: item.subclass && item.subclass.map(function (sitem) {
            return {
              category_id: sitem.id,
              group_id: '',
              name: sitem.name,
              cover: /^https?\:\/\/.*((((jpe?)|pn)g)|gif)$/.test(sitem.logo) ? sitem.logo : 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
              pid: item.id,
              weight: sitem.weight || ''
            };
          }) || []
        };
      });
      if ((!compData.customFeature.classifyType || compData.customFeature.classifyType == 1) && !compData.customFeature.showAllClassify) {
        // 非自定义分类显示全部分类
        classifyData.unshift({
          category_id: '',
          group_id: '',
          name: '全部',
          cover: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
          pid: 0,
          weight: '',
          subclass: []
        });
      }
    }

    if (compData.classifyType == 'level2-vertical-withpic' || compData.customFeature.showAllClassify) {
      // 过滤分类中的全部分类
      classifyData = classifyData.filter(function (item) {
        return item.category_id;
      });
    }

    if (classifyLevel == 1 && classifyData[0]) {
      currentCategory.push(classifyData[0]['category_id']);
    } else if (classifyLevel == 2 && classifyData[0]) {

      currentCategory = [classifyData[0]['category_id'], classifyData[0]['category_id']];

      if (!compData.customFeature.showAllClassify && compData.classifyType !== 'level2-vertical-withpic') {
        // 二级是否显示全部
        classifyData.forEach(function (item) {
          if (item.name === '全部') {
            return;
          }
          item.subclass.unshift({
            category_id: item.category_id,
            group_id: item.group_id,
            name: '全部',
            cover: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/zhichi-default.png',
            pid: 0,
            weight: item.weight
          });
        });
      } else if (classifyData[0].subclass[0]) {
        currentCategory[1] = classifyData[0].subclass[0]['category_id'];
      };
    }
    newData['eles[' + compindex + '].customFeature.selected'] = 0;
    newData['eles[' + compindex + '].classifyData'] = classifyData;
    newData['eles[' + compindex + '].classifyGroupForm'] = compData.customFeature.form;
    newData['eles[' + compindex + '].currentCategory'] = currentCategory;
    pageInstance.setData(newData);
    if (classifyLevel == 1 && currentCategory.length < 1) {
      return;
    } else if (classifyLevel == 2 && currentCategory.length < 2) {
      if (currentCategory.length == 1) {
        currentCategory[1] = currentCategory[0];
      } else {
        return;
      }
    }
    if (compData.classifyType == 'level2-vertical-withpic') {
      return;
    }
    var idx_value = currentCategory[classifyLevel - 1] == -1 ? '' : currentCategory[classifyLevel - 1];
    var param = {
      page: 1,
      page_size: compData.customFeature.loadingNum || 10,
      form: compData.customFeature.form,
      idx_arr: {
        idx: 'category',
        idx_value: idx_value
      }
    };
    param.page_size = compData.customFeature.loadingNum || 10;
    var field = _app.appMethod.getListVessel(compData);
    var fieldData = {};
    fieldData['eles[' + compindex + '].listField'] = field;
    pageInstance.setData(fieldData);

    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {};
        if (param.form !== 'form') {
          // 动态列表绑定表单则不调用富文本解析
          for (var j in res.data) {
            for (var k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if (/region/.test(k)) {
                continue;
              }
              if (k == 'goods_model') {
                res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
              }
              if (k == 'distance') {
                res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
              }
              var description = res.data[j].form_data[k];
              if (field.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              } else if (_app.appMethod.needParseRichText(description)) {
                res.data[j].form_data[k] = _app.appMethod.getWxParseResult(description);
              }
            }
          }
        }
        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more || '';
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.dynamicSetBoundingClientRectInfo = function (pageIns, compindex, n) {
    if (!compindex || compindex === -1) {
      return;
    }
    var that = _this4,
        pageInstance = pageIns || _app.appMethod.getAppCurrentPage(),
        winHeight = '100%',
        newData = {};
    _app.appMethod.getBoundingClientRect('.sub-classify-area', function (areaRect) {
      if (!areaRect.length) {
        if (isNaN(n)) {
          n = 0;
        }
        if (n < 10) {
          setTimeout(function () {
            that.dynamicSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
        }
        return;
      }
      winHeight = areaRect.shift().height;
      newData['eles[' + compindex + '].SCAOffHeight'] = winHeight;
      _app.appMethod.getBoundingClientRect('.sub-classify-item-list', function (itemRects) {
        if (!itemRects.length && (isNaN(n) || n < 10)) {
          if (isNaN(n)) {
            n = 0;
          }
          setTimeout(function () {
            that.dynamicSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
          return;
        }
        var offsetArr = [];
        var baseHeight = 0;
        if (pageInstance.data.eles[compindex].customFeature.showActiveImage && pageInstance.data.eles[compindex].customFeature.activeImage) {
          baseHeight = parseInt(pageInstance.data.eles[compindex].classifyStyle.classifyImgHeight) * 2.34375 / _app.appMethod.globalData.systemInfo.rpxRatio + parseInt(20 / _app.appMethod.globalData.systemInfo.rpxRatio);
        }
        itemRects.map(function (rect) {
          return rect.height;
        }).reduce(function (p, c) {
          offsetArr.push(p);
          return p + c;
        }, baseHeight);

        newData['eles[' + compindex + '].SCILOffsetTopArr'] = offsetArr;

        if (itemRects.length) {
          // 滚动区域最小高度
          newData['eles[' + compindex + '].SCAMinHeight'] = itemRects.pop().top + winHeight + 'px';
        }
        pageInstance.setData(newData);
      });
    });
  };

  this.tapDynamicClassifyFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var level = event.currentTarget.dataset.level;
    var categoryId = event.currentTarget.dataset.categoryId;
    var hideSubclass = event.currentTarget.dataset.hideSubclass;
    var hasSubclass = event.currentTarget.dataset.hasSubclass;
    var cateIndex = event.currentTarget.dataset.index;
    var compData = pageInstance.data.eles[compindex];
    var currentClassifyLevel = compData.classifyType.charAt(5);
    var showClassifySelect = compData.showClassifySelect;
    var sortKey = compData.sort_key === undefined ? '' : compData.sort_key;
    var sortDirection = compData.sort_direction === undefined ? '' : compData.sort_direction;
    var newData = {};
    if (showClassifySelect) {
      newData['eles[' + compindex + '].showClassifySelect'] = false;
    }
    if (hideSubclass == 1) {
      newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      pageInstance.setData(newData);
      return;
    }
    if (currentClassifyLevel == 2) {
      if (categoryId == '') {
        compData.currentCategory[0] = categoryId;
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      } else if (compData.currentCategory[level - 1] == categoryId) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = hasSubclass ? !compData['classifyAreaLevel2Show'] : false;;
      } else if (level == 1) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = hasSubclass ? true : false;
      } else if (level == 2) {
        newData['eles[' + compindex + '].classifyAreaLevel2Show'] = false;
      }
    }
    compData.currentCategory[level - 1] = categoryId;
    newData['eles[' + compindex + '].currentCategory'] = compData.currentCategory;
    // 隐藏遮罩层
    newData['eles[' + compindex + '].showAllSubclassifySelect'] = false;
    pageInstance.setData(newData);
    if (compData.classifyType == 'level1-vertical-withpic') {
      _app.appMethod.turnToPage('/pages/classifyGoodsListPage/classifyGoodsListPage?form=' + compData.classifyGroupForm + '&category_id=' + categoryId, false);
      return;
    }
    if (compData.classifyType == 'level2-vertical-withpic') {
      if (level == 2) {
        _app.appMethod.turnToPage('/pages/classifyGoodsListPage/classifyGoodsListPage?form=' + compData.classifyGroupForm + '&category_id=' + categoryId, false);
      }
      if (level == 1) {
        if (compData.customFeature.scrollChangeClassify) {
          var _pageInstance$setData;

          var SCILOffsetTopArr = compData.SCILOffsetTopArr || [];
          pageInstance.setData((_pageInstance$setData = {}, (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].SCAScrollTop', SCILOffsetTopArr[cateIndex]), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].isSCATap', true), _pageInstance$setData));
        } else {
          // 点击切换分类哦
          var setStr = 'eles[' + compindex + '].customFeature.selected';
          pageInstance.setData((0, _defineProperty3.default)({}, setStr, cateIndex));
        }
      }
      return;
    }
    if (currentClassifyLevel != level && hasSubclass) {
      // 点击非最后一级的分类不请求新数据
      if (level == 1 && compData.classifyType == 'level2-vertical-nopic') {
        categoryId = event.currentTarget.dataset.subclassId;
        compData.currentCategory[1] = event.currentTarget.dataset.subclassId;
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].currentCategory', compData.currentCategory));
      } else {
        return;
      }
    }

    newData = {};
    if (compData.classifyType == 'level1-horizontal' && compData.classifyStyle.mode == 2) {
      if (cateIndex && cateIndex > 3) {
        newData['eles[' + compindex + '].CAScrollLeft'] = 150 * (cateIndex - 3) + 'rpx';
      } else {
        newData['eles[' + compindex + '].CAScrollLeft'] = 0;
      }
    }
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    newData['eles[' + compindex + '].list_data'] = [];
    newData['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newData);

    // 根据groupId请求第一个分类绑定的数据
    var param = {
      page: 1,
      page_size: 10,
      form: compData.classifyGroupForm,
      idx_arr: {
        idx: 'category',
        idx_value: categoryId == -1 ? '' : categoryId
      },
      sort_key: sortKey,
      sort_direction: sortDirection
    };
    param.page_size = compData.customFeature.loadingNum || 10;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/getFormDataList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {};
        if (param.form !== 'form') {
          // 动态列表绑定表单则不调用富文本解析
          for (var j in res.data) {
            for (var k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if (/region/.test(k)) {
                continue;
              }
              if (k == 'goods_model') {
                res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
              }
              if (k == 'distance') {
                res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
              }

              var description = res.data[j].form_data[k];
              var listField = compData.listField;
              if (listField && listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              } else if (_app.appMethod.needParseRichText(description)) {
                res.data[j].form_data[k] = _app.appMethod.getWxParseResult(description);
              }
            }
          }
        }
        newdata['eles[' + compindex + '].list_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.tapDynamicShowAllClassify = function (event) {
    var dataset = event.currentTarget.dataset,
        compindex = dataset.compindex,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        compData = pageInstance.data.eles[compindex],
        showClassifyAll = compData.showClassifySelect;

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].showClassifySelect', !showClassifyAll));
  };

  this.dynamicSubClassifyAreaScrollEvent = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var offsetTopArr = JSON.parse(dataset.offsetTopArr);
    var scrollTop = event.detail.scrollTop;


    if (pageInstance.data.eles[compindex].isSCATap) {
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].isSCATap', false));
      return;
    }

    offsetTopArr = offsetTopArr || []; // WEBAPP
    for (var i = 0, l = offsetTopArr.length; i < l; i++) {
      if (Math.abs(scrollTop - offsetTopArr[i]) < 50) {
        var classifyData = pageInstance.data.eles[compindex].classifyData;
        if (!classifyData[i]) {
          return;
        }
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].currentCategory[0]', classifyData[i].category_id));
        return;
      }
    }
  };

  this.bindEventTapHandler = function (e) {
    var form = JSON.parse(e.currentTarget.dataset.eventparams);
    var action = form.action;
    customEvent.clickEventHandler[action] && customEvent.clickEventHandler[action](form);
  };

  this.topHover = function (pageInstance, compindex) {
    var compData = pageInstance.data.eles[compindex];
    compData.classify_observer = new IntersectionObserver(function (_ref6) {
      var _ref7 = (0, _slicedToArray3.default)(_ref6, 1),
          res = _ref7[0];

      if (!res) {
        return;
      }
      if (res.boundingClientRect.top < 0 && res.intersectionRect.top == 0) {
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topHover', res.intersectionRatio == 1 ? false : true));
      } else {
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topHover', false));
      }
    });
    var top = 0;
    if (pageInstance.data.page_hasNavBar) {
      //WEBAPP
      top = 0 - _app.appMethod.globalData.topNavBarHeight;
    }
    setTimeout(function () {
      var $customComponent = document.getElementsByClassName('custom-page')[0].children[_this4.props.index];
      var $topHover = $customComponent.getElementsByClassName('topHover')[0];
      compData.classify_observer.observe($topHover);
      // compData.classify_observer.relativeToViewport({top: top}).observe($topHover)
    }, 0);
  };

  this.bottomHover = function (pageInstance, compindex) {
    var compData = pageInstance.data.eles[compindex];
    compData.list_observer = new IntersectionObserver(function (_ref8) {
      var _ref9 = (0, _slicedToArray3.default)(_ref8, 1),
          res = _ref9[0];

      if (!(res.intersectionRatio > 0) && res.boundingClientRect.top < 0) {
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topHover', false));
      }
    });
    setTimeout(function () {
      var $customComponent = document.getElementsByClassName('custom-page')[0].children[_this4.props.index];
      var $bottomHover = $customComponent.getElementsByClassName('bottomHover')[0];
      compData.list_observer.observe($bottomHover);
    }, 0);
  };

  this.showAllSubclassify = function (event) {
    var dataset = event.currentTarget.dataset,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        compindex = dataset.compindex,
        compData = pageInstance.data.eles[compindex];
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].showAllSubclassifySelect', !compData.showAllSubclassifySelect));
  };

  this.hideCover = function (event) {
    var _pageInstance$setData11;

    var dataset = event.currentTarget.dataset,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        compindex = dataset.compindex,
        compData = pageInstance.data.eles[compindex];
    pageInstance.setData((_pageInstance$setData11 = {}, (0, _defineProperty3.default)(_pageInstance$setData11, 'eles[' + compindex + '].classifyAreaLevel2Show', false), (0, _defineProperty3.default)(_pageInstance$setData11, 'eles[' + compindex + '].showClassifySelect', false), _pageInstance$setData11));
  };

  this.listVesselTurnToPage = function (event) {
    _app.appMethod.listVesselTurnToPage(event);
  };

  this.pageScrollFunc = function (event) {
    _app.appMethod.pageScrollFunc(event);
  };
};

exports.default = DynamicClassifyCustomComponent;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(765);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vesselCheckIfCount = function vesselCheckIfCount(compData) {
  // 标记是否有计数器组件
  var flag = false;
  var types = {
    'count-ele': true,
    'new-count': true
  };
  var checkHasEle = function checkHasEle(ele) {
    // 已经标记为true
    if (flag) {
      return;
    }
    // 不为组件
    if (!ele.type) {
      return;
    }
    // 当前组件是否有寻找的组件，有则标记
    if (types[ele.type]) {
      flag = true;
      return;
    }
    // 判断当前组件不为最后一级
    if (Array.isArray(ele.content)) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = ele.content[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var subEle = _step.value;

          checkHasEle(subEle);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (ele.type === 'layout-vessel') {
      // 双栏组件的content不为数组
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = Object.keys(ele.content)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var attr = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = ele.content[attr][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _subEle = _step3.value;

              checkHasEle(_subEle);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  };
  checkHasEle(compData);
  if (flag) {
    return 1;
  }
  return 0;
};

var DynamicVesselCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(DynamicVesselCustomComponent, _React$Component);

  function DynamicVesselCustomComponent(props) {
    (0, _classCallCheck3.default)(this, DynamicVesselCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DynamicVesselCustomComponent.__proto__ || Object.getPrototypeOf(DynamicVesselCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  // 动态容器跳转（应该跟动态列表是同一个跳转函数，暂时分成两个）


  (0, _createClass3.default)(DynamicVesselCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 组件内容处理
       */
      var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component dynamic-vessel', style: styleObj },
        data.list_data && data.list_data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'dynamic-vessel-item', key: index,
              onClick: _this2.dynamicVesselTurnToPage,
              'data-compindex': _this2.props.index,
              'data-index': index,
              'data-dataid': item.id || item.form_data.id && item.form_data.id[0] && item.form_data.id,
              'data-router': data.customFeature.link,
              'data-is-group': item.form_data.is_group_buy,
              'data-is-seckill': item.form_data.is_seckill && item.form_data.is_seckill[0] && item.form_data.is_seckill
            },
            content.map(function (componentData, componentIndex) {
              return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, dynamicData: item['form_data'] });
            })
          );
        }),
        data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
        data.is_more == 0 && data.list_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无数据~' } }),
        data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'dynamicVesselScrollFunc', compindex: this.props.index } }),
        data.is_more == 0 && data.list_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
        !!(data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail) && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: data.customFeature, onClick: this.dynamicVesselScrollFunc, 'data-compindex': this.props.index })
      );
    }
  }]);
  return DynamicVesselCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  this.init = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex]; // 后续更更改为this.props.data
    var customFeature = compData.customFeature;
    var param = {
      id: customFeature['id'],
      form: customFeature['form'],
      page: 1,
      app_id: _app.appMethod.getAppId(),
      is_count: vesselCheckIfCount(compData), // TODO 当前容器中是否有计数器组件
      param_segment: customFeature['param_segment'],
      search_segment: customFeature['search_segment']
    };
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));
  };

  this.detailPageInit = function (compindex, pageInstance, formdata) {
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var oldParam = compData.param || {};
    var vessel_param = {
      "form": customFeature.form,
      "is_count": oldParam.is_count,
      "page": 1,
      "param_segment": customFeature.param_segment,
      "search_segment": customFeature.search_segment
    };

    if (vessel_param.param_segment === 'id') {
      vessel_param.idx = vessel_param.search_segment;
      vessel_param.idx_value = pageInstance.dataId;
    } else if (!!formdata[vessel_param.param_segment]) {
      vessel_param.idx = vessel_param.search_segment;
      vessel_param.idx_value = formdata[vessel_param.param_segment];
    } else {
      return;
    }
    var dynewdata = {};
    dynewdata['eles[' + compindex + '].loading'] = true;
    dynewdata['eles[' + compindex + '].loadingFail'] = false;
    dynewdata['eles[' + compindex + '].list_data'] = [];
    dynewdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(dynewdata);
    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      data: {
        form: vessel_param.form,
        page: 1,
        idx_arr: {
          idx: vessel_param.idx,
          idx_value: vessel_param.idx_value
        }
      },
      method: 'post',
      chain: true,
      success: function success(res) {
        var newDynamicData = {};

        if (!res.data.length) {
          newDynamicData['eles[' + compindex + '].is_more'] = 0;
          newDynamicData['eles[' + compindex + '].loading'] = false;
          newDynamicData['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newDynamicData);
          return;
        }

        if (vessel_param.form !== 'form') {
          // 动态列表绑定表单则不调用富文本解析
          for (var j in res.data) {
            for (var k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if (/region/.test(k)) {
                continue;
              }
              if (k == 'goods_model') {
                res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
              }

              var description = res.data[j].form_data[k];
            }
          }
        }

        newDynamicData['eles[' + compindex + '].list_data'] = res.data;
        newDynamicData['eles[' + compindex + '].is_more'] = res.is_more || 0;
        newDynamicData['eles[' + compindex + '].curpage'] = res.current_page;
        newDynamicData['eles[' + compindex + '].loading'] = false;
        newDynamicData['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newDynamicData);
      },
      fail: function fail() {
        var dynewdata2 = {};
        dynewdata2['eles[' + compindex + '].loadingFail'] = true;
        dynewdata2['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dynewdata2);
      }
    });
  };

  this.dynamicVesselScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.target.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var curpage = compData.curpage + 1;
    var newdata = {};
    var param = {};

    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    if (customFeature.param_segment === 'id') {
      param.idx = customFeature.search_segment;
      param.idx_value = pageInstance.dataId;
    } else if (!!pageInstance.data.detailData[customFeature.param_segment]) {
      param.idx = customFeature.search_segment;
      param.idx_value = pageInstance.data.detailData[customFeature.param_segment];
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      data: {
        form: customFeature.form,
        page: curpage,
        idx_arr: {
          idx: param.idx,
          idx_value: param.idx_value
        }
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        newdata = {};
        for (var j in res.data) {
          for (var k in res.data[j].form_data) {
            if (k == 'category') {
              continue;
            }
            if (/region/.test(k)) {
              continue;
            }
            if (k == 'goods_model') {
              res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
            }

            var description = res.data[j].form_data[k];
          }
        }
        newdata['eles[' + compindex + '].list_data'] = compData.list_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  };

  this.dynamicVesselTurnToPage = function (event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var data_id = dataset.dataid;
    var router = dataset.router;
    var page_form = pageInstance.page_form;
    var isGroup = dataset.isGroup;
    var isSeckill = dataset.isSeckill;
    var compindex = dataset.compindex;
    var index = dataset.index;
    var list = pageInstance.data.eles[compindex].list_data[index];
    var form_data = list.form_data || list;

    if (router == '' || router == -1 || router == '-1') {
      return;
    }

    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (isGroup && isGroup == 1) {
      _app.appMethod.turnToPage('groupGoodsDetail?detail=' + data_id + chainParam);
      return;
    }
    if (isSeckill && isSeckill == 1) {
      _app.appMethod.turnToPage('goodsDetail?detail=' + data_id + '&goodsType=seckill' + chainParam);
      return;
    }

    if (page_form != '') {
      if (router == 'tostoreDetail') {
        _app.appMethod.turnToPage('toStoreDetail?detail=' + data_id + chainParam);
      } else if (router == 'goodsDetail') {
        _app.appMethod.turnToPage('goodsDetail?detail=' + data_id + chainParam);
      } else if (router == 'videoDetail') {
        _app.appMethod.turnToPage('videoDetail?detail=' + data_id + chainParam);
      } else if (router == 'franchiseeDetail') {
        var mode = form_data.mode_id;
        _app.appMethod.goToFranchisee(mode, {
          detail: data_id
        });
      } else if (router == 'presellDetail') {
        _app.appMethod.turnToPage(router + '?detail=' + data_id);
      } else {
        _app.appMethod.turnToPage(router + '?detail=' + data_id);
      }
    }
  };
};

exports.default = DynamicVesselCustomComponent;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

__webpack_require__(767);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormVesselCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(FormVesselCustomComponent, _React$Component);

  function FormVesselCustomComponent(props) {
    (0, _classCallCheck3.default)(this, FormVesselCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FormVesselCustomComponent.__proto__ || Object.getPrototypeOf(FormVesselCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(FormVesselCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      /**
       * 传入数据
       */
      var data = this.props.data;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 组件内容处理
       */
      var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component form-vessel', style: styleObj },
        content.map(function (componentData, componentIndex) {
          return _react2.default.createElement(_CustomComponent2.default, {
            key: componentIndex,
            index: componentIndex,
            data: componentData,
            onSubmit: _this3.submitForm,
            formCompindex: _this3.props.index,
            form_data: data.form_data
          });
        })
      );
    }
  }]);
  return FormVesselCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var _this = _this4;
    var newData = {};
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var content = pageInstance.data.eles[compindex].content;
    var buttonContent = '';
    var buttonIndex = '';
    for (var i = 0; i < content.length; i++) {
      if (content[i].type == 'form-button') {
        buttonContent = content[i];
        buttonIndex = i;
      }
    }
    // 绑定当前动态表单的对象字段
    var formData = _app.appInstance.state.allData.form_data && _app.appInstance.state.allData.form_data[customFeature.form];
    if (formData) {
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].field_arr', formData.field_arr));
    }
    if (buttonIndex === '') {
      return;
    }
    newData['eles[' + compindex + '].content[' + buttonIndex + '].can_use'] = 1;
    pageInstance.setData(newData);
    var param = {
      button_info: {
        'type': buttonContent.customFeature.effect || 1,
        'times': buttonContent.customFeature.frequency || -1,
        'button_id': customFeature.id
      }
    };
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppData/isFormSubmitButtonValid',
      data: param,
      method: 'post',
      success: function success(res) {
        newData = {};
        newData['eles[' + compindex + '].content[' + buttonIndex + '].can_use'] = res.data.can_use;
        newData['eles[' + compindex + '].buttonContent'] = buttonContent;
        pageInstance.setData(newData);
        if (res.data.can_use == 0 && buttonContent.customFeature.showPreviousData) {
          _this.requestLastForm(compindex, pageInstance);
        }
      }
    });
  };

  this.requestLastForm = function (compindex, pageInstance) {
    var content = pageInstance.data.eles[compindex].content;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/GetDatasByUserToken',
      data: { form: pageInstance.data.eles[compindex].customFeature.form },
      method: 'post',
      success: function success(res) {
        var _pageInstance$setData3;

        var preFormData = res.data[0].form_data;
        var asForm = 'eles[' + compindex + '].form_data';
        var asContent = 'eles[' + compindex + '].content';
        content.map(function (item) {
          var item_id = item.customFeature.segment;
          var item_type = item.type;
          for (var key in preFormData) {
            if (key == item_id) {
              switch (item_type) {
                case 'select-ele':
                  if (item.customFeature.type == 1) {
                    var selectArr = [];
                    for (var i = 0; i < item.content.lists.length; i++) {
                      if (item.content.lists[i] == preFormData[key]) {
                        selectArr[i] = i;
                      } else {
                        selectArr[i] = null;
                      }
                    }
                    item.selectedValue = selectArr;
                  }
                  if (item.customFeature.multiSelection) {
                    var _selectArr = [],
                        selectedData = { "checkLength": 0 };
                    for (var _i = 0; _i < item.content.lists.length; _i++) {
                      if (preFormData[key].indexOf(item.content.lists[_i]) >= 0) {
                        _selectArr[_i] = true;
                        selectedData.checkLength++;
                      } else {
                        _selectArr[_i] = false;
                      }
                    }
                    item.content.selectArr = _selectArr;
                    item.selectedData = selectedData;
                  }
                  break;
                case 'time-ele':
                  var time = preFormData[key].split(" ");
                  item.date = time[0];
                  item.time = time[1];
                  break;
                case 'drop-down':
                  var asDrop = 'eles[' + compindex + '].dropDown';
                  var drop = preFormData[key].split(",");
                  var dropDown = {};
                  dropDown[item_id] = drop;
                  pageInstance.setData((0, _defineProperty3.default)({}, asDrop, dropDown));
                  break;
              }
            }
          }
        });
        pageInstance.setData((_pageInstance$setData3 = {}, (0, _defineProperty3.default)(_pageInstance$setData3, asForm, preFormData), (0, _defineProperty3.default)(_pageInstance$setData3, asContent, content), _pageInstance$setData3));
      }
    });
  };

  this.submitForm = function () {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var _this = _this4;
    var compindex = _this4.props.index;
    var compData = _this4.props.data;
    var form = _this4.props.data.customFeature.form;
    var form_data = compData.form_data;
    var field_info = compData.field_info;
    var content = compData.content;
    var form_id = compData.customFeature.id;
    var buttonContent = compData.buttonContent;
    if (!buttonContent) {
      console.log('提交按钮信息有误');
      return;
    }
    var button_info = {
      'type': buttonContent.customFeature.effect,
      'times': buttonContent.customFeature.frequency,
      'pay': buttonContent.customFeature.pay,
      'price': buttonContent.customFeature.price,
      'isDiscount': buttonContent.customFeature.discount,
      'button_id': form_id,
      'operation': ''
    };
    var url = '';
    var contentTip = '';
    var formEleType = ['input-ele', 'textarea-ele', 'grade-ele', 'select-ele', 'upload-img', 'time-ele', 'drop-down', 'pic-options', 'address-ele', 'anonymous-ele', 'upload-video'];

    switch (buttonContent.customFeature.action) {
      case 'integral':
        button_info['operation'] = 1;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['interests'] || 0) + '积分';
        button_info['num'] = buttonContent.customFeature['interests'];
        url = "myIntegral";
        break;
      case 'scratch':
        button_info['operation'] = 2;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['scratch'] || 0) + '刮刮乐次数';
        button_info['num'] = buttonContent.customFeature['scratch'];
        url = "scratch";
        break;
      case 'break-egg':
        button_info['operation'] = 3;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['break-egg'] || 0) + '砸金蛋次数';
        button_info['num'] = buttonContent.customFeature['break-egg'];
        url = "goldenEggs";
        break;
      case 'turntable':
        button_info['operation'] = 4;
        contentTip = '提交成功，增加' + (buttonContent.customFeature['turntable'] || 0) + '大转盘次数';
        button_info['num'] = buttonContent.customFeature['turntable'];
        url = "uckyWheelDetail";
        break;
      case 'coupon':
        button_info['operation'] = 5;
        button_info['obj_id'] = buttonContent.customFeature['couponId'];
        button_info['num'] = buttonContent.customFeature['coupon-num'];
        contentTip = '提交成功，增加' + (buttonContent.customFeature['coupon-num'] || 0) + '优惠券';
        url = "couponList";
        break;
      case 'vip-card':
        button_info['operation'] = 6;
        button_info['obj_id'] = buttonContent.customFeature['vipId'];
        contentTip = '提交成功，增加会员卡一张';
        url = "vipCardList";
        break;
      case 'inner-link':
        button_info['operation'] = 'inner-link';
        var innerParam = buttonContent.customFeature;
        url = innerParam['inner-page-link'];
        break;
      case 'plugin-link':
        button_info['operation'] = 'plugin-link';
        var pluginParam = buttonContent.customFeature;
        url = pluginParam['plugin-page'];
        break;
    }

    var _loop = function _loop(index) {
      if (formEleType.indexOf(content[index].type) == -1) {
        return 'continue';
      }
      var customFeature = content[index].customFeature;
      var segment = customFeature.segment;
      var fieldItem = compData.field_arr.find(function (item) {
        return item.field == segment;
      });
      var ifMust = fieldItem ? Number(fieldItem.necessary) : 0;
      var fieldName = fieldItem ? fieldItem.name : '';
      switch (content[index].type) {
        case 'drop-down':
        case 'anonymous-ele':
          if ((!form_data || !form_data[segment] || form_data[segment].length < content[index].customFeature.contents.length || form_data[segment].split(',').includes('')) && ifMust == 1) {
            _app.appMethod.showModal({
              content: fieldName + ' 没有填写'
            });
            return {
              v: void 0
            };
          }
          break;
        case 'pic-options':
          if (ifMust == 1) {
            if (content[index].customFeature.multiSelection) {
              if (!form_data || !form_data[segment] || form_data[segment].length < content[index].customFeature.minSelect) {
                _app.appMethod.showModal({
                  content: content[index].customFeature.name + '是多选必选项'
                });
                return {
                  v: void 0
                };
              }
            } else {
              if (!form_data || !form_data[segment]) {
                _app.appMethod.showModal({
                  content: content[index].customFeature.name + '是必选项'
                });
                return {
                  v: void 0
                };
              }
            }
          } else {
            if (content[index].customFeature.multiSelection && form_data && form_data[segment] && form_data[segment].length && form_data[segment].length < content[index].customFeature.minSelect) {
              _app.appMethod.showModal({
                content: content[index].customFeature.name + '至少选择' + content[index].customFeature.minSelect + '项'
              });
              return {
                v: void 0
              };
            }
          }
          break;
        case 'input-ele':
        case 'textarea-ele':
          if (ifMust == 1) {
            if (!form_data || !form_data[segment] || form_data[segment].length == 0) {
              _app.appMethod.showModal({
                content: fieldName + ' 没有填写'
              });
              return {
                v: void 0
              };
            } else {
              if (_this.formRegex(content[index].customFeature.dataType, form_data[segment])) {
                return {
                  v: void 0
                };
              }
            }
          } else {
            if (form_data && segment && form_data[segment] && form_data[segment].length && _this.formRegex(content[index].customFeature.dataType, form_data[segment])) {
              return {
                v: void 0
              };
            }
          }
          break;
        case 'select-ele':
          if (content[index].customFeature.type === undefined) {
            break;
          } else if (content[index].customFeature.type === 0) {
            if (ifMust == 1) {
              if (content[index].customFeature.multiSelection) {
                if (!form_data || !form_data[segment] || content[index].selectedData.itemLength < content[index].customFeature.minSelect) {
                  _app.appMethod.showModal({
                    content: content[index].content.title + '是多选必选项'
                  });
                  return {
                    v: void 0
                  };
                }
              } else {
                if (!form_data || !form_data[segment]) {
                  _app.appMethod.showModal({
                    content: content[index].content.title + '是必选项'
                  });
                  return {
                    v: void 0
                  };
                }
              }
            } else {
              if (content[index].customFeature.multiSelection && form_data && form_data[segment] && content[index].selectedData.itemLength && content[index].selectedData.itemLength < content[index].customFeature.minSelect) {
                _app.appMethod.showModal({
                  content: content[index].content.title + '至少选择' + content[index].customFeature.minSelect + '项'
                });
                return {
                  v: void 0
                };
              }
            }
          } else if (content[index].customFeature.type === 1) {
            if (!content[index].selectedValue) {
              if (ifMust == 1) {
                _app.appMethod.showModal({
                  content: content[index].content.title + ' 没有填写'
                });
                return {
                  v: void 0
                };
              }
            } else {
              var arrLength = 0;
              for (var _i2 = 0; _i2 < content[index].selectedValue.length; _i2++) {
                if (content[index].selectedValue[_i2] != null) {
                  arrLength++;
                }
              }
              if (ifMust == 1) {
                if (content[index].customFeature.multiSelection) {
                  if (!form_data || !form_data[segment] || arrLength < content[index].customFeature.minSelect) {
                    _app.appMethod.showModal({
                      content: content[index].content.title + '是多选必选项'
                    });
                    return {
                      v: void 0
                    };
                  }
                } else {
                  if (!form_data || !form_data[segment]) {
                    _app.appMethod.showModal({
                      content: content[index].content.title + '是必选项'
                    });
                    return {
                      v: void 0
                    };
                  }
                }
              } else {
                if (content[index].customFeature.multiSelection && form_data && form_data[segment] && arrLength && arrLength < content[index].customFeature.minSelect) {
                  _app.appMethod.showModal({
                    content: content[index].content.title + '至少选择' + content[index].customFeature.minSelect + '项'
                  });
                  return {
                    v: void 0
                  };
                }
              }
            }
          }
          break;
        case 'time-ele':
          if ((!form_data || !form_data[segment] || form_data[segment].length == 0) && ifMust == 1) {
            // 提示错误
            _app.appMethod.showModal({
              content: fieldName + ' 没有填写'
            });
            return {
              v: void 0
            };
          }
          if (!content[index].customFeature.ifAllDay && (content[index].date && !content[index].time || !content[index].date && content[index].time)) {
            _app.appMethod.showModal({
              content: '请选择具体时间'
            });
            return {
              v: void 0
            };
          }
          break;
        default:
          if (ifMust == 1 && (!form_data || !form_data[segment] || form_data[segment].length == 0)) {
            // 提示错误
            _app.appMethod.showModal({
              content: fieldName + ' 没有填写'
            });
            return {
              v: void 0
            };
          }
          break;
      }
    };

    for (var index = 0; index < content.length; index++) {
      var _ret = _loop(index);

      switch (_ret) {
        case 'continue':
          continue;

        default:
          if ((typeof _ret === 'undefined' ? 'undefined' : (0, _typeof3.default)(_ret)) === "object") return _ret.v;
      }
    }

    if (pageInstance.submitting) return;
    var countNum = 0;
    var countEmptyNum = 0;
    if (!form_data) {
      _app.appMethod.showModal({
        content: '数据为空'
      });
      return;
    } else {
      for (var i in form_data) {
        countNum++;
        if (form_data[i] && typeof form_data[i] == 'number') {
          continue;
        }
        if (!form_data[i] || form_data[i] instanceof Array && form_data[i].length == 0) {
          countEmptyNum++;
        }
      }
      if (countNum == countEmptyNum) {
        _app.appMethod.showModal({
          content: '数据为空'
        });
        return;
      }
    }
    pageInstance.submitting = true;

    var submitData = {
      button_info: button_info,
      form: form,
      form_data: form_data,
      is_transfer_order: button_info.pay ? 1 : 0
    };

    _this.submitFormRequest({
      url: url,
      data: submitData,
      compindex: compindex,
      contentTip: contentTip
    });
  };

  this.submitFormRequest = function (options) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/addData',
      data: options.data,
      method: 'POST',
      success: function success(res) {
        if (options.data.button_info.pay) {
          options.data.form_data_id = res.data;
          _this.submitFormByPay({
            compindex: options.compindex,
            price: options.data.button_info.price,
            isDiscount: options.data.button_info.isDiscount,
            submitData: options.data,
            url: options.url,
            contentTip: options.contentTip
          });
          return;
        };
        _this.addFormDataSuccess(options, res);
      },
      complete: function complete() {
        pageInstance.submitting = false;
      }
    });
  };

  this.submitFormByPay = function (options) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var _data = {};
    if (!options.isDiscount) {
      _data = {
        price: options.price,
        is_balance: 0,
        selected_benefit: {
          no_use_benefit: 1
        }
      };
    } else {
      _data = {
        price: options.price,
        is_balance: 0
      };
    }
    var formInfo = {
      calculData: _data,
      isDiscount: options.isDiscount,
      price: +options.price,
      submitData: options.submitData,
      show: true,
      logo: _app.appMethod.globalData.appLogo,
      name: _app.appMethod.getAppTitle()
    };
    pageInstance.setData({
      formInfo: formInfo
    });
    pageInstance.formPayRef.current.show({
      formInfo: formInfo
    });
    pageInstance.formPayRef.current.calculateTotalPrice({
      compindex: options.compindex,
      url: options.url,
      contentTip: options.contentTip,
      data: options.submitData
    });
  };

  this.addFormDataSuccess = function (options, res) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this4.init(options.compindex, pageInstance);
    if (options.data.button_info['operation'] === 'inner-link' || options.data.button_info['operation'] === 'plugin-link') {
      _app.appMethod.showToast({
        title: '提交成功',
        icon: 'success',
        duration: 3000,
        success: function success() {
          if (options.url) {
            _app.appMethod.turnToPage(options.url);
          }
        }
      });
      return;
    }
    if (!res.msg) {
      _app.appMethod.showModal({
        content: options.contentTip || '提交成功',
        confirmText: options.data.button_info['operation'] ? '去查看' : '确认',
        confirm: function confirm() {
          if (options.url) {
            _app.appMethod.turnToPage(options.url);
          }
        }
      });
    } else {
      _app.appMethod.showModal({
        content: res.msg
      });
    }
  };

  this.formRegex = function (dataType, data) {
    switch (dataType) {
      case 'phone':
        if (!_util2.default.isPhoneNumber(data)) {
          _app.appMethod.showModal({
            content: '请输入正确的手机号'
          });
          return true;
        }
        break;
      case 'IDcard':
        if (!(/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/.test(data) || /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/.test(data))) {
          _app.appMethod.showModal({
            content: '请输入正确的身份证'
          });
          return true;
        }
        break;
      case 'email':
        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(data)) {
          _app.appMethod.showModal({
            content: '请输入正确的邮箱'
          });
          return true;
        }
        break;
      case 'chinese':
        if (!/^[\u4e00-\u9fa5]*$/.test(data)) {
          _app.appMethod.showModal({
            content: '请输入中文'
          });
          return true;
        }
        break;
      case 'number':
        if (!/^[0-9]*$/.test(data)) {
          _app.appMethod.showModal({
            content: '请输入数字'
          });
          return true;
        }
        break;
      case 'english':
        if (!/^[a-zA-Z]*$/.test(data)) {
          _app.appMethod.showModal({
            content: '请输入英文'
          });
          return true;
        }
        break;
      default:
        return false;
        break;
    }
  };
};

exports.default = FormVesselCustomComponent;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputEleCustomComponent;

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(769);

function InputEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  if (data.segment_required) {
    styleObj['maxWidth'] = '7.00rem';
  }
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   * @param {*} event 
   */
  var inputChange = function inputChange(event) {
    var dataset = event.currentTarget.dataset;
    var value = event.target.value;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = dataset.datakey;
    var segment = dataset.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【单行文本】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var newdata = {};
    newdata[datakey] = value;
    pageInstance.setData(newdata);
  };
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component input-ele ' + (data.segment_required ? 'must' : ''),
      style: styleObj
    },
    React.createElement('input', {
      type: 'text',
      placeholder: !!customFeature.placeholder ? customFeature.placeholder : ''
      // value={form_data[data.customFeature.segment]}
      , onInput: inputChange,
      'data-segment': data.customFeature.segment,
      'data-datakey': 'eles[' + formCompindex + '].form_data.' + customFeature.segment,
      'data-value': form_data[data.customFeature.segment]
    })
  );
}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextareaEleCustomComponent;

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(771);

function TextareaEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   * @param {*} event 
   */
  var inputChange = function inputChange(event) {
    var dataset = event.currentTarget.dataset;
    var value = event.target.value;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = dataset.datakey;
    var segment = dataset.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【多行文本】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var newdata = {};
    newdata[datakey] = value;
    pageInstance.setData(newdata);
  };
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component textarea-ele', style: styleObj },
    React.createElement('textarea', {
      placeholder: !!customFeature.placeholder ? customFeature.placeholder : '',
      maxLength: '-1',
      value: form_data[data.customFeature.segment],
      onInput: inputChange,
      'data-segment': data.customFeature.segment,
      'data-datakey': 'eles[' + formCompindex + '].form_data.' + customFeature.segment
    })
  );
}

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slider = __webpack_require__(773);

var _slider2 = _interopRequireDefault(_slider);

exports.default = GradeEleCustomComponent;

__webpack_require__(781);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(783);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GradeEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 根据customFeature.type字段生成对应内容
   */
  var $content = function $content() {
    // 组件类型、单项样式、选中颜色
    var type = customFeature.type,
        icon = customFeature.icon,
        _customFeature$select = customFeature.selectedBackgroundColor,
        selectedBackgroundColor = _customFeature$select === undefined ? '#3091f2' : _customFeature$select;
    // 当前评分

    var editScore = data.editScore;
    var getIconName = function getIconName(i) {
      var o = {
        'love': 'heart',
        'plum': 'clubs'
      };
      return o[i] || i;
    };
    if (type == 0) {
      return _react2.default.createElement(
        'div',
        { className: 'grade-wrap' },
        [1, 2, 3, 4, 5].map(function (item, index) {
          return _react2.default.createElement('div', {
            key: index,
            className: 'ico-moon icon-' + getIconName(icon) + (editScore >= item ? '' : '-empty'),
            style: {
              color: editScore >= item ? selectedBackgroundColor : '#D3D3D3'
            },
            onClick: bindScoreChange,
            'data-compindex': props.index,
            'data-segment': customFeature.segment,
            'data-formcompindex': formCompindex,
            'data-datakey': 'eles[' + formCompindex + '].form_data.' + customFeature.segment,
            'data-score': item
          });
        })
      );
    } else if (type == 1) {
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'slider' },
          _react2.default.createElement(_slider2.default, {
            min: 0,
            max: Number(customFeature.numberNodes) || 1,
            trackStyle: {
              backgroundColor: customFeature.selectedBackgroundColor
            },
            railStyle: {
              backgroundColor: customFeature.lineBackgroundColor
            },
            handleStyle: {
              borderColor: customFeature.sliderColor,
              backgroundColor: customFeature.sliderColor
            },
            onChange: bindSliderChange
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'slider-score' },
          data.sliderScore || 0
        )
      );
    }
  };
  /**
   * 绑定事件
   */
  /**
   * 评分点击更改
   * @param {*} event 
   */
  function bindScoreChange(event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = dataset.datakey;
    var value = dataset.score;
    var compindex = dataset.compindex;
    var formcompindex = dataset.formcompindex;
    var segment = dataset.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var newdata = {};
    newdata[datakey] = value;
    newdata['eles[' + formcompindex + '].content[' + compindex + '].editScore'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 评分滑动更改
   * @param {*} event 
   */
  function bindSliderChange(event) {
    var value = event;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【评分】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var newdata = {};
    newdata[datakey] = value;
    newdata['eles[' + formcompindex + '].content[' + compindex + '].sliderScore'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */
  return _react2.default.createElement(
    'div',
    { className: 'custom-component grade-ele', style: styleObj },
    $content()
  );
}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _Slider = __webpack_require__(774);

var _Slider2 = _interopRequireDefault(_Slider);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Slider = function (_React$Component) {
    (0, _inherits3['default'])(Slider, _React$Component);

    function Slider() {
        (0, _classCallCheck3['default'])(this, Slider);
        return (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Slider, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'div',
                { className: this.props.prefixCls + '-wrapper' },
                React.createElement(_Slider2['default'], this.props)
            );
        }
    }]);
    return Slider;
}(React.Component);

exports['default'] = Slider;

Slider.defaultProps = {
    prefixCls: 'am-slider'
};
module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _Track = __webpack_require__(775);

var _Track2 = _interopRequireDefault(_Track);

var _createSlider = __webpack_require__(776);

var _createSlider2 = _interopRequireDefault(_createSlider);

var _utils = __webpack_require__(212);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* eslint-disable react/prop-types */
var Slider = function (_React$Component) {
  (0, _inherits3['default'])(Slider, _React$Component);

  function Slider(props) {
    (0, _classCallCheck3['default'])(this, Slider);

    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  (0, _createClass3['default'])(Slider, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

      var prevValue = this.state.value;
      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
      var nextValue = this.trimAlignValue(value, nextProps);
      if (nextValue === prevValue) return;

      this.setState({ value: nextValue });
      if (utils.isValueOutOfRange(value, nextProps)) {
        this.props.onChange(nextValue);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      }

      var changedValue = state.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      utils.pauseEvent(e);
      var state = this.state;
      var value = this.calcValueByPos(position);
      var oldValue = state.value;
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
      var val = utils.ensureValueInRange(v, mergedProps);
      return utils.ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          included = _props.included,
          disabled = _props.disabled,
          minimumTrackStyle = _props.minimumTrackStyle,
          trackStyle = _props.trackStyle,
          handleStyle = _props.handleStyle,
          min = _props.min,
          max = _props.max,
          handleGenerator = _props.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = _react2['default'].createElement(_Track2['default'], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        length: offset,
        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);
  return Slider;
}(_react2['default'].Component);

Slider.propTypes = {
  defaultValue: _propTypes2['default'].number,
  value: _propTypes2['default'].number,
  disabled: _propTypes2['default'].bool
};
exports['default'] = (0, _createSlider2['default'])(Slider);
module.exports = exports['default'];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;


  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = (0, _extends3['default'])({
    visibility: included ? 'visible' : 'hidden'
  }, style, positonStyle);
  return _react2['default'].createElement('div', { className: className, style: elStyle });
}; /* eslint-disable react/prop-types */
exports['default'] = Track;
module.exports = exports['default'];

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(52);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(202);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

exports['default'] = createSlider;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addEventListener = __webpack_require__(777);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

var _Steps = __webpack_require__(778);

var _Steps2 = _interopRequireDefault(_Steps);

var _Marks = __webpack_require__(779);

var _Marks2 = _interopRequireDefault(_Marks);

var _Handle = __webpack_require__(780);

var _Handle2 = _interopRequireDefault(_Handle);

var _utils = __webpack_require__(212);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    (0, _inherits3['default'])(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      (0, _classCallCheck3['default'])(this, ComponentEnhancer);

      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = utils.getMousePosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentMouseEvents();
        utils.pauseEvent(e);
      };

      _this.onTouchStart = function (e) {
        if (utils.isNotTouchEvent(e)) return;

        var isVertical = _this.props.vertical;
        var position = utils.getTouchPosition(isVertical, e);
        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        utils.pauseEvent(e);
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = utils.getMousePosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = utils.getTouchPosition(_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        (0, _warning2['default'])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    (0, _createClass3['default'])(ComponentEnhancer, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = (0, _addEventListener2['default'])(document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = (0, _addEventListener2['default'])(document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = (0, _addEventListener2['default'])(document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();

        return this.props.vertical ? rect.top : rect.left;
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props = this.props,
            vertical = _props.vertical,
            min = _props.min,
            max = _props.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props2 = this.props,
            min = _props2.min,
            max = _props2.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props3 = this.props,
            prefixCls = _props3.prefixCls,
            className = _props3.className,
            marks = _props3.marks,
            dots = _props3.dots,
            step = _props3.step,
            included = _props3.included,
            disabled = _props3.disabled,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max,
            children = _props3.children,
            maximumTrackStyle = _props3.maximumTrackStyle,
            style = _props3.style,
            railStyle = _props3.railStyle,
            dotStyle = _props3.dotStyle,
            activeDotStyle = _props3.activeDotStyle;

        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
        return _react2['default'].createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            style: style
          },
          _react2['default'].createElement('div', {
            className: prefixCls + '-rail',
            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          _react2['default'].createElement(_Steps2['default'], {
            prefixCls: prefixCls,
            vertical: vertical,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          _react2['default'].createElement(_Marks2['default'], {
            className: prefixCls + '-mark',
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min
          }),
          children
        );
      }
    }]);
    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
    min: _propTypes2['default'].number,
    max: _propTypes2['default'].number,
    step: _propTypes2['default'].number,
    marks: _propTypes2['default'].object,
    included: _propTypes2['default'].bool,
    className: _propTypes2['default'].string,
    prefixCls: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    children: _propTypes2['default'].any,
    onBeforeChange: _propTypes2['default'].func,
    onChange: _propTypes2['default'].func,
    onAfterChange: _propTypes2['default'].func,
    handle: _propTypes2['default'].func,
    dots: _propTypes2['default'].bool,
    vertical: _propTypes2['default'].bool,
    style: _propTypes2['default'].object,
    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
    railStyle: _propTypes2['default'].object,
    dotStyle: _propTypes2['default'].object,
    activeDotStyle: _propTypes2['default'].object
  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);

      delete restProps.dragging;
      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}
module.exports = exports['default'];

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addEventListenerWrap;

var _addDomEventListener = _interopRequireDefault(__webpack_require__(206));

var _reactDom = _interopRequireDefault(__webpack_require__(19));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
    _reactDom.default.unstable_batchedUpdates(cb, e);
  } : cb;
  return (0, _addDomEventListener.default)(target, eventType, callback, option);
}

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _warning = __webpack_require__(40);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i = i + step) {
      if (points.indexOf(i) >= 0) continue;
      points.push(i);
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
    if (isActived) {
      style = (0, _extends3['default'])({}, style, activeDotStyle);
    }

    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), _classNames));

    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
  });

  return _react2['default'].createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

exports['default'] = Steps;
module.exports = exports['default'];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;

    var markPoint = marks[point];
    var markPointIsObject = (typeof markPoint === 'undefined' ? 'undefined' : (0, _typeof3['default'])(markPoint)) === 'object' && !_react2['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
    return _react2['default'].createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point
      },
      markLabel
    );
  });

  return _react2['default'].createElement(
    'div',
    { className: className },
    elements
  );
};

exports['default'] = Marks;
module.exports = exports['default'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(52);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(15);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Handle = function (_React$Component) {
  (0, _inherits3['default'])(Handle, _React$Component);

  function Handle() {
    (0, _classCallCheck3['default'])(this, Handle);
    return (0, _possibleConstructorReturn3['default'])(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  (0, _createClass3['default'])(Handle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          vertical = _props.vertical,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value']);


      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
      var elStyle = (0, _extends3['default'])({}, style, postionStyle);
      var ariaProps = {};
      if (value !== undefined) {
        ariaProps = (0, _extends3['default'])({}, ariaProps, {
          'aria-valuemin': min,
          'aria-valuemax': max,
          'aria-valuenow': value,
          'aria-disabled': !!disabled
        });
      }
      return _react2['default'].createElement('div', (0, _extends3['default'])({
        role: 'slider'
      }, ariaProps, restProps, {
        className: className,
        style: elStyle
      }));
    }
  }]);
  return Handle;
}(_react2['default'].Component);

exports['default'] = Handle;


Handle.propTypes = {
  className: _propTypes2['default'].string,
  vertical: _propTypes2['default'].bool,
  offset: _propTypes2['default'].number,
  style: _propTypes2['default'].object,
  disabled: _propTypes2['default'].bool,
  min: _propTypes2['default'].number,
  max: _propTypes2['default'].number,
  value: _propTypes2['default'].number
};
module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(782);

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _radio = __webpack_require__(79);

var _radio2 = _interopRequireDefault(_radio);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _checkbox = __webpack_require__(785);

var _checkbox2 = _interopRequireDefault(_checkbox);

exports.default = SelectEleCustomComponent;

__webpack_require__(80);

__webpack_require__(47);

__webpack_require__(788);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(790);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var titleStyleObj = {
    backgroundColor: customFeature.lineBackgroundColor,
    color: customFeature.secColor,
    fontSize: (0, _tools.transformPx2Rem)(customFeature.secFontSize, 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.secLineHeight, 320),
    fontWeight: (0, _tools.transformPx2Rem)(customFeature.secFontWeight, 320),
    fontStyle: customFeature.secFontStyle,
    textDecoration: customFeature.secTextDecoration
    /**
     * 组件内容处理
     */
  };var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 根据customFeature.type字段生成对应内容
   */
  var $content = function $content() {
    // 组件类型、选中样式
    var type = customFeature.type,
        select_style = customFeature.select_style,
        multiSelection = customFeature.multiSelection;

    if (type === undefined) {
      return React.createElement(
        'div',
        null,
        '\u5F53\u524D\u5C55\u793A\u7C7B\u578B\u4E0D\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u8BBE\u7F6E'
      ); // 数据太久 TODO
    } else if (type === 0) {
      // 是否多选
      if (multiSelection) {
        return React.createElement(
          _list2.default,
          null,
          content.lists.map(function (item, index) {
            return React.createElement(
              'div',
              { key: index, className: 'select-item' },
              React.createElement(
                _checkbox2.default.CheckboxItem,
                {
                  disabled: data.selectedData && data.customFeature.maxSelect == data.selectedData.itemLength && data.selectedData[item] != 1,
                  checked: data.content.selectArr && data.content.selectArr[index],
                  onChange: function onChange(e) {
                    return selectOptionOne(e, {
                      value: item,
                      segment: data.customFeature.segment,
                      datakey: 'eles[' + formCompindex + '].form_data.' + customFeature.segment,
                      compindex: props.index,
                      formcompindex: formCompindex
                    });
                  },
                  'data-value': item,
                  'data-segment': data.customFeature.segment,
                  'data-datakey': 'eles[' + formCompindex + '].form_data.' + customFeature.segment,
                  'data-compindex': props.index,
                  'data-formcompindex': formCompindex
                },
                React.createElement(
                  'div',
                  { className: 'select-text' },
                  item
                )
              )
            );
          })
        );
      } else {
        return React.createElement(
          _list2.default,
          null,
          content.lists.map(function (item, index) {
            return React.createElement(
              'div',
              { key: index, className: 'select-item' },
              React.createElement(
                _radio2.default.RadioItem,
                {
                  checked: item == form_data[data.customFeature.segment],
                  onChange: function onChange(e) {
                    return selectOptionOne(e, {
                      value: item,
                      segment: data.customFeature.segment,
                      datakey: 'eles[' + formCompindex + '].form_data.' + customFeature.segment,
                      compindex: props.index,
                      formcompindex: formCompindex
                    });
                  },
                  'data-value': item,
                  'data-segment': data.customFeature.segment,
                  'data-formcompindex': formCompindex,
                  'data-datakey': 'eles[' + formCompindex + '].form_data.' + customFeature.segment
                },
                React.createElement(
                  'div',
                  { className: 'select-text' },
                  item
                )
              )
            );
          })
        );
      }
    } else if (type === 1) {
      return content.lists.map(function (item, index) {
        return React.createElement(
          'div',
          { key: index, className: 'select-list',
            onClick: selectOptionSecond,
            'data-segment': data.customFeature.segment,
            'data-index': index,
            'data-compindex': props.index,
            'data-formcompindex': formCompindex,
            style: {
              borderWidth: (0, _tools.transformPx2Rem)(select_style['border-width'], 320),
              borderStyle: select_style['border-style'],
              borderColor: data.selectedValue && (data.selectedValue[index] === index ? select_style['border-active-color'] : select_style['border-color'])
            }
          },
          data.selectedValue && data.selectedValue[index] == index && React.createElement('div', { className: 'icoo-moon icon-gou',
            style: {
              background: '-webkit-gradient(linear, right top, left bottom, from(' + data.customFeature.select_style['border-active-color'] + '), color-stop(0.5, ' + data.customFeature.select_style['border-active-color'] + '), color-stop(0.5, rgba(255, 0, 0,0)), to(rgba(255, 0, 0,0)))'
            }
          }),
          item
        );
      });
    }
  };
  /**
   *  绑定事件 
   */
  function selectOptionOne(event) {
    var dataset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    event.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var value = dataset.value;
    var datakey = dataset.datakey;
    var segment = dataset.segment;
    var compindex = dataset.compindex;
    var formcompindex = dataset.formcompindex;
    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var newdata = {};
    var selectKey = {};
    newdata[datakey] = value;
    if (newdata[datakey].constructor === Array) {
      newdata[datakey] = newdata[datakey].join();
      for (var i in value) {
        selectKey[value[i]] = 1;
      }
      selectKey.itemLength = value.length;
    } else {
      selectKey[value] = 1;
      selectKey.itemLength = 1;
    }
    newdata['eles[' + formcompindex + '].content[' + compindex + '].selectedData'] = selectKey;
    pageInstance.setData(newdata);
  }
  function selectOptionSecond(event) {
    event.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var formcompindex = dataset.formcompindex;
    var segment = customFeature.segment;
    var multi = customFeature.multiSelection;
    var min = customFeature.minSelect;
    var max = customFeature.maxSelect;
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;
    var selectedValue = data.selectedValue;
    var selectedData = data.content.lists;
    var newdata = {};
    var dataArray = [];

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var componentKey = 'eles[' + formcompindex + '].content[' + compindex + ']';
    newdata[componentKey + '.selectedValue'] = selectedValue ? selectedValue : [];
    if (multi) {
      var arrLength = 0;
      if (newdata[componentKey + '.selectedValue'][index] === index) {
        newdata[componentKey + '.selectedValue'][index] = null;
      } else {
        newdata[componentKey + '.selectedValue'][index] = index;
      }
      for (var i = 0; i < newdata[componentKey + '.selectedValue'].length; i++) {
        var dataIndex = newdata[componentKey + '.selectedValue'][i];
        if (dataIndex != null) {
          arrLength++;
          if (arrLength > max) {
            _app.appMethod.showModal({
              content: '最多选择' + max + '项'
            });
            return;
          }
          dataArray.push(selectedData[dataIndex]);
        }
        newdata[datakey] = dataArray.join(',');
      }
    } else {
      newdata[datakey] = '';
      if (newdata[componentKey + '.selectedValue'][index] === index) {
        newdata[componentKey + '.selectedValue'][index] = null;
      } else {
        newdata[componentKey + '.selectedValue'] = [];
        newdata[componentKey + '.selectedValue'][index] = index;
        newdata[datakey] = selectedData[index];
      }
    }
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component select-ele type-' + customFeature.type, style: styleObj },
    React.createElement(
      'div',
      { className: 'select-container' },
      React.createElement(
        'div',
        { className: 'title-container', style: titleStyleObj },
        React.createElement(
          'span',
          { className: 'title' },
          data.content.title
        )
      ),
      $content()
    )
  );
}

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AgreeItem = __webpack_require__(786);

var _AgreeItem2 = _interopRequireDefault(_AgreeItem);

var _Checkbox = __webpack_require__(153);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _CheckboxItem = __webpack_require__(787);

var _CheckboxItem2 = _interopRequireDefault(_CheckboxItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_Checkbox2['default'].CheckboxItem = _CheckboxItem2['default'];
_Checkbox2['default'].AgreeItem = _AgreeItem2['default'];
exports['default'] = _Checkbox2['default'];
module.exports = exports['default'];

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _getDataAttr = __webpack_require__(201);

var _getDataAttr2 = _interopRequireDefault(_getDataAttr);

var _Checkbox = __webpack_require__(153);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var AgreeItem = function (_React$Component) {
    (0, _inherits3['default'])(AgreeItem, _React$Component);

    function AgreeItem() {
        (0, _classCallCheck3['default'])(this, AgreeItem);
        return (0, _possibleConstructorReturn3['default'])(this, (AgreeItem.__proto__ || Object.getPrototypeOf(AgreeItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(AgreeItem, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                style = _a.style,
                restProps = __rest(_a, ["style"]);var prefixCls = restProps.prefixCls,
                className = restProps.className;

            var wrapCls = (0, _classnames2['default'])(prefixCls + '-agree', className);
            return React.createElement(
                'div',
                (0, _extends3['default'])({}, (0, _getDataAttr2['default'])(restProps), { className: wrapCls, style: style }),
                React.createElement(_Checkbox2['default'], (0, _extends3['default'])({}, restProps, { className: prefixCls + '-agree-label' }))
            );
        }
    }]);
    return AgreeItem;
}(React.Component);

exports['default'] = AgreeItem;

AgreeItem.defaultProps = {
    prefixCls: 'am-checkbox'
};
module.exports = exports['default'];

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _Checkbox = __webpack_require__(153);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var ListItem = _list2['default'].Item;
// tslint:disable-next-line:no-empty
function noop() {}

var CheckboxItem = function (_React$Component) {
    (0, _inherits3['default'])(CheckboxItem, _React$Component);

    function CheckboxItem() {
        (0, _classCallCheck3['default'])(this, CheckboxItem);
        return (0, _possibleConstructorReturn3['default'])(this, (CheckboxItem.__proto__ || Object.getPrototypeOf(CheckboxItem)).apply(this, arguments));
    }

    (0, _createClass3['default'])(CheckboxItem, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                listPrefixCls = _a.listPrefixCls,
                onChange = _a.onChange,
                disabled = _a.disabled,
                checkboxProps = _a.checkboxProps,
                onClick = _a.onClick,
                restProps = __rest(_a, ["listPrefixCls", "onChange", "disabled", "checkboxProps", "onClick"]);var prefixCls = restProps.prefixCls,
                className = restProps.className,
                children = restProps.children;

            var wrapCls = (0, _classnames3['default'])(prefixCls + '-item', className, (0, _defineProperty3['default'])({}, prefixCls + '-item-disabled', disabled === true));
            // Note: if not omit `onChange`, it will trigger twice on check listitem
            if (!disabled) {
                restProps.onClick = onClick || noop;
            }
            var extraProps = {};
            ['name', 'defaultChecked', 'checked', 'onChange', 'disabled'].forEach(function (i) {
                if (i in _this2.props) {
                    extraProps[i] = _this2.props[i];
                }
            });
            return React.createElement(
                ListItem,
                (0, _extends3['default'])({}, restProps, { prefixCls: listPrefixCls, className: wrapCls, thumb: React.createElement(_Checkbox2['default'], (0, _extends3['default'])({}, checkboxProps, extraProps)) }),
                children
            );
        }
    }]);
    return CheckboxItem;
}(React.Component);

exports['default'] = CheckboxItem;

CheckboxItem.defaultProps = {
    prefixCls: 'am-checkbox',
    listPrefixCls: 'am-list',
    checkboxProps: {}
};
module.exports = exports['default'];

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(47);

__webpack_require__(789);

/***/ }),
/* 789 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = UploadImgCustomComponent;

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _ImgUpload = __webpack_require__(100);

__webpack_require__(792);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UploadImgCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  var segment = customFeature.segment;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  styleObj['padding'] = (0, _tools.transformPx2Rem)('15px', 320);

  /**
   * 绑定事件
   */
  var uploadFormImg = function uploadFormImg(url) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var datakey = 'eles[' + formcompindex + '].form_data.' + customFeature.segment;

    var hasImgList = form_data[segment] || [];
    var newdata = {};
    newdata[datakey] = [].concat((0, _toConsumableArray3.default)(hasImgList), [url]);
    pageInstance.setData(newdata);
  };
  var noBindSegment = function noBindSegment() {
    _app.appMethod.showModal({
      content: '该组件【添加图片】未绑定字段 请在电脑编辑页绑定后使用'
    });
  };
  var deleteUploadImg = function deleteUploadImg(index) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var formcompindex = formCompindex;
    var datakey = 'eles[' + formcompindex + '].form_data.' + customFeature.segment;
    _app.appMethod.showModal({
      content: '确定删除该图片？',
      showCancel: true,
      confirm: function confirm() {
        var newdata = {};
        form_data[segment].splice(index, 1);
        newdata[datakey] = form_data[segment];
        pageInstance.setData(newdata);
      }
    });
  };
  var tapPrevewPictureHandler = function tapPrevewPictureHandler(event) {
    _app.appMethod.tapPrevewPictureHandler(event);
  };
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component upload-img ' + (data.segment_required ? 'must' : ''), style: styleObj },
    form_data[segment] && form_data[segment].map(function (item, index) {
      return React.createElement(
        'div',
        { key: item, className: 'has-upload-img' },
        React.createElement('div', { className: 'ico-moon icon-closes delete-img', onClick: function onClick() {
            return deleteUploadImg(index);
          } }),
        React.createElement('img', { src: item,
          onClick: tapPrevewPictureHandler,
          'data-img': item.pic,
          'data-imgarr': JSON.stringify(form_data[segment]) })
      );
    }),
    (!form_data[segment] || form_data[segment].length < (customFeature.upImageCount || 9)) && React.createElement(
      'div',
      { className: 'plus-div' },
      React.createElement(
        'span',
        null,
        '+'
      ),
      React.createElement(
        'div',
        null,
        '\u6DFB\u52A0\u56FE\u7247'
      ),
      segment && React.createElement(_ImgUpload.ImgUpload, { complete: function complete(url) {
          return uploadFormImg(url);
        } }),
      !segment && React.createElement('div', { className: 'no-bind', onClick: noBindSegment })
    )
  );
}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _datePicker = __webpack_require__(101);

var _datePicker2 = _interopRequireDefault(_datePicker);

exports.default = TimeEleCustomComponent;

__webpack_require__(102);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(794);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function format2Date(date) {
  var pad = function pad(n) {
    return n < 10 ? '0' + n : n;
  };
  var dateStr = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
  return '' + dateStr;
}
function format2Time(date) {
  var pad = function pad(n) {
    return n < 10 ? '0' + n : n;
  };
  var timeStr = pad(date.getHours()) + ':' + pad(date.getMinutes());
  return '' + timeStr;
}
function TimeEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  if (customFeature.ifAllDay) {
    styleObj['width'] = '100%';
  }

  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  var Btn = function Btn(_ref) {
    var extra = _ref.extra,
        onClick = _ref.onClick,
        children = _ref.children;
    return React.createElement(
      'div',
      { className: 'time-btn', onClick: onClick },
      children,
      extra
    );
  };
  /**
   * 绑定事件
   */
  function bindDateChange(v) {
    var value = format2Date(v);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var newdata = {};

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【时间】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    var obj = pageInstance.data.eles[formcompindex]['form_data'];
    if (_util2.default.isPlainObject(obj)) {
      obj = pageInstance.data.eles[formcompindex]['form_data'] = {};
    }
    obj = obj[segment];

    if (!!obj) {
      var date = obj.substr(0, 10);
      var time = obj.substr(11);

      if (obj.length == 16) {
        newdata[datakey] = value + ' ' + time;
      } else if (obj.length == 10) {
        newdata[datakey] = value;
      } else if (obj.length == 5) {
        newdata[datakey] = value + ' ' + obj;
      } else if (obj.length == 0) {
        newdata[datakey] = value;
      }
    } else {
      newdata[datakey] = value;
    }
    newdata['eles[' + formcompindex + '].content[' + compindex + '].date'] = value;
    pageInstance.setData(newdata);
  }
  function bindTimeChange(v) {
    var value = format2Time(v);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var newdata = {};

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【时间】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    var obj = pageInstance.data.eles[formcompindex]['form_data'];
    if (_util2.default.isPlainObject(obj)) {
      obj = pageInstance.data.eles[formcompindex]['form_data'] = {};
    }
    obj = obj[segment];

    if (!!obj) {
      var date = obj.substr(0, 10);
      var time = obj.substr(11);

      if (obj.length == 16) {
        newdata[datakey] = date + ' ' + value;
      } else if (obj.length == 10) {
        newdata[datakey] = obj + ' ' + value;
      } else if (obj.length == 5) {
        newdata[datakey] = value;
      } else if (obj.length == 0) {
        newdata[datakey] = value;
      }
    } else {
      newdata[datakey] = value;
    }
    newdata['eles[' + formcompindex + '].content[' + compindex + '].time'] = value;
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component time-ele', style: styleObj },
    React.createElement(
      _datePicker2.default,
      { mode: 'date', format: 'YYYY-MM-DD', extra: data.date || '请选择日期', onChange: function onChange(v) {
          return bindDateChange(v);
        } },
      React.createElement(Btn, null)
    ),
    React.createElement(
      _datePicker2.default,
      { mode: 'time', format: 'HH:mm', extra: data.time || '请选择时间', onChange: function onChange(v) {
          return bindTimeChange(v);
        } },
      React.createElement(Btn, null)
    )
  );
}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

exports.default = DropDownCustomComponent;

__webpack_require__(20);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(796);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropDownCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var titleObj = {
    height: (0, _tools.transformPx2Rem)(customFeature.titleStyle['line-height'], 320),
    color: customFeature.titleStyle.color,
    backgroundColor: customFeature.titleStyle['background-color'],
    fontSize: (0, _tools.transformPx2Rem)(customFeature.titleStyle['font-size'], 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.titleStyle['line-height'], 320),
    fontWeight: customFeature.titleStyle['font-weight'],
    fontStyle: customFeature.titleStyle['font-style'],
    textDecoration: customFeature.titleStyle['text-decoration']
  };
  var pickerTitleObj = {
    height: (0, _tools.transformPx2Rem)(customFeature.contentStyle['line-height'], 320),
    color: customFeature.contentStyle.color,
    backgroundColor: customFeature.contentStyle['background-color'],
    fontSize: (0, _tools.transformPx2Rem)(customFeature.contentStyle['font-size'], 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.contentStyle['line-height'], 320),
    fontWeight: customFeature.contentStyle['font-weight'],
    fontStyle: customFeature.contentStyle['font-style'],
    textDecoration: customFeature.contentStyle['text-decoration']
  };
  /**
   * 组件内容处理
   */
  /**
   * 下拉选项中的contents.options处理为组件需要的optionsData格式
   */
  customFeature.contents.forEach(function (item) {
    item['optionsData'] = item['options'].map(function (item, index) {
      return {
        label: item,
        value: item
      };
    });
  });
  /**
   * Picker内部组件
   */
  var PickerTitle = function PickerTitle(_ref) {
    var extra = _ref.extra,
        onClick = _ref.onClick,
        children = _ref.children;
    return React.createElement(
      'div',
      { className: 'picker-title', style: pickerTitleObj, onClick: onClick },
      children,
      extra
    );
  };
  /**
   * 绑定事件
   * v: 当前【下拉栏】选中的值
   * i: 当前【下拉栏】的索引
   */
  function changeDropDown(v, i) {
    var value = v;
    var index = i;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var componentKey = 'eles[' + formcompindex + '].content[' + compindex + ']';
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【下拉选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    var newdata = {};
    newdata[componentKey + '.dropDown'] = data.dropDown || [];
    newdata[componentKey + '.dropDown'][index] = value;
    newdata[datakey] = newdata[componentKey + '.dropDown'].join(',');
    pageInstance.setData(newdata);
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component drop-down', style: styleObj },
    React.createElement(
      'div',
      { className: 'title', style: titleObj },
      customFeature.name
    ),
    customFeature.contents.map(function (item, index) {
      return React.createElement(
        _picker2.default,
        {
          key: index,
          cols: 1,
          extra: data.dropDown && data.dropDown[index] || item.name,
          data: item.optionsData,
          onChange: function onChange(value) {
            return changeDropDown(value, index);
          }
        },
        React.createElement(PickerTitle, null)
      );
    })
  );
}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = PicOptionsCustomComponent;

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(798);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PicOptionsCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  var picOptions = data.picOptions || [];
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var titleStyleObj = {
    textAlign: customFeature.title_style['text-align'],
    color: customFeature.title_style['color'],
    backgroundColor: customFeature.title_style['background-color'],
    fontSize: (0, _tools.transformPx2Rem)(customFeature.title_style['font-size'], 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.title_style['line-height'], 320),
    fontWeight: customFeature.title_style['font-weight'],
    fontStyle: customFeature.title_style['font-style'],
    textDecoration: customFeature.title_style['text-decoration']
  };
  var itemStyleObj = {
    width: (0, _tools.transformPx2Rem)(customFeature.pic_style.width, 320),
    height: (0, _tools.transformPx2Rem)(customFeature.pic_style.height, 320)
  };
  var iconGouStyleObj = {
    background: '-webkit-gradient(linear, right top, left bottom, from(' + customFeature.pic_style['border-active-color'] + '), color-stop(0.5, ' + customFeature.pic_style['border-active-color'] + '),color-stop(0.5, rgba(255, 0, 0,0)), to(rgba(255, 0, 0,0)))'
  };
  var picStyleObj = {
    width: (0, _tools.transformPx2Rem)(customFeature.pic_style.width, 320),
    height: (0, _tools.transformPx2Rem)(customFeature.pic_style.height, 320),
    borderColor: customFeature.pic_style['border-color'],
    borderRadius: customFeature.pic_style['border-radius'],
    borderStyle: customFeature.pic_style['border-style'],
    borderWidth: customFeature.pic_style['border-width']
  };
  var selectedPicStyleObj = (0, _extends3.default)({}, picStyleObj, {
    borderColor: customFeature.pic_style['border-active-color']
    /**
     * 组件内容处理
     */
  });var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   */
  function selectPicOption(src, index) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var componentKey = 'eles[' + formcompindex + '].content[' + compindex + ']';
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;
    var name = customFeature.name;
    var max = customFeature.maxSelect;
    var multi = customFeature.multiSelection;
    var newdata = {};

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【图片选项】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    // 是否为多选
    if (multi) {
      var _picOptions = data.picOptions || [];
      if (_picOptions[index]) {
        _picOptions[index] = null;
      } else {
        _picOptions[index] = src;
      }
      newdata[componentKey + '.picOptions'] = _picOptions;
      var selectPicOptions = _picOptions.filter(Boolean);
      newdata[datakey] = selectPicOptions;
      if (selectPicOptions > max) {
        _app.appMethod.showModal({
          content: name + '最多选择' + max + '项'
        });
        return;
      }
    } else {
      var _picOptions2 = data.picOptions || [];
      if (_picOptions2[index]) {
        _picOptions2 = [];
      } else {
        _picOptions2 = [];
        _picOptions2[index] = src;
      }
      newdata[componentKey + '.picOptions'] = _picOptions2;
      newdata[datakey] = _picOptions2;
    }
    pageInstance.setData(newdata);
  }
  function tapPrevewPictureHandler(event) {
    _app.appMethod.tapPrevewPictureHandler(event);
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component pic-options mode-' + customFeature.mode, style: styleObj },
    React.createElement(
      'div',
      { className: 'title', style: titleStyleObj },
      customFeature.name
    ),
    customFeature.picOptions.map(function (item, index) {
      return React.createElement(
        'div',
        { className: 'pic-options-list', key: index, onClick: function onClick() {
            return selectPicOption(item.pic, index);
          } },
        React.createElement(
          'div',
          { className: 'pic-options-item', style: itemStyleObj },
          picOptions[index] && React.createElement('div', { className: 'icon-moon icon-gou', style: iconGouStyleObj }),
          React.createElement('img', { src: item.pic, style: picOptions[index] ? selectedPicStyleObj : picStyleObj }),
          React.createElement('span', { className: 'icon-moon icon-big-pic' })
        ),
        React.createElement(
          'div',
          { className: 'pic-options-name',
            onClick: tapPrevewPictureHandler,
            'data-img': item.pic,
            'data-imgarr': JSON.stringify(item.pic)
          },
          item.name
        )
      );
    })
  );
}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AddressEleCustomComponent;

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(800);

function AddressEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var titleObj = {
    height: (0, _tools.transformPx2Rem)(customFeature.titleStyle['line-height'], 320),
    color: customFeature.titleStyle.color,
    backgroundColor: customFeature.titleStyle['background-color'],
    fontSize: (0, _tools.transformPx2Rem)(customFeature.titleStyle['font-size'], 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.titleStyle['line-height'], 320),
    fontWeight: customFeature.titleStyle['font-weight'],
    fontStyle: customFeature.titleStyle['font-style'],
    textDecoration: customFeature.titleStyle['text-decoration'],
    textAlign: customFeature.titleStyle['text-align']
  };
  var selectAddressObj = {
    height: (0, _tools.transformPx2Rem)(customFeature.contentStyle['line-height'], 320),
    color: customFeature.contentStyle.color,
    backgroundColor: customFeature.contentStyle['background-color'],
    fontSize: (0, _tools.transformPx2Rem)(customFeature.contentStyle['font-size'], 320),
    lineHeight: (0, _tools.transformPx2Rem)(customFeature.contentStyle['line-height'], 320),
    fontWeight: customFeature.contentStyle['font-weight'],
    fontStyle: customFeature.contentStyle['font-style'],
    textDecoration: customFeature.contentStyle['text-decoration'],
    textAlign: customFeature.contentStyle['text-align']
  };
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 绑定事件
   */
  function formAddress() {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = formCompindex;
    var formcompindex = props.index;
    var syncUserAddress = customFeature.syncUserAddress;
    var filed = customFeature.segment;
    _app.appMethod.turnToPage('myAddress?from=form&syncUserAddress=' + syncUserAddress);
    // TODO 页面返回后进行回调设置(需要解决页面返回可回调处理的问题/处理前一个页面的实例)
    pageInstance.selectAddressCallback = function (res) {
      var newdata = {};
      var address = res.address_info.province.text + res.address_info.city.text + res.address_info.district.text + res.address_info.detailAddress;
      newdata['eles[' + formcompindex + '].content[' + compindex + '].' + filed] = address;
      pageInstance.setData(newdata);
    };
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component address-ele', style: styleObj },
    React.createElement(
      'div',
      { className: 'title', style: titleObj },
      customFeature.name
    ),
    React.createElement(
      'div',
      { className: 'select-address', style: selectAddressObj, onClick: formAddress },
      '请选择地区',
      React.createElement('span', { className: 'ico-moon icon-rightarrow' })
    )
  );
}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormButtonCustomComponent;

var _tools = __webpack_require__(6);

__webpack_require__(802);

function FormButtonCustomComponent(props) {
  /**
   * 传入数据
   */
  // 组件数据
  var data = props.data;
  // 组件配置对象
  var customFeature = data.customFeature;
  // 动态数据
  var dynamicData = props.dynamicData;
  // 组件状态
  var canUse = data.can_use || 1;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  if (canUse != 1) {
    styleObj['backgroundImage'] = customFeature.lineBackgroundImage;
    styleObj['backgroundColor'] = customFeature.lineBackgroundColor;
  }
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {
    // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component form-button', style: styleObj, disabled: canUse != 1, onClick: props.onSubmit },
    canUse == 1 ? data.content : customFeature.disabledContent || '已提交'
  );
}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FreeVesselCustomComponent;

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(804);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FreeVesselCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component free-vessel', style: styleObj, onClick: function onClick() {
        return (0, _customEvent.customEvent)({ customFeature: customFeature });
      } },
    content.map(function (componentData, componentIndex) {
      return React.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
    })
  );
}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabNavCustomComponent;

var _app = __webpack_require__(4);

__webpack_require__(806);

var turnToPage = function turnToPage(item, selectedRouter) {
  if (item.router === selectedRouter) {
    return;
  }
  _app.appMethod.turnToPage(item.router);
};

function TabNavCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var customFeature = data.customFeature; // 组件特性
  /**
   * 样式数据处理
   */
  var styleObj = {
    backgroundColor: customFeature.backgroundColor,
    borderColor: customFeature.borderStyle === 'black' ? '#d5d5d5' : customFeature.borderStyle
  };
  /**
   * 组件内容处理
   */
  var selectedRouter = props.match.url.substr(1);
  var content = data.content.map(function (item) {
    if (item.router === selectedRouter) {
      item['imgUrl'] = item.selectedIconPath; // 当前项：图片地址
      item['textColor'] = customFeature.selectedColor; // 当前项：文本颜色
    } else {
      item['imgUrl'] = item.iconPath;
      item['textColor'] = customFeature.color;
    }
    return item;
  });
  var itemWidth = 100 / content.length + '%';
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component tab-nav', style: styleObj },
    content.map(function (item, index) {
      return React.createElement(
        'div',
        { className: 'item', key: index, style: { width: itemWidth }, onClick: function onClick() {
            return turnToPage(item, selectedRouter);
          } },
        React.createElement(
          'div',
          { className: 'item-img' },
          React.createElement('img', { src: item.imgUrl })
        ),
        React.createElement(
          'div',
          { className: 'item-text', style: { color: item.textColor } },
          item.text
        )
      );
    })
  );
}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

var _util = __webpack_require__(17);

__webpack_require__(808);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "goods-list" 
 * 组件：商品列表
 * 描述：电商、到店、预约的商品列表显示组件
 * 
 * 组件配置对象
 * customFeature.addShoppingCartImageSrc 控制购物车按钮
 * 
 * customFeature.mode 列表类型
 * 
 */

var hotelDefaultTime = function hotelDefaultTime(date) {
  var date = new Date(date) || new Date(),
      nextDate = new Date(new Date().setDate(date.getDate() + 1)),
      dayList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      start_day = dayList[date.getDay()],
      end_day = dayList[nextDate.getDay()],
      start_date = date.getMonth() + 1 + '月' + date.getDate() + '日',
      end_date = nextDate.getMonth() + 1 + '月' + nextDate.getDate() + '日';
  return {
    start_day: start_day,
    end_day: end_day,
    start_date: start_date,
    end_date: end_date
  };
};

var GoodsListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(GoodsListCustomComponent, _React$Component);

  function GoodsListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, GoodsListCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoodsListCustomComponent.__proto__ || Object.getPrototypeOf(GoodsListCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }
  /**
   * 当前组件内部方法
   */
  /**
   * 初始化
   */


  (0, _createClass3.default)(GoodsListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      if (!data.storeStyle) {
        data.storeStyle = {};
      }
      var styleObj = (0, _tools.convertStyleData)(data.style);
      styleObj['fontSize'] = (0, _tools.transformPx2Rem)(data.style['font-size'], 320); // 计算后重新覆盖值
      if (customFeature.vesselAutoheight == 0) {
        styleObj['height'] = (0, _tools.transformPx2Rem)(customFeature['height'], 320);
      }
      var itemStyleObj = {
        marginBottom: (0, _tools.transformPx2Rem)(customFeature.margin, 320),
        backgroundColor: customFeature.lineBackgroundColor,
        backgroundImage: customFeature.lineBackgroundImage,
        height: (0, _tools.transformPx2Rem)(customFeature.lineHeight, 320)
      };
      var itemImgStyleObj = {
        width: (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.imgHeight, 320)
        // 图片大小根据模式进行调整
      };if (customFeature.mode == 3) {
        itemImgStyleObj['width'] = '100%';
      }
      // 内容部分（非图片）的宽度
      var contentWidth = null;
      // 根据列表类型设置
      switch (customFeature.mode) {
        // 单列
        case 0:
          contentWidth = 'calc(100% - ' + itemImgStyleObj.width + ')';
          break;
        // 双列、大图
        case 1:
        case 3:
          contentWidth = '100%';
          break;
        // 横向
        case 2:
          contentWidth = '' + itemImgStyleObj.width;
          break;
        default:
          contentWidth = 'calc(100% - ' + itemImgStyleObj.width + ')';
          break;
      }

      // 判断购物车按钮是否为图片
      var isImage = function isImage(string) {
        var a = string || 'addshoppingcart1';
        return a.indexOf('addshoppingcart');
      };

      // 判断商品是否包邮
      var isFree = function isFree(goods) {
        var expressFeeSort = goods.form_data.goods_express_data.express_fee_sort;
        if (expressFeeSort.length == 1 && expressFeeSort[0] == 0) {
          return true;
        } else {
          return false;
        }
      };

      /**
       * 加载状态/点击按钮
       */
      var Others = function Others() {
        // 是否为竖版
        var hor = customFeature.mode == 2 && data.curpage > 0;
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading', hor: hor }),
          data.is_more == 0 && data.goods_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无商品数据~' }, hor: hor }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'goodsScrollFunc', compindex: _this2.props.index }, hor: hor }),
          data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll', hor: hor }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: _this2.goodsScrollFunc, 'data-compindex': _this2.props.index })
        );
      };

      /**
       * 积分商品列表
       */
      var IntegralGoodsList = function IntegralGoodsList() {
        return _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'goods-list goods-list-mode-' + customFeature.mode + ' ' + (data.customFeature.mode == 2 && data.curpage > 0 ? 'hor-request-status' : ''),
            style: styleObj,
            'scroll-x': data.customFeature.mode == 2 ? true : false,
            'scroll-y': data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0 ? false : true,
            'scroll-top': data.scrollTop,
            bindscrolltolower: _this2.goodsScrollFunc,
            'data-compindex': _this2.props.index
            // bindanimationend="animationEnd"
          },
          data.customFeature.mode !== 3 && _react2.default.createElement(
            'div',
            { className: 'js-list-container' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-list-item background-ele', key: index, 'data-id': item.form_data.id,
                  style: (0, _extends3.default)({}, itemStyleObj, {
                    height: data.customFeature.mode !== 0 ? data.customFeature.mode === 1 ? '300px ' : '280px' : itemStyleObj.height,
                    marginBottom: data.customFeature.mode !== 0 ? '0px' : ''
                  }),
                  'data-contact': data.customFeature.ifUseContact,
                  'data-goods-type': item.form_data.goods_type,
                  'data-group': item.form_data.is_group_buy,
                  'data-presell': item.form_data.is_presell_goods,
                  'data-groupid': item.form_data.group_buy_activity_id,
                  'data-hidestock': data.customFeature.isHideStock || '',
                  'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice,
                  'data-app-id': item.form_data.app_id,
                  onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement(
                  'div',
                  { className: 'inner-content', style: { verticalAlign: 'top' } },
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: (0, _extends3.default)({}, itemImgStyleObj, {
                      position: 'relative'
                    }) }),
                  item.form_data.corner_mark > 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                  _react2.default.createElement(
                    'div',
                    { className: 'title-container', style: {
                        width: contentWidth
                      } },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                      item.form_data.title
                    ),
                    data.customFeature.isShowVirtualPrice && data.customFeature.form == 'goods' ? data.customFeature.mode == 0 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      data.customFeature.isHideSales && _react2.default.createElement(
                        'div',
                        { style: {
                            width: contentWidth,
                            position: 'absolute',
                            bottom: 0,
                            paddingLeft: '.20rem',
                            height: '60%'
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'price', style: {
                              marginBottom: '.10rem',
                              color: data.storeStyle.theme
                            } },
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                'fontSize': '.28125rem',
                                'marginRight': '.10rem'
                              } },
                            '\xA5'
                          ),
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          ),
                          item.form_data.max_can_use_integral != 0 && item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            null,
                            '+'
                          ),
                          item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.max_can_use_integral,
                            '\u79EF\u5206'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: {
                              bottom: 0
                            } },
                          _react2.default.createElement(
                            'span',
                            { className: 'sales' },
                            '\u9500\u91CF\uFF1A',
                            item.form_data.sales
                          ),
                          item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                          item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') && _react2.default.createElement(
                            'label',
                            { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id,
                              onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                            _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                          )
                        )
                      ),
                      !data.customFeature.isHideSales && _react2.default.createElement(
                        'div',
                        { style: {
                            width: contentWidth,
                            paddingLeft: '.20rem'
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'price', style: { color: data.storeStyle.theme } },
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.28125rem',
                                marginRight: '.1rem',
                                color: data.storeStyle.theme
                              } },
                            '\xA5'
                          ),
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme } },
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          ),
                          item.form_data.max_can_use_integral != 0 && item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme } },
                            '+'
                          ),
                          item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme } },
                            item.form_data.max_can_use_integral,
                            '\u79EF\u5206'
                          )
                        )
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { style: {
                          width: contentWidth
                        } },
                      _react2.default.createElement(
                        'div',
                        { style: {
                            paddingLeft: 0
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'integral-flex-wrap' },
                          item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { className: 'price', style: { color: data.storeStyle.theme } },
                            '\xA5',
                            item.form_data.price
                          ),
                          _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' && _react2.default.createElement(
                              'span',
                              { className: 'price', style: { color: data.storeStyle.theme } },
                              '+'
                            ),
                            item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                              'span',
                              { className: 'price', style: { color: data.storeStyle.theme } },
                              item.form_data.max_can_use_integral,
                              '\u79EF\u5206'
                            )
                          )
                        )
                      ),
                      data.customFeature.isHideSales && _react2.default.createElement(
                        'div',
                        { className: 'sales' },
                        '\u9500\u91CF\uFF1A',
                        item.form_data.sales
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { style: {
                          width: contentWidth
                        } },
                      _react2.default.createElement(
                        'div',
                        { className: 'integral-flex-wrap' },
                        item.form_data.price != '0.00' && _react2.default.createElement(
                          'span',
                          { className: 'price', style: { color: data.storeStyle.theme } },
                          '\xA5',
                          item.form_data.price
                        ),
                        _react2.default.createElement(
                          'span',
                          null,
                          item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { className: 'price', style: { color: data.storeStyle.theme } },
                            '+'
                          ),
                          item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                            'span',
                            { className: 'price', style: { color: data.storeStyle.theme } },
                            item.form_data.max_can_use_integral,
                            '\u79EF\u5206'
                          )
                        )
                      ),
                      data.customFeature.isHideSales && _react2.default.createElement(
                        'span',
                        { className: 'sales' },
                        '\u9500\u91CF\uFF1A',
                        item.form_data.sales
                      )
                    )
                  )
                )
              );
            })
          ),
          data.customFeature.mode === 3 && _react2.default.createElement(
            'div',
            { className: 'js-list-container four-goods-list', 'data-list-index': '0' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-list-item background-ele', key: index, style: itemStyleObj, 'data-id': item.form_data.id, 'data-contact': data.customFeature.ifUseContact, 'data-goods-type': item.form_data.goods_type, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, 'data-hidestock': data.customFeature.isHideStock || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice || '', 'data-app-id': item.form_data.app_id, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement(
                  'div',
                  { style: {
                      position: 'relative'
                    } },
                  item.form_data.corner_mark > 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'four-goods-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    item.form_data.price != '0.00' && _react2.default.createElement(
                      'span',
                      { className: 'integral-price price',
                        style: { color: data.storeStyle.theme } },
                      '\xA5',
                      item.form_data.price
                    ),
                    item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                      'span',
                      { className: 'integral-price price',
                        style: { color: data.storeStyle.theme } },
                      item.form_data.max_can_use_integral,
                      '\u79EF\u5206'
                    ),
                    item.form_data.virtual_price != 0 && data.customFeature.isShowVirtualPrice && _react2.default.createElement(
                      'span',
                      { className: 'virtual_price' },
                      '\xA5',
                      item.form_data.virtual_price
                    ),
                    !data.customFeature.isHideSales && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                    !data.customFeature.isHideSales && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                      'label',
                      { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                      _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                    )
                  ),
                  data.customFeature.isHideSales && _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      '\u9500\u91CF\uFF1A',
                      item.form_data.sales
                    )
                  )
                )
              );
            })
          ),
          _react2.default.createElement(Others, null)
        );
      };

      /**
       * 原有商品列表
       */
      var GoodsList = function GoodsList() {
        var defaultTime = function defaultTime(date) {
          var date = getDate(date) || getDate();
          var nextDate = getDate(getDate().setDate(date.getDate() + 1));
          var dayList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
          var start_day = dayList[date.getDay()];
          var end_day = dayList[nextDate.getDay()];
          var start_date = date.getMonth() + 1 + '月' + date.getDate() + '日';
          var end_date = nextDate.getMonth() + 1 + '月' + nextDate.getDate() + '日';
          return {
            start_day: start_day,
            end_day: end_day,
            start_date: start_date,
            end_date: end_date
          };
        };
        return _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'goods-list goods-list-mode-' + customFeature.mode + ' ' + (data.customFeature.mode == 2 && data.curpage > 0 ? 'hor-request-status' : ''),
            style: styleObj,
            'scroll-x': data.customFeature.mode == 2 ? true : false,
            'scroll-y': data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0 ? false : true,
            'scroll-top': data.scrollTop,
            bindscrolltolower: _this2.goodsScrollFunc,
            'data-compindex': _this2.props.index
            // bindanimationend="animationEnd"
          },
          data.customFeature.form == 'new_appointment' && data.customFeature.unit == 3 ?
          // 行业预约：酒店
          _react2.default.createElement(
            'div',
            { className: 'js-list-container hotel_appointment', 'data-goods-type': '10', 'data-unit': '1', 'data-tplid': data.customFeature.tpl_id, onClick: _this2.turnToGoodsDetail },
            _react2.default.createElement(
              'div',
              { className: 'hotel-section hotel-area' },
              _react2.default.createElement(
                'div',
                { className: 'hotel-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'hotel-h' },
                  '\u76EE\u7684\u5730'
                )
              ),
              _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'hotel-section hotel-time' },
              _react2.default.createElement(
                'div',
                { className: 'enter-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'hotel-h' },
                  hotelDefaultTime(data.customFeature.now_date).start_day,
                  ' \u5165\u4F4F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'hotel-p' },
                  hotelDefaultTime(data.customFeature.now_date).start_date
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'dis-time' },
                '\u51711\u665A'
              ),
              _react2.default.createElement(
                'div',
                { className: 'leave-time' },
                _react2.default.createElement(
                  'div',
                  { className: 'hotel-h' },
                  hotelDefaultTime(data.customFeature.now_date).end_day,
                  ' \u79BB\u5E97'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'hotel-p' },
                  hotelDefaultTime(data.customFeature.now_date).end_date
                )
              )
            )
          ) : +data.customFeature.mode !== 3 && data.customFeature.unit != 3 ? _react2.default.createElement(
            'div',
            { className: 'js-list-container' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-list-item background-ele', key: index, style: itemStyleObj, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, 'data-app-id': item.form_data.app_id, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement(
                  'div',
                  { className: 'inner-content' },
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: (0, _extends3.default)({}, itemImgStyleObj, { position: 'relative' }), mode: 'scaleToFill' }),
                  item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                  _react2.default.createElement(
                    'div',
                    { className: 'title-container', style: {
                        width: contentWidth
                      } },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                      item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                      item.form_data.title
                    ),
                    data.customFeature.isShowVirtualPrice && (data.customFeature.form == 'goods' || data.customFeature.form == 'new_appointment') ? data.customFeature.mode == 0 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      !data.customFeature.isHideSales && _react2.default.createElement(
                        'div',
                        { style: {
                            width: contentWidth,
                            position: 'absolute',
                            bottom: 0,
                            paddingLeft: '.20rem',
                            height: '60%'
                          } },
                        item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                          'div',
                          { className: 'price', style: {
                              marginBottom: '.10rem',
                              color: data.storeStyle.theme
                            } },
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.28125rem',
                                marginRight: '.10rem'
                              } },
                            '\xA5'
                          ),
                          _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          ),
                          item.form_data.virtual_price != 0 && _react2.default.createElement(
                            'span',
                            { className: 'virtual_price' },
                            '\xA5',
                            item.form_data.virtual_price
                          )
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'price member-price' },
                          _react2.default.createElement(
                            'span',
                            { className: 'member-vip-price' },
                            _react2.default.createElement(
                              'span',
                              { style: {
                                  fontSize: '.26rem'
                                } },
                              '\xA5'
                            ),
                            item.form_data.vip_min_price
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'vip-logo', style: {
                                margin: '0 .10rem 0 .20rem'
                              } },
                            '\u4F1A\u5458\u4EF7'
                          ),
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.24rem',
                                color: '#999'
                              } },
                            '\xA5',
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: {
                              bottom: 0
                            } },
                          _react2.default.createElement(
                            'span',
                            { className: 'sales' },
                            '\u9500\u91CF\uFF1A',
                            item.form_data.sales
                          ),
                          item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                          item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && (data.customFeature.form == 'goods' || data.customFeature.form == 'tostore') && _react2.default.createElement(
                            'label',
                            { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                            _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                          )
                        )
                      ),
                      data.customFeature.isHideSales && _react2.default.createElement(
                        'div',
                        { style: {
                            width: contentWidth,
                            paddingLeft: '.20rem'
                          } },
                        item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                          'div',
                          { className: 'price', style: {
                              color: data.storeStyle.theme
                            } },
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.28125rem',
                                marginRight: '.10rem'
                              } },
                            '\xA5'
                          ),
                          _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          ),
                          item.form_data.virtual_price != 0 && _react2.default.createElement(
                            'span',
                            { className: 'virtual_price' },
                            '\xA5',
                            item.form_data.virtual_price
                          ),
                          item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                          item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                            'label',
                            { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                            _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                          )
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'price member-price' },
                          _react2.default.createElement(
                            'span',
                            { className: 'member-vip-price' },
                            _react2.default.createElement(
                              'span',
                              { style: {
                                  fontSize: '.26rem'
                                } },
                              '\xA5'
                            ),
                            item.form_data.vip_min_price
                          ),
                          _react2.default.createElement(
                            'span',
                            { className: 'vip-logo', style: {
                                margin: '0 .20rem 0 .10rem'
                              } },
                            '\u4F1A\u5458\u4EF7'
                          ),
                          item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.24rem',
                                color: '#999'
                              } },
                            '\xA5',
                            item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                          )
                        )
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { style: {
                          width: contentWidth
                        } },
                      item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                        'div',
                        { style: {
                            paddingLeft: 0
                          } },
                        _react2.default.createElement(
                          'span',
                          { className: 'price', style: {
                              color: data.storeStyle.theme
                            } },
                          '\xA5',
                          item.form_data.price
                        ),
                        item.form_data.virtual_price != 0 && _react2.default.createElement(
                          'span',
                          { className: 'virtual_price', style: {
                              marginLeft: 0
                            } },
                          '\xA5',
                          item.form_data.virtual_price
                        )
                      ) : _react2.default.createElement(
                        'div',
                        { className: 'price member-price' },
                        _react2.default.createElement(
                          'span',
                          { className: 'member-vip-price' },
                          _react2.default.createElement(
                            'span',
                            { style: {
                                fontSize: '.26rem'
                              } },
                            '\xA5'
                          ),
                          item.form_data.vip_min_price
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'vip-logo vip-logo-mode-1' },
                          '\u4F1A\u5458\u4EF7'
                        ),
                        item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                          'span',
                          { style: {
                              fontSize: '.24rem',
                              color: '#999',
                              marginLeft: '.10rem'
                            } },
                          '\xA5',
                          item.form_data.goods_type != '1' ? item.form_data.price : item.form_data.price != '0.00' ? item.form_data.price : '免费'
                        )
                      ),
                      data.customFeature.isHideSales && _react2.default.createElement(
                        'span',
                        { className: 'sales' },
                        '\u9500\u91CF\uFF1A',
                        item.form_data.sales
                      ),
                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                        'label',
                        { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                        _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                      )
                    ) : _react2.default.createElement(
                      'div',
                      { style: {
                          width: contentWidth
                        } },
                      _react2.default.createElement(
                        'span',
                        { className: 'price', style: {
                            color: data.storeStyle.theme
                          } },
                        '\xA5',
                        item.form_data.price
                      ),
                      !+data.customFeature.isHideSales && _react2.default.createElement(
                        'span',
                        { className: 'sales' },
                        '\u9500\u91CF\uFF1A',
                        item.form_data.sales
                      ),
                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                      item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.form != 'appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                        'label',
                        { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? 'showGoodsShoppingcart' : 'showAddShoppingcart' },
                        _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                      )
                    )
                  )
                )
              );
            })
          ) : null,
          data.customFeature.mode === 3 && data.customFeature.unit != 3 && _react2.default.createElement(
            'div',
            { className: 'js-list-container four-goods-list' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-list-item background-ele', key: index, style: itemStyleObj, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, 'data-app-id': item.form_data.app_id, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement(
                  'div',
                  { style: {
                      position: 'relative'
                    } },
                  item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'four-goods-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                    item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      item.form_data.price != '0.00' && _react2.default.createElement(
                        'span',
                        { className: 'integral-price price',
                          style: { color: data.storeStyle.theme } },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.max_can_use_integral != 0 && item.form_data.price != '0.00' && _react2.default.createElement(
                        'span',
                        { className: 'integral-price price',
                          style: { color: data.storeStyle.theme } },
                        '+'
                      ),
                      item.form_data.max_can_use_integral != 0 && _react2.default.createElement(
                        'span',
                        { className: 'integral-price price',
                          style: { color: data.storeStyle.theme } },
                        item.form_data.max_can_use_integral,
                        '\u79EF\u5206'
                      ),
                      item.form_data.virtual_price != 0 && data.customFeature.isShowVirtualPrice && data.customFeature.form == 'goods' && _react2.default.createElement(
                        'span',
                        { className: 'virtual_price' },
                        '\xA5',
                        item.form_data.virtual_price
                      )
                    ) : _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: 'member-vip-price' },
                        _react2.default.createElement(
                          'span',
                          { style: {
                              fontSize: '.26rem'
                            } },
                          '\xA5'
                        ),
                        item.form_data.vip_min_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'vip-logo' },
                        '\u4F1A\u5458\u4EF7'
                      ),
                      item.form_data.goods_type != 1 && item.form_data.price != '0.00' && _react2.default.createElement(
                        'span',
                        { style: {
                            fontSize: '.24rem',
                            color: '#999',
                            marign: '0 .10rem 0 .20rem'
                          } },
                        '\xA5',
                        item.form_data.price
                      )
                    ),
                    data.customFeature.isHideSales && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                    data.customFeature.isHideSales && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                      'label',
                      { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                      _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                    )
                  ),
                  !+data.customFeature.isHideSales && _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      '\u9500\u91CF\uFF1A',
                      item.form_data.sales
                    ),
                    item.form_data.is_group_buy != 1 && item.form_data.goods_type != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) >= 0 && _react2.default.createElement('label', { className: 'addShoppingcart ico-moon icon-' + (data.customFeature.addShoppingCartImageSrc || 'addshoppingcart1'), 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] }),
                    item.form_data.is_group_buy != 1 && data.customFeature.form != 'new_appointment' && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                      'label',
                      { className: 'addShoppingcart shoppingImage', 'data-id': item.form_data.id, 'data-buynow': data.customFeature.isBuyNow || '', 'data-isshowvirtualprice': data.customFeature.isShowVirtualPrice, 'data-app-id': item.form_data.app_id, onClick: item.form_data.goods_type == 0 ? _this2['showGoodsShoppingcart'] : _this2['showAddShoppingcart'] },
                      _react2.default.createElement('img', { src: data.customFeature.addShoppingCartImageSrc })
                    )
                  )
                )
              );
            })
          ),
          _react2.default.createElement(Others, null)
        );
      };

      /**
       * 新版商品列表
       */
      var NewGoodsList = function NewGoodsList() {
        return _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'new-goods-list ' + (data.customFeature.mode == 2 && data.curpage > 0 ? 'hor-request-status' : ''),
            style: (0, _extends3.default)({}, styleObj, {
              background: data.customFeature.mode != 0 ? '#f3f3f3' : ''
            }),
            'scroll-x': data.customFeature.mode == 2 ? true : false,
            'scroll-y': data.customFeature.mode == 2 ? false : true,
            'scroll-top': data.scrollTop,
            bindscrolltolower: _this2.goodsScrollFunc,
            'data-compindex': _this2.props.index
            // bindanimationend="animationEnd"
          },
          data.customFeature.mode == 0 && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            data.customFeature.styleMode !== '0-4' ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'new-goods-list-one' },
                data.goods_data && data.goods_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'goods-content', key: index, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-app-id': item.form_data.app_id, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, style: itemStyleObj, onClick: _this2.turnToGoodsDetail },
                    _react2.default.createElement('img', { className: 'goods-image', src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' }),
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                    data.customFeature.styleMode == '0-1' && _react2.default.createElement(
                      'div',
                      { className: 'goods-detail' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                        item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                        item.form_data.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'discount-box' },
                        item.form_data.is_vip_goods == 1 && _react2.default.createElement(
                          'span',
                          { className: 'vip-logo', style: {
                              marginRight: '.10rem'
                            } },
                          '\u4F1A\u5458\u4EF7'
                        ),
                        item.form_data.virtual_price != 0 && _react2.default.createElement(
                          'span',
                          { className: 'discount', style: {
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            } },
                          item.form_data.is_vip_goods != 1 ? item.form_data.discount + '\u6298\u4F18\u60E0' : item.form_data.vip_discount + '\u6298\u4F18\u60E0'
                        ),
                        isFree(item) && _react2.default.createElement(
                          'span',
                          { className: 'express', style: {
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            } },
                          '\u5305\u90AE'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'price-box' },
                        item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme }, className: 'real-price' },
                            '\xA5',
                            item.form_data.price
                          ),
                          item.form_data.virtual_price != 0 && _react2.default.createElement(
                            'span',
                            { className: 'virtual-price' },
                            '\xA5',
                            item.form_data.virtual_price
                          )
                        ) : _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme }, className: 'real-price' },
                            '\xA5',
                            item.form_data.vip_min_price
                          ),
                          item.form_data.price != 0 && _react2.default.createElement(
                            'span',
                            { className: 'virtual-price', style: {
                                textDecoration: 'inherit',
                                position: 'relative',
                                top: '.02rem'
                              } },
                            '\xA5',
                            item.form_data.price
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'sales-box' },
                        _react2.default.createElement(
                          'span',
                          { className: 'sales' },
                          item.form_data.sales,
                          '\u4EBA\u4ED8\u6B3E'
                        )
                      ),
                      item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                    ),
                    data.customFeature.styleMode == '0-2' && _react2.default.createElement(
                      'div',
                      { className: 'goods-detail one-two-mode' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                        item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                        item.form_data.title
                      ),
                      item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                        'div',
                        { className: 'price-box' },
                        _react2.default.createElement(
                          'span',
                          { style: {
                              fontSize: '24rpx',
                              color: '#999',
                              position: 'relative',
                              top: '.06rem'
                            }, className: 'real-price' },
                          '\xA5',
                          item.form_data.price
                        ),
                        item.form_data.virtual_price != 0 && _react2.default.createElement(
                          'span',
                          { style: {
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33',
                              position: 'relative',
                              top: '.05rem'
                            }, className: 'discount two-style-discount vip-trangel' },
                          _react2.default.createElement('span', { style: {
                              borderRightColor: data.storeStyle.theme + '33',
                              marginTop: '.10rem'
                            }, className: 'trangel' }),
                          item.form_data.discount,
                          '\u6298'
                        ),
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme },
                              className: 'real-price' },
                            '\xA5',
                            item.form_data.vip_min_price
                          ),
                          _react2.default.createElement(
                            'span',
                            { style: {
                                color: data.storeStyle.theme,
                                background: data.storeStyle.theme + '33'
                              }, className: 'discount two-style-discount' },
                            _react2.default.createElement('span', { style: {
                                borderRightColor: data.storeStyle.theme + '33'
                              }, className: 'trangel' }),
                            item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                          )
                        )
                      ) : _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        item.form_data.is_vip_goods != 1 && _react2.default.createElement(
                          'span',
                          { className: 'virtual-price' },
                          item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'price-box' },
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme }, className: 'real-price' },
                            '\xA5',
                            item.form_data.price
                          ),
                          item.form_data.virtual_price != 0 && _react2.default.createElement(
                            'span',
                            { style: {
                                color: data.storeStyle.theme,
                                background: data.storeStyle.theme + '33'
                              }, className: 'discount two-style-discount' },
                            _react2.default.createElement('span', { style: {
                                borderRightColor: data.storeStyle.theme + '33'
                              }, className: 'trangel' }),
                            item.form_data.discount,
                            '\u6298'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'sales-box' },
                        isFree(item) && _react2.default.createElement(
                          'span',
                          { className: 'express', style: {
                              color: data.storeStyle.theme,
                              borderColor: data.storeStyle.theme + '33'
                            } },
                          '\u5305\u90AE'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'sales' },
                          item.form_data.sales,
                          '\u4EBA\u4ED8\u6B3E'
                        )
                      ),
                      item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                    ),
                    data.customFeature.styleMode == '0-3' && _react2.default.createElement(
                      'div',
                      { className: 'goods-detail one-three-mode' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                        item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                        item.form_data.title
                      ),
                      item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 && _react2.default.createElement(
                        'span',
                        { style: {
                            background: data.storeStyle.theme
                          }, className: 'discount-sign ico-moon icon-download-sign discount-sign-' + (data.storeStyle.theme ? data.storeStyle.theme.replace('#', '') : '') },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.discount,
                        '\u6298'
                      ),
                      item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                        'div',
                        { className: 'price-box ' + (item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 ? '' : 'mgt85') },
                        _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme },
                              className: 'real-price' },
                            '\xA5',
                            item.form_data.vip_min_price
                          ),
                          _react2.default.createElement(
                            'span',
                            { style: {
                                color: data.storeStyle.theme,
                                background: data.storeStyle.theme + '33'
                              }, className: 'discount two-style-discount' },
                            _react2.default.createElement('span', { style: {
                                borderRightColor: data.storeStyle.theme + '33'
                              }, className: 'trangel' }),
                            item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                          ),
                          isFree(item) && _react2.default.createElement(
                            'span',
                            { className: 'express', style: {
                                color: data.storeStyle.theme,
                                borderColor: data.storeStyle.theme,
                                background: data.storeStyle.theme ? 'none' : ''
                              } },
                            '\u5305\u90AE'
                          )
                        )
                      ) : _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                          'div',
                          { className: 'price-box ' + (item.form_data.virtual_price != 0 && item.form_data.is_vip_goods !== 1 ? '' : 'mgt85') },
                          _react2.default.createElement(
                            'span',
                            { style: { color: data.storeStyle.theme }, className: 'real-price' },
                            '\xA5',
                            item.form_data.price
                          ),
                          item.form_data.is_vip_goods != 1 && _react2.default.createElement(
                            'span',
                            { className: 'virtual-price' },
                            item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''
                          ),
                          isFree(item) && _react2.default.createElement(
                            'span',
                            { className: 'express', style: {
                                color: data.storeStyle.theme,
                                borderColor: data.storeStyle.theme,
                                background: data.storeStyle.theme ? 'none' : ''
                              } },
                            '\u5305\u90AE'
                          )
                        )
                      ),
                      item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                    )
                  );
                })
              )
            ) : _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'new-goods-list-one-four' },
                data.goods_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    {
                      className: 'goods-card-content',
                      key: index,
                      'data-id': item.form_data.id,
                      'data-goods-type': item.form_data.goods_type,
                      'data-app-id': item.form_data.app_id,
                      style: itemStyleObj,
                      'data-group': item.form_data.is_group_buy,
                      'data-presell': item.form_data.is_presell_goods,
                      'data-group-id': item.form_data.group_buy_activity_id,
                      'data-stock': item.form_data.stock,
                      onClick: _this2.turnToGoodsDetail
                    },
                    _react2.default.createElement('img', {
                      className: 'goods-image',
                      src: item.form_data.cover,
                      style: itemImgStyleObj,
                      mode: 'scaleToFill'
                    }),
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', {
                      className: 'goods-subscript',
                      src: item.form_data.corner_url
                    }),
                    item.form_data.stock == 0 && _react2.default.createElement(
                      'div',
                      { className: 'sell-out' },
                      _react2.default.createElement(
                        'div',
                        { className: 'sell-out-btn' },
                        '\u5DF2\u552E\u7F44'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'one-four-mode' },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', {
                            className: 'title-subscript',
                            src: item.form_data.corner_url
                          }),
                          item.form_data.app_shop_data && item.form_data.app_shop_data.name && _react2.default.createElement(
                            'span',
                            null,
                            '【' + item.form_data.app_shop_data.name + '】'
                          ),
                          item.form_data.title
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'shop-info' },
                          _react2.default.createElement(
                            'div',
                            { className: 'shop-tags' },
                            _react2.default.createElement(
                              'div',
                              { className: 'tag-wrap' },
                              item.form_data.category && item.form_data.category.map(function (tag, index) {
                                return _react2.default.createElement(
                                  _react2.default.Fragment,
                                  { key: index },
                                  index === item.form_data.category.length - 1 && _react2.default.createElement(
                                    'span',
                                    null,
                                    tag
                                  )
                                );
                              })
                            ),
                            _react2.default.createElement(
                              'div',
                              null,
                              item.form_data.app_shop_data && item.form_data.app_shop_data.county_name
                            )
                          ),
                          item.form_data.app_shop_data && item.form_data.app_shop_data.distance && _react2.default.createElement(
                            'div',
                            null,
                            item.form_data.app_shop_data.distance
                          )
                        ),
                        item.form_data.is_vip_goods == 1 && _react2.default.createElement(
                          'div',
                          { className: 'price-vip-box' },
                          _react2.default.createElement('img', {
                            className: 'price-vip-image',
                            src: 'http://develop.zhichiwangluo.com/static/webapp/images/xcx-goods/vip-price.png'
                          }),
                          _react2.default.createElement(
                            'span',
                            null,
                            item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                          )
                        ),
                        item.form_data.is_vip_goods != 1 && item.form_data.virtual_price != 0 && data.customFeature.virtualPriceOption != 3 && data.customFeature.priceOption != 3 && _react2.default.createElement(
                          'div',
                          { className: 'real-price-box' },
                          item.form_data.discount + '折'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'price-btn' },
                        item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'div',
                            { className: 'price-box' },
                            item.form_data.price_break_discounts_activity_id > 0 && _react2.default.createElement(
                              'span',
                              { className: 'discount' },
                              '\u6EE1\u51CF'
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                style: { color: data.storeStyle.theme },
                                className: 'real-price'
                              },
                              '¥' + item.form_data.price
                            ),
                            _react2.default.createElement('div', null)
                          )
                        ) : _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(
                            'div',
                            { className: 'price-box' },
                            item.form_data.price_break_discounts_activity_id > 0 && _react2.default.createElement(
                              'span',
                              { className: 'discount' },
                              '\u6EE1\u51CF'
                            ),
                            _react2.default.createElement(
                              'span',
                              {
                                style: { color: data.storeStyle.theme },
                                className: 'real-price'
                              },
                              '¥' + item.form_data.price
                            ),
                            item.form_data.is_vip_goods != 1 && _react2.default.createElement(
                              'span',
                              { className: 'virtual-price' },
                              item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''
                            ),
                            item.discountStr && item.form_data.integral == '1' && _react2.default.createElement(
                              'span',
                              {
                                style: {
                                  color: data.storeStyle.theme,
                                  background: data.storeStyle.theme + '33'
                                },
                                className: 'express-new two-style-discount'
                              },
                              _react2.default.createElement('span', {
                                style: {
                                  borderRightColor: data.storeStyle.theme + '33'
                                },
                                className: 'trangel'
                              }),
                              item.discountStr
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'submit-btn' },
                          '\u7ACB\u5373\u62A2'
                        )
                      )
                    )
                  );
                })
              )
            )
          ),
          data.customFeature.mode == 1 && _react2.default.createElement(
            'div',
            { className: 'new-goods-list-two clearfix' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-content', key: index, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-app-id': item.form_data.app_id, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, style: itemStyleObj, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' }),
                item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                  item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                  item.form_data.title
                ),
                data.customFeature.styleMode == '1-1' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail' },
                  _react2.default.createElement(
                    'div',
                    { className: 'discount-box' },
                    item.form_data.is_vip_goods == 1 && _react2.default.createElement(
                      'span',
                      { className: 'vip-logo', style: {
                          marginRight: '.10rem'
                        } },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    item.form_data.virtual_price != 0 && _react2.default.createElement(
                      'span',
                      { className: 'discount', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      item.form_data.is_vip_goods != 1 ? item.form_data.discount + '\u6298\u4F18\u60E0' : item.form_data.vip_discount + '\u6298\u4F18\u60E0'
                    ),
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price' },
                        '\xA5',
                        item.form_data.virtual_price
                      )
                    ) : _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      item.form_data.price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price', style: {
                            textDecoration: 'inherit',
                            position: 'relative',
                            top: '.02rem'
                          } },
                        '\xA5',
                        item.form_data.price
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                ),
                data.customFeature.styleMode == '1-2' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail two-two-mode' },
                  item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    _react2.default.createElement(
                      'span',
                      { style: {
                          fontSize: '24rpx',
                          color: '#999',
                          position: 'relative',
                          top: '.06rem'
                        }, className: 'real-price' },
                      '\xA5',
                      item.form_data.price
                    ),
                    item.form_data.virtual_price != 0 && _react2.default.createElement(
                      'span',
                      { style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33',
                          position: 'relative',
                          top: '.05rem'
                        }, className: 'discount two-style-discount vip-trangel' },
                      _react2.default.createElement('span', { style: {
                          borderRightColor: data.storeStyle.theme + '33',
                          marginTop: '.10rem'
                        }, className: 'trangel' }),
                      item.form_data.discount,
                      '\u6298'
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme },
                          className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: {
                            color: data.storeStyle.theme,
                            background: data.storeStyle.theme + '33'
                          }, className: 'discount two-style-discount' },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                      )
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.form_data.is_vip_goods != 1 && _react2.default.createElement(
                      'span',
                      { className: 'virtual-price' },
                      item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'price-box' },
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { style: {
                            color: data.storeStyle.theme,
                            background: data.storeStyle.theme + '33'
                          }, className: 'discount two-style-discount' },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.discount,
                        '\u6298'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          borderColor: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                )
              );
            })
          ),
          data.customFeature.mode == 2 && _react2.default.createElement(
            'div',
            { className: 'new-goods-list-three' },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-content', key: index, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-app-id': item.form_data.app_id, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, style: itemStyleObj, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' }),
                item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                  item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                  item.form_data.title
                ),
                data.customFeature.styleMode == '2-1' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail' },
                  _react2.default.createElement(
                    'div',
                    { className: 'discount-box' },
                    item.form_data.is_vip_goods == 1 && _react2.default.createElement(
                      'span',
                      { className: 'vip-logo', style: {
                          marginRight: '.10rem'
                        } },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    item.form_data.virtual_price != 0 && _react2.default.createElement(
                      'span',
                      { className: 'discount', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      item.form_data.is_vip_goods != 1 ? item.form_data.discount + '\u6298\u4F18\u60E0' : item.form_data.vip_discount + '\u6298\u4F18\u60E0'
                    ),
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price' },
                        '\xA5',
                        item.form_data.virtual_price
                      )
                    ) : _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      item.form_data.price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price', style: {
                            textDecoration: 'inherit',
                            position: 'relative',
                            top: '.02rem'
                          } },
                        '\xA5',
                        item.form_data.price
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                ),
                data.customFeature.styleMode == '2-2' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail three-two-mode' },
                  item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    _react2.default.createElement(
                      'span',
                      { style: {
                          fontSize: '24rpx',
                          color: '#999',
                          position: 'relative',
                          top: '.06rem'
                        }, className: 'real-price' },
                      '\xA5',
                      item.form_data.price
                    ),
                    item.form_data.virtual_price != 0 && _react2.default.createElement(
                      'span',
                      { style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33',
                          position: 'relative',
                          top: '.05rem'
                        }, className: 'discount two-style-discount vip-trangel' },
                      _react2.default.createElement('span', { style: {
                          borderRightColor: data.storeStyle.theme + '33',
                          marginTop: '.10rem'
                        }, className: 'trangel' }),
                      item.form_data.discount,
                      '\u6298'
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme },
                          className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: {
                            color: data.storeStyle.theme,
                            background: data.storeStyle.theme + '33'
                          }, className: 'discount two-style-discount' },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                      )
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    item.form_data.is_vip_goods != 1 && _react2.default.createElement(
                      'span',
                      { className: 'virtual-price' },
                      item.form_data.virtual_price != 0 ? '¥' + item.form_data.virtual_price : ''
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'price-box' },
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { style: {
                            color: data.storeStyle.theme,
                            background: data.storeStyle.theme + '33'
                          }, className: 'discount two-style-discount' },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.discount,
                        '\u6298'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'sales-box' },
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          borderColor: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                )
              );
            })
          ),
          data.customFeature.mode == 3 && _react2.default.createElement(
            'div',
            { className: 'new-goods-list-four ' + (data.customFeature.styleMode == '3-3' ? 'list-padding' : '') },
            data.goods_data && data.goods_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'goods-content ' + (data.customFeature.styleMode == '3-3' ? 'list-border' : ''), key: index, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-app-id': item.form_data.app_id, 'data-group': item.form_data.is_group_buy, 'data-presell': item.form_data.is_presell_goods, 'data-groupid': item.form_data.group_buy_activity_id, style: itemStyleObj, onClick: _this2.turnToGoodsDetail },
                _react2.default.createElement('img', { className: 'goods-image ' + (data.customFeature.styleMode == '3-3' ? 'image-border' : ''), src: item.form_data.cover, style: itemImgStyleObj, mode: 'scaleToFill' }),
                item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                data.customFeature.styleMode == '3-1' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                    item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'discount-box' },
                    item.form_data.is_vip_goods == 1 && _react2.default.createElement(
                      'span',
                      { className: 'vip-logo', style: {
                          marginRight: '.10rem'
                        } },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    item.form_data.virtual_price != 0 && _react2.default.createElement(
                      'span',
                      { className: 'discount', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      item.form_data.is_vip_goods != 1 ? item.form_data.discount + '\u6298\u4F18\u60E0' : item.form_data.vip_discount + '\u6298\u4F18\u60E0'
                    ),
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    item.form_data.is_vip_goods != 1 ? _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price' },
                        '\xA5',
                        item.form_data.virtual_price
                      )
                    ) : _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      item.form_data.price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price', style: {
                            textDecoration: 'inherit',
                            position: 'relative',
                            top: '.02rem'
                          } },
                        '\xA5',
                        item.form_data.price
                      )
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                ),
                data.customFeature.styleMode == '3-2' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail four-two-mode' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                    item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                    item.form_data.title
                  ),
                  item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                    'div',
                    { className: 'price-box' },
                    _react2.default.createElement(
                      'span',
                      { style: { color: data.storeStyle.theme },
                        className: 'real-price' },
                      '\xA5',
                      item.form_data.vip_min_price
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: {
                          color: data.storeStyle.theme,
                          background: data.storeStyle.theme + '33'
                        }, className: 'discount two-style-discount' },
                      _react2.default.createElement('span', { style: {
                          borderRightColor: data.storeStyle.theme + '33'
                        }, className: 'trangel' }),
                      item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'price-box' },
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { className: 'virtual-price' },
                        '\xA5',
                        item.form_data.virtual_price
                      ),
                      item.form_data.virtual_price != 0 && _react2.default.createElement(
                        'span',
                        { style: {
                            color: data.storeStyle.theme,
                            background: data.storeStyle.theme + '33'
                          }, className: 'discount two-style-discount' },
                        _react2.default.createElement('span', { style: {
                            borderRightColor: data.storeStyle.theme + '33'
                          }, className: 'trangel' }),
                        item.form_data.discount,
                        '\u6298'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'discount-box' },
                    isFree(item) && _react2.default.createElement(
                      'span',
                      { className: 'express', style: {
                          color: data.storeStyle.theme,
                          borderColor: data.storeStyle.theme + '33'
                        } },
                      '\u5305\u90AE'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'sales' },
                      item.form_data.sales,
                      '\u4EBA\u4ED8\u6B3E'
                    ),
                    item.form_data.is_group_buy != 1 && _react2.default.createElement('label', { style: { color: data.storeStyle.theme }, className: 'shopping-icon ico-moon icon-addshoppingcart5', 'data-id': item.form_data.id, 'data-app-id': item.form_data.app_id, onClick: _this2.showGoodsShoppingcart })
                  )
                ),
                data.customFeature.styleMode == '3-3' && _react2.default.createElement(
                  'div',
                  { className: 'goods-detail four-three-mode' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                    item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                    item.form_data.title
                  ),
                  item.form_data.is_vip_goods == 1 ? _react2.default.createElement(
                    'div',
                    { className: 'price-box ' + (data.customFeature.styleMode == '3-3' ? 'df' : '') },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme }, className: 'real-price' },
                        '\xA5',
                        item.form_data.vip_min_price
                      ),
                      item.discountStr && item.form_data.integral == '1' && _react2.default.createElement('span', { style: { color: data.storeStyle.theme, background: data.storeStyle.theme + '33' }, className: 'express-new two-style-discount' }),
                      _react2.default.createElement(
                        'span',
                        { style: { color: data.storeStyle.theme, background: data.storeStyle.theme + '33' }, className: 'discount two-style-discount' },
                        item.form_data.virtual_price != 0 ? '会员' + item.form_data.vip_discount + '折' : '会员价'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'purchase-btn', style: { background: data.storeStyle.theme, boxShadow: '0.03rem 0.12rem 0.18rem ' + (data.storeStyle.theme + '33') } },
                      '\u7ACB\u5373\u8D2D\u4E70'
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'price-box ' + (data.customFeature.styleMode == '3-3' ? 'df' : '') },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'span',
                          { style: { color: data.storeStyle.theme }, className: 'real-price' },
                          '\xA5',
                          item.form_data.price
                        ),
                        item.form_data.virtual_price != 0 && _react2.default.createElement(
                          'span',
                          { className: 'virtual-price' },
                          '\u5E02\u573A\u4EF7\xA5',
                          item.form_data.virtual_price
                        ),
                        item.form_data.virtual_price != 0 && _react2.default.createElement(
                          'span',
                          { style: {
                              color: data.storeStyle.theme,
                              background: data.storeStyle.theme + '33'
                            }, className: 'discount two-style-discount' },
                          item.form_data.discount,
                          '\u6298'
                        ),
                        isFree(item) && _react2.default.createElement(
                          'span',
                          { className: 'express', style: {
                              color: data.storeStyle.theme,
                              borderColor: data.storeStyle.theme,
                              background: data.storeStyle.theme ? 'none' : ''
                            } },
                          '\u5305\u90AE'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'purchase-btn', style: { background: data.storeStyle.theme, boxShadow: '0.03rem 0.12rem 0.18rem ' + (data.storeStyle.theme + '33') } },
                        '\u7ACB\u5373\u8D2D\u4E70'
                      )
                    )
                  )
                )
              );
            })
          ),
          data.customFeature.mode == 4 && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            data.customFeature.styleMode == '4-1' && _react2.default.createElement(
              'div',
              { className: 'new-goods-list-five' },
              data.goods_data && data.goods_data.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'goods-content', key: index, 'data-id': item.form_data.id, 'data-goods-type': item.form_data.goods_type, 'data-app-id': item.form_data.app_id, onClick: _this2.turnToGoodsDetail, 'data-group': item.form_data.is_group_buy,
                    'data-presell': item.form_data.is_presell_goods, 'data-group-id': item.form_data.group_buy_activity_id, style: itemStyleObj },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-image', style: (0, _extends3.default)({}, itemImgStyleObj, { backgroundImage: 'url(' + item.form_data.cover + ')' }) },
                    item.form_data.corner_mark > 0 && item.form_data.corner_position == 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'good_detail' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      item.form_data.corner_mark > 0 && item.form_data.corner_position == 1 && _react2.default.createElement('img', { className: 'title-subscript', src: item.form_data.corner_url }),
                      item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                      item.form_data.title
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: { color: data.storeStyle.theme }, className: 'real-price' },
                      '\xA5',
                      item.form_data.price
                    ),
                    item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && !(isImage(data.customFeature.addShoppingCartImageSrc) < 0) && _react2.default.createElement('label', { style: { color: data.storeStyle.theme },
                      className: 'shopping-icon ico-moon icon-' + data.customFeature.addShoppingCartImageSrc,
                      'data-id': item.form_data.id,
                      'data-app-id': item.form_data.app_id,
                      'data-ispackage': item.form_data.is_package_goods,
                      onClick: _this2.showGoodsShoppingcart, 'data-buynow': data.customFeature.isBuyNow }),
                    item.form_data.is_group_buy != 1 && data.customFeature.isShoppingCart && isImage(data.customFeature.addShoppingCartImageSrc) < 0 && _react2.default.createElement(
                      'label',
                      { style: { color: data.storeStyle.theme },
                        className: 'shopping-icon',
                        'data-id': item.form_data.id,
                        'data-app-id': item.form_data.app_id,
                        'data-ispackage': item.form_data.is_package_goods,
                        onClick: _this2.showGoodsShoppingcart, 'data-buynow': data.customFeature.isBuyNow },
                      _react2.default.createElement('img', { className: 'image', src: data.customFeature.addShoppingCartImageSrc })
                    )
                  )
                );
              })
            )
          ),
          _react2.default.createElement(Others, null)
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component goods-list' },
        customFeature.controlCheck ? _react2.default.createElement(IntegralGoodsList, null) : !customFeature.styleMode ? _react2.default.createElement(GoodsList, null) : _react2.default.createElement(NewGoodsList, null)
      );
    }
  }]);
  return GoodsListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var param = {
      id: customFeature['id'],
      form: customFeature['form'],
      goods_type: (0, _tools.getGoodsTypeByForm)(customFeature['form']),
      tpl_id: customFeature['tplId'],
      page: 1,
      is_count: 0
    };
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));
    var newInitData = {};
    newInitData['eles[' + compindex + '].goods_data'] = [];
    newInitData['eles[' + compindex + '].is_more'] = 1;
    newInitData['eles[' + compindex + '].loadingFail'] = false;
    newInitData['eles[' + compindex + '].loading'] = true;
    newInitData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(newInitData);

    param.page = 1;
    if (customFeature.controlCheck) {
      param.is_integral = 3;
    } else {
      if (customFeature.isIntegral) {
        param.is_integral = 1;
      } else {
        param.is_integral = 5;
      }
    }
    if (customFeature.isShowGroupBuyGoods) {
      param.is_group_buy = 1;
    }
    param.is_count = 0;
    param.page_size = customFeature.loadingNum || 10;

    if (customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      };
    }

    if (param.form === 'goods' && customFeature.pickUpArr) {
      param.pick_up_type = [];
      if (customFeature.pickUpArr.express) {
        param.pick_up_type.push(1);
      }

      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }

      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }

      if (customFeature.pickUpArr.dining) {
        if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods) {
          // 子店点餐商品先不显示
        } else {
          param.pick_up_type.push(4);
        }
      }
    }

    if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      // 显示子店商品 // TODO
      param['is_app_shop_cate_goods'] = 1;
      param['is_app_shop'] = 1;
    }

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));

    if (param.form === 'tostore') {
      _this3.tostoreInit(compindex, pageInstance, param);
    } else if (param.form == 'new_appointment') {
      _this3.newAppointmentInit(compindex, pageInstance, param);
    } else {
      _this3.goodsListInit(compindex, pageInstance, param);
    }
  };

  this.tostoreInit = function (compindex, pageInstance, param) {
    if (_app.appMethod.isLogin()) {
      _app.appMethod.getTostoreCartList();
    }

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO: 未处理
      success: function success(res) {
        var newdata = {};
        var goodslist = res.data;
        // TODO: 尚未处理
        if (_app.appMethod.getHomepageRouter() == pageInstance.state.router) {
          var second = new Date().getMinutes().toString();
          if (second.length <= 1) {
            second = '0' + second;
          }
          var currentTime = new Date().getHours().toString() + second,
              showFlag = true,
              showTime = '';

          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppShop/getBusinessTime',
            method: 'post',
            data: {},
            chain: true,
            subshop: pageInstance.franchiseeId || '', // TODO
            success: function success(res) {
              var businessTime = res.data.business_time;
              if (businessTime && businessTime.length) {
                for (var i = 0; i < businessTime.length; i++) {
                  showTime += businessTime[i].start_time.substring(0, 2) + ':' + businessTime[i].start_time.substring(2, 4) + '-' + businessTime[i].end_time.substring(0, 2) + ':' + businessTime[i].end_time.substring(2, 4) + (businessTime.length == 1 ? '' : i <= businessTime.length - 1 ? ' / ' : '');
                  if (+currentTime > +businessTime[i].start_time && +currentTime < +businessTime[i].end_time) {
                    showFlag = false;
                  }
                }
              }
              if (showFlag) {
                _app.appMethod.showModal({
                  content: '店铺休息中,暂时无法接单。营业时间为：' + showTime
                });
              }
            }
          });
        }
        goodslist.map(function (item) {
          item.form_data.goods_model && delete item.form_data.goods_model;
        });
        newdata['eles[' + compindex + '].goods_data'] = goodslist;
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.getAptGoodsList = function (compindex, pageInstance, param, customFeature) {
    var noAppointTpl = {};
    noAppointTpl['eles[' + compindex + '].param'] = param;
    noAppointTpl['eles[' + compindex + '].customFeature.tpl_id'] = param.tpl_id;
    noAppointTpl['eles[' + compindex + '].customFeature.unit'] = param.unit;
    noAppointTpl['eles[' + compindex + '].customFeature.now_date'] = new Date().getTime();

    if (!param.tpl_id) {
      noAppointTpl['eles[' + compindex + '].goods_data'] = [];
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      noAppointTpl['eles[' + compindex + '].loadingFail'] = false;
      noAppointTpl['eles[' + compindex + '].loading'] = false;
      pageInstance.setData(noAppointTpl);
      return;
    }
    pageInstance.setData(noAppointTpl);

    var isClassify = false;
    if (pageInstance.newClassifyGroupidsParams && !!pageInstance.newClassifyGroupidsParams.length) {
      var params = pageInstance.newClassifyGroupidsParams;
      for (var i = 0; i < params.length; i++) {
        var newClassifyCompindex = params[i].compindex;
        if (!pageInstance.data.eles[newClassifyCompindex].hidden && pageInstance.data.eles[newClassifyCompindex].customFeature.refresh_object == customFeature.id) {
          isClassify = true;
        }
      }
    }
    if (!isClassify) {
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetGoodsList',
        data: param,
        method: 'post',
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function success(res) {
          if (res.status == 0) {
            for (var _i in res.data) {
              res.data[_i].form_data.price = res.data[_i].form_data.min_price;
              delete res.data[_i].form_data.description;
            }
            var newdata = {};
            newdata['eles[' + compindex + '].goods_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loadingFail'] = false;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        },
        fail: function fail(res) {
          var newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    }
  };

  this.newAppointmentInit = function (compindex, pageInstance, param) {
    var self = _this3;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    if (customFeature.trade_apt_id) {
      param.tpl_id = customFeature.trade_apt_id;
      param.unit = customFeature.unitType;
      self.getAptGoodsList(compindex, pageInstance, param, customFeature);
    } else {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppAppointment/GetUsedTpl',
        method: 'POST',
        hideLoading: true,
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function success(res) {
          param.tpl_id = res.data.length ? res.data[0].id : '';
          param.unit = res.data.length ? res.data[0].unit : '';
          self.getAptGoodsList(compindex, pageInstance, param);
        },

        fail: function fail(res) {
          var newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    }
  };

  this.goodsListInit = function (compindex, pageInstance, param) {
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var isClassify = false;

    if (_app.appMethod.getInvolvedFromRefreshObject(customFeature.id, "new-classify")) {
      isClassify = true;
    }

    if (!isClassify) {
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/GetGoodsList',
        data: param,
        method: 'post',
        chain: true,
        subshop: pageInstance.franchiseeId || '', // TODO
        success: function success(res) {
          var appId = _app.appMethod.getAppId();
          if (res.status == 0) {
            for (var i in res.data) {
              if (res.data[i].form_data.goods_model) {
                (function () {
                  var minPrice = res.data[i].form_data.goods_model[0].price;
                  var virtualMinPrice = void 0;
                  res.data[i].form_data.goods_model.map(function (goods) {
                    if (+minPrice >= +goods.price) {
                      minPrice = goods.price;
                      virtualMinPrice = goods.virtual_price;
                    }
                  });
                  res.data[i].form_data.virtual_price = virtualMinPrice;
                  res.data[i].form_data.price = minPrice;
                })();
              }
              res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
              var vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
              res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
              delete res.data[i].form_data.description;

              if (+param['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId && !pageInstance.franchiseeId) {
                res.data[i].form_data.isSubShopGoods = true;
              } else {
                res.data[i].form_data.isSubShopGoods = false;
              }
              var formData = res.data[i].form_data;
              if (formData.app_shop_data && formData.app_shop_data.distance != undefined) {
                var distance = formData.app_shop_data.distance;
                formData.app_shop_data.distance = util.formatDistance(distance);
              }
            }
            var newdata = {};
            newdata['eles[' + compindex + '].goods_data'] = res.data;
            newdata['eles[' + compindex + '].is_more'] = res.is_more;
            newdata['eles[' + compindex + '].curpage'] = 1;
            newdata['eles[' + compindex + '].loadingFail'] = false;
            newdata['eles[' + compindex + '].loading'] = false;
            pageInstance.setData(newdata);
          }
        },
        fail: function fail(res) {
          var newdata = {};
          newdata['eles[' + compindex + '].loadingFail'] = true;
          newdata['eles[' + compindex + '].loading'] = false;
          pageInstance.setData(newdata);
        }
      });
    }
    // 电商店铺风格
    if (param.form === 'goods') {
      _app.appMethod.getAppECStoreConfig(function (res) {
        var newdata = {};
        newdata['eles[' + compindex + '].storeStyle'] = res.color_config;
        pageInstance.setData(newdata);
      });
    }
  };

  this._goodsScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = compData.curpage + 1;
    var customFeature = compData.customFeature;
    var newdata = {};
    var param = compData.param;

    if (!compData.is_more && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
      _app.appMethod.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    //行业预约  模板为空兼容
    if (param.form == 'new_appointment' && !param.tpl_id) {
      var noAppointTpl = {};
      noAppointTpl['eles[' + compindex + '].goods_data'] = [];
      noAppointTpl['eles[' + compindex + '].is_more'] = 0;
      pageInstance.setData(noAppointTpl);
      return;
    }

    param.page = curpage;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      hideLoading: true,
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '', // TODO
      success: function success(res) {
        var newdata = {};
        var appId = _app.appMethod.getAppId();
        for (var i in res.data) {
          if (res.data[i].form_data.goods_model) {
            (function () {
              var minPrice = res.data[i].form_data.goods_model[0].price;
              var virtualMinPrice = void 0;
              res.data[i].form_data.goods_model.map(function (goods) {
                if (+minPrice >= +goods.price) {
                  minPrice = goods.price;
                  virtualMinPrice = goods.virtual_price;
                }
              });
              res.data[i].form_data.virtual_price = virtualMinPrice;
              res.data[i].form_data.price = minPrice;
            })();
          }
          res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          var vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
          delete res.data[i].form_data.description;
          res.data[i].form_data.goods_model && delete res.data[i].form_data.goods_model;

          if (+param['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId && !pageInstance.franchiseeId) {
            res.data[i].form_data.isSubShopGoods = true;
          } else {
            res.data[i].form_data.isSubShopGoods = false;
          }
          var formData = res.data[i].form_data;
          if (formData.app_shop_data && formData.app_shop_data.distance != undefined) {
            var distance = formData.app_shop_data.distance;
            formData.app_shop_data.distance = util.formatDistance(distance);
          }
        }
        if (res.current_page == 1) {
          compData.goods_data = [];
        }
        newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  };

  this._refreshGoodsList = function (targetCompIndex, requestData, pageInstance) {
    var customFeature = pageInstance.data.eles[targetCompIndex].customFeature;
    var newData = {};

    newData['eles[' + targetCompIndex + '].loading'] = true;
    newData['eles[' + targetCompIndex + '].loadingFail'] = false;
    newData['eles[' + targetCompIndex + '].is_more'] = 1;
    newData['eles[' + targetCompIndex + '].goods_data'] = [];
    newData['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newData);

    requestData.page_size = customFeature.loadingNum || 10;

    if (customFeature.form === 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      // 显示子店商品(排除子店功能页)
      requestData['is_app_shop_cate_goods'] = 1;
      requestData['is_app_shop'] = 1;
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      method: 'post',
      hideLoading: true,
      data: requestData,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newData = {};
        var appId = _app.appMethod.getAppId();
        for (var i in res.data) {
          if (res.data[i].form_data.goods_model) {
            (function () {
              var minPrice = res.data[i].form_data.goods_model[0].price;
              var virtualMinPrice = void 0;
              res.data[i].form_data.goods_model.map(function (goods) {
                if (+minPrice >= +goods.price) {
                  minPrice = goods.price;
                  virtualMinPrice = goods.virtual_price;
                }
              });
              res.data[i].form_data.virtual_price = virtualMinPrice;
              res.data[i].form_data.price = minPrice;
            })();
          }
          res.data[i].form_data.discount = (res.data[i].form_data.price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          var vip_discount = (res.data[i].form_data.vip_min_price * 10 / res.data[i].form_data.virtual_price).toFixed(2);
          res.data[i].form_data.vip_discount = vip_discount < 0.01 ? 0.01 : vip_discount;
          res.data[i].form_data.goods_model && delete res.data[i].form_data.goods_model;

          if (+requestData['is_app_shop_cate_goods'] === 1 && res.data[i].form_data.app_id !== appId) {
            res.data[i].form_data.isSubShopGoods = true;
          } else {
            res.data[i].form_data.isSubShopGoods = false;
          }
        }
        newData['eles[' + targetCompIndex + '].goods_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function fail(res) {
        var newData = {};
        newData['eles[' + targetCompIndex + '].loadingFail'] = true;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      }
    });
  };

  this.goodsScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    if (compData.is_search) {
      // 与搜索组件相关联
      var searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    } else {
      _this3._goodsScrollFunc(event);
    }
  };

  this.turnToGoodsDetail = function (event) {
    var dataset = event.currentTarget.dataset;
    var id = dataset.id;
    var contact = dataset.contact;
    var goodsType = dataset.goodsType;
    var group = dataset.group;
    var hidestock = dataset.hidestock;
    var isShowVirtualPrice = dataset.isshowvirtualprice;
    var unit = dataset.unit;

    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.appId && dataset.appId !== _app.appMethod.getAppId() && chainParam === '') {
      // 跳转子店商品
      chainParam += '&franchisee=' + dataset.appId;
    }
    if (group && group == 1) {
      _app.appMethod.turnToPage('gpgoodsDetail?goods_id=' + id + '&activity_id=' + dataset.groupid + '&contact=' + contact + chainParam);
      return;
    }
    switch (+goodsType) {
      case 0:
        _app.appMethod.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + '&isShowVirtualPrice=' + isShowVirtualPrice + chainParam);
        break;
      case 1:
        _app.appMethod.turnToPage('goodsDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        break;
      case 3:
        _app.appMethod.turnToPage('toStoreDetail?detail=' + id + chainParam);
        break;
      case 10:
        if (unit) {
          _app.appMethod.turnToPage('hotel?contact=' + contact + '&hidestock=' + hidestock + chainParam);
        } else {
          _app.appMethod.turnToPage('newAppointmentDetail?detail=' + id + '&contact=' + contact + '&hidestock=' + hidestock + chainParam);
        }
        break;
    }
  };

  this.showGoodsShoppingcart = function (e) {
    e.stopPropagation();
    if (e.currentTarget.dataset.appId && e.currentTarget.dataset.appId !== _app.appMethod.getAppId()) {
      _app.appMethod.showModal({
        content: '子店商品添加到购物车需要在商品详情页购物车购买',
        confirm: function confirm() {
          _app.appMethod.showGoodsShoppingcart(e);
        }
      });
    } else {
      _app.appMethod.showGoodsShoppingcart(e);
    }
  };

  this.showAddShoppingcart = function (e) {
    e.stopPropagation();
    if (e.currentTarget.dataset.appId && e.currentTarget.dataset.appId !== _app.appMethod.getAppId()) {
      _app.appMethod.showModal({
        content: '子店商品添加到购物车需要在商品详情页购物车购买',
        confirm: function confirm() {
          _app.appMethod.showAddShoppingcart(e);
        }
      });
    } else {
      _app.appMethod.showAddShoppingcart(e);
    }
  };
};

exports.default = GoodsListCustomComponent;

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ButtonCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(810);

function ButtonCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component button', style: styleObj, onClick: function onClick() {
        return (0, _customEvent.customEvent)({ customFeature: customFeature });
      } },
    content
  );
}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LayoutVesselCustomComponent;

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(812);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LayoutVesselCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(props.data.style);
  /**
   * 组件特性数据处理
   */
  var customFeature = (0, _tools.cssObj2DomObj)(props.data.customFeature);
  var leftStyleObj = {
    width: customFeature.cellWidth + '%'
  };
  var rightStyleObj = {
    width: 100 - customFeature.cellWidth + '%',
    borderLeftStyle: customFeature.CellBorderStyle,
    borderLeftWidth: (0, _tools.transformPx2Rem)(customFeature.CellBorderWidth, 320),
    borderLeftColor: customFeature.CellBorderColor
    /**
     * 组件内容处理
     */
  };var content = data.content;
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component layout-vessel', style: styleObj, onClick: function onClick() {
        return (0, _customEvent.customEvent)({ customFeature: customFeature });
      } },
    React.createElement(
      'div',
      { className: 'left-eles', style: leftStyleObj },
      content.leftEles.map(function (componentData, componentIndex) {
        return React.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
      })
    ),
    React.createElement(
      'div',
      { className: 'left-eles', style: rightStyleObj },
      content.rightEles.map(function (componentData, componentIndex) {
        return React.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
      })
    )
  );
}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TitleEleCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(814);

function TitleEleCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 标记样式
   */
  var markStyleObj = {
    backgroundColor: customFeature['markColor']
  };
  if (customFeature.mode === 0) {
    markStyleObj['display'] = 'none';
  } else if (customFeature.mode === 1 || customFeature.mode === 3) {
    markStyleObj['left'] = '-' + (0, _tools.transformPx2Rem)(customFeature['markMargin-right'], 320);
  } else if (customFeature.mode === 2) {
    markStyleObj['marginTop'] = '' + (0, _tools.transformPx2Rem)(customFeature['markMargin-top'], 320);
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component title-ele mode-' + customFeature.mode, style: styleObj, onClick: function onClick() {
        return (0, _customEvent.customEvent)({ customFeature: customFeature });
      } },
    React.createElement(
      'div',
      { className: 'title-content' },
      React.createElement(
        'div',
        { className: 'title-text' },
        React.createElement('div', { className: 'mark', style: markStyleObj }),
        content
      )
    )
  );
}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(816);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewsCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(NewsCustomComponent, _React$Component);

  function NewsCustomComponent(props) {
    (0, _classCallCheck3.default)(this, NewsCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (NewsCustomComponent.__proto__ || Object.getPrototypeOf(NewsCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(NewsCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      // 组件数据
      var data = this.props.data;
      // 用户信息
      var userInfo = _page.pageInstance.state.userInfo || {};
      // 组件配置对象
      var customFeature = data.customFeature;
      // 分类tab样式
      var tabStyle = {
        backgroundColor: customFeature.backgroundColor,
        color: customFeature.tabTextColor
        // 选中tab样式
      };var selectedStyle = {
        backgroundColor: customFeature.backgroundSelectColor,
        color: customFeature.tabTextSelectColor,
        fontWeight: 'bold',
        opacity: 1
      };
      var styleObj = (0, _tools.convertStyleData)(data.style);

      var $newsItem = function $newsItem(item) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          item && item.imgs && item.imgs[0] && item.style == 4 && item['article_type'] != 2 && _react2.default.createElement(
            'div',
            { className: 'news-img-groups' },
            item.imgs && item.imgs.map(function (imgUrl, imgIdx) {
              return _react2.default.createElement(
                'div',
                { className: 'news-img', key: imgIdx },
                _react2.default.createElement('img', { src: userInfo.cover_thumb || imgUrl, alt: '' }),
                (item['form_data']['url']['video'] && item['form_data']['url']['video']['cover'] || item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) && _react2.default.createElement(
                  'div',
                  { className: 'icon-wrap' },
                  _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
                )
              );
            })
          ),
          item.media_id && _react2.default.createElement(
            'div',
            { className: 'news-img-groups' },
            _react2.default.createElement(
              'div',
              { className: 'news-img ' + (item.form_data.url.article.type == 3 ? 'audio-icon' : '') },
              _react2.default.createElement('img', { src: item.form_data.url.article.cover || '', alt: '' }),
              item.form_data.url.article.type == 4 && _react2.default.createElement(
                'div',
                { className: 'icon-wrap' },
                _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'news-text' },
            _react2.default.createElement(
              'div',
              { className: 'news-title' },
              item.title
            ),
            (item.style == 0 || item.style == 4 || item.style == 5) && _react2.default.createElement(
              'div',
              { className: 'news-text-bottom' },
              item.form_data.red_package.command && _react2.default.createElement('img', { className: 'red-pocket-icon', src: data.cdnUrl + '/zhichi_frontend/static/webapp/images/pocket/little_pocket.png', alt: '' }),
              item.article_type == 3 ? _react2.default.createElement(
                'span',
                { className: 'news-adver-tag' },
                '\u63A8\u8350'
              ) : _react2.default.createElement(
                'span',
                null,
                item.comment_count,
                '\u8BC4\u8BBA'
              ),
              _react2.default.createElement(
                'span',
                null,
                item.publish_time
              )
            )
          ),
          item && item.imgs && item.imgs[0] && item.style != 4 && item['article_type'] != 2 ? _react2.default.createElement(
            'div',
            { className: 'news-img-groups' },
            item.imgs && item.imgs.map(function (imgUrl, imgIdx) {
              return _react2.default.createElement(
                'div',
                { className: 'news-img', key: imgIdx },
                _react2.default.createElement('img', { src: imgUrl, mode: 'aspectFill', alt: '' }),
                (item['form_data']['url']['video'] && item['form_data']['url']['video']['cover'] || item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) && _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
              );
            })
          ) : !item.media_id && item['article_type'] == 2 ? _react2.default.createElement(
            'div',
            { className: 'news-link-groups' },
            item.form_data.url.article && _react2.default.createElement(
              'div',
              { className: 'news-article-groups' },
              _react2.default.createElement(
                'div',
                { className: 'img-wrap' },
                _react2.default.createElement('img', { src: item.form_data.url.article.cover, mode: 'aspectFill' }),
                item.form_data.url.article && item.form_data.url.article.type == 4 && _react2.default.createElement(
                  'div',
                  { className: 'icon-wrap' },
                  _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title-wrap' },
                item.form_data.url.article.title
              )
            ),
            item.form_data.url.video && _react2.default.createElement(
              'div',
              { className: 'news-video-groups' },
              _react2.default.createElement('img', { src: item.form_data.url.video.cover, mode: 'aspectFill' }),
              (item['form_data']['url']['video'] && item['form_data']['url']['video']['cover'] || item['form_data']['video'][0] && item['form_data']['video'][0]['video_url']) && _react2.default.createElement(
                'div',
                { className: 'icon-wrap' },
                _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
              )
            )
          ) : null,
          item.style != 0 && item.style != 4 && item.style != 5 && _react2.default.createElement(
            'div',
            { className: 'news-text-bottom' },
            item.form_data && item.form_data.red_package.command && _react2.default.createElement('img', { className: 'red-pocket-icon', src: data.cdnUrl + '/zhichi_frontend/static/webapp/images/pocket/little_pocket.png' }),
            item.article_type == 3 ? _react2.default.createElement(
              'span',
              { className: 'news-adver-tag' },
              '\u63A8\u8350'
            ) : _react2.default.createElement(
              'span',
              null,
              item.comment_count,
              '\u8BC4\u8BBA'
            ),
            _react2.default.createElement(
              'span',
              null,
              item.publish_time
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component news', style: styleObj },
        customFeature.isPartClassify && _react2.default.createElement(
          'div',
          { className: 'news-tab', style: tabStyle },
          data.cateData && data.cateData.map(function (cateItem) {
            return _react2.default.createElement(
              'span',
              { key: cateItem.id,
                style: data.selectedCateId === cateItem.id ? selectedStyle : {},
                onClick: _this3.getNewsCateList,
                'data-compindex': _this3.props.index,
                'data-id': cateItem.id
              },
              cateItem.name
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'news-list' },
          data.newslist && data.newslist.map(function (item, index) {
            return (
              // 文章多种版式类型处理
              _react2.default.createElement(
                'div',
                { className: 'news-item mode-' + item.style, key: index,
                  onClick: _this3.turnToNewsDetail,
                  'data-router': 'newsDetail',
                  'data-id': item.id,
                  'data-cateid': item.category_id,
                  'data-isliked': item.is_liked,
                  'data-recommend': item.is_recommend,
                  'data-reward': item.is_reward,
                  'data-article-type': item.article_type,
                  'data-event-params': JSON.stringify(item.event_params || {})
                },
                $newsItem(item)
              )
            );
          }),
          data.pageObj && data.pageObj.isLoading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          data.pageObj && data.pageObj.noMore && data.newslist.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无资讯文章~' } }),
          data.pageObj && data.pageObj.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'getNewsList', compindex: this.props.index } }),
          data.pageObj && data.pageObj.noMore && data.newslist.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' })
        )
      );
    }
  }]);
  return NewsCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var _this = _this4;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var selectedCateId = +customFeature.newsClassifyId || '';
    var initData = {};

    initData['eles[' + compindex + '].pageObj'] = {
      isLoading: false,
      noMore: false,
      page: 1
    };
    initData['eles[' + compindex + '].cdnUrl'] = _app.appMethod.globalData.cdnUrl;
    pageInstance.setData(initData);

    if (customFeature.isPartClassify) {
      if (!!!selectedCateId && !!!customFeature.isManualClassify) {
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppNews/GetCategoryByPage',
          data: { page: -1 },
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function success(res) {
            _this.createNewsCateData(pageInstance, compindex, res.data);
          },
          fail: function fail() {
            _this.createNewsCateData(pageInstance, compindex, []);
          }
        });
      } else {
        _this.createNewsCateData(pageInstance, compindex, pageInstance.data.eles[compindex].content);
      }
    } else {
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].selectedCateId', selectedCateId));
      _this.getNewsList({ compindex: compindex, category_id: selectedCateId, pageInstance: pageInstance, page: 1 });
    }
  };

  this.createNewsCateData = function (pageIns, compindex, cateArr, selectedId) {
    if (compindex < 0) {
      return;
    }
    var compContent = cateArr || [],
        pageInstance = pageIns || _app.appMethod.getAppCurrentPage(),
        selectId = selectedId,
        cateData = [],
        newData = {};
    cateData = compContent.map(function (cc) {
      return {
        compindex: compindex,
        id: cc.id || cc.classifyId,
        name: cc.name || cc.classifyName
      };
    });
    newData['eles[' + compindex + '].cateData'] = cateData;
    selectId || (selectId = cateData.length ? cateData[0].id : '');
    newData['eles[' + compindex + '].selectedCateId'] = selectId;
    pageInstance.setData(newData);
    _this4.getNewsList({ compindex: compindex, category_id: selectId, pageInstance: pageInstance, page: 1 });
  };

  this.getNewsList = function (component_params, callback) {
    if (typeof component_params === 'number') {
      component_params = {
        compindex: component_params
      };
    } else if (typeof component_params !== 'number' && !component_params) {
      component_params = {};
    }
    var pageInstance = component_params.pageInstance || _app.appMethod.getAppCurrentPage();
    // 未处理 pageInstance.newsComps
    var compindex = component_params.compindex;
    var newsData = pageInstance.data.eles[compindex];
    var cateId = component_params.category_id;
    var searchValue = component_params.search_value || '';
    var pageObj = newsData.pageObj;
    var page = component_params.page || pageObj.page || 1;
    var pageSize = component_params.page_size || newsData.customFeature.loadingNum || 10;
    var newsList = newsData.newslist || [];

    if (cateId === undefined) {
      cateId = newsData.selectedCateId;
    }

    var newdata = {};
    if (page == 1) {
      newdata['eles[' + compindex + '].newslist'] = [];
      newdata['eles[' + compindex + '].pageObj.noMore'] = false;
    }
    if (pageObj.isLoading || pageObj.noMore) {
      return;
    }
    newdata['eles[' + compindex + '].pageObj.isLoading'] = true;
    newdata['eles[' + compindex + '].pageObj.loadingFail'] = false;
    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppNews/GetArticleByPage',
      data: {
        category_id: cateId,
        orderby: 'add_time',
        page: page,
        search_value: searchValue,
        page_size: pageSize
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function success(res) {
        if (res.status == 0) {
          var resData = res.data,
              newData = {};

          resData = resData.map(function (n) {
            if (n.wechat_id) {
              return n;
            }
            if (n.form_data.url.article && n.form_data.url.article.type == 3) {
              //添加音乐图标
              n.form_data.url.article.cover = _app.appMethod.globalData.cdnUrl + '/zhichi_frontend/static/webapp/images/audio_default.png';
            }
            if (n.form_data.event.action) {
              n.event_params = n.form_data.event;
            } else {
              n.event_params = '';
            }
            if (n.article_type == 2 && n.form_data.url.article) {
              delete n.form_data.url.article.body;
            }
            if (n.content) {
              delete n.content;
            }
            if (n.form_data.recommend) {
              delete n.form_data.recommend;
            }
            if (n.media_id) {
              // 更换导入公众号文章展示方式
              n.style = 4;
            }
            return n;
          });

          if (pageObj.page == 1) {
            newsList = resData;
          } else {
            newsList = newsList.concat(resData);
          }

          newData['eles[' + compindex + '].newslist'] = newsList;
          pageInstance.setData(newData);

          if (res.is_more == 0) {
            pageObj.noMore = true;
          }
          pageObj.isLoading = false;
          pageObj.loadingFail = false;
          pageObj.page++;
        }
      },
      fail: function fail() {
        pageObj.loadingFail = true;
      },
      complete: function complete(res) {
        pageObj.isLoading = false;
        var newPageObj = {};
        newPageObj['eles[' + compindex + '].pageObj'] = pageObj;
        pageInstance.setData(newPageObj);
        typeof callback == 'function' && callback(res);
      }
    });
  };

  this.getNewsCateList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var cateId = dataset.id;
    var pageObj = {
      isLoading: false,
      noMore: false,
      page: 1
    };
    var newData = {};

    newData['eles[' + compindex + '].pageObj'] = pageObj;
    newData['eles[' + compindex + '].selectedCateId'] = cateId;
    newData['eles[' + compindex + '].newslist'] = [];
    pageInstance.setData(newData);

    _this4.getNewsList({ compindex: compindex, category_id: cateId, pageInstance: pageInstance });
  };

  this.turnToNewsDetail = function (event) {
    if (event.currentTarget.dataset.articleType == 3) {
      var form = JSON.parse(event.currentTarget.dataset.eventParams);
      (0, _customEvent.customEvent)({
        customFeature: form
      });
      return;
    }
    var id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('/informationManagement/pages/newsDetail/newsDetail?detail=' + id + chainParam);
  };

  this._refreshNewsList = function (targetCompIndex, requestData, pageInstance) {
    var _pageInstance$setData2;

    pageInstance.setData((_pageInstance$setData2 = {}, (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + targetCompIndex + '].pageObj', {
      isLoading: false,
      noMore: false,
      page: 1
    }), (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + targetCompIndex + '].selectedCateId', requestData.idx_arr.idx_value), _pageInstance$setData2));
    customComponent['news'].getNewsList({ page: 1, compid: targetCompIndex, category_id: requestData.idx_arr.idx_value });
  };
};

exports.default = NewsCustomComponent;

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = CarouselCustomComponent;

__webpack_require__(31);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(818);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CarouselCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var itemStyleObj = {
    borderRadius: (0, _tools.transformPx2Rem)(customFeature.picBorderRadius, 320)
  };
  var imgHeight = (0, _tools.transformPx2Rem)(data.style.height, 320);
  /**
   * 组件内容处理
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 关闭轮播图视频播放
   */
  var carouselVideoClose = function carouselVideoClose(event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].videoUrl', ''));
  };
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component carousel', style: styleObj },
    React.createElement(
      _carousel2.default,
      {
        autoplay: customFeature.autoplay,
        autoplayInterval: customFeature.interval * 1000,
        vertical: customFeature.vertical,
        infinite: true,
        dotStyle: { background: customFeature.indicatorColor },
        dotActiveStyle: { background: customFeature.indicatorActiveColor }
      },
      content.map(function (item, itemIndex) {
        return React.createElement(
          'div',
          {
            className: 'carousel-item',
            key: itemIndex,
            href: '',
            style: itemStyleObj,
            onClick: function onClick() {
              return (0, _customEvent.customEvent)({
                customFeature: (0, _extends3.default)({}, item.customFeature, {
                  compindex: props.index
                })
              });
            }
          },
          React.createElement('img', {
            src: item.pic,
            alt: item.name,
            style: { height: imgHeight }
          }),
          item.customFeature.action == 'video-play' && React.createElement('div', { className: 'ico-moon icon-play video-play' })
        );
      })
    ),
    data.content.length == 0 && React.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '你还未添加轮播项~' } }),
    !!data.videoUrl && React.createElement(
      'div',
      { className: 'carousel-video-play' },
      React.createElement(
        'div',
        { className: 'inner', style: {
            marginTop: (0, _tools.transformPx2Rem)(data.carouselVideoTop, 320)
          } },
        React.createElement('div', { className: 'icon-moon icon-closes close', onClick: carouselVideoClose, 'data-compindex': props.index }),
        React.createElement('video', { src: data.videoUrl, controls: true, preload: 'meta' })
      )
    )
  );
}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BreaklineCustomComponent;

var _tools = __webpack_require__(6);

__webpack_require__(820);

function BreaklineCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 返回组件
   */
  return React.createElement('div', { className: 'custom-component breakline', style: styleObj });
}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StaticVesselCustomComponent;

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(822);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StaticVesselCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(props.data.style);
  /**
   * 组件内容处理
   */
  var content = data.content;
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component static-vessel', style: styleObj, onClick: function onClick() {
        return (0, _customEvent.customEvent)({ customFeature: customFeature });
      } },
    content.map(function (componentData, componentIndex) {
      return React.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
    })
  );
}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

__webpack_require__(824);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AudioCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(AudioCustomComponent, _React$Component);

  function AudioCustomComponent(props) {
    (0, _classCallCheck3.default)(this, AudioCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AudioCustomComponent.__proto__ || Object.getPrototypeOf(AudioCustomComponent)).call(this, props));

    _this.state = {
      isPlay: false,
      duration: 0,
      currentTime: 0
    };

    _this.changeIsPlay = function () {
      var $audio = _this.audioRef.current;
      var isPlay = _this.state.isPlay; // 当前播放状态： true: play / false: pause
      _this.setState({
        isPlay: !isPlay
      });
      if (isPlay) {
        // 状态更改：play => pause
        $audio.pause();
      } else {
        // 状态更改：pause => play
        $audio.play();
      }
    };

    _this.setAudioDuration = function () {
      _this.setState({
        duration: _this.audioRef.current.duration
      });
    };

    _this.setCurrentTime = function () {
      var $audio = _this.audioRef.current;
      _this.setState({
        currentTime: $audio.currentTime
      });
      if ($audio.currentTime == $audio.duration) {
        _this.setState({
          isPlay: false
        });
      }
    };

    _this.audioRef = _react2.default.createRef();
    return _this;
  }
  /**
   * 更改播放状态
   */

  /**
   * 设置音频时长
   */

  /**
   * 设置当前时间
   */


  (0, _createClass3.default)(AudioCustomComponent, [{
    key: 'millisecondToDate',

    /**
     * 转换时间
     */
    value: function millisecondToDate(time) {
      var second = Math.floor(time % 60);
      var minite = Math.floor(time / 60);
      return (minite >= 10 ? minite : '0' + minite) + ':' + (second >= 10 ? second : '0' + second);
    }
  }, {
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var detailData = this.props.detailData; // 详情页数据
      var dynamicData = this.props.dynamicData; // 动态数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 组件内容处理
       */
      var content = data.content;
      var segment = data.customFeature.segment; // 已绑定字段
      // 是否有绑定字段
      if (segment) {
        if (detailData && detailData[segment]) {
          content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
        } else if (dynamicData && dynamicData[segment]) {
          content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
        }
      }
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component audio', style: styleObj, onClick: this.changeIsPlay },
        _react2.default.createElement(
          'div',
          { className: 'poster' },
          _react2.default.createElement('img', { src: customFeature['background-thumb'] }),
          _react2.default.createElement(
            'div',
            { className: 'control' },
            _react2.default.createElement('span', { className: this.state.isPlay ? 'pause' : 'play' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content' },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            customFeature['file-name']
          ),
          _react2.default.createElement(
            'div',
            { className: 'author' },
            customFeature.audioAuthor
          ),
          _react2.default.createElement(
            'div',
            { className: 'time' },
            this.state.currentTime === 0 ? this.millisecondToDate(this.state.duration) : this.millisecondToDate(this.state.currentTime)
          )
        ),
        _react2.default.createElement('audio', { ref: this.audioRef, src: customFeature['file-src'], preload: 'metadata', onCanPlay: this.setAudioDuration, onError: this.setAudioDuration, onTimeUpdate: this.setCurrentTime })
      );
    }
  }]);
  return AudioCustomComponent;
}(_react2.default.Component);

exports.default = AudioCustomComponent;

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AlbumCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(826);

function AlbumCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  if (!customFeature.isSideslip) {
    // 非横滑
    styleObj['paddingBottom'] = (0, _tools.transformPx2Rem)(data.customFeature['padding-top'], 320);
  } else {
    // 横滑（需要根据mode计算组件高度）
    styleObj['paddingRight'] = (0, _tools.transformPx2Rem)(data.customFeature['padding-left'], 320);
    var height = null;
    if (customFeature.mode === 0) {
      height = parseInt(data.customFeature.imgHeight) + parseInt(data.customFeature['padding-top']) * 2;
    } else if (customFeature.mode === 1) {
      height = parseInt(data.customFeature.imgHeight) + (parseInt(customFeature.textHeight) || 14) * 1.6 + parseInt(data.customFeature['padding-top']) * 2;
    }
    styleObj['height'] = (0, _tools.transformPx2Rem)(height, 320);
  }
  /**
   * 单项样式
   */
  var itemWidth = null;
  if (!customFeature.isSideslip) {
    // 非横滑（需要计算单行单列宽度）
    var num = (320 - parseInt(data.customFeature['padding-left']) * (parseInt(data.customFeature['col']) + 1)) / parseInt(data.customFeature['col']);
    itemWidth = (0, _tools.transformPx2Rem)(num, 320);
  } else {
    // 横滑
    itemWidth = (0, _tools.transformPx2Rem)(data.customFeature.width, 320);
  }
  var itemStyleObj = {
    width: itemWidth,
    marginTop: (0, _tools.transformPx2Rem)(data.customFeature['padding-top'], 320),
    marginLeft: (0, _tools.transformPx2Rem)(data.customFeature['padding-left'], 320)
  };
  /**
   * 图片样式（与图片标题共同组成父容器的高度）
   */
  var imgStyleObj = {
    height: (0, _tools.transformPx2Rem)(data.customFeature.imgHeight, 320),
    borderRadius: (0, _tools.transformPx2Rem)(data.customFeature.picBorderRadius, 320)
  };
  /**
   * 组件内容处理（TODO: 应该没有动态数据，后续删减）
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {
    // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component album mode-' + customFeature.mode + ' ' + (customFeature.isSideslip && 'sideslip'), style: styleObj },
    content.map(function (item, itemIndex) {
      return React.createElement(
        'div',
        { className: 'album-item', key: itemIndex, style: itemStyleObj, onClick: function onClick() {
            return (0, _customEvent.customEvent)({ customFeature: item.customFeature });
          } },
        React.createElement('img', { style: imgStyleObj, src: item.pic, alt: item.title }),
        React.createElement(
          'div',
          { className: 'title' },
          item.title
        )
      );
    })
  );
}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _noticeBar = __webpack_require__(828);

var _noticeBar2 = _interopRequireDefault(_noticeBar);

exports.default = AnnounceCustomComponent;

__webpack_require__(31);

__webpack_require__(830);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(832);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnounceCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var customFeature = data.customFeature;
  styleObj['height'] = (0, _tools.transformPx2Rem)(customFeature.height, 320);
  styleObj['width'] = (0, _tools.transformPx2Rem)(customFeature.width, 320);
  // 图标类型
  var iconType = customFeature.selectImg.indexOf('announce') !== -1 ? 'icon-' + customFeature.selectImg : '';
  var iconStyle = {
    color: customFeature.lineBackgroundColor,
    backgroundImage: iconType === '' ? 'url(' + customFeature.selectImg + ')' : ''
    /**
     * 组件内容处理
     */
  };var content = data.content;

  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component announce', style: styleObj },
    customFeature.mode === 0 && React.createElement(
      _noticeBar2.default,
      {
        marqueeProps: { loop: true, fps: 10 / customFeature.interval * 20, leading: 500, trailing: 500 },
        icon: React.createElement('span', { className: iconType + ' announce-icon', style: iconStyle })
      },
      content.map(function (contentData, contentIndex) {
        return React.createElement(
          'span',
          { className: 'announce-text', key: contentIndex, onClick: function onClick() {
              return (0, _customEvent.customEvent)({ customFeature: contentData.customFeature });
            } },
          contentData.secContent
        );
      })
    ),
    customFeature.mode === 1 && React.createElement(
      'div',
      { className: 'announce-vertical' },
      React.createElement('span', { className: iconType + ' announce-icon', style: iconStyle }),
      React.createElement(
        _carousel2.default,
        {
          vertical: true,
          dots: false,
          dragging: false,
          swiping: false,
          autoplay: true,
          infinite: true,
          autoplayInterval: '' + Number(customFeature.interval) * 1000
        },
        content.map(function (contentData, contentIndex) {
          return React.createElement(
            'span',
            { className: 'announce-text', key: contentIndex, onClick: function onClick() {
                return (0, _customEvent.customEvent)({ customFeature: contentData.customFeature });
              } },
            contentData.secContent
          );
        })
      )
    )
  );
}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _Marquee = __webpack_require__(829);

var _Marquee2 = _interopRequireDefault(_Marquee);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }return t;
};

var NoticeBar = function (_React$Component) {
    (0, _inherits3['default'])(NoticeBar, _React$Component);

    function NoticeBar(props) {
        (0, _classCallCheck3['default'])(this, NoticeBar);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (NoticeBar.__proto__ || Object.getPrototypeOf(NoticeBar)).call(this, props));

        _this.onClick = function () {
            var _this$props = _this.props,
                mode = _this$props.mode,
                onClick = _this$props.onClick;

            if (onClick) {
                onClick();
            }
            if (mode === 'closable') {
                _this.setState({
                    show: false
                });
            }
        };
        _this.state = {
            show: true
        };
        return _this;
    }

    (0, _createClass3['default'])(NoticeBar, [{
        key: 'render',
        value: function render() {
            var _a = this.props,
                mode = _a.mode,
                icon = _a.icon,
                onClick = _a.onClick,
                children = _a.children,
                className = _a.className,
                prefixCls = _a.prefixCls,
                action = _a.action,
                marqueeProps = _a.marqueeProps,
                restProps = __rest(_a, ["mode", "icon", "onClick", "children", "className", "prefixCls", "action", "marqueeProps"]);
            var extraProps = {};
            var operationDom = null;
            if (mode === 'closable') {
                operationDom = React.createElement(
                    'div',
                    { className: prefixCls + '-operation', onClick: this.onClick, role: 'button', 'aria-label': 'close' },
                    action ? action : React.createElement(_icon2['default'], { type: 'cross', size: 'md' })
                );
            } else {
                if (mode === 'link') {
                    operationDom = React.createElement(
                        'div',
                        { className: prefixCls + '-operation', role: 'button', 'aria-label': 'go to detail' },
                        action ? action : React.createElement(_icon2['default'], { type: 'right', size: 'md' })
                    );
                }
                extraProps.onClick = onClick;
            }
            var wrapCls = (0, _classnames2['default'])(prefixCls, className);
            return this.state.show ? React.createElement(
                'div',
                (0, _extends3['default'])({ className: wrapCls }, restProps, extraProps, { role: 'alert' }),
                icon &&
                // tslint:disable-next-line:jsx-no-multiline-js
                React.createElement(
                    'div',
                    { className: prefixCls + '-icon', 'aria-hidden': 'true' },
                    icon
                ),
                React.createElement(
                    'div',
                    { className: prefixCls + '-content' },
                    React.createElement(_Marquee2['default'], (0, _extends3['default'])({ prefixCls: prefixCls, text: children }, marqueeProps))
                ),
                operationDom
            ) : null;
        }
    }]);
    return NoticeBar;
}(React.Component);

exports['default'] = NoticeBar;

NoticeBar.defaultProps = {
    prefixCls: 'am-notice-bar',
    mode: '',
    icon: React.createElement(_icon2['default'], { type: 'voice', size: 'xxs' }),
    onClick: function onClick() {}
};
module.exports = exports['default'];

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _reactDom = __webpack_require__(19);

var ReactDOM = _interopRequireWildcard(_reactDom);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * https://github.com/jasonslyvia/react-marquee
 * remove PC
 * support React Element for text prop
*/
var Marquee = function (_React$Component) {
    (0, _inherits3['default'])(Marquee, _React$Component);

    function Marquee() {
        (0, _classCallCheck3['default'])(this, Marquee);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (Marquee.__proto__ || Object.getPrototypeOf(Marquee)).apply(this, arguments));

        _this.state = {
            animatedWidth: 0,
            overflowWidth: 0
        };
        return _this;
    }

    (0, _createClass3['default'])(Marquee, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._measureText();
            this._startAnimation();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this._measureText();
            if (!this._marqueeTimer) {
                this._startAnimation();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._marqueeTimer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                prefixCls = _props.prefixCls,
                className = _props.className,
                text = _props.text;

            var style = (0, _extends3['default'])({ position: 'relative', right: this.state.animatedWidth, whiteSpace: 'nowrap', display: 'inline-block' }, this.props.style);
            return React.createElement(
                'div',
                { className: prefixCls + '-marquee-wrap ' + className, style: { overflow: 'hidden' }, role: 'marquee' },
                React.createElement(
                    'div',
                    { ref: function ref(el) {
                            return _this2.textRef = el;
                        }, className: prefixCls + '-marquee', style: style },
                    text
                )
            );
        }
    }, {
        key: '_startAnimation',
        value: function _startAnimation() {
            var _this3 = this;

            if (this._marqueeTimer) {
                window.clearTimeout(this._marqueeTimer);
            }
            var fps = this.props.fps;
            var TIMEOUT = 1 / fps * 1000;
            var isLeading = this.state.animatedWidth === 0;
            var timeout = isLeading ? this.props.leading : TIMEOUT;
            var animate = function animate() {
                var overflowWidth = _this3.state.overflowWidth;

                var animatedWidth = _this3.state.animatedWidth + 1;
                var isRoundOver = animatedWidth > overflowWidth;
                if (isRoundOver) {
                    if (_this3.props.loop) {
                        animatedWidth = 0;
                    } else {
                        return;
                    }
                }
                if (isRoundOver && _this3.props.trailing) {
                    _this3._marqueeTimer = window.setTimeout(function () {
                        _this3.setState({
                            animatedWidth: animatedWidth
                        });
                        _this3._marqueeTimer = window.setTimeout(animate, TIMEOUT);
                    }, _this3.props.trailing);
                } else {
                    _this3.setState({
                        animatedWidth: animatedWidth
                    });
                    _this3._marqueeTimer = window.setTimeout(animate, TIMEOUT);
                }
            };
            if (this.state.overflowWidth !== 0) {
                this._marqueeTimer = window.setTimeout(animate, timeout);
            }
        }
    }, {
        key: '_measureText',
        value: function _measureText() {
            var container = ReactDOM.findDOMNode(this);
            var node = this.textRef;
            if (container && node) {
                var containerWidth = container.offsetWidth;
                var textWidth = node.offsetWidth;
                var overflowWidth = textWidth - containerWidth;
                if (overflowWidth !== this.state.overflowWidth) {
                    this.setState({
                        overflowWidth: overflowWidth
                    });
                }
            }
        }
    }]);
    return Marquee;
}(React.Component);

exports['default'] = Marquee;

Marquee.defaultProps = {
    text: '',
    loop: false,
    leading: 500,
    trailing: 800,
    fps: 40,
    className: ''
};
module.exports = exports['default'];

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(27);

__webpack_require__(831);

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(834);

function ListCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   * 单项样式
   */
  var itemStyleObj = {
    marginBottom: (0, _tools.transformPx2Rem)(data.customFeature.margin, 320),
    backgroundColor: data.customFeature.lineBackgroundColor,
    backgroundImage: data.customFeature.lineBackgroundImage,
    height: (0, _tools.transformPx2Rem)(data.customFeature.lineHeight, 320)
  };
  /**
   * 图片样式
   */
  var imgStyleObj = {
    width: (0, _tools.transformPx2Rem)(data.customFeature.imgWidth, 320),
    height: (0, _tools.transformPx2Rem)(data.customFeature.imgHeight, 320)
  };
  /**
   * 标题区域样式
   */
  var titleContainerStyleObj = {};
  if (data.customFeature.mode === 0) {
    titleContainerStyleObj['width'] = 'calc(100% - ' + imgStyleObj.width + ')';
  }
  /**
   * 副标题样式
   */
  var secTitleStyleObj = {
    color: data.customFeature.secColor,
    fontSize: (0, _tools.transformPx2Rem)(data.customFeature.secFontSize, 320),
    fontStyle: data.customFeature.secFontStyle,
    fontWeight: data.customFeature.secFontWeight,
    textAlign: data.customFeature.secTextAlign,
    textDecoration: data.customFeature.secTextDecoration
  };
  /**
   * 组件内容处理（TODO: 应该没有动态数据，后续删减）
   */
  var content = data.content;
  var segment = data.customFeature.segment; // 已绑定字段
  if (dynamicData && segment) {
    // 当前组件有动态数据并已绑定某字段
    content = dynamicData[segment]; // TODO: 如果content为富文本，需要处理
  }
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component list mode-' + customFeature.mode, style: styleObj },
    content.map(function (item, index) {
      return React.createElement(
        'div',
        { className: 'list-item', key: index, style: itemStyleObj, onClick: function onClick() {
            return (0, _customEvent.customEvent)({ customFeature: item.customFeature });
          } },
        React.createElement('img', { style: imgStyleObj, src: item.pic, alt: item.title }),
        React.createElement(
          'div',
          { className: 'title-container', style: titleContainerStyleObj },
          React.createElement(
            'div',
            { className: 'title' },
            item.title
          ),
          React.createElement(
            'div',
            { className: 'sec-title', style: secTitleStyleObj },
            item.secTitle
          )
        )
      );
    })
  );
}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SuspensionCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(836);

function SuspensionCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var wrapStyle = {
    backgroundImage: styleObj.backgroundImage,
    backgroundColor: styleObj.backgroundColor,
    bottom: styleObj.bottom,
    right: styleObj.right,
    opacity: styleObj.opacity
  };
  var textStyle = {
    fontSize: styleObj.fontSize,
    fontStyle: styleObj.fontStyle,
    fontWeight: styleObj.fontWeight,
    color: styleObj.color,
    textDecoration: styleObj.textDecoration
    /**
     * 组件特性数据处理
     */
  };var customFeature = data.customFeature;
  var btnStyle = {
    margin: (0, _tools.transformPx2Rem)(customFeature['margin'] / 2, 320)
  };
  var imgStyle = {
    borderRadius: data.style['border-radius'] ? data.style['border-radius'].replace('px', '') + '%' : data.style['border-radius'],
    width: (0, _tools.transformPx2Rem)(customFeature['img-size'], 320),
    height: (0, _tools.transformPx2Rem)(customFeature['img-size'], 320)
    /**
     * 组件内容处理
     */
  };var content = data.content;
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component suspension mode-' + customFeature.mode, style: wrapStyle },
    content.map(function (item, index) {
      return React.createElement(
        'div',
        { className: 'suspension-btn', key: index, style: btnStyle, onClick: function onClick() {
            return (0, _customEvent.customEvent)({ customFeature: item.customFeature });
          } },
        customFeature.openIcon && React.createElement('img', { className: 'btn-icon', style: imgStyle, src: item.pic, alt: '' }),
        customFeature.openText && React.createElement(
          'span',
          { style: textStyle },
          item.title
        )
      );
    })
  );
}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

__webpack_require__(838);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(VideoCustomComponent, _React$Component);

  function VideoCustomComponent(props) {
    (0, _classCallCheck3.default)(this, VideoCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (VideoCustomComponent.__proto__ || Object.getPrototypeOf(VideoCustomComponent)).call(this, props));

    _this.state = {
      hidden: false, // 是否显示
      videoUrl: null, // 视频地址
      videoPic: null, // 视频图片
      playing: false // 播放状态
    };

    _this.getVideoLibrary = function () {
      var customFeature = _this.props.data.customFeature;
      var param = {
        app_id: (0, _global.getAppId)(),
        id: customFeature['video-id']
      };
      (0, _http.ajax)({
        url: '/index.php?r=AppVideo/GetVideoLibUrl',
        data: param,
        success: function success(res) {
          if (res.status !== 0) {
            return;
          }
          if (res.data.is_deleted == 1) {
            _this.setState({
              hidden: true
            });
          } else {
            _this.setState({
              videoUrl: res.data,
              videoPic: customFeature['video-pic']
            });
          }
        }
      });
    };

    _this.getVideoProject = function () {
      var customFeature = _this.props.data.customFeature;
      var param = {
        app_id: (0, _global.getAppId)(),
        id: customFeature['videoProjectId']
      };
      (0, _http.ajax)({
        url: '/index.php?r=AppVideo/GetProjectInfo',
        data: param,
        success: function success(res) {
          if (res.status !== 0) {
            return;
          }
          if (res.data.is_deleted == 1) {
            _this.setState({
              hidden: true
            });
          } else {
            _this.setState({
              videoUrl: res.data.video_url,
              videoPic: customFeature['preview_img']
            });
          }
        }
      });
    };

    _this.getTencentVideo = function () {
      var customFeature = _this.props.data.customFeature;
      var param = {
        app_id: (0, _global.getAppId)(),
        argv: customFeature.vid
      };
      (0, _http.ajax)({
        url: '/index.php?r=AppNews/GetVideoUrl',
        data: param,
        success: function success(res) {
          if (res.status !== 0) {
            return;
          }
          _this.setState({
            videoUrl: res.data
          });
        }
      });
    };

    _this.videoPlay = function () {
      _this.videoRef.current.play();
      _this.setState({
        playing: true
      });
    };

    _this.videoRef = _react2.default.createRef();
    return _this;
  }

  (0, _createClass3.default)(VideoCustomComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var customFeature = this.props.data.customFeature;
      switch (customFeature.usage) {
        // 小程序：源文件
        case 'xcx':
          this.setState({
            videoUrl: customFeature.videoSourceUrl
          });
          break;
        // 小程序：视频库
        case 'videoLibrary':
          this.getVideoLibrary();
          break;
        // 小程序：视频项目
        case 'videoProject':
          this.getVideoProject();
          break;
        // 小程序：腾讯视频
        case 'tencentVideo':
          this.getTencentVideo();
          break;
        // 网页应用、默认
        case 'webapp':
        default:
          this.setState({
            videoUrl: this.props.data.content
          });
          break;
      }
    }
    /**
     * 获取视频库地址
     */

    /**
     * 获取视频项目地址
     */

    /**
     * 获取腾讯视频地址
     */

    /**
     * 视频播放
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var detailData = this.props.detailData; // 详情页数据
      var dynamicData = this.props.dynamicData; // 动态数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 组件内容处理（TODO：动态数据未处理）
       */
      var content = data.content;
      var segment = data.customFeature.segment; // 已绑定字段
      // 是否有绑定字段
      if (segment) {
        if (detailData && detailData[segment]) {
          content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
        } else if (dynamicData && dynamicData[segment]) {
          content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
        }
      }
      /**
       * 根据customFeature.usage字段生成对应内容
       */
      var $content = function $content(usage) {
        var $video = _react2.default.createElement('video', { ref: _this2.videoRef, src: _this2.state.videoUrl, controls: true, preload: 'meta' });
        var $cover = !_this2.state.playing && _react2.default.createElement(
          'div',
          { className: 'cover-wrap', onClick: _this2.videoPlay },
          _react2.default.createElement('img', { className: 'cover', src: _this2.state.videoPic }),
          _react2.default.createElement('span', { className: 'icon-play' })
        );
        switch (usage) {
          // 小程序：源文件
          case 'xcx':
          // 小程序：腾讯视频
          case 'tencentVideo':
            return $video;
          // 小程序：视频库
          case 'videoLibrary':
          // 小程序：视频项目
          case 'videoProject':
            return _react2.default.createElement(
              _react2.default.Fragment,
              null,
              $video,
              $cover
            );
          // 网页应用、默认
          case 'webapp':
          default:
            return _this2.state.videoUrl; // 视频通用路径
        }
      };
      /**
       * 返回组件
       */
      return !this.state.hidden && _react2.default.createElement(
        'div',
        { className: 'custom-component video', style: styleObj },
        $content(customFeature.usage)
      );
    }
  }]);
  return VideoCustomComponent;
}(_react2.default.Component);

exports.default = VideoCustomComponent;

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

__webpack_require__(840);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewSuspensionCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(NewSuspensionCustomComponent, _React$Component);

  function NewSuspensionCustomComponent(props) {
    (0, _classCallCheck3.default)(this, NewSuspensionCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewSuspensionCustomComponent.__proto__ || Object.getPrototypeOf(NewSuspensionCustomComponent)).call(this, props));

    _this.unfoldSus = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var tapType = e.currentTarget.dataset.taptype;
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].customFeature.buttonHidden', tapType === 'heightSus' ? true : tapType === 'foldSus' ? false : false));
    };

    return _this;
  }

  (0, _createClass3.default)(NewSuspensionCustomComponent, [{
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 组件特性数据处理
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _extends3.default)({}, (0, _tools.convertStyleData)(data.style), {
        bottom: (0, _tools.transformPx2Rem)(_app.appMethod.isTabBarPage() ? parseInt(data.style.bottom) + 48 : data.style.bottom, 320)
      });
      var wrapStyleObj = {
        borderRadius: (0, _tools.transformPx2Rem)(customFeature["border-radius"], 320)
      };
      if (!customFeature.backgroundType) {
        wrapStyleObj['backgroundColor'] = customFeature.lineBackgroundColor;
      } else {
        wrapStyleObj['background'] = customFeature.lineBackgroundImage;
      }
      if (customFeature.pickUpType == 2) {
        // wrapStyleObj['width'] = 0; // 暂时没有动画
      } else {
          // wrapStyleObj['height'] = 0; // 暂时没有动画
        }
      if (customFeature.suspensionShowList.length > 2 && customFeature.pickUpType == 1) {
        // wrapStyleObj['height'] = transformPx2Rem(customFeature.height, 320); // 小程序好像有问题
      } else {
          // wrapStyleObj['width'] = transformPx2Rem(customFeature.width, 320);  // 小程序好像有问题
        }
      var itemStyleObj = {
        marginTop: customFeature['margin-bottom'],
        marginBottom: customFeature['margin-bottom']
      };
      if (customFeature.suspensionShowList.length == data.content.length) {
        itemStyleObj['marginLeft'] = customFeature['margin-right'];
        itemStyleObj['marginRight'] = customFeature['margin-right'];
      }
      itemStyleObj = (0, _tools.convertStyleData)(itemStyleObj);
      var itemImgStyleObj = {
        width: (0, _tools.transformPx2Rem)(customFeature['icon-size'], 320),
        height: (0, _tools.transformPx2Rem)(customFeature['icon-size'], 320),
        borderRadius: (0, _tools.transformPx2Rem)(customFeature['icon-radius'], 320),
        opacity: customFeature['icon-opacity']
      };
      var btnStyleObj = {
        background: customFeature.pickUpIcon || '',
        backgroundSize: 'contain'
      };
      var navStyleObj = {
        width: (0, _tools.transformPx2Rem)(customFeature.navigationWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.navigationHeight, 320),
        right: (0, _tools.transformPx2Rem)(customFeature.navigationRight, 320),
        bottom: (0, _tools.transformPx2Rem)(_app.appMethod.isTabBarPage() ? parseInt(customFeature.navigationBottom) + 48 : customFeature.navigationBottom, 320),
        opacity: customFeature.opacity
      };
      var unfoldBtnStyleObj = {
        background: data.customFeature.spreadIcon || '',
        backgroundSize: 'contain',
        width: '100%',
        height: '100%',
        borderRadius: (0, _tools.transformPx2Rem)(customFeature.navigationRadius, 320)
        /**
         * 组件内容处理
         */
      };var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component new-suspension' },
        _react2.default.createElement(
          'div',
          { className: 'newSuspension', style: styleObj },
          _react2.default.createElement(
            'div',
            { className: 'newSuspension-wrap ' + (data.customFeature.pickUpLocation == 'left' ? '' : 'newSuspension-right') + ' ' + (data.customFeature.pickUpType == 1 ? '' : 'newSuspension-round') + ' ' + (data.customFeature.structure == 1 ? '' : 'newSuspension-structure'),
              style: wrapStyleObj
            },
            _react2.default.createElement(
              'div',
              { className: 'newSuspension-box ' + (customFeature.buttonHidden ? '' : 'newSuspension-hiddenBtn'),
                style: {
                  padding: customFeature.suspensionShowList.length == data.content.length ? '.20rem 0' : ''
                }
              },
              customFeature.suspensionShowList && customFeature.suspensionShowList.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'newSuspension-item-box' },
                  item.map(function (subItem, subIndex) {
                    return _react2.default.createElement(
                      'div',
                      { key: subIndex, className: 'newSuspension-item',
                        style: itemStyleObj,
                        onClick: function onClick() {
                          return (0, _customEvent.customEvent)({ customFeature: subItem.customFeature });
                        } },
                      _react2.default.createElement('img', { src: subItem.pic, style: itemImgStyleObj }),
                      _react2.default.createElement(
                        'span',
                        { className: 'item-name' },
                        subItem.title
                      )
                    );
                  })
                );
              }),
              customFeature.pickUpType == 1 && customFeature.structure == 1 && _react2.default.createElement(
                'div',
                { className: 'newSuspension-btmBar ' + (customFeature.suspensionShowList.length == data.content.length ? 'marginAuto' : 'float'),
                  onClick: this.unfoldSus,
                  'data-compindex': this.props.index,
                  'data-taptype': 'foldSus'
                },
                _react2.default.createElement('div', { className: 'unfoldBtn', style: btnStyleObj })
              ),
              customFeature.pickUpType == 1 && customFeature.structure == 2 && _react2.default.createElement(
                'div',
                { className: 'newSuspension-close',
                  onClick: this.unfoldSus,
                  'data-compindex': this.props.index,
                  'data-taptype': 'foldSus',
                  style: {
                    background: customFeature.pickUpIcon,
                    backgroundSize: 'contain'
                  }
                },
                _react2.default.createElement('div', { className: 'unfoldBtn', style: btnStyleObj })
              ),
              customFeature.pickUpType == 2 && customFeature.pickUpLocation == 'left' && _react2.default.createElement(
                'div',
                { className: 'newSuspension-sideBar',
                  onClick: this.unfoldSus,
                  'data-compindex': this.props.index,
                  'data-taptype': 'foldSus',
                  style: {
                    background: customFeature.pickUpIcon,
                    backgroundSize: 'contain'
                  }
                },
                _react2.default.createElement('div', { className: 'unfoldBtn', style: btnStyleObj })
              ),
              customFeature.pickUpType == 2 && customFeature.pickUpLocation == 'right' && _react2.default.createElement(
                'div',
                { className: 'sideBarRight',
                  onClick: this.unfoldSus,
                  'data-compindex': this.props.index,
                  'data-taptype': 'foldSus',
                  style: {
                    background: customFeature.pickUpIcon,
                    backgroundSize: 'contain'
                  }
                },
                _react2.default.createElement('div', { className: 'unfoldBtn', style: btnStyleObj })
              )
            )
          )
        ),
        !customFeature.buttonHidden && _react2.default.createElement(
          'div',
          { className: 'sideBarRightOut ' + (customFeature.pickUpType == 1 ? 'roundBar' : '') + ' ' + (customFeature.pickUpType == 1 ? '' : 'newSuspension-round') + ' ' + (customFeature.structure == 1 ? '' : 'newSuspension-structure'),
            'data-compindex': this.props.index,
            style: navStyleObj,
            onClick: this.unfoldSus,
            'data-taptype': 'heightSus'
          },
          _react2.default.createElement('div', { className: 'unfoldBtn',
            style: unfoldBtnStyleObj })
        )
      );
    }
  }]);
  return NewSuspensionCustomComponent;
}(_react2.default.Component);

exports.default = NewSuspensionCustomComponent;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(842);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopupWindowCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(PopupWindowCustomComponent, _React$Component);

  function PopupWindowCustomComponent(props) {
    (0, _classCallCheck3.default)(this, PopupWindowCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PopupWindowCustomComponent.__proto__ || Object.getPrototypeOf(PopupWindowCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(PopupWindowCustomComponent, [{
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var detailData = this.props.detailData; // 详情页数据
      var dynamicData = this.props.dynamicData; // 动态数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var maskStyleObj = {
        backgroundColor: customFeature.maskBackgroundColor,
        opacity: customFeature.maskOpacity
        /**
         * 组件内容处理
         */
      };var content = data.content;
      var segment = data.customFeature.segment; // 已绑定字段
      // 是否有绑定字段
      if (segment) {
        if (detailData && detailData[segment]) {
          content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
        } else if (dynamicData && dynamicData[segment]) {
          content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
        }
      }
      /**
       * 返回组件
       */
      if (!data.showPopupWindow) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'custom-component popup-window' },
        _react2.default.createElement('div', { className: 'popup-window-mask', style: maskStyleObj, onClick: this.tapMaskClosePopupWindow, 'data-compindex': this.props.index }),
        _react2.default.createElement(
          'div',
          { className: 'popup-window-content', style: styleObj },
          content.map(function (componentData, componentIndex) {
            return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
          })
        )
      );
    }
  }]);
  return PopupWindowCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance, isPullRefresh) {
    if (isPullRefresh) {
      return;
    }
    _this3.controlAutoPopupWindow(compindex, pageInstance);
  };

  this.controlAutoPopupWindow = function (compindex, pageInstance) {
    var _this = _this3;
    var newData = {};
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;

    // TODO: webapp暂无顶部导航,暂不支持,先注释
    // let topnav = pageInstance.data['custom_top_nav1'];
    // if (topnav && topnav.customFeature.isDefault == 1 && !compData.styleInit){
    //   let top = compData.style.match(/margin-top:(\-?([\d|\.]*))rpx;/);
    //   if(top){
    //     let systeminfo = app.getSystemInfoData();
    //     let rpxRatio = systeminfo.rpxRatio || 2.34375;
    //     let mtop = "margin-top:" + (+top[1] + (app.globalData.topNavBarHeight || 0) * rpxRatio) + "rpx;";
    //     let style = compData.style.replace(top[0], mtop);
    //     newData['eles[' + compindex + '].style'] = style;
    //     newData['eles[' + compindex + '].styleInit'] = true;
    //   }
    // }

    if (customFeature.autoPopup === true) {
      if (customFeature.popupScene === 'everyDay' || customFeature.popupScene === 'firstAuthorize') {
        // 获取用户是否为第一次授权、是否为当天第一次登录
        if (!_app.appMethod.globalData.firstLoginAppChecked) {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=AppData/CheckFirstLoginApp',
            success: function success(data) {
              _app.appMethod.globalData.firstAuthorize = data.data.isAppFirstLogin;
              _app.appMethod.globalData.dailyFirstLogin = data.data.isDailyFirstLogin;
              _app.appMethod.globalData.firstLoginAppChecked = true;
              _this.controlAutoPopupWindow(compindex, pageInstance);
            }
          });
          return;
        }
        if (_app.appMethod.globalData.firstAuthorize && customFeature.popupScene === 'firstAuthorize' || _app.appMethod.globalData.dailyFirstLogin && customFeature.popupScene === 'everyDay') {
          if (!pageInstance.data.eles[compindex].alreadyShown) {
            newData['eles[' + compindex + '].showPopupWindow'] = true;
            newData['eles[' + compindex + '].alreadyShown'] = true;
            pageInstance.setData(newData);
          }
        }
      } else if (customFeature.popupScene === 'everyTime') {
        newData['eles[' + compindex + '].showPopupWindow'] = true;
        pageInstance.setData(newData);
      }

      if (customFeature.autoClose === true) {
        setTimeout(function () {
          newData['eles[' + compindex + '].showPopupWindow'] = false;
          pageInstance.setData(newData);
        }, +customFeature.closeDelay * 1000);
      }
    }
  };

  this.tapMaskClosePopupWindow = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compdata = pageInstance.data.eles[compindex];
    var newData = {};
    if (compdata.customFeature.tapMaskClose === true) {
      newData['eles[' + compindex + '].showPopupWindow'] = false;
      pageInstance.setData(newData);
    }
  };
};

exports.default = PopupWindowCustomComponent;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

__webpack_require__(844);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlidingPanelCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(SlidingPanelCustomComponent, _React$Component);

  function SlidingPanelCustomComponent(props) {
    (0, _classCallCheck3.default)(this, SlidingPanelCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SlidingPanelCustomComponent.__proto__ || Object.getPrototypeOf(SlidingPanelCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  // 滑动面板设置节点信息


  // TODO： 应该没用


  // TODO： 应该没用


  (0, _createClass3.default)(SlidingPanelCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var detailData = this.props.detailData; // 详情页数据
      var dynamicData = this.props.dynamicData; // 动态数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var vesselMode2StyleObj = (0, _extends3.default)({}, styleObj, {
        height: 'auto',
        width: 'auto',
        marginRight: (0, _tools.transformPx2Rem)(data.style['margin-left'], 320)
      });
      var secStyleObj = (0, _extends3.default)({
        marginLeft: data.customFeature.style['margin-left'],
        marginRight: data.customFeature.style['margin-right']
      }, (0, _tools.convertStyleData)({
        'font-size': customFeature.secFontSize,
        'font-weight': customFeature.secFontWeight || 'normal',
        'font-style': customFeature.secFontStyle || 'normal',
        'text-decoration': customFeature.secTextDecoration || 'none',
        'color': customFeature.secColor,
        'text-align': customFeature.secTextAlign
      }));
      var mainStyleObj = (0, _extends3.default)({}, (0, _tools.convertStyleData)(customFeature.style), {
        marginTop: (0, _tools.transformPx2Rem)(customFeature.style['margin-bt']),
        marginBottem: (0, _tools.transformPx2Rem)(customFeature.style['margin-bt'])
      });
      /**
       * 组件内容处理
       */
      var content = data.content || [];
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component sliding-panel vessel-mode-' + (customFeature.vesselMode || 1) },
        customFeature.vesselMode === 1 && _react2.default.createElement(
          'div',
          { className: 'slide mode-' + customFeature.mode + ' dots-' + customFeature.navigateMode, style: styleObj },
          _react2.default.createElement(
            _carousel2.default,
            {
              autoplay: customFeature.autoplay,
              autoplayInterval: customFeature.interval * 1000,
              infinite: true,
              dots: customFeature.mode !== -1,
              dotStyle: { background: customFeature.navigateDefaultColor },
              dotActiveStyle: { background: customFeature.navigateActiveColor }
            },
            content.map(function (data, index) {
              return _react2.default.createElement(
                'div',
                { className: 'panel', key: index, style: { height: styleObj.height } },
                data.content.map(function (componentData, componentIndex) {
                  return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
                })
              );
            })
          )
        ),
        customFeature.vesselMode === 2 && _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            'scroll-x': true,
            className: 'slide-panel silde-panel-mode2',
            id: 'sliding-panel-' + this.props.index,
            style: vesselMode2StyleObj,
            bindscroll: this.slidePanelScrollEvent,
            'data-compindex': this.props.index,
            'data-offset-left-arr': JSON.stringify(data.offsetLeftArr || []),
            'data-active-index': JSON.stringify(data.activeIndex || 0),
            'data-container-offset-width': JSON.stringify(data.containerOffsetWidth) },
          data.content.map(function (item, contentIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'sildeItem', key: contentIndex,
                style: {
                  transform: 'scale(' + (contentIndex == data.activeIndex ? 1 : data.scaleDegree) + ')'
                },
                'data-compindex': _this2.props.index },
              !!data.customFeature.isShowTitle && _react2.default.createElement(
                'div',
                { className: 'sildeItem-title',
                  style: secStyleObj },
                item.title || item.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'sildeItem-main', style: mainStyleObj },
                item.content.map(function (componentData, componentIndex) {
                  return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
                })
              ),
              !!data.customFeature.isShowNum && _react2.default.createElement(
                'div',
                { className: 'sildeItem-pagination' },
                contentIndex + 1 + '/' + data.content.length
              )
            );
          })
        )
      );
    }
  }]);
  return SlidingPanelCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var compData = _this3.props.data;
    clearInterval(compData.slideInterval);
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].customFeature.slideIndex', 0));
    if (compData.customFeature.autoplay && compData.customFeature.interval) {
      _this3.slideSwiper({
        pageInstance: pageInstance,
        compindex: compindex
      });
    }
    if (compData.customFeature.vesselMode === 2) {
      var _pageInstance$setData2;

      // 滑动面板
      var customFeature = compData.customFeature;
      var activeIndex = 0;
      var scaleDegree = 1;
      customFeature.proportion > 1 && (scaleDegree = Math.round(100 / customFeature.proportion) / 100);
      pageInstance.setData((_pageInstance$setData2 = {}, (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + compindex + '].activeIndex', activeIndex), (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + compindex + '].scaleDegree', scaleDegree), (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + compindex + '].reference', customFeature.reference || 0.618), _pageInstance$setData2));
      _this3.slidePanelSetBoundingClientRectInfo(pageInstance, compindex);
    }
  };

  this.slideSwiper = function (options) {
    var compData = options.pageInstance.data.eles[options.compindex];
    options.pageInstance.data.eles[options.compindex].slideInterval = setInterval(function () {
      var index = compData.customFeature.slideIndex;
      var direction = '_interval';
      if (index >= compData.content.length) {
        index = 0;
      } else {
        index += 1;
      }
      _this3.slideAnimation({
        compindex: options.compindex,
        num: index,
        pageInstance: options.pageInstance,
        direction: direction
      });
    }, compData.customFeature.interval * 1000);
  };

  this.slidePanelSetBoundingClientRectInfo = function (pageIns) {
    var compindex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var n = arguments[2];

    if (compindex === -1) {
      return;
    }
    var that = _this3,
        pageInstance = pageIns || _app.appMethod.getAppCurrentPage(),
        newData = {},
        containerSelector = '#sliding-panel-' + compindex,
        selector = containerSelector + ' .sildeItem';
    _app.appMethod.getBoundingClientRect(containerSelector, function (areaRect) {
      if (!areaRect.length) {
        if (isNaN(n)) {
          n = 0;
        }
        if (n < 10) {
          setTimeout(function () {
            that.slidePanelSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
        }
        return;
      }
      var containerOffsetWidth = areaRect.shift().width;
      newData['eles[' + compindex + '].containerOffsetWidth'] = containerOffsetWidth;
      _app.appMethod.getBoundingClientRect(selector, function (itemRects) {
        var offsetArr = [],
            itemWidth = itemRects.length && itemRects[0].width || 0;
        if ((containerOffsetWidth == 0 || itemWidth == 0) && (isNaN(n) || n < 10)) {
          if (isNaN(n)) {
            n = 0;
          }
          setTimeout(function () {
            that.slidePanelSetBoundingClientRectInfo(pageInstance, compindex, ++n);
          }, 300);
          return;
        }
        offsetArr = itemRects.map(function (v, k) {
          return itemWidth * (k + 1);
        });
        newData['eles[' + compindex + '].offsetLeftArr'] = offsetArr;
        pageInstance.setData(newData);
      });
    });
  };

  this.slidePanelStart = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var startX = e.changedTouches[0].clientX;
    clearInterval(pageInstance.data.eles[compindex].slideInterval);
    var data = {};
    data['eles[' + compindex + '].startX'] = startX;
    pageInstance.setData(data);
  };

  this.slidePanelEnd = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var endX = e.changedTouches[0].clientX;
    var startX = compData.startX;
    var index = compData.customFeature.slideIndex;
    var direction = void 0;
    if (Math.abs(startX - endX) > 50) {
      startX - endX > 0 ? index++ : index--;
      if (compData.customFeature.autoplay) {
        compData.slideInterval = setInterval(function () {
          var index = compData.customFeature.slideIndex;
          if (index >= compData.content.length) {
            index = 0;
          } else {
            index += 1;
          }
          var direction = '_interval';
          _this3.slideAnimation({
            compindex: compindex,
            num: index,
            pageInstance: pageInstance,
            direction: direction
          });
        }, compData.customFeature.interval * 1000);
      } else {
        clearInterval(compData.slideInterval);
      }
      if (index >= compData.content.length || index < 0) {
        return;
      }
      _this3.slideAnimation({ compindex: compindex, num: index, pageInstance: pageInstance, direction: direction });
    }
  };

  this.slideAnimation = function (params) {
    // let animation = wx.createAnimation({
    //   duration: (params.num == 0 && params.direction) ? 0 : 500
    //   // duration: 500
    // });
    var length = -750 * params.num + 'rpx';
    var data = {};
    // animation.left(length).step();
    // data['eles[' + params.compindex + '].animations'] = animation.export();
    data['eles[' + params.compindex + '].customFeature.slideIndex'] = params.num;
    params.pageInstance.setData(data);
  };

  this.slidePanelScrollEvent = function (event, clear) {
    var that = _this3;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var activeIndex = JSON.parse(dataset.activeIndex);
    var offsetLeftArr = JSON.parse(dataset.offsetLeftArr);
    var containerOffsetWidth = JSON.parse(dataset.containerOffsetWidth);
    var _event$detail = event.detail,
        scrollLeft = _event$detail.scrollLeft,
        scrollWidth = _event$detail.scrollWidth;

    var compData = pageInstance.data.eles[compindex];
    var reference = +compData.reference;
    var timeoutId = null;
    var newData = {};
    var targetIndex = 0;
    var i = activeIndex;
    var l = offsetLeftArr.length;
    var flagOffset = containerOffsetWidth * reference + scrollLeft;

    if (scrollLeft < 20) {
      targetIndex = 0;
    } else if (scrollWidth - scrollLeft - containerOffsetWidth < 20) {
      targetIndex = l - 1;
    } else {
      if (flagOffset < offsetLeftArr[i]) {
        if (flagOffset < offsetLeftArr[i - 1]) {
          targetIndex = i - 1;
        } else {
          targetIndex = i;
        }
      } else {
        targetIndex = i + 1;
      }
    }

    if (activeIndex != targetIndex) {
      newData['eles[' + compindex + '].activeIndex'] = targetIndex;
    }

    if (!clear) {
      compData.timeoutId && clearTimeout(compData.timeoutId);
      timeoutId = setTimeout(function () {
        that.slidePanelScrollEvent(event, true);
      }, 140);
    }
    newData['eles[' + compindex + '].timeoutId'] = timeoutId;
    pageInstance.setData(newData);
  };
};

exports.default = SlidingPanelCustomComponent;

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(846);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "franchisee-list" 
 * 组件：多商家组件
 */

var FranchiseeListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(FranchiseeListCustomComponent, _React$Component);

  function FranchiseeListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, FranchiseeListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FranchiseeListCustomComponent.__proto__ || Object.getPrototypeOf(FranchiseeListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(FranchiseeListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      var style = (0, _tools.convertStyleData)(data.style);
      if (customFeature.vesselAutoheight == 0) {
        style['height'] = (0, _tools.transformPx2Rem)(customFeature['height'], 320);
      }
      var imgStyle = {
        width: (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.imgHeight, 320)
      };
      var itemStyle = {
        backgroundColor: customFeature.lineBackgroundColor,
        backgroundImage: customFeature.lineBackgroundImage,
        marginBottom: (0, _tools.transformPx2Rem)(customFeature.margin)
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component franchisee-list', style: style },
        _react2.default.createElement(
          'div',
          { className: 'franchisee-title', onClick: this.tapFranchiseeLocation, 'data-compindex': this.props.index },
          _react2.default.createElement(
            'div',
            { className: 'location',
              onClick: this.tapFranchiseeLocation,
              'data-compindex': this.props.index
            },
            _react2.default.createElement(
              'span',
              { className: 'ico-moon icon-fre_adress' },
              data.location_address || '定位中...'
            )
          ),
          '\u9644\u8FD1\u5546\u5BB6'
        ),
        _react2.default.createElement(
          'div',
          { className: 'list-wrap', onScroll: this.franchiseeScrollFunc },
          data.franchisee_data && data.franchisee_data.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'list-item', key: index, style: itemStyle,
                onClick: _this3.turnToFranchiseeDetail,
                'data-appid': item.app_id,
                'data-mode': item.mode_id,
                'data-audit': item.is_audit,
                'data-id': item.id,
                'data-newpage': item.sub_app_bar['homepage-router'] || '',
                'data-newmode': item.sub_app_bar.mode_id || ''
              },
              _react2.default.createElement(
                'div',
                { className: 'img-wrap', style: imgStyle },
                _react2.default.createElement('img', { src: item.picture, alt: '' }),
                item.open_staus == 0 && _react2.default.createElement(
                  'div',
                  { className: 'not-open-mask' },
                  _react2.default.createElement(
                    'div',
                    { className: 'list-status not-open-tip' },
                    '\u4F11\u606F\u4E2D'
                  )
                ),
                item.is_audit == 2 && _react2.default.createElement(
                  'div',
                  { className: 'list-status list-audit' },
                  '\u5F85\u5BA1\u6838'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'info-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'title-wrap' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.name
                  ),
                  !!item.distance && _react2.default.createElement(
                    'div',
                    { className: 'distance' },
                    item.distance
                  )
                ),
                !!item.per_capita && _react2.default.createElement(
                  'div',
                  { className: 'defaul' },
                  _react2.default.createElement(
                    'div',
                    { className: 'average-price' },
                    '\xA5',
                    item.per_capita,
                    '/\u4EBA'
                  )
                ),
                item.industry_type_name && _react2.default.createElement(
                  'div',
                  { className: 'list-bottom' },
                  _react2.default.createElement(
                    'div',
                    { className: 'list-industry' },
                    item.industry_type_name
                  )
                ),
                item.coupon_list.best_subtract_value || item.coupon_list.best_discount && _react2.default.createElement(
                  'div',
                  { className: 'discount-coupons' },
                  item.coupon_list.best_subtract_value != '' && _react2.default.createElement(
                    'div',
                    { className: 'coupons-cash' },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u51CF'
                    ),
                    '\u8FDB\u5E97\u9886\u53D6',
                    item.coupon_list.best_subtract_value
                  ),
                  item.coupon_list.best_discount != '' && _react2.default.createElement(
                    'div',
                    { className: 'coupons-rebate' },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u6298'
                    ),
                    '\u8FDB\u5E97\u9886\u53D6',
                    item.coupon_list.best_discount,
                    '\u6298\u4F18\u60E0'
                  )
                )
              )
            );
          }),
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          data.is_more == 0 && data.franchisee_data && data.franchisee_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无商家~' } }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'franchiseeScrollFunc', compindex: this.props.index } }),
          data.is_more == 0 && data.franchisee_data && data.franchisee_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.franchiseeScrollFunc, 'data-compindex': this.props.index })
        ),
        data.showNationList && _react2.default.createElement(
          'div',
          { className: 'nation-select-container' },
          _react2.default.createElement(
            'div',
            { className: 'nation-list-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'nation-closed', onClick: this.hideNationList, 'data-compindex': this.props.index },
              _react2.default.createElement('span', { className: 'ico-moon icon-closed' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tip' },
              '\u9009\u62E9\u670D\u52A1\u6240\u5728\u56FD\u5BB6'
            ),
            _react2.default.createElement(
              'div',
              { className: 'list' },
              data.nationList && data.nationList.map(function (item, itemIndex) {
                return _react2.default.createElement(
                  'div',
                  { key: itemIndex,
                    onClick: _this3.reLocalAddress,
                    'data-nationname': item.nation_name,
                    'data-nationid': item.oversea_region_id,
                    'data-compindex': _this3.props.index,
                    'data-address': data.location_address,
                    'data-latlng': data.addressInfo },
                  _react2.default.createElement(
                    'div',
                    { className: 'nation-name' },
                    item.nation_name
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return FranchiseeListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var _this = _this4;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var locationInfo = _app.appMethod.globalData.locationInfo;

    // 设置当前组件param
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', {
      'id': customFeature['id'],
      'form': customFeature['form'], //TODO: AppShopService::FORM_APP_SHOP,
      'page': 1,
      'app_id': _app.appMethod.getAppId(),
      'sort_key': 'distance',
      'sort_direction': 1
    }));

    var param = {};
    var isClassify = false;
    if (_app.appMethod.getInvolvedFromRefreshObject(customFeature.id, 'new-classify')) {
      isClassify = true;
    }
    if (isClassify) {
      return;
    }

    param.form = "app_shop";
    if (_this4.withSortCompFlag(compindex, pageInstance)) {
      // 判断是否有绑定排序组件
      param.sort_key = "weight";
      param.sort_direction = 0;
    } else {
      param.sort_key = "distance";
      param.sort_direction = 1;
    }
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    if (customFeature.sourceType == 'industry' && customFeature.source && customFeature.source != 'none') {
      param.industry_type = customFeature.source;
    } else if (customFeature.sourceType == 'shop' && customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      };
    }

    if (locationInfo.latitude) {
      var newdata = {};
      newdata['eles[' + compindex + '].location_address'] = locationInfo.address;
      pageInstance.setData(newdata);

      param.latitude = locationInfo.latitude;
      param.longitude = locationInfo.longitude;
      _this.getFranchiseeList(compindex, param, pageInstance);
    } else {
      _app.appMethod.getLocation({
        type: 'gcj02',
        success: function success(res) {
          var latitude = res.latitude,
              longitude = res.longitude;

          if (res.latitude) {
            pageInstance.requestNum++;
            _app.appMethod.sendRequest({
              hideLoading: true,
              url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
              data: {
                latitude: latitude,
                longitude: longitude
              },
              success: function success(res) {
                var newdata = {};
                newdata['eles[' + compindex + '].location_address'] = res.data.formatted_addresses.recommend;
                pageInstance.setData(newdata);

                _app.appMethod.setLocationInfo({
                  latitude: latitude,
                  longitude: longitude,
                  address: res.data.formatted_addresses.recommend,
                  info: res.data
                });
              }
            });
            param.latitude = latitude;
            param.longitude = longitude;

            _this.getFranchiseeList(compindex, param, pageInstance);
          } else {
            var _newdata = {};
            _newdata['eles[' + compindex + '].location_address'] = '定位失败';
            pageInstance.setData(_newdata);
          }
        },
        fail: function fail(res) {
          var newdata = {};
          if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
            newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
          } else {
            newdata['eles[' + compindex + '].location_address'] = '定位失败';
          }
          param.sort_key = 'weight';
          _this.getFranchiseeList(compindex, param, pageInstance);
          pageInstance.setData(newdata);
        }
      });
    }

    _app.appMethod.getNationList(compindex);
  };

  this.getFranchiseeList = function (compindex, param, pageInstance) {
    var _this = _this4;
    var newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].franchisee_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    if (param['sort_key'] === 'distance' && !param['latitude']) {
      // 防止没没有经纬度报错
      param['sort_key'] = 'weight';
      param['sort_direction'] = 0;
    }
    newdata['eles[' + compindex + '].param'] = param;

    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: param,
      method: 'post',
      success: function success(res) {
        for (var index in res.data) {
          var distance = res.data[index].distance;
          res.data[index].distance = _util2.default.formatDistance(distance);
        }

        _this.getMyAppShopList(compindex, pageInstance);

        var newdata = {};
        newdata['eles[' + compindex + '].franchisee_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  };

  this.getMyAppShopList = function (compindex, pageInstance, reset) {
    var that = _this4;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetMyAppShopList',
      data: {
        parent_app_id: _app.appMethod.getAppId()
      },
      hideLoading: true,
      success: function success(res) {
        var newdata = {};
        var oldList = pageInstance.data.eles[compindex].franchisee_data || [];
        var list = res.data;
        var listId = [];
        if (reset) {
          var l = 0;
          for (var i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 2) {
              l++;
            } else {
              break;
            }
          }
          oldList.splice(0, l);
        }
        for (var _i = 0; _i < list.length; _i++) {
          if (list[_i].is_audit == 2) {
            oldList.unshift(list[_i]);
            listId.push(list[_i].id);
          }
        }
        if (reset) {
          for (var _i2 = 0; _i2 < oldList.length; _i2++) {
            if (oldList[_i2].is_audit == 1 && listId.indexOf(oldList[_i2].id) > -1) {
              oldList.splice(_i2, 1);
            }
          }
        }
        newdata['eles[' + compindex + '].franchisee_data'] = oldList;

        pageInstance.setData(newdata);
      }
    });
  };

  this.tapFranchiseeLocation = function (event) {
    var _this = _this4;
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].showNationList', true));

    return; // TODO: 是否之后的代码需要去掉

    function success(res) {
      var name = res.name || res.address || '';
      var lat = res.latitude;
      var lng = res.longitude;
      var newdata = {};
      var param = pageInstance.data.eles[compindex].param;
      var requestData = void 0;

      newdata['eles[' + compindex + '].location_address'] = name;
      pageInstance.setData(newdata);

      param.latitude = lat;
      param.longitude = lng;

      requestData = {
        id: compindex,
        form: 'app_shop',
        page: 1,
        sort_key: param.sort_key,
        sort_direction: param.sort_direction,
        latitude: param.latitude,
        longitude: param.longitude,
        idx_arr: param.idx_arr
      };
      _app.appMethod.globalData.locationInfo.latitude = lat;
      _app.appMethod.globalData.locationInfo.longitude = lng;

      this._refreshFranchiseeList(compindex, requestData, pageInstance);

      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
        data: {
          latitude: lat,
          longitude: lng
        },
        success: function success(data) {

          if (!name || name == ' ') {
            var _newdata2 = {};
            _newdata2['eles[' + compindex + '].location_address'] = data.data.formatted_addresses.recommend;
            pageInstance.setData(_newdata2);
          }

          _app.appMethod.setLocationInfo({
            latitude: lat,
            longitude: lng,
            address: name,
            info: data.data
          });
        }
      });
    }

    function cancel() {
      console.log('cancel');
    }

    function fail() {
      console.log('fail');
    }
    _app.appMethod.chooseLocation({
      success: success,
      fail: fail,
      cancel: cancel
    });
  };

  this.turnToFranchiseeDetail = function (event) {
    var dataset = event.currentTarget.dataset;
    var appid = dataset.appid;
    var mode = dataset.mode;
    var pageLink = dataset.newpage;
    var param = {};

    param.detail = appid;
    if (dataset.audit == 2) {
      param.shop_id = dataset.id;
    }
    if (pageLink) {
      mode = dataset.newmode;
      _this4.turnToFranchiseePage(mode, pageLink, appid, param);
      return;
    }
    _app.appMethod.goToFranchisee(mode, param);
  };

  this.turnToFranchiseePage = function (mode, pageLink, franchiseeId, param) {
    switch (pageLink.trim()) {
      case 'franchiseeWaimai':
        _app.appMethod.goToFranchisee(1, param);
        return;
      case 'franchiseeTostore':
        _app.appMethod.goToFranchisee(3, param);
        return;
      case 'franchiseeDetail4':
        _app.appMethod.goToFranchisee(2, param);
        return;
      case 'franchiseeDetail':
        _app.appMethod.goToFranchisee(0, param);
        return;
      default:
        break;
    }
    var queryStr = franchiseeId ? '?franchisee=' + franchiseeId + '&fmode=' + mode : '';
    _app.appMethod.turnToPage(pageLink + queryStr);
  };

  this.hideNationList = function (event) {
    var _this = _this4;
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].showNationList', false));
  };

  this.reLocalAddress = function (event) {
    var dataset = event.currentTarget.dataset,
        pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var param = pageInstance.data.eles[compindex].param;
    var newdata = {};
    newdata['eles[' + compindex + '].showNationList'] = false;
    pageInstance.setData(newdata);
    if (dataset.nationid) {
      _app.appMethod.turnToPage('searchAddress?from=franchisee&locateAddress=' + dataset.address + '&compindex=' + dataset.compindex + '&nationId=' + dataset.nationid + '&nationname=' + dataset.nationname + '&latitude=' + param.latitude + '&longitude=' + param.longitude);
    }
  };

  this.franchiseeListRefresh = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var param = pageInstance.data.eles[compindex].param; // 就是当前组件的param
    var requestData = {};

    requestData = {
      id: compindex,
      form: 'app_shop',
      page: 1,
      sort_key: param.sort_key,
      sort_direction: param.sort_direction,
      latitude: param.latitude,
      longitude: param.longitude,
      idx_arr: param.idx_arr
    };

    _this4._refreshFranchiseeList(compindex, requestData, pageInstance);
  };

  this.withSortCompFlag = function (compindex, pageInstance) {
    var pageData = pageInstance.data;
    var targetId = pageData.eles[compindex].customFeature.id;
    return pageData.eles.some(function (ele) {
      return !ele.hidden && ele.customFeature.sort_object === targetId;
    });
  };

  this._refreshFranchiseeList = function (targetCompIndex, requestData, pageInstance) {
    var _this = _this4;
    var newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].franchisee_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    newdata['eles[' + targetCompIndex + '].curpage'] = 0;
    newdata['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newdata);

    requestData.latitude = _app.appMethod.globalData.locationInfo.latitude;
    requestData.longitude = _app.appMethod.globalData.locationInfo.longitude;

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      method: 'post',
      data: requestData,
      success: function success(res) {
        var newData = {};

        for (var index in res.data) {
          var distance = res.data[index].distance;
          res.data[index].distance = _util2.default.formatDistance(distance);
        }
        newData['eles[' + targetCompIndex + '].franchisee_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.franchiseeScrollFunc = function (event) {
    // TODO 未处理滚动加载
    console.log('TODO: 未处理滚动加载');
    return;
    _app.appMethod.franchiseeScrollFunc(event);
  };
};

exports.default = FranchiseeListCustomComponent;

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

__webpack_require__(848);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stringLength = function stringLength(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var a = str.charCodeAt(i);;
    if (a >= 0 && a <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
};

var isEllipsis = function isEllipsis(str, max) {
  var strLength = stringLength(str);
  return strLength > max;
};

/**
 * type: "franchisee-chain" 
 * 组件：连锁多商家组件
 * 
 * TODO: 目前未写接口请求店铺及子店数据
 */

var FranchiseeChainCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(FranchiseeChainCustomComponent, _React$Component);

  function FranchiseeChainCustomComponent(props) {
    (0, _classCallCheck3.default)(this, FranchiseeChainCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FranchiseeChainCustomComponent.__proto__ || Object.getPrototypeOf(FranchiseeChainCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(FranchiseeChainCustomComponent, [{
    key: 'render',
    value: function render() {
      // 组件数据
      var data = this.props.data;
      // 当前连锁店数据
      var currentChainStore = _page.pageInstance.data.currentChainStore || {};
      // 组件配置对象
      var customFeature = data.customFeature;
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var btnColor = customFeature.buttonColor;
      var titleColor = customFeature.titleColor;
      var infoColor = customFeature.instructionsColor;

      return _react2.default.createElement(
        'div',
        { className: 'custom-component franchisee-chain mode-' + customFeature.mode, style: styleObj, 'data-compindex': this.props.index, onClick: this.turnToChainStoreList },
        customFeature.mode == 0 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'store-current' },
            _react2.default.createElement(
              'div',
              { className: 'store-change', style: {
                  color: customFeature.buttonColor
                } },
              _react2.default.createElement(
                'span',
                null,
                customFeature.prefixTitle || '换门店'
              ),
              _react2.default.createElement('span', { className: 'ico-moon icon-filter-down' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'store-name', style: {
                  color: data.customFeature.titleColor
                } },
              currentChainStore.name || ''
            ),
            currentChainStore.not_business || currentChainStore.is_open == 0 && _react2.default.createElement(
              'div',
              { className: 'store-business', style: {
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                } },
              '\u6B47\u4E1A\u4E2D'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'store-info', style: {
                color: customFeature.instructionsColor
              } },
            _react2.default.createElement(
              'div',
              { className: 'store-phone' },
              _react2.default.createElement('span', { className: 'ico-moon icon-takeout-cellphone' }),
              _react2.default.createElement(
                'span',
                null,
                currentChainStore.phone || ''
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'store-address' },
              _react2.default.createElement('span', { className: 'ico-moon icon-community-location' }),
              _react2.default.createElement(
                'span',
                null,
                currentChainStore.address || ''
              )
            )
          )
        ),
        customFeature.mode == 1 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'store-current' },
            _react2.default.createElement(
              'div',
              { className: 'store-change', style: {
                  color: customFeature.buttonColor
                } },
              _react2.default.createElement(
                'span',
                null,
                customFeature.prefixTitle || '换门店'
              ),
              _react2.default.createElement('span', { className: 'ico-moon icon-filter-down' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'store-name', style: {
                  color: data.customFeature.titleColor
                } },
              currentChainStore.name || ''
            ),
            currentChainStore.not_business || currentChainStore.is_open == 0 && _react2.default.createElement(
              'div',
              { className: 'store-business', style: {
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                } },
              '\u6B47\u4E1A\u4E2D'
            )
          )
        ),
        customFeature.mode == 2 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'store-current' },
            _react2.default.createElement(
              'div',
              { className: 'store-name', style: {
                  color: data.customFeature.titleColor
                } },
              _react2.default.createElement('span', { className: 'ico-moon icon-community-location', style: {
                  color: customFeature.buttonColor
                } }),
              currentChainStore.name || ''
            ),
            currentChainStore.not_business || currentChainStore.is_open == 0 && _react2.default.createElement(
              'div',
              { className: 'store-business', style: {
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                } },
              '\u6B47\u4E1A\u4E2D'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'store-search' },
            _react2.default.createElement('span', { className: 'icon-moon icon-search' }),
            _react2.default.createElement(
              'span',
              null,
              '\u641C\u7D22\u5176\u4ED6\u5E97\u94FA'
            )
          )
        ),
        customFeature.mode == 3 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'store-current' },
            _react2.default.createElement(
              'div',
              { className: 'store-name', style: {
                  color: data.customFeature.titleColor
                } },
              currentChainStore.name || ''
            ),
            currentChainStore.not_business || currentChainStore.is_open == 0 && _react2.default.createElement(
              'div',
              { className: 'store-business', style: {
                  marginLeft: isEllipsis(currentChainStore.name, 24) ? '0' : '.20rem'
                } },
              '\u6B47\u4E1A\u4E2D'
            ),
            _react2.default.createElement(
              'div',
              { className: 'store-info', style: {
                  color: customFeature.instructionsColor
                } },
              _react2.default.createElement(
                'div',
                { className: 'store-phone' },
                _react2.default.createElement('span', { className: 'ico-moon icon-takeout-cellphone' }),
                _react2.default.createElement(
                  'span',
                  null,
                  currentChainStore.phone || ''
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'store-address' },
                _react2.default.createElement('span', { className: 'ico-moon icon-community-location' }),
                _react2.default.createElement(
                  'span',
                  null,
                  currentChainStore.address || ''
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FranchiseeChainCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.init = function (compindex, pageInstance, isPullRefresh) {
    if (isPullRefresh) {
      return;
    }
    var data = pageInstance.data;
    if (pageInstance.hasChain) {
      return;
    }
    pageInstance.hasChain = true;
    var chainStore = _app.appMethod.globalData.chainAppId;
    if (chainStore) {
      _this2.getChainStoreInfo();
    } else {
      _this2.getMainStoreInfo();
    }
  };

  this.getMainStoreInfo = function () {
    var that = _this2;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopInfo',
      data: {},
      success: function success(res) {
        var newdata = {};
        var data = res.data;
        if (!data.app_id) {
          return;
        }
        var pageInstance = _app.appMethod.getAppCurrentPage();
        var inBusiness = _app.appMethod.businessTimeCompare(data.business_time || []);
        pageInstance.setData({
          currentChainStore: {
            name: data.name,
            phone: data.phone,
            address: data.province_name + data.city_name + data.county_name + data.address_detail,
            not_business: !inBusiness,
            is_open: data.is_open
          }
        });
      }
    });
  };

  this.getChainStoreInfo = function () {
    var that = _this2;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        is_show_chain: 1,
        sub_shop_app_id: _app.appMethod.globalData.chainAppId,
        page: 1,
        page_size: 1
      },
      success: function success(res) {
        that.setChainInfo(res);
      },
      fail: function fail() {
        var pageInstance = _app.appMethod.getAppCurrentPage();
        _app.appMethod.globalData.chainAppId = '';
        _app.appMethod.globalData.chainHistoryDataId = '';
        if (pageInstance && pageInstance.page_router && _app.appMethod.globalData.chainNotLoading && pageInstance.dataInitial) {
          pageInstance.dataInitial();
        }
        _app.appMethod.globalData.chainNotLoading = false;
      }
    });
  };

  this.getNearbyChainInfo = function (param, pageIns) {
    var that = _this2;
    var pageInstance = pageIns || _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        is_show_chain: 1,
        sort_key: 'distance',
        sort_direction: 1,
        online_his_id: _app.appMethod.globalData.historyDataId,
        latitude: param.latitude,
        longitude: param.longitude,
        page: 1,
        page_size: 1
      },
      success: function success(res) {
        that.setChainInfo(res);
      },
      fail: function fail() {
        _app.appMethod.globalData.chainAppId = '';
        _app.appMethod.globalData.chainHistoryDataId = '';
        if (pageInstance && pageInstance.page_router && _app.appMethod.globalData.chainNotLoading && pageInstance.dataInitial) {
          pageInstance.dataInitial();
        }
        _app.appMethod.globalData.chainNotLoading = false;
      },
      complete: function complete() {
        wx.hideLoading();
      }
    });
  };

  this.setChainInfo = function (res, _from) {
    var that = _this2;
    var newdata = {};
    var data = res.data[0];
    var pageInstance = _app.appMethod.getAppCurrentPage();

    if (!data || _app.appMethod.globalData.historyDataId != data.s_his_data.online_his_id) {
      if (_from === 'fromWxCode') {
        _app.appMethod.showModal({
          title: '提示',
          content: '连锁子店版本与线上版本不一致，将回到总店'
        });
      }
      _app.appMethod.globalData.chainAppId = '';
      _app.appMethod.globalData.chainHistoryDataId = '';
      if (pageInstance && pageInstance.page_router && _app.appMethod.globalData.chainNotLoading && pageInstance.dataInitial) {
        pageInstance.dataInitial();
      }
      _app.appMethod.globalData.chainNotLoading = false;
      return;
    }
    var inBusiness = _app.appMethod.businessTimeCompare(data.business_time || []);
    _app.appMethod.globalData.chainHistoryDataId = data.s_his_data.his_id;
    if (_app.appMethod.globalData.chainNotLoading) {
      _app.appMethod.globalData.chainAppId = data.app_id;
    }
    if (pageInstance && pageInstance.page_router) {
      pageInstance.setData({
        currentChainStore: {
          name: data.name,
          phone: data.phone,
          address: data.province_name + data.city_name + data.county_name + data.address_detail,
          not_business: !inBusiness,
          is_open: data.is_open
        }
      });
      if (_app.appMethod.globalData.chainNotLoading && pageInstance.dataInitial) {
        pageInstance.dataInitial();
      }
    }
    _app.appMethod.globalData.chainNotLoading = false;
  };

  this.turnToChainStoreList = function (e) {
    var compindex = e.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var param = '';

    if (customFeature.sourceType && customFeature.source) {
      param = '?sourceType=' + customFeature.sourceType + '&source=' + customFeature.source;
    }
    _app.appMethod.turnToPage('chainStoreList' + param);
  };
};

exports.default = FranchiseeChainCustomComponent;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CustomComponent = __webpack_require__(44);

var _CustomComponent2 = _interopRequireDefault(_CustomComponent);

var _tools = __webpack_require__(6);

var _page = __webpack_require__(43);

__webpack_require__(850);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(SidebarCustomComponent, _React$Component);

  function SidebarCustomComponent(props) {
    (0, _classCallCheck3.default)(this, SidebarCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SidebarCustomComponent.__proto__ || Object.getPrototypeOf(SidebarCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    return _this;
  }

  (0, _createClass3.default)(SidebarCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var detailData = this.props.detailData; // 详情页数据
      var dynamicData = this.props.dynamicData; // 动态数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      styleObj['animation'] = '' + (data.hideSidebar ? 'hide' : 'show') + (customFeature.direction === 'left' ? 'Left' : 'Right') + 'Sidebar .3s forwards';
      var maskStyleObj = {
        backgroundColor: customFeature.maskBackgroundColor,
        opacity: customFeature.maskOpacity
        /**
         * 组件内容处理
         */
      };var content = data.content;
      var segment = data.customFeature.segment; // 已绑定字段
      // 是否有绑定字段
      if (segment) {
        if (detailData && detailData[segment]) {
          content = detailData[segment]; // 当前组件处于详情页数据并已绑定某字段
        } else if (dynamicData && dynamicData[segment]) {
          content = dynamicData[segment]; // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
        }
      }
      /**
       * 返回组件
       */
      if (!data.showSidebar) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'custom-component sidebar' },
        _react2.default.createElement('div', { className: 'sidebar-mask', style: maskStyleObj, onClick: function onClick() {
            return _this2.tapMaskCloseSidebar();
          } }),
        _react2.default.createElement(
          'div',
          { className: 'sidebar-content', style: styleObj },
          content.map(function (componentData, componentIndex) {
            return _react2.default.createElement(_CustomComponent2.default, { key: componentIndex, index: componentIndex, data: componentData, detailData: detailData, dynamicData: dynamicData });
          })
        )
      );
    }
  }]);
  return SidebarCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.tapMaskCloseSidebar = function () {
    var props = _this3.props;
    var componentIndex = props.index;
    _page.pageMethod.setCustomComponentData(componentIndex, (0, _extends3.default)({}, props.data, { hideSidebar: true }));
    setTimeout(function () {
      _page.pageMethod.setCustomComponentData(componentIndex, (0, _extends3.default)({}, props.data, { showSidebar: false }));
    }, 300);
  };
};

exports.default = SidebarCustomComponent;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

exports.default = AdvertisingCustomComponent;

__webpack_require__(13);

var _tools = __webpack_require__(6);

__webpack_require__(852);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AdvertisingCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var imgStyle = {
    width: '100%'
  };
  var showToast = function showToast() {
    _toast2.default.info('仅为预览图效果，实际功能请在小程序端体验(该组件仅支持微信小程序)');
  };
  styleObj['height'] = 'unset';
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return React.createElement(
    'div',
    { className: 'custom-component', style: styleObj, onClick: showToast },
    React.createElement('img', { style: imgStyle, src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/advertising1.png', alt: '\u5E7F\u544A\u7EC4\u4EF6\uFF08\u4EC5\u652F\u6301\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\uFF09' })
  );
}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PluginCustomComponent;

__webpack_require__(854);

function PluginCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return React.createElement(
    "div",
    { className: "custom-component plugin" },
    React.createElement(
      "p",
      null,
      "\u63D2\u4EF6\u7EC4\u4EF6\uFF08\u4EC5\u652F\u6301\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F\uFF09"
    )
  );
}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

exports.default = OfficialAccountCustomComponent;

__webpack_require__(13);

__webpack_require__(856);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OfficialAccountCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  var imgStyle = {
    width: '100%'
  };
  var showToast = function showToast() {
    _toast2.default.info('仅为预览图效果，实际功能请在小程序端体验(该组件仅支持微信小程序)');
  };
  return React.createElement(
    'div',
    { className: 'custom-component', onClick: showToast },
    React.createElement('img', { style: imgStyle, src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/official-account.png', alt: '\u516C\u4F17\u53F7\u5173\u6CE8\u7EC4\u4EF6\uFF08\u4EC5\u652F\u6301\u5FAE\u4FE1\u5C0F\u7A0B\u5E8F)' })
  );
}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ClassifyCustomComponent;

__webpack_require__(858);

function ClassifyCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return React.createElement(
    "div",
    { className: "custom-component classify" },
    React.createElement(
      "p",
      null,
      "\u65E7\u7248\u5206\u7C7B\u7EC4\u4EF6\uFF08\u6682\u4E0D\u652F\u6301\uFF09"
    ),
    React.createElement(
      "p",
      null,
      "\u5EFA\u8BAE\u4F7F\u7528\u65B0\u7248\u5206\u7C7B\u7EC4\u4EF6"
    )
  );
}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CountCustomComponent;

__webpack_require__(860);

function CountCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return React.createElement(
    "div",
    { className: "custom-component count" },
    React.createElement(
      "p",
      null,
      "\u65E7\u7248\u8BA1\u6570\u5668\u7EC4\u4EF6\uFF08\u6682\u4E0D\u652F\u6301\uFF09"
    ),
    React.createElement(
      "p",
      null,
      "\u5EFA\u8BAE\u4F7F\u7528\u65B0\u7248\u8BA1\u6570\u5668\u7EC4\u4EF6"
    )
  );
}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewCountCustomComponent;

var _tools = __webpack_require__(6);

__webpack_require__(862);

function NewCountCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  var imgStyleObj = (0, _tools.convertStyleData)({
    width: customFeature.size,
    height: customFeature.size
  });
  /**
   * 组件内容处理
   */
  var imgUrl = null;
  var todayCount = 0;
  var allCount = 0;
  var counted = false;
  if (customFeature.type === 0) {
    if (customFeature.va == 0 && customFeature.effect == 1) {
      counted = todayCount > 0;
    } else {
      counted = allCount > 0;
    }
  }
  imgUrl = counted ? customFeature.voteChangePicture : customFeature.voteInitPicture;
  var count = '';
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component new-count', style: styleObj },
    React.createElement(
      'div',
      { className: 'new-count-ele' },
      customFeature.isShowImage && React.createElement('img', { className: 'new-count-image', src: imgUrl, style: imgStyleObj }),
      React.createElement(
        'span',
        { className: 'new-count-content' },
        data.content,
        count
      )
    )
  );
}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(MapCustomComponent, _React$Component);

  function MapCustomComponent(props) {
    (0, _classCallCheck3.default)(this, MapCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MapCustomComponent.__proto__ || Object.getPrototypeOf(MapCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    _this.qmap = _react2.default.createRef();
    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(MapCustomComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var customFeature = this.props.data.customFeature;
      if (customFeature.type !== 'withmap') {
        return;
      }
      // let mapInstance = new qq.maps.Map(this.qmap.current, {
      //   zoom: 13,
      //   zoomControl: false,
      //   panControl: false,
      //   mapTypeControl: false
      // });
      // if (customFeature.lat && customFeature.lng) {
      //   let latLng = new qq.maps.LatLng(customFeature.lat, customFeature.lng);
      //   this.qqMapMarker = new qq.maps.Marker({
      //     map: mapInstance,
      //     position: latLng
      //   });
      //   mapInstance.setCenter(latLng);
      // } else {
      //   mapInstance.map && mapInstance.setCenter(mapInstance.map.center);
      // }
      // mapInstance.zoomTo(13);
    }
    /**
     * 跳转地图详情
     */

  }, {
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component map', style: styleObj,
          onClick: this.tapMapDetail,
          'data-event-params': data.customFeature.markers_json_str
        },
        customFeature.type === 'withmap' && _react2.default.createElement('div', { ref: this.qmap, className: 'map-module' }),
        _react2.default.createElement(
          'div',
          { className: 'map-text' },
          _react2.default.createElement('span', { className: 'ico-moon icon-location' }),
          _react2.default.createElement(
            'span',
            { className: 'map-link' },
            data.content
          )
        )
      );
    }
  }]);
  return MapCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.init = function (compindex, pageInstance) {
    var customFeature = _this2.props.data.customFeature;
    var markers = [{
      latitude: customFeature['lat'],
      longitude: customFeature['lng'],
      name: customFeature['address'],
      desc: customFeature['text']
    }];
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].customFeature', (0, _extends3.default)({}, customFeature, {
      markers: markers,
      markers_json_str: JSON.stringify(markers)
    })));
  };

  this.tapMapDetail = function (event) {
    event.stopPropagation();
    _app.appMethod.tapMapDetail(event);
  };
};

exports.default = MapCustomComponent;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

var _tools = __webpack_require__(6);

__webpack_require__(866);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(SearchCustomComponent, _React$Component);

  function SearchCustomComponent(props) {
    (0, _classCallCheck3.default)(this, SearchCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchCustomComponent.__proto__ || Object.getPrototypeOf(SearchCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }
  /**
   * event
   * sevent 关联的列表组件绑定的事件（可选）
   */


  /**
   * 触发input值的变化
   */


  (0, _createClass3.default)(SearchCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 页面上的数据
       */
      var userInfo = _page.pageInstance.data.userInfo || {}; // 用户信息
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = {};
      /**
       * 组件内容处理
       */
      var content = data.content;
      // 搜索组件类型
      var type = customFeature.searchObject && customFeature.searchObject.type === 'topic' ? '0' : '1';
      var ifLocation = false;
      if (type === '0') {
        var style = data.style;
        // 话题列表搜索组件styleObj特殊处理
        styleObj = (0, _tools.convertStyleData)({
          width: style.width,
          height: style.height,
          background: style.background,
          backgroundColor: style['background-color'] || style['backgroundColor'],
          marginTop: style['margin-top'] || style['marginTop']
        });
      } else {
        styleObj = (0, _tools.convertStyleData)(data.style);
      }
      if (type === '1' && customFeature.ifLocation) {
        ifLocation = true;
      }
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component search type-' + type + ' ' + (ifLocation ? 'has-location' : ''), style: styleObj },
        type === '0' && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'search-input-label' },
            _react2.default.createElement('span', { className: 'ico-moon icon-search' }),
            _react2.default.createElement('input', { className: 'search-input', type: 'text',
              onBlur: function onBlur(e) {
                return _this2.searchForTopicAct(e);
              },
              'data-compindex': this.props.index,
              'data-topic-id': data.customFeature.searchObject.id,
              'data-topic-compindex': data.relateTopicCompIndex,
              placeholder: content.placeholder })
          ),
          !!data.showCenter && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              'div',
              { className: 'search-usercenter', onClick: this.turnToTopicUserCenter },
              _react2.default.createElement('img', { src: userInfo.cover_thumb })
            ),
            _react2.default.createElement('div', { className: 'ico-moon icon-community_notify search-notify', onClick: this.turnToTopicNotify })
          )
        ),
        type === '1' && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          ifLocation && _react2.default.createElement(
            'div',
            { className: 'ico-moon icon-location location',
              onClick: this.turnToSearchPage,
              'data-param': customFeature.ifLocation,
              'data-listid': customFeature.searchObject.customFeature.id
            },
            '\u5168\u56FD'
          ),
          _react2.default.createElement(
            'div',
            { className: 'search-input' },
            _react2.default.createElement('span', { className: 'ico-moon icon-search' }),
            customFeature.searchObject && customFeature.searchObject.type == 'goods-list' && _react2.default.createElement('div', { className: 'fake-search',
              onClick: this.turnToSearchPage,
              'data-form': customFeature.searchObject.customFeature.form,
              'data-listid': customFeature.searchObject.customFeature.id
            }),
            customFeature.searchObject && customFeature.searchObject.type == 'franchisee-list' && _react2.default.createElement('div', { className: 'fake-search',
              onClick: this.turnToFranchiseeSearchPage
            }),
            _react2.default.createElement('input', { type: 'text', value: this.state.keyword, onChange: this.handleChange, placeholder: content.placeholder }),
            customFeature.searchObject && _react2.default.createElement(
              'div',
              { className: 'search-btn',
                onClick: this.searchList,
                'data-compindex': this.props.index,
                'data-listid': customFeature.searchObject.customFeature.id,
                'data-listtype': customFeature.searchObject && customFeature.searchObject.type,
                'data-form': customFeature.searchObject.customFeature.form
              },
              '\u641C\u7D22'
            )
          )
        )
      );
    }
  }]);
  return SearchCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    keyword: ''
  };

  this.init = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var searchObject = compData.customFeature.searchObject;
    if (searchObject && searchObject.type == 'topic') {
      var topicComponentIndex = _app.appMethod.findComponentIndexById(searchObject.customFeature.id);
      if (topicComponentIndex > -1) {
        var _pageInstance$setData;

        var isShowList = pageInstance.data.eles[topicComponentIndex].customFeature.isShowList;
        pageInstance.setData((_pageInstance$setData = {}, (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].searchValue', ''), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].showCenter', isShowList === false ? isShowList : true), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].relateTopicCompIndex', topicComponentIndex), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + topicComponentIndex + '].relateSearchCompIndex', compindex), _pageInstance$setData));
      } else {
        _app.appMethod.showModal({ content: '搜索未找到绑定的话题列表' });
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].searchValue', ''));
      }
    }
  };

  this.searchList = function (event, sevent) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    // 搜索组件的索引
    // 如果sevent存在则event为当前搜索组件的的compindex
    var compindex = !sevent ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var listid = customFeature.searchObject.customFeature.id;
    var listType = customFeature.searchObject.type;
    var form = customFeature.searchObject.customFeature.form;
    var keyword = _this3.state.keyword || '';
    var page = '';

    // 搜索组件绑定的列表组件的索引
    var componentIndex = _app.appMethod.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    // 搜索组件绑定的列表组件的数据
    var componentData = pageInstance.data.eles[componentIndex];
    if (listType == 'group-buy-list') {
      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getGroupBuyList',
        argvs: [componentIndex, {
          param: {
            page: 1,
            status: componentData.selectNum,
            search_value: keyword
          }
        }]
      });
      return;
    } else if (listType == 'news') {
      var _pageInstance$setData3;

      form = componentData.param.form;
      pageInstance.setData((_pageInstance$setData3 = {}, (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + componentIndex + '].pageObj', {
        isLoading: false,
        noMore: false,
        page: 1
      }), (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + componentIndex + '].selectedCateId', ''), (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + componentIndex + '].newslist', []), _pageInstance$setData3));

      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getNewsList',
        argvs: [{
          compindex: componentIndex,
          page: keyword ? -1 : 1,
          search_value: keyword
        }, function (res) {
          if (keyword) {
            setTimeout(function () {
              _app.appMethod.showModal({
                content: '搜索到' + res.data.length + '条资讯'
              });
            }, 0);
          }
        }]
      });
      return;
    }

    var newdata = {};

    // 是否为滚动
    if (sevent) {
      componentData = pageInstance.data.eles[componentIndex];

      page = componentData.curpage + 1;
      // TODO: web端处理
      if (!componentData.is_more && (typeof sevent === 'undefined' ? 'undefined' : (0, _typeof3.default)(sevent)) == 'object' && sevent.type == 'tap') {
        _app.appMethod.showModal({
          content: '已经加载到最后了'
        });
      }

      if (pageInstance.requesting || !componentData.is_more) {
        return;
      }
      pageInstance.requesting = true;
    } else {

      page = 1;

      if (listType === 'list-vessel') {
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].list_data'] = [];
      } else if (listType === 'goods-list') {
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].goods_data'] = [];
      } else if (listType === 'franchisee-list') {
        form = componentData.param.form;
        newdata['eles[' + componentIndex + '].franchisee_data'] = [];
      } else if (listType === 'video-list') {
        form = componentData.param.form;
        newdata['eles[' + componentIndex + '].video_data'] = [];
      } else if (listType === 'dynamic-classify') {
        form = componentData.customFeature.form;
        newdata['eles[' + componentIndex + '].list_data'] = [];
      }
    }
    newdata['eles[' + componentIndex + '].loading'] = true;
    newdata['eles[' + componentIndex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    var url = '/index.php?r=appData/search';
    var param = {
      "search": {
        "data": [{ "_allkey": keyword, "form": form }],
        "app_id": _app.appMethod.getAppId()
      },
      no_wrap: listType === 'video-list' || listType === 'franchisee-list' ? 1 : '',
      page_size: componentData.customFeature.loadingNum || 20,
      page: page
    };

    if (listType === 'franchisee-list') {
      var info = _app.appMethod.getLocationInfo();
      param.search.longitude = info.longitude;
      param.search.latitude = info.latitude;
    }

    _app.appMethod.sendRequest({
      url: url,
      data: param,
      hideLoading: true,
      chain: listType !== 'franchisee-list' ? true : '',
      success: function success(res) {
        var newdata = {};
        if (res.data.length == 0) {
          setTimeout(function () {
            _app.appMethod.showModal({
              content: '没有找到与“' + keyword + '”相关的内容'
            });
          }, 0);
        }
        if (listType === "goods-list") {
          newdata['eles[' + componentIndex + '].goods_data'] = page == 1 ? res.data : componentData.goods_data.concat(res.data);
        } else if (listType === 'list-vessel' || listType == 'dynamic-classify') {
          if (componentData.classifyType == "level1-vertical-withpic" || componentData.classifyType == "level2-vertical-withpic") {
            _app.appMethod.turnToPage('classifyGoodsListPage?form=' + form + '&isShoppingCart=true& isBuyNow=false&search=' + keyword);
          }
          var listField = componentData.listField;
          for (var j in res.data) {
            for (var k in res.data[j].form_data) {
              if (k == 'category') {
                continue;
              }
              if (/region/.test(k)) {
                continue;
              }
              if (k == 'goods_model') {
                res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
              }
              var description = res.data[j].form_data[k];
              if (listField && listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                //没有绑定的字段的富文本置为空
                res.data[j].form_data[k] = '';
              } else if (_app.appMethod.needParseRichText(description)) {
                res.data[j].form_data[k] = _app.appMethod.getWxParseResult(description);
              }
            }
          }
          newdata['eles[' + componentIndex + '].list_data'] = page == 1 ? res.data : componentData.list_data.concat(res.data);
        } else if (listType === 'franchisee-list') {
          for (var index in res.data) {
            var distance = res.data[index].distance;
            res.data[index].distance = util.formatDistance(distance);
          }
          newdata['eles[' + componentIndex + '].franchisee_data'] = page == 1 ? res.data : componentData.franchisee_data.concat(res.data);
        } else if (listType == 'video-list') {
          var rdata = res.data;

          for (var i = 0; i < rdata.length; i++) {
            rdata[i].video_view = _app.appMethod.handlingNumber(rdata[i].video_view);
          }
          newdata['eles[' + componentIndex + '].video_data'] = page == 1 ? rdata : componentData.video_data.concat(rdata);
        }

        newdata['eles[' + componentIndex + '].is_search'] = true;
        newdata['eles[' + componentIndex + '].searchEle'] = compindex;
        newdata['eles[' + componentIndex + '].is_more'] = res.is_more;
        newdata['eles[' + componentIndex + '].curpage'] = res.current_page;
        newdata['eles[' + componentIndex + '].loading'] = false;
        newdata['eles[' + componentIndex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail(err) {
        var newdata = {};
        newdata['eles[' + componentIndex + '].loadingFail'] = true;
        newdata['eles[' + componentIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  };

  this.searchForTopicAct = function (e) {
    var currentTarget = e.currentTarget;
    var dataset = currentTarget.dataset;
    var compindex = dataset.compindex;
    var topicCompIndex = dataset.topicCompindex;
    var search_value = e.target.value;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};

    if (topicCompIndex > -1) {
      var classifyCompIndex = pageInstance.data.eles[topicCompIndex].relateClassifyCompIndex;

      newdata['eles[' + compindex + '].searchValue'] = search_value;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].listParam.section_id'] = '';
      newdata['eles[' + topicCompIndex + '].listParam.category_id'] = '';

      if (classifyCompIndex > -1) {
        newdata['eles[' + classifyCompIndex + '].selectedSectionId'] = '';
        newdata['eles[' + classifyCompIndex + '].selectedCategoryId'] = '';
      }
      newdata['eles[' + topicCompIndex + '].listParam.search_value'] = search_value;
      newdata['eles[' + topicCompIndex + '].listParam.page'] = -1;
      pageInstance.setData(newdata);
      pageInstance.callComponentMethod({
        componentIndex: topicCompIndex,
        methodName: 'getTopListData',
        argvs: [topicCompIndex, pageInstance, function (data) {
          _app.appMethod.showModal({
            content: '搜索到' + data.length + '条话题'
          });
        }]
      });
    } else {
      _app.appMethod.showModal({ content: '搜索未找到绑定的话题列表' });
    }
  };

  this.turnToTopicUserCenter = function (e) {
    _app.appMethod.turnToPage('communityUsercenter?detail=');
  };

  this.turnToTopicNotify = function (e) {
    _app.appMethod.turnToPage('communityNotify?detail=');
  };

  this.turnToFranchiseeSearchPage = function (e) {
    _app.appMethod.turnToPage('franchiseeSearch');
  };

  this.turnToSearchPage = function (e) {
    _app.appMethod.turnToSearchPage(e);
  };

  this.handleChange = function (event) {
    _this3.setState({
      value: event.target.value
    });
  };
};

exports.default = SearchCustomComponent;

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SortCustomComponent;

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(868);

function SortCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);
  /**
   *  组件内容处理
   */
  var content = data.content;
  /**
   * 点击事件
   */
  var sortListFunc = function sortListFunc(event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var listid = dataset.listid;
    var idx = dataset.idx;

    var componentIndex = _app.appMethod.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    var componentData = pageInstance.data.eles[componentIndex];
    var listType = componentData.type;
    var componentParams = null;
    if (listType == 'dynamic-classify') {
      componentParams = {
        param: {
          form: componentData.customFeature.form,
          id: componentData.customFeature.id,
          idx_arr: {
            idx: 'category',
            idx_value: componentData.currentCategory.slice(-1).pop() || ''
          },
          page: 1,
          page_size: 10,
          is_count: 0
        },
        compindex: componentIndex
      };
    } else if (listType == 'group-buy-list') {
      componentParams = {
        param: {
          form: componentData.customFeature.form,
          page: 1,
          status: componentData.selectNum || 0
        },
        compindex: componentIndex
      };
    } else {
      componentParams = {
        param: componentData.param
      };
    }

    componentParams.compindex = componentIndex;
    componentParams.param.page = 1;

    if (idx != 0) {
      componentParams.param.sort_key = dataset.sortkey;
      componentParams.param.sort_direction = dataset.sortdirection;
    } else {
      componentParams.param.sort_key = 'weight';
      componentParams.param.sort_direction = 0;
    }
    var customFeature = componentData.customFeature;
    if (listType == 'goods-list') {
      if (customFeature.controlCheck) {
        componentParams.param.is_integral = 3;
      } else {
        if (customFeature.isIntegral) {
          componentParams.param.is_integral = 1;
        } else {
          componentParams.param.is_integral = 5;
        }
      }
    }
    if (customFeature.source && customFeature.source !== 'none') {
      componentParams.param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }
    if (customFeature.isShowGroupBuyGoods) {
      componentParams.param.is_group_buy = 1;
    }
    if (customFeature.form == 'goods' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      // 显示子店商品(排除子店功能页)
      componentParams['param']['is_app_shop_cate_goods'] = 1;
      componentParams['param']['is_app_shop'] = 1;
    }
    if (dataset.sortkey === 'shop_distance') {
      var locationInfo = _app.appMethod.globalData.locationInfo;
      if (locationInfo.latitude) {
        componentParams.param.latitude = locationInfo.latitude;
        componentParams.param.longitude = locationInfo.longitude;
        _getDateList(dataset, listType, componentParams);
      } else {
        _app.appMethod.getLocation({
          success: function success(res) {
            var latitude = res.latitude,
                longitude = res.longitude;
            if (res.latitude) {
              _app.appMethod.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function success(res) {
                  _app.appMethod.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: recommendAddress,
                    info: res.data
                  });
                }
              });
              componentParams.param.latitude = latitude;
              componentParams.param.longitude = longitude;
              _getDateList(dataset, listType, componentParams);
              return;
            }
            _getDateList(dataset, listType, componentParams);
          },
          fail: function fail(res) {
            _getDateList(dataset, listType, componentParams);
          }
        });
      }
      return;
    }
    _getDateList(dataset, listType, componentParams);
  };
  var _getDateList = function _getDateList(dataset, listType, componentParams) {
    _updateSortStatus(dataset);
    switch (listType) {
      case 'dynamic-classify':
      case 'list-vessel':
        _app.appMethod._sortListVessel(componentParams);
        break;
      case 'group-buy-list':
        pageInstance.callComponentMethod({
          componentIndex: componentParams.compindex,
          methodName: 'getGroupBuyList',
          argvs: [componentParams.compindex, componentParams]
        });
        break;
      case 'goods-list':
        _app.appMethod._sortGoodsList(componentParams);
        break;
      case 'franchisee-list':
        _app.appMethod._sortFranchiseeList(componentParams);
        break;
      case 'video-list':
        _app.appMethod._sortVideoList(componentParams);
        break;
    }
  };

  var _updateSortStatus = function _updateSortStatus(dataset) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var sortCompindex = dataset.compindex;
    var selectSortIndex = dataset.idx;
    var newdata = {};

    newdata['eles[' + sortCompindex + '].customFeature.selected'] = selectSortIndex;
    if (selectSortIndex != 0 && dataset.sortdirection == 1) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 0;
    } else if (selectSortIndex != 0) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 1;
    } else if (selectSortIndex == 0) {
      newdata['eles[' + sortCompindex + '].content[' + selectSortIndex + '].customFeature.sort_direction'] = 0;
    }

    pageInstance.setData(newdata);
  };
  /**
   * 返回组件
   */
  return React.createElement(
    'div',
    { className: 'custom-component sort', style: styleObj },
    React.createElement(
      'div',
      { className: 'container' },
      content.map(function (item, itemIndex) {
        return React.createElement(
          'div',
          { key: itemIndex,
            className: 'item ' + (customFeature.selected == itemIndex ? 'selected' : ''),
            style: customFeature.selected == itemIndex ? { color: customFeature.selectedColor } : null,
            onClick: sortListFunc,
            'data-compindex': props.index,
            'data-listid': data.customFeature.sort_object,
            'data-sortkey': item.customFeature.sort_key,
            'data-sortdirection': item.customFeature.sort_direction,
            'data-idx': itemIndex
          },
          React.createElement(
            'span',
            null,
            item.text
          ),
          itemIndex !== 0 && customFeature.selected == itemIndex && React.createElement(
            'div',
            { className: 'arr-wrap' },
            React.createElement(
              'span',
              { className: 'sort-arr arr-up', style: {
                  color: item.customFeature.sort_direction == 0 ? data.customFeature.selectedColor : '#ddd'
                } },
              '\u25B2'
            ),
            React.createElement(
              'span',
              { className: 'sort-arr arr-down', style: {
                  color: item.customFeature.sort_direction == 1 ? data.customFeature.selectedColor : '#ddd'
                } },
              '\u25BC'
            )
          )
        );
      })
    )
  );
}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _pickerView = __webpack_require__(870);

var _pickerView2 = _interopRequireDefault(_pickerView);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(181);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(872);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CitylocationCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(CitylocationCustomComponent, _React$Component);

  function CitylocationCustomComponent(props) {
    (0, _classCallCheck3.default)(this, CitylocationCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CitylocationCustomComponent.__proto__ || Object.getPrototypeOf(CitylocationCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(CitylocationCustomComponent, [{
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      styleObj['padding'] = 'unset';
      styleObj['lineHeight'] = styleObj['height'];
      /**
       *  组件内容处理
       */
      var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component citylocation' },
        _react2.default.createElement(
          'div',
          {
            className: 'citylocation-input',
            style: styleObj,
            onClick: this.selectLocal,
            'data-compindex': this.props.index
          },
          data.content,
          ': ',
          data.newlocal || data.local || '未选择'
        ),
        data.citylocationHidden && _react2.default.createElement(
          'div',
          { className: 'citylocation-choose' },
          _react2.default.createElement(
            'div',
            { className: 'picker-btn' },
            _react2.default.createElement(
              'span',
              { onClick: this.cancelCity, 'data-compindex': this.props.index },
              '\u53D6\u6D88'
            ),
            _react2.default.createElement(
              'span',
              { onClick: this.submitCity,
                'data-compindex': this.props.index,
                'data-listid': customFeature.citylocation.customFeature.id,
                'data-listtype': customFeature.citylocation.type,
                'data-form': customFeature.citylocation.customFeature.form },
              '\u786E\u5B9A'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'picker-view' },
            _react2.default.createElement(_pickerView2.default, {
              cols: 3,
              data: data.afterAreaList,
              value: data.value || ['', '', ''],
              onChange: this.bindCityChange,
              cascade: true
            })
          )
        )
      );
    }
  }]);
  return CitylocationCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.init = function (compindex, pageInstance) {
    var pageRequestNum = pageInstance.requestNum;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var form = customFeature.citylocation ? customFeature.citylocation.customFeature.form : '';
    pageInstance.data.eles[compindex].citylocationHidden = false;

    var newdata = {};
    newdata['eles[' + compindex + '].value'] = ['', '', ''];
    if (_app.appMethod.globalData.locationInfo.latitude) {
      var info = _app.appMethod.globalData.locationInfo.info;

      newdata['eles[' + compindex + '].local'] = info.address_component.province + ' ' + info.address_component.city + ' ' + info.address_component.district + ' >';
      pageInstance.setData(newdata);
    } else {
      _app.appMethod.getLocation({
        success: function success(res) {
          var latitude = res.latitude,
              longitude = res.longitude;
          if (!latitude) {
            newdata = {};
            newdata['eles[' + compindex + '].local'] = '定位失败';
            pageInstance.setData(newdata);
            return;
          }
          pageInstance.requestNum = pageRequestNum + 1;
          _app.appMethod.sendRequest({
            hideLoading: pageRequestNum++ == 1 ? false : true,
            url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
            data: {
              latitude: latitude,
              longitude: longitude
            },
            success: function success(res) {
              newdata['eles[' + compindex + '].local'] = res.data.address_component.province + ' ' + res.data.address_component.city + ' ' + res.data.address_component.district + ' >';
              pageInstance.setData(newdata);

              _app.appMethod.setLocationInfo({
                latitude: latitude,
                longitude: longitude,
                address: res.data.formatted_addresses.recommend,
                info: res.data
              });
            }
          });
        }
      });
    }
    pageInstance.requestNum = pageRequestNum + 1;
    _app.appMethod.sendRequest({
      hideLoading: pageRequestNum++ == 1 ? false : true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppRegion/getAllExistedDataRegionList&is_xcx=1&form=' + form,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newArea = {};
        newArea['eles[' + compindex + '].areaList'] = res.data;
        pageInstance.setData(newArea);
      }
    });
  };

  this.selectLocal = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compdata = pageInstance.data.eles[compindex];
    var newdata = {};
    newdata['eles[' + compindex + '].citylocationHidden'] = (0, _typeof3.default)(compdata.citylocationHidden) == undefined ? false : !compdata.citylocationHidden;
    if (!compdata.hasIntial) {
      // areaList处理后的数据
      var afterAreaList = [{
        label: '请选择',
        value: '',
        children: [{
          label: '请选择',
          value: '',
          children: [{
            label: '请选择',
            value: ''
          }]
        }]
      }];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = compdata.areaList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var province = _step.value;

          var afterProvice = {};
          afterProvice['label'] = province['name'];
          afterProvice['value'] = province['region_id'];
          afterProvice['children'] = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = province.cities[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var city = _step2.value;

              var afterCity = {};
              afterCity['label'] = city['name'];
              afterCity['value'] = city['region_id'];
              afterCity['children'] = [];
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = city.towns[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var town = _step3.value;

                  var afterTown = {};
                  afterTown['label'] = town['name'];
                  afterTown['value'] = town['region_id'];
                  afterCity['children'].push(afterTown);
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              afterProvice['children'].push(afterCity);
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          afterAreaList.push(afterProvice);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      newdata['eles[' + compindex + '].afterAreaList'] = afterAreaList;
      newdata['eles[' + compindex + '].hasIntial'] = true;
    }
    pageInstance.setData(newdata);
  };

  this.cancelCity = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compdata = pageInstance.data.eles[compindex];
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].citylocationHidden', !compdata.citylocationHidden));
  };

  this.submitCity = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compdata = pageInstance.data.eles[compindex];
    var afterAreaList = compdata.afterAreaList,
        value = compdata.value;

    var newdata = {};
    if (!value || value.length < 3 || !value[2]) {
      _app.appMethod.showModal({ content: '您未选择城市!' });
    } else {
      newdata['eles[' + compindex + '].citylocationHidden'] = !compdata.citylocationHidden;
      var province = afterAreaList.find(function (item) {
        return item.value === value[0];
      });
      var city = province['children'].find(function (item) {
        return item.value === value[1];
      });
      var district = city['children'].find(function (item) {
        return item.value === value[2];
      });
      newdata['eles[' + compindex + '].newlocal'] = province['label'] + city['label'] + district['label'];
      pageInstance.setData(newdata);
      var regionId = value[2];
      _this2._citylocationList(event.currentTarget.dataset, regionId);
    }
  };

  this.bindCityChange = function (value) {
    var compindex = _this2.props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].value', value));
  };

  this._citylocationList = function (dataset, region_id) {
    var listid = dataset.listid;
    var listType = dataset.listtype;
    var form = dataset.form;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var needColumnArr = [];

    var componentIndex = _app.appMethod.findComponentIndexById(listid);
    if (componentIndex === -1) {
      return;
    }
    var componentData = pageInstance.data.eles[componentIndex];
    // 拼团列表 单独处理
    if (listType == 'group-buy-list') {
      pageInstance.callComponentMethod({
        componentIndex: componentIndex,
        methodName: 'getGroupBuyList',
        argvs: [componentIndex, {
          param: {
            page: 1,
            status: componentData.selectNum,
            region_id: region_id
          }
        }]
      });
      return;
    }

    if (listType === 'list-vessel' || listType === 'dynamic-classify') {
      // 动态列表、动态分类
      newdata['eles[' + componentIndex + '].list_data'] = [];
      needColumnArr = componentData.need_column_arr || [];
    } else if (listType === 'goods-list') {
      // 商品列表
      newdata['eles[' + componentIndex + '].goods_data'] = [];
    } else if (listType === 'franchisee-list') {
      // 多商家列表
      newdata['eles[' + componentIndex + '].franchisee_data'] = [];
    }
    newdata['eles[' + componentIndex + '].param.page'] = 1;
    newdata['eles[' + componentIndex + '].loading'] = true;
    newdata['eles[' + componentIndex + '].loadingFail'] = false;
    newdata['eles[' + componentIndex + '].is_more'] = 1;
    pageInstance.setData(newdata);

    var url = '/index.php?r=AppData/GetFormDataList&idx_arr[idx]=region_id&idx_arr[idx_value]=' + region_id + '&extra_cond_arr[latitude]=' + _app.appMethod.globalData.locationInfo.latitude + '&extra_cond_arr[longitude]=' + _app.appMethod.globalData.locationInfo.longitude + '&extra_cond_arr[county_id]=' + region_id;
    var param = {
      form: form
    };
    if (needColumnArr.length) {
      // 优化请求
      param.need_column_arr = needColumnArr;
    }
    _app.appMethod.sendRequest({
      url: url,
      data: param,
      method: 'post',
      hideLoading: true,
      chain: listType === 'franchisee-list' ? true : '',
      success: function success(res) {
        if (res.data.length == 0) {
          setTimeout(function () {
            _app.appMethod.showModal({
              content: '没有找到与所选区域的相关的内容'
            });
          }, 0);
        }
        if (res.status == 0) {
          var _newdata = {};

          if (listType === "goods-list") {
            _newdata['eles[' + componentIndex + '].goods_data'] = res.data;
          } else if (listType === 'list-vessel') {
            if (param.form !== 'form') {
              var listField = pageInstance.data.eles[componentIndex].listField;
              for (var j in res.data) {
                for (var k in res.data[j].form_data) {
                  if (k == 'category') {
                    continue;
                  }
                  if (/region/.test(k)) {
                    continue;
                  }
                  if (k == 'goods_model') {
                    res.data[j].form_data.virtual_price = _app.appMethod.formVirtualPrice(res.data[j].form_data);
                  }
                  if (k == 'distance') {
                    res.data[j].form_data[k] = _util2.default.formatDistance(res.data[j].form_data[k]);
                  }

                  var description = res.data[j].form_data[k];
                  if (listField.indexOf(k) < 0 && /<("[^"]*"|'[^']*'|[^'">])*>/.test(description)) {
                    //没有绑定的字段的富文本置为空
                    res.data[j].form_data[k] = '';
                  } else if (_app.appMethod.needParseRichText(description)) {
                    res.data[j].form_data[k] = _app.appMethod.getWxParseResult(description);
                  }
                }
              }
            }
            _newdata['eles[' + componentIndex + '].list_data'] = res.data;
          } else if (listType === 'franchisee-list') {
            for (var index in res.data) {
              var distance = res.data[index].distance;
              res.data[index].distance = _util2.default.formatDistance(distance);
            }
            _newdata['eles[' + componentIndex + '].franchisee_data'] = res.data;
          } else if (listType === 'dynamic-classify') {
            _newdata['eles[' + componentIndex + '].list_data'] = res.data;
          }

          _newdata['eles[' + componentIndex + '].is_more'] = res.is_more;
          _newdata['eles[' + componentIndex + '].curpage'] = 1;
          _newdata['eles[' + componentIndex + '].loading'] = false;
          _newdata['eles[' + componentIndex + '].loadingFail'] = false;

          pageInstance.setData(_newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + componentIndex + '].loadingFail'] = true;
        newdata['eles[' + componentIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };
};

exports.default = CitylocationCustomComponent;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PickerView = __webpack_require__(871);

var _PickerView2 = _interopRequireDefault(_PickerView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _PickerView2['default'];
module.exports = exports['default'];

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

var _Cascader = __webpack_require__(177);

var _Cascader2 = _interopRequireDefault(_Cascader);

var _MultiPicker = __webpack_require__(93);

var _MultiPicker2 = _interopRequireDefault(_MultiPicker);

var _Picker = __webpack_require__(94);

var _Picker2 = _interopRequireDefault(_Picker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/* tslint:disable:jsx-no-multiline-js */
function getDefaultProps() {
    return {
        prefixCls: 'am-picker',
        pickerPrefixCls: 'am-picker-col',
        cols: 3,
        cascade: true,
        value: [],
        onChange: function onChange() {}
    };
}

var PickerView = function (_React$Component) {
    (0, _inherits3['default'])(PickerView, _React$Component);

    function PickerView() {
        (0, _classCallCheck3['default'])(this, PickerView);

        var _this = (0, _possibleConstructorReturn3['default'])(this, (PickerView.__proto__ || Object.getPrototypeOf(PickerView)).apply(this, arguments));

        _this.isMultiPicker = function () {
            if (!_this.props.data) {
                return false;
            }
            return Array.isArray(_this.props.data[0]);
        };
        _this.getCol = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                pickerPrefixCls = _this$props.pickerPrefixCls,
                indicatorStyle = _this$props.indicatorStyle,
                itemStyle = _this$props.itemStyle;

            var formattedData = _this.isMultiPicker() ? data : [data];
            return formattedData.map(function (col, index) {
                return React.createElement(
                    _Picker2['default'],
                    { key: index, prefixCls: pickerPrefixCls, style: { flex: 1 }, indicatorStyle: indicatorStyle, itemStyle: itemStyle },
                    col.map(function (item) {
                        return React.createElement(
                            _Picker2['default'].Item,
                            { key: item.value, value: item.value },
                            item.label
                        );
                    })
                );
            });
        };
        return _this;
    }

    (0, _createClass3['default'])(PickerView, [{
        key: 'render',
        value: function render() {
            // tslint:disable-next-line:no-this-assignment
            var props = this.props;

            var picker = void 0;
            if (props.cascade) {
                picker = React.createElement(_Cascader2['default'], { prefixCls: props.prefixCls, pickerPrefixCls: props.pickerPrefixCls, data: props.data, value: props.value, onChange: props.onChange, onScrollChange: props.onScrollChange, cols: props.cols, indicatorStyle: props.indicatorStyle, pickerItemStyle: props.itemStyle });
            } else {
                picker = React.createElement(
                    _MultiPicker2['default'],
                    { prefixCls: props.prefixCls, selectedValue: props.value, onValueChange: props.onChange, onScrollChange: props.onScrollChange, style: { flexDirection: 'row' } },
                    this.getCol()
                );
            }
            return picker;
        }
    }]);
    return PickerView;
}(React.Component);

exports['default'] = PickerView;

PickerView.defaultProps = getDefaultProps();
module.exports = exports['default'];

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(874);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewClassifyCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(NewClassifyCustomComponent, _React$Component);

  function NewClassifyCustomComponent(props) {
    (0, _classCallCheck3.default)(this, NewClassifyCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewClassifyCustomComponent.__proto__ || Object.getPrototypeOf(NewClassifyCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(NewClassifyCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var containerStyleObj = {
        // height: `calc(${transformPx2Rem(data.style['height'])} + .3rem)`
      };
      var subContainerStyleObj = {
        backgroundImage: customFeature['background-image'],
        backgroundColor: customFeature['background-color'],
        opacity: customFeature['opacity'],
        fontSize: customFeature['font-size'],
        fontWeight: customFeature['font-weight'],
        fontStyle: customFeature['font-style'],
        textDecoration: customFeature['text-decoration'],
        color: customFeature['color']
      };
      if (customFeature.mode == 2) {
        containerStyleObj['width'] = '80%';
      }
      /**
       *  组件内容处理
       */
      var content = data.content;
      var classifyLevel = data.classifyLevel;
      var selectedIndex = data.selectedIndex;
      var $level1List = function $level1List() {
        return data.classifyData.map(function (item, itemIndex) {
          if (item.category_id == data.selectedCateId) {
            return _react2.default.createElement(
              'div',
              {
                key: itemIndex,
                className: 'new-classify-item selected',
                style: { color: customFeature.selectedColor },
                onClick: _this2.tapNewClassifyRefreshHandler,
                'data-category-id': item.category_id,
                'data-index': itemIndex,
                'data-compindex': _this2.props.index
              },
              _react2.default.createElement(
                'span',
                {
                  className: 'text-span',
                  style: customFeature.mode == 0 ? { backgroundColor: customFeature.selectedColor } : null },
                item.name
              ),
              customFeature.mode == 1 && _react2.default.createElement('span', { className: 'underline' })
            );
          } else {
            return _react2.default.createElement(
              'div',
              { key: itemIndex, className: 'new-classify-item',
                onClick: _this2.tapNewClassifyRefreshHandler,
                'data-category-id': item.category_id,
                'data-index': itemIndex,
                'data-compindex': _this2.props.index
              },
              _react2.default.createElement(
                'span',
                { className: 'text-span' },
                item.name
              )
            );
          };
        });
      };
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component new-classify mode-' + customFeature.mode + ' level-' + classifyLevel, style: styleObj },
        classifyLevel === 1 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'container', style: containerStyleObj },
            $level1List()
          ),
          customFeature.mode == 2 && _react2.default.createElement(
            'div',
            { className: 'newclassify-select-btn', onClick: this.tapShowNewClassifySelect, 'data-compindex': this.props.index },
            _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
          )
        ),
        classifyLevel === 2 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'container' },
            data.classifyData.map(function (item, itemIndex) {
              return _react2.default.createElement(
                'div',
                {
                  key: itemIndex,
                  className: 'new-classify-item ' + (itemIndex == data.selectedIndex ? 'selected' : ''),
                  style: itemIndex == data.selectedIndex ? { color: customFeature.selectedColor } : null,
                  onClick: function onClick(e) {
                    if (item.subclass[0]) {
                      _this2.tapNewClassifyShowSubClassify(e);
                    } else {
                      _this2.tapNewClassifyRefreshHandler(e);
                    }
                  },
                  'data-category-id': item.category_id,
                  'data-index': itemIndex,
                  'data-compindex': _this2.props.index
                },
                item.category_id == '' ? _react2.default.createElement(
                  'span',
                  { className: 'text-span' },
                  '\u5168\u90E8'
                ) : _react2.default.createElement(
                  'span',
                  { className: 'text-span' },
                  item.name
                ),
                item.category_id != '' && item.subclass[0] && _react2.default.createElement('span', { className: 'triangle', style: itemIndex == data.selectedIndex ? { borderTopColor: customFeature.selectedColor } : null }),
                itemIndex != data.classifyData.length - 1 && _react2.default.createElement('span', { className: 'divide-line' })
              );
            })
          ),
          data.showSubClassify && _react2.default.createElement(
            'div',
            { className: 'new-classify-subclassify', style: subContainerStyleObj },
            data.classifyData.map(function (item, itemIndex) {
              return itemIndex == data.selectedIndex && _react2.default.createElement(
                'div',
                { className: 'sub-classify-item-list', key: itemIndex },
                item.subclass.map(function (subItem, subItemIndex) {
                  return _react2.default.createElement(
                    'div',
                    { key: subItemIndex, className: 'sub-classify-item ' + (subItem.category_id == data.selectedCateId ? 'selected' : ''),
                      style: {
                        color: subItem.category_id == data.selectedCateId ? customFeature.selectedColor : '',
                        borderColor: subItem.category_id === data.selectedCateId && data.customFeature.mode == 1 ? data.customFeature.selectedColor : ''
                      },
                      onClick: _this2.tapNewClassifyRefreshHandler,
                      'data-category-id': subItem.category_id,
                      'data-compindex': _this2.props.index
                    },
                    console.log(subItem),
                    _react2.default.createElement(
                      'span',
                      { className: 'text-span', style: {
                          backgroundColor: subItem.category_id === data.selectedCateId && data.customFeature.mode == 0 ? data.customFeature.selectedColor : ''
                        } },
                      subItem.name
                    )
                  );
                })
              );
            })
          )
        ),
        customFeature.mode == 2 && data.showNewClassifySelect && _react2.default.createElement(
          'div',
          { className: 'newclassify-select-wrap' },
          _react2.default.createElement(
            'div',
            { className: 'newclassify-select-main' },
            _react2.default.createElement(
              'div',
              { className: 'newclassify-select-btn', onClick: this.tapShowNewClassifySelect, 'data-compindex': this.props.index },
              _react2.default.createElement('span', { className: 'ico-moon icon-uparrow' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'newclassify-list-wrap' },
              $level1List()
            )
          )
        )
      );
    }
  }]);
  return NewClassifyCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var that = _this3;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var cateReqUrl = '/index.php?r=appData/getCategoryByGroup';
    var cateParam = {
      group_id: customFeature.classifyGroupId
    };
    var refreshCompIndex = _app.appMethod.findComponentIndexById(customFeature.refresh_object);
    if (refreshCompIndex < 0) {
      console.log('该分类组件没有绑定列表');
      return;
    }
    var refreshCompData = pageInstance.data.eles[refreshCompIndex];
    var refresh_form = refreshCompData.customFeature.form;

    if (customFeature.selectClassifyType == 2) {
      var selfClassifyData = customFeature.classifyList || [];
      _this3.initNewClassifyGroup(pageInstance, compindex, selfClassifyData, customFeature, refresh_form);
    } else {
      if (cateParam.group_id === '') {
        ;
        // app.showModal({content: '请绑定分类组'})
        _app.appMethod.showToast({
          title: '分类组件未绑定分类组',
          icon: 'none'
        });
      } else {
        if (cateParam.group_id == -1) {
          cateReqUrl = '/index.php?r=AppData/ListCategory';
          if (['goods', 'appointment', 'waimai', 'tostore', 'group_buy'].indexOf(customFeature.refresh_form) > -1) {
            cateParam = {
              form: 'goods',
              goods_type: (0, _tools.getGoodsTypeByForm)(refresh_form)
            };
          } else {
            cateParam = {
              form: refresh_form
            };
          }
        }
        _app.appMethod.sendRequest({
          hideModal: true,
          hideLoading: true,
          url: cateReqUrl,
          data: cateParam,
          chain: true,
          subshop: pageInstance.franchiseeId || '',
          success: function success(res) {
            var classifyData = [],
                form = '';

            if (cateParam.form) {
              classifyData = res.data;
              form = refresh_form;
            } else {
              classifyData = res.data.item;
              form = res.data.form;
              if (customFeature.isManualAddClassify === true) {
                var compContent = compData.content,
                    newClassifyData = [];
                compContent.forEach(function (co) {
                  var newItem = {};
                  var targetItem = classifyData.find(function (cd) {
                    return cd.category_id == co.firstClassifyId;
                  });
                  if (targetItem) {
                    Object.keys(targetItem).forEach(function (k) {
                      newItem[k] = targetItem[k];
                    });
                    if (co.secondClassifyId > 0 && newItem.subclass.length) {
                      newItem.subclass = newItem.subclass.filter(function (sc) {
                        return sc.category_id == co.secondClassifyId;
                      });
                    } else {
                      newItem.subclass.unshift({
                        category_id: co.firstClassifyId,
                        group_id: newItem.group_id,
                        name: '全部',
                        cover: '',
                        pid: 0,
                        weight: 1
                      });
                    }
                  } else {
                    newItem = {};
                  }
                  newClassifyData.push(newItem);
                });
                classifyData = newClassifyData;
              }
            }

            that.initNewClassifyGroup(pageInstance, compindex, classifyData, customFeature, form);
          }
        });
      }
    }

    var newData = {};
    var page_hasNavBar = pageInstance.data.page_hasNavBar;
    if (page_hasNavBar) {
      newData['eles[' + compindex + '].top'] = _app.appMethod.globalData.topNavBarPaddingTop + 80;
      pageInstance.setData(newData);
    }
  };

  this.initNewClassifyGroup = function (pageIns, compindex, cateData, customFeature, form) {
    var pageInstance = pageIns || _app.appMethod.getAppCurrentPage();
    var classifyData = cateData;
    var classifyLevel = +customFeature.classifyType || 1;
    var selectedIndex = customFeature.selected || 0;
    var categoryId = '';
    var newData = {};

    if (customFeature.selectClassifyType == 2 || customFeature.selectClassifyType == 1 && customFeature.classifyGroupId == -1) {
      if (customFeature.classifyType > 1) {
        classifyData = classifyData.map(function (item) {
          return {
            category_id: item.id,
            group_id: '',
            name: item.name,
            pid: 0,
            subclass: item.subclass && item.subclass.map(function (sitem) {
              return {
                category_id: sitem.id,
                group_id: '',
                name: sitem.name,
                pid: item.id
              };
            }) || []
          };
        });
      } else {
        classifyData = classifyData.map(function (item) {
          return {
            category_id: item.id,
            group_id: '',
            name: item.name,
            pid: 0,
            subclass: []
          };
        });
      }
    }

    if (customFeature.selectClassifyType == 1) {
      if (customFeature.showAllClassify) {
        classifyData = classifyData.filter(function (item) {
          return item.category_id;
        });
        if (classifyLevel === 2) {
          classifyData.forEach(function (item) {
            if (item.subclass[0] && item.subclass[0].category_id == item.category_id) {
              item.subclass = item.subclass.slice(1);
            }
          });
        }
      } else {
        if (classifyData[0] && classifyData[0].category_id) {
          classifyData.unshift({
            category_id: '',
            group_id: '',
            name: '全部',
            pid: 0,
            weight: '',
            subclass: []
          });
        }
        if (classifyLevel === 2) {
          classifyData.forEach(function (item) {
            if (!item.category_id) {
              return;
            }
            if (item.subclass[0] && item.subclass[0].category_id == item.category_id) {
              return;
            }
            item.subclass.unshift({
              category_id: item.category_id,
              group_id: '',
              name: '全部',
              pid: 0,
              weight: '',
              subclass: []
            });
          });
        }
      }
    }

    if (classifyData[selectedIndex]) {
      if (classifyLevel > 1) {
        if (classifyData[selectedIndex].subclass && classifyData[selectedIndex].subclass[0]) {
          categoryId = classifyData[selectedIndex].subclass[0].category_id;
        } else {
          categoryId = classifyData[selectedIndex].category_id;
        }
      } else {
        categoryId = classifyData[selectedIndex].category_id;
      }
    }

    newData['eles[' + compindex + '].classifyData'] = classifyData;
    newData['eles[' + compindex + '].classifyGroupForm'] = form || customFeature.refresh_form;
    newData['eles[' + compindex + '].selectedIndex'] = selectedIndex;
    newData['eles[' + compindex + '].selectedCateId'] = categoryId;
    newData['eles[' + compindex + '].classifyLevel'] = classifyLevel;
    newData['eles[' + compindex + '].showSubClassify'] = false;
    pageInstance.setData(newData);
    _this3.tapNewClassifyRefreshHandler(null, compindex, categoryId, pageInstance);
  };

  this.tapNewClassifyRefreshHandler = function (event, componentIndex, categoryId, pageIn) {
    var pageInstance = pageIn || _app.appMethod.getAppCurrentPage();
    var compindex = componentIndex > -1 ? componentIndex : event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newData = {};
    var eventParams = {
      refresh_object: compData.customFeature.refresh_object,
      index_segment: 'category',
      index_value: categoryId === undefined ? event.currentTarget.dataset.categoryId : categoryId
    };
    if (event && event.currentTarget && event.currentTarget.dataset.index !== undefined) {
      newData['eles[' + compindex + '].selectedIndex'] = event.currentTarget.dataset.index;
    }
    if (compData.showNewClassifySelect) {
      var index = event.currentTarget.dataset.index,
          scrollLeft = 0;
      if (index > 3) {
        scrollLeft = (index - 3) * 150 + 'rpx';
      }
      newData['eles[' + compindex + '].newClassifyScrollLeft'] = scrollLeft;
      _this3.tapShowNewClassifySelect({ currentTarget: { dataset: { compindex: compindex } } });
    }
    newData['eles[' + compindex + '].selectedCateId'] = eventParams.index_value;
    newData['eles[' + compindex + '].showSubClassify'] = false;
    pageInstance.setData(newData);
    _app.appMethod.tapRefreshListHandler(null, eventParams);
  };

  this.tapShowNewClassifySelect = function (e) {
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var showFlag = compData.showNewClassifySelect;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].showNewClassifySelect', !showFlag));
  };

  this.tapNewClassifyShowSubClassify = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var index = event.currentTarget.dataset.index;
    var newdata = {};
    newdata['eles[' + compindex + '].selectedIndex'] = index;
    if (compData.selectedIndex === index) {
      newdata['eles[' + compindex + '].showSubClassify'] = !compData.showSubClassify;
    } else {
      newdata['eles[' + compindex + '].showSubClassify'] = true;
    }
    pageInstance.setData(newdata);
  };
};

exports.default = NewClassifyCustomComponent;

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

__webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(FilterCustomComponent, _React$Component);

  function FilterCustomComponent(props) {
    (0, _classCallCheck3.default)(this, FilterCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FilterCustomComponent.__proto__ || Object.getPrototypeOf(FilterCustomComponent)).call(this, props));

    _this.sortByDefault = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

      var goods_compindex = _app.appMethod.findComponentIndexById(addGroup_object);
      if (goods_compindex === -1) {
        _app.appMethod.showModal({
          content: '找不到关联的列表'
        });
        return;
      }

      var param = pageInstance.data.eles[goods_compindex].param;
      param.sort_key = '';
      param.sort_direction = '';

      newdata['eles[' + compindex + '].tab'] = 0;
      newdata['eles[' + compindex + '].sortKey'] = '';
      newdata['eles[' + compindex + '].sortDirection'] = '';
      newdata['eles[' + goods_compindex + '].curpage'] = 0;
      newdata['eles[' + goods_compindex + '].is_more'] = 1;
      newdata['eles[' + goods_compindex + '].goods_data'] = [];
      newdata['eles[' + goods_compindex + '].param'] = param;

      pageInstance.setData(newdata);

      pageInstance.callComponentMethod({
        componentIndex: goods_compindex,
        methodName: '_goodsScrollFunc',
        argvs: [goods_compindex]
      });
    };

    _this.sortBySales = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

      var goods_compindex = _app.appMethod.findComponentIndexById(addGroup_object);
      if (goods_compindex === -1) {
        _app.appMethod.showModal({
          content: '找不到关联的列表'
        });
        return;
      }
      var param = pageInstance.data.eles[goods_compindex].param;
      param.sort_key = 'sales';
      param.sort_direction = 0;

      newdata['eles[' + compindex + '].tab'] = 1;
      newdata['eles[' + compindex + '].sortKey'] = 'sales';
      newdata['eles[' + compindex + '].sortDirection'] = 0;
      newdata['eles[' + goods_compindex + '].curpage'] = 0;
      newdata['eles[' + goods_compindex + '].is_more'] = 1;
      newdata['eles[' + goods_compindex + '].goods_data'] = [];
      newdata['eles[' + goods_compindex + '].param'] = param;

      pageInstance.setData(newdata);

      pageInstance.callComponentMethod({
        componentIndex: goods_compindex,
        methodName: '_goodsScrollFunc',
        argvs: [goods_compindex]
      });
    };

    _this.pickUpStyle = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var compData = pageInstance.data.eles[compindex];
      if (compData.showPickUpBox) {
        newdata['eles[' + compindex + '].pickUpObj'] = compData.initPickUpObj;
        newdata['eles[' + compindex + '].showPickUpBox'] = false;
        pageInstance.setData(newdata);
        return;
      }
      var pickUpObj = compData.pickUpObj || { '1': 1, '2': 2, '3': 3, '4': 4 };
      var initPickUpObj = JSON.parse(JSON.stringify(pickUpObj));

      // 先处理子店显示点餐类型
      var goods_compindex = _app.appMethod.findComponentIndexById(compData.customFeature.addGroup_object);
      var goods_customFeature = goods_compindex > -1 ? pageInstance.data.eles[goods_compindex].customFeature : {};

      _app.appMethod.getAppECStoreConfig(function (res) {
        newdata['eles[' + compindex + '].tabExpress'] = res.express;
        newdata['eles[' + compindex + '].tabIntraCity'] = res.intra_city;
        newdata['eles[' + compindex + '].tabDelivery'] = res.is_self_delivery;
        newdata['eles[' + compindex + '].tabDining'] = res.dining;

        // 子店不显示点餐类型
        if (goods_customFeature.form === 'goods' && goods_customFeature.isShowFranchiseeGoods) {
          newdata['eles[' + compindex + '].tabDining'] = false;
          pickUpObj = compData.pickUpObj || { '1': 1, '2': 2, '3': 3 };
          initPickUpObj = JSON.parse(JSON.stringify(pickUpObj));
        }

        newdata['eles[' + compindex + '].initPickUpObj'] = initPickUpObj;
        newdata['eles[' + compindex + '].pickUpObj'] = pickUpObj;
        newdata['eles[' + compindex + '].tab'] = 3;
        newdata['eles[' + compindex + '].showPickUpBox'] = true;

        pageInstance.setData(newdata);
      });
    };

    _this.sortByPrice = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var compData = pageInstance.data.eles[compindex];
      var sd = compData.sortDirection;
      var addGroup_object = compData.customFeature.addGroup_object;

      var goods_compindex = _app.appMethod.findComponentIndexById(addGroup_object);
      if (goods_compindex === -1) {
        _app.appMethod.showModal({
          content: '找不到关联的列表'
        });
        return;
      }

      sd = !sd || sd == 0 ? 1 : 0;

      var param = pageInstance.data.eles[goods_compindex].param;
      param.sort_key = 'price';
      param.sort_direction = sd;

      newdata['eles[' + compindex + '].tab'] = 2;
      newdata['eles[' + compindex + '].sortKey'] = 'price';
      newdata['eles[' + compindex + '].sortDirection'] = sd;
      newdata['eles[' + goods_compindex + '].curpage'] = 0;
      newdata['eles[' + goods_compindex + '].is_more'] = 1;
      newdata['eles[' + goods_compindex + '].goods_data'] = [];
      newdata['eles[' + goods_compindex + '].param'] = param;

      pageInstance.setData(newdata);

      pageInstance.callComponentMethod({
        componentIndex: goods_compindex,
        methodName: '_goodsScrollFunc',
        argvs: [goods_compindex]
      });
    };

    _this.filterList = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      pageInstance.setData({
        filterShow: true,
        filterCompindex: compindex
      });
      pageInstance.filterRef.current.show({
        filterShow: true,
        chooseCateId: pageInstance.data.categoryId,
        form: pageInstance.data.classifyGroupForm,
        confirm: function confirm(e) {
          _this.filterConfirm(e);
        }
      });
    };

    _this.selectPickUp = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var pickType = e.currentTarget.dataset.type;
      var pickUpObj = pageInstance.data.eles[compindex].pickUpObj;
      pickUpObj[pickType] = pickUpObj[pickType] ? '' : pickType;

      newdata['eles[' + compindex + '].pickUpObj'] = pickUpObj;

      pageInstance.setData(newdata);
    };

    _this.resetPickBtn = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var pickUpObj = { '1': 1, '2': 2, '3': 3, '4': 4 };

      // 先处理子店显示点餐类型
      var compData = pageInstance.data.eles[compindex];
      var goods_compindex = _app.appMethod.findComponentIndexById(compData.customFeature.addGroup_object);
      var goods_customFeature = goods_compindex > -1 ? pageInstance.data.eles[goods_compindex].customFeature : {};
      // 子店不显示点餐类型
      if (goods_customFeature.form === 'goods' && goods_customFeature.isShowFranchiseeGoods) {
        pickUpObj = { '1': 1, '2': 2, '3': 3 };
      }

      newdata['eles[' + compindex + '].pickUpObj'] = pickUpObj;

      pageInstance.setData(newdata);
    };

    _this.surePickBtn = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      var compData = pageInstance.data.eles[compindex];
      var addGroup_object = compData.customFeature.addGroup_object;

      var goods_compindex = _app.appMethod.findComponentIndexById(addGroup_object);
      if (goods_compindex === -1) {
        _app.appMethod.showModal({
          content: '找不到关联的列表'
        });
        return;
      }

      var pickType = compData.pickUpObj;
      var pickUpArr = [];
      for (var i in pickType) {
        pickType[i] && pickUpArr.push(pickType[i]);
      }

      var param = pageInstance.data.eles[goods_compindex].param;
      param.pick_up_type = pickUpArr;

      newdata['eles[' + compindex + '].showPickUpBox'] = false;
      newdata['eles[' + goods_compindex + '].curpage'] = 0;
      newdata['eles[' + goods_compindex + '].is_more'] = 1;
      newdata['eles[' + goods_compindex + '].goods_data'] = [];
      newdata['eles[' + goods_compindex + '].param'] = param;

      pageInstance.setData(newdata);

      pageInstance.callComponentMethod({
        componentIndex: goods_compindex,
        methodName: '_goodsScrollFunc',
        argvs: [goods_compindex]
      });
    };

    _this.filterConfirm = function (e) {
      var detail = e.detail;
      var hasFilter = detail.leastPrice || detail.mostPrice || detail.chooseCateId || detail.currentRegionId ? true : false;
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = pageInstance.data.filterCompindex;
      var newdata = {};
      var addGroup_object = pageInstance.data.eles[compindex].customFeature.addGroup_object;

      var goods_compindex = _app.appMethod.findComponentIndexById(addGroup_object);
      if (goods_compindex === -1) {
        _app.appMethod.showModal({
          content: '找不到关联的列表'
        });
        return;
      }
      var idx = detail.chooseCateId ? {
        idx: 'category',
        idx_value: detail.chooseCateId
      } : '';
      var param = pageInstance.data.eles[goods_compindex].param;
      param.least_price = detail.leastPrice || '';
      param.most_price = detail.mostPrice || '';
      param.region_id = detail.currentRegionId || '';
      param.idx_arr = idx;

      newdata['eles[' + compindex + '].hasFilter'] = hasFilter;
      newdata['eles[' + goods_compindex + '].curpage'] = 0;
      newdata['eles[' + goods_compindex + '].is_more'] = 1;
      newdata['eles[' + goods_compindex + '].goods_data'] = [];
      newdata['eles[' + goods_compindex + '].param'] = param;

      pageInstance.setData(newdata);

      pageInstance.callComponentMethod({
        componentIndex: goods_compindex,
        methodName: '_goodsScrollFunc',
        argvs: [goods_compindex]
      });
    };

    _this.hideFilterPickUpBox = function (e) {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var compindex = e.currentTarget.dataset.compindex;
      var newdata = {};
      newdata['eles[' + compindex + '].pickUpObj'] = pageInstance.data.eles[compindex].initPickUpObj;
      newdata['eles[' + compindex + '].showPickUpBox'] = false;
      pageInstance.setData(newdata);
    };

    _this.turnToSearchPage = function (e) {
      _app.appMethod.turnToSearchPage(e);
    };

    return _this;
  }

  // 筛选组件 综合排序tab = 0


  // 筛选组件 按销量排序 tab = 1


  // 筛选组件 按取货排序 tab = 3


  // 筛选组件 按价格排序 tab = 2


  // 筛选组件 展示侧边筛选


  // 筛选侧栏确定


  (0, _createClass3.default)(FilterCustomComponent, [{
    key: 'render',
    value: function render() {
      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var searchStyleObj = (0, _tools.convertStyleData)(customFeature.searchStyle.style);
      var sortStyleObj = (0, _tools.convertStyleData)(customFeature.sortStyle.style);
      var colorStyleObj = {
        color: customFeature.selectedColor
      };
      var sortColorStyleObj = {
        color: customFeature.sortStyle.style.color
      };
      var backgroundStyleObj = {
        background: customFeature.selectedColor
      };
      /**
       *  组件内容处理
       */
      var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'custom-component filter', style: styleObj },
          _react2.default.createElement(
            'div',
            { className: 'search-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'search-inner', style: searchStyleObj,
                onClick: this.turnToSearchPage,
                'data-form': 'goods',
                'data-compindex': this.props.index,
                'data-listid': customFeature.addGroup_object
              },
              _react2.default.createElement('span', { className: 'ico-moon icon-search' }),
              customFeature.placeholder
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'tab-wrap', style: sortStyleObj },
            _react2.default.createElement(
              'div',
              { className: 'tab-item',
                style: data.tab == 0 ? colorStyleObj : null,
                onClick: this.sortByDefault,
                'data-compindex': this.props.index
              },
              '\u7EFC\u5408'
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab-item',
                style: data.tab == 1 ? colorStyleObj : null,
                onClick: this.sortBySales,
                'data-compindex': this.props.index
              },
              '\u9500\u91CF'
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab-item pick-up',
                style: data.tab == 3 ? colorStyleObj : null,
                onClick: this.pickUpStyle,
                'data-compindex': this.props.index
              },
              '\u53D6\u8D27',
              _react2.default.createElement('span', { className: 'filter-down' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab-item tab-price',
                style: data.tab == 2 ? colorStyleObj : null,
                onClick: this.sortByPrice,
                'data-compindex': this.props.index
              },
              '\u4EF7\u683C',
              _react2.default.createElement(
                'div',
                { className: 'label' },
                _react2.default.createElement('span', { className: 'filter-up',
                  style: data.tab == 2 && data.sortDirection == 1 ? colorStyleObj : sortColorStyleObj }),
                _react2.default.createElement('span', { className: 'filter-down',
                  style: data.tab == 2 && data.sortDirection == 0 ? colorStyleObj : sortColorStyleObj })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'tab-item',
                style: data.hasFilter ? colorStyleObj : null,
                onClick: this.filterList,
                'data-compindex': this.props.index
              },
              '\u7B5B\u9009',
              _react2.default.createElement('span', { className: 'ico-moon icon-filter-f' })
            )
          ),
          data.showPickUpBox && _react2.default.createElement(
            'div',
            { className: 'pick-up-box' },
            _react2.default.createElement(
              'div',
              { className: 'pick-style-content' },
              data.tabExpress == 1 && _react2.default.createElement(
                'div',
                { style: data.pickUpObj[1] ? colorStyleObj : null,
                  onClick: this.selectPickUp,
                  'data-type': '1',
                  'data-compindex': this.props.index
                },
                '\u5FEB\u9012',
                _react2.default.createElement('span', { className: 'pick-bottom-line',
                  style: data.pickUpObj[1] ? backgroundStyleObj : null }),
                data.pickUpObj[1] && _react2.default.createElement('span', { className: 'ico-moon icon-gou' })
              ),
              data.tabDelivery == 1 && _react2.default.createElement(
                'div',
                { style: data.pickUpObj[3] ? colorStyleObj : null,
                  onClick: this.selectPickUp,
                  'data-type': '3',
                  'data-compindex': this.props.index
                },
                '\u4E0A\u95E8\u81EA\u63D0',
                _react2.default.createElement('span', { className: 'pick-bottom-line',
                  style: data.pickUpObj[3] ? backgroundStyleObj : null }),
                data.pickUpObj[3] && _react2.default.createElement('span', { className: 'ico-moon icon-gou' })
              ),
              data.tabIntraCity == 1 && _react2.default.createElement(
                'div',
                { style: data.pickUpObj[2] ? colorStyleObj : null,
                  onClick: this.selectPickUp,
                  'data-type': '2',
                  'data-compindex': this.props.index
                },
                '\u540C\u57CE\u914D\u9001',
                _react2.default.createElement('span', { className: 'pick-bottom-line',
                  style: data.pickUpObj[2] ? backgroundStyleObj : null }),
                data.pickUpObj[2] && _react2.default.createElement('span', { className: 'ico-moon icon-gou' })
              ),
              data.tabDining == 1 && _react2.default.createElement(
                'div',
                { style: data.pickUpObj[4] ? colorStyleObj : null,
                  onClick: this.selectPickUp,
                  'data-type': '4',
                  'data-compindex': this.props.index
                },
                '\u5802\u98DF\u70B9\u9910',
                _react2.default.createElement('span', { className: 'pick-bottom-line',
                  style: data.pickUpObj[4] ? backgroundStyleObj : null }),
                data.pickUpObj[4] && _react2.default.createElement('span', { className: 'ico-moon icon-gou' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'pick-btn-content' },
              _react2.default.createElement(
                'span',
                { onClick: this.resetPickBtn, 'data-compindex': this.props.index },
                '\u91CD\u7F6E'
              ),
              _react2.default.createElement(
                'span',
                { className: 'sure-pick-btn',
                  style: {
                    background: customFeature.selectedColor
                  },
                  onClick: this.surePickBtn,
                  'data-compindex': this.props.index
                },
                '\u786E\u5B9A'
              )
            )
          )
        ),
        data.showPickUpBox && _react2.default.createElement('div', { className: 'custom-component filter pick-up-mask', onClick: this.hideFilterPickUpBox })
      );
    }
  }]);
  return FilterCustomComponent;
}(_react2.default.Component);

exports.default = FilterCustomComponent;

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(878);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: community-group
 * 组件: 社区团购-社区团购活动列表
 */

var CommunityGroupCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(CommunityGroupCustomComponent, _React$Component);

  function CommunityGroupCustomComponent(props) {
    (0, _classCallCheck3.default)(this, CommunityGroupCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CommunityGroupCustomComponent.__proto__ || Object.getPrototypeOf(CommunityGroupCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  // 根据经纬度获取团长


  // 获取购买记录


  // 判断团长可不可用


  (0, _createClass3.default)(CommunityGroupCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;

      // 样式数据处理
      var styleObj = (0, _tools.convertStyleData)(data.style);

      // 时间轴1
      var $timeLineOne = function $timeLineOne() {
        return _react2.default.createElement(
          'div',
          { className: 'time-line-box',
            onClick: _this3.searchTimeLineActive,
            'data-compindex': _this3.props.index,
            style: {
              background: data.customFeature.timeLineSetting['background'],
              marginTop: data.customFeature.timeLineSetting['margin-top']
            } },
          data.customFeature.timeLineSetting.content.map(function (item, index) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: index },
              item.show && _react2.default.createElement(
                'div',
                { 'data-type': index,
                  style: {
                    fontWeight: data.param && data.param.status == index ? 600 : '',
                    color: data.param && data.param.status == index ? data.customFeature.timeLineSetting['underline-color'] : ''
                  } },
                item.name,
                data.param && data.param.status == index && _react2.default.createElement('span', { className: 'under-line',
                  style: {
                    background: data.customFeature.timeLineSetting['underline-color'],
                    height: data.customFeature.timeLineSetting['underline-height']
                  } })
              )
            );
          })
        );
      };

      // 时间轴2
      var $timeLineTwo = function $timeLineTwo() {
        return _react2.default.createElement(
          'div',
          { className: 'time-line-box',
            onClick: _this3.searchTimeLineActive,
            'data-compindex': _this3.props.index,
            style: {
              background: data.customFeature.timeLineSetting['background'],
              marginTop: data.customFeature.timeLineSetting['margin-top']
            } },
          data.customFeature.timeLineSetting.content.map(function (item, index) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: index },
              item.show && _react2.default.createElement(
                'div',
                { 'data-type': index, className: data.param && data.param.status == index ? 'selected' : '' },
                _react2.default.createElement(
                  'span',
                  { 'data-type': index, style: { background: data.param && data.param.status == index ? data.customFeature.timeLineSetting['slected-color'] : '' } },
                  item.name
                )
              )
            );
          })
        );
      };

      //社区活动列表
      var $activityList = function $activityList() {
        return _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            'scroll-y': 'true',
            className: 'scroll-ele ' + data.type,
            style: { height: data.customFeature.height },
            bindanimationend: 'animationEnd',
            'data-compindex': _this3.props.index,
            'data-type': data.type,
            bindscrolltolower: _this3.communityGroupScrollFunc },
          data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            data.communityGroup_data.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { className: 'community-group-item',
                  key: item.group_id,
                  'data-id': item.group_id,
                  'data-leader-token': item.user_token,
                  'data-longitude': item.leader_info.longitude,
                  'data-latitude': item.leader_info.latitude,
                  'data-status': item.group_info.status == 2,
                  onClick: _this3.toCommunityGroup },
                _react2.default.createElement(
                  'div',
                  { className: 'community-group-title' },
                  _react2.default.createElement(
                    'div',
                    { className: 'group-active-name' },
                    item.group_info.status == 1 && _react2.default.createElement(
                      'label',
                      null,
                      '\u8FDB\u884C\u4E2D'
                    ),
                    item.group_info.status == 2 && _react2.default.createElement(
                      'label',
                      null,
                      '\u5DF2\u7ED3\u675F'
                    ),
                    item.group_info.status == 3 && _react2.default.createElement(
                      'label',
                      null,
                      '\u5373\u5C06\u5F00\u59CB'
                    ),
                    item.group_info.status == 4 && _react2.default.createElement(
                      'label',
                      null,
                      '\u660E\u65E5\u5F00\u59CB'
                    ),
                    item.group_info.status == 5 && _react2.default.createElement(
                      'label',
                      null,
                      '\u66F4\u591A\u9884\u544A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'ellipsis' },
                      item.group_info.title
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'column-time' },
                    _react2.default.createElement('span', { className: 'icon-comTime ico-moon', style: { marginRight: '.09rem', color: item.group_info.status == 2 ? '#d2d2d2' : '#ff7100' } }),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.group_info.start_date,
                      ' - ',
                      item.group_info.end_date
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'group-title-illustration' },
                    item.group_info.illustration
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { whiteSpace: 'nowrap' } },
                  data.communityGroup_data[index].goods_info && data.communityGroup_data[index].goods_info.map(function (item) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'img-content', key: item.id },
                      _react2.default.createElement('img', { src: item.cover }),
                      _react2.default.createElement(
                        'div',
                        { className: 'community-good-price' },
                        '\xA5',
                        item.price
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'community-group-describe' },
                  _react2.default.createElement(
                    'div',
                    { className: 'describe-tag' },
                    '\u6D4F\u89C8\uFF1A',
                    item.group_info.view_count
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'describe-tag' },
                    '\u9500\u91CF\uFF1A',
                    item.group_info.sold_count
                  )
                )
              );
            })
          ),
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          data.is_more == 0 && !(data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info) && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: "暂无社区团购活动~" } }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'communityGroupScrollFunc', compindex: data.compindex } }),
          data.is_more == 0 && !(data.communityGroup_data && data.communityGroup_data[0] && data.communityGroup_data[0].group_info) && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!+data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: data.customFeature, 'data-compindex': _this3.props.index, onClick: _this3.communityGroupScrollFunc })
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component community-group-wrap' },
        _react2.default.createElement(
          'div',
          { className: 'element community-group', style: styleObj },
          data.customFeature.showSearch && _react2.default.createElement(
            'div',
            {
              className: 'search-box',
              style: { height: data.customFeature.searchSetting.height, marginTop: data.customFeature.searchSetting['margin-top'] } },
            _react2.default.createElement(
              'div',
              { className: 'search-input' },
              _react2.default.createElement(_icon2.default, { size: 'xxs', type: 'search', className: 'icon-search' }),
              _react2.default.createElement('input', { type: 'text',
                placeholder: '\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9'
                // TODO  bindconfirm={this.searchGroupList}
                , onBlur: this.searchGroupList,
                'data-compindex': this.props.index })
            )
          ),
          data.customFeature.showGroup && _react2.default.createElement(
            'div',
            { className: 'community-head',
              style: {
                height: data.customFeature.groupSetting.height,
                marginTop: data.customFeature.groupSetting['margin-top'],
                background: data.customFeature.groupSetting.background
              } },
            _react2.default.createElement('img', { className: 'colone-avatar', src: data.leaderInfo && data.leaderInfo.logo || 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/new-zhichi-default.png' }),
            _react2.default.createElement(
              'div',
              { className: 'colone-detail-box' },
              _react2.default.createElement(
                'div',
                { className: 'colone-name',
                  style: {
                    color: data.customFeature.groupSetting['group-color'],
                    fontSize: data.customFeature.groupSetting['group-font-size']
                  } },
                data.leaderInfo && data.leaderInfo.nick_name ? data.leaderInfo.nick_name + '-' : '暂无团长',
                data.leaderInfo && data.leaderInfo.housing_estate
              ),
              _react2.default.createElement(
                'div',
                { className: 'colone-address',
                  style: {
                    color: data.customFeature.groupSetting['address-color'],
                    fontSize: data.customFeature.groupSetting['address-font-size']
                  } },
                '\u81EA\u63D0\u5730\u5740\uFF1A',
                data.leaderInfo && data.leaderInfo.address_detail || "暂未设置"
              )
            ),
            data.customFeature.groupSetting.changeCaptain && _react2.default.createElement(
              'div',
              {
                className: 'change-captain',
                'data-compindex': this.props.index,
                onClick: data.leaderInfo ? this.chengeCommunityGroup : this.isOpenCommunityGroup,
                style: {
                  color: data.customFeature.groupSetting['btn-color'],
                  background: data.customFeature.groupSetting['btn-background']
                } },
              _react2.default.createElement('span', { className: 'ico-moon icon-change' }),
              data.leaderInfo ? '切换团长' : '申请团长'
            ),
            data.buyerInfoList && !!data.buyerInfoList.length && _react2.default.createElement(
              'div',
              { className: 'scroll-avatar-box' },
              _react2.default.createElement(
                'div',
                { className: 'community-buyer-scrollling' },
                data.buyerInfoList[data.buyerIndex] && _react2.default.createElement(
                  'div',
                  { className: 'scroll-avatar' },
                  _react2.default.createElement('img', { src: data.buyerInfoList[data.buyerIndex].buyer_info.logo }),
                  _react2.default.createElement(
                    'span',
                    { className: 'scroll-name' },
                    data.buyerInfoList[data.buyerIndex].buyer_info.nickname
                  ),
                  '\u4E0B\u5355\u6210\u529F\u4E86'
                )
              )
            )
          ),
          data.customFeature.timeLineSetting && data.customFeature.timeLineSetting.timeLineStyle == 1 && data.customFeature.showTimeline && $timeLineOne(),
          data.customFeature.timeLineSetting && data.customFeature.timeLineSetting.timeLineStyle == 2 && data.customFeature.showTimeline && $timeLineTwo(),
          $activityList()
        )
      );
    }
  }]);
  return CommunityGroupCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.isOpenCommunityGroup = function () {
    _app.appMethod._isOpenCommunityGroup();
  };

  this.init = function (compindex, pageInstance) {
    // 获取购买记录
    _this4.getGoodsIdxList(compindex);
    var _this = _this4;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var locationInfo = _app.appMethod.globalData.locationInfo;
    var param = {};
    if (customFeature.groupSetting && customFeature.groupSetting.height.indexOf('rem') < 0) {
      customFeature.groupSetting.height = parseInt(customFeature.groupSetting.height) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['margin-top'] = parseInt(customFeature.groupSetting['margin-top']) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['address-font-size'] = parseInt(customFeature.groupSetting['address-font-size']) / 100 * 2.34 + 'rem';
      customFeature.groupSetting['group-font-size'] = parseInt(customFeature.groupSetting['group-font-size']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting.height = parseInt(customFeature.timeLineSetting.height) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['margin-top'] = parseInt(customFeature.timeLineSetting['margin-top']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['underline-height'] = parseInt(customFeature.timeLineSetting['underline-height']) / 100 * 2.34 + 'rem';
      customFeature.timeLineSetting['font-size'] = parseInt(customFeature.timeLineSetting['font-size']) / 100 * 2.34 + 'rem';
      customFeature.searchSetting.height = parseInt(customFeature.searchSetting.height) / 100 * 2.34 + 'rem';
      customFeature.searchSetting['margin-top'] = parseInt(customFeature.searchSetting['margin-top']) / 100 * 2.34 + 'rem';
      var newData = {};
      newData['eles[' + compindex + '].customFeature'] = customFeature;
      pageInstance.setData(newData);
    }
    if (customFeature.showTimeline) {
      var timeLineContent = customFeature.timeLineSetting.content;
      for (var i = 0; i < timeLineContent.length; i++) {
        if (timeLineContent[i].show) {
          param.status = i;
          break;
        }
      }
    } else {
      if (customFeature.startActive && !customFeature.finishActive) {
        param.status = 5;
      } else if (!customFeature.startActive && customFeature.finishActive) {
        param.status = 6;
      } else if (customFeature.startActive && customFeature.finishActive) {
        param.status = 7;
      } else if (!customFeature.startActive && !customFeature.finishActive) {
        param.status = 0;
      }
    }
    // 切换团长后不需要重新请求团长列表
    if (pageInstance.data.eles[compindex].leaderInfo) {
      _this.getCommunityActiveList(compindex, param);
      return;
    }
    // 判断分享进来的团长可不可用
    if (_app.appMethod.globalData.communityUserToken) {
      _this4.checkGroupLeader(compindex, param, _app.appMethod.globalData.communityUserToken);
      return;
    }
    // 获取上一次团长 如果没有上一次团长则就近获取团长
    _app.appMethod.getStorage({
      key: 'groupToken',
      complete: function complete(res) {
        if (res && res.data) {
          _this.checkGroupLeader(compindex, param, res.data);
        } else if (locationInfo.latitude) {
          _this.latitude = locationInfo.latitude;
          _this.longitude = locationInfo.longitude;
          _this.getGroupList(compindex, param);
        } else {
          _app.appMethod.getLocation({
            type: 'gcj02',
            success: function success(res) {
              var latitude = res.latitude;
              var longitude = res.longitude;
              pageInstance.requestNum++;
              _app.appMethod.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function success(res) {
                  _app.appMethod.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: res.data.formatted_addresses.recommend,
                    info: res.data
                  });
                }
              });
              _this.latitude = latitude;
              _this.longitude = longitude;
              _this.getGroupList(compindex, param);
            },
            fail: function fail(res) {
              var newdata = {};
              if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
                newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
              } else {
                newdata['eles[' + compindex + '].location_address'] = '定位失败';
              }
              pageInstance.setData(newdata);
            }
          });
        }
      }
    });
  };

  this.getGroupList = function (compindex, param) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetDistributorExtList',
      method: 'post',
      data: {
        latitude: _this4.latitude,
        longitude: _this4.longitude,
        is_audit: 1,
        filter_deleted: 1
      },
      success: function success(res) {
        if (res.data.length) {
          var data = {};
          data['eles[' + compindex + '].leaderInfo'] = res.data[0];
          _app.appMethod.setStorage({
            key: 'groupToken',
            data: res.data[0].user_token
          });
          pageInstance.setData(data);
        }
        _this.getCommunityActiveList(compindex, param);
      }
    });
  };

  this.getCommunityActiveList = function (compindex, param) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var newdata = {};
    if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
      newdata['eles[' + compindex + '].customFeature.height'] = 'auto';
    } else {
      if (customFeature.height.indexOf('rpx') < 0) {
        newdata['eles[' + compindex + '].customFeature.height'] = parseInt(customFeature.height) * 2.34 + 'rpx';
      }
    }
    param.page_size = customFeature.loadingNum || 10;
    newdata['eles[' + compindex + '].param'] = param;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].communityGroup_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 1;
    pageInstance.setData(newdata);
    var leaderToken = pageInstance.data.eles[compindex].leaderInfo ? pageInstance.data.eles[compindex].leaderInfo.user_token : '';
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetGroupsByDistance',
      method: 'post',
      data: {
        idx_arr: {
          idx: 'title',
          idx_value: param.idx_value || ''
        },
        is_stock_gte_zero: customFeature.soldOut ? 1 : '',
        status: param.status >= 0 ? param.status + 1 : '',
        page_size: param.page_size,
        page: 1,
        leader_token: leaderToken
      },
      success: function success(res) {
        var data = {};
        if (!res.data.length) {
          data['eles[' + compindex + '].loading'] = false;
          data['eles[' + compindex + '].communityGroup_data'] = [];
          data['eles[' + compindex + '].is_more'] = 0;
          pageInstance.setData(data);
          return;
        }
        data['eles[' + compindex + '].communityGroup_data'] = res.data;
        data['eles[' + compindex + '].is_more'] = res.is_more;
        data['eles[' + compindex + '].curpage'] = res.current_page;
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function fail() {
        var dataFail = {};
        dataFail['eles[' + compindex + '].loadingFail'] = true;
        dataFail['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dataFail);
      }
    });
  };

  this.communityGroupScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = compData.curpage + 1;
    var newdata = {};
    var param = {
      idx_arr: {
        idx: 'title',
        idx_value: compData.param && compData.param.idx_value || ''
      },
      status: compData.param.status >= 0 ? compData.param.status + 1 : '',
      page_size: compData.param.page_size,
      page: curpage,
      leader_token: pageInstance.data.eles[compindex].leaderInfo.user_token
    };
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetGroupsByDistance',
      data: param,
      method: 'post',
      hideLoading: true,
      success: function success(res) {
        newdata = {};
        newdata['eles[' + compindex + '].communityGroup_data'] = [].concat((0, _toConsumableArray3.default)(compData.communityGroup_data), (0, _toConsumableArray3.default)(res.data));
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      fail: function fail() {
        newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.chengeCommunityGroup = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var token = pageInstance.data.eles[compindex].leaderInfo.user_token;
    var router = _app.appMethod.returnSubPackageRouter("communityGroupSearchVillage");
    _app.appMethod.turnToPage(router + '?token=' + token + '&compindex=' + compindex);
  };

  this.toCommunityGroup = function (e) {
    var id = e.currentTarget.dataset.id;
    var leader_token = e.currentTarget.dataset.leaderToken || '';
    var isOnlineTime = e.currentTarget.dataset.status;
    var latitude = e.currentTarget.dataset.latitude;
    var longitude = e.currentTarget.dataset.longitude;
    var router = _app.appMethod.returnSubPackageRouter("communityGroupGoodDetail") + ('?id=' + id + '&leader_token=' + leader_token + '&latitude=' + latitude + '&longitude=' + longitude);
    if (!isOnlineTime) {
      _app.appMethod.turnToPage(router);
    } else {
      _app.appMethod.showModal({
        content: '活动已结束'
      });
    }
  };

  this.searchTimeLineActive = function (event) {
    var currentTarget = event.currentTarget.dataset;
    var compindex = currentTarget.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var param = {
      status: event.target.dataset.type
    };
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      _app.appMethod.showModal({
        content: '暂无团长，无法搜索'
      });
      return;
    }
    _this4.getCommunityActiveList(compindex, param);
  };

  this.searchGroupList = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var value = event.target.value;
    var param = pageInstance.data.eles[compindex].param;
    param.idx_value = value;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      _app.appMethod.showModal({
        content: '暂无团长，无法搜索'
      });
      return;
    }
    _this4.getCommunityActiveList(compindex, param, pageInstance);
  };

  this.getGoodsIdxList = function (compindex) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsIdxList',
      success: function success(res) {
        var _pageInstance$setData;

        pageInstance.setData((_pageInstance$setData = {}, (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].buyerIndex', 0), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].buyerInfoList', res.data || []), _pageInstance$setData));
        if (res.data.length) {
          _this.cycleGroupBuyerList(compindex);
        }
      }
    });
  };

  this.cycleGroupBuyerList = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindexParam = pageInstance.data.eles[compindex];
    if (compindexParam.buyerIndex < 0) {
      return;
    }
    setInterval(function () {
      var index = compindexParam.buyerIndex;
      var buyerInfoList = compindexParam.buyerInfoList;
      index++;
      if (index == buyerInfoList.length - 1) {
        index = 0;
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].buyerIndex', index));
    }, 8000);
  };

  this.checkGroupLeader = function (compindex, param, userToken) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/CheckIsDistributorGroupLeaderInfo',
      data: {
        leader_token: userToken
      },
      success: function success(res) {
        var newdata = {};
        if (!res.data.learder_info) {
          _app.appMethod.globalData.communityUserToken = '';
          _app.appMethod.removeStorage({
            key: 'groupToken',
            complete: function complete() {
              _this.init(compindex, pageInstance);
            }
          });
          return;
        }
        newdata['eles[' + compindex + '].leaderInfo'] = res.data.learder_info;
        pageInstance.setData(newdata);
        _this.getCommunityActiveList(compindex, param);
      }
    });
  };
};

exports.default = CommunityGroupCustomComponent;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(880);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'exchange-coupon'
 * 组件：可兑换券组件
 */
var ExchangeCouponCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(ExchangeCouponCustomComponent, _React$Component);

  function ExchangeCouponCustomComponent(props) {
    (0, _classCallCheck3.default)(this, ExchangeCouponCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExchangeCouponCustomComponent.__proto__ || Object.getPrototypeOf(ExchangeCouponCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(ExchangeCouponCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          _data$list_data = data.list_data,
          list_data = _data$list_data === undefined ? [] : _data$list_data;
      var margin = customFeature.margin,
          lineBackgroundColor = customFeature.lineBackgroundColor,
          secColor = customFeature.secColor;

      secColor = secColor.replace(/;+/g, '');

      /**
       * @desc 优惠券列表
       */
      var couponItem = function couponItem(item, index) {
        return _react2.default.createElement(
          'div',
          { className: 'exchange-coupon-wrapper', style: { backgroundColor: lineBackgroundColor } },
          item.stock != 0 && _react2.default.createElement('div', { className: 'exchange-coupon-linetop', style: { backgroundColor: item.stock != 0 ? secColor : '#cccccc' } }),
          _react2.default.createElement(
            'div',
            { className: 'exchange-coupon-top' },
            _react2.default.createElement(
              'div',
              { className: 'exchange-coupon-left' },
              _react2.default.createElement(
                'div',
                { className: 'exchange-coupon-left-first' },
                item.title
              ),
              _react2.default.createElement(
                'div',
                { className: 'exchange-coupon-left-second', style: { color: item.stock == 0 ? '#333' : '' } },
                item.exchange_condition.price > 0 && _react2.default.createElement(
                  'span',
                  null,
                  '\xA5',
                  item.exchange_condition.price
                ),
                item.exchange_condition.price > 0 && item.exchange_condition.integral > 0 && _react2.default.createElement(
                  'span',
                  null,
                  '+'
                ),
                item.exchange_condition.integral > 0 && _react2.default.createElement(
                  'span',
                  null,
                  item.exchange_condition.integral,
                  '\u79EF\u5206'
                )
              )
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'exchange-coupon-right',
                style: { backgroundColor: secColor },
                'data-coinid': item.id,
                'data-limitnum': item.limit_num,
                'data-userrecvnum': item.user_recv_num,
                'data-index': index,
                'data-status': item.recv_status,
                'data-money': item.exchange_condition.price,
                'data-compindex': _this2.props.index,
                onClick: function onClick(e) {
                  _this2.getexchangeCoupon(e);e.stopPropagation();
                } },
              item.stock != 0 && item.user_recv_num == 0 ? '立即兑换' : '再次兑换'
            ),
            item.stock == 0 && _react2.default.createElement(
              'div',
              { className: 'exchange-coupon-right-used' },
              '\u5DF2\u62A2\u5B8C'
            ),
            counponIcon(item),
            _react2.default.createElement('div', { className: 'exchange-coupon-icon-wrapper', style: { borderColor: item.stock != 0 ? secColor : '#ccc' } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'exchange-coupon-bottom' },
            item.expire == '-1' && _react2.default.createElement(
              'span',
              { className: 'exchange-coupon-expire-time' },
              '\u6709\u6548\u671F ',
              item.start_use_date,
              '\u81F3',
              item.end_use_date,
              ' ',
              item.exclude_holiday == 0 ? '' : '除去法定节假日',
              ' ',
              item.exclude_weekend == 0 ? '' : '周一至周五',
              ' ',
              item.start_use_time,
              '-',
              item.end_use_time
            ),
            item.expire != '-1' && _react2.default.createElement(
              'span',
              { className: 'exchange-coupon-expire-time' },
              '\u6709\u6548\u671F ',
              item.expire == '0' ? '领取当天生效,有效期1天' : '领取' + (item.react > 0 ? item.react + '天后' : '当天') + '生效，有效期' + item.expire + '天',
              item.exclude_holiday == 0 ? '' : '除去法定节假日',
              ' ',
              item.exclude_weekend == 0 ? '' : '周一至周五',
              ' ',
              item.start_use_time,
              '-',
              item.end_use_time
            )
          )
        );
      };

      /**
       * @desc 优惠券类型图标icon
       */
      var counponIcon = function counponIcon(item) {
        var type = {
          0: '减', 1: '折', 2: '代',
          3: '兑', 4: '储', 5: '通',
          6: '次'
        };
        return _react2.default.createElement(
          'div',
          { className: 'exchange-coupon-icon ' + (item.stock == 0 ? 'exchange-coupon-icon-used' : ''), style: { backgroundColor: secColor } },
          _react2.default.createElement(
            'div',
            null,
            type[item.type]
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component exchange-coupon' },
        list_data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            {
              className: 'exchange-coupon-item background-ele',
              key: item.id,
              style: { marginBottom: margin + 'px' },
              'data-compindex': _this2.props.index,
              'data-id': item.id,
              'data-status': item.recv_status,
              onClick: _this2.turnToexchangeCouponDetail },
            couponItem(item, index)
          );
        }),
        !list_data.length && _react2.default.createElement(
          'div',
          { className: 'no-data' },
          _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/request-none.png' }),
          _react2.default.createElement(
            'p',
            null,
            '\u4F60\u8FD8\u672A\u6DFB\u52A0\u53EF\u5151\u6362\u4F18\u60E0\u5238~'
          )
        )
      );
    }
  }]);
  return ExchangeCouponCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var param = {};
    var url = '/index.php?r=AppShop/getCoupons';
    var fieldData = {};

    param.in_show_list = 1;
    param.enable_status = 1;
    param.stock = 1;
    param.exchangeable = 1;
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    param.is_integral = customFeature.isIntegral ? 1 : 0;

    fieldData['eles[' + compindex + '].param'] = param;
    fieldData['eles[' + compindex + '].loading'] = true;
    fieldData['eles[' + compindex + '].loadingFail'] = false;
    fieldData['eles[' + compindex + '].list_data'] = [];
    fieldData['eles[' + compindex + '].is_more'] = 1;
    fieldData['eles[' + compindex + '].curpage'] = 0;
    pageInstance.setData(fieldData);

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: url,
      data: param,
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          var newdata = {};
          newdata['eles[' + compindex + '].list_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.exchangeCouponScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = compData.curpage + 1;
    var customFeature = compData.customFeature;
    var newdata = {};
    var param = {};
    if (!compData.is_more && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
      _app.appMethod.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    param = compData.param;
    param.page_size = +customFeature.loadingNum || 10;

    param.page = curpage;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getCoupons',
      data: param,
      method: 'post',
      hideLoading: true,
      success: function success(res) {
        newdata = {};
        var rdata = res.data,
            downcountArr = pageInstance.downcountArr || [];

        for (var i = 0; i < rdata.length; i++) {
          var f = rdata[i],
              dc = void 0,
              idx = (curpage - 1) * param.page_size + i;

          f.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00'
          };
          if (f.seckill_start_state == 0) {
            dc = _app.appMethod.beforeSeckillDownCount(f, pageInstance, compindex + '.list_data[' + idx + ']');
          } else if (f.seckill_start_state == 1) {
            dc = _app.appMethod.duringSeckillDownCount(f, pageInstance, compindex + '.list_data[' + idx + ']');
          }
          dc && downcountArr.push(dc);
        }
        newdata['eles[' + compindex + '].list_data'] = compData.list_data.concat(res.data);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.downcountArr = downcountArr;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  };

  this.turnToexchangeCouponDetail = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    _app.appMethod.globalData.exchangeCouponStyle = compData;
    var dataset = event.currentTarget.dataset;
    var id = dataset.id;
    var recv_status = dataset.status;
    // if (recv_status == 0) {
    //   app.showModal({content: '超过可兑换次数'});
    //   return
    // }
    _app.appMethod.turnToPage('/exchangeCoupon/pages/exchangeCouponDetail/exchangeCouponDetail?id=' + id);
  };

  this.getexchangeCoupon = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    _app.appMethod.globalData.exchangeCouponStyle = compData;
    var coinid = dataset.coinid;
    var index = dataset.index;
    var recv_status = dataset.status;
    var money = dataset.money ? +dataset.money : 0;
    var limitNum = dataset.limitnum ? +dataset.limitnum : 0;
    var userRecvNum = dataset.userrecvnum ? +dataset.userrecvnum : 0;

    if (recv_status == 0) {
      _app.appMethod.showModal({ content: '超过可兑换次数' });
      return;
    }
    if (money && money > 0) {
      _app.appMethod.turnToPage('/exchangeCoupon/pages/exchangeCouponDetailOrder/exchangeCouponDetailOrder?id=' + coinid);
      return;
    }
    _app.appMethod.showModal({
      title: '是否确认兑换？',
      content: '注：兑换成功后不支持退换',
      showCancel: true,
      cancelText: "否",
      confirmText: "是",
      confirm: function confirm() {
        _this3.checkexchangeCoupon(coinid, compindex, index, limitNum, userRecvNum);
      }
    });
  };

  this.checkexchangeCoupon = function (coinid, compindex, index, limitNum, userRecvNum) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      url: '/index.php?r=appCoupon/addCouponOrder',
      data: {
        'id': coinid
      },
      method: 'post',
      hideLoading: true,
      success: function success(res) {
        _app.appMethod.showToast({
          title: '兑换成功',
          icon: 'none',
          duration: 1000
        });
        if (limitNum >= userRecvNum + 1) {
          var newdata = {};
          newdata['eles[' + compindex + '].list_data[' + index + '].user_recv_num'] = userRecvNum + 1;
          pageInstance.setData(newdata);
        } else {
          var _newdata = {};
          _newdata['eles[' + compindex + '].list_data[' + index + '].recv_status'] = 0;
          pageInstance.setData(_newdata);
        }
      },
      complete: function complete(res) {
        // if (res.status === 0) {
        //   return
        // }
        // let newdata = {};
        // newdata[id+'.list_data[' + index + '].recv_status'] = 0
        // pageInstance.setData(newdata);
      }
    });
  };
};

exports.default = ExchangeCouponCustomComponent;

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(882);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'row-num'
 * 组件：排号组件
 */
var RowNumCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(RowNumCustomComponent, _React$Component);

  function RowNumCustomComponent(props) {
    (0, _classCallCheck3.default)(this, RowNumCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RowNumCustomComponent.__proto__ || Object.getPrototypeOf(RowNumCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(RowNumCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          currentRowNumberData = data.currentRowNumberData,
          numberTypeData = data.numberTypeData,
          isShowTakeNumberWindow = data.isShowTakeNumberWindow,
          isShowCancelWindow = data.isShowCancelWindow,
          selectRowNumberTypeId = data.selectRowNumberTypeId;
      var lineBackgroundColor = customFeature.lineBackgroundColor,
          picBorderRadius = customFeature.picBorderRadius,
          secColor = customFeature.secColor;

      /**
       * @desc 数据初始化
       */

      currentRowNumberData = currentRowNumberData || { count_info: [] };
      numberTypeData = numberTypeData || { additional_info: {} };
      isShowTakeNumberWindow = !!isShowTakeNumberWindow;
      isShowCancelWindow = !!isShowCancelWindow;

      /**
       * @desc 头部内容
       */
      var topWrap = function topWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'row-number-top', style: { backgroundColor: currentRowNumberData.id || numberTypeData.status == 1 ? lineBackgroundColor : '#838383' } },
          !currentRowNumberData.id && _react2.default.createElement(
            'div',
            { className: 'number-top-title' },
            '\u5C1A\u672A\u53D6\u53F7'
          ),
          currentRowNumberData.id && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'number-top-title' },
              currentRowNumberData.line_up_type_data.name,
              currentRowNumberData.queue_num_name
            ),
            _react2.default.createElement(
              'div',
              { className: 'wait-content' },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('span', { className: 'color-round', style: { backgroundColor: secColor } }),
                currentRowNumberData.status == 4 ? '已过号' : '\u8FD8\u8981\u7B49\u5F85: ' + currentRowNumberData.head_wait_num + '\u4E2A\u53F7'
              ),
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement('span', { className: 'color-round', style: { backgroundColor: secColor } }),
                '\u9884\u8BA1\u7B49\u5F85: ',
                currentRowNumberData.status == 4 ? '--' : (currentRowNumberData.prepare_wait_time > numberTypeData.max_display_time ? '>' + numberTypeData.max_display_time : currentRowNumberData.prepare_wait_time) + '分钟'
              )
            )
          )
        );
      };

      /**
       * @desc 底部内容
       */
      var bottomWrap = function bottomWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'row-number-bottom' },
          _react2.default.createElement(
            'div',
            { className: 'number-bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'number-refresh', onClick: function onClick(e) {
                  return _this2.rowNumberRefresh(e);
                }, style: { backgroundColor: secColor } },
              _react2.default.createElement('span', { className: 'ico-moon icon-row-number-refresh' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'bottom-content-title' },
              _react2.default.createElement(
                'div',
                null,
                '\u7C7B\u578B'
              ),
              _react2.default.createElement(
                'div',
                null,
                '\u524D\u65B9\u6392\u961F'
              ),
              _react2.default.createElement(
                'div',
                null,
                !currentRowNumberData.id ? '预计时间' : '当前进度'
              )
            ),
            currentRowNumberData.count_info.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: 'content-type' },
                  _react2.default.createElement(
                    'span',
                    null,
                    item.line_up_type_name
                  ),
                  item.accept_range.enable == 1 && _react2.default.createElement(
                    'span',
                    null,
                    item.accept_range.from,
                    '-',
                    item.accept_range.to,
                    '\u4EBA'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  item.head_wait_num
                ),
                (currentRowNumberData.id || numberTypeData.status != 0) && _react2.default.createElement(
                  'div',
                  { className: 'estimated-time' },
                  !currentRowNumberData.id ? item.prepare_wait_time > 0 ? (item.prepare_wait_time > numberTypeData.max_display_time ? '>' + numberTypeData.max_display_time : item.prepare_wait_time) + '分钟' : '无需等待' : item.earliest_queue_num_name || '--',
                  item.prepare_wait_time <= 0 && !currentRowNumberData.id && _react2.default.createElement('div', { className: 'row-number-round', style: { backgroundColor: lineBackgroundColor } })
                ),
                !currentRowNumberData.id && numberTypeData.status == 0 && _react2.default.createElement(
                  'div',
                  null,
                  '- -'
                )
              );
            })
          ),
          !numberTypeData.status && _react2.default.createElement(
            'div',
            { className: 'no-open-row-number' },
            '\u5546\u5BB6\u6682\u672A\u5F00\u542F\u53D6\u53F7\u529F\u80FD'
          ),
          _react2.default.createElement(
            'div',
            { className: 'number-bottom-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'number-tips' },
              numberTypeData.additional_info.info
            ),
            currentRowNumberData.id ? _react2.default.createElement(
              'div',
              { className: 'take-number-box' },
              _react2.default.createElement(
                'span',
                {
                  style: { color: lineBackgroundColor, borderColor: lineBackgroundColor, borderRadius: picBorderRadius },
                  'data-compindex': _this2.props.index,
                  onClick: _this2.showCancelWindow },
                '\u53D6\u6D88\u6392\u53F7'
              ),
              _react2.default.createElement(
                'span',
                {
                  style: { backgroundColor: lineBackgroundColor, borderRadius: picBorderRadius },
                  'data-order-id': currentRowNumberData.order_id,
                  onClick: _this2.goToCheckRowNumberDetail },
                '\u67E5\u770B\u53F7\u5355'
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'take-number',
                style: { backgroundColor: numberTypeData.status == 1 ? lineBackgroundColor : '#838383', borderRadius: picBorderRadius },
                'data-compindex': _this2.props.index,
                onClick: numberTypeData.status == 1 ? _this2.showTakeNumberWindow : null },
              numberTypeData.status == 1 ? '取号' + (numberTypeData.line_up_price > 0 ? ' ¥' + numberTypeData.line_up_price : '') : '暂停取号'
            )
          )
        );
      };

      /**
       * @desc 取号弹窗
       */
      var takeNumberWindow = function takeNumberWindow() {
        return _react2.default.createElement(
          'div',
          { className: 'take-number-contain' },
          _react2.default.createElement(
            'div',
            { className: 'take-number-head', style: { backgroundColor: lineBackgroundColor } },
            _react2.default.createElement('span', { className: 'color-round', style: { backgroundColor: secColor } }),
            '\u8BF7\u9009\u62E9\u6392\u53F7\u7C7B\u578B',
            _react2.default.createElement('span', { className: 'color-round', style: { backgroundColor: secColor } })
          ),
          _react2.default.createElement(
            'div',
            { className: 'take-number-content' },
            numberTypeData.line_up_type_info.map(function (item) {
              return _react2.default.createElement(
                'div',
                { key: item.id,
                  className: 'take-number-type ' + (selectRowNumberTypeId == item.id ? 'active' : ''),
                  style: { background: selectRowNumberTypeId == item.id ? lineBackgroundColor : '' },
                  'data-id': item.id,
                  'data-compindex': _this2.props.index,
                  onClick: _this2.selectRowNumberType },
                _react2.default.createElement(
                  'span',
                  null,
                  item.name
                ),
                item.accept_range.enable == 1 && _react2.default.createElement(
                  'span',
                  null,
                  '(',
                  item.accept_range.from,
                  '-',
                  item.accept_range.to,
                  '\u4EBA)'
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'take-number-bottom' },
            _react2.default.createElement(
              'div',
              {
                'data-compindex': _this2.props.index,
                onClick: _this2.hideTakeNumberWindow },
              '\u53D6\u6D88'
            ),
            _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                'button',
                { type: 'button',
                  style: { color: lineBackgroundColor },
                  'data-compindex': _this2.props.index,
                  onClick: numberTypeData.line_up_price > 0 ? _this2.goToPreviewRowNumberOrder : _this2.sureTakeNumber },
                '\u786E\u8BA4',
                numberTypeData.line_up_price > 0 ? '¥' + numberTypeData.line_up_price : ''
              )
            )
          )
        );
      };

      /**
       * @desc 取消取号弹窗
       */
      var cancelNumberWindow = function cancelNumberWindow() {
        return _react2.default.createElement(
          'div',
          { className: 'cancel-window-box' },
          _react2.default.createElement(
            'div',
            { className: 'cancel-window-content' },
            '\u53D6\u6D88\u540E\u60A8\u7684\u6392\u53F7\u4FE1\u606F\u65E0\u6CD5\u6062\u590D\u6392\u53F7\u8D39\u5C06\u9000\u6B3E\u3002\u786E\u5B9A\u53D6\u6D88\uFF1F'
          ),
          _react2.default.createElement(
            'div',
            { className: 'cancel-window-btn' },
            _react2.default.createElement(
              'span',
              {
                'data-order-id': currentRowNumberData.order_id,
                'data-compindex': _this2.props.index,
                onClick: _this2.cancelCheckRowNumber },
              '\u53D6\u6D88\u6392\u53F7'
            ),
            _react2.default.createElement(
              'span',
              {
                style: { color: lineBackgroundColor },
                'data-compindex': _this2.props.index,
                onClick: _this2.hideCancelWindow },
              '\u7EE7\u7EED\u6392\u53F7'
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component row-num' },
        _react2.default.createElement(
          'div',
          { id: 'row-number' },
          topWrap(),
          bottomWrap()
        ),
        isShowTakeNumberWindow && _react2.default.createElement(
          'div',
          { className: 'take-number-window' },
          takeNumberWindow()
        ),
        isShowCancelWindow && _react2.default.createElement(
          'div',
          { className: 'take-num-cancel-window' },
          cancelNumberWindow()
        )
      );
    }
  }]);
  return RowNumCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    _this3.isOpenRowNumber(compindex, pageInstance);
  };

  this.isOpenRowNumber = function (compindex, pageInstance) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      data: {
        sub_app_id: _app.appMethod.getPageFranchiseeId()
      },
      success: function success(res) {
        newData['eles[' + compindex + '].numberTypeData'] = res.data;
        pageInstance.setData(newData);
        _toast2.default.hide();
        _this3.rowNumber(pageInstance, compindex);
      }
    });
  };

  this.rowNumber = function (pageInstance, compindex) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppTostore/getLiningUpQueueByUserToken',
      data: {
        sub_app_id: _app.appMethod.getPageFranchiseeId()
      },
      method: 'post',
      success: function success(res) {
        newData['eles[' + compindex + '].currentRowNumberData'] = res.data;
        pageInstance.setData(newData);
      }
    });
  };

  this.rowNumberRefresh = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    _toast2.default.loading('加载中', 0);
    _this3.isOpenRowNumber(compindex, pageInstance);
  };

  this.showCancelWindow = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].isShowCancelWindow'] = true;
    pageInstance.setData(newData);
  };

  this.goToCheckRowNumberDetail = function (e) {
    var orderId = e.currentTarget.dataset.orderId;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.turnToPage('/orderMeal/pages/checkRowNumberDetail/checkRowNumberDetail?orderId=' + orderId + (franchiseeId ? '&franchisee=' + franchiseeId : ''));
  };

  this.showTakeNumberWindow = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].selectRowNumberTypeId'] = '';
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = true;
    pageInstance.setData(newData);
  };

  this.selectRowNumberType = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].selectRowNumberTypeId'] = e.currentTarget.dataset.id;
    pageInstance.setData(newData);
  };

  this.hideTakeNumberWindow = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
    pageInstance.setData(newData);
  };

  this.goToPreviewRowNumberOrder = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var id = pageInstance.data.eles[compindex].selectRowNumberTypeId;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    var newData = {};
    if (!id) {
      _app.appMethod.showToast({
        title: '请选择排号类型',
        icon: 'none'
      });
      return;
    }
    newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
    pageInstance.setData(newData);
    _app.appMethod.turnToPage('/orderMeal/pages/previewRowNumberOrder/previewRowNumberOrder?detail=' + id + (franchiseeId ? '&franchisee=' + franchiseeId : ''));
  };

  this.sureTakeNumber = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    var compData = pageInstance.data.eles[compindex];
    var id = compData.selectRowNumberTypeId;
    if (!id) {
      _app.appMethod.showToast({
        title: '请选择排号类型',
        icon: 'none'
      });
      return;
    }
    if (compData.isClick) {
      return;
    }
    newData['eles[' + compindex + '].isClick'] = true;
    pageInstance.setData(newData);
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppTostore/addLineUpOrder',
      data: {
        line_up_type_id: id,
        formId: e.detail.formId,
        total_price: 0,
        sub_app_id: _app.appMethod.getPageFranchiseeId()
      },
      method: 'post',
      success: function success(res) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: res.data,
            total_price: 0
          },
          success: function success(res) {
            newData = {};
            newData['eles[' + compindex + '].isClick'] = false;
            newData['eles[' + compindex + '].isShowTakeNumberWindow'] = false;
            pageInstance.setData(newData);
            _this3.isOpenRowNumber(compindex, pageInstance);
            _app.appMethod.showToast({
              title: '取号成功，请耐心等待',
              icon: 'none'
            });
          }
        });
      }
    });
  };

  this.cancelCheckRowNumber = function (e) {
    var orderId = e.currentTarget.dataset.orderId;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppTostore/lineUpOrderRefund',
      method: 'post',
      data: {
        order_id: orderId,
        sub_app_id: _app.appMethod.getPageFranchiseeId()
      },
      success: function success(res) {
        _this3.isOpenRowNumber(compindex, pageInstance);
        newData['eles[' + compindex + '].isShowCancelWindow'] = false;
        pageInstance.setData(newData);
      }
    });
  };

  this.hideCancelWindow = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].isShowCancelWindow'] = false;
    pageInstance.setData(newData);
  };
};

exports.default = RowNumCustomComponent;

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = __webpack_require__(144);

var _tabs2 = _interopRequireDefault(_tabs);

var _activityIndicator = __webpack_require__(213);

var _activityIndicator2 = _interopRequireDefault(_activityIndicator);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(214);

__webpack_require__(215);

__webpack_require__(27);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

var _tools = __webpack_require__(6);

__webpack_require__(886);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "takeout" 
 * 组件：外卖组件
 * TODO: 购物车加菜减菜待完成；评价列表待完成；店铺信息待完成；
 */

var TakeoutCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TakeoutCustomComponent, _React$Component);

  function TakeoutCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TakeoutCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TakeoutCustomComponent.__proto__ || Object.getPrototypeOf(TakeoutCustomComponent)).call(this, props));

    _this.state = {
      takeOutInfo: {},
      category: [],
      goodsList: [],
      AssessList: [],
      categoryName: '',
      loading: false,
      selectId: '',
      selectIndex: 0
    };

    _this.getTakeOutInfo = function () {
      var param = {
        app_id: (0, _global.getAppId)()
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/getTakeOutInfo',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            _this.setState({
              takeOutInfo: res.data
            });
            resolve();
          }
        });
      });
    };

    _this.getCategory = function () {
      var param = {
        app_id: (0, _global.getAppId)(),
        goods_type: 2,
        filter_null: 1
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/getGoodsCategory',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            if (res.data.length !== 0) {
              _this.setState({
                category: res.data
              });
              resolve();
            }
          }
        });
      });
    };

    _this.getGoodsList = function () {
      _this.setState({ loading: true });
      var option = {
        idx_arr: {
          idx: 'category',
          idx_value: _this.state.selectId === 'all' ? '' : _this.state.selectId // 传all的时候替换为'';
        }
      };
      var param = (0, _extends3.default)({
        app_id: (0, _global.getAppId)(),
        goods_type: 2,
        form: 'takeout',
        page: 1,
        page_size: 10,
        is_integral: 5,
        sort_key: '',
        sort_direction: 0
      }, option);
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/GetGoodsList',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            _this.setState({
              goodsList: res.data,
              loading: false
            });
            resolve();
          }
        });
      });
    };

    _this.getAssessList = function () {
      var param = {
        app_id: (0, _global.getAppId)(),
        goods_type: 2,
        page: 1,
        page_size: 10
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/getAssessList',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            _this.setState({
              AssessList: res.data
            });
            resolve();
          }
        });
      });
    };

    _this.switchCategory = function (id, name, index) {
      if (_this.state.selectId !== id || _this.state.selectIndex !== index) {
        _this.setState({ selectId: id, selectIndex: index, categoryName: name, goodsList: [] }, function () {
          _this.getGoodsList();
        });
      }
    };

    return _this;
  }

  (0, _createClass3.default)(TakeoutCustomComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      console.log(data);
      // 组件配置对象
      var customFeature = data.customFeature;
      var content = data.content;

      this.getTakeOutInfo().then(function () {
        if (customFeature.databind === '1') {
          _this2.getCategory().then(function () {
            _this2.setState({
              selectId: _this2.state.category[0]['id'],
              categoryName: _this2.state.category[0]['name']
            });
            _this2.getGoodsList();
          });
        } else {
          _this2.setState({
            selectId: content[0]['source'],
            categoryName: content[0]['text']
          });
          _this2.getGoodsList();
        }
      });
    }

    // 获取外卖店铺信息


    // 获取外卖商品分类信息


    // 获取外卖商品信息


    // 获取评论列表 

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 商品分类
      var content = data.content;
      var tabs = [{ title: '商品' }, { title: '评价' }, { title: '店铺' }];
      // 组件样式
      var topStyle = (0, _tools.cssObj2DomObj)(customFeature.style);
      var logoRadius = (0, _tools.transformPx2Rem)(customFeature.logoRadius);
      var categoryStyle = (0, _tools.convertStyleData)(customFeature.leftSpan);
      categoryStyle['paddingLeft'] = (0, _tools.transformPx2Rem)(customFeature.typeLeft, 320);
      var selectStyle = {
        backgroundColor: customFeature.selectedBackgroundColor,
        color: customFeature.selectedColor,
        borderLeft: '4px solid #ff7100',
        paddingLeft: (0, _tools.transformPx2Rem)(customFeature.typeLeft, 320)
      };
      var underlineStyle = {
        border: '1px solid #ff7100',
        transform: 'scale(0.5, 1)'
      };
      return _react2.default.createElement(
        'div',
        { className: 'custom-component takeout' },
        customFeature.showShopInfo && _react2.default.createElement(
          'div',
          { className: 'header' },
          customFeature.mode == '0' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-0' },
            _react2.default.createElement(
              'div',
              { className: 'info-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'logo', style: { borderRadius: logoRadius } },
                _react2.default.createElement('img', { src: this.state.takeOutInfo.logo, alt: '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'msg', style: { color: customFeature.storeSecColor } },
                  '\u8D77\u9001\u4EF7\xA5',
                  this.state.takeOutInfo.min_deliver_price,
                  _react2.default.createElement(
                    'span',
                    null,
                    '|'
                  ),
                  '\u914D\u9001\u8D39\xA5',
                  this.state.takeOutInfo.deliver_fee,
                  _react2.default.createElement(
                    'span',
                    null,
                    '|'
                  ),
                  this.state.takeOutInfo.deliver_time,
                  '\u5206\u949F\u9001\u8FBE'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'activity', style: { color: customFeature.storeSecColor } },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u6682\u65E0\u5546\u5BB6\u6D3B\u52A8'
                  ),
                  _react2.default.createElement(_icon2.default, { type: 'right', size: 'xxs' })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          customFeature.mode == '1' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-1' },
            _react2.default.createElement(
              'div',
              { className: 'top', style: topStyle },
              _react2.default.createElement(
                'div',
                { className: 'logo', style: { borderRadius: logoRadius } },
                _react2.default.createElement('img', { src: this.state.takeOutInfo.logo, alt: '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'msg', style: { color: customFeature.storeSecColor } },
                '\u8D77\u9001\u4EF7\xA5',
                this.state.takeOutInfo.min_deliver_price,
                _react2.default.createElement(
                  'span',
                  null,
                  '|'
                ),
                '\u914D\u9001\u8D39\xA5',
                this.state.takeOutInfo.deliver_fee,
                _react2.default.createElement(
                  'span',
                  null,
                  '|'
                ),
                this.state.takeOutInfo.deliver_time,
                '\u5206\u949F\u9001\u8FBE'
              ),
              _react2.default.createElement(
                'div',
                { className: 'activity', style: { color: customFeature.storeSecColor } },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u6682\u65E0\u5546\u5BB6\u6D3B\u52A8'
                ),
                _react2.default.createElement(_icon2.default, { type: 'right', size: 'xxs' })
              )
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          customFeature.mode == '2' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-2' },
            _react2.default.createElement('div', { className: 'top', style: topStyle }),
            _react2.default.createElement(
              'div',
              { className: 'info' },
              _react2.default.createElement(
                'div',
                { className: 'msg', style: { color: customFeature.storeSecColor } },
                '\u8D77\u9001\u4EF7\xA5',
                this.state.takeOutInfo.min_deliver_price,
                _react2.default.createElement(
                  'span',
                  null,
                  '|'
                ),
                '\u914D\u9001\u8D39\xA5',
                this.state.takeOutInfo.deliver_fee,
                _react2.default.createElement(
                  'span',
                  null,
                  '|'
                ),
                this.state.takeOutInfo.deliver_time,
                '\u5206\u949F\u9001\u8FBE'
              ),
              _react2.default.createElement(
                'div',
                { className: 'activity', style: { color: customFeature.storeSecColor } },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u6682\u65E0\u5546\u5BB6\u6D3B\u52A8'
                ),
                _react2.default.createElement(_icon2.default, { type: 'right', size: 'xxs' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'logo', style: { borderRadius: logoRadius } },
              _react2.default.createElement('img', { src: this.state.takeOutInfo.logo, alt: '' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tab' },
          _react2.default.createElement(
            _tabs2.default,
            { tabs: tabs,
              tabBarActiveTextColor: '#ff7100',
              tabBarUnderlineStyle: underlineStyle
            },
            _react2.default.createElement(
              'div',
              { className: 'goods-wrap', style: { height: '100%' } },
              _react2.default.createElement(
                'div',
                { className: 'sort-list' },
                customFeature.databind === '0' && content.map(function (categoryData, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'sort-item',
                      key: index,
                      onClick: function onClick() {
                        return _this3.switchCategory(categoryData.source, categoryData.text, index);
                      },
                      style: _this3.state.selectIndex === index ? selectStyle : categoryStyle
                    },
                    categoryData.text
                  );
                }),
                customFeature.databind === '1' && this.state.category.map(function (categoryData, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'sort-item',
                      key: index,
                      onClick: function onClick() {
                        return _this3.switchCategory(categoryData.id, categoryData.name);
                      },
                      style: _this3.state.selectId === categoryData.id ? selectStyle : categoryStyle
                    },
                    categoryData.name
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-list' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-sort' },
                  this.state.categoryName
                ),
                _react2.default.createElement(_activityIndicator2.default, { animating: this.state.loading, size: 'large' }),
                this.state.goodsList.map(function (goodsData) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'goods-type', key: goodsData.form_data.id },
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-item' },
                      _react2.default.createElement('img', { src: goodsData.form_data.cover, alt: '' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-top' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            goodsData.form_data.title
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'sales' },
                            '\u9500\u91CF\uFF1A',
                            goodsData.form_data.sales
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-bottom' },
                          _react2.default.createElement(
                            'div',
                            { className: 'price' },
                            _react2.default.createElement(
                              'span',
                              { className: 'real-price' },
                              '\uFFE5',
                              goodsData.form_data.goods_price
                            ),
                            customFeature.isShowVirtualPrice && _react2.default.createElement(
                              'span',
                              { className: 'virtual-price' },
                              '\uFFE5',
                              goodsData.form_data.virtual_price
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'buy-btn' },
                            '+'
                          )
                        )
                      )
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'assess-wrap', style: { height: '500px' } },
              this.state.AssessList.length === 0 && _react2.default.createElement(
                'div',
                { className: 'no-assess' },
                _react2.default.createElement('img', { src: 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png', alt: '' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u6682\u65E0\u4EFB\u4F55\u8BC4\u4EF7'
                )
              ),
              this.state.AssessList.length !== 0 && _react2.default.createElement('div', { className: 'assess-list' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'shop-wrap', style: { height: '500px' } },
              _react2.default.createElement(
                'div',
                { className: 'merchant-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'info-title' },
                  '\u5546\u5BB6\u4FE1\u606F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-fesadress' }),
                    this.state.takeOutInfo.address_detail
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-tokeout-info' }),
                    this.state.takeOutInfo.description
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-sales-num' }),
                    '\u6708\u552E',
                    this.state.takeOutInfo.total_sales,
                    '\u4EFD'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-business-time' }),
                    '\u8425\u4E1A\u65F6\u95F4\u4E3A\uFF1A00:00-23:59'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'delivery-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'info-title' },
                  '\u914D\u9001\u4FE1\u606F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'delivery-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'info-item' },
                      _react2.default.createElement('i', { className: 'icon-distribution' }),
                      '\u5546\u5BB6\u914D\u9001'
                    ),
                    _react2.default.createElement('div', { className: 'item-desc' })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom' },
          _react2.default.createElement(
            'div',
            { className: 'money-count' },
            _react2.default.createElement(
              'div',
              { className: 'cart-wrap' },
              _react2.default.createElement('i', { className: 'icon icon-fn-cart' })
            ),
            _react2.default.createElement(
              'div',
              null,
              '\u8BF7\u9009\u62E9\u5546\u54C1'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'order-btn' },
            '\u8FD8\u5DEE25\u5143\u8D77\u9001'
          )
        )
      );
    }
  }]);
  return TakeoutCustomComponent;
}(_react2.default.Component);

exports.default = TakeoutCustomComponent;

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tabs = __webpack_require__(144);

var _tabs2 = _interopRequireDefault(_tabs);

var _activityIndicator = __webpack_require__(213);

var _activityIndicator2 = _interopRequireDefault(_activityIndicator);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _toast = __webpack_require__(12);

var _toast2 = _interopRequireDefault(_toast);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(214);

__webpack_require__(215);

__webpack_require__(13);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _global = __webpack_require__(42);

var _http = __webpack_require__(36);

var _tools = __webpack_require__(6);

__webpack_require__(888);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "tostore" 
 * 组件：到店组件
 * TODO: 购物车加菜减菜待完成；评价列表待完成；店铺信息待完成；
 */

var TostoreCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TostoreCustomComponent, _React$Component);

  function TostoreCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TostoreCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TostoreCustomComponent.__proto__ || Object.getPrototypeOf(TostoreCustomComponent)).call(this, props));

    _this.state = {
      storeInfo: {},
      category: [],
      goodsList: [],
      AssessList: [],
      categoryName: '',
      loading: false,
      selectId: '',
      selectIndex: 0
    };

    _this.getStoreInfo = function () {
      var param = {
        app_id: (0, _global.getAppId)()
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/GetTostoreWaitingRule',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            _this.setState({
              storeInfo: res.data
            });
            resolve();
          }
        });
      });
    };

    _this.getCategory = function () {
      var param = {
        app_id: (0, _global.getAppId)(),
        goods_type: 3,
        filter_null: 1
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/getGoodsCategory',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            if (res.data.length !== 0) {
              _this.setState({
                category: res.data
              });
              resolve();
            }
          }
        });
      });
    };

    _this.getGoodsList = function () {
      _this.setState({ loading: true });
      var option = {
        idx_arr: {
          idx: 'category',
          idx_value: _this.state.selectId === 'all' ? '' : _this.state.selectId // 传all的时候替换为'';
        }
      };
      var param = (0, _extends3.default)({
        app_id: (0, _global.getAppId)(),
        goods_type: 2,
        form: 'tostore',
        page: 1,
        page_size: 10,
        is_integral: 5,
        sort_key: '',
        sort_direction: 0
      }, option);
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/GetGoodsList',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            _this.setState({
              goodsList: res.data,
              loading: false
            });
            resolve();
          }
        });
      });
    };

    _this.getAssessList = function () {
      var param = {
        app_id: (0, _global.getAppId)(),
        goods_type: 2,
        page: 1,
        page_size: 10
      };
      return new Promise(function (resolve) {
        (0, _http.ajax)({
          url: '/index.php?r=AppShop/getAssessList',
          data: param,
          success: function success(res) {
            if (res.status !== 0) {
              _toast2.default.info(res.data);
              return;
            }
            console.log(res.datta);
            _this.setState({
              AssessList: res.data
            });
            resolve();
          }
        });
      });
    };

    _this.switchCategory = function (id, name, index) {
      if (_this.state.selectId !== id || _this.state.selectIndex !== index) {
        _this.setState({ selectId: id, selectIndex: index, categoryName: name, goodsList: [] }, function () {
          _this.getGoodsList();
        });
      }
    };

    return _this;
  }

  (0, _createClass3.default)(TostoreCustomComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      console.log(data);
      // 组件配置对象
      var customFeature = data.customFeature;
      var content = data.content;

      this.getStoreInfo().then(function () {
        if (customFeature.databind === '1') {
          _this2.getCategory().then(function () {
            _this2.setState({
              selectId: _this2.state.category[0]['id'],
              categoryName: _this2.state.category[0]['name']
            });
            _this2.getGoodsList();
          });
        } else {
          _this2.setState({
            selectId: content[0]['source'],
            categoryName: content[0]['text']
          });
          _this2.getGoodsList();
        }
      });
    }

    // 获取到店店铺信息


    // 获取到店商品分类信息


    // 获取到店商品信息


    // 获取评论列表 

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 商品分类
      var content = data.content;
      var tabs = [{ title: '商品' }, { title: '评价' }, { title: '店铺' }];
      // 组件样式
      var topStyle = (0, _tools.cssObj2DomObj)(customFeature.style);
      var logoRadius = (0, _tools.transformPx2Rem)(customFeature.logoRadius);
      var categoryStyle = (0, _tools.convertStyleData)(customFeature.leftSpan);
      categoryStyle['paddingLeft'] = (0, _tools.transformPx2Rem)(customFeature.typeLeft, 320);
      var selectStyle = {
        backgroundColor: customFeature.selectedBackgroundColor,
        color: customFeature.selectedColor,
        borderLeft: '4px solid #ff7100',
        paddingLeft: (0, _tools.transformPx2Rem)(customFeature.typeLeft, 320)
      };
      var underlineStyle = {
        border: '1px solid #ff7100',
        transform: 'scale(0.5, 1)'
      };
      return _react2.default.createElement(
        'div',
        { className: 'custom-component tostore' },
        customFeature.showShopInfo && _react2.default.createElement(
          'div',
          { className: 'header' },
          customFeature.mode == '0' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-0' },
            _react2.default.createElement(
              'div',
              { className: 'info-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'logo', style: { borderRadius: logoRadius } },
                _react2.default.createElement('img', { src: this.state.storeInfo.logo, alt: '' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'msg', style: { color: customFeature.storeSecColor } },
                  '\u8425\u4E1A\u65F6\u95F4\u4E3A\uFF1A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'address', style: { color: customFeature.storeSecColor } },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u5E97\u94FA\u5730\u5740\uFF1A',
                    this.state.storeInfo.address_detail
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          customFeature.mode == '1' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-1' },
            _react2.default.createElement(
              'div',
              { className: 'top', style: topStyle },
              _react2.default.createElement(
                'div',
                { className: 'logo', style: { borderRadius: logoRadius } },
                _react2.default.createElement('img', { src: this.state.storeInfo.logo, alt: '' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'msg', style: { color: customFeature.storeSecColor } },
                '\u8425\u4E1A\u65F6\u95F4\u4E3A\uFF1A'
              ),
              _react2.default.createElement(
                'div',
                { className: 'address', style: { color: customFeature.storeSecColor } },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u5E97\u94FA\u5730\u5740\uFF1A',
                  this.state.storeInfo.address_detail
                )
              )
            ),
            _react2.default.createElement('div', { className: 'line' })
          ),
          customFeature.mode == '2' && _react2.default.createElement(
            'div',
            { className: 'shop-desc-mode-2' },
            _react2.default.createElement('div', { className: 'top', style: topStyle }),
            _react2.default.createElement(
              'div',
              { className: 'info' },
              _react2.default.createElement(
                'div',
                { className: 'msg', style: { color: customFeature.storeSecColor } },
                '\u8425\u4E1A\u65F6\u95F4\u4E3A\uFF1A'
              ),
              _react2.default.createElement(
                'div',
                { className: 'address', style: { color: customFeature.storeSecColor } },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u5E97\u94FA\u5730\u5740\uFF1A',
                  this.state.storeInfo.address_detail
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'logo', style: { borderRadius: logoRadius } },
              _react2.default.createElement('img', { src: this.state.storeInfo.logo, alt: '' })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tab' },
          _react2.default.createElement(
            _tabs2.default,
            { tabs: tabs,
              tabBarActiveTextColor: '#ff7100',
              tabBarUnderlineStyle: underlineStyle
            },
            _react2.default.createElement(
              'div',
              { className: 'goods-wrap', style: { height: '100%' } },
              _react2.default.createElement(
                'div',
                { className: 'sort-list' },
                customFeature.databind === '0' && content.map(function (categoryData, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'sort-item',
                      key: index,
                      onClick: function onClick() {
                        return _this3.switchCategory(categoryData.source, categoryData.text, index);
                      },
                      style: _this3.state.selectIndex === index ? selectStyle : categoryStyle
                    },
                    categoryData.text
                  );
                }),
                customFeature.databind === '1' && this.state.category.map(function (categoryData, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'sort-item',
                      key: index,
                      onClick: function onClick() {
                        return _this3.switchCategory(categoryData.id, categoryData.name);
                      },
                      style: _this3.state.selectId === categoryData.id ? selectStyle : categoryStyle
                    },
                    categoryData.name
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-list' },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-sort' },
                  this.state.categoryName
                ),
                _react2.default.createElement(_activityIndicator2.default, { animating: this.state.loading, size: 'large' }),
                this.state.goodsList.map(function (goodsData) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'goods-type', key: goodsData.form_data.id },
                    _react2.default.createElement(
                      'div',
                      { className: 'goods-item' },
                      _react2.default.createElement('img', { src: goodsData.form_data.cover, alt: '' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'goods-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-top' },
                          _react2.default.createElement(
                            'div',
                            { className: 'title' },
                            goodsData.form_data.title
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'sales' },
                            '\u9500\u91CF\uFF1A',
                            goodsData.form_data.sales
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'goods-bottom' },
                          _react2.default.createElement(
                            'div',
                            { className: 'price' },
                            _react2.default.createElement(
                              'span',
                              { className: 'real-price' },
                              '\uFFE5',
                              goodsData.form_data.goods_price
                            ),
                            customFeature.isShowVirtualPrice && _react2.default.createElement(
                              'span',
                              { className: 'virtual-price' },
                              '\uFFE5',
                              goodsData.form_data.virtual_price
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'buy-btn' },
                            '+'
                          )
                        )
                      )
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'assess-wrap', style: { height: '500px' } },
              this.state.AssessList.length === 0 && _react2.default.createElement(
                'div',
                { className: 'no-assess' },
                _react2.default.createElement('img', { src: 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png', alt: '' }),
                _react2.default.createElement(
                  'div',
                  null,
                  '\u6682\u65E0\u4EFB\u4F55\u8BC4\u4EF7'
                )
              ),
              this.state.AssessList.length !== 0 && _react2.default.createElement('div', { className: 'assess-list' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'shop-wrap', style: { height: '500px' } },
              _react2.default.createElement(
                'div',
                { className: 'merchant-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'info-title' },
                  '\u5546\u5BB6\u4FE1\u606F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-fesadress' }),
                    this.state.storeInfo.address_detail
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-tokeout-info' }),
                    this.state.storeInfo.description
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-sales-num' }),
                    '\u6708\u552E',
                    this.state.storeInfo.total_sales,
                    '\u4EFD'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-item' },
                    _react2.default.createElement('i', { className: 'icon-business-time' }),
                    '\u8425\u4E1A\u65F6\u95F4\u4E3A\uFF1A00:00-23:59'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bottom' },
          _react2.default.createElement(
            'div',
            { className: 'money-count' },
            _react2.default.createElement(
              'div',
              { className: 'cart-wrap' },
              _react2.default.createElement('i', { className: 'icon icon-fn-cart' })
            ),
            _react2.default.createElement(
              'div',
              null,
              '\u8BF7\u9009\u62E9\u5546\u54C1'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'order-btn' },
            '\u53BB\u4E0B\u5355'
          )
        )
      );
    }
  }]);
  return TostoreCustomComponent;
}(_react2.default.Component);

exports.default = TostoreCustomComponent;

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(890);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "community" 
 * 组件：社区组件
 */

var CommunityCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(CommunityCustomComponent, _React$Component);

  function CommunityCustomComponent(props) {
    (0, _classCallCheck3.default)(this, CommunityCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommunityCustomComponent.__proto__ || Object.getPrototypeOf(CommunityCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  // 跳转社区页


  (0, _createClass3.default)(CommunityCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 组件样式
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var itemStyle = {
        height: (0, _tools.transformPx2Rem)(customFeature.lineHeight, 320),
        marginBottom: (0, _tools.transformPx2Rem)(customFeature.margin, 320),
        backgroundColor: customFeature.lineBackgroundColor,
        backgroundImage: customFeature.lineBackgroundImage
      };
      if (customFeature.mode != 0) {
        itemStyle['width'] = (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320);
      }
      if (customFeature.mode == 2) {
        itemStyle['marginRight'] = (0, _tools.transformPx2Rem)(customFeature.maskMarginSpace, 320);
      }
      var imgStyle = {
        width: (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.imgHeight, 320)
      };
      var descStyle = {
        color: customFeature.secColor,
        fontSize: (0, _tools.transformPx2Rem)(customFeature.secFontSize, 375),
        fontStyle: customFeature.secFontStyle,
        fontWeight: customFeature.secFontWeight ? customFeature.secFontWeight : 'normal',
        textAlign: customFeature.secTextAlign,
        textDecoration: customFeature.secTextDecoration
      };
      var maskStyle = {
        backgroundColor: customFeature.maskBackgroundColor,
        opacity: customFeature.opacity
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component community mode-' + customFeature.mode + ' style-' + customFeature.style, style: styleObj },
        customFeature.mode == 0 && data.community_data && data.community_data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'item', key: index, style: itemStyle, onClick: _this2.turnToCommunityPage, 'data-id': item.id },
            _react2.default.createElement(
              'div',
              { className: 'content' },
              _react2.default.createElement('img', { className: 'img', style: imgStyle, src: item.img, alt: '' }),
              _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                  'div',
                  { className: 'info' },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.name
                  ),
                  item.show_article_comment && _react2.default.createElement(
                    'div',
                    { className: 'num', style: descStyle },
                    '\u8BDD\u9898 ',
                    item.xcx_article_count
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'desc', style: descStyle },
                  item.description
                )
              )
            )
          );
        }),
        (customFeature.mode == 1 || customFeature.mode == 2) && data.community_data && data.community_data.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'item', key: index, style: itemStyle, onClick: _this2.turnToCommunityPage, 'data-id': item.id },
            _react2.default.createElement(
              'div',
              { className: 'img-container' },
              _react2.default.createElement('img', { className: 'img', style: imgStyle, src: item.img, alt: '' }),
              customFeature.style == 0 && _react2.default.createElement('div', { className: 'mask', style: maskStyle })
            ),
            _react2.default.createElement(
              'div',
              { className: 'info' },
              _react2.default.createElement(
                'div',
                { className: 'title' },
                item.name
              ),
              item.show_article_comment && _react2.default.createElement(
                'div',
                { className: 'num', style: descStyle },
                item.xcx_article_count,
                '\u8BDD\u9898'
              )
            )
          );
        }),
        data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
        data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'getCommunityList', compindex: this.props.index } })
      );
    }
  }]);
  return CommunityCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var newData = {};
    if (customFeature.mode == undefined) {
      newData['eles[' + compindex + '].customFeature.mode'] = 0;
      newData['eles[' + compindex + '].customFeature.style'] = 1;
    }
    pageInstance.setData(newData);

    _this3.initialCommunityList(compindex, pageInstance);
  };

  this.initialCommunityList = function (compindex, pageIns) {
    var pageInstance = pageIns || _app.appMethod.getAppCurrentPage();
    var compdata = pageInstance.data.eles[compindex];
    var dataId = [];
    var content = compdata.content;
    var newdata = {};

    for (var j in content) {
      dataId.push(content[j]['community-id']);
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetSectionByPage',
      data: {
        section_ids: dataId,
        page: 1,
        page_size: 100
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var ddata = {},
            lastdata = [],
            newdata = {};

        for (var x = 0; x < res.data.length; x++) {
          var val = res.data[x];
          ddata[val.id] = val;
        }
        for (var y = 0; y < dataId.length; y++) {
          var _val = ddata[dataId[y]];
          if (_val) {
            lastdata.push(_val);
          }
        }
        newdata['eles[' + compindex + '].community_data'] = lastdata;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  };

  this.turnToCommunityPage = function (event) {
    var id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('communityPage?detail=' + id + chainParam);
  };
};

exports.default = CommunityCustomComponent;

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _customEvent = __webpack_require__(18);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(892);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopicCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TopicCustomComponent, _React$Component);

  function TopicCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TopicCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopicCustomComponent.__proto__ || Object.getPrototypeOf(TopicCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(TopicCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 商品分类
      var content = data.content;
      // 组件样式
      var styleObj = (0, _tools.convertStyleData)(data.style);

      // TODO: 可能是小程序的bug，应该
      styleObj['backgroundColor'] = '#F2F2F2';

      if (customFeature.vesselAutoheight == 0) {
        styleObj['height'] = (0, _tools.transformPx2Rem)(height, 320);
      }

      var btnsGroupStyleObj = {};
      if (data.topicSuspension && data.topicSuspension.style) {
        btnsGroupStyleObj = (0, _extends3.default)({}, (0, _tools.convertStyleData)(data.topicSuspension.style), {
          bottom: (0, _tools.transformPx2Rem)(_app.appMethod.isTabBarPage() ? parseInt(data.style.bottom) + 48 : data.style.bottom, 320)
        });
      } else {
        btnsGroupStyleObj = {
          bottom: _app.appMethod.isTabBarPage() ? 'calc(.40rem + 48px)' : '.40rem',
          right: '.30rem'
        };
      }
      // todo 底部导航
      return _react2.default.createElement(
        'div',
        { className: 'custom-component topic mode-' + customFeature.mode, style: styleObj },
        data.topicList && data.topicList.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'topic-item', key: index,
              onClick: _this2.turnToTopicDetail,
              'data-index': index,
              'data-compindex': _this2.props.index,
              'data-articlestyle': _this2.mode2articlestyle(customFeature.mode)
            },
            customFeature.mode == 0 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'user' },
                _react2.default.createElement(
                  'div',
                  { className: 'user-img',
                    onClick: _this2.topicTurnToUsercenter,
                    'data-usertoken': item.user_token,
                    'data-sourcetype': item.source_type
                  },
                  _react2.default.createElement('img', { src: item.headimgurl, alt: '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'user-info' },
                  _react2.default.createElement(
                    'span',
                    { className: 'author' },
                    item.nickname
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'time' },
                    item.add_time
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'title' },
                item.title
              ),
              _react2.default.createElement(
                'div',
                { className: 'content-text' },
                item.content.text
              ),
              item.content.imgs && item.content.imgs[0] && _react2.default.createElement(
                'div',
                { className: 'content-img' },
                _react2.default.createElement('img', { src: item.content.imgs[0], alt: '' })
              ),
              item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] && _react2.default.createElement(
                'div',
                { className: 'goods',
                  onClick: _this2.topicTurnToGoodsDetail,
                  'data-id': item.form_data.list_recommend.recommend_goods[0].id,
                  'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type
                },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-img' },
                  _react2.default.createElement('img', { src: item.form_data.list_recommend.recommend_goods[0].image })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-dec' },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-title' },
                    item.form_data.list_recommend.recommend_goods[0].name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-price' },
                    '\xA5',
                    item.form_data.list_recommend.recommend_goods[0].price
                  ),
                  _react2.default.createElement('span', { className: 'ico-moon icon-community-group-arrow' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom' },
                _react2.default.createElement(
                  'div',
                  { className: 'reading' },
                  item.read_count,
                  '\u9605\u8BFB\u91CF'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'utils' },
                  _react2.default.createElement(
                    'div',
                    { className: 'thumbs',
                      onClick: _this2.topicPerformLikeAct,
                      'data-compindex': _this2.props.index,
                      'data-index': index,
                      'data-isliked': item.is_liked
                    },
                    _react2.default.createElement('span', { className: 'ico-moon icon-community-group-thumb' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'num' },
                      item.like_count
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'reply',
                      onClick: _this2.showTopicReplyComment,
                      'data-compindex': _this2.props.index,
                      'data-index': index
                    },
                    _react2.default.createElement('span', { className: 'ico-moon icon-goods-customer-service' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'num' },
                      item.comment_count
                    )
                  )
                )
              )
            ),
            customFeature.mode == 1 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'topic-top' },
                _react2.default.createElement(
                  'div',
                  { className: 'author-logo', onClick: _this2.topicTurnToUsercenter, 'data-usertoken': item.user_token, 'data-sourcetype': item.source_type },
                  _react2.default.createElement('img', { src: item.headimgurl, alt: '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'author-name' },
                  item.nickname
                ),
                item.top_flag == 1 && _react2.default.createElement('span', { className: 'topic-stick' }),
                item.phone && _react2.default.createElement('span', { className: 'contact-ta', 'data-compindex': _this2.props.index, 'data-phone': item.phone, onClick: _this2.showTopicPhoneModal }),
                _react2.default.createElement(
                  'div',
                  { className: 'topic-title' },
                  item.title
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-des' },
                item.content.text || ''
              ),
              item.content.type == 2 && item.content.url.article && _react2.default.createElement(
                'div',
                { className: 'topic-link' },
                _react2.default.createElement(
                  'div',
                  { className: 'link-logo-wrap' },
                  _react2.default.createElement('img', { className: 'link-logo', src: item.content.url.article.cover || item.content.url.article.logo, mode: 'aspectFill', alt: '' }),
                  item.content.url.article.type == 4 && _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'link-text' },
                  item.content.url.article.title
                )
              ),
              item.content.type == 2 && item.content.url.video && _react2.default.createElement(
                'div',
                { className: 'topic-video' },
                _react2.default.createElement('img', { className: 'video-cover', src: item.content.url.video.cover || '', mode: 'aspectFill', alt: '' }),
                _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
              ),
              item.content.imgs && item.content.imgs.length > 0 && _react2.default.createElement(
                'div',
                { className: 'imgs-list' },
                item.content.imgs.map(function (img, imgIdx) {
                  if (imgIdx < 9) {
                    return _react2.default.createElement(
                      'div',
                      { key: imgIdx, className: 'img-item' },
                      _react2.default.createElement('img', { src: img, mode: 'aspectFill', alt: '', 'data-img': img, 'data-imgarr': JSON.stringify(item.content.imgs), onClick: _this2.tapPrevewPictureHandler })
                    );
                  }
                })
              ),
              item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] && _react2.default.createElement(
                'div',
                { className: 'topic-goods', onClick: _this2.topicTurnToGoodsDetail, 'data-id': item.form_data.list_recommend.recommend_goods[0].id, 'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-left' },
                  _react2.default.createElement('img', { src: item.form_data.list_recommend.recommend_goods[0].image })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-center' },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-name' },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.form_data.list_recommend.recommend_goods[0].name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-price' },
                    '\xA5',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.form_data.list_recommend.recommend_goods[0].price
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-right' },
                  _react2.default.createElement(
                    'button',
                    null,
                    '\u53BB\u8D2D\u4E70'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-publish-info' },
                _react2.default.createElement(
                  'span',
                  { className: 'topic-publish-date' },
                  item.add_time
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'topic-publish-address' },
                  item.address && _react2.default.createElement('i', { className: 'ico-moon icon-community-location' }),
                  item.address
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'publish-where', onClick: _this2.goToCommunityPage, 'data-id': item.section_id },
                  '\u6765\u81EA',
                  item.section_name
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-bottom' },
                item.comment_count > 0 && _react2.default.createElement(
                  'div',
                  { className: 'topic-disscuss' },
                  item.comment.map(function (co, coIdx) {
                    return _react2.default.createElement(
                      'div',
                      { key: coIdx, className: 'topic-diss-li' },
                      _react2.default.createElement(
                        'span',
                        { className: 'topic-diss-name' },
                        co.nickname
                      ),
                      co.content.reply_to && _react2.default.createElement(
                        'span',
                        null,
                        '\u56DE\u590D'
                      ),
                      co.content.reply_to && _react2.default.createElement(
                        'span',
                        null,
                        co.content.reply_to.nickname
                      ),
                      '\uFF1A',
                      _react2.default.createElement(
                        'span',
                        null,
                        co.content.text
                      )
                    );
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'topic-diss-all' },
                    '\u67E5\u770B\u5168\u90E8',
                    _react2.default.createElement(
                      'span',
                      { className: 'topic-diss-count' },
                      item.comment_count
                    ),
                    '\u6761\u8BC4\u8BBA'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-footer' },
                _react2.default.createElement(
                  'span',
                  { className: 'topic-share' },
                  _react2.default.createElement('i', { className: 'ico-moon icon-community_share' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.spread_count > 0 ? item.spread_count : '分享'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'topic-viewcount' },
                  _react2.default.createElement('i', { className: 'ico-moon icon-community_view' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.read_count > 0 ? item.read_count : '浏览'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'topic-rating', 'data-compindex': _this2.props.index, 'data-index': index, onClick: _this2.showTopicReplyComment },
                  _react2.default.createElement('i', { className: 'ico-moon icon-community_message' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.comment_count > 0 ? item.comment_count : '评论'
                  )
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'topic-voteup', 'data-isliked': item.is_liked, 'data-compindex': _this2.props.index, 'data-index': index, onClick: _this2.topicPerformLikeAct, style: item.is_liked == 1 ? { color: '#FF4141' } : {} },
                  _react2.default.createElement('i', { className: 'ico-moon ' + (item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise') }),
                  _react2.default.createElement(
                    'span',
                    null,
                    item.like_count > 0 ? item.like_count : '点赞'
                  )
                )
              )
            ),
            customFeature.mode == 2 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                'div',
                { className: 'topic-top' },
                _react2.default.createElement(
                  'div',
                  { className: 'author-logo', onClick: _this2.topicTurnToUsercenter, 'data-usertoken': item.user_token,
                    'data-sourcetype': item.source_type },
                  _react2.default.createElement('img', { src: item.headimgurl, alt: '' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'top-right' },
                  _react2.default.createElement(
                    'div',
                    { className: 'author-name' },
                    item.nickname
                  ),
                  item.top_flag == 1 && _react2.default.createElement('span', { className: 'topic-stick' }),
                  item.hot_flag == 1 && _react2.default.createElement('span', { className: 'topic-favorite' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'topic-title' },
                    _react2.default.createElement(
                      'span',
                      { onClick: _this2.goToCommunityPage, 'data-id': item.section_id, className: 'publish-where' },
                      '#',
                      item.section_name,
                      '#'
                    ),
                    item.title
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-des' },
                item.content.text || ''
              ),
              item.content.type == 2 && item.content.url.article && _react2.default.createElement(
                'div',
                { className: 'topic-link' },
                _react2.default.createElement(
                  'div',
                  { className: 'link-logo-wrap' },
                  _react2.default.createElement('img', { className: 'link-logo', src: item.content.url.article.cover || item.content.url.article.logo, mode: 'aspectFill',
                    alt: '' }),
                  item.content.url.article.type == 4 && _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'link-text' },
                  item.content.url.article.title
                )
              ),
              item.content.type == 2 && item.content.url.video && _react2.default.createElement(
                'div',
                { className: 'topic-video' },
                _react2.default.createElement('img', { className: 'video-cover', src: item.content.url.video.cover || '', mode: 'aspectFill', alt: '' }),
                _react2.default.createElement('label', { className: 'ico-moon icon-news-video-play' })
              ),
              item.content.imgs && item.content.imgs.length > 0 && _react2.default.createElement(
                'div',
                { className: 'imgs-list' },
                item.content.imgs.map(function (img, imgIdx) {
                  return _react2.default.createElement(
                    'div',
                    { key: imgIdx, className: 'img-item' },
                    _react2.default.createElement('img', { src: img, mode: 'aspectFill', alt: '', 'data-img': img, 'data-imgarr': JSON.stringify(item.content.imgs), onClick: _this2.tapPrevewPictureHandler })
                  );
                })
              ),
              item.form_data.list_recommend.recommend_goods && item.form_data.list_recommend.recommend_goods[0] && _react2.default.createElement(
                'div',
                { className: 'topic-goods-friend', onClick: _this2.topicTurnToGoodsDetail,
                  'data-id': item.form_data.list_recommend.recommend_goods[0].id, 'data-goods-type': item.form_data.list_recommend.recommend_goods[0].goods_type },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-left-friend' },
                  _react2.default.createElement('img', { src: item.form_data.list_recommend.recommend_goods[0].image })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-center-friend' },
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-name-friend' },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.form_data.list_recommend.recommend_goods[0].name
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-price-friend' },
                    _react2.default.createElement(
                      'span',
                      null,
                      '\xA5 ',
                      item.form_data.list_recommend.recommend_goods[0].price
                    ),
                    _react2.default.createElement(
                      'button',
                      null,
                      '\u8D2D\u4E70'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-publish-info' },
                _react2.default.createElement(
                  'span',
                  { className: 'topic-publish-date' },
                  item.add_time
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'topic-publish-address' },
                  item.address && _react2.default.createElement('i', { className: 'ico-moon icon-community-location' }),
                  item.address
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    item.read_count,
                    '\u9605\u8BFB\u91CF'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'topic-comment', 'data-compindex': _this2.props.index, 'data-index': index, onClick: _this2.showTopicCommentBox },
                  _react2.default.createElement(
                    'div',
                    { className: 'li-comments' },
                    _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/comments.png' })
                  ),
                  item.comment_box_show && _react2.default.createElement(
                    'div',
                    { className: 'topic-comment-box' },
                    _react2.default.createElement(
                      'span',
                      { className: 'topic-comment-like', 'data-isliked': item.is_liked, 'data-compindex': _this2.props.index,
                        'data-index': index, onClick: _this2.topicPerformLikeAct },
                      _react2.default.createElement('i', { className: 'ico-moon ' + (item.is_liked == 1 ? 'icon-community_praise_fill' : 'icon-community_praise') }),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.like_count > 0 ? item.like_count : '点赞'
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'topic-comment-rating', 'data-compindex': _this2.props.index, 'data-index': index, onClick: _this2.showTopicReplyComment },
                      _react2.default.createElement('i', { className: 'ico-moon icon-community_message' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.comment_count > 0 ? item.comment_count : '评论'
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'topic-bottom' },
                item.like_count > 0 && _react2.default.createElement(
                  'div',
                  { className: 'topic-like-list' },
                  _react2.default.createElement('i', { className: 'ico-moon icon-community_praise' }),
                  item.like.map(function (like, likeIdx) {
                    return _react2.default.createElement(
                      'span',
                      { key: likeIdx, className: 'topic-like-text' },
                      likeIdx > 0 && _react2.default.createElement(
                        'span',
                        null,
                        ','
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.nickname
                      )
                    );
                  })
                ),
                item.comment_count > 0 && _react2.default.createElement(
                  'div',
                  { className: 'topic-disscuss' },
                  item.comment.map(function (co, coIdx) {
                    _react2.default.createElement(
                      'div',
                      { key: coIdx, className: 'topic-diss-li' },
                      _react2.default.createElement(
                        'span',
                        { className: 'topic-diss-name' },
                        co.nickname
                      ),
                      co.content.reply_to && _react2.default.createElement(
                        'span',
                        { style: {
                            color: '#333'
                          } },
                        '\u56DE\u590D'
                      ),
                      co.content.reply_to && _react2.default.createElement(
                        'span',
                        null,
                        co.content.reply_to.nickname
                      ),
                      ': ',
                      _react2.default.createElement(
                        'span',
                        null,
                        co.content.text
                      )
                    );
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'topic-diss-all-friend' },
                    '\u67E5\u770B\u5168\u90E8\u56DE\u590D',
                    _react2.default.createElement('span', { className: 'ico-moon icon-downarrow' })
                  )
                )
              )
            )
          );
        }),
        data.listStatus && data.listStatus.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
        data.listStatus && !data.listStatus.isMore && data.topicList.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无话题~' } }),
        data.listStatus && data.listStatus.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'topicEleScrollFunc', compindex: this.props.index } }),
        data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
        data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!data.listStatus.isMore && !data.listStatus.loading && !data.listStatus.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.topicEleScrollFunc, 'data-compindex': this.props.index }),
        data.topicSuspension && data.topicSuspension.isShow && _react2.default.createElement(
          'div',
          { className: 'topic-btns-group',
            style: btnsGroupStyleObj,
            'data-compindex': this.props.index },
          data.topicSuspension.topBtnShow && _react2.default.createElement(
            'div',
            { className: 'topic-backtop-btn', 'data-compindex': this.props.index, onClick: this.pageBackTopAct },
            _react2.default.createElement('label', { className: 'ico-moon icon-community-go-top' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'topic-publish-btn', 'data-compindex': this.props.index, onClick: this.turnToTopicPublish },
            _react2.default.createElement('label', { className: 'ico-moon icon-community-edit' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'topic-service-btn' },
            _react2.default.createElement('label', { className: 'ico-moon icon-community-ai' }),
            _react2.default.createElement('button', { onClick: function onClick() {
                return (0, _customEvent.customEvent)({ customFeature: { action: 'contact' } });
              } })
          )
        ),
        data.topicPhoneModal && data.topicPhoneModal.isShow && _react2.default.createElement(
          'div',
          { className: 'actionSheet-wrap' },
          _react2.default.createElement(
            'div',
            { className: 'actionSheet-buttons' },
            _react2.default.createElement(
              'button',
              { className: 'phoneNum-btn' },
              data.topicPhoneModal.phone
            ),
            _react2.default.createElement(
              'button',
              { className: 'call-btn', onClick: this.topicMakePhoneCall, 'data-compindex': this.props.index },
              '\u547C\u53EB'
            ),
            _react2.default.createElement(
              'button',
              { className: 'cancel-btn', 'data-phone': '', onClick: this.showTopicPhoneModal, 'data-compindex': this.props.index },
              '\u53D6\u6D88'
            )
          )
        ),
        data.topicReplyComment && data.topicReplyComment.isShow && _react2.default.createElement('div', { className: 'comment-mask', 'data-compindex': this.props.index, onClick: this.topicCancelReply }),
        data.topicReplyComment && data.topicReplyComment.isShow && _react2.default.createElement(
          'div',
          { className: 'comment-box', id: this.props.index + '-comment-box',
            style: {
              bottom: data.topicReplyComment.focus ? data.topicReplyComment.keyboardHeight : 0
            } },
          _react2.default.createElement(
            'div',
            { className: 'comment-top' },
            _react2.default.createElement('textarea', { type: 'textarea', className: 'comment-input', id: '', placeholder: data.topicReplyComment.replyPlaceholder
              // TODO 属性待补全
              // placeholder-style="color: #d8d8d8; font-size: 28rpx;"
              , maxLength: '-1',
              value: data.topicReplyParam.text
              // focus={data.topicReplyComment.focus}
              // show-confirm-bar="{{false}}"
              // fixed="{{true}}"
              // adjust-position="{{false}}"
              , 'data-compindex': this.props.index, onChange: this.topicReplyInput,
              onFocus: this.topicReplyFocus,
              onBlur: this.topicReplyBlur
              // bindlinechange="topicReplyLineChange"
              , style: {
                height: (data.topicReplyComment.commentContentHeight + 20) / 100 + 'rem'
              } }),
            (data.topicReplyParam.comment_img_url || data.topicReplyParam.address) && _react2.default.createElement(
              'div',
              { className: 'comment-others' },
              data.topicReplyParam.comment_img_url && _react2.default.createElement(
                'div',
                { className: 'others-image', style: {
                    marginBottom: (data.topicReplyParam.address ? '0.36' : '0') + 'rem'
                  } },
                _react2.default.createElement('img', { src: data.topicReplyParam.comment_img_url, mode: 'aspectFill', 'data-compindex': this.props.index, onClick: this.topicReplyImagePreview }),
                _react2.default.createElement(
                  'div',
                  { className: 'image-close-icon-box', 'data-compindex': this.props.index, onClick: this.topicReplyImageDelete },
                  _react2.default.createElement('span', { className: 'image-close-icon ico-moon icon-closes' })
                )
              ),
              data.topicReplyParam.address && _react2.default.createElement(
                'div',
                { className: ']others-location', 'data-compindex': this.props.index, onClick: this.topicReplyLocationDelete },
                _react2.default.createElement(
                  'span',
                  null,
                  data.topicReplyParam.address
                ),
                _react2.default.createElement('span', { className: 'location-close-icon ico-moon icon-closes' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'comment-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'comment-bottom-left' },
              _react2.default.createElement('span', { className: 'comment-bottom-icon ico-moon icon-picture', 'data-compindex': this.props.index, onClick: this.topicReplyImageChoose }),
              _react2.default.createElement('span', { className: 'comment-bottom-icon ico-moon icon-community-location', 'data-compindex': this.props.index, onClick: this.topicReplyLocationChoose })
            ),
            _react2.default.createElement(
              'div',
              { className: 'comment-bottom-right' },
              _react2.default.createElement(
                'div',
                { className: 'comment-bottom-right-cancel', 'data-compindex': this.props.index, onClick: this.topicCancelReply },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u53D6\u6D88'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'comment-bottom-right-send', 'data-compindex': this.props.index, onClick: this.topicSubmitReply },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u53D1\u5E03'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TopicCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.state = {
    articleList: []
  };

  this.init = function (compindex, pageInstance) {
    var that = _this3,
        comData = pageInstance.data.eles[compindex],
        customFeature = comData.customFeature,
        listId = customFeature.id,
        style = comData.style,
        listParam = {
      page: 1,
      page_size: customFeature.loadingNum || 10,
      orderby: 'comment_count',
      article_style: 1,
      section_id: customFeature.bindPlate || '',
      category_id: customFeature.bindTopic || '',
      search_value: ''
    },
        listStatus = {
      loading: false,
      isMore: true
    },
        topicSuspension = {
      isShow: customFeature.isShowSuspension,
      topBtnShow: false
    },
        topicPhoneModal = {
      isShow: false,
      phone: ''
    },
        topicReplyComment = {
      index: '',
      isShow: false,
      focus: false,
      keyboardHeight: '50%',
      hasTabBar: _app.appMethod.isTabBarPage(_app.appMethod.getPageRouter()),
      commentContentMaxHeight: 0,
      commentContentHeight: 40
    },
        topicReplyParam = {
      text: '',
      agent_user_token: '',
      address: '',
      latitude: '',
      longitude: '',
      comment_img_url: '',
      comment_id: 0,
      parent_comment_id: 0,
      article_id: '',
      sub_app_id: ''
    },
        newdata = {};

    // 设置param
    var param = customFeature;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));
    // 找到当前话题排序组件
    var relateSortCompIndex = pageInstance.data.eles.findIndex(function (ele) {
      if (ele.type === 'topic-sort') {
        return ele.param.topic_sort_object == listId;
      }
      return false;
    });
    // 设置话题排序
    if (relateSortCompIndex > -1) {
      var firstSortItem = pageInstance.data.eles[relateSortCompIndex].content[0];
      listParam.orderby = firstSortItem.orderby;
      listParam.order = firstSortItem.order;
    }

    var pageRouter = _app.appMethod.getPageRouter();
    var currentPageTopics = _app.appMethod.globalData.susTopicsMap[pageRouter];
    if (!currentPageTopics) {
      currentPageTopics = _app.appMethod.globalData.susTopicsMap[pageRouter] = [];
    }
    if (topicSuspension.isShow) {
      // 将有悬浮窗的话题compindex存起来
      if (currentPageTopics.indexOf(compindex) === -1) {
        currentPageTopics.push(compindex);
      }
      if (currentPageTopics.length > 1 && compindex !== currentPageTopics[0]) {
        topicSuspension.isShow = false;
      }
    }

    newdata['eles[' + compindex + '].listParam'] = listParam;
    newdata['eles[' + compindex + '].listStatus'] = listStatus;
    newdata['eles[' + compindex + '].topicSuspension'] = topicSuspension;
    newdata['eles[' + compindex + '].topicPhoneModal'] = topicPhoneModal;
    newdata['eles[' + compindex + '].topicReplyComment'] = topicReplyComment;
    newdata['eles[' + compindex + '].topicReplyParam'] = topicReplyParam;
    pageInstance.setData(newdata);

    if (listParam.orderby === 'distance' && !listParam.latitude) {
      _app.appMethod.getLocation({
        success: function success(res) {
          var _pageInstance$setData2;

          pageInstance.setData((_pageInstance$setData2 = {}, (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + compindex + '].listParam.longitude', res.longitude), (0, _defineProperty3.default)(_pageInstance$setData2, 'eles[' + compindex + '].listParam.latitude', res.latitude), _pageInstance$setData2));
          that.getTopListData(compindex, pageInstance);
        }
      });
    } else {
      _this3.getTopListData(compindex, pageInstance);
    }
    _app.appMethod.globalData.hasTopicCom = true;
    _this3.systemInfo = _app.appMethod.getSystemInfo();
    _this3.getSysnInfoTimer = setTimeout(function () {
      var systemInfo = _app.appMethod.getSystemInfo();
      if (systemInfo.windowHeight !== _this3.systemInfo.windowHeight) {
        _this3.systemInfo = systemInfo;
      }
    }, 500);
  };

  this.getTopListData = function (compindex, pageIns, callback) {
    var that = _this3;
    var pageInstance = pageIns || _app.appMethod.getAppCurrentPage(),
        listComData = pageInstance.data.eles[compindex],
        listParam = listComData.listParam,
        listStatus = listComData.listStatus,
        topicList = listComData.topicList || [];
    if (listComData.customFeature.isShowList === false) {
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicList', []));
      return;
    }
    if (listStatus.loading || !listStatus.isMore) {
      return;
    }
    var newdata = {};
    newdata['eles[' + compindex + '].listStatus.loading'] = true;
    newdata['eles[' + compindex + '].listStatus.loadingFail'] = false;
    if (listParam.page == 1) {
      newdata['eles[' + compindex + '].topicList'] = [];
      newdata['eles[' + compindex + '].listStatus.isMore'] = true;
    }
    pageInstance.setData(newdata);

    if (listParam.orderby === 'distance') {
      // 距离最近排序需要添加参数order，其他排序不用
      listParam.order = 'asc';
    } else if ('order' in listParam) {
      delete listParam.order;
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: listParam,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {};
        listStatus.loading = false;
        listStatus.isMore = res.is_more == 1;
        listStatus.loadingFail = false;
        res.data.forEach(function (t) {
          t.comment_box_show = false;
          if (t.content.type == 2) {
            if (t.content.url.article) {
              if (t.content.url.article.type == 1) {
                delete t.content.url.article.body;
              }
              if (t.content.url.article.type == 3) {
                t.content.url.article.cover = _app.appMethod.globalData.cdnUrl + '/zhichi_frontend/static/webapp/images/audio_default.png';
              }
            }
          }
          if (t.form_data.list_recommend && t.form_data.list_recommend.recommend_goods && t.form_data.list_recommend.recommend_goods[0]) {
            var _t$form_data$list_rec = t.form_data.list_recommend.recommend_goods[0],
                title = _t$form_data$list_rec.title,
                price = _t$form_data$list_rec.price,
                cover = _t$form_data$list_rec.cover,
                id = _t$form_data$list_rec.id;

            t.form_data.list_recommend.recommend_goods[0] = {
              name: title,
              price: price,
              image: cover,
              id: id
            };
          }
        });
        topicList = res.current_page > 1 ? topicList.concat(res.data) : res.data;
        newdata['eles[' + compindex + '].topicList'] = topicList;
        newdata['eles[' + compindex + '].listParam.page'] = res.current_page + 1;
        newdata['eles[' + compindex + '].listStatus'] = listStatus;
        pageInstance.setData(newdata);
        typeof callback === 'function' && callback(res.data);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].listStatus.loading'] = false;
        newdata['eles[' + compindex + '].listStatus.loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  };

  this.topicEleScrollFunc = function (e) {
    var currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        compindex = dataset.compindex;
    _this3.getTopListData(compindex, null);
  };

  this.turnToTopicDetail = function (e) {
    e.stopPropagation();
    if (_app.appMethod.globalData.topicTurnToDetail) {
      return;
    }
    _app.appMethod.globalData.topicTurnToDetail = true;
    var currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        articlestyle = dataset.articlestyle,
        compindex = dataset.compindex,
        index = dataset.index,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        topic = pageInstance.data.eles[compindex].topicList[index],
        newdata = {};
    newdata['eles[' + compindex + '].topicList[' + index + '].read_count'] = +topic.read_count + 1;
    pageInstance.setData(newdata);
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('/informationManagement/pages/communityDetail/communityDetail?detail=' + topic.id + '&articleStyle=' + articlestyle + '&dataLiked=' + topic.is_liked + '&phoneNumber=' + topic.phone + '&sectionid=' + topic.section_id + chainParam);
    _app.appMethod.globalData.topicTurnToDetail = false;
  };

  this.showTopicPhoneModal = function (e) {
    e.stopPropagation();
    var currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        phone = dataset.phone,
        compindex = dataset.compindex,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        topicPhoneModal = pageInstance.data.eles[compindex].topicPhoneModal;
    topicPhoneModal.phone = phone.replace(/^(\d{3})(\d{4})(\d{4})$/, '$1-$2-$3');
    topicPhoneModal.isShow = !topicPhoneModal.isShow;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicPhoneModal', topicPhoneModal));
  };

  this.topicImgLoad = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage(),
        owidth = event.target.width,
        oheight = event.target.height,
        path = event.currentTarget.dataset.path,
        style = event.currentTarget.dataset.style,
        oscale = owidth / oheight,
        cwidth = 290,
        cheight = 120,
        ewidth = void 0,
        eheight = void 0;

    if (style == 1) {
      cwidth = 240;
    }

    if (oscale > cwidth / cheight) {
      ewidth = cwidth;
      eheight = cwidth / oscale;
    } else {
      ewidth = cheight * oscale;
      eheight = cheight;
    }

    pageInstance.setData((0, _defineProperty3.default)({}, path, 'width:' + ewidth + 'px;height:' + eheight + 'px;'));
  };

  this.showTopicCommentBox = function (e) {
    e.stopPropagation();
    var currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        compindex = dataset.compindex,
        index = dataset.index,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        topic = pageInstance.data.eles[compindex].topicList[index],
        commentBoxShow = topic.comment_box_show;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicList[' + index + '].comment_box_show', !commentBoxShow));
  };

  this.topicPerformLikeAct = function (e) {
    e.stopPropagation();
    var that = _this3,
        currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        compindex = dataset.compindex,
        index = dataset.index,
        isliked = dataset.isliked,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        topic = pageInstance.data.eles[compindex].topicList[index];

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/PerformLike',
      data: {
        obj_type: 1,
        obj_id: topic.id
      },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          _app.appMethod.showToast({
            title: isliked == 1 ? '点赞取消' : '点赞成功',
            icon: 'success',
            success: function success() {
              pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicList[' + index + '].comment_box_show', false));
              that.refreshOneTopicData({ 'articleId': topic.id, index: index, compindex: compindex });
            }
          });
        }
      }
    });
  };

  this.refreshOneTopicData = function (param) {
    if (!param.articleId || !param.compindex) {
      return;
    }
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppSNS/GetArticleByPage',
      data: { article_id: param.articleId, page: 1, page_size: 10 },
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (!res.data.length) {
          return;
        }
        var topic = res.data[0];
        if (topic.form_data.list_recommend && topic.form_data.list_recommend.recommend_goods && topic.form_data.list_recommend.recommend_goods[0]) {
          var _topic$form_data$list = topic.form_data.list_recommend.recommend_goods[0],
              title = _topic$form_data$list.title,
              price = _topic$form_data$list.price,
              cover = _topic$form_data$list.cover,
              id = _topic$form_data$list.id;

          topic.form_data.list_recommend.recommend_goods[0] = {
            name: title,
            price: price,
            image: cover,
            id: id
          };
        }
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + param.compindex + '].topicList[' + param.index + ']', topic));
      },
      fail: function fail() {}
    });
  };

  this.showTopicReplyComment = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var _e$currentTarget$data = e.currentTarget.dataset,
        compindex = _e$currentTarget$data.compindex,
        index = _e$currentTarget$data.index;

    var topic = pageInstance.data.eles[compindex].topicList[index];
    if (topic) {
      var section_id = topic.section_id,
          id = topic.id,
          agent_user_token = topic.agent_user_token;

      var newdata = {};
      newdata['eles[' + compindex + '].topicReplyParam.section_id'] = section_id;
      newdata['eles[' + compindex + '].topicReplyParam.article_id'] = id;
      newdata['eles[' + compindex + '].topicReplyParam.agent_user_token'] = agent_user_token;
      newdata['eles[' + compindex + '].topicReplyComment.index'] = index;
      newdata['eles[' + compindex + '].topicReplyComment.isShow'] = true;
      newdata['eles[' + compindex + '].topicReplyComment.focus'] = true;
      newdata['eles[' + compindex + '].topicList[' + index + '].comment_box_show'] = false;
      pageInstance.setData(newdata);
    }
  };

  this.pageBackTopAct = function (e) {
    e.stopPropagation();
    _app.appMethod.pageScrollTo(0);
  };

  this.turnToTopicPublish = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    pageInstance.communityPublishTypeRef.current.show({
      communityPublishType: {
        show: true
      }
    });
  };

  this.topicMakePhoneCall = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage(),
        compindex = e.currentTarget.dataset.compindex,
        phone = pageInstance.data.eles[compindex].topicPhoneModal.phone;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicPhoneModal.isShow', false));
    _app.appMethod.makePhoneCall(phone);
  };

  this.goToCommunityPage = function (event) {
    event.stopPropagation();
    var id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('/informationManagement/pages/communityPage/communityPage?detail=' + id + chainParam);
  };

  this.topicTurnToGoodsDetail = function (event) {
    event.stopPropagation();
    var id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('/pages/goodsDetail/goodsDetail?detail=' + id + chainParam);
  };

  this.topicReplyInput = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyParam.text', e.target.value));
  };

  this.topicReplyFocus = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    var newdata = {};
    if (e.target.height) {
      var curKbHeight = e.target.height;
      if (/iPhone\s?X/i.test(_app.appMethod.globalData.systemInfo.model)) {
        curKbHeight = 365;
      }
      var hasTabBar = pageInstance.data.eles[compindex].topicReplyComment.hasTabBar;
      if (hasTabBar) {
        // 暂时无法获取tabBar的高度，默认取54px
        curKbHeight = curKbHeight - 54;
      }
      newdata['eles[' + compindex + '].topicReplyComment.keyboardHeight'] = curKbHeight + 'px';
    }
    newdata['eles[' + compindex + '].topicReplyComment.focus'] = true;
    pageInstance.setData(newdata);
  };

  this.topicReplyBlur = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyComment.focus', false));
  };

  this.topicReplyLineChange = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    var lineHeight = 40;
    var marginTop = 45;
    var commentContentHeight = lineHeight;
    var maxHeight = pageInstance.data.eles[compindex].topicReplyComment.commentContentMaxHeight;
    // 获取评论框距离页面顶部的高度px
    _app.appMethod.getBoundingClientRect('#' + compindex + '-comment-box', function (rect) {
      if (Array.isArray(rect) && rect[0]) {
        commentContentHeight = e.target.lineCount * lineHeight;
        if (rect[0].top > marginTop && e.target.lineCount >= 1) {
          if (rect[0].top - marginTop <= lineHeight) {
            maxHeight = commentContentHeight + lineHeight;
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyComment.commentContentMaxHeight', maxHeight));
          }
          pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyComment.commentContentHeight', commentContentHeight));
        }
        if (rect[0].top <= marginTop && commentContentHeight <= maxHeight) {
          pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyComment.commentContentHeight', commentContentHeight));
        }
      }
    });
  };

  this.topicReplyImagePreview = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    var commentImage = pageInstance.data.eles[compindex].topicReplyParam.comment_img_url;
    _app.appMethod.previewImage({
      current: commentImage
    });
  };

  this.topicReplyImageDelete = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyParam.comment_img_url', ''));
  };

  this.topicReplyLocationDelete = function (e) {
    var _pageInstance$setData16;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    pageInstance.setData((_pageInstance$setData16 = {}, (0, _defineProperty3.default)(_pageInstance$setData16, 'eles[' + compindex + '].topicReplyParam.address', ''), (0, _defineProperty3.default)(_pageInstance$setData16, 'eles[' + compindex + '].topicReplyParam.latitude', ''), (0, _defineProperty3.default)(_pageInstance$setData16, 'eles[' + compindex + '].topicReplyParam.longitude', ''), _pageInstance$setData16));
  };

  this.topicReplyImageChoose = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    _app.appMethod.chooseImage(function (imageUrls) {
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyParam.comment_img_url', imageUrls));
    }, 1);
  };

  this.topicReplyLocationChoose = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    _app.appMethod.chooseLocation({
      success: function success(_ref) {
        var name = _ref.name,
            address = _ref.address,
            latitude = _ref.latitude,
            longitude = _ref.longitude;

        var newdata = {};
        newdata['eles[' + compindex + '].topicReplyParam.latitude'] = latitude;
        newdata['eles[' + compindex + '].topicReplyParam.longitude'] = longitude;
        if (name || address) {
          newdata['eles[' + compindex + '].topicReplyParam.address'] = name || address;
        } else {
          _app.appMethod.sendRequest({
            hideLoading: true,
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            data: {
              latitude: latitude,
              longitude: longitude,
              country_region_id: 1 // 中国
            },
            success: function success(res) {
              address = res.data.address || '';
              pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicReplyParam.address', address));
            }
          });
        }
        pageInstance.setData(newdata);
      }
    });
  };

  this.clearCommentInput = function (compindex) {
    var _pageInstance$setData19;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    pageInstance.setData((_pageInstance$setData19 = {}, (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.text', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.agent_user_token', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.address', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.latitude', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.longitude', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.comment_img_url', ''), (0, _defineProperty3.default)(_pageInstance$setData19, 'eles[' + compindex + '].topicReplyParam.articleId', ''), _pageInstance$setData19));
  };

  this.topicCancelReply = function (e) {
    var _pageInstance$setData20;

    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    pageInstance.setData((_pageInstance$setData20 = {}, (0, _defineProperty3.default)(_pageInstance$setData20, 'eles[' + compindex + '].topicReplyComment.isShow', false), (0, _defineProperty3.default)(_pageInstance$setData20, 'eles[' + compindex + '].topicReplyComment.focus', false), _pageInstance$setData20));
    _this3.clearCommentInput(compindex);
  };

  this.topicSubmitReply = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var that = _this3,
        _pageInstance$data$el = pageInstance.data.eles[compindex],
        topicReplyParam = _pageInstance$data$el.topicReplyParam,
        index = _pageInstance$data$el.topicReplyComment.index;


    topicReplyParam.text = topicReplyParam.text.trim(); // 去除两端的空格

    if (!topicReplyParam.text) {
      _app.appMethod.showModal({ content: '请填写回复内容' });
      return;
    }

    if (_app.appMethod.globalData.isTopicCommentSubmiting) {
      return;
    }
    _app.appMethod.globalData.isTopicCommentSubmiting = true;

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppSNS/AddComment',
      data: topicReplyParam,
      method: 'post',
      success: function success(res) {
        _app.appMethod.showToast({
          title: '回复成功',
          success: function success() {
            var _pageInstance$setData21;

            pageInstance.setData((_pageInstance$setData21 = {}, (0, _defineProperty3.default)(_pageInstance$setData21, 'eles[' + compindex + '].topicReplyComment.isShow', false), (0, _defineProperty3.default)(_pageInstance$setData21, 'eles[' + compindex + '].topicReplyComment.focus', false), _pageInstance$setData21));
          }
        });
        that.refreshOneTopicData({ articleId: topicReplyParam.article_id, compindex: compindex, index: index });
        that.clearCommentInput();
      },
      complete: function complete(res) {
        _app.appMethod.globalData.isTopicCommentSubmiting = false;
      }
    });
  };

  this.topicTurnToUsercenter = function (e) {
    var _e$currentTarget$data2 = e.currentTarget.dataset,
        usertoken = _e$currentTarget$data2.usertoken,
        sourcetype = _e$currentTarget$data2.sourcetype;

    if (sourcetype === undefined) {
      return;
    }
    _app.appMethod.turnToPage('/informationManagement/pages/communityUsercenter/communityUsercenter?detail=&usertoken=' + usertoken + '&sourcetype=' + sourcetype);
  };

  this.tapPrevewPictureHandler = function (e) {
    e.stopPropagation();
    _app.appMethod.tapPrevewPictureHandler(e);
  };

  this.topicSuspensionTouchEvent = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;

    var topicSuspension = pageInstance.data.eles[compindex].topicSuspension;
    var _systemInfo = _this3.systemInfo,
        windowWidth = _systemInfo.windowWidth,
        windowHeight = _systemInfo.windowHeight;
    var _e$touches$ = e.touches[0],
        clientX = _e$touches$.clientX,
        clientY = _e$touches$.clientY;

    if (e.type === 'touchstart') {
      var _e$currentTarget = e.currentTarget,
          offsetLeft = _e$currentTarget.offsetLeft,
          offsetTop = _e$currentTarget.offsetTop;

      var itemOffsetWidth = windowWidth / 750 * 80,
          itemOffsetHeight = windowWidth / 750 * 100,
          count = topicSuspension.topBtnShow ? 3 : 2;

      _this3.suspensionStyle = {
        width: itemOffsetWidth,
        height: itemOffsetHeight * count,
        deltX: clientX - offsetLeft,
        deltY: clientY - offsetTop
      };
      return;
    }
    var _suspensionStyle = _this3.suspensionStyle,
        width = _suspensionStyle.width,
        height = _suspensionStyle.height,
        deltX = _suspensionStyle.deltX,
        deltY = _suspensionStyle.deltY;

    var leftVal = clientX - deltX;
    var topVal = clientY - deltY;
    var maxLeftVal = windowWidth - width;
    var maxTopVal = windowHeight - height;
    leftVal < 0 && (rightVal = 0);
    leftVal > maxLeftVal && (leftVal = maxLeftVal);
    topVal < 0 && (topVal = 0);
    topVal > maxTopVal && (topVal = maxTopVal);

    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].topicSuspension.style', {
      top: (0, _tools.transformPx2Rem)(topVal),
      left: (0, _tools.transformPx2Rem)(leftVal),
      bottom: '.40rem',
      right: '.30rem'
    }));
  };

  this._refreshTopicList = function (targetCompIndex, requestData, pageInstance) {
    var _pageInstance$setData23;

    var categoryId = requestData.idx_arr.idx_value || '';
    pageInstance.setData((_pageInstance$setData23 = {}, (0, _defineProperty3.default)(_pageInstance$setData23, targetCompId + '.listParam.page', 1), (0, _defineProperty3.default)(_pageInstance$setData23, targetCompId + '.listParam.category_id', categoryId), (0, _defineProperty3.default)(_pageInstance$setData23, targetCompId + '.listStatus', {
      loading: false,
      isMore: true
    }), _pageInstance$setData23));
    _this3.getTopListData(targetCompIndex, pageInstance);
  };

  this.mode2articlestyle = function (mode) {
    var convert = {
      0: 2,
      1: 1,
      2: 1
    };
    return convert[mode];
  };
};

exports.default = TopicCustomComponent;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _list = __webpack_require__(49);

var _list2 = _interopRequireDefault(_list);

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(47);

__webpack_require__(33);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _app = __webpack_require__(4);

__webpack_require__(894);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'sign-in'
 * 组件：每日签到组件
 */
var SignInCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(SignInCustomComponent, _React$Component);

  function SignInCustomComponent(props) {
    (0, _classCallCheck3.default)(this, SignInCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignInCustomComponent.__proto__ || Object.getPrototypeOf(SignInCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  // 获取活动详情


  // 获取已连续签到的天数


  // 可领取的奖励列表


  // 获取用户连续签到提醒开关


  // 判断当天有无签到


  // 签到


  // 只获取时间轴


  // 获取日期数组


  // 查看每日可领取的奖励


  // 获取所有已签到的日期


  // 关闭领取成功窗口


  // 关闭领取奖励弹窗


  // 获取用户积分


  // 格式化时间轴数组


  // 阻止滚动穿透


  // 跳转路径页面


  // 推送模板消息


  // switch开关


  // 领取额外奖励按钮formId


  // 关闭领取奖励弹窗


  // 领取额外奖励


  (0, _createClass3.default)(SignInCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;

      var customFeature = data.customFeature,
          activityData = data.activityData,
          nodata = data.nodata,
          showSignMask = data.showSignMask,
          default_style = data.default_style,
          style_settings = data.style_settings,
          advance = data.advance,
          can_use_integral = data.can_use_integral,
          continuous_sign = data.continuous_sign,
          showDateArr = data.showDateArr,
          hasSign = data.hasSign,
          giftTips_con = data.giftTips_con,
          giftTips_acc = data.giftTips_acc,
          continuous_notice = data.continuous_notice,
          continuous_notice_user = data.continuous_notice_user,
          continuous_array = data.continuous_array,
          accumulate_array = data.accumulate_array,
          showSignSus = data.showSignSus,
          successTips = data.successTips,
          signInProgressWidth = data.signInProgressWidth,
          cur_date = data.cur_date;

      activityData = activityData || {};
      style_settings = style_settings || {};

      var nodataType = customFeature.nodataType;

      /**
       * @desc 活动未开始
       */

      var activityNoStart = function activityNoStart() {
        var content = null;
        if (!nodataType && !activityData.id && nodata) {
          content = _react2.default.createElement(
            'div',
            { className: 'signIn-notActive' },
            _react2.default.createElement(
              'div',
              { className: 'signIn-showImage' },
              _react2.default.createElement('img', { src: 'https://cdn.jisuapp.cn/static/webapp/images/retroactive/notActive.png' }),
              _react2.default.createElement(
                'div',
                { className: 'signIn-notActive-exp' },
                '\u6D3B\u52A8\u672A\u5F00\u59CB\uFF0C\u656C\u8BF7\u671F\u5F85'
              )
            )
          );
        }
        return content;
      };

      /**
       * @desc 有活动的情况
       */
      var signWrap = function signWrap() {
        return _react2.default.createElement(
          'div',
          null,
          activityData.id && _react2.default.createElement(
            'div',
            { className: 'qiandao-sign' },
            _react2.default.createElement('div', { className: 'signIn-sign-mask',
              style: { display: showSignMask ? 'block' : 'none' },
              onTouchMove: _this2.signInNotMove }),
            (default_style == 1 || default_style == 2) && _react2.default.createElement(
              'div',
              { className: 'signIn-sign-bg',
                style: { background: style_settings.background_image ? "url(" + style_settings.background_image + ") no-repeat center /100% 100%;" : style_settings.background_color
                } },
              _react2.default.createElement(
                'div',
                { className: 'signIn-sign-rule',
                  'data-type': 7,
                  onClick: _this2.signInNavigatorTo,
                  style: { color: advance.color_style ? advance.color_style.rule : "#FFFFFF",
                    background: advance.color_style ? advance.color_style.background : "linear-gradient(180deg, rgba(255, 195, 29, 1) 0%, rgba(255, 181, 64, 1) 100%)"
                  } },
                '\u89C4\u5219'
              ),
              _react2.default.createElement(
                'div',
                { className: 'signIn-cur-integral',
                  style: { color: advance.color_style ? advance.color_style.main : "" } },
                '\u5F53\u524D\u79EF\u5206'
              ),
              _react2.default.createElement(
                'div',
                { className: 'signIn-cur-integral-num',
                  style: { color: advance.color_style ? advance.color_style.main : "" } },
                can_use_integral || 0
              ),
              _react2.default.createElement(
                'div',
                { className: 'signIn-integral-record',
                  style: { color: advance.color_style ? advance.color_style.main : "",
                    border: '.01rem solid ' + (advance.color_style ? advance.color_style.main : "#fff")
                  },
                  'data-type': 1,
                  onClick: _this2.signInNavigatorTo },
                '\u79EF\u5206\u8BB0\u5F55'
              )
            ),
            default_style == 3 && _react2.default.createElement(
              'div',
              { style: { paddingBottom: "1.8rem" } },
              _react2.default.createElement(
                'div',
                { className: 'sign-bg3',
                  style: { background: style_settings.background_image ? 'url("' + style_settings.background_image + '") no-repeat center /100% 100%;' : style_settings.background_color
                  } },
                _react2.default.createElement(
                  'form',
                  { bindsubmit: 'signInSendFormId' },
                  _react2.default.createElement(
                    'div',
                    { className: 'sign-calendar3',
                      style: { backgroundColor: advance.color_style ? advance.color_style.sign_calendar : '' },
                      'data-compindex': _this2.props.index,
                      'data-type': 5,
                      'data-start': _this2.props.start_time,
                      'data-end': _this2.props.end_time,
                      onClick: _this2.signInNavigatorTo },
                    '\u7B7E\u5230\u65E5\u5386'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'sign-accumulateDays', style: { color: advance.color_style.sign_day } },
                  '\u7D2F\u8BA1\u7B7E\u5230',
                  _react2.default.createElement(
                    'span',
                    { style: { fontSize: ".48rem" } },
                    signedDays
                  ),
                  '\u5929'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'sign-signIn3' },
                  _react2.default.createElement(
                    'form',
                    { style: { margin: "0 auto" } },
                    _react2.default.createElement(
                      'button',
                      { type: 'button',
                        className: 'signIn-signactive',
                        style: { background: advance.color_style ? advance.color_style.main : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                          color: "#4D4338",
                          display: hasSign ? 'none' : 'hidden'
                        },
                        'data-compindex': _this2.props.index,
                        onClick: _this2.signInSubmit },
                      '\u7B7E\u5230'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-signed',
                        style: { background: advance.color_style ? advance.color_style.main : "linear-gradient(144deg,rgba(251,240,216,1) 0%,rgba(244,225,185,1) 100%)",
                          color: '#4D4338',
                          display: hasSign ? 'flex' : 'none'
                        } },
                      '\u5DF2\u7B7E\u5230'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-box' },
              _react2.default.createElement(
                'div',
                { className: 'signIn-sign-wrapper' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-sign-info' },
                  _react2.default.createElement(
                    'span',
                    { className: 'signIn-sign-sum' },
                    '\u5DF2\u8FDE\u7EED\u7B7E\u5230',
                    _react2.default.createElement(
                      'span',
                      { style: { color: advance.color_style ? advance.color_style.rule_span : "#F00",
                          margin: '0 .05rem',
                          fontWeight: 'bold'
                        } },
                      continuous_sign
                    ),
                    '\u5929'
                  ),
                  _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      'button',
                      { type: 'button',
                        className: 'signIn-sign-calendar',
                        'data-compindex': _this2.props.compindex,
                        'data-type': 5,
                        'data-start': _this2.props.start_time,
                        'data-end': _this2.props.end_time,
                        onClick: _this2.signInNavigatorTo,
                        style: { background: 'none', border: 'none', padding: 0 } },
                      _react2.default.createElement('span', { className: 'signIn-sign-calendarIcon' }),
                      '\u7B7E\u5230\u65E5\u5386'
                    )
                  )
                ),
                showDateArr.length > 1 && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'signIn-sign-progress-box',
                      style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.background, 0.2) : "#fff0b8"
                      } },
                    _react2.default.createElement('div', { className: 'signIn-sign-progress',
                      style: { width: +signInProgressWidth * 0.01 + 'rem',
                        backgroundColor: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "#FF7235" : "#930bd4"
                      } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'signIn-sign-date' },
                    showDateArr.map(function (item) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: item.date },
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-date-item' },
                          item.date === cur_date ? '今天' : item.date,
                          _react2.default.createElement('div', { className: 'signIn-date-dot',
                            style: { backgroundColor: advance.color_style ? advance.color_style.background : default_style === 1 ? "#ffaf52" : "#FFC568"
                            } }),
                          _react2.default.createElement(
                            'div',
                            { className: 'signIn-date-integral',
                              style: { background: advance.color_style ? advance.color_style.background : "linear-gradient(180deg, rgba(255, 223, 32, 1) 0%, rgba(255, 189, 31, 1) 100%)",
                                color: advance.color_style ? advance.color_style.rule : "#674444",
                                display: item.isSign ? 'none' : 'block'
                              } },
                            '+',
                            item.integral,
                            _react2.default.createElement('div', { className: 'signIn-date-triangle',
                              style: { borderTopColor: advance.color_style ? advance.color_style.background : "#ffc61f",
                                display: item.isSign ? 'none' : 'block'
                              } })
                          ),
                          item.isSign && _react2.default.createElement('div', { className: 'signIn-date-signIn',
                            style: { background: 'url(' + (advance ? advance.signed_icons : default_style === 1 ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn.png) no-repeat center/contain" : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/signIn2.png) no-repeat center/contain")
                            } }),
                          (item.accumulatedReward || item.continuousReward) && _react2.default.createElement('div', { className: 'signIn-date-gift',
                            style: { background: 'url(' + (advance ? advance.gift_icons : default_style === 1 ? "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift.png) no-repeat center/contain" : "https://cdn.jisuapp.cn/static/webapp/images/retroactive/gift2.png) no-repeat center/contain"),
                              display: item.date === cur_date && hasSign ? 'none' : 'block'
                            } })
                        )
                      );
                    })
                  )
                ),
                showDateArr.length === 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-last-date-box' },
                  _react2.default.createElement('img', { className: 'signIn-lastIcon', src: 'https://cdn.jisuapp.cn/static/webapp/images/retroactive/' + (hasSign ? "signIn.png" : "lastCoin.png") }),
                  _react2.default.createElement(
                    'span',
                    { className: 'signIn-lastTxt', style: { color: hasSign ? "#999" : "#674444" } },
                    hasSign ? "成功完成签到，你真棒" : '+' + showDateArr[showDateArr.length - 1].integral
                  ),
                  _react2.default.createElement('span', { className: 'signIn-lastTxt' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-sign-button' },
                  _react2.default.createElement(
                    'form',
                    { style: { margin: '0 auto' } },
                    _react2.default.createElement(
                      'button',
                      { type: 'button',
                        className: 'signIn-signactive',
                        style: { background: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                          display: hasSign ? 'none' : 'block'
                        },
                        'data-compindex': _this2.props.index,
                        onClick: _this2.signInSubmit },
                      '\u7B7E\u5230'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-signed',
                        style: { background: advance.color_style ? advance.color_style.rule_span : default_style === 1 ? "#ff6c19" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                          display: hasSign ? 'flex' : 'none'
                        } },
                      '\u5DF2\u7B7E\u5230'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-gift-tips' },
                  giftTips_con,
                  giftTips_con && giftTips_acc ? "，" : "",
                  giftTips_acc
                )
              ),
              continuous_notice == 1 && _react2.default.createElement(
                'div',
                { className: 'signIn-sign-remind' },
                _react2.default.createElement(
                  _list2.default,
                  null,
                  _react2.default.createElement(
                    _list2.default.Item,
                    {
                      extra: _react2.default.createElement(_switch2.default, { className: 'switch',
                        color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? '#fe4739' : '#801dfe',
                        checked: continuous_notice_user,
                        onChange: function onChange(e) {
                          return _this2.signInChangeSwitch(e, _this2.props.index);
                        } }) },
                    _react2.default.createElement(
                      'div',
                      { className: 'signIn-remind-box' },
                      _react2.default.createElement('div', { className: 'signIn-icon-shalou' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'signIn-remind-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-remind-info-t' },
                          '\u8FDE\u7EED\u7B7E\u5230\u63D0\u9192'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'signIn-remind-info-b' },
                          '\u5F00\u542F\u5F00\u5173\uFF0C\u6BCF\u592912:00\u5C06\u4F1A\u4EE5\u6A21\u677F\u6D88\u606F\u65B9\u5F0F\u63D0\u9192'
                        )
                      )
                    )
                  )
                )
              ),
              continuous_array && continuous_array.rewards && continuous_array.rewards.length > 0 && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u8FDE\u7EED\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#FE4739" : "#6240FE",
                      display: continuous_array.kind_limit == 99999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  continuous_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  continuous_array.rewards.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      (item.received || continuous_array.received_times != continuous_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          continuous_array.kind_limit != continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          continuous_array.kind_limit == continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && continuous_array.received_times < continuous_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                padding: 0
                              },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.rule_text, 0.1) : default_style === 1 ? "rgba(255, 240, 219, 1)" : "rgba(128, 29, 254, 0.1)",
                                color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f" : "#6240FE"
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && continuous_array.received_times == continuous_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              ),
              accumulate_array && accumulate_array.rewards && accumulate_array.rewards.length > 0 && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                accumulate_array.accumulate_type == 2 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u5F53\u6708\u7D2F\u8BA1\u7B7E\u5230\u6EE1',
                  accumulate_array.hit_day,
                  '\u5929\u989D\u5916\u5956\u52B1'
                ),
                accumulate_array.accumulate_type == 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u7D2F\u8BA1\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#FE4739" : "#6240FE",
                      display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  accumulate_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  accumulate_array.rewards.map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      (item.received || accumulate_array.received_times != accumulate_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          accumulate_array.kind_limit != accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          accumulate_array.kind_limit == accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && accumulate_array.received_times < accumulate_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "linear-gradient(90deg, rgba(255, 135, 0, 1) 0%, rgba(255, 67, 62, 1) 100%)" : "linear-gradient(90deg, rgba(197, 48, 249, 1) 0%, rgba(116, 59, 255, 1) 100%)",
                                padding: 0
                              },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.rule_text, 0.1) : default_style === 1 ? "rgba(255, 240, 219, 1)" : "rgba(128, 29, 254, 0.1)",
                                color: advance.color_style ? advance.color_style.rule_text : default_style === 1 ? "#ff7e0f" : "#6240FE"
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && accumulate_array.received_times >= accumulate_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            default_style == 3 && _react2.default.createElement(
              'div',
              { className: 'signIn-sign-box',
                style: { paddingBottom: continuous_array.rewards.length || accumulate_array.rewards.length ? "1.5rem" : "" } },
              continuous_array.rewards.length && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u8FDE\u7EED\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.main : "",
                      display: continuous_array.kind_limit == 99999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  continuous_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  continuous_array.rewards.map(function (item) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: item.id },
                      (item.received || continuous_array.received_times != continuous_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          continuous_array.kind_limit != continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.rewards.length !== 4 && continuous_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          continuous_array.kind_limit == _this2.continuous_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            continuous_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            continuous_array.kind_limit != 4 && continuous_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && continuous_array.received_times < continuous_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.main : "", padding: 0 },
                              'data-type': item.type,
                              'data-method': 2,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.main, 0.1) : "",
                                color: advance.color_style ? advance.color_style.main : ""
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: function onClick(e) {
                                return _this2.signInNavigatorTo(e);
                              } },
                            '\u67E5\u770B'
                          ),
                          !item.received && continuous_array.received_times == continuous_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              ),
              accumulate_array.rewards.length && _react2.default.createElement(
                'div',
                { className: 'signIn-reward-box' },
                accumulate_array.accumulate_type == 2 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u5F53\u6708\u7D2F\u8BA1\u7B7E\u5230\u6EE1',
                  accumulate_array.hit_day,
                  '\u5929\u989D\u5916\u5956\u52B1'
                ),
                accumulate_array.accumulate_type == 1 && _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-title' },
                  '\u7D2F\u8BA1\u7B7E\u5230\u989D\u5916\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-chooseNum',
                    style: { color: advance.color_style ? advance.color_style.main : '',
                      display: accumulate_array.kind_limit == 9999 ? 'none' : 'block'
                    } },
                  '\u4EE5\u4E0B\u5956\u52B1\u9009',
                  accumulate_array.kind_limit || 1,
                  '\u4E2A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'signIn-reward-type' },
                  accumulate_array.rewards.map(function (item) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: item.id },
                      (item.received || accumulate_array.received_times != accumulate_array.kind_limit) && _react2.default.createElement(
                        'div',
                        { className: 'signIn-reward-item' },
                        _react2.default.createElement(
                          'div',
                          null,
                          item.type === 1 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u79EF\u5206'
                          ),
                          item.type === 2 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u50A8\u503C'
                          ),
                          item.type === 3 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F18\u60E0\u5238'
                          ),
                          item.type === 4 && _react2.default.createElement(
                            'div',
                            { className: 'signIn-award-top' },
                            '\u4F1A\u5458\u5361'
                          ),
                          accumulate_array.kind_limit != accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.rewards.length === 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length === 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.rewards.length !== 4 && accumulate_array.rewards.length !== 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          ),
                          accumulate_array.kind_limit == accumulate_array.received_times && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            accumulate_array.kind_limit == 4 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.3rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit == 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '1.56rem' } },
                              item.title ? item.title : item.value
                            ),
                            accumulate_array.kind_limit != 4 && accumulate_array.kind_limit != 3 && _react2.default.createElement(
                              'div',
                              { className: 'signIn-award-bottom', style: { maxWidth: '2.6rem' } },
                              item.title ? item.title : item.value
                            )
                          )
                        ),
                        _react2.default.createElement(
                          'form',
                          null,
                          !item.received && accumulate_array.received_times < accumulate_array.kind_limit && _react2.default.createElement(
                            'button',
                            { type: 'button',
                              className: 'signIn-getRewardBtn signIn-get-reward',
                              style: { background: advance.color_style ? advance.color_style.main : '', padding: 0 },
                              'data-type': item.type,
                              'data-method': 3,
                              'data-compindex': _this2.props.index,
                              onClick: _this2.signInReceiveExtReward },
                            '\u9886\u53D6'
                          ),
                          item.received && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-see_get-reward',
                              style: { background: advance.color_style ? _this2.getRgbColor(advance.color_style.main, 0.1) : '',
                                color: advance.color_style ? advance.color_style.main : ''
                              },
                              'data-detail': item.value,
                              'data-type': item.type,
                              onClick: _this2.signInNavigatorTo },
                            '\u67E5\u770B'
                          ),
                          !item.received && accumulate_array.received_times >= accumulate_array.kind_limit && _react2.default.createElement(
                            'div',
                            { className: 'signIn-getRewardBtn signIn-cant_get-reward' },
                            '\u4E0D\u53EF\u9886\u53D6'
                          )
                        )
                      )
                    );
                  })
                )
              )
            ),
            successWrap()
          )
        );
      };

      var successWrap = function successWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'signIn-sign-success',
            onTouchMove: _this2.signInNotMove,
            style: { display: showSignSus ? 'block' : 'none' } },
          _react2.default.createElement('div', { className: 'signIn-sign-success-bg' }),
          _react2.default.createElement(
            'div',
            { className: 'signIn-sign-success-box' },
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-success-tip' },
              successTips
            ),
            _react2.default.createElement(
              'div',
              { className: 'signIn-sign-success-btn signIn-index',
                'data-compindex': _this2.props.index,
                onClick: _this2.signInSusClose },
              '\u786E\u5B9A'
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component sign-in' },
        activityNoStart(),
        signWrap()
      );
    }
  }]);
  return SignInCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    _app.appMethod.getStorage({
      'key': 'activityData',
      success: function success(res) {
        _this3.signInExtraRewards(compindex, pageInstance, Number(res && res.data && res.data.id));
      }
    });
    _this3.signInGetActivity(compindex, pageInstance);
  };

  this.signInGetActivity = function (compindex, pageInstance) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetEffectActivity',
      data: {},
      success: function success(res) {
        _app.appMethod.setStorage({
          key: 'activityData',
          data: res.data
        });
        var start_time = new Date(res.data.start_time * 1000).toLocaleDateString();
        var end_time = new Date(res.data.end_time * 1000).toLocaleDateString();
        var activityData = res.data;
        var style_settings = res.data.style_settings;
        var advance = res.data.style_settings.advance || '';
        var cur_date = _util2.default.formatTimeYMD('', 'MM.DD'); // 获取当前时间
        newData['eles[' + compindex + '].start_time'] = start_time;
        newData['eles[' + compindex + '].end_time'] = end_time;
        newData['eles[' + compindex + '].cur_date'] = cur_date;
        newData['eles[' + compindex + '].sign_type'] = res.data.sign_type;
        newData['eles[' + compindex + '].continuous_notice'] = res.data.continuous_notice;
        newData['eles[' + compindex + '].activity_id'] = Number(res.data.id);
        newData['eles[' + compindex + '].activityData'] = activityData;
        newData['eles[' + compindex + '].style_settings'] = style_settings;
        newData['eles[' + compindex + '].default_style'] = style_settings.default_style;
        newData['eles[' + compindex + '].advance'] = advance;
        newData['eles[' + compindex + '].isLoading'] = false;

        newData['eles[' + compindex + '].showDateArr'] = [];
        newData['eles[' + compindex + '].sendFormIdTimes'] = 0;
        newData['eles[' + compindex + '].showGetRetroModal'] = false;
        newData['eles[' + compindex + '].showSignMask'] = false;
        newData['eles[' + compindex + '].showSignSus'] = false;
        newData['eles[' + compindex + '].showExchangeModal'] = false;
        newData['eles[' + compindex + '].timer'] = null;
        pageInstance.setData(newData);
        _this3.signInGetContinuousDay(compindex, pageInstance); // 连续签到日期
        _this3.signInExtraRewards(compindex, pageInstance); // 查看可领额外奖励
        if (res.data.continuous_notice === '1') {
          _this3.signInGetUserNotice(compindex, pageInstance); // 查询用户连续签到提醒设置
        }
      },
      successStatusAbnormal: function successStatusAbnormal() {
        newData['eles[' + compindex + '].nodata'] = true;
        pageInstance.setData(newData);
        return false;
      }
    });
  };

  this.signInGetContinuousDay = function (compindex, pageInstance) {
    var newData = {};
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetContinuousDay',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_sign'] = res.data.continuous_sign;
        pageInstance.setData(newData);
        _this3.signInDateIsSign(compindex, pageInstance); // 判断今日是否签到
      }
    });
  };

  this.signInExtraRewards = function (compindex, pageInstance, id) {
    var newData = {};
    var activity_id = id || pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetExtraRewards',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_array'] = res.data.continuous;
        newData['eles[' + compindex + '].accumulate_array'] = res.data.accumulate;
        pageInstance.setData(newData);
      },
      successStatusAbnormal: function successStatusAbnormal() {
        return false;
      }
    });
  };

  this.signInGetUserNotice = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetUserNoticeSwitch',
      data: {
        activity_id: activity_id
      },
      success: function success(res) {
        newData['eles[' + compindex + '].continuous_notice_user'] = res.data == 0 ? false : true;
        pageInstance.setData(newData);
      },
      successStatusAbnormal: function successStatusAbnormal() {
        return false;
      }
    });
  };

  this.signInDateIsSign = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/DateIsSign',
      data: {
        activity_id: activity_id,
        sign_date: new Date().toDateString()
      },
      success: function success(res) {
        var newData = {};
        if (res.data.is_sign) {
          newData['eles[' + compindex + '].hasSign'] = true;
          pageInstance.setData(newData);
        } else if (pageInstance.data.eles[compindex].sign_type == 2) {
          // 开启极速签到 
          _this3.signIn(compindex, pageInstance, '');
        }
        _this3.getTimeLength(compindex, pageInstance);
      }
    });
  };

  this.signIn = function (compindex, pageInstance, form_id) {
    var width = 0;
    var newData = {};
    var sign_type = pageInstance.data.eles[compindex].sign_type;
    var cur_date = pageInstance.data.eles[compindex].cur_date;
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var hasSign = pageInstance.data.eles[compindex].hasSign;
    var showDateArr = [].concat((0, _toConsumableArray3.default)(pageInstance.data.eles[compindex].showDateArr));
    var isLoading = pageInstance.data.eles[compindex].isLoading; // false
    if (isLoading) return;
    newData['eles[' + compindex + '].isLoading'] = true;
    pageInstance.setData(newData);
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/SignIn',
      method: 'post',
      data: {
        activity_id: activity_id,
        homepageRouter: 'pages/' + _app.appMethod.globalData.homepageRouter + '/' + _app.appMethod.globalData.homepageRouter,
        form_id: form_id
      },
      success: function success(res) {
        for (var i = 0; i < showDateArr.length; i++) {
          if (showDateArr[i].date === cur_date) {
            showDateArr[i].isSign = true;
            // 展示数组的总宽度是 630 去掉前端和后端 应为540 
            if (!hasSign && i === 0) {
              width = 20;
            } else {
              width = i / (showDateArr.length - 1) * 540 + 60;
            }
            newData['eles[' + compindex + '].signInProgressWidth'] = width;
          }
        }
        newData['eles[' + compindex + '].hasSign'] = true;
        newData['eles[' + compindex + '].showDateArr'] = showDateArr;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].successTips'] = sign_type == 2 ? '极速签到成功' : '签到成功';
        pageInstance.setData(newData, function () {
          _this3.signInRewardCheck(compindex, pageInstance); // 获取每日额外奖励
          _this3.signInExtraRewards(compindex, pageInstance); //  查看可额外领取的奖励
          _this3.signInGetSignedDates(compindex, pageInstance); // 查询所有已签到的日期
          _this3.signInGetContinuousDay(compindex, pageInstance); // 获取已连续签到的天数
          _this3.signInCloseSignModal(compindex, pageInstance); // 关闭弹窗
          _this3.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        });
      },
      complete: function complete(res) {}
    });
  };

  this.getTimeLength = function (compindex, pageInstance) {
    // 拿到今天的日期，连续签到的天数,
    var st = new Date();
    var et = new Date();
    var day1 = pageInstance.data.eles[compindex].start_time;
    var day2 = pageInstance.data.eles[compindex].end_time;
    var continuous_sign = pageInstance.data.eles[compindex].continuous_sign;
    var hasSign = pageInstance.data.eles[compindex].hasSign;
    // 若连续签到为7天的倍数  开始时间则为今天
    if (continuous_sign % 7 == 0 && !hasSign) {} else {
      // 否则开始时间则往前算连续签到的天数 取余
      continuous_sign = hasSign ? continuous_sign - 1 : continuous_sign;
      st = new Date(st.getTime() - continuous_sign % 7 * 24 * 60 * 60 * 1000);
    }
    // 时间轴长度
    var date_length = Math.floor((new Date(day2).getTime() - st.getTime()) / (24 * 60 * 60 * 1000)) + 1;
    if (date_length >= 7) {
      et = _util2.default.formatTimeYMD(new Date(st.getTime() + 6 * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD');
    } else {
      et = _util2.default.formatTimeYMD(new Date(st.getTime() + date_length * (24 * 60 * 60 * 1000)), 'YYYY/MM/DD');
    }
    st = _util2.default.formatTimeYMD(st, 'YYYY/MM/DD');
    var dateArr = _this3.signInGetDays(st, et);
    var newData = {};
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    pageInstance.setData(newData);
    _this3.signInRewardCheck(compindex, pageInstance); // 查询每日奖励
  };

  this.signInGetDays = function (day1, day2) {
    var st = new Date(day1);
    var et = new Date(day2);
    var arr = [];
    // 获取开始的日期 (年，月，日)
    var yyyy = st.getFullYear(),
        mm = st.getMonth(),
        dd = st.getDate();
    // 循环
    while (st.getTime() <= et.getTime()) {
      arr.push(_util2.default.formatNumber(st.getMonth() + 1) + '.' + _util2.default.formatNumber(st.getDate()));
      // 使用dd++进行天数的自增
      st = new Date(yyyy, mm, ++dd);
    };
    var brr = arr.map(function (item, index) {
      return {
        isSign: false,
        date: item
      };
    });
    return brr;
  };

  this.signInRewardCheck = function (compindex, pageInstance) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    var dateArr = pageInstance.data.eles[compindex].dateArr;
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/DaysRewards',
      data: {
        'activity_id': activity_id,
        'days': dateArr.length
      },
      success: function success(res) {
        for (var i = 0; i < dateArr.length; i++) {
          for (var j = 0; j < res.data.length; j++) {
            // 获取当日日期
            if (_util2.default.formatTimeYMD(res.data[j].timestamps, 'MM.DD') == dateArr[i].date) {
              dateArr[i].accumulatedReward = res.data[j].accumulatedReward;
              dateArr[i].continuousReward = res.data[j].continuousReward;
              dateArr[i].integral = res.data[j].integral;
            }
          }
        }
        newData['eles[' + compindex + '].giftTips_con'] = res.continuous_str;
        newData['eles[' + compindex + '].giftTips_acc'] = res.accumulated_str;
        newData['eles[' + compindex + '].dateArr'] = [].concat((0, _toConsumableArray3.default)(dateArr));
        pageInstance.setData(newData);
        _this3.signInGetSignedDates(compindex, pageInstance, _this3.signInFn); // 查询所有已签到的日期
      }
    });
  };

  this.signInGetSignedDates = function (compindex, pageInstance, fn) {
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/GetSignedDates',
      data: {
        activity_id: activity_id,
        include_today: 1
      },
      success: function success(res) {
        typeof fn == 'function' && fn(compindex, pageInstance, res.data);
      }
    });
  };

  this.signInCloseSignModal = function (compindex, pageInstance) {
    clearTimeout(pageInstance.data.eles[compindex].timer);
    pageInstance.data.eles[compindex].timer = setTimeout(function () {
      _this3.signInGetIntegral(compindex, pageInstance);
    }, 3000);
  };

  this.signInGetIntegral = function (compindex, pageInstance) {
    var newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  };

  this.signInGetIntegralInfo = function (compindex, pageInstance) {
    var newData = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetIntegralInfo',
      data: {},
      success: function success(res) {
        newData['eles[' + compindex + '].can_use_integral'] = res.data.can_use_integral;
        pageInstance.setData(newData);
      }
    });
  };

  this.signInFn = function (compindex, pageInstance, opt) {
    var dateArr = pageInstance.data.eles[compindex].dateArr;

    var cur_date = pageInstance.data.eles[compindex].cur_date;
    var hasSign = pageInstance.data.eles[compindex].hasSign;

    var newArray = opt.map(function (item) {
      return _util2.default.formatTimeYMD(item, 'MM.DD');
    });

    for (var i = 0; i < dateArr.length; i++) {
      for (var j = 0; j < newArray.length; j++) {
        if (dateArr[i].date === newArray[j]) {
          dateArr[i].isSign = true;
        }
      }
    }

    // dateArr = this.signInSplitPassed(dateArr, cur_date, compindex, pageInstance);
    // let splitDateArr = this.signInSplitArray(dateArr, 7); // 显示时间轴最长为7天
    // let result = this.signInGetShowDateArr(splitDateArr, cur_date);
    // let showDateArr = splitDateArr[result.index]; // 没有签到就从数组中去掉，第一个日期为今天
    var showDateArr = dateArr;
    var newData = {};
    var width = 0;
    // 设置进度条长度
    for (var k = 0; k < showDateArr.length; k++) {
      if (showDateArr[k].date === cur_date) {
        // 展示数组的总宽度是 630 去掉前端和后端 应为540 
        if (!hasSign && k === 0) {
          width = 20;
        } else {
          width = k / (showDateArr.length - 1) * 540 + 60;
        }
        newData['eles[' + compindex + '].signInProgressWidth'] = width;
      }
    }
    newData['eles[' + compindex + '].dateArr'] = dateArr;
    newData['eles[' + compindex + '].showDateArr'] = showDateArr;
    newData['eles[' + compindex + '].signedDays'] = opt.length;
    pageInstance.setData(newData);
  };

  this.signInNotMove = function (e) {};

  this.signInNavigatorTo = function (e) {
    var type = e.currentTarget.dataset.type.toString();
    var url = '';
    switch (type) {
      case '1':
        url = '/userCenter/pages/myIntegral/myIntegral';
        break;
      case '2':
        url = '/eCommerce/pages/balance/balance';
        break;
      case '3':
        url = '/eCommerce/pages/couponList/couponList';
        break;
      case '4':
        var detail = e.target.dataset.detail;
        url = '/eCommerce/pages/vipCard/vipCard?is_paid_vip=1&detail=' + detail;
        break;
      case '5':
        var start_time = e.target.dataset.start;
        var end_time = e.target.dataset.end;
        url = '/signIn/pages/calendar/calendar' + '?start_time=' + start_time + '&end_time=' + end_time;
        break;
      case '6':
        url = '/signIn/pages/retroactive/retroactive';
        break;
      case '7':
        url = '/signIn/pages/rule/rule';
        break;
    }
    _app.appMethod.turnToPage(url, false);
  };

  this.signInSubmit = function (e) {
    // TODO
    // let form_id = e.detail.formId || '';
    var form_id = '';
    var compindex = e.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();

    _this3.signIn(compindex, pageInstance, form_id);
    _this3.signInSendForm(compindex, pageInstance, form_id);
  };

  this.signInSendForm = function (compindex, pageInstance, form_id) {
    var sendFormIdTimes = pageInstance.data.eles[compindex].sendFormIdTimes;
    var newData = {};
    if (sendFormIdTimes === 0) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
        data: {
          form_id: form_id
        },
        method: 'post',
        success: function success(res) {
          newData['eles[' + compindex + '].sendFormIdTimes'] = 2;
          pageInstance.setData(newData);
        }
      });
    }
  };

  this.signInChangeSwitch = function (checked, compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    // TODO
    // let checked = e.target.value;
    var newData = {};
    newData['eles[' + compindex + '].continuous_notice_user'] = checked;
    pageInstance.setData(newData);
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/SignNoticeSwitch',
      data: {
        'activity_id': activity_id,
        'switch': checked ? 1 : 0
      },
      success: function success(res) {
        if (res.status !== 0) {
          newData['eles[' + compindex + '].continuous_notice_user'] = !checked;
          pageInstance.setData(newData);
        }
      }
    });
  };

  this.signInReceiveExtReward = function (e) {
    // TODO
    // let form_id = e.detail.formId;
    var form_id = '';
    var type = e.currentTarget.dataset.type;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var method = e.currentTarget.dataset.method;
    _this3.signInGetReward(compindex, pageInstance, form_id, type, method);
  };

  this.signInSusClose = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.target.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].showSignMask'] = false;
    newData['eles[' + compindex + '].showSignSus'] = false;
    pageInstance.setData(newData);
  };

  this.signInGetReward = function (compindex, pageInstance, form_id, type, method) {
    var newData = {};
    var activity_id = pageInstance.data.eles[compindex].activity_id;
    _app.appMethod.sendRequest({
      url: '/index.php?r=appSignActivity/ReceiveExtraReward',
      data: {
        activity_id: activity_id,
        reward_type: type,
        received_method: method,
        form_id: form_id
      },
      success: function success(res) {
        switch (type) {
          case 1:
            type = '积分';
            break;
          case 2:
            type = '储值';
            break;
          case 3:
            type = '优惠券';
            break;
          case 4:
            type = '会员卡';
            break;
        }
        newData['eles[' + compindex + '].showSignMask'] = true;
        newData['eles[' + compindex + '].showSignSus'] = true;
        newData['eles[' + compindex + '].successTips'] = type + '领取成功';
        pageInstance.setData(newData);
        _this3.signInExtraRewards(compindex, pageInstance); // 查看
        if (type == '积分') {
          _this3.signInGetIntegralInfo(compindex, pageInstance); // 刷新积分
        }
      },
      successStatusAbnormal: function successStatusAbnormal() {
        _app.appMethod.showToast({
          title: '库存不足',
          icon: 'none',
          duration: 1500
        });
        return false;
      }
    });
    _this3.signInCloseSignModal(compindex, pageInstance);
  };

  this.getRgbColor = function (sHex) {
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    arr = [sHex.substring(1, 3), sHex.substring(3, 5), sHex.substring(5)];
    brr = arr.map(function (item, index) {
      return parseInt(item, 16);
    });
    return 'rgba(' + brr.join(',') + ',' + alpha + ')';
  };
};

exports.default = SignInCustomComponent;

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(896);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'group-buy-list'
 * 组件：拼团列表组件
 */
var GroupBuyListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(GroupBuyListCustomComponent, _React$Component);

  function GroupBuyListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, GroupBuyListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (GroupBuyListCustomComponent.__proto__ || Object.getPrototypeOf(GroupBuyListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(GroupBuyListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          goods_data = data.goods_data;

      var styleObj = (0, _tools.convertStyleData)(data.style);
      // 是否为竖版
      var hor = customFeature.mode == 2 && data.curpage > 0;
      var mode = customFeature.mode,
          lineHeight = customFeature.lineHeight,
          margin = customFeature.margin,
          lineBackgroundColor = customFeature.lineBackgroundColor,
          imgHeight = customFeature.imgHeight,
          imgWidth = customFeature.imgWidth,
          isShowGroupBuyStatus = customFeature.isShowGroupBuyStatus,
          isShowCountdown = customFeature.isShowCountdown,
          isShowVirtualPrice = customFeature.isShowVirtualPrice,
          isShowSales = customFeature.isShowSales;


      lineHeight = (0, _tools.transformPx2Rem)(lineHeight, 320);
      margin = (0, _tools.transformPx2Rem)(margin, 320);
      imgHeight = (0, _tools.transformPx2Rem)(imgHeight, 320);
      imgWidth = (0, _tools.transformPx2Rem)(imgWidth, 320);

      /**
       * @desc 状态
       */
      var joinStatus = function joinStatus(item, index) {
        return _react2.default.createElement(
          'div',
          { className: 'to-join' },
          item.status == 0 && _react2.default.createElement(
            'button',
            { className: 'ready' },
            '\u5373\u5C06\u5F00\u56E2'
          ),
          item.status == 1 && _react2.default.createElement(
            'button',
            { className: 'remain',
              'data-goodsid': item.goods_id,
              'data-activityid': item.activity_id,
              'data-index': index,
              'data-compindex': _this3.props.index,
              onClick: _this3.remainMe },
            '\u63D0\u9192\u6211'
          ),
          item.status == 2 && _react2.default.createElement(
            'button',
            { className: 'reminded' },
            '\u5DF2\u63D0\u9192'
          ),
          item.status == 3 && _react2.default.createElement(
            'button',
            { className: 'go' },
            item.activity_type == 4 ? '参与抽奖' : '去拼团'
          ),
          item.status == 4 && _react2.default.createElement(
            'button',
            { className: 'over' },
            '\u5DF2\u7ED3\u675F'
          )
        );
      };

      var salesWrap = function salesWrap(item, index) {
        var wrap = null;
        if ((mode == 1 || mode == 2) && isShowSales) {
          wrap = _react2.default.createElement(
            'div',
            { className: 'hava-sales' },
            _react2.default.createElement(
              'div',
              { className: 'price' },
              _react2.default.createElement(
                'span',
                { className: 'min-price' },
                '\xA5',
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '.36rem' } },
                  item.group_buy_price
                )
              ),
              isShowVirtualPrice && _react2.default.createElement(
                'span',
                { className: 'origin-price' },
                '\xA5',
                item.original_price
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'status' },
              _react2.default.createElement(
                'div',
                { className: 'sales' },
                '\u5DF2\u56E2',
                item.goods_count,
                '\u4EF6'
              ),
              joinStatus(item, index)
            )
          );
        } else if ((mode == 1 || mode == 2) && !isShowSales) {
          wrap = _react2.default.createElement(
            'div',
            { className: 'no-sales' },
            _react2.default.createElement(
              'div',
              { className: 'price' },
              _react2.default.createElement(
                'div',
                { className: 'min-price' },
                '\xA5',
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '.36rem' } },
                  item.group_buy_price
                )
              ),
              isShowVirtualPrice && _react2.default.createElement(
                'div',
                { className: 'origin-price' },
                '\xA5',
                item.original_price
              )
            ),
            joinStatus(item, index)
          );
        } else if (mode == 3) {
          wrap = _react2.default.createElement(
            'div',
            { className: 'sales-status' },
            _react2.default.createElement(
              'div',
              { className: 'price' },
              _react2.default.createElement(
                'span',
                { className: 'min-price' },
                '\xA5',
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: '.36rem' } },
                  item.group_buy_price
                )
              ),
              isShowVirtualPrice && _react2.default.createElement(
                'span',
                { className: 'origin-price' },
                '\xA5',
                item.original_price
              ),
              isShowSales && _react2.default.createElement(
                'div',
                { className: 'sales' },
                '\u5DF2\u56E2',
                item.goods_count,
                '\u4EF6'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'status' },
              joinStatus(item, index)
            )
          );
        }
        return wrap;
      };

      var groupListOne = function groupListOne() {
        return _react2.default.createElement(
          'div',
          { className: 'js-list-container group-list list' },
          goods_data && goods_data.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'background-ele goods-item',
                key: index,
                style: {
                  height: lineHeight,
                  marginBottom: margin,
                  background: lineBackgroundColor
                },
                'data-goodsid': item.goods_id,
                'data-activityid': item.activity_id,
                'data-status': item.status,
                'data-app-id': item.app_id,
                onClick: _this3.gotoGroupDetail },
              _react2.default.createElement(
                'div',
                { className: 'image-wrap',
                  style: {
                    width: imgWidth,
                    height: imgHeight
                  } },
                _react2.default.createElement('img', { src: item.cover })
              ),
              _react2.default.createElement(
                'div',
                { className: 'content-wrap',
                  style: { width: 'calc(100% - ' + imgWidth + ' - .2rem)' } },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  isShowGroupBuyStatus && _react2.default.createElement(
                    'div',
                    { className: 'type', style: { background: lineBackgroundColor } },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('i', { className: 'icon-moon icon-number-people' })
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.activity_type == 0 ? item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团'
                    )
                  ),
                  item.isSubShopGoods ? '【' + item.app_sub_shop_name + '】' : '',
                  item.title
                ),
                item.status != 4 && isShowCountdown && !(item.status == 3 && item.end_date == '-1') ? _react2.default.createElement(
                  'div',
                  { className: 'same-line' },
                  _react2.default.createElement(
                    'div',
                    { className: 'first-line' },
                    _react2.default.createElement(
                      'div',
                      { className: 'price-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'min-price' },
                        '\xA5',
                        _react2.default.createElement(
                          'span',
                          { style: { fontSize: '.37rem' } },
                          item.group_buy_price
                        )
                      ),
                      isShowVirtualPrice && _react2.default.createElement(
                        'span',
                        { className: 'origin-price' },
                        '\xA5',
                        item.original_price
                      )
                    ),
                    joinStatus(item, index)
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'second-line' },
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-num' },
                      isShowSales && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        '\u5DF2\u56E2',
                        item.goods_count,
                        '\u4EF6'
                      )
                    ),
                    !(item.status == 3 && item.end_date == '-1') && _react2.default.createElement(
                      'div',
                      { className: 'count-big-down' },
                      item.status != 3 ? '距开始' : '距结束',
                      item.downCount.days != '00' && item.downCount.days != '0' ? item.downCount.days + '天' : "",
                      item.downCount.hours,
                      ' : ',
                      item.downCount.minutes,
                      ' : ',
                      item.downCount.seconds
                    )
                  )
                ) : _react2.default.createElement(
                  'div',
                  { className: 'differ-line' },
                  _react2.default.createElement(
                    'div',
                    { className: 'first-line' },
                    _react2.default.createElement(
                      'div',
                      { className: 'price-detail' },
                      _react2.default.createElement(
                        'span',
                        { className: 'min-price' },
                        '\xA5',
                        _react2.default.createElement(
                          'span',
                          { style: { fontSize: '.36rem' } },
                          item.group_buy_price
                        )
                      ),
                      isShowVirtualPrice && _react2.default.createElement(
                        'span',
                        { className: 'origin-price' },
                        '\xA5',
                        item.original_price
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'sales-num' },
                      isShowSales && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        '\u5DF2\u56E2',
                        item.goods_count,
                        '\u4EF6'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'second-line' },
                    joinStatus(item, index)
                  )
                )
              )
            );
          })
        );
      };

      /**
       * @desc 团列表
       */
      var groupList = function groupList() {
        var type = {
          1: 'opposite',
          3: 'bigPicture'
        }[mode] || '';
        return _react2.default.createElement(
          'div',
          { className: 'js-list-container group-list ' + type },
          goods_data && goods_data.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'background-ele goods-item',
                key: index,
                style: {
                  height: lineHeight,
                  marginBottom: margin,
                  background: lineBackgroundColor
                },
                'data-goodsid': item.goods_id,
                'data-activityid': item.activity_id,
                'data-status': item.status,
                'data-app-id': item.app_id,
                onClick: _this3.gotoGroupDetail },
              _react2.default.createElement(
                'div',
                { className: 'image-wrap', style: { width: imgWidth, height: imgHeight } },
                _react2.default.createElement('img', { src: item.cover }),
                item.status != 4 && isShowCountdown && _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  !(item.status == 3 && item.end_date == '-1') && item.status != 4 && _react2.default.createElement(
                    'div',
                    { className: 'count-down ' + (item.status == 0 || item.status == 1 ? 'ready' : 'going') },
                    _react2.default.createElement(
                      'div',
                      { className: 'group-buy-status' },
                      item.status != 3 && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        '\u8DDD\u5F00\u59CB'
                      ),
                      item.status == 3 && item.end_date != '-1' && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        '\u8DDD\u7ED3\u675F'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      item.downCount.days != '00' && item.downCount.days != '0' && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                          'div',
                          null,
                          item.downCount.days
                        ),
                        _react2.default.createElement(
                          'span',
                          null,
                          ' \u5929 '
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        item.downCount.hours
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        ' : '
                      ),
                      _react2.default.createElement(
                        'div',
                        { style: { width: '.48rem' } },
                        item.downCount.minutes
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        ' : '
                      ),
                      _react2.default.createElement(
                        'div',
                        { style: { width: '.48rem' } },
                        item.downCount.seconds
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'content-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  isShowGroupBuyStatus && _react2.default.createElement(
                    'div',
                    { className: 'type', style: { background: lineBackgroundColor } },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('i', { className: 'icon-moon icon-number-people' })
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.activity_type == 0 ? item.num_of_people.length > 1 ? '多人团' : item.num_of_people[0] + '人团' : item.activity_type == 1 ? '新人团' : item.activity_type == 2 ? '阶梯团' : item.activity_type == 3 ? '帮帮团' : '抽奖团'
                    )
                  ),
                  item.isSubShopGoods ? '【' + item.app_sub_shop_name + '】' : '',
                  item.title
                ),
                salesWrap(item)
              )
            );
          })
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component group-buy-list' },
        _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'element group scroll-ele group-list-mode-' + mode + ' ' + (data.customFeature.mode == 2 && data.curpage > 0 ? 'hor-request-status' : ''),
            style: styleObj,
            'data-compindex': this.props.index,
            'data-type': 'group-list',
            'scroll-y': data.customFeature.mode == 2 || data.customFeature.vesselAutoheight != 0 ? false : true,
            'scroll-x': data.customFeature.mode == 2 ? true : false,
            'lower-threshold': '100',
            bindscrolltolower: this.catchMoreGroupList
            // bindanimationend="animationEnd"
          },
          mode == 0 && groupListOne(),
          mode != 0 && groupList(),
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading', hor: hor }),
          data.is_more == 0 && data.goods_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: "暂无商品" }, hor: hor }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: this.catchMoreGroupList, compindex: this.props.index }, hor: hor }),
          data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll', hor: hor }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: data.customFeature, 'data-compindex': this.props.index, onClick: this.catchMoreGroupList })
        )
      );
    }
  }]);
  return GroupBuyListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var that = _this4;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var param = {
      page: 1,
      status: 0
    };
    // TODO: 拼团状态组件初始化，应该要挪到对应组件里面设置
    pageInstance.data.eles.forEach(function (ele, eleIndex) {
      if (ele.type === 'group-buy-status' && customFeature.id === ele.customFeature.status_refresh_object) {
        var statusCompindex = eleIndex;
        var groupStatusData = pageInstance.data.eles[statusCompindex].customFeature;
        var checkOptionsOne = groupStatusData.checkOptionsOne;
        for (var selectIndex in checkOptionsOne) {
          if (checkOptionsOne[selectIndex].checked) {
            param = {
              page: 1,
              status: selectIndex
            };
            var newdata = {};
            newdata['eles[' + statusCompindex + '].customFeature.selectNum'] = selectIndex;
            newdata['eles[' + compindex + '].selectNum'] = selectIndex;
            pageInstance.setData(newdata);
            break;
          }
        }
      }
    });
    var newClassifyCompid = _app.appMethod.getInvolvedFromRefreshObject(customFeature.id, 'new-classify', 'refresh_object', pageInstance);
    if (!newClassifyCompid) {
      that.getGroupBuyList(compindex, param);
    }
  };

  this.getGroupBuyList = function (compindex, param) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var loadingNum = customFeature.loadingNum || 10;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex]) {
      var downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (var i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    pageInstance.setData(newdata);

    param.page_size = loadingNum;
    if (customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      // 是否多店拼团(排除子店功能页)
      param['parent_app_id'] = _app.appMethod.getAppId();
    }
    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=appGroupBuy/goodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.data) {
          var rdata = res.data,
              appId = _app.appMethod.getAppId(),
              _newdata = {},
              _downcountArr = [];

          for (var _i = 0; _i < rdata.length; _i++) {
            var f = rdata[_i],
                dc = void 0;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
            f.server_time = res.current_time || Date.parse(new Date()) / 1000;
            f.seckill_end_time = f.end_date;
            f.seckill_start_time = f.start_date;
            if (f.status == 0 || f.status == 1 || f.status == 2) {
              dc = _app.appMethod.beforeGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + _i + ']');
            } else if (f.status == 3) {
              if (f.end_date != '-1') {
                dc = _app.appMethod.duringGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + _i + ']');
              }
            }
            dc && _downcountArr.push(dc);
            if (customFeature.isShowFranchiseeGoods && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          _newdata['eles[' + compindex + '].goods_data'] = res.data;
          _newdata['eles[' + compindex + '].is_more'] = res.is_more;
          _newdata['eles[' + compindex + '].curpage'] = res.current_page;
          _newdata['eles[' + compindex + '].loading'] = false;
          _newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = _downcountArr;
          pageInstance.setData(_newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.remainMe = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var data = e.currentTarget.dataset;
    var compindex = data.compindex;
    var index = data.index;

    _app.appMethod.sendRequest({
      url: '/index.php?r=appShop/careActivity',
      data: {
        data_id: data.goodsid,
        activity_id: data.activityid,
        activity_type: 0
      },
      success: function success(res) {
        _app.appMethod.showToast({
          title: '提醒成功！',
          duration: 2000
        });
        var newdata = {};
        newdata['eles[' + compindex + '].goods_data[' + index + '].status'] = 2;
        pageInstance.setData(newdata);
      }
    });
    _this4.groupSaveUserFormId(e.detail.formId);
  };

  this.catchMoreGroupList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var curpage = compData.curpage + 1;
    var param = {};
    var newData = {};

    if (compData.loading || !compData.is_more) {
      return;
    }
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newData);

    param.page_size = customFeature.loadingNum || 10;
    param.page = curpage;
    param.status = 0;
    param.is_count = 0;
    param.status = compData.selectNum;
    if (customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      // 是否多店拼团(排除子店功能页)
      param['parent_app_id'] = _app.appMethod.getAppId();
    }

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=appGroupBuy/goodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.data) {
          var rdata = res.data,
              appId = _app.appMethod.getAppId(),
              newdata = {},
              length = compData.goods_data.length,
              downcountArr = pageInstance.downcountObject[compindex] || [];

          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i],
                dc = void 0;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            f.server_time = res.current_time || Date.parse(new Date()) / 1000;
            f.seckill_end_time = f.end_date;
            f.seckill_start_time = f.start_date;
            if (f.status == 0 || f.status == 1 || f.status == 2) {
              dc = _app.appMethod.beforeGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + (i + length) + ']');
            } else if (f.status == 3) {
              if (f.end_date != '-1') {
                dc = _app.appMethod.duringGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + (i + length) + ']');
              }
            }
            dc && downcountArr.push(dc);
            if (customFeature.isShowFranchiseeGoods && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          var dataArr = res.data;
          newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(dataArr);
          newdata['eles[' + compindex + '].is_more'] = res.is_more;
          newdata['eles[' + compindex + '].curpage'] = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.gotoGroupDetail = function (e) {
    var data = e.currentTarget.dataset;
    var appId = data.appId;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (appId && appId !== _app.appMethod.getAppId() && chainParam === '') {
      chainParam = '&franchisee=' + appId;
    }
    var pageUrl = data.status == 4 ? '/pages/goodsDetail/goodsDetail?detail=' + data.goodsid + chainParam : '/group/pages/gpgoodsDetail/gpgoodsDetail?goods_id=' + data.goodsid + '&activity_id=' + data.activityid + chainParam;
    _app.appMethod.turnToPage(pageUrl);
  };

  this.groupSaveUserFormId = function (formId) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      data: {
        form_id: [formId]
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      method: 'post'
    });
  };

  this._refreshGroupBuyList = function (targetCompIndex, requestData, pageInstance) {
    var _this = _this4;
    var compdata = pageInstance.data.eles[targetCompIndex];
    var customFeature = compdata.customFeature;
    var newData = {};

    newData['eles[' + targetCompIndex + '].loading'] = true;
    newData['eles[' + targetCompIndex + '].loadingFail'] = false;
    newData['eles[' + targetCompIndex + '].is_more'] = 1;
    newData['eles[' + targetCompIndex + '].goods_data'] = [];
    pageInstance.setData(newData);

    requestData.page_size = customFeature.loadingNum || 10;
    requestData.status = compdata.selectNum || 0;
    if (customFeature.source && customFeature.source != 'none') {
      requestData.idx_arr = {
        idx: 'category',
        idx_value: customFeature.source
      };
    }

    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[targetCompIndex]) {
      var downcountArr = pageInstance.downcountObject[targetCompIndex];
      if (downcountArr && downcountArr.length) {
        for (var i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    // 是否多店拼团(排除子店功能页)
    if (customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
      requestData['parent_app_id'] = _app.appMethod.getAppId();
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=appGroupBuy/goodsList',
      method: 'post',
      hideLoading: true,
      data: requestData,
      chain: true,
      success: function success(res) {
        var rdata = res.data,
            newdata = {},
            downcountArr = [];

        for (var _i2 = 0; _i2 < rdata.length; _i2++) {
          var f = rdata[_i2],
              dc = void 0;
          f.description = '';
          f.downCount = {
            hours: '00',
            minutes: '00',
            seconds: '00',
            days: '00'
          };
          f.original_price = f.virtual_price == '0.00' ? f.original_price : f.virtual_price;
          f.server_time = res.current_time || Date.parse(new Date()) / 1000;
          f.seckill_end_time = f.end_date;
          f.seckill_start_time = f.start_date;
          if (f.status == 0 || f.status == 1 || f.status == 2) {
            dc = _app.appMethod.beforeGroupDownCount(f, pageInstance, 'eles[' + targetCompIndex + '].goods_data[' + _i2 + ']');
          } else if (f.status == 3) {
            if (f.end_date != '-1') {
              dc = _app.appMethod.duringGroupDownCount(f, pageInstance, 'eles[' + targetCompIndex + '].goods_data[' + _i2 + ']');
            }
          }
          dc && downcountArr.push(dc);
        }

        newdata['eles[' + targetCompIndex + '].goods_data'] = rdata;
        newdata['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newdata['eles[' + targetCompIndex + '].curpage'] = res.current_page;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
        pageInstance.downcountObject[targetCompIndex] = downcountArr;
        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newData = {};
        newData['eles[' + targetCompIndex + '].loadingFail'] = true;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      }
    });
  };
};

exports.default = GroupBuyListCustomComponent;

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

__webpack_require__(898);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'group-buy-status'
 * 组件：拼团状态组件
 */
var GroupBuyStatusCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(GroupBuyStatusCustomComponent, _React$Component);

  function GroupBuyStatusCustomComponent(props) {
    (0, _classCallCheck3.default)(this, GroupBuyStatusCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GroupBuyStatusCustomComponent.__proto__ || Object.getPrototypeOf(GroupBuyStatusCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(GroupBuyStatusCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          style = data.style;
      var fontSize = customFeature.fontSize,
          fontColor = customFeature.fontColor,
          fontWeight = customFeature.fontWeight,
          fontStyle = customFeature.fontStyle,
          textDecoration = customFeature.textDecoration,
          mode = customFeature.mode,
          background = customFeature.background,
          checkOptionsOne = customFeature.checkOptionsOne,
          checkedNum = customFeature.checkedNum,
          selectColor = customFeature.selectColor,
          selectFontStyle = customFeature.selectFontStyle,
          selectTextDecoration = customFeature.selectTextDecoration,
          defaultColor = customFeature.defalutColor;

      /**
       * @desc 处理拼团状态组件选中问题
       */

      var selectNum = customFeature.selectNum || 0;

      var styleObj = {
        fontSize: fontSize,
        color: fontColor,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        textDecoration: textDecoration
      };

      var tabBarStyle = (0, _extends3.default)({}, styleObj, (0, _tools.convertStyleData)(style));

      // tabbar-list1样式
      var selectStyle = {
        color: selectColor,
        borderBottom: '.04rem solid ' + selectColor,
        fontStyle: selectFontStyle,
        textDecoration: selectTextDecoration
      };

      // tabbar-list2样式
      var selectStyleTwo = {
        background: selectColor,
        color: '#fff',
        fontStyle: selectFontStyle,
        textDecoration: selectTextDecoration
      };

      /**
       * @desc tabBar列表
       */
      var tabBarList = function tabBarList() {
        var config = {
          1: {
            name: 'tabbar-list1',
            style: selectStyle
          },
          2: {
            name: 'tabbar-list2',
            style: selectStyleTwo
          }
        }[mode];
        return _react2.default.createElement(
          'div',
          { className: 'tabbar-list ' + config.name, style: tabBarStyle },
          checkOptionsOne.map(function (item, index) {
            return item.checked && _react2.default.createElement(
              'div',
              {
                className: 'item',
                key: item.value,
                style: { minWidth: checkedNum == 2 ? '3.75rem' : checkedNum == 3 ? '2.5rem' : '1.87rem' },
                'data-index': index,
                'data-compindex': _this2.props.index,
                'data-status': '0',
                onClick: _this2.catchGroupList },
              _react2.default.createElement(
                'div',
                { style: selectNum == index ? (0, _extends3.default)({}, config.style) : { color: defaultColor } },
                item.label
              )
            );
          })
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component group-buy-status' },
        _react2.default.createElement(
          'div',
          { style: styleObj,
            className: 'group-status-list' },
          _react2.default.createElement(
            'div',
            { className: 'list-status' },
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { 'scroll-x': 'true', className: 's-view', style: { 'background': data.customFeature.background, width: '100%', whiteSpace: 'nowrap', textDecoration: 'inherit', overflowX: 'scroll', 'overflowY': 'hidden' } },
              tabBarList()
            )
          )
        )
      );
    }
  }]);
  return GroupBuyStatusCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {};

  this.catchGroupList = function (e) {
    var that = _this3;
    var index = e.currentTarget.dataset.index;
    var compindex = e.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var param = {
      page: 1,
      status: e.currentTarget.dataset.index || 0
    };
    var listId = pageInstance.data.eles[compindex].customFeature.status_refresh_object;
    var groupCompindex = _app.appMethod.findComponentIndexById(listId);
    if (groupCompindex === -1) {
      _app.appMethod.showModal({ content: '找不到绑定的拼团列表' });
      return;
    }
    if (pageInstance.newClassifyGroupidsParams && !!pageInstance.newClassifyGroupidsParams.length) {
      var params = pageInstance.newClassifyGroupidsParams;
      for (var i = 0; i < params.length; i++) {
        var newClassifyCompid = params[i].compindex;
        var newClassifyCompData = pageInstance.data.eles[newClassifyCompid];
        if (newClassifyCompData.customFeature.refresh_object == pageInstance.data.eles[groupCompindex].customFeature.id) {
          param.idx_arr = {
            idx: 'category',
            idx_value: newClassifyCompData.selectedCateId
          };
        }
      }
    }
    var newdata = {};
    newdata['eles[' + compindex + '].customFeature.selectNum'] = index;
    newdata['eles[' + groupCompindex + '].selectNum'] = index;
    pageInstance.setData(newdata);
    pageInstance.callComponentMethod({
      componentIndex: groupCompindex,
      methodName: 'getGroupBuyList',
      argvs: [groupCompindex, param]
    });
  };
};

exports.default = GroupBuyStatusCustomComponent;

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _progress = __webpack_require__(900);

var _progress2 = _interopRequireDefault(_progress);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(901);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(903);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'seckill'
 * 组件：秒杀组件
 */
var SeckillCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(SeckillCustomComponent, _React$Component);

  function SeckillCustomComponent(props) {
    (0, _classCallCheck3.default)(this, SeckillCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SeckillCustomComponent.__proto__ || Object.getPrototypeOf(SeckillCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  /** 设置模板消息提醒功能*/


  /** 跳转秒杀详情*/


  /**
   * 秒杀倒计时显示处理
  */


  /**
  * 第一次初始化秒杀列表
  */


  /**
   * 查询活动是否为多店活动
   */


  (0, _createClass3.default)(SeckillCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          goods_data = data.goods_data,
          curpage = data.curpage;
      var mode = customFeature.mode,
          everyoneLimited = customFeature.everyoneLimited,
          limited = customFeature.limited,
          peopleCounting = customFeature.peopleCounting;


      var styleObj = (0, _tools.convertStyleData)(data.style);
      if (customFeature.vesselAutoheight == 0) {
        styleObj['height'] = (0, _tools.transformPx2Rem)(customFeature['height'], 320);
      }
      /**
       * @desc 图片样式转换
       */
      var imgStyleObj = {
        width: (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.imgHeight, 320)
      };

      // 内容部分的宽度
      var title_width = null;
      switch (mode) {
        case 0:
          title_width = { width: 'calc(100% - ' + imgStyleObj.width + ')' };
          break;
        case 2:
          title_width = { width: '' + imgStyleObj.width };
          break;
        default:
          title_width = { width: 'calc(100% - ' + imgStyleObj.width + ')' };
          break;
      }

      /**
       * @desc 列表样式转换
       */
      var listStyleObj = {
        marginBottom: (0, _tools.transformPx2Rem)(customFeature.margin, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.lineHeight, 320),
        backgroundColor: customFeature.lineBackgroundColor
      };
      var modeZero = function modeZero() {
        return _react2.default.createElement(
          'div',
          null,
          goods_data && goods_data.map(function (item, goodsIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'zero-mode-div seckill-style',
                key: item.form_data.id,
                style: (0, _extends3.default)({ marginTop: customFeature.margin }, listStyleObj),
                'data-contact': customFeature.ifUseContact,
                'data-formdata': JSON.stringify(item.form_data),
                'data-goods-type': item.form_data.goods_type,
                'data-seckilltype': customFeature.seckillType == 'activeSeckill' ? 1 : 0,
                'data-app-id': item.form_data.app_id,
                onClick: function onClick(e) {
                  _this2.goSeckillDetail(e);e.stopPropagation();
                } },
              _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: imgStyleObj }),
              _react2.default.createElement(
                'div',
                { className: 'seckill-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-title' },
                  item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                  item.form_data.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-content-bottom' },
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-content-left' },
                    _react2.default.createElement(
                      'div',
                      { className: 'seckill-now-price seckill-start-color-' + item.form_data.seckill_start_state },
                      _react2.default.createElement(
                        'span',
                        { className: 'font24' },
                        '\xA5'
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.form_data.seckill_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-original-price font24' },
                        '\xA5',
                        item.form_data.price,
                        _react2.default.createElement('span', { className: 'original-price-line' })
                      )
                    ),
                    item.form_data.seckill_start_state !== 0 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-progress-new seckill-progress-new-' + item.form_data.seckill_progress },
                      item.form_data.seckill_progress != 100 && _react2.default.createElement('img', { className: 'seckill-progress-image',
                        src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png',
                        style: { width: item.form_data.seckill_progress + '%' } }),
                      item.form_data.seckill_progress == 100 && _react2.default.createElement('img', { className: 'seckill-progress-image', src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'seckill-progress-font' },
                        _react2.default.createElement(
                          'div',
                          null,
                          '\u5DF2\u62A2',
                          item.form_data.seckill_activity_sales,
                          '\u4EF6'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : '' },
                          item.form_data.seckill_progress,
                          '%'
                        )
                      )
                    ),
                    item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-describe' },
                      everyoneLimited && _react2.default.createElement(
                        'div',
                        { className: 'seckill-buy-limit' },
                        '\u6BCF\u4EBA\u9650\u62A2',
                        item.form_data.seckill_buy_limit,
                        '\u4EFD'
                      ),
                      everyoneLimited && limited && _react2.default.createElement('div', { className: 'vertical-bar' }),
                      limited && _react2.default.createElement(
                        'div',
                        { className: 'seckill-stock' },
                        '\u9650\u91CF',
                        item.form_data.seckill_stock
                      )
                    ),
                    item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-time seckill-start-color-' + item.form_data.seckill_start_state },
                      item.form_data.seckill_start_state == 0 && item.form_data.startDay == 1 && _react2.default.createElement(
                        'label',
                        null,
                        '\u8DDD\u5F00\u59CB'
                      ),
                      item.form_data.seckill_start_state == 0 && item.form_data.startDay == 2 && _react2.default.createElement(
                        'label',
                        null,
                        '\u5F00\u62A2\u65F6\u95F4'
                      ),
                      item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                        'label',
                        null,
                        '\u8DDD\u7ED3\u675F'
                      ),
                      (item.form_data.seckill_start_state == 1 || item.form_data.seckill_start_state == 0 && item.form_data.startDay == 1) && _react2.default.createElement(
                        'span',
                        null,
                        !!item.form_data.downCount.days && _react2.default.createElement(
                          'span',
                          { className: 'days' },
                          item.form_data.downCount.days,
                          '\u5929'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'hours' },
                          item.form_data.downCount.hours
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'minutes' },
                          item.form_data.downCount.minutes
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'seconds' },
                          item.form_data.downCount.seconds
                        )
                      ),
                      item.form_data.seckill_start_state == 0 && item.form_data.startDay == 2 && _react2.default.createElement(
                        'span',
                        null,
                        item.form_data.seckill_startTime
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-content-right' },
                    item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button seckill-background-F23031' },
                      '\u9A6C\u4E0A\u62A2',
                      _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow icon-rightarrow-cover' })
                    ),
                    item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button seckill-background-D0D0D0' },
                      '\u5DF2\u62A2\u5149'
                    ),
                    item.form_data.seckill_start_state == 2 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button seckill-background-D0D0D0' },
                      '\u5DF2\u7ED3\u675F'
                    ),
                    item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 0 && _react2.default.createElement(
                      'form',
                      null,
                      _react2.default.createElement(
                        'button',
                        { className: 'form-button seckill-background-FF7100',
                          type: 'button',
                          'data-goods': JSON.stringify(item.form_data),
                          'data-index': goodsIndex,
                          'data-is_deleted': '0',
                          'data-compindex': _this2.props.index,
                          onClick: function onClick(e) {
                            _this2.formSubmitRemind(e);e.stopPropagation();
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'seckill-button' },
                          '\u63D0\u9192\u6211'
                        )
                      )
                    ),
                    item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 1 && _react2.default.createElement(
                      'form',
                      null,
                      _react2.default.createElement(
                        'button',
                        { className: 'form-button seckill-background-FF7100',
                          type: 'button',
                          'data-goods': JSON.stringify(item.form_data),
                          'data-index': goodsIndex,
                          'data-is_deleted': '1',
                          'data-compindex': _this2.props.index,
                          onClick: function onClick(e) {
                            _this2.formSubmitRemind(e);e.stopPropagation();
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'seckill-button seckill-background-FF7100' },
                          '\u53D6\u6D88\u63D0\u9192'
                        )
                      )
                    ),
                    (item.form_data.seckill_start_state == 1 || item.form_data.seckill_progress == 100) && everyoneLimited && _react2.default.createElement(
                      'div',
                      { className: 'seckill-content-right-describe' },
                      '\u6BCF\u4EBA\u9650\u62A2',
                      item.form_data.seckill_buy_limit,
                      '\u4EFD'
                    ),
                    item.form_data.seckill_start_state == 0 && item.form_data.seckill_activity_care > 0 && peopleCounting && _react2.default.createElement(
                      'div',
                      { className: 'seckill-content-right-describe' },
                      item.form_data.seckill_activity_care,
                      '\u4EBA\u5DF2\u8BBE\u7F6E'
                    )
                  )
                )
              ),
              _react2.default.createElement('div', { className: 'seckill-bottom-line' })
            );
          })
        );
      };

      var modeOneAndTwo = function modeOneAndTwo() {
        return _react2.default.createElement(
          'div',
          { className: mode == 1 ? '' : 'two-mode-div-block' },
          goods_data && goods_data.map(function (item, goodsIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'seckill-style ' + (mode == 1 ? 'one-mode-div' : 'two-mode-div'),
                key: item.form_data.id,
                style: (0, _extends3.default)({ width: mode === 2 ? title_width.width : '' }, listStyleObj),
                'data-formdata': JSON.stringify(item.form_data),
                'data-contact': customFeature.ifUseContact,
                'data-goods-type': item.form_data.goods_type,
                'data-seckilltype': customFeature.seckillType == 'activeSeckill' ? 1 : 0,
                'data-app-id': item.form_data.app_id,
                onClick: function onClick(e) {
                  _this2.goSeckillDetail(e);e.stopPropagation();
                } },
              _react2.default.createElement(
                'div',
                { className: 'seckill-image-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'image-content', style: imgStyleObj },
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: imgStyleObj }),
                  item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                    'div',
                    { className: 'seckill-time ' + (item.form_data.seckill_start_state != 0 ? 'seckill-background-F23031' : '') + ' ' + (item.form_data.seckill_start_state == 0 ? 'seckill-background-FF7100' : '') },
                    item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u5F00\u59CB'
                    ),
                    item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                      'label',
                      null,
                      '\u8DDD\u7ED3\u675F'
                    ),
                    item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                      'span',
                      null,
                      !!item.form_data.downCount.days && _react2.default.createElement(
                        'span',
                        { className: 'days' },
                        item.form_data.downCount.days,
                        '\u5929'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'hours countdown-text' },
                        item.form_data.downCount.hours
                      ),
                      ':',
                      _react2.default.createElement(
                        'span',
                        { className: 'minutes countdown-text' },
                        item.form_data.downCount.minutes
                      ),
                      ':',
                      _react2.default.createElement(
                        'span',
                        { className: 'seconds countdown-text' },
                        item.form_data.downCount.seconds
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'seckill-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-title' },
                  item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                  item.form_data.title
                ),
                item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-progress-new ' + (mode == 1 ? 'seckill-matop4' : 'seckill-matop2') + ' seckill-progress-new-ready' },
                  '\u672A\u5F00\u59CB'
                ),
                item.form_data.seckill_start_state != 0 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-progress-new ' + (mode == 1 ? 'seckill-matop4' : 'seckill-matop2') + ' seckill-progress-new-' + item.form_data.seckill_progress },
                  item.form_data.seckill_progress != 100 && _react2.default.createElement('img', { className: 'seckill-progress-image',
                    src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png',
                    style: { width: item.form_data.seckill_progress + '%' } }),
                  item.form_data.seckill_progress == 100 && _react2.default.createElement('img', { className: 'seckill-progress-image',
                    src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-progress-font' },
                    _react2.default.createElement(
                      'div',
                      null,
                      '\u5DF2\u62A2',
                      item.form_data.seckill_activity_sales,
                      '\u4EF6'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : '' },
                      item.form_data.seckill_progress,
                      '%'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-describe seckill-matop8' },
                  everyoneLimited && _react2.default.createElement(
                    'div',
                    { className: 'seckill-buy-limit' },
                    '\u6BCF\u4EBA\u9650\u62A2',
                    item.form_data.seckill_buy_limit,
                    '\u4EFD'
                  ),
                  everyoneLimited && item.form_data.seckill_start_state == 0 && limited && _react2.default.createElement('div', { className: 'vertical-bar' }),
                  item.form_data.seckill_start_state == 0 && limited && _react2.default.createElement(
                    'div',
                    { className: 'seckill-stock' },
                    '\u9650\u91CF',
                    item.form_data.seckill_stock
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-now-price seckill-start-color-' + item.form_data.seckill_start_state + ' seckill-matop4' },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      'span',
                      { className: 'font24' },
                      '\xA5'
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.form_data.seckill_price
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-original-price font22' },
                    '\xA5',
                    item.form_data.price,
                    _react2.default.createElement('span', { className: 'original-price-line' })
                  )
                ),
                item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-button seckill-background-F23031' },
                  '\u9A6C\u4E0A\u62A2'
                ),
                item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-button seckill-background-D0D0D0' },
                  '\u5DF2\u62A2\u5149'
                ),
                item.form_data.seckill_start_state == 2 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-button seckill-background-D0D0D0' },
                  '\u5DF2\u7ED3\u675F'
                ),
                item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-button-box' },
                  item.form_data.is_seckill_activity_care == 0 && _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'form-button',
                        'data-goods': JSON.stringify(item.form_data),
                        'data-index': goodsIndex,
                        'data-is_deleted': '0',
                        'data-compindex': _this2.props.index,
                        onClick: function onClick(e) {
                          _this2.formSubmitRemind(e);e.stopPropagation();
                        } },
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-button-new seckill-background-FF7100' },
                        '\u63D0\u9192\u6211'
                      )
                    )
                  ),
                  item.form_data.is_seckill_activity_care == 1 && _react2.default.createElement(
                    'form',
                    null,
                    _react2.default.createElement(
                      'button',
                      {
                        type: 'button',
                        className: 'form-button',
                        'data-goods': JSON.stringify(item.form_data),
                        'data-index': goodsIndex,
                        'data-is_deleted': '1',
                        'data-compindex': _this2.props.index,
                        onClick: function onClick(e) {
                          _this2.formSubmitRemind(e);e.stopPropagation();
                        } },
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-button-new seckill-background-FF7100' },
                        '\u53D6\u6D88\u63D0\u9192'
                      )
                    )
                  ),
                  item.form_data.seckill_activity_care > 0 && peopleCounting && _react2.default.createElement(
                    'span',
                    { className: 'seckill-content-right-describe' },
                    item.form_data.seckill_activity_care,
                    '\u4EBA\u5DF2\u8BBE\u7F6E'
                  )
                )
              )
            );
          })
        );
      };

      var modeThree = function modeThree() {
        return _react2.default.createElement(
          'div',
          null,
          goods_data && goods_data.map(function (item, goodsIndex) {
            return _react2.default.createElement(
              'div',
              { className: 'three-mode-div seckill-style',
                key: item.form_data.id,
                style: listStyleObj,
                'data-formdata': JSON.stringify(item.form_data),
                'data-contact': customFeature.ifUseContact,
                'data-goods-type': item.form_data.goods_type,
                'data-seckilltype': customFeature.seckillType == 'activeSeckill' ? 1 : 0,
                'data-app-id': item.form_data.app_id,
                onClick: function onClick(e) {
                  _this2.goSeckillDetail(e);e.stopPropagation();
                } },
              _react2.default.createElement(
                'div',
                { className: 'seckill-image-content' },
                item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                  'div',
                  { className: 'seckill-time ' + (item.form_data.seckill_start_state != 0 ? 'seckill-background-F23031' : '') + ' ' + (item.form_data.seckill_start_state == 0 ? 'seckill-background-FF7100' : '') },
                  item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                    'label',
                    null,
                    '\u8DDD\u5F00\u59CB'
                  ),
                  item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                    'label',
                    null,
                    '\u8DDD\u7ED3\u675F'
                  ),
                  !!item.form_data.downCount.days && _react2.default.createElement(
                    'span',
                    { className: 'days' },
                    item.form_data.downCount.days,
                    '\u5929'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'hours countdown-text ' + (item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : '') },
                    item.form_data.downCount.hours
                  ),
                  ':',
                  _react2.default.createElement(
                    'span',
                    { className: 'minutes countdown-text ' + (item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : '') },
                    item.form_data.downCount.minutes
                  ),
                  ':',
                  _react2.default.createElement(
                    'span',
                    { className: 'seconds countdown-text ' + (item.form_data.seckill_start_state == 1 ? 'seckill-background-CD0C0E' : '') },
                    item.form_data.downCount.seconds
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'image-content', style: imgStyleObj },
                  _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: imgStyleObj })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'seckill-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-title' },
                  item.form_data.isSubShopGoods ? '【' + item.form_data.app_shop_name + '】' : '',
                  item.form_data.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'seckill-content-bottom' },
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-content-left' },
                    _react2.default.createElement(
                      'div',
                      { className: 'seckill-now-price seckill-start-color-' + item.form_data.seckill_start_state },
                      _react2.default.createElement(
                        'span',
                        { className: 'font24' },
                        '\xA5'
                      ),
                      _react2.default.createElement(
                        'span',
                        null,
                        item.form_data.seckill_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'seckill-original-price font24' },
                        '\xA5',
                        item.form_data.price,
                        _react2.default.createElement('span', { className: 'original-price-line' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'seckill-items-center seckill-matop2' },
                      item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                        'div',
                        { className: 'seckill-progress-new' },
                        item.form_data.seckill_progress != 100 && _react2.default.createElement('img', { className: 'seckill-progress-image',
                          src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-red.png',
                          style: { width: item.form_data.seckill_progress + '%' } }),
                        item.form_data.seckill_progress == 100 && _react2.default.createElement('img', { className: 'seckill-progress-image', src: 'http://cdn.jisuapp.cn/static/jisuapp_editor/images/seckill-progress-gray.png' }),
                        _react2.default.createElement(
                          'div',
                          { className: 'seckill-progress-font' },
                          _react2.default.createElement(
                            'div',
                            null,
                            '\u5DF2\u62A2',
                            item.form_data.seckill_activity_sales,
                            '\u4EF6'
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: item.form_data.seckill_progress < 60 ? 'seckill-progress-percent' : '' },
                            item.form_data.seckill_progress,
                            '%'
                          )
                        )
                      ),
                      everyoneLimited && _react2.default.createElement(
                        'div',
                        { className: 'seckill-buy-limit ' + (item.form_data.seckill_start_state == 1 ? 'seckill-buy-limit-new' : '') },
                        '\u6BCF\u4EBA\u9650\u62A2',
                        item.form_data.seckill_buy_limit,
                        '\u4EFD'
                      ),
                      everyoneLimited && item.form_data.seckill_start_state == 0 && limited && _react2.default.createElement('div', { className: 'vertical-bar' }),
                      item.form_data.seckill_start_state == 0 && limited && _react2.default.createElement(
                        'div',
                        { className: 'seckill-stock' },
                        '\u9650\u91CF',
                        item.form_data.seckill_stock
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'seckill-content-right' },
                    item.form_data.seckill_start_state == 0 && item.form_data.seckill_activity_care > 0 && peopleCounting && _react2.default.createElement(
                      'div',
                      { className: 'seckill-content-right-describe' },
                      item.form_data.seckill_activity_care,
                      '\u4EBA\u5DF2\u8BBE\u7F6E'
                    ),
                    item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress != 100 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button seckill-background-F23031' },
                      '\u9A6C\u4E0A\u62A2',
                      _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow icon-rightarrow-cover' })
                    ),
                    item.form_data.seckill_start_state == 1 && item.form_data.seckill_progress == 100 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button  seckill-background-D0D0D0' },
                      '\u5DF2\u62A2\u5149'
                    ),
                    item.form_data.seckill_start_state == 2 && _react2.default.createElement(
                      'div',
                      { className: 'seckill-button  seckill-background-D0D0D0' },
                      '\u5DF2\u7ED3\u675F'
                    ),
                    item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 0 && _react2.default.createElement(
                      'form',
                      null,
                      _react2.default.createElement(
                        'button',
                        {
                          type: 'button',
                          className: 'form-button',
                          'data-goods': JSON.stringify(item.form_data),
                          'data-index': goodsIndex,
                          'data-is_deleted': '0',
                          'data-compindex': _this2.props.index,
                          onClick: function onClick(e) {
                            _this2.formSubmitRemind(e);e.stopPropagation();
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'seckill-button seckill-background-FF7100' },
                          '\u63D0\u9192\u6211'
                        )
                      )
                    ),
                    item.form_data.seckill_start_state == 0 && item.form_data.is_seckill_activity_care == 1 && _react2.default.createElement(
                      'form',
                      null,
                      _react2.default.createElement(
                        'button',
                        {
                          type: 'button',
                          className: 'form-button',
                          'data-goods': JSON.stringify(item.form_data),
                          'data-index': goodsIndex,
                          'data-is_deleted': '1',
                          'data-compindex': _this2.props.index,
                          onClick: function onClick(e) {
                            _this2.formSubmitRemind(e);e.stopPropagation();
                          } },
                        _react2.default.createElement(
                          'div',
                          { className: 'seckill-button seckill-background-FF7100' },
                          '\u53D6\u6D88\u63D0\u9192'
                        )
                      )
                    )
                  )
                )
              )
            );
          })
        );
      };

      var wrap = function wrap() {
        return _react2.default.createElement(
          'div',
          { className: 'js-list-container' },
          goods_data && goods_data.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: 'seckill-list-item background-ele',
                key: item.form_data.id,
                style: listStyleObj,
                'data-formdata': JSON.stringify(item.form_data),
                'data-contact': customFeature.ifUseContact,
                'data-goods-type': item.form_data.goods_type,
                'data-seckilltype': customFeature.seckillType == 'activeSeckill' ? 1 : 0,
                'data-app-id': item.form_data.app_id,
                onClick: function onClick(e) {
                  _this2.goSeckillDetail(e);e.stopPropagation();
                } },
              _react2.default.createElement(
                'div',
                { className: 'inner-content' },
                _react2.default.createElement('img', { className: 'list-img', src: item.form_data.cover, style: imgStyleObj }),
                _react2.default.createElement(
                  'div',
                  { className: 'title-container', style: { width: title_width.width } },
                  _react2.default.createElement(
                    'div',
                    { className: 'title' },
                    item.form_data.title
                  ),
                  mode == 1 || mode == 2 ? _react2.default.createElement(
                    'div',
                    { className: 'seckill-list-bottom ' + (item.form_data.seckill_start_state == 1 ? 'seckill-during' : '') + '\n                                                       ' + (item.form_data.seckill_start_state == 2 ? 'seckill-end' : '') },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: 'price' },
                        '\xA5',
                        item.form_data.seckill_price
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'oldprice' },
                        '\xA5',
                        item.form_data.price
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'seckill-progress-wrap' },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u5DF2\u552E',
                          item.form_data.seckill_progress,
                          '%'
                        ),
                        _react2.default.createElement(_progress2.default, {
                          className: 'seckill-progress',
                          unfilled: false,
                          percent: item.form_data.seckill_progress,
                          barStyle: { borderColor: '#fa6583' },
                          position: 'normal' })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'countdown' },
                        item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                          'label',
                          null,
                          '\u8DDD\u5F00\u59CB'
                        ),
                        item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                          'label',
                          null,
                          '\u8DDD\u7ED3\u675F'
                        ),
                        item.form_data.seckill_start_state == 2 && _react2.default.createElement(
                          'label',
                          null,
                          '\u5DF2\u7ED3\u675F'
                        ),
                        !!item.form_data.downCount.days && _react2.default.createElement(
                          'span',
                          { className: 'days' },
                          item.form_data.downCount.days,
                          '\u5929'
                        ),
                        item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                          'span',
                          { className: 'hours countdown-text' },
                          item.form_data.downCount.hours
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'minutes countdown-text' },
                          item.form_data.downCount.minutes
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'seconds countdown-text' },
                          item.form_data.downCount.seconds
                        )
                      )
                    )
                  ) : _react2.default.createElement(
                    'div',
                    { className: 'seckill-list-bottom ' + (item.form_data.seckill_start_state == 1 ? 'seckill-during' : '') + '\n                                                       ' + (item.form_data.seckill_start_state == 2 ? 'seckill-end' : ''),
                      style: { width: title_width.width } },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: 'price' },
                        '\xA5',
                        item.form_data.seckill_price
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'countdown' },
                        item.form_data.seckill_start_state == 0 && _react2.default.createElement(
                          'label',
                          null,
                          '\u8DDD\u5F00\u59CB'
                        ),
                        item.form_data.seckill_start_state == 1 && _react2.default.createElement(
                          'label',
                          null,
                          '\u8DDD\u7ED3\u675F'
                        ),
                        item.form_data.seckill_start_state == 2 && _react2.default.createElement(
                          'label',
                          null,
                          '\u5DF2\u7ED3\u675F'
                        ),
                        !!item.form_data.downCount.days && _react2.default.createElement(
                          'span',
                          { className: 'days' },
                          item.form_data.downCount.days,
                          '\u5929'
                        ),
                        item.form_data.seckill_start_state != 2 && _react2.default.createElement(
                          'span',
                          { className: 'hours countdown-text' },
                          item.form_data.downCount.hours
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'minutes countdown-text' },
                          item.form_data.downCount.minutes
                        ),
                        ':',
                        _react2.default.createElement(
                          'span',
                          { className: 'seconds countdown-text' },
                          item.form_data.downCount.seconds
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'oldPrice-wrap' },
                      _react2.default.createElement(
                        'span',
                        { className: 'oldprice' },
                        '\xA5',
                        item.form_data.price
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'seckill-progress-wrap flex-wrap' },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u5DF2\u552E',
                          item.form_data.seckill_progress,
                          '%'
                        ),
                        _react2.default.createElement(_progress2.default, {
                          className: 'seckill-progress',
                          position: 'normal',
                          unfilled: false,
                          percent: item.form_data.seckill_progress,
                          barStyle: { borderColor: '#fa6583' } })
                      )
                    )
                  )
                )
              )
            );
          })
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component seckill' },
        customFeature.style == 2 ? _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'element seckill scroll-ele sec-style-mode-' + mode,
            'data-param': data.param,
            'data-compindex': this.props.index,
            'data-type': 'seckill-list',
            style: styleObj,
            'scroll-y': mode == 2 || customFeature.vesselAutoheight != 0 ? false : true,
            'scroll-x': mode == 2 ? true : false,
            'lower-threshold': '10',
            bindscrolltolower: this.seckillScrollFunc
            // bindanimationend="animationEnd"
          },
          mode === 0 && modeZero(),
          (mode === 1 || mode === 2) && modeOneAndTwo(),
          mode === 3 && modeThree()
        ) : _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'element seckill scroll-ele seckill-list-mode-' + mode + ' ' + (mode == 2 && curpage > 0 ? 'hor-request-status' : ''),
            style: styleObj },
          wrap()
        ),
        data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
        data.is_more == 0 && data.goods_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无秒杀商品~' } }),
        data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'seckillScrollFunc', compindex: this.props.index } }),
        data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
        data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.seckillScrollFunc, 'data-compindex': this.props.index })
      );
    }
  }]);
  return SeckillCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var isTimeline = false;
    var that = _this3;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    if (pageInstance.timelineComps && pageInstance.timelineComps.length) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = pageInstance.timelineComps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (customFeature.id == pageInstance.data.eles[item.compindex].customFeature.timeline_object) {
            isTimeline = true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    };
    if (!isTimeline) {
      var param = {};
      var newdata = {};
      newdata['eles[' + compindex + '].loading'] = true;
      newdata['eles[' + compindex + '].loadingFail'] = false;
      newdata['eles[' + compindex + '].goods_data'] = [];
      newdata['eles[' + compindex + '].is_more'] = 1;
      newdata['eles[' + compindex + '].curpage'] = 0;

      param.form = "goods";
      param.goods_type = 0;
      param.page_size = customFeature.loadingNum || 10;
      param.is_seckill = 1;
      param.page = 1;
      param.is_integral = customFeature.isIntegral ? 1 : 0;
      param.is_count = 0;
      param.seckill_activity_arr = {
        seckill_activity_id: customFeature.seckillActive,
        seckill_activity_time_type: 6
      };
      param.is_seckill_activity = customFeature.seckillType == 'activeSeckill' ? 1 : 0;

      if (customFeature.source && customFeature.source != 'none') {
        param.idx_arr = {
          "idx": "category",
          "idx_value": customFeature.source
        };
      }

      newdata['eles[' + compindex + '].seckill_activity_arr'] = param.seckill_activity_arr;
      if (customFeature.seckillType === 'activeSeckill' && customFeature.isShowFranchiseeGoods && !pageInstance.franchiseeId) {
        // 查询子店秒杀商品(排除子店功能页)
        _this3.checkActivityIsFranchisee(customFeature.seckillActive).then(function (flag) {
          if (flag) {
            param['is_app_shop_seckill'] = 1;
          }
          newdata['eles[' + compindex + '].param'] = param;
          pageInstance.setData(newdata);
          that.initSeckillList(compindex, param, pageInstance);
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        newdata['eles[' + compindex + '].param'] = param;
        pageInstance.setData(newdata);
        _this3.initSeckillList(compindex, param, pageInstance);
      }
    }
  };

  this.seckillScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = compData.curpage + 1;
    var customFeature = compData.customFeature;
    var newdata = {};
    var param = compData.param;
    var that = _this3;

    if (!compData.is_more && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
      _app.appMethod.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    param.page_size = +customFeature.loadingNum || 10;
    param.page = curpage;
    param.seckill_activity_arr = compData.seckill_activity_arr;
    param.is_seckill_activity = customFeature.seckillType == 'activeSeckill' ? 1 : 0;

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        newdata = {};
        var rdata = res.data,
            appId = _app.appMethod.getAppId(),
            downcountArr = pageInstance.downcountObject[compindex] || [];

        if (rdata) {
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i].form_data,
                dc = void 0,
                idx = (curpage - 1) * param.page_size + i;

            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (f.seckill_start_state == 0) {
              dc = _app.appMethod.beforeSeckillDownCount(f, pageInstance, 'eles[' + compindex + 'goods_data[' + idx + '].form_data');
            } else if (f.seckill_start_state == 1) {
              dc = _app.appMethod.duringSeckillDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + idx + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              rdata[i].form_data = that.seckillStartTimeView(f);
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(res.data);
          newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
          newdata['eles[' + compindex + '].curpage'] = res.current_page;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.downcountObject[compindex] = downcountArr;

          pageInstance.setData(newdata);
        }
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  };

  this.formSubmitRemind = function (e) {
    var formid = '';
    var data = e.currentTarget.dataset;
    var goodsInfo = JSON.parse(data.goods);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newData = {};
    var loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
    var seventDay = 86400 * 7;
    if (goodsInfo.seckill_start_timestamp > loaclDayTime + seventDay) {
      _app.appMethod.showModal({ content: '请于开抢前7天来设置哦' });
      return;
    }
    if (e.target.formId != 'the formId is a mock one') {
      formid = e.target.formId;
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/setActivityGoodsCare',
      method: 'post',
      data: {
        data_id: goodsInfo.id,
        activity_type: 1,
        activity_id: goodsInfo.seckill_activity_id,
        seckill_activity_arr: {
          seckill_activity_time_id: goodsInfo.seckill_activity_time_id,
          form_id: formid
        },
        is_deleted: data.is_deleted
      },
      success: function success(res) {
        if (!res.status) {
          if (data.is_deleted == 0) {
            _app.appMethod.showModal({
              title: '提示',
              content: '开抢前3分钟提醒你哦',
              showCancel: false
            });
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.is_seckill_activity_care'] = 1;
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.seckill_activity_care'] = pageInstance.data.eles[data.compindex].goods_data[data.index].form_data.seckill_activity_care + 1;
          } else {
            _app.appMethod.showToast({
              title: '提醒已取消'
            });
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.is_seckill_activity_care'] = 0;
            newData['eles[' + data.compindex + '].goods_data[' + data.index + '].form_data.seckill_activity_care'] = pageInstance.data.eles[data.compindex].goods_data[data.index].form_data.seckill_activity_care - 1;
          }
          pageInstance.setData(newData);
        }
      }
    });
  };

  this.goSeckillDetail = function (e) {
    var data = JSON.parse(e.currentTarget.dataset.formdata);
    var appId = e.currentTarget.dataset.appId;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (appId && appId !== _app.appMethod.getAppId() && chainParam === '') {
      // 子店秒杀商品
      chainParam = '&franchisee=' + appId;
    }
    if (data.seckill_start_state != 2) {
      var path = '/seckill/pages/seckillDetail/seckillDetail?id=' + data.id + '&sec_act_id=' + data.seckill_activity_id + '&sec_t_id=' + data.seckill_activity_time_id + '&secType=' + e.currentTarget.dataset.seckilltype + chainParam;
      _app.appMethod.turnToPage(path);
    } else {
      _app.appMethod.showModal({ content: '该商品秒杀活动已结束' });
    }
  };

  this.seckillStartTimeView = function (goods) {
    var loaclDayTime = new Date(new Date().toLocaleDateString()).getTime() / 1000;
    var tomorrowTime = loaclDayTime + 86400;
    var afterTomorrowTime = tomorrowTime + 86400;
    var date = new Date(goods.seckill_start_timestamp * 1000);
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var h = date.getHours();
    var min = date.getMinutes();
    goods.seckill_startTime = '';
    if (goods.seckill_start_timestamp <= tomorrowTime) {
      goods.startDay = 1;
    } else if (goods.seckill_start_timestamp > tomorrowTime && goods.seckill_start_timestamp <= afterTomorrowTime) {
      goods.startDay = 2;
      if (min == '00') {
        goods.seckill_startTime = '明日' + h + '点整开抢';
      } else if (min != '00' && min < 10) {
        goods.seckill_startTime = '明日' + h + ':0' + min + '开抢';
      } else {
        goods.seckill_startTime = '明日' + h + ':' + min + '开抢';
      }
    } else if (goods.seckill_start_timestamp > afterTomorrowTime) {
      goods.startDay = 2;
      if (min == '00') {
        goods.seckill_startTime = m + '月' + d + '日' + h + '点整开抢';
      } else if (min != '00' && min < 10) {
        goods.seckill_startTime = m + '月' + d + '日' + h + ':0' + min + '开抢';
      } else {
        goods.seckill_startTime = m + '月' + d + '日' + h + ':' + min + '开抢';
      }
    }
    return goods;
  };

  this.initSeckillList = function (compindex, param, pageInstance) {
    var that = _this3;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var rdata = res.data,
            appId = _app.appMethod.getAppId(),
            customFeature = pageInstance.data.eles[compindex].customFeature,
            downcountArr = pageInstance.downcountObject[compindex] || [],
            newdata = {};
        if (rdata) {
          for (var i = 0; i < rdata.length; i++) {
            var f = rdata[i].form_data,
                dc = void 0;

            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (f.seckill_start_state == 0) {
              dc = _app.appMethod.beforeSeckillDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + '].form_data');
            } else if (f.seckill_start_state == 1) {
              dc = _app.appMethod.duringSeckillDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + i + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              if (customFeature.style == 2 && customFeature.mode == 0) {
                rdata[i].form_data = that.seckillStartTimeView(f);
              }
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
          newdata['eles[' + compindex + '].goods_data'] = res.data;
          newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
          newdata['eles[' + compindex + '].curpage'] = 1;
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.downcountObject[compindex] = downcountArr;
          pageInstance.setData(newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.checkActivityIsFranchisee = function (activityId) {
    return new Promise(function (resolve, reject) {
      if (!activityId) {
        reject(false);
      }
      var seckillActivityObjectMap = _app.appMethod.globalData.seckillActivityObjectMap;
      if (seckillActivityObjectMap === undefined) {
        seckillActivityObjectMap = _app.appMethod.globalData.seckillActivityObjectMap = {};
      }
      if (seckillActivityObjectMap[activityId] !== undefined) {
        resolve(seckillActivityObjectMap[activityId]);
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/GetSeckillActivityTitle',
        data: {
          activity_id: activityId
        },
        success: function success(res) {
          if (res.status === 0) {
            if (Array.isArray(res.data) && res.data[0]) {
              seckillActivityObjectMap[activityId] = res.data[0]['is_app_shop_seckill'] > 0;
            } else {
              seckillActivityObjectMap[activityId] = false;
            }
            resolve(seckillActivityObjectMap[activityId]);
          } else {
            resolve(false);
          }
        },
        fail: reject
      });
    });
  };
};

exports.default = SeckillCustomComponent;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames2 = __webpack_require__(16);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(5);

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Progress = function (_React$Component) {
    (0, _inherits3['default'])(Progress, _React$Component);

    function Progress() {
        (0, _classCallCheck3['default'])(this, Progress);
        return (0, _possibleConstructorReturn3['default'])(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
    }

    (0, _createClass3['default'])(Progress, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.noAppearTransition = true;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.appearTransition) {
                setTimeout(function () {
                    if (_this2.barRef) {
                        _this2.barRef.style.width = _this2.props.percent + '%';
                    }
                }, 10);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this3 = this;

            var _props = this.props,
                className = _props.className,
                prefixCls = _props.prefixCls,
                position = _props.position,
                unfilled = _props.unfilled,
                _props$style = _props.style,
                style = _props$style === undefined ? {} : _props$style,
                _props$barStyle = _props.barStyle,
                barStyle = _props$barStyle === undefined ? {} : _props$barStyle;

            var percentStyle = {
                width: this.noAppearTransition || !this.props.appearTransition ? this.props.percent + '%' : 0,
                height: 0
            };
            var wrapCls = (0, _classnames3['default'])(prefixCls + '-outer', className, (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-fixed-outer', position === 'fixed'), (0, _defineProperty3['default'])(_classnames, prefixCls + '-hide-outer', !unfilled), _classnames));
            return React.createElement(
                'div',
                { style: style, className: wrapCls, role: 'progressbar', 'aria-valuenow': this.props.percent, 'aria-valuemin': 0, 'aria-valuemax': 100 },
                React.createElement('div', { ref: function ref(el) {
                        return _this3.barRef = el;
                    }, className: prefixCls + '-bar', style: (0, _extends3['default'])({}, barStyle, percentStyle) })
            );
        }
    }]);
    return Progress;
}(React.Component);

exports['default'] = Progress;

Progress.defaultProps = {
    prefixCls: 'am-progress',
    percent: 0,
    position: 'fixed',
    unfilled: true,
    appearTransition: false
};
module.exports = exports['default'];

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(29);

__webpack_require__(902);

/***/ }),
/* 902 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

__webpack_require__(905);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'timeline',
 * 组件：秒杀时间轴组件
 */
var TimelineCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TimelineCustomComponent, _React$Component);

  function TimelineCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TimelineCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TimelineCustomComponent.__proto__ || Object.getPrototypeOf(TimelineCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  /** 秒杀时间轴组件初始化*/


  /**
   * 点击时间轴筛选秒杀列表
   */


  (0, _createClass3.default)(TimelineCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * @desc 时间轴组件数据
       */
      var data = this.props.data;
      var _props$data = this.props.data,
          customFeature = _props$data.customFeature,
          content = _props$data.content,
          timelineData = _props$data.timelineData,
          severTime = _props$data.severTime;

      if (!timelineData) {
        timelineData = [];
      }
      var background = customFeature.background,
          fontSize = customFeature.fontSize,
          fontColor = customFeature.fontColor,
          fontWeight = customFeature.fontWeight,
          fontStyle = customFeature.fontStyle,
          textDecoration = customFeature.textDecoration,
          maskMarginSpace = customFeature.maskMarginSpace,
          isFranchisee = customFeature.isFranchisee,
          mode = customFeature.mode,
          selectNum = customFeature.selectNum,
          underlineHeight = customFeature.underlineHeight,
          underlineColor = customFeature.underlineColor,
          selectFontBackground = customFeature.selectFontBackground,
          fontRadius = customFeature.fontRadius,
          singleBackground = customFeature.singleBackground;


      maskMarginSpace = (0, _tools.transformPx2Rem)(maskMarginSpace);

      /**
       * @desc 样式转换
       */
      var styleObj = {
        height: this.props.data.style.height

        /**
         * @desc 时间轴样式处理
         */
      };var timelineStyleObj = {
        fontSize: (0, _tools.transformPx2Rem)(fontSize, 320),
        color: fontColor,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        textDecoration: textDecoration
      };

      /**
       * @desc 选中样式处理
       */
      var selectStyleObj = {
        fontSize: customFeature.selectFontSize,
        color: customFeature.selectFontColor,
        fontWeight: customFeature.selectFontWeight,
        fontStyle: customFeature.selectFontStyle,
        textDecoration: customFeature.selectTextDecoration
      };

      var selectTimeStyleObj = {
        fontSize: customFeature.selectTimeFontSize,
        color: customFeature.selectTimeFontColor,
        fontWeight: customFeature.selectTimeFontWeight,
        fontStyle: customFeature.selectTimeFontStyle,
        textDecoration: customFeature.selectTimeTextDecoration
      };
      return _react2.default.createElement(
        'div',
        { className: 'custom-component timeline', style: { background: background } },
        _react2.default.createElement(
          _ScrollView.ScrollView,
          { 'scroll-x': true, style: { background: data.customFeature.background } },
          _react2.default.createElement(
            'div',
            { style: (0, _extends3.default)({}, styleObj, timelineStyleObj), className: 'time-line' },
            content.map(function (item, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                mode == 1 && item.isShowTheArea && _react2.default.createElement(
                  'div',
                  { className: 'first-time-line',
                    style: { marginRight: maskMarginSpace },
                    'data-index': index,
                    'data-compindex': _this2.props.index,
                    'data-is-franchisee': isFranchisee || false,
                    onClick: _this2.screeningSeckillList },
                  _react2.default.createElement(
                    'div',
                    { className: 'first-timeline-font timeline-padLTB',
                      style: selectNum == index ? selectStyleObj : {} },
                    item.name
                  ),
                  selectNum == index && _react2.default.createElement('div', { className: 'select-line', style: { height: underlineHeight, background: underlineColor } })
                ),
                mode == 2 && item.isShowTheArea && _react2.default.createElement(
                  'div',
                  { className: 'first-time-line',
                    style: { marginRight: maskMarginSpace },
                    'data-index': index,
                    'data-compindex': _this2.props.index,
                    'data-is-franchisee': isFranchisee || false,
                    onClick: _this2.screeningSeckillList },
                  _react2.default.createElement(
                    'div',
                    { className: 'first-timeline-font',
                      style: selectNum == index ? (0, _extends3.default)({ background: selectFontBackground, borderRadius: fontRadius }, selectStyleObj) : {} },
                    item.name
                  )
                )
              );
            }),
            mode != 2 && mode != 1 && timelineData.map(function (item, index) {
              return item.isShowTheArea && _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: 'first-time-line',
                    style: { marginRight: maskMarginSpace, background: mode == 5 && (selectNum == index ? singleBackground : '') },
                    'data-index': index,
                    'data-compindex': _this2.props.index,
                    'data-is-franchisee': isFranchisee || false,
                    onClick: _this2.screeningSeckillList },
                  _react2.default.createElement(
                    'div',
                    null,
                    item.date_diff != 'more' && _react2.default.createElement(
                      'div',
                      { className: 'timeline-time', style: selectNum == index ? selectTimeStyleObj : {} },
                      (mode == 3 || mode == 5) && _react2.default.createElement(
                        'span',
                        null,
                        item.start_time
                      ),
                      mode == 4 && _react2.default.createElement(
                        'span',
                        { style: selectNum == index ? { background: selectFontBackground, borderRadius: fontRadius } : {} },
                        item.start_time
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'first-timeline-font timeline-padLTB',
                        style: selectNum == index ? selectStyleObj : {} },
                      item.start_timestamp <= severTime && content[0].isShowTheArea && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        content[0].name
                      ),
                      item.date_diff == 0 && item.start_timestamp > severTime && content[1].isShowTheArea && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        content[1].name
                      ),
                      item.date_diff == 1 && content[2].isShowTheArea && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        content[2].name
                      ),
                      item.date_diff == 'more' && content[3].isShowTheArea && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        content[3].name
                      )
                    )
                  ),
                  selectNum == index && _react2.default.createElement('div', { className: 'select-line', style: { height: underlineHeight, background: underlineColor } })
                )
              );
            })
          )
        )
      );
    }
  }]);
  return TimelineCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var that = _this3;
    var timelineData = pageInstance.data.eles[compindex];
    var timelineCustomFeature = timelineData.customFeature;
    var seckillCompindex = _app.appMethod.findComponentIndexById(timelineCustomFeature.timeline_object, pageInstance);

    //获取时间轴对应的秒杀活动id
    if (seckillCompindex > -1) {
      var seckillCustomFeature = pageInstance.data.eles[seckillCompindex].customFeature;
      if (seckillCustomFeature.seckillType === 'activeSeckill' && seckillCustomFeature.isShowFranchiseeGoods) {
        // 多店活动秒杀
        var activityId = seckillCustomFeature.seckillActive;
        var result = pageInstance.callComponentMethod({
          componentIndex: seckillCompindex,
          methodName: 'checkActivityIsFranchisee',
          argvs: [activityId]
        });
        result && result.then(function (flag) {
          that.timelineInit(compindex, pageInstance, flag, timelineData, activityId);
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        _this3.timelineInit(compindex, pageInstance);
      }
    }
  };

  this.timelineInit = function (compindex, pageInstance, isFranchisee, tlData, activityId) {
    var that = _this3;
    var timelineData = tlData || pageInstance.data.eles[compindex];
    timelineData.compindex = _this3.props.index;
    timelineData.customFeature.selectNum = -1;
    for (var i = 0; i < timelineData.content.length; i++) {
      if (timelineData.content[i].isShowTheArea && timelineData.customFeature.selectNum == -1) {
        timelineData.customFeature.selectNum = i; //默认选中第一个开启显示的
      }
    }
    timelineData.customFeature.compindex = _app.appMethod.findComponentIndexById(timelineData.customFeature.timeline_object, pageInstance);
    //获取时间轴对应的秒杀活动id
    if (timelineData.customFeature.compindex > -1) {
      timelineData.activeId = activityId || pageInstance.data.eles[timelineData.customFeature.compindex].customFeature.seckillActive;
    }
    var newData = {};
    if (timelineData.customFeature.mode == 1 || timelineData.customFeature.mode == 2) {
      newData['eles[' + compindex + '].customFeature.selectNum'] = timelineData.customFeature.selectNum;
      newData['eles[' + compindex + '].customFeature.isFranchisee'] = !!isFranchisee;
      var param = {
        currentTarget: {
          dataset: {
            compindex: timelineData.compindex,
            index: timelineData.customFeature.selectNum,
            isFranchisee: !!isFranchisee
          }
        }
      };
      that.screeningSeckillList(param);
      pageInstance.setData(newData);
    } else {
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppMarketing/GetSeckillActivityTime',
        data: {
          activity_id: timelineData.activeId
        },
        success: function success(res) {
          if (!res.status) {
            //删除明天以后的秒杀数据，并添加一个更多预告
            var data = res.data;
            var num = 0;
            var deleteIndex = 0;
            var selectNum = -1;
            for (var _i = 0; _i < data.length; _i++) {
              if (data[_i].date_diff > 1 && num == 0) {
                deleteIndex = _i;
              }
              if (data[_i].date_diff > 1) {
                num = num + 1;
              }
              if (data[_i].start_timestamp < res.time) {
                data[_i].isShowTheArea = timelineData.content[0].isShowTheArea;
              }
              if (data[_i].date_diff == 0 && data[_i].start_timestamp > res.time) {
                data[_i].isShowTheArea = timelineData.content[1].isShowTheArea;
              }
              if (data[_i].date_diff == 1) {
                data[_i].isShowTheArea = timelineData.content[2].isShowTheArea;
              }
              if (data[_i].isShowTheArea && selectNum == -1) {
                selectNum = _i;
              }
            }
            if (num) {
              data.splice(deleteIndex, num);
              data.push({ 'date_diff': 'more', 'isShowTheArea': timelineData.content[3].isShowTheArea });
            }
            newData['eles[' + compindex + '].timelineData'] = data;
            newData['eles[' + compindex + '].severTime'] = res.time;
            newData['eles[' + compindex + '].customFeature.selectNum'] = selectNum;
            newData['eles[' + compindex + '].customFeature.isFranchisee'] = !!isFranchisee;
          }
          pageInstance.setData(newData);
          var param = {
            currentTarget: {
              dataset: {
                compindex: timelineData.compindex,
                index: newData['eles[' + compindex + '].customFeature.selectNum'],
                isFranchisee: !!isFranchisee
              }
            }
          };
          that.screeningSeckillList(param);
        }
      });
    }
  };

  this.screeningSeckillList = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var timelineParameter = e.currentTarget.dataset;
    var timelineData = pageInstance.data.eles[timelineParameter.compindex];
    var compindex = timelineData.customFeature.compindex;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var param = {};

    var newdata = {};
    var seckill_activity_time_id = '';
    var seckill_activity_time_type = '';
    newdata['eles[' + timelineParameter.compindex + '].customFeature.selectNum'] = timelineParameter.index;

    if (timelineData.customFeature.mode == 1 || timelineData.customFeature.mode == 2) {
      if (timelineParameter.index < 2) {
        seckill_activity_time_type = timelineParameter.index + 1;
      } else {
        seckill_activity_time_type = timelineParameter.index + 2;
      }
    } else {
      if (timelineData.timelineData[timelineParameter.index] && timelineData.timelineData[timelineParameter.index].date_diff != 'more') {
        seckill_activity_time_id = timelineData.timelineData[timelineParameter.index].id;
      } else {
        seckill_activity_time_type = 5;
      }
    }
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex]) {
      var downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (var i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].goods_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].goods_data'] = [];

    param.form = "goods";
    param.goods_type = 0;
    param.page_size = customFeature.loadingNum || 10;
    param.is_seckill = 1;
    param.page = 1;
    param.is_integral = customFeature.isIntegral ? 1 : 0;
    param.is_count = 0;
    param.seckill_activity_arr = {
      seckill_activity_id: timelineData.activeId,
      seckill_activity_time_id: seckill_activity_time_id,
      seckill_activity_time_type: seckill_activity_time_type
    };
    param.is_seckill_activity = 1;
    if (timelineParameter['isFranchisee']) {
      param['is_app_shop_seckill'] = 1;
    }

    newdata['eles[' + compindex + '].seckill_activity_arr'] = param.seckill_activity_arr;
    newdata['eles[' + compindex + '].param'] = param;

    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      success: function success(res) {
        var rdata = res.data,
            appId = _app.appMethod.getAppId(),
            newdata = {},
            downcountArr = pageInstance.downcountObject[compindex] || [];
        if (rdata) {
          for (var _i2 = 0; _i2 < rdata.length; _i2++) {
            var f = rdata[_i2].form_data,
                dc = void 0;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            };
            if (f.seckill_start_state == 0) {
              dc = _app.appMethod.beforeSeckillDownCount(f, pageInstance, compindex + '.goods_data[' + _i2 + '].form_data');
            } else if (f.seckill_start_state == 1) {
              dc = _app.appMethod.duringSeckillDownCount(f, pageInstance, compindex + '.goods_data[' + _i2 + '].form_data');
            }
            dc && downcountArr.push(dc);
            if (customFeature.style == 2 && customFeature.mode == 0) {
              rdata[_i2].form_data = pageInstance.callComponentMethod({
                componentIndex: compindex,
                methodName: 'seckillStartTimeView',
                argvs: [f]
              });
            }
            if (+param.is_app_shop_seckill === 1 && f.app_id !== appId) {
              f.isSubShopGoods = true;
            } else {
              f.isSubShopGoods = false;
            }
          }
        }
        newdata['eles[' + compindex + '].goods_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more ? res.is_more : 0;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.downcountObject[compindex] = downcountArr;
        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };
};

exports.default = TimelineCustomComponent;

/***/ }),
/* 905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _ImgUpload = __webpack_require__(100);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(907);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'bbs'
 * 组件：评论组件
 */
var BbsCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(BbsCustomComponent, _React$Component);

  function BbsCustomComponent(props) {
    (0, _classCallCheck3.default)(this, BbsCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BbsCustomComponent.__proto__ || Object.getPrototypeOf(BbsCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(BbsCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this,
          _ref;

      // 组件数据
      var pageInstance = _app.appMethod.getAppCurrentPage();
      var data = this.props.data;
      var _props$data = this.props.data,
          customFeature = _props$data.customFeature,
          style = _props$data.style,
          content = _props$data.content,
          isShowReplyDialog = _props$data.isShowReplyDialog,
          dialogTop = _props$data.dialogTop,
          comment = _props$data.comment,
          replyIndex = _props$data.replyIndex;


      comment = comment || {};

      var mode = customFeature.mode,
          themeColor = customFeature.themeColor,
          ifLike = customFeature.ifLike;

      var styleObj = (0, _tools.convertStyleData)(style);

      return _react2.default.createElement(
        'div',
        { className: 'custom-component element bbs ' + (mode === 1 ? 'bbs-mode1' : ''),
          style: styleObj,
          onAnimationEnd: function onAnimationEnd(e) {
            return _this2.animationEnd(e);
          } },
        mode !== 1 && _react2.default.createElement(
          'div',
          { className: 'comment-amount-p' },
          _react2.default.createElement(
            'span',
            { className: 'ca-span' },
            _react2.default.createElement('span', { style: { backgroundColor: themeColor } }),
            '\u5168\u90E8\u8BC4\u8BBA'
          ),
          content.count || 0
        ),
        mode === 1 && _react2.default.createElement(
          'div',
          { className: 'comment-amount-p' },
          _react2.default.createElement(
            'span',
            { className: 'ca-span' },
            _react2.default.createElement('span', { style: { backgroundColor: themeColor } }),
            '\u5168\u90E8\u8BC4\u8BBA'
          ),
          content.count || 0
        ),
        _react2.default.createElement(
          'div',
          { className: 'comment-container js-list-container' },
          content.data && content.data.map(function (item, index) {
            return _react2.default.createElement(
              'div',
              { className: 'comment', key: index },
              _react2.default.createElement('img', { className: 'cover-img', src: item.form_data.cover_thumb || '//img.zhichiwangluo.com/zc_app_default_photo.png' }),
              _react2.default.createElement(
                'div',
                { className: 'comment-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'nickname-wrap' },
                  _react2.default.createElement(
                    'label',
                    { className: 'nickname' },
                    item.form_data.nickname
                  ),
                  _react2.default.createElement(
                    'label',
                    null,
                    item.form_data.content.reply && _react2.default.createElement(
                      'span',
                      { className: 'comment-reference-text' },
                      '@',
                      item.form_data.content.reply.nickname
                    ),
                    item.form_data.content.text
                  )
                ),
                Array.isArray(item.form_data.content.img || '') ? _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  item.form_data.content.img.map(function (el, index) {
                    return _react2.default.createElement('img', { className: 'comment-img',
                      key: index,
                      src: el,
                      'data-src': el,
                      onClick: function onClick(e) {
                        return _this2.previewImage(e, { current: el, urls: item.form_data.content.img });
                      } });
                  })
                ) : _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  item.form_data.content.img && _react2.default.createElement('img', { className: 'comment-img',
                    src: item.form_data.content.img,
                    'data-src': el,
                    onClick: function onClick(e) {
                      return _this2.previewImage(e, { current: el, urls: item.form_data.content.img });
                    } })
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'label',
                    { className: 'add-time' },
                    item.form_data.content.addTime
                  ),
                  ifLike && _react2.default.createElement(
                    'label',
                    {
                      className: 'bbs-content-btn ico-moon ' + (item.has_count == 1 ? 'icon-collect-solid' : 'icon-collect'),
                      style: { color: item.has_count == 1 ? '#f00' : '' },
                      'data-objrel': 'bbs_' + item.form_data.id,
                      'data-counted': item.has_count,
                      'data-compindex': _this2.props.index,
                      'data-parentcompindex': _this2.props.index,
                      'data-index': index,
                      onClick: _this2.changeCount },
                    item.count_num
                  ),
                  _react2.default.createElement('label', {
                    className: 'bbs-content-btn ico-moon icon-reply comment-reply-btn',
                    'data-compindex': _this2.props.index,
                    'data-index': index,
                    onClick: _this2.clickBbsReplyBtn })
                )
              )
            );
          }),
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          content.is_more == 0 && content.data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '还没有评论呦~' } }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'bbsScrollFuc', compindex: this.props.index } }),
          content.is_more == 0 && content.data.length > 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' })
        ),
        !mode ? _react2.default.createElement(
          'div',
          { className: 'bbs-fix-btn', style: {
              bottom: _app.appMethod.isTabBarPage() ? '48px' : ''
            } },
          _react2.default.createElement(
            'button',
            { className: 'ico-moon icon-bbs-comment',
              'data-compindex': this.props.index,
              onClick: this.showBbsReplyDialog },
            '\u8BC4\u8BBA'
          ),
          _react2.default.createElement('span', null),
          _react2.default.createElement(
            'button',
            { className: 'ico-moon icon-bbs-share' },
            '\u5206\u4EAB'
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'bbs-fix-btn', style: {
              bottom: _app.appMethod.isTabBarPage() ? '48px' : ''
            } },
          _react2.default.createElement(
            'span',
            { style: (_ref = {
                display: 'inline-block',
                width: '5.3rem',
                border: '1px solid #ddd',
                borderRadius: '.08rem',
                verticalAlign: 'middle',
                margin: '.18rem',
                height: 'calc(.6rem - 2px)',
                textIndent: '.1rem'
              }, (0, _defineProperty3.default)(_ref, 'height', '.6rem'), (0, _defineProperty3.default)(_ref, 'backgroundColor', '#fff'), (0, _defineProperty3.default)(_ref, 'lineHeight', '.6rem'), (0, _defineProperty3.default)(_ref, 'color', '#666'), _ref),
              'data-compindex': this.props.index,
              onClick: this.showBbsReplyDialog },
            '\u5199\u8BC4\u8BBA...'
          ),
          _react2.default.createElement(
            'button',
            { className: 'ico-moon icon-bbs-share',
              style: {
                backgroundColor: themeColor,
                color: '#fff',
                width: '1.38rem',
                fontSize: '.28rem',
                padding: '0 .1rem',
                borderRadius: '.08rem',
                margin: '.18rem',
                height: '.6rem',
                lineHeight: '.6rem',
                float: 'right'
              } },
            '\u5206\u4EAB'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'replyDialog',
            style: { display: !isShowReplyDialog ? 'none' : 'block' },
            'data-compindex': this.props.index,
            onClick: this.hideBbsReplyDialog },
          _react2.default.createElement(
            'div',
            { onClick: this.stopPropagation, style: dialogTop ? { top: dialogTop + 'px' } : {} },
            _react2.default.createElement(
              'div',
              { className: 'bbs-dialog-title' },
              '\u53D1\u8BC4\u8BBA',
              _react2.default.createElement('span', {
                style: { float: 'right', fontSize: '.36rem' },
                className: 'ico-moon icon-downarrow',
                'data-compindex': this.props.index,
                onClick: this.hideBbsReplyDialog }),
              '/'
            ),
            _react2.default.createElement(
              'div',
              { style: { backgroundColor: '#efefef', margin: '.1rem 0' } },
              _react2.default.createElement('textarea', { ref: function ref(input) {
                  return _this2.input = input;
                },
                value: comment.text || '',
                'data-compindex': this.props.index,
                onInput: this.bbsInputComment,
                onChange: function onChange() {} }),
              comment.img && comment.img.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, style: { position: 'relative', width: '1.4rem', display: 'inline-block', marginRight: '.2rem' } },
                  _react2.default.createElement('span', { className: 'delete-comment-img',
                    'data-index': index,
                    'data-compindex': _this2.props.index,
                    onClick: _this2.deleteCommentImage }),
                  _react2.default.createElement('img', { className: 'bbs-comment-img', src: item })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'ico-moon icon-pic selectBbsPic' },
                _react2.default.createElement(_ImgUpload.ImgUpload, { complete: function complete(url) {
                    return _this2.uploadBbsCommentImage(url);
                  } })
              ),
              _react2.default.createElement(
                'span',
                { className: 'bbs-publish-btn',
                  style: { backgroundColor: comment.text && comment.text.length || comment.img ? '#3091f2' : '#ccc' },
                  'data-compindex': this.props.index,
                  onClick: replyIndex == undefined || replyIndex == 'undefined' ? this.bbsPublishComment : this.bbsPublishReply },
                '\u53D1\u9001'
              )
            )
          )
        )
      );
    }
  }]);
  return BbsCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var bbsData = pageInstance.data.eles[compindex],
        bbs_idx_value = '';
    var pageRequestNum = pageInstance.requestNum;

    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        bbs_idx_value = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        bbs_idx_value = pageInstance.page_router;
      }
    } else {
      bbs_idx_value = _app.appMethod.getAppId();
    }
    var newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].content.data'] = [];
    newdata['eles[' + compindex + '].content.is_more'] = 1;
    newdata['eles[' + compindex + '].content.current_page'] = 0;
    pageInstance.setData(newdata);

    pageInstance.requestNum = pageRequestNum + 1;
    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: {
        form: 'bbs',
        is_count: bbsData.customFeature.ifLike ? 1 : 0,
        page: 1,
        idx_arr: {
          idx: 'rel_obj',
          idx_value: bbs_idx_value
        }
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var data = {};

        for (var i in res.data) {
          res.data[i].form_data.content.addTime = res.data[i].form_data.content.addTime.slice(2, 19);
        }
        if (res.count > 99) {
          res.count = '99+';
        } else if (res.count > 999) {
          res.count = '999+';
        } else if (res.count > 10000) {
          res.count = '1w+';
        }

        data['eles[' + compindex + '].content'] = res;
        data['eles[' + compindex + '].comment'] = {};
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.clickBbsReplyBtn = function (event) {
    event.stopPropagation();
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var index = dataset.index;
    var data = {};
    data['eles[' + compindex + '].replyIndex'] = index;
    data['eles[' + compindex + '].bbsFocus'] = true;
    data['eles[' + compindex + '].isShowReplyDialog'] = true;
    pageInstance.setData(data);
  };

  this.bbsScrollFuc = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var bbsData = pageInstance.data.eles[compindex];
    var bbs_idx_value = '';

    if (bbsData.loading || bbsData.content.is_more == 0) {
      return;
    }
    var newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    pageInstance.setData(newdata);

    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        bbs_idx_value = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        bbs_idx_value = pageInstance.page_router;
      }
    } else {
      bbs_idx_value = _app.appMethod.getAppId();
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/getFormDataList',
      method: 'post',
      data: {
        form: 'bbs',
        is_count: bbsData.customFeature.ifLike ? 1 : 0,
        page: bbsData.content.current_page + 1,
        idx_arr: {
          idx: 'rel_obj',
          idx_value: bbs_idx_value
        }
      },
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var data = {},
            newData = {};
        data = res;

        data.data = bbsData.content.data.concat(res.data);
        data.isloading = false;

        newData['eles[' + compindex + '].content'] = data;
        newData['eles[' + compindex + '].loading'] = false;
        newData['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(newData);
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.showBbsReplyDialog = function (e) {
    _this3.input.focus();
    var compindex = e.currentTarget.dataset.compindex,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        newdata = {};
    newdata['eles[' + compindex + '].isShowReplyDialog'] = true;
    newdata['eles[' + compindex + '].bbsFocus'] = true;
    if (pageInstance.data.eles.page_hasNavBar) {
      newdata['eles[' + compindex + '].dialogTop'] = _app.appMethod.globalData.topNavBarHeight || 0;
    }
    pageInstance.setData(newdata);
  };

  this.hideBbsReplyDialog = function (e) {
    var compindex = e.currentTarget.dataset.compindex,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        newdata = {};
    newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
    newdata['eles[' + compindex + '].bbsFocus'] = false;
    newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
    pageInstance.setData(newdata);
  };

  this.bbsInputComment = function (event) {
    var dataset = event.target.dataset;
    var comment = event.target.value;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var data = {};
    data['eles[' + compindex + '].comment.text'] = comment;
    pageInstance.setData(data);
  };

  this.deleteCommentImage = function (event) {
    event.stopPropagation();
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var index = dataset.index;
    var oldData = pageInstance.data.eles[compindex].comment.img;
    var data = {};
    oldData.splice(index, 1);
    data['eles[' + compindex + '].comment.img'] = oldData;
    pageInstance.setData(data);
  };

  this.uploadBbsCommentImage = function (res) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = _this3.props.index;
    var data = {};

    var oldData = pageInstance.data.eles[compindex].comment.img || [];
    data['eles[' + compindex + '].comment.img'] = [].concat((0, _toConsumableArray3.default)(oldData), [res]);
    pageInstance.setData(data);
  };

  this.bbsPublishComment = function (event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var bbsData = pageInstance.data.eles[compindex];
    var comment = bbsData.comment;
    var param = void 0;

    if (!comment.text || !comment.text.trim()) {
      _app.appMethod.showModal({
        content: '请输入评论内容'
      });
      return;
    }

    comment.text = encodeURIComponent(comment.text);

    delete comment.showReply;
    comment.addTime = _util2.default.formatTime();

    param = {};
    param.nickname = _app.appMethod.globalData.userInfo.nickname;
    param.cover_thumb = _app.appMethod.globalData.userInfo.cover_thumb;
    param.user_token = _app.appMethod.globalData.userInfo.user_token;
    param.page_url = pageInstance.page_router;
    param.content = comment;
    param.rel_obj = '';
    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        param.rel_obj = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        param.rel_obj = pageInstance.page_router;
      }
    } else {
      param.rel_obj = _app.appMethod.getAppId();
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/addData',
      method: 'post',
      data: {
        form: 'bbs',
        form_data: param
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var commentList = bbsData.content.data || [],
            newdata = {};

        param.id = res.data;
        param.content.text = decodeURIComponent(param.content.text);
        newdata['eles[' + compindex + '].content.data'] = [{
          form_data: param,
          count_num: 0
        }].concat(commentList);
        var count = '';
        if (+bbsData.content.count + 1 <= 99) {
          count = +bbsData.content.count + 1;
        } else if (+bbsData.content.count + 1 > 99) {
          count = '99+';
        } else if (+bbsData.content.count + 1 > 999) {
          count = '999+';
        } else if (+bbsData.content.count + 1 > 10000) {
          count = '1w+';
        }
        newdata['eles[' + compindex + '].content.count'] = count;
        newdata['eles[' + compindex + '].comment'] = {};
        newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
        newdata['eles[' + compindex + '].bbsFocus'] = false;
        newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
        pageInstance.setData(newdata);
      }
    });
  };

  this.bbsPublishReply = function (event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var bbsData = pageInstance.data.eles[compindex];
    var index = bbsData.replyIndex;
    var form_data = bbsData.content.data[index].form_data;
    var comment = bbsData.comment;
    var param = void 0;
    if (!comment.text || !comment.text.trim()) {
      _app.appMethod.showModal({
        content: '请输入回复内容'
      });
      return;
    }

    comment.text = encodeURIComponent(comment.text);

    comment.addTime = _util2.default.formatTime();
    comment.reply = {
      nickname: form_data.nickname,
      text: form_data.content.text,
      img: form_data.content.img,
      user_token: form_data.user_token,
      reply: form_data.content.reply
    };

    param = {};
    param.nickname = _app.appMethod.globalData.userInfo.nickname;
    param.cover_thumb = _app.appMethod.globalData.userInfo.cover_thumb;
    param.user_token = _app.appMethod.globalData.userInfo.user_token;
    param.page_url = pageInstance.page_router;
    param.content = comment;
    param.rel_obj = '';
    if (bbsData.customFeature.ifBindPage && bbsData.customFeature.ifBindPage !== 'false') {
      if (pageInstance.page_form && pageInstance.page_form != 'none') {
        param.rel_obj = pageInstance.page_form + '_' + pageInstance.dataId;
      } else {
        param.rel_obj = pageInstance.page_router;
      }
    } else {
      param.rel_obj = _app.appMethod.getAppId();
    }

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppData/addData',
      method: 'post',
      data: {
        form: 'bbs',
        form_data: param
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var commentList = bbsData.content.data || [],
            newdata = {};

        param.id = res.data;
        param.content.text = decodeURIComponent(param.content.text);
        if (commentList.length) {
          delete commentList[index].replyText;
          delete commentList[index].showReply;
        }
        newdata['eles[' + compindex + '].content.data'] = [{
          form_data: param,
          count_num: 0
        }].concat(commentList);
        var count = '';
        if (+bbsData.content.count + 1 <= 99) {
          count = +bbsData.content.count + 1;
        } else if (+bbsData.content.count + 1 > 99) {
          count = '99+';
        } else if (+bbsData.content.count + 1 > 999) {
          count = '999+';
        } else if (+bbsData.content.count + 1 > 10000) {
          count = '1w+';
        }
        newdata['eles[' + compindex + '].content.count'] = count;
        newdata['eles[' + compindex + '].comment'] = {};
        newdata['eles[' + compindex + '].isShowReplyDialog'] = false;
        newdata['eles[' + compindex + '].bbsFocus'] = false;
        newdata['eles[' + compindex + '].replyIndex'] = 'undefined';
        pageInstance.setData(newdata);
      }
    });
  };

  this.previewImage = function (e, options) {
    e.stopPropagation();
    _app.appMethod.previewImage(options);
  };

  this.changeCount = function (e) {
    e.stopPropagation();
    _app.appMethod.changeCount(e);
  };

  this.stopPropagation = function (e) {
    e.stopPropagation();
  };
};

exports.default = BbsCustomComponent;

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(909);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'video-list'
 * 组件：视频列表组件
 */
var VideoListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(VideoListCustomComponent, _React$Component);

  function VideoListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, VideoListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (VideoListCustomComponent.__proto__ || Object.getPrototypeOf(VideoListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  (0, _createClass3.default)(VideoListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;
      var _props$data = this.props.data,
          customFeature = _props$data.customFeature,
          style = _props$data.style,
          video_data = _props$data.video_data,
          title_width = _props$data.title_width;
      // TODO 暂时拿不到title_width

      title_width = title_width || { width: '' };
      var mode = customFeature.mode,
          hideRate = customFeature.hideRate,
          hidePlayCount = customFeature.hidePlayCount,
          imgWidth = customFeature.imgWidth,
          imgHeight = customFeature.imgHeight,
          lineHeight = customFeature.lineHeight,
          margin = customFeature.margin,
          lineBackgroundColor = customFeature.lineBackgroundColor;

      var styleObj = (0, _tools.convertStyleData)(style);
      if (customFeature.vesselAutoheight == 0) {
        styleObj['height'] = (0, _tools.transformPx2Rem)(customFeature['height'], 320);
      }
      var listStyleObj = {
        marginBottom: (0, _tools.transformPx2Rem)(margin, 320),
        backgroundColor: lineBackgroundColor,
        height: (0, _tools.transformPx2Rem)(lineHeight, 320)
      };
      var imgStyleObj = {
        width: (0, _tools.transformPx2Rem)(imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(imgHeight, 320)
      };

      var swiperStyleObj = {
        marginBottom: (0, _tools.transformPx2Rem)(margin, 320),
        height: (0, _tools.transformPx2Rem)(lineHeight, 320),
        backgroundColor: lineBackgroundColor
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component video-list' },
        _react2.default.createElement(
          _ScrollView.ScrollView,
          {
            className: 'element video-list scroll-ele video-list-mode-' + mode,
            style: styleObj,
            'data-compindex': this.props.index,
            'scroll-y': 'true',
            'scroll-x': 'false',
            'lower-threshold': '100',
            bindscrolltolower: function bindscrolltolower(e) {
              return _this3.videoScrollFunc(e);
            }
            // bindanimationend="animationEnd"
          },
          _react2.default.createElement(
            'div',
            { className: 'js-list-container video-list-ul clearfix' },
            mode == 1 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              video_data && video_data.map(function (item) {
                return _react2.default.createElement(
                  'div',
                  { className: 'video-list-item clearfix',
                    key: item.id,
                    style: listStyleObj,
                    'data-id': item.id,
                    onClick: _this3.turnToVideoDetail },
                  _react2.default.createElement(
                    'div',
                    { className: 'video-list-inner' },
                    _react2.default.createElement(
                      'div',
                      { className: 'list-img-outer', style: imgStyleObj },
                      _react2.default.createElement('img', { className: 'list-img', src: item.preview_img }),
                      _react2.default.createElement('div', { className: 'video-list-play icon-play ico-moon' }),
                      !hideRate && _react2.default.createElement(
                        'label',
                        { className: 'rate' },
                        item.score
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'title-container' },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.title
                      ),
                      !hidePlayCount && _react2.default.createElement(
                        'div',
                        { className: 'play-count-outer' },
                        _react2.default.createElement('label', { className: 'video-eye ico-moon icon-eye' }),
                        _react2.default.createElement(
                          'label',
                          { className: 'play-count' },
                          item.video_view
                        )
                      ),
                      item.is_free == '0' && _react2.default.createElement(
                        'div',
                        { className: 'price' },
                        _react2.default.createElement(
                          'label',
                          { className: 'rmb' },
                          '\xA5'
                        ),
                        item.price
                      ),
                      item.is_free != '0' && _react2.default.createElement(
                        'div',
                        { className: 'price' },
                        '\u514D\u8D39'
                      )
                    )
                  )
                );
              })
            ),
            mode == 3 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _carousel2.default,
                {
                  autoplay: false,
                  dots: false,
                  infinite: true,
                  style: swiperStyleObj
                },
                video_data && video_data.map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'video-list-item', key: item.id, style: listStyleObj },
                    _react2.default.createElement(
                      'div',
                      { className: 'video-list-inner' },
                      _react2.default.createElement(
                        'div',
                        { className: 'list-img-outer', style: imgStyleObj },
                        _react2.default.createElement('img', { className: 'list-img', src: item.preview_img }),
                        _react2.default.createElement('div', { className: 'video-list-play icon-play ico-moon' }),
                        !hideRate && _react2.default.createElement(
                          'label',
                          { className: 'rate' },
                          item.score
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'title-container', style: { width: mode == 0 ? title_width.width : 'auto' } },
                        _react2.default.createElement(
                          'div',
                          { className: 'title' },
                          item.title
                        ),
                        item.is_free == '0' && _react2.default.createElement(
                          'div',
                          { className: 'price' },
                          _react2.default.createElement(
                            'label',
                            { className: 'rmb' },
                            '\xA5'
                          ),
                          item.price
                        ),
                        item.is_free != '0' && _react2.default.createElement(
                          'div',
                          { className: 'price' },
                          '\u514D\u8D39'
                        ),
                        !hidePlayCount && _react2.default.createElement(
                          'div',
                          { className: 'play-count-outer' },
                          _react2.default.createElement('label', { className: 'video-eye ico-moon icon-eye' }),
                          _react2.default.createElement(
                            'label',
                            { className: 'play-count' },
                            item.video_view
                          )
                        )
                      )
                    )
                  );
                })
              )
            ),
            mode != 1 && mode != 3 && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              video_data && video_data.map(function (item) {
                return _react2.default.createElement(
                  'div',
                  { className: 'video-list-item clearfix',
                    key: item.id,
                    style: listStyleObj,
                    'data-id': item.id,
                    onClick: _this3.turnToVideoDetail },
                  _react2.default.createElement(
                    'div',
                    { className: 'video-list-inner' },
                    _react2.default.createElement(
                      'div',
                      { className: 'list-img-outer' },
                      _react2.default.createElement('img', { className: 'list-img', src: item.preview_img, style: imgStyleObj }),
                      _react2.default.createElement('div', { className: 'video-list-play icon-play ico-moon' })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'title-container', style: { width: mode == 0 ? title_width.width : 'auto' } },
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'video-list-score' },
                        !hideRate && _react2.default.createElement(
                          'div',
                          { className: 'video-score-wrap' },
                          _react2.default.createElement(
                            'div',
                            { className: 'numeric' },
                            _react2.default.createElement('label', { className: 'star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star ico-moon icon-score' })
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'numeric numeric-top', style: { width: item.score * 10 + '%' } },
                            _react2.default.createElement('label', { className: 'star full-star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star full-star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star full-star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star full-star ico-moon icon-score' }),
                            _react2.default.createElement('label', { className: 'star full-star ico-moon icon-score' })
                          )
                        ),
                        !hideRate && _react2.default.createElement(
                          'label',
                          { className: 'rate' },
                          item.score
                        ),
                        !hidePlayCount && _react2.default.createElement('label', { className: 'video-eye ico-moon icon-eye' }),
                        !hidePlayCount && _react2.default.createElement(
                          'label',
                          { className: 'play-count' },
                          item.video_view
                        )
                      ),
                      item.is_free == '0' && _react2.default.createElement(
                        'div',
                        { className: 'price' },
                        _react2.default.createElement(
                          'label',
                          { className: 'rmb' },
                          '\xA5'
                        ),
                        item.price
                      ),
                      item.is_free != '0' && _react2.default.createElement(
                        'div',
                        { className: 'price' },
                        '\u514D\u8D39'
                      )
                    )
                  )
                );
              })
            )
          ),
          customFeature.mode != 3 && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
            data.is_more == 0 && data.video_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无视频~' } }),
            data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'videoScrollFunc', compindex: this.props.index } }),
            data.is_more == 0 && data.video_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
            data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.videoScrollFunc, 'data-compindex': this.props.index })
          )
        )
      );
    }
  }]);
  return VideoListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var param = {};
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var newdata = {};

    var isClassify = false;
    if (_app.appMethod.getInvolvedFromRefreshObject(customFeature.id, 'new-classify')) {
      isClassify = true;
    }
    if (isClassify) {
      return;
    }

    param.form = "video";
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    if (customFeature.source && customFeature.source != 'none') {
      param.cate_id = customFeature.source;
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].video_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].param'] = param;
    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppVideo/GetVideoList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          var rdata = res.data,
              _newdata = {};

          for (var i = 0; i < rdata.length; i++) {
            rdata[i].video_view = _app.appMethod.handlingNumber(rdata[i].video_view);
          }

          _newdata['eles[' + compindex + '].video_data'] = rdata;

          _newdata['eles[' + compindex + '].is_more'] = res.is_more;
          _newdata['eles[' + compindex + '].curpage'] = 1;
          _newdata['eles[' + compindex + '].loading'] = false;
          _newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.setData(_newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.videoScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];

    if (compData.is_search) {
      // 与搜索组件相关联
      var searchComponentIndex = compData.searchEle;
      pageInstance.callComponentMethod({
        componentIndex: searchComponentIndex,
        methodName: 'searchList',
        argvs: [searchComponentIndex, event]
      });
    } else {
      _this4._videoScrollFunc(event);
    }
  };

  this._videoScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var curpage = compData.curpage + 1;
    var customFeature = compData.customFeature;
    var newdata = {};
    var param = compData.param || {};

    if (!compData.is_more && (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' && event.type == 'tap') {
      _app.appMethod.showModal({
        content: '已经加载到最后了'
      });
    }
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);

    param.page_size = customFeature.loadingNum || 20;
    param.page = curpage;

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppVideo/GetVideoList',
      data: param,
      method: 'post',
      hideLoading: true,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var rdata = res.data;

        for (var i = 0; i < rdata.length; i++) {
          rdata[i].video_view = _app.appMethod.handlingNumber(rdata[i].video_view);
        }

        newdata = {};
        newdata['eles[' + compindex + '].video_data'] = compData.video_data.concat(rdata);
        newdata['eles[' + compindex + '].is_more'] = res.is_more;
        newdata['eles[' + compindex + '].curpage'] = res.current_page;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {}
    });
  };

  this.turnToVideoDetail = function (e) {
    _app.appMethod.turnToVideoDetail(e);
  };

  this._refreshVideoList = function (targetCompIndex, requestData, pageInstance) {
    var _this = _this4;

    requestData.page_size = requestData.page_size || pageInstance.data.eles[targetCompIndex].customFeature.loadingNum || 10;
    if (requestData.idx_arr['idx'] === 'category') {
      requestData.cate_id = requestData.idx_arr['idx_value'];
    }

    var newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].video_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    newdata['eles[' + targetCompIndex + '].curpage'] = 0;
    newdata['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newdata);

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppVideo/GetVideoList',
      data: requestData,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          var rdata = res.data,
              _newdata2 = {};

          for (var i = 0; i < rdata.length; i++) {
            rdata[i].video_view = _app.appMethod.handlingNumber(rdata[i].video_view);
          }

          _newdata2['eles[' + targetCompIndex + '].video_data'] = rdata;

          _newdata2['eles[' + targetCompIndex + '].is_more'] = res.is_more;
          _newdata2['eles[' + targetCompIndex + '].curpage'] = 1;
          _newdata2['eles[' + targetCompIndex + '].loading'] = false;
          _newdata2['eles[' + targetCompIndex + '].loadingFail'] = false;

          pageInstance.setData(_newdata2);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };
};

exports.default = VideoListCustomComponent;

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(911);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "topic-classify" 
 * 组件：话题分类组件
 */

var TopicClassifyCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TopicClassifyCustomComponent, _React$Component);

  function TopicClassifyCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TopicClassifyCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopicClassifyCustomComponent.__proto__ || Object.getPrototypeOf(TopicClassifyCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(TopicClassifyCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 商品分类
      var content = data.content;
      // 组件样式
      var styleObj = (0, _tools.convertStyleData)(data.style);
      // 图片样式
      var imgStyle = {
        width: (0, _tools.transformPx2Rem)(customFeature.width, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.height, 320),
        marginLeft: (0, _tools.transformPx2Rem)(customFeature['margin-left']),
        marginTop: (0, _tools.transformPx2Rem)(customFeature['margin-top']),
        borderRadius: (0, _tools.transformPx2Rem)(customFeature.picBorderRadius)
        // 被选中样式
      };var selectStyle = {
        color: customFeature.selectedColor
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component topic-classify', style: styleObj },
        content.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'classify-item',
              key: index,
              style: data.selectedSectionId == item.bindPlate && data.selectedCategoryId == item.classifyId ? selectStyle : {},
              onClick: _this2.switchTopicCategory,
              'data-compindex': _this2.props.index,
              'data-topic-compindex': data.relateTopicCompIndex,
              'data-sectionid': item.bindPlate,
              'data-categoryid': item.classifyId
            },
            _react2.default.createElement(
              'div',
              { className: 'img-wrap' },
              _react2.default.createElement('img', { className: 'classify-logo', style: imgStyle, src: item.pic, alt: '' })
            ),
            _react2.default.createElement(
              'div',
              null,
              item.name
            )
          );
        })
      );
    }
  }]);
  return TopicClassifyCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  this.init = function (compindex, pageInstance) {
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    // 设置param

    var param = customFeature;
    // 感觉后面topic可直接用customFeature
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));
    var newdata = {};
    var topicCompIndex = _app.appMethod.findComponentIndexById(customFeature.topic_refresh_object, pageInstance);
    if (topicCompIndex > -1) {
      var topicList = pageInstance.data.eles[topicCompIndex].customFeature;
      newdata['eles[' + compindex + '.relateTopicCompIndex'] = topicCompIndex;
      newdata['eles[' + topicCompIndex + '.relateClassifyCompIndex'] = compindex;
      newdata['eles[' + compindex + '.selectedSectionId'] = topicList.bindPlate;
      newdata['eles[' + compindex + '.selectedCategoryId'] = topicList.bindTopic;
      pageInstance.setData(newdata);
    } else {
      _app.appMethod.showModal({ content: '话题分类未找到绑定的话题列表' });
    }
  };

  this.switchTopicCategory = function (e) {
    var currentTarget = e.currentTarget,
        dataset = currentTarget.dataset,
        compindex = dataset.compindex,
        section_id = dataset.sectionid || 0,
        category_id = dataset.categoryid || 0,
        topicCompIndex = dataset.topicCompindex,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        newdata = {};

    if (topicCompIndex) {
      var searchCompIndex = pageInstance.data.eles[topicCompIndex].relateSearchCompIndex;

      newdata['eles[' + compindex + '].selectedSectionId'] = section_id;
      newdata['eles[' + compindex + '].selectedCategoryId'] = category_id;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].listParam.search_value'] = '';
      newdata['eles[' + topicCompIndex + '].topicList'] = [];

      if (searchCompIndex && searchCompIndex > -1) {
        newdata['eles[' + searchCompIndex + '].searchValue'] = '';
      }
      newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
      newdata['eles[' + topicCompIndex + '].listParam.section_id'] = section_id;
      newdata['eles[' + topicCompIndex + '].listParam.category_id'] = category_id;

      pageInstance.setData(newdata);
      pageInstance.callComponentMethod({
        componentIndex: topicCompIndex,
        methodName: 'getTopListData',
        argvs: [topicCompIndex, pageInstance]
      });
    } else {
      _app.appMethod.showModal({ content: '话题分类未找到绑定的话题列表' });
    }
  };
};

exports.default = TopicClassifyCustomComponent;

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(913);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "topic-sort" 
 * 组件：话题排序组件
 */

var TopicSortCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(TopicSortCustomComponent, _React$Component);

  function TopicSortCustomComponent(props) {
    (0, _classCallCheck3.default)(this, TopicSortCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopicSortCustomComponent.__proto__ || Object.getPrototypeOf(TopicSortCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(TopicSortCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 商品分类
      var content = data.content;
      // 组件样式
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var selectStyle = {
        color: customFeature.selectedColor
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component topic-sort', style: styleObj },
        content.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'sort-item',
              key: index,
              style: item.orderby == data.currentOrderby ? selectStyle : {},
              onClick: _this2.switchTopiclistOrderBy,
              'data-orderby': item.orderby,
              'data-order': item.order,
              'data-compindex': _this2.props.index
            },
            item.text
          );
        })
      );
    }
  }]);
  return TopicSortCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  this.init = function (compindex, pageInstance) {
    var _pageInstance$setData3;

    var _pageInstance$data$el = pageInstance.data.eles[compindex],
        customFeature = _pageInstance$data$el.customFeature,
        content = _pageInstance$data$el.content;
    // 设置param

    var param = customFeature;
    // 感觉后面topic可直接用customFeature
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].param', param));
    var topicCompIndex = _app.appMethod.findComponentIndexById(customFeature.topic_sort_object);
    if (topicCompIndex < 0) {
      _app.appMethod.showModal({ content: '话题排序未找到绑定的话题列表' });
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].currentOrderby', 'comment_count'));
      return;
    }
    pageInstance.setData((_pageInstance$setData3 = {}, (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + compindex + '].currentOrderby', content[0].orderby), (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + compindex + '].relateTopicCompIndex', topicCompIndex), (0, _defineProperty3.default)(_pageInstance$setData3, 'eles[' + topicCompIndex + '.relateSortCompIndex', compindex), _pageInstance$setData3));
  };

  this.switchTopiclistOrderBy = function (e) {
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var orderby = dataset.orderby;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];

    if (compData.relateTopicCompIndex) {
      var topicCompIndex = compData.relateTopicCompIndex;
      var topicListParam = pageInstance.data.eles[topicCompIndex].listParam;

      newdata['eles[' + compindex + '].currentOrderby'] = orderby;
      newdata['eles[' + topicCompIndex + '].listParam.orderby'] = orderby;
      newdata['eles[' + topicCompIndex + '].listStatus.loading'] = false;
      newdata['eles[' + topicCompIndex + '].listStatus.isMore'] = true;
      newdata['eles[' + topicCompIndex + '].topicList'] = [];

      if (orderby === 'distance' && !topicListParam.latitude) {
        _app.appMethod.getLocation({
          success: function success(res) {
            newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
            newdata['eles[' + topicCompIndex + '].listParam.orderby'] = orderby;
            newdata['eles[' + topicCompIndex + '].listParam.latitude'] = res.latitude;
            newdata['eles[' + topicCompIndex + '].listParam.longitude'] = res.longitude;
            pageInstance.setData(newdata);
            pageInstance.callComponentMethod({
              componentIndex: topicCompIndex,
              methodName: 'getTopListData',
              argvs: [topicCompIndex, pageInstance]
            });
          }
        });
      } else {
        newdata['eles[' + topicCompIndex + '].listParam.page'] = 1;
        pageInstance.setData(newdata);
        pageInstance.callComponentMethod({
          componentIndex: topicCompIndex,
          methodName: 'getTopListData',
          argvs: [topicCompIndex, pageInstance]
        });
      }
    } else {
      _app.appMethod.showModal({ content: '话题排序未找到绑定的话题列表' });
    }
  };
};

exports.default = TopicSortCustomComponent;

/***/ }),
/* 913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _global = __webpack_require__(42);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

__webpack_require__(915);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserCenterHeadCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(UserCenterHeadCustomComponent, _React$Component);

  function UserCenterHeadCustomComponent(props) {
    (0, _classCallCheck3.default)(this, UserCenterHeadCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserCenterHeadCustomComponent.__proto__ || Object.getPrototypeOf(UserCenterHeadCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(UserCenterHeadCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var userData = data.userData; // 用户数据
      /**
       * 页面上的数据
       */
      var userInfo = _page.pageInstance.state.userInfo || {}; // 用户信息
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;
      /**
       * 样式数据处理
       */
      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * 组件内容处理
       */
      var content = data.content;
      /**
       * 返回组件
       */
      return _react2.default.createElement(
        'div',
        { className: 'custom-component user-center-head', style: styleObj },
        customFeature.member == 1 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          customFeature['personal-mode'] == 1 && _react2.default.createElement(
            'div',
            { className: 'show-view', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter',
              style: {
                height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                backgroundColor: customFeature.topSectionStyle['background-color'],
                backgroundImage: customFeature.topSectionStyle['background-image'],
                opacity: customFeature.topSectionStyle['opacity'] || 1,
                backgroundSize: '100% 100%'
              }
            },
            _react2.default.createElement('label', { className: 'empty-span' }),
            _react2.default.createElement('img', { className: 'cover-thumb', style: {
                width: customFeature.topSectionStyle.coverHeight,
                height: customFeature.topSectionStyle.coverHeight
              }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' }),
            _react2.default.createElement(
              'label',
              { className: 'nickname', style: {
                  color: customFeature.topSectionStyle.color,
                  fontSize: customFeature.topSectionStyle['font-size'],
                  fontStyle: customFeature.topSectionStyle['font-style'],
                  textDecoration: customFeature.topSectionStyle['text-decoration'],
                  fontWeight: customFeature.topSectionStyle['font-weight'],
                  marginLeft: '.40rem'
                } },
              userInfo.nickname || '用户名'
            ),
            _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow' })
          ),
          customFeature['personal-mode'] == 2 && _react2.default.createElement(
            'div',
            { className: 'show-view', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter',
              style: {
                textAlign: 'center',
                height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                backgroundColor: customFeature.topSectionStyle['background-color'],
                backgroundImage: customFeature.topSectionStyle['background-image'],
                opacity: customFeature.topSectionStyle['opacity'] || 1,
                backgroundSize: '100% 100%'
              } },
            _react2.default.createElement('label', { className: 'empty-span' }),
            _react2.default.createElement(
              'div',
              { style: {
                  display: 'inline-block',
                  verticalAlign: 'middle'
                } },
              _react2.default.createElement('img', { className: 'cover-thumb', style: {
                  width: customFeature.topSectionStyle.coverHeight,
                  height: customFeature.topSectionStyle.coverHeight
                }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' }),
              _react2.default.createElement(
                'label',
                { className: 'nickname', style: {
                    color: customFeature.topSectionStyle.color,
                    fontSize: customFeature.topSectionStyle['font-size'],
                    fontStyle: customFeature.topSectionStyle['font-style'],
                    textDecoration: customFeature.topSectionStyle['text-decoration'],
                    fontWeight: customFeature.topSectionStyle['font-weight']
                  } },
                userInfo.nickname || '用户名'
              )
            ),
            _react2.default.createElement('div', { className: 'empty-span' })
          ),
          customFeature['personal-mode'] == 3 && _react2.default.createElement(
            'div',
            { className: 'personal-mode-0', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter',
              style: {
                textAlign: 'center',
                height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                backgroundColor: customFeature.topSectionStyle['background-color'],
                backgroundImage: customFeature.topSectionStyle['background-image'],
                opacity: customFeature.topSectionStyle['opacity'] || 1,
                backgroundSize: '100% 100%'
              } },
            _react2.default.createElement('label', { className: 'empty-span' }),
            _react2.default.createElement(
              'label',
              { className: 'nickname', style: {
                  color: customFeature.topSectionStyle.color,
                  fontSize: customFeature.topSectionStyle['font-size'],
                  fontStyle: customFeature.topSectionStyle['font-style'],
                  textDecoration: customFeature.topSectionStyle['text-decoration'],
                  fontWeight: customFeature.topSectionStyle['font-weight']
                } },
              userInfo.nickname || '用户名'
            ),
            _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow' }),
            _react2.default.createElement('img', { className: 'cover-thumb', style: {
                width: customFeature.topSectionStyle.coverHeight,
                height: customFeature.topSectionStyle.coverHeight
              }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' })
          )
        ),
        userData && customFeature.member == 2 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          customFeature['senior-mode'] == 1 && _react2.default.createElement(
            'div',
            { style: {
                paddingBottom: !userData.user_vip_card || !userData.user_paid_vip_card || userData.need_collect_info == 1 ? '.30rem' : 0
              } },
            _react2.default.createElement(
              'div',
              { className: 'show-view-all', style: {
                  paddingBottom: !userData.user_vip_card || !userData.user_paid_vip_card || userData.need_collect_info == 1 ? '.30rem' : 0
                } },
              _react2.default.createElement(
                _carousel2.default,
                {
                  dots: userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info != 1 ? true : false,
                  style: {
                    height: userData.user_paid_vip_card && userData.need_collect_info != 1 ? 'calc(' + (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320) + ' + 20px)' : (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                    zIndex: 2
                  },
                  dotStyle: {
                    background: '#E1E1E1'
                  },
                  dotActiveStyle: {
                    background: '#ADADAD'
                  }
                },
                [!!(!userData.user_vip_card && !userData.user_paid_vip_card || userData.need_collect_info == 1) && _react2.default.createElement(
                  'div',
                  { className: 'personal-mode-3 show-view',
                    style: {
                      textAlign: 'center',
                      height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%'
                    },
                    onClick: this.vipCardTurnToPage,
                    'data-type': 'average-user',
                    'data-needcollectinfo': userData.need_collect_info,
                    'data-isturnto': userData.all_vip_card.length > 0 || userData.is_vip_benefit_day == 1 ? 'true' : 'false'
                  },
                  (!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card || !userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1 || userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1) && _react2.default.createElement('img', { className: 'user-center-mark', src: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'personal-main' },
                    _react2.default.createElement('img', { className: 'cover-thumb', style: {
                        width: customFeature.topSectionStyle.coverHeight,
                        height: customFeature.topSectionStyle.coverHeight
                      }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png',
                      onClick: this.userCenterTurnToPage, 'data-router': 'userCenter', alt: '' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'personal-main-right' },
                      _react2.default.createElement(
                        'div',
                        { className: 'nickname', style: {
                            color: customFeature.topSectionStyle.color,
                            fontSize: customFeature.topSectionStyle['font-size'],
                            fontStyle: customFeature.topSectionStyle['font-style'],
                            textDecoration: customFeature.topSectionStyle['text-decoration'],
                            fontWeight: customFeature.topSectionStyle['font-weight']
                          } },
                        userInfo.nickname || '用户名'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'user-type', style: {
                            color: customFeature.topSectionStyle['vip-color'],
                            fontSize: customFeature.topSectionStyle['vip-font-size'],
                            fontStyle: customFeature.topSectionStyle['vip-font-style'],
                            textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['vip-font-weigh']
                          } },
                        '\u666E\u901A\u7528\u6237'
                      )
                    )
                  ),
                  userData.buyVip == true && userData.need_collect_info == 0 && _react2.default.createElement(
                    'div',
                    { className: 'buy-vip-hot buy-vip-margin',
                      onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip', 'data-id': '\'\'' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buy-vip', style: {
                          color: customFeature.topSectionStyle['button-color'],
                          fontSize: customFeature.topSectionStyle['button-font-size'],
                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                          background: customFeature['button-background']
                        } },
                      '\u8D2D\u4E70\u4F1A\u5458'
                    )
                  ),
                  userData.need_collect_info == 1 && _react2.default.createElement(
                    'div',
                    { className: 'buy-vip-hot get-vip', onClick: this.vipCardTurnToPage, 'data-type': 'get-vip', 'data-id': userData.user_vip_card && userData.user_vip_card.vip_id },
                    _react2.default.createElement(
                      'div',
                      { className: 'buy-vip', style: {
                          color: customFeature.topSectionStyle['button-color'],
                          fontSize: customFeature.topSectionStyle['button-font-size'],
                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                          background: customFeature['button-background']
                        } },
                      userData.reminder_config.button
                    )
                  ),
                  userData.need_collect_info == 1 && _react2.default.createElement(
                    'div',
                    { className: 'vip-bottom-font', onClick: this.vipCardTurnToPage, 'data-type': 'get-vip' },
                    _react2.default.createElement(
                      'span',
                      { style: {
                          color: customFeature.topSectionStyle['other-color'],
                          fontSize: customFeature.topSectionStyle['other-font-size'],
                          fontStyle: customFeature.topSectionStyle['other-font-style'],
                          textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['other-font-weight']
                        } },
                      userData.reminder_config.description
                    )
                  )
                ), !!(userData.user_paid_vip_card && userData.need_collect_info != 1) && _react2.default.createElement(
                  'div',
                  { className: 'personal-mode-3 show-view',
                    style: {
                      textAlign: 'center',
                      height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: customFeature.topSectionStyle['background-color'],
                      backgroundImage: customFeature.topSectionStyle['background-image'],
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%'
                    },
                    onClick: this.vipCardTurnToPage,
                    'data-type': 'renewal-vip',
                    'data-id': userData.user_paid_vip_card.vip_id
                  },
                  (!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card || !userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1 || userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1) && _react2.default.createElement('img', { className: 'user-center-mark', src: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'personal-main' },
                    _react2.default.createElement('img', { className: 'cover-thumb', style: {
                        width: customFeature.topSectionStyle.coverHeight,
                        height: customFeature.topSectionStyle.coverHeight,
                        zIndex: 2
                      }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png',
                      onClick: this.userCenterTurnToPage, 'data-router': 'userCenter', alt: '' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'personal-main-right' },
                      _react2.default.createElement(
                        'div',
                        { className: 'nickname', style: {
                            color: customFeature.topSectionStyle.color,
                            fontSize: customFeature.topSectionStyle['font-size'],
                            fontStyle: customFeature.topSectionStyle['font-style'],
                            textDecoration: customFeature.topSectionStyle['text-decoration'],
                            fontWeight: customFeature.topSectionStyle['font-weight']
                          } },
                        userInfo.nickname || '用户名'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'user-type pay-user-type', style: {
                            color: customFeature.topSectionStyle['vip-color'],
                            fontSize: customFeature.topSectionStyle['vip-font-size'],
                            fontStyle: customFeature.topSectionStyle['vip-font-style'],
                            textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['vip-font-weigh']
                          } },
                        userData.user_paid_vip_card.title
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-qr-code qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': userData.user_paid_vip_card, 'data-type': '1', 'data-isshow': 'true' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'buy-vip-hot' },
                    userData.user_paid_vip_card.enable_status == 1 && _react2.default.createElement(
                      'div',
                      { className: 'buy-vip renewal-vip', onClick: this.vipCardTurnToPage, 'data-type': 'renewal-vip', 'data-id': userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id,
                        style: {
                          color: customFeature.topSectionStyle['button-color'],
                          fontSize: customFeature.topSectionStyle['button-font-size'],
                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                          background: customFeature['button-background']
                        } },
                      '\u7ACB\u5373\u7EED\u8D39'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'vip-bottom-date',
                        style: {
                          color: customFeature.topSectionStyle['other-color'],
                          fontSize: customFeature.topSectionStyle['other-font-size'],
                          fontStyle: customFeature.topSectionStyle['other-font-style'],
                          textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['other-font-weight']
                        } },
                      userData.user_paid_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                        'div',
                        { className: 'vip-id' },
                        'N0.',
                        userData.user_paid_vip_card.id
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'vip-expired-time' },
                        userData.user_paid_vip_card.expired_time != '永久' ? _react2.default.createElement(
                          'span',
                          null,
                          userData.user_paid_vip_card.expired_time,
                          '\u5230\u671F'
                        ) : _react2.default.createElement(
                          'span',
                          null,
                          userData.user_paid_vip_card.expired_time,
                          '\u6709\u6548'
                        )
                      )
                    )
                  )
                ), !!(userData.user_vip_card && userData.need_collect_info != 1) && _react2.default.createElement(
                  'div',
                  { className: 'personal-mode-3 show-view',
                    style: {
                      textAlign: 'center',
                      height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                      backgroundColor: userData.user_vip_card.background_type == 1 ? userData.user_vip_card.background : '',
                      backgroundImage: userData.user_vip_card.background_type == 0 ? 'url(' + userData.user_vip_card.background + ')' : '',
                      opacity: customFeature.topSectionStyle['opacity'] || 1,
                      backgroundSize: '100% 100%'
                    },
                    onClick: this.vipCardTurnToPage, 'data-type': 'ordinary-vip', 'data-id': userData.user_vip_card.vip_id },
                  (!data.customFeature.topSectionStyle['background-image'] && !userData.user_paid_vip_card && !userData.user_vip_card || !userData.user_paid_vip_card && userData.user_vip_card && userData.user_vip_card.background_type == 1 || userData.user_paid_vip_card && userData.user_paid_vip_card.background_type == 1) && _react2.default.createElement('img', { className: 'user-center-mark', src: 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/userCenterHead.png' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'personal-main' },
                    _react2.default.createElement('img', { className: 'cover-thumb', style: {
                        width: customFeature.topSectionStyle.coverHeight,
                        height: customFeature.topSectionStyle.coverHeight,
                        zIndex: 2
                      },
                      src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'personal-main-right' },
                      _react2.default.createElement(
                        'div',
                        { className: 'nickname', style: {
                            color: customFeature.topSectionStyle.color,
                            fontSize: customFeature.topSectionStyle['font-size'],
                            fontStyle: customFeature.topSectionStyle['font-style'],
                            textDecoration: customFeature.topSectionStyle['text-decoration'],
                            fontWeight: customFeature.topSectionStyle['font-weight']
                          } },
                        userInfo.nickname || '用户名'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'user-type', style: {
                            color: customFeature.topSectionStyle['vip-color'],
                            fontSize: customFeature.topSectionStyle['vip-font-size'],
                            fontStyle: customFeature.topSectionStyle['vip-font-style'],
                            textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['vip-font-weigh']
                          } },
                        userData.user_vip_card.title
                      )
                    )
                  ),
                  _react2.default.createElement('div', { className: 'ico-moon icon-qr-code qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': userData.user_vip_card.id, 'data-type': '0', 'data-isshow': 'true' }),
                  userData.buyVip == true && _react2.default.createElement(
                    'div',
                    { className: 'buy-vip-hot', onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip', 'data-id': '\'\'' },
                    _react2.default.createElement(
                      'div',
                      { className: 'buy-vip buy-vip-margin-2',
                        style: {
                          color: customFeature.topSectionStyle['button-color'],
                          fontSize: customFeature.topSectionStyle['button-font-size'],
                          fontStyle: customFeature.topSectionStyle['button-font-style'],
                          textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                          fontWeight: customFeature.topSectionStyle['button-font-weight'],
                          background: customFeature['button-background']
                        } },
                      '\u8D2D\u4E70\u4F1A\u5458'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'vip-bottom-date',
                      style: {
                        color: customFeature.topSectionStyle['other-color'],
                        fontSize: customFeature.topSectionStyle['other-font-size'],
                        fontStyle: customFeature.topSectionStyle['other-font-style'],
                        textDecoration: customFeature.topSectionStyle['other-text-decoration'],
                        fontWeight: customFeature.topSectionStyle['other-font-weight']
                      } },
                    userData.user_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                      'div',
                      { className: 'vip-id' },
                      'N0.',
                      userData.user_vip_card.id
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'vip-expired-time' },
                      userData.user_vip_card.expired_time != '永久' ? _react2.default.createElement(
                        'span',
                        null,
                        userData.user_vip_card.expired_time,
                        '\u5230\u671F'
                      ) : _react2.default.createElement(
                        'span',
                        null,
                        userData.user_vip_card.expired_time,
                        '\u6709\u6548'
                      )
                    )
                  )
                )].filter(Boolean).map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index },
                    item
                  );
                })
              )
            )
          ),
          customFeature['senior-mode'] == 2 && _react2.default.createElement(
            'div',
            { className: 'senior-mode', style: {
                textAlign: 'center',
                height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                backgroundColor: customFeature.topSectionStyle['background-color'],
                backgroundImage: customFeature.topSectionStyle['background-image'],
                opacity: customFeature.topSectionStyle['opacity'] || 1,
                backgroundSize: '100% 100%'
              } },
            _react2.default.createElement(
              'div',
              { className: 'senior-mode-user', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter' },
              _react2.default.createElement('img', { className: 'cover-thumb', style: {
                  width: customFeature.topSectionStyle.coverHeight,
                  height: customFeature.topSectionStyle.coverHeight
                }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' }),
              _react2.default.createElement(
                'label',
                { className: 'nickname', style: {
                    color: customFeature.topSectionStyle.color,
                    fontSize: customFeature.topSectionStyle['font-size'],
                    fontStyle: customFeature.topSectionStyle['font-style'],
                    textDecoration: customFeature.topSectionStyle['text-decoration'],
                    fontWeight: customFeature.topSectionStyle['font-weight'],
                    marginLeft: '.20rem'
                  } },
                userInfo.nickname || '用户名'
              ),
              _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'member-card-box', onClick: this.vipCardTurnToPage, 'data-type': 'average-user', 'data-needcollectinfo': userData.need_collect_info, 'data-isturnto': userData.all_vip_card.length > 0 || userData.is_vip_benefit_day == 1 ? 'true' : 'false' },
              _react2.default.createElement(
                'div',
                { style: {
                    height: data.customFeature.showInfo ? '2.36rem' : '.86rem',
                    transition: 'all linear 0.25s',
                    overflow: 'hidden'
                  } },
                _react2.default.createElement(
                  _carousel2.default,
                  {
                    dots: userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info != 1 ? true : false,
                    dotStyle: {
                      background: '#B2B2B2'
                    },
                    dotActiveStyle: {
                      background: '#E5E5E5'
                    }
                  },
                  [
                  // 无卡用户
                  !!(!userData.user_vip_card && !userData.user_paid_vip_card || userData.need_collect_info == 1) && _react2.default.createElement(
                    'div',
                    { className: 'senior-mode-card' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-head none-card' },
                      _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_close.png', mode: 'aspectFill', className: 'card-head-ico' }),
                      userData.need_collect_info == 0 && _react2.default.createElement(
                        'span',
                        null,
                        '\u6682\u65E0\u4F1A\u5458\u5361'
                      ),
                      userData.need_collect_info == 1 && _react2.default.createElement(
                        'span',
                        { onClick: this.vipCardTurnToPage, 'data-type': 'get-vip' },
                        userData.reminder_config.description
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head-btn' },
                        userData.buyVip && userData.need_collect_info == 0 && _react2.default.createElement(
                          'div',
                          { onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip', 'data-id': '\'\'' },
                          '\u8D2D\u4E70\u4F1A\u5458'
                        ),
                        userData.need_collect_info == 1 && _react2.default.createElement(
                          'div',
                          { onClick: vipCardTurnToPage, 'data-type': 'get-vip', 'data-id': userData.user_vip_card && userData.user_vip_card.vip_id },
                          userData.reminder_config.button
                        )
                      )
                    )
                  ),
                  // 付费卡
                  !!(userData.user_paid_vip_card && userData.need_collect_info != 1) && _react2.default.createElement(
                    'div',
                    { className: 'senior-mode-card' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-head' },
                      _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png', mode: 'aspectFill', className: 'card-head-ico' }),
                      _react2.default.createElement(
                        'span',
                        { className: 'card-head-title', style: { color: '#4a3d34' } },
                        userData.user_paid_vip_card.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head-btn', onClick: this.showVipCardInfo, 'data-compindex': this.props.index, 'data-show': data.customFeature.showInfo },
                        !data.customFeature.showInfo ? _react2.default.createElement(
                          'span',
                          null,
                          '\u5C55\u5F00'
                        ) : _react2.default.createElement(
                          'span',
                          null,
                          '\u6536\u8D77'
                        ),
                        _react2.default.createElement('label', { className: 'ico-moon icon-' + (data.customFeature.showInfo ? 'up' : 'down') + 'arrow' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'card-main' },
                      userData.user_paid_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                        'span',
                        { className: 'card-number' },
                        'N0.',
                        userData.user_paid_vip_card.id
                      ),
                      userData.user_paid_vip_card.enable_status == 1 && _react2.default.createElement(
                        'div',
                        { className: 'card-buyVip',
                          onClick: this.vipCardTurnToPage, 'data-type': 'renewal-vip',
                          'data-id': userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id,
                          style: {
                            color: customFeature.topSectionStyle['button-color'],
                            fontSize: customFeature.topSectionStyle['button-font-size'],
                            fontStyle: customFeature.topSectionStyle['button-font-style'],
                            textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['button-font-weight'],
                            background: customFeature['button-background']
                          }
                        },
                        '\u7ACB\u5373\u7EED\u8D39'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-qrcode' },
                        userData.user_paid_vip_card.expired_time != '永久' ? _react2.default.createElement(
                          'span',
                          null,
                          userData.user_paid_vip_card.expired_time,
                          '\u5230\u671F'
                        ) : _react2.default.createElement(
                          'span',
                          null,
                          userData.user_paid_vip_card.expired_time,
                          '\u6709\u6548'
                        ),
                        _react2.default.createElement('span', { className: 'ico-moon icon-qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': userData.user_paid_vip_card.id, 'data-type': '1', 'data-isshow': 'true' })
                      )
                    )
                  ),
                  // 免费卡
                  !!(userData.user_vip_card && userData.need_collect_info != 1) && _react2.default.createElement(
                    'div',
                    { className: 'senior-mode-card' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-head' },
                      _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png', mode: 'aspectFill', className: 'card-head-ico' }),
                      _react2.default.createElement(
                        'span',
                        { className: 'card-head-title', style: { color: '#4a3d34' } },
                        userData.user_vip_card.title
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head-btn', onClick: this.showVipCardInfo, 'data-compindex': this.props.index, 'data-show': data.customFeature.showInfo },
                        !data.customFeature.showInfo ? _react2.default.createElement(
                          'span',
                          null,
                          '\u5C55\u5F00'
                        ) : _react2.default.createElement(
                          'span',
                          null,
                          '\u6536\u8D77'
                        ),
                        _react2.default.createElement('label', { className: 'ico-moon icon-' + (data.customFeature.showInfo ? 'up' : 'down') + 'arrow' })
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'card-main' },
                      userData.user_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                        'span',
                        { className: 'card-number' },
                        'N0.',
                        userData.user_vip_card.id
                      ),
                      userData.buyVip == true && _react2.default.createElement(
                        'div',
                        { className: 'card-buyVip',
                          onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip',
                          style: {
                            color: customFeature.topSectionStyle['button-color'],
                            fontSize: customFeature.topSectionStyle['button-font-size'],
                            fontStyle: customFeature.topSectionStyle['button-font-style'],
                            textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                            fontWeight: customFeature.topSectionStyle['button-font-weight'],
                            background: customFeature['button-background']
                          }
                        },
                        '\u7ACB\u5373\u8D2D\u4E70'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-qrcode' },
                        userData.user_vip_card.expired_time != '永久' ? _react2.default.createElement(
                          'span',
                          null,
                          userData.user_vip_card.expired_time,
                          '\u5230\u671F'
                        ) : _react2.default.createElement(
                          'span',
                          null,
                          userData.user_vip_card.expired_time,
                          '\u6709\u6548'
                        ),
                        _react2.default.createElement('span', { className: 'ico-moon icon-qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': data.userData.user_vip_card.id, 'data-type': '0', 'data-isshow': 'true' })
                      )
                    )
                  )].filter(Boolean).map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      { key: index },
                      item
                    );
                  })
                )
              )
            )
          ),
          customFeature['senior-mode'] == 3 && _react2.default.createElement(
            'div',
            { style: { backgroundColor: '#fff' } },
            _react2.default.createElement(
              'div',
              { className: 'senior-mode ' + (customFeature.showInfo ? '' : 'bottom-radius') + ' senior-mode-3', style: {
                  textAlign: 'center',
                  height: (0, _tools.transformPx2Rem)(customFeature.topSectionStyle.topHeight, 320),
                  backgroundColor: customFeature.topSectionStyle['background-color'],
                  backgroundImage: customFeature.topSectionStyle['background-image'],
                  opacity: customFeature.topSectionStyle['opacity'] || 1,
                  backgroundSize: '100% 100%'
                } },
              _react2.default.createElement(
                'div',
                { className: 'senior-mode-user', onClick: this.userCenterTurnToPage, 'data-router': 'userCenter' },
                _react2.default.createElement('img', { className: 'cover-thumb', style: {
                    width: customFeature.topSectionStyle.coverHeight,
                    height: customFeature.topSectionStyle.coverHeight
                  }, src: userInfo.cover_thumb || 'http://img.zhichiwangluo.com/zc_app_default_photo.png', alt: '' }),
                _react2.default.createElement(
                  'div',
                  { style: {
                      textAlign: 'left'
                    } },
                  _react2.default.createElement(
                    'label',
                    { className: 'nickname', style: {
                        color: customFeature.topSectionStyle.color,
                        fontSize: customFeature.topSectionStyle['font-size'],
                        fontStyle: customFeature.topSectionStyle['font-style'],
                        textDecoration: customFeature.topSectionStyle['text-decoration'],
                        fontWeight: customFeature.topSectionStyle['font-weight'],
                        marginLeft: '.20rem'
                      } },
                    userInfo.nickname || '用户名'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'default-user', style: {
                        color: customFeature.topSectionStyle['vip-color'],
                        fontSize: customFeature.topSectionStyle['vip-font-size'],
                        fontStyle: customFeature.topSectionStyle['vip-font-style'],
                        textDecoration: customFeature.topSectionStyle['vip-text-decoration'],
                        fontWeight: customFeature.topSectionStyle['vip-font-weight']
                      } },
                    userData.user_paid_vip_card ? '恭喜您，您已经是我们的付费会员' : userData.user_vip_card ? '恭喜您，您已经是我们的普通会员' : '普通用户'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'member-card-box',
                  onClick: this.vipCardTurnToPage,
                  'data-type': 'average-user',
                  'data-needcollectinfo': userData.need_collect_info,
                  'data-isturnto': userData.all_vip_card.length > 0 || userData.is_vip_benefit_day == 1 ? 'true' : 'false'
                },
                _react2.default.createElement(
                  'div',
                  { className: '' + (data.customFeature.showInfo ? "" : "senior-mode-radius") },
                  _react2.default.createElement(
                    _carousel2.default,
                    {
                      dots: userData.user_vip_card && userData.user_paid_vip_card && userData.need_collect_info != 1 ? true : false,
                      style: {
                        height: data.customFeature.showInfo ? '2.36rem' : '.86rem',
                        transition: 'all linear 0.25s'
                      },
                      dotStyle: {
                        background: '#B2B2B2'
                      },
                      dotActiveStyle: {
                        background: '#E5E5E5'
                      }
                    },
                    [
                    // 无卡用户
                    !!(!data.userData.user_vip_card && !data.userData.user_paid_vip_card || data.userData.need_collect_info == 1) && _react2.default.createElement(
                      'div',
                      { className: 'senior-mode-card senior-mode-card2' },
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head none-card' },
                        _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_close.png', mode: 'aspectFill', className: 'card-head-ico' }),
                        userData.need_collect_info == 0 && _react2.default.createElement(
                          'span',
                          null,
                          '\u6682\u65E0\u4F1A\u5458\u5361'
                        ),
                        userData.need_collect_info == 1 && _react2.default.createElement(
                          'span',
                          { onClick: this.vipCardTurnToPage, 'data-type': 'get-vip' },
                          userData.reminder_config.description
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'card-head-btn' },
                          userData.buyVip && userData.need_collect_info == 0 && _react2.default.createElement(
                            'div',
                            { onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip', 'data-id': '\'\'' },
                            '\u8D2D\u4E70\u4F1A\u5458'
                          ),
                          userData.need_collect_info == 1 && _react2.default.createElement(
                            'div',
                            { onClick: this.vipCardTurnToPage, 'data-type': 'get-vip', 'data-id': data.userData.user_vip_card && data.userData.user_vip_card.vip_id },
                            data.userData.reminder_config.button
                          )
                        )
                      )
                    ),
                    // 付费卡
                    !!(data.userData.user_paid_vip_card && data.userData.need_collect_info != 1) && _react2.default.createElement(
                      'div',
                      { className: 'senior-mode-card  senior-mode-card2' },
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head' },
                        _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png', mode: 'aspectFill', className: 'card-head-ico' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'card-head-title', style: 'color:#DAAF87' },
                          data.userData.user_paid_vip_card.title
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'card-head-btn', onClick: this.showVipCardInfo, 'data-compindex': this.props.index, 'data-show': data.customFeature.showInfo },
                          !data.customFeature.showInfo ? _react2.default.createElement(
                            'span',
                            null,
                            '\u5C55\u5F00'
                          ) : _react2.default.createElement(
                            'span',
                            null,
                            '\u6536\u8D77'
                          ),
                          _react2.default.createElement('label', { className: 'ico-moon icon-' + (data.customFeature.showInfo ? 'up' : 'down') + 'arrow' })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-main' },
                        userData.user_paid_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                          'span',
                          { className: 'card-number' },
                          'N0.',
                          userData.user_paid_vip_card.id
                        ),
                        userData.user_paid_vip_card.enable_status == 1 && _react2.default.createElement(
                          'div',
                          { className: 'card-buyVip',
                            onClick: this.vipCardTurnToPage, 'data-type': 'renewal-vip',
                            'data-id': userData.user_paid_vip_card && userData.user_paid_vip_card.vip_id,
                            style: {
                              color: customFeature.topSectionStyle['button-color'],
                              fontSize: customFeature.topSectionStyle['button-font-size'],
                              fontStyle: customFeature.topSectionStyle['button-font-style'],
                              textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                              fontWeight: customFeature.topSectionStyle['button-font-weight'],
                              background: customFeature['button-background']
                            }
                          },
                          '\u7ACB\u5373\u7EED\u8D39'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'card-qrcode' },
                          userData.user_paid_vip_card.expired_time != '永久' ? _react2.default.createElement(
                            'span',
                            null,
                            userData.user_paid_vip_card.expired_time,
                            '\u5230\u671F'
                          ) : _react2.default.createElement(
                            'span',
                            null,
                            userData.user_paid_vip_card.expired_time,
                            '\u6709\u6548'
                          ),
                          _react2.default.createElement('span', { className: 'ico-moon icon-qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': userData.user_paid_vip_card.id, 'data-type': '1', 'data-isshow': 'true' })
                        )
                      )
                    ),
                    // 免费卡
                    !!(data.userData.user_vip_card && data.userData.need_collect_info != 1) && _react2.default.createElement(
                      'div',
                      { className: 'senior-mode-card senior-mode-card2' },
                      _react2.default.createElement(
                        'div',
                        { className: 'card-head' },
                        _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/user-center/vip_level.png', mode: 'aspectFill', className: 'card-head-ico' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'card-head-title', style: { color: '#DAAF87' } },
                          data.userData.user_vip_card.title
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'card-head-btn', onClick: this.showVipCardInfo, 'data-compindex': this.props.index, 'data-show': data.customFeature.showInfo },
                          !data.customFeature.showInfo ? _react2.default.createElement(
                            'span',
                            null,
                            '\u5C55\u5F00'
                          ) : _react2.default.createElement(
                            'span',
                            null,
                            '\u6536\u8D77'
                          ),
                          _react2.default.createElement('label', { className: 'ico-moon icon-' + (data.customFeature.showInfo ? 'up' : 'down') + 'arrow' })
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'card-main' },
                        userData.user_vip_card.is_show_vipid == 1 && _react2.default.createElement(
                          'span',
                          { className: 'card-number' },
                          'N0.',
                          userData.user_vip_card.id
                        ),
                        userData.buyVip == true && _react2.default.createElement(
                          'div',
                          { className: 'card-buyVip',
                            onClick: this.vipCardTurnToPage, 'data-type': 'buy-vip',
                            style: {
                              color: customFeature.topSectionStyle['button-color'],
                              fontSize: customFeature.topSectionStyle['button-font-size'],
                              fontStyle: customFeature.topSectionStyle['button-font-style'],
                              textDecoration: customFeature.topSectionStyle['button-text-decoration'],
                              fontWeight: customFeature.topSectionStyle['button-font-weight'],
                              background: customFeature['button-background']
                            }
                          },
                          '\u7ACB\u5373\u8D2D\u4E70'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'card-qrcode' },
                          userData.user_vip_card.expired_time != '永久' ? _react2.default.createElement(
                            'span',
                            null,
                            userData.user_vip_card.expired_time,
                            '\u5230\u671F'
                          ) : _react2.default.createElement(
                            'span',
                            null,
                            userData.user_vip_card.expired_time,
                            '\u6709\u6548'
                          ),
                          _react2.default.createElement('span', { className: 'ico-moon icon-qr-code', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-id': data.userData.user_vip_card.id, 'data-type': '0', 'data-isshow': 'true' })
                        )
                      )
                    )].filter(Boolean).map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { key: index },
                        item
                      );
                    })
                  )
                )
              )
            )
          )
        ),
        customFeature.isHiddenComponent && customFeature['member'] == 2 && customFeature['senior-mode'] != 1 && _react2.default.createElement('div', { style: {
            height: '.8rem',
            background: '#fff'
          } }),
        userData && !customFeature.isHiddenComponent && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('div', { style: {
              height: (0, _tools.transformPx2Rem)(customFeature['margin-top'], 320),
              background: '#fff'
            } }),
          _react2.default.createElement(
            'div',
            {
              className: 'user-data-show',
              style: {
                height: (0, _tools.transformPx2Rem)(customFeature.height, 320)
              } },
            customFeature.showDataBlock && customFeature.showDataBlock[0].blockArr.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                {
                  key: index,
                  className: 'user-data-show-item',
                  style: {
                    width: 'calc(100% / ' + customFeature.colums + ')'
                  },
                  onClick: _this2[item.bindtap],
                  'data-router': item.router
                },
                _react2.default.createElement(
                  'div',
                  { style: {
                      width: '100%'
                    } },
                  _react2.default.createElement(
                    'div',
                    { style: {
                        color: '#686868',
                        fontSize: '.36rem',
                        fontWeight: 'bold'
                      } },
                    userData[item.feild],
                    userData.cross_add_coupon_mark > 0 && item.feild == 'coupon_count' && _react2.default.createElement('span', { className: 'coupon-prompt' }),
                    item.feild == 'coupon_count' && _react2.default.createElement(
                      'span',
                      null,
                      '\u5F20'
                    ),
                    item.feild == 'balance' && _react2.default.createElement(
                      'span',
                      null,
                      '\u5143'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: {
                        color: '#999999',
                        fontSize: '.24rem'
                      } },
                    item.name
                  )
                ),
                index != customFeature.showDataBlock[0].blockArr.length - 1 && _react2.default.createElement(
                  'div',
                  { className: 'user-data-divline' },
                  _react2.default.createElement('div', { className: 'divline-content' })
                )
              );
            })
          )
        ),
        userData && customFeature.isShowIntegral && !!userData.xcx_differential_entry && _react2.default.createElement(
          'div',
          { className: 'integral-platform', onClick: this.vipCardTurnToPage, 'data-type': 'differential-mall' },
          _react2.default.createElement('div', { className: 'ico-moon icon-differential-tag icon-container-cover icon-differentail-color' }),
          _react2.default.createElement(
            'span',
            { className: 'integral-platform-title' },
            '\u5FAE\u5206\u5546\u57CE'
          ),
          _react2.default.createElement(
            'span',
            { className: 'integral-platform-content' },
            '\u6D77\u91CF\u5546\u5BB6\u4F18\u60E0\u5238\u7B49\u4F60\u53BB\u9886\uFF01'
          ),
          _react2.default.createElement(
            'div',
            { className: 'integral-platform-right' },
            userData.cross_add_differential_mark > 0 && _react2.default.createElement('span', { className: 'integral-platform-prompt' }),
            _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow icon-container-cover' })
          )
        ),
        userData && data.qrData && userData.qrRemarkShow && _react2.default.createElement(
          'div',
          { className: 'qr-remark', onClick: this.showQRRemark, 'data-compindex': this.props.index, 'data-isshow': 'false' },
          _react2.default.createElement(
            'div',
            { className: 'paid-vip-info', onClick: this.showQRRemark },
            _react2.default.createElement(
              'div',
              { className: 'paid-vip-title' },
              _react2.default.createElement(
                'span',
                null,
                data.qrData.user_info
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'paid-vip-content' },
              _react2.default.createElement('img', { src: data.qrData.pic_url, className: 'paid-vip-card-qr' }),
              _react2.default.createElement(
                'div',
                { className: 'paid-vip-card-id' },
                data.qrData.id
              )
            )
          )
        )
      );
    }
  }]);
  return UserCenterHeadCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  this.init = function (compindex, pageInstance) {
    var url = '/index.php?r=appVipCard/getUserAccountSurvey';
    _app.appMethod.sendRequest({
      url: url,
      success: function success(res) {
        var userData = {};
        res.data.buyVip = false;
        res.data.balance = parseInt(res.data.balance);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = res.data.all_vip_card[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (item.condition_type == 2) {
              res.data.buyVip = true; //是否显示购买会员按钮
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        userData['eles[' + compindex + '].userData'] = res.data;
        pageInstance.setData(userData);
      }
    });
  };

  this.showVipCardInfo = function (e) {
    var data = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var show = e.currentTarget.dataset.show == 'true'; // 跟小程序略有不同
    var compData = pageInstance.state.eles[compindex];
    var height = parseInt(compData['customFeature']['topSectionStyle']['topHeight']);
    if (!show) {
      data['eles[' + compindex + '].customFeature.topSectionStyle.topHeight'] = ((height >= 270 ? height : 270) + 150) / 100 + 'rem';
    } else {
      data['eles[' + compindex + '].customFeature.topSectionStyle.topHeight'] = (height * 100 - 150) / 100 + 'rem';
    }
    data['eles[' + compindex + '].customFeature.showInfo'] = !show;
    pageInstance.setData(data);
    e.stopPropagation(); // 阻止冒泡
  };

  this.userCenterTurnToPage = function (e) {
    _app.appMethod.userCenterTurnToPage(e);
    e.stopPropagation(); // 阻止冒泡
  };

  this.vipCardTurnToPage = function (e) {
    e.stopPropagation();
    var _e$currentTarget$data = e.currentTarget.dataset,
        type = _e$currentTarget$data.type,
        id = _e$currentTarget$data.id,
        isturnto = _e$currentTarget$data.isturnto,
        needcollectinfo = _e$currentTarget$data.needcollectinfo;

    var chainParam = '';
    if (type == 'get-vip') {
      _app.appMethod.turnToPage('userCenter', {
        is_member: 1,
        franchisee: _app.globalData.chainAppId || ''
      });
    } else if (type == 'buy-vip') {
      _app.appMethod.turnToPage('vipBenefits', {
        is_paid_card: 1
      });
    } else if (type == 'renewal-vip') {
      _app.appMethod.turnToPage('vipBenefits', {
        is_paid_card: 1,
        id: id
      });
    } else if (type == 'ordinary-vip') {
      _app.appMethod.turnToPage('vipBenefits', {
        id: id
      });
    } else if (type == 'average-user') {
      if (isturnto == 'true') {
        if (needcollectinfo == 1) {
          _app.appMethod.turnToPage('userCenter' + chainParam, {
            is_member: 1,
            franchisee: _app.globalData.chainAppId || ''
          });
        } else {
          _app.appMethod.turnToPage('vipBenefits');
        }
      }
    } else if (type == 'differential-mall') {
      _app.appMethod.turnToPage('/dMWebView');
    }
  };

  this.showQRRemark = function (e) {
    _app.appMethod.showQRRemark(e);
    e.stopPropagation(); // 阻止冒泡
  };
};

exports.default = UserCenterHeadCustomComponent;

/***/ }),
/* 915 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _page = __webpack_require__(43);

var _app = __webpack_require__(4);

__webpack_require__(917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserCenterContentCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(UserCenterContentCustomComponent, _React$Component);

  function UserCenterContentCustomComponent(props) {
    (0, _classCallCheck3.default)(this, UserCenterContentCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserCenterContentCustomComponent.__proto__ || Object.getPrototypeOf(UserCenterContentCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(UserCenterContentCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      /**
       * 传入数据
       */
      var data = this.props.data; // 组件数据
      var userData = data.userData || {}; // 用户数据
      /**
       * 页面上的数据
       */
      var storeStyle = _page.pageInstance.data.storeStyle || {}; // 电商店铺样式数据
      /**
       * 组件配置对象
       */
      var customFeature = data.customFeature;

      return _react2.default.createElement(
        'div',
        { className: 'custom-component user-center-content' },
        data.content.map(function (item, i) {
          return _react2.default.createElement(
            'div',
            { className: 'usercenter-block',
              key: i,
              style: {
                color: item['color'],
                marginTop: item['margin-top'] || '.2rem',
                backgroundColor: item['background-color'] || '#fff',
                backgroundImage: item['background-image'],
                textDecoration: item['text-decoration'],
                fontWeight: item['font-weight'],
                opacity: customFeature.blockStyle['opacity'] || 1,
                borderRadius: item['mode'] == 3 ? '.2rem' : (0, _tools.transformPx2Rem)(item['border-radius'], 320),
                width: 'calc(100% - ' + (item['mode'] == 3 ? '.2rem' : (0, _tools.transformPx2Rem)(item['margin'] * 2)) + ')'
              } },
            item.showName && _react2.default.createElement(
              'div',
              { className: 'block-name', style: {
                  fontSize: item['font-size']
                } },
              item.customTitleImg && item.showAreaIcon && _react2.default.createElement('img', { className: 'block-name-image', src: item.customTitleImg, alt: '' }),
              _react2.default.createElement(
                'span',
                null,
                item.name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'block-detail', style: {
                  color: item['color'] || 'rgb(89, 96, 123)',
                  lineHeight: (0, _tools.transformPx2Rem)(item['line-height'], 320)
                } },
              item.blockArr.map(function (blockItem, j) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: j },
                  (item.mode == 1 || item.mode == 3 || !item.mode) && _react2.default.createElement(
                    'div',
                    { className: 'block-item mode-one',
                      onClick: _this2[blockItem.bindtap],
                      'data-need-collect-info': userData.need_collect_info,
                      'data-router': blockItem.router,
                      'data-open-verify-phone': blockItem.openVerifyPhone || false,
                      'data-event-params': JSON.stringify(blockItem.param),
                      style: {
                        textAlign: 'center',
                        display: 'inline-block',
                        width: 'calc(100% / ' + item.col + ')'
                      }
                    },
                    _react2.default.createElement(
                      'div',
                      { style: {
                          lineHeight: 'normal'
                        } },
                      _react2.default.createElement(
                        'div',
                        { style: {
                            position: 'relative',
                            width: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                            height: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                            margin: '0 auto'
                          } },
                        !blockItem.custom && _react2.default.createElement('div', { className: 'ico-moon ' + blockItem.icon + ' ' + (data.customFeature.iconType == '2' ? '' : (i + 1) % 5 == 1 || (i + 1) % 5 == 4 ? 'color-1-4' : (i + 1) % 5 == 2 || (i + 1) % 5 == 0 ? 'color-2-5' : (i + 1) % 5 == 3 ? 'color-3' : ''), style: {
                            fontSize: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                            fontStyle: 'normal'
                          } }),
                        blockItem.custom && _react2.default.createElement('img', { src: blockItem.custom, style: {
                            width: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                            height: item.imgHeight
                          } }),
                        blockItem.count && _react2.default.createElement(
                          'span',
                          { className: 'orderCount', style: {
                              left: 'calc(' + item.imgHeight + ' - .14rem)',
                              backgroundColor: storeStyle.theme
                            } },
                          blockItem.count
                        ),
                        blockItem.router == 'myMessage' && userData.msgUnreadCount && userData.msgUnreadCount.totalCount != 0 && _react2.default.createElement(
                          'span',
                          { className: 'message-unread-count',
                            style: {
                              left: 'calc(' + item.imgHeight + ' - .14rem)',
                              backgroundColor: storeStyle.theme
                            } },
                          userData.msgUnreadCount.totalCount
                        ),
                        blockItem.action && blockItem.action.inner_page_link === 'myFormMessage' && userData.msgUnreadCount && userData.msgUnreadCount.msgCount['3'].unread_count != 0 && _react2.default.createElement(
                          'span',
                          { className: 'message-unread-count',
                            style: {
                              left: 'calc(' + item.imgHeight + ' - .14rem)',
                              backgroundColor: storeStyle.theme
                            } },
                          userData.msgUnreadCount.msgCount[3].unread_count
                        )
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: {
                            fontSize: (0, _tools.transformPx2Rem)(item['font-size'], 320),
                            textDecoration: item['text-decoration'] || ''
                          } },
                        blockItem.name
                      )
                    )
                  ),
                  item.mode == 2 && _react2.default.createElement(
                    'div',
                    { className: 'mode-two',
                      onClick: _this2[blockItem.bindtap],
                      'data-router': blockItem.router,
                      'data-open-verify-phone': blockItem.openVerifyPhone,
                      'data-event-params': JSON.stringify(blockItem.param),
                      style: {
                        height: item.height,
                        lineHeight: item.height
                      }
                    },
                    _react2.default.createElement(
                      'div',
                      { style: {
                          position: 'relative',
                          width: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          height: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          margin: '0 auto',
                          display: 'inline-block',
                          verticalAlign: 'middle',
                          marginLeft: '.40rem',
                          marginRight: '.20rem'
                        } },
                      !blockItem.custom && _react2.default.createElement('div', { className: 'ico-moon ' + blockItem.icon + ' ' + (data.customFeature.iconType == '2' ? '' : (i + 1) % 5 == 1 || (i + 1) % 5 == 4 ? 'color-1-4' : (i + 1) % 5 == 2 || (i + 1) % 5 == 0 ? 'color-2-5' : (i + 1) % 5 == 3 ? 'color-3' : ''), style: {
                          fontStyle: 'normal',
                          lineHeight: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          fontSize: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          width: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          height: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          verticalSlign: 'top'
                        } }),
                      blockItem.custom && _react2.default.createElement('img', { src: blockItem.custom, style: {
                          width: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          height: (0, _tools.transformPx2Rem)(item.imgHeight, 320),
                          verticalAlign: 'top'
                        } }),
                      blockItem.count && _react2.default.createElement(
                        'span',
                        { className: 'orderCount', style: {
                            left: 'calc(' + item.imgHeight + ' - .14rem)',
                            backgroundColor: storeStyle.theme
                          } },
                        blockItem.count
                      ),
                      blockItem.router == 'myMessage' && userData.msgUnreadCount && userData.msgUnreadCount.totalCount != 0 && _react2.default.createElement(
                        'span',
                        { className: 'message-unread-count',
                          style: {
                            left: 'calc(' + item.imgHeight + ' - .14rem)',
                            backgroundColor: storeStyle.theme
                          } },
                        userData.msgUnreadCount.totalCount
                      ),
                      blockItem.action && blockItem.action.inner_page_link === 'myFormMessage' && userData.msgUnreadCount && userData.msgUnreadCount.msgCount['3'].unread_count != 0 && _react2.default.createElement(
                        'span',
                        { className: 'message-unread-count',
                          style: {
                            left: 'calc(' + item.imgHeight + ' - .14rem)',
                            backgroundColor: storeStyle.theme
                          } },
                        userData.msgUnreadCount.msgCount[3].unread_count
                      )
                    ),
                    _react2.default.createElement(
                      'span',
                      { style: {
                          verticalAlign: 'middle',
                          fontSize: (0, _tools.transformPx2Rem)(item['font-size'], 320)
                        } },
                      blockItem.name
                    )
                  )
                );
              })
            )
          );
        })
      );
    }
  }]);
  return UserCenterContentCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var data = {};
    var content = pageInstance.state.eles[compindex].content;
    // 获取系统通知未读条数
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppNotify/GetNotifyMsgUnreadCount',
      data: {
        'types': '3,5,6,16'
      },
      success: function success(res) {
        var userData = {};
        var msgUnreadCount = {
          totalCount: 0,
          msgCount: res.data
        };
        Object.keys(res.data).forEach(function (key) {
          if (key == 3) {
            msgUnreadCount.totalCount += 0;
          } else {
            msgUnreadCount.totalCount += +res.data[key].unread_count;
          }
        });
        if (msgUnreadCount.totalCount > 99) {
          msgUnreadCount.totalCount = '99+';
        }
        userData['eles[' + compindex + '].userData.msgUnreadCount'] = msgUnreadCount;
        pageInstance.setData(userData);
      }
    });
    var goodsTypeList = [];
    for (var i = 0; i < 24; i++) {
      var sub = {
        requested: false,
        index: []
      };
      goodsTypeList.push(sub);
    };
    for (var _i in content) {
      for (var j in content[_i].blockArr) {
        var item = content[_i].blockArr[j];
        if (item.actionType === 'custom') {
          var action = item.action;
          action.action = item.action.actionType;
          item.bindtap = "tapEventCommonHandler";
          item.param = action;
        } else {
          (function () {
            var goodsTypeReg = new RegExp('(^|&)goodsType=([^&]*)(&|$)');
            var orderIndex = new RegExp('(^|&)currentIndex=([^&]*)(&|$)');
            var goodsType = item.param && item.param.match(goodsTypeReg) ? +item.param.match(goodsTypeReg)[2] : -1;
            var k = item.param && item.param.match(orderIndex) ? +item.param.match(orderIndex)[2] : -1;
            if (goodsType >= 0 && goodsType < 4) {
              goodsTypeList[goodsType].index.push([_i, j, k]);
            }

            if (item.router === 'myOrder' && goodsType != -1 && goodsTypeList[goodsType] && !goodsTypeList[goodsType].requested) {
              goodsTypeList[goodsType].requested = true;
              setTimeout(function () {
                _this3.userCenterOrderCount({
                  goodsType: goodsType
                }, function (data) {
                  var newdata = {};
                  data = [0].concat((0, _toConsumableArray3.default)(data));
                  for (var _i2 in goodsTypeList[goodsType].index) {
                    var index = goodsTypeList[goodsType].index[_i2];
                    newdata['eles[' + compindex + '].content[' + index[0] + ']blockArr[' + index[1] + ']count'] = +data[index[2]] || '';
                  }
                  pageInstance.setData(newdata);
                });
              }, 0);
            }
          })();
        }
      }
    }
    data['eles[' + compindex + '].content'] = content;
    pageInstance.setData(data);
  };

  this.userCenterOrderCount = function (options, callback) {
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/countStatusOrder',
      data: {
        parent_shop_app_id: _app.appMethod.getAppId(),
        goods_type: options.goodsType
      },
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          callback(res.data);
        }
      }
    });
  };

  this.userCenterTurnToPage = function (e) {
    _app.appMethod.userCenterTurnToPage(e);
  };

  this.tapEventCommonHandler = function (e) {
    _app.appMethod.tapEventCommonHandler(e);
  };
};

exports.default = UserCenterContentCustomComponent;

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomTopNavCustomComponent;

var _tools = __webpack_require__(6);

var _customEvent = __webpack_require__(18);

var _app = __webpack_require__(4);

__webpack_require__(919);

function CustomTopNavCustomComponent(props) {
  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var detailData = props.detailData; // 详情页数据
  var dynamicData = props.dynamicData; // 动态数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;

  var isTabBarPage = _app.appMethod.isTabBarPage();

  var currentPageRouter = _app.appMethod.getPageRouter();

  var homepageRouter = _app.appMethod.getHomepageRouter();

  var turnBack = function turnBack() {
    _app.appMethod.turnBack();
  };

  var turnHome = function turnHome() {
    _app.appMethod.turnToPage(homepageRouter, {}, true);
  };
  /**
   * 返回组件
   */
  return React.createElement('div', { className: 'custom-component custom-top-nav' });
}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(921);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type：'presell'
 * 组件：预售组件
 */
var PresellCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(PresellCustomComponent, _React$Component);

  function PresellCustomComponent(props) {
    (0, _classCallCheck3.default)(this, PresellCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PresellCustomComponent.__proto__ || Object.getPrototypeOf(PresellCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  (0, _createClass3.default)(PresellCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;
      var customFeature = data.customFeature,
          goods_data = data.goods_data;

      var styleObj = (0, _tools.convertStyleData)(data.style);
      /**
       * @desc 商品列表样式
       */
      var goodsItemStyleObj = {
        height: (0, _tools.transformPx2Rem)(customFeature.lineHeight, 320),
        marginBottom: (0, _tools.transformPx2Rem)(customFeature.margin, 320),
        background: customFeature.lineBackgroundColor
      };

      var imgWrapStyleObj = {
        width: (0, _tools.transformPx2Rem)(customFeature.imgWidth, 320),
        height: (0, _tools.transformPx2Rem)(customFeature.imgHeight, 320)

        /**
         * @desc mode为1、2、3的时候的列表
         */
      };var ModeWrap = function ModeWrap(props) {
        var className = props.className,
            colRowClassName = props.colRowClassName;

        return _react2.default.createElement(
          'div',
          { className: 'presell-list ' + className },
          !!goods_data && goods_data.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: 'presell-goods-item isRelative',
                key: item.form_data.id,
                style: goodsItemStyleObj,
                'data-goodsid': item.form_data.goods_id,
                'data-activityid': item.form_data.activity_id,
                'data-status': item.status,
                'data-presellstatus': item.status,
                onClick: item.status != 4 ? _this2.gotoPresellDetail : _this2.showOverTips },
              _react2.default.createElement(
                'div',
                { className: 'presell-image-wrap', style: imgWrapStyleObj },
                _react2.default.createElement('img', { src: item.form_data.cover }),
                customFeature.isShowCountdown && item.status != 4 && _react2.default.createElement(
                  'div',
                  { className: 'count-down ' + (item.status == 0 ? 'presell-not-begun' : 'pay-presell') },
                  item.status == 0 ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    '\u8DDD\u5F00\u59CB',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.days,
                      '\u5929'
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.hours
                    ),
                    ' :',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.minutes
                    ),
                    ' :',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.seconds
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    '\u8DDD\u7ED3\u675F',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.days,
                      '\u5929'
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.hours
                    ),
                    ' :',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.minutes
                    ),
                    ' :',
                    _react2.default.createElement(
                      'span',
                      null,
                      item.downCount.seconds
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'presell-content-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'presell-title' },
                  customFeature.isShowPresaleStatus && _react2.default.createElement(
                    'div',
                    { className: 'presell-logo ' + (item.status == 0 ? 'presell-not-begun' : 'pay-presell') },
                    '\u9884\u552E'
                  ),
                  item.form_data.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'presell-detail-msg ' + colRowClassName },
                  customFeature.isShowSales && customFeature.isShowVirtualPrice ? _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    (customFeature.mode == 1 || customFeature.mode == 2) && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-first-line' },
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-price' },
                          _react2.default.createElement(
                            'label',
                            { className: 'presell-price', style: { color: item.status == 0 ? '#8262E8' : '#FF4D4F' } },
                            '\xA5',
                            _react2.default.createElement(
                              'span',
                              { className: 'presell-price-int' },
                              item.form_data._presell_goods.presell_current_price
                            )
                          ),
                          customFeature.isShowVirtualPrice && _react2.default.createElement(
                            'span',
                            { className: 'presell-origin-price' },
                            '\xA5',
                            item.form_data.price
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-second-line' },
                        item.status != 0 ? _react2.default.createElement(
                          'div',
                          { className: 'presell-view-count' },
                          '\u5DF2\u552E',
                          item.form_data._presell_goods.bargain_payment_count,
                          '\u4EF6'
                        ) : _react2.default.createElement(
                          'div',
                          { className: 'presell-view-count' },
                          item.form_data._presell_goods.presell_goods_view_count,
                          '\u4EBA\u6D4F\u89C8'
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-status-btn' },
                          item.status == 0 && _react2.default.createElement(
                            'label',
                            { className: 'presell-not-begun' },
                            '\u672A\u5F00\u552E'
                          ),
                          item.status == 3 && _react2.default.createElement(
                            'label',
                            { className: 'pay-presell',
                              'data-paramstr': item.param_str,
                              'data-goodsid': item.form_data.goods_id,
                              'data-model': item.model_length,
                              onClick: function onClick(e) {
                                _this2.payPresell(e), e.stopPropagation();
                              } },
                            '\u4ED8\u5B9A\u91D1'
                          ),
                          item.status != 0 && item.status != 3 && _react2.default.createElement(
                            'label',
                            { className: 'over-presell' },
                            '\u5DF2\u7ED3\u675F'
                          )
                        )
                      )
                    ),
                    customFeature.mode == 3 && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-left-line' },
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-price' },
                          _react2.default.createElement(
                            'label',
                            { className: 'presell-price', style: { color: item.status == 0 ? '#8262E8' : '#FF4D4F' } },
                            '\xA5',
                            _react2.default.createElement(
                              'span',
                              { className: 'presell-price-int' },
                              item.form_data._presell_goods.presell_current_price
                            )
                          ),
                          customFeature.isShowVirtualPrice && _react2.default.createElement(
                            'span',
                            { className: 'presell-origin-price', style: { marginLeft: '.1rem' } },
                            '\xA5',
                            item.form_data.price
                          )
                        ),
                        customFeature.isShowSales && _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          item.status != 0 ? _react2.default.createElement(
                            'div',
                            { className: 'presell-view-count' },
                            '\u5DF2\u552E',
                            item.form_data._presell_goods.bargain_payment_count,
                            '\u4EF6'
                          ) : _react2.default.createElement(
                            'div',
                            { className: 'presell-view-count' },
                            item.form_data._presell_goods.presell_goods_view_count,
                            '\u4EBA\u6D4F\u89C8'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-right-line' },
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-status-btn' },
                          item.status == 0 && _react2.default.createElement(
                            'label',
                            { className: 'presell-not-begun' },
                            '\u672A\u5F00\u552E'
                          ),
                          item.status == 3 && _react2.default.createElement(
                            'label',
                            { className: 'pay-presell',
                              'data-paramstr': item.param_str,
                              'data-goodsid': item.form_data.goods_id,
                              'data-model': item.model_length,
                              onClick: function onClick(e) {
                                _this2.payPresell(e), e.stopPropagation();
                              } },
                            '\u4ED8\u5B9A\u91D1'
                          ),
                          item.status != 0 && item.status != 3 && _react2.default.createElement(
                            'label',
                            { className: 'over-presell' },
                            '\u5DF2\u7ED3\u675F'
                          )
                        )
                      )
                    )
                  ) : _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'presell-left-line' },
                      customFeature.isShowSales && item.status != 0 ? _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-pricecustomFeature.', style: customFeature.mode == 3 ? { display: 'inline-block' } : {} },
                          _react2.default.createElement(
                            'label',
                            { className: 'presell-price', style: { color: item.status == 0 ? '#8262E8' : '#FF4D4F' } },
                            '\xA5',
                            _react2.default.createElement(
                              'span',
                              { className: 'presell-price-int' },
                              item.form_data._presell_goods.presell_current_price
                            )
                          ),
                          customFeature.isShowVirtualPrice && _react2.default.createElement(
                            'span',
                            { className: 'presell-origin-price' },
                            '\xA5',
                            item.form_data.price
                          )
                        ),
                        customFeature.isShowSales && _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          item.status != 0 ? _react2.default.createElement(
                            'div',
                            { className: 'presell-view-count', style: customFeature.mode == 3 ? { display: 'inline-block', marginLeft: '.1rem' } : { marginTop: '.2rem' } },
                            '\u5DF2\u552E',
                            item.form_data._presell_goods.bargain_payment_count,
                            '\u4EF6'
                          ) : _react2.default.createElement(
                            'div',
                            { className: 'presell-view-count', style: customFeature.mode == 3 ? { display: 'inline-block' } : { marginTop: '.2rem' } },
                            item.form_data._presell_goods.presell_goods_view_count,
                            '\u4EBA\u6D4F\u89C8'
                          )
                        )
                      ) : _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        _react2.default.createElement(
                          'div',
                          { className: 'presell-price', style: customFeature.mode == 3 ? { display: 'inline-block' } : {} },
                          _react2.default.createElement(
                            'label',
                            { className: 'presell-price', style: { color: item.status == 0 ? '#8262E8' : '#FF4D4F' } },
                            '\xA5',
                            _react2.default.createElement(
                              'span',
                              { className: 'presell-price-int' },
                              item.form_data._presell_goods.presell_current_price
                            )
                          )
                        ),
                        customFeature.isShowVirtualPrice && _react2.default.createElement(
                          'div',
                          { className: 'presell-origin-price', style: customFeature.mode == 3 ? { display: 'inline-block', marginLeft: '.1rem' } : {} },
                          '\xA5',
                          item.form_data.price
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'presell-right-line' },
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-status-btn' },
                        item.status == 0 && _react2.default.createElement(
                          'label',
                          { className: 'presell-not-begun' },
                          '\u672A\u5F00\u552E'
                        ),
                        item.status == 3 && _react2.default.createElement(
                          'label',
                          { className: 'pay-presell',
                            'data-paramstr': item.param_str,
                            'data-goodsid': item.form_data.goods_id,
                            'data-model': item.model_length,
                            onClick: function onClick(e) {
                              _this2.payPresell(e), e.stopPropagation();
                            } },
                          '\u4ED8\u5B9A\u91D1'
                        ),
                        item.status != 0 && item.status != 3 && _react2.default.createElement(
                          'label',
                          { className: 'over-presell' },
                          '\u5DF2\u7ED3\u675F'
                        )
                      )
                    )
                  )
                )
              )
            );
          })
        );
      };

      // 是否为竖版
      var hor = customFeature.mode == 2 && data.curpage > 0;

      return _react2.default.createElement(
        _ScrollView.ScrollView,
        {
          className: 'custom-component presell presell-list-mode-' + customFeature.mode + ' ' + (customFeature.mode == 2 && data.curpage > 0 ? 'hor-request-status' : ''),
          'data-compindex': this.props.index,
          'data-type': 'presell-list',
          style: styleObj,
          'scroll-y': customFeature.mode == 2 || customFeature.vesselAutoheight != 0 ? false : true,
          'scroll-x': customFeature.mode == 2 ? true : false,
          'lower-threshold': '100',
          bindscrolltolower: this.catchMorePresellList
          // bindanimationend="animationEnd"
        },
        customFeature.mode == 0 && _react2.default.createElement(
          'div',
          { className: 'presell-list list' },
          !!goods_data && goods_data.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: 'presell-goods-item isRelative',
                key: item.form_data.id,
                style: goodsItemStyleObj,
                'data-goodsid': item.form_data.goods_id,
                'data-activityid': item.form_data.group_buy_activity_id,
                'data-status': item.status,
                'data-presellstatus': item.status,
                onClick: item.status != 4 ? _this2.gotoPresellDetail : _this2.showOverTips },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'presell-image-wrap', style: imgWrapStyleObj },
                  _react2.default.createElement('img', { src: item.form_data.cover })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'presell-content-wrap' },
                  _react2.default.createElement(
                    'div',
                    { className: 'presell-title' },
                    customFeature.isShowPresaleStatus && _react2.default.createElement(
                      'div',
                      { className: 'presell-logo ' + (item.status == 0 ? 'presell-not-begun' : 'pay-presell') },
                      '\u9884\u552E'
                    ),
                    item.form_data.title
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'presell-detail-msg' },
                    _react2.default.createElement(
                      'div',
                      { className: 'first-line' },
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-price' },
                        _react2.default.createElement(
                          'label',
                          { className: 'presell-price', style: { color: item.status == 0 ? '#8262E8' : '#FF4D4F' } },
                          '\xA5',
                          _react2.default.createElement(
                            'span',
                            { className: 'presell-price-int' },
                            item.form_data._presell_goods.presell_current_price
                          )
                        ),
                        customFeature.isShowVirtualPrice && _react2.default.createElement(
                          'span',
                          { className: 'presell-origin-price' },
                          '\xA5',
                          item.form_data.price
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'presell-status-btn' },
                        item.status == 0 && _react2.default.createElement(
                          'label',
                          { className: 'presell-not-begun' },
                          '\u672A\u5F00\u552E'
                        ),
                        item.status == 3 && _react2.default.createElement(
                          'label',
                          { className: 'pay-presell',
                            'data-paramstr': item.param_str,
                            'data-goodsid': item.form_data.goods_id,
                            'data-model': item.model_length,
                            onClick: function onClick(e) {
                              _this2.payPresell(e), e.stopPropagation();
                            }
                          },
                          '\u4ED8\u5B9A\u91D1'
                        ),
                        item.status != 0 && item.status != 3 && _react2.default.createElement(
                          'label',
                          { className: 'over-presell' },
                          '\u5DF2\u7ED3\u675F'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'second-line' },
                      customFeature.isShowSales && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        item.status != 0 ? _react2.default.createElement(
                          'span',
                          { className: 'presell-view-count' },
                          '\u5DF2\u552E',
                          item.form_data._presell_goods.bargain_payment_count,
                          '\u4EF6'
                        ) : _react2.default.createElement(
                          'span',
                          { className: 'presell-view-count' },
                          item.form_data._presell_goods.presell_goods_view_count,
                          '\u4EBA\u6D4F\u89C8'
                        )
                      ),
                      customFeature.isShowCountdown && item.status != 4 && _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        item.status == 0 ? _react2.default.createElement(
                          'span',
                          { className: 'pull-right', style: { color: '#8262E8' } },
                          '\u8DDD\u5F00\u59CB\uFF1A',
                          item.downCount.days,
                          '\u5929',
                          item.downCount.hours,
                          ':',
                          item.downCount.minutes,
                          ':',
                          item.downCount.seconds
                        ) : _react2.default.createElement(
                          'span',
                          { className: 'pull-right', style: { color: '#FF4D4F' } },
                          '\u8DDD\u7ED3\u675F\uFF1A',
                          item.downCount.days,
                          '\u5929',
                          item.downCount.hours,
                          ':',
                          item.downCount.minutes,
                          ':',
                          item.downCount.seconds
                        )
                      )
                    )
                  )
                )
              )
            );
          })
        ),
        customFeature.mode == 1 && _react2.default.createElement(ModeWrap, { className: 'opposite', colRowClassName: !customFeature.isShowSales || !customFeature.isShowVirtualPrice ? 'col' : 'row' }),
        customFeature.mode == 2 && _react2.default.createElement(ModeWrap, { className: 'swiper', colRowClassName: !customFeature.isShowSales || !customFeature.isShowVirtualPrice ? 'col' : 'row' }),
        customFeature.mode == 3 && _react2.default.createElement(ModeWrap, { className: 'bigPicture', colRowClassName: '' }),
        data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading', hor: hor }),
        data.is_more == 0 && data.goods_data.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无商品' }, hor: hor }),
        data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'catchMorePresellList', compindex: this.props.index }, hor: hor }),
        data.is_more == 0 && data.goods_data.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll', hor: hor }),
        data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: customFeature, onClick: this.goodsScrollFunc, 'data-compindex': this.props.index })
      );
    }
  }]);
  return PresellCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    var component_params = {
      page: 1,
      page_size: 10
    };
    var newdata = {};
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    newdata['eles[' + compindex + '].loading'] = false;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    _this3.loadPresellList(compindex, component_params);
  };

  this.loadPresellList = function (compindex, component_params) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var loadingNum = customFeature.loadingNum || 10;

    if (compData.is_more == 0 || compData.loading) {
      return;
    }

    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    if (component_params.page == 1) {
      newdata['eles[' + compindex + '].goods_data'] = [];
    }
    //清除定时器
    if (pageInstance.downcountObject && pageInstance.downcountObject[compindex] && component_params.page == 1) {
      var downcountArr = pageInstance.downcountObject[compindex];
      if (downcountArr && downcountArr.length) {
        for (var i = 0; i < downcountArr.length; i++) {
          downcountArr[i] && downcountArr[i].clear();
        }
      }
    }
    pageInstance.setData(newdata);
    component_params.page_size = loadingNum;
    if (customFeature.source && customFeature.source != 'none') {
      component_params.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      };
    }

    pageInstance.setData({
      'loading': true
    });

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppPreSell/GetPreSellGoodsList',
      data: component_params,
      method: 'post',
      success: function success(res) {
        if (res.data) {
          var rdata = res.data,
              activity_info = res._presell_activity,
              final_payment_start_time = activity_info && activity_info.final_payment_start_time,
              _newdata = {},
              _downcountArr = pageInstance.downcountObject && pageInstance.downcountObject[compindex] || [],
              length = compData.goods_data.length || 0,
              matchReg = /CN_.*?\.mtl/gi;
          for (var _i = 0; _i < rdata.length; _i++) {
            var f = rdata[_i],
                _newdata2 = {},
                dc = void 0,
                form_data = f.form_data,
                server_time = form_data.server_time || Date.parse(new Date()) / 1000,
                acid = form_data.presell_activity_id,
                activity = res._presell_activity[acid],
                presell_goods = form_data._presell_goods,
                start_time = activity && activity.bargain_start_time * 1,
                _presell_discount_info = form_data._presell_discount_info == null ? [] : form_data._presell_discount_info[0],
                end_time = activity && activity.bargain_end_time * 1;
            f.description = '';
            f.downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00',
              days: '00'
            };

            f.final_payment_start_time = _util2.default.formatTimeYMD(new Date(activity && activity.final_payment_start_time * 1000), 'MM月DD日 hh:mm');
            var param_str = {
              goods_id: form_data.goods_id,
              activity_id: form_data.presell_activity_id || '',
              model_id: form_data.model_id || '',
              nums: 1,
              address_id: f.address_id || '',
              models_text: f.model_value_str || '',
              models_stock: _presell_discount_info.presell_stock,
              final_payment_start_time: f.final_payment_start_time || '',
              bargain_order_id: '',
              presell_status: f.presell_status || 0,
              limit_buy: _presell_discount_info.buy_limit_num
            };
            f.param_str = JSON.stringify(param_str);
            f.presellprice = {
              integer: typeof presell_goods.presell_min_price == 'string' && presell_goods.presell_min_price.match(/(\S*)./)[1] ? presell_goods.presell_min_price.match(/(\S*)./)[1] : presell_goods.presell_min_price,
              zero: typeof presell_goods.presell_min_price == 'string' && presell_goods.presell_min_price.match(/.(\S*)/)[1] ? presell_goods.presell_min_price.match(/.(\S*)/)[1] : '00'
            };
            f.model_length = f.form_data.goods_model ? f.form_data.goods_model.length : 0;
            f.server_time = server_time;
            f.seckill_end_time = _util2.default.formatTime(new Date(end_time * 1000));
            f.seckill_start_time = _util2.default.formatTime(new Date(start_time * 1000));
            f.status = server_time > start_time ? server_time > end_time ? 2 : 3 : 0;
            if (f.status == 0) {
              dc = _app.appMethod.beforeGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + (_i + length) + ']');
            } else if (f.status == 3) {
              dc = _app.appMethod.duringGroupDownCount(f, pageInstance, 'eles[' + compindex + ']goods_data[' + (_i + length) + ']');
            }
            dc && _downcountArr.push(dc);
            f.form_data.price = form_data.virtual_price == '0.00' ? _presell_discount_info.origin_goods_price : form_data.virtual_price;
          }
          _newdata['eles[' + compindex + '].goods_data'] = compData.goods_data.concat(rdata);
          _newdata['eles[' + compindex + '].is_more'] = res.is_more;
          _newdata['eles[' + compindex + '].curpage'] = res.current_page;
          _newdata['eles[' + compindex + '].loading'] = false;
          _newdata['eles[' + compindex + '].loadingFail'] = false;

          pageInstance.downcountObject[compindex] = _downcountArr;
          pageInstance.setData(_newdata);
        }
      },
      fail: function fail(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    });
  };

  this.catchMorePresellList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var curpage = compData.curpage + 1;
    var goods_data = compData.goods_data || [];
    if (compData.loading || !compData.is_more) {
      return;
    }
    var component_params = {
      page: curpage,
      page_size: customFeature.loadingNum || 10
      // if (compData.loading || !compData.is_more) {
      //   return;
      // }
    };_this3.loadPresellList(compindex, component_params);
  };

  this.showOverTips = function (e) {
    _app.appMethod.showModal({
      content: '预售活动已结束'
    });
  };

  this.gotoPresellDetail = function (e) {
    var dataset = e.currentTarget.dataset,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        franchisee = pageInstance.franchiseeId;
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    _app.appMethod.turnToPage('/presell/pages/presellDetail/presellDetail?detail=' + dataset.goodsid + chainParam);
  };

  this.payPresell = function (e) {
    var dataset = e.currentTarget.dataset,
        pageInstance = _app.appMethod.getAppCurrentPage(),
        franchisee = pageInstance.franchiseeId;
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    if (dataset.model > 0) {
      _app.appMethod.turnToPage('/presell/pages/presellDetail/presellDetail?detail=' + dataset.goodsid + chainParam);
    } else {
      var param_str = dataset.paramstr,
          pagePath = '/presell/pages/previewPresellOrder/previewPresellOrder?param=' + encodeURIComponent(param_str) + chainParam;
      _app.appMethod.turnToPage(pagePath);
    }
  };
};

exports.default = PresellCustomComponent;

/***/ }),
/* 921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _tools = __webpack_require__(6);

var _app = __webpack_require__(4);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(923);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "vertical-list" 
 * 组件：竖版列表组件
 */

var price = {
  price: function price(a, b) {
    var c = (a - b).toFixed(2);
    return c;
  },
  shopScore: function shopScore(a, b) {
    var c = (1 - (b - a) / b).toFixed(2) * 100;
    return c;
  },
  pxToRpx: function pxToRpx(size) {
    return parseInt(size) * 2.34375 / 100 + 'rem';
  },
  parseStyle: function parseStyle(style) {
    // 调用此方法的话，应改为使用transformPx2Rem
    var styleArr1 = ["width", "font-size", 'margin-left'];
    var styleArr2 = ["background-color", 'color', 'font-style', 'font-weight', 'text-decoration'];
    var s = '';
    for (var i = 0; i < styleArr1.length; i++) {
      var idx = styleArr1[i];
      if (style[idx]) {
        s += idx + ':' + parseInt(style[idx]) * 2.34375 + 'rpx;';
        if (idx == "height") {
          s += 'line-height:' + parseInt(style[idx]) * 2.34375 + 'rpx;';
        }
      }
    }
    for (var i = 0; i < styleArr2.length; i++) {
      var idx = styleArr2[i];
      if (style[idx]) {
        s += idx + ':' + style[idx] + ';';
      }
    }
    return s;
  }
};

var VerticalListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(VerticalListCustomComponent, _React$Component);

  function VerticalListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, VerticalListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (VerticalListCustomComponent.__proto__ || Object.getPrototypeOf(VerticalListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  //显示隐藏店铺信息


  // 隐藏搜索


  // 排序


  //减商品


  //加商品


  //搜索下拉获取更多


  // 搜索商品


  //显示购物车


  //结算（旧版）


  //切换评论类别


  //获取更多评论


  //打开地图


  //获取单个商品评论


  //隐藏选择规格弹窗


  //选择规格


  //商品规格价格


  //加多规格商品


  //减多规格商品


  //隐藏购物车


  //购物车减商品


  //购物车加商品


  //清空购物车


  //获取商品


  //获取购物车


  //加入购物车


  //返回购物车数组


  //获取评论


  //加载全部数据，列表滚动事件


  //跳转到手动选择地址


  //获取当前定位


  //cartIdArray


  //获取自己的cartIds


  //结算（新版）


  //打开分开结算弹窗


  //隐藏分开结算弹窗


  //结算


  //关闭会员权益不足弹窗 


  //获取会员卡信息


  //扫码


  //获取多人点餐购物车

  //多人点餐购物车数据处理


  //轮询点餐购物车


  //多人点餐清空


  //保存formId


  (0, _createClass3.default)(VerticalListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this,
          _React$createElement3;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 判断当前页是否有导航
      var isShowBottom = _app.appMethod.isTabBarPage();
      return _react2.default.createElement(
        'div',
        { className: 'custom-component vertical-list' },
        _react2.default.createElement(
          'div',
          { className: 'verticalList-wrap', onTouchStart: this.verticalListTouchstart, onTouchMove: this.verticalListTouchmove, 'data-compindex': this.props.index },
          !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && _react2.default.createElement(
            'div',
            { className: 'goods-location-box', onClick: function onClick(e) {
                _this3.vlSelectGoodsSameJourney(e);e.stopPropagation();
              }, 'data-compindex': this.props.index },
            _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
            _react2.default.createElement(
              'span',
              { className: 'address-box' },
              data.selectSameJourney ? data.selectSameJourney.address_info.province.text + data.selectSameJourney.address_info.city.text + data.selectSameJourney.address_info.district.text + data.selectSameJourney.detail_address : data.currentLocationData && data.currentLocationData.formatted_addresses && data.currentLocationData.formatted_addresses.recommend || '暂无地址'
            ),
            _react2.default.createElement('span', { className: 'ico-moon icon-fesdown' })
          ),
          !!data.customFeature.showShopInfo && _react2.default.createElement(
            'div',
            { className: 'shopInfoHeight',
              hidden: data.infoHeight && data.shopHeight // TOOD: 后续处理了动画之后可以去掉这个
              , style: {
                overflow: 'hidden'
              }
              // animation={data.shopInfoHeight} 
              // bindtransitionend="stopAnimation"
              , 'data-compindex': this.props.index },
            data.customFeature.mode == 0 && _react2.default.createElement(
              'div',
              { className: 'takeout-shop-desc', style: {
                  paddingBottom: data.customFeature.is_together ? null : '.16rem'
                } },
              _react2.default.createElement(
                'div',
                { style: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    position: 'relative',
                    overflow: 'hidden'
                  }, 'data-a': data.in_business_time },
                _react2.default.createElement('img', { src: data.shopInfo && data.shopInfo.logo, style: {
                    borderRadius: price.pxToRpx(data.customFeature.logoRadius)
                  } }),
                data.in_business_time == 0 && _react2.default.createElement(
                  'div',
                  { className: 'takeoutShopRest' },
                  '\u5546\u5BB6\u4F11\u606F'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'shop-title', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    data.shopInfo ? data.shopInfo.title : ''
                  )
                ),
                !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && _react2.default.createElement(
                  'div',
                  { className: 'shop-send', style: {
                      marginBottom: '.08rem'
                    } },
                  '\u8D77\u9001\xA5',
                  data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_min_deliver_price : data.config_data.min_deliver_price),
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  '\u914D\u9001\u8D39\xA5',
                  data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data.deliver_fee),
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  data.config_data && (data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_time : data.config_data.deliver_time),
                  '\u5206\u949F\u9001\u8FBE'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'shop-adress', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    '\u5E97\u94FA\u5730\u5740\uFF1A',
                    data.shopInfo ? data.shopInfo.address_detail : ''
                  )
                )
              )
            ),
            data.customFeature.mode == 1 && _react2.default.createElement(
              'div',
              { className: 'takeout-shop-desc1' },
              _react2.default.createElement('div', { className: 'takeout-shop-bgPic',
                style: {
                  opacity: data.customFeature.style['opacity'],
                  background: data.customFeature['backgroundType'] == '0' ? data.customFeature.style['background-color'] : data.customFeature.style['background-image'],
                  backgroundSize: '100%'
                } }),
              _react2.default.createElement(
                'div',
                { className: 'shop-info shopInfo1' },
                _react2.default.createElement(
                  'div',
                  { className: 'shop-title', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    data.shopInfo ? data.shopInfo.title : ''
                  )
                ),
                !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && _react2.default.createElement(
                  'div',
                  { className: 'shop-send', style: { marginBottom: '.12rem' } },
                  '\u8D77\u9001\xA5',
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_min_deliver_price : data.config_data ? data.config_data.min_deliver_price : '',
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  '\u914D\u9001\u8D39\xA5',
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data ? data.config_data.deliver_fee : '',
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_time : data.config_data ? data.config_data.deliver_time : '',
                  '\u5206\u949F\u9001\u8FBE'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'shop-adress', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    '\u5E97\u94FA\u5730\u5740\uFF1A',
                    data.shopInfo ? data.shopInfo.address_detail : ''
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info-cover' },
                _react2.default.createElement('img', { src: data.shopInfo && data.shopInfo.logo, style: {
                    borderRadius: price.pxToRpx(data.customFeature.logoRadius)
                  } })
              )
            ),
            data.customFeature.mode == 2 && _react2.default.createElement(
              'div',
              { className: 'takeout-shop-desc2' },
              _react2.default.createElement('div', { className: 'takeout-shop-bgPic',
                style: {
                  opacity: data.customFeature.style['opacity'],
                  backgroundColor: data.customFeature['backgroundType'] == '0' ? data.customFeature.style['background-color'] : null,
                  backgroundImage: data.customFeature['backgroundType'] != '0' ? data.customFeature.style['background-image'] : null,
                  backgroundSize: '100%'
                } }),
              _react2.default.createElement(
                'div',
                { className: 'shop-info shopInfo' },
                _react2.default.createElement(
                  'div',
                  { className: 'shop-title', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    data.shopInfo ? data.shopInfo.title : ''
                  )
                ),
                !!(data.customFeature.pickUpArr.sameJourney && !data.customFeature.is_together) && _react2.default.createElement(
                  'div',
                  { className: 'shop-send', style: { marginBottom: '.12rem' } },
                  '\u8D77\u9001\xA5',
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_min_deliver_price : data.config_data ? data.config_data.min_deliver_price : '',
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  '\u914D\u9001\u8D39\xA5',
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data ? data.config_data.deliver_fee : '',
                  _react2.default.createElement(
                    'span',
                    { style: { margin: '0 .1rem', color: '#E5E5E5' } },
                    '|'
                  ),
                  data.config_data && data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_time : data.config_data ? data.config_data.deliver_time : '',
                  '\u5206\u949F\u9001\u8FBE'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'shop-adress', style: { color: data.customFeature.storeMainColor || '#000' } },
                  _react2.default.createElement(
                    'span',
                    { style: { color: data.customFeature.storeMainColor || '#000' } },
                    '\u5E97\u94FA\u5730\u5740\uFF1A',
                    data.shopInfo ? data.shopInfo.address_detail : ''
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info-cover1' },
                _react2.default.createElement('img', { src: data.shopInfo && data.shopInfo.logo, style: {
                    borderRadius: price.pxToRpx(data.customFeature.logoRadius)
                  } })
              )
            ),
            !!(data.customFeature.mode != 2 && !data.customFeature.is_together) && _react2.default.createElement('div', { className: 'cutoffLine', style: {
                height: '.20rem'
              } })
          ),
          !!data.customFeature.is_together && _react2.default.createElement(
            'div',
            { className: 'user_list' },
            _react2.default.createElement(
              'div',
              { className: 'table_user_info' },
              data.user_list && data.user_list.map(function (user, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'cover_thumb', style: {
                      zIndex: data.user_list.length - index,
                      marginLeft: index === 0 ? '0rem' : '-.20rem'
                    } },
                  _react2.default.createElement('img', { src: user.cover_thumb })
                );
              }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  data.user_list.length,
                  '\u4EBA\u6B63\u5728\u9009\u8D2D\u4E2D'
                )
              )
            ),
            data.customFeature.mode != 2 && _react2.default.createElement('div', { className: 'cutoffLine', style: { height: '.20rem' } })
          ),
          !data.showSearch && _react2.default.createElement(
            'div',
            { className: 'waimai-goods-evaluate-search' },
            _react2.default.createElement(
              'div',
              { style: { width: data.customFeature.isShowSearch ? '25%' : '33%' } },
              _react2.default.createElement(
                'div',
                { 'data-index': '1', 'data-compindex': this.props.index, onClick: function onClick(e) {
                    _this3.verticalListChangeEvaluate(e);e.stopPropagation();
                  }, className: data.selected == 1 ? 'selected' : '' },
                '\u5546\u54C1'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { width: data.customFeature.isShowSearch ? '25%' : '33%' } },
              _react2.default.createElement(
                'div',
                { className: data.selected == 2 ? 'selected' : '', 'data-index': '2', 'data-compindex': this.props.index, onClick: function onClick(e) {
                    _this3.verticalListChangeEvaluate(e);e.stopPropagation();
                  } },
                '\u8BC4\u4EF7'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { width: data.customFeature.isShowSearch ? '25%' : '33%' } },
              _react2.default.createElement(
                'div',
                { className: data.selected == 3 ? 'selected' : '', 'data-index': '3', 'data-compindex': this.props.index, onClick: function onClick(e) {
                    _this3.verticalListChangeEvaluate(e);e.stopPropagation();
                  } },
                '\u5E97\u94FA'
              )
            ),
            !!data.customFeature.isShowSearch && _react2.default.createElement(
              'div',
              { className: 'waimai-list-search' },
              _react2.default.createElement(
                'div',
                { onClick: this.verticalListShowGoodsSearch, 'data-compindex': this.props.index },
                _react2.default.createElement('label', { className: 'ico-moon icon-waimai-search' }),
                _react2.default.createElement(
                  'span',
                  null,
                  '\u641C\u7D22'
                )
              )
            )
          ),
          !!data.showSearch && _react2.default.createElement(
            'div',
            { className: 'waimai-goods-evaluate-search-mode2' },
            _react2.default.createElement('div', { className: 'ico-moon icon-leftarrow', onClick: this.verticalListHideGoodsSearch, 'data-compindex': this.props.index }),
            _react2.default.createElement(
              'div',
              { className: 'waimai-goods-search-input' },
              _react2.default.createElement('label', { className: 'ico-moon icon-waimai-search', style: { float: 'left' } }),
              !data.hideSearchInput && _react2.default.createElement('input', { placeholder: '\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0', onInput: this.verticalListBindSearchTitle, onKeyDown: function onKeyDown(e) {
                  if (e.keyCode !== 13) {
                    return;
                  };_this3.verticalListSearchByTitle(e);
                }, 'data-compindex': this.props.index })
            ),
            _react2.default.createElement(
              'div',
              { className: 'evaluate-search-button', onClick: this.verticalListSearchByTitle, 'data-compindex': this.props.index },
              '\u641C\u7D22'
            )
          ),
          !data.showSearch && data.selected == 1 && _react2.default.createElement(
            'div',
            { className: 'element waimai waimai-container-wrap', style: (0, _extends3.default)({}, (0, _tools.convertStyleData)(data.style), {
                height: 'calc(' + data.heightPx + 'px ' + (data.infoHeight ? '' : '- ' + (data.shopHeight || 0) + 'px') + ' - .68rem - .76rem ' + (data.customFeature.is_together ? '- .52rem' : '- 0rem') + ' ' + (isShowBottom ? ' - .98rem' : '') + ')'
              })
              // bindanimationend="animationEnd"
              , 'data-compindex': this.props.index
            },
            _react2.default.createElement(
              _ScrollView.ScrollView,
              {
                className: 'typeList',
                'scroll-y': true,
                style: {
                  width: '1.52rem',
                  height: '100%',
                  maxWidth: '1.52rem'
                }
              },
              data.content && data.content.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'waimaiCategory',
                    style: (0, _extends3.default)({}, (0, _tools.convertStyleData)(data.customFeature.leftSpan), {
                      padding: '.32rem 0',
                      backgroundColor: data.customFeature.selected == index ? data.customFeature.selectedBackgroundColor : (0, _tools.convertStyleData)(data.customFeature.leftSpan).backgroundColor,
                      color: data.customFeature.selected == index ? data.customFeature.selectedColor : (0, _tools.convertStyleData)(data.customFeature.leftSpan).color,
                      borderLeft: data.customFeature.selected == index ? '.08rem solid #ff7100' : '',
                      textAlign: data.customFeature.typeLeft && data.customFeature.typeLeft != 'px' ? price.pxToRpx(data.customFeature.typeLeft) : '',
                      maxWidth: '1.52rem'
                    }),
                    onClick: function onClick(e) {
                      _this3.verticalListClickCategory(e);e.stopPropagation();
                    },
                    'data-index': index,
                    'data-id': item.source,
                    'data-compindex': _this3.props.index,
                    'data-param': data.pagination && JSON.stringify(data.pagination['category' + item.source].param),
                    'data-cateindex': index
                  },
                  !!+(item.pic && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon && +data.customFeature.databind || item.pic && data.customFeature.directionLeft == 0 && !+data.customFeature.databind) && _react2.default.createElement('img', { src: item.pic,
                    style: {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginRight: '.10rem',
                      width: data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.30rem',
                      height: data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.30rem',
                      borderRadius: price.pxToRpx(data.customFeature.iconRadius)
                    }
                  }),
                  _react2.default.createElement(
                    'span',
                    { className: 'waimai-cate-text' },
                    item.text
                  ),
                  !!+(item.pic && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon && +data.customFeature.databind || item.pic && data.customFeature.directionLeft == 1 && !+data.customFeature.databind) && _react2.default.createElement('img', { src: item.pic,
                    style: {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginLeft: '.10rem',
                      width: price.pxToRpx(data.customFeature.typeImgWidth),
                      height: price.pxToRpx(data.customFeature.typeImgWidth),
                      borderRadius: price.pxToRpx(data.customFeature.iconRadius)
                    }
                  })
                );
              }),
              _react2.default.createElement('div', { style: { height: '1.11rem' } })
            ),
            !!(!data.customFeature.loadAllData || data.customFeature.loadAllData == '0') && _react2.default.createElement(
              'div',
              { className: 'waimai-shoppingList', style: {
                  left: '1.52rem',
                  width: 'calc(100% - 1.52rem)',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  height: '100%',
                  minWidth: 'calc(100% - 1.52rem)'
                } },
              _react2.default.createElement(
                'div',
                null,
                !!(data.scrollTopLoading === 'top' && data.customFeature.selected > 0) && _react2.default.createElement(
                  'span',
                  { style: {
                      height: '2.00rem',
                      lineHeight: '2.00rem',
                      textAlign: 'center',
                      color: '#999',
                      fontSize: '.24rem',
                      display: 'block'
                    } },
                  '\u4E0A\u6ED1\u67E5\u770B\u4E0A\u4E00\u7C7B'
                )
              ),
              data.content && data.content.map(function (items, index) {
                var _React$createElement;

                return index == data.customFeature.selected && _react2.default.createElement(
                  _ScrollView.ScrollView,
                  (_React$createElement = { key: index, className: 'waimaigoodslist'
                  }, (0, _defineProperty3.default)(_React$createElement, 'key', index), (0, _defineProperty3.default)(_React$createElement, 'style', {
                    left: '1.52rem',
                    verticalAlign: 'top',
                    height: '100%'
                  }), (0, _defineProperty3.default)(_React$createElement, 'scroll-into-view', data.scrollId), (0, _defineProperty3.default)(_React$createElement, 'scroll-y', data.customFeature.showShopInfo && !data.infoHeight && data.customFeature.selected == 0 ? false : true), (0, _defineProperty3.default)(_React$createElement, 'data-compindex', _this3.props.index), (0, _defineProperty3.default)(_React$createElement, 'data-curpage', data.curpage), (0, _defineProperty3.default)(_React$createElement, 'data-categoryid', items.source), (0, _defineProperty3.default)(_React$createElement, 'data-param', data.pagination && JSON.stringify(data.pagination['category' + items.source].param)), (0, _defineProperty3.default)(_React$createElement, 'bindscrolltolower', _this3.verticalListStyleScrollFunc), (0, _defineProperty3.default)(_React$createElement, 'scroll-top', data.scrollTop), (0, _defineProperty3.default)(_React$createElement, 'bindscrolltoupper', _this3.verticalListStyleScrollTop), (0, _defineProperty3.default)(_React$createElement, 'upper-threshold', '.20rem'), (0, _defineProperty3.default)(_React$createElement, 'lower-threshold', '.50rem'), (0, _defineProperty3.default)(_React$createElement, 'bindtouchstart', _this3.scrollStart), (0, _defineProperty3.default)(_React$createElement, 'bindtouchmove', _this3.scrollMove), (0, _defineProperty3.default)(_React$createElement, 'bindtouchend', _this3.scrollEnd), _React$createElement),
                  _react2.default.createElement(
                    'div',
                    { className: 'takeoutCategory', 'data-source': items.source },
                    items.text,
                    data.customFeature.listType == '1' && _react2.default.createElement(
                      'div',
                      { className: 'price',
                        onClick: _this3.sortVerticalList,
                        'data-compindex': _this3.props.index,
                        'data-curpage': data.curpage,
                        'data-categoryid': items.source,
                        'data-param': data.pagination && JSON.stringify(data.pagination['category' + items.source].param),
                        'data-sort_key': 'price',
                        'data-direction': data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u4EF7\u683C'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-news-up',
                        style: {
                          color: data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction == 1 && data.categorySort['category' + items.source].sortKey == 'price' ? '#666' : '#ccc'
                        }
                      }),
                      _react2.default.createElement('label', { className: 'ico-moon icon-news-down',
                        style: {
                          color: data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction == 0 && data.categorySort['category' + items.source].sortKey == 'price' ? '#666' : '#ccc'
                        }
                      })
                    ),
                    data.customFeature.listType == '1' && _react2.default.createElement(
                      'div',
                      { className: 'sales',
                        onClick: _this3.sortVerticalList,
                        'data-compindex': _this3.props.index,
                        'data-curpage': data.curpage,
                        'data-categoryid': items.source,
                        'data-param': data.pagination && JSON.stringify(data.pagination['category' + items.source].param),
                        'data-sort_key': 'sales',
                        'data-direction': data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction
                      },
                      _react2.default.createElement(
                        'span',
                        null,
                        '\u9500\u91CF'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-news-up',
                        style: {
                          color: data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction == 1 && data.categorySort['category' + items.source].sortKey == 'sales' ? '#666' : '#ccc'
                        }
                      }),
                      _react2.default.createElement('label', { className: 'ico-moon icon-news-down',
                        style: {
                          color: data.categorySort['category' + items.source] && data.categorySort['category' + items.source].sort_direction == 0 && data.categorySort['category' + items.source].sortKey == 'sales' ? '#666' : '#ccc'
                        }
                      })
                    )
                  ),
                  data.show_goods_data && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].map(function (item, index) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: index },
                      data.customFeature['listArrange'] == '0' && _react2.default.createElement(
                        'div',
                        { className: 'waimaigoods-list-item list-item' },
                        !(!data.customFeature.showIntegral && item.integral === '1') && _react2.default.createElement(
                          'div',
                          { 'data-id': item.id, 'data-compindex': _this3.props.index },
                          _react2.default.createElement(
                            'div',
                            { className: 'inner-content' },
                            _react2.default.createElement('img', { className: 'waimai-img',
                              src: item.cover,
                              onClick: _this3.showVerticalListGoodsDetail,
                              'data-id': item.id,
                              'data-compindex': _this3.props.index,
                              'data-index': index,
                              'data-category': items.source }),
                            data.customFeature.isShowStock && item.stock < 6 && _react2.default.createElement(
                              'label',
                              { className: 'goods-stock' },
                              '\u4EC5\u5269',
                              item.stock,
                              '\u4EF6'
                            ),
                            !!+item.corner_mark && _react2.default.createElement('img', { className: 'new-goods', src: item.corner_url }),
                            _react2.default.createElement(
                              'div',
                              { className: 'waimai-title', style: { width: 'initial' } },
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-title-text',
                                  onClick: _this3.showVerticalListGoodsDetail,
                                  'data-id': item.id,
                                  'data-compindex': _this3.props.index,
                                  'data-index': index,
                                  'data-category': items.source },
                                item.max_can_use_integral > 0 && _react2.default.createElement(
                                  'span',
                                  { className: 'jifen' },
                                  '\u79EF'
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'text' },
                                  item.title
                                ),
                                !!(item.vipGoods && data.customFeature.vipShopping) && _react2.default.createElement(
                                  'span',
                                  { className: 'vip-goods' },
                                  '\u4F1A\u5458\u8D2D'
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-title-dec' },
                                data.customFeature.sale !== false ? _react2.default.createElement(
                                  'span',
                                  null,
                                  '\u9500\u91CF\uFF1A',
                                  item.sales
                                ) : _react2.default.createElement('span', null)
                              ),
                              !!item.is_vip_goods && _react2.default.createElement(
                                'div',
                                { className: 'vip_goods_price' },
                                _react2.default.createElement(
                                  'span',
                                  { style: {
                                      marginRight: '.08rem'
                                    } },
                                  _react2.default.createElement(
                                    'span',
                                    { style: {
                                        fontSize: '.24rem',
                                        fontWeight: 'normal'
                                      } },
                                    '\xA5'
                                  ),
                                  item.vip_price
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'vip_goods_tips' },
                                  '\u4F1A\u5458\u4EF7'
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-item-bottom', style: {
                                    paddingTop: 0,
                                    marginTop: item.is_vip_goods ? '.26rem' : '.60rem'
                                  } },
                                _react2.default.createElement(
                                  'span',
                                  { className: 'waimai-price-per' },
                                  _react2.default.createElement(
                                    'span',
                                    { style: {
                                        fontSize: '.24rem',
                                        fontWeight: 'normal'
                                      } },
                                    '\xA5'
                                  ),
                                  item.price
                                ),
                                !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00') && _react2.default.createElement(
                                  'span',
                                  { style: {
                                      textDecoration: 'line-through',
                                      fontSize: '.22rem',
                                      color: '#999'
                                    } },
                                  '\xA5',
                                  item.virtual_price
                                ),
                                _react2.default.createElement(
                                  'label',
                                  { className: 'waimai-number-change' },
                                  !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && _react2.default.createElement('label', { className: 'waimai-count-minus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                      _this3.verticalListListMinus(e);e.stopPropagation();
                                    }, 'data-stock': data.goods_data_list[item.id].stock,
                                    'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                                  data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                    'span',
                                    { className: 'waimai-number' },
                                    data.goods_data_list[item.id].totalNum
                                  ),
                                  !item.goods_model && _react2.default.createElement('label', { className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''), 'data-goodsid': item.id, onClick: function onClick(e) {
                                      _this3.verticalListListPlus(e);e.stopPropagation();
                                    }, 'data-stock': data.goods_data_list[item.id].stock,
                                    'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                                  !!item.goods_model && _react2.default.createElement(
                                    'label',
                                    { className: 'waimai-count-model-plus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                        _this3.verticalListListPlus(e);e.stopPropagation();
                                      }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model,
                                      'data-is-in-business': item.is_in_business_time },
                                    '\u9009\u89C4\u683C'
                                  )
                                )
                              )
                            )
                          )
                        )
                      ),
                      data.customFeature['listArrange'] == '1' && _react2.default.createElement(
                        'div',
                        { className: 'waimai-list-mode2' },
                        !(!data.customFeature.showIntegral && item.integral === '1') && _react2.default.createElement(
                          'div',
                          { 'data-id': item.id, 'data-compindex': _this3.props.index },
                          _react2.default.createElement(
                            'div',
                            { className: 'inner-mode2-content' },
                            _react2.default.createElement(
                              'div',
                              { className: 'image-content' },
                              _react2.default.createElement('img', { className: 'waimai-mode2-img', src: item.cover, onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': items.source }),
                              !!(data.customFeature.isShowStock && item.stock < 6) && _react2.default.createElement(
                                'label',
                                { className: 'goods-stock' },
                                '\u4EC5\u5269',
                                item.stock,
                                '\u4EF6'
                              ),
                              !!+item.corner_mark && _react2.default.createElement('img', { className: 'new-goods', src: item.corner_url })
                            ),
                            _react2.default.createElement(
                              'div',
                              { style: { width: 'initial' }, className: 'waimai-title waimai-mode2-title' },
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-title-mode2-text', onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': items.source },
                                item.max_can_use_integral > 0 && _react2.default.createElement(
                                  'span',
                                  { className: 'jifen' },
                                  '\u79EF'
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'text' },
                                  item.title
                                ),
                                item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                                  'span',
                                  { className: 'vip-goods' },
                                  '\u4F1A\u5458\u8D2D'
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-title-mode2-dec' },
                                data.customFeature.sale !== false && _react2.default.createElement(
                                  'span',
                                  null,
                                  '\u9500\u91CF\uFF1A',
                                  item.sales
                                )
                              ),
                              !!item.is_vip_goods && _react2.default.createElement(
                                'div',
                                { className: 'vip_goods_price' },
                                _react2.default.createElement(
                                  'span',
                                  { style: { marginRight: '.08rem' } },
                                  _react2.default.createElement(
                                    'span',
                                    { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                    '\xA5'
                                  ),
                                  item.vip_price
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'vip_goods_tips' },
                                  '\u4F1A\u5458\u4EF7'
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'waimai-item-bottom', style: {
                                    paddingTop: '0',
                                    marginTop: item.is_vip_goods ? '.02rem' : '.36rem'
                                  } },
                                _react2.default.createElement(
                                  'span',
                                  { className: 'waimai-price-per' },
                                  _react2.default.createElement(
                                    'span',
                                    { style: {
                                        fontSize: '.24rem',
                                        fontWeight: 'normal'
                                      } },
                                    '\xA5'
                                  ),
                                  item.price
                                ),
                                !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00') && _react2.default.createElement(
                                  'span',
                                  { style: {
                                      textDecoration: 'line-through',
                                      fontSize: '.22rem',
                                      color: '#999'
                                    } },
                                  '\xA5',
                                  item.virtual_price
                                ),
                                _react2.default.createElement(
                                  'label',
                                  { className: 'waimai-number-change' },
                                  !item.goods_model && _react2.default.createElement(
                                    'label',
                                    { className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''), 'data-goodsid': item.id, onClick: function onClick(e) {
                                        _this3.verticalListListPlus(e);e.stopPropagation();
                                      }, 'data-stock': data.goods_data_list[item.id].stock,
                                      'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time },
                                    data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                      'label',
                                      null,
                                      data.goods_data_list[item.id].totalNum
                                    )
                                  ),
                                  !!item.goods_model && _react2.default.createElement(
                                    'label',
                                    { className: 'waimai-count-model-plus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                        _this3.verticalListListPlus(e);e.stopPropagation();
                                      }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model,
                                      'data-is-in-business': item.is_in_business_time },
                                    '\u9009\u89C4\u683C',
                                    data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                      'label',
                                      null,
                                      data.goods_data_list[item.id].totalNum
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    );
                  }),
                  data.customFeature.selected !== data.content.length - 1 && data.show_goods_data && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].length > 0 && _react2.default.createElement(
                    'div',
                    { style: {
                        height: '5.00rem',
                        lineHeight: '5.00rem',
                        textAlign: 'center',
                        color: '#999',
                        fontSize: '.24rem'
                      } },
                    data.scrollTopLoading === 'bottom' && data.pagination['category' + items.source].is_more == 0 && _react2.default.createElement(
                      'span',
                      null,
                      '\u4E0B\u6ED1\u67E5\u770B\u4E0B\u4E00\u5206\u7C7B'
                    )
                  ),
                  data.customFeature.selected == data.content.length - 1 && _react2.default.createElement('div', { style: { height: '2.00rem' } }),
                  data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
                  !!(data.pagination && data.pagination['category' + items.source].is_more == 0 && data.show_goods_data && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].length == 0) && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无数据~' } }),
                  data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'verticalListStyleScrollFunc', compindex: _this3.props.index } }),
                  !!(data.pagination && data.pagination['category' + items.source].is_more == 0 && data.show_goods_data && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].length > 0 && data.customFeature.selected == data.content.length - 1) && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' })
                );
              }),
              data.customFeature.loadAllData == '1' && _react2.default.createElement('div', { style: { height: '1.11rem' } })
            ),
            data.customFeature.loadAllData == '1' && _react2.default.createElement(
              'div',
              { className: 'waimai-shoppingList', style: {
                  left: '1.52rem',
                  width: 'calc(100% - 1.52rem)',
                  display: 'inline-block',
                  verticalAlign: 'top',
                  height: '100%',
                  minWidth: 'calc(100% - 1.52rem)'
                } },
              _react2.default.createElement(
                _ScrollView.ScrollView,
                { style: { height: '100%', verticalAlign: 'top' }, className: 'waimaigoodslist', 'scroll-y': true, 'scroll-into-view': data.scrollInto, 'scroll-with-animation': true, onScroll: this.verticalListGoodsListScroll, 'data-compindex': this.props.index },
                _react2.default.createElement('div', { className: 'takeoutCategory' }),
                data.content && data.content.map(function (cate, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      { id: 'cate-' + index, style: {
                          height: '.38rem',
                          paddingLeft: '.20rem'
                        } },
                      cate.text
                    ),
                    data.loadFirstCate && index == 0 && _react2.default.createElement(
                      'div',
                      { className: 'firstCate', style: {
                          height: '100%',
                          position: 'absolute',
                          width: '100%',
                          zIndex: '99'
                        } },
                      _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' })
                    ),
                    data.show_goods_data && data.show_goods_data['category' + cate.source] && data.show_goods_data['category' + cate.source].map(function (item, index) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: index },
                        data.customFeature['listArrange'] == '0' && _react2.default.createElement(
                          'div',
                          { className: 'waimaigoods-list-item list-item' },
                          !(!data.customFeature.showIntegral && item.integral === '1') && _react2.default.createElement(
                            'div',
                            { 'data-id': item.id, 'data-compindex': _this3.props.index },
                            _react2.default.createElement(
                              'div',
                              { className: 'inner-content' },
                              _react2.default.createElement('img', { className: 'waimai-img', src: item.cover, onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': cate.source }),
                              !!(data.customFeature.isShowStock && item.stock < 6) && _react2.default.createElement(
                                'label',
                                { className: 'goods-stock' },
                                '\u4EC5\u5269',
                                item.stock,
                                '\u4EF6'
                              ),
                              !!+item.corner_mark && _react2.default.createElement('img', { className: 'new-goods', src: item.corner_url }),
                              _react2.default.createElement(
                                'div',
                                { style: { width: 'initial' }, className: 'waimai-title' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-title-text', onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': cate.source },
                                  item.max_can_use_integral > 0 && _react2.default.createElement(
                                    'span',
                                    { className: 'jifen' },
                                    '\u79EF'
                                  ),
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'text' },
                                    item.title
                                  ),
                                  item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                                    'span',
                                    { className: 'vip-goods' },
                                    '\u4F1A\u5458\u8D2D'
                                  )
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-title-dec' },
                                  data.customFeature.sale !== false ? _react2.default.createElement(
                                    'span',
                                    null,
                                    '\u9500\u91CF\uFF1A',
                                    item.sales
                                  ) : _react2.default.createElement('span', null)
                                ),
                                !!item.is_vip_goods && _react2.default.createElement(
                                  'div',
                                  { className: 'vip_goods_price' },
                                  _react2.default.createElement(
                                    'span',
                                    { style: { marginRight: '.08rem' } },
                                    _react2.default.createElement(
                                      'span',
                                      { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                      '\xA5'
                                    ),
                                    item.vip_price
                                  ),
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'vip_goods_tips' },
                                    '\u4F1A\u5458\u4EF7'
                                  )
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-item-bottom', style: {
                                      paddingTop: '0',
                                      marginTop: item.is_vip_goods ? '.26rem' : '.60rem'
                                    } },
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'waimai-price-per' },
                                    _react2.default.createElement(
                                      'span',
                                      { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                      '\xA5'
                                    ),
                                    item.price
                                  ),
                                  !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00') && _react2.default.createElement(
                                    'span',
                                    { style: {
                                        textDecoration: 'line-through',
                                        fontSize: '.22rem',
                                        color: '#999'
                                      } },
                                    '\xA5',
                                    item.virtual_price
                                  ),
                                  _react2.default.createElement(
                                    'label',
                                    { className: 'waimai-number-change' },
                                    !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && _react2.default.createElement('label', { className: 'waimai-count-minus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                        _this3.verticalListListMinus(e);e.stopPropagation();
                                      }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                                    data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                      'span',
                                      { className: 'waimai-number' },
                                      data.goods_data_list[item.id].totalNum
                                    ),
                                    !item.goods_model && _react2.default.createElement('label', { className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''), 'data-goodsid': item.id, onClick: function onClick(e) {
                                        _this3.verticalListListPlus(e);e.stopPropagation();
                                      }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                                    !!item.goods_model && _react2.default.createElement(
                                      'label',
                                      { className: 'waimai-count-model-plus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                          _this3.verticalListListPlus(e);e.stopPropagation();
                                        }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time },
                                      '\u9009\u89C4\u683C'
                                    )
                                  )
                                )
                              )
                            )
                          )
                        ),
                        data.customFeature['listArrange'] == '1' && _react2.default.createElement(
                          'div',
                          { className: 'waimai-list-mode2' },
                          !(!data.customFeature.showIntegral && item.integral === '1') && _react2.default.createElement(
                            'div',
                            { 'data-id': item.id, 'data-compindex': _this3.props.index },
                            _react2.default.createElement(
                              'div',
                              { className: 'inner-mode2-content' },
                              _react2.default.createElement(
                                'div',
                                { className: 'image-content' },
                                _react2.default.createElement('img', { className: 'waimai-mode2-img', src: item.cover, onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': cate.source }),
                                !!(data.customFeature.isShowStock && item.stock < 6) && _react2.default.createElement(
                                  'label',
                                  { className: 'goods-stock' },
                                  '\u4EC5\u5269',
                                  item.stock,
                                  '\u4EF6'
                                ),
                                !!+item.corner_mark && _react2.default.createElement('img', { className: 'new-goods', src: item.corner_url })
                              ),
                              _react2.default.createElement(
                                'div',
                                { style: { width: 'initial' }, className: 'waimai-title waimai-mode2-title' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-title-mode2-text', onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': cate.source },
                                  item.max_can_use_integral > 0 && _react2.default.createElement(
                                    'span',
                                    { className: 'jifen' },
                                    '\u79EF'
                                  ),
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'text' },
                                    item.title
                                  ),
                                  item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                                    'span',
                                    { className: 'vip-goods' },
                                    '\u4F1A\u5458\u8D2D'
                                  )
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-title-mode2-dec' },
                                  data.customFeature.sale !== false && _react2.default.createElement(
                                    'span',
                                    null,
                                    '\u9500\u91CF\uFF1A',
                                    item.sales
                                  )
                                ),
                                !!item.is_vip_goods && _react2.default.createElement(
                                  'div',
                                  { className: 'vip_goods_price' },
                                  _react2.default.createElement(
                                    'span',
                                    { style: { marginRight: '.08rem' } },
                                    _react2.default.createElement(
                                      'span',
                                      { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                      '\xA5'
                                    ),
                                    item.vip_price
                                  ),
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'vip_goods_tips' },
                                    '\u4F1A\u5458\u4EF7'
                                  )
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'waimai-item-bottom', style: {
                                      paddingTop: '0',
                                      marginTop: item.is_vip_goods ? '.02rem' : '.36rem'
                                    } },
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'waimai-price-per' },
                                    _react2.default.createElement(
                                      'span',
                                      { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                      '\xA5'
                                    ),
                                    item.price
                                  ),
                                  !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00') && _react2.default.createElement(
                                    'span',
                                    { style: {
                                        textDecoration: 'line-through',
                                        fontSize: '.22rem',
                                        color: '#999'
                                      } },
                                    '\xA5',
                                    item.virtual_price
                                  ),
                                  _react2.default.createElement(
                                    'label',
                                    { className: 'waimai-number-change' },
                                    !item.goods_model && _react2.default.createElement(
                                      'label',
                                      { className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''), 'data-goodsid': item.id, onClick: function onClick(e) {
                                          _this3.verticalListListPlus(e);e.stopPropagation();
                                        }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time },
                                      data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                        'label',
                                        null,
                                        data.goods_data_list[item.id].totalNum
                                      )
                                    ),
                                    !!item.goods_model && _react2.default.createElement(
                                      'label',
                                      { className: 'waimai-count-model-plus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                          _this3.verticalListListPlus(e);e.stopPropagation();
                                        }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time },
                                      '\u9009\u89C4\u683C',
                                      data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                                        'label',
                                        null,
                                        data.goods_data_list[item.id].totalNum
                                      )
                                    )
                                  )
                                )
                              )
                            )
                          )
                        )
                      );
                    })
                  );
                }),
                _react2.default.createElement('div', { style: { height: '3.00rem' } })
              )
            )
          ),
          !!data.showSearch && _react2.default.createElement(
            'div',
            { className: 'element waimai waimai-container-wrap searchResult', 'data-compindex': this.props.index },
            _react2.default.createElement(
              _ScrollView.ScrollView,
              (_React$createElement3 = { 'scroll-y': 'true', 'data-compindex': this.props.index, style: { height: 'calc(' + data.searchHeight + 'px ' + (data.customFeature.is_together ? '- .20rem' : '- 0em') + (isShowBottom ? ' - .98rem' : '') + '})' } }, (0, _defineProperty3.default)(_React$createElement3, 'data-compindex', this.props.index), (0, _defineProperty3.default)(_React$createElement3, 'bindscrolltolower', 'verticalListSearchScrollFunc'), _React$createElement3),
              data.show_goods_data['searchResult'] && data.show_goods_data['searchResult'].map(function (item, index) {
                var _React$createElement2;

                return _react2.default.createElement(
                  'div',
                  { key: index, 'data-id': item.id, 'data-compindex': _this3.props.index, className: 'clearfix', style: { padding: '.20rem' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'inner-content' },
                    _react2.default.createElement('img', { className: 'waimai-img', src: item.cover, onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index, 'data-category': item.source, 'data-is_search': 'search' }),
                    !!(data.customFeature.isShowStock && item.stock < 6) && _react2.default.createElement(
                      'label',
                      { className: 'goods-stock' },
                      '\u4EC5\u5269',
                      item.stock,
                      '\u4EF6'
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { width: 'initial' }, className: 'waimai-title' },
                      _react2.default.createElement(
                        'div',
                        (_React$createElement2 = { className: 'waimai-title-text', onClick: _this3.showVerticalListGoodsDetail, 'data-id': item.id }, (0, _defineProperty3.default)(_React$createElement2, 'data-id', item.id), (0, _defineProperty3.default)(_React$createElement2, 'data-compindex', _this3.props.index), (0, _defineProperty3.default)(_React$createElement2, 'data-index', index), (0, _defineProperty3.default)(_React$createElement2, 'data-category', item.source), (0, _defineProperty3.default)(_React$createElement2, 'data-is_search', 'search'), _React$createElement2),
                        item.max_can_use_integral > 0 && _react2.default.createElement(
                          'span',
                          { className: 'jifen' },
                          '\u79EF'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'text' },
                          item.title
                        ),
                        item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                          'span',
                          { className: 'vip-goods' },
                          '\u4F1A\u5458\u8D2D'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'waimai-title-dec' },
                        data.customFeature.sale !== false ? _react2.default.createElement(
                          'span',
                          null,
                          '\u9500\u91CF\uFF1A',
                          item.sales
                        ) : _react2.default.createElement('span', null)
                      ),
                      !!item.is_vip_goods && _react2.default.createElement(
                        'div',
                        { className: 'vip_goods_price' },
                        _react2.default.createElement(
                          'span',
                          { style: { marginRight: '.08rem' } },
                          _react2.default.createElement(
                            'span',
                            { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                            '\xA5'
                          ),
                          item.vip_price
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'vip_goods_tips' },
                          '\u4F1A\u5458\u4EF7'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'waimai-item-bottom', style: {
                            paddingTop: '0',
                            marginTop: item.is_vip_goods ? '.0rem' : '.60rem'
                          } },
                        _react2.default.createElement(
                          'span',
                          { className: 'waimai-price-per' },
                          _react2.default.createElement(
                            'span',
                            { style: { fontSize: '.24rem', fontWeight: 'normal' } },
                            '\xA5'
                          ),
                          item.price
                        ),
                        !!(data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00') && _react2.default.createElement(
                          'span',
                          { style: {
                              fontSize: '.28rem',
                              color: '#666666',
                              textDecoration: 'line-through'
                            } },
                          '\xA5',
                          item.virtual_price
                        ),
                        _react2.default.createElement(
                          'label',
                          { className: 'waimai-number-change' },
                          !!(data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together) && _react2.default.createElement('label', { className: 'waimai-count-minus', 'data-goodsid': item.id, onClick: function onClick(e) {
                              _this3.verticalListListMinus(e);e.stopPropagation();
                            }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                          data.goods_data_list[item.id].totalNum > 0 && _react2.default.createElement(
                            'span',
                            { className: 'waimai-number' },
                            data.goods_data_list[item.id].totalNum
                          ),
                          !item.goods_model && _react2.default.createElement('label', { className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''), 'data-goodsid': item.id, onClick: function onClick(e) {
                              _this3.verticalListListPlus(e);e.stopPropagation();
                            }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time }),
                          !!item.goods_model && _react2.default.createElement(
                            'label',
                            { className: 'waimai-count-model-plus', 'data-goodsid': item.id, onClick: function onClick(e) {
                                _this3.verticalListListPlus(e);e.stopPropagation();
                              }, 'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index, 'data-model': item.goods_model, 'data-is-in-business': item.is_in_business_time },
                            '\u9009\u89C4\u683C'
                          )
                        )
                      )
                    )
                  )
                );
              }),
              data.searchLoading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
              !!(data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length > 0) && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
              !!(data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length == 0) && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: '暂无数据~' } })
            )
          ),
          !!(data.selected == 1 || data.showSearch) && _react2.default.createElement(
            'div',
            { className: 'goods-bottom-opt',
              style: {
                bottom: isShowBottom ? '1.18rem' : '.20rem'
              },
              'data-compindex': this.props.index, onClick: function onClick(e) {
                _this3.verticalListShowShoppingCartPop(e);e.stopPropagation();
              } },
            _react2.default.createElement(
              'div',
              { className: 'shoppingcart-total-money' },
              _react2.default.createElement(
                'div',
                { className: 'shopping-cart-wrap' },
                _react2.default.createElement('label', { className: 'ico-moon icon-fn-cart', 'data-compindex': this.props.index, onClick: function onClick(e) {
                    _this3.verticalListShowShoppingCartPop(e);e.stopPropagation();
                  } }),
                data.TotalNum != 0 && _react2.default.createElement(
                  'label',
                  { className: 'waimai-count' },
                  data.TotalNum
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shopping-money-wrap' },
                data.TotalPrice != 0 ? _react2.default.createElement(
                  'div',
                  { className: 'shopping-money-price' },
                  _react2.default.createElement(
                    'span',
                    { style: {
                        marginRight: '.06rem'
                      } },
                    '\xA5'
                  ),
                  data.TotalPrice
                ) : _react2.default.createElement(
                  'div',
                  { className: 'classname', style: {
                      color: '#9b9b9d',
                      lineHeight: '.88rem'
                    } },
                  '\u8BF7\u9009\u62E9\u5546\u54C1'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'button',
                { className: 'sure-waimai-order ' + (data.TotalNum == 0 ? 'disabledBtn' : ''), onClick: function onClick(e) {
                    _this3.verticalListSettlement(e);e.stopPropagation();
                  }, 'data-compindex': this.props.index },
                '\u53BB\u7ED3\u7B97'
              )
            )
          ),
          !data.showSearch && data.selected == 2 && _react2.default.createElement(
            'div',
            { className: 'verticalList-shop-evaluate' },
            !!(data.assessList && data.assessList.length > 0 || data.moreAssess) && _react2.default.createElement(
              _ScrollView.ScrollView,
              { style: {
                  height: 'calc(' + data.heightPx + 'px ' + (data.infoHeight ? '' : '- ' + (data.shopHeight || 0) + 'px') + ' - .90rem' + (isShowBottom ? ' - .98rem' : '') + ')'
                }, 'scroll-y': true },
              _react2.default.createElement('div', { style: {
                  width: '100%',
                  height: '.12rem',
                  background: '#F3F3F3'
                } }),
              _react2.default.createElement(
                'div',
                { style: {
                    padding: '.30rem',
                    display: 'flex',
                    justifyContent: 'space-between'
                  } },
                _react2.default.createElement(
                  'div',
                  { className: 'verticalList-assess-btn ' + (data.assessActive == 0 ? 'active' : ''), 'data-active': '0', 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListChangeAssessType(e);e.stopPropagation();
                    } },
                  '\u6709\u56FE(',
                  data.assessNum[4] || 0,
                  ')'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'verticalList-assess-btn ' + (data.assessActive == 1 ? 'active' : ''), 'data-active': '1', 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListChangeAssessType(e);e.stopPropagation();
                    } },
                  '\u597D\u8BC4(',
                  data.assessNum[1] || 0,
                  ')'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'verticalList-assess-btn ' + (data.assessActive == 2 ? 'active' : ''), 'data-active': '2', 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListChangeAssessType(e);e.stopPropagation();
                    } },
                  '\u4E2D\u8BC4(',
                  data.assessNum[2] || 0,
                  ')'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'verticalList-assess-btn ' + (data.assessActive == 3 ? 'active' : ''), 'data-active': '3', 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListChangeAssessType(e);e.stopPropagation();
                    } },
                  '\u5DEE\u8BC4(',
                  data.assessNum[3] || 0,
                  ')'
                )
              ),
              data.showAssess && data.showAssess.map(function (item, i) {
                return _react2.default.createElement(
                  'div',
                  { key: i, className: 'verticalListAssessList' },
                  _react2.default.createElement('img', { src: item.buyer_headimgurl }),
                  _react2.default.createElement(
                    'div',
                    { className: 'assessInfoTop' },
                    _react2.default.createElement(
                      'div',
                      { className: 'verticalListNickname' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tackoutNickText' },
                        item.buyer_nickname
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: ' pull-right' },
                        item.add_time
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'verticalListService' },
                      '\u5546\u5BB6\u670D\u52A1\uFF1A',
                      _react2.default.createElement('label', { className: 'ico-moon icon-satisfied ' + (item.assess_info.level == 1 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 1 ? 'active' : '' },
                        ' \u6EE1\u610F'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: { color: '#9b9b9b', margin: '0 .09rem' } },
                        '|'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-satisfied ' + (item.assess_info.level == 2 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 2 ? 'active' : '' },
                        ' \u4E00\u822C'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: { color: '#9b9b9b', margin: '0 .09rem' } },
                        '|'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-satisfied ' + (item.assess_info.level == 3 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 3 ? 'active' : '' },
                        ' \u4E0D\u6EE1\u610F'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'verticalList-assess-title' },
                    _react2.default.createElement(
                      'span',
                      { className: 'verticalList-assess-goodsTitle' },
                      item.goods_info.title,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'verticalList-assess-goodsContent' },
                      item.assess_info.content
                    )
                  ),
                  !!item.assess_info.has_img && _react2.default.createElement(
                    'div',
                    { style: { marginLeft: '.74rem' } },
                    item.assess_info.img_arr && item.assess_info.img_arr.map(function (imgs, index) {
                      return _react2.default.createElement('img', { key: index, 'data-imgarr': JSON.stringify(item.assess_info.img_arr), 'data-src': imgs, src: imgs, onClick: function onClick(e) {
                          _this3.previewImage(e);e.stopPropagation();
                        } });
                    })
                  )
                );
              }),
              !!data.moreAssess && _react2.default.createElement(
                'div',
                { className: 'getMoreAssess', onClick: this.verticalListGetMoreAssess, 'data-compindex': this.props.index, 'data-nextpage': data.assessCurrentPage + 1 },
                '\u67E5\u770B\u66F4\u591A',
                _react2.default.createElement('label', { className: 'ico-moon icon-downarrow' })
              ),
              !data.moreAssess && _react2.default.createElement(
                'div',
                { className: 'getMoreAssess' },
                data.assessList.length ? '已经到底啦' : '暂无评价'
              )
            ),
            !!(!data.moreAssess && !(data.assessList && data.assessList.length)) && _react2.default.createElement(
              'div',
              { className: 'noMoreAssess' },
              _react2.default.createElement('img', { mode: 'aspectFit', src: 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png' }),
              _react2.default.createElement(
                'div',
                { className: 'getMoreAssess', style: { background: '#fff' } },
                '\u6682\u65E0\u4EFB\u4F55\u8BC4\u4EF7'
              )
            )
          ),
          !data.showSearch && data.selected == 3 && _react2.default.createElement(
            'div',
            { className: 'tokeout-shop-info', style: {
                padding: '0'
              } },
            _react2.default.createElement(
              'div',
              { style: { fontSize: '.26rem', color: '#333333' } },
              _react2.default.createElement(
                'div',
                { className: 'info-title', style: { fontSize: '.30rem' } },
                '\u5546\u5BB6\u4FE1\u606F'
              ),
              _react2.default.createElement(
                'div',
                { className: 'info-shopInfo' },
                _react2.default.createElement(
                  'div',
                  { className: 'info-adress', onClick: function onClick(e) {
                      _this3.openVerticalListLocation(e);e.stopPropagation();
                    }, 'data-name': data.shopInfo.title, 'data-address': data.shopInfo.address_detail, 'data-lat': data.shopInfo.latitude, 'data-lng': data.shopInfo.longitude },
                  _react2.default.createElement('label', { className: 'ico-moon icon-fesadress' }),
                  _react2.default.createElement(
                    'span',
                    null,
                    data.shopInfo.address_detail
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { onClick: function onClick(e) {
                      _app.appMethod.callPhone(e);e.stopPropagation();
                    }, 'data-phone': data.shopInfo.service_phone, className: 'info-takeout-phone' },
                  _react2.default.createElement('label', { className: 'ico-moon icon-fn-phone', style: { marginRight: '0', fontSize: '.40rem', color: '#d2d2d2' } })
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { width: 'auto', overflow: 'hidden', margin: '0 .26rem', padding: '.26rem 0', borderBottom: '.02rem solid #F3F3F3' } },
                _react2.default.createElement('label', { className: 'ico-moon icon-tokeout-info', style: { float: 'left', marginTop: '.08rem' } }),
                _react2.default.createElement(
                  'span',
                  { style: { width: '6.50rem', whiteSpace: 'normal' } },
                  data.shopInfo.store_desc
                )
              )
            ),
            !!(data.shopInfo.shop_environment && data.shopInfo.shop_environment.length > 0) && _react2.default.createElement('div', { className: 'cutoffLine', style: { backgroundColor: '#f3f3f3', marginBottom: '0rem', paddingBottom: '0rem', height: '.16rem' } }),
            !!(data.shopInfo.shop_environment && data.shopInfo.shop_environment.length > 0) && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'info-title' },
                '\u5E97\u94FA\u98CE\u91C7'
              ),
              _react2.default.createElement(
                'div',
                { className: 'info-mien', style: { whiteSpace: 'nowrap', overflowX: 'auto' } },
                data.shopInfo.shop_environment && data.shopInfo.shop_environment.map(function (imgs, index) {
                  return _react2.default.createElement('img', { key: index, 'data-imgarr': JSON.stringify(data.shopInfo.shop_environment), 'data-src': imgs, src: imgs, onClick: function onClick(e) {
                      _this3.previewImage(e);e.stopPropagation();
                    } });
                })
              )
            )
          ),
          !!data.goodsDetailShow && _react2.default.createElement(
            'div',
            { className: 'takeout-goods-picture', 'data-compindex': this.props.index },
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: '1.20rem' } },
              _react2.default.createElement(
                'div',
                { className: 'takeout-goods-pic' },
                _react2.default.createElement('label', { className: 'ico-moon icon-closes', 'data-compindex': this.props.index, onClick: this.verticalListHideDetailPop }),
                !!data.goodsDetail.img_urls.length ? _react2.default.createElement(
                  _carousel2.default,
                  {
                    dots: true,
                    infinite: true,
                    autoplay: true,
                    autoplayInterval: 5000
                  },
                  data.goodsDetail.img_urls.map(function (item, index) {
                    return _react2.default.createElement('img', {
                      key: index,
                      src: item
                    });
                  })
                ) : _react2.default.createElement('img', { src: data.goodsDetail.cover, mode: 'aspectFit' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'goods-info', style: { borderBottom: data.goodsDetail.description ? '.02rem solid #F3F3F3' : 'none' } },
                _react2.default.createElement(
                  'div',
                  { className: 'goods-detail-title' },
                  _react2.default.createElement(
                    'span',
                    { className: 'text' },
                    data.goodsDetail.title
                  ),
                  data.goodsDetail.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                    'span',
                    { className: 'vip-goods' },
                    '\u4F1A\u5458\u8D2D'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-sales-detail' },
                  data.customFeature.sale !== false && _react2.default.createElement(
                    'span',
                    { style: { marginRight: '.16rem' } },
                    '\u9500\u91CF',
                    data.goodsDetail.sales,
                    '\u4EFD'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'waimai-title clearfix', style: { position: 'relative' } },
                  !data.goodsDetail.is_vip_goods ? _react2.default.createElement(
                    'span',
                    { style: { marginRight: '.18rem', color: '#FF6500', fontSize: '.32rem' } },
                    '\xA5',
                    data.goodsDetail.price
                  ) : _react2.default.createElement(
                    'div',
                    { className: 'goodsDetail_vip_goods' },
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_vip_price' },
                      '\xA5',
                      data.goodsDetail.vip_price
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_vip_text' },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_price' },
                      '\xA5',
                      data.goodsDetail.price
                    )
                  ),
                  data.customFeature.isShowVirtualPrice && data.goodsDetail.virtual_price != '0.00' && _react2.default.createElement(
                    'span',
                    { style: { color: '#666666', fontSize: '.28rem', textDecoration: 'line-through' } },
                    '\xA5',
                    data.goodsDetail.virtual_price
                  ),
                  _react2.default.createElement(
                    'label',
                    { className: 'waimai-number-change', style: { top: '-.08rem' } },
                    !!(data.goods_data_list[data.goodsDetail.id].totalNum > 0 && !data.customFeature.is_together) && _react2.default.createElement('label', { className: 'waimai-count-minus', 'data-goodsid': data.goodsDetail.id, onClick: function onClick(e) {
                        _this3.verticalListListMinus(e);e.stopPropagation();
                      }, 'data-stock': data.goods_data_list[data.goodsDetail.id].stock,
                      'data-compindex': this.props.index, 'data-model': data.goodsDetail.goods_model, 'data-is-in-business': data.goodsDetail.is_in_business_time }),
                    data.goods_data_list[data.goodsDetail.id].totalNum > 0 && _react2.default.createElement(
                      'span',
                      { className: 'waimai-number' },
                      data.goods_data_list[data.goodsDetail.id].totalNum
                    ),
                    !data.goodsDetail.goods_model && _react2.default.createElement('label', { className: 'waimai-count-plus ' + (data.goods_data_list[data.goodsDetail.id].totalNum >= data.goods_data_list[data.goodsDetail.id].stock ? 'disabled' : ''), 'data-goodsid': data.goodsDetail.id, onClick: function onClick(e) {
                        _this3.verticalListListPlus(e);e.stopPropagation();
                      },
                      'data-stock': data.goods_data_list[data.goodsDetail.id].stock, 'data-compindex': this.props.index, 'data-model': data.goodsDetail.goods_model, 'data-is-in-business': data.goodsDetail.is_in_business_time }),
                    !!data.goodsDetail.goods_model && _react2.default.createElement(
                      'label',
                      { className: 'waimai-count-model-plus', 'data-goodsid': data.goodsDetail.id, onClick: function onClick(e) {
                          _this3.verticalListListPlus(e);e.stopPropagation();
                        }, 'data-stock': data.goods_data_list[data.goodsDetail.id].stock, 'data-compindex': this.props.index, 'data-model': data.goodsDetail.goods_model, 'data-is-in-business': data.goodsDetail.is_in_business_time },
                      '\u9009\u89C4\u683C'
                    )
                  )
                )
              ),
              !!data.goodsDetail.description && _react2.default.createElement(
                'div',
                { className: 'goods-desc' },
                _react2.default.createElement(
                  'div',
                  { style: { color: '#323232', fontSize: '.26rem', marginBottom: '.16rem' } },
                  '\u5546\u54C1\u63CF\u8FF0'
                ),
                _react2.default.createElement('div', { className: 'rich-text', dangerouslySetInnerHTML: { __html: data.goodsDetail.des && data.goodsDetail.des.replace(/href=".*?"/g, '') } })
              ),
              data.goodsDetail.goodsAssess.count > 0 && _react2.default.createElement(
                'div',
                { className: 'goods-evaluate' },
                _react2.default.createElement(
                  'div',
                  { className: 'evaluate-title' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8BC4\u4EF7'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'evaluate-count pull-right', style: { color: '#999999' } },
                    data.goodsDetail.goodsAssess.count,
                    '\u6761\u8BC4\u4EF7'
                  )
                ),
                data.goodsDetail.goodsAssess.data && data.goodsDetail.goodsAssess.data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'evaluate-info' },
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-userInfo' },
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-pic' },
                        _react2.default.createElement('img', { src: item.buyer_headimgurl })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'evaluate-userInfo-nickname' },
                          item.buyer_nickname
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'evaluate-userInfo-time' },
                          item.add_time
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-desc' },
                      _react2.default.createElement(
                        'div',
                        { className: 'assess' },
                        item.assess_info.content
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-pics' },
                      item.assess_info.i_arr && item.assess_info.i_arr.map(function (imgs, index) {
                        return _react2.default.createElement('img', { key: index, 'data-imgarr': JSON.stringify(item.assess_info.img_arr), 'data-src': imgs, src: imgs, onClick: function onClick(e) {
                            _this3.previewImage(e);e.stopPropagation();
                          } });
                      })
                    )
                  );
                }),
                data.goodsDetail.goodsAssess.is_more == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
                data.goodsDetail.goodsAssess.is_more == 1 && _react2.default.createElement(
                  'div',
                  { className: 'request-all', 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListGetMoreGoodsAssess(e);e.stopPropagation();
                    } },
                  '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
                )
              )
            )
          ),
          !!data.goodsModelShow && _react2.default.createElement(
            'div',
            { className: 'takeout-model-choose', 'data-compindex': this.props.index, onClick: this.verticalListHideModelPop },
            _react2.default.createElement(
              'div',
              {
                onClick: this.stopPropagation
              },
              _react2.default.createElement(
                'div',
                { className: 'takeout-title' },
                data.goods_data_list[data.modelGoodsId].model.name,
                _react2.default.createElement(
                  'div',
                  { className: 'takeout-title-close', 'data-compindex': this.props.index, onClick: this.verticalListHideModelPop },
                  _react2.default.createElement('span', { className: 'ico-moon icon-closes' })
                )
              ),
              _react2.default.createElement(
                _ScrollView.ScrollView,
                { style: { paddingLeft: '.40rem', height: '4.84rem', width: '6.10rem' }, 'scroll-y': true },
                data.goods_data_list[data.modelGoodsId].model.modelData && data.goods_data_list[data.modelGoodsId].model.modelData.map(function (goodsItems, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      { className: '', style: { paddingTop: '.30rem', paddingBottom: '.20rem', color: '#666', fontSize: '.26rem' } },
                      goodsItems.name,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'model-btn' },
                      goodsItems.subModelName && goodsItems.subModelName.map(function (item, i) {
                        return _react2.default.createElement(
                          'span',
                          { key: i, className: 'attr-btn ' + (goodsItems.subModelId[i] == data.modelIdArr[index] ? 'active' : ''), 'data-id': goodsItems.subModelId[i], 'data-goodsid': data.modelGoodsId, 'data-index': i, 'data-parentindex': index,
                            'data-modelname': item, 'data-compindex': _this3.props.index, onClick: function onClick(e) {
                              _this3.verticalListChooseModel(e);e.stopPropagation();
                            } },
                          item
                        );
                      })
                    )
                  );
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'takeoutGoodsModelBtn' },
                _react2.default.createElement(
                  'span',
                  { style: { paddingLeft: '.40rem' } },
                  _react2.default.createElement(
                    'span',
                    { style: { fontSize: '.24rem', fontWeight: 'normal', marginRight: '.10rem' } },
                    '\xA5'
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    data.modelPrice
                  ),
                  !!data.modelNum && _react2.default.createElement(
                    'span',
                    { style: { fontSize: '.32rem', color: '#000', fontWeight: 'normal' } },
                    ' (',
                    data.modelNum,
                    ')'
                  )
                ),
                !!(data.modelPrice > 0 && data.isModelPrice) && _react2.default.createElement(
                  'span',
                  { className: 'modle_vip_text' },
                  '\u4F1A\u5458\u4EF7'
                ),
                !data.modelNum && _react2.default.createElement(
                  'div',
                  { 'data-modelprice': data.modelPrice, 'data-goodsid': data.clickGoodsId, 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListSureChooseModel(e);e.stopPropagation();
                    }, style: { background: data.modelChoose.length > 0 && data.modelChoose.length == data.modelIdArr.length ? '#ff7100' : '#aaaaaa' } },
                  data.modelChoose.length > 0 && data.modelChoose.length == data.modelIdArr.length ? "加入购物车" : "请选择规格"
                ),
                !!data.modelNum && _react2.default.createElement(
                  'div',
                  { className: 'cart-btn', style: { background: 'none' } },
                  !data.customFeature.is_together && _react2.default.createElement('label', { className: 'takeout-count-minus', onClick: function onClick(e) {
                      _this3.verticalListMinuModel(e);e.stopPropagation();
                    }, 'data-modelprice': data.modelPrice, 'data-goodsid': data.clickGoodsId, 'data-compindex': this.props.index }),
                  _react2.default.createElement('input', { type: 'text', style: { width: '.60rem', display: 'inline-block', verticalAlign: 'middle', color: '#000' }, disabled: 'disabled', value: data.modelNum }),
                  _react2.default.createElement('label', { className: 'takeout-count-plus ' + ((data.mdelInfo && data.mdelInfo.totalNum) >= (data.modelInfo && data.mdelInfo.stock) ? 'disabled' : ''), 'data-modelprice': data.modelPrice, 'data-goodsid': data.clickGoodsId, 'data-compindex': this.props.index, onClick: function onClick(e) {
                      _this3.verticalListSureChooseModel(e);e.stopPropagation();
                    } })
                )
              )
            )
          ),
          !!(data.shoppingCartShow && !data.customFeature.is_together) && _react2.default.createElement(
            'div',
            { className: 'verticalList-shopping-carts-list', 'data-compindex': this.props.index, onClick: this.verticalListHideShoppingCart },
            _react2.default.createElement(
              'div',
              {
                onClick: this.stopPropagation,
                style: { maxHeight: 'calc(' + (data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 : (data.heightPx + 86) / 2) + 'px + .76rem)', height: 'auto' },
                className: 'carts-content' },
              _react2.default.createElement(
                'div',
                { className: 'chosen-title' },
                '\u5DF2\u9009\u5546\u54C1',
                !!+data.TotalNum && _react2.default.createElement(
                  'div',
                  { className: 'pull-right ico-moon icon-delete', onClick: function onClick(e) {
                      _this3.verticalListDeleteAllCarts(e);e.stopPropagation();
                    }, 'data-compindex': this.props.index, style: { display: 'inline-block', fontSize: '.26rem', fontWeight: '400', color: '#333', marginRight: '.50rem' } },
                  ' \u6E05\u7A7A'
                )
              ),
              +data.TotalNum === 0 && _react2.default.createElement(
                'div',
                { className: 'noGoods' },
                '\u6682\u672A\u9009\u8D2D\u5546\u54C1'
              ),
              _react2.default.createElement(
                _ScrollView.ScrollView,
                {
                  style: { maxHeight: 'calc(' + (data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 - 37 : (data.heightPx + 86) / 2 - 37) + 'px + .50rem)' },
                  'scroll-y': true },
                data.cartGoodsIdList && data.cartGoodsIdList.map(function (items, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    data.cartList[0][items] && Object.values(data.cartList[0][items]).map(function (item, i) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: i },
                        item.modelId != 0 ? !!+item.num && _react2.default.createElement(
                          'div',
                          { key: i, className: 'shopping-cart-list ' + (item.in_business_time == 0 ? 'gray' : ''), style: { margin: '0 .30rem' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-info' },
                            _react2.default.createElement(
                              'div',
                              { className: 'cart-title', style: { marginTop: '.30rem' } },
                              item.gooodsName
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'cart-model' },
                              item.modelName
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-price' },
                            !!item.is_vip_goods && _react2.default.createElement(
                              'span',
                              { className: 'cart_vip_tips' },
                              '\u4F1A\u5458'
                            ),
                            _react2.default.createElement(
                              'span',
                              null,
                              '\xA5',
                              item.totalPrice
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-btn' },
                            item.in_business_time != 0 ? _react2.default.createElement(
                              _react2.default.Fragment,
                              null,
                              _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''), onClick: function onClick(e) {
                                  _this3.verticalListCartListMinus(e);e.stopPropagation();
                                }, 'data-id': item.cart_id, 'data-modelid': item.modelId, 'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-index': '0',
                                'data-num': item.num, 'data-price': item.price }),
                              _react2.default.createElement('input', { type: 'text', style: { width: '.50rem', display: 'inline-block' }, disabled: 'disabled', value: item.num }),
                              !!(!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', { className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.num >= item.stock ? 'disabled' : ''), onClick: function onClick(e) {
                                  _this3.verticalListCartListPlus(e);e.stopPropagation();
                                }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-is-in-business': item.in_business_time, 'data-goodsid': item.id, 'data-index': '0', 'data-stock': item.stock, 'data-num': item.num, 'data-id': item.cart_id })
                            ) : _react2.default.createElement(
                              'span',
                              { className: 'delete-single-cart', onClick: function onClick(e) {
                                  _this3.deleteSingleCarts(e);e.stopPropagation();
                                }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id },
                              '\u5220\u9664'
                            )
                          )
                        ) : !!+item.num && _react2.default.createElement(
                          'div',
                          { className: 'shopping-cart-list', style: { margin: '0 .30rem' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-info' },
                            item.in_business_time != 0 ? _react2.default.createElement(
                              'div',
                              { className: 'cart-title', style: { lineHeight: '1.30rem' } },
                              item.gooodsName
                            ) : _react2.default.createElement(
                              _react2.default.Fragment,
                              null,
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-title', style: { marginTop: '.30rem' } },
                                item.gooodsName
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-model' },
                                '(\u4E0D\u5728\u51FA\u552E\u65F6\u95F4)'
                              )
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-price' },
                            !!item.is_vip_goods && _react2.default.createElement(
                              'span',
                              { className: 'cart_vip_tips' },
                              '\u4F1A\u5458'
                            ),
                            _react2.default.createElement(
                              'span',
                              null,
                              '\xA5',
                              item.totalPrice
                            )
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'cart-btn' },
                            item.in_business_time != 0 ? _react2.default.createElement(
                              _react2.default.Fragment,
                              null,
                              _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''), 'data-is-in-business': item.in_business_time, onClick: function onClick(e) {
                                  _this3.verticalListCartListMinus(e);e.stopPropagation();
                                }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-id': item.cart_id, 'data-index': '0',
                                'data-price': item.price, 'data-num': item.num }),
                              _react2.default.createElement('input', { type: 'text', style: { width: '.50rem', display: 'inline-block' }, disabled: 'disabled', value: item.num }),
                              !!(!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', { className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.num >= item.stock ? 'disabled' : ''), onClick: function onClick(e) {
                                  _this3.verticalListCartListPlus(e);e.stopPropagation();
                                }, 'data-modelid': item.modelId, 'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-num': item.num, 'data-index': '0', 'data-id': item.cart_id })
                            ) : _react2.default.createElement(
                              'span',
                              { className: 'delete-single-cart', onClick: function onClick(e) {
                                  _this3.deleteSingleCarts(e);e.stopPropagation();
                                }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id },
                              '\u5220\u9664'
                            )
                          )
                        )
                      );
                    })
                  );
                })
              )
            )
          ),
          !!(data.shoppingCartShow && data.customFeature.is_together) && _react2.default.createElement(
            'div',
            { className: 'verticalList-shopping-carts-list', 'data-compindex': this.props.index, onClick: this.verticalListHideShoppingCart, catchtouchmove: 'true' },
            _react2.default.createElement(
              'div',
              {
                onClick: this.stopPropagation,
                style: { maxHeight: 'calc(' + (data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 : (data.heightPx + 86) / 2) + 'px + .76rem)', height: 'auto' },
                className: 'carts-content' },
              _react2.default.createElement(
                _ScrollView.ScrollView,
                {
                  style: { maxHeight: 'calc(' + (data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 - 37 : (data.heightPx + 86) / 2 - 37) + 'px + .50rem)' },
                  'scroll-y': true
                },
                data.buyer_info && data.buyer_info.map(function (buyer, buyer_index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: buyer_index },
                    _react2.default.createElement(
                      'div',
                      { className: 'chosen-title', style: { borderRadius: buyer_index === 0 ? '.20rem .20rem 0 0' : null } },
                      _react2.default.createElement('img', { src: buyer.cover_thumb, className: 'cart_cover_thumb' }),
                      _react2.default.createElement(
                        'span',
                        { style: { verticalAlign: 'middle' } },
                        buyer.nickname,
                        buyer_index === 0 ? '（我）' : ''
                      ),
                      !!data.TotalNum && _react2.default.createElement(
                        'div',
                        { className: 'pull-right', onClick: function onClick(e) {
                            _this3.verticalListDeleteBuyerCarts(e);e.stopPropagation();
                          }, 'data-compindex': _this3.props.index, 'data-index': buyer_index, style: { display: 'inline-block', fontSize: '.26rem', fontWeight: '400', color: '#333', marginRight: '.50rem' } },
                        _react2.default.createElement('span', { className: 'ico-moon icon-delete', style: { verticalAlign: 'middle' } }),
                        _react2.default.createElement(
                          'span',
                          { style: { display: 'inline-block', verticalAlign: 'middle', marginLeft: '.06rem' } },
                          ' \u6E05\u7A7A'
                        )
                      )
                    ),
                    !!((data.cartGoodsIdList.length === 0 || data.myCartNum === 0) && buyer_index === 0) && _react2.default.createElement(
                      'div',
                      { className: 'noGoods' },
                      '\u6682\u672A\u9009\u8D2D\u5546\u54C1'
                    ),
                    data.cartGoodsIdList && data.cartGoodsIdList.map(function (cartid_item, cartid_index) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: cartid_index },
                        data.cartList[buyer_index][cartid_item] && [data.cartList[buyer_index][cartid_item]].map(function (item, goods_index) {
                          return _react2.default.createElement(
                            'div',
                            { key: goods_index },
                            item.modelId != 0 ? !!+item.num && _react2.default.createElement(
                              'div',
                              { key: cartid_index, className: 'shopping-cart-list ' + (item.in_business_time == 0 ? 'gray' : ''),
                                style: { margin: '0 .30rem' } },
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-info' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'cart-title', style: { marginTop: '.30rem' } },
                                  item.gooodsName
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'cart-model' },
                                  item.modelName
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-price' },
                                !!item.is_vip_goods && _react2.default.createElement(
                                  'span',
                                  { className: 'cart_vip_tips' },
                                  '\u4F1A\u5458'
                                ),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  '\xA5',
                                  item.totalPrice
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-btn' },
                                item.in_business_time != 0 ? _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''),
                                    onClick: function onClick(e) {
                                      _this3.verticalListCartListMinus(e);e.stopPropagation();
                                    }, 'data-id': item.cart_id, 'data-modelid': item.modelId,
                                    'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index,
                                    'data-goodsid': item.id, 'data-stock': item.stock, 'data-index': buyer_index, 'data-num': item.num,
                                    'data-price': item.price }),
                                  _react2.default.createElement('input', { type: 'text', style: { width: '.50rem', display: 'inline-block' }, disabled: 'disabled',
                                    value: item.num }),
                                  !!(!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', {
                                    className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.num >= item.stock ? 'disabled' : ''),
                                    onClick: function onClick(e) {
                                      _this3.verticalListCartListPlus(e);e.stopPropagation();
                                    }, 'data-id': item.cart_id, 'data-modelid': item.modelId,
                                    'data-compindex': _this3.props.index, 'data-is-in-business': item.in_business_time,
                                    'data-goodsid': item.id, 'data-index': buyer_index, 'data-stock': item.stock,
                                    'data-num': item.num })
                                ) : _react2.default.createElement(
                                  'span',
                                  { className: 'delete-single-cart', onClick: function onClick(e) {
                                      _this3.deleteSingleCarts(e);e.stopPropagation();
                                    }, 'data-modelid': item.modelId,
                                    'data-compindex': _this3.props.index, 'data-goodsid': item.id },
                                  '\u5220\u9664'
                                )
                              )
                            ) : !!+item.num && _react2.default.createElement(
                              'div',
                              { className: 'shopping-cart-list', style: { margin: '0 .30rem' } },
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-info' },
                                item.in_business_time != 0 ? _react2.default.createElement(
                                  'div',
                                  { className: 'cart-title', style: { lineHeight: '1.30rem' } },
                                  item.gooodsName
                                ) : _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'cart-title', style: { marginTop: '.30rem' } },
                                    item.gooodsName
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'cart-model' },
                                    '(\u4E0D\u5728\u51FA\u552E\u65F6\u95F4)'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-price' },
                                !!item.is_vip_goods && _react2.default.createElement(
                                  'span',
                                  { className: 'cart_vip_tips' },
                                  '\u4F1A\u5458'
                                ),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  '\xA5',
                                  item.totalPrice
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-btn' },
                                item.in_business_time != 0 ? _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''), 'data-is-in-business': item.in_business_time, 'data-id': item.cart_id, onClick: function onClick(e) {
                                      _this3.verticalListCartListMinus(e);e.stopPropagation();
                                    }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-index': buyer_index,
                                    'data-price': item.price, 'data-num': item.num }),
                                  _react2.default.createElement('input', { type: 'text', style: { width: '.50rem', display: 'inline-block' }, disabled: 'disabled', value: item.num }),
                                  !!(!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', { className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.num >= item.stock ? 'disabled' : ''), onClick: function onClick(e) {
                                      _this3.verticalListCartListPlus(e);e.stopPropagation();
                                    }, 'data-id': item.cart_id, 'data-modelid': item.modelId, 'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-num': item.num, 'data-index': buyer_index })
                                ) : _react2.default.createElement(
                                  'span',
                                  { className: 'delete-single-cart', onClick: function onClick(e) {
                                      _this3.deleteSingleCarts(e);e.stopPropagation();
                                    }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id },
                                  '\u5220\u9664'
                                )
                              )
                            )
                          );
                        })
                      );
                    })
                  );
                })
              )
            )
          ),
          !!data.showSettlementMask && _react2.default.createElement(
            'div',
            { className: 'settlement-mask' },
            _react2.default.createElement(
              'div',
              { className: 'settlement-box' },
              _react2.default.createElement(
                'div',
                { className: 'settlement-title' },
                '\u8BF7\u5206\u5F00\u7ED3\u7B97\u4EE5\u4E0B\u5546\u54C1'
              ),
              data.canUsePickUpType[1] && !!data.canUsePickUpType[1].cart_list.length && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-title' },
                      '\u5FEB\u9012\u5546\u54C1'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-express' },
                      '\u914D\u9001\u8D39',
                      data.canUsePickUpType[1].express_data && data.canUsePickUpType[1].express_data.express_fee,
                      '\u5143'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-count' },
                      '\u5171',
                      data.canUsePickUpType[1].goods_num,
                      '\u4EF6\uFF0C\u5408\u8BA1\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-price', style: { color: data.storeStyle && data.storeStyle.theme } },
                      '\xA5',
                      data.canUsePickUpType[1].goods_price
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    { 'data-type': '1', 'data-cart-id': data.canUsePickUpType[1].cart_list, className: 'settlement-btn', style: { color: data.storeStyle && data.storeStyle.theme, borderColor: data.storeStyle && data.storeStyle.theme }, onClick: function onClick(e) {
                        _this3.goodsPay(e);e.stopPropagation();
                      }, 'data-compindex': this.props.index },
                    '\u53BB\u7ED3\u7B97'
                  )
                )
              ),
              data.canUsePickUpType[3] && !!data.canUsePickUpType[3].cart_list.length && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-title' },
                      '\u4E0A\u95E8\u81EA\u63D0\u5546\u54C1'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-express' },
                      '\u914D\u9001\u8D390\u5143'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-count' },
                      '\u5171',
                      data.canUsePickUpType[3].goods_num,
                      '\u4EF6\uFF0C\u5408\u8BA1\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-price', style: { color: data.storeStyle && data.storeStyle.theme } },
                      '\xA5',
                      data.canUsePickUpType[3].goods_price
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    { 'data-type': '3', 'data-cart-id': data.canUsePickUpType[3].cart_list, className: 'settlement-btn', style: { color: data.storeStyle && data.storeStyle.theme, borderColor: data.storeStyle && data.storeStyle.theme }, onClick: function onClick(e) {
                        _this3.goodsPay(e);e.stopPropagation();
                      }, 'data-compindex': this.props.index },
                    '\u53BB\u7ED3\u7B97'
                  )
                )
              ),
              data.canUsePickUpType[2] && !!data.canUsePickUpType[2].cart_list.length && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content ' + (data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 ? 'no-achieve-intra-box' : '') },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-title' },
                      '\u540C\u57CE\u914D\u9001\u5546\u54C1'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-express' },
                      '\u914D\u9001\u8D39',
                      data.intraCityData.express_fee,
                      '\u5143'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-count' },
                      '\u5171',
                      data.canUsePickUpType[2].goods_num,
                      '\u4EF6\uFF0C\u5408\u8BA1\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-price', style: { color: data.storeStyle && data.storeStyle.theme } },
                      '\xA5',
                      data.canUsePickUpType[2].goods_price
                    )
                  ),
                  data.intraCityData.in_business_time != 1 ? _react2.default.createElement(
                    'div',
                    { className: 'no-achieve-intra', style: { color: data.storeStyle && data.storeStyle.theme } },
                    '\u5E97\u94FA\u5DF2\u6253\u70CA'
                  ) : data.intraCityData.is_enough_price != 1 ? _react2.default.createElement(
                    'div',
                    { className: 'no-achieve-intra', style: { color: data.storeStyle && data.storeStyle.theme } },
                    '\u672A\u8FBE\u5230\u8D77\u9001\u4EF7 \u8FD8\u5DEE',
                    data.intraCityData.min_deliver_price_balance,
                    '\u5143'
                  ) : data.intraCityData.in_distance != 1 ? _react2.default.createElement(
                    'div',
                    { className: 'no-achieve-intra', style: { color: data.storeStyle && data.storeStyle.theme } },
                    '\u4E0D\u5728\u914D\u9001\u8303\u56F4'
                  ) : null
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    { 'data-type': '2', 'data-cart-id': data.canUsePickUpType[2].cart_list, className: 'settlement-btn ' + (data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 || data.intraCityData.in_business_time != 1 ? 'no-achieve-intra-btn' : ''), style: { color: data.storeStyle && data.storeStyle.theme, borderColor: data.storeStyle && data.storeStyle.theme }, onClick: data.intraCityData.is_enough_price != 1 || data.intraCityData.in_distance != 1 || data.intraCityData.in_business_time != 1 ? null : function (e) {
                        _this3['goodsPay'](e);e.stopPropagation();
                      }, 'data-compindex': this.props.index },
                    '\u53BB\u7ED3\u7B97'
                  ),
                  data.intraCityData.in_business_time == 1 && data.intraCityData.is_enough_price == 1 && data.intraCityData.in_distance != 1 && _react2.default.createElement(
                    'div',
                    { className: 'settlement-btn', style: { marginLeft: '.20rem', color: data.storeStyle && data.storeStyle.theme, borderColor: data.storeStyle && data.storeStyle.theme }, onClick: function onClick(e) {
                        _this3.vlSelectGoodsSameJourney(e);e.stopPropagation();
                      }, 'data-compindex': this.props.index },
                    '\u4FEE\u6539\u5730\u5740'
                  )
                )
              ),
              data.canUsePickUpType[4] && !!data.canUsePickUpType[4].cart_list.length && _react2.default.createElement(
                'div',
                { className: 'settlement-type' },
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-type-content ' + (data.dining_data.in_business_time != 1 ? 'no-achieve-intra-box' : '') },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-title' },
                      '\u5802\u98DF\u70B9\u9910'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-count' },
                      '\u5171',
                      data.canUsePickUpType[4].goods_num,
                      '\u4EF6\uFF0C\u5408\u8BA1\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'settlement-type-price', style: { color: data.storeStyle && data.storeStyle.theme } },
                      '\xA5',
                      data.canUsePickUpType[4].goods_price
                    )
                  ),
                  data.dining_data.in_business_time != 1 && _react2.default.createElement(
                    'div',
                    { className: 'no-achieve-intra', style: { color: data.storeStyle && data.storeStyle.theme } },
                    '\u5E97\u94FA\u5DF2\u6253\u70CA'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'settlement-btn-box' },
                  _react2.default.createElement(
                    'div',
                    { 'form-type': 'submit', className: 'settlement-btn ' + (data.dining_data.in_business_time != 1 ? 'no-achieve-intra-btn' : ''), style: { color: data.storeStyle && data.storeStyle.theme, borderColor: data.storeStyle && data.storeStyle.theme }, onClick: data.dining_data.in_business_time != 1 ? null : function (e) {
                        _this3['goodsPay'](e);e.stopPropagation();
                      }, 'data-type': '4', 'data-cart-id': data.canUsePickUpType[4].cart_list, 'data-compindex': this.props.index },
                    '\u53BB\u7ED3\u7B97'
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'close-settlement-mask', 'data-compindex': this.props.index, onClick: function onClick(e) {
                  _this3.verticalListCloseSettlement(e);e.stopPropagation();
                } },
              '\u5173\u95ED'
            )
          ),
          data.shoppingCouponsList && _react2.default.createElement(
            'div',
            { className: 'takeout-shopping-carts-list coupons-list' },
            _react2.default.createElement(
              'div',
              { className: 'shop-info-detail' },
              _react2.default.createElement(
                _ScrollView.ScrollView,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'shop-name' },
                  data.shopInfo.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'shop-info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'content-text' },
                    '\u8425\u4E1A\u65F6\u95F4'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-deliver-content' },
                    data.shopInfo.business_time_str
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'shop-info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'content-text' },
                    '\u5E97\u94FA\u5730\u5740'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-deliver-content' },
                    data.shopInfo.address
                  )
                ),
                !!data.customFeature.isShowNotice && data.shopInfo.shop_notice && _react2.default.createElement(
                  'div',
                  { className: 'shop-info-content' },
                  _react2.default.createElement(
                    'div',
                    { className: 'content-text' },
                    '\u516C\u544A'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'info-deliver-content' },
                    '\u516C\u544A\uFF1A',
                    data.shopInfo.shop_notice
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'detail-close', 'data-compindex': this.props.index, onClick: this.verticalListHideCouponsList },
                _react2.default.createElement('label', { className: 'ico-moon icon-closes' })
              )
            )
          ),
          data.showVipDialog && _react2.default.createElement(
            'div',
            { className: 'verticalList-vipDialog', 'data-compindex': this.props.index, onClick: function onClick(e) {
                _this3.verticalListCloseVipDialog(e);e.stopPropagation();
              } },
            _react2.default.createElement(
              'div',
              { onClick: this.stopPropagation },
              _react2.default.createElement('label', { onClick: this.verticalListCloseVipDialog, className: 'ico-moon icon-closes', 'data-compindex': this.props.index }),
              _react2.default.createElement(
                'div',
                { className: 'vipCardUp' },
                _react2.default.createElement('img', { src: 'http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/vip_card_up.png' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'cardTips' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u60A8\u5F53\u524D\u7684\u4F1A\u5458\u5361\uFF0C\u6682\u65E0\u8D2D\u4E70\u8BE5\u5546\u54C1\u6743\u9650\uFF0C\u53EF\u5347\u7EA7\u4F1A\u5458\u5361'
                )
              ),
              _react2.default.createElement(
                _ScrollView.ScrollView,
                null,
                data.vipCondtionInfo && data.vipCondtionInfo.vip_card_data && data.vipCondtionInfo.vip_card_data.length > 0 && data.vipCondtionInfo.vip_card_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'cardContent' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-title' },
                      item.title,
                      '\u4F1A\u5458\u5361(V',
                      item.level,
                      ')\u8FBE\u6210\u6761\u4EF6\uFF1A'
                    ),
                    item.trade_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u7D2F\u8BA1\u4EA4\u6613\u6210\u529F',
                      item.trade_count,
                      '\u7B14'
                    ),
                    item.consume_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u6216\u7D2F\u8BA1\u6D88\u8D39\u91D1\u989D',
                      item.consume_count,
                      '\u5143'
                    ),
                    item.integral_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u6216\u7D2F\u8BA1\u79EF\u5206\u8FBE\u5230',
                      item.integral_count,
                      '\u7B14'
                    )
                  );
                }),
                data.vipCondtionInfo && data.vipCondtionInfo.paid_vip_card_data && data.vipCondtionInfo.paid_vip_card_data.length > 0 && data.vipCondtionInfo.paid_vip_card_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'cardContent' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-title' },
                      item.title,
                      '\u4F1A\u5458\u5361(V',
                      item.level,
                      ')\u8FBE\u6210\u6761\u4EF6\uFF1A'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u4EF7\u683C\uFF1A\u6BCF\u6708',
                      item.price
                    )
                  );
                })
              )
            )
          ),
          !!(data.customFeature.showScanCode && data.selected == 1) && _react2.default.createElement(
            'div',
            { className: 'scanCode', onClick: function onClick(e) {
                _this3.scanShopping(e);e.stopPropagation();
              }, onTouchMove: this.scanMove, 'data-compindex': this.props.index, style: { top: data.scanCode + 'px' } },
            _react2.default.createElement('span', { className: 'ico-moon icon-shopping-scan' }),
            _react2.default.createElement(
              'div',
              { className: 'scan-word' },
              '\u626B\u7801'
            )
          )
        )
      );
    }
  }]);
  return VerticalListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    var _pageInstance$setData;

    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var param = {};
    var that = _this4;
    //根据选择的配送方式获取对应的商品
    param['pick_up_type'] = [];
    if (customFeature.pickUpArr) {
      if (customFeature.is_together) {
        if (customFeature.pickUpArr.dining) {
          param.pick_up_type.push(4);
        }
      } else {
        if (customFeature.pickUpArr.express) {
          param.pick_up_type.push(1);
        }
        if (customFeature.pickUpArr.sameJourney) {
          param.pick_up_type.push(2);
        }
        if (customFeature.pickUpArr.selfLifting) {
          param.pick_up_type.push(3);
        }
        if (customFeature.pickUpArr.dining) {
          param.pick_up_type.push(4);
        }
      }
    }
    //pick_up_type 为空后台默认返回所有商品，
    if (param.pick_up_type.length === 0) {
      param.pick_up_type.push(0);
    }
    param.form = 'goods';
    param.is_count = 0;
    pageInstance.setData((_pageInstance$setData = {}, (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].pick_up_type', param.pick_up_type), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].buyer_info', []), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].user_list', []), _pageInstance$setData));
    compData.timer = null; //轮询定时器
    compData.loopRequest = true; //轮询接口是否完成
    compData.is_init = true; //首次需要重新渲染购物车
    compData.addCartComplete = true; //加购物车  成功后才拿到cart_id
    var franchisee_id = _app.appMethod.getPageFranchiseeId();
    if (franchisee_id) {
      compData.location_id = _app.appMethod.globalData[franchisee_id] ? _app.appMethod.globalData[franchisee_id].ec_location_id : '';
    } else {
      compData.location_id = _app.appMethod.globalData.ec_location_id || '';
    }
    _this4.verticalListCompsInit(compindex, pageInstance, param);
  };

  this.verticalListCompsInit = function (compindex, pageInstance, par) {
    var that = _this4;
    var param = par;
    pageInstance.returnToVerticalFlag = 0;
    var compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true;
    compData.flag = true;
    clearInterval(compData.timer);
    var newTostoreData = {};
    newTostoreData['eles[' + compindex + '].goodsDetailShow'] = false;
    newTostoreData['eles[' + compindex + '].goodsModelShow'] = false;
    newTostoreData['eles[' + compindex + '].hideSearchInput'] = false;
    if (pageInstance.data.page_hasNavBar) {
      newTostoreData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - _app.appMethod.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newTostoreData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100 - _app.appMethod.globalData.topNavBarHeight;
    } else {
      newTostoreData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newTostoreData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100;
    }
    newTostoreData['eles[' + compindex + '].selected'] = 1;
    newTostoreData['eles[' + compindex + '].customFeature.selected'] = 0;
    if (compData.TotalNum == undefined) {
      newTostoreData['eles[' + compindex + '].TotalNum'] = 0;
      newTostoreData['eles[' + compindex + '].TotalPrice'] = 0.00;
    }
    newTostoreData['eles[' + compindex + '].cartList'] = [{}];
    newTostoreData['eles[' + compindex + '].cartGoodsIdList'] = [];
    newTostoreData['eles[' + compindex + '].loading'] = true;
    newTostoreData['eles[' + compindex + '].loadingFail'] = false;
    if (compData.goods_data_list) {
      newTostoreData['eles[' + compindex + '].show_goods_data'] = {};
      newTostoreData['eles[' + compindex + '].goods_data_list'] = {};
    }
    newTostoreData['eles[' + compindex + '].categorySort'] = {};
    newTostoreData['eles[' + compindex + '].showSearch'] = false;
    newTostoreData['eles[' + compindex + '].goodsCateHeight'] = {}; // 每个分类的商品列表高度
    newTostoreData['eles[' + compindex + '].requestNum'] = 0;
    newTostoreData['eles[' + compindex + '].isChangeTab'] = 0;
    newTostoreData['eles[' + compindex + '].showSettlementMask'] = false;
    newTostoreData['eles[' + compindex + '].franchiseeId'] = _app.appMethod.getPageFranchiseeId() || '';
    pageInstance.setData(newTostoreData);
    pageInstance['verticalList' + compindex] || (pageInstance['verticalList' + compindex] = {});
    param['sort_key'] = '';
    param['sort_direction'] = 0;
    param['page'] = 1;
    param['page_size'] = 10;
    param['take_out_style'] = 1;
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      !compData.currentLocationData && !compData.selectSameJourney ? _this4.getCurrentLocation(compindex, pageInstance) : '';
    }
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        res.data ? res.data : res.data = {};
        var newdata = {};
        res.data ? res.data : res.data = {};
        var shopInfoData = res.data;
        if (!shopInfoData.app_store_data) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
            data: {
              pick_up_type: 4,
              sub_shop_app_id: sub_shop_app_id || ''
            },
            success: function success(res) {
              res.data ? res.data : res.data = {};
              var newdata = {};
              res.data ? res.data : res.data = {};
              var shopInfoData = res.data;
              newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
              newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
              newdata['eles[' + compindex + '].infoHeight'] = 0;
              pageInstance.setData(newdata, function () {
                _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
                  var animationData = {};
                  pageInstance['verticalList' + compindex]['shopInfoHeight'] || (pageInstance['verticalList' + compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
                  // let animation = app.createAnimation({
                  //   duration: 200,
                  //   timingFunction: 'linear'
                  // })
                  // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
                  // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
                  animationData['eles[' + compindex + '].shopHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
                  pageInstance.setData(animationData);
                });
              });
            }
          });
        } else {
          newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
          newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
          newdata['eles[' + compindex + '].infoHeight'] = 0;
          pageInstance.setData(newdata, function () {
            _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
              var animationData = {};
              pageInstance['verticalList' + compindex]['shopInfoHeight'] || (pageInstance['verticalList' + compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
              // let animation = app.createAnimation({
              //   duration: 200,
              //   timingFunction: 'linear'
              // })
              // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
              // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
              animationData['eles[' + compindex + '].shopHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
              pageInstance.setData(animationData);
            });
          });
        }
      }
    });

    if (compData.customFeature.databind && compData.customFeature.databind == 1) {
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/getGoodsCategory',
        method: 'post',
        data: {
          filter_null: 1,
          goods_type: 0,
          pick_up_type: compData.pick_up_type,
          sub_shop_app_id: _app.appMethod.getPageFranchiseeId() || ''
        },
        success: function success(res) {
          var content = [];
          var cateData = {};
          for (var i = 0; i < res.data.length; i++) {
            content.push({
              text: res.data[i].name,
              source: res.data[i].id,
              pic: res.data[i].logo
            });
          }
          cateData['eles[' + compindex + '].content'] = content;
          for (var j in content) {
            var cateParam = {};
            cateParam.param = {};
            Object.assign(cateParam.param, param);
            cateParam.param.idx_arr = {
              idx: 'category',
              idx_value: content[j].source == 'all' ? '' : content[j].source
            };
            cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
          }
          if (pageInstance.data.page_hasNavBar) {
            cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - _app.appMethod.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
            cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100 - _app.appMethod.globalData.topNavBarHeight;
          } else {
            cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
            cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100;
          }
          cateData['eles[' + compindex + '].route'] = pageInstance.route;
          pageInstance.setData(cateData);
          if (compData.content.length === 0) {
            return;
          }

          if (compData.customFeature.loadAllData == '1') {
            param.page = -1;
            compData['loading'] = true;
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].loadFirstCate', true));
            param.idx_arr = {
              idx: 'category',
              idx_value: compData.content[0].source == 'all' ? '' : compData.content[0].source
            };
            that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            for (var _i = 1; _i < compData.content.length; _i++) {
              param.idx_arr = {
                idx: 'category',
                idx_value: compData.content[_i].source == 'all' ? '' : compData.content[_i].source
              };
              param.page = -1;
              that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            }
          } else {
            param.page = 1;
            param.page_size = 10;
            if (content[0]) {
              param.idx_arr = {
                idx: 'category',
                idx_value: content[0].source == 'all' ? '' : content[0].source
              };
              compData['loading'] = true;
              that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
            }
          }
        }
      });
    } else {
      var content = compData.content;
      var cateData = {};
      for (var j in content) {
        var cateParam = {};
        cateParam.param = {};
        Object.assign(cateParam.param, param);
        cateParam.param.idx_arr = {
          idx: 'category',
          idx_value: content[j].source == 'all' ? '' : content[j].source
        };
        cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
      }
      if (pageInstance.data.page_hasNavBar) {
        cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - _app.appMethod.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
        cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100 - _app.appMethod.globalData.topNavBarHeight;
      } else {
        cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
        cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100;
      }
      cateData['eles[' + compindex + '].route'] = pageInstance.route;
      pageInstance.setData(cateData);

      if (compData.customFeature.loadAllData == '1') {
        param.page = -1;
        pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].loadFirstCate', true));
        param.idx_arr = {
          idx: 'category',
          idx_value: compData.content[0].source == 'all' ? '' : compData.content[0].source
        };
        that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
        for (var i = 1; i < compData.content.length; i++) {
          param.idx_arr = {
            idx: 'category',
            idx_value: compData.content[i].source == 'all' ? '' : compData.content[i].source
          };
          param.page = -1;
          that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
        }
      } else {
        param.page = 1;
        param.page_size = 10;
        param.idx_arr = {
          idx: 'category',
          idx_value: content[0].source == 'all' ? '' : content[0].source
        };
        compData['loading'] = true;
        that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
      }
    }
  };

  this.verticalListChangeEvaluate = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = event.currentTarget.dataset.compindex;
    if (event.currentTarget.dataset.index == 2) {
      pageInstance.hasRequireAssess = true;
      _this4._getAssessList(pageInstance, compindex);
    }
    newdata['eles[' + compindex + '].selected'] = event.currentTarget.dataset.index;
    pageInstance.setData(newdata);
  };

  this.verticalListTouchstart = function (event) {
    var newdata = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
    newdata['eles[' + compindex + '].startPoint'] = startPoint;
    pageInstance.setData(newdata);
  };

  this.verticalListTouchmove = function (event) {
    var newdata = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    if (compData['showSearch']) return;
    if (compData.customFeature.selected > 0) return;
    if (compData.customFeature.loadAllData == '1') return;
    if (!compData.shopInfo || !pageInstance['verticalList' + compindex] || pageInstance['verticalList' + compindex] && pageInstance['verticalList' + compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    if (compData.startPoint.y - event.touches[0].pageY > 40 && compData.heightFlag && compData['infoHeight'] === 0) {
      _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
        // compData.heightFlag = false; // WEBAPP: 之后要去掉当前注释
        pageInstance['verticalList' + compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        // let animation = app.createAnimation({
        //   duration: 400,
        //   timingFunction: 'linear'
        // })
        // animation.translateY(-pageInstance['verticalList'+compindex]['shopInfoHeight']).height(0).step();
        // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      });
    }
    if (event.touches[0].pageY - compData.startPoint.y > 40 && compData.heightFlag && compData['infoHeight'] !== 0) {
      // compData.heightFlag = false; // WEBAPP: 之后要去掉当前注释
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  };

  this.stopAnimation = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true;
  };

  this.verticalListShowGoodsSearch = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var data = {};
    data['eles[' + compindex + '].showSearch'] = true;
    if (!compData.shopInfo || !pageInstance['verticalList' + compindex] || pageInstance['verticalList' + compindex] && pageInstance['verticalList' + compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    if (compData['show_goods_data'] && compData['show_goods_data']['searchResult']) {
      data['eles[' + compindex + '].show_goods_data.searchResult'] = [];
    }
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.height(0).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
    pageInstance.setData(data);
  };

  this.verticalListHideGoodsSearch = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var data = {};
    data['eles[' + compindex + '].showSearch'] = false;
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.data.eles[compindex].heightFlag = true;
    pageInstance.setData(data);
  };

  this.verticalListBindSearchTitle = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].searchTitle'] = event.target.value;
    pageInstance.setData(newdata);
  };

  this.verticalListSearchByTitle = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var pagination = {};
    if (compData.pagination['searchResult']) {
      pagination = compData.pagination['searchResult'];
    } else {
      pagination = compData.pagination['category' + compData.content[0].source];
    }
    var param = JSON.parse(JSON.stringify(pagination.param));
    var category_arr = [];
    var hasAll = false;
    for (var i = 0; i < compData.content.length; i++) {
      if (compData.content[i].source == 'all') {
        hasAll = true;
        break;
      } else {
        category_arr.push(compData.content[i].source);
      }
    }
    hasAll ? '' : param['category_arr'] = category_arr;
    param.idx_arr['idx'] = 'title';
    param.idx_arr['idx_value'] = compData.searchTitle;
    param.page = 1;
    newdata['eles[' + compindex + '].pagination.searchResult.param'] = param;
    newdata['eles[' + compindex + '].pagination.searchResult.requesting'] = false;
    pageInstance.setData(newdata);
    _this4._getVerticalListListByTitle(param, pageInstance, compindex, 1);
  };

  this.verticalListClickCategory = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var index = dataset.index;
    var id = dataset.id;
    var newdata = {};
    var param = JSON.parse(dataset.param);
    var compData = pageInstance.data.eles[compindex];
    var cateIndex = Number(dataset.cateindex);
    if (compData['loading'] || pageInstance['verticalList' + compindex] && pageInstance['verticalList' + compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    if (!compData.customFeature.loadAllData || compData.customFeature.loadAllData == '0') {
      if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
        newdata['eles[' + compindex + '].loading'] = true;
        _this4._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
      }
      newdata['eles[' + compindex + '].scrollTopLoading'] = false;
      newdata['eles[' + compindex + '].scrollTop'] = '.02rem';
      newdata['eles[' + compindex + '].customFeature.selected'] = index;
      newdata['eles[' + compindex + '].loadingFail'] = false;
    } else {
      newdata['eles[' + compindex + '].customFeature.selected'] = index;
      newdata['eles[' + compindex + '].scrollInto'] = 'cate-' + cateIndex;
      newdata['eles[' + compindex + '].currentCate'] = compData.content[index].text;
    }
    if (index > 0) {
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(0).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
    }
    pageInstance.setData(newdata);
    compData['isChangeTab'] = true;
  };

  this.verticalListStyleScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var newdata = {};
    var pagination = compData.pagination['category' + categoryId];
    var param = pagination.param;
    var that = _this4;
    if ((pagination.requesting || pagination.is_more === 0 || compData['loading']) && !compData.loadingFail) {
      if (pagination.requesting) {
        return;
      }
      if (compData.customFeature.selected < compData.content.length - 1) {
        compData['scrollTo'] = 'bottom';
      }
      return;
    }
    newdata['eles[' + compindex + '].pagination.category' + categoryId + '.requesting'] = true;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
  };

  this.verticalListStyleScrollTop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var pagination = compData.pagination['category' + categoryId];
    var param = pagination.param;
    var that = _this4;
    if (pagination.requesting) {
      return;
    }
    if (compData.customFeature.selected > 0) {
      compData['scrollTo'] = 'top';
    }
  };

  this.scrollStart = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
    compData['scrollStratPoint'] = startPoint;
  };

  this.scrollMove = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    if (compData['scrollTo'] === 'bottom') {
      if (compData.scrollStratPoint.y - event.touches[0].pageY > 20) {
        if (compData['scrollTopLoading'] !== 'bottom') {
          var loadingData = {};
          compData['scrollTopLoading'] = 'bottom';
          loadingData['eles[' + compindex + '].scrollTopLoading'] = 'bottom';
          pageInstance.setData(loadingData);
        }
      }
      if (compData.startPoint.y - event.touches[0].pageY > 150) {
        compData['toCate'] = 'next';
      }
    } else if (compData['scrollTo'] === 'top') {
      if (event.touches[0].pageY - compData.scrollStratPoint.y > 50) {
        if (compData['scrollTopLoading'] !== 'top') {
          var _loadingData = {};
          compData['scrollTopLoading'] = 'top';
          _loadingData['eles[' + compindex + '].scrollTopLoading'] = 'top';
          pageInstance.setData(_loadingData);
        }
      }
      if (event.touches[0].pageY - compData.startPoint.y > 100) {
        compData['toCate'] = 'prev';
      }
    }
  };

  this.scrollEnd = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var newdata = {};
    var pagination = compData.pagination['category' + categoryId];
    var param = pagination.param;
    var that = _this4;
    var loadingData = {};
    loadingData['eles[' + compindex + '].scrollTopLoading'] = false;
    pageInstance.setData(loadingData);
    if (compData['loading'] || !compData['toCate']) return;
    var index = +compData.customFeature.selected || 0;
    if (compData['toCate'] === 'next') {
      index = +compData.customFeature.selected + 1;
    } else if (compData['toCate'] === 'prev') {
      index = +compData.customFeature.selected - 1;
    }
    compData['toCate'] = false;
    var id = compData.content[index].source;
    if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
      compData['loading'] = true;
      newdata['eles[' + compindex + '].loading'] = true;
      param.page = 1;
      param.idx_arr.idx_value = id == 'all' ? '' : id;
      that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
    }
    // newdata['eles[' + compindex + '].scrollTop'] = '2rpx';
    newdata['eles[' + compindex + '].customFeature.selected'] = index;
    newdata['eles[' + compindex + '].scrollTopLoading'] = false;
    pageInstance.setData(newdata, function () {
      compData['scrollTo'] = false;
    });
  };

  this.sortVerticalList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var newdata = {};
    var pagination = compData.pagination['category' + categoryId];
    var param = pagination.param;
    param.idx_arr.idx_value = categoryId == 'all' ? '' : categoryId;
    var sort_key = dataset.sort_key;
    var sort_direction = dataset.direction;
    if (+sort_direction === 0) {
      sort_direction = 1;
    } else {
      sort_direction = 0;
    }
    if (!compData.categorySort) {
      sort_direction = 0;
    } else {
      if (compData.categorySort['category' + categoryId] && compData.categorySort['category' + categoryId].sortKey !== sort_key) {
        sort_direction = 0;
      }
    }
    param.sort_key = sort_key;
    param.sort_direction = sort_direction;
    param.page = 1;
    newdata['eles[' + compindex + '].categorySort'] = compData.categorySort;
    if (!newdata['eles[' + compindex + '].categorySort']) {
      newdata['eles[' + compindex + '].categorySort'] = {};
    }
    newdata['eles[' + compindex + '].categorySort']['category' + categoryId] = {
      sortKey: sort_key,
      sort_direction: sort_direction
    };
    pageInstance.setData(newdata);
    _this4._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  };

  this.showVerticalListGoodsDetail = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var id = dataset.id;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var category = dataset.category;
    var is_search = dataset.is_search || '';
    var compData = pageInstance.data.eles[compindex];
    var showGoodsData = void 0;
    if (is_search == 'search') {
      showGoodsData = compData.show_goods_data['searchResult'][index];
    } else {
      showGoodsData = compData.show_goods_data['category' + category][index];
    }
    var businessTime = showGoodsData.business_time ? showGoodsData.business_time.business_time : '';
    if (businessTime) {
      var business_time = '';
      for (var key in businessTime) {
        business_time += businessTime[key].start_time.slice(0, 2) + ':' + businessTime[key].start_time.slice(2, 4) + '-' + businessTime[key].end_time.slice(0, 2) + ':' + businessTime[key].end_time.slice(2, 4) + ' ';
      }
      showGoodsData.businessTime = business_time;
    }
    showGoodsData.des = _app.appMethod.getWxParseResult(showGoodsData.description);
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        var newdata = {};
        newdata['eles[' + compindex + '].goodsDetailShow'] = true;
        newdata['eles[' + compindex + '].hideSearchInput'] = true;
        newdata['eles[' + compindex + '].goodsDetail'] = showGoodsData;
        newdata['eles[' + compindex + '].goodsDetail']['goodsData'] = compData.goods_data_list[id];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess'] = res;
        pageInstance.setData(newdata);
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/GoodsView',
          data: {
            goods_id: id
          },
          success: function success() {}
        });
      }
    });
  };

  this.verticalListListMinus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.target.dataset;
    var goodsid = dataset.goodsid;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var totalNum = +compData.TotalNum;
    var totalPrice = +compData.TotalPrice;
    var newdata = {};
    var model = Number(dataset.model); // WEBAPP：处理为number类型
    var isInBusiness = dataset.isInBusiness;
    if (isInBusiness == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }
    if (model) {
      _app.appMethod.showModal({
        content: '多规格商品只能去购物车操作'
      });
      return;
    }
    if (compData.cartList[0][goodsid][0].num == 0) {
      return;
    }
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = --totalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice - Number(newdata['eles[' + compindex + '].goods_data_list.' + goodsid].calculationPrice)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    pageInstance.setData(newdata, function () {
      that.takeoutTimeout = setTimeout(function () {
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
      }, 300);
    });
  };

  this.verticalListListPlus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.target.dataset;
    var goodsid = dataset.goodsid;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    if (compData.flag) {
      return;
    }
    compData.addCartComplete = false;
    var model = Number(dataset.model); // WEBAPP：处理为number类型
    var goodsInfo = compData.goods_data_list[goodsid];
    var totalNum = compData.TotalNum;
    var totalPrice = +compData.TotalPrice;
    var is_in_business = dataset.isInBusiness;
    var newdata = {};
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    var userCart = compData.cartList[0];
    var myCartNum = 0;
    for (var k in userCart) {
      for (var j in userCart[k]) {
        myCartNum += userCart[k][j].num;
      }
    }
    if (is_in_business == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }
    if (model) {
      newdata['eles[' + compindex + '].goodsModelShow'] = true;
      newdata['eles[' + compindex + '].hideSearchInput'] = true;
      newdata['eles[' + compindex + '].modelGoodsId'] = goodsid;
      newdata['eles[' + compindex + '].modelIdArr'] = [];
      for (var index = 0; index < compData.goods_data_list[goodsid]['model'].modelData.length; index++) {
        newdata['eles[' + compindex + '].modelIdArr'].push(0);
      }
      pageInstance.setData(newdata);
    } else {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
      newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
      var newNum = 1;
      newdata['eles[' + compindex + '].TotalNum'] = +totalNum + 1;
      newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice + +goodsInfo.calculationPrice).toFixed(2);
      newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum++;
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num++;
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = (+newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * goodsInfo.calculationPrice).toFixed(2);
      } else {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0] = {
          list: 'list',
          id: goodsid,
          modelId: 0,
          num: newNum,
          // price: goodsInfo.price,
          price: goodsInfo.calculationPrice,
          gooodsName: goodsInfo.name,
          totalPrice: (newNum * goodsInfo.calculationPrice).toFixed(2),
          stock: goodsInfo.stock,
          cart_id: 0,
          in_business_time: compData.goods_data_list[goodsid].in_business_time,
          pick_up_type: goodsInfo.pick_up_type,
          is_vip_goods: goodsInfo.is_vip_goods || 0
          // calculationPrice: goodsInfo.calculationPrice
        };
      }
      if (compData.cartGoodsIdList.indexOf(+goodsid) == -1) {
        newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
        newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
      }
      myCartNum += 1;
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      clearInterval(compData.timer);
      compData.loopRequest = false;
      pageInstance.setData(newdata, function () {
        that.takeoutTimeout = setTimeout(function () {
          var options = {
            goods_type: 0,
            cartListData: compData.cartList,
            thisPage: pageInstance,
            compindex: compindex
          };
          that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
        }, 300);
      });
    }
  };

  this.verticalListSearchScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var pagination = compData.pagination['searchResult'];
    var param = pagination.param;
    if ((pagination.requesting || pagination.is_more === 0) && !compData.loadingFail) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    _this4._getVerticalListListByTitle(param, pageInstance, compindex, 0);
  };

  this._getVerticalListListByTitle = function (param, pageInstance, compindex, isOnShow) {
    var _this = _this4;
    pageInstance.requesting = true;
    var newdata = {};
    newdata['eles[' + compindex + '].searchLoading'] = true;
    pageInstance.setData(newdata);
    param.form = 'goods';
    param.only_display_common = 0;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          newdata['eles[' + compindex + '].searchLoading'] = false;
          var compData = pageInstance.data.eles[compindex],
              isRequireing = {},
              categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          isRequireing['eles[' + compindex + '].pagination.searchResult'].requesting = false;
          pageInstance.setData(isRequireing);
          if (!compData.show_goods_data || compData.show_goods_data && !compData.show_goods_data['searchResult'] || isOnShow == 1) {
            categoryList['searchResult'] = [];
          } else {
            categoryList['searchResult'] = compData.show_goods_data['searchResult'];
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list;
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {};
          }
          if (!pageInstance['verticalList' + compindex]['goods_model_list']) {
            pageInstance['verticalList' + compindex]['goods_model_list'] = {};
          }
          for (var i in res.data) {
            var _newdata;

            var form_data = res.data[i].form_data;
            categoryList['searchResult'].push({
              app_id: form_data.app_id,
              cover: form_data.cover,
              description: form_data.description,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              id: form_data.id,
              price: form_data.price,
              sales: form_data.sales,
              title: form_data.title,
              business_time: form_data.business_time,
              is_in_business_time: form_data.goods_in_business_time,
              stock: form_data.stock,
              virtual_price: form_data.virtual_price,
              vipGoods: form_data.paid_vip_card_condition || form_data.paid_vip_level_condition || form_data.vip_card_condition || form_data.vip_level_condition ? true : false,
              integral: form_data.integral,
              img_urls: form_data.img_urls || [],
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            });
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = (_newdata = {
              totalNum: 0,
              stock: form_data.stock,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              name: form_data.title,
              price: form_data.price,
              in_business_time: form_data.goods_in_business_time,
              model: {}
            }, (0, _defineProperty3.default)(_newdata, 'goods_model', {}), (0, _defineProperty3.default)(_newdata, 'vip_price', form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price), (0, _defineProperty3.default)(_newdata, 'vip_goods_price', form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null), (0, _defineProperty3.default)(_newdata, 'calculationPrice', form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price), (0, _defineProperty3.default)(_newdata, 'is_vip_goods', form_data.is_vip_goods || 0), _newdata);
            if (form_data.goods_model) {
              var new_goods_model = {};
              for (var _i2 in form_data.goods_model) {
                new_goods_model[form_data.goods_model[_i2].id] = {
                  model: form_data.goods_model[_i2].model,
                  stock: form_data.goods_model[_i2].stock,
                  price: form_data.goods_model[_i2].price,
                  goods_id: form_data.goods_model[_i2].goods_id,
                  totalNum: 0,
                  vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                  calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                  is_vip_goods: form_data.is_vip_goods || 0
                };
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              };
              pageInstance['verticalList' + compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              };
              for (var k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                });
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                is_vip_goods: form_data.is_vip_goods && form_data.vip_goods_price != form_data.price || 0
              };
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.searchResult'] = categoryList['searchResult'];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.searchResult'].param = param;
          newdata['eles[' + compindex + '].pagination.searchResult'].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.searchResult'].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
      },
      fail: function fail() {
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].searchLoading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  };

  this.verticalListShowShoppingCartPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var isShowShoppingCart = dataset.isshow;
    var newdata = {};
    if (isShowShoppingCart) {
      newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    } else {
      newdata['eles[' + compindex + '].shoppingCartShow'] = true;
    }
    pageInstance.setData(newdata);
  };

  this.verticalListChooseComplete = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.target.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    if (!compData.TotalNum) {
      return;
    }
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      that._addTakeoutCart(options, that.eachCartList(options), function (idArr) {
        var franchiseeId = _app.appMethod.getPageFranchiseeId();
        var franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
        pageInstance.returnToVerticalFlag = 1;
        _app.appMethod.turnToPage('/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' + idArr + franchiseeParam);
      });
    }, 300);
  };

  this.verticalListChangeAssessType = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var assessActive = event.currentTarget.dataset.active;
    var showAssess = [];
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].assessActive'] = assessActive;
    for (var i = 0; i < compData.assessList.length; i++) {
      var alist = compData.assessList[i];
      if (assessActive == 0) {
        alist.assess_info.has_img == 1 ? showAssess.push(alist) : null;
      } else if (alist.assess_info.level == assessActive) {
        showAssess.push(alist);
      }
    }
    newdata['eles[' + compindex + '].showAssess'] = showAssess;
    pageInstance.setData(newdata);
  };

  this.verticalListGetMoreAssess = function (event) {
    var dataset = event.currentTarget.dataset;
    var page = dataset.nextpage;
    var compindex = dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        "idx_arr[0][idx]": 'goods_type',
        "idx_arr[0][idx_value]": 0,
        page: page,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var alist = compData.assessList;
        for (var i in res.data) {
          alist.push(res.data[i]);
        }
        newdata['eles[' + compindex + '].assessList'] = alist;
        var commentNums = [],
            showAssess = [],
            hasImgAssessList = 0,
            goodAssess = 0,
            normalAssess = 0,
            badAssess = 0;
        for (var _i3 = 0; _i3 < alist.length; _i3++) {
          var listItem = alist[_i3];
          listItem.assess_info.has_img == 1 ? hasImgAssessList++ : null;
          listItem.assess_info.level == 3 ? goodAssess++ : listItem.assess_info.level == 1 ? badAssess++ : normalAssess++;
          if (listItem.assess_info.has_img == 1 && compData.assessActive == 0) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 3 && compData.assessActive == 3) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 1 && compData.assessActive == 1) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 2 && compData.assessActive == 2) {
            showAssess.push(listItem);
          }
        }
        commentNums = [hasImgAssessList, goodAssess, normalAssess, badAssess];
        newdata['eles[' + compindex + '].commentNums'] = commentNums;
        newdata['eles[' + compindex + '].assessCurrentPage'] = page;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        pageInstance.setData(newdata);
      }
    });
  };

  this.openVerticalListLocation = function (event) {
    var dataset = event.currentTarget.dataset;
    _app.appMethod.openLocation({
      latitude: +dataset.lat,
      longitude: +dataset.lng,
      name: dataset.name,
      address: dataset.address
    });
  };

  this.verticalListHideDetailPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].goodsDetailShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    pageInstance.setData(newdata);
  };

  this.verticalListGetMoreGoodsAssess = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};

    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: compData.goodsDetail.id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: compData.goodsDetail.goodsAssess.current_page + 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        newdata['eles[' + compindex + '].goodsDetail'] = compData['goodsDetail'];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['data'] = compData['goodsDetail']['goodsAssess']['data'].concat(res.data);
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['is_more'] = res.is_more;
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['current_page'] = res.current_page;
        pageInstance.setData(newdata);
      }
    });
  };

  this.verticalListHideModelPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].goodsModelShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + '].modelNum'] = 0;
    newdata['eles[' + compindex + '].addCartComplete'] = true;
    pageInstance.setData(newdata);
  };

  this.verticalListChooseModel = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var pIndex = dataset.parentindex;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var compData = pageInstance.data.eles[compindex];
    var modelData = compData.goods_data_list[goodsid]['model'].modelData;
    var newdata = {};
    newdata['eles[' + compindex + '].modelChoose'] = compData.modelChoose;
    newdata['eles[' + compindex + '].modelIdArr'] = compData.modelIdArr;
    newdata['eles[' + compindex + '].modelChoose'][pIndex] = modelData[pIndex].subModelName[index];
    newdata['eles[' + compindex + '].modelIdArr'][pIndex] = modelData[pIndex].subModelId[index];
    pageInstance.setData(newdata);
    _this4._ModelPirce(dataset, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
  };

  this._ModelPirce = function (dataset, modelNameArr) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = dataset.compindex;
    var goods_model = pageInstance['verticalList' + compindex].goods_model_list[dataset.goodsid].goods_model;
    var compData = pageInstance.data.eles[compindex];
    for (var i in goods_model) {
      if (goods_model[i].model.split(',').sort().join(',') == modelNameArr.sort().join(',')) {
        newdata['eles[' + compindex + '].modelChooseId'] = i;
        if (goods_model[i].is_vip_goods && !compData.customFeature.is_together) {
          newdata['eles[' + compindex + '].modelPrice'] = goods_model[i].vip_price;
          goods_model[i].vip_price != goods_model[i].price ? newdata['eles[' + compindex + '].isModelPrice'] = true : newdata['eles[' + compindex + '].isModelPrice'] = false;
        } else {
          newdata['eles[' + compindex + '].modelPrice'] = goods_model[i].price;
          newdata['eles[' + compindex + '].isModelPrice'] = false;
        }

        if (compData.cartList[0][dataset.goodsid] && compData.cartList[0][dataset.goodsid][i]) {
          newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][i].num;
        } else {
          newdata['eles[' + compindex + '].modelNum'] = 0;
        }
      }
    }
    pageInstance.setData(newdata);
  };

  this.verticalListSureChooseModel = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var price = +compData.modelPrice;
    var modelId = compData.modelChooseId;
    var thisModelInfo = pageInstance['verticalList' + compindex].goods_model_list[goodsid].goods_model[modelId];
    if (!compData.modelPrice) {
      _app.appMethod.showModal({
        content: '请选择规格'
      });
      return;
    }
    if (thisModelInfo.stock <= thisModelInfo.totalNum) {
      _app.appMethod.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    newdata['eles[' + compindex + '].mdelInfo'] = thisModelInfo;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    var goods_num = thisModelInfo.totalNum + 1;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = compData.goods_data_list[goodsid].totalNum + 1;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId] = thisModelInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId].totalNum++;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = ++compData.TotalNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId] = {
      modelName: compData.modelChoose.join(' | '),
      modelId: modelId,
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisModelInfo.totalNum * price).toFixed(2),
      stock: thisModelInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type
    };
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods) {
      newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + 1;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = 1;
    }

    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListMinuModel = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var price = +compData.modelPrice;
    var modelid = compData.modelChooseId;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = --compData.TotalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num--;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = --compData.modelNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    }
    var thisModelInfo = pageInstance['verticalList' + compindex].goods_model_list[goodsid];
    if (thisModelInfo && thisModelInfo.goods_model) {
      thisModelInfo.goods_model[modelid].totalNum--;
    }
    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListHideShoppingCart = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    pageInstance.setData(newdata);
  };

  this.verticalListDeleteAllCarts = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    cartIds = _this4.getCartIdArray(compindex, pageInstance);
    if (cartIds.length == 0) {
      _app.appMethod.showModal({
        content: '请先添加商品'
      });
      return;
    }
    _this4._removeFromCart(cartIds, function () {
      _this4._removeFromCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance
      });
    }, compindex);
  };

  this._removeFromCartCallback = function (options) {
    var n = {};
    var c = options.compindex;
    var goods_data_list = options.compData.goods_data_list;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var goods_model_list = pageInstance.data.eles[c]['goods_model_list'];
    n['eles[' + c + '].cartList'] = [{}];
    n['eles[' + c + '].cart_data'] = [];
    for (var i in goods_data_list) {
      goods_data_list[i].totalNum = 0;
    }
    for (var _i4 in goods_model_list) {
      for (var j in goods_model_list[_i4].goods_model) {
        goods_model_list[_i4].goods_model[j].totalNum = 0;
      }
    }
    n['eles[' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].cartGoodsIdList'] = [];
    n['eles[' + c + '].TotalNum'] = 0;
    n['eles[' + c + '].TotalPrice'] = 0;
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  };

  this.verticalListCartListMinus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var data = pageInstance.data;
    var newdata = {};
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var price = dataset.price;
    var modelid = dataset.modelid;
    var compData = pageInstance.data.eles[compindex];
    var index = dataset.index;
    var id = dataset.id;
    if (compData.cartList[index][goodsid][modelid].num == 0) {
      return;
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    if (modelid != 0) {
      if (pageInstance['verticalList' + compindex]['goods_model_list'][goodsid] && pageInstance['verticalList' + compindex]['goods_model_list'][goodsid].goods_model) {
        pageInstance['verticalList' + compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum--;
      }
    }
    newdata['eles[' + compindex + '].TotalNum'] = --compData.TotalNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num--;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num).toFixed(2);
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum--;
    }
    if (index === 0) {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          myCartNum += userCart[k][j].num;
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListCartListPlus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var dataset = event.currentTarget.dataset;
    var goodsid = dataset.goodsid;
    var modelid = dataset.modelid;
    var is_in_business = dataset.isInBusiness;
    var num = dataset.num;
    var stock = dataset.stock;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var index = dataset.index;
    var id = dataset.id;
    if (num == stock) {
      _app.appMethod.showModal({
        content: '该商品库存不足'
      });
      return;
    }
    if (is_in_business == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + 1;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(compData.cartList[index][goodsid][modelid].price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    if (+modelid) {
      if (compData.goods_data_list[goodsid]) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum;
      }
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num = ++compData.cartList[index][goodsid][modelid].num;
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].num * compData.cartList[index][goodsid][modelid].price).toFixed(2);
      if (pageInstance['verticalList' + compindex]['goods_model_list'][goodsid]) {
        pageInstance['verticalList' + compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum++;
      }
    } else {
      if (compData.goods_data_list[goodsid] && compData.goods_data_list[goodsid].totalNum) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].price).toFixed(2);
      } else {
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].price).toFixed(2);
      }
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListHideCouponsList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].shoppingCouponsList'] = false;
    pageInstance.setData(newdata);
  };

  this.tapVerticalListCoupon = function (event) {
    var coupon_id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage('/pages/couponDetail/couponDetail?detail=' + coupon_id + chainParam);
  };

  this.deleteSingleCarts = function (event) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var modelid = dataset.modelid;
    var compData = pageInstance.data.eles[compindex];
    _this4._removeFromCart([compData.cartList[0][goodsid][modelid].cart_id], function () {
      var newdata = {};
      var num = compData.cartList[0][goodsid][modelid].num;
      var price = (compData.cartList[0][goodsid][modelid].price * num).toFixed(2);
      delete compData.cart_data[goodsid][modelid];
      delete compData.cartList[0][goodsid][modelid];
      if (util.isPlainObject(compData.cart_data[goodsid])) {
        delete compData.cart_data[goodsid];
        delete compData.cartList[0][goodsid];
      }
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.totalNum'] = compData.goods_data_list[goodsid].totalNum - num;
      newdata['eles[' + compindex + '].cart_data'] = compData.cart_data;
      newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
      newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - num;
      newdata['eles[' + compindex + '].TotalPrice'] = (compData.TotalPrice - +price).toFixed(2);
      pageInstance.setData(newdata);
    }, compindex);
  };

  this._removeFromCart = function (cart_id, callback, compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var data = {
      cart_id_arr: cart_id
    };
    compData.location_id ? data.location_id = compData.location_id : data = data;
    compData.loopRequest = false;
    clearInterval(compData.timer);
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: data,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function success(res) {
        callback && callback();
      },
      fail: function fail(res) {
        _app.appMethod.showModal({
          content: '清空购物车失败'
        });
      },
      complete: function complete() {
        compData.loopRequest = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  };

  this._getTakeoutStyleGoodsList = function (param, pageInstance, compindex, isOnShow) {
    if (!param.is_integral) {
      param.is_integral = 5;
    }
    var _this = _this4;
    var categoryId = param.idx_arr.idx_value == '' ? 'all' : param.idx_arr.idx_value;
    param.form = 'goods';
    param.only_display_common = 0;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          var compData = pageInstance.data.eles[compindex],
              newdata = {},
              isRequireing = {},
              categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId].requesting = false;
          pageInstance.setData(isRequireing);
          if (compData.customFeature.loadAllData == '1') {
            var pxRatio = void 0;
            if (_app.appMethod.isWeixin()) {
              pxRatio = _app.appMethod.globalData.systemInfo.windowWidth ? 750 / _app.appMethod.globalData.systemInfo.windowWidth : 2;
            } else {
              pxRatio = window.innerWidth ? 750 / window.innerWidth : 2;
            }
            compData.requestNum++;
            compData.goodsCateHeight[categoryId] = {};
            if (compData.customFeature.listArrange == 1) {
              compData.goodsCateHeight[categoryId] = (Math.ceil(res.data.length / 2) * 474 + 38) / pxRatio;
            } else {
              compData.goodsCateHeight[categoryId] = (res.data.length * 226 + 38) / pxRatio;
            }
          }
          if (!compData.show_goods_data || compData.show_goods_data && !compData.show_goods_data['category' + categoryId] || isOnShow == 1) {
            categoryList['category' + categoryId] = [];
          } else {
            categoryList['category' + categoryId] = compData.show_goods_data['category' + categoryId];
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list;
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {};
          }
          if (!pageInstance['verticalList' + compindex]['goods_model_list']) {
            pageInstance['verticalList' + compindex]['goods_model_list'] = {};
          }
          for (var i in res.data) {
            var _newdata2;

            var form_data = res.data[i].form_data;
            categoryList['category' + categoryId].push({
              app_id: form_data.app_id,
              cover: form_data.cover,
              description: form_data.description,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              id: form_data.id,
              price: form_data.price,
              sales: form_data.sales,
              title: form_data.title,
              business_time: form_data.business_time,
              is_in_business_time: form_data.goods_in_business_time,
              stock: form_data.stock,
              virtual_price: form_data.virtual_price,
              corner_mark: form_data.corner_mark,
              corner_url: form_data.corner_url,
              vipGoods: form_data.paid_vip_card_condition || form_data.paid_vip_level_condition || form_data.vip_card_condition || form_data.vip_level_condition ? true : false,
              integral: form_data.integral,
              img_urls: form_data.img_urls || [],
              max_can_use_integral: Number(form_data.max_can_use_integral),
              vip_price: form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price,
              vip_goods_price: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null,
              calculationPrice: form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price,
              is_vip_goods: form_data.is_vip_goods || 0
            });
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = (_newdata2 = {
              totalNum: 0,
              stock: form_data.stock,
              goods_model: form_data.goods_model ? form_data.goods_model.length : 0,
              name: form_data.title,
              price: form_data.price,
              in_business_time: form_data.goods_in_business_time,
              model: {}
            }, (0, _defineProperty3.default)(_newdata2, 'goods_model', {}), (0, _defineProperty3.default)(_newdata2, 'pick_up_type', form_data.pick_up_type), (0, _defineProperty3.default)(_newdata2, 'paid_vip_card_condition', form_data.paid_vip_card_condition), (0, _defineProperty3.default)(_newdata2, 'paid_vip_level_condition', form_data.paid_vip_level_condition), (0, _defineProperty3.default)(_newdata2, 'vip_card_condition', form_data.vip_card_condition), (0, _defineProperty3.default)(_newdata2, 'vip_level_condition', form_data.vip_level_condition), (0, _defineProperty3.default)(_newdata2, 'vip_price', form_data.vip_min_price == form_data.vip_max_price ? form_data.vip_min_price : form_data.vip_min_price + '~' + form_data.vip_max_price), (0, _defineProperty3.default)(_newdata2, 'vip_goods_price', form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : null), (0, _defineProperty3.default)(_newdata2, 'calculationPrice', form_data.vip_goods_price && form_data.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(form_data.vip_goods_price).toFixed(2) : form_data.price), (0, _defineProperty3.default)(_newdata2, 'is_vip_goods', form_data.is_vip_goods || 0), _newdata2);
            if (form_data.goods_model) {
              var new_goods_model = {};
              for (var _i5 in form_data.goods_model) {
                new_goods_model[form_data.goods_model[_i5].id] = {
                  model: form_data.goods_model[_i5].model,
                  stock: form_data.goods_model[_i5].stock,
                  price: form_data.goods_model[_i5].price,
                  goods_id: form_data.goods_model[_i5].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[_i5].vip_price && form_data.goods_model[_i5].vip_price !== 0 ? Number(form_data.goods_model[_i5].vip_price).toFixed(2) : null,
                  is_vip_goods: form_data.is_vip_goods || 0
                };
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              };
              pageInstance['verticalList' + compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              };
              for (var k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                });
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                is_vip_goods: form_data.is_vip_goods && form_data.vip_goods_price != form_data.price || 0
              };
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.category' + categoryId] = categoryList['category' + categoryId];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].param = param;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          newdata['eles[' + compindex + '].loadFirstCate'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.loadAllData == '1') {
            if (compData.requestNum == compData.content.length) {
              if (compData.customFeature.is_together) {
                compData.loopRequest = true;
                _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
                if (compData.location_id) {
                  _this.getDiningCart(pageInstance, compindex);
                }
              } else {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              };
            }
          } else {
            if (compData.customFeature.is_together) {
              compData.loopRequest = true;
              _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
              if (compData.location_id) {
                _this.getDiningCart(pageInstance, compindex);
              }
            } else {
              if (_app.appMethod.globalData.isLogin) {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              } else {
                _this._parseTakeoutCartListData({ data: [] }, pageInstance, compindex);
              }
            }
          }
        }
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  };

  this._getTakeoutStyleCartList = function (pageInstance, compindex) {
    var _this = _this4;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: -1,
        page_size: 1000,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? _app.appMethod.getAppId() : '',
        not_get_takeout: 1
      },
      success: function success(cartlist) {
        _this._parseTakeoutCartListData(cartlist, pageInstance, compindex);
      },
      fail: function fail(res) {
        _app.appMethod.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function confirm() {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        });
      }
    });
  };

  this._parseTakeoutCartListData = function (cartlist, pageInstance, compindex) {
    var newdata = {},
        stockEmpty = false,
        compData = pageInstance.data.eles[compindex],
        totalNum = 0,
        totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    var goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    if (cartlist.data.length) {
      for (var i in cartlist.data) {
        var item = cartlist.data[i];
        if (goodsList[item.goods_id]) {
          goodsList[item.goods_id].totalNum = 0;
        }
      }
      newdata['eles[' + compindex + '].cartlistData'] = [];
      for (var _i6 in cartlist.data) {
        var _item = cartlist.data[_i6];
        newdata['eles[' + compindex + '].cartlistData'].push(_item);
        if (_item.goods_type == 0) {
          if (+_item.num > +_item.stock) {
            _item.num = _item.stock;
            stockEmpty = true;
          }
          newdata['eles[' + compindex + '].cart_data'][_item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][_item.goods_id] = {};
          newdata['eles[' + compindex + '].cart_data'][_item.goods_id][_item.model_id] = {
            cart_id: _item.id
          };
          if (compData.goods_data_list[_item.goods_id]) {
            newdata['eles[' + compindex + '].goods_data_list']['' + _item.goods_id].totalNum += +_item.num;
            if (pageInstance['verticalList' + compindex]['goods_model_list'][_item.goods_id + '']) {
              if (pageInstance['verticalList' + compindex]['goods_model_list'][_item.goods_id + ''].goods_model) {
                pageInstance['verticalList' + compindex]['goods_model_list'][_item.goods_id + ''].goods_model[_item.model_id].totalNum += +_item.num;
              } else {
                pageInstance['verticalList' + compindex]['goods_model_list'][_item.goods_id + ''][0].num += +_item.num;
              }
            }
          }
          if (!newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id]) {
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id] = {};
          }
          if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+_item.goods_id) == -1) {
            newdata['eles[' + compindex + '].cartGoodsIdList'].push(+_item.goods_id);
          }
          newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id] = {
            list: 'list',
            id: _item.goods_id,
            modelName: _item.model_value ? _item.model_value.join(' | ') : '',
            modelId: _item.model_id,
            num: +_item.num,
            price: +_item.price,
            gooodsName: _item.title,
            totalPrice: Number(_item.num * _item.price).toFixed(2),
            stock: _item.stock,
            cart_id: _item.id,
            in_business_time: compData.goods_data_list[_item.goods_id] && compData.goods_data_list[_item.goods_id].in_business_time,
            pick_up_type: _item.pick_up_type,
            is_vip_goods: _item.cart_vip_goods && _item.original_price != _item.price || 0
          };
          totalNum += Number(_item.num);
          totalPrice += Number(_item.price) * _item.num;
        }
      }
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        _app.appMethod.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        });
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        _this4._addTakeoutCart(options, _this4.eachCartList(options));
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
  };

  this._addTakeoutCart = function (options, cart_info, callback, goodsid) {
    var that = _this4;
    var compindex = options.compindex;
    var compData = options.thisPage.data.eles[compindex];
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    cart_info.map(function (item) {
      if (item.pick_up_type) {
        delete item.pick_up_type;
      }
    });
    var cartInfo = [];
    for (var i = 0; i < cart_info.length; i++) {
      if (goodsid == cart_info[i].goods_id) {
        cartInfo.push(cart_info[i]);
      }
    }
    var data = {
      cart_info: cartInfo,
      goods_type: options.goods_type,
      sub_app_id: franchiseeId || ''
    };
    if (compData['location_id'] && compData.customFeature.is_together) {
      data.location_id = compData['location_id'];
    }
    compData.loopRequest = false;
    compData.addCartComplete = false;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/addVerticalCart',
      method: 'post',
      hideLoading: false,
      data: data,
      success: function success(res) {
        if (res.status === 0) {
          var _data = {};
          _data['eles[' + compindex + '].cart_data.' + goodsid] = res.data[goodsid] || {};
          var cartIdArr = [];
          var isNotEnouth = true;
          for (var k in cart_info) {
            var item = cart_info[k];
            var goods = res.data[item.goods_id];
            if (goods && goods[item.model_id] && goods[item.model_id].stock < item.num) {
              isNotEnouth = false;
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.num'] = goods[item.model_id].stock;
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.cart_id'] = goods[item.model_id].cart_id;
            }
            if (item.num > 0 && goods && goods[item.model_id]) {
              cartIdArr.push(goods[item.model_id].cart_id);
            }
          }
          that.changeStock(res.data, options);
          callback && callback(cartIdArr);
          options.thisPage.setData(_data, function () {
            compData.addCartComplete = true;
          });
          if (!isNotEnouth) {
            _app.appMethod.showModal({
              content: '商品库存不足'
            });
            that.updateGoodsListNum(compindex, goodsid);
          }
        }
      },
      successStatusAbnormal: function successStatusAbnormal(res) {
        if (res.status === 1 && res.is_vip_limit === 1) {
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            that.getMultiOrderingVerticalCart(compindex, pageInstance, true, 1);
          } else {
            that._getTakeoutStyleCartList(pageInstance, compindex);
          }

          //会员购权益不足，不加入cartList
          if (goodsid) {
            var newdata = {};
            var goodsInfo = compData.goods_data_list[goodsid];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
            newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = 0;
            for (var _i7 in compData.cartList[0]) {
              for (var j in compData.cartList[0][_i7]) {
                if (compData.cartList[0][_i7] && compData.cartList[0][_i7][j].id == goodsid) {
                  newdata['eles[' + compindex + '].modelPrice'] = 0;
                  newdata['eles[' + compindex + '].modelNum'] = 0;
                  newdata['eles[' + compindex + '].goodsModelShow'] = false;
                  delete newdata['eles[' + compindex + '].cartList[0]'][goodsid];
                }
              }
            }
            that.getGoodsVipCondtionInfo(compindex, goodsid);
            newdata['eles[' + compindex + '].showVipDialog'] = true;
            pageInstance.setData(newdata);
            return false;
          }
        }
      },
      complete: function complete() {
        compData.loopRequest = true;
        compData.addCartComplete = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  };

  this.changeStock = function (data, options) {
    var newdata = {};
    for (var i in data) {
      for (var j in data[i]) {
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].goods_data_list.' + i + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.cart_id'] = data[i][j].cart_id;
      }
    }
    options.thisPage.setData(newdata);
  };

  this.updateGoodsListNum = function (compindex, goodsid) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var totalprice = 0;
    newdata['eles[' + compindex + '].TotalNum'] = 0;
    newdata['eles[' + compindex + '].TotalPrice'] = 0;
    for (var i in compData.cartList[0]) {
      var num = 0;
      var _price = 0;
      for (var j in compData.cartList[0][i]) {
        num += +compData.cartList[0][i][j].num;
        _price = +(_price + +compData.cartList[0][i][j].num * compData.cartList[0][i][j].price).toFixed(2);
      }
      newdata['eles[' + compindex + '].goods_data_list.' + i + '.totalNum'] = num;
      newdata['eles[' + compindex + '].TotalNum'] += num;
      totalprice = (+totalprice + +_price).toFixed(2);
      newdata['eles[' + compindex + '].TotalPrice'] = totalprice;
    }
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.eachCartList = function (options, callback) {
    var cart_info = [];
    var cart_index = options.index || 0;
    for (var index in options.cartListData[cart_index]) {
      if (index != undefined) {
        for (var j in options.cartListData[cart_index][index]) {
          var obj = {
            goods_id: index.replace('goods', ''),
            model_id: options.cartListData[cart_index][index][j].modelId,
            num: options.cartListData[cart_index][index][j].num,
            pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
          };
          options.cartListData[cart_index][index][j].cart_id ? obj['id'] = options.cartListData[cart_index][index][j].cart_id : '';
          cart_info.push(obj);
        }
      }
    }
    return cart_info;
  };

  this._getAssessList = function (pageInstance, compindex) {
    var idx_value = 0;
    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/getAssessList&idx_arr[0][idx]=goods_type&idx_arr[0][idx_value]=' + idx_value,
      data: {
        page: 1,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {},
            showAssess = [],
            hasImgAssessList = 0,
            goodAssess = 0,
            normalAssess = 0,
            badAssess = 0;
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].assess_info.has_img == 1 ? (hasImgAssessList++, showAssess.push(res.data[i])) : null;
          res.data[i].assess_info.level == 3 ? goodAssess++ : res.data[i].assess_info.level == 1 ? badAssess++ : normalAssess++;
        }
        for (var j = 0; j < res.num.length; j++) {
          res.num[j] = parseInt(res.num[j]);
        }
        newdata['eles[' + compindex + '].assessActive'] = 0;
        newdata['eles[' + compindex + '].assessList'] = res.data;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].assessNum'] = res.num;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        newdata['eles[' + compindex + '].assessCurrentPage'] = res.current_page;
        pageInstance.setData(newdata);
      }
    });
  };

  this.verticalListGoodsListScroll = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var that = _this4;
    var scrollTop = e.target.scrollTop;
    var cate = compData.content;
    var totalHeight = -40;
    var cateHeight = compData.goodsCateHeight;
    var id = 0;
    var index = 0;
    if (compData['isChangeTab']) {
      compData['isChangeTab'] = false;
      return;
    }
    for (var i = 0; i < cate.length; i++) {
      totalHeight += cateHeight[cate[i].source];
      if (scrollTop < totalHeight) {
        id = cate[i].source;
        index = i;
        break;
      }
    }
    if (compData.customFeature.selected !== index) {
      var data = {};
      data['eles[' + compindex + '].customFeature.selected'] = index;
      pageInstance.setData(data);
    }
    if (scrollTop > 100 && compData.heightFlag && compData['infoHeight'] === 0) {
      compData.heightFlag = false;
      _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
        compData.heightFlag = false;
        pageInstance['verticalList' + compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        // let animation = app.createAnimation({
        //   duration: 400,
        //   timingFunction: 'linear'
        // })
        // animation.translateY(-pageInstance['verticalList'+compindex]['shopInfoHeight']).height(0).step();
        // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance['verticalList' + compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      });
    } else if (scrollTop < 20 && compData.heightFlag && compData['infoHeight'] !== 0) {
      compData.heightFlag = false;
      // let animation = app.createAnimation({
      //   duration: 200,
      //   timingFunction: 'linear'
      // })
      // animation.height(pageInstance['verticalList'+compindex]['shopInfoHeight']).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  };

  this.vlSelectGoodsSameJourney = function (e, compIndex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e ? e.currentTarget.dataset.compindex : compIndex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var selectSameJourney = pageInstance.data.selectSameJourney;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
  };

  this.getCurrentLocation = function (compindex, pageInstance) {
    var _this = _this4;
    var newdata = {};
    var compData = pageInstance.data.eles[compindex];
    _app.appMethod.getLocation({
      success: function success(res) {
        var latitude = res.latitude;
        var longitude = res.longitude;
        _app.appMethod.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function success(res) {
            newdata['eles[' + compindex + '].currentLocationData'] = res.data;
            pageInstance.setData(newdata);
          }
        });
      }
    });
  };

  this.getCartIdArray = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    for (var i = 0; i < compData.cartList.length; i++) {
      var userCart = compData.cartList[i];
      for (var k in userCart) {
        for (var j in userCart[k]) {
          if (userCart[k][j].num > 0) {
            cartIds.push(userCart[k][j].cart_id);
          }
        }
      }
    }
    return cartIds;
  };

  this.getMyCartIdArray = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    var userCart = compData.cartList[0];
    for (var k in userCart) {
      for (var j in userCart[k]) {
        if (userCart[k][j].num > 0) {
          cartIds.push(userCart[k][j].cart_id);
        }
      }
    }
    return cartIds;
  };

  this.verticalListSettlement = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var payIdArr = [];
    var franchiseeId = _app.appMethod.getPageFranchiseeId() || '';
    var cartIdArray = [];
    var that = _this4;
    _this4.saveFormId(event.target.formId);
    if (!compData.addCartComplete) {
      return;
    }
    cartIdArray = _this4.getCartIdArray(compindex, pageInstance);
    if (!cartIdArray.length) {
      _app.appMethod.showModal({
        content: '请选择结算的商品'
      });
      return;
    }
    // 只选择一件商品和商家后台只有一种取货方式时不弹窗 (多人点餐只有堂食)
    if (compData.pick_up_type.length === 1 && cartIdArray.length == 1 || compData.customFeature.is_together) {
      var currentLocationData = compData.currentLocationData;
      var selectSameJourney = compData.selectSameJourney;
      var data = {
        cart_id_arr: cartIdArray,
        filter_pick_up_type: compData.pick_up_type
      };
      if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
        if (!selectSameJourney && !currentLocationData) {
          _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
          return;
        }
        var lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
        var lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
        var regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
        data['latitude'] = lat;
        data['longitude'] = lng;
        data['region_id'] = regionId;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
        method: 'post',
        data: data,
        success: function success(res) {
          if (res.is_modify) {
            if (compData.customFeature.is_together) {
              that.getMultiOrderingVerticalCart(compindex, pageInstance);
            } else {
              that._getTakeoutStyleCartList(pageInstance, compindex);
            }
          }
          //同城和堂食需要判断是否在营业时间
          if (compData.customFeature.is_together) {
            if (!res.data || !res.data[4]) {
              _app.appMethod.showModal({
                content: '下单方式已关闭，无法下单，请联系管理员'
              });
              return;
            }
            if (res.data[4].dining_data.in_business_time === 0) {
              _app.appMethod.showModal({
                content: '不在营业时间'
              });
              return;
            }
          }
          if (compData.pick_up_type[0] == 2) {
            if (res.data[2].intra_city_data.in_business_time === 0) {
              _app.appMethod.showModal({
                content: '不在营业时间'
              });
              return;
            }
          }
          var addressId = compData.selectSameJourneyId;
          var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          addressId && (pagePath += '&addressId=' + addressId);
          compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
          compData.customFeature.is_together ? pagePath += '&is_together=true' : pagePath += '&is_together=false';
          pagePath += '&type=' + compData.pick_up_type[0];
          pageInstance.returnToVerticalFlag = 1;
          _app.appMethod.turnToPage(pagePath);
          return;
        }
      });
    } else {
      that.showSettlement(compindex);
      return;
    }
  };

  this.showSettlement = function (compindex) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    var cartIds = [];
    cartIds = _this4.getCartIdArray(compindex, pageInstance);
    var currentLocationData = compData.currentLocationData;
    var selectSameJourney = compData.selectSameJourney;
    if (!currentLocationData && !selectSameJourney) {
      _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + sub_shop_app_id + '&compindex=' + compindex + '&from=' + 'preview');
      return;
    }
    var lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
    var lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
    var regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
    if (!cartIds.length) {
      _app.appMethod.showModal({
        content: '请选择商品'
      });
      return;
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppEcommerce/getCanUsePickUpTypeAtCart',
      method: 'post',
      data: {
        latitude: lat,
        longitude: lng,
        region_id: regionId,
        cart_id_arr: cartIds,
        sub_shop_app_id: sub_shop_app_id || '',
        filter_pick_up_type: compData.pick_up_type
      },
      success: function success(res) {
        if (res.is_modify) {
          if (compData.customFeature.is_together) {
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
        var data = res.data;
        var cartIdArray = void 0;
        var type = 0;
        // 多件商品同时只支持一种取货方式时不弹窗
        if (data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[1].cart_list;
          type = 1;
        }
        if (!data.hasOwnProperty(1) && data.hasOwnProperty(2) && !data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[2].cart_list;
          type = 2;
        }
        if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && data.hasOwnProperty(3) && !data.hasOwnProperty(4)) {
          cartIdArray = data[3].cart_list;
          type = 3;
        }
        if (!data.hasOwnProperty(1) && !data.hasOwnProperty(2) && !data.hasOwnProperty(3) && data.hasOwnProperty(4)) {
          cartIdArray = data[4].cart_list;
          type = 4;
        }
        if (cartIdArray) {
          var franchiseeId = _app.appMethod.getPageFranchiseeId();
          var addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
          var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
          franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
          addressId && (pagePath += '&addressId=' + addressId);
          compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
          compData.customFeature.is_together ? pagePath += '&is_together=true' : pagePath += '&is_together=false';
          pagePath += '&type=' + type;
          pageInstance.returnToVerticalFlag = 1;
          _app.appMethod.turnToPage(pagePath);
          return;
        }
        var newdata = {};
        newdata['eles[' + compindex + '].canUsePickUpType'] = data;
        newdata['eles[' + compindex + '].intraCityData'] = data[2] && data[2].intra_city_data || '';
        newdata['eles[' + compindex + '].dining_data'] = data[4] && data[4].dining_data || '';
        newdata['eles[' + compindex + '].showSettlementMask'] = true;
        pageInstance.setData(newdata);
      }
    });
  };

  this.verticalListCloseSettlement = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].showSettlementMask'] = false;
    pageInstance.setData(newdata);
  };

  this.goodsPay = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var franchiseeId = _app.appMethod.getPageFranchiseeId(),
        cartIdArray = [],
        type = e.currentTarget.dataset.type,
        cartId = e.currentTarget.dataset.cartId,
        addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    cartIdArray = cartId;
    var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    compData.customFeature.is_together ? pagePath += '&is_together=true' : pagePath += '&is_together=false';
    pagePath += '&type=' + type;
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage(pagePath);
  };

  this.verticalListCloseVipDialog = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].showVipDialog'] = false;
    pageInstance.setData(newdata);
  };

  this.getGoodsVipCondtionInfo = function (compindex, goodsId) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var newdata = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getGoodsVipCondtionInfo',
      method: 'post',
      hideLoading: false,
      data: {
        goods_id: goodsId
      },
      success: function success(res) {
        if (res.status == 0) {
          newdata['eles[' + compindex + '].vipCondtionInfo'] = res.data;
          pageInstance.setData(newdata);
        }
      }
    });
  };

  this.scanMove = function (e) {
    e.stopPropagation;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var y = e.changedTouches[0].clientY;
    var width = _app.appMethod.getSystemInfoSync().windowWidth;
    var maxHeight = _app.appMethod.getSystemInfoSync().windowHeight - 208 / 750 * width;
    y = y < 120 ? 120 : y > maxHeight ? maxHeight : y;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].scanCode', y));
  };

  this.scanShopping = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var _this = _this4;
    var pre_location_id = compData.location_id || 0;
    var cartIdArray = [];
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId() || '';
    cartIdArray = _this.getMyCartIdArray(compindex, pageInstance);
    _app.appMethod.scanCode({
      success: function success(res) {
        var path = res.path;
        if (!path) {
          _app.appMethod.showModal({
            content: '位置码错误'
          });
          return;
        }
        var location_id = path.match(/\ec_location_id=(\S*)/) && path.match(/\ec_location_id=(\S*)/)[1];
        if (!location_id) {
          _app.appMethod.showModal({
            content: '位置码错误'
          });
          return;
        }
        _app.appMethod.sendRequest({
          url: "/index.php?r=AppEcommerce/getEcLocationData",
          data: {
            id: location_id,
            sub_shop_app_id: sub_shop_app_id || ''
          },
          hideLoading: true,
          success: function success(res) {
            if (res.status === 0) {
              compData['location_id'] = location_id;
              pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].location_id', location_id));
              var franchisee_id = _app.appMethod.getPageFranchiseeId();
              if (franchisee_id) {
                _app.appMethod.globalData[franchisee_id] = {};
                _app.appMethod.globalData[franchisee_id].ec_location_id = location_id;
              } else {
                _app.appMethod.globalData.ec_location_id = location_id;
              }
              setTimeout(function () {
                _app.appMethod.hideToast();
                _app.appMethod.showToast({
                  title: '已获取桌位号，可立即点餐啦',
                  icon: 'none',
                  duration: 2000
                });
              }, 1000);
              if (!compData.customFeature.is_together) {
                return;
              }
              var data = {
                location_id: location_id,
                cart_id_arr: cartIdArray,
                sub_shop_app_id: sub_shop_app_id || ''
              };
              pre_location_id ? data.pre_location_id = pre_location_id : '';
              _app.appMethod.sendRequest({
                url: "/index.php?r=AppEcommerce/scanQrcodeInitCartUserInfo",
                method: 'post',
                data: data,
                hideLoading: true,
                success: function success(res) {
                  compData.loopRequest = true;
                  _this.getDiningCart(pageInstance, compindex);
                }
              });
            }
          }
        });
      },
      fail: function fail(res) {
        console.log(res.errMsg);
      }
    });
  };

  this.getMultiOrderingVerticalCart = function (compindex, pageInstance, hideLoading, isFirst) {
    var that = _this4;
    var compData = pageInstance.data.eles[compindex];
    var data = {
      get_user_list: 1,
      page: -1,
      page_size: 1000,
      sub_shop_app_id: _app.appMethod.getPageFranchiseeId() || ''
    };
    var newdata = {};
    if (compData['location_id']) {
      data.location_id = compData['location_id'];
    }
    _app.appMethod.sendRequest({
      url: "/index.php?r=AppEcommerce/getMultiOrderingVerticalCart",
      method: 'get',
      data: data,
      hideLoading: hideLoading === false ? false : true,
      success: function success(res) {
        compData.flag = false;
        if (!compData.loopRequest) {
          return;
        }
        compData.loopRequest = false;
        if (res.status == 0) {
          if (res.is_notice) {
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].cartList', [{}]));
            _app.appMethod.showModal({
              content: "您的同桌" + res.buyer_nickname + '已下单'
            });
          }
          if (!compData.user_list || res.user_list.length !== compData.user_list.length) {
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].user_list', res.user_list));
          }
          var buyer_info = res.buyer_info;
          var user_list = res.user_list;
          var my_info = {};
          for (var i = 0; i < user_list.length; i++) {
            if (user_list[i].is_myself) {
              my_info = user_list[i];
            }
          }
          var hasMyInfo = false;
          for (var j = 0; j < buyer_info.length; j++) {
            if (my_info.buyer_id === buyer_info[j].buyer_id) {
              hasMyInfo = true;
              buyer_info.unshift(buyer_info.splice(j, 1)[0]);
            }
          }
          if (!hasMyInfo) {
            buyer_info.unshift(my_info);
          }
          pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].buyer_info', buyer_info));
          if (res.is_reload || isFirst || compData.is_init) {
            compData.is_init = false;
            pageInstance.setData({}, function () {
              that._parseDinningCartListData(res, pageInstance, compindex);
            });
          }
        }
      },
      complete: function complete() {
        compData.loopRequest = true;
      },
      fail: function fail() {
        _app.appMethod.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function confirm() {
            that.getMultiOrderingVerticalCart(compindex, pageInstance, hideLoading, isFirst);
          }
        });
      }
    });
  };

  this._parseDinningCartListData = function (cartlist, pageInstance, compindex) {
    var newdata = {},
        stockEmpty = false,
        compData = pageInstance.data.eles[compindex],
        totalNum = 0,
        totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    var goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    for (var k in goodsList) {
      goodsList[k].totalNum = 0;
    }
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    if (cartlist.data.length) {
      newdata['eles[' + compindex + '].cartlistData'] = [];
      var buyer_info = cartlist.buyer_info;
      var data = cartlist.data;
      var cartlistArr = [];
      for (var i = 0; i < buyer_info.length; i++) {
        cartlistArr[i] = {};
        for (var j = 0; j < data.length; j++) {
          var item = data[j];
          newdata['eles[' + compindex + '].cartlistData'].push(item);
          if (item.goods_type == 0) {
            if (+item.num > +item.stock) {
              item.num = item.stock;
              stockEmpty = true;
            }
            newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
            newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
              cart_id: item.id
            };
            if (compData.goods_data_list[item.goods_id] && i == 0) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
              if (pageInstance['verticalList' + compindex]['goods_model_list'][item.goods_id + '']) {
                if (pageInstance['verticalList' + compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                  pageInstance['verticalList' + compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum = +item.num;
                } else {
                  pageInstance['verticalList' + compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num;
                }
              }
            }
            if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
              newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
            }
            if (item.buyer_id === buyer_info[i].buyer_id) {
              cartlistArr[i][item.goods_id] = cartlistArr[i][item.goods_id] || {};
              cartlistArr[i][item.goods_id][item.model_id] = {
                list: 'list',
                id: item.goods_id,
                modelName: item.model_value ? item.model_value.join(' | ') : '',
                modelId: item.model_id,
                num: +item.num,
                price: +item.price,
                gooodsName: item.title,
                totalPrice: Number(item.num * item.price).toFixed(2),
                stock: item.stock,
                cart_id: item.id,
                in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
                pick_up_type: item.pick_up_type,
                is_vip_goods: item.cart_vip_goods && item.original_price != item.price || 0
              };
            }
          }
          if (i == 0) {
            totalNum += Number(item.num);
            totalPrice += Number(item.price) * item.num;
          }
        }
      }
      var userCart = cartlistArr[0];
      var myCartNum = 0;
      for (var _k in userCart) {
        for (var _j in userCart[_k]) {
          myCartNum += userCart[_k][_j].num;
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      newdata['eles[' + compindex + '].cartList'] = cartlistArr;
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        _app.appMethod.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        });
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        _this4._addTakeoutCart(options, _this4.eachCartList(options));
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
    pageInstance.setData(newdata);
  };

  this.getDiningCart = function (pageInstance, compindex) {
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    clearInterval(compData.timer);
    compData.timer = setInterval(function () {
      that.getMultiOrderingVerticalCart(compindex, pageInstance, true);
    }, 4000);
  };

  this.verticalListDeleteBuyerCarts = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var that = _this4;
    var index = dataset.index;
    var cartIds = [];
    var buyerCartList = compData.cartList[index];
    for (var i in buyerCartList) {
      for (var j in buyerCartList[i]) {
        if (buyerCartList[i][j].num > 0) {
          cartIds.push(buyerCartList[i][j].cart_id);
        }
      }
    }
    if (cartIds.length == 0) {
      _app.appMethod.showModal({
        content: '请先添加商品'
      });
      return;
    }
    _this4._removeFromCart(cartIds, function () {
      that._removeByerCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance,
        index: index
      });
    }, compindex);
  };

  this._removeByerCartCallback = function (options) {
    var n = {};
    var c = options.compindex;
    var goods_data_list = options.compData.goods_data_list;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var goods_model_list = pageInstance[c]['goods_model_list'];
    var index = options.index;
    n['eles[' + c + '].cartList' + '[' + index + ']'] = [{}];
    var buyerCartList = options.compData.cartList[index];
    var buyer_totalNum = 0;
    var buyer_totalPrice = 0;
    for (var goodsId in buyerCartList) {
      for (var i in buyerCartList[goodsId]) {
        buyer_totalNum += Number(buyerCartList[goodsId][i].num);
        buyer_totalPrice += Number((buyerCartList[goodsId][i].num * buyerCartList[goodsId][i].price).toFixed(2));
        if (goods_data_list[goodsId]) {
          goods_data_list[goodsId].totalNum -= buyerCartList[goodsId][i].num;
        }
      }
    }
    for (var _i8 in goods_model_list) {
      for (var j in goods_model_list[_i8].goods_model) {
        goods_model_list[_i8].goods_model[j].totalNum = 0;
      }
    }
    if (index === 0) {
      n['eles[' + c + '].myCartNum'] = 0;
    }
    n['eles[' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].TotalNum'] = options.compData.TotalNum - buyer_totalNum;
    n['eles[' + c + '].TotalPrice'] = Number(options.compData.TotalPrice - buyer_totalPrice).toFixed(2);
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  };

  this.saveFormId = function (form_id) {
    var that = _this4;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
      data: {
        form_id: form_id
      },
      method: 'post',
      success: function success(res) {
        console.log(res);
      }
    });
  };

  this.scrollStart = function (e) {
    _app.appMethod.scrollStart(e);
  };

  this.scrollMove = function (e) {
    _app.appMethod.scrollMove(e);
  };

  this.scrollEnd = function (e) {
    _app.appMethod.scrollEnd(e);
  };

  this.stopAnimation = function (e) {
    _app.appMethod.stopAnimation(e);
  };

  this.previewImage = function (e) {
    var _e$currentTarget$data = e.currentTarget.dataset,
        src = _e$currentTarget$data.src,
        imgarr = _e$currentTarget$data.imgarr;

    _app.appMethod.previewImage({
      current: src,
      urls: JSON.parse(imgarr)
    });
  };

  this.stopPropagation = function (e) {
    e.stopPropagation();
  };
};

exports.default = VerticalListCustomComponent;

/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(925);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: "stored-value" 
 * 组件：储值项列表组件
 * TODO: ；
 */

var StoredValueCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(StoredValueCustomComponent, _React$Component);

  function StoredValueCustomComponent(props) {
    (0, _classCallCheck3.default)(this, StoredValueCustomComponent);

    var _this = (0, _possibleConstructorReturn3.default)(this, (StoredValueCustomComponent.__proto__ || Object.getPrototypeOf(StoredValueCustomComponent)).call(this, props));

    _initialiseProps.call(_this);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this.init(compindex, pageInstance);
    return _this;
  }

  //获取储值项


  //拼接赠送说明


  //跳转充值详情


  //立即充值按钮


  (0, _createClass3.default)(StoredValueCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // 组件数据
      var data = this.props.data;
      // 组件配置对象
      var customFeature = data.customFeature;
      // 组件样式
      var styleObj = (0, _tools.convertStyleData)(data.style);
      var color = customFeature.styleColor;

      return _react2.default.createElement(
        'div',
        { className: 'custom-component stored-value', style: styleObj },
        data.stored_value_list && data.stored_value_list.length !== 0 && data.stored_value_list.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { className: 'value-item', key: index, style: { borderTopColor: color },
              onClick: _this2.turnToStoredValue,
              'data-storedid': item.id
            },
            _react2.default.createElement(
              'div',
              { className: 'item-info' },
              _react2.default.createElement(
                'div',
                { className: 'pirce-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'title' },
                  item.price,
                  '\u5143\u50A8\u503C\u91D1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'gift' },
                  item.instructions
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'btn-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'btn', style: { backgroundColor: color },
                    onClick: _this2.gotoRecharge,
                    'data-storedid': item.id
                  },
                  '\u7ACB\u5373\u5145\u503C'
                ),
                _react2.default.createElement('div', { className: 'fir-color', style: { backgroundColor: color } }),
                _react2.default.createElement('div', { className: 'sec-color', style: { backgroundColor: color } }),
                _react2.default.createElement('div', { className: 'thi-color', style: { backgroundColor: color } })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'desc' },
              '\u8BF4\u660E\uFF1A',
              item.description_type == 1 ? _react2.default.createElement(
                'span',
                null,
                item.description
              ) : _react2.default.createElement(
                'span',
                null,
                '\u8BF7\u67E5\u770B\u8BE6\u60C5'
              )
            )
          );
        }),
        data.stored_value_list && data.stored_value_list.length === 0 && _react2.default.createElement(
          'div',
          null,
          '\u6682\u65E0\u50A8\u503C'
        )
      );
    }
  }]);
  return StoredValueCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.init = function (compindex, pageInstance) {
    _this3.getItemInfo(compindex, pageInstance);
  };

  this.getItemInfo = function (compindex, pageInstance) {
    var that = _this3;
    var data = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getStoredItems',
      success: function success(res) {
        if (res.data.length != 0) {
          var newData = res.data;
          data['eles[' + compindex + '].stored_value_list'] = that.givingInstructions(newData);
        }
        pageInstance.setData(data);
      }
    });
  };

  this.givingInstructions = function (data) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        var dataArr = [];
        var instructions = '';
        item.g_price = Number(item.g_price);
        if (item.g_price) {
          dataArr.push(item.g_price + '元');
        }
        item.g_integral = Number(item.g_integral);
        if (item.g_integral) {
          dataArr.push(item.g_integral + '积分');
        }
        if (item.g_vip_card && item.g_vip_card.title) {
          dataArr.push(item.g_vip_card.title);
        }
        if (item.g_coupon_list && item.g_coupon_list.length) {
          dataArr.push(item.g_coupon_list[0].num + '张' + item.g_coupon_list[0].title);
        }
        for (var i = 0; i < dataArr.length; i++) {
          if (i != dataArr.length - 1) {
            instructions = instructions + dataArr[i] + '、';
          } else {
            instructions = instructions + dataArr[i];
          }
        }
        if (instructions) {
          item.instructions = '赠送' + instructions;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return data;
  };

  this.turnToStoredValue = function (event) {
    var sotredId = event.currentTarget.dataset.storedid;
    var path = 'recharge?storedId=' + sotredId;
    _app.appMethod.turnToPage(path);
  };

  this.gotoRecharge = function (event) {
    var that = _this3;
    var param = {
      type: 1
    };
    param['stored_id'] = event.currentTarget.dataset.storedid;
    param['form_id'] = event.detail.formId;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/creatStoredItemOrder',
      data: param,
      success: function success(res) {
        if (!res.status) {
          var orderId = res.data;
          // app.sendRequest({
          //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
          //   data: {
          //     order_id: orderId
          //   },
          //   success: function (res) {
          //     var param = res.data;
          //     param.orderId = orderId;
          //     param.success = function () {
          //       app.showToast({
          //         title: '充值成功',
          //         success: function () {
          //           setTimeout(function () {
          //             app.turnToPage('/eCommerce/pages/balance/balance');
          //           }, 1500);
          //         }
          //       });
          //     };
          //     param.fail = function () {
          //     }
          //     app.wxPay(param);
          //   },
          //   fail: function () {
          //     app.showToast({
          //       title: res.data,
          //     });
          //   }
          // });
          _app.appMethod.goPay({
            orderId: orderId,
            successUrl: '/balance'
          });
        } else {}
      }
    });
    event.stopPropagation();
  };
};

exports.default = StoredValueCustomComponent;

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = UploadVideoCustomComponent;

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(927);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'upload-vieo'
 * 组件：动态表单：添加视频
 */
function UploadVideoCustomComponent(props) {
  var _this = this;

  /**
   * 传入数据
   */
  var data = props.data; // 组件数据
  var dynamicData = props.dynamicData; // 动态数据
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入数据
  /**
   * 组件配置对象
   */
  var customFeature = data.customFeature;
  var segment = customFeature.segment;
  var upVideoCount = customFeature.segment;
  /**
   * 样式数据处理
   */
  var styleObj = (0, _extends3.default)({
    paddingLeft: '.17rem',
    paddingRight: '.27rem'
  }, (0, _tools.convertStyleData)(data.style));

  /**
   * 绑定事件
   */

  var uploadFormVideo = function uploadFormVideo(res) {
    var dataset = event.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var datakey = dataset.datakey;
    var segment = dataset.segment;
    var formId = dataset.formcompid;

    // TODO: 功能暂不支持提醒
    _this.noDevelopCompleted();
    return;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }
    var hasVideoList = pageInstance.data[formId].form_data ? pageInstance.data[formId].form_data[segment] || [] : [];
    _app.appMethod.chooseVideo({
      success: function success(bar) {
        _app.appMethod.showLoading({
          title: '视频上传中'
        });
        if (bar == 100) {
          _app.appMethod.hideLoading();
        }
      },
      fail: function fail(err, result) {
        if (err.errMsg != 'chooseVideo:fail cancel') {
          _app.appMethod.showModal({
            content: '上传出错，请重新选择上传'
          });
        }
      },
      complete: function complete(res) {
        var newdata = {};
        var video = {
          'id': res['video']['video_id'],
          'fileName': res['video']['video_url'],
          'previewImageUrl': res['video']['image_url'],
          'fileSize': res['video']['file_size'],
          'type': 'video',
          'virtual': '',
          'isFull': false
        };
        hasVideoList.push(video);
        newdata[datakey] = hasVideoList;
        pageInstance.setData(newdata);
      }
    }, 15);

    // 以下代价不知道需不需要,等确定后再删除
    // let pageInstance = app.getAppCurrentPage();
    // let formcompindex = formCompindex;
    // let segment      = customFeature.segment;
    // let datakey = `eles[${formcompindex}].form_data.${segment}`;

    // let newdata = {};
    // let hasVideoList = form_data[segment] || [];
    // console.log('upload', res)
    // let video = {
    //   'id': res['video']['video_id'],
    //   'fileName': res['video']['video_url'],
    //   'previewImageUrl': res['video']['image_url'],
    //   'fileSize': res['video']['file_size'],
    //   'type': 'video',
    //   'virtual': '',
    //   'isFull': false
    // };
    // newdata[datakey] = [...hasVideoList, video];
    // pageInstance.setData(newdata);
  };

  var noDevelopCompleted = function noDevelopCompleted() {
    _app.appMethod.showModal({
      content: '该组件【添加视频】在webapp端尚在开发中'
    });
  };

  var noBindSegment = function noBindSegment() {
    _app.appMethod.showModal({
      content: '该组件【添加视频】未绑定字段 请在电脑编辑页绑定后使用'
    });
  };

  var deleteUploadVideo = function deleteUploadVideo(event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var formcompindex = formCompindex;
    var datakey = 'eles[' + formcompindex + '].form_data.' + customFeature.segment;
    _app.appMethod.showModal({
      content: '确定删除该视频？',
      showCancel: true,
      confirm: function confirm() {
        var newdata = {};
        form_data[segment].splice(index, 1);
        newdata[datakey] = form_data[segment];
        pageInstance.setData(newdata);
      }
    });
  };

  var bindplay = function bindplay(event) {
    console.log('暂未处理');
    return;
  };

  var bindPlayVideo = function bindPlayVideo(event) {
    console.log('暂未处理');
    return;
  };

  var bindFullVideo = function bindFullVideo(event) {
    console.log('暂未处理');
    return;
  };

  return React.createElement(
    'div',
    { className: 'custom-component upload-video ' + (data.segment_required ? 'must' : ''), style: styleObj },
    form_data[segment] && form_data[segment].map(function (item, index) {
      return React.createElement(
        'div',
        { key: item, className: 'has-upload-video' },
        React.createElement(
          'div',
          { className: 'video-cover' },
          !item.isFull && React.createElement('div', { className: 'ico-moon icon-closes delete-img', onClick: function onClick() {
              return deleteUploadVideo(index);
            } }),
          React.createElement('div', { className: 'controls',
            hidden: item.fileName == item.virtual,
            onClick: bindplay }),
          React.createElement('video', { controls: true,
            className: 'video',
            onPlay: bindPlayVideo })
        )
      );
    }),
    (!form_data[segment] || form_data[segment].length < upVideoCount) && React.createElement(
      'div',
      { className: 'plus-div',
        'data-compindex': props.index,
        'data-formcompid': data.formCompid,
        'data-segment': data.customFeature.segment,
        'data-datakey': data.formCompid + '.form_data.' + data.customFeature.segment,
        onClick: uploadFormVideo
      },
      React.createElement(
        'span',
        null,
        '\uFF0B'
      ),
      React.createElement(
        'div',
        null,
        '\u6DFB\u52A0\u89C6\u9891'
      ),
      segment && React.createElement('div', { onClick: noDevelopCompleted }),
      !segment && React.createElement('div', { onClick: noBindSegment })
    )
  );
}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

exports.default = AnonymousEleCustomComponent;

__webpack_require__(20);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

__webpack_require__(929);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: 'anonymous-ele'
 * 组件：动态表单：匿名组件
 */
function AnonymousEleCustomComponent(props) {
  /**
   * @desc 传入数据
   */
  var data = props.data;
  var formCompindex = props.formCompindex; // 动态表单索引
  var form_data = props.form_data || {}; // 动态表单传入

  /**
   * @desc 组件配置对象
   */
  var customFeature = data.customFeature;
  /**
   * @desc 样式数据处理
   */
  var styleObj = (0, _tools.convertStyleData)(data.style);

  var titleStyleObj = (0, _tools.convertStyleData)(customFeature.titleStyle);
  titleStyleObj['height'] = titleStyleObj['lineHeight'];

  var contentStyleObj = (0, _tools.convertStyleData)(customFeature.contentStyle);
  contentStyleObj['height'] = contentStyleObj['lineHeight'];

  /**
   * 组件内容处理
   */
  var contents = customFeature.contents;
  /**
   * @desc 处理成组件需要的格式
   */
  contents.forEach(function (item) {
    item['optionsData'] = item['options'].map(function (item, index) {
      return {
        label: item,
        value: item
      };
    });
  });

  var changeAnonymous = function changeAnonymous(v, i) {
    var value = v;
    var index = i;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = props.index;
    var formcompindex = formCompindex;
    var segment = customFeature.segment;
    var componentKey = 'eles[' + formcompindex + '].content[' + compindex + ']';
    var datakey = 'eles[' + formCompindex + '].form_data.' + customFeature.segment;

    if (!segment) {
      _app.appMethod.showModal({
        content: '该组件【匿名组件】未绑定字段 请在电脑编辑页绑定后使用'
      });
      return;
    }

    var newdata = {};
    newdata[componentKey + '.anonymous'] = data.anonymous || [];
    newdata[componentKey + '.anonymous'][index] = value;
    newdata[datakey] = value == '实名提交' ? _app.appMethod.globalData.userInfo.nickname || '获取失败' : '匿名提交';

    pageInstance.setData(newdata);
  };

  return React.createElement(
    'div',
    { className: 'custom-component anonymous-ele' },
    React.createElement(
      'div',
      { className: 'drop-down', style: styleObj },
      React.createElement(
        'div',
        { style: titleStyleObj },
        customFeature.name
      ),
      contents.map(function (item, index) {
        return React.createElement(
          _picker2.default,
          { key: index,
            cols: 1,
            data: item.optionsData,
            onChange: function onChange(value) {
              return changeAnonymous(value, index);
            } },
          React.createElement(
            'div',
            { className: 'picker-title', style: contentStyleObj },
            data.anonymous && data.anonymous[index] || item.name
          )
        );
      })
    )
  );
}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(37);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _typeof2 = __webpack_require__(21);

var _typeof3 = _interopRequireDefault(_typeof2);

var _icon = __webpack_require__(26);

var _icon2 = _interopRequireDefault(_icon);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(27);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

var _LoadingBtn = __webpack_require__(45);

__webpack_require__(931);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * type: community-goods-list
 * 组件：社区团购-社区团购活动列表
 */

var stockChangeModule = {
  stockChange: function stockChange(a) {
    var b = a;
    if (a > 10000) {
      b = parseInt(a / 10000) + 'w';
    }
    return b;
  }
};

var CommuntiyGoodsListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(CommuntiyGoodsListCustomComponent, _React$Component);

  function CommuntiyGoodsListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, CommuntiyGoodsListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CommuntiyGoodsListCustomComponent.__proto__ || Object.getPrototypeOf(CommuntiyGoodsListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance);
    return _this2;
  }

  // 根据经纬度获取团长


  // 判断团长可不可用


  (0, _createClass3.default)(CommuntiyGoodsListCustomComponent, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;

      // 样式数据处理
      var styleObj = (0, _tools.convertStyleData)(data.style);

      // 顶部搜索框
      var $searchWrap = function $searchWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'search-box',
            style: {
              height: data.customFeature.searchSetting.height,
              marginTop: data.customFeature.searchSetting['margin-top']
            } },
          _react2.default.createElement(
            'div',
            { className: 'search-input' },
            _react2.default.createElement(_icon2.default, { size: 'xxs', type: 'search', color: '#999' }),
            _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u641C\u7D22\u5185\u5BB9', onKeyDown: function onKeyDown(e) {
                return _this3.searchGoodsList(e);
              }, 'data-compindex': _this3.props.index })
          )
        );
      };

      // 头部内容
      var $headWrap = function $headWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'community-head',
            style: {
              height: data.customFeature.groupSetting.height, marginTop: data.customFeature.groupSetting['margin-top'],
              background: data.customFeature.groupSetting.background
            } },
          _react2.default.createElement('img', { className: 'colone-avatar',
            src: data.leaderInfo && data.leaderInfo.logo || 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/new-zhichi-default.png' }),
          _react2.default.createElement(
            'div',
            { className: 'colone-detail-box' },
            _react2.default.createElement(
              'div',
              { className: 'colone-name',
                style: {
                  color: data.customFeature.groupSetting['group-color'],
                  fontSize: data.customFeature.groupSetting['group-font-size']
                } },
              data.leaderInfo && data.leaderInfo.nick_name ? data.leaderInfo.nick_name + '-' : '暂无团长',
              data.leaderInfo && data.leaderInfo.housing_estate || ''
            ),
            _react2.default.createElement(
              'div',
              { className: 'colone-address',
                style: {
                  color: data.customFeature.groupSetting['address-color'],
                  fontSize: data.customFeature.groupSetting['address-font-size']
                } },
              '\u81EA\u63D0\u5730\u5740\uFF1A',
              data.leaderInfo && data.leaderInfo.address_detail || "暂未设置"
            )
          ),
          data.customFeature.groupSetting.changeCaptain && _react2.default.createElement(
            'div',
            { className: 'change-captain',
              'data-compindex': data.compindex,
              onClick: data.leaderInfo ? _this3.chengeCommunityGroup : _this3.isOpenCommunityGroup,
              style: { color: data.customFeature.groupSetting['btn-color'], background: data.customFeature.groupSetting['btn-background'] } },
            _react2.default.createElement('span', { className: 'ico-moon icon-change' }),
            data.leaderInfo ? '切换团长' : '申请团长'
          ),
          !!(data.buyerInfoList && data.buyerInfoList.length) && _react2.default.createElement(
            'div',
            { className: 'scroll-avatar-box' },
            _react2.default.createElement(
              'div',
              { className: 'community-buyer-scrollling' },
              _react2.default.createElement(
                'div',
                { className: 'scroll-avatar' },
                _react2.default.createElement('img', { src: '{{data.buyerInfoList[data.buyerIndex].buyer_info.logo}}' }),
                _react2.default.createElement(
                  'span',
                  { className: 'scroll-name' },
                  data.buyerInfoList[data.buyerIndex].buyer_info.nickname
                ),
                '\u4E0B\u5355\u6210\u529F\u4E86'
              )
            )
          )
        );
      };

      // 时间轴1
      var $timeLineOne = function $timeLineOne() {
        return _react2.default.createElement(
          'div',
          { className: 'time-line-box',
            onClick: _this3.getTimeLineGoods,
            'data-compindex': _this3.props.index,
            style: {
              background: data.customFeature.timeLineSetting['background'],
              marginTop: data.customFeature.timeLineSetting['margin-top']
            } },
          data.customFeature.timeLineSetting.content.map(function (item, index) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: index },
              _react2.default.createElement(
                'div',
                { 'data-type': index,
                  style: {
                    fontWeight: data.status == index ? 600 : '',
                    color: data.status == index ? data.customFeature.timeLineSetting['underline-color'] : ''
                  } },
                item.name,
                data.status == index && _react2.default.createElement('span', { className: 'under-line',
                  style: {
                    background: data.customFeature.timeLineSetting['underline-color'],
                    height: data.customFeature.timeLineSetting['underline-height']
                  } })
              )
            );
          })
        );
      };

      // 时间轴2
      var $timeLineTwo = function $timeLineTwo() {
        return _react2.default.createElement(
          'div',
          { className: 'time-line-box',
            onClick: _this3.getTimeLineGoods,
            'data-compindex': _this3.props.index,
            style: {
              background: data.customFeature.timeLineSetting['background'],
              marginTop: data.customFeature.timeLineSetting['margin-top']
            } },
          data.customFeature.timeLineSetting.content.map(function (item, index) {
            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: index },
              item.show && _react2.default.createElement(
                'div',
                { 'data-type': index, className: data.status == index ? 'selected' : '' },
                _react2.default.createElement(
                  'span',
                  { 'data-type': index,
                    style: { background: data.status == index ? data.customFeature.timeLineSetting['slected-color'] : null } },
                  item.name
                )
              )
            );
          })
        );
      };

      // 社区活动商品列表
      var $goodsList = function $goodsList() {
        return _react2.default.createElement(
          _ScrollView.ScrollView,
          { className: 'scroll-ele ' + data.type,
            'scroll-y': 'true',
            bindscrolltolower: _this3.communityGoodsScrollFunc,
            style: { height: data.customFeature.height },
            bindanimationend: 'animationEnd',
            'data-compindex': _this3.props.index,
            'data-type': data.type },
          data.communityGoodsDat && data.communityGoodsData.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: 'community-goods-item',
                key: item.id,
                'data-leader-token': data.leaderInfo && data.leaderInfo.user_token,
                'data-goods-id': item.id,
                onClick: _this3.toCommunityGoodsDetail,
                'data-group-id': item.group_id,
                style: {
                  marginTop: data.customFeature.margin,
                  height: data.customFeature.goodsList['height']
                } },
              _react2.default.createElement(
                'div',
                { className: 'community-goods-image', style: { width: data.customFeature.imgWidth, height: data.customFeature.imgHeight } },
                _react2.default.createElement('img', { src: item.cover }),
                item.form_data.corner_mark > 0 && _react2.default.createElement('img', { className: 'goods-subscript', src: item.form_data.corner_url }),
                item.dis_group_status == 2 && _react2.default.createElement('img', { className: 'group-end', src: 'http://cdn.jisuapp.cn/static/webapp/images/promotion/group-end.png' }),
                item.stock == 0 && _react2.default.createElement('img', { className: 'group-no-stock', src: 'http://cdn.jisuapp.cn/static/webapp/images/promotion/group-no-stock.png' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'item-content-box' },
                _react2.default.createElement(
                  'div',
                  { className: 'community-good-title', style: { fontSize: data.customFeature.goodsList['font-size'] } },
                  item.title
                ),
                (item.dis_group_status == 2 || item.stock == 0) && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'end-progress-bar-box' },
                    _react2.default.createElement('span', { className: 'ico-moon icon-community-group-fire' }),
                    '\u5DF2\u552E',
                    item.sales,
                    '\u4EF6'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'community-stock' },
                    '\u5269\u4F59',
                    stockChangeModule.stockChange(item.stock),
                    '\u4EF6'
                  )
                ),
                item.dis_group_status == 1 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'progress-bar-box' },
                    _react2.default.createElement('span', { className: 'ico-moon icon-community-group-fire' }),
                    _react2.default.createElement(
                      'span',
                      null,
                      '\u5DF2\u552E',
                      item.sales,
                      '\u4EF6'
                    )
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'community-stock' },
                    '\u5269\u4F59',
                    stockChangeModule.stockChange(item.stock),
                    '\u4EF6'
                  )
                ),
                item.dis_group_status == 3 || item.dis_group_status == 4 || item.dis_group_status == 5 && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'unstart-progress-bar-box' },
                    _react2.default.createElement('span', { className: 'ico-moon icon-about-start' }),
                    '\u5373\u5C06\u5F00\u59CB'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'community-stock' },
                    '\u4EC5\u5269',
                    stockChangeModule.stockChange(item.stock),
                    '\u4EF6'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'community-good-price ' + (item.dis_group_status == 2 || item.stock == 0 ? 'end-pirce' : '') },
                  _react2.default.createElement(
                    'span',
                    { className: 'community-price-icon' },
                    '\xA5'
                  ),
                  item.form_data.max_price || item.price,
                  item.virtual_price != 0 && _react2.default.createElement(
                    'span',
                    { className: 'community-virtual-price' },
                    '\xA5',
                    item.form_data.virtual_max_price || item.virtual_price
                  )
                ),
                item.dis_group_status == 1 && item.stock != 0 && _react2.default.createElement('div', { className: 'add-community-cart ico-moon icon-community-group-goods-cart',
                  onClick: _this3.addCommunityCart,
                  'data-compindex': _this3.props.index,
                  'data-id': item.id })
              )
            );
          }),
          data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
          data.is_more == 0 && data.communityGoodsData.length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: "暂无活动商品~" } }),
          data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'communityGoodsScrollFunc', compindex: _this3.props.index } }),
          data.is_more == 0 && data.communityGoodsData.length > 0 && data.customFeature.isShowFinishText && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestAll' }),
          data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!+data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail && _react2.default.createElement(_LoadingBtn.LoadingBtn, { customFeature: data.customFeature, 'data-compindex': _this3.props.index, onClick: _this3.communityGoodsScrollFunc })
        );
      };

      // 加入购物车
      var $shoppingCart = function $shoppingCart() {
        return _react2.default.createElement(
          'div',
          { className: 'goods-detail-dialog', hidden: !data.showGoodsDetail },
          _react2.default.createElement(
            'div',
            { className: 'goods-detail-contain' },
            _react2.default.createElement('div', { className: 'ico-moon icon-closes', onClick: _this3.hideGoodsDialog, 'data-compindex': _this3.props.index }),
            _react2.default.createElement(
              'div',
              { className: 'goods-detail-header' },
              _react2.default.createElement('img', { className: 'community-goods-cover', src: data.selectGoodsModelInfo && data.selectGoodsModelInfo.imgurl || data.goodsDetail && data.goodsDetail.cover }),
              _react2.default.createElement(
                'div',
                { className: 'select-goods-info' },
                _react2.default.createElement(
                  'div',
                  { className: 'community-goods-price' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\xA5',
                    data.selectGoodsModelInfo && data.selectGoodsModelInfo.price
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'community-goods-stock' },
                  '\u5E93\u5B58',
                  data.selectGoodsModelInfo && data.selectGoodsModelInfo.stock
                ),
                data.selectGoodsModelInfo && data.selectGoodsModelInfo.models_text && _react2.default.createElement(
                  'div',
                  { className: 'select-model' },
                  '\u5DF2\u9009\uFF1A',
                  data.selectGoodsModelInfo.models_text
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-detail-content' },
              _react2.default.createElement(
                'div',
                { className: 'goods-dialog-content', hidden: !(data.goodsDetail && data.goodsDetail.model.length) },
                data.goodsDetail && data.goodsDetail.model.map(function (model, modelIndex) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'goods-model', key: modelIndex },
                    _react2.default.createElement(
                      'div',
                      { className: 'model-title' },
                      model.name
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'sub-model' },
                      model.subModelName(function (subModelName, submodelIndex) {
                        return _react2.default.createElement(
                          'text',
                          {
                            key: submodelIndex,
                            'data-compindex': _this3.props.index,
                            'data-model-index': modelIndex,
                            'data-submodel-index': submodelIndex,
                            className: 'subModel ' + (data.selectGoodsModelInfo.models[modelIndex] == model.subModelId[submodelIndex] ? 'select' : ''),
                            'data-submodel-id': model.subModelId[submodelIndex], onClick: _this3.selectGoodsSubModel },
                          subModelName
                        );
                      })
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-num-contain' },
              _react2.default.createElement(
                'span',
                { className: 'goods-num-title' },
                '\u8D2D\u4E70\u6570\u91CF\uFF1A'
              ),
              _react2.default.createElement('div', { className: 'good-number-box pull-right' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-shopping-bottom' },
              _react2.default.createElement(
                'div',
                { className: 'add-shoppingcart', onClick: _this3.sureAddToShoppingCart, 'data-compindex': _this3.props.index },
                '\u52A0\u5165\u8D2D\u7269\u8F66'
              )
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component community-goods-list' },
        _react2.default.createElement(
          'div',
          { className: 'element community-goods-list', style: styleObj },
          data.customFeature.showSearch && $searchWrap(),
          data.customFeature.showGroup && $headWrap(),
          data.customFeature.timeLineSetting.timeLineStyle == 1 && data.customFeature.showTimeline && $timeLineOne(),
          data.customFeature.timeLineSetting.timeLineStyle == 2 && data.customFeature.showTimeline && $timeLineTwo(),
          $goodsList(),
          $shoppingCart()
        )
      );
    }
  }]);
  return CommuntiyGoodsListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.init = function (compindex, pageInstance) {
    _this4.getGoodsIdxList(compindex);
    var _this = _this4;
    var customFeature = pageInstance.data.eles[compindex].customFeature;
    var locationInfo = _app.appMethod.globalData.locationInfo;
    var param = {};
    var data = {};
    data['eles[' + compindex + '].communityGoodsData'] = [];
    pageInstance.setData(data);
    if (customFeature.groupSetting && customFeature.groupSetting.height.indexOf('rem') < 0) {
      customFeature.margin = parseInt(customFeature.margin) * 2.34 / 100 + 'rem';
      customFeature.imgWidth = parseInt(customFeature.imgWidth) * 2.34 / 100 + 'rem';
      customFeature.imgHeight = parseInt(customFeature.imgHeight) * 2.34 / 100 + 'rem';
      customFeature.groupSetting.height = parseInt(customFeature.groupSetting.height) * 2.34 / 100 + 'rem';
      customFeature.groupSetting['margin-top'] = parseInt(customFeature.groupSetting['margin-top']) * 2.34 / 100 + 'rem';
      customFeature.groupSetting['address-font-size'] = parseInt(customFeature.groupSetting['address-font-size']) * 2.34 / 100 + 'rem';
      customFeature.groupSetting['group-font-size'] = parseInt(customFeature.groupSetting['group-font-size']) * 2.34 / 100 + 'rem';
      customFeature.timeLineSetting.height = parseInt(customFeature.timeLineSetting.height) * 2.34 / 100 + 'rem';
      customFeature.timeLineSetting['margin-top'] = parseInt(customFeature.timeLineSetting['margin-top']) * 2.34 / 100 + 'rem';
      customFeature.timeLineSetting['underline-height'] = parseInt(customFeature.timeLineSetting['underline-height']) * 2.34 / 100 + 'rem';
      customFeature.timeLineSetting['font-size'] = parseInt(customFeature.timeLineSetting['font-size']) * 2.34 / 100 + 'rem';
      customFeature.searchSetting.height = parseInt(customFeature.searchSetting.height) * 2.34 / 100 + 'rem';
      customFeature.searchSetting['margin-top'] = parseInt(customFeature.searchSetting['margin-top']) * 2.34 / 100 + 'rem';
      customFeature.goodsList['font-size'] = parseInt(customFeature.goodsList['font-size']) * 2.34 / 100 + 'rem';
      customFeature.goodsList['height'] = parseInt(customFeature.goodsList['height']) * 2.34 / 100 + 'rem';
      if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
        customFeature.height = 'auto';
      } else {
        customFeature.height = parseInt(customFeature.height) * 2.34 / 100 + 'rem';
      }
      var newData = {};
      newData['eles[' + compindex + '].customFeature'] = customFeature;
      pageInstance.setData(newData);
    }
    if (customFeature.showTimeline) {
      var _newData = {};
      var timeLineContent = customFeature.timeLineSetting.content;
      for (var i = 0; i < timeLineContent.length; i++) {
        if (timeLineContent[i].show) {
          _newData['eles[' + compindex + '].status'] = i;
          break;
        }
      }
      pageInstance.setData(_newData);
    } else {
      var _newData2 = {};
      if (customFeature.startActive && !customFeature.finishActive) {
        _newData2['eles[' + compindex + '].status'] = 5;
      } else if (!customFeature.startActive && customFeature.finishActive) {
        _newData2['eles[' + compindex + '].status'] = 6;
      } else if (customFeature.startActive && customFeature.finishActive) {
        _newData2['eles[' + compindex + '].status'] = 7;
      } else if (!customFeature.startActive && !customFeature.finishActive) {
        _newData2['eles[' + compindex + '].status'] = 0;
      }
      pageInstance.setData(_newData2);
    }
    // 切换团长后不需要重新请求团长列表
    if (pageInstance.data.eles[compindex].leaderInfo) {
      _this.getCommunityGoodsList(compindex);
      return;
    }
    // 判断分享进来的团长可不可用
    if (_app.appMethod.globalData.communityUserToken) {
      _this4.checkGroupGoodsLeader(compindex, _app.appMethod.globalData.communityUserToken);
      return;
    }
    // 获取上一次团长
    _app.appMethod.getStorage({
      key: 'groupToken',
      complete: function complete(res) {
        if (res && res.data) {
          _this.checkGroupGoodsLeader(compindex, res.data);
        } else if (locationInfo.latitude) {
          _this.latitude = locationInfo.latitude;
          _this.longitude = locationInfo.longitude;
          _this.getGoodsGroupList(compindex, param);
        } else {
          _app.appMethod.getLocation({
            type: 'gcj02',
            success: function success(res) {
              var latitude = res.latitude;
              var longitude = res.longitude;
              pageInstance.requestNum++;
              _app.appMethod.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function success(res) {
                  _app.appMethod.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: res.data.formatted_addresses.recommend,
                    info: res.data
                  });
                }
              });
              _this.latitude = latitude;
              _this.longitude = longitude;
              _this.getGoodsGroupList(compindex);
            },
            fail: function fail(res) {
              var newdata = {};
              if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
                newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
              } else {
                newdata['eles[' + compindex + '].location_address'] = '定位失败';
              }
              pageInstance.setData(newdata);
            }
          });
        }
      }
    });
  };

  this.getGoodsGroupList = function (compindex) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetDistributorExtList',
      method: 'post',
      data: {
        latitude: _this4.latitude,
        longitude: _this4.longitude,
        is_audit: 1,
        filter_deleted: 1
      },
      success: function success(res) {
        if (res.data.length) {
          var data = {};
          data['eles[' + compindex + '].leaderInfo'] = res.data[0];
          // 储存上一次的团长userToken
          _app.appMethod.setStorage({
            key: 'groupToken',
            data: res.data[0].user_token
          });
          pageInstance.setData(data);
        }
        _this.getCommunityGoodsList(compindex);
      }
    });
  };

  this.communityGoodsScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = (typeof event === 'undefined' ? 'undefined' : (0, _typeof3.default)(event)) == 'object' ? event.currentTarget.dataset.compindex : event;
    var compData = pageInstance.data.eles[compindex];
    var page = compData.page + 1;
    var newdata = {};
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].page'] = page;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    _this4.getCommunityGoodsList(compindex);
  };

  this.chengeCommunityGroup = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var token = pageInstance.data.eles[compindex].leaderInfo.user_token;
    var router = _app.appMethod.returnSubPackageRouter("communityGroupSearchVillage");
    _app.appMethod.turnToPage(router + '?token=' + token + '&compindex=' + compindex);
  };

  this.toCommunityGoodsDetail = function (e) {
    var goodsId = e.currentTarget.dataset.goodsId;
    var groupId = e.currentTarget.dataset.groupId;
    var leader_token = e.currentTarget.dataset.leaderToken || '';
    var router = _app.appMethod.returnSubPackageRouter("commuGroupGoods") + ('?goodsId=' + goodsId + '&group_id=' + groupId + '&leaderToken=' + leader_token);
    _app.appMethod.turnToPage(router);
  };

  this.getCommunityGoodsList = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindexParam = pageInstance.data.eles[compindex];
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsList',
      method: 'post',
      data: {
        idx_arr: {
          idx: 'title',
          idx_value: compindexParam.idx_value
        },
        is_stock_gte_zero: compindexParam.customFeature.soldOut ? 1 : 0,
        status: compindexParam.status >= 0 ? compindexParam.status + 1 : -1,
        page_size: compindexParam.customFeature.loadingNum || 10,
        page: compindexParam.page || 1,
        leader_token: compindexParam.leaderInfo ? compindexParam.leaderInfo.user_token : ''
      },
      success: function success(res) {
        var data = {};
        var goodsList = compindexParam.communityGoodsData || [];
        data['eles[' + compindex + '].communityGoodsData'] = [].concat((0, _toConsumableArray3.default)(goodsList), (0, _toConsumableArray3.default)(res.data));
        data['eles[' + compindex + '].is_more'] = res.is_more;
        data['eles[' + compindex + '].page'] = res.current_page;
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function fail() {
        var dataFail = {};
        dataFail['eles[' + compindex + '].loadingFail'] = true;
        dataFail['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dataFail);
      }
    });
  };

  this.getTimeLineGoods = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var type = e.target.dataset.type;
    var compindex = e.currentTarget.dataset.compindex;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      _app.appMethod.showModal({
        content: '暂无团长，无法搜索'
      });
      return;
    }
    newdata['eles[' + compindex + '].communityGoodsData'] = [];
    newdata['eles[' + compindex + '].status'] = type;
    newdata['eles[' + compindex + '].page'] = 1;
    newdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    _this4.getCommunityGoodsList(compindex);
  };

  this.searchGoodsList = function (e) {
    if (e.keyCode !== 13) {
      return;
    }
    var newdata = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var value = e.target.value;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      _app.appMethod.showModal({
        content: '暂无团长，无法搜索'
      });
      return;
    }
    newdata['eles[' + compindex + '].communityGoodsData'] = [];
    newdata['eles[' + compindex + '].idx_value'] = value;
    newdata['eles[' + compindex + '].page'] = 1;
    newdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    _this4.getCommunityGoodsList(compindex);
  };

  this.hideGoodsDialog = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e.currentTarget.dataset.compindex;
    var newData = {};
    newData['eles[' + compindex + '].showGoodsDetail'] = false;
    pageInstance.setData(newData);
  };

  this.addCommunityCart = function (e) {
    e.stopPropagation();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var id = e.currentTarget.dataset.id;
    var compindex = e.currentTarget.dataset.compindex;
    var compindexParam = pageInstance.data.eles[compindex];
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      _app.appMethod.showModal({
        content: '暂无团长，无法加入购物车'
      });
      return;
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsList',
      method: 'post',
      data: {
        leader_token: compindexParam.leaderInfo.user_token,
        goods_id: [id]
      },
      success: function success(res) {
        var newData = {};
        var goods = res.data[0];
        var selectGoodsModelInfo = void 0;
        var defaultSelect = void 0,
            goodprice = void 0,
            goodstock = void 0,
            goodimgurl = void 0,
            virtual_price = void 0,
            goodId = void 0;
        var goodsModel = [];
        var selectModels = [];
        var selectText = '';
        if (goods.form_data.goods_model) {
          defaultSelect = goods.form_data.goods_model[0];
          goodprice = defaultSelect.price;
          goodstock = defaultSelect.stock;
          goodId = defaultSelect.id;
          goodimgurl = defaultSelect.img_url;
          virtual_price = defaultSelect.virtual_price;
        } else {
          goodprice = goods.price;
          goodstock = goods.stock;
          goodimgurl = goods.cover;
          virtual_price = goods.virtual_price;
        }
        for (var key in goods.form_data.model) {
          if (key) {
            var model = goods.form_data.model[key];
            goodsModel.push(model);
            selectModels.push(model.subModelId[0]);
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
        goods.model = goodsModel;
        selectGoodsModelInfo = {
          price: goodprice,
          stock: goodstock,
          buyCount: 1,
          models: selectModels,
          modelId: goodId || '',
          models_text: selectText,
          imgurl: goodimgurl,
          virtual_price: virtual_price
        };
        newData['eles[' + compindex + '].selectGoodsModelInfo'] = selectGoodsModelInfo;
        newData['eles[' + compindex + '].showGoodsDetail'] = true;
        newData['eles[' + compindex + '].goodsDetail'] = goods;
        pageInstance.setData(newData);
      }
    });
  };

  this.selectGoodsSubModel = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var dataset = event.target.dataset;
    var modelIndex = dataset.modelIndex;
    var submodelIndex = dataset.submodelIndex;
    var data = {};
    var selectModels = pageInstance.data.eles[compindex].selectGoodsModelInfo.models;
    var model = pageInstance.data.eles[compindex].goodsDetail.model;
    var text = '';
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
    for (var i = 0; i < selectModels.length; i++) {
      var selectSubModelId = model[i].subModelId;
      for (var j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” ';
        }
      }
    }
    data['eles[' + compindex + '].selectGoodsModelInfo.models'] = selectModels;
    data['eles[' + compindex + '].selectGoodsModelInfo.models_text'] = text;
    pageInstance.setData(data);
    _this4.resetSelectCountPrice(compindex);
  };

  this.resetSelectCountPrice = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var selectModelIds = pageInstance.data.eles[compindex].selectGoodsModelInfo.models.join(',');
    var modelItems = pageInstance.data.eles[compindex].goodsDetail.form_data.goods_model;
    var data = {};
    data['eles[' + compindex + '].selectGoodsModelInfo.buyCount'] = 1;
    for (var i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['eles[' + compindex + '].selectGoodsModelInfo.stock'] = modelItems[i].stock;
        data['eles[' + compindex + '].selectGoodsModelInfo.price'] = modelItems[i].price;
        data['eles[' + compindex + '].selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
        data['eles[' + compindex + '].selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || '';
        data['eles[' + compindex + '].selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price;
        break;
      }
    }
    pageInstance.setData(data);
  };

  this.inputBuyCount = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].selectGoodsModelInfo.buyCount', e.target.value));
  };

  this.clickGoodsMinusButton = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var count = pageInstance.data.eles[compindex].selectGoodsModelInfo.buyCount;
    if (count <= 1) {
      return;
    }
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].selectGoodsModelInfo.buyCount', count - 1));
  };

  this.clickGoodsPlusButton = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var selectGoodsModelInfo = pageInstance.data.eles[compindex].selectGoodsModelInfo;
    var count = selectGoodsModelInfo.buyCount;
    var stock = selectGoodsModelInfo.stock;
    if (count >= stock) {
      return;
    }
    pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].selectGoodsModelInfo.buyCount', count + 1));
  };

  this.sureAddToShoppingCart = function (event) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compindexParam = pageInstance.data.eles[compindex];
    var param = {
      goods_id: compindexParam.goodsDetail.id,
      model_id: compindexParam.selectGoodsModelInfo.modelId || '',
      num: compindexParam.selectGoodsModelInfo.buyCount,
      dis_group_id: compindexParam.goodsDetail.group_id,
      leader_token: compindexParam.leaderInfo.user_token
    };
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function success(res) {
        _this.hideGoodsDialog(event);
      }
    });
  };

  this.getGoodsIdxList = function (compindex) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsIdxList',
      success: function success(res) {
        var _pageInstance$setData4;

        pageInstance.setData((_pageInstance$setData4 = {}, (0, _defineProperty3.default)(_pageInstance$setData4, 'eles[' + compindex + '].buyerIndex', 0), (0, _defineProperty3.default)(_pageInstance$setData4, 'eles[' + compindex + '].buyerInfoList', res.data || []), _pageInstance$setData4));
        if (res.data.length) {
          _this.cycleGoodsBuyerList(compindex);
        }
      }
    });
  };

  this.cycleGoodsBuyerList = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindexParam = pageInstance.data.eles[compindex];
    if (compindexParam.buyerIndex < 0) {
      return;
    }
    setInterval(function () {
      var index = compindexParam.buyerIndex;
      var buyerInfoList = compindexParam.buyerInfoList;
      index++;
      if (index == buyerInfoList.length - 1) {
        index = 0;
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].buyerIndex', index));
    }, 8000);
  };

  this.checkGroupGoodsLeader = function (compindex, userToken) {
    var _this = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/CheckIsDistributorGroupLeaderInfo',
      data: {
        leader_token: userToken
      },
      success: function success(res) {
        var newdata = {};
        if (!res.data.learder_info) {
          _app.appMethod.globalData.communityUserToken = '';
          _app.appMethod.removeStorage({
            key: 'groupToken',
            complete: function complete() {
              _this.init(compindex, pageInstance);
            }
          });
          return;
        }
        newdata['eles[' + compindex + '].leaderInfo'] = res.data.learder_info;
        pageInstance.setData(newdata);
        _this.getCommunityGoodsList(compindex);
      }
    });
  };
};

exports.default = CommuntiyGoodsListCustomComponent;

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(10);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _carousel = __webpack_require__(30);

var _carousel2 = _interopRequireDefault(_carousel);

var _extends2 = __webpack_require__(9);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(31);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

var _tools = __webpack_require__(6);

var _ScrollView = __webpack_require__(11);

var _RequestStatus = __webpack_require__(25);

__webpack_require__(933);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var price = {
  price: function price(a, b) {
    var c = (a - b).toFixed(2);
    return c;
  },
  shopScore: function shopScore(a, b) {
    var c = (1 - (b - a) / b).toFixed(2) * 100;
    return c;
  },
  pxToRpx: function pxToRpx(size) {
    return parseInt(size) * 2.34375 / 100 + 'rem';
  },
  parseStyle: function parseStyle(style) {
    var styleArr1 = ["width", "font-size", 'margin-left'];
    var styleArr2 = ["background-color", 'color', 'font-style', 'font-weight', 'text-decoration'];
    var s = '';
    for (var i = 0; i < styleArr1.length; i++) {
      var idx = styleArr1[i];
      if (style[idx]) {
        s += idx + ':' + parseInt(style[idx]) * 2.34375 / 100 + 'rem;';
        if (idx == "height") {
          s += 'line-height:' + parseInt(style[idx]) * 2.34375 / 100 + 'rem;';
        }
      }
    }
    for (var i = 0; i < styleArr2.length; i++) {
      var idx = styleArr2[i];
      if (style[idx]) {
        s += idx + ':' + style[idx] + ';';
      }
    }
    return s;
  },
  hasPickUp: function hasPickUp(pick_up_arr, pick_up_type) {
    if (pick_up_arr && pick_up_arr.length) {
      return pick_up_arr.indexOf(pick_up_type);
    }
    return -1;
  },
  getNumber: function getNumber(string) {
    return parseInt(string);
  }
};

var DrinkVerticalListCustomComponent = function (_React$Component) {
  (0, _inherits3.default)(DrinkVerticalListCustomComponent, _React$Component);

  function DrinkVerticalListCustomComponent(props) {
    (0, _classCallCheck3.default)(this, DrinkVerticalListCustomComponent);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (DrinkVerticalListCustomComponent.__proto__ || Object.getPrototypeOf(DrinkVerticalListCustomComponent)).call(this, props));

    _initialiseProps.call(_this2);

    var compindex = props.index;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    _this2.init(compindex, pageInstance, true);
    return _this2;
  }

  (0, _createClass3.default)(DrinkVerticalListCustomComponent, [{
    key: 'sortVerticalList',
    value: function sortVerticalList(event) {}

    //获取店铺广告位

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.props.data;
      var isShowBottom = false;

      // 多商家配送方式
      var $merchatsPickup = function $merchatsPickup() {
        return _react2.default.createElement(
          'div',
          { className: 'merchants-and-pickup' },
          _react2.default.createElement(
            'div',
            { className: 'merchants-box' },
            data.customFeature.multipleMerchants && _react2.default.createElement(
              'div',
              { onClick: _this3.drinkTurnToChainStoreList },
              currentChainStore.name || data.shopInfo.title,
              ' ',
              _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow', style: { color: '#666' } })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'pickup-box', hidden: !(data.pick_up_type && data.pick_up_type.length > 1) },
            price.hasPickUp(data.pick_up_type, 3) >= 0 && _react2.default.createElement(
              'span',
              { className: 'pickup-item ' + (data.pick_up_select == 3 ? 'active' : ''),
                onClick: function onClick(e) {
                  return _this3.selectPickUpType(e);
                },
                'data-compindex': _this3.props.index, 'data-id': '3' },
              '\u81EA\u63D0'
            ),
            price.hasPickUp(data.pick_up_type, 4) >= 0 && _react2.default.createElement(
              'span',
              { className: 'pickup-item ' + (data.pick_up_select == 4 ? 'active' : ''),
                onClick: function onClick(e) {
                  return _this3.selectPickUpType(e);
                },
                'data-compindex': _this3.props.index, 'data-id': '4' },
              '\u5802\u98DF'
            ),
            price.hasPickUp(data.pick_up_type, 2) >= 0 && _react2.default.createElement(
              'span',
              { className: 'pickup-item ' + (data.pick_up_select == 2 ? 'active' : ''),
                onClick: function onClick(e) {
                  return _this3.selectPickUpType(e);
                },
                'data-compindex': _this3.props.index, 'data-id': '2' },
              '\u914D\u9001'
            ),
            _react2.default.createElement('div', { className: 'active pickup-item-active',
              style: {
                left: (data.pick_up_select_left / 50 || 0) + 'rem',
                width: 'calc((100% / ' + data.pick_up_type.length + '))'
              } })
          )
        );
      };

      // 顶部定位
      var $locationBox = function $locationBox() {
        return _react2.default.createElement(
          'div',
          { className: 'goods-location-box', onClick: _this3.drinkSelectGoodsSameJourney, 'data-compindex': _this3.props.index },
          _react2.default.createElement('span', { className: 'ico-moon icon-goods-location' }),
          _react2.default.createElement(
            'span',
            { className: 'address-box' },
            data.selectSameJourney ? data.selectSameJourney.address_info.province.text + data.selectSameJourney.address_info.city.text + data.selectSameJourney.address_info.district.text + data.selectSameJourney.detail_address : data.currentLocationData && data.currentLocationData.formatted_addresses.recommend || '暂无地址'
          ),
          _react2.default.createElement('span', { className: 'ico-moon icon-downarrow', style: { transform: 'translateY(.04rem)', color: '#999' } })
        );
      };

      // tab切换栏
      var $tabsWrap = function $tabsWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'waimai-goods-evaluate-search' },
          _react2.default.createElement(
            'div',
            { style: { width: '' + (data.customFeature.isShowSearch ? '25%' : '33%') } },
            _react2.default.createElement(
              'div',
              { 'data-index': '1', 'data-compindex': _this3.props.index, onClick: _this3.drinkVerticalListChangeEvaluate,
                className: data.selected == 1 ? 'selected' : '' },
              '\u5546\u54C1'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { width: '' + (data.customFeature.isShowSearch ? '25%' : '33%') } },
            _react2.default.createElement(
              'div',
              { className: '' + (data.selected == 2 ? 'selected' : ''), 'data-index': '2', 'data-compindex': _this3.props.index,
                onClick: _this3.drinkVerticalListChangeEvaluate },
              '\u8BC4\u4EF7'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { width: '' + (data.customFeature.isShowSearch ? '25%' : '33%') } },
            _react2.default.createElement(
              'div',
              { className: '' + (data.selected == 3 ? 'selected' : ''), 'data-index': '3', 'data-compindex': _this3.props.index,
                onClick: _this3.drinkVerticalListChangeEvaluate },
              '\u5E97\u94FA'
            )
          ),
          data.customFeature.isShowSearch && _react2.default.createElement(
            'div',
            { className: 'waimai-list-search' },
            _react2.default.createElement(
              'div',
              { onClick: _this3.drinkVerticalListShowGoodsSearch, 'data-compindex': _this3.props.index },
              _react2.default.createElement('label', { className: 'ico-moon icon-waimai-search' }),
              _react2.default.createElement(
                'span',
                null,
                '\u641C\u7D22'
              )
            )
          )
        );
      };

      // 搜索
      var $searchWrap = function $searchWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'waimai-goods-evaluate-search-mode2' },
          _react2.default.createElement('div', { className: 'ico-moon icon-leftarrow', onClick: _this3.drinkVerticalListHideGoodsSearch,
            'data-compindex': _this3.props.index }),
          _react2.default.createElement(
            'div',
            { className: 'waimai-goods-search-input' },
            _react2.default.createElement('label', { className: 'ico-moon icon-waimai-search', style: { float: 'left' } }),
            !data.hideSearchInput && _react2.default.createElement('input', { placeholder: '\u8BF7\u8F93\u5165\u5546\u54C1\u540D\u79F0', onInput: _this3.drinkVerticalListBindSearchTitle,
              onKeyDown: function onKeyDown(e) {
                e.keyCode === 13 && _this3.drinkVerticalListSearchByTitle;
              }, 'data-compindex': _this3.props.index })
          ),
          _react2.default.createElement(
            'div',
            { className: 'evaluate-search-button', onClick: _this3.drinkVerticalListSearchByTitle, 'data-compindex': _this3.props.index },
            '\u641C\u7D22'
          )
        );
      };

      // 分类 商品列表
      var $waimaiContainerWrap = function $waimaiContainerWrap() {
        // 样式数据处理
        var styleObj = (0, _tools.convertStyleData)(data.style);
        return _react2.default.createElement(
          'div',
          { className: 'element waimai waimai-container-wrap',
            style: (0, _extends3.default)({ display: '' + (data.selected == 1 ? 'block' : 'none'),
              height: 'calc(' + data.heightPx / 50 + 'rem - .76rem - .1rem ' + (data.pick_up_select == 2 ? '- .68rem' : '') + ' ' + (data.pick_up_type.length > 1 || data.customFeature.multipleMerchants ? '- 1.1rem' : '- 0') + (isShowBottom ? ' - .98rem' : '') + ')'
            }, styleObj),
            onAnimationEnd: _this3.animationEnd, 'data-compindex': _this3.props.index },
          _react2.default.createElement(
            _ScrollView.ScrollView,
            { className: 'typeList', 'scroll-y': 'true', style: { width: "1.6rem", height: "100%", maxWidth: '1.6rem' } },
            data.content.map(function (item, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: 'waimaiCategory',
                    style: {
                      backgroundColor: '' + (data.customFeature.selected == index ? data.customFeature.selectedBackgroundColor : ''),
                      color: '' + (data.customFeature.selected == index ? data.customFeature.selectedColor : '#333'),
                      borderLeft: '' + (data.customFeature.selected == index ? '.08rem solid #FA5A47' : 'initial'),
                      width: '1.6rem',
                      maxWidth: '1.6rem',
                      fontSize: '.26rem',
                      padding: 0,
                      height: '.9rem',
                      lineHeight: '.9rem',
                      fontWeight: '' + (data.customFeature.selected == index ? '600' : 'normal')
                    },
                    'data-index': index, 'data-id': item.source, 'data-compindex': _this3.props.index,
                    'data-param': data.pagination && JSON.stringify(data.pagination['category' + item.source].param), onClick: _this3.drinkVerticalListClickCategory,
                    'data-cateindex': index },
                  item.pic && data.customFeature.directionLeft == 0 && data.customFeature.isShowListIcon && data.customFeature.databind || item.pic && data.customFeature.directionLeft == 0 && !data.customFeature.databind && _react2.default.createElement('img', {
                    src: item.pic,
                    style: {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginRight: '.1rem',
                      width: '' + (data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.3rem'),
                      height: '' + (data.customFeature.typeImgWidth ? price.pxToRpx(data.customFeature.typeImgWidth) : '.3rem'),
                      borderRadius: '' + price.pxToRpx(data.customFeature.iconRadius)
                    } }),
                  _react2.default.createElement(
                    'span',
                    { className: 'waimai-cate-text' },
                    item.text
                  ),
                  item.pic && data.customFeature.directionLeft == 1 && data.customFeature.isShowListIcon && data.customFeature.databind || item.pic && data.customFeature.directionLeft == 1 && !data.customFeature.databind && _react2.default.createElement('img', {
                    src: item.pic,
                    style: {
                      display: 'inline-block',
                      verticalAlign: 'middle',
                      marginLeft: '.1rem',
                      width: '' + price.pxToRpx(data.customFeature.typeImgWidth),
                      height: '' + price.pxToRpx(data.customFeature.typeImgWidth),
                      borderRadius: '' + price.pxToRpx(data.customFeature.iconRadius)
                    } })
                )
              );
            }),
            _react2.default.createElement('div', { style: { height: '1.1rem' } })
          ),
          (!data.customFeature.loadAllData || data.customFeature.loadAllData == '0') && _react2.default.createElement(
            'div',
            { className: 'waimai-shoppingList',
              style: { left: '1.6rem',
                width: 'calc(100% - 1.6rem)',
                display: 'inline-block',
                verticalAlign: 'top',
                height: '100%',
                minWidth: 'calc(100% - 1.6rem)'
              } },
            data.content.map(function (items, index) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: index },
                _react2.default.createElement(
                  _ScrollView.ScrollView,
                  { hidden: index != data.customFeature.selected, className: 'waimaigoodslist',
                    style: { left: '1.6rem', verticalAlign: 'top', height: '100%' }, 'scroll-into-view': data.scrollId,
                    'scroll-y': '' + (data.customFeature.showShopInfo && !data.infoHeight && data.customFeature.selected == 0 ? false : true),
                    'data-compindex': _this3.props.index, 'data-curpage': data.curpage, 'data-categoryid': items.source,
                    'data-param': data.pagination && data.pagination['category' + items.source].param,
                    bindscrolltolower: _this3.drinkVerticalListStyleScrollFunc, 'scroll-top': data.scrollTop,
                    bindscrolltoupper: _this3.drinkVerticalListStyleScrollTop, 'upper-threshold': '.2rem', 'lower-threshold': '.5rem' },
                  data.customFeature.selected == 0 && data.advancedList && data.advancedList[0] !== 'none' && _react2.default.createElement(
                    'div',
                    { className: 'advance' },
                    data.advancedList.map(function (item, index) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        { key: index },
                        item.mark === 'img' && _react2.default.createElement(
                          'div',
                          { className: 'advanceItem' },
                          item.img.map(function (imgItem, i) {
                            return _react2.default.createElement(
                              _react2.default.Fragment,
                              { key: i },
                              item.Models[i].formData.action === 'turn-to-xcx' ? _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement('img', { src: imgItem,
                                  style: {
                                    width: '' + (item.type == 1 ? '100%' : item.type == 2 ? 'calc(50% - .08rem)' : item.type == 3 ? 'calc(33% - .08rem)' : 'calc(25% - .1rem)'),
                                    height: item.height / 50 + 'rem',
                                    marginRight: '' + (item.type == 1 ? '0' : 'initial')
                                  } })
                              ) : _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement('img', { src: imgItem,
                                  style: {
                                    width: '' + (item.type == 1 ? '100%' : item.type == 2 ? 'calc(50% - .08rem)' : item.type == 3 ? 'calc(33% - .08rem)' : 'calc(25% - .1rem)'),
                                    height: item.height / 50 + 'rem',
                                    marginRight: '' + (item.type == 1 ? '0' : 'initial')
                                  },
                                  'data-event-params': JSON.stringify(item.Models[i].formData),
                                  'data-compindex': _this3.props.index, onClick: item.Models[i].formData.action && item.Models[i].formData.action != 'none' ? _this3.tapEventCommonHandler : null, 'data-imgarr': imgItem })
                              )
                            );
                          })
                        ),
                        item.mark === 'carousel' && _react2.default.createElement(
                          'div',
                          { className: 'advanceItem', 'data-compindex': _this3.props.index },
                          item.img.length > 0 && _react2.default.createElement(
                            _carousel2.default,
                            {
                              dots: true,
                              autoPlay: item.autoplay == 'false' ? false : true,
                              autoplayInterval: item.auto * 1000,
                              speed: 750,
                              style: { height: '2rem' },
                              dotActiveStyle: { background: item.indicatorActiveColor }
                            },
                            item.img.map(function (imgItem, i) {
                              return item.Models[i].formData.action == 'turn-to-xcx' ? _react2.default.createElement(
                                'div',
                                { key: i },
                                _react2.default.createElement('img', { className: 'swiper-item', src: imgItem, style: { height: '2rem' } })
                              ) : _react2.default.createElement(
                                'div',
                                { key: i, 'data-event-params': JSON.stringify(item.Models[i].formData), 'data-compindex': _this3.props.index,
                                  onClick: item.Models[i].formData.action && item.Models[i].formData.action != 'none' ? _this3.tapEventCommonHandler : null, 'data-imgarr': imgItem },
                                _react2.default.createElement('img', { className: 'swiper-item', src: imgItem, style: { height: '2rem' } })
                              );
                            })
                          )
                        )
                      );
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'takeoutCategory', 'data-source': items.source },
                    items.text,
                    data.customFeature.listType == '1' && _react2.default.createElement(
                      _react2.default.Fragment,
                      null,
                      _react2.default.createElement(
                        'div',
                        { className: 'price', 'data-compindex': _this3.props.index, 'data-curpage': data.curpage,
                          'data-categoryid': items.source, 'data-param': data.pagination['category' + items.source].param,
                          'data-sort_key': 'price', 'data-direction': data.categorySort['category' + items.source].sort_direction,
                          onClick: _this3.drinkSortVerticalList },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u4EF7\u683C'
                        ),
                        _react2.default.createElement('label', { className: 'ico-moon icon-news-up',
                          style: { color: '' + (data.categorySort['category' + items.source].sort_direction == 1 && data.categorySort['category' + items.source].sortKey == 'price' ? '#666' : '#ccc') } }),
                        _react2.default.createElement('label', { className: 'ico-moon icon-news-down',
                          style: { color: '' + (data.categorySort['category' + items.source].sort_direction == 0 && data.categorySort['category' + items.source].sortKey == 'price' ? '#666' : '#ccc') } })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'sales', 'data-compindex': _this3.props.index, 'data-curpage': data.curpage,
                          'data-categoryid': items.source, 'data-param': data.pagination['category' + items.source].param,
                          'data-sort_key': 'sales', 'data-direction': data.categorySort['category' + items.source].sort_direction,
                          onClick: _this3.drinkSortVerticalList },
                        _react2.default.createElement(
                          'span',
                          null,
                          '\u9500\u91CF'
                        ),
                        _react2.default.createElement('label', { className: 'ico-moon icon-news-up',
                          style: { color: '' + (data.categorySort['category' + items.source].sort_direction == 1 && data.categorySort['category' + items.source].sortKey == 'sales' ? '#666' : '#ccc') } }),
                        _react2.default.createElement('label', { className: 'ico-moon icon-news-down',
                          style: { color: '' + (data.categorySort['category' + items.source].sort_direction == 0 && data.categorySort['category' + items.source].sortKey == 'sales' ? '#666' : '#ccc') } })
                      )
                    )
                  ),
                  data.show_goods_data && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].map(function (item, index) {
                    return data.customFeature['listArrange'] == '0' && _react2.default.createElement(
                      'div',
                      { className: 'waimaigoods-list-item list-item', key: index },
                      !(!data.customFeature.showIntegral && item.integral === '1') && _react2.default.createElement(
                        'div',
                        { 'data-id': item.id, 'data-compindex': _this3.props.index },
                        _react2.default.createElement(
                          'div',
                          { className: 'inner-content' },
                          _react2.default.createElement(
                            'div',
                            { className: 'waimai-img' },
                            _react2.default.createElement('img', { src: item.cover, onClick: _this3.showDrinkVerticalListGoodsDetail,
                              'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index,
                              'data-category': items.source, 'data-attributes': item.attributes, 'data-model': item.goods_model }),
                            data.customFeature.isShowStock && item.stock < 6 && _react2.default.createElement(
                              'label',
                              { className: 'goods-stock' },
                              '\u4EC5\u5269',
                              item.stock,
                              '\u4EF6'
                            )
                          ),
                          !!+item.corner_mark && _react2.default.createElement('img', { className: 'new-goods', src: item.corner_url }),
                          _react2.default.createElement(
                            'div',
                            { style: { width: 'initial', minHeight: '1.68rem' }, className: 'waimai-title' },
                            _react2.default.createElement(
                              'div',
                              { className: 'waimai-title-text', onClick: _this3.showDrinkVerticalListGoodsDetail, 'data-id': item.id,
                                'data-compindex': _this3.props.index, 'data-index': index, 'data-category': items.source,
                                'data-model': item.goods_model },
                              item.max_can_use_integral > 0 && _react2.default.createElement(
                                'span',
                                { className: 'jifen' },
                                '\u79EF'
                              ),
                              _react2.default.createElement(
                                'span',
                                { className: 'text' },
                                item.title
                              ),
                              item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                                'span',
                                { className: 'vip-goods' },
                                '\u4F1A\u5458\u8D2D'
                              )
                            ),
                            data.customFeature.isShowTag && item.tags && item.tags.length && _react2.default.createElement(
                              'div',
                              { className: 'waimai-title-dec drink-tags-box' },
                              item.tags.map(function (tagsItem, index) {
                                return _react2.default.createElement(
                                  'span',
                                  { className: 'tag', key: index },
                                  tagsItem
                                );
                              })
                            ),
                            data.customFeature.isShowDesc && item.simple_description && _react2.default.createElement(
                              'div',
                              { className: 'waimai-title-dec' },
                              item.simple_description || ''
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'waimai-title-dec' },
                              data.customFeature.sale !== false && _react2.default.createElement(
                                'span',
                                null,
                                '\u9500\u91CF\uFF1A',
                                item.sales
                              ),
                              item.min_sales_nums > 1 && _react2.default.createElement(
                                'span',
                                { style: { marginLeft: '.2rem' } },
                                '\u8D77\u5356\u6570:',
                                item.min_sales_nums
                              )
                            ),
                            !!+item.is_vip_goods && _react2.default.createElement(
                              'div',
                              { className: 'vip_goods_price' },
                              _react2.default.createElement(
                                'span',
                                { className: 'vip_goods_tips' },
                                '\u4F1A\u5458\u4EF7'
                              )
                            ),
                            _react2.default.createElement(
                              'div',
                              { className: 'waimai-item-bottom',
                                style: {
                                  paddingTop: 0,
                                  marginTop: '' + (data.customFeature.isShowTag && data.customFeature.isShowDesc ? '0' : '.26rem')
                                } },
                              _react2.default.createElement(
                                'span',
                                { className: 'waimai-price-per' },
                                _react2.default.createElement(
                                  'span',
                                  {
                                    style: { fontSize: '.24rem', fontWeight: 'normal' } },
                                  '\xA5'
                                ),
                                item.is_vip_goods > 0 ? item.vip_min_price : item.price,
                                _react2.default.createElement(
                                  'span',
                                  {
                                    style: { fontSize: '.2rem', fontWeight: 'normal' } },
                                  item.is_vip_goods > 0 ? "起" : ""
                                )
                              ),
                              data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00' && _react2.default.createElement(
                                'span',
                                { style: { textDecoration: 'line-through', fontSize: '.2rem', color: '#999', lineHeight: '.6rem' } },
                                '\xA5',
                                item.virtual_price
                              ),
                              _react2.default.createElement(
                                'label',
                                { className: 'waimai-number-change' },
                                data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement('label', {
                                  className: 'waimai-count-minus', 'data-goodsid': item.id,
                                  onClick: _this3.drinkVerticalListListMinus, 'data-stock': data.goods_data_list[item.id].stock,
                                  'data-compindex': _this3.props.index, 'data-model': item.goods_model,
                                  'data-attributes': item.attributes, 'data-is-in-business': item.is_in_business_time,
                                  'data-package': item.is_package_goods }),
                                data.goods_data_list[item.id].totalNum > 0 && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement(
                                  'span',
                                  {
                                    className: 'waimai-number' },
                                  data.goods_data_list[item.id].totalNum
                                ),
                                !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement('label', {
                                  className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''),
                                  'data-goodsid': item.id, onClick: _this3.drinkVerticalListListPlus,
                                  'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                                  'data-model': item.goods_model, 'data-categoryid': data.showCategory && data.showCategory.source,
                                  'data-is-in-business': item.is_in_business_time }),
                                !!item.goods_model && _react2.default.createElement(
                                  'label',
                                  { className: 'waimai-count-model-plus',
                                    'data-goodsid': item.id, onClick: _this3.showDrinkVerticalListGoodsDetail,
                                    'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                                    'data-model': item.goods_model, 'data-attributes': item.attributes,
                                    'data-categoryid': data.showCategory && data.showCategory.source,
                                    'data-is-in-business': item.is_in_business_time, 'data-category': items.source, 'data-index': index },
                                  '\u9009\u89C4\u683C'
                                ),
                                !item.goods_model && item.attributes && item.attributes.length && _react2.default.createElement(
                                  'label',
                                  {
                                    className: 'waimai-count-model-plus', 'data-goodsid': item.id,
                                    onClick: _this3.showDrinkVerticalListGoodsDetail, 'data-stock': data.goods_data_list[item.id].stock,
                                    'data-compindex': _this3.props.index, 'data-attributes': item.attributes,
                                    'data-categoryid': data.showCategory && data.showCategory.source,
                                    'data-is-in-business': item.is_in_business_time, 'data-category': items.source, 'data-index': index },
                                  '\u9009\u5C5E\u6027'
                                ),
                                !!+item.is_package_goods && _react2.default.createElement(
                                  'label',
                                  {
                                    className: 'waimai-count-model-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''),
                                    'data-goodsid': item.id, onClick: _this3.drinkToSetMeal,
                                    'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                                    'data-model': item.goods_model, 'data-categoryid': data.showCategory && data.showCategory.source,
                                    'data-is-in-business': item.is_in_business_time },
                                  '\u9009\u5957\u9910'
                                ),
                                data.goods_data_list[item.id].totalNum > 0 && (item.goods_model || item.attributes && item.attributes.length || !!+item.is_package_goods) && _react2.default.createElement(
                                  'span',
                                  { className: 'waimai-number-dot' },
                                  data.goods_data_list[item.id].totalNum
                                )
                              )
                            )
                          )
                        )
                      )
                    );
                  }),
                  data.loading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
                  data.pagination && data.pagination['category' + items.source].is_more == 0 && data.show_goods_data['category' + items.source] && data.show_goods_data['category' + items.source].length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: "暂无数据~" } }),
                  data.loadingFail && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestFail', data: { refreshEvent: 'drinkVerticalListStyleScrollFunc', compindex: data.compindex } }),
                  _react2.default.createElement('div', { style: { height: '2rem' } })
                )
              );
            })
          )
        );
      };

      // 搜索结果
      var $searchResult = function $searchResult() {
        var _React$createElement2;

        return _react2.default.createElement(
          'div',
          { className: 'element waimai waimai-container-wrap searchResult', onAnimationEnd: _this3.animationEnd,
            'data-compindex': _this3.props.index },
          _react2.default.createElement(
            _ScrollView.ScrollView,
            (_React$createElement2 = { 'scroll-y': 'true', 'data-compindex': _this3.props.index,
              style: {
                height: 'calc(' + data.searchHeight / 50 + 'rem ' + (data.customFeature.is_together ? '- .2rem' : '- 0') + (isShowBottom ? ' - .98rem' : '') + ')',
                paddingBottom: '' + (data.selected == 1 && data.TotalNum != 0 && !data.goodsDetailShow && !data.goodsAttrShow ? '1.3rem' : '')
              }
            }, (0, _defineProperty3.default)(_React$createElement2, 'data-compindex', _this3.props.index), (0, _defineProperty3.default)(_React$createElement2, 'bindscrolltolower', _this3.drinkVerticalListSearchScrollFunc), _React$createElement2),
            data.show_goods_data && data.show_goods_data['searchResult'] && data.show_goods_data['searchResult'].map(function (item, index) {
              var _React$createElement;

              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'div',
                  { 'data-id': item.id, 'data-compindex': _this3.props.index, className: 'clearfix', style: { padding: '.2rem' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'inner-content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'waimai-img' },
                      _react2.default.createElement('img', { src: item.cover, onClick: _this3.showDrinkVerticalListGoodsDetail,
                        'data-id': item.id, 'data-compindex': _this3.props.index, 'data-index': index,
                        'data-category': item.source, 'data-is_search': 'search', 'data-model': item.goods_model }),
                      data.customFeature.isShowStock && item.stock < 6 && _react2.default.createElement(
                        'label',
                        { className: 'goods-stock' },
                        '\u4EC5\u5269',
                        item.stock,
                        '\u4EF6'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { style: { width: 'initial', minHeight: '1.68rem' }, className: 'waimai-title' },
                      _react2.default.createElement(
                        'div',
                        (_React$createElement = { className: 'waimai-title-text', onClick: _this3.showDrinkVerticalListGoodsDetail, 'data-id': item.id
                        }, (0, _defineProperty3.default)(_React$createElement, 'data-id', item.id), (0, _defineProperty3.default)(_React$createElement, 'data-compindex', _this3.props.index), (0, _defineProperty3.default)(_React$createElement, 'data-index', index), (0, _defineProperty3.default)(_React$createElement, 'data-category', item.source), (0, _defineProperty3.default)(_React$createElement, 'data-is_search', 'search'), (0, _defineProperty3.default)(_React$createElement, 'data-model', item.goods_model), _React$createElement),
                        item.max_can_use_integral > 0 && _react2.default.createElement(
                          'span',
                          { className: 'jifen' },
                          ' 0}}">\u79EF'
                        ),
                        _react2.default.createElement(
                          'span',
                          { className: 'text' },
                          item.title
                        ),
                        item.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                          'span',
                          { className: 'vip-goods' },
                          '\u4F1A\u5458\u8D2D'
                        )
                      ),
                      data.customFeature.isShowTag && item.tags && item.tags.length && _react2.default.createElement(
                        'div',
                        { className: 'waimai-title-dec drink-tags-box' },
                        item.tags.map(function (tagsItem, index) {
                          return _react2.default.createElement(
                            'span',
                            { className: 'tag', key: index },
                            tagsItem
                          );
                        })
                      ),
                      data.customFeature.isShowDesc && item.simple_description && _react2.default.createElement(
                        'div',
                        { className: 'waimai-title-dec' },
                        ' ',
                        item.simple_description || ''
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'waimai-title-dec' },
                        data.customFeature.sale !== false && _react2.default.createElement(
                          'span',
                          null,
                          '\u9500\u91CF\uFF1A',
                          item.sales
                        ),
                        item.min_sales_nums > 1 && _react2.default.createElement(
                          'span',
                          { style: { marginLeft: '.2rem' } },
                          '\u8D77\u5356\u6570:',
                          item.min_sales_nums
                        )
                      ),
                      !!+item.is_vip_goods && _react2.default.createElement(
                        'div',
                        { className: 'vip_goods_price' },
                        _react2.default.createElement(
                          'span',
                          { className: 'vip_goods_tips' },
                          '\u4F1A\u5458\u4EF7'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'waimai-item-bottom',
                          style: {
                            paddingTop: 0,
                            marginTop: '' + (data.customFeature.isShowTag && data.customFeature.isShowDesc ? '0' : '.26rem')
                          } },
                        _react2.default.createElement(
                          'span',
                          { className: 'waimai-price-per' },
                          _react2.default.createElement(
                            'span',
                            {
                              style: { fontSize: '.24rem', fontWeight: 'normal' } },
                            '\xA5'
                          ),
                          item.is_vip_goods > 0 ? item.vip_min_price : item.price,
                          _react2.default.createElement(
                            'span',
                            {
                              style: { fontSize: '.24rem', fontWeight: 'normal' } },
                            item.is_vip_goods > 0 ? "起" : "",
                            ' '
                          )
                        ),
                        data.customFeature.isShowVirtualPrice && item.virtual_price && item.virtual_price != '0.00' && _react2.default.createElement(
                          'span',
                          { style: { fontSize: '.28rem', color: '#666666', textDecoration: 'line-through', lineHeight: '.6rem' } },
                          '\xA5',
                          item.virtual_price
                        ),
                        _react2.default.createElement(
                          'label',
                          { className: 'waimai-number-change' },
                          data.goods_data_list[item.id].totalNum > 0 && !data.customFeature.is_together && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement('label', {
                            className: 'waimai-count-minus', 'data-goodsid': item.id, onClick: _this3.drinkVerticalListListMinus,
                            'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                            'data-model': item.goods_model, 'data-attributes': item.attributes,
                            'data-is-in-business': item.is_in_business_time,
                            'data-package': item.is_package_goods }),
                          data.goods_data_list[item.id].totalNum > 0 && !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement(
                            'span',
                            { className: 'waimai-number' },
                            data.goods_data_list[item.id].totalNum
                          ),
                          !item.goods_model && (!item.attributes || !item.attributes.length) && !item.is_package_goods && _react2.default.createElement('label', {
                            className: 'waimai-count-plus ' + (data.goods_data_list[item.id].totalNum >= data.goods_data_list[item.id].stock ? 'disabled' : ''),
                            'data-goodsid': item.id, onClick: _this3.drinkVerticalListListPlus,
                            'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                            'data-model': item.goods_model, 'data-categoryid': data.showCategory && data.showCategory.source,
                            'data-is-in-business': item.is_in_business_time }),
                          item.goods_model && _react2.default.createElement(
                            'label',
                            { className: 'waimai-count-model-plus', 'data-goodsid': item.id,
                              onClick: _this3.showDrinkVerticalListGoodsDetail, 'data-stock': data.goods_data_list[item.id].stock,
                              'data-compindex': _this3.props.index, 'data-model': item.goods_model,
                              'data-attributes': item.attributes, 'data-categoryid': data.showCategory && data.showCategory.source,
                              'data-is-in-business': item.is_in_business_time, 'data-category': item.source, 'data-index': index, 'data-is_search': 'search' },
                            '\u9009\u89C4\u683C'
                          ),
                          !item.goods_model && item.attributes && item.attributes.length && _react2.default.createElement(
                            'label',
                            {
                              className: 'waimai-count-model-plus', 'data-goodsid': item.id,
                              onClick: _this3.showDrinkVerticalListGoodsDetail, 'data-stock': data.goods_data_list[item.id].stock,
                              'data-compindex': _this3.props.index, 'data-attributes': item.attributes,
                              'data-categoryid': data.showCategory && data.showCategory.source,
                              'data-is-in-business': item.is_in_business_time, 'data-category': item.source, 'data-index': index, 'data-is_search': 'search' },
                            '\u9009\u5C5E\u6027'
                          ),
                          !!item.is_package_goods && _react2.default.createElement(
                            'label',
                            { className: 'waimai-count-model-plus',
                              'data-goodsid': item.id, onClick: _this3.drinkToSetMeal,
                              'data-stock': data.goods_data_list[item.id].stock, 'data-compindex': _this3.props.index,
                              'data-model': item.goods_model, 'data-categoryid': data.showCategory && data.showCategory.source,
                              'data-is-in-business': item.is_in_business_time },
                            '\u9009\u5957\u9910'
                          ),
                          data.goods_data_list[item.id].totalNum > 0 && (item.goods_model || item.attributes && item.attributes.length || item.is_package_goods) && _react2.default.createElement(
                            'span',
                            { className: 'waimai-number-dot' },
                            data.goods_data_list[item.id].totalNum
                          )
                        )
                      )
                    )
                  )
                )
              );
            }),
            data.searchLoading && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestLoading' }),
            data.pagination['searchResult'] && data.pagination['searchResult'].is_more == 0 && data.show_goods_data['searchResult'].length == 0 && _react2.default.createElement(_RequestStatus.RequestStatus, { is: 'requestNone', data: { data: "暂无数据~" } })
          )
        );
      };

      // 底部购物车
      var $bottomShoppingCart = function $bottomShoppingCart() {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          (data.selected == 1 || data.showSearch) && data.TotalNum != 0 && _react2.default.createElement('div', { className: 'goods-bottom-background' }),
          (data.selected == 1 || data.showSearch) && data.TotalNum != 0 && _react2.default.createElement(
            'div',
            { className: 'goods-bottom-opt',
              style: { bottom: (isShowBottom ? 118 / 50 : 20 / 50) + '}rem' },
              'data-compindex': _this3.props.index, onClick: _this3.drinkShowShoppingCartPop },
            _react2.default.createElement(
              'div',
              { className: 'shoppingcart-total-money' },
              _react2.default.createElement(
                'div',
                { className: 'shopping-cart-wrap ' + (data.addCarting ? 'addCarting' : '') },
                _react2.default.createElement('label', { className: 'ico-moon icon-fn-cart', 'data-compindex': _this3.props.index,
                  onClick: _this3.drinkShowShoppingCartPop }),
                data.TotalNum != 0 && _react2.default.createElement(
                  'label',
                  { className: 'waimai-count' },
                  data.TotalNum
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shopping-money-wrap' },
                data.TotalPrice != 0 ? _react2.default.createElement(
                  _react2.default.Fragment,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'shopping-money-price ' + (data.pick_up_select != 2 ? 'no-fee' : '') },
                    _react2.default.createElement(
                      'span',
                      { style: { marginRight: '.06rem' } },
                      '\xA5'
                    ),
                    data.TotalPrice
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'shopping-deliver-fee ' + (data.pick_up_select != 2 ? 'no-fee' : '') },
                    '\u914D\u9001\u8D39 \xA5',
                    data.config_data.set_deliver_area_type == 1 ? data.config_data.deliver_rule_data.base_deliver_fee : data.config_data.deliver_fee
                  )
                ) : _react2.default.createElement(
                  'div',
                  { className: 'classname', style: { color: '#9b9b9d', lineHeight: '.88rem' } },
                  '\u8BF7\u9009\u62E9\u5546\u54C1'
                )
              )
            ),
            _react2.default.createElement(
              'form',
              null,
              _react2.default.createElement(
                'button',
                { 'data-compindex': _this3.props.index,
                  type: 'button',
                  onClick: _this3.drinkSelectSettlement,
                  className: 'sure-waimai-order ' + (data.pick_up_select == 2 && data.config_data && price.getNumber(data.TotalPrice) < data.config_data.min_deliver_price ? 'disabledBtn' : '') },
                data.pick_up_select == 2 && data.config_data && price.getNumber(data.TotalPrice) < data.config_data.min_deliver_price ? '￥' + data.config_data.min_deliver_price + ' 起送' : '去结算'
              )
            )
          )
        );
      };

      // 评价
      var $evaluationWrap = function $evaluationWrap() {
        return _react2.default.createElement(
          'div',
          { className: 'verticalList-shop-evaluate', style: { display: '' + (data.selected == 2 ? 'block' : 'none') } },
          (data.assessList && data.assessList.length > 0 || !!data.moreAssess) && _react2.default.createElement(
            _ScrollView.ScrollView,
            {
              style: {
                height: 'calc(' + data.heightPx / 50 + 'rem ' + (data.infoHeight ? '' : '- ' + data.shopHeight / 50 + 'rem') + ' - .9rem)'
              },
              'scroll-y': 'true' },
            _react2.default.createElement('div', { style: { width: '100%', height: '.12rem', background: '#F3F3F3' } }),
            _react2.default.createElement(
              'div',
              { style: { padding: '.3rem', display: 'flex', justifyContent: 'space-between' } },
              _react2.default.createElement(
                'div',
                { className: 'verticalList-assess-btn ' + (data.assessActive == 0 ? 'active' : ''), 'data-active': '0',
                  'data-compindex': _this3.props.index, onClick: _this3.drinkChangeAssessType },
                '\u6709\u56FE(',
                data.assessNum[4] || 0,
                ')'
              ),
              _react2.default.createElement(
                'div',
                { className: 'verticalList-assess-btn ' + (data.assessActive == 1 ? 'active' : ''), 'data-active': '1',
                  'data-compindex': _this3.props.index, onClick: _this3.drinkChangeAssessType },
                '\u597D\u8BC4(',
                data.assessNum[1] || 0,
                ')'
              ),
              _react2.default.createElement(
                'div',
                { className: 'verticalList-assess-btn ' + (data.assessActive == 2 ? 'active' : ''), 'data-active': '2',
                  'data-compindex': _this3.props.index, onClick: _this3.drinkChangeAssessType },
                '\u4E2D\u8BC4(',
                data.assessNum[2] || 0,
                ')'
              ),
              _react2.default.createElement(
                'div',
                { className: 'verticalList-assess-btn ' + (data.assessActive == 3 ? 'active' : ''), 'data-active': '3',
                  'data-compindex': _this3.props.index, onClick: _this3.drinkChangeAssessType },
                '\u5DEE\u8BC4(',
                data.assessNum[3] || 0,
                ')'
              )
            ),
            data.showAssess.map(function (item, i) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: i },
                _react2.default.createElement(
                  'div',
                  { className: 'verticalListAssessList' },
                  _react2.default.createElement('img', { src: item.buyer_headimgurl }),
                  _react2.default.createElement(
                    'div',
                    { className: 'assessInfoTop' },
                    _react2.default.createElement(
                      'div',
                      { className: 'verticalListNickname' },
                      _react2.default.createElement(
                        'span',
                        { className: 'tackoutNickText' },
                        item.buyer_nickname
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: ' pull-right' },
                        item.add_time
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'verticalListService' },
                      '\u5546\u5BB6\u670D\u52A1\uFF1A',
                      _react2.default.createElement('label', { className: 'ico-moon icon-satisfied ' + (item.assess_info.level == 1 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 1 ? 'active' : '' },
                        ' \u6EE1\u610F'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: { color: '#9b9b9b', margin: '0 .09rem' } },
                        '|'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-commonly ' + (item.assess_info.level == 2 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 2 ? 'active' : '' },
                        ' \u4E00\u822C'
                      ),
                      _react2.default.createElement(
                        'span',
                        { style: { color: '#9b9b9b', margin: '0 .09rem' } },
                        '|'
                      ),
                      _react2.default.createElement('label', { className: 'ico-moon icon-dissatisfied ' + (item.assess_info.level == 3 ? 'active' : '') }),
                      _react2.default.createElement(
                        'span',
                        { className: item.assess_info.level == 3 ? 'active' : '' },
                        ' \u4E0D\u6EE1\u610F'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'verticalList-assess-title' },
                    _react2.default.createElement(
                      'span',
                      { className: 'verticalList-assess-goodsTitle' },
                      item.goods_info.title,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'verticalList-assess-goodsContent' },
                      item.assess_info.content
                    )
                  ),
                  !!item.assess_info.has_img && _react2.default.createElement(
                    _react2.default.Fragment,
                    null,
                    _react2.default.createElement(
                      'div',
                      { style: { marginLeft: '.74rem' } },
                      item.assess_info.img_arr.map(function (imgs, index) {
                        return _react2.default.createElement('img', { key: index,
                          'data-imgarr': JSON.stringify(item.assess_info.img_arr), 'data-src': imgs, src: imgs,
                          onClick: _this3.previewImage });
                      })
                    )
                  )
                )
              );
            }),
            !!data.moreAssess && _react2.default.createElement(
              'div',
              { className: 'getMoreAssess', onClick: _this3.drinkGetMoreAssess,
                'data-compindex': _this3.props.index, 'data-nextpage': data.assessCurrentPage + 1 },
              '\u67E5\u770B\u66F4\u591A',
              _react2.default.createElement('label', { className: 'ico-moon icon-downarrow' })
            ),
            !data.moreAssess && _react2.default.createElement(
              'div',
              { className: 'getMoreAssess' },
              data.assessList.length ? '已经到底啦' : '暂无评价'
            )
          ),
          !data.moreAssess && !(data.assessList && data.assessList.length) && _react2.default.createElement(
            'div',
            { className: 'noMoreAssess' },
            _react2.default.createElement('img', { src: 'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/moreAssess.png' }),
            _react2.default.createElement(
              'div',
              { className: 'getMoreAssess', style: { background: '#fff' } },
              '\u6682\u65E0\u4EFB\u4F55\u8BC4\u4EF7'
            )
          )
        );
      };

      // 店铺信息
      var $takeoutShopInfo = function $takeoutShopInfo() {
        return _react2.default.createElement(
          'div',
          { className: 'tokeout-shop-info', style: {
              display: '' + (data.selected == 3 ? 'block' : 'none'),
              padding: 0
            } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: '.26rem', color: '#333333' } },
            _react2.default.createElement(
              'div',
              { className: 'info-title', style: { fontSize: '.3rem' } },
              '\u5546\u5BB6\u4FE1\u606F'
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-shopInfo' },
              _react2.default.createElement(
                'div',
                { className: 'info-adress', onClick: _this3.openDrinkLocation, 'data-name': data.shopInfo && data.shopInfo.title,
                  'data-address': data.shopInfo && data.shopInfo.address_detail, 'data-lat': data.shopInfo && data.shopInfo.latitude,
                  'data-lng': data.shopInfo && data.shopInfo.longitude },
                _react2.default.createElement('label', { className: 'ico-moon icon-fesadress' }),
                _react2.default.createElement(
                  'span',
                  null,
                  data.shopInfo && data.shopInfo.address_detail
                )
              ),
              _react2.default.createElement(
                'div',
                { onClick: _this3.callPhone, 'data-phone': data.shopInfo && data.shopInfo.service_phone, className: 'info-takeout-phone' },
                _react2.default.createElement('label', { className: 'ico-moon icon-fn-phone', style: { marginRight: 0, fontSize: '.4rem', color: '#d2d2d2' } })
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { width: 'auto', overflow: 'hidden', margin: '0 .26rem', padding: '.26rem 0', borderBottom: '1px solid #F3F3F3' } },
              _react2.default.createElement('label', { className: 'ico-moon icon-tokeout-info', style: { float: 'left', marginTop: '.08rem' } }),
              _react2.default.createElement(
                'span',
                { style: { width: '6.5rem', whiteSpace: 'normal' } },
                data.shopInfo && data.shopInfo.store_desc
              )
            )
          ),
          data.shopInfo && data.shopInfo.shop_environment && data.shopInfo.shop_environment.length > 0 && _react2.default.createElement('div', { className: 'cutoffLine', style: { backgroundColor: '#f3f3f3', marginBottom: 0, paddingBottom: 0, height: '.16rem' } }),
          data.shopInfo && data.shopInfo.shop_environment && data.shopInfo.shop_environment.length > 0 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: 'info-title' },
              '\u5E97\u94FA\u98CE\u91C7'
            ),
            _react2.default.createElement(
              'div',
              { className: 'info-mien', style: { whiteSpace: 'nowrap', overflowX: 'auto' } },
              data.shopInfo.shop_environment.map(function (imgs, index) {
                return _react2.default.createElement('img', { key: index,
                  'data-imgarr': JSON.stringify(data.shopInfo.shop_environment), 'data-src': imgs, src: imgs,
                  onClick: _this3.previewImage });
              })
            )
          )
        );
      };

      // 商品详情弹窗
      var $goodsDetailDialog = function $goodsDetailDialog() {
        return _react2.default.createElement(
          'div',
          { className: 'takeout-goods-picture', 'data-compindex': _this3.props.index,
            style: { display: 'block' } },
          _react2.default.createElement(
            'div',
            { className: 'takeout-goods-pic' },
            _react2.default.createElement('label', { className: 'ico-moon icon-closes', 'data-compindex': _this3.props.index, onClick: _this3.drinkHideDetailPop }),
            data.goodsDetail && data.goodsDetail.img_urls.length ? _react2.default.createElement(
              _carousel2.default,
              { dots: true },
              data.goodsDetail.img_urls.map(function (item, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('img', { src: item })
                  )
                );
              })
            ) : _react2.default.createElement('img', { src: data.goodsDetail && data.goodsDetail.cover })
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-detail-box' },
            _react2.default.createElement(
              'div',
              { className: 'goods-info' },
              _react2.default.createElement(
                'div',
                { className: 'goods-detail-title' },
                _react2.default.createElement(
                  'span',
                  { className: 'text' },
                  data.goodsDetail && data.goodsDetail.title
                ),
                data.goodsDetail && data.goodsDetail.vipGoods && data.customFeature.vipShopping && _react2.default.createElement(
                  'span',
                  { className: 'vip-goods' },
                  '\u4F1A\u5458\u8D2D'
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].model.modelData && data.goods_data_list[data.modelGoodsId].model.modelData.map(function (goodsItems, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      { className: '', style: { paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' } },
                      goodsItems.name,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'model-btn' },
                      goodsItems.subModelName.map(function (item, i) {
                        return _react2.default.createElement(
                          'span',
                          { key: i,
                            className: 'attr-btn ' + (goodsItems.subModelId[i] == data.modelIdArr[index] ? 'active' : ''),
                            'data-id': goodsItems.subModelId[i], 'data-goodsid': data.modelGoodsId, 'data-index': i,
                            'data-parentindex': index, 'data-modelname': item, 'data-compindex': _this3.props.index,
                            onClick: _this3.drinkChooseModel },
                          item
                        );
                      })
                    )
                  );
                }),
                data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].attributes && data.goods_data_list[data.modelGoodsId].attributes.map(function (goodsItems, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      { className: '', style: { paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' } },
                      goodsItems.name,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'model-btn' },
                      goodsItems.elem.map(function (item, i) {
                        return _react2.default.createElement(
                          'div',
                          { key: i,
                            className: 'attr-btn ' + (item.id == (data.attrData && data.attrData[goodsItems.id + '_' + item.id] && data.attrData[goodsItems.id + '_' + item.id].id) ? 'active' : ''),
                            'data-id': item.id, 'data-goodsid': data.modelGoodsId, 'data-index': i,
                            'data-parentindex': index, 'data-modelname': item.name, 'data-compindex': _this3.props.index,
                            onClick: _this3.drinkChooseAttr, style: { marginTop: '.1rem', marginBottom: '.1rem' } },
                          item.name,
                          _react2.default.createElement(
                            'span',
                            { className: 'atrr-price' },
                            '+\uFFE5',
                            item.price
                          )
                        );
                      })
                    )
                  );
                })
              )
            ),
            data.goodsDetail && data.goodsDetail.description && _react2.default.createElement(
              'div',
              { className: 'goods-desc' },
              _react2.default.createElement(
                'div',
                { style: { color: '#323232', fontSize: '.26rem', marginBottom: '.16rem' } },
                '\u5546\u54C1\u63CF\u8FF0'
              ),
              _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.goodsDetail.des } })
            ),
            data.goodsDetail && data.goodsDetail.goodsAssess.count > 0 && _react2.default.createElement(
              'div',
              { className: 'goods-evaluate' },
              _react2.default.createElement(
                'div',
                { className: 'evaluate-title' },
                _react2.default.createElement(
                  'span',
                  null,
                  '\u8BC4\u4EF7'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'evaluate-count pull-right', style: { color: '#999999' } },
                  data.goodsDetail.goodsAssess.count,
                  '\u6761\u8BC4\u4EF7'
                )
              ),
              data.goodsDetail.goodsAssess.data.map(function (item, index) {
                return _react2.default.createElement(
                  'div',
                  { className: 'evaluate-info', key: index },
                  _react2.default.createElement(
                    'div',
                    { className: 'evaluate-userInfo' },
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-userInfo-pic' },
                      _react2.default.createElement('img', { src: item.buyer_headimgurl })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-userInfo-info' },
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-nickname' },
                        item.buyer_nickname
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-time' },
                        item.add_time
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'evaluate-desc' },
                    _react2.default.createElement(
                      'div',
                      { className: 'assess' },
                      item.assess_info.content
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'evaluate-pics' },
                    item.assess_info.img_arr && item.assess_info.img_arr.map(function (imgs, index) {
                      return _react2.default.createElement('img', { key: index,
                        'data-imgarr': JSON.stringify(item.assess_info.img_arr), 'data-src': imgs, src: imgs, onClick: _this3.previewImage });
                    })
                  )
                );
              }),
              data.goodsDetail.goodsAssess.is_more == 1 && _react2.default.createElement(
                'div',
                { className: 'request-all',
                  'data-compindex': _this3.props.index, onClick: _this3.drinkGetMoreGoodsAssess },
                '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'goods-add-cart' },
            _react2.default.createElement(
              'div',
              { className: 'goods-addcart-top' },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'waimai-title clearfix' },
                  !(data.goodsDetail && data.goodsDetail.is_vip_goods) ? _react2.default.createElement(
                    'span',
                    { style: { marginRight: '.18rem', fontSize: '.32rem', fontWeight: 600 } },
                    '\xA5',
                    data.modelPrice
                  ) : _react2.default.createElement(
                    'div',
                    { className: 'goodsDetail_vip_goods' },
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_vip_price' },
                      '\xA5',
                      data.modelPrice
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_vip_text' },
                      '\u4F1A\u5458\u4EF7'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'detail_price' },
                      '\xA5',
                      data.modelVipPrice
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'goods-addcart_txt' },
                  data.modelChoose.join(','),
                  data.attrName ? data.modelChoose ? ',' + data.attrName : data.attrName : ''
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'cart-btn', style: { background: 'none' } },
                _react2.default.createElement('label', { className: 'takeout-count-minus', onClick: _this3.drinkMinusModelNum, 'data-modelprice': data.modelPrice,
                  'data-goodsid': data.goodsDetail && data.goodsDetail.id, 'data-compindex': _this3.props.index, 'data-isattr': 'true' }),
                data.hasAddNum > 0 && _react2.default.createElement('input', { type: 'text', style: { width: '.6rem', display: 'inline-block', verticalAlign: 'middle', color: '#000', textAlign: 'center', backgroundColor: 'transparent', border: 'none' },
                  disabled: 'disabled', value: data.hasAddNum }),
                _react2.default.createElement('label', { className: 'takeout-count-plus', 'data-modelprice': data.modelPrice,
                  'data-goodsid': data.goodsDetail && data.goodsDetail.id, 'data-compindex': _this3.props.index,
                  onClick: _this3.drinkAddModelNum })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'bottom-btn', 'data-modelprice': data.modelPrice, 'data-goodsid': data.clickGoodsId,
                'data-compindex': _this3.props.index, onClick: _this3.drinkSureChooseModel,
                style: { background: '#FA5A47' } },
              data.modelLength > 0 && data.modelLength == data.modelIdArr.length ? "加入购物车" : "请选择规格"
            )
          )
        );
      };

      // 单规格属性弹窗
      var $takeoutModelChoose = function $takeoutModelChoose() {
        return _react2.default.createElement(
          'div',
          { className: 'takeout-model-choose', style: {
              display: '' + (!data.goodsAttrShow ? 'none' : 'block')
            },
            'data-compindex': _this3.props.index, onClick: _this3.drinkHideModelPop },
          _react2.default.createElement(
            'div',
            { onClick: function onClick(e) {
                e.stopPropagation();
              }, className: 'takeout-goods-picture' },
            _react2.default.createElement(
              'div',
              { className: 'takeout-goods-pic' },
              _react2.default.createElement('label', { className: 'ico-moon icon-closes', 'data-compindex': _this3.props.index, onClick: _this3.drinkHideDetailPop }),
              data.goodsDetail && data.goodsDetail.img_urls.length ? _react2.default.createElement(
                _carousel2.default,
                { dots: true },
                data.goodsDetail.img_urls.map(function (item, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: index },
                    _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement('img', { src: item })
                    )
                  );
                })
              ) : _react2.default.createElement('img', { src: data.goodsDetail && data.goodsDetail.cover })
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { style: { paddingLeft: '.4rem', height: '4.84rem', width: '6.1rem' }, 'scroll-y': 'true' },
              data.goods_data_list && data.goods_data_list[data.modelGoodsId] && data.goods_data_list[data.modelGoodsId].attributes && data.goods_data_list[data.modelGoodsId].attributes.map(function (goodsItems, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  _react2.default.createElement(
                    'div',
                    { className: '', style: { paddingTop: '.3rem', paddingBottom: '.2rem', color: '#666', fontSize: '.26rem' } },
                    goodsItems.name,
                    '\uFF1A'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'model-btn' },
                    goodsItems.elem.map(function (item, i) {
                      return _react2.default.createElement(
                        'div',
                        {
                          key: i,
                          className: 'attr-btn ' + (item.id == (data.attrData && data.attrData[goodsItems.id + '_' + item.id] && data.attrData[goodsItems.id + '_' + item.id].id) ? 'active' : ''),
                          'data-id': item.id, 'data-goodsid': data.modelGoodsId, 'data-index': i,
                          'data-parentindex': index, 'data-modelname': item.name, 'data-compindex': _this3.props.index,
                          onClick: _this3.drinkChooseAttr, style: { marginTop: '.1rem', marginBottom: '.1rem' } },
                        item.name,
                        _react2.default.createElement(
                          'span',
                          { className: 'atrr-price' },
                          '+\uFFE5',
                          item.price
                        )
                      );
                    })
                  )
                );
              }),
              data.goodsDetail && data.goodsDetail.description && _react2.default.createElement(
                'div',
                { className: 'goods-desc', style: { padding: '.28rem 0 .32rem 0' } },
                _react2.default.createElement(
                  'div',
                  { style: { color: '#323232', fontSize: '.26rem', marginBottom: '.16rem' } },
                  '\u5546\u54C1\u63CF\u8FF0'
                ),
                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.goodsDetail.des } })
              ),
              data.goodsDetail && data.goodsDetail.goodsAssess.count > 0 && _react2.default.createElement(
                'div',
                { className: 'goods-evaluate' },
                _react2.default.createElement(
                  'div',
                  { className: 'evaluate-title' },
                  _react2.default.createElement(
                    'span',
                    null,
                    '\u8BC4\u4EF7'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'evaluate-count pull-right', style: { color: '#999999' } },
                    data.goodsDetail.goodsAssess.count,
                    '\u6761\u8BC4\u4EF7'
                  )
                ),
                data.goodsDetail.goodsAssess.data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'evaluate-info', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-userInfo' },
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-pic' },
                        _react2.default.createElement('img', { src: item.buyer_headimgurl })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'evaluate-userInfo-info' },
                        _react2.default.createElement(
                          'div',
                          { className: 'evaluate-userInfo-nickname' },
                          item.buyer_nickname
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'evaluate-userInfo-time' },
                          item.add_time
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-desc' },
                      _react2.default.createElement(
                        'div',
                        { className: 'assess' },
                        item.assess_info.content
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'evaluate-pics' },
                      item.assess_info.img_arr && item.assess_info.img_arr.map(function (imgs, index) {
                        return _react2.default.createElement('img', { key: index,
                          'data-imgarr': JSON.stringify(item.assess_info.img_arr), 'data-src': imgs, src: imgs, onClick: _this3.previewImage });
                      })
                    )
                  );
                }),
                data.goodsDetail.goodsAssess.is_more == 1 && _react2.default.createElement(
                  'div',
                  { className: 'request-all',
                    'data-compindex': _this3.props.index, onClick: _this3.drinkGetMoreGoodsAssess },
                  '\u70B9\u51FB\u52A0\u8F7D\u66F4\u591A'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'goods-add-cart' },
              _react2.default.createElement(
                'div',
                { className: 'goods-addcart-top' },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'waimai-title clearfix' },
                    !(data.goodsDetail && data.goodsDetail.is_vip_goods) ? _react2.default.createElement(
                      'span',
                      { style: { marginRight: '.18rem', fontSize: '.32rem', fontWeight: 600 } },
                      '\xA5',
                      data.modelPrice
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'goodsDetail_vip_goods' },
                      _react2.default.createElement(
                        'span',
                        { className: 'detail_vip_price' },
                        '\xA5',
                        data.modelVipPrice
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'detail_vip_text' },
                        '\u4F1A\u5458\u4EF7'
                      ),
                      _react2.default.createElement(
                        'span',
                        { className: 'detail_price' },
                        '\xA5',
                        data.modelPrice
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'goods-addcart_txt' },
                    data.modelChoose && data.modelChoose.join(','),
                    data.attrName || ''
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'cart-btn', style: { background: 'none' } },
                  _react2.default.createElement('label', { className: 'takeout-count-minus', onClick: _this3.drinkMinusModelNum, 'data-modelprice': data.modelPrice,
                    'data-goodsid': data.goodsDetail && data.goodsDetail.id, 'data-compindex': _this3.props.index, 'data-isattr': 'true' }),
                  data.hasAddNum > 0 && _react2.default.createElement('input', { type: 'text', style: { width: '.6rem', display: 'inline-block', verticalAlign: 'middle', color: '#000', textAlign: 'center' },
                    disabled: 'disabled', value: data.hasAddNum }),
                  _react2.default.createElement('label', { className: 'takeout-count-plus', 'data-modelprice': data.modelPrice,
                    'data-goodsid': data.goodsDetail && data.goodsDetail.id, 'data-compindex': _this3.props.index,
                    onClick: _this3.drinkAddModelNum })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom-btn', 'data-modelprice': data.modelPrice, 'data-goodsid': data.goodsDetail && data.goodsDetail.id,
                  'data-compindex': _this3.props.index, onClick: _this3.drinkAddAttrGoods,
                  style: { background: '#FA5A47' } },
                '\u52A0\u5165\u8D2D\u7269\u8F66'
              )
            )
          )
        );
      };

      // 单人购物车
      var $verticalListShoppingCartsList = function $verticalListShoppingCartsList() {
        return _react2.default.createElement(
          'div',
          { className: 'verticalList-shopping-carts-list',
            style: {
              display: '' + (data.shoppingCartShow ? 'block' : 'none')
            },
            'data-compindex': _this3.props.index, onClick: function onClick(e) {
              e.stopPropagation();_this3.drinkHideShoppingCart(e);
            } },
          _react2.default.createElement(
            'div',
            { onClick: function onClick(e) {
                return e.stopPropagation();
              },
              style: {
                maxHeight: 'calc(' + (data.customFeature.showShopInfo ? (data.heightPx + 181) / 2 / 50 : (data.heightPx + 86) / 2 / 50) + 'rem + .76rem)',
                height: 'auto'
              },
              className: 'carts-content' },
            _react2.default.createElement(
              'div',
              { className: 'chosen-title', style: { borderRadius: '.2rem .2rem 0 0' } },
              _react2.default.createElement(
                'span',
                { className: 'pull-right', 'data-compindex': _this3.props.index, onClick: function onClick(e) {
                    e.stopPropagation();_this3.drinkDeleteAllCarts(e);
                  }, style: { display: 'inline-block', fontSize: '.26rem', fontWeight: 400, color: '#999', margin: '0 .3rem 0 .05rem' } },
                '\u6E05\u7A7A'
              ),
              !!data.TotalNum && _react2.default.createElement('div', { className: 'pull-right ico-moon icon-delete', onClick: _this3.drinkDeleteAllCarts,
                'data-compindex': _this3.props.index,
                style: { display: 'inline-block', fontSize: '.26rem', fontWeight: 400, color: '#999', transform: 'translateY(.02rem)' } })
            ),
            data.TotalNum === 0 && _react2.default.createElement(
              'div',
              { className: 'noGoods' },
              '\u6682\u672A\u9009\u8D2D\u5546\u54C1'
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              {
                style: {
                  maxHeight: 'calc(' + (data.customFeature.showShopInfo ? ((data.heightPx + 181) / 2 - 37) / 50 : ((data.heightPx + 86) / 2 - 37) / 50) + 'rem + .5rem)'
                },
                'scroll-y': 'true' },
              data.cartGoodsIdList.map(function (items, index) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: index },
                  data.cartList[0][items] && Object.values(data.cartList[0][items]).map(function (item, i) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: i },
                      item.attrArr && item.attrArr.map(function (it, i) {
                        return _react2.default.createElement(
                          _react2.default.Fragment,
                          { key: i },
                          item.modelId != 0 ? _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            !!item.attrObj[it].num && _react2.default.createElement(
                              'div',
                              {
                                className: 'shopping-cart-list ' + (item.in_business_time == 0 ? 'gray' : ''), style: { margin: '0 .3rem' },
                                key: index },
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-info' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'cart-title', style: { marginTop: '.3rem' } },
                                  item.gooodsName
                                ),
                                _react2.default.createElement(
                                  'div',
                                  { className: 'cart-model' },
                                  item.modelName
                                ),
                                item.attrObj[it].attrNameArr && !!item.attrObj[it].attrNameArr.length && _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  item.attrObj[it].attrNameArr.map(function (attrItem, attrIndex) {
                                    return _react2.default.createElement(
                                      _react2.default.Fragment,
                                      { key: attrIndex },
                                      _react2.default.createElement(
                                        'div',
                                        { className: 'cart-model' },
                                        attrItem.pName,
                                        ' : ',
                                        attrItem.name,
                                        ' ',
                                        _react2.default.createElement(
                                          'span',
                                          {
                                            style: { color: '#F2303E' } },
                                          '+\uFFE5',
                                          attrItem.price
                                        )
                                      )
                                    );
                                  })
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-price' },
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  '\xA5',
                                  item.attrObj[it].totalPrice
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-btn' },
                                item.in_business_time != 0 ? _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''),
                                    onClick: function onClick(e) {
                                      e.stopPropagation();_this3.drinkCartListMinus(e);
                                    }, 'data-id': item.cart_id, 'data-modelid': item.modelId,
                                    'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index,
                                    'data-attrid': it, 'data-goodsid': item.id, 'data-stock': item.stock, 'data-index': '0',
                                    'data-num': item.attrObj[it].num, 'data-price': item.attrObj[it].price }),
                                  _react2.default.createElement('input', { type: 'text', style: { width: '.5rem', display: 'inline-block', border: 'none', backgroundColor: 'transparent' }, disabled: 'disabled',
                                    value: item.attrObj[it].num }),
                                  (!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', {
                                    className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.attrObj[it].num >= item.stock ? 'disabled' : ''),
                                    onClick: function onClick(e) {
                                      e.stopPropagation();_this3.drinkCartListPlus(e);
                                    }, 'data-modelid': item.modelId, 'data-compindex': _this3.props.index,
                                    'data-is-in-business': item.in_business_time, 'data-goodsid': item.id, 'data-index': '0',
                                    'data-stock': item.stock, 'data-num': item.attrObj[it].num, 'data-id': item.cart_id,
                                    'data-attrid': it })
                                ) : _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'delete-single-cart', onClick: _this3.drinkDeleteSingleCarts,
                                      'data-modelid': item.modelId, 'data-compindex': _this3.props.index,
                                      'data-goodsid': item.id },
                                    '\u5220\u9664'
                                  )
                                )
                              )
                            )
                          ) : _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            !!item.attrObj[it].num && _react2.default.createElement(
                              'div',
                              { className: 'shopping-cart-list', style: { margin: '0 .3rem' } },
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-info' },
                                item.in_business_time != 0 && _react2.default.createElement(
                                  'div',
                                  { className: 'cart-title',
                                    style: {
                                      marginTop: '' + (item.attrObj[it].attrName && item.attrObj[it].packageArr ? '.3rem' : '.44rem')
                                    },
                                    'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id,
                                    'data-index': '0', 'data-it': it, onClick: _this3.drinkMealDetailTab,
                                    'data-ispackage': item.is_package_goods },
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'goodsName',
                                      style: {
                                        maxWidth: '' + (item.is_package_goods ? 'calc(100% - .6rem)' : '100%')
                                      } },
                                    item.gooodsName
                                  ),
                                  !item.attrObj[it].isShowMealDetail && !!+item.is_package_goods && item.attrObj[it].packageArr && _react2.default.createElement('label', { className: 'ico-moon icon-downarrow' }),
                                  item.attrObj[it].isShowMealDetail && !!+item.is_package_goods && item.attrObj[it].packageArr && _react2.default.createElement('label', { className: 'ico-moon icon-uparrow' }),
                                  item.attrObj[it].attrNameArr && !!item.attrObj[it].attrNameArr.length && _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    item.attrObj[it].attrNameArr.map(function (attrItem, attrIndex) {
                                      return _react2.default.createElement(
                                        _react2.default.Fragment,
                                        { key: attrIndex },
                                        _react2.default.createElement(
                                          'div',
                                          { className: 'cart-model' },
                                          attrItem.pName,
                                          ' : ',
                                          attrItem.name,
                                          ' ',
                                          _react2.default.createElement(
                                            'span',
                                            {
                                              style: { color: '#F2303E' } },
                                            '+\uFFE5',
                                            attrItem.price
                                          )
                                        )
                                      );
                                    })
                                  )
                                ),
                                item.in_business_time == 0 && _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'cart-title', style: { marginTop: '.3rem' } },
                                    item.gooodsName
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'cart-model' },
                                    '(\u4E0D\u5728\u51FA\u552E\u65F6\u95F4)'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-price' },
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  '\xA5',
                                  item.attrObj[it].totalPrice
                                )
                              ),
                              _react2.default.createElement(
                                'div',
                                { className: 'cart-btn' },
                                item.in_business_time != 0 ? _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement('label', { className: 'verticalList-count-minus ' + (item.in_business_time == 0 ? 'disabled' : ''),
                                    'data-is-in-business': item.in_business_time, onClick: function onClick(e) {
                                      e.stopPropagation();_this3.drinkCartListMinus(e);
                                    },
                                    'data-modelid': item.modelId, 'data-compindex': _this3.props.index, 'data-goodsid': item.id,
                                    'data-stock': item.stock, 'data-attrid': it, 'data-id': item.cart_id, 'data-index': '0',
                                    'data-price': item.price, 'data-num': item.attrObj[it].num }),
                                  _react2.default.createElement('input', { type: 'text', style: { width: '.5rem', display: 'inline-block', border: 'none', backgroundColor: 'initial' }, disabled: 'disabled',
                                    value: item.attrObj[it].num }),
                                  (!data.customFeature.is_together || buyer_index == 0) && _react2.default.createElement('label', {
                                    className: 'verticalList-count-plus ' + (item.in_business_time == 0 || item.attrObj[it].num >= item.stock ? 'disabled' : ''),
                                    onClick: function onClick(e) {
                                      e.stopPropagation();_this3.drinkCartListPlus(e);
                                    }, 'data-attrid': it, 'data-modelid': item.modelId,
                                    'data-is-in-business': item.in_business_time, 'data-compindex': _this3.props.index,
                                    'data-goodsid': item.id, 'data-stock': item.stock, 'data-num': item.attrObj[it].num,
                                    'data-index': '0', 'data-id': item.cart_id })
                                ) : _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'delete-single-cart', onClick: _this3.drinkDeleteSingleCarts,
                                      'data-modelid': item.modelId, 'data-compindex': _this3.props.index,
                                      'data-goodsid': item.id },
                                    '\u5220\u9664'
                                  )
                                )
                              ),
                              item.attrObj[it].isShowMealDetail && item.is_package_goods && _react2.default.createElement(
                                'div',
                                { className: 'cart-meal' },
                                _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'meal-detail' },
                                    item.attrObj[it].packageArr.map(function (packageItem, index) {
                                      return _react2.default.createElement(
                                        _react2.default.Fragment,
                                        { key: index },
                                        packageItem.goods_id_list.map(function (skuId, index) {
                                          return _react2.default.createElement(
                                            _react2.default.Fragment,
                                            { key: index },
                                            packageItem.goods_list[skuId] && _react2.default.createElement(
                                              'div',
                                              { className: 'meal-item' },
                                              _react2.default.createElement(
                                                'div',
                                                { className: 'meal-info' },
                                                packageItem.goods_list[skuId].is_require > 0 && packageItem.goods_list[skuId].is_multi_select > 0 && packageItem.goods_list[skuId].selected_num > packageItem.goods_list[skuId].min_sales_nums && packageItem.goods_list[skuId].selected_num > 1 ? _react2.default.createElement(
                                                  _react2.default.Fragment,
                                                  null,
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-title' },
                                                    _react2.default.createElement(
                                                      'span',
                                                      null,
                                                      packageItem.goods_list[skuId].title
                                                    ),
                                                    _react2.default.createElement(
                                                      'label',
                                                      null,
                                                      '\u5FC5'
                                                    ),
                                                    _react2.default.createElement(
                                                      'label',
                                                      null,
                                                      '\u6807\u914D'
                                                    )
                                                  ),
                                                  packageItem.goods_list[skuId].model_name && _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-info' },
                                                    ' ',
                                                    packageItem.goods_list[skuId].model_name
                                                  ),
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-title' },
                                                    _react2.default.createElement(
                                                      'span',
                                                      null,
                                                      packageItem.goods_list[skuId].title
                                                    ),
                                                    packageItem.goods_list[skuId].added_price > 0 && _react2.default.createElement(
                                                      'div',
                                                      { style: { float: 'right' }, className: 'item-add-price' },
                                                      '+\uFFE5',
                                                      packageItem.goods_list[skuId].added_price
                                                    )
                                                  )
                                                ) : _react2.default.createElement(
                                                  _react2.default.Fragment,
                                                  null,
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-title' },
                                                    _react2.default.createElement(
                                                      'span',
                                                      null,
                                                      packageItem.goods_list[skuId].title
                                                    ),
                                                    packageItem.goods_list[skuId].is_require > 0 && _react2.default.createElement(
                                                      'label',
                                                      null,
                                                      '\u5FC5'
                                                    ),
                                                    packageItem.goods_list[skuId].is_require > 0 && _react2.default.createElement(
                                                      'label',
                                                      null,
                                                      '\u6807\u914D'
                                                    ),
                                                    !(packageItem.goods_list[skuId].is_require > 0) && packageItem.goods_list[skuId].added_price > 0 && _react2.default.createElement(
                                                      'div',
                                                      { style: { float: 'right' }, className: 'item-add-price' },
                                                      '+\uFFE5',
                                                      packageItem.goods_list[skuId].added_price
                                                    )
                                                  )
                                                ),
                                                packageItem.goods_list[skuId].model_name && _react2.default.createElement(
                                                  'div',
                                                  { className: 'item-info' },
                                                  ' ',
                                                  packageItem.goods_list[skuId].model_name
                                                ),
                                                packageItem.goods_list[skuId]._attributes.map(function (_attr, index) {
                                                  return _react2.default.createElement(
                                                    _react2.default.Fragment,
                                                    { key: index },
                                                    _attr.elem.map(function (elem, index) {
                                                      return _react2.default.createElement(
                                                        _react2.default.Fragment,
                                                        { key: index },
                                                        elem.price > 0 && _react2.default.createElement(
                                                          'div',
                                                          { className: 'item-info' },
                                                          _attr.name,
                                                          ' : ',
                                                          elem.name,
                                                          _react2.default.createElement(
                                                            'span',
                                                            null,
                                                            ' +\uFFE5',
                                                            elem.price
                                                          )
                                                        )
                                                      );
                                                    })
                                                  );
                                                })
                                              ),
                                              _react2.default.createElement(
                                                'div',
                                                { style: { display: 'inline-block', verticalAlign: 'top', float: 'right' } },
                                                packageItem.goods_list[skuId].is_require > 0 && packageItem.goods_list[skuId].is_multi_select > 0 && packageItem.goods_list[skuId].selected_num > packageItem.goods_list[skuId].min_sales_nums && packageItem.goods_list[skuId].selected_num > 1 ? _react2.default.createElement(
                                                  _react2.default.Fragment,
                                                  null,
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-num' },
                                                    '\xD7',
                                                    packageItem.goods_list[skuId].min_sales_nums
                                                  ),
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-num',
                                                      style: {
                                                        float: 'none',
                                                        paddingTop: '' + (packageItem.goods_list[skuId].model_name ? '.76rem' : '')
                                                      } },
                                                    '\xD7',
                                                    packageItem.goods_list[skuId].selected_num - packageItem.goods_list[skuId].min_sales_nums
                                                  )
                                                ) : _react2.default.createElement(
                                                  _react2.default.Fragment,
                                                  null,
                                                  _react2.default.createElement(
                                                    'div',
                                                    { className: 'item-num' },
                                                    '\xD7',
                                                    packageItem.goods_list[skuId].selected_num
                                                  )
                                                )
                                              )
                                            )
                                          );
                                        })
                                      );
                                    })
                                  )
                                )
                              )
                            )
                          )
                        );
                      })
                    );
                  })
                );
              })
            )
          )
        );
      };

      // 优惠券弹窗
      var $couponsList = function $couponsList() {
        return _react2.default.createElement(
          'div',
          { className: 'takeout-shopping-carts-list coupons-list',
            style: {
              display: '' + (!data.shoppingCouponsList ? 'none' : 'block')
            } },
          _react2.default.createElement(
            'div',
            { className: 'shop-info-detail' },
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { 'scroll-y': true },
              _react2.default.createElement(
                'div',
                { className: 'shop-name' },
                data.shopInfo && data.shopInfo.title
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-text' },
                  '\u8425\u4E1A\u65F6\u95F4'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-deliver-content' },
                  data.shopInfo && data.shopInfo.business_time_str
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'shop-info-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-text' },
                  '\u5E97\u94FA\u5730\u5740'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-deliver-content' },
                  data.shopInfo && data.shopInfo.address
                )
              ),
              data.customFeature.isShowNotice && data.shopInfo && data.shopInfo.shop_notice && _react2.default.createElement(
                'div',
                { className: 'shop-info-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'content-text' },
                  '\u516C\u544A'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'info-deliver-content' },
                  '\u516C\u544A\uFF1A',
                  data.shopInfo.shop_notice
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail-close', 'data-compindex': _this3.props.index, onClick: _this3.drinkHideCouponsList },
              _react2.default.createElement('label', { className: 'ico-moon icon-closes' })
            )
          )
        );
      };

      // 会员购弹窗
      var $vipDialog = function $vipDialog() {
        return _react2.default.createElement(
          'div',
          { className: 'verticalList-vipDialog', style: {
              display: '' + (!data.showVipDialog ? 'none' : 'block')
            },
            'data-compindex': _this3.props.index, onClick: _this3.drinkCloseVipDialog },
          _react2.default.createElement(
            'div',
            { onClick: function onClick(e) {
                return e.stopPropagation();
              } },
            _react2.default.createElement('label', { onClick: _this3.drinkCloseVipDialog, className: 'ico-moon icon-closes', 'data-compindex': _this3.props.index }),
            _react2.default.createElement(
              'div',
              { className: 'vipCardUp' },
              _react2.default.createElement('img', { src: 'http://test.zhichiwangluo.com/zhichi_frontend/static/webapp/images/takeout/vip_card_up.png' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'cardTips' },
              _react2.default.createElement(
                'span',
                null,
                '\u60A8\u5F53\u524D\u7684\u4F1A\u5458\u5361\uFF0C\u6682\u65E0\u8D2D\u4E70\u8BE5\u5546\u54C1\u6743\u9650\uFF0C\u53EF\u5347\u7EA7\u4F1A\u5458\u5361'
              )
            ),
            _react2.default.createElement(
              _ScrollView.ScrollView,
              { 'scroll-y': true },
              data.vipCondtionInfo && data.vipCondtionInfo.vip_card_data.length > 0 && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.vipCondtionInfo.vip_card_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'cardContent', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-title' },
                      item.title,
                      '\u4F1A\u5458\u5361(V',
                      item.level,
                      ')\u8FBE\u6210\u6761\u4EF6\uFF1A'
                    ),
                    item.trade_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u7D2F\u8BA1\u4EA4\u6613\u6210\u529F',
                      item.trade_count,
                      '\u7B14'
                    ),
                    item.consume_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u6216\u7D2F\u8BA1\u6D88\u8D39\u91D1\u989D',
                      item.consume_count,
                      '\u5143'
                    ),
                    item.integral_count > -1 && _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u6216\u7D2F\u8BA1\u79EF\u5206\u8FBE\u5230',
                      item.integral_count,
                      '\u5206'
                    )
                  );
                })
              ),
              data.vipCondtionInfo && data.vipCondtionInfo.paid_vip_card_data.length > 0 && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.vipCondtionInfo.paid_vip_card_data.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'cardContent', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-title' },
                      item.title,
                      '\u4F1A\u5458\u5361(V',
                      item.level,
                      ')\u8FBE\u6210\u6761\u4EF6\uFF1A'
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'card-content-tips' },
                      '\u4EF7\u683C\uFF1A\u6BCF\u6708',
                      item.price
                    )
                  );
                })
              )
            )
          )
        );
      };

      return _react2.default.createElement(
        'div',
        { className: 'custom-component drink-vertical-list' },
        _react2.default.createElement(
          'div',
          { className: 'drinkVerticalList-wrap', 'data-compindex': this.props.index },
          _react2.default.createElement(
            'div',
            {
              className: 'zcdrink-box-shadow ' + (data.pick_up_type.length > 1 || data.customFeature.multipleMerchants ? 'margin' : '') },
            $merchatsPickup(),
            +data.pick_up_select === 2 && $locationBox()
          ),
          !data.showSearch && $tabsWrap(),
          data.showSearch && $searchWrap(),
          !data.showSearch && $waimaiContainerWrap(),
          data.showSearch && $searchResult(),
          $bottomShoppingCart(),
          !data.showSearch && $evaluationWrap(),
          !data.showSearch && $takeoutShopInfo(),
          data.goodsDetailShow && $goodsDetailDialog(),
          $takeoutModelChoose(),
          $verticalListShoppingCartsList(),
          data.showGoodDetailMask && _react2.default.createElement('div', { className: 'settlement-mask', 'data-compindex': this.props.index, onClick: this.drinkHideDetailPop, onTouchMove: this.drinkStopMove }),
          $couponsList(),
          $vipDialog()
        )
      );
    }
  }]);
  return DrinkVerticalListCustomComponent;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.drinkVerticalListChangeEvaluate = function (e) {
    _this4.verticalListChangeEvaluate(e);
  };

  this.drinkVerticalListShowGoodsSearch = function (e) {
    _this4.verticalListShowGoodsSearch(e);
  };

  this.drinkVerticalListHideGoodsSearch = function (e) {
    _this4.verticalListHideGoodsSearch(e);
  };

  this.drinkVerticalListBindSearchTitle = function (e) {
    _this4.verticalListBindSearchTitle(e);
  };

  this.drinkVerticalListSearchByTitle = function (e) {
    _this4.verticalListSearchByTitle(e);
  };

  this.drinkVerticalListClickCategory = function (e) {
    _this4.verticalListClickCategory(e);
  };

  this.drinkVerticalListStyleScrollFunc = function (e) {
    _this4.verticalListStyleScrollFunc(e);
  };

  this.drinkVerticalListStyleScrollTop = function (e) {
    _this4.verticalListStyleScrollTop(e);
  };

  this.drinkSortVerticalList = function (e) {
    _this4.sortVerticalList(e);
  };

  this.showDrinkVerticalListGoodsDetail = function (e) {
    _this4.showVerticalListGoodsDetail(e);
  };

  this.drinkAddModelNum = function (e) {
    _this4.addModelNum(e);
  };

  this.drinkMinusModelNum = function (e) {
    _this4.minusModelNum(e);
  };

  this.drinkVerticalListListMinus = function (e) {
    _this4.verticalListListMinus(e);
  };

  this.drinkVerticalListListPlus = function (e) {
    _this4.verticalListListPlus(e);
  };

  this.drinkVerticalListSearchScrollFunc = function (e) {
    _this4.verticalListSearchScrollFunc(e);
  };

  this.drinkShowShoppingCartPop = function (e) {
    _this4.verticalListShowShoppingCartPop(e);
  };

  this.drinkChangeAssessType = function (e) {
    _this4.verticalListChangeAssessType(e);
  };

  this.drinkGetMoreAssess = function (e) {
    _this4.verticalListGetMoreAssess(e);
  };

  this.openDrinkLocation = function (e) {
    _this4.openVerticalListLocation(e);
  };

  this.drinkHideDetailPop = function (e) {
    _this4.verticalListHideDetailPop(e);
  };

  this.drinkGetMoreGoodsAssess = function (e) {
    _this4.verticalListGetMoreGoodsAssess(e);
  };

  this.drinkHideModelPop = function (e) {
    _this4.verticalListHideModelPop(e);
  };

  this.drinkChooseModel = function (e) {
    _this4.verticalListChooseModel(e);
  };

  this.drinkSureChooseModel = function (e) {
    _this4.verticalListSureChooseModel(e);
  };

  this.drinkMinuModel = function (e) {
    _this4.verticalListMinuModel(e);
  };

  this.drinkHideShoppingCart = function (e) {
    _this4.verticalListHideShoppingCart(e);
  };

  this.drinkDeleteAllCarts = function (e) {
    _this4.verticalListDeleteAllCarts(e);
  };

  this.drinkCartListMinus = function (e) {
    _this4.verticalListCartListMinus(e);
  };

  this.drinkCartListPlus = function (e) {
    _this4.verticalListCartListPlus(e);
  };

  this.drinkHideCouponsList = function (e) {
    _this4.verticalListHideCouponsList(e);
  };

  this.drinkDeleteSingleCarts = function (e) {
    _this4.deleteSingleCarts(e);
  };

  this.drinkSelectGoodsSameJourney = function (e, compindex) {
    _this4.vlSelectGoodsSameJourney(e, compindex);
  };

  this.drinkSelectSettlement = function (e) {
    _this4.verticalListSettlement(e);
  };

  this.drinkCloseVipDialog = function (e) {
    _this4.verticalListCloseVipDialog(e);
  };

  this.drinkDeleteBuyerCarts = function (e) {
    _this4.verticalListDeleteBuyerCarts(e);
  };

  this.drinkToSetMeal = function (e) {
    _this4.toSetMeal(e);
  };

  this.drinkMealDetailTab = function (e) {
    _this4.mealDetailTab(e);
  };

  this.drinkChooseAttr = function (e) {
    _this4.verticalListChooseAttr(e);
  };

  this.drinkAddAttrGoods = function (e) {
    _this4.addAttrGoods(e);
  };

  this.drinkMinuAttrGoods = function (e) {
    _this4.minuAttrGoods(e);
  };

  this.drinkCheckedPickRadioFn = function (event) {
    _this4.checkedPickRadioFn(event);
  };

  this.drinkConfirmGoodsPick = function (event) {
    _this4.confirmGoodsPick(event);
  };

  this.drinkStopMove = function () {
    return;
  };

  this.drinkTurnToChainStoreList = function () {
    _this4.drinkTurnToChainStoreList();
  };

  this.selectPickUpType = function (event) {
    _this4.selectPickUpType(event);
  };

  this.drinkAddCartAnimation = function (pageInstance, compindex) {
    _this4.addCartAnimation(pageInstance, compindex);
  };

  this.tapEventCommonHandler = function (e) {
    _app.appMethod.tapEventCommonHandler(e);
  };

  this.previewImage = function (e) {
    var _e$currentTarget$data = e.currentTarget.dataset,
        src = _e$currentTarget$data.src,
        imgarr = _e$currentTarget$data.imgarr;

    _app.appMethod.previewImage({
      current: src,
      urls: JSON.parse(imgarr)
    });
  };

  this.init = function (compindex, pageInstance, show) {
    var _pageInstance$setData;

    var compData = pageInstance.data.eles[compindex];
    var customFeature = compData.customFeature;
    var param = {};
    var that = _this4;
    var pick_up_type_new = [];
    param['pick_up_type'] = [];
    if (customFeature.pickUpArr) {
      if (customFeature.pickUpArr.sameJourney) {
        param.pick_up_type.push(2);
      }
      if (customFeature.pickUpArr.selfLifting) {
        param.pick_up_type.push(3);
      }
      if (customFeature.pickUpArr.dining) {
        param.pick_up_type.push(4);
      }
    }
    if (param.pick_up_type.length === 0) {
      param.pick_up_type.push(0);
    }
    param.form = 'goods';
    param.is_count = 0;
    if (param.pick_up_type.indexOf(3) >= 0) {
      pick_up_type_new.push(3);
    }
    if (param.pick_up_type.indexOf(4) >= 0) {
      pick_up_type_new.push(4);
    }
    if (param.pick_up_type.indexOf(2) >= 0) {
      pick_up_type_new.push(2);
    }
    pageInstance.setData((_pageInstance$setData = {}, (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].pick_up_type', param.pick_up_type), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].pick_up_type_new', pick_up_type_new), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].buyer_info', []), (0, _defineProperty3.default)(_pageInstance$setData, 'eles[' + compindex + '].user_list', []), _pageInstance$setData));
    if (show) {
      var pick_up_type = param.pick_up_type[0];
      if (param.pick_up_type.indexOf(3) >= 0) pick_up_type = 3;
      if (param.pick_up_type.indexOf(4) >= 0 && pick_up_type != 3) pick_up_type = 4;
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].pick_up_select', pick_up_type));
      pick_up_type = null;
      that._getPickUpLeft(compindex);
    }
    compData.timer = null; //轮询定时器
    compData.loopRequest = true; //轮询接口是否完成
    compData.is_init = true; //首次需要重新渲染购物车
    compData.addCartComplete = true; //加购物车  成功后才拿到cart_id
    var franchisee_id = _app.appMethod.getPageFranchiseeId();
    if (franchisee_id) {
      compData.location_id = _app.appMethod.globalData[franchisee_id] ? _app.appMethod.globalData[franchisee_id].ec_location_id : '';
    } else {
      compData.location_id = _app.appMethod.globalData.ec_location_id || '';
    }
    if (customFeature.multipleMerchants) {
      _this4.getMainStoreInfo();
    }
    _this4.verticalListCompsInit(compindex, pageInstance, param);
    pick_up_type_new = null;
  };

  this.verticalListCompsInit = function (compindex, pageInstance, par) {
    var that = _this4;
    var param = par;
    pageInstance.returnToVerticalFlag = 0;
    var compData = pageInstance.data.eles[compindex];
    compData.heightFlag = true; //显示隐藏店铺信息是否完成
    compData.flag = true; //获取购物车数据并转换数据完成后才允许加商品
    clearInterval(compData.timer);
    var newData = {};
    newData['eles[' + compindex + '].goodsDetailShow'] = false;
    newData['eles[' + compindex + '].goodsModelShow'] = false;
    newData['eles[' + compindex + '].goodsAttrShow'] = false;
    newData['eles[' + compindex + '].hideSearchInput'] = false;

    if (pageInstance.data.eles.page_hasNavBar) {
      newData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - _app.appMethod.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100 - _app.appMethod.globalData.topNavBarHeight;
    } else {
      newData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      newData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100;
    }
    newData['eles[' + compindex + '].selected'] = 1;
    newData['eles[' + compindex + '].customFeature.selected'] = 0;
    if (compData.TotalNum == undefined) {
      newData['eles[' + compindex + '].TotalNum'] = 0;
      newData['eles[' + compindex + '].TotalPrice'] = 0.00;
    }
    newData['eles[' + compindex + '].cartList'] = [{}];
    newData['eles[' + compindex + '].cartGoodsIdList'] = [];
    newData['eles[' + compindex + '].loading'] = true;
    newData['eles[' + compindex + '].loadingFail'] = false;
    if (compData.goods_data_list) {
      newData['eles[' + compindex + '].show_goods_data'] = {};
      newData['eles[' + compindex + '].goods_data_list'] = {};
    }
    newData['eles[' + compindex + '].categorySort'] = {};
    newData['eles[' + compindex + '].showSearch'] = false;
    newData['eles[' + compindex + '].goodsCateHeight'] = {}; // 每个分类的商品列表高度
    newData['eles[' + compindex + '].requestNum'] = 0;
    newData['eles[' + compindex + '].isChangeTab'] = 0;
    newData['eles[' + compindex + '].showSettlementMask'] = false;
    newData['eles[' + compindex + '].showGoodDetailMask'] = false;
    newData['eles[' + compindex + '].franchiseeId'] = _app.appMethod.getPageFranchiseeId() || '';
    pageInstance.setData(newData);
    pageInstance[compindex] || (pageInstance[compindex] = {});
    param['sort_key'] = '';
    param['sort_direction'] = 0;
    param['page'] = 1;
    param['page_size'] = 10;
    param['take_out_style'] = 1;
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      !compData.currentLocationData && !compData.selectSameJourney ? _this4.getCurrentLocation(compindex, pageInstance) : '';
    }
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
      data: {
        pick_up_type: 2,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        res.data ? res.data : res.data = {};
        res.data ? res.data : res.data = {};
        var shopInfoData = res.data;
        if (!shopInfoData.app_store_data) {
          _app.appMethod.sendRequest({
            url: '/index.php?r=AppEcommerce/getPickUpGoodsTypeSetting',
            data: {
              pick_up_type: 4,
              sub_shop_app_id: sub_shop_app_id || ''
            },
            success: function success(res) {
              res.data ? res.data : res.data = {};
              var shopInfoData = res.data;
              that.setShopInfo(pageInstance, compindex, shopInfoData);
            }
          });
        } else {
          that.setShopInfo(pageInstance, compindex, shopInfoData);
        }
      }
    });

    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getGoodsCategory',
      method: 'post',
      data: {
        filter_null: 1,
        goods_type: 0,
        pick_up_type: compData.pick_up_type,
        sub_shop_app_id: _app.appMethod.getPageFranchiseeId() || ''
      },
      success: function success(res) {
        var content = [];
        for (var i = 0; i < res.data.length; i++) {
          content.push({
            text: res.data[i].name,
            source: res.data[i].id,
            pic: res.data[i].logo
          });
        }
        var cateData = {};
        cateData['eles[' + compindex + '].content'] = content;
        pageInstance.setData(cateData);
        if (content.length === 0) return;
        that.getGoodListByCate(pageInstance, compindex, content, param);
      }
    });
  };

  this.setShopInfo = function (pageInstance, compindex, shopInfoData) {
    var newdata = {};
    newdata['eles[' + compindex + '].shopInfo'] = shopInfoData.app_store_data || {};
    newdata['eles[' + compindex + '].config_data'] = shopInfoData.config_data || {};
    newdata['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.setData(newdata, function () {
      _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
        var animationData = {};
        pageInstance[compindex]['shopInfoHeight'] || (pageInstance[compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0);
        // TODO
        // let animation = app.createAnimation({
        //   duration: 200,
        //   timingFunction: 'linear'
        // })
        // animation.height(pageInstance[compindex]['shopInfoHeight']).step();
        // animationData['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        animationData['eles[' + compindex + '].shopHeight'] = pageInstance[compindex]['shopInfoHeight'];
        pageInstance.setData(animationData);
      });
    });
    _this4.getShopAdvancedSetting(pageInstance, compindex);
  };

  this.getGoodListByCate = function (pageInstance, compindex, content, param) {
    var cateData = {};
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    for (var j in content) {
      var cateParam = {};
      cateParam.param = {};
      Object.assign(cateParam.param, param);
      cateParam.param.idx_arr = {
        idx: 'category',
        idx_value: content[j].source == 'all' ? '' : content[j].source
      };
      cateData['eles[' + compindex + '].pagination.category' + content[j].source] = cateParam;
    }
    if (pageInstance.data.eles.page_hasNavBar) {
      cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) - _app.appMethod.globalData.topNavBarHeight + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100 - _app.appMethod.globalData.topNavBarHeight;
    } else {
      cateData['eles[' + compindex + '].heightPx'] = _app.appMethod.returnListHeight(compData.customFeature.showShopInfo, 2, pageInstance.data.eles[compindex].customFeature.mode) + (compData.customFeature.pickUpArr.sameJourney ? 0 : 40);
      cateData['eles[' + compindex + '].searchHeight'] = _app.appMethod.getSystemInfoSync().windowHeight - 100;
    }
    cateData['eles[' + compindex + '].route'] = pageInstance.route;
    pageInstance.setData(cateData);
    //分类加载（先加载第一个分类前十条数据）
    param.page = 1;
    param.page_size = 10;
    param.idx_arr = {
      idx: 'category',
      idx_value: content[0].source == 'all' ? '' : content[0].source
    };
    compData['loading'] = true;
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  };

  this.verticalListChangeEvaluate = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = event.currentTarget.dataset.compindex;
    if (event.currentTarget.dataset.index == 2) {
      pageInstance.hasRequireAssess = true;
      _this4._getAssessList(pageInstance, compindex);
    }
    newdata['eles[' + compindex + '].selected'] = event.currentTarget.dataset.index;
    pageInstance.setData(newdata);
  };

  this.verticalListTouchstart = function (event) {
    var newdata = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var startPoint = {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
    newdata['eles[' + compindex + '].startPoint'] = startPoint;
    pageInstance.setData(newdata);
  };

  this.verticalListTouchmove = function (event) {
    var newdata = {};
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    if (compData['showSearch']) return;
    if (compData.customFeature.selected > 0) return;
    if (compData.customFeature.loadAllData == '1') return;
    if (!compData.shopInfo || !pageInstance[compindex] || pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    var animation = _app.appMethod.createAnimation({
      duration: 400,
      timingFunction: 'linear'
    });
    if (compData.startPoint.y - event.touches[0].pageY > 40 && compData.heightFlag && compData['infoHeight'] === 0) {
      _app.appMethod.getBoundingClientRect('.shopInfoHeight', function (rects) {
        compData.heightFlag = false;
        pageInstance[compindex]['shopInfoHeight'] = rects[0] != undefined ? rects[0].height : 0;
        animation.translateY(-pageInstance[compindex]['shopInfoHeight']).height(0).step();
        newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
        newdata['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
        pageInstance.setData(newdata);
      });
    }
    if (event.touches[0].pageY - compData.startPoint.y > 40 && compData.heightFlag && compData['infoHeight'] !== 0) {
      compData.heightFlag = false;
      animation.translateY(0).height(pageInstance[compindex]['shopInfoHeight']).step();
      newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = 0;
      pageInstance.setData(newdata);
    }
  };

  this.stopAnimation = function (event) {};

  this.verticalListShowGoodsSearch = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var data = {};
    data['eles[' + compindex + '].showSearch'] = true;
    if (!compData.shopInfo || !pageInstance[compindex] || pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    if (compData['show_goods_data'] && compData['show_goods_data']['searchResult']) {
      data['eles[' + compindex + '].show_goods_data.searchResult'] = [];
    }
    // TODO
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.translateY(-pageInstance[compindex]['shopInfoHeight']).height(0).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
    pageInstance.setData(data);
  };

  this.verticalListHideGoodsSearch = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var data = {};
    data['eles[' + compindex + '].showSearch'] = false;
    // TODO
    // let animation = app.createAnimation({
    //   duration: 300,
    //   timingFunction: 'linear'
    // })
    // animation.translateY(0).height(pageInstance[compindex]['shopInfoHeight']).step();
    // data['eles[' + compindex + '].shopInfoHeight'] = animation.export();
    data['eles[' + compindex + '].infoHeight'] = 0;
    pageInstance.data.eles[compindex].heightFlag = true;
    pageInstance.setData(data);
  };

  this.verticalListBindSearchTitle = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].searchTitle'] = event.target.value;
    pageInstance.setData(newdata);
  };

  this.verticalListSearchByTitle = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var pagination = {};
    if (compData.pagination['searchResult']) {
      pagination = compData.pagination['searchResult'];
    } else {
      pagination = compData.pagination['category' + compData.content[0].source];
    }
    var param = JSON.parse(JSON.stringify(pagination.param));
    var category_arr = [];
    var hasAll = false;
    for (var i = 0; i < compData.content.length; i++) {
      if (compData.content[i].source == 'all') {
        hasAll = true;
        break;
      } else {
        category_arr.push(compData.content[i].source);
      }
    }
    hasAll ? '' : param['category_arr'] = category_arr;
    param.idx_arr['idx'] = 'title';
    param.idx_arr['idx_value'] = compData.searchTitle;
    param.page = 1;
    newdata['eles[' + compindex + '].pagination.searchResult.param'] = param;
    newdata['eles[' + compindex + '].pagination.searchResult.requesting'] = false;
    pageInstance.setData(newdata);
    _this4._getVerticalListListByTitle(param, pageInstance, compindex, 1);
  };

  this.verticalListClickCategory = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var index = dataset.index;
    var id = dataset.id;
    var newdata = {};
    var param = JSON.parse(dataset.param);
    var compData = pageInstance.data.eles[compindex];
    var cateIndex = dataset.cateindex;
    if (compData['loading'] || pageInstance[compindex] && pageInstance[compindex]['shopInfoHeight'] == undefined) {
      return;
    }
    if (!(compData.show_goods_data && compData.show_goods_data['category' + id])) {
      newdata['eles[' + compindex + '].loading'] = true;
      _this4._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
    }
    newdata['eles[' + compindex + '].scrollTopLoading'] = false;
    newdata['eles[' + compindex + '].scrollTop'] = '2rpx';
    newdata['eles[' + compindex + '].customFeature.selected'] = index;
    newdata['eles[' + compindex + '].loadingFail'] = false;

    if (index > 0) {
      // let animation = app.createAnimation({
      //   duration: 400,
      //   timingFunction: 'linear'
      // })
      // animation.height(0).step();
      // newdata['eles[' + compindex + '].shopInfoHeight'] = animation.export();
      newdata['eles[' + compindex + '].infoHeight'] = pageInstance[compindex]['shopInfoHeight'];
    }
    pageInstance.setData(newdata);
    compData['isChangeTab'] = true;
  };

  this.verticalListStyleScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var newdata = {};
    var pagination = compData.pagination['category' + categoryId];
    var param = pagination.param;
    var that = _this4;
    if ((pagination.requesting || pagination.is_more === 0 || compData['loading']) && !compData.loadingFail) {
      if (pagination.requesting) {
        return;
      }
      if (compData.customFeature.selected < compData.content.length - 1) {
        compData['scrollTo'] = 'bottom';
      }
      return;
    }
    newdata['eles[' + compindex + '].pagination.category' + categoryId + '.requesting'] = true;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    that._getTakeoutStyleGoodsList(param, pageInstance, compindex, 0);
  };

  this.verticalListStyleScrollTop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = compData.content[compData.customFeature.selected].source;
    var pagination = compData.pagination['category' + categoryId];
    var that = _this4;
    if (pagination.requesting) {
      return;
    }
    if (compData.customFeature.selected > 0) {
      compData['scrollTo'] = 'top';
    }
  };

  this.addModelNum = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var goodsid = dataset.id || dataset.goodsid;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var thisGoodsInfo = compData.goods_data_list[goodsid];
    var newdata = {};
    var addNum = 1;
    if (!compData['hasAddNum'] && !compData['modelNum']) {
      addNum = thisGoodsInfo.min_sales_nums || 1;
    }
    if ((+compData['hasAddNum'] || 0) + (+compData["modelNum"] || 0) + addNum > thisGoodsInfo.stock) {
      _app.appMethod.showModal({
        content: '商品库存不足'
      });
      return;
    }
    newdata['eles[' + compindex + '].hasAddNum'] = (+compData.hasAddNum || 0) + addNum;
    pageInstance.setData(newdata);
  };

  this.minusModelNum = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var goodsid = dataset.id || dataset.goodsid;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var thisGoodsInfo = compData.goods_data_list[goodsid];
    var newdata = {};
    var minusNum = -1;
    if ((+compData['hasAddNum'] || 1) + minusNum < (thisGoodsInfo.min_sales_nums || 1)) {
      return;
    }
    newdata['eles[' + compindex + '].hasAddNum'] = (+compData.hasAddNum || 0) + minusNum;
    pageInstance.setData(newdata);
  };

  this.showVerticalListGoodsDetail = function (event) {
    var that = _this4;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var model = dataset.model;
    var attributes = dataset.attributes;
    var id = dataset.id || dataset.goodsid;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var category = dataset.category;
    var is_search = dataset.is_search || '';
    var compData = pageInstance.data.eles[compindex];
    var showGoodsData = void 0;
    if (is_search == 'search') {
      showGoodsData = compData.show_goods_data['searchResult'][index];
    } else {
      showGoodsData = compData.show_goods_data['category' + category][index];
    }
    var businessTime = showGoodsData.business_time ? showGoodsData.business_time.business_time : '';
    if (businessTime) {
      var business_time = '';
      for (var key in businessTime) {
        business_time += businessTime[key].start_time.slice(0, 2) + ':' + businessTime[key].start_time.slice(2, 4) + '-' + businessTime[key].end_time.slice(0, 2) + ':' + businessTime[key].end_time.slice(2, 4) + ' ';
      }
      showGoodsData.businessTime = business_time;
    }
    showGoodsData.des = _app.appMethod.getWxParseResult(showGoodsData.description);
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        var newdata = {};
        // 默认选中规格
        var modelData = compData.goods_data_list[id]['model'].modelData;
        var modelChoose = [],
            modelIdArr = [],
            modelLength = 0;
        modelData && modelData.map(function (item) {
          if (item.subModelName && item.subModelName.length) {
            modelChoose.push(item.subModelName[0]);
          }
          if (item.subModelId && item.subModelId.length) {
            modelIdArr.push(item.subModelId[0]);
          }
        });
        modelLength = modelIdArr.length;
        newdata['eles[' + compindex + '].modelChoose'] = modelChoose || [];
        newdata['eles[' + compindex + '].modelIdArr'] = modelIdArr;
        newdata['eles[' + compindex + '].modelLength'] = modelLength;

        if (modelLength) {
          that._ModelPirce({ goodsid: id, compindex: compindex }, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
        }

        if (!!+model || attributes) {
          newdata['eles[' + compindex + '].hideSearchInput'] = true;
          if (model) {
            var goods_model = pageInstance[compindex].goods_model_list[id].goods_model;
            for (var i in goods_model) {
              if (goods_model[i].model.split(',').sort().join(',') == modelIdArr.sort().join(',')) {
                newdata['eles[' + compindex + '].hasAddNum'] = goods_model[i].min_sales_nums || 1; // 初始化弹窗里的商品数量 最小起卖数
              }
            }
            newdata['eles[' + compindex + '].goodsDetailShow'] = true;
            newdata['eles[' + compindex + '].showGoodDetailMask'] = true;
          } else {
            newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[id].price)).toFixed(2);
            newdata['eles[' + compindex + '].modelNum'] = compData.goods_data_list[id] && compData.goods_data_list[id].num || 0;
            newdata['eles[' + compindex + '].hasAddNum'] = compData.goods_data_list[id] && compData.goods_data_list[id].min_sales_nums || 1; // 初始化弹窗里的商品数量 最小起卖数
            newdata['eles[' + compindex + '].goodsAttrShow'] = true;
          }
          pageInstance.setData(newdata);
        }
        newdata['eles[' + compindex + '].modelVipPrice'] = compData.goods_data_list[id].calculationPrice;
        newdata['eles[' + compindex + '].goodsDetail'] = showGoodsData;
        newdata['eles[' + compindex + '].goodsDetail']['goodsData'] = compData.goods_data_list[id];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess'] = res;
        newdata['eles[' + compindex + '].modelGoodsId'] = id;
        pageInstance.setData(newdata);
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/GoodsView',
          data: {
            goods_id: id
          },
          success: function success() {}
        });
      }
    });
  };

  this.verticalListListMinus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.target.dataset;
    var goodsid = dataset.goodsid;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var totalNum = +compData.TotalNum;
    var totalPrice = +compData.TotalPrice;
    var newdata = {};
    var model = dataset.model;
    var isInBusiness = dataset.isInBusiness;
    var isPackage = dataset.package;
    var isAttributes = dataset.attributes && dataset.attributes.length > 0;
    if (isInBusiness == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }
    if (!!+model) {
      _app.appMethod.showModal({
        content: '多规格商品只能去购物车操作'
      });
      return;
    }
    if (!!+isPackage) {
      _app.appMethod.showModal({
        content: '套餐商品只能去购物车操作'
      });
      return;
    }
    if (isAttributes) {
      _app.appMethod.showModal({
        content: '属性商品只能去购物车操作'
      });
      return;
    }
    // if (compData.cartList[0][goodsid][0].attrObj['0'].num == 0) {
    //   return;
    // }
    var minusNum = 1; //最小起卖数
    if (compData.goods_data_list[goodsid].totalNum <= compData.goods_data_list[goodsid].min_sales_nums) {
      minusNum = compData.goods_data_list[goodsid].totalNum;
    }
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = totalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice - Number(newdata['eles[' + compindex + '].goods_data_list.' + goodsid].calculationPrice) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj[0].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = Number(newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj[0].num * newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].calculationPrice).toFixed(2);
    pageInstance.setData(newdata, function () {
      that.takeoutTimeout = setTimeout(function () {
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
      }, 300);
    });
  };

  this.verticalListListPlus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.target.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = dataset.goodsid || compData.modelGoodsId;
    var that = _this4;
    if (compData.flag) {
      return;
    }
    compData.addCartComplete = false;
    var model = dataset.model;
    var attributes = dataset.attributes;
    var goodsInfo = compData.goods_data_list[goodsid];
    var totalNum = compData.TotalNum;
    var totalPrice = +compData.TotalPrice;
    var is_in_business = dataset.isInBusiness;
    var newdata = {};
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].attrPrice'] = 0;
    newdata['eles[' + compindex + '].attrData'] = null;
    compData.cartAttrId = '0';
    var userCart = compData.cartList[0];
    var myCartNum = 0;
    for (var k in userCart) {
      for (var j in userCart[k]) {
        for (var o in userCart[k][j].attrObj) {
          myCartNum += userCart[k][j].attrObj[o].num;
        }
      }
    }
    if (is_in_business == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }

    if (!!+model || attributes) {
      newdata['eles[' + compindex + '].hideSearchInput'] = true;
      newdata['eles[' + compindex + '].modelGoodsId'] = goodsid;
      if (model) {
        newdata['eles[' + compindex + '].modelIdArr'] = [];
        newdata['eles[' + compindex + '].goodsModelShow'] = true; //选规格弹窗
        // for (let index = 0; index < compData.goods_data_list[goodsid]['model'].modelData.length; index++) {
        //   newdata['eles[' + compindex + '].modelIdArr'].push(0)
        // }
      } else {
        newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[goodsid].price)).toFixed(2);
        newdata['eles[' + compindex + '].modelNum'] = 0;
        newdata['eles[' + compindex + '].goodsAttrShow'] = true;
      }
      pageInstance.setData(newdata);
    } else {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
      newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
      var newNum = compData.goods_data_list[goodsid].min_sales_nums || 1;
      var addNum = 1; //最小起卖数
      if (compData.goods_data_list[goodsid].totalNum == 0) {
        addNum = compData.goods_data_list[goodsid].min_sales_nums || 1;
      }
      if (addNum > compData.goods_data_list[goodsid].stock) {
        _app.appMethod.showModal({
          content: '库存不足'
        });
        return;
      }
      newdata['eles[' + compindex + '].TotalNum'] = +totalNum + addNum;
      newdata['eles[' + compindex + '].TotalPrice'] = (+totalPrice + +goodsInfo.calculationPrice * addNum).toFixed(2);
      newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum += addNum;
      var attrIdArr = [];
      var attrObj = {};
      var attrNum = 0;
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        attrNum = newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj['0'].num + addNum;
      } else {
        attrNum = addNum;
      }
      attrObj['0'] = {
        num: attrNum,
        price: Number(+goodsInfo.calculationPrice),
        totalPrice: (attrNum * Number(+goodsInfo.calculationPrice)).toFixed(2),
        attrIdArr: attrIdArr
      };
      var attrArr = ['0'];
      if (newdata['eles[' + compindex + '].cartList[0].' + goodsid][0]) {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].totalPrice = (+newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].num * goodsInfo.calculationPrice).toFixed(2);
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrObj = attrObj;
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0].attrArr = attrArr;
      } else {
        newdata['eles[' + compindex + '].cartList[0].' + goodsid][0] = {
          list: 'list',
          id: goodsid,
          modelId: 0,
          gooodsName: goodsInfo.name,
          totalPrice: (newNum * goodsInfo.calculationPrice).toFixed(2),
          stock: goodsInfo.stock,
          cart_id: 0,
          in_business_time: compData.goods_data_list[goodsid].in_business_time,
          pick_up_type: goodsInfo.pick_up_type,
          is_vip_goods: goodsInfo.is_vip_goods || 0,
          attrObj: attrObj,
          attrArr: attrArr
        };
      }
      if (compData.cartGoodsIdList.indexOf(+goodsid) == -1) {
        newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
        newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
      }
      myCartNum += 1;
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      clearInterval(compData.timer);
      compData.loopRequest = false;
      pageInstance.setData(newdata, function () {
        that.takeoutTimeout = setTimeout(function () {
          var options = {
            goods_type: 0,
            cartListData: compData.cartList,
            thisPage: pageInstance,
            compindex: compindex
          };
          that._addTakeoutCart(options, that.eachCartList(options), null, goodsid);
          that.drinkAddCartAnimation(pageInstance, compindex);
        }, 300);
      });
    }
  };

  this.verticalListSearchScrollFunc = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var pagination = compData.pagination['searchResult'];
    var param = pagination.param;
    if ((pagination.requesting || pagination.is_more === 0) && !compData.loadingFail) {
      return;
    }
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    _this4._getVerticalListListByTitle(param, pageInstance, compindex, 0);
  };

  this._getVerticalListListByTitle = function (param, pageInstance, compindex, isOnShow) {
    var _this = _this4;
    pageInstance.requesting = true;
    var newdata = {};
    newdata['eles[' + compindex + "].searchLoading"] = true;
    pageInstance.setData(newdata);
    param.form = 'goods';
    param.only_display_common = 0;
    if (pageInstance.data.eles[compindex].customFeature.showSetMeal) {
      param.show_package_goods = 2;
    }
    param.pick_up_type = [pageInstance.data.eles[compindex].pick_up_select];
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      success: function success(res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          newdata['eles[' + compindex + "].searchLoading"] = false;
          var compData = pageInstance.data.eles[compindex],
              isRequireing = {},
              categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          isRequireing['eles[' + compindex + '].pagination.searchResult'].requesting = false;
          pageInstance.setData(isRequireing);
          if (!compData.show_goods_data || compData.show_goods_data && !compData.show_goods_data['searchResult'] || isOnShow == 1) {
            categoryList['searchResult'] = [];
          } else {
            categoryList['searchResult'] = compData.show_goods_data['searchResult'];
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list;
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {};
          }
          if (!pageInstance[compindex]['goods_model_list']) {
            pageInstance[compindex]['goods_model_list'] = {};
          }
          for (var i in res.data) {
            var form_data = res.data[i].form_data;
            var goods = _this.returnCateGoods(form_data, compData);
            categoryList['searchResult'].push(goods);
            var goodsDataList = _this.returnGoodsDataList(form_data, compData);
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = goodsDataList;
            if (form_data.goods_model) {
              var new_goods_model = {};
              for (var _i in form_data.goods_model) {
                new_goods_model[form_data.goods_model[_i].id] = {
                  model: form_data.goods_model[_i].model,
                  stock: form_data.goods_model[_i].stock,
                  price: form_data.goods_model[_i].price,
                  goods_id: form_data.goods_model[_i].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[_i].vip_price && form_data.goods_model[_i].vip_price !== 0 ? Number(form_data.goods_model[_i].vip_price).toFixed(2) : null,
                  calculationPrice: form_data.goods_model[_i].vip_price && form_data.goods_model[_i].vip_price !== 0 ? Number(form_data.goods_model[_i].vip_price).toFixed(2) : form_data.goods_model[_i].price,
                  is_vip_goods: form_data.is_vip_goods || 0,
                  min_sales_nums: +form_data.goods_model[_i].min_sales_nums || 0
                };
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              };
              pageInstance[compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              };
              for (var k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                });
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                calculationPrice: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : form_data.price,
                is_vip_goods: form_data.is_vip_goods && form_data.vip_goods_price != form_data.price || 0
              };
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.searchResult'] = categoryList['searchResult'];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.searchResult'] = compData.pagination['searchResult'];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.searchResult'].param = param;
          newdata['eles[' + compindex + '].pagination.searchResult'].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.searchResult'].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelLength'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            _this.getMultiOrderingVerticalCart(compindex, pageInstance);
          } else {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        }
      },
      fail: function fail() {
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + "].searchLoading"] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  };

  this.verticalListShowShoppingCartPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var isShowShoppingCart = dataset.isshow;
    var newdata = {};
    if (isShowShoppingCart) {
      newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    } else {
      newdata['eles[' + compindex + '].shoppingCartShow'] = true;
    }
    pageInstance.setData(newdata);
  };

  this.verticalListChooseComplete = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.target.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    if (!compData.TotalNum) {
      return;
    }
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      that._addTakeoutCart(options, that.eachCartList(options), function (idArr) {
        var franchiseeId = _app.appMethod.getPageFranchiseeId();
        var franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
        pageInstance.returnToVerticalFlag = 1;
        _app.appMethod.turnToPage('/orderMeal/pages/previewOrderDetail/previewOrderDetail?cart_arr=' + idArr + franchiseeParam);
      });
    }, 300);
  };

  this.verticalListChangeAssessType = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var assessActive = event.currentTarget.dataset.active;
    var showAssess = [];
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    newdata['eles[' + compindex + '].assessActive'] = assessActive;
    for (var i = 0; i < compData.assessList.length; i++) {
      var alist = compData.assessList[i];
      if (assessActive == 0) {
        alist.assess_info.has_img == 1 ? showAssess.push(alist) : null;
      } else if (alist.assess_info.level == assessActive) {
        showAssess.push(alist);
      }
    }
    newdata['eles[' + compindex + '].showAssess'] = showAssess;
    pageInstance.setData(newdata);
  };

  this.verticalListGetMoreAssess = function (event) {
    var dataset = event.currentTarget.dataset;
    var page = dataset.nextpage;
    var compindex = dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        "idx_arr[0][idx]": 'goods_type',
        "idx_arr[0][idx_value]": 0,
        page: page,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var alist = compData.assessList;
        for (var i in res.data) {
          alist.push(res.data[i]);
        }
        newdata['eles[' + compindex + '].assessList'] = alist;
        var commentNums = [],
            showAssess = [],
            hasImgAssessList = 0,
            goodAssess = 0,
            normalAssess = 0,
            badAssess = 0;
        for (var _i2 = 0; _i2 < alist.length; _i2++) {
          var listItem = alist[_i2];
          listItem.assess_info.has_img == 1 ? hasImgAssessList++ : null;
          listItem.assess_info.level == 3 ? goodAssess++ : listItem.assess_info.level == 1 ? badAssess++ : normalAssess++;
          if (listItem.assess_info.has_img == 1 && compData.assessActive == 0) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 3 && compData.assessActive == 3) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 1 && compData.assessActive == 1) {
            showAssess.push(listItem);
          } else if (listItem.assess_info.level == 2 && compData.assessActive == 2) {
            showAssess.push(listItem);
          }
        }
        commentNums = [hasImgAssessList, goodAssess, normalAssess, badAssess];
        newdata['eles[' + compindex + '].commentNums'] = commentNums;
        newdata['eles[' + compindex + '].assessCurrentPage'] = page;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        pageInstance.setData(newdata);
      }
    });
  };

  this.openVerticalListLocation = function (event) {
    var dataset = event.currentTarget.dataset;
    _app.appMethod.openLocation({
      latitude: +dataset.lat,
      longitude: +dataset.lng,
      name: dataset.name,
      address: dataset.address
    });
  };

  this.verticalListHideDetailPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].goodsDetailShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].showGoodDetailMask'] = false;
    // 清空规格信息
    newdata['eles[' + compindex + '].goodsAttrShow'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelLength'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + '].attrData'] = {}; // 清空属性
    newdata['eles[' + compindex + '].attrName'] = ''; // 清空属性
    newdata['eles[' + compindex + "].modelNum"] = 0;
    newdata['eles[' + compindex + "].attrPrice"] = 0;
    newdata['eles[' + compindex + "].addCartComplete"] = true;
    pageInstance.setData(newdata);
  };

  this.verticalListGetMoreGoodsAssess = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var sub_shop_app_id = _app.appMethod.getPageFranchiseeId();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getAssessList',
      method: 'post',
      data: {
        goods_id: compData.goodsDetail.id,
        "idx_arr[0][idx]": 'level',
        "idx_arr[0][idx_value]": 0,
        page: compData.goodsDetail.goodsAssess.current_page + 1,
        page_size: 20,
        sub_shop_app_id: sub_shop_app_id || ''
      },
      success: function success(res) {
        newdata['eles[' + compindex + '].goodsDetail'] = compData['goodsDetail'];
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['data'] = compData['goodsDetail']['goodsAssess']['data'].concat(res.data);
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['is_more'] = res.is_more;
        newdata['eles[' + compindex + '].goodsDetail']['goodsAssess']['current_page'] = res.current_page;
        pageInstance.setData(newdata);
      }
    });
  };

  this.verticalListHideModelPop = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].goodsModelShow'] = false;
    newdata['eles[' + compindex + '].goodsAttrShow'] = false;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].modelPrice'] = 0;
    newdata['eles[' + compindex + "].attrPrice"] = 0;
    newdata['eles[' + compindex + '].attrData'] = {}; // 清空属性
    newdata['eles[' + compindex + '].attrName'] = ''; // 清空属性
    newdata['eles[' + compindex + '].modelChoose'] = [];
    newdata['eles[' + compindex + '].modelLength'] = [];
    newdata['eles[' + compindex + '].modelIdArr'] = [];
    newdata['eles[' + compindex + "].modelNum"] = 0;
    newdata['eles[' + compindex + "].addCartComplete"] = true;
    pageInstance.setData(newdata);
  };

  this.verticalListChooseModel = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var pIndex = dataset.parentindex;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var compData = pageInstance.data.eles[compindex];
    var modelData = compData.goods_data_list[goodsid]['model'].modelData;
    var newdata = {};
    newdata['eles[' + compindex + '].modelChoose'] = compData.modelChoose || [];
    newdata['eles[' + compindex + '].modelIdArr'] = compData.modelIdArr;
    newdata['eles[' + compindex + '].modelChoose'][pIndex] = modelData[pIndex].subModelName[index];
    newdata['eles[' + compindex + '].modelIdArr'][pIndex] = modelData[pIndex].subModelId[index];
    var model = compData.modelChoose.filter(function (s) {
      return s && s.trim();
    });
    newdata['eles[' + compindex + '].modelLength'] = model.length;
    pageInstance.setData(newdata);
    _this4._ModelPirce(dataset, [].concat(newdata['eles[' + compindex + '].modelIdArr']));
  };

  this._ModelPirce = function (dataset, modelNameArr) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var goods_model = pageInstance[compindex].goods_model_list[dataset.goodsid].goods_model;
    var compData = pageInstance.data.eles[compindex];
    var attrPrice = 0;
    var attrName = '';
    var tempArr = [];
    if (compData.attrData) {
      for (var i in compData.attrData) {
        if (compData.attrData[i]) {
          attrPrice += Number(compData.attrData[i].price);
          tempArr.push(compData.attrData[i].name);
        }
      }
    }
    attrName = tempArr.join(',');
    newdata['eles[' + compindex + '].attrPrice'] = attrPrice;
    newdata['eles[' + compindex + '].attrName'] = attrName;
    for (var _i3 in goods_model) {
      if (goods_model[_i3].model.split(',').sort().join(',') == modelNameArr.sort().join(',')) {
        newdata['eles[' + compindex + '].modelChooseId'] = _i3;
        // 拿多规格的 最小起卖数
        newdata['eles[' + compindex + '].hasAddNum'] = goods_model[_i3].min_sales_nums || 1;
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.min_sales_nums'] = goods_model[_i3].min_sales_nums || 1;
        newdata['eles[' + compindex + '].modelVipPrice'] = Number(Number(compData.goods_data_list[goodsid].calculationPrice) + attrPrice).toFixed(2);
        if (goods_model[_i3].is_vip_goods && !compData.customFeature.is_together) {
          newdata['eles[' + compindex + '].modelPrice'] = Number(Number(goods_model[_i3].vip_price) + attrPrice).toFixed(2);
          goods_model[_i3].vip_price != goods_model[_i3].price ? newdata['eles[' + compindex + '].isModelPrice'] = true : newdata['eles[' + compindex + '].isModelPrice'] = false;
        } else {
          newdata['eles[' + compindex + '].modelPrice'] = Number(Number(goods_model[_i3].price) + attrPrice).toFixed(2);
          newdata['eles[' + compindex + '].isModelPrice'] = false;
        }
        if (compData.cartList[0][dataset.goodsid] && compData.cartList[0][dataset.goodsid][_i3] && compData.cartList[0][dataset.goodsid][_i3].attrObj) {
          var attrId = _this4.selectedAttrIdStr(compData);
          if (newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][_i3].attrObj[attrId]) {
            newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][dataset.goodsid][_i3].attrObj[attrId].num;
          } else {
            newdata['eles[' + compindex + '].modelNum'] = 0;
          }
        } else {
          newdata['eles[' + compindex + '].modelNum'] = 0;
        }
      }
    }
    pageInstance.setData(newdata);
  };

  this.verticalListSureChooseModel = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var price = +compData.modelPrice;
    var modelId = compData.modelChooseId;
    if (!pageInstance[compindex].goods_model_list[goodsid]) {
      _this4.drinkVerticalListListPlus(event); // 触发添加商品
      // this.verticalListHideDetailPop(event)   // 关闭详情弹窗
      return;
    }
    var thisModelInfo = pageInstance[compindex].goods_model_list[goodsid].goods_model[modelId];
    if (!compData.modelPrice) {
      _app.appMethod.showModal({
        content: '请选择规格'
      });
      return;
    }
    if (thisModelInfo.stock <= thisModelInfo.totalNum) {
      _app.appMethod.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    var attrIdArr = [];
    var attrNameArr = [];
    for (var i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
        attrNameArr.push({
          pName: compData.attrData[i].pName,
          name: compData.attrData[i].name,
          price: compData.attrData[i].price
        });
      }
    }
    var attrIdStr = attrIdArr.sort().join('_');
    var attrObj = {};
    var attrNum = 0;
    attrIdStr || (attrIdStr = '0');
    compData.cartAttrId = attrIdStr || '0';
    var addNum = compData.hasAddNum;
    // if (!(compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrObj && compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] && compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num > 0)) {
    //   addNum = thisModelInfo.min_sales_nums || 1;
    // }
    if (thisModelInfo.stock < addNum) {
      _app.appMethod.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    newdata['eles[' + compindex + '].mdelInfo'] = thisModelInfo;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    var goods_num = thisModelInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = compData.goods_data_list[goodsid].totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId] = thisModelInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].goods_model[modelId].totalNum += addNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price) * addNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + addNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrObj) {
      attrObj = compData.cartList[0][goodsid][modelId].attrObj;
      compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] = compData.cartList[0][goodsid][modelId].attrObj[attrIdStr] || {};
      attrNum = compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num ? compData.cartList[0][goodsid][modelId].attrObj[attrIdStr].num + addNum : addNum;
    } else {
      attrNum = addNum;
    }
    attrObj[attrIdStr] = {
      num: attrNum,
      price: Number(price),
      totalPrice: (attrNum * Number(price)).toFixed(2),
      attrIdArr: attrIdArr,
      attrNameArr: attrNameArr
    };
    var attrArr = [];
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][modelId] && compData.cartList[0][goodsid][modelId].attrArr) {
      attrArr = compData.cartList[0][goodsid][modelId].attrArr;
    }
    if (attrArr.indexOf(attrIdStr) == -1) {
      attrArr.push(attrIdStr);
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId] = {
      modelName: compData.modelChoose.join(' | '),
      modelId: modelId,
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisModelInfo.totalNum * price).toFixed(2),
      stock: thisModelInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type,
      attrObj: attrObj,
      attrArr: attrArr
    };
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods) {
      newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelId].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + 1;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = attrNum;
    }
    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
      // this.verticalListHideDetailPop(event)   // 关闭详情弹窗
      _this4.drinkAddCartAnimation(pageInstance, compindex);
    }, 0);

    _this4.verticalListHideDetailPop(event); // 关闭详情弹窗
  };

  this.verticalListMinuModel = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var price = +compData.modelPrice;
    var modelid = compData.modelChooseId;
    var attrIdArr = [];
    for (var i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
      }
    }
    var attrIdStr = attrIdArr.sort().join('_');
    attrIdStr || (attrIdStr = '0');
    var thisModelInfo = pageInstance[compindex].goods_model_list[goodsid];
    var minusNum = 1; //起卖数
    if (compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num <= thisModelInfo.goods_model[modelid].min_sales_nums) {
      minusNum = compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num;
    }
    if (thisModelInfo && thisModelInfo.goods_model) {
      thisModelInfo.goods_model[modelid].totalNum -= minusNum;
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = compData.modelNum - minusNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListHideShoppingCart = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].shoppingCartShow'] = false;
    pageInstance.setData(newdata);
  };

  this.verticalListDeleteAllCarts = function (event) {
    var compindex = event.currentTarget.dataset.compindex;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    cartIds = _this4.getCartIdArray(compindex, pageInstance);
    if (cartIds.length == 0) {
      _app.appMethod.showModal({
        content: '请先添加商品'
      });
      return;
    }
    _app.appMethod.showModal({
      content: '确认要清空购物车么？',
      showCancel: true,
      confirm: function confirm() {
        _this4._removeFromCart(cartIds, function () {
          _this4._removeFromCartCallback({
            compData: compData,
            compindex: compindex,
            thisPage: pageInstance
          });
        }, compindex);
      }
    });
  };

  this._removeFromCartCallback = function (options) {
    var n = {};
    var c = options.compindex;
    var goods_data_list = options.compData.goods_data_list;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var goods_model_list = pageInstance[c]['goods_model_list'];
    n['eles[' + c + '].cartList'] = [{}];
    n['eles[' + c + '].cart_data'] = [];
    for (var i in goods_data_list) {
      goods_data_list[i].totalNum = 0;
    }
    for (var _i4 in goods_model_list) {
      for (var j in goods_model_list[_i4].goods_model) {
        goods_model_list[_i4].goods_model[j].totalNum = 0;
      }
    }
    n['eles' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].cartGoodsIdList'] = [];
    n['eles[' + c + '].TotalNum'] = 0;
    n['eles[' + c + '].TotalPrice'] = 0;
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  };

  this.verticalListCartListMinus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var price = dataset.price;
    var modelid = dataset.modelid;
    var compData = pageInstance.data.eles[compindex];
    var index = dataset.index;
    var id = dataset.id;
    var attrId = dataset.attrid;
    compData.isAddCartGoods = true;
    compData.cartAttrId = attrId || '0';
    if (compData.cartList[index][goodsid][modelid].num == 0) {
      return;
    }
    var minusNum = 1; //起卖数
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    if (modelid != 0) {
      if (pageInstance[compindex]['goods_model_list'][goodsid] && pageInstance[compindex]['goods_model_list'][goodsid].goods_model) {
        pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum--;
        if (compData.cartList[index][goodsid][modelid].attrObj[attrId].num <= pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].min_sales_nums) {
          minusNum = compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
        }
      }
    } else {
      if (compData.goods_data_list[goodsid].min_sales_nums && compData.cartList[index][goodsid][modelid].attrObj[attrId].num <= compData.goods_data_list[goodsid].min_sales_nums) {
        minusNum = compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
      }
    }
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num -= minusNum;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].totalPrice = (Number(price) * Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num)).toFixed(2);
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    if (index === 0) {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
    if (compData.TotalNum == 0) {
      // 关闭购物车
      _this4.verticalListHideShoppingCart(event);
    }
  };

  this.verticalListCartListPlus = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var dataset = event.currentTarget.dataset;
    var goodsid = dataset.goodsid;
    var modelid = dataset.modelid;
    var is_in_business = dataset.isInBusiness;
    var num = dataset.num;
    var stock = dataset.stock;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var index = dataset.index;
    var attrId = dataset.attrid;
    compData.isAddCartGoods = true;
    compData.cartAttrId = attrId || '0';
    if (num == stock) {
      _app.appMethod.showModal({
        content: '该商品库存不足'
      });
      return;
    }
    if (is_in_business == 0) {
      _app.appMethod.showModal({
        content: '该商品不在出售时间'
      });
      return;
    }
    if (compData.goods_data_list[goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    }
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + 1;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(compData.cartList[index][goodsid][modelid].price)).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    if (+modelid) {
      if (compData.goods_data_list[goodsid]) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum;
      }
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num = ++compData.cartList[index][goodsid][modelid].attrObj[attrId].num;
      newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[attrId].num * compData.cartList[index][goodsid][modelid].attrObj[attrId].price).toFixed(2);
      if (pageInstance[compindex]['goods_model_list'][goodsid]) {
        pageInstance[compindex]['goods_model_list'][goodsid].goods_model[modelid].totalNum++;
      }
    } else {
      if (compData.goods_data_list[goodsid] && compData.goods_data_list[goodsid].totalNum) {
        newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = ++compData.goods_data_list[goodsid].totalNum;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].price).toFixed(2);
      } else {
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num++;
        newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].totalPrice = Number(newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].num * newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][0].attrObj[attrId].price).toFixed(2);
      }
    }
    clearInterval(compData.timer);
    compData.loopRequest = false;
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex,
        index: index || 0
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.verticalListHideCouponsList = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].shoppingCouponsList'] = false;
    pageInstance.setData(newdata);
  };

  this.tapVerticalListCoupon = function (event) {
    var coupon_id = event.currentTarget.dataset.id;
    var franchisee = _app.appMethod.getPageFranchiseeId();
    var chainParam = franchisee ? '&franchisee=' + franchisee : '';
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage('/pages/couponDetail/couponDetail?detail=' + coupon_id + chainParam);
  };

  this.deleteSingleCarts = function (e) {
    var dataset = e.currentTarget.dataset;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var modelid = dataset.modelid;
    var compData = pageInstance.data.eles[compindex];
    _this4._removeFromCart([compData.cartList[0][goodsid][modelid].cart_id], function () {
      var newdata = {};
      var num = compData.cartList[0][goodsid][modelid].num;
      var price = (compData.cartList[0][goodsid][modelid].price * num).toFixed(2);
      delete compData.cart_data[goodsid][modelid];
      delete compData.cartList[0][goodsid][modelid];
      if (util.isPlainObject(compData.cart_data[goodsid])) {
        delete compData.cart_data[goodsid];
        delete compData.cartList[0][goodsid];
      }
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid + '.totalNum'] = compData.goods_data_list[goodsid].totalNum - num;
      newdata['eles[' + compindex + '].cart_data'] = compData.cart_data;
      newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
      newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - num;
      newdata['eles[' + compindex + '].TotalPrice'] = (compData.TotalPrice - +price).toFixed(2);
      pageInstance.setData(newdata);
    }, compindex);
  };

  this._removeFromCart = function (cart_id, callback, compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var data = {
      cart_id_arr: cart_id
    };
    var newdata = {};
    compData.location_id ? data.location_id = compData.location_id : data = data;
    compData.loopRequest = false;
    clearInterval(compData.timer);
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/deleteCart',
      method: 'post',
      data: data,
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      hideLoading: true,
      success: function success(res) {
        callback && callback();
        newdata['eles[' + compindex + '].shoppingCartShow'] = false;
        pageInstance.setData(newdata);
      },
      fail: function fail(res) {
        _app.appMethod.showModal({
          content: '清空购物车失败'
        });
      },
      complete: function complete() {
        compData.loopRequest = true;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  };

  this._getTakeoutStyleGoodsList = function (param, pageInstance, compindex, isOnShow) {
    if (!param.is_integral) {
      param.is_integral = 5;
    }
    var _this = _this4;
    var categoryId = param.idx_arr.idx_value == '' ? 'all' : param.idx_arr.idx_value;
    if (pageInstance.data.eles[compindex].customFeature.showSetMeal) {
      param.show_package_goods = 2;
    }
    param.form = 'goods';
    param.only_display_common = 0;
    param.pick_up_type = [pageInstance.data.eles[compindex].pick_up_select];
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetGoodsList',
      data: param,
      method: 'post',
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        if (res.status == 0) {
          pageInstance.requesting = false;
          var compData = pageInstance.data.eles[compindex],
              newdata = {},
              isRequireing = {},
              categoryList = {};
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          isRequireing['eles[' + compindex + '].pagination.category' + categoryId].requesting = false;
          pageInstance.setData(isRequireing);
          if (compData.customFeature.loadAllData == '1') {
            var pxRatio = _app.appMethod.globalData.systemInfo.windowWidth ? 750 / _app.appMethod.globalData.systemInfo.windowWidth : 2;
            compData.requestNum++;
            compData.goodsCateHeight[categoryId] = {};
            if (compData.customFeature.listArrange == 1) {
              compData.goodsCateHeight[categoryId] = (Math.ceil(res.data.length / 2) * 474 + 38) / pxRatio;
            } else {
              compData.goodsCateHeight[categoryId] = (res.data.length * 226 + 38) / pxRatio;
            }
          }
          if (!compData.show_goods_data || compData.show_goods_data && !compData.show_goods_data['category' + categoryId] || isOnShow == 1) {
            categoryList['category' + categoryId] = [];
          } else {
            categoryList['category' + categoryId] = compData.show_goods_data['category' + categoryId];
          }
          if (compData.goods_data_list) {
            newdata['eles[' + compindex + '].goods_data_list'] = compData.goods_data_list;
          } else {
            newdata['eles[' + compindex + '].goods_data_list'] = {};
          }
          if (!pageInstance[compindex]['goods_model_list']) {
            pageInstance[compindex]['goods_model_list'] = {};
          }
          for (var i in res.data) {
            var form_data = res.data[i].form_data;
            var goods = _this.returnCateGoods(form_data, compData);
            categoryList['category' + categoryId].push(goods);
            var goodsDataList = _this.returnGoodsDataList(form_data, compData);
            newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + ''] = goodsDataList;
            if (form_data.goods_model) {
              var new_goods_model = {};
              for (var _i5 in form_data.goods_model) {
                new_goods_model[form_data.goods_model[_i5].id] = {
                  model: form_data.goods_model[_i5].model,
                  stock: form_data.goods_model[_i5].stock,
                  price: form_data.goods_model[_i5].price,
                  goods_id: form_data.goods_model[_i5].goods_id,
                  totalNum: 0,
                  vip_price: form_data.goods_model[_i5].vip_price && form_data.goods_model[_i5].vip_price !== 0 ? Number(form_data.goods_model[_i5].vip_price).toFixed(2) : null,
                  is_vip_goods: form_data.is_vip_goods || 0,
                  min_sales_nums: +form_data.goods_model[_i5].min_sales_nums || 0
                };
              }
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {
                modelData: [],
                name: form_data.title
              };
              pageInstance[compindex]['goods_model_list'][form_data.id] = {
                goods_model: new_goods_model
              };
              for (var k in form_data.model) {
                newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model']['modelData'].push({
                  name: form_data.model[k].name,
                  subModelName: form_data.model[k].subModelName,
                  subModelId: form_data.model[k].subModelId
                });
              }
            } else {
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'] = {};
              newdata['eles[' + compindex + '].goods_data_list']['' + form_data.id + '']['model'][0] = {
                price: form_data.price,
                num: 0,
                stock: form_data.stock,
                vip_price: form_data.vip_price && form_data.vip_price !== 0 ? Number(form_data.vip_price).toFixed(2) : null,
                is_vip_goods: form_data.is_vip_goods && form_data.vip_goods_price != form_data.price || 0
              };
            }
          }
          newdata['eles[' + compindex + '].show_goods_data.category' + categoryId] = categoryList['category' + categoryId];
          newdata['eles[' + compindex + '].in_business_time'] = res.in_business_time;
          newdata['eles[' + compindex + '].pagination.category' + categoryId] = compData.pagination['category' + categoryId];
          param.page = res.current_page + 1;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].param = param;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].is_more = res.is_more;
          newdata['eles[' + compindex + '].pagination.category' + categoryId].current_page = res.current_page;
          newdata['eles[' + compindex + '].modelChoose'] = [];
          newdata['eles[' + compindex + '].modelLength'] = [];
          newdata['eles[' + compindex + '].modelIdArr'] = [];
          newdata['eles[' + compindex + '].loading'] = false;
          newdata['eles[' + compindex + '].loadingFail'] = false;
          newdata['eles[' + compindex + '].loadFirstCate'] = false;
          pageInstance.setData(newdata);
          if (compData.customFeature.loadAllData == '1') {
            if (compData.requestNum == compData.content.length) {
              if (compData.customFeature.is_together) {
                compData.loopRequest = true;
                _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
                if (compData.location_id) {
                  _this.getDiningCart(pageInstance, compindex);
                }
              } else {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              };
            }
          } else {
            if (compData.customFeature.is_together) {
              compData.loopRequest = true;
              _this.getMultiOrderingVerticalCart(compindex, pageInstance, false);
              if (compData.location_id) {
                _this.getDiningCart(pageInstance, compindex);
              }
            } else {
              if (_app.appMethod.globalData.isLogin) {
                _this._getTakeoutStyleCartList(pageInstance, compindex);
              } else {
                _this._parseTakeoutCartListData({ data: [] }, pageInstance, compindex);
              }
            }
          }
        }
      },
      fail: function fail() {
        var newdata = {};
        newdata['eles[' + compindex + '].loadingFail'] = true;
        newdata['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(newdata);
      },
      complete: function complete() {
        setTimeout(function () {
          pageInstance.requesting = false;
        }, 300);
      }
    });
  };

  this._getTakeoutStyleCartList = function (pageInstance, compindex) {
    var _this = _this4;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/cartList',
      data: {
        page: -1,
        page_size: 1000,
        sub_shop_app_id: franchiseeId || '',
        parent_shop_app_id: franchiseeId ? _app.appMethod.getAppId() : '',
        not_get_takeout: 1,
        pick_up_type: pageInstance.data.eles[compindex].pick_up_select
      },
      success: function success(cartlist) {
        _this._parseTakeoutCartListData(cartlist, pageInstance, compindex);
      },
      fail: function fail(res) {
        _app.appMethod.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function confirm() {
            _this._getTakeoutStyleCartList(pageInstance, compindex);
          }
        });
      }
    });
  };

  this._parseTakeoutCartListData = function (cartlist, pageInstance, compindex) {
    var newdata = {},
        stockEmpty = false,
        compData = pageInstance.data.eles[compindex],
        totalNum = 0,
        totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    var goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    if (cartlist.data.length) {
      for (var i in cartlist.data) {
        var item = cartlist.data[i];
        if (goodsList[item.goods_id]) {
          goodsList[item.goods_id].totalNum = 0;
        }
      }
      newdata['eles[' + compindex + '].cartlistData'] = [];
      for (var _i6 in cartlist.data) {
        var _item = cartlist.data[_i6];
        newdata['eles[' + compindex + '].cartlistData'].push(_item);
        if (_item.goods_type == 0) {
          if (+_item.num > +_item.stock) {
            _item.num = _item.stock;
            stockEmpty = true;
          }
          newdata['eles[' + compindex + '].cart_data'][_item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][_item.goods_id] = {};
          newdata['eles[' + compindex + '].cart_data'][_item.goods_id][_item.model_id] = {
            cart_id: _item.id
          };
          if (compData.goods_data_list[_item.goods_id]) {
            newdata['eles[' + compindex + '].goods_data_list']['' + _item.goods_id].totalNum += +_item.num;
            if (pageInstance[compindex]['goods_model_list'][_item.goods_id + '']) {
              if (pageInstance[compindex]['goods_model_list'][_item.goods_id + ''].goods_model) {
                pageInstance[compindex]['goods_model_list'][_item.goods_id + ''].goods_model[_item.model_id].totalNum += +_item.num;
              } else {
                pageInstance[compindex]['goods_model_list'][_item.goods_id + ''][0].num += +_item.num;
              }
            }
          } else {
            newdata['eles[' + compindex + '].goods_data_list']['' + _item.goods_id] = _item;
          }
          if (!newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id]) {
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id] = {};
          }
          if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+_item.goods_id) == -1) {
            newdata['eles[' + compindex + '].cartGoodsIdList'].push(+_item.goods_id);
          }
          newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id] || (newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id] = {
            list: 'list',
            id: _item.goods_id,
            modelName: _item.model_value ? _item.model_value.join(' | ') : '',
            modelId: _item.model_id,
            num: +_item.num,
            price: +_item.price,
            gooodsName: _item.title,
            totalPrice: Number(_item.num * _item.price).toFixed(2),
            stock: _item.stock,
            cart_id: _item.id,
            in_business_time: compData.goods_data_list[_item.goods_id] && compData.goods_data_list[_item.goods_id].in_business_time,
            pick_up_type: _item.pick_up_type,
            is_vip_goods: _item.cart_vip_goods && _item.original_price != _item.price || 0,
            is_package_goods: _item.is_package_goods || 0
          });
          var packageArr = [];
          if (_item.is_package_goods) {
            for (var _i7 in _item.attributes) {
              packageArr.push(_item.attributes[_i7]);
            }
          }
          var attrIdArr = [];
          var arrtStr = '';
          var attrNameArr = [];
          if (_item.form_data && _item.form_data.attributes) {
            for (var _i8 = 0; _i8 < _item.form_data.attributes.length; _i8++) {
              attrIdArr.push(_item.form_data.attributes[_i8].id);
            }
            if (!_item.is_package_goods) {
              for (var j = 0; j < _item.attributes.length; j++) {
                if (_item.attributes) {
                  var elem = _item.attributes[j].elem;
                  for (var k = 0; k < elem.length; k++) {
                    attrNameArr.push({
                      pName: _item.attributes[j].name,
                      name: elem[k].name,
                      price: elem[k].price
                    });
                  }
                }
              }
            }
            arrtStr = attrIdArr.join('_');
            if (_item.is_package_goods) {
              arrtStr = _item.attributes_id;
              attrIdArr = [_item.attributes_id];
              attrNameArr = [];
            }
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj || (newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj = {});
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr ? newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr.push(arrtStr) : newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr = [].concat(arrtStr);
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj[arrtStr] = {
              num: +_item.num,
              price: +_item.price,
              totalPrice: Number(_item.num * _item.price).toFixed(2),
              cart_id: _item.id,
              attrIdArr: attrIdArr,
              attrNameArr: attrNameArr
            };
            if (_item.is_package_goods) {
              for (var a = 0; a < packageArr.length; a++) {
                var goods_id_list = [];
                for (var _k in packageArr[a].goods_list) {
                  goods_id_list.push(_k);
                }
                packageArr[a].goods_id_list = goods_id_list;
              }
              newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj[arrtStr].packageArr = packageArr;
            }
          } else {
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj || (newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj = {});
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr ? newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr.push('0') : newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrArr = [].concat('0');
            newdata['eles[' + compindex + '].cartList[0].' + _item.goods_id][_item.model_id].attrObj['0'] = {
              num: +_item.num,
              price: +_item.price,
              totalPrice: Number(_item.num * _item.price).toFixed(2),
              cart_id: _item.id,
              attrIdArr: attrIdArr,
              attrNameArr: attrNameArr
            };
          }
          totalNum += Number(_item.num);
          totalPrice += Number(_item.price) * _item.num;
        }
      }
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        _app.appMethod.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        });
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        _this4._addTakeoutCart(options, _this4.eachCartList(options));
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
  };

  this._addTakeoutCart = function (options, cart_info, callback, goodsid) {
    var that = _this4;
    var compindex = options.compindex;
    var compData = options.thisPage.data.eles[compindex];
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    var pageInstance = _app.appMethod.getAppCurrentPage();
    cart_info.map(function (item) {
      if (item.pick_up_type) {
        delete item.pick_up_type;
      }
      if (item.attrObj) {
        delete item.attrObj;
      }
      if (!item.form_data || item.form_data.attributes.length < 1) {
        delete item.form_data;
      }
    });
    var cartInfo = [];
    for (var i = 0; i < cart_info.length; i++) {
      if (goodsid == cart_info[i].goods_id) {
        cartInfo.push(cart_info[i]);
      }
    }
    var data = {
      cart_info: cartInfo,
      goods_type: options.goods_type,
      sub_app_id: franchiseeId || ''
    };
    if (compData['location_id'] && compData.customFeature.is_together) {
      data.location_id = compData['location_id'];
    }
    compData.loopRequest = false;
    compData.addCartComplete = false;
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/addVerticalCart',
      method: 'post',
      hideLoading: true,
      data: data,
      success: function success(res) {
        if (res.status === 0) {
          var _data = {};
          _data['eles[' + compindex + '].cart_data.' + goodsid] = res.data[goodsid] || {};
          var cartIdArr = [];
          var isNotEnouth = true;
          for (var k in cart_info) {
            var item = cart_info[k];
            var goods = res.data[item.goods_id];
            if (goods && goods[item.model_id] && goods[item.model_id].stock < item.num) {
              isNotEnouth = false;
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.num'] = +goods[item.model_id].stock;
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.num'] = +goods[item.model_id].stock;
              _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.totalPrice'] = (goods[item.model_id].stock * compData.cartList[0][item.goods_id][item.model_id].price).toFixed(2);
              if (!compData.isAddCartGoods) {
                _data['eles[' + compindex + '].cartList[0].' + item.goods_id + '.' + item.model_id + '.attrObj.' + compData.cartAttrId + '.cart_id'] = goods[item.model_id].cart_id;
              }
            }
            if (item.num > 0 && goods && goods[item.model_id]) {
              cartIdArr.push(goods[item.model_id].cart_id);
            }
          }
          that.changeStock(res.data, options, compData);
          callback && callback(cartIdArr);
          options.thisPage.setData(_data, function () {
            compData.addCartComplete = true;
          });
          if (!isNotEnouth) {
            _app.appMethod.showModal({
              content: '商品库存不足'
            });
            that.updateGoodsListNum(compindex, goodsid);
          }
        }
      },
      successStatusAbnormal: function successStatusAbnormal(res) {
        if (res.status === 1 && res.is_vip_limit === 1) {
          if (compData.customFeature.is_together) {
            compData.loopRequest = true;
            that.getMultiOrderingVerticalCart(compindex, pageInstance, true, 1);
          } else {
            that._getTakeoutStyleCartList(pageInstance, compindex);
          }
          if (goodsid) {
            var newdata = {};
            var goodsInfo = compData.goods_data_list[goodsid];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = goodsInfo;
            newdata['eles[' + compindex + '].cartList[0]'] = compData.cartList[0];
            newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = 0;
            for (var _i9 in compData.cartList[0]) {
              for (var j in compData.cartList[0][_i9]) {
                if (compData.cartList[0][_i9] && compData.cartList[0][_i9][j].id == goodsid) {
                  newdata['eles[' + compindex + '].modelPrice'] = 0;
                  newdata['eles[' + compindex + '].modelNum'] = 0;
                  newdata['eles[' + compindex + '].goodsModelShow'] = false;
                  newdata['eles[' + compindex + '].goodsAttrShow'] = false;
                  delete newdata['eles[' + compindex + '].cartList[0]'][goodsid];
                }
              }
            }
            that.getGoodsVipCondtionInfo(compindex, goodsid);
            newdata['eles[' + compindex + '].showVipDialog'] = true;
            pageInstance.setData(newdata);
            return false;
          }
        }
      },
      complete: function complete() {
        compData.loopRequest = true;
        compData.addCartComplete = true;
        compData.isAddCartGoods = false;
        if (compData.customFeature.is_together && compData['location_id']) {
          that.getDiningCart(pageInstance, compindex);
        }
      }
    });
  };

  this.changeStock = function (data, options, compData) {
    var newdata = {};
    var cartAttrId = compData.cartAttrId || '0';
    for (var i in data) {
      for (var j in data[i]) {
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].goods_data_list.' + i + '.stock'] = data[i][j].stock;
        newdata['eles[' + options.compindex + '].cartList[0].' + i + '.' + j + '.attrObj.' + cartAttrId + '.cart_id'] = data[i][j].cart_id;
      }
    }
    options.thisPage.setData(newdata);
  };

  this.updateGoodsListNum = function (compindex, goodsid) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var totalprice = 0;
    newdata['eles[' + compindex + '].TotalNum'] = 0;
    newdata['eles[' + compindex + '].TotalPrice'] = 0;
    for (var i in compData.cartList[0]) {
      var num = 0;
      var _price = 0;
      for (var j in compData.cartList[0][i]) {
        for (var k in compData.cartList[0][i][j].attrObj) {
          var obj = compData.cartList[0][i][j].attrObj[k];
          num += +obj.num;
          _price = (obj.num * obj.price).toFixed(2);
        }
      }
      newdata['eles[' + compindex + '].goods_data_list.' + i + '.totalNum'] = num;
      newdata['eles[' + compindex + '].TotalNum'] += num;
      totalprice = (+totalprice + +_price).toFixed(2);
      newdata['eles[' + compindex + '].TotalPrice'] = totalprice;
    }
    pageInstance.setData(newdata);
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.eachCartList = function (options, callback) {
    var cart_info = [];
    var cart_index = options.index || 0;
    for (var index in options.cartListData[cart_index]) {
      if (index != undefined) {
        for (var j in options.cartListData[cart_index][index]) {
          if (options.cartListData[cart_index][index][j].attrObj) {
            for (var k in options.cartListData[cart_index][index][j].attrObj) {
              var obj = {
                goods_id: index.replace('goods', ''),
                model_id: options.cartListData[cart_index][index][j].modelId,
                pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
              };
              obj.form_data = {
                attributes: []
              };
              if (options.cartListData[cart_index][index][j].attrObj[k]) {
                var attrIdArr = options.cartListData[cart_index][index][j].attrObj[k].attrIdArr;
                var packageArr = options.cartListData[cart_index][index][j].attrObj[k].packageArr;
                if (packageArr) {
                  for (var i = 0; i < attrIdArr.length; i++) {
                    if (attrIdArr[i] != 0) {
                      for (var _j = 0; _j < packageArr.length; _j++) {
                        for (var q in packageArr[_j].goods_list) {
                          var elem = [];
                          if (packageArr[_j].goods_list[q]._attributes) {
                            for (var e = 0; e < packageArr[_j].goods_list[q]._attributes.length; e++) {
                              for (var a = 0; a < packageArr[_j].goods_list[q]._attributes[e].length; a++) {
                                elem.push(packageArr[_j].goods_list[q]._attributes[e][a].id);
                              }
                            }
                          }
                          var y = {
                            id: packageArr[_j].goods_list[q].goods_id,
                            num: packageArr[_j].goods_list[q].selected_num,
                            model_id: packageArr[_j].goods_list[q].model_id
                          };
                          if (elem.length) {
                            y.elem = elem;
                          }
                          obj.form_data.attributes.push(y);
                        }
                      }
                    }
                  }
                } else {
                  for (var _i10 = 0; _i10 < attrIdArr.length; _i10++) {
                    if (attrIdArr[_i10] != 0) {
                      obj.form_data.attributes.push({
                        id: attrIdArr[_i10],
                        num: 1
                      });
                    }
                  }
                }
                obj.num = options.cartListData[cart_index][index][j].attrObj[k].num;
                options.cartListData[cart_index][index][j].attrObj[k].cart_id ? obj['id'] = options.cartListData[cart_index][index][j].attrObj[k].cart_id : '';
              }
              cart_info.push(obj);
            }
          } else {
            var _obj = {
              goods_id: index.replace('goods', ''),
              model_id: options.cartListData[cart_index][index][j].modelId,
              num: options.cartListData[cart_index][index][j].num,
              pick_up_type: options.cartListData[cart_index][index][j].pick_up_type
            };
            if (options.cartListData[cart_index][index][j].attrObj) {
              _obj.attrObj = options.cartListData[cart_index][index][j].attrObj;
            }
            options.cartListData[cart_index][index][j].cart_id ? _obj['id'] = options.cartListData[cart_index][index][j].cart_id : '';
            cart_info.push(_obj);
          }
        }
      }
    }
    return cart_info;
  };

  this._getAssessList = function (pageInstance, compindex) {
    var idx_value = 0;
    _app.appMethod.sendRequest({
      hideLoading: true, // 页面第一个请求才展示loading
      url: '/index.php?r=AppShop/getAssessList&idx_arr[0][idx]=goods_type&idx_arr[0][idx_value]=' + idx_value,
      data: {
        page: 1,
        page_size: 20,
        obj_name: 'app_id'
      },
      chain: true,
      subshop: pageInstance.franchiseeId || '',
      success: function success(res) {
        var newdata = {},
            showAssess = [],
            hasImgAssessList = 0,
            goodAssess = 0,
            normalAssess = 0,
            badAssess = 0;
        for (var i = 0; i < res.data.length; i++) {
          res.data[i].assess_info.has_img == 1 ? (hasImgAssessList++, showAssess.push(res.data[i])) : null;
          res.data[i].assess_info.level == 3 ? goodAssess++ : res.data[i].assess_info.level == 1 ? badAssess++ : normalAssess++;
        }
        for (var j = 0; j < res.num.length; j++) {
          res.num[j] = parseInt(res.num[j]);
        }
        newdata['eles[' + compindex + '].assessActive'] = 0;
        newdata['eles[' + compindex + '].assessList'] = res.data;
        newdata['eles[' + compindex + '].showAssess'] = showAssess;
        newdata['eles[' + compindex + '].assessNum'] = res.num;
        newdata['eles[' + compindex + '].moreAssess'] = res.is_more;
        newdata['eles[' + compindex + '].assessCurrentPage'] = res.current_page;
        pageInstance.setData(newdata);
      }
    });
  };

  this.vlSelectGoodsSameJourney = function (e, compIndex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = e ? e.currentTarget.dataset.compindex : compIndex;
    var selectSameJourney = pageInstance.data.eles.selectSameJourney;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
  };

  this.getCurrentLocation = function (compindex, pageInstance) {
    var newdata = {};
    _app.appMethod.getLocation({
      success: function success(res) {
        var latitude = res.latitude;
        var longitude = res.longitude;
        _app.appMethod.sendRequest({
          url: '/index.php?r=Map/getAreaInfoByLatAndLng',
          method: 'post',
          data: {
            latitude: latitude,
            longitude: longitude
          },
          success: function success(res) {
            newdata['eles[' + compindex + '].currentLocationData'] = res.data;
            pageInstance.setData(newdata);
          }
        });
      }
    });
  };

  this.getCartIdArray = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    for (var i = 0; i < compData.cartList.length; i++) {
      var userCart = compData.cartList[i];
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var l in userCart[k][j].attrObj) {
            if (userCart[k][j].attrObj[l].num > 0) {
              cartIds.push(userCart[k][j].attrObj[l].cart_id);
            }
          }
        }
      }
    }
    return cartIds;
  };

  this.getMyCartIdArray = function (compindex, pageInstance) {
    var compData = pageInstance.data.eles[compindex];
    var cartIds = [];
    var userCart = compData.cartList[0];
    for (var k in userCart) {
      for (var j in userCart[k]) {
        for (var l in userCart[k][j].attrObj) {
          if (userCart[k][j].attrObj[l].num > 0) {
            cartIds.push(userCart[k][j].attrObj[l].cart_id);
          }
        }
      }
    }
    return cartIds;
  };

  this.verticalListSettlement = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compindex = event.currentTarget.dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var franchiseeId = _app.appMethod.getPageFranchiseeId() || '';
    var cartIdArray = [];
    var that = _this4;
    _this4.saveFormId(event.target.formId);
    if (!compData.addCartComplete) {
      return;
    }
    if (compData.config_data.set_deliver_area_type == 1 && compData.pick_up_select == 2 && +compData.config_data.deliver_rule_data.base_min_deliver_price > +compData.TotalPrice) {
      // 最低配送价
      return;
    }
    if (compData.config_data.set_deliver_area_type != 1 && compData.pick_up_select == 2 && +compData.config_data.min_deliver_price > +compData.TotalPrice) {
      // 最低配送价
      return;
    }

    cartIdArray = _this4.getCartIdArray(compindex, pageInstance);
    if (!cartIdArray.length) {
      _app.appMethod.showModal({
        content: '请选择结算的商品'
      });
      return;
    }
    // 结算 选配送方式

    var currentLocationData = compData.currentLocationData;
    var selectSameJourney = compData.selectSameJourney;
    var data = {
      cart_id_arr: cartIdArray,
      filter_pick_up_type: compData.pick_up_type
    };
    if (!(compData.pick_up_type.length == 1 && compData.pick_up_type[0] == 4)) {
      if (compData.pick_up_select == 2) {
        if (!selectSameJourney && !currentLocationData) {
          _app.appMethod.turnToPage('/eCommerce/pages/goodsSameJourney/goodsSameJourney?sameJourneyId=' + (selectSameJourney ? selectSameJourney.id : '') + '&franchiseeId=' + franchiseeId + '&compindex=' + compindex + '&from=' + 'preview');
          return;
        }
        var lat = selectSameJourney ? selectSameJourney.latitude : currentLocationData.location.lat;
        var lng = selectSameJourney ? selectSameJourney.longitude : currentLocationData.location.lng;
        var regionId = selectSameJourney ? selectSameJourney.address_info.district.id : currentLocationData.region_id;
        data['latitude'] = lat;
        data['longitude'] = lng;
        data['region_id'] = regionId;
      }
    }
    var addressId = compData.selectSameJourneyId;
    var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    pagePath += '&type=' + compData.pick_up_select;
    pagePath += '&is_from=drink_vertical_list'; // 不让切换配送类型
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage(pagePath);
  };

  this.goodsPay = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var franchiseeId = _app.appMethod.getPageFranchiseeId(),
        cartIdArray = [],
        type = e.currentTarget.dataset.type,
        cartId = e.currentTarget.dataset.cartId,
        addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    cartIdArray = cartId;
    var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    compData.location_id && (pagePath += '&ec_location_id=' + compData.location_id);
    compData.customFeature.is_together ? pagePath += '&is_together=true' : pagePath += '&is_together=false';
    pagePath += '&type=' + type;
    pageInstance.returnToVerticalFlag = 1;
    _app.appMethod.turnToPage(pagePath);
  };

  this.verticalListCloseVipDialog = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var newdata = {};
    newdata['eles[' + compindex + '].showVipDialog'] = false;
    pageInstance.setData(newdata);
  };

  this.getGoodsVipCondtionInfo = function (compindex, goodsId) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/getGoodsVipCondtionInfo',
      method: 'post',
      hideLoading: false,
      data: {
        goods_id: goodsId
      },
      success: function success(res) {
        if (res.status == 0) {
          newdata['eles[' + compindex + '].vipCondtionInfo'] = res.data;
          pageInstance.setData(newdata);
        }
      }
    });
  };

  this.getMultiOrderingVerticalCart = function (compindex, pageInstance, hideLoading, isFirst) {
    var that = _this4;
    var compData = pageInstance.data.eles[compindex];
    var data = {
      get_user_list: 1,
      page: -1,
      page_size: 1000,
      sub_shop_app_id: _app.appMethod.getPageFranchiseeId() || ''
    };
    if (compData['location_id']) {
      data.location_id = compData['location_id'];
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppEcommerce/getMultiOrderingVerticalCart',
      method: 'get',
      data: data,
      hideLoading: hideLoading === false ? false : true,
      success: function success(res) {
        compData.flag = false;
        if (!compData.loopRequest) {
          return;
        }
        compData.loopRequest = false;
        if (res.status == 0) {
          if (res.is_notice) {
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].cartList', [{}]));
            _app.appMethod.showModal({
              content: '您的同桌' + res.buyer_nickname + '已下单'
            });
          }
          if (!compData.user_list || res.user_list.length !== compData.user_list.length) {
            pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].user_list', res.user_list));
          }
          var buyer_info = res.buyer_info;
          var user_list = res.user_list;
          var my_info = {};
          for (var i = 0; i < user_list.length; i++) {
            if (user_list[i].is_myself) {
              my_info = user_list[i];
            }
          }
          var hasMyInfo = false;
          for (var j = 0; j < buyer_info.length; j++) {
            if (my_info.buyer_id === buyer_info[j].buyer_id) {
              hasMyInfo = true;
              buyer_info.unshift(buyer_info.splice(j, 1)[0]);
            }
          }
          if (!hasMyInfo) {
            buyer_info.unshift(my_info);
          }
          pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].buyer_info', buyer_info));
          if (res.is_reload || isFirst || compData.is_init) {
            compData.is_init = false;
            pageInstance.setData({}, function () {
              that._parseDinningCartListData(res, pageInstance, compindex);
            });
          }
        }
      },
      complete: function complete() {
        compData.loopRequest = true;
      },
      fail: function fail() {
        _app.appMethod.showModal({
          content: '购物车数据请求失败，点击确定重新加载',
          confirm: function confirm() {
            that.getMultiOrderingVerticalCart(compindex, pageInstance, hideLoading, isFirst);
          }
        });
      }
    });
  };

  this._parseDinningCartListData = function (cartlist, pageInstance, compindex) {
    var newdata = {},
        stockEmpty = false,
        compData = pageInstance.data.eles[compindex],
        totalNum = 0,
        totalPrice = 0.00;
    newdata['eles[' + compindex + '].cart_data'] = {};
    var goodsList = compData.goods_data_list || {};
    newdata['eles[' + compindex + '].cartGoodsIdList'] = [];
    compData.flag = false;
    for (var k in goodsList) {
      goodsList[k].totalNum = 0;
    }
    newdata['eles[' + compindex + '].goods_data_list'] = goodsList;
    if (cartlist.data.length) {
      newdata['eles[' + compindex + '].cartlistData'] = [];
      var buyer_info = cartlist.buyer_info;
      var data = cartlist.data;
      var cartlistArr = [];
      for (var i = 0; i < buyer_info.length; i++) {
        cartlistArr[i] = {};
        for (var j = 0; j < data.length; j++) {
          var item = data[j];
          newdata['eles[' + compindex + '].cartlistData'].push(item);
          if (item.goods_type == 0) {
            if (+item.num > +item.stock) {
              item.num = item.stock;
              stockEmpty = true;
            }
            newdata['eles[' + compindex + '].cart_data'][item.goods_id] ? null : newdata['eles[' + compindex + '].cart_data'][item.goods_id] = {};
            newdata['eles[' + compindex + '].cart_data'][item.goods_id][item.model_id] = {
              cart_id: item.id
            };
            if (compData.goods_data_list[item.goods_id] && i == 0) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id].totalNum += +item.num;
              if (pageInstance[compindex]['goods_model_list'][item.goods_id + '']) {
                if (pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model) {
                  pageInstance[compindex]['goods_model_list'][item.goods_id + ''].goods_model[item.model_id].totalNum = +item.num;
                } else {
                  pageInstance[compindex]['goods_model_list'][item.goods_id + ''][0].num += +item.num;
                }
              }
            }
            if (!compData.goods_data_list[item.goods_id]) {
              newdata['eles[' + compindex + '].goods_data_list']['' + item.goods_id] = item;
            }
            if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+item.goods_id) == -1) {
              newdata['eles[' + compindex + '].cartGoodsIdList'].push(+item.goods_id);
            }
            if (item.buyer_id === buyer_info[i].buyer_id) {
              cartlistArr[i][item.goods_id] = cartlistArr[i][item.goods_id] || {};
              cartlistArr[i][item.goods_id][item.model_id] = cartlistArr[i][item.goods_id][item.model_id] || {
                list: 'list',
                id: item.goods_id,
                modelName: item.model_value ? item.model_value.join(' | ') : '',
                modelId: item.model_id,
                num: +item.num,
                price: +item.price,
                gooodsName: item.title,
                totalPrice: Number(item.num * item.price).toFixed(2),
                stock: item.stock,
                cart_id: item.id,
                in_business_time: compData.goods_data_list[item.goods_id] && compData.goods_data_list[item.goods_id].in_business_time,
                pick_up_type: item.pick_up_type,
                is_vip_goods: item.cart_vip_goods && item.original_price != item.price || 0,
                is_package_goods: item.is_package_goods || 0
              };
              var packageArr = [];
              if (item.is_package_goods) {
                for (var _i11 in item.attributes) {
                  packageArr.push(item.attributes[_i11]);
                }
              }
              var attrIdArr = [];
              var arrtStr = '';
              var attrNameArr = [];
              if (item.form_data && item.form_data.attributes) {
                for (var _i12 = 0; _i12 < item.form_data.attributes.length; _i12++) {
                  attrIdArr.push(item.form_data.attributes[_i12].id);
                }
                if (!item.is_package_goods) {
                  for (var _j2 = 0; _j2 < item.attributes.length; _j2++) {
                    if (item.attributes) {
                      var elem = item.attributes[_j2].elem;
                      for (var _k2 = 0; _k2 < elem.length; _k2++) {
                        attrNameArr.push({
                          pName: item.attributes[_j2].name,
                          name: elem[_k2].name,
                          price: elem[_k2].price
                        });
                      }
                    }
                  }
                }
                arrtStr = attrIdArr.join('_');
                if (item.is_package_goods) {
                  arrtStr = item.attributes_id;
                  attrIdArr = [item.attributes_id];
                  attrNameArr = [];
                }
                cartlistArr[i][item.goods_id][item.model_id].attrObj || (cartlistArr[i][item.goods_id][item.model_id].attrObj = {});
                cartlistArr[i][item.goods_id][item.model_id].attrArr ? cartlistArr[i][item.goods_id][item.model_id].attrArr.push(arrtStr) : cartlistArr[i][item.goods_id][item.model_id].attrArr = [].concat(arrtStr);
                cartlistArr[i][item.goods_id][item.model_id].attrObj[arrtStr] = {
                  num: +item.num,
                  price: +item.price,
                  totalPrice: Number(item.num * item.price).toFixed(2),
                  cart_id: item.id,
                  attrIdArr: attrIdArr,
                  attrNameArr: attrNameArr
                };
                if (item.is_package_goods) {
                  for (var a = 0; a < packageArr.length; a++) {
                    var goods_id_list = [];
                    for (var _k3 in packageArr[a].goods_list) {
                      goods_id_list.push(_k3);
                    }
                    packageArr[a].goods_id_list = goods_id_list;
                  }
                  cartlistArr[i][item.goods_id][item.model_id].attrObj[arrtStr].packageArr = packageArr;
                }
              } else {
                cartlistArr[i][item.goods_id][item.model_id].attrObj || (cartlistArr[i][item.goods_id][item.model_id].attrObj = {});
                cartlistArr[i][item.goods_id][item.model_id].attrArr ? cartlistArr[i][item.goods_id][item.model_id].attrArr.push('0') : cartlistArr[i][item.goods_id][item.model_id].attrArr = [].concat('0');
                cartlistArr[i][item.goods_id][item.model_id].attrObj['0'] = {
                  num: +item.num,
                  price: +item.price,
                  totalPrice: Number(item.num * item.price).toFixed(2),
                  cart_id: item.id,
                  attrIdArr: attrIdArr
                };
              }
            }
          }
          if (i == 0) {
            totalNum += Number(item.num);
            totalPrice += Number(item.price) * item.num;
          }
        }
      }
      var userCart = cartlistArr[0];
      var myCartNum = 0;
      for (var _k4 in userCart) {
        for (var _j3 in userCart[_k4]) {
          for (var o in userCart[_k4][_j3].attrObj) {
            myCartNum += userCart[_k4][_j3].attrObj[o].num;
          }
        }
      }
      newdata['eles[' + compindex + '].myCartNum'] = myCartNum;
      newdata['eles[' + compindex + '].cartList'] = cartlistArr;
      newdata['eles[' + compindex + '].TotalNum'] = totalNum;
      newdata['eles[' + compindex + '].TotalPrice'] = Number(+totalPrice).toFixed(2);
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
      if (stockEmpty) {
        _app.appMethod.showModal({
          content: '部分商品库存不足，购物车总数量已修改为最大库存'
        });
        var options = {
          goods_type: 0,
          cartListData: compData.cartList,
          thisPage: pageInstance,
          compindex: compindex
        };
        _this4._addTakeoutCart(options, _this4.eachCartList(options));
      }
    } else {
      newdata['eles[' + compindex + '].TotalNum'] = 0;
      newdata['eles[' + compindex + '].TotalPrice'] = 0.00;
      newdata['eles[' + compindex + '].loadFirstCate'] = false;
      pageInstance.setData(newdata);
    }
    pageInstance.setData(newdata);
  };

  this.getDiningCart = function (pageInstance, compindex) {
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    clearInterval(compData.timer);
    compData.timer = setInterval(function () {
      that.getMultiOrderingVerticalCart(compindex, pageInstance, true);
    }, 4000);
  };

  this.verticalListDeleteBuyerCarts = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var that = _this4;
    var index = dataset.index;
    var cartIds = [];
    var buyerCartList = compData.cartList[index];
    for (var i in buyerCartList) {
      for (var j in buyerCartList[i]) {
        for (var k in buyerCartList[i][j].attrObj) {
          if (buyerCartList[i][j].attrObj[k].num > 0) {
            cartIds.push(buyerCartList[i][j].attrObj[k].cart_id);
          }
        }
      }
    }
    if (cartIds.length == 0) {
      _app.appMethod.showModal({
        content: '请先添加商品'
      });
      return;
    }
    _this4._removeFromCart(cartIds, function () {
      that._removeByerCartCallback({
        compData: compData,
        compindex: compindex,
        thisPage: pageInstance,
        index: index
      });
    }, compindex);
  };

  this._removeByerCartCallback = function (options) {
    var n = {};
    var c = options.compindex;
    var goods_data_list = options.compData.goods_data_list;
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var goods_model_list = pageInstance[c]['goods_model_list'];
    var index = options.index;
    n['eles[' + c + '].cartList' + '[' + index + ']'] = [{}];
    var buyerCartList = options.compData.cartList[index];
    var buyer_totalNum = 0;
    var buyer_totalPrice = 0;
    for (var goodsId in buyerCartList) {
      for (var i in buyerCartList[goodsId]) {
        for (var j in buyerCartList[goodsId][i].attrObj) {
          buyer_totalNum += Number(buyerCartList[goodsId][i].attrObj[j].num);
          buyer_totalPrice += Number((buyerCartList[goodsId][i].attrObj[j].num * buyerCartList[goodsId][i].attrObj[j].price).toFixed(2));
          if (goods_data_list[goodsId]) {
            goods_data_list[goodsId].totalNum -= buyerCartList[goodsId][i].attrObj[j].num;
          }
        }
      }
    }
    for (var _i13 in goods_model_list) {
      for (var _j4 in goods_model_list[_i13].goods_model) {
        goods_model_list[_i13].goods_model[_j4].totalNum = 0;
      }
    }
    if (index === 0) {
      n['eles[' + c + '].myCartNum'] = 0;
    }
    n['eles[' + c + '].goods_data_list'] = goods_data_list;
    n['eles[' + c + '].TotalNum'] = options.compData.TotalNum - buyer_totalNum;
    n['eles[' + c + '].TotalPrice'] = Number(options.compData.TotalPrice - buyer_totalPrice).toFixed(2);
    options.compData.shopInfo.min_deliver_price ? n['eles[' + c + '].isDeliver'] = options.compData.shopInfo.min_deliver_price : '';
    n['eles[' + c + '].shoppingCartShow'] = true;
    options.thisPage.setData(n);
  };

  this.saveFormId = function (form_id) {
    var that = _this4;
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=api/AppMsgTpl/SaveUserFormId',
      data: {
        form_id: form_id
      },
      method: 'post',
      success: function success(res) {}
    });
  };

  this.toSetMeal = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var id = dataset.goodsid;
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    var franchiseeParam = franchiseeId ? '&franchisee=' + franchiseeId : '';
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    pageInstance.returnToVerticalFlag = 1;
    if (compData.goods_data_list[id].stock <= compData.goods_data_list[id].totalNum) {
      _app.appMethod.showModal({
        content: '库存不足'
      });
      return;
    }
    _app.appMethod.turnToPage('/eCommerce/pages/setMeal/setMeal?goods_id=' + id + franchiseeParam + '&listType=drink');
  };

  this.returnCateGoods = function (goods, compData) {
    return {
      app_id: goods.app_id,
      cover: goods.cover,
      description: goods.description,
      tags: goods.tags,
      goods_model: goods.goods_model ? goods.goods_model.length : 0,
      id: goods.id,
      price: goods.price,
      sales: goods.sales,
      title: goods.title,
      business_time: goods.business_time,
      is_in_business_time: goods.goods_in_business_time,
      stock: goods.stock,
      virtual_price: goods.virtual_price,
      corner_mark: goods.corner_mark,
      corner_url: goods.corner_url,
      vipGoods: goods.paid_vip_card_condition || goods.paid_vip_level_condition || goods.vip_card_condition || goods.vip_level_condition ? true : false,
      integral: goods.integral,
      img_urls: goods.img_urls || [],
      max_can_use_integral: Number(goods.max_can_use_integral),
      vip_price: goods.vip_min_price == goods.vip_max_price ? goods.vip_min_price : goods.vip_min_price + '~' + goods.vip_max_price,
      vip_goods_price: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : null,
      calculationPrice: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : goods.price,
      is_vip_goods: goods.is_vip_goods || 0,
      attributes: goods.attributes || null,
      is_package_goods: goods.is_package_goods || 0,
      min_sales_nums: goods.min_sales_nums || null,
      vip_min_price: goods.vip_min_price || 0,
      simple_description: goods.simple_description || ''
    };
  };

  this.returnGoodsDataList = function (goods, compData) {
    return {
      totalNum: 0,
      stock: goods.stock,
      name: goods.title,
      price: goods.price,
      in_business_time: goods.goods_in_business_time,
      model: {},
      goods_model: {},
      pick_up_type: goods.pick_up_type,
      paid_vip_card_condition: goods.paid_vip_card_condition,
      paid_vip_level_condition: goods.paid_vip_level_condition,
      vip_card_condition: goods.vip_card_condition,
      vip_level_condition: goods.vip_level_condition,
      vip_price: goods.vip_min_price == goods.vip_max_price ? goods.vip_min_price : goods.vip_min_price + '~' + goods.vip_max_price,
      vip_goods_price: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : null,
      calculationPrice: goods.vip_goods_price && goods.vip_goods_price !== 0 && !compData.customFeature.is_together ? Number(goods.vip_goods_price).toFixed(2) : goods.price,
      is_vip_goods: goods.is_vip_goods || 0,
      attributes: goods.attributes || null,
      min_sales_nums: goods.min_sales_nums || null,
      vip_min_price: goods.vip_min_price || 0
    };
  };

  this.mealDetailTab = function (e) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = e.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var newdata = {};
    var that = _this4;
    var goodsid = dataset.goodsid;
    var modelid = dataset.modelid;
    var index = dataset.index;
    var it = dataset.it;
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid] = compData.cartList[index][goodsid];
    newdata['eles[' + compindex + '].cartList' + '[' + index + '].' + goodsid][modelid].attrObj[it].isShowMealDetail = !compData.cartList[index][goodsid][modelid].attrObj[it].isShowMealDetail;
    pageInstance.setData(newdata);
  };

  this.verticalListChooseAttr = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var pIndex = dataset.parentindex;
    var index = dataset.index;
    var compindex = dataset.compindex;
    var goodsid = dataset.goodsid;
    var compData = pageInstance.data.eles[compindex];
    var attrData = compData.goods_data_list[goodsid]['attributes'][pIndex];
    var newdata = {};
    var that = _this4;
    newdata['eles[' + compindex + '].attrData'] = compData.attrData || {};
    var isModel = compData.goods_data_list[goodsid].model.modelData ? true : false;
    if (attrData.selected_type === "1") {
      for (var i in compData.attrData) {
        if (compData.attrData[i] && compData.attrData[i].attributes_id === attrData.id) {
          newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + compData.attrData[i].id] = null;
        }
      }
    }
    if (newdata['eles[' + compindex + '].attrData'][attrData.id + '_' + attrData.elem[index].id]) {
      newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + attrData.elem[index].id] = null;
    } else {
      attrData.elem[index].pName = attrData.name;
      newdata['eles[' + compindex + '].attrData.' + attrData.id + '_' + attrData.elem[index].id] = attrData.elem[index];
    }
    pageInstance.setData(newdata, function () {
      if (isModel) {
        that._ModelPirce(dataset, JSON.parse(JSON.stringify(compData.modelIdArr)));
      } else {
        that._AttrPirce(dataset, goodsid);
      }
    });
  };

  this.selectedAttrIdStr = function (compData) {
    var arr = [];
    for (var i in compData.attrData) {
      if (compData.attrData[i]) {
        arr.push(compData.attrData[i].id);
      }
    }
    if (arr.length > 0) {
      return arr.sort().join('_');
    } else {
      return '0';
    }
  };

  this._AttrPirce = function (dataset, goodsid) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var attrPrice = 0;
    var attrName = '';
    var tempArr = [];

    if (compData.attrData) {
      for (var i in compData.attrData) {
        if (compData.attrData[i]) {
          attrPrice += Number(compData.attrData[i].price);
          tempArr.push(compData.attrData[i].name);
        }
      }
    }
    attrName = tempArr.join(',');
    newdata['eles[' + compindex + '].modelVipPrice'] = Number(Number(compData.goods_data_list[goodsid].calculationPrice) + attrPrice).toFixed(2);
    newdata['eles[' + compindex + '].attrName'] = attrName;
    newdata['eles[' + compindex + '].attrPrice'] = attrPrice;
    newdata['eles[' + compindex + '].modelPrice'] = Number(Number(compData.goods_data_list[goodsid].price) + attrPrice).toFixed(2);
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid][0] && compData.cartList[0][goodsid][0].attrObj) {
      var attrId = _this4.selectedAttrIdStr(compData);
      if (newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][goodsid]['0'].attrObj[attrId]) {
        newdata['eles[' + compindex + '].modelNum'] = compData.cartList[0][goodsid]['0'].attrObj[attrId].num;
      } else {
        newdata['eles[' + compindex + '].modelNum'] = 0;
      }
    } else {
      newdata['eles[' + compindex + '].modelNum'] = 0;
    }
    pageInstance.setData(newdata);
  };

  this.addAttrGoods = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var thisGoodsInfo = compData.goods_data_list[goodsid];
    var price = (Number(thisGoodsInfo.calculationPrice) + (Number(compData.attrPrice) || 0)).toFixed(2);
    if (thisGoodsInfo.stock <= thisGoodsInfo.totalNum) {
      _app.appMethod.showModal({
        content: '该规格库存不足'
      });
      return;
    }
    var attrIdArr = [];
    var attrNameArr = [];
    for (var i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
        attrNameArr.push({
          pName: compData.attrData[i].pName,
          name: compData.attrData[i].name,
          price: compData.attrData[i].price
        });
      }
    }
    var attrIdStr = attrIdArr.sort().join('_');
    var attrObj = {};
    var attrNum = 0;
    attrIdStr || (attrIdStr = '0');
    compData.cartAttrId = attrIdStr || '0';
    var addNum = compData.hasAddNum;
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrObj) {
      attrObj = compData.cartList[0][goodsid]['0'].attrObj;
      compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] || {};
      attrNum = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num ? compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num + addNum : addNum;
    } else {
      attrNum = addNum;
    }
    newdata['eles[' + compindex + '].cartGoodsIdList'] = compData.cartGoodsIdList;
    var goods_num = thisGoodsInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = thisGoodsInfo;
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum = thisGoodsInfo.totalNum + addNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) + Number(price) * addNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum + addNum;
    newdata['eles[' + compindex + '].hideSearchInput'] = false;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid] || {};
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrObj) {
      attrObj = compData.cartList[0][goodsid]['0'].attrObj;
      compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr] || {};
      attrNum = compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num ? compData.cartList[0][goodsid]['0'].attrObj[attrIdStr].num + addNum : addNum;
    } else {
      attrNum = addNum;
    }
    attrObj[attrIdStr] = {
      num: attrNum,
      price: Number(price),
      totalPrice: (attrNum * Number(price)).toFixed(2),
      attrIdArr: attrIdArr,
      attrNameArr: attrNameArr
    };
    var attrArr = [];
    if (compData.cartList[0][goodsid] && compData.cartList[0][goodsid]['0'] && compData.cartList[0][goodsid]['0'].attrArr) {
      attrArr = compData.cartList[0][goodsid]['0'].attrArr;
    }
    if (attrArr.indexOf(attrIdStr) == -1) {
      attrArr.push(attrIdStr);
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid]['0'] = {
      modelId: '0',
      num: goods_num,
      price: price,
      id: goodsid,
      gooodsName: compData.goods_data_list[goodsid].name,
      totalPrice: (thisGoodsInfo.totalNum * price).toFixed(2),
      stock: thisGoodsInfo.stock,
      cart_id: 0,
      pick_up_type: compData.goods_data_list[goodsid].pick_up_type,
      attrObj: attrObj,
      attrArr: attrArr
    };
    if (!compData.customFeature.is_together && compData.goods_data_list[goodsid].is_vip_goods) {
      newdata['eles[' + compindex + '].cartList[0].' + goodsid]['0'].is_vip_goods = 1;
    }
    if (newdata['eles[' + compindex + '].cartGoodsIdList'].indexOf(+goodsid) == -1) {
      newdata['eles[' + compindex + '].cartGoodsIdList'].push(+goodsid);
    }
    if (compData['modelNum']) {
      newdata['eles[' + compindex + '].modelNum'] = +compData['modelNum'] + addNum;
    } else {
      newdata['eles[' + compindex + '].modelNum'] = addNum;
    }
    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: compData.cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
      _this4.drinkHideDetailPop(event);
      _this4.drinkAddCartAnimation(pageInstance, compindex);
    }, 0);
  };

  this.minuAttrGoods = function (event) {
    clearTimeout(_this4.takeoutTimeout);
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var newdata = {};
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var goodsid = compData.modelGoodsId;
    var thisGoodsInfo = compData.goods_data_list[goodsid];
    var price = thisGoodsInfo.calculationPrice;
    var modelid = '0';
    var attrIdArr = [];
    for (var i in compData.attrData) {
      if (compData.attrData[i]) {
        attrIdArr.push(compData.attrData[i].id);
      }
    }
    var attrIdStr = attrIdArr.sort().join('_');
    attrIdStr || (attrIdStr = '0');
    var minusNum = 1; //起卖数
    if (compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num <= compData.goods_data_list[goodsid].min_sales_nums) {
      minusNum = compData.cartList[0][goodsid][modelid].attrObj[attrIdStr].num;
    }
    newdata['eles[' + compindex + '].cartList[0].' + goodsid] = compData.cartList[0][goodsid];
    newdata['eles[' + compindex + '].goods_data_list.' + goodsid] = compData.goods_data_list[goodsid];
    newdata['eles[' + compindex + '].TotalNum'] = compData.TotalNum - minusNum;
    newdata['eles[' + compindex + '].TotalPrice'] = (Number(compData.TotalPrice) - Number(price) * minusNum).toFixed(2);
    newdata['eles[' + compindex + '].isDeliver'] = (+compData.shopInfo.min_deliver_price - newdata['eles[' + compindex + '].TotalPrice']).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].num).toFixed(2);
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num -= minusNum;
    newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].totalPrice = Number(price * newdata['eles[' + compindex + '].cartList[0].' + goodsid][modelid].attrObj[attrIdStr].num).toFixed(2);
    newdata['eles[' + compindex + '].modelNum'] = compData.modelNum - minusNum;
    if (newdata['eles[' + compindex + '].goods_data_list.' + goodsid]) {
      newdata['eles[' + compindex + '].goods_data_list.' + goodsid].totalNum -= minusNum;
    }
    pageInstance.setData(newdata, function () {
      var userCart = compData.cartList[0];
      var myCartNum = 0;
      for (var k in userCart) {
        for (var j in userCart[k]) {
          for (var o in userCart[k][j].attrObj) {
            myCartNum += userCart[k][j].attrObj[o].num;
          }
        }
      }
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].myCartNum', myCartNum));
    });
    _this4.takeoutTimeout = setTimeout(function () {
      var options = {
        goods_type: 0,
        cartListData: pageInstance.data.eles[compindex].cartList,
        thisPage: pageInstance,
        compindex: compindex
      };
      _this4._addTakeoutCart(options, _this4.eachCartList(options), null, goodsid);
    }, 300);
  };

  this.checkedPickRadioFn = function (event) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var type = dataset.type;
    var newData = {};
    var compindex = dataset.compindex;
    newData['eles[' + compindex + '].pickUpType'] = type;
    pageInstance.setData(newData);
  };

  this.confirmGoodsPick = function (event) {
    // 跳转确认支付 type = compData.pickUpType
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var franchiseeId = _app.appMethod.getPageFranchiseeId();
    var addressId = compData.selectSameJourneyId ? compData.selectSameJourneyId.id : undefined;
    var type = compData.pickUpType;
    var cartIdArray = compData.canUsePickUpType[type].cart_list;
    var pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?type=' + type + '&cart_arr=' + encodeURIComponent(cartIdArray);
    franchiseeId && (pagePath += '&franchisee=' + franchiseeId);
    addressId && (pagePath += '&addressId=' + addressId);
    _app.appMethod.turnToPage(pagePath);
  };

  this.drinkTurnToChainStoreList = function (e) {
    _app.appMethod.turnToPage('/franchisee/pages/chainStoreList/chainStoreList');
  };

  this.getMainStoreInfo = function () {
    var param = {};
    if (_app.appMethod.globalData.chainAppId) {
      param.app_id = _app.appMethod.globalData.chainAppId;
    } else {
      param = {};
    }
    _app.appMethod.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopInfo',
      data: param,
      success: function success(res) {
        var data = res.data;
        if (!data.app_id) {
          return;
        }
        var pageInstance = _app.appMethod.getAppCurrentPage();
        var inBusiness = _app.appMethod.businessTimeCompare(data.business_time || []);
        pageInstance.setData({
          currentChainStore: {
            name: data.name,
            phone: data.phone,
            address: data.province_name + data.city_name + data.county_name + data.address_detail,
            not_business: !inBusiness,
            is_open: data.is_open
          }
        });
      }
    });
  };

  this.selectPickUpType = function (event) {
    var _pageInstance$setData10;

    var pageInstance = _app.appMethod.getAppCurrentPage();
    var dataset = event.currentTarget.dataset;
    var compindex = dataset.compindex;
    var compData = pageInstance.data.eles[compindex];
    var categoryId = '';
    if (compData && compData.content && compData.content[compData.customFeature.selected]) {
      categoryId = compData.content[compData.customFeature.selected].source;
    }
    var pagination = compData.pagination["category" + categoryId];
    var param = pagination.param;
    var id = dataset.id;
    var newdata = {};
    pageInstance.setData((_pageInstance$setData10 = {}, (0, _defineProperty3.default)(_pageInstance$setData10, 'eles[' + compindex + '].pick_up_select', id), (0, _defineProperty3.default)(_pageInstance$setData10, 'eles[' + compindex + '].cartList', [{}]), _pageInstance$setData10));
    param.page = 1;
    param.page_size = 10;
    _this4._getPickUpLeft(compindex);
    _this4._getTakeoutStyleGoodsList(param, pageInstance, compindex, 1);
  };

  this._getPickUpLeft = function (compindex) {
    var pageInstance = _app.appMethod.getAppCurrentPage();
    var compData = pageInstance.data.eles[compindex];
    var _index = compData.pick_up_type_new.indexOf(+compData.pick_up_select);
    // 防止dom未渲染时获取不到dom
    setTimeout(function () {
      var $pickupItem = document.querySelector('.pickup-item');
      pageInstance.setData((0, _defineProperty3.default)({}, 'eles[' + compindex + '].pick_up_select_left', $pickupItem.offsetWidth * _index));
    }, 0);
    // web没有以下api 故使用上述offsetWidth获取
    // app.createSelectorQuery().select('.pickup-item').boundingClientRect(rect => {
    //   pageInstance.setData({
    //     ['eles[' + compindex + '].pick_up_select_left']: rect.width * _index
    //   })
    // }).exec();
  };

  this.getShopAdvancedSetting = function (pageInstance, compindex) {
    var newdata = {};
    _app.appMethod.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/getShopAdvancedSetting',
      data: {
        goods_type: 0,
        app_id: _app.appMethod.getPageFranchiseeId()
      },
      chain: true,
      success: function success(res) {
        newdata['eles[' + compindex + "].advancedList"] = res.data.config_data;
        pageInstance.setData(newdata);
      }
    });
  };

  this.addCartAnimation = function (pageInstance, compindex) {
    var newdata = {};
    newdata['eles[' + compindex + '].addCarting'] = true;
    pageInstance.setData(newdata);
    setTimeout(function () {
      newdata['eles[' + compindex + '].addCarting'] = false;
      pageInstance.setData(newdata);
    }, 500);
  };
};

exports.default = DrinkVerticalListCustomComponent;

/***/ }),
/* 933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 934 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TechSupport = exports.TechSupport = function TechSupport() {
  return React.createElement(
    'div',
    { style: {
        width: '100%',
        height: '1.30rem',
        overflow: 'hidden',
        marginTop: '.20rem'
      } },
    React.createElement('img', {
      src: '//cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/tec-support-new.png',
      style: {
        width: '100%',
        height: '100%'
      }
    })
  );
};

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _util = __webpack_require__(17);

var _util2 = _interopRequireDefault(_util);

__webpack_require__(937);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Filter = exports.Filter = function (_CommonComponent) {
  (0, _inherits3.default)(Filter, _CommonComponent);

  function Filter(props) {
    (0, _classCallCheck3.default)(this, Filter);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this.confirm = '';

    _this.show = function (options) {
      var filterShow = options.filterShow,
          chooseCateId = options.chooseCateId,
          form = options.form,
          confirm = options.confirm;


      if (filterShow && filterShow === true) {
        var newdata = {};
        newdata.filterShow = true;
        _this.getCategory();
        newdata.hasTabbar = _app.appMethod.isTabBarPage();

        if (chooseCateId) {
          newdata.chooseCateId = chooseCateId;
        }
        if (form) {
          newdata.form = form || 'goods';
          newdata.goodsType = _util2.default.getGoodsTypeByForm(form);
        }
        _this.setData(newdata);
        if (confirm) {
          _this.confirm = confirm;
        }
      }
    };

    _this.getLocation = function () {
      var that = _this;
      _app.appMethod.getLocation({
        success: function success(res) {

          if (!res.longitude) {
            return;
          }
          _app.appMethod.sendRequest({
            url: '/index.php?r=Map/getAreaInfoByLatAndLng',
            data: {
              longitude: res.longitude,
              latitude: res.latitude
            },
            success: function success(data) {
              var province = data.data.address_component.province;
              var city = data.data.address_component.city;
              var district = data.data.address_component.district;

              that.setData({
                location: province + city + district,
                currentRegionId: data.data.region_id
              });
            }
          });

          that.setData({
            longitude: res.longitude,
            latitude: res.latitude
          });
        },
        fail: function fail(res) {
          console.log(res);
        }
      });
    };

    _this.hasGetCateGory = false;

    _this.getCategory = function () {
      var that = _this;
      if (that.hasGetCateGory) {
        return;
      }
      var pageInstance = _app.appMethod.getAppCurrentPage();
      _app.appMethod.sendRequest({
        url: '/index.php?r=appData/listCategory',
        data: {
          form: 'goods',
          goods_type: that.data.goodsType
        },
        chain: true,
        subshop: pageInstance.franchiseeId || '',
        success: function success(res) {
          var data = res.data;
          var newdata = {};
          that.hasGetCateGory = true;

          for (var i = 0; i < data.length; i++) {
            var subclass = data[i].subclass;
            if (subclass && subclass.length > 0) {
              var h = Math.ceil((subclass.length + 1) / 2) * 99 + 15;
              data[i].height = h;
              if (i == 0 || i == 1) {
                data[i].isOpen = true;
              }
            }
          }

          newdata['category'] = data;
          that.setData(newdata);
        }
      });
    };

    _this.chooseCategory = function (e) {
      var id = e.currentTarget.dataset.id;
      var detail = {
        leastPrice: _this.data.leastPrice,
        mostPrice: _this.data.mostPrice,
        chooseCateId: id,
        currentRegionId: _this.data.currentRegionId
      };
      _this.setData(detail);
      _this.confirm && _this.confirm({ detail: detail });
    };

    _this.openCate = function (e) {
      var index = e.currentTarget.dataset.index;
      var newdata = {};

      newdata['category[' + index + '].isOpen'] = !_this.data.category[index].isOpen;
      _this.setData(newdata);
    };

    _this.showMyAddress = function () {
      _this.setData({
        myAddress: true
      });
      _this.getMyAddress();
    };

    _this.hideMyAddress = function () {
      _this.setData({
        myAddress: false
      });
    };

    _this.getMyAddress = function () {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addressList',
        data: {},
        success: function success(res) {
          var list = res.data;
          var newdata = {};

          newdata['myAddressList'] = list;
          that.setData(newdata);
        }
      });
    };

    _this.chooseMyAddress = function (e) {
      var index = e.currentTarget.dataset.index;
      var ad = _this.data.myAddressList[index];
      var region = e.currentTarget.dataset.region;

      _this.setData({
        myAddressIndex: index,
        myAddress: false,
        location: ad.address_info.province.text + ad.address_info.city.text + ad.address_info.district.text,
        currentRegionId: region
      });
    };

    _this.showChooseArea = function () {
      _this.setData({
        chooseArea: true,
        areaType: 'province',
        province: {},
        city: {},
        town: {}
      });
      _this.getArea();
    };

    _this.hideChooseArea = function () {
      _this.setData({
        chooseArea: false
      });
    };

    _this.allAreaList = [];

    _this.getArea = function () {
      var that = _this;

      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getAllRegionInfo',
        data: {},
        success: function success(res) {
          var list = res.data;
          var provinceArr = [];
          var newdata = {};

          that.allAreaList = list;

          newdata['areaList'] = list;

          that.setData(newdata);
        }
      });
    };

    _this.chooseArea = function (e) {
      var newdata = {};
      var that = _this;
      var id = e.currentTarget.dataset.id;
      var areaType = that.data.areaType;
      var areaList = that.data.areaList;

      if (areaType == 'province') {
        for (var i in areaList) {
          if (id == areaList[i].id) {
            newdata[that.data.areaType] = areaList[i];
            newdata['areaList'] = areaList[i].cities;
          }
        }
        newdata['areaType'] = 'city';
      } else if (areaType == 'city') {
        for (var _i in areaList) {
          if (id == areaList[_i].id) {
            newdata[that.data.areaType] = areaList[_i];
            newdata['areaList'] = areaList[_i].towns;
          }
        }
        newdata['areaType'] = 'town';
      } else if (areaType == 'town') {
        for (var _i2 in areaList) {
          if (id == areaList[_i2].id) {
            newdata[that.data.areaType] = areaList[_i2];
            newdata['currentRegionId'] = id;
          }
        }
        newdata['location'] = that.data.province.name + that.data.city.name + newdata.town.name;
        newdata['myAddress'] = false;
        newdata['chooseArea'] = false;
      }
      newdata['areaId'] = id;
      _this.setData(newdata);
    };

    _this.resetProvince = function () {
      var that = _this;
      that.setData({
        areaType: 'province',
        areaId: '',
        areaList: that.allAreaList,
        province: {},
        city: {},
        town: {}
      });
    };

    _this.resetCity = function () {
      var that = _this;
      that.setData({
        areaType: 'city',
        areaId: '',
        areaList: that.data.province.cities,
        city: {},
        town: {}
      });
    };

    _this.filterHide = function () {
      _this.setData({
        filterShow: false,
        myAddress: false,
        chooseArea: false
      });
    };

    _this.leastPriceInput = function (e) {
      _this.setData({
        leastPrice: e.target.value
      });
    };

    _this.mostPriceInput = function (e) {
      _this.setData({
        mostPrice: e.target.value
      });
    };

    _this.filterReset = function () {
      var detail = {
        leastPrice: '',
        mostPrice: '',
        chooseCateId: '',
        location: '',
        currentRegionId: ''
      };
      _this.setData(detail);
      _this.confirm && _this.confirm({ detail: detail });
    };

    _this.filterConfirm = function () {
      var that = _this;
      if (that.data.leastPrice || that.data.mostPrice) {
        if (!/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(that.data.leastPrice) || !/(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/.test(that.data.mostPrice)) {
          _app.appMethod.showModal({
            content: '价格区间填写有误'
          });
          return;
        }
        if (+that.data.leastPrice > +that.data.mostPrice) {
          _app.appMethod.showModal({
            content: '价格区间中设置的最大值需大于最小值'
          });
          return;
        }
      }
      var detail = {
        leastPrice: that.data.leastPrice || '',
        mostPrice: that.data.mostPrice || '',
        chooseCateId: that.data.chooseCateId,
        currentRegionId: that.data.currentRegionId
      };
      that.setData(detail);
      _this.confirm && _this.confirm({ detail: detail });
      that.filterHide();
    };

    _this.options = _this.props.options;

    _this.state = {
      filterShow: false,
      category: [],
      chooseCateId: '',
      location: '',
      myAddress: false,
      myAddressList: [],
      myAddressIndex: '',
      chooseArea: false,
      areaList: [],
      province: {},
      city: {},
      town: {},
      areaType: 'province', // type值为province、city、town
      areaId: '',
      leastPrice: '',
      mostPrice: '',
      currentRegionId: '',
      form: 'goods',
      goodsType: 0,
      hasTabbar: false
    };
    return _this;
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一直


  // 获取定位


  // 获取商品分类


  // 选择分类


  // 展开、隐藏二级分类


  // 展示我的地址


  // 隐藏我的地址


  // 获取我的地址


  // 选择我的地址


  // 展示选择地区


  // 隐藏选择地区


  // 获取地区


  // 选择地区


  // 重设省份


  // 重设城市


  // 隐藏组件


  // 最低价格输入框


  // 最高价格输入框


  // 重置


  // 确定


  (0, _createClass3.default)(Filter, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          filterShow = _state.filterShow,
          topNavBarHeight = _state.topNavBarHeight,
          category = _state.category,
          chooseCateId = _state.chooseCateId,
          leastPrice = _state.leastPrice,
          mostPrice = _state.mostPrice,
          location = _state.location,
          myAddress = _state.myAddress,
          myAddressList = _state.myAddressList,
          myAddressIndex = _state.myAddressIndex,
          chooseArea = _state.chooseArea,
          areaType = _state.areaType,
          province = _state.province,
          city = _state.city,
          town = _state.town,
          areaList = _state.areaList,
          areaId = _state.areaId,
          hasTabbar = _state.hasTabbar;


      if (!filterShow) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component filter filter-wrap', style: { top: topNavBarHeight + 'px', bottom: hasTabbar ? '49px' : '0px' } },
        _react2.default.createElement('div', { className: 'filter-bg', onClick: this.filterHide }),
        _react2.default.createElement(
          'div',
          { className: 'filter-inner active' },
          _react2.default.createElement(
            'div',
            { className: 'filter-cate' },
            category.map(function (item, index) {
              return item.subclass && item.subclass.length > 0 ? _react2.default.createElement(
                'div',
                { className: 'filter-box', key: item.id },
                _react2.default.createElement(
                  'div',
                  { className: 'filter-box-head clearfix', 'data-id': item.id, 'data-index': index, onClick: _this2.openCate },
                  _react2.default.createElement(
                    'div',
                    { className: 'filter-box-title' },
                    item.name
                  ),
                  item.isOpen ? _react2.default.createElement(
                    'div',
                    { className: 'filter-box-all' },
                    '\u6536\u8D77 ',
                    _react2.default.createElement('label', { className: 'ico-moon icon-uparrow' })
                  ) : _react2.default.createElement(
                    'div',
                    { className: 'filter-box-all' },
                    '\u5C55\u5F00 ',
                    _react2.default.createElement('label', { className: 'ico-moon icon-downarrow' })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'filter-box-content cate-content', style: item.isOpen ? { height: item.height / 100 + 'rem' } : {} },
                  _react2.default.createElement(
                    'div',
                    { className: 'filter-box-item ' + (chooseCateId == item.id ? 'active' : ''), 'data-id': item.id, onClick: _this2.chooseCategory },
                    _react2.default.createElement(
                      'label',
                      { className: 'filter-subcate-text filter-subcate-noimg' },
                      '\u5168\u90E8'
                    )
                  ),
                  item.subclass.map(function (subclass) {
                    return _react2.default.createElement(
                      _react2.default.Fragment,
                      { key: subclass.id },
                      subclass.logo ? _react2.default.createElement(
                        'div',
                        { className: 'filter-box-item ' + (chooseCateId == subclass.id ? 'active' : ''), 'data-id': subclass.id, onClick: _this2.chooseCategory },
                        _react2.default.createElement(
                          'label',
                          { className: 'filter-subcate-text' },
                          subclass.name
                        ),
                        _react2.default.createElement('img', { className: 'filter-subcate-img', src: subclass.logo, mode: 'aspectFill' })
                      ) : _react2.default.createElement(
                        'div',
                        { className: 'filter-box-item ' + (chooseCateId == subclass.id ? 'active' : ''), 'data-id': subclass.id, onClick: _this2.chooseCategory },
                        _react2.default.createElement(
                          'label',
                          { className: 'filter-subcate-text filter-subcate-noimg' },
                          subclass.name
                        )
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                'div',
                { className: 'filter-box', key: item.id },
                _react2.default.createElement(
                  'div',
                  { className: 'filter-box-head clearfix ' + (chooseCateId == item.id ? 'active' : ''), 'data-id': item.id, onClick: _this2.chooseCategory },
                  _react2.default.createElement(
                    'div',
                    { className: 'filter-box-title' },
                    item.name
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'filter-box-all' },
                    '\u67E5\u770B\u5168\u90E8 ',
                    _react2.default.createElement('label', { className: 'ico-moon icon-rightarrow' })
                  ),
                  _react2.default.createElement('div', { className: 'filter-head-line' })
                )
              );
            }),
            _react2.default.createElement(
              'div',
              { className: 'filter-box' },
              _react2.default.createElement(
                'div',
                { className: 'filter-box-head' },
                _react2.default.createElement(
                  'div',
                  { className: 'filter-box-title' },
                  '\u4EF7\u683C\u533A\u95F4\uFF08\u5143\uFF09'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'filter-box-content' },
                _react2.default.createElement('input', { className: 'filter-price-input', type: 'number', placeholder: '\u6700\u4F4E\u4EF7', value: leastPrice, onInput: this.leastPriceInput, onChange: function onChange() {} }),
                _react2.default.createElement(
                  'label',
                  { className: 'filter-price-line' },
                  '-'
                ),
                _react2.default.createElement('input', { className: 'filter-price-input', type: 'number', step: '0.1', placeholder: '\u6700\u9AD8\u4EF7', value: mostPrice, onInput: this.mostPriceInput, onChange: function onChange() {} })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'filter-box' },
              _react2.default.createElement(
                'div',
                { className: 'filter-box-head' },
                _react2.default.createElement(
                  'div',
                  { className: 'filter-box-title' },
                  '\u57CE\u5E02\u9009\u62E9'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'filter-box-content' },
                _react2.default.createElement(
                  'div',
                  { className: 'filter-address ' + (location ? 'active' : ''), onClick: this.showMyAddress },
                  _react2.default.createElement('label', { className: 'filter-address-icon ico-moon icon-fesadress' }),
                  location || '无'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'filter-location', onClick: this.getLocation },
                  _react2.default.createElement('label', { className: 'filter-location-icon ico-moon icon-fesadress' }),
                  '\u5B9A\u4F4D'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'filter-reset', onClick: this.filterReset },
              '\u91CD\u7F6E'
            ),
            _react2.default.createElement(
              'div',
              { className: 'filter-confirm', onClick: this.filterConfirm },
              '\u786E\u5B9A'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'filter-inner filter-myaddress ' + (myAddress ? 'active' : '') },
          _react2.default.createElement(
            'div',
            { className: 'filter-inner-head' },
            _react2.default.createElement('label', { className: 'filter-inner-head-icon ico-moon icon-leftarrow', onClick: this.hideMyAddress }),
            '\u9009\u62E9\u5730\u5740'
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-myaddress-list' },
            myAddressList.map(function (item, index) {
              return _react2.default.createElement(
                'div',
                { key: item.id, className: 'filter-myaddress-item ' + (myAddressIndex === index ? 'active' : ''), 'data-id': item.id, 'data-index': index, 'data-region': item.address_info.district.id, onClick: _this2.chooseMyAddress },
                _react2.default.createElement('label', { className: 'filter-myaddress-icon ico-moon icon-community-location' }),
                _react2.default.createElement(
                  'span',
                  { className: 'filter-myaddress-text' },
                  item.address_info.province.text + item.address_info.city.text + item.address_info.district.text + (item.detail_address || '')
                ),
                _react2.default.createElement('label', { className: 'filter-myaddress-icon filter-myaddress-gou ico-moon icon-gou' })
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-bottom' },
            _react2.default.createElement(
              'div',
              { className: 'filter-confirm', onClick: this.showChooseArea },
              '\u9009\u62E9\u5176\u4ED6\u5730\u5740'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'filter-inner filter-area ' + (chooseArea ? 'active' : '') },
          _react2.default.createElement(
            'div',
            { className: 'filter-inner-head' },
            _react2.default.createElement('label', { className: 'filter-inner-head-icon ico-moon icon-leftarrow', onClick: this.hideChooseArea }),
            '\u9009\u62E9\u5730\u5740'
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-choose-area' },
            _react2.default.createElement(
              'div',
              { className: 'filter-choose-item ' + (areaType == 'province' ? 'active' : ''), onClick: this.resetProvince },
              province.name || '请选择省'
            ),
            city.name || areaType == 'city' && _react2.default.createElement(
              'div',
              { className: 'filter-choose-item ' + (areaType == 'city' ? 'active' : ''), onClick: this.resetCity },
              city.name || '请选择市'
            ),
            town.name || areaType == 'town' && _react2.default.createElement(
              'div',
              { className: 'filter-choose-item ' + (areaType == 'town' ? 'active' : '') },
              town.name || '请选择区'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'filter-area-list' },
            Object.keys(areaList).map(function (objkey) {
              return _react2.default.createElement(
                'div',
                { className: 'filter-area-item ' + (areaId == areaList[objkey].id ? 'active' : ''), key: areaList[objkey].id, 'data-id': areaList[objkey].id, onClick: _this2.chooseArea },
                _react2.default.createElement(
                  'span',
                  { className: 'filter-area-text' },
                  areaList[objkey].name
                ),
                _react2.default.createElement('label', { className: 'filter-area-gou ico-moon icon-gou' })
              );
            })
          )
        )
      );
    }
  }]);
  return Filter;
}(_CommonComponent3.default);

/***/ }),
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPay = undefined;

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(33);

__webpack_require__(20);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

var _page = __webpack_require__(43);

__webpack_require__(939);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormPay = exports.FormPay = function (_CommonComponent) {
  (0, _inherits3.default)(FormPay, _CommonComponent);

  function FormPay(props) {
    (0, _classCallCheck3.default)(this, FormPay);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (FormPay.__proto__ || Object.getPrototypeOf(FormPay)).call(this, props));

    _this2.show = function (options) {
      var formInfo = options.formInfo;


      if (formInfo && formInfo.show === true) {
        _this2.setData({
          formInfo: formInfo
        });
      }
    };

    _this2.discountChange = function (val) {
      var index = val;

      _this2.setData({
        'formInfo.selectDiscountInfo': _this2.data.formInfo.discountList[index] || '',
        'formInfo.selectDiscountIndex': index,
        'formInfo.calculData.selected_benefit': _this2.data.formInfo.discountList[index] || ''
      });
      _this2.calculateTotalPrice();
    };

    _this2.closeDialog = function () {
      _this2.setData({
        'formInfo.show': false,
        'formInfo.useBalance': false
      });
      var thisPage = _app.appMethod.getAppCurrentPage();
      thisPage.setData({
        'formInfo.show': false
      });
    };

    _this2.inputRemark = function (e) {
      _this2.setData({
        remark: e.target.value
      });
    };

    _this2.confirmPay = function () {
      var _this = _this2;
      var inputPrice = +_this2.data.formInfo.price;
      var totalPayment = _this2.data.formInfo.totalPayment;
      var benefits = _this2.data.formInfo.selectDiscountInfo;
      if (isNaN(totalPayment) || totalPayment < 0) {
        alertTip('error payment amount');
        return;
      }

      if (_this2.data.requesting) {
        return;
      }
      _this2.setData({
        requesting: true
      });

      if (benefits.no_use_benefit == 1) {
        benefits = '';
      }

      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/createTransferOrder',
        method: 'post',
        data: {
          price: inputPrice,
          check_price: totalPayment,
          message: _this2.data.remark,
          selected_benefit: benefits,
          is_balance: _this2.data.formInfo.useBalance == true ? 1 : 0,
          form_info: _this2.data.formInfo.submitData
        },
        success: function success(res) {
          _this.setData({
            'formInfo.submitData.button_info.order_id': res.data
          });
          _this.payOrder(res.data);
        },
        fail: function fail() {
          _this.setData({
            requesting: false
          });
        }
      });
    };

    _this2.payOrder = function (orderId) {
      var _this = _this2;
      function paySuccess() {
        var newData = {
          'formInfo.show': false,
          remark: '',
          'formInfo.useBalance': false
        };
        _app.appMethod.getAppCurrentPage().setData(newData);
        _this.setData({
          requesting: false
        });
        var formVesselCompindex = _this.data.buttonInfo.compindex;
        if (formVesselCompindex != -1) {
          _page.pageInstance.callComponentMethod({
            componentIndex: formVesselCompindex,
            methodName: 'addFormDataSuccess',
            argvs: [_this.data.buttonInfo, { msg: '' }]
          });
        }
      }

      function payFail() {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/cancelOrder',
          data: {
            order_id: orderId
          },
          success: function success(res) {},
          fail: function fail() {
            payFail();
          },
          complete: function complete() {
            _this.setData({
              requesting: false
            });
          }
        });
      }

      if (_this2.data.formInfo.totalPayment == 0) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/paygoods',
          data: {
            order_id: orderId,
            total_price: 0
          },
          success: function success(res) {
            paySuccess();
          },
          fail: function fail() {
            payFail();
          }
        });
        return;
      }
      // app.sendRequest({
      //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
      //   data: {
      //     order_id: orderId
      //   },
      //   success: function (res) {
      //     var param = res.data;

      //     param.orderId = orderId;
      //     param.goodsType = 5;
      //     param.success = paySuccess;
      //     param.fail = payFail;
      //     app.wxPay(param);
      //   },
      //   complete: function(){
      //     let newData = {
      //       'formInfo.show': false,
      //       remark: '',
      //       'formInfo.useBalance': false
      //     };
      //     _this.setData({
      //       requesting: false
      //     });
      //     app.getAppCurrentPage().setData(newData);
      //   }
      // })
      _app.appMethod.goPay({
        orderId: orderId
      });
      paySuccess();
    };

    _this2.calculateTotalPrice = function (options) {
      if (options) {
        _this2.setData({
          buttonInfo: options
        });
      }
      var _this = _this2;
      var price = +_this2.data.formInfo.price;
      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/calculationPrice',
        method: 'post',
        data: _this2.data.formInfo.calculData,
        success: function success(res) {
          var data = res.data;
          var benefits = data.can_use_benefit.data;
          var selected_benefit = void 0;
          var selectDiscountIndex = void 0;

          if (benefits.length) {
            benefits.unshift({
              title: '不使用优惠',
              name: '无',
              no_use_benefit: 1
            });
          }

          selected_benefit = data.selected_benefit_info;
          for (var i = 0; i <= benefits.length - 1; i++) {
            var select_discount_type = selected_benefit.discount_type;
            if (select_discount_type === benefits[i].discount_type) {
              if (select_discount_type === 'coupon') {
                if (benefits[i].coupon_id == selected_benefit.coupon_id) {
                  selectDiscountIndex = i;
                  break;
                }
              } else {
                selectDiscountIndex = i;
                break;
              }
            }
          }

          _this.setData({
            'formInfo.totalPayment': data.price,
            'formInfo.discountList': benefits,
            'formInfo.selectDiscountInfo': selected_benefit,
            'formInfo.selectDiscountIndex': selectDiscountIndex || '',
            'formInfo.balance': data.balance,
            'formInfo.use_balance_count': data.use_balance,
            'formInfo.discount_cut_price': data.discount_cut_price
          });
        }
      });
    };

    _this2.ifUseBalance = function (val) {
      _this2.setData({
        'formInfo.useBalance': val,
        'formInfo.calculData.is_balance': val == true ? 1 : 0
      });
      _this2.calculateTotalPrice();
    };

    _this2.options = _this2.props.options;

    _this2.state = {
      formInfo: {
        price: 0,
        form_data: {}
      },
      buttonInfo: '',
      remark: ''
    };
    return _this2;
  }

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一直


  (0, _createClass3.default)(FormPay, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          formInfo = _state.formInfo,
          remark = _state.remark;
      // WEBAPP  TODO

      var discountListPickerData = formInfo.discountList && formInfo.discountList.map(function (item, index) {
        return {
          label: item.title,
          value: index
        };
      }) || [];
      if (!formInfo.show) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component form-pay form-pay-dialog' },
        _react2.default.createElement(
          'div',
          { className: 'form-title' },
          '\u4ED8\u6B3E\u7ED9 ',
          formInfo.name,
          ' ',
          _react2.default.createElement('img', { className: 'cheques-img', src: formInfo.logo })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-content' },
          _react2.default.createElement(
            'div',
            { style: { color: '#333' } },
            _react2.default.createElement(
              'span',
              null,
              '\xA5'
            ),
            _react2.default.createElement(
              'span',
              { className: 'form-price' },
              formInfo.price
            )
          ),
          formInfo.isDiscount && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              _picker2.default,
              { data: discountListPickerData, cols: 1, value: formInfo.selectDiscountIndex, onChange: this.discountChange },
              _react2.default.createElement(
                'div',
                { className: 'picker' },
                _react2.default.createElement(
                  'span',
                  { className: 'left-label' },
                  '\u4F7F\u7528\u4F18\u60E0'
                ),
                _react2.default.createElement(
                  'span',
                  { style: { color: '#ff7100' } },
                  formInfo.selectDiscountInfo && formInfo.selectDiscountInfo.title || '无'
                ),
                _react2.default.createElement('span', { className: 'ico-moon icon-downarrow', style: { float: 'right', lineHeight: '1em' } })
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'left-label', style: { height: '.64rem', lineHeight: '.64rem' } },
                '\u4F7F\u7528\u50A8\u503C\u62B5\u6263'
              ),
              formInfo.useBalance && _react2.default.createElement(
                'span',
                { style: { color: '#ff7100' } },
                '\u62B5',
                formInfo.use_balance_count,
                '\u5143'
              ),
              _react2.default.createElement(_switch2.default, { className: 'pull-right', checked: formInfo.useBalance, onChange: this.ifUseBalance, platform: 'ios' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'marign-top' },
            _react2.default.createElement(
              'span',
              { className: 'left-label' },
              '\u5907\u6CE8'
            ),
            _react2.default.createElement('textarea', { className: 'remarks', onChange: this.inputRemark, value: remark })
          ),
          _react2.default.createElement(
            'div',
            { className: 'marign-top actual-pay' },
            _react2.default.createElement(
              'span',
              { className: 'left-label' },
              '\u5B9E\u9645\u4ED8\u6B3E'
            ),
            _react2.default.createElement(
              'span',
              { style: { color: '#ff7100', float: 'right' } },
              '\xA5',
              _react2.default.createElement(
                'span',
                { className: 'actual-price' },
                formInfo.totalPayment
              )
            )
          ),
          _react2.default.createElement(
            'button',
            { className: 'pay-btn marign-top', onClick: this.confirmPay },
            '\u786E\u8BA4\u652F\u4ED8'
          ),
          _react2.default.createElement('div', { className: 'form-pay-close ico-moon icon-closes', onClick: this.closeDialog })
        )
      );
    }
  }]);
  return FormPay;
}(_CommonComponent3.default);

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunityPublish = undefined;

var _picker = __webpack_require__(22);

var _picker2 = _interopRequireDefault(_picker);

var _switch = __webpack_require__(32);

var _switch2 = _interopRequireDefault(_switch);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(20);

__webpack_require__(33);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(941);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSubmiting = false;

var routeIsCommunityPage = function routeIsCommunityPage() {
  return (/^informationManagement/.test(_app.appMethod.getAppCurrentPage().route)
  );
};

var CommunityPublish = exports.CommunityPublish = function (_CommonComponent) {
  (0, _inherits3.default)(CommunityPublish, _CommonComponent);

  function CommunityPublish(props) {
    (0, _classCallCheck3.default)(this, CommunityPublish);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommunityPublish.__proto__ || Object.getPrototypeOf(CommunityPublish)).call(this, props));

    _this.show = function (options) {
      var defaultValue = {
        publishType: 0,
        detail: '',
        articleId: '',
        from: '',
        franchisee: '',
        reqAudit: ''
      },
          newOptions = Object.assign({}, defaultValue, options.communityPublish);
      _this.setData({
        communityPublish: newOptions
      });
      _this.init(newOptions);
    };

    _this.init = function (options) {
      var that = _this;
      var publishType = options.publishType,
          detail = options.detail,
          articleId = options.articleId,
          from = options.from,
          franchisee = options.franchisee,
          reqAudit = options.reqAudit;

      isSubmiting = false;

      _app.appMethod.getStorage({
        key: 'communityThemeColor-' + detail,
        success: function success(res) {
          that.setData({ theme_color: res.data });
        }
      });

      _this.setData({
        'communityId': detail || '',
        'articleId': articleId || '',
        'require_audit': reqAudit || '',
        'articleData.section_id': detail || '',
        'fromCommunityPage': from || '',
        'type': publishType == 2 ? 'link' : 'default',
        'articleData.type': publishType,
        'franchisee': franchisee || '',
        showTopWrap: false,
        selectedTime: [],
        selectedTimeIndex: 0,
        isShowTop: false,
        isBuyTop: false,
        topOrderInfo: {}
      });

      if (articleId) {
        _this.getArticle(articleId);
      } else {
        _this.getSections(detail);
      }
    };

    _this.submitData = function (event) {
      var that = _this,
          articleData = _this.data.articleData,
          title = articleData.title,
          text = articleData.text,
          need_loc = that.data.require_loc,
          need_phone = that.data.require_phone,
          latitude = need_loc ? articleData.latitude : '',
          longitude = need_loc ? articleData.longitude : '',
          address = need_loc ? that.data.address : '',
          phone = need_phone ? articleData.phone : '',
          communityId = _this.data.communityId || articleData.section_id,
          categoryId = articleData.category_id,
          type = articleData.type || 0,
          origin_url = articleData.origin_url || articleData.origin_url || '';

      if (!title) {
        _app.appMethod.showModal({ content: '请填写标题' });
        return;
      } else if (title.length > 46) {
        _app.appMethod.showModal({ content: '标题字数不得超过46' });
        return;
      } else {}

      if (_this.data.type == 'default') {
        if (!text) {
          _app.appMethod.showModal({ content: '请填写话题内容' });
          return;
        }
      } else if (_this.data.type == 'link') {
        if (!origin_url) {
          _app.appMethod.showModal({ content: '请粘贴公众号文章或腾讯视频链接' });
          return;
        }
      } else {}
      if (!_this.data.selectedSectionName || !_this.data.selectedCategoryName) {
        _app.appMethod.showModal({ content: '请选择分类' });
        return;
      }

      var url = '/index.php?r=AppSNS/AddArticle';
      var article_id = that.data.articleId;

      if (article_id) {
        url = '/index.php?r=AppSNS/UpdateArticle';
      }

      if (isSubmiting) {
        _app.appMethod.showModal({
          content: '正在提交中，请勿重复点击',
          complete: function complete() {
            !isSubmiting && that.returnBack();
          }
        });
        return;
      }
      isSubmiting = true;

      var submitParams = {
        audit_status: 2,
        article_id: article_id,
        section_id: communityId || _this.data.sectionList[_this.data.selectedSectionIndex].id, //版块id
        category_id: categoryId || _this.data.categoryList[_this.data.selectedCategoryIndex].id, //分类id 可不传
        title: title,
        text: text,
        imgs: articleData.imgs,
        is_carousel: 0, //是否开启轮播 1为开启 0不开启
        top_flag: 0, //是否置顶 1为置顶 0不置顶
        hot_flag: 0, //是否精品 1是 0否
        phone: phone,
        latitude: latitude,
        longitude: longitude,
        address: address,
        type: type,
        origin_url: origin_url,
        sub_app_id: that.data.franchisee
      };

      if (articleData.imgs.length > 0) {
        that.wxImgsCheck(articleData.imgs).then(function () {
          that.afterCheckSubmitData(url, submitParams);
        }, function (res) {
          _app.appMethod.showModal({ content: res && res.data || '网络错误或图片审核不通过' });
          isSubmiting = false;
        });
      } else {
        if (type == 2) {
          that.checkGrabLinkIsOk(origin_url).then(function (res) {
            if (!!res.unSupportable) {
              _app.appMethod.showModal({
                title: '提示',
                content: res.data || '暂不支持抓取含音频|视频|投票|小程序的图文文章',
                showCancel: true,
                confirmText: '继续',
                cancelText: '放弃',
                confirm: function confirm() {
                  that.afterCheckSubmitData(url, submitParams);
                },
                cancel: function cancel() {
                  isSubmiting = false;
                }
              });
            } else {
              that.afterCheckSubmitData(url, submitParams);
            }
          }, function () {
            isSubmiting = false;
          });
        } else {
          that.afterCheckSubmitData(url, submitParams);
        }
      }
    };

    _this.afterCheckSubmitData = function (url, data) {
      var that = _this;
      if (that.data.isShowTop && !that.data.isBuyTop) {
        data.topTime = that.data.selectedTime[that.data.selectedTimeIndex].days;
        data.topPrice = that.data.selectedTime[that.data.selectedTimeIndex].price;
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppSNS/AddSectionOrder',
          data: {
            days: that.data.selectedTime[that.data.selectedTimeIndex].days,
            section_id: that.data.communityId
          },
          method: 'post',
          success: function success(res) {
            var param = res.data;
            param.success = function () {
              data.order_id = res.order_id;
              that.afterPaySubmitData(url, data);
            };
            param.fail = function (res1) {
              isSubmiting = false;
            };
            _app.appMethod.wxPay(param);
          },
          fail: function fail() {
            isSubmiting = false;
          }
        });
      } else {
        that.afterPaySubmitData(url, data);
      }
    };

    _this.afterPaySubmitData = function (url, data) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: url,
        data: data,
        method: 'post',
        success: function success(res) {
          var content = that.data.require_audit == 1 ? '提交成功，待审核。' : '提交成功';
          if (that.data.require_audit == 1 && data.topTime) {
            content = "提交成功，待审核。审核如果失败，置顶费用将原路返回";
          }
          _app.appMethod.showModal({
            content: content,
            confirm: function confirm() {
              that.setData({
                'articleData.title': '',
                'articleData.text': ''
              });
              that.returnBack();
              if (routeIsCommunityPage()) {
                _app.appMethod.globalData.communityPageRefresh = true;
              } else {
                _app.appMethod.globalData.topicRefresh = true;
              }
              // app.onPageShow(); // 主动刷新页面
              window.location.reload(); //TODO：暂时这样处理
            }
          });
          _app.appMethod.globalData.communityPageRefresh = true;
          _app.appMethod.globalData.communityUsercenterRefresh = true;
        },
        complete: function complete(res) {
          isSubmiting = false;
        }
      });
    };

    _this.bindTitleInput = function (event) {
      var val = event.target.value;

      _this.setData({
        'articleData.title': val
      });
    };

    _this.bindTextInput = function (event) {
      var val = event.target.value;

      _this.setData({
        'articleData.text': val,
        'articleData.viewtext': val.replace(/\\n/g, '\n')
      });
    };

    _this.bindTextBlur = function (event) {
      var val = event.target.value;

      _this.setData({
        'articleData.text': val,
        'articleData.viewtext': val.replace(/\\n/g, '\n')
      });
    };

    _this.bindPhoneInput = function (event) {
      var val = event.target.value;

      _this.setData({
        'articleData.phone': val
      });
    };

    _this.bindPhoneBlur = function (event) {
      var val = event.target.value;
      _this.setData({ 'articleData.phone': val });
    };

    _this.uploadImg = function () {
      var that = _this,
          imgs = that.data.articleData.imgs;

      _app.appMethod.chooseImage(function (imageUrls) {
        imgs = imgs.concat(imageUrls);
        that.setData({
          'articleData.imgs': imgs
        });
      }, 9);
    };

    _this.deleteImg = function (event) {
      var index = event.currentTarget.dataset.index,
          imgs = _this.data.articleData.imgs;

      imgs.splice(index, 1);
      _this.setData({
        'articleData.imgs': imgs
      });
    };

    _this.getSections = function (communityId, callback) {
      var that = _this,
          param = {
        page: -1,
        sub_app_id: that.data.franchisee
      };
      if (communityId) {
        param.page = 1;
        param.section_id = communityId;
      }
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetSectionByPage',
        data: param,
        method: 'post',
        success: function success(res) {
          var newdata = {};
          var sec = res.data[0];
          newdata.require_loc = sec.require_location == 1;
          newdata.require_phone = sec.require_phone == 1;
          if (!that.data.theme_color) {
            newdata.theme_color = sec.theme_color;
          }
          if (communityId) {
            newdata['selectedSectionName'] = sec.name;
            newdata['require_audit'] = sec.require_audit;
            newdata['showCategoryList'] = true;
            newdata.showTopWrap = res.data[0].price_set ? true : false;
            newdata.selectedTime = res.data[0].price_set ? res.data[0].price_set : {};
          }
          newdata['sectionList'] = res.data;
          that.setData(newdata);
          that.getCategory(communityId || res.data[0].id);
          typeof callback == 'function' && callback(res.data);
        }
      });
    };

    _this.getCategory = function (sectionId, callback) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetCategoryByPage',
        data: {
          section_id: sectionId || that.data.communityId,
          page: -1,
          page_size: 100,
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data,
                newdata = [{ id: '', name: '全部(默认)' }].concat(info);
            that.setData({ 'categoryList': newdata });
            typeof callback == 'function' && callback(newdata);
          }
        }
      });
    };

    _this.getArticle = function (article_id) {
      var that = _this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppSNS/GetArticleByPage',
        data: {
          article_id: article_id,
          only_own_record: 1,
          sub_app_id: that.data.franchisee
        },
        method: 'post',
        success: function success(res) {
          if (res.status == 0) {
            var info = res.data[0],
                newdata = {};

            newdata['communityId'] = info.section_id;
            newdata['articleData.title'] = info.title;
            newdata['articleData.text'] = info.content.text;
            newdata['articleData.viewtext'] = info.content.text.replace(/\\n/, '\n');
            newdata['articleData.imgs'] = info.content.imgs || [];
            newdata['articleData.phone'] = info.phone;
            newdata['articleData.section_id'] = info.section_id;
            newdata['articleData.category_id'] = info.category_id;
            newdata['articleData.latitude'] = info.latitude;
            newdata['articleData.longitude'] = info.longitude;
            newdata['articleData.origin_url'] = info.content.origin_url;
            newdata['articleData.view_origin_url'] = info.content.origin_url.replace(/\\n/, '\n');
            newdata['address'] = info.address;
            newdata['isBuyTop'] = !!info.is_paid_article;
            newdata['isShowTop'] = !!info.is_paid_article;
            newdata['topOrderInfo'] = info.order_info;

            // that.getLocByLatAndLng(info.latitude, info.longitude, function (data) {
            //   that.setData({ address: data.address });
            // })

            that.getSections(info.section_id);
            that.getCategory(info.section_id, function (data) {
              data.some(function (cate, cateIdx) {
                that.setData({
                  'selectedCategoryIndex': cateIdx,
                  'selectedCategoryName': cate.name,
                  'showCategoryList': true
                });
              });
            });

            that.setData(newdata);
          }
        }
      });
    };

    _this.getAddress = function () {
      var that = _this;
      _app.appMethod.chooseLocation({
        success: function success(res) {
          if (!res.longitude) {
            _app.appMethod.showModal({
              content: '请选择具体的地址'
            });
            return;
          }
          that.setData({
            'articleData.latitude': res.latitude,
            'articleData.longitude': res.longitude,
            'address': res.address || ''
          });
          if (!res.address) {
            that.getLocByLatAndLng(res.latitude, res.longitude, function (data) {
              that.setData({ address: data.address });
            });
          }
        }
      });
    };

    _this.addressInput = function (event) {
      if (event.target.value) {
        _this.setData({
          'articleData.latitude': '',
          'articleData.longitude': '',
          'address': ''
        });
      }
    };

    _this.getLocByLatAndLng = function (lat, lng, cb) {
      _app.appMethod.sendRequest({
        url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
        data: {
          latitude: lat,
          longitude: lng
        },
        method: 'post',
        success: function success(data) {
          if (data.status == 0 && typeof cb == 'function') {
            cb(data.data);
          }
        }
      });
    };

    _this.showClassifyBox = function () {
      var showFlag = _this.data.showClassifyBox;
      _this.setData({ showClassifyBox: !showFlag });
      if (!_this.data.articleData.category_id) {
        _this.setData({
          'articleData.category_id': 0,
          selectedClassify: '全部（默认）'
        });
      }
    };

    _this.showSlectWindowAct = function () {
      if (_this.data.showSlectWindow && _this.data.selectedCategoryName && !_this.data.showCategoryList) {
        _this.setData({
          'showCategoryList': true
        });
      }
      _this.setData({
        'showSlectWindow': !_this.data.showSlectWindow
      });
    };

    _this.selectSectionAct = function (e) {
      var currentTarget = e.currentTarget,
          dataset = currentTarget.dataset,
          secIndex = dataset.index,
          currentSection = _this.data.sectionList[secIndex];
      _this.setData({
        'selectedSectionIndex': secIndex,
        'selectedSectionName': currentSection.name,
        'require_audit': currentSection.require_audit,
        'require_loc': currentSection.require_location == 1,
        'require_phone': currentSection.require_phone == 1,
        'showTopWrap': currentSection.price_set ? true : false,
        'selectedTime': currentSection.price_set || [],
        'communityId': currentSection.id,
        'selectedCategoryIndex': '',
        'selectedCategoryName': '',
        'showCategoryList': true
      });
      _this.getCategory(currentSection.id);
    };

    _this.selectCategoryAct = function (e) {
      var currentTarget = e.currentTarget,
          dataset = currentTarget.dataset,
          cateIndex = dataset.index,
          currentCategory = _this.data.categoryList[cateIndex];
      _this.setData({
        'selectedCategoryIndex': cateIndex,
        'selectedCategoryName': currentCategory.name,
        'showSlectWindow': false
      });
    };

    _this.changeShowListAct = function () {
      if (_this.data.fromCommunityPage) {
        return;
      }
      _this.setData({
        'showCategoryList': !_this.data.showCategoryList
      });
    };

    _this.stopPropagation = function (event) {
      event.stopPropagation();
    };

    _this.bindTextFocus = function () {
      _this.data.showSlectWindow && _this.showSlectWindowAct();
    };

    _this.bindLinkInput = function (e) {
      var articlelinkInput = e.target.value;
      _this.setData({
        'articleData.origin_url': articlelinkInput,
        'articleData.view_origin_url': articlelinkInput.replace(/\\n/g, '\n')
      });
    };

    _this.bindLinkBlur = function (e) {
      var articlelink = e.target.value;
      _this.setData({
        'articleData.origin_url': articlelink,
        'articleData.view_origin_url': articlelink.replace(/\\n/g, '\n')
      });
    };

    _this.imgCheck = function (img) {
      return new Promise(function (resolve, reject) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/ImgSecCheck',
          data: { imgs: [img] },
          method: 'post',
          success: function success(res) {
            resolve(img);
          },
          complete: function complete(res) {
            if (!res || res.status != 0) {
              reject(res);
            }
          }
        });
      });
    };

    _this.wxImgsCheck = function (arr) {
      return Promise.all(arr.map(function (img) {
        return _this.imgCheck(img);
      }));
    };

    _this.checkGrabLinkIsOk = function (url) {
      return new Promise(function (resolve, reject) {
        _app.appMethod.sendRequest({
          url: '/index.php?r=AppShop/WechatUrlCheck',
          data: { url: url },
          method: 'post',
          success: function success(res) {
            resolve(res);
          },
          complete: function complete(res) {
            if (!res || res.status != 0) {
              reject(res);
            }
          }
        });
      });
    };

    _this.returnBack = function () {
      _this.setData({
        'communityPublish.show': false,
        showCategoryList: false,
        articleData: {
          title: '',
          text: '',
          imgs: [],
          section_id: '',
          category_id: '',
          phone: '',
          latitude: '',
          longitude: '',
          type: 0,
          origin_url: '',
          viewtext: '',
          view_origin_url: ''
        },
        selectedSectionIndex: '',
        selectedSectionName: '',
        selectedCategoryIndex: '',
        selectedCategoryName: '',
        address: ''
      });
    };

    _this.chooseTopTime = function (e) {
      _this.setData({
        selectedTimeIndex: e.target.value
      });
    };

    _this.toSetingTop = function (e) {
      _this.setData({
        isShowTop: e.target.value
      });
    };

    _this.submitRegion = function (e) {
      _this.setData({
        selectedTimeIndex: e.target.value
      });
    };

    _this.state = {
      communityPublish: {
        show: false,
        publishType: 0,
        detail: '',
        articleId: '',
        from: '',
        franchisee: '',
        reqAudit: ''
      },
      communityId: '',
      articleData: {
        title: '',
        text: '',
        imgs: [],
        section_id: '',
        category_id: '',
        phone: '',
        latitude: '',
        longitude: '',
        type: 0,
        origin_url: ''
      },
      address: '',
      theme_color: '',
      selectedClassify: '',
      require_audit: '',
      require_loc: true,
      require_phone: true,
      fromCommunityPage: false,
      showSlectWindow: false,
      showClassifyBox: false,
      showCategoryList: false,
      selectedSectionIndex: '',
      selectedSectionName: '',
      sectionList: [],
      selectedCategoryIndex: '',
      selectedCategoryName: '',
      categoryList: [],
      showTopWrap: false,
      selectedTime: [],
      selectedTimeIndex: 0,
      isShowTop: false
    };
    return _this;
  }

  (0, _createClass3.default)(CommunityPublish, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          communityPublish = _state.communityPublish,
          type = _state.type,
          require_loc = _state.require_loc,
          require_phone = _state.require_phone,
          showClassifyBox = _state.showClassifyBox,
          articleData = _state.articleData,
          address = _state.address,
          theme_color = _state.theme_color,
          selectedSectionName = _state.selectedSectionName,
          selectedCategoryName = _state.selectedCategoryName,
          showTopWrap = _state.showTopWrap,
          isShowTop = _state.isShowTop,
          isBuyTop = _state.isBuyTop,
          showSlectWindow = _state.showSlectWindow,
          showCategoryList = _state.showCategoryList,
          categoryList = _state.categoryList,
          sectionList = _state.sectionList;

      if (!communityPublish.show) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component' },
        _react2.default.createElement(
          'div',
          { className: 'communityPublish-wrap', id: 'communityPublish' },
          _react2.default.createElement(
            'div',
            { className: 'communityPublish-main', style: require_loc ? { paddingBottom: 0 } : {} },
            _react2.default.createElement(
              'div',
              { className: 'communityPublish-title' },
              _react2.default.createElement('input', { className: 'communityPublish-title-input ' + (showClassifyBox ? 'hide' : ''), id: 'communityPublish-title-input', placeholder: '\u8BF7\u8F93\u5165\u6807\u9898', 'placeholder-style': 'color:#6e6e6e;font-size:14px;', type: 'text', onInput: this.bindTitleInput, onChange: this.bindTitleInput, value: articleData.title })
            ),
            type == 'default' && _react2.default.createElement(
              'div',
              { className: 'communityPublish-content' },
              _react2.default.createElement('textarea', { className: 'communityPublish-content-input ' + (showClassifyBox ? 'hide' : ''), id: 'communityPublish-content-input', placeholder: '\u8BF7\u8F93\u5165\u5185\u5BB9...', 'placeholder-style': 'color:#6e6e6e;font-size:12px;', onInput: this.bindTextInput, onChange: this.bindTextInput, value: articleData.text })
            ),
            type == 'link' && _react2.default.createElement(
              'div',
              { className: 'communityPublish-content' },
              _react2.default.createElement('textarea', { className: 'communityPublish-content-input ' + (showClassifyBox ? 'hide' : ''), id: 'communityPublish-content-input', placeholder: '\u8BF7\u7C98\u8D34\u516C\u4F17\u53F7\u6587\u7AE0\u6216\u94FE\u63A5', 'placeholder-style': 'color:#6e6e6e;font-size:12px;', onInput: this.bindLinkInput, onChange: this.bindLinkInput, value: articleData.origin_url })
            ),
            type == 'default' && _react2.default.createElement(
              'div',
              { className: 'communityPublish-img-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'communityPublish-ul clearfix', id: 'communityPublish-ul' },
                articleData.imgs && articleData.imgs.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'communityPublish-item' },
                    _react2.default.createElement('img', { className: 'communityPublish-upload-image', src: item, mode: 'aspectFill' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'communityPublish-item-delete', 'data-index': index, onClick: _this2.deleteImg },
                      '\xD7'
                    )
                  );
                }),
                _react2.default.createElement(
                  'div',
                  { className: 'communityPublish-item-add', onClick: this.uploadImg },
                  _react2.default.createElement(
                    'label',
                    { className: 'add-label' },
                    '+'
                  )
                )
              )
            ),
            require_loc && _react2.default.createElement(
              'div',
              { className: 'communityPublish-address', onClick: this.getAddress },
              _react2.default.createElement('label', { className: 'communityPublish-address-label ico-moon icon-community-location', style: { color: address ? theme_color : '' } }),
              _react2.default.createElement('input', { className: 'communityPublish-address-input ' + (showClassifyBox ? 'hide' : ''), id: 'communityPublish-address-input', placeholder: '\u6240\u5728\u4F4D\u7F6E', 'placeholder-style': 'color:#6e6e6e;font-size:14px;', type: 'text', disabled: true, onChange: this.addressInput, value: address })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'communityPublish-center' },
            require_phone && _react2.default.createElement(
              'div',
              { className: 'communityPublish-piece communityPublish-phone' },
              _react2.default.createElement('label', { className: 'communityPublish-piece-icon ico-moon icon-takeout-cellphone', style: { color: articleData.phone ? theme_color : '' } }),
              _react2.default.createElement('input', { className: 'communityPublish-phone-input', id: 'communityPublish-phone-input', placeholder: '\u7535\u8BDD\u53F7\u7801', 'placeholder-style': 'color:#6e6e6e;font-size:14px;', type: 'number', onInput: this.bindPhoneInput, onBlur: this.bindPhoneBlur, onChange: this.bindPhoneInput, value: articleData.phone })
            ),
            _react2.default.createElement(
              'div',
              { className: 'communityPublish-piece communityPublish-classify-title' },
              _react2.default.createElement('label', { className: 'communityPublish-piece-icon ico-moon icon-community-category', style: { color: selectedSectionName && selectedCategoryName ? theme_color : '' } }),
              _react2.default.createElement(
                'span',
                null,
                '\u9009\u62E9\u5206\u7C7B'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'communityPublish-piece communityPublish-classify' },
              !selectedCategoryName ? _react2.default.createElement(
                'div',
                { className: 'communityPublish-classify-view communityPublish-select-classify', onClick: this.showSlectWindowAct },
                _react2.default.createElement(
                  'span',
                  { className: 'communityPublish-classify-text' },
                  '\u8BF7\u9009\u62E9'
                ),
                _react2.default.createElement('label', { className: 'communityPublish-piece-icon ico-moon icon-filter-down' })
              ) : _react2.default.createElement(
                'div',
                { className: 'communityPublish-classify-view communityPublish-current-classify', onClick: this.showSlectWindowAct },
                _react2.default.createElement(
                  'span',
                  { className: 'communityPublish-classify-text' },
                  selectedSectionName
                ),
                '-',
                _react2.default.createElement(
                  'span',
                  { className: 'communityPublish-classify-text' },
                  selectedCategoryName
                )
              )
            )
          ),
          showTopWrap && _react2.default.createElement(
            'div',
            { className: 'communityPublish-setTop' },
            _react2.default.createElement(
              'div',
              { className: 'communityPublish-seting-top flex-wrap' },
              _react2.default.createElement(
                'div',
                null,
                '\u6211\u8981\u7F6E\u9876'
              ),
              _react2.default.createElement(_switch2.default, { className: 'switch', color: isBuyTop ? '#dedede' : theme_color, disabled: isBuyTop, checked: isShowTop, onChange: this.toSetingTop })
            ),
            isShowTop && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _picker2.default,
                { mode: 'selector', disabled: isBuyTop, value: selectedIndex, data: selectedTime, cols: 1, onChange: this.submitRegion },
                _react2.default.createElement(
                  'div',
                  { className: 'communityPublish-seting-time flex-wrap' },
                  _react2.default.createElement(
                    'div',
                    null,
                    '\u9009\u62E9\u7F6E\u9876\u65F6\u95F4'
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: isBuyTop ? { color: '#dedede' } : {} },
                    isBuyTop ? topOrderInfo.days : selectedTime[selectedTimeIndex].days,
                    '\u5929',
                    _react2.default.createElement('div', { className: 'ico-moon icon-rightarrow' })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'communityPublish-seting-money flex-wrap' },
                _react2.default.createElement(
                  'div',
                  null,
                  '\u7F6E\u9876\u8D39\u7528'
                ),
                _react2.default.createElement(
                  'div',
                  null,
                  '\xA5',
                  selectedTime[selectedTimeIndex].price
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'communityPublish-foot' },
            _react2.default.createElement(
              'button',
              { className: 'communityPublish-btn', onClick: this.submitData, style: { backgroundColor: theme_color } },
              '\u7ACB\u5373\u53D1\u5E03'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'return-btn', onClick: this.returnBack },
            _react2.default.createElement('label', { className: 'ico-moon icon-closes' })
          )
        ),
        showSlectWindow && _react2.default.createElement(
          'div',
          { className: 'communityPublish-classify-select-wrap', onClick: this.showSlectWindowAct },
          _react2.default.createElement('div', { className: 'communityPublish-catchtouchmove-layer' }),
          _react2.default.createElement(
            'div',
            { className: 'communityPublish-classify-select-window', onClick: this.stopPropagation },
            _react2.default.createElement(
              'div',
              { className: 'communityPublish-classify-select-top' },
              selectedSectionName && _react2.default.createElement(
                'span',
                { className: 'communityPublish-cst-text', onClick: this.changeShowListAct },
                selectedSectionName
              ),
              selectedCategoryName && showCategoryList && _react2.default.createElement(
                'span',
                { className: 'communityPublish-cst-text' },
                selectedCategoryName
              ),
              !selectedCategoryName && _react2.default.createElement(
                'span',
                { className: 'communityPublish-cst-text' },
                selectedSectionName ? '选择分类' : '请选择'
              )
            ),
            showCategoryList ? _react2.default.createElement(
              'div',
              { className: 'communityPublish-classify-select-list category-list' },
              categoryList && categoryList.map(function (cate, cateIdx) {
                return _react2.default.createElement(
                  'div',
                  { key: cateIdx, className: 'communityPublish-classify-select-item', 'data-index': cateIdx, onClick: _this2.selectCategoryAct },
                  _react2.default.createElement(
                    'span',
                    { className: 'communityPublish-csi-text' },
                    cate.name
                  ),
                  _react2.default.createElement('label', { className: 'communityPublish-csi-icon ico-moon icon-rightarrow' })
                );
              })
            ) : _react2.default.createElement(
              'div',
              { className: 'communityPublish-classify-select-list section-list' },
              sectionList && sectionList.map(function (sec, secIdx) {
                return _react2.default.createElement(
                  'div',
                  { className: 'communityPublish-classify-select-item', key: secIdx, 'data-index': secIdx, onClick: _this2.selectSectionAct },
                  _react2.default.createElement('img', { className: 'communityPublish-csi-image', src: sec.img, alt: '' }),
                  _react2.default.createElement(
                    'span',
                    { className: 'communityPublish-csi-text' },
                    sec.name
                  ),
                  _react2.default.createElement('label', { className: 'communityPublish-csi-icon ico-moon icon-rightarrow' })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return CommunityPublish;
}(_CommonComponent3.default);

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunityPublishType = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(943);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommunityPublishType = exports.CommunityPublishType = function (_CommonComponent) {
  (0, _inherits3.default)(CommunityPublishType, _CommonComponent);

  function CommunityPublishType(props) {
    (0, _classCallCheck3.default)(this, CommunityPublishType);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CommunityPublishType.__proto__ || Object.getPrototypeOf(CommunityPublishType)).call(this, props));

    _this.show = function (options) {
      _this.setState({
        communityPublishType: options.communityPublishType
      });
    };

    _this.turnToCommunityPublish = function (e) {
      var dataset = Object.assign({}, e.currentTarget.dataset, _this.data.communityPublishType.communityPublish);
      var publishType = dataset.type === 'link' ? 2 : 0;
      var pageInstance = _app.appMethod.getAppCurrentPage();

      _this.setData({
        'communityPublishType.show': false
      });
      pageInstance.communityPublishRef.current.show({
        communityPublish: {
          'show': true,
          'publishType': publishType,
          'detail': dataset.detail || '',
          'articleId': dataset.articleId || '',
          'reqAudit': dataset.reqAudit || '',
          'from': dataset.from || '',
          'franchisee': dataset.franchisee || ''
        }
      });
    };

    _this.returnBack = function (e) {
      _this.setData({
        'communityPublishType.show': false
      });
    };

    _this.state = {
      communityPublishType: {
        show: false,
        communityPublish: {}
      }
    };
    return _this;
  }

  (0, _createClass3.default)(CommunityPublishType, [{
    key: 'render',
    value: function render() {
      var communityPublishType = this.state.communityPublishType;

      if (!communityPublishType.show) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component communityPublishType-wrap' },
        _react2.default.createElement(
          'div',
          { className: 'communityPublishType-list' },
          _react2.default.createElement(
            'div',
            { className: 'type-default communityPublishType-type', 'data-type': 'default', onClick: this.turnToCommunityPublish },
            _react2.default.createElement(
              'div',
              { className: 'type-image' },
              _react2.default.createElement('img', { className: 'image-icon', src: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/pocket/community_default.png', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'type-text' },
              _react2.default.createElement(
                'div',
                { className: 'type-title' },
                '\u56FE\u6587'
              ),
              _react2.default.createElement(
                'div',
                { className: 'type-desc' },
                '\u62CD\u7167\u6216\u76F8\u518C\u4E0A\u4F20'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'type-link communityPublishType-type', 'data-type': 'link', onClick: this.turnToCommunityPublish },
            _react2.default.createElement(
              'div',
              { className: 'type-image' },
              _react2.default.createElement('img', { className: 'image-icon', src: 'https://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/pocket/community_link.png', alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'type-text' },
              _react2.default.createElement(
                'div',
                { className: 'type-title' },
                '\u6587\u7AE0/\u94FE\u63A5'
              ),
              _react2.default.createElement(
                'div',
                { className: 'type-desc' },
                '\u516C\u4F17\u53F7\u6587\u7AE0\u6216\u94FE\u63A5'
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'return-btn', onClick: this.returnBack },
          _react2.default.createElement('label', { className: 'ico-moon icon-closes' })
        )
      );
    }
  }]);
  return CommunityPublishType;
}(_CommonComponent3.default);

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TostoreShoppingCart = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(946);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TostoreShoppingCart = exports.TostoreShoppingCart = function (_CommonComponent) {
  (0, _inherits3.default)(TostoreShoppingCart, _CommonComponent);

  function TostoreShoppingCart(props) {
    (0, _classCallCheck3.default)(this, TostoreShoppingCart);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TostoreShoppingCart.__proto__ || Object.getPrototypeOf(TostoreShoppingCart)).call(this, props));

    _this2.goodsId = '';
    _this2.franchiseeId = '';

    _this2.show = function (data) {
      _this2.goodsId = data.goodsId;
      _this2.franchiseeId = data.franchisee || '';
      var pageInstance = _app.appMethod.getAppCurrentPage();
      _this2.setData({
        isShowBottom: pageInstance.data.isShowBottom || ""
      });
      _this2.getGoodsDetail();
    };

    _this2.getGoodsDetail = function () {
      var _this = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getGoods',
        data: {
          data_id: _this.goodsId,
          sub_shop_app_id: _this.franchiseeId
        },
        method: 'post',
        success: function success(res) {
          var goods = res.data[0].form_data;
          var defaultSelect = goods.model_items[0];
          var goodsModel = [];
          var selectModels = [];
          var goodprice = 0;
          var goodstock = 0;
          var goodid = void 0;
          var selectText = '';
          var goodimgurl = '';
          if (goods.model_items.length) {
            goodprice = defaultSelect.price;
            goodstock = defaultSelect.stock;
            goodid = defaultSelect.id;
            goodimgurl = defaultSelect.img_url;
          } else {
            goodprice = goods.price;
            goodstock = goods.stock;
            goodimgurl = goods.cover;
          }
          for (var key in goods.model) {
            if (key) {
              var model = goods.model[key];
              goodsModel.push(model);
              selectModels.push(model.subModelId[0]);
              selectText += '“' + model.subModelName[0] + '” ';
            }
          }
          goods.model = goodsModel;
          var businesssTimeString = '';
          if (goods.business_time && goods.business_time.business_time) {
            var goodBusinesssTime = goods.business_time.business_time;
            for (var i = 0; i < goodBusinesssTime.length; i++) {
              businesssTimeString += goodBusinesssTime[i].start_time.substring(0, 2) + ':' + goodBusinesssTime[i].start_time.substring(2, 4) + '-' + goodBusinesssTime[i].end_time.substring(0, 2) + ':' + goodBusinesssTime[i].end_time.substring(2, 4) + '/';
            }
            businesssTimeString = '出售时间：' + businesssTimeString.substring(0, businesssTimeString.length - 1);
          }
          _this.getTostoreCartList();
          _this.setData({
            businesssTimeString: businesssTimeString,
            goodsInfo: goods,
            'addTostoreShoppingCartShow': true,
            'selectGoodsModelInfo.price': goodprice,
            'selectGoodsModelInfo.stock': goodstock,
            'selectGoodsModelInfo.buyTostoreCount': 0,
            'selectGoodsModelInfo.cart_id': '',
            'selectGoodsModelInfo.models': selectModels,
            'selectGoodsModelInfo.modelId': goodid || '',
            'selectGoodsModelInfo.models_text': selectText,
            'selectGoodsModelInfo.imgurl': goodimgurl
          });
        }
      });
    };

    _this2.selectGoodsSubModel = function (event) {
      var dataset = event.target.dataset;
      var modelIndex = dataset.modelIndex;
      var submodelIndex = dataset.submodelIndex;
      var nweData = {};
      var selectModels = _this2.data.selectGoodsModelInfo.models;
      var model = _this2.data.goodsInfo.model;
      var text = '';

      selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];

      for (var i = 0; i < selectModels.length; i++) {
        var selectSubModelId = model[i].subModelId;
        for (var j = 0; j < selectSubModelId.length; j++) {
          if (selectModels[i] == selectSubModelId[j]) {
            text += '“' + model[i].subModelName[j] + '” ';
          }
        }
      }
      nweData['selectGoodsModelInfo.models'] = selectModels;
      nweData['selectGoodsModelInfo.models_text'] = text;

      _this2.setData(nweData);
      _this2.resetSelectCountPrice();
    };

    _this2.resetSelectCountPrice = function () {
      var selectModelIds = _this2.data.selectGoodsModelInfo.models.join(',');
      var modelItems = _this2.data.goodsInfo.model_items;
      var data = {};
      var cover = _this2.data.goodsInfo.cover;

      data['selectGoodsModelInfo.buyCount'] = 1;
      data['selectGoodsModelInfo.buyTostoreCount'] = 0;
      for (var i = modelItems.length - 1; i >= 0; i--) {
        if (modelItems[i].model == selectModelIds) {
          data['selectGoodsModelInfo.stock'] = modelItems[i].stock;
          data['selectGoodsModelInfo.price'] = modelItems[i].price;
          data['selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
          data['selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || cover;
          data['selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price;
          data['selectGoodsModelInfo.vipprice'] = modelItems[i].vip_price;
          break;
        }
      }
      _this2.setData(data);
    };

    _this2.clickTostoreMinusButton = function () {
      var _this = _this2;
      var count = _this2.data.selectGoodsModelInfo.buyTostoreCount;
      if (count <= 0) {
        return;
      }
      if (count <= 1) {
        _app.appMethod.sendRequest({
          hideLoading: true,
          url: '/index.php?r=AppShop/deleteCart',
          method: 'post',
          data: {
            cart_id_arr: [_this.data.selectGoodsModelInfo.cart_id],
            sub_shop_app_id: _app.appMethod.getPageFranchiseeId()
          }
        });
        _this2.setData({
          'selectGoodsModelInfo.buyTostoreCount': count - 1
        });
        _this2.getTostoreCartList();
        return;
      }
      _this2.setData({
        'selectGoodsModelInfo.buyTostoreCount': count
      });
      _this2.sureAddTostoreShoppingCart('mins');
    };

    _this2.clickTostorePlusButton = function () {
      var selectGoodsModelInfo = _this2.data.selectGoodsModelInfo;
      var count = selectGoodsModelInfo.buyTostoreCount;
      var stock = selectGoodsModelInfo.stock;

      if (count >= stock) {
        _this2.showModal({
          content: '库存不足'
        });
        return;
      }
      _this2.setData({
        'selectGoodsModelInfo.buyTostoreCount': count
      });
      _this2.sureAddTostoreShoppingCart('plus');
    };

    _this2.sureAddTostoreShoppingCart = function (type) {
      var that = _this2;
      var goodsNum = that.data.selectGoodsModelInfo.buyTostoreCount;
      if (type == 'plus') {
        goodsNum = goodsNum + 1;
      } else {
        goodsNum = goodsNum - 1;
      }
      var franchiseeId = _app.appMethod.getPageFranchiseeId();
      var param = {
        goods_id: that.data.goodsInfo.id,
        model_id: that.data.selectGoodsModelInfo.modelId || '',
        num: goodsNum,
        sub_shop_app_id: franchiseeId || ''
      };

      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/addCart',
        data: param,
        success: function success(res) {
          var data = res.data;
          that.setData({
            'selectGoodsModelInfo.cart_id': data,
            'selectGoodsModelInfo.buyTostoreCount': goodsNum
          });
          that.getTostoreCartList();
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          that.setData({
            'selectGoodsModelInfo.buyTostoreCount': 0
          });
        }
      });
    };

    _this2.readyToTostorePay = function () {
      var franchiseeId = _app.appMethod.getPageFranchiseeId();
      var pagePath = '/orderMeal/pages/previewOrderDetail/previewOrderDetail' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      if (_this2.data.cartGoodsNum <= 0 || !_this2.data.tostoreTypeFlag) {
        return;
      }
      _this2.hideAddShoppingcart();
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.goToShoppingCart = function () {
      var franchiseeId = _app.appMethod.getPageFranchiseeId();
      var pagePath = '/eCommerce/pages/shoppingCart/shoppingCart' + (franchiseeId ? '?franchisee=' + franchiseeId : '');
      _this2.hideAddShoppingcart();
      _app.appMethod.turnToPage(pagePath);
    };

    _this2.getValidateTostore = function () {
      var that = _this2;
      var franchiseeId = _app.appMethod.getPageFranchiseeId();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/precheckShoppingCart',
        data: {
          sub_shop_app_id: franchiseeId || '',
          parent_shop_app_id: franchiseeId ? _app.appMethod.getAppId() : ''
        },
        success: function success(res) {
          that.readyToTostorePay();
        },
        successShowModalConfirm: function successShowModalConfirm(res) {
          res.status === 1 && that.goToShoppingCart();
        }
      });
    };

    _this2.hideAddShoppingcart = function () {
      _this2.setData({
        addTostoreShoppingCartShow: false
      });
    };

    _this2.getTostoreCartList = function () {
      var that = _this2;
      var franchiseeId = _app.appMethod.getPageFranchiseeId();
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/cartList',
        data: {
          page: 1,
          page_size: 100,
          sub_shop_app_id: franchiseeId || '',
          parent_shop_app_id: franchiseeId ? _app.appMethod.getAppId() : ''
        },
        success: function success(res) {
          var price = 0,
              num = 0,
              addToShoppingCartCount = 0,
              tostoreTypeFlag = false;

          for (var i = res.data.length - 1; i >= 0; i--) {
            var data = res.data[i];
            if (data.goods_type == 3) {
              tostoreTypeFlag = true;
              price += +data.num * +data.price;
              num += +data.num;
            }
            if (this.goodsId == data.goods_id) {
              addToShoppingCartCount = data.num;
              that.cart_id = data.id;
            }
          }
          that.setData({
            tostoreTypeFlag: tostoreTypeFlag,
            cartGoodsNum: num,
            cartGoodsTotalPrice: price.toFixed(2),
            addToShoppingCartCount: addToShoppingCartCount
          });
        }
      });
    };

    _this2.stopPropagation = function (event) {
      event.stopPropagation();
    };

    _this2.options = _this2.props.options;

    _this2.state = {
      addTostoreShoppingCartShow: false,
      goodsInfo: {},
      selectGoodsModelInfo: {
        buyCount: 0
      },
      cartGoodsNum: 0,
      cartGoodsTotalPrice: 0,
      tostoreTypeFlag: false,
      businesssTimeString: ''
    };
    return _this2;
  }

  (0, _createClass3.default)(TostoreShoppingCart, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          addTostoreShoppingCartShow = _state.addTostoreShoppingCartShow,
          goodsInfo = _state.goodsInfo,
          selectGoodsModelInfo = _state.selectGoodsModelInfo,
          cartGoodsNum = _state.cartGoodsNum,
          cartGoodsTotalPrice = _state.cartGoodsTotalPrice,
          tostoreTypeFlag = _state.tostoreTypeFlag,
          isShowBottom = _state.isShowBottom,
          businesssTimeString = _state.businesssTimeString;

      return _react2.default.createElement(
        'div',
        { className: 'common-component tostore-shopping-cart tostorePayDialog page-addshoppingcart-dialog', hidden: !addTostoreShoppingCartShow, onClick: this.hideAddShoppingcart },
        _react2.default.createElement(
          'div',
          { className: 'page-bottom-dialog', style: isShowBottom ? { bottom: '1rem' } : {}, onClick: this.stopPropagation },
          _react2.default.createElement(
            'div',
            { className: 'page-bottom-content' },
            _react2.default.createElement(
              'div',
              { className: 'pay-close-dialog page-dialog-close', onClick: this.hideAddShoppingcart },
              '\xD7'
            ),
            _react2.default.createElement(
              'div',
              { className: 'dialog-block-item' },
              _react2.default.createElement(
                'div',
                { className: 'pay-goods-baseinfo' },
                _react2.default.createElement(
                  'div',
                  { className: 'pay-goods-title ellipsis' },
                  goodsInfo.title
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'dialog-block-item', hidden: !(goodsInfo.model_items && goodsInfo.model_items.length), style: { marginBottom: 0 } },
              _react2.default.createElement(
                'div',
                { className: 'pay-goods-models' },
                goodsInfo.model && goodsInfo.model.map(function (model, modelIndex) {
                  return _react2.default.createElement(
                    'div',
                    { key: modelIndex },
                    _react2.default.createElement(
                      'span',
                      { style: { verticalAlign: 'top', marginTop: '0.2rem', width: '1.2rem', display: 'inline-block', textAlign: 'right', fontSize: '.24rem' } },
                      model.name,
                      '\uFF1A'
                    ),
                    _react2.default.createElement(
                      'span',
                      { className: 'pills-list', style: { textAlign: 'center', maxWidth: '5.28rem' } },
                      model.subModelName.map(function (name, index) {
                        return _react2.default.createElement(
                          'label',
                          { className: 'subModel ' + (selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : ''), key: index, 'data-model-index': modelIndex, 'data-submodel-index': index, 'data-submodel-id': model.subModelId[index], onClick: _this3.selectGoodsSubModel },
                          name
                        );
                      })
                    )
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'dialog-block-item' },
              _react2.default.createElement(
                'div',
                { className: 'pay-goods-price clearfix' },
                _react2.default.createElement(
                  'div',
                  { className: 'pay-current-price', style: { fontSize: '16px' } },
                  '\xA5',
                  selectGoodsModelInfo.price
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'pull-right' },
                  goodsInfo.goods_type != 3 && _react2.default.createElement(
                    'label',
                    null,
                    '\u5E93\u5B58 ',
                    _react2.default.createElement(
                      'span',
                      { className: 'pay-goods-stock' },
                      selectGoodsModelInfo.stock
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'quantity' },
                    _react2.default.createElement('label', { className: 'minus ' + (selectGoodsModelInfo.buyTostoreCount <= 0 ? 'disabled' : '') }),
                    _react2.default.createElement(
                      'span',
                      { className: 'pay-buy-count', style: { margin: 'auto 10px' } },
                      selectGoodsModelInfo.buyTostoreCount
                    ),
                    _react2.default.createElement('label', { className: 'plus ' + (selectGoodsModelInfo.buyTostoreCount >= selectGoodsModelInfo.stock ? 'disabled' : '') }),
                    _react2.default.createElement('div', { className: 'response-area response-area-minus', onClick: this.clickTostoreMinusButton }),
                    _react2.default.createElement('div', { className: 'response-area response-area-plus', onClick: this.clickTostorePlusButton })
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '12px', marginTop: '10px', color: '#c9c9c9', textAlign: 'center' } },
                businesssTimeString
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'toStore-bottom-nav' },
              _react2.default.createElement(
                'div',
                { className: 'bottom-nav-detail', onClick: this.goToShoppingCart },
                _react2.default.createElement(
                  'label',
                  { className: 'icon-shoppingcart ico-moon' },
                  cartGoodsNum != 0 && _react2.default.createElement(
                    'label',
                    { className: 'toStore-cart-tip' },
                    cartGoodsNum
                  )
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  '\xA5',
                  cartGoodsTotalPrice
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bottom-nav-ready ' + (cartGoodsNum == 0 ? 'disabled' : '') + ' ' + (tostoreTypeFlag ? '' : 'disabled'), onClick: this.getValidateTostore },
                '\u9009\u597D\u4E86'
              )
            )
          )
        )
      );
    }
  }]);
  return TostoreShoppingCart;
}(_CommonComponent3.default);

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RewardPointModal = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(948);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardPointModal = exports.RewardPointModal = function (_CommonComponent) {
  (0, _inherits3.default)(RewardPointModal, _CommonComponent);

  function RewardPointModal(props) {
    (0, _classCallCheck3.default)(this, RewardPointModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RewardPointModal.__proto__ || Object.getPrototypeOf(RewardPointModal)).call(this, props));

    _this.show = function (options) {
      if (options.rewardPointObj) {
        _this.setState({
          rewardPointObj: options.rewardPointObj
        });
      }
      if (options.shareGiftsObj) {
        _this.setState({
          shareGiftsObj: options.shareGiftsObj
        });
      }
      if (options.collectGiftsObj) {
        if (options.collectGiftsObj && options.collectGiftsObj.showModal) {
          var pageInstance = _app.appMethod.getAppCurrentPage();
          if (pageInstance.data.page_hasNavBar) {
            _this.setState({
              topNavBarHeight: _app.appMethod.globalData.topNavBarHeight
            });
          }
        }
        _this.setState({
          collectGiftsObj: options.collectGiftsObj
        });
      }
      if (options.collectGetObj) {
        _this.setState({
          collectGetObj: options.collectGetObj
        });
      }
    };

    _this.stopPropagation = function (e) {
      e.stopPropagation();
    };

    _this.closeModal = function () {
      _this.setData({
        'rewardPointObj.showModal': false
      });
      _app.appMethod.rewardPointCB(_this.data.rewardPointObj.callback);
    };

    _this.closeShareModal = function () {
      _this.setData({
        'shareGiftsObj.showRewardsModal': false
      });
    };

    _this.closeExtraGifts = function () {
      _this.setData({
        'shareGiftsObj.showExtraRewardModal': false
      });
    };

    _this.toshareGifts = function () {
      var shareGiftsObj = _this.data.shareGiftsObj;
      _this.setData({
        'rewardPointObj.showModal': false,
        'shareGiftsObj.showRewardsModal': false
      });
      _app.appMethod.turnToPage('/eCommerce/pages/shareGifts/shareGifts?ids=' + shareGiftsObj.gifts.appoint_ids + '&extraIds=' + shareGiftsObj.gifts.extra_appoint_ids);
    };

    _this.toShowGifts = function (e) {
      var that = _this,
          type = that.data.shareGiftsObj.extra_rewards[0].type,
          path = void 0;
      switch (type) {
        case '1':
          path = '/eCommerce/pages/couponList/couponList';
          break;
        case '2':
          path = '/userCenter/pages/myIntegral/myIntegral';
          break;
        case '3':
          path = '/eCommerce/pages/balance/balance';
          break;
        case '4':
          path = '/userCenter/pages/vipCardList/vipCardList';
          break;
        case '5':
          path = '/eCommerce/pages/vipBenefits/vipBenefits?id=' + that.data.shareGiftsObj.extra_rewards[0].value;
          break;
        case '6':
          path = '/awardManagement/pages/collectStars/collectStars';
          break;
        case '7':
          path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail';
          break;
        case '8':
          path = '/awardManagement/pages/scratch/scratch';
          break;
        case '9':
          path = '/awardManagement/pages/goldenEggs/goldenEggs';
          break;
      }
      _this.setData({
        'rewardPointObj.showModal': false,
        'shareGiftsObj.showExtraRewardModal': false
      });
      _app.appMethod.turnToPage(path);
    };

    _this.toCollectGifts = function (e) {
      var data = e.currentTarget.dataset,
          type = data.type,
          path = void 0;
      switch (type) {
        case '1':
          path = '/eCommerce/pages/couponList/couponList';
          break;
        case '2':
          path = '/userCenter/pages/myIntegral/myIntegral';
          break;
        case '3':
          path = '/eCommerce/pages/balance/balance';
          break;
        case '4':
          path = '/userCenter/pages/vipCardList/vipCardList';
          break;
        case '5':
          path = '/eCommerce/pages/vipBenefits/vipBenefits';
          break;
        case '6':
          path = '/awardManagement/pages/collectStars/collectStars';
          break;
        case '7':
          path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail';
          break;
        case '8':
          path = '/awardManagement/pages/scratch/scratch';
          break;
        case '9':
          path = '/awardManagement/pages/goldenEggs/goldenEggs';
          break;
      }
      _this.setData({
        'rewardPointObj.showModal': false,
        'shareGiftsObj.showExtraRewardModal': false
      });
      _app.appMethod.turnToPage(path);
    };

    _this.closeGiftsModal = function () {
      _this.setData({
        'collectGiftsObj.showModal': false
      });
    };

    _this.closeGetModal = function () {
      _this.setData({
        'collectGetObj.showModal': false
      });
    };

    _this.state = {
      rewardPointObj: {
        showModal: false,
        count: '',
        callback: ''
      },
      collectGiftsObj: {
        showModal: false,
        gifts: '',
        callback: ''
      },
      collectGetObj: {
        showModal: false,
        gifts: '',
        callback: ''
      },
      shareGiftsObj: {
        showRewardsModal: false,
        showExtraRewardModal: false,
        gifts: '',
        immediately: '',
        callback: ''
      },
      cdnUrl: _app.appMethod.getCdnUrl(),
      topNavBarHeight: 0
    };
    return _this;
  }

  (0, _createClass3.default)(RewardPointModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          rewardPointObj = _state.rewardPointObj,
          cdnUrl = _state.cdnUrl,
          shareGiftsObj = _state.shareGiftsObj,
          topNavBarHeight = _state.topNavBarHeight,
          collectGiftsObj = _state.collectGiftsObj,
          collectGetObj = _state.collectGetObj;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        rewardPointObj.showModal && _react2.default.createElement(
          'div',
          { className: 'common-component rewardPointModal-wrap', onTouchMove: function onTouchMove(e) {
              return _this2.stopPropagation(e);
            }, style: { zIndex: 11 } },
          _react2.default.createElement(
            'div',
            { className: 'rewardPointModal-win' },
            _react2.default.createElement(
              'div',
              { className: 'rewardPointModal-bg', style: { backgroundImage: 'url(' + cdnUrl + '/static/webapp/images/reward_bg.png),url(' + cdnUrl + '/static/webapp/images/reward_coin.png);' } },
              _react2.default.createElement('label', { onClick: 'closeModal', className: 'ico-moon icon-closes rewardPointModal-closes' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'rewardPointModal-text' },
              _react2.default.createElement(
                'div',
                { className: 'rewardPointModal-p1' },
                '\u606D\u559C\u4F60'
              ),
              _react2.default.createElement(
                'div',
                { className: 'rewardPointModal-p2' },
                '\u83B7\u5F97',
                _react2.default.createElement(
                  'span',
                  { className: 'rewardPointModal-rewardCount' },
                  rewardPointObj.count,
                  '\u79EF\u5206'
                )
              )
            ),
            _react2.default.createElement(
              'button',
              { className: 'rewardPointModal-button', onClick: 'closeModal' },
              '\u77E5\u9053\u4E86'
            )
          )
        ),
        shareGiftsObj.showRewardsModal && shareGiftsObj.gifts.rewards.length > 0 && _react2.default.createElement(
          'div',
          { className: 'common-component rewardPointModal-wrap', onTouchMove: function onTouchMove(e) {
              return _this2.stopPropagation(e);
            }, style: { zIndex: 12 } },
          _react2.default.createElement(
            'div',
            { className: 'share-gifts-wrap share-reward-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'share-main-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'share-top-wrap' },
                _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/popup-top.png' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'share-content-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'share-tips' },
                  '\u5206\u4EAB\u6709\u793C'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'share-method' },
                  (shareGiftsObj.gifts.recv_limit == 0 || shareGiftsObj.gifts.rewards.length == 1) && _react2.default.createElement(
                    'div',
                    null,
                    '\u606D\u559C\u4F60\u83B7\u5F97\u4EE5\u4E0B\u5956\u52B1'
                  ),
                  shareGiftsObj.gifts.recv_limit == 1 && _react2.default.createElement(
                    'div',
                    null,
                    shareGiftsObj.gifts.recv_chance == 0 ? '奖励领取成功' : !(shareGiftsObj.gifts.recv_chance > 1 && shareGiftsObj.gifts.recv_limit == 1 && shareGiftsObj.gifts.rewards.length > 1) ? '以下奖励选一个' : '以下奖励可选'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'share-method-list' },
                    shareGiftsObj.gifts && shareGiftsObj.gifts.rewards && shareGiftsObj.gifts.rewards.map(function (item, index) {
                      return item.stock != 0 && _react2.default.createElement(
                        'div',
                        { className: 'list-item', key: index, style: { width: '80%', margin: '0 auto', wordBreak: 'break-all' } },
                        item.type == 1 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png' }),
                        item.type == 2 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png' }),
                        item.type == 3 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png' }),
                        (item.type == 4 || item.type == 5) && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png' }),
                        item.type == 6 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png' }),
                        item.type == 7 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png' }),
                        item.type == 8 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png' }),
                        item.type == 9 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'list-item-text' },
                          item.title
                        )
                      );
                    })
                  )
                ),
                shareGiftsObj.gifts.rewards.length <= 1 || shareGiftsObj.gifts.recv_limit == 0 ? _react2.default.createElement(
                  'div',
                  { className: 'share-btn', onClick: this.toshareGifts, 'data-type': shareGiftsObj.gifts.rewards[0].type },
                  '\u70B9\u51FB\u524D\u5F80\u67E5\u770B'
                ) : _react2.default.createElement(
                  'div',
                  { className: 'share-btn', onClick: this.toshareGifts },
                  '\u70B9\u51FB\u524D\u5F80\u9886\u53D6'
                )
              )
            ),
            _react2.default.createElement('div', { className: 'ico-moon icon-closed share-gifts-closes', onClick: this.closeShareModal })
          )
        ),
        shareGiftsObj.showExtraRewardModal && shareGiftsObj.extra_rewards.length > 0 && (shareGiftsObj.immediately == 1 || shareGiftsObj.gifts.rewards.length == 0) && _react2.default.createElement(
          'div',
          { className: 'common-component rewardPointModal-wrap', onTouchMove: function onTouchMove(e) {
              return _this2.stopPropagation(e);
            }, style: { zIndex: 11 } },
          _react2.default.createElement(
            'div',
            { className: 'share-gifts-wrap share-extraReward-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'share-main-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'share-top-wrap' },
                _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/popup-top.png' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'share-content-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'share-tips' },
                  '\u62C9\u65B0\u6210\u529F'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'share-method' },
                  _react2.default.createElement(
                    'div',
                    { className: 'share-new_comer' },
                    '\u62C9\u65B0\u6210\u529F\uFF1A\u3010',
                    _react2.default.createElement(
                      'span',
                      { className: 'new-comer-nickname' },
                      shareGiftsObj.extra_rewards[0].new_comer
                    ),
                    shareGiftsObj.extra_rewards[0].num > 1 ? '等' : ''
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'extra-text' },
                    '\u606D\u559C\u4F60\u83B7\u5F97\u4EE5\u4E0B\u5956\u52B1'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'share-method-list' },
                    shareGiftsObj.extra_rewards && shareGiftsObj.extra_rewards.map(function (item, index) {
                      return _react2.default.createElement(
                        'div',
                        { className: 'list-item', key: index, style: { width: '80%', margin: '0 auto', wordBreak: 'break-all' } },
                        shareGiftsObj.extra_rewards[0].type == 1 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png' }),
                        shareGiftsObj.extra_rewards[0].type == 2 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png' }),
                        shareGiftsObj.extra_rewards[0].type == 3 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png' }),
                        (shareGiftsObj.extra_rewards[0].type == 4 || shareGiftsObj.extra_rewards[0].type == 5) && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png' }),
                        shareGiftsObj.extra_rewards[0].type == 6 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png' }),
                        shareGiftsObj.extra_rewards[0].type == 7 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png' }),
                        shareGiftsObj.extra_rewards[0].type == 8 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png' }),
                        shareGiftsObj.extra_rewards[0].type == 9 && _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png' }),
                        _react2.default.createElement(
                          'span',
                          { className: 'list-item-text' },
                          item.reward_title,
                          ' ',
                          item.num > 1 ? '*' + item.num : ''
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'share-btn', onClick: this.toShowGifts },
                  '\u70B9\u51FB\u524D\u5F80\u67E5\u770B'
                )
              )
            ),
            _react2.default.createElement('div', { className: 'ico-moon icon-closed share-gifts-closes', onClick: this.closeExtraGifts })
          )
        ),
        collectGiftsObj.showModal && _react2.default.createElement(
          'div',
          { className: 'common-component rewardPointModal-wrap', onTouchMove: function onTouchMove(e) {
              return _this2.stopPropagation(e);
            }, style: collectGiftsObj.style.type == 1 || collectGiftsObj.style.type == 2 ? { zIndex: 15, top: topNavBarHeight + 'px', background: 'rgba(0,0,0,.70)' } : { zIndex: 15, top: topNavBarHeight + 'px', height: '4.5rem', background: 'rgba(255,255,255,0)' } },
          collectGiftsObj.style.type == 1 && _react2.default.createElement(
            'div',
            { className: 'collect-gifts-wrap type1' },
            _react2.default.createElement('div', { className: 'type1-arrow' }),
            _react2.default.createElement(
              'div',
              { className: 'collect-step' },
              _react2.default.createElement('div', { className: 'type1-collect' }),
              _react2.default.createElement(
                'div',
                { className: 'section-tips' },
                _react2.default.createElement(
                  'div',
                  { className: 'tips-text', style: { color: '#ff7100' } },
                  '\u70B9\u51FB',
                  _react2.default.createElement('img', { className: 'bottom-line', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png' })
                ),
                '\u8FD9\u91CC\uFF0C\u9009\u62E9\u6DFB\u52A0\u5230\u6211\u7684\u5C0F\u7A0B\u5E8F'
              )
            ),
            _react2.default.createElement('img', { className: 'section-logo', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/section-arrow.png' }),
            _react2.default.createElement(
              'div',
              { className: 'collect-step' },
              _react2.default.createElement(
                'div',
                { className: 'type1-customer' },
                ' '
              ),
              _react2.default.createElement(
                'div',
                { className: 'section-tips' },
                '\u5FAE\u4FE1',
                _react2.default.createElement(
                  'div',
                  { className: 'tips-text', style: { color: '#ff7100' } },
                  '\u4E0B\u62C9',
                  _react2.default.createElement('image', { className: 'bottom-line', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png' })
                ),
                '\uFF0C\u4ECE\u3010\u6211\u7684\u5C0F\u7A0B\u5E8F\u3011\u8FDB\u5165\u5E97\u94FA'
              )
            ),
            _react2.default.createElement('img', { className: 'section-logo', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/section-arrow.png' }),
            _react2.default.createElement(
              'div',
              { className: 'method-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'method-list method-list-show', style: { position: 'absolute' } },
                collectGiftsObj.gifts && collectGiftsObj.gifts.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { className: 'method-item-list', key: index },
                    _react2.default.createElement(
                      'div',
                      { className: 'method-item' },
                      _react2.default.createElement('img', { className: 'image', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/hook.png' }),
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.title
                      )
                    )
                  );
                })
              ),
              _react2.default.createElement('div', { style: { height: 0.5 * collectGiftsObj.gifts.length + 'rem', marginBottom: '.5rem' } }),
              _react2.default.createElement(
                'div',
                { className: 'section-tips', style: { fontSize: '.3rem' } },
                '\u5B8C\u6210\u540E\uFF0C\u5C06\u83B7\u5F97\u4EE5\u4E0A',
                _react2.default.createElement(
                  'div',
                  { className: 'tips-text', style: { color: '#ff7100' } },
                  '\u5956\u52B1',
                  _react2.default.createElement('img', { className: 'bottom-line', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast1/bottom-line.png' })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'collect-gifts-closes', onClick: this.closeGiftsModal },
                collectGiftsObj.manualClose.value
              )
            )
          ),
          collectGiftsObj.style.type == 2 && _react2.default.createElement(
            'div',
            { className: 'collect-gifts-wrap type2' },
            _react2.default.createElement(
              'div',
              { className: 'main-wrap' },
              _react2.default.createElement(
                'div',
                { className: 'collect-step' },
                _react2.default.createElement(
                  'div',
                  { className: 'image-wrap step-item' },
                  '1. \u70B9\u51FB\u53F3\u4E0A\u89D2',
                  _react2.default.createElement('img', { className: 'image', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/share.png', style: { marginLeft: '.1rem' } }),
                  '\u6309\u94AE'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'collect-step' },
                _react2.default.createElement(
                  'div',
                  { className: 'step-item' },
                  '2. \u70B9\u51FB\u201C\u6DFB\u52A0\u5230\u6211\u7684\u5C0F\u7A0B\u5E8F\u201D'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'collect-step' },
                _react2.default.createElement(
                  'div',
                  { className: 'step-item' },
                  '3. \u5728\u5FAE\u4FE1\u9996\u9875\u4E0B\u62C9\u6253\u5F00\u4EFB\u52A1\u680F\uFF0C\u4ECE\u201C\u6211\u7684\u5C0F\u7A0B\u5E8F\u201D\u8FDB\u5165\u5E97\u94FA\u3002'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'method-wrap' },
                _react2.default.createElement(
                  'div',
                  { className: 'image-wrap' },
                  _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/block.png', style: { width: '.26rem', height: '.18rem', marginRight: '12rpx' } }),
                  '\u5B8C\u6210\u4EE5\u4E0A\u6B65\u9AA4\u4F60\u5C06\u83B7\u5F97\u4EE5\u4E0B\u5956\u52B1'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'method-list' },
                  collectGiftsObj.gifts && collectGiftsObj.gifts.map(function (item, index) {
                    return _react2.default.createElement(
                      'div',
                      { className: 'method-item image-wrap', key: index },
                      _react2.default.createElement('img', { className: 'image', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/hook.png', style: { height: '.26rem', width: '.32rem', marginRight: '.17rem' } }),
                      _react2.default.createElement(
                        'div',
                        { className: 'title' },
                        item.title
                      )
                    );
                  })
                )
              )
            ),
            _react2.default.createElement('label', { onClick: this.closeGiftsModal, className: 'ico-moon icon-closes rewardPointModal-closes' })
          ),
          collectGiftsObj.style.type == 3 && _react2.default.createElement(
            'div',
            { className: 'collect-gifts-wrap type3 mode' + collectGiftsObj.style.default, style: { background: collectGiftsObj.style.bg } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'main-wrap', style: { color: collectGiftsObj.style.text } },
                _react2.default.createElement(
                  'div',
                  { className: 'header-tips' },
                  _react2.default.createElement(
                    'div',
                    { className: 'logo-tips', style: { color: collectGiftsObj.style.main } },
                    _react2.default.createElement('label', { className: 'ico-moon icon-collect-rect-left collect-rect', style: { marginRight: '-.06rem' } }),
                    _react2.default.createElement('label', { className: 'ico-moon icon-collect-rect-right collect-rect', style: { opacity: 0.2 } })
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { opacity: 0.8 } },
                    '\u5B8C\u6210\u4EE5\u4E0B\u6B65\u9AA4\u6709\u5956\u52B1'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'collect-step' },
                  _react2.default.createElement(
                    'div',
                    { className: 'image-wrap step-item' },
                    _react2.default.createElement('span', { className: 'step ico-moon icon-collect-first' }),
                    '\u70B9\u51FB\u8FD9\u91CC',
                    _react2.default.createElement('img', { src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast2/share.png', onClick: this.closeGiftsModal, style: { width: '.87rem', height: '.48rem', margin: '0 0.07rem' } }),
                    '\u9009\u62E9\u6DFB\u52A0\u5230\u6211\u7684\u5C0F\u7A0B\u5E8F'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'collect-step' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('span', { className: 'step ico-moon icon-collect-second' }),
                    '\u5FAE\u4FE1\u4E0B\u62C9\uFF0C\u4ECE\u201C\u6211\u7684\u5C0F\u7A0B\u5E8F\u201D\u8FDB\u5165\u5E97\u94FA'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'method-wrap' },
                  _react2.default.createElement(
                    'div',
                    { className: 'gifts-logo' },
                    _react2.default.createElement(
                      'span',
                      { className: 'rewards-tips', style: { opacity: 0.8 } },
                      '\u5956\u52B1'
                    ),
                    _react2.default.createElement('label', { className: 'ico-moon icon-collect-line', style: { color: collectGiftsObj.style.main } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'gifts-list' },
                    collectGiftsObj.gifts && collectGiftsObj.gifts.map(function (item, index) {
                      return _react2.default.createElement(
                        _react2.default.Fragment,
                        null,
                        index == collectGiftsObj.gifts.length - 1 ? item.title : item.title + '、'
                      );
                    })
                  )
                )
              ),
              _react2.default.createElement('label', { onClick: this.closeGiftsModal, className: 'ico-moon icon-collect-close rewardPointModal-closes', style: { color: collectGiftsObj.style.btn } })
            ),
            _react2.default.createElement(
              'div',
              { className: 'arrow-logo-wrap' },
              _react2.default.createElement('div', { className: 'arrow-logo', style: { background: collectGiftsObj.style.bg } })
            )
          )
        ),
        collectGetObj.showModal && _react2.default.createElement(
          'div',
          { className: 'common-component rewardPointModal-wrap', onTouchMove: function onTouchMove(e) {
              return _this2.stopPropagation(e);
            }, style: { zIndex: 15, background: 'rgba(0,0,0,.7)' } },
          _react2.default.createElement(
            'div',
            { className: 'collect-get-main-wrap' },
            _react2.default.createElement(
              'div',
              { className: 'image-wrap' },
              _react2.default.createElement('img', { className: 'image', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/toast-gifts/star.png' })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'header-tips' },
                '\u6B22\u8FCE\u56DE\u6765 \u606D\u559C\u4F60\u83B7\u5F97\u4EE5\u4E0B\u5956\u52B1'
              ),
              _react2.default.createElement(
                'div',
                { className: 'method-list' },
                collectGetObj.gifts && collectGetObj.gifts.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'method-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'methods' },
                      _react2.default.createElement(
                        'div',
                        { className: 'meth' },
                        item.type == 1 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(255, 129, 45, .1)' } },
                          _react2.default.createElement('image', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/coupon.png' })
                        ),
                        item.type == 2 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(244, 90, 97, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/intergral.png' })
                        ),
                        item.type == 3 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(253, 181, 43, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/balance.png' })
                        ),
                        (item.type == 4 || item.type == 5) && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(244, 90, 97, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/vip-card.png' })
                        ),
                        item.type == 6 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(112, 212, 94, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/collect.png' })
                        ),
                        item.type == 7 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(63, 145, 230, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/luckyWheel.png' })
                        ),
                        item.type == 8 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(253, 181, 43, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/scratch.png' })
                        ),
                        item.type == 9 && _react2.default.createElement(
                          'div',
                          { className: 'gifts-logo', style: { background: 'rgba(255, 129, 45, .1)' } },
                          _react2.default.createElement('img', { className: 'image-wrap', src: 'http://cdn.jisuapp.cn/static/webapp/images/collect-gifts/gifts-logo/golden.png' })
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'gifts-name' },
                          item.title
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'show-btn', onClick: _this2.toCollectGifts, 'data-type': item.type, 'data-classify': 'collect' },
                        '\u67E5\u770B'
                      )
                    )
                  );
                })
              )
            ),
            _react2.default.createElement('label', { className: 'ico-moon icon-closes rewardPointModal-closes', onClick: this.closeGetModal })
          )
        )
      );
    }
  }]);
  return RewardPointModal;
}(_CommonComponent3.default);

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShowVipModal = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(950);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowVipModal = exports.ShowVipModal = function (_CommonComponent) {
  (0, _inherits3.default)(ShowVipModal, _CommonComponent);

  function ShowVipModal(props) {
    (0, _classCallCheck3.default)(this, ShowVipModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ShowVipModal.__proto__ || Object.getPrototypeOf(ShowVipModal)).call(this, props));

    _this.show = function (options) {
      if (options.shopVipModal) {
        _this.setState({
          shopVipModal: options.shopVipModal
        });
      }
    };

    _this.stopPropagation = function (e) {
      e.stopPropagation();
    };

    _this.closeModal = function () {
      _this.setData({
        'shopVipModal.showModal': false
      });
    };

    _this.turnToVipCard = function () {
      _app.appMethod.turnToPage('/userCenter/pages/vipCardList/vipCardList');
      _this.closeModal();
    };

    _this.state = {
      shopVipModal: {
        showModal: false,
        isUp: false
      },
      cdnUrl: _app.appMethod.getCdnUrl()
    };
    return _this;
  }

  (0, _createClass3.default)(ShowVipModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          shopVipModal = _state.shopVipModal,
          cdnUrl = _state.cdnUrl;

      if (!shopVipModal.showModal) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-component shopVipModal-wrap', onTouchMove: function onTouchMove(e) {
            return _this2.stopPropagation(e);
          } },
        !shopVipModal.isUp && _react2.default.createElement(
          'div',
          { className: 'shopVipModal-win shopVipModal-vip' },
          _react2.default.createElement(
            'div',
            { className: 'shopVipModal-vip-top', style: { backgroundImage: 'url(' + cdnUrl + '/static/webapp/images/shop_vip.png)' } },
            _react2.default.createElement(
              'div',
              { className: 'shopVipModal-closes-wrap' },
              _react2.default.createElement('label', { onClick: this.closeModal, className: 'ico-moon icon-closes shopVipModal-closes' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'shopVipModal-p' },
              '\u606D\u559C\u4F60\u6210\u4E3A\u672C\u5E97\u4F1A\u5458'
            ),
            _react2.default.createElement(
              'div',
              { className: 'shopVipModal-p' },
              '\u83B7\u5F97\u4E00\u5F20\u4F1A\u5458\u5361\uFF0C\u8BF7\u5230\u4E2A\u4EBA\u4E2D\u5FC3\u67E5\u770B'
            )
          ),
          _react2.default.createElement(
            'button',
            { className: 'shopVipModal-button', onClick: this.turnToVipCard },
            '\u53BB\u67E5\u770B'
          )
        ),
        shopVipModal.isUp && _react2.default.createElement(
          'div',
          { className: 'shopVipModal-win shopVipModal-upgrade' },
          _react2.default.createElement(
            'div',
            { className: 'shopVipModal-upgrade-top', style: { backgroundImage: 'url(' + cdnUrl + '/static/webapp/images/shop_vip_upgrade.png)' } },
            _react2.default.createElement('label', { onClick: this.closeModal, className: 'ico-moon icon-closes shopVipModal-closes' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'shopVipModal-upgrade-text' },
            '\u8BF7\u5230\u4E2A\u4EBA\u4E2D\u5FC3\u67E5\u770B\u6700\u65B0\u4F1A\u5458\u6743\u76CA\u5427'
          ),
          _react2.default.createElement(
            'button',
            { className: 'shopVipModal-button', onClick: this.turnToVipCard },
            '\u53BB\u67E5\u770B'
          )
        )
      );
    }
  }]);
  return ShowVipModal;
}(_CommonComponent3.default);

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageQrcode = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _CommonComponent2 = __webpack_require__(39);

var _CommonComponent3 = _interopRequireDefault(_CommonComponent2);

var _app = __webpack_require__(4);

__webpack_require__(952);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageQrcode = exports.PageQrcode = function (_CommonComponent) {
  (0, _inherits3.default)(PageQrcode, _CommonComponent);

  function PageQrcode(props) {
    (0, _classCallCheck3.default)(this, PageQrcode);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (PageQrcode.__proto__ || Object.getPrototypeOf(PageQrcode)).call(this, props));

    _this2.ctx = null;

    _this2.show = function (options) {
      _this2.setData({
        pageQRCodeData: options.pageQRCodeData || {
          shareDialogShow: "100%",
          shareMenuShow: false
        }
      });
    };

    _this2.drawing = function () {
      var _this = _this2;
      var ctx = _this2.ctx;
      _this.setDrawImage(ctx, _this.data.pageQRCodeData.goodsInfo.goods_img, 10, 10, 260, 260, 1);
      _this.setDrawImage(ctx, _this.data.pageQRCodeData.goodsInfo.qrcode_img_url, 190, 280, 70, 70, 0);
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, 280, 390);
      _this.setFillText(ctx, _this.data.pageQRCodeData.goodsInfo.text, '#333333', 300);
    };

    _this2.setFillText = function (ctx, text, color, y) {
      var textString = void 0;
      if (text.length > 36) {
        textString = text.substr(0, 33) + '...';
      } else {
        textString = text;
      }
      var textRowArr = [];
      for (var tmp = 0; tmp < textString.length;) {
        textRowArr.push(textString.substr(tmp, 12));
        tmp += 12;
      }
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = textRowArr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          ctx.font = "13px";
          ctx.fillStyle = color;
          ctx.fillText(item, 10, y);
          y += 20;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var goodsInfo = _this2.data.pageQRCodeData.goodsInfo;
      if (goodsInfo.isSeckill && goodsInfo.isSeckill == 1) {
        goodsInfo.virtual_price = goodsInfo.price;
        goodsInfo.price = goodsInfo.seckill_price ? goodsInfo.seckill_price : '';
      }
      if (goodsInfo.price) {
        ctx.font = "16px";
        ctx.fillStyle = '#FF3600';
        if (goodsInfo.integral == '2') {
          if (goodsInfo.price == '0.00') {
            ctx.fillText(goodsInfo.max_can_use_integral + '积分', 10, y + 10);
          } else {
            ctx.fillText('¥' + goodsInfo.price + '+' + goodsInfo.max_can_use_integral + '积分', 10, y + 10);
          }
        } else {
          ctx.fillText('¥' + goodsInfo.price, 10, y + 10);
        }
      }
      var virtual_price = goodsInfo.virtual_price;
      if (virtual_price) {
        var vx = (String(goodsInfo.price).length + 1) * 9 + 20;
        ctx.font = "12px";
        ctx.fillStyle = '#999';
        ctx.fillText('¥' + virtual_price, vx, y + 10);
        ctx.beginPath();
        ctx.strokeStyle = '#999';
        ctx.moveTo(vx, y + 6);
        ctx.lineTo(vx + (String(virtual_price).length + 1) * 6 + 12, y + 6);
        ctx.stroke();
      }

      ctx.font = "10px";
      ctx.fillStyle = '#666666';
      ctx.fillText('长按识别二维码', 190, 365);

      ctx.beginPath();
      ctx.lineWidth = 1;
      ctx.lineJoin = 'miter';
      ctx.moveTo(260, 280);
      ctx.lineTo(270, 280);
      ctx.lineTo(270, 290);

      ctx.moveTo(260, 375);
      ctx.lineTo(270, 375);
      ctx.lineTo(270, 365);

      ctx.moveTo(190, 280);
      ctx.lineTo(180, 280);
      ctx.lineTo(180, 290);

      ctx.moveTo(190, 375);
      ctx.lineTo(180, 375);
      ctx.lineTo(180, 365);

      ctx.strokeStyle = '#FF3600';
      ctx.stroke();
    };

    _this2.setDrawImage = function (ctx, src, x, y, w, h, index) {
      var _this = _this2;
      var img = new Image();

      img.setAttribute('crossOrigin', 'anonymous');
      img.onload = function () {
        ctx.drawImage(img, x, y, w, h);
        if (index == 1 && _this.data.pageQRCodeData.goodsInfo.isSeckill) {
          _this.setDrawImage(ctx, 'http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/seckill-share-icon.png', 10, 252, 62, 18, 0);
        }
      };
      img.src = src;
    };

    _this2.getShareToMomentsSwitch = function () {
      var that = _this2;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppData/GetShareToMomentsSwitch',
        data: {},
        success: function success(res) {
          that.setData({
            showShare: res.data
          });
        }
      });
    };

    _this2.hideShareDialog = function () {
      _this2.setData({
        "pageQRCodeData.shareDialogShow": "100%",
        "pageQRCodeData.shareMenuShow": false,
        "pageQRCodeShow": false
      });
    };

    _this2.showAppMessageMenu = function () {
      var pageInstance = _app.appMethod.getAppCurrentPage();
      pageInstance.shareClickEvent();
      _this2.hideShareDialog();
    };

    _this2.showPageCode = function () {
      _this2.setData({
        "pageQRCodeData.shareMenuShow": false,
        pageQRCodeShow: true
      });
      setTimeout(function () {
        _this2.drawing();
      }, 200);
    };

    _this2.stopPropagation = function (event) {
      event.stopPropagation();
    };

    _this2.savePageCode = function () {
      var drawcanvas = document.getElementById("pageqrcode-canvas");
      var img = drawcanvas.toDataURL("image/png").replace("image/png", "image/octet-stream");

      var link = document.createElement('a');
      link.setAttribute('download', 'code.png');
      link.setAttribute('href', img);
      link.click();

      setTimeout(function () {
        _app.appMethod.showToast({
          title: '保存成功',
          duration: 4000
        });
        _this2.setData({
          "pageQRCodeData.shareDialogShow": "100%",
          "pageQRCodeData.shareMenuShow": false,
          "pageQRCodeShow": false
        });
      }, 2000);
    };

    _this2.state = {
      pageQRCodeShow: false,
      pageQRCodeData: {
        shareDialogShow: "100%",
        shareMenuShow: false
      },
      showShare: false
    };
    return _this2;
  }

  (0, _createClass3.default)(PageQrcode, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getShareToMomentsSwitch();
      var drawcanvas = document.getElementById("pageqrcode-canvas");
      this.ctx = drawcanvas.getContext('2d');
    }

    // 获取是否显示转发朋友圈


    // 这里是一个自定义方法
    // 隐藏分享组件


    // 转发到朋友圈

  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          pageQRCodeData = _state.pageQRCodeData,
          pageQRCodeShow = _state.pageQRCodeShow,
          showShare = _state.showShare;

      return _react2.default.createElement(
        'div',
        { className: 'common-component page-qrcode page-qr-code-dialog', onClick: this.hideShareDialog, onTouchMove: this.stopPropagation, style: { top: pageQRCodeData.shareDialogShow } },
        _react2.default.createElement(
          'div',
          { className: 'page-qr-code', hidden: !pageQRCodeShow, onClick: this.stopPropagation },
          _react2.default.createElement('canvas', { id: 'pageqrcode-canvas', className: 'goods-share-canvas', width: '280', height: '390' }),
          _react2.default.createElement(
            'div',
            { className: 'save-btn', onClick: this.savePageCode },
            '\u4FDD\u5B58\u56FE\u7247'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'page-bottom-dialog', style: { position: 'absolute', bottom: pageQRCodeData.shareMenuShow ? 0 : '-3.2rem', left: 0, width: '7.50rem', backgroundColor: 'rgba(238, 238, 238, 1)' }, onClick: this.stopPropagation },
          _react2.default.createElement(
            'button',
            { className: 'button', onClick: this.showAppMessageMenu },
            '\u8F6C\u53D1\u81F3\u597D\u53CB'
          ),
          showShare && _react2.default.createElement(
            'button',
            { className: 'button shareToMoments', onClick: this.showPageCode },
            '\u8F6C\u53D1\u81F3\u670B\u53CB\u5708'
          ),
          _react2.default.createElement(
            'button',
            { className: 'button cancelShare', onClick: this.hideShareDialog },
            '\u53D6\u6D88'
          )
        )
      );
    }
  }]);
  return PageQrcode;
}(_CommonComponent3.default);

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pay = undefined;

var _radio = __webpack_require__(79);

var _radio2 = _interopRequireDefault(_radio);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(1);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

__webpack_require__(80);

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _app = __webpack_require__(4);

__webpack_require__(954);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pay = exports.Pay = function (_React$Component) {
  (0, _inherits3.default)(Pay, _React$Component);

  function Pay(props) {
    (0, _classCallCheck3.default)(this, Pay);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Pay.__proto__ || Object.getPrototypeOf(Pay)).call(this, props));

    _this.timer = null;

    _this.showPay = function (options) {
      if (!options.orderId) {
        console.error('orderId 是必传字段');
        return;
      }

      _this.orderId = options.orderId;
      _this.orderType = options.orderType || 1; //说明： http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884350
      _this.franchisee = options.franchisee || '';
      // this.success = options.success || '';
      // this.fail = options.fail || '';
      _this.cancel = options.cancel || '';
      _this.successUrl = options.successUrl || '';
      _this.failUrl = options.failUrl || '';

      _this.getOrder();
      if (_app.appMethod.isWeixin()) {
        // 微信里面直接调微信支付
        _this.chooseWXPay();
      } else if (_app.appMethod.isPC()) {
        //pc上暂时用微信二维码支付
        _this.chooseWXCodePay();
      } else {
        // 其他的暂时选择支付方式弹窗
        _this.setState({
          payShow: true,
          choosePayShow: true
        });
      }
      _this.setState({
        payLoading: false,
        orderPrice: 0
      });
    };

    _this.closePayEvent = function () {
      _this.closePay();
      typeof _this.cancel === 'function' && _this.cancel();
    };

    _this.changePayType = function (type) {
      _this.setState({
        choosePayType: type
      });
    };

    _this.goPay = function () {
      var payType = _this.state.choosePayType;
      if (_this.state.payLoading) {
        return;
      }
      _this.setState({
        payLoading: true
      });
      var successUrl = _this.getTurnToPageUrl(_this.successUrl);
      var failUrl = _this.getTurnToPageUrl(_this.failUrl);
      _app.appMethod.setStorage({
        key: 'payCallbackUrl',
        data: {
          successUrl: successUrl,
          failUrl: failUrl
        }
      });
      if (payType == 'wxpay') {
        _this.wxPay();
      } else if (payType == 'alipay') {
        _this.aliPay();
      }
    };

    _this.wxPay = function () {
      if (_app.appMethod.isWeixin()) {
        //微信内部直接调起支付
        _this.chooseWXPay();
      }if (_app.appMethod.isPC()) {
        // pc上面弹出支付二维码
        _this.chooseWXCodePay();
      } else {
        // 在手机上使用h5调起微信支付
        _this.chooseWXH5Pay();
      }
    };

    _this.chooseWXPay = function () {
      var that = _this;
      that.getUniPay({
        payment_id: 18,
        success: function success(res) {
          var param = res.data;
          wx.chooseWXPay({
            timestamp: param.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: param.nonceStr, // 支付签名随机串，不长于 32 位
            package: param.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: param.signType || 'MD5', // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: param.paySign, // 支付签名
            success: function success(res) {
              // that.wxPaySuccess(param);
              that.successUrl && _app.appMethod.turnToPage(that.successUrl, {}, true);
              // typeof that.success === 'function' && that.success(res);
            },
            cancel: function cancel(res) {
              _app.appMethod.showModal({
                content: '支付已取消',
                confirm: function confirm() {
                  // typeof that.fail === 'function' && that.fail();
                  that.failUrl && _app.appMethod.turnToPage(that.failUrl, {}, true);
                }
              });
            },
            fail: function fail(res) {
              if (res.errMsg === 'requestPayment:fail') {
                res.errMsg = '支付失败';
              }
              if (res.errMsg.indexOf('ETIMEDOUT')) {
                res.errMsg = '支付超时！';
              }
              _app.appMethod.showModal({
                content: res.errMsg
              });
              // that.wxPayFail(param, res.errMsg);
              that.failUrl && _app.appMethod.turnToPage(that.failUrl, {}, true);
              // typeof that.fail === 'function' && that.fail();
            }
          });
        },
        fail: function fail() {},
        complete: function complete() {
          that.setState({
            payLoading: false
          });
        }
      });
    };

    _this.chooseWXCodePay = function () {
      var that = _this;
      that.getUniPay({
        payment_id: 0,
        success: function success(res) {
          that.checkOrderPay();
          that.setState({
            wxcodePay: true,
            payShow: true,
            choosePayShow: false,
            wxcodeUrl: res.data
          });
        },
        fail: function fail() {},
        complete: function complete() {
          that.setState({
            payLoading: false
          });
        }
      });
    };

    _this.chooseWXH5Pay = function () {
      var that = _this;
      _app.appMethod.turnToPage('/paying?orderId=' + that.orderId, {}, true);
      that.getUniPay({
        payment_id: 19,
        success: function success(res) {
          if (res.data.return_msg == 'OK') {
            var mweburl = res.data.mweb_url;
            var redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
            mweburl = mweburl + '&redirect_url=' + encodeURIComponent(redirect_url);
            window.location.href = mweburl;
            that.setState({
              payShow: false,
              choosePayShow: false
            });
          }
        },
        fail: function fail() {},
        complete: function complete() {
          that.setState({
            payLoading: false
          });
        }
      });
    };

    _this.aliPay = function () {
      if (_app.appMethod.isPC()) {
        // pc上去新页面进入支付宝支付
        _this.chooseALiPCPay();
      } else {
        // 在手机上使用h5调起支付宝支付
        _this.chooseALiH5Pay();
      }
    };

    _this.chooseALiPCPay = function () {
      var that = _this;
      var redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
      _app.appMethod.turnToPage('/paying?orderId=' + that.orderId, {}, true);
      that.getUniPay({
        payment_id: 21,
        return_url: redirect_url,
        success: function success(res) {
          var divDom = document.createElement('div');
          divDom.innerHTML = res.data;
          divDom.removeChild(divDom.childNodes[1]);
          document.body.appendChild(divDom);
          document.forms['alipaysubmit'].submit();
          setTimeout(function () {
            divDom.remove();
          }, 50);
          that.setState({
            payShow: false,
            choosePayShow: false
          });
        },
        fail: function fail() {},
        complete: function complete() {
          that.setState({
            payLoading: false
          });
        }
      });
    };

    _this.chooseALiH5Pay = function () {
      var that = _this;
      var redirect_url = that.getIntactUrl('/paying?isPayBack=1&orderId=' + that.orderId);
      _app.appMethod.turnToPage('/paying?orderId=' + that.orderId, {}, true);
      that.getUniPay({
        payment_id: 20,
        return_url: redirect_url,
        success: function success(res) {
          var divDom = document.createElement('div');
          divDom.innerHTML = res.data;
          divDom.removeChild(divDom.childNodes[1]);
          document.body.appendChild(divDom);
          document.forms['alipaysubmit'].submit();
          setTimeout(function () {
            divDom.remove();
          }, 50);
          that.setState({
            payShow: false,
            choosePayShow: false
          });
        },
        fail: function fail() {},
        complete: function complete() {
          that.setState({
            payLoading: false
          });
        }
      });
    };

    _this.wxPaySuccess = function (param) {
      var orderId = param.orderId,
          goodsType = param.goodsType,
          formId = param.package.substr(10),
          t_num = goodsType == 1 ? 'AT0104' : 'AT0009';

      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
        data: {
          formId: formId,
          t_num: t_num,
          order_id: orderId
        }
      });
    };

    _this.wxPayFail = function (param, errMsg) {
      var orderId = param.orderId,
          formId = param.package.substr(10);

      _app.appMethod.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppShop/SendXcxOrderCompleteMsg',
        data: {
          formId: formId,
          t_num: 'AT0010',
          order_id: orderId,
          fail_reason: errMsg
        }
      });
    };

    _this.state = {
      payShow: false,
      choosePayShow: false,
      choosePayType: 'wxpay',
      wxcodePay: false,
      wxcodeUrl: '',
      payLoading: false,
      orderPrice: 0
    };
    _this.orderId = '';
    _this.orderType = 1;
    _this.franchisee = '';
    _this.success = '';
    _this.fail = '';
    _this.cancel = '';
    return _this;
  }

  // 外部调用接口


  (0, _createClass3.default)(Pay, [{
    key: 'getOrder',


    // pc上面弹出微信支付支付二维码时查询订单是否支付
    value: function getOrder() {
      var that = this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getOrder',
        data: {
          order_id: this.orderId,
          sub_shop_app_id: this.franchisee
        },
        hideLoading: false,
        success: function success(res) {
          that.setState({
            orderPrice: res.data[0].form_data.total_price
          });
        },
        fail: function fail() {}
      });
    }

    // pc上面弹出微信支付支付二维码时查询订单是否支付

  }, {
    key: 'orderIsPay',
    value: function orderIsPay() {
      var that = this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=AppShop/getOrder',
        data: {
          order_id: this.orderId,
          sub_shop_app_id: this.franchisee
        },
        success: function success(res) {
          if (res.data[0].form_data.status != 0) {
            that.closePay();
            that.successUrl && _app.appMethod.turnToPage(that.successUrl, {}, true);
            // typeof that.success === 'function' && that.success(res);
          }
        },
        fail: function fail() {
          // clearInterval(this.timer);
          // typeof that.fail === 'function' && that.fail();
        }
      });
    }

    // pc上面弹出微信支付支付二维码时轮询是否支付了

  }, {
    key: 'checkOrderPay',
    value: function checkOrderPay() {
      var _this2 = this;

      clearInterval(this.timer);
      this.timer = setInterval(function () {
        _this2.orderIsPay();
      }, 2000);
    }

    // 关闭支付弹窗

  }, {
    key: 'closePay',
    value: function closePay() {
      clearInterval(this.timer);
      _app.appMethod.removeStorage({ key: 'payCallbackUrl' });
      this.setState({
        payShow: false,
        choosePayShow: false,
        wxcodePay: false
      });
    }

    // 点击关闭支付弹窗事件


    // 选择支付方式

  }, {
    key: 'getIntactUrl',
    value: function getIntactUrl(url) {
      var urlArr = url.split('/');
      url = window.location.origin + '/zc_webapp/' + urlArr[urlArr.length - 1];
      if (!/app_id/.test(url)) {
        if (url.indexOf('?') < 0) {
          url = url + '?app_id=' + _app.appMethod.getAppId();
        } else {
          url = url + '&app_id=' + _app.appMethod.getAppId();
        }
      }
      return url;
    }
  }, {
    key: 'getTurnToPageUrl',
    value: function getTurnToPageUrl(url) {
      if (url && !/app_id/.test(url)) {
        if (url.indexOf('?') < 0) {
          url = url + '?app_id=' + _app.appMethod.getAppId();
        } else {
          url = url + '&app_id=' + _app.appMethod.getAppId();
        }
      }
      return url;
    }

    // 去支付


    // 微信支付


    // 微信内部支付


    // pc端微信二维码支付


    // 手机上使用h5调起微信支付

  }, {
    key: 'getUniPay',


    /*
    *@param {number} param.payment_id 支付方式id。默认0
    *@param {function} param.success 请求成功回调
    *@param {function} param.fail 请求失败回调
    */
    value: function getUniPay(param) {
      var that = this;
      _app.appMethod.sendRequest({
        url: '/index.php?r=pay/Pay/GetUniPay',
        data: {
          order_id: this.orderId,
          order_type: this.orderType,
          payment_id: param.payment_id || 0, //相关说明 http://confluence.zhichiwangluo.com/pages/viewpage.action?pageId=2884343
          return_url: param.return_url || '', //这个针对支付宝
          sub_shop_app_id: this.franchisee
        },
        hideLoading: false,
        success: function success(res) {
          typeof param.success === 'function' && param.success(res);
        },
        fail: function fail(res) {
          typeof param.fail === 'function' && param.fail(res);
        },
        complete: function complete(res) {
          typeof param.complete === 'function' && param.complete(res);
        },
        successStatusAbnormal: function successStatusAbnormal(res) {
          param.fail && typeof param.fail === 'function' && param.fail(res);
          that.failUrl && _app.appMethod.turnToPage(that.failUrl, {}, true);
        }
      });
    }

    // 支付宝支付


    // pc端支付宝支付


    // 手机上支付宝支付


    // 支付成功


    /**
     * 支付成功
     */

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          payShow = _state.payShow,
          choosePayShow = _state.choosePayShow,
          choosePayType = _state.choosePayType,
          wxcodePay = _state.wxcodePay,
          wxcodeUrl = _state.wxcodeUrl,
          payLoading = _state.payLoading,
          orderPrice = _state.orderPrice;

      if (!payShow) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        { className: 'common-api pay-wrap' },
        _react2.default.createElement(
          'div',
          { className: 'choose-pay', style: { bottom: choosePayShow ? 0 : '-7rem' } },
          _react2.default.createElement(
            'div',
            { className: 'choose-pay-head' },
            '\u652F\u4ED8'
          ),
          _react2.default.createElement('div', { className: 'pay-close icon-moon icon-closes', onClick: this.closePayEvent }),
          _react2.default.createElement(
            'div',
            { className: 'pay-money' },
            _react2.default.createElement(
              'label',
              null,
              '\xA5'
            ),
            _react2.default.createElement(
              'span',
              null,
              orderPrice
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'choose-item-warp' },
            _react2.default.createElement(
              'div',
              { className: 'choose-pay-item pay-item-wx', onClick: function onClick() {
                  return _this3.changePayType('wxpay');
                } },
              _react2.default.createElement('label', { className: 'pay-item-logo icon-moon icon-weixin-pay' }),
              _react2.default.createElement(
                'span',
                null,
                '\u5FAE\u4FE1\u652F\u4ED8'
              ),
              _react2.default.createElement(_radio2.default, { className: 'pay-item-radio', checked: choosePayType === 'wxpay' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'choose-pay-item pay-item-ali', onClick: function onClick() {
                  return _this3.changePayType('alipay');
                } },
              _react2.default.createElement('label', { className: 'pay-item-logo icon-moon icon-alipay' }),
              _react2.default.createElement(
                'span',
                null,
                '\u652F\u4ED8\u5B9D'
              ),
              _react2.default.createElement(_radio2.default, { className: 'pay-item-radio', checked: choosePayType === 'alipay' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'choose-pay-btn ' + (payLoading ? 'choose-btn-disabled' : ''), onClick: this.goPay },
            '\u786E\u8BA4\u652F\u4ED8'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'pay-qrcode-wrap', hidden: !wxcodePay },
          _react2.default.createElement('div', { className: 'pay-close icon-moon icon-closes', onClick: this.closePayEvent }),
          _react2.default.createElement(
            'div',
            { className: 'pay-qrcode' },
            _react2.default.createElement('img', { src: wxcodeUrl })
          ),
          _react2.default.createElement(
            'div',
            { className: 'pay-qrcode-tip' },
            '\u957F\u6309\u4E8C\u7EF4\u7801\u626B\u63CF\u652F\u4ED8'
          )
        )
      );
    }
  }]);
  return Pay;
}(_react2.default.Component);

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[216]);


// WEBPACK FOOTER //
// index.js